/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 609);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(618);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translate__ = __webpack_require__(666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__translate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__I18n__ = __webpack_require__(381);
/* unused harmony reexport I18n */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interpolate__ = __webpack_require__(668);
/* unused harmony reexport Interpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trans__ = __webpack_require__(669);
/* unused harmony reexport Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadNamespaces__ = __webpack_require__(676);
/* unused harmony reexport loadNamespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context__ = __webpack_require__(272);
/* unused harmony reexport reactI18nextModule */
/* unused harmony reexport setDefaults */
/* unused harmony reexport getDefaults */
/* unused harmony reexport setI18n */
/* unused harmony reexport getI18n */








/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(636);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, exports) {

var MODAL_WIDTH_SM=480;var MODAL_WIDTH_MD=640;var MODAL_WIDTH_LG=960;var MODAL_WIDTH_XL=1024;var MODAL_HEIGHT_XS=320;var MODAL_HEIGHT_MD=640;var MARGIN_XS=4;var MARGIN_SM=8;var MARGIN_MD=16;var MARGIN_LG=24;var MARGIN_XL=32;var PADDING_XS=4;var PADDING_SM=8;var PADDING_MD=16;var GUTTER_XS=4;var GUTTER_SM=8;var GUTTER_MD=16;var SPAN_ONE_QUARTER=6;var SPAN_ONE_THIRD=8;var SPAN_HALF=12;var SPAN_TWO_THIRDS=16;var SPAN_THREE_QUARTERS=18;var SPAN_FULL=24;var COLOR_FONT_DISABLED='rgba(0,0,0,.25)';var CSS_HIDDEN={display:'none'};var CSS_POINTER={cursor:'pointer'};var Z_INDEX_SPINNER=999;var Z_INDEX_MODAL=1000;var Z_INDEX_ENHANCED_MODAL=998;var TABLE_COL_MIN_WIDTH_ID=100;var TABLE_COL_MIN_WIDTH_NAME=150;module.exports.MODAL_WIDTH_SM=MODAL_WIDTH_SM;module.exports.MODAL_WIDTH_MD=MODAL_WIDTH_MD;module.exports.MODAL_WIDTH_LG=MODAL_WIDTH_LG;module.exports.MODAL_WIDTH_XL=MODAL_WIDTH_XL;module.exports.MODAL_HEIGHT_XS=MODAL_HEIGHT_XS;module.exports.MODAL_HEIGHT_MD=MODAL_HEIGHT_MD;module.exports.MARGIN_XS=MARGIN_XS;module.exports.MARGIN_SM=MARGIN_SM;module.exports.MARGIN_MD=MARGIN_MD;module.exports.MARGIN_LG=MARGIN_LG;module.exports.MARGIN_XL=MARGIN_XL;module.exports.PADDING_XS=PADDING_XS;module.exports.PADDING_SM=PADDING_SM;module.exports.PADDING_MD=PADDING_MD;module.exports.GUTTER_XS=GUTTER_XS;module.exports.GUTTER_SM=GUTTER_SM;module.exports.GUTTER_MD=GUTTER_MD;module.exports.SPAN_ONE_QUARTER=SPAN_ONE_QUARTER;module.exports.SPAN_ONE_THIRD=SPAN_ONE_THIRD;module.exports.SPAN_HALF=SPAN_HALF;module.exports.SPAN_TWO_THIRDS=SPAN_TWO_THIRDS;module.exports.SPAN_THREE_QUARTERS=SPAN_THREE_QUARTERS;module.exports.SPAN_FULL=SPAN_FULL;module.exports.COLOR_FONT_DISABLED=COLOR_FONT_DISABLED;module.exports.CSS_HIDDEN=CSS_HIDDEN;module.exports.CSS_POINTER=CSS_POINTER;module.exports.Z_INDEX_SPINNER=Z_INDEX_SPINNER;module.exports.Z_INDEX_MODAL=Z_INDEX_MODAL;module.exports.Z_INDEX_ENHANCED_MODAL=Z_INDEX_ENHANCED_MODAL;module.exports.TABLE_COL_MIN_WIDTH_ID=TABLE_COL_MIN_WIDTH_ID;module.exports.TABLE_COL_MIN_WIDTH_NAME=TABLE_COL_MIN_WIDTH_NAME;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(620)();
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93), __webpack_require__(207)(module)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(904));

var _buttonGroup = _interopRequireDefault(__webpack_require__(907));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_button["default"].Group = _buttonGroup["default"];
var _default = _button["default"];
exports["default"] = _default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(867);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REQUEST_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REQUEST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REQUEST_METHOD_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REQUEST_METHOD_PUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REQUEST_METHOD_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_METHOD_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return postRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return putRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return allRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return startRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return successRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return errorRequest; });
var REQUEST_START='REQUEST_START';var REQUEST_SUCCESS='REQUEST_SUCCESS';var REQUEST_ERROR='REQUEST_ERROR';var REQUEST_METHOD_POST='POST';var REQUEST_METHOD_PUT='PUT';var REQUEST_METHOD_GET='GET';var REQUEST_METHOD_DELETE='DELETE';var REQUEST='REQUEST';var postRequest=function postRequest(label,url,data,messages,contentType,doNotJSONParse,endpointId){var hideSpinner=arguments.length>7&&arguments[7]!==undefined?arguments[7]:false;return{type:REQUEST,method:REQUEST_METHOD_POST,label:label,url:url,data:data,messages:messages,contentType:contentType,doNotJSONParse:doNotJSONParse,endpointId:endpointId,hideSpinner:hideSpinner};};var putRequest=function putRequest(label,url,data,messages,contentType){return{type:REQUEST,method:REQUEST_METHOD_PUT,label:label,url:url,data:data,messages:messages,contentType:contentType};};var getRequest=function getRequest(label,url,messages,doNotJSONParse,endpointId,timeout){var hideSpinner=arguments.length>6&&arguments[6]!==undefined?arguments[6]:false;return{type:REQUEST,method:REQUEST_METHOD_GET,label:label,url:url,messages:messages,doNotJSONParse:doNotJSONParse,endpointId:endpointId,timeout:timeout,hideSpinner:hideSpinner};};var allRequest=function allRequest(label,methods,urls,datas,messages,idsForErrorReport,sequential){return{type:REQUEST,label:label,method:methods,url:urls,data:datas,messages:messages,isArray:true,idsForErrorReport:idsForErrorReport,sequential:sequential};};var deleteRequest=function deleteRequest(label,url,messages){return{type:REQUEST,method:REQUEST_METHOD_DELETE,label:label,url:url,messages:messages};};var startRequest=function startRequest(uuid,action){return Object.assign({},action,{type:REQUEST_START,uuid:uuid});};var successRequest=function successRequest(uuid,action,response,header){return Object.assign({},action,{type:REQUEST_SUCCESS,uuid:uuid,response:response,header:header});};var errorRequest=function errorRequest(uuid,action,statusCode,error,hideFeedback){return Object.assign({},action,{type:REQUEST_ERROR,uuid:uuid,statusCode:statusCode,error:error,hideFeedback:hideFeedback});};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SDMX_JSON_DSD_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SDMX_JSON_DATAFLOW_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SDMX_JSON_MSD_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SDMX_JSON_METADATAFLOW_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SDMX_JSON_CODELIST_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SDMX_JSON_CATEGORY_SCHEME_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SDMX_JSON_CONCEPT_SCEHME_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SDMX_JSON_INFO_MODEL_CONCEPT_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SDMX_JSON_INFO_MODEL_CODELIST_URN_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SDMX_JSON_DATAFLOW_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SDMX_JSON_AGENCY_SCHEME_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SDMX_JSON_CATEGORY_SCHEME_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SDMX_JSON_CONCEPT_SCHEME_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SDMX_JSON_CATEGORISATION_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SDMX_JSON_CODELIST_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SDMX_JSON_DSD_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SDMX_JSON_CONTENT_CONSTRAINT_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SDMX_JSON_METADATAFLOW_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SDMX_JSON_MSD_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SDMX_JSON_METADATA_SET_LIST_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SDMX_JSON_CODELIST_ITEMS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SDMX_JSON_AGENCY_SCHEME_ITEMS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FILTER_MODE_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FILTER_MODE_NOT_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CODELIST_ORDER_ANNOTATION_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONCEPT_SCHEME_ORDER_ANNOTATION_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CATEGORY_SCHEME_ORDER_ANNOTATION_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getSdmxStructuresFromSdmxJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getItemFromSdmxJsonStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DSD_DIMENSION_TYPE_NORMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DSD_DIMENSION_TYPE_FREQUENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DSD_DIMENSION_TYPE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DSD_DIMENSION_TYPE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DSD_DIMENSION_ID_FREQUENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DSD_DIMENSION_ID_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DSD_ATTRIBUTE_ATTACHMENT_LEVEL_OBSERVATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DSD_ATTRIBUTE_ATTACHMENT_LEVEL_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DSD_ATTRIBUTE_ATTACHMENT_LEVEL_SERIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DSD_ATTRIBUTE_ATTACHMENT_LEVEL_DATASET; });
/* unused harmony export getDsdComponentFromSdmxJsonStructure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getSdmxJsonStructureFromDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getDsdFromSdmxJsonStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getContentConstraintFromSdmxJsonStructure; });
/* unused harmony export getSdmxJsonStructureFromDsdComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getItemSchemeFromSdmxJsonFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getArtefactFromSdmxJsonStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getSdmxJsonFromSdmxJsonStructures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getSdmxJsonStructureFromContentConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getSdmxJsonStructureFromArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getSdmxJsonStructureFromItem; });
/* unused harmony export getCategoryIdFromUrn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getArtefactTripletFromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getArtefactTripletFromUrn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getUrnFromArtefactTriplet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getStringFromArtefactTriplet; });
/* harmony export (immutable) */ __webpack_exports__["_4"] = getUrnFromArtefact;
/* harmony export (immutable) */ __webpack_exports__["_2"] = getStringFromItemUrn;
/* unused harmony export isArtefactChildOfArtefact */
/* harmony export (immutable) */ __webpack_exports__["_3"] = getTypeFromArtefact;
/* harmony export (immutable) */ __webpack_exports__["U"] = getQuartupletFromItemString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__artefacts__ = __webpack_require__(56);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var SDMX_JSON_DSD_URN_NAMESPACE='org.sdmx.infomodel.datastructure.DataStructure';var SDMX_JSON_DATAFLOW_URN_NAMESPACE='org.sdmx.infomodel.datastructure.Dataflow';var SDMX_JSON_MSD_URN_NAMESPACE='org.sdmx.infomodel.metadatastructure.MetadataStructure';var SDMX_JSON_METADATAFLOW_URN_NAMESPACE='org.sdmx.infomodel.metadatastructure.Metadataflow';var SDMX_JSON_CODELIST_URN_NAMESPACE='org.sdmx.infomodel.datastructure.Codelist';var SDMX_JSON_CATEGORY_SCHEME_URN_NAMESPACE='org.sdmx.infomodel.datastructure.CategoryScheme';var SDMX_JSON_CONCEPT_SCEHME_URN_NAMESPACE='org.sdmx.infomodel.datastructure.ConceptScheme';var SDMX_JSON_INFO_MODEL_CONCEPT_URN_NAMESPACE='org.sdmx.infomodel.conceptscheme.Concept';var SDMX_JSON_INFO_MODEL_CODELIST_URN_NAMESPACE='org.sdmx.infomodel.codelist.Codelist';var SDMX_JSON_DATAFLOW_LIST_KEY='dataflows';var SDMX_JSON_AGENCY_SCHEME_LIST_KEY='agencySchemes';var SDMX_JSON_CATEGORY_SCHEME_LIST_KEY='categorySchemes';var SDMX_JSON_CONCEPT_SCHEME_LIST_KEY='conceptSchemes';var SDMX_JSON_CATEGORISATION_LIST_KEY='categorisations';var SDMX_JSON_CODELIST_LIST_KEY='codelists';var SDMX_JSON_DSD_LIST_KEY='dataStructures';var SDMX_JSON_CONTENT_CONSTRAINT_LIST_KEY='contentConstraints';var SDMX_JSON_METADATAFLOW_LIST_KEY='metadataflows';var SDMX_JSON_MSD_LIST_KEY='msds';var SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY='hierarchicalCodelist';var SDMX_JSON_METADATA_SET_LIST_KEY='metadataSets';var SDMX_JSON_CODELIST_ITEMS_KEY='codes';var SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY='concepts';var SDMX_JSON_AGENCY_SCHEME_ITEMS_KEY='agencies';var FILTER_MODE_IN='FILTER_MODE_IN';var FILTER_MODE_NOT_IN='FILTER_MODE_NOT_IN';var CODELIST_ORDER_ANNOTATION_KEY="codelistsOrder";var CONCEPT_SCHEME_ORDER_ANNOTATION_KEY="conceptSchemesOrder";var CATEGORY_SCHEME_ORDER_ANNOTATION_KEY="categorySchemesOrder";/* READ */var getSdmxStructuresFromSdmxJson=function getSdmxStructuresFromSdmxJson(json,sdmxJsonStructuresType){return json.data[sdmxJsonStructuresType||Object.keys(json.data)[0]]||[];};var getItemFromSdmxJsonStructure=function getItemFromSdmxJsonStructure(item,annotationsConfig,orderAnnotationKey,customIsAutoAnnotation){return Object.assign({},item,{names:undefined,// fix after sdmx-source update 1.17
name:item.names,// fix after sdmx-source update 1.17
descriptions:undefined,// fix after sdmx-source update 1.17
description:item.descriptions,// fix after sdmx-source update 1.17
annotations:item.annotations&&annotationsConfig?Object(__WEBPACK_IMPORTED_MODULE_2__artefacts__["d" /* getFilteredAnnotations */])(item.annotations,annotationsConfig,customIsAutoAnnotation).map(function(annot){return Object.assign({},annot,{text:annot.texts,// fix after sdmx-source update 1.17
texts:undefined// fix after sdmx-source update 1.17
});}):undefined,autoAnnotations:item.annotations&&annotationsConfig?Object(__WEBPACK_IMPORTED_MODULE_2__artefacts__["c" /* getAutoAnnotations */])(item.annotations,annotationsConfig,customIsAutoAnnotation).map(function(annot){return Object.assign({},annot,{text:annot.texts,// fix after sdmx-source update 1.17
texts:undefined// fix after sdmx-source update 1.17
});}):undefined,order:item.annotations&&annotationsConfig&&orderAnnotationKey?Object(__WEBPACK_IMPORTED_MODULE_2__artefacts__["e" /* getItemOrder */])(item,annotationsConfig[orderAnnotationKey]):undefined,coreRepresentation:item.coreRepresentation});};var DSD_DIMENSION_TYPE_NORMAL='Dimension';var DSD_DIMENSION_TYPE_FREQUENCY='Frequency Dimension';var DSD_DIMENSION_TYPE_TIME='Time Dimension';var DSD_DIMENSION_TYPE_MEASURE='Measure Dimension';var DSD_DIMENSION_ID_FREQUENCY="FREQ";var DSD_DIMENSION_ID_TIME="TIME_PERIOD";var DSD_ATTRIBUTE_ATTACHMENT_LEVEL_OBSERVATION='Observation';var DSD_ATTRIBUTE_ATTACHMENT_LEVEL_GROUP='Group';var DSD_ATTRIBUTE_ATTACHMENT_LEVEL_SERIES='Series';var DSD_ATTRIBUTE_ATTACHMENT_LEVEL_DATASET='Dataset';var getDsdComponentFromSdmxJsonStructure=function getDsdComponentFromSdmxJsonStructure(comp){var attachmentLevel=null;var attachmentGroup=null;if(comp.attributeRelationship&&comp.attributeRelationship.hasOwnProperty('dimensions')){attachmentLevel='Series';}else if(comp.attributeRelationship&&comp.attributeRelationship.hasOwnProperty('primaryMeasure')){attachmentLevel='Observation';}else if(comp.attributeRelationship&&comp.attributeRelationship.hasOwnProperty('attachmentGroups')){attachmentLevel='Group';attachmentGroup=comp.attributeRelationship.attachmentGroups&&comp.attributeRelationship.attachmentGroups.length?comp.attributeRelationship.attachmentGroups[0]:null;}else if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(comp.attributeRelationship)){attachmentLevel='Dataset';}return Object.assign({},comp,{attachmentLevel:attachmentLevel,attachmentGroup:attachmentGroup,annotations:comp.annotations?comp.annotations.map(function(annot){return Object.assign({},annot,{text:annot.texts,// fix after sdmx-source update 1.17
texts:undefined// fix after sdmx-source update 1.17
});}):undefined,concept:comp.conceptIdentity,representation:(comp.localRepresentation||{}).enumeration||null,attachedDimensions:(comp.attributeRelationship||{}).dimensions||null});};var getSdmxJsonStructureFromDsd=function getSdmxJsonStructureFromDsd(dsd){return Object.assign({},getSdmxJsonStructureFromArtefact(dsd),{dataStructureComponents:{measureList:{id:"MeasureDescriptor",primaryMeasure:Object.assign({},getSdmxJsonStructureFromDsdComponent(dsd.primaryMeasure))},dimensionList:{id:"DimensionDescriptor",dimensions:dsd.dimensions.filter(function(_ref){var type=_ref.type;return type===DSD_DIMENSION_TYPE_NORMAL||type===DSD_DIMENSION_TYPE_FREQUENCY;}).map(function(dim){return Object.assign({},getSdmxJsonStructureFromDsdComponent(dim),{type:"Dimension"});})||undefined,measureDimensions:dsd.dimensions.filter(function(_ref2){var type=_ref2.type;return type===DSD_DIMENSION_TYPE_MEASURE;}).map(function(dim){return Object.assign({},getSdmxJsonStructureFromDsdComponent(dim),{type:"MeasureDimension"});})||undefined,timeDimensions:dsd.dimensions.filter(function(_ref3){var type=_ref3.type;return type===DSD_DIMENSION_TYPE_TIME;}).map(function(dim){return Object.assign({},getSdmxJsonStructureFromDsdComponent(dim),{type:"TimeDimension",localRepresentation:{textFormat:{textType:"ObservationalTimePeriod",isSequence:false,isMultiLingual:false}}});})||undefined},groups:dsd.groups?dsd.groups.map(getSdmxJsonStructureFromDsdComponent):undefined,attributeList:dsd.attributes?{id:"AttributeDescriptor",attributes:dsd.attributes.sort(function(a,b){return a.order-b.order;}).map(function(attr){return Object.assign({},getSdmxJsonStructureFromDsdComponent(attr),{position:undefined,attributeRelationship:attr.attachmentLevel===DSD_ATTRIBUTE_ATTACHMENT_LEVEL_SERIES?{dimensions:attr.attachedDimensions}:attr.attachmentLevel===DSD_ATTRIBUTE_ATTACHMENT_LEVEL_GROUP?{attachmentGroups:[attr.attachmentGroup]}:attr.attachmentLevel===DSD_ATTRIBUTE_ATTACHMENT_LEVEL_DATASET?{}:Object.assign({},attr.attributeRelationship,{primaryMeasure:"OBS_VALUE"})});})}:undefined}});};var getDsdFromSdmxJsonStructure=function getDsdFromSdmxJsonStructure(dsd,annotationsConfig,customIsAutoAnnotation){return Object.assign({},getArtefactFromSdmxJsonStructure(dsd,annotationsConfig,customIsAutoAnnotation),{primaryMeasure:getDsdComponentFromSdmxJsonStructure(dsd.dataStructureComponents.measureList.primaryMeasure),dimensions:[].concat(_toConsumableArray(dsd.dataStructureComponents.dimensionList.dimensions.map(function(dim){return Object.assign({},dim,{type:dim.id===DSD_DIMENSION_ID_FREQUENCY?DSD_DIMENSION_TYPE_FREQUENCY:DSD_DIMENSION_TYPE_NORMAL});})),_toConsumableArray((dsd.dataStructureComponents.dimensionList.measureDimensions||[]).map(function(dim){return Object.assign({},dim,{type:DSD_DIMENSION_TYPE_MEASURE});})),_toConsumableArray((dsd.dataStructureComponents.dimensionList.timeDimensions||[]).map(function(dim){return Object.assign({},dim,{type:DSD_DIMENSION_TYPE_TIME});}))).map(getDsdComponentFromSdmxJsonStructure).map(function(dim){return Object.assign({},dim,{order:dim.position+1});}),groups:dsd.dataStructureComponents.groups?dsd.dataStructureComponents.groups.map(getDsdComponentFromSdmxJsonStructure):null,attributes:(dsd.dataStructureComponents.attributeList||{}).attributes?dsd.dataStructureComponents.attributeList.attributes.map(getDsdComponentFromSdmxJsonStructure).map(function(attr,index){return Object.assign({},attr,{order:index+1});}):null,dataStructureComponents:Object.assign({},dsd.dataStructureComponents,{attributeList:dsd.dataStructureComponents.attributeList?Object.assign({},dsd.dataStructureComponents.attributeList,{attributes:dsd.dataStructureComponents.attributeList.attributes.map(getDsdComponentFromSdmxJsonStructure)}):undefined})});};var getContentConstraintFromSdmxJsonStructure=function getContentConstraintFromSdmxJsonStructure(contentConstraint,annotationsConfig){var filter={};if(contentConstraint.cubeRegions){contentConstraint.cubeRegions.forEach(function(_ref4){var isIncluded=_ref4.isIncluded,keyValues=_ref4.keyValues;return keyValues.forEach(function(keyValue){if(filter[keyValue.id]===undefined){filter[keyValue.id]={mode:isIncluded?FILTER_MODE_IN:FILTER_MODE_NOT_IN};filter[keyValue.id].values=[];}if(keyValue.id==="ID_TIME_PERIOD"||keyValue.id==="TIME_PERIOD"){filter[keyValue.id].values=[keyValue.timeRange.startPeriod.period,keyValue.timeRange.endPeriod.period];}else{var _filter$keyValue$id$v;(_filter$keyValue$id$v=filter[keyValue.id].values).push.apply(_filter$keyValue$id$v,_toConsumableArray(keyValue.values||[]));}});});}return{contentConstraint:getArtefactFromSdmxJsonStructure(contentConstraint,annotationsConfig),attachmentType:getTypeFromUrn((contentConstraint.constraintAttachment.dataStructures||contentConstraint.constraintAttachment.dataflows)[0]),attachmentUrn:(contentConstraint.constraintAttachment.dataStructures||contentConstraint.constraintAttachment.dataflows)[0],filter:filter};};var getTypeFromUrn=function getTypeFromUrn(urn){return urn.split("=")[0].split(".").splice(-1)[0];};var getSdmxJsonStructureFromDsdComponent=function getSdmxJsonStructureFromDsdComponent(comp){var annotations=comp.annotations&&comp.annotations.length>0?comp.annotations.filter(function(annot){return!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(annot);}).map(function(annot){return{id:annot.id?annot.id:undefined,title:annot.title?annot.title:undefined,type:annot.type?annot.type:undefined,texts:annot.text?__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(annot.text,function(val){return val.length>0;}):undefined// fix after sdmx-source update 1.17
};}):[];return{id:comp.id,position:comp.order?comp.order-1:undefined,conceptIdentity:comp.concept,localRepresentation:comp.representation?{enumeration:comp.representation}:undefined,attributeRelationship:comp.attachedDimensions?{dimensions:comp.attachedDimensions}:comp.attachmentGroup?{attachmentGroups:[comp.attachmentGroup]}:undefined,groupDimensions:comp.groupDimensions||undefined,assignmentStatus:comp.assignmentStatus||undefined,annotations:annotations&&annotations.length>0?annotations:undefined};};var getItemSchemeFromSdmxJsonFactory=function getItemSchemeFromSdmxJsonFactory(itemsKey,annotationsConfig,orderAnnotationKey,customIsAutoAnnotation){return function(itemScheme){var res=getArtefactFromSdmxJsonStructure(itemScheme,annotationsConfig,customIsAutoAnnotation);if(itemsKey&&res[itemsKey]){res[itemsKey]=itemScheme[itemsKey].map(function(item){return getItemFromSdmxJsonStructure(item,annotationsConfig,orderAnnotationKey,customIsAutoAnnotation);});}return res;};};var getArtefactFromSdmxJsonStructure=function getArtefactFromSdmxJsonStructure(artefact,annotationsConfig,customIsAutoAnnotation){return Object.assign({},artefact,{names:undefined,// fix after sdmx-source update 1.17
name:artefact.names,// fix after sdmx-source update 1.17
descriptions:undefined,// fix after sdmx-source update 1.17
description:artefact.descriptions,// fix after sdmx-source update 1.17
isFinal:artefact.isFinal||false,validFrom:artefact.validFrom&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(artefact.validFrom).unix()>0?__WEBPACK_IMPORTED_MODULE_1_moment___default()(artefact.validFrom):undefined,validTo:artefact.validTo&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(artefact.validTo).unix()>0?__WEBPACK_IMPORTED_MODULE_1_moment___default()(artefact.validTo):undefined,reportingBegin:artefact.reportingBegin&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(artefact.reportingBegin).unix()>0?__WEBPACK_IMPORTED_MODULE_1_moment___default()(artefact.reportingBegin):undefined,reportingEnd:artefact.reportingEnd&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(artefact.reportingEnd).unix()>0?__WEBPACK_IMPORTED_MODULE_1_moment___default()(artefact.reportingEnd):undefined,publicationYear:artefact.publicationYear&&!isNaN(artefact.publicationYear)?Number(artefact.publicationYear):undefined,annotations:artefact.annotations?Object(__WEBPACK_IMPORTED_MODULE_2__artefacts__["d" /* getFilteredAnnotations */])(artefact.annotations,annotationsConfig,customIsAutoAnnotation).map(function(annot){return Object.assign({},annot,{text:annot.texts,// fix after sdmx-source update 1.17
texts:undefined// fix after sdmx-source update 1.17
});}):undefined,autoAnnotations:artefact.annotations?Object(__WEBPACK_IMPORTED_MODULE_2__artefacts__["c" /* getAutoAnnotations */])(artefact.annotations,annotationsConfig,customIsAutoAnnotation).map(function(annot){return Object.assign({},annot,{text:annot.texts,// fix after sdmx-source update 1.17
texts:undefined// fix after sdmx-source update 1.17
});}):undefined,urn:artefact.urn||((artefact.links||[]).filter(function(link){return link.rel==='self';})[0]||{}).urn,msdUrn:getMsdUrnFromMetadataSet(artefact)||undefined});};/* WRITE */var getSdmxJsonFromSdmxJsonStructures=function getSdmxJsonFromSdmxJsonStructures(structures,sdmxJsonStructuresType){return{meta:{},data:_defineProperty({},sdmxJsonStructuresType,structures)};};var getSdmxJsonStructureFromContentConstraint=function getSdmxJsonStructureFromContentConstraint(contentConstraint,attachmentType,attachmentUrn,filter){var cubeRegions=[];if(filter!==null){Object.keys(filter).filter(function(id){return filter[id].values.length>0;}).forEach(function(id){return cubeRegions.push({isIncluded:filter[id].mode===FILTER_MODE_IN,keyValues:[{id:id,values:id!=="ID_TIME_PERIOD"&&id!=="TIME_PERIOD"?filter[id].values:undefined,timeRange:id==="ID_TIME_PERIOD"||id==="TIME_PERIOD"?{startPeriod:{period:filter[id].values[0],isInclusive:true},endPeriod:{period:filter[id].values[1],isInclusive:true}}:undefined}]});});}return Object.assign({},getSdmxJsonStructureFromArtefact(contentConstraint),{type:"Actual",constraintAttachment:_defineProperty({},attachmentType==="dsd"?"dataStructures":"dataflows",[attachmentUrn]),cubeRegions:cubeRegions.length>0?cubeRegions:undefined});};var getSdmxJsonStructureFromArtefact=function getSdmxJsonStructureFromArtefact(artefact){var annotations=artefact.annotations&&artefact.annotations.length>0?artefact.annotations.filter(function(annot){return!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(annot);}).map(function(annot){return{id:annot.id?annot.id:undefined,title:annot.title?annot.title:undefined,type:annot.type?annot.type:undefined,texts:annot.text?__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(annot.text,function(val){return val&&val.length>0;}):undefined// fix after sdmx-source update 1.17
};}):[];var autoAnnotations=artefact.autoAnnotations&&artefact.autoAnnotations.length>0?artefact.autoAnnotations.filter(function(annot){return!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(annot);}).map(function(annot){return{id:annot.id?annot.id:undefined,title:annot.title?annot.title:undefined,type:annot.type?annot.type:undefined,texts:annot.text?__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(annot.text,function(val){return val&&val.length>0;}):undefined// fix after sdmx-source update 1.17
};}):[];annotations=annotations.concat(autoAnnotations);var description=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(artefact.description,function(val){return val&&val.length>0;});return{id:artefact.id,version:artefact.version,agencyID:artefact.agencyID,isFinal:artefact.isFinal||undefined,uri:artefact.uri&&artefact.uri.length>0?artefact.uri:undefined,validFrom:artefact.validFrom?artefact.validFrom:undefined,validTo:artefact.validTo?artefact.validTo:undefined,reportingBegin:artefact.reportingBegin?artefact.reportingBegin:undefined,reportingEnd:artefact.reportingEnd?artefact.reportingEnd:undefined,publicationYear:artefact.publicationYear&&typeof artefact.publicationYear==="number"?Number(artefact.publicationYear).toString():undefined,publicationPeriod:artefact.publicationPeriod?artefact.publicationPeriod:undefined,names:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(artefact.name,function(val){return val.length>0;}),// fix after sdmx-source update 1.17
descriptions:!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(description)?description:undefined,// fix after sdmx-source update 1.17
annotations:annotations&&annotations.length>0?annotations:undefined,structure:artefact.structure?artefact.structure:undefined,source:artefact.source?artefact.source:undefined,target:artefact.target?artefact.target:undefined,codes:artefact.codes&&artefact.codes.length>0?artefact.codes:undefined,categories:artefact.categories&&artefact.categories.length>0?artefact.categories:undefined,concepts:artefact.concepts&&artefact.concepts.length>0?artefact.concepts:undefined,agencies:artefact.agencies&&artefact.agencies.length>0?artefact.agencies:undefined,reports:artefact.reports?artefact.reports:undefined,metadataStructureComponents:artefact.metadataStructureComponents?artefact.metadataStructureComponents:undefined,links:artefact.msdUrn?[getMsdUrnLinkFromMetadataSet(artefact)]:undefined};};var getSdmxJsonStructureFromItem=function getSdmxJsonStructureFromItem(item,orderAnnotationType,discardOrderAnnotation){if(orderAnnotationType&&item.order!==undefined){if(item.order!==null&&!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.order,function(val){return val.length>0;}))){if(item.autoAnnotations){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(item.autoAnnotations,function(annotation){return annotation.type===orderAnnotationType;})){var correctValues=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.order,function(val){return val.length>0;});__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(item.autoAnnotations,function(annotation){return annotation.type===orderAnnotationType;}).texts=!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(correctValues)?correctValues:undefined;}else{var _correctValues=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.order,function(val){return val.length>0;});item.autoAnnotations.push({type:orderAnnotationType,text:!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(_correctValues)?_correctValues:undefined});}}else{var _correctValues2=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.order,function(val){return val.length>0;});item.autoAnnotations=[{type:orderAnnotationType,text:!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(_correctValues2)?_correctValues2:undefined}];}}else{if(item.autoAnnotations){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(item.autoAnnotations,function(annotation){return annotation.type===orderAnnotationType;})){item.autoAnnotations=item.autoAnnotations.filter(function(annot){return annot.type!==orderAnnotationType;});}}}}var annotations=item.annotations&&item.annotations.length>0?item.annotations.filter(function(annot){return!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(annot);}).map(function(annot){var correctValue=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(annot.text,function(val){return val.length>0;});return{id:annot.id?annot.id:undefined,title:annot.title?annot.title:undefined,type:annot.type?annot.type:undefined,texts:annot.text&&!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(correctValue)?correctValue:undefined// fix after sdmx-source update 1.17
};}):null;var autoAnnotations=item.autoAnnotations&&item.autoAnnotations.length>0?item.autoAnnotations.filter(function(annot){return!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(annot);}).filter(function(_ref5){var type=_ref5.type;return!discardOrderAnnotation||type.toLowerCase()!==orderAnnotationType.toLowerCase();}).map(function(annot){var correctValue=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(annot.text,function(val){return val.length>0;});return{id:annot.id?annot.id:undefined,title:annot.title?annot.title:undefined,type:annot.type?annot.type:undefined,texts:annot.text&&!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(correctValue)?correctValue:undefined// fix after sdmx-source update 1.17
};}):null;annotations=(annotations||[]).concat(autoAnnotations||[]);var description=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.description,function(val){return val.length>0;});return{id:item.id,names:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.name,function(val){return val.length>0;}),// fix after sdmx-source update 1.17
parent:item.parent||undefined,categories:item.categories?item.categories.map(function(item){return getSdmxJsonStructureFromItem(item,orderAnnotationType,discardOrderAnnotation);}):undefined,annotations:annotations&&annotations.length>0?annotations:undefined,descriptions:!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(description)?description:undefined,// fix after sdmx-source update 1.17,
coreRepresentation:item.coreRepresentation};};/* URN & STRINGS */function getCategoryIdFromUrn(urn){return urn.split('=')[1].split('.').length>2?urn.substr(urn.lastIndexOf('.')+1):getArtefactTripletFromUrn(urn).id;}var getArtefactTripletFromString=function getArtefactTripletFromString(str){var split=str.split('+');return{id:split[0],agencyID:split[1],version:split[2]};};var getArtefactTripletFromUrn=function getArtefactTripletFromUrn(str){var substr=str.split('=')[1];return{id:substr.split(':')[1].split('(')[0],agencyID:substr.split(':')[0],version:substr.split('(')[1].split(')')[0]};};var getUrnFromArtefactTriplet=function getUrnFromArtefactTriplet(_ref6,structureTypeUrnNamespace){var id=_ref6.id,agencyID=_ref6.agencyID,version=_ref6.version;return'urn:sdmx:'+structureTypeUrnNamespace+'='+agencyID+':'+id+'('+version+')';};var getStringFromArtefactTriplet=function getStringFromArtefactTriplet(triplet){return triplet?triplet.id+'+'+triplet.agencyID+'+'+triplet.version:"";};function getUrnFromArtefact(artefact){return artefact.urn||artefact.links.filter(function(link){return link.rel==='self';})[0].urn;}function getStringFromItemUrn(urn){return'('+getStringFromArtefactTriplet(getArtefactTripletFromUrn(urn))+') '+urn.split(".").pop();}function getMsdUrnFromMetadataSet(metadataSet){return metadataSet.links?(metadataSet.links.find(function(link){return link.rel==='msd';})||{}).urn:undefined;}function getMsdUrnLinkFromMetadataSet(metadataSet){return{rel:"msd",urn:metadataSet.msdUrn};}/* OTHER */function isArtefactChildOfArtefact(child,parent){var childUrn=getUrnFromArtefact(child);if(childUrn.lastIndexOf(")")===childUrn.length-1){return false;// è un category scheme
}else{var parentUrn=getUrnFromArtefact(parent);var str=childUrn.substr(childUrn.indexOf("="));return str.substr(0,str.lastIndexOf("."))===parentUrn.substr(parentUrn.indexOf("="));}}function getTypeFromArtefact(artefact){var urn=artefact.links.filter(function(link){return link.rel==='self';})[0].urn;var firstPart=urn.split('=')[0];var dotSplit=firstPart.split(".");return dotSplit[dotSplit.length-1].toLowerCase();}function getQuartupletFromItemString(str){return{id:str.split('(')[1].split('+')[0],agencyID:str.split('(')[1].split('+')[1],version:str.split('(')[1].split('+')[2].split(")")[0],itemId:str.split(')')[1].split(' ')[1]};}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(215);

var _default = _grid.Row;
exports["default"] = _default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(296);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(215);

var _default = _grid.Col;
exports["default"] = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(296);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(986);

__webpack_require__(8);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Modal = _interopRequireWildcard(__webpack_require__(441));

var _confirm = _interopRequireDefault(__webpack_require__(991));

var _icon = _interopRequireDefault(__webpack_require__(25));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

_Modal["default"].info = function (props) {
  var config = _extends({
    type: 'info',
    icon: React.createElement(_icon["default"], {
      type: "info-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].success = function (props) {
  var config = _extends({
    type: 'success',
    icon: React.createElement(_icon["default"], {
      type: "check-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].error = function (props) {
  var config = _extends({
    type: 'error',
    icon: React.createElement(_icon["default"], {
      type: "close-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].warning = _Modal["default"].warn = function (props) {
  var config = _extends({
    type: 'warning',
    icon: React.createElement(_icon["default"], {
      type: "exclamation-circle"
    }),
    okCancel: false
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].confirm = function (props) {
  var config = _extends({
    type: 'confirm',
    okCancel: true
  }, props);

  return (0, _confirm["default"])(config);
};

_Modal["default"].destroyAll = function () {
  while (_Modal.destroyFns.length) {
    var close = _Modal.destroyFns.pop();

    if (close) {
      close();
    }
  }
};

var _default = _Modal["default"];
exports["default"] = _default;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* Calls a function right after the WrappedComponent has been mounted and updated (if props changed) */var Call=function(_React$Component){_inherits(Call,_React$Component);function Call(){_classCallCheck(this,Call);return _possibleConstructorReturn(this,(Call.__proto__||Object.getPrototypeOf(Call)).apply(this,arguments));}_createClass(Call,[{key:'componentDidMount',value:function componentDidMount(){/* children has been mounted */if((this.props.disabled===undefined||!this.props.disabled)&&!this.props.disableFirst){this.props.cb(this.props.cbParam);}}},{key:'componentDidUpdate',value:function componentDidUpdate(_ref){var cb=_ref.cb,cbParam=_ref.cbParam,disabled=_ref.disabled;/* children has been updated */if((this.props.disabled===undefined||!this.props.disabled||this.props.checkCbParamChangeOnly)&&(JSON.stringify(cbParam)!==JSON.stringify(this.props.cbParam)||this.props.disabled!==undefined&&disabled===true&&this.props.disabled===false&&!this.props.checkCbParamChangeOnly)){this.props.cb(this.props.cbParam);}}},{key:'render',value:function render(){return this.props.children;}}]);return Call;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Call);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_language_selector__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_css__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ANT_MODAL_CONTENT_SELECTOR='.ant-modal-content';var ANT_MODAL_HEADER_SELECTOR='.ant-modal-header';var ANT_MODAL_BODY_SELECTOR='.ant-modal-body';var ANT_MODAL_FOOTER_SELECTOR='.ant-modal-footer';var ANT_MODAL_FULLSCREEN_TOP=30;var ANT_MODAL_FULLSCREEN_PERCENTAGE=98;var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var $=window.jQuery;var EnhancedModal=function(_Component){_inherits(EnhancedModal,_Component);function EnhancedModal(props){_classCallCheck(this,EnhancedModal);var _this2=_possibleConstructorReturn(this,(EnhancedModal.__proto__||Object.getPrototypeOf(EnhancedModal)).call(this,props));_this2.state={className:__WEBPACK_IMPORTED_MODULE_11_uuid___default()(),dragAndResizeEnabled:false,language:null,oldVisible:null,modalInitialDimensions:null,modalBodyInitialHeight:null,isFullscreen:false,modalHeaderAndFooterHeight:0};_this2.revertInitialPosAndDim=_this2.revertInitialPosAndDim.bind(_this2);return _this2;}_createClass(EnhancedModal,[{key:"componentDidMount",value:function componentDidMount(){var _this3=this;$(window).resize(function(e){if(e.target===window){var modal=$("."+_this3.state.className+" "+ANT_MODAL_CONTENT_SELECTOR);if(modal){modal.css({top:0,left:0});// reset modal position (centered)
}}});this.setState({isFullscreen:this.props.fullscreen});}},{key:"componentDidUpdate",value:function componentDidUpdate(){var _this4=this;var modal=$("."+this.state.className+" "+ANT_MODAL_CONTENT_SELECTOR);var modalHeader=modal.find(ANT_MODAL_HEADER_SELECTOR);var modalHeaderHeight=modalHeader.outerHeight()||0;var modalFooter=modal.find(ANT_MODAL_FOOTER_SELECTOR);var modalFooterHeight=modalFooter.outerHeight()||0;if(this.state.modalHeaderAndFooterHeight===0&&modalHeaderHeight+modalFooterHeight>0){this.setState({modalHeaderAndFooterHeight:modalHeaderHeight+modalFooterHeight});}if(!this.state.dragAndResizeEnabled&&this.state.modalHeaderAndFooterHeight>0){this.setState({dragAndResizeEnabled:true});if(modal.length>0){var modalBody=modal.find(ANT_MODAL_BODY_SELECTOR);modal.draggable({handle:ANT_MODAL_HEADER_SELECTOR+", "+ANT_MODAL_FOOTER_SELECTOR,// containment: 'document',
scroll:false}).resizable({disabled:this.state.isFullscreen,minWidth:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_SM"],minHeight:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_HEIGHT_XS"],maxHeight:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_HEIGHT_MD"]+this.state.modalHeaderAndFooterHeight,handles:'n, e, s, w, ne, se, sw, nw',resize:function resize(_,_ref){var originalSize=_ref.originalSize,size=_ref.size;var modalBodyHeight=modal.outerHeight()-modalHeader.outerHeight()-(modalFooter.outerHeight()||0)-(modalBody.outerHeight()-modalBody.height());if(originalSize.height!==size.height){modalBody.height(modalBodyHeight);}if(!_this4.state.modalInitialDimensions){_this4.setState({modalInitialDimensions:{width:originalSize.width,height:originalSize.height},modalBodyInitialHeight:originalSize.height-modalHeader.outerHeight()-(modalFooter.outerHeight()||0)-(modalBody.outerHeight()-modalBody.height())});}}});var resetter=$("\n          <div style='\n            background: #ccc8; \n            color: #fffc; \n            text-align: center; \n            border-bottom-left-radius: 8px; \n            border-bottom-right-radius: 8px; \n            width: 200px; \n            left: 50%;\n            margin-left: -100px; \n            position: absolute; \n            z-index: 100000; \n            cursor: pointer'\n          > \n            "+this.props.t("components.enhancedModal.resetter.title")+" \n          </div>\n        ");var _this=this;resetter.click(function(e){return e.target===this?_this.revertInitialPosAndDim():null;});modal.parent().parent()// .css("overflow", "hidden")
.prepend(resetter);}}}},{key:"revertInitialPosAndDim",value:function revertInitialPosAndDim(){var modal=$("."+this.state.className+" "+ANT_MODAL_CONTENT_SELECTOR);if(this.state.modalInitialDimensions&&this.state.modalBodyInitialHeight!==null){modal.width(this.state.modalInitialDimensions.width);modal.height(this.state.modalInitialDimensions.height);var modalBody=modal.find(ANT_MODAL_BODY_SELECTOR);modalBody.height(this.state.modalBodyInitialHeight);}modal.css({top:0,left:0});}},{key:"render",value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(parentDataLanguage){var dataLanguage=_this5.state.language||parentDataLanguage||(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.find(_this5.props.dataLanguages,function(_ref2){var code=_ref2.code;return code===_this5.props.appLanguage;})||{}).code||'en';return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a,Object.assign({},_this5.props,{width:_this5.state.isFullscreen?ANT_MODAL_FULLSCREEN_PERCENTAGE+"vw":_this5.props.width,style:{minWidth:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_SM"],minHeight:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_HEIGHT_XS"],top:_this5.state.isFullscreen?ANT_MODAL_FULLSCREEN_TOP:undefined,paddingBottom:_this5.state.isFullscreen?0:undefined},className:_this5.state.className+" "+(_this5.state.isFullscreen?"enhanced-modal--fullscreen":""),bodyStyle:Object.assign({width:"100%",height:_this5.state.isFullscreen?"calc("+ANT_MODAL_FULLSCREEN_PERCENTAGE+"vh - "+(_this5.state.modalHeaderAndFooterHeight+ANT_MODAL_FULLSCREEN_TOP)+"px)":"100%",maxHeight:_this5.state.isFullscreen?undefined:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_HEIGHT_MD"],overflow:'auto'},_this5.props.bodyStyle),forceRender:true,destroyOnClose:false,maskClosable:false,afterClose:_this5.revertInitialPosAndDim,title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:{marginRight:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_XL"]+__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,_this5.props.title),_this5.props.withDataLanguageSelector&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{fontWeight:'initial'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__data_language_selector__["a" /* default */],{value:dataLanguage,size:"small",onSelect:function onSelect(selected){if(_this5.props.onDataLanguageSelectorChange){_this5.props.onDataLanguageSelectorChange(selected,function(){return _this5.setState({language:selected});});}else{_this5.setState({language:selected});}}}))),footer:_this5.props.footer?_this5.props.withDataLanguageSelector?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["b" /* DataLanguageProvider */],{value:dataLanguage},_this5.props.footer):_this5.props.footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null),zIndex:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["Z_INDEX_ENHANCED_MODAL"]}),_this5.props.visible&&(_this5.props.withDataLanguageSelector?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["b" /* DataLanguageProvider */],{value:dataLanguage},_this5.props.children):_this5.props.children));});}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(props,state){return{oldVisible:props.visible,language:props.visible&&!state.oldVisible?null:state.language};}}]);return EnhancedModal;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps))(EnhancedModal));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(131);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(718);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(722);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(131);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(911);

__webpack_require__(427);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Form = _interopRequireDefault(__webpack_require__(912));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Form["default"];
exports["default"] = _default;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var allIcons = _interopRequireWildcard(__webpack_require__(759));

var _iconsReact = _interopRequireDefault(__webpack_require__(402));

var _IconFont = _interopRequireDefault(__webpack_require__(857));

var _utils = __webpack_require__(858);

var _warning = _interopRequireDefault(__webpack_require__(87));

var _twoTonePrimaryColor = __webpack_require__(859);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

// Initial setting
_iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
  return allIcons[key];
})));

(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
var defaultTheme = 'outlined';
var dangerousTheme = undefined;

var Icon = function Icon(props) {
  var _classNames;

  var className = props.className,
      type = props.type,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      children = props.children,
      theme = props.theme,
      twoToneColor = props.twoToneColor,
      restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "children", "theme", "twoToneColor"]);

  (0, _warning["default"])(Boolean(type || Component || children), 'Icon should have `type` prop or `component` prop or `children`.');
  var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
  var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
  var innerNode; // component > children > type

  if (Component) {
    var innerSvgProps = _extends({}, _utils.svgBaseProps, {
      className: svgClassString,
      viewBox: viewBox
    });

    if (!viewBox) {
      delete innerSvgProps.viewBox;
    }

    innerNode = React.createElement(Component, innerSvgProps, children);
  }

  if (children) {
    (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && React.isValidElement(children) && React.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');

    var _innerSvgProps = _extends({}, _utils.svgBaseProps, {
      className: svgClassString
    });

    innerNode = React.createElement("svg", _extends({}, _innerSvgProps, {
      viewBox: viewBox
    }), children);
  }

  if (typeof type === 'string') {
    var computedType = type;

    if (theme) {
      var themeInName = (0, _utils.getThemeFromTypeName)(type);
      (0, _warning["default"])(!themeInName || theme === themeInName, "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
    }

    computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)((0, _utils.alias)(computedType)), dangerousTheme || theme || defaultTheme);
    innerNode = React.createElement(_iconsReact["default"], {
      className: svgClassString,
      type: computedType,
      primaryColor: twoToneColor
    });
  }

  return React.createElement("i", _extends({}, restProps, {
    className: classString
  }), innerNode);
};

function unstable_ChangeThemeOfIconsDangerously(theme) {
  (0, _warning["default"])(false, "You are using the unstable method 'Icon.unstable_ChangeThemeOfAllIconsDangerously', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
  dangerousTheme = theme;
}

function unstable_ChangeDefaultThemeOfIcons(theme) {
  (0, _warning["default"])(false, "You are using the unstable method 'Icon.unstable_ChangeDefaultThemeOfIcons', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
  defaultTheme = theme;
}

Icon.createFromIconfontCN = _IconFont["default"];
Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
var _default = Icon;
exports["default"] = _default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(866);

__webpack_require__(8);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Input = _interopRequireDefault(__webpack_require__(297));

var _Group = _interopRequireDefault(__webpack_require__(902));

var _Search = _interopRequireDefault(__webpack_require__(903));

var _TextArea = _interopRequireDefault(__webpack_require__(908));

var _Password = _interopRequireDefault(__webpack_require__(910));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Input["default"].Group = _Group["default"];
_Input["default"].Search = _Search["default"];
_Input["default"].TextArea = _TextArea["default"];
_Input["default"].Password = _Password["default"];
var _default = _Input["default"];
exports["default"] = _default;

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getDsdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAgencySchemeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return getPaginatedCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return getUpdateCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getCloneCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return getInsertItemUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return getUpdateItemUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getDeleteItemUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return getMoveItemUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getAvailableParentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getCubeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAllCubeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getDcsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return getFileMappingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getCategorySchemeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getConceptSchemeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getDdbDataflowUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getDataflowUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return getMsdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return getHierarchicalCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return getMetadataflowUrl; });
/* unused harmony export getAgencyUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAgencyNamesUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return getUpdateArtefactsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getCreateArtefactsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getDeleteArtefactUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getDataflowHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getCreateDdbDataflowUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return getUpdateDdbDataflowUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getContentConstraintUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getDataflowContentConstraintUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getArtefactReferenceUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return getMetadataSetsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return getMetadataSetUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return getMetadataSetReportsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return getMetadataSetReportUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return getUpsertMetadataSetUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getDeleteMetadataSetUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getCloneMetadataSetUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return getUpsertJsonReportUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getDeleteReportUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return getUpdateStateReportUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return getPaginatedDerivedCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getDerivedCodelistSelectTargetItemUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getDerivedCodelistSelectSourceItemUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getDerivedCodelistSelectAllItemsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getDerivedCodelistStoreSelectedItemsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getDerivedCodelistCreateUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getDerivedCodelistRestoreDbUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getDerivedCodelistIsSourceItemValidUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return getSetDefaultOrderUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return getUpdateMsdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return getUpdateHierarchicalCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return getSeriesForCubeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getDeleteSeriesForCubeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return getUploadFileOnServerUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return getUploadFileOnServerAbsoluteUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getCsvHeaderUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getCsvTablePreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getCsvTableColumnPreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return getPreloadCsvUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return getStagingAreaTablesUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return getFileFromStagingAreaTableUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return getImportCsvUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getAttributeFileUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return getTablePreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return getSdmxMlTablePreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return getImportSdmxMlUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return getImportDCSUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getDataflowPreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getDataflowColumnPreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getDataflowCsvUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getDownloadArtefactUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return getMultipleDownloadArtefactUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getDownloadDdbdataflowUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return getExportArtefactUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getCheckImportedFileXmlSdmxObjectsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return getImportFileXmlSdmxObjectsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getCreateDataflowMappingSetUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return getRemoveDataflowMappingSetUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getCreateDataflowTranscodingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getCreateDataflowTranscodingFromCCUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return getRemoveDataflowTranscodingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getCreateDataflowContentConstraintUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return getRemoveDataflowContentConstraintUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return getSetDataflowProductionFlagUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return getMappingSetIdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getCheckImportedFileCsvItemUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return getImportFileCsvItemUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return getShyncCodelistsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAllCodelistToBeSynchronizedUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return getDsdWithDataflowUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getAllUpgradableDsdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return getUpgradeDsdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return getGenerateReportDsdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getCompareDsdsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return getGenerateFileReportDsdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getCompareCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getCompareItemsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getCompareItemsForFileUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return getMergeArtefactsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return getMergeCodelistsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return getMergedCodelistPageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return getSaveMergedCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return getXmlArtefactPreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return getXmlCodelistPreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return getUploadRMFileOnServerUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getDownloadRMFileOnServerUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getCreateDCSCategoryUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return getEditDCSCategoryUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getDeleteDCSCategoryUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getCloneMsdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getCloneHclUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getConvertPxToCsvUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getConvertXlsToCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return getImportDSDFromDataflowUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return getEasyLoadDataFromSdmxUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getEasyLoadDataFromFileUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getEasyLoadDataFromDbUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return getEasyUpdateDataFromSdmxUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return getEasyUpdateDataFromFileUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return getEasyUpdateDataFromDbUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return getPartialCodelistUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getDataUploadStatusUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIG_TYPE_APP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONFIG_TYPE_NODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getConfigUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getAppConfigUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return getNodePingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return getSaveConfigNodeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getDeleteConfigNodeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return getSortNodesUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getCheckEndpointNSIUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getCheckEndpointMAUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getCheckEndpointDMUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getCheckAgencyAssignedToAnyUserUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return getSaveConfigNodeProviderUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return getLoginUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return getLogoutUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return getSuperUserLoginUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return getSuperUserLogoutUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return getRecoverPasswordUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return getUpdateUserUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return getProviderLoginUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return getReadPermissionsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAllAgenciesUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAllFunctionalitiesUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getAllRulesUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return getSubmitPermissionsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return getSynchronizeAuthDBUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getCreateUserUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getDeleteUserUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getCubeOwnersUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getDataflowOwnersUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return getMetadataflowOwnersUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return getSetOwnersUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return getRemoveTempTablesUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getDisembargoCubeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return getEmptyCubeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getDdbResetUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAddAgencyToConfigUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getDataBrowserClearAllCacheUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getDataBrowserClearCacheUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getCreateCodelistUrl; });
/* CRUD */var getArtefactUrl=function getArtefactUrl(artefactTriplet){return artefactTriplet?'/'+artefactTriplet.id+'/'+artefactTriplet.agencyID+'/'+artefactTriplet.version:'';};var getDsdUrl=function getDsdUrl(dsdTriplet,excludeCustom){return'dsd'+(dsdTriplet?getArtefactUrl(dsdTriplet):'')+(!dsdTriplet&&excludeCustom?'/true':'');};var getCodelistUrl=function getCodelistUrl(triplet){return'codelist'+(triplet?getArtefactUrl(triplet):'');};var getAgencySchemeUrl=function getAgencySchemeUrl(triplet){return'agencyScheme'+(triplet?getArtefactUrl(triplet):'');};var getPaginatedCodelistUrl=function getPaginatedCodelistUrl(){return'NOSQL/codelist';};var getUpdateCodelistUrl=function getUpdateCodelistUrl(triplet,lang){return'NOSQL/save'+getArtefactUrl(triplet)+'/'+lang;};var getCloneCodelistUrl=function getCloneCodelistUrl(srcTriplet,destTriplet){return'codelist/clone'+getArtefactUrl(srcTriplet)+getArtefactUrl(destTriplet);};var getInsertItemUrl=function getInsertItemUrl(triplet,lang){return'/NOSQL/insert'+getArtefactUrl(triplet)+'/'+lang;};var getUpdateItemUrl=function getUpdateItemUrl(triplet,lang){return'/NOSQL/update'+getArtefactUrl(triplet)+'/'+lang;};var getDeleteItemUrl=function getDeleteItemUrl(triplet,itemId,lang,autoSave){return'/NOSQL/codelist'+getArtefactUrl(triplet)+'/'+itemId+'/'+lang+'/'+autoSave;};var getMoveItemUrl=function getMoveItemUrl(triplet,lang){return'/NOSQL/move'+getArtefactUrl(triplet)+'/'+lang;};var getAvailableParentUrl=function getAvailableParentUrl(){return'NOSQL/parentsAvailable';};var getCubeUrl=function getCubeUrl(cubeId){return'cube'+(cubeId?'/'+cubeId:'');};var getAllCubeUrl=function getAllCubeUrl(){return'cubesNoFilter';};var getDcsUrl=function getDcsUrl(){return'dcs';};var getFileMappingUrl=function getFileMappingUrl(fileMappingId){return'fileMapping'+(fileMappingId?'/'+fileMappingId:'');};var getCategorySchemeUrl=function getCategorySchemeUrl(categorySchemeTriplet,withCategorisations){return'categoryScheme'+(categorySchemeTriplet?getArtefactUrl(categorySchemeTriplet):'')+(withCategorisations?'/parents':'');};var getConceptSchemeUrl=function getConceptSchemeUrl(conceptSchemeTriplet,withCategorisations){return'conceptScheme'+(conceptSchemeTriplet?getArtefactUrl(conceptSchemeTriplet):'')+(withCategorisations?'/parents':'');};var getDdbDataflowUrl=function getDdbDataflowUrl(ddbDataflowId){return'ddbDataflow'+(ddbDataflowId?'/'+ddbDataflowId:'');};var getDataflowUrl=function getDataflowUrl(dataflowTriplet){return'dataflow'+(dataflowTriplet?getArtefactUrl(dataflowTriplet):'');};var getMsdUrl=function getMsdUrl(msdTriplet){return'msd'+(msdTriplet?getArtefactUrl(msdTriplet):'');};var getHierarchicalCodelistUrl=function getHierarchicalCodelistUrl(hierarchicalCodelistTriplet){return'getHierarchicalCodelist'+(hierarchicalCodelistTriplet?getArtefactUrl(hierarchicalCodelistTriplet):'');};var getMetadataflowUrl=function getMetadataflowUrl(metadataflowTriplet){return'metadataflow'+(metadataflowTriplet?getArtefactUrl(metadataflowTriplet):'');};var getUsernameUrl=function getUsernameUrl(username){return''+(username?'/'+username:'');};var getAgencyUrl=function getAgencyUrl(username){return'getAgency'+getUsernameUrl(username);};var getAgencyNamesUrl=function getAgencyNamesUrl(){return'AgencyName';};var getUpdateArtefactsUrl=function getUpdateArtefactsUrl(){return'updateArtefacts';};var getCreateArtefactsUrl=function getCreateArtefactsUrl(){return'createArtefacts';};var getDeleteArtefactUrl=function getDeleteArtefactUrl(artefactType,artefactTriplet){return'artefact/'+artefactType+getArtefactUrl(artefactTriplet);};var getDataflowHeader=function getDataflowHeader(dataflowTriplet){return'getDfHeader'+getArtefactUrl(dataflowTriplet);};var getCreateDdbDataflowUrl=function getCreateDdbDataflowUrl(){return'/createDDBDataflow';};var getUpdateDdbDataflowUrl=function getUpdateDdbDataflowUrl(){return'/updateDDBDataflow';};var getContentConstraintUrl=function getContentConstraintUrl(triplet){return'/getContentConstraint'+getArtefactUrl(triplet);};var getDataflowContentConstraintUrl=function getDataflowContentConstraintUrl(artefactTriplet){return"ArtefactContentConstraint/dataflow"+getArtefactUrl(artefactTriplet);};var getArtefactReferenceUrl=function getArtefactReferenceUrl(artefactType,artefactTriplet){return'artefactReference/'+artefactType+getArtefactUrl(artefactTriplet);};var getMetadataSetsUrl=function getMetadataSetsUrl(){return'api/RM/getJsonMetadatasetList';};var getMetadataSetUrl=function getMetadataSetUrl(metadataSetId){return'api/RM/getJsonMetadataset/'+metadataSetId+'/?excludeReport=true&withAttributes=false';};var getMetadataSetReportsUrl=function getMetadataSetReportsUrl(metadataSetId){return'api/RM/getJsonMetadataset/'+metadataSetId+'/?excludeReport=false&withAttributes=false';};var getMetadataSetReportUrl=function getMetadataSetReportUrl(metadataSetId,reportId){return'api/RM/getJsonReport/'+metadataSetId+'/'+reportId;};var getUpsertMetadataSetUrl=function getUpsertMetadataSetUrl(){return'api/RM/upsertJsonMetadataSet';};var getDeleteMetadataSetUrl=function getDeleteMetadataSetUrl(metadataSetId){return'api/RM/deleteGenericMetadataset/'+metadataSetId;};var getCloneMetadataSetUrl=function getCloneMetadataSetUrl(metadataSetId,newMetadataSetId){return'api/RM/cloneJsonMetadataSet/'+metadataSetId+'/'+newMetadataSetId;};var getUpsertJsonReportUrl=function getUpsertJsonReportUrl(metadataSetId){return'api/RM/upsertJsonReport/'+metadataSetId;};var getDeleteReportUrl=function getDeleteReportUrl(reportDbId){return'api/RM/deleteReport/'+reportDbId;};var getUpdateStateReportUrl=function getUpdateStateReportUrl(metadataSetId,reportId){return'api/RM/updateStateMetReport/'+metadataSetId+'/'+reportId;};var getPaginatedDerivedCodelistUrl=function getPaginatedDerivedCodelistUrl(isTarget){return'NOSQL/preview/codelist/'+isTarget;};var getDerivedCodelistSelectTargetItemUrl=function getDerivedCodelistSelectTargetItemUrl(artefactTriplet,isSelected,lang){return'NOSQL/preview/selectedItem/'+isSelected+getArtefactUrl(artefactTriplet)+'/'+lang;};var getDerivedCodelistSelectSourceItemUrl=function getDerivedCodelistSelectSourceItemUrl(artefactTriplet,isSelected,lang){return'NOSQL/selectedItem/'+isSelected+getArtefactUrl(artefactTriplet)+'/'+lang;};var getDerivedCodelistSelectAllItemsUrl=function getDerivedCodelistSelectAllItemsUrl(artefactTriplet,isTarget,isSelected,lang){return'NOSQL/selectAllItem/'+isTarget+'/'+isSelected+getArtefactUrl(artefactTriplet)+'/'+lang;};var getDerivedCodelistStoreSelectedItemsUrl=function getDerivedCodelistStoreSelectedItemsUrl(artefactTriplet,isTarget,lang,removeParent,parents,children,descendants){return'NOSQL/preview/storeSelectedItem/'+isTarget+getArtefactUrl(artefactTriplet)+'/'+lang+'/'+parents+'/'+children+'/'+descendants+'/'+removeParent;};var getDerivedCodelistCreateUrl=function getDerivedCodelistCreateUrl(artefactTriplet,lang){return'NOSQL/save/preview'+getArtefactUrl(artefactTriplet)+'/'+lang;};var getDerivedCodelistRestoreDbUrl=function getDerivedCodelistRestoreDbUrl(artefactTriplet){return'NOSQL/previewEmpty'+getArtefactUrl(artefactTriplet);};var getDerivedCodelistIsSourceItemValidUrl=function getDerivedCodelistIsSourceItemValidUrl(artefactTriplet,lang){return'NOSQL/previewIsValid'+getArtefactUrl(artefactTriplet)+'/'+lang;};var getSetDefaultOrderUrl=function getSetDefaultOrderUrl(artefactTriplet,lang){return'NOSQL/copyorder'+getArtefactUrl(artefactTriplet)+'/'+lang;};var getUpdateMsdUrl=function getUpdateMsdUrl(){return"msd";};var getUpdateHierarchicalCodelistUrl=function getUpdateHierarchicalCodelistUrl(){return"updateHierarchicalCodelist";};var getSeriesForCubeUrl=function getSeriesForCubeUrl(cubeId){return'/SeriesForCube/'+cubeId;};var getDeleteSeriesForCubeUrl=function getDeleteSeriesForCubeUrl(cubeId){return'RemoveSeriesForCube/'+cubeId;};/* UTILITY */var getUploadFileOnServerUrl=function getUploadFileOnServerUrl(cubeId){return'uploadFileOnServer'+(cubeId?'/'+cubeId:'');};var getUploadFileOnServerAbsoluteUrl=function getUploadFileOnServerAbsoluteUrl(getAbsolutePath){return'uploadFileOnServer?getAbsolutePath='+(getAbsolutePath?getAbsolutePath:false);};var getCsvHeaderUrl=function getCsvHeaderUrl(separator,delimiter,hasHeader,filePath){return'getCSVHeader/'+encodeURIComponent(separator)+'/'+hasHeader+(delimiter!==null?'/'+encodeURIComponent(delimiter):'')+'?filePath='+encodeURIComponent(filePath);};var getCsvTablePreviewUrl=function getCsvTablePreviewUrl(separator,delimiter,hasHeader,filePath,tid,idMappingSpecialTimePeriod){return'getCSVTablePreview/'+encodeURIComponent(separator)+'/'+hasHeader+(delimiter!==null?'/'+encodeURIComponent(delimiter):'')+'?filePath='+encodeURIComponent(filePath)+(tid!==null?'&tid='+encodeURIComponent(tid):'')+(idMappingSpecialTimePeriod!==null?'&idMappingSpecialTimePeriod='+encodeURIComponent(idMappingSpecialTimePeriod):'');};var getCsvTableColumnPreviewUrl=function getCsvTableColumnPreviewUrl(separator,delimiter,hasHeader,filePath){return'getCSVTableColumnPreview/'+encodeURIComponent(separator)+'/'+hasHeader+(delimiter!==null?'/'+encodeURIComponent(delimiter):'')+'?filePath='+encodeURIComponent(filePath);};var getPreloadCsvUrl=function getPreloadCsvUrl(separator,delimiter,hasHeader,filePath,tid){return'preloadCSV/'+encodeURIComponent(separator)+'/'+hasHeader+(delimiter!==null?'/'+encodeURIComponent(delimiter):'')+'?filePath='+encodeURIComponent(filePath)+(tid!==null?'&tid='+encodeURIComponent(tid):'');};var getStagingAreaTablesUrl=function getStagingAreaTablesUrl(){return"getStagingAreaTables";};var getFileFromStagingAreaTableUrl=function getFileFromStagingAreaTableUrl(tableName,csvSeparator){return'getFileFromStagingAreaTable/'+tableName+'/'+encodeURIComponent(csvSeparator)+'/true';};var getImportCsvUrl=function getImportCsvUrl(separator,delimiter,hasHeader,importType,cubeId,mappingId,filePath,tid,idMappingSpecialTimePeriod,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return'importCSVData/'+encodeURIComponent(separator)+'/'+hasHeader+'/'+importType+'/'+cubeId+'/'+mappingId+(delimiter!==null?'/'+encodeURIComponent(delimiter):'')+('?filePath='+encodeURIComponent(filePath))+(tid!=null?'&tid='+encodeURIComponent(tid):'')+(idMappingSpecialTimePeriod!==null?'&idMappingSpecialTimePeriod='+encodeURIComponent(idMappingSpecialTimePeriod):'')+(embargo===true?'&embargo=true':'')+(refreshProdDf===true?'&refreshProdDf=true':'')+(checkFiltAttributes===true?'&checkFiltAttributes=true':'')+(ignoreConcurrentUpload===true?'&ignoreCuncurrentUpload=true':'');};var getAttributeFileUrl=function getAttributeFileUrl(separator,delimiter,hasHeader,cubeId,filePath,tid,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return'importAttributeFile/'+encodeURIComponent(separator)+'/'+hasHeader+'/'+cubeId+(delimiter!==null?'/'+encodeURIComponent(delimiter):'')+('?filePath='+encodeURIComponent(filePath))+(tid!=null?'&tid='+encodeURIComponent(tid):'')+(refreshProdDf===true?'&refreshProdDf=true':'')+(checkFiltAttributes===true?'&checkFiltAttributes=true':'')+(ignoreConcurrentUpload===true?'&ignoreCuncurrentUpload=true':'');};var getTablePreviewUrl=function getTablePreviewUrl(tableName){return'getTablePreview/'+encodeURIComponent(tableName);};var getSdmxMlTablePreviewUrl=function getSdmxMlTablePreviewUrl(dsdId,dsdAgencyId,dsdVersion,filePath){return'getSDMXMLTablePreview/'+dsdId+'/'+dsdAgencyId+'/'+dsdVersion+'?filePath='+encodeURIComponent(filePath);};var getImportSdmxMlUrl=function getImportSdmxMlUrl(importType,cubeId,dsdId,dsdAgencyId,dsdVersion,filePath,tid,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return'importSDMXMLData/'+importType+'/'+cubeId+'/'+dsdId+'/'+dsdAgencyId+'/'+dsdVersion+('?filePath='+encodeURIComponent(filePath))+(tid!==null?'&tid='+tid:'')+(embargo===true?'&embargo=true':'')+(refreshProdDf===true?'&refreshProdDf=true':'')+(checkFiltAttributes===true?'&checkFiltAttributes=true':'')+(ignoreConcurrentUpload===true?'&ignoreCuncurrentUpload=true':'');};var getImportDCSUrl=function getImportDCSUrl(id,agencyId,version){return'importDCS/'+id+'/'+agencyId+'/'+version;};var getDataflowPreviewUrl=function getDataflowPreviewUrl(checkFilter){return'getDDBDataflowPreview/'+(checkFilter?"true":"");};var getDataflowColumnPreviewUrl=function getDataflowColumnPreviewUrl(colName,pageNum,pageSize){return'getDataflowColumnPreview/'+colName+'/'+pageNum+'/'+pageSize;};var getDataflowCsvUrl=function getDataflowCsvUrl(separator,delimiter,compression){return'getDDBDataflowCsv/'+compression+'?separator='+encodeURIComponent(separator)+(delimiter?'&delimiter='+encodeURIComponent(delimiter):'');};var getDownloadArtefactUrl=function getDownloadArtefactUrl(artefactType,artefactTriplet,format,references,compression,lang,separator,delimiter){return'downloadMetadati/'+artefactType+getArtefactUrl(artefactTriplet)+'/'+format+'/'+references+'/'+compression+'/'+lang+(''+(separator?'/'+separator:'')+(delimiter?'/'+delimiter:''));};var getMultipleDownloadArtefactUrl=function getMultipleDownloadArtefactUrl(artefactType,format,references,compression,lang){return'downloadMetadati/'+artefactType+'/'+format+'/'+references+'/'+compression+'/'+lang;};var getDownloadDdbdataflowUrl=function getDownloadDdbdataflowUrl(format,compression,separator,delimiter,dimension){return'/downloadDataflow/'+format+'/'+compression+(separator?'/'+separator:'')+(delimiter?'/'+delimiter:'')+(dimension?'?observation='+dimension:'');};var getExportArtefactUrl=function getExportArtefactUrl(){return"DuplicateArtefact";};var getCheckImportedFileXmlSdmxObjectsUrl=function getCheckImportedFileXmlSdmxObjectsUrl(){return'checkImportedFileXmlSdmxObjects';};var getImportFileXmlSdmxObjectsUrl=function getImportFileXmlSdmxObjectsUrl(){return'importFileXmlSdmxObjects';};var getCreateDataflowMappingSetUrl=function getCreateDataflowMappingSetUrl(ddbDataflowId,defaultValue){return'CreateMappingSetForDataflow/'+ddbDataflowId+(defaultValue?'/'+encodeURIComponent(defaultValue):'');};var getRemoveDataflowMappingSetUrl=function getRemoveDataflowMappingSetUrl(ddbDataflowId){return'RemoveMappingSetForDataflow/'+ddbDataflowId;};var getCreateDataflowTranscodingUrl=function getCreateDataflowTranscodingUrl(ddbDataflowId){return'CreateTranscodingsForDataflow/'+ddbDataflowId;};var getCreateDataflowTranscodingFromCCUrl=function getCreateDataflowTranscodingFromCCUrl(ddbDataflowId,contentConstraintTriplet){return'CreateTranscodingsFromCCForDataflow/'+ddbDataflowId+'/'+contentConstraintTriplet.agencyID+'/'+contentConstraintTriplet.id+'/'+contentConstraintTriplet.version;};var getRemoveDataflowTranscodingUrl=function getRemoveDataflowTranscodingUrl(ddbDataflowId){return'RemoveTranscodingsForDataflow/'+ddbDataflowId;};var getCreateDataflowContentConstraintUrl=function getCreateDataflowContentConstraintUrl(ddbDataflowId){return'CreateContentConstraintsForDataflow/'+ddbDataflowId;};var getRemoveDataflowContentConstraintUrl=function getRemoveDataflowContentConstraintUrl(ddbDataflowId){return'RemoveContentConstraintsForDataflow/'+ddbDataflowId;};var getSetDataflowProductionFlagUrl=function getSetDataflowProductionFlagUrl(ddbDataflowId,isProduction){return'SetDataflowProductionFlag/'+ddbDataflowId+'/'+isProduction;};var getMappingSetIdUrl=function getMappingSetIdUrl(ddbDataflowId){return'GetMappingSetIdForDDBDataflow/'+ddbDataflowId;};var getCheckImportedFileCsvItemUrl=function getCheckImportedFileCsvItemUrl(){return'checkImportedFileCsvItem';};var getImportFileCsvItemUrl=function getImportFileCsvItemUrl(){return'importFileCsvItem';};var getShyncCodelistsUrl=function getShyncCodelistsUrl(){return'syncCodelist';};var getAllCodelistToBeSynchronizedUrl=function getAllCodelistToBeSynchronizedUrl(){return'getAllCodelistToBeSynchronized';};var getDsdWithDataflowUrl=function getDsdWithDataflowUrl(){return'getDSDWithDataflow';};var getAllUpgradableDsdUrl=function getAllUpgradableDsdUrl(dsdTriplet){return'getAllUpgradableDSD'+getArtefactUrl(dsdTriplet);};var getUpgradeDsdUrl=function getUpgradeDsdUrl(){return'upgradeDSD';};var getGenerateReportDsdUrl=function getGenerateReportDsdUrl(sourceDsdTriplet,targetDsdTriplet,checkIfIsUpgradable){return'generateReportDSD'+getArtefactUrl(sourceDsdTriplet)+getArtefactUrl(targetDsdTriplet)+(checkIfIsUpgradable?'/true':'/false');};var getCompareDsdsUrl=function getCompareDsdsUrl(callCompare){return'compareDSD/'+(callCompare?"true":"false");};var getGenerateFileReportDsdUrl=function getGenerateFileReportDsdUrl(lang){return'generateFileReportDSD/'+lang;};var getCompareCodelistUrl=function getCompareCodelistUrl(sourceCodelistTriplet,targetCodelistTriplet,sourceDsdFile,targetDsdFile){return(sourceDsdFile||targetDsdFile?"CompareCodelistMix":"CompareCodelist")+getArtefactUrl(sourceCodelistTriplet)+getArtefactUrl(targetCodelistTriplet)+(sourceDsdFile||targetDsdFile?'?sourceFile='+encodeURIComponent(sourceDsdFile||"NULL")+'&targetFile='+encodeURIComponent(targetDsdFile||"NULL"):"");};var getCompareItemsUrl=function getCompareItemsUrl(artefactType,sourceTriplet,targetTriplet){return'compareItem/'+artefactType+('?first='+(sourceTriplet?encodeURIComponent(sourceTriplet.id+'+'+sourceTriplet.agencyID+'+'+sourceTriplet.version):''))+('&second='+(targetTriplet?encodeURIComponent(targetTriplet.id+'+'+targetTriplet.agencyID+'+'+targetTriplet.version):''));};var getCompareItemsForFileUrl=function getCompareItemsForFileUrl(artefactType,lang,sourceTriplet,targetTriplet){return'compareItemForFile/'+artefactType+'/'+lang+('?first='+(sourceTriplet?encodeURIComponent(sourceTriplet.id+'+'+sourceTriplet.agencyID+'+'+sourceTriplet.version):''))+('&second='+(targetTriplet?encodeURIComponent(targetTriplet.id+'+'+targetTriplet.agencyID+'+'+targetTriplet.version):''));};var getMergeArtefactsUrl=function getMergeArtefactsUrl(artefactType,sourceTriplet,targetTriplet){return'mergeArtefact/'+artefactType+('?first='+(sourceTriplet?encodeURIComponent(sourceTriplet.id+'+'+sourceTriplet.agencyID+'+'+sourceTriplet.version):''))+('&second='+(targetTriplet?encodeURIComponent(targetTriplet.id+'+'+targetTriplet.agencyID+'+'+targetTriplet.version):''));};var getMergeCodelistsUrl=function getMergeCodelistsUrl(sourceTriplet,targetTriplet){return'mergeCodelist/codelist'+('?first='+(sourceTriplet?encodeURIComponent(sourceTriplet.id+'+'+sourceTriplet.agencyID+'+'+sourceTriplet.version):''))+('&second='+(targetTriplet?encodeURIComponent(targetTriplet.id+'+'+targetTriplet.agencyID+'+'+targetTriplet.version):''));};var getMergedCodelistPageUrl=function getMergedCodelistPageUrl(){return"NOSQL/searchmerge/codelist";};var getSaveMergedCodelistUrl=function getSaveMergedCodelistUrl(lang){return'saveMergeCodelist/'+lang;};var getXmlArtefactPreviewUrl=function getXmlArtefactPreviewUrl(artefactType){return'previewArtefact/'+artefactType;};var getXmlCodelistPreviewUrl=function getXmlCodelistPreviewUrl(lang){return'previewCodelist/'+lang;};var getUploadRMFileOnServerUrl=function getUploadRMFileOnServerUrl(){return'uploadReferenceMetadataFileOnServer';};var getDownloadRMFileOnServerUrl=function getDownloadRMFileOnServerUrl(fileName){return'referenceMetadataFileOnServer?filename='+encodeURIComponent(fileName);};var getCreateDCSCategoryUrl=function getCreateDCSCategoryUrl(){return"InsertDCS";};var getEditDCSCategoryUrl=function getEditDCSCategoryUrl(){return"UpdateDCS";};var getDeleteDCSCategoryUrl=function getDeleteDCSCategoryUrl(catCode){return'DeleteDCS/'+catCode;};var getCloneMsdUrl=function getCloneMsdUrl(srcTriplet,destTriplet){return'msd/clone'+getArtefactUrl(srcTriplet)+getArtefactUrl(destTriplet);};var getCloneHclUrl=function getCloneHclUrl(srcTriplet,destTriplet){return'hcl/clone'+getArtefactUrl(srcTriplet)+getArtefactUrl(destTriplet);};var getConvertPxToCsvUrl=function getConvertPxToCsvUrl(fileServerPath,cubeId){return'ConvertPCAxisToCsv/?pcAxisFilePath='+encodeURIComponent(fileServerPath)+'&idCube='+cubeId;};var getConvertXlsToCsv=function getConvertXlsToCsv(xlsServerPath,xmlServerPath,cubeId){return'ConvertExcelToCsv'+('?excelFilePath='+encodeURIComponent(xlsServerPath))+('&mappFilePath='+encodeURIComponent(xmlServerPath))+('&idCube='+cubeId);};var getImportDSDFromDataflowUrl=function getImportDSDFromDataflowUrl(nodeId,sdcDataflowTriplet){return'ImportDSDFromDataflow/'+nodeId+getArtefactUrl(sdcDataflowTriplet);};var getEasyLoadDataFromSdmxUrl=function getEasyLoadDataFromSdmxUrl(nodeId,srcDataflowTriplet,dstDataflowTriplet,categoryId,publishDf,transcodeDf){return'EasyLoadDataFromSdmx/'+nodeId+getArtefactUrl(srcDataflowTriplet)+getArtefactUrl(dstDataflowTriplet)+'/'+categoryId+'/'+publishDf+'/'+transcodeDf;};var getEasyLoadDataFromFileUrl=function getEasyLoadDataFromFileUrl(filePath,separator,delimiter,hasHeader,DsId,DsAg,DsVs,Category,mappFilePath,publishDf,executeTrans){return'EasyLoadDataFromFile/'+encodeURIComponent(separator)+'/'+hasHeader+'/'+DsId+'/'+DsAg+'/'+DsVs+'/'+Category+'/'+publishDf+'/'+executeTrans+'?filePath='+encodeURIComponent(filePath)+(mappFilePath!==null?'&mappFilePath='+encodeURIComponent(mappFilePath):'')+(delimiter!==null?'&delimiter='+encodeURIComponent(delimiter):'');};var getEasyLoadDataFromDbUrl=function getEasyLoadDataFromDbUrl(tableName,DsId,DsAg,DsVs,Category,publishDf,executeTrans){return'/EasyLoadDataFromDb/'+tableName+'/'+DsId+'/'+DsAg+'/'+DsVs+'/'+Category+'/'+publishDf+'/'+executeTrans;};var getEasyUpdateDataFromSdmxUrl=function getEasyUpdateDataFromSdmxUrl(nodeId,srcDataflowTriplet,dstDDBDataflowId,transcodeDf){return'EasyUpdateDataFromSdmx/'+nodeId+getArtefactUrl(srcDataflowTriplet)+'/'+dstDDBDataflowId+'/'+transcodeDf;};var getEasyUpdateDataFromFileUrl=function getEasyUpdateDataFromFileUrl(filePath,separator,delimiter,hasHeader,DsId,mappId,mappFilePath,transcodeDf){return'EasyUpdateDataFromFile/'+encodeURIComponent(separator)+'/'+hasHeader+'/'+DsId+'/'+mappId+'/'+transcodeDf+'?filePath='+encodeURIComponent(filePath)+(mappFilePath!==null?'&mappFilePath='+encodeURIComponent(mappFilePath):'')+(delimiter!==null?'&delimiter='+encodeURIComponent(delimiter):'');};var getEasyUpdateDataFromDbUrl=function getEasyUpdateDataFromDbUrl(tableName,DsId,mappId,transcodeDf){return'EasyUpdateDataFromDb/'+tableName+'/'+DsId+'/'+mappId+'/'+transcodeDf;};var getPartialCodelistUrl=function getPartialCodelistUrl(dataflowTriplet,dimensionId,pageNum,pageSize){return'PartialCodelist'+getArtefactUrl(dataflowTriplet)+'/'+pageNum+'/'+pageSize+'?dimId='+dimensionId;};var getDataUploadStatusUrl=function getDataUploadStatusUrl(dataflowTriplet){return'GetDataUploadStatus'+getArtefactUrl(dataflowTriplet);};var CONFIG_TYPE_APP='app';var CONFIG_TYPE_NODES='nodes';var getConfigUrl=function getConfigUrl(configType){return'configuration/'+configType;};var getAppConfigUrl=function getAppConfigUrl(){return'appConfig';};var getNodePingUrl=function getNodePingUrl(){return'ping';};var getSaveConfigNodeUrl=function getSaveConfigNodeUrl(username,password){return'Config/SaveNode/'+username+(password?'/'+encodeURIComponent(password):'');};var getDeleteConfigNodeUrl=function getDeleteConfigNodeUrl(nodeId){return'/Config/DeleteNode/'+nodeId;};var getSortNodesUrl=function getSortNodesUrl(){return'Config/SortConfiguration';};var getCheckEndpointNSIUrl=function getCheckEndpointNSIUrl(){return"Config/CheckEndPointNSI";};var getCheckEndpointMAUrl=function getCheckEndpointMAUrl(){return"Config/CheckEndPointMA";};var getCheckEndpointDMUrl=function getCheckEndpointDMUrl(){return"Config/CheckEndPointDM";};var getCheckAgencyAssignedToAnyUserUrl=function getCheckAgencyAssignedToAnyUserUrl(agencyCode,nodeCode){return'IsAgencyAssignToAnyUser/'+agencyCode+'/'+nodeCode;};var getSaveConfigNodeProviderUrl=function getSaveConfigNodeProviderUrl(providerName){return'Config/SaveNodeWithProvider/'+providerName;};/* AUTHENTICATION */var getLoginUrl=function getLoginUrl(){return'api/Security/Authenticate';};var getLogoutUrl=function getLogoutUrl(){return'api/Security/Logout';};var getSuperUserLoginUrl=function getSuperUserLoginUrl(){return'/api/Security/LoginSuperUser';};var getSuperUserLogoutUrl=function getSuperUserLogoutUrl(){return'/api/Security/LogoutSuperUser';};var getRecoverPasswordUrl=function getRecoverPasswordUrl(){return'/api/Security/RecoveryPassword';};var getUpdateUserUrl=function getUpdateUserUrl(){return'/Config/UpdateUser';};var getProviderLoginUrl=function getProviderLoginUrl(provider){return'/api/Security/AuthenticateProvider/'+provider;};/* PERMISSIONS */var getUsers=function getUsers(){return'GetUsers';};var getReadPermissionsUrl=function getReadPermissionsUrl(username){return'GetData'+(username?'/'+encodeURIComponent(username):'');};var getAllAgenciesUrl=function getAllAgenciesUrl(){return'GetAllAgency';};var getAllFunctionalitiesUrl=function getAllFunctionalitiesUrl(){return'GetFunctionalityHierarchy';};var getAllRulesUrl=function getAllRulesUrl(){return'GetAllRules';};var getSubmitPermissionsUrl=function getSubmitPermissionsUrl(){return'AssignsAll';};var getSynchronizeAuthDBUrl=function getSynchronizeAuthDBUrl(){return'SynchronizeAuthDB';};var getCreateUserUrl=function getCreateUserUrl(){return'/Config/CreateUser';};var getDeleteUserUrl=function getDeleteUserUrl(username){return'Config/DeleteUser/'+username;};var getCubeOwnersUrl=function getCubeOwnersUrl(cubeId){return'GetOwners/Cube?id='+encodeURIComponent(cubeId);};var getDataflowOwnersUrl=function getDataflowOwnersUrl(dataflowTripletStr){return'GetOwners/Dataflow?id='+encodeURIComponent(dataflowTripletStr);};var getMetadataflowOwnersUrl=function getMetadataflowOwnersUrl(metadataflowTripletStr){return'GetOwners/MetadataFlow?id='+encodeURIComponent(metadataflowTripletStr);};var getSetOwnersUrl=function getSetOwnersUrl(){return"SetOwners";};/* UTILS */var getRemoveTempTablesUrl=function getRemoveTempTablesUrl(){return'Utils/RemoveTempTable';};var getDisembargoCubeUrl=function getDisembargoCubeUrl(cubeId){return'DisembargoCube/'+cubeId;};var getEmptyCubeUrl=function getEmptyCubeUrl(cubeId){return'EmptyCube/'+cubeId;};var getDdbResetUrl=function getDdbResetUrl(){return"DDBReset";};var getAddAgencyToConfigUrl=function getAddAgencyToConfigUrl(nodeId){return'AddAgencyToConfig/'+nodeId;};/* DATA BROWSER */var getDataBrowserClearAllCacheUrl=function getDataBrowserClearAllCacheUrl(){return"DataBrowserGenerateCatalogCache";};var getDataBrowserClearCacheUrl=function getDataBrowserClearCacheUrl(id,agencyId,version){return'DataBrowserClearItemCache/'+id+'/'+agencyId+'/'+version;};/* Easy loading */var getCreateCodelistUrl=function getCreateCodelistUrl(dfId,tableName,inStagingDb){return'CreateCustomCodelistsForASTDataflow/'+dfId+'/'+tableName+'/'+inStagingDb;};

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DataLanguageContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DataLanguageProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataLanguageConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return withDataLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DataLanguageContext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);var DataLanguageProvider=DataLanguageContext.Provider;var DataLanguageConsumer=DataLanguageContext.Consumer;var withDataLanguage=function withDataLanguage(){return function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DataLanguageConsumer,null,function(dataLanguage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},props,{dataLanguage:dataLanguage}));});};};};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reuseAction;
/* harmony export (immutable) */ __webpack_exports__["c"] = reuseReducer;
/* harmony export (immutable) */ __webpack_exports__["b"] = reuseInReducer;
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// allows reusability of an action
// by adding a prefix
// params:
// - action: the action to reuse
// - prefix: the prefix to add
// returns:
// the new action with prefix
function reuseAction(action,prefix){return Object.assign({},action,_defineProperty({},action.label?"label":"type",prefix+(action.label||action.type)));}// allows reusability of a reducer
// by making it responding to the same actions but with a prefix
// params:
//    - reducer: the reducer to reuse
//    - prefix: the prefix of actions
// returns:
//    the reducer responding to the same actions but with a prefix
function reuseReducer(reducer,prefix){return function(state,action){if(state===undefined){// initialization (dispatched by redux): action must be untouched
return reducer(state,action);}else if((action.label||action.type).startsWith(prefix)){// must be managed by this reducer
return reducer(state,Object.assign({},action,{// remove prefix
label:action.label?action.label.substr(prefix.length):undefined,type:!action.label&&action.type?action.type.substr(prefix.length):action.type}));}else{// must be managed by some other reducer
return state;}};}// allows a reducer to host some reusable reducers
// by nesting in the host reducer the states of the reusable reducers
// params:
//    - hostReducer: the reducer that will host other reducers
//    - hostedReducersObj: an object containing the reducers to be host
//    e.g. {hosted1: hostedReducer1, hosted2: hostedReducer2}
// returns:
//    the reducer created by extending the host reducer
function reuseInReducer(hostReducer,hostedReducersObj){return function(state,action){// we have to produce an object containing a property for each new state of hosted reducers
var hostedReducersState={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(hostedReducersObj)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var reducerKey=_step.value;hostedReducersState[reducerKey]=// create the property containing the new state of a hosted reducer...
hostedReducersObj[reducerKey](state?state[reducerKey]:undefined,action);// ...by calling the hosted reducer
}// state returned by host reducer
}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return Object.assign({},hostReducer(state,action),hostedReducersState);};}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(690);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNCATEGORIZED_CATEGORY_CODE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getCategoriesOrderedTree;
/* unused harmony export getCategoriesCustomOrderedTree */
/* harmony export (immutable) */ __webpack_exports__["d"] = getCategorisedObjectsTree;
/* harmony export (immutable) */ __webpack_exports__["k"] = getNode;
/* harmony export (immutable) */ __webpack_exports__["l"] = getNodes;
/* harmony export (immutable) */ __webpack_exports__["b"] = countNodes;
/* harmony export (immutable) */ __webpack_exports__["f"] = getFilteredTree;
/* harmony export (immutable) */ __webpack_exports__["g"] = getFilteredTreeWithPaths;
/* harmony export (immutable) */ __webpack_exports__["h"] = getMappedTree;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMappedTreeDeptFirst;
/* harmony export (immutable) */ __webpack_exports__["e"] = getDeadEndNodes;
/* harmony export (immutable) */ __webpack_exports__["o"] = testAnchestor;
/* harmony export (immutable) */ __webpack_exports__["n"] = getTreeFromArray;
/* harmony export (immutable) */ __webpack_exports__["j"] = getMaxTreeDepth;
/* harmony export (immutable) */ __webpack_exports__["m"] = getNodesAtDepth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var UNCATEGORIZED_CATEGORY_CODE='UNCATEGORIZED';function getCategoriesOrderedTree(categories,childrenKey,testIsChildOf,compare){categories=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(categories);var recursivelyPushOrderedChildCategories=function recursivelyPushOrderedChildCategories(category){if(category!==null){var _category$childrenKey;category[childrenKey]=[];(_category$childrenKey=category[childrenKey]).push.apply(_category$childrenKey,_toConsumableArray(categories.filter(function(cat){return testIsChildOf(cat,category);}).sort(compare)));category[childrenKey].map(recursivelyPushOrderedChildCategories);}return category;};return[].concat(_toConsumableArray(categories.filter(function(cat){return!testIsChildOf(cat);}).sort(compare))).map(recursivelyPushOrderedChildCategories);}function getCategoriesCustomOrderedTree(categories,childrenKey,testIsChildOf,getOrderedChildrens){categories=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(categories);var recursivelyPushOrderedChildCategories=function recursivelyPushOrderedChildCategories(category){if(category!==null){var _category$childrenKey2;category[childrenKey]=[];(_category$childrenKey2=category[childrenKey]).push.apply(_category$childrenKey2,_toConsumableArray(getOrderedChildrens(categories.filter(function(cat){return testIsChildOf(cat,category);}))));category[childrenKey].map(recursivelyPushOrderedChildCategories);}return category;};return getOrderedChildrens(categories.filter(function(cat){return!testIsChildOf(cat);})).map(recursivelyPushOrderedChildCategories);}function getCategorisedObjectsTree(objects,categoryTree,categoryTreeChildrenKey,objectsCompare,testObjectCategory,categoryCodeKey,categoryNameKey,discardUncategorised,objectsFirst){objects=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(objects);categoryTree=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(categoryTree);var recursivelyPushOrderedChildArtefacts=function recursivelyPushOrderedChildArtefacts(category){if(category){if(category[categoryTreeChildrenKey]){// first this (to avoid recursion on objects)
category[categoryTreeChildrenKey].map(recursivelyPushOrderedChildArtefacts);}else{category[categoryTreeChildrenKey]=[];}var filteredAndSortedObjects=objects.filter(function(object){return testObjectCategory(object,category);}).sort(function(a,b){return objectsCompare(a,b,category);});if(objectsFirst===true){var _category$categoryTre;(_category$categoryTre=category[categoryTreeChildrenKey]).unshift.apply(_category$categoryTre,_toConsumableArray(filteredAndSortedObjects));}else{var _category$categoryTre2;(_category$categoryTre2=category[categoryTreeChildrenKey]).push.apply(_category$categoryTre2,_toConsumableArray(filteredAndSortedObjects));}}return category;};var res=categoryTree.map(recursivelyPushOrderedChildArtefacts);var uncategorisedObjects=objects.filter(function(object){return!testObjectCategory(object);}).sort(objectsCompare);if(uncategorisedObjects.length&&discardUncategorised!==true){var _res$push;res.push((_res$push={},_defineProperty(_res$push,categoryCodeKey,UNCATEGORIZED_CATEGORY_CODE),_defineProperty(_res$push,categoryNameKey,{en:'Uncategorized',it:'Senza categoria'}),_defineProperty(_res$push,categoryTreeChildrenKey,uncategorisedObjects),_res$push));}return res;}function getNode(tree,childrenKey,test){if(!(tree!==null&&tree.length))return null;var foundNodes=tree.filter(test);if(foundNodes.length){return foundNodes[0];}else{var foundNodesInChild=tree.filter(function(node){return node[childrenKey];}).map(function(node){return getNode(node[childrenKey],childrenKey,test);}).filter(function(result){return result!==null;});if(foundNodesInChild.length){return foundNodesInChild[0];}else{return null;}}}function getNodes(tree,childrenKey,test){var res=[];var recursive=function recursive(subTree){return subTree?subTree.map(function(node){if(test&&test(node)){res.push(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(node));}if(node[childrenKey]&&node[childrenKey].length){recursive(node[childrenKey]);}return null;}):[];};recursive(tree);return res;}function countNodes(tree,childrenKey,test){var res=0;var recursive=function recursive(subTree){return subTree?subTree.map(function(node){if(test&&test(node)){res++;}if(node[childrenKey]&&node[childrenKey].length){recursive(node[childrenKey]);}return null;}):[];};recursive(tree);return res;}function getFilteredTree(tree,childrenKey,test){tree=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(tree);tree=tree.filter(test);tree=tree.map(function(subTree){if(subTree[childrenKey]){subTree[childrenKey]=getFilteredTree(subTree[childrenKey],childrenKey,test);}return subTree;});return tree;}function getFilteredTreeWithPaths(tree,childrenKey,test){tree=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(tree);tree=tree.map(function(subTree){if(subTree[childrenKey]){subTree[childrenKey]=getFilteredTreeWithPaths(subTree[childrenKey],childrenKey,test);}return subTree;});tree=tree.filter(function(node){return node[childrenKey]&&node[childrenKey].length||test(node);});return tree;}function getMappedTree(tree,childrenKey,map){tree=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(tree);tree=tree.map(function(root){return map(root);});tree=tree.map(function(subTree){if(subTree[childrenKey]){subTree[childrenKey]=getMappedTree(subTree[childrenKey],childrenKey,map);}return subTree;});return tree;}function getMappedTreeDeptFirst(tree,childrenKey,map){tree=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(tree);tree=tree.map(function(node){var visitedNode=map(node);if(visitedNode[childrenKey]){visitedNode[childrenKey]=getMappedTreeDeptFirst(visitedNode[childrenKey],childrenKey,map);}return visitedNode;});return tree;}function getDeadEndNodes(categoryTree,categoryTreeChildrenKey){categoryTree=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(categoryTree);var res=[];var recursivelyMarkNoChildrenCategory=function recursivelyMarkNoChildrenCategory(category){if(category){if(category[categoryTreeChildrenKey]){category[categoryTreeChildrenKey].map(recursivelyMarkNoChildrenCategory);if(category[categoryTreeChildrenKey].length===0||childChecker(category)){category.isDeadEnd=true;res.push(category);}}}return category;};var childChecker=function childChecker(category){var result=true;category[categoryTreeChildrenKey].forEach(function(child){if(!(child[categoryTreeChildrenKey]&&child.isDeadEnd)){result=false;}});return result;};if(categoryTree){categoryTree.map(recursivelyMarkNoChildrenCategory);}return res;}function testAnchestor(node,anchestor,tree,childrenKey){if(node.parent===undefined||node.parent===null){return false;}else if(node.id===anchestor.id||node.parent===anchestor.id){return true;}else{return testAnchestor(getNode(tree,childrenKey,function(n){return n.id===node.parent;}),anchestor,tree,childrenKey);}}function getTreeFromArray(arr,childrenKey){var fixMissingHierarchy=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var mappedArr={};var tree=[];// first map the nodes of the array to an object -> create a hash table.
arr.forEach(function(el){el[childrenKey]=[];mappedArr[el.id]=el;});arr.forEach(function(el){if(el.parent&&!mappedArr[el.parent]&&fixMissingHierarchy){el.parent=undefined;}if(el.parent){// if the element is not at the root level, add it to its parent array of children.
mappedArr[el.parent][childrenKey].push(el);}else{// if the element is at the root level, add it to first level elements array.
tree.push(el);}});return tree;}function getMaxTreeDepth(tree,childrenKey){var recursive=function recursive(node){return node?1+Math.max.apply(Math,_toConsumableArray((node[childrenKey]||[]).map(recursive)).concat([0])):0;};return tree?Math.max.apply(Math,_toConsumableArray(tree.map(recursive)).concat([0])):0;}function getNodesAtDepth(tree,childrenKey,depth){var res=[];var recursive=function recursive(subTree,currDepth){return subTree?subTree.map(function(node){if(depth===currDepth){res.push(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(node));}if(node[childrenKey]&&node[childrenKey].length){recursive(node[childrenKey],currDepth+1);}return null;}):[];};recursive(tree,1);return res;}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(733);

__webpack_require__(70);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _addEventListener = _interopRequireDefault(__webpack_require__(289));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _Grid = _interopRequireDefault(__webpack_require__(737));

var _Meta = _interopRequireDefault(__webpack_require__(738));

var _tabs = _interopRequireDefault(__webpack_require__(71));

var _row = _interopRequireDefault(__webpack_require__(11));

var _col = _interopRequireDefault(__webpack_require__(13));

var _configProvider = __webpack_require__(35);

var _throttleByAnimationFrame = __webpack_require__(864);

var _warning = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Card =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Card, _React$Component);

  function Card() {
    var _this;

    _classCallCheck(this, Card);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Card).apply(this, arguments));
    _this.state = {
      widerPadding: false
    };
    _this.updateWiderPaddingCalled = false;

    _this.onTabChange = function (key) {
      if (_this.props.onTabChange) {
        _this.props.onTabChange(key);
      }
    };

    _this.saveRef = function (node) {
      _this.container = node;
    };

    _this.renderCard = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          extra = _a.extra,
          _a$headStyle = _a.headStyle,
          headStyle = _a$headStyle === void 0 ? {} : _a$headStyle,
          _a$bodyStyle = _a.bodyStyle,
          bodyStyle = _a$bodyStyle === void 0 ? {} : _a$bodyStyle,
          noHovering = _a.noHovering,
          hoverable = _a.hoverable,
          title = _a.title,
          loading = _a.loading,
          _a$bordered = _a.bordered,
          bordered = _a$bordered === void 0 ? true : _a$bordered,
          _a$size = _a.size,
          size = _a$size === void 0 ? 'default' : _a$size,
          type = _a.type,
          cover = _a.cover,
          actions = _a.actions,
          tabList = _a.tabList,
          children = _a.children,
          activeTabKey = _a.activeTabKey,
          defaultActiveTabKey = _a.defaultActiveTabKey,
          others = __rest(_a, ["prefixCls", "className", "extra", "headStyle", "bodyStyle", "noHovering", "hoverable", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey"]);

      var prefixCls = getPrefixCls('card', customizePrefixCls);
      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-hoverable"), _this.getCompatibleHoverable()), _defineProperty(_classNames, "".concat(prefixCls, "-wider-padding"), _this.state.widerPadding), _defineProperty(_classNames, "".concat(prefixCls, "-padding-transition"), _this.updateWiderPaddingCalled), _defineProperty(_classNames, "".concat(prefixCls, "-contain-grid"), _this.isContainGrid()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-type-").concat(type), !!type), _classNames));
      var loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? {
        padding: 24
      } : undefined;
      var loadingBlock = React.createElement("div", {
        className: "".concat(prefixCls, "-loading-content"),
        style: loadingBlockStyle
      }, React.createElement(_row["default"], {
        gutter: 8
      }, React.createElement(_col["default"], {
        span: 22
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      }))), React.createElement(_row["default"], {
        gutter: 8
      }, React.createElement(_col["default"], {
        span: 8
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      })), React.createElement(_col["default"], {
        span: 15
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      }))), React.createElement(_row["default"], {
        gutter: 8
      }, React.createElement(_col["default"], {
        span: 6
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      })), React.createElement(_col["default"], {
        span: 18
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      }))), React.createElement(_row["default"], {
        gutter: 8
      }, React.createElement(_col["default"], {
        span: 13
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      })), React.createElement(_col["default"], {
        span: 9
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      }))), React.createElement(_row["default"], {
        gutter: 8
      }, React.createElement(_col["default"], {
        span: 4
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      })), React.createElement(_col["default"], {
        span: 3
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      })), React.createElement(_col["default"], {
        span: 16
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      }))), React.createElement(_row["default"], {
        gutter: 8
      }, React.createElement(_col["default"], {
        span: 8
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      })), React.createElement(_col["default"], {
        span: 6
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      })), React.createElement(_col["default"], {
        span: 8
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-loading-block")
      }))));
      var hasActiveTabKey = activeTabKey !== undefined;

      var extraProps = _defineProperty({}, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey);

      var head;
      var tabs = tabList && tabList.length ? React.createElement(_tabs["default"], _extends({}, extraProps, {
        className: "".concat(prefixCls, "-head-tabs"),
        size: "large",
        onChange: _this.onTabChange
      }), tabList.map(function (item) {
        return React.createElement(_tabs["default"].TabPane, {
          tab: item.tab,
          disabled: item.disabled,
          key: item.key
        });
      })) : null;

      if (title || extra || tabs) {
        head = React.createElement("div", {
          className: "".concat(prefixCls, "-head"),
          style: headStyle
        }, React.createElement("div", {
          className: "".concat(prefixCls, "-head-wrapper")
        }, title && React.createElement("div", {
          className: "".concat(prefixCls, "-head-title")
        }, title), extra && React.createElement("div", {
          className: "".concat(prefixCls, "-extra")
        }, extra)), tabs);
      }

      var coverDom = cover ? React.createElement("div", {
        className: "".concat(prefixCls, "-cover")
      }, cover) : null;
      var body = React.createElement("div", {
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
      }, loading ? loadingBlock : children);
      var actionDom = actions && actions.length ? React.createElement("ul", {
        className: "".concat(prefixCls, "-actions")
      }, _this.getAction(actions)) : null;
      var divProps = (0, _omit["default"])(others, ['onTabChange']);
      return React.createElement("div", _extends({}, divProps, {
        className: classString,
        ref: _this.saveRef
      }), head, coverDom, body, actionDom);
    };

    return _this;
  }

  _createClass(Card, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWiderPadding();
      this.resizeEvent = (0, _addEventListener["default"])(window, 'resize', this.updateWiderPadding);

      if ('noHovering' in this.props) {
        (0, _warning["default"])(!this.props.noHovering, '`noHovering` of Card is deprecated, you can remove it safely or use `hoverable` instead.');
        (0, _warning["default"])(!!this.props.noHovering, '`noHovering={false}` of Card is deprecated, use `hoverable` instead.');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeEvent) {
        this.resizeEvent.remove();
      }

      this.updateWiderPadding.cancel();
    }
  }, {
    key: "updateWiderPadding",
    value: function updateWiderPadding() {
      var _this2 = this;

      if (!this.container) {
        return;
      } // 936 is a magic card width pixel number indicated by designer


      var WIDTH_BOUNDARY_PX = 936;

      if (this.container.offsetWidth >= WIDTH_BOUNDARY_PX && !this.state.widerPadding) {
        this.setState({
          widerPadding: true
        }, function () {
          _this2.updateWiderPaddingCalled = true; // first render without css transition
        });
      }

      if (this.container.offsetWidth < WIDTH_BOUNDARY_PX && this.state.widerPadding) {
        this.setState({
          widerPadding: false
        }, function () {
          _this2.updateWiderPaddingCalled = true; // first render without css transition
        });
      }
    }
  }, {
    key: "isContainGrid",
    value: function isContainGrid() {
      var containGrid;
      React.Children.forEach(this.props.children, function (element) {
        if (element && element.type && element.type === _Grid["default"]) {
          containGrid = true;
        }
      });
      return containGrid;
    }
  }, {
    key: "getAction",
    value: function getAction(actions) {
      if (!actions || !actions.length) {
        return null;
      }

      var actionList = actions.map(function (action, index) {
        return React.createElement("li", {
          style: {
            width: "".concat(100 / actions.length, "%")
          },
          key: "action-".concat(index)
        }, React.createElement("span", null, action));
      });
      return actionList;
    } // For 2.x compatible

  }, {
    key: "getCompatibleHoverable",
    value: function getCompatibleHoverable() {
      var _this$props = this.props,
          noHovering = _this$props.noHovering,
          hoverable = _this$props.hoverable;

      if ('noHovering' in this.props) {
        return !noHovering || hoverable;
      }

      return !!hoverable;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCard);
    }
  }]);

  return Card;
}(React.Component);

exports["default"] = Card;
Card.Grid = _Grid["default"];
Card.Meta = _Meta["default"];

__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Card.prototype, "updateWiderPadding", null);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withConfigConsumer = withConfigConsumer;
exports["default"] = exports.ConfigConsumer = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createReactContext = _interopRequireDefault(__webpack_require__(171));

var _renderEmpty = _interopRequireDefault(__webpack_require__(624));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ConfigContext = (0, _createReactContext["default"])({
  // We provide a default function for Context without provider
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return "ant-".concat(suffixCls);
  },
  renderEmpty: _renderEmpty["default"]
});
var ConfigConsumer = ConfigContext.Consumer;
exports.ConfigConsumer = ConfigConsumer;

var ConfigProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConfigProvider, _React$Component);

  function ConfigProvider() {
    var _this;

    _classCallCheck(this, ConfigProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfigProvider).apply(this, arguments));

    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
      var _this$props$prefixCls = _this.props.prefixCls,
          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
      if (customizePrefixCls) return customizePrefixCls;
      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
    };

    _this.renderProvider = function (context) {
      var _this$props = _this.props,
          children = _this$props.children,
          getPopupContainer = _this$props.getPopupContainer,
          renderEmpty = _this$props.renderEmpty;

      var config = _extends({}, context, {
        getPrefixCls: _this.getPrefixCls
      });

      if (getPopupContainer) {
        config.getPopupContainer = getPopupContainer;
      }

      if (renderEmpty) {
        config.renderEmpty = renderEmpty;
      }

      return React.createElement(ConfigContext.Provider, {
        value: config
      }, children);
    };

    return _this;
  }

  _createClass(ConfigProvider, [{
    key: "render",
    value: function render() {
      return React.createElement(ConfigConsumer, null, this.renderProvider);
    }
  }]);

  return ConfigProvider;
}(React.Component);

function withConfigConsumer(config) {
  return function (Component) {
    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
    return function (props) {
      return React.createElement(ConfigConsumer, null, function (configProps) {
        var basicPrefixCls = config.prefixCls;
        var getPrefixCls = configProps.getPrefixCls;
        var customizePrefixCls = props.prefixCls;
        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
        return React.createElement(Component, _extends({}, configProps, props, {
          prefixCls: prefixCls
        }));
      });
    };
  };
}

var _default = ConfigProvider;
exports["default"] = _default;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1006);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isUpperCase */
/* harmony export (immutable) */ __webpack_exports__["c"] = isDateValid;
/* harmony export (immutable) */ __webpack_exports__["f"] = isIDValidWithHelp;
/* harmony export (immutable) */ __webpack_exports__["i"] = isVersionValidWithHelp;
/* harmony export (immutable) */ __webpack_exports__["d"] = isDictionaryValid;
/* harmony export (immutable) */ __webpack_exports__["a"] = isArtefactValid;
/* harmony export (immutable) */ __webpack_exports__["g"] = isItemValid;
/* harmony export (immutable) */ __webpack_exports__["b"] = isCloneDestTripletValid;
/* harmony export (immutable) */ __webpack_exports__["e"] = isExportDestinationValid;
/* harmony export (immutable) */ __webpack_exports__["j"] = isYearValid;
/* harmony export (immutable) */ __webpack_exports__["h"] = isStrTripletValidWithHelp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataflow__ = __webpack_require__(221);
function isUpperCase(str){return str===str.toUpperCase()&&str!==str.toLowerCase();}function isDateValid(validFrom,validTo){return!validFrom||!validTo||validFrom<=validTo;}function isIDValidWithHelp(t,id){if(/[^0-9a-z_-]/gi.test(id)){return{valid:false,help:t('validators.id.containsUnallowedChars')};}else{return{valid:true};}}function isVersionValidWithHelp(t,version){var MAX_LENGTH=10;if(!version||version.length===0){return{valid:true};}else if(version.length>10){// max length 10
return{valid:false,help:t('validators.version.exceddsMaxLength',{maxLength:MAX_LENGTH})};}else if(version.indexOf(".")<0){// must contain "."
return{valid:false,help:t('validators.version.notContainsDot')};}else if(version.substr(version.length-1)==="."){// must not end with .
return{valid:false,help:t('validators.version.endsWithDot')};}else{var arr=version.split(".");if(arr.length>3){// max version depth is x.y.z
return{valid:false,help:t('validators.version.exceddsMaxDepth')};}else if(arr.filter(function(number){return number==="0"||/^[1-9]([0-9]*)$/.test(number);}).length!==arr.length){// each x, y, z must be 0 or a number
return{valid:false,help:t('validators.version.componentIsInvalid')};}else{return{valid:true};}}}function isDictionaryValid(dictionary){return dictionary!==undefined&&dictionary!==null&&__WEBPACK_IMPORTED_MODULE_0_lodash___default()(dictionary).pickBy(function(val){return val!==undefined&&val!==null&&val.length>0;}).keys().value().length>0;}function isArtefactValid(artefact){return!(artefact===null||artefact===undefined||artefact.id===null||artefact.id===undefined||artefact.id.length===0||artefact.agencyID===null||artefact.agencyID===undefined||artefact.agencyID.length===0||artefact.version===null||artefact.version===undefined||artefact.version.length===0||artefact.dsd===null&&artefact.dataflowType===__WEBPACK_IMPORTED_MODULE_2__dataflow__["a" /* DATAFLOW_TYPE_NORMAL */]||artefact.msd===null||!isIDValidWithHelp(function(f){return f;},artefact.id).valid||!isVersionValidWithHelp(function(f){return f;},artefact.version).valid||!isDateValid(artefact.validFrom,artefact.validTo)||!isDictionaryValid(artefact.name));}function isItemValid(item){return!(item===null||item.id===null||item.id.length===0||!isIDValidWithHelp(function(f){return f;},item.id).valid||!isDictionaryValid(item.name));}function isCloneDestTripletValid(cloneDestTriplet){return!(!cloneDestTriplet||cloneDestTriplet.id===null||cloneDestTriplet.id.length===0||cloneDestTriplet.agencyID===null||cloneDestTriplet.agencyID.length===0||cloneDestTriplet.version===null||cloneDestTriplet.version.length===0||!isVersionValidWithHelp(function(f){return f;},cloneDestTriplet.version).valid);}function isExportDestinationValid(exportDestination){var ignoreUsername=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var validLoginOption=exportDestination.loginOption===__WEBPACK_IMPORTED_MODULE_1__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?ignoreUsername===true||exportDestination.username:(exportDestination.providerLoginCode||"").length>0;return exportDestination&&exportDestination.endpoint&&validLoginOption&&exportDestination.id&&exportDestination.agencyID&&exportDestination.version&&isVersionValidWithHelp(function(f){return f;},exportDestination.version).valid;}function isYearValid(year){return!year||!isNaN(year)&&Number(year)>1000&&Number(year)<9999;}function isStrTripletValidWithHelp(t,str){if((str||"").length===0){return{valid:true};}var split=str.split('+');if(split.length!==3){return{valid:false,help:t('validators.triplet.wrongNumberElements')};};var id=split[0];var agencyID=split[1];var version=split[2];var idIsValid=isIDValidWithHelp(t,id);if(!idIsValid.valid){return{valid:false,help:"id: "+idIsValid.help};}var agencyIDIsValid=isIDValidWithHelp(t,agencyID);if(!agencyIDIsValid.valid){return{valid:false,help:"agencyID: "+agencyIDIsValid.help};};var versionIsValid=isVersionValidWithHelp(t,version);if(!versionIsValid.valid){return{valid:false,help:"version: "+versionIsValid.help};};return{valid:true};}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(626);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(688);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Checkbox = _interopRequireDefault(__webpack_require__(384));

var _Group = _interopRequireDefault(__webpack_require__(731));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Checkbox["default"].Group = _Group["default"];
var _default = _Checkbox["default"];
exports["default"] = _default;

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocalizedStr; });
var getLocalizedStr=function getLocalizedStr(multilangStr,prefLang,dataLangs,noFallback){if(multilangStr===null||multilangStr===undefined||multilangStr==={}){return null;}if(typeof multilangStr==="string"){return multilangStr;}if(multilangStr[prefLang]){return multilangStr[prefLang];}if(!noFallback){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=dataLangs[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref=_step.value;var code=_ref.code;if(multilangStr[code]){return multilangStr[code];}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return multilangStr[Object.keys(multilangStr)[0]];}else{return"";}};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentNodeConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CURRENT_NODE_CONFIG_KEY='CURRENT_NODE_CONFIG_KEY';var getCurrentNodeConfig=function getCurrentNodeConfig(action){return action[CURRENT_NODE_CONFIG_KEY];};var currentNodeConfigMiddleware=function currentNodeConfigMiddleware(_ref){var getState=_ref.getState;return function(next){return function(action){var state=getState();var decoratedAction=action;if(state.app.endpointId!==null&&state.config.nodes!==null&&state.config.nodes.length>0){decoratedAction=Object.assign({},action,_defineProperty({},CURRENT_NODE_CONFIG_KEY,__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state.config.nodes.find(function(node){return node.general.id===state.app.endpointId;}))));}return next(decoratedAction);};};};/* harmony default export */ __webpack_exports__["a"] = (currentNodeConfigMiddleware);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _rcSelect = _interopRequireWildcard(__webpack_require__(868));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

var _omit = _interopRequireDefault(__webpack_require__(86));

var _warning = _interopRequireDefault(__webpack_require__(87));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _type = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var SelectSizes = (0, _type.tuple)('default', 'large', 'small');
var SelectPropTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(SelectSizes),
  notFoundContent: PropTypes.any,
  showSearch: PropTypes.bool,
  optionLabelProp: PropTypes.string,
  transitionName: PropTypes.string,
  choiceTransitionName: PropTypes.string,
  id: PropTypes.string
}; // => It is needless to export the declaration of below two inner components.
// export { Option, OptGroup };

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _this.saveSelect = function (node) {
      _this.rcSelect = node;
    };

    _this.renderSelect = function (_ref) {
      var _classNames;

      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls,
          renderEmpty = _ref.renderEmpty;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          _a$className = _a.className,
          className = _a$className === void 0 ? '' : _a$className,
          size = _a.size,
          mode = _a.mode,
          getPopupContainer = _a.getPopupContainer,
          removeIcon = _a.removeIcon,
          clearIcon = _a.clearIcon,
          menuItemSelectedIcon = _a.menuItemSelectedIcon,
          restProps = __rest(_a, ["prefixCls", "className", "size", "mode", "getPopupContainer", "removeIcon", "clearIcon", "menuItemSelectedIcon"]);

      var rest = (0, _omit["default"])(restProps, ['inputIcon']);
      var prefixCls = getPrefixCls('select', customizePrefixCls);
      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className);
      var optionLabelProp = _this.props.optionLabelProp;

      if (_this.isCombobox()) {
        // children 带 dom 结构时，无法填入输入框
        optionLabelProp = optionLabelProp || 'value';
      }

      var modeConfig = {
        multiple: mode === 'multiple',
        tags: mode === 'tags',
        combobox: _this.isCombobox()
      };
      var finalRemoveIcon = removeIcon && (React.isValidElement(removeIcon) ? React.cloneElement(removeIcon, {
        className: (0, _classnames["default"])(removeIcon.props.className, "".concat(prefixCls, "-remove-icon"))
      }) : removeIcon) || React.createElement(_icon["default"], {
        type: "close",
        className: "".concat(prefixCls, "-remove-icon")
      });
      var finalClearIcon = clearIcon && (React.isValidElement(clearIcon) ? React.cloneElement(clearIcon, {
        className: (0, _classnames["default"])(clearIcon.props.className, "".concat(prefixCls, "-clear-icon"))
      }) : clearIcon) || React.createElement(_icon["default"], {
        type: "close-circle",
        theme: "filled",
        className: "".concat(prefixCls, "-clear-icon")
      });
      var finalMenuItemSelectedIcon = menuItemSelectedIcon && (React.isValidElement(menuItemSelectedIcon) ? React.cloneElement(menuItemSelectedIcon, {
        className: (0, _classnames["default"])(menuItemSelectedIcon.props.className, "".concat(prefixCls, "-selected-icon"))
      }) : menuItemSelectedIcon) || React.createElement(_icon["default"], {
        type: "check",
        className: "".concat(prefixCls, "-selected-icon")
      });
      return React.createElement(_rcSelect["default"], _extends({
        inputIcon: _this.renderSuffixIcon(prefixCls),
        removeIcon: finalRemoveIcon,
        clearIcon: finalClearIcon,
        menuItemSelectedIcon: finalMenuItemSelectedIcon
      }, rest, modeConfig, {
        prefixCls: prefixCls,
        className: cls,
        optionLabelProp: optionLabelProp || 'children',
        notFoundContent: _this.getNotFoundContent(renderEmpty),
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        ref: _this.saveSelect
      }));
    };

    (0, _warning["default"])(props.mode !== 'combobox', 'The combobox mode of Select is deprecated, ' + 'it will be removed in next major version, ' + 'please use AutoComplete instead');
    return _this;
  }

  _createClass(Select, [{
    key: "focus",
    value: function focus() {
      this.rcSelect.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcSelect.blur();
    }
  }, {
    key: "getNotFoundContent",
    value: function getNotFoundContent(renderEmpty) {
      var notFoundContent = this.props.notFoundContent;

      if (notFoundContent !== undefined) {
        return notFoundContent;
      }

      if (this.isCombobox()) {
        return null;
      }

      return renderEmpty('Select'); // if (this.isCombobox()) {
      //   // AutoComplete don't have notFoundContent defaultly
      //   return notFoundContent === undefined ? null : notFoundContent;
      // }
      // return renderEmpty('Select');
      // // return notFoundContent === undefined ? locale.notFoundContent : notFoundContent;
    }
  }, {
    key: "isCombobox",
    value: function isCombobox() {
      var mode = this.props.mode;
      return mode === 'combobox' || mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE;
    }
  }, {
    key: "renderSuffixIcon",
    value: function renderSuffixIcon(prefixCls) {
      var _this$props = this.props,
          loading = _this$props.loading,
          suffixIcon = _this$props.suffixIcon;

      if (suffixIcon) {
        return React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
          className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-arrow-icon"))
        }) : suffixIcon;
      }

      if (loading) {
        return React.createElement(_icon["default"], {
          type: "loading"
        });
      }

      return React.createElement(_icon["default"], {
        type: "down",
        className: "".concat(prefixCls, "-arrow-icon")
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSelect);
    }
  }]);

  return Select;
}(React.Component);

exports["default"] = Select;
Select.Option = _rcSelect.Option;
Select.OptGroup = _rcSelect.OptGroup;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
Select.defaultProps = {
  showSearch: false,
  transitionName: 'slide-up',
  choiceTransitionName: 'zoom'
};
Select.propTypes = SelectPropTypes;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTO_ANNOTATION_DDBDATAFLOW_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTO_ANNOTATION_FILE_PATH_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AUTO_ANNOTATION_IS_MULTILINGUAL_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUTO_ANNOTATION_HAVE_METADATA_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DATAFLOW_CATALOG_TYPE_ONLY_FILE; });
/* unused harmony export isStrCaseInsensitiveEquals */
/* harmony export (immutable) */ __webpack_exports__["v"] = getGenericAnnotations;
/* harmony export (immutable) */ __webpack_exports__["u"] = getCustomAnnotationsTabsMap;
/* harmony export (immutable) */ __webpack_exports__["t"] = getCustomAnnotationsFromTabsMap;
/* harmony export (immutable) */ __webpack_exports__["r"] = countCustomAnnotations;
/* harmony export (immutable) */ __webpack_exports__["O"] = getLayoutAnnotations;
/* harmony export (immutable) */ __webpack_exports__["s"] = countLayoutAnnotations;
/* harmony export (immutable) */ __webpack_exports__["F"] = getLayoutAnnotationDefaultForCodelist;
/* harmony export (immutable) */ __webpack_exports__["Z"] = setLayoutAnnotationDefaultForCodelist;
/* harmony export (immutable) */ __webpack_exports__["D"] = getLayoutAnnotationDefault;
/* harmony export (immutable) */ __webpack_exports__["X"] = setLayoutAnnotationDefault;
/* harmony export (immutable) */ __webpack_exports__["J"] = getLayoutAnnotationFullname;
/* harmony export (immutable) */ __webpack_exports__["_3"] = setLayoutAnnotationFullName;
/* harmony export (immutable) */ __webpack_exports__["K"] = getLayoutAnnotationNotDisplayed;
/* harmony export (immutable) */ __webpack_exports__["_4"] = setLayoutAnnotationNotDisplayed;
/* harmony export (immutable) */ __webpack_exports__["H"] = getLayoutAnnotationDefaultTableLayout;
/* harmony export (immutable) */ __webpack_exports__["_1"] = setLayoutAnnotationDefaultTableLayout;
/* harmony export (immutable) */ __webpack_exports__["E"] = getLayoutAnnotationDefaultChartLayout;
/* harmony export (immutable) */ __webpack_exports__["Y"] = setLayoutAnnotationDefaultChartLayout;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getLayoutAnnotationDataflowKeywords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return setLayoutAnnotationDataflowKeywords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getLayoutAnnotationAttachedDataFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return setLayoutAnnotationAttachedDataFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getLayoutAnnotationCriteriaSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return setLayoutAnnotationCriteriaSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getLayoutAnnotationDecimalSeparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return setLayoutAnnotationDecimalSeparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getLayoutAnnotationNumberOfDecimals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return setLayoutAnnotationNumberOfDecimals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getLayoutAnnotationReferenceMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return setLayoutAnnotationReferenceMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getLayoutAnnotationEmptyCellPlaceholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return setLayoutAnnotationEmptyCellPlaceholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getLayoutAnnotationDataflowNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return setLayoutAnnotationDataflowNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getLayoutAnnotationDataflowSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return setLayoutAnnotationDataflowSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getLayoutAnnotationTerritorialDimensionIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return setLayoutAnnotationTerritorialDimensionIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getLayoutAnnotationDefaultPresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return setLayoutAnnotationDefaultPresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getLayoutAnnotationDataflowHidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return setLayoutAnnotationDataflowHidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return removeOrderAnnotation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__artefactValidators__ = __webpack_require__(37);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var AUTO_ANNOTATION_DDBDATAFLOW_KEY="ddbDataflow";var AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY="restrictedForPublication";var AUTO_ANNOTATION_FILE_PATH_KEY="attachedFilePath";var AUTO_ANNOTATION_IS_MULTILINGUAL_KEY="dcaT_IsMultilingual";var AUTO_ANNOTATION_HAVE_METADATA_KEY="haveMetadata";var AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY="customIsPresentational";var AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY="virtualDataflowNode";var AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY="dataflowCatalogType";var LAYOUT_ANNOTATION_DEFAULT_KEY="default";var LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_KEY="layoutRow";var LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_COLUMN_KEY="layoutColumn";var LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_SECTION_KEY="layoutRowSection";var LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_FILTER="layoutFilter";var LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM="layoutChartPrimaryDim";var LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM="layoutChartSecondaryDim";var LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER="layoutChartFilter";var LAYOUT_ANNOTATION_NOT_DISPLAYED_KEY="notDisplayed";var LAYOUT_ANNOTATION_FULL_NAME_KEY="fullName";var LAYOUT_ANNOTATION_DATAFLOW_KEYWORDS_KEY='layoutDataflowKeywords';var LAYOUT_ANNOTATION_CRITERIA_SELECTION_KEY='layoutCriteriaSelection';var LAYOUT_ANNOTATION_ATTACHED_DATA_FILES_KEY='layoutAttachedDataFiles';var LAYOUT_ANNOTATION_DEFAULT_PRESENTATION_KEY='layoutDefaultPresentation';var LAYOUT_ANNOTATION_DECIMAL_SEPARATOR_KEY='layoutDecimalSeparator';var LAYOUT_ANNOTATION_NUMBER_OF_DECIMALS_KEY='layoutNumberOfDecimals';var LAYOUT_ANNOTATION_REFERENCE_METADATA_KEY='layoutReferenceMetadata';var LAYOUT_ANNOTATION_EMPTY_CELL_PLACEHOLDER_KEY='layoutEmptyCellPlaceholder';var LAYOUT_ANNOTATION_DATAFLOW_HIDDEN_KEY='layoutDataflowHidden';var LAYOUT_ANNOTATION_DATAFLOW_NOTES_KEY='layoutDataflowNotes';var LAYOUT_ANNOTATION_TERRITORIAL_DIMENSION_IDS_KEY='layoutTerritorialDimensionIds';var LAYOUT_ANNOTATION_DATAFLOW_SOURCE_KEY='layoutDataflowSource';var LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER='LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER';var LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER='LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER';var TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START='TIME_PERIOD_START';var TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END='TIME_PERIOD_END';var TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS='LASTNOBSERVATIONS';var TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS='LASTNPERIODS';var TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE="TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE";var TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS="TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS";var DATAFLOW_CATALOG_TYPE_ONLY_FILE="ONLY_FILE";var LAYOUT_ANNOTATION_KEYS=[LAYOUT_ANNOTATION_DEFAULT_KEY,LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_KEY,LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_COLUMN_KEY,LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_SECTION_KEY,LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_FILTER,LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM,LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM,LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER,LAYOUT_ANNOTATION_NOT_DISPLAYED_KEY,LAYOUT_ANNOTATION_FULL_NAME_KEY,LAYOUT_ANNOTATION_DATAFLOW_KEYWORDS_KEY,LAYOUT_ANNOTATION_CRITERIA_SELECTION_KEY,LAYOUT_ANNOTATION_ATTACHED_DATA_FILES_KEY,LAYOUT_ANNOTATION_DEFAULT_PRESENTATION_KEY,LAYOUT_ANNOTATION_DECIMAL_SEPARATOR_KEY,LAYOUT_ANNOTATION_NUMBER_OF_DECIMALS_KEY,LAYOUT_ANNOTATION_REFERENCE_METADATA_KEY,LAYOUT_ANNOTATION_EMPTY_CELL_PLACEHOLDER_KEY,LAYOUT_ANNOTATION_DATAFLOW_NOTES_KEY,LAYOUT_ANNOTATION_TERRITORIAL_DIMENSION_IDS_KEY,LAYOUT_ANNOTATION_DATAFLOW_SOURCE_KEY,LAYOUT_ANNOTATION_DATAFLOW_HIDDEN_KEY];var isStrCaseInsensitiveEquals=function isStrCaseInsensitiveEquals(str1,str2){return(str1||"").toLowerCase()===(str2||"").toLowerCase();};function getGenericAnnotations(allAnnotations,customAnnotationsConfig,annotationsConfig){allAnnotations=allAnnotations||[];customAnnotationsConfig=customAnnotationsConfig||[];var customAnnotationTypes=[];customAnnotationsConfig.forEach(function(_ref){var annotations=_ref.annotations;return annotations.forEach(function(_ref2){var name=_ref2.name;return customAnnotationTypes.push(name.toLowerCase());});});var layoutAnnotationTypes=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatMap(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(annotationsConfig,LAYOUT_ANNOTATION_KEYS)).map(function(annot){return annot.toLowerCase();});return allAnnotations.filter(function(_ref3){var type=_ref3.type;return!customAnnotationTypes.includes((type||"").toLowerCase())&&!layoutAnnotationTypes.includes((type||"").toLowerCase());});}function getCustomAnnotationsTabsMap(allAnnotations,customAnnotationsConfig){allAnnotations=allAnnotations||[];customAnnotationsConfig=customAnnotationsConfig||[];var res={};customAnnotationsConfig.forEach(function(_ref4){var tabName=_ref4.name,label=_ref4.label,annotations=_ref4.annotations;res[tabName]={label:label,annotations:{}};annotations.forEach(function(_ref5){var type=_ref5.name;return res[tabName].annotations[type]=(allAnnotations.find(function(annot){return isStrCaseInsensitiveEquals(annot.type,type);})||{}).text||null;});});return res;}function getCustomAnnotationsFromTabsMap(tabsMap){var res=[];Object.keys(tabsMap).forEach(function(key){return Object.keys(tabsMap[key].annotations).forEach(function(type){if(tabsMap[key].annotations[type]&&__WEBPACK_IMPORTED_MODULE_0_lodash___default()(tabsMap[key].annotations[type]).pickBy(function(val){return val.length>0;}).keys().value().length>0){res.push({type:type,text:tabsMap[key].annotations[type]});}});});return res;}function countCustomAnnotations(allAnnotations,customAnnotationsConfig,includeNotVisible){allAnnotations=allAnnotations||[];customAnnotationsConfig=customAnnotationsConfig||[];var customAnnotationTypes=[];customAnnotationsConfig.forEach(function(_ref6){var annotations=_ref6.annotations,isVisible=_ref6.isVisible;if(isVisible||includeNotVisible){annotations.forEach(function(_ref7){var name=_ref7.name,isVisible=_ref7.isVisible;if(isVisible||includeNotVisible){customAnnotationTypes.push(name.toLowerCase());}});}});return allAnnotations.filter(function(_ref8){var type=_ref8.type;return customAnnotationTypes.includes((type||"").toLowerCase());}).length;}function getLayoutAnnotations(allAnnotations,annotationsConfig){allAnnotations=allAnnotations||[];var layoutAnnotationTypes=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatMap(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(annotationsConfig,LAYOUT_ANNOTATION_KEYS)).map(function(annot){return annot.toLowerCase();});return allAnnotations.filter(function(_ref9){var type=_ref9.type;return layoutAnnotationTypes.includes((type||"").toLowerCase());});}function countLayoutAnnotations(allAnnotations,annotationsConfig){allAnnotations=allAnnotations||[];var layoutAnnotationTypes=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatMap(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(annotationsConfig,LAYOUT_ANNOTATION_KEYS)).map(function(annot){return annot.toLowerCase();});return allAnnotations.filter(function(_ref10){var type=_ref10.type;return layoutAnnotationTypes.includes((type||"").toLowerCase());}).length;}function getLayoutAnnotationDefaultForCodelist(allAnnotations,annotationsConfig){allAnnotations=allAnnotations||[];var defaultAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];return!!allAnnotations.find(function(_ref11){var type=_ref11.type;return isStrCaseInsensitiveEquals(type,defaultAnnotationType);});}function setLayoutAnnotationDefaultForCodelist(allAnnotations,annotationsConfig,isDefault){allAnnotations=allAnnotations||[];var defaultAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];var otherAnnotations=allAnnotations.filter(function(_ref12){var type=_ref12.type;return!isStrCaseInsensitiveEquals(type,defaultAnnotationType);});return isDefault?[].concat(_toConsumableArray(otherAnnotations),[{type:defaultAnnotationType,id:defaultAnnotationType,title:defaultAnnotationType}]):otherAnnotations;}function getLayoutAnnotationDefault(allAnnotations,annotationsConfig){allAnnotations=allAnnotations||[];var notDisplayedAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];var splitRes=((allAnnotations.find(function(_ref13){var type=_ref13.type;return isStrCaseInsensitiveEquals(type,notDisplayedAnnotationType);})||{}).title||"").split(",");var normalizedSplitRes=splitRes.filter(function(val){return val.length>0;}).map(function(val){return val.split("=");}).filter(function(arr){return arr[0].length>0;});var res={};normalizedSplitRes.forEach(function(split){res[split[0]]=split[1]?split[1].split("+").filter(function(val){return val.length>0;}):[];});return res;}function setLayoutAnnotationDefault(allAnnotations,annotationsConfig,defaultObj){allAnnotations=allAnnotations||[];var notDisplayAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];var otherAnnotations=allAnnotations.filter(function(_ref14){var type=_ref14.type;return!isStrCaseInsensitiveEquals(type,notDisplayAnnotationType);});return Object.keys(defaultObj).length>0?[].concat(_toConsumableArray(otherAnnotations),[{type:notDisplayAnnotationType,id:notDisplayAnnotationType,title:Object.keys(defaultObj).map(function(id){return id+(defaultObj[id].length>0?"="+defaultObj[id].join("+"):"");}).join(",")}]):otherAnnotations;}function getLayoutAnnotationFullname(allAnnotations,annotationsConfig){allAnnotations=allAnnotations||[];var fullNameAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_FULL_NAME_KEY];return(allAnnotations.find(function(_ref15){var type=_ref15.type;return isStrCaseInsensitiveEquals(type,fullNameAnnotationType);})||{}).text||null;}function setLayoutAnnotationFullName(allAnnotations,annotationsConfig,fullName){allAnnotations=allAnnotations||[];var fullNameAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_FULL_NAME_KEY];var otherAnnotations=allAnnotations.filter(function(_ref16){var type=_ref16.type;return!isStrCaseInsensitiveEquals(type,fullNameAnnotationType);});return __WEBPACK_IMPORTED_MODULE_0_lodash___default()(fullName).pickBy(function(val){return val.length>0;}).keys().value().length>0?[].concat(_toConsumableArray(otherAnnotations),[{type:fullNameAnnotationType,id:fullNameAnnotationType,title:fullNameAnnotationType,text:fullName}]):otherAnnotations;}function getLayoutAnnotationNotDisplayed(allAnnotations,annotationsConfig){allAnnotations=allAnnotations||[];var notDisplayedAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_NOT_DISPLAYED_KEY];var splitRes=((allAnnotations.find(function(_ref17){var type=_ref17.type;return isStrCaseInsensitiveEquals(type,notDisplayedAnnotationType);})||{}).title||"").split(",");var normalizedSplitRes=splitRes.filter(function(val){return val.length>0;}).map(function(val){return val.split("=");}).filter(function(arr){return arr[0].length>0;});var res={};normalizedSplitRes.forEach(function(split){res[split[0]]=split[1]?split[1].split("+").filter(function(val){return val.length>0;}):[];});return res;}function setLayoutAnnotationNotDisplayed(allAnnotations,annotationsConfig,notDisplayed){allAnnotations=allAnnotations||[];var notDisplayAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_NOT_DISPLAYED_KEY];var otherAnnotations=allAnnotations.filter(function(_ref18){var type=_ref18.type;return!isStrCaseInsensitiveEquals(type,notDisplayAnnotationType);});return Object.keys(notDisplayed).length>0?[].concat(_toConsumableArray(otherAnnotations),[{type:notDisplayAnnotationType,id:notDisplayAnnotationType,title:Object.keys(notDisplayed).map(function(id){return id+(notDisplayed[id].length>0?"="+notDisplayed[id].join("+"):"");}).join(",")}]):otherAnnotations;}function getLayoutAnnotationDefaultTableLayout(allAnnotations,annotationsConfig){allAnnotations=allAnnotations||[];var layoutRowAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_KEY];var layoutColumnAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_COLUMN_KEY];var layoutFilterAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_FILTER];var layoutRowSectionAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_SECTION_KEY];var rowSplitRes=((allAnnotations.find(function(_ref19){var type=_ref19.type;return isStrCaseInsensitiveEquals(type,layoutRowAnnotationType);})||{}).title||"").split(",");var columnSplitRes=((allAnnotations.find(function(_ref20){var type=_ref20.type;return isStrCaseInsensitiveEquals(type,layoutColumnAnnotationType);})||{}).title||"").split(",");var filterSpitRes=((allAnnotations.find(function(_ref21){var type=_ref21.type;return isStrCaseInsensitiveEquals(type,layoutFilterAnnotationType);})||{}).title||"").split(",");var rowSectionSplitRes=((allAnnotations.find(function(_ref22){var type=_ref22.type;return isStrCaseInsensitiveEquals(type,layoutRowSectionAnnotationType);})||{}).title||"").split(",");return rowSplitRes[0]!==""||columnSplitRes[0]!==""||filterSpitRes[0]!==""||rowSectionSplitRes[0]!==""?{row:rowSplitRes[0]===""?[]:rowSplitRes,column:columnSplitRes[0]===""?[]:columnSplitRes,filter:filterSpitRes[0]===""?[]:filterSpitRes,rowSection:rowSectionSplitRes[0]===""?[]:rowSectionSplitRes}:null;}function setLayoutAnnotationDefaultTableLayout(allAnnotations,annotationsConfig,layout){allAnnotations=allAnnotations||[];var layoutRowAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_KEY];var layoutColumnAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_COLUMN_KEY];var layoutFilterAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_FILTER];var layoutRowSectionAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_SECTION_KEY];var otherAnnotations=allAnnotations.filter(function(_ref23){var type=_ref23.type;return!isStrCaseInsensitiveEquals(type,layoutRowAnnotationType)&&!isStrCaseInsensitiveEquals(type,layoutColumnAnnotationType)&&!isStrCaseInsensitiveEquals(type,layoutRowSectionAnnotationType)&&!isStrCaseInsensitiveEquals(type,layoutFilterAnnotationType);});return otherAnnotations.concat(layout&&layout.row.length>0?[{type:layoutRowAnnotationType,id:layoutRowAnnotationType,title:layout.row.join(",")}]:[]).concat(layout&&layout.column.length>0?[{type:layoutColumnAnnotationType,id:layoutColumnAnnotationType,title:layout.column.join(",")}]:[]).concat(layout&&layout.filter.length>0?[{type:layoutFilterAnnotationType,id:layoutFilterAnnotationType,title:layout.filter.join(",")}]:[]).concat(layout&&layout.rowSection.length>0?[{type:layoutRowSectionAnnotationType,id:layoutRowSectionAnnotationType,title:layout.rowSection.join(",")}]:[]);}function getLayoutAnnotationDefaultChartLayout(allAnnotations,annotationsConfig){allAnnotations=allAnnotations||[];var layoutPrimaryDimAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM];var layoutSecondaryDimAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM];var layoutFiltersAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER];var primaryDim=(allAnnotations.find(function(_ref24){var type=_ref24.type;return isStrCaseInsensitiveEquals(type,layoutPrimaryDimAnnotationType);})||{}).title||"";var secondaryDim=(allAnnotations.find(function(_ref25){var type=_ref25.type;return isStrCaseInsensitiveEquals(type,layoutSecondaryDimAnnotationType);})||{}).title||"";var filterSpitRes=((allAnnotations.find(function(_ref26){var type=_ref26.type;return isStrCaseInsensitiveEquals(type,layoutFiltersAnnotationType);})||{}).title||"").split(",");return primaryDim!==""||secondaryDim!==""||filterSpitRes[0]!==""?{primaryDim:[primaryDim],secondaryDim:[secondaryDim],filter:filterSpitRes[0]===""?[]:filterSpitRes}:null;}function setLayoutAnnotationDefaultChartLayout(allAnnotations,annotationsConfig,layout){allAnnotations=allAnnotations||[];var layoutPrimaryDimAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM];var layoutSecondaryDimAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM];var layoutFilterAnnotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER];var otherAnnotations=allAnnotations.filter(function(_ref27){var type=_ref27.type;return!isStrCaseInsensitiveEquals(type,layoutPrimaryDimAnnotationType)&&!isStrCaseInsensitiveEquals(type,layoutSecondaryDimAnnotationType)&&!isStrCaseInsensitiveEquals(type,layoutFilterAnnotationType);});return otherAnnotations.concat(layout&&layout.primaryDim&&layout.primaryDim.length>0?[{type:layoutPrimaryDimAnnotationType,id:layoutPrimaryDimAnnotationType,title:layout.primaryDim[0]}]:[]).concat(layout&&layout.secondaryDim&&layout.secondaryDim.length>0?[{type:layoutSecondaryDimAnnotationType,id:layoutSecondaryDimAnnotationType,title:layout.secondaryDim[0]}]:[]).concat(layout&&layout.filter&&layout.filter.length>0?[{type:layoutFilterAnnotationType,id:layoutFilterAnnotationType,title:layout.filter.join(",")}]:[]);}var getLayoutAnnotationDataflowKeywords=function getLayoutAnnotationDataflowKeywords(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_KEYWORDS_KEY];var annotationText=(allAnnotations.find(function(_ref28){var type=_ref28.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).text||null;if(annotationText!==null){// {en: "k1+k2", it: "k3+k4"}
return __WEBPACK_IMPORTED_MODULE_0_lodash___default()(annotationText).pickBy(function(val){return val!==undefined&&val!==null&&val.length>0;}).mapValues(function(val){return val.split("+");}).value();}else{return null;}};var setLayoutAnnotationDataflowKeywords=function setLayoutAnnotationDataflowKeywords(allAnnotations,annotationsConfig,dataflowKeywords){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_KEYWORDS_KEY];var otherAnnotations=allAnnotations.filter(function(_ref29){var type=_ref29.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(Object(__WEBPACK_IMPORTED_MODULE_1__artefactValidators__["d" /* isDictionaryValid */])(dataflowKeywords)){annotation={id:annotationType,type:annotationType,title:annotationType,text:""};// {en: "k1+k2", it: "k3+k4"}
annotation.text=__WEBPACK_IMPORTED_MODULE_0_lodash___default()(dataflowKeywords).pickBy(function(val){return val!==undefined&&val!==null&&val.length>0;}).mapValues(function(val){return val.join("+");}).value();}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationAttachedDataFiles=function getLayoutAnnotationAttachedDataFiles(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_ATTACHED_DATA_FILES_KEY];var annotationText=(allAnnotations.find(function(_ref30){var type=_ref30.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).text||null;if(annotationText!==null){return __WEBPACK_IMPORTED_MODULE_0_lodash___default()(annotationText).mapValues(function(val){return val.split("||").map(function(elem){return{url:decodeURI(elem.split("|")[0]),format:decodeURI(elem.split("|")[1])};});}).value();}else{return null;}};var setLayoutAnnotationAttachedDataFiles=function setLayoutAnnotationAttachedDataFiles(allAnnotations,annotationsConfig,attachedDataFiles){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_ATTACHED_DATA_FILES_KEY];var otherAnnotations=allAnnotations.filter(function(_ref31){var type=_ref31.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;var normalizedAttachedDataFiles=__WEBPACK_IMPORTED_MODULE_0_lodash___default()(attachedDataFiles).pickBy(function(val){return val!==undefined&&val!==null;}).mapValues(function(val){return val.filter(function(_ref32){var url=_ref32.url,format=_ref32.format;return url!==null&&url.length>0&&format!==null&&format.length>0;});}).pickBy(function(val){return val.length>0;}).value();if(__WEBPACK_IMPORTED_MODULE_0_lodash___default()(normalizedAttachedDataFiles).keys().value().length>0){annotation={id:annotationType,type:annotationType,text:__WEBPACK_IMPORTED_MODULE_0_lodash___default()(normalizedAttachedDataFiles).mapValues(function(val){return val.map(function(_ref33){var url=_ref33.url,format=_ref33.format;return encodeURI(url)+"|"+encodeURI(format);}).join("||");}).value()};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationCriteriaSelection=function getLayoutAnnotationCriteriaSelection(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_CRITERIA_SELECTION_KEY];var annotationText=(allAnnotations.find(function(_ref34){var type=_ref34.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).title||null;return annotationText||null;};var setLayoutAnnotationCriteriaSelection=function setLayoutAnnotationCriteriaSelection(allAnnotations,annotationsConfig,criteriaSelection){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_CRITERIA_SELECTION_KEY];var otherAnnotations=allAnnotations.filter(function(_ref35){var type=_ref35.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(criteriaSelection&&criteriaSelection.length>0){annotation={id:annotationType,type:annotationType,title:criteriaSelection};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationDecimalSeparator=function getLayoutAnnotationDecimalSeparator(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DECIMAL_SEPARATOR_KEY];var annotationText=(allAnnotations.find(function(_ref36){var type=_ref36.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).title||null;return annotationText||null;};var setLayoutAnnotationDecimalSeparator=function setLayoutAnnotationDecimalSeparator(allAnnotations,annotationsConfig,decimalSeparator){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DECIMAL_SEPARATOR_KEY];var otherAnnotations=allAnnotations.filter(function(_ref37){var type=_ref37.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(decimalSeparator&&decimalSeparator.length>0){annotation={id:annotationType,type:annotationType,title:decimalSeparator};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationNumberOfDecimals=function getLayoutAnnotationNumberOfDecimals(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_NUMBER_OF_DECIMALS_KEY];var annotationText=(allAnnotations.find(function(_ref38){var type=_ref38.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).title||null;return annotationText?Number(annotationText):null;};var setLayoutAnnotationNumberOfDecimals=function setLayoutAnnotationNumberOfDecimals(allAnnotations,annotationsConfig,numberOfDecimals){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_NUMBER_OF_DECIMALS_KEY];var otherAnnotations=allAnnotations.filter(function(_ref39){var type=_ref39.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(numberOfDecimals!==null){annotation={id:annotationType,type:annotationType,title:String(numberOfDecimals)};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationReferenceMetadata=function getLayoutAnnotationReferenceMetadata(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_REFERENCE_METADATA_KEY];var annotationText=(allAnnotations.find(function(_ref40){var type=_ref40.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).text||null;return annotationText||null;};var setLayoutAnnotationReferenceMetadata=function setLayoutAnnotationReferenceMetadata(allAnnotations,annotationsConfig,referenceMetadata){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_REFERENCE_METADATA_KEY];var otherAnnotations=allAnnotations.filter(function(_ref41){var type=_ref41.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(referenceMetadata&&__WEBPACK_IMPORTED_MODULE_0_lodash___default()(referenceMetadata).pickBy(function(val){return val.length>0;}).keys().value().length>0){annotation={id:annotationType,type:annotationType,title:annotationType,text:referenceMetadata};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationEmptyCellPlaceholder=function getLayoutAnnotationEmptyCellPlaceholder(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_EMPTY_CELL_PLACEHOLDER_KEY];var annotationText=(allAnnotations.find(function(_ref42){var type=_ref42.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).title||null;return annotationText||null;};var setLayoutAnnotationEmptyCellPlaceholder=function setLayoutAnnotationEmptyCellPlaceholder(allAnnotations,annotationsConfig,emptyCellPlaceholder){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_EMPTY_CELL_PLACEHOLDER_KEY];var otherAnnotations=allAnnotations.filter(function(_ref43){var type=_ref43.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(emptyCellPlaceholder&&emptyCellPlaceholder.length>0){annotation={id:annotationType,type:annotationType,title:emptyCellPlaceholder};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationDataflowNotes=function getLayoutAnnotationDataflowNotes(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_NOTES_KEY];var annotationText=(allAnnotations.find(function(_ref44){var type=_ref44.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).text||null;return annotationText||null;};var setLayoutAnnotationDataflowNotes=function setLayoutAnnotationDataflowNotes(allAnnotations,annotationsConfig,dataflowNotes){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_NOTES_KEY];var otherAnnotations=allAnnotations.filter(function(_ref45){var type=_ref45.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(dataflowNotes&&__WEBPACK_IMPORTED_MODULE_0_lodash___default()(dataflowNotes).pickBy(function(val){return val.length>0;}).keys().value().length>0){annotation={id:annotationType,type:annotationType,title:annotationType,text:dataflowNotes};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationDataflowSource=function getLayoutAnnotationDataflowSource(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_SOURCE_KEY];var annotationText=(allAnnotations.find(function(_ref46){var type=_ref46.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).text||null;return annotationText||null;};var setLayoutAnnotationDataflowSource=function setLayoutAnnotationDataflowSource(allAnnotations,annotationsConfig,dataflowSource){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_SOURCE_KEY];var otherAnnotations=allAnnotations.filter(function(_ref47){var type=_ref47.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(dataflowSource&&__WEBPACK_IMPORTED_MODULE_0_lodash___default()(dataflowSource).pickBy(function(val){return val.length>0;}).keys().value().length>0){annotation={id:annotationType,type:annotationType,title:annotationType,text:dataflowSource};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationTerritorialDimensionIds=function getLayoutAnnotationTerritorialDimensionIds(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_TERRITORIAL_DIMENSION_IDS_KEY];var annotationText=(allAnnotations.find(function(_ref48){var type=_ref48.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).title||null;if(annotationText!==null){return annotationText.split("+")||[];}else{return[];}};var setLayoutAnnotationTerritorialDimensionIds=function setLayoutAnnotationTerritorialDimensionIds(allAnnotations,annotationsConfig,territorialDimensionIds){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_TERRITORIAL_DIMENSION_IDS_KEY];var otherAnnotations=allAnnotations.filter(function(_ref49){var type=_ref49.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(territorialDimensionIds.length>0){annotation={id:annotationType,type:annotationType,title:territorialDimensionIds.join("+")};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationDefaultPresentation=function getLayoutAnnotationDefaultPresentation(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_PRESENTATION_KEY];var annotationText=(allAnnotations.find(function(_ref50){var type=_ref50.type;return isStrCaseInsensitiveEquals(type,annotationType);})||{}).title||null;return annotationText||null;};var setLayoutAnnotationDefaultPresentation=function setLayoutAnnotationDefaultPresentation(allAnnotations,annotationsConfig,defaultPresentation){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_PRESENTATION_KEY];var otherAnnotations=allAnnotations.filter(function(_ref51){var type=_ref51.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(defaultPresentation&&defaultPresentation.length>0){annotation={id:annotationType,type:annotationType,title:defaultPresentation};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var getLayoutAnnotationDataflowHidden=function getLayoutAnnotationDataflowHidden(allAnnotations,annotationsConfig){var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_HIDDEN_KEY];return!!allAnnotations.find(function(_ref52){var type=_ref52.type;return isStrCaseInsensitiveEquals(type,annotationType);});};var setLayoutAnnotationDataflowHidden=function setLayoutAnnotationDataflowHidden(allAnnotations,annotationsConfig,isHidden){allAnnotations=allAnnotations||[];var annotationType=annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_HIDDEN_KEY];var otherAnnotations=allAnnotations.filter(function(_ref53){var type=_ref53.type;return!isStrCaseInsensitiveEquals(type,annotationType);});var annotation=null;if(isHidden){annotation={id:annotationType,type:annotationType,title:annotationType};}return annotation!==null?otherAnnotations.concat(annotation):otherAnnotations;};var removeOrderAnnotation=function removeOrderAnnotation(allAnnotations,itemsOrderAnnotationType){var annotations=(allAnnotations||[]).filter(function(_ref54){var type=_ref54.type;return type!==itemsOrderAnnotationType;});return annotations&&annotations.length>0?annotations:undefined;};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.23.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(207)(module)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(865);

__webpack_require__(206);

__webpack_require__(26);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(397);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_paths__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{username:state.app.user.username,permissions:state.app.user.permissions,endpoints:state.config.nodes,endpointId:state.app.endpointId,appLanguage:state.app.language};};var ArtefactList=function(_React$Component){_inherits(ArtefactList,_React$Component);function ArtefactList(props){_classCallCheck(this,ArtefactList);var _this=_possibleConstructorReturn(this,(ArtefactList.__proto__||Object.getPrototypeOf(ArtefactList)).call(this,props));_this.state={isParentsAndChildrenVisible:false,artefactTriplet:null};_this.onParentsAndChildrenShow=_this.onParentsAndChildrenShow.bind(_this);_this.onParentsAndChildrenHide=_this.onParentsAndChildrenHide.bind(_this);return _this;}_createClass(ArtefactList,[{key:"onParentsAndChildrenShow",value:function onParentsAndChildrenShow(artefactTriplet){this.setState({isParentsAndChildrenVisible:true,artefactTriplet:artefactTriplet});}},{key:"onParentsAndChildrenHide",value:function onParentsAndChildrenHide(){this.setState({isParentsAndChildrenVisible:false,artefactTriplet:null});this.props.onParentsAndChildrenHide();}},{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,username=_props.username,permissions=_props.permissions,artefacts=_props.artefacts,endpoints=_props.endpoints,endpointId=_props.endpointId,appLanguage=_props.appLanguage,getIsDisabledRow=_props.getIsDisabledRow,onCreate=_props.onCreate,onDetailShow=_props.onDetailShow,onDownloadShow=_props.onDownloadShow,onCloneShow=_props.onCloneShow,onExportShow=_props.onExportShow,onOwnershipShow=_props.onOwnershipShow,onContentConstraintsShow=_props.onContentConstraintsShow,ownershipPermissions=_props.ownershipPermissions,onDelete=_props.onDelete,onSelectedItemDelete=_props.onSelectedItemDelete,onRowClick=_props.onRowClick,onAnnotationsShow=_props.onAnnotationsShow,onLayoutAnnotationsShow=_props.onLayoutAnnotationsShow,parentsAndChildren=_props.parentsAndChildren,fetchParentsAndChildren=_props.fetchParentsAndChildren,onParentsAndChildrenHide=_props.onParentsAndChildrenHide,showImportButton=_props.showImportButton;var _state=this.state,isParentsAndChildrenVisible=_state.isParentsAndChildrenVisible,artefactTriplet=_state.artefactTriplet;var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;var customAnnotationsConfig=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].annotationTabs.tabs;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__infinite_scroll_table__["a" /* default */],{data:artefacts?artefacts.sort(function(a,b){return a.id.localeCompare(b.id);}):null,getRowKey:function getRowKey(_ref){var urn=_ref.urn;return urn;},columns:[{title:t('data.artefact.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.agencyID.shortLabel'),dataIndex:'agencyID',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.name.shortLabel'),dataIndex:'name',minWidth:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.artefact.version.shortLabel'),dataIndex:'version',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.isFinal.shortLabel'),dataIndex:"isFinal",width:30,withValuesFilter:true,render:function render(isFinal){return isFinal?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"check"}):null;},renderText:function renderText(isFinal){return isFinal?t('data.artefact.isFinal.values.final'):t('data.artefact.isFinal.values.notFinal');}}],multilangStrDataIndexes:["name"],actions:[].concat(onDetailShow?function(_ref2){var agencyID=_ref2.agencyID;return Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["l" /* BUTTON_DETAIL */],{title:permissions&&permissions.agencies.find(function(agency){return agency===agencyID;})?t('commons.actions.detail.title'):t('commons.actions.detailReadOnly.title'),onClick:function onClick(_ref3){var id=_ref3.id,agencyID=_ref3.agencyID,version=_ref3.version;return onDetailShow({id:id,agencyID:agencyID,version:version});}});}:[]).concat(fetchParentsAndChildren&&onParentsAndChildrenHide?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["w" /* BUTTON_PARENTS_AND_CHILDREN */],{title:t('commons.actions.parentsAndChildren.title'),onClick:function onClick(_ref4){var id=_ref4.id,agencyID=_ref4.agencyID,version=_ref4.version;return _this2.onParentsAndChildrenShow({id:id,agencyID:agencyID,version:version});}}):[]).concat(onContentConstraintsShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["e" /* BUTTON_CONTENT_CONSTRAINTS */],{title:t('components.artefactList.showContentConstraints.title'),onClick:function onClick(_ref5){var id=_ref5.id,agencyID=_ref5.agencyID,version=_ref5.version;return onContentConstraintsShow({id:id,agencyID:agencyID,version:version});}}):[]).concat(onDownloadShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["m" /* BUTTON_DOWNLOAD */],{title:t('commons.actions.download.title'),onClick:function onClick(_ref6){var id=_ref6.id,agencyID=_ref6.agencyID,version=_ref6.version;return onDownloadShow([{id:id,agencyID:agencyID,version:version}],lang);}}):[]).concat(username&&onCloneShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["d" /* BUTTON_CLONE */],{title:t('commons.actions.clone.title'),onClick:function onClick(_ref7){var id=_ref7.id,agencyID=_ref7.agencyID,version=_ref7.version;return onCloneShow({id:id,agencyID:agencyID,version:version});}}):[]).concat(onExportShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["q" /* BUTTON_EXPORT */],{title:t('commons.actions.export.title'),onClick:function onClick(_ref8){var id=_ref8.id,agencyID=_ref8.agencyID,version=_ref8.version;return onExportShow({id:id,agencyID:agencyID,version:version});}}):[]).concat(onOwnershipShow&&ownershipPermissions?function(_ref9){var id=_ref9.id,agencyID=_ref9.agencyID,version=_ref9.version;return ownershipPermissions.includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agencyID,version:version}))?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["v" /* BUTTON_MANAGE_OWNERS */],{title:t('commons.actions.manageOwners.title'),onClick:function onClick(){return onOwnershipShow(Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agencyID,version:version}));}}):null;}:[]).concat(username&&onDelete?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('commons.actions.delete.title'),onClick:function onClick(_ref10,deselect){var id=_ref10.id,agencyID=_ref10.agencyID,version=_ref10.version;return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('components.artefactList.modals.confirms.delete.title',{triplet:Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agencyID,version:version})}),onOk:function onOk(){deselect();onDelete({id:id,agencyID:agencyID,version:version});},cancelText:t('commons.buttons.cancel.title')});}}):[]),fixedActions:[].concat(onAnnotationsShow?function(_ref11){var id=_ref11.id,agencyID=_ref11.agencyID,version=_ref11.version,annotations=_ref11.annotations;var customAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_18__utils_annotations__["r" /* countCustomAnnotations */])(annotations,customAnnotationsConfig);return customAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["g" /* BUTTON_CUSTOM_ANNOTATIONS */],{title:t('commons.actions.customAnnotations.title')+": "+customAnnotationsCount,onClick:function onClick(){return onAnnotationsShow(annotations,{id:id,agencyID:agencyID,version:version});}}):null;}:[]).concat(username&&onLayoutAnnotationsShow?function(_ref12){var id=_ref12.id,agencyID=_ref12.agencyID,version=_ref12.version,annotations=_ref12.annotations;var layoutAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_18__utils_annotations__["s" /* countLayoutAnnotations */])(annotations,annotationsConfig);return layoutAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["u" /* BUTTON_LAYOUT_ANNOTATIONS */],{title:t('commons.actions.layoutAnnotations.title')+": "+layoutAnnotationsCount,onClick:function onClick(){return onLayoutAnnotationsShow(annotations,{id:id,agencyID:agencyID,version:version});}}):null;}:[]),tableActions:[onDownloadShow?{icon:"download",title:t('commons.actions.download.title'),hasRectangularButton:true,onClick:function onClick(selectedArr){onDownloadShow(selectedArr.map(function(cl){return Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(cl.urn);}),lang);}}:null,username&&onSelectedItemDelete?{icon:"delete",title:t('commons.actions.delete.title'),hasRectangularButton:true,onClick:function onClick(selectedArr,deselect){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('components.artefactList.modals.confirms.multiDelete.title',{count:selectedArr.length}),onOk:function onOk(){deselect();onSelectedItemDelete(selectedArr.map(function(cl){return Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(cl.urn);}));},cancelText:t('commons.buttons.cancel.title')});}}:null],rightActions:(onCreate||showImportButton)&&username?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_SM"]},permissions&&permissions.functionality.filter(function(func){return func===__WEBPACK_IMPORTED_MODULE_17__constants_paths__["C" /* PATH_IMPORT_STRUCTURES */].substr(__WEBPACK_IMPORTED_MODULE_17__constants_paths__["C" /* PATH_IMPORT_STRUCTURES */].lastIndexOf("/")+1);}).length>0&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("a",{href:"./#"+__WEBPACK_IMPORTED_MODULE_17__constants_paths__["C" /* PATH_IMPORT_STRUCTURES */]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{icon:"upload"},t('components.artefactList.buttons.import.title')))),onCreate&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",icon:"plus",onClick:onCreate},t('components.artefactList.buttons.create.title')))):null,onRowClick:onRowClick,getIsDisabledRow:getIsDisabledRow});}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__enhanced_modal__["a" /* default */],{visible:isParentsAndChildrenVisible,onCancel:this.onParentsAndChildrenHide,title:t('components.artefactList.modals.parentsAndChildren.title',{triplet:Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(artefactTriplet)}),width:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:this.onParentsAndChildrenHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__hocs_call__["a" /* default */],{cb:fetchParentsAndChildren,cbParam:artefactTriplet,disabled:!isParentsAndChildrenVisible},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__infinite_scroll_table__["a" /* default */],{data:parentsAndChildren,getRowKey:function getRowKey(_ref13){var id=_ref13.id,agency=_ref13.agency,version=_ref13.version;return Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agency:agency,version:version});},columns:[{title:t('data.artefact.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.agencyID.shortLabel'),dataIndex:'agency',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.name.shortLabel'),dataIndex:'names',minWidth:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.artefact.version.shortLabel'),dataIndex:'version',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.isFinal.shortLabel'),dataIndex:"isFinal",width:30,withValuesFilter:true,render:function render(isFinal){return isFinal?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"check"}):null;},renderText:function renderText(isFinal){return isFinal?t('data.artefact.isFinal.values.final'):t('data.artefact.isFinal.values.notFinal');}},{title:t('data.artefact.type.shortLabel'),dataIndex:'artefactType',minWidth:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"],withValuesFilter:true},{title:t('data.artefact.relationship.shortLabel'),dataIndex:'referenceType',minWidth:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"],withValuesFilter:true,render:function render(referenceType){return referenceType==="children"?t('data.artefact.relationship.children.label'):t('data.artefact.relationship.parent.label');},renderText:function renderText(referenceType){return referenceType==="children"?t('data.artefact.relationship.children.label'):t('data.artefact.relationship.parent.label');}}],multilangStrDataIndexes:["names"]}))));}}]);return ArtefactList;}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps))(ArtefactList));

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_OPTION_ACCOUNT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants_getSdmxTypesTranslations__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__perf_input__ = __webpack_require__(103);
var LOGIN_OPTION_ACCOUNT="account";var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,user:state.app.user};};var mapPropsToFields=function mapPropsToFields(_ref){var destination=_ref.destination;return{endpoint:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:destination?destination.endpoint:null}),username:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:destination?destination.username:null}),password:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:destination?destination.password:null}),id:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:destination?destination.id:null}),agencyID:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:destination?destination.agencyID:null}),version:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:destination?destination.version:null}),withReferences:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:destination?destination.withReferences:null}),loginOption:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:destination?destination.loginOption:null})};};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]}};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var ArtefactExportForm=function ArtefactExportForm(_ref3){var t=_ref3.t,form=_ref3.form,destination=_ref3.destination,agencies=_ref3.agencies,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,user=_ref3.user,endpoints=_ref3.endpoints,endpointId=_ref3.endpointId,type=_ref3.type,sourceTriplet=_ref3.sourceTriplet,isIdDisabled=_ref3.isIdDisabled,isVersionDisabled=_ref3.isVersionDisabled,withReferences=_ref3.withReferences,_onChange=_ref3.onChange;var userHasProvider=user&&user.providerId;var isReadOnlyNode=endpointId&&!__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.find(endpoints,function(node){return node.general.id===endpointId;}).endpoint.haveDMWS;var node=(endpoints||[]).find(function(node){return node.general.id===form.getFieldValue('endpoint');});var supportedAuths=node?node.supportedAuths||[]:[];var handleExternalLogin=function handleExternalLogin(loginURL){localStorage.removeItem("loginCode");window.open(loginURL,"","width=720,height=720");};Object(__WEBPACK_IMPORTED_MODULE_16_react__["useEffect"])(function(){function loginHandler(e){var loginCode=localStorage.getItem("loginCode");if(e.storageArea===localStorage&&loginCode){_onChange({providerLoginCode:loginCode});localStorage.removeItem("loginCode");}}window.addEventListener('storage',loginHandler);return function(){window.removeEventListener('storage',loginHandler);};},[_onChange]);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,{type:"inner",title:t('components.exportArtefactForm.cards.source.title'),size:"small",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('components.exportArtefactForm.artefactType.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,{disabled:true,value:type?Object(__WEBPACK_IMPORTED_MODULE_21__constants_getSdmxTypesTranslations__["a" /* getSdmxTypesTranslations */])(t)[type]:null}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.id.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,{disabled:true,value:sourceTriplet?sourceTriplet.id:null})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.agencyID.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:true,style:{width:"100%"},title:agencies&&sourceTriplet.agencyID&&(Object(__WEBPACK_IMPORTED_MODULE_24__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[sourceTriplet.agencyID],lang,dataLanguages)||sourceTriplet.agencyID),value:sourceTriplet&&sourceTriplet.agencyID},agencies?Object.keys(agencies).map(function(agencyID,index){var agencyName=Object(__WEBPACK_IMPORTED_MODULE_24__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[agencyID],lang,dataLanguages);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:index,value:agencyID,title:agencyID&&agencyName?agencyID+" - "+agencyName:agencyID},agencyID&&agencyName?agencyID+" - "+agencyName:agencyID);}):null))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.version.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,{disabled:true,value:sourceTriplet?sourceTriplet.version:null,title:sourceTriplet?sourceTriplet.version:null}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,{type:"inner",size:"small",title:t('components.exportArtefactForm.cards.destination.title')},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({},formItemLayout,{className:"form-item-required",label:t('components.exportArtefactForm.destinationEndpoint.label')}),form.getFieldDecorator('endpoint')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref5){var props=_ref5.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},style:{width:"100%"},onChange:function onChange(value){_onChange({loginOption:LOGIN_OPTION_ACCOUNT});}},endpoints.filter(function(endpoint){return endpoint.general.id!==endpointId&&endpoint.endpoint.haveDMWS;}).map(function(endpoint){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:endpoint.general.id,value:endpoint.general.id,title:endpoint.general.name},endpoint.general.name);}))))),isReadOnlyNode&&supportedAuths.length>0&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({},formItemLayout,{className:"form-item-required",label:t('components.exportArtefactForm.loginOption.label')}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{style:{width:"100%"},value:form.getFieldValue('loginOption'),onChange:function onChange(value){_onChange({loginOption:value});if(value!==LOGIN_OPTION_ACCOUNT){var loginBaseURL=supportedAuths.find(function(supportedAuth){return supportedAuth.providerName===value;}).loginBaseURL;handleExternalLogin(loginBaseURL);}}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:LOGIN_OPTION_ACCOUNT,value:LOGIN_OPTION_ACCOUNT,title:t('components.exportArtefactForm.loginOption.values.account')},t('components.exportArtefactForm.loginOption.values.account')),supportedAuths.map(function(_ref6){var label=_ref6.label,loginBaseURL=_ref6.loginBaseURL,providerName=_ref6.providerName;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:providerName,value:providerName,title:label},label);}))))),(!userHasProvider||isReadOnlyNode)&&form.getFieldValue('loginOption')===LOGIN_OPTION_ACCOUNT&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('components.exportArtefactForm.username.label')},formItemLayout),form.getFieldDecorator('username')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('components.exportArtefactForm.password.label')},formItemLayout),form.getFieldDecorator('password')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,type:"password",autoComplete:"new-password"})))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('components.exportArtefactForm.artefactType.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,{disabled:true,value:type?Object(__WEBPACK_IMPORTED_MODULE_21__constants_getSdmxTypesTranslations__["a" /* getSdmxTypesTranslations */])(t)[type]:null}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.id.label'),validateStatus:destination&&Object(__WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,destination.id).help?"warning":null,help:destination&&Object(__WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,destination.id).help},formItemLayout),form.getFieldDecorator('id',{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,disabled:isIdDisabled,style:{textTransform:"uppercase"}}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.agencyID.label')},formItemLayout),form.getFieldDecorator('agencyID')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref7){var props=_ref7.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},style:{width:"100%"},title:agencies&&form.getFieldValue('agencyID')&&(Object(__WEBPACK_IMPORTED_MODULE_24__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[form.getFieldValue('agencyID')],lang,dataLanguages)||form.getFieldValue('agencyID'))},agencies?Object.keys(agencies).map(function(agencyID,index){var agencyName=Object(__WEBPACK_IMPORTED_MODULE_24__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[agencyID],lang,dataLanguages);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:index,value:agencyID,title:agencyID&&agencyName?agencyID+" - "+agencyName:agencyID},agencyID&&agencyName?agencyID+" - "+agencyName:agencyID);}):null)))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.version.label')},formItemLayout,{hasFeedback:true,validateStatus:destination&&Object(__WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,destination.version).help?"warning":null,help:destination&&Object(__WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,destination.version).help}),form.getFieldDecorator('version')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,title:form.getFieldValue('version'),disabled:isVersionDisabled}))))),withReferences&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"end",align:"middle",style:{marginTop:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{style:{marginRight:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},t('components.exportArtefactForm.withReferences.label')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,form.getFieldDecorator('withReferences',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,null)))))));});};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_18_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_20_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}),Object(__WEBPACK_IMPORTED_MODULE_19_react_redux__["b" /* connect */])(mapStateToProps))(ArtefactExportForm));

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numberStringSorter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_css__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_style__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sort_buttons__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filter_button__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_window__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__contants__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pre_header__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__footer__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_sizeme__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_sizeme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_sizeme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__contexts_DataLanguage__ = __webpack_require__(29);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.jQuery;var numberStringSorter=function numberStringSorter(a,b){return Number(a)-Number(b);};var InfiniteScrollTable=function(_React$Component){_inherits(InfiniteScrollTable,_React$Component);function InfiniteScrollTable(props){_classCallCheck(this,InfiniteScrollTable);var _this2=_possibleConstructorReturn(this,(InfiniteScrollTable.__proto__||Object.getPrototypeOf(InfiniteScrollTable)).call(this,props));_this2.onSearchTextChange=_this2.onSearchTextChange.bind(_this2);_this2.onFiltersChange=_this2.onFiltersChange.bind(_this2);_this2.onSortChange=_this2.onSortChange.bind(_this2);_this2.getSelectedRowKeys=_this2.getSelectedRowKeys.bind(_this2);_this2.onRowSelectionChange=_this2.onRowSelectionChange.bind(_this2);_this2.getCols=_this2.getCols.bind(_this2);_this2.getNormalizedTableActions=_this2.getNormalizedTableActions.bind(_this2);_this2.renderActions=_this2.renderActions.bind(_this2);_this2.renderGridRow=_this2.renderGridRow.bind(_this2);_this2.renderFixedActions=_this2.renderFixedActions.bind(_this2);_this2.renderHeaderCells=_this2.renderHeaderCells.bind(_this2);_this2.renderCheckboxTitle=_this2.renderCheckboxTitle.bind(_this2);_this2.renderCheckbox=_this2.renderCheckbox.bind(_this2);_this2.getPopulatedRows=_this2.getPopulatedRows.bind(_this2);_this2.getColWidths=_this2.getColWidths.bind(_this2);_this2.calculateRowHeight=_this2.calculateRowHeight.bind(_this2);_this2.getQueriedRows=_this2.getQueriedRows.bind(_this2);_this2.getRenderedRows=_this2.getRenderedRows.bind(_this2);_this2.onRenderedRowsChange=_this2.onRenderedRowsChange.bind(_this2);_this2.state={uuid:__WEBPACK_IMPORTED_MODULE_13_uuid___default()(),gridKeyForRefresh:__WEBPACK_IMPORTED_MODULE_13_uuid___default()(),scrollTop:0,scrollLeft:0,gridScrollbarWidth:Object(__WEBPACK_IMPORTED_MODULE_12__utils_style__["a" /* getScrollBarWidth */])(),searchText:"",sortCol:null,sortByDesc:false,filters:{},selectedRowKeys:props.rowSelection&&props.rowSelection.selectedRowKeys?props.rowSelection.selectedRowKeys:[],cols:null,populatedRows:null,colWidths:null,renderedRows:null,queriedRows:null,isResizing:false,resizeTimeout:null,pageSize:null,pageNum:null,pageRequestTimeout:null,isPaginating:props.isPaginated,pageRequestParams:null,viewStartIdx:null,viewEndIdx:null,viewIndexesUpdateTimeout:null,doNotCallOnChangeOnNextRenderedRowsChange:false};if(props.isPaginated){_this2.state.pageRequestParams={pageSize:__WEBPACK_IMPORTED_MODULE_19__contants__["n" /* DEFAULT_PAGE_SIZE */],pageNum:__WEBPACK_IMPORTED_MODULE_19__contants__["m" /* DEFAULT_PAGE_NUM */],filters:_this2.state.filters,searchText:_this2.state.searchText,sortCol:_this2.state.sortCol,sortByDesc:_this2.state.sortByDesc};}if(props.onChange&&props.isPaginated){props.onChange(_this2.state.pageRequestParams);}_this2.listRef=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();return _this2;}_createClass(InfiniteScrollTable,[{key:"getPopulatedRows",/* === Hooks === */value:function getPopulatedRows(rows){var _props=this.props,multilangStrDataIndexes=_props.multilangStrDataIndexes,appLanguage=_props.appLanguage,dataLanguage=_props.dataLanguage,dataLanguages=_props.dataLanguages,actions=_props.actions,fixedActions=_props.fixedActions,altActions=_props.altActions,getIsAltRow=_props.getIsAltRow;var getActionsObjs=function getActionsObjs(actions,row){return(actions||[]).filter(function(action){return action!==null;}).map(function(action){return typeof action==="function"?action(row):action;}).filter(function(action){return action!==null;}).map(function(action){return Object.assign({},action,{row:row});});};return rows!==null?rows.map(function(row){var populatedRow=Object.assign({},row);populatedRow[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]]=Object.assign({},populatedRow);if(multilangStrDataIndexes){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=multilangStrDataIndexes[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var dataIndex=_step.value;populatedRow[dataIndex]=Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_i18n_utils__["a" /* getLocalizedStr */])(populatedRow[dataIndex],dataLanguage||appLanguage,dataLanguages);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}populatedRow[__WEBPACK_IMPORTED_MODULE_19__contants__["k" /* DATA_INDEX_ORIGINAL_TRANSLATED_ROW */]]=Object.assign({},populatedRow);populatedRow[__WEBPACK_IMPORTED_MODULE_19__contants__["h" /* DATA_INDEX_FIXED_ACTIONS_OBJS */]]=fixedActions?getActionsObjs(fixedActions,populatedRow[__WEBPACK_IMPORTED_MODULE_19__contants__["k" /* DATA_INDEX_ORIGINAL_TRANSLATED_ROW */]]):null;populatedRow[__WEBPACK_IMPORTED_MODULE_19__contants__["f" /* DATA_INDEX_ACTIONS_OBJS */]]=actions||altActions?getActionsObjs(getIsAltRow&&getIsAltRow(populatedRow[__WEBPACK_IMPORTED_MODULE_19__contants__["k" /* DATA_INDEX_ORIGINAL_TRANSLATED_ROW */]])?altActions:actions,populatedRow[__WEBPACK_IMPORTED_MODULE_19__contants__["k" /* DATA_INDEX_ORIGINAL_TRANSLATED_ROW */]]):null;return populatedRow;}):null;}},{key:"getColWidths",value:function getColWidths(rows,cols){var size=this.props.size;var gridScrollbarWidth=this.state.gridScrollbarWidth;if(cols===null){return null;}var getTextWidthEl=$('<span>').css({visibility:'hidden',position:'absolute'}).appendTo('body').get(0);var colWidths=cols.map(function(col){var colWidth=void 0;var colTitleWidth=Object(__WEBPACK_IMPORTED_MODULE_12__utils_style__["c" /* getTextWidth */])(col.title,getTextWidthEl)+(!col.noFilter||!col.noSort?__WEBPACK_IMPORTED_MODULE_19__contants__["r" /* HEADER_CELL_GUTTER */]:0)+(col.noFilter?0:__WEBPACK_IMPORTED_MODULE_19__contants__["p" /* FILTER_BUTTON_WIDTH */])+(col.noSort?0:__WEBPACK_IMPORTED_MODULE_19__contants__["w" /* SORT_BUTTON_WIDTH */])+(!col.noFilter&&!col.noSort?__WEBPACK_IMPORTED_MODULE_19__contants__["q" /* HEADER_CELL_CONTROLS_GUTTER */]:0)+__WEBPACK_IMPORTED_MODULE_19__contants__["c" /* CELL_PADDING */]*2+__WEBPACK_IMPORTED_MODULE_19__contants__["e" /* COL_WIDTH_SAFE */];if(col.width){colWidth=Math.max(colTitleWidth,col.width);}else if((col.widthToContent||col.minWidthToContent)&&rows.length>0){colWidth=Math.max.apply(Math,[colTitleWidth].concat(_toConsumableArray(rows.map(function(row){var text=col.renderText?col.renderText(row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]][col.dataIndex]):row[col.dataIndex];if(text&&String(text)&&!String(text).includes(" ")){$(getTextWidthEl).css("word-break","break-word");}var res=Object(__WEBPACK_IMPORTED_MODULE_12__utils_style__["c" /* getTextWidth */])(text,getTextWidthEl)+__WEBPACK_IMPORTED_MODULE_19__contants__["c" /* CELL_PADDING */]*2+__WEBPACK_IMPORTED_MODULE_19__contants__["e" /* COL_WIDTH_SAFE */];if(text&&String(text)&&!String(text).includes(" ")){$(getTextWidthEl).css("word-break","initial");}return res;}))));}else if(col.minWidth){colWidth=Math.max(colTitleWidth,col.minWidth);}else{colWidth=colTitleWidth;}return colWidth;});$(getTextWidthEl).remove();var isVariableSizeCol=function isVariableSizeCol(col){return!col.width&&(rows.length>0?!col.widthToContent:true);};var variableSizeCols=cols.filter(isVariableSizeCol);var colWidthsSum=0;colWidths.forEach(function(width){return colWidthsSum+=width;});var availableWidth=size.width-colWidthsSum-(rows!==null&&this.getIsVerticalScrollbarVisible(rows.length)?gridScrollbarWidth:0)-__WEBPACK_IMPORTED_MODULE_19__contants__["y" /* TABLE_TOTAL_BORDER */];if(variableSizeCols.length>0&&availableWidth>0){var widthToAdd=availableWidth/variableSizeCols.length;colWidths=colWidths.map(function(colWidth,colIndex){return isVariableSizeCol(cols[colIndex])?colWidth+widthToAdd:colWidth;});}return colWidths;}},{key:"calculateRowHeight",value:function calculateRowHeight(row,cols,colsWidths,textHeightEl){return Math.max.apply(Math,_toConsumableArray(cols.map(function(col,colIndex){$(textHeightEl).outerWidth(colsWidths[colIndex]);if(!col.render&&row[col.dataIndex]&&String(row[col.dataIndex])&&!String(row[col.dataIndex]).includes(" ")){$(textHeightEl).css("word-break","break-word");}var res=Object(__WEBPACK_IMPORTED_MODULE_12__utils_style__["b" /* getTextHeight */])(col.render?col.render(row[col.dataIndex],row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]]):row[col.dataIndex],textHeightEl);if(!col.render&&row[col.dataIndex]&&String(row[col.dataIndex])&&!String(row[col.dataIndex]).includes(" ")){$(textHeightEl).css("word-break","initial");}return res;})));}},{key:"getRenderedRows",value:function getRenderedRows(rows,cols,colsWidths,selectedRowKeys){var _this3=this;var _props2=this.props,rowSelection=_props2.rowSelection,tableActions=_props2.tableActions,getRowKey=_props2.getRowKey;var textHeightEl=$('<div>').addClass("infinite-scroll-table__grid__cell").addClass("ant-modal-body")// better include this class, it may override style in some cases
.css({visibility:'hidden',position:'absolute',minHeight:__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */]}).appendTo('body').get(0);var res=rows!==null?rows.map(function(row){var _Object$assign;var resRow=Object.assign({},row);if(rowSelection||tableActions){resRow[__WEBPACK_IMPORTED_MODULE_19__contants__["g" /* DATA_INDEX_CHECKED */]]=selectedRowKeys.includes(getRowKey(row));}return Object.assign({},resRow,(_Object$assign={},_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_19__contants__["l" /* DATA_INDEX_RENDERED */],_this3.renderGridRow(resRow,cols,colsWidths)),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_19__contants__["i" /* DATA_INDEX_HEIGHT */],_this3.calculateRowHeight(resRow,cols,colsWidths,textHeightEl)),_Object$assign));}):null;$(textHeightEl).remove();return res;}},{key:"getQueriedRows",value:function getQueriedRows(rows,cols,filters,searchText,sortCol,sortByDesc){var isPaginated=this.props.isPaginated;if(isPaginated){return rows;}else{var queriedRows=this.getFilteredGridRows(rows,cols,filters);queriedRows=this.getSearchTextFilteredGridRows(queriedRows,cols,searchText);return this.getSortedGridRows(queriedRows,cols,sortCol,sortByDesc);}}},{key:"componentDidMount",value:function componentDidMount(){var data=this.props.data;var _state=this.state,filters=_state.filters,searchText=_state.searchText,sortCol=_state.sortCol,sortByDesc=_state.sortByDesc;if(data!==null){var cols=this.getCols();var populatedRows=this.getPopulatedRows(data);var colWidths=this.getColWidths(populatedRows,cols);var renderedRows=this.getRenderedRows(populatedRows,cols,colWidths,this.getSelectedRowKeys());var queriedRows=this.getQueriedRows(renderedRows,cols,filters,searchText,sortCol,sortByDesc);this.setState({cols:cols,populatedRows:populatedRows,colWidths:colWidths,renderedRows:renderedRows,queriedRows:queriedRows});}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var _this4=this;var _props3=this.props,isPaginated=_props3.isPaginated,rowSelection=_props3.rowSelection,appLanguage=_props3.appLanguage,dataLanguage=_props3.dataLanguage,data=_props3.data;var _state2=this.state,uuid=_state2.uuid,filters=_state2.filters,searchText=_state2.searchText,sortCol=_state2.sortCol,sortByDesc=_state2.sortByDesc,scrollLeft=_state2.scrollLeft,scrollTop=_state2.scrollTop,resizeTimeout=_state2.resizeTimeout,colWidths=_state2.colWidths,cols=_state2.cols,pageSize=_state2.pageSize,pageNum=_state2.pageNum,pageRequestParams=_state2.pageRequestParams;if(InfiniteScrollTable.isArrayPropertyChangedLazy(prevProps.data,data)||prevProps.dataLanguage!==dataLanguage||prevProps.appLanguage!==appLanguage){var newCols=null;var newPopulatedRows=null;var newColWidths=null;var newRenderedRows=null;var newQueriedRows=null;var newScrollTop=null;if(data!==null){if(this.listRef.current){this.listRef.current.resetAfterIndex(0,false);}newCols=this.getCols();newPopulatedRows=this.getPopulatedRows(this.props.data);newColWidths=colWidths!==null&&cols!==null&&(prevProps.data===null&&false||prevProps.data!==null&&prevProps.data.length===0&&data.length===0)?colWidths:this.getColWidths(newPopulatedRows,newCols);newRenderedRows=this.getRenderedRows(newPopulatedRows,newCols,newColWidths,this.getSelectedRowKeys());newQueriedRows=this.getQueriedRows(newRenderedRows,newCols,filters,searchText,sortCol,sortByDesc);}else{var _$grid=$(".infinite-scroll-table__"+uuid+" .infinite-scroll-table__grid");if(_$grid){newScrollTop=_$grid.scrollTop();}}this.setState({cols:newCols,populatedRows:newPopulatedRows,colWidths:newColWidths,renderedRows:newRenderedRows,queriedRows:newQueriedRows,pageNum:isPaginated&&pageRequestParams?pageRequestParams.pageNum:pageNum,pageSize:isPaginated&&pageRequestParams?pageRequestParams.pageSize:pageSize,isPaginating:false,pageRequestParams:null,scrollTop:newScrollTop,selectedRowKeys:this.getSelectedRowKeys()});}else if(rowSelection&&InfiniteScrollTable.isArrayPropertyChangedLazy(prevProps.rowSelection.selectedRowKeys,rowSelection.selectedRowKeys)){this.setState({selectedRowKeys:rowSelection.selectedRowKeys});this.updateRenderedRows(rowSelection.selectedRowKeys);}else if(prevProps.size&&this.props.size&&prevProps.size.width!==this.props.size.width){if(resizeTimeout){clearTimeout(resizeTimeout);}var _newScrollTop=null;var _$grid2=$(".infinite-scroll-table__"+uuid+" .infinite-scroll-table__grid");if(_$grid2){_newScrollTop=_$grid2.scrollTop();}this.setState({isResizing:true,scrollTop:_newScrollTop||scrollTop,resizeTimeout:setTimeout(function(){_this4.setState(function(state){var populatedRows=state.populatedRows,cols=state.cols;var colWidths=_this4.getColWidths(populatedRows,cols);var renderedRows=_this4.getRenderedRows(populatedRows,cols,colWidths,_this4.getSelectedRowKeys());var queriedRows=_this4.getQueriedRows(renderedRows,cols,filters,searchText,sortCol,sortByDesc);return{gridKeyForRefresh:__WEBPACK_IMPORTED_MODULE_13_uuid___default()(),isResizing:false,resizeTimeout:null,colWidths:colWidths,renderedRows:renderedRows,queriedRows:queriedRows};});},__WEBPACK_IMPORTED_MODULE_19__contants__["u" /* RESIZE_TIMEOUT */])});}var $grid=$(".infinite-scroll-table__"+uuid+" .infinite-scroll-table__grid:not(.infinite-scroll-table__grid--with-event-handlers)");if($grid.length){var _this=this;$grid.scrollLeft(scrollLeft).addClass('infinite-scroll-table__grid--with-event-handlers').on('scroll',function(){var newScrollLeft=$(this).scrollLeft();if(newScrollLeft!==_this.state.scrollLeft){$(".infinite-scroll-table__"+uuid+" .infinite-scroll-table__header").scrollLeft(newScrollLeft);_this.setState({scrollLeft:newScrollLeft});}});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){var _state3=this.state,uuid=_state3.uuid,resizeTimeout=_state3.resizeTimeout,pageRequestTimeout=_state3.pageRequestTimeout,viewIndexesUpdateTimeout=_state3.viewIndexesUpdateTimeout;var $grid=$(".infinite-scroll-table__"+uuid+" .infinite-scroll-table__grid--with-event-handlers");if($grid.length){$grid.off('scroll');}if(resizeTimeout){clearTimeout(resizeTimeout);}if(pageRequestTimeout){clearTimeout(pageRequestTimeout);}if(viewIndexesUpdateTimeout){clearTimeout(viewIndexesUpdateTimeout);}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState,nextContext){return!(this.state.gridKeyForRefresh===nextState.gridKeyForRefresh&&this.state.scrollLeft!==nextState.scrollLeft);}/* === Event handlers === */},{key:"updateRenderedRows",value:function updateRenderedRows(selectedRowKeys){var _state4=this.state,populatedRows=_state4.populatedRows,cols=_state4.cols,colWidths=_state4.colWidths,filters=_state4.filters,searchText=_state4.searchText,sortCol=_state4.sortCol,sortByDesc=_state4.sortByDesc;var renderedRows=this.getRenderedRows(populatedRows,cols,colWidths,selectedRowKeys);this.setState({renderedRows:renderedRows,queriedRows:this.getQueriedRows(renderedRows,cols,filters,searchText,sortCol,sortByDesc)});}},{key:"applyQueryChange",value:function applyQueryChange(filters,searchText,sortCol,sortByDesc){var isPaginated=this.props.isPaginated;var _state5=this.state,renderedRows=_state5.renderedRows,cols=_state5.cols,queriedRows=_state5.queriedRows;this.setState({scrollTop:0,gridKeyForRefresh:__WEBPACK_IMPORTED_MODULE_13_uuid___default()(),queriedRows:isPaginated?queriedRows:this.getQueriedRows(renderedRows,cols,filters,searchText,sortCol,sortByDesc)});}},{key:"onFiltersChange",value:function onFiltersChange(dataIndex,value){var _props4=this.props,onChange=_props4.onChange,isPaginated=_props4.isPaginated;var _state6=this.state,searchText=_state6.searchText,sortCol=_state6.sortCol,sortByDesc=_state6.sortByDesc;var newFilters=this.state.filters;if(value!==null&&value.length>0){newFilters[dataIndex]=value;}else{delete newFilters[dataIndex];}var newPageRequestParams={pageNum:__WEBPACK_IMPORTED_MODULE_19__contants__["m" /* DEFAULT_PAGE_NUM */],pageSize:__WEBPACK_IMPORTED_MODULE_19__contants__["n" /* DEFAULT_PAGE_SIZE */],searchText:searchText,filters:newFilters,sortCol:sortCol,sortByDesc:sortByDesc};this.setState({filters:newFilters,isPaginating:isPaginated,pageRequestParams:isPaginated?newPageRequestParams:null,doNotCallOnChangeOnNextRenderedRowsChange:isPaginated&&onChange});this.applyQueryChange(newFilters,searchText,sortCol,sortByDesc);if(onChange){onChange(newPageRequestParams);}}},{key:"onSearchTextChange",value:function onSearchTextChange(value){var _props5=this.props,onChange=_props5.onChange,isPaginated=_props5.isPaginated;var _state7=this.state,filters=_state7.filters,sortCol=_state7.sortCol,sortByDesc=_state7.sortByDesc;var newSearchText=value;var newPageRequestParams={pageNum:__WEBPACK_IMPORTED_MODULE_19__contants__["m" /* DEFAULT_PAGE_NUM */],pageSize:__WEBPACK_IMPORTED_MODULE_19__contants__["n" /* DEFAULT_PAGE_SIZE */],searchText:newSearchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc};this.setState({searchText:newSearchText,isPaginating:isPaginated,pageRequestParams:isPaginated?newPageRequestParams:null,doNotCallOnChangeOnNextRenderedRowsChange:isPaginated&&onChange});this.applyQueryChange(filters,newSearchText,sortCol,sortByDesc);if(onChange){onChange(newPageRequestParams);}}},{key:"onSortChange",value:function onSortChange(colDataIndex,direction){var _props6=this.props,onChange=_props6.onChange,isPaginated=_props6.isPaginated;var _state8=this.state,searchText=_state8.searchText,filters=_state8.filters;var newSortCol=direction?colDataIndex:null;var newSortByDesc=direction===__WEBPACK_IMPORTED_MODULE_14__sort_buttons__["b" /* SORT_DIRECTION_DESC */];var newPageRequestParams={pageNum:__WEBPACK_IMPORTED_MODULE_19__contants__["m" /* DEFAULT_PAGE_NUM */],pageSize:__WEBPACK_IMPORTED_MODULE_19__contants__["n" /* DEFAULT_PAGE_SIZE */],searchText:searchText,filters:filters,sortCol:newSortCol,sortByDesc:newSortByDesc};this.setState({sortCol:newSortCol,sortByDesc:newSortByDesc,isPaginating:isPaginated,pageRequestParams:isPaginated?newPageRequestParams:null,doNotCallOnChangeOnNextRenderedRowsChange:isPaginated&&onChange});this.applyQueryChange(filters,searchText,newSortCol,newSortByDesc);if(onChange){onChange(newPageRequestParams);}}},{key:"onRowSelectionChange",value:function onRowSelectionChange(rowKey,selected){var _state9=this.state,searchText=_state9.searchText,sortCol=_state9.sortCol,sortByDesc=_state9.sortByDesc,filters=_state9.filters;var _props7=this.props,rowSelection=_props7.rowSelection,getRowKey=_props7.getRowKey,getIsDisabledRow=_props7.getIsDisabledRow;if(rowSelection&&(rowSelection.onSelect||rowSelection.onSelectAll)){if(rowKey!==null&&rowSelection.onSelect){rowSelection.onSelect(rowKey,selected);}if(rowKey===null&&rowSelection.onSelectAll){rowSelection.onSelectAll(selected,{searchText:searchText,sortCol:sortCol,sortByDesc:sortByDesc,filters:filters});}}else{var _state10=this.state,selectedRowKeys=_state10.selectedRowKeys,queriedRows=_state10.queriedRows;var newSelectedRowKeys=void 0;if(rowKey!==null){newSelectedRowKeys=selected?[].concat(_toConsumableArray(selectedRowKeys),[rowKey]):selectedRowKeys.filter(function(selRowKey){return selRowKey!==rowKey;});}else{newSelectedRowKeys=selected?queriedRows.map(function(row){return row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]];}).filter(function(row){return!getIsDisabledRow||!getIsDisabledRow(row);}).map(function(row){return getRowKey(row);}):[];}if(rowSelection&&rowSelection.onChange){rowSelection.onChange(newSelectedRowKeys);}this.setState({selectedRowKeys:newSelectedRowKeys});this.updateRenderedRows(newSelectedRowKeys);}}/* === Getters === */},{key:"getCols",value:function getCols(){var _props8=this.props,columns=_props8.columns,rowSelection=_props8.rowSelection;if(columns===null){return null;}else{var res=columns.filter(function(col){return col!==null;});if(rowSelection||this.getNormalizedTableActions().length>0){res=[{dataIndex:__WEBPACK_IMPORTED_MODULE_19__contants__["g" /* DATA_INDEX_CHECKED */],render:this.renderCheckbox,titleRender:this.renderCheckboxTitle,noSearchText:true,noFilter:true,noSort:true,width:__WEBPACK_IMPORTED_MODULE_19__contants__["d" /* CHECKBOX_WIDTH */],renderText:function renderText(){return null;}}].concat(_toConsumableArray(res));}if(this.getNormalizedFixedActions().length>0){res=[].concat(_toConsumableArray(res),[{dataIndex:__WEBPACK_IMPORTED_MODULE_19__contants__["h" /* DATA_INDEX_FIXED_ACTIONS_OBJS */],render:this.renderFixedActions,noSearchText:true,noFilter:true,noSort:true,disableOnRowClickForCell:true,renderText:function renderText(){return null;},width:this.getNormalizedFixedActions().length*(__WEBPACK_IMPORTED_MODULE_19__contants__["b" /* ACTION_WIDTH */]+__WEBPACK_IMPORTED_MODULE_19__contants__["a" /* ACTIONS_GUTTER */])-__WEBPACK_IMPORTED_MODULE_19__contants__["a" /* ACTIONS_GUTTER */]+__WEBPACK_IMPORTED_MODULE_19__contants__["e" /* COL_WIDTH_SAFE */]+2*__WEBPACK_IMPORTED_MODULE_19__contants__["c" /* CELL_PADDING */]}]);}if(this.getNormalizedActions().length>0||this.getNormalizedAltActions().length>0){res=[].concat(_toConsumableArray(res),[{dataIndex:__WEBPACK_IMPORTED_MODULE_19__contants__["f" /* DATA_INDEX_ACTIONS_OBJS */],render:this.renderActions,noSearchText:true,noFilter:true,noSort:true,disableOnRowClickForCell:true,renderText:function renderText(){return null;},width:Math.max(this.getNormalizedActions().length,this.getNormalizedAltActions().length)*(__WEBPACK_IMPORTED_MODULE_19__contants__["b" /* ACTION_WIDTH */]+__WEBPACK_IMPORTED_MODULE_19__contants__["a" /* ACTIONS_GUTTER */])-__WEBPACK_IMPORTED_MODULE_19__contants__["a" /* ACTIONS_GUTTER */]+__WEBPACK_IMPORTED_MODULE_19__contants__["e" /* COL_WIDTH_SAFE */]+2*__WEBPACK_IMPORTED_MODULE_19__contants__["c" /* CELL_PADDING */]}]);}return res;}}},{key:"getNormalizedTableActions",value:function getNormalizedTableActions(){var tableActions=this.props.tableActions;return(tableActions||[]).filter(function(action){return action!==null;});}},{key:"getNormalizedActions",value:function getNormalizedActions(){var actions=this.props.actions;return(actions||[]).filter(function(action){return action!==null;});}},{key:"getNormalizedAltActions",value:function getNormalizedAltActions(){var altActions=this.props.altActions;return(altActions||[]).filter(function(action){return action!==null;});}},{key:"getNormalizedFixedActions",value:function getNormalizedFixedActions(){var fixedActions=this.props.fixedActions;return(fixedActions||[]).filter(function(action){return action!==null;});}},{key:"getSelectedRowKeys",value:function getSelectedRowKeys(){var rowSelection=this.props.rowSelection;var selectedRowKeys=this.state.selectedRowKeys;return rowSelection&&rowSelection.selectedRowKeys?rowSelection.selectedRowKeys:selectedRowKeys;}/* === Data manipulation === */},{key:"getFilteredGridRows",value:function getFilteredGridRows(rows,cols,filters){return Object.keys(filters).length>0?rows.filter(function(row){var _loop=function _loop(dataIndex){if(filters.hasOwnProperty(dataIndex)){var col=cols.find(function(col){return col.dataIndex===dataIndex;});var testPassed=col.withValuesFilter?filters[dataIndex].includes(row[dataIndex]):InfiniteScrollTable.isValuePassingSearchText(col.renderText?col.renderText(row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]][dataIndex]):row[dataIndex],filters[dataIndex]);if(!testPassed){return{v:false};}}};for(var dataIndex in filters){var _ret=_loop(dataIndex);if((typeof _ret==="undefined"?"undefined":_typeof(_ret))==="object")return _ret.v;}return true;}):rows;}},{key:"getSearchTextFilteredGridRows",value:function getSearchTextFilteredGridRows(rows,cols,searchText){return searchText!==null?rows!==null?rows.filter(function(row){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=cols[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var col=_step2.value;if(!col.noSearchText&&typeof row[col.dataIndex]!=='boolean'&&InfiniteScrollTable.isValuePassingSearchText(col.renderText?col.renderText(row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]][col.dataIndex]):row[col.dataIndex],searchText)){return true;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return false;}):null:rows;}},{key:"getSortedGridRows",value:function getSortedGridRows(rows,cols,sortCol,sortByDesc){var column=sortCol!==null?cols.find(function(col){return col.dataIndex===sortCol;}):null;return column?rows.sort(function(a,b){var _a=column.renderText?column.renderText(a[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]][column.dataIndex]):a[column.dataIndex];var _b=column.renderText?column.renderText(b[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]][column.dataIndex]):b[column.dataIndex];return column.sorter?column.sorter(_a,_b)*(sortByDesc?-1:1):InfiniteScrollTable.defaultSorter(_a,_b,sortByDesc);}):rows;}/* === Rendering ==== */},{key:"renderGridRow",value:function renderGridRow(row,cols,colWidths){var _props9=this.props,onRowClick=_props9.onRowClick,getIsDisabledRow=_props9.getIsDisabledRow;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table__grid__row",style:{width:"100%",height:"100%"}},cols.map(function(col,colIndex){var cellData=row[col.dataIndex];var isRowClickDisabled=!onRowClick||col.disableOnRowClickForCell||getIsDisabledRow&&getIsDisabledRow(row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]]);var colLeftAttr=0;cols.slice(0,colIndex).map(function(_,index){return index;}).forEach(function(index){return colLeftAttr+=colWidths[index];});return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:colIndex,className:'infinite-scroll-table__grid__cell'+(getIsDisabledRow&&getIsDisabledRow(row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]])?' infinite-scroll-table__grid__cell--disabled':''),style:{position:"absolute",width:colWidths[colIndex],height:"100%",top:0,left:colLeftAttr,cursor:!isRowClickDisabled?"pointer":null,wordBreak:String((col.renderText?col.renderText(cellData):cellData)||"").includes(" ")?"initial":"break-word"},onClick:!isRowClickDisabled?function(){return onRowClick(row[__WEBPACK_IMPORTED_MODULE_19__contants__["k" /* DATA_INDEX_ORIGINAL_TRANSLATED_ROW */]]);}:null,title:col.renderText?col.renderText(cellData):cellData},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table__grid__cell__content",style:{overflow:col.render?undefined:"hidden"}},col.render?col.render(cellData,row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]]):cellData));}));}},{key:"renderHeaderCells",value:function renderHeaderCells(cols,columnWidths,rows){var _this5=this;var data=this.props.data;var _state11=this.state,filters=_state11.filters,sortCol=_state11.sortCol,sortByDesc=_state11.sortByDesc;return(cols||[]).map(function(col,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:index,className:"infinite-scroll-table__header__cell",style:{width:columnWidths[index],height:__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"space-between",gutter:__WEBPACK_IMPORTED_MODULE_19__contants__["r" /* HEADER_CELL_GUTTER */]},(col.title||col.titleRender)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,col.titleRender?col.titleRender(rows):col.title),!col.noFilter||!col.noSort?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_19__contants__["q" /* HEADER_CELL_CONTROLS_GUTTER */]},!col.noSort&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__sort_buttons__["c" /* default */],{value:col.dataIndex===sortCol?sortByDesc?__WEBPACK_IMPORTED_MODULE_14__sort_buttons__["b" /* SORT_DIRECTION_DESC */]:__WEBPACK_IMPORTED_MODULE_14__sort_buttons__["a" /* SORT_DIRECTION_ASC */]:null,onChange:function onChange(value){return _this5.onSortChange(col.dataIndex,value);}})),!col.noFilter&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__filter_button__["a" /* default */],{value:filters[col.dataIndex],onChange:function onChange(value){return _this5.onFiltersChange(col.dataIndex,value);},options:col.withValuesFilter?__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.uniq((data||[]).map(function(row){return row[col.dataIndex];})).map(function(option){return{value:option,text:col.renderText?col.renderText(option):option};}).sort(function(a,b){return col.sorter?col.sorter(a.text,b.text):InfiniteScrollTable.defaultSorter(a.text,b.text);}):null})))):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,"\xA0")));});}},{key:"renderFixedActions",value:function renderFixedActions(actions){var _this6=this;var getRowKey=this.props.getRowKey;var selectedRowKeys=this.state.selectedRowKeys;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_19__contants__["a" /* ACTIONS_GUTTER */]},(actions||[]).map(function(action,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{key:index},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,Object.assign({},action,{key:index,type:"primary",shape:"circle",size:"small",onClick:function onClick(e){e.stopPropagation();action.onClick(action.row,function(){return _this6.setState({selectedRowKeys:selectedRowKeys.filter(function(key){return key!==getRowKey(action.row);})});});}}),action.iconText||null));}));}},{key:"renderActions",value:function renderActions(actions){var _this7=this;var getRowKey=this.props.getRowKey;var selectedRowKeys=this.state.selectedRowKeys;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{className:"infinite-scroll-table__grid__cell__actions-container",type:"flex",justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_19__contants__["a" /* ACTIONS_GUTTER */]},(actions||[]).map(function(action,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{key:index},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",shape:"circle",size:"small",className:"infinite-scroll-table__grid__cell__action "+(action.className||""),icon:action.icon,title:action.title,disabled:action.disabled,onClick:function onClick(e){e.stopPropagation();action.onClick(action.row,function(){return _this7.setState({selectedRowKeys:selectedRowKeys.filter(function(key){return key!==getRowKey(action.row);})});});}},action.iconText||null));}));}},{key:"renderTableAction",value:function renderTableAction(action,rows){var _this8=this;var getRowKey=this.props.getRowKey;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",className:action.className,icon:action.icon,title:action.title,disabled:action.disabled,onClick:function onClick(e){e.stopPropagation();action.onClick(rows.filter(function(row){return _this8.getSelectedRowKeys().includes(getRowKey(row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]]));}),function(){return _this8.onRowSelectionChange(null,false);});}},action.title);}},{key:"renderCheckbox",value:function renderCheckbox(checked,row){var _this9=this;var _props10=this.props,getRowKey=_props10.getRowKey,rowSelection=_props10.rowSelection,getIsDisabledRow=_props10.getIsDisabledRow;var checkboxProps=rowSelection&&rowSelection.getCheckboxProps?rowSelection.getCheckboxProps(row):{disabled:getIsDisabledRow&&getIsDisabledRow(row)};return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,Object.assign({},checkboxProps,{checked:checked,onClick:function onClick(e){e.stopPropagation();_this9.onRowSelectionChange(getRowKey(row),!checked);}}));}},{key:"renderCheckboxTitle",value:function renderCheckboxTitle(rows){var _this10=this;var _props11=this.props,getRowKey=_props11.getRowKey,getIsDisabledRow=_props11.getIsDisabledRow;var selectedRowKeys=this.getSelectedRowKeys();var checked=rows!==null&&rows.length>0&&rows.filter(function(row){return!getIsDisabledRow||!getIsDisabledRow(row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]]);}).map(function(row){return getRowKey(row[__WEBPACK_IMPORTED_MODULE_19__contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]]);}).filter(function(rowKey){return!selectedRowKeys.includes(rowKey);}).length===0;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:checked,onChange:function onChange(){return _this10.onRowSelectionChange(null,!checked);}});}},{key:"onRenderedRowsChange",value:function onRenderedRowsChange(viewStartIdx,viewEndIdx,overscanStartIdx,overscanEndIdx){var _this11=this;var _props12=this.props,onChange=_props12.onChange,rowCount=_props12.rowCount,isPaginated=_props12.isPaginated;var _state12=this.state,pageRequestTimeout=_state12.pageRequestTimeout,pageSize=_state12.pageSize,pageNum=_state12.pageNum,isPaginating=_state12.isPaginating,viewIndexesUpdateTimeout=_state12.viewIndexesUpdateTimeout,doNotCallOnChangeOnNextRenderedRowsChange=_state12.doNotCallOnChangeOnNextRenderedRowsChange;if(viewIndexesUpdateTimeout){clearTimeout(viewIndexesUpdateTimeout);}this.setState({viewIndexesUpdateTimeout:setTimeout(function(){return _this11.setState({viewStartIdx:viewStartIdx,viewEndIdx:viewEndIdx,viewIndexesUpdateTimeout:null});},__WEBPACK_IMPORTED_MODULE_19__contants__["z" /* VIEW_INDEXES_UPDATE_TIMEOUT */])});if(isPaginated&&!doNotCallOnChangeOnNextRenderedRowsChange){var currentPageIndexes=Object(__WEBPACK_IMPORTED_MODULE_20__utils__["a" /* getIndexesFromPaginationParams */])(pageSize||__WEBPACK_IMPORTED_MODULE_19__contants__["n" /* DEFAULT_PAGE_SIZE */],pageNum||__WEBPACK_IMPORTED_MODULE_19__contants__["m" /* DEFAULT_PAGE_NUM */]);if(isPaginating||overscanStartIdx<currentPageIndexes.startIdx||overscanEndIdx>currentPageIndexes.stopIdx){if(pageRequestTimeout!==null){clearTimeout(pageRequestTimeout);}var safePageSize=__WEBPACK_IMPORTED_MODULE_19__contants__["s" /* MAX_PAGE_SIZE */]/2;// getPaginationParamsFromIndexes can double the size of a page
var pageRowsThird=Math.floor(safePageSize/3);var newPaginationParams=Object(__WEBPACK_IMPORTED_MODULE_20__utils__["b" /* getPaginationParamsFromIndexes */])(Math.max(overscanStartIdx-pageRowsThird,0),Math.min(overscanStartIdx+2*pageRowsThird-1,rowCount-1),rowCount);var newPageRequestParams={pageSize:newPaginationParams.pageSize,pageNum:newPaginationParams.pageNum,filters:this.state.filters,searchText:this.state.searchText,sortCol:this.state.sortCol,sortByDesc:this.state.sortByDesc};this.setState({isPaginating:true,pageRequestTimeout:setTimeout(function(){onChange(newPageRequestParams);_this11.setState({pageRequestParams:newPageRequestParams});},__WEBPACK_IMPORTED_MODULE_19__contants__["t" /* PAGINATION_TIMEOUT */])});}}else if(isPaginated){this.setState({doNotCallOnChangeOnNextRenderedRowsChange:false});}}},{key:"getIsVerticalScrollbarVisible",value:function getIsVerticalScrollbarVisible(rowNum){var _props$height=this.props.height,height=_props$height===undefined?__WEBPACK_IMPORTED_MODULE_19__contants__["o" /* DEFAULT_TABLE_HEIGHT */]:_props$height;return rowNum*__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */]>height;}},{key:"render",value:function render(){var _this12=this;var _props13=this.props,t=_props13.t,size=_props13.size,leftActions=_props13.leftActions,rightActions=_props13.rightActions,_props13$showHeader=_props13.showHeader,showHeader=_props13$showHeader===undefined?true:_props13$showHeader,rowCount=_props13.rowCount,_props13$isPaginated=_props13.isPaginated,isPaginated=_props13$isPaginated===undefined?false:_props13$isPaginated,_props13$height=_props13.height,height=_props13$height===undefined?__WEBPACK_IMPORTED_MODULE_19__contants__["o" /* DEFAULT_TABLE_HEIGHT */]:_props13$height,selectedRowCount=_props13.selectedRowCount,_props13$autoSearch=_props13.autoSearch,autoSearch=_props13$autoSearch===undefined?true:_props13$autoSearch,searchBarSpan=_props13.searchBarSpan;var _state13=this.state,uuid=_state13.uuid,cols=_state13.cols,gridKeyForRefresh=_state13.gridKeyForRefresh,scrollTop=_state13.scrollTop,gridScrollbarWidth=_state13.gridScrollbarWidth,populatedRows=_state13.populatedRows,queriedRows=_state13.queriedRows,isResizing=_state13.isResizing,colWidths=_state13.colWidths,pageSize=_state13.pageSize,pageNum=_state13.pageNum,isPaginating=_state13.isPaginating,viewStartIdx=_state13.viewStartIdx,viewEndIdx=_state13.viewEndIdx,viewIndexesUpdateTimeout=_state13.viewIndexesUpdateTimeout,searchText=_state13.searchText;var currentPageIndexes=Object(__WEBPACK_IMPORTED_MODULE_20__utils__["a" /* getIndexesFromPaginationParams */])(pageSize||__WEBPACK_IMPORTED_MODULE_19__contants__["n" /* DEFAULT_PAGE_SIZE */],pageNum||__WEBPACK_IMPORTED_MODULE_19__contants__["m" /* DEFAULT_PAGE_NUM */]);var colWidthsSum=__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.sum(colWidths);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table infinite-scroll-table__"+uuid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pre_header__["a" /* default */],{searchText:searchText,autoSearch:autoSearch,onSearch:this.onSearchTextChange,selectedRowCount:selectedRowCount?selectedRowCount:this.getSelectedRowKeys().length,tableActions:this.getNormalizedTableActions(),renderTableAction:function renderTableAction(action){return _this12.renderTableAction(action,populatedRows);},leftActions:leftActions,rightActions:rightActions,searchBarSpan:searchBarSpan}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,showHeader&&(isResizing?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table__header-placeholder",style:{height:__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */]}}):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table__header",style:{height:__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */]}},queriedRows!==null?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table__header__cells-container"},this.renderHeaderCells(cols,colWidths,queriedRows)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table__header__scrollbar-padding",style:{width:gridScrollbarWidth,height:__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */]}})):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table__header-placeholder",style:{height:__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */],width:size.width}}))),isResizing||queriedRows===null||queriedRows.length===0?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{style:{height:height},className:"infinite-scroll-table__grid-container-placeholder"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__custom_empty__["a" /* default */],{width:!isResizing&&queriedRows!==null?colWidthsSum:undefined,text:isResizing?t('components.infiniteScroll.placeholder.resizing'):queriedRows===null?t('components.infiniteScroll.placeholder.updating'):undefined,backgroundColor:__WEBPACK_IMPORTED_MODULE_19__contants__["x" /* TABLE_PLACEHOLDER_BGCOLOR */],image:isResizing?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:"loading",style:{marginTop:48,fontSize:48,color:"grey"},spin:true}):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",null)})):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:"infinite-scroll-table__grid-container",style:{position:"relative",height:height}},isPaginating&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{style:{position:"absolute",width:Math.min(colWidthsSum,size.width),height:height}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__custom_empty__["a" /* default */],{text:t('components.infiniteScroll.placeholder.updating'),backgroundColor:__WEBPACK_IMPORTED_MODULE_19__contants__["x" /* TABLE_PLACEHOLDER_BGCOLOR */]})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_window__["b" /* VariableSizeList */],{ref:this.listRef,className:"infinite-scroll-table__grid",key:gridKeyForRefresh,width:size.width,height:height,estimatedItemSize:__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */],itemSize:function itemSize(index){return!isPaginated||!isPaginating&&currentPageIndexes.startIdx<=index&&index<=currentPageIndexes.stopIdx&&index-currentPageIndexes.startIdx<queriedRows.length?queriedRows[isPaginated?index-currentPageIndexes.startIdx:index][__WEBPACK_IMPORTED_MODULE_19__contants__["i" /* DATA_INDEX_HEIGHT */]]:__WEBPACK_IMPORTED_MODULE_19__contants__["v" /* ROW_HEIGHT */];},itemCount:rowCount||queriedRows.length,initialScrollOffset:scrollTop,onItemsRendered:function onItemsRendered(_ref){var visibleStartIndex=_ref.visibleStartIndex,visibleStopIndex=_ref.visibleStopIndex,overscanStartIndex=_ref.overscanStartIndex,overscanStopIndex=_ref.overscanStopIndex;return _this12.onRenderedRowsChange(visibleStartIndex,visibleStopIndex,overscanStartIndex,overscanStopIndex);}},function(_ref2){var index=_ref2.index,style=_ref2.style;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{style:Object.assign({},style,{width:colWidthsSum}),className:"infinite-scroll-table__grid__row infinite-scroll-table__grid__row--"+(index%2?'odd':'even')},!isPaginated||!isPaginating&&currentPageIndexes.startIdx<=index&&index<=currentPageIndexes.stopIdx&&index-currentPageIndexes.startIdx<queriedRows.length?queriedRows[isPaginated?index-currentPageIndexes.startIdx:index][__WEBPACK_IMPORTED_MODULE_19__contants__["l" /* DATA_INDEX_RENDERED */]]:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",null));})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__footer__["a" /* default */],{isHidden:queriedRows===null||queriedRows.length===0,isLoading:isPaginating||viewIndexesUpdateTimeout,rowNumStart:viewStartIdx+1,rowNumEnd:viewEndIdx+1,rowCount:rowCount||(queriedRows?queriedRows.length:null)})));}}],[{key:"isValuePassingSearchText",value:function isValuePassingSearchText(value,searchText){return String(value).toLowerCase().includes(searchText.toLowerCase());}},{key:"isArrayPropertyChangedLazy",value:function isArrayPropertyChangedLazy(prevProp,prop){return prevProp!==prop||(prevProp===null||prevProp===undefined)&&prop!==null&&prop!==undefined||prevProp&&prop&&prevProp.length!==prop.length;}}]);return InfiniteScrollTable;}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);InfiniteScrollTable.defaultSorter=function(a,b,isDesc){var normalize=function normalize(val){return typeof val==="string"?val.toLowerCase():Number(val);};var _a=normalize(a);var _b=normalize(b);return(isDesc?_b<_a:_a<_b)?-1:1;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_23_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_26_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_24_react_sizeme__["withSize"])(),Object(__WEBPACK_IMPORTED_MODULE_28__contexts_DataLanguage__["c" /* withDataLanguage */])(),Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(function(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};}))(InfiniteScrollTable));

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getFilterObjFromViewerObj;
/* harmony export (immutable) */ __webpack_exports__["e"] = getFilterStrFromViewerObj;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFilterObjFromStr; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getServerQueryObj;
/* harmony export (immutable) */ __webpack_exports__["d"] = getFilterStrFromServerQueryObj;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFilterStrFromObj; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getFilterObjFromViewerObj(colNames,searchText,filters){var res=[];if(colNames&&colNames.length>0){if(filters){Object.keys(filters).forEach(function(colName){if(filters[colName]){res.push({colName:colName,oper:"LIKE",val:filters[colName],isAnd:true});}});}if(searchText&&searchText.length>0){colNames.forEach(function(colName){return res.push({colName:colName,oper:"LIKE",val:searchText,isAnd:false});});}}return res;}function getFilterStrFromViewerObj(colNames,searchText,filters,prevFilter){var filtersStr="";var searchTextStr="";if(colNames&&colNames.length>0){if(filters){var filtersArr=Object.keys(filters).filter(function(colName){return filters[colName];});filtersArr.forEach(function(colName,index){if(index===0){filtersStr+="(";}else{filtersStr+=' AND ';}filtersStr+=colName+" LIKE '%"+filters[colName]+"%'";if(index===filtersArr.length-1){filtersStr+=")";}});}if(searchText&&searchText.length>0){colNames.forEach(function(colName,index){if(index===0){searchTextStr+="(";}else{searchTextStr+=' OR ';}searchTextStr+=colName+" LIKE '%"+searchText+"%'";if(index===colNames.length-1){searchTextStr+=")";}});}}return[prevFilter,filtersStr,searchTextStr].filter(function(str){return str.length>0;}).join(" AND ");}var getFilterObjFromStr=function getFilterObjFromStr(filterStr,removeId_){var res=[];if(filterStr!==null&&filterStr.length>0){filterStr.split(') AND (')// ottengo i blocchi
.map(function(block,index,arr){if(arr.length===1){return block.substr(1,block.length-2);}else if(index===0){return block.substr("1");}else if(index===arr.length-1){return block.substr(0,block.length-1);}else return block;}).map(function(block){return block// rimuovo parentesi IN e NOT IN
.replace('(','').replace(')','');}).map(function(block){return block.indexOf(" IN ")>=0?block:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.chunk(block.split(" "),4);})// gruppi: <colonna> <op_confronto> <valore> [<op_logico>]
.forEach(function(block){if(block.indexOf(" IN ")>=0){res.push({column:removeId_?block.split(" ")[0].replace("ID_",""):block.split(" ")[0],conditions:[{comparisonOperator:block.indexOf(" NOT IN ")>=0?"NOT IN":"IN",value:block.split(" IN ")[1].split(",").map(function(val){return val.replace("'","").replace("'","");})}],logicalOperator:"AND"});}else{var firstCol=block[0][0];var i=1;var equalCols=true;while(block[i]&&equalCols){if(block[i][0]!==firstCol){equalCols=false;}else{i++;}}i=0;var isOr=true;while(block[i]&&isOr){if(block[i][3]==='AND'){isOr=false;}else{i++;}}if(equalCols){res.push({column:removeId_?block[0][0].replace("ID_",""):block[0][0],conditions:// ottengo op. confronto e valore da ogni gruppo
block.map(function(_ref){var _ref2=_slicedToArray(_ref,3),comparisonOperator=_ref2[1],value=_ref2[2];return{comparisonOperator:comparisonOperator,value:value.replace("'","").replace("'","")};}),logicalOperator:block[0].length===4?block[0][3]:'AND'// op. logico
});}else{block.forEach(function(b){return res.push({column:removeId_?b[0].replace("ID_",""):b[0],conditions:[{comparisonOperator:b[1],value:b[2].replace("'","").replace("'","")}],isOr:isOr,logicalOperator:b.length===4?b[3]:'AND'// op. logico
});});}}});}return res;};function getServerQueryObj(selCols,filterObj,pageNum,pageSize,sortCols,sortByDesc,idCube,idDataflow){var res={Filter:{FiltersGroupAnd:{},FiltersGroupOr:{}},SqlData:{SelCols:selCols,SortCols:sortCols,SortByDesc:sortByDesc,NumPage:pageNum,PageSize:pageSize},iDDataflow:idDataflow,iDCube:idCube};var index=0;if(filterObj){filterObj.filter(function(_ref3){var isOr=_ref3.isOr;return!isOr;}).forEach(function(_ref4){var column=_ref4.column,conditions=_ref4.conditions,logicalOperator=_ref4.logicalOperator;res.Filter.FiltersGroupAnd[index++]=conditions.filter(function(_ref5){var isOr=_ref5.isOr;return!isOr;}).map(function(_ref6){var comparisonOperator=_ref6.comparisonOperator,value=_ref6.value;return{ColumnName:column,Operator:comparisonOperator,FilterValues:Array.isArray(value)?value:[value],WhereAndOr:logicalOperator,ColumnType:"string"};});});filterObj.filter(function(_ref7){var isOr=_ref7.isOr;return isOr;}).forEach(function(_ref8){var _res$Filter$FiltersGr;var column=_ref8.column,conditions=_ref8.conditions;if(!res.Filter.FiltersGroupAnd[index]){res.Filter.FiltersGroupAnd[index]=[];}(_res$Filter$FiltersGr=res.Filter.FiltersGroupAnd[index]).push.apply(_res$Filter$FiltersGr,_toConsumableArray(conditions.filter(function(_ref9){var isOr=_ref9.isOr;return!isOr;}).map(function(_ref10){var comparisonOperator=_ref10.comparisonOperator,value=_ref10.value;return{ColumnName:column,Operator:comparisonOperator,FilterValues:Array.isArray(value)?value:[value],WhereAndOr:"OR",ColumnType:"string"};})));});}return res;}function getFilterStrFromServerQueryObj(obj){var res="";if(obj.FiltersGroupAnd){Object.keys(obj.FiltersGroupAnd).forEach(function(key,index){if(index>0){res+=" AND ";}obj.FiltersGroupAnd[key].forEach(function(_ref11,index){var ColumnName=_ref11.ColumnName,Operator=_ref11.Operator,FilterValues=_ref11.FilterValues,WhereAndOr=_ref11.WhereAndOr;if(index===0){res+="(";}res+=index>0&&WhereAndOr!==null?" "+(WhereAndOr==='AND'?'AND':'OR')+" ":'';res+=ColumnName+' ';res+=Operator+' ';res+=Operator.includes("IN")?'('+FilterValues.map(function(v){return"'"+v+"'";}).join(',')+')':"'"+(FilterValues[0]===''?"''":FilterValues[0])+"'";if(index===obj.FiltersGroupAnd[key].length-1){res+=")";}});});}return res;}var getFilterStrFromObj=function getFilterStrFromObj(filterObj,columns){return filterObj!==null&&columns!==null?filterObj.filter(function(_ref12){var conditions=_ref12.conditions;return conditions!==null&&conditions.filter(function(_ref13){var value=_ref13.value;return value!==null&&String(value).length>0;}).length>0;}).map(function(_ref14){var column=_ref14.column,conditions=_ref14.conditions,logicalOperator=_ref14.logicalOperator;return'('+conditions.filter(function(_ref15){var value=_ref15.value;return value!==null&&String(value).length>0;}).map(function(_ref16){var comparisonOperator=_ref16.comparisonOperator,value=_ref16.value;return column+' '+comparisonOperator+' '+(columns.filter(function(_ref17){var name=_ref17.name;return name===column;})[0].isNumeric?value:"'"+value+"'");}).map(function(condition,index){return index>0?" "+logicalOperator+" "+condition:condition;}).join('')+')';}).map(function(block,index){return index>0?" AND "+block:block;}).join(''):'';};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var iconStyle={cursor:'pointer'};/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var Selector=function(_React$Component){_inherits(Selector,_React$Component);function Selector(props){_classCallCheck(this,Selector);var _this=_possibleConstructorReturn(this,(Selector.__proto__||Object.getPrototypeOf(Selector)).call(this,props));_this.state={value:null};_this.callOnChange=_this.callOnChange.bind(_this);return _this;}_createClass(Selector,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){this.props.onChange(value);}}//
// componentDidUpdate(prevProps) {
//   if (prevProps.value !== this.props.value) {
//     this.callOnChange(this.props.value);
//   }
// }
},{key:'render',value:function render(){var _props=this.props,disabled=_props.disabled,detailTitle=_props.detailTitle,selectTitle=_props.selectTitle,resetTitle=_props.resetTitle,onDetail=_props.onDetail,onSelect=_props.onSelect,onReset=_props.onReset,render=_props.render,size=_props.size,style=_props.style;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{style:style,size:size,value:render?render(value):value,title:render?render(value):value,onChange:function onChange(f){return f;},disabled:disabled,addonBefore:onDetail&&value!==null&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'file-text',onClick:onDetail,title:detailTitle,style:iconStyle}),addonAfter:!disabled&&(value!==null?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'close',onClick:onReset,title:resetTitle,style:iconStyle}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'plus',onClick:onSelect,title:selectTitle,style:iconStyle}))});}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,state){if(nextProps.value!==state.value){return{value:nextProps.value};}else{return null;}}}]);return Selector;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Selector);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DOWNLOAD_FORMAT_TYPE_STRUCTURE */
/* unused harmony export DOWNLOAD_FORMAT_TYPE_STRUCTURE20 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DOWNLOAD_FORMAT_TYPE_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DOWNLOAD_FORMAT_TYPE_SDMXCSV; });
/* unused harmony export DOWNLOAD_FORMAT_TYPE_RTF */
/* unused harmony export DOWNLOAD_FORMAT_TYPE_RDF */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DOWNLOAD_FORMAT_TYPE_GENERIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DOWNLOAD_FORMAT_TYPE_GENERIC20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DOWNLOAD_FORMAT_TYPE_COMPACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DOWNLOAD_FORMAT_TYPE_JSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARTEFACT_TYPE_CODELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARTEFACT_TYPE_CATEGORY_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ARTEFACT_TYPE_CONCEPT_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARTEFACT_TYPE_AGENCY_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ARTEFACT_TYPE_DATAFLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ARTEFACT_TYPE_METADATAFLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ARTEFACT_TYPE_DSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ARTEFACT_TYPE_MSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ARTEFACT_TYPE_HIERARCHICAL_CODELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ARTEFACT_TYPE_CONTENT_CONSTRAINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ARTEFACT_TYPE_DDBDATAFLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ARTEFACT_TYPE_MULTIPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getArtefactDownloadOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getArtefactDownloadFileSaveNameAndType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__ = __webpack_require__(10);
var DOWNLOAD_FORMAT_TYPE_STRUCTURE="structure";var DOWNLOAD_FORMAT_TYPE_STRUCTURE20="structure20";var DOWNLOAD_FORMAT_TYPE_CSV="csv";var DOWNLOAD_FORMAT_TYPE_SDMXCSV="sdmxcsv";var DOWNLOAD_FORMAT_TYPE_RTF="rtf";var DOWNLOAD_FORMAT_TYPE_RDF="rdf";var DOWNLOAD_FORMAT_TYPE_GENERIC="genericdata";var DOWNLOAD_FORMAT_TYPE_GENERIC20="genericdata20";var DOWNLOAD_FORMAT_TYPE_COMPACT="compactdata";var DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC="structurespecificdata";var DOWNLOAD_FORMAT_TYPE_JSON="jsondata";var DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM="customcsv";var ARTEFACT_TYPE_CODELIST="codelist";var ARTEFACT_TYPE_CATEGORY_SCHEME="categoryScheme";var ARTEFACT_TYPE_CONCEPT_SCHEME="conceptScheme";var ARTEFACT_TYPE_AGENCY_SCHEME="agencyScheme";var ARTEFACT_TYPE_DATAFLOW="dataflow";var ARTEFACT_TYPE_METADATAFLOW="metadataflow";var ARTEFACT_TYPE_DSD="dsd";var ARTEFACT_TYPE_MSD="msd";var ARTEFACT_TYPE_HIERARCHICAL_CODELIST="hierarchicalCodelist";var ARTEFACT_TYPE_CONTENT_CONSTRAINT="contentConstraint";var ARTEFACT_TYPE_DDBDATAFLOW="ddbdataflow";var ARTEFACT_TYPE_MULTIPLE="multipleArtefacts";var getArtefactDownloadOptions=function getArtefactDownloadOptions(t,artefactType){switch(artefactType){case ARTEFACT_TYPE_CODELIST:case ARTEFACT_TYPE_CATEGORY_SCHEME:case ARTEFACT_TYPE_CONCEPT_SCHEME:case ARTEFACT_TYPE_AGENCY_SCHEME:return[{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE,label:t("data.artefact.downloadFormat.structure.label")},{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE20,label:t("data.artefact.downloadFormat.structure20.label")},{key:DOWNLOAD_FORMAT_TYPE_CSV,label:t("data.artefact.downloadFormat.csv.label")},{key:DOWNLOAD_FORMAT_TYPE_JSON,label:t("data.artefact.downloadFormat.json.label")},{key:DOWNLOAD_FORMAT_TYPE_RDF,label:t("data.artefact.downloadFormat.rdf.label")}];case ARTEFACT_TYPE_DATAFLOW:return[{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE,label:t("data.artefact.downloadFormat.structure.label")},{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE20,label:t("data.artefact.downloadFormat.structure20.label")},{key:DOWNLOAD_FORMAT_TYPE_JSON,label:t("data.artefact.downloadFormat.json.label")},{key:DOWNLOAD_FORMAT_TYPE_RDF,label:t("data.artefact.downloadFormat.rdf.label")}];case ARTEFACT_TYPE_METADATAFLOW:return[{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE,label:t("data.artefact.downloadFormat.structure.label")},{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE20,label:t("data.artefact.downloadFormat.structure20.label")},{key:DOWNLOAD_FORMAT_TYPE_JSON,label:t("data.artefact.downloadFormat.json.label")}];case ARTEFACT_TYPE_DSD:return[{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE,label:t("data.artefact.downloadFormat.structure.label")},{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE20,label:t("data.artefact.downloadFormat.structure20.label")},{key:DOWNLOAD_FORMAT_TYPE_JSON,label:t("data.artefact.downloadFormat.json.label")},{key:DOWNLOAD_FORMAT_TYPE_RDF,label:t("data.artefact.downloadFormat.rdf.label")},{key:DOWNLOAD_FORMAT_TYPE_RTF,label:t("data.artefact.downloadFormat.rtf.label")}];case ARTEFACT_TYPE_MSD:return[{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE,label:t("data.artefact.downloadFormat.structure.label")},{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE20,label:t("data.artefact.downloadFormat.structure20.label")},{key:DOWNLOAD_FORMAT_TYPE_JSON,label:t("data.artefact.downloadFormat.json.label")}];case ARTEFACT_TYPE_HIERARCHICAL_CODELIST:return[{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE,label:t("data.artefact.downloadFormat.structure.label")},{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE20,label:t("data.artefact.downloadFormat.structure20.label")}];case ARTEFACT_TYPE_CONTENT_CONSTRAINT:return[{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE,label:t("data.artefact.downloadFormat.structure.label")},{key:DOWNLOAD_FORMAT_TYPE_JSON,label:t("data.artefact.downloadFormat.json.label")}];case ARTEFACT_TYPE_DDBDATAFLOW:return[{key:DOWNLOAD_FORMAT_TYPE_GENERIC,label:t("data.artefact.downloadFormat.generic.label")},{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC,label:t("data.artefact.downloadFormat.structureSpecific.label")},{key:DOWNLOAD_FORMAT_TYPE_GENERIC20,label:t("data.artefact.downloadFormat.generic20.label")},{key:DOWNLOAD_FORMAT_TYPE_COMPACT,label:t("data.artefact.downloadFormat.compact.label")},{key:DOWNLOAD_FORMAT_TYPE_SDMXCSV,label:t("data.artefact.downloadFormat.sdmxCsv.label")},{key:DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM,label:t("data.artefact.downloadFormat.csvCustom.label")},{key:DOWNLOAD_FORMAT_TYPE_JSON,label:t("data.artefact.downloadFormat.sdmxJson.label")},{key:DOWNLOAD_FORMAT_TYPE_RDF,label:t("data.artefact.downloadFormat.rdf.label")}];case ARTEFACT_TYPE_MULTIPLE:return[{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE,label:t("data.artefact.downloadFormat.structure.label")},{key:DOWNLOAD_FORMAT_TYPE_STRUCTURE20,label:t("data.artefact.downloadFormat.structure20.label")}];default:return[];}};var getArtefactDownloadExtension=function getArtefactDownloadExtension(artefactFormat,isCompressed){if(isCompressed){return"zip";}switch(artefactFormat){case DOWNLOAD_FORMAT_TYPE_STRUCTURE:case DOWNLOAD_FORMAT_TYPE_STRUCTURE20:case DOWNLOAD_FORMAT_TYPE_GENERIC:case DOWNLOAD_FORMAT_TYPE_GENERIC20:case DOWNLOAD_FORMAT_TYPE_COMPACT:case DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC:return"xml";case DOWNLOAD_FORMAT_TYPE_CSV:case DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM:case DOWNLOAD_FORMAT_TYPE_SDMXCSV:return"csv";case DOWNLOAD_FORMAT_TYPE_RTF:return"rtf";case DOWNLOAD_FORMAT_TYPE_RDF:return"rdf";case DOWNLOAD_FORMAT_TYPE_JSON:return"json";default:return artefactFormat;}};var getArtefactDownloadFileSaveNameAndType=function getArtefactDownloadFileSaveNameAndType(artefactTriplets,artefactType,artefactFormat,isCompressed,lang){var currDate=__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD_HH-mm-ss');var ext=getArtefactDownloadExtension(artefactFormat,isCompressed);return{name:artefactTriplets&&artefactTriplets.length>1?artefactType+"s_"+currDate+"."+ext:""+Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(artefactTriplets[0])+(""+(artefactType===ARTEFACT_TYPE_DDBDATAFLOW?"_"+currDate:''))+(""+(artefactFormat===DOWNLOAD_FORMAT_TYPE_CSV?"_"+lang.toUpperCase():''))+("."+ext),type:isCompressed?"application/zip":"text/plain;charset=utf-8"};};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTO_ANNOTATION_NONPRODUCTIONDATAFLOW_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateItemOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return itemsOrderCompare; });
/* unused harmony export isAutoAnnotation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFilteredAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAutoAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return normalizeDsdComponentsOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return existsComponentWithId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getItemOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSQLItemFromItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOrderedChildren; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var AUTO_ANNOTATION_KEYS=["categorySchemesOrder","conceptSchemesOrder","categorisationsOrder","codelistsOrder","associatedCube","changed","customDSD","ddbDataflow","haveMetadata","metadataset","customIsPresentational","virtualDataflowNode","lastUpdate","AnnotationServiceURL","AnnotationStructureURL","dataflowCatalogType"];var AUTO_ANNOTATION_NONPRODUCTIONDATAFLOW_TYPE="nonproductiondataflow";var updateItemOrder=function updateItemOrder(item,order,itemsOrderAnnotationType,lang){item.order?item.order[lang]=order:item.order=_defineProperty({},lang,order);if(itemsOrderAnnotationType){if(item.autoAnnotations){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(item.autoAnnotations,function(annotation){return annotation.type===itemsOrderAnnotationType;})){__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(item.autoAnnotations,function(annotation){return annotation.type===itemsOrderAnnotationType;}).text[lang]=order;}else{item.autoAnnotations.push({type:itemsOrderAnnotationType,text:_defineProperty({},lang,order)});}}else{item.autoAnnotations=[{type:itemsOrderAnnotationType,text:_defineProperty({},lang,order)}];}}};var itemsOrderCompare=function itemsOrderCompare(a,b,lang){if(Number(a.order[lang])>Number(b.order[lang])){return 1;}if(Number(a.order[lang])<Number(b.order[lang])){return-1;}return 0;};var isAutoAnnotation=function isAutoAnnotation(annotation,annotationsConfig){var autoAnnotationTypes=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatMap(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(annotationsConfig,AUTO_ANNOTATION_KEYS)).concat(AUTO_ANNOTATION_NONPRODUCTIONDATAFLOW_TYPE).map(function(annot){return annot.toLowerCase();});return annotation.type&&autoAnnotationTypes.includes(annotation.type.toLowerCase());};var getFilteredAnnotations=function getFilteredAnnotations(annotations,annotationsConfig,customIsAutoAnnotation){return annotations&&annotations.length>0?annotations.filter(function(annotation){return customIsAutoAnnotation?!customIsAutoAnnotation(annotation,annotationsConfig):!isAutoAnnotation(annotation,annotationsConfig);}):[];};var getAutoAnnotations=function getAutoAnnotations(annotations,annotationsConfig,customIsAutoAnnotation){return annotations&&annotations.length>0?annotations.filter(function(annotation){return customIsAutoAnnotation?customIsAutoAnnotation(annotation,annotationsConfig):isAutoAnnotation(annotation,annotationsConfig);}):[];};var normalizeDsdComponentsOrder=function normalizeDsdComponentsOrder(components,componentId){return components?components.map(function(comp){return Object.assign({},comp,{order:comp.order?Number(comp.order):null});}).sort(function(a,b){if(a.order===b.order){if(a.id===componentId){return-1;}else if(b.id===componentId)return 1;else{return a.id-b.id;}}else if(a.order!==null&&b.order===null){return-1;}else if(a.order===null&&b.order!==null){return 1;}else{return a.order-b.order;}}).map(function(comp,idx){return Object.assign({},comp,{order:idx+1});}):null;};var existsComponentWithId=function existsComponentWithId(dsd,id){return Boolean([dsd.primaryMeasure].concat(_toConsumableArray(dsd.dimensions||[]),_toConsumableArray(dsd.groups||[]),_toConsumableArray(dsd.attributes||[])).find(function(component){return component.id===id;}));};var getItemOrder=function getItemOrder(item,orderAnnotationType){return(item.annotations.find(function(annot){return annot.type&&annot.type===orderAnnotationType;})||[]).texts;};var getSQLItemFromItem=function getSQLItemFromItem(item,lang,autoSave,itemsOrderAnnotationType){var annotations=item.annotations&&item.annotations.length>0?item.annotations.filter(function(annot){return!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(annot)&&annot.type!==itemsOrderAnnotationType;}).map(function(annot){return{id:annot.id?annot.id:undefined,title:annot.title?annot.title:undefined,type:annot.type?annot.type:undefined,texts:annot.text?__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(annot.text,function(val){return val.length>0;}):undefined// fix after sdmx-source update 1.17
};}):[];var autoAnnotations=item.autoAnnotations&&item.autoAnnotations.length>0?item.autoAnnotations.filter(function(annot){return!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(annot)&&annot.type!==itemsOrderAnnotationType;}).map(function(annot){return{id:annot.id?annot.id:undefined,title:annot.title?annot.title:undefined,type:annot.type?annot.type:undefined,texts:annot.text?__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(annot.text,function(val){return val.length>0;}):undefined// fix after sdmx-source update 1.17
};}):[];annotations=annotations.concat(autoAnnotations);var name=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.name,function(val){return val.length>0;});var description=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.description,function(val){return val.length>0;});var order=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(item.order,function(val){return val.length>0;});return{itemCode:item.id,parent:item.parent?item.parent:undefined,name:name&&name[lang]?name[lang]:undefined,names:name,desc:description&&description[lang]?description[lang]:undefined,descs:!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(description)?description:undefined,treePosition:order&&order[lang]?order[lang]:undefined,order:!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(order)?order:undefined,annotations:annotations.length>0?annotations:undefined,autoSave:autoSave};};var getOrderedChildren=function getOrderedChildren(categories,parentId,lang,itemsOrderAnnotationType){var orderedChilds=[];var childs=[];categories&&categories.forEach(function(child){if(child.autoAnnotations&&itemsOrderAnnotationType){var orderAnnotations=child.autoAnnotations.find(function(annotation){return annotation.type===itemsOrderAnnotationType;});orderAnnotations&&orderAnnotations.text&&orderAnnotations.text[lang]&&!isNaN(orderAnnotations.text[lang])?orderedChilds.push(Object.assign({},child,{order:orderAnnotations.text,parent:parentId})):childs.push(Object.assign({},child,{parent:parentId}));}else{childs.push(Object.assign({},child,{parent:parentId}));}});orderedChilds.sort(function(a,b){return itemsOrderCompare(a,b,lang);});return orderedChilds.concat(childs);};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(397);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1030);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Group", {
  enumerable: true,
  get: function get() {
    return _group["default"];
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _radioButton["default"];
  }
});
exports["default"] = void 0;

var _radio = _interopRequireDefault(__webpack_require__(322));

var _group = _interopRequireDefault(__webpack_require__(1031));

var _radioButton = _interopRequireDefault(__webpack_require__(1032));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_radio["default"].Button = _radioButton["default"];
_radio["default"].Group = _group["default"];
var _default = _radio["default"];
exports["default"] = _default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1066);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(38));

var _rcAnimate = _interopRequireDefault(__webpack_require__(102));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(479));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function noop() {}

var Alert =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Alert, _React$Component);

  function Alert() {
    var _this;

    _classCallCheck(this, Alert);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Alert).apply(this, arguments));
    _this.state = {
      closing: true,
      closed: false
    };

    _this.handleClose = function (e) {
      e.preventDefault();
      var dom = ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
      dom.style.height = "".concat(dom.offsetHeight, "px"); // Magic code
      // 重复一次后才能正确设置 height

      dom.style.height = "".concat(dom.offsetHeight, "px");

      _this.setState({
        closing: false
      });

      (_this.props.onClose || noop)(e);
    };

    _this.animationEnd = function () {
      _this.setState({
        closed: true,
        closing: true
      });

      (_this.props.afterClose || noop)();
    };

    _this.renderAlert = function (_ref) {
      var _classNames, _classNames2;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          description = _this$props.description,
          customizePrefixCls = _this$props.prefixCls,
          message = _this$props.message,
          closeText = _this$props.closeText,
          banner = _this$props.banner,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          style = _this$props.style,
          icon = _this$props.icon;
      var _this$props2 = _this.props,
          closable = _this$props2.closable,
          type = _this$props2.type,
          showIcon = _this$props2.showIcon,
          iconType = _this$props2.iconType;
      var prefixCls = getPrefixCls('alert', customizePrefixCls); // banner模式默认有 Icon

      showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告

      type = banner && type === undefined ? 'warning' : type || 'info';
      var iconTheme = 'filled'; // should we give a warning?
      // warning(!iconType, `The property 'iconType' is deprecated. Use the property 'icon' instead.`);

      if (!iconType) {
        switch (type) {
          case 'success':
            iconType = 'check-circle';
            break;

          case 'info':
            iconType = 'info-circle';
            break;

          case 'error':
            iconType = 'close-circle';
            break;

          case 'warning':
            iconType = 'exclamation-circle';
            break;

          default:
            iconType = 'default';
        } // use outline icon in alert with description


        if (!!description) {
          iconTheme = 'outlined';
        }
      } // closeable when closeText is assigned


      if (closeText) {
        closable = true;
      }

      var alertCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-close"), !_this.state.closing), _defineProperty(_classNames, "".concat(prefixCls, "-with-description"), !!description), _defineProperty(_classNames, "".concat(prefixCls, "-no-icon"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-banner"), !!banner), _defineProperty(_classNames, "".concat(prefixCls, "-closable"), closable), _classNames), className);
      var closeIcon = closable ? React.createElement("a", {
        onClick: _this.handleClose,
        className: "".concat(prefixCls, "-close-icon")
      }, closeText || React.createElement(_icon["default"], {
        type: "close"
      })) : null;
      var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(_this.props);
      var iconNode = icon && (React.isValidElement(icon) ? React.cloneElement(icon, {
        className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, icon.props.className, icon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-icon"), true), _classNames2))
      }) : React.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, icon)) || React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: iconType,
        theme: iconTheme
      });
      return _this.state.closed ? null : React.createElement(_rcAnimate["default"], {
        component: "",
        showProp: "data-show",
        transitionName: "".concat(prefixCls, "-slide-up"),
        onEnd: _this.animationEnd
      }, React.createElement("div", _extends({
        "data-show": _this.state.closing,
        className: alertCls,
        style: style
      }, dataOrAriaProps), showIcon ? iconNode : null, React.createElement("span", {
        className: "".concat(prefixCls, "-message")
      }, message), React.createElement("span", {
        className: "".concat(prefixCls, "-description")
      }, description), closeIcon));
    };

    return _this;
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderAlert);
    }
  }]);

  return Alert;
}(React.Component);

exports["default"] = Alert;

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return EL_MODE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return EL_MODE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return EL_STEP_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return EL_STEP_CONNECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return EL_STEP_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return EL_STEP_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return EL_STEP_STRUCTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return EL_STEP_DIMENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EL_STEP_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return EL_STEP_SEMANTIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return EL_STEP_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return EL_SOURCE_FORMAT_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EL_SOURCE_FORMAT_XLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EL_SOURCE_FORMAT_SDMX_EP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EL_SOURCE_FORMAT_DB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EL_COL_TYPE_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EL_COL_TYPE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EL_COL_TYPE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EL_COL_TYPE_TRANSLATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EL_COL_TYPE_IGNORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EL_DIMENSION_ROLE_FREQUENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EL_DIMENSION_ROLE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EL_DIMENSION_ROLE_TERRITORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EL_DIMENSION_ROLE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EL_DIMENSION_ROLE_GENERIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EL_ATTRIBUTE_REFERS_OBSERVATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EL_ATTRIBUTE_REFERS_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EL_ATTRIBUTE_REFERS_DATASET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return EL_SEMANTIC_CONCEPT_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return EL_SEMANTIC_CONCEPT_EXISTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EL_LOAD_CUBE_COMPONENT_TYPE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EL_LOAD_CUBE_COMPONENT_TYPE_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EL_LOAD_CUBE_COMPONENT_TYPE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return EL_LOAD_CUBE_COMPONENT_TYPE_TIME_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getDataImportStatusTranslation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getELDimensionRoleTranslations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getELAtributeRefersTranslations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getELSemanticConceptTypeTranslations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return newMapping; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var EL_MODE_CREATE="EL_MODE_CREATE";var EL_MODE_UPDATE="EL_MODE_UPDATE";var EL_STEP_DATA="EL_STEP_DATA";var EL_STEP_CONNECTION="EL_STEP_CONNECTION";var EL_STEP_FILTER="EL_STEP_FILTER";var EL_STEP_LOAD="EL_STEP_LOAD";var EL_STEP_STRUCTURE="EL_STEP_STRUCTURE";var EL_STEP_DIMENSIONS="EL_STEP_DIMENSIONS";var EL_STEP_ATTRIBUTES="EL_STEP_ATTRIBUTES";var EL_STEP_SEMANTIC="EL_STEP_SEMANTIC";var EL_STEP_MAPPING="EL_STEP_MAPPING";var EL_SOURCE_FORMAT_CSV="EL_SOURCE_FORMAT_CSV";var EL_SOURCE_FORMAT_XLS="EL_SOURCE_FORMAT_XLS";var EL_SOURCE_FORMAT_SDMX_EP="EL_SOURCE_FORMAT_SDMX_EP";var EL_SOURCE_FORMAT_DB="EL_SOURCE_FORMAT_DB";var EL_COL_TYPE_DIMENSION="EL_COL_TYPE_DIMENSION";var EL_COL_TYPE_MEASURE="EL_COL_TYPE_MEASURE";var EL_COL_TYPE_ATTRIBUTE="EL_COL_TYPE_ATTRIBUTE";var EL_COL_TYPE_TRANSLATION="EL_COL_TYPE_TRANSLATION";var EL_COL_TYPE_IGNORE="EL_COL_TYPE_IGNORE";var EL_DIMENSION_ROLE_FREQUENCY="EL_DIMENSION_ROLE_FREQUENCY";var EL_DIMENSION_ROLE_TIME="EL_DIMENSION_ROLE_TIME";var EL_DIMENSION_ROLE_TERRITORY="EL_DIMENSION_ROLE_TERRITORY";var EL_DIMENSION_ROLE_MEASURE="EL_DIMENSION_ROLE_MEASURE";var EL_DIMENSION_ROLE_GENERIC="EL_DIMENSION_ROLE_GENERIC";var EL_ATTRIBUTE_REFERS_OBSERVATION="EL_ATTRIBUTE_REFERS_OBSERVATION";var EL_ATTRIBUTE_REFERS_DIMENSION="EL_ATTRIBUTE_REFERS_DIMENSION";var EL_ATTRIBUTE_REFERS_DATASET="EL_ATTRIBUTE_REFERS_DATASET";var EL_SEMANTIC_CONCEPT_NEW="EL_SEMANTIC_CONCEPT_NEW";var EL_SEMANTIC_CONCEPT_EXISTING="EL_SEMANTIC_CONCEPT_EXISTING";var EL_LOAD_CUBE_COMPONENT_TYPE_ATTRIBUTE=0;var EL_LOAD_CUBE_COMPONENT_TYPE_DIMENSION=1;var EL_LOAD_CUBE_COMPONENT_TYPE_MEASURE=2;var EL_LOAD_CUBE_COMPONENT_TYPE_TIME_DIMENSION=3;var STARTED_STEP="STARTED";var CREATING_CUBE_STEP="CREATING_CUBE";var IMPORTING_DATA_STEP="IMPORTING_DATA";var CREATING_DATAFLOW_STEP="CREATING_DATAFLOW";var CREATING_MAPPING_STEP="CREATING_MAPPING";var PUBLISHING_DATAFLOW_STEP="PUBLISHING_DATAFLOW";var COMPLETED_STEP="COMPLETED";var TRASCODING_STEP="TRASCODING";var DOWNLOADING_DATA_STEP="DOWNLOADING_DATA";var getDataImportStatusTranslation=function getDataImportStatusTranslation(t){var translate=function translate(t){var _ref;return _ref={},_defineProperty(_ref,STARTED_STEP,t('components.easyLoading.dataImportStatus.STARTED')),_defineProperty(_ref,CREATING_CUBE_STEP,t('components.easyLoading.dataImportStatus.CREATING_CUBE')),_defineProperty(_ref,IMPORTING_DATA_STEP,t('components.easyLoading.dataImportStatus.IMPORTING_DATA')),_defineProperty(_ref,CREATING_DATAFLOW_STEP,t('components.easyLoading.dataImportStatus.CREATING_DATAFLOW')),_defineProperty(_ref,CREATING_MAPPING_STEP,t('components.easyLoading.dataImportStatus.CREATING_MAPPING')),_defineProperty(_ref,PUBLISHING_DATAFLOW_STEP,t('components.easyLoading.dataImportStatus.PUBLISHING_DATAFLOW')),_defineProperty(_ref,COMPLETED_STEP,t('components.easyLoading.dataImportStatus.COMPLETED')),_defineProperty(_ref,TRASCODING_STEP,t('components.easyLoading.dataImportStatus.TRASCODING')),_defineProperty(_ref,DOWNLOADING_DATA_STEP,t('components.easyLoading.dataImportStatus.DOWNLOADING_DATA')),_ref;};return translate(t!==undefined?t:function(str){return str;});};var getELDimensionRoleTranslations=function getELDimensionRoleTranslations(t){var translate=function translate(t){var _ref2;return _ref2={},_defineProperty(_ref2,EL_DIMENSION_ROLE_GENERIC,t('components.easyLoading.dimensions.table.dimension.role.generic')),_defineProperty(_ref2,EL_DIMENSION_ROLE_FREQUENCY,t('components.easyLoading.dimensions.table.dimension.role.frequency')),_defineProperty(_ref2,EL_DIMENSION_ROLE_TIME,t('components.easyLoading.dimensions.table.dimension.role.time')),_defineProperty(_ref2,EL_DIMENSION_ROLE_TERRITORY,t('components.easyLoading.dimensions.table.dimension.role.territory')),_defineProperty(_ref2,EL_DIMENSION_ROLE_MEASURE,t('components.easyLoading.dimensions.table.dimension.role.measure')),_ref2;};return translate(t!==undefined?t:function(str){return str;});};var getELAtributeRefersTranslations=function getELAtributeRefersTranslations(t){var translate=function translate(t){var _ref3;return _ref3={},_defineProperty(_ref3,EL_ATTRIBUTE_REFERS_OBSERVATION,t('components.easyLoading.attributes.table.refers.observation')),_defineProperty(_ref3,EL_ATTRIBUTE_REFERS_DIMENSION,t('components.easyLoading.attributes.table.refers.dimension')),_defineProperty(_ref3,EL_ATTRIBUTE_REFERS_DATASET,t('components.easyLoading.attributes.table.refers.dataset')),_ref3;};return translate(t!==undefined?t:function(str){return str;});};var getELSemanticConceptTypeTranslations=function getELSemanticConceptTypeTranslations(t){var translate=function translate(t){var _ref4;return _ref4={},_defineProperty(_ref4,EL_SEMANTIC_CONCEPT_NEW,t('components.easyLoading.semantic.table.conceptType.new')),_defineProperty(_ref4,EL_SEMANTIC_CONCEPT_EXISTING,t('components.easyLoading.semantic.table.conceptType.existing')),_ref4;};return translate(t!==undefined?t:function(str){return str;});};var newMapping={IDMapping:-1,Name:""};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return warning; });
/* harmony export (immutable) */ __webpack_exports__["d"] = format;
/* harmony export (immutable) */ __webpack_exports__["e"] = isEmptyValue;
/* unused harmony export isEmptyObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = complementError;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var formatRegExp = /%[sdj%]/g;

var warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var next = function next(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === objArrLength) {
      callback(results);
    }
  };
  objArrKeys.forEach(function (key) {
    var arr = objArr[key];
    if (firstFields.indexOf(key) !== -1) {
      asyncSerialArray(arr, func, next);
    } else {
      asyncParallelArray(arr, func, next);
    }
  });
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(target[s]) === 'object') {
          target[s] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TREE_FILTER_MAX_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TREE_NODE_KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTreeFilterStrFromObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTreeFilterObjFromStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertFilterStrWithSimpleFilterForTimePeriod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDateTimeStrFromTimePeriodColumnVal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTimePeriodColumnValFromDateTimeStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBestFrequency; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var TREE_FILTER_MAX_LENGTH=6400;var TREE_NODE_KEY_PREFIX='TREE_NODE_KEY_';var getTreeFilterStrFromObj=function getTreeFilterStrFromObj(filterObj,colNames){return filterObj&&Object.keys(filterObj).length>0&&colNames!==null?colNames.filter(function(name){return filterObj[name]!==undefined&&filterObj[name].values.length>0;}).map(function(name){return"("+name+" "+(filterObj[name].mode===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["o" /* FILTER_MODE_NOT_IN */]?"NOT IN":"IN")+" "+("("+filterObj[name].values.filter(function(val){return!(val&&val.startsWith(TREE_NODE_KEY_PREFIX));}).map(function(val){return"'"+val+"'";}).join(",")+"))");}).join(" AND "):'';};var getTreeFilterObjFromStr=function getTreeFilterObjFromStr(filterStr){var res={};if(filterStr!==null&&filterStr.length>0){var pairs=filterStr.split(') AND (').map(function(block,index,arr){var res=block;if(index===0){res=res.substr(1);}if(index===arr.length-1){res=res.substr(0,res.length-1);}return res;}).map(function(block){if(block.includes("TIME_PERIOD")){return{colName:block.includes("ID_TIME_PERIOD")?"ID_TIME_PERIOD":"TIME_PERIOD",mode:"IN",values:[block.includes(">=")?block.split(">= '")[1].split("'")[0]:null,block.includes("<=")?block.split("<= '")[1].split("'")[0]:null]};}else{return block.includes(" NOT IN ")?{colName:block.split(" NOT IN")[0],mode:"NOT IN",values:block.split(" NOT IN ")[1].substr(1,block.split(" NOT IN ")[1].length-2).split(",").map(function(val){return val.substr(1,val.length-2);})}:{colName:block.split(" IN ")[0],mode:"IN",values:block.split(" IN ")[1].substr(1,block.split(" IN ")[1].length-2).split(",").map(function(val){return val.substr(1,val.length-2);})};}});pairs.forEach(function(_ref){var colName=_ref.colName,mode=_ref.mode,values=_ref.values;return res[colName]={mode:mode,values:values};});}return res;};var convertFilterStrWithSimpleFilterForTimePeriod=function convertFilterStrWithSimpleFilterForTimePeriod(str){if(str.includes("TIME_PERIOD IN")){var colName=str.includes("ID_TIME_PERIOD")?"ID_TIME_PERIOD":"TIME_PERIOD";var replaceStart=str.indexOf(colName);var replaceEnd=replaceStart+str.substr(replaceStart).indexOf(")");var strToReplace=str.substr(replaceStart,replaceEnd-replaceStart+1);var from=strToReplace.split(",")[0].split("(")[1];var to=strToReplace.split(",")[1].split(")")[0];var fromStr=from!=="'null'"?colName+" >= "+from:null;var toStr=to!=="'null'"?colName+" <= "+to:null;if(fromStr&&toStr){return str.replace(strToReplace,fromStr+" AND "+toStr);}else if(fromStr){return str.replace(strToReplace,fromStr);}else{return str.replace(strToReplace,toStr);}}else{return str;}};var getDateTimeStrFromTimePeriodColumnVal=function getDateTimeStrFromTimePeriodColumnVal(val,isTo){var y=void 0,m=void 0,d=void 0;if(!val.includes("-")){// 2020
y=val;m=isTo?12:1;d=isTo?31:1;}else{y=Number(val.split("-")[0]);if(val.includes("Q")){// 2020-Q4
var q=Number(val.split("Q")[1]);if(isTo){m=q*3;d=q===2||q===3?30:31;}else{m=(q-1)*3+1;d=1;}}else if(val.includes("S")){// 2020-S2
var s=Number(val.split("S")[1]);if(isTo){m=s*6;d=s===1?30:31;}else{m=(s-1)*6+1;d=1;}}else{// 2020-12
m=Number(val.split("-")[1]);if(isTo){if(m===4||m===6||m===9||m===11){d=30;}else if(m===2){if(y%4===0&&y%100!==0||y%400===0){// leap year
d=29;}else{d=28;}}else{d=31;}}else{d=1;}}}return String(y).padStart(4,"0")+"-"+String(m).padStart(2,"0")+"-"+String(d).padStart(2,"0")+"T00:00:00.000Z";};var getTimePeriodColumnValFromDateTimeStr=function getTimePeriodColumnValFromDateTimeStr(str,freq){var _str$split$0$split=str.split("T")[0].split("-"),_str$split$0$split2=_slicedToArray(_str$split$0$split,2),y=_str$split$0$split2[0],m=_str$split$0$split2[1];if(freq==="A"){return y;}else if(freq==="S"){var res=y+"-S";if(Number(m)<=6){return res+"1";}else{return res+"2";}}else if(freq==="Q"){var _res=y+"-Q";if(Number(m)<=3){return _res+"1";}else if(Number(m)<=6){return _res+"2";}else if(Number(m)<=9){return _res+"3";}else{return _res+"4";}}else{return y+"-"+m;}};var getBestFrequency=function getBestFrequency(frequencies){if(!frequencies){return"A";}else if(frequencies.includes("M")){return"M";}else if(frequencies.includes("Q")){return"Q";}else if(frequencies.includes("S")){return"S";}else{return"A";}};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tooltip_style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tooltip__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_tree_style__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_tree_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_tree_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_tree__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_css__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__auto_search_input__ = __webpack_require__(468);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.jQuery;var IconFontCNIcon=__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a.createFromIconfontCN({scriptUrl:'./static/vendor/iconfont_cn/iconfont.js'});var MAX_TREE_SIZE_FOR_DEFAULT_EXPANDED_TREE=100;var EnhancedTree=function(_React$Component){_inherits(EnhancedTree,_React$Component);function EnhancedTree(props){_classCallCheck(this,EnhancedTree);var _this=_possibleConstructorReturn(this,(EnhancedTree.__proto__||Object.getPrototypeOf(EnhancedTree)).call(this,props));_this.state={searchText:'',expandedKeys:null,uuidClassName:__WEBPACK_IMPORTED_MODULE_24_uuid___default()(),showMoreKeyClicks:{},isPaginated:false,filteredTree:null,filteredTreeLength:null,scrollTop:null,selectedKeys:null};_this.getKeys=_this.getKeys.bind(_this);_this.getKey=_this.getKey.bind(_this);_this.getTitle=_this.getTitle.bind(_this);_this.getActions=_this.getActions.bind(_this);_this.getFilteredTree=_this.getFilteredTree.bind(_this);_this.getNode=_this.getNode.bind(_this);_this.getShowMoreNode=_this.getShowMoreNode.bind(_this);_this.removeDraggableFromShowMoreNodes=_this.removeDraggableFromShowMoreNodes.bind(_this);_this.countVisibleNodes=_this.countVisibleNodes.bind(_this);_this.addTitleToDisabledCheckbox=_this.addTitleToDisabledCheckbox.bind(_this);_this.onSelect=_this.onSelect.bind(_this);return _this;}_createClass(EnhancedTree,[{key:'removeDraggableFromShowMoreNodes',value:function removeDraggableFromShowMoreNodes(){$('.tree__node__show-more .draggable').removeAttr("draggable");}},{key:'addTitleToDisabledCheckbox',value:function addTitleToDisabledCheckbox(){var _this2=this;if(this.props.disabledCheckboxTitle){$('.custom-tree__tree-container__'+this.state.uuidClassName+' .ant-tree-checkbox-disabled').each(function(_,el){return $(el).attr('title',_this2.props.disabledCheckboxTitle);});}}},{key:'componentDidMount',value:function componentDidMount(){var filteredTree=this.getFilteredTree(this.state.searchText);this.setState({filteredTree:filteredTree,filteredTreeLength:this.countVisibleNodes(filteredTree),isPaginated:this.props.noPagination?false:this.countVisibleNodes(this.props.tree)>=this.props.minTreeNodesForPagination,expandedKeys:null,selectedKeys:this.props.selectedKeys});this.removeDraggableFromShowMoreNodes();this.addTitleToDisabledCheckbox();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props=this.props,expandSelectedOnTreeChange=_props.expandSelectedOnTreeChange,defaultSelectedKeys=_props.defaultSelectedKeys;var _state=this.state,uuidClassName=_state.uuidClassName,scrollTop=_state.scrollTop,filteredTree=_state.filteredTree,selectedKeys=_state.selectedKeys,expandedKeys=_state.expandedKeys;var newExpandedKeys=expandedKeys;if(this.state.expandedKeys===null&&this.props.tree!==null&&!this.props.defaultCollapsed){var treeKeys=this.getKeys(this.props.tree);newExpandedKeys=treeKeys.length>MAX_TREE_SIZE_FOR_DEFAULT_EXPANDED_TREE?[]:treeKeys;}if(scrollTop!==null&&filteredTree!==null){this.setState({scrollTop:null});$('.custom-tree__tree-container__'+uuidClassName).scrollTop(scrollTop);}if(prevProps.selectedKeys!==this.props.selectedKeys){this.setState({selectedKeys:this.props.selectedKeys});}if(prevProps.tree!==this.props.tree){var _filteredTree=this.getFilteredTree(this.state.searchText);if(scrollTop===null){this.setState({scrollTop:$('.custom-tree__tree-container__'+uuidClassName).scrollTop()});}if(expandSelectedOnTreeChange===true){newExpandedKeys=__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.uniq((newExpandedKeys||[]).concat(this.props.selectedKeys||selectedKeys||[]).concat(defaultSelectedKeys||[]));}this.setState({filteredTree:_filteredTree,filteredTreeLength:this.countVisibleNodes(_filteredTree),isPaginated:this.props.noPagination?false:this.countVisibleNodes(this.props.tree)>=this.props.minTreeNodesForPagination});}if(newExpandedKeys!==expandedKeys){this.setState({expandedKeys:newExpandedKeys});}this.removeDraggableFromShowMoreNodes();this.addTitleToDisabledCheckbox();if(this.props.onRenderComplete){this.props.onRenderComplete();}}},{key:'countVisibleNodes',value:function countVisibleNodes(tree){var _this3=this;return Object(__WEBPACK_IMPORTED_MODULE_25__utils_tree__["b" /* countNodes */])(tree,this.props.childrenKey,function(node){return _this3.props.hiddenKeys?!_this3.props.hiddenKeys.includes(_this3.getKey(node)):_this3.props.getNodeIsCounted?_this3.props.getNodeIsCounted(node):true;});}},{key:'getKey',value:function getKey(node){return this.props.getNodeKey!==undefined?this.props.getNodeKey(node):node[this.props.childrenKey]?node[this.props.catIdKey]||node[this.props.catNameKey]:node[this.props.idKey]||node[this.props.nameKey];}},{key:'getTitle',value:function getTitle(node,preferredLanguage){var _props2=this.props,idKey=_props2.idKey,nameKey=_props2.nameKey,catIdKey=_props2.catIdKey,catNameKey=_props2.catNameKey,hiddenIdKeys=_props2.hiddenIdKeys,hideIds=_props2.hideIds,unallowedIdKeys=_props2.unallowedIdKeys,dataLanguages=_props2.dataLanguages,childrenKey=_props2.childrenKey,getIsNameMultilanguage=_props2.getIsNameMultilanguage,getNodeTextColor=_props2.getNodeTextColor,getCatId=_props2.getCatId;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{style:(unallowedIdKeys&&unallowedIdKeys.indexOf(this.getKey(node)))>=0?{color:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["COLOR_FONT_DISABLED"]}:getNodeTextColor?{color:getNodeTextColor(node)}:null},(hideIds||hiddenIdKeys&&hiddenIdKeys.indexOf(this.getKey(node))>=0?'':getCatId&&node[childrenKey]?'['+getCatId(node)+'] ':'['+node[node[childrenKey]?catIdKey:idKey]+'] ')+(getIsNameMultilanguage&&getIsNameMultilanguage(node)===false?node[node[childrenKey]?catNameKey:nameKey]:Object(__WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__["a" /* getLocalizedStr */])(node[node[childrenKey]?catNameKey:nameKey],preferredLanguage,dataLanguages)));}},{key:'getActions',value:function getActions(node){if(this.props.nodeActions){var actions=this.props.nodeActions.filter(function(act){return act;}).map(function(act){return typeof act==="function"?act(node):act;}).filter(function(act){return act;});return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,actions.map(function(action,key){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,Object.assign({key:key},action,{type:'primary',shape:'circle',size:'small',onClick:function onClick(e){e.stopPropagation();action.onClick(node);},style:{marginLeft:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_XS"],transform:'scale(0.8)'}}));}));}else{return null;}}},{key:'getKeys',value:function getKeys(tree){var _this4=this;var childrenKey=this.props.childrenKey;var res=[];var recursive=function recursive(subTree){return subTree?subTree.map(function(node){if(node[childrenKey]&&node[childrenKey].length){recursive(node[childrenKey]);}res.push(_this4.getKey(node));return null;}):[];};recursive(tree);return res;}},{key:'getFilteredTree',value:function getFilteredTree(searchText){var _this5=this;var childrenKey=this.props.childrenKey;var filterNode=this.props.getFilter(searchText);var hiddenKeys=this.props.hiddenKeys;var recursive=function recursive(subtree){return subtree?[].concat(_toConsumableArray(subtree.map(function(node){return Object.assign({},node);}).filter(function(node){if(node[childrenKey]&&node[childrenKey].length){if((!hiddenKeys||!hiddenKeys.includes(_this5.getKey(node)))&&filterNode(node)){return true;}else{var filteredChildren=[].concat(_toConsumableArray(recursive(node[childrenKey])));if(filteredChildren.length){node[childrenKey]=filteredChildren;return!hiddenKeys||!hiddenKeys.includes(_this5.getKey(node));}else{return false;}}}else{return(!hiddenKeys||!hiddenKeys.includes(_this5.getKey(node)))&&filterNode(node);}}))):null;};return recursive(this.props.tree);}},{key:'getShowMoreNode',value:function getShowMoreNode(parent){var _this6=this;var key=''+(parent?this.getKey(parent):'root');var remaining=(parent?parent[this.props.childrenKey]:this.state.filteredTree.filter(function(node){return node!=null;})).length-((this.state.showMoreKeyClicks[key]||0)+1)*this.props.treePageSize;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tree___default.a.TreeNode,{key:key+'_showMore',className:'tree__node tree__node__show-more',title:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('i',{onClick:function onClick(e){e.stopPropagation();if(_this6.props.onShowMoreForbidden&&$(".tree__node:not(.tree__node__show-more)").length>=_this6.props.maxTreeNodesForPagination){_this6.props.onShowMoreForbidden();}else{_this6.setState({showMoreKeyClicks:Object.assign({},_this6.state.showMoreKeyClicks,_defineProperty({},key,_this6.state.showMoreKeyClicks[key]?_this6.state.showMoreKeyClicks[key]+1:1))});}}},this.props.t('components.tree.showMore',{pageSize:Math.min(remaining,this.props.treePageSize),remaining:remaining})),selectable:false,disableCheckbox:true});}},{key:'getNode',value:function getNode(node,isRoot,preferredLanguage){var _this7=this;var key=this.getKey(node);var isVisible=this.props.hiddenKeys?this.props.hiddenKeys.indexOf(key)<0:true;var isSelectable=this.props.unselectableKeys?this.props.unselectableKeys.indexOf(key)<0:true;var isCheckable=this.props.getNodeIsCheckable?this.props.getNodeIsCheckable(node):true;var _props3=this.props,childrenKey=_props3.childrenKey,treePageSize=_props3.treePageSize,isRootIconLikeChildrenIcon=_props3.isRootIconLikeChildrenIcon,isEmptyCategoryIconLikeLeafIcon=_props3.isEmptyCategoryIconLikeLeafIcon,_icon=_props3.icon,getIconColor=_props3.getIconColor,isCustomIcon=_props3.isCustomIcon,getIcon=_props3.getIcon;var nodeTitle=this.props.rightClickActions&&this.props.rightClickActions.filter(function(action){return action(node)!==null;}).length>0?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tooltip___default.a,{placement:'right',title:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"],type:'flex'},this.props.rightClickActions.map(function(action){return action(node);}).filter(function(action){return action!==null;}).map(function(action,index){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{key:index},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,Object.assign({},action,{onClick:function onClick(e){e.preventDefault();e.stopPropagation();action.onClick(node);},size:'small',shape:'circle',type:'primary'})));})),trigger:'contextMenu',getPopupContainer:function getPopupContainer(){return $('.custom-tree__tree-container__'+_this7.state.uuidClassName)[0];}},this.getTitle(node,preferredLanguage),this.getActions(node)):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{onContextMenu:function onContextMenu(e){return e.preventDefault();}},this.getTitle(node,preferredLanguage),this.getActions(node));return isVisible?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tree___default.a.TreeNode,{title:nodeTitle,className:'tree__node',key:key,'data-node':node,icon:function icon(_ref){var expanded=_ref.expanded;var getIconResult=getIcon?getIcon(node,expanded,isRoot):null;if(getIconResult!==null){return getIconResult;}else{if(isRoot&&!isRootIconLikeChildrenIcon){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(IconFontCNIcon,{type:'database'});}else if(node[childrenKey]&&(node[childrenKey].length||!isEmptyCategoryIconLikeLeafIcon)){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{theme:'filled',style:{color:'#f7c427'},type:node[childrenKey].length&&expanded?'folder-open':'folder'});}else{var IconComponent=isCustomIcon?IconFontCNIcon:__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(IconComponent,{type:_icon,theme:getIconColor?"filled":null,style:getIconColor?{color:getIconColor(node)}:null});}}},selectable:isSelectable,disableCheckbox:!isCheckable},node[childrenKey]?node[childrenKey].filter(function(child,index){return!_this7.state.isPaginated||index<treePageSize*((_this7.state.showMoreKeyClicks[key]||0)+1);}).map(function(child){return _this7.getNode(child,false,preferredLanguage);}).concat(this.state.isPaginated&&node[childrenKey].length>treePageSize*((this.state.showMoreKeyClicks[key]||0)+1)?[this.getShowMoreNode(node)]:[]):''):isRoot?null:'';}},{key:'onSelect',value:function onSelect(){var _props4=this.props,onSelect=_props4.onSelect,externalControlledSelectedKeys=_props4.externalControlledSelectedKeys;if(!externalControlledSelectedKeys){this.setState({selectedKeys:arguments.length<=0?undefined:arguments[0]});}if(onSelect){onSelect(arguments.length<=0?undefined:arguments[0]);}}},{key:'render',value:function render(){var _this8=this;var _props5=this.props,t=_props5.t,tree=_props5.tree,treePrefix=_props5.treePrefix,actions=_props5.actions,treeActions=_props5.treeActions,onSelect=_props5.onSelect,multiple=_props5.multiple,checkable=_props5.checkable,checkStrictly=_props5.checkStrictly,checkedKeys=_props5.checkedKeys,onCheck=_props5.onCheck,getFilter=_props5.getFilter,defaultSelectedKeys=_props5.defaultSelectedKeys,draggable=_props5.draggable,onDrop=_props5.onDrop,appLanguage=_props5.appLanguage,treePageSize=_props5.treePageSize,leftActions=_props5.leftActions,rightActions=_props5.rightActions,placeholder=_props5.placeholder,_props5$searchBarSpan=_props5.searchBarSpan,searchBarSpan=_props5$searchBarSpan===undefined?__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_ONE_QUARTER"]:_props5$searchBarSpan,isTreeVisible=_props5.isTreeVisible,maxNodeForExpandAll=_props5.maxNodeForExpandAll;var _state2=this.state,expandedKeys=_state2.expandedKeys,searchText=_state2.searchText,uuidClassName=_state2.uuidClassName,filteredTree=_state2.filteredTree,isPaginated=_state2.isPaginated,filteredTreeLength=_state2.filteredTreeLength,selectedKeys=_state2.selectedKeys;var keys=this.getKeys(tree);var filteredTreeKeys=this.getKeys(filteredTree);var visibleNodesCount=this.countVisibleNodes(filteredTree);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var antTreeChildren=filteredTree!==null?filteredTree.filter(function(topLevelNode,index){return!isPaginated||index<treePageSize*((_this8.state.showMoreKeyClicks['root']||0)+1);}).map(function(topLevelNode){return _this8.getNode(topLevelNode,true,dataLanguage||appLanguage);}).filter(function(node){return node!==null;}).concat(isPaginated&&filteredTree.length>treePageSize*((_this8.state.showMoreKeyClicks['root']||0)+1)?[_this8.getShowMoreNode()]:[]):null;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],className:"custom-tree__tree-header",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:searchBarSpan},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__auto_search_input__["a" /* default */],{placeholder:t('components.tree.searchInput.placeholder'),onSearch:function onSearch(searchText){var filteredTree=_this8.getFilteredTree(searchText);_this8.setState({searchText:searchText,expandedKeys:searchText?filteredTreeKeys:keys,filteredTree:filteredTree,filteredTreeLength:_this8.countVisibleNodes(filteredTree)});}})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]-searchBarSpan},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],type:'flex',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,leftActions?leftActions:null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],type:'flex',justify:'end'},rightActions&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,rightActions),actions&&actions.filter(function(action){return action!==null;}).length>0&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"],type:'flex'},actions.filter(function(action){return action!==null;}).map(function(action,index){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{key:index},action.render?action.render(Object.assign({},action,{render:undefined})):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,Object.assign({},action,{render:undefined})));}))),treeActions&&treeActions.filter(function(action){return action!==null;}).length>0&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"],type:'flex'},treeActions.filter(function(action){return action!==null;}).map(function(action,index){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{key:index},action.render?action.render(Object.assign({},action,{render:undefined})):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,Object.assign({},action,{render:undefined})));}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"],type:'flex'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return _this8.setState({expandedKeys:[],showMoreKeyClicks:{}});},title:t('components.tree.actions.collapseAll'),icon:'folder'})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return _this8.setState({expandedKeys:keys});},title:t('components.tree.actions.expandAll'),icon:'folder-open',disabled:visibleNodesCount>maxNodeForExpandAll}))))))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',style:{overflow:'auto'},className:'custom-tree__tree-container custom-tree__tree-container__'+uuidClassName},antTreeChildren&&antTreeChildren.length>0&&isTreeVisible!==false?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,treePrefix&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tree___default.a,{checkable:checkable,checkStrictly:checkStrictly,checkedKeys:checkedKeys,onCheck:onCheck,multiple:multiple,onSelect:onSelect,draggable:draggable,onDrop:onDrop,defaultExpandAll:true},treePrefix.map(function(node){return _this8.getNode(node,true,dataLanguage||appLanguage);})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_SM"],marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_SM"]}})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tree___default.a,{showIcon:true,filterTreeNode:searchText?function(TreeNode){return TreeNode.props['data-node']?getFilter(searchText)(TreeNode.props['data-node']):true;}:null,checkable:checkable,checkStrictly:checkStrictly,checkedKeys:checkedKeys,onCheck:onCheck,multiple:multiple,onSelect:_this8.onSelect,selectedKeys:selectedKeys!==null&&selectedKeys!==undefined?selectedKeys:defaultSelectedKeys!==null&&defaultSelectedKeys!==undefined?defaultSelectedKeys:[],expandedKeys:expandedKeys,onExpand:function onExpand(expandedKeys){return _this8.setState({expandedKeys:expandedKeys});},draggable:draggable,onDrop:onDrop},antTreeChildren)):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__custom_empty__["a" /* default */],{text:placeholder})),filteredTreeLength>0&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',justify:'end',className:"custom-tree__tree-footer",style:{marginTop:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,t('components.tree.count',{count:_this8.state.filteredTreeLength}))));});}}]);return EnhancedTree;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_redux__["b" /* connect */])(function(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,minTreeNodesForPagination:state.config.userInterface.minTreeNodesForPagination,maxTreeNodesForPagination:state.config.userInterface.maxTreeNodesForPagination,maxNodeForExpandAll:state.config.userInterface.maxNodeForExpandAll,treePageSize:state.config.userInterface.treePageSize};}),Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])())(EnhancedTree));

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BUTTON_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return BUTTON_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BUTTON_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BUTTON_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return BUTTON_PREVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BUTTON_DATA_EXPLORER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return BUTTON_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BUTTON_CUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return BUTTON_PASTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return BUTTON_PASTE_AS_BROTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return BUTTON_SET_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return BUTTON_UNSET_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return BUTTON_PUBLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return BUTTON_UNPUBLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return BUTTON_INFO_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return BUTTON_INFO_PAGE_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUTTON_API_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BUTTON_CUSTOM_ANNOTATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return BUTTON_DSD_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BUTTON_DATAFLOW_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BUTTON_DSD_COMPARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return BUTTON_LAYOUT_ANNOTATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return BUTTON_REMOVE_EMBARGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return BUTTON_MANAGE_OWNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return BUTTON_PARENTS_AND_CHILDREN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUTTON_CHECK_ALL_CHILDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUTTON_CONTENT_CONSTRAINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return BUTTON_UNCATEGORIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return BUTTON_EMPTY_CUBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUTTON_CLONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return BUTTON_EXPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return BUTTON_SET_DEFAULT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return BUTTON_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTON_ADD_AGENCY_TO_CONFIG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttons_css__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__buttons_css__);
var BUTTON_DETAIL={icon:"file-text",className:"button-color-blue"};var BUTTON_DOWNLOAD={icon:"download",className:"button-color-light-green"};var BUTTON_DELETE={icon:"delete",className:"button-color-red"};var BUTTON_CREATE={icon:"plus",className:"button-color-green"};var BUTTON_PREVIEW={icon:"eye",className:"button-color-light-blue"};var BUTTON_DATA_EXPLORER={icon:"global",className:"button-color-light-blue"};var BUTTON_INFO={icon:"info",className:"button-color-light-blue"};var BUTTON_CUT={icon:"scissor",className:"button-color-orange"};var BUTTON_PASTE={icon:"audit",className:"button-color-orange"};var BUTTON_PASTE_AS_BROTHER={icon:"solution",className:"button-color-orange"};var BUTTON_SET_DEFAULT={icon:"flag",className:"button-color-orange"};var BUTTON_UNSET_DEFAULT={icon:"flag",className:"button-color-orange"};var BUTTON_PUBLISH={icon:"database",className:"button-color-orange"};var BUTTON_UNPUBLISH={icon:"close-square",className:"button-color-orange"};var BUTTON_INFO_PAGE={icon:"export",className:"button-color-light-blue"};var BUTTON_INFO_PAGE_LINK={icon:"link",className:"button-color-light-blue"};var BUTTON_API_LINK={icon:"link",className:"button-color-orange"};var BUTTON_CUSTOM_ANNOTATIONS={icon:"info",className:"button-color-white"};var BUTTON_DSD_UPGRADE={icon:"up-square",className:"button-color-orange"};var BUTTON_DATAFLOW_LIST={icon:"unordered-list",className:"button-color-light-blue"};var BUTTON_DSD_COMPARE={icon:"block",className:"button-color-orange"};var BUTTON_LAYOUT_ANNOTATIONS={icon:"info",className:"button-color-orange"};var BUTTON_REMOVE_EMBARGO={iconText:"E",className:"button-color-light-blue"};var BUTTON_MANAGE_OWNERS={icon:"user",className:"button-color-orange"};var BUTTON_PARENTS_AND_CHILDREN={icon:"unordered-list",className:"button-color-light-blue"};var BUTTON_CHECK_ALL_CHILDS={icon:"unordered-list",className:"button-color-orange"};var BUTTON_CONTENT_CONSTRAINTS={icon:"link",className:"button-color-light-blue"};var BUTTON_UNCATEGORIZE={icon:"disconnect",className:"button-color-orange"};var BUTTON_EMPTY_CUBE={icon:"close-square",className:"button-color-orange"};var BUTTON_CLONE={icon:"copy",className:"button-color-green"};var BUTTON_EXPORT={icon:"export",className:"button-color-green"};var BUTTON_SET_DEFAULT_ORDER={className:"button-color-orange"};var BUTTON_REPORTS={icon:"unordered-list",className:"button-color-light-blue"};var BUTTON_ADD_AGENCY_TO_CONFIG={icon:"file-add",className:"button-color-orange"};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return DSD_DETAIL_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DSD_DETAIL_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DSD_DETAIL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return DSD_DETAIL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DSD_DETAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return DSD_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return DSD_DETAIL_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DSD_DETAIL_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DSD_DETAIL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return DSD_DETAIL_DIMENSION_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return DSD_DETAIL_DIMENSION_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return DSD_DETAIL_DIMENSION_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DSD_DETAIL_DIMENSION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return DSD_DETAIL_DIMENSION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return DSD_DETAIL_DIMENSION_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return DSD_DETAIL_GROUP_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return DSD_DETAIL_GROUP_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return DSD_DETAIL_GROUP_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return DSD_DETAIL_GROUP_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return DSD_DETAIL_GROUP_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return DSD_DETAIL_GROUP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DSD_DETAIL_ATTRIBUTE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DSD_DETAIL_ATTRIBUTE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DSD_DETAIL_ATTRIBUTE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DSD_DETAIL_ATTRIBUTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DSD_DETAIL_ATTRIBUTE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DSD_DETAIL_ATTRIBUTE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return DSD_DETAIL_PRIMARY_MEASURE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DSD_DETAIL_CODELISTS_FOR_SELECTOR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DSD_DETAIL_CODELISTS_FOR_SELECTOR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DSD_DETAIL_CODELISTS_FOR_SELECTOR_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DSD_DETAIL_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return DSD_DETAIL_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return DSD_DETAIL_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return DSD_DETAIL_DOWNLOAD_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DSD_DETAIL_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DSD_DETAIL_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DSD_DETAIL_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DSD_DETAIL_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DSD_DETAIL_CODELISTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DSD_DETAIL_CONCEPT_SCHEMES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return DSD_DETAIL_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DSD_DETAIL_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DSD_DETAIL_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return DSD_DETAIL_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DSD_DETAIL_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DSD_DETAIL_COMPONENT_NOT_DISPLAYED_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DSD_DETAIL_COMPONENT_DEFAULT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_ITEMS_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DSD_DETAIL_DEFAULT_CODES_SELECTOR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DSD_DETAIL_DEFAULT_CODES_SELECTOR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DSD_DETAIL_DEFAULT_CODES_SELECTOR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DSD_DETAIL_DEFAULT_CODES_SELECTOR_ITEMS_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DSD_DETAIL_DEFAULT_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return DSD_DETAIL_DEFAULT_TIME_DIMENSION_START_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DSD_DETAIL_DEFAULT_TIME_DIMENSION_END_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_OBSERVATIONS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_PERIODS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DSD_DETAIL_DEFAULT_TIME_DIMENSION_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return readDsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return createDsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return editDsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return showDsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return changeDsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return hideDsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return submitDsdDetailCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return submitDsdDetailUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return readDsdDetailAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return changeDsdDetailPrimaryMeasure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return editDsdDetailDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return createDsdDetailDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return hideDsdDetailDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return deleteDsdDetailDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return submitDsdDetailDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return changeDsdDetailDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return editDsdDetailGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return createDsdDetailGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return deleteDsdDetailGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return hideDsdDetailGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return changeDsdDetailGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return submitDsdDetailGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return editDsdDetailAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return deleteDsdDetailAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return createDsdDetailAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return hideDsdDetailAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return changeDsdDetailAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return submitDsdDetailAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return showDsdDetailCodelistsForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return hideDsdDetailCodelistsForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return setDsdDetailCodelistsForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return showDsdDetailConceptSchemesForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return hideDsdDetailConceptSchemesForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return readDsdDetailConceptSchemeForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return showDsdDetailConceptSchemeForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return hideDsdDetailConceptSchemeForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return setDsdDetailConceptSchemeForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return showDsdDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return hideDsdDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return changeDsdDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return submitDsdDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return showDsdDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return hideDsdDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return changeDsdDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return submitDsdDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return showDsdDetailMeasureDimensionConceptSchemesForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return hideDsdDetailMeasureDimensionConceptSchemesForSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return setDsdDetailMeasureDimensionConceptSchemesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return readDsdDetailCodelists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return readDsdDetailConceptSchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return showDsdDetailDsdExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return hideDsdDetailDsdExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return changeDsdDetailDsdExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return submitDsdDetailDsdExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return hideDsdDetailDsdExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return changeDsdDetailComponentNotDisplayed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return changeDsdDetailComponentDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return showDsdDetailNotDisplayedCodesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return hideDsdDetailNotDisplayedCodesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return submitDsdDetailNotDisplayedCodesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return showDsdDetailDefaultCodesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return hideDsdDetailDefaultCodesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return submitDsdDetailDefaultCodesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return readDsdDetailItemsPageForNotDisplayedCodesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return readDsdDetailItemsPageForDefaultCodesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return changeDsdDetailNotDisplayedCodesSelectorTempSelectedCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return changeDsdDetailDefaultCodesSelectorTempSelectedCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return changeDsdDetailDefaultTimeDimensionStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return changeDsdDetailDefaultTimeDimensionEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return changeDsdDetailDefaultTimeDimensionLastNObservations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return changeDsdDetailDefaultTimeDimensionLastNPeriods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return changeDsdDetailDefaultTimeDimensionMode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artefact_export_form__ = __webpack_require__(51);
var DSD_DETAIL_READ='DSD_DETAIL_READ';var DSD_DETAIL_CREATE='DSD_DETAIL_CREATE';var DSD_DETAIL_EDIT='DSD_DETAIL_EDIT';var DSD_DETAIL_SHOW='DSD_DETAIL_SHOW';var DSD_DETAIL_CHANGE='DSD_DETAIL_CHANGE';var DSD_DETAIL_HIDE='DSD_DETAIL_HIDE';var DSD_DETAIL_UPDATE_SUBMIT='DSD_DETAIL_UPDATE_SUBMIT';var DSD_DETAIL_CREATE_SUBMIT='DSD_DETAIL_CREATE_SUBMIT';var DSD_DETAIL_AGENCIES_READ='DSD_DETAIL_AGENCIES_READ';var DSD_DETAIL_DIMENSION_EDIT='DSD_DETAIL_DIMENSION_EDIT';var DSD_DETAIL_DIMENSION_CREATE='DSD_DETAIL_DIMENSION_CREATE';var DSD_DETAIL_DIMENSION_HIDE='DSD_DETAIL_DIMENSION_HIDE';var DSD_DETAIL_DIMENSION_CHANGE='DSD_DETAIL_DIMENSION_CHANGE';var DSD_DETAIL_DIMENSION_DELETE='DSD_DETAIL_DIMENSION_DELETE';var DSD_DETAIL_DIMENSION_SUBMIT='DSD_DETAIL_DIMENSION_SUBMIT';var DSD_DETAIL_GROUP_EDIT='DSD_DETAIL_GROUP_EDIT';var DSD_DETAIL_GROUP_CREATE='DSD_DETAIL_GROUP_CREATE';var DSD_DETAIL_GROUP_HIDE='DSD_DETAIL_GROUP_HIDE';var DSD_DETAIL_GROUP_CHANGE='DSD_DETAIL_GROUP_CHANGE';var DSD_DETAIL_GROUP_DELETE='DSD_DETAIL_GROUP_DELETE';var DSD_DETAIL_GROUP_SUBMIT='DSD_DETAIL_GROUP_SUBMIT';var DSD_DETAIL_ATTRIBUTE_EDIT='DSD_DETAIL_ATTRIBUTE_EDIT';var DSD_DETAIL_ATTRIBUTE_CREATE='DSD_DETAIL_ATTRIBUTE_CREATE';var DSD_DETAIL_ATTRIBUTE_HIDE='DSD_DETAIL_ATTRIBUTE_HIDE';var DSD_DETAIL_ATTRIBUTE_CHANGE='DSD_DETAIL_ATTRIBUTE_CHANGE';var DSD_DETAIL_ATTRIBUTE_DELETE='DSD_DETAIL_ATTRIBUTE_DELETE';var DSD_DETAIL_ATTRIBUTE_SUBMIT='DSD_DETAIL_ATTRIBUTE_SUBMIT';var DSD_DETAIL_PRIMARY_MEASURE_CHANGE='DSD_DETAIL_PRIMARY_MEASURE_CHANGE';var DSD_DETAIL_CODELISTS_FOR_SELECTOR_SHOW='DSD_DETAIL_CODELISTS_FOR_SELECTOR_SHOW';var DSD_DETAIL_CODELISTS_FOR_SELECTOR_HIDE='DSD_DETAIL_CODELISTS_FOR_SELECTOR_HIDE';var DSD_DETAIL_CODELISTS_FOR_SELECTOR_SET='DSD_DETAIL_CODELISTS_FOR_SELECTOR_SET';var DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW='DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW';var DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE='DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE';var DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_READ='DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_READ';var DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SHOW='DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SHOW';var DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_HIDE='DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_HIDE';var DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SET='DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SET';var DSD_DETAIL_DOWNLOAD_SHOW='DSD_DETAIL_DOWNLOAD_SHOW';var DSD_DETAIL_DOWNLOAD_HIDE='DSD_DETAIL_DOWNLOAD_HIDE';var DSD_DETAIL_DOWNLOAD_CHANGE='DSD_DETAIL_DOWNLOAD_CHANGE';var DSD_DETAIL_DOWNLOAD_SUBMIT='DSD_DETAIL_DOWNLOAD_SUBMIT';var DSD_DETAIL_CLONE_SHOW='DSD_DETAIL_CLONE_SHOW';var DSD_DETAIL_CLONE_HIDE='DSD_DETAIL_CLONE_HIDE';var DSD_DETAIL_CLONE_CHANGE='DSD_DETAIL_CLONE_CHANGE';var DSD_DETAIL_CLONE_SUBMIT='DSD_DETAIL_CLONE_SUBMIT';var DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW='DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW';var DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE='DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE';var DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SET='DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SET';var DSD_DETAIL_CODELISTS_READ='DSD_DETAIL_CODELISTS_READ';var DSD_DETAIL_CONCEPT_SCHEMES_READ='DSD_DETAIL_CONCEPT_SCHEMES_READ';var DSD_DETAIL_EXPORT_SHOW='DSD_DETAIL_EXPORT_SHOW';var DSD_DETAIL_EXPORT_HIDE='DSD_DETAIL_EXPORT_HIDE';var DSD_DETAIL_EXPORT_CHANGE='DSD_DETAIL_EXPORT_CHANGE';var DSD_DETAIL_EXPORT_SUBMIT='DSD_DETAIL_EXPORT_SUBMIT';var DSD_DETAIL_EXPORT_REPORT_HIDE='DSD_DETAIL_EXPORT_REPORT_HIDE';var DSD_DETAIL_COMPONENT_NOT_DISPLAYED_CHANGE='DSD_DETAIL_COMPONENT_NOT_DISPLAYED_CHANGE';var DSD_DETAIL_COMPONENT_DEFAULT_CHANGE='DSD_DETAIL_COMPONENT_DEFAULT_CHANGE';var DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SHOW='DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SHOW';var DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_HIDE='DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_HIDE';var DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SUBMIT='DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SUBMIT';var DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_ITEMS_PAGE_READ='DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_ITEMS_PAGE_READ';var DSD_DETAIL_DEFAULT_CODES_SELECTOR_SHOW='DSD_DETAIL_DEFAULT_CODES_SELECTOR_SHOW';var DSD_DETAIL_DEFAULT_CODES_SELECTOR_HIDE='DSD_DETAIL_DEFAULT_CODES_SELECTOR_HIDE';var DSD_DETAIL_DEFAULT_CODES_SELECTOR_SUBMIT='DSD_DETAIL_DEFAULT_CODES_SELECTOR_SUBMIT';var DSD_DETAIL_DEFAULT_CODES_SELECTOR_ITEMS_PAGE_READ='DSD_DETAIL_DEFAULT_CODES_SELECTOR_ITEMS_PAGE_READ';var DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE='DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE';var DSD_DETAIL_DEFAULT_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE='DSD_DETAIL_DEFAULT_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE';var DSD_DETAIL_DEFAULT_TIME_DIMENSION_START_CHANGE='DSD_DETAIL_DEFAULT_TIME_DIMENSION_START_CHANGE';var DSD_DETAIL_DEFAULT_TIME_DIMENSION_END_CHANGE='DSD_DETAIL_DEFAULT_TIME_DIMENSION_END_CHANGE';var DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_OBSERVATIONS_CHANGE='DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_OBSERVATIONS_CHANGE';var DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_PERIODS_CHANGE='DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_PERIODS_CHANGE';var DSD_DETAIL_DEFAULT_TIME_DIMENSION_MODE_CHANGE='DSD_DETAIL_DEFAULT_TIME_DIMENSION_MODE_CHANGE';var readDsdDetail=function readDsdDetail(dsdTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DSD_DETAIL_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(dsdTriplet));};var createDsdDetail=function createDsdDetail(){return{type:DSD_DETAIL_CREATE};};var editDsdDetail=function editDsdDetail(dsdTriplet){return{type:DSD_DETAIL_EDIT,dsdTriplet:dsdTriplet};};var showDsdDetail=function showDsdDetail(dsdTriplet){return{type:DSD_DETAIL_SHOW,dsdTriplet:dsdTriplet};};var changeDsdDetail=function changeDsdDetail(fields){return{type:DSD_DETAIL_CHANGE,fields:fields};};var hideDsdDetail=function hideDsdDetail(){return{type:DSD_DETAIL_HIDE};};var submitDsdDetailCreate=function submitDsdDetailCreate(dsd){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DSD_DETAIL_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["Y" /* getSdmxJsonStructureFromDsd */])(dsd)],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["D" /* SDMX_JSON_DSD_LIST_KEY */]),function(t){return{success:t('reduxComponents.dsdDetail.messages.create.success')};});};var submitDsdDetailUpdate=function submitDsdDetailUpdate(dsd){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(DSD_DETAIL_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["Y" /* getSdmxJsonStructureFromDsd */])(dsd)],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["D" /* SDMX_JSON_DSD_LIST_KEY */]),function(t){return{success:t('reduxComponents.dsdDetail.messages.update.success')};});};var readDsdDetailAgencies=function readDsdDetailAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DSD_DETAIL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var changeDsdDetailPrimaryMeasure=function changeDsdDetailPrimaryMeasure(fields){return{type:DSD_DETAIL_PRIMARY_MEASURE_CHANGE,fields:fields};};var editDsdDetailDimension=function editDsdDetailDimension(id){return{type:DSD_DETAIL_DIMENSION_EDIT,id:id};};var createDsdDetailDimension=function createDsdDetailDimension(){return{type:DSD_DETAIL_DIMENSION_CREATE};};var hideDsdDetailDimension=function hideDsdDetailDimension(){return{type:DSD_DETAIL_DIMENSION_HIDE};};var deleteDsdDetailDimension=function deleteDsdDetailDimension(id){return{type:DSD_DETAIL_DIMENSION_DELETE,id:id};};var submitDsdDetailDimension=function submitDsdDetailDimension(){return{type:DSD_DETAIL_DIMENSION_SUBMIT};};var changeDsdDetailDimension=function changeDsdDetailDimension(fields){return{type:DSD_DETAIL_DIMENSION_CHANGE,fields:fields};};var editDsdDetailGroup=function editDsdDetailGroup(id){return{type:DSD_DETAIL_GROUP_EDIT,id:id};};var createDsdDetailGroup=function createDsdDetailGroup(){return{type:DSD_DETAIL_GROUP_CREATE};};var deleteDsdDetailGroup=function deleteDsdDetailGroup(id){return{type:DSD_DETAIL_GROUP_DELETE,id:id};};var hideDsdDetailGroup=function hideDsdDetailGroup(){return{type:DSD_DETAIL_GROUP_HIDE};};var changeDsdDetailGroup=function changeDsdDetailGroup(fields){return{type:DSD_DETAIL_GROUP_CHANGE,fields:fields};};var submitDsdDetailGroup=function submitDsdDetailGroup(){return{type:DSD_DETAIL_GROUP_SUBMIT};};var editDsdDetailAttribute=function editDsdDetailAttribute(id){return{type:DSD_DETAIL_ATTRIBUTE_EDIT,id:id};};var deleteDsdDetailAttribute=function deleteDsdDetailAttribute(id){return{type:DSD_DETAIL_ATTRIBUTE_DELETE,id:id};};var createDsdDetailAttribute=function createDsdDetailAttribute(){return{type:DSD_DETAIL_ATTRIBUTE_CREATE};};var hideDsdDetailAttribute=function hideDsdDetailAttribute(){return{type:DSD_DETAIL_ATTRIBUTE_HIDE};};var changeDsdDetailAttribute=function changeDsdDetailAttribute(fields){return{type:DSD_DETAIL_ATTRIBUTE_CHANGE,fields:fields};};var submitDsdDetailAttribute=function submitDsdDetailAttribute(){return{type:DSD_DETAIL_ATTRIBUTE_SUBMIT};};var showDsdDetailCodelistsForSelector=function showDsdDetailCodelistsForSelector(){return{type:DSD_DETAIL_CODELISTS_FOR_SELECTOR_SHOW};};var hideDsdDetailCodelistsForSelector=function hideDsdDetailCodelistsForSelector(){return{type:DSD_DETAIL_CODELISTS_FOR_SELECTOR_HIDE};};var setDsdDetailCodelistsForSelector=function setDsdDetailCodelistsForSelector(codelistUrn){return{type:DSD_DETAIL_CODELISTS_FOR_SELECTOR_SET,codelistUrn:codelistUrn};};var showDsdDetailConceptSchemesForSelector=function showDsdDetailConceptSchemesForSelector(){return{type:DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW};};var hideDsdDetailConceptSchemesForSelector=function hideDsdDetailConceptSchemesForSelector(){return{type:DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE};};var readDsdDetailConceptSchemeForSelector=function readDsdDetailConceptSchemeForSelector(conceptSchemeTriplet,itemOrderAnnotationType){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])(conceptSchemeTriplet)),{itemOrderAnnotationType:itemOrderAnnotationType});};var showDsdDetailConceptSchemeForSelector=function showDsdDetailConceptSchemeForSelector(conceptSchemeTriplet){return{type:DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SHOW,conceptSchemeTriplet:conceptSchemeTriplet};};var hideDsdDetailConceptSchemeForSelector=function hideDsdDetailConceptSchemeForSelector(){return{type:DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_HIDE};};var setDsdDetailConceptSchemeForSelector=function setDsdDetailConceptSchemeForSelector(conceptUrn){return{type:DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SET,conceptUrn:conceptUrn};};var showDsdDetailDownload=function showDsdDetailDownload(artefactTriplets,lang){return{type:DSD_DETAIL_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideDsdDetailDownload=function hideDsdDetailDownload(){return{type:DSD_DETAIL_DOWNLOAD_HIDE};};var changeDsdDetailDownload=function changeDsdDetailDownload(fields){return{type:DSD_DETAIL_DOWNLOAD_CHANGE,fields:fields};};var submitDsdDetailDownload=function submitDsdDetailDownload(artefactTriplets,downloadDsdParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DSD_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_3__constants_download__["h" /* ARTEFACT_TYPE_DSD */],downloadDsdParams.format,downloadDsdParams.references,downloadDsdParams.compression,lang),artefactTriplets.map(function(_ref){var id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_3__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_3__constants_download__["h" /* ARTEFACT_TYPE_DSD */],downloadDsdParams.format,downloadDsdParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DSD_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_3__constants_download__["h" /* ARTEFACT_TYPE_DSD */],artefactTriplets[0],downloadDsdParams.format,downloadDsdParams.references,downloadDsdParams.compression,lang),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_3__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_3__constants_download__["h" /* ARTEFACT_TYPE_DSD */],downloadDsdParams.format,downloadDsdParams.compression)});};var showDsdDetailClone=function showDsdDetailClone(srcTriplet){return{type:DSD_DETAIL_CLONE_SHOW,srcTriplet:srcTriplet};};var hideDsdDetailClone=function hideDsdDetailClone(){return{type:DSD_DETAIL_CLONE_HIDE};};var changeDsdDetailClone=function changeDsdDetailClone(fields){return{type:DSD_DETAIL_CLONE_CHANGE,fields:fields};};var submitDsdDetailClone=function submitDsdDetailClone(cloneDestTriplet,dsd,annotationsConfig){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DSD_DETAIL_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["Y" /* getSdmxJsonStructureFromDsd */])(Object.assign({},dsd,cloneDestTriplet,{isFinal:false,annotations:Object(__WEBPACK_IMPORTED_MODULE_4__utils_artefacts__["d" /* getFilteredAnnotations */])(dsd.annotations,annotationsConfig),autoAnnotations:null}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["D" /* SDMX_JSON_DSD_LIST_KEY */]),function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showDsdDetailMeasureDimensionConceptSchemesForSelector=function showDsdDetailMeasureDimensionConceptSchemesForSelector(){return{type:DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW};};var hideDsdDetailMeasureDimensionConceptSchemesForSelector=function hideDsdDetailMeasureDimensionConceptSchemesForSelector(){return{type:DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE};};var setDsdDetailMeasureDimensionConceptSchemesSelector=function setDsdDetailMeasureDimensionConceptSchemesSelector(conceptSchemeUrn){return{type:DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SET,conceptSchemeUrn:conceptSchemeUrn};};var readDsdDetailCodelists=function readDsdDetailCodelists(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DSD_DETAIL_CODELISTS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["A" /* getCodelistUrl */])());};var readDsdDetailConceptSchemes=function readDsdDetailConceptSchemes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DSD_DETAIL_CONCEPT_SCHEMES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])());};var showDsdDetailDsdExport=function showDsdDetailDsdExport(sourceTriplet){return{type:DSD_DETAIL_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideDsdDetailDsdExport=function hideDsdDetailDsdExport(){return{type:DSD_DETAIL_EXPORT_HIDE};};var changeDsdDetailDsdExport=function changeDsdDetailDsdExport(fields){return{type:DSD_DETAIL_EXPORT_CHANGE,fields:fields};};var submitDsdDetailDsdExport=function submitDsdDetailDsdExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DSD_DETAIL_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||[]),EnumType:"Dsd",CopyReferencedArtefact:destination.withReferences,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_5__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideDsdDetailDsdExportReport=function hideDsdDetailDsdExportReport(){return{type:DSD_DETAIL_EXPORT_REPORT_HIDE};};var changeDsdDetailComponentNotDisplayed=function changeDsdDetailComponentNotDisplayed(val){return{type:DSD_DETAIL_COMPONENT_NOT_DISPLAYED_CHANGE,val:val};};var changeDsdDetailComponentDefault=function changeDsdDetailComponentDefault(val){return{type:DSD_DETAIL_COMPONENT_DEFAULT_CHANGE,val:val};};var showDsdDetailNotDisplayedCodesSelector=function showDsdDetailNotDisplayedCodesSelector(codelistTriplet){return{type:DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SHOW,codelistTriplet:codelistTriplet};};var hideDsdDetailNotDisplayedCodesSelector=function hideDsdDetailNotDisplayedCodesSelector(){return{type:DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_HIDE};};var submitDsdDetailNotDisplayedCodesSelector=function submitDsdDetailNotDisplayedCodesSelector(){return{type:DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SUBMIT};};var showDsdDetailDefaultCodesSelector=function showDsdDetailDefaultCodesSelector(codelistTriplet){return{type:DSD_DETAIL_DEFAULT_CODES_SELECTOR_SHOW,codelistTriplet:codelistTriplet};};var hideDsdDetailDefaultCodesSelector=function hideDsdDetailDefaultCodesSelector(){return{type:DSD_DETAIL_DEFAULT_CODES_SELECTOR_HIDE};};var submitDsdDetailDefaultCodesSelector=function submitDsdDetailDefaultCodesSelector(){return{type:DSD_DETAIL_DEFAULT_CODES_SELECTOR_SUBMIT};};var readDsdDetailItemsPageForNotDisplayedCodesSelector=function readDsdDetailItemsPageForNotDisplayedCodesSelector(_ref2){var codelistTriplet=_ref2.codelistTriplet,language=_ref2.language,pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc;return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_ITEMS_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{Id:codelistTriplet.id,AgencyId:codelistTriplet.agencyID,Version:codelistTriplet.version,Lang:language,PageNum:pageNum,PageSize:pageSize,AllSearch:searchText,CodeSearch:filters.id?filters.id:undefined,NameSearch:filters.name?filters.name:undefined,ParentSearch:filters.parent?filters.parent:undefined,SortColumn:sortCol?sortCol:undefined,SortDesc:sortByDesc?sortByDesc:undefined,rebuildDb:false});};var readDsdDetailItemsPageForDefaultCodesSelector=function readDsdDetailItemsPageForDefaultCodesSelector(_ref3){var codelistTriplet=_ref3.codelistTriplet,language=_ref3.language,pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,searchText=_ref3.searchText,filters=_ref3.filters,sortCol=_ref3.sortCol,sortByDesc=_ref3.sortByDesc;return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DSD_DETAIL_DEFAULT_CODES_SELECTOR_ITEMS_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{Id:codelistTriplet.id,AgencyId:codelistTriplet.agencyID,Version:codelistTriplet.version,Lang:language,PageNum:pageNum,PageSize:pageSize,AllSearch:searchText,CodeSearch:filters.id?filters.id:undefined,NameSearch:filters.name?filters.name:undefined,ParentSearch:filters.parent?filters.parent:undefined,SortColumn:sortCol?sortCol:undefined,SortDesc:sortByDesc?sortByDesc:undefined,rebuildDb:false});};var changeDsdDetailNotDisplayedCodesSelectorTempSelectedCodes=function changeDsdDetailNotDisplayedCodesSelectorTempSelectedCodes(selected){return{type:DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE,selected:selected};};var changeDsdDetailDefaultCodesSelectorTempSelectedCodes=function changeDsdDetailDefaultCodesSelectorTempSelectedCodes(selected){return{type:DSD_DETAIL_DEFAULT_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE,selected:selected};};var changeDsdDetailDefaultTimeDimensionStart=function changeDsdDetailDefaultTimeDimensionStart(val){return{type:DSD_DETAIL_DEFAULT_TIME_DIMENSION_START_CHANGE,val:val};};var changeDsdDetailDefaultTimeDimensionEnd=function changeDsdDetailDefaultTimeDimensionEnd(val){return{type:DSD_DETAIL_DEFAULT_TIME_DIMENSION_END_CHANGE,val:val};};var changeDsdDetailDefaultTimeDimensionLastNObservations=function changeDsdDetailDefaultTimeDimensionLastNObservations(val){return{type:DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_OBSERVATIONS_CHANGE,val:val};};var changeDsdDetailDefaultTimeDimensionLastNPeriods=function changeDsdDetailDefaultTimeDimensionLastNPeriods(val){return{type:DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_PERIODS_CHANGE,val:val};};var changeDsdDetailDefaultTimeDimensionMode=function changeDsdDetailDefaultTimeDimensionMode(val){return{type:DSD_DETAIL_DEFAULT_TIME_DIMENSION_MODE_CHANGE,val:val};};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARTEFACT_FORM_MODE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARTEFACT_FORM_MODE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARTEFACT_FORM_MODE_CREATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__annotations_form__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__localized_date_picker__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__multilanguage_zoomable_textarea__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__constants_numbers__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_dataflow__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__perf_input__ = __webpack_require__(103);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,endpoints:state.config.nodes,endpointId:state.app.endpointId,username:state.app.user.username};};var mapPropsToFields=function mapPropsToFields(_ref){var artefact=_ref.artefact,canBeSpecialDataflow=_ref.canBeSpecialDataflow,DSDInput=_ref.DSDInput,MSDInput=_ref.MSDInput,isMsd=_ref.isMsd;return{id:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.id:null}),agencyID:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.agencyID:null}),version:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.version:null}),isFinal:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.isFinal:null}),uri:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.uri:null}),urn:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.urn:null}),validFrom:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.validFrom:null}),validTo:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.validTo:null}),name:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.name:null}),description:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact&&artefact.description?artefact.description:null}),dsd:DSDInput?__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.dsd:null}):undefined,msd:MSDInput?__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.msd:null}):undefined,customIsPresentational:isMsd?__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.customIsPresentational:null}):undefined,dataflowType:canBeSpecialDataflow?__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:artefact?artefact.dataflowType:null}):undefined};};var onFieldsChange=function onFieldsChange(props,fields){if(props.onChange){var newFields=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;});if(newFields.id&&newFields.id.length>(props.idMaxLen||__WEBPACK_IMPORTED_MODULE_29__constants_numbers__["a" /* ID_MAX_LEN */])){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:props.t('commons.alerts.fieldTooLong.title'),content:props.t('commons.alerts.fieldTooLong.content',{maxLen:props.idMaxLen||__WEBPACK_IMPORTED_MODULE_29__constants_numbers__["a" /* ID_MAX_LEN */]})});props.onChange(props.artefact);}else{props.onChange(newFields);}}};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_TWO_THIRDS"]}};var datePickerProps={format:'DD/MM/YYYY'};var rowStyle={marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"],marginLeft:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"],marginRight:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]};var ARTEFACT_FORM_MODE_READ='ARTEFACT_FORM_MODE_READ';var ARTEFACT_FORM_MODE_EDIT='ARTEFACT_FORM_MODE_EDIT';var ARTEFACT_FORM_MODE_CREATE='ARTEFACT_FORM_MODE_CREATE';var ArtefactForm=function(_Component){_inherits(ArtefactForm,_Component);function ArtefactForm(props){_classCallCheck(this,ArtefactForm);var _this=_possibleConstructorReturn(this,(ArtefactForm.__proto__||Object.getPrototypeOf(ArtefactForm)).call(this,props));_this.state={initIsFinal:null};return _this;}_createClass(ArtefactForm,[{key:'render',value:function render(){var _props=this.props,t=_props.t,form=_props.form,_props$mode=_props.mode,mode=_props$mode===undefined?ARTEFACT_FORM_MODE_READ:_props$mode,isIdDisabled=_props.isIdDisabled,isVersionDisabled=_props.isVersionDisabled,isFinalDisabled=_props.isFinalDisabled,agencies=_props.agencies,DSDInput=_props.DSDInput,MSDInput=_props.MSDInput,artefact=_props.artefact,onChange=_props.onChange,dataLanguages=_props.dataLanguages,appLanguage=_props.appLanguage,endpoints=_props.endpoints,endpointId=_props.endpointId,username=_props.username,dsdDimensions=_props.dsdDimensions,isMsd=_props.isMsd,isDataflow=_props.isDataflow,canBeSpecialDataflow=_props.canBeSpecialDataflow,isLayoutAnnotationsFormVisible=_props.isLayoutAnnotationsFormVisible,dataflow=_props.dataflow,VirtualDFNodeInput=_props.VirtualDFNodeInput,VirtualDFDataflowInput=_props.VirtualDFDataflowInput,dsdForLayoutAnnotations=_props.dsdForLayoutAnnotations,onLayoutAnnotationsFormShow=_props.onLayoutAnnotationsFormShow,onLayoutAnnotationsFormHide=_props.onLayoutAnnotationsFormHide,onLayoutAnnotationsFormSubmit=_props.onLayoutAnnotationsFormSubmit,onLayoutAnnotationsFormReset=_props.onLayoutAnnotationsFormReset,fetchDsdForLayoutAnnotations=_props.fetchDsdForLayoutAnnotations,itemsPageForLayoutAnnotations=_props.itemsPageForLayoutAnnotations,fetchItemsPageForLayoutAnnotations=_props.fetchItemsPageForLayoutAnnotations,resetItemsPageForLayoutAnnotations=_props.resetItemsPageForLayoutAnnotations;var initIsFinal=this.state.initIsFinal;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:rowStyle},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.id.label'),validateStatus:artefact&&Object(__WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,artefact.id).help?"warning":null,help:artefact&&Object(__WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,artefact.id).help},formItemLayout),form.getFieldDecorator('id',{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,title:form.getFieldValue('id'),disabled:mode!==ARTEFACT_FORM_MODE_CREATE||isIdDisabled||form.getFieldValue('dataflowType')===__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */],style:{textTransform:"uppercase"}})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.agencyID.label')},formItemLayout),form.getFieldDecorator('agencyID')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref3){var props=_ref3.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:mode!==ARTEFACT_FORM_MODE_CREATE||form.getFieldValue('dataflowType')===__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */],title:agencies&&form.getFieldValue('agencyID')&&(Object(__WEBPACK_IMPORTED_MODULE_24__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[form.getFieldValue('agencyID')],language,dataLanguages)||form.getFieldValue('agencyID'))},agencies?Object.keys(agencies).map(function(agencyID,index){var agencyName=Object(__WEBPACK_IMPORTED_MODULE_24__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[agencyID],language,dataLanguages);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:index,value:agencyID,title:agencyID&&agencyName?agencyID+' - '+agencyName:agencyID},agencyID&&agencyName?agencyID+' - '+agencyName:agencyID);}):null)));}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:rowStyle},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.version.label'),hasFeedback:true,validateStatus:artefact&&Object(__WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,artefact.version).help?"warning":null,help:artefact&&Object(__WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,artefact.version).help},formItemLayout),form.getFieldDecorator('version')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,title:form.getFieldValue('version'),disabled:mode!==ARTEFACT_FORM_MODE_CREATE||isVersionDisabled||form.getFieldValue('dataflowType')===__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.isFinal.label')},formItemLayout),form.getFieldDecorator('isFinal',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{disabled:mode===ARTEFACT_FORM_MODE_READ||mode===ARTEFACT_FORM_MODE_EDIT&&initIsFinal===true||isFinalDisabled||form.getFieldValue('dataflowType')===__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]}))))),(DSDInput||canBeSpecialDataflow)&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:rowStyle},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},DSDInput&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_FORM_MODE_CREATE&&form.getFieldValue('dataflowType')!==__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]?'form-item-required':null,label:t('data.artefact.dsd.label')},formItemLayout),form.getFieldDecorator('dsd')(DSDInput))),canBeSpecialDataflow&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.dataflowType.label')},formItemLayout),form.getFieldDecorator('dataflowType')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{disabled:mode!==ARTEFACT_FORM_MODE_CREATE},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["a" /* DATAFLOW_TYPE_NORMAL */]},t("data.artefact.dataflowType.values.normal")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]},t("data.artefact.dataflowType.values.virtual")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]},t("data.artefact.dataflowType.values.onlyFile"))))))),MSDInput&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:rowStyle},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.msd.label')},formItemLayout),form.getFieldDecorator('msd')(MSDInput)))),canBeSpecialDataflow&&(VirtualDFNodeInput||VirtualDFDataflowInput)&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:rowStyle},VirtualDFNodeInput&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.virtualDFNode.label')},formItemLayout),VirtualDFNodeInput)),VirtualDFDataflowInput&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.virtualDFDataflow.label')},formItemLayout),VirtualDFDataflowInput))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:rowStyle},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.uri.label')},formItemLayout),form.getFieldDecorator('uri')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,disabled:mode===ARTEFACT_FORM_MODE_READ,title:form.getFieldValue('uri')})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.urn.label')},formItemLayout),form.getFieldDecorator('urn')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,disabled:true,title:form.getFieldValue('urn')}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:rowStyle},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.validFrom.label')},formItemLayout),form.getFieldDecorator('validFrom')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__localized_date_picker__["a" /* default */],Object.assign({disabled:mode===ARTEFACT_FORM_MODE_READ},datePickerProps))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.validTo.label')},formItemLayout,{hasFeedback:true,validateStatus:artefact&&!Object(__WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__["c" /* isDateValid */])(artefact.validFrom,artefact.validTo)?"warning":null,help:artefact&&!Object(__WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__["c" /* isDateValid */])(artefact.validFrom,artefact.validTo)?t("commons.helps.invalidDateRange.label"):null}),form.getFieldDecorator('validTo')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__localized_date_picker__["a" /* default */],Object.assign({disabled:mode===ARTEFACT_FORM_MODE_READ},datePickerProps)))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',bodyStyle:{paddingLeft:19,paddingRight:22}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{className:mode!==ARTEFACT_FORM_MODE_READ?'form-item-required':null,label:t('data.artefact.name.label'),labelCol:{span:4},wrapperCol:{span:20}},form.getFieldDecorator('name')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_20__multilanguage_input__["a" /* default */],disabled:mode===ARTEFACT_FORM_MODE_READ}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{label:t('data.artefact.description.label'),labelCol:{span:4},wrapperCol:{span:20}},form.getFieldDecorator('description')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_28__multilanguage_zoomable_textarea__["a" /* default */],disabled:mode===ARTEFACT_FORM_MODE_READ})))))),isMsd&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'end',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{margin:"16px 16px 0"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,t('data.artefact.isAttributeWithChildrenPresentational.label')+':'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,form.getFieldDecorator('customIsPresentational',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{disabled:mode===ARTEFACT_FORM_MODE_READ})))))),mode===ARTEFACT_FORM_MODE_READ&&(!artefact||!artefact.annotations||username&&artefact.annotations.length===0||username===null&&Object(__WEBPACK_IMPORTED_MODULE_30__utils_annotations__["v" /* getGenericAnnotations */])(artefact.annotations,endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].annotationTabs.tabs,endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations).length===0)?null:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__annotations_form__["a" /* default */],{annotations:artefact?artefact.annotations:null,onChange:onChange,disabled:mode===ARTEFACT_FORM_MODE_READ,dsdDimensions:dsdDimensions,isDataflow:isDataflow,isLayoutAnnotationsFormVisible:isLayoutAnnotationsFormVisible,dataflow:dataflow,dsdForLayoutAnnotations:dsdForLayoutAnnotations,onLayoutAnnotationsFormShow:onLayoutAnnotationsFormShow,onLayoutAnnotationsFormHide:onLayoutAnnotationsFormHide,onLayoutAnnotationsFormSubmit:onLayoutAnnotationsFormSubmit,onLayoutAnnotationsFormReset:onLayoutAnnotationsFormReset,fetchDsdForLayoutAnnotations:fetchDsdForLayoutAnnotations,itemsPageForLayoutAnnotations:itemsPageForLayoutAnnotations,fetchItemsPageForLayoutAnnotations:fetchItemsPageForLayoutAnnotations,resetItemsPageForLayoutAnnotations:resetItemsPageForLayoutAnnotations,isOnlyFileDataflow:form.getFieldValue('dataflowType')===__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */],isVirtualDataflow:form.getFieldValue('dataflowType')===__WEBPACK_IMPORTED_MODULE_31__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]}));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,state){if(state.initIsFinal===null&&nextProps.artefact){return{initIsFinal:nextProps.artefact.isFinal};}else if(nextProps.artefact===null){return{initIsFinal:null};}else{return null;}}}]);return ArtefactForm;}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);/* harmony default export */ __webpack_exports__["d"] = (Object(__WEBPACK_IMPORTED_MODULE_17_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_18_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(mapStateToProps),__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ArtefactForm));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(734);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(38));

var _rcTabs = _interopRequireWildcard(__webpack_require__(739));

var _TabContent = _interopRequireDefault(__webpack_require__(746));

var _TabBar = _interopRequireDefault(__webpack_require__(747));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

var _warning = _interopRequireDefault(__webpack_require__(87));

var _isFlexSupported = _interopRequireDefault(__webpack_require__(860));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs() {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).apply(this, arguments));

    _this.removeTab = function (targetKey, e) {
      e.stopPropagation();

      if (!targetKey) {
        return;
      }

      var onEdit = _this.props.onEdit;

      if (onEdit) {
        onEdit(targetKey, 'remove');
      }
    };

    _this.handleChange = function (activeKey) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(activeKey);
      }
    };

    _this.createNewTab = function (targetKey) {
      var onEdit = _this.props.onEdit;

      if (onEdit) {
        onEdit(targetKey, 'add');
      }
    };

    _this.renderTabs = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          size = _this$props.size,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? 'line' : _this$props$type,
          tabPosition = _this$props.tabPosition,
          children = _this$props.children,
          _this$props$animated = _this$props.animated,
          animated = _this$props$animated === void 0 ? true : _this$props$animated,
          hideAdd = _this$props.hideAdd;
      var tabBarExtraContent = _this.props.tabBarExtraContent;
      var tabPaneAnimated = _typeof(animated) === 'object' ? animated.tabPane : animated; // card tabs should not have animation

      if (type !== 'line') {
        tabPaneAnimated = 'animated' in _this.props ? tabPaneAnimated : false;
      }

      (0, _warning["default"])(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), "Tabs[type=card|editable-card] doesn't have small or large size, it's by design.");
      var prefixCls = getPrefixCls('tabs', customizePrefixCls);
      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), tabPosition === 'left' || tabPosition === 'right'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card"), type.indexOf('card') >= 0), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), true), _defineProperty(_classNames, "".concat(prefixCls, "-no-animation"), !tabPaneAnimated), _classNames)); // only card type tabs can be added and closed

      var childrenWithClose = [];

      if (type === 'editable-card') {
        childrenWithClose = [];
        React.Children.forEach(children, function (child, index) {
          var closable = child.props.closable;
          closable = typeof closable === 'undefined' ? true : closable;
          var closeIcon = closable ? React.createElement(_icon["default"], {
            type: "close",
            className: "".concat(prefixCls, "-close-x"),
            onClick: function onClick(e) {
              return _this.removeTab(child.key, e);
            }
          }) : null;
          childrenWithClose.push(React.cloneElement(child, {
            tab: React.createElement("div", {
              className: closable ? undefined : "".concat(prefixCls, "-tab-unclosable")
            }, child.props.tab, closeIcon),
            key: child.key || index
          }));
        }); // Add new tab handler

        if (!hideAdd) {
          tabBarExtraContent = React.createElement("span", null, React.createElement(_icon["default"], {
            type: "plus",
            className: "".concat(prefixCls, "-new-tab"),
            onClick: _this.createNewTab
          }), tabBarExtraContent);
        }
      }

      tabBarExtraContent = tabBarExtraContent ? React.createElement("div", {
        className: "".concat(prefixCls, "-extra-content")
      }, tabBarExtraContent) : null;

      var _a = _this.props,
          dropped = _a.className,
          tabBarProps = __rest(_a, ["className"]);

      var contentCls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-content"), type.indexOf('card') >= 0 && "".concat(prefixCls, "-card-content"));
      return React.createElement(_rcTabs["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        className: cls,
        tabBarPosition: tabPosition,
        renderTabBar: function renderTabBar() {
          return React.createElement(_TabBar["default"], _extends({}, tabBarProps, {
            tabBarExtraContent: tabBarExtraContent
          }));
        },
        renderTabContent: function renderTabContent() {
          return React.createElement(_TabContent["default"], {
            className: contentCls,
            animated: tabPaneAnimated,
            animatedWithMargin: true
          });
        },
        onChange: _this.handleChange
      }), childrenWithClose.length > 0 ? childrenWithClose : children);
    };

    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var NO_FLEX = ' no-flex';
      var tabNode = ReactDOM.findDOMNode(this);

      if (tabNode && !(0, _isFlexSupported["default"])() && tabNode.className.indexOf(NO_FLEX) === -1) {
        tabNode.className += NO_FLEX;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderTabs);
    }
  }]);

  return Tabs;
}(React.Component);

exports["default"] = Tabs;
Tabs.TabPane = _rcTabs.TabPane;
Tabs.defaultProps = {
  hideAdd: false,
  tabPosition: 'top'
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CODELIST_DETAIL_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CODELIST_DETAIL_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CODELIST_DETAIL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CODELIST_DETAIL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CODELIST_DETAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CODELIST_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CODELIST_DETAIL_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CODELIST_DETAIL_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CODELIST_DETAIL_TAB_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CODELIST_DETAIL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CODELIST_DETAIL_ITEM_PAGE_PARAMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CODELIST_DETAIL_ITEM_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CODELIST_DETAIL_ITEM_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CODELIST_DETAIL_ITEMS_AUTOSAVE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CODELIST_DETAIL_ITEMS_ITEM_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CODELIST_DETAIL_ITEMS_ITEM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CODELIST_DETAIL_ITEMS_ITEM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CODELIST_DETAIL_ITEMS_ITEM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CODELIST_DETAIL_ITEMS_ITEM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CODELIST_DETAIL_ITEMS_ITEM_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CODELIST_DETAIL_ITEMS_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CODELIST_DETAIL_ITEMS_ITEM_DROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CODELIST_DETAIL_ITEMS_ITEM_CUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CODELIST_DETAIL_ITEMS_ITEM_PASTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CODELIST_DETAIL_ITEMS_VIEW_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CODELIST_DETAIL_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CODELIST_DETAIL_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CODELIST_DETAIL_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CODELIST_DETAIL_DOWNLOAD_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CODELIST_DETAIL_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CODELIST_DETAIL_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CODELIST_DETAIL_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CODELIST_DETAIL_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CODELIST_DETAIL_LANGUAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CODELIST_DETAIL_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CODELIST_DETAIL_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CODELIST_DETAIL_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CODELIST_DETAIL_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CODELIST_DETAIL_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_PARAMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_PARAMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CODELIST_DETAIL_DERIVED_CODELIST_ALL_ITEMS_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CODELIST_DETAIL_DERIVED_CODELIST_SELECTED_ITEMS_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CODELIST_DETAIL_DERIVED_CODELIST_ITEMS_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CODELIST_DETAIL_DERIVED_CODELIST_CHECKBOX_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CODELIST_DETAIL_DERIVED_CODELIST_CREATE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CODELIST_DETAIL_DERIVED_CODELIST_CREATE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CODELIST_DETAIL_DERIVED_CODELIST_VIEW_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CODELIST_DETAIL_DERIVED_CODELIST_DB_RESTORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_TREE_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CODELIST_DETAIL_DERIVED_CODELIST_TARGET_TREE_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CODELIST_DETAIL_DERIVED_TAB_FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CODELIST_DETAIL_DERIVED_TAB_UNFOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CODELIST_DETAIL_ITEMS_DEFAULT_ORDER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return readCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return createCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return editCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return showCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return readCodelistDetailItemPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return updateCodelistDetailItemPageParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return readCodelistDetailItemTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return changeCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return submitCodelistDetailCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return submitCodelistDetailUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return readCodelistDetailAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return changeCodelistDetailItemsViewMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return showCodelistDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return hideCodelistDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return changeCodelistDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return submitCodelistDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return createCodelistDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return editCodelistDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return changeCodelistDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return submitCodelistDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return hideCodelistDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return deleteCodelistDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return selectCodelistDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return showCodelistDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return hideCodelistDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return changeCodelistDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return uploadCodelistDetailItemsImportFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return importCodelistDetailItemsImportFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return hideCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return showCodelistDetailItemsItemAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return hideCodelistDetailItemsItemAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return showCodelistDetailItemsItemLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return hideCodelistDetailItemsItemLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return showCodelistDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return readCodelistDetailItemsItemParentListPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return hideCodelistDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return setCodelistDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return unsetCodelistDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return dropCodelistDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return changeCodelistDetailCodelistLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return cutCodelistDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return pasteCodelistDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return showCodelistDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return hideCodelistDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return changeCodelistDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return submitCodelistDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return changeCodelistDetailItemsAutoSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return showCodelistDetailItemsFileSystemTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return hideCodelistDetailItemsFileSystemTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return selectCodelistDetailItemsFileSystemTreeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return showCodelistDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return hideCodelistDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return changeCodelistDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return submitCodelistDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return hideCodelistDetailExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return changeCodelistDetailTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return showCodelistDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return hideCodelistDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return uploadCodelistDetailItemsImportFormCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return readCodelistDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return updateCodelistDetailDerivedCodelistSourceItemPageParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return readCodelistDetailDerivedCodelistSourceItemPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return updateCodelistDetailDerivedCodelistTargetItemPageParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return readCodelistDetailDerivedCodelistTargetItemPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return selectCodelistDetailDerivedCodelistSourceItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return selectCodelistDetailDerivedCodelistTargetItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return selectCodelistDetailDerivedCodelistSourceTreeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return selectCodelistDetailDerivedCodelistTargetTreeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return selectCodelistDetailDerivedCodelistAllItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return storeCodelistDetailDerivedCodelistSelectedItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return changeCodelistDetailDerivedCodelistCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return showCodelistDetailDerivedCodelistCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return hideCodelistDetailDerivedCodelistCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return changeCodelistDetailDerivedCodelistCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return submitCodelistDetailDerivedCodelistCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return restoreCodelistDetailDerivedCodelistDb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return focusCodelistDetailDerivedTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return unfocusCodelistDetailDerivedTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return setCodelistDetailItemsDefaultOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return changeCodelistDetailDerivedCodelistViewMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return readCodelistDetailDerivedCodelistSourceItemTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return readCodelistDetailDerivedCodelistTargetItemTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return storeCodelistDetailDerivedCodelistItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artefact_export_form__ = __webpack_require__(51);
var CODELIST_DETAIL_READ='CODELIST_DETAIL_READ';var CODELIST_DETAIL_CREATE='CODELIST_DETAIL_CREATE';var CODELIST_DETAIL_EDIT='CODELIST_DETAIL_EDIT';var CODELIST_DETAIL_SHOW='CODELIST_DETAIL_SHOW';var CODELIST_DETAIL_CHANGE='CODELIST_DETAIL_CHANGE';var CODELIST_DETAIL_HIDE='CODELIST_DETAIL_HIDE';var CODELIST_DETAIL_CREATE_SUBMIT='CODELIST_DETAIL_CREATE_SUBMIT';var CODELIST_DETAIL_UPDATE_SUBMIT='CODELIST_DETAIL_UPDATE_SUBMIT';var CODELIST_DETAIL_TAB_CHANGE='CODELIST_DETAIL_TAB_CHANGE';var CODELIST_DETAIL_AGENCIES_READ='CODELIST_DETAIL_AGENCIES_READ';var CODELIST_DETAIL_ITEM_PAGE_PARAMS_UPDATE='CODELIST_DETAIL_ITEM_PAGE_PARAMS_UPDATE';var CODELIST_DETAIL_ITEM_PAGE_READ='CODELIST_DETAIL_ITEM_PAGE_READ';var CODELIST_DETAIL_ITEM_TREE_READ='CODELIST_DETAIL_ITEM_TREE_READ';var CODELIST_DETAIL_ITEMS_AUTOSAVE_CHANGE='CODELIST_DETAIL_ITEMS_AUTOSAVE_CHANGE';var CODELIST_DETAIL_ITEMS_ITEM_CREATE='CODELIST_DETAIL_ITEMS_ITEM_CREATE';var CODELIST_DETAIL_ITEMS_ITEM_SHOW='CODELIST_DETAIL_ITEMS_ITEM_SHOW';var CODELIST_DETAIL_ITEMS_ITEM_CHANGE='CODELIST_DETAIL_ITEMS_ITEM_CHANGE';var CODELIST_DETAIL_ITEMS_ITEM_HIDE='CODELIST_DETAIL_ITEMS_ITEM_HIDE';var CODELIST_DETAIL_ITEMS_ITEM_SUBMIT='CODELIST_DETAIL_ITEMS_ITEM_SUBMIT';var CODELIST_DETAIL_ITEMS_ITEM_DELETE='CODELIST_DETAIL_ITEMS_ITEM_DELETE';var CODELIST_DETAIL_ITEMS_ITEM_SELECT='CODELIST_DETAIL_ITEMS_ITEM_SELECT';var CODELIST_DETAIL_ITEMS_ITEM_DROP='CODELIST_DETAIL_ITEMS_ITEM_DROP';var CODELIST_DETAIL_ITEMS_ITEM_CUT='CODELIST_DETAIL_ITEMS_ITEM_CUT';var CODELIST_DETAIL_ITEMS_ITEM_PASTE='CODELIST_DETAIL_ITEMS_ITEM_PASTE';var CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_SHOW='CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_SHOW';var CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_HIDE='CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_HIDE';var CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_ITEM_SELECT='CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_ITEM_SELECT';var CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW='CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW';var CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE='CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE';var CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW='CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW';var CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE='CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE';var CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW='CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW';var CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_PAGE_READ='CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_PAGE_READ';var CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE='CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE';var CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SET='CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SET';var CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET='CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET';var CODELIST_DETAIL_ITEMS_VIEW_MODE_CHANGE='CODELIST_DETAIL_ITEMS_VIEW_MODE_CHANGE';var CODELIST_DETAIL_DOWNLOAD_SHOW='CODELIST_DETAIL_DOWNLOAD_SHOW';var CODELIST_DETAIL_DOWNLOAD_HIDE='CODELIST_DETAIL_DOWNLOAD_HIDE';var CODELIST_DETAIL_DOWNLOAD_CHANGE='CODELIST_DETAIL_DOWNLOAD_CHANGE';var CODELIST_DETAIL_DOWNLOAD_SUBMIT='CODELIST_DETAIL_DOWNLOAD_SUBMIT';var CODELIST_DETAIL_CLONE_SHOW='CODELIST_DETAIL_CLONE_SHOW';var CODELIST_DETAIL_CLONE_HIDE='CODELIST_DETAIL_CLONE_HIDE';var CODELIST_DETAIL_CLONE_CHANGE='CODELIST_DETAIL_CLONE_CHANGE';var CODELIST_DETAIL_CLONE_SUBMIT='CODELIST_DETAIL_CLONE_SUBMIT';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_SHOW='CODELIST_DETAIL_ITEMS_IMPORT_FORM_SHOW';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_HIDE='CODELIST_DETAIL_ITEMS_IMPORT_FORM_HIDE';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW='CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE='CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD='CODELIST_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ='CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_CHANGE='CODELIST_DETAIL_ITEMS_IMPORT_FORM_CHANGE';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD='CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD';var CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT='CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT';var CODELIST_DETAIL_LANGUAGE_CHANGE='CODELIST_DETAIL_LANGUAGE_CHANGE';var CODELIST_DETAIL_EXPORT_SHOW='CODELIST_DETAIL_EXPORT_SHOW';var CODELIST_DETAIL_EXPORT_HIDE='CODELIST_DETAIL_EXPORT_HIDE';var CODELIST_DETAIL_EXPORT_CHANGE='CODELIST_DETAIL_EXPORT_CHANGE';var CODELIST_DETAIL_EXPORT_SUBMIT='CODELIST_DETAIL_EXPORT_SUBMIT';var CODELIST_DETAIL_EXPORT_REPORT_HIDE='CODELIST_DETAIL_EXPORT_REPORT_HIDE';var CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_PARAMS_UPDATE='CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_PARAMS_UPDATE';var CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_READ='CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_READ';var CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_PARAMS_UPDATE='CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_PARAMS_UPDATE';var CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_READ='CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_READ';var CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_TREE_READ='CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_TREE_READ';var CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_TREE_READ='CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_TREE_READ';var CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_SELECT='CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_SELECT';var CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_SELECT='CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_SELECT';var CODELIST_DETAIL_DERIVED_CODELIST_ALL_ITEMS_SELECT='CODELIST_DETAIL_DERIVED_CODELIST_ALL_ITEMS_SELECT';var CODELIST_DETAIL_DERIVED_CODELIST_SELECTED_ITEMS_STORE='CODELIST_DETAIL_DERIVED_CODELIST_SELECTED_ITEMS_STORE';var CODELIST_DETAIL_DERIVED_CODELIST_ITEMS_STORE='CODELIST_DETAIL_DERIVED_CODELIST_ITEMS_STORE';var CODELIST_DETAIL_DERIVED_CODELIST_CHECKBOX_CHANGE='CODELIST_DETAIL_DERIVED_CODELIST_CHECKBOX_CHANGE';var CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SHOW='CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SHOW';var CODELIST_DETAIL_DERIVED_CODELIST_CREATE_CHANGE='CODELIST_DETAIL_DERIVED_CODELIST_CREATE_CHANGE';var CODELIST_DETAIL_DERIVED_CODELIST_CREATE_HIDE='CODELIST_DETAIL_DERIVED_CODELIST_CREATE_HIDE';var CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SUBMIT='CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SUBMIT';var CODELIST_DETAIL_DERIVED_CODELIST_VIEW_MODE_CHANGE='CODELIST_DETAIL_DERIVED_CODELIST_VIEW_MODE_CHANGE';var CODELIST_DETAIL_DERIVED_CODELIST_DB_RESTORE='CODELIST_DETAIL_DERIVED_CODELIST_DB_RESTORE';var CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_TREE_ITEM_SELECT='CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_TREE_ITEM_SELECT';var CODELIST_DETAIL_DERIVED_CODELIST_TARGET_TREE_ITEM_SELECT='CODELIST_DETAIL_DERIVED_CODELIST_TARGET_TREE_ITEM_SELECT';var CODELIST_DETAIL_DERIVED_TAB_FOCUS='CODELIST_DETAIL_DERIVED_TAB_FOCUS';var CODELIST_DETAIL_DERIVED_TAB_UNFOCUS='CODELIST_DETAIL_DERIVED_TAB_UNFOCUS';var CODELIST_DETAIL_ITEMS_DEFAULT_ORDER_SET='CODELIST_DETAIL_ITEMS_DEFAULT_ORDER_SET';var readCodelistDetail=function readCodelistDetail(triplet,lang,itemsOrderAnnotationType){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:triplet&&triplet.id?triplet.id:undefined,agencyId:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:1,pageSize:0,rebuildDb:true}),{itemsOrderAnnotationType:itemsOrderAnnotationType});};var createCodelistDetail=function createCodelistDetail(defaultItemsViewMode){return{type:CODELIST_DETAIL_CREATE,defaultItemsViewMode:defaultItemsViewMode};};var editCodelistDetail=function editCodelistDetail(codelistTriplet,defaultItemsViewMode){return{type:CODELIST_DETAIL_EDIT,codelistTriplet:codelistTriplet,defaultItemsViewMode:defaultItemsViewMode};};var showCodelistDetail=function showCodelistDetail(codelistTriplet,defaultItemsViewMode){return{type:CODELIST_DETAIL_SHOW,codelistTriplet:codelistTriplet,defaultItemsViewMode:defaultItemsViewMode};};var readCodelistDetailItemPage=function readCodelistDetailItemPage(triplet,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc,rebuildDb){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEM_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:triplet&&triplet.id?triplet.id:undefined,agencyId:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:pageNum?pageNum:undefined,pageSize:pageSize?pageSize:undefined,allSearch:searchText?searchText:undefined,codeSearch:filters&&filters.id?filters.id:undefined,nameSearch:filters&&filters.name?filters.name:undefined,parentSearch:filters&&filters.parent?filters.parent:undefined,sortColumn:sortCol?sortCol:undefined,sortDesc:sortByDesc?sortByDesc:undefined,rebuildDb:rebuildDb}),{itemsOrderAnnotationType:itemsOrderAnnotationType});};var updateCodelistDetailItemPageParams=function updateCodelistDetailItemPageParams(params){return{type:CODELIST_DETAIL_ITEM_PAGE_PARAMS_UPDATE,params:params};};var readCodelistDetailItemTree=function readCodelistDetailItemTree(triplet,lang,itemsOrderAnnotationType,rebuildDb){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEM_TREE_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:triplet&&triplet.id?triplet.id:undefined,agencyId:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:1,pageSize:-1,rebuildDb:rebuildDb}),{itemsOrderAnnotationType:itemsOrderAnnotationType});};var changeCodelistDetail=function changeCodelistDetail(fields){return{type:CODELIST_DETAIL_CHANGE,fields:fields};};var submitCodelistDetailCreate=function submitCodelistDetailCreate(codelist,codelistTriplet){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(codelist)],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["v" /* SDMX_JSON_CODELIST_LIST_KEY */]),function(t){return{success:t('reduxComponents.codelistDetail.messages.create.success')};}),{codelistTriplet:codelistTriplet});};var submitCodelistDetailUpdate=function submitCodelistDetailUpdate(codelist,lang,closeDetail){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_97" /* getUpdateCodelistUrl */])(Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(codelist)),lang),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(codelist),function(t){return{success:t('reduxComponents.codelistDetail.messages.update.success')};}),{closeDetail:closeDetail});};var readCodelistDetailAgencies=function readCodelistDetailAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(CODELIST_DETAIL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var changeCodelistDetailItemsViewMode=function changeCodelistDetailItemsViewMode(viewMode){return{type:CODELIST_DETAIL_ITEMS_VIEW_MODE_CHANGE,viewMode:viewMode};};var showCodelistDetailDownload=function showCodelistDetailDownload(artefactTriplets,lang){return{type:CODELIST_DETAIL_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideCodelistDetailDownload=function hideCodelistDetailDownload(){return{type:CODELIST_DETAIL_DOWNLOAD_HIDE};};var changeCodelistDetailDownload=function changeCodelistDetailDownload(fields){return{type:CODELIST_DETAIL_DOWNLOAD_CHANGE,fields:fields};};var submitCodelistDetailDownload=function submitCodelistDetailDownload(artefactTriplets,downloadCodelistParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_7__constants_download__["c" /* ARTEFACT_TYPE_CODELIST */],downloadCodelistParams.format,false,downloadCodelistParams.compression,lang),artefactTriplets.map(function(_ref){var id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_7__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_7__constants_download__["c" /* ARTEFACT_TYPE_CODELIST */],downloadCodelistParams.format,downloadCodelistParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(CODELIST_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_7__constants_download__["c" /* ARTEFACT_TYPE_CODELIST */],artefactTriplets[0],downloadCodelistParams.format,false,downloadCodelistParams.compression,downloadCodelistParams.format===__WEBPACK_IMPORTED_MODULE_7__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadCodelistParams.csvLanguage:lang,downloadCodelistParams.format===__WEBPACK_IMPORTED_MODULE_7__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadCodelistParams.csvSeparator:null,downloadCodelistParams.format===__WEBPACK_IMPORTED_MODULE_7__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadCodelistParams.csvDelimiter:null),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_7__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_7__constants_download__["c" /* ARTEFACT_TYPE_CODELIST */],downloadCodelistParams.format,downloadCodelistParams.compression,downloadCodelistParams.csvLanguage)});};var createCodelistDetailItemsItem=function createCodelistDetailItemsItem(parentId,order,lang){return{type:CODELIST_DETAIL_ITEMS_ITEM_CREATE,parentId:parentId,order:order,lang:lang};};var editCodelistDetailItemsItem=function editCodelistDetailItemsItem(item){return{type:CODELIST_DETAIL_ITEMS_ITEM_SHOW,item:item};};var changeCodelistDetailItemsItem=function changeCodelistDetailItemsItem(fields,lang,itemsOrderAnnotationType){return{type:CODELIST_DETAIL_ITEMS_ITEM_CHANGE,fields:fields,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var submitCodelistDetailItemsItem=function submitCodelistDetailItemsItem(triplet,item,lang,isItemEditMode,autoSave,itemsOrderAnnotationType,itemsTree,cutItem,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["k" /* getNode */])(itemsTree,"codes",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.codes.push(cutItem);parentNode.codes.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}return isItemEditMode?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["n" /* putRequest */])(CODELIST_DETAIL_ITEMS_ITEM_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_100" /* getUpdateItemUrl */])(triplet,lang),Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["g" /* getSQLItemFromItem */])(item,lang,autoSave,itemsOrderAnnotationType),autoSave?function(t){return{success:t('reduxComponents.codelistDetail.messages.update.success')};}:undefined),{unsavedChange:!autoSave}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_ITEM_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_52" /* getInsertItemUrl */])(triplet,lang),Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["g" /* getSQLItemFromItem */])(item,lang,autoSave,itemsOrderAnnotationType),autoSave?function(t){return{success:t('reduxComponents.codelistDetail.messages.update.success')};}:undefined),{unsavedChange:!autoSave});};var hideCodelistDetailItemsItem=function hideCodelistDetailItemsItem(){return{type:CODELIST_DETAIL_ITEMS_ITEM_HIDE};};var deleteCodelistDetailsItemsItem=function deleteCodelistDetailsItemsItem(codelistTriplet,itemId,autoSave,itemsTree,cutItem,lang,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["k" /* getNode */])(itemsTree,"codes",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.codes.push(cutItem);parentNode.codes.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["j" /* deleteRequest */])(CODELIST_DETAIL_ITEMS_ITEM_DELETE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_14" /* getDeleteItemUrl */])(codelistTriplet,itemId,lang,autoSave),autoSave?function(t){return{success:t('reduxComponents.codelistDetail.messages.update.success')};}:undefined),{unsavedChange:!autoSave});};var selectCodelistDetailsItemsItem=function selectCodelistDetailsItemsItem(id){return{type:CODELIST_DETAIL_ITEMS_ITEM_SELECT,id:id};};var showCodelistDetailItemsImportForm=function showCodelistDetailItemsImportForm(){return{type:CODELIST_DETAIL_ITEMS_IMPORT_FORM_SHOW};};var hideCodelistDetailItemsImportForm=function hideCodelistDetailItemsImportForm(){return{type:CODELIST_DETAIL_ITEMS_IMPORT_FORM_HIDE};};var changeCodelistDetailItemsImportForm=function changeCodelistDetailItemsImportForm(fields){return{type:CODELIST_DETAIL_ITEMS_IMPORT_FORM_CHANGE,fields:fields};};var uploadCodelistDetailItemsImportFormFile=function uploadCodelistDetailItemsImportFormFile(codelist,itemsImportForm){var formData=new FormData();formData.append('file',itemsImportForm.file);formData.append('CustomData',JSON.stringify({type:'codelist',identity:{ID:codelist.id,Agency:codelist.agencyID,Version:codelist.version},lang:itemsImportForm.language,firstRowHeader:itemsImportForm.hasHeader,columns:itemsImportForm.hasHeader?{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?3:-1,order:itemsImportForm.hasOrderCol?4:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?5:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?6:-1}:{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?2+itemsImportForm.hasDescriptionCol:-1,order:itemsImportForm.hasOrderCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol+itemsImportForm.hasLayoutAnnotationFullNameCol:-1},textSeparator:itemsImportForm.separator,textDelimiter:itemsImportForm.delimiter}));return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["u" /* getCheckImportedFileCsvItemUrl */])(),formData,function(t){return{success:t('commons.artefact.messages.itemsImport.fileUpload.success')};});};var importCodelistDetailItemsImportFormFile=function importCodelistDetailItemsImportFormFile(codelist,itemsImportForm){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_49" /* getImportFileCsvItemUrl */])(),{hashImport:itemsImportForm.hash,type:'codelist',identity:{ID:codelist.id,Agency:codelist.agencyID,Version:codelist.version},lang:itemsImportForm.language,firstRowHeader:itemsImportForm.hasHeader,columns:itemsImportForm.hasHeader?{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?3:-1,order:itemsImportForm.hasOrderCol?4:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?5:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?6:-1}:{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?2+itemsImportForm.hasDescriptionCol:-1,order:itemsImportForm.hasOrderCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol+itemsImportForm.hasLayoutAnnotationFullNameCol:-1},textSeparator:itemsImportForm.separator,textDelimiter:itemsImportForm.delimiter},function(t){return{success:t('commons.artefact.messages.itemsImport.fileImport.success')};});};var hideCodelistDetail=function hideCodelistDetail(){return{type:CODELIST_DETAIL_HIDE};};var showCodelistDetailItemsItemAnnotations=function showCodelistDetailItemsItemAnnotations(annotations,itemId){return{type:CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW,annotations:annotations,itemId:itemId};};var hideCodelistDetailItemsItemAnnotations=function hideCodelistDetailItemsItemAnnotations(){return{type:CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE};};var showCodelistDetailItemsItemLayoutAnnotations=function showCodelistDetailItemsItemLayoutAnnotations(annotations,itemId){return{type:CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW,annotations:annotations,itemId:itemId};};var hideCodelistDetailItemsItemLayoutAnnotations=function hideCodelistDetailItemsItemLayoutAnnotations(){return{type:CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE};};var showCodelistDetailItemsItemParentList=function showCodelistDetailItemsItemParentList(){return{type:CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW};};var readCodelistDetailItemsItemParentListPage=function readCodelistDetailItemsItemParentListPage(triplet,itemId,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["o" /* getAvailableParentUrl */])(),{Id:triplet.id?triplet.id:undefined,AgencyId:triplet.agencyID?triplet.agencyID:undefined,Version:triplet.version?triplet.version:undefined,ItemForParent:itemId?itemId:undefined,Lang:lang?lang:undefined,PageNum:pageNum?pageNum:undefined,PageSize:pageSize?pageSize:undefined,AllSearch:searchText?searchText:undefined,CodeSearch:filters.id?filters.id:undefined,NameSearch:filters.name?filters.name:undefined,ParentSearch:filters.parent?filters.parent:undefined,SortColumn:sortCol?sortCol:undefined,SortDesc:sortByDesc?sortByDesc:undefined}),{itemsOrderAnnotationType:itemsOrderAnnotationType});};var hideCodelistDetailItemsItemParentList=function hideCodelistDetailItemsItemParentList(){return{type:CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE};};var setCodelistDetailItemsItemParentList=function setCodelistDetailItemsItemParentList(item){return{type:CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SET,item:item};};var unsetCodelistDetailItemsItemParentList=function unsetCodelistDetailItemsItemParentList(){return{type:CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET};};var dropCodelistDetailItemsItem=function dropCodelistDetailItemsItem(artefactTriplet,itemId,newParentId,moveBefore,moveAfter,lang,autoSave,itemsTree,cutItem,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["k" /* getNode */])(itemsTree,"codes",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.codes.push(cutItem);parentNode.codes.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_ITEM_DROP,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_65" /* getMoveItemUrl */])(artefactTriplet,lang),{itemCode:itemId,parent:newParentId,moveBefore:moveBefore?moveBefore:undefined,moveAfter:moveAfter?moveAfter:undefined,autoSave:autoSave},autoSave?function(t){return{success:t('reduxComponents.codelistDetail.messages.update.success')};}:undefined),{unsavedChange:!autoSave});};var changeCodelistDetailCodelistLanguage=function changeCodelistDetailCodelistLanguage(lang,itemsOrderAnnotationType){return{type:CODELIST_DETAIL_LANGUAGE_CHANGE,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var cutCodelistDetailItemsItem=function cutCodelistDetailItemsItem(item){return{type:CODELIST_DETAIL_ITEMS_ITEM_CUT,item:item};};var pasteCodelistDetailItemsItem=function pasteCodelistDetailItemsItem(artefactTriplet,lang,cutItemId,newParentId,pasteAfterId,autoSave){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_ITEM_PASTE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_65" /* getMoveItemUrl */])(artefactTriplet,lang),{itemCode:cutItemId,parent:newParentId?newParentId:undefined,moveAfter:pasteAfterId?pasteAfterId:undefined,autoSave:autoSave},autoSave?function(t){return{success:t('reduxComponents.codelistDetail.messages.update.success')};}:undefined),{unsavedChange:!autoSave});};var showCodelistDetailClone=function showCodelistDetailClone(srcTriplet){return{type:CODELIST_DETAIL_CLONE_SHOW,srcTriplet:srcTriplet};};var hideCodelistDetailClone=function hideCodelistDetailClone(){return{type:CODELIST_DETAIL_CLONE_HIDE};};var changeCodelistDetailClone=function changeCodelistDetailClone(fields){return{type:CODELIST_DETAIL_CLONE_CHANGE,fields:fields};};var submitCodelistDetailClone=function submitCodelistDetailClone(srcTriplet,destTriplet){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["w" /* getCloneCodelistUrl */])(srcTriplet,destTriplet),null,function(t){return{success:t('commons.artefact.messages.clone.success')};});};var changeCodelistDetailItemsAutoSave=function changeCodelistDetailItemsAutoSave(){return{type:CODELIST_DETAIL_ITEMS_AUTOSAVE_CHANGE};};var showCodelistDetailItemsFileSystemTree=function showCodelistDetailItemsFileSystemTree(){return{type:CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_SHOW};};var hideCodelistDetailItemsFileSystemTree=function hideCodelistDetailItemsFileSystemTree(){return{type:CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_HIDE};};var selectCodelistDetailItemsFileSystemTreeItem=function selectCodelistDetailItemsFileSystemTreeItem(selectedItem){return{type:CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_ITEM_SELECT,selectedItem:selectedItem};};var showCodelistDetailExport=function showCodelistDetailExport(sourceTriplet){return{type:CODELIST_DETAIL_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideCodelistDetailExport=function hideCodelistDetailExport(){return{type:CODELIST_DETAIL_EXPORT_HIDE};};var changeCodelistDetailExport=function changeCodelistDetailExport(fields){return{type:CODELIST_DETAIL_EXPORT_CHANGE,fields:fields};};var submitCodelistDetailExport=function submitCodelistDetailExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||[]),EnumType:"CodeList",CopyReferencedArtefact:false,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_10__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideCodelistDetailExportReport=function hideCodelistDetailExportReport(){return{type:CODELIST_DETAIL_EXPORT_REPORT_HIDE};};var changeCodelistDetailTab=function changeCodelistDetailTab(newTab){return{type:CODELIST_DETAIL_TAB_CHANGE,newTab:newTab};};var showCodelistDetailItemsImportFormAllCsvRows=function showCodelistDetailItemsImportFormAllCsvRows(){return{type:CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW};};var hideCodelistDetailItemsImportFormAllCsvRows=function hideCodelistDetailItemsImportFormAllCsvRows(){return{type:CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE};};var uploadCodelistDetailItemsImportFormCsv=function uploadCodelistDetailItemsImportFormCsv(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),fileFormData);};var readCodelistDetailItemsImportFormAllCsvRows=function readCodelistDetailItemsImportFormAllCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,filePath,null,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var updateCodelistDetailDerivedCodelistSourceItemPageParams=function updateCodelistDetailDerivedCodelistSourceItemPageParams(params){return{type:CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_PARAMS_UPDATE,params:params};};var readCodelistDetailDerivedCodelistSourceItemPage=function readCodelistDetailDerivedCodelistSourceItemPage(triplet,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_70" /* getPaginatedDerivedCodelistUrl */])(false),{id:triplet&&triplet.id?triplet.id:undefined,agencyId:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:pageNum?pageNum:undefined,pageSize:pageSize?pageSize:undefined,allSearch:searchText?searchText:undefined,codeSearch:filters&&filters.code?filters.code:undefined,nameSearch:filters&&filters.name?filters.name:undefined,parentSearch:filters&&filters.parent?filters.parent:undefined,sortColumn:sortCol?sortCol:undefined,sortDesc:sortByDesc?sortByDesc:undefined}),{itemsOrderAnnotationType:itemsOrderAnnotationType});};var updateCodelistDetailDerivedCodelistTargetItemPageParams=function updateCodelistDetailDerivedCodelistTargetItemPageParams(params){return{type:CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_PARAMS_UPDATE,params:params};};var readCodelistDetailDerivedCodelistTargetItemPage=function readCodelistDetailDerivedCodelistTargetItemPage(triplet,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_70" /* getPaginatedDerivedCodelistUrl */])(true),{id:triplet&&triplet.id?triplet.id:undefined,agencyId:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:pageNum?pageNum:undefined,pageSize:pageSize?pageSize:undefined,allSearch:searchText?searchText:undefined,codeSearch:filters&&filters.code?filters.code:undefined,nameSearch:filters&&filters.name?filters.name:undefined,parentSearch:filters&&filters.parent?filters.parent:undefined,sortColumn:sortCol?sortCol:undefined,sortDesc:sortByDesc?sortByDesc:undefined}),{itemsOrderAnnotationType:itemsOrderAnnotationType});};var selectCodelistDetailDerivedCodelistSourceItem=function selectCodelistDetailDerivedCodelistSourceItem(itemId,triplet,isSelected,lang){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_SELECT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_23" /* getDerivedCodelistSelectSourceItemUrl */])(triplet,isSelected,lang),[itemId]);};var selectCodelistDetailDerivedCodelistTargetItem=function selectCodelistDetailDerivedCodelistTargetItem(itemId,triplet,isSelected,lang){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_SELECT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_24" /* getDerivedCodelistSelectTargetItemUrl */])(triplet,isSelected,lang),[itemId]);};var selectCodelistDetailDerivedCodelistSourceTreeItem=function selectCodelistDetailDerivedCodelistSourceTreeItem(itemsIds){return{type:CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_TREE_ITEM_SELECT,itemsIds:itemsIds};};var selectCodelistDetailDerivedCodelistTargetTreeItem=function selectCodelistDetailDerivedCodelistTargetTreeItem(itemsIds){return{type:CODELIST_DETAIL_DERIVED_CODELIST_TARGET_TREE_ITEM_SELECT,itemsIds:itemsIds};};var selectCodelistDetailDerivedCodelistAllItems=function selectCodelistDetailDerivedCodelistAllItems(triplet,isTarget,isSelected,filter,lang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_ALL_ITEMS_SELECT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_22" /* getDerivedCodelistSelectAllItemsUrl */])(triplet,isTarget,isSelected,lang),filter?{id:triplet&&triplet.id?triplet.id:undefined,agencyId:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:1,pageSize:-1,allSearch:filter.searchText?filter.searchText:undefined,codeSearch:filter.filters&&filter.filters.code?filter.filters.code:undefined,nameSearch:filter.filters&&filter.filters.name?filter.filters.name:undefined,parentSearch:filter.filters&&filter.filters.parent?filter.filters.parent:undefined,sortColumn:filter.sortCol?filter.sortCol:undefined,sortDesc:filter.sortByDesc?filter.sortByDesc:undefined}:null),{isTarget:isTarget});};var storeCodelistDetailDerivedCodelistSelectedItems=function storeCodelistDetailDerivedCodelistSelectedItems(isTarget,triplet,lang,importCheckbox){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_SELECTED_ITEMS_STORE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_25" /* getDerivedCodelistStoreSelectedItemsUrl */])(triplet,isTarget,lang,importCheckbox?!importCheckbox.preserveHierarchy:false,importCheckbox&&importCheckbox.preserveHierarchy?importCheckbox.importParents:false,importCheckbox&&importCheckbox.preserveHierarchy?importCheckbox.importChildren:false,importCheckbox&&importCheckbox.preserveHierarchy?importCheckbox.importDescendants:false));};var changeCodelistDetailDerivedCodelistCheckbox=function changeCodelistDetailDerivedCodelistCheckbox(checkbox){return{type:CODELIST_DETAIL_DERIVED_CODELIST_CHECKBOX_CHANGE,checkbox:checkbox};};var showCodelistDetailDerivedCodelistCreate=function showCodelistDetailDerivedCodelistCreate(codelistTriplet,lang){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SHOW,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_20" /* getDerivedCodelistIsSourceItemValidUrl */])(codelistTriplet,lang));};var hideCodelistDetailDerivedCodelistCreate=function hideCodelistDetailDerivedCodelistCreate(){return{type:CODELIST_DETAIL_DERIVED_CODELIST_CREATE_HIDE};};var changeCodelistDetailDerivedCodelistCreate=function changeCodelistDetailDerivedCodelistCreate(fields){return{type:CODELIST_DETAIL_DERIVED_CODELIST_CREATE_CHANGE,fields:fields};};var submitCodelistDetailDerivedCodelistCreate=function submitCodelistDetailDerivedCodelistCreate(triplet,lang,derivedCodelist){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_19" /* getDerivedCodelistCreateUrl */])(triplet,lang),Object.assign({},derivedCodelist,{names:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.pickBy(derivedCodelist.name,function(val){return val.length>0;}),name:undefined}));};var restoreCodelistDetailDerivedCodelistDb=function restoreCodelistDetailDerivedCodelistDb(triplet){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["j" /* deleteRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_DB_RESTORE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_21" /* getDerivedCodelistRestoreDbUrl */])(triplet)));};var focusCodelistDetailDerivedTab=function focusCodelistDetailDerivedTab(){return{type:CODELIST_DETAIL_DERIVED_TAB_FOCUS};};var unfocusCodelistDetailDerivedTab=function unfocusCodelistDetailDerivedTab(){return{type:CODELIST_DETAIL_DERIVED_TAB_UNFOCUS};};var setCodelistDetailItemsDefaultOrder=function setCodelistDetailItemsDefaultOrder(triplet,lang){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_ITEMS_DEFAULT_ORDER_SET,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_86" /* getSetDefaultOrderUrl */])(triplet,lang),[],function(t){return{success:t('reduxComponents.codelistDetail.messages.update.success')};});};var changeCodelistDetailDerivedCodelistViewMode=function changeCodelistDetailDerivedCodelistViewMode(mode,triplet){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["j" /* deleteRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_VIEW_MODE_CHANGE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_21" /* getDerivedCodelistRestoreDbUrl */])(triplet)),{mode:mode});};var readCodelistDetailDerivedCodelistSourceItemTree=function readCodelistDetailDerivedCodelistSourceItemTree(triplet,lang,itemsOrderAnnotationType){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_TREE_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_70" /* getPaginatedDerivedCodelistUrl */])(false),{id:triplet.id,agencyId:triplet.agencyID,version:triplet.version,lang:lang,pageNum:1,pageSize:-1}),{itemsOrderAnnotationType:itemsOrderAnnotationType});};var readCodelistDetailDerivedCodelistTargetItemTree=function readCodelistDetailDerivedCodelistTargetItemTree(triplet,lang,itemsOrderAnnotationType){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_TREE_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_70" /* getPaginatedDerivedCodelistUrl */])(true),{id:triplet.id,agencyId:triplet.agencyID,version:triplet.version,lang:lang,pageNum:1,pageSize:-1}),{itemsOrderAnnotationType:itemsOrderAnnotationType});};var storeCodelistDetailDerivedCodelistItems=function storeCodelistDetailDerivedCodelistItems(items,isTarget,triplet,lang,importCheckbox){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["i" /* allRequest */])(CODELIST_DETAIL_DERIVED_CODELIST_ITEMS_STORE,[__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */],__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */]],[isTarget?Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_24" /* getDerivedCodelistSelectTargetItemUrl */])(triplet,true,lang):Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_23" /* getDerivedCodelistSelectSourceItemUrl */])(triplet,true,lang),Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_25" /* getDerivedCodelistStoreSelectedItemsUrl */])(triplet,isTarget,lang,false,false,false,false)],[items.filter(function(id){return!(id&&id.startsWith(__WEBPACK_IMPORTED_MODULE_9__components_tree_filter_utils__["b" /* TREE_NODE_KEY_PREFIX */]));}),undefined],undefined,undefined,true);};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DCS_ORDERED_TREE_ROOT; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getCubesTree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tree__ = __webpack_require__(32);
var DCS_ORDERED_TREE_ROOT={CatCode:'DCS',labels:{en:'Default Category Scheme',/* TODO: translatable */it:'Category Scheme di Lavoro'}};function getCubesTree(cubesJson,dcsJson){return Object(__WEBPACK_IMPORTED_MODULE_0__tree__["d" /* getCategorisedObjectsTree */])(cubesJson,[Object.assign({},DCS_ORDERED_TREE_ROOT,{children:Object(__WEBPACK_IMPORTED_MODULE_0__tree__["c" /* getCategoriesOrderedTree */])(dcsJson,'children',function(cat,anch){return anch?cat.ParCode===anch.CatCode:cat.ParCode!==null;},function(a,b){return(a.Code||-1)-(b.Code||-1)||a.CatCode-b.CatCode;})})],'children',function(a,b){return a.Code-b.Code;},function(obj,cat){return cat?obj.IDCat===cat.IDCat:obj.IDCat!==null;},'CatCode','labels',true);}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__infinite_scroll_table__ = __webpack_require__(52);
var InfiniteScrollDataTable=function InfiniteScrollDataTable(_ref){var data=_ref.data,cols=_ref.cols,height=_ref.height,hiddenCols=_ref.hiddenCols,rowTotal=_ref.rowTotal,onChange=_ref.onChange,rowSelection=_ref.rowSelection,getRowKey=_ref.getRowKey,onRowClick=_ref.onRowClick,noFilter=_ref.noFilter,noSort=_ref.noSort,isPaginated=_ref.isPaginated;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__infinite_scroll_table__["a" /* default */],{data:data,height:height,rowCount:rowTotal,getRowKey:getRowKey||JSON.stringify,columns:cols?cols.filter(function(col){return!hiddenCols||hiddenCols.filter(function(hiddenCol){return hiddenCol===col;}).length===0;}).map(function(col){return{title:col,dataIndex:col,minWidthToContent:true,noFilter:noFilter,noSort:noSort};}):null,onChange:onChange,isPaginated:isPaginated!==undefined?isPaginated:true,autoSearch:false,rowSelection:rowSelection,onRowClick:onRowClick});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])()(InfiniteScrollDataTable));

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(732);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Divider = function Divider(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        _props$type = props.type,
        type = _props$type === void 0 ? 'horizontal' : _props$type,
        _props$orientation = props.orientation,
        orientation = _props$orientation === void 0 ? '' : _props$orientation,
        className = props.className,
        children = props.children,
        dashed = props.dashed,
        restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed"]);

    var prefixCls = getPrefixCls('divider', customizePrefixCls);
    var orientationPrefix = orientation.length > 0 ? '-' + orientation : orientation;
    var classString = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), children), _defineProperty(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), _classNames));
    return React.createElement("div", _extends({
      className: classString
    }, restProps), children && React.createElement("span", {
      className: "".concat(prefixCls, "-inner-text")
    }, children));
  });
};

var _default = Divider;
exports["default"] = _default;

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return REPORT_ID_ANNOTATION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return METADATA_SET_ID_ANNOTATION_ID; });
/* unused harmony export REPORT_STATE_ID_ANNOTATION_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return REPORT_STATE_NAME_ANNOTATION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REPORT_STATE_NOT_PUBLISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return REPORT_STATE_PUBLISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REPORT_STATE_DRAFT; });
/* unused harmony export REPORT_STATE_DRAFT_ID */
/* unused harmony export REPORT_STATE_NOT_PUBLISHED_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CATALOG_TARGET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DATAFLOW_TARGET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CATALOG_IDENTIFIER; });
/* unused harmony export DATASET_IDENTIFIER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return EMPTY_REPORT_ATTRIBUTE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTRIBUTE_TEXT_TYPE_BOOLEAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ATTRIBUTE_TEXT_TYPE_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ATTRIBUTE_TEXT_TYPE_XHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ATTRIBUTE_TEXT_TYPE_DATETIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ATTRIBUTE_TEXT_TYPE_GREGORIANDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ATTRIBUTE_TEXT_TYPE_TIME; });
/* unused harmony export ATTRIBUTE_TEXT_TYPE_ALPHANUMERIC */
/* unused harmony export ATTRIBUTE_TEXT_TYPE_ALPHA */
/* unused harmony export ATTRIBUTE_TEXT_TYPES_INTEGER */
/* unused harmony export ATTRIBUTE_TEXT_TYPES_DECIMAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ATTRIBUTE_TEXT_TYPE_GREGORIANYEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ATTRIBUTE_TEXT_TYPE_GREGORIANYEARMONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ATTRIBUTE_TEXT_TYPE_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ATTRIBUTE_TEXT_TYPE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ATTRIBUTE_TEXT_TYPE_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ATTRIBUTE_TEXT_TYPE_MONTHDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ATTRIBUTE_TEXT_TYPE_YEARMONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ATTRIBUTE_TEXT_TYPE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ATTRIBUTE_TEXT_TYPE_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ATTRIBUTE_TEXT_TYPE_FORMAT_DATETIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ATTRIBUTE_TEXT_TYPE_FORMAT_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ATTRIBUTE_TEXT_TYPE_FORMAT_TIME; });
/* unused harmony export getReportNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return isEmptyAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getMsdTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getReportStructureFromSdmxJsonReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getSdmxJsonReportFromReportStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getMetadataflowTripletFromAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getDbIdAnnotationFromAnnotations; });
/* unused harmony export getAttachmentAnnotationFromAnnotations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return updateReportStateAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getCustomIsPresentationalFromAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getCategorisationsFromAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getAttributeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getMetadataSetHtmlPageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getDcatMetadataSetHtmlPageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getDcatMetadataSetCategoryHtmlPageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getReportHtmlPageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getMetadataApiReportUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getMetadataApiDcatReportUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getMetadataApiDcatMetadataSetUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getNextAttributeIndexAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return isAttributeValueValorizedAndValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return isAttributeValueValid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__languages__ = __webpack_require__(91);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var REPORT_ID_ANNOTATION_ID="ReportId";var METADATA_SET_ID_ANNOTATION_ID="MetadataSetId";var REPORT_STATE_ID_ANNOTATION_ID="ReportStateId";var REPORT_STATE_NAME_ANNOTATION_ID="ReportStateName";var REPORT_STATE_NOT_PUBLISHED="NOT_PUBLISHED";var REPORT_STATE_PUBLISHED="PUBLISHED";var REPORT_STATE_DRAFT="DRAFT";var REPORT_STATE_DRAFT_ID="4";var REPORT_STATE_NOT_PUBLISHED_ID="2";var CATALOG_TARGET_ID="CATALOG_TARGET_ID";var DATAFLOW_TARGET_ID="DATAFLOW_TARGET_ID";var CATALOG_IDENTIFIER="CATALOG_IDENTIFIER";var DATASET_IDENTIFIER="DATASET_IDENTIFIER";var FOLDER_KEY="FOLDER___";var EMPTY_REPORT_ATTRIBUTE_KEY="EMPTY_REPORT_ATTRIBUTE___";var ATTRIBUTE_TEXT_TYPE_BOOLEAN="boolean";var ATTRIBUTE_TEXT_TYPE_STRING="string";var ATTRIBUTE_TEXT_TYPE_XHTML="xhtml";var ATTRIBUTE_TEXT_TYPE_DATETIME="datetime";var ATTRIBUTE_TEXT_TYPE_GREGORIANDAY="gregorianday";var ATTRIBUTE_TEXT_TYPE_TIME="time";var ATTRIBUTE_TEXT_TYPE_ALPHANUMERIC="alphanumeric";var ATTRIBUTE_TEXT_TYPE_ALPHA="alpha";var ATTRIBUTE_TEXT_TYPES_INTEGER=["numeric","integer","biginteger","long","short","count"];var ATTRIBUTE_TEXT_TYPES_DECIMAL=["decimal","float","double","inclusivevaluerange","exclusivevaluerange","incremental"];var ATTRIBUTE_TEXT_TYPE_GREGORIANYEAR="gregorianyear";var ATTRIBUTE_TEXT_TYPE_GREGORIANYEARMONTH="gregorianyearmonth";var ATTRIBUTE_TEXT_TYPE_DAY="day";var ATTRIBUTE_TEXT_TYPE_MONTH="month";var ATTRIBUTE_TEXT_TYPE_YEAR="year";// SDMX v2.0
var ATTRIBUTE_TEXT_TYPE_MONTHDAY="monthday";var ATTRIBUTE_TEXT_TYPE_YEARMONTH="yearmonth";// SDMX v2.0
var ATTRIBUTE_TEXT_TYPE_DATE="date";// SDMX v2.0
var ATTRIBUTE_TEXT_TYPE_URI="uri";var ATTRIBUTE_TEXT_TYPE_FORMAT_DATETIME="YYYY-MM-DD HH:mm:ss";var ATTRIBUTE_TEXT_TYPE_FORMAT_DATE="YYYY-MM-DD";var ATTRIBUTE_TEXT_TYPE_FORMAT_TIME="HH:mm:ss";var AUTO_ANNOTATIONS=["repattributeid"];/** structures utilities **/// visit report structure and call map for all node
function getMappedReportTree(tree,map){tree=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(tree);tree=tree.map(function(root){return map(root);});tree=tree.map(function(subTree){if(subTree&&subTree.attributeSet&&subTree.attributeSet.reportedAttributes){subTree.attributeSet.reportedAttributes=getMappedReportTree(subTree.attributeSet.reportedAttributes,map);}return subTree;});return tree;}// visit report structure and return, if present, the matching node
function getReportNode(tree,test){if(!(tree!==null&&tree.length))return null;var foundNodes=tree.filter(test);if(foundNodes.length){return foundNodes[0];}else{var foundNodesInChild=tree.filter(function(node){return node.attributeSet.reportedAttributes;}).map(function(node){return getReportNode(node.attributeSet.reportedAttributes,test);}).filter(function(result){return result!==null;});if(foundNodesInChild.length){return foundNodesInChild[0];}else{return null;}}}// check if an attribute has a valid "texts" field or not
var isEmptyAttribute=function isEmptyAttribute(attr){var isValidText=function isValidText(text){if(!text){return false;}var parsedText=(new DOMParser().parseFromString(text,"text/html").documentElement.textContent||"").trim();return parsedText.length>0;};if(!attr.isFolder&&!attr.isPresentational){if(getAttributeType(attr).toLowerCase()===ATTRIBUTE_TEXT_TYPE_BOOLEAN){return false;}else if(attr.texts===null||attr.texts===undefined||(typeof attr.texts==='string'||attr.texts instanceof String)&&!isValidText(attr.texts)||(_typeof(attr.texts)==='object'||attr.texts instanceof Object)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default()(attr.texts).pickBy(function(val){return isValidText(val);}).keys().value().length===0){return true;}}return false;};// gets a tree structure from msd
var getMsdTree=function getMsdTree(msd,conceptSchemes,appLang,dataLangs,annotationsConfig,permissions){var customIsPresentational=getCustomIsPresentationalFromAnnotations(msd,annotationsConfig);// iterates on msd structure and initialize utility fields
var msdTree=msd.metadataStructureComponents.reportStructureList.reportStructures.map(function(reportStructure){return{target:reportStructure.metadataTargetId[0],metadataAttributes:Object(__WEBPACK_IMPORTED_MODULE_5__tree__["h" /* getMappedTree */])(reportStructure.metadataAttributeList.metadataAttributes,"metadataAttributes",function(node){var isMultiLangAnnot=node.annotations&&node.annotations.find(function(annot){return(annot.type||"").toLowerCase()===(annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["f" /* AUTO_ANNOTATION_IS_MULTILINGUAL_KEY */]]||"").toLowerCase();});var isMultiLang=isMultiLangAnnot&&isMultiLangAnnot.title==="True";var attributeType=getAttributeType(node).toLowerCase();return Object.assign({},node,{texts:null,metadataAttributes:(node.metadataAttributes||[]).map(function(child){return Object.assign({},child,{parent:node.id});}),annotations:[],autoAnnotations:[],isMultiLang:node.id==="DCAT_AP_IT_DATASET_IDENTIFIER"?false:attributeType===ATTRIBUTE_TEXT_TYPE_STRING||attributeType===ATTRIBUTE_TEXT_TYPE_XHTML?true:!!isMultiLang,attachment:Object(__WEBPACK_IMPORTED_MODULE_10__languages__["a" /* getEmptyDictionaryForLanguages */])(dataLangs,null),attachmentName:Object(__WEBPACK_IMPORTED_MODULE_10__languages__["a" /* getEmptyDictionaryForLanguages */])(dataLangs,null),attachmentUploaded:Object(__WEBPACK_IMPORTED_MODULE_10__languages__["a" /* getEmptyDictionaryForLanguages */])(dataLangs,false),isPublic:true,isPresentational:!customIsPresentational?node.isPresentational:node.isPresentational||(node.metadataAttributes||[]).length>0});}),identifiableTargets:msd.metadataStructureComponents.metadataTargetList.metadataTargets.find(function(target){return target.id===reportStructure.metadataTargetId[0];}).identifiableTarget.map(function(identifiableTarget){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(identifiableTarget,"id","objectType");})};});// iterates on msd tree and add folder nodes to handle attribute cardinality
var getFolderFromNode=function getFolderFromNode(node){return Object.assign({},node,{id:FOLDER_KEY+node.id,isFolder:true,metadataAttributes:[Object.assign({},node,{metadataAttributes:[]})]});};msdTree=msdTree.map(function(el){var tempTree=[];Object(__WEBPACK_IMPORTED_MODULE_5__tree__["h" /* getMappedTree */])([el],"metadataAttributes",function(node){node.metadataAttributes.forEach(function(child){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_5__tree__["k" /* getNode */])(tempTree,"metadataAttributes",function(_ref){var id=_ref.id;return id===child.parent;});if(child.minOccurs!=='1'||child.maxOccurs!=='1'){(parentNode?parentNode.metadataAttributes:tempTree).push(getFolderFromNode(child));}else{(parentNode?parentNode.metadataAttributes:tempTree).push(Object.assign({},child,{metadataAttributes:[]}));}});return node;});return Object.assign({},el,{metadataAttributes:tempTree});});// iterates on msd tree and add all the required attributes + an empty one as child of the corresponding folder
msdTree=msdTree.map(function(el){return Object.assign({},el,{metadataAttributes:Object(__WEBPACK_IMPORTED_MODULE_5__tree__["h" /* getMappedTree */])(el.metadataAttributes,"metadataAttributes",function(node){if(node.isFolder){node.id=node.id.substring(FOLDER_KEY.length);var metadataAttributes=[];for(var i=1;i<=node.minOccurs;i++){metadataAttributes.push(Object.assign({},node.metadataAttributes[0],{id:i+". "+node.id}));}metadataAttributes.push(Object.assign({},node.metadataAttributes[0],{id:EMPTY_REPORT_ATTRIBUTE_KEY+node.id}));node.metadataAttributes=metadataAttributes;}return node;})});});// iterates on msd tree and add to all node the corresponding name taken from associated conceptScheme
msdTree=msdTree.map(function(el){return Object.assign({},el,{metadataAttributes:Object(__WEBPACK_IMPORTED_MODULE_5__tree__["h" /* getMappedTree */])(el.metadataAttributes,"metadataAttributes",function(node){var nodeStr=Object(__WEBPACK_IMPORTED_MODULE_7__sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_7__sdmxJson__["P" /* getArtefactTripletFromUrn */])(node.conceptIdentity));var nodeConceptScheme=conceptSchemes.find(function(conceptScheme){return Object(__WEBPACK_IMPORTED_MODULE_7__sdmxJson__["_1" /* getStringFromArtefactTriplet */])(conceptScheme)===nodeStr;});if(nodeConceptScheme){var concept=nodeConceptScheme.concepts.find(function(concept){return concept.id===node.conceptIdentity.split(".").pop();});if(concept){var prefix=node.id.match(/\d+. /g);return Object.assign({},node,{name:(prefix?prefix:'')+Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_i18n_utils__["a" /* getLocalizedStr */])(concept.name,appLang,dataLangs)});}}return Object.assign({},node,{name:node.id});})});});return msdTree;};// gets report structure from SDMXJson report
var getReportStructureFromSdmxJsonReport=function getReportStructureFromSdmxJsonReport(msdTree,target,report,dataLanguages,t,annotationsConfig,permissions){// gets text from attribute
var getTexts=function getTexts(node,attribute){if(attribute.texts===null||attribute.texts===undefined){return null;}var attributeType=getAttributeType(node).toLowerCase();if(node.localRepresentation.enumeration){return attribute.texts;}else if(attributeType===ATTRIBUTE_TEXT_TYPE_DATETIME){return __WEBPACK_IMPORTED_MODULE_3_moment___default()(attribute.texts["und"],ATTRIBUTE_TEXT_TYPE_FORMAT_DATETIME);}else if(attributeType===ATTRIBUTE_TEXT_TYPE_GREGORIANDAY){return __WEBPACK_IMPORTED_MODULE_3_moment___default()(attribute.texts["und"],ATTRIBUTE_TEXT_TYPE_FORMAT_DATE);}else if(attributeType===ATTRIBUTE_TEXT_TYPE_TIME){return __WEBPACK_IMPORTED_MODULE_3_moment___default()(attribute.texts["und"],ATTRIBUTE_TEXT_TYPE_FORMAT_TIME);}else if(attributeType===ATTRIBUTE_TEXT_TYPE_BOOLEAN){return(attribute.texts["und"]||"").toLowerCase()==="true";}else if(node.isMultiLang){if(attributeType===ATTRIBUTE_TEXT_TYPE_XHTML||attributeType===ATTRIBUTE_TEXT_TYPE_STRING){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forOwn(attribute.texts,function(val,key){return attribute.texts[key]=decodeURIComponent(val);});}else{return attribute.texts;}}else{if(attributeType===ATTRIBUTE_TEXT_TYPE_XHTML||attributeType===ATTRIBUTE_TEXT_TYPE_STRING){return decodeURIComponent(attribute.texts["und"]);}else{return attribute.texts["und"];}}};var tree=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(msdTree);// gets the corresponding report structures and add an unique key
var reportStructure=[];reportStructure=tree.find(function(el){return el.target===target;}).metadataAttributes;reportStructure=Object(__WEBPACK_IMPORTED_MODULE_5__tree__["h" /* getMappedTree */])(reportStructure,"metadataAttributes",function(node){return Object.assign({},node,{nodeKey:__WEBPACK_IMPORTED_MODULE_4_uuid___default()()});});// if report is defined this need to be initialized
if(report){reportStructure=getReportStructuresWithPath(reportStructure);// remove all empty node added by getMsdTree. this is required to avoid to add empty nodes in the next steps
reportStructure=Object(__WEBPACK_IMPORTED_MODULE_5__tree__["f" /* getFilteredTree */])(reportStructure,"metadataAttributes",function(node){return!node.id||!node.id.match(/\d+\. \w+/g);});// iterates on report adding to all nodes "isFolder" taken from the corresponding node in reportStructures
var reportRoot=[{isRoot:true,attributeSet:{reportedAttributes:report&&report.attributeSet&&report.attributeSet.reportedAttributes?report.attributeSet.reportedAttributes:[]}}];report=getMappedReportTree(reportRoot,function(attr){if(attr.isRoot){return attr;}var node=Object(__WEBPACK_IMPORTED_MODULE_5__tree__["k" /* getNode */])(reportStructure,"metadataAttributes",function(node){return node.id===attr.id.replace(/\d+. /g,"");});return Object.assign({},attr,{isFolder:node.isFolder,attributeSet:{reportedAttributes:attr&&attr.attributeSet&&attr.attributeSet.reportedAttributes?attr.attributeSet.reportedAttributes:[]}});});// iterates on report adding to all attribute the prefix "N. "
report=getMappedReportTree(report,function(attr){var counts={};(attr.attributeSet.reportedAttributes||[]).forEach(function(attr){if(attr.isFolder){counts[attr.id]=1;}});attr.attributeSet.reportedAttributes=(attr.attributeSet.reportedAttributes||[]).map(function(attr){if(!counts[attr.id]){return attr;}else{var newAttr=Object.assign({},attr,{id:counts[attr.id]+'. '+attr.id});counts[attr.id]=counts[attr.id]+1;return newAttr;}});return attr;})[0].attributeSet.reportedAttributes;// iterates on report adding to all attribute the path from root
report=report.map(function(attr){return Object.assign({},attr,{path:''});});report=getMappedReportTree(report,function(attr){return Object.assign({},attr,{attributeSet:{reportedAttributes:(attr.attributeSet.reportedAttributes||[]).map(function(child){return Object.assign({},child,{path:attr.path.length>0?attr.path+'+'+attr.id:attr.id});})}});});// iterates on report to create or initialize the corresponding node in reportStructures
getMappedReportTree(report,function(attr){var node=Object(__WEBPACK_IMPORTED_MODULE_5__tree__["k" /* getNode */])(reportStructure,"metadataAttributes",function(node){return node.id===attr.id.replace(/\d+. /g,"")&&node.path===attr.path;});if(node!==null){var attachmentAnnot=getAttachmentAnnotationFromAnnotations(attr,annotationsConfig);var attachment=Object(__WEBPACK_IMPORTED_MODULE_10__languages__["a" /* getEmptyDictionaryForLanguages */])(dataLanguages,null);var attachmentName=Object(__WEBPACK_IMPORTED_MODULE_10__languages__["a" /* getEmptyDictionaryForLanguages */])(dataLanguages,null);if(attachmentAnnot!==null&&attachmentAnnot!==undefined){attachmentName=Object.assign({},attachmentName,attachmentAnnot.texts);}var attachmentUploaded=Object(__WEBPACK_IMPORTED_MODULE_10__languages__["a" /* getEmptyDictionaryForLanguages */])(dataLanguages,false);if(attachmentAnnot!==null&&attachmentAnnot!==undefined){Object.keys(attachmentAnnot.texts).forEach(function(key){attachmentUploaded[key]=true;});}var customNoneIsAutoAnnotation=permissions&&permissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;if(!node.isFolder){node.annotations=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(node.annotations.concat(Object(__WEBPACK_IMPORTED_MODULE_6__artefacts__["d" /* getFilteredAnnotations */])(attr.annotations,annotationsConfig,customNoneIsAutoAnnotation||isReferenceMetadataAutoAnnotation)).map(function(annot){return Object.assign({},annot,{text:annot.texts,texts:undefined});}),"type");node.autoAnnotations=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(node.autoAnnotations.concat(Object(__WEBPACK_IMPORTED_MODULE_6__artefacts__["c" /* getAutoAnnotations */])(attr.annotations,annotationsConfig,customNoneIsAutoAnnotation||isReferenceMetadataAutoAnnotation)).map(function(annot){return Object.assign({},annot,{text:annot.texts,texts:undefined});}),"type");if(!node.isPresentational){node.texts=getTexts(node,attr);node.path=attr.path;node.nodeKey=__WEBPACK_IMPORTED_MODULE_4_uuid___default()();node.attachment=attachment;node.attachmentName=attachmentName;node.attachmentUploaded=attachmentUploaded;node.isPublic=getIsPublicFromAnnotations(attr.annotations,annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["g" /* AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY */]]);}}else{if(attr.texts||attr.attributeSet&&attr.attributeSet.reportedAttributes&&attr.attributeSet.reportedAttributes.length>0){var newChild=node.metadataAttributes.find(function(child){return child.id===EMPTY_REPORT_ATTRIBUTE_KEY+attr.id.replace(/\d+. /g,"");});node.metadataAttributes.push(Object.assign({},newChild,{isFolder:null,id:node.metadataAttributes.length+". "+node.id,name:node.metadataAttributes.length+". "+node.name,nodeKey:__WEBPACK_IMPORTED_MODULE_4_uuid___default()(),texts:getTexts(newChild,attr),annotations:newChild.annotations.concat(Object(__WEBPACK_IMPORTED_MODULE_6__artefacts__["d" /* getFilteredAnnotations */])(attr.annotations,annotationsConfig,customNoneIsAutoAnnotation||isReferenceMetadataAutoAnnotation)).map(function(annot){return Object.assign({},annot,{text:annot.texts,texts:undefined});}),autoAnnotations:Object(__WEBPACK_IMPORTED_MODULE_6__artefacts__["c" /* getAutoAnnotations */])(attr.annotations,annotationsConfig,customNoneIsAutoAnnotation||isReferenceMetadataAutoAnnotation),path:attr.path,attachment:attachment,attachmentName:attachmentName,attachmentUploaded:attachmentUploaded,isPublic:getIsPublicFromAnnotations(attr.annotations,annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["g" /* AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY */]])}));node.metadataAttributes=getReportStructuresWithPath(node.metadataAttributes);}}}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t("components.reportStructureTree.modals.warning.attributeNotPresent.title"),content:t("components.reportStructureTree.modals.warning.attributeNotPresent.content",{attributeId:attr.id})});}return attr;});}return Object(__WEBPACK_IMPORTED_MODULE_5__tree__["f" /* getFilteredTree */])(reportStructure,"metadataAttributes",function(node){return!node.id||!node.id.includes(EMPTY_REPORT_ATTRIBUTE_KEY);});};// gets SDMXJson report from report structure
var getSdmxJsonReportFromReportStructure=function getSdmxJsonReportFromReportStructure(reportStructure,report,annotationsConfig){// gets text from attribute
var getTexts=function getTexts(attr){if(attr.texts===null||attr.texts===undefined||attr.isPresentational||attr.isFolder){return null;}var attributeType=getAttributeType(attr).toLowerCase();if(attr.localRepresentation.enumeration!==null){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pickBy(attr.texts,function(val){return(val||"").length>0;});}else if(attributeType===ATTRIBUTE_TEXT_TYPE_DATETIME){return{und:__WEBPACK_IMPORTED_MODULE_3_moment___default()(attr.texts).format(ATTRIBUTE_TEXT_TYPE_FORMAT_DATETIME)};}else if(attributeType===ATTRIBUTE_TEXT_TYPE_GREGORIANDAY){return{und:__WEBPACK_IMPORTED_MODULE_3_moment___default()(attr.texts).format(ATTRIBUTE_TEXT_TYPE_FORMAT_DATE)};}else if(attributeType===ATTRIBUTE_TEXT_TYPE_TIME){return{und:__WEBPACK_IMPORTED_MODULE_3_moment___default()(attr.texts).format(ATTRIBUTE_TEXT_TYPE_FORMAT_TIME)};}else if(attributeType===ATTRIBUTE_TEXT_TYPE_BOOLEAN){return{und:attr.texts};}else if(attr.isMultiLang){if(attributeType===ATTRIBUTE_TEXT_TYPE_XHTML||attributeType===ATTRIBUTE_TEXT_TYPE_STRING){var texts=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pickBy(attr.texts,function(val){return(val||"").length>0;});return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forOwn(texts,function(val,key){return texts[key]=encodeURIComponent(val);});}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pickBy(attr.texts,function(val){return(val||"").length>0;});}}else{if(attributeType===ATTRIBUTE_TEXT_TYPE_XHTML||attributeType===ATTRIBUTE_TEXT_TYPE_STRING){return{und:encodeURIComponent(attr.texts)};}else{return{und:attr.texts};}}};// iterates on reportStructure to create or initialize the corresponding node in report
reportStructure=getReportStructuresWithPath(reportStructure);Object(__WEBPACK_IMPORTED_MODULE_5__tree__["i" /* getMappedTreeDeptFirst */])(reportStructure,"metadataAttributes",function(node){if(!node.isFolder){var annotations=node.annotations||[];var autoAnnotations=node.autoAnnotations||[];var allAnnotations=annotations.concat(autoAnnotations);// handling of restricted for publication annotation
if(annotationsConfig){var isNotPublicAnnotation=allAnnotations.find(function(_ref2){var type=_ref2.type;return(type||"").toLowerCase()===annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["g" /* AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY */]].toLowerCase();});if(node.isPublic){if(isNotPublicAnnotation){allAnnotations=allAnnotations.filter(function(_ref3){var type=_ref3.type;return(type||"").toLowerCase()!==annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["g" /* AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY */]].toLowerCase();});}}else{if(!isNotPublicAnnotation){allAnnotations.push({id:annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["g" /* AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY */]],type:annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["g" /* AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY */]],title:annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["g" /* AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY */]]});}}}// handling of attachment annotation
if(annotationsConfig){allAnnotations=getAnnotationsWithAttachmentAnnot(node,allAnnotations,annotationsConfig);}var tempNode={id:node.id,texts:getTexts(node),annotations:allAnnotations.length>0?allAnnotations.map(function(annot){return Object.assign({},annot,{text:undefined,texts:annot.text});}):null,attributeSet:{reportedAttributes:[]},path:node.path};if(!node.parent){report.attributeSet.reportedAttributes.push(tempNode);}else{var reportNode=getReportNode(report.attributeSet.reportedAttributes,function(attr){return node.path===""+(attr.path.length>0?attr.path+'+':'')+attr.id;});reportNode.attributeSet.reportedAttributes.push(tempNode);}}return node;});// iterates on report to remove all unnecessary fields
report.attributeSet.reportedAttributes=getMappedReportTree(report.attributeSet.reportedAttributes,function(attr){return{id:attr.id.replace(/\d+. /g,""),texts:attr.texts,annotations:attr.annotations,attributeSet:attr&&attr.attributeSet&&attr.attributeSet.reportedAttributes&&attr.attributeSet.reportedAttributes.length>0?attr.attributeSet:undefined};});return report;};// iterates on reportStructures adding to all nodes the path to root node
var getReportStructuresWithPath=function getReportStructuresWithPath(reportStructure){var reportStructureWithPath=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(reportStructure);reportStructureWithPath=reportStructureWithPath.map(function(node){return Object.assign({},node,{path:node.path?node.path:''});});reportStructureWithPath=Object(__WEBPACK_IMPORTED_MODULE_5__tree__["h" /* getMappedTree */])(reportStructureWithPath,"metadataAttributes",function(node){return Object.assign({},node,{metadataAttributes:node.metadataAttributes.map(function(child){var childPath=!node.isFolder?node.id:'';return Object.assign({},child,{path:node.path.length>0&&childPath.length>0?node.path+'+'+childPath:node.path+childPath});})});});return reportStructureWithPath;};/** annotations utilities **/// check if an annotation is an autoAnnotation or a user one
var isReferenceMetadataAutoAnnotation=function isReferenceMetadataAutoAnnotation(annotation,annotationsConfig){var autoAnnotations=AUTO_ANNOTATIONS.concat(annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["d" /* AUTO_ANNOTATION_FILE_PATH_KEY */]].toLowerCase()).concat(annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["g" /* AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY */]].toLowerCase()).concat(annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["f" /* AUTO_ANNOTATION_IS_MULTILINGUAL_KEY */]].toLowerCase());return annotation.id&&autoAnnotations.includes(annotation.id.toLowerCase())||annotation.type&&autoAnnotations.includes(annotation.type.toLowerCase());};// gets metadataflow triplet from annotations
var getMetadataflowTripletFromAnnotations=function getMetadataflowTripletFromAnnotations(metadataSet){var annotations=metadataSet&&metadataSet.annotations?metadataSet.annotations:[];var autoAnnotations=metadataSet&&metadataSet.autoAnnotations?metadataSet.autoAnnotations:[];return{id:((annotations.concat(autoAnnotations).find(function(annot){return annot.id==="MetadataflowId";})||{}).text||{})["en"],agencyID:((annotations.concat(autoAnnotations).find(function(annot){return annot.id==="MetadataflowAgency";})||{}).text||{})["en"],version:((annotations.concat(autoAnnotations).find(function(annot){return annot.id==="MetadataflowVersion";})||{}).text||{})["en"]};};// gets db unique id annotation from annotations
var getDbIdAnnotationFromAnnotations=function getDbIdAnnotationFromAnnotations(artefact,annotationId){var annotations=artefact&&artefact.annotations?artefact.annotations:[];var autoAnnotations=artefact&&artefact.autoAnnotations?artefact.autoAnnotations:[];return annotations.concat(autoAnnotations).find(function(annot){return(annot.id||"").toLowerCase()===annotationId.toLowerCase();});};// gets attachment annotation from annotations
var getAttachmentAnnotationFromAnnotations=function getAttachmentAnnotationFromAnnotations(attribute,annotationsConfig){var annotations=attribute&&attribute.annotations?attribute.annotations:[];var autoAnnotations=attribute&&attribute.autoAnnotations?attribute.autoAnnotations:[];return annotations.concat(autoAnnotations).find(function(annot){return(annot.type||"").toLowerCase()===(annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["d" /* AUTO_ANNOTATION_FILE_PATH_KEY */]]||"").toLowerCase();});};// check if an attribute is public or not from annotations
var getIsPublicFromAnnotations=function getIsPublicFromAnnotations(annotations,annotType){return!(annotations||[]).find(function(annot){return(annot.type||"").toLowerCase()===annotType.toLowerCase();});};var setReportStateAnnotations=function setReportStateAnnotations(annotations,statusId,statusName){var stateIdAnnotation=(annotations||[]).find(function(annot){return(annot.id||"").toLowerCase()===REPORT_STATE_ID_ANNOTATION_ID.toLowerCase();});var stateNameAnnotation=(annotations||[]).find(function(annot){return(annot.id||"").toLowerCase()===REPORT_STATE_NAME_ANNOTATION_ID.toLowerCase();});if(stateIdAnnotation){stateIdAnnotation.texts={en:statusId};stateIdAnnotation.text=statusId;}else{annotations.push({id:REPORT_STATE_ID_ANNOTATION_ID,texts:{en:statusId},text:statusId});}if(stateNameAnnotation){stateNameAnnotation.texts={en:statusName};stateNameAnnotation.text=statusName;}else{annotations.push({id:REPORT_STATE_NAME_ANNOTATION_ID,texts:{en:statusName},text:statusName});}};var updateReportStateAnnotations=function updateReportStateAnnotations(annotations,isDraft){if(isDraft){setReportStateAnnotations(annotations,REPORT_STATE_DRAFT_ID,REPORT_STATE_DRAFT);}else{setReportStateAnnotations(annotations,REPORT_STATE_NOT_PUBLISHED_ID,REPORT_STATE_NOT_PUBLISHED);}return annotations;};// checks if an attribute with children should be treated as presentational
var getCustomIsPresentationalFromAnnotations=function getCustomIsPresentationalFromAnnotations(msd,annotationsConfig){var annotations=msd&&msd.annotations?msd.annotations:[];var autoAnnotations=msd&&msd.autoAnnotations?msd.autoAnnotations:[];return!!annotations.concat(autoAnnotations).find(function(_ref4){var type=_ref4.type;return(type||"").toLowerCase()===(annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]]||"").toLowerCase();});};var getAnnotationsWithAttachmentAnnot=function getAnnotationsWithAttachmentAnnot(attribute,annotations,annotationsConfig){var newAnnotations=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(annotations||[]);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default()(attribute.attachmentUploaded).pickBy(function(val){return val===true;}).keys().value().length<1){newAnnotations=newAnnotations.filter(function(annot){return(annot.type||"").toLowerCase()!==(annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["d" /* AUTO_ANNOTATION_FILE_PATH_KEY */]]||"").toLowerCase();});}else{var fileAttachedAnnot=newAnnotations.find(function(annot){return(annot.type||"").toLowerCase()===(annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["d" /* AUTO_ANNOTATION_FILE_PATH_KEY */]]||"").toLowerCase();});var fileAttachedAnnotText={};Object.keys(attribute.attachmentUploaded).forEach(function(lang){if(attribute.attachmentUploaded[lang]===true){fileAttachedAnnotText[lang]=attribute.attachmentName[lang];}});if(!fileAttachedAnnot){newAnnotations.push({id:annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["d" /* AUTO_ANNOTATION_FILE_PATH_KEY */]],type:annotationsConfig[__WEBPACK_IMPORTED_MODULE_9__annotations__["d" /* AUTO_ANNOTATION_FILE_PATH_KEY */]],text:fileAttachedAnnotText});}else{fileAttachedAnnot.text=fileAttachedAnnotText;}}return newAnnotations;};// utility to get categorisation list from annotations
var getCategorisationsFromAnnotations=function getCategorisationsFromAnnotations(artefact){var annotations=(artefact.annotations||[]).concat(artefact.autoAnnotations||[]);return annotations.length>0?annotations.filter(function(annot){return String(annot.id).substring(0,14)==="categorisation";}).map(function(_ref5){var text=_ref5.text;return text["en"];}).map(function(categorisationStr){var categorisation=categorisationStr.split('+');return{id:categorisation[0],agencyID:categorisation[1],version:categorisation[2],source:categorisation[3],target:categorisation[4]};}):null;};/** utilities **/// gets attribute type from attribute node
var getAttributeType=function getAttributeType(attribute){return((attribute.localRepresentation||{}).textFormat||{}).textType||"";};var getClientBaseUrl=function getClientBaseUrl(){var currUrl=window.location;var baseUrl=currUrl.protocol+"//"+currUrl.host+currUrl.pathname;return baseUrl+(baseUrl.slice(-1)==='/'?'':'/');};var templateBaseUrl="static/referenceMetadata/template";// gets the link to the metadata set html preview page
var getMetadataSetHtmlPageUrl=function getMetadataSetHtmlPageUrl(nodeId,metadataSetId,lang,metadataApiBaseUrl){var baseUrl=getClientBaseUrl();return baseUrl+templateBaseUrl+"/MetadatasetTemplate.html"+("?nodeId="+nodeId+"&metadataSetId="+metadataSetId+"&lang="+lang+"&BaseUrlMDA="+metadataApiBaseUrl+"&BaseUrlMDM="+baseUrl);};// gets the link to the DCAT-AP_IT metadata set html preview page
var getDcatMetadataSetHtmlPageUrl=function getDcatMetadataSetHtmlPageUrl(nodeId,metadataSetId,lang,metadataApiBaseUrl){var baseUrl=getClientBaseUrl();return baseUrl+templateBaseUrl+"/DCAT-APTemplate.html"+("?nodeId="+nodeId+"&metadataSetId="+metadataSetId+"&lang="+lang+"&BaseUrlMDA="+metadataApiBaseUrl+"&BaseUrlMDM="+baseUrl);};// gets the link to the DCAT-AP_IT metadata set html categories page
var getDcatMetadataSetCategoryHtmlPageUrl=function getDcatMetadataSetCategoryHtmlPageUrl(nodeId,metadataSetId,lang,metadataApiBaseUrl){var baseUrl=getClientBaseUrl();return baseUrl+templateBaseUrl+"/CategoryTemplate.html"+("?nodeId="+nodeId+"&metadataSetId="+metadataSetId+"&lang="+lang+"&BaseUrlMDA="+metadataApiBaseUrl+"&BaseUrlMDM="+baseUrl);};// gets the link to the report html preview page
var getReportHtmlPageUrl=function getReportHtmlPageUrl(nodeId,metadataSetId,reportId,lang,metadataApiBaseUrl){var baseUrl=getClientBaseUrl();return baseUrl+templateBaseUrl+"/GenericMetadataTemplate.html"+("?nodeId="+nodeId+"&metadataSetId="+metadataSetId+"&reportId="+reportId+"&lang="+lang+"&BaseUrlMDA="+metadataApiBaseUrl+"&BaseUrlMDM="+baseUrl);};// gets the link to the MetadataApi "getMetadatada"
var getMetadataApiReportUrl=function getMetadataApiReportUrl(metadataApiBaseUrl,metadataSetId,reportId){return""+metadataApiBaseUrl+(metadataApiBaseUrl.slice(-1)==='/'?'':'/')+"api/getMetadata?metadataSetId="+metadataSetId+"&reportId="+reportId;};// gets the link to the MetadataApi "package_show"
var getMetadataApiDcatReportUrl=function getMetadataApiDcatReportUrl(metadataApiBaseUrl,metadataSetId,reportId,lang){return""+metadataApiBaseUrl+(metadataApiBaseUrl.slice(-1)==='/'?'':'/')+lang+"/"+metadataSetId+"/api/3/action/package_show?id="+reportId;};// gets the link to the MetadataApi "package_search"
var getMetadataApiDcatMetadataSetUrl=function getMetadataApiDcatMetadataSetUrl(metadataApiBaseUrl,metadataSetId,lang){return""+metadataApiBaseUrl+(metadataApiBaseUrl.slice(-1)==='/'?'':'/')+lang+"/"+metadataSetId+"/api/3/action/package_search";};// gets the next available index for a folder node child
var getNextAttributeIndexAvailable=function getNextAttributeIndexAvailable(array){var _loop=function _loop(i){if(!array.find(function(el){return i===Number(el.id.substring(0,String(i).length));})){return{v:i};}};for(var i=1;i<=array.length;i++){var _ret=_loop(i);if((typeof _ret==="undefined"?"undefined":_typeof(_ret))==="object")return _ret.v;}return array.length+1;};var getRegexExp=function getRegexExp(attributeType){var type=(attributeType||"").toLowerCase();if(type===ATTRIBUTE_TEXT_TYPE_ALPHA){return /^[a-z ]*$/gim;}else if(type===ATTRIBUTE_TEXT_TYPE_ALPHANUMERIC){return /^[a-z0-9 ]*$/gim;}else if(ATTRIBUTE_TEXT_TYPES_INTEGER.includes(type)){return /^[0-9]*$/gim;}else if(ATTRIBUTE_TEXT_TYPES_DECIMAL.includes(type)){return /^([+-])?([0-9]+(([.,])[0-9]+)?|([.,])[0-9]+)$/gim;}else if(type===ATTRIBUTE_TEXT_TYPE_DAY){return /^(0[1-9]|[12][0-9]|3[01])$/gim;}else if(type===ATTRIBUTE_TEXT_TYPE_MONTH){return /^(0[1-9]|1[0-2])$/gim;}else if(type===ATTRIBUTE_TEXT_TYPE_YEAR||type===ATTRIBUTE_TEXT_TYPE_GREGORIANYEAR){return /^[0-9]{4}$/gim;}else if(type===ATTRIBUTE_TEXT_TYPE_MONTHDAY){return /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/gim;}else if(type===ATTRIBUTE_TEXT_TYPE_YEARMONTH||type===ATTRIBUTE_TEXT_TYPE_GREGORIANYEARMONTH){return /^([0-9]{4})-(0[1-9]|1[0-2])$/gim;}else if(type===ATTRIBUTE_TEXT_TYPE_DATE){return /^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/gim;}else if(type===ATTRIBUTE_TEXT_TYPE_URI){return /^(https:\/\/|http:\/\/)?(www\.)?[a-zA-Z0-9@:%._+~#=-]{2,256}\.[a-z]{2,6}([a-zA-Z0-9@:%_+.~\-#?&/=]*)$/gi;}else{return /^.*$/gim;}};var isAttributeValueValorizedAndValid=function isAttributeValueValorizedAndValid(attribute){if(!attribute||!attribute.texts){return false;}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default()(attribute.texts).pickBy(function(val){return val&&val.length>0;}).keys().value().length<1){return false;}return isAttributeValueValid(attribute);};var isAttributeValueValid=function isAttributeValueValid(attribute){if(!attribute||!attribute.texts){return true;}var attributeType=getAttributeType(attribute);var values=[];if(!attribute.isMultiLang){values.push(attribute.texts);}else{for(var key in attribute.texts){if(attribute.texts.hasOwnProperty(key)){values.push(attribute.texts[key]);}}}return!values.find(function(val){return!getRegexExp(attributeType).test(val);});};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUserPermissions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CURRENT_USER_PERMISSIONS_KEY='CURRENT_USER_PERMISSIONS_KEY';var getCurrentUserPermissions=function getCurrentUserPermissions(action){return action[CURRENT_USER_PERMISSIONS_KEY];};var currentUserPermissionsMiddleware=function currentUserPermissionsMiddleware(_ref){var getState=_ref.getState;return function(next){return function(action){var state=getState();var decoratedAction=Object.assign({},action,_defineProperty({},CURRENT_USER_PERMISSIONS_KEY,state.app.user&&state.app.user.permissions?__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state.app.user.permissions):null));return next(decoratedAction);};};};/* harmony default export */ __webpack_exports__["a"] = (currentUserPermissionsMiddleware);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_empty_style__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_empty_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_empty_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_empty__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
var CustomEmpty=function CustomEmpty(_ref){var className=_ref.className,t=_ref.t,text=_ref.text,width=_ref.width,backgroundColor=_ref.backgroundColor,color=_ref.color,image=_ref.image;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_empty___default.a,{className:className,description:text||t('components.empty.text'),image:image||__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null),style:{width:width,margin:0,backgroundColor:backgroundColor,color:color}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])()(CustomEmpty));

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__required__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whitespace__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__range__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pattern__ = __webpack_require__(964);







/* harmony default export */ __webpack_exports__["a"] = ({
  required: __WEBPACK_IMPORTED_MODULE_0__required__["a" /* default */],
  whitespace: __WEBPACK_IMPORTED_MODULE_1__whitespace__["a" /* default */],
  type: __WEBPACK_IMPORTED_MODULE_2__type__["a" /* default */],
  range: __WEBPACK_IMPORTED_MODULE_3__range__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_4__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_5__pattern__["a" /* default */]
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeItemsOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNormalizedColumnName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__artefacts__ = __webpack_require__(56);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var normalizeItemsOrder=function normalizeItemsOrder(itemsTree,childrenKey,appLanguage,itemsOrderAnnotationType){var root=_defineProperty({isRoot:true},childrenKey,itemsTree);var count=1;var func=function func(node){if(!node.isRoot){Object(__WEBPACK_IMPORTED_MODULE_1__artefacts__["j" /* updateItemOrder */])(node,String(count),itemsOrderAnnotationType,appLanguage);count++;}};var visitDfs=function visitDfs(node,func){if(func){func(node);}__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(node[childrenKey],function(child){return visitDfs(child,func);});};visitDfs(root,func);return count-1;};var getNormalizedColumnName=function getNormalizedColumnName(colName){return colName.substring(0,3)==="ID_"?colName.substring(3,colName.length):colName==="_OBS_VALUE"?"OBS_VALUE":colName;};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1025);
var v4 = __webpack_require__(1026);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__contexts_DataLanguage__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language};};var ItemList=function(_React$Component){_inherits(ItemList,_React$Component);function ItemList(){_classCallCheck(this,ItemList);return _possibleConstructorReturn(this,(ItemList.__proto__||Object.getPrototypeOf(ItemList)).apply(this,arguments));}_createClass(ItemList,[{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,appLanguage=_props.appLanguage,hideOrderCol=_props.hideOrderCol,noFilter=_props.noFilter,noSort=_props.noSort;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__infinite_scroll_table__["a" /* default */],Object.assign({},_this2.props,{getRowKey:function getRowKey(_ref){var id=_ref.id;return id;},columns:[{title:t('data.item.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["TABLE_COL_MIN_WIDTH_ID"],noSort:noSort,noFilter:noFilter},{title:t('data.item.name.shortLabel'),dataIndex:'name',minWidth:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"],noSort:noSort,noFilter:noFilter},{title:t('data.item.parent.shortLabel'),dataIndex:'parent',minWidth:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["TABLE_COL_MIN_WIDTH_ID"],noSort:noSort,noFilter:noFilter},hideOrderCol?null:{title:t('data.item.order.shortLabel'),dataIndex:'order',widthToContent:true,render:function render(order){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{title:order&&order[lang]?order[lang]:'',style:{width:'100%',height:'100%'}},order&&order[lang]?order[lang]:'');},renderText:function renderText(order){return order&&order[lang]?order[lang]:'';},sorter:__WEBPACK_IMPORTED_MODULE_4__infinite_scroll_table__["b" /* numberStringSorter */],noSort:noSort,noFilter:noFilter}],multilangStrDataIndexes:["name"]}));});}}]);return ItemList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps))(ItemList));

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__collapsible_text__ = __webpack_require__(1280);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var CustomAnnotationList=function CustomAnnotationList(_ref){var t=_ref.t,endpoints=_ref.endpoints,endpointId=_ref.endpointId,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,annotations=_ref.annotations,title=_ref.title,onClose=_ref.onClose;var config=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].annotationTabs;var typesMap=Object(__WEBPACK_IMPORTED_MODULE_16__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(annotations,config.tabs);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:annotations!=null,onCancel:onClose,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onClose},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_LG"],title:title||'',withDataLanguageSelector:true},config.tabs.filter(function(_ref2){var isVisible=_ref2.isVisible;return isVisible;}).length>0?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,null,config.tabs.filter(function(_ref3){var isVisible=_ref3.isVisible;return isVisible;}).map(function(tab){var annotations=tab.annotations.filter(function(annot){return annot.isVisible&&typesMap[tab.name].annotations[annot.name];});return annotations.length>0?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:tab.name,tab:Object(__WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__["a" /* getLocalizedStr */])(typesMap[tab.name].label,language,dataLanguages)||tab.name},annotations.map(function(annot,key){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],{key:key},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_ONE_QUARTER"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__["a" /* getLocalizedStr */])(annot.label,language,dataLanguages)||annot.name)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_THREE_QUARTERS"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__collapsible_text__["a" /* default */],{isCollapsedDefault:config.isTextCollapsed},Object(__WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__["a" /* getLocalizedStr */])(typesMap[tab.name].annotations[annot.name],language,dataLanguages)))),key<annotations.length-1&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"],marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}}));})):null;}));}):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__custom_empty__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps))(CustomAnnotationList));

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _warning = _interopRequireDefault(__webpack_require__(98));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var warned = {};

var _default = function _default(valid, message) {
  if (!valid && !warned[message]) {
    (0, _warning["default"])(false, message);
    warned[message] = true;
  }
};

exports["default"] = _default;

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return EL_STEP_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EL_CATEGORIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EL_CATEGORY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return EL_DST_DATAFLOW_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EL_DST_DATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return EL_DST_DATAFLOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return EL_DST_DATAFLOW_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return EL_SOURCE_FORMAT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EL_CONNECTION_ENDPOINT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EL_CONNECTION_ENDPOINT_PING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return EL_SRC_DATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return EL_SRC_DATAFLOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return EL_SRC_DATAFLOW_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return EL_SRC_FILE_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return EL_SRC_FILE_CSV_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return EL_SRC_FILE_EXCEL_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return EL_SRC_FILE_EXCEL_CONVERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return EL_SRC_FILE_PREVIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return EL_SRC_FILE_PREVIEW_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return EL_SRC_FILE_PREVIEW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return EL_SRC_TABLES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return EL_SRC_TABLE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return EL_SRC_DATAFLOW_DSD_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EL_CODELIST_COUNT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EL_CODELIST_ITEMS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EL_CSV_HEADER_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EL_CSV_COUNT_AND_ITEMS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return EL_FILTER_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return EL_FILTER_MODE_ADVANCED_VALUES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return EL_FILTER_MODE_ADVANCED_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return EL_FILTER_MODE_SIMPLE_BLOCK_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return EL_FILTER_MODE_SIMPLE_BLOCK_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return EL_FILTER_MODE_SIMPLE_CONDITION_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return EL_FILTER_MODE_SIMPLE_CONDITION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return EL_FILTER_MODE_SIMPLE_VALUES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return EL_FILTER_MODE_SIMPLE_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return EL_FILTER_MODE_SIMPLE_VALUES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return EL_FILTER_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return EL_STRUCTURE_CSV_HEADER_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return EL_STRUCTURE_COLUMN_TYPE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EL_DIMENSIONS_COLUMNS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EL_CODELISTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EL_ATTRIBUTES_COLUMNS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return EL_SEMANTIC_COLUMNS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EL_CONCEPT_SCHEMES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EL_CONCEPTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EL_CONCEPTS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return EL_METADATA_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return EL_METADATA_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return EL_PUBLISH_DATAFLOW_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return EL_TRANSCODE_DATAFLOW_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return EL_DATA_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EL_DATA_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return EL_DATA_CREATE_FROM_FILE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return EL_DATA_UPDATE_FROM_FILE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return EL_DATA_UPDATE_FROM_DB_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return EL_DATA_CREATE_FROM_DB_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return EL_DATA_IMPORT_STATUS_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return EL_METADATA_CSV_PRELOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return EL_LOAD_TABLE_SET_EXISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EL_CREATE_ARTEFACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EL_DELETE_CREATED_ARTEFACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EL_CREATE_DSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return EL_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return setELStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return readElAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return readELCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return setELCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return changeELDstDataflowForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return readELDstDataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return setELDstDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return unsetELDstDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return setELSourceFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return setElConnectionEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return pingELConnectionEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return readELSrcDataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return setELSrcDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return unsetELSrcDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return changeELSrcFileForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return uploadElSrcFileCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return uploadElSrcFileCsvAbsolute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return uploadElSrcFileExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return uploadElSrcFileXlsAbsolute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return convertElSrcFileExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return showElSrcFilePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return hideElSrcFilePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return readElSrcFilePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return readElSrcTables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return setElSrcTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return readELSrcDataflowDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return readELCodelistCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return readELCodelistItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return readELCsvHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return readELCsvCountAndItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return changeELFilterMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return changeELFilterModeAdvancedValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return changeELFilterModeAdvancedMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return addELFilterModeSimpleBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return deleteELFilterModeSimpleBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return addELFilterModeSimpleCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return deleteELFilterModeSimpleCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return changeELFilterModeSimpleValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return readELFilterModeSimpleValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return resetELFilterModeSimpleValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return resetELFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getELCsvStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return setELStructureColumnType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return setELDimensionsColumnsValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return readELCodelists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return setELAttributesColumnsValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return setELSemanticColumnsConcept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return readELConceptSchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return readELConcepts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return resetELConcepts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return submitELMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return hideElMetadataReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return preloadELCSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return setELLoadTableExists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return createELArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return deleteELCreatedArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return createELDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return changeElPublishDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return changeElTranscodeDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return submitELDataCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return submitELDataUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return submitELDataFromFileCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return submitELDataFromDbCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return submitELDataFromFileUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return submitELDataFromDBUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getELDataImportStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return resetEl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return readASTTerritorialCodelistConcept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__load_step_utils__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__ = __webpack_require__(10);
var EL_STEP_SET="EL_STEP_SET";var EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT="EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT";/* data step */var EL_AGENCIES_READ="EL_AGENCIES_READ";var EL_CATEGORIES_READ="EL_CATEGORIES_READ";var EL_CATEGORY_SET="EL_CATEGORY_SET";var EL_DST_DATAFLOW_FORM_CHANGE="EL_DST_DATAFLOW_FORM_CHANGE";var EL_DST_DATAFLOWS_READ="EL_DST_DATAFLOWS_READ";var EL_DST_DATAFLOW_SET="EL_DST_DATAFLOW_SET";var EL_DST_DATAFLOW_UNSET="EL_DST_DATAFLOW_UNSET";/* connection step */var EL_SOURCE_FORMAT_SET="EL_SOURCE_FORMAT_SET";var EL_CONNECTION_ENDPOINT_SET="EL_CONNECTION_ENDPOINT_SET";var EL_CONNECTION_ENDPOINT_PING="EL_CONNECTION_ENDPOINT_PING";var EL_SRC_DATAFLOWS_READ="EL_SRC_DATAFLOWS_READ";var EL_SRC_DATAFLOW_SET="EL_SRC_DATAFLOW_SET";var EL_SRC_DATAFLOW_UNSET="EL_SRC_DATAFLOW_UNSET";var EL_SRC_FILE_FORM_CHANGE="EL_SRC_FILE_FORM_CHANGE";var EL_SRC_FILE_CSV_UPLOAD="EL_SRC_FILE_CSV_UPLOAD";var EL_SRC_FILE_EXCEL_UPLOAD="EL_SRC_FILE_EXCEL_UPLOAD";var EL_SRC_FILE_EXCEL_CONVERT="EL_SRC_FILE_EXCEL_CONVERT";var EL_SRC_FILE_PREVIEW_SHOW="EL_SRC_FILE_PREVIEW_SHOW";var EL_SRC_FILE_PREVIEW_HIDE="EL_SRC_FILE_PREVIEW_HIDE";var EL_SRC_FILE_PREVIEW_READ="EL_SRC_FILE_PREVIEW_READ";var EL_SRC_TABLES_READ="EL_SRC_TABLES_READ";var EL_SRC_TABLE_SET="EL_SRC_TABLE_SET";/* filter step */var EL_SRC_DATAFLOW_DSD_READ="EL_SRC_DATAFLOW_DSD_READ";var EL_CODELIST_COUNT_READ="EL_CODELIST_COUNT_READ";var EL_CODELIST_ITEMS_READ="EL_CODELIST_ITEMS_READ";var EL_CSV_HEADER_READ="EL_CSV_HEADER_READ";var EL_CSV_COUNT_AND_ITEMS_READ="EL_CSV_COUNT_AND_ITEMS_READ";var EL_FILTER_MODE_CHANGE="EL_FILTER_MODE_CHANGE";var EL_FILTER_MODE_ADVANCED_VALUES_CHANGE="EL_FILTER_MODE_ADVANCED_VALUES_CHANGE";var EL_FILTER_MODE_ADVANCED_MODE_CHANGE="EL_FILTER_MODE_ADVANCED_MODE_CHANGE";var EL_FILTER_MODE_SIMPLE_BLOCK_ADD="EL_FILTER_MODE_SIMPLE_BLOCK_ADD";var EL_FILTER_MODE_SIMPLE_BLOCK_DELETE="EL_FILTER_MODE_SIMPLE_BLOCK_DELETE";var EL_FILTER_MODE_SIMPLE_CONDITION_ADD="EL_FILTER_MODE_SIMPLE_CONDITION_ADD";var EL_FILTER_MODE_SIMPLE_CONDITION_DELETE="EL_FILTER_MODE_SIMPLE_CONDITION_DELETE";var EL_FILTER_MODE_SIMPLE_VALUES_CHANGE="EL_FILTER_MODE_SIMPLE_VALUES_CHANGE";var EL_FILTER_MODE_SIMPLE_VALUES_READ="EL_FILTER_MODE_SIMPLE_VALUES_READ";var EL_FILTER_MODE_SIMPLE_VALUES_RESET="EL_FILTER_MODE_SIMPLE_VALUES_RESET";var EL_FILTER_RESET="EL_FILTER_RESET";/* structure step */var EL_STRUCTURE_CSV_HEADER_READ="EL_STRUCTURE_CSV_HEADER_READ";var EL_STRUCTURE_COLUMN_TYPE_SET="EL_STRUCTURE_COLUMN_TYPE_SET";/* dimensions step */var EL_DIMENSIONS_COLUMNS_SET="EL_DIMENSIONS_COLUMNS_SET";var EL_CODELISTS_READ="EL_CODELISTS_READ";/* attributes step */var EL_ATTRIBUTES_COLUMNS_SET="EL_ATTRIBUTES_COLUMNS_SET";/* semantic step */var EL_SEMANTIC_COLUMNS_SET="EL_SEMANTIC_COLUMNS_SET";var EL_CONCEPT_SCHEMES_READ="EL_CONCEPT_SCHEMES_READ";var EL_CONCEPTS_READ="EL_CONCEPTS_READ";var EL_CONCEPTS_CLEAR="EL_CONCEPTS_CLEAR";/* load step */var EL_METADATA_SUBMIT="EL_METADATA_SUBMIT";var EL_METADATA_REPORT_HIDE="EL_METADATA_REPORT_HIDE";var EL_PUBLISH_DATAFLOW_CHANGE="EL_PUBLISH_DATAFLOW_CHANGE";var EL_TRANSCODE_DATAFLOW_CHANGE="EL_TRANSCODE_DATAFLOW_CHANGE";var EL_DATA_CREATE_SUBMIT="EL_DATA_CREATE_SUBMIT";var EL_DATA_UPDATE_SUBMIT="EL_DATA_UPDATE_SUBMIT";var EL_DATA_CREATE_FROM_FILE_SUBMIT="EL_DATA_CREATE_FROM_FILE_SUBMIT";var EL_DATA_UPDATE_FROM_FILE_SUBMIT="EL_DATA_UPDATE_FROM_FILE_SUBMIT";var EL_DATA_UPDATE_FROM_DB_SUBMIT="EL_DATA_UPDATE_FROM_DB_SUBMIT";var EL_DATA_CREATE_FROM_DB_SUBMIT="EL_DATA_CREATE_FROM_DB_SUBMIT";var EL_DATA_IMPORT_STATUS_GET="EL_DATA_IMPORT_STATUS_GET";var EL_METADATA_CSV_PRELOAD="EL_METADATA_CSV_PRELOAD";var EL_LOAD_TABLE_SET_EXISTS="EL_LOAD_TABLE_SET_EXISTS";var EL_CREATE_ARTEFACTS="EL_CREATE_ARTEFACTS";var EL_DELETE_CREATED_ARTEFACTS="EL_DELETE_CREATED_ARTEFACTS";var EL_CREATE_DSD="EL_CREATE_DSD";var EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE="EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE";var EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE="EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE";var EL_RESET="EL_RESET";var setELStep=function setELStep(step){return{type:EL_STEP_SET,step:step};};var readElAgencies=function readElAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var readELCategories=function readELCategories(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_CATEGORIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])());};var setELCategory=function setELCategory(category){return{type:EL_CATEGORY_SET,category:category};};var changeELDstDataflowForm=function changeELDstDataflowForm(fields){return{type:EL_DST_DATAFLOW_FORM_CHANGE,fields:fields};};var readELDstDataflows=function readELDstDataflows(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(EL_DST_DATAFLOWS_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_9" /* getDdbDataflowUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])()]);};var setELDstDataflow=function setELDstDataflow(dataflow){return{type:EL_DST_DATAFLOW_SET,dataflow:dataflow};};var unsetELDstDataflow=function unsetELDstDataflow(){return{type:EL_DST_DATAFLOW_UNSET};};var setELSourceFormat=function setELSourceFormat(format){return{type:EL_SOURCE_FORMAT_SET,format:format};};var setElConnectionEndpoint=function setElConnectionEndpoint(endpointId){return{type:EL_CONNECTION_ENDPOINT_SET,endpointId:endpointId};};var pingELConnectionEndpoint=function pingELConnectionEndpoint(endpointId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_CONNECTION_ENDPOINT_PING,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_68" /* getNodePingUrl */])(),undefined,undefined,endpointId);};var readELSrcDataflows=function readELSrcDataflows(endpointId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_SRC_DATAFLOWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])(),undefined,undefined,endpointId);};var setELSrcDataflow=function setELSrcDataflow(dataflow){return{type:EL_SRC_DATAFLOW_SET,dataflow:dataflow};};var unsetELSrcDataflow=function unsetELSrcDataflow(){return{type:EL_SRC_DATAFLOW_UNSET};};var changeELSrcFileForm=function changeELSrcFileForm(fields){return{type:EL_SRC_FILE_FORM_CHANGE,fields:fields};};var uploadElSrcFileCsv=function uploadElSrcFileCsv(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_SRC_FILE_CSV_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),fileFormData,function(t){return{start:t('components.easyLoading.messages.srcFileUpload.start'),success:t('components.easyLoading.messages.srcFileUpload.success')};});};var uploadElSrcFileCsvAbsolute=function uploadElSrcFileCsvAbsolute(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_105" /* getUploadFileOnServerAbsoluteUrl */])(true),fileFormData);};var uploadElSrcFileExcel=function uploadElSrcFileExcel(file,mappingFile){var fileFormData=new FormData();fileFormData.append('file',file);var mappingFileFormData=new FormData();mappingFileFormData.append('file',mappingFile);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(EL_SRC_FILE_EXCEL_UPLOAD,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])()],[fileFormData,mappingFileFormData],function(t){return{start:t('components.easyLoading.messages.srcFileUpload.start'),success:t('components.easyLoading.messages.srcFileUpload.success')};});};var uploadElSrcFileXlsAbsolute=function uploadElSrcFileXlsAbsolute(file,mappingFile){var fileFormData=new FormData();fileFormData.append('file',file);var mappingFileFormData=new FormData();mappingFileFormData.append('file',mappingFile);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_105" /* getUploadFileOnServerAbsoluteUrl */])(true),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_105" /* getUploadFileOnServerAbsoluteUrl */])(true)],[fileFormData,mappingFileFormData]);};var convertElSrcFileExcel=function convertElSrcFileExcel(filePath,mappingPath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_SRC_FILE_EXCEL_CONVERT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["J" /* getConvertXlsToCsv */])(filePath,mappingPath,0));};var showElSrcFilePreview=function showElSrcFilePreview(){return{type:EL_SRC_FILE_PREVIEW_SHOW};};var hideElSrcFilePreview=function hideElSrcFilePreview(){return{type:EL_SRC_FILE_PREVIEW_HIDE};};var readElSrcFilePreview=function readElSrcFilePreview(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,csvPath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_SRC_FILE_PREVIEW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,csvPath,null,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var readElSrcTables=function readElSrcTables(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_SRC_TABLES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_90" /* getStagingAreaTablesUrl */])());};var setElSrcTable=function setElSrcTable(tableName,csvSeparator){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_SRC_TABLE_SET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_41" /* getFileFromStagingAreaTableUrl */])(tableName,csvSeparator),Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])("")).Filter),{tableName:tableName});};var readELSrcDataflowDsd=function readELSrcDataflowDsd(dsdTriplet,endpointId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_SRC_DATAFLOW_DSD_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(dsdTriplet),undefined,undefined,endpointId);};var readELCodelistCount=function readELCodelistCount(sdcDataflowTriplet,dimensionId,endpointId){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_CODELIST_COUNT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_71" /* getPartialCodelistUrl */])(sdcDataflowTriplet,dimensionId,1,0),undefined,undefined,endpointId),{dimensionId:dimensionId});};var readELCodelistItems=function readELCodelistItems(sdcDataflowTriplet,dimensionId,endpointId){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_CODELIST_ITEMS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_71" /* getPartialCodelistUrl */])(sdcDataflowTriplet,dimensionId,1,-1),undefined,undefined,endpointId),{dimensionId:dimensionId});};var readELCsvHeader=function readELCsvHeader(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_CSV_HEADER_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["T" /* getCsvHeaderUrl */])(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath));};var readELCsvCountAndItems=function readELCsvCountAndItems(dimensionId,separator,delimiter,hasHeader,csvPath){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_CSV_COUNT_AND_ITEMS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["U" /* getCsvTableColumnPreviewUrl */])(separator,delimiter,hasHeader,csvPath),{SelCols:[dimensionId],PageNum:1,PageSize:-1}),{dimensionId:dimensionId});};var changeELFilterMode=function changeELFilterMode(mode){return{type:EL_FILTER_MODE_CHANGE,mode:mode};};var changeELFilterModeAdvancedValues=function changeELFilterModeAdvancedValues(colName,values){return{type:EL_FILTER_MODE_ADVANCED_VALUES_CHANGE,colName:colName,values:values};};var changeELFilterModeAdvancedMode=function changeELFilterModeAdvancedMode(colName,mode){return{type:EL_FILTER_MODE_ADVANCED_MODE_CHANGE,colName:colName,mode:mode};};var addELFilterModeSimpleBlock=function addELFilterModeSimpleBlock(){return{type:EL_FILTER_MODE_SIMPLE_BLOCK_ADD};};var deleteELFilterModeSimpleBlock=function deleteELFilterModeSimpleBlock(blockIndex){return{type:EL_FILTER_MODE_SIMPLE_BLOCK_DELETE,blockIndex:blockIndex};};var addELFilterModeSimpleCondition=function addELFilterModeSimpleCondition(blockIndex){return{type:EL_FILTER_MODE_SIMPLE_CONDITION_ADD,blockIndex:blockIndex};};var deleteELFilterModeSimpleCondition=function deleteELFilterModeSimpleCondition(blockIndex,conditionIndex){return{type:EL_FILTER_MODE_SIMPLE_CONDITION_DELETE,blockIndex:blockIndex,conditionIndex:conditionIndex};};var changeELFilterModeSimpleValues=function changeELFilterModeSimpleValues(fields){return{type:EL_FILTER_MODE_SIMPLE_VALUES_CHANGE,fields:fields};};var readELFilterModeSimpleValues=function readELFilterModeSimpleValues(dimensionId,separator,delimiter,hasHeader,csvPath){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_FILTER_MODE_SIMPLE_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["U" /* getCsvTableColumnPreviewUrl */])(separator,delimiter,hasHeader,csvPath),{SelCols:[dimensionId],PageNum:1,PageSize:-1}),{dimensionId:dimensionId});};var resetELFilterModeSimpleValues=function resetELFilterModeSimpleValues(dimensionId){return{type:EL_FILTER_MODE_SIMPLE_VALUES_RESET,dimensionId:dimensionId};};var resetELFilter=function resetELFilter(){return{type:EL_FILTER_RESET};};var getELCsvStructure=function getELCsvStructure(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath,appLang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_STRUCTURE_CSV_HEADER_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["T" /* getCsvHeaderUrl */])(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath)),{appLang:appLang});};var setELStructureColumnType=function setELStructureColumnType(columnId,columnType,transColId,langCode){return{type:EL_STRUCTURE_COLUMN_TYPE_SET,columnId:columnId,columnType:columnType,transColId:transColId,langCode:langCode};};var setELDimensionsColumnsValues=function setELDimensionsColumnsValues(columnId,role,association){return{type:EL_DIMENSIONS_COLUMNS_SET,columnId:columnId,role:role,association:association};};var readELCodelists=function readELCodelists(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_CODELISTS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["A" /* getCodelistUrl */])());};var setELAttributesColumnsValues=function setELAttributesColumnsValues(columnId,refers,dimensions,association){return{type:EL_ATTRIBUTES_COLUMNS_SET,columnId:columnId,refers:refers,dimensions:dimensions,association:association};};var setELSemanticColumnsConcept=function setELSemanticColumnsConcept(columnId,conceptType,conceptName,conceptLang,conceptSchema,concept){return{type:EL_SEMANTIC_COLUMNS_SET,columnId:columnId,conceptType:conceptType,conceptName:conceptName,conceptLang:conceptLang,conceptSchema:conceptSchema,concept:concept};};var readELConceptSchemes=function readELConceptSchemes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_CONCEPT_SCHEMES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])());};var readELConcepts=function readELConcepts(csTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_CONCEPTS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])(csTriplet));};var resetELConcepts=function resetELConcepts(){return{type:EL_CONCEPTS_CLEAR};};var submitELMetadata=function submitELMetadata(endpointId,sdcDataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_METADATA_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_48" /* getImportDSDFromDataflowUrl */])(endpointId,sdcDataflowTriplet),null,function(t){return{success:t('components.easyLoading.messages.submitMetadata.success')};});};var hideElMetadataReport=function hideElMetadataReport(){return{type:EL_METADATA_REPORT_HIDE};};var preloadELCSV=function preloadELCSV(separator,delimiter,hasHeader,filePath,tid){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_METADATA_CSV_PRELOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_72" /* getPreloadCsvUrl */])(separator,delimiter,hasHeader,filePath,tid));};var setELLoadTableExists=function setELLoadTableExists(value){return{type:EL_LOAD_TABLE_SET_EXISTS,value:value};};var createELArtefacts=function createELArtefacts(structureColumns,filterStr,dstDataflow,tableName,inStagingDb,appLang){var requestsMethod=[];var requestsUrl=[];var requestsBody=[];var codelistColumns=null;var conceptSchemaDefinition=null;var conceptRequest=Object(__WEBPACK_IMPORTED_MODULE_4__load_step_utils__["b" /* getCreateConceptRequest */])(structureColumns,dstDataflow,appLang);if(conceptRequest!==null){requestsMethod=requestsMethod.concat(conceptRequest.methods);requestsUrl=requestsUrl.concat(conceptRequest.urls);requestsBody=requestsBody.concat(conceptRequest.body);conceptSchemaDefinition=conceptRequest.data;}var codelistRequests=Object(__WEBPACK_IMPORTED_MODULE_4__load_step_utils__["a" /* getCreateCodelistsRequests */])(structureColumns,filterStr,dstDataflow.id,tableName,inStagingDb);if(codelistRequests!==null){requestsMethod=requestsMethod.concat(codelistRequests.methods);requestsUrl=requestsUrl.concat(codelistRequests.urls);requestsBody=requestsBody.concat(codelistRequests.body);codelistColumns=codelistRequests.data;}if(requestsMethod.length===0){return{type:EL_CREATE_ARTEFACTS};}return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(EL_CREATE_ARTEFACTS,requestsMethod,requestsUrl,requestsBody,function(t){return{start:t('components.easyLoading.messages.createCodelistsConceptSchema.start'),success:t('components.easyLoading.messages.createCodelistsConceptSchema.success')};}),{codelistColumns:codelistColumns,conceptSchemaDefinition:conceptSchemaDefinition});};var deleteELCreatedArtefacts=function deleteELCreatedArtefacts(toDeleteCodelists,toDeleteConceptSchema){var requestsMethod=[];var requestsUrl=[];if(toDeleteConceptSchema){requestsMethod.push(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */]);requestsUrl.push(Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("ConceptScheme",toDeleteConceptSchema.conceptSchema));}if(toDeleteCodelists){Object.keys(toDeleteCodelists).forEach(function(column){var codelistId=toDeleteCodelists[column];var triplet={id:codelistId,agencyID:"AST",version:"1.0"};requestsMethod.push(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */]);requestsUrl.push(Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("CodeList",triplet));});}if(requestsMethod.length===0){return{type:EL_DELETE_CREATED_ARTEFACTS};}return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(EL_DELETE_CREATED_ARTEFACTS,requestsMethod,requestsUrl));};var createELDsd=function createELDsd(structureColumns,dstDataflow,appLang,codelists,conceptSchema,astTerritoryDimId){var dsd=Object(__WEBPACK_IMPORTED_MODULE_4__load_step_utils__["d" /* getDataflowDSD */])(structureColumns,dstDataflow,appLang,codelists,conceptSchema,astTerritoryDimId);return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_CREATE_DSD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["Y" /* getSdmxJsonStructureFromDsd */])(dsd)],__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["D" /* SDMX_JSON_DSD_LIST_KEY */]),function(t){return{start:t('components.easyLoading.messages.createDsd.start'),success:t('components.easyLoading.messages.createDsd.success')};}),{dsdTriplet:{id:dsd.id,agencyID:dsd.agencyID,version:dsd.version}});};var changeElPublishDataflow=function changeElPublishDataflow(publishDf){return{type:EL_PUBLISH_DATAFLOW_CHANGE,publishDf:publishDf};};var changeElTranscodeDataflow=function changeElTranscodeDataflow(transcodeDf){return{type:EL_TRANSCODE_DATAFLOW_CHANGE,transcodeDf:transcodeDf};};var submitELDataCreate=function submitELDataCreate(endpointId,sdcDataflowTriplet,dstDataflowTriplet,datasetName,categoryId,filterStr,publishDf,transcodeDf){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_DATA_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_34" /* getEasyLoadDataFromSdmxUrl */])(endpointId,sdcDataflowTriplet,dstDataflowTriplet,categoryId,publishDf,transcodeDf),{labels:datasetName,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_3__tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filterStr))).Filter},function(t){return{success:t('components.easyLoading.messages.submitData.success')};},undefined,undefined,undefined,true);};var submitELDataUpdate=function submitELDataUpdate(endpointId,sdcDataflowTriplet,dstDDBDataflowId,filterStr,transcodeDf){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_DATA_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_37" /* getEasyUpdateDataFromSdmxUrl */])(endpointId,sdcDataflowTriplet,dstDDBDataflowId,transcodeDf),Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_3__tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filterStr))).Filter,function(t){return{success:t('components.easyLoading.messages.submitData.success')};},undefined,undefined,undefined,true);};var submitELDataFromFileCreate=function submitELDataFromFileCreate(structureColumns,astTerritoryDimId,datasetName,filePath,separator,delimiter,hasHeader,DsId,DsAg,DsVs,CategoryId,DsdCode,mappFilePath,publishDf,executeTrans,filterStr){var componentMapping=Object(__WEBPACK_IMPORTED_MODULE_4__load_step_utils__["c" /* getCreateFileComponentMapping */])(structureColumns,astTerritoryDimId);var url=Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_33" /* getEasyLoadDataFromFileUrl */])(filePath,separator,delimiter,hasHeader,DsId,DsAg,DsVs,CategoryId,mappFilePath,publishDf,executeTrans);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_DATA_CREATE_FROM_FILE_SUBMIT,url,{labels:datasetName,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(filterStr)).Filter,mapp:componentMapping,DsdCode:DsdCode},function(t){return{success:t('components.easyLoading.messages.submitData.success')};},undefined,undefined,undefined,true);};var submitELDataFromDbCreate=function submitELDataFromDbCreate(structureColumns,astTerritoryDimId,tableName,datasetName,DsId,DsAg,DsVs,CategoryId,DsdCode,publishDf,executeTrans,filterStr){var componentMapping=Object(__WEBPACK_IMPORTED_MODULE_4__load_step_utils__["c" /* getCreateFileComponentMapping */])(structureColumns,astTerritoryDimId);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_DATA_CREATE_FROM_DB_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_32" /* getEasyLoadDataFromDbUrl */])(tableName,DsId,DsAg,DsVs,CategoryId,publishDf,executeTrans),{labels:datasetName,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(filterStr)).Filter,mapp:componentMapping,DsdCode:DsdCode},function(t){return{success:t('components.easyLoading.messages.submitData.success')};},undefined,undefined,undefined,true);};var submitELDataFromFileUpdate=function submitELDataFromFileUpdate(datasetName,filePath,separator,delimiter,hasHeader,ddbDataflowId,currentMapping,components,mappFilePath,transcodeDf,filterStr){var componentMapping=null;var mappId=null;if(currentMapping.IDMapping!==-1){mappId=currentMapping.IDMapping;}else{componentMapping=Object(__WEBPACK_IMPORTED_MODULE_4__load_step_utils__["e" /* getUpdateFileComponentMapping */])(components);}var url=Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_36" /* getEasyUpdateDataFromFileUrl */])(filePath,separator,delimiter,hasHeader,ddbDataflowId,mappId,mappFilePath,transcodeDf);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_DATA_UPDATE_FROM_FILE_SUBMIT,url,{labels:datasetName,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(filterStr)).Filter,mapp:componentMapping},function(t){return{success:t('components.easyLoading.messages.updateData.success')};},undefined,undefined,undefined,true);};var submitELDataFromDBUpdate=function submitELDataFromDBUpdate(datasetName,tableName,ddbDataflowId,currentMapping,components,transcodeDf,filterStr){var componentMapping=null;var mappId=null;if(currentMapping.IDMapping!==-1){mappId=currentMapping.IDMapping;}else{componentMapping=Object(__WEBPACK_IMPORTED_MODULE_4__load_step_utils__["e" /* getUpdateFileComponentMapping */])(components);}var url=Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_35" /* getEasyUpdateDataFromDbUrl */])(tableName,ddbDataflowId,mappId,transcodeDf);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(EL_DATA_UPDATE_FROM_DB_SUBMIT,url,{labels:datasetName,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(filterStr)).Filter,mapp:componentMapping},function(t){return{success:t('components.easyLoading.messages.updateData.success')};},undefined,undefined,undefined,true);};var getELDataImportStatus=function getELDataImportStatus(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(EL_DATA_IMPORT_STATUS_GET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_0" /* getDataUploadStatusUrl */])(dataflowTriplet),undefined,undefined,undefined,undefined,true);};var resetEl=function resetEl(){return{type:EL_RESET};};var readASTTerritorialCodelistConcept=function readASTTerritorialCodelistConcept(codelist,conceptScheme,concept){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["A" /* getCodelistUrl */])(Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelist)),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])(Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(conceptScheme))]),{codelist:codelist,conceptScheme:conceptScheme,concept:concept});};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_languages__ = __webpack_require__(91);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var MultilanguageInput=function(_React$Component){_inherits(MultilanguageInput,_React$Component);function MultilanguageInput(props){_classCallCheck(this,MultilanguageInput);var _this=_possibleConstructorReturn(this,(MultilanguageInput.__proto__||Object.getPrototypeOf(MultilanguageInput)).call(this,props));_this.state=MultilanguageInput.getInitState(props);_this.callOnChange=_this.callOnChange.bind(_this);_this.setLanguage=_this.setLanguage.bind(_this);_this.setValueForLanguage=_this.setValueForLanguage.bind(_this);return _this;}_createClass(MultilanguageInput,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){this.props.onChange(value);}}},{key:'setLanguage',value:function setLanguage(lang){var state=Object.assign({},this.state);state.language=lang;this.setState(state);this.callOnChange(state.value);}},{key:'setValueForLanguage',value:function setValueForLanguage(newValue,language){var state=Object.assign({},this.state);state.value[language]=newValue;this.setState(state);this.callOnChange(state.value);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,disabled=_props.disabled,dataLanguages=_props.dataLanguages,onBlur=_props.onBlur,addonAfter=_props.addonAfter;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(contextDataLanguage){var language=contextDataLanguage||_this2.state.language;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a.Group,{compact:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{value:value[language],onChange:function onChange(e){return _this2.setValueForLanguage(e.target.value,language);},title:value[language],disabled:disabled,style:{width:contextDataLanguage?'100%':'calc(100% - 100px)'},onBlur:onBlur,addonAfter:addonAfter}),!contextDataLanguage&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{value:language,onChange:_this2.setLanguage,style:{width:100}},dataLanguages.map(function(_ref){var code=_ref.code;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:code,value:code,title:Object(__WEBPACK_IMPORTED_MODULE_11__utils_languages__["c" /* getLanguageLabel */])(t,code)},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',{className:'flag-icon '+Object(__WEBPACK_IMPORTED_MODULE_11__utils_languages__["b" /* getLanguageFlagIconCss */])(code,dataLanguages),style:{marginRight:8}}),code!==null?code.toUpperCase():null);})));});}}],[{key:'getInitState',value:function getInitState(props){return{value:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.fromPairs(props.dataLanguages.map(function(_ref2){var code=_ref2.code;return[code,''];})),language:(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(props.dataLanguages,function(_ref3){var code=_ref3.code;return code===props.appLanguage;})||{}).code||'en'// isInitialized: false OBSOLETE
};}},{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props){if(props.value!==null&&props.value!==undefined){return{value:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.merge(MultilanguageInput.getInitState(props).value,props.value)// isInitialized: true OBSOLETE
};}else{return MultilanguageInput.getInitState(props);}}}]);return MultilanguageInput;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps))(MultilanguageInput));

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QUERY_FORM_FILTER_MODE_PLAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QUERY_FORM_FILTER_MODE_TREE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ColumnsForm__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_css__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__query_form_filter__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var cardStyle={type:'inner',headStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["PADDING_MD"]},size:"small",bodyStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["PADDING_MD"],height:480,overflow:'auto'}};var QUERY_FORM_FILTER_MODE_PLAIN='QUERY_FORM_FILTER_MODE_PLAIN';var QUERY_FORM_FILTER_MODE_TREE='QUERY_FORM_FILTER_MODE_TREE';var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var QueryForm=function(_React$Component){_inherits(QueryForm,_React$Component);function QueryForm(){_classCallCheck(this,QueryForm);return _possibleConstructorReturn(this,(QueryForm.__proto__||Object.getPrototypeOf(QueryForm)).apply(this,arguments));}_createClass(QueryForm,[{key:'render',value:function render(){var _props=this.props,t=_props.t,appLanguage=_props.appLanguage,dataLanguages=_props.dataLanguages,categorisedCubes=_props.categorisedCubes,ddbDataflowId=_props.ddbDataflowId,ddbDataflow=_props.ddbDataflow,isCubeTreeVisible=_props.isCubeTreeVisible,cubeId=_props.cubeId,cube=_props.cube,cubeFirstRow=_props.cubeFirstRow,isRowsModalVisible=_props.isRowsModalVisible,filter=_props.filter,filterTemp=_props.filterTemp,treeFilter=_props.treeFilter,treeFilterTemp=_props.treeFilterTemp,filterMode=_props.filterMode,rows=_props.rows,fetchDdbDataflow=_props.fetchDdbDataflow,fetchCube=_props.fetchCube,fetchCategorisedCubes=_props.fetchCategorisedCubes,fetchCubeFirstRow=_props.fetchCubeFirstRow,fetchColumnValues=_props.fetchColumnValues,resetColumnValues=_props.resetColumnValues,fetchColumnCodes=_props.fetchColumnCodes,fetchColumnCodelistCount=_props.fetchColumnCodelistCount,fetchColumnCodelistTree=_props.fetchColumnCodelistTree,fetchColumnFilteredValues=_props.fetchColumnFilteredValues,onCubeTreeShow=_props.onCubeTreeShow,onCubeTreeHide=_props.onCubeTreeHide,onCubeSet=_props.onCubeSet,onCubeUnset=_props.onCubeUnset,onColumnsChange=_props.onColumnsChange,onBlockAdd=_props.onBlockAdd,onBlockDelete=_props.onBlockDelete,onConditionAdd=_props.onConditionAdd,onConditionDelete=_props.onConditionDelete,onFilterChange=_props.onFilterChange,fetchRows=_props.fetchRows,onRowsModalShow=_props.onRowsModalShow,onRowsModalHide=_props.onRowsModalHide,onFilterReset=_props.onFilterReset,onFilterModeChange=_props.onFilterModeChange,onFilterModalShow=_props.onFilterModalShow,onFilterModalHide=_props.onFilterModalHide,onFilterModalSubmit=_props.onFilterModalSubmit,disabled=_props.disabled,isFilterModalVisible=_props.isFilterModalVisible,onTreeFilterChange=_props.onTreeFilterChange,onColumnModeChange=_props.onColumnModeChange,onColumnValuesChange=_props.onColumnValuesChange,dsd=_props.dsd;var uncheckableDims=[];if(dsd&&dsd.dataStructureComponents&&dsd.dataStructureComponents.groups){dsd.dataStructureComponents.groups.forEach(function(_ref){var groupDimensions=_ref.groupDimensions;return uncheckableDims=uncheckableDims.concat(groupDimensions);});}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,Object.assign({title:t('scenes.dataManager.dataflowBuilder.wizard.query.columnsForm.title')},cardStyle),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ColumnsForm__["a" /* default */],{appLanguage:appLanguage,dataLanguages:dataLanguages,dataLanguage:dataLanguage,categorisedCubes:categorisedCubes,ddbDataflowId:ddbDataflowId,ddbDataflow:ddbDataflow,cubeId:cubeId,cube:cube,cubeFirstRow:cubeFirstRow,isCubeTreeVisible:isCubeTreeVisible,onCubeTreeShow:onCubeTreeShow,onCubeTreeHide:onCubeTreeHide,onCubeSet:onCubeSet,onCubeUnset:onCubeUnset,fetchDdbDataflow:fetchDdbDataflow,fetchCube:fetchCube,fetchCubeFirstRow:fetchCubeFirstRow,fetchCategorisedCubes:fetchCategorisedCubes,onColumnsChange:onColumnsChange,disabled:disabled,uncheckableDims:uncheckableDims}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["SPAN_TWO_THIRDS"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,Object.assign({title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.title')},cardStyle),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__query_form_filter__["a" /* default */],{onFilterModalShow:onFilterModalShow,cube:cube,filter:filter,treeFilter:treeFilter,isFilterModalVisible:isFilterModalVisible,onFilterModalHide:onFilterModalHide,onFilterModalSubmit:onFilterModalSubmit,filterMode:filterMode,filterTemp:filterTemp,treeFilterTemp:treeFilterTemp,disabled:disabled,onFilterModeChange:onFilterModeChange,onFilterReset:onFilterReset,onRowsModalShow:onRowsModalShow,dataLanguage:dataLanguage,onFilterChange:onFilterChange,onBlockAdd:onBlockAdd,fetchColumnValues:fetchColumnValues,resetColumnValues:resetColumnValues,fetchColumnCodes:fetchColumnCodes,onBlockDelete:onBlockDelete,onConditionAdd:onConditionAdd,onConditionDelete:onConditionDelete,fetchColumnCodelistCount:fetchColumnCodelistCount,fetchColumnCodelistTree:fetchColumnCodelistTree,fetchColumnFilteredValues:fetchColumnFilteredValues,cubeId:cubeId,onTreeFilterChange:onTreeFilterChange,onColumnModeChange:onColumnModeChange,cubeFirstRow:cubeFirstRow,onColumnValuesChange:onColumnValuesChange,rows:rows,isRowsModalVisible:isRowsModalVisible,onRowsModalHide:onRowsModalHide,fetchRows:fetchRows}))));});}}]);return QueryForm;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_14_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps))(QueryForm));

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLanguageLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLanguageFlagIconCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEmptyDictionaryForLanguages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var getLanguageLabel=function getLanguageLabel(t,langCode){var langTranslation=t("languages."+langCode);return langTranslation!=="languages."+langCode?langTranslation:langCode.toUpperCase();};var getLanguageFlagIconCss=function getLanguageFlagIconCss(langCode,langsConfig){var langsConfigEl=langsConfig.find(function(_ref){var code=_ref.code;return code===langCode;});return"flag-icon-"+(langsConfigEl?langsConfigEl.flag:langCode);};var getEmptyDictionaryForLanguages=function getEmptyDictionaryForLanguages(languages,emptyElem){return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.fromPairs(languages.map(function(_ref2){var code=_ref2.code;return[code,emptyElem];}));};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(520);
var isBuffer = __webpack_require__(1164);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APP_CONFIG_CONFIG_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_CONFIG_CONFIG_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return APP_CONFIG_USER_INTERFACE_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_CONFIG_AGENCIES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return APP_CONFIG_DATA_MANAGEMENT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return APP_CONFIG_DEFAULT_HEADER_SUBMIT_STRUCTURE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return APP_CONFIG_SUPERUSER_CREDENTIALS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return APP_CONFIG_ENDPOINT_SETTINGS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return readAppConfigConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return submitAppConfigConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return changeAppConfigUserInterfaceForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return changeAppConfigAgenciesForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return changeAppConfigDataManagementForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return changeAppConfigDefaultHeaderSubmitStructureForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return changeAppConfigSuperUserCredentialsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return changeAppConfigEndpointSettingsForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var APP_CONFIG_CONFIG_READ='APP_CONFIG_CONFIG_READ';var APP_CONFIG_CONFIG_SUBMIT='APP_CONFIG_CONFIG_SUBMIT';var APP_CONFIG_USER_INTERFACE_FORM_CHANGE='APP_CONFIG_USER_INTERFACE_FORM_CHANGE';var APP_CONFIG_AGENCIES_CHANGE='APP_CONFIG_AGENCIES_CHANGE';var APP_CONFIG_DATA_MANAGEMENT_CHANGE='APP_CONFIG_DATA_MANAGEMENT_CHANGE';var APP_CONFIG_DEFAULT_HEADER_SUBMIT_STRUCTURE_CHANGE='APP_CONFIG_DEFAULT_HEADER_SUBMIT_STRUCTURE_CHANGE';var APP_CONFIG_SUPERUSER_CREDENTIALS_CHANGE='APP_CONFIG_SUPERUSER_CREDENTIALS_CHANGE';var APP_CONFIG_ENDPOINT_SETTINGS_CHANGE='APP_CONFIG_ENDPOINT_SETTINGS_CHANGE';var readAppConfigConfig=function readAppConfigConfig(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(APP_CONFIG_CONFIG_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["G" /* getConfigUrl */])(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["a" /* CONFIG_TYPE_APP */]));};var submitAppConfigConfig=function submitAppConfigConfig(config){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(APP_CONFIG_CONFIG_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["G" /* getConfigUrl */])(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["a" /* CONFIG_TYPE_APP */]),Object.assign({},config,{SuperUserCredentials:config.SuperUserCredentials.map(function(el){return Object.assign({},el,{password:el.password?btoa(el.password):undefined,confirmPassword:el.confirmPassword?btoa(el.confirmPassword):undefined});})}),function(t){return{success:t('scenes.configuration.appConfig.messages.submit.success')};});};var changeAppConfigUserInterfaceForm=function changeAppConfigUserInterfaceForm(fields){return{type:APP_CONFIG_USER_INTERFACE_FORM_CHANGE,fields:fields};};var changeAppConfigAgenciesForm=function changeAppConfigAgenciesForm(fields){return{type:APP_CONFIG_AGENCIES_CHANGE,fields:fields};};var changeAppConfigDataManagementForm=function changeAppConfigDataManagementForm(fields){return{type:APP_CONFIG_DATA_MANAGEMENT_CHANGE,fields:fields};};var changeAppConfigDefaultHeaderSubmitStructureForm=function changeAppConfigDefaultHeaderSubmitStructureForm(fields){return{type:APP_CONFIG_DEFAULT_HEADER_SUBMIT_STRUCTURE_CHANGE,fields:fields};};var changeAppConfigSuperUserCredentialsForm=function changeAppConfigSuperUserCredentialsForm(fields){return{type:APP_CONFIG_SUPERUSER_CREDENTIALS_CHANGE,fields:fields};};var changeAppConfigEndpointSettingsForm=function changeAppConfigEndpointSettingsForm(fields){return{type:APP_CONFIG_ENDPOINT_SETTINGS_CHANGE,fields:fields};};

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_getSdmxTypesTranslations__ = __webpack_require__(307);
var IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS="Success";var IMPORT_STRUCTURES_REPORT_STATUS_WARNING="Warning";var IMPORT_STRUCTURES_REPORT_STATUS_ERROR="Error";var IMPORT_STRUCTURES_REPORT_STATUS_FAILURE="Failure";var ArtefactExportReport=function ArtefactExportReport(_ref){var t=_ref.t,report=_ref.report;return report!==null?report.map(function(_ref2,index){var maintainableObject=_ref2.maintainableObject,status=_ref2.status,result=_ref2.result;var temp=maintainableObject.split("=")[0].split(".");var type=temp[temp.length-1];return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'space-between',style:index>0?{marginTop:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}:null},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_11__constants_getSdmxTypesTranslations__["a" /* getSdmxTypesTranslations */])(t)[type.toLowerCase()]+' ['+Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(maintainableObject))+']'),status===IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.success')+' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'check-circle',theme:'filled',style:{color:'green'}})))),status!==IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,function(){switch(status){case IMPORT_STRUCTURES_REPORT_STATUS_WARNING:return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'exclamation-circle',theme:'filled',style:{color:'orange'}})," ",t('scenes.utilities.importStructures.reportModal.status.warning')+': ',result);case IMPORT_STRUCTURES_REPORT_STATUS_ERROR:return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'close-circle',theme:'filled',style:{color:'red'}})," ",t('scenes.utilities.importStructures.reportModal.status.error')+': ',result);case IMPORT_STRUCTURES_REPORT_STATUS_FAILURE:return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'close-circle',theme:'filled',style:{color:'red'}})," ",t('scenes.utilities.importStructures.reportModal.status.error')+': ',result);default:return status;}}())));}):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])())(ArtefactExportReport));

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_upload_style__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_upload__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var FileInput=function(_React$Component){_inherits(FileInput,_React$Component);function FileInput(props){_classCallCheck(this,FileInput);var _this=_possibleConstructorReturn(this,(FileInput.__proto__||Object.getPrototypeOf(FileInput)).call(this,props));_this.state=FileInput.getInitState();_this.callOnChange=_this.callOnChange.bind(_this);_this.setFile=_this.setFile.bind(_this);return _this;}_createClass(FileInput,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){this.props.onChange(value);}}},{key:'setFile',value:function setFile(file,isZipAllowed,t){if(!file||file.size<2147483648){// 2147483648 bytes = 2 GB
this.setState({value:file});this.callOnChange(file);}else{__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('components.fileInput.modals.warning.fileTooBig.title'),content:file.type!=="application/x-zip-compressed"&&isZipAllowed?t('components.fileInput.modals.warning.fileTooBig.zipIt.content'):t('components.fileInput.modals.warning.fileTooBig.content')});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,accept=_props.accept,disabled=_props.disabled,isZipAllowed=_props.isZipAllowed;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{value:value!==null?value.name:null,onChange:function onChange(f){return f;},disabled:disabled,addonAfter:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_upload___default.a,{accept:accept,customRequest:function customRequest(upload){return _this2.setFile(upload.file,isZipAllowed,t);},showUploadList:false,style:{cursor:disabled?'not-allowed':'pointer'},disabled:disabled||value!==null},value!==null?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{onClick:disabled?null:function(e){e.stopPropagation();_this2.setFile(null,isZipAllowed,t);},type:'close'}):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:'paper-clip'}))});}}],[{key:'getInitState',value:function getInitState(){return{value:null};}},{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){return nextProps.value!==null?{value:nextProps.value}:FileInput.getInitState();}}]);return FileInput;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])()(FileInput));

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_languages__ = __webpack_require__(91);
var mapPropsToFields=function mapPropsToFields(_ref){var downloadArtefactForm=_ref.downloadArtefactForm;return{format:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:downloadArtefactForm?downloadArtefactForm.format:null}),references:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:downloadArtefactForm?downloadArtefactForm.references:null}),compression:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:downloadArtefactForm?downloadArtefactForm.compression:null}),csvSeparator:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:downloadArtefactForm?downloadArtefactForm.csvSeparator:null}),csvDelimiter:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:downloadArtefactForm?downloadArtefactForm.csvDelimiter:null}),csvLanguage:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:downloadArtefactForm?downloadArtefactForm.csvLanguage:null}),dimension:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:downloadArtefactForm?downloadArtefactForm.dimension:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]}};var ArtefactDownloadForm=function ArtefactDownloadForm(_ref3){var t=_ref3.t,form=_ref3.form,langs=_ref3.langs,hasReferences=_ref3.hasReferences,options=_ref3.options,queryFormRead=_ref3.queryFormRead,queryFormShow=_ref3.queryFormShow,queryPreviewShow=_ref3.queryPreviewShow,isQuerySet=_ref3.isQuerySet,isQueryPreviewShowDisabled=_ref3.isQueryPreviewShowDisabled,dimensions=_ref3.dimensions,sdmxFilters=_ref3.sdmxFilters;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.artefactDownloadForm.format.label')},formItemLayout),form.getFieldDecorator("format")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},title:form.getFieldValue("format")},options&&options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:index,value:option.key,title:option.label},option.label);})))),queryFormRead&&(form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["o" /* DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM */]||sdmxFilters&&(form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["p" /* DOWNLOAD_FORMAT_TYPE_GENERIC */]||form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["t" /* DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC */]||form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["q" /* DOWNLOAD_FORMAT_TYPE_GENERIC20 */]||form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["m" /* DOWNLOAD_FORMAT_TYPE_COMPACT */]||form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["s" /* DOWNLOAD_FORMAT_TYPE_SDMXCSV */]||form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["r" /* DOWNLOAD_FORMAT_TYPE_JSON */]))&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.artefactDownloadForm.query.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,isQuerySet?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{style:{width:96},onClick:queryFormShow},t('commons.buttons.edit.title')):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{style:{width:96},type:"primary",onClick:queryFormRead},t('commons.buttons.set.title')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{style:{width:96,marginLeft:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_MD"]},onClick:queryPreviewShow,disabled:isQueryPreviewShowDisabled},t('commons.buttons.preview.title')))),form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.commons.language.label')},formItemLayout),form.getFieldDecorator('csvLanguage')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref5){var props=_ref5.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},title:form.getFieldValue("csvLanguage")},langs.map(function(_ref6){var code=_ref6.code;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:code,value:code,title:Object(__WEBPACK_IMPORTED_MODULE_16__utils_languages__["c" /* getLanguageLabel */])(t,code)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i',{className:'flag-icon '+Object(__WEBPACK_IMPORTED_MODULE_16__utils_languages__["b" /* getLanguageFlagIconCss */])(code,langs),style:{marginRight:8}}),Object(__WEBPACK_IMPORTED_MODULE_16__utils_languages__["c" /* getLanguageLabel */])(t,code));})))),(form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]||form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["o" /* DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM */])&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.csv.separator.label')},formItemLayout),form.getFieldDecorator('csvSeparator')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue("csvSeparator"),maxLength:1,style:{width:96}}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.csv.delimiter.label')},formItemLayout),form.getFieldDecorator('csvDelimiter')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue("csvDelimiter"),maxLength:1,style:{width:96}})))),(form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["t" /* DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC */]||form.getFieldValue("format")===__WEBPACK_IMPORTED_MODULE_15__constants_download__["r" /* DOWNLOAD_FORMAT_TYPE_JSON */])&&dimensions&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('components.artefactDownloadForm.dimension.label')},formItemLayout),form.getFieldDecorator("dimension")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref7){var props=_ref7.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},title:form.getFieldValue("dimension")},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:null,title:t('components.artefactDownloadForm.dimension.noDimension.label')},t('components.artefactDownloadForm.dimension.noDimension.label')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:'AllDimensions',title:t('components.artefactDownloadForm.dimension.allDimension.label')},t('components.artefactDownloadForm.dimension.allDimension.label')),dimensions&&dimensions.map(function(dimension,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:index,value:dimension,title:dimension},dimension);})))),hasReferences&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('components.artefactDownloadForm.references.label')},formItemLayout),form.getFieldDecorator("references",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{title:form.getFieldValue("references")}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('components.artefactDownloadForm.compression.label')},formItemLayout),form.getFieldDecorator("compression",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{title:form.getFieldValue("compression")}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ArtefactDownloadForm));

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(281)('wks');
var uid = __webpack_require__(210);
var Symbol = __webpack_require__(119).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(401);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_animate__ = __webpack_require__(411);












var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Animate);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var PerfInput=function PerfInput(props,ref){var value=props.value;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),tempValue=_useState2[0],setTempValue=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setTempValue(value);},[value]);var componentProps=Object.assign({},props);delete componentProps.Component;delete componentProps.getValueFromEvent;var getValueFromEvent=props.getValueFromEvent||function(e){return e.target?e.target.value:e;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(props.Component,Object.assign({},componentProps,{ref:ref,value:tempValue,onChange:function onChange(e){return setTempValue(getValueFromEvent(e));},onBlur:function onBlur(){return props.onChange(tempValue);}}));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(PerfInput));

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CONCEPT_SCHEME_DETAIL_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONCEPT_SCHEME_DETAIL_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CONCEPT_SCHEME_DETAIL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CONCEPT_SCHEME_DETAIL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONCEPT_SCHEME_DETAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CONCEPT_SCHEME_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONCEPT_SCHEME_DETAIL_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CONCEPT_SCHEME_DETAIL_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONCEPT_SCHEME_DETAIL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CONCEPT_SCHEME_DETAIL_LANGUAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CONCEPT_SCHEME_DETAIL_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CONCEPT_SCHEME_DETAIL_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CONCEPT_SCHEME_DETAIL_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CONCEPT_SCHEME_DETAIL_DOWNLOAD_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONCEPT_SCHEME_DETAIL_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONCEPT_SCHEME_DETAIL_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONCEPT_SCHEME_DETAIL_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONCEPT_SCHEME_DETAIL_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CONCEPT_SCHEME_DETAIL_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CONCEPT_SCHEME_DETAIL_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CONCEPT_SCHEME_DETAIL_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CONCEPT_SCHEME_DETAIL_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CONCEPT_SCHEME_DETAIL_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CONCEPT_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CONCEPT_SCHEME_DETAIL_DERIVED_TAB_FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CONCEPT_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CONCEPT_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return readConceptSchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return createConceptSchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return editConceptSchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return showConceptSchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return changeConceptSchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return submitConceptSchemeDetailCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return submitConceptSchemeDetailUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return readConceptSchemeDetailAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return changeConceptSchemeDetailItemsViewMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return createConceptSchemeDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return editConceptSchemeDetailItemsItemDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return changeConceptSchemeDetailItemsItemDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return submitConceptSchemeDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return hideConceptSchemeDetailItemsItemDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return deleteConceptSchemeDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return selectConceptSchemeDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return showConceptSchemeDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return hideConceptSchemeDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return changeConceptSchemeDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return uploadConceptSchemeDetailItemsImportFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return importConceptSchemeDetailItemsImportFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return hideConceptSchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return showConceptSchemeDetailItemsItemAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return hideConceptSchemeDetailItemsItemAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return showConceptSchemeDetailItemsItemLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return hideConceptSchemeDetailItemsItemLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return showConceptSchemeDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return hideConceptSchemeDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return setConceptSchemeDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return unsetConceptSchemeDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return dropConceptSchemeDetailItemsItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return changeConceptSchemeDetailConceptSchemeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return hideConceptSchemeDetailItemsItemDuplicateItemError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return cutConceptSchemeDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return pasteConceptSchemeDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return showConceptSchemeDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return hideConceptSchemeDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return changeConceptSchemeDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return submitConceptSchemeDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return showConceptSchemeDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return hideConceptSchemeDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return changeConceptSchemeDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return submitConceptSchemeDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return showConceptSchemeDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return hideConceptSchemeDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return changeConceptSchemeDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return submitConceptSchemeDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return hideConceptSchemeDetailExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return showConceptSchemeDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return hideConceptSchemeDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return uploadConceptSchemeDetailItemsImportFormCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return readConceptSchemeDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return submitConceptSchemeDetailDerivedItemSchemeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return focusConceptSchemeDetailDerivedTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return unfocusConceptSchemeDetailDerivedTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return setConceptSchemeDetailItemsDefaultOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return changeConceptSchemeDetailDerivedCategorySchemeViewMode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artefact_export_form__ = __webpack_require__(51);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CONCEPT_SCHEME_DETAIL_READ='CONCEPT_SCHEME_DETAIL_READ';var CONCEPT_SCHEME_DETAIL_CREATE='CONCEPT_SCHEME_DETAIL_CREATE';var CONCEPT_SCHEME_DETAIL_EDIT='CONCEPT_SCHEME_DETAIL_EDIT';var CONCEPT_SCHEME_DETAIL_SHOW='CONCEPT_SCHEME_DETAIL_SHOW';var CONCEPT_SCHEME_DETAIL_CHANGE='CONCEPT_SCHEME_DETAIL_CHANGE';var CONCEPT_SCHEME_DETAIL_HIDE='CONCEPT_SCHEME_DETAIL_HIDE';var CONCEPT_SCHEME_DETAIL_CREATE_SUBMIT='CONCEPT_SCHEME_DETAIL_CREATE_SUBMIT';var CONCEPT_SCHEME_DETAIL_UPDATE_SUBMIT='CONCEPT_SCHEME_DETAIL_UPDATE_SUBMIT';var CONCEPT_SCHEME_DETAIL_AGENCIES_READ='CONCEPT_SCHEME_DETAIL_AGENCIES_READ';var CONCEPT_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE='CONCEPT_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CREATE='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CREATE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_EDIT='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_EDIT';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CHANGE='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CHANGE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_HIDE='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_HIDE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_SELECT='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_SELECT';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD';var CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ='CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET';var CONCEPT_SCHEME_DETAIL_LANGUAGE_CHANGE='CONCEPT_SCHEME_DETAIL_LANGUAGE_CHANGE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE';var CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CUT='CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CUT';var CONCEPT_SCHEME_DETAIL_DOWNLOAD_SHOW='CONCEPT_SCHEME_DETAIL_DOWNLOAD_SHOW';var CONCEPT_SCHEME_DETAIL_DOWNLOAD_HIDE='CONCEPT_SCHEME_DETAIL_DOWNLOAD_HIDE';var CONCEPT_SCHEME_DETAIL_DOWNLOAD_CHANGE='CONCEPT_SCHEME_DETAIL_DOWNLOAD_CHANGE';var CONCEPT_SCHEME_DETAIL_DOWNLOAD_SUBMIT='CONCEPT_SCHEME_DETAIL_DOWNLOAD_SUBMIT';var CONCEPT_SCHEME_DETAIL_CLONE_SHOW='CONCEPT_SCHEME_DETAIL_CLONE_SHOW';var CONCEPT_SCHEME_DETAIL_CLONE_HIDE='CONCEPT_SCHEME_DETAIL_CLONE_HIDE';var CONCEPT_SCHEME_DETAIL_CLONE_CHANGE='CONCEPT_SCHEME_DETAIL_CLONE_CHANGE';var CONCEPT_SCHEME_DETAIL_CLONE_SUBMIT='CONCEPT_SCHEME_DETAIL_CLONE_SUBMIT';var CONCEPT_SCHEME_DETAIL_EXPORT_SHOW='CONCEPT_SCHEME_DETAIL_EXPORT_SHOW';var CONCEPT_SCHEME_DETAIL_EXPORT_HIDE='CONCEPT_SCHEME_DETAIL_EXPORT_HIDE';var CONCEPT_SCHEME_DETAIL_EXPORT_CHANGE='CONCEPT_SCHEME_DETAIL_EXPORT_CHANGE';var CONCEPT_SCHEME_DETAIL_EXPORT_SUBMIT='CONCEPT_SCHEME_DETAIL_EXPORT_SUBMIT';var CONCEPT_SCHEME_DETAIL_EXPORT_REPORT_HIDE='CONCEPT_SCHEME_DETAIL_EXPORT_REPORT_HIDE';var CONCEPT_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT='CONCEPT_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT';var CONCEPT_SCHEME_DETAIL_DERIVED_TAB_FOCUS='CONCEPT_SCHEME_DETAIL_DERIVED_TAB_FOCUS';var CONCEPT_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS='CONCEPT_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS';var CONCEPT_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE='CONCEPT_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE';var readConceptSchemeDetail=function readConceptSchemeDetail(conceptSchemeTriplet,itemsOrderAnnotationType,lang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(CONCEPT_SCHEME_DETAIL_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["F" /* getConceptSchemeUrl */])(conceptSchemeTriplet)),{itemsOrderAnnotationType:itemsOrderAnnotationType,lang:lang});};var createConceptSchemeDetail=function createConceptSchemeDetail(defaultItemsViewMode){return{type:CONCEPT_SCHEME_DETAIL_CREATE,defaultItemsViewMode:defaultItemsViewMode};};var editConceptSchemeDetail=function editConceptSchemeDetail(conceptSchemeTriplet,defaultItemsViewMode){return{type:CONCEPT_SCHEME_DETAIL_EDIT,conceptSchemeTriplet:conceptSchemeTriplet,defaultItemsViewMode:defaultItemsViewMode};};var showConceptSchemeDetail=function showConceptSchemeDetail(conceptSchemeTriplet,defaultItemsViewMode){return{type:CONCEPT_SCHEME_DETAIL_SHOW,conceptSchemeTriplet:conceptSchemeTriplet,defaultItemsViewMode:defaultItemsViewMode};};var changeConceptSchemeDetail=function changeConceptSchemeDetail(fields){return{type:CONCEPT_SCHEME_DETAIL_CHANGE,fields:fields};};var submitConceptSchemeDetailCreate=function submitConceptSchemeDetailCreate(conceptScheme,conceptSchemeTriplet){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(conceptScheme)],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["z" /* SDMX_JSON_CONCEPT_SCHEME_LIST_KEY */]),function(t){return{success:t('reduxComponents.conceptSchemeDetail.messages.create.success')};}),{conceptSchemeTriplet:conceptSchemeTriplet});};var submitConceptSchemeDetailUpdate=function submitConceptSchemeDetailUpdate(conceptScheme,itemsTree,itemsOrderAnnotationType){var ret=[];var root=[{isRoot:true,concepts:itemsTree}];if(itemsTree){Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"concepts",function(node){if(!node.isRoot){var retNode=Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["Z" /* getSdmxJsonStructureFromItem */])(node);retNode.parent=undefined;retNode.annotations=conceptScheme.isFinal?retNode.annotations:Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["P" /* removeOrderAnnotation */])(retNode.annotations,itemsOrderAnnotationType);ret.push(retNode);}return node;});conceptScheme=Object.assign({},conceptScheme,{concepts:ret});}return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["n" /* putRequest */])(CONCEPT_SCHEME_DETAIL_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(conceptScheme)],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["z" /* SDMX_JSON_CONCEPT_SCHEME_LIST_KEY */]),function(t){return{success:t('reduxComponents.conceptSchemeDetail.messages.update.success')};}),{itemsTree:itemsTree});};var readConceptSchemeDetailAgencies=function readConceptSchemeDetailAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(CONCEPT_SCHEME_DETAIL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var changeConceptSchemeDetailItemsViewMode=function changeConceptSchemeDetailItemsViewMode(viewMode){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE,viewMode:viewMode};};var createConceptSchemeDetailsItemsItem=function createConceptSchemeDetailsItemsItem(parentId,order,lang,itemsOrderAnnotationType){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CREATE,parentId:parentId,order:order,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var editConceptSchemeDetailItemsItemDetail=function editConceptSchemeDetailItemsItemDetail(item){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_EDIT,item:item};};var changeConceptSchemeDetailItemsItemDetail=function changeConceptSchemeDetailItemsItemDetail(fields,lang,itemsOrderAnnotationType){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CHANGE,fields:fields,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var submitConceptSchemeDetailItemsItem=function submitConceptSchemeDetailItemsItem(conceptScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"concepts",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.concepts.push(cutItem);parentNode.concepts.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}if(isItemEditMode||!Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"concepts",function(node){return node.id===item.id;})){var root=[{isRoot:true,concepts:itemsTree}];itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"concepts",function(node){if(node.id===item.parent||node.id===undefined&&item.parent===null){if(isItemEditMode){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(node.concepts,function(child){return child.id===item.id;})){node.concepts.push(item);}node.concepts=node.concepts.map(function(child){if(child.id===item.id){if(item.order&&child.order[lang]!==item.order[lang]){var tempItem=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(item);tempItem.order[lang].length>0?Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(tempItem,String(Number(item.order[lang])-0.1),itemsOrderAnnotationType,lang):Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(tempItem,String(Number.MAX_VALUE),itemsOrderAnnotationType,lang);return tempItem;}return item;}else{return child;}});}else{item.order[lang].length>0?Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(item,String(Number(item.order[lang])-0.1),itemsOrderAnnotationType,lang):Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(item,String(Number.MAX_VALUE),itemsOrderAnnotationType,lang);node.concepts.push(item);}node.concepts.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{node.concepts=node.concepts.filter(function(c){return c.id!==item.id;});}return node;})[0].concepts;// if (isNormalizeNeeded) // uncomment for performance improvement
Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["b" /* normalizeItemsOrder */])(itemsTree,"concepts",lang,itemsOrderAnnotationType);return submitConceptSchemeDetailUpdate(conceptScheme,itemsTree,itemsOrderAnnotationType);}else{return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW};}};var hideConceptSchemeDetailItemsItemDetail=function hideConceptSchemeDetailItemsItemDetail(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_HIDE};};var deleteConceptSchemeDetailsItemsItem=function deleteConceptSchemeDetailsItemsItem(conceptScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"concepts",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.concepts.push(cutItem);parentNode.concepts.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}var root=[{isRoot:true,concepts:itemsTree}];itemsTree=item.parent?Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"concepts",function(node){if(node.id===item.parent){node.concepts=node.concepts.filter(function(child){return child.id!==item.id;});}return node;})[0].concepts:itemsTree.filter(function(node){return node.id!==item.id;});return submitConceptSchemeDetailUpdate(conceptScheme,itemsTree,itemsOrderAnnotationType);};var selectConceptSchemeDetailsItemsItem=function selectConceptSchemeDetailsItemsItem(id){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_SELECT,id:id};};var showConceptSchemeDetailItemsImportForm=function showConceptSchemeDetailItemsImportForm(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW};};var hideConceptSchemeDetailItemsImportForm=function hideConceptSchemeDetailItemsImportForm(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE};};var changeConceptSchemeDetailItemsImportForm=function changeConceptSchemeDetailItemsImportForm(fields){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE,fields:fields};};var uploadConceptSchemeDetailItemsImportFormFile=function uploadConceptSchemeDetailItemsImportFormFile(conceptScheme,itemsImportForm){var formData=new FormData();formData.append('file',itemsImportForm.file);formData.append('CustomData',JSON.stringify({type:'conceptScheme',identity:{ID:conceptScheme.id,Agency:conceptScheme.agencyID,Version:conceptScheme.version},lang:itemsImportForm.language,firstRowHeader:itemsImportForm.hasHeader,columns:itemsImportForm.hasHeader?{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?3:-1,order:itemsImportForm.hasOrderCol?4:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?5:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?6:-1}:{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?2+itemsImportForm.hasDescriptionCol:-1,order:itemsImportForm.hasOrderCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol+itemsImportForm.hasLayoutAnnotationFullNameCol:-1},textSeparator:itemsImportForm.separator,textDelimiter:itemsImportForm.delimiter}));return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["u" /* getCheckImportedFileCsvItemUrl */])(),formData,function(t){return{success:t('commons.artefact.messages.itemsImport.fileUpload.success')};});};var importConceptSchemeDetailItemsImportFormFile=function importConceptSchemeDetailItemsImportFormFile(conceptScheme,itemsImportForm){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_49" /* getImportFileCsvItemUrl */])(),{hashImport:itemsImportForm.hash,type:'conceptScheme',identity:{ID:conceptScheme.id,Agency:conceptScheme.agencyID,Version:conceptScheme.version},lang:itemsImportForm.language,firstRowHeader:itemsImportForm.hasHeader,columns:itemsImportForm.hasHeader?{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?3:-1,order:itemsImportForm.hasOrderCol?4:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?5:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?6:-1}:{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?2+itemsImportForm.hasDescriptionCol:-1,order:itemsImportForm.hasOrderCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol+itemsImportForm.hasLayoutAnnotationFullNameCol:-1},textSeparator:itemsImportForm.separator,textDelimiter:itemsImportForm.delimiter},function(t){return{success:t('commons.artefact.messages.itemsImport.fileImport.success')};});};var hideConceptSchemeDetail=function hideConceptSchemeDetail(){return{type:CONCEPT_SCHEME_DETAIL_HIDE};};var showConceptSchemeDetailItemsItemAnnotations=function showConceptSchemeDetailItemsItemAnnotations(annotations,itemId){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW,annotations:annotations,itemId:itemId};};var hideConceptSchemeDetailItemsItemAnnotations=function hideConceptSchemeDetailItemsItemAnnotations(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE};};var showConceptSchemeDetailItemsItemLayoutAnnotations=function showConceptSchemeDetailItemsItemLayoutAnnotations(annotations,itemId){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW,annotations:annotations,itemId:itemId};};var hideConceptSchemeDetailItemsItemLayoutAnnotations=function hideConceptSchemeDetailItemsItemLayoutAnnotations(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE};};var showConceptSchemeDetailItemsItemParentList=function showConceptSchemeDetailItemsItemParentList(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW};};var hideConceptSchemeDetailItemsItemParentList=function hideConceptSchemeDetailItemsItemParentList(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE};};var setConceptSchemeDetailItemsItemParentList=function setConceptSchemeDetailItemsItemParentList(item){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET,item:item};};var unsetConceptSchemeDetailItemsItemParentList=function unsetConceptSchemeDetailItemsItemParentList(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET};};var dropConceptSchemeDetailItemsItems=function dropConceptSchemeDetailItemsItems(item,newParent,newOrder,conceptScheme,itemsTree,itemsOrderAnnotationType,lang,cutItem,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"concepts",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.concepts.push(cutItem);parentNode.concepts.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}var root=[{isRoot:true,concepts:itemsTree}];itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"concepts",function(node){if((node.id===newParent||node.id===null&&newParent===undefined||node.id===undefined&&newParent===null)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(node.concepts,function(child){return child.id===item.id;})){node.concepts.push(Object.assign({},item,{parent:node.id}));}node.concepts.forEach(function(child){if(child.id===item.id){if(!(node.id===newParent||node.id===null&&newParent===undefined||node.id===undefined&&newParent===null)){node.concepts=node.concepts.filter(function(c){return c.id!==child.id;});}else{Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(child,newOrder,itemsOrderAnnotationType,lang);node.concepts.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}}});return node;})[0].concepts;Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["b" /* normalizeItemsOrder */])(itemsTree,"concepts",lang,itemsOrderAnnotationType);return submitConceptSchemeDetailUpdate(conceptScheme,itemsTree,itemsOrderAnnotationType);};var changeConceptSchemeDetailConceptSchemeLanguage=function changeConceptSchemeDetailConceptSchemeLanguage(lang,itemsOrderAnnotationType){return{type:CONCEPT_SCHEME_DETAIL_LANGUAGE_CHANGE,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var hideConceptSchemeDetailItemsItemDuplicateItemError=function hideConceptSchemeDetailItemsItemDuplicateItemError(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE};};var cutConceptSchemeDetailItemsItem=function cutConceptSchemeDetailItemsItem(item){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CUT,item:item};};var pasteConceptSchemeDetailItemsItem=function pasteConceptSchemeDetailItemsItem(cutItem,newParent,pasteAfter,conceptScheme,itemsTree,lang,itemsOrderAnnotationType){if(pasteAfter){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"concepts",function(node){return node.id===pasteAfter.parent;});if(parentNode){parentNode.concepts.push(Object.assign({},cutItem,{parent:parentNode.id,order:Object.assign({},cutItem.order,_defineProperty({},lang,String(Number(pasteAfter.order[lang])+0.1)))}));parentNode.concepts.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(Object.assign({},cutItem,{parent:null,order:Object.assign({},cutItem.order,_defineProperty({},lang,String(Number(pasteAfter.order[lang])+0.1)))}));itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}}else{var _parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"concepts",function(node){return node.id===newParent.id;});_parentNode.concepts.push(Object.assign({},cutItem,{parent:_parentNode.id}));_parentNode.concepts.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}return submitConceptSchemeDetailUpdate(conceptScheme,itemsTree.splice(0),itemsOrderAnnotationType);};var showConceptSchemeDetailDownload=function showConceptSchemeDetailDownload(artefactTriplets,lang){return{type:CONCEPT_SCHEME_DETAIL_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideConceptSchemeDetailDownload=function hideConceptSchemeDetailDownload(){return{type:CONCEPT_SCHEME_DETAIL_DOWNLOAD_HIDE};};var changeConceptSchemeDetailDownload=function changeConceptSchemeDetailDownload(fields){return{type:CONCEPT_SCHEME_DETAIL_DOWNLOAD_CHANGE,fields:fields};};var submitConceptSchemeDetailDownload=function submitConceptSchemeDetailDownload(artefactTriplets,downloadConceptSchemeParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_9__constants_download__["d" /* ARTEFACT_TYPE_CONCEPT_SCHEME */],downloadConceptSchemeParams.format,false,downloadConceptSchemeParams.compression,lang),artefactTriplets.map(function(_ref){var id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_9__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_9__constants_download__["d" /* ARTEFACT_TYPE_CONCEPT_SCHEME */],downloadConceptSchemeParams.format,downloadConceptSchemeParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(CONCEPT_SCHEME_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_9__constants_download__["d" /* ARTEFACT_TYPE_CONCEPT_SCHEME */],artefactTriplets[0],downloadConceptSchemeParams.format,false,downloadConceptSchemeParams.compression,downloadConceptSchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadConceptSchemeParams.csvLanguage:lang,downloadConceptSchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadConceptSchemeParams.csvSeparator:null,downloadConceptSchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadConceptSchemeParams.csvDelimiter:null),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_9__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_9__constants_download__["d" /* ARTEFACT_TYPE_CONCEPT_SCHEME */],downloadConceptSchemeParams.format,downloadConceptSchemeParams.compression,downloadConceptSchemeParams.csvLanguage)});};var showConceptSchemeDetailClone=function showConceptSchemeDetailClone(srcTriplet){return{type:CONCEPT_SCHEME_DETAIL_CLONE_SHOW,srcTriplet:srcTriplet};};var hideConceptSchemeDetailClone=function hideConceptSchemeDetailClone(){return{type:CONCEPT_SCHEME_DETAIL_CLONE_HIDE};};var changeConceptSchemeDetailClone=function changeConceptSchemeDetailClone(fields){return{type:CONCEPT_SCHEME_DETAIL_CLONE_CHANGE,fields:fields};};var submitConceptSchemeDetailClone=function submitConceptSchemeDetailClone(cloneDestTriplet,srcConceptScheme,srcConceptSchemeItemsTree,annotationsConfig){var concepts=undefined;if(srcConceptSchemeItemsTree){concepts=srcConceptSchemeItemsTree.map(function(node){node.parent=undefined;return Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["Z" /* getSdmxJsonStructureFromItem */])(node,annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["c" /* CONCEPT_SCHEME_ORDER_ANNOTATION_KEY */]],true);});}return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},srcConceptScheme,cloneDestTriplet,{concepts:concepts,isFinal:false,annotations:Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["d" /* getFilteredAnnotations */])(srcConceptScheme.annotations,annotationsConfig),autoAnnotations:null}))],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["z" /* SDMX_JSON_CONCEPT_SCHEME_LIST_KEY */]),function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showConceptSchemeDetailExport=function showConceptSchemeDetailExport(sourceTriplet){return{type:CONCEPT_SCHEME_DETAIL_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideConceptSchemeDetailExport=function hideConceptSchemeDetailExport(){return{type:CONCEPT_SCHEME_DETAIL_EXPORT_HIDE};};var changeConceptSchemeDetailExport=function changeConceptSchemeDetailExport(fields){return{type:CONCEPT_SCHEME_DETAIL_EXPORT_CHANGE,fields:fields};};var submitConceptSchemeDetailExport=function submitConceptSchemeDetailExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||[]),EnumType:"ConceptScheme",CopyReferencedArtefact:false,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_11__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideConceptSchemeDetailExportReport=function hideConceptSchemeDetailExportReport(){return{type:CONCEPT_SCHEME_DETAIL_EXPORT_REPORT_HIDE};};var showConceptSchemeDetailItemsImportFormAllCsvRows=function showConceptSchemeDetailItemsImportFormAllCsvRows(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW};};var hideConceptSchemeDetailItemsImportFormAllCsvRows=function hideConceptSchemeDetailItemsImportFormAllCsvRows(){return{type:CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE};};var uploadConceptSchemeDetailItemsImportFormCsv=function uploadConceptSchemeDetailItemsImportFormCsv(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),fileFormData);};var readConceptSchemeDetailItemsImportFormAllCsvRows=function readConceptSchemeDetailItemsImportFormAllCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,filePath,null,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var submitConceptSchemeDetailDerivedItemSchemeCreate=function submitConceptSchemeDetailDerivedItemSchemeCreate(derivedConceptScheme,derivedItems){var concepts=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["n" /* getTreeFromArray */])(derivedItems,"concepts");concepts=concepts.map(function(concept){return Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["Z" /* getSdmxJsonStructureFromItem */])(concept);});return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CONCEPT_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},derivedConceptScheme,{concepts:concepts}))],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["z" /* SDMX_JSON_CONCEPT_SCHEME_LIST_KEY */]),function(t){return{success:t('reduxComponents.conceptSchemeDetail.messages.create.success')};});};var focusConceptSchemeDetailDerivedTab=function focusConceptSchemeDetailDerivedTab(){return{type:CONCEPT_SCHEME_DETAIL_DERIVED_TAB_FOCUS};};var unfocusConceptSchemeDetailDerivedTab=function unfocusConceptSchemeDetailDerivedTab(){return{type:CONCEPT_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS};};var setConceptSchemeDetailItemsDefaultOrder=function setConceptSchemeDetailItemsDefaultOrder(conceptScheme,itemsTree,currLang,dataLangs,itemsOrderAnnotationType){itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(itemsTree,"concepts",function(item){var orderAnnotation=item.autoAnnotations.find(function(_ref2){var type=_ref2.type;return type===itemsOrderAnnotationType;});dataLangs.map(function(_ref3){var code=_ref3.code;return code;}).forEach(function(lang){if(lang!==currLang){orderAnnotation.text[lang]=orderAnnotation.text[currLang];}});return item;});return submitConceptSchemeDetailUpdate(conceptScheme,itemsTree,itemsOrderAnnotationType);};var changeConceptSchemeDetailDerivedCategorySchemeViewMode=function changeConceptSchemeDetailDerivedCategorySchemeViewMode(mode){return{type:CONCEPT_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE,mode:mode};};

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CATEGORY_SCHEME_DETAIL_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CATEGORY_SCHEME_DETAIL_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CATEGORY_SCHEME_DETAIL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CATEGORY_SCHEME_DETAIL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CATEGORY_SCHEME_DETAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CATEGORY_SCHEME_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CATEGORY_SCHEME_DETAIL_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CATEGORY_SCHEME_DETAIL_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CATEGORY_SCHEME_DETAIL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CATEGORY_SCHEME_DETAIL_LANGUAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CATEGORY_SCHEME_DETAIL_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CATEGORY_SCHEME_DETAIL_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CATEGORY_SCHEME_DETAIL_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CATEGORY_SCHEME_DETAIL_DOWNLOAD_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CATEGORY_SCHEME_DETAIL_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CATEGORY_SCHEME_DETAIL_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CATEGORY_SCHEME_DETAIL_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CATEGORY_SCHEME_DETAIL_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CATEGORY_SCHEME_DETAIL_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CATEGORY_SCHEME_DETAIL_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CATEGORY_SCHEME_DETAIL_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CATEGORY_SCHEME_DETAIL_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CATEGORY_SCHEME_DETAIL_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CATEGORY_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CATEGORY_SCHEME_DETAIL_DERIVED_TAB_FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CATEGORY_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CATEGORY_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return createCategorySchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return showCategorySchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return editCategorySchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return readCategorySchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return changeCategorySchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return hideCategorySchemeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return submitCategorySchemeDetailCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return submitCategorySchemeDetailUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return readCategorySchemeDetailAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return changeCategorySchemeDetailItemsViewMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return createCategorySchemesDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return editCategorySchemesDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return changeCategorySchemeDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return submitCategorySchemeDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return hideCategorySchemeDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return deleteCategorySchemeDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return selectCategorySchemeDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return showCategorySchemeDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return hideCategorySchemeDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return changeCategorySchemeDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return uploadCategorySchemeDetailItemsImportFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return importCategorySchemeDetailItemsImportFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return showCategorySchemeDetailItemsItemAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return hideCategorySchemeDetailItemsItemAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return showCategorySchemeDetailItemsItemLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return hideCategorySchemeDetailItemsItemLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return showCategorySchemeDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return hideCategorySchemeDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return setCategorySchemeDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return unsetCategorySchemeDetailItemsItemParentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return dropCategorySchemesDetailItemsItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return changeCategorySchemeDetailLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return hideCategorySchemeDetailItemsItemDuplicateItemError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return cutCategorySchemeDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return pasteCategorySchemeDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return showCategorySchemeDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return hideCategorySchemeDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return changeCategorySchemeDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return submitCategorySchemeDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return showCategorySchemeCategorySchemeClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return hideCategorySchemeCategorySchemeClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return changeCategorySchemeCategorySchemeClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return submitCategorySchemeCategorySchemeClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return showCategorySchemeCategorySchemeExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return hideCategorySchemeDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return changeCategorySchemeDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return submitCategorySchemeDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return hideCategorySchemeDetailExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return showCategorySchemeDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return hideCategorySchemeDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return uploadCategorySchemeDetailItemsImportFormCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return readCategorySchemeDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return submitCategorySchemeDetailDerivedItemSchemeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return focusCategorySchemeDetailDerivedTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return unfocusCategorySchemeDetailDerivedTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return setCategorySchemeDetailItemsDefaultOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return changeCategorySchemeDetailDerivedCategorySchemeViewMode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artefact_export_form__ = __webpack_require__(51);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CATEGORY_SCHEME_DETAIL_READ='CATEGORY_SCHEME_DETAIL_READ';var CATEGORY_SCHEME_DETAIL_CREATE='CATEGORY_SCHEME_DETAIL_CREATE';var CATEGORY_SCHEME_DETAIL_EDIT='CATEGORY_SCHEME_DETAIL_EDIT';var CATEGORY_SCHEME_DETAIL_SHOW='CATEGORY_SCHEME_DETAIL_SHOW';var CATEGORY_SCHEME_DETAIL_CHANGE='CATEGORY_SCHEME_DETAIL_CHANGE';var CATEGORY_SCHEME_DETAIL_HIDE='CATEGORY_SCHEME_DETAIL_HIDE';var CATEGORY_SCHEME_DETAIL_CREATE_SUBMIT='CATEGORY_SCHEME_DETAIL_CREATE_SUBMIT';var CATEGORY_SCHEME_DETAIL_UPDATE_SUBMIT='CATEGORY_SCHEME_DETAIL_UPDATE_SUBMIT';var CATEGORY_SCHEME_DETAIL_AGENCIES_READ='CATEGORY_SCHEME_DETAIL_AGENCIES_READ';var CATEGORY_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE='CATEGORY_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CREATE='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CREATE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_EDIT='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_EDIT';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CHANGE='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CHANGE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_HIDE='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_HIDE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_SELECT='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_SELECT';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD';var CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT='CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET';var CATEGORY_SCHEME_DETAIL_LANGUAGE_CHANGE='CATEGORY_SCHEME_DETAIL_LANGUAGE_CHANGE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE';var CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CUT='CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CUT';var CATEGORY_SCHEME_DETAIL_DOWNLOAD_SHOW='CATEGORY_SCHEME_DETAIL_DOWNLOAD_SHOW';var CATEGORY_SCHEME_DETAIL_DOWNLOAD_HIDE='CATEGORY_SCHEME_DETAIL_DOWNLOAD_HIDE';var CATEGORY_SCHEME_DETAIL_DOWNLOAD_CHANGE='CATEGORY_SCHEME_DETAIL_DOWNLOAD_CHANGE';var CATEGORY_SCHEME_DETAIL_DOWNLOAD_SUBMIT='CATEGORY_SCHEME_DETAIL_DOWNLOAD_SUBMIT';var CATEGORY_SCHEME_DETAIL_CLONE_SHOW='CATEGORY_SCHEME_DETAIL_CLONE_SHOW';var CATEGORY_SCHEME_DETAIL_CLONE_HIDE='CATEGORY_SCHEME_DETAIL_CLONE_HIDE';var CATEGORY_SCHEME_DETAIL_CLONE_CHANGE='CATEGORY_SCHEME_DETAIL_CLONE_CHANGE';var CATEGORY_SCHEME_DETAIL_CLONE_SUBMIT='CATEGORY_SCHEME_DETAIL_CLONE_SUBMIT';var CATEGORY_SCHEME_DETAIL_EXPORT_SHOW='CATEGORY_SCHEME_DETAIL_EXPORT_SHOW';var CATEGORY_SCHEME_DETAIL_EXPORT_HIDE='CATEGORY_SCHEME_DETAIL_EXPORT_HIDE';var CATEGORY_SCHEME_DETAIL_EXPORT_CHANGE='CATEGORY_SCHEME_DETAIL_EXPORT_CHANGE';var CATEGORY_SCHEME_DETAIL_EXPORT_SUBMIT='CATEGORY_SCHEME_DETAIL_EXPORT_SUBMIT';var CATEGORY_SCHEME_DETAIL_EXPORT_REPORT_HIDE='CATEGORY_SCHEME_DETAIL_EXPORT_REPORT_HIDE';var CATEGORY_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT='CATEGORY_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT';var CATEGORY_SCHEME_DETAIL_DERIVED_TAB_FOCUS='CATEGORY_SCHEME_DETAIL_DERIVED_TAB_FOCUS';var CATEGORY_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS='CATEGORY_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS';var CATEGORY_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE='CATEGORY_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE';var getNewItemCategorisations=function getNewItemCategorisations(categoryScheme,item,itemsTree,categorisations){var newItemCategorisations=[];if(categoryScheme.isFinal){var oldItemCategorisations=categorisations.filter(function(_ref){var target=_ref.target;return Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["U" /* getQuartupletFromItemString */])(Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_2" /* getStringFromItemUrn */])(target)).itemId===item.id;});if(oldItemCategorisations.length>0){var itemP=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["g" /* getFilteredTreeWithPaths */])(itemsTree,"categories",function(_ref2){var id=_ref2.id;return id===item.id;})[0];var itemPathStr="";while(itemP){itemPathStr+=itemP.id+".";if(itemP.categories&&itemP.categories[0]){itemP=itemP.categories[0];}else{itemP=null;}}itemPathStr=itemPathStr.slice(0,-1);var newTarget="urn:sdmx:org.sdmx.infomodel.categoryscheme.Category="+(categoryScheme.agencyID+":"+categoryScheme.id+"("+categoryScheme.version+").")+itemPathStr;newItemCategorisations=oldItemCategorisations.filter(function(_ref3){var target=_ref3.target;return target!==newTarget;}).map(function(cat){return Object.assign({},cat,{target:newTarget});});}}return newItemCategorisations;};var createCategorySchemeDetail=function createCategorySchemeDetail(defaultItemsViewMode){return{type:CATEGORY_SCHEME_DETAIL_CREATE,defaultItemsViewMode:defaultItemsViewMode};};var showCategorySchemeDetail=function showCategorySchemeDetail(categorySchemeTriplet,defaultItemsViewMode){return{type:CATEGORY_SCHEME_DETAIL_SHOW,categorySchemeTriplet:categorySchemeTriplet,defaultItemsViewMode:defaultItemsViewMode};};var editCategorySchemeDetail=function editCategorySchemeDetail(categorySchemeTriplet,defaultItemsViewMode){return{type:CATEGORY_SCHEME_DETAIL_EDIT,categorySchemeTriplet:categorySchemeTriplet,defaultItemsViewMode:defaultItemsViewMode};};var readCategorySchemeDetail=function readCategorySchemeDetail(categorySchemeTriplet,itemsOrderAnnotationType,lang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["i" /* allRequest */])(CATEGORY_SCHEME_DETAIL_READ,[__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["p" /* getCategorySchemeUrl */])(categorySchemeTriplet),Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["p" /* getCategorySchemeUrl */])(null,true)]),{itemsOrderAnnotationType:itemsOrderAnnotationType,lang:lang});};var changeCategorySchemeDetail=function changeCategorySchemeDetail(fields){return{type:CATEGORY_SCHEME_DETAIL_CHANGE,fields:fields};};var hideCategorySchemeDetail=function hideCategorySchemeDetail(){return{type:CATEGORY_SCHEME_DETAIL_HIDE};};var submitCategorySchemeDetailCreate=function submitCategorySchemeDetailCreate(categoryScheme,categorySchemeTriplet){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(categoryScheme)],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */]),function(t){return{success:t('reduxComponents.categorySchemeDetail.messages.create.success')};}),{categorySchemeTriplet:categorySchemeTriplet});};var submitCategorySchemeDetailUpdate=function submitCategorySchemeDetailUpdate(categoryScheme,itemsTree,itemsOrderAnnotationType,newItemCategorisations){var categories=undefined;if(itemsTree){categories=itemsTree.map(function(node){return Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["Z" /* getSdmxJsonStructureFromItem */])(node);});categories=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(categories,"categories",function(item){return Object.assign({},item,{annotations:categoryScheme.isFinal?item.annotations:Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["P" /* removeOrderAnnotation */])(item.annotations,itemsOrderAnnotationType),parent:undefined});});categoryScheme=Object.assign({},categoryScheme,{categories:categories});}var categorySchemeJson=Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(categoryScheme)],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */]);if(newItemCategorisations&&newItemCategorisations.length){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["i" /* allRequest */])(CATEGORY_SCHEME_DETAIL_UPDATE_SUBMIT,[__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["f" /* REQUEST_METHOD_PUT */],__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */]],[Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])()],[categorySchemeJson,Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])(newItemCategorisations.map(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */]),__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["r" /* SDMX_JSON_CATEGORISATION_LIST_KEY */])],function(t){return{success:t('reduxComponents.categorySchemeDetail.messages.update.success')};},null,true),{itemsTree:itemsTree});}else{return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["n" /* putRequest */])(CATEGORY_SCHEME_DETAIL_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),categorySchemeJson,function(t){return{success:t('reduxComponents.categorySchemeDetail.messages.update.success')};}),{itemsTree:itemsTree});}};var readCategorySchemeDetailAgencies=function readCategorySchemeDetailAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(CATEGORY_SCHEME_DETAIL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var changeCategorySchemeDetailItemsViewMode=function changeCategorySchemeDetailItemsViewMode(viewMode){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE,viewMode:viewMode};};var createCategorySchemesDetailsItemsItem=function createCategorySchemesDetailsItemsItem(parentId,order,lang,itemsOrderAnnotationType){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CREATE,parentId:parentId,order:order,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var editCategorySchemesDetailItemsItem=function editCategorySchemesDetailItemsItem(item){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_EDIT,item:item};};var changeCategorySchemeDetailItemsItem=function changeCategorySchemeDetailItemsItem(fields,lang,itemsOrderAnnotationType){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CHANGE,fields:fields,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var submitCategorySchemeDetailItemsItem=function submitCategorySchemeDetailItemsItem(categoryScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"categories",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.categories.push(cutItem);parentNode.categories.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}if(isItemEditMode||!Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"categories",function(node){return node.id===item.id;})){var root=[{isRoot:true,categories:itemsTree}];itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"categories",function(node){if(node.id===item.parent||node.id===undefined&&item.parent===null){if(isItemEditMode){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(node.categories,function(child){return child.id===item.id;})){node.categories.push(item);}node.categories=node.categories.map(function(child){if(child.id===item.id){if(item.order&&child.order[lang]!==item.order[lang]){var tempItem=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(item);tempItem.order[lang].length>0?Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(tempItem,String(Number(item.order[lang])-0.1),itemsOrderAnnotationType,lang):Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(tempItem,String(Number.MAX_VALUE),itemsOrderAnnotationType,lang);return tempItem;}return item;}else{return child;}});}else{item.order[lang].length>0?Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(item,String(Number(item.order[lang])-0.1),itemsOrderAnnotationType,lang):Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(item,String(Number.MAX_VALUE),itemsOrderAnnotationType,lang);node.categories.push(item);}node.categories.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{node.categories=node.categories.filter(function(c){return c.id!==item.id;});}return node;})[0].categories;// if (isNormalizeNeeded) // uncomment for performance improvement
Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["b" /* normalizeItemsOrder */])(itemsTree,"categories",lang,itemsOrderAnnotationType);return submitCategorySchemeDetailUpdate(categoryScheme,itemsTree,itemsOrderAnnotationType);}else{return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW};}};var hideCategorySchemeDetailItemsItem=function hideCategorySchemeDetailItemsItem(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_HIDE};};var deleteCategorySchemeDetailsItemsItem=function deleteCategorySchemeDetailsItemsItem(categoryScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"categories",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.categories.push(cutItem);parentNode.categories.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}var root=[{isRoot:true,categories:itemsTree}];itemsTree=item.parent?Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"categories",function(node){if(node.id===item.parent){node.categories=node.categories.filter(function(child){return child.id!==item.id;});}return node;})[0].categories:itemsTree.filter(function(node){return node.id!==item.id;});return submitCategorySchemeDetailUpdate(categoryScheme,itemsTree,itemsOrderAnnotationType);};var selectCategorySchemeDetailsItemsItem=function selectCategorySchemeDetailsItemsItem(id){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_SELECT,id:id};};var showCategorySchemeDetailItemsImportForm=function showCategorySchemeDetailItemsImportForm(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW};};var hideCategorySchemeDetailItemsImportForm=function hideCategorySchemeDetailItemsImportForm(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE};};var changeCategorySchemeDetailItemsImportForm=function changeCategorySchemeDetailItemsImportForm(fields){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE,fields:fields};};var uploadCategorySchemeDetailItemsImportFormFile=function uploadCategorySchemeDetailItemsImportFormFile(categoryScheme,itemsImportForm){var formData=new FormData();formData.append('file',itemsImportForm.file);formData.append('CustomData',JSON.stringify({type:'categoryScheme',identity:{ID:categoryScheme.id,Agency:categoryScheme.agencyID,Version:categoryScheme.version},lang:itemsImportForm.language,firstRowHeader:itemsImportForm.hasHeader,columns:itemsImportForm.hasHeader?{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?3:-1,order:itemsImportForm.hasOrderCol?4:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?5:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?6:-1}:{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?2+itemsImportForm.hasDescriptionCol:-1,order:itemsImportForm.hasOrderCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol+itemsImportForm.hasLayoutAnnotationFullNameCol:-1},textSeparator:itemsImportForm.separator,textDelimiter:itemsImportForm.delimiter}));return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["u" /* getCheckImportedFileCsvItemUrl */])(),formData,function(t){return{success:t('commons.artefact.messages.itemsImport.fileUpload.success')};});};var importCategorySchemeDetailItemsImportFormFile=function importCategorySchemeDetailItemsImportFormFile(categoryScheme,itemsImportForm){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_49" /* getImportFileCsvItemUrl */])(),{hashImport:itemsImportForm.hash,type:'categoryScheme',identity:{ID:categoryScheme.id,Agency:categoryScheme.agencyID,Version:categoryScheme.version},lang:itemsImportForm.language,firstRowHeader:itemsImportForm.hasHeader,columns:itemsImportForm.hasHeader?{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?3:-1,order:itemsImportForm.hasOrderCol?4:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?5:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?6:-1}:{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?2+itemsImportForm.hasDescriptionCol:-1,order:itemsImportForm.hasOrderCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol+itemsImportForm.hasLayoutAnnotationFullNameCol:-1},textSeparator:itemsImportForm.separator,textDelimiter:itemsImportForm.delimiter},function(t){return{success:t('commons.artefact.messages.itemsImport.fileImport.success')};});};var showCategorySchemeDetailItemsItemAnnotations=function showCategorySchemeDetailItemsItemAnnotations(annotations,itemId){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW,annotations:annotations,itemId:itemId};};var hideCategorySchemeDetailItemsItemAnnotations=function hideCategorySchemeDetailItemsItemAnnotations(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE};};var showCategorySchemeDetailItemsItemLayoutAnnotations=function showCategorySchemeDetailItemsItemLayoutAnnotations(annotations,itemId){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW,annotations:annotations,itemId:itemId};};var hideCategorySchemeDetailItemsItemLayoutAnnotations=function hideCategorySchemeDetailItemsItemLayoutAnnotations(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE};};var showCategorySchemeDetailItemsItemParentList=function showCategorySchemeDetailItemsItemParentList(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW};};var hideCategorySchemeDetailItemsItemParentList=function hideCategorySchemeDetailItemsItemParentList(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE};};var setCategorySchemeDetailItemsItemParentList=function setCategorySchemeDetailItemsItemParentList(item){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET,item:item};};var unsetCategorySchemeDetailItemsItemParentList=function unsetCategorySchemeDetailItemsItemParentList(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET};};var dropCategorySchemesDetailItemsItems=function dropCategorySchemesDetailItemsItems(item,newParent,newOrder,categoryScheme,itemsTree,categorisations,itemsOrderAnnotationType,lang,cutItem,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"categories",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.categories.push(cutItem);parentNode.categories.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}var root=[{isRoot:true,categories:itemsTree}];itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"categories",function(node){if((node.id===newParent||node.id===null&&newParent===undefined||node.id===undefined&&newParent===null)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(node.categories,function(child){return child.id===item.id;})){node.categories.push(Object.assign({},item,{parent:node.id}));}node.categories.forEach(function(child){if(child.id===item.id){if(!(node.id===newParent||node.id===null&&newParent===undefined||node.id===undefined&&newParent===null)){node.categories=node.categories.filter(function(c){return c.id!==child.id;});}else{Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(child,newOrder,itemsOrderAnnotationType,lang);node.categories.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}}});return node;})[0].categories;Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["b" /* normalizeItemsOrder */])(itemsTree,"categories",lang,itemsOrderAnnotationType);var newItemCategorisations=getNewItemCategorisations(categoryScheme,item,itemsTree,categorisations);return submitCategorySchemeDetailUpdate(categoryScheme,itemsTree,itemsOrderAnnotationType,newItemCategorisations);};var changeCategorySchemeDetailLanguage=function changeCategorySchemeDetailLanguage(lang,itemsOrderAnnotationType){return{type:CATEGORY_SCHEME_DETAIL_LANGUAGE_CHANGE,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var hideCategorySchemeDetailItemsItemDuplicateItemError=function hideCategorySchemeDetailItemsItemDuplicateItemError(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE};};var cutCategorySchemeDetailItemsItem=function cutCategorySchemeDetailItemsItem(item){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CUT,item:item};};var pasteCategorySchemeDetailItemsItem=function pasteCategorySchemeDetailItemsItem(cutItem,newParent,pasteAfter,categoryScheme,itemsTree,categorisations,lang,itemsOrderAnnotationType){if(pasteAfter){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"categories",function(node){return node.id===pasteAfter.parent;});if(parentNode){parentNode.categories.push(Object.assign({},cutItem,{parent:parentNode.id,order:Object.assign({},cutItem.order,_defineProperty({},lang,String(Number(pasteAfter.order[lang])+0.1)))}));parentNode.categories.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(Object.assign({},cutItem,{parent:null,order:Object.assign({},cutItem.order,_defineProperty({},lang,String(Number(pasteAfter.order[lang])+0.1)))}));itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}}else{var _parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"categories",function(node){return node.id===newParent.id;});_parentNode.categories.push(Object.assign({},cutItem,{parent:_parentNode.id}));_parentNode.categories.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}var newItemCategorisations=getNewItemCategorisations(categoryScheme,cutItem,itemsTree,categorisations);return submitCategorySchemeDetailUpdate(categoryScheme,itemsTree.splice(0),itemsOrderAnnotationType,newItemCategorisations);};var showCategorySchemeDetailDownload=function showCategorySchemeDetailDownload(artefactTriplets,lang){return{type:CATEGORY_SCHEME_DETAIL_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideCategorySchemeDetailDownload=function hideCategorySchemeDetailDownload(){return{type:CATEGORY_SCHEME_DETAIL_DOWNLOAD_HIDE};};var changeCategorySchemeDetailDownload=function changeCategorySchemeDetailDownload(fields){return{type:CATEGORY_SCHEME_DETAIL_DOWNLOAD_CHANGE,fields:fields};};var submitCategorySchemeDetailDownload=function submitCategorySchemeDetailDownload(artefactTriplets,downloadCategorySchemeParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_9__constants_download__["b" /* ARTEFACT_TYPE_CATEGORY_SCHEME */],downloadCategorySchemeParams.format,false,downloadCategorySchemeParams.compression,lang),artefactTriplets.map(function(_ref4){var id=_ref4.id,agencyID=_ref4.agencyID,version=_ref4.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_9__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_9__constants_download__["b" /* ARTEFACT_TYPE_CATEGORY_SCHEME */],downloadCategorySchemeParams.format,downloadCategorySchemeParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(CATEGORY_SCHEME_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_9__constants_download__["b" /* ARTEFACT_TYPE_CATEGORY_SCHEME */],artefactTriplets[0],downloadCategorySchemeParams.format,false,downloadCategorySchemeParams.compression,downloadCategorySchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadCategorySchemeParams.csvLanguage:lang,downloadCategorySchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadCategorySchemeParams.csvSeparator:null,downloadCategorySchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadCategorySchemeParams.csvDelimiter:null),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_9__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_9__constants_download__["b" /* ARTEFACT_TYPE_CATEGORY_SCHEME */],downloadCategorySchemeParams.format,downloadCategorySchemeParams.compression,downloadCategorySchemeParams.csvLanguage)});};var showCategorySchemeCategorySchemeClone=function showCategorySchemeCategorySchemeClone(srcTriplet){return{type:CATEGORY_SCHEME_DETAIL_CLONE_SHOW,srcTriplet:srcTriplet};};var hideCategorySchemeCategorySchemeClone=function hideCategorySchemeCategorySchemeClone(){return{type:CATEGORY_SCHEME_DETAIL_CLONE_HIDE};};var changeCategorySchemeCategorySchemeClone=function changeCategorySchemeCategorySchemeClone(fields){return{type:CATEGORY_SCHEME_DETAIL_CLONE_CHANGE,fields:fields};};var submitCategorySchemeCategorySchemeClone=function submitCategorySchemeCategorySchemeClone(cloneDestTriplet,srcCategoryScheme,srcCategorySchemeItemsTree,annotationsConfig){var categories=undefined;if(srcCategorySchemeItemsTree){categories=srcCategorySchemeItemsTree.map(function(node){return Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["Z" /* getSdmxJsonStructureFromItem */])(node,annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]],true);});categories=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(categories,"categories",function(item){return Object.assign({},item,{parent:undefined});});}return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},srcCategoryScheme,cloneDestTriplet,{categories:categories,isFinal:false,annotations:Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["d" /* getFilteredAnnotations */])(srcCategoryScheme.annotations,annotationsConfig),autoAnnotations:null}))],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */]),function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showCategorySchemeCategorySchemeExport=function showCategorySchemeCategorySchemeExport(sourceTriplet){return{type:CATEGORY_SCHEME_DETAIL_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideCategorySchemeDetailExport=function hideCategorySchemeDetailExport(){return{type:CATEGORY_SCHEME_DETAIL_EXPORT_HIDE};};var changeCategorySchemeDetailExport=function changeCategorySchemeDetailExport(fields){return{type:CATEGORY_SCHEME_DETAIL_EXPORT_CHANGE,fields:fields};};var submitCategorySchemeDetailExport=function submitCategorySchemeDetailExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.loginOption===__WEBPACK_IMPORTED_MODULE_11__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.username:null,password:destination.loginOption===__WEBPACK_IMPORTED_MODULE_11__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?btoa(destination.password||[]):null,EnumType:"CategoryScheme",CopyReferencedArtefact:false,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_11__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideCategorySchemeDetailExportReport=function hideCategorySchemeDetailExportReport(){return{type:CATEGORY_SCHEME_DETAIL_EXPORT_REPORT_HIDE};};var showCategorySchemeDetailItemsImportFormAllCsvRows=function showCategorySchemeDetailItemsImportFormAllCsvRows(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW};};var hideCategorySchemeDetailItemsImportFormAllCsvRows=function hideCategorySchemeDetailItemsImportFormAllCsvRows(){return{type:CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE};};var uploadCategorySchemeDetailItemsImportFormCsv=function uploadCategorySchemeDetailItemsImportFormCsv(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),fileFormData);};var readCategorySchemeDetailItemsImportFormAllCsvRows=function readCategorySchemeDetailItemsImportFormAllCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,filePath,null,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var submitCategorySchemeDetailDerivedItemSchemeCreate=function submitCategorySchemeDetailDerivedItemSchemeCreate(derivedCategoryScheme,derivedItems){var categories=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["n" /* getTreeFromArray */])(derivedItems,"categories");categories=categories.map(function(category){return Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["Z" /* getSdmxJsonStructureFromItem */])(category);});categories=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(categories,"categories",function(item){return Object.assign({},item,{parent:undefined});});return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(CATEGORY_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},derivedCategoryScheme,{categories:categories}))],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */]),function(t){return{success:t('reduxComponents.categorySchemeDetail.messages.create.success')};});};var focusCategorySchemeDetailDerivedTab=function focusCategorySchemeDetailDerivedTab(){return{type:CATEGORY_SCHEME_DETAIL_DERIVED_TAB_FOCUS};};var unfocusCategorySchemeDetailDerivedTab=function unfocusCategorySchemeDetailDerivedTab(){return{type:CATEGORY_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS};};var setCategorySchemeDetailItemsDefaultOrder=function setCategorySchemeDetailItemsDefaultOrder(categoryScheme,itemsTree,currLang,dataLangs,itemsOrderAnnotationType){itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(itemsTree,"categories",function(item){var orderAnnotation=item.autoAnnotations.find(function(_ref5){var type=_ref5.type;return type===itemsOrderAnnotationType;});dataLangs.map(function(_ref6){var code=_ref6.code;return code;}).forEach(function(lang){if(lang!==currLang){orderAnnotation.text[lang]=orderAnnotation.text[currLang];}});return item;});return submitCategorySchemeDetailUpdate(categoryScheme,itemsTree,itemsOrderAnnotationType);};var changeCategorySchemeDetailDerivedCategorySchemeViewMode=function changeCategorySchemeDetailDerivedCategorySchemeViewMode(mode){return{type:CATEGORY_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE,mode:mode};};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1260);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _rcInputNumber = _interopRequireDefault(__webpack_require__(1261));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var InputNumber =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputNumber, _React$Component);

  function InputNumber() {
    var _this;

    _classCallCheck(this, InputNumber);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputNumber).apply(this, arguments));

    _this.renderInputNumber = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          className = _a.className,
          size = _a.size,
          customizePrefixCls = _a.prefixCls,
          others = __rest(_a, ["className", "size", "prefixCls"]);

      var prefixCls = getPrefixCls('input-number', customizePrefixCls);
      var inputNumberClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className);
      var upIcon = React.createElement(_icon["default"], {
        type: "up",
        className: "".concat(prefixCls, "-handler-up-inner")
      });
      var downIcon = React.createElement(_icon["default"], {
        type: "down",
        className: "".concat(prefixCls, "-handler-down-inner")
      });
      return React.createElement(_rcInputNumber["default"], _extends({
        ref: function ref(c) {
          return _this.inputNumberRef = c;
        },
        className: inputNumberClass,
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls
      }, others));
    };

    return _this;
  }

  _createClass(InputNumber, [{
    key: "focus",
    value: function focus() {
      this.inputNumberRef.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.inputNumberRef.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderInputNumber);
    }
  }]);

  return InputNumber;
}(React.Component);

exports["default"] = InputNumber;
InputNumber.defaultProps = {
  step: 1
};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_getSdmxTypesTranslations__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__perf_input__ = __webpack_require__(103);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var mapPropsToFields=function mapPropsToFields(_ref){var destTriplet=_ref.destTriplet;return{id:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:destTriplet?destTriplet.id:null}),agencyID:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:destTriplet?destTriplet.agencyID:null}),version:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:destTriplet?destTriplet.version:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_TWO_THIRDS"]}};var ArtefactCloneForm=function ArtefactCloneForm(_ref3){var t=_ref3.t,form=_ref3.form,destTriplet=_ref3.destTriplet,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,agencies=_ref3.agencies,isIdDisabled=_ref3.isIdDisabled,isVersionDisabled=_ref3.isVersionDisabled,srcArtefact=_ref3.srcArtefact;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{title:t('components.artefactCloneForm.cards.source.title'),size:'small',type:'inner',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.artefactCloneForm.artefactType.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{disabled:true,value:srcArtefact?Object(__WEBPACK_IMPORTED_MODULE_18__constants_getSdmxTypesTranslations__["a" /* getSdmxTypesTranslations */])(t)[Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["_3" /* getTypeFromArtefact */])(srcArtefact)]:null}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.artefact.id.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{disabled:true,value:srcArtefact?srcArtefact.id:null})))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.artefact.agencyID.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{disabled:true,value:srcArtefact?srcArtefact.agencyID:null}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.artefact.version.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{disabled:true,value:srcArtefact?srcArtefact.version:null}))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{title:t('components.artefactCloneForm.cards.destination.title'),size:'small',type:'inner'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.artefactCloneForm.artefactType.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{disabled:true,value:srcArtefact?Object(__WEBPACK_IMPORTED_MODULE_18__constants_getSdmxTypesTranslations__["a" /* getSdmxTypesTranslations */])(t)[Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["_3" /* getTypeFromArtefact */])(srcArtefact)]:null}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.artefact.id.label'),validateStatus:destTriplet&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,destTriplet.id).help?"warning":null,help:destTriplet&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,destTriplet.id).help},formItemLayout),form.getFieldDecorator("id",{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,disabled:isIdDisabled,style:{textTransform:"uppercase"}}))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.artefact.agencyID.label')},formItemLayout),form.getFieldDecorator("agencyID")(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},title:agencies&&form.getFieldValue('agencyID')&&(Object(__WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[form.getFieldValue('agencyID')],lang,dataLanguages)||form.getFieldValue('agencyID'))},agencies?Object.keys(agencies).map(function(agencyID,index){var agencyName=Object(__WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[agencyID],lang,dataLanguages);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:index,value:agencyID,title:agencyID&&agencyName?agencyID+' - '+agencyName:agencyID},agencyID&&agencyName?agencyID+' - '+agencyName:agencyID);}):null)))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.artefact.version.label')},formItemLayout,{hasFeedback:true,validateStatus:destTriplet&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,destTriplet.version).help?"warning":null,help:destTriplet&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,destTriplet.version).help}),form.getFieldDecorator("version")(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,title:form.getFieldValue('version'),disabled:isVersionDisabled})))))));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps),__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ArtefactCloneForm));

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_SIDEBAR_COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return APP_SIDEBAR_UNCOLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APP_LANGUAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_ENDPOINT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return APP_USER_DROPDOWN_VISIBLE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return APP_USER_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return APP_USER_PERMISSIONS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return collapseAppSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return expandAppSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setAppLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setAppEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return changeAppUserDropdownVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clearAppUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return readAppUserPermissions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var APP_SIDEBAR_COLLAPSE='APP_SIDEBAR_COLLAPSE';var APP_SIDEBAR_UNCOLLAPSE='APP_SIDEBAR_UNCOLLAPSE';var APP_LANGUAGE_SET='APP_LANGUAGE_SET';var APP_ENDPOINT_SET='APP_ENDPOINT_SET';var APP_USER_DROPDOWN_VISIBLE_CHANGE='APP_USER_DROPDOWN_VISIBLE_CHANGE';var APP_USER_CLEAR='APP_USER_CLEAR';var APP_USER_PERMISSIONS_READ='APP_USER_PERMISSIONS_READ';var collapseAppSidebar=function collapseAppSidebar(){return{type:APP_SIDEBAR_COLLAPSE};};var expandAppSidebar=function expandAppSidebar(){return{type:APP_SIDEBAR_UNCOLLAPSE};};var setAppLanguage=function setAppLanguage(language){return{type:APP_LANGUAGE_SET,payload:{language:language}};};var setAppEndpoint=function setAppEndpoint(endpointId){return{type:APP_ENDPOINT_SET,endpointId:endpointId};};var changeAppUserDropdownVisible=function changeAppUserDropdownVisible(visible){return{type:APP_USER_DROPDOWN_VISIBLE_CHANGE,visible:visible};};var clearAppUser=function clearAppUser(){return{type:APP_USER_CLEAR};};var readAppUserPermissions=function readAppUserPermissions(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(APP_USER_PERMISSIONS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_74" /* getReadPermissionsUrl */])());};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tuple = void 0;

// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};

exports.tuple = tuple;

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_node_GeneralForm__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artefact_export_form__ = __webpack_require__(51);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var codelistDetailModalReducer=function codelistDetailModalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{codelistTriplet:null,isVisible:false,isEditDisabled:false,isCodelistValid:true,isAgenciesValid:true,isCodelistGeneralTabDirty:false,forceIsFinalDisabled:false,codelist:null,item:null,selectedItem:null,isItemEditMode:false,agencies:null,allAgencies:null,itemsViewMode:null,isItemsImportFormVisible:false,itemsImportForm:null,itemAnnotations:null,itemLayoutAnnotations:null,itemAnnotationId:null,isItemsParentListVisible:false,itemsTree:null,maxOrder:null,focusItemsTab:false,cutItem:null,cloneDestTriplet:null,downloadCodelistTriplets:null,downloadCodelistLang:null,downloadCodelistParams:null,itemPage:null,fetchPageParams:null,itemCount:null,parentPage:null,autoSave:true,isFileSystemTreeVisible:false,fileSystemSelectedItem:null,unsavedChange:false,rebuildDb:false,codelistExportSourceTriplet:null,codelistExportDestination:null,codelistExportReport:null,currentTab:null,importCheckbox:{preserveHierarchy:true,importParents:true,importChildren:false,importDescendants:false},derivedCodelist:null,dCSourceFetchPageParams:null,dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:null,dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,isCreateVisible:false,isRestoreDbDisabled:true,restoreDbWithRefresh:false,isDerivedTabFocused:false,derivedCodelistViewMode:null,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[],dcSourceItemTreeTimeStamp:null,dcTargetItemTreeTimeStamp:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CODELIST_DETAIL_CREATE */]:return Object.assign({},state,{codelist:{id:null,agencyID:null,version:null,isFinal:false,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,codes:null},isVisible:true,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],currentTab:"general",isAgenciesValid:false,isDerivedTabFocused:false,derivedCodelistViewMode:Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],dcSourceSelectedItems:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* CODELIST_DETAIL_EDIT */]:return Object.assign({},state,{isVisible:true,codelistTriplet:action.codelistTriplet,isCodelistValid:false,isAgenciesValid:false,isCodelistGeneralTabDirty:false,focusItemsTab:false,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],isEditDisabled:false,currentTab:"general",isDerivedTabFocused:false,derivedCodelistViewMode:Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],dcSourceSelectedItems:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["_28" /* CODELIST_DETAIL_SHOW */]:return Object.assign({},state,{forceIsFinalDisabled:false,isVisible:true,codelistTriplet:action.codelistTriplet,isCodelistValid:false,isAgenciesValid:false,isCodelistGeneralTabDirty:false,focusItemsTab:false,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],isEditDisabled:true,currentTab:"general",isDerivedTabFocused:false,derivedCodelistViewMode:Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* CODELIST_DETAIL_HIDE */]:return Object.assign({},state,{isVisible:false,codelistTriplet:null,forceIsFinalDisabled:false,codelist:null,item:null,selectedItem:null,itemsViewMode:null,itemsTree:null,maxOrder:null,focusItemsTab:false,cutItem:null,itemPage:null,fetchPageParams:null,autoSave:true,unsavedChange:false,agencies:null,allAgencies:null,currentTab:null,importCheckbox:{preserveHierarchy:true,importParents:true,importChildren:false,importDescendants:false},derivedCodelist:null,dCSourceFetchPageParams:null,dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:null,dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,isDerivedTabFocused:false,derivedCodelistViewMode:null,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CODELIST_DETAIL_CHANGE */]:{var codelist=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.codelist);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{codelist:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(codelist,action.fields,customizer),isCodelistGeneralTabDirty:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_22" /* CODELIST_DETAIL_ITEMS_VIEW_MODE_CHANGE */]:return Object.assign({},state,{itemsViewMode:action.viewMode,selectedItem:null,itemPage:null,fetchPageParams:null,cutItem:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_6" /* CODELIST_DETAIL_ITEMS_ITEM_CREATE */]:{return Object.assign({},state,{item:{id:null,parent:action.parentId,order:action.order?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(action.order,function(val){return String(Number(val)+1);}):null,name:null,annotations:null,autoAnnotations:null,description:null,codes:[]},isItemEditMode:false});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_20" /* CODELIST_DETAIL_ITEMS_ITEM_SHOW */]:{var item=state.itemPage?state.itemPage.find(function(item){return item.id===action.item.id;}):Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"codes",function(node){return node.id===action.item.id;});return Object.assign({},state,{item:item,isItemEditMode:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_5" /* CODELIST_DETAIL_ITEMS_ITEM_CHANGE */]:{var _item=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.item);var _customizer=function _customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{item:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(_item,action.fields,_customizer)});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_10" /* CODELIST_DETAIL_ITEMS_ITEM_HIDE */]:return Object.assign({},state,{item:null,isItemEditMode:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["_19" /* CODELIST_DETAIL_ITEMS_ITEM_SELECT */]:{var selectedItem=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"codes",function(node){return node.id===action.id;});return Object.assign({},state,{selectedItem:action.id?selectedItem:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_2" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_SHOW */]:return Object.assign({},state,{isItemsImportFormVisible:true,itemsImportForm:{file:null,language:null,separator:";",delimiter:null,hasHeader:true,hasDescriptionCol:true,hasParentCol:true,hasOrderCol:true,hasLayoutAnnotationFullNameCol:false,hasLayoutAnnotationIsDefaultCol:false,csvRows:null,filePath:null,allCsvRows:null,isAllCsvRowsVisible:false}});case __WEBPACK_IMPORTED_MODULE_1__actions__["_1" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_HIDE */]:return Object.assign({},state,{isItemsImportFormVisible:false,itemsImportForm:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["W" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{isAllCsvRowsVisible:true})});case __WEBPACK_IMPORTED_MODULE_1__actions__["U" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{isAllCsvRowsVisible:false})});case __WEBPACK_IMPORTED_MODULE_1__actions__["X" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_CHANGE */]:return Object.assign({},state,{itemsImportForm:Object.assign({},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(state.itemsImportForm,action.fields),{csvRows:action.fields.language?state.itemsImportForm.csvRows:null,hash:action.fields.language?state.itemsImportForm.hash:null,filePath:action.fields.language?state.itemsImportForm.filePath:null,allCsvRows:action.fields.language?state.itemsImportForm.allCsvRows:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["_4" /* CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW */]:return Object.assign({},state,{itemAnnotations:action.annotations,itemAnnotationId:action.itemId});case __WEBPACK_IMPORTED_MODULE_1__actions__["_3" /* CODELIST_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE */]:return Object.assign({},state,{itemAnnotations:null,itemAnnotationId:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_12" /* CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW */]:return Object.assign({},state,{itemLayoutAnnotations:action.annotations,itemAnnotationId:action.itemId});case __WEBPACK_IMPORTED_MODULE_1__actions__["_11" /* CODELIST_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE */]:return Object.assign({},state,{itemLayoutAnnotations:null,itemAnnotationId:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_16" /* CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW */]:return Object.assign({},state,{isItemsParentListVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["_13" /* CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE */]:return Object.assign({},state,{isItemsParentListVisible:false,parentPage:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_15" /* CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_SET */]:return Object.assign({},state,{item:Object.assign({},state.item,{parent:action.item.id}),isItemsParentListVisible:false,parentPage:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_17" /* CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET */]:return Object.assign({},state,{item:Object.assign({},state.item,{parent:null}),parentPage:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_26" /* CODELIST_DETAIL_LANGUAGE_CHANGE */]:{return Object.assign({},state,{fetchPageParams:Object.assign({},state.fetchPageParams,{pageNum:1,lang:action.lang}),dCSourceFetchPageParams:Object.assign({},state.dCSourceFetchPageParams,{pageNum:1,lang:action.lang}),dCTargetFetchPageParams:Object.assign({},state.dCTargetFetchPageParams,{pageNum:1,lang:action.lang}),itemPage:null,itemsTree:null,unsavedChange:false});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_7" /* CODELIST_DETAIL_ITEMS_ITEM_CUT */]:var parentNode=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"codes",function(node){return node.id===action.item.parent;});parentNode?parentNode.codes=parentNode.codes.filter(function(child){return child.id!==action.item.id;}):state.itemsTree=state.itemsTree.filter(function(child){return child.id!==action.item.id;});return Object.assign({},state,{cutItem:action.item,itemsTree:state.itemsTree.splice(0)});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* CODELIST_DETAIL_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadCodelistTriplets:action.artefactTriplets,downloadCodelistLang:action.lang,downloadCodelistParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* CODELIST_DETAIL_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadCodelistTriplets:null,downloadCodelistLang:null,downloadCodelistParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* CODELIST_DETAIL_DOWNLOAD_CHANGE */]:var downloadCodelistParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadCodelistParams);return Object.assign({},state,{downloadCodelistParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadCodelistParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CODELIST_DETAIL_CLONE_SHOW */]:var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),codelistTriplet:state.codelistTriplet?state.codelistTriplet:action.srcTriplet,isCodelistValid:!!state.codelist,isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CODELIST_DETAIL_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,codelist:state.isVisible?state.codelist:null,codelistTriplet:state.isVisible?state.codelistTriplet:null,itemCount:state.isVisible?state.itemCount:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_23" /* CODELIST_DETAIL_ITEM_PAGE_PARAMS_UPDATE */]:return Object.assign({},state,{fetchPageParams:Object.assign({},action.params,{timeStamp:new Date().getTime()})});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CODELIST_DETAIL_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* CODELIST_DETAIL_ITEMS_AUTOSAVE_CHANGE */]:return Object.assign({},state,{autoSave:!state.autoSave});case __WEBPACK_IMPORTED_MODULE_1__actions__["T" /* CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_SHOW */]:return Object.assign({},state,{isFileSystemTreeVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["R" /* CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_HIDE */]:return Object.assign({},state,{isFileSystemTreeVisible:false,fileSystemSelectedItem:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["S" /* CODELIST_DETAIL_ITEMS_FILE_SYSTEM_TREE_ITEM_SELECT */]:return Object.assign({},state,{fileSystemSelectedItem:Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"codes",function(item){return item.id===action.selectedItem;})});case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* CODELIST_DETAIL_EXPORT_SHOW */]:return Object.assign({},state,{codelistExportSourceTriplet:action.sourceTriplet,codelistExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,loginOption:__WEBPACK_IMPORTED_MODULE_8__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null},isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* CODELIST_DETAIL_EXPORT_HIDE */]:return Object.assign({},state,{codelistExportSourceTriplet:null,codelistExportDestination:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* CODELIST_DETAIL_EXPORT_CHANGE */]:var codelistExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.codelistExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(codelistExportDestination,action.fields);return Object.assign({},state,{codelistExportDestination:codelistExportDestination});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* CODELIST_DETAIL_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{codelistExportReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_29" /* CODELIST_DETAIL_TAB_CHANGE */]:return Object.assign({},state,{currentTab:action.newTab});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_PARAMS_UPDATE */]:return Object.assign({},state,{dCSourceFetchPageParams:Object.assign({},action.params,{timeStamp:new Date().getTime()})});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_PARAMS_UPDATE */]:return Object.assign({},state,{dCTargetFetchPageParams:Object.assign({},action.params,{timeStamp:new Date().getTime()})});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* CODELIST_DETAIL_DERIVED_CODELIST_CHECKBOX_CHANGE */]:return Object.assign({},state,{importCheckbox:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(state.importCheckbox,action.checkbox)});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* CODELIST_DETAIL_DERIVED_CODELIST_CREATE_HIDE */]:return Object.assign({},state,{isCreateVisible:false,derivedCodelist:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* CODELIST_DETAIL_DERIVED_CODELIST_CREATE_CHANGE */]:var derivedCodelist=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.derivedCodelist);return Object.assign({},state,{derivedCodelist:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(derivedCodelist,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* CODELIST_DETAIL_DERIVED_TAB_FOCUS */]:return Object.assign({},state,{isDerivedTabFocused:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* CODELIST_DETAIL_DERIVED_TAB_UNFOCUS */]:return Object.assign({},state,{isDerivedTabFocused:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_TREE_ITEM_SELECT */]:{return Object.assign({},state,{dcSourceSelectedItems:action.itemsIds});}case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* CODELIST_DETAIL_DERIVED_CODELIST_TARGET_TREE_ITEM_SELECT */]:{return Object.assign({},state,{dcTargetSelectedItems:action.itemsIds});}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["_30" /* CODELIST_DETAIL_UPDATE_SUBMIT */]:return Object.assign({},state,{isCodelistGeneralTabDirty:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["_27" /* CODELIST_DETAIL_READ */]:{var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(_ref){var type=_ref.type;return type&&type.toLowerCase()===Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */]].toLowerCase();}:undefined;var _codelist=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */],customNoneIsAutoAnnotation)(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);return Object.assign({},state,{codelist:_codelist,isCodelistValid:true,itemCount:Number(action.header["x-total-count"]),isRestoreDbDisabled:false});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_24" /* CODELIST_DETAIL_ITEM_PAGE_READ */]:{var _userPermissions=Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var _customNoneIsAutoAnnotation=_userPermissions&&_userPermissions.rules.includes("CanManageWorkingAnnotation")?function(_ref2){var type=_ref2.type;return type&&type.toLowerCase()===Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */]].toLowerCase();}:undefined;var _codelist2=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */],_customNoneIsAutoAnnotation)(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var isInvisibleItem=function isInvisibleItem(item){return item.annotations&&item.annotations.find(function(annot){return annot.id==="INVISIBLE"&&annot.title==="INVISIBLE"&&annot.type==="INVISIBLE";})!==undefined;};return Object.assign({},state,{codelist:state.codelist===null?_codelist2:state.codelist,isCodelistValid:true,itemPage:(_codelist2.codes||[]).filter(function(item){return!isInvisibleItem(item);}),itemCount:Number(action.header["x-total-count"]),rebuildDb:false});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_25" /* CODELIST_DETAIL_ITEM_TREE_READ */]:{var _userPermissions2=Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var _customNoneIsAutoAnnotation2=_userPermissions2&&_userPermissions2.rules.includes("CanManageWorkingAnnotation")?function(_ref3){var type=_ref3.type;return type&&type.toLowerCase()===Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */]].toLowerCase();}:undefined;var _codelist3=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */],_customNoneIsAutoAnnotation2)(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var itemsTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["n" /* getTreeFromArray */])(_codelist3.codes||[],"codes");return Object.assign({},state,{itemsTree:itemsTree,rebuildDb:false});}case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_TREE_READ */]:{var dcSourceItemTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["c" /* getCategoriesOrderedTree */])(action.response.map(function(node){return{parent:node.parent,id:node.code,name:{en:node.name},isSelectable:node.isSelectable,isSelected:node.isSelected};}),"codes",function(item,cat){if(!cat){return item.parent!=="";}else{return item.parent===cat.id;}});var dcSourceItemTreeMaxDepth=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["j" /* getMaxTreeDepth */])(dcSourceItemTree,"codes");return Object.assign({},state,{dcSourceItemTree:dcSourceItemTree,dcSourceItemTreeMaxDepth:dcSourceItemTreeMaxDepth});}case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_TREE_READ */]:{var dcTargetItemTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["c" /* getCategoriesOrderedTree */])(action.response.map(function(node){return{parent:node.parent,id:node.code,name:{en:node.name},isSelectable:node.isSelectable,isSelected:node.isSelected};}),"codes",function(item,cat){if(!cat){return item.parent!=="";}else{return item.parent===cat.id;}});var dcTargetItemTreeMaxDepth=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["j" /* getMaxTreeDepth */])(dcTargetItemTree,"codes");return Object.assign({},state,{dcTargetItemTree:dcTargetItemTree,dcTargetItemTreeMaxDepth:dcTargetItemTreeMaxDepth});}case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CODELIST_DETAIL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response,isAgenciesValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* CODELIST_DETAIL_CREATE_SUBMIT */]:return Object.assign({},state,{codelist:null,isVisible:true,itemsTree:null,maxOrder:null,codelistTriplet:action.codelistTriplet,isCodelistValid:false,isCodelistGeneralTabDirty:false,focusItemsTab:true,itemPage:null,fetchPageParams:null,currentTab:"items",importCheckbox:{preserveHierarchy:true,importParents:true,importChildren:false,importDescendants:false},derivedCodelist:null,dCSourceFetchPageParams:null,dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:null,dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,forceIsFinalDisabled:state.codelist.isFinal,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["_30" /* CODELIST_DETAIL_UPDATE_SUBMIT */]:return Object.assign({},state,{unsavedChange:false,importCheckbox:{preserveHierarchy:true,importParents:true,importChildren:false,importDescendants:false},derivedCodelist:null,dCSourceFetchPageParams:null,dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:null,dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,forceIsFinalDisabled:state.codelist.isFinal,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["_0" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{csvRows:action.response.importedItemCsv,hash:action.response.hashImport,allCsvRows:null,filePath:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["Z" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT */]:return Object.assign({},state,{itemsImportForm:null,isItemsImportFormVisible:false,itemsTree:null,rebuildDb:true,unsavedChange:false,derivedCodelist:null,dCSourceFetchPageParams:null,dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:null,dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,isRestoreDbDisabled:false,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[],dcSourceItemTreeTimeStamp:null,dcTargetItemTreeTimeStamp:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* CODELIST_DETAIL_DOWNLOAD_SUBMIT */]:return Object.assign({},state,{downloadCodelistTriplets:null,downloadCodelistLang:null,downloadCodelistParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CODELIST_DETAIL_CLONE_SUBMIT */]:return Object.assign({},state,{cloneDestTriplet:null,codelist:state.isVisible?state.codelist:null,codelistTriplet:state.isVisible?state.codelistTriplet:null,itemCount:state.isVisible?state.itemCount:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_21" /* CODELIST_DETAIL_ITEMS_ITEM_SUBMIT */]:return Object.assign({},state,{item:null,fetchPageParams:Object.assign({},state.fetchPageParams,{timeStamp:new Date().getTime()}),itemsTree:null,unsavedChange:action.unsavedChange,dCSourceFetchPageParams:Object.assign({},state.dCSourceFetchPageParams,{pageNum:1,timeStamp:new Date().getTime()}),dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:Object.assign({},state.dCTargetFetchPageParams,{pageNum:1,timeStamp:new Date().getTime()}),dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,isRestoreDbDisabled:false,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[],dcSourceItemTreeTimeStamp:new Date().getTime(),dcTargetItemTreeTimeStamp:new Date().getTime()});case __WEBPACK_IMPORTED_MODULE_1__actions__["_8" /* CODELIST_DETAIL_ITEMS_ITEM_DELETE */]:return Object.assign({},state,{fetchPageParams:Object.assign({},state.fetchPageParams,{timeStamp:new Date().getTime()}),itemsTree:null,unsavedChange:action.unsavedChange,dCSourceFetchPageParams:Object.assign({},state.dCSourceFetchPageParams,{pageNum:1,timeStamp:new Date().getTime()}),dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:Object.assign({},state.dCTargetFetchPageParams,{pageNum:1,timeStamp:new Date().getTime()}),dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,isRestoreDbDisabled:false,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[],dcSourceItemTreeTimeStamp:new Date().getTime(),dcTargetItemTreeTimeStamp:new Date().getTime()});case __WEBPACK_IMPORTED_MODULE_1__actions__["_14" /* CODELIST_DETAIL_ITEMS_ITEM_PARENT_LIST_PAGE_READ */]:{var _userPermissions3=Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var _customNoneIsAutoAnnotation3=_userPermissions3&&_userPermissions3.rules.includes("CanManageWorkingAnnotation")?function(_ref4){var type=_ref4.type;return type&&type.toLowerCase()===Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */]].toLowerCase();}:undefined;var _codelist4=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */],_customNoneIsAutoAnnotation3)(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var _isInvisibleItem=function _isInvisibleItem(item){return item.annotations&&item.annotations.find(function(annot){return annot.id==="INVISIBLE"&&annot.title==="INVISIBLE"&&annot.type==="INVISIBLE";})!==undefined;};return Object.assign({},state,{parentPage:(_codelist4.codes||[]).filter(function(item){return!_isInvisibleItem(item);}),itemCount:Number(action.header["x-total-count"])});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_9" /* CODELIST_DETAIL_ITEMS_ITEM_DROP */]:return Object.assign({},state,{itemsTree:null,cutItem:null,unsavedChange:action.unsavedChange,dCSourceFetchPageParams:Object.assign({},state.dCSourceFetchPageParams,{pageNum:1,timeStamp:new Date().getTime()}),dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:Object.assign({},state.dCTargetFetchPageParams,{pageNum:1,timeStamp:new Date().getTime()}),dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,isRestoreDbDisabled:false,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[],dcSourceItemTreeTimeStamp:new Date().getTime(),dcTargetItemTreeTimeStamp:new Date().getTime()});case __WEBPACK_IMPORTED_MODULE_1__actions__["_18" /* CODELIST_DETAIL_ITEMS_ITEM_PASTE */]:return Object.assign({},state,{itemsTree:null,cutItem:null,unsavedChange:action.unsavedChange,dCSourceFetchPageParams:Object.assign({},state.dCSourceFetchPageParams,{pageNum:1,timeStamp:new Date().getTime()}),dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetFetchPageParams:Object.assign({},state.dCTargetFetchPageParams,{pageNum:1,timeStamp:new Date().getTime()}),dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,isRestoreDbDisabled:false,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[],dcSourceItemTreeTimeStamp:new Date().getTime(),dcTargetItemTreeTimeStamp:new Date().getTime()});case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* CODELIST_DETAIL_EXPORT_SUBMIT */]:return Object.assign({},state,{codelistExportSourceTriplet:null,codelistExportDestination:null,codelistExportReport:action.response.itemsMessage,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{filePath:action.response})});case __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* CODELIST_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{allCsvRows:action.response})});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_PAGE_READ */]:{return Object.assign({},state,{dCSourceItemPage:action.response,dCSourceItemCount:Number(action.header["x-total-count"]),dCSourceSelectedItemCount:action.header["x-selected-count"]?Number(action.header["x-selected-count"]):0});}case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_PAGE_READ */]:{return Object.assign({},state,{dCTargetItemPage:action.response,dCTargetItemCount:Number(action.header["x-total-count"]),dCTargetSelectedItemCount:action.header["x-selected-count"]?Number(action.header["x-selected-count"]):0});}case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* CODELIST_DETAIL_DERIVED_CODELIST_SOURCE_ITEM_SELECT */]:{var dcSourceSelectedItems=action.isSelected?[].concat(_toConsumableArray(state.dcSourceSelectedItems),[action.itemId]):state.dcSourceSelectedItems.filter(function(id){return id!==action.itemId;});return Object.assign({},state,{dcSourceSelectedItems:dcSourceSelectedItems,dCSourceFetchPageParams:Object.assign({},state.dCSourceFetchPageParams,{timeStamp:new Date().getTime()})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* CODELIST_DETAIL_DERIVED_CODELIST_TARGET_ITEM_SELECT */]:{var dcTargetSelectedItems=action.isSelected?[].concat(_toConsumableArray(state.dcSourceSelectedItems),[action.itemId]):state.dcSourceSelectedItems.filter(function(id){return id!==action.itemId;});return Object.assign({},state,{dcTargetSelectedItems:dcTargetSelectedItems,dCTargetFetchPageParams:Object.assign({},state.dCTargetFetchPageParams,{timeStamp:new Date().getTime()})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* CODELIST_DETAIL_DERIVED_CODELIST_ALL_ITEMS_SELECT */]:{return Object.assign({},state,{dCSourceFetchPageParams:!action.isTarget?Object.assign({},state.dCSourceFetchPageParams,{timeStamp:new Date().getTime()}):state.dCSourceFetchPageParams,dCTargetFetchPageParams:action.isTarget?Object.assign({},state.dCTargetFetchPageParams,{timeStamp:new Date().getTime()}):state.dCTargetFetchPageParams});}case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* CODELIST_DETAIL_DERIVED_CODELIST_ITEMS_STORE */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* CODELIST_DETAIL_DERIVED_CODELIST_SELECTED_ITEMS_STORE */]:{return Object.assign({},state,{dCSourceFetchPageParams:Object.assign({},state.dCSourceFetchPageParams,{timeStamp:new Date().getTime()}),dCTargetFetchPageParams:Object.assign({},state.dCTargetFetchPageParams,{timeStamp:new Date().getTime()}),dcSourceItemTreeTimeStamp:new Date().getTime(),dcTargetItemTreeTimeStamp:new Date().getTime(),dcSourceSelectedItems:[],dcTargetSelectedItems:[]});}case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SHOW */]:{return Object.assign({},state,{isCreateVisible:true,derivedCodelist:action.response?{id:null,agencyID:null,version:null,name:null}:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SUBMIT */]:{return Object.assign({},state,{derivedCodelist:null,dCSourceItemPage:null,dCSourceItemCount:null,dCSourceSelectedItemCount:null,dCTargetItemPage:null,dCTargetItemCount:null,dCTargetSelectedItemCount:null,isCreateVisible:false,isRestoreDbDisabled:false,restoreDbWithRefresh:true,dcSourceItemTree:null,dcSourceItemTreeMaxDepth:null,dcSourceSelectedItems:[],dcTargetItemTree:null,dcTargetItemTreeMaxDepth:null,dcTargetSelectedItems:[]});}case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* CODELIST_DETAIL_DERIVED_CODELIST_DB_RESTORE */]:{return Object.assign({},state,{isRestoreDbDisabled:true,restoreDbWithRefresh:false,dcSourceSelectedItems:[],dcTargetSelectedItems:[],dCTargetFetchPageParams:Object.assign({},state.dCTargetFetchPageParams,{timeStamp:new Date().getTime()}),dCSourceFetchPageParams:Object.assign({},state.dCSourceFetchPageParams,{timeStamp:new Date().getTime()}),dcSourceItemTreeTimeStamp:new Date().getTime(),dcTargetItemTreeTimeStamp:new Date().getTime()});}case __WEBPACK_IMPORTED_MODULE_1__actions__["Q" /* CODELIST_DETAIL_ITEMS_DEFAULT_ORDER_SET */]:return Object.assign({},state,{unsavedChange:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* CODELIST_DETAIL_DERIVED_CODELIST_VIEW_MODE_CHANGE */]:return Object.assign({},state,{derivedCodelistViewMode:action.mode,isRestoreDbDisabled:true,restoreDbWithRefresh:false,dcSourceSelectedItems:[],dcTargetSelectedItems:[],dCTargetFetchPageParams:action.fetchTarget||state.restoreDbWithRefresh?Object.assign({},state.dCTargetFetchPageParams,{timeStamp:new Date().getTime()}):state.dCTargetFetchPageParams,dCSourceFetchPageParams:action.fetchTarget||state.restoreDbWithRefresh?Object.assign({},state.dCSourceFetchPageParams,{timeStamp:new Date().getTime()}):state.dCSourceFetchPageParams,dcSourceItemTreeTimeStamp:new Date().getTime(),dcTargetItemTreeTimeStamp:new Date().getTime(),dCTargetItemCount:0,dcTargetItemTreeMaxDepth:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["_27" /* CODELIST_DETAIL_READ */]:return Object.assign({},state,{isVisible:false,isCodelistValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["_9" /* CODELIST_DETAIL_ITEMS_ITEM_DROP */]:return Object.assign({},state,{itemsTree:null,cutItem:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_18" /* CODELIST_DETAIL_ITEMS_ITEM_PASTE */]:return Object.assign({},state,{itemsTree:null,cutItem:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (codelistDetailModalReducer);

/***/ }),
/* 113 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_css__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__middlewares_scrollTo_actions__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_uuid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.jQuery;var mapDispatchToProps=function mapDispatchToProps(dispatch){return{scrollToLastInput:function scrollToLastInput(lastListItem){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__middlewares_scrollTo_actions__["b" /* scrollTo */])(lastListItem));}};};var FormList=function(_React$Component){_inherits(FormList,_React$Component);function FormList(props){_classCallCheck(this,FormList);var _this=_possibleConstructorReturn(this,(FormList.__proto__||Object.getPrototypeOf(FormList)).call(this,props));_this.state={expanded:true,className:__WEBPACK_IMPORTED_MODULE_23_uuid___default()()};return _this;}_createClass(FormList,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.values&&this.props.values&&prevProps.values.length<this.props.values.length){var listItems=$('.'+this.state.className+' .form-list__list-item');window.setTimeout(function(){return _this2.props.scrollToLastInput(listItems[listItems.length-1]);},250);}}},{key:'render',value:function render(){var _this3=this;var _props=this.props,_props$componentProps=_props.componentProps,componentProps=_props$componentProps===undefined?{}:_props$componentProps,_props$disabled=_props.disabled,disabled=_props$disabled===undefined?false:_props$disabled,_props$isAddItemDisab=_props.isAddItemDisabled,isAddItemDisabled=_props$isAddItemDisab===undefined?false:_props$isAddItemDisab;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div',{className:this.state.className},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,this.props.values&&this.props.values.length>0?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default.a,{bordered:false,defaultActiveKey:["1"],onChange:function onChange(key){return key.includes("1")?_this3.setState({expanded:true}):_this3.setState({expanded:false});},activeKey:this.state.expanded?'1':''},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default.a.Panel,{header:this.state.expanded?this.props.t("components.formList.collapse.collapse.label"):this.props.t("components.formList.collapse.expand.label",{count:this.props.values.length}),className:"form-list__collapse-panel__header__text",key:'1',style:{border:0}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{bodyStyle:{padding:0}},this.props.values&&this.props.values.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div',{style:{padding:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["PADDING_MD"]},className:'form-list__list-item'},function(){var item=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(_this3.props.Component,Object.assign({},componentProps,{value:value,disabled:disabled,onChange:function onChange(fields){var newValues=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(_this3.props.values);var customizer=function customizer(_,src){if(Array.isArray(src))return src;else{return undefined;}};newValues[index]=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.mergeWith(newValues[index],fields,customizer);_this3.props.onChange(newValues);}}));var removeButton=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{icon:'delete',title:_this3.props.compact?_this3.props.removeItemLabel?_this3.props.removeItemLabel:_this3.props.t("components.formList.buttons.remove.title"):null,onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:_this3.props.t("components.formList.removeAlert.title"),onOk:function onOk(){var newValues=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(_this3.props.values);newValues.splice(index,1);_this3.props.onChange(newValues);},cancelText:_this3.props.t('commons.buttons.cancel.title')});},disabled:disabled||(_this3.props.minItems?_this3.props.values.length<=_this3.props.minItems:false)},!_this3.props.compact?_this3.props.removeItemLabel?_this3.props.removeItemLabel:_this3.props.t("components.formList.buttons.remove.title"):null);return _this3.props.compact?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,item),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,removeButton)):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,item,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_divider___default.a,{style:{marginTop:16,marginBottom:16}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,removeButton)));}()),index<_this3.props.values.length-1&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_divider___default.a,{style:{marginTop:0,marginBottom:0}}));})))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__custom_empty__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',justify:'start',style:{marginLeft:16,marginBottom:8,marginTop:this.props.values&&this.props.values.length>0?0:8}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{icon:'plus',disabled:disabled||isAddItemDisabled,onClick:function onClick(){var newValues=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(_this3.props.values);newValues.push(__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(_this3.props.newItem));_this3.setState({expanded:true});_this3.props.onChange(newValues);}},this.props.addItemLabel?this.props.addItemLabel:this.props.t("components.formList.buttons.add.title"))))));}}]);return FormList;}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(null,mapDispatchToProps))(FormList));

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Items__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__DerivedCodelist__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,isVisible:instanceState.isVisible,forceIsFinalDisabled:instanceState.forceIsFinalDisabled,codelistTriplet:instanceState.codelistTriplet,isEditDisabled:instanceState.isEditDisabled,isCodelistValid:instanceState.isCodelistValid,isAgenciesValid:instanceState.isAgenciesValid,isCodelistGeneralTabDirty:instanceState.isCodelistGeneralTabDirty,codelist:instanceState.codelist,agencies:instanceState.agencies,allAgencies:instanceState.allAgencies,focusItemsTab:instanceState.focusItemsTab,cloneDestTriplet:instanceState.cloneDestTriplet,downloadCodelistTriplets:instanceState.downloadCodelistTriplets,downloadCodelistLang:instanceState.downloadCodelistLang,downloadCodelistParams:instanceState.downloadCodelistParams,codelistExportSourceTriplet:instanceState.codelistExportSourceTriplet,codelistExportDestination:instanceState.codelistExportDestination,codelistExportReport:instanceState.codelistExportReport,unsavedChange:instanceState.unsavedChange,autoSave:instanceState.autoSave,currentTab:instanceState.currentTab,itemsTree:instanceState.itemsTree,isRestoreDbDisabled:instanceState.isRestoreDbDisabled,isDerivedTabFocused:instanceState.isDerivedTabFocused,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onDetailHide:function onDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_52" /* hideCodelistDetail */])(),instancePrefix));},onDetailChange:function onDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_31" /* changeCodelistDetail */])(fields),instancePrefix));},onDetailCreate:function onDetailCreate(codelist,codelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_101" /* submitCodelistDetailCreate */])(codelist,codelistTriplet),instancePrefix));},onDetailUpdate:function onDetailUpdate(codelist,lang,closeDetail){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_106" /* submitCodelistDetailUpdate */])(codelist,lang,closeDetail),instancePrefix));},fetchCodelist:function fetchCodelist(_ref3){var codelistTriplet=_ref3.codelistTriplet,lang=_ref3.lang,itemsOrderAnnotationType=_ref3.itemsOrderAnnotationType;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_67" /* readCodelistDetail */])(codelistTriplet,lang,itemsOrderAnnotationType),instancePrefix));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_68" /* readCodelistDetailAgencies */])(allowedAgencies),instancePrefix));},onLanguageChange:function onLanguageChange(lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_33" /* changeCodelistDetailCodelistLanguage */])(lang,itemsOrderAnnotationType),instancePrefix));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_90" /* showCodelistDetailDownload */])(artefactTriplets,lang),instancePrefix));},onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_55" /* hideCodelistDetailDownload */])(),instancePrefix));},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_37" /* changeCodelistDetailDownload */])(fields),instancePrefix));},onDownloadSubmit:function onDownloadSubmit(artefactTriplets,downloadCodelistParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_103" /* submitCodelistDetailDownload */])(artefactTriplets,downloadCodelistParams,lang),instancePrefix));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_88" /* showCodelistDetailClone */])(artefactTriplet),instancePrefix));},onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_53" /* hideCodelistDetailClone */])(),instancePrefix));},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_32" /* changeCodelistDetailClone */])(fields),instancePrefix));},onCloneSubmit:function onCloneSubmit(srcTriplet,destTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_100" /* submitCodelistDetailClone */])(srcTriplet,destTriplet),instancePrefix));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_91" /* showCodelistDetailExport */])(sourceTriplet),instancePrefix));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_56" /* hideCodelistDetailExport */])(),instancePrefix));},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_38" /* changeCodelistDetailExport */])(fields),instancePrefix));},onExportSubmit:function onExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_104" /* submitCodelistDetailExport */])(sourceTriplet,destination),instancePrefix));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_57" /* hideCodelistDetailExportReport */])(),instancePrefix));},onAutoSaveChange:function onAutoSaveChange(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_39" /* changeCodelistDetailItemsAutoSave */])(),instancePrefix));},onTabChange:function onTabChange(newTab){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_43" /* changeCodelistDetailTab */])(newTab),instancePrefix));},onDbRestore:function onDbRestore(codelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_77" /* restoreCodelistDetailDerivedCodelistDb */])(codelistTriplet),instancePrefix));},onDerivedTabFocus:function onDerivedTabFocus(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_51" /* focusCodelistDetailDerivedTab */])(),instancePrefix));},onDerivedTabUnfocus:function onDerivedTabUnfocus(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_107" /* unfocusCodelistDetailDerivedTab */])(),instancePrefix));}};};var ReduxCodelistDetailModal=function ReduxCodelistDetailModal(_ref4){var t=_ref4.t,nodes=_ref4.nodes,nodeId=_ref4.nodeId,permissions=_ref4.permissions,appLanguage=_ref4.appLanguage,dataLanguages=_ref4.dataLanguages,instanceState=_ref4.instanceState,instancePrefix=_ref4.instancePrefix,isVisible=_ref4.isVisible,codelistTriplet=_ref4.codelistTriplet,isEditDisabled=_ref4.isEditDisabled,isCodelistValid=_ref4.isCodelistValid,isAgenciesValid=_ref4.isAgenciesValid,isCodelistGeneralTabDirty=_ref4.isCodelistGeneralTabDirty,codelist=_ref4.codelist,agencies=_ref4.agencies,allAgencies=_ref4.allAgencies,cloneDestTriplet=_ref4.cloneDestTriplet,onDetailHide=_ref4.onDetailHide,onDetailChange=_ref4.onDetailChange,onDetailCreate=_ref4.onDetailCreate,onDetailUpdate=_ref4.onDetailUpdate,fetchCodelist=_ref4.fetchCodelist,fetchAgencies=_ref4.fetchAgencies,onLanguageChange=_ref4.onLanguageChange,focusItemsTab=_ref4.focusItemsTab,downloadCodelistTriplets=_ref4.downloadCodelistTriplets,downloadCodelistLang=_ref4.downloadCodelistLang,downloadCodelistParams=_ref4.downloadCodelistParams,onDownloadShow=_ref4.onDownloadShow,onDownloadChange=_ref4.onDownloadChange,onDownloadHide=_ref4.onDownloadHide,onDownloadSubmit=_ref4.onDownloadSubmit,onCloneShow=_ref4.onCloneShow,onCloneHide=_ref4.onCloneHide,onCloneChange=_ref4.onCloneChange,onCloneSubmit=_ref4.onCloneSubmit,unsavedChange=_ref4.unsavedChange,codelistExportSourceTriplet=_ref4.codelistExportSourceTriplet,codelistExportDestination=_ref4.codelistExportDestination,codelistExportReport=_ref4.codelistExportReport,onExportShow=_ref4.onExportShow,onExportHide=_ref4.onExportHide,onExportChange=_ref4.onExportChange,onExportSubmit=_ref4.onExportSubmit,onExportReportHide=_ref4.onExportReportHide,autoSave=_ref4.autoSave,onAutoSaveChange=_ref4.onAutoSaveChange,currentTab=_ref4.currentTab,onTabChange=_ref4.onTabChange,itemsTree=_ref4.itemsTree,isRestoreDbDisabled=_ref4.isRestoreDbDisabled,onDbRestore=_ref4.onDbRestore,onDerivedTabFocus=_ref4.onDerivedTabFocus,onDerivedTabUnfocus=_ref4.onDerivedTabUnfocus,isDerivedTabFocused=_ref4.isDerivedTabFocused,user=_ref4.user,forceIsFinalDisabled=_ref4.forceIsFinalDisabled;var itemsOrderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.codelistsOrder;var userHasPermissionsToEdit=permissions&&codelistTriplet&&permissions.agencies.filter(function(agency){return agency===codelistTriplet.agencyID;}).length>0;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;var ignoreUsername=(user&&user.providerId)!==null;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__hocs_call__["a" /* default */],{cb:fetchCodelist,cbParam:{codelistTriplet:codelistTriplet,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType},disabled:isCodelistValid||currentTab&&currentTab!=="general"||!codelistTriplet},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:isAgenciesValid},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_XL"],title:codelistTriplet!==null?userHasPermissionsToEdit&&!isEditDisabled?t('reduxComponents.codelistDetail.title.editMode.title',{triplet:codelistTriplet}):t('reduxComponents.codelistDetail.title.viewMode.title',{triplet:codelistTriplet}):t('reduxComponents.codelistDetail.title.createMode.title'),onCancel:function onCancel(){if(unsavedChange){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('commons.artefact.modals.unsavedChange.discard.title'),onOk:function onOk(){codelistTriplet&&onDbRestore(codelistTriplet);onDetailHide();},cancelText:t('commons.buttons.cancel.title')});}else{codelistTriplet&&onDbRestore(codelistTriplet);onDetailHide();}},footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',justify:'end',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"]},currentTab==="items"&&userHasPermissionsToEdit&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',justify:'end',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,t("components.itemList.label.autoSave")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default.a,{checked:autoSave,onChange:onAutoSaveChange})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',justify:'end',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){if(unsavedChange){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('commons.artefact.modals.unsavedChange.discard.title'),onOk:function onOk(){codelistTriplet&&onDbRestore(codelistTriplet);onDetailHide();},cancelText:t('commons.buttons.cancel.title')});}else{codelistTriplet&&onDbRestore(codelistTriplet);onDetailHide();}}},t('commons.buttons.close.title'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,(codelistTriplet===null||userHasPermissionsToEdit)&&!isEditDisabled&&!isDerivedTabFocused&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(codelist)){if(codelistTriplet!==null){onDetailUpdate(codelist,lang,true);codelistTriplet&&onDbRestore(codelistTriplet);}else{onDetailCreate(codelist,{id:codelist.id,agencyID:codelist.agencyID,version:codelist.version});}}else{__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t("commons.buttons.save.title"))))));}),withDataLanguageSelector:true,onDataLanguageSelectorChange:function onDataLanguageSelectorChange(lang,changeLang){if(unsavedChange){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('commons.artefact.modals.unsavedChange.discard.title'),onOk:function onOk(){onLanguageChange(lang,itemsOrderAnnotationType);changeLang();},cancelText:t('commons.buttons.cancel.title')});}else{onLanguageChange(lang,itemsOrderAnnotationType);changeLang();}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return codelistTriplet?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,permissions&&!userHasPermissionsToEdit&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"],justify:"end"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,onDownloadShow&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){if(unsavedChange){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('commons.artefact.modals.unsavedChange.different.title'),onOk:function onOk(){onDownloadShow([codelistTriplet],lang);},cancelText:t('commons.buttons.cancel.title')});}else{onDownloadShow([codelistTriplet],lang);}}})),permissions&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){if(unsavedChange){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('commons.artefact.modals.unsavedChange.different.title'),onOk:function onOk(){onCloneShow(codelistTriplet);},cancelText:t('commons.buttons.cancel.title')});}else{onCloneShow(codelistTriplet);}}})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){if(unsavedChange){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('commons.artefact.modals.unsavedChange.different.title'),onOk:function onOk(){onExportShow(codelistTriplet);},cancelText:t('commons.buttons.cancel.title')});}else{onExportShow(codelistTriplet);}}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{activeKey:currentTab,onTabClick:function onTabClick(key){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(codelist)){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{if(key==="derived"){onDerivedTabFocus();}else if(isDerivedTabFocused){onDerivedTabUnfocus();}if(key==="categorisations"){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.error({title:t('errors.notImplemented')});}if(isCodelistGeneralTabDirty){onDetailUpdate(codelist,lang,false);}onTabChange(key);}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'general',tab:t('commons.artefact.tabs.general.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_artefact_form__["d" /* default */],{artefact:codelist,mode:userHasPermissionsToEdit&&!isEditDisabled?__WEBPACK_IMPORTED_MODULE_21__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_21__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],agencies:agencies,onChange:onDetailChange,artefactOrderType:itemsOrderAnnotationType,isFinalDisabled:forceIsFinalDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'items',tab:t('commons.artefact.tabs.items.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Items__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix,isEditDisabled:isEditDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'categorisations',tab:t('commons.artefact.tabs.categorisations.title')}),permissions&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'derived',tab:t('reduxComponents.codelistDetail.tabs.derived.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__DerivedCodelist__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix,itemTree:itemsTree,agencies:agencies})))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_artefact_form__["d" /* default */],{artefact:codelist,mode:__WEBPACK_IMPORTED_MODULE_21__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */],agencies:agencies,onChange:onDetailChange,artefactOrderType:itemsOrderAnnotationType});})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:downloadCodelistTriplets!==null&&downloadCodelistTriplets!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onDownloadSubmit(downloadCodelistTriplets,downloadCodelistParams,downloadCodelistLang);},type:'primary',disabled:downloadCodelistParams&&downloadCodelistParams.format===null||downloadCodelistParams&&downloadCodelistParams.format===__WEBPACK_IMPORTED_MODULE_31__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadCodelistParams.csvSeparator===null||downloadCodelistParams.csvSeparator.length!==1||downloadCodelistParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_SM"],title:downloadCodelistTriplets&&downloadCodelistTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadCodelistTriplets?Object(__WEBPACK_IMPORTED_MODULE_33__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadCodelistTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadCodelistParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_31__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadCodelistTriplets&&downloadCodelistTriplets.length>1?__WEBPACK_IMPORTED_MODULE_31__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_31__constants_download__["c" /* ARTEFACT_TYPE_CODELIST */]),langs:dataLanguages})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(codelistTriplet,cloneDestTriplet);}},type:'primary'},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:codelist,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:codelistExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["e" /* isExportDestinationValid */])(codelistExportDestination,ignoreUsername)){onExportSubmit(codelistExportSourceTriplet,codelistExportDestination);}else{__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_artefact_export_form__["b" /* default */],{type:'codelist',agencies:allAgencies,sourceTriplet:codelistExportSourceTriplet,destination:codelistExportDestination,onChange:onExportChange})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:codelistExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_artefact_export_report__["a" /* default */],{report:codelistExportReport})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__hocs_call__["a" /* default */],{cb:onDbRestore,cbParam:codelistTriplet,disabled:!codelistTriplet||isRestoreDbDisabled||isEditDisabled},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('span',null)));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ReduxCodelistDetailModal));

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIG_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONFIG_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return readConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_persistence_middleware__ = __webpack_require__(273);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CONFIG_INIT='CONFIG_INIT';var CONFIG_READ='CONFIG_READ';var initConfig=function initConfig(){return{type:CONFIG_INIT};};var readConfig=function readConfig(persistanceObj,doNotPing){var _Object$assign;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONFIG_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["l" /* getAppConfigUrl */])()),(_Object$assign={},_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_2__middlewares_persistence_middleware__["a" /* PERSISTENCE_ACTION_KEY */],persistanceObj),_defineProperty(_Object$assign,'doNotPing',doNotPing),_Object$assign));};

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NODES_CONFIG_CONFIG_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NODES_CONFIG_CONFIG_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return NODES_CONFIG_NODE_CONFIG_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NODES_CONFIG_NODE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NODES_CONFIG_NEW_NODE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return NODES_CONFIG_NODE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NODES_CONFIG_NODE_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return NODES_CONFIG_NODE_COLLAPSED_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NODES_CONFIG_NODE_CHECK_ENDPOINT_NSI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NODES_CONFIG_NODE_CHECK_ENDPOINT_MA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NODES_CONFIG_NODE_CHECK_ENDPOINT_DM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NODES_CONFIG_NODE_CHECK_ENDPOINT_MD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NODES_CONFIG_NODE_AGENCY_ASSIGNED_TO_ANY_USER_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NODES_CONFIG_MSDS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NODES_CONFIG_MSDS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NODES_CONFIG_MSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NODES_CONFIG_MSD_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NODES_CONFIG_MSD_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getNodesConfigConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return changeNodesConfigConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return submitNodesConfigNodeConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return addNodesConfigNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return removeNodesConfigNewNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return removeNodesConfigNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return sortNodesConfigNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return changeNodesConfigNodeCollapsed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return checkEndpointNSIUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return checkEndpointMAUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return checkEndpointDMUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return showNodesConfigMsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return hideNodesConfigMsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return readNodesConfigMsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return setNodesConfigMsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return unsetNodesConfigMsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return checkEndpointMDUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return checkNodesConfigNodeAgencyAssignedToAnyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return submitNodesConfigNodeConfigProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_metadata_api_actions__ = __webpack_require__(382);
var NODES_CONFIG_CONFIG_READ='NODES_CONFIG_CONFIG_READ';var NODES_CONFIG_CONFIG_CHANGE='NODES_CONFIG_CONFIG_CHANGE';var NODES_CONFIG_NODE_CONFIG_SUBMIT='NODES_CONFIG_NODE_CONFIG_SUBMIT';var NODES_CONFIG_NODE_ADD='NODES_CONFIG_NODE_ADD';var NODES_CONFIG_NEW_NODE_REMOVE='NODES_CONFIG_NEW_NODE_REMOVE';var NODES_CONFIG_NODE_REMOVE='NODES_CONFIG_NODE_REMOVE';var NODES_CONFIG_NODE_SORT='NODES_CONFIG_NODE_SORT';var NODES_CONFIG_NODE_COLLAPSED_CHANGE='NODES_CONFIG_NODE_COLLAPSED_SET';var NODES_CONFIG_NODE_CHECK_ENDPOINT_NSI='NODES_CONFIG_NODE_CHECK_ENDPOINT_NSI';var NODES_CONFIG_NODE_CHECK_ENDPOINT_MA='NODES_CONFIG_NODE_CHECK_ENDPOINT_MA';var NODES_CONFIG_NODE_CHECK_ENDPOINT_DM='NODES_CONFIG_NODE_CHECK_ENDPOINT_DM';var NODES_CONFIG_NODE_CHECK_ENDPOINT_MD='NODES_CONFIG_NODE_CHECK_ENDPOINT_MD';var NODES_CONFIG_NODE_AGENCY_ASSIGNED_TO_ANY_USER_CHECK='NODES_CONFIG_NODE_AGENCY_ASSIGNED_TO_ANY_USER_CHECK';var NODES_CONFIG_MSDS_SHOW='NODES_CONFIG_MSDS_SHOW';var NODES_CONFIG_MSDS_HIDE='NODES_CONFIG_MSDS_HIDE';var NODES_CONFIG_MSDS_READ='NODES_CONFIG_MSDS_READ';var NODES_CONFIG_MSD_SET='NODES_CONFIG_MSD_SET';var NODES_CONFIG_MSD_UNSET='NODES_CONFIG_MSD_UNSET';var getNodesConfigConfig=function getNodesConfigConfig(){return Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["l" /* getRequest */])(NODES_CONFIG_CONFIG_READ,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["G" /* getConfigUrl */])(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["b" /* CONFIG_TYPE_NODES */]));};var changeNodesConfigConfig=function changeNodesConfigConfig(config){return{type:NODES_CONFIG_CONFIG_CHANGE,config:config};};var submitNodesConfigNodeConfig=function submitNodesConfigNodeConfig(nodeConfig,username,password){return Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["m" /* postRequest */])(NODES_CONFIG_NODE_CONFIG_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_81" /* getSaveConfigNodeUrl */])(username,password?btoa(password):undefined),Object.assign({},nodeConfig,{isNewNode:undefined,isCollapsed:undefined,isNSIPingOk:undefined,isMAPingOk:undefined,isDMPingOk:undefined,Proxy:Object.assign({},nodeConfig.Proxy,{Port:nodeConfig.Proxy.Port||0}),LoginProviders:(nodeConfig.LoginProviders||[]).map(function(loginProvider){var mails=loginProvider.SuperadminMails||[];var filteredMails=mails.filter(function(mail){return(mail||"").length>0;});return Object.assign({},loginProvider,{SuperadminMails:filteredMails.length>0?filteredMails.join("|"):null});})}),function(t){return{success:t('scenes.configuration.nodesConfig.messages.nodeSubmit.success')};});};var addNodesConfigNode=function addNodesConfigNode(dataLangs){return{type:NODES_CONFIG_NODE_ADD,dataLangs:dataLangs};};var removeNodesConfigNewNode=function removeNodesConfigNewNode(nodeIndex){return{type:NODES_CONFIG_NEW_NODE_REMOVE,nodeIndex:nodeIndex};};var removeNodesConfigNode=function removeNodesConfigNode(nodeIndex,nodeId){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["j" /* deleteRequest */])(NODES_CONFIG_NODE_REMOVE,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_12" /* getDeleteConfigNodeUrl */])(nodeId),function(t){return{success:t('scenes.configuration.nodesConfig.messages.nodeDelete.success')};}),{nodeIndex:nodeIndex});};var sortNodesConfigNode=function sortNodesConfigNode(orderedNodes){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["m" /* postRequest */])(NODES_CONFIG_NODE_SORT,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_89" /* getSortNodesUrl */])(),orderedNodes.map(function(node){return node.General.ID;}),function(t){return{success:t('scenes.configuration.nodesConfig.messages.nodeSort.success')};}),{orderedNodes:orderedNodes});};var changeNodesConfigNodeCollapsed=function changeNodesConfigNodeCollapsed(nodeIndex,collapsed){return{type:NODES_CONFIG_NODE_COLLAPSED_CHANGE,nodeIndex:nodeIndex,collapsed:collapsed};};var checkEndpointNSIUrl=function checkEndpointNSIUrl(nodeIndex,config){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["m" /* postRequest */])(NODES_CONFIG_NODE_CHECK_ENDPOINT_NSI,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["t" /* getCheckEndpointNSIUrl */])(),config),{nodeIndex:nodeIndex});};var checkEndpointMAUrl=function checkEndpointMAUrl(nodeIndex,config){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["m" /* postRequest */])(NODES_CONFIG_NODE_CHECK_ENDPOINT_MA,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["s" /* getCheckEndpointMAUrl */])(),config),{nodeIndex:nodeIndex});};var checkEndpointDMUrl=function checkEndpointDMUrl(nodeIndex,config){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["m" /* postRequest */])(NODES_CONFIG_NODE_CHECK_ENDPOINT_DM,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["r" /* getCheckEndpointDMUrl */])(),config),{nodeIndex:nodeIndex});};var showNodesConfigMsds=function showNodesConfigMsds(nodeIndex){return{type:NODES_CONFIG_MSDS_SHOW,nodeIndex:nodeIndex};};var hideNodesConfigMsds=function hideNodesConfigMsds(){return{type:NODES_CONFIG_MSDS_HIDE};};var readNodesConfigMsds=function readNodesConfigMsds(){return Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["l" /* getRequest */])(NODES_CONFIG_MSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_66" /* getMsdUrl */])());};var setNodesConfigMsd=function setNodesConfigMsd(msd){return{type:NODES_CONFIG_MSD_SET,msd:msd};};var unsetNodesConfigMsd=function unsetNodesConfigMsd(nodeIndex){return{type:NODES_CONFIG_MSD_UNSET,nodeIndex:nodeIndex};};var checkEndpointMDUrl=function checkEndpointMDUrl(nodeIndex,metadataApiUrl){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_metadata_api_actions__["b" /* pingMetadataApi */])(NODES_CONFIG_NODE_CHECK_ENDPOINT_MD,metadataApiUrl),{nodeIndex:nodeIndex});};var checkNodesConfigNodeAgencyAssignedToAnyUser=function checkNodesConfigNodeAgencyAssignedToAnyUser(agencyCode,nodeCode,onSuccess){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["l" /* getRequest */])(NODES_CONFIG_NODE_AGENCY_ASSIGNED_TO_ANY_USER_CHECK,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["q" /* getCheckAgencyAssignedToAnyUserUrl */])(agencyCode,nodeCode)),{onSuccess:onSuccess});};var submitNodesConfigNodeConfigProvider=function submitNodesConfigNodeConfigProvider(nodeConfig,providerId){return Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["m" /* postRequest */])(NODES_CONFIG_NODE_CONFIG_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_80" /* getSaveConfigNodeProviderUrl */])(providerId),{NodeConfigurationClient:Object.assign({},nodeConfig,{isNewNode:undefined,isCollapsed:undefined,isNSIPingOk:undefined,isMAPingOk:undefined,isDMPingOk:undefined,Proxy:Object.assign({},nodeConfig.Proxy,{Port:nodeConfig.Proxy.Port||0}),LoginProviders:(nodeConfig.LoginProviders||[]).map(function(loginProvider){var mails=loginProvider.SuperadminMails||[];var filteredMails=mails.filter(function(mail){return(mail||"").length>0;});return Object.assign({},loginProvider,{SuperadminMails:filteredMails.length>0?filteredMails.join("|"):null});})})},function(t){return{success:t('scenes.configuration.nodesConfig.messages.nodeSubmit.success')};});};

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DSD_DETAIL_CODELIST_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX; });
/* unused harmony export DSD_PRIMARY_MEASURE_ID */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_concept_scheme_detail_modal_reducer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artefact_export_form__ = __webpack_require__(51);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var dsdDetailModalReducer=function dsdDetailModalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{dsdTriplet:null,dsd:null,isVisible:false,isAgenciesValid:true,isEditDisabled:false,codelists:null,conceptSchemes:null,agencies:null,allAgencies:null,dimension:null,group:null,attribute:null,isCreatingComponent:false,notDisplayedVal:null,defaultVal:null,codelistTripletForCodesSelector:null,itemsPageForNotDisplayedCodesSelector:null,itemsCountForNotDisplayedCodesSelector:null,tempSelectedCodesForNotDisplayedCodesSelector:null,itemsPageForDefaultCodesSelector:null,itemsCountForDefaultCodesSelector:null,tempSelectedCodesForDefaultCodesSelector:null,defaultTimeDimensionStart:null,defaultTimeDimensionEnd:null,defaultTimeDimensionLastNObservations:null,defaultTimeDimensionLastNPeriods:null,defaultTimeDimensionMode:null,isConceptSchemesForSelectorVisible:false,conceptSchemeForSelectorTriplet:null,conceptSchemeForSelector:null,isCodelistsForSelectorVisible:false,downloadDsdTriplets:null,downloadDsdLang:null,downloadDsdParams:null,cloneDestTriplet:null,isMeasureDimensionConceptSchemesForSelectorVisible:false,dsdExportSourceTriplet:null,dsdExportDestination:null,dsdExportReport:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* DSD_DETAIL_EDIT */]:return Object.assign({},state,{isVisible:true,dsdTriplet:action.dsdTriplet,isEditDisabled:false,isAgenciesValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["_18" /* DSD_DETAIL_SHOW */]:return Object.assign({},state,{isVisible:true,dsdTriplet:action.dsdTriplet,isEditDisabled:true,isAgenciesValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["_10" /* DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW */]:return Object.assign({},state,{isMeasureDimensionConceptSchemesForSelectorVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["_8" /* DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE */]:return Object.assign({},state,{isMeasureDimensionConceptSchemesForSelectorVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["_9" /* DSD_DETAIL_MEASURE_DIMENSION_CONCEPT_SCHEMES_FOR_SELECTOR_SET */]:return Object.assign({},state,{isMeasureDimensionConceptSchemesForSelectorVisible:false,dimension:Object.assign({},state.dimension,{representation:action.conceptSchemeUrn})});case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* DSD_DETAIL_CREATE */]:return Object.assign({},state,{isVisible:true,dsd:{id:null,agencyID:null,version:null,isFinal:false,remoteIsFinal:false,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,primaryMeasure:{id:DSD_PRIMARY_MEASURE_ID,concept:null,representation:null,annotations:null},dimensions:null,groups:null,attributes:null,annotations:null},isAgenciesValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["T" /* DSD_DETAIL_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadDsdTriplets:action.artefactTriplets,downloadDsdLang:action.lang,downloadDsdParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["S" /* DSD_DETAIL_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadDsdTriplets:null,downloadDsdLang:null,downloadDsdParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["R" /* DSD_DETAIL_DOWNLOAD_CHANGE */]:var downloadDsdParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadDsdParams);return Object.assign({},state,{downloadDsdParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadDsdParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* DSD_DETAIL_CLONE_SHOW */]:{var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),dsdTriplet:state.dsdTriplet?state.dsdTriplet:action.srcTriplet,isAgenciesValid:!!state.allAgencies});}case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* DSD_DETAIL_CLONE_HIDE */]:{return Object.assign({},state,{cloneDestTriplet:null,dsd:state.isVisible?state.dsd:null,dsdTriplet:state.isVisible?state.dsdTriplet:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* DSD_DETAIL_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* DSD_DETAIL_CHANGE */]:{var dsd=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.dsd);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{dsd:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(dsd,action.fields,customizer)});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_7" /* DSD_DETAIL_HIDE */]:return Object.assign({},state,{isVisible:false,dsdTriplet:null,dsd:null,agencies:null,allAgencies:null,codelists:null,conceptSchemes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* DSD_DETAIL_DIMENSION_CREATE */]:return Object.assign({},state,{isCreatingComponent:true,dimension:{type:__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["l" /* DSD_DIMENSION_TYPE_NORMAL */],id:null,order:null,concept:null,representation:null,annotations:null},notDisplayedVal:null,defaultVal:null,defaultTimeDimensionStart:null,defaultTimeDimensionEnd:null,defaultTimeDimensionLastNObservations:null,defaultTimeDimensionLastNPeriods:null,defaultTimeDimensionMode:__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* DSD_DETAIL_DIMENSION_EDIT */]:{var _annotationsConfig=Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations;var dimension=state.dsd.dimensions.find(function(_ref){var id=_ref.id;return id===action.id;});var defaultTimeDimensionStart=dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]?Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["D" /* getLayoutAnnotationDefault */])(state.dsd.annotations,_annotationsConfig)[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]]:null;var defaultTimeDimensionEnd=dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]?Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["D" /* getLayoutAnnotationDefault */])(state.dsd.annotations,_annotationsConfig)[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]]:null;var defaultTimeDimensionLastNObservations=dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]?Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["D" /* getLayoutAnnotationDefault */])(state.dsd.annotations,_annotationsConfig)[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]]:null;var defaultTimeDimensionLastNPeriods=dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]?Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["D" /* getLayoutAnnotationDefault */])(state.dsd.annotations,_annotationsConfig)[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]]:null;var defaultTimeDimensionMode=dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]&&defaultTimeDimensionLastNPeriods?__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["n" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS */]:__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */];return Object.assign({},state,{dimension:dimension,notDisplayedVal:Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(state.dsd.annotations,_annotationsConfig)[action.id]||null,defaultVal:dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]?!!defaultTimeDimensionStart||!!defaultTimeDimensionEnd||!!defaultTimeDimensionLastNObservations||!!defaultTimeDimensionLastNPeriods||null:Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["D" /* getLayoutAnnotationDefault */])(state.dsd.annotations,_annotationsConfig)[action.id]||null,defaultTimeDimensionStart:defaultTimeDimensionStart?defaultTimeDimensionStart[0]:null,defaultTimeDimensionEnd:defaultTimeDimensionEnd?defaultTimeDimensionEnd[0]:null,defaultTimeDimensionLastNObservations:defaultTimeDimensionLastNObservations?defaultTimeDimensionLastNObservations[0]:null,defaultTimeDimensionLastNPeriods:defaultTimeDimensionLastNPeriods?defaultTimeDimensionLastNPeriods[0]:null,defaultTimeDimensionMode:defaultTimeDimensionMode});}case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* DSD_DETAIL_DIMENSION_HIDE */]:return Object.assign({},state,{isCreatingComponent:false,dimension:null,notDisplayedVal:null,defaultVal:null,defaultTimeDimensionStart:null,defaultTimeDimensionEnd:null,defaultTimeDimensionLastNObservations:null,defaultTimeDimensionLastNPeriods:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* DSD_DETAIL_DIMENSION_DELETE */]:return Object.assign({},state,{dsd:Object.assign({},state.dsd,{dimensions:Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["i" /* normalizeDsdComponentsOrder */])([].concat(_toConsumableArray(state.dsd.dimensions.filter(function(_ref2){var id=_ref2.id;return id!==action.id;}))))})});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* DSD_DETAIL_ATTRIBUTE_DELETE */]:return Object.assign({},state,{dsd:Object.assign({},state.dsd,{attributes:Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["i" /* normalizeDsdComponentsOrder */])([].concat(_toConsumableArray(state.dsd.attributes.filter(function(_ref3){var id=_ref3.id;return id!==action.id;}))))})});case __WEBPACK_IMPORTED_MODULE_1__actions__["_3" /* DSD_DETAIL_GROUP_DELETE */]:return Object.assign({},state,{dsd:Object.assign({},state.dsd,{groups:[].concat(_toConsumableArray(state.dsd.groups.filter(function(_ref4){var id=_ref4.id;return id!==action.id;})))})});case __WEBPACK_IMPORTED_MODULE_1__actions__["Q" /* DSD_DETAIL_DIMENSION_SUBMIT */]:var dimensions=state.isCreatingComponent?[].concat(_toConsumableArray(state.dsd.dimensions||[]),[state.dimension]):state.dsd.dimensions.map(function(comp){return comp.id===state.dimension.id?state.dimension:comp;});var annotationsConfig=Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations;var newDsdAnnotations=state.dsd.annotations||[];var newDefaultObj=Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["D" /* getLayoutAnnotationDefault */])(newDsdAnnotations,annotationsConfig);if(state.defaultVal!==null){newDefaultObj[state.dimension.id]=state.defaultVal;}else{delete newDefaultObj[state.dimension.id];}if(state.dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]){if(state.defaultTimeDimensionStart!==null){delete newDefaultObj[state.dimension.id];newDefaultObj[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]]=[state.defaultTimeDimensionStart];}else{delete newDefaultObj[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]];}if(state.defaultTimeDimensionEnd!==null){delete newDefaultObj[state.dimension.id];newDefaultObj[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]]=[state.defaultTimeDimensionEnd];}else{delete newDefaultObj[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]];}if(state.defaultTimeDimensionLastNObservations!==null){delete newDefaultObj[state.dimension.id];newDefaultObj[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]]=[state.defaultTimeDimensionLastNObservations];}else{delete newDefaultObj[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]];}if(state.defaultTimeDimensionLastNPeriods!==null){delete newDefaultObj[state.dimension.id];newDefaultObj[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]]=[state.defaultTimeDimensionLastNPeriods];}else{delete newDefaultObj[__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]];}}newDsdAnnotations=Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["X" /* setLayoutAnnotationDefault */])(newDsdAnnotations,annotationsConfig,newDefaultObj);var newNotDisplayedObj=Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(newDsdAnnotations,annotationsConfig);if(state.notDisplayedVal!==null){newNotDisplayedObj[state.dimension.id]=state.notDisplayedVal;}else{delete newNotDisplayedObj[state.dimension.id];}newDsdAnnotations=Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["_4" /* setLayoutAnnotationNotDisplayed */])(newDsdAnnotations,annotationsConfig,newNotDisplayedObj);return Object.assign({},state,{isCreatingComponent:false,dimension:null,dsd:Object.assign({},state.dsd,{dimensions:Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["i" /* normalizeDsdComponentsOrder */])(dimensions,state.dimension.id),annotations:newDsdAnnotations}),defaultVal:null,notDisplayedVal:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_2" /* DSD_DETAIL_GROUP_CREATE */]:return Object.assign({},state,{isCreatingComponent:true,group:{id:null,groupDimensions:null,annotations:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["_6" /* DSD_DETAIL_GROUP_SUBMIT */]:return Object.assign({},state,{isCreatingComponent:false,group:null,dsd:Object.assign({},state.dsd,{groups:state.isCreatingComponent?[].concat(_toConsumableArray(state.dsd.groups||[]),[state.group]):state.dsd.groups.map(function(comp){return comp.id===state.group.id?state.group:comp;})})});case __WEBPACK_IMPORTED_MODULE_1__actions__["_4" /* DSD_DETAIL_GROUP_EDIT */]:return Object.assign({},state,{group:state.dsd.groups.find(function(_ref5){var id=_ref5.id;return id===action.id;})});case __WEBPACK_IMPORTED_MODULE_1__actions__["_5" /* DSD_DETAIL_GROUP_HIDE */]:return Object.assign({},state,{isCreatingComponent:false,group:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* DSD_DETAIL_ATTRIBUTE_CREATE */]:return Object.assign({},state,{isCreatingComponent:true,attribute:{id:null,order:null,concept:null,representation:null,assignmentStatus:null,attachmentLevel:null,annotations:null},notDisplayedVal:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* DSD_DETAIL_ATTRIBUTE_SUBMIT */]:{var attributes=state.isCreatingComponent?[].concat(_toConsumableArray(state.dsd.attributes||[]),[state.attribute]):state.dsd.attributes.map(function(comp){return comp.id===state.attribute.id?state.attribute:comp;});var _annotationsConfig2=Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations;var _newDsdAnnotations=state.dsd.annotations||[];var _newNotDisplayedObj=Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(_newDsdAnnotations,_annotationsConfig2);if(state.notDisplayedVal!==null){_newNotDisplayedObj[state.attribute.id]=state.notDisplayedVal;}else{delete _newNotDisplayedObj[state.attribute.id];}_newDsdAnnotations=Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["_4" /* setLayoutAnnotationNotDisplayed */])(_newDsdAnnotations,_annotationsConfig2,_newNotDisplayedObj);return Object.assign({},state,{isCreatingComponent:false,attribute:null,dsd:Object.assign({},state.dsd,{attributes:Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["i" /* normalizeDsdComponentsOrder */])(attributes,state.attribute.id),annotations:_newDsdAnnotations}),notDisplayedVal:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* DSD_DETAIL_ATTRIBUTE_EDIT */]:{var _annotationsConfig3=Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations;return Object.assign({},state,{attribute:state.dsd.attributes.find(function(_ref6){var id=_ref6.id;return id===action.id;}),notDisplayedVal:Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(state.dsd.annotations,_annotationsConfig3)[action.id]||null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* DSD_DETAIL_ATTRIBUTE_HIDE */]:return Object.assign({},state,{isCreatingComponent:false,attribute:null,notDisplayedVal:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* DSD_DETAIL_DIMENSION_CHANGE */]:{var _dimension=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.dimension);var _customizer=function _customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(_dimension,action.fields,_customizer);if(action.fields.type){_dimension.concept=null;_dimension.codelist=null;_dimension.conceptScheme=null;_dimension.representation=null;if(state.dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["j" /* DSD_DIMENSION_TYPE_FREQUENCY */]||state.dimension.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]){_dimension.id=null;}}if(action.fields.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["j" /* DSD_DIMENSION_TYPE_FREQUENCY */]){_dimension.id=__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["h" /* DSD_DIMENSION_ID_FREQUENCY */];}else if(action.fields.type===__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]){_dimension.id=__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */];}return Object.assign({},state,{dimension:_dimension,defaultVal:action.fields.representation===null?state.defaultVal?[]:null:state.defaultVal,notDisplayedVal:action.fields.representation===null?state.notDisplayedVal?[]:null:state.notDisplayedVal});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_16" /* DSD_DETAIL_PRIMARY_MEASURE_CHANGE */]:{var primaryMeasure=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.dsd.primaryMeasure);var _customizer2=function _customizer2(_,src,key){if(key==="annotations")return src;else{return undefined;}};__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(primaryMeasure,action.fields,_customizer2);return Object.assign({},state,{dsd:Object.assign({},state.dsd,{primaryMeasure:primaryMeasure})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_1" /* DSD_DETAIL_GROUP_CHANGE */]:{var group=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.group);var _customizer3=function _customizer3(_,src,key){if(key==="annotations"||key==="groupDimensions")return src;else{return undefined;}};__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(group,action.fields,_customizer3);return Object.assign({},state,{group:group});}case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* DSD_DETAIL_ATTRIBUTE_CHANGE */]:{var attribute=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.attribute);var _customizer4=function _customizer4(_,src,key){if(key==="annotations"||key==="groupDimensions"||key==="attachedDimensions")return src;else{return undefined;}};__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(attribute,action.fields,_customizer4);if(action.fields.attachmentLevel){attribute.attachedDimensions=null;attribute.attachmentGroup=null;}return Object.assign({},state,{attribute:attribute,notDisplayedVal:action.fields.representation===null?state.notDisplayedVal?[]:null:state.notDisplayedVal});}case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* DSD_DETAIL_CODELISTS_FOR_SELECTOR_SHOW */]:return Object.assign({},state,{isCodelistsForSelectorVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* DSD_DETAIL_CODELISTS_FOR_SELECTOR_HIDE */]:return Object.assign({},state,{isCodelistsForSelectorVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* DSD_DETAIL_CODELISTS_FOR_SELECTOR_SET */]:if(state.dimension){return Object.assign({},state,{isCodelistsForSelectorVisible:false,dimension:Object.assign({},state.dimension,{representation:action.codelistUrn})});}else if(state.attribute){return Object.assign({},state,{isCodelistsForSelectorVisible:false,attribute:Object.assign({},state.attribute,{representation:action.codelistUrn})});}else{return Object.assign({},state,{isCodelistsForSelectorVisible:false,dsd:Object.assign({},state.dsd,{primaryMeasure:Object.assign({},state.dsd.primaryMeasure,{representation:action.codelistUrn})})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SET */]:if(state.dimension){return Object.assign({},state,{conceptSchemeForSelectorTriplet:null,conceptSchemeForSelector:null,dimension:Object.assign({},state.dimension,{concept:action.conceptUrn,id:state.dimension.id||Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["U" /* getQuartupletFromItemString */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_2" /* getStringFromItemUrn */])(action.conceptUrn)).itemId})});}else if(state.attribute){return Object.assign({},state,{conceptSchemeForSelectorTriplet:null,conceptSchemeForSelector:null,attribute:Object.assign({},state.attribute,{concept:action.conceptUrn,id:state.attribute.id||Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["U" /* getQuartupletFromItemString */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_2" /* getStringFromItemUrn */])(action.conceptUrn)).itemId})});}else{return Object.assign({},state,{conceptSchemeForSelectorTriplet:null,conceptSchemeForSelector:null,dsd:Object.assign({},state.dsd,{primaryMeasure:Object.assign({},state.dsd.primaryMeasure,{concept:action.conceptUrn})})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_SHOW */]:return Object.assign({},state,{isConceptSchemesForSelectorVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* DSD_DETAIL_CONCEPT_SCHEMES_FOR_SELECTOR_HIDE */]:return Object.assign({},state,{isConceptSchemesForSelectorVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_SHOW */]:return Object.assign({},state,{isConceptSchemesForSelectorVisible:false,conceptSchemeForSelectorTriplet:action.conceptSchemeTriplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_HIDE */]:return Object.assign({},state,{isConceptSchemesForSelectorVisible:true,conceptSchemeForSelectorTriplet:null,conceptSchemeForSelector:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["Z" /* DSD_DETAIL_EXPORT_SHOW */]:return Object.assign({},state,{dsdExportSourceTriplet:action.sourceTriplet,dsdExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,withReferences:true,loginOption:__WEBPACK_IMPORTED_MODULE_12__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null},isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["X" /* DSD_DETAIL_EXPORT_HIDE */]:return Object.assign({},state,{dsdExportSourceTriplet:null,dsdExportDestination:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["W" /* DSD_DETAIL_EXPORT_CHANGE */]:var dsdExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.dsdExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(dsdExportDestination,action.fields);return Object.assign({},state,{dsdExportDestination:dsdExportDestination});case __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* DSD_DETAIL_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{dsdExportReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* DSD_DETAIL_COMPONENT_DEFAULT_CHANGE */]:return Object.assign({},state,{defaultVal:action.val});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* DSD_DETAIL_COMPONENT_NOT_DISPLAYED_CHANGE */]:return Object.assign({},state,{notDisplayedVal:action.val});case __WEBPACK_IMPORTED_MODULE_1__actions__["_13" /* DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SHOW */]:{return Object.assign({},state,{codelistTripletForCodesSelector:action.codelistTriplet,itemsPageForNotDisplayedCodesSelector:null,itemsCountForNotDisplayedCodesSelector:null,tempSelectedCodesForNotDisplayedCodesSelector:state.notDisplayedVal});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_11" /* DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_HIDE */]:return Object.assign({},state,{codelistTripletForCodesSelector:null,itemsPageForNotDisplayedCodesSelector:null,itemsCountForNotDisplayedCodesSelector:null,tempSelectedCodesForNotDisplayedCodesSelector:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_14" /* DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_SUBMIT */]:return Object.assign({},state,{codelistTripletForCodesSelector:null,itemsPageForNotDisplayedCodesSelector:null,itemsCountForNotDisplayedCodesSelector:null,tempSelectedCodesForNotDisplayedCodesSelector:null,notDisplayedVal:state.tempSelectedCodesForNotDisplayedCodesSelector});case __WEBPACK_IMPORTED_MODULE_1__actions__["_15" /* DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE */]:return Object.assign({},state,{tempSelectedCodesForNotDisplayedCodesSelector:action.selected});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* DSD_DETAIL_DEFAULT_CODES_SELECTOR_SHOW */]:{return Object.assign({},state,{codelistTripletForCodesSelector:action.codelistTriplet,itemsPageForDefaultCodesSelector:null,itemsCountForDefaultCodesSelector:null,tempSelectedCodesForDefaultCodesSelector:state.defaultVal});}case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* DSD_DETAIL_DEFAULT_CODES_SELECTOR_HIDE */]:return Object.assign({},state,{codelistTripletForCodesSelector:null,itemsPageForDefaultCodesSelector:null,itemsCountForDefaultCodesSelector:null,tempSelectedCodesForDefaultCodesSelector:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* DSD_DETAIL_DEFAULT_CODES_SELECTOR_SUBMIT */]:return Object.assign({},state,{codelistTripletForCodesSelector:null,itemsPageForDefaultCodesSelector:null,itemsCountForDefaultCodesSelector:null,tempSelectedCodesForDefaultCodesSelector:null,defaultVal:state.tempSelectedCodesForDefaultCodesSelector});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* DSD_DETAIL_DEFAULT_CODES_SELECTOR_TEMP_SELECTED_CODES_CHANGE */]:return Object.assign({},state,{tempSelectedCodesForDefaultCodesSelector:action.selected});case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* DSD_DETAIL_DEFAULT_TIME_DIMENSION_START_CHANGE */]:return Object.assign({},state,{defaultTimeDimensionStart:action.val});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* DSD_DETAIL_DEFAULT_TIME_DIMENSION_END_CHANGE */]:return Object.assign({},state,{defaultTimeDimensionEnd:action.val});case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_OBSERVATIONS_CHANGE */]:return Object.assign({},state,{defaultTimeDimensionLastNObservations:action.val});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* DSD_DETAIL_DEFAULT_TIME_DIMENSION_LAST_N_PERIODS_CHANGE */]:return Object.assign({},state,{defaultTimeDimensionLastNPeriods:action.val});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* DSD_DETAIL_DEFAULT_TIME_DIMENSION_MODE_CHANGE */]:return Object.assign({},state,{defaultTimeDimensionMode:action.val,defaultTimeDimensionStart:null,defaultTimeDimensionEnd:null,defaultTimeDimensionLastNObservations:null,defaultTimeDimensionLastNPeriods:null});case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["_17" /* DSD_DETAIL_READ */]:{var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _dsd=Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["R" /* getDsdFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,customNoneIsAutoAnnotation);return Object.assign({},state,{dsd:Object.assign({},_dsd,{remoteIsFinal:_dsd.isFinal})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DSD_DETAIL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response,isAgenciesValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* DSD_DETAIL_CONCEPT_SCHEME_FOR_SELECTOR_READ */]:{var conceptScheme=Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);conceptScheme.concepts=conceptScheme.concepts&&Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["l" /* getNodes */])(conceptScheme.concepts,"concepts",function(){return true;});conceptScheme.concepts=conceptScheme.concepts&&conceptScheme.concepts.map(function(concept){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(concept),{order:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(concept.autoAnnotations,function(annotation){return annotation.type===action.itemOrderAnnotationType;})&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(concept.autoAnnotations,function(annotation){return annotation.type===action.itemOrderAnnotationType;}).text||null});});return Object.assign({},state,{conceptSchemeForSelector:conceptScheme});}case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* DSD_DETAIL_CREATE_SUBMIT */]:return Object.assign({},state,{dsd:null,dsdTriplet:{id:state.dsd.id,agencyID:state.dsd.agencyID,version:state.dsd.version}});case __WEBPACK_IMPORTED_MODULE_1__actions__["_19" /* DSD_DETAIL_UPDATE_SUBMIT */]:return Object.assign({},state,{dsd:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["U" /* DSD_DETAIL_DOWNLOAD_SUBMIT */]:return Object.assign({},state,{downloadDsdTriplets:null,downloadDsdLang:null,downloadDsdParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* DSD_DETAIL_CLONE_SUBMIT */]:return Object.assign({},state,{cloneDestTriplet:null,dsd:state.isVisible?state.dsd:null,dsdTriplet:state.isVisible?state.dsdTriplet:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* DSD_DETAIL_CODELISTS_READ */]:return Object.assign({},state,{codelists:(Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* DSD_DETAIL_CONCEPT_SCHEMES_READ */]:return Object.assign({},state,{conceptSchemes:(Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["_0" /* DSD_DETAIL_EXPORT_SUBMIT */]:return Object.assign({},state,{dsdExportSourceTriplet:null,dsdExportDestination:null,dsdExportReport:action.response.itemsMessage,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_12" /* DSD_DETAIL_NOT_DISPLAYED_CODES_SELECTOR_ITEMS_PAGE_READ */]:return Object.assign({},state,{itemsPageForNotDisplayedCodesSelector:Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes||[],itemsCountForNotDisplayedCodesSelector:Number(action.header["x-total-count"])});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* DSD_DETAIL_DEFAULT_CODES_SELECTOR_ITEMS_PAGE_READ */]:return Object.assign({},state,{itemsPageForDefaultCodesSelector:Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes||[],itemsCountForDefaultCodesSelector:Number(action.header["x-total-count"])});default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["_17" /* DSD_DETAIL_READ */]:return Object.assign({},state,{isVisible:false});default:return state;}default:return state;}};var DSD_DETAIL_CODELIST_DETAIL_PREFIX="DSD_DETAIL_CODELIST_DETAIL_PREFIX_";var DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX="DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX";var DSD_PRIMARY_MEASURE_ID="OBS_VALUE";/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_reduxReuse__["b" /* reuseInReducer */])(dsdDetailModalReducer,{codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_6__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_7__redux_codelist_detail_modal_reducer__["a" /* default */],DSD_DETAIL_CODELIST_DETAIL_PREFIX),conceptSchemeDetail:Object(__WEBPACK_IMPORTED_MODULE_6__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_8__redux_concept_scheme_detail_modal_reducer__["b" /* default */],DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX)}));

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(147);
var IE8_DOM_DEFINE = __webpack_require__(386);
var toPrimitive = __webpack_require__(276);
var dP = Object.defineProperty;

exports.f = __webpack_require__(129) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
var NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE='Table';var NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE='Tree';var mapPropsToFields=function mapPropsToFields(_ref){var General=_ref.General;return{ID:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:General&&General.ID?General.ID:""}),Name:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:General&&General.Name?General.Name:""}),DefaultItemsViewMode:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:General?General.DefaultItemsViewMode:null}),canViewUnallowedBuilderNodes:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:General?General.canViewUnallowedBuilderNodes:null}),Invisible:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:General?General.Invisible:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var GeneralForm=function GeneralForm(_ref3){var t=_ref3.t,form=_ref3.form,disableID=_ref3.disableID;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.general.id.label'),style:{marginBottom:0}},form.getFieldDecorator('ID',{normalize:__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.toUpper})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{disabled:disableID}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.general.name.label'),style:{marginBottom:0}},form.getFieldDecorator('Name')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.general.defaultItemsViewMode.label'),style:{marginBottom:0}},form.getFieldDecorator('DefaultItemsViewMode')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE,title:t('data.nodesConfig.general.defaultItemsViewMode.options.table.label')},t('data.nodesConfig.general.defaultItemsViewMode.options.table.label')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE,title:t('data.nodesConfig.general.defaultItemsViewMode.options.tree.label')},t('data.nodesConfig.general.defaultItemsViewMode.options.tree.label'))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.general.canViewUnallowedBuilderNodes.label")+' :'),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,null,form.getFieldDecorator("canViewUnallowedBuilderNodes",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.general.invisible.label")+' :'),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,null,form.getFieldDecorator("Invisible",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null))))));};/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_14_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(GeneralForm));

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return showDefaultCategorySchemeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hideDefaultCategorySchemeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return showDefaultCategorySchemeSelectorSelectModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return showDefaultCategorySchemeSelectorCreateModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return readDefaultCategorySchemeSelectorCategorySchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return submitDefaultCategorySchemeSelectorSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return submitDefaultCategorySchemeSelectorCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return changeDefaultCategorySchemeSelectorCreate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var DEFAULT_CATEGORY_SCHEME_SELECTOR_SHOW='DEFAULT_CATEGORY_SCHEME_SELECTOR_SHOW';var DEFAULT_CATEGORY_SCHEME_SELECTOR_HIDE='DEFAULT_CATEGORY_SCHEME_SELECTOR_HIDE';var DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_MODAL_SHOW='DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_MODAL_SHOW';var DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_MODAL_SHOW='DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_MODAL_SHOW';var DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ='DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ';var DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT='DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT';var DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT='DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT';var DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_CHANGE='DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_CHANGE';var showDefaultCategorySchemeSelector=function showDefaultCategorySchemeSelector(){return{type:DEFAULT_CATEGORY_SCHEME_SELECTOR_SHOW};};var hideDefaultCategorySchemeSelector=function hideDefaultCategorySchemeSelector(){return{type:DEFAULT_CATEGORY_SCHEME_SELECTOR_HIDE};};var showDefaultCategorySchemeSelectorSelectModal=function showDefaultCategorySchemeSelectorSelectModal(){return{type:DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_MODAL_SHOW};};var showDefaultCategorySchemeSelectorCreateModal=function showDefaultCategorySchemeSelectorCreateModal(){return{type:DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_MODAL_SHOW};};var readDefaultCategorySchemeSelectorCategorySchemes=function readDefaultCategorySchemeSelectorCategorySchemes(){return Object(__WEBPACK_IMPORTED_MODULE_0__api_actions__["l" /* getRequest */])(DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["p" /* getCategorySchemeUrl */])());};var submitDefaultCategorySchemeSelectorSelect=function submitDefaultCategorySchemeSelectorSelect(categorySchemeTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__api_actions__["l" /* getRequest */])(DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_47" /* getImportDCSUrl */])(categorySchemeTriplet.id,categorySchemeTriplet.agencyID,categorySchemeTriplet.version),function(t){return{success:t('middlewares.defaultCategorySchemeSelector.messages.selectSubmit.success')};});};var submitDefaultCategorySchemeSelectorCreate=function submitDefaultCategorySchemeSelectorCreate(cat){return Object(__WEBPACK_IMPORTED_MODULE_0__api_actions__["m" /* postRequest */])(DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["M" /* getCreateDCSCategoryUrl */])(),{catCode:cat.catCode,parCode:null,ord:"1",labels:cat.labels},function(t){return{success:t('middlewares.defaultCategorySchemeSelector.messages.createSubmit.success')};});};var changeDefaultCategorySchemeSelectorCreate=function changeDefaultCategorySchemeSelectorCreate(fields){return{type:DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_CHANGE,fields:fields};};

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PATH_META_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PATH_CODELISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PATH_CONCEPT_SCHEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PATH_CATEGORY_SCHEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PATH_DATA_STRUCTURE_DEFINITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PATH_DATAFLOWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PATH_CATEGORISATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PATH_HIERARCHICAL_CODELISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PATH_AGENCY_SCHEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PATH_DATA_PROVIDER_SCHEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PATH_DATA_CONSUMER_SCHEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PATH_ORGANIZATION_UNIT_SCHEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PATH_CONTENT_CONSTRAINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PATH_STRUCTURE_SETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PATH_PROVISION_AGREEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PATH_REGISTRATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PATH_CATEGORY_SCHEMES_AND_DATAFLOWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PATH_MSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PATH_METADATAFLOWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PATH_DATA_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PATH_BUILDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PATH_FILE_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return PATH_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PATH_DATAFLOW_BUILDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PATH_CUBE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PATH_MANAGE_SERIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return PATH_UPGRADE_DSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PATH_SYNCRONIZE_CODELISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PATH_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PATH_DDB_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PATH_REMOVE_TEMP_TABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PATH_UPDATE_DATABROWSER_CACHE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PATH_EASY_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PATH_EASY_LOADING_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PATH_EASY_LOADING_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return PATH_UTILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return PATH_IMPORT_STRUCTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PATH_COMPARE_DSDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PATH_COMPARE_ITEM_SCHEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PATH_MERGE_ITEM_SCHEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PATH_ARTEFACT_BROWSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PATH_REFERENCE_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PATH_METADATA_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PATH_DCAT_AP_IT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PATH_MANAGE_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return PATH_USER_MANAGEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PATH_SET_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PATH_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PATH_APP_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PATH_NODES_CONFIGURATION; });
var PATH_META_MANAGER='/meta-manager';var PATH_CODELISTS=PATH_META_MANAGER+'/codelists';var PATH_CONCEPT_SCHEMES=PATH_META_MANAGER+'/concept-schemes';var PATH_CATEGORY_SCHEMES=PATH_META_MANAGER+'/category-schemes';var PATH_DATA_STRUCTURE_DEFINITIONS=PATH_META_MANAGER+'/data-structure-definitions';var PATH_DATAFLOWS=PATH_META_MANAGER+'/dataflows';var PATH_CATEGORISATIONS=PATH_META_MANAGER+'/categorisations';var PATH_HIERARCHICAL_CODELISTS=PATH_META_MANAGER+'/hierarchical-codelists';var PATH_AGENCY_SCHEMES=PATH_META_MANAGER+'/agency-schemes';var PATH_DATA_PROVIDER_SCHEMES=PATH_META_MANAGER+'/data-provider-schemes';var PATH_DATA_CONSUMER_SCHEMES=PATH_META_MANAGER+'/data-consumer-schemes';var PATH_ORGANIZATION_UNIT_SCHEMES=PATH_META_MANAGER+'/organization-unit-schemes';var PATH_CONTENT_CONSTRAINTS=PATH_META_MANAGER+'/content-constraints';var PATH_STRUCTURE_SETS=PATH_META_MANAGER+'/structure-sets';var PATH_PROVISION_AGREEMENTS=PATH_META_MANAGER+'/provision-agreements';var PATH_REGISTRATIONS=PATH_META_MANAGER+'/registrations';var PATH_CATEGORY_SCHEMES_AND_DATAFLOWS=PATH_META_MANAGER+'/category-schemes-and-dataflows';var PATH_MSD=PATH_META_MANAGER+'/msds';var PATH_METADATAFLOWS=PATH_META_MANAGER+'/metadataflows';var PATH_DATA_MANAGER='/data-manager';var PATH_BUILDER=PATH_DATA_MANAGER+'/builder';var PATH_FILE_MAPPING=PATH_DATA_MANAGER+'/file-mapping';var PATH_LOADER=PATH_DATA_MANAGER+'/loader';var PATH_DATAFLOW_BUILDER=PATH_DATA_MANAGER+'/dataflow-builder';var PATH_CUBE_LIST=PATH_DATA_MANAGER+'/cube-list';var PATH_MANAGE_SERIES=PATH_DATA_MANAGER+'/manage-series';var PATH_UPGRADE_DSD=PATH_DATA_MANAGER+'/upgrade-dsd';var PATH_SYNCRONIZE_CODELISTS=PATH_DATA_MANAGER+'/synchronize-codelists';var PATH_ATTRIBUTE=PATH_DATA_MANAGER+'/attribute-file';var PATH_DDB_RESET=PATH_DATA_MANAGER+'/ddb-reset';var PATH_REMOVE_TEMP_TABLES=PATH_DATA_MANAGER+'/remove-temp-tables';var PATH_UPDATE_DATABROWSER_CACHE=PATH_DATA_MANAGER+'/update-databrowser-cache';var PATH_EASY_LOADING='/easy-loading';var PATH_EASY_LOADING_CREATE=PATH_EASY_LOADING+'/easy-loading-create';var PATH_EASY_LOADING_UPDATE=PATH_EASY_LOADING+'/easy-loading-update';var PATH_UTILITIES='/utilities';var PATH_IMPORT_STRUCTURES=PATH_UTILITIES+'/import-structures';var PATH_COMPARE_DSDS=PATH_UTILITIES+'/compare-dsds';var PATH_COMPARE_ITEM_SCHEMES=PATH_UTILITIES+'/compare-item-schemes';var PATH_MERGE_ITEM_SCHEMES=PATH_UTILITIES+'/merge-item-schemes';var PATH_ARTEFACT_BROWSER=PATH_UTILITIES+'/artefact-browser';var PATH_REFERENCE_METADATA='/reference-metadata';var PATH_METADATA_SET=PATH_REFERENCE_METADATA+'/metadata-set';var PATH_DCAT_AP_IT=PATH_REFERENCE_METADATA+'/dcat-ap-it';var PATH_MANAGE_USERS='/users';var PATH_USER_MANAGEMENT=PATH_MANAGE_USERS+'/user-management';var PATH_SET_PERMISSIONS=PATH_MANAGE_USERS+'/permissions';var PATH_CONFIGURATION='/configurations';var PATH_APP_CONFIGURATION=PATH_CONFIGURATION+'/app';var PATH_NODES_CONFIGURATION=PATH_CONFIGURATION+'/nodes';

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var LayoutAnnotationList=function LayoutAnnotationList(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,endpoints=_ref.endpoints,endpointId=_ref.endpointId,annotations=_ref.annotations,title=_ref.title,onClose=_ref.onClose;var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__["a" /* default */],{visible:annotations!=null,onCancel:onClose,footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onClose},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MODAL_WIDTH_LG"],title:t('components.layoutAnnotationList.title')+(title?": "+title:''),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(lang){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__infinite_scroll_table__["a" /* default */],{data:annotations?Object(__WEBPACK_IMPORTED_MODULE_6__utils_annotations__["O" /* getLayoutAnnotations */])(annotations,annotationsConfig).map(function(annot,key){return Object.assign({},annot,{key:key,text:Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_i18n_utils__["a" /* getLocalizedStr */])(annot.text,lang||appLanguage,dataLanguages,true)});}):[],getRowKey:function getRowKey(_ref2){var key=_ref2.key;return key;},columns:[{title:t('data.annotation.id.label'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.annotation.title.label'),dataIndex:'title',minWidth:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.annotation.type.label'),dataIndex:'type',minWidth:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.annotation.text.label'),dataIndex:'text',minWidth:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]}]});}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps))(LayoutAnnotationList));

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(119);
var core = __webpack_require__(99);
var ctx = __webpack_require__(275);
var hide = __webpack_require__(146);
var has = __webpack_require__(130);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(176)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 130 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(697);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(708);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyUtils__ = __webpack_require__(885);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

var getComputedStyleX = void 0;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["c" /* getTransitionProperty */])(elem) || '';
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = presetH + 'px';
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = presetV + 'px';
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}

function setTransform(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["b" /* getTransformXY */])(elem);
  var resultXY = { x: originalXY.x, y: originalXY.y };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["d" /* setTransformXY */])(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);

    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["a" /* getTransformName */])() in document.body.style) {
    setTransform(elem, offset, option);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = '' + prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val = void 0;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },

  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i = void 0;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },

  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    for (var i = 0; i < args.length; i++) {
      utils.mix(ret, args[i]);
    }
    return ret;
  },

  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArray(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(922),
    getValue = __webpack_require__(925);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

exports.getTodayTime = getTodayTime;
exports.getTitleString = getTitleString;
exports.getTodayTimeStr = getTodayTimeStr;
exports.getMonthName = getMonthName;
exports.syncTime = syncTime;
exports.getTimeConfig = getTimeConfig;
exports.isTimeValidByConfig = isTimeValidByConfig;
exports.isTimeValid = isTimeValid;
exports.isAllowedDate = isAllowedDate;
exports.formatDate = formatDate;

var _moment = __webpack_require__(46);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};

function getTodayTime(value) {
  var today = (0, _moment2['default'])();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}

function getTitleString(value) {
  return value.format('LL');
}

function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}

function getMonthName(month) {
  var locale = month.locale();
  var localeData = month.localeData();
  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}

function syncTime(from, to) {
  if (!_moment2['default'].isMoment(from) || !_moment2['default'].isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
}

function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = (0, _extends3['default'])({}, defaultDisabledTime, disabledTimeConfig);
  return disabledTimeConfig;
}

function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;
  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_LIST_DATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_DATAFLOW_MAPPING_SET_ID_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE; });
/* unused harmony export DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_FORCE_CACHE_UPDATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CUBE_AND_DDBDATAFLOW_READ; });
/* unused harmony export DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CHANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_CODES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_DSD_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return readDataflowBuilderListDataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return editDataflowBuilderListDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return deleteDataflowBuilderListDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return showDataflowBuilderListDataflowPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return hideDataflowBuilderListDataflowPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return readDataflowBuilderListDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return readDataflowBuilderListDataflowPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return setDataflowBuilderListDataflowMappingSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return unsetDataflowBuilderListDataflowMappingSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return changeDataflowBuilderListDataflowTranscodingMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return setDataflowBuilderListDataflowTranscoding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return showDataflowBuilderListDataflowTranscodingFromCCList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return hideDataflowBuilderListDataflowTranscodingFromCCList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return readDataflowBuilderListDataflowTranscodingFromCCList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return setDataflowBuilderListDataflowTranscodingFromCCContentConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return unsetDataflowBuilderListDataflowTranscodingFromCCContentConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return setDataflowBuilderListDataflowTranscodingFromCC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return unsetDataflowBuilderListDataflowTranscoding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return setDataflowBuilderListDataflowContentConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return unsetDataflowBuilderListDataflowContentConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return setDataflowBuilderListDataflowProductionFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return readDataflowBuilderListonDataflowMappingSetId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return showDataflowBuilderListDataflowProductionModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return hideDataflowBuilderListDataflowProductionModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return showDataflowBuilderListDataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return hideDataflowBuilderListDataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return changeDataflowBuilderListDataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return downloadDataflowBuilderListDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return showDataflowBuilderListDataflowDownloadQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return hideDataflowBuilderListDataflowDownloadQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return setDataflowBuilderListDataflowDownloadQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return unsetDataflowBuilderListDataflowDownloadQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return readDataflowBuilderListDataflowDownloadCubeAndDdBDataflow; });
/* unused harmony export changeDataflowBuilderListDataflowDownloadFilterForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return addDataflowBuilderListDataflowDownloadFilterFormBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return deleteDataflowBuilderListDataflowDownloadFilterFormBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return addDataflowBuilderListDataflowDownloadFilterFormCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return deleteDataflowBuilderListDataflowDownloadFilterFormCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return readDataflowBuilderListDataflowDownloadFilterFormColumnValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return resetDataflowBuilderListDataflowDownloadFilterFormColumnValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return readDataflowBuilderListDataflowDownloadFilterFormColumnCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return readDataflowBuilderListDataflowDownloadPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return showDataflowBuilderListDataflowDownloadPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return hideDataflowBuilderListDataflowDownloadPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return checkDataflowBuilderListDataflowDownloadColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return changeDataflowBuilderListDataflowDownloadColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return readDataflowBuilderListDataflowDsdDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return showDataflowBuilderListDataflowAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return hideDataflowBuilderListDataflowAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return showDataflowBuilderListDataflowLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return hideDataflowBuilderListDataflowLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return showDataflowBuilderListDataflowDownloadFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return hideDataflowBuilderListDataflowDownloadFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return submitDataflowBuilderListDataflowDownloadFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return changeDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return changeDataflowBuilderListDataflowDownloadFilterModalFilterMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return resetDataflowBuilderListDataflowDownloadFilterModalFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return changeDataflowBuilderListDataflowDownloadFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return changeDataflowBuilderListDataflowDownloadFilterModalTreeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnCodelistCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnCodelistTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnFilteredValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return changeDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return showDataflowBuilderListDataflowDownloadFilterRowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return hideDataflowBuilderListDataflowDownloadFilterRowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return readDataflowBuilderListDataflowDownloadFilterRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return forceDataflowBuilderListDataflowCacheUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__ = __webpack_require__(65);
var DATAFLOW_BUILDER_LIST_DATAFLOWS_READ='DATAFLOW_BUILDER_LIST_DATAFLOWS_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_EDIT='DATAFLOW_BUILDER_LIST_DATAFLOW_EDIT';var DATAFLOW_BUILDER_LIST_DATAFLOW_DELETE='DATAFLOW_BUILDER_LIST_DATAFLOW_DELETE';var DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_SET='DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_SET';var DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_UNSET='DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_UNSET';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_MODE_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_MODE_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_SET='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_SET';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_UNSET='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_UNSET';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_SET='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_SET';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_SET='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_SET';var DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_UNSET='DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_UNSET';var DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET='DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET';var DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET='DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET';var DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET='DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET';var DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_DATAFLOW_MAPPING_SET_ID_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_DATAFLOW_MAPPING_SET_ID_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_FORCE_CACHE_UPDATE='DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_FORCE_CACHE_UPDATE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SET='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SET';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CUBE_AND_DDBDATAFLOW_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CUBE_AND_DDBDATAFLOW_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_ADD='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_ADD';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_DELETE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_DELETE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_ADD='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_ADD';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_DELETE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_DELETE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_RESET='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_RESET';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_CODES_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_CODES_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_DSD_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_DSD_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SUBMIT='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SUBMIT';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_RESET='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_RESET';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_SHOW='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_SHOW';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_HIDE='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_HIDE';var DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_READ='DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_READ';var readDataflowBuilderListDataflows=function readDataflowBuilderListDataflows(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOWS_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_9" /* getDdbDataflowUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])()]);};var editDataflowBuilderListDataflow=function editDataflowBuilderListDataflow(ddbDataflowId,dataflowTriplet,cubeId,filter){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_EDIT,ddbDataflowId:ddbDataflowId,dataflowTriplet:dataflowTriplet,cubeId:cubeId,filter:filter};};var deleteDataflowBuilderListDataflow=function deleteDataflowBuilderListDataflow(ddbDataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_9" /* getDdbDataflowUrl */])(ddbDataflowId),function(t){return{success:t('scenes.dataManager.dataflowBuilder.dataflowTable.messages.delete.success')};});};var showDataflowBuilderListDataflowPreview=function showDataflowBuilderListDataflowPreview(dataflowId){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_SHOW,dataflowId:dataflowId};};var hideDataflowBuilderListDataflowPreview=function hideDataflowBuilderListDataflowPreview(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_HIDE};};var readDataflowBuilderListDataflow=function readDataflowBuilderListDataflow(ddbDataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_9" /* getDdbDataflowUrl */])(ddbDataflowId));};var readDataflowBuilderListDataflowPreview=function readDataflowBuilderListDataflowPreview(cubeId,cubeColumns,filter,pageNum,pageSize,sortCols,sortByDesc,dataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_6" /* getDataflowPreviewUrl */])(true),Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(cubeColumns,Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter)),pageNum,pageSize,sortCols,sortByDesc,cubeId,dataflowId));};var setDataflowBuilderListDataflowMappingSet=function setDataflowBuilderListDataflowMappingSet(ddbDataflowId,defaultValue){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_SET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["O" /* getCreateDataflowMappingSetUrl */])(ddbDataflowId,defaultValue),function(t){return{success:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.createMappingSet.success')};});};var unsetDataflowBuilderListDataflowMappingSet=function unsetDataflowBuilderListDataflowMappingSet(ddbDataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_UNSET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_77" /* getRemoveDataflowMappingSetUrl */])(ddbDataflowId),function(t){return{success:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.deleteMappingSet.success')};});};var changeDataflowBuilderListDataflowTranscodingMode=function changeDataflowBuilderListDataflowTranscodingMode(mode){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_MODE_CHANGE,mode:mode};};var setDataflowBuilderListDataflowTranscoding=function setDataflowBuilderListDataflowTranscoding(ddbDataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_SET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["Q" /* getCreateDataflowTranscodingUrl */])(ddbDataflowId),function(t){return{success:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.createTranscoding.success')};});};var showDataflowBuilderListDataflowTranscodingFromCCList=function showDataflowBuilderListDataflowTranscodingFromCCList(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_SHOW};};var hideDataflowBuilderListDataflowTranscodingFromCCList=function hideDataflowBuilderListDataflowTranscodingFromCCList(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_HIDE};};var readDataflowBuilderListDataflowTranscodingFromCCList=function readDataflowBuilderListDataflowTranscodingFromCCList(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_2" /* getDataflowContentConstraintUrl */])(dataflowTriplet));};var setDataflowBuilderListDataflowTranscodingFromCCContentConstraint=function setDataflowBuilderListDataflowTranscodingFromCCContentConstraint(contentConstraintTriplet){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_SET,contentConstraintTriplet:contentConstraintTriplet};};var unsetDataflowBuilderListDataflowTranscodingFromCCContentConstraint=function unsetDataflowBuilderListDataflowTranscodingFromCCContentConstraint(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_UNSET};};var setDataflowBuilderListDataflowTranscodingFromCC=function setDataflowBuilderListDataflowTranscodingFromCC(ddbDataflowId,contentConstraintTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_SET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["P" /* getCreateDataflowTranscodingFromCCUrl */])(ddbDataflowId,contentConstraintTriplet),function(t){return{success:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.createTranscoding.success')};});};var unsetDataflowBuilderListDataflowTranscoding=function unsetDataflowBuilderListDataflowTranscoding(ddbDataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_UNSET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_78" /* getRemoveDataflowTranscodingUrl */])(ddbDataflowId),function(t){return{success:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.deleteTranscoding.success')};});};var setDataflowBuilderListDataflowContentConstraint=function setDataflowBuilderListDataflowContentConstraint(ddbDataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["N" /* getCreateDataflowContentConstraintUrl */])(ddbDataflowId),function(t){return{success:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.createContentConstraints.success')};});};var unsetDataflowBuilderListDataflowContentConstraint=function unsetDataflowBuilderListDataflowContentConstraint(ddbDataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_76" /* getRemoveDataflowContentConstraintUrl */])(ddbDataflowId),function(t){return{success:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.deleteContentConstraints.success')};});};var setDataflowBuilderListDataflowProductionFlag=function setDataflowBuilderListDataflowProductionFlag(ddbDataflowId,notProductionFlag){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_85" /* getSetDataflowProductionFlagUrl */])(ddbDataflowId,notProductionFlag),function(t){return{success:notProductionFlag?t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.removePublish.success'):t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.publish.success')};});};var readDataflowBuilderListonDataflowMappingSetId=function readDataflowBuilderListonDataflowMappingSetId(ddbDataflowId){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_DATAFLOW_MAPPING_SET_ID_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_55" /* getMappingSetIdUrl */])(ddbDataflowId)),{ddbDataflowId:ddbDataflowId});};var showDataflowBuilderListDataflowProductionModal=function showDataflowBuilderListDataflowProductionModal(ddbDataflowId,dataflowTriplet){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW,ddbDataflowId:ddbDataflowId,dataflowTriplet:dataflowTriplet};};var hideDataflowBuilderListDataflowProductionModal=function hideDataflowBuilderListDataflowProductionModal(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE};};var showDataflowBuilderListDataflowDownload=function showDataflowBuilderListDataflowDownload(ddbDataflowId,cubeId,dataflowTriplet,dsdTriplet){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_SHOW,ddbDataflowId:ddbDataflowId,cubeId:cubeId,dataflowTriplet:dataflowTriplet,dsdTriplet:dsdTriplet};};var hideDataflowBuilderListDataflowDownload=function hideDataflowBuilderListDataflowDownload(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_HIDE};};var changeDataflowBuilderListDataflowDownload=function changeDataflowBuilderListDataflowDownload(fields){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CHANGE,fields:fields};};var downloadDataflowBuilderListDataflow=function downloadDataflowBuilderListDataflow(ddbdataflowId,dataflowtriplet,dataflowDownloadParams,sortedCols,cubeId){var sortedSelCols=void 0;if(dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["o" /* DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM */]&&dataflowDownloadParams.selCols&&sortedCols){sortedSelCols=sortedCols.filter(function(col){return dataflowDownloadParams.selCols.includes(col);});}var hasFilters=dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["o" /* DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["p" /* DOWNLOAD_FORMAT_TYPE_GENERIC */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["t" /* DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["q" /* DOWNLOAD_FORMAT_TYPE_GENERIC20 */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["m" /* DOWNLOAD_FORMAT_TYPE_COMPACT */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["s" /* DOWNLOAD_FORMAT_TYPE_SDMXCSV */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["r" /* DOWNLOAD_FORMAT_TYPE_JSON */];var isSdmx=dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["p" /* DOWNLOAD_FORMAT_TYPE_GENERIC */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["t" /* DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["q" /* DOWNLOAD_FORMAT_TYPE_GENERIC20 */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["m" /* DOWNLOAD_FORMAT_TYPE_COMPACT */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["s" /* DOWNLOAD_FORMAT_TYPE_SDMXCSV */]||dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["r" /* DOWNLOAD_FORMAT_TYPE_JSON */];return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_28" /* getDownloadDdbdataflowUrl */])(dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["s" /* DOWNLOAD_FORMAT_TYPE_SDMXCSV */]?'csv':dataflowDownloadParams.format,dataflowDownloadParams.compression,dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["o" /* DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM */]?dataflowDownloadParams.csvSeparator:null,dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["o" /* DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM */]?dataflowDownloadParams.csvDelimiter:null,dataflowDownloadParams.format===__WEBPACK_IMPORTED_MODULE_2__constants_download__["t" /* DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC */]?dataflowDownloadParams.dimension:null),Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(hasFilters&&sortedSelCols?sortedSelCols:null,hasFilters?Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(isSdmx?dataflowDownloadParams.filter:Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(dataflowDownloadParams.filter),isSdmx):null,undefined,undefined,undefined,undefined,cubeId,ddbdataflowId),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_2__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])([dataflowtriplet],__WEBPACK_IMPORTED_MODULE_2__constants_download__["g" /* ARTEFACT_TYPE_DDBDATAFLOW */],dataflowDownloadParams.format,dataflowDownloadParams.compression)});};var showDataflowBuilderListDataflowDownloadQuery=function showDataflowBuilderListDataflowDownloadQuery(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW};};var hideDataflowBuilderListDataflowDownloadQuery=function hideDataflowBuilderListDataflowDownloadQuery(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE};};var setDataflowBuilderListDataflowDownloadQuery=function setDataflowBuilderListDataflowDownloadQuery(selCols,filter){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SET,selCols:selCols,filter:filter};};var unsetDataflowBuilderListDataflowDownloadQuery=function unsetDataflowBuilderListDataflowDownloadQuery(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET};};var readDataflowBuilderListDataflowDownloadCubeAndDdBDataflow=function readDataflowBuilderListDataflowDownloadCubeAndDdBDataflow(cubeId,ddbdataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CUBE_AND_DDBDATAFLOW_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_9" /* getDdbDataflowUrl */])(ddbdataflowId)]);};var changeDataflowBuilderListDataflowDownloadFilterForm=function changeDataflowBuilderListDataflowDownloadFilterForm(fields){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CHANGE,fields:fields};};var addDataflowBuilderListDataflowDownloadFilterFormBlock=function addDataflowBuilderListDataflowDownloadFilterFormBlock(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_ADD};};var deleteDataflowBuilderListDataflowDownloadFilterFormBlock=function deleteDataflowBuilderListDataflowDownloadFilterFormBlock(blockIndex){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_DELETE,blockIndex:blockIndex};};var addDataflowBuilderListDataflowDownloadFilterFormCondition=function addDataflowBuilderListDataflowDownloadFilterFormCondition(blockIndex){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_ADD,blockIndex:blockIndex};};var deleteDataflowBuilderListDataflowDownloadFilterFormCondition=function deleteDataflowBuilderListDataflowDownloadFilterFormCondition(blockIndex,conditionIndex){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_DELETE,blockIndex:blockIndex,conditionIndex:conditionIndex};};var readDataflowBuilderListDataflowDownloadFilterFormColumnValue=function readDataflowBuilderListDataflowDownloadFilterFormColumnValue(cubeId,columnName,viewerObj,dataflowId){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(columnName,viewerObj.pageNum,viewerObj.pageSize),{idCube:cubeId,dataflowColumns:[columnName],idDataflow:dataflowId,filter:Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(undefined,viewerObj.filterObj||Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["e" /* getFilterStrFromViewerObj */])([columnName],viewerObj.searchText,[],""))).Filter}),{columnName:columnName});};var resetDataflowBuilderListDataflowDownloadFilterFormColumnValue=function resetDataflowBuilderListDataflowDownloadFilterFormColumnValue(columnName){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_RESET,columnName:columnName};};var readDataflowBuilderListDataflowDownloadFilterFormColumnCodes=function readDataflowBuilderListDataflowDownloadFilterFormColumnCodes(columnName,codelistCode){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_CODES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).id,agencyId:Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).agencyID,version:Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).version,pageNum:1,pageSize:-1,rebuildDb:false,lang:"en"}),{columnName:columnName});};var readDataflowBuilderListDataflowDownloadPreview=function readDataflowBuilderListDataflowDownloadPreview(cubeId,cubeColumns,filter,pageNum,pageSize,sortCols,sortByDesc,dataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_6" /* getDataflowPreviewUrl */])(true),Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(cubeColumns,Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter)),pageNum,pageSize,sortCols,sortByDesc,cubeId,dataflowId));};var showDataflowBuilderListDataflowDownloadPreview=function showDataflowBuilderListDataflowDownloadPreview(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW};};var hideDataflowBuilderListDataflowDownloadPreview=function hideDataflowBuilderListDataflowDownloadPreview(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_HIDE};};var checkDataflowBuilderListDataflowDownloadColumns=function checkDataflowBuilderListDataflowDownloadColumns(cols){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK,cols:cols};};var changeDataflowBuilderListDataflowDownloadColumns=function changeDataflowBuilderListDataflowDownloadColumns(cols){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE,cols:cols};};var readDataflowBuilderListDataflowDsdDataflow=function readDataflowBuilderListDataflowDsdDataflow(triplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_DSD_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(triplet));};var showDataflowBuilderListDataflowAnnotations=function showDataflowBuilderListDataflowAnnotations(annotations){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_SHOW,annotations:annotations};};var hideDataflowBuilderListDataflowAnnotations=function hideDataflowBuilderListDataflowAnnotations(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_HIDE};};var showDataflowBuilderListDataflowLayoutAnnotations=function showDataflowBuilderListDataflowLayoutAnnotations(annotations){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_SHOW,annotations:annotations};};var hideDataflowBuilderListDataflowLayoutAnnotations=function hideDataflowBuilderListDataflowLayoutAnnotations(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_HIDE};};var showDataflowBuilderListDataflowDownloadFilterModal=function showDataflowBuilderListDataflowDownloadFilterModal(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SHOW};};var hideDataflowBuilderListDataflowDownloadFilterModal=function hideDataflowBuilderListDataflowDownloadFilterModal(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_HIDE};};var submitDataflowBuilderListDataflowDownloadFilterModal=function submitDataflowBuilderListDataflowDownloadFilterModal(filter){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SUBMIT,filter:filter};};var changeDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnMode=function changeDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnMode(colName,mode){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE,colName:colName,mode:mode};};var changeDataflowBuilderListDataflowDownloadFilterModalFilterMode=function changeDataflowBuilderListDataflowDownloadFilterModalFilterMode(filterMode){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE,filterMode:filterMode};};var resetDataflowBuilderListDataflowDownloadFilterModalFilter=function resetDataflowBuilderListDataflowDownloadFilterModalFilter(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_RESET};};var changeDataflowBuilderListDataflowDownloadFilter=function changeDataflowBuilderListDataflowDownloadFilter(fields){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE,fields:fields};};var changeDataflowBuilderListDataflowDownloadFilterModalTreeFilter=function changeDataflowBuilderListDataflowDownloadFilterModalTreeFilter(treeFilter){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE,treeFilter:treeFilter};};var readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnCodelistCount=function readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnCodelistCount(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnCodelistTree=function readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnCodelistTree(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:-1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnFilteredValues=function readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnFilteredValues(cubeId,colNames,filter,dataflowId){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(colNames[colNames.length-1],1,-1),{idCube:cubeId,dataflowColumns:colNames,filter:Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(undefined,Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter))).Filter,idDataflow:dataflowId}),{colName:colNames[colNames.length-1]});};var changeDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnValues=function changeDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnValues(colName,values){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE,colName:colName,values:values};};var showDataflowBuilderListDataflowDownloadFilterRowsModal=function showDataflowBuilderListDataflowDownloadFilterRowsModal(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_SHOW};};var hideDataflowBuilderListDataflowDownloadFilterRowsModal=function hideDataflowBuilderListDataflowDownloadFilterRowsModal(){return{type:DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_HIDE};};var readDataflowBuilderListDataflowDownloadFilterRows=function readDataflowBuilderListDataflowDownloadFilterRows(cubeId,cubeColumns,filter,pageNum,pageSize,sortCols,sortByDesc,dataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_6" /* getDataflowPreviewUrl */])(true),Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(cubeColumns,Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter)),pageNum,pageSize,sortCols,sortByDesc,cubeId,dataflowId));};var forceDataflowBuilderListDataflowCacheUpdate=function forceDataflowBuilderListDataflowCacheUpdate(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_FORCE_CACHE_UPDATE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["Z" /* getDataBrowserClearCacheUrl */])(dataflowTriplet.id,dataflowTriplet.agencyID,dataflowTriplet.version),undefined,function(t){return{success:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.forceCacheUpdate.success')};});};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return DATAFLOWS_LIST_DATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DATAFLOWS_DATAFLOW_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DATAFLOWS_DATAFLOW_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DATAFLOWS_DATAFLOW_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DATAFLOWS_DETAIL_DATAFLOW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DATAFLOWS_DETAIL_DATAFLOW_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DATAFLOWS_DETAIL_DATAFLOW_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DATAFLOWS_DETAIL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return DATAFLOWS_DETAIL_DSDS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DATAFLOWS_DETAIL_DSDS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DATAFLOWS_DETAIL_DSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return DATAFLOWS_DETAIL_DSD_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return DATAFLOWS_DETAIL_DSD_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return DATAFLOWS_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DATAFLOWS_DETAIL_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DATAFLOWS_DETAIL_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return DATAFLOWS_SELECTED_DATAFLOWS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DATAFLOWS_DATAFLOW_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DATAFLOWS_DATAFLOW_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DATAFLOWS_DATAFLOW_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOWS_DATAFLOW_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOWS_DATAFLOW_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOWS_DATAFLOW_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DATAFLOWS_DATAFLOW_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DATAFLOWS_DATAFLOW_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DATAFLOWS_DATAFLOW_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATAFLOWS_DATAFLOW_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DATAFLOWS_DATAFLOW_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DATAFLOWS_DATAFLOW_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DATAFLOWS_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DATAFLOWS_DATAFLOW_OWNERSHIP_USERS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DATAFLOWS_DATAFLOW_OWNERSHIP_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DATAFLOWS_DATAFLOW_OWNERSHIP_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_PING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return setDataflowsDetailVirtualDataflowEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return setDataflowsDetailVirtualDataflowDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return unsetDataflowsDetailVirtualDataflowDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return pingDataflowsDetailVirtualDataflowEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return openDataflowsDetailVirtualDataflowDataflowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return closeDataflowsDetailVirtualDataflowDataflowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return readDataflowsDetailVirtualDataflowDataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return readDataflowsListDataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return createDataflowsDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return editDataflowsDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return deleteDataflowsDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return readDataflowsDetailDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return changeDataflowsDetailDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return submitDataflowsDetailDataflowCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return submitDataflowsDetailDataflowUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return readDataflowsDetailAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return showDataflowsDetailDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return hideDataflowsDetailDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return readDataflowsDetailDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return setDataflowsDetailDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return unsetDataflowsDetailDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return hideDataflowsDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return showDataflowsDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return hideDataflowsDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return showDataflowsDetailLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return hideDataflowsDetailLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return deleteDataflowsSelectedDataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return showDataflowsDataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return hideDataflowsDataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return changeDataflowsDataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return submitDataflowsDataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return showDataflowsDataflowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return hideDataflowsDataflowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return changeDataflowsDataflowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return submitDataflowsDataflowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return showDataflowsDataflowExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return hideDataflowsDataflowExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return changeDataflowsDataflowExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return submitDataflowsDataflowExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return hideDataflowsDataflowExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return readDataflowsDetailDsdForLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return showDataflowsDataflowOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return hideDataflowsDataflowOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return readDataflowsDataflowOwnershipUsersRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return readDataflowsDataflowOwnershipOwnersRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return changeDataflowsDataflowOwnershipOwners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return submitDataflowsDataflowOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return readDataflowsDataflowParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return hideDataflowsDataflowParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return showDataflowsDataflowContentConstraints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return hideDataflowsDataflowContentConstraints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return readDataflowsDataflowContentConstraints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return showDataflowsDetailLayoutAnnotationsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return hideDataflowsDetailLayoutAnnotationsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return submitDataflowsDetailLayoutAnnotationsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return resetDataflowsDetailLayoutAnnotationsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return readDataflowsDetailLayoutAnnotationsItemsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return resetDataflowsDetailLayoutAnnotationsItemsPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artefact_export_form__ = __webpack_require__(51);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DATAFLOWS_LIST_DATAFLOWS_READ='DATAFLOWS_LIST_DATAFLOWS_READ';var DATAFLOWS_DATAFLOW_CREATE='DATAFLOWS_DATAFLOW_CREATE';var DATAFLOWS_DATAFLOW_EDIT='DATAFLOWS_DATAFLOW_EDIT';var DATAFLOWS_DATAFLOW_DELETE='DATAFLOWS_DATAFLOW_DELETE';var DATAFLOWS_DETAIL_DATAFLOW_READ='DATAFLOWS_DETAIL_DATAFLOW_READ';var DATAFLOWS_DETAIL_DATAFLOW_CHANGE='DATAFLOWS_DETAIL_DATAFLOW_CHANGE';var DATAFLOWS_DETAIL_DATAFLOW_CREATE_SUBMIT='DATAFLOWS_DETAIL_DATAFLOW_CREATE_SUBMIT';var DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT='DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT';var DATAFLOWS_DETAIL_AGENCIES_READ='DATAFLOWS_DETAIL_AGENCIES_READ';var DATAFLOWS_DETAIL_DSDS_SHOW='DATAFLOWS_DETAIL_DSDS_SHOW';var DATAFLOWS_DETAIL_DSDS_HIDE='DATAFLOWS_DETAIL_DSDS_HIDE';var DATAFLOWS_DETAIL_DSDS_READ='DATAFLOWS_DETAIL_DSDS_READ';var DATAFLOWS_DETAIL_DSD_SET='DATAFLOWS_DETAIL_DSD_SET';var DATAFLOWS_DETAIL_DSD_UNSET='DATAFLOWS_DETAIL_DSD_UNSET';var DATAFLOWS_DETAIL_HIDE='DATAFLOWS_DETAIL_HIDE';var DATAFLOWS_DETAIL_ANNOTATIONS_SHOW='DATAFLOWS_DETAIL_ANNOTATIONS_SHOW';var DATAFLOWS_DETAIL_ANNOTATIONS_HIDE='DATAFLOWS_DETAIL_ANNOTATIONS_HIDE';var DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_SHOW='DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_SHOW';var DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_HIDE='DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_HIDE';var DATAFLOWS_SELECTED_DATAFLOWS_DELETE='DATAFLOWS_SELECTED_DATAFLOWS_DELETE';var DATAFLOWS_DATAFLOW_DOWNLOAD_SHOW='DATAFLOWS_DATAFLOW_DOWNLOAD_SHOW';var DATAFLOWS_DATAFLOW_DOWNLOAD_HIDE='DATAFLOWS_DATAFLOW_DOWNLOAD_HIDE';var DATAFLOWS_DATAFLOW_DOWNLOAD_CHANGE='DATAFLOWS_DATAFLOW_DOWNLOAD_CHANGE';var DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT='DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT';var DATAFLOWS_DATAFLOW_CLONE_SHOW='DATAFLOWS_DATAFLOW_CLONE_SHOW';var DATAFLOWS_DATAFLOW_CLONE_HIDE='DATAFLOWS_DATAFLOW_CLONE_HIDE';var DATAFLOWS_DATAFLOW_CLONE_CHANGE='DATAFLOWS_DATAFLOW_CLONE_CHANGE';var DATAFLOWS_DATAFLOW_CLONE_SUBMIT='DATAFLOWS_DATAFLOW_CLONE_SUBMIT';var DATAFLOWS_DATAFLOW_EXPORT_SHOW='DATAFLOWS_DATAFLOW_EXPORT_SHOW';var DATAFLOWS_DATAFLOW_EXPORT_HIDE='DATAFLOWS_DATAFLOW_EXPORT_HIDE';var DATAFLOWS_DATAFLOW_EXPORT_CHANGE='DATAFLOWS_DATAFLOW_EXPORT_CHANGE';var DATAFLOWS_DATAFLOW_EXPORT_SUBMIT='DATAFLOWS_DATAFLOW_EXPORT_SUBMIT';var DATAFLOWS_DATAFLOW_EXPORT_REPORT_HIDE='DATAFLOWS_DATAFLOW_EXPORT_REPORT_HIDE';var DATAFLOWS_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ='DATAFLOWS_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ';var DATAFLOWS_DATAFLOW_OWNERSHIP_USERS_READ='DATAFLOWS_DATAFLOW_OWNERSHIP_USERS_READ';var DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_READ='DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_READ';var DATAFLOWS_DATAFLOW_OWNERSHIP_SHOW='DATAFLOWS_DATAFLOW_OWNERSHIP_SHOW';var DATAFLOWS_DATAFLOW_OWNERSHIP_HIDE='DATAFLOWS_DATAFLOW_OWNERSHIP_HIDE';var DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_CHANGE='DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_CHANGE';var DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_SUBMIT='DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_SUBMIT';var DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_READ='DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_READ';var DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_HIDE='DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_HIDE';var DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_SHOW='DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_SHOW';var DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_READ='DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_READ';var DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_HIDE='DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_HIDE';var DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW='DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW';var DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE='DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE';var DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT='DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT';var DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET='DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET';var DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ='DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ';var DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET='DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET';var DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_SET='DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_SET';var DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_SET='DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_SET';var DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_UNSET='DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_UNSET';var DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_PING='DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_PING';var DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_OPEN='DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_OPEN';var DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_CLOSE='DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_CLOSE';var DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_READ='DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_READ';var setDataflowsDetailVirtualDataflowEndpoint=function setDataflowsDetailVirtualDataflowEndpoint(endpointId){return{type:DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_SET,endpointId:endpointId};};var setDataflowsDetailVirtualDataflowDataflow=function setDataflowsDetailVirtualDataflowDataflow(dataflowTriplet){return{type:DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_SET,dataflowTriplet:dataflowTriplet};};var unsetDataflowsDetailVirtualDataflowDataflow=function unsetDataflowsDetailVirtualDataflowDataflow(){return{type:DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_UNSET};};var pingDataflowsDetailVirtualDataflowEndpoint=function pingDataflowsDetailVirtualDataflowEndpoint(endpointId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_PING,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_68" /* getNodePingUrl */])(),undefined,undefined,endpointId);};var openDataflowsDetailVirtualDataflowDataflowsModal=function openDataflowsDetailVirtualDataflowDataflowsModal(){return{type:DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_OPEN};};var closeDataflowsDetailVirtualDataflowDataflowsModal=function closeDataflowsDetailVirtualDataflowDataflowsModal(){return{type:DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_CLOSE};};var readDataflowsDetailVirtualDataflowDataflows=function readDataflowsDetailVirtualDataflowDataflows(endpointId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])(),undefined,undefined,endpointId);};var readDataflowsListDataflows=function readDataflowsListDataflows(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_LIST_DATAFLOWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])());};var createDataflowsDataflow=function createDataflowsDataflow(){return{type:DATAFLOWS_DATAFLOW_CREATE};};var editDataflowsDataflow=function editDataflowsDataflow(dataflowTriplet){return{type:DATAFLOWS_DATAFLOW_EDIT,dataflowTriplet:dataflowTriplet};};var deleteDataflowsDataflow=function deleteDataflowsDataflow(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(DATAFLOWS_DATAFLOW_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("Dataflow",dataflowTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var readDataflowsDetailDataflow=function readDataflowsDetailDataflow(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DETAIL_DATAFLOW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])(dataflowTriplet));};var changeDataflowsDetailDataflow=function changeDataflowsDetailDataflow(fields){return{type:DATAFLOWS_DETAIL_DATAFLOW_CHANGE,fields:fields};};var submitDataflowsDetailDataflowCreate=function submitDataflowsDetailDataflowCreate(dataflow){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOWS_DETAIL_DATAFLOW_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(dataflow)],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["B" /* SDMX_JSON_DATAFLOW_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.dataflows.messages.create.success')};});};var submitDataflowsDetailDataflowUpdate=function submitDataflowsDetailDataflowUpdate(dataflow,keepModalOpen){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(dataflow)],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["B" /* SDMX_JSON_DATAFLOW_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.dataflows.messages.update.success')};}),{keepModalOpen:keepModalOpen});};var readDataflowsDetailAgencies=function readDataflowsDetailAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DETAIL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var showDataflowsDetailDsds=function showDataflowsDetailDsds(){return{type:DATAFLOWS_DETAIL_DSDS_SHOW};};var hideDataflowsDetailDsds=function hideDataflowsDetailDsds(){return{type:DATAFLOWS_DETAIL_DSDS_HIDE};};var readDataflowsDetailDsds=function readDataflowsDetailDsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DETAIL_DSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(null,true));};var setDataflowsDetailDsd=function setDataflowsDetailDsd(dsdTriplet){return{type:DATAFLOWS_DETAIL_DSD_SET,dsdTriplet:dsdTriplet};};var unsetDataflowsDetailDsd=function unsetDataflowsDetailDsd(){return{type:DATAFLOWS_DETAIL_DSD_UNSET};};var hideDataflowsDetail=function hideDataflowsDetail(){return{type:DATAFLOWS_DETAIL_HIDE};};var showDataflowsDetailAnnotations=function showDataflowsDetailAnnotations(annotations,triplet){return{type:DATAFLOWS_DETAIL_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideDataflowsDetailAnnotations=function hideDataflowsDetailAnnotations(){return{type:DATAFLOWS_DETAIL_ANNOTATIONS_HIDE};};var showDataflowsDetailLayoutAnnotations=function showDataflowsDetailLayoutAnnotations(annotations,triplet){return{type:DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideDataflowsDetailLayoutAnnotations=function hideDataflowsDetailLayoutAnnotations(){return{type:DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_HIDE};};var deleteDataflowsSelectedDataflows=function deleteDataflowsSelectedDataflows(dataflowTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DATAFLOWS_SELECTED_DATAFLOWS_DELETE,dataflowTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),dataflowTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("Dataflow",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},dataflowTriplets.map(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]));};var showDataflowsDataflowDownload=function showDataflowsDataflowDownload(artefactTriplets,lang){return{type:DATAFLOWS_DATAFLOW_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideDataflowsDataflowDownload=function hideDataflowsDataflowDownload(){return{type:DATAFLOWS_DATAFLOW_DOWNLOAD_HIDE};};var changeDataflowsDataflowDownload=function changeDataflowsDataflowDownload(fields){return{type:DATAFLOWS_DATAFLOW_DOWNLOAD_CHANGE,fields:fields};};var submitDataflowsDataflowDownload=function submitDataflowsDataflowDownload(artefactTriplets,downloadDataflowParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_3__constants_download__["f" /* ARTEFACT_TYPE_DATAFLOW */],downloadDataflowParams.format,downloadDataflowParams.references,downloadDataflowParams.compression,lang),artefactTriplets.map(function(_ref){var id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_3__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_3__constants_download__["f" /* ARTEFACT_TYPE_DATAFLOW */],downloadDataflowParams.format,downloadDataflowParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_3__constants_download__["f" /* ARTEFACT_TYPE_DATAFLOW */],artefactTriplets[0],downloadDataflowParams.format,downloadDataflowParams.references,downloadDataflowParams.compression,lang),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_3__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_3__constants_download__["f" /* ARTEFACT_TYPE_DATAFLOW */],downloadDataflowParams.format,downloadDataflowParams.compression)});};var showDataflowsDataflowClone=function showDataflowsDataflowClone(srcTriplet){return{type:DATAFLOWS_DATAFLOW_CLONE_SHOW,srcTriplet:srcTriplet};};var hideDataflowsDataflowClone=function hideDataflowsDataflowClone(){return{type:DATAFLOWS_DATAFLOW_CLONE_HIDE};};var changeDataflowsDataflowClone=function changeDataflowsDataflowClone(fields){return{type:DATAFLOWS_DATAFLOW_CLONE_CHANGE,fields:fields};};var submitDataflowsDataflowClone=function submitDataflowsDataflowClone(cloneDestTriplet,srcDataflow,annotationsConfig){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOWS_DATAFLOW_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},srcDataflow,cloneDestTriplet,{isFinal:false,annotations:Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["d" /* getFilteredAnnotations */])(srcDataflow.annotations,annotationsConfig),autoAnnotations:[].concat(_toConsumableArray(srcDataflow.annotations||[]),_toConsumableArray(srcDataflow.autoAnnotations||[])).filter(function(annot){return annot.type.toLowerCase()===annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["b" /* AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY */]].toLowerCase()||annot.type.toLowerCase()===__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["a" /* AUTO_ANNOTATION_NONPRODUCTIONDATAFLOW_TYPE */].toLowerCase();})}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["B" /* SDMX_JSON_DATAFLOW_LIST_KEY */]),function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showDataflowsDataflowExport=function showDataflowsDataflowExport(sourceTriplet){return{type:DATAFLOWS_DATAFLOW_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideDataflowsDataflowExport=function hideDataflowsDataflowExport(){return{type:DATAFLOWS_DATAFLOW_EXPORT_HIDE};};var changeDataflowsDataflowExport=function changeDataflowsDataflowExport(fields){return{type:DATAFLOWS_DATAFLOW_EXPORT_CHANGE,fields:fields};};var submitDataflowsDataflowExport=function submitDataflowsDataflowExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOWS_DATAFLOW_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||[]),EnumType:"Dataflow",CopyReferencedArtefact:false,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_6__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideDataflowsDataflowExportReport=function hideDataflowsDataflowExportReport(){return{type:DATAFLOWS_DATAFLOW_EXPORT_REPORT_HIDE};};var readDataflowsDetailDsdForLayoutAnnotations=function readDataflowsDetailDsdForLayoutAnnotations(dsdTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(dsdTriplet,true));};var showDataflowsDataflowOwnership=function showDataflowsDataflowOwnership(dataflowTripletStr){return{type:DATAFLOWS_DATAFLOW_OWNERSHIP_SHOW,dataflowTripletStr:dataflowTripletStr};};var hideDataflowsDataflowOwnership=function hideDataflowsDataflowOwnership(){return{type:DATAFLOWS_DATAFLOW_OWNERSHIP_HIDE};};var readDataflowsDataflowOwnershipUsersRead=function readDataflowsDataflowOwnershipUsersRead(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DATAFLOW_OWNERSHIP_USERS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_110" /* getUsers */])());};var readDataflowsDataflowOwnershipOwnersRead=function readDataflowsDataflowOwnershipOwnersRead(dataflowTripletStr){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_5" /* getDataflowOwnersUrl */])(dataflowTripletStr));};var changeDataflowsDataflowOwnershipOwners=function changeDataflowsDataflowOwnershipOwners(owners){return{type:DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_CHANGE,owners:owners};};var submitDataflowsDataflowOwnership=function submitDataflowsDataflowOwnership(dataflowTripletStr,owners){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_87" /* getSetOwnersUrl */])(),{type:"Dataflow",id:dataflowTripletStr,owners:owners.map(function(username){return{username:username};})},function(t){return{success:t('scenes.metaManager.dataflows.messages.ownership.success')};});};var readDataflowsDataflowParentsAndChildren=function readDataflowsDataflowParentsAndChildren(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideDataflowsDataflowParentsAndChildren=function hideDataflowsDataflowParentsAndChildren(){return{type:DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_HIDE};};var showDataflowsDataflowContentConstraints=function showDataflowsDataflowContentConstraints(dataflowTriplet){return{type:DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_SHOW,dataflowTriplet:dataflowTriplet};};var hideDataflowsDataflowContentConstraints=function hideDataflowsDataflowContentConstraints(){return{type:DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_HIDE};};var readDataflowsDataflowContentConstraints=function readDataflowsDataflowContentConstraints(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_2" /* getDataflowContentConstraintUrl */])(dataflowTriplet));};var showDataflowsDetailLayoutAnnotationsForm=function showDataflowsDetailLayoutAnnotationsForm(){return{type:DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW};};var hideDataflowsDetailLayoutAnnotationsForm=function hideDataflowsDetailLayoutAnnotationsForm(){return{type:DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE};};var submitDataflowsDetailLayoutAnnotationsForm=function submitDataflowsDetailLayoutAnnotationsForm(annotations){return{type:DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT,annotations:annotations};};var resetDataflowsDetailLayoutAnnotationsForm=function resetDataflowsDetailLayoutAnnotationsForm(){return{type:DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET};};var readDataflowsDetailLayoutAnnotationsItemsPage=function readDataflowsDetailLayoutAnnotationsItemsPage(_ref2){var codelistTriplet=_ref2.codelistTriplet,language=_ref2.language,pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc;return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{Id:codelistTriplet.id,AgencyId:codelistTriplet.agencyID,Version:codelistTriplet.version,Lang:language,PageNum:pageNum,PageSize:pageSize,AllSearch:searchText,CodeSearch:filters.id?filters.id:undefined,NameSearch:filters.name?filters.name:undefined,ParentSearch:filters.parent?filters.parent:undefined,SortColumn:sortCol?sortCol:undefined,SortDesc:sortByDesc?sortByDesc:undefined,rebuildDb:false});};var resetDataflowsDetailLayoutAnnotationsItemsPage=function resetDataflowsDetailLayoutAnnotationsItemsPage(){return{type:DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET};};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_PERMISSIONS_USERS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_PERMISSIONS_PERMISSIONS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_PERMISSIONS_USER_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_PERMISSIONS_USER_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_PERMISSIONS_TAB_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_PERMISSIONS_FUNCTIONALITIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_PERMISSIONS_FUNCTIONALITIES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_PERMISSIONS_RULES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_PERMISSIONS_RULES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PERMISSIONS_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PERMISSIONS_AGENCIES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PERMISSIONS_CATEGORISED_CUBES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PERMISSIONS_CATEGORISED_CUBES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_PERMISSIONS_PERMISSIONS_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_PERMISSIONS_SYNCHRONIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return readSetPermissionsUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return readSetPermissionsPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return editSetPermissionsUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return hideSetPermissionsUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return changeSetPermissionsTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return readSetPermissionsFunctionalities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return readSetPermissionsRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return readSetPermissionsAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return readSetPermissionsCategorisedCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return changeSetPermissionsFunctionalitiesPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return changeSetPermissionsRulesPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return changeSetPermissionsAgenciesPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return changeSetPermissionsCategorisedCubesPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return submitSetPermissionsPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return synchronizeSetPermissions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var SET_PERMISSIONS_USERS_READ='SET_PERMISSIONS_USERS_READ';var SET_PERMISSIONS_PERMISSIONS_READ='SET_PERMISSIONS_PERMISSIONS_READ';var SET_PERMISSIONS_USER_EDIT='SET_PERMISSIONS_USER_EDIT';var SET_PERMISSIONS_USER_HIDE='SET_PERMISSIONS_USER_HIDE';var SET_PERMISSIONS_TAB_CHANGE='SET_PERMISSIONS_TAB_CHANGE';var SET_PERMISSIONS_FUNCTIONALITIES_READ='SET_PERMISSIONS_FUNCTIONALITIES_READ';var SET_PERMISSIONS_FUNCTIONALITIES_CHANGE='SET_PERMISSIONS_FUNCTIONALITIES_CHANGE';var SET_PERMISSIONS_RULES_READ='SET_PERMISSIONS_RULES_READ';var SET_PERMISSIONS_RULES_CHANGE='SET_PERMISSIONS_RULES_CHANGE';var SET_PERMISSIONS_AGENCIES_READ='SET_PERMISSIONS_AGENCIES_READ';var SET_PERMISSIONS_AGENCIES_CHANGE='SET_PERMISSIONS_AGENCIES_CHANGE';var SET_PERMISSIONS_CATEGORISED_CUBES_READ='SET_PERMISSIONS_CATEGORISED_CUBES_READ';var SET_PERMISSIONS_CATEGORISED_CUBES_CHANGE='SET_PERMISSIONS_CATEGORISED_CUBES_CHANGE';var SET_PERMISSIONS_PERMISSIONS_SUBMIT='SET_PERMISSIONS_PERMISSIONS_SUBMIT';var SET_PERMISSIONS_SYNCHRONIZE='SET_PERMISSIONS_SYNCHRONIZE';var readSetPermissionsUsers=function readSetPermissionsUsers(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(SET_PERMISSIONS_USERS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_110" /* getUsers */])());};var readSetPermissionsPermissions=function readSetPermissionsPermissions(username){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(SET_PERMISSIONS_PERMISSIONS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_74" /* getReadPermissionsUrl */])(username));};var editSetPermissionsUser=function editSetPermissionsUser(username,email){return{type:SET_PERMISSIONS_USER_EDIT,username:username,email:email};};var hideSetPermissionsUser=function hideSetPermissionsUser(){return{type:SET_PERMISSIONS_USER_HIDE};};var changeSetPermissionsTab=function changeSetPermissionsTab(tab){return{type:SET_PERMISSIONS_TAB_CHANGE,tab:tab};};var readSetPermissionsFunctionalities=function readSetPermissionsFunctionalities(menu){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(SET_PERMISSIONS_FUNCTIONALITIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["i" /* getAllFunctionalitiesUrl */])()),{menu:menu});};var readSetPermissionsRules=function readSetPermissionsRules(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(SET_PERMISSIONS_RULES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["j" /* getAllRulesUrl */])());};var readSetPermissionsAgencies=function readSetPermissionsAgencies(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(SET_PERMISSIONS_AGENCIES_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["f" /* getAllAgenciesUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])()]);};var readSetPermissionsCategorisedCubes=function readSetPermissionsCategorisedCubes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(SET_PERMISSIONS_CATEGORISED_CUBES_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["h" /* getAllCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])()]);};var changeSetPermissionsFunctionalitiesPermissions=function changeSetPermissionsFunctionalitiesPermissions(functionalitiesPermissions){return{type:SET_PERMISSIONS_FUNCTIONALITIES_CHANGE,functionalitiesPermissions:functionalitiesPermissions};};var changeSetPermissionsRulesPermissions=function changeSetPermissionsRulesPermissions(rulesPermissions){return{type:SET_PERMISSIONS_RULES_CHANGE,rulesPermissions:rulesPermissions};};var changeSetPermissionsAgenciesPermissions=function changeSetPermissionsAgenciesPermissions(agenciesPermissions){return{type:SET_PERMISSIONS_AGENCIES_CHANGE,agenciesPermissions:agenciesPermissions};};var changeSetPermissionsCategorisedCubesPermissions=function changeSetPermissionsCategorisedCubesPermissions(categorisedCubesPermissions){return{type:SET_PERMISSIONS_CATEGORISED_CUBES_CHANGE,categorisedCubesPermissions:categorisedCubesPermissions};};var submitSetPermissionsPermissions=function submitSetPermissionsPermissions(username,permissions,token){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(SET_PERMISSIONS_PERMISSIONS_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_91" /* getSubmitPermissionsUrl */])(),Object.assign({},permissions,{username:username,token:token}),function(t){return{success:t('scenes.manageUsers.setPermissions.messages.permissionsSubmit.success')};});};var synchronizeSetPermissions=function synchronizeSetPermissions(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(SET_PERMISSIONS_SYNCHRONIZE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_94" /* getSynchronizeAuthDBUrl */])());};

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return AGENCY_SCHEMES_LIST_AGENCY_SCHEMES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return AGENCY_SCHEMES_DETAIL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_VIEW_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return AGENCY_SCHEMES_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return AGENCY_SCHEMES_DETAIL_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return AGENCY_SCHEMES_DETAIL_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return AGENCY_SCHEMES_SELECTED_AGENCY_SCHEMES_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_LANGUAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_REPORT_HIDE; });
/* unused harmony export AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ADD_TO_CONFIG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return readAgencySchemesListAgencySchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return createAgencySchemesAgencyScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return editAgencySchemesAgencyScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return deleteAgencySchemesAgencyScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return readAgencySchemesDetailAgencyScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return changeAgencySchemesDetailAgencyScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return submitAgencySchemesDetailAgencySchemeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return submitAgencySchemesDetailAgencySchemeUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return readAgencySchemesDetailAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return changeAgencySchemesDetailItemsViewMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return createAgencySchemesDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return editAgencySchemesDetailItemsItemDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return changeAgencySchemesDetailItemsItemDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return submitAgencySchemesDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return hideAgencySchemesDetailItemsItemDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return deleteAgencySchemesDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return selectAgencySchemesDetailsItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return showAgencySchemesDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return hideAgencySchemesDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return changeAgencySchemesDetailItemsImportForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return uploadAgencySchemesDetailItemsImportFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return importAgencySchemesDetailItemsImportFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return hideAgencySchemesDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return showAgencySchemesDetailItemsItemAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return hideAgencySchemesDetailItemsItemAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return showAgencySchemesDetailItemsItemLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return hideAgencySchemesDetailItemsItemLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return showAgencySchemesDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return hideAgencySchemesDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return deleteAgencySchemesSelectedAgencySchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return dropAgencySchemesDetailItemsItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return changeAgencySchemesDetailAgencySchemeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return hideAgencySchemeDetailItemsItemDuplicateItemError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return cutAgencySchemesDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return pasteAgencySchemesDetailItemsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return showAgencySchemesAgencySchemeDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return hideAgencySchemesAgencySchemeDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return changeAgencySchemesAgencySchemeDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return downloadAgencySchemesAgencyScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return showAgencySchemesAgencySchemeClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return hideAgencySchemesAgencySchemeClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return changeAgencySchemesAgencySchemeClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return submitAgencySchemesAgencySchemeClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return showAgencySchemesAgencySchemeExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return hideAgencySchemesAgencySchemeExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return changeAgencySchemesAgencySchemeExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return submitAgencySchemesAgencySchemeExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return hideAgencySchemesAgencySchemeExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return showAgencySchemesDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return hideAgencySchemesDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return uploadAgencySchemesDetailItemsImportFormCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return readAgencySchemesDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return addAgencyToConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middlewares_authentication_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_infinite_scroll_table_contants__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_artefact_export_form__ = __webpack_require__(51);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var AGENCY_SCHEMES_LIST_AGENCY_SCHEMES_READ='AGENCY_SCHEMES_LIST_AGENCY_SCHEMES_READ';var AGENCY_SCHEMES_AGENCY_SCHEME_CREATE='AGENCY_SCHEMES_AGENCY_SCHEME_CREATE';var AGENCY_SCHEMES_AGENCY_SCHEME_EDIT='AGENCY_SCHEMES_AGENCY_SCHEME_EDIT';var AGENCY_SCHEMES_AGENCY_SCHEME_DELETE='AGENCY_SCHEMES_AGENCY_SCHEME_DELETE';var AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_READ='AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_READ';var AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CHANGE='AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CHANGE';var AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CREATE_SUBMIT='AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CREATE_SUBMIT';var AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_UPDATE_SUBMIT='AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_UPDATE_SUBMIT';var AGENCY_SCHEMES_DETAIL_AGENCIES_READ='AGENCY_SCHEMES_DETAIL_AGENCIES_READ';var AGENCY_SCHEMES_DETAIL_ITEMS_VIEW_MODE_CHANGE='AGENCY_SCHEMES_DETAIL_ITEMS_VIEW_MODE_CHANGE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CREATE='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CREATE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_EDIT='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_EDIT';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_CHANGE='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_CHANGE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_HIDE='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_HIDE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_SELECT='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_SELECT';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_SHOW='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_SHOW';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_HIDE='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_HIDE';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CHANGE='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CHANGE';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD';var AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT='AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT';var AGENCY_SCHEMES_DETAIL_HIDE='AGENCY_SCHEMES_DETAIL_HIDE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE';var AGENCY_SCHEMES_DETAIL_ANNOTATIONS_SHOW='AGENCY_SCHEMES_DETAIL_ANNOTATIONS_SHOW';var AGENCY_SCHEMES_DETAIL_ANNOTATIONS_HIDE='AGENCY_SCHEMES_DETAIL_ANNOTATIONS_HIDE';var AGENCY_SCHEMES_SELECTED_AGENCY_SCHEMES_DELETE='AGENCY_SCHEMES_SELECTED_AGENCY_SCHEMES_DELETE';var AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_LANGUAGE_CHANGE='AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_LANGUAGE_CHANGE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CUT='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CUT';var AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_SHOW='AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_SHOW';var AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_HIDE='AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_HIDE';var AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_CHANGE='AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_CHANGE';var AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD='AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD';var AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SHOW='AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SHOW';var AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_HIDE='AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_HIDE';var AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_CHANGE='AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_CHANGE';var AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SUBMIT='AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SUBMIT';var AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SHOW='AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SHOW';var AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_HIDE='AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_HIDE';var AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_CHANGE='AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_CHANGE';var AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SUBMIT='AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SUBMIT';var AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_REPORT_HIDE='AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_REPORT_HIDE';var AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ADD_TO_CONFIG='AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ADD_TO_CONFIG';var readAgencySchemesListAgencySchemes=function readAgencySchemesListAgencySchemes(){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(AGENCY_SCHEMES_LIST_AGENCY_SCHEMES_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["e" /* getAgencySchemeUrl */])());};var createAgencySchemesAgencyScheme=function createAgencySchemesAgencyScheme(defaultItemsViewMode){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_CREATE,defaultItemsViewMode:defaultItemsViewMode};};var editAgencySchemesAgencyScheme=function editAgencySchemesAgencyScheme(agencySchemeTriplet,defaultItemsViewMode){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_EDIT,agencySchemeTriplet:agencySchemeTriplet,defaultItemsViewMode:defaultItemsViewMode};};var deleteAgencySchemesAgencyScheme=function deleteAgencySchemesAgencyScheme(agencySchemeTriplet){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["j" /* deleteRequest */])(AGENCY_SCHEMES_AGENCY_SCHEME_DELETE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_11" /* getDeleteArtefactUrl */])("AgencyScheme",agencySchemeTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var readAgencySchemesDetailAgencyScheme=function readAgencySchemesDetailAgencyScheme(agencySchemeTriplet,itemsOrderAnnotationType,lang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["e" /* getAgencySchemeUrl */])(agencySchemeTriplet)),{itemsOrderAnnotationType:itemsOrderAnnotationType,lang:lang});};var changeAgencySchemesDetailAgencyScheme=function changeAgencySchemesDetailAgencyScheme(fields){return{type:AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CHANGE,fields:fields};};var submitAgencySchemesDetailAgencySchemeCreate=function submitAgencySchemesDetailAgencySchemeCreate(agencyScheme,agencySchemeTriplet){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(agencyScheme)],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["q" /* SDMX_JSON_AGENCY_SCHEME_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.agencySchemes.messages.create.success')};}),{agencySchemeTriplet:agencySchemeTriplet});};var submitAgencySchemesDetailAgencySchemeUpdate=function submitAgencySchemesDetailAgencySchemeUpdate(agencyScheme,itemsTree,itemsOrderAnnotationType){var ret=[];var root=[{isRoot:true,agencies:itemsTree}];if(itemsTree){Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"agencies",function(node){if(!node.isRoot){var retNode=Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["Z" /* getSdmxJsonStructureFromItem */])(node);retNode.parent=undefined;retNode.annotations=agencyScheme.isFinal?retNode.annotations:Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["P" /* removeOrderAnnotation */])(retNode.annotations,itemsOrderAnnotationType);ret.push(retNode);}return node;});agencyScheme=Object.assign({},agencyScheme,{agencies:ret});}return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["n" /* putRequest */])(AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(agencyScheme)],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["q" /* SDMX_JSON_AGENCY_SCHEME_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.agencySchemes.messages.update.success')};}),{itemsTree:itemsTree});};var readAgencySchemesDetailAgencies=function readAgencySchemesDetailAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(AGENCY_SCHEMES_DETAIL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var changeAgencySchemesDetailItemsViewMode=function changeAgencySchemesDetailItemsViewMode(viewMode){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_VIEW_MODE_CHANGE,viewMode:viewMode};};var createAgencySchemesDetailsItemsItem=function createAgencySchemesDetailsItemsItem(parentId,order,lang,itemsOrderAnnotationType){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CREATE,parentId:parentId,order:order,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var editAgencySchemesDetailItemsItemDetail=function editAgencySchemesDetailItemsItemDetail(item){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_EDIT,item:item};};var changeAgencySchemesDetailItemsItemDetail=function changeAgencySchemesDetailItemsItemDetail(fields,lang,itemsOrderAnnotationType){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_CHANGE,fields:fields,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var submitAgencySchemesDetailItemsItem=function submitAgencySchemesDetailItemsItem(agencyScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"agencies",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.agencies.push(cutItem);parentNode.agencies.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}if(isItemEditMode||!Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"agencies",function(node){return node.id===item.id;})){var root=[{isRoot:true,agencies:itemsTree}];itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"agencies",function(node){if(node.id===item.parent||node.id===undefined&&item.parent===null){if(isItemEditMode){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(node.agencies,function(child){return child.id===item.id;})){node.agencies.push(item);}node.agencies=node.agencies.map(function(child){if(child.id===item.id){if(item.order&&child.order[lang]!==item.order[lang]){var tempItem=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(item);tempItem.order[lang].length>0?Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(tempItem,String(Number(item.order[lang])-0.1),itemsOrderAnnotationType,lang):Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(tempItem,String(Number.MAX_VALUE),itemsOrderAnnotationType,lang);return tempItem;}return item;}else{return child;}});}else{item.order[lang].length>0?Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(item,String(Number(item.order[lang])-0.1),itemsOrderAnnotationType,lang):Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(item,String(Number.MAX_VALUE),itemsOrderAnnotationType,lang);node.agencies.push(item);}node.agencies.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{node.agencies=node.agencies.filter(function(c){return c.id!==item.id;});}return node;})[0].agencies;// if (isNormalizeNeeded) // uncomment for performance improvement
Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["b" /* normalizeItemsOrder */])(itemsTree,"agencies",lang,itemsOrderAnnotationType);return submitAgencySchemesDetailAgencySchemeUpdate(agencyScheme,itemsTree,itemsOrderAnnotationType);}else{return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW};}};var hideAgencySchemesDetailItemsItemDetail=function hideAgencySchemesDetailItemsItemDetail(){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_HIDE};};var deleteAgencySchemesDetailsItemsItem=function deleteAgencySchemesDetailsItemsItem(agencyScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"agencies",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.agencies.push(cutItem);parentNode.agencies.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}var root=[{isRoot:true,agencies:itemsTree}];itemsTree=item.parent?Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"agencies",function(node){if(node.id===item.parent){node.agencies=node.agencies.filter(function(child){return child.id!==item.id;});}return node;})[0].agencies:itemsTree.filter(function(node){return node.id!==item.id;});return submitAgencySchemesDetailAgencySchemeUpdate(agencyScheme,itemsTree,itemsOrderAnnotationType);};var selectAgencySchemesDetailsItemsItem=function selectAgencySchemesDetailsItemsItem(id){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_SELECT,id:id};};var showAgencySchemesDetailItemsImportForm=function showAgencySchemesDetailItemsImportForm(){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_SHOW};};var hideAgencySchemesDetailItemsImportForm=function hideAgencySchemesDetailItemsImportForm(){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_HIDE};};var changeAgencySchemesDetailItemsImportForm=function changeAgencySchemesDetailItemsImportForm(fields){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CHANGE,fields:fields};};var uploadAgencySchemesDetailItemsImportFormFile=function uploadAgencySchemesDetailItemsImportFormFile(agencyScheme,itemsImportForm){var formData=new FormData();formData.append('file',itemsImportForm.file);formData.append('CustomData',JSON.stringify({type:'agencyScheme',identity:{ID:agencyScheme.id,Agency:agencyScheme.agencyID,Version:agencyScheme.version},lang:itemsImportForm.language,firstRowHeader:itemsImportForm.hasHeader,columns:itemsImportForm.hasHeader?{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?3:-1,order:itemsImportForm.hasOrderCol?4:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?5:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?6:-1}:{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?2+itemsImportForm.hasDescriptionCol:-1,order:itemsImportForm.hasOrderCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol+itemsImportForm.hasLayoutAnnotationFullNameCol:-1},textSeparator:itemsImportForm.separator,textDelimiter:itemsImportForm.delimiter}));return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["u" /* getCheckImportedFileCsvItemUrl */])(),formData,function(t){return{success:t('commons.artefact.messages.itemsImport.fileUpload.success')};});};var importAgencySchemesDetailItemsImportFormFile=function importAgencySchemesDetailItemsImportFormFile(agencyScheme,itemsImportForm){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_49" /* getImportFileCsvItemUrl */])(),{hashImport:itemsImportForm.hash,type:'agencyScheme',identity:{ID:agencyScheme.id,Agency:agencyScheme.agencyID,Version:agencyScheme.version},lang:itemsImportForm.language,firstRowHeader:itemsImportForm.hasHeader,columns:itemsImportForm.hasHeader?{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?3:-1,order:itemsImportForm.hasOrderCol?4:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?5:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?6:-1}:{id:0,name:1,description:itemsImportForm.hasDescriptionCol?2:-1,parent:itemsImportForm.hasParentCol?2+itemsImportForm.hasDescriptionCol:-1,order:itemsImportForm.hasOrderCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol:-1,fullName:itemsImportForm.hasLayoutAnnotationFullNameCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol:-1,isDefault:itemsImportForm.hasLayoutAnnotationIsDefaultCol?2+itemsImportForm.hasDescriptionCol+itemsImportForm.hasParentCol+itemsImportForm.hasOrderCol+itemsImportForm.hasLayoutAnnotationFullNameCol:-1},textSeparator:itemsImportForm.separator,textDelimiter:itemsImportForm.delimiter},function(t){return{success:t('commons.artefact.messages.itemsImport.fileImport.success')};});};var hideAgencySchemesDetail=function hideAgencySchemesDetail(){return{type:AGENCY_SCHEMES_DETAIL_HIDE};};var showAgencySchemesDetailItemsItemAnnotations=function showAgencySchemesDetailItemsItemAnnotations(annotations){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW,annotations:annotations};};var hideAgencySchemesDetailItemsItemAnnotations=function hideAgencySchemesDetailItemsItemAnnotations(){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE};};var showAgencySchemesDetailItemsItemLayoutAnnotations=function showAgencySchemesDetailItemsItemLayoutAnnotations(annotations){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW,annotations:annotations};};var hideAgencySchemesDetailItemsItemLayoutAnnotations=function hideAgencySchemesDetailItemsItemLayoutAnnotations(){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE};};var showAgencySchemesDetailAnnotations=function showAgencySchemesDetailAnnotations(annotations,triplet){return{type:AGENCY_SCHEMES_DETAIL_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideAgencySchemesDetailAnnotations=function hideAgencySchemesDetailAnnotations(){return{type:AGENCY_SCHEMES_DETAIL_ANNOTATIONS_HIDE};};var deleteAgencySchemesSelectedAgencySchemes=function deleteAgencySchemesSelectedAgencySchemes(agencySchemeTriplets){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["i" /* allRequest */])(AGENCY_SCHEMES_SELECTED_AGENCY_SCHEMES_DELETE,agencySchemeTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),agencySchemeTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_11" /* getDeleteArtefactUrl */])("AgencyScheme",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},agencySchemeTriplets.map(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]),true);};var dropAgencySchemesDetailItemsItems=function dropAgencySchemesDetailItemsItems(item,newParent,newOrder,agencyScheme,itemsTree,itemsOrderAnnotationType,lang,cutItem,t){if(cutItem){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"agencies",function(node){return node.id===cutItem.parent;});if(parentNode){parentNode.agencies.push(cutItem);parentNode.agencies.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(cutItem);itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:t("commons.artefact.messages.nodeRestored.title")});}var root=[{isRoot:true,agencies:itemsTree}];itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["h" /* getMappedTree */])(root,"agencies",function(node){if((node.id===newParent||node.id===null&&newParent===undefined||node.id===undefined&&newParent===null)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(node.agencies,function(child){return child.id===item.id;})){node.agencies.push(Object.assign({},item,{parent:node.id}));}node.agencies.forEach(function(child){if(child.id===item.id){if(!(node.id===newParent||node.id===null&&newParent===undefined||node.id===undefined&&newParent===null)){node.agencies=node.agencies.filter(function(c){return c.id!==child.id;});}else{Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["j" /* updateItemOrder */])(child,newOrder,itemsOrderAnnotationType,lang);node.agencies.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}}});return node;})[0].agencies;Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["b" /* normalizeItemsOrder */])(itemsTree,"agencies",lang,itemsOrderAnnotationType);return submitAgencySchemesDetailAgencySchemeUpdate(agencyScheme,itemsTree,itemsOrderAnnotationType);};var changeAgencySchemesDetailAgencySchemeLanguage=function changeAgencySchemesDetailAgencySchemeLanguage(lang,itemsOrderAnnotationType){return{type:AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_LANGUAGE_CHANGE,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType};};var hideAgencySchemeDetailItemsItemDuplicateItemError=function hideAgencySchemeDetailItemsItemDuplicateItemError(){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE};};var cutAgencySchemesDetailItemsItem=function cutAgencySchemesDetailItemsItem(item){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CUT,item:item};};var pasteAgencySchemesDetailItemsItem=function pasteAgencySchemesDetailItemsItem(cutItem,newParent,pasteAfter,agencyScheme,itemsTree,lang,itemsOrderAnnotationType){if(pasteAfter){var parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"agencies",function(node){return node.id===pasteAfter.parent;});if(parentNode){parentNode.agencies.push(Object.assign({},cutItem,{parent:parentNode.id,order:Object.assign({},cutItem.order,_defineProperty({},lang,String(Number(pasteAfter.order[lang])+0.1)))}));parentNode.agencies.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}else{itemsTree.push(Object.assign({},cutItem,{parent:null,order:Object.assign({},cutItem.order,_defineProperty({},lang,String(Number(pasteAfter.order[lang])+0.1)))}));itemsTree.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}}else{var _parentNode=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["k" /* getNode */])(itemsTree,"agencies",function(node){return node.id===newParent.id;});_parentNode.agencies.push(Object.assign({},cutItem,{parent:_parentNode.id}));_parentNode.agencies.sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["h" /* itemsOrderCompare */])(a,b,lang);});}return submitAgencySchemesDetailAgencySchemeUpdate(agencyScheme,itemsTree.splice(0),itemsOrderAnnotationType);};var showAgencySchemesAgencySchemeDownload=function showAgencySchemesAgencySchemeDownload(artefactTriplets,lang){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideAgencySchemesAgencySchemeDownload=function hideAgencySchemesAgencySchemeDownload(){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_HIDE};};var changeAgencySchemesAgencySchemeDownload=function changeAgencySchemesAgencySchemeDownload(fields){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_CHANGE,fields:fields};};var downloadAgencySchemesAgencyScheme=function downloadAgencySchemesAgencyScheme(artefactTriplets,downloadAgencySchemeParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_9__constants_download__["a" /* ARTEFACT_TYPE_AGENCY_SCHEME */],downloadAgencySchemeParams.format,false,downloadAgencySchemeParams.compression,lang),artefactTriplets.map(function(_ref){var id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_9__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_9__constants_download__["a" /* ARTEFACT_TYPE_AGENCY_SCHEME */],downloadAgencySchemeParams.format,downloadAgencySchemeParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["l" /* getRequest */])(AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_9__constants_download__["a" /* ARTEFACT_TYPE_AGENCY_SCHEME */],artefactTriplets[0],downloadAgencySchemeParams.format,false,downloadAgencySchemeParams.compression,downloadAgencySchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadAgencySchemeParams.csvLanguage:lang,downloadAgencySchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadAgencySchemeParams.csvSeparator:null,downloadAgencySchemeParams.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]?downloadAgencySchemeParams.csvDelimiter:null),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_9__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_9__constants_download__["a" /* ARTEFACT_TYPE_AGENCY_SCHEME */],downloadAgencySchemeParams.format,downloadAgencySchemeParams.compression,downloadAgencySchemeParams.csvLanguage)});};var showAgencySchemesAgencySchemeClone=function showAgencySchemesAgencySchemeClone(srcTriplet){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SHOW,srcTriplet:srcTriplet};};var hideAgencySchemesAgencySchemeClone=function hideAgencySchemesAgencySchemeClone(){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_HIDE};};var changeAgencySchemesAgencySchemeClone=function changeAgencySchemesAgencySchemeClone(fields){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_CHANGE,fields:fields};};var submitAgencySchemesAgencySchemeClone=function submitAgencySchemesAgencySchemeClone(cloneDestTriplet,srcAgencyScheme,srcAgencySchemeItemsTree,annotationsConfig){var agencies=undefined;if(srcAgencySchemeItemsTree){agencies=srcAgencySchemeItemsTree.map(function(node){node.parent=undefined;return Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["Z" /* getSdmxJsonStructureFromItem */])(node);});}return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},srcAgencyScheme,cloneDestTriplet,{agencies:agencies,isFinal:false,annotations:Object(__WEBPACK_IMPORTED_MODULE_7__utils_artefacts__["d" /* getFilteredAnnotations */])(srcAgencyScheme.annotations,annotationsConfig),autoAnnotations:null}))],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["q" /* SDMX_JSON_AGENCY_SCHEME_LIST_KEY */]),function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showAgencySchemesAgencySchemeExport=function showAgencySchemesAgencySchemeExport(sourceTriplet){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideAgencySchemesAgencySchemeExport=function hideAgencySchemesAgencySchemeExport(){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_HIDE};};var changeAgencySchemesAgencySchemeExport=function changeAgencySchemesAgencySchemeExport(fields){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_CHANGE,fields:fields};};var submitAgencySchemesAgencySchemeExport=function submitAgencySchemesAgencySchemeExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||[]),EnumType:"AgencyScheme",CopyReferencedArtefact:false,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_13__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideAgencySchemesAgencySchemeExportReport=function hideAgencySchemesAgencySchemeExportReport(){return{type:AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_REPORT_HIDE};};var showAgencySchemesDetailItemsImportFormAllCsvRows=function showAgencySchemesDetailItemsImportFormAllCsvRows(){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW};};var hideAgencySchemesDetailItemsImportFormAllCsvRows=function hideAgencySchemesDetailItemsImportFormAllCsvRows(){return{type:AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE};};var uploadAgencySchemesDetailItemsImportFormCsv=function uploadAgencySchemesDetailItemsImportFormCsv(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),fileFormData);};var readAgencySchemesDetailItemsImportFormAllCsvRows=function readAgencySchemesDetailItemsImportFormAllCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,filePath,null,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var addAgencyToConfig=function addAgencyToConfig(superUserUsername,endpointId,agency){var addAgencyToConfigAction=Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["m" /* postRequest */])(AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ADD_TO_CONFIG,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["c" /* getAddAgencyToConfigUrl */])(endpointId),{Id:agency.id,Name:agency[__WEBPACK_IMPORTED_MODULE_12__components_infinite_scroll_table_contants__["j" /* DATA_INDEX_ORIGINAL_ROW */]].name},function(t){return{success:t('scenes.metaManager.agencySchemes.messages.addAgencyToConfig.success')};});if(superUserUsername){return addAgencyToConfigAction;}else{return{type:__WEBPACK_IMPORTED_MODULE_11__middlewares_authentication_actions__["a" /* SUPER_USER_LOGIN_FORM_SHOW */],onSuccessAction:addAgencyToConfigAction};}};

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flag_icon_css_css_flag_icon_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_flag_icon_css_css_flag_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_languages__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_css__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,maxDescriptionLength:state.config.dataManagement.maxDescriptionLength};};/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var MultilanguageZoomableTextArea=function(_React$Component){_inherits(MultilanguageZoomableTextArea,_React$Component);function MultilanguageZoomableTextArea(props){_classCallCheck(this,MultilanguageZoomableTextArea);var _this=_possibleConstructorReturn(this,(MultilanguageZoomableTextArea.__proto__||Object.getPrototypeOf(MultilanguageZoomableTextArea)).call(this,props));_this.state=MultilanguageZoomableTextArea.getInitState(props);_this.callOnChange=_this.callOnChange.bind(_this);_this.setLanguage=_this.setLanguage.bind(_this);_this.setValueForLanguage=_this.setValueForLanguage.bind(_this);_this.showModal=_this.showModal.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.callOnBlur=_this.callOnBlur.bind(_this);return _this;}_createClass(MultilanguageZoomableTextArea,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){if(this.props.disableMaxLength){this.props.onChange(value);}else{if(value[this.state.language].length>this.props.maxDescriptionLength){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:this.props.t('commons.alerts.fieldTooLong.title'),content:this.props.t('commons.alerts.fieldTooLong.content',{maxLen:this.props.maxDescriptionLength})});}else{this.props.onChange(value);}}}}},{key:'callOnBlur',value:function callOnBlur(){if(this.props.onBlur){if(this.props.disableMaxLength){this.props.onBlur(this.state.value);}else{if(this.state.value[this.state.language].length>this.props.maxDescriptionLength){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:this.props.t('commons.alerts.fieldTooLong.title'),content:this.props.t('commons.alerts.fieldTooLong.content',{maxLen:this.props.maxDescriptionLength})});}else{this.props.onBlur(this.state.value);}}}}},{key:'setLanguage',value:function setLanguage(lang){var state=Object.assign({},this.state);state.language=lang;this.setState(state);this.callOnChange(state.value);}},{key:'setValueForLanguage',value:function setValueForLanguage(newValue,language){var state=Object.assign({},this.state);state.value[language]=newValue;this.setState(state);this.callOnChange(state.value);}},{key:'showModal',value:function showModal(){this.setState({isModalVisible:true});}},{key:'hideModal',value:function hideModal(){this.setState({isModalVisible:false});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,disabled=_props.disabled,dataLanguages=_props.dataLanguages,singleLine=_props.singleLine;var _state=this.state,value=_state.value,isModalVisible=_state.isModalVisible,language=_state.language;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(contextDataLanguage){var lang=contextDataLanguage||language;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a.Group,{compact:true,className:'multilanguage-zoomable-textarea__input-group',style:{position:"relative"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{icon:'zoom-in',style:{position:"absolute",height:"100%"},onClick:_this2.showModal}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a.TextArea,{autosize:singleLine?{minRows:1,maxRows:1}:{maxRows:3},value:value[lang],onChange:function onChange(e){return _this2.setValueForLanguage(e.target.value,lang);},onBlur:_this2.callOnBlur,title:value[lang],disabled:disabled,style:Object.assign({},_this2.props.style,{width:contextDataLanguage?'calc(100% - 32px)':'calc(100% - 132px)',resize:'none',left:32})}),!contextDataLanguage&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{value:lang,onChange:_this2.setLanguage,style:{width:100,position:"absolute",height:"100%",right:0}},value&&Object.keys(value).map(function(lang){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:lang,value:lang,title:Object(__WEBPACK_IMPORTED_MODULE_15__utils_languages__["c" /* getLanguageLabel */])(t,lang)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i',{className:'flag-icon '+Object(__WEBPACK_IMPORTED_MODULE_15__utils_languages__["b" /* getLanguageFlagIconCss */])(lang,dataLanguages),style:{marginRight:8}}),lang!==null?lang.toUpperCase():null);}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["b" /* DataLanguageProvider */],{value:lang},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__enhanced_modal__["a" /* default */],{visible:isModalVisible,onCancel:_this2.hideModal,footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(contextDataLanguage){var lang=contextDataLanguage||language;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return _this2.setValueForLanguage("",lang);},icon:'delete'},t('components.multilanguageZoomableTextarea.modal.reset')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:_this2.hideModal,icon:'zoom-out'},t('components.multilanguageZoomableTextarea.modal.close')));}),width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_MD"],withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(contextDataLanguage){var lang=contextDataLanguage||language;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{height:460}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a.TextArea,{value:value[lang],onChange:function onChange(e){return _this2.setValueForLanguage(e.target.value,lang);},onBlur:_this2.callOnBlur,title:value[lang],disabled:disabled,style:Object.assign({},_this2.props.style,{resize:'none',width:"100%",height:"100%"})}));}))));});}}],[{key:'getInitState',value:function getInitState(props){return{value:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.fromPairs(props.dataLanguages.map(function(_ref){var code=_ref.code;return[code,''];})),language:(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.find(props.dataLanguages,function(_ref2){var code=_ref2.code;return code===props.appLanguage;})||{}).code||'en',isModalVisible:false,initialDefaultValue:null};}},{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){if(props.defaultValue!==null&&props.defaultValue!==undefined&&state.initialDefaultValue===null){return{value:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.merge(MultilanguageZoomableTextArea.getInitState(props).value,props.defaultValue),initialDefaultValue:props.defaultValue};}else if(props.value!==null&&props.value!==undefined){return{value:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.merge(MultilanguageZoomableTextArea.getInitState(props).value,props.value)};}else if(state.initialDefaultValue!==null||props.defaultValue===null&&props.value===undefined){return state;}else{return Object.assign({},MultilanguageZoomableTextArea.getInitState(props),{isModalVisible:state.isModalVisible});}}}]);return MultilanguageZoomableTextArea;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps))(MultilanguageZoomableTextArea));

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _default = _interopRequireDefault(__webpack_require__(263));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LocaleReceiver =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocaleReceiver, _React$Component);

  function LocaleReceiver() {
    _classCallCheck(this, LocaleReceiver);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocaleReceiver).apply(this, arguments));
  }

  _createClass(LocaleReceiver, [{
    key: "getLocale",
    value: function getLocale() {
      var _this$props = this.props,
          componentName = _this$props.componentName,
          defaultLocale = _this$props.defaultLocale;
      var locale = defaultLocale || _default["default"][componentName || 'global'];
      var antLocale = this.context.antLocale;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _extends({}, typeof locale === 'function' ? locale() : locale, localeFromContext || {});
    }
  }, {
    key: "getLocaleCode",
    value: function getLocaleCode() {
      var antLocale = this.context.antLocale;
      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

      if (antLocale && antLocale.exist && !localeCode) {
        return _default["default"].locale;
      }

      return localeCode;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.getLocale(), this.getLocaleCode());
    }
  }]);

  return LocaleReceiver;
}(React.Component);

exports["default"] = LocaleReceiver;
LocaleReceiver.defaultProps = {
  componentName: 'global'
};
LocaleReceiver.contextTypes = {
  antLocale: PropTypes.object
};

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(643);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(649);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(650);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(652);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(656);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(269);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(658);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(662);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(663);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(664);
/* unused harmony reexport withRouter */





























/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(173);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUPER_USER_LOGIN_FORM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUPER_USER_LOGIN_FORM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUPER_USER_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showSuperUserLoginForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return submitSuperUserLoginForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return logoutSuperUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var SUPER_USER_LOGIN_FORM_SUBMIT='SUPER_USER_LOGIN_FORM_SUBMIT';var SUPER_USER_LOGIN_FORM_SHOW='SUPER_USER_LOGIN_FORM_SHOW';var SUPER_USER_LOGOUT='SUPER_USER_LOGOUT';var showSuperUserLoginForm=function showSuperUserLoginForm(){return{type:SUPER_USER_LOGIN_FORM_SHOW};};var submitSuperUserLoginForm=function submitSuperUserLoginForm(username,password,onSuccessAction){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__api_actions__["m" /* postRequest */])(SUPER_USER_LOGIN_FORM_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_92" /* getSuperUserLoginUrl */])(),{Username:username,Password:btoa(password)}),{username:username,onSuccessAction:onSuccessAction});};var logoutSuperUser=function logoutSuperUser(){return Object(__WEBPACK_IMPORTED_MODULE_0__api_actions__["m" /* postRequest */])(SUPER_USER_LOGOUT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_93" /* getSuperUserLogoutUrl */])());};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(120);
var createDesc = __webpack_require__(177);
module.exports = __webpack_require__(129) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(148);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(389);
var defined = __webpack_require__(278);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(398)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyFromChildrenIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenuIdFromSubMenuEventKey;
/* harmony export (immutable) */ __webpack_exports__["e"] = loopMenuItem;
/* harmony export (immutable) */ __webpack_exports__["f"] = loopMenuItemRecursively;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return menuAllProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMobileDevice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var isMobile = __webpack_require__(878);

function noop() {}

function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || prefix + 'item_' + index;
}

function getMenuIdFromSubMenuEventKey(eventKey) {
  return eventKey + '-menu-';
}

function loopMenuItem(children, cb) {
  var index = -1;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    index++;
    if (c && c.type && c.type.isMenuItemGroup) {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(c.props.children, function (c2) {
        index++;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}

function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    if (c) {
      var construct = c.type;
      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }
      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}

var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator',

// the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon'];

// ref: https://github.com/ant-design/ant-design/issues/14007
// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
// getBoundingClientRect return the full precision value, which is
// not the same behavior as on chrome. Set the precision to 6 to
// unify their behavior
var getWidth = function getWidth(elem) {
  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;
  if (width) {
    width = +width.toFixed(6);
  }
  return width || 0;
};

var setStyle = function setStyle(elem, styleProperty, value) {
  if (elem && typeof elem.style === 'object') {
    elem.style[styleProperty] = value;
  }
};

var isMobileDevice = function isMobileDevice() {
  return isMobile.any;
};

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ContainerRender__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Portal__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Popup__ = __webpack_require__(880);
















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.prevPopupVisible = popupVisible;

    _this.state = {
      popupVisible: popupVisible
    };
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    ALL_HANDLERS.forEach(function (h) {
      _this2['fire' + h] = function (e) {
        _this2.fireEvents(h, e);
      };
    });
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    this.prevPopupVisible = prevState.popupVisible;

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;


    this.clearDelayTimer();

    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this3 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this3.setPopupVisible(visible, point);
        _this3.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this4 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this4.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Portal__["a" /* default */],
        {
          key: 'portal',
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this5.props.mouseEnterDelay;

    _this5.fireEvents('onMouseEnter', e);
    _this5.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this5.fireEvents('onMouseMove', e);
    _this5.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this5.fireEvents('onMouseLeave', e);
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this5.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this5.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this5.clearDelayTimer();
    if (_this5.isFocusToShow()) {
      _this5.focusTime = Date.now();
      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this5.fireEvents('onMouseDown', e);
    _this5.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this5.fireEvents('onTouchStart', e);
    _this5.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this5.fireEvents('onBlur', e);
    _this5.clearDelayTimer();
    if (_this5.isBlurToHide()) {
      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this5.fireEvents('onContextMenu', e);
    _this5.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this5.isContextMenuToShow()) {
      _this5.close();
    }
  };

  this.onClick = function (event) {
    _this5.fireEvents('onClick', event);
    // focus will trigger click
    if (_this5.focusTime) {
      var preTime = void 0;
      if (_this5.preClickTime && _this5.preTouchTime) {
        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
      } else if (_this5.preClickTime) {
        preTime = _this5.preClickTime;
      } else if (_this5.preTouchTime) {
        preTime = _this5.preTouchTime;
      }
      if (Math.abs(preTime - _this5.focusTime) < 20) {
        return;
      }
      _this5.focusTime = 0;
    }
    _this5.preClickTime = 0;
    _this5.preTouchTime = 0;
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this5.state.popupVisible;
    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
      _this5.setPopupVisible(!_this5.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this5.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this5.hasPopupMouseDown = true;

    clearTimeout(_this5.mouseDownTimeout);
    _this5.mouseDownTimeout = setTimeout(function () {
      _this5.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this5.props.mask && !_this5.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
    if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this5.hasPopupMouseDown) {
      _this5.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this5.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this5.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this5.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this5.getPopupAlign();

    var mouseProps = {};
    if (_this5.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
    }
    if (_this5.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this5.onPopupMouseDown;
    mouseProps.onTouchStart = _this5.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this5.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this5.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this5.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this5.props.alignPoint;

    if (!alignPoint || !point) return;

    _this5.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this5._component = node;
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Trigger);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1007);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(49);

var _rcTooltip = _interopRequireDefault(__webpack_require__(1008));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _placements = _interopRequireDefault(__webpack_require__(1012));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var splitObject = function splitObject(obj, keys) {
  var picked = {};

  var omitted = _extends({}, obj);

  keys.forEach(function (key) {
    if (obj && key in obj) {
      picked[key] = obj[key];
      delete omitted[key];
    }
  });
  return {
    picked: picked,
    omitted: omitted
  };
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this, props));

    _this.onVisibleChange = function (visible) {
      var onVisibleChange = _this.props.onVisibleChange;

      if (!('visible' in _this.props)) {
        _this.setState({
          visible: _this.isNoTitle() ? false : visible
        });
      }

      if (onVisibleChange && !_this.isNoTitle()) {
        onVisibleChange(visible);
      }
    }; // 动态设置动画点


    _this.onPopupAlign = function (domNode, align) {
      var placements = _this.getPlacements(); // 当前返回的位置


      var placement = Object.keys(placements).filter(function (key) {
        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
      })[0];

      if (!placement) {
        return;
      } // 根据当前坐标设置动画点


      var rect = domNode.getBoundingClientRect();
      var transformOrigin = {
        top: '50%',
        left: '50%'
      };

      if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
      } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
        transformOrigin.top = "".concat(-align.offset[1], "px");
      }

      if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
      } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
        transformOrigin.left = "".concat(-align.offset[0], "px");
      }

      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };

    _this.saveTooltip = function (node) {
      _this.tooltip = node;
    };

    _this.renderTooltip = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      var customizePrefixCls = props.prefixCls,
          title = props.title,
          overlay = props.overlay,
          openClassName = props.openClassName,
          getPopupContainer = props.getPopupContainer,
          getTooltipContainer = props.getTooltipContainer;
      var children = props.children;
      var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
      var visible = state.visible; // Hide tooltip when there is no title

      if (!('visible' in props) && _this.isNoTitle()) {
        visible = false;
      }

      var child = _this.getDisabledCompatibleChildren(React.isValidElement(children) ? children : React.createElement("span", null, children));

      var childProps = child.props;
      var childCls = (0, _classnames["default"])(childProps.className, _defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true));
      return React.createElement(_rcTooltip["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: _this.saveTooltip,
        builtinPlacements: _this.getPlacements(),
        overlay: overlay || title || '',
        visible: visible,
        onVisibleChange: _this.onVisibleChange,
        onPopupAlign: _this.onPopupAlign
      }), visible ? (0, React.cloneElement)(child, {
        className: childCls
      }) : child);
    };

    _this.state = {
      visible: !!props.visible || !!props.defaultVisible
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "getPopupDomNode",
    value: function getPopupDomNode() {
      return this.tooltip.getPopupDomNode();
    }
  }, {
    key: "getPlacements",
    value: function getPlacements() {
      var _this$props = this.props,
          builtinPlacements = _this$props.builtinPlacements,
          arrowPointAtCenter = _this$props.arrowPointAtCenter,
          autoAdjustOverflow = _this$props.autoAdjustOverflow;
      return builtinPlacements || (0, _placements["default"])({
        arrowPointAtCenter: arrowPointAtCenter,
        verticalArrowShift: 8,
        autoAdjustOverflow: autoAdjustOverflow
      });
    } // Fix Tooltip won't hide at disabled button
    // mouse events don't trigger at disabled button in Chrome
    // https://github.com/react-component/tooltip/issues/18

  }, {
    key: "getDisabledCompatibleChildren",
    value: function getDisabledCompatibleChildren(element) {
      if ((element.type.__ANT_BUTTON || element.type === 'button') && element.props.disabled) {
        // Pick some layout related style properties up to span
        // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
        var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
            picked = _splitObject.picked,
            omitted = _splitObject.omitted;

        var spanStyle = _extends({
          display: 'inline-block'
        }, picked, {
          cursor: 'not-allowed',
          width: element.props.block ? '100%' : null
        });

        var buttonStyle = _extends({}, omitted, {
          pointerEvents: 'none'
        });

        var child = (0, React.cloneElement)(element, {
          style: buttonStyle,
          className: null
        });
        return React.createElement("span", {
          style: spanStyle,
          className: element.props.className
        }, child);
      }

      return element;
    }
  }, {
    key: "isNoTitle",
    value: function isNoTitle() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          overlay = _this$props2.overlay;
      return !title && !overlay; // overlay for old version compatibility
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderTooltip);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('visible' in nextProps) {
        return {
          visible: nextProps.visible
        };
      }

      return null;
    }
  }]);

  return Tooltip;
}(React.Component);

Tooltip.defaultProps = {
  placement: 'top',
  transitionName: 'zoom-big-fast',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  arrowPointAtCenter: false,
  autoAdjustOverflow: true
};
(0, _reactLifecyclesCompat.polyfill)(Tooltip);
var _default = Tooltip;
exports["default"] = _default;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1045);

__webpack_require__(154);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = _interopRequireWildcard(__webpack_require__(182));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _SubMenu = _interopRequireDefault(__webpack_require__(1046));

var _MenuItem = _interopRequireDefault(__webpack_require__(1047));

var _configProvider = __webpack_require__(35);

var _openAnimation = _interopRequireDefault(__webpack_require__(319));

var _warning = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu(props) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this, props));
    _this.inlineOpenKeys = []; // Restore vertical mode when menu is collapsed responsively when mounted
    // https://github.com/ant-design/ant-design/issues/13104
    // TODO: not a perfect solution, looking a new way to avoid setting switchingModeFromInline in this situation

    _this.handleMouseEnter = function (e) {
      _this.restoreModeVerticalFromInline();

      var onMouseEnter = _this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter(e);
      }
    };

    _this.handleTransitionEnd = function (e) {
      // when inlineCollapsed menu width animation finished
      // https://github.com/ant-design/ant-design/issues/12864
      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix for <Menu style={{ width: '100%' }} />, the width transition won't trigger when menu is collapsed
      // https://github.com/ant-design/ant-design-pro/issues/2783

      var iconScaled = e.propertyName === 'font-size' && e.target.className.indexOf('anticon') >= 0;

      if (widthCollapsed || iconScaled) {
        _this.restoreModeVerticalFromInline();
      }
    };

    _this.handleClick = function (e) {
      _this.handleOpenChange([]);

      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e);
      }
    };

    _this.handleOpenChange = function (openKeys) {
      _this.setOpenKeys(openKeys);

      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(openKeys);
      }
    };

    _this.renderMenu = function (_ref) {
      var getPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          className = _this$props.className,
          theme = _this$props.theme;

      var menuMode = _this.getRealMenuMode();

      var menuOpenAnimation = _this.getMenuOpenAnimation(menuMode);

      var prefixCls = getPrefixCls('menu', customizePrefixCls);
      var menuClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()));
      var menuProps = {
        openKeys: _this.state.openKeys,
        onOpenChange: _this.handleOpenChange,
        className: menuClassName,
        mode: menuMode
      };

      if (menuMode !== 'inline') {
        // closing vertical popup submenu after click it
        menuProps.onClick = _this.handleClick;
        menuProps.openTransitionName = menuOpenAnimation;
      } else {
        menuProps.openAnimation = menuOpenAnimation;
      } // https://github.com/ant-design/ant-design/issues/8587


      var collapsedWidth = _this.context.collapsedWidth;

      if (_this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px')) {
        return null;
      }

      return React.createElement(_rcMenu["default"], _extends({
        getPopupContainer: getPopupContainer
      }, _this.props, menuProps, {
        prefixCls: prefixCls,
        onTransitionEnd: _this.handleTransitionEnd,
        onMouseEnter: _this.handleMouseEnter
      }));
    };

    (0, _warning["default"])(!('onOpen' in props || 'onClose' in props), '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
    (0, _warning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), "`inlineCollapsed` should only be used when Menu's `mode` is inline.");
    var openKeys;

    if ('openKeys' in props) {
      openKeys = props.openKeys;
    } else if ('defaultOpenKeys' in props) {
      openKeys = props.defaultOpenKeys;
    }

    _this.state = {
      openKeys: openKeys || []
    };
    return _this;
  }

  _createClass(Menu, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        inlineCollapsed: this.getInlineCollapsed(),
        antdMenuTheme: this.props.theme
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (this.props.mode === 'inline' && nextProps.mode !== 'inline') {
        this.switchingModeFromInline = true;
      }

      if ('openKeys' in nextProps) {
        this.setState({
          openKeys: nextProps.openKeys
        });
        return;
      }

      if (nextProps.inlineCollapsed && !this.props.inlineCollapsed || nextContext.siderCollapsed && !this.context.siderCollapsed) {
        this.switchingModeFromInline = true;
        this.inlineOpenKeys = this.state.openKeys;
        this.setState({
          openKeys: []
        });
      }

      if (!nextProps.inlineCollapsed && this.props.inlineCollapsed || !nextContext.siderCollapsed && this.context.siderCollapsed) {
        this.setState({
          openKeys: this.inlineOpenKeys
        });
        this.inlineOpenKeys = [];
      }
    }
  }, {
    key: "restoreModeVerticalFromInline",
    value: function restoreModeVerticalFromInline() {
      if (this.switchingModeFromInline) {
        this.switchingModeFromInline = false;
        this.setState({});
      }
    }
  }, {
    key: "setOpenKeys",
    value: function setOpenKeys(openKeys) {
      if (!('openKeys' in this.props)) {
        this.setState({
          openKeys: openKeys
        });
      }
    }
  }, {
    key: "getRealMenuMode",
    value: function getRealMenuMode() {
      var inlineCollapsed = this.getInlineCollapsed();

      if (this.switchingModeFromInline && inlineCollapsed) {
        return 'inline';
      }

      var mode = this.props.mode;
      return inlineCollapsed ? 'vertical' : mode;
    }
  }, {
    key: "getInlineCollapsed",
    value: function getInlineCollapsed() {
      var inlineCollapsed = this.props.inlineCollapsed;

      if (this.context.siderCollapsed !== undefined) {
        return this.context.siderCollapsed;
      }

      return inlineCollapsed;
    }
  }, {
    key: "getMenuOpenAnimation",
    value: function getMenuOpenAnimation(menuMode) {
      var _this$props2 = this.props,
          openAnimation = _this$props2.openAnimation,
          openTransitionName = _this$props2.openTransitionName;
      var menuOpenAnimation = openAnimation || openTransitionName;

      if (openAnimation === undefined && openTransitionName === undefined) {
        if (menuMode === 'horizontal') {
          menuOpenAnimation = 'slide-up';
        } else if (menuMode === 'inline') {
          menuOpenAnimation = _openAnimation["default"];
        } else {
          // When mode switch from inline
          // submenu should hide without animation
          if (this.switchingModeFromInline) {
            menuOpenAnimation = '';
            this.switchingModeFromInline = false;
          } else {
            menuOpenAnimation = 'zoom-big';
          }
        }
      }

      return menuOpenAnimation;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu);
    }
  }]);

  return Menu;
}(React.Component);

exports["default"] = Menu;
Menu.Divider = _rcMenu.Divider;
Menu.Item = _MenuItem["default"];
Menu.SubMenu = _SubMenu["default"];
Menu.ItemGroup = _rcMenu.ItemGroup;
Menu.defaultProps = {
  className: '',
  theme: 'light',
  focusable: false
};
Menu.childContextTypes = {
  inlineCollapsed: PropTypes.bool,
  antdMenuTheme: PropTypes.string
};
Menu.contextTypes = {
  siderCollapsed: PropTypes.bool,
  collapsedWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getTodayTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTitleString;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTodayTimeStr;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMonthName;
/* harmony export (immutable) */ __webpack_exports__["h"] = syncTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTimeConfig;
/* unused harmony export isTimeValidByConfig */
/* unused harmony export isTimeValid */
/* harmony export (immutable) */ __webpack_exports__["g"] = isAllowedDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};

function getTodayTime(value) {
  var today = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}

function getTitleString(value) {
  return value.format('LL');
}

function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}

function getMonthName(month) {
  var locale = month.locale();
  var localeData = month.localeData();
  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}

function syncTime(from, to) {
  if (!__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(from) || !__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
}

function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultDisabledTime, disabledTimeConfig);
  return disabledTimeConfig;
}

function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;
  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DATAFLOW_BUILDER_WIZARD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOW_BUILDER_WIZARD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATAFLOW_BUILDER_WIZARD_STEP_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATAFLOW_BUILDER_WIZARD_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_WIZARD_DATAFLOW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_WIZARD_DSD_FOR_LAYOUT_ANNOTATIONS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return showDataflowBuilderWizard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hideDataflowBuilderWizard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setDataflowBuilderWizardStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return submitDataflowBuilderWizard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return readDataflowBuilderWizardDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return readDataflowBuilderWizardDsdForLayoutAnnotations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__ = __webpack_require__(65);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DATAFLOW_BUILDER_WIZARD_SHOW='DATAFLOW_BUILDER_WIZARD_SHOW';var DATAFLOW_BUILDER_WIZARD_HIDE='DATAFLOW_BUILDER_WIZARD_HIDE';var DATAFLOW_BUILDER_WIZARD_STEP_SET='DATAFLOW_BUILDER_WIZARD_STEP_SET';var DATAFLOW_BUILDER_WIZARD_SUBMIT='DATAFLOW_BUILDER_WIZARD_SUBMIT';var DATAFLOW_BUILDER_WIZARD_DATAFLOW_READ='DATAFLOW_BUILDER_WIZARD_DATAFLOW_READ';var DATAFLOW_BUILDER_WIZARD_DSD_FOR_LAYOUT_ANNOTATIONS_READ='DATAFLOW_BUILDER_WIZARD_DSD_FOR_LAYOUT_ANNOTATIONS_READ';var showDataflowBuilderWizard=function showDataflowBuilderWizard(){return{type:DATAFLOW_BUILDER_WIZARD_SHOW};};var hideDataflowBuilderWizard=function hideDataflowBuilderWizard(){return{type:DATAFLOW_BUILDER_WIZARD_HIDE};};var setDataflowBuilderWizardStep=function setDataflowBuilderWizardStep(step){return{type:DATAFLOW_BUILDER_WIZARD_STEP_SET,step:step};};var submitDataflowBuilderWizard=function submitDataflowBuilderWizard(dataflow,cube,filter,categoriesUrns,header,ddbDataflowId,cubeCode){var cubeColumns=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];}));var dataflowUrn=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])({id:dataflow.id,agencyID:dataflow.agencyID,version:dataflow.version},__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */]);var getHeaderSenderOrReceiver=function getHeaderSenderOrReceiver(obj){return{id:obj.organisationId,name:obj.organisationName&&obj.organisationName.length?{en:obj.organisationName}:null,contacts:obj.contactName&&obj.contactName.length||obj.contactDepartment&&obj.contactDepartment.length||obj.contactRole&&obj.contactRole.length||obj.contactEmail&&obj.contactEmail.length?[{name:obj.contactName&&obj.contactName.length?{en:obj.contactName}:null,department:obj.contactDepartment&&obj.contactDepartment.length?{en:obj.contactDepartment}:null,role:obj.contactRole&&obj.contactRole.length?{en:obj.contactRole}:null,email:obj.contactEmail&&obj.contactEmail.length?[obj.contactEmail]:null}]:undefined};};return Object.assign({reportFileName:cubeCode},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_WIZARD_SUBMIT,ddbDataflowId?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_98" /* getUpdateDdbDataflowUrl */])():Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["R" /* getCreateDdbDataflowUrl */])(),{ddbDF:{IDDataflow:ddbDataflowId||undefined,ID:dataflow.id,Agency:dataflow.agencyID,Version:dataflow.version,labels:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(dataflow.name,function(str){return str.length>0;}),IDCube:cube.IDCube,DataflowColumns:cubeColumns.filter(function(_ref){var checked=_ref.checked;return checked===true;}).map(function(_ref2){var ColName=_ref2.ColName;return ColName;}),filter:Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter))).Filter},msdbDF:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},dataflow,{name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(dataflow.name,function(str){return str.length>0;}),structure:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(cube.DSDCode),__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */])}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["B" /* SDMX_JSON_DATAFLOW_LIST_KEY */]),msdbCat:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([].concat(_toConsumableArray(categoriesUrns.map(function(catUrn){var categorisationId='CAT_'+dataflow.id.substr(0,40)+'_'+String(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.random(99999)).padStart(5,'0');return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])({id:categorisationId,agencyID:dataflow.agencyID,version:dataflow.version,name:{en:categorisationId},source:dataflowUrn,target:catUrn});}))),__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["r" /* SDMX_JSON_CATEGORISATION_LIST_KEY */]),header:header!==null?Object.assign({},header,{sender:header.sender?getHeaderSenderOrReceiver(header.sender):null,receiver:header.receiver&&header.receiver.organisationId&&header.receiver.organisationId.length?[getHeaderSenderOrReceiver(header.receiver)]:null,dataSetAgencyId:header.dataSetAgencyId,parentId:dataflowUrn}):undefined},function(t){return{start:ddbDataflowId?t('scenes.dataManager.dataflowBuilder.wizard.messages.edit.start'):t('scenes.dataManager.dataflowBuilder.wizard.messages.create.start'),success:ddbDataflowId?t('scenes.dataManager.dataflowBuilder.wizard.messages.edit.success'):t('scenes.dataManager.dataflowBuilder.wizard.messages.create.success')};}));};var readDataflowBuilderWizardDataflow=function readDataflowBuilderWizardDataflow(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_WIZARD_DATAFLOW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])(dataflowTriplet));};var readDataflowBuilderWizardDsdForLayoutAnnotations=function readDataflowBuilderWizardDsdForLayoutAnnotations(dsdTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_WIZARD_DSD_FOR_LAYOUT_ANNOTATIONS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(dsdTriplet));};

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPORT_DETAILS_WIZARD_STEP_FIRST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REPORT_DETAILS_WIZARD_STEP_SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARTEFACT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return customIsReferenceMetadataAutoAnnotation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getWorkingAnnotations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__ = __webpack_require__(10);
var REPORT_DETAILS_WIZARD_STEP_FIRST=0;var REPORT_DETAILS_WIZARD_STEP_SECOND=1;var ARTEFACT_TYPES=[{type:"codelist",url:Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["A" /* getCodelistUrl */])(),urnNamespace:__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["w" /* SDMX_JSON_CODELIST_URN_NAMESPACE */]},{type:"categoryscheme",url:Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["p" /* getCategorySchemeUrl */])(),urnNamespace:__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["t" /* SDMX_JSON_CATEGORY_SCHEME_URN_NAMESPACE */]},{type:"conceptscheme",url:Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["F" /* getConceptSchemeUrl */])(),urnNamespace:__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["x" /* SDMX_JSON_CONCEPT_SCEHME_URN_NAMESPACE */]},{type:"dataflow",url:Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_7" /* getDataflowUrl */])(),urnNamespace:__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */]},{type:"metadataflow",url:Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_64" /* getMetadataflowUrl */])(),urnNamespace:__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["J" /* SDMX_JSON_METADATAFLOW_URN_NAMESPACE */]}];var AUTO_ANNOTATIONS=["metadatasetid","metadataflowcategorylist","metadataflowid","metadataflowagency","metadataflowversion","msdid","msdagency","msdversion"];var customIsReferenceMetadataAutoAnnotation=function customIsReferenceMetadataAutoAnnotation(annotation){return annotation.id&&(AUTO_ANNOTATIONS.includes(annotation.id.toLowerCase())||annotation.id.substring(0,14)==="categorisation");};var getWorkingAnnotations=function getWorkingAnnotations(metadataSet){var metadataflowTriplet=metadataSet.metadataflowTriplet;var msdTriplet=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(metadataSet.msdUrn);return[{id:"MetadataflowId",text:{en:metadataflowTriplet.id}},{id:"MetadataflowAgency",text:{en:metadataflowTriplet.agencyID}},{id:"MetadataflowVersion",text:{en:metadataflowTriplet.version}},{id:"MSDId",text:{en:msdTriplet.id}},{id:"MSDAgency",text:{en:msdTriplet.agencyID}},{id:"MSDVersion",text:{en:msdTriplet.version}}];};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CONTENT_CONSTRAINT_DETAIL_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CONTENT_CONSTRAINT_DETAIL_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CONTENT_CONSTRAINT_DETAIL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CONTENT_CONSTRAINT_DETAIL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CONTENT_CONSTRAINT_DETAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CONTENT_CONSTRAINT_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CONTENT_CONSTRAINT_DETAIL_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTENT_CONSTRAINT_DETAIL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONTENT_CONSTRAINT_DETAIL_ARTEFACT_TYPE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTENT_CONSTRAINT_DETAIL_ARTEFACT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONTENT_CONSTRAINT_DETAIL_ARTEFACT_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONTENT_CONSTRAINT_DETAIL_ARTEFACT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CONTENT_CONSTRAINT_DETAIL_RELEASE_CALENDAR_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CONTENT_CONSTRAINT_DETAIL_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CONTENT_CONSTRAINT_DETAIL_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CONTENT_CONSTRAINT_DETAIL_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CONTENT_CONSTRAINT_DETAIL_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CONTENT_CONSTRAINT_DETAIL_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CONTENT_CONSTRAINT_DETAIL_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CONTENT_CONSTRAINT_DETAIL_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CONTENT_CONSTRAINT_DETAIL_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CONTENT_CONSTRAINT_DETAIL_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return createContentConstraintDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return editContentConstraintDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return showContentConstraintDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return readContentConstraintDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return changeContentConstraintDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return submitContentConstraintDetailCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return submitContentConstraintDetailUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return readContentConstraintDetailAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return hideContentConstraintDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return selectContentConstraintDetailArtefactType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return showContentConstraintDetailArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return hideContentConstraintDetailArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return readContentConstraintDetailArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return setContentConstraintDetailArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return unsetContentConstraintDetailArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return readContentConstraintDetailArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return resetContentConstraintDetailFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_COUNT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return readContentConstraintDetailFilterColumnCodelistCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return readContentConstraintDetailFilterColumnCodelistTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return showContentConstraintDetailFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return hideContentConstraintDetailFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return showContentConstraintDetailFilterQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return hideContentConstraintDetailFilterQuery; });
/* unused harmony export CONTENT_CONSTRAINT_DETAIL_FILTER_CHANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return changeContentConstraintDetailFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_FILTERED_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return readContentConstraintDetailFilterColumnFilteredValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_DSD_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return readContentConstraintDetailFilterDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return readContentConstraintDetailFilterCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return changeContentConstraintDetailFilterColumnMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_VALUES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return changeContentConstraintDetailFilterColumnValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return changeContentConstraintDetailReleaseCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return showContentConstraintDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return hideContentConstraintDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return changeContentConstraintDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return submitContentConstraintDetailDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return showContentConstraintDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return hideContentConstraintDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return changeContentConstraintDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return submitContentConstraintDetailClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return showContentConstraintDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return hideContentConstraintDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return changeContentConstraintDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return submitContentConstraintDetailExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return hideContentConstraintDetailExportReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FilterTab__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artefact_export_form__ = __webpack_require__(51);
var CONTENT_CONSTRAINT_DETAIL_READ='CONTENT_CONSTRAINT_DETAIL_READ';var CONTENT_CONSTRAINT_DETAIL_CREATE='CONTENT_CONSTRAINT_DETAIL_CREATE';var CONTENT_CONSTRAINT_DETAIL_EDIT='CONTENT_CONSTRAINT_DETAIL_EDIT';var CONTENT_CONSTRAINT_DETAIL_SHOW='CONTENT_CONSTRAINT_DETAIL_SHOW';var CONTENT_CONSTRAINT_DETAIL_CHANGE='CONTENT_CONSTRAINT_DETAIL_CHANGE';var CONTENT_CONSTRAINT_DETAIL_HIDE='CONTENT_CONSTRAINT_DETAIL_HIDE';var CONTENT_CONSTRAINT_DETAIL_CREATE_SUBMIT='CONTENT_CONSTRAINT_DETAIL_CREATE_SUBMIT';var CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT='CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT';var CONTENT_CONSTRAINT_DETAIL_AGENCIES_READ='CONTENT_CONSTRAINT_DETAIL_AGENCIES_READ';var CONTENT_CONSTRAINT_DETAIL_ARTEFACT_TYPE_SELECT='CONTENT_CONSTRAINT_DETAIL_ARTEFACT_TYPE_SELECT';var CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_SHOW='CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_SHOW';var CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_HIDE='CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_HIDE';var CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_READ='CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_READ';var CONTENT_CONSTRAINT_DETAIL_ARTEFACT_SET='CONTENT_CONSTRAINT_DETAIL_ARTEFACT_SET';var CONTENT_CONSTRAINT_DETAIL_ARTEFACT_UNSET='CONTENT_CONSTRAINT_DETAIL_ARTEFACT_UNSET';var CONTENT_CONSTRAINT_DETAIL_ARTEFACT_READ='CONTENT_CONSTRAINT_DETAIL_ARTEFACT_READ';var CONTENT_CONSTRAINT_DETAIL_RELEASE_CALENDAR_CHANGE='CONTENT_CONSTRAINT_DETAIL_RELEASE_CALENDAR_CHANGE';var CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SHOW='CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SHOW';var CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_HIDE='CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_HIDE';var CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_CHANGE='CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_CHANGE';var CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SUBMIT='CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SUBMIT';var CONTENT_CONSTRAINT_DETAIL_CLONE_SHOW='CONTENT_CONSTRAINT_DETAIL_CLONE_SHOW';var CONTENT_CONSTRAINT_DETAIL_CLONE_HIDE='CONTENT_CONSTRAINT_DETAIL_CLONE_HIDE';var CONTENT_CONSTRAINT_DETAIL_CLONE_CHANGE='CONTENT_CONSTRAINT_DETAIL_CLONE_CHANGE';var CONTENT_CONSTRAINT_DETAIL_CLONE_SUBMIT='CONTENT_CONSTRAINT_DETAIL_CLONE_SUBMIT';var CONTENT_CONSTRAINT_DETAIL_EXPORT_SHOW='CONTENT_CONSTRAINT_DETAIL_EXPORT_SHOW';var CONTENT_CONSTRAINT_DETAIL_EXPORT_HIDE='CONTENT_CONSTRAINT_DETAIL_EXPORT_HIDE';var CONTENT_CONSTRAINT_DETAIL_EXPORT_CHANGE='CONTENT_CONSTRAINT_DETAIL_EXPORT_CHANGE';var CONTENT_CONSTRAINT_DETAIL_EXPORT_SUBMIT='CONTENT_CONSTRAINT_DETAIL_EXPORT_SUBMIT';var CONTENT_CONSTRAINT_DETAIL_EXPORT_REPORT_HIDE='CONTENT_CONSTRAINT_DETAIL_EXPORT_REPORT_HIDE';var createContentConstraintDetail=function createContentConstraintDetail(){return{type:CONTENT_CONSTRAINT_DETAIL_CREATE};};var editContentConstraintDetail=function editContentConstraintDetail(contentConstraintTriplet){return{type:CONTENT_CONSTRAINT_DETAIL_EDIT,contentConstraintTriplet:contentConstraintTriplet};};var showContentConstraintDetail=function showContentConstraintDetail(contentConstraintTriplet){return{type:CONTENT_CONSTRAINT_DETAIL_SHOW,contentConstraintTriplet:contentConstraintTriplet};};var readContentConstraintDetail=function readContentConstraintDetail(contentConstraintTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONTENT_CONSTRAINT_DETAIL_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["H" /* getContentConstraintUrl */])(contentConstraintTriplet));};var changeContentConstraintDetail=function changeContentConstraintDetail(fields){return{type:CONTENT_CONSTRAINT_DETAIL_CHANGE,fields:fields};};var submitContentConstraintDetailCreate=function submitContentConstraintDetailCreate(contentConstraint,attachmentType,attachmentUrn,filter){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CONTENT_CONSTRAINT_DETAIL_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["X" /* getSdmxJsonStructureFromContentConstraint */])(contentConstraint,attachmentType,attachmentUrn,Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* getContentConstraintFilter */])(filter))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["A" /* SDMX_JSON_CONTENT_CONSTRAINT_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.contentConstraints.messages.create.success')};});};var submitContentConstraintDetailUpdate=function submitContentConstraintDetailUpdate(contentConstraint,attachmentType,attachmentUrn,filter,timePeriod,keepModalOpen){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["X" /* getSdmxJsonStructureFromContentConstraint */])(contentConstraint,attachmentType,attachmentUrn,Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* getContentConstraintFilter */])(filter),timePeriod)],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["A" /* SDMX_JSON_CONTENT_CONSTRAINT_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.contentConstraints.messages.update.success')};}),{keepModalOpen:keepModalOpen});};var readContentConstraintDetailAgencies=function readContentConstraintDetailAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONTENT_CONSTRAINT_DETAIL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var hideContentConstraintDetail=function hideContentConstraintDetail(){return{type:CONTENT_CONSTRAINT_DETAIL_HIDE};};var selectContentConstraintDetailArtefactType=function selectContentConstraintDetailArtefactType(artefactType){return{type:CONTENT_CONSTRAINT_DETAIL_ARTEFACT_TYPE_SELECT,artefactType:artefactType};};var showContentConstraintDetailArtefacts=function showContentConstraintDetailArtefacts(){return{type:CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_SHOW};};var hideContentConstraintDetailArtefacts=function hideContentConstraintDetailArtefacts(){return{type:CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_HIDE};};var readContentConstraintDetailArtefacts=function readContentConstraintDetailArtefacts(artefactType){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_READ,artefactType==="dataflow"?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])():Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])());};var setContentConstraintDetailArtefact=function setContentConstraintDetailArtefact(artefactTriplet){return{type:CONTENT_CONSTRAINT_DETAIL_ARTEFACT_SET,artefactTriplet:artefactTriplet};};var unsetContentConstraintDetailArtefact=function unsetContentConstraintDetailArtefact(){return{type:CONTENT_CONSTRAINT_DETAIL_ARTEFACT_UNSET};};var readContentConstraintDetailArtefact=function readContentConstraintDetailArtefact(artefactType,artefactTriplet,haveDMWS,isUserLogged){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(CONTENT_CONSTRAINT_DETAIL_ARTEFACT_READ,artefactType===__WEBPACK_IMPORTED_MODULE_3__FilterTab__["a" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW */]?[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]].concat(haveDMWS&&isUserLogged?__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]:[]):[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],artefactType===__WEBPACK_IMPORTED_MODULE_3__FilterTab__["a" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW */]?[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])(artefactTriplet)].concat(haveDMWS&&isUserLogged?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_9" /* getDdbDataflowUrl */])():[]):[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(artefactTriplet)]),{artefactType:artefactType,haveDMWS:haveDMWS,isUserLogged:isUserLogged});};var CONTENT_CONSTRAINT_DETAIL_FILTER_RESET='CONTENT_CONSTRAINT_DETAIL_FILTER_RESET';var resetContentConstraintDetailFilter=function resetContentConstraintDetailFilter(){return{type:CONTENT_CONSTRAINT_DETAIL_FILTER_RESET};};var CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_COUNT_READ='CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_COUNT_READ';var readContentConstraintDetailFilterColumnCodelistCount=function readContentConstraintDetailFilterColumnCodelistCount(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_COUNT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_TREE_READ='CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_TREE_READ';var readContentConstraintDetailFilterColumnCodelistTree=function readContentConstraintDetailFilterColumnCodelistTree(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_TREE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:-1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_SHOW='CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_SHOW';var showContentConstraintDetailFilterModal=function showContentConstraintDetailFilterModal(){return{type:CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_SHOW};};var CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_HIDE='CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_HIDE';var hideContentConstraintDetailFilterModal=function hideContentConstraintDetailFilterModal(){return{type:CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_HIDE};};var CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_SHOW='CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_SHOW';var showContentConstraintDetailFilterQuery=function showContentConstraintDetailFilterQuery(){return{type:CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_SHOW};};var CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_HIDE='CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_HIDE';var hideContentConstraintDetailFilterQuery=function hideContentConstraintDetailFilterQuery(){return{type:CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_HIDE};};var CONTENT_CONSTRAINT_DETAIL_FILTER_CHANGE='CONTENT_CONSTRAINT_DETAIL_FILTER_CHANGE';var changeContentConstraintDetailFilter=function changeContentConstraintDetailFilter(filter){return{type:CONTENT_CONSTRAINT_DETAIL_FILTER_CHANGE};};var CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_FILTERED_VALUES_READ='CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_FILTERED_VALUES_READ';var readContentConstraintDetailFilterColumnFilteredValues=function readContentConstraintDetailFilterColumnFilteredValues(cubeId,colNames,filter){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_FILTERED_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(colNames[colNames.length-1],1,-1),{idCube:cubeId,dataflowColumns:colNames,filter:Object(__WEBPACK_IMPORTED_MODULE_5__utils_filter__["f" /* getServerQueryObj */])(undefined,Object(__WEBPACK_IMPORTED_MODULE_5__utils_filter__["a" /* getFilterObjFromStr */])("")).Filter}),{colName:colNames[colNames.length-1]});};var CONTENT_CONSTRAINT_DETAIL_FILTER_DSD_READ='CONTENT_CONSTRAINT_DETAIL_FILTER_DSD_READ';var readContentConstraintDetailFilterDsd=function readContentConstraintDetailFilterDsd(dsdTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONTENT_CONSTRAINT_DETAIL_FILTER_DSD_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(dsdTriplet));};var CONTENT_CONSTRAINT_DETAIL_FILTER_CUBE_READ='CONTENT_CONSTRAINT_DETAIL_FILTER_CUBE_READ';var readContentConstraintDetailFilterCube=function readContentConstraintDetailFilterCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONTENT_CONSTRAINT_DETAIL_FILTER_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_MODE_CHANGE='CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_MODE_CHANGE';var changeContentConstraintDetailFilterColumnMode=function changeContentConstraintDetailFilterColumnMode(colName,mode){return{type:CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_MODE_CHANGE,colName:colName,mode:mode};};var CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_VALUES_CHANGE='CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_VALUES_CHANGE';var changeContentConstraintDetailFilterColumnValues=function changeContentConstraintDetailFilterColumnValues(colName,values){return{type:CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_VALUES_CHANGE,colName:colName,values:values};};var changeContentConstraintDetailReleaseCalendar=function changeContentConstraintDetailReleaseCalendar(fields){return{type:CONTENT_CONSTRAINT_DETAIL_RELEASE_CALENDAR_CHANGE,fields:fields};};var showContentConstraintDetailDownload=function showContentConstraintDetailDownload(artefactTriplet,lang){return{type:CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SHOW,artefactTriplet:artefactTriplet,lang:lang};};var hideContentConstraintDetailDownload=function hideContentConstraintDetailDownload(){return{type:CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_HIDE};};var changeContentConstraintDetailDownload=function changeContentConstraintDetailDownload(fields){return{type:CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_CHANGE,fields:fields};};var submitContentConstraintDetailDownload=function submitContentConstraintDetailDownload(artefactTriplets,downloadContentConstraintParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_4__constants_download__["e" /* ARTEFACT_TYPE_CONTENT_CONSTRAINT */],downloadContentConstraintParams.format,downloadContentConstraintParams.references,downloadContentConstraintParams.compression,lang),artefactTriplets.map(function(_ref){var id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_4__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_4__constants_download__["e" /* ARTEFACT_TYPE_CONTENT_CONSTRAINT */],downloadContentConstraintParams.format,downloadContentConstraintParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_4__constants_download__["e" /* ARTEFACT_TYPE_CONTENT_CONSTRAINT */],artefactTriplets[0],downloadContentConstraintParams.format,downloadContentConstraintParams.references,downloadContentConstraintParams.compression,lang),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_4__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_4__constants_download__["e" /* ARTEFACT_TYPE_CONTENT_CONSTRAINT */],downloadContentConstraintParams.format,downloadContentConstraintParams.compression)});};var showContentConstraintDetailClone=function showContentConstraintDetailClone(srcTriplet){return{type:CONTENT_CONSTRAINT_DETAIL_CLONE_SHOW,srcTriplet:srcTriplet};};var hideContentConstraintDetailClone=function hideContentConstraintDetailClone(){return{type:CONTENT_CONSTRAINT_DETAIL_CLONE_HIDE};};var changeContentConstraintDetailClone=function changeContentConstraintDetailClone(fields){return{type:CONTENT_CONSTRAINT_DETAIL_CLONE_CHANGE,fields:fields};};var submitContentConstraintDetailClone=function submitContentConstraintDetailClone(cloneDestTriplet,srcContentConstraint,srcContentConstraintAttachmentType,srcContentConstraintAttachmentUrn,srcContentConstraintFilter,annotationsConfig){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CONTENT_CONSTRAINT_DETAIL_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["X" /* getSdmxJsonStructureFromContentConstraint */])(Object.assign({},srcContentConstraint,cloneDestTriplet,{isFinal:false,annotations:Object(__WEBPACK_IMPORTED_MODULE_6__utils_artefacts__["d" /* getFilteredAnnotations */])(srcContentConstraint.annotations,annotationsConfig),autoAnnotations:null}),srcContentConstraintAttachmentType,srcContentConstraintAttachmentUrn,Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* getContentConstraintFilter */])(srcContentConstraintFilter))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["A" /* SDMX_JSON_CONTENT_CONSTRAINT_LIST_KEY */]),function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showContentConstraintDetailExport=function showContentConstraintDetailExport(sourceTriplet,sourceAttachmentType,sourceAttachmentUrn,sourceFilter){return{type:CONTENT_CONSTRAINT_DETAIL_EXPORT_SHOW,sourceTriplet:sourceTriplet,sourceAttachmentType:sourceAttachmentType,sourceAttachmentUrn:sourceAttachmentUrn,sourceFilter:sourceFilter};};var hideContentConstraintDetailExport=function hideContentConstraintDetailExport(){return{type:CONTENT_CONSTRAINT_DETAIL_EXPORT_HIDE};};var changeContentConstraintDetailExport=function changeContentConstraintDetailExport(fields){return{type:CONTENT_CONSTRAINT_DETAIL_EXPORT_CHANGE,fields:fields};};var submitContentConstraintDetailExport=function submitContentConstraintDetailExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CONTENT_CONSTRAINT_DETAIL_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||[]),EnumType:"ContentConstraint",CopyReferencedArtefact:false,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_8__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideContentConstraintDetailExportReport=function hideContentConstraintDetailExportReport(){return{type:CONTENT_CONSTRAINT_DETAIL_EXPORT_REPORT_HIDE};};

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return METADATAFLOWS_LIST_METADATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return METADATAFLOWS_METADATAFLOW_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return METADATAFLOWS_METADATAFLOW_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return METADATAFLOWS_METADATAFLOW_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return METADATAFLOWS_DETAIL_METADATAFLOW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return METADATAFLOWS_DETAIL_METADATAFLOW_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return METADATAFLOWS_DETAIL_METADATAFLOW_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return METADATAFLOWS_DETAIL_METADATAFLOW_UPDATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return METADATAFLOWS_DETAIL_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return METADATAFLOWS_DETAIL_MSDS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return METADATAFLOWS_DETAIL_MSDS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return METADATAFLOWS_DETAIL_MSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return METADATAFLOWS_DETAIL_MSD_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return METADATAFLOWS_DETAIL_MSD_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return METADATAFLOWS_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return METADATAFLOWS_DETAIL_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return METADATAFLOWS_DETAIL_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return METADATAFLOWS_SELECTED_METADATAFLOWS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return METADATAFLOWS_METADATAFLOW_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return METADATAFLOWS_METADATAFLOW_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return METADATAFLOWS_METADATAFLOW_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return METADATAFLOWS_METADATAFLOW_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return METADATAFLOWS_METADATAFLOW_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return METADATAFLOWS_METADATAFLOW_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return METADATAFLOWS_METADATAFLOW_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return METADATAFLOWS_METADATAFLOW_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return METADATAFLOWS_METADATAFLOW_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return METADATAFLOWS_METADATAFLOW_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return METADATAFLOWS_METADATAFLOW_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return METADATAFLOWS_METADATAFLOW_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return METADATAFLOWS_METADATAFLOW_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return METADATAFLOWS_METADATAFLOW_OWNERSHIP_USERS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return METADATAFLOWS_METADATAFLOW_OWNERSHIP_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return METADATAFLOWS_METADATAFLOW_OWNERSHIP_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return readMetadataflowsListMetadataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return createMetadataflowsMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return editMetadataflowsMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return deleteMetadataflowsMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return readMetadataflowsDetailMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return changeMetadataflowsDetailMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return submitMetadataflowsDetailMetadataflowCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return submitMetadataflowsDetailMetadataflowUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return readMetadataflowsDetailAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return showMetadataflowsDetailMsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return hideMetadataflowsDetailMsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return readMetadataflowsDetailMsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return setMetadataflowsDetailMsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return unsetMetadataflowsDetailMsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return hideMetadataflowsDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return showMetadataflowsDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return hideMetadataflowsDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return deleteMetadataflowsSelectedMetadataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return showMetadataflowsMetadataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return hideMetadataflowsMetadataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return changeMetadataflowsMetadataflowDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return downloadMetadataflowsMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return showMetadataflowsMetadataflowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return hideMetadataflowsMetadataflowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return changeMetadataflowsMetadataflowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return submitMetadataflowsMetadataflowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return showMetadataflowsMetadataflowExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return hideMetadataflowsMetadataflowExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return changeMetadataflowsMetadataflowExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return submitMetadataflowsMetadataflowExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return hideMetadataflowsMetadataflowExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return showMetadataflowsMetadataflowOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return hideMetadataflowsMetadataflowOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return readMetadataflowsMetadataflowOwnershipUsersRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return readMetadataflowsMetadataflowOwnershipOwnersRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return changeMetadataflowsMetadataflowOwnershipOwners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return submitMetadataflowsMetadataflowOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return readMetadataflowsMetadataflowParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return hideMetadataflowsMetadataflowParentsAndChildren; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artefact_export_form__ = __webpack_require__(51);
var METADATAFLOWS_LIST_METADATAFLOWS_READ='METADATAFLOWS_LIST_METADATAFLOWS_READ';var METADATAFLOWS_METADATAFLOW_CREATE='METADATAFLOWS_METADATAFLOW_CREATE';var METADATAFLOWS_METADATAFLOW_EDIT='METADATAFLOWS_METADATAFLOW_EDIT';var METADATAFLOWS_METADATAFLOW_DELETE='METADATAFLOWS_METADATAFLOW_DELETE';var METADATAFLOWS_DETAIL_METADATAFLOW_READ='METADATAFLOWS_DETAIL_METADATAFLOW_READ';var METADATAFLOWS_DETAIL_METADATAFLOW_CHANGE='METADATAFLOWS_DETAIL_METADATAFLOW_CHANGE';var METADATAFLOWS_DETAIL_METADATAFLOW_CREATE_SUBMIT='METADATAFLOWS_DETAIL_METADATAFLOW_CREATE_SUBMIT';var METADATAFLOWS_DETAIL_METADATAFLOW_UPDATE_SUBMIT='METADATAFLOWS_DETAIL_METADATAFLOW_UPDATE_SUBMIT';var METADATAFLOWS_DETAIL_AGENCIES_READ='METADATAFLOWS_DETAIL_AGENCIES_READ';var METADATAFLOWS_DETAIL_MSDS_SHOW='METADATAFLOWS_DETAIL_MSDS_SHOW';var METADATAFLOWS_DETAIL_MSDS_HIDE='METADATAFLOWS_DETAIL_MSDS_HIDE';var METADATAFLOWS_DETAIL_MSDS_READ='METADATAFLOWS_DETAIL_MSDS_READ';var METADATAFLOWS_DETAIL_MSD_SET='METADATAFLOWS_DETAIL_MSD_SET';var METADATAFLOWS_DETAIL_MSD_UNSET='METADATAFLOWS_DETAIL_MSD_UNSET';var METADATAFLOWS_DETAIL_HIDE='METADATAFLOWS_DETAIL_HIDE';var METADATAFLOWS_DETAIL_ANNOTATIONS_SHOW='METADATAFLOWS_DETAIL_ANNOTATIONS_SHOW';var METADATAFLOWS_DETAIL_ANNOTATIONS_HIDE='METADATAFLOWS_DETAIL_ANNOTATIONS_HIDE';var METADATAFLOWS_SELECTED_METADATAFLOWS_DELETE='METADATAFLOWS_SELECTED_METADATAFLOWS_DELETE';var METADATAFLOWS_METADATAFLOW_DOWNLOAD_SHOW='METADATAFLOWS_METADATAFLOW_DOWNLOAD_SHOW';var METADATAFLOWS_METADATAFLOW_DOWNLOAD_HIDE='METADATAFLOWS_METADATAFLOW_DOWNLOAD_HIDE';var METADATAFLOWS_METADATAFLOW_DOWNLOAD_CHANGE='METADATAFLOWS_METADATAFLOW_DOWNLOAD_CHANGE';var METADATAFLOWS_METADATAFLOW_DOWNLOAD='METADATAFLOWS_METADATAFLOW_DOWNLOAD';var METADATAFLOWS_METADATAFLOW_CLONE_SHOW='METADATAFLOWS_METADATAFLOW_CLONE_SHOW';var METADATAFLOWS_METADATAFLOW_CLONE_HIDE='METADATAFLOWS_METADATAFLOW_CLONE_HIDE';var METADATAFLOWS_METADATAFLOW_CLONE_CHANGE='METADATAFLOWS_METADATAFLOW_CLONE_CHANGE';var METADATAFLOWS_METADATAFLOW_CLONE_SUBMIT='METADATAFLOWS_METADATAFLOW_CLONE_SUBMIT';var METADATAFLOWS_METADATAFLOW_EXPORT_SHOW='METADATAFLOWS_METADATAFLOW_EXPORT_SHOW';var METADATAFLOWS_METADATAFLOW_EXPORT_HIDE='METADATAFLOWS_METADATAFLOW_EXPORT_HIDE';var METADATAFLOWS_METADATAFLOW_EXPORT_CHANGE='METADATAFLOWS_METADATAFLOW_EXPORT_CHANGE';var METADATAFLOWS_METADATAFLOW_EXPORT_SUBMIT='METADATAFLOWS_METADATAFLOW_EXPORT_SUBMIT';var METADATAFLOWS_METADATAFLOW_EXPORT_REPORT_HIDE='METADATAFLOWS_METADATAFLOW_EXPORT_REPORT_HIDE';var METADATAFLOWS_METADATAFLOW_OWNERSHIP_USERS_READ='METADATAFLOWS_METADATAFLOW_OWNERSHIP_USERS_READ';var METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_READ='METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_READ';var METADATAFLOWS_METADATAFLOW_OWNERSHIP_SHOW='METADATAFLOWS_METADATAFLOW_OWNERSHIP_SHOW';var METADATAFLOWS_METADATAFLOW_OWNERSHIP_HIDE='METADATAFLOWS_METADATAFLOW_OWNERSHIP_HIDE';var METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_CHANGE='METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_CHANGE';var METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_SUBMIT='METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_SUBMIT';var METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_READ='METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_READ';var METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_HIDE='METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_HIDE';var readMetadataflowsListMetadataflows=function readMetadataflowsListMetadataflows(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATAFLOWS_LIST_METADATAFLOWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_64" /* getMetadataflowUrl */])());};var createMetadataflowsMetadataflow=function createMetadataflowsMetadataflow(){return{type:METADATAFLOWS_METADATAFLOW_CREATE};};var editMetadataflowsMetadataflow=function editMetadataflowsMetadataflow(metadataflowTriplet){return{type:METADATAFLOWS_METADATAFLOW_EDIT,metadataflowTriplet:metadataflowTriplet};};var deleteMetadataflowsMetadataflow=function deleteMetadataflowsMetadataflow(metadataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(METADATAFLOWS_METADATAFLOW_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("Metadataflow",metadataflowTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var readMetadataflowsDetailMetadataflow=function readMetadataflowsDetailMetadataflow(metadataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATAFLOWS_DETAIL_METADATAFLOW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_64" /* getMetadataflowUrl */])(metadataflowTriplet));};var changeMetadataflowsDetailMetadataflow=function changeMetadataflowsDetailMetadataflow(fields){return{type:METADATAFLOWS_DETAIL_METADATAFLOW_CHANGE,fields:fields};};var submitMetadataflowsDetailMetadataflowCreate=function submitMetadataflowsDetailMetadataflowCreate(metadataflow){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATAFLOWS_DETAIL_METADATAFLOW_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(metadataflow)],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["I" /* SDMX_JSON_METADATAFLOW_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.metadataflows.messages.create.success')};});};var submitMetadataflowsDetailMetadataflowUpdate=function submitMetadataflowsDetailMetadataflowUpdate(metadataflow,keepModalOpen){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(METADATAFLOWS_DETAIL_METADATAFLOW_UPDATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(metadataflow)],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["I" /* SDMX_JSON_METADATAFLOW_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.metadataflows.messages.update.success')};}),{keepModalOpen:keepModalOpen});};var readMetadataflowsDetailAgencies=function readMetadataflowsDetailAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATAFLOWS_DETAIL_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var showMetadataflowsDetailMsds=function showMetadataflowsDetailMsds(){return{type:METADATAFLOWS_DETAIL_MSDS_SHOW};};var hideMetadataflowsDetailMsds=function hideMetadataflowsDetailMsds(){return{type:METADATAFLOWS_DETAIL_MSDS_HIDE};};var readMetadataflowsDetailMsds=function readMetadataflowsDetailMsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATAFLOWS_DETAIL_MSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_66" /* getMsdUrl */])());};var setMetadataflowsDetailMsd=function setMetadataflowsDetailMsd(msdTriplet){return{type:METADATAFLOWS_DETAIL_MSD_SET,msdTriplet:msdTriplet};};var unsetMetadataflowsDetailMsd=function unsetMetadataflowsDetailMsd(){return{type:METADATAFLOWS_DETAIL_MSD_UNSET};};var hideMetadataflowsDetail=function hideMetadataflowsDetail(){return{type:METADATAFLOWS_DETAIL_HIDE};};var showMetadataflowsDetailAnnotations=function showMetadataflowsDetailAnnotations(annotations,triplet){return{type:METADATAFLOWS_DETAIL_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideMetadataflowsDetailAnnotations=function hideMetadataflowsDetailAnnotations(){return{type:METADATAFLOWS_DETAIL_ANNOTATIONS_HIDE};};var deleteMetadataflowsSelectedMetadataflows=function deleteMetadataflowsSelectedMetadataflows(metadataflowTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(METADATAFLOWS_SELECTED_METADATAFLOWS_DELETE,metadataflowTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),metadataflowTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("Metadataflow",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},metadataflowTriplets.map(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]));};var showMetadataflowsMetadataflowDownload=function showMetadataflowsMetadataflowDownload(artefactTriplets,lang){return{type:METADATAFLOWS_METADATAFLOW_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideMetadataflowsMetadataflowDownload=function hideMetadataflowsMetadataflowDownload(){return{type:METADATAFLOWS_METADATAFLOW_DOWNLOAD_HIDE};};var changeMetadataflowsMetadataflowDownload=function changeMetadataflowsMetadataflowDownload(fields){return{type:METADATAFLOWS_METADATAFLOW_DOWNLOAD_CHANGE,fields:fields};};var downloadMetadataflowsMetadataflow=function downloadMetadataflowsMetadataflow(artefactTriplets,downloadMetadataflowParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATAFLOWS_METADATAFLOW_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_3__constants_download__["j" /* ARTEFACT_TYPE_METADATAFLOW */],downloadMetadataflowParams.format,downloadMetadataflowParams.references,downloadMetadataflowParams.compression,lang),artefactTriplets.map(function(_ref){var id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_3__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_3__constants_download__["j" /* ARTEFACT_TYPE_METADATAFLOW */],downloadMetadataflowParams.format,downloadMetadataflowParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATAFLOWS_METADATAFLOW_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_3__constants_download__["j" /* ARTEFACT_TYPE_METADATAFLOW */],artefactTriplets[0],downloadMetadataflowParams.format,downloadMetadataflowParams.references,downloadMetadataflowParams.compression,lang),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_3__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_3__constants_download__["j" /* ARTEFACT_TYPE_METADATAFLOW */],downloadMetadataflowParams.format,downloadMetadataflowParams.compression)});};var showMetadataflowsMetadataflowClone=function showMetadataflowsMetadataflowClone(srcTriplet){return{type:METADATAFLOWS_METADATAFLOW_CLONE_SHOW,srcTriplet:srcTriplet};};var hideMetadataflowsMetadataflowClone=function hideMetadataflowsMetadataflowClone(){return{type:METADATAFLOWS_METADATAFLOW_CLONE_HIDE};};var changeMetadataflowsMetadataflowClone=function changeMetadataflowsMetadataflowClone(fields){return{type:METADATAFLOWS_METADATAFLOW_CLONE_CHANGE,fields:fields};};var submitMetadataflowsMetadataflowClone=function submitMetadataflowsMetadataflowClone(cloneDestTriplet,srcMetadataflow,annotationsConfig){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATAFLOWS_METADATAFLOW_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},srcMetadataflow,cloneDestTriplet,{isFinal:false,annotations:Object(__WEBPACK_IMPORTED_MODULE_4__utils_artefacts__["d" /* getFilteredAnnotations */])(srcMetadataflow.annotations,annotationsConfig),autoAnnotations:null}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["I" /* SDMX_JSON_METADATAFLOW_LIST_KEY */]),function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showMetadataflowsMetadataflowExport=function showMetadataflowsMetadataflowExport(sourceTriplet){return{type:METADATAFLOWS_METADATAFLOW_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideMetadataflowsMetadataflowExport=function hideMetadataflowsMetadataflowExport(){return{type:METADATAFLOWS_METADATAFLOW_EXPORT_HIDE};};var changeMetadataflowsMetadataflowExport=function changeMetadataflowsMetadataflowExport(fields){return{type:METADATAFLOWS_METADATAFLOW_EXPORT_CHANGE,fields:fields};};var submitMetadataflowsMetadataflowExport=function submitMetadataflowsMetadataflowExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATAFLOWS_METADATAFLOW_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||""),EnumType:"Metadataflow",CopyReferencedArtefact:false,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_5__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideMetadataflowsMetadataflowExportReport=function hideMetadataflowsMetadataflowExportReport(){return{type:METADATAFLOWS_METADATAFLOW_EXPORT_REPORT_HIDE};};var showMetadataflowsMetadataflowOwnership=function showMetadataflowsMetadataflowOwnership(metadataflowTripletStr){return{type:METADATAFLOWS_METADATAFLOW_OWNERSHIP_SHOW,metadataflowTripletStr:metadataflowTripletStr};};var hideMetadataflowsMetadataflowOwnership=function hideMetadataflowsMetadataflowOwnership(){return{type:METADATAFLOWS_METADATAFLOW_OWNERSHIP_HIDE};};var readMetadataflowsMetadataflowOwnershipUsersRead=function readMetadataflowsMetadataflowOwnershipUsersRead(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATAFLOWS_METADATAFLOW_OWNERSHIP_USERS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_110" /* getUsers */])());};var readMetadataflowsMetadataflowOwnershipOwnersRead=function readMetadataflowsMetadataflowOwnershipOwnersRead(metadataflowTripletStr){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_63" /* getMetadataflowOwnersUrl */])(metadataflowTripletStr));};var changeMetadataflowsMetadataflowOwnershipOwners=function changeMetadataflowsMetadataflowOwnershipOwners(owners){return{type:METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_CHANGE,owners:owners};};var submitMetadataflowsMetadataflowOwnership=function submitMetadataflowsMetadataflowOwnership(metadataflowTripletStr,owners){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_87" /* getSetOwnersUrl */])(),{type:"MetadataFlow",id:metadataflowTripletStr,owners:owners.map(function(username){return{username:username};})},function(t){return{success:t('scenes.metaManager.metadataflows.messages.ownership.success')};});};var readMetadataflowsMetadataflowParentsAndChildren=function readMetadataflowsMetadataflowParentsAndChildren(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideMetadataflowsMetadataflowParentsAndChildren=function hideMetadataflowsMetadataflowParentsAndChildren(){return{type:METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_HIDE};};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return METADATA_SET_CATEGORIZED_METADATA_SETS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return METADATA_SET_CATEGORY_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return METADATA_SET_METADATA_SET_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return METADATA_SET_METADATA_SET_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return METADATA_SET_METADATA_SET_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return METADATA_SET_METADATA_SET_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return METADATA_SET_METADATA_SET_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return METADATA_SET_METADATA_SET_CATEGORISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return METADATA_SET_METADATA_SET_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return METADATA_SET_METADATA_SET_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return METADATA_SET_METADATA_SET_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return METADATA_SET_METADATA_SET_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return METADATA_SET_METADATA_SET_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return METADATA_SET_METADATAFLOWS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return METADATA_SET_METADATAFLOWS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return METADATA_SET_METADATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return METADATA_SET_METADATAFLOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return METADATA_SET_METADATAFLOW_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return METADATA_SET_REPORT_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return METADATA_SET_REPORT_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return METADATA_SET_REPORT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return METADATA_SET_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return METADATA_SET_REPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return METADATA_SET_REPORT_STEP_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return METADATA_SET_REPORT_ATTRIBUTE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return METADATA_SET_REPORT_ATTRIBUTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return METADATA_SET_REPORT_ATTRIBUTE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return METADATA_SET_REPORT_ATTRIBUTE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return METADATA_SET_UPDATE_REPORT_STATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return METADATA_SET_REPORT_HTML_PAGE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return METADATA_SET_REPORT_HTML_PAGE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return METADATA_SET_REPORT_ATTRIBUTE_CODES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return METADATA_SET_REPORT_ATTRIBUTE_CODES_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return METADATA_SET_REPORT_ATTRIBUTE_CODES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return METADATA_SET_REPORT_ATTRIBUTE_CODE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return METADATA_SET_REPORT_ATTRIBUTE_CODE_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return METADATA_SET_REPORT_ID_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return METADATA_SET_REPORT_TARGET_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return METADATA_SET_REPORT_TARGET_ARTEFACTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return METADATA_SET_REPORT_TARGET_ARTEFACTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return METADATA_SET_REPORT_TARGET_ARTEFACTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return METADATA_SET_REPORT_TARGET_ARTEFACT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return METADATA_SET_REPORT_TARGET_ARTEFACT_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return METADATA_SET_CONCEPT_SCHEMES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return METADATA_SET_REPORT_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return METADATA_SET_METADATA_SET_HTML_PAGE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return METADATA_SET_METADATA_SET_HTML_PAGE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return readMetadataSetCategorizedMetadataSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return selectMetadataSetCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return selectMetadataSetMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return createMetadataSetMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return readMetadataSetMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return changeMetadataSetMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return submitMetadataSetMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return categoriseMetadataSetMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return deleteMetadataSetMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return showMetadataSetMetadataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return hideMetadataSetMetadataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return readMetadataSetMetadataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return setMetadataSetMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return unsetMetadataSetMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return createMetadataSetReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return deleteMetadataSetReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return readMetadataSetReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return hideMetadataSetReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return submitMetadataSetReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return submitMetadataSetUpdateReportState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return showMetadataSetReportHtmlPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return hideMetadataSetReportHtmlPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return setMetadataSetReportStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return selectMetadataSetReportAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return changeMetadataSetReportAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return createMetadataSetReportAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return deleteMetadataSetReportAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return showMetadataSetReportAttributeCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return hideMetadataSetReportAttributeCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return readMetadataSetReportAttributeCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return setMetadataSetReportAttributeCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return unsetMetadataSetReportAttributeCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return uploadMetadataSetReportAttributeAttachment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return downloadMetadataSetReportAttributeAttachment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return changeMetadataSetReportId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return selectMetadataSetReportTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return showMetadataSetReportTargetArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return hideMetadataSetReportTargetArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return readMetadataSetReportTargetArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return setMetadataSetReportTargetArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return unsetMetadataSetReportTargetArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return readMetadataSetConceptSchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return showMetadataSetMetadataSetClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return hideMetadataSetMetadataSetClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return changeMetadataSetMetadataSetClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return submitMetadataSetMetadataSetClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return downloadMetadataSetReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return showMetadataSetMetadataSetHtmlPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return hideMetadataSetMetadataSetHtmlPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_constants__ = __webpack_require__(161);
var METADATA_SET_CATEGORIZED_METADATA_SETS_READ="METADATA_SET_CATEGORIZED_METADATA_SETS_READ";var METADATA_SET_CATEGORY_SELECT="METADATA_SET_CATEGORY_SELECT";var METADATA_SET_METADATA_SET_SELECT="METADATA_SET_METADATA_SET_SELECT";var METADATA_SET_METADATA_SET_CREATE="METADATA_SET_METADATA_SET_CREATE";var METADATA_SET_METADATA_SET_READ="METADATA_SET_METADATA_SET_READ";var METADATA_SET_METADATA_SET_CHANGE="METADATA_SET_METADATA_SET_CHANGE";var METADATA_SET_METADATA_SET_SUBMIT="METADATA_SET_METADATA_SET_SUBMIT";var METADATA_SET_METADATA_SET_CATEGORISE="METADATA_SET_METADATA_SET_CATEGORISE";var METADATA_SET_METADATA_SET_DELETE="METADATA_SET_METADATA_SET_DELETE";var METADATA_SET_METADATA_SET_CLONE_SHOW="METADATA_SET_METADATA_SET_CLONE_SHOW";var METADATA_SET_METADATA_SET_CLONE_HIDE="METADATA_SET_METADATA_SET_CLONE_HIDE";var METADATA_SET_METADATA_SET_CLONE_CHANGE="METADATA_SET_METADATA_SET_CLONE_CHANGE";var METADATA_SET_METADATA_SET_CLONE_SUBMIT="METADATA_SET_METADATA_SET_CLONE_SUBMIT";var METADATA_SET_METADATAFLOWS_SHOW="METADATA_SET_METADATAFLOWS_SHOW";var METADATA_SET_METADATAFLOWS_HIDE="METADATA_SET_METADATAFLOWS_HIDE";var METADATA_SET_METADATAFLOWS_READ="METADATA_SET_METADATAFLOWS_READ";var METADATA_SET_METADATAFLOW_SET="METADATA_SET_METADATAFLOW_SET";var METADATA_SET_METADATAFLOW_UNSET="METADATA_SET_METADATAFLOW_UNSET";var METADATA_SET_REPORT_CREATE="METADATA_SET_REPORT_CREATE";var METADATA_SET_REPORT_DELETE="METADATA_SET_REPORT_DELETE";var METADATA_SET_REPORT_READ="METADATA_SET_REPORT_READ";var METADATA_SET_REPORT_HIDE="METADATA_SET_REPORT_HIDE";var METADATA_SET_REPORT_SUBMIT="METADATA_SET_REPORT_SUBMIT";var METADATA_SET_REPORT_STEP_SET="METADATA_SET_REPORT_STEP_SET";var METADATA_SET_REPORT_ATTRIBUTE_SELECT="METADATA_SET_REPORT_ATTRIBUTE_SELECT";var METADATA_SET_REPORT_ATTRIBUTE_CHANGE="METADATA_SET_REPORT_ATTRIBUTE_CHANGE";var METADATA_SET_REPORT_ATTRIBUTE_CREATE="METADATA_SET_REPORT_ATTRIBUTE_CREATE";var METADATA_SET_REPORT_ATTRIBUTE_DELETE="METADATA_SET_REPORT_ATTRIBUTE_DELETE";var METADATA_SET_UPDATE_REPORT_STATE_SUBMIT="METADATA_SET_UPDATE_REPORT_STATE_SUBMIT";var METADATA_SET_REPORT_HTML_PAGE_SHOW="METADATA_SET_REPORT_HTML_PAGE_SHOW";var METADATA_SET_REPORT_HTML_PAGE_HIDE="METADATA_SET_REPORT_HTML_PAGE_HIDE";var METADATA_SET_REPORT_ATTRIBUTE_CODES_SHOW="METADATA_SET_REPORT_ATTRIBUTE_CODES_SHOW";var METADATA_SET_REPORT_ATTRIBUTE_CODES_HIDE="METADATA_SET_REPORT_ATTRIBUTE_CODES_HIDE";var METADATA_SET_REPORT_ATTRIBUTE_CODES_READ="METADATA_SET_REPORT_ATTRIBUTE_CODES_READ";var METADATA_SET_REPORT_ATTRIBUTE_CODE_SET="METADATA_SET_REPORT_ATTRIBUTE_CODE_SET";var METADATA_SET_REPORT_ATTRIBUTE_CODE_UNSET="METADATA_SET_REPORT_ATTRIBUTE_CODE_UNSET";var METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD="METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD";var METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD="METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD";var METADATA_SET_REPORT_ID_CHANGE="METADATA_SET_REPORT_ID_CHANGE";var METADATA_SET_REPORT_TARGET_SELECT="METADATA_SET_REPORT_TARGET_SELECT";var METADATA_SET_REPORT_TARGET_ARTEFACTS_SHOW="METADATA_SET_REPORT_TARGET_ARTEFACTS_SHOW";var METADATA_SET_REPORT_TARGET_ARTEFACTS_HIDE="METADATA_SET_REPORT_TARGET_ARTEFACTS_HIDE";var METADATA_SET_REPORT_TARGET_ARTEFACTS_READ="METADATA_SET_REPORT_TARGET_ARTEFACTS_READ";var METADATA_SET_REPORT_TARGET_ARTEFACT_SET="METADATA_SET_REPORT_TARGET_ARTEFACT_SET";var METADATA_SET_REPORT_TARGET_ARTEFACT_UNSET="METADATA_SET_REPORT_TARGET_ARTEFACT_UNSET";var METADATA_SET_CONCEPT_SCHEMES_READ="METADATA_SET_CONCEPT_SCHEMES_READ";var METADATA_SET_REPORT_DOWNLOAD="METADATA_SET_REPORT_DOWNLOAD";var METADATA_SET_METADATA_SET_HTML_PAGE_SHOW="METADATA_SET_METADATA_SET_HTML_PAGE_SHOW";var METADATA_SET_METADATA_SET_HTML_PAGE_HIDE="METADATA_SET_METADATA_SET_HTML_PAGE_HIDE";var readMetadataSetCategorizedMetadataSets=function readMetadataSetCategorizedMetadataSets(lang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(METADATA_SET_CATEGORIZED_METADATA_SETS_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["p" /* getCategorySchemeUrl */])(null,true),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_62" /* getMetadataSetsUrl */])()]),{lang:lang});};var selectMetadataSetCategory=function selectMetadataSetCategory(categoryId,categoryUrn){return{type:METADATA_SET_CATEGORY_SELECT,categoryId:categoryId,categoryUrn:categoryUrn};};var selectMetadataSetMetadataSet=function selectMetadataSetMetadataSet(metadataSet,msdTriplet){return{type:METADATA_SET_METADATA_SET_SELECT,metadataSet:metadataSet,msdTriplet:msdTriplet};};var createMetadataSetMetadataSet=function createMetadataSetMetadataSet(){return{type:METADATA_SET_METADATA_SET_CREATE};};var readMetadataSetMetadataSet=function readMetadataSetMetadataSet(metadataSetId,msdTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(METADATA_SET_METADATA_SET_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_60" /* getMetadataSetReportsUrl */])(metadataSetId),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_66" /* getMsdUrl */])(msdTriplet)]);};var changeMetadataSetMetadataSet=function changeMetadataSetMetadataSet(fields){return{type:METADATA_SET_METADATA_SET_CHANGE,fields:fields};};var submitMetadataSetMetadataSet=function submitMetadataSetMetadataSet(metadataSet,categoryUrn){var newCategorisation=null;if(categoryUrn){var catId='CAT_'+metadataSet.metadataflowTriplet.id.substr(0,40)+'_'+String(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.random(99999)).padStart(5,'0');newCategorisation={id:catId,agencyID:metadataSet.metadataflowTriplet.agencyID,version:metadataSet.metadataflowTriplet.version,source:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(metadataSet.metadataflowTriplet,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["J" /* SDMX_JSON_METADATAFLOW_URN_NAMESPACE */]),target:categoryUrn};}var autoAnnotations=Object(__WEBPACK_IMPORTED_MODULE_5__commons_constants__["e" /* getWorkingAnnotations */])(metadataSet);if(newCategorisation){autoAnnotations.push({id:"categorisation_["+newCategorisation.id+"]",text:{en:newCategorisation.id+"+"+newCategorisation.agencyID+"+"+newCategorisation.version+"+"+newCategorisation.source+"+"+newCategorisation.target}});}else{var categorisationAnnotations=(metadataSet.annotations||[]).concat(metadataSet.autoAnnotations||[]).filter(function(annotation){return annotation.id.substring(0,14)==="categorisation";});autoAnnotations=autoAnnotations.concat(categorisationAnnotations);}var idAnnotation=Object(__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */]);if(idAnnotation){autoAnnotations.push(idAnnotation);}return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATA_SET_METADATA_SET_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_109" /* getUpsertMetadataSetUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},metadataSet,{reports:undefined,autoAnnotations:autoAnnotations}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["K" /* SDMX_JSON_METADATA_SET_LIST_KEY */]),function(t){return{success:idAnnotation!==undefined?t('scenes.referenceMetadata.metadataSet.messages.metadataSet.update.success'):t('scenes.referenceMetadata.metadataSet.messages.metadataSet.create.success')};}),{metadataSetId:metadataSet.id,metadataSetCategory:categoryUrn||metadataSet.categoryUrn,msdTriplet:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(metadataSet.msdUrn)});};var categoriseMetadataSetMetadataSet=function categoriseMetadataSetMetadataSet(metadataSet,categoryUrn){var categorisations=[];if(metadataSet.categoryUrn){categorisations=Object(__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["D" /* getCategorisationsFromAnnotations */])(metadataSet)||[];var catToEdit=categorisations.find(function(categorisation){return categorisation.target===metadataSet.categoryUrn;});if(categoryUrn){catToEdit.target=categoryUrn;}else{categorisations=categorisations.filter(function(cat){return cat.id!==catToEdit.id;});}}else{var categorisationId='CAT_'+metadataSet.metadataflowTriplet.id.substr(0,40)+'_'+String(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.random(99999)).padStart(5,'0');categorisations=[{id:categorisationId,agencyID:metadataSet.metadataflowTriplet.agencyID,version:metadataSet.metadataflowTriplet.version,source:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(metadataSet.metadataflowTriplet,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["J" /* SDMX_JSON_METADATAFLOW_URN_NAMESPACE */]),target:categoryUrn}];}return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATA_SET_METADATA_SET_CATEGORISE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_109" /* getUpsertMetadataSetUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},metadataSet,{reports:undefined,autoAnnotations:[],annotations:(metadataSet.annotations||[]).concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */])).concat(Object(__WEBPACK_IMPORTED_MODULE_5__commons_constants__["e" /* getWorkingAnnotations */])(metadataSet)).concat(categorisations.map(function(cat){return{id:"categorisation_["+cat.id+"]",text:{en:cat.id+"+"+cat.agencyID+"+"+cat.version+"+"+cat.source+"+"+cat.target}};}))}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["K" /* SDMX_JSON_METADATA_SET_LIST_KEY */]),function(t){return{success:metadataSet.categoryUrn?categoryUrn?t('scenes.referenceMetadata.metadataSet.messages.categorisation.update.success'):t('scenes.referenceMetadata.metadataSet.messages.categorisation.remove.success'):t('scenes.referenceMetadata.metadataSet.messages.categorisation.create.success')};}),{metadataSetId:metadataSet.categoryUrn&&!categoryUrn?null:metadataSet.id,metadataSetCategory:metadataSet.categoryUrn&&!categoryUrn?null:categoryUrn,msdTriplet:metadataSet.categoryUrn&&!categoryUrn?null:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(metadataSet.msdUrn)});};var deleteMetadataSetMetadataSet=function deleteMetadataSetMetadataSet(metadataSetId){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(METADATA_SET_METADATA_SET_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_15" /* getDeleteMetadataSetUrl */])(metadataSetId),function(t){return{success:t('scenes.referenceMetadata.metadataSet.messages.metadataSet.delete.success')};}),{metadataSetId:metadataSetId});};var showMetadataSetMetadataflows=function showMetadataSetMetadataflows(){return{type:METADATA_SET_METADATAFLOWS_SHOW};};var hideMetadataSetMetadataflows=function hideMetadataSetMetadataflows(){return{type:METADATA_SET_METADATAFLOWS_HIDE};};var readMetadataSetMetadataflows=function readMetadataSetMetadataflows(ownedMetadataflows){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATA_SET_METADATAFLOWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_64" /* getMetadataflowUrl */])()),{ownedMetadataflows:ownedMetadataflows});};var setMetadataSetMetadataflow=function setMetadataSetMetadataflow(triplet,msdUrn){return{type:METADATA_SET_METADATAFLOW_SET,triplet:triplet,msdUrn:msdUrn};};var unsetMetadataSetMetadataflow=function unsetMetadataSetMetadataflow(){return{type:METADATA_SET_METADATAFLOW_UNSET};};var createMetadataSetReport=function createMetadataSetReport(){return{type:METADATA_SET_REPORT_CREATE};};var deleteMetadataSetReport=function deleteMetadataSetReport(reportId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(METADATA_SET_REPORT_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_16" /* getDeleteReportUrl */])(reportId),function(t){return{success:t('scenes.referenceMetadata.metadataSet.messages.report.delete.success')};});};var readMetadataSetReport=function readMetadataSetReport(metadataSetId,reportId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATA_SET_REPORT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_59" /* getMetadataSetReportUrl */])(metadataSetId,reportId));};var hideMetadataSetReport=function hideMetadataSetReport(){return{type:METADATA_SET_REPORT_HIDE};};var submitMetadataSetReport=function submitMetadataSetReport(metadataSet,report,reportAnnotations,reportStructure,id,target,identifiableTargets,annotationsConfig,isDraft){var annotations=report?report.annotations:reportAnnotations?reportAnnotations:[];annotations=Object(__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["V" /* updateReportStateAnnotations */])(annotations,isDraft);var reportRoot={id:id,target:{id:target,referenceValues:identifiableTargets.map(function(value){return{id:value.id,object:value.value};})},annotations:annotations.length>0?annotations:undefined,attributeSet:{reportedAttributes:[]}};return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATA_SET_REPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_108" /* getUpsertJsonReportUrl */])(metadataSet.id),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},metadataSet,{reports:[Object(__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["R" /* getSdmxJsonReportFromReportStructure */])(reportStructure,reportRoot,annotationsConfig)]}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["K" /* SDMX_JSON_METADATA_SET_LIST_KEY */]),function(t){return{success:report||reportAnnotations?t('scenes.referenceMetadata.metadataSet.messages.report.update.success'):t('scenes.referenceMetadata.metadataSet.messages.report.create.success')};});};var submitMetadataSetUpdateReportState=function submitMetadataSetUpdateReportState(metadataSetId,reportId,newState){var formData=new FormData();formData.append('newState',newState);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATA_SET_UPDATE_REPORT_STATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_102" /* getUpdateStateReportUrl */])(metadataSetId,reportId),formData,function(t){return{success:t('scenes.referenceMetadata.metadataSet.messages.report.stateUpdate.success')};});};var showMetadataSetReportHtmlPage=function showMetadataSetReportHtmlPage(htmlPageUrl){return{type:METADATA_SET_REPORT_HTML_PAGE_SHOW,htmlPageUrl:htmlPageUrl};};var hideMetadataSetReportHtmlPage=function hideMetadataSetReportHtmlPage(){return{type:METADATA_SET_REPORT_HTML_PAGE_HIDE};};var setMetadataSetReportStep=function setMetadataSetReportStep(step,dataLanguages,t){return{type:METADATA_SET_REPORT_STEP_SET,step:step,dataLanguages:dataLanguages,t:t};};var selectMetadataSetReportAttribute=function selectMetadataSetReportAttribute(selectedAttributeKey){return{type:METADATA_SET_REPORT_ATTRIBUTE_SELECT,selectedAttributeKey:selectedAttributeKey};};var changeMetadataSetReportAttribute=function changeMetadataSetReportAttribute(fields){return{type:METADATA_SET_REPORT_ATTRIBUTE_CHANGE,fields:fields};};var createMetadataSetReportAttribute=function createMetadataSetReportAttribute(){return{type:METADATA_SET_REPORT_ATTRIBUTE_CREATE};};var deleteMetadataSetReportAttribute=function deleteMetadataSetReportAttribute(){return{type:METADATA_SET_REPORT_ATTRIBUTE_DELETE};};var showMetadataSetReportAttributeCodes=function showMetadataSetReportAttributeCodes(){return{type:METADATA_SET_REPORT_ATTRIBUTE_CODES_SHOW};};var hideMetadataSetReportAttributeCodes=function hideMetadataSetReportAttributeCodes(){return{type:METADATA_SET_REPORT_ATTRIBUTE_CODES_HIDE};};var readMetadataSetReportAttributeCodes=function readMetadataSetReportAttributeCodes(triplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATA_SET_REPORT_ATTRIBUTE_CODES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["A" /* getCodelistUrl */])(triplet));};var setMetadataSetReportAttributeCode=function setMetadataSetReportAttributeCode(codeId){return{type:METADATA_SET_REPORT_ATTRIBUTE_CODE_SET,codeId:codeId};};var unsetMetadataSetReportAttributeCode=function unsetMetadataSetReportAttributeCode(){return{type:METADATA_SET_REPORT_ATTRIBUTE_CODE_UNSET};};var uploadMetadataSetReportAttributeAttachment=function uploadMetadataSetReportAttributeAttachment(file,lang){var fileFormData=new FormData();fileFormData.append('file',file);return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_107" /* getUploadRMFileOnServerUrl */])(),fileFormData,function(t){return{success:t("scenes.referenceMetadata.commons.messages.attachmentUpload.success")};}),{lang:lang});};var downloadMetadataSetReportAttributeAttachment=function downloadMetadataSetReportAttributeAttachment(fileName){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_29" /* getDownloadRMFileOnServerUrl */])(fileName),undefined,true),{fileSave:{name:fileName}});};var changeMetadataSetReportId=function changeMetadataSetReportId(id){return{type:METADATA_SET_REPORT_ID_CHANGE,id:id};};var selectMetadataSetReportTarget=function selectMetadataSetReportTarget(target){return{type:METADATA_SET_REPORT_TARGET_SELECT,target:target};};var showMetadataSetReportTargetArtefacts=function showMetadataSetReportTargetArtefacts(identifiableTarget){return{type:METADATA_SET_REPORT_TARGET_ARTEFACTS_SHOW,identifiableTarget:identifiableTarget};};var hideMetadataSetReportTargetArtefacts=function hideMetadataSetReportTargetArtefacts(){return{type:METADATA_SET_REPORT_TARGET_ARTEFACTS_HIDE};};var readMetadataSetReportTargetArtefacts=function readMetadataSetReportTargetArtefacts(identifiableTarget){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATA_SET_REPORT_TARGET_ARTEFACTS_READ,__WEBPACK_IMPORTED_MODULE_5__commons_constants__["a" /* ARTEFACT_TYPES */].find(function(_ref){var type=_ref.type;return type===identifiableTarget.objectType.toLowerCase();}).url);};var setMetadataSetReportTargetArtefact=function setMetadataSetReportTargetArtefact(value,identifiableTargetId){return{type:METADATA_SET_REPORT_TARGET_ARTEFACT_SET,value:value,identifiableTargetId:identifiableTargetId};};var unsetMetadataSetReportTargetArtefact=function unsetMetadataSetReportTargetArtefact(identifiableTarget){return{type:METADATA_SET_REPORT_TARGET_ARTEFACT_UNSET,identifiableTarget:identifiableTarget};};var readMetadataSetConceptSchemes=function readMetadataSetConceptSchemes(conceptSchemeTriplets,appLang,dataLangs){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(METADATA_SET_CONCEPT_SCHEMES_READ,conceptSchemeTriplets.map(function(_){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */];}),conceptSchemeTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])(triplet);})),{appLang:appLang,dataLangs:dataLangs});};var showMetadataSetMetadataSetClone=function showMetadataSetMetadataSetClone(){return{type:METADATA_SET_METADATA_SET_CLONE_SHOW};};var hideMetadataSetMetadataSetClone=function hideMetadataSetMetadataSetClone(){return{type:METADATA_SET_METADATA_SET_CLONE_HIDE};};var changeMetadataSetMetadataSetClone=function changeMetadataSetMetadataSetClone(fields){return{type:METADATA_SET_METADATA_SET_CLONE_CHANGE,fields:fields};};var submitMetadataSetMetadataSetClone=function submitMetadataSetMetadataSetClone(metadataSetId,newMetadataSetId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(METADATA_SET_METADATA_SET_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["y" /* getCloneMetadataSetUrl */])(metadataSetId,newMetadataSetId),function(t){return{success:t('scenes.referenceMetadata.metadataSet.messages.metadataSet.clone.success')};});};var downloadMetadataSetReport=function downloadMetadataSetReport(metadataSetId,reportId,fileName,metadataApiBaseUrl){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(METADATA_SET_REPORT_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["K" /* getMetadataApiReportUrl */])(metadataApiBaseUrl,metadataSetId,reportId)),{fileSave:{name:fileName,stringifyResponse:true}});};var showMetadataSetMetadataSetHtmlPage=function showMetadataSetMetadataSetHtmlPage(htmlPageUrl){return{type:METADATA_SET_METADATA_SET_HTML_PAGE_SHOW,htmlPageUrl:htmlPageUrl};};var hideMetadataSetMetadataSetHtmlPage=function hideMetadataSetMetadataSetHtmlPage(){return{type:METADATA_SET_METADATA_SET_HTML_PAGE_HIDE};};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dsd_detail__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__artefact_selectors_CodelistSelector__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__artefact_selectors_ConceptSchemeSelector__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__artefact_selectors_ConceptSelector__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__component_details_DimensionDetail__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__component_details_GroupDetail__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__component_details_AttributeDetail__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__redux_concept_scheme_detail_modal_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__redux_concept_scheme_detail_modal__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__artefact_selectors_NotDisplayedCodesSelector__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__artefact_selectors_DefaultCodesSelector__ = __webpack_require__(1393);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodeId:state.app.endpointId,nodes:state.config.nodes,permissions:state.app.user.permissions,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,isVisible:instanceState.isVisible,isAgenciesValid:instanceState.isAgenciesValid,dsd:instanceState.dsd,dsdTriplet:instanceState.dsdTriplet,isEditDisabled:instanceState.isEditDisabled,agencies:instanceState.agencies,allAgencies:instanceState.allAgencies,cloneDestTriplet:instanceState.cloneDestTriplet,downloadDsdTriplets:instanceState.downloadDsdTriplets,downloadDsdLang:instanceState.downloadDsdLang,downloadDsdParams:instanceState.downloadDsdParams,dsdExportSourceTriplet:instanceState.dsdExportSourceTriplet,dsdExportDestination:instanceState.dsdExportDestination,dsdExportReport:instanceState.dsdExportReport,codelistDetail:instanceState.codelistDetail,conceptSchemeDetail:instanceState.conceptSchemeDetail,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_48" /* hideDsdDetail */])(),instancePrefix));},onDimensionCreate:function onDimensionCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_39" /* createDsdDetailDimension */])(),instancePrefix));},onDimensionDetail:function onDimensionDetail(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_46" /* editDsdDetailDimension */])(id),instancePrefix));},onDimensionDelete:function onDimensionDelete(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_42" /* deleteDsdDetailDimension */])(id),instancePrefix));},onGroupCreate:function onGroupCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_40" /* createDsdDetailGroup */])(),instancePrefix));},onGroupDetail:function onGroupDetail(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_47" /* editDsdDetailGroup */])(id),instancePrefix));},onGroupDelete:function onGroupDelete(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_43" /* deleteDsdDetailGroup */])(id),instancePrefix));},onAttributeCreate:function onAttributeCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_38" /* createDsdDetailAttribute */])(),instancePrefix));},onAttributeDetail:function onAttributeDetail(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_45" /* editDsdDetailAttribute */])(id),instancePrefix));},onAttributeDelete:function onAttributeDelete(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_41" /* deleteDsdDetailAttribute */])(id),instancePrefix));},onConceptSchemeDetailShow:function onConceptSchemeDetailShow(conceptSchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_35__redux_concept_scheme_detail_modal_actions__["_38" /* showConceptSchemeDetail */])(conceptSchemeTriplet,defaultItemsViewMode),instancePrefix+__WEBPACK_IMPORTED_MODULE_32__reducer__["b" /* DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX */]));},onCodelistDetailShow:function onCodelistDetailShow(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_34__redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),instancePrefix+__WEBPACK_IMPORTED_MODULE_32__reducer__["a" /* DSD_DETAIL_CODELIST_DETAIL_PREFIX */]));},onDownloadShow:function onDownloadShow(dsdTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_78" /* showDsdDetailDownload */])(dsdTriplets,lang),instancePrefix));},onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_56" /* hideDsdDetailDownload */])(),instancePrefix));},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_32" /* changeDsdDetailDownload */])(fields),instancePrefix));},onDownloadSubmit:function onDownloadSubmit(artefactTriplets,downloadDsdParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_87" /* submitDsdDetailDownload */])(artefactTriplets,downloadDsdParams,lang),instancePrefix));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_73" /* showDsdDetailClone */])(artefactTriplet),instancePrefix));},onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_50" /* hideDsdDetailClone */])(),instancePrefix));},onCloneSubmit:function onCloneSubmit(cloneDestTriplet,srcDsd,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_83" /* submitDsdDetailClone */])(cloneDestTriplet,srcDsd,annotationsConfig),instancePrefix));},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_22" /* changeDsdDetailClone */])(fields),instancePrefix));},onConceptSchemesForSelectorShow:function onConceptSchemesForSelectorShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_76" /* showDsdDetailConceptSchemesForSelector */])(),instancePrefix));},onCodelistsForSelectorShow:function onCodelistsForSelectorShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_74" /* showDsdDetailCodelistsForSelector */])(),instancePrefix));},onPrimaryMeasureChange:function onPrimaryMeasureChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_36" /* changeDsdDetailPrimaryMeasure */])(fields),instancePrefix));},onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_20" /* changeDsdDetail */])(fields),instancePrefix));},onSubmitCreate:function onSubmitCreate(dsd){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_84" /* submitDsdDetailCreate */])(dsd),instancePrefix));},onSubmitUpdate:function onSubmitUpdate(dsd){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_91" /* submitDsdDetailUpdate */])(dsd),instancePrefix));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_63" /* readDsdDetailAgencies */])(allowedAgencies),instancePrefix));},fetchDsd:function fetchDsd(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_62" /* readDsdDetail */])(dsdTriplet),instancePrefix));},fetchCodelists:function fetchCodelists(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_64" /* readDsdDetailCodelists */])(),instancePrefix));},fetchConceptSchemes:function fetchConceptSchemes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_66" /* readDsdDetailConceptSchemes */])(),instancePrefix));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_79" /* showDsdDetailDsdExport */])(sourceTriplet),instancePrefix));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_57" /* hideDsdDetailDsdExport */])(),instancePrefix));},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_33" /* changeDsdDetailDsdExport */])(fields),instancePrefix));},onExportSubmit:function onExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_88" /* submitDsdDetailDsdExport */])(sourceTriplet,destination),instancePrefix));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_58" /* hideDsdDetailDsdExportReport */])(),instancePrefix));}};};var ReduxDsdDetailModal=function ReduxDsdDetailModal(_ref3){var t=_ref3.t,nodeId=_ref3.nodeId,nodes=_ref3.nodes,permissions=_ref3.permissions,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,instanceState=_ref3.instanceState,instancePrefix=_ref3.instancePrefix,isVisible=_ref3.isVisible,isAgenciesValid=_ref3.isAgenciesValid,dsd=_ref3.dsd,dsdTriplet=_ref3.dsdTriplet,isEditDisabled=_ref3.isEditDisabled,agencies=_ref3.agencies,allAgencies=_ref3.allAgencies,codelistDetail=_ref3.codelistDetail,conceptSchemeDetail=_ref3.conceptSchemeDetail,user=_ref3.user,onHide=_ref3.onHide,onChange=_ref3.onChange,onPrimaryMeasureChange=_ref3.onPrimaryMeasureChange,_onDimensionDetail=_ref3.onDimensionDetail,onDimensionCreate=_ref3.onDimensionCreate,_onDimensionDelete=_ref3.onDimensionDelete,_onGroupDetail=_ref3.onGroupDetail,onGroupCreate=_ref3.onGroupCreate,_onGroupDelete=_ref3.onGroupDelete,_onAttributeDetail=_ref3.onAttributeDetail,onAttributeCreate=_ref3.onAttributeCreate,_onAttributeDelete=_ref3.onAttributeDelete,onSubmitCreate=_ref3.onSubmitCreate,onSubmitUpdate=_ref3.onSubmitUpdate,onCodelistDetailShow=_ref3.onCodelistDetailShow,onConceptSchemeDetailShow=_ref3.onConceptSchemeDetailShow,fetchDsd=_ref3.fetchDsd,fetchCodelists=_ref3.fetchCodelists,fetchConceptSchemes=_ref3.fetchConceptSchemes,fetchAgencies=_ref3.fetchAgencies,onCodelistsForSelectorShow=_ref3.onCodelistsForSelectorShow,onConceptSchemesForSelectorShow=_ref3.onConceptSchemesForSelectorShow,downloadDsdTriplets=_ref3.downloadDsdTriplets,downloadDsdLang=_ref3.downloadDsdLang,downloadDsdParams=_ref3.downloadDsdParams,onDownloadShow=_ref3.onDownloadShow,onDownloadHide=_ref3.onDownloadHide,onDownloadChange=_ref3.onDownloadChange,onDownloadSubmit=_ref3.onDownloadSubmit,cloneDestTriplet=_ref3.cloneDestTriplet,onCloneShow=_ref3.onCloneShow,onCloneHide=_ref3.onCloneHide,onCloneSubmit=_ref3.onCloneSubmit,onCloneChange=_ref3.onCloneChange,dsdExportSourceTriplet=_ref3.dsdExportSourceTriplet,dsdExportDestination=_ref3.dsdExportDestination,dsdExportReport=_ref3.dsdExportReport,onExportShow=_ref3.onExportShow,onExportHide=_ref3.onExportHide,onExportChange=_ref3.onExportChange,onExportSubmit=_ref3.onExportSubmit,onExportReportHide=_ref3.onExportReportHide;var getRelatedComponentId=function getRelatedComponentId(id){return[].concat(_toConsumableArray(dsd.groups||[]),_toConsumableArray(dsd.attributes||[])).find(function(_ref4){var groupDimensions=_ref4.groupDimensions,attachedDimensions=_ref4.attachedDimensions,attachmentGroup=_ref4.attachmentGroup;return(groupDimensions||attachedDimensions||(attachmentGroup?[attachmentGroup]:null)||[]).find(function(compId){return compId===id;});});};var userHasPermissionsToEdit=permissions&&dsdTriplet&&permissions.agencies.filter(function(agency){return agency===dsdTriplet.agencyID;}).length>0;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchCodelists,disabled:!isVisible},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchConceptSchemes,disabled:!isVisible},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchDsd,cbParam:dsdTriplet,disabled:dsdTriplet===null||dsd!==null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:isAgenciesValid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_XL"],title:dsdTriplet!==null?userHasPermissionsToEdit&&!isEditDisabled?t('reduxComponents.dsdDetail.title.editMode.title',{triplet:dsdTriplet}):t('reduxComponents.dsdDetail.title.viewMode.title',{triplet:dsdTriplet}):t('reduxComponents.dsdDetail.title.createMode.title'),onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),(dsdTriplet===null||userHasPermissionsToEdit)&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_28__utils_artefactValidators__["a" /* isArtefactValid */])(dsd)){if(dsd&&dsd.primaryMeasure.id&&dsd.primaryMeasure.concept&&dsd.dimensions&&dsd.dimensions.length&&dsd.dimensions.find(function(_ref5){var type=_ref5.type;return type===__WEBPACK_IMPORTED_MODULE_27__utils_sdmxJson__["l" /* DSD_DIMENSION_TYPE_NORMAL */];})){return dsdTriplet?onSubmitUpdate(dsd):onSubmitCreate(dsd);}else{return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('reduxComponents.dsdDetail.modals.warnings.submitIncomplete.title'),content:t('reduxComponents.dsdDetail.modals.warnings.submitIncomplete.content')});}}else{__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.buttons.save.title'))),withDataLanguageSelector:true},dsdTriplet&&permissions&&!userHasPermissionsToEdit&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a,{type:"warning",showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),dsdTriplet&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],justify:"end"},onDownloadShow&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:"primary",shape:"circle",icon:"download",size:"small",title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onDownloadShow([dsdTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:"primary",shape:"circle",icon:"copy",size:"small",title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){return onCloneShow(dsdTriplet);}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:"primary",shape:"circle",icon:"export",size:"small",title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onExportShow(dsdTriplet);}}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__dsd_detail__["a" /* default */],{dsd:dsd,mode:dsdTriplet===null?__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */]:userHasPermissionsToEdit&&!isEditDisabled?__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],isComponentsDisabled:dsd&&dsd.remoteIsFinal,agencies:agencies,onGeneralChange:onChange,onPrimaryMeasureChange:onPrimaryMeasureChange,onDimensionDetail:function onDimensionDetail(_ref6){var id=_ref6.id;return _onDimensionDetail(id);},onDimensionCreate:onDimensionCreate,onDimensionDelete:function onDimensionDelete(_ref7){var id=_ref7.id;return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('reduxComponents.dsdDetail.component.deleteConfirmModal.title',{id:id}),onOk:function onOk(){var relatedComponent=getRelatedComponentId(id);relatedComponent?__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('reduxComponents.dsdDetail.component.deleteWarningModal.title',{id:id}),content:t('reduxComponents.dsdDetail.component.deleteWarningModal.content',{component:relatedComponent.id})}):_onDimensionDelete(id);},cancelText:t('commons.buttons.cancel.title')});},onGroupDetail:function onGroupDetail(_ref8){var id=_ref8.id;return _onGroupDetail(id);},onGroupCreate:onGroupCreate,onGroupDelete:function onGroupDelete(_ref9){var id=_ref9.id;return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('reduxComponents.dsdDetail.component.deleteConfirmModal.title',{id:id}),onOk:function onOk(){var relatedComponent=getRelatedComponentId(id);relatedComponent?__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('reduxComponents.dsdDetail.component.deleteWarningModal.title',{id:id}),content:t('reduxComponents.dsdDetail.component.deleteWarningModal.content',{component:relatedComponent.id})}):_onGroupDelete(id);},cancelText:t('commons.buttons.cancel.title')});},onAttributeDetail:function onAttributeDetail(_ref10){var id=_ref10.id;return _onAttributeDetail(id);},onAttributeCreate:onAttributeCreate,onAttributeDelete:function onAttributeDelete(_ref11){var id=_ref11.id;return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('reduxComponents.dsdDetail.component.deleteConfirmModal.title',{id:id}),onOk:function onOk(){_onAttributeDelete(id);},cancelText:t('commons.buttons.cancel.title')});},onCodelistDetail:function onCodelistDetail(codelistTriplet){return onCodelistDetailShow(codelistTriplet,defaultItemsViewMode);},onConceptDetail:function onConceptDetail(codelistTriplet){return onConceptSchemeDetailShow(codelistTriplet,defaultItemsViewMode);},onConceptSchemeDetail:function onConceptSchemeDetail(conceptSchemeTriplet){return onConceptSchemeDetailShow(conceptSchemeTriplet,defaultItemsViewMode);},onPrimaryMeasureCodelistSelect:onCodelistsForSelectorShow,onPrimaryMeasureConceptSelect:onConceptSchemesForSelectorShow}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__component_details_DimensionDetail__["a" /* default */],{userHasPermissionsToEdit:userHasPermissionsToEdit&&!isEditDisabled,instanceState:instanceState,instancePrefix:instancePrefix}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__component_details_GroupDetail__["a" /* default */],{userHasPermissionsToEdit:userHasPermissionsToEdit&&!isEditDisabled,instanceState:instanceState,instancePrefix:instancePrefix}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__component_details_AttributeDetail__["a" /* default */],{userHasPermissionsToEdit:userHasPermissionsToEdit&&!isEditDisabled,instanceState:instanceState,instancePrefix:instancePrefix}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__redux_codelist_detail_modal__["a" /* default */],{instancePrefix:instancePrefix+__WEBPACK_IMPORTED_MODULE_32__reducer__["a" /* DSD_DETAIL_CODELIST_DETAIL_PREFIX */],instanceState:codelistDetail}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__redux_concept_scheme_detail_modal__["a" /* default */],{instancePrefix:instancePrefix+__WEBPACK_IMPORTED_MODULE_32__reducer__["b" /* DSD_DETAIL_CONCEPT_SCHEME_DETAIL_PREFIX */],instanceState:conceptSchemeDetail}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__artefact_selectors_ConceptSelector__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__artefact_selectors_CodelistSelector__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__artefact_selectors_ConceptSchemeSelector__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__artefact_selectors_NotDisplayedCodesSelector__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__artefact_selectors_DefaultCodesSelector__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix}))));}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__["a" /* default */],{visible:downloadDsdTriplets!==null&&downloadDsdTriplets!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:function onClick(){return onDownloadSubmit(downloadDsdTriplets,downloadDsdParams,downloadDsdLang);},type:"primary",disabled:downloadDsdParams&&downloadDsdParams.format===null},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_SM"],title:downloadDsdTriplets&&downloadDsdTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadDsdTriplets?Object(__WEBPACK_IMPORTED_MODULE_27__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadDsdTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadDsdParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_39__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadDsdTriplets&&downloadDsdTriplets.length>1?__WEBPACK_IMPORTED_MODULE_39__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_39__constants_download__["h" /* ARTEFACT_TYPE_DSD */]),langs:dataLanguages,hasReferences:true})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_28__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(cloneDestTriplet,dsd,nodes.find(function(node){return node.general.id===nodeId;}).annotations);}},type:"primary"},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:dsd,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__["a" /* default */],{visible:dsdExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_28__utils_artefactValidators__["e" /* isExportDestinationValid */])(dsdExportDestination,(user&&user.providerId)!==null)){onExportSubmit(dsdExportSourceTriplet,dsdExportDestination);}else{__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_artefact_export_form__["b" /* default */],{type:"datastructure",agencies:allAgencies,sourceTriplet:dsdExportSourceTriplet,destination:dsdExportDestination,onChange:onExportChange,withReferences:true})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__["a" /* default */],{visible:dsdExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_artefact_export_report__["a" /* default */],{report:dsdExportReport})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_16_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ReduxDsdDetailModal));

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(241);
var core = __webpack_require__(113);
var ctx = __webpack_require__(1202);
var hide = __webpack_require__(1204);
var has = __webpack_require__(532);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(243)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DSD_COMPONENT_TYPE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DSD_COMPONENT_TYPE_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DSD_COMPONENT_TYPE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DSD_COMPONENT_TYPE_ATTRIBUTE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_annotations_form__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__getSdmxDimensionTypesTranslations__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__getSdmxAttributeAttachmentLevelTranslations__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_localized_month_picker__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_artefactValidators__ = __webpack_require__(37);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]}};var mapPropsToFields=function mapPropsToFields(_ref){var component=_ref.component;return{type:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component?component.type:null}),id:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component?component.id:null}),order:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component?component.order:null}),concept:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component&&component.concept?Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["_2" /* getStringFromItemUrn */])(component.concept):null}),representation:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component&&component.representation?Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(component.representation)):null}),groupDimensions:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component?component.groupDimensions||[]:null}),assignmentStatus:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component?component.assignmentStatus:null}),attachmentLevel:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component?component.attachmentLevel:null}),attachedDimensions:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component?component.attachedDimensions||[]:null}),attachmentGroup:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:component?component.attachmentGroup:null})};};var DSD_COMPONENT_TYPE_MEASURE='DSD_COMPONENT_TYPE_MEASURE';var DSD_COMPONENT_TYPE_DIMENSION='DSD_COMPONENT_TYPE_DIMENSION';var DSD_COMPONENT_TYPE_GROUP='DSD_COMPONENT_TYPE_GROUP';var DSD_COMPONENT_TYPE_ATTRIBUTE='DSD_COMPONENT_TYPE_ATTRIBUTE';var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var ComponentForm=function ComponentForm(_ref3){var t=_ref3.t,component=_ref3.component,mode=_ref3.mode,disableAnnotations=_ref3.disableAnnotations,type=_ref3.type,form=_ref3.form,dimensions=_ref3.dimensions,groups=_ref3.groups,notDisplayedVal=_ref3.notDisplayedVal,defaultVal=_ref3.defaultVal,defaultTimeDimensionStart=_ref3.defaultTimeDimensionStart,defaultTimeDimensionEnd=_ref3.defaultTimeDimensionEnd,defaultTimeDimensionLastNObservations=_ref3.defaultTimeDimensionLastNObservations,defaultTimeDimensionLastNPeriods=_ref3.defaultTimeDimensionLastNPeriods,defaultTimeDimensionMode=_ref3.defaultTimeDimensionMode,onChange=_ref3.onChange,onNotDisplayedValChange=_ref3.onNotDisplayedValChange,onDefaultValChange=_ref3.onDefaultValChange,onConceptSelect=_ref3.onConceptSelect,onConceptSchemeSelect=_ref3.onConceptSchemeSelect,onCodelistSelect=_ref3.onCodelistSelect,onNotDisplayedCodesSelectorShow=_ref3.onNotDisplayedCodesSelectorShow,onDefaultCodesSelectorShow=_ref3.onDefaultCodesSelectorShow,onDefaultTimeDimensionStartChange=_ref3.onDefaultTimeDimensionStartChange,onDefaultTimeDimensionEndChange=_ref3.onDefaultTimeDimensionEndChange,onDefaultTimeDimensionLastNObservationsChange=_ref3.onDefaultTimeDimensionLastNObservationsChange,onDefaultTimeDimensionLastNPeriodsChange=_ref3.onDefaultTimeDimensionLastNPeriodsChange,onDefaultTimeDimensionModeChange=_ref3.onDefaultTimeDimensionModeChange;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,null,type===DSD_COMPONENT_TYPE_DIMENSION&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.dsd.dimension.type.label')},formItemLayout),form.getFieldDecorator('type')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]||mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */],title:form.getFieldValue('type')},[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["l" /* DSD_DIMENSION_TYPE_NORMAL */],__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["j" /* DSD_DIMENSION_TYPE_FREQUENCY */],__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */],__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["k" /* DSD_DIMENSION_TYPE_MEASURE */]].map(function(opt){return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:opt,value:opt,title:Object(__WEBPACK_IMPORTED_MODULE_27__getSdmxDimensionTypesTranslations__["a" /* getSdmxDimensionTypesTranslations */])(t)[opt]},Object(__WEBPACK_IMPORTED_MODULE_27__getSdmxDimensionTypesTranslations__["a" /* getSdmxDimensionTypesTranslations */])(t)[opt]);})))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.dsd.component.id.label'),validateStatus:component&&Object(__WEBPACK_IMPORTED_MODULE_32__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,component.id).help?"warning":null,help:component&&Object(__WEBPACK_IMPORTED_MODULE_32__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,component.id).help},formItemLayout),form.getFieldDecorator('id',{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]||mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]||type===DSD_COMPONENT_TYPE_MEASURE||type===DSD_COMPONENT_TYPE_DIMENSION&&(component.type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["j" /* DSD_DIMENSION_TYPE_FREQUENCY */]||component.type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]),title:form.getFieldValue('id'),style:{textTransform:"uppercase"}}))))),(type===DSD_COMPONENT_TYPE_DIMENSION||type===DSD_COMPONENT_TYPE_ATTRIBUTE)&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.component.order.label')},formItemLayout),form.getFieldDecorator('order')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a,{disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('order'),min:0,style:{width:"100%"}}))))),(type===DSD_COMPONENT_TYPE_MEASURE||type===DSD_COMPONENT_TYPE_DIMENSION||type===DSD_COMPONENT_TYPE_ATTRIBUTE)&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.dsd.component.concept.label')},formItemLayout),form.getFieldDecorator('concept')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_selector__["a" /* default */],{disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('concept'),onSelect:onConceptSelect,onReset:function onReset(){return onChange({concept:null});}}))))),(type!==DSD_COMPONENT_TYPE_DIMENSION||component.type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["l" /* DSD_DIMENSION_TYPE_NORMAL */]||component.type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["j" /* DSD_DIMENSION_TYPE_FREQUENCY */])&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.component.codelist.label')},formItemLayout),form.getFieldDecorator('representation')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_selector__["a" /* default */],{disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('representation'),onSelect:onCodelistSelect,onReset:function onReset(){return onChange({representation:null});}}))))),type===DSD_COMPONENT_TYPE_DIMENSION&&component.type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["k" /* DSD_DIMENSION_TYPE_MEASURE */]&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.component.conceptScheme.label'),className:"form-item-required"},formItemLayout),form.getFieldDecorator('representation')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_selector__["a" /* default */],{disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('representation'),onSelect:onConceptSchemeSelect,onReset:function onReset(){return onChange({representation:null});}})))))),type===DSD_COMPONENT_TYPE_GROUP&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.dsd.group.dimensions.label')},formItemLayout),form.getFieldDecorator('groupDimensions')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{mode:"multiple",disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('groupDimensions')},(dimensions||[]).map(function(dim){return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:dim.id,value:dim.id},dim.id);})))))),type===DSD_COMPONENT_TYPE_ATTRIBUTE&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginTop:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"],marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.dsd.attribute.assignmentStatus.label')},formItemLayout),form.getFieldDecorator('assignmentStatus')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref5){var props=_ref5.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('assignmentStatus')},["Conditional","Mandatory"].map(function(opt){return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:opt,value:opt,title:opt},opt);})))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.dsd.attribute.attachmentLevel.label')},formItemLayout),form.getFieldDecorator('attachmentLevel')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref6){var props=_ref6.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('attachmentLevel')},[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["f" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_OBSERVATION */],__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["d" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_DATASET */],__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["g" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_SERIES */],__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["e" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_GROUP */]].map(function(opt){return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:opt,value:opt,title:Object(__WEBPACK_IMPORTED_MODULE_28__getSdmxAttributeAttachmentLevelTranslations__["a" /* getSdmxAttributeAttachmentLevelTranslations */])(t)[opt]},Object(__WEBPACK_IMPORTED_MODULE_28__getSdmxAttributeAttachmentLevelTranslations__["a" /* getSdmxAttributeAttachmentLevelTranslations */])(t)[opt]);})))))),form.getFieldValue("attachmentLevel")==="Series"&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.dsd.attribute.dimensions.label')},formItemLayout),form.getFieldDecorator('attachedDimensions')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{mode:"multiple",disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('attachedDimensions')},(dimensions||[]).map(function(_ref7){var id=_ref7.id;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:id,value:id},id);})))))),form.getFieldValue("attachmentLevel")==="Group"&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.dsd.attribute.group.label')},formItemLayout),form.getFieldDecorator('attachmentGroup')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref8){var props=_ref8.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:mode===__WEBPACK_IMPORTED_MODULE_24__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],title:form.getFieldValue('attachmentGroup')},(groups||[]).map(function(_ref9){var id=_ref9.id;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:id,value:id,title:id},id);}))))))),(type===DSD_COMPONENT_TYPE_DIMENSION||type===DSD_COMPONENT_TYPE_ATTRIBUTE)&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.dsd.component.notDisplayed.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{disabled:disableAnnotations,checked:notDisplayedVal!==null,onChange:function onChange(e){if(e.target.checked){onNotDisplayedValChange([]);}else{onNotDisplayedValChange(null);}}}))),component.representation&&notDisplayedVal!==null&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_TWO_THIRDS"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.dsd.component.notDisplayedItems.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_selector__["a" /* default */],{disabled:disableAnnotations,value:notDisplayedVal.length>0?notDisplayedVal.join("+"):null,detailTitle:t('reduxComponents.dsdDetailModal.dsdDetail.componentForm.annotationsCodesSelector.detail.title'),selectTitle:t('reduxComponents.dsdDetailModal.dsdDetail.componentForm.annotationsCodesSelector.select.title'),resetTitle:t('reduxComponents.dsdDetailModal.dsdDetail.componentForm.annotationsCodesSelector.reset.title'),onDetail:function onDetail(){return onNotDisplayedCodesSelectorShow(Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(component.representation));},onSelect:function onSelect(){return onNotDisplayedCodesSelectorShow(Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(component.representation));},onReset:function onReset(){return onNotDisplayedValChange([]);}})))),type===DSD_COMPONENT_TYPE_DIMENSION&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.dsd.dimension.default.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{disabled:disableAnnotations,checked:defaultVal!==null,onChange:function onChange(e){if(e.target.checked){onDefaultValChange([]);}else{onDefaultValChange(null);}}}))),defaultVal!==null&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_TWO_THIRDS"]},component.type!==__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]&&component.representation&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.dsd.dimension.defaultItems.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_selector__["a" /* default */],{disabled:disableAnnotations,value:defaultVal.length>0?defaultVal.join("+"):null,detailTitle:t('reduxComponents.dsdDetailModal.dsdDetail.componentForm.annotationsCodesSelector.detail.title'),selectTitle:t('reduxComponents.dsdDetailModal.dsdDetail.componentForm.annotationsCodesSelector.select.title'),resetTitle:t('reduxComponents.dsdDetailModal.dsdDetail.componentForm.annotationsCodesSelector.reset.title'),onDetail:function onDetail(){return onDefaultCodesSelectorShow(Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(component.representation));},onSelect:function onSelect(){return onDefaultCodesSelectorShow(Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(component.representation));},onReset:function onReset(){return onDefaultValChange([]);}})),component.type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]},type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Group,{disabled:disableAnnotations,value:defaultTimeDimensionMode,onChange:function onChange(_ref10){var target=_ref10.target;if(defaultTimeDimensionStart||defaultTimeDimensionEnd||defaultTimeDimensionLastNObservations||defaultTimeDimensionLastNPeriods){__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a.confirm({title:t('reduxComponents.dsdDetailModal.dsdDetail.componentForm.timeDimensionModeChangeConfirm.title'),content:t('reduxComponents.dsdDetailModal.dsdDetail.componentForm.timeDimensionModeChangeConfirm.content'),onOk:function onOk(){onDefaultTimeDimensionModeChange(target.value);},cancelText:t('commons.buttons.cancel.title')});}else{onDefaultTimeDimensionModeChange(target.value);}}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_31__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */]},t('data.dsd.timDimension.mode.values.range')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_31__utils_annotations__["n" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS */]},t('data.dsd.timDimension.mode.values.lastNPeriods')))))),defaultTimeDimensionMode===__WEBPACK_IMPORTED_MODULE_31__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */]?__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.dsd.timDimension.defaultTimeStart.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_localized_month_picker__["a" /* default */],{format:"YYYY-MM",value:defaultTimeDimensionStart?__WEBPACK_IMPORTED_MODULE_30_moment___default()(defaultTimeDimensionStart):null,disabled:disableAnnotations,onChange:function onChange(val){return onDefaultTimeDimensionStartChange(val?val.format("YYYY-MM"):null);}}))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.dsd.timDimension.defaultTimeEnd.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_localized_month_picker__["a" /* default */],{format:"YYYY-MM",value:defaultTimeDimensionEnd?__WEBPACK_IMPORTED_MODULE_30_moment___default()(defaultTimeDimensionEnd):null,disabled:disableAnnotations,onChange:function onChange(val){return onDefaultTimeDimensionEndChange(val?val.format("YYYY-MM"):null);}})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.dsd.timDimension.defaultLastNObservations.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a,{style:{width:"100%"},min:0,precision:0,value:defaultTimeDimensionLastNObservations,disabled:disableAnnotations,onChange:function onChange(val){return onDefaultTimeDimensionLastNObservationsChange(val||null);}}))))):__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.dsd.timDimension.defaultLastNPeriods.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_THREE_QUARTERS"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_ONE_QUARTER"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a,{style:{width:"100%"},min:0,precision:0,value:defaultTimeDimensionLastNPeriods,disabled:disableAnnotations,onChange:function onChange(val){return onDefaultTimeDimensionLastNPeriodsChange(val||null);}}))))))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_annotations_form__["a" /* default */],{annotations:component?component.annotations:null,onChange:onChange,disabled:disableAnnotations}));};/* harmony default export */ __webpack_exports__["e"] = (Object(__WEBPACK_IMPORTED_MODULE_21_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ComponentForm));

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(619);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(632);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDPOINT_DROPDOWN_NODE_PING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pingNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var ENDPOINT_DROPDOWN_NODE_PING='ENDPOINT_DROPDOWN_NODE_PING';var pingNode=function pingNode(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(ENDPOINT_DROPDOWN_NODE_PING,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_68" /* getNodePingUrl */])(),undefined,undefined,undefined,14000);};

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_DROPDOWN_USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_DROPDOWN_USER_LOGOUT; });
/* unused harmony export USER_DROPDOWN_USER_PASSWORD_RECOVER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loginUserDropdownUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return logoutUserDropdownUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return recoverUserDropdownUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loginUserDropdownProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var USER_DROPDOWN_USER_LOGIN='USER_DROPDOWN_USER_LOGIN';var USER_DROPDOWN_USER_LOGOUT='USER_DROPDOWN_USER_LOGOUT';var USER_DROPDOWN_USER_PASSWORD_RECOVER='USER_DROPDOWN_USER_PASSWORD_RECOVER';var loginUserDropdownUser=function loginUserDropdownUser(username,password){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(USER_DROPDOWN_USER_LOGIN,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_53" /* getLoginUrl */])(),{Username:username,Password:btoa(password||"")});};var logoutUserDropdownUser=function logoutUserDropdownUser(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(USER_DROPDOWN_USER_LOGOUT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_54" /* getLogoutUrl */])());};var recoverUserDropdownUserPassword=function recoverUserDropdownUserPassword(username,email){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(USER_DROPDOWN_USER_PASSWORD_RECOVER,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_75" /* getRecoverPasswordUrl */])(),{username:username,email:email},function(t){return{success:t('page.header.userDropdown.recoverPassword.messages.success')};});};var loginUserDropdownProvider=function loginUserDropdownProvider(providerId,loginCode){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(USER_DROPDOWN_USER_LOGIN,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_73" /* getProviderLoginUrl */])(providerId),JSON.stringify(loginCode),undefined,"application/json"),{providerId:providerId});};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.toArray = toArray;
exports.getActiveIndex = getActiveIndex;
exports.getActiveKey = getActiveKey;
exports.setTransform = setTransform;
exports.isTransformSupported = isTransformSupported;
exports.setTransition = setTransition;
exports.getTransformPropValue = getTransformPropValue;
exports.isVertical = isVertical;
exports.getTransformByIndex = getTransformByIndex;
exports.getMarginStyle = getMarginStyle;
exports.getStyle = getStyle;
exports.setPxStyle = setPxStyle;
exports.getDataAttr = getDataAttr;
exports.getLeft = getLeft;
exports.getTop = getTop;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  _react2['default'].Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransformSupported(style) {
  return 'transform' in style || 'webkitTransform' in style || 'MozTransform' in style;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}
function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

function toNum(style, property) {
  return +style.getPropertyValue(property).replace('px', '');
}

function getTypeValue(start, current, end, tabNode, wrapperNode) {
  var total = getStyle(wrapperNode, 'padding-' + start);
  if (!tabNode || !tabNode.parentNode) {
    return total;
  }

  var childNodes = tabNode.parentNode.childNodes;

  Array.prototype.some.call(childNodes, function (node) {
    var style = window.getComputedStyle(node);

    if (node !== tabNode) {
      total += toNum(style, 'margin-' + start);
      total += node[current];
      total += toNum(style, 'margin-' + end);

      if (style.boxSizing === 'content-box') {
        total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
      }
      return false;
    }

    // We need count current node margin
    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
    total += toNum(style, 'margin-' + start);

    return true;
  });

  return total;
}

function getLeft(tabNode, wrapperNode) {
  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}

function getTop(tabNode, wrapperNode) {
  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(214),
    getRawTag = __webpack_require__(756),
    objectToString = __webpack_require__(757);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divider__ = __webpack_require__(899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubMenu", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_4__Divider__["a"]; });








/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Menu__["a" /* default */]);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(213);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUX_CONCEPT_SCHEMES_DETAIL_DERIVED_IS_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_derived_item_scheme_reducer__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artefact_export_form__ = __webpack_require__(51);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REDUX_CONCEPT_SCHEMES_DETAIL_DERIVED_IS_PREFIX="REDUX_CONCEPT_SCHEMES_DETAIL_DERIVED_IS_PREFIX_";var conceptSchemeDetailModalReducer=function conceptSchemeDetailModalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{conceptSchemeTriplet:null,forceIsFinalDisabled:false,isVisible:false,isEditDisabled:false,isConceptSchemeValid:true,isAgenciesValid:true,isConceptSchemeGeneralTabDirty:false,conceptScheme:null,item:null,selectedItem:null,isItemEditMode:false,agencies:null,allAgencies:null,itemsViewMode:null,isItemsImportFormVisible:false,itemsImportForm:null,itemAnnotations:null,itemLayoutAnnotations:null,itemAnnotationId:null,conceptSchemeAnnotations:null,conceptSchemeLayoutAnnotations:null,isItemsParentListVisible:false,itemsTree:null,itemsTreeMaxDepth:null,maxOrder:null,isNormalizeNeeded:false,isDuplicateItemErrorVisible:false,focusItemsTab:false,cutItem:null,downloadConceptSchemeTriplets:null,downloadConceptSchemeLang:null,downloadConceptSchemeParams:null,cloneDestTriplet:null,conceptSchemeExportSourceTriplet:null,conceptSchemeExportDestination:null,conceptSchemeExportReport:null,parentsAndChildren:null,isDerivedTabFocused:false,derivedConceptSchemeViewMode:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CONCEPT_SCHEME_DETAIL_CREATE */]:return Object.assign({},state,{conceptScheme:{id:null,agencyID:null,version:null,isFinal:false,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,concepts:null},isVisible:true,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],isAgenciesValid:false,isDerivedTabFocused:false,derivedConceptSchemeViewMode:Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* CONCEPT_SCHEME_DETAIL_EDIT */]:return Object.assign({},state,{isVisible:true,conceptSchemeTriplet:action.conceptSchemeTriplet,isConceptSchemeValid:false,isAgenciesValid:false,isConceptSchemeGeneralTabDirty:false,focusItemsTab:false,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],isEditDisabled:false,isDerivedTabFocused:false,derivedConceptSchemeViewMode:Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["Z" /* CONCEPT_SCHEME_DETAIL_SHOW */]:return Object.assign({},state,{isVisible:true,forceIsFinalDisabled:false,conceptSchemeTriplet:action.conceptSchemeTriplet,isConceptSchemeValid:false,isAgenciesValid:false,isConceptSchemeGeneralTabDirty:false,focusItemsTab:false,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],isEditDisabled:true,isDerivedTabFocused:false,derivedConceptSchemeViewMode:Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* CONCEPT_SCHEME_DETAIL_HIDE */]:return Object.assign({},state,{forceIsFinalDisabled:false,isVisible:false,conceptSchemeTriplet:null,conceptScheme:null,item:null,selectedItem:null,itemsViewMode:null,itemsTree:null,itemsTreeMaxDepth:null,maxOrder:null,focusItemsTab:false,cutItem:null,agencies:null,allAgencies:null,isDerivedTabFocused:false,derivedConceptSchemeViewMode:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CONCEPT_SCHEME_DETAIL_CHANGE */]:{var conceptScheme=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.conceptScheme);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{conceptScheme:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(conceptScheme,action.fields,customizer),isConceptSchemeGeneralTabDirty:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["W" /* CONCEPT_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE */]:return Object.assign({},state,{itemsViewMode:action.viewMode,selectedItem:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* CONCEPT_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE */]:return Object.assign({},state,{derivedConceptSchemeViewMode:action.mode});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CREATE */]:{var maxOrder=state.maxOrder+1;var isNormalizeNeeded=Number(action.order)!==maxOrder;return Object.assign({},state,{item:{id:null,parent:action.parentId?action.parentId:null,order:_defineProperty({},action.lang,action.order),name:null,annotations:null,autoAnnotations:[{type:action.itemsOrderAnnotationType,text:_defineProperty({},action.lang,action.order)}],description:null,concepts:[]},isItemEditMode:false,maxOrder:maxOrder,isNormalizeNeeded:isNormalizeNeeded});}case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_EDIT */]:var node=null;if(action.item){node=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"concepts",function(node){return node.id===action.item.id;});}return Object.assign({},state,{item:{id:action.item?action.item.id:null,parent:action.item?action.item.parent:null,order:node?node.order:null,name:node?node.name:null,annotations:action.item?action.item.annotations:null,autoAnnotations:action.item?action.item.autoAnnotations:null,description:node?node.description:null,concepts:node?node.concepts:[]},isItemEditMode:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CHANGE */]:{var item=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.item);var _isNormalizeNeeded=state.isNormalizeNeeded;if(action.fields.order){item.autoAnnotations.find(function(annotation){return annotation.type===action.itemsOrderAnnotationType;}).text=action.fields.order;_isNormalizeNeeded=state.item.order[action.lang]!==action.fields.order[action.lang];}var _customizer=function _customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{item:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(item,action.fields,_customizer),isNormalizeNeeded:_isNormalizeNeeded});}case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_HIDE */]:return Object.assign({},state,{item:null,isItemEditMode:false,isDuplicateItemErrorVisible:false,maxOrder:state.maxOrder-1});case __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_SELECT */]:{var selectedItem=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"concepts",function(node){return node.id===action.id;});return Object.assign({},state,{selectedItem:action.id?selectedItem:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW */]:return Object.assign({},state,{isItemsImportFormVisible:true,itemsImportForm:{file:null,language:null,separator:";",delimiter:null,hasHeader:true,hasDescriptionCol:true,hasParentCol:true,hasOrderCol:true,hasLayoutAnnotationFullNameCol:false,hasLayoutAnnotationIsDefaultCol:false,csvRows:null,filePath:null,allCsvRows:null,isAllCsvRowsVisible:false}});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE */]:return Object.assign({},state,{isItemsImportFormVisible:false,itemsImportForm:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{isAllCsvRowsVisible:true})});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{isAllCsvRowsVisible:false})});case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE */]:return Object.assign({},state,{itemsImportForm:Object.assign({},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(state.itemsImportForm,action.fields),{hash:action.fields.language?state.itemsImportForm.hash:null,csvRows:action.fields.language?state.itemsImportForm.csvRows:null,filePath:action.fields.language?state.itemsImportForm.filePath:null,allCsvRows:action.fields.language?state.itemsImportForm.allCsvRows:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW */]:return Object.assign({},state,{itemAnnotations:action.annotations,itemAnnotationId:action.itemId});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE */]:return Object.assign({},state,{itemAnnotations:null,itemAnnotationId:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["Q" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW */]:return Object.assign({},state,{itemLayoutAnnotations:action.annotations,itemAnnotationId:action.itemId});case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE */]:return Object.assign({},state,{itemLayoutAnnotations:null,itemAnnotationId:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["T" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW */]:return Object.assign({},state,{isItemsParentListVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["R" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE */]:return Object.assign({},state,{isItemsParentListVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["S" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET */]:return Object.assign({},state,{item:Object.assign({},state.item,{parent:action.item.id}),isItemsParentListVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["U" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET */]:return Object.assign({},state,{item:Object.assign({},state.item,{parent:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["X" /* CONCEPT_SCHEME_DETAIL_LANGUAGE_CHANGE */]:{var root=[{isRoot:true,concepts:state.itemsTree}];var _itemsTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["h" /* getMappedTree */])(root,"concepts",function(node){node.concepts=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.concepts,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].concepts;var count=Object(__WEBPACK_IMPORTED_MODULE_6__utils_normalizers__["b" /* normalizeItemsOrder */])(_itemsTree,"concepts",action.lang,action.itemsOrderAnnotationType);return Object.assign({},state,{itemsTree:_itemsTree,maxOrder:count});}case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW */]:return Object.assign({},state,{isDuplicateItemErrorVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE */]:return Object.assign({},state,{isDuplicateItemErrorVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* CONCEPT_SCHEME_DETAIL_ITEMS_ITEM_CUT */]:var parentNode=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"concepts",function(node){return node.id===action.item.parent;});parentNode?parentNode.concepts=parentNode.concepts.filter(function(child){return child.id!==action.item.id;}):state.itemsTree=state.itemsTree.filter(function(child){return child.id!==action.item.id;});var itemsTree=state.itemsTree.splice(0);return Object.assign({},state,{cutItem:action.item,itemsTree:itemsTree,itemsTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["j" /* getMaxTreeDepth */])(itemsTree,"concepts")});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* CONCEPT_SCHEME_DETAIL_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadConceptSchemeTriplets:action.artefactTriplets,downloadConceptSchemeLang:action.lang,downloadConceptSchemeParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* CONCEPT_SCHEME_DETAIL_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadConceptSchemeTriplets:null,downloadConceptSchemeLang:null,downloadConceptSchemeParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* CONCEPT_SCHEME_DETAIL_DOWNLOAD_CHANGE */]:var downloadConceptSchemeParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadConceptSchemeParams);return Object.assign({},state,{downloadConceptSchemeParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadConceptSchemeParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CONCEPT_SCHEME_DETAIL_CLONE_SHOW */]:var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),conceptSchemeTriplet:state.conceptSchemeTriplet?state.conceptSchemeTriplet:action.srcTriplet,isConceptSchemeValid:!!state.conceptScheme,isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CONCEPT_SCHEME_DETAIL_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,conceptScheme:state.isVisible?state.conceptScheme:null,conceptSchemeTriplet:state.isVisible?state.conceptSchemeTriplet:null,itemsTree:state.isVisible?state.itemsTree:null,itemsTreeMaxDepth:state.isVisible?state.itemsTreeMaxDepth:null,maxOrder:state.isVisible?state.maxOrder:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CONCEPT_SCHEME_DETAIL_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* CONCEPT_SCHEME_DETAIL_EXPORT_SHOW */]:return Object.assign({},state,{conceptSchemeExportSourceTriplet:action.sourceTriplet,conceptSchemeExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,loginOption:__WEBPACK_IMPORTED_MODULE_12__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null},isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* CONCEPT_SCHEME_DETAIL_EXPORT_HIDE */]:return Object.assign({},state,{conceptSchemeExportSourceTriplet:null,conceptSchemeExportDestination:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* CONCEPT_SCHEME_DETAIL_EXPORT_CHANGE */]:var conceptSchemeExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.conceptSchemeExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(conceptSchemeExportDestination,action.fields);return Object.assign({},state,{conceptSchemeExportDestination:conceptSchemeExportDestination});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* CONCEPT_SCHEME_DETAIL_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{conceptSchemeExportReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* CONCEPT_SCHEME_DETAIL_DERIVED_TAB_FOCUS */]:return Object.assign({},state,{isDerivedTabFocused:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* CONCEPT_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS */]:return Object.assign({},state,{isDerivedTabFocused:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* CONCEPT_SCHEME_DETAIL_READ */]:var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_11__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(_ref){var type=_ref.type;return type&&type.toLowerCase()===Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["c" /* CONCEPT_SCHEME_ORDER_ANNOTATION_KEY */]].toLowerCase();}:undefined;var _conceptScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["y" /* SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["c" /* CONCEPT_SCHEME_ORDER_ANNOTATION_KEY */],customNoneIsAutoAnnotation)(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var _itemsTree2=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["n" /* getTreeFromArray */])(_conceptScheme.concepts||[],"concepts");var _root=[{isRoot:true,concepts:_itemsTree2}];_itemsTree2=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["h" /* getMappedTree */])(_root,"concepts",function(node){node.concepts=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.concepts,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].concepts;var _count=Object(__WEBPACK_IMPORTED_MODULE_6__utils_normalizers__["b" /* normalizeItemsOrder */])(_itemsTree2,"concepts",action.lang,action.itemsOrderAnnotationType);return Object.assign({},state,{conceptScheme:_conceptScheme,isConceptSchemeValid:true,itemsTree:_itemsTree2,itemsTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["j" /* getMaxTreeDepth */])(_itemsTree2,"concepts"),maxOrder:_count});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CONCEPT_SCHEME_DETAIL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response,isAgenciesValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* CONCEPT_SCHEME_DETAIL_CREATE_SUBMIT */]:return Object.assign({},state,{conceptScheme:null,isVisible:true,itemsTree:null,itemsTreeMaxDepth:null,maxOrder:null,conceptSchemeTriplet:action.conceptSchemeTriplet,isConceptSchemeValid:false,isConceptSchemeGeneralTabDirty:false,focusItemsTab:true,forceIsFinalDisabled:state.conceptScheme.isFinal});case __WEBPACK_IMPORTED_MODULE_1__actions__["_0" /* CONCEPT_SCHEME_DETAIL_UPDATE_SUBMIT */]:return Object.assign({},state,{item:null,selectedItem:null,itemsTree:action.itemsTree,itemsTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["j" /* getMaxTreeDepth */])(action.itemsTree,"concepts"),isNormalizeNeeded:false,cutItem:null,agencies:null,allAgencies:null,forceIsFinalDisabled:state.conceptScheme.isFinal});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{csvRows:action.response.importedItemCsv,hash:action.response.hashImport,allCsvRows:null,filePath:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT */]:return Object.assign({},state,{itemsImportForm:null,isItemsImportFormVisible:false,isConceptSchemeValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* CONCEPT_SCHEME_DETAIL_DOWNLOAD_SUBMIT */]:return Object.assign({},state,{downloadConceptSchemeTriplets:null,downloadConceptSchemeLang:null,downloadConceptSchemeParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CONCEPT_SCHEME_DETAIL_CLONE_SUBMIT */]:return Object.assign({},state,{cloneDestTriplet:null,conceptScheme:state.isVisible?state.conceptScheme:null,conceptSchemeTriplet:state.isVisible?state.conceptSchemeTriplet:null,itemsTree:state.isVisible?state.itemsTree:null,itemsTreeMaxDepth:state.isVisible?state.itemsTreeMaxDepth:null,maxOrder:state.isVisible?state.maxOrder:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* CONCEPT_SCHEME_DETAIL_EXPORT_SUBMIT */]:return Object.assign({},state,{conceptSchemeExportSourceTriplet:null,conceptSchemeExportDestination:null,conceptSchemeExportReport:action.response.itemsMessage,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{filePath:action.response})});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* CONCEPT_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{allCsvRows:action.response})});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* CONCEPT_SCHEME_DETAIL_READ */]:return Object.assign({},state,{isVisible:false,isConceptSchemeValid:true});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["b" /* reuseInReducer */])(conceptSchemeDetailModalReducer,{derivedConceptScheme:Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_9__redux_derived_item_scheme_reducer__["a" /* default */],REDUX_CONCEPT_SCHEMES_DETAIL_DERIVED_IS_PREFIX)}));

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FILE_MAPPING_WIZARD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FILE_MAPPING_WIZARD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FILE_MAPPING_WIZARD_CSV_HEADER_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FILE_MAPPING_WIZARD_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_MAPPING_WIZARD_COLUMN_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FILE_MAPPING_WIZARD_STEP_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FILE_MAPPING_WIZARD_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_MAPPING_WIZARD_COMPONENTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_MAPPING_WIZARD_COMPONENTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FILE_MAPPING_WIZARD_PX_TO_CSV_CONVERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FILE_MAPPING_WIZARD_XLS_TO_CSV_CONVERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return showFileMappingWizard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return hideFileMappingWizard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return changeFileMappingWizardForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getFileMappingWizardCsvHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return readFileMappingWizardCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return selectFileMappingWizardColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return createFileMappingWizardFileMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setFileMappingWizardStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return showFileMappingWizardCubeComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return hideFileMappingWizardCubeComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return showFileMappingWizardComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return hideFileMappingWizardComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return convertFileMappingWizardPxToCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return convertFileMappingWizardXlsToCsv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var FILE_MAPPING_WIZARD_SHOW='FILE_MAPPING_WIZARD_SHOW';var FILE_MAPPING_WIZARD_HIDE='FILE_MAPPING_WIZARD_HIDE';var FILE_MAPPING_WIZARD_CSV_HEADER_GET='FILE_MAPPING_WIZARD_CSV_HEADER_GET';var FILE_MAPPING_WIZARD_CUBE_READ='FILE_MAPPING_WIZARD_CUBE_READ';var FILE_MAPPING_WIZARD_COLUMN_SELECT='FILE_MAPPING_WIZARD_COLUMN_SELECT';var FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE='FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE';var FILE_MAPPING_WIZARD_STEP_SET='FILE_MAPPING_WIZARD_STEP_SET';var FILE_MAPPING_WIZARD_FORM_CHANGE='FILE_MAPPING_WIZARD_FORM_CHANGE';var FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW='FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW';var FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE='FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE';var FILE_MAPPING_WIZARD_COMPONENTS_SHOW='FILE_MAPPING_WIZARD_COMPONENTS_SHOW';var FILE_MAPPING_WIZARD_COMPONENTS_HIDE='FILE_MAPPING_WIZARD_COMPONENTS_HIDE';var FILE_MAPPING_WIZARD_PX_TO_CSV_CONVERT='FILE_MAPPING_WIZARD_PX_TO_CSV_CONVERT';var FILE_MAPPING_WIZARD_XLS_TO_CSV_CONVERT='FILE_MAPPING_WIZARD_XLS_TO_CSV_CONVERT';var showFileMappingWizard=function showFileMappingWizard(cubeId,cubeCode){return{type:FILE_MAPPING_WIZARD_SHOW,cubeId:cubeId,cubeCode:cubeCode};};var hideFileMappingWizard=function hideFileMappingWizard(){return{type:FILE_MAPPING_WIZARD_HIDE};};var changeFileMappingWizardForm=function changeFileMappingWizardForm(fields){return{type:FILE_MAPPING_WIZARD_FORM_CHANGE,fields:fields};};var getFileMappingWizardCsvHeader=function getFileMappingWizardCsvHeader(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath,csvHasDotStatFormat){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(FILE_MAPPING_WIZARD_CSV_HEADER_GET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["T" /* getCsvHeaderUrl */])(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath)),{csvHasDotStatFormat:csvHasDotStatFormat});};var readFileMappingWizardCube=function readFileMappingWizardCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(FILE_MAPPING_WIZARD_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var selectFileMappingWizardColumn=function selectFileMappingWizardColumn(columnName){return{type:FILE_MAPPING_WIZARD_COLUMN_SELECT,columnName:columnName};};var createFileMappingWizardFileMapping=function createFileMappingWizardFileMapping(name,description,tid,cubeId,components,csvForm,xmlServerPath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_42" /* getFileMappingUrl */])(),{Name:name,Description:description!==null&&description.length>0?description:null,Tid:tid!==null&&tid.length>0?tid:null,IDCube:cubeId,Components:components.map(function(comp){return{ColumnName:comp.columnName,CubeComponentCode:comp.cubeComponentCode,CubeComponentType:comp.cubeComponentType};}),CSVDelimiter:csvForm.delimiter,CSVSeparator:csvForm.separator,HasHeader:csvForm.hasHeader,HasSpecialTimePeriod:csvForm.hasDotStatFormat,XMLFilePath:xmlServerPath},function(t){return{start:t('scenes.dataManager.fileMapping.wizard.messages.fileMappingCreate.start'),success:t('scenes.dataManager.fileMapping.wizard.messages.fileMappingCreate.success')};});};var setFileMappingWizardStep=function setFileMappingWizardStep(step){return{type:FILE_MAPPING_WIZARD_STEP_SET,step:step};};var showFileMappingWizardCubeComponents=function showFileMappingWizardCubeComponents(){return{type:FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW};};var hideFileMappingWizardCubeComponents=function hideFileMappingWizardCubeComponents(){return{type:FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE};};var showFileMappingWizardComponents=function showFileMappingWizardComponents(){return{type:FILE_MAPPING_WIZARD_COMPONENTS_SHOW};};var hideFileMappingWizardComponents=function hideFileMappingWizardComponents(){return{type:FILE_MAPPING_WIZARD_COMPONENTS_HIDE};};var convertFileMappingWizardPxToCsv=function convertFileMappingWizardPxToCsv(fileServerPath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(FILE_MAPPING_WIZARD_PX_TO_CSV_CONVERT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["I" /* getConvertPxToCsvUrl */])(fileServerPath,0));};var convertFileMappingWizardXlsToCsv=function convertFileMappingWizardXlsToCsv(fileServerPath,xmlServerPath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(FILE_MAPPING_WIZARD_XLS_TO_CSV_CONVERT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["J" /* getConvertXlsToCsv */])(fileServerPath,xmlServerPath,0));};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1040);

__webpack_require__(8);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dropdown = _interopRequireDefault(__webpack_require__(469));

var _dropdownButton = _interopRequireDefault(__webpack_require__(1044));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dropdown["default"].Button = _dropdownButton["default"];
var _default = _dropdown["default"];
exports["default"] = _default;

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SPINNER_ACTION_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SPINNER_ACTION_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SPINNER_ACTIONS_FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addSpinnerAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return completeSpinnerAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flushSpinnerActions; });
var SPINNER_ACTION_ADD='SPINNER_ACTION_ADD';var SPINNER_ACTION_COMPLETE='SPINNER_ACTION_COMPLETE';var SPINNER_ACTIONS_FLUSH='SPINNER_ACTIONS_FLUSH';var addSpinnerAction=function addSpinnerAction(action,uuid){return{type:SPINNER_ACTION_ADD,action:action,uuid:uuid};};var completeSpinnerAction=function completeSpinnerAction(action,uuid){return{type:SPINNER_ACTION_COMPLETE,action:action,uuid:uuid};};var flushSpinnerActions=function flushSpinnerActions(){return{type:SPINNER_ACTIONS_FLUSH};};

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_locale_it_IT__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_locale_it_IT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_locale_it_IT__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language};};var LocalizedDatePicker=function LocalizedDatePicker(_ref){var appLanguage=_ref.appLanguage,value=_ref.value,_ref$format=_ref.format,format=_ref$format===undefined?"YYYY-MM-DD":_ref$format,returnParsedDate=_ref.returnParsedDate,_onChange=_ref.onChange,props=_objectWithoutProperties(_ref,["appLanguage","value","format","returnParsedDate","onChange"]);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{title:value?__WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format(format):null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a,Object.assign({},props,{style:Object.assign({width:"100%"},props["style"]),value:value?__WEBPACK_IMPORTED_MODULE_5_moment___default()(value):null,locale:appLanguage==='it'?__WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_locale_it_IT___default.a:null,format:format,onChange:function onChange(date){return _onChange(date?returnParsedDate?__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format(format):date:null);}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(LocalizedDatePicker));

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_FIRST_ROW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_DDB_DATAFLOW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CATEGORISED_CUBES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CODELIST_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_CODES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DATAFLOW_BUILER_WIZARD_QUERY_PREVIEW_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_COUNT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return showDataflowBuilderWizardQueryCubeColumnsFormCubeTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return hideDataflowBuilderWizardQueryCubeColumnsFormCubeTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return setDataflowBuilderWizardQueryCubeColumnsFormCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return unsetDataflowBuilderWizardQueryCubeColumnsFormCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return readDataflowBuilderWizardQueryCubeColumnsFormCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return readDataflowBuilderWizardQueryCubeColumnsFormCubeFirstRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return readDataflowBuilderWizardQueryCubeColumnsFormCategorisedCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return changeDataflowBuilderWizardQueryCubeColumnsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return readDataflowBuilderWizardQueryCubeColumnsFormDdbDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return changeDataflowBuilderWizardFilterForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return addDataflowBuilderWizardQueryFilterFormBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return deleteDataflowBuilderWizardQueryFilterFormBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return addDataflowBuilderWizardQueryFilterFormCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return deleteDataflowBuilderWizardQueryFilterFormCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return readDataflowBuilderWizardQueryFilterFormColumnValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return resetDataflowBuilderWizardQueryFilterFormColumnValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return readDataflowBuilderWizardQueryFilterFormColumnCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return readDataflowBuilderWizardQueryPreviewRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return showDataflowBuilderWizardQueryPreviewRowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return hideDataflowBuilderWizardQueryPreviewRowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return readDataflowBuilderWizardQueryTreeFilterColumnCodelistCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return readDataflowBuilderWizardQueryTreeFilterColumnCodelistTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return resetDataflowBuilderWizardQueryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return changeDataflowBuilderWizardQueryFilterMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return showDataflowBuilderWizardQueryFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return hideDataflowBuilderWizardQueryFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return submitDataflowBuilderWizardQueryFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return changeDataflowBuilderWizardQueryTreeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return readDataflowBuilderWizardQueryTreeFilterColumnFilteredValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return changeDataflowBuilderWizardQueryTreeFilterColumnMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return changeDataflowBuilderWizardQueryTreeFilterColumnValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tree_filter_utils__ = __webpack_require__(65);
var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_SHOW='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_SHOW';var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_HIDE='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_HIDE';var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_SET='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_SET';var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_UNSET='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_UNSET';var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_READ='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_CUBE_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_FIRST_ROW_READ='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_FIRST_ROW_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_DDB_DATAFLOW_READ='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_DDB_DATAFLOW_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CATEGORISED_CUBES_READ='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CATEGORISED_CUBES_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CHANGE='DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CHANGE';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CODELIST_READ='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CODELIST_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_CODES_READ='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_CODES_READ';var DATAFLOW_BUILER_WIZARD_QUERY_PREVIEW_ROWS_READ='DATAFLOW_BUILER_WIZARD_QUERY_PREVIEW_ROWS_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_SHOW='DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_SHOW';var DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_HIDE='DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_HIDE';var DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_COUNT_READ='DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_COUNT_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_TREE_READ='DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_TREE_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_RESET='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_RESET';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SHOW='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SHOW';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_HIDE='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_HIDE';var DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT='DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT';var DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE='DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE';var DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ='DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ';var DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE='DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE';var DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE='DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE';var showDataflowBuilderWizardQueryCubeColumnsFormCubeTree=function showDataflowBuilderWizardQueryCubeColumnsFormCubeTree(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_SHOW};};var hideDataflowBuilderWizardQueryCubeColumnsFormCubeTree=function hideDataflowBuilderWizardQueryCubeColumnsFormCubeTree(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_HIDE};};var setDataflowBuilderWizardQueryCubeColumnsFormCube=function setDataflowBuilderWizardQueryCubeColumnsFormCube(cubeId){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_SET,cubeId:cubeId};};var unsetDataflowBuilderWizardQueryCubeColumnsFormCube=function unsetDataflowBuilderWizardQueryCubeColumnsFormCube(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_UNSET};};var readDataflowBuilderWizardQueryCubeColumnsFormCube=function readDataflowBuilderWizardQueryCubeColumnsFormCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var readDataflowBuilderWizardQueryCubeColumnsFormCubeFirstRow=function readDataflowBuilderWizardQueryCubeColumnsFormCubeFirstRow(cubeId,cubeColumns){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_FIRST_ROW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_6" /* getDataflowPreviewUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["f" /* getServerQueryObj */])(cubeColumns,[],1,1,undefined,undefined,cubeId));};var readDataflowBuilderWizardQueryCubeColumnsFormCategorisedCubes=function readDataflowBuilderWizardQueryCubeColumnsFormCategorisedCubes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CATEGORISED_CUBES_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])()]);};var changeDataflowBuilderWizardQueryCubeColumnsForm=function changeDataflowBuilderWizardQueryCubeColumnsForm(fields){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CHANGE,fields:fields};};var readDataflowBuilderWizardQueryCubeColumnsFormDdbDataflow=function readDataflowBuilderWizardQueryCubeColumnsFormDdbDataflow(ddbDataflowId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_DDB_DATAFLOW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_9" /* getDdbDataflowUrl */])(ddbDataflowId));};var changeDataflowBuilderWizardFilterForm=function changeDataflowBuilderWizardFilterForm(fields){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE,fields:fields};};var addDataflowBuilderWizardQueryFilterFormBlock=function addDataflowBuilderWizardQueryFilterFormBlock(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD};};var deleteDataflowBuilderWizardQueryFilterFormBlock=function deleteDataflowBuilderWizardQueryFilterFormBlock(blockIndex){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE,blockIndex:blockIndex};};var addDataflowBuilderWizardQueryFilterFormCondition=function addDataflowBuilderWizardQueryFilterFormCondition(blockIndex){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD,blockIndex:blockIndex};};var deleteDataflowBuilderWizardQueryFilterFormCondition=function deleteDataflowBuilderWizardQueryFilterFormCondition(blockIndex,conditionIndex){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE,blockIndex:blockIndex,conditionIndex:conditionIndex};};var readDataflowBuilderWizardQueryFilterFormColumnValues=function readDataflowBuilderWizardQueryFilterFormColumnValues(cubeId,columnName,viewerObj){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(columnName,viewerObj.pageNum,viewerObj.pageSize),{idCube:cubeId,dataflowColumns:[columnName],idDataflow:0,filter:Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["f" /* getServerQueryObj */])(undefined,viewerObj.filterObj||Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["e" /* getFilterStrFromViewerObj */])([columnName],viewerObj.searchText,[],""))).Filter}),{columnName:columnName});};var resetDataflowBuilderWizardQueryFilterFormColumnValues=function resetDataflowBuilderWizardQueryFilterFormColumnValues(columnName){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET,columnName:columnName};};var readDataflowBuilderWizardQueryFilterFormColumnCodes=function readDataflowBuilderWizardQueryFilterFormColumnCodes(columnName,codelistCode){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_CODES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).id,agencyId:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).agencyID,version:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).version,pageNum:1,pageSize:-1,rebuildDb:false,lang:"en"}),{columnName:columnName});};var readDataflowBuilderWizardQueryPreviewRows=function readDataflowBuilderWizardQueryPreviewRows(cubeId,cubeColumns,filter,pageNum,pageSize,sortCols,sortByDesc){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILER_WIZARD_QUERY_PREVIEW_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_6" /* getDataflowPreviewUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["f" /* getServerQueryObj */])(cubeColumns,Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_4__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter)),pageNum,pageSize,sortCols,sortByDesc,cubeId));};var showDataflowBuilderWizardQueryPreviewRowsModal=function showDataflowBuilderWizardQueryPreviewRowsModal(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_SHOW};};var hideDataflowBuilderWizardQueryPreviewRowsModal=function hideDataflowBuilderWizardQueryPreviewRowsModal(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_HIDE};};var readDataflowBuilderWizardQueryTreeFilterColumnCodelistCount=function readDataflowBuilderWizardQueryTreeFilterColumnCodelistCount(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_COUNT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var readDataflowBuilderWizardQueryTreeFilterColumnCodelistTree=function readDataflowBuilderWizardQueryTreeFilterColumnCodelistTree(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_TREE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:-1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var resetDataflowBuilderWizardQueryFilter=function resetDataflowBuilderWizardQueryFilter(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_RESET};};var changeDataflowBuilderWizardQueryFilterMode=function changeDataflowBuilderWizardQueryFilterMode(filterMode){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE,filterMode:filterMode};};var showDataflowBuilderWizardQueryFilterModal=function showDataflowBuilderWizardQueryFilterModal(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SHOW};};var hideDataflowBuilderWizardQueryFilterModal=function hideDataflowBuilderWizardQueryFilterModal(){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_HIDE};};var submitDataflowBuilderWizardQueryFilterModal=function submitDataflowBuilderWizardQueryFilterModal(filter){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT,filter:filter};};var changeDataflowBuilderWizardQueryTreeFilter=function changeDataflowBuilderWizardQueryTreeFilter(treeFilter){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE,treeFilter:treeFilter};};var readDataflowBuilderWizardQueryTreeFilterColumnFilteredValues=function readDataflowBuilderWizardQueryTreeFilterColumnFilteredValues(cubeId,colNames,filter){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(colNames[colNames.length-1],1,-1),{idCube:cubeId,dataflowColumns:colNames,filter:Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["f" /* getServerQueryObj */])(undefined,Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_4__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter))).Filter}),{colName:colNames[colNames.length-1]});};var changeDataflowBuilderWizardQueryTreeFilterColumnMode=function changeDataflowBuilderWizardQueryTreeFilterColumnMode(colName,mode){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE,colName:colName,mode:mode};};var changeDataflowBuilderWizardQueryTreeFilterColumnValues=function changeDataflowBuilderWizardQueryTreeFilterColumnValues(colName,values){return{type:DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE,colName:colName,values:values};};

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUX_CATEGORY_SCHEMES_DETAIL_DERIVED_IS_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_derived_item_scheme_reducer__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artefact_export_form__ = __webpack_require__(51);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REDUX_CATEGORY_SCHEMES_DETAIL_DERIVED_IS_PREFIX="REDUX_CATEGORY_SCHEMES_DETAIL_DERIVED_IS_PREFIX_";var categorySchemeDetailModalReducer=function categorySchemeDetailModalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{categorySchemeTriplet:null,isVisible:false,isEditDisabled:false,isCategorySchemeValid:true,isAgenciesValid:true,isCategorySchemeGeneralTabDirty:false,categoryScheme:null,catSchemeCategorisations:null,forceIsFinalDisabled:false,item:null,selectedItem:null,isItemEditMode:false,agencies:null,allAgencies:null,itemsViewMode:null,isItemsImportFormVisible:false,itemsImportForm:null,itemAnnotations:null,itemLayoutAnnotations:null,itemAnnotationId:null,categorySchemeAnnotations:null,categorySchemeLayoutAnnotations:null,isItemsParentListVisible:false,itemsTree:null,itemsTreeMaxDepth:null,maxOrder:null,isNormalizeNeeded:false,isDuplicateItemErrorVisible:false,focusItemsTab:false,cutItem:null,downloadCategorySchemeParams:null,downloadCategorySchemeTriplets:null,downloadCategorySchemeLang:null,cloneDestTriplet:null,categorySchemeExportSourceTriplet:null,categorySchemeExportDestination:null,categorySchemeExportReport:null,isDerivedTabFocused:false,derivedCategorySchemeViewMode:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CATEGORY_SCHEME_DETAIL_CREATE */]:return Object.assign({},state,{categoryScheme:{id:null,agencyID:null,version:null,isFinal:false,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,categories:null},isVisible:true,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],isAgenciesValid:false,isDerivedTabFocused:false,derivedCategorySchemeViewMode:Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* CATEGORY_SCHEME_DETAIL_EDIT */]:return Object.assign({},state,{isVisible:true,categorySchemeTriplet:action.categorySchemeTriplet,isCategorySchemeValid:false,isAgenciesValid:false,isCategorySchemeGeneralTabDirty:false,focusItemsTab:false,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],isEditDisabled:false,isDerivedTabFocused:false,derivedCategorySchemeViewMode:Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["Z" /* CATEGORY_SCHEME_DETAIL_SHOW */]:return Object.assign({},state,{forceIsFinalDisabled:false,isVisible:true,categorySchemeTriplet:action.categorySchemeTriplet,isCategorySchemeValid:false,isAgenciesValid:false,isCategorySchemeGeneralTabDirty:false,focusItemsTab:false,itemsViewMode:action.defaultItemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],isEditDisabled:true,isDerivedTabFocused:false,derivedCategorySchemeViewMode:Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.itemsViewMode||__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* CATEGORY_SCHEME_DETAIL_HIDE */]:return Object.assign({},state,{forceIsFinalDisabled:false,isVisible:false,categorySchemeTriplet:null,categoryScheme:null,catSchemeCategorisations:null,item:null,selectedItem:null,itemsViewMode:null,itemsTree:null,itemsTreeMaxDepth:null,maxOrder:null,focusItemsTab:false,cutItem:null,agencies:null,allAgencies:null,isDerivedTabFocused:false,derivedCategorySchemeViewMode:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CATEGORY_SCHEME_DETAIL_CHANGE */]:{var categoryScheme=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.categoryScheme);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{categoryScheme:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(categoryScheme,action.fields,customizer),isCategorySchemeGeneralTabDirty:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["W" /* CATEGORY_SCHEME_DETAIL_ITEMS_VIEW_MODE_CHANGE */]:return Object.assign({},state,{itemsViewMode:action.viewMode,selectedItem:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* CATEGORY_SCHEME_DETAIL_DERIVED_CATEGORY_SCHEME_VIEW_MODE_CHANGE */]:return Object.assign({},state,{derivedCategorySchemeViewMode:action.mode});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CREATE */]:{var maxOrder=state.maxOrder+1;var isNormalizeNeeded=Number(action.order)!==maxOrder;return Object.assign({},state,{item:{id:null,parent:action.parentId?action.parentId:null,order:_defineProperty({},action.lang,action.order),name:null,annotations:null,autoAnnotations:[{type:action.itemsOrderAnnotationType,text:_defineProperty({},action.lang,action.order)}],description:null,categories:[]},isItemEditMode:false,maxOrder:maxOrder,isNormalizeNeeded:isNormalizeNeeded});}case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_EDIT */]:var node=null;if(action.item){node=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"categories",function(node){return node.id===action.item.id;});}return Object.assign({},state,{item:{id:action.item?action.item.id:null,parent:action.item?action.item.parent:null,order:node?node.order:null,name:node?node.name:null,annotations:action.item?action.item.annotations:null,autoAnnotations:action.item?action.item.autoAnnotations:null,description:node?node.description:null,categories:node?node.categories:[]},isItemEditMode:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CHANGE */]:{var item=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.item);var _isNormalizeNeeded=state.isNormalizeNeeded;if(action.fields.order){item.autoAnnotations.find(function(annotation){return annotation.type===action.itemsOrderAnnotationType;}).text=action.fields.order;_isNormalizeNeeded=state.item.order[action.lang]!==action.fields.order[action.lang];}var _customizer=function _customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{item:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(item,action.fields,_customizer),isNormalizeNeeded:_isNormalizeNeeded});}case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_HIDE */]:return Object.assign({},state,{item:null,isItemEditMode:false,isDuplicateItemErrorVisible:false,maxOrder:state.maxOrder-1});case __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_SELECT */]:{var selectedItem=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"categories",function(node){return node.id===action.id;});return Object.assign({},state,{selectedItem:action.id?selectedItem:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_SHOW */]:return Object.assign({},state,{isItemsImportFormVisible:true,itemsImportForm:{file:null,language:null,separator:";",delimiter:null,hasHeader:true,hasDescriptionCol:true,hasParentCol:true,hasOrderCol:true,hasLayoutAnnotationFullNameCol:false,hasLayoutAnnotationIsDefaultCol:false,csvRows:null,filePath:null,allCsvRows:null,isAllCsvRowsVisible:false}});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_HIDE */]:return Object.assign({},state,{isItemsImportFormVisible:false,itemsImportForm:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{isAllCsvRowsVisible:true})});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{isAllCsvRowsVisible:false})});case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CHANGE */]:return Object.assign({},state,{itemsImportForm:Object.assign({},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(state.itemsImportForm,action.fields),{hash:action.fields.language?state.itemsImportForm.hash:null,csvRows:action.fields.language?state.itemsImportForm.csvRows:null,filePath:action.fields.language?state.itemsImportForm.filePath:null,allCsvRows:action.fields.language?state.itemsImportForm.allCsvRows:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW */]:return Object.assign({},state,{itemAnnotations:action.annotations,itemAnnotationId:action.itemId});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE */]:return Object.assign({},state,{itemAnnotations:null,itemAnnotationId:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["Q" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW */]:return Object.assign({},state,{itemLayoutAnnotations:action.annotations,itemAnnotationId:action.itemId});case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE */]:return Object.assign({},state,{itemLayoutAnnotations:null,itemAnnotationId:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["T" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SHOW */]:return Object.assign({},state,{isItemsParentListVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["R" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_HIDE */]:return Object.assign({},state,{isItemsParentListVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["S" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_SET */]:return Object.assign({},state,{item:Object.assign({},state.item,{parent:action.item.id}),isItemsParentListVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["U" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_PARENT_LIST_UNSET */]:return Object.assign({},state,{item:Object.assign({},state.item,{parent:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["X" /* CATEGORY_SCHEME_DETAIL_LANGUAGE_CHANGE */]:{var root=[{isRoot:true,categories:state.itemsTree}];var _itemsTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["h" /* getMappedTree */])(root,"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].categories;var count=Object(__WEBPACK_IMPORTED_MODULE_6__utils_normalizers__["b" /* normalizeItemsOrder */])(_itemsTree,"categories",action.lang,action.itemsOrderAnnotationType);return Object.assign({},state,{itemsTree:_itemsTree,maxOrder:count});}case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW */]:return Object.assign({},state,{isDuplicateItemErrorVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE */]:return Object.assign({},state,{isDuplicateItemErrorVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* CATEGORY_SCHEME_DETAIL_ITEMS_ITEM_CUT */]:var parentNode=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"categories",function(node){return node.id===action.item.parent;});parentNode?parentNode.categories=parentNode.categories.filter(function(child){return child.id!==action.item.id;}):state.itemsTree=state.itemsTree.filter(function(child){return child.id!==action.item.id;});var itemsTree=state.itemsTree.splice(0);return Object.assign({},state,{cutItem:action.item,itemsTree:itemsTree,itemsTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["j" /* getMaxTreeDepth */])(itemsTree,"categories")});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* CATEGORY_SCHEME_DETAIL_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadCategorySchemeTriplets:action.artefactTriplets,downloadCategorySchemeLang:action.lang,downloadCategorySchemeParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* CATEGORY_SCHEME_DETAIL_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadCategorySchemeTriplets:null,downloadCategorySchemeLang:null,downloadCategorySchemeParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* CATEGORY_SCHEME_DETAIL_DOWNLOAD_CHANGE */]:var downloadCategorySchemeParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadCategorySchemeParams);return Object.assign({},state,{downloadCategorySchemeParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadCategorySchemeParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CATEGORY_SCHEME_DETAIL_CLONE_SHOW */]:var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),categorySchemeTriplet:state.categorySchemeTriplet?state.categorySchemeTriplet:action.srcTriplet,isCategorySchemeValid:!!state.categoryScheme,isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CATEGORY_SCHEME_DETAIL_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,categoryScheme:state.isVisible?state.categoryScheme:null,catSchemeCategorisations:null,categorySchemeTriplet:state.isVisible?state.categorySchemeTriplet:null,itemsTree:state.isVisible?state.itemsTree:null,itemsTreeMaxDepth:state.isVisible?state.itemsTreeMaxDepth:null,maxOrder:state.isVisible?state.maxOrder:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CATEGORY_SCHEME_DETAIL_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* CATEGORY_SCHEME_DETAIL_EXPORT_SHOW */]:return Object.assign({},state,{categorySchemeExportSourceTriplet:action.sourceTriplet,categorySchemeExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,loginOption:__WEBPACK_IMPORTED_MODULE_12__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null},isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* CATEGORY_SCHEME_DETAIL_EXPORT_HIDE */]:return Object.assign({},state,{categorySchemeExportSourceTriplet:null,categorySchemeExportDestination:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* CATEGORY_SCHEME_DETAIL_EXPORT_CHANGE */]:var categorySchemeExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.categorySchemeExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(categorySchemeExportDestination,action.fields);return Object.assign({},state,{categorySchemeExportDestination:categorySchemeExportDestination});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* CATEGORY_SCHEME_DETAIL_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{categorySchemeExportReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* CATEGORY_SCHEME_DETAIL_DERIVED_TAB_FOCUS */]:return Object.assign({},state,{isDerivedTabFocused:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* CATEGORY_SCHEME_DETAIL_DERIVED_TAB_UNFOCUS */]:return Object.assign({},state,{isDerivedTabFocused:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["_0" /* CATEGORY_SCHEME_DETAIL_UPDATE_SUBMIT */]:return Object.assign({},state,{isCategorySchemeGeneralTabDirty:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* CATEGORY_SCHEME_DETAIL_READ */]:{var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_11__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(_ref){var type=_ref.type;return type&&type.toLowerCase()===Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]].toLowerCase();}:undefined;var _categoryScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0])[0],Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,customNoneIsAutoAnnotation);var catSchemeCategorisations=(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["r" /* SDMX_JSON_CATEGORISATION_LIST_KEY */])||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);}).filter(function(_ref2){var target=_ref2.target;return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["U" /* getQuartupletFromItemString */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_2" /* getStringFromItemUrn */])(target)).id===_categoryScheme.id&&Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["U" /* getQuartupletFromItemString */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_2" /* getStringFromItemUrn */])(target)).agencyID===_categoryScheme.agencyID&&Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["U" /* getQuartupletFromItemString */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_2" /* getStringFromItemUrn */])(target)).version===_categoryScheme.version;});var _itemsTree2=_categoryScheme.categories?Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["h" /* getMappedTree */])(_categoryScheme.categories,"categories",function(node){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(node,Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */],customNoneIsAutoAnnotation);}):[];var _root=[{isRoot:true,categories:_itemsTree2}];_itemsTree2=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["h" /* getMappedTree */])(_root,"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].categories;var _count=Object(__WEBPACK_IMPORTED_MODULE_6__utils_normalizers__["b" /* normalizeItemsOrder */])(_itemsTree2,"categories",action.lang,action.itemsOrderAnnotationType);return Object.assign({},state,{categoryScheme:_categoryScheme,catSchemeCategorisations:catSchemeCategorisations,isCategorySchemeValid:true,itemsTree:_itemsTree2,itemsTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["j" /* getMaxTreeDepth */])(_itemsTree2,"categories"),maxOrder:_count});}case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CATEGORY_SCHEME_DETAIL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response,isAgenciesValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* CATEGORY_SCHEME_DETAIL_CREATE_SUBMIT */]:return Object.assign({},state,{categoryScheme:null,catSchemeCategorisations:null,isVisible:true,itemsTree:null,itemsTreeMaxDepth:null,maxOrder:null,categorySchemeTriplet:action.categorySchemeTriplet,isCategorySchemeValid:false,isCategorySchemeGeneralTabDirty:false,focusItemsTab:true,forceIsFinalDisabled:state.categoryScheme.isFinal});case __WEBPACK_IMPORTED_MODULE_1__actions__["_0" /* CATEGORY_SCHEME_DETAIL_UPDATE_SUBMIT */]:return Object.assign({},state,{item:null,selectedItem:null,itemsTree:action.itemsTree,itemsTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["j" /* getMaxTreeDepth */])(action.itemsTree,"categories"),isNormalizeNeeded:false,cutItem:null,agencies:null,allAgencies:null,forceIsFinalDisabled:state.categoryScheme.isFinal});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{csvRows:action.response.importedItemCsv,hash:action.response.hashImport,allCsvRows:null,filePath:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT */]:return Object.assign({},state,{itemsImportForm:null,isItemsImportFormVisible:false,isCategorySchemeValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* CATEGORY_SCHEME_DETAIL_DOWNLOAD_SUBMIT */]:return Object.assign({},state,{downloadCategorySchemeTriplets:null,downloadCategorySchemeLang:null,downloadCategorySchemeParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CATEGORY_SCHEME_DETAIL_CLONE_SUBMIT */]:return Object.assign({},state,{cloneDestTriplet:null,categoryScheme:state.isVisible?state.categoryScheme:null,catSchemeCategorisations:null,categorySchemeTriplet:state.isVisible?state.categorySchemeTriplet:null,itemsTree:state.isVisible?state.itemsTree:null,itemsTreeMaxDepth:state.isVisible?state.itemsTreeMaxDepth:null,maxOrder:state.isVisible?state.maxOrder:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* CATEGORY_SCHEME_DETAIL_EXPORT_SUBMIT */]:return Object.assign({},state,{categorySchemeExportSourceTriplet:null,categorySchemeExportDestination:null,categorySchemeExportReport:action.response.itemsMessage,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{filePath:action.response})});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* CATEGORY_SCHEME_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{allCsvRows:action.response})});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* CATEGORY_SCHEME_DETAIL_READ */]:return Object.assign({},state,{isVisible:false,isCategorySchemeValid:true});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["b" /* reuseInReducer */])(categorySchemeDetailModalReducer,{derivedCategoryScheme:Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_9__redux_derived_item_scheme_reducer__["a" /* default */],REDUX_CATEGORY_SCHEMES_DETAIL_DERIVED_IS_PREFIX)}));

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MSDS_LIST_MSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MSDS_MSD_DETAIL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MSDS_MSD_DETAIL_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MSDS_MSD_DETAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MSDS_MSD_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MSDS_MSD_DETAIL_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MSDS_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MSDS_MSD_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MSDS_SELECTED_MSDS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MSDS_MSD_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MSDS_MSD_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MSDS_MSD_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MSDS_MSD_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MSDS_MSD_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MSDS_MSD_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MSDS_MSD_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MSDS_MSD_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MSDS_MSD_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MSDS_MSD_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MSDS_MSD_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MSDS_MSD_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MSDS_MSD_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MSDS_MSD_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MSDS_MSD_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return readMsdsListMsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return showMsdsMsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return readMsdsMsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return changeMsdsMsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return hideMsdsMsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return submitMsdsMsdDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return readMsdsAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return deleteMsdsMsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return deleteMsdsSelectedMsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return showMsdsMsdDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return hideMsdsMsdDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return changeMsdsMsdDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return downloadMsdsMsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return readMsdsMsdParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return hideMsdsMsdParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return showMsdsMsdClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return hideMsdsMsdClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return changeMsdsMsdClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return submitMsdsMsdClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return showMsdsMsdExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return hideMsdsMsdExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return changeMsdsMsdExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return submitMsdsMsdExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return hideMsdsMsdExportReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artefact_export_form__ = __webpack_require__(51);
var MSDS_LIST_MSDS_READ='MSDS_LIST_MSDS_READ';var MSDS_MSD_DETAIL_SHOW='MSDS_MSD_DETAIL_SHOW';var MSDS_MSD_DETAIL_READ='MSDS_MSD_DETAIL_READ';var MSDS_MSD_DETAIL_CHANGE='MSDS_MSD_DETAIL_CHANGE';var MSDS_MSD_DETAIL_HIDE='MSDS_MSD_DETAIL_HIDE';var MSDS_MSD_DETAIL_SUBMIT='MSDS_MSD_DETAIL_SUBMIT';var MSDS_AGENCIES_READ='MSDS_AGENCIES_READ';var MSDS_MSD_DELETE='MSDS_MSD_DELETE';var MSDS_SELECTED_MSDS_DELETE='MSDS_SELECTED_MSDS_DELETE';var MSDS_MSD_DOWNLOAD_SHOW='MSDS_MSD_DOWNLOAD_SHOW';var MSDS_MSD_DOWNLOAD_HIDE='MSDS_MSD_DOWNLOAD_HIDE';var MSDS_MSD_DOWNLOAD_CHANGE='MSDS_MSD_DOWNLOAD_CHANGE';var MSDS_MSD_DOWNLOAD='MSDS_MSD_DOWNLOAD';var MSDS_MSD_PARENTS_AND_CHILDREN_READ='MSDS_MSD_PARENTS_AND_CHILDREN_READ';var MSDS_MSD_PARENTS_AND_CHILDREN_HIDE='MSDS_MSD_PARENTS_AND_CHILDREN_HIDE';var MSDS_MSD_CLONE_SHOW='MSDS_MSD_CLONE_SHOW';var MSDS_MSD_CLONE_HIDE='MSDS_MSD_CLONE_HIDE';var MSDS_MSD_CLONE_CHANGE='MSDS_MSD_CLONE_CHANGE';var MSDS_MSD_CLONE_SUBMIT='MSDS_MSD_CLONE_SUBMIT';var MSDS_MSD_EXPORT_SHOW='MSDS_MSD_EXPORT_SHOW';var MSDS_MSD_EXPORT_HIDE='MSDS_MSD_EXPORT_HIDE';var MSDS_MSD_EXPORT_CHANGE='MSDS_MSD_EXPORT_CHANGE';var MSDS_MSD_EXPORT_SUBMIT='MSDS_MSD_EXPORT_SUBMIT';var MSDS_MSD_EXPORT_REPORT_HIDE='MSDS_MSD_EXPORT_REPORT_HIDE';var readMsdsListMsds=function readMsdsListMsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(MSDS_LIST_MSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_66" /* getMsdUrl */])());};var showMsdsMsdDetail=function showMsdsMsdDetail(artefactTriplet){return{type:MSDS_MSD_DETAIL_SHOW,artefactTriplet:artefactTriplet};};var readMsdsMsdDetail=function readMsdsMsdDetail(artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(MSDS_MSD_DETAIL_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_66" /* getMsdUrl */])(artefactTriplet));};var changeMsdsMsdDetail=function changeMsdsMsdDetail(fields){return{type:MSDS_MSD_DETAIL_CHANGE,fields:fields};};var hideMsdsMsdDetail=function hideMsdsMsdDetail(){return{type:MSDS_MSD_DETAIL_HIDE};};var submitMsdsMsdDetail=function submitMsdsMsdDetail(msd,annotationsConfig){var customIsPresentationalAnnotType=(annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]]||"").toLowerCase();if(msd.customIsPresentational){if(!msd.autoAnnotations.find(function(_ref){var type=_ref.type;return(type||"").toLowerCase()!==customIsPresentationalAnnotType;})){msd.autoAnnotations.push({type:annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]],id:annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]],title:annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]]});}}else{msd.autoAnnotations=(msd.autoAnnotations||[]).filter(function(_ref2){var type=_ref2.type;return(type||"").toLowerCase()!==customIsPresentationalAnnotType;});}return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(MSDS_MSD_DETAIL_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_101" /* getUpdateMsdUrl */])(),Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(msd),{agencyID:undefined,agency:msd.agencyID}),function(t){return{success:t('scenes.metaManager.msds.messages.update.success')};});};var readMsdsAgencies=function readMsdsAgencies(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(MSDS_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])());};var deleteMsdsMsd=function deleteMsdsMsd(artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(MSDS_MSD_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("Msd",artefactTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var deleteMsdsSelectedMsds=function deleteMsdsSelectedMsds(artefactTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(MSDS_SELECTED_MSDS_DELETE,artefactTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),artefactTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("Msd",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},artefactTriplets.map(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]));};var showMsdsMsdDownload=function showMsdsMsdDownload(artefactTriplets,lang){return{type:MSDS_MSD_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideMsdsMsdDownload=function hideMsdsMsdDownload(){return{type:MSDS_MSD_DOWNLOAD_HIDE};};var changeMsdsMsdDownload=function changeMsdsMsdDownload(fields){return{type:MSDS_MSD_DOWNLOAD_CHANGE,fields:fields};};var downloadMsdsMsd=function downloadMsdsMsd(artefactTriplets,downloadMsdParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MSDS_MSD_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_2__constants_download__["k" /* ARTEFACT_TYPE_MSD */],downloadMsdParams.format,downloadMsdParams.references,downloadMsdParams.compression,lang),artefactTriplets.map(function(_ref3){var id=_ref3.id,agencyID=_ref3.agencyID,version=_ref3.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_2__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_2__constants_download__["k" /* ARTEFACT_TYPE_MSD */],downloadMsdParams.format,downloadMsdParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(MSDS_MSD_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_2__constants_download__["k" /* ARTEFACT_TYPE_MSD */],artefactTriplets[0],downloadMsdParams.format,downloadMsdParams.references,downloadMsdParams.compression,lang),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_2__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_2__constants_download__["k" /* ARTEFACT_TYPE_MSD */],downloadMsdParams.format,downloadMsdParams.compression)});};var readMsdsMsdParentsAndChildren=function readMsdsMsdParentsAndChildren(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(MSDS_MSD_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideMsdsMsdParentsAndChildren=function hideMsdsMsdParentsAndChildren(){return{type:MSDS_MSD_PARENTS_AND_CHILDREN_HIDE};};var showMsdsMsdClone=function showMsdsMsdClone(srcTriplet){return{type:MSDS_MSD_CLONE_SHOW,srcTriplet:srcTriplet};};var hideMsdsMsdClone=function hideMsdsMsdClone(){return{type:MSDS_MSD_CLONE_HIDE};};var changeMsdsMsdClone=function changeMsdsMsdClone(fields){return{type:MSDS_MSD_CLONE_CHANGE,fields:fields};};var submitMsdsMsdClone=function submitMsdsMsdClone(cloneDestTriplet,srcMsd){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MSDS_MSD_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["z" /* getCloneMsdUrl */])({id:srcMsd.id,agencyID:srcMsd.agencyID,version:srcMsd.version},cloneDestTriplet),null,function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showMsdsMsdExport=function showMsdsMsdExport(sourceTriplet){return{type:MSDS_MSD_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideMsdsMsdExport=function hideMsdsMsdExport(){return{type:MSDS_MSD_EXPORT_HIDE};};var changeMsdsMsdExport=function changeMsdsMsdExport(fields){return{type:MSDS_MSD_EXPORT_CHANGE,fields:fields};};var submitMsdsMsdExport=function submitMsdsMsdExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MSDS_MSD_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||""),EnumType:"Msd",CopyReferencedArtefact:destination.withReferences,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_5__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideMsdsMsdExportReport=function hideMsdsMsdExportReport(){return{type:MSDS_MSD_EXPORT_REPORT_HIDE};};

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPGRADE_DSD_DSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPGRADE_DSD_UPGRADED_DSDS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPGRADE_DSD_UPGRADED_DSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPGRADE_DSD_UPGRADED_DSDS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPGRADE_DSD_DSDS_COMPARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPGRADE_DSD_DSDS_COMPARE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPGRADE_DSD_DSD_UPGRADE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPGRADE_DSD_DSD_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPGRADE_DSD_DSD_UPGRADE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPGRADE_DSD_DATAFLOWS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPGRADE_DSD_DATAFLOWS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPGRADE_DSD_CODELIST_COMPARE_REPORT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPGRADE_DSD_CODELIST_COMPARE_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPGRADE_DSD_IMPORT_DSD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPGRADE_DSD_IMPORT_DSD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPGRADE_DSD_IMPORT_DSD_FILE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPGRADE_DSD_IMPORT_DSD_IMPORT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPGRADE_DSD_IMPORT_DSD_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return readUpgradeDsdDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return showUpgradeDsdUpgradedDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return hideUpgradeDsdUpgradedDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return readUpgradeDsdUpgradedDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return compareUpgradeDsdDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return hideUpgradeDsdDsdsCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return showUpgradeDsdDsdUpgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return upgradeUpgradeDsdDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return hideUpgradeDsdDsdUpgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return showUpgradeDsdDataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return hideUpgradeDsdDataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return readUpgradeDsdCodelistCompareReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return hideUpgradeDsdCodelistCompareReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return showUpgradeDsdImportDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return hideUpgradeDsdImportDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return setUpgradeDsdImportDsdFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return submitUpgradeDsdImportDsdDsdsCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return downloadUpgradeDsdImportDsdDsdsCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return startUpgradeDsdImportDsdImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return uploadUpgradeDsdImportDsdFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return submitUpgradeDsdImportDsdFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return hideUpgradeDsdImportDsdReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var UPGRADE_DSD_DSDS_READ="UPGRADE_DSD_DSDS_READ";var UPGRADE_DSD_UPGRADED_DSDS_SHOW='UPGRADE_DSD_UPGRADED_DSDS_SHOW';var UPGRADE_DSD_UPGRADED_DSDS_READ='UPGRADE_DSD_UPGRADED_DSDS_READ';var UPGRADE_DSD_UPGRADED_DSDS_HIDE='UPGRADE_DSD_UPGRADED_DSDS_HIDE';var UPGRADE_DSD_DSDS_COMPARE='UPGRADE_DSD_DSDS_COMPARE';var UPGRADE_DSD_DSDS_COMPARE_HIDE='UPGRADE_DSD_DSDS_COMPARE_HIDE';var UPGRADE_DSD_DSD_UPGRADE_SHOW='UPGRADE_DSD_DSD_UPGRADE_SHOW';var UPGRADE_DSD_DSD_UPGRADE='UPGRADE_DSD_DSD_UPGRADE';var UPGRADE_DSD_DSD_UPGRADE_HIDE='UPGRADE_DSD_DSD_UPGRADE_HIDE';var UPGRADE_DSD_DATAFLOWS_SHOW='UPGRADE_DSD_DATAFLOWS_SHOW';var UPGRADE_DSD_DATAFLOWS_HIDE='UPGRADE_DSD_DATAFLOWS_HIDE';var UPGRADE_DSD_CODELIST_COMPARE_REPORT_READ='UPGRADE_DSD_CODELIST_COMPARE_REPORT_READ';var UPGRADE_DSD_CODELIST_COMPARE_REPORT_HIDE='UPGRADE_DSD_CODELIST_COMPARE_REPORT_HIDE';var UPGRADE_DSD_IMPORT_DSD_SHOW='UPGRADE_DSD_IMPORT_DSD_SHOW';var UPGRADE_DSD_IMPORT_DSD_HIDE='UPGRADE_DSD_IMPORT_DSD_HIDE';var UPGRADE_DSD_IMPORT_DSD_FILE_SET='UPGRADE_DSD_IMPORT_DSD_FILE_SET';var UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT='UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT';var UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_DOWNLOAD='UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_DOWNLOAD';var UPGRADE_DSD_IMPORT_DSD_IMPORT_START='UPGRADE_DSD_IMPORT_DSD_IMPORT_START';var UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD='UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD';var UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT='UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT';var UPGRADE_DSD_IMPORT_DSD_REPORT_HIDE='UPGRADE_DSD_IMPORT_DSD_REPORT_HIDE';var readUpgradeDsdDsds=function readUpgradeDsdDsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(UPGRADE_DSD_DSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_31" /* getDsdWithDataflowUrl */])());};var showUpgradeDsdUpgradedDsds=function showUpgradeDsdUpgradedDsds(dsdTriplet){return{type:UPGRADE_DSD_UPGRADED_DSDS_SHOW,dsdTriplet:dsdTriplet};};var hideUpgradeDsdUpgradedDsds=function hideUpgradeDsdUpgradedDsds(){return{type:UPGRADE_DSD_UPGRADED_DSDS_HIDE};};var readUpgradeDsdUpgradedDsds=function readUpgradeDsdUpgradedDsds(dsdTriplet){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(UPGRADE_DSD_UPGRADED_DSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["k" /* getAllUpgradableDsdUrl */])(dsdTriplet)));};var compareUpgradeDsdDsds=function compareUpgradeDsdDsds(sourceDsdTriplet,targetDsdTriplet,showModal){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(UPGRADE_DSD_DSDS_COMPARE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_44" /* getGenerateReportDsdUrl */])(sourceDsdTriplet,targetDsdTriplet,true)),{showModal:showModal,targetDsdTriplet:targetDsdTriplet});};var hideUpgradeDsdDsdsCompare=function hideUpgradeDsdDsdsCompare(){return{type:UPGRADE_DSD_DSDS_COMPARE_HIDE};};var showUpgradeDsdDsdUpgrade=function showUpgradeDsdDsdUpgrade(dsdTriplet){return{type:UPGRADE_DSD_DSD_UPGRADE_SHOW,dsdTriplet:dsdTriplet};};var upgradeUpgradeDsdDsd=function upgradeUpgradeDsdDsd(report){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(UPGRADE_DSD_DSD_UPGRADE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_104" /* getUpgradeDsdUrl */])(),report);};var hideUpgradeDsdDsdUpgrade=function hideUpgradeDsdDsdUpgrade(success){return{type:UPGRADE_DSD_DSD_UPGRADE_HIDE,success:success};};var showUpgradeDsdDataflows=function showUpgradeDsdDataflows(dsdTriplet,dataflows){return{type:UPGRADE_DSD_DATAFLOWS_SHOW,dsdTriplet:dsdTriplet,dataflows:dataflows};};var hideUpgradeDsdDataflows=function hideUpgradeDsdDataflows(){return{type:UPGRADE_DSD_DATAFLOWS_HIDE};};var readUpgradeDsdCodelistCompareReport=function readUpgradeDsdCodelistCompareReport(sourceTriplet,targetTriplet,targetFile){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(UPGRADE_DSD_CODELIST_COMPARE_REPORT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["B" /* getCompareCodelistUrl */])(sourceTriplet,targetTriplet,null,targetFile)),{targetTriplet:targetTriplet});};var hideUpgradeDsdCodelistCompareReport=function hideUpgradeDsdCodelistCompareReport(){return{type:UPGRADE_DSD_CODELIST_COMPARE_REPORT_HIDE};};var showUpgradeDsdImportDsd=function showUpgradeDsdImportDsd(){return{type:UPGRADE_DSD_IMPORT_DSD_SHOW};};var hideUpgradeDsdImportDsd=function hideUpgradeDsdImportDsd(){return{type:UPGRADE_DSD_IMPORT_DSD_HIDE};};var setUpgradeDsdImportDsdFile=function setUpgradeDsdImportDsdFile(file){return{type:UPGRADE_DSD_IMPORT_DSD_FILE_SET,file:file};};var submitUpgradeDsdImportDsdDsdsCompare=function submitUpgradeDsdImportDsdDsdsCompare(srcTriplet,targetFile,showModal){var customData={sourceArtefact:srcTriplet?{ID:srcTriplet.id,Agency:srcTriplet.agencyID,Version:srcTriplet.version,StreamType:'Database'}:{StreamType:'Xml'},targetArtefact:{StreamType:'Xml'}};var fileFormData=new FormData();fileFormData.append('Files',targetFile);fileFormData.append('CustomData',JSON.stringify(customData));return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["C" /* getCompareDsdsUrl */])(true),fileFormData),{showModal:showModal});};var downloadUpgradeDsdImportDsdDsdsCompare=function downloadUpgradeDsdImportDsdDsdsCompare(srcTriplet,targetTriplet,targetFile,lang){var currDate=__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD_HH-mm-ss');var fileSave={name:"CompareDsds_"+currDate+".txt",type:"text/plain;charset=utf-8"};var customData={sourceArtefact:{ID:srcTriplet.id,Agency:srcTriplet.agencyID,Version:srcTriplet.version,StreamType:'Database'},targetArtefact:targetTriplet?{ID:targetTriplet.id,Agency:targetTriplet.agencyID,Version:targetTriplet.version,StreamType:'Database'}:{StreamType:'Xml'}};var fileFormData=new FormData();if(targetFile!==null){fileFormData.append('Files',targetFile);}fileFormData.append('CustomData',JSON.stringify(customData));return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_43" /* getGenerateFileReportDsdUrl */])(lang),fileFormData,undefined,undefined,true),{fileSave:fileSave});};var startUpgradeDsdImportDsdImport=function startUpgradeDsdImportDsdImport(){return{type:UPGRADE_DSD_IMPORT_DSD_IMPORT_START};};var uploadUpgradeDsdImportDsdFile=function uploadUpgradeDsdImportDsdFile(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["v" /* getCheckImportedFileXmlSdmxObjectsUrl */])(),fileFormData,function(t){return{success:t('scenes.utilities.importStructures.messages.fileUpload.success')};});};var submitUpgradeDsdImportDsdFile=function submitUpgradeDsdImportDsdFile(structures,hash){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_50" /* getImportFileXmlSdmxObjectsUrl */])(),{importedItem:structures,hashImport:hash});};var hideUpgradeDsdImportDsdReport=function hideUpgradeDsdImportDsdReport(){return{type:UPGRADE_DSD_IMPORT_DSD_REPORT_HIDE};};

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIERARCHICAL_CODELISTS_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return readHierarchicalCodelistsListHierarchicalCodelists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return showHierarchicalCodelistsHierarchicalCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return readHierarchicalCodelistsHierarchicalCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return changeHierarchicalCodelistsHierarchicalCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return hideHierarchicalCodelistsHierarchicalCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return submitHierarchicalCodelistsHierarchicalCodelistDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return readHierarchicalCodelistsAgencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return deleteHierarchicalCodelistsHierarchicalCodelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return deleteHierarchicalCodelistsSelectedHierarchicalCodelists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return showHierarchicalCodelistsHierarchicalCodelistDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return hideHierarchicalCodelistsHierarchicalCodelistDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return changeHierarchicalCodelistsHierarchicalCodelistDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return downloadHierarchicalCodelistsHierarchicalCodelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return showHierarchicalCodelistsHierarchicalCodelistClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return hideHierarchicalCodelistsHierarchicalCodelistClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return changeHierarchicalCodelistsHierarchicalCodelistClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return submitHierarchicalCodelistsHierarchicalCodelistClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return showHierarchicalCodelistsHierarchicalCodelistExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return hideHierarchicalCodelistsHierarchicalCodelistExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return changeHierarchicalCodelistsHierarchicalCodelistExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return submitHierarchicalCodelistsHierarchicalCodelistExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return hideHierarchicalCodelistsHierarchicalCodelistExportReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artefact_export_form__ = __webpack_require__(51);
var HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ='HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SHOW='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SHOW';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SUBMIT='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SUBMIT';var HIERARCHICAL_CODELISTS_AGENCIES_READ='HIERARCHICAL_CODELISTS_AGENCIES_READ';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE';var HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE='HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT';var HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE='HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE';var readHierarchicalCodelistsListHierarchicalCodelists=function readHierarchicalCodelistsListHierarchicalCodelists(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_45" /* getHierarchicalCodelistUrl */])());};var showHierarchicalCodelistsHierarchicalCodelistDetail=function showHierarchicalCodelistsHierarchicalCodelistDetail(artefactTriplet){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SHOW,artefactTriplet:artefactTriplet};};var readHierarchicalCodelistsHierarchicalCodelistDetail=function readHierarchicalCodelistsHierarchicalCodelistDetail(artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_45" /* getHierarchicalCodelistUrl */])(artefactTriplet));};var changeHierarchicalCodelistsHierarchicalCodelistDetail=function changeHierarchicalCodelistsHierarchicalCodelistDetail(fields){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE,fields:fields};};var hideHierarchicalCodelistsHierarchicalCodelistDetail=function hideHierarchicalCodelistsHierarchicalCodelistDetail(){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE};};var submitHierarchicalCodelistsHierarchicalCodelistDetail=function submitHierarchicalCodelistsHierarchicalCodelistDetail(hierarchicalCodelist,annotationsConfig){var customIsPresentationalAnnotType=(annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]]||"").toLowerCase();if(hierarchicalCodelist.customIsPresentational){if(!hierarchicalCodelist.autoAnnotations.find(function(_ref){var type=_ref.type;return(type||"").toLowerCase()!==customIsPresentationalAnnotType;})){hierarchicalCodelist.autoAnnotations.push({type:annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]],id:annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]],title:annotationsConfig[__WEBPACK_IMPORTED_MODULE_4__utils_annotations__["a" /* AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY */]]});}}else{hierarchicalCodelist.autoAnnotations=(hierarchicalCodelist.autoAnnotations||[]).filter(function(_ref2){var type=_ref2.type;return(type||"").toLowerCase()!==customIsPresentationalAnnotType;});}return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_99" /* getUpdateHierarchicalCodelistUrl */])(),Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(hierarchicalCodelist),{agencyID:undefined,agency:hierarchicalCodelist.agencyID}),function(t){return{success:t('scenes.metaManager.hierarchicalCodelists.messages.update.success')};});};var readHierarchicalCodelistsAgencies=function readHierarchicalCodelistsAgencies(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(HIERARCHICAL_CODELISTS_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])());};var deleteHierarchicalCodelistsHierarchicalCodelist=function deleteHierarchicalCodelistsHierarchicalCodelist(artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("HierarchicalCodelist",artefactTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var deleteHierarchicalCodelistsSelectedHierarchicalCodelists=function deleteHierarchicalCodelistsSelectedHierarchicalCodelists(artefactTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE,artefactTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),artefactTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("HierarchicalCodelist",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},artefactTriplets.map(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]));};var showHierarchicalCodelistsHierarchicalCodelistDownload=function showHierarchicalCodelistsHierarchicalCodelistDownload(artefactTriplets,lang){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW,artefactTriplets:artefactTriplets,lang:lang};};var hideHierarchicalCodelistsHierarchicalCodelistDownload=function hideHierarchicalCodelistsHierarchicalCodelistDownload(){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE};};var changeHierarchicalCodelistsHierarchicalCodelistDownload=function changeHierarchicalCodelistsHierarchicalCodelistDownload(fields){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE,fields:fields};};var downloadHierarchicalCodelistsHierarchicalCodelist=function downloadHierarchicalCodelistsHierarchicalCodelist(artefactTriplets,downloadHierarchicalCodelistParams,lang){return artefactTriplets&&artefactTriplets.length>1?Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_67" /* getMultipleDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_2__constants_download__["i" /* ARTEFACT_TYPE_HIERARCHICAL_CODELIST */],downloadHierarchicalCodelistParams.format,downloadHierarchicalCodelistParams.references,downloadHierarchicalCodelistParams.compression,lang),artefactTriplets.map(function(_ref3){var id=_ref3.id,agencyID=_ref3.agencyID,version=_ref3.version;return{id:id,agency:agencyID,version:version};}),undefined,undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_2__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_2__constants_download__["i" /* ARTEFACT_TYPE_HIERARCHICAL_CODELIST */],downloadHierarchicalCodelistParams.format,downloadHierarchicalCodelistParams.compression)}):Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_27" /* getDownloadArtefactUrl */])(__WEBPACK_IMPORTED_MODULE_2__constants_download__["i" /* ARTEFACT_TYPE_HIERARCHICAL_CODELIST */],artefactTriplets[0],downloadHierarchicalCodelistParams.format,downloadHierarchicalCodelistParams.references,downloadHierarchicalCodelistParams.compression,lang),undefined,true),{fileSave:Object(__WEBPACK_IMPORTED_MODULE_2__constants_download__["u" /* getArtefactDownloadFileSaveNameAndType */])(artefactTriplets,__WEBPACK_IMPORTED_MODULE_2__constants_download__["i" /* ARTEFACT_TYPE_HIERARCHICAL_CODELIST */],downloadHierarchicalCodelistParams.format,downloadHierarchicalCodelistParams.compression)});};var readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren=function readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren=function hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren(){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE};};var showHierarchicalCodelistsHierarchicalCodelistClone=function showHierarchicalCodelistsHierarchicalCodelistClone(srcTriplet){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW,srcTriplet:srcTriplet};};var hideHierarchicalCodelistsHierarchicalCodelistClone=function hideHierarchicalCodelistsHierarchicalCodelistClone(){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE};};var changeHierarchicalCodelistsHierarchicalCodelistClone=function changeHierarchicalCodelistsHierarchicalCodelistClone(fields){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE,fields:fields};};var submitHierarchicalCodelistsHierarchicalCodelistClone=function submitHierarchicalCodelistsHierarchicalCodelistClone(cloneDestTriplet,srcHcl){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["x" /* getCloneHclUrl */])({id:srcHcl.id,agencyID:srcHcl.agencyID,version:srcHcl.version},cloneDestTriplet),null,function(t){return{success:t('commons.artefact.messages.clone.success')};});};var showHierarchicalCodelistsHierarchicalCodelistExport=function showHierarchicalCodelistsHierarchicalCodelistExport(sourceTriplet){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW,sourceTriplet:sourceTriplet};};var hideHierarchicalCodelistsHierarchicalCodelistExport=function hideHierarchicalCodelistsHierarchicalCodelistExport(){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE};};var changeHierarchicalCodelistsHierarchicalCodelistExport=function changeHierarchicalCodelistsHierarchicalCodelistExport(fields){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE,fields:fields};};var submitHierarchicalCodelistsHierarchicalCodelistExport=function submitHierarchicalCodelistsHierarchicalCodelistExport(sourceTriplet,destination){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_40" /* getExportArtefactUrl */])(),{id:sourceTriplet.id,agency:sourceTriplet.agencyID,version:sourceTriplet.version,targetID:destination.id,targetAgency:destination.agencyID,targetVersion:destination.version,nodeId:destination.endpoint,username:destination.username,password:btoa(destination.password||""),EnumType:"HierarchicalCodelist",CopyReferencedArtefact:false,ShiboletCode:destination.loginOption!==__WEBPACK_IMPORTED_MODULE_5__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */]?destination.providerLoginCode:null});};var hideHierarchicalCodelistsHierarchicalCodelistExportReport=function hideHierarchicalCodelistsHierarchicalCodelistExportReport(){return{type:HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE};};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EL_MAPPING_RESET_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EL_MAPPING_FILE_MAPPING_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getELCsvMappingsCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return resetELMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return readELFileMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return selectELMappingColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return addELComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return removeELComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return removeAllELComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addAllELComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return selectELComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return selectELCubeComponentListComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
var EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ="EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ";var EL_MAPPING_RESET_MAPPING="EL_MAPPING_RESET_MAPPING";var EL_MAPPING_FILE_MAPPING_READ="EL_MAPPING_FILE_MAPPING_READ";var EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT="EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT";var EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT="EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT";var EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD="EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD";var EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL="EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL";var EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE="EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE";var EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL="EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL";var EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT="EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT";var getELCsvMappingsCube=function getELCsvMappingsCube(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath,cubeId){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["i" /* allRequest */])(EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ,[__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["T" /* getCsvHeaderUrl */])(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath),Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_42" /* getFileMappingUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["X" /* getCubeUrl */])(cubeId)]),{cubeId:cubeId});};var resetELMapping=function resetELMapping(){return{type:EL_MAPPING_RESET_MAPPING};};var readELFileMapping=function readELFileMapping(fileMappingId){return Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["l" /* getRequest */])(EL_MAPPING_FILE_MAPPING_READ,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_42" /* getFileMappingUrl */])(fileMappingId));};var selectELMappingColumn=function selectELMappingColumn(columnName){return{type:EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT,columnName:columnName};};var addELComponentMapperComponent=function addELComponentMapperComponent(columnName,cubeComponentCode){return{type:EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD,columnName:columnName,cubeComponentCode:cubeComponentCode};};var removeELComponentMapperComponent=function removeELComponentMapperComponent(columnName,cubeComponentCode){return{type:EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE,columnName:columnName,cubeComponentCode:cubeComponentCode};};var removeAllELComponentMapperComponent=function removeAllELComponentMapperComponent(){return{type:EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL};};var addAllELComponentMapperComponent=function addAllELComponentMapperComponent(){return{type:EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL};};var selectELComponentMapperComponent=function selectELComponentMapperComponent(columnName,cubeComponentCode){return{type:EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT,columnName:columnName,cubeComponentCode:cubeComponentCode};};var selectELCubeComponentListComponent=function selectELCubeComponentListComponent(cubeComponentCode){return{type:EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT,cubeComponentCode:cubeComponentCode};};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1159);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcNotification = _interopRequireDefault(__webpack_require__(1160));

var _icon = _interopRequireDefault(__webpack_require__(25));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

/* global Promise */
var defaultDuration = 3;
var defaultTop;
var messageInstance;
var key = 1;
var prefixCls = 'ant-message';
var transitionName = 'move-up';
var getContainer;
var maxCount;

function getMessageInstance(callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }

  _rcNotification["default"].newInstance({
    prefixCls: prefixCls,
    transitionName: transitionName,
    style: {
      top: defaultTop
    },
    getContainer: getContainer,
    maxCount: maxCount
  }, function (instance) {
    if (messageInstance) {
      callback(messageInstance);
      return;
    }

    messageInstance = instance;
    callback(instance);
  });
}

function notice(args) {
  var duration = args.duration !== undefined ? args.duration : defaultDuration;
  var iconType = {
    info: 'info-circle',
    success: 'check-circle',
    error: 'close-circle',
    warning: 'exclamation-circle',
    loading: 'loading'
  }[args.type];
  var target = key++;
  var closePromise = new Promise(function (resolve) {
    var callback = function callback() {
      if (typeof args.onClose === 'function') {
        args.onClose();
      }

      return resolve(true);
    };

    getMessageInstance(function (instance) {
      var iconNode = React.createElement(_icon["default"], {
        type: iconType,
        theme: iconType === 'loading' ? 'outlined' : 'filled'
      });
      instance.notice({
        key: target,
        duration: duration,
        style: {},
        content: React.createElement("div", {
          className: "".concat(prefixCls, "-custom-content").concat(args.type ? " ".concat(prefixCls, "-").concat(args.type) : '')
        }, args.icon ? args.icon : iconType ? iconNode : '', React.createElement("span", null, args.content)),
        onClose: callback
      });
    });
  });

  var result = function result() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };

  result.then = function (filled, rejected) {
    return closePromise.then(filled, rejected);
  };

  result.promise = closePromise;
  return result;
}

var api = {
  open: notice,
  config: function config(options) {
    if (options.top !== undefined) {
      defaultTop = options.top;
      messageInstance = null; // delete messageInstance for new defaultTop
    }

    if (options.duration !== undefined) {
      defaultDuration = options.duration;
    }

    if (options.prefixCls !== undefined) {
      prefixCls = options.prefixCls;
    }

    if (options.getContainer !== undefined) {
      getContainer = options.getContainer;
    }

    if (options.transitionName !== undefined) {
      transitionName = options.transitionName;
      messageInstance = null; // delete messageInstance for new transitionName
    }

    if (options.maxCount !== undefined) {
      maxCount = options.maxCount;
      messageInstance = null;
    }
  },
  destroy: function destroy() {
    if (messageInstance) {
      messageInstance.destroy();
      messageInstance = null;
    }
  }
};
['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
  api[type] = function (content, duration, onClose) {
    if (typeof duration === 'function') {
      onClose = duration;
      duration = undefined;
    }

    return api.open({
      content: content,
      duration: duration,
      type: type,
      onClose: onClose
    });
  };
});
api.warn = api.warning;
var _default = api;
exports["default"] = _default;

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isClassificationsServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isPageVisible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_menus__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_paths__ = __webpack_require__(124);
var isClassificationsServer=function isClassificationsServer(username,permissions,anonymousPages,t){var metaManagerNode=Object(__WEBPACK_IMPORTED_MODULE_0__constants_menus__["b" /* userMenu */])(t).find(function(_ref){var path=_ref.path;return path===__WEBPACK_IMPORTED_MODULE_1__constants_paths__["J" /* PATH_META_MANAGER */];});return username!==null?!permissions||!permissions.functionality||permissions.functionality.length!==1?false:metaManagerNode.children.map(function(_ref2){var path=_ref2.path;return path.substr(path.lastIndexOf("/")+1);}).includes(permissions.functionality[0]):!anonymousPages||anonymousPages.length!==1?false:metaManagerNode.children.map(function(_ref3){var path=_ref3.path;return path;}).includes(anonymousPages[0]);};var isPageVisible=function isPageVisible(permissions,anonymousPages){return function(_ref4){var children=_ref4.children,path=_ref4.path,isDivider=_ref4.isDivider;return isDivider||children||(permissions!==null?permissions.functionality?permissions.functionality.filter(function(page){return page===path.substr(path.lastIndexOf("/")+1);}).length:false:children||anonymousPages.filter(function(page){return page===path;}).length);};};

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return userMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return superUserMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paths__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scenes_data_manager_builder__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_data_manager_file_mapping__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_data_manager_loader__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_data_manager_cube_list__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scenes_data_manager_dataflow_builder__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scenes_configuration_nodes_config__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_configuration_app_config__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scenes_utilities_import_structures__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scenes_meta_manager_codelists__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scenes_meta_manager_category_schemes__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scenes_meta_manager_concept_schemes__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scenes_meta_manager_dataflows__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scenes_manage_users_set_permissions__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scenes_data_manager_sync_codelists__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__scenes_reference_metadata_dcat__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__scenes_meta_manager_category_schemes_and_dataflows__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__scenes_meta_manager_dsds__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scenes_manage_users_user_menagment__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scenes_meta_manager_msds__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scenes_meta_manager_agency_schemes__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__scenes_meta_manager_metadataflows__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__scenes_data_manager_upgrade_dsd__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__scenes_data_manager_remove_temp_tables_RemoveTempTables__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scenes_utilities_compare_dsds__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scenes_utilities_compare_item_schemes__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scenes_meta_manager_content_constraint__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__scenes_reference_metadata_metadata_set__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__scenes_data_manager_ddb_reset_DdbReset__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scenes_utilities_merge_item_schemes__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__scenes_meta_manager_hierarchical_codelists__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__scenes_data_manager_manage_series__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__scenes_data_manager_attribute_file__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__scenes_data_manager_update_databrowser_cache_UpdateDatabrowserCache__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__scenes_easy_loading_easy_loading_create__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__scenes_easy_loading_easy_loading_update__ = __webpack_require__(1583);
var userMenu=function userMenu(t){return[{label:t('menu.metaManager.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["J" /* PATH_META_MANAGER */],blackIconPath:'./static/png/meta-manager.png',redIconPath:'./static/png/meta-manager_red.png',children:[{label:t('menu.conceptSchemes.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["l" /* PATH_CONCEPT_SCHEMES */],blackIconPath:'./static/png/concept-schemes.png',redIconPath:'./static/png/concept-schemes_red.png',component:__WEBPACK_IMPORTED_MODULE_11__scenes_meta_manager_concept_schemes__["a" /* default */]},{label:t('menu.codelists.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["i" /* PATH_CODELISTS */],blackIconPath:'./static/png/codelists.png',redIconPath:'./static/png/codelists_red.png',component:__WEBPACK_IMPORTED_MODULE_9__scenes_meta_manager_codelists__["a" /* default */]},{label:t('menu.dataStructureDefinitions.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["u" /* PATH_DATA_STRUCTURE_DEFINITIONS */],blackIconPath:'./static/png/data-structure-definitions.png',redIconPath:'./static/png/data-structure-definitions_red.png',component:__WEBPACK_IMPORTED_MODULE_17__scenes_meta_manager_dsds__["a" /* default */]},{label:t('menu.dataflows.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["p" /* PATH_DATAFLOWS */],blackIconPath:'./static/png/dataflows.png',redIconPath:'./static/png/dataflows_red.png',component:__WEBPACK_IMPORTED_MODULE_12__scenes_meta_manager_dataflows__["a" /* default */]},{label:t('menu.categorySchemes.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["g" /* PATH_CATEGORY_SCHEMES */],blackIconPath:'./static/png/category-schemes.png',redIconPath:'./static/png/category-schemes_red.png',component:__WEBPACK_IMPORTED_MODULE_10__scenes_meta_manager_category_schemes__["a" /* default */]},{label:t('menu.categorisations.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["f" /* PATH_CATEGORISATIONS */],blackIconPath:'./static/png/categorisations.png',redIconPath:'./static/png/categorisations_red.png'},{label:t('menu.hierarchicalCodelists.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["B" /* PATH_HIERARCHICAL_CODELISTS */],blackIconPath:'./static/png/hierarchical-codelists.png',redIconPath:'./static/png/hierarchical-codelists_red.png',component:__WEBPACK_IMPORTED_MODULE_30__scenes_meta_manager_hierarchical_codelists__["a" /* default */]},{label:t('menu.agencySchemes.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["a" /* PATH_AGENCY_SCHEMES */],blackIconPath:'./static/png/agency-schemes.png',redIconPath:'./static/png/agency-schemes_red.png',component:__WEBPACK_IMPORTED_MODULE_20__scenes_meta_manager_agency_schemes__["a" /* default */]},{label:t('menu.dataProviderSchemes.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["t" /* PATH_DATA_PROVIDER_SCHEMES */],blackIconPath:'./static/png/data-provider-schemes.png',redIconPath:'./static/png/data-provider-schemes_red.png'},{label:t('menu.dataConsumerSchemes.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["r" /* PATH_DATA_CONSUMER_SCHEMES */],blackIconPath:'./static/png/data-consumer-schemes.png',redIconPath:'./static/png/data-consumer-schemes_red.png'},{label:t('menu.organizationUnitSchemes.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["M" /* PATH_ORGANIZATION_UNIT_SCHEMES */],blackIconPath:'./static/png/organization-unit-schemes.png',redIconPath:'./static/png/organization-unit-schemes_red.png'},{label:t('menu.contentConstraints.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["n" /* PATH_CONTENT_CONSTRAINTS */],blackIconPath:'./static/png/content-constraints.png',redIconPath:'./static/png/content-constraints_red.png',component:__WEBPACK_IMPORTED_MODULE_26__scenes_meta_manager_content_constraint__["a" /* default */]},{label:t('menu.structureSets.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["S" /* PATH_STRUCTURE_SETS */],blackIconPath:'./static/png/structure-sets.png',redIconPath:'./static/png/structure-sets_red.png'},{label:t('menu.provisionAgreements.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["N" /* PATH_PROVISION_AGREEMENTS */],blackIconPath:'./static/png/provision-agreements.png',redIconPath:'./static/png/provision-agreements_red.png'},{label:t('menu.registrations.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["P" /* PATH_REGISTRATIONS */],blackIconPath:'./static/png/registrations.png',redIconPath:'./static/png/registrations_red.png'},{label:t('menu.categorySchemesAndDataflows.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["h" /* PATH_CATEGORY_SCHEMES_AND_DATAFLOWS */],component:__WEBPACK_IMPORTED_MODULE_16__scenes_meta_manager_category_schemes_and_dataflows__["a" /* default */],blackIconPath:'./static/png/categorisations.png',redIconPath:'./static/png/categorisations_red.png'},{label:t('menu.msds.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["K" /* PATH_MSD */],blackIconPath:'./static/png/msds.png',redIconPath:'./static/png/msds_red.png',component:__WEBPACK_IMPORTED_MODULE_19__scenes_meta_manager_msds__["a" /* default */]},{label:t('menu.metadataflows.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["H" /* PATH_METADATAFLOWS */],blackIconPath:'./static/png/metadataflows.png',redIconPath:'./static/png/metadataflows_red.png',component:__WEBPACK_IMPORTED_MODULE_21__scenes_meta_manager_metadataflows__["a" /* default */]}]},{label:t('menu.dataManager.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["s" /* PATH_DATA_MANAGER */],blackIconPath:'./static/png/data-manager.png',redIconPath:'./static/png/data-manager_red.png',children:[{label:t('menu.builder.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["e" /* PATH_BUILDER */],blackIconPath:'./static/png/builder.png',redIconPath:'./static/png/builder_red.png',component:__WEBPACK_IMPORTED_MODULE_1__scenes_data_manager_builder__["a" /* default */]},{label:t('menu.fileMapping.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["A" /* PATH_FILE_MAPPING */],blackIconPath:'./static/png/file-mapping.png',redIconPath:'./static/png/file-mapping_red.png',component:__WEBPACK_IMPORTED_MODULE_2__scenes_data_manager_file_mapping__["a" /* default */]},{label:t('menu.loader.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["D" /* PATH_LOADER */],blackIconPath:'./static/png/loader.png',redIconPath:'./static/png/loader_red.png',component:__WEBPACK_IMPORTED_MODULE_3__scenes_data_manager_loader__["a" /* default */]},{label:t('menu.dataflowBuilder.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["q" /* PATH_DATAFLOW_BUILDER */],blackIconPath:'./static/png/dataflow-builder.png',redIconPath:'./static/png/dataflow-builder_red.png',component:__WEBPACK_IMPORTED_MODULE_5__scenes_data_manager_dataflow_builder__["a" /* default */]},{label:t('menu.cubeList.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["o" /* PATH_CUBE_LIST */],blackIconPath:'./static/png/datasets-list.png',redIconPath:'./static/png/datasets-list_red.png',component:__WEBPACK_IMPORTED_MODULE_4__scenes_data_manager_cube_list__["a" /* default */]},{isDivider:true},{label:t('menu.manageSeries.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["E" /* PATH_MANAGE_SERIES */],blackIconPath:'./static/png/manage-series.png',redIconPath:'./static/png/manage-series_red.png',component:__WEBPACK_IMPORTED_MODULE_31__scenes_data_manager_manage_series__["a" /* default */]},{label:t('menu.upgradeDSD.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["V" /* PATH_UPGRADE_DSD */],blackIconPath:'./static/png/upgrade-dsd.png',redIconPath:'./static/png/upgrade-dsd_red.png',component:__WEBPACK_IMPORTED_MODULE_22__scenes_data_manager_upgrade_dsd__["a" /* default */]},{label:t('menu.synchronizeCodelists.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["T" /* PATH_SYNCRONIZE_CODELISTS */],blackIconPath:'./static/png/synchronize-codelists.png',redIconPath:'./static/png/synchronize-codelists_red.png',component:__WEBPACK_IMPORTED_MODULE_14__scenes_data_manager_sync_codelists__["a" /* default */]},{label:t('menu.attributeFile.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["d" /* PATH_ATTRIBUTE */],blackIconPath:'./static/png/attribute-file.png',redIconPath:'./static/png/attribute-file_red.png',component:__WEBPACK_IMPORTED_MODULE_32__scenes_data_manager_attribute_file__["a" /* default */]},{label:t('menu.updateDataBrowserCache.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["U" /* PATH_UPDATE_DATABROWSER_CACHE */],blackIconPath:'./static/png/update-databrowser-cache.png',redIconPath:'./static/png/update-databrowser-cache_red.png',component:__WEBPACK_IMPORTED_MODULE_33__scenes_data_manager_update_databrowser_cache_UpdateDatabrowserCache__["a" /* default */]},{label:t('menu.ddbReset.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["w" /* PATH_DDB_RESET */],blackIconPath:'./static/png/ddb-reset.png',redIconPath:'./static/png/ddb-reset_red.png',component:__WEBPACK_IMPORTED_MODULE_28__scenes_data_manager_ddb_reset_DdbReset__["a" /* default */]},{label:t('menu.removeTempTables.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["Q" /* PATH_REMOVE_TEMP_TABLES */],blackIconPath:'./static/png/remove-temp-tables.png',redIconPath:'./static/png/remove-temp-tables_red.png',component:__WEBPACK_IMPORTED_MODULE_23__scenes_data_manager_remove_temp_tables_RemoveTempTables__["a" /* default */]}]},{label:t('menu.easyLoading.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["x" /* PATH_EASY_LOADING */],blackIconPath:'./static/png/easy-loading.png',redIconPath:'./static/png/easy-loading_red.png',children:[{label:t('menu.easyLoadingCreate.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["y" /* PATH_EASY_LOADING_CREATE */],blackIconPath:'./static/png/nodes-configuration.png',redIconPath:'./static/png/nodes-configuration_red.png',component:__WEBPACK_IMPORTED_MODULE_34__scenes_easy_loading_easy_loading_create__["a" /* default */]},{label:t('menu.easyLoadingUpdate.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["z" /* PATH_EASY_LOADING_UPDATE */],blackIconPath:'./static/png/nodes-configuration.png',redIconPath:'./static/png/nodes-configuration_red.png',component:__WEBPACK_IMPORTED_MODULE_35__scenes_easy_loading_easy_loading_update__["a" /* default */]}]},{label:t('menu.utilities.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["X" /* PATH_UTILITIES */],blackIconPath:'./static/png/utilities.png',redIconPath:'./static/png/utilities_red.png',children:[{label:t('menu.importStructures.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["C" /* PATH_IMPORT_STRUCTURES */],blackIconPath:'./static/png/import-structures.png',redIconPath:'./static/png/import-structures_red.png',component:__WEBPACK_IMPORTED_MODULE_8__scenes_utilities_import_structures__["a" /* default */]},{label:t('menu.compareDSDs.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["j" /* PATH_COMPARE_DSDS */],blackIconPath:'./static/png/compare-dsds.png',redIconPath:'./static/png/compare-dsds_red.png',component:__WEBPACK_IMPORTED_MODULE_24__scenes_utilities_compare_dsds__["a" /* default */]},{label:t('menu.compareItemSchemes.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["k" /* PATH_COMPARE_ITEM_SCHEMES */],blackIconPath:'./static/png/compare-item-schemes.png',redIconPath:'./static/png/compare-item-schemes_red.png',component:__WEBPACK_IMPORTED_MODULE_25__scenes_utilities_compare_item_schemes__["a" /* default */]},{label:t('menu.mergeItemSchemes.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["G" /* PATH_MERGE_ITEM_SCHEMES */],blackIconPath:'./static/png/merge-item-schemes.png',redIconPath:'./static/png/merge-item-schemes_red.png',component:__WEBPACK_IMPORTED_MODULE_29__scenes_utilities_merge_item_schemes__["a" /* default */]},{label:t('menu.artefactBrowser.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["c" /* PATH_ARTEFACT_BROWSER */],blackIconPath:'./static/png/artefact-browser.png',redIconPath:'./static/png/artefact-browser_red.png'}]},{label:t('menu.referenceMetadata.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["O" /* PATH_REFERENCE_METADATA */],blackIconPath:'./static/png/reference-metadata.png',redIconPath:'./static/png/reference-metadata_red.png',children:[{label:t('menu.metadataSet.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["I" /* PATH_METADATA_SET */],blackIconPath:'./static/png/metadata-set.png',redIconPath:'./static/png/metadata-set_red.png',component:__WEBPACK_IMPORTED_MODULE_27__scenes_reference_metadata_metadata_set__["a" /* default */]},{label:t('menu.DCAT-AP_IT.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["v" /* PATH_DCAT_AP_IT */],blackIconPath:'./static/png/dcat-ap_it.png',redIconPath:'./static/png/dcat-ap_it_red.png',component:__WEBPACK_IMPORTED_MODULE_15__scenes_reference_metadata_dcat__["a" /* default */]}]},{label:t('menu.manageUsers.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["F" /* PATH_MANAGE_USERS */],blackIconPath:'./static/png/manage-users.png',redIconPath:'./static/png/manage-users_red.png',children:[{label:t('menu.userManagement.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["W" /* PATH_USER_MANAGEMENT */],blackIconPath:'./static/png/user-management.png',redIconPath:'./static/png/user-management_red.png',component:__WEBPACK_IMPORTED_MODULE_18__scenes_manage_users_user_menagment__["a" /* default */]},{label:t('menu.setPermissions.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["R" /* PATH_SET_PERMISSIONS */],blackIconPath:'./static/png/set-permissions.png',redIconPath:'./static/png/set-permissions_red.png',component:__WEBPACK_IMPORTED_MODULE_13__scenes_manage_users_set_permissions__["a" /* default */]}]}];};var superUserMenu=function superUserMenu(t){return[{label:t('menu.configuration.label'),blackIconPath:'./static/png/configuration.png',redIconPath:'./static/png/configuration_red.png',path:__WEBPACK_IMPORTED_MODULE_0__paths__["m" /* PATH_CONFIGURATION */],children:[{label:t('menu.applicationConfiguration.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["b" /* PATH_APP_CONFIGURATION */],blackIconPath:'./static/png/application-configuration.png',redIconPath:'./static/png/application-configuration_red.png',component:__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_app_config__["a" /* default */]},{label:t('menu.nodesConfiguration.label'),path:__WEBPACK_IMPORTED_MODULE_0__paths__["L" /* PATH_NODES_CONFIGURATION */],blackIconPath:'./static/png/nodes-configuration.png',redIconPath:'./static/png/nodes-configuration_red.png',component:__WEBPACK_IMPORTED_MODULE_6__scenes_configuration_nodes_config__["a" /* default */]}]}];};

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__GenericAnnotationsForm__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CustomAnnotationsForm__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DefaultTableLayout__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DefaultChartLayout__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Layout__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__layout_annotations_form_DefaultMapLayout__ = __webpack_require__(556);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,username:state.app.user.username,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var TAB_KEY_GENERAL="TAB_KEY_GENERAL";var TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT="TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT";var TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT="TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT";var TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_MAP_LAYOUT="TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_MAP_LAYOUT";var AnnotationsForm=function AnnotationsForm(_ref){var t=_ref.t,username=_ref.username,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,disabled=_ref.disabled,annotations=_ref.annotations,endpoints=_ref.endpoints,endpointId=_ref.endpointId,dsdDimensions=_ref.dsdDimensions,genericOnly=_ref.genericOnly,isGenericOneLinePerField=_ref.isGenericOneLinePerField,isDataflow=_ref.isDataflow,onChange=_ref.onChange,isLayoutAnnotationsFormVisible=_ref.isLayoutAnnotationsFormVisible,dataflow=_ref.dataflow,dsdForLayoutAnnotations=_ref.dsdForLayoutAnnotations,onLayoutAnnotationsFormShow=_ref.onLayoutAnnotationsFormShow,onLayoutAnnotationsFormHide=_ref.onLayoutAnnotationsFormHide,onLayoutAnnotationsFormSubmit=_ref.onLayoutAnnotationsFormSubmit,onLayoutAnnotationsFormReset=_ref.onLayoutAnnotationsFormReset,fetchDsdForLayoutAnnotations=_ref.fetchDsdForLayoutAnnotations,itemsPageForLayoutAnnotations=_ref.itemsPageForLayoutAnnotations,fetchItemsPageForLayoutAnnotations=_ref.fetchItemsPageForLayoutAnnotations,resetItemsPageForLayoutAnnotations=_ref.resetItemsPageForLayoutAnnotations,valuesForLayoutAnnotations=_ref.valuesForLayoutAnnotations,fetchValuesForLayoutAnnotations=_ref.fetchValuesForLayoutAnnotations,resetValuesForLayoutAnnotations=_ref.resetValuesForLayoutAnnotations,isOnlyFileDataflow=_ref.isOnlyFileDataflow,isVirtualDataflow=_ref.isVirtualDataflow;var annotationTabsConfig=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].annotationTabs.tabs;var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;var genericAnnotations=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["v" /* getGenericAnnotations */])(annotations,annotationTabsConfig,annotationsConfig);var tabsMap=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(annotations,annotationTabsConfig);var layoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["O" /* getLayoutAnnotations */])(annotations,annotationsConfig);var callOnChange=function callOnChange(genericAnnotations,customAnnotationsTabsMap,layoutAnnotations){return onChange({annotations:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.cloneDeep(genericAnnotations)),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(customAnnotationsTabsMap))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.cloneDeep(layoutAnnotations)))});};var GenericAnnotationsTab=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__GenericAnnotationsForm__["a" /* default */],{disabled:disabled,annotations:genericAnnotations,onChange:function onChange(_ref2){var newGenericAnnotations=_ref2.annotations;if(Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["r" /* countCustomAnnotations */])(newGenericAnnotations,annotationTabsConfig,true)>0||Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["s" /* countLayoutAnnotations */])(newGenericAnnotations,annotationsConfig)>0){callOnChange(genericAnnotations,tabsMap,layoutAnnotations);__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t('components.annotationsForm.alerts.illegalAnnotationType.title'),content:t('components.annotationsForm.alerts.illegalAnnotationType.content')});}else{callOnChange(newGenericAnnotations,tabsMap,layoutAnnotations);}},isOneLinePerField:isGenericOneLinePerField});var variableTabs=[];if(username&&dsdDimensions!==undefined){if(isDataflow){variableTabs.push(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default.a.TabPane,{key:TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT,tab:t('components.annotationsForm.cards.annotations.tabs.layoutAnnotations.title')},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Layout__["a" /* default */],{dsdDimensions:dsdDimensions,disabled:disabled,isFormVisible:isLayoutAnnotationsFormVisible,dataflow:dataflow,dsdForLayoutAnnotations:dsdForLayoutAnnotations,onFormShow:onLayoutAnnotationsFormShow,onFormHide:onLayoutAnnotationsFormHide,onFormSubmit:onLayoutAnnotationsFormSubmit,onFormReset:onLayoutAnnotationsFormReset,fetchDsdForLayoutAnnotations:fetchDsdForLayoutAnnotations,itemsPage:itemsPageForLayoutAnnotations,fetchItemsPage:fetchItemsPageForLayoutAnnotations,resetItemsPage:resetItemsPageForLayoutAnnotations,isOnlyFileDataflow:isOnlyFileDataflow,isVirtualDataflow:isVirtualDataflow,valuesForLayoutAnnotations:valuesForLayoutAnnotations,fetchValuesForLayoutAnnotations:fetchValuesForLayoutAnnotations,resetValuesForLayoutAnnotations:resetValuesForLayoutAnnotations})));}else{variableTabs.push(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default.a.TabPane,{key:TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT,tab:t('components.annotationsForm.cards.annotations.tabs.layoutAnnotationDefaultTableLayout.title'),disabled:dsdDimensions===null},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DefaultTableLayout__["a" /* default */],{disabled:disabled,dsdDimensions:dsdDimensions,layoutAnnotations:layoutAnnotations,onChange:function onChange(_ref3){var newLayoutAnnotations=_ref3.layoutAnnotations;callOnChange(genericAnnotations,tabsMap,newLayoutAnnotations);},annotationsConfig:annotationsConfig})));variableTabs.push(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default.a.TabPane,{key:TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT,tab:t('components.annotationsForm.cards.annotations.tabs.layoutAnnotationDefaultChartLayout.title'),disabled:dsdDimensions===null},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DefaultChartLayout__["a" /* default */],{disabled:disabled,dsdDimensions:dsdDimensions,layoutAnnotations:layoutAnnotations,onChange:function onChange(_ref4){var newLayoutAnnotations=_ref4.layoutAnnotations;callOnChange(genericAnnotations,tabsMap,newLayoutAnnotations);},annotationsConfig:annotationsConfig})));variableTabs.push(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default.a.TabPane,{key:TAB_KEY_LAYOUT_ANNOTATION_DEFAULT_MAP_LAYOUT,tab:t('components.annotationsForm.cards.annotations.tabs.layoutAnnotationDefaultMapLayout.title'),disabled:dsdDimensions===null},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__layout_annotations_form_DefaultMapLayout__["a" /* default */],{t:t,disabled:disabled,dsdDimensions:dsdDimensions,annotationsConfig:annotationsConfig,annotations:layoutAnnotations,onChange:function onChange(_ref5){var newLayoutAnnotations=_ref5.layoutAnnotations;callOnChange(genericAnnotations,tabsMap,newLayoutAnnotations);}})));}}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:'inner',title:t('components.annotationsForm.cards.annotations.title'),style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]}},genericOnly?GenericAnnotationsTab:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default.a,null,disabled&&(!genericAnnotations||genericAnnotations.length===0)?null:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default.a.TabPane,{key:TAB_KEY_GENERAL,tab:t('components.annotationsForm.cards.annotations.tabs.general.title')},GenericAnnotationsTab),username&&annotationTabsConfig.filter(function(_ref6){var isVisible=_ref6.isVisible;return isVisible;}).map(function(tab){var isTabEmpty=tabsMap[tab.name]===null||__WEBPACK_IMPORTED_MODULE_11_lodash___default()(tabsMap[tab.name]).pickBy(function(val){return val!==null;}).keys().value().length<1;return disabled&&isTabEmpty?null:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default.a.TabPane,{key:tab.name,tab:Object(__WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__["a" /* getLocalizedStr */])(tab.label,language,dataLanguages)||tab.name},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__CustomAnnotationsForm__["a" /* default */],{disabled:disabled,config:annotationTabsConfig.find(function(_ref7){var name=_ref7.name;return name===tab.name;}).annotations,typesMap:tabsMap[tab.name].annotations,onChange:function onChange(_ref8){var typesMap=_ref8.typesMap;var newCustomAnnotationTabsMap=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.cloneDeep(tabsMap);newCustomAnnotationTabsMap[tab.name].annotations=typesMap;callOnChange(genericAnnotations,newCustomAnnotationTabsMap,layoutAnnotations);}}));}),variableTabs)));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps))(AnnotationsForm));

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_MAX_LEN; });
var ID_MAX_LEN=50;

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(630);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(173);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(681);

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(388);
var enumBugKeys = __webpack_require__(282);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(150),
    now = __webpack_require__(754),
    toNumber = __webpack_require__(755);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(180),
    isObjectLike = __webpack_require__(181);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(101);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _row["default"];
  }
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _col["default"];
  }
});

var _row = _interopRequireDefault(__webpack_require__(403));

var _col = _interopRequireDefault(__webpack_require__(407));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.connect = exports.Provider = undefined;

var _Provider2 = __webpack_require__(875);

var _Provider3 = _interopRequireDefault(_Provider2);

var _connect2 = __webpack_require__(876);

var _connect3 = _interopRequireDefault(_connect2);

var _create2 = __webpack_require__(877);

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(135);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(930),
    listCacheDelete = __webpack_require__(931),
    listCacheGet = __webpack_require__(932),
    listCacheHas = __webpack_require__(933),
    listCacheSet = __webpack_require__(934);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(302);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(936);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_TYPE_NORMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOW_TYPE_VIRTUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_TYPE_ONLY_FILE; });
var DATAFLOW_TYPE_NORMAL='DATAFLOW_TYPE_NORMAL';var DATAFLOW_TYPE_VIRTUAL='DATAFLOW_TYPE_VIRTUAL';var DATAFLOW_TYPE_ONLY_FILE='DATAFLOW_TYPE_ONLY_FILE';

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DERIVED_ITEM_SCHEME_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DERIVED_ITEM_SCHEME_ITEMS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DERIVED_ITEM_SCHEME_ITEMS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DERIVED_ITEM_SCHEME_CHECKBOX_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DERIVED_ITEM_SCHEME_CREATE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DERIVED_ITEM_SCHEME_CREATE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DERIVED_ITEM_SCHEME_CREATE_HIDE; });
/* unused harmony export DERIVED_ITEM_SCHEME_VIEW_MODE_CHANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DERIVED_ITEM_SCHEME_STATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return selectDerivedItemSchemeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return addDerivedItemSchemeItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return removeDerivedItemSchemeItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return changeDerivedItemSchemeCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return showDerivedItemSchemeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hideDerivedItemSchemeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return changeDerivedItemSchemeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return resetDerivedItemSchemeState; });
/* unused harmony export changeDerivedItemSchemeViewMode */
var DERIVED_ITEM_SCHEME_ITEM_SELECT='DERIVED_ITEM_SCHEME_ITEM_SELECT';var DERIVED_ITEM_SCHEME_ITEMS_ADD='DERIVED_ITEM_SCHEME_ITEMS_ADD';var DERIVED_ITEM_SCHEME_ITEMS_REMOVE='DERIVED_ITEM_SCHEME_ITEMS_REMOVE';var DERIVED_ITEM_SCHEME_CHECKBOX_CHANGE='DERIVED_ITEM_SCHEME_CHECKBOX_CHANGE';var DERIVED_ITEM_SCHEME_CREATE_SHOW='DERIVED_ITEM_SCHEME_CREATE_SHOW';var DERIVED_ITEM_SCHEME_CREATE_CHANGE='DERIVED_ITEM_SCHEME_CREATE_CHANGE';var DERIVED_ITEM_SCHEME_CREATE_HIDE='DERIVED_ITEM_SCHEME_CREATE_HIDE';var DERIVED_ITEM_SCHEME_VIEW_MODE_CHANGE='DERIVED_ITEM_SCHEME_VIEW_MODE_CHANGE';var DERIVED_ITEM_SCHEME_STATE_RESET='DERIVED_ITEM_SCHEME_STATE_RESET';var selectDerivedItemSchemeItem=function selectDerivedItemSchemeItem(selectedArr,isSource){return{type:DERIVED_ITEM_SCHEME_ITEM_SELECT,selectedArr:selectedArr,isSource:isSource};};var addDerivedItemSchemeItems=function addDerivedItemSchemeItems(itemTree,childrenKey,forcePreserveHierarchy){return{type:DERIVED_ITEM_SCHEME_ITEMS_ADD,itemTree:itemTree,childrenKey:childrenKey,forcePreserveHierarchy:forcePreserveHierarchy};};var removeDerivedItemSchemeItems=function removeDerivedItemSchemeItems(items,childrenKey){return{type:DERIVED_ITEM_SCHEME_ITEMS_REMOVE,items:items,childrenKey:childrenKey};};var changeDerivedItemSchemeCheckbox=function changeDerivedItemSchemeCheckbox(checkbox){return{type:DERIVED_ITEM_SCHEME_CHECKBOX_CHANGE,checkbox:checkbox};};var showDerivedItemSchemeCreate=function showDerivedItemSchemeCreate(){return{type:DERIVED_ITEM_SCHEME_CREATE_SHOW};};var hideDerivedItemSchemeCreate=function hideDerivedItemSchemeCreate(){return{type:DERIVED_ITEM_SCHEME_CREATE_HIDE};};var changeDerivedItemSchemeCreate=function changeDerivedItemSchemeCreate(fields){return{type:DERIVED_ITEM_SCHEME_CREATE_CHANGE,fields:fields};};var resetDerivedItemSchemeState=function resetDerivedItemSchemeState(){return{type:DERIVED_ITEM_SCHEME_STATE_RESET};};var changeDerivedItemSchemeViewMode=function changeDerivedItemSchemeViewMode(mode){return{type:DERIVED_ITEM_SCHEME_VIEW_MODE_CHANGE,mode:mode};};

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILDER_CUBE_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUILDER_CUBE_FORM_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUILDER_CUBE_FORM_DSD_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUILDER_CUBE_FORM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return readBuilderCubeFormDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeBuilderCubeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return readBuilderCubeFormCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return submitBuilderCubeForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var BUILDER_CUBE_FORM_CHANGE='BUILDER_CUBE_FORM_CHANGE';var BUILDER_CUBE_FORM_CUBE_READ='BUILDER_CUBE_FORM_CUBE_READ';var BUILDER_CUBE_FORM_DSD_READ='BUILDER_CUBE_FORM_DSD_READ';var BUILDER_CUBE_FORM_SUBMIT='BUILDER_CUBE_FORM_SUBMIT';var readBuilderCubeFormDsd=function readBuilderCubeFormDsd(dsdCode){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(BUILDER_CUBE_FORM_DSD_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(dsdCode)));};var changeBuilderCubeForm=function changeBuilderCubeForm(fields){return{type:BUILDER_CUBE_FORM_CHANGE,fields:fields};};var readBuilderCubeFormCube=function readBuilderCubeFormCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(BUILDER_CUBE_FORM_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var submitBuilderCubeForm=function submitBuilderCubeForm(cube){var getMapAttribute=function getMapAttribute(IsTid){return function(attr){return{IsTid:IsTid,Code:IsTid?'TID':attr.Code,IsMandatory:attr.disabled,AttachmentLevel:IsTid?'Dataset':attr.attachmentLevel,CodelistCode:!IsTid&&attr.localRepresentation&&attr.localRepresentation.enumeration&&Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(attr.localRepresentation.enumeration))||null,refDim:attr.attributeRelationship&&attr.attributeRelationship.dimensions||attr.otherGroupDimensions||[]};};};var getMapDimension=function getMapDimension(IsTimeSeriesDim){return function(dim){return{IsTimeSeriesDim:IsTimeSeriesDim,Code:dim.Code,CodelistCode:dim.localRepresentation&&dim.localRepresentation.enumeration&&Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(dim.localRepresentation.enumeration))||null};};};var cubeToSend={Code:cube.Code,labels:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(cube.labels,function(str){return str.length>0;}),IDCat:cube.IDCat,DSDCode:cube.DSDCode,Attributes:[].concat(_toConsumableArray(cube.cubeComponents.attributes.filter(function(attr){return attr.checked;}).map(getMapAttribute(false))),_toConsumableArray(cube.cubeComponents.tidAttributes.filter(function(attr){return attr.checked;}).map(getMapAttribute(true)))),Dimensions:[].concat(_toConsumableArray(cube.cubeComponents.dimensions.filter(function(dim){return dim.checked;}).map(getMapDimension(false))),_toConsumableArray(cube.cubeComponents.timeDimensions.filter(function(dim){return dim.checked;}).map(getMapDimension(true)))),Measures:cube.cubeComponents.measures.map(function(meas){return{Code:meas.Code,IsAlphanumeric:cube.observedValueCanBeAlphanumeric};})};return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(BUILDER_CUBE_FORM_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(),cubeToSend,function(t){return{start:t('scenes.dataManager.builder.cubeForm.messages.submit.start'),success:t('scenes.dataManager.builder.cubeForm.messages.submit.success')};});};

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUILDER_CATEGORY_FORM_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUILDER_CATEGORY_FORM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUILDER_CATEGORY_FORM_CREATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUILDER_CATEGORY_FORM_EDIT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILDER_CATEGORY_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BUILDER_CATEGORY_FORM_PARENT_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BUILDER_CATEGORY_FORM_PARENT_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createBuilderCategoryForm; });
/* unused harmony export hideBuilderCategoryForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return changeBuilderCategoryForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return submitBuilderCategoryFormCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return submitBuilderCategoryFormEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return showBuilderCategoryFormParentModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hideBuilderCategoryFormParentModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
var BUILDER_CATEGORY_FORM_CREATE='BUILDER_CATEGORY_FORM_CREATE';var BUILDER_CATEGORY_FORM_HIDE='BUILDER_CATEGORY_FORM_HIDE';var BUILDER_CATEGORY_FORM_CREATE_SUBMIT='BUILDER_CATEGORY_FORM_CREATE_SUBMIT';var BUILDER_CATEGORY_FORM_EDIT_SUBMIT='BUILDER_CATEGORY_FORM_EDIT_SUBMIT';var BUILDER_CATEGORY_FORM_CHANGE='BUILDER_CATEGORY_FORM_CHANGE';var BUILDER_CATEGORY_FORM_PARENT_MODAL_SHOW='BUILDER_CATEGORY_FORM_PARENT_MODAL_SHOW';var BUILDER_CATEGORY_FORM_PARENT_MODAL_HIDE='BUILDER_CATEGORY_FORM_PARENT_MODAL_HIDE';var createBuilderCategoryForm=function createBuilderCategoryForm(parCode){return{type:BUILDER_CATEGORY_FORM_CREATE,parCode:parCode};};var hideBuilderCategoryForm=function hideBuilderCategoryForm(){return{type:BUILDER_CATEGORY_FORM_HIDE};};var changeBuilderCategoryForm=function changeBuilderCategoryForm(fields){return{type:BUILDER_CATEGORY_FORM_CHANGE,fields:fields};};var submitBuilderCategoryFormCreate=function submitBuilderCategoryFormCreate(cat){return Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["m" /* postRequest */])(BUILDER_CATEGORY_FORM_CREATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["M" /* getCreateDCSCategoryUrl */])(),{catCode:cat.CatCode,parCode:cat.ParCode,ord:cat.Ord,labels:cat.labels},function(t){return{success:t('scenes.dataManager.builder.categoryForm.messages.create.success')};});};var submitBuilderCategoryFormEdit=function submitBuilderCategoryFormEdit(cat){return Object(__WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["n" /* putRequest */])(BUILDER_CATEGORY_FORM_EDIT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_0__constants_urls__["_38" /* getEditDCSCategoryUrl */])(),[{idCat:cat.IDCat,catCode:cat.CatCode,parCode:cat.ParCode,ord:cat.Ord,labels:cat.labels}],function(t){return{success:t('scenes.dataManager.builder.categoryForm.messages.edit.success')};});};var showBuilderCategoryFormParentModal=function showBuilderCategoryFormParentModal(){return{type:BUILDER_CATEGORY_FORM_PARENT_MODAL_SHOW};};var hideBuilderCategoryFormParentModal=function hideBuilderCategoryFormParentModal(){return{type:BUILDER_CATEGORY_FORM_PARENT_MODAL_HIDE};};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_MAPPING_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_MAPPING_WIZARD_CSV_ROW_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_MAPPING_WIZARD_CSV_ROW_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFileMappingWizardCsvRowListCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showFileMappingWizardCsvRowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hideFileMappingWizardCsvRowList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var FILE_MAPPING_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET='FILE_MAPPING_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET';var FILE_MAPPING_WIZARD_CSV_ROW_LIST_SHOW='FILE_MAPPING_WIZARD_CSV_ROW_LIST_SHOW';var FILE_MAPPING_WIZARD_CSV_ROW_LIST_HIDE='FILE_MAPPING_WIZARD_CSV_ROW_LIST_HIDE';var getFileMappingWizardCsvRowListCsvRows=function getFileMappingWizardCsvRowListCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(FILE_MAPPING_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,filePath,null,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var showFileMappingWizardCsvRowList=function showFileMappingWizardCsvRowList(){return{type:FILE_MAPPING_WIZARD_CSV_ROW_LIST_SHOW};};var hideFileMappingWizardCsvRowList=function hideFileMappingWizardCsvRowList(){return{type:FILE_MAPPING_WIZARD_CSV_ROW_LIST_HIDE};};

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_FORMAT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setLoaderFormat; });
var LOADER_FORMAT_SET='LOADER_FORMAT_SET';var setLoaderFormat=function setLoaderFormat(format){return{type:LOADER_FORMAT_SET,format:format};};

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUBE_LIST_CUBES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CUBE_LIST_CURRENT_DATA_VIEW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CUBE_LIST_CURRENT_DATA_VIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CUBE_LIST_CURRENT_DATA_VIEW_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CUBE_LIST_CUBE_DOWNLOAD_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CUBE_LIST_CUBE_DOWNLOAD_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CUBE_LIST_CUBE_DOWNLOAD_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_CODES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CUBE_LIST_CUBE_DOWNLOAD_CSV_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CUBE_LIST_CUBE_EMBARGO_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CUBE_LIST_CUBE_OWNERSHIP_USERS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CUBE_LIST_CUBE_OWNERSHIP_OWNERS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CUBE_LIST_CUBE_OWNERSHIP_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CUBE_LIST_CUBE_OWNERSHIP_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CUBE_LIST_CUBE_OWNERSHIP_OWNERS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CUBE_LIST_CUBE_OWNERSHIP_OWNERS_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CUBE_LIST_CUBE_EMPTY_CUBE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUBE_LIST_CUBE_DELETE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return readCubeListCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return showCubeListCurrentDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return hideCubeListCurrentDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return readCubeListCurrentDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return showCubeListCubeDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return hideCubeListCubeDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return readCubeListCubeDownloadCube; });
/* unused harmony export changeCubeListCubeDownloadWhereConditionsForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return addCubeListCubeDownloadWhereConditionsFormBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return deleteCubeListCubeDownloadWhereConditionsFormBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return addCubeListCubeDownloadWhereConditionsFormCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return deleteCubeListCubeDownloadWhereConditionsFormCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return readCubeListCubeDownloadWhereConditionsFormColumnValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return resetCubeListCubeDownloadWhereConditionsFormColumnValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return readCubeListCubeDownloadWhereConditionsFormColumnCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return showCubeListCubeDownloadPreviewRowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return hideCubeListCubeDownloadPreviewRowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return readCubeListCubeDownloadPreviewRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return readCubeListCubeDownloadCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return checkCubeListCubeDownloadCubeColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return changeCubeListCubeDownloadCubeColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return removeCubeListCubeEmbargo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return showCubeListCubeOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return hideCubeListCubeOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return readCubeListCubeOwnershipUsersRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return readCubeListCubeOwnershipOwnersRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return changeCubeListCubeOwnershipOwners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return submitCubeListCubeOwnership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return submitCubeListEmptyCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return submitCubeListDeleteCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return showCubeListCubeDownloadFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return hideCubeListCubeDownloadFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return submitCubeListCubeDownloadFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return changeCubeListCubeDownloadFilterModalTreeFilterColumnMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return changeCubeListCubeDownloadFilterModalFilterMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return resetCubeListCubeDownloadFilterModalFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return changeCubeListCubeDownloadFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return changeCubeListCubeDownloadFilterModalTreeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return readCubeListCubeDownloadFilterModalTreeFilterColumnCodelistCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return readCubeListCubeDownloadFilterModalTreeFilterColumnCodelistTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return readCubeListCubeDownloadFilterModalTreeFilterColumnFilteredValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return changeCubeListCubeDownloadFilterModalTreeFilterColumnValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__ = __webpack_require__(65);
var CUBE_LIST_CUBES_READ='CUBE_LIST_CUBES_READ';var CUBE_LIST_CURRENT_DATA_VIEW_READ='CUBE_LIST_CURRENT_DATA_VIEW_READ';var CUBE_LIST_CURRENT_DATA_VIEW_SHOW='CUBE_LIST_CURRENT_DATA_VIEW_SHOW';var CUBE_LIST_CURRENT_DATA_VIEW_HIDE='CUBE_LIST_CURRENT_DATA_VIEW_HIDE';var CUBE_LIST_CUBE_DOWNLOAD_SHOW='CUBE_LIST_CUBE_DOWNLOAD_SHOW';var CUBE_LIST_CUBE_DOWNLOAD_HIDE='CUBE_LIST_CUBE_DOWNLOAD_HIDE';var CUBE_LIST_CUBE_DOWNLOAD_CUBE_READ='CUBE_LIST_CUBE_DOWNLOAD_CUBE_READ';var CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CHANGE='CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CHANGE';var CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_ADD='CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_ADD';var CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_DELETE='CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_DELETE';var CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_ADD='CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_ADD';var CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_DELETE='CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_DELETE';var CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_READ='CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_READ';var CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_RESET='CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_RESET';var CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_CODES_READ='CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_CODES_READ';var CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_SHOW='CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_SHOW';var CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_HIDE='CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_HIDE';var CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_READ='CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_READ';var CUBE_LIST_CUBE_DOWNLOAD_CSV_READ='CUBE_LIST_CUBE_DOWNLOAD_CSV_READ';var CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHECK='CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHECK';var CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHANGE='CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHANGE';var CUBE_LIST_CUBE_EMBARGO_REMOVE='CUBE_LIST_CUBE_EMBARGO_REMOVE';var CUBE_LIST_CUBE_OWNERSHIP_USERS_READ='CUBE_LIST_CUBE_OWNERSHIP_USERS_READ';var CUBE_LIST_CUBE_OWNERSHIP_OWNERS_READ='CUBE_LIST_CUBE_OWNERSHIP_OWNERS_READ';var CUBE_LIST_CUBE_OWNERSHIP_SHOW='CUBE_LIST_CUBE_OWNERSHIP_SHOW';var CUBE_LIST_CUBE_OWNERSHIP_HIDE='CUBE_LIST_CUBE_OWNERSHIP_HIDE';var CUBE_LIST_CUBE_OWNERSHIP_OWNERS_CHANGE='CUBE_LIST_CUBE_OWNERSHIP_OWNERS_CHANGE';var CUBE_LIST_CUBE_OWNERSHIP_OWNERS_SUBMIT='CUBE_LIST_CUBE_OWNERSHIP_OWNERS_SUBMIT';var CUBE_LIST_CUBE_EMPTY_CUBE_SUBMIT='CUBE_LIST_CUBE_EMPTY_CUBE_SUBMIT';var CUBE_LIST_CUBE_DELETE_SUBMIT='CUBE_LIST_CUBE_DELETE_SUBMIT';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SHOW='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SHOW';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SUBMIT='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SUBMIT';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_RESET='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_RESET';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_HIDE='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_HIDE';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ';var CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ='CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ';var readCubeListCubes=function readCubeListCubes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CUBE_LIST_CUBES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])());};var showCubeListCurrentDataView=function showCubeListCurrentDataView(cubeId){return{type:CUBE_LIST_CURRENT_DATA_VIEW_SHOW,cubeId:cubeId};};var hideCubeListCurrentDataView=function hideCubeListCurrentDataView(){return{type:CUBE_LIST_CURRENT_DATA_VIEW_HIDE};};var readCubeListCurrentDataView=function readCubeListCurrentDataView(cubeId,pageNum,pageSize,filterTable,sortCols,sortByDesc){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CURRENT_DATA_VIEW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_95" /* getTablePreviewUrl */])('Dataset_'+cubeId+'_ViewCurrentData'),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var showCubeListCubeDownload=function showCubeListCubeDownload(cubeId){return{type:CUBE_LIST_CUBE_DOWNLOAD_SHOW,cubeId:cubeId};};var hideCubeListCubeDownload=function hideCubeListCubeDownload(){return{type:CUBE_LIST_CUBE_DOWNLOAD_HIDE};};var readCubeListCubeDownloadCube=function readCubeListCubeDownloadCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CUBE_LIST_CUBE_DOWNLOAD_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var changeCubeListCubeDownloadWhereConditionsForm=function changeCubeListCubeDownloadWhereConditionsForm(fields){return{type:CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CHANGE,fields:fields};};var addCubeListCubeDownloadWhereConditionsFormBlock=function addCubeListCubeDownloadWhereConditionsFormBlock(){return{type:CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_ADD};};var deleteCubeListCubeDownloadWhereConditionsFormBlock=function deleteCubeListCubeDownloadWhereConditionsFormBlock(blockIndex){return{type:CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_DELETE,blockIndex:blockIndex};};var addCubeListCubeDownloadWhereConditionsFormCondition=function addCubeListCubeDownloadWhereConditionsFormCondition(blockIndex){return{type:CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_ADD,blockIndex:blockIndex};};var deleteCubeListCubeDownloadWhereConditionsFormCondition=function deleteCubeListCubeDownloadWhereConditionsFormCondition(blockIndex,conditionIndex){return{type:CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_DELETE,blockIndex:blockIndex,conditionIndex:conditionIndex};};var readCubeListCubeDownloadWhereConditionsFormColumnValue=function readCubeListCubeDownloadWhereConditionsFormColumnValue(cubeId,columnName,viewerObj){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(columnName,viewerObj.pageNum,viewerObj.pageSize),{idCube:cubeId,dataflowColumns:[columnName],idDataflow:0,filter:Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(undefined,viewerObj.filterObj||Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["e" /* getFilterStrFromViewerObj */])([columnName],viewerObj.searchText,[],""))).Filter}),{columnName:columnName});};var resetCubeListCubeDownloadWhereConditionsFormColumnValue=function resetCubeListCubeDownloadWhereConditionsFormColumnValue(columnName){return{type:CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_RESET,columnName:columnName};};var readCubeListCubeDownloadWhereConditionsFormColumnCodes=function readCubeListCubeDownloadWhereConditionsFormColumnCodes(columnName,codelistCode){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_CODES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).id,agencyId:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).agencyID,version:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).version,pageNum:1,pageSize:-1,rebuildDb:false,lang:"en"}),{columnName:columnName});};var showCubeListCubeDownloadPreviewRowsModal=function showCubeListCubeDownloadPreviewRowsModal(){return{type:CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_SHOW};};var hideCubeListCubeDownloadPreviewRowsModal=function hideCubeListCubeDownloadPreviewRowsModal(){return{type:CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_HIDE};};var readCubeListCubeDownloadPreviewRows=function readCubeListCubeDownloadPreviewRows(cubeId,cubeColumns,filter,pageNum,pageSize,sortCols,sortByDesc){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_6" /* getDataflowPreviewUrl */])(true),Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(cubeColumns,Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter)),pageNum,pageSize,sortCols,sortByDesc,cubeId));};var readCubeListCubeDownloadCsv=function readCubeListCubeDownloadCsv(cubeId,cubeColumns,filter,separator,delimiter,compression){var currDate=__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD_HH-mm-ss');var fileSave={name:'cube_'+cubeId+'_'+currDate+'.'+(compression?'zip':'csv'),type:"text/plain;charset=utf-8"};return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_DOWNLOAD_CSV_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_3" /* getDataflowCsvUrl */])(separator,delimiter,!!compression),Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(cubeColumns,Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter)),undefined,undefined,undefined,undefined,cubeId),undefined,undefined,true),{fileSave:fileSave});};var checkCubeListCubeDownloadCubeColumns=function checkCubeListCubeDownloadCubeColumns(cols){return{type:CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHECK,cols:cols};};var changeCubeListCubeDownloadCubeColumns=function changeCubeListCubeDownloadCubeColumns(cols){return{type:CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHANGE,cols:cols};};var removeCubeListCubeEmbargo=function removeCubeListCubeEmbargo(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_EMBARGO_REMOVE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_26" /* getDisembargoCubeUrl */])(cubeId),function(t){return{success:t('scenes.dataManager.cubeList.messages.removeEmbargo.success')};});};var showCubeListCubeOwnership=function showCubeListCubeOwnership(cubeId){return{type:CUBE_LIST_CUBE_OWNERSHIP_SHOW,cubeId:cubeId};};var hideCubeListCubeOwnership=function hideCubeListCubeOwnership(){return{type:CUBE_LIST_CUBE_OWNERSHIP_HIDE};};var readCubeListCubeOwnershipUsersRead=function readCubeListCubeOwnershipUsersRead(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CUBE_LIST_CUBE_OWNERSHIP_USERS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_110" /* getUsers */])());};var readCubeListCubeOwnershipOwnersRead=function readCubeListCubeOwnershipOwnersRead(code){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CUBE_LIST_CUBE_OWNERSHIP_OWNERS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["W" /* getCubeOwnersUrl */])(code));};var changeCubeListCubeOwnershipOwners=function changeCubeListCubeOwnershipOwners(owners){return{type:CUBE_LIST_CUBE_OWNERSHIP_OWNERS_CHANGE,owners:owners};};var submitCubeListCubeOwnership=function submitCubeListCubeOwnership(code,owners){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_OWNERSHIP_OWNERS_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_87" /* getSetOwnersUrl */])(),{type:"Cube",id:code,owners:owners.map(function(username){return{username:username};})},function(t){return{success:t('scenes.dataManager.cubeList.messages.ownership.success')};});};var submitCubeListEmptyCube=function submitCubeListEmptyCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_EMPTY_CUBE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_39" /* getEmptyCubeUrl */])(cubeId),null,function(t){return{success:t('scenes.dataManager.cubeList.messages.emptyCube.success')};});};var submitCubeListDeleteCube=function submitCubeListDeleteCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(CUBE_LIST_CUBE_DELETE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId),function(t){return{success:t('scenes.dataManager.cubeList.messages.delete.success')};});};var showCubeListCubeDownloadFilterModal=function showCubeListCubeDownloadFilterModal(){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SHOW};};var hideCubeListCubeDownloadFilterModal=function hideCubeListCubeDownloadFilterModal(){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_HIDE};};var submitCubeListCubeDownloadFilterModal=function submitCubeListCubeDownloadFilterModal(filter){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SUBMIT,filter:filter};};var changeCubeListCubeDownloadFilterModalTreeFilterColumnMode=function changeCubeListCubeDownloadFilterModalTreeFilterColumnMode(colName,mode){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE,colName:colName,mode:mode};};var changeCubeListCubeDownloadFilterModalFilterMode=function changeCubeListCubeDownloadFilterModalFilterMode(filterMode){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE,filterMode:filterMode};};var resetCubeListCubeDownloadFilterModalFilter=function resetCubeListCubeDownloadFilterModalFilter(){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_RESET};};var changeCubeListCubeDownloadFilter=function changeCubeListCubeDownloadFilter(fields){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE,fields:fields};};var changeCubeListCubeDownloadFilterModalTreeFilter=function changeCubeListCubeDownloadFilterModalTreeFilter(treeFilter){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE,treeFilter:treeFilter};};var readCubeListCubeDownloadFilterModalTreeFilterColumnCodelistCount=function readCubeListCubeDownloadFilterModalTreeFilterColumnCodelistCount(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var readCubeListCubeDownloadFilterModalTreeFilterColumnCodelistTree=function readCubeListCubeDownloadFilterModalTreeFilterColumnCodelistTree(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:-1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var readCubeListCubeDownloadFilterModalTreeFilterColumnFilteredValues=function readCubeListCubeDownloadFilterModalTreeFilterColumnFilteredValues(cubeId,colNames,filter){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(colNames[colNames.length-1],1,-1),{idCube:cubeId,dataflowColumns:colNames,filter:Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["f" /* getServerQueryObj */])(undefined,Object(__WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_5__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter))).Filter}),{colName:colNames[colNames.length-1]});};var changeCubeListCubeDownloadFilterModalTreeFilterColumnValues=function changeCubeListCubeDownloadFilterModalTreeFilterColumnValues(colName,values){return{type:CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE,colName:colName,values:values};};

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_languages__ = __webpack_require__(91);
var mapStateToProps=function mapStateToProps(state){return{options:state.config.dataManagement.dataLanguages};};var DataLanguageSelector=function DataLanguageSelector(_ref){var t=_ref.t,options=_ref.options,value=_ref.value,onSelect=_ref.onSelect,size=_ref.size,showLangCode=_ref.showLangCode,style=_ref.style;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{value:value,onSelect:onSelect,size:size,style:style},options.map(function(_ref2){var code=_ref2.code;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:code,value:code},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("i",{className:"flag-icon "+Object(__WEBPACK_IMPORTED_MODULE_7__utils_languages__["b" /* getLanguageFlagIconCss */])(code,options),style:{marginRight:__WEBPACK_IMPORTED_MODULE_6__styles_constants__["MARGIN_SM"]}}),showLangCode?code.toUpperCase():Object(__WEBPACK_IMPORTED_MODULE_7__utils_languages__["c" /* getLanguageLabel */])(t,code));}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps),Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])())(DataLanguageSelector));

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__middlewares_spinner_actions__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TimePeriod__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Tree__ = __webpack_require__(1116);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{endpointId:state.app.endpointId,nodes:state.config.nodes,appLanguage:state.app.language,maxTreeNodes:state.config.userInterface.maxTreeNodes,dataLanguages:state.config.dataManagement.dataLanguages};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showSpinner:function showSpinner(uuid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_spinner_actions__["d" /* addSpinnerAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* showQueryFormSpinner */])(),uuid));},hideSpinner:function hideSpinner(uuid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_spinner_actions__["e" /* completeSpinnerAction */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* showQueryFormSpinner */])(),uuid));}};};var TreeFilter=function(_React$Component){_inherits(TreeFilter,_React$Component);function TreeFilter(props){_classCallCheck(this,TreeFilter);var _this=_possibleConstructorReturn(this,(TreeFilter.__proto__||Object.getPrototypeOf(TreeFilter)).call(this,props));_this.state={currentTab:"0",tempTPFrom:null,tempTPTo:null};return _this;}_createClass(TreeFilter,[{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,nodes=_props.nodes,appLanguage=_props.appLanguage,dataLanguages=_props.dataLanguages,endpointId=_props.endpointId,maxTreeNodes=_props.maxTreeNodes,fetchColumnCodelistCount=_props.fetchColumnCodelistCount,fetchColumnCodelistTree=_props.fetchColumnCodelistTree,fetchColumnFilteredValues=_props.fetchColumnFilteredValues,columns=_props.columns,treeFilter=_props.treeFilter,onColumnModeChange=_props.onColumnModeChange,onColumnValuesChange=_props.onColumnValuesChange,showSpinner=_props.showSpinner,hideSpinner=_props.hideSpinner,disabled=_props.disabled,hideInclusionRadio=_props.hideInclusionRadio,isCC=_props.isCC,isSdmx=_props.isSdmx,minDate=_props.minDate,maxDate=_props.maxDate,hideIds=_props.hideIds,showTimePeriodAsTree=_props.showTimePeriodAsTree;var itemsOrderAnnotationType=__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.find(nodes,function(node){return node.general.id===endpointId;}).annotations.codelistsOrder;var callOnColumnValuesChangeWithSpinner=function callOnColumnValuesChangeWithSpinner(colName,values){showSpinner();window.setTimeout(function(){hideSpinner();onColumnValuesChange(colName,values);},0);};var callOnColumnModeChangeWithSpinner=function callOnColumnModeChangeWithSpinner(colName,mode){showSpinner();window.setTimeout(function(){hideSpinner();onColumnModeChange(colName,mode);},0);};var freqCol=columns.find(function(_ref){var name=_ref.name;return name==="FREQ"||name==="ID_FREQ";});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){return columns!==null&&(isCC||columns.filter(function(_ref2){var CodelistCode=_ref2.CodelistCode;return CodelistCode;}).length>0)?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a,{onChange:function onChange(key){return _this2.setState({currentTab:key});}},(columns||[]).filter(function(_ref3){var CodelistCode=_ref3.CodelistCode;return CodelistCode!==undefined;}).filter(function(_ref4){var name=_ref4.name;return!isCC||Object(__WEBPACK_IMPORTED_MODULE_7__utils_normalizers__["a" /* getNormalizedColumnName */])(name)!=="TID";}).map(function(column,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane,{tab:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span",{title:column.name},Object(__WEBPACK_IMPORTED_MODULE_7__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)),key:index},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchColumnCodelistCount,cbParam:{codelistTriplet:column.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(column.CodelistCode):null,language:dataLanguage||appLanguage,dimensionId:column.id},disabled:column.CodelistCode===null||column.codelistCount!==null},column.codelistCount!==null&&column.codelistCount>maxTreeNodes?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a,{type:"warning",showIcon:true,message:t('components.treeFilter.warnings.codelistTooBig.title')}):column.hasCodesError?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a,{type:"error",showIcon:true,message:t('components.treeFilter.errors.codesError.title')}):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchColumnCodelistTree,cbParam:{codelistTriplet:column.CodelistCode===null||Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(column.CodelistCode),language:dataLanguage||appLanguage,itemsOrderAnnotationType:itemsOrderAnnotationType,dimensionId:column.id},disabled:column.CodelistCode===null||column.codelistCount===null||column.codelistTree!==null},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchColumnFilteredValues,cbParam:{colNames:columns.map(function(_ref5){var name=_ref5.name;return name;}).splice(0,index+1),filterStr:Object(__WEBPACK_IMPORTED_MODULE_15__utils__["h" /* getTreeFilterStrFromObj */])(treeFilter,columns.slice(0,index).map(function(_ref6){var name=_ref6.name;return name;}))},disabled:fetchColumnFilteredValues===null||column.CodelistCode!==null&&(column.codelistTree===null||column.filteredCodelistTree!==null)||!isCC&&column.CodelistCode===null&&column.filteredValues===null||_this2.state.currentTab!==String(index)},showTimePeriodAsTree||column.name!=="ID_TIME_PERIOD"&&column.name!=="TIME_PERIOD"?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Tree__["a" /* default */],{column:column,dataLanguage:dataLanguage,appLanguage:appLanguage,dataLanguages:dataLanguages,treeFilter:treeFilter,isCC:isCC,columns:columns,callOnColumnValuesChangeWithSpinner:callOnColumnValuesChangeWithSpinner,index:index,disabled:disabled,hideInclusionRadio:hideInclusionRadio,setTPFromTo:function setTPFromTo(obj){return _this2.setState(obj);},callOnColumnModeChangeWithSpinner:callOnColumnModeChangeWithSpinner,hideIds:hideIds}):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchColumnCodelistCount,cbParam:{codelistTriplet:freqCol?freqCol.CodelistCode===null||Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(freqCol.CodelistCode):null,language:dataLanguage||appLanguage,dimensionId:column.id},disabled:!freqCol||freqCol.CodelistCode===null||freqCol.codelistCount!==null},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchColumnCodelistTree,cbParam:{codelistTriplet:freqCol?freqCol.CodelistCode===null||Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(freqCol.CodelistCode):null,language:dataLanguage||appLanguage,itemsOrderAnnotationType:itemsOrderAnnotationType,dimensionId:column.id},disabled:!freqCol||!isCC||!fetchColumnFilteredValues||freqCol.CodelistCode===null||freqCol.codelistCount===null||freqCol.codelistTree!==null},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchColumnFilteredValues,cbParam:{colNames:[freqCol?freqCol.name:null],filterStr:""},disabled:!freqCol||!isCC||!fetchColumnFilteredValues||freqCol.CodelistCode!==null&&(freqCol.codelistTree===null||freqCol.filteredCodelistTree!==null)||!isCC&&freqCol.CodelistCode===null&&freqCol.filteredValues===null||_this2.state.currentTab!==String(index)},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TimePeriod__["a" /* default */],{disabled:disabled,treeFilter:treeFilter,columns:columns,column:column,index:index,isCC:isCC,isSdmx:isSdmx,tempTPFrom:_this2.state.tempTPFrom,tempTPTo:_this2.state.tempTPTo,setTPFromTo:function setTPFromTo(obj){return _this2.setState(obj);},callOnColumnValuesChangeWithSpinner:callOnColumnValuesChangeWithSpinner,usePickers:!fetchColumnFilteredValues,minDate:minDate,maxDate:maxDate}))))))));})):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{bodyStyle:{height:526}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__custom_empty__["a" /* default */],null));});}}]);return TreeFilter;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(TreeFilter));

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

exports['default'] = KeyCode;
module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = interopDefault;

// https://github.com/moment/moment/issues/3650
function interopDefault(m) {
  return m["default"] || m;
}

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_css__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,maxDescriptionLength:state.config.dataManagement.maxDescriptionLength};};/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var ZoomableTextArea=function(_React$Component){_inherits(ZoomableTextArea,_React$Component);function ZoomableTextArea(props){_classCallCheck(this,ZoomableTextArea);var _this=_possibleConstructorReturn(this,(ZoomableTextArea.__proto__||Object.getPrototypeOf(ZoomableTextArea)).call(this,props));_this.state=ZoomableTextArea.getInitState();_this.callOnChange=_this.callOnChange.bind(_this);_this.showModal=_this.showModal.bind(_this);_this.hideModal=_this.hideModal.bind(_this);return _this;}_createClass(ZoomableTextArea,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){this.props.onChange(value);}}},{key:'showModal',value:function showModal(){this.setState({isModalVisible:true});}},{key:'hideModal',value:function hideModal(){this.setState({isModalVisible:false});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,value=_props.value,disabled=_props.disabled,singleLine=_props.singleLine,placeholder=_props.placeholder,_props$multilanguage=_props.multilanguage,multilanguage=_props$multilanguage===undefined?true:_props$multilanguage;var isModalVisible=this.state.isModalVisible;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__enhanced_modal__["a" /* default */],{visible:isModalVisible,onCancel:this.hideModal,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:this.hideModal,icon:'zoom-out'},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_MD"],withDataLanguageSelector:multilanguage,title:'\xA0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{style:{height:460}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a.TextArea,{placeholder:placeholder,value:value,onChange:function onChange(e){return _this2.callOnChange(e.target.value);},onBlur:this.props.onBlur,title:value,disabled:disabled,style:Object.assign({},this.props.style,{resize:'none',width:"100%",height:"100%"})}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a.Group,{compact:true,className:'zoomable-textarea__input-group',style:{position:"relative",height:"100%"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{icon:'zoom-in',style:{position:"absolute",height:"100%"},onClick:this.showModal}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a.TextArea,{autosize:singleLine?{minRows:1,maxRows:1}:null,placeholder:placeholder,value:value,onChange:function onChange(e){return _this2.callOnChange(e.target.value);},onBlur:this.props.onBlur,title:value,disabled:disabled,style:Object.assign({},this.props.style,{width:'calc(100% - 32px)',resize:'none',height:'100%',left:32})})));}}],[{key:'getInitState',value:function getInitState(){return{isModalVisible:false};}}]);return ZoomableTextArea;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps))(ZoomableTextArea));

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DCAT_METADATA_SETS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DCAT_METADATA_SET_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DCAT_METADATA_SET_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DCAT_METADATA_SET_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DCAT_METADATA_SET_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DCAT_METADATA_SET_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DCAT_METADATA_SET_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DCAT_METADATA_SET_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DCAT_METADATA_SET_REPORTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DCAT_METADATA_SET_REPORTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DCAT_METADATA_SET_REPORTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DCAT_METADATAFLOWS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DCAT_METADATAFLOWS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DCAT_METADATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DCAT_METADATAFLOW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DCAT_METADATAFLOW_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DCAT_REPORT_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DCAT_REPORT_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return DCAT_REPORT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DCAT_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return DCAT_REPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return DCAT_REPORT_STEP_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DCAT_REPORT_ATTRIBUTE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DCAT_REPORT_ATTRIBUTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DCAT_REPORT_ATTRIBUTE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DCAT_REPORT_ATTRIBUTE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DCAT_UPDATE_REPORT_STATE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return DCAT_REPORT_HTML_PAGE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return DCAT_REPORT_HTML_PAGE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DCAT_REPORT_ATTRIBUTE_CODES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DCAT_REPORT_ATTRIBUTE_CODES_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DCAT_REPORT_ATTRIBUTE_CODES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DCAT_REPORT_ATTRIBUTE_CODE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DCAT_REPORT_ATTRIBUTE_CODE_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DCAT_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DCAT_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return DCAT_REPORT_ID_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DCAT_REPORT_TARGET_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return DCAT_REPORT_TARGET_ARTEFACTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return DCAT_REPORT_TARGET_ARTEFACTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DCAT_REPORT_TARGET_ARTEFACTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DCAT_REPORT_TARGET_ARTEFACT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DCAT_REPORT_TARGET_ARTEFACT_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DCAT_DATAFLOW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DCAT_DATAFLOW_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DCAT_DATAFLOW_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DCAT_DATAFLOW_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DCAT_CONCEPT_SCHEMES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return DCAT_REPORT_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DCAT_METADATA_SET_HTML_PAGE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DCAT_METADATA_SET_HTML_PAGE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return readDcatMetadataSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return showDcatMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return hideDcatMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return readDcatMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return createDcatMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return changeDcatMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return submitDcatMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return deleteDcatMetadataSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return showDcatMetadataSetReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return hideDcatMetadataSetReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return readDcatMetadataSetReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return showDcatMetadataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return hideDcatMetadataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return readDcatMetadataflows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return setDcatMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return unsetDcatMetadataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return createDcatReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return deleteDcatReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return readDcatReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return hideDcatReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return submitDcatReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return submitDcatUpdateReportState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return showDcatReportHtmlPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return hideDcatReportHtmlPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return setDcatReportStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return selectDcatReportAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return changeDcatReportAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return createDcatReportAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return deleteDcatReportAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return showDcatReportAttributeCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return hideDcatReportAttributeCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return readDcatReportAttributeCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return setDcatReportAttributeCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return changeDcatReportId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return selectDcatReportTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return unsetDcatReportAttributeCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return uploadDcatReportAttributeAttachment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return downloadDcatReportAttributeAttachment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return showDcatReportTargetArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return hideDcatReportTargetArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return readDcatReportTargetArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return setDcatReportTargetArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return unsetDcatReportTargetArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return readDcatDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return changeDcatDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return submitDcatDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return hideDcatDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return readDcatConceptSchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return downloadDcatReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return showDcatMetadataSetHtmlPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return hideDcatMetadataSetHtmlPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_constants__ = __webpack_require__(161);
var DCAT_METADATA_SETS_READ="DCAT_METADATA_SETS_READ";var DCAT_METADATA_SET_SHOW="DCAT_METADATA_SET_SHOW";var DCAT_METADATA_SET_HIDE="DCAT_METADATA_SET_HIDE";var DCAT_METADATA_SET_READ="DCAT_METADATA_SET_READ";var DCAT_METADATA_SET_CREATE="DCAT_METADATA_SET_CREATE";var DCAT_METADATA_SET_CHANGE="DCAT_METADATA_SET_CHANGE";var DCAT_METADATA_SET_SUBMIT="DCAT_METADATA_SET_SUBMIT";var DCAT_METADATA_SET_DELETE="DCAT_METADATA_SET_DELETE";var DCAT_METADATA_SET_REPORTS_SHOW="DCAT_METADATA_SET_REPORTS_SHOW";var DCAT_METADATA_SET_REPORTS_HIDE="DCAT_METADATA_SET_REPORTS_HIDE";var DCAT_METADATA_SET_REPORTS_READ="DCAT_METADATA_SET_REPORTS_READ";var DCAT_METADATAFLOWS_SHOW="DCAT_METADATAFLOWS_SHOW";var DCAT_METADATAFLOWS_HIDE="DCAT_METADATAFLOWS_HIDE";var DCAT_METADATAFLOWS_READ="DCAT_METADATAFLOWS_READ";var DCAT_METADATAFLOW_SET="DCAT_METADATAFLOW_SET";var DCAT_METADATAFLOW_UNSET="DCAT_METADATAFLOW_UNSET";var DCAT_REPORT_CREATE="DCAT_REPORT_CREATE";var DCAT_REPORT_DELETE="DCAT_REPORT_DELETE";var DCAT_REPORT_READ="DCAT_REPORT_READ";var DCAT_REPORT_HIDE="DCAT_REPORT_HIDE";var DCAT_REPORT_SUBMIT="DCAT_REPORT_SUBMIT";var DCAT_REPORT_STEP_SET="DCAT_REPORT_STEP_SET";var DCAT_REPORT_ATTRIBUTE_SELECT="DCAT_REPORT_ATTRIBUTE_SELECT";var DCAT_REPORT_ATTRIBUTE_CHANGE="DCAT_REPORT_ATTRIBUTE_CHANGE";var DCAT_REPORT_ATTRIBUTE_CREATE="DCAT_REPORT_ATTRIBUTE_CREATE";var DCAT_REPORT_ATTRIBUTE_DELETE="DCAT_REPORT_ATTRIBUTE_DELETE";var DCAT_UPDATE_REPORT_STATE_SUBMIT="DCAT_UPDATE_REPORT_STATE_SUBMIT";var DCAT_REPORT_HTML_PAGE_SHOW='DCAT_REPORT_HTML_PAGE_SHOW';var DCAT_REPORT_HTML_PAGE_HIDE='DCAT_REPORT_HTML_PAGE_HIDE';var DCAT_REPORT_ATTRIBUTE_CODES_SHOW="DCAT_REPORT_ATTRIBUTE_CODES_SHOW";var DCAT_REPORT_ATTRIBUTE_CODES_HIDE="DCAT_REPORT_ATTRIBUTE_CODES_HIDE";var DCAT_REPORT_ATTRIBUTE_CODES_READ="DCAT_REPORT_ATTRIBUTE_CODES_READ";var DCAT_REPORT_ATTRIBUTE_CODE_SET="DCAT_REPORT_ATTRIBUTE_CODE_SET";var DCAT_REPORT_ATTRIBUTE_CODE_UNSET="DCAT_REPORT_ATTRIBUTE_CODE_UNSET";var DCAT_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD="DCAT_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD";var DCAT_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD="DCAT_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD";var DCAT_REPORT_ID_CHANGE="DCAT_REPORT_ID_CHANGE";var DCAT_REPORT_TARGET_SELECT="DCAT_REPORT_TARGET_SELECT";var DCAT_REPORT_TARGET_ARTEFACTS_SHOW="DCAT_REPORT_TARGET_ARTEFACTS_SHOW";var DCAT_REPORT_TARGET_ARTEFACTS_HIDE="DCAT_REPORT_TARGET_ARTEFACTS_HIDE";var DCAT_REPORT_TARGET_ARTEFACTS_READ="DCAT_REPORT_TARGET_ARTEFACTS_READ";var DCAT_REPORT_TARGET_ARTEFACT_SET="DCAT_REPORT_TARGET_ARTEFACT_SET";var DCAT_REPORT_TARGET_ARTEFACT_UNSET="DCAT_REPORT_TARGET_ARTEFACT_UNSET";var DCAT_DATAFLOW_READ="DCAT_DATAFLOW_READ";var DCAT_DATAFLOW_CHANGE="DCAT_DATAFLOW_CHANGE";var DCAT_DATAFLOW_SUBMIT="DCAT_DATAFLOW_SUBMIT";var DCAT_DATAFLOW_HIDE="DCAT_DATAFLOW_HIDE";var DCAT_CONCEPT_SCHEMES_READ="DCAT_CONCEPT_SCHEMES_READ";var DCAT_REPORT_DOWNLOAD="DCAT_REPORT_DOWNLOAD";var DCAT_METADATA_SET_HTML_PAGE_SHOW="DCAT_METADATA_SET_HTML_PAGE_SHOW";var DCAT_METADATA_SET_HTML_PAGE_HIDE="DCAT_METADATA_SET_HTML_PAGE_HIDE";var readDcatMetadataSets=function readDcatMetadataSets(msdTriplet,ownedMetadataflows){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DCAT_METADATA_SETS_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_62" /* getMetadataSetsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_66" /* getMsdUrl */])(msdTriplet)]),{ownedMetadataflows:ownedMetadataflows});};var showDcatMetadataSet=function showDcatMetadataSet(metadataSetId){return{type:DCAT_METADATA_SET_SHOW,metadataSetId:metadataSetId};};var hideDcatMetadataSet=function hideDcatMetadataSet(){return{type:DCAT_METADATA_SET_HIDE};};var readDcatMetadataSet=function readDcatMetadataSet(metadataSetId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_METADATA_SET_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_61" /* getMetadataSetUrl */])(metadataSetId));};var createDcatMetadataSet=function createDcatMetadataSet(){return{type:DCAT_METADATA_SET_CREATE};};var changeDcatMetadataSet=function changeDcatMetadataSet(fields){return{type:DCAT_METADATA_SET_CHANGE,fields:fields};};var submitDcatMetadataSet=function submitDcatMetadataSet(metadataSet){var autoAnnotations=Object(__WEBPACK_IMPORTED_MODULE_4__commons_constants__["e" /* getWorkingAnnotations */])(metadataSet);var idAnnotation=Object(__WEBPACK_IMPORTED_MODULE_3__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_3__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */]);if(idAnnotation){autoAnnotations.push(idAnnotation);}return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DCAT_METADATA_SET_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_109" /* getUpsertMetadataSetUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},metadataSet,{reports:undefined,autoAnnotations:autoAnnotations}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["K" /* SDMX_JSON_METADATA_SET_LIST_KEY */]),function(t){return{success:idAnnotation?t('scenes.referenceMetadata.metadataSet.messages.metadataSet.update.success'):t('scenes.referenceMetadata.metadataSet.messages.metadataSet.create.success')};});};var deleteDcatMetadataSet=function deleteDcatMetadataSet(metadataSetId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(DCAT_METADATA_SET_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_15" /* getDeleteMetadataSetUrl */])(metadataSetId),function(t){return{success:t('scenes.referenceMetadata.metadataSet.messages.metadataSet.delete.success')};});};var showDcatMetadataSetReports=function showDcatMetadataSetReports(metadataSetId){return{type:DCAT_METADATA_SET_REPORTS_SHOW,metadataSetId:metadataSetId};};var hideDcatMetadataSetReports=function hideDcatMetadataSetReports(){return{type:DCAT_METADATA_SET_REPORTS_HIDE};};var readDcatMetadataSetReports=function readDcatMetadataSetReports(metadataSetId,ownedDataflows,ownedMetadataflows){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_METADATA_SET_REPORTS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_60" /* getMetadataSetReportsUrl */])(metadataSetId)),{ownedDataflows:ownedDataflows,ownedMetadataflows:ownedMetadataflows});};var showDcatMetadataflows=function showDcatMetadataflows(){return{type:DCAT_METADATAFLOWS_SHOW};};var hideDcatMetadataflows=function hideDcatMetadataflows(){return{type:DCAT_METADATAFLOWS_HIDE};};var readDcatMetadataflows=function readDcatMetadataflows(ownedMetadataflows,msdUrn){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_METADATAFLOWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_64" /* getMetadataflowUrl */])()),{ownedMetadataflows:ownedMetadataflows,msdUrn:msdUrn});};var setDcatMetadataflow=function setDcatMetadataflow(triplet,msdUrn){return{type:DCAT_METADATAFLOW_SET,triplet:triplet,msdUrn:msdUrn};};var unsetDcatMetadataflow=function unsetDcatMetadataflow(){return{type:DCAT_METADATAFLOW_UNSET};};var createDcatReport=function createDcatReport(){return{type:DCAT_REPORT_CREATE};};var deleteDcatReport=function deleteDcatReport(reportId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(DCAT_REPORT_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_16" /* getDeleteReportUrl */])(reportId),function(t){return{success:t('scenes.referenceMetadata.dcat.messages.report.delete.success')};});};var readDcatReport=function readDcatReport(metadataSetId,reportId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_REPORT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_59" /* getMetadataSetReportUrl */])(metadataSetId,reportId));};var hideDcatReport=function hideDcatReport(){return{type:DCAT_REPORT_HIDE};};var submitDcatReport=function submitDcatReport(metadataSet,report,reportAnnotations,reportStructure,id,target,identifiableTargets,annotationsConfig,isDraft){var annotations=report?report.annotations:reportAnnotations?reportAnnotations:[];annotations=Object(__WEBPACK_IMPORTED_MODULE_3__utils_referenceMetadata__["V" /* updateReportStateAnnotations */])(annotations,isDraft);var reportRoot={id:id,target:{id:target,referenceValues:identifiableTargets.map(function(value){return{id:value.id,object:value.value};})},annotations:annotations.length>0?annotations:undefined,attributeSet:{reportedAttributes:[]}};return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DCAT_REPORT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_108" /* getUpsertJsonReportUrl */])(metadataSet.id),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(Object.assign({},metadataSet,{reports:[Object(__WEBPACK_IMPORTED_MODULE_3__utils_referenceMetadata__["R" /* getSdmxJsonReportFromReportStructure */])(reportStructure,reportRoot,annotationsConfig)]}))],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["K" /* SDMX_JSON_METADATA_SET_LIST_KEY */]),function(t){return{success:report||reportAnnotations?t('scenes.referenceMetadata.dcat.messages.report.update.success'):t('scenes.referenceMetadata.dcat.messages.report.create.success')};});};var submitDcatUpdateReportState=function submitDcatUpdateReportState(metadataSetId,reportId,newState){var formData=new FormData();formData.append('newState',newState);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DCAT_UPDATE_REPORT_STATE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_102" /* getUpdateStateReportUrl */])(metadataSetId,reportId),formData,function(t){return{success:t('scenes.referenceMetadata.dcat.messages.report.stateUpdate.success')};});};var showDcatReportHtmlPage=function showDcatReportHtmlPage(htmlPageUrl){return{type:DCAT_REPORT_HTML_PAGE_SHOW,htmlPageUrl:htmlPageUrl};};var hideDcatReportHtmlPage=function hideDcatReportHtmlPage(){return{type:DCAT_REPORT_HTML_PAGE_HIDE};};var setDcatReportStep=function setDcatReportStep(step,dataLanguages,t,mawsUrl){return{type:DCAT_REPORT_STEP_SET,step:step,dataLanguages:dataLanguages,t:t,mawsUrl:mawsUrl};};var selectDcatReportAttribute=function selectDcatReportAttribute(selectedAttributeKey){return{type:DCAT_REPORT_ATTRIBUTE_SELECT,selectedAttributeKey:selectedAttributeKey};};var changeDcatReportAttribute=function changeDcatReportAttribute(fields){return{type:DCAT_REPORT_ATTRIBUTE_CHANGE,fields:fields};};var createDcatReportAttribute=function createDcatReportAttribute(){return{type:DCAT_REPORT_ATTRIBUTE_CREATE};};var deleteDcatReportAttribute=function deleteDcatReportAttribute(){return{type:DCAT_REPORT_ATTRIBUTE_DELETE};};var showDcatReportAttributeCodes=function showDcatReportAttributeCodes(){return{type:DCAT_REPORT_ATTRIBUTE_CODES_SHOW};};var hideDcatReportAttributeCodes=function hideDcatReportAttributeCodes(){return{type:DCAT_REPORT_ATTRIBUTE_CODES_HIDE};};var readDcatReportAttributeCodes=function readDcatReportAttributeCodes(triplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_REPORT_ATTRIBUTE_CODES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["A" /* getCodelistUrl */])(triplet));};var setDcatReportAttributeCode=function setDcatReportAttributeCode(codeId){return{type:DCAT_REPORT_ATTRIBUTE_CODE_SET,codeId:codeId};};var changeDcatReportId=function changeDcatReportId(id){return{type:DCAT_REPORT_ID_CHANGE,id:id};};var selectDcatReportTarget=function selectDcatReportTarget(target){return{type:DCAT_REPORT_TARGET_SELECT,target:target};};var unsetDcatReportAttributeCode=function unsetDcatReportAttributeCode(){return{type:DCAT_REPORT_ATTRIBUTE_CODE_UNSET};};var uploadDcatReportAttributeAttachment=function uploadDcatReportAttributeAttachment(file,lang){var fileFormData=new FormData();fileFormData.append('file',file);return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DCAT_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_107" /* getUploadRMFileOnServerUrl */])(),fileFormData,function(t){return{success:t("scenes.referenceMetadata.commons.messages.attachmentUpload.success")};}),{lang:lang});};var downloadDcatReportAttributeAttachment=function downloadDcatReportAttributeAttachment(fileName){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_29" /* getDownloadRMFileOnServerUrl */])(fileName),undefined,true),{fileSave:{name:fileName}});};var showDcatReportTargetArtefacts=function showDcatReportTargetArtefacts(identifiableTarget){return{type:DCAT_REPORT_TARGET_ARTEFACTS_SHOW,identifiableTarget:identifiableTarget};};var hideDcatReportTargetArtefacts=function hideDcatReportTargetArtefacts(){return{type:DCAT_REPORT_TARGET_ARTEFACTS_HIDE};};var readDcatReportTargetArtefacts=function readDcatReportTargetArtefacts(identifiableTarget,ownedDataflows){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_REPORT_TARGET_ARTEFACTS_READ,__WEBPACK_IMPORTED_MODULE_4__commons_constants__["a" /* ARTEFACT_TYPES */].find(function(_ref){var type=_ref.type;return type===identifiableTarget.objectType.toLowerCase();}).url),{ownedDataflows:ownedDataflows});};var setDcatReportTargetArtefact=function setDcatReportTargetArtefact(value,identifiableTargetId){return{type:DCAT_REPORT_TARGET_ARTEFACT_SET,value:value,identifiableTargetId:identifiableTargetId};};var unsetDcatReportTargetArtefact=function unsetDcatReportTargetArtefact(identifiableTarget){return{type:DCAT_REPORT_TARGET_ARTEFACT_UNSET,identifiableTarget:identifiableTarget};};var readDcatDataflow=function readDcatDataflow(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_DATAFLOW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])(dataflowTriplet));};var changeDcatDataflow=function changeDcatDataflow(fields){return{type:DCAT_DATAFLOW_CHANGE,fields:fields};};var submitDcatDataflow=function submitDcatDataflow(dataflow){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(DCAT_DATAFLOW_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(dataflow)],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["B" /* SDMX_JSON_DATAFLOW_LIST_KEY */]),function(t){return{success:t('scenes.referenceMetadata.dcat.messages.dataflow.update.success')};}),{dataflow:dataflow});};var hideDcatDataflow=function hideDcatDataflow(){return{type:DCAT_DATAFLOW_HIDE};};var readDcatConceptSchemes=function readDcatConceptSchemes(conceptSchemeTriplets,appLang,dataLangs){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DCAT_CONCEPT_SCHEMES_READ,conceptSchemeTriplets.map(function(_){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */];}),conceptSchemeTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])(triplet);})),{appLang:appLang,dataLangs:dataLangs});};var downloadDcatReport=function downloadDcatReport(metadataSetId,reportId,fileName,metadataApiBaseUrl){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DCAT_REPORT_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_3__utils_referenceMetadata__["K" /* getMetadataApiReportUrl */])(metadataApiBaseUrl,metadataSetId,reportId)),{fileSave:{name:fileName,stringifyResponse:true}});};var showDcatMetadataSetHtmlPage=function showDcatMetadataSetHtmlPage(htmlPageUrl){return{type:DCAT_METADATA_SET_HTML_PAGE_SHOW,htmlPageUrl:htmlPageUrl};};var hideDcatMetadataSetHtmlPage=function hideDcatMetadataSetHtmlPage(){return{type:DCAT_METADATA_SET_HTML_PAGE_HIDE};};

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MM_DATAFLOWS_DSD_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MM_DATAFLOWS_CC_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_dsd_detail_modal_reducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_components_redux_content_constraint_modal_reducer__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_dataflow__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artefact_export_form__ = __webpack_require__(51);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var MM_DATAFLOWS_DSD_DETAIL_PREFIX="MM_DATAFLOWS_DSD_DETAIL_PREFIX_";var MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX="MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX_";var MM_DATAFLOWS_CC_DETAIL_PREFIX="MM_DATAFLOWS_CC_DETAIL_PREFIX";var DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD={id:"VIRTUALDSD",agencyID:"MDM",version:"1.0"};var dataflowsReducer=function dataflowsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isDetailVisible:false,dataflowTriplet:null,dataflows:null,isDataflowValid:true,isAgenciesValid:true,isDataflowGeneralTabDirty:false,dataflow:null,dsdForLayoutAnnotations:null,agencies:null,dsds:null,isDsdsListVisible:false,dsdDetail:null,selectedDsdTriplet:null,isDsdDetailVisible:false,downloadDataflowParams:null,downloadDataflowTriplets:null,downloadDataflowLang:null,cloneDestTriplet:null,dataflowAnnotations:null,dataflowLayoutAnnotations:null,dataflowAnnotationTriplet:null,dataflowExportSourceTriplet:null,dataflowExportDestination:null,dataflowExportReport:null,dataflowOwnershipDataflowTripletStr:null,dataflowOwnershipOwners:null,dataflowOwnershipUsers:null,parentsAndChildren:null,dataflowCCsDataflowTriplet:null,dataflowCCsContentConstraints:null,contentConstraintDetail:null,isLayoutAnnotationsFormVisible:false,dataflowOriginalAnnotations:null,itemsPageForLayoutAnnotations:null,isVirtualDFEndpointAvailable:null,virtualDFDataflows:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["R" /* DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW */]:return Object.assign({},state,{isLayoutAnnotationsFormVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE */]:return Object.assign({},state,{isLayoutAnnotationsFormVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["S" /* DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT */]:return Object.assign({},state,{isLayoutAnnotationsFormVisible:false,dataflow:Object.assign({},state.dataflow,{annotations:action.annotations})});case __WEBPACK_IMPORTED_MODULE_1__actions__["Q" /* DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET */]:return Object.assign({},state,{dataflow:Object.assign({},state.dataflow,{annotations:state.dataflowOriginalAnnotations})});case __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET */]:return Object.assign({},state,{itemsPageForLayoutAnnotations:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* DATAFLOWS_DATAFLOW_CREATE */]:return Object.assign({},state,{dataflow:{id:null,agencyID:null,version:null,isFinal:false,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,dsd:null,structure:null,annotations:null,dataflowType:__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["a" /* DATAFLOW_TYPE_NORMAL */]},dataflowOriginalAnnotations:undefined,isDetailVisible:true,isAgenciesValid:false,isVirtualDFEndpointAvailable:false,virtualDFDataflows:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_SHOW */]:return Object.assign({},state,{dataflowCCsDataflowTriplet:action.dataflowTriplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_HIDE */]:return Object.assign({},state,{dataflowCCsDataflowTriplet:null,dataflowCCsContentConstraints:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* DATAFLOWS_DATAFLOW_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{dataflowExportReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* DATAFLOWS_DATAFLOW_OWNERSHIP_SHOW */]:{return Object.assign({},state,{dataflowOwnershipDataflowTripletStr:action.dataflowTripletStr});}case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* DATAFLOWS_DATAFLOW_OWNERSHIP_HIDE */]:return Object.assign({},state,{dataflowOwnershipDataflowTripletStr:null,dataflowOwnershipOwners:null,dataflowOwnershipUsers:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_CHANGE */]:return Object.assign({},state,{dataflowOwnershipOwners:action.owners});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* DATAFLOWS_DATAFLOW_EDIT */]:return Object.assign({},state,{isDetailVisible:true,dataflowTriplet:action.dataflowTriplet,isDataflowValid:false,isAgenciesValid:false,isDataflowGeneralTabDirty:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* DATAFLOWS_DETAIL_HIDE */]:return Object.assign({},state,{isDetailVisible:false,dataflowTriplet:null,dataflow:null,dsds:null,dsdForLayoutAnnotations:null,isDsdsListVisible:false,dsdDetail:null,selectedDsdTriplet:null,isDsdDetailVisible:false,agencies:null,allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* DATAFLOWS_DETAIL_DATAFLOW_CHANGE */]:{var dataflow=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.dataflow);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};var newDataflow=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(dataflow,action.fields,customizer);var newAutoAnnotations=newDataflow.autoAnnotations;// if dataflow type has changed in "only file", add "dataflow catalog type" annotation
if(newDataflow.dataflowType!==state.dataflow.dataflowType&&newDataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]){var dataflowCatalogTypeAnnotationType=Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["b" /* AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY */]];newAutoAnnotations=[].concat(_toConsumableArray((newAutoAnnotations||[]).filter(function(_ref){var type=_ref.type;return type!==dataflowCatalogTypeAnnotationType;})),[{type:dataflowCatalogTypeAnnotationType,id:dataflowCatalogTypeAnnotationType,title:__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["i" /* DATAFLOW_CATALOG_TYPE_ONLY_FILE */]}]);}// if dataflow type is not "virtual", remove related annotation
newAutoAnnotations=newDataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]?newAutoAnnotations:(newAutoAnnotations||[]).filter(function(_ref2){var type=_ref2.type;return type!==Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["h" /* AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY */]];});// if dataflow type is not "only file", remove related annotation
newAutoAnnotations=newDataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]?newAutoAnnotations:(newAutoAnnotations||[]).filter(function(_ref3){var type=_ref3.type;return type!==Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["b" /* AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY */]];});// reflect dataflow type in isExternalReference
newDataflow.isExternalReference=newDataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */];return Object.assign({},state,{dataflow:Object.assign({},newDataflow,{id:!state.dataflow.isExternalReference&&newDataflow.isExternalReference?"":newDataflow.id,agencyID:!state.dataflow.isExternalReference&&newDataflow.isExternalReference?"":newDataflow.agencyID,version:!state.dataflow.isExternalReference&&newDataflow.isExternalReference?"":newDataflow.version,isFinal:!state.dataflow.isExternalReference&&newDataflow.isExternalReference?true:newDataflow.isFinal,dsd:newDataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]||newDataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD):state.dataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]||state.dataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]?null:state.dataflow.dsd,structure:newDataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]||newDataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */]):state.dataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]||state.dataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]?null:state.dataflow.structure,autoAnnotations:newAutoAnnotations}),isDataflowGeneralTabDirty:true,dataflowOriginalAnnotations:newDataflow.annotations});}case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* DATAFLOWS_DETAIL_DSDS_SHOW */]:return Object.assign({},state,{isDsdsListVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* DATAFLOWS_DETAIL_DSDS_HIDE */]:return Object.assign({},state,{isDsdsListVisible:false,dsds:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* DATAFLOWS_DETAIL_DSD_SET */]:return Object.assign({},state,{isDsdsListVisible:false,dsds:null,dataflow:Object.assign({},state.dataflow,{dsd:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.dsdTriplet),structure:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(action.dsdTriplet,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */])}),selectedDsdTriplet:action.dsdTriplet,dsdDetail:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* DATAFLOWS_DETAIL_DSD_UNSET */]:return Object.assign({},state,{dataflow:Object.assign({},state.dataflow,{dsd:null,structure:null}),dsdDetail:null,dsdForLayoutAnnotations:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* DATAFLOWS_DETAIL_ANNOTATIONS_SHOW */]:return Object.assign({},state,{dataflowAnnotations:action.annotations,dataflowAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* DATAFLOWS_DETAIL_ANNOTATIONS_HIDE */]:return Object.assign({},state,{dataflowAnnotations:null,dataflowAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["W" /* DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_SHOW */]:return Object.assign({},state,{dataflowLayoutAnnotations:action.annotations,dataflowAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["T" /* DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_HIDE */]:return Object.assign({},state,{dataflowLayoutAnnotations:null,dataflowAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* DATAFLOWS_DATAFLOW_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadDataflowTriplets:action.artefactTriplets,downloadDataflowLang:action.lang,downloadDataflowParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* DATAFLOWS_DATAFLOW_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadDataflowTriplets:null,downloadDataflowLang:null,downloadDataflowParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* DATAFLOWS_DATAFLOW_DOWNLOAD_CHANGE */]:var downloadDataflowParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadDataflowParams);return Object.assign({},state,{downloadDataflowParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadDataflowParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* DATAFLOWS_DATAFLOW_CLONE_SHOW */]:var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),dataflowTriplet:state.dataflowTriplet?state.dataflowTriplet:action.srcTriplet,isDataflowValid:!!state.dataflow,isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* DATAFLOWS_DATAFLOW_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,dataflow:state.isDetailVisible?state.dataflow:null,selectedDsdTriplet:state.selectedDsdTriplet?state.dataflow:null,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DATAFLOWS_DATAFLOW_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* DATAFLOWS_DATAFLOW_EXPORT_SHOW */]:return Object.assign({},state,{dataflowExportSourceTriplet:action.sourceTriplet,dataflowExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version},isAgenciesValid:!!state.allAgencies,loginOption:__WEBPACK_IMPORTED_MODULE_11__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* DATAFLOWS_DATAFLOW_EXPORT_HIDE */]:return Object.assign({},state,{dataflowExportSourceTriplet:null,dataflowExportDestination:null,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* DATAFLOWS_DATAFLOW_EXPORT_CHANGE */]:var dataflowExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.dataflowExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(dataflowExportDestination,action.fields);return Object.assign({},state,{dataflowExportDestination:dataflowExportDestination});case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_3" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_SET */]:{var virtualDataflowNodeAnnotationType=Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["h" /* AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY */]];var autoAnnotations=state.dataflow.autoAnnotations=[].concat(_toConsumableArray((state.dataflow.autoAnnotations||[]).filter(function(_ref4){var type=_ref4.type;return type!==virtualDataflowNodeAnnotationType;})),[{type:virtualDataflowNodeAnnotationType,id:virtualDataflowNodeAnnotationType,title:action.endpointId}]);return Object.assign({},state,{dataflow:Object.assign({},state.dataflow,{id:null,agencyID:null,version:null,autoAnnotations:autoAnnotations})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_0" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_SET */]:return Object.assign({},state,{dataflow:Object.assign({},state.dataflow,{id:action.dataflowTriplet.id,agencyID:action.dataflowTriplet.agencyID,version:action.dataflowTriplet.version}),isVirtualDFDataflowsModalOpen:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["_1" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOW_UNSET */]:return Object.assign({},state,{dataflow:Object.assign({},state.dataflow,{id:null,agencyID:null,version:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_OPEN */]:return Object.assign({},state,{isVirtualDFDataflowsModalOpen:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["X" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_MODAL_CLOSE */]:return Object.assign({},state,{isVirtualDFDataflowsModalOpen:false,virtualDFDataflows:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT */]:return Object.assign({},state,{isDataflowGeneralTabDirty:false,agencies:null,allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* DATAFLOWS_DETAIL_DSDS_READ */]:return Object.assign({},state,{dsds:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_2" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_PING */]:return Object.assign({},state,{isVirtualDFEndpointAvailable:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["_2" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_ENDPOINT_PING */]:return Object.assign({},state,{isVirtualDFEndpointAvailable:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["Z" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DATAFLOWS_READ */]:return Object.assign({},state,{virtualDFDataflows:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["U" /* DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ */]:return Object.assign({},state,{itemsPageForLayoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes||[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_READ */]:return Object.assign({},state,{dataflowOwnershipOwners:action.response.owners.map(function(_ref5){var username=_ref5.username;return username;})});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* DATAFLOWS_DATAFLOW_OWNERSHIP_USERS_READ */]:return Object.assign({},state,{dataflowOwnershipUsers:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_SUBMIT */]:return Object.assign({},state,{dataflowOwnershipDataflowTripletStr:null,dataflowOwnershipOwners:null,dataflowOwnershipUsers:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_4" /* DATAFLOWS_LIST_DATAFLOWS_READ */]:return Object.assign({},state,{dataflows:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* DATAFLOWS_DETAIL_DATAFLOW_READ */]:var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _dataflow=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,customNoneIsAutoAnnotation);var annotationTabsConfig=Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotationTabs.tabs;var annotationsConfig=Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations;var isExternalReference=!![].concat(_toConsumableArray(_dataflow.annotations||[]),_toConsumableArray(_dataflow.autoAnnotations||[])).find(function(_ref6){var type=_ref6.type;return type===annotationsConfig[__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["h" /* AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY */]];});var isOnlyFile=!![].concat(_toConsumableArray(_dataflow.annotations||[]),_toConsumableArray(_dataflow.autoAnnotations||[])).find(function(_ref7){var type=_ref7.type;return type===annotationsConfig[__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["b" /* AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY */]];});return Object.assign({},state,{dataflow:Object.assign({},_dataflow,{isExternalReference:isExternalReference,dataflowType:isExternalReference?__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]:isOnlyFile?__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]:__WEBPACK_IMPORTED_MODULE_10__utils_dataflow__["a" /* DATAFLOW_TYPE_NORMAL */],dsd:_dataflow.structure?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(_dataflow.structure)):null}),selectedDsdTriplet:_dataflow.structure?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(_dataflow.structure):null,isDataflowValid:true,dataflowOriginalAnnotations:[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["v" /* getGenericAnnotations */])(_dataflow.annotations,annotationTabsConfig,annotationsConfig)),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(_dataflow.annotations,annotationTabsConfig))),[(_dataflow.autoAnnotations||[]).find(function(_ref8){var type=_ref8.type;return type===Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["h" /* AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY */]];})]),isVirtualDFEndpointAvailable:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* DATAFLOWS_DETAIL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response,isAgenciesValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* DATAFLOWS_DETAIL_DATAFLOW_CREATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* DATAFLOWS_DATAFLOW_DELETE */]:return Object.assign({},state,{dataflow:null,dataflows:null,isDetailVisible:false,agencies:null,allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT */]:return Object.assign({},state,{dataflow:null,dataflows:null,isDataflowValid:false,item:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* DATAFLOWS_DETAIL_DSDS_READ */]:return Object.assign({},state,{dsds:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["_5" /* DATAFLOWS_SELECTED_DATAFLOWS_DELETE */]:return Object.assign({},state,{dataflow:null,dataflows:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT */]:return Object.assign({},state,{downloadDataflowTriplets:null,downloadDataflowLang:null,downloadDataflowParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* DATAFLOWS_DATAFLOW_CLONE_SUBMIT */]:return Object.assign({},state,{dataflows:null,cloneDestTriplet:null,dataflow:state.isDetailVisible?state.dataflow:null,selectedDsdTriplet:state.selectedDsdTriplet?state.dataflow:null,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* DATAFLOWS_DATAFLOW_EXPORT_SUBMIT */]:return Object.assign({},state,{dataflowExportSourceTriplet:null,dataflowExportDestination:null,dataflowExportReport:action.response.itemsMessage,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* DATAFLOWS_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ */]:return Object.assign({},state,{dsdForLayoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["R" /* getDsdFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)});case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_READ */]:return Object.assign({},state,{dataflowCCsContentConstraints:action.response.map(function(art){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(art,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);}).map(function(cc){return Object.assign({},cc,{agencyID:cc.agency});})});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* DATAFLOWS_DETAIL_DATAFLOW_READ */]:return Object.assign({},state,{isDetailVisible:false,isDataflowValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["_5" /* DATAFLOWS_SELECTED_DATAFLOWS_DELETE */]:return Object.assign({},state,{dataflows:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["e"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["b" /* reuseInReducer */])(dataflowsReducer,{dsdDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_dsd_detail_modal_reducer__["c" /* default */],MM_DATAFLOWS_DSD_DETAIL_PREFIX),selectedDsdDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_dsd_detail_modal_reducer__["c" /* default */],MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX),contentConstraintDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_7__redux_components_redux_content_constraint_modal_reducer__["a" /* default */],MM_DATAFLOWS_CC_DETAIL_PREFIX)}));

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DM_UPGRADE_DSD_DSD_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_components_redux_dsd_detail_modal_reducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
var DM_UPGRADE_DSD_DSD_DETAIL_PREFIX="DM_UPGRADE_DSD_DSD_DETAIL_PREFIX_";var DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX="DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX_";var upgradeDsdReducer=function upgradeDsdReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{dsds:null,dataflows:null,dataflowsDsdTriplet:null,isUpgradedDsdsVisible:false,upgradedDsds:null,sourceDsdTriplet:null,targetDsdTriplet:null,isCompareReportVisible:false,compareReport:null,isUpgradeVisible:false,upgradeReport:null,codelistCompareReport:null,isImportDsdVisible:false,dsdFile:null,isImportEnabled:false,importDsdHash:null,importDsdItems:null,importDsdReport:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* UPGRADE_DSD_UPGRADED_DSDS_SHOW */]:return Object.assign({},state,{sourceDsdTriplet:action.dsdTriplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* UPGRADE_DSD_DATAFLOWS_SHOW */]:return Object.assign({},state,{dataflows:action.dataflows,dataflowsDsdTriplet:action.dsdTriplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* UPGRADE_DSD_DATAFLOWS_HIDE */]:return Object.assign({},state,{dataflows:null,dataflowsDsdTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* UPGRADE_DSD_UPGRADED_DSDS_HIDE */]:return Object.assign({},state,{isUpgradedDsdsVisible:false,sourceDsdTriplet:null,upgradedDsds:null,dsds:null,targetDsdTriplet:null,isCompareReportVisible:false,compareReport:null,isUpgradeVisible:false,upgradeReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* UPGRADE_DSD_DSDS_COMPARE_HIDE */]:return Object.assign({},state,{isCompareReportVisible:false,compareReport:null,isUpgradeVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* UPGRADE_DSD_DSD_UPGRADE_SHOW */]:return Object.assign({},state,{isUpgradeVisible:true,targetDsdTriplet:action.dsdTriplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* UPGRADE_DSD_DSD_UPGRADE_HIDE */]:return Object.assign({},state,{isUpgradedDsdsVisible:!action.success,sourceDsdTriplet:action.success?null:state.sourceDsdTriplet,targetDsdTriplet:null,upgradedDsds:null,dsds:action.success?null:state.dsds,compareReport:null,isUpgradeVisible:false,upgradeReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* UPGRADE_DSD_CODELIST_COMPARE_REPORT_HIDE */]:return Object.assign({},state,{codelistCompareReport:null,targetDsdTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* UPGRADE_DSD_IMPORT_DSD_SHOW */]:return Object.assign({},state,{isImportDsdVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* UPGRADE_DSD_IMPORT_DSD_HIDE */]:return Object.assign({},state,{compareReport:null,isImportDsdVisible:false,dsdFile:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* UPGRADE_DSD_IMPORT_DSD_FILE_SET */]:return Object.assign({},state,{dsdFile:action.file});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* UPGRADE_DSD_IMPORT_DSD_IMPORT_START */]:return Object.assign({},state,{compareReport:null,isImportEnabled:true,isImportDsdVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* UPGRADE_DSD_IMPORT_DSD_REPORT_HIDE */]:return Object.assign({},state,{compareReport:null,isImportEnabled:false,importDsdHash:null,importDsdItems:null,importDsdReport:null,dsdFile:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* UPGRADE_DSD_DSDS_READ */]:return Object.assign({},state,{dsds:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* UPGRADE_DSD_UPGRADED_DSDS_READ */]:return Object.assign({},state,{isUpgradedDsdsVisible:true,upgradedDsds:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* UPGRADE_DSD_DSDS_COMPARE */]:return Object.assign({},state,{isCompareReportVisible:action.showModal,compareReport:action.response,targetDsdTriplet:action.targetDsdTriplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* UPGRADE_DSD_DSD_UPGRADE */]:return Object.assign({},state,{upgradeReport:action.response,isCompareReportVisible:false,upgradedDsds:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* UPGRADE_DSD_CODELIST_COMPARE_REPORT_READ */]:return Object.assign({},state,{codelistCompareReport:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT */]:return Object.assign({},state,{isCompareReportVisible:action.showModal,compareReport:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD */]:return Object.assign({},state,{importDsdHash:action.response.hashImport,importDsdItems:action.response.importedItem});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT */]:return Object.assign({},state,{dsdFile:null,importDsdHash:null,importDsdReport:action.response.itemsMessage,isImportDsdVisible:false,upgradedDsds:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* UPGRADE_DSD_DSDS_COMPARE */]:return Object.assign({},state,{targetDsdTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* UPGRADE_DSD_DSD_UPGRADE */]:return Object.assign({},state,{upgradedDsds:null,targetDsdTriplet:null,compareReport:null,isUpgradeVisible:false,upgradeReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT */]:return Object.assign({},state,{isImportEnabled:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD */]:return Object.assign({},state,{isImportEnabled:false,compareReport:null,dsdFile:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT */]:return Object.assign({},state,{isImportEnabled:false,importDsdHash:null,importDsdItems:null,compareReport:null,dsdFile:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_reduxReuse__["b" /* reuseInReducer */])(upgradeDsdReducer,{dsdDetail:Object(__WEBPACK_IMPORTED_MODULE_2__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_dsd_detail_modal_reducer__["c" /* default */],DM_UPGRADE_DSD_DSD_DETAIL_PREFIX),codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_2__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_codelist_detail_modal_reducer__["a" /* default */],DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX)}));

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UTILITIES_COMPARE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UTILITIES_COMPARE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UTILITIES_COMPARE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPARE_ITEM_SCHEMES_FORMAT_TYPE_SDMX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_components_redux_concept_scheme_detail_modal_reducer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_components_redux_category_scheme_detail_modal_reducer__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_artefacts__ = __webpack_require__(56);
var UTILITIES_COMPARE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX="UTILITIES_COMPARE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX_";var UTILITIES_COMPARE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX="UTILITIES_COMPARE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX_";var UTILITIES_COMPARE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX="UTILITIES_COMPARE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX_";var COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST="Codelist";var COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME="CategoryScheme";var COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME="ConceptScheme";var COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB="msdb";var COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV="csv";var COMPARE_ITEM_SCHEMES_FORMAT_TYPE_SDMX="sdmx";var compareItemSchemesReducer=function compareItemSchemesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{artefactType:COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST,sourceFormat:COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB,targetFormat:COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB,source:null,target:null,isSource:null,isArtefactsVisible:false,artefacts:null,sourceCsvProps:null,targetCsvProps:null,report:null,isXmlPreviewVisible:false,isCsvPreviewVisible:false,isSourcePreview:null,previewItems:null,previewItemCount:null,previewCodelistTriplet:{id:"IdUseOnlyForPreview-aea11369-686d-4997-bff1-98853f3c4882",agencyID:"MERGE",version:"1.0"},previewItemParams:null,csvFilePath:null,allCsvRows:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE */]:return Object.assign({},state,{artefactType:action.artefactType,sourceFormat:COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB,targetFormat:COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB,source:null,target:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* COMPARE_ITEM_SCHEMES_FORMAT_CHANGE */]:return Object.assign({},state,{sourceFormat:action.isSource?action.format:state.sourceFormat,targetFormat:!action.isSource?action.format:state.targetFormat,source:action.isSource?null:state.source,target:!action.isSource?null:state.target,sourceCsvProps:action.isSource?state.sourceFormat!==COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV&&action.format===COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV?{identity:{ID:'tempID_1',Agency:'tempAgency_1',Version:'1.0'},textSeparator:';',textDelimiter:'',lang:action.lang,type:state.artefactType,firstRowHeader:true}:null:state.sourceCsvProps,targetCsvProps:!action.isSource?state.targetFormat!==COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV&&action.format===COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV?{identity:{ID:'tempID_2',Agency:'tempAgency_2',Version:'1.0'},textSeparator:';',textDelimiter:'',lang:action.lang,type:state.artefactType,firstRowHeader:true}:null:state.targetCsvProps});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* COMPARE_ITEM_SCHEMES_CSV_PROPS_CHANGE */]:var sourceCsvProps=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.sourceCsvProps);var targetCsvProps=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.targetCsvProps);return Object.assign({},state,{sourceCsvProps:action.isSource?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(sourceCsvProps,action.fields):state.sourceCsvProps,targetCsvProps:!action.isSource?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(targetCsvProps,action.fields):state.targetCsvProps});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* COMPARE_ITEM_SCHEMES_FILE_SET */]:return Object.assign({},state,{source:action.isSource?action.file:state.source,target:!action.isSource?action.file:state.target});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACTS_SHOW */]:return Object.assign({},state,{isArtefactsVisible:true,isSource:action.isSource});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* COMPARE_ITEM_SCHEMES_ARTEFACTS_HIDE */]:return Object.assign({},state,{isArtefactsVisible:false,artefacts:null,isSource:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* COMPARE_ITEM_SCHEMES_ARTEFACT_SET */]:return Object.assign({},state,{isArtefactsVisible:false,artefacts:null,isSource:null,source:state.isSource?action.artefactTriplet:state.source,target:!state.isSource?action.artefactTriplet:state.target});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* COMPARE_ITEM_SCHEMES_ARTEFACT_UNSET */]:return Object.assign({},state,{source:action.isSource?null:state.source,target:!action.isSource?null:state.target});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* COMPARE_ITEM_SCHEMES_COMPARE_HIDE */]:return Object.assign({},state,{report:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* COMPARE_ITEM_SCHEMES_CSV_PREVIEW_SHOW */]:return Object.assign({},state,{isCsvPreviewVisible:true,isSourcePreview:action.isSource});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* COMPARE_ITEM_SCHEMES_XML_PREVIEW_SHOW */]:return Object.assign({},state,{isXmlPreviewVisible:true,isSourcePreview:action.isSource});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* COMPARE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE */]:return Object.assign({},state,{previewItemParams:Object.assign({},action.params,{timeStamp:new Date().getTime()})});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* COMPARE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE */]:return Object.assign({},state,{previewItemParams:Object.assign({},state.previewItemParams,{pageNum:1,lang:action.lang}),previewItems:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* COMPARE_ITEM_SCHEMES_PREVIEW_HIDE */]:return Object.assign({},state,{isCsvPreviewVisible:false,isXmlPreviewVisible:false,isSourcePreview:null,previewItems:null,previewItemCount:null,previewItemParams:null,csvFilePath:null,allCsvRows:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACTS_READ */]:return Object.assign({},state,{artefacts:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* COMPARE_ITEM_SCHEMES_COMPARE_READ */]:return Object.assign({},state,{report:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* COMPARE_ITEM_SCHEMES_XML_PREVIEW_READ */]:var previewItems=null;var previewItemCount=null;if(state.artefactType===COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST){previewItems=action.response;previewItemCount=Number(action.header["x-total-count"]);}else if(state.artefactType===COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME){var categoryScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);var itemsTree=categoryScheme.categories?Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["h" /* getMappedTree */])(categoryScheme.categories,"categories",function(node){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(node,Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]);}):[];itemsTree=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["h" /* getMappedTree */])([{isRoot:true,categories:itemsTree}],"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_10__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].categories;previewItems=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["l" /* getNodes */])(itemsTree,"categories",function(){return true;});}else if(state.artefactType===COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME){var conceptScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["y" /* SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);previewItems=conceptScheme.concepts;}return Object.assign({},state,{previewItems:previewItems,previewItemCount:previewItemCount});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* COMPARE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ */]:{var codelist=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var isInvisibleItem=function isInvisibleItem(item){return item.annotations&&item.annotations.find(function(annot){return annot.id==="INVISIBLE"&&annot.title==="INVISIBLE"&&annot.type==="INVISIBLE";})!==undefined;};return Object.assign({},state,{previewItems:(codelist.codes||[]).filter(function(item){return!isInvisibleItem(item);}),previewItemCount:Number(action.header["x-total-count"])});}case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* COMPARE_ITEM_SCHEMES_CSV_FILE_UPLOAD */]:return Object.assign({},state,{csvFilePath:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* COMPARE_ITEM_SCHEMES_CSV_PAGE_READ */]:return Object.assign({},state,{allCsvRows:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["j"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["b" /* reuseInReducer */])(compareItemSchemesReducer,{codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_reducer__["a" /* default */],UTILITIES_COMPARE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX),conceptSchemeDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_6__redux_components_redux_concept_scheme_detail_modal_reducer__["b" /* default */],UTILITIES_COMPARE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX),categorySchemeDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_7__redux_components_redux_category_scheme_detail_modal_reducer__["b" /* default */],UTILITIES_COMPARE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX)}));

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cardStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EL_MAPPING_ROW_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CUBE_COMPONENT_TYPE_TIME_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUBE_COMPONENT_TYPE_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUBE_COMPONENT_TYPE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CUBE_COMPONENT_TYPE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EL_MAPPING_NEW_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getELMappingTranslations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_constants__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var cardStyle={type:"inner",headStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_0__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_0__styles_constants__["PADDING_MD"]},bodyStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_0__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_0__styles_constants__["PADDING_MD"],height:420}};var EL_MAPPING_ROW_HEIGHT=400;var CUBE_COMPONENT_TYPE_TIME_DIMENSION="TimeDimension";var CUBE_COMPONENT_TYPE_DIMENSION="Dimension";var CUBE_COMPONENT_TYPE_ATTRIBUTE="Attribute";var CUBE_COMPONENT_TYPE_MEASURE="Measure";var EL_MAPPING_NEW_MAPPING="EL_MAPPING_NEW_MAPPING";var getELMappingTranslations=function getELMappingTranslations(t){var translate=function translate(t){return _defineProperty({},EL_MAPPING_NEW_MAPPING,t('components.easyLoading.steps.mapping.options.newMapping'));};return translate(t!==undefined?t:function(str){return str;});};

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
    return this;
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        observer.apply(observer, [event].concat(args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getErrorCodesTranslations; });
var getErrorCodesTranslations=function getErrorCodesTranslations(t,params){var errorCodesTranslations=function errorCodesTranslations(t){return{UNAUTHORIZED:t('errors.statusCodes.401'),FORBIDDEN:t('errors.statusCodes.403'),'CUBE_NOT_FOUND':t('errors.businessLogic.CUBE_NOT_FOUND',Object.assign({},params)),'CUBE_WITHOUT_LABEL':t('errors.businessLogic.CUBE_WITHOUT_LABEL',Object.assign({},params)),'CUBE_DUPLICATED_CODE':t('errors.businessLogic.CUBE_DUPLICATED_CODE',Object.assign({},params)),'CUBE_CATEGORY_NOT_DEFINED':t('errors.businessLogic.CUBE_CATEGORY_NOT_DEFINED',Object.assign({},params)),'CUBE_CATCUBE_INSERT_ERROR':t('errors.businessLogic.CUBE_CATCUBE_INSERT_ERROR',Object.assign({},params)),'CUBE_NO_LABELS':t('errors.businessLogic.CUBE_NO_LABELS',Object.assign({},params)),'CUBE_LABELS_CREATION':t('errors.businessLogic.CUBE_LABELS_CREATION',Object.assign({},params)),'CUBE_NO_DIM':t('errors.businessLogic.CUBE_NO_DIM',Object.assign({},params)),'CUBE_DIM_DUPLICATED_CODE':t('errors.businessLogic.CUBE_DIM_DUPLICATED_CODE',Object.assign({},params)),'CUBE_DIM_CREATE':t('errors.businessLogic.CUBE_DIM_CREATE',Object.assign({},params)),'CUBE_TIME_DIM_ERR':t('errors.businessLogic.CUBE_TIME_DIM_ERR',Object.assign({},params)),'CUBE_ATT_DUPLICATED_CODE':t('errors.businessLogic.CUBE_ATT_DUPLICATED_CODE',Object.assign({},params)),'CUBE_ATT_CREATE':t('errors.businessLogic.CUBE_ATT_CREATE',Object.assign({},params)),'CUBE_NO_MEAS':t('errors.businessLogic.CUBE_NO_MEAS',Object.assign({},params)),'CUBE_MEAS_DUPLICATED_CODE':t('errors.businessLogic.CUBE_MEAS_DUPLICATED_CODE',Object.assign({},params)),'CUBE_FACT_TABLE_CREATE':t('errors.businessLogic.CUBE_FACT_TABLE_CREATE',Object.assign({},params)),'CUBE_FILT_TABLE_CREATE':t('errors.businessLogic.CUBE_FILT_TABLE_CREATE',Object.assign({},params)),'CUBE_VIEW_DATA_CREATE':t('errors.businessLogic.CUBE_VIEW_DATA_CREATE',Object.assign({},params)),'CUBE_VIEW_ALL_SERIES_CREATE':t('errors.businessLogic.CUBE_VIEW_ALL_SERIES_CREATE',Object.assign({},params)),'CUBE_VIEW_DATAFACT_CREATE':t('errors.businessLogic.CUBE_VIEW_DATAFACT_CREATE',Object.assign({},params)),'CUBE_WITH_ASSOCIATED_DATAFLOWS':t('errors.businessLogic.CUBE_WITH_ASSOCIATED_DATAFLOWS',Object.assign({},params)),'CUBE_DELETE_ERROR':t('errors.businessLogic.CUBE_DELETE_ERROR',Object.assign({},params)),'CUBE_CREATE_ERROR':t('errors.businessLogic.CUBE_CREATE_ERROR',Object.assign({},params)),'CUBE_RETRIEVING_ERROR':t('errors.businessLogic.CUBE_RETRIEVING_ERROR',Object.assign({},params)),'CUBE_RETRIEVING_AV_ERROR':t('errors.businessLogic.CUBE_RETRIEVING_AV_ERROR',Object.assign({},params)),'DEF_CAT_SCHEME_EMPTY':t('errors.businessLogic.DEF_CAT_SCHEME_EMPTY',Object.assign({},params)),'DEF_CAT_SCHEME_ALREADY_EXISTS':t('errors.businessLogic.DEF_CAT_SCHEME_ALREADY_EXISTS',Object.assign({},params)),'DEF_CAT_SCHEME_IMPORT_ERROR':t('errors.businessLogic.DEF_CAT_SCHEME_IMPORT_ERROR',Object.assign({},params)),'DCS_RETRIEVING_ERROR':t('errors.businessLogic.DCS_RETRIEVING_ERROR',Object.assign({},params)),'MAPPINGS_RETRIEVING_ERROR':t('errors.businessLogic.MAPPINGS_RETRIEVING_ERROR',Object.assign({},params)),'MAPPING_NOT_EXISTENT':t('errors.businessLogic.MAPPING_NOT_EXISTENT',Object.assign({},params)),'MAPPING_EMPTY':t('errors.businessLogic.MAPPING_EMPTY',Object.assign({},params)),'MAPPING_CREATE_ERROR':t('errors.businessLogic.MAPPING_CREATE_ERROR',Object.assign({},params)),'MAPPING_CREATE_DUPLICATED_NAME':t('errors.businessLogic.MAPPING_CREATE_DUPLICATED_NAME',Object.assign({},params)),'MAPPING_CHECK_NOT_MAPPED_COMPONENT':t('errors.businessLogic.MAPPING_CHECK_NOT_MAPPED_COMPONENT',Object.assign({},params)),'UPLOAD_CSV_FILE_NULL_OR_EMPTY':t('errors.businessLogic.UPLOAD_CSV_FILE_NULL_OR_EMPTY',Object.assign({},params)),'FILE_FORMAT_UNSUPPORTED':t('errors.businessLogic.FILE_FORMAT_UNSUPPORTED',Object.assign({},params)),'CSV_HEADER_RETRIEVING_ERROR':t('errors.businessLogic.CSV_HEADER_RETRIEVING_ERROR',Object.assign({},params)),'CSV_PRELOAD':t('errors.businessLogic.CSV_PRELOAD',Object.assign({},params)),'SDMX_TO_CSV_FILE_CONVERTING':t('errors.businessLogic.SDMX_TO_CSV_FILE_CONVERTING',Object.assign({},params)),'LOADING_TEMP_TABLE_NOT_EXISTENT':t('errors.businessLogic.LOADING_TEMP_TABLE_NOT_EXISTENT',Object.assign({},params)),'LOADING_CSV_NOT_MATCHING_MAPPING':t('errors.businessLogic.LOADING_CSV_NOT_MATCHING_MAPPING',Object.assign({},params)),'FILE_IMPORT_ELAPSED_TIME':t('errors.businessLogic.FILE_IMPORT_ELAPSED_TIME',Object.assign({},params)),'FILE_IMPORT_NUM_ROWS':t('errors.businessLogic.FILE_IMPORT_NUM_ROWS',Object.assign({},params)),'FILE_IMPORT_NUM_SERIES':t('errors.businessLogic.FILE_IMPORT_NUM_SERIES',Object.assign({},params)),'FILE_IMPORT_FILE_NAME':t('errors.businessLogic.FILE_IMPORT_FILE_NAME',Object.assign({},params)),'FILE_IMPORT_DUPL_ROW':t('errors.businessLogic.FILE_IMPORT_DUPL_ROW',Object.assign({},params)),'FILE_IMPORT_DUPL_ROW_CONFL':t('errors.businessLogic.FILE_IMPORT_DUPL_ROW_CONFL',Object.assign({},params)),'FILE_IMPORT_WRONG_CROSS_REF':t('errors.businessLogic.FILE_IMPORT_WRONG_CROSS_REF',Object.assign({},params)),'FILE_IMPORT_WRONG_ATTRIBUTE':t('errors.businessLogic.FILE_IMPORT_WRONG_ATTRIBUTE',Object.assign({},params)),'FILE_IMPORT_NO_ASSOCIATED_SERIES':t('errors.businessLogic.FILE_IMPORT_NO_ASSOCIATED_SERIES',Object.assign({},params)),'IMPORT_DATA_IMPORT_TID':t('errors.businessLogic.IMPORT_DATA_IMPORT_TID',Object.assign({},params)),'IMPORT_DATA_IMPORT_NOT_CODED_ATTS':t('errors.businessLogic.IMPORT_DATA_IMPORT_NOT_CODED_ATTS',Object.assign({},params)),'IMPORT_DATA_IMPORT_NOT_CODED_DIMS':t('errors.businessLogic.IMPORT_DATA_IMPORT_NOT_CODED_DIMS',Object.assign({},params)),'IMPORT_DATA_CHECKING_DUPL_ROWS':t('errors.businessLogic.IMPORT_DATA_CHECKING_DUPL_ROWS',Object.assign({},params)),'IMPORT_DATA_CHECKING_WRONG_ATTRIBUTES':t('errors.businessLogic.IMPORT_DATA_CHECKING_WRONG_ATTRIBUTES',Object.assign({},params)),'IMPORT_DATA_CHECKING_WRONG_CROSS_REF':t('errors.businessLogic.IMPORT_DATA_CHECKING_WRONG_CROSS_REF',Object.assign({},params)),'IMPORT_DATA_MAX_NUM_WRONG_ROWS':t('errors.businessLogic.IMPORT_DATA_MAX_NUM_WRONG_ROWS',Object.assign({},params)),'IMPORT_DATA_CHECKING_NO_SERIES_ROWS':t('errors.businessLogic.IMPORT_DATA_CHECKING_NO_SERIES_ROWS',Object.assign({},params)),'IMPORT_DATA_CHECKING_TID_UNIQUENESS':t('errors.businessLogic.IMPORT_DATA_CHECKING_TID_UNIQUENESS',Object.assign({},params)),'IMPORT_DATA_LOADING_SERIES':t('errors.businessLogic.IMPORT_DATA_LOADING_SERIES',Object.assign({},params)),'IMPORT_DATA_LOADING_DATA':t('errors.businessLogic.IMPORT_DATA_LOADING_DATA',Object.assign({},params)),'IMPORT_DATA_CREATING_SERIES_VIEW':t('errors.businessLogic.IMPORT_DATA_CREATING_SERIES_VIEW',Object.assign({},params)),'IMPORT_DATA_CREATING_TEMP_TABLE_VIEW':t('errors.businessLogic.IMPORT_DATA_CREATING_TEMP_TABLE_VIEW',Object.assign({},params)),'GET_TABLE_PREVIEW':t('errors.businessLogic.GET_TABLE_PREVIEW',Object.assign({},params)),'GET_TABLE_COLUMN_PREVIEW':t('errors.businessLogic.GET_TABLE_COLUMN_PREVIEW',Object.assign({},params)),'UPLOAD_FILE_ON_SERVER':t('errors.businessLogic.UPLOAD_FILE_ON_SERVER',Object.assign({},params)),'CUBE_DUPL_COMP_CODES':t('errors.businessLogic.CUBE_DUPL_COMP_CODES',Object.assign({},params)),'DF_RETRIEVING_DFS_ERROR':t('errors.businessLogic.DF_RETRIEVING_DFS_ERROR',Object.assign({},params)),'DF_RETRIEVING_ERROR':t('errors.businessLogic.DF_RETRIEVING_ERROR',Object.assign({},params)),'DF_NOT_FOUND':t('errors.businessLogic.DF_NOT_FOUND',Object.assign({},params)),'DF_WITHOUT_LABEL':t('errors.businessLogic.DF_WITHOUT_LABEL',Object.assign({},params)),'DF_DUPLICATED_CODE':t('errors.businessLogic.DF_DUPLICATED_CODE',Object.assign({},params)),'DF_CATDF_INSERT_ERROR':t('errors.businessLogic.DF_CATDF_INSERT_ERROR',Object.assign({},params)),'DF_NO_LABELS':t('errors.businessLogic.DF_NO_LABELS',Object.assign({},params)),'DF_LABELS_CREATION':t('errors.businessLogic.DF_LABELS_CREATION',Object.assign({},params)),'DF_NO_COLS':t('errors.businessLogic.DF_NO_COLS',Object.assign({},params)),'DF_COL_CREATE':t('errors.businessLogic.DF_COL_CREATE',Object.assign({},params)),'DF_DELETE_ERROR':t('errors.businessLogic.DF_DELETE_ERROR',Object.assign({},params)),'DF_UNK_COLS':t('errors.businessLogic.DF_UNK_COLS',Object.assign({},params)),'MAND_ATTR_NULL':t('errors.businessLogic.MAND_ATTR_NULL',Object.assign({},params)),'DF_FILTER_MISS_COND':t('errors.businessLogic.DF_FILTER_MISS_COND',Object.assign({},params)),'DF_FILTER':t('errors.businessLogic.DF_FILTER',Object.assign({},params)),'NSI_WS_GET_ARTEFACT':t('errors.businessLogic.NSI_WS_GET_ARTEFACT',Object.assign({},params)),'NSI_WS_DF_UNCORRECT':t('errors.businessLogic.NSI_WS_DF_UNCORRECT',Object.assign({},params)),'SDMXML_PRELOAD':t('errors.businessLogic.SDMXML_PRELOAD',Object.assign({},params)),'DF_CREATE_ERROR':t('errors.businessLogic.DF_CREATE_ERROR',Object.assign({},params)),'GET_CONNECTION_STRING':t('errors.businessLogic.GET_CONNECTION_STRING',Object.assign({},params)),'DSD_WITH_ASSOCIATED_CUBES_OR_DF':t('errors.businessLogic.DSD_WITH_ASSOCIATED_CUBES_OR_DF',Object.assign({},params)),'COL_NOT_IN_CUBE':t('errors.businessLogic.COL_NOT_IN_CUBE',Object.assign({},params)),'ERR_TRANSCODING':t('errors.businessLogic.ERR_TRANSCODING',Object.assign({},params)),'DF_TRANSC_FLAG':t('errors.businessLogic.DF_TRANSC_FLAG',Object.assign({},params)),'CONFIG_GET_ERROR':t('errors.businessLogic.CONFIG_GET_ERROR',Object.assign({},params)),'CONFIG_SET_ERROR':t('errors.businessLogic.CONFIG_SET_ERROR',Object.assign({},params)),'CONFIG_NODE_NOT_FOUND':t('errors.businessLogic.CONFIG_NODE_NOT_FOUND',Object.assign({},params)),'DF_PROD_SET':t('errors.businessLogic.DF_PROD_SET',Object.assign({},params)),'DF_PROD_SET_TRANSC':t('errors.businessLogic.DF_PROD_SET_TRANSC',Object.assign({},params)),'DF_UPDATE_IN_PROD':t('errors.businessLogic.DF_UPDATE_IN_PROD',Object.assign({},params)),'DF_UPDATE_ERROR':t('errors.businessLogic.DF_UPDATE_ERROR',Object.assign({},params)),'DF_VIEW_DATA_CREATE':t('errors.businessLogic.DF_VIEW_DATA_CREATE',Object.assign({},params)),'DF_PROD_REM':t('errors.businessLogic.DF_PROD_REM',Object.assign({},params)),'NODE_Sdmx21_CONNECTION_ERROR':t('errors.businessLogic.NODE_Sdmx21_CONNECTION_ERROR',Object.assign({},params)),'NODE_DmApi_CONNECTION_ERROR':t('errors.businessLogic.NODE_DmApi_CONNECTION_ERROR',Object.assign({},params)),'NODE_MaApi_CONNECTION_ERROR':t('errors.businessLogic.NODE_MaApi_CONNECTION_ERROR',Object.assign({},params)),'NODE_DmApi_NOT_FOUND':t('errors.businessLogic.NODE_DmApi_NOT_FOUND',Object.assign({},params)),'CONFIG_NODE_SESSION_NOT_FOUND':t('errors.businessLogic.CONFIG_NODE_SESSION_NOT_FOUND',Object.assign({},params)),'IMPORTXML_FILENOTFOUND':t('errors.businessLogic.IMPORTXML_FILENOTFOUND',Object.assign({},params)),'IMPORTXML_FINAL_ARTEFACT_ERROR':t('errors.businessLogic.IMPORTXML_FINAL_ARTEFACT_ERROR',Object.assign({},params)),'FILE_UPLOAD_FORMAT':t('errors.businessLogic.FILE_UPLOAD_FORMAT',Object.assign({},params)),'DMAPI_NOTCONFIGURATED':t('errors.businessLogic.DMAPI_NOTCONFIGURATED',Object.assign({},params)),'MAAPI_NOTCONFIGURATED':t('errors.businessLogic.MAAPI_NOTCONFIGURATED',Object.assign({},params)),'NSIAPI_MAAPI_DIFFERENT_DB':t('errors.businessLogic.NSIAPI_MAAPI_DIFFERENT_DB',Object.assign({},params)),'MASID_INVALID':t('errors.businessLogic.MASID_INVALID',Object.assign({},params)),'IMPORTCSVITEM_FILE_READERROR':t('errors.businessLogic.IMPORTCSVITEM_FILE_READERROR',Object.assign({},params)),'IMPORTCSVITEM_FILE_DATAERROR':t('errors.businessLogic.IMPORTCSVITEM_FILE_DATAERROR',Object.assign({},params)),'IMPORTCSVITEM_FILE_IDERROR':t('errors.businessLogic.IMPORTCSVITEM_FILE_IDERROR',Object.assign({},params)),'IMPORTCSVITEM_FILE_NAMEERROR':t('errors.businessLogic.IMPORTCSVITEM_FILE_NAMEERROR',Object.assign({},params)),'USER_NOT_PRESENT':t('errors.businessLogic.USER_NOT_PRESENT',Object.assign({},params)),'ARTEFACTS_EMPTY':t('errors.businessLogic.ARTEFACTS_EMPTY',Object.assign({},params)),'SEARCH_METADATASET_ERROR':t('errors.businessLogic.SEARCH_METADATASET_ERROR',Object.assign({},params)),'GET_METADATASET_ERROR':t('errors.businessLogic.GET_METADATASET_ERROR',Object.assign({},params)),'SEARCH_REPORT_ERROR':t('errors.businessLogic.SEARCH_REPORT_ERROR',Object.assign({},params)),'GET_MSD_FOR_REPORT':t('errors.businessLogic.GET_MSD_FOR_REPORT',Object.assign({},params)),'GET_REPORT_ERROR':t('errors.businessLogic.GET_REPORT_ERROR',Object.assign({},params)),'UPDATE_METADATASET_ERROR':t('errors.businessLogic.UPDATE_METADATASET_ERROR',Object.assign({},params)),'UPDATE_REPORT_ERROR':t('errors.businessLogic.UPDATE_REPORT_ERROR',Object.assign({},params)),'CREATE_METADATASET_ERROR':t('errors.businessLogic.CREATE_METADATASET_ERROR',Object.assign({},params)),'UPSERT_REPORT_ERROR':t('errors.businessLogic.UPSERT_REPORT_ERROR',Object.assign({},params)),'DELETE_METADATASET_ERROR':t('errors.businessLogic.DELETE_METADATASET_ERROR',Object.assign({},params)),'DELETE_REPORT_ERROR':t('errors.businessLogic.DELETE_REPORT_ERROR',Object.assign({},params)),'SUPERUSER_PASSWORD_NOTMATCH':t('errors.businessLogic.SUPERUSER_PASSWORD_NOTMATCH',Object.assign({},params)),'NODE_ID_NOT_FOUND':t('errors.businessLogic.NODE_ID_NOT_FOUND',Object.assign({},params)),'INVALID_AUTHDB_CONFIGURATION':t('errors.businessLogic.INVALID_AUTHDB_CONFIGURATION',Object.assign({},params)),'DDB_CONFIG_ERROR':t('errors.businessLogic.DDB_CONFIG_ERROR',Object.assign({},params)),'CHECKAUTHDB_UNKNOW_ERROR':t('errors.businessLogic.CHECKAUTHDB_UNKNOW_ERROR',Object.assign({},params)),'DATAFLOW_DOWNLOAD_NOTINPRODUCTION':t('errors.businessLogic.DATAFLOW_DOWNLOAD_NOTINPRODUCTION',Object.assign({},params)),'DATAFLOW_DOWNLOAD_NOTFOUND':t('errors.businessLogic.DATAFLOW_DOWNLOAD_NOTFOUND',Object.assign({},params)),'DATAFLOW_DOWNLOAD_MA_NOTFOUND':t('errors.businessLogic.DATAFLOW_DOWNLOAD_MA_NOTFOUND',Object.assign({},params)),'DF_WITH_ASSOCIATED_DDB_DF':t('errors.businessLogic.DF_WITH_ASSOCIATED_DDB_DF',Object.assign({},params)),'DDBRESET_ERROR':t('errors.businessLogic.DDBRESET_ERROR',Object.assign({},params)),'DEL_CONT_CONSTRAINTS':t('errors.businessLogic.DEL_CONT_CONSTRAINTS',Object.assign({},params)),'ERR_GEN_CONT_CONSTRAINTS':t('errors.businessLogic.ERR_GEN_CONT_CONSTRAINTS',Object.assign({},params)),'DF_CC_FLAG':t('errors.businessLogic.DF_CC_FLAG',Object.assign({},params)),'DF_TRANSC_REM':t('errors.businessLogic.DF_TRANSC_REM',Object.assign({},params)),'WSDL_NOT_FOUND':t('errors.businessLogic.WSDL_NOT_FOUND',Object.assign({},params)),'DF_MS_SET':t('errors.businessLogic.DF_MS_SET',Object.assign({},params)),'DF_MS_REM':t('errors.businessLogic.DF_MS_REM',Object.assign({},params)),'FINAL_ARTEFACTS_EXIST':t('errors.businessLogic.FINAL_ARTEFACTS_EXIST',Object.assign({},params)),'ITEM_DUPLICATE':t('errors.businessLogic.ITEM_DUPLICATE',Object.assign({},params)),'CANT_DELETE_ITEM_WITH_CHILDREN':t('errors.businessLogic.CANT_DELETE_ITEM_WITH_CHILDREN',Object.assign({},params)),'CATEGORYSCHEME_WITH_CATEGORIZATION':t('errors.businessLogic.CATEGORYSCHEME_WITH_CATEGORIZATION',Object.assign({},params)),'DATAFLOW_DOWNLOAD_MISSING_MAPPINGSET':t('errors.businessLogic.DATAFLOW_DOWNLOAD_MISSING_MAPPINGSET',Object.assign({},params)),'DF_WITH_ASSOCIATED_METADATA':t('errors.businessLogic.DF_WITH_ASSOCIATED_METADATA',Object.assign({},params)),'SWITCHING_FACT_TABLES':t('errors.businessLogic.SWITCHING_FACT_TABLES',Object.assign({},params)),'DISEMBARGO_CUBE':t('errors.businessLogic.DISEMBARGO_CUBE',Object.assign({},params)),'DUPL_ROWS_UNRES_CONFLICT':t('errors.businessLogic.DUPL_ROWS_UNRES_CONFLICT',Object.assign({},params)),'UPGRADECUBE_ERROR':t('errors.businessLogic.UPGRADECUBE_ERROR',Object.assign({},params)),'IMPORTCSVITEM_FILE_HEADER_IDERROR':t('errors.businessLogic.IMPORTCSVITEM_FILE_HEADER_IDERROR',Object.assign({},params)),'IMPORTCSVITEM_FILE_HEADER_NAMEERROR':t('errors.businessLogic.IMPORTCSVITEM_FILE_HEADER_NAMEERROR',Object.assign({},params)),'COMPAREITEMS_DIFFERENT_TYPE':t('errors.businessLogic.COMPAREITEMS_DIFFERENT_TYPE',Object.assign({},params)),'COMPAREITEMS_SOURCETOOMANY':t('errors.businessLogic.COMPAREITEMS_SOURCETOOMANY',Object.assign({},params)),'COMPAREITEMS_TARGETTOOMANY':t('errors.businessLogic.COMPAREITEMS_TARGETTOOMANY',Object.assign({},params)),'DELETE_METADATASET_WITH_REPORT':t('errors.businessLogic.DELETE_METADATASET_WITH_REPORT',Object.assign({},params)),'METADATAFLOW_WITH_ASSOCIATED_METADATASET':t('errors.businessLogic.METADATAFLOW_WITH_ASSOCIATED_METADATASET',Object.assign({},params)),'NODE_FORBIDDEN':t('errors.businessLogic.NODE_FORBIDDEN',Object.assign({},params)),'NODE_UNAUTHORIZED':t('errors.businessLogic.NODE_UNAUTHORIZED',Object.assign({},params)),'EMPTY_CUBE':t('errors.businessLogic.EMPTY_CUBE',Object.assign({},params)),'LOAD_GEN_COMPLEX_REPORT':t('errors.businessLogic.LOAD_GEN_COMPLEX_REPORT',Object.assign({},params)),'GENERATEREPORTDSD_TARGETNOTFOUND':t('errors.businessLogic.GENERATEREPORTDSD_TARGETNOTFOUND',Object.assign({},params)),'GENERATEREPORTDSD_SOURCENOTFOUND':t('errors.businessLogic.GENERATEREPORTDSD_SOURCENOTFOUND',Object.assign({},params)),'NOTFOUNDTARTEFACT':t('errors.businessLogic.NOTFOUNDTARTEFACT',Object.assign({},params)),'DERIVED_CODELIST_REMOVE_ITEM':t('errors.businessLogic.DERIVED_CODELIST_REMOVE_ITEM',Object.assign({},params)),'DCS_CATEGORYNOTFOUND':t('errors.businessLogic.DCS_CATEGORYNOTFOUND',Object.assign({},params)),'DCS_UPDATE_PARENTNOTFOUND':t('errors.businessLogic.DCS_UPDATE_PARENTNOTFOUND',Object.assign({},params)),'DCS_DELETE_CATWITHCHILDREN':t('errors.businessLogic.DCS_DELETE_CATWITHCHILDREN',Object.assign({},params)),'DCS_DELETE_CATWITHCUBES':t('errors.businessLogic.DCS_DELETE_CATWITHCUBES',Object.assign({},params)),'DCS_DELETE_ERROR':t('errors.businessLogic.DCS_DELETE_ERROR',Object.assign({},params)),'LOADING_CONCURRENT_UPLOAD_SAME_CUBE':t('errors.businessLogic.LOADING_CONCURRENT_UPLOAD_SAME_CUBE',Object.assign({},params)),'DRAFT_REPORT_PUBLICATION':t('errors.businessLogic.DRAFT_REPORT_PUBLICATION',Object.assign({},params)),'DCS_UPDATE_CATEGORYNOTFOUND':t('errors.businessLogic.DCS_UPDATE_CATEGORYNOTFOUND',Object.assign({},params)),'DCS_UPDATE_ERROR':t('errors.businessLogic.DCS_UPDATE_ERROR',Object.assign({},params)),'DCS_INSERT_DUPLICATECODE':t('errors.businessLogic.DCS_INSERT_DUPLICATECODE',Object.assign({},params)),'DCS_INSERT_PARENTNOTFOUND':t('errors.businessLogic.DCS_INSERT_PARENTNOTFOUND',Object.assign({},params)),'DCS_INSERT_ERROR':t('errors.businessLogic.DCS_INSERT_ERROR',Object.assign({},params)),'DSD_WITH_NON_FINAL_ARTEFACTS':t('errors.businessLogic.DSD_WITH_NON_FINAL_ARTEFACTS',Object.assign({},params)),'CUBE_ATTDSLEV_TABLE_CREATE':t('errors.businessLogic.CUBE_ATTDSLEV_TABLE_CREATE',Object.assign({},params)),'IMPORT_DS_LEV_ATTRIBUTES':t('errors.businessLogic.IMPORT_DS_LEV_ATTRIBUTES',Object.assign({},params)),'ATTS_UNRES_CONFLICT':t('errors.businessLogic.ATTS_UNRES_CONFLICT',Object.assign({},params)),'FILE_IMPORT_WRONG_CODED_OBS_VALUE':t('errors.businessLogic.FILE_IMPORT_WRONG_CODED_OBS_VALUE',Object.assign({},params)),'IMPORT_DATA_CHECKING_CODED_OBS_VALUE':t('errors.businessLogic.IMPORT_DATA_CHECKING_CODED_OBS_VALUE',Object.assign({},params)),'MASID_NOTPRESENT':t('errors.businessLogic.MASID_NOTPRESENT',Object.assign({},params)),'AGENCY_ALREADY_IN_CONFIG':t('errors.businessLogic.AGENCY_ALREADY_IN_CONFIG',Object.assign({},params)),'ATTR_FILE_WRONG_FORMAT':t('errors.businessLogic.ATTR_FILE_WRONG_FORMAT',Object.assign({},params)),'LOC_CODES_REMOVE':t('errors.businessLogic.LOC_CODES_REMOVE',Object.assign({},params)),'FILE_IMPORT_WRONG_TIMEPERIOD_ATTACH':t('errors.businessLogic.FILE_IMPORT_WRONG_TIMEPERIOD_ATTACH',Object.assign({},params)),'URL_MAX_SIZE':t('errors.businessLogic.URL_MAX_SIZE',Object.assign({},params)),'DATABROWSER_NOT_FOUND':t('errors.businessLogic.DATABROWSER_NOT_FOUND',Object.assign({},params)),'WRONG_COMPLEX_MAPPING':t('errors.businessLogic.WRONG_COMPLEX_MAPPING',Object.assign({},params)),'EXCEL_CONV_ERROR':t('errors.businessLogic.EXCEL_CONV_ERROR',Object.assign({},params)),'METADATASET_ID_EXISTS':t('errors.businessLogic.METADATASET_ID_EXISTS',Object.assign({},params)),'MSD_DIFFERENT_ERROR':t('errors.businessLogic.MSD_DIFFERENT_ERROR',Object.assign({},params)),'IMPORT_REPORT_ERROR':t('errors.businessLogic.IMPORT_REPORT_ERROR',Object.assign({},params)),'IMPORT_DSD_FROM_DATAFLOW':t('errors.businessLogic.IMPORT_DSD_FROM_DATAFLOW',Object.assign({},params)),'ERR_PARAMETERS':t('errors.businessLogic.ERR_PARAMETERS',Object.assign({},params)),'CL_FROM_TABLE_WRONG_FORMAT':t('errors.businessLogic.CL_FROM_TABLE_WRONG_FORMAT',Object.assign({},params)),'CL_FROM_TABLE_WRONG_FORMAT_TABLE':t('errors.businessLogic.CL_FROM_TABLE_WRONG_FORMAT_TABLE',Object.assign({},params)),'PARTIAL_CL_NOT_SUPPORTED_OR_NOT_FOUND':t('errors.businessLogic.PARTIAL_CL_NOT_SUPPORTED_OR_NOT_FOUND',Object.assign({},params)),'UPGRADECUBE_NOTCOMPATIBLE':t('errors.businessLogic.UPGRADECUBE_NOTCOMPATIBLE',Object.assign({},params)),'MAWS_ASSOCIATE_DF_USER':t('errors.businessLogic.MAWS_ASSOCIATE_DF_USER',Object.assign({},params)),'CCFROMFILE_INVALIDCC':t('errors.businessLogic.CCFROMFILE_INVALIDCC',Object.assign({},params)),'GENCC_NOMATCH':t('errors.businessLogic.GENCC_NOMATCH',Object.assign({},params)),'TABLEFROMCC_INVALIDCC':t('errors.businessLogic.TABLEFROMCC_INVALIDCC',Object.assign({},params)),'IMPORT_DATA_CHECKING_CC':t('errors.businessLogic.IMPORT_DATA_CHECKING_CC',Object.assign({},params)),'CC_CHECK':t('errors.businessLogic.CC_CHECK',Object.assign({},params)),'FILE_IMPORT_WRONG_CC_CHECK':t('errors.businessLogic.FILE_IMPORT_WRONG_CC_CHECK',Object.assign({},params)),'IMPORT_ATTR_WRONG_FORMAT':t('errors.businessLogic.IMPORT_ATTR_WRONG_FORMAT',Object.assign({},params)),'PASSW_REGEX':t('errors.businessLogic.PASSW_REGEX',Object.assign({},params)),'PASSW_SAME':t('errors.businessLogic.PASSW_SAME',Object.assign({},params)),'PASSW_CONTAINS_USER':t('errors.businessLogic.PASSW_CONTAINS_USER',Object.assign({},params)),'OP_EMPTY_CUBE':t('errors.businessLogic.OP_EMPTY_CUBE',Object.assign({},params)),'AST_TERR_CL':t('errors.businessLogic.AST_TERR_CL',Object.assign({},params)),'TR01-PARAM_OUTDIR_NULL_OR_EMPTY':t('errors.businessLogic.TR01-PARAM_OUTDIR_NULL_OR_EMPTY',Object.assign({},params)),'TR02-PARAM_COMPLETEFILENAME_NULL_OR_EMPTY':t('errors.businessLogic.TR02-PARAM_COMPLETEFILENAME_NULL_OR_EMPTY',Object.assign({},params)),'TR04-DIR_OUTDIR_NOT_EXIST':t('errors.businessLogic.TR04-DIR_OUTDIR_NOT_EXIST',Object.assign({},params)),'TR05-COMPLETEFILENAME_NOT_EXIST':t('errors.businessLogic.TR05-COMPLETEFILENAME_NOT_EXIST',Object.assign({},params)),'TR06-FILE_EXTENSION_ERROR':t('errors.businessLogic.TR06-FILE_EXTENSION_ERROR',Object.assign({},params)),'TR07-TRASCCSVCOMPLETEFILENAME_NOT_EXIST':t('errors.businessLogic.TR07-TRASCCSVCOMPLETEFILENAME_NOT_EXIST',Object.assign({},params)),'TR08-CSV_ROW_EMPTY':t('errors.businessLogic.TR08-CSV_ROW_EMPTY',Object.assign({},params)),'TR09-CSV_FILE_FORMAT_ERROR':t('errors.businessLogic.TR09-CSV_FILE_FORMAT_ERROR',Object.assign({},params)),'TR10-OBS_VALUE_NOT_NUMERIC':t('errors.businessLogic.TR10-OBS_VALUE_NOT_NUMERIC',Object.assign({},params)),'TR11-OBS_VALUE_POSITION_NOT_FOUND':t('errors.businessLogic.TR11-OBS_VALUE_POSITION_NOT_FOUND',Object.assign({},params)),'TR12-ROW_EMPTY_ON_AGGREGATION':t('errors.businessLogic.TR12-ROW_EMPTY_ON_AGGREGATION',Object.assign({},params)),'TR13-HEADER_TERRITORY_NOT_FOUND':t('errors.businessLogic.TR13-HEADER_TERRITORY_NOT_FOUND',Object.assign({},params)),'TR15-PARAM_TERRITORYNAMES_NULL_OR_EMPTY':t('errors.businessLogic.TR15-PARAM_TERRITORYNAMES_NULL_OR_EMPTY',Object.assign({},params)),'TR14-HEADER_TIME_PERIOD_NOT_FOUND':t('errors.businessLogic.TR14-HEADER_TIME_PERIOD_NOT_FOUND',Object.assign({},params)),'TR16-ERROR-ON-WRITE-LOG':t('errors.businessLogic.TR16-ERROR-ON-WRITE-LOG',Object.assign({},params)),'TR51-FILE_SORT_IS_NULL':t('errors.businessLogic.TR51-FILE_SORT_IS_NULL',Object.assign({},params)),'TR52-DIRECTORY_IS_NULL':t('errors.businessLogic.TR52-DIRECTORY_IS_NULL',Object.assign({},params)),'TR53-FILE_TO_SORT_EMPTY':t('errors.businessLogic.TR53-FILE_TO_SORT_EMPTY',Object.assign({},params)),'TR54-PROBLEMS_DURING_SORTING':t('errors.businessLogic.TR54-PROBLEMS_DURING_SORTING',Object.assign({},params)),'TR99-TRANSCODING_GENERIC_ERROR':t('errors.businessLogic.TR99-TRANSCODING_GENERIC_ERROR',Object.assign({},params)),'CAT_NOT_FOUND':t('errors.businessLogic.CAT_NOT_FOUND',Object.assign({},params)),'TR17-TRASCCSVCOMPLETEFILENAME_NOT_VALID':t('errors.businessLogic.TR17-TRASCCSVCOMPLETEFILENAME_NOT_VALID',Object.assign({},params)),'DF_WITH_CC':t('errors.businessLogic.DF_WITH_CC',Object.assign({},params)),'DF_FREQ_TPER_ERR':t('errors.businessLogic.DF_FREQ_TPER_ERR',Object.assign({},params)),'MAPPING_DELETE_IN_SEQMAP':t('errors.businessLogic.MAPPING_DELETE_IN_SEQMAP',Object.assign({},params)),'SEQMAPPING_RETRIEVING_ERROR':t('errors.businessLogic.SEQMAPPING_RETRIEVING_ERROR',Object.assign({},params)),'SEQMAPPINGS_RETRIEVING_ERROR':t('errors.businessLogic.SEQMAPPINGS_RETRIEVING_ERROR',Object.assign({},params)),'SEQMAPPING_NOT_EXISTENT':t('errors.businessLogic.SEQMAPPING_NOT_EXISTENT',Object.assign({},params)),'SEQMAPPING_EMPTY':t('errors.businessLogic.SEQMAPPING_EMPTY',Object.assign({},params)),'SEQMAPPING_CREATE_ERROR':t('errors.businessLogic.SEQMAPPING_CREATE_ERROR',Object.assign({},params)),'SEQMAPPING_DELETE_ERROR':t('errors.businessLogic.SEQMAPPING_DELETE_ERROR',Object.assign({},params)),'SEQMAPPING_CREATE_DUPLICATED_NAME':t('errors.businessLogic.SEQMAPPING_CREATE_DUPLICATED_NAME',Object.assign({},params)),'SEQMAPPING_MAP_NOTFOUND':t('errors.businessLogic.SEQMAPPING_MAP_NOTFOUND',Object.assign({},params)),'SEQMAPPING_DIFF_CUBE':t('errors.businessLogic.SEQMAPPING_DIFF_CUBE',Object.assign({},params)),'SEQMAPPING_NOT_EXCEL':t('errors.businessLogic.SEQMAPPING_NOT_EXCEL',Object.assign({},params)),'MAPPING_DELETE_ERROR':t('errors.businessLogic.MAPPING_DELETE_ERROR',Object.assign({},params)),'CC_NOT_FOUND':t('errors.businessLogic.CC_NOT_FOUND',Object.assign({},params)),'CC_NOT_COHERENT_CUBE':t('errors.businessLogic.CC_NOT_COHERENT_CUBE',Object.assign({},params)),'CREATE_DDBDATAFLOW_HEADERFAIL':t('errors.businessLogic.CREATE_DDBDATAFLOW_HEADERFAIL',Object.assign({},params)),'CL_WRONG_CODE_FORMAT':t('errors.businessLogic.CL_WRONG_CODE_FORMAT',Object.assign({},params))};};return errorCodesTranslations(t!==undefined?t:function(str){return str;});};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(1209);
var enumBugKeys = __webpack_require__(537);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1267);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Collapse = _interopRequireDefault(__webpack_require__(1268));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Collapse["default"];
exports["default"] = _default;

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollTo; });
var SCROLL_TO='SCROLL_TO';var scrollTo=function scrollTo(element){return{type:SCROLL_TO,element:element};};

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_TWO_THIRDS"]}};var ArtefactSummary=function ArtefactSummary(_ref){var t=_ref.t,id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,{className:'advanced-form'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.id.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{value:id,disabled:true}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.agencyID.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{value:agencyID,disabled:true}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('data.artefact.version.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{value:version,disabled:true}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* translate */])()(ArtefactSummary));

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ITEM_FORM_MODE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ITEM_FORM_MODE_EDIT_PARENT_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ITEM_FORM_MODE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ITEM_FORM_MODE_CREATE_PARENT_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ITEM_FORM_MODE_READ; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__annotations_form__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__multilanguage_zoomable_textarea__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__multilanguage_input_number__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__perf_input__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__ = __webpack_require__(37);
var mapPropsToFields=function mapPropsToFields(_ref){var item=_ref.item,annotationsConfig=_ref.annotationsConfig;return{id:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:item&&item.id?item.id:null}),parent:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:item&&item.parent?item.parent:null}),order:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:item&&item.order?__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.mapValues(item.order,function(order){return order>0?Math.ceil(Number(order)):"";}):""}),name:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:item&&item.name?item.name:null}),description:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:item&&item.description?item.description:null}),layoutAnnotationFullName:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:item&&item.annotations?Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["J" /* getLayoutAnnotationFullname */])(item.annotations,annotationsConfig):null})};};var onFieldsChange=function onFieldsChange(props,fields){var newFields=__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;});if(newFields.layoutAnnotationFullName){var newAnnotations=__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.cloneDeep(props.item.annotations);newAnnotations=Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["_3" /* setLayoutAnnotationFullName */])(newAnnotations,props.annotationsConfig,newFields.layoutAnnotationFullName);props.onChange({annotations:newAnnotations});}else{props.onChange(newFields);}};var formItemLayout={labelCol:{span:9},wrapperCol:{span:15}};var rowStyle={marginBottom:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"],marginLeft:24,marginRight:24};var ITEM_FORM_MODE_EDIT='ITEM_FORM_MODE_EDIT';var ITEM_FORM_MODE_EDIT_PARENT_DISABLED='ITEM_FORM_MODE_EDIT_PARENT_DISABLED';var ITEM_FORM_MODE_CREATE='ITEM_FORM_MODE_CREATE';var ITEM_FORM_MODE_CREATE_PARENT_DISABLED='ITEM_FORM_MODE_CREATE_PARENT_DISABLED';var ITEM_FORM_MODE_READ='ITEM_FORM_MODE_READ';var ItemForm=function ItemForm(_ref3){var t=_ref3.t,form=_ref3.form,item=_ref3.item,_ref3$mode=_ref3.mode,mode=_ref3$mode===undefined?ITEM_FORM_MODE_CREATE:_ref3$mode,onChange=_ref3.onChange,itemsParentListShow=_ref3.itemsParentListShow,itemsParentListUnset=_ref3.itemsParentListUnset;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:rowStyle},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t("data.item.id.label"),validateStatus:item&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,item.id).help?"warning":null,help:item&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,item.id).help},formItemLayout),form.getFieldDecorator("id",{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,disabled:mode!==ITEM_FORM_MODE_CREATE&&mode!==ITEM_FORM_MODE_CREATE_PARENT_DISABLED,title:form.getFieldValue("id"),style:{textTransform:"uppercase"}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("data.item.parent.label")},formItemLayout),form.getFieldDecorator("parent",{getValueFromEvent:function getValueFromEvent(val){return val.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__selector__["a" /* default */],{disabled:mode===ITEM_FORM_MODE_CREATE_PARENT_DISABLED||mode===ITEM_FORM_MODE_EDIT_PARENT_DISABLED||mode===ITEM_FORM_MODE_READ,selectTitle:t('components.itemForm.selector.buttons.select.title'),resetTitle:t('components.itemForm.selector.buttons.reset.title'),onSelect:itemsParentListShow,onReset:itemsParentListUnset,onDetail:null,render:function render(v){return(v||"").toUpperCase();}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("data.item.order.label")},formItemLayout),form.getFieldDecorator("order")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_20__multilanguage_input_number__["a" /* default */],disabled:mode===ITEM_FORM_MODE_READ,title:form.getFieldValue("order"),min:0}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{className:"form-item-required",label:t("data.item.name.label"),labelCol:{span:3},wrapperCol:{span:21}},form.getFieldDecorator("name")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_15__multilanguage_input__["a" /* default */],disabled:mode===ITEM_FORM_MODE_READ,title:form.getFieldValue("name")}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t("data.item.description.label"),labelCol:{span:3},wrapperCol:{span:21}},form.getFieldDecorator("description")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_18__multilanguage_zoomable_textarea__["a" /* default */],disabled:mode===ITEM_FORM_MODE_READ,title:form.getFieldValue("description")}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t("data.item.layoutAnnotationFullName.label"),labelCol:{span:3},wrapperCol:{span:21}},form.getFieldDecorator("layoutAnnotationFullName")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_18__multilanguage_zoomable_textarea__["a" /* default */],disabled:mode===ITEM_FORM_MODE_READ,title:form.getFieldValue("layoutAnnotationFullName")}))))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__annotations_form__["a" /* default */],{annotations:item?item.annotations:null,onChange:onChange,disabled:mode===ITEM_FORM_MODE_READ}));};/* harmony default export */ __webpack_exports__["f"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ItemForm));

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_css__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__file_system_tree__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scenes_configuration_nodes_config_node_GeneralForm__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__item_list__ = __webpack_require__(84);
var TREE_NODE_COLOR_LAYOUT_ANNOTATION_DEFAULT="blue";var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,maxTreeNodes:state.config.userInterface.maxTreeNodes,endpoints:state.config.nodes,endpointId:state.app.endpointId,username:state.app.user.username};};var onDropHandler=function onDropHandler(ev,onDrop,artefact,itemTree,itemsOrderAnnotationType,lang,cutItem,t,isNotHierarchical){var pos=ev.node.props.pos.split('-');var dropPos=ev.dropPosition-Number(pos[pos.length-1]);var newParent=isNotHierarchical?ev.node.props["data-node"].parent:ev.dropToGap?ev.node.props["data-node"].parent:ev.node.props["data-node"].id;var newOrder=ev.dropToGap?dropPos>0?Number(ev.node.props["data-node"].order[lang])+0.1// dropPos = 1 => drag on bottom node gap
:Number(ev.node.props["data-node"].order[lang])-0.1// dropPos = -1 => drag on top node gap
:isNotHierarchical?Number(ev.node.props["data-node"].order[lang])+0.1:Number.MAX_VALUE;onDrop(ev.dragNode.props["data-node"],newParent,String(newOrder),artefact,itemTree,itemsOrderAnnotationType,lang,cutItem,t);};var onPaginatedDropHandler=function onPaginatedDropHandler(ev,onPaginatedDrop,artefactTriplet,lang,autoSave,itemTree,cutItem,t){var pos=ev.node.props.pos.split('-');var dropPos=ev.dropPosition-Number(pos[pos.length-1]);var newParentId=ev.dropToGap?ev.node.props["data-node"].parent:ev.node.props["data-node"].id;var gapPos=ev.dropToGap?dropPos>0?{before:null,after:ev.node.props["data-node"].id// dropPos = 1 => drag on bottom node gap
}:{before:ev.node.props["data-node"].id,after:null// dropPos = -1 => drag on top node gap
}:{before:null,after:null};onPaginatedDrop(artefactTriplet,ev.dragNode.props["data-node"].id,newParentId,gapPos.before,gapPos.after,lang,autoSave,itemTree,cutItem,t);};var ItemsViewer=function ItemsViewer(_ref){var t=_ref.t,permissions=_ref.permissions,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,artefact=_ref.artefact,artefactTriplet=_ref.artefactTriplet,itemPage=_ref.itemPage,fetchPage=_ref.fetchPage,fetchPageParams=_ref.fetchPageParams,fetchPageParamsUpdate=_ref.fetchPageParamsUpdate,itemTree=_ref.itemTree,fetchTree=_ref.fetchTree,itemCount=_ref.itemCount,childrenKey=_ref.childrenKey,selectedItem=_ref.selectedItem,cutItem=_ref.cutItem,itemsViewMode=_ref.itemsViewMode,itemsOrderAnnotationType=_ref.itemsOrderAnnotationType,maxOrder=_ref.maxOrder,onCreate=_ref.onCreate,onPaginatedCreate=_ref.onPaginatedCreate,onDelete=_ref.onDelete,onPaginatedDelete=_ref.onPaginatedDelete,onDetailShow=_ref.onDetailShow,onSelect=_ref.onSelect,_onDrop=_ref.onDrop,onPaginatedDrop=_ref.onPaginatedDrop,onCut=_ref.onCut,onPaste=_ref.onPaste,onPaginatedPaste=_ref.onPaginatedPaste,onAnnotationsShow=_ref.onAnnotationsShow,onLayoutAnnotationsShow=_ref.onLayoutAnnotationsShow,onSetDefault=_ref.onSetDefault,onUnsetDefault=_ref.onUnsetDefault,onViewModeChange=_ref.onViewModeChange,onImportFormShow=_ref.onImportFormShow,autoSave=_ref.autoSave,isFileSystemTreeVisible=_ref.isFileSystemTreeVisible,onFileSystemtreeShow=_ref.onFileSystemtreeShow,onFileSystemtreeHide=_ref.onFileSystemtreeHide,fileSystemSelectedItem=_ref.fileSystemSelectedItem,onFileSystemSelect=_ref.onFileSystemSelect,maxTreeNodes=_ref.maxTreeNodes,unsavedChange=_ref.unsavedChange,rebuildDb=_ref.rebuildDb,endpoints=_ref.endpoints,endpointId=_ref.endpointId,username=_ref.username,isNotHierarchical=_ref.isNotHierarchical,isEditDisabled=_ref.isEditDisabled,isCallDisabled=_ref.isCallDisabled,onSetDefaultOrder=_ref.onSetDefaultOrder,onPaginatedSetDefaultOrder=_ref.onPaginatedSetDefaultOrder,onAddAgencyToConfig=_ref.onAddAgencyToConfig;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;var userHasPermissionsToEdit=permissions&&artefactTriplet&&permissions.agencies.filter(function(agency){return agency===artefactTriplet.agencyID;}).length>0&&!isEditDisabled;var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;var customAnnotationsConfig=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].annotationTabs.tabs;var treeNodeActions=[function(node){return onDetailShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["l" /* BUTTON_DETAIL */],{title:userHasPermissionsToEdit?t('components.itemList.actions.edit.title'):t('components.itemList.actions.view.title'),onClick:function onClick(){return onDetailShow(node);}}):null;},function(node){return(onCreate||onPaginatedCreate)&&userHasPermissionsToEdit&&!isNotHierarchical?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["f" /* BUTTON_CREATE */],{title:t('components.itemList.actions.add.title'),onClick:function onClick(){return onPaginatedCreate?onPaginatedCreate(node.id,null,lang):onCreate(node.id,String(maxOrder+1),lang,itemsOrderAnnotationType);}}):null;},function(node){return(onDelete||onPaginatedDelete)&&userHasPermissionsToEdit?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('components.itemList.actions.delete.title'),onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('components.itemList.modals.confirms.delete.title',{id:node.id}),onOk:function onOk(){onPaginatedDelete?onPaginatedDelete(artefactTriplet,node.id,autoSave,itemTree,cutItem,lang,t):node[childrenKey]&&node[childrenKey].length>0||cutItem&&node.id===cutItem.parent?__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning({title:t('components.itemList.modals.warning.delete.title')}):onDelete(artefact,itemTree,node,cutItem,lang,t,itemsOrderAnnotationType);},cancelText:t('commons.buttons.cancel.title')});},disabled:artefact&&artefact.isFinal}):null;},function(node){return(onPaste||onPaginatedPaste)&&onCut&&userHasPermissionsToEdit&&!cutItem?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["h" /* BUTTON_CUT */],{title:t('components.itemList.actions.cut.title'),onClick:function onClick(){return onCut(node);}}):null;},function(node){return(onPaste||onPaginatedPaste)&&onCut&&userHasPermissionsToEdit&&cutItem&&!isNotHierarchical?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["x" /* BUTTON_PASTE */],{title:t('components.itemList.actions.pasteAsChild.title'),onClick:function onClick(){return onPaginatedPaste?onPaginatedPaste(artefactTriplet,lang,cutItem.id,node.id,null,autoSave):onPaste(cutItem,node,null,artefact,itemTree,lang,itemsOrderAnnotationType);}}):null;},function(node){return(onPaste||onPaginatedPaste)&&onCut&&userHasPermissionsToEdit&&cutItem?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["y" /* BUTTON_PASTE_AS_BROTHER */],{title:t('components.itemList.actions.pasteAsBrother.title'),onClick:function onClick(){return onPaginatedPaste?onPaginatedPaste(artefactTriplet,lang,cutItem.id,node.parent,node.id,autoSave):onPaste(cutItem,null,node,artefact,itemTree,lang,itemsOrderAnnotationType);}}):null;},function(node){return onSetDefault&&onUnsetDefault&&userHasPermissionsToEdit?Object(__WEBPACK_IMPORTED_MODULE_27__utils_annotations__["F" /* getLayoutAnnotationDefaultForCodelist */])(node.annotations,annotationsConfig)?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["H" /* BUTTON_UNSET_DEFAULT */],{title:t('components.itemList.actions.unsetDefault.title'),onClick:function onClick(){return onUnsetDefault(node);}}):Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["D" /* BUTTON_SET_DEFAULT */],{title:t('components.itemList.actions.setDefault.title'),onClick:function onClick(){return onSetDefault(node);}}):null;},function(node){return onAddAgencyToConfig?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["a" /* BUTTON_ADD_AGENCY_TO_CONFIG */],{title:t('components.itemList.actions.addAgencyToConfig.title'),onClick:function onClick(){return onAddAgencyToConfig(node);}}):null;}];var treeNodeFixedActions=[function(_ref2){var annotations=_ref2.annotations;var customAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_27__utils_annotations__["r" /* countCustomAnnotations */])(annotations,customAnnotationsConfig);return onAnnotationsShow&&customAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["g" /* BUTTON_CUSTOM_ANNOTATIONS */],{title:t('commons.actions.customAnnotations.title')+": "+customAnnotationsCount,onClick:function onClick(){return onAnnotationsShow(annotations);}}):null;},function(_ref3){var annotations=_ref3.annotations;return username?function(){var layoutAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_27__utils_annotations__["s" /* countLayoutAnnotations */])(annotations,annotationsConfig);return layoutAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["u" /* BUTTON_LAYOUT_ANNOTATIONS */],{title:t('commons.actions.layoutAnnotations.title')+": "+layoutAnnotationsCount,onClick:function onClick(){return onLayoutAnnotationsShow(annotations);}}):null;}():null;}];var leftActions=__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"start",gutter:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_SM"]},onViewModeChange&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group,{value:itemsViewMode,onChange:function onChange(_ref4){var target=_ref4.target;return target.value===__WEBPACK_IMPORTED_MODULE_26__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]&&itemCount>maxTreeNodes?__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t('components.itemList.modals.treeViewModeUnavailable.title'),content:t('components.itemList.modals.treeViewModeUnavailable.content')}):onViewModeChange(target.value);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_26__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{title:t('components.itemList.buttons.viewModeRadio.table.title')},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"table"}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_26__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{title:t('components.itemList.buttons.viewModeRadio.tree.title')},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"branches",style:{transform:"rotate(90deg)"}}))))),onImportFormShow&&userHasPermissionsToEdit&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{icon:"upload",title:t('components.itemList.buttons.upload.title'),onClick:function onClick(){if(unsavedChange){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('commons.artefact.modals.unsavedChange.discard.title'),onOk:function onOk(){onImportFormShow();},cancelText:t('commons.buttons.cancel.title')});}else{onImportFormShow();}}})),(onCreate||onPaginatedCreate)&&userHasPermissionsToEdit&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["f" /* BUTTON_CREATE */],{type:"primary",title:t('components.itemList.buttons.create.title'),onClick:function onClick(){return selectedItem?onPaginatedCreate?onPaginatedCreate(selectedItem.parent,selectedItem.order,lang):onCreate(selectedItem.parent,String(Number(selectedItem.order[lang])+0.1),lang,itemsOrderAnnotationType):onPaginatedCreate?onPaginatedCreate(null,null,lang):onCreate(null,String(maxOrder+1),lang,itemsOrderAnnotationType);}}))),(onSetDefaultOrder||onPaginatedSetDefaultOrder)&&userHasPermissionsToEdit&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["E" /* BUTTON_SET_DEFAULT_ORDER */],{type:"primary",title:t('components.itemList.buttons.setDefaultOrder.title'),onClick:onPaginatedSetDefaultOrder?function(){if(unsavedChange){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('commons.artefact.modals.unsavedChange.autoSave.title'),onOk:function onOk(){onPaginatedSetDefaultOrder(artefactTriplet,lang);},cancelText:t('commons.buttons.cancel.title')});}else{onPaginatedSetDefaultOrder(artefactTriplet,lang);}}:function(){return onSetDefaultOrder(artefact,itemTree,lang,dataLanguages,itemsOrderAnnotationType);},disabled:!artefact||!artefact.isFinal}),t('components.itemList.buttons.setDefaultOrder.label'))));var itemList=itemTree&&!fetchPage?Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["l" /* getNodes */])(itemTree,childrenKey,function(){return true;}):[];return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,itemsViewMode===__WEBPACK_IMPORTED_MODULE_26__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__hocs_call__["a" /* default */],{cb:fetchPage,cbParam:Object.assign({},fetchPageParams,{rebuildDb:rebuildDb}),disabled:!fetchPage||fetchPageParams===null||isCallDisabled},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__item_list__["a" /* default */],{data:itemPage||itemList,rowCount:fetchPage?itemCount:null,isPaginated:fetchPage?true:false,actions:[].concat(onDetailShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["l" /* BUTTON_DETAIL */],{title:userHasPermissionsToEdit?t('components.itemList.actions.edit.title'):t('components.itemList.actions.view.title'),onClick:function onClick(item){return onDetailShow(item);}}):[]).concat((onCreate||onPaginatedCreate)&&userHasPermissionsToEdit&&!isNotHierarchical?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["f" /* BUTTON_CREATE */],{title:t('components.itemList.actions.add.title'),onClick:function onClick(item){return onPaginatedCreate?onPaginatedCreate(item.id,null,lang):onCreate(item.id,String(maxOrder+1),lang,itemsOrderAnnotationType);}}):[]).concat(onSetDefault&&onUnsetDefault&&userHasPermissionsToEdit?function(item){return Object(__WEBPACK_IMPORTED_MODULE_27__utils_annotations__["F" /* getLayoutAnnotationDefaultForCodelist */])(item.annotations,annotationsConfig)?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["H" /* BUTTON_UNSET_DEFAULT */],{title:t('components.itemList.actions.unsetDefault.title'),onClick:function onClick(){return onUnsetDefault((itemPage||itemList).find(function(_ref5){var id=_ref5.id;return id===item.id;}));}}):Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["D" /* BUTTON_SET_DEFAULT */],{title:t('components.itemList.actions.setDefault.title'),onClick:function onClick(){return onSetDefault((itemPage||itemList).find(function(_ref6){var id=_ref6.id;return id===item.id;}));}});}:[]).concat(onAddAgencyToConfig?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["a" /* BUTTON_ADD_AGENCY_TO_CONFIG */],{title:t('components.itemList.actions.addAgencyToConfig.title'),onClick:function onClick(item){return onAddAgencyToConfig(item);}}):[]).concat((onDelete||onPaginatedDelete)&&userHasPermissionsToEdit?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('components.itemList.actions.delete.title'),onClick:function onClick(item){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('components.itemList.modals.confirms.delete.title',{id:item.id}),onOk:function onOk(){onPaginatedDelete?onPaginatedDelete(artefactTriplet,item.id,autoSave,itemTree,cutItem,lang,t):item[childrenKey]&&item[childrenKey].length>0||cutItem&&item.id===cutItem.parent?__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning({title:t('components.itemList.modals.warning.delete.title')}):onDelete(artefact,itemTree,item,cutItem,lang,t,itemsOrderAnnotationType);},cancelText:t('commons.buttons.cancel.title')});},disabled:artefact&&artefact.isFinal}):[]),fixedActions:[].concat(onAnnotationsShow?function(_ref7){var id=_ref7.id,annotations=_ref7.annotations;var customAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_27__utils_annotations__["r" /* countCustomAnnotations */])(annotations,customAnnotationsConfig);return customAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["g" /* BUTTON_CUSTOM_ANNOTATIONS */],{title:t('commons.actions.customAnnotations.title')+": "+customAnnotationsCount,onClick:function onClick(){return onAnnotationsShow(annotations,id);}}):null;}:[]).concat(onLayoutAnnotationsShow&&username?function(_ref8){var id=_ref8.id,annotations=_ref8.annotations;var layoutAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_27__utils_annotations__["s" /* countLayoutAnnotations */])(annotations,annotationsConfig);return layoutAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["u" /* BUTTON_LAYOUT_ANNOTATIONS */],{title:t('commons.actions.layoutAnnotations.title')+": "+layoutAnnotationsCount,onClick:function onClick(){return onLayoutAnnotationsShow(annotations,id);}}):null;}:[]),leftActions:leftActions,onChange:function onChange(_ref9){var pageNum=_ref9.pageNum,pageSize=_ref9.pageSize,searchText=_ref9.searchText,filters=_ref9.filters,sortCol=_ref9.sortCol,sortByDesc=_ref9.sortByDesc;return fetchPageParamsUpdate?fetchPageParamsUpdate({artefactTriplet:artefactTriplet,lang:lang,pageNum:pageNum,pageSize:pageSize,itemsOrderAnnotationType:itemsOrderAnnotationType,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc}):null;}})):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"item-list__tree "+(isNotHierarchical?'item-list__tree__not-hierarchical-drag-over':'')},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__hocs_call__["a" /* default */],{cb:fetchTree,cbParam:{artefactTriplet:artefactTriplet,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType,rebuildDb:rebuildDb},disabled:(fetchTree?itemTree!==null:true)||isCallDisabled},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__enhanced_tree__["a" /* default */],{tree:itemTree,getNodeKey:function getNodeKey(_ref10){var id=_ref10.id;return id;},childrenKey:childrenKey,idKey:"id",nameKey:"name",catIdKey:"id",catNameKey:"name",icon:"file-text",isRootIconLikeChildrenIcon:true,isEmptyCategoryIconLikeLeafIcon:true,getFilter:function getFilter(searchText){return function(_ref11){var id=_ref11.id,name=_ref11.name;var search=searchText.toLowerCase();return id&&id.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_15__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,lang,dataLanguages).toLowerCase().indexOf(search)>=0;};},draggable:(_onDrop||onPaginatedDrop)&&userHasPermissionsToEdit,onDrop:function onDrop(ev){return onPaginatedDrop?onPaginatedDropHandler(ev,onPaginatedDrop,artefactTriplet,lang,autoSave,itemTree,cutItem,t):onDropHandler(ev,_onDrop,artefact,itemTree,itemsOrderAnnotationType,lang,cutItem,t,isNotHierarchical);},unselectableKeys:onSelect?[]:Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["l" /* getNodes */])(itemTree,childrenKey,function(){return true;}).map(function(item){return item.id;}),onSelect:onSelect?function(selectedArr){if(selectedArr!==null){onSelect(selectedArr[0]);}else{onSelect(null);}}:null,treeActions:[onFileSystemtreeShow?{icon:'eye',title:t('components.itemList.actions.fileSystemTree.title'),onClick:function onClick(){return onFileSystemtreeShow();}}:null],actions:[onDetailShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["l" /* BUTTON_DETAIL */],{title:userHasPermissionsToEdit?t('components.itemList.actions.edit.title'):t('components.itemList.actions.view.title'),onClick:function onClick(){return onDetailShow(selectedItem);},disabled:selectedItem===null}):null,(onCreate||onPaginatedCreate)&&userHasPermissionsToEdit&&!isNotHierarchical?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["f" /* BUTTON_CREATE */],{title:t('components.itemList.actions.add.title'),onClick:function onClick(){return onPaginatedCreate?onPaginatedCreate(selectedItem.id,null,lang):onCreate(selectedItem.id,String(maxOrder+1),lang,itemsOrderAnnotationType);},disabled:selectedItem===null}):null,(onDelete||onPaginatedDelete)&&userHasPermissionsToEdit?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('components.itemList.actions.delete.title'),onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('components.itemList.modals.confirms.delete.title',{id:selectedItem.id}),onOk:function onOk(){onPaginatedDelete?onPaginatedDelete(artefactTriplet,selectedItem.id,autoSave,itemTree,cutItem,lang,t):selectedItem[childrenKey]&&selectedItem[childrenKey].length>0||cutItem&&selectedItem.id===cutItem.parent?__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning({title:t('components.itemList.modals.warning.delete.title')}):onDelete(artefact,itemTree,selectedItem,cutItem,lang,t,itemsOrderAnnotationType);},cancelText:t('commons.buttons.cancel.title')});},disabled:selectedItem===null||artefact&&artefact.isFinal}):null],nodeActions:treeNodeFixedActions,rightClickActions:treeNodeActions,leftActions:leftActions,onShowMoreForbidden:function onShowMoreForbidden(){var modal=__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning();modal.update({title:t('components.itemList.modals.maxTreeSizeReached.title'),content:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,t('components.itemList.modals.maxTreeSizeReached.content')+" ",__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("a",{onClick:function onClick(){modal.destroy();onFileSystemtreeShow();},style:{textDecoration:"underline"}},t('components.itemList.modals.maxTreeSizeReached.exploreLink')))});},getNodeTextColor:function getNodeTextColor(_ref12){var annotations=_ref12.annotations;return Object(__WEBPACK_IMPORTED_MODULE_27__utils_annotations__["F" /* getLayoutAnnotationDefaultForCodelist */])(annotations,annotationsConfig)?TREE_NODE_COLOR_LAYOUT_ANNOTATION_DEFAULT:null;},isTreeVisible:!isFileSystemTreeVisible}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__enhanced_modal__["a" /* default */],{visible:isFileSystemTreeVisible,onCancel:onFileSystemtreeHide,title:t('components.itemList.modals.parentList.title'),width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onFileSystemtreeHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__file_system_tree__["a" /* default */],{height:390,getItemKey:function getItemKey(item){return item.id;},getItems:function getItems(key){return key?(Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["k" /* getNode */])(itemTree,"codes",function(item){return item.id===key;})||{}).codes:itemTree;},getItemIcon:function getItemIcon(item){return item.codes&&item.codes.length>0?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"folder",theme:"filled",style:{color:"#f7c427"}}):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"file-text"});},getItemLabel:function getItemLabel(item){return"["+item.id+"] "+Object(__WEBPACK_IMPORTED_MODULE_15__middlewares_i18n_utils__["a" /* getLocalizedStr */])(item.name,lang,dataLanguages);},getItemLabelForPath:function getItemLabelForPath(item){return item.id;},getItemIsLeaf:function getItemIsLeaf(item){return!item.codes||item.codes.length===0;},actions:[onDetailShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["l" /* BUTTON_DETAIL */],{title:userHasPermissionsToEdit?t('components.itemList.actions.edit.title'):t('components.itemList.actions.view.title'),onClick:function onClick(){return onDetailShow(fileSystemSelectedItem);},disabled:fileSystemSelectedItem===null}):null,(onCreate||onPaginatedCreate)&&userHasPermissionsToEdit?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["f" /* BUTTON_CREATE */],{title:t('components.itemList.actions.add.title'),onClick:function onClick(){return onPaginatedCreate?onPaginatedCreate(fileSystemSelectedItem.id,null,lang):onCreate(fileSystemSelectedItem.id,String(maxOrder+1),lang,itemsOrderAnnotationType);},disabled:fileSystemSelectedItem===null}):null,(onDelete||onPaginatedDelete)&&userHasPermissionsToEdit?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('components.itemList.actions.delete.title'),onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('components.itemList.modals.confirms.delete.title',{id:fileSystemSelectedItem.id}),onOk:function onOk(){onPaginatedDelete?onPaginatedDelete(artefactTriplet,fileSystemSelectedItem.id,autoSave,itemTree,cutItem,lang,t):fileSystemSelectedItem[childrenKey]&&fileSystemSelectedItem[childrenKey].length>0||cutItem&&fileSystemSelectedItem.id===cutItem.parent?__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning({title:t('components.itemList.modals.warning.delete.title')}):onDelete(artefact,itemTree,fileSystemSelectedItem,cutItem,lang,t,itemsOrderAnnotationType);},cancelText:t('commons.buttons.cancel.title')});},disabled:fileSystemSelectedItem===null||artefact&&artefact.isFinal}):null],treeActions:[(onCreate||onPaginatedCreate)&&userHasPermissionsToEdit?Object.assign({},__WEBPACK_IMPORTED_MODULE_25__styles_buttons__["f" /* BUTTON_CREATE */],{title:t('components.itemList.buttons.create.title'),onClick:function onClick(){return fileSystemSelectedItem?onPaginatedCreate?onPaginatedCreate(fileSystemSelectedItem.parent,fileSystemSelectedItem.order,lang):onCreate(fileSystemSelectedItem.parent,String(Number(fileSystemSelectedItem.order[lang])+0.1),lang,itemsOrderAnnotationType):onPaginatedCreate?onPaginatedCreate(null,null,lang):onCreate(null,String(maxOrder+1),lang,itemsOrderAnnotationType);}}):null],itemActions:treeNodeActions,fixedItemActions:treeNodeFixedActions,selected:fileSystemSelectedItem?fileSystemSelectedItem.id:null,onSelect:onFileSystemSelect})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_19_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_18_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["b" /* connect */])(mapStateToProps))(ItemsViewer));

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_languages__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__infinite_scroll_data_table__ = __webpack_require__(74);
var mapStateToProps=function mapStateToProps(state){return{dataLanguages:state.config.dataManagement.dataLanguages};};var mapPropsToFields=function mapPropsToFields(_ref){var formData=_ref.formData;return{file:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.file:null}),language:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.language:null}),separator:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.separator:null}),delimiter:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.delimiter:null}),hasHeader:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.hasHeader:null}),hasDescriptionCol:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.hasDescriptionCol:null}),hasParentCol:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.hasParentCol:null}),hasOrderCol:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.hasOrderCol:null}),hasLayoutAnnotationFullNameCol:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.hasLayoutAnnotationFullNameCol:null}),hasLayoutAnnotationIsDefaultCol:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:formData?formData.hasLayoutAnnotationIsDefaultCol:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var ItemsImportForm=function ItemsImportForm(_ref3){var t=_ref3.t,form=_ref3.form,dataLanguages=_ref3.dataLanguages,formData=_ref3.formData,isVisible=_ref3.isVisible,onHide=_ref3.onHide,onUpload=_ref3.onUpload,onImport=_ref3.onImport,onAllCsvRowsShow=_ref3.onAllCsvRowsShow,onAllCsvRowsHide=_ref3.onAllCsvRowsHide,uploadCsv=_ref3.uploadCsv,fetchAllCsvRows=_ref3.fetchAllCsvRows;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__enhanced_modal__["a" /* default */],{visible:isVisible,title:t('components.itemsImportForm.title'),width:800,onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{disabled:formData===null||formData.file===null||formData.language===null||formData.separator===null||formData.separator.length!==1||formData.hash===null,icon:"check",type:"primary",onClick:onImport},t('components.itemsImportForm.importButton.label')))},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,{className:"advanced-form"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.csv.file.label')},form.getFieldDecorator('file')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__file_input__["a" /* default */],{accept:".csv"})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.commons.language.label')},form.getFieldDecorator('language')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());}},dataLanguages.map(function(_ref5){var code=_ref5.code;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option,{key:code,value:code,title:Object(__WEBPACK_IMPORTED_MODULE_26__utils_languages__["c" /* getLanguageLabel */])(t,code)},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("i",{className:"flag-icon "+Object(__WEBPACK_IMPORTED_MODULE_26__utils_languages__["b" /* getLanguageFlagIconCss */])(code,dataLanguages),style:{marginRight:8}}),Object(__WEBPACK_IMPORTED_MODULE_26__utils_languages__["c" /* getLanguageLabel */])(t,code));})))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],justify:"space-between"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.csv.separator.label')},form.getFieldDecorator('separator')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{maxLength:1,style:{width:48}})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.csv.delimiter.label')},form.getFieldDecorator('delimiter')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{maxLength:1,style:{width:48}})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.csv.hasHeader.label')},form.getFieldDecorator('hasHeader',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))))),formData&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:"inner",title:t('components.itemsImportForm.columnsCard.title'),headStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["PADDING_MD"]},bodyStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["PADDING_MD"],paddingTop:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["PADDING_SM"],paddingBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["PADDING_SM"]},style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('components.itemsImportForm.columnsCard.hasIDCol.label')},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{disabled:true,checked:true})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('components.itemsImportForm.columnsCard.hasNameCol.label')},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{disabled:true,checked:true})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('components.itemsImportForm.columnsCard.hasDescriptionCol.label')},form.getFieldDecorator('hasDescriptionCol',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('components.itemsImportForm.columnsCard.hasParentCol.label')},form.getFieldDecorator('hasParentCol',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('components.itemsImportForm.columnsCard.hasOrderCol.label')},form.getFieldDecorator('hasOrderCol',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('components.itemsImportForm.columnsCard.hasLayoutAnnotationFullNameCol.label')},form.getFieldDecorator('hasLayoutAnnotationFullNameCol',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('components.itemsImportForm.columnsCard.hasLayoutAnnotationIsDefaultCol.label')},form.getFieldDecorator('hasLayoutAnnotationIsDefaultCol',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null)))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{disabled:formData===null||formData.file===null||formData.language===null||formData.separator===null||formData.separator.length!==1,icon:"upload",type:"primary",onClick:onUpload},t('data.csv.uploadButton.label')))),formData&&formData.csvRows&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{style:{marginTop:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__infinite_scroll_table__["a" /* default */],{getRowKey:function getRowKey(_ref6){var id=_ref6.id;return id;},data:formData.csvRows.filter(function(row){return!row.isHeader;}),height:240,columns:[{title:t('data.item.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.item.name.shortLabel'),dataIndex:'name',minWidth:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},formData.hasDescriptionCol?{title:t('data.item.description.shortLabel'),dataIndex:'description',minWidth:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]}:null,formData.hasParentCol?{title:t('data.item.parent.shortLabel'),dataIndex:'parent',minWidth:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]}:null,formData.hasOrderCol?{title:t('data.item.order.shortLabel'),dataIndex:'order',widthToContent:true}:null,formData.hasLayoutAnnotationFullNameCol?{title:t('data.item.layoutAnnotationFullName.shortLabel'),dataIndex:'fullName',minWidth:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]}:null,formData.hasLayoutAnnotationIsDefaultCol?{title:t('data.item.layoutAnnotationIsDefault.shortLabel'),dataIndex:'isDefault',width:30,withValuesFilter:true,render:function render(isDefault){return isDefault==="1"||isDefault===true||isDefault==="true"||isDefault==="True"?__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:"check"}):null;},renderText:function renderText(isDefault){return isDefault==="1"||isDefault===true||isDefault==="true"||isDefault==="True"?t('data.item.layoutAnnotationIsDefault.values.true'):t('data.item.layoutAnnotationIsDefault.values.false');}}:null],rightActions:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{onClick:onAllCsvRowsShow},t('components.itemsImportForm.showAllCsvRows.label'))}),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__hocs_call__["a" /* default */],{cb:uploadCsv,cbParam:formData.file,disabled:!formData.isAllCsvRowsVisible||formData.filePath!==null},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__enhanced_modal__["a" /* default */],{title:t('components.itemsImportForm.allCSVRowsModal.title'),visible:formData!==null&&formData.isAllCsvRowsVisible&&formData.filePath!==null,onCancel:onAllCsvRowsHide,footer:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{onClick:onAllCsvRowsHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MODAL_WIDTH_LG"]},formData.filePath&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__infinite_scroll_data_table__["a" /* default */],{data:formData.allCsvRows&&formData.allCsvRows.Data,rowTotal:formData.allCsvRows&&formData.allCsvRows.Count,cols:formData.allCsvRows&&formData.allCsvRows.Columns,hiddenCols:['NumRow'],onChange:function onChange(_ref7){var pageNum=_ref7.pageNum,pageSize=_ref7.pageSize,searchText=_ref7.searchText,filters=_ref7.filters,sortCol=_ref7.sortCol,sortByDesc=_ref7.sortByDesc;return fetchAllCsvRows(pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_28__utils_filter__["b" /* getFilterObjFromViewerObj */])(formData.allCsvRows&&formData.allCsvRows.Columns.filter(function(colName){return colName!=='NumRow';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc,formData.separator,formData.delimiter,formData.hasHeader,formData.filePath);}}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_24_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(mapStateToProps),__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ItemsImportForm));

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Items__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__reducer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__redux_derived_item_scheme__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__redux_derived_item_scheme_actions__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_sdmxJson__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,isVisible:instanceState.isVisible,forceIsFinalDisabled:instanceState.forceIsFinalDisabled,isEditDisabled:instanceState.isEditDisabled,conceptSchemeTriplet:instanceState.conceptSchemeTriplet,isConceptSchemeValid:instanceState.isConceptSchemeValid,isAgenciesValid:instanceState.isAgenciesValid,isConceptSchemeGeneralTabDirty:instanceState.isConceptSchemeGeneralTabDirty,conceptScheme:instanceState.conceptScheme,agencies:instanceState.agencies,allAgencies:instanceState.allAgencies,itemsTree:instanceState.itemsTree,focusItemsTab:instanceState.focusItemsTab,downloadConceptSchemeTriplets:instanceState.downloadConceptSchemeTriplets,downloadConceptSchemeLang:instanceState.downloadConceptSchemeLang,downloadConceptSchemeParams:instanceState.downloadConceptSchemeParams,cloneDestTriplet:instanceState.cloneDestTriplet,conceptSchemeExportSourceTriplet:instanceState.conceptSchemeExportSourceTriplet,conceptSchemeExportDestination:instanceState.conceptSchemeExportDestination,conceptSchemeExportReport:instanceState.conceptSchemeExportReport,derivedConceptScheme:instanceState.derivedConceptScheme,isDerivedTabFocused:instanceState.isDerivedTabFocused,derivedConceptSchemeViewMode:instanceState.derivedConceptSchemeViewMode,itemsTreeMaxDepth:instanceState.itemsTreeMaxDepth,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onDetailHide:function onDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_18" /* hideConceptSchemeDetail */])(),instancePrefix));},onDetailChange:function onDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_1" /* changeConceptSchemeDetail */])(fields),instancePrefix));},onDetailCreate:function onDetailCreate(conceptScheme,conceptSchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_48" /* submitConceptSchemeDetailCreate */])(conceptScheme,conceptSchemeTriplet),instancePrefix));},onDetailUpdate:function onDetailUpdate(conceptScheme,itemsTree,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_53" /* submitConceptSchemeDetailUpdate */])(conceptScheme,itemsTree,itemsOrderAnnotationType),instancePrefix));},fetchConceptScheme:function fetchConceptScheme(_ref3){var conceptSchemeTriplet=_ref3.conceptSchemeTriplet,itemsOrderAnnotationType=_ref3.itemsOrderAnnotationType,lang=_ref3.lang;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_32" /* readConceptSchemeDetail */])(conceptSchemeTriplet,itemsOrderAnnotationType,lang),instancePrefix));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_33" /* readConceptSchemeDetailAgencies */])(allowedAgencies),instancePrefix));},onLanguageChange:function onLanguageChange(lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_3" /* changeConceptSchemeDetailConceptSchemeLanguage */])(lang,itemsOrderAnnotationType),instancePrefix));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_40" /* showConceptSchemeDetailDownload */])(artefactTriplets,lang),instancePrefix));},onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_20" /* hideConceptSchemeDetailDownload */])(),instancePrefix));},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_5" /* changeConceptSchemeDetailDownload */])(fields),instancePrefix));},onDownloadSubmit:function onDownloadSubmit(artefactTriplets,downloadConceptSchemeParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_50" /* submitConceptSchemeDetailDownload */])(artefactTriplets,downloadConceptSchemeParams,lang),instancePrefix));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_39" /* showConceptSchemeDetailClone */])(artefactTriplet),instancePrefix));},onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_19" /* hideConceptSchemeDetailClone */])(),instancePrefix));},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_2" /* changeConceptSchemeDetailClone */])(fields),instancePrefix));},onCloneSubmit:function onCloneSubmit(cloneDestTriplet,srcConceptScheme,srcConceptSchemeItemsTree,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_47" /* submitConceptSchemeDetailClone */])(cloneDestTriplet,srcConceptScheme,srcConceptSchemeItemsTree,annotationsConfig),instancePrefix));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_41" /* showConceptSchemeDetailExport */])(sourceTriplet),instancePrefix));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_21" /* hideConceptSchemeDetailExport */])(),instancePrefix));},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_6" /* changeConceptSchemeDetailExport */])(fields),instancePrefix));},onExportSubmit:function onExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_51" /* submitConceptSchemeDetailExport */])(sourceTriplet,destination),instancePrefix));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_22" /* hideConceptSchemeDetailExportReport */])(),instancePrefix));},onDerivedItemSchemeCreateSubmit:function onDerivedItemSchemeCreateSubmit(derivedConceptScheme,derivedItems){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_49" /* submitConceptSchemeDetailDerivedItemSchemeCreate */])(derivedConceptScheme,derivedItems),instancePrefix));},onDerivedItemSchemeStateReset:function onDerivedItemSchemeStateReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_30__redux_derived_item_scheme_actions__["n" /* resetDerivedItemSchemeState */])(),instancePrefix+__WEBPACK_IMPORTED_MODULE_28__reducer__["a" /* REDUX_CONCEPT_SCHEMES_DETAIL_DERIVED_IS_PREFIX */]));},onDerivedTabFocus:function onDerivedTabFocus(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_17" /* focusConceptSchemeDetailDerivedTab */])(),instancePrefix));},onDerivedTabUnfocus:function onDerivedTabUnfocus(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_54" /* unfocusConceptSchemeDetailDerivedTab */])(),instancePrefix));},onDerivedConceptSchemeViewModeChange:function onDerivedConceptSchemeViewModeChange(mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_4" /* changeConceptSchemeDetailDerivedCategorySchemeViewMode */])(mode),instancePrefix));}};};var ReduxConceptSchemeDetailModal=function ReduxConceptSchemeDetailModal(_ref4){var t=_ref4.t,nodes=_ref4.nodes,nodeId=_ref4.nodeId,permissions=_ref4.permissions,appLanguage=_ref4.appLanguage,dataLanguages=_ref4.dataLanguages,instanceState=_ref4.instanceState,instancePrefix=_ref4.instancePrefix,isVisible=_ref4.isVisible,isEditDisabled=_ref4.isEditDisabled,conceptSchemeTriplet=_ref4.conceptSchemeTriplet,isConceptSchemeValid=_ref4.isConceptSchemeValid,isAgenciesValid=_ref4.isAgenciesValid,isConceptSchemeGeneralTabDirty=_ref4.isConceptSchemeGeneralTabDirty,conceptScheme=_ref4.conceptScheme,agencies=_ref4.agencies,allAgencies=_ref4.allAgencies,cloneDestTriplet=_ref4.cloneDestTriplet,onDetailHide=_ref4.onDetailHide,onDetailChange=_ref4.onDetailChange,onDetailCreate=_ref4.onDetailCreate,onDetailUpdate=_ref4.onDetailUpdate,fetchConceptScheme=_ref4.fetchConceptScheme,fetchAgencies=_ref4.fetchAgencies,itemsTree=_ref4.itemsTree,onLanguageChange=_ref4.onLanguageChange,focusItemsTab=_ref4.focusItemsTab,downloadConceptSchemeTriplets=_ref4.downloadConceptSchemeTriplets,downloadConceptSchemeLang=_ref4.downloadConceptSchemeLang,downloadConceptSchemeParams=_ref4.downloadConceptSchemeParams,onDownloadShow=_ref4.onDownloadShow,onDownloadHide=_ref4.onDownloadHide,onDownloadChange=_ref4.onDownloadChange,onDownloadSubmit=_ref4.onDownloadSubmit,onCloneShow=_ref4.onCloneShow,onCloneHide=_ref4.onCloneHide,onCloneChange=_ref4.onCloneChange,onCloneSubmit=_ref4.onCloneSubmit,conceptSchemeExportSourceTriplet=_ref4.conceptSchemeExportSourceTriplet,conceptSchemeExportDestination=_ref4.conceptSchemeExportDestination,conceptSchemeExportReport=_ref4.conceptSchemeExportReport,onExportShow=_ref4.onExportShow,onExportHide=_ref4.onExportHide,onExportChange=_ref4.onExportChange,onExportSubmit=_ref4.onExportSubmit,onExportReportHide=_ref4.onExportReportHide,derivedConceptScheme=_ref4.derivedConceptScheme,onDerivedItemSchemeCreateSubmit=_ref4.onDerivedItemSchemeCreateSubmit,onDerivedItemSchemeStateReset=_ref4.onDerivedItemSchemeStateReset,onDerivedTabFocus=_ref4.onDerivedTabFocus,onDerivedTabUnfocus=_ref4.onDerivedTabUnfocus,isDerivedTabFocused=_ref4.isDerivedTabFocused,forceIsFinalDisabled=_ref4.forceIsFinalDisabled,derivedConceptSchemeViewMode=_ref4.derivedConceptSchemeViewMode,onDerivedConceptSchemeViewModeChange=_ref4.onDerivedConceptSchemeViewModeChange,itemsTreeMaxDepth=_ref4.itemsTreeMaxDepth,user=_ref4.user;var itemsOrderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.conceptSchemesOrder;var userHasPermissionsToEdit=permissions&&conceptSchemeTriplet&&permissions.agencies.filter(function(agency){return agency===conceptSchemeTriplet.agencyID;}).length>0;var _useState=Object(__WEBPACK_IMPORTED_MODULE_12_react__["useState"])("general"),_useState2=_slicedToArray(_useState,2),tab=_useState2[0],setTab=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_12_react__["useEffect"])(function(){if(focusItemsTab){setTab("items");}else{setTab("general");}},[focusItemsTab]);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;var ignoreUsername=(user&&user.providerId)!==null;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchConceptScheme,cbParam:{conceptSchemeTriplet:conceptSchemeTriplet,itemsOrderAnnotationType:itemsOrderAnnotationType,lang:lang},disabled:isConceptSchemeValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:isAgenciesValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_XL"],title:conceptSchemeTriplet!==null?userHasPermissionsToEdit&&!isEditDisabled?t('reduxComponents.conceptSchemeDetail.title.editMode.title',{triplet:conceptSchemeTriplet}):t('reduxComponents.conceptSchemeDetail.title.viewMode.title',{triplet:conceptSchemeTriplet}):t('reduxComponents.conceptSchemeDetail.title.createMode.title'),onCancel:function onCancel(){onDetailHide();onDerivedItemSchemeStateReset();},footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){onDetailHide();onDerivedItemSchemeStateReset();}},t('commons.buttons.close.title')),(conceptSchemeTriplet===null||userHasPermissionsToEdit)&&!isEditDisabled&&!isDerivedTabFocused?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["a" /* isArtefactValid */])(conceptScheme)){if(conceptSchemeTriplet!==null){onDetailUpdate(conceptScheme,itemsTree,itemsOrderAnnotationType);onDerivedItemSchemeStateReset();}else{onDetailCreate(conceptScheme,{id:conceptScheme.id,agencyID:conceptScheme.agencyID,version:conceptScheme.version});}}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true,onDataLanguageSelectorChange:function onDataLanguageSelectorChange(lang,changeLang){onLanguageChange(lang,itemsOrderAnnotationType);changeLang();}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return conceptSchemeTriplet?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,permissions&&!userHasPermissionsToEdit&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],justify:"end"},onDownloadShow&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onDownloadShow([conceptSchemeTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){return onCloneShow(conceptSchemeTriplet);}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onExportShow(conceptSchemeTriplet);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{activeKey:tab,onTabClick:function onTabClick(key){if(!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["a" /* isArtefactValid */])(conceptScheme)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{setTab(key);if(key==="derived"){onDerivedTabFocus();}else if(isDerivedTabFocused){onDerivedTabUnfocus();}if(key==="categorisations"){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.error({title:t('errors.notImplemented')});}if(isConceptSchemeGeneralTabDirty){onDetailUpdate(conceptScheme,itemsTree,itemsOrderAnnotationType);}}}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'general',tab:t('commons.artefact.tabs.general.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:conceptScheme,mode:userHasPermissionsToEdit&&!isEditDisabled?__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],agencies:agencies,onChange:onDetailChange,artefactOrderType:itemsOrderAnnotationType,isFinalDisabled:forceIsFinalDisabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'items',tab:t('commons.artefact.tabs.items.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Items__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix,isEditDisabled:isEditDisabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'categorisations',tab:t('commons.artefact.tabs.categorisations.title')}),permissions&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'derived',tab:t('reduxComponents.conceptSchemeDetail.tabs.derived.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__redux_derived_item_scheme__["a" /* default */],{instanceState:derivedConceptScheme,instancePrefix:instancePrefix+__WEBPACK_IMPORTED_MODULE_28__reducer__["a" /* REDUX_CONCEPT_SCHEMES_DETAIL_DERIVED_IS_PREFIX */],itemTree:itemsTree,childrenKey:"concepts",agencies:agencies,onCreateSubmit:onDerivedItemSchemeCreateSubmit,viewMode:derivedConceptSchemeViewMode,onViewModeChange:onDerivedConceptSchemeViewModeChange,itemTreeMaxDepth:itemsTreeMaxDepth,title:t('reduxComponents.conceptSchemeDetail.tabs.derived.title')})))):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:conceptScheme,mode:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */],agencies:agencies,onChange:onDetailChange,artefactOrderType:itemsOrderAnnotationType});})))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:downloadConceptSchemeTriplets!==null&&downloadConceptSchemeTriplets!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){return onDownloadSubmit(downloadConceptSchemeTriplets,downloadConceptSchemeParams,downloadConceptSchemeLang);},type:'primary',disabled:downloadConceptSchemeParams&&downloadConceptSchemeParams.format===null||downloadConceptSchemeParams&&downloadConceptSchemeParams.format===__WEBPACK_IMPORTED_MODULE_31__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadConceptSchemeParams.csvSeparator===null||downloadConceptSchemeParams.csvSeparator.length!==1||downloadConceptSchemeParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_SM"],title:downloadConceptSchemeTriplets&&downloadConceptSchemeTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadConceptSchemeTriplets?Object(__WEBPACK_IMPORTED_MODULE_33__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadConceptSchemeTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadConceptSchemeParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_31__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadConceptSchemeTriplets&&downloadConceptSchemeTriplets.length>1?__WEBPACK_IMPORTED_MODULE_31__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_31__constants_download__["d" /* ARTEFACT_TYPE_CONCEPT_SCHEME */]),langs:dataLanguages})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(cloneDestTriplet,conceptScheme,itemsTree,nodes.find(function(node){return node.general.id===nodeId;}).annotations);}},type:'primary'},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:conceptScheme,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:conceptSchemeExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["e" /* isExportDestinationValid */])(conceptSchemeExportDestination,ignoreUsername)){onExportSubmit(conceptSchemeExportSourceTriplet,conceptSchemeExportDestination);}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_artefact_export_form__["b" /* default */],{type:'conceptscheme',agencies:allAgencies,sourceTriplet:conceptSchemeExportSourceTriplet,destination:conceptSchemeExportDestination,onChange:onExportChange})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:conceptSchemeExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_artefact_export_report__["a" /* default */],{report:conceptSchemeExportReport})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ReduxConceptSchemeDetailModal));

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
var FileMappingComponentList=function FileMappingComponentList(_ref){var t=_ref.t,value=_ref.value,selected=_ref.selected,onSelect=_ref.onSelect,columnNameKey=_ref.columnNameKey,cubeComponentCodeKey=_ref.cubeComponentCodeKey;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{overflow:"auto",height:"100%",border:"1px solid #e8e8e8",paddingLeft:4,paddingRight:4}},(value||[]).map(function(value,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:index,onClick:function onClick(){return onSelect?onSelect(value):null;},title:onSelect?t("commons.actions.select.title")+' '+value.columnName+' - '+value.cubeComponentCode:null,style:{paddingTop:2,paddingBottom:2,paddingLeft:8,paddingRight:8,cursor:onSelect?"pointer":"cursor",background:''+value.columnName+value.cubeComponentCode===selected?"#ffafa3":index%2?"#f5f5f5":"#ffffff",minWidth:120}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{width:"calc(50% - 24px)",verticalAlign:"middle",display:"inline-block",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}},value[columnNameKey]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'link',style:{width:32,marginLeft:8,marginRight:8,verticalAlign:"middle",display:"inline-block"}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{width:"calc(50% - 24px)",verticalAlign:"middle",display:"inline-block",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}},value[cubeComponentCodeKey]));}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])()(FileMappingComponentList));

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1408);

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _rcSteps = _interopRequireDefault(__webpack_require__(1409));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Steps =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Steps, _React$Component);

  function Steps() {
    var _this;

    _classCallCheck(this, Steps);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Steps).apply(this, arguments));

    _this.renderSteps = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var prefixCls = getPrefixCls('steps', _this.props.prefixCls);
      var iconPrefix = getPrefixCls('', _this.props.iconPrefix);
      var icons = {
        finish: React.createElement(_icon["default"], {
          type: "check",
          className: "".concat(prefixCls, "-finish-icon")
        }),
        error: React.createElement(_icon["default"], {
          type: "close",
          className: "".concat(prefixCls, "-error-icon")
        })
      };
      return React.createElement(_rcSteps["default"], _extends({
        icons: icons
      }, _this.props, {
        prefixCls: prefixCls,
        iconPrefix: iconPrefix
      }));
    };

    return _this;
  }

  _createClass(Steps, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSteps);
    }
  }]);

  return Steps;
}(React.Component);

exports["default"] = Steps;
Steps.Step = _rcSteps["default"].Step;
Steps.defaultProps = {
  current: 0
};
Steps.propTypes = {
  prefixCls: PropTypes.string,
  iconPrefix: PropTypes.string,
  current: PropTypes.number
};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_constants__);
var IconFontCNIcon=__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a.createFromIconfontCN({scriptUrl:'./static/vendor/iconfont_cn/iconfont.js'});var FileMappingWizardComponentList=function FileMappingWizardComponentList(_ref){var t=_ref.t,components=_ref.components,disabled=_ref.disabled,hasIcon=_ref.hasIcon,selected=_ref.selected,onSelect=_ref.onSelect;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{overflow:"auto",height:"100%",border:"1px solid #e8e8e8",paddingLeft:4,paddingRight:4}},(components||[]).map(function(component,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:index,onClick:function onClick(){return!disabled.includes(component.name)&&onSelect(component);},title:t("commons.actions.select.title")+' '+component.name,className:disabled.includes(component.name)?"ant-select-disabled":"",style:{paddingTop:2,paddingBottom:2,paddingLeft:8,paddingRight:4,background:component.name===selected?"#ffafa3":index%2?"#f5f5f5":"#ffffff",borderTop:"1px solid #e8e8e8",cursor:'pointer',minWidth:120}},hasIcon?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:component.icon,style:{width:16,marginRight:8,verticalAlign:"middle",display:"inline-block",color:disabled.filter(function(el){return el===component.name;}).length>0?__WEBPACK_IMPORTED_MODULE_4__styles_constants__["COLOR_FONT_DISABLED"]:undefined}}):null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{width:hasIcon?"calc(100% - 56px)":"calc(100% - 32px)",verticalAlign:"middle",display:"inline-block",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",color:disabled.filter(function(el){return el===component.name;}).length>0?__WEBPACK_IMPORTED_MODULE_4__styles_constants__["COLOR_FONT_DISABLED"]:undefined,fontWeight:!disabled.filter(function(el){return el===component.name;}).length>0?"bold":undefined}},component.IsMandatory?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconFontCNIcon,{type:'m',style:{marginRight:4},title:'Mandatory'}):null,component.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{title:component.detailTitle,style:{width:16,marginLeft:8,verticalAlign:"middle",display:"inline-block",cursor:component.onDetail!==null?'pointer':'not-allowed',color:component.onDetail===null?__WEBPACK_IMPORTED_MODULE_4__styles_constants__["COLOR_FONT_DISABLED"]:null},onClick:component.onDetail!==null?function(e){e.stopPropagation();component.onDetail(component);}:null,type:'file-search'}));}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])()(FileMappingWizardComponentList));

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Items__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__reducer__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__redux_components_redux_derived_item_scheme__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__redux_derived_item_scheme_actions__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_sdmxJson__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,isVisible:instanceState.isVisible,forceIsFinalDisabled:instanceState.forceIsFinalDisabled,isEditDisabled:instanceState.isEditDisabled,categorySchemeTriplet:instanceState.categorySchemeTriplet,isCategorySchemeValid:instanceState.isCategorySchemeValid,isAgenciesValid:instanceState.isAgenciesValid,isCategorySchemeGeneralTabDirty:instanceState.isCategorySchemeGeneralTabDirty,categoryScheme:instanceState.categoryScheme,agencies:instanceState.agencies,allAgencies:instanceState.allAgencies,itemsTree:instanceState.itemsTree,focusItemsTab:instanceState.focusItemsTab,downloadCategorySchemeTriplets:instanceState.downloadCategorySchemeTriplets,downloadCategorySchemeParams:instanceState.downloadCategorySchemeParams,downloadCategorySchemeLang:instanceState.downloadCategorySchemeLang,cloneDestTriplet:instanceState.cloneDestTriplet,categorySchemeExportSourceTriplet:instanceState.categorySchemeExportSourceTriplet,categorySchemeExportDestination:instanceState.categorySchemeExportDestination,categorySchemeExportReport:instanceState.categorySchemeExportReport,derivedCategoryScheme:instanceState.derivedCategoryScheme,isDerivedTabFocused:instanceState.isDerivedTabFocused,derivedCategorySchemeViewMode:instanceState.derivedCategorySchemeViewMode,itemsTreeMaxDepth:instanceState.itemsTreeMaxDepth,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onDetailHide:function onDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_19" /* hideCategorySchemeDetail */])(),instancePrefix));},onDetailChange:function onDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_2" /* changeCategorySchemeDetail */])(fields),instancePrefix));},onDetailCreate:function onDetailCreate(categoryScheme,categorySchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_48" /* submitCategorySchemeDetailCreate */])(categoryScheme,categorySchemeTriplet),instancePrefix));},onDetailUpdate:function onDetailUpdate(categoryScheme,itemsTree,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_53" /* submitCategorySchemeDetailUpdate */])(categoryScheme,itemsTree,itemsOrderAnnotationType),instancePrefix));},fetchCategoryScheme:function fetchCategoryScheme(_ref3){var categorySchemeTriplet=_ref3.categorySchemeTriplet,itemsOrderAnnotationType=_ref3.itemsOrderAnnotationType,lang=_ref3.lang;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_32" /* readCategorySchemeDetail */])(categorySchemeTriplet,itemsOrderAnnotationType,lang),instancePrefix));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_33" /* readCategorySchemeDetailAgencies */])(allowedAgencies),instancePrefix));},onLanguageChange:function onLanguageChange(lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_9" /* changeCategorySchemeDetailLanguage */])(lang,itemsOrderAnnotationType),instancePrefix));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_41" /* showCategorySchemeDetailDownload */])(artefactTriplets,lang),instancePrefix));},onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_20" /* hideCategorySchemeDetailDownload */])(),instancePrefix));},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_4" /* changeCategorySchemeDetailDownload */])(fields),instancePrefix));},onDownload:function onDownload(artefactTriplets,downloadCategorySchemeParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_50" /* submitCategorySchemeDetailDownload */])(artefactTriplets,downloadCategorySchemeParams,lang),instancePrefix));},onCloneShow:function onCloneShow(srcTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_38" /* showCategorySchemeCategorySchemeClone */])(srcTriplet),instancePrefix));},onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_18" /* hideCategorySchemeCategorySchemeClone */])(),instancePrefix));},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_1" /* changeCategorySchemeCategorySchemeClone */])(fields),instancePrefix));},onCloneSubmit:function onCloneSubmit(cloneDestTriplet,srcCategoryScheme,srcCategorySchemeItemsTree,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_47" /* submitCategorySchemeCategorySchemeClone */])(cloneDestTriplet,srcCategoryScheme,srcCategorySchemeItemsTree,annotationsConfig),instancePrefix));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_39" /* showCategorySchemeCategorySchemeExport */])(sourceTriplet),instancePrefix));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_21" /* hideCategorySchemeDetailExport */])(),instancePrefix));},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_5" /* changeCategorySchemeDetailExport */])(fields),instancePrefix));},onExportSubmit:function onExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_51" /* submitCategorySchemeDetailExport */])(sourceTriplet,destination),instancePrefix));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_22" /* hideCategorySchemeDetailExportReport */])(),instancePrefix));},onDerivedItemSchemeCreateSubmit:function onDerivedItemSchemeCreateSubmit(derivedCategoryScheme,derivedItems){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_49" /* submitCategorySchemeDetailDerivedItemSchemeCreate */])(derivedCategoryScheme,derivedItems),instancePrefix));},onDerivedItemSchemeStateReset:function onDerivedItemSchemeStateReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_30__redux_derived_item_scheme_actions__["n" /* resetDerivedItemSchemeState */])(),instancePrefix+__WEBPACK_IMPORTED_MODULE_28__reducer__["a" /* REDUX_CATEGORY_SCHEMES_DETAIL_DERIVED_IS_PREFIX */]));},onDerivedTabFocus:function onDerivedTabFocus(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_17" /* focusCategorySchemeDetailDerivedTab */])(),instancePrefix));},onDerivedTabUnfocus:function onDerivedTabUnfocus(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_54" /* unfocusCategorySchemeDetailDerivedTab */])(),instancePrefix));},onDerivedCategorySchemeViewModeChange:function onDerivedCategorySchemeViewModeChange(mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_3" /* changeCategorySchemeDetailDerivedCategorySchemeViewMode */])(mode),instancePrefix));}};};var ReduxCategorySchemeDetailModal=function ReduxCategorySchemeDetailModal(_ref4){var t=_ref4.t,nodes=_ref4.nodes,nodeId=_ref4.nodeId,permissions=_ref4.permissions,appLanguage=_ref4.appLanguage,dataLanguages=_ref4.dataLanguages,instanceState=_ref4.instanceState,instancePrefix=_ref4.instancePrefix,isVisible=_ref4.isVisible,isEditDisabled=_ref4.isEditDisabled,categorySchemeTriplet=_ref4.categorySchemeTriplet,isCategorySchemeValid=_ref4.isCategorySchemeValid,isAgenciesValid=_ref4.isAgenciesValid,isCategorySchemeGeneralTabDirty=_ref4.isCategorySchemeGeneralTabDirty,categoryScheme=_ref4.categoryScheme,agencies=_ref4.agencies,allAgencies=_ref4.allAgencies,cloneDestTriplet=_ref4.cloneDestTriplet,onDetailHide=_ref4.onDetailHide,onDetailChange=_ref4.onDetailChange,onDetailCreate=_ref4.onDetailCreate,onDetailUpdate=_ref4.onDetailUpdate,fetchCategoryScheme=_ref4.fetchCategoryScheme,fetchAgencies=_ref4.fetchAgencies,itemsTree=_ref4.itemsTree,onLanguageChange=_ref4.onLanguageChange,focusItemsTab=_ref4.focusItemsTab,downloadCategorySchemeTriplets=_ref4.downloadCategorySchemeTriplets,downloadCategorySchemeLang=_ref4.downloadCategorySchemeLang,downloadCategorySchemeParams=_ref4.downloadCategorySchemeParams,onDownloadShow=_ref4.onDownloadShow,onDownloadHide=_ref4.onDownloadHide,onDownloadChange=_ref4.onDownloadChange,onDownload=_ref4.onDownload,onCloneShow=_ref4.onCloneShow,onCloneHide=_ref4.onCloneHide,onCloneChange=_ref4.onCloneChange,onCloneSubmit=_ref4.onCloneSubmit,categorySchemeExportSourceTriplet=_ref4.categorySchemeExportSourceTriplet,categorySchemeExportDestination=_ref4.categorySchemeExportDestination,categorySchemeExportReport=_ref4.categorySchemeExportReport,onExportShow=_ref4.onExportShow,onExportHide=_ref4.onExportHide,onExportChange=_ref4.onExportChange,onExportSubmit=_ref4.onExportSubmit,onExportReportHide=_ref4.onExportReportHide,derivedCategoryScheme=_ref4.derivedCategoryScheme,onDerivedItemSchemeCreateSubmit=_ref4.onDerivedItemSchemeCreateSubmit,onDerivedItemSchemeStateReset=_ref4.onDerivedItemSchemeStateReset,onDerivedTabFocus=_ref4.onDerivedTabFocus,onDerivedTabUnfocus=_ref4.onDerivedTabUnfocus,isDerivedTabFocused=_ref4.isDerivedTabFocused,forceIsFinalDisabled=_ref4.forceIsFinalDisabled,derivedCategorySchemeViewMode=_ref4.derivedCategorySchemeViewMode,onDerivedCategorySchemeViewModeChange=_ref4.onDerivedCategorySchemeViewModeChange,itemsTreeMaxDepth=_ref4.itemsTreeMaxDepth,user=_ref4.user;var itemsOrderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.categorySchemesOrder;var hasUserPermissionsToEdit=permissions&&categorySchemeTriplet&&permissions.agencies.filter(function(agency){return agency===categorySchemeTriplet.agencyID;}).length>0;var _useState=Object(__WEBPACK_IMPORTED_MODULE_12_react__["useState"])("general"),_useState2=_slicedToArray(_useState,2),tab=_useState2[0],setTab=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_12_react__["useEffect"])(function(){if(focusItemsTab){setTab("items");}else{setTab("general");}},[focusItemsTab]);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;var ignoreUsername=(user&&user.providerId)!==null;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchCategoryScheme,cbParam:{categorySchemeTriplet:categorySchemeTriplet,itemsOrderAnnotationType:itemsOrderAnnotationType,lang:lang},disabled:isCategorySchemeValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:isAgenciesValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_XL"],title:categorySchemeTriplet!==null?hasUserPermissionsToEdit&&!isEditDisabled?t('reduxComponents.categorySchemeDetail.title.editMode.title',{triplet:categorySchemeTriplet}):t('reduxComponents.categorySchemeDetail.title.viewMode.title',{triplet:categorySchemeTriplet}):t('reduxComponents.categorySchemeDetail.title.createMode.title'),onCancel:function onCancel(){onDetailHide();onDerivedItemSchemeStateReset();},footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){onDetailHide();onDerivedItemSchemeStateReset();}},t('commons.buttons.close.title')),(categorySchemeTriplet===null||hasUserPermissionsToEdit)&&!isEditDisabled&&!isDerivedTabFocused?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["a" /* isArtefactValid */])(categoryScheme)){if(categorySchemeTriplet!==null){onDetailUpdate(categoryScheme,itemsTree,itemsOrderAnnotationType);onDerivedItemSchemeStateReset();}else{onDetailCreate(categoryScheme,{id:categoryScheme.id,agencyID:categoryScheme.agencyID,version:categoryScheme.version});}}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true,onDataLanguageSelectorChange:function onDataLanguageSelectorChange(lang,changeLang){onLanguageChange(lang,itemsOrderAnnotationType);changeLang();}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return categorySchemeTriplet?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,permissions&&!hasUserPermissionsToEdit&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],justify:"end"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onDownloadShow([categorySchemeTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){return onCloneShow(categorySchemeTriplet);}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onExportShow(categorySchemeTriplet);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{activeKey:tab,onTabClick:function onTabClick(key){if(!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["a" /* isArtefactValid */])(categoryScheme)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{setTab(key);if(key==="derived"){onDerivedTabFocus();}else if(isDerivedTabFocused){onDerivedTabUnfocus();}if(key==="categorisations"){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.error({title:t('errors.notImplemented')});}if(isCategorySchemeGeneralTabDirty){onDetailUpdate(categoryScheme,itemsTree,itemsOrderAnnotationType);}}}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'general',tab:t('commons.artefact.tabs.general.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:categoryScheme,mode:hasUserPermissionsToEdit&&!isEditDisabled?__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],agencies:agencies,onChange:onDetailChange,isFinalDisabled:forceIsFinalDisabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'items',tab:t('commons.artefact.tabs.items.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Items__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix,isEditDisabled:isEditDisabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'categorisations',tab:t('commons.artefact.tabs.categorisations.title')}),permissions&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'derived',tab:t('reduxComponents.categorySchemeDetail.tabs.derived.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__redux_components_redux_derived_item_scheme__["a" /* default */],{instanceState:derivedCategoryScheme,instancePrefix:instancePrefix+__WEBPACK_IMPORTED_MODULE_28__reducer__["a" /* REDUX_CATEGORY_SCHEMES_DETAIL_DERIVED_IS_PREFIX */],itemTree:itemsTree,childrenKey:"categories",agencies:agencies,onCreateSubmit:onDerivedItemSchemeCreateSubmit,viewMode:derivedCategorySchemeViewMode,onViewModeChange:onDerivedCategorySchemeViewModeChange,itemTreeMaxDepth:itemsTreeMaxDepth,title:t('reduxComponents.categorySchemeDetail.tabs.derived.title')})))):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:categoryScheme,mode:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */],agencies:agencies,onChange:onDetailChange});})))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:downloadCategorySchemeTriplets!==null&&downloadCategorySchemeTriplets!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){return onDownload(downloadCategorySchemeTriplets,downloadCategorySchemeParams,downloadCategorySchemeLang);},type:'primary',disabled:downloadCategorySchemeParams&&downloadCategorySchemeParams.format===null||downloadCategorySchemeParams&&downloadCategorySchemeParams.format===__WEBPACK_IMPORTED_MODULE_31__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadCategorySchemeParams.csvSeparator===null||downloadCategorySchemeParams.csvSeparator.length!==1||downloadCategorySchemeParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_SM"],title:downloadCategorySchemeTriplets&&downloadCategorySchemeTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadCategorySchemeTriplets?Object(__WEBPACK_IMPORTED_MODULE_33__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadCategorySchemeTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadCategorySchemeParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_31__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadCategorySchemeTriplets&&downloadCategorySchemeTriplets.length>1?__WEBPACK_IMPORTED_MODULE_31__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_31__constants_download__["b" /* ARTEFACT_TYPE_CATEGORY_SCHEME */]),langs:dataLanguages})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(cloneDestTriplet,categoryScheme,itemsTree,nodes.find(function(node){return node.general.id===nodeId;}).annotations);}},type:'primary'},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:categoryScheme,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:categorySchemeExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["e" /* isExportDestinationValid */])(categorySchemeExportDestination,ignoreUsername)){onExportSubmit(categorySchemeExportSourceTriplet,categorySchemeExportDestination);}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_artefact_export_form__["b" /* default */],{type:'categoryscheme',agencies:allAgencies,sourceTriplet:categorySchemeExportSourceTriplet,destination:categorySchemeExportDestination,onChange:onExportChange})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:categorySchemeExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_artefact_export_report__["a" /* default */],{report:categorySchemeExportReport})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ReduxCategorySchemeDetailModal));

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigConsumer; });
/* unused harmony export withConfigConsumer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_context__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__renderEmpty__ = __webpack_require__(1488);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var ConfigContext = __WEBPACK_IMPORTED_MODULE_1_create_react_context___default()({
  // We provide a default function for Context without provider
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return "ant-".concat(suffixCls);
  },
  renderEmpty: __WEBPACK_IMPORTED_MODULE_2__renderEmpty__["a" /* default */]
});
var ConfigConsumer = ConfigContext.Consumer;

var ConfigProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConfigProvider, _React$Component);

  function ConfigProvider() {
    var _this;

    _classCallCheck(this, ConfigProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfigProvider).apply(this, arguments));

    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
      var _this$props$prefixCls = _this.props.prefixCls,
          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
      if (customizePrefixCls) return customizePrefixCls;
      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
    };

    _this.renderProvider = function (context) {
      var _this$props = _this.props,
          children = _this$props.children,
          getPopupContainer = _this$props.getPopupContainer,
          renderEmpty = _this$props.renderEmpty;

      var config = _extends({}, context, {
        getPrefixCls: _this.getPrefixCls
      });

      if (getPopupContainer) {
        config.getPopupContainer = getPopupContainer;
      }

      if (renderEmpty) {
        config.renderEmpty = renderEmpty;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ConfigContext.Provider, {
        value: config
      }, children);
    };

    return _this;
  }

  _createClass(ConfigProvider, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ConfigConsumer, null, this.renderProvider);
    }
  }]);

  return ConfigProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function withConfigConsumer(config) {
  return function (Component) {
    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
    return function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ConfigConsumer, null, function (configProps) {
        var basicPrefixCls = config.prefixCls;
        var getPrefixCls = configProps.getPrefixCls;
        var customizePrefixCls = props.prefixCls;
        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component, _extends({}, configProps, props, {
          prefixCls: prefixCls
        }));
      });
    };
  };
}
/* unused harmony default export */ var _unused_webpack_default_export = (ConfigProvider);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1590);

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _layout = _interopRequireDefault(__webpack_require__(1591));

var _Sider = _interopRequireDefault(__webpack_require__(1592));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_layout["default"].Sider = _Sider["default"];
var _default = _layout["default"];
exports["default"] = _default;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(142));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

/* babel-plugin-inline-import './empty.svg' */
var emptyImg = "data:image/svg+xml;base64,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";

var Empty = function Empty(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var className = props.className,
        image = props.image,
        description = props.description,
        children = props.children,
        restProps = __rest(props, ["className", "image", "description", "children"]);

    var prefixCls = getPrefixCls('empty', props.prefixCls);
    return React.createElement(_LocaleReceiver["default"], {
      componentName: "Empty"
    }, function (locale) {
      var des = description || locale.description;
      var alt = typeof des === 'string' ? des : 'empty';
      var imageNode = null;

      if (!image) {
        imageNode = React.createElement("img", {
          alt: alt,
          src: emptyImg
        });
      } else if (typeof image === 'string') {
        imageNode = React.createElement("img", {
          alt: alt,
          src: image
        });
      } else {
        imageNode = image;
      }

      return React.createElement("div", _extends({
        className: (0, _classnames["default"])(prefixCls, className)
      }, restProps), React.createElement("div", {
        className: "".concat(prefixCls, "-image")
      }, imageNode), React.createElement("p", {
        className: "".concat(prefixCls, "-description")
      }, des), children && React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, children));
    });
  });
};

var _default = Empty;
exports["default"] = _default;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(367));

var _en_US2 = _interopRequireDefault(__webpack_require__(264));

var _en_US3 = _interopRequireDefault(__webpack_require__(265));

var _en_US4 = _interopRequireDefault(__webpack_require__(625));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  locale: 'en',
  Pagination: _en_US["default"],
  DatePicker: _en_US2["default"],
  TimePicker: _en_US3["default"],
  Calendar: _en_US4["default"],
  global: {
    placeholder: 'Please select'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    sortTitle: 'Sort'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file'
  },
  Empty: {
    description: 'No Data'
  }
};
exports["default"] = _default;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(368));

var _en_US2 = _interopRequireDefault(__webpack_require__(265));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Merge into a locale object
var locale = {
  lang: _extends({
    placeholder: 'Select date',
    rangePlaceholder: ['Start date', 'End date']
  }, _en_US["default"]),
  timePickerLocale: _extends({}, _en_US2["default"])
}; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

var _default = locale;
exports["default"] = _default;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'Select time'
};
var _default = locale;
exports["default"] = _default;

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(270);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaults;
/* harmony export (immutable) */ __webpack_exports__["d"] = setI18n;
/* harmony export (immutable) */ __webpack_exports__["b"] = getI18n;
/* unused harmony export reactI18nextModule */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false,
  omitBoundRerender: true
};

var i18n = void 0;

function setDefaults(options) {
  defaultOptions = _extends({}, defaultOptions, options);
}

function getDefaults() {
  return defaultOptions;
}

function setI18n(instance) {
  i18n = instance;
}

function getI18n() {
  return i18n;
}

var reactI18nextModule = {
  type: '3rdParty',

  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PERSISTENCE_LOCAL_STORAGE_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PERSISTENCE_ACTION_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_config_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_configuration_app_config_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_configuration_nodes_config_actions__ = __webpack_require__(117);
var PERSISTENCE_LOCAL_STORAGE_KEY="app";var PERSISTENCE_ACTION_KEY="persistentAppState";var persistenceMiddleware=function persistenceMiddleware(_ref){var getState=_ref.getState;return function(next){return function(action){var type=action.type,label=action.label;if(type===__WEBPACK_IMPORTED_MODULE_1__api_actions__["h" /* REQUEST_SUCCESS */]&&label===__WEBPACK_IMPORTED_MODULE_0__reducers_config_actions__["b" /* CONFIG_READ */]){action[PERSISTENCE_ACTION_KEY]=JSON.parse(localStorage.getItem(PERSISTENCE_LOCAL_STORAGE_KEY));}else if(type===__WEBPACK_IMPORTED_MODULE_1__api_actions__["h" /* REQUEST_SUCCESS */]&&(label===__WEBPACK_IMPORTED_MODULE_2__scenes_configuration_app_config_actions__["c" /* APP_CONFIG_CONFIG_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_3__scenes_configuration_nodes_config_actions__["p" /* NODES_CONFIG_NODE_CONFIG_SUBMIT */])){localStorage.removeItem(PERSISTENCE_LOCAL_STORAGE_KEY);}var result=next(action);var appState=getState().app;if(appState.endpointId!==null){localStorage.setItem(PERSISTENCE_LOCAL_STORAGE_KEY,JSON.stringify({endpointId:appState.endpointId,language:appState.language,isSidebarCollapsed:appState.isSidebarCollapsed,user:{username:appState.user.username,token:appState.user.token,providerId:appState.user.providerId}}));}return result;};};};/* harmony default export */ __webpack_exports__["b"] = (persistenceMiddleware);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUILDER_DSD_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUILDER_DSD_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILDER_DSD_LIST_DSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showBuilderDsdList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideBuilderDsdList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return readBuilderDsdListDsds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var BUILDER_DSD_LIST_SHOW='BUILDER_DSD_LIST_SHOW';var BUILDER_DSD_LIST_HIDE='BUILDER_DSD_LIST_HIDE';var BUILDER_DSD_LIST_DSDS_READ='BUILDER_DSD_LIST_DSDS_READ';var showBuilderDsdList=function showBuilderDsdList(){return{type:BUILDER_DSD_LIST_SHOW};};var hideBuilderDsdList=function hideBuilderDsdList(){return{type:BUILDER_DSD_LIST_HIDE};};var readBuilderDsdListDsds=function readBuilderDsdListDsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(BUILDER_DSD_LIST_DSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(null,true));};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(693);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(148);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 278 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 279 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(281)('keys');
var uid = __webpack_require__(210);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(99);
var global = __webpack_require__(119);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(209) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 282 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 283 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(278);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(147);
var dPs = __webpack_require__(701);
var enumBugKeys = __webpack_require__(282);
var IE_PROTO = __webpack_require__(280)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(387)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(702).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(120).f;
var has = __webpack_require__(130);
var TAG = __webpack_require__(100)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(100);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(119);
var core = __webpack_require__(99);
var LIBRARY = __webpack_require__(209);
var wksExt = __webpack_require__(287);
var defineProperty = __webpack_require__(120).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = addEventListenerWrap;

var _addDomEventListener = __webpack_require__(396);

var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = _reactDom2['default'].unstable_batchedUpdates ? function run(e) {
    _reactDom2['default'].unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener2['default'])(target, eventType, callback, option);
}
module.exports = exports['default'];

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toArray */
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiveIndex;
/* unused harmony export getActiveKey */
/* unused harmony export setTransform */
/* unused harmony export isTransformSupported */
/* unused harmony export setTransition */
/* harmony export (immutable) */ __webpack_exports__["e"] = getTransformPropValue;
/* unused harmony export isVertical */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTransformByIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMarginStyle;
/* unused harmony export getStyle */
/* unused harmony export setPxStyle */
/* harmony export (immutable) */ __webpack_exports__["b"] = getDataAttr;
/* unused harmony export getLeft */
/* unused harmony export getTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransformSupported(style) {
  return 'transform' in style || 'webkitTransform' in style || 'MozTransform' in style;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}
function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

function toNum(style, property) {
  return +style.getPropertyValue(property).replace('px', '');
}

function getTypeValue(start, current, end, tabNode, wrapperNode) {
  var total = getStyle(wrapperNode, 'padding-' + start);
  if (!tabNode || !tabNode.parentNode) {
    return total;
  }

  var childNodes = tabNode.parentNode.childNodes;

  Array.prototype.some.call(childNodes, function (node) {
    var style = window.getComputedStyle(node);

    if (node !== tabNode) {
      total += toNum(style, 'margin-' + start);
      total += node[current];
      total += toNum(style, 'margin-' + end);

      if (style.boxSizing === 'content-box') {
        total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
      }
      return false;
    }

    // We need count current node margin
    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
    total += toNum(style, 'margin-' + start);

    return true;
  });

  return total;
}

function getLeft(tabNode, wrapperNode) {
  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}

function getTop(tabNode, wrapperNode) {
  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(410);
} catch (err) {
  var index = __webpack_require__(410);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCssAnimationSupported", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["default"] = (cssAnimation);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(896);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["u"] = toTitle;
/* harmony export (immutable) */ __webpack_exports__["k"] = getValuePropValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = getPropValue;
/* unused harmony export isMultiple */
/* harmony export (immutable) */ __webpack_exports__["m"] = isCombobox;
/* harmony export (immutable) */ __webpack_exports__["n"] = isMultipleOrTags;
/* harmony export (immutable) */ __webpack_exports__["o"] = isMultipleOrTagsOrCombobox;
/* harmony export (immutable) */ __webpack_exports__["p"] = isSingleMode;
/* harmony export (immutable) */ __webpack_exports__["t"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["h"] = getMapKey;
/* harmony export (immutable) */ __webpack_exports__["q"] = preventDefaultEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = findIndexInValueBySingleValue;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLabelFromPropsValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSelectKeys;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSELECTABLE_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNSELECTABLE_ATTRIBUTE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = findFirstMenuItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = includesSeparators;
/* harmony export (immutable) */ __webpack_exports__["s"] = splitBySeparators;
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultFilterFn;
/* harmony export (immutable) */ __webpack_exports__["v"] = validateOptionValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = saveRef;
/* harmony export (immutable) */ __webpack_exports__["f"] = generateUUID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function toTitle(title) {
  if (typeof title === 'string') {
    return title;
  }

  return '';
}
function getValuePropValue(child) {
  if (!child) {
    return null;
  }

  var props = child.props;

  if ('value' in props) {
    return props.value;
  }

  if (child.key) {
    return child.key;
  }

  if (child.type && child.type.isSelectOptGroup && props.label) {
    return props.label;
  }

  throw new Error("Need at least a key or a value or a label (only for OptGroup) for ".concat(child));
}
function getPropValue(child, prop) {
  if (prop === 'value') {
    return getValuePropValue(child);
  }

  return child.props[prop];
}
function isMultiple(props) {
  return props.multiple;
}
function isCombobox(props) {
  return props.combobox;
}
function isMultipleOrTags(props) {
  return props.multiple || props.tags;
}
function isMultipleOrTagsOrCombobox(props) {
  return isMultipleOrTags(props) || isCombobox(props);
}
function isSingleMode(props) {
  return !isMultipleOrTagsOrCombobox(props);
}
function toArray(value) {
  var ret = value;

  if (value === undefined) {
    ret = [];
  } else if (!Array.isArray(value)) {
    ret = [value];
  }

  return ret;
}
function getMapKey(value) {
  return "".concat(typeof value, "-").concat(value);
}
function preventDefaultEvent(e) {
  e.preventDefault();
}
function findIndexInValueBySingleValue(value, singleValue) {
  var index = -1;

  if (value) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === singleValue) {
        index = i;
        break;
      }
    }
  }

  return index;
}
function getLabelFromPropsValue(value, key) {
  var label;
  value = toArray(value);

  if (value) {
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < value.length; i++) {
      if (value[i].key === key) {
        label = value[i].label;
        break;
      }
    }
  }

  return label;
}
function getSelectKeys(menuItems, value) {
  if (value === null || value === undefined) {
    return [];
  }

  var selectedKeys = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(menuItems, function (item) {
    var type = item.type;

    if (type.isMenuItemGroup) {
      selectedKeys = selectedKeys.concat(getSelectKeys(item.props.children, value));
    } else {
      var itemValue = getValuePropValue(item);
      var itemKey = item.key;

      if (findIndexInValueBySingleValue(value, itemValue) !== -1 && itemKey) {
        selectedKeys.push(itemKey);
      }
    }
  });
  return selectedKeys;
}
var UNSELECTABLE_STYLE = {
  userSelect: 'none',
  WebkitUserSelect: 'none'
};
var UNSELECTABLE_ATTRIBUTE = {
  unselectable: 'on'
};
function findFirstMenuItem(children) {
  // tslint:disable-next-line:prefer-for-of
  for (var i = 0; i < children.length; i++) {
    var child = children[i];

    if (child.type.isMenuItemGroup) {
      var found = findFirstMenuItem(child.props.children);

      if (found) {
        return found;
      }
    } else if (!child.props.disabled) {
      return child;
    }
  }

  return null;
}
function includesSeparators(str, separators) {
  // tslint:disable-next-line:prefer-for-of
  for (var i = 0; i < separators.length; ++i) {
    if (str.lastIndexOf(separators[i]) > 0) {
      return true;
    }
  }

  return false;
}
function splitBySeparators(str, separators) {
  var reg = new RegExp("[".concat(separators.join(), "]"));
  return str.split(reg).filter(function (token) {
    return token;
  });
}
function defaultFilterFn(input, child) {
  if (child.props.disabled) {
    return false;
  }

  var value = toArray(getPropValue(child, this.props.optionFilterProp)).join('');
  return value.toLowerCase().indexOf(input.toLowerCase()) > -1;
}
function validateOptionValue(value, props) {
  if (isSingleMode(props) || isMultiple(props)) {
    return;
  }

  if (typeof value !== 'string') {
    throw new Error("Invalid `value` of type `".concat(typeof value, "` supplied to Option, ") + "expected `string` when `tags/combobox` is `true`.");
  }
}
function saveRef(instance, name) {
  return function (node) {
    instance[name] = node;
  };
}
function generateUUID() {
  if (false) {
    return 'test-uuid';
  }

  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // tslint:disable-next-line:no-bitwise
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16); // tslint:disable-next-line:no-bitwise

    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
  });
  return uuid;
}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _reactLifecyclesCompat = __webpack_require__(49);

var _configProvider = __webpack_require__(35);

var _icon = _interopRequireDefault(__webpack_require__(25));

var _type = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return value;
}

var InputSizes = (0, _type.tuple)('small', 'default', 'large');

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onPressEnter = _this$props.onPressEnter,
          onKeyDown = _this$props.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.handleReset = function (e) {
      _this.setValue('', e);
    };

    _this.handleChange = function (e) {
      _this.setValue(e.target.value, e);
    };

    _this.renderComponent = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var customizePrefixCls = _this.props.prefixCls;
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      return _this.renderLabeledInput(prefixCls, _this.renderInput(prefixCls));
    };

    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(Input, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "getInputClassName",
    value: function getInputClassName(prefixCls) {
      var _classNames;

      var _this$props2 = this.props,
          size = _this$props2.size,
          disabled = _this$props2.disabled;
      return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    }
  }, {
    key: "setValue",
    value: function setValue(value, e) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      var onChange = this.props.onChange;

      if (onChange) {
        var event = e;

        if (e.type === 'click') {
          // click clear icon
          event = Object.create(e);
          event.target = this.input;
          event.currentTarget = this.input;
          var originalInputValue = this.input.value; // change input value cause e.target.value should be '' when clear input

          this.input.value = '';
          onChange(event); // reset input value

          this.input.value = originalInputValue;
          return;
        }

        onChange(event);
      }
    }
  }, {
    key: "renderClearIcon",
    value: function renderClearIcon(prefixCls) {
      var allowClear = this.props.allowClear;
      var value = this.state.value;

      if (!allowClear || value === undefined || value === '') {
        return null;
      }

      return React.createElement(_icon["default"], {
        type: "close-circle",
        theme: "filled",
        onClick: this.handleReset,
        className: "".concat(prefixCls, "-clear-icon"),
        role: "button"
      });
    }
  }, {
    key: "renderSuffix",
    value: function renderSuffix(prefixCls) {
      var _this$props3 = this.props,
          suffix = _this$props3.suffix,
          allowClear = _this$props3.allowClear;

      if (suffix || allowClear) {
        return React.createElement("span", {
          className: "".concat(prefixCls, "-suffix")
        }, this.renderClearIcon(prefixCls), suffix);
      }

      return null;
    }
  }, {
    key: "renderLabeledInput",
    value: function renderLabeledInput(prefixCls, children) {
      var _classNames3;

      var props = this.props; // Not wrap when there is not addons

      if (!props.addonBefore && !props.addonAfter) {
        return children;
      }

      var wrapperClassName = "".concat(prefixCls, "-group");
      var addonClassName = "".concat(wrapperClassName, "-addon");
      var addonBefore = props.addonBefore ? React.createElement("span", {
        className: addonClassName
      }, props.addonBefore) : null;
      var addonAfter = props.addonAfter ? React.createElement("span", {
        className: addonClassName
      }, props.addonAfter) : null;
      var className = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
      var groupClassName = (0, _classnames["default"])("".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), props.size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
      // and put style prop in wrapper

      return React.createElement("span", {
        className: groupClassName,
        style: props.style
      }, React.createElement("span", {
        className: className
      }, addonBefore, React.cloneElement(children, {
        style: null
      }), addonAfter));
    }
  }, {
    key: "renderLabeledIcon",
    value: function renderLabeledIcon(prefixCls, children) {
      var _classNames4;

      var props = this.props;
      var suffix = this.renderSuffix(prefixCls);

      if (!('prefix' in props) && !suffix) {
        return children;
      }

      var prefix = props.prefix ? React.createElement("span", {
        className: "".concat(prefixCls, "-prefix")
      }, props.prefix) : null;
      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames4, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _classNames4));
      return React.createElement("span", {
        className: affixWrapperCls,
        style: props.style
      }, prefix, React.cloneElement(children, {
        style: null,
        className: this.getInputClassName(prefixCls)
      }), suffix);
    }
  }, {
    key: "renderInput",
    value: function renderInput(prefixCls) {
      var className = this.props.className;
      var value = this.state.value; // Fix https://fb.me/react-unknown-prop

      var otherProps = (0, _omit["default"])(this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      'defaultValue']);
      return this.renderLabeledIcon(prefixCls, React.createElement("input", _extends({}, otherProps, {
        value: fixControlledValue(value),
        onChange: this.handleChange,
        className: (0, _classnames["default"])(this.getInputClassName(prefixCls), className),
        onKeyDown: this.handleKeyDown,
        ref: this.saveInput
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return Input;
}(React.Component);

Input.defaultProps = {
  type: 'text',
  disabled: false
};
Input.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.oneOf(InputSizes),
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  addonBefore: PropTypes.node,
  addonAfter: PropTypes.node,
  prefixCls: PropTypes.string,
  onPressEnter: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  allowClear: PropTypes.bool
};
(0, _reactLifecyclesCompat.polyfill)(Input);
var _default = Input;
exports["default"] = _default;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(38);

var _Event = _interopRequireDefault(__webpack_require__(905));

var _raf = _interopRequireDefault(__webpack_require__(906));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var styleForPesudo; // Where el is the DOM element you'd like to test for visibility

function isHidden(element) {
  if (false) {
    return false;
  }

  return !element || element.offsetParent === null;
}

var Wave =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Wave, _React$Component);

  function Wave() {
    var _this;

    _classCallCheck(this, Wave);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Wave).apply(this, arguments));
    _this.animationStart = false;
    _this.destroy = false;

    _this.onClick = function (node, waveColor) {
      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
        return;
      }

      var insertExtraNode = _this.props.insertExtraNode;
      _this.extraNode = document.createElement('div');
      var extraNode = _this.extraNode;
      extraNode.className = 'ant-click-animating-node';

      var attributeName = _this.getAttributeName();

      node.removeAttribute(attributeName);
      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey

      styleForPesudo = styleForPesudo || document.createElement('style');

      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && _this.isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
      waveColor !== 'transparent') {
        extraNode.style.borderColor = waveColor;
        styleForPesudo.innerHTML = "[ant-click-animating-without-extra-node]:after { border-color: ".concat(waveColor, "; }");

        if (!document.body.contains(styleForPesudo)) {
          document.body.appendChild(styleForPesudo);
        }
      }

      if (insertExtraNode) {
        node.appendChild(extraNode);
      }

      _Event["default"].addStartEventListener(node, _this.onTransitionStart);

      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
    };

    _this.bindAnimationEvent = function (node) {
      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
        return;
      }

      var onClick = function onClick(e) {
        // Fix radio button click twice
        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
          return;
        }

        _this.resetEffect(node); // Get wave color from target


        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
        _this.clickWaveTimeoutId = window.setTimeout(function () {
          return _this.onClick(node, waveColor);
        }, 0);

        _raf["default"].cancel(_this.animationStartId);

        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.

        _this.animationStartId = (0, _raf["default"])(function () {
          _this.animationStart = false;
        }, 10);
      };

      node.addEventListener('click', onClick, true);
      return {
        cancel: function cancel() {
          node.removeEventListener('click', onClick, true);
        }
      };
    };

    _this.onTransitionStart = function (e) {
      if (_this.destroy) return;
      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_assertThisInitialized(_this)));

      if (!e || e.target !== node) {
        return;
      }

      if (!_this.animationStart) {
        _this.resetEffect(node);
      }
    };

    _this.onTransitionEnd = function (e) {
      if (!e || e.animationName !== 'fadeEffect') {
        return;
      }

      _this.resetEffect(e.target);
    };

    return _this;
  }

  _createClass(Wave, [{
    key: "isNotGrey",
    value: function isNotGrey(color) {
      var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);

      if (match && match[1] && match[2] && match[3]) {
        return !(match[1] === match[2] && match[2] === match[3]);
      }

      return true;
    }
  }, {
    key: "getAttributeName",
    value: function getAttributeName() {
      var insertExtraNode = this.props.insertExtraNode;
      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
    }
  }, {
    key: "resetEffect",
    value: function resetEffect(node) {
      if (!node || node === this.extraNode || !(node instanceof Element)) {
        return;
      }

      var insertExtraNode = this.props.insertExtraNode;
      var attributeName = this.getAttributeName();
      node.removeAttribute(attributeName);
      this.removeExtraStyleNode();

      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
        node.removeChild(this.extraNode);
      }

      _Event["default"].removeStartEventListener(node, this.onTransitionStart);

      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
    }
  }, {
    key: "removeExtraStyleNode",
    value: function removeExtraStyleNode() {
      if (styleForPesudo) {
        styleForPesudo.innerHTML = '';
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = (0, _reactDom.findDOMNode)(this);

      if (node.nodeType !== 1) {
        return;
      }

      this.instance = this.bindAnimationEvent(node);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.cancel();
      }

      if (this.clickWaveTimeoutId) {
        clearTimeout(this.clickWaveTimeoutId);
      }

      this.destroy = true;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return Wave;
}(React.Component);

exports["default"] = Wave;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(121),
    isKey = __webpack_require__(300),
    stringToPath = __webpack_require__(916),
    toString = __webpack_require__(940);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(121),
    isSymbol = __webpack_require__(213);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(919),
    mapCacheDelete = __webpack_require__(935),
    mapCacheGet = __webpack_require__(937),
    mapCacheHas = __webpack_require__(938),
    mapCacheSet = __webpack_require__(939);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(135),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

exports.argumentContainer = argumentContainer;
exports.identity = identity;
exports.flattenArray = flattenArray;
exports.treeTraverse = treeTraverse;
exports.flattenFields = flattenFields;
exports.normalizeValidateRules = normalizeValidateRules;
exports.getValidateTriggers = getValidateTriggers;
exports.getValueFromEvent = getValueFromEvent;
exports.getErrorStrs = getErrorStrs;
exports.getParams = getParams;
exports.isEmptyObject = isEmptyObject;
exports.hasRules = hasRules;
exports.startsWith = startsWith;

var _hoistNonReactStatics = __webpack_require__(205);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _warning = __webpack_require__(435);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
}

function argumentContainer(Container, WrappedComponent) {
  /* eslint no-param-reassign:0 */
  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
  Container.WrappedComponent = WrappedComponent;
  return (0, _hoistNonReactStatics2['default'])(Container, WrappedComponent);
}

function identity(obj) {
  return obj;
}

function flattenArray(arr) {
  return Array.prototype.concat.apply([], arr);
}

function treeTraverse() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tree = arguments[1];
  var isLeafNode = arguments[2];
  var errorMessage = arguments[3];
  var callback = arguments[4];

  if (isLeafNode(path, tree)) {
    callback(path, tree);
  } else if (tree === undefined || tree === null) {
    // Do nothing
  } else if (Array.isArray(tree)) {
    tree.forEach(function (subTree, index) {
      return treeTraverse(path + '[' + index + ']', subTree, isLeafNode, errorMessage, callback);
    });
  } else {
    // It's object and not a leaf node
    if (typeof tree !== 'object') {
      (0, _warning2['default'])(false, errorMessage);
      return;
    }
    Object.keys(tree).forEach(function (subTreeKey) {
      var subTree = tree[subTreeKey];
      treeTraverse('' + path + (path ? '.' : '') + subTreeKey, subTree, isLeafNode, errorMessage, callback);
    });
  }
}

function flattenFields(maybeNestedFields, isLeafNode, errorMessage) {
  var fields = {};
  treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, function (path, node) {
    fields[path] = node;
  });
  return fields;
}

function normalizeValidateRules(validate, rules, validateTrigger) {
  var validateRules = validate.map(function (item) {
    var newItem = (0, _extends3['default'])({}, item, {
      trigger: item.trigger || []
    });
    if (typeof newItem.trigger === 'string') {
      newItem.trigger = [newItem.trigger];
    }
    return newItem;
  });
  if (rules) {
    validateRules.push({
      trigger: validateTrigger ? [].concat(validateTrigger) : [],
      rules: rules
    });
  }
  return validateRules;
}

function getValidateTriggers(validateRules) {
  return validateRules.filter(function (item) {
    return !!item.rules && item.rules.length;
  }).map(function (item) {
    return item.trigger;
  }).reduce(function (pre, curr) {
    return pre.concat(curr);
  }, []);
}

function getValueFromEvent(e) {
  // To support custom element
  if (!e || !e.target) {
    return e;
  }
  var target = e.target;

  return target.type === 'checkbox' ? target.checked : target.value;
}

function getErrorStrs(errors) {
  if (errors) {
    return errors.map(function (e) {
      if (e && e.message) {
        return e.message;
      }
      return e;
    });
  }
  return errors;
}

function getParams(ns, opt, cb) {
  var names = ns;
  var options = opt;
  var callback = cb;
  if (cb === undefined) {
    if (typeof names === 'function') {
      callback = names;
      options = {};
      names = undefined;
    } else if (Array.isArray(names)) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      } else {
        options = options || {};
      }
    } else {
      callback = options;
      options = names || {};
      names = undefined;
    }
  }
  return {
    names: names,
    options: options,
    callback: callback
  };
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function hasRules(validate) {
  if (validate) {
    return validate.some(function (item) {
      return item.rules && item.rules.length;
    });
  }
  return false;
}

function startsWith(str, prefix) {
  return str.lastIndexOf(prefix, 0) === 0;
}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSdmxTypesTranslations; });
var getSdmxTypesTranslations=function getSdmxTypesTranslations(t){var sdmxTypesTranslations=function sdmxTypesTranslations(t){return{codelist:t('sdmxTypes.codelist'),categoryscheme:t('sdmxTypes.categoryScheme'),conceptscheme:t('sdmxTypes.conceptScheme'),dataflow:t('sdmxTypes.dataflow'),datastructure:t('sdmxTypes.dsd'),dsd:t('sdmxTypes.dsd'),metadataflow:t('sdmxTypes.metadataflow'),agencyscheme:t('sdmxTypes.agencyScheme'),contentconstraint:t('sdmxTypes.contentConstraint'),hierarchicalcodelist:t('sdmxTypes.hierarchicalCodelist'),metadatastructure:t('sdmxTypes.metadataStructure'),msd:t('sdmxTypes.metadataStructure')};};return sdmxTypesTranslations(t!==undefined?t:function(str){return str;});};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BUILDER_CUBE_TREE_CUBE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUILDER_CUBE_TREE_CUBE_CATEGORY_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUILDER_CUBE_TREE_CUBE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BUILDER_CUBE_TREE_CUBE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUILDER_CUBE_TREE_CATEGORY_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUILDER_CUBE_TREE_CATEGORY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return readBuilderCubeTreeCategorisedCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteBuilderCubeTreeCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectBuilderCubeTreeCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectBuilderCubeTreeCubeCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createBuilderCubeTreeCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteBuilderCubeTreeCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return moveBuilderCubeTreeCategory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ='BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ';var BUILDER_CUBE_TREE_CUBE_SELECT='BUILDER_CUBE_TREE_CUBE_SELECT';var BUILDER_CUBE_TREE_CUBE_CATEGORY_SELECT='BUILDER_CUBE_TREE_CUBE_CATEGORY_SELECT';var BUILDER_CUBE_TREE_CUBE_CREATE='BUILDER_CUBE_TREE_CUBE_CREATE';var BUILDER_CUBE_TREE_CUBE_DELETE='BUILDER_CUBE_TREE_CUBE_DELETE';var BUILDER_CUBE_TREE_CATEGORY_DELETE='BUILDER_CUBE_TREE_CATEGORY_DELETE';var BUILDER_CUBE_TREE_CATEGORY_MOVE='BUILDER_CUBE_TREE_CATEGORY_MOVE';var readBuilderCubeTreeCategorisedCubes=function readBuilderCubeTreeCategorisedCubes(forbiddenCubes,forbiddenCategories){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["h" /* getAllCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])()]),{forbiddenCubes:forbiddenCubes,forbiddenCategories:forbiddenCategories});};var deleteBuilderCubeTreeCube=function deleteBuilderCubeTreeCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(BUILDER_CUBE_TREE_CUBE_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId),function(t){return{success:t('scenes.dataManager.builder.cubeTree.messages.cubeDelete.success')};});};var selectBuilderCubeTreeCube=function selectBuilderCubeTreeCube(cubeId){return{type:BUILDER_CUBE_TREE_CUBE_SELECT,cubeId:cubeId};};var selectBuilderCubeTreeCubeCategory=function selectBuilderCubeTreeCubeCategory(category){return{type:BUILDER_CUBE_TREE_CUBE_CATEGORY_SELECT,category:category};};var createBuilderCubeTreeCube=function createBuilderCubeTreeCube(cubeCategoryId){return{type:BUILDER_CUBE_TREE_CUBE_CREATE,cubeCategoryId:cubeCategoryId};};var deleteBuilderCubeTreeCategory=function deleteBuilderCubeTreeCategory(catCode){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(BUILDER_CUBE_TREE_CATEGORY_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_13" /* getDeleteDCSCategoryUrl */])(catCode),function(t){return{success:t('scenes.dataManager.builder.cubeTree.messages.categoryDelete.success')};});};var moveBuilderCubeTreeCategory=function moveBuilderCubeTreeCategory(categories){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(BUILDER_CUBE_TREE_CATEGORY_MOVE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_38" /* getEditDCSCategoryUrl */])(),categories.map(function(cat){return{parCode:cat.ParCode,catCode:cat.CatCode,idCat:cat.IDCat,ord:cat.Ord,labels:cat.labels};}),function(t){return{success:t('scenes.dataManager.builder.cubeTree.messages.categoryMove.success')};});};

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUILDER_CUBE_FORM_DSD_CONTROL_DSD_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUILDER_CUBE_FORM_DSD_CONTROL_DSD_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return showBuilderCubeFormDsdControlDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hideBuilderCUbeFormDsdControlDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return readBuilderCubeFormDsdControlDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setBuilderCubeFormDsdControlDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return unsetBuilderCubeFormDsdControlDsd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_SHOW='BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_SHOW';var BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_HIDE='BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_HIDE';var BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_READ='BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_READ';var BUILDER_CUBE_FORM_DSD_CONTROL_DSD_SET='BUILDER_CUBE_FORM_DSD_CONTROL_DSD_SET';var BUILDER_CUBE_FORM_DSD_CONTROL_DSD_UNSET='BUILDER_CUBE_FORM_DSD_CONTROL_DSD_UNSET';var showBuilderCubeFormDsdControlDsds=function showBuilderCubeFormDsdControlDsds(){return{type:BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_SHOW};};var hideBuilderCUbeFormDsdControlDsds=function hideBuilderCUbeFormDsdControlDsds(){return{type:BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_HIDE};};var readBuilderCubeFormDsdControlDsds=function readBuilderCubeFormDsdControlDsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])(null,true));};var setBuilderCubeFormDsdControlDsd=function setBuilderCubeFormDsdControlDsd(dsdTriplet){return{type:BUILDER_CUBE_FORM_DSD_CONTROL_DSD_SET,dsdTriplet:dsdTriplet};};var unsetBuilderCubeFormDsdControlDsd=function unsetBuilderCubeFormDsdControlDsd(){return{type:BUILDER_CUBE_FORM_DSD_CONTROL_DSD_UNSET};};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILE_MAPPING_WIZARD_STEP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOT_STAT_COLUMN_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_selector_reducer__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_selector_actions__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__csv_form_actions__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__csv_row_list_reducer__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__csv_column_value_list_reducer__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cube_component_list_reducer__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_mapper_actions__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cube_component_list_actions__ = __webpack_require__(452);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION=0;var FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD=1;var FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING=2;var FILE_MAPPING_WIZARD_STEP_NAME=3;var DOT_STAT_COLUMN_NAME="_FREQ_";var fileMappingWizardReducer=Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])({cubeSelector:__WEBPACK_IMPORTED_MODULE_3__cube_selector_reducer__["a" /* default */],csvRowList:__WEBPACK_IMPORTED_MODULE_7__csv_row_list_reducer__["a" /* default */],csvColumnValueList:__WEBPACK_IMPORTED_MODULE_8__csv_column_value_list_reducer__["a" /* default */],cubeComponentList:__WEBPACK_IMPORTED_MODULE_9__cube_component_list_reducer__["b" /* default */]}),shared:function shared(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{csvForm:{file:null,xmlFile:null,separator:';',delimiter:null,hasHeader:true,hasDotStatFormat:false},fileFormat:'csv',cubeId:null,cubeCode:null,cube:null,fileServerPath:null,xmlServerPath:null,csvServerPath:null,csvHeader:null,components:[],selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* FILE_MAPPING_WIZARD_SHOW */]:return Object.assign({},state,{cubeId:action.cubeId!==undefined?action.cubeId:null,cubeCode:action.cubeCode!==undefined?action.cubeCode:null,cube:null,components:[],selectedCubeComponentCode:null,selectedComponent:null,fileFormat:'csv',csvForm:{file:null,xmlFile:null,separator:';',delimiter:null,hasHeader:true,hasDotStatFormat:false},fileServerPath:null,xmlServerPath:null,csvServerPath:null});case __WEBPACK_IMPORTED_MODULE_5__csv_form_actions__["a" /* FILE_MAPPING_WIZARD_CSV_FORM_CHANGE */]:return Object.assign({},state,{csvForm:Object.assign({},state.csvForm,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(action.fields,function(field){return field.value;})),fileServerPath:null,xmlServerPath:null,csvServerPath:null,csvHeader:null,components:[],selectedColumnName:null,selectedComponent:null});case __WEBPACK_IMPORTED_MODULE_5__csv_form_actions__["b" /* FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET */]:return Object.assign({},state,{fileFormat:action.fileFormat,csvForm:{file:null,xmlFile:null,separator:';',delimiter:null,hasHeader:true,hasDotStatFormat:false},fileServerPath:null,xmlServerPath:null,csvServerPath:null});case __WEBPACK_IMPORTED_MODULE_4__cube_selector_actions__["b" /* FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET */]:return Object.assign({},state,{cubeId:action.cubeId,cubeCode:action.cubeCode,cube:null,components:[],selectedCubeComponentCode:null,selectedComponent:null,fileFormat:'csv',csvForm:{file:null,xmlFile:null,separator:';',delimiter:null,hasHeader:true,hasDotStatFormat:false},fileServerPath:null,xmlServerPath:null,csvServerPath:null});case __WEBPACK_IMPORTED_MODULE_4__cube_selector_actions__["c" /* FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET */]:return Object.assign({},state,{cubeId:null,cubeCode:null,cube:null,components:[],selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:null,fileFormat:'csv',csvForm:{file:null,xmlFile:null,separator:';',delimiter:null,hasHeader:true,hasDotStatFormat:false},fileServerPath:null,xmlServerPath:null,csvServerPath:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_WIZARD_COLUMN_SELECT */]:return Object.assign({},state,{selectedColumnName:action.columnName,selectedComponent:null});case __WEBPACK_IMPORTED_MODULE_11__cube_component_list_actions__["a" /* FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT */]:return Object.assign({},state,{selectedCubeComponentCode:action.cubeComponentCode,selectedComponent:null});case __WEBPACK_IMPORTED_MODULE_10__component_mapper_actions__["a" /* FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD */]:return Object.assign({},state,{selectedComponent:{columnName:action.columnName,cubeComponentCode:action.cubeComponentCode},selectedColumnName:null,selectedCubeComponentCode:null,components:[{columnName:action.columnName,cubeComponentCode:action.cubeComponentCode,cubeComponentType:[].concat(_toConsumableArray(state.cube.components.dimensions),_toConsumableArray(state.cube.components.timeDimensions),_toConsumableArray(state.cube.components.attributes),_toConsumableArray(state.cube.components.measures)).filter(function(comp){return comp.Code===action.cubeComponentCode;})[0].cubeComponentType}].concat(_toConsumableArray(state.components))});case __WEBPACK_IMPORTED_MODULE_10__component_mapper_actions__["b" /* FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL */]:return Object.assign({},state,{components:[].concat(_toConsumableArray(state.csvHeader.filter(function(columnNameToBeMapped){return state.components.map(function(mappedComponents){return mappedComponents.columnName;}).indexOf(columnNameToBeMapped)<0;}).map(function(columnNameToBeMapped){var relatedCubeComponentCodeArr=[].concat(_toConsumableArray(state.cube.components.dimensions),_toConsumableArray(state.cube.components.timeDimensions),_toConsumableArray(state.cube.components.attributes),_toConsumableArray(state.cube.components.measures)).filter(function(cubeComp){return cubeComp.Code===columnNameToBeMapped&&state.components.map(function(mappedComp){return mappedComp.cubeComponentCode;}).indexOf(cubeComp.Code)<0;});return relatedCubeComponentCodeArr.length>0?{columnName:columnNameToBeMapped,cubeComponentCode:relatedCubeComponentCodeArr[0].Code,cubeComponentType:relatedCubeComponentCodeArr[0].cubeComponentType}:null;}).filter(function(comp){return comp!==null;})),_toConsumableArray(state.components)),selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:null});case __WEBPACK_IMPORTED_MODULE_10__component_mapper_actions__["c" /* FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE */]:return Object.assign({},state,{components:state.components.filter(function(_ref){var columnName=_ref.columnName,cubeComponentCode=_ref.cubeComponentCode;return columnName!==action.columnName||cubeComponentCode!==action.cubeComponentCode;}).map(function(comp){return Object.assign({},comp);})});case __WEBPACK_IMPORTED_MODULE_10__component_mapper_actions__["d" /* FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL */]:return Object.assign({},state,{components:[],selectedComponent:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* FILE_MAPPING_WIZARD_HIDE */]:return{csvForm:{file:null,xmlFile:null,separator:';',delimiter:null,hasHeader:true,hasDotStatFormat:false},fileFormat:'csv',cubeId:null,cubeCode:null,cube:null,fileServerPath:null,xmlServerPath:null,csvServerPath:null,csvHeader:null,components:[],selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:null};case __WEBPACK_IMPORTED_MODULE_10__component_mapper_actions__["e" /* FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT */]:return Object.assign({},state,{selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:{columnName:action.columnName,cubeComponentCode:action.cubeComponentCode}});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* FILE_MAPPING_WIZARD_CUBE_READ */]:return Object.assign({},state,{cube:null});case __WEBPACK_IMPORTED_MODULE_5__csv_form_actions__["c" /* FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT */]:return Object.assign({},state,{fileServerPath:null,xmlServerPath:null,csvServerPath:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* FILE_MAPPING_WIZARD_CSV_HEADER_GET */]:return Object.assign({},state,{csvHeader:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_5__csv_form_actions__["c" /* FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT */]:var fileServerPath=Array.isArray(action.response)?action.response[0]:action.response;return Object.assign({},state,{fileServerPath:fileServerPath,csvServerPath:state.fileFormat==='csv'?fileServerPath:null,xmlServerPath:Array.isArray(action.response)?action.response[1]:null,components:[],selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* FILE_MAPPING_WIZARD_CSV_HEADER_GET */]:return Object.assign({},state,{csvHeader:action.response.concat(action.csvHasDotStatFormat?[DOT_STAT_COLUMN_NAME]:[])});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* FILE_MAPPING_WIZARD_CUBE_READ */]:return Object.assign({},state,{cube:Object.assign({},action.response,{components:{dimensions:action.response.Dimensions.filter(function(dim){return!dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{cubeComponentType:'Dimension'});}),timeDimensions:action.response.Dimensions.filter(function(dim){return dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{cubeComponentType:'TimeDimension'});}),tidAttributes:action.response.Attributes.filter(function(attr){return attr.IsTid;}).map(function(attr){return Object.assign({},attr,{cubeComponentType:'Attribute'});}),attributes:action.response.Attributes.filter(function(attr){return!attr.IsTid;}).map(function(attr){return Object.assign({},attr,{cubeComponentType:'Attribute'});}),measures:action.response.Measures.map(function(meas){return Object.assign({},meas,{cubeComponentType:'Measure'});})}})});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE */]:return{csvForm:{file:null,xmlFile:null,separator:';',delimiter:null,hasHeader:true,hasDotStatFormat:false},fileFormat:'csv',cubeId:null,cubeCode:null,cube:null,fileServerPath:null,xmlServerPath:null,csvServerPath:null,csvHeader:null,components:[],selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:null};case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* FILE_MAPPING_WIZARD_PX_TO_CSV_CONVERT */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* FILE_MAPPING_WIZARD_XLS_TO_CSV_CONVERT */]:return Object.assign({},state,{csvServerPath:action.response});default:return state;}default:return state;}},local:function local(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isVisible:false,isCubeComponentsVisible:false,isComponentsVisible:false,step:FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,name:null,tid:null,description:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* FILE_MAPPING_WIZARD_COMPONENTS_SHOW */]:return Object.assign({},state,{isComponentsVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* FILE_MAPPING_WIZARD_COMPONENTS_HIDE */]:return Object.assign({},state,{isComponentsVisible:false});case __WEBPACK_IMPORTED_MODULE_4__cube_selector_actions__["b" /* FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET */]:return Object.assign({},state,{name:'MAPP_'+new Date().getMilliseconds()+'_'+action.cubeCode.toUpperCase()});case __WEBPACK_IMPORTED_MODULE_4__cube_selector_actions__["c" /* FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET */]:return Object.assign({},state,{name:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* FILE_MAPPING_WIZARD_STEP_SET */]:return Object.assign({},state,{step:action.step});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW */]:return Object.assign({},state,{isCubeComponentsVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE */]:return Object.assign({},state,{isCubeComponentsVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* FILE_MAPPING_WIZARD_FORM_CHANGE */]:var _action$fields=action.fields,name=_action$fields.name,tid=_action$fields.tid,description=_action$fields.description;return Object.assign({},state,{name:name!==undefined?name:state.name,tid:tid!==undefined?tid:state.tid,description:description!==undefined?description:state.description});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE */]:return Object.assign({},state,{step:FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* FILE_MAPPING_WIZARD_SHOW */]:return Object.assign({},state,{isVisible:true,step:action.cubeId?FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD:FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,name:action.cubeCode?'MAPP_'+new Date().getMilliseconds()+'_'+action.cubeCode.toUpperCase():null});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* FILE_MAPPING_WIZARD_HIDE */]:return Object.assign({},state,{isVisible:false,isCubeComponentsVisible:false,step:FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,name:null,description:null,tid:null,isComponentsVisible:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE */]:return Object.assign({},state,{isVisible:false,isCubeComponentsVisibile:false,isComponentsVisible:false,step:FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,name:null,description:null,tid:null});default:return state;}default:return state;}}});/* harmony default export */ __webpack_exports__["f"] = (fileMappingWizardReducer);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return readFileMappingWizardCubeSelectorCategorisedCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setFileMappingWizardCubeSelectorCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return unsetFileMappingWizardCubeSelectorCube; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ='FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ';var FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET='FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET';var FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET='FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET';var readFileMappingWizardCubeSelectorCategorisedCubes=function readFileMappingWizardCubeSelectorCategorisedCubes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])()]);};var setFileMappingWizardCubeSelectorCube=function setFileMappingWizardCubeSelectorCube(cubeId,cubeCode){return{type:FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET,cubeId:cubeId,cubeCode:cubeCode};};var unsetFileMappingWizardCubeSelectorCube=function unsetFileMappingWizardCubeSelectorCube(){return{type:FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET};};

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_COL_VALUES_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFileMappingWizardCsvColumnValueListColValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showFileMappingWizardColumnValueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hideFileMappingWizardColumnValueList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_COL_VALUES_GET='FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_COL_VALUES_GET';var FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_SHOW='FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_SHOW';var FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_HIDE='FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_HIDE';var getFileMappingWizardCsvColumnValueListColValues=function getFileMappingWizardCsvColumnValueListColValues(colName,pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_COL_VALUES_GET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["U" /* getCsvTableColumnPreviewUrl */])(separator,delimiter,hasHeader,filePath),{SelCols:[colName],PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var showFileMappingWizardColumnValueList=function showFileMappingWizardColumnValueList(colName){return{type:FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_SHOW,colName:colName};};var hideFileMappingWizardColumnValueList=function hideFileMappingWizardColumnValueList(){return{type:FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_HIDE};};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setLoaderCsvFormMappingControlMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return unsetLoaderCsvFormMappingControlMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return showLoaderCsvFormMappingControlMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return showLoaderCsvFormMappingControlDetailMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return showLoaderCsvFormMappingControlSelectedMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hideLoaderCsvFormMappingControlMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hideLoaderCsvFormMappingControlDetailMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return hideLoaderCsvFormMappingControlSelectedMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return readLoaderCsvFormMappingControlMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return readLoaderCsvFormMappingControlDetailMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return readLoaderCsvFormMappingControlDetailMappingCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return readLoaderCsvFormMappingControlSelectedMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return readLoaderCsvFormMappingControlSelectedMappingCube; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET='LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET';var LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET='LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET';var LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW='LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW';var LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW='LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW';var LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW='LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW';var LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE='LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE';var LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE='LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE';var LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE='LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE';var LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ='LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ';var LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ='LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ';var LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ='LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ';var LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ='LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ';var LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ='LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ';var setLoaderCsvFormMappingControlMapping=function setLoaderCsvFormMappingControlMapping(mappingId){return{type:LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET,mappingId:mappingId};};var unsetLoaderCsvFormMappingControlMapping=function unsetLoaderCsvFormMappingControlMapping(){return{type:LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET};};var showLoaderCsvFormMappingControlMappings=function showLoaderCsvFormMappingControlMappings(){return{type:LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW};};var showLoaderCsvFormMappingControlDetailMapping=function showLoaderCsvFormMappingControlDetailMapping(mappingId){return{type:LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW,mappingId:mappingId};};var showLoaderCsvFormMappingControlSelectedMapping=function showLoaderCsvFormMappingControlSelectedMapping(){return{type:LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW};};var hideLoaderCsvFormMappingControlMappings=function hideLoaderCsvFormMappingControlMappings(){return{type:LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE};};var hideLoaderCsvFormMappingControlDetailMapping=function hideLoaderCsvFormMappingControlDetailMapping(){return{type:LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE};};var hideLoaderCsvFormMappingControlSelectedMapping=function hideLoaderCsvFormMappingControlSelectedMapping(){return{type:LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE};};var readLoaderCsvFormMappingControlMappings=function readLoaderCsvFormMappingControlMappings(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["h" /* getAllCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_42" /* getFileMappingUrl */])()]);};var readLoaderCsvFormMappingControlDetailMapping=function readLoaderCsvFormMappingControlDetailMapping(mappingId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_42" /* getFileMappingUrl */])(mappingId));};var readLoaderCsvFormMappingControlDetailMappingCube=function readLoaderCsvFormMappingControlDetailMappingCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var readLoaderCsvFormMappingControlSelectedMapping=function readLoaderCsvFormMappingControlSelectedMapping(mappingId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_42" /* getFileMappingUrl */])(mappingId));};var readLoaderCsvFormMappingControlSelectedMappingCube=function readLoaderCsvFormMappingControlSelectedMappingCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOADER_CSV_FORM_ROW_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADER_CSV_FORM_ROW_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_CSV_FORM_ROW_LIST_CSV_ROWS_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showLoaderCsvFormRowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hideLoaderCsvFormRowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLoaderCsvFormRowListCsvRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var LOADER_CSV_FORM_ROW_LIST_SHOW='LOADER_CSV_FORM_ROW_LIST_SHOW';var LOADER_CSV_FORM_ROW_LIST_HIDE='LOADER_CSV_FORM_ROW_LIST_HIDE';var LOADER_CSV_FORM_ROW_LIST_CSV_ROWS_GET='LOADER_CSV_FORM_ROW_LIST_CSV_ROWS_GET';var showLoaderCsvFormRowList=function showLoaderCsvFormRowList(){return{type:LOADER_CSV_FORM_ROW_LIST_SHOW};};var hideLoaderCsvFormRowList=function hideLoaderCsvFormRowList(){return{type:LOADER_CSV_FORM_ROW_LIST_HIDE};};var getLoaderCsvFormRowListCsvRows=function getLoaderCsvFormRowListCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,tid,filePath,idMappingSpecialTimePeriod){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(LOADER_CSV_FORM_ROW_LIST_CSV_ROWS_GET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,filePath,tid,idMappingSpecialTimePeriod),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_XML_ROW_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOADER_XML_ROW_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADER_XML_ROW_LIST_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hideLoaderXmlRowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showLoaderXmlRowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLoaderXmlFormRowListRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var LOADER_XML_ROW_LIST_HIDE='LOADER_XML_ROW_LIST_HIDE';var LOADER_XML_ROW_LIST_SHOW='LOADER_XML_ROW_LIST_SHOW';var LOADER_XML_ROW_LIST_ROWS_READ='LOADER_XML_ROW_LIST_ROWS_READ';var hideLoaderXmlRowList=function hideLoaderXmlRowList(){return{type:LOADER_XML_ROW_LIST_HIDE};};var showLoaderXmlRowList=function showLoaderXmlRowList(){return{type:LOADER_XML_ROW_LIST_SHOW};};var getLoaderXmlFormRowListRows=function getLoaderXmlFormRowListRows(dsdId,dsdAgencyId,dsdVersion,pageNum,pageSize,filterTable,sortCols,sortByDesc,filePath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(LOADER_XML_ROW_LIST_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_83" /* getSdmxMlTablePreviewUrl */])(dsdId,dsdAgencyId,dsdVersion,filePath),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStyleProperty */
/* harmony export (immutable) */ __webpack_exports__["c"] = getStyleValue;
/* unused harmony export getVendorPrefixes */
/* unused harmony export getVendorPrefixedEventName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return transitionEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportTransition; });
/* harmony export (immutable) */ __webpack_exports__["e"] = mergeChildren;
/* harmony export (immutable) */ __webpack_exports__["b"] = cloneProps;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTransitionName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Children_toArray__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment__);



// =================== Style ====================
var stylePrefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < stylePrefixes.length; i++) {
    ret = style.getPropertyValue(stylePrefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function getStyleValue(node, name) {
  return parseFloat(getStyleProperty(node, name));
}

// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}

var vendorPrefixes = getVendorPrefixes(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment__["canUseDOM"], typeof window !== 'undefined' ? window : {});

var style = {};

if (__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
  style = document.createElement('div').style;
}

var prefixedEventNames = {};

function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}

var animationEndName = getVendorPrefixedEventName('animationend');
var transitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(animationEndName && transitionEndName);

// ==================== Node ====================
/**
 * [Legacy] Find the same children in both prev & next list.
 * Insert not find one before the find one, otherwise in the end. For example:
 * - prev: [1,2,3]
 * - next: [2,4]
 * -> [1,2,4,3]
 */
function mergeChildren(prev, next) {
  var prevList = Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Children_toArray__["a" /* default */])(prev);
  var nextList = Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Children_toArray__["a" /* default */])(next);

  // Skip if is single children
  if (prevList.length === 1 && nextList.length === 1 && prevList[0].key === nextList[0].key) {
    return nextList;
  }

  var mergeList = [];
  var nextChildrenMap = {};
  var missMatchChildrenList = [];

  // Fill matched prev node into next node map
  prevList.forEach(function (prevNode) {
    if (prevNode && nextList.some(function (_ref) {
      var key = _ref.key;
      return key === prevNode.key;
    })) {
      if (missMatchChildrenList.length) {
        nextChildrenMap[prevNode.key] = missMatchChildrenList;
        missMatchChildrenList = [];
      }
    } else {
      missMatchChildrenList.push(prevNode);
    }
  });

  // Insert prev node before the matched next node
  nextList.forEach(function (nextNode) {
    if (nextNode && nextChildrenMap[nextNode.key]) {
      mergeList = mergeList.concat(nextChildrenMap[nextNode.key]);
    }
    mergeList.push(nextNode);
  });

  mergeList = mergeList.concat(missMatchChildrenList);

  return mergeList;
}

function cloneProps(props, propList) {
  var newProps = {};
  propList.forEach(function (prop) {
    if (prop in props) {
      newProps[prop] = props[prop];
    }
  });

  return newProps;
}

function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (typeof transitionName === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return transitionName + '-' + transitionType;
}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(57);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.warnOnlyTreeNode = warnOnlyTreeNode;
exports.arrDel = arrDel;
exports.arrAdd = arrAdd;
exports.posToArr = posToArr;
exports.getPosition = getPosition;
exports.isTreeNode = isTreeNode;
exports.getNodeChildren = getNodeChildren;
exports.isCheckDisabled = isCheckDisabled;
exports.traverseTreeNodes = traverseTreeNodes;
exports.mapChildren = mapChildren;
exports.getDragNodesKeys = getDragNodesKeys;
exports.calcDropPosition = calcDropPosition;
exports.calcSelectedKeys = calcSelectedKeys;
exports.convertDataToTree = convertDataToTree;
exports.convertTreeToEntities = convertTreeToEntities;
exports.parseCheckedKeys = parseCheckedKeys;
exports.conductCheck = conductCheck;
exports.conductExpandParent = conductExpandParent;
exports.getDataAndAria = getDataAndAria;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _toArray = __webpack_require__(465);

var _toArray2 = _interopRequireDefault(_toArray);

var _warning = __webpack_require__(316);

var _warning2 = _interopRequireDefault(_warning);

var _TreeNode = __webpack_require__(1022);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DRAG_SIDE_RANGE = 0.25;
var DRAG_MIN_GAP = 2;

var onlyTreeNodeWarned = false;

function warnOnlyTreeNode() {
  if (onlyTreeNodeWarned) return;

  onlyTreeNodeWarned = true;
  (0, _warning2['default'])(false, 'Tree only accept TreeNode as children.');
}

function arrDel(list, value) {
  var clone = list.slice();
  var index = clone.indexOf(value);
  if (index >= 0) {
    clone.splice(index, 1);
  }
  return clone;
}

function arrAdd(list, value) {
  var clone = list.slice();
  if (clone.indexOf(value) === -1) {
    clone.push(value);
  }
  return clone;
}

function posToArr(pos) {
  return pos.split('-');
}

function getPosition(level, index) {
  return level + '-' + index;
}

function isTreeNode(node) {
  return node && node.type && node.type.isTreeNode;
}

function getNodeChildren(children) {
  return (0, _toArray2['default'])(children).filter(isTreeNode);
}

function isCheckDisabled(node) {
  var _ref = node.props || {},
      disabled = _ref.disabled,
      disableCheckbox = _ref.disableCheckbox;

  return !!(disabled || disableCheckbox);
}

function traverseTreeNodes(treeNodes, callback) {
  function processNode(node, index, parent) {
    var children = node ? node.props.children : treeNodes;
    var pos = node ? getPosition(parent.pos, index) : 0;

    // Filter children
    var childList = getNodeChildren(children);

    // Process node if is not root
    if (node) {
      var data = {
        node: node,
        index: index,
        pos: pos,
        key: node.key || pos,
        parentPos: parent.node ? parent.pos : null
      };

      callback(data);
    }

    // Process children node
    _react.Children.forEach(childList, function (subNode, subIndex) {
      processNode(subNode, subIndex, { node: node, pos: pos });
    });
  }

  processNode(null);
}

/**
 * Use `rc-util` `toArray` to get the children list which keeps the key.
 * And return single node if children is only one(This can avoid `key` missing check).
 */
function mapChildren(children, func) {
  var list = (0, _toArray2['default'])(children).map(func);
  if (list.length === 1) {
    return list[0];
  }
  return list;
}

function getDragNodesKeys(treeNodes, node) {
  var _node$props = node.props,
      eventKey = _node$props.eventKey,
      pos = _node$props.pos;

  var dragNodesKeys = [];

  traverseTreeNodes(treeNodes, function (_ref2) {
    var key = _ref2.key;

    dragNodesKeys.push(key);
  });
  dragNodesKeys.push(eventKey || pos);
  return dragNodesKeys;
}

// Only used when drag, not affect SSR.
function calcDropPosition(event, treeNode) {
  var clientY = event.clientY;

  var _treeNode$selectHandl = treeNode.selectHandle.getBoundingClientRect(),
      top = _treeNode$selectHandl.top,
      bottom = _treeNode$selectHandl.bottom,
      height = _treeNode$selectHandl.height;

  var des = Math.max(height * DRAG_SIDE_RANGE, DRAG_MIN_GAP);

  if (clientY <= top + des) {
    return -1;
  } else if (clientY >= bottom - des) {
    return 1;
  }

  return 0;
}

/**
 * Return selectedKeys according with multiple prop
 * @param selectedKeys
 * @param props
 * @returns [string]
 */
function calcSelectedKeys(selectedKeys, props) {
  if (!selectedKeys) return undefined;

  var multiple = props.multiple;

  if (multiple) {
    return selectedKeys.slice();
  }

  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }
  return selectedKeys;
}

/**
 * Since React internal will convert key to string,
 * we need do this to avoid `checkStrictly` use number match
 */
function keyListToString(keyList) {
  if (!keyList) return keyList;
  return keyList.map(function (key) {
    return String(key);
  });
}

var internalProcessProps = function internalProcessProps(props) {
  return props;
};
function convertDataToTree(treeData, processer) {
  if (!treeData) return [];

  var _ref3 = processer || {},
      _ref3$processProps = _ref3.processProps,
      processProps = _ref3$processProps === undefined ? internalProcessProps : _ref3$processProps;

  var list = Array.isArray(treeData) ? treeData : [treeData];
  return list.map(function (_ref4) {
    var children = _ref4.children,
        props = (0, _objectWithoutProperties3['default'])(_ref4, ['children']);

    var childrenNodes = convertDataToTree(children, processer);

    return _react2['default'].createElement(
      _TreeNode2['default'],
      processProps(props),
      childrenNodes
    );
  });
}

// TODO: ========================= NEW LOGIC =========================
/**
 * Calculate treeNodes entities. `processTreeEntity` is used for `rc-tree-select`
 * @param treeNodes
 * @param processTreeEntity  User can customize the entity
 */
function convertTreeToEntities(treeNodes) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      initWrapper = _ref5.initWrapper,
      processEntity = _ref5.processEntity,
      onProcessFinished = _ref5.onProcessFinished;

  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities: posEntities,
    keyEntities: keyEntities
  };

  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }

  traverseTreeNodes(treeNodes, function (item) {
    var node = item.node,
        index = item.index,
        pos = item.pos,
        key = item.key,
        parentPos = item.parentPos;

    var entity = { node: node, index: index, key: key, pos: pos };

    posEntities[pos] = entity;
    keyEntities[key] = entity;

    // Fill children
    entity.parent = posEntities[parentPos];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }

    if (processEntity) {
      processEntity(entity, wrapper);
    }
  });

  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }

  return wrapper;
}

/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */
function parseCheckedKeys(keys) {
  if (!keys) {
    return null;
  }

  // Convert keys to object format
  var keyProps = void 0;
  if (Array.isArray(keys)) {
    // [Legacy] Follow the api doc
    keyProps = {
      checkedKeys: keys,
      halfCheckedKeys: undefined
    };
  } else if (typeof keys === 'object') {
    keyProps = {
      checkedKeys: keys.checked || undefined,
      halfCheckedKeys: keys.halfChecked || undefined
    };
  } else {
    (0, _warning2['default'])(false, '`checkedKeys` is not an array or an object');
    return null;
  }

  keyProps.checkedKeys = keyListToString(keyProps.checkedKeys);
  keyProps.halfCheckedKeys = keyListToString(keyProps.halfCheckedKeys);

  return keyProps;
}

/**
 * Conduct check state by the keyList. It will conduct up & from the provided key.
 * If the conduct path reach the disabled or already checked / unchecked node will stop conduct.
 * @param keyList       list of keys
 * @param isCheck       is check the node or not
 * @param keyEntities   parsed by `convertTreeToEntities` function in Tree
 * @param checkStatus   Can pass current checked status for process (usually for uncheck operation)
 * @returns {{checkedKeys: [], halfCheckedKeys: []}}
 */
function conductCheck(keyList, isCheck, keyEntities) {
  var checkStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var checkedKeys = {};
  var halfCheckedKeys = {}; // Record the key has some child checked (include child half checked)

  (checkStatus.checkedKeys || []).forEach(function (key) {
    checkedKeys[key] = true;
  });

  (checkStatus.halfCheckedKeys || []).forEach(function (key) {
    halfCheckedKeys[key] = true;
  });

  // Conduct up
  function conductUp(key) {
    if (checkedKeys[key] === isCheck) return;

    var entity = keyEntities[key];
    if (!entity) return;

    var children = entity.children,
        parent = entity.parent,
        node = entity.node;


    if (isCheckDisabled(node)) return;

    // Check child node checked status
    var everyChildChecked = true;
    var someChildChecked = false; // Child checked or half checked

    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (_ref6) {
      var childKey = _ref6.key;

      var childChecked = checkedKeys[childKey];
      var childHalfChecked = halfCheckedKeys[childKey];

      if (childChecked || childHalfChecked) someChildChecked = true;
      if (!childChecked) everyChildChecked = false;
    });

    // Update checked status
    if (isCheck) {
      checkedKeys[key] = everyChildChecked;
    } else {
      checkedKeys[key] = false;
    }
    halfCheckedKeys[key] = someChildChecked;

    if (parent) {
      conductUp(parent.key);
    }
  }

  // Conduct down
  function conductDown(key) {
    if (checkedKeys[key] === isCheck) return;

    var entity = keyEntities[key];
    if (!entity) return;

    var children = entity.children,
        node = entity.node;


    if (isCheckDisabled(node)) return;

    checkedKeys[key] = isCheck;

    (children || []).forEach(function (child) {
      conductDown(child.key);
    });
  }

  function conduct(key) {
    var entity = keyEntities[key];

    if (!entity) {
      (0, _warning2['default'])(false, '\'' + key + '\' does not exist in the tree.');
      return;
    }

    var children = entity.children,
        parent = entity.parent,
        node = entity.node;

    checkedKeys[key] = isCheck;

    if (isCheckDisabled(node)) return;

    // Conduct down
    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (child) {
      conductDown(child.key);
    });

    // Conduct up
    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conduct(key);
  });

  var checkedKeyList = [];
  var halfCheckedKeyList = [];

  // Fill checked list
  Object.keys(checkedKeys).forEach(function (key) {
    if (checkedKeys[key]) {
      checkedKeyList.push(key);
    }
  });

  // Fill half checked list
  Object.keys(halfCheckedKeys).forEach(function (key) {
    if (!checkedKeys[key] && halfCheckedKeys[key]) {
      halfCheckedKeyList.push(key);
    }
  });

  return {
    checkedKeys: checkedKeyList,
    halfCheckedKeys: halfCheckedKeyList
  };
}

/**
 * If user use `autoExpandParent` we should get the list of parent node
 * @param keyList
 * @param keyEntities
 */
function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = {};

  function conductUp(key) {
    if (expandedKeys[key]) return;

    var entity = keyEntities[key];
    if (!entity) return;

    expandedKeys[key] = true;

    var parent = entity.parent,
        node = entity.node;


    if (isCheckDisabled(node)) return;

    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conductUp(key);
  });

  return Object.keys(expandedKeys);
}

/**
 * Returns only the data- and aria- key/value pairs
 * @param {object} props 
 */
function getDataAndAria(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cssAnimation = _interopRequireDefault(__webpack_require__(293));

var _raf = _interopRequireDefault(__webpack_require__(151));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function animate(node, show, done) {
  var height;
  var requestAnimationFrameId;
  return (0, _cssAnimation["default"])(node, 'ant-motion-collapse', {
    start: function start() {
      if (!show) {
        node.style.height = "".concat(node.offsetHeight, "px");
        node.style.opacity = '1';
      } else {
        height = node.offsetHeight;
        node.style.height = '0px';
        node.style.opacity = '0';
      }
    },
    active: function active() {
      if (requestAnimationFrameId) {
        _raf["default"].cancel(requestAnimationFrameId);
      }

      requestAnimationFrameId = (0, _raf["default"])(function () {
        node.style.height = "".concat(show ? height : 0, "px");
        node.style.opacity = show ? '1' : '0';
      });
    },
    end: function end() {
      if (requestAnimationFrameId) {
        _raf["default"].cancel(requestAnimationFrameId);
      }

      node.style.height = '';
      node.style.opacity = '';
      done();
    }
  });
}

var animation = {
  enter: function enter(node, done) {
    return animate(node, true, done);
  },
  leave: function leave(node, done) {
    return animate(node, false, done);
  },
  appear: function appear(node, done) {
    return animate(node, true, done);
  }
};
var _default = animation;
exports["default"] = _default;

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item__ = __webpack_require__(1028);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var CubeComponentList=function(_React$Component){_inherits(CubeComponentList,_React$Component);function CubeComponentList(props){_classCallCheck(this,CubeComponentList);var _this=_possibleConstructorReturn(this,(CubeComponentList.__proto__||Object.getPrototypeOf(CubeComponentList)).call(this,props));_this.state=CubeComponentList.getInitState();_this.callOnChange=_this.callOnChange.bind(_this);_this.setChecked=_this.setChecked.bind(_this);return _this;}_createClass(CubeComponentList,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){this.props.onChange(value);}}},{key:'setChecked',value:function setChecked(componentsListKey,code,checked,uncheckableDims,t){if((uncheckableDims||[]).includes(code)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('components.cubeComponentList.modals.uncheckableDim.title')});}else{var value=Object.assign({},this.state.value,_defineProperty({},componentsListKey,this.state.value[componentsListKey].map(function(comp){return comp.Code===code?Object.assign({},comp,{checked:checked}):comp;})));this.setState({value:value});this.callOnChange(value);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,onCodelistShow=_props.onCodelistShow,onAttributeShow=_props.onAttributeShow,onDimensionShow=_props.onDimensionShow,onMeasureShow=_props.onMeasureShow,disabled=_props.disabled,labelKey=_props.labelKey,checkboxDisabled=_props.checkboxDisabled,uncheckableDims=_props.uncheckableDims;var _state$value=this.state.value,dimensions=_state$value.dimensions,timeDimensions=_state$value.timeDimensions,tidAttributes=_state$value.tidAttributes,attributes=_state$value.attributes,measures=_state$value.measures;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,dimensions.map(function(dim){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__item__["a" /* default */],{key:dim.Code,icon:'bar-chart',label:dim[labelKey||'Code'],isChecked:dim.checked,hasCheckbox:!disabled,disabled:dim.disabled||checkboxDisabled,onChange:function onChange(e){return _this2.setChecked('dimensions',dim.Code,e.target.checked,uncheckableDims,t);},onDetail:onDimensionShow?function(){return onDimensionShow(dim.Code);}:null,onCodelistShow:onCodelistShow?dim.localRepresentation&&dim.localRepresentation.enumeration?function(){return onCodelistShow(Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(dim.localRepresentation.enumeration));}:null:undefined});}),timeDimensions.map(function(dim){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__item__["a" /* default */],{key:dim.Code,icon:'clock-circle',label:dim[labelKey||'Code'],disabled:dim.disabled||checkboxDisabled,isChecked:dim.checked,onDetail:onDimensionShow?function(){return onDimensionShow(dim.Code);}:null,onChange:function onChange(e){return _this2.setChecked('timeDimensions',dim.Code,e.target.checked,uncheckableDims,t);},hasCheckbox:!disabled});}),tidAttributes.map(function(attr){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__item__["a" /* default */],{key:attr.Code,icon:'flag',disabled:attr.disabled||checkboxDisabled,label:attr[labelKey||'Code'],isChecked:attr.checked,onChange:function onChange(e){return _this2.setChecked('tidAttributes',attr.Code,e.target.checked,uncheckableDims,t);},hasCheckbox:!disabled,onAttributeShow:null,isTid:true});}),attributes.map(function(attr){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__item__["a" /* default */],{key:attr.Code,icon:'profile',label:attr[labelKey||'Code'],disabled:attr.disabled||checkboxDisabled,isChecked:attr.checked,onChange:function onChange(e){return _this2.setChecked('attributes',attr.Code,e.target.checked,uncheckableDims,t);},hasCheckbox:!disabled,onDetail:onAttributeShow?function(){return onAttributeShow(attr.Code);}:null,onCodelistShow:onCodelistShow?attr.localRepresentation&&attr.localRepresentation.enumeration?function(){return onCodelistShow(Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(attr.localRepresentation.enumeration));}:null:undefined,isMandatory:attr.IsMandatory||(attr.assignmentStatus||"").toLowerCase()==="mandatory"});}),measures.map(function(meas){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__item__["a" /* default */],{key:meas.Code,icon:'line-chart',label:meas[labelKey||'Code'],disabled:meas.disabled||checkboxDisabled,isChecked:meas.checked,onChange:function onChange(e){return _this2.setChecked('measures',meas.Code,e.target.checked,uncheckableDims,t);},hasCheckbox:!disabled,onDetail:onMeasureShow?function(){return onMeasureShow();}:null,onCodelistShow:onCodelistShow?meas.localRepresentation&&meas.localRepresentation.enumeration?function(){return onCodelistShow(Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(meas.localRepresentation.enumeration));}:null:undefined});}));}}],[{key:'getInitState',value:function getInitState(){return{value:{dimensions:[],timeDimensions:[],tidAttributes:[],attributes:[],measures:[]}};}},{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){return nextProps.value!==null?{value:nextProps.value}:CubeComponentList.getInitState();}}]);return CubeComponentList;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])()(CubeComponentList));

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filter_form__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__tree_filter__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__query_form_Preview__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__zoomable_textarea__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_filter__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var QueryFormFilter=function(_React$Component){_inherits(QueryFormFilter,_React$Component);function QueryFormFilter(props){_classCallCheck(this,QueryFormFilter);var _this=_possibleConstructorReturn(this,(QueryFormFilter.__proto__||Object.getPrototypeOf(QueryFormFilter)).call(this,props));_this.state={isFilterQueryModalVisible:false};_this.onFilterQueryModalShow=_this.onFilterQueryModalShow.bind(_this);_this.onFilterQueryModalHide=_this.onFilterQueryModalHide.bind(_this);return _this;}_createClass(QueryFormFilter,[{key:"onFilterQueryModalShow",value:function onFilterQueryModalShow(){this.setState({isFilterQueryModalVisible:true});}},{key:"onFilterQueryModalHide",value:function onFilterQueryModalHide(){this.setState({isFilterQueryModalVisible:false});}},{key:"render",value:function render(){var _props=this.props,onFilterModalShow=_props.onFilterModalShow,cube=_props.cube,t=_props.t,isFilterModalVisible=_props.isFilterModalVisible,onFilterModalHide=_props.onFilterModalHide,onFilterModalSubmit=_props.onFilterModalSubmit,filterMode=_props.filterMode,filter=_props.filter,filterTemp=_props.filterTemp,treeFilter=_props.treeFilter,treeFilterTemp=_props.treeFilterTemp,disabled=_props.disabled,onFilterModeChange=_props.onFilterModeChange,onFilterReset=_props.onFilterReset,onRowsModalShow=_props.onRowsModalShow,onFilterChange=_props.onFilterChange,onBlockAdd=_props.onBlockAdd,onBlockDelete=_props.onBlockDelete,cubeFirstRow=_props.cubeFirstRow,onConditionAdd=_props.onConditionAdd,onConditionDelete=_props.onConditionDelete,fetchColumnCodelistCount=_props.fetchColumnCodelistCount,fetchColumnCodelistTree=_props.fetchColumnCodelistTree,_fetchColumnFilteredValues=_props.fetchColumnFilteredValues,cubeId=_props.cubeId,onTreeFilterChange=_props.onTreeFilterChange,onColumnModeChange=_props.onColumnModeChange,onColumnValuesChange=_props.onColumnValuesChange,rows=_props.rows,isRowsModalVisible=_props.isRowsModalVisible,onRowsModalHide=_props.onRowsModalHide,fetchRows=_props.fetchRows,fetchColumnValues=_props.fetchColumnValues,resetColumnValues=_props.resetColumnValues,fetchColumnCodes=_props.fetchColumnCodes,sdmxFilters=_props.sdmxFilters;var isFilterQueryModalVisible=this.state.isFilterQueryModalVisible;var filterStr=filterMode===__WEBPACK_IMPORTED_MODULE_21__query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?Object(__WEBPACK_IMPORTED_MODULE_27__utils_filter__["c" /* getFilterStrFromObj */])(filter,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})):null):Object(__WEBPACK_IMPORTED_MODULE_24__tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(treeFilter,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(_ref){var name=_ref.name;return name;}):null);var filterTempStr=filterMode===__WEBPACK_IMPORTED_MODULE_21__query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?Object(__WEBPACK_IMPORTED_MODULE_27__utils_filter__["c" /* getFilterStrFromObj */])(filterTemp,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})):null):Object(__WEBPACK_IMPORTED_MODULE_24__tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(treeFilterTemp,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(_ref2){var name=_ref2.name;return name;}):null);var columns=cube!==null&&cubeFirstRow!==null&&cubeFirstRow!==undefined?__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(col){return Object.assign({},col,{fetchValues:col.values!==undefined?function(viewerObj){return fetchColumnValues(cubeId,col.ColName,viewerObj);}:null,resetValues:function resetValues(){return resetColumnValues(col.ColName);},hasCodelist:!!col.CodelistCode,fetchCodes:!!col.CodelistCode?function(){return fetchColumnCodes(col.ColName,col.CodelistCode);}:null});}):null;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:{marginTop:5}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",onClick:onFilterModalShow,disabled:cube===null},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.editFilter.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__enhanced_modal__["a" /* default */],{visible:isFilterModalVisible,onCancel:onFilterModalHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onFilterModalHide},t('commons.buttons.cancel.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onFilterModalSubmit(filterMode===__WEBPACK_IMPORTED_MODULE_21__query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?filterTemp:treeFilterTemp);}},t('commons.buttons.confirm.title'))),width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_LG"],title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterModal.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__enhanced_modal__["a" /* default */],{visible:isFilterQueryModalVisible,onCancel:this.onFilterQueryModalHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:this.onFilterQueryModalHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_LG"],title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterQueryModal.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{fontFamily:'monospace'}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea,{disabled:true,value:Object(__WEBPACK_IMPORTED_MODULE_24__tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filterTempStr),style:{overflow:'auto',resize:'none',height:560}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,!sdmxFilters&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group,{disabled:disabled,value:filterMode,onChange:function onChange(_ref3){var target=_ref3.target;if(target.value===__WEBPACK_IMPORTED_MODULE_21__query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]&&Object.keys(treeFilterTemp).length>0||target.value===__WEBPACK_IMPORTED_MODULE_21__query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]&&filterTempStr.length>0){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.title'),content:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.content'),onOk:function onOk(){onFilterModeChange(target.value);},cancelText:t('commons.buttons.cancel.title')});}else{onFilterModeChange(target.value);}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_21__query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.plain.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_21__query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.tree.title')))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{icon:"code",onClick:this.onFilterQueryModalShow},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.showQuery.title'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{icon:"delete",onClick:onFilterReset,disabled:disabled},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.resetFilter.title'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onRowsModalShow,disabled:cube===null,icon:"eye"},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.preview.title')))))),filterMode===__WEBPACK_IMPORTED_MODULE_21__query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{bodyStyle:{height:396,overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__filter_form__["a" /* default */],{filter:filterTemp,columns:columns,onChange:onFilterChange,onBlockAdd:onBlockAdd,onBlockDelete:onBlockDelete,onBlockConditionAdd:onConditionAdd,onBlockConditionDelete:onConditionDelete,disabled:disabled})),filterMode===__WEBPACK_IMPORTED_MODULE_21__query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"query__tree-filter"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__tree_filter__["a" /* default */],{disabled:disabled,columns:columns,fetchColumnCodelistCount:fetchColumnCodelistCount,fetchColumnCodelistTree:fetchColumnCodelistTree,fetchColumnFilteredValues:function fetchColumnFilteredValues(_ref4){var colNames=_ref4.colNames,filterStr=_ref4.filterStr;return _fetchColumnFilteredValues(cubeId,colNames,filterStr);},onChange:onTreeFilterChange,treeFilter:treeFilterTemp,onColumnModeChange:onColumnModeChange,onColumnValuesChange:onColumnValuesChange,hideInclusionRadio:sdmxFilters,isSdmx:sdmxFilters}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onRowsModalShow,disabled:cube===null,icon:"eye"},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.preview.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__query_form_Preview__["a" /* default */],{filterStr:isFilterModalVisible?filterTempStr:filterStr,rows:rows,cube:cube,isRowsModalVisible:isRowsModalVisible,onRowsModalHide:onRowsModalHide,fetchRows:fetchRows}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{fontFamily:'monospace',marginTop:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"],height:395}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__zoomable_textarea__["a" /* default */],{disabled:true,value:Object(__WEBPACK_IMPORTED_MODULE_24__tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filterStr),style:{overflow:'auto',resize:'none'}})));}}]);return QueryFormFilter;}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_26_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(mapStateToProps))(QueryFormFilter));

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _rcCheckbox = _interopRequireDefault(__webpack_require__(385));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _shallowequal = _interopRequireDefault(__webpack_require__(132));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radio).apply(this, arguments));

    _this.saveCheckbox = function (node) {
      _this.rcCheckbox = node;
    };

    _this.renderRadio = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          props = _assertThisInitialize.props,
          context = _assertThisInitialize.context;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          children = props.children,
          style = props.style,
          restProps = __rest(props, ["prefixCls", "className", "children", "style"]);

      var radioGroup = context.radioGroup;
      var prefixCls = getPrefixCls('radio', customizePrefixCls);

      var radioProps = _extends({}, restProps);

      if (radioGroup) {
        radioProps.name = radioGroup.name;
        radioProps.onChange = radioGroup.onChange;
        radioProps.checked = props.value === radioGroup.value;
        radioProps.disabled = props.disabled || radioGroup.disabled;
      }

      var wrapperClassString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _classNames));
      return React.createElement("label", {
        className: wrapperClassString,
        style: style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
      }, React.createElement(_rcCheckbox["default"], _extends({}, radioProps, {
        prefixCls: prefixCls,
        ref: _this.saveCheckbox
      })), children !== undefined ? React.createElement("span", null, children) : null);
    };

    return _this;
  }

  _createClass(Radio, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.radioGroup, nextContext.radioGroup);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcCheckbox.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcCheckbox.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRadio);
    }
  }]);

  return Radio;
}(React.Component);

exports["default"] = Radio;
Radio.defaultProps = {
  type: 'radio'
};
Radio.contextTypes = {
  radioGroup: PropTypes.any
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__block__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_constants__);
var mapPropsToFields=function mapPropsToFields(_ref){var filter=_ref.filter;return{filter:filter?filter.map(function(block){return{column:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:block.column}),logicalOperator:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:block.logicalOperator}),conditions:block.conditions!==null?block.conditions.map(function(condition){return{comparisonOperator:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:condition.comparisonOperator}),value:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:condition.value})};}):null};}):undefined};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange({filter:fields.filter.map(function(block){return{column:block.column!==undefined?block.column.value:undefined,logicalOperator:block.logicalOperator!==undefined?block.logicalOperator.value:undefined,conditions:block.conditions!==undefined?block.conditions.map(function(condition){return{comparisonOperator:condition.comparisonOperator!==undefined?condition.comparisonOperator.value:undefined,value:condition.value!==undefined?condition.value.value:undefined};}):undefined};})});};var FilterForm=function FilterForm(_ref2){var t=_ref2.t,form=_ref2.form,filter=_ref2.filter,columns=_ref2.columns,onBlockAdd=_ref2.onBlockAdd,onBlockDelete=_ref2.onBlockDelete,onBlockConditionAdd=_ref2.onBlockConditionAdd,onBlockConditionDelete=_ref2.onBlockConditionDelete,disabled=_ref2.disabled;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,filter&&filter.map(function(block,blockIndex){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{key:blockIndex,type:'inner',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]},headStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["PADDING_MD"]},bodyStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["PADDING_MD"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__block__["a" /* default */],{form:form,column:block.column!==null&&columns!==null?columns.filter(function(_ref3){var name=_ref3.name;return name===block.column;})[0]:null,conditions:block.conditions,columns:columns,index:blockIndex,onDelete:function onDelete(){return onBlockDelete(blockIndex);},onConditionAdd:function onConditionAdd(){return onBlockConditionAdd(blockIndex);},onConditionDelete:function onConditionDelete(conditionIndex){return onBlockConditionDelete(blockIndex,conditionIndex);},disabled:disabled}));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onBlockAdd,icon:'plus',disabled:columns===null||columns.length===0||disabled},t('components.whereConditionsForm.addBlockButton')));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(FilterForm));

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1070);

__webpack_require__(26);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1071);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = __webpack_require__(49);

var _createChainedFunction = __webpack_require__(1096);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _KeyCode = __webpack_require__(230);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _placements = __webpack_require__(1097);

var _placements2 = _interopRequireDefault(_placements);

var _rcTrigger = __webpack_require__(153);

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker = function (_React$Component) {
  (0, _inherits3['default'])(Picker, _React$Component);

  function Picker(props) {
    (0, _classCallCheck3['default'])(this, Picker);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var open = void 0;
    if ('open' in props) {
      open = props.open;
    } else {
      open = props.defaultOpen;
    }
    var value = props.value || props.defaultValue;
    _this.saveCalendarRef = refFn.bind(_this, 'calendarInstance');

    _this.state = {
      open: open,
      value: value
    };
    return _this;
  }

  Picker.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    if (!prevState.open && this.state.open) {
      // setTimeout is for making sure saveCalendarRef happen before focusCalendar
      this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
    }
  };

  Picker.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.focusTimeout);
  };

  Picker.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    var newState = {};
    var value = nextProps.value,
        open = nextProps.open;

    if ('value' in nextProps) {
      newState.value = value;
    }
    if (open !== undefined) {
      newState.open = open;
    }
    return newState;
  };

  Picker.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        placement = props.placement,
        style = props.style,
        getCalendarContainer = props.getCalendarContainer,
        align = props.align,
        animation = props.animation,
        disabled = props.disabled,
        dropdownClassName = props.dropdownClassName,
        transitionName = props.transitionName,
        children = props.children;

    var state = this.state;
    return _react2['default'].createElement(
      _rcTrigger2['default'],
      {
        popup: this.getCalendarElement(),
        popupAlign: align,
        builtinPlacements: _placements2['default'],
        popupPlacement: placement,
        action: disabled && !state.open ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getCalendarContainer,
        popupStyle: style,
        popupAnimation: animation,
        popupTransitionName: transitionName,
        popupVisible: state.open,
        onPopupVisibleChange: this.onVisibleChange,
        prefixCls: prefixCls,
        popupClassName: dropdownClassName
      },
      _react2['default'].cloneElement(children(state, props), { onKeyDown: this.onKeyDown })
    );
  };

  return Picker;
}(_react2['default'].Component);

Picker.propTypes = {
  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]),
  disabled: _propTypes2['default'].bool,
  transitionName: _propTypes2['default'].string,
  onChange: _propTypes2['default'].func,
  onOpenChange: _propTypes2['default'].func,
  children: _propTypes2['default'].func,
  getCalendarContainer: _propTypes2['default'].func,
  calendar: _propTypes2['default'].element,
  style: _propTypes2['default'].object,
  open: _propTypes2['default'].bool,
  defaultOpen: _propTypes2['default'].bool,
  prefixCls: _propTypes2['default'].string,
  placement: _propTypes2['default'].any,
  value: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
  defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
  align: _propTypes2['default'].object
};
Picker.defaultProps = {
  prefixCls: 'rc-calendar-picker',
  style: {},
  align: {},
  placement: 'bottomLeft',
  defaultOpen: false,
  onChange: noop,
  onOpenChange: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onCalendarKeyDown = function (event) {
    if (event.keyCode === _KeyCode2['default'].ESC) {
      event.stopPropagation();
      _this2.close(_this2.focus);
    }
  };

  this.onCalendarSelect = function (value) {
    var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var props = _this2.props;
    if (!('value' in props)) {
      _this2.setState({
        value: value
      });
    }
    if (cause.source === 'keyboard' || cause.source === 'dateInputSelect' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
      _this2.close(_this2.focus);
    }
    props.onChange(value);
  };

  this.onKeyDown = function (event) {
    if (!_this2.state.open && (event.keyCode === _KeyCode2['default'].DOWN || event.keyCode === _KeyCode2['default'].ENTER)) {
      _this2.open();
      event.preventDefault();
    }
  };

  this.onCalendarOk = function () {
    _this2.close(_this2.focus);
  };

  this.onCalendarClear = function () {
    _this2.close(_this2.focus);
  };

  this.onVisibleChange = function (open) {
    _this2.setOpen(open);
  };

  this.getCalendarElement = function () {
    var props = _this2.props;
    var state = _this2.state;
    var calendarProps = props.calendar.props;
    var value = state.value;

    var defaultValue = value;
    var extraProps = {
      ref: _this2.saveCalendarRef,
      defaultValue: defaultValue || calendarProps.defaultValue,
      selectedValue: value,
      onKeyDown: _this2.onCalendarKeyDown,
      onOk: (0, _createChainedFunction2['default'])(calendarProps.onOk, _this2.onCalendarOk),
      onSelect: (0, _createChainedFunction2['default'])(calendarProps.onSelect, _this2.onCalendarSelect),
      onClear: (0, _createChainedFunction2['default'])(calendarProps.onClear, _this2.onCalendarClear)
    };

    return _react2['default'].cloneElement(props.calendar, extraProps);
  };

  this.setOpen = function (open, callback) {
    var onOpenChange = _this2.props.onOpenChange;

    if (_this2.state.open !== open) {
      if (!('open' in _this2.props)) {
        _this2.setState({
          open: open
        }, callback);
      }
      onOpenChange(open);
    }
  };

  this.open = function (callback) {
    _this2.setOpen(true, callback);
  };

  this.close = function (callback) {
    _this2.setOpen(false, callback);
  };

  this.focus = function () {
    if (!_this2.state.open) {
      _reactDom2['default'].findDOMNode(_this2).focus();
    }
  };

  this.focusCalendar = function () {
    if (_this2.state.open && !!_this2.calendarInstance) {
      _this2.calendarInstance.focus();
    }
  };
};

(0, _reactLifecyclesCompat.polyfill)(Picker);

exports['default'] = Picker;
module.exports = exports['default'];

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(46));

var _reactLifecyclesCompat = __webpack_require__(49);

var _TimePicker = _interopRequireDefault(__webpack_require__(1102));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(142));

var _configProvider = __webpack_require__(35);

var _en_US = _interopRequireDefault(__webpack_require__(265));

var _interopDefault = _interopRequireDefault(__webpack_require__(231));

var _icon = _interopRequireDefault(__webpack_require__(25));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

function generateShowHourMinuteSecond(format) {
  // Ref: http://momentjs.com/docs/#/parsing/string-format/
  return {
    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
    showMinute: format.indexOf('m') > -1,
    showSecond: format.indexOf('s') > -1
  };
}

var TimePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).call(this, props));

    _this.handleChange = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          _this$props$format = _this$props.format,
          format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;

      if (onChange) {
        onChange(value, value && value.format(format) || '');
      }
    };

    _this.handleOpenClose = function (_ref) {
      var open = _ref.open;
      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.saveTimePicker = function (timePickerRef) {
      _this.timePickerRef = timePickerRef;
    };

    _this.renderTimePicker = function (locale) {
      return React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
        var _classNames2;

        var getContextPopupContainer = _ref2.getPopupContainer,
            getPrefixCls = _ref2.getPrefixCls;

        var _a = _this.props,
            getPopupContainer = _a.getPopupContainer,
            customizePrefixCls = _a.prefixCls,
            props = __rest(_a, ["getPopupContainer", "prefixCls"]);

        delete props.defaultValue;

        var format = _this.getDefaultFormat();

        var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
        var className = (0, _classnames["default"])(props.className, _defineProperty({}, "".concat(prefixCls, "-").concat(props.size), !!props.size));

        var addon = function addon(panel) {
          return props.addon ? React.createElement("div", {
            className: "".concat(prefixCls, "-panel-addon")
          }, props.addon(panel)) : null;
        };

        var suffixIcon = props.suffixIcon;
        var clockIcon = suffixIcon && (React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-clock-icon"), true), _classNames2))
        }) : React.createElement("span", {
          className: "".concat(prefixCls, "-clock-icon")
        }, suffixIcon)) || React.createElement(_icon["default"], {
          type: "clock-circle",
          className: "".concat(prefixCls, "-clock-icon"),
          theme: "outlined"
        });
        var inputIcon = React.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, clockIcon);
        var clearIcon = React.createElement(_icon["default"], {
          type: "close-circle",
          className: "".concat(prefixCls, "-panel-clear-btn-icon"),
          theme: "filled"
        });
        return React.createElement(_TimePicker["default"], _extends({}, generateShowHourMinuteSecond(format), props, {
          prefixCls: prefixCls,
          getPopupContainer: getPopupContainer || getContextPopupContainer,
          ref: _this.saveTimePicker,
          format: format,
          className: className,
          value: _this.state.value,
          placeholder: props.placeholder === undefined ? locale.placeholder : props.placeholder,
          onChange: _this.handleChange,
          onOpen: _this.handleOpenClose,
          onClose: _this.handleOpenClose,
          addon: addon,
          inputIcon: inputIcon,
          clearIcon: clearIcon
        }));
      });
    };

    var value = props.value || props.defaultValue;

    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
      throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
    }

    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: "focus",
    value: function focus() {
      this.timePickerRef.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.timePickerRef.blur();
    }
  }, {
    key: "getDefaultFormat",
    value: function getDefaultFormat() {
      var _this$props2 = this.props,
          format = _this$props2.format,
          use12Hours = _this$props2.use12Hours;

      if (format) {
        return format;
      } else if (use12Hours) {
        return 'h:mm:ss a';
      }

      return 'HH:mm:ss';
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_LocaleReceiver["default"], {
        componentName: "TimePicker",
        defaultLocale: _en_US["default"]
      }, this.renderTimePicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TimePicker;
}(React.Component);

TimePicker.defaultProps = {
  align: {
    offset: [0, -2]
  },
  disabled: false,
  disabledHours: undefined,
  disabledMinutes: undefined,
  disabledSeconds: undefined,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  transitionName: 'slide-up',
  focusOnOpen: true
};
(0, _reactLifecyclesCompat.polyfill)(TimePicker);
var _default = TimePicker;
exports["default"] = _default;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcAnimate = _interopRequireDefault(__webpack_require__(102));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _reactLifecyclesCompat = __webpack_require__(49);

var _icon = _interopRequireDefault(__webpack_require__(25));

var _CheckableTag = _interopRequireDefault(__webpack_require__(1112));

var _configProvider = __webpack_require__(35);

var _wave = _interopRequireDefault(__webpack_require__(298));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var InnerTag = function InnerTag(_a) {
  var show = _a.show,
      restProps = __rest(_a, ["show"]);

  var divProps = (0, _omit["default"])(restProps, ['onClose', 'afterClose', 'color', 'visible', 'closable']);
  return React.createElement("div", divProps);
};

var Tag =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tag, _React$Component);

  function Tag() {
    var _this;

    _classCallCheck(this, Tag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tag).apply(this, arguments));
    _this.state = {
      visible: true
    };

    _this.handleIconClick = function (e) {
      _this.setVisible(false, e);
    };

    _this.animationEnd = function (_, existed) {
      if (!existed) {
        var afterClose = _this.props.afterClose;

        if (afterClose) {
          afterClose();
        }
      }
    };

    _this.renderTag = function (configProps) {
      var getPrefixCls = configProps.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          children = _a.children,
          otherProps = __rest(_a, ["prefixCls", "children"]);

      var visible = _this.state.visible;
      var prefixCls = getPrefixCls('tag', customizePrefixCls);
      return React.createElement(_wave["default"], null, React.createElement(_rcAnimate["default"], {
        component: "",
        showProp: "show",
        transitionName: "".concat(prefixCls, "-zoom"),
        onEnd: _this.animationEnd
      }, React.createElement(InnerTag, _extends({
        show: visible
      }, otherProps, {
        className: _this.getTagClassName(configProps),
        style: _this.getTagStyle()
      }), children, _this.renderCloseIcon())));
    };

    return _this;
  }

  _createClass(Tag, [{
    key: "setVisible",
    value: function setVisible(visible, e) {
      var onClose = this.props.onClose;

      if (onClose) {
        onClose(e);
      }

      if (e.defaultPrevented) {
        return;
      }

      if (!('visible' in this.props)) {
        this.setState({
          visible: visible
        });
      }
    }
  }, {
    key: "isPresetColor",
    value: function isPresetColor(color) {
      if (!color) {
        return false;
      }

      return /^(pink|red|yellow|orange|cyan|green|blue|purple|geekblue|magenta|volcano|gold|lime)(-inverse)?$/.test(color);
    }
  }, {
    key: "getTagStyle",
    value: function getTagStyle() {
      var _this$props = this.props,
          color = _this$props.color,
          style = _this$props.style;
      var isPresetColor = this.isPresetColor(color);
      return _extends({
        backgroundColor: color && !isPresetColor ? color : undefined
      }, style);
    }
  }, {
    key: "getTagClassName",
    value: function getTagClassName(_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props2 = this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          color = _this$props2.color;
      var visible = this.state.visible;
      var isPresetColor = this.isPresetColor(color);
      var prefixCls = getPrefixCls('tag', customizePrefixCls);
      return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-has-color"), color && !isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-hidden"), !visible), _classNames), className);
    }
  }, {
    key: "renderCloseIcon",
    value: function renderCloseIcon() {
      var closable = this.props.closable;
      return closable ? React.createElement(_icon["default"], {
        type: "close",
        onClick: this.handleIconClick
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderTag);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('visible' in nextProps) {
        return {
          visible: nextProps.visible
        };
      }

      return null;
    }
  }]);

  return Tag;
}(React.Component);

Tag.CheckableTag = _CheckableTag["default"];
Tag.defaultProps = {
  closable: false
};
(0, _reactLifecyclesCompat.polyfill)(Tag);
var _default = Tag;
exports["default"] = _default;

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE_NAVIGATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return navigatePage; });
var PAGE_NAVIGATE='PAGE_NAVIGATE';var navigatePage=function navigatePage(){return{type:PAGE_NAVIGATE};};

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_SELECTION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeDataflowBuilderWizardCategoryTreeSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return readDataflowBuilderWizardCategoryTreeCategorisations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_SELECTION_CHANGE='DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_SELECTION_CHANGE';var DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ='DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ';var changeDataflowBuilderWizardCategoryTreeSelection=function changeDataflowBuilderWizardCategoryTreeSelection(selection){return{type:DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_SELECTION_CHANGE,selection:selection};};var readDataflowBuilderWizardCategoryTreeCategorisations=function readDataflowBuilderWizardCategoryTreeCategorisations(lang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["p" /* getCategorySchemeUrl */])(null,true)),{lang:lang});};

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return showDataflowBuilderWizardLayoutAnnotationsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hideDataflowBuilderWizardLayoutAnnotationsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return submitDataflowBuilderWizardLayoutAnnotationsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return resetDataflowBuilderWizardLayoutAnnotationsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return readDataflowBuilderWizardLayoutAnnotationsItemsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return resetDataflowBuilderWizardLayoutAnnotationsItemsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchDataflowBuilderWizardLayoutAnnotationsValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return resetDataflowBuilderWizardLayoutAnnotationsValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tree_filter_utils__ = __webpack_require__(65);
var DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SHOW="DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SHOW";var DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_HIDE="DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_HIDE";var DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT="DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT";var DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_RESET="DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_RESET";var DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ="DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ";var DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET="DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET";var DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_READ="DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_READ";var DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_RESET="DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_RESET";var showDataflowBuilderWizardLayoutAnnotationsForm=function showDataflowBuilderWizardLayoutAnnotationsForm(){return{type:DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SHOW};};var hideDataflowBuilderWizardLayoutAnnotationsForm=function hideDataflowBuilderWizardLayoutAnnotationsForm(){return{type:DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_HIDE};};var submitDataflowBuilderWizardLayoutAnnotationsForm=function submitDataflowBuilderWizardLayoutAnnotationsForm(annotations){return{type:DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT,annotations:annotations};};var resetDataflowBuilderWizardLayoutAnnotationsForm=function resetDataflowBuilderWizardLayoutAnnotationsForm(){return{type:DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_RESET};};var readDataflowBuilderWizardLayoutAnnotationsItemsPage=function readDataflowBuilderWizardLayoutAnnotationsItemsPage(_ref,cubeId,colNames,colName,filterStr,selectedCodes){var codelistTriplet=_ref.codelistTriplet,language=_ref.language,pageNum=_ref.pageNum,pageSize=_ref.pageSize,searchText=_ref.searchText,filters=_ref.filters,sortCol=_ref.sortCol,sortByDesc=_ref.sortByDesc;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(colName,1,-1)],[{Id:codelistTriplet.id,AgencyId:codelistTriplet.agencyID,Version:codelistTriplet.version,Lang:language,PageNum:pageNum,PageSize:pageSize,AllSearch:searchText,CodeSearch:filters.id?filters.id:undefined,NameSearch:filters.name?filters.name:undefined,ParentSearch:filters.parent?filters.parent:undefined,SortColumn:sortCol?sortCol:undefined,SortDesc:sortByDesc?sortByDesc:undefined,rebuildDb:false},{idCube:cubeId,dataflowColumns:colNames,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(undefined,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_3__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filterStr))).Filter}]),{colName:colName,selectedCodes:selectedCodes});};var resetDataflowBuilderWizardLayoutAnnotationsItemsPage=function resetDataflowBuilderWizardLayoutAnnotationsItemsPage(){return{type:DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET};};var fetchDataflowBuilderWizardLayoutAnnotationsValues=function fetchDataflowBuilderWizardLayoutAnnotationsValues(cubeId,colNames,colName,filterStr){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(colName,1,-1),{idCube:cubeId,dataflowColumns:colNames,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(undefined,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_3__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filterStr))).Filter}),{colName:colName});};var resetDataflowBuilderWizardLayoutAnnotationsValues=function resetDataflowBuilderWizardLayoutAnnotationsValues(){return{type:DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_RESET};};

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOW_BUILDER_TREE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_TREE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_TREE_CATEGORISED_DATAFLOWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showDataflowBuilderTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideDataflowBuilderTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return readDataflowBuilderTreeCategorisedDataflows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var DATAFLOW_BUILDER_TREE_SHOW='DATAFLOW_BUILDER_TREE_SHOW';var DATAFLOW_BUILDER_TREE_HIDE='DATAFLOW_BUILDER_TREE_HIDE';var DATAFLOW_BUILDER_TREE_CATEGORISED_DATAFLOWS_READ='DATAFLOW_BUILDER_TREE_CATEGORISED_DATAFLOWS_READ';var showDataflowBuilderTree=function showDataflowBuilderTree(){return{type:DATAFLOW_BUILDER_TREE_SHOW};};var hideDataflowBuilderTree=function hideDataflowBuilderTree(){return{type:DATAFLOW_BUILDER_TREE_HIDE};};var readDataflowBuilderTreeCategorisedDataflows=function readDataflowBuilderTreeCategorisedDataflows(lang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DATAFLOW_BUILDER_TREE_CATEGORISED_DATAFLOWS_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_9" /* getDdbDataflowUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["p" /* getCategorySchemeUrl */])(null,true),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_7" /* getDataflowUrl */])()]),{lang:lang});};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CATEGORY_SCHEME */
/* unused harmony export NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CODELIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CONCEPT_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_SOAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_REST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ping_icon__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(117);
var NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CATEGORY_SCHEME="CategoryScheme";var NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CODELIST="Codelist";var NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CONCEPT_SCHEME="ConceptScheme";var NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_SOAP='SOAP';var NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_REST='REST';var mapPropsToFields=function mapPropsToFields(_ref){var node=_ref.node;return{NSIEndpoint:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.NSIEndpoint?node.Endpoint.NSIEndpoint:""}),NSIReadOnlyUsername:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.NSIReadOnlyUsername?node.Endpoint.NSIReadOnlyUsername:""}),NSIReadOnlyPassword:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.NSIReadOnlyPassword?node.Endpoint.NSIReadOnlyPassword:""}),InitialWSDL:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.InitialWSDL?node.Endpoint.InitialWSDL:""}),PingArtefact:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint?node.Endpoint.PingArtefact:null}),NSIEndpointType:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint?node.Endpoint.NSIEndpointType:null}),MAEndpoint:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.MAEndpoint?node.Endpoint.MAEndpoint:""}),SupportPostFilters:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.SupportPostFilters?node.Endpoint.SupportPostFilters:null}),DMEndpoint:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.DMEndpoint?node.Endpoint.DMEndpoint:""}),LDAPEndpoint:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.LDAPEndpoint?node.Endpoint.LDAPEndpoint:""}),ActiveDirectoryEndpoint:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.ActiveDirectoryEndpoint?node.Endpoint.ActiveDirectoryEndpoint:""}),MetadataBaseURL:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.MetadataBaseURL?node.Endpoint.MetadataBaseURL:""}),SupportAllCompleteStubs:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:node.Endpoint&&node.Endpoint.SupportAllCompleteStubs?node.Endpoint.SupportAllCompleteStubs:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onPingNSI:function onPingNSI(nodeIndex,config){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["y" /* checkEndpointNSIUrl */])(nodeIndex,config));},onPingMA:function onPingMA(nodeIndex,config){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["w" /* checkEndpointMAUrl */])(nodeIndex,config));},onPingDM:function onPingDM(nodeIndex,config){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["v" /* checkEndpointDMUrl */])(nodeIndex,config));},onPingMD:function onPingMD(nodeIndex,metadataApiUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["x" /* checkEndpointMDUrl */])(nodeIndex,metadataApiUrl));}};};var EndpointForm=function EndpointForm(_ref3){var t=_ref3.t,form=_ref3.form,node=_ref3.node,nodeIndex=_ref3.nodeIndex,onPingNSI=_ref3.onPingNSI,onPingMA=_ref3.onPingMA,onPingDM=_ref3.onPingDM,onPingMD=_ref3.onPingMD;var PingAddOn=function PingAddOn(_ref4){var isOk=_ref4.isOk,onClick=_ref4.onClick,disabled=_ref4.disabled;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('span',{onClick:onClick,style:disabled?{color:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["COLOR_FONT_DISABLED"],cursor:"not-allowed"}:{cursor:"pointer"}},'Ping'),isOk!==null&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:{display:"inline-block",marginLeft:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ping_icon__["a" /* default */],{isOk:isOk})));};return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.endpoint.nsiEndpointType.label'),style:{marginBottom:0}},form.getFieldDecorator('NSIEndpointType')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref5){var props=_ref5.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_SOAP,title:t('data.nodesConfig.endpoint.nsiEndpointType.options.soap.label')},t('data.nodesConfig.endpoint.nsiEndpointType.options.soap.label')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_REST,title:t('data.nodesConfig.endpoint.nsiEndpointType.options.rest.label')},t('data.nodesConfig.endpoint.nsiEndpointType.options.rest.label'))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.endpoint.nsiEndpoint.label'),style:{marginBottom:0}},form.getFieldDecorator('NSIEndpoint')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{placeholder:t("data.nodesConfig.endpoint.nsiEndpoint.placeholder"),addonAfter:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(PingAddOn,{isOk:node.isNSIPingOk,onClick:function onClick(){return onPingNSI(nodeIndex,{EndPointUrl:node.Endpoint.NSIEndpoint,NSIEndpointType:node.Endpoint.NSIEndpointType,PingArtefact:node.Endpoint.PingArtefact,NSIReadOnlyUsername:node.Endpoint.NSIReadOnlyUsername,NSIReadOnlyPassword:node.Endpoint.NSIReadOnlyPassword,Enabled:node.Proxy.Enabled,Address:node.Proxy.Address,Port:node.Proxy.Port,Username:node.Proxy.Username,Password:node.Proxy.Password});},disabled:!node.Endpoint.NSIEndpoint||node.Endpoint.NSIEndpoint.length===0||!node.Endpoint.NSIEndpointType||!node.Endpoint.PingArtefact||node.Endpoint.NSIReadOnlyUsername&&!node.Endpoint.NSIReadOnlyPassword||!node.Endpoint.NSIReadOnlyUsername&&node.Endpoint.NSIReadOnlyPassword||node.Proxy.Enabled&&(!node.Proxy.Address||!node.Proxy.Port||node.Proxy.Username&&!node.Proxy.Password||!node.Proxy.Username&&node.Proxy.Password)})}))),form.getFieldValue("NSIEndpointType")===NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_REST&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.endpoint.supportAllCompleteStubs.label")+' :'),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,null,form.getFieldDecorator("SupportAllCompleteStubs",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.endpoint.nsiReadOnlyUsername.label'),style:{marginBottom:0}},form.getFieldDecorator('NSIReadOnlyUsername')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.endpoint.nsiReadOnlyPassword.label'),style:{marginBottom:0}},form.getFieldDecorator('NSIReadOnlyPassword')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{type:"password",autoComplete:'new-password'}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.endpoint.initialWsdl.label'),style:{marginBottom:0}},form.getFieldDecorator('InitialWSDL')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.endpoint.pingArtefact.label'),style:{marginBottom:0}},form.getFieldDecorator('PingArtefact')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref6){var props=_ref6.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CATEGORY_SCHEME,title:t('data.nodesConfig.endpoint.pingArtefact.options.categoryScheme.label')},t('data.nodesConfig.endpoint.pingArtefact.options.categoryScheme.label')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CODELIST,title:t('data.nodesConfig.endpoint.pingArtefact.options.codelist.label')},t('data.nodesConfig.endpoint.pingArtefact.options.codelist.label')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CONCEPT_SCHEME,title:t('data.nodesConfig.endpoint.pingArtefact.options.conceptScheme.label')},t('data.nodesConfig.endpoint.pingArtefact.options.conceptScheme.label'))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.endpoint.maEndpoint.label'),style:{marginBottom:0}},form.getFieldDecorator('MAEndpoint')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{placeholder:t("data.nodesConfig.endpoint.maEndpoint.placeholder"),addonAfter:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(PingAddOn,{isOk:node.isMAPingOk,onClick:function onClick(){return onPingMA(nodeIndex,{EndPointUrl:node.Endpoint.MAEndpoint,PingArtefact:node.Endpoint.PingArtefact,Enabled:node.Proxy.Enabled,Address:node.Proxy.Address,Port:node.Proxy.Port,Username:node.Proxy.Username,Password:node.Proxy.Password});},disabled:!node.Endpoint.MAEndpoint||node.Endpoint.MAEndpoint.length===0||!node.Endpoint.PingArtefact||node.Proxy.Enabled&&(!node.Proxy.Address||!node.Proxy.Port||node.Proxy.Username&&!node.Proxy.Password||!node.Proxy.Username&&node.Proxy.Password)})}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.endpoint.supportPostFilters.label")+' :'),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,null,form.getFieldDecorator("SupportPostFilters",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.endpoint.dmEndpoint.label'),style:{marginBottom:0}},form.getFieldDecorator('DMEndpoint')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{placeholder:t("data.nodesConfig.endpoint.dmEndpoint.placeholder"),addonAfter:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(PingAddOn,{isOk:node.isDMPingOk,onClick:function onClick(){return onPingDM(nodeIndex,{EndPointUrl:node.Endpoint.DMEndpoint,Enabled:node.Proxy.Enabled,Address:node.Proxy.Address,Port:node.Proxy.Port,Username:node.Proxy.Username,Password:node.Proxy.Password});},disabled:!node.Endpoint.DMEndpoint||node.Endpoint.DMEndpoint.length===0||node.Proxy.Enabled&&(!node.Proxy.Address||!node.Proxy.Port||node.Proxy.Username&&!node.Proxy.Password||!node.Proxy.Username&&node.Proxy.Password)})}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'not-implemented',label:t('data.nodesConfig.endpoint.ldapEndpoint.label'),style:{marginBottom:0}},form.getFieldDecorator('LDAPEndpoint')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'not-implemented',label:t('data.nodesConfig.endpoint.activeDirectoryEndpoint.label'),style:{marginBottom:0}},form.getFieldDecorator('ActiveDirectoryEndpoint')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.endpoint.metadataBaseURL.label'),style:{marginBottom:0}},form.getFieldDecorator('MetadataBaseURL')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{placeholder:t("data.nodesConfig.endpoint.metadataBaseURL.placeholder"),addonAfter:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(PingAddOn,{isOk:node.isMDPingOk,onClick:function onClick(){return onPingMD(nodeIndex,node.Endpoint.MetadataBaseURL);},disabled:!node.Endpoint.MetadataBaseURL||node.Endpoint.MetadataBaseURL.length===0})}))));};/* harmony default export */ __webpack_exports__["d"] = (Object(__WEBPACK_IMPORTED_MODULE_14_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(null,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(EndpointForm));

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MM_CODELISTS_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
var MM_CODELISTS_PREFIX="MM_CODELISTS_PREFIX_";var codelistsReducer=function codelistsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{codelists:null,codelistAnnotations:null,codelistAnnotationTriplet:null,parentsAndChildren:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CODELISTS_DETAIL_ANNOTATIONS_SHOW */]:return Object.assign({},state,{codelistAnnotations:action.annotations,codelistAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CODELISTS_DETAIL_ANNOTATIONS_HIDE */]:return Object.assign({},state,{codelistAnnotations:null,codelistAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CODELISTS_CODELIST_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CODELISTS_LIST_CODELISTS_READ */]:return Object.assign({},state,{codelists:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CODELISTS_CODELIST_DELETE */]:return Object.assign({},state,{codelists:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CODELISTS_SELECTED_CODELISTS_DELETE */]:return Object.assign({},state,{codelists:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CODELISTS_CODELIST_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});case MM_CODELISTS_PREFIX+__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_actions__["h" /* CODELIST_DETAIL_CREATE_SUBMIT */]:case MM_CODELISTS_PREFIX+__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_actions__["_30" /* CODELIST_DETAIL_UPDATE_SUBMIT */]:case MM_CODELISTS_PREFIX+__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_actions__["f" /* CODELIST_DETAIL_CLONE_SUBMIT */]:case MM_CODELISTS_PREFIX+__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_actions__["n" /* CODELIST_DETAIL_DERIVED_CODELIST_CREATE_SUBMIT */]:return Object.assign({},state,{codelists:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CODELISTS_SELECTED_CODELISTS_DELETE */]:return Object.assign({},state,{codelists:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["b" /* reuseInReducer */])(codelistsReducer,{codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_codelist_detail_modal_reducer__["a" /* default */],MM_CODELISTS_PREFIX)}));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MM_CATEGORY_SCHEMES_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_components_redux_category_scheme_detail_modal_actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_category_scheme_detail_modal_reducer__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
var MM_CATEGORY_SCHEMES_PREFIX="MM_CATEGORY_SCHEMES_PREFIX_";var categorySchemesReducer=function categorySchemesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{categorySchemes:null,categorySchemeAnnotations:null,categorySchemeAnnotationTriplet:null,parentsAndChildren:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_SHOW */]:return Object.assign({},state,{categorySchemeAnnotations:action.annotations,categorySchemeAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_HIDE */]:return Object.assign({},state,{categorySchemeAnnotations:null,categorySchemeAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CATEGORY_SCHEMES_LIST_CATEGORY_SCHEMES_READ */]:return Object.assign({},state,{categorySchemes:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CATEGORY_SCHEMES_CATEGORY_SCHEME_DELETE */]:return Object.assign({},state,{categorySchemes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CATEGORY_SCHEMES_SELECTED_CATEGORY_SCHEMES_DELETE */]:return Object.assign({},state,{categorySchemes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});case MM_CATEGORY_SCHEMES_PREFIX+__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_category_scheme_detail_modal_actions__["h" /* CATEGORY_SCHEME_DETAIL_CREATE_SUBMIT */]:case MM_CATEGORY_SCHEMES_PREFIX+__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_category_scheme_detail_modal_actions__["_0" /* CATEGORY_SCHEME_DETAIL_UPDATE_SUBMIT */]:case MM_CATEGORY_SCHEMES_PREFIX+__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_category_scheme_detail_modal_actions__["f" /* CATEGORY_SCHEME_DETAIL_CLONE_SUBMIT */]:case MM_CATEGORY_SCHEMES_PREFIX+__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_category_scheme_detail_modal_actions__["j" /* CATEGORY_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT */]:return Object.assign({},state,{categorySchemes:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CATEGORY_SCHEMES_SELECTED_CATEGORY_SCHEMES_DELETE */]:return Object.assign({},state,{categorySchemes:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["b" /* reuseInReducer */])(categorySchemesReducer,{categorySchemeDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_category_scheme_detail_modal_reducer__["b" /* default */],MM_CATEGORY_SCHEMES_PREFIX)}));

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MM_CONCEPT_SCHEMES_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_concept_scheme_detail_modal_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_concept_scheme_detail_modal_reducer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
var MM_CONCEPT_SCHEMES_PREFIX="MM_CONCEPT_SCHEMES_PREFIX_";var conceptSchemesReducer=function conceptSchemesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{conceptSchemes:null,conceptSchemeAnnotations:null,conceptSchemeAnnotationTriplet:null,parentsAndChildren:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_SHOW */]:return Object.assign({},state,{conceptSchemeAnnotations:action.annotations,conceptSchemeAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_HIDE */]:return Object.assign({},state,{conceptSchemeAnnotations:null,conceptSchemeAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CONCEPT_SCHEMES_LIST_CONCEPT_SCHEMES_READ */]:return Object.assign({},state,{conceptSchemes:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CONCEPT_SCHEMES_CONCEPT_SCHEME_DELETE */]:return Object.assign({},state,{conceptSchemes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CONCEPT_SCHEMES_SELECTED_CONCEPT_SCHEMES_DELETE */]:return Object.assign({},state,{conceptSchemes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});case MM_CONCEPT_SCHEMES_PREFIX+__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_concept_scheme_detail_modal_actions__["h" /* CONCEPT_SCHEME_DETAIL_CREATE_SUBMIT */]:case MM_CONCEPT_SCHEMES_PREFIX+__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_concept_scheme_detail_modal_actions__["_0" /* CONCEPT_SCHEME_DETAIL_UPDATE_SUBMIT */]:case MM_CONCEPT_SCHEMES_PREFIX+__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_concept_scheme_detail_modal_actions__["f" /* CONCEPT_SCHEME_DETAIL_CLONE_SUBMIT */]:case MM_CONCEPT_SCHEMES_PREFIX+__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_concept_scheme_detail_modal_actions__["j" /* CONCEPT_SCHEME_DETAIL_DERIVED_ITEM_SCHEME_CREATE_SUBMIT */]:return Object.assign({},state,{conceptSchemes:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CONCEPT_SCHEMES_SELECTED_CONCEPT_SCHEMES_DELETE */]:return Object.assign({},state,{conceptSchemes:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["b" /* reuseInReducer */])(conceptSchemesReducer,{conceptSchemeDetail:Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_concept_scheme_detail_modal_reducer__["b" /* default */],MM_CONCEPT_SCHEMES_PREFIX)}));

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW; });
/* unused harmony export CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD; });
/* unused harmony export CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD_LABEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_tree_filter__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_css__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_css__);
var CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW="dataflow";var CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW_LABEL="Dataflow";var CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD="dsd";var CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD_LABEL="Data Structure Definition";var mapStateToProps=function mapStateToProps(state){return{nodes:state.config.nodes,nodeId:state.app.endpointId,username:state.app.user.username};};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_TWO_THIRDS"]}};var FilterTab=function FilterTab(_ref){var t=_ref.t,nodes=_ref.nodes,nodeId=_ref.nodeId,username=_ref.username,artefactType=_ref.artefactType,artefactTriplet=_ref.artefactTriplet,onArtefactTypeSelect=_ref.onArtefactTypeSelect,onArtefactsShow=_ref.onArtefactsShow,onArtefactUnset=_ref.onArtefactUnset,filterDsdTriplet=_ref.filterDsdTriplet,filterCubeId=_ref.filterCubeId,onFilterReset=_ref.onFilterReset,filterColumns=_ref.filterColumns,onFilterChange=_ref.onFilterChange,isFilterQueryVisible=_ref.isFilterQueryVisible,onFilterQueryShow=_ref.onFilterQueryShow,onFilterQueryHide=_ref.onFilterQueryHide,filter=_ref.filter,onFilterColumnModeChange=_ref.onFilterColumnModeChange,onFilterColumnValuesChange=_ref.onFilterColumnValuesChange,fetchArtefact=_ref.fetchArtefact,fetchFilterDsd=_ref.fetchFilterDsd,fetchFilterCube=_ref.fetchFilterCube,fetchFilterColumnCodelistCount=_ref.fetchFilterColumnCodelistCount,fetchFilterColumnCodelistTree=_ref.fetchFilterColumnCodelistTree,fetchFilterColumnFilteredValues=_ref.fetchFilterColumnFilteredValues,disabled=_ref.disabled;var haveDMWS=nodes.find(function(node){return node.general.id===nodeId;}).endpoint.haveDMWS;var isUserLogged=username!==null&&username!==undefined;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.metaManager.commons.detail.tabs.constraintItems.select.title'),className:'form-item-required'},formItemLayout),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a,{disabled:disabled,showSearch:true,filterOption:function filterOption(inputValue,_ref2){var props=_ref2.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},defaultValue:artefactType,onSelect:onArtefactTypeSelect,style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW,title:CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW_LABEL},CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW_LABEL),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD,title:CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD_LABEL},CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD_LABEL)))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.metaManager.commons.detail.tabs.constraintItems.selector.title'),className:'form-item-required'},formItemLayout),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_selector__["a" /* default */],{value:artefactTriplet,selectTitle:t('scenes.metaManager.commons.detail.tabs.constraintItems.selector.select.title'),resetTitle:t('scenes.metaManager.commons.detail.tabs.constraintItems.selector.reset.title'),onSelect:onArtefactsShow,onReset:onArtefactUnset,disabled:disabled})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchArtefact,cbParam:{artefactType:artefactType,artefactTriplet:artefactTriplet?Object(__WEBPACK_IMPORTED_MODULE_18__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(artefactTriplet):null,haveDMWS:haveDMWS,isUserLogged:isUserLogged},disabled:artefactTriplet===null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchFilterDsd,cbParam:filterDsdTriplet,disabled:filterDsdTriplet===null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchFilterCube,cbParam:filterCubeId,disabled:filterCubeId===null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:"content-constraint-filter-tab__tree-filter"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_tree_filter__["a" /* default */],{hideInclusionRadio:true,disabled:disabled,columns:filterColumns||[],fetchColumnCodelistCount:fetchFilterColumnCodelistCount,fetchColumnCodelistTree:fetchFilterColumnCodelistTree,fetchColumnFilteredValues:filterCubeId?function(_ref3){var colNames=_ref3.colNames,filterStr=_ref3.filterStr;return fetchFilterColumnFilteredValues(filterCubeId,colNames,filterStr);}:null,onChange:onFilterChange,treeFilter:filter,onColumnModeChange:onFilterColumnModeChange,onColumnValuesChange:onFilterColumnValuesChange,isCC:true})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"],style:{marginTop:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{icon:'delete',onClick:onFilterReset,disabled:disabled},t('components.contentConstraintFilterTab.buttons.resetFilters.title'))))))));};/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps),Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])())(FilterTab));

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MM_DSDS_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_dsd_detail_modal_reducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_dsd_detail_modal_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
var MM_DSDS_PREFIX="MM_DSDS_PREFIX_";var dsdsReducer=function dsdsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{dsds:null,dsdAnnotations:null,dsdLayoutAnnotations:null,dsdAnnotationTriplet:null,parentsAndChildren:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* DSDS_LIST_DSD_ANNOTATIONS_SHOW */]:return Object.assign({},state,{dsdAnnotations:action.annotations,dsdAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* DSDS_LIST_DSD_ANNOTATIONS_HIDE */]:return Object.assign({},state,{dsdAnnotations:null,dsdAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_SHOW */]:return Object.assign({},state,{dsdLayoutAnnotations:action.annotations,dsdAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_HIDE */]:return Object.assign({},state,{dsdLayoutAnnotations:null,dsdAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DSDS_DSD_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* DSDS_LIST_DSDS_READ */]:return Object.assign({},state,{dsds:Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* DSDS_LIST_DSD_DELETE */]:return Object.assign({},state,{dsds:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* DSDS_LIST_SELECTED_DSDS_DELETE */]:return Object.assign({},state,{dsds:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* DSDS_DSD_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});case MM_DSDS_PREFIX+__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_dsd_detail_modal_actions__["A" /* DSD_DETAIL_CREATE_SUBMIT */]:case MM_DSDS_PREFIX+__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_dsd_detail_modal_actions__["_19" /* DSD_DETAIL_UPDATE_SUBMIT */]:case MM_DSDS_PREFIX+__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_dsd_detail_modal_actions__["l" /* DSD_DETAIL_CLONE_SUBMIT */]:return Object.assign({},state,{dsds:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* DSDS_LIST_SELECTED_DSDS_DELETE */]:return Object.assign({},state,{dsds:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["b" /* reuseInReducer */])(dsdsReducer,{dsdDetail:Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_dsd_detail_modal_reducer__["c" /* default */],MM_DSDS_PREFIX)}));

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_MANAGEMENT_USERS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return USER_MANAGEMENT_USER_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_MANAGEMENT_USER_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_MANAGEMENT_USER_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_MANAGEMENT_USER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_MANAGEMENT_USER_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_MANAGEMENT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_MANAGEMENT_SYNCHRONIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_MANAGEMENT_USER_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return readUserManagementUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return readUserManagementUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return editUserManagementUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hideUserManagementUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return changeUserManagementUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createUserManagementUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return synchronizeUserManagement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return submitUserManagement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deleteUserManagementUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var USER_MANAGEMENT_USERS_READ='USER_MANAGEMENT_USERS_READ';var USER_MANAGEMENT_USER_READ='USER_MANAGEMENT_USER_READ';var USER_MANAGEMENT_USER_EDIT='USER_MANAGEMENT_USER_EDIT';var USER_MANAGEMENT_USER_HIDE='USER_MANAGEMENT_USER_HIDE';var USER_MANAGEMENT_USER_CHANGE='USER_MANAGEMENT_USER_CHANGE';var USER_MANAGEMENT_USER_CREATE='USER_MANAGEMENT_USER_CREATE';var USER_MANAGEMENT_SUBMIT='USER_MANAGEMENT_SUBMIT';var USER_MANAGEMENT_SYNCHRONIZE='USER_MANAGEMENT_SYNCHRONIZE';var USER_MANAGEMENT_USER_DELETE='USER_MANAGEMENT_USER_DELETE';var readUserManagementUsers=function readUserManagementUsers(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(USER_MANAGEMENT_USERS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_110" /* getUsers */])());};var readUserManagementUser=function readUserManagementUser(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(USER_MANAGEMENT_USER_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_74" /* getReadPermissionsUrl */])());};var editUserManagementUser=function editUserManagementUser(username,email,isExternal){return{type:USER_MANAGEMENT_USER_EDIT,username:username,email:email,isExternal:isExternal};};var hideUserManagementUser=function hideUserManagementUser(){return{type:USER_MANAGEMENT_USER_HIDE};};var changeUserManagementUser=function changeUserManagementUser(fields){return{type:USER_MANAGEMENT_USER_CHANGE,fields:fields};};var createUserManagementUser=function createUserManagementUser(username,password,email){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(USER_MANAGEMENT_USER_CREATE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["S" /* getCreateUserUrl */])(),{username:username,password:btoa(password||""),email:email},function(t){return{success:t('scenes.manageUsers.userManagement.messages.createUserSubmit.success')};});};var synchronizeUserManagement=function synchronizeUserManagement(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(USER_MANAGEMENT_SYNCHRONIZE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_94" /* getSynchronizeAuthDBUrl */])());};var submitUserManagement=function submitUserManagement(user,token,editPassword,isLoginValid){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(USER_MANAGEMENT_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_103" /* getUpdateUserUrl */])(),{username:user.username,token:token,password:editPassword?btoa(user.password||""):null,email:user.email},function(t){return{success:isLoginValid?t('scenes.manageUsers.userManagement.messages.editUserSubmit.success'):t('scenes.manageUsers.userManagement.messages.editCurrentUserSubmit.success')};}),{isLoginValid:isLoginValid});};var deleteUserManagementUser=function deleteUserManagementUser(username){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(USER_MANAGEMENT_USER_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_18" /* getDeleteUserUrl */])(username),function(t){return{success:t('scenes.manageUsers.userManagement.messages.deleteUser.success')};});};

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPARE_DSDS_SRC_DSDS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMPARE_DSDS_SRC_DSDS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMPARE_DSDS_SRC_DSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMPARE_DSDS_SRC_TRIPLET_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMPARE_DSDS_SRC_TRIPLET_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return COMPARE_DSDS_TARGET_DSDS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COMPARE_DSDS_TARGET_DSDS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COMPARE_DSDS_TARGET_DSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return COMPARE_DSDS_TARGET_TRIPLET_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return COMPARE_DSDS_TARGET_TRIPLET_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPARE_DSDS_REPORT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPARE_DSDS_REPORT_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPARE_DSDS_CODELIST_COMPARE_REPORT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPARE_DSDS_CODELIST_COMPARE_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPARE_DSDS_DSD_SOURCE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPARE_DSDS_DSD_FILE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return showCompareDsdsSrcDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return showCompareDsdsTargetDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return hideCompareDsdsSrcDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return hideCompareDsdsTargetDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return readCompareDsdsSrcDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return readCompareDsdsTargetDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return setCompareDsdsSrcTriplet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return resetCompareDsdsSrcTriplet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return setCompareDsdsTargetTriplet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return resetCompareDsdsTargetTriplet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return readCompareDsdsReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return readCompareDsdsCodelistCompareReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return hideCompareDsdsCodelistCompareReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return downloadCompareDsdsReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return changeCompareDsdsDsdSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return setCompareDsdsDsdFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var COMPARE_DSDS_SRC_DSDS_SHOW='COMPARE_DSDS_SRC_DSDS_SHOW';var COMPARE_DSDS_SRC_DSDS_HIDE='COMPARE_DSDS_SRC_DSDS_HIDE';var COMPARE_DSDS_SRC_DSDS_READ='COMPARE_DSDS_SRC_DSDS_READ';var COMPARE_DSDS_SRC_TRIPLET_SET='COMPARE_DSDS_SRC_TRIPLET_SET';var COMPARE_DSDS_SRC_TRIPLET_RESET='COMPARE_DSDS_SRC_TRIPLET_RESET';var COMPARE_DSDS_TARGET_DSDS_SHOW='COMPARE_DSDS_TARGET_DSDS_SHOW';var COMPARE_DSDS_TARGET_DSDS_HIDE='COMPARE_DSDS_TARGET_DSDS_HIDE';var COMPARE_DSDS_TARGET_DSDS_READ='COMPARE_DSDS_TARGET_DSDS_READ';var COMPARE_DSDS_TARGET_TRIPLET_SET='COMPARE_DSDS_TARGET_TRIPLET_SET';var COMPARE_DSDS_TARGET_TRIPLET_RESET='COMPARE_DSDS_TARGET_TRIPLET_RESET';var COMPARE_DSDS_REPORT_READ='COMPARE_DSDS_REPORT_READ';var COMPARE_DSDS_REPORT_DOWNLOAD='COMPARE_DSDS_REPORT_DOWNLOAD';var COMPARE_DSDS_CODELIST_COMPARE_REPORT_READ='COMPARE_DSDS_CODELIST_COMPARE_REPORT_READ';var COMPARE_DSDS_CODELIST_COMPARE_REPORT_HIDE='COMPARE_DSDS_CODELIST_COMPARE_REPORT_HIDE';var COMPARE_DSDS_DSD_SOURCE_CHANGE='COMPARE_DSDS_DSD_SOURCE_CHANGE';var COMPARE_DSDS_DSD_FILE_SET='COMPARE_DSDS_DSD_FILE_SET';var showCompareDsdsSrcDsds=function showCompareDsdsSrcDsds(){return{type:COMPARE_DSDS_SRC_DSDS_SHOW};};var showCompareDsdsTargetDsds=function showCompareDsdsTargetDsds(){return{type:COMPARE_DSDS_TARGET_DSDS_SHOW};};var hideCompareDsdsSrcDsds=function hideCompareDsdsSrcDsds(){return{type:COMPARE_DSDS_SRC_DSDS_HIDE};};var hideCompareDsdsTargetDsds=function hideCompareDsdsTargetDsds(){return{type:COMPARE_DSDS_TARGET_DSDS_HIDE};};var readCompareDsdsSrcDsds=function readCompareDsdsSrcDsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(COMPARE_DSDS_SRC_DSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])());};var readCompareDsdsTargetDsds=function readCompareDsdsTargetDsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(COMPARE_DSDS_TARGET_DSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])());};var setCompareDsdsSrcTriplet=function setCompareDsdsSrcTriplet(srcTriplet){return{type:COMPARE_DSDS_SRC_TRIPLET_SET,srcTriplet:srcTriplet};};var resetCompareDsdsSrcTriplet=function resetCompareDsdsSrcTriplet(){return{type:COMPARE_DSDS_SRC_TRIPLET_RESET};};var setCompareDsdsTargetTriplet=function setCompareDsdsTargetTriplet(targetTriplet){return{type:COMPARE_DSDS_TARGET_TRIPLET_SET,targetTriplet:targetTriplet};};var resetCompareDsdsTargetTriplet=function resetCompareDsdsTargetTriplet(){return{type:COMPARE_DSDS_TARGET_TRIPLET_RESET};};var readCompareDsdsReport=function readCompareDsdsReport(srcTriplet,targetTriplet,srcFile,targetFile){var customData={sourceArtefact:srcTriplet?{ID:srcTriplet.id,Agency:srcTriplet.agencyID,Version:srcTriplet.version,StreamType:'Database'}:{StreamType:'Xml'},targetArtefact:targetTriplet?{ID:targetTriplet.id,Agency:targetTriplet.agencyID,Version:targetTriplet.version,StreamType:'Database'}:{StreamType:'Xml'}};var fileFormData=new FormData();if(srcFile!==null){fileFormData.append('Files',srcFile);}if(targetFile!==null){fileFormData.append('Files',targetFile);}fileFormData.append('CustomData',JSON.stringify(customData));return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(COMPARE_DSDS_REPORT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["C" /* getCompareDsdsUrl */])(),fileFormData);};var readCompareDsdsCodelistCompareReport=function readCompareDsdsCodelistCompareReport(srcTriplet,targetTriplet,srcFile,targetFile){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(COMPARE_DSDS_CODELIST_COMPARE_REPORT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["B" /* getCompareCodelistUrl */])(srcTriplet,targetTriplet,srcFile,targetFile));};var hideCompareDsdsCodelistCompareReport=function hideCompareDsdsCodelistCompareReport(){return{type:COMPARE_DSDS_CODELIST_COMPARE_REPORT_HIDE};};var downloadCompareDsdsReport=function downloadCompareDsdsReport(srcTriplet,targetTriplet,srcFile,targetFile,lang){var currDate=__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD_HH-mm-ss');var fileSave={name:"CompareDsds_"+currDate+".txt",type:"text/plain;charset=utf-8"};var customData={sourceArtefact:srcTriplet?{ID:srcTriplet.id,Agency:srcTriplet.agencyID,Version:srcTriplet.version,StreamType:'Database'}:{StreamType:'Xml'},targetArtefact:targetTriplet?{ID:targetTriplet.id,Agency:targetTriplet.agencyID,Version:targetTriplet.version,StreamType:'Database'}:{StreamType:'Xml'}};var fileFormData=new FormData();if(srcFile!==null){fileFormData.append('Files',srcFile);}if(targetFile!==null){fileFormData.append('Files',targetFile);}fileFormData.append('CustomData',JSON.stringify(customData));return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(COMPARE_DSDS_REPORT_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_43" /* getGenerateFileReportDsdUrl */])(lang),fileFormData,undefined,undefined,true),{fileSave:fileSave});};var changeCompareDsdsDsdSource=function changeCompareDsdsDsdSource(source,isSrc){return{type:COMPARE_DSDS_DSD_SOURCE_CHANGE,source:source,isSrc:isSrc};};var setCompareDsdsDsdFile=function setCompareDsdsDsdFile(file,isSrc){return{type:COMPARE_DSDS_DSD_FILE_SET,file:file,isSrc:isSrc};};

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return COMPARE_ITEM_SCHEMES_FORMAT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COMPARE_ITEM_SCHEMES_CSV_PROPS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return COMPARE_ITEM_SCHEMES_FILE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPARE_ITEM_SCHEMES_ARTEFACTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPARE_ITEM_SCHEMES_ARTEFACTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPARE_ITEM_SCHEMES_ARTEFACTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPARE_ITEM_SCHEMES_ARTEFACT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPARE_ITEM_SCHEMES_ARTEFACT_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPARE_ITEM_SCHEMES_COMPARE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMPARE_ITEM_SCHEMES_COMPARE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMPARE_ITEM_SCHEMES_COMPARE_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return COMPARE_ITEM_SCHEMES_XML_PREVIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return COMPARE_ITEM_SCHEMES_XML_PREVIEW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return COMPARE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return COMPARE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return COMPARE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return COMPARE_ITEM_SCHEMES_PREVIEW_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COMPARE_ITEM_SCHEMES_CSV_PREVIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMPARE_ITEM_SCHEMES_CSV_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMPARE_ITEM_SCHEMES_CSV_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return changeCompareItemSchemesArtefactType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return changeCompareItemSchemesFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return changeCompareItemSchemesCsvProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return setCompareItemSchemesFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return showCompareItemSchemesArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return hideCompareItemSchemesArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return readCompareItemSchemesArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return setCompareItemSchemesArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return unsetCompareItemSchemesArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return readCompareItemSchemesCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return hideCompareItemSchemesCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return downloadCompareItemSchemesCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return showCompareItemSchemesXmlPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return readCompareItemSchemesXmlPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return updateCompareItemSchemesXmlPreviewParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return changeCompareItemSchemesXmlPreviewLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return readCompareItemSchemesXmlPreviewPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return hideCompareItemSchemesPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return showCompareItemSchemesCsvPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return uploadCompareItemSchemesCsvFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return readCompareItemSchemesCsvPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE='COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE';var COMPARE_ITEM_SCHEMES_FORMAT_CHANGE='COMPARE_ITEM_SCHEMES_FORMAT_CHANGE';var COMPARE_ITEM_SCHEMES_CSV_PROPS_CHANGE='COMPARE_ITEM_SCHEMES_CSV_PROPS_CHANGE';var COMPARE_ITEM_SCHEMES_FILE_SET='COMPARE_ITEM_SCHEMES_FILE_SET';var COMPARE_ITEM_SCHEMES_ARTEFACTS_SHOW='COMPARE_ITEM_SCHEMES_ARTEFACTS_SHOW';var COMPARE_ITEM_SCHEMES_ARTEFACTS_HIDE='COMPARE_ITEM_SCHEMES_ARTEFACTS_HIDE';var COMPARE_ITEM_SCHEMES_ARTEFACTS_READ='COMPARE_ITEM_SCHEMES_ARTEFACTS_READ';var COMPARE_ITEM_SCHEMES_ARTEFACT_SET='COMPARE_ITEM_SCHEMES_ARTEFACT_SET';var COMPARE_ITEM_SCHEMES_ARTEFACT_UNSET='COMPARE_ITEM_SCHEMES_ARTEFACT_UNSET';var COMPARE_ITEM_SCHEMES_COMPARE_READ='COMPARE_ITEM_SCHEMES_COMPARE_READ';var COMPARE_ITEM_SCHEMES_COMPARE_HIDE='COMPARE_ITEM_SCHEMES_COMPARE_HIDE';var COMPARE_ITEM_SCHEMES_COMPARE_DOWNLOAD='COMPARE_ITEM_SCHEMES_COMPARE_DOWNLOAD';var COMPARE_ITEM_SCHEMES_XML_PREVIEW_SHOW='COMPARE_ITEM_SCHEMES_XML_PREVIEW_SHOW';var COMPARE_ITEM_SCHEMES_XML_PREVIEW_READ='COMPARE_ITEM_SCHEMES_XML_PREVIEW_READ';var COMPARE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE='COMPARE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE';var COMPARE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE='COMPARE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE';var COMPARE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ='COMPARE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ';var COMPARE_ITEM_SCHEMES_PREVIEW_HIDE='COMPARE_ITEM_SCHEMES_PREVIEW_HIDE';var COMPARE_ITEM_SCHEMES_CSV_PREVIEW_SHOW='COMPARE_ITEM_SCHEMES_CSV_PREVIEW_SHOW';var COMPARE_ITEM_SCHEMES_CSV_FILE_UPLOAD='COMPARE_ITEM_SCHEMES_CSV_FILE_UPLOAD';var COMPARE_ITEM_SCHEMES_CSV_PAGE_READ='COMPARE_ITEM_SCHEMES_CSV_PAGE_READ';var changeCompareItemSchemesArtefactType=function changeCompareItemSchemesArtefactType(artefactType){return{type:COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE,artefactType:artefactType};};var changeCompareItemSchemesFormat=function changeCompareItemSchemesFormat(isSource,format,lang){return{type:COMPARE_ITEM_SCHEMES_FORMAT_CHANGE,isSource:isSource,format:format,lang:lang};};var changeCompareItemSchemesCsvProps=function changeCompareItemSchemesCsvProps(isSource,fields){return{type:COMPARE_ITEM_SCHEMES_CSV_PROPS_CHANGE,isSource:isSource,fields:fields};};var setCompareItemSchemesFile=function setCompareItemSchemesFile(isSource,file){return{type:COMPARE_ITEM_SCHEMES_FILE_SET,isSource:isSource,file:file};};var showCompareItemSchemesArtefacts=function showCompareItemSchemesArtefacts(isSource){return{type:COMPARE_ITEM_SCHEMES_ARTEFACTS_SHOW,isSource:isSource};};var hideCompareItemSchemesArtefacts=function hideCompareItemSchemesArtefacts(){return{type:COMPARE_ITEM_SCHEMES_ARTEFACTS_HIDE};};var readCompareItemSchemesArtefacts=function readCompareItemSchemesArtefacts(artefactType){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(COMPARE_ITEM_SCHEMES_ARTEFACTS_READ,artefactType===__WEBPACK_IMPORTED_MODULE_2__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["A" /* getCodelistUrl */])():artefactType===__WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME */]?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["p" /* getCategorySchemeUrl */])():Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])());};var setCompareItemSchemesArtefact=function setCompareItemSchemesArtefact(artefactTriplet){return{type:COMPARE_ITEM_SCHEMES_ARTEFACT_SET,artefactTriplet:artefactTriplet};};var unsetCompareItemSchemesArtefact=function unsetCompareItemSchemesArtefact(isSource){return{type:COMPARE_ITEM_SCHEMES_ARTEFACT_UNSET,isSource:isSource};};var readCompareItemSchemesCompare=function readCompareItemSchemesCompare(artefactType,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps){var fileFormData=new FormData();if(sourceFormat!==__WEBPACK_IMPORTED_MODULE_2__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]){fileFormData.append('files',source);}if(targetFormat!==__WEBPACK_IMPORTED_MODULE_2__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]){fileFormData.append('files',target);}if(sourceFormat===__WEBPACK_IMPORTED_MODULE_2__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]){fileFormData.append('customDataFirst',JSON.stringify(sourceCsvProps));}if(targetFormat===__WEBPACK_IMPORTED_MODULE_2__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]){fileFormData.append('customDataSecond',JSON.stringify(targetCsvProps));}return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(COMPARE_ITEM_SCHEMES_COMPARE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["E" /* getCompareItemsUrl */])(artefactType,sourceFormat===__WEBPACK_IMPORTED_MODULE_2__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]?source:null,targetFormat===__WEBPACK_IMPORTED_MODULE_2__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]?target:null),fileFormData);};var hideCompareItemSchemesCompare=function hideCompareItemSchemesCompare(){return{type:COMPARE_ITEM_SCHEMES_COMPARE_HIDE};};var downloadCompareItemSchemesCompare=function downloadCompareItemSchemesCompare(artefactType,lang,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps){var fileFormData=new FormData();if(sourceFormat!==__WEBPACK_IMPORTED_MODULE_2__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]){fileFormData.append('files',source);}if(targetFormat!==__WEBPACK_IMPORTED_MODULE_2__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]){fileFormData.append('files',target);}if(sourceFormat===__WEBPACK_IMPORTED_MODULE_2__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]){fileFormData.append('customDataFirst',JSON.stringify(sourceCsvProps));}if(targetFormat===__WEBPACK_IMPORTED_MODULE_2__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]){fileFormData.append('customDataSecond',JSON.stringify(targetCsvProps));}var currDate=__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD_HH-mm-ss');var fileSave={name:"CompareItemSchemes_"+currDate+".txt",type:"text/plain;charset=utf-8"};return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(COMPARE_ITEM_SCHEMES_COMPARE_DOWNLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["D" /* getCompareItemsForFileUrl */])(artefactType,lang,sourceFormat===__WEBPACK_IMPORTED_MODULE_2__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]?source:null,targetFormat===__WEBPACK_IMPORTED_MODULE_2__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]?target:null),fileFormData),{fileSave:fileSave});};var showCompareItemSchemesXmlPreview=function showCompareItemSchemesXmlPreview(isSource){return{type:COMPARE_ITEM_SCHEMES_XML_PREVIEW_SHOW,isSource:isSource};};var readCompareItemSchemesXmlPreview=function readCompareItemSchemesXmlPreview(artefactType,file,lang){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(COMPARE_ITEM_SCHEMES_XML_PREVIEW_READ,artefactType===__WEBPACK_IMPORTED_MODULE_2__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_112" /* getXmlCodelistPreviewUrl */])(lang):Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_111" /* getXmlArtefactPreviewUrl */])(artefactType),fileFormData);};var updateCompareItemSchemesXmlPreviewParams=function updateCompareItemSchemesXmlPreviewParams(params){return{type:COMPARE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE,params:params};};var changeCompareItemSchemesXmlPreviewLang=function changeCompareItemSchemesXmlPreviewLang(lang){return{type:COMPARE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE,lang:lang};};var readCompareItemSchemesXmlPreviewPage=function readCompareItemSchemesXmlPreviewPage(triplet,lang,pageNum,pageSize,searchText,filters,sortCol,sortByDesc,rebuildDb){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(COMPARE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:triplet&&triplet.id?triplet.id:undefined,agencyID:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:pageNum?pageNum:undefined,pageSize:pageSize?pageSize:undefined,allSearch:searchText?searchText:undefined,codeSearch:filters&&filters.id?filters.id:undefined,nameSearch:filters&&filters.name?filters.name:undefined,parentSearch:filters&&filters.parent?filters.parent:undefined,sortColumn:sortCol?sortCol:undefined,sortDesc:sortByDesc?sortByDesc:undefined,rebuildDb:rebuildDb}));};var hideCompareItemSchemesPreview=function hideCompareItemSchemesPreview(){return{type:COMPARE_ITEM_SCHEMES_PREVIEW_HIDE};};var showCompareItemSchemesCsvPreview=function showCompareItemSchemesCsvPreview(isSource){return{type:COMPARE_ITEM_SCHEMES_CSV_PREVIEW_SHOW,isSource:isSource};};var uploadCompareItemSchemesCsvFile=function uploadCompareItemSchemesCsvFile(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(COMPARE_ITEM_SCHEMES_CSV_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),fileFormData);};var readCompareItemSchemesCsvPage=function readCompareItemSchemesCsvPage(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(COMPARE_ITEM_SCHEMES_CSV_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,filePath,null,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MM_CONTENT_CONSTRAINTS_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_content_constraint_modal_reducer__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_components_redux_content_constraint_modal_actions__ = __webpack_require__(162);
var MM_CONTENT_CONSTRAINTS_PREFIX="MM_CONTENT_CONSTRAINTS_PREFIX";var contentConstraintsReducer=function contentConstraintsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{contentConstraints:null,contentConstraintAnnotations:null,contentConstraintAnnotationTriplet:null,parentsAndChildren:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_SHOW */]:return Object.assign({},state,{contentConstraintAnnotations:action.annotations,contentConstraintAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_HIDE */]:return Object.assign({},state,{contentConstraintAnnotations:null,contentConstraintAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CONTENT_CONSTRAINTS_LIST_CONTENT_CONSTRAINTS_READ */]:return Object.assign({},state,{contentConstraints:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_3__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_DELETE */]:return Object.assign({},state,{contentConstraints:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CONTENT_CONSTRAINTS_SELECTED_CONTENT_CONSTRAINTS_DELETE */]:return Object.assign({},state,{contentConstraints:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});case MM_CONTENT_CONSTRAINTS_PREFIX+__WEBPACK_IMPORTED_MODULE_6__redux_components_redux_content_constraint_modal_actions__["o" /* CONTENT_CONSTRAINT_DETAIL_CREATE_SUBMIT */]:case MM_CONTENT_CONSTRAINTS_PREFIX+__WEBPACK_IMPORTED_MODULE_6__redux_components_redux_content_constraint_modal_actions__["P" /* CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT */]:case MM_CONTENT_CONSTRAINTS_PREFIX+__WEBPACK_IMPORTED_MODULE_6__redux_components_redux_content_constraint_modal_actions__["m" /* CONTENT_CONSTRAINT_DETAIL_CLONE_SUBMIT */]:return Object.assign({},state,{contentConstraints:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CONTENT_CONSTRAINTS_SELECTED_CONTENT_CONSTRAINTS_DELETE */]:return Object.assign({},state,{contentConstraints:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["b" /* reuseInReducer */])(contentConstraintsReducer,{contentConstraintDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_content_constraint_modal_reducer__["a" /* default */],MM_CONTENT_CONSTRAINTS_PREFIX)}));

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MERGE_ITEM_SCHEMES_FORMAT_TYPE_SDMX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MERGE_ITEM_SCHEMES_FORMAT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MERGE_ITEM_SCHEMES_CSV_PROPS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MERGE_ITEM_SCHEMES_FILE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MERGE_ITEM_SCHEMES_ARTEFACTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MERGE_ITEM_SCHEMES_ARTEFACTS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MERGE_ITEM_SCHEMES_ARTEFACTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MERGE_ITEM_SCHEMES_ARTEFACT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MERGE_ITEM_SCHEMES_ARTEFACT_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MERGE_ITEM_SCHEMES_MERGE_PREVIEW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MERGE_ITEM_SCHEMES_MERGE_PREVIEW_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_LANG_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_PARAMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MERGE_ITEM_SCHEMES_CODELIST_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MERGE_ITEM_SCHEMES_MERGE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MERGE_ITEM_SCHEMES_MERGE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MERGE_ITEM_SCHEMES_MERGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MERGE_ITEM_SCHEMES_MERGE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return MERGE_ITEM_SCHEMES_XML_PREVIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return MERGE_ITEM_SCHEMES_XML_PREVIEW_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return MERGE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return MERGE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return MERGE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MERGE_ITEM_SCHEMES_CSV_PREVIEW_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MERGE_ITEM_SCHEMES_CSV_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MERGE_ITEM_SCHEMES_CSV_PAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MERGE_ITEM_SCHEMES_PREVIEW_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return changeMergeItemSchemesArtefactType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return changeMergeItemSchemesFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return changeMergeItemSchemesCsvProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return setMergeItemSchemesFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return showMergeItemSchemesArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return hideMergeItemSchemesArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return readMergeItemSchemesArtefacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return setMergeItemSchemesArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return unsetMergeItemSchemesArtefact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return readMergeItemSchemesMergePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return hideMergeItemSchemesMergePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return changeMergeItemSchemesCodelistMergePreviewLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return updateMergeItemSchemesCodelistMergePreviewParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return readMergeItemSchemesCodelistPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return showMergeItemSchemesMerge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return hideMergeItemSchemesMerge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return changeMergeItemSchemesMerge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return submitMergeItemSchemesMerge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return showMergeItemSchemesXmlPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return readMergeItemSchemesXmlPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return updateMergeItemSchemesXmlPreviewParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return changeMergeItemSchemesXmlPreviewLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return readMergeItemSchemesXmlPreviewPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return showMergeItemSchemesCsvPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return uploadMergeItemSchemesCsvFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return readMergeItemSchemesCsvPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return hideMergeItemSchemesPreview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
var MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB="msdb";var MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV="csv";var MERGE_ITEM_SCHEMES_FORMAT_TYPE_SDMX="sdmx";var MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST="Codelist";var MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME="CategoryScheme";var MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME="ConceptScheme";var MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE='MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE';var MERGE_ITEM_SCHEMES_FORMAT_CHANGE='MERGE_ITEM_SCHEMES_FORMAT_CHANGE';var MERGE_ITEM_SCHEMES_CSV_PROPS_CHANGE='MERGE_ITEM_SCHEMES_CSV_PROPS_CHANGE';var MERGE_ITEM_SCHEMES_FILE_SET='MERGE_ITEM_SCHEMES_FILE_SET';var MERGE_ITEM_SCHEMES_ARTEFACTS_SHOW='MERGE_ITEM_SCHEMES_ARTEFACTS_SHOW';var MERGE_ITEM_SCHEMES_ARTEFACTS_HIDE='MERGE_ITEM_SCHEMES_ARTEFACTS_HIDE';var MERGE_ITEM_SCHEMES_ARTEFACTS_READ='MERGE_ITEM_SCHEMES_ARTEFACTS_READ';var MERGE_ITEM_SCHEMES_ARTEFACT_SET='MERGE_ITEM_SCHEMES_ARTEFACT_SET';var MERGE_ITEM_SCHEMES_ARTEFACT_UNSET='MERGE_ITEM_SCHEMES_ARTEFACT_UNSET';var MERGE_ITEM_SCHEMES_MERGE_PREVIEW_READ='MERGE_ITEM_SCHEMES_MERGE_PREVIEW_READ';var MERGE_ITEM_SCHEMES_MERGE_PREVIEW_HIDE='MERGE_ITEM_SCHEMES_MERGE_PREVIEW_HIDE';var MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_LANG_CHANGE='MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_LANG_CHANGE';var MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_PARAMS_UPDATE='MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_PARAMS_UPDATE';var MERGE_ITEM_SCHEMES_CODELIST_PAGE_READ='MERGE_ITEM_SCHEMES_CODELIST_PAGE_READ';var MERGE_ITEM_SCHEMES_MERGE_SHOW='MERGE_ITEM_SCHEMES_MERGE_SHOW';var MERGE_ITEM_SCHEMES_MERGE_HIDE='MERGE_ITEM_SCHEMES_MERGE_HIDE';var MERGE_ITEM_SCHEMES_MERGE_CHANGE='MERGE_ITEM_SCHEMES_MERGE_CHANGE';var MERGE_ITEM_SCHEMES_MERGE_SUBMIT='MERGE_ITEM_SCHEMES_MERGE_SUBMIT';var MERGE_ITEM_SCHEMES_XML_PREVIEW_SHOW='MERGE_ITEM_SCHEMES_XML_PREVIEW_SHOW';var MERGE_ITEM_SCHEMES_XML_PREVIEW_READ='MERGE_ITEM_SCHEMES_XML_PREVIEW_READ';var MERGE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ='MERGE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ';var MERGE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE='MERGE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE';var MERGE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE='MERGE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE';var MERGE_ITEM_SCHEMES_CSV_PREVIEW_SHOW='MERGE_ITEM_SCHEMES_CSV_PREVIEW_SHOW';var MERGE_ITEM_SCHEMES_CSV_FILE_UPLOAD='MERGE_ITEM_SCHEMES_CSV_FILE_UPLOAD';var MERGE_ITEM_SCHEMES_CSV_PAGE_READ='MERGE_ITEM_SCHEMES_CSV_PAGE_READ';var MERGE_ITEM_SCHEMES_PREVIEW_HIDE='MERGE_ITEM_SCHEMES_PREVIEW_HIDE';var changeMergeItemSchemesArtefactType=function changeMergeItemSchemesArtefactType(artefactType){return{type:MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE,artefactType:artefactType};};var changeMergeItemSchemesFormat=function changeMergeItemSchemesFormat(isSource,format,lang){return{type:MERGE_ITEM_SCHEMES_FORMAT_CHANGE,isSource:isSource,format:format,lang:lang};};var changeMergeItemSchemesCsvProps=function changeMergeItemSchemesCsvProps(isSource,fields){return{type:MERGE_ITEM_SCHEMES_CSV_PROPS_CHANGE,isSource:isSource,fields:fields};};var setMergeItemSchemesFile=function setMergeItemSchemesFile(isSource,file){return{type:MERGE_ITEM_SCHEMES_FILE_SET,isSource:isSource,file:file};};var showMergeItemSchemesArtefacts=function showMergeItemSchemesArtefacts(isSource){return{type:MERGE_ITEM_SCHEMES_ARTEFACTS_SHOW,isSource:isSource};};var hideMergeItemSchemesArtefacts=function hideMergeItemSchemesArtefacts(){return{type:MERGE_ITEM_SCHEMES_ARTEFACTS_HIDE};};var readMergeItemSchemesArtefacts=function readMergeItemSchemesArtefacts(artefactType){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(MERGE_ITEM_SCHEMES_ARTEFACTS_READ,artefactType===MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["A" /* getCodelistUrl */])():artefactType===MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["p" /* getCategorySchemeUrl */])():Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])());};var setMergeItemSchemesArtefact=function setMergeItemSchemesArtefact(artefactTriplet){return{type:MERGE_ITEM_SCHEMES_ARTEFACT_SET,artefactTriplet:artefactTriplet};};var unsetMergeItemSchemesArtefact=function unsetMergeItemSchemesArtefact(isSource){return{type:MERGE_ITEM_SCHEMES_ARTEFACT_UNSET,isSource:isSource};};var readMergeItemSchemesMergePreview=function readMergeItemSchemesMergePreview(artefactType,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps,lang){var fileFormData=new FormData();if(sourceFormat!==MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB){fileFormData.append('files',source);}if(targetFormat!==MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB){fileFormData.append('files',target);}if(sourceFormat===MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV){fileFormData.append('customDataFirst',JSON.stringify(sourceCsvProps));}if(targetFormat===MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV){fileFormData.append('customDataSecond',JSON.stringify(targetCsvProps));}if(artefactType===MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST){var searchInput={id:"IdUseOnlyForMerge-aea11369-686d-4997-bff1-98853f3c4882",agencyID:"MERGE",version:"1.0",lang:lang,pageNum:1,pageSize:0,rebuildDb:true};fileFormData.append('searchInput',JSON.stringify(searchInput));return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_MERGE_PREVIEW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_57" /* getMergeCodelistsUrl */])(sourceFormat===MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB?source:null,targetFormat===MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB?target:null),fileFormData);}else{return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_MERGE_PREVIEW_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_56" /* getMergeArtefactsUrl */])(artefactType,sourceFormat===MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB?source:null,targetFormat===MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB?target:null),fileFormData);}};var hideMergeItemSchemesMergePreview=function hideMergeItemSchemesMergePreview(){return{type:MERGE_ITEM_SCHEMES_MERGE_PREVIEW_HIDE};};var changeMergeItemSchemesCodelistMergePreviewLang=function changeMergeItemSchemesCodelistMergePreviewLang(lang){return{type:MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_LANG_CHANGE,lang:lang};};var updateMergeItemSchemesCodelistMergePreviewParams=function updateMergeItemSchemesCodelistMergePreviewParams(params){return{type:MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_PARAMS_UPDATE,params:params};};var readMergeItemSchemesCodelistPage=function readMergeItemSchemesCodelistPage(triplet,lang,pageNum,pageSize,searchText,filters,sortCol,sortByDesc,rebuildDb){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_CODELIST_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_58" /* getMergedCodelistPageUrl */])(),{id:triplet&&triplet.id?triplet.id:undefined,agencyID:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:pageNum?pageNum:undefined,pageSize:pageSize?pageSize:undefined,allSearch:searchText?searchText:undefined,codeSearch:filters&&filters.id?filters.id:undefined,nameSearch:filters&&filters.name?filters.name:undefined,parentSearch:filters&&filters.parent?filters.parent:undefined,sortColumn:sortCol?sortCol:undefined,sortDesc:sortByDesc?sortByDesc:undefined,rebuildDb:rebuildDb}));};var showMergeItemSchemesMerge=function showMergeItemSchemesMerge(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(MERGE_ITEM_SCHEMES_MERGE_SHOW,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};var hideMergeItemSchemesMerge=function hideMergeItemSchemesMerge(){return{type:MERGE_ITEM_SCHEMES_MERGE_HIDE};};var changeMergeItemSchemesMerge=function changeMergeItemSchemesMerge(fields){return{type:MERGE_ITEM_SCHEMES_MERGE_CHANGE,fields:fields};};var submitMergeItemSchemesMerge=function submitMergeItemSchemesMerge(artefactType,mergedItemScheme,mergedItemsFromServer,lang){if(artefactType===MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_MERGE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_82" /* getSaveMergedCodelistUrl */])(lang),{ID:mergedItemScheme.id,Agency:mergedItemScheme.agencyID,Version:mergedItemScheme.version,Names:mergedItemScheme.name},function(t){return{success:t('scenes.utilities.mergeItemSchemes.messages.create.success')};});}else if(artefactType===MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_MERGE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object.assign({},mergedItemScheme,{isFinal:false,categories:mergedItemsFromServer})],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */]),function(t){return{success:t('scenes.utilities.mergeItemSchemes.messages.create.success')};});}else if(artefactType===MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_MERGE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object.assign({},mergedItemScheme,{isFinal:false,concepts:mergedItemsFromServer})],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["z" /* SDMX_JSON_CONCEPT_SCHEME_LIST_KEY */]),function(t){return{success:t('scenes.utilities.mergeItemSchemes.messages.create.success')};});}};var showMergeItemSchemesXmlPreview=function showMergeItemSchemesXmlPreview(isSource){return{type:MERGE_ITEM_SCHEMES_XML_PREVIEW_SHOW,isSource:isSource};};var readMergeItemSchemesXmlPreview=function readMergeItemSchemesXmlPreview(artefactType,file,lang){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_XML_PREVIEW_READ,artefactType===MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST?Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_112" /* getXmlCodelistPreviewUrl */])(lang):Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_111" /* getXmlArtefactPreviewUrl */])(artefactType),fileFormData);};var updateMergeItemSchemesXmlPreviewParams=function updateMergeItemSchemesXmlPreviewParams(params){return{type:MERGE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE,params:params};};var changeMergeItemSchemesXmlPreviewLang=function changeMergeItemSchemesXmlPreviewLang(lang){return{type:MERGE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE,lang:lang};};var readMergeItemSchemesXmlPreviewPage=function readMergeItemSchemesXmlPreviewPage(triplet,lang,pageNum,pageSize,searchText,filters,sortCol,sortByDesc,rebuildDb){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:triplet&&triplet.id?triplet.id:undefined,agencyID:triplet&&triplet.agencyID?triplet.agencyID:undefined,version:triplet&&triplet.version?triplet.version:undefined,lang:lang?lang:undefined,pageNum:pageNum?pageNum:undefined,pageSize:pageSize?pageSize:undefined,allSearch:searchText?searchText:undefined,codeSearch:filters&&filters.id?filters.id:undefined,nameSearch:filters&&filters.name?filters.name:undefined,parentSearch:filters&&filters.parent?filters.parent:undefined,sortColumn:sortCol?sortCol:undefined,sortDesc:sortByDesc?sortByDesc:undefined,rebuildDb:rebuildDb}));};var showMergeItemSchemesCsvPreview=function showMergeItemSchemesCsvPreview(isSource){return{type:MERGE_ITEM_SCHEMES_CSV_PREVIEW_SHOW,isSource:isSource};};var uploadMergeItemSchemesCsvFile=function uploadMergeItemSchemesCsvFile(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_CSV_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),fileFormData);};var readMergeItemSchemesCsvPage=function readMergeItemSchemesCsvPage(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MERGE_ITEM_SCHEMES_CSV_PAGE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,hasHeader,filePath,null,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};var hideMergeItemSchemesPreview=function hideMergeItemSchemesPreview(){return{type:MERGE_ITEM_SCHEMES_PREVIEW_HIDE};};

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMPORT_ATTRIBUTE_ROW_LIST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IMPORT_ATTRIBUTE_ROW_LIST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showAttributeFileRowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hideAttributeFileRowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAttributeFileRowListCsvRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var IMPORT_ATTRIBUTE_ROW_LIST_SHOW='IMPORT_ATTRIBUTE_ROW_LIST_SHOW';var IMPORT_ATTRIBUTE_ROW_LIST_HIDE='IMPORT_ATTRIBUTE_ROW_LIST_HIDE';var IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET='IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET';var showAttributeFileRowList=function showAttributeFileRowList(){return{type:IMPORT_ATTRIBUTE_ROW_LIST_SHOW};};var hideAttributeFileRowList=function hideAttributeFileRowList(){return{type:IMPORT_ATTRIBUTE_ROW_LIST_HIDE};};var getAttributeFileRowListCsvRows=function getAttributeFileRowListCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,tid,filePath){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["V" /* getCsvTablePreviewUrl */])(separator,delimiter,true,filePath,tid,null),{PageNum:pageNum,PageSize:pageSize,FilterTable:filterTable,SortCols:sortCols,SortByDesc:sortByDesc});};

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EL_CODELIST_DETAIL_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scenes_meta_manager_dataflows_reducer__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__structure_step_utils__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mapping_step_utils__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mapping_step_constants__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__redux_components_redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_reduxReuse__ = __webpack_require__(30);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialStateStepData={categoryTree:null,forbiddenCategoriesCodes:null,agencies:null,dstDataflow:null,dstDataflows:null,category:null};var initialStateStepConnection={sourceFormat:__WEBPACK_IMPORTED_MODULE_11__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */],connectionEndpointId:null,isConnectionEndpointAvailable:false,srcDataflows:null,srcDataflow:null,srcFileRowsVisible:false,srcFileRows:null,srcTables:null,srcTable:null,srcFile:{separator:";"}};var initialStateStepFilter={dsdColumns:null,filterMode:__WEBPACK_IMPORTED_MODULE_10__query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */],filter:[],treeFilter:{},filterStr:""};var initialStateStepStructure={structureColumns:null};var initialStateStepDimensions={structureCodelists:null};var initialStateStepSemantic={structureConceptSchemes:null,structureConcepts:null};var initialStateMapping={mappings:null,csvHeader:null,currentMapping:__WEBPACK_IMPORTED_MODULE_11__constants__["M" /* newMapping */],currentMappingIsValid:false,cube:null,components:[],selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:null,shouldVerifyMapping:false};var initialStateStepLoad={isMetadataImportReportVisible:false,metadataImportReport:null,isDataImportPending:false,dataImportReport:null,dataImportStatus:null,publishDf:false,transcodeDf:true,loadTableExists:false,createdCodelists:null,conceptSchemaDefinition:null,artefactsCreated:false,dsdTriplet:null,toDeleteCodelists:null,toDeleteConceptSchema:null,hasToDeleteArtefacts:false};var deleteArtefactsInitialState={artefactsCreated:false,createdCodelists:null,conceptSchemaDefinition:null,toDeleteCodelists:null,toDeleteConceptSchema:null,hasToDeleteArtefacts:false};var isImportStatusWithError=function isImportStatusWithError(steps){return!steps||steps.length===1&&steps[0]==="NOT_STARTED_OR_ALREADY_COMPLETED";};var easyLoadingReducer=function easyLoadingReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object.assign({step:__WEBPACK_IMPORTED_MODULE_11__constants__["B" /* EL_STEP_DATA */],astTerritorialCodelist:null,astTerritoryConceptScheme:null,astTerritoryConcept:null},initialStateStepData,initialStateStepConnection,initialStateStepFilter,initialStateStepStructure,initialStateStepDimensions,initialStateStepSemantic,initialStateMapping,initialStateStepLoad);var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["_12" /* EL_STEP_SET */]:return Object.assign({},state,{step:action.step});case __WEBPACK_IMPORTED_MODULE_0__actions__["A" /* EL_DST_DATAFLOW_FORM_CHANGE */]:return Object.assign({},state,{dstDataflow:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge(state.dstDataflow,action.fields)});case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* EL_CATEGORY_SET */]:return Object.assign({},state,{category:action.category});case __WEBPACK_IMPORTED_MODULE_0__actions__["B" /* EL_DST_DATAFLOW_SET */]:return Object.assign({},state,initialStateStepData,initialStateStepConnection,initialStateStepFilter,initialStateStepStructure,initialStateStepDimensions,initialStateStepSemantic,initialStateMapping,initialStateStepLoad,{dstDataflows:null,dstDataflow:action.dataflow});case __WEBPACK_IMPORTED_MODULE_0__actions__["C" /* EL_DST_DATAFLOW_UNSET */]:return Object.assign({},state,{dstDataflow:null},initialStateStepData,initialStateStepConnection,initialStateStepFilter,initialStateStepStructure,initialStateStepDimensions,initialStateStepSemantic,initialStateMapping,initialStateStepLoad);case __WEBPACK_IMPORTED_MODULE_0__actions__["W" /* EL_SOURCE_FORMAT_SET */]:return Object.assign({},state,initialStateStepConnection,{sourceFormat:action.format},initialStateStepFilter,initialStateStepStructure,initialStateStepDimensions,initialStateStepSemantic,initialStateMapping,initialStateStepLoad);case __WEBPACK_IMPORTED_MODULE_0__actions__["_6" /* EL_SRC_FILE_FORM_CHANGE */]:{var stateSrcFile=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(state.srcFile);return Object.assign({},state,{srcFile:Object.assign({},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mergeWith(stateSrcFile,action.fields),{csvPath:null})});}case __WEBPACK_IMPORTED_MODULE_0__actions__["_9" /* EL_SRC_FILE_PREVIEW_SHOW */]:return Object.assign({},state,{srcFileRowsVisible:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["_7" /* EL_SRC_FILE_PREVIEW_HIDE */]:return Object.assign({},state,{srcFileRowsVisible:false,srcFileRows:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["l" /* EL_CONNECTION_ENDPOINT_SET */]:return Object.assign({},state,{connectionEndpointId:action.endpointId,isConnectionEndpointAvailable:false,srcDataflow:null},initialStateStepFilter,initialStateStepLoad);case __WEBPACK_IMPORTED_MODULE_0__actions__["Z" /* EL_SRC_DATAFLOW_SET */]:return Object.assign({},state,{srcDataflows:null,srcDataflow:action.dataflow});case __WEBPACK_IMPORTED_MODULE_0__actions__["_0" /* EL_SRC_DATAFLOW_UNSET */]:return Object.assign({},state,{srcDataflow:null},initialStateStepFilter,initialStateStepLoad);case __WEBPACK_IMPORTED_MODULE_0__actions__["F" /* EL_FILTER_MODE_CHANGE */]:return Object.assign({},state,{filterMode:action.mode,filter:[],treeFilter:{},filterStr:""});case __WEBPACK_IMPORTED_MODULE_0__actions__["E" /* EL_FILTER_MODE_ADVANCED_VALUES_CHANGE */]:{var treeFilter=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.treeFilter);var columnName=Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["a" /* getNormalizedColumnName */])(action.colName);treeFilter[columnName]={mode:treeFilter[columnName]&&treeFilter[columnName].mode?treeFilter[columnName].mode:__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["n" /* FILTER_MODE_IN */],values:action.values};var colNames=state.dsdColumns.map(function(_ref){var name=_ref.name;return name;});var colIndex=colNames.indexOf(action.colName);var subsequentColNames=colNames.splice(colIndex+1);// delete filters for subsequent cols
subsequentColNames.forEach(function(name){delete treeFilter[Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["a" /* getNormalizedColumnName */])(name)];});var newDsdColumns=state.dsdColumns.map(function(col){return subsequentColNames.includes(col.id)?Object.assign({},col,{valuesCount:null,filteredValues:null,codelistCount:null,filteredCodelistTree:null,filteredCodelistTreeMaxDepth:null}):col;});return Object.assign({},state,{dsdColumns:newDsdColumns,treeFilter:treeFilter,filterStr:Object(__WEBPACK_IMPORTED_MODULE_9__tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(treeFilter,(state.dsdColumns||[]).map(function(_ref2){var name=_ref2.name;return name;}))},initialStateStepLoad);}case __WEBPACK_IMPORTED_MODULE_0__actions__["D" /* EL_FILTER_MODE_ADVANCED_MODE_CHANGE */]:{var _treeFilter=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.treeFilter);var _columnName=Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["a" /* getNormalizedColumnName */])(action.colName);_treeFilter[_columnName]={mode:action.mode,values:_treeFilter[action.colName]&&_treeFilter[action.colName].values?_treeFilter[action.colName].values:[]};var _colNames=state.dsdColumns.map(function(_ref3){var name=_ref3.name;return name;});var _colIndex=_colNames.indexOf(action.colName);var _subsequentColNames=_colNames.splice(_colIndex+1);// delete filters for subsequent cols
_subsequentColNames.forEach(function(name){delete _treeFilter[Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["a" /* getNormalizedColumnName */])(name)];});var _newDsdColumns=state.dsdColumns.map(function(col){return _subsequentColNames.includes(col.id)?Object.assign({},col,{valuesCount:null,filteredValues:null,codelistCount:null,filteredCodelistTree:null,filteredCodelistTreeMaxDepth:null}):col;});return Object.assign({},state,{dsdColumns:_newDsdColumns,treeFilter:_treeFilter,filterStr:Object(__WEBPACK_IMPORTED_MODULE_9__tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(_treeFilter,(state.dsdColumns||[]).map(function(_ref4){var name=_ref4.name;return name;}))});}case __WEBPACK_IMPORTED_MODULE_0__actions__["G" /* EL_FILTER_MODE_SIMPLE_BLOCK_ADD */]:{var newBlock={column:null,logicalOperator:'OR',conditions:null};var newFilter=state.filter!==null?[].concat(_toConsumableArray(state.filter),[newBlock]):[newBlock];return Object.assign({},state,{filter:newFilter,filterStr:Object(__WEBPACK_IMPORTED_MODULE_13__utils_filter__["c" /* getFilterStrFromObj */])(newFilter,state.dsdColumns||[])});}case __WEBPACK_IMPORTED_MODULE_0__actions__["H" /* EL_FILTER_MODE_SIMPLE_BLOCK_DELETE */]:{var _newFilter=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.filter);_newFilter.splice(action.blockIndex,1);return Object.assign({},state,{filter:_newFilter,filterStr:Object(__WEBPACK_IMPORTED_MODULE_13__utils_filter__["c" /* getFilterStrFromObj */])(_newFilter,state.dsdColumns||[])});}case __WEBPACK_IMPORTED_MODULE_0__actions__["I" /* EL_FILTER_MODE_SIMPLE_CONDITION_ADD */]:{var _newFilter2=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.filter);var newCondition={comparisonOperator:null,value:null};if(_newFilter2[action.blockIndex].conditions!==null){_newFilter2[action.blockIndex].conditions.push(newCondition);}else{_newFilter2[action.blockIndex].conditions=[newCondition];}return Object.assign({},state,{filter:_newFilter2,filterStr:Object(__WEBPACK_IMPORTED_MODULE_13__utils_filter__["c" /* getFilterStrFromObj */])(_newFilter2,state.dsdColumns||[])});}case __WEBPACK_IMPORTED_MODULE_0__actions__["J" /* EL_FILTER_MODE_SIMPLE_CONDITION_DELETE */]:{var _newFilter3=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.filter);_newFilter3[action.blockIndex].conditions.splice(action.conditionIndex,1);return Object.assign({},state,{filter:_newFilter3,filterStr:Object(__WEBPACK_IMPORTED_MODULE_13__utils_filter__["c" /* getFilterStrFromObj */])(_newFilter3,state.dsdColumns||[])});}case __WEBPACK_IMPORTED_MODULE_0__actions__["K" /* EL_FILTER_MODE_SIMPLE_VALUES_CHANGE */]:{var _newFilter4=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.filter);if(action.fields.filter.filter(function(block){return block.column!==undefined;}).length>0){action.fields.filter=action.fields.filter.map(function(block){return Object.assign({},block,{conditions:null});});}_newFilter4=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge(_newFilter4,action.fields.filter);return Object.assign({},state,{filter:_newFilter4,filterStr:Object(__WEBPACK_IMPORTED_MODULE_13__utils_filter__["c" /* getFilterStrFromObj */])(_newFilter4,state.dsdColumns||[])});}case __WEBPACK_IMPORTED_MODULE_0__actions__["M" /* EL_FILTER_MODE_SIMPLE_VALUES_RESET */]:{var _newDsdColumns2=state.dsdColumns.map(function(col){return col.id===action.dimensionId?Object.assign({},col,{valuesCount:null,values:null}):col;});return Object.assign({},state,{dsdColumns:_newDsdColumns2});}case __WEBPACK_IMPORTED_MODULE_0__actions__["N" /* EL_FILTER_RESET */]:return Object.assign({},state,{filter:[],treeFilter:{},filterStr:""});case __WEBPACK_IMPORTED_MODULE_0__actions__["_13" /* EL_STRUCTURE_COLUMN_TYPE_SET */]:{var columns=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.structureColumns)||[];var column=columns.find(function(c){return c.id===action.columnId;});if(!column){return Object.assign({},state,{structureColumns:columns});}column.type=action.columnType;column.translationDefinition.transColId=action.transColId;column.translationDefinition.langCode=action.langCode;column.dimensionDefinition.role=null;column.dimensionDefinition.association=null;if(!Object(__WEBPACK_IMPORTED_MODULE_14__structure_step_utils__["d" /* columnCanBeTranslated */])(column)){Object(__WEBPACK_IMPORTED_MODULE_14__structure_step_utils__["c" /* clearTranslationsOfCurrentColumn */])(columns,column);}Object(__WEBPACK_IMPORTED_MODULE_14__structure_step_utils__["b" /* clearTranslatedColumn */])(columns,column);if(column.type===__WEBPACK_IMPORTED_MODULE_11__constants__["h" /* EL_COL_TYPE_TRANSLATION */]&&column.translationDefinition.transColId&&column.translationDefinition.langCode){Object(__WEBPACK_IMPORTED_MODULE_14__structure_step_utils__["a" /* assignTranslation */])(columns,column);}if(column.type!==__WEBPACK_IMPORTED_MODULE_11__constants__["h" /* EL_COL_TYPE_TRANSLATION */]){column.translations=null;column.translationDefinition.transColId=null;column.translationDefinition.langCode=null;}return Object.assign({},state,{structureColumns:columns});}case __WEBPACK_IMPORTED_MODULE_0__actions__["y" /* EL_DIMENSIONS_COLUMNS_SET */]:{var _columns=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.structureColumns)||[];var _column=_columns.find(function(c){return c.id===action.columnId;});if(_column){_column.dimensionDefinition.role=action.role;_column.dimensionDefinition.association=action.association;if(_column.dimensionDefinition.role===__WEBPACK_IMPORTED_MODULE_11__constants__["m" /* EL_DIMENSION_ROLE_TIME */]){_column.dimensionDefinition.association=null;}}return Object.assign({},state,initialStateStepSemantic,initialStateMapping,initialStateStepLoad,{structureColumns:_columns});}case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* EL_ATTRIBUTES_COLUMNS_SET */]:{var _columns2=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.structureColumns)||[];var _column2=_columns2.find(function(c){return c.id===action.columnId;});if(_column2){_column2.attributeDefinition.refers=action.refers;_column2.attributeDefinition.dimensions=action.dimensions;_column2.attributeDefinition.association=action.association;}return Object.assign({},state,initialStateStepSemantic,initialStateMapping,initialStateStepLoad,{structureColumns:_columns2});}case __WEBPACK_IMPORTED_MODULE_0__actions__["V" /* EL_SEMANTIC_COLUMNS_SET */]:{var _columns3=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.structureColumns)||[];var _column3=_columns3.find(function(c){return c.id===action.columnId;});if(_column3){_column3.semanticDefinition.conceptType=action.conceptType;if(action.conceptType===__WEBPACK_IMPORTED_MODULE_11__constants__["u" /* EL_SEMANTIC_CONCEPT_NEW */]){if(action.conceptLang){_column3.semanticDefinition.currentLang=action.conceptLang;_column3.semanticDefinition.newConcept[action.conceptLang]=action.conceptName||"";}}else{_column3.semanticDefinition.newConcept={};}_column3.semanticDefinition.conceptSchema=action.conceptSchema;_column3.semanticDefinition.concept=action.concept;}return Object.assign({},state,initialStateMapping,initialStateStepLoad,{structureColumns:_columns3});}case __WEBPACK_IMPORTED_MODULE_0__actions__["O" /* EL_LOAD_TABLE_SET_EXISTS */]:return Object.assign({},state,{loadTableExists:action.value});case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* EL_CONCEPTS_CLEAR */]:{return Object.assign({},state,{structureConcepts:null});}case __WEBPACK_IMPORTED_MODULE_0__actions__["m" /* EL_CREATE_ARTEFACTS */]:{return Object.assign({},state,{createdCodelists:null,conceptSchemaDefinition:null,artefactsCreated:true,metadataImportReport:[]});}case __WEBPACK_IMPORTED_MODULE_0__actions__["x" /* EL_DELETE_CREATED_ARTEFACTS */]:{return Object.assign({},state,deleteArtefactsInitialState);}case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["j" /* EL_MAPPING_RESET_MAPPING */]:return Object.assign({},state,initialStateStepLoad,{currentMapping:__WEBPACK_IMPORTED_MODULE_11__constants__["M" /* newMapping */],currentMappingIsValid:false,selectedColumnName:null,selectedComponent:null,selectedCubeComponentCode:null,components:[]});case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["h" /* EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT */]:return Object.assign({},state,initialStateStepLoad,{selectedColumnName:action.columnName,selectedComponent:null});case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["e" /* EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT */]:return Object.assign({},state,initialStateStepLoad,{selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:{columnName:action.columnName,cubeComponentCode:action.cubeComponentCode}});case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["a" /* EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD */]:{var components=[{columnName:action.columnName,cubeComponentCode:action.cubeComponentCode,cubeComponentType:[].concat(_toConsumableArray(state.cube.components.dimensions),_toConsumableArray(state.cube.components.timeDimensions),_toConsumableArray(state.cube.components.attributes),_toConsumableArray(state.cube.components.measures)).filter(function(comp){return comp.Code===action.cubeComponentCode;})[0].cubeComponentType}].concat(_toConsumableArray(state.components));var isValidMapping=Object(__WEBPACK_IMPORTED_MODULE_17__mapping_step_utils__["c" /* mappingIsValid */])(components,state.cube.components);return Object.assign({},state,initialStateStepLoad,{selectedComponent:{columnName:action.columnName,cubeComponentCode:action.cubeComponentCode},selectedColumnName:null,selectedCubeComponentCode:null,components:components,currentMappingIsValid:isValidMapping});}case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["b" /* EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL */]:{var _components=[].concat(_toConsumableArray(state.csvHeader.filter(function(columnNameToBeMapped){return state.components.map(function(mappedComponents){return mappedComponents.columnName;}).indexOf(columnNameToBeMapped)<0;}).map(function(columnNameToBeMapped){var relatedCubeComponentCodeArr=[].concat(_toConsumableArray(state.cube.components.dimensions),_toConsumableArray(state.cube.components.timeDimensions),_toConsumableArray(state.cube.components.attributes),_toConsumableArray(state.cube.components.measures)).filter(function(cubeComp){return cubeComp.Code===columnNameToBeMapped&&state.components.map(function(mappedComp){return mappedComp.cubeComponentCode;}).indexOf(cubeComp.Code)<0;});return relatedCubeComponentCodeArr.length>0?{columnName:columnNameToBeMapped,cubeComponentCode:relatedCubeComponentCodeArr[0].Code,cubeComponentType:relatedCubeComponentCodeArr[0].cubeComponentType}:null;}).filter(function(comp){return comp!==null;})),_toConsumableArray(state.components));var _isValidMapping=Object(__WEBPACK_IMPORTED_MODULE_17__mapping_step_utils__["c" /* mappingIsValid */])(_components,state.cube.components);return Object.assign({},state,initialStateStepLoad,{components:_components,selectedColumnName:null,selectedCubeComponentCode:null,selectedComponent:null,currentMappingIsValid:_isValidMapping});}case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["c" /* EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE */]:{var _components2=state.components.filter(function(_ref5){var columnName=_ref5.columnName,cubeComponentCode=_ref5.cubeComponentCode;return columnName!==action.columnName||cubeComponentCode!==action.cubeComponentCode;}).map(function(comp){return Object.assign({},comp);});var _isValidMapping2=Object(__WEBPACK_IMPORTED_MODULE_17__mapping_step_utils__["c" /* mappingIsValid */])(_components2,state.cube.components);return Object.assign({},state,initialStateStepLoad,{components:_components2,currentMappingIsValid:_isValidMapping2});}case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["d" /* EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL */]:return Object.assign({},state,initialStateStepLoad,{components:[],selectedComponent:null,currentMappingIsValid:false});case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["g" /* EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT */]:return Object.assign({},state,initialStateStepLoad,{selectedCubeComponentCode:action.cubeComponentCode,selectedComponent:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["Q" /* EL_METADATA_REPORT_HIDE */]:return Object.assign({},state,{isMetadataImportReportVisible:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["S" /* EL_PUBLISH_DATAFLOW_CHANGE */]:return Object.assign({},state,{publishDf:action.publishDf});case __WEBPACK_IMPORTED_MODULE_0__actions__["_15" /* EL_TRANSCODE_DATAFLOW_CHANGE */]:return Object.assign({},state,{transcodeDf:action.transcodeDf});case __WEBPACK_IMPORTED_MODULE_0__actions__["U" /* EL_RESET */]:{return Object.assign({},state,{step:__WEBPACK_IMPORTED_MODULE_11__constants__["B" /* EL_STEP_DATA */],astTerritorialCodelist:null,astTerritoryConceptScheme:null,astTerritoryConcept:null},initialStateStepData,initialStateStepConnection,initialStateStepFilter,initialStateStepStructure,initialStateStepDimensions,initialStateStepSemantic,initialStateMapping,initialStateStepLoad);}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* EL_CATEGORIES_READ */]:return Object.assign({},state,{categoryTree:null,forbiddenCategoriesCodes:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* EL_CONNECTION_ENDPOINT_PING */]:return Object.assign({},state,{isConnectionEndpointAvailable:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["_11" /* EL_SRC_TABLE_SET */]:{return Object.assign({},state,{srcTable:action.tableName});}case __WEBPACK_IMPORTED_MODULE_0__actions__["s" /* EL_DATA_CREATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["r" /* EL_DATA_CREATE_FROM_FILE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["q" /* EL_DATA_CREATE_FROM_DB_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["w" /* EL_DATA_UPDATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["v" /* EL_DATA_UPDATE_FROM_FILE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["u" /* EL_DATA_UPDATE_FROM_DB_SUBMIT */]:{return Object.assign({},state,{isDataImportPending:true,dataImportReport:null});}default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* EL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);})});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* EL_CATEGORIES_READ */]:var permissions=Object(__WEBPACK_IMPORTED_MODULE_3__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var isAdmin=permissions&&permissions.rules&&permissions.rules.includes("AdminRole");var categoriesTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_treeBuilders__["b" /* getCubesTree */])([],action.response);var forbiddenCategoriesCodes=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["l" /* getNodes */])(categoriesTree,"children",function(_ref6){var CatCode=_ref6.CatCode;return!permissions||CatCode!==undefined&&permissions.categories.indexOf(CatCode)<0;}).map(function(_ref7){var CatCode=_ref7.CatCode;return CatCode;}).filter(function(catCode){return catCode!==__WEBPACK_IMPORTED_MODULE_4__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode&&catCode!==__WEBPACK_IMPORTED_MODULE_5__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */];});var allowedCategoriesTree=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["g" /* getFilteredTreeWithPaths */])(categoriesTree,"children",function(obj){return obj.Code||isAdmin||!forbiddenCategoriesCodes.includes(obj.CatCode);});var orderedAllowedCategoriesTree=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["h" /* getMappedTree */])(allowedCategoriesTree,"children",function(node){var ordCount=1;return Object.assign({},node,{children:node.children?node.children.sort(function(a,b){if(a.Ord!==undefined&&b.Ord!==undefined){return a.Ord-b.Ord;}else if(a.Ord!==undefined){return a;}else if(b.Ord!==undefined){return b;}else{return(a.CatCode||-1)-(b.CatCode||-1);}}).map(function(c){return Object.assign({},c,{Ord:c.Ord!==undefined?String(ordCount++):undefined});}):node.children});});return Object.assign({},state,{categoryTree:orderedAllowedCategoriesTree,forbiddenCategoriesCodes:forbiddenCategoriesCodes});case __WEBPACK_IMPORTED_MODULE_0__actions__["z" /* EL_DST_DATAFLOWS_READ */]:{var ddbDataflowsMap={};(action.response[0]||[]).forEach(function(ddbDataflow){var ddbDataflowTriplet={id:ddbDataflow.ID,agencyID:ddbDataflow.Agency,version:ddbDataflow.Version};ddbDataflowsMap[Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(ddbDataflowTriplet)]=ddbDataflow;});var dstDataflows=[];(Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1])||[]).filter(function(_ref8){var structure=_ref8.structure;return structure&&Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(__WEBPACK_IMPORTED_MODULE_12__scenes_meta_manager_dataflows_reducer__["a" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD */],__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */])!==structure;}).forEach(function(artefact){var msdbDataflow=Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact);var ddbDataflow=ddbDataflowsMap[Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(msdbDataflow)];if(ddbDataflow!==undefined){dstDataflows.push(Object.assign({},msdbDataflow,{ddbDataflowId:ddbDataflow.IDDataflow,cubeId:ddbDataflow.IDCube}));}});return Object.assign({},state,{dstDataflows:dstDataflows});}case __WEBPACK_IMPORTED_MODULE_0__actions__["X" /* EL_SRC_DATAFLOWS_READ */]:{return Object.assign({},state,{srcDataflows:(Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).filter(function(_ref9){var structure=_ref9.structure;return structure&&Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(__WEBPACK_IMPORTED_MODULE_12__scenes_meta_manager_dataflows_reducer__["a" /* DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD */],__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */])!==structure;}).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact);})});}case __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* EL_CONNECTION_ENDPOINT_PING */]:return Object.assign({},state,{isConnectionEndpointAvailable:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions__["_1" /* EL_SRC_FILE_CSV_UPLOAD */]:{return Object.assign({},state,initialStateStepFilter,initialStateStepStructure,initialStateStepDimensions,initialStateStepSemantic,initialStateMapping,{srcFile:Object.assign({},state.srcFile,{filePath:action.response,csvPath:action.response})});}case __WEBPACK_IMPORTED_MODULE_0__actions__["_2" /* EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE */]:{return Object.assign({},state,{srcFile:Object.assign({},state.srcFile,{fileAbsolutePath:action.response})});}case __WEBPACK_IMPORTED_MODULE_0__actions__["_4" /* EL_SRC_FILE_EXCEL_UPLOAD */]:return Object.assign({},state,{srcFile:Object.assign({},state.srcFile,{filePath:action.response[0],mappingPath:action.response[1]})});case __WEBPACK_IMPORTED_MODULE_0__actions__["_5" /* EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE */]:{return Object.assign({},state,{srcFile:Object.assign({},state.srcFile,{fileAbsolutePath:action.response[0],mappingAbsolutePath:action.response[1]})});}case __WEBPACK_IMPORTED_MODULE_0__actions__["_3" /* EL_SRC_FILE_EXCEL_CONVERT */]:return Object.assign({},state,{srcFile:Object.assign({},state.srcFile,{csvPath:action.response})});case __WEBPACK_IMPORTED_MODULE_0__actions__["_8" /* EL_SRC_FILE_PREVIEW_READ */]:return Object.assign({},state,{srcFileRows:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions__["_10" /* EL_SRC_TABLES_READ */]:{return Object.assign({},state,{srcFile:Object.assign({},state.srcFile,{separator:";"}),srcTables:action.response});}case __WEBPACK_IMPORTED_MODULE_0__actions__["_11" /* EL_SRC_TABLE_SET */]:{return Object.assign({},state,{srcFile:Object.assign({},state.srcFile,{csvPath:action.response})});}case __WEBPACK_IMPORTED_MODULE_0__actions__["Y" /* EL_SRC_DATAFLOW_DSD_READ */]:var dsd=Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["R" /* getDsdFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);var _columns4=(dsd.dimensions||[]).map(function(dim){return{id:dim.id,name:dim.id,isNumeric:false,CodelistCode:"CodelistCode",valuesCount:null,values:null,filteredValues:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,filteredCodelistTreeMaxDepth:null,hasCodelist:false,fetchCodes:null};});return Object.assign({},state,{dsdColumns:_columns4});case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* EL_CODELIST_COUNT_READ */]:{var dsdColumns=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.dsdColumns);dsdColumns=dsdColumns.map(function(col){return col.id===action.dimensionId?Object.assign({},col,{codelistCount:Number(action.header["x-total-count"])}):col;});return Object.assign({},state,{dsdColumns:dsdColumns});}case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* EL_CODELIST_ITEMS_READ */]:{var codelist=Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var itemsTree=void 0;try{itemsTree=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["n" /* getTreeFromArray */])(codelist.codes||[],"codes",true);}catch(e){itemsTree=null;}var _dsdColumns=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.dsdColumns);_dsdColumns=_dsdColumns.map(function(col){return col.id===action.dimensionId?Object.assign({},col,{filteredValues:Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["l" /* getNodes */])(itemsTree,"codes",function(){return true;}).map(function(_ref10){var id=_ref10.id;return id;}),filteredCodelistTree:itemsTree,filteredCodelistTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["j" /* getMaxTreeDepth */])(itemsTree,"codes"),hasCodesError:!itemsTree}):col;});return Object.assign({},state,{dsdColumns:_dsdColumns});}case __WEBPACK_IMPORTED_MODULE_0__actions__["p" /* EL_CSV_HEADER_READ */]:{var _columns5=(action.response||[]).map(function(dim){return{id:dim,name:dim,isNumeric:false,CodelistCode:"",valuesCount:null,values:null,filteredValues:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,filteredCodelistTreeMaxDepth:null,hasCodelist:false,fetchCodes:null};});return Object.assign({},state,{dsdColumns:_columns5});}case __WEBPACK_IMPORTED_MODULE_0__actions__["_14" /* EL_STRUCTURE_CSV_HEADER_READ */]:{var _columns6=[];var nodeConfig=Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action);var territorialDimIds=nodeConfig.ast&&(nodeConfig.ast.territorialDimIds||[]).length>0?nodeConfig.ast.territorialDimIds:[];var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_3__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var canUpdateStructuralMetadata=userPermissions&&userPermissions.rules&&userPermissions.rules.includes("CanUpdateStructuralMetadata");var conceptType=canUpdateStructuralMetadata?null:__WEBPACK_IMPORTED_MODULE_11__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */];(action.response||[]).forEach(function(dim){var dimUpper=dim.toUpperCase();var column={id:dim,type:null,translations:null,translationDefinition:{langCode:null,transColId:null},dimensionDefinition:{role:null,association:null},attributeDefinition:{refers:null,association:null,dimensions:null},semanticDefinition:{conceptType:conceptType,newConcept:{},currentLang:action.appLang,conceptSchema:null,concept:null}};if(dimUpper==="FREQ"){column.type=__WEBPACK_IMPORTED_MODULE_11__constants__["e" /* EL_COL_TYPE_DIMENSION */];column.dimensionDefinition.role=__WEBPACK_IMPORTED_MODULE_11__constants__["i" /* EL_DIMENSION_ROLE_FREQUENCY */];}else if(dimUpper==="TIME_PERIOD"){column.type=__WEBPACK_IMPORTED_MODULE_11__constants__["e" /* EL_COL_TYPE_DIMENSION */];column.dimensionDefinition.role=__WEBPACK_IMPORTED_MODULE_11__constants__["m" /* EL_DIMENSION_ROLE_TIME */];}else if(dimUpper==="OBS_VALUE"){column.type=__WEBPACK_IMPORTED_MODULE_11__constants__["g" /* EL_COL_TYPE_MEASURE */];}else if(territorialDimIds.includes(dim.toUpperCase())){column.type=__WEBPACK_IMPORTED_MODULE_11__constants__["e" /* EL_COL_TYPE_DIMENSION */];column.dimensionDefinition.role=__WEBPACK_IMPORTED_MODULE_11__constants__["l" /* EL_DIMENSION_ROLE_TERRITORY */];var dimAssociation=null;if(nodeConfig.ast&&nodeConfig.ast.astTerritorialCodelist){var _codelist=Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(nodeConfig.ast.astTerritorialCodelist);if(Object(__WEBPACK_IMPORTED_MODULE_15__utils_artefactValidators__["f" /* isIDValidWithHelp */])(action.t,_codelist.id)&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(action.t,_codelist.version)&&(_codelist.agencyID||"").length>0){dimAssociation=_codelist;}}column.dimensionDefinition.association=dimAssociation;}_columns6.push(column);});return Object.assign({},state,{structureColumns:_columns6});}case __WEBPACK_IMPORTED_MODULE_0__actions__["o" /* EL_CSV_COUNT_AND_ITEMS_READ */]:{var items=(action.response.Data||[]).map(function(item){return{id:item[action.dimensionId],name:item[action.dimensionId]};});var _newDsdColumns3=state.dsdColumns.map(function(col){return col.id===action.dimensionId?Object.assign({},col,{valuesCount:action.response.Count,filteredValues:items.map(function(_ref11){var id=_ref11.id;return id;}),codelistCount:action.response.Count,filteredCodelistTree:items,filteredCodelistTreeMaxDepth:1}):col;});return Object.assign({},state,{dsdColumns:_newDsdColumns3});}case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* EL_CODELISTS_READ */]:return Object.assign({},state,{structureCodelists:(Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact);})});case __WEBPACK_IMPORTED_MODULE_0__actions__["j" /* EL_CONCEPT_SCHEMES_READ */]:return Object.assign({},state,{structureConceptSchemes:(Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact);})});case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* EL_CONCEPTS_READ */]:{return Object.assign({},state,{structureConcepts:Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["y" /* SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).concepts});}case __WEBPACK_IMPORTED_MODULE_0__actions__["L" /* EL_FILTER_MODE_SIMPLE_VALUES_READ */]:{var _newDsdColumns4=state.dsdColumns.map(function(col){return col.id===action.dimensionId?Object.assign({},col,{valuesCount:action.response.Count,values:action.response.Data}):col;});return Object.assign({},state,{dsdColumns:_newDsdColumns4});}case __WEBPACK_IMPORTED_MODULE_0__actions__["R" /* EL_METADATA_SUBMIT */]:{return Object.assign({},state,{isMetadataImportReportVisible:true,metadataImportReport:action.response.itemsMessage});}case __WEBPACK_IMPORTED_MODULE_0__actions__["P" /* EL_METADATA_CSV_PRELOAD */]:{return Object.assign({},state,{srcTable:action.response,loadTableExists:true});}case __WEBPACK_IMPORTED_MODULE_0__actions__["m" /* EL_CREATE_ARTEFACTS */]:{var metadataImportReport=[];var conceptSchemaDefinition=action.conceptSchemaDefinition;var hasConceptSchema=conceptSchemaDefinition!==null;var response=action.response;if(hasConceptSchema){var csResponse=response.shift();if(csResponse){var conceptSchema=conceptSchemaDefinition.conceptSchema;metadataImportReport.push({"status":"Success","maintainableObject":"ConceptScheme="+conceptSchema.agencyID+":"+conceptSchema.id+"("+conceptSchema.version+")","isFinal":true,"result":"Success","customMessage":null});}}var codelistColumns=action.codelistColumns||[];var hasCodelists=codelistColumns.length>0;var createdCodelists=null;if(hasCodelists){createdCodelists={};var dataflowId=state.dstDataflow.id;var actionCodelists=response[0]||[];var _loop=function _loop(i){var columnName=codelistColumns[i];var createdCodelistName=actionCodelists.find(function(c){return c.startsWith(dataflowId+"_"+columnName);});if(createdCodelistName){createdCodelists[columnName]=createdCodelistName;metadataImportReport.push({"status":"Success","maintainableObject":"CodeList=AST:"+createdCodelistName+"(1.0)","isFinal":true,"result":"Success","customMessage":null});}};for(var i=0;i<codelistColumns.length;i++){_loop(i);}}return Object.assign({},state,{createdCodelists:createdCodelists,conceptSchemaDefinition:conceptSchemaDefinition,artefactsCreated:true,metadataImportReport:metadataImportReport});}case __WEBPACK_IMPORTED_MODULE_0__actions__["x" /* EL_DELETE_CREATED_ARTEFACTS */]:{return Object.assign({},state,deleteArtefactsInitialState);}case __WEBPACK_IMPORTED_MODULE_0__actions__["n" /* EL_CREATE_DSD */]:{var dsdTriplet=action.dsdTriplet;var _metadataImportReport=state.metadataImportReport;_metadataImportReport.push({"status":"Success","maintainableObject":"Dsd="+dsdTriplet.agencyID+":"+dsdTriplet.id+"("+dsdTriplet.version+")","isFinal":true,"result":"Success","customMessage":null});return Object.assign({},state,{dsdTriplet:dsdTriplet,metadataImportReport:_metadataImportReport,isMetadataImportReportVisible:true,hasToDeleteArtefacts:false,toDeleteCodelists:null,toDeleteConceptSchema:null});}case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["f" /* EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ */]:{var _csvHeader=action.response[0];var mappings=(action.response[1]||[]).filter(function(m){return m.IDCube===action.cubeId;});var responseCube=action.response[2];var _cube=Object.assign({},responseCube,{components:{dimensions:responseCube.Dimensions.filter(function(dim){return!dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{cubeComponentType:__WEBPACK_IMPORTED_MODULE_18__mapping_step_constants__["b" /* CUBE_COMPONENT_TYPE_DIMENSION */]});}),timeDimensions:responseCube.Dimensions.filter(function(dim){return dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{cubeComponentType:__WEBPACK_IMPORTED_MODULE_18__mapping_step_constants__["d" /* CUBE_COMPONENT_TYPE_TIME_DIMENSION */]});}),tidAttributes:responseCube.Attributes.filter(function(attr){return attr.IsTid;}).map(function(attr){return Object.assign({},attr,{cubeComponentType:__WEBPACK_IMPORTED_MODULE_18__mapping_step_constants__["a" /* CUBE_COMPONENT_TYPE_ATTRIBUTE */]});}),attributes:responseCube.Attributes.filter(function(attr){return!attr.IsTid;}).map(function(attr){return Object.assign({},attr,{cubeComponentType:__WEBPACK_IMPORTED_MODULE_18__mapping_step_constants__["a" /* CUBE_COMPONENT_TYPE_ATTRIBUTE */]});}),measures:responseCube.Measures.map(function(measure){return Object.assign({},measure,{cubeComponentType:__WEBPACK_IMPORTED_MODULE_18__mapping_step_constants__["c" /* CUBE_COMPONENT_TYPE_MEASURE */]});})}});var _shouldVerifyMapping=mappings.length===1;return Object.assign({},state,{csvHeader:_csvHeader,mappings:mappings,cube:_cube,shouldVerifyMapping:_shouldVerifyMapping});}case __WEBPACK_IMPORTED_MODULE_16__mapping_step_actions__["i" /* EL_MAPPING_FILE_MAPPING_READ */]:var mapping=action.response;var csvHeader=state.csvHeader;var cube=state.cube;var mappingComponents=Object(__WEBPACK_IMPORTED_MODULE_17__mapping_step_utils__["a" /* createMappingComponents */])(mapping,csvHeader,cube.components);var _isValidMapping3=Object(__WEBPACK_IMPORTED_MODULE_17__mapping_step_utils__["c" /* mappingIsValid */])(mappingComponents,cube.components);var shouldVerifyMapping=state.shouldVerifyMapping;var currentMapping=mapping;var _components3=mappingComponents;if(shouldVerifyMapping&&!_isValidMapping3){currentMapping=__WEBPACK_IMPORTED_MODULE_11__constants__["M" /* newMapping */];_components3=[];}return Object.assign({},state,{currentMapping:currentMapping,components:_components3,shouldVerifyMapping:false,currentMappingIsValid:_isValidMapping3});case __WEBPACK_IMPORTED_MODULE_0__actions__["s" /* EL_DATA_CREATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["r" /* EL_DATA_CREATE_FROM_FILE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["q" /* EL_DATA_CREATE_FROM_DB_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["w" /* EL_DATA_UPDATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["v" /* EL_DATA_UPDATE_FROM_FILE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["u" /* EL_DATA_UPDATE_FROM_DB_SUBMIT */]:{return Object.assign({},state,{isDataImportPending:false,dataImportReport:action.response});}case __WEBPACK_IMPORTED_MODULE_0__actions__["t" /* EL_DATA_IMPORT_STATUS_GET */]:{return Object.assign({},state,{dataImportStatus:isImportStatusWithError(action.response)?state.dataImportStatus:action.response});}case __WEBPACK_IMPORTED_MODULE_0__actions__["T" /* EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT */]:{var codelistResponse=action.response[0];var _codelist2=-1;if(((codelistResponse.data||{}).codelists||[]).length===1){_codelist2=action.codelist;}var conceptResponse=action.response[1];var conceptScheme=-1;var concept=-1;if(((conceptResponse.data||{}).conceptSchemes||[]).length===1){conceptScheme=action.conceptScheme;var concepts=Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["y" /* SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(conceptResponse)[0]).concepts;var requiredConcept=(concepts||[]).find(function(c){return c.id===action.concept;});if(requiredConcept){concept=action.concept;}}return Object.assign({},state,{astTerritorialCodelist:_codelist2,astTerritoryConceptScheme:conceptScheme,astTerritoryConcept:concept});}default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["_11" /* EL_SRC_TABLE_SET */]:{return Object.assign({},state,{srcTable:null});}case __WEBPACK_IMPORTED_MODULE_0__actions__["s" /* EL_DATA_CREATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["r" /* EL_DATA_CREATE_FROM_FILE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["q" /* EL_DATA_CREATE_FROM_DB_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["w" /* EL_DATA_UPDATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["v" /* EL_DATA_UPDATE_FROM_FILE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["u" /* EL_DATA_UPDATE_FROM_DB_SUBMIT */]:{return Object.assign({},state,{isDataImportPending:false,dataImportStatus:null});}case __WEBPACK_IMPORTED_MODULE_0__actions__["t" /* EL_DATA_IMPORT_STATUS_GET */]:{return Object.assign({},state,{dataImportStatus:null});}case __WEBPACK_IMPORTED_MODULE_0__actions__["m" /* EL_CREATE_ARTEFACTS */]:return Object.assign({},state,{hasToDeleteArtefacts:true,artefactsCreated:false,metadataImportReport:null,dsdTriplet:-1});case __WEBPACK_IMPORTED_MODULE_0__actions__["x" /* EL_DELETE_CREATED_ARTEFACTS */]:{return Object.assign({},state,deleteArtefactsInitialState);}case __WEBPACK_IMPORTED_MODULE_0__actions__["n" /* EL_CREATE_DSD */]:var toDeleteCodelists=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.createdCodelists);var toDeleteConceptSchema=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.conceptSchemaDefinition);return Object.assign({},state,{createdCodelists:null,conceptSchemaDefinition:null,dsdTriplet:-1,toDeleteCodelists:toDeleteCodelists,toDeleteConceptSchema:toDeleteConceptSchema,hasToDeleteArtefacts:true});default:return state;}default:return state;}};var EL_CODELIST_DETAIL_PREFIX="EL_CODELIST_DETAIL_PREFIX_";/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_20__utils_reduxReuse__["b" /* reuseInReducer */])(easyLoadingReducer,{codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_20__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_19__redux_components_redux_codelist_detail_modal_reducer__["a" /* default */],EL_CODELIST_DETAIL_PREFIX)}));

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return columnCanBeTranslated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearTranslationsOfCurrentColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearTranslatedColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assignTranslation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return structureIsWellDefined; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(63);
var columnCanBeTranslated=function columnCanBeTranslated(column){return column.type===__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* EL_COL_TYPE_ATTRIBUTE */]||column.type===__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EL_COL_TYPE_DIMENSION */];};var clearTranslationsOfCurrentColumn=function clearTranslationsOfCurrentColumn(columns,column){column.translations=null;var translationsOfCurrentColumn=columns.filter(function(c){return c.id!==column.id&&c.type===__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* EL_COL_TYPE_TRANSLATION */]&&c.translationDefinition.transColId===column.id;})||[];translationsOfCurrentColumn.forEach(function(c){c.type=null;c.translationDefinition.transColId=null;c.translationDefinition.langCode=null;c.dimensionDefinition.role=null;c.dimensionDefinition.association=null;});};var clearTranslatedColumn=function clearTranslatedColumn(columns,column){var translatedColumn=null;columns.forEach(function(c){if(c.id!==column.id&&columnCanBeTranslated(c)){var cTranslations=c.translations||[];cTranslations.forEach(function(translation){if(translation.column===column.id){translatedColumn=c;}});}});if(translatedColumn){translatedColumn.translations=translatedColumn.translations.filter(function(translation){return translation.column!==column.id;});}};var assignTranslation=function assignTranslation(columns,column){var translatedColumn=columns.find(function(c){return c.id===column.translationDefinition.transColId;});if(translatedColumn){var translation={column:column.id,lang:column.translationDefinition.langCode};var columnsTranslations=translatedColumn.translations||[];columnsTranslations.push(translation);translatedColumn.translations=columnsTranslations;}};var structureIsWellDefined=function structureIsWellDefined(t,structureColumns){var numberOfMeasures=0;var numberOfDimensions=0;var allColumunHasType=true;var translationsAreWellDefined=true;var translationHasDuplicateLanguage=false;var _loop=function _loop(i){var column=structureColumns[i];if(column.type===null){allColumunHasType=false;};if(column.type===__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* EL_COL_TYPE_TRANSLATION */]){if(column.translationDefinition.transColId===null||column.translationDefinition.langCode===null){translationsAreWellDefined=false;}else{var sameLanguageColumn=structureColumns.find(function(c){return c.id!==column.id&&c.type===__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* EL_COL_TYPE_TRANSLATION */]&&c.translationDefinition.transColId===column.translationDefinition.transColId&&c.translationDefinition.langCode===column.translationDefinition.langCode;});if(sameLanguageColumn){translationHasDuplicateLanguage=true;}}}else if(column.type===__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EL_COL_TYPE_DIMENSION */]){numberOfDimensions++;}else if(column.type===__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* EL_COL_TYPE_MEASURE */]){numberOfMeasures++;}};for(var i=0;i<(structureColumns||[]).length;i++){_loop(i);}var messages=[];if(!allColumunHasType){messages.push(t('components.easyLoading.error.structure.columnTypes'));};if(!translationsAreWellDefined){messages.push(t('components.easyLoading.error.structure.notWellDefinedTranslations'));};if(translationHasDuplicateLanguage){messages.push(t('components.easyLoading.error.structure.duplicateLanguageTranslations'));};if(numberOfMeasures!==1){messages.push(t('components.easyLoading.error.structure.measures'));};if(numberOfDimensions<2){messages.push(t('components.easyLoading.error.structure.dimensions'));}return{result:allColumunHasType&&translationsAreWellDefined&&!translationHasDuplicateLanguage&&numberOfMeasures===1&&numberOfDimensions>=2,messages:messages};};

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMappingIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createMappingComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mappingIsValid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(237);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var getMappingIcon=function getMappingIcon(mappingId){var iconType=mappingId===-1?"plus":"retweet";return iconType;};var createMappingComponents=function createMappingComponents(currentMapping,csvHeader,cubeComponents){var components=[];(currentMapping.Components||[]).forEach(function(mapping){var component=void 0;if(csvHeader.some(function(column){return column===mapping.ColumnName;})){switch(mapping.CubeComponentType){case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CUBE_COMPONENT_TYPE_TIME_DIMENSION */]:component=cubeComponents.timeDimensions;break;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CUBE_COMPONENT_TYPE_ATTRIBUTE */]:component=cubeComponents.attributes.concat(cubeComponents.tidAttributes);break;case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CUBE_COMPONENT_TYPE_MEASURE */]:component=cubeComponents.measures;break;case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CUBE_COMPONENT_TYPE_DIMENSION */]:default:component=cubeComponents.dimensions;break;}if(component.some(function(c){return c.Code===mapping.CubeComponentCode;})){components.push({columnName:mapping.ColumnName,cubeComponentCode:mapping.CubeComponentCode,cubeComponentType:mapping.CubeComponentType,idMapping:mapping.IDMapping,mappingType:mapping.MappingType});}}});return components;};var mappingIsValid=function mappingIsValid(mappingComponents,cubeComponents){var _loop=function _loop(i){var code=cubeComponents.dimensions[i].Code;var componentisMapped=(mappingComponents||[]).some(function(c){return c.cubeComponentCode===code&&c.cubeComponentType===__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CUBE_COMPONENT_TYPE_DIMENSION */];});if(!componentisMapped){return{v:false};}};for(var i=0;i<(cubeComponents.dimensions||[]).length;i++){var _ret=_loop(i);if((typeof _ret==="undefined"?"undefined":_typeof(_ret))==="object")return _ret.v;}var _loop2=function _loop2(i){var code=cubeComponents.timeDimensions[i].Code;var componentisMapped=(mappingComponents||[]).some(function(c){return c.cubeComponentCode===code&&c.cubeComponentType===__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CUBE_COMPONENT_TYPE_TIME_DIMENSION */];});if(!componentisMapped){return{v:false};}};for(var i=0;i<(cubeComponents.timeDimensions||[]).length;i++){var _ret2=_loop2(i);if((typeof _ret2==="undefined"?"undefined":_typeof(_ret2))==="object")return _ret2.v;}var _loop3=function _loop3(i){var code=cubeComponents.measures[i].Code;var componentisMapped=(mappingComponents||[]).some(function(c){return c.cubeComponentCode===code&&c.cubeComponentType===__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CUBE_COMPONENT_TYPE_MEASURE */];});if(!componentisMapped){return{v:false};}};for(var i=0;i<(cubeComponents.measures||[]).length;i++){var _ret3=_loop3(i);if((typeof _ret3==="undefined"?"undefined":_typeof(_ret3))==="object")return _ret3.v;}var mandatoryAttributes=(cubeComponents.attributes||[]).filter(function(a){return a.IsMandatory===true;});var mandatoryTidAttributes=(cubeComponents.tidAttributes||[]).filter(function(a){return a.IsMandatory===true;});var attributes=mandatoryAttributes.concat(mandatoryTidAttributes);var _loop4=function _loop4(i){var code=attributes[i].Code;var componentisMapped=(mappingComponents||[]).some(function(c){return c.cubeComponentCode===code&&c.cubeComponentType===__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CUBE_COMPONENT_TYPE_ATTRIBUTE */];});if(!componentisMapped){return{v:false};}};for(var i=0;i<(attributes||[]).length;i++){var _ret4=_loop4(i);if((typeof _ret4==="undefined"?"undefined":_typeof(_ret4))==="object")return _ret4.v;}return true;};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(92);
var normalizeHeaderName = __webpack_require__(1166);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(521);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(521);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(290)))

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConnectedDraggable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConnectedDroppable; });
/* unused harmony export resetServerContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_use_memo_one__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_box_model__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_memoize_one__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raf_schd__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer__);
















var isProduction = "production" === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
var warning = function warning(message) {
  var _console;

  if (isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console).warn.apply(_console, getFormattedMessage(message));
};

function printFatalError(error) {
  var _console;

  if (true) {
    return;
  }

  (_console = console).error.apply(_console, getFormattedMessage("\n        An error has occurred while a drag is occurring.\n        Any existing drag will be cancelled.\n\n        > " + error.message + "\n        "));

  console.error('raw', error);
}

function shouldRecover(error) {
  return error.message.indexOf('Invariant failed') !== -1;
}

var ErrorBoundary = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.onError = void 0;

    _this.setOnError = function (fn) {
      _this.onError = fn;
    };

    _this.onFatalError = function (error) {
      printFatalError(error);

      if (_this.onError) {
        _this.onError();
      } else {
         false ? warning('Could not find recovering function') : void 0;
      }

      if (shouldRecover(error)) {
        _this.setState({});
      }
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('error', this.onFatalError);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('error', this.onFatalError);
  };

  _proto.componentDidCatch = function componentDidCatch(error) {
    this.onFatalError(error);

    if (!shouldRecover(error)) {
      throw error;
    }
  };

  _proto.render = function render() {
    return this.props.children(this.setOnError);
  };

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var isEqual$1 = function isEqual(first, second) {
  return first.top === second.top && first.right === second.right && first.bottom === second.bottom && first.left === second.left;
};
var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

var records = {};
var isEnabled = false;

var isTimingsEnabled = function isTimingsEnabled() {
  return isEnabled;
};
var start = function start(key) {
  if (false) {
    if (!isTimingsEnabled()) {
      return;
    }

    var now = performance.now();
    records[key] = now;
  }
};
var finish = function finish(key) {
  if (false) {
    if (!isTimingsEnabled()) {
      return;
    }

    var now = performance.now();
    var previous = records[key];

    if (!previous) {
      console.warn('cannot finish timing as no previous time found', key);
      return;
    }

    var result = now - previous;
    var rounded = result.toFixed(2);

    var style = function () {
      if (result < 12) {
        return {
          textColor: 'green',
          symbol: '✅'
        };
      }

      if (result < 40) {
        return {
          textColor: 'orange',
          symbol: '⚠️'
        };
      }

      return {
        textColor: 'red',
        symbol: '❌'
      };
    }();

    console.log(style.symbol + " %cTiming %c" + rounded + " %cms %c" + key, 'color: blue; font-weight: bold;', "color: " + style.textColor + "; font-size: 1.1em;", 'color: grey;', 'color: purple; font-weight: bold;');
  }
};

var whatIsDraggedOver = (function (impact) {
  var merge = impact.merge,
      destination = impact.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (merge) {
    return merge.combine.droppableId;
  }

  return null;
});

function values(map) {
  return __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_values___default()(map);
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}

var toDroppableMap = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (droppables) {
  return values(droppables);
});
var toDraggableList = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (draggables) {
  return values(draggables);
});

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPositionInFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (point) {
    return isWithinVertical(point.y) && isWithinVertical(point.y) && isWithinHorizontal(point.x) && isWithinHorizontal(point.x);
  };
});

var getDroppableOver = (function (_ref) {
  var target = _ref.target,
      droppables = _ref.droppables;
  var maybe = find(toDroppableList(droppables), function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    var active = droppable.subject.active;

    if (!active) {
      return false;
    }

    return isPositionInFrame(active)(target);
  });
  return maybe ? maybe.descriptor.id : null;
});

var getDraggablesInsideDroppable = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

var withDroppableScroll = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.value);
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isUserMovingForward = (function (axis, direction) {
  return axis === vertical ? direction.vertical === 'down' : direction.horizontal === 'right';
});

var didStartDisplaced = (function (draggableId, onLift) {
  return Boolean(onLift.wasDisplaced[draggableId]);
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      onLift = _ref.onLift,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced[combineWith]);

  if (didStartDisplaced(combineWith, onLift)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var getWhenEntered = function getWhenEntered(id, current, oldMerge) {
  if (!oldMerge) {
    return current;
  }

  if (id !== oldMerge.combine.draggableId) {
    return current;
  }

  return oldMerge.whenEntered;
};

var isCombiningWith = function isCombiningWith(_ref) {
  var id = _ref.id,
      currentCenter = _ref.currentCenter,
      axis = _ref.axis,
      borderBox = _ref.borderBox,
      displaceBy = _ref.displaceBy,
      currentUserDirection = _ref.currentUserDirection,
      oldMerge = _ref.oldMerge;
  var start = borderBox[axis.start] + displaceBy[axis.line];
  var end = borderBox[axis.end] + displaceBy[axis.line];
  var size = borderBox[axis.size];
  var twoThirdsOfSize = size * 0.666;
  var whenEntered = getWhenEntered(id, currentUserDirection, oldMerge);
  var isMovingForward = isUserMovingForward(axis, whenEntered);
  var targetCenter = currentCenter[axis.line];

  if (isMovingForward) {
    return isWithin(start, start + twoThirdsOfSize)(targetCenter);
  }

  return isWithin(end - twoThirdsOfSize, end)(targetCenter);
};

var getCombineImpact = (function (_ref2) {
  var currentCenter = _ref2.pageBorderBoxCenterWithDroppableScrollChange,
      previousImpact = _ref2.previousImpact,
      destination = _ref2.destination,
      insideDestinationWithoutDraggable = _ref2.insideDestinationWithoutDraggable,
      userDirection = _ref2.userDirection,
      onLift = _ref2.onLift;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var map = previousImpact.movement.map;
  var canBeDisplacedBy = previousImpact.movement.displacedBy;
  var oldMerge = previousImpact.merge;
  var target = find(insideDestinationWithoutDraggable, function (child) {
    var id = child.descriptor.id;
    var displaceBy = getCombinedItemDisplacement({
      displaced: map,
      onLift: onLift,
      combineWith: id,
      displacedBy: canBeDisplacedBy
    });
    return isCombiningWith({
      id: id,
      currentCenter: currentCenter,
      axis: axis,
      borderBox: child.page.borderBox,
      displaceBy: displaceBy,
      currentUserDirection: userDirection,
      oldMerge: oldMerge
    });
  });

  if (!target) {
    return null;
  }

  var merge = {
    whenEntered: getWhenEntered(target.descriptor.id, userDirection, oldMerge),
    combine: {
      draggableId: target.descriptor.id,
      droppableId: destination.descriptor.id
    }
  };

  var withMerge = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, previousImpact, {
    destination: null,
    merge: merge
  });

  return withMerge;
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(forceShouldAnimate, isVisible, previous) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!isVisible) {
    return false;
  }

  if (!previous) {
    return true;
  }

  return previous.shouldAnimate;
};

var getTarget = function getTarget(draggable, onLift) {
  var marginBox = draggable.page.marginBox;

  if (!didStartDisplaced(draggable.descriptor.id, onLift)) {
    return marginBox;
  }

  var expandBy = {
    top: onLift.displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: onLift.displacedBy.point.x
  };
  return Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])(Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["c" /* expand */])(marginBox, expandBy));
};

var getDisplacement = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var id = draggable.descriptor.id;
  var map = previousImpact.movement.map;
  var target = getTarget(draggable, onLift);
  var isVisible = isPartiallyVisible({
    target: target,
    destination: destination,
    viewport: viewport,
    withDroppableDisplacement: true
  });
  var shouldAnimate = getShouldAnimate(forceShouldAnimate, isVisible, map[id]);
  var displacement = {
    draggableId: id,
    isVisible: isVisible,
    shouldAnimate: shouldAnimate
  };
  return displacement;
});

var getDisplacementMap = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (displaced) {
  return displaced.reduce(function (map, displacement) {
    map[displacement.draggableId] = displacement;
    return map;
  }, {});
});

var getDisplacedBy = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getReorderImpact = (function (_ref) {
  var currentCenter = _ref.pageBorderBoxCenterWithDroppableScrollChange,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestinationWithoutDraggable = _ref.insideDestinationWithoutDraggable,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      userDirection = _ref.userDirection,
      onLift = _ref.onLift;
  var axis = destination.axis;
  var isMovingForward = isUserMovingForward(destination.axis, userDirection);
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var targetCenter = currentCenter[axis.line];
  var displacement = displacedBy.value;
  var displaced = insideDestinationWithoutDraggable.filter(function (child) {
    var borderBox = child.page.borderBox;
    var start = borderBox[axis.start];
    var end = borderBox[axis.end];
    var didStartDisplaced$1 = didStartDisplaced(child.descriptor.id, onLift);

    if (isMovingForward) {
      if (didStartDisplaced$1) {
        return targetCenter < start;
      }

      return targetCenter < start + displacement;
    }

    if (didStartDisplaced$1) {
      return targetCenter <= end - displacement;
    }

    return targetCenter <= end;
  }).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      previousImpact: previousImpact,
      viewport: viewport.frame,
      onLift: onLift
    });
  });
  var newIndex = insideDestinationWithoutDraggable.length - displaced.length;
  var movement = {
    displacedBy: displacedBy,
    displaced: displaced,
    map: getDisplacementMap(displaced)
  };
  var impact = {
    movement: movement,
    destination: {
      droppableId: destination.descriptor.id,
      index: newIndex
    },
    merge: null
  };
  return impact;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var noMovement = {
  displaced: [],
  map: {},
  displacedBy: noDisplacedBy
};
var noImpact = {
  movement: noMovement,
  destination: null,
  merge: null
};

var removeDraggableFromList = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var getDragImpact = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      userDirection = _ref.userDirection,
      onLift = _ref.onLift;
  var destinationId = getDroppableOver({
    target: pageBorderBoxCenter,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var insideDestinationWithoutDraggable = removeDraggableFromList(draggable, insideDestination);
  var pageBorderBoxCenterWithDroppableScrollChange = withDroppableScroll(destination, pageBorderBoxCenter);
  var withMerge = getCombineImpact({
    pageBorderBoxCenterWithDroppableScrollChange: pageBorderBoxCenterWithDroppableScrollChange,
    previousImpact: previousImpact,
    destination: destination,
    insideDestinationWithoutDraggable: insideDestinationWithoutDraggable,
    userDirection: userDirection,
    onLift: onLift
  });

  if (withMerge) {
    return withMerge;
  }

  return getReorderImpact({
    pageBorderBoxCenterWithDroppableScrollChange: pageBorderBoxCenterWithDroppableScrollChange,
    destination: destination,
    draggable: draggable,
    insideDestinationWithoutDraggable: insideDestinationWithoutDraggable,
    previousImpact: previousImpact,
    viewport: viewport,
    userDirection: userDirection,
    onLift: onLift
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getHomeOnLift = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var originallyDisplaced = insideHome.slice(draggable.descriptor.index + 1);
  var wasDisplaced = originallyDisplaced.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var onLift = {
    displacedBy: displacedBy,
    wasDisplaced: wasDisplaced
  };
  var displaced = originallyDisplaced.map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: home,
      previousImpact: noImpact,
      viewport: viewport.frame,
      forceShouldAnimate: false,
      onLift: onLift
    });
  });
  var movement = {
    displaced: displaced,
    map: getDisplacementMap(displaced),
    displacedBy: displacedBy
  };
  var impact = {
    movement: movement,
    destination: getHomeLocation(draggable.descriptor),
    merge: null
  };
  return {
    impact: impact,
    onLift: onLift
  };
});

var getDragPositions = (function (_ref) {
  var oldInitial = _ref.initial,
      oldCurrent = _ref.current,
      oldClientBorderBoxCenter = _ref.oldClientBorderBoxCenter,
      newClientBorderBoxCenter = _ref.newClientBorderBoxCenter,
      viewport = _ref.viewport;
  var shift = subtract(newClientBorderBoxCenter, oldClientBorderBoxCenter);

  var initial = function () {
    var client = {
      selection: add(oldInitial.client.selection, shift),
      borderBoxCenter: newClientBorderBoxCenter,
      offset: origin
    };
    var page = {
      selection: add(client.selection, viewport.scroll.initial),
      borderBoxCenter: add(client.selection, viewport.scroll.initial)
    };
    return {
      client: client,
      page: page
    };
  }();

  var current = function () {
    var reverse = negate(shift);
    var offset = add(oldCurrent.client.offset, reverse);
    var client = {
      selection: add(initial.client.selection, offset),
      borderBoxCenter: add(initial.client.borderBoxCenter, offset),
      offset: offset
    };
    var page = {
      selection: add(client.selection, viewport.scroll.current),
      borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current)
    };
    !isEqual(oldCurrent.client.borderBoxCenter, client.borderBoxCenter) ?  false ? invariant(false, "\n        Incorrect new client center position.\n        Expected (" + oldCurrent.client.borderBoxCenter.x + ", " + oldCurrent.client.borderBoxCenter.y + ")\n        to equal (" + client.borderBoxCenter.x + ", " + client.borderBoxCenter.y + ")\n      ") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return {
      client: client,
      page: page
    };
  }();

  return {
    current: current,
    initial: initial
  };
});

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["f" /* offset */])(draggable.client, offset$1);
  var page = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(client, initialWindowScroll);

  var moved = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, draggable, {
    placeholder: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var adjustExistingForAdditionsAndRemovals = (function (_ref) {
  var existing = _ref.existing,
      droppables = _ref.droppables,
      addedDraggables = _ref.additions,
      removedDraggables = _ref.removals,
      viewport = _ref.viewport;
  var shifted = {};
  toDroppableList(droppables).forEach(function (droppable) {
    var axis = droppable.axis;
    var original = getDraggablesInsideDroppable(droppable.descriptor.id, existing);
    var toShift = {};

    var addShift = function addShift(id, shift) {
      var previous = toShift[id];

      if (!previous) {
        toShift[id] = shift;
        return;
      }

      toShift[id] = {
        indexChange: previous.indexChange + shift.indexChange,
        offset: add(previous.offset, shift.offset)
      };
    };

    var removals = toDraggableMap(removedDraggables.map(function (id) {
      var item = existing[id];
      !item ?  false ? invariant(false, "Could not find removed draggable \"" + id + "\"") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      return item;
    }).filter(function (draggable) {
      return draggable.descriptor.droppableId === droppable.descriptor.id;
    }));
    var withRemovals = original.filter(function (item, index) {
      var isBeingRemoved = Boolean(removals[item.descriptor.id]);

      if (!isBeingRemoved) {
        return true;
      }

      var offset = negate(patch(axis.line, item.displaceBy[axis.line]));
      original.slice(index).forEach(function (sibling) {
        if (removals[sibling.descriptor.id]) {
          return;
        }

        addShift(sibling.descriptor.id, {
          indexChange: -1,
          offset: offset
        });
      });
      return false;
    });
    var additions = addedDraggables.filter(function (draggable) {
      return draggable.descriptor.droppableId === droppable.descriptor.id;
    });
    var withAdditions = withRemovals.slice(0);
    additions.forEach(function (item) {
      withAdditions.splice(item.descriptor.index, 0, item);
    });
    var additionMap = toDraggableMap(additions);
    withAdditions.forEach(function (item, index) {
      var wasAdded = Boolean(additionMap[item.descriptor.id]);

      if (!wasAdded) {
        return;
      }

      var offset = patch(axis.line, item.client.marginBox[axis.size]);
      withAdditions.slice(index).forEach(function (sibling) {
        if (additionMap[sibling.descriptor.id]) {
          return;
        }

        addShift(sibling.descriptor.id, {
          indexChange: 1,
          offset: offset
        });
      });
    });
    withAdditions.forEach(function (item) {
      if (additionMap[item.descriptor.id]) {
        return;
      }

      var shift = toShift[item.descriptor.id];

      if (!shift) {
        return;
      }

      var moved = offsetDraggable({
        draggable: item,
        offset: shift.offset,
        initialWindowScroll: viewport.scroll.initial
      });
      var index = item.descriptor.index + shift.indexChange;

      var updated = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, moved, {
        descriptor: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, item.descriptor, {
          index: index
        })
      });

      shifted[moved.descriptor.id] = updated;
    });
  });

  var map = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, existing, shifted);

  return map;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = modified.frame;
    !frame ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var adjustAdditionsForCollapsedHome = (function (_ref) {
  var additions = _ref.additions,
      dragging = _ref.dragging,
      home = _ref.home,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, dragging.displaceBy);
  return additions.map(function (draggable) {
    if (draggable.descriptor.droppableId !== home.descriptor.id) {
      return draggable;
    }

    if (draggable.descriptor.index < dragging.descriptor.index) {
      return draggable;
    }

    return offsetDraggable({
      draggable: draggable,
      offset: displacedBy.point,
      initialWindowScroll: viewport.scroll.initial
    });
  });
});

var updateDraggables = (function (_ref) {
  var updatedDroppables = _ref.updatedDroppables,
      criticalId = _ref.criticalId,
      unmodifiedExisting = _ref.existing,
      unmodifiedAdditions = _ref.additions,
      removals = _ref.removals,
      viewport = _ref.viewport;
  var existing = adjustExistingForAdditionsAndRemovals({
    droppables: updatedDroppables,
    existing: unmodifiedExisting,
    additions: unmodifiedAdditions,
    removals: removals,
    viewport: viewport
  });
  var dragging = existing[criticalId];
  var home = updatedDroppables[dragging.descriptor.droppableId];
  var scrolledAdditions = adjustAdditionsForScrollChanges({
    additions: unmodifiedAdditions,
    updatedDroppables: updatedDroppables,
    viewport: viewport
  });
  var additions = adjustAdditionsForCollapsedHome({
    additions: scrolledAdditions,
    dragging: dragging,
    home: home,
    viewport: viewport
  });

  var map = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, existing, toDraggableMap(additions));

  removals.forEach(function (id) {
    delete map[id];
  });
  return map;
});

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;
  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, frame, {
    scroll: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ?  false ? invariant(false, 'Should not add placeholder space to home list') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !!droppable.subject.withPlaceholder ?  false ? invariant(false, 'Cannot add placeholder size to a subject when it already has one') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ?  false ? invariant(false, 'Cannot remove placeholder form subject when there was none') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ?  false ? invariant(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ?  false ? invariant(false, 'Expected Droppable to have a frame') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return frame;
});

var throwIfSpacingChange = function throwIfSpacingChange(old, fresh) {
  if (false) {
    var getMessage = function getMessage(spacingType) {
      return "Cannot change the " + spacingType + " of a Droppable during a drag";
    };

    !isEqual$1(old.margin, fresh.margin) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('margin')) : invariant(false) : void 0;
    !isEqual$1(old.border, fresh.border) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('border')) : invariant(false) : void 0;
    !isEqual$1(old.padding, fresh.padding) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('padding')) : invariant(false) : void 0;
  }
};

var adjustBorderBoxSize = function adjustBorderBoxSize(axis, old, fresh) {
  return {
    top: old.top,
    left: old.left,
    right: old.left + fresh.width,
    bottom: old.top + fresh.height
  };
};

var updateDroppables = (function (_ref) {
  var modified = _ref.modified,
      existing = _ref.existing,
      viewport = _ref.viewport;

  if (!modified.length) {
    return existing;
  }

  var adjusted = modified.map(function (provided) {
    var raw = existing[provided.descriptor.id];
    !raw ?  false ? invariant(false, 'Could not locate droppable in existing droppables') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var hasPlaceholder = Boolean(raw.subject.withPlaceholder);
    var dimension = hasPlaceholder ? removePlaceholder(raw) : raw;
    var oldClient = dimension.client;
    var newClient = provided.client;
    var oldScrollable = getFrame(dimension);
    var newScrollable = getFrame(provided);

    if (false) {
      throwIfSpacingChange(dimension.client, provided.client);
      throwIfSpacingChange(oldScrollable.frameClient, newScrollable.frameClient);
      var isFrameEqual = oldScrollable.frameClient.borderBox.height === newScrollable.frameClient.borderBox.height && oldScrollable.frameClient.borderBox.width === newScrollable.frameClient.borderBox.width;
      !isFrameEqual ? process.env.NODE_ENV !== "production" ? invariant(false, 'The width and height of your Droppable scroll container cannot change when adding or removing Draggables during a drag') : invariant(false) : void 0;
    }

    var client = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["b" /* createBox */])({
      borderBox: adjustBorderBoxSize(dimension.axis, oldClient.borderBox, newClient.borderBox),
      margin: oldClient.margin,
      border: oldClient.border,
      padding: oldClient.padding
    });
    var closest = {
      client: oldScrollable.frameClient,
      page: Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(oldScrollable.frameClient, viewport.scroll.initial),
      shouldClipSubject: oldScrollable.shouldClipSubject,
      scrollSize: newScrollable.scrollSize,
      scroll: oldScrollable.scroll.initial
    };
    var withSizeChanged = getDroppableDimension({
      descriptor: provided.descriptor,
      isEnabled: provided.isEnabled,
      isCombineEnabled: provided.isCombineEnabled,
      isFixedOnPage: provided.isFixedOnPage,
      direction: provided.axis.direction,
      client: client,
      page: Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(client, viewport.scroll.initial),
      closest: closest
    });
    var scrolled = scrollDroppable(withSizeChanged, newScrollable.scroll.current);
    return scrolled;
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, existing, toDroppableMap(adjusted));

  return result;
});

var withNoAnimatedDisplacement = (function (impact) {
  var displaced = impact.movement.displaced;

  if (!displaced.length) {
    return impact;
  }

  var withoutAnimation = displaced.map(function (displacement) {
    if (!displacement.isVisible) {
      return displacement;
    }

    if (!displacement.shouldAnimate) {
      return displacement;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, displacement, {
      shouldAnimate: false
    });
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact, {
    movement: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact.movement, {
      displaced: withoutAnimation,
      map: getDisplacementMap(withoutAnimation)
    })
  });

  return result;
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var timingsKey = 'Processing dynamic changes';
var publishWhileDragging = (function (_ref) {
  var _extends2, _extends3;

  var state = _ref.state,
      published = _ref.published;
  start(timingsKey);
  var updatedDroppables = updateDroppables({
    modified: published.modified,
    existing: state.dimensions.droppables,
    viewport: state.viewport
  });
  var draggables = updateDraggables({
    updatedDroppables: updatedDroppables,
    criticalId: state.critical.draggable.id,
    existing: state.dimensions.draggables,
    additions: published.additions,
    removals: published.removals,
    viewport: state.viewport
  });
  var critical = {
    draggable: draggables[state.critical.draggable.id].descriptor,
    droppable: updatedDroppables[state.critical.droppable.id].descriptor
  };
  var original = state.dimensions.draggables[critical.draggable.id];
  var updated = draggables[critical.draggable.id];
  var droppables = recomputePlaceholders({
    draggable: updated,
    draggables: draggables,
    droppables: updatedDroppables,
    previousImpact: state.impact,
    impact: state.impact
  });
  var dimensions = {
    draggables: draggables,
    droppables: droppables
  };

  var _getDragPositions = getDragPositions({
    initial: state.initial,
    current: state.current,
    oldClientBorderBoxCenter: original.client.borderBox.center,
    newClientBorderBoxCenter: updated.client.borderBox.center,
    viewport: state.viewport
  }),
      initial = _getDragPositions.initial,
      current = _getDragPositions.current;

  var _getHomeOnLift = getHomeOnLift({
    draggable: updated,
    home: dimensions.droppables[critical.droppable.id],
    draggables: dimensions.draggables,
    viewport: state.viewport
  }),
      homeImpact = _getHomeOnLift.impact,
      onLift = _getHomeOnLift.onLift;

  var impact = withNoAnimatedDisplacement(getDragImpact({
    pageBorderBoxCenter: current.page.borderBoxCenter,
    draggable: updated,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: homeImpact,
    viewport: state.viewport,
    userDirection: state.userDirection,
    onLift: onLift
  }));
  var isOrphaned = Boolean(state.movementMode === 'SNAP' && !whatIsDraggedOver(impact));
  !!isOrphaned ?  false ? invariant(false, 'Dragging item no longer has a valid merge/destination after a dynamic update. This is not supported') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  finish(timingsKey);

  var draggingState = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    phase: 'DRAGGING'
  }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.critical = critical, _extends2.current = current, _extends2.initial = initial, _extends2.impact = impact, _extends2.dimensions = dimensions, _extends2.onLift = onLift, _extends2.onLiftImpact = homeImpact, _extends2.forceShouldAnimate = false, _extends2));

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    phase: 'DROP_PENDING'
  }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));

  return dropPending;
});

var forward = {
  vertical: 'down',
  horizontal: 'right'
};
var backward = {
  vertical: 'up',
  horizontal: 'left'
};

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      destination = _ref.destination,
      originalInsideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  if (previousImpact.merge) {
    return null;
  }

  var location = previousImpact.destination;
  !location ?  false ? invariant(false, 'Need a previous location to move from into a combine') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var currentIndex = location.index;

  var currentInsideDestination = function () {
    var shallow = originalInsideDestination.slice();

    if (isInHomeList) {
      shallow.splice(draggable.descriptor.index, 1);
    }

    shallow.splice(location.index, 0, draggable);
    return shallow;
  }();

  var targetIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;

  if (targetIndex < 0) {
    return null;
  }

  if (targetIndex > currentInsideDestination.length - 1) {
    return null;
  }

  var target = currentInsideDestination[targetIndex];
  !(target !== draggable) ?  false ? invariant(false, 'Cannot combine with self') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var merge = {
    whenEntered: isMovingForward ? forward : backward,
    combine: {
      draggableId: target.descriptor.id,
      droppableId: destination.descriptor.id
    }
  };
  var impact = {
    movement: previousImpact.movement,
    destination: null,
    merge: merge
  };
  return impact;
});

var addClosest = function addClosest(add, displaced) {
  var added = {
    draggableId: add.descriptor.id,
    isVisible: true,
    shouldAnimate: true
  };
  return [added].concat(displaced);
};
var removeClosest = function removeClosest(displaced) {
  return displaced.slice(1);
};

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      initialInside = _ref.insideDestination,
      location = _ref.location;
  var insideDestination = initialInside.slice();
  var currentIndex = location.index;
  var isInForeignList = !isInHomeList;

  if (isInForeignList) {
    insideDestination.splice(location.index, 0, draggable);
  }

  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;

  if (proposedIndex < 0) {
    return null;
  }

  if (proposedIndex > insideDestination.length - 1) {
    return null;
  }

  return {
    proposedIndex: proposedIndex,
    modifyDisplacement: true
  };
});

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      draggables = _ref.draggables,
      merge = _ref.merge,
      onLift = _ref.onLift;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var movement = previousImpact.movement;
  var combineId = merge.combine.draggableId;
  var combine = draggables[combineId];
  var combineIndex = combine.descriptor.index;
  var wasDisplacedAtStart = didStartDisplaced(combineId, onLift);

  if (wasDisplacedAtStart) {
    var hasDisplacedFromStart = !movement.map[combineId];

    if (hasDisplacedFromStart) {
      if (isMovingForward) {
        return {
          proposedIndex: combineIndex,
          modifyDisplacement: false
        };
      }

      return {
        proposedIndex: combineIndex - 1,
        modifyDisplacement: true
      };
    }

    if (isMovingForward) {
      return {
        proposedIndex: combineIndex,
        modifyDisplacement: true
      };
    }

    return {
      proposedIndex: combineIndex - 1,
      modifyDisplacement: false
    };
  }

  var isDisplaced = Boolean(movement.map[combineId]);

  if (isDisplaced) {
    if (isMovingForward) {
      return {
        proposedIndex: combineIndex + 1,
        modifyDisplacement: true
      };
    }

    return {
      proposedIndex: combineIndex,
      modifyDisplacement: false
    };
  }

  if (isMovingForward) {
    return {
      proposedIndex: combineIndex + 1,
      modifyDisplacement: false
    };
  }

  return {
    proposedIndex: combineIndex,
    modifyDisplacement: true
  };
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      onLift = _ref.onLift;

  var instruction = function () {
    if (previousImpact.destination) {
      return fromReorder({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        location: previousImpact.destination,
        insideDestination: insideDestination
      });
    }

    if (previousImpact.merge) {
      return fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        previousImpact: previousImpact,
        draggables: draggables,
        merge: previousImpact.merge,
        onLift: onLift
      });
    }
    return null;
  }();

  if (instruction == null) {
    return null;
  }

  var proposedIndex = instruction.proposedIndex,
      modifyDisplacement = instruction.modifyDisplacement;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);

  var displaced = function () {
    var lastDisplaced = previousImpact.movement.displaced;

    if (!modifyDisplacement) {
      return lastDisplaced;
    }

    if (isMovingForward) {
      return removeClosest(lastDisplaced);
    }

    var withoutDraggable = removeDraggableFromList(draggable, insideDestination);
    var atProposedIndex = withoutDraggable[proposedIndex];
    return addClosest(atProposedIndex, lastDisplaced);
  }();

  return {
    movement: {
      displacedBy: displacedBy,
      displaced: displaced,
      map: getDisplacementMap(displaced)
    },
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    },
    merge: null
  };
});

var whenCombining = (function (_ref) {
  var combine = _ref.combine,
      onLift = _ref.onLift,
      movement = _ref.movement,
      draggables = _ref.draggables;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: movement.map,
    onLift: onLift,
    combineWith: combineWith,
    displacedBy: movement.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var movement = _ref.movement,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      onLift = _ref.onLift;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = movement.displaced,
      displacedBy = movement.displacedBy;

  if (displaced.length) {
    var closestAfter = draggables[displaced[0].draggableId];

    if (didStartDisplaced(closestAfter.descriptor.id, onLift)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closestAfter.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["f" /* offset */])(closestAfter.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartDisplaced(last.descriptor.id, onLift)) {
    var page = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["f" /* offset */])(last.page, negate(onLift.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      onLift = _ref.onLift;
  var merge = impact.merge;
  var destination = impact.destination;
  var original = draggable.page.borderBox.center;

  if (!droppable) {
    return original;
  }

  if (destination) {
    return whenReordering({
      movement: impact.movement,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      onLift: onLift
    });
  }

  if (merge) {
    return whenCombining({
      movement: impact.movement,
      combine: merge.combine,
      draggables: draggables,
      onLift: onLift
    });
  }

  return original;
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

var withNewDisplacement = (function (impact, displaced) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact, {
    movement: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact.movement, {
      displaced: displaced,
      map: getDisplacementMap(displaced)
    })
  });
});

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange,
      onLift = _ref.onLift;
  var displaced = impact.movement.displaced;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var updated = displaced.map(function (entry) {
    if (entry.isVisible) {
      return entry;
    }

    var draggable = draggables[entry.draggableId];
    var withScrolledViewport = getDisplacement({
      draggable: draggable,
      destination: destination,
      previousImpact: impact,
      viewport: scrolledViewport.frame,
      onLift: onLift,
      forceShouldAnimate: false
    });

    if (withScrolledViewport.isVisible) {
      return withScrolledViewport;
    }

    var withScrolledDroppable = getDisplacement({
      draggable: draggable,
      destination: scrolledDroppable,
      previousImpact: impact,
      viewport: viewport.frame,
      onLift: onLift,
      forceShouldAnimate: false
    });

    if (withScrolledDroppable.isVisible) {
      return withScrolledDroppable;
    }

    return entry;
  });
  return withNewDisplacement(impact, updated);
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      onLift = _ref.onLift;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isInHomeList: isInHomeList,
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    onLift: onLift
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    onLift: onLift
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance,
    onLift: onLift
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ?  false ? invariant(false, 'Cannot get clipped area from droppable') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, onLift) {
  var original = draggable.page.borderBox.center;
  return didStartDisplaced(draggable.descriptor.id, onLift) ? subtract(original, onLift.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, onLift) {
  var original = draggable.page.borderBox;
  return didStartDisplaced(draggable.descriptor.id, onLift) ? offsetByPosition(original, negate(onLift.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      onLift = _ref.onLift;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, onLift),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, onLift)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, onLift)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      movement: noMovement,
      destination: {
        droppableId: destination.descriptor.id,
        index: 0
      },
      merge: null
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      onLift: onLift
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] < moveRelativeTo.page.borderBox.center[destination.axis.line]);
  var targetIndex = insideDestination.indexOf(moveRelativeTo);
  !(targetIndex !== -1) ?  false ? invariant(false, 'Cannot find target in list') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

  var proposedIndex = function () {
    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return targetIndex;
    }

    if (isGoingBeforeTarget) {
      return targetIndex;
    }

    return targetIndex + 1;
  }();

  var displaced = removeDraggableFromList(draggable, insideDestination).slice(proposedIndex).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      viewport: viewport.frame,
      previousImpact: previousImpact,
      onLift: onLift
    });
  });
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var impact = {
    movement: {
      displacedBy: displacedBy,
      displaced: displaced,
      map: getDisplacementMap(displaced)
    },
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    },
    merge: null
  };
  return impact;
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    onLift: onLift
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    onLift: onLift
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    onLift: onLift
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var getDroppableOver$1 = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver$1(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    onLift: state.onLift
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    previousImpact: state.impact,
    viewport: state.viewport,
    onLift: state.onLift
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

var getVertical = function getVertical(previous, diff) {
  if (diff === 0) {
    return previous;
  }

  return diff > 0 ? 'down' : 'up';
};

var getHorizontal = function getHorizontal(previous, diff) {
  if (diff === 0) {
    return previous;
  }

  return diff > 0 ? 'right' : 'left';
};

var getUserDirection = (function (previous, oldPageBorderBoxCenter, newPageBorderBoxCenter) {
  var diff = subtract(newPageBorderBoxCenter, oldPageBorderBoxCenter);
  return {
    horizontal: getHorizontal(previous.horizontal, diff.x),
    vertical: getVertical(previous.vertical, diff.y)
  };
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var currentWindowScroll = viewport.scroll.current;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, currentWindowScroll),
    borderBoxCenter: add(client.borderBoxCenter, currentWindowScroll)
  };
  var current = {
    client: client,
    page: page
  };
  var userDirection = getUserDirection(state.userDirection, state.current.page.borderBoxCenter, current.page.borderBoxCenter);

  if (state.phase === 'COLLECTING') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current,
      userDirection: userDirection
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageBorderBoxCenter: page.borderBoxCenter,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    userDirection: userDirection,
    onLift: state.onLift
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state, {
    current: current,
    userDirection: userDirection,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      onLift = _ref.onLift,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var updated = impact.movement.displaced.map(function (entry) {
    return getDisplacement({
      draggable: draggables[entry.draggableId],
      destination: destination,
      previousImpact: impact,
      viewport: viewport.frame,
      onLift: onLift,
      forceShouldAnimate: forceShouldAnimate
    });
  });
  return withNewDisplacement(impact, updated);
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    onLift: onLift
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ?  false ? invariant(false, 'Must be over a destination in SNAP movement mode') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    onLift: state.onLift
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    onLift: state.onLift
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'CLEAN') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, idle, {
      shouldFlush: action.payload.shouldFlush
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ?  false ? invariant(false, 'INITIAL_PUBLISH must come after a IDLE phase') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getHomeOnLift = getHomeOnLift({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getHomeOnLift.impact,
        onLift = _getHomeOnLift.onLift;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      onLift: onLift,
      onLiftImpact: impact,
      viewport: viewport,
      userDirection: forward,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    var _extends2;

    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? invariant(false, "Collection cannot start from phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var _result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'COLLECTING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Unexpected " + action.type + " received in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return publishWhileDragging({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    if (state.phase === 'COLLECTING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        offset = _action$payload2.offset;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, offset);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ?  false ? invariant(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    !(_target.isEnabled !== isEnabled) ?  false ? invariant(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var updated = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ?  false ? invariant(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ?  false ? invariant(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var _updated = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Cannot move by window in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    !state.isWindowScrollAllowed ?  false ? invariant(false, 'Window scrolling is currently not supported for fixed lists. Aborting drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, newScroll)) {
      return state;
    }

    var _viewport = scrollViewport(state.viewport, newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.viewport, {
      scroll: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? invariant(false, action.type + " received while not in DRAGGING phase") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var _extends3;

    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ?  false ? invariant(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var newState = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DROP_PENDING'
    }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot animate drop from phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      dimensions: state.dimensions,
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _action$payload6 = action.payload,
        _completed = _action$payload6.completed,
        shouldFlush = _action$payload6.shouldFlush;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: shouldFlush
    };
  }

  return state;
});

var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging$1 = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var clean$1 = function clean(args) {
  if (args === void 0) {
    args = {
      shouldFlush: false
    };
  }

  return {
    type: 'CLEAN',
    payload: args
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed,
            shouldFlush: true
          }));
        }

        !(getState().phase === 'IDLE') ?  false ? invariant(false, 'Incorrect phase to start a drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'CLEAN' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    onLift: onLift,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  var merge = impact.merge;

  if (merge && didStartDisplaced(merge.combine.draggableId, onLift)) {
    return subtract(offset, onLift.displacedBy.point);
  }

  return offset;
});

var getDropImpact = (function (_ref) {
  var reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      onLiftImpact = _ref.onLiftImpact,
      onLift = _ref.onLift;
  var didDropInsideDroppable = reason === 'DROP' && Boolean(whatIsDraggedOver(lastImpact));

  if (!didDropInsideDroppable) {
    var impact = recompute({
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      draggables: draggables,
      onLift: onLift,
      forceShouldAnimate: true
    });
    return {
      impact: impact,
      didDropInsideDroppable: didDropInsideDroppable
    };
  }

  if (lastImpact.destination) {
    return {
      impact: lastImpact,
      didDropInsideDroppable: didDropInsideDroppable
    };
  }

  var withoutMovement = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, lastImpact, {
    movement: noMovement
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: didDropInsideDroppable
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ?  false ? invariant(false, 'A DROP action occurred while DROP_PENDING and still waiting') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot drop in phase: " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        onLift: state.onLift,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var draggable = dimensions.draggables[state.critical.draggable.id];
      var destination = didDropInsideDroppable ? impact.destination : null;
      var combine = didDropInsideDroppable && impact.merge ? impact.merge.combine : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        onLift: state.onLift
      });
      var completed = {
        critical: state.critical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed,
          shouldFlush: false
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
       false ? warning('Announcement already made. Not making a second announcement') : void 0;
      return;
    }

    if (isExpired) {
       false ? warning("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ?  false ? invariant(false, 'Could not find timer') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start(key);
  fn();
  finish(key);
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = impact.destination;
    var combine = impact.merge ? impact.merge.combine : null;
    !dragging ?  false ? invariant(false, 'Cannot fire onDragMove when onDragStart has not been called') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ?  false ? invariant(false, 'Can only flush responders while dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ?  false ? invariant(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'CLEAN') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ?  false ? invariant(false, 'Cannot finish a drop animating when no drop is occurring') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed,
        shouldFlush: false
      }));
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'CLEAN' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'CLEAN';
};

var shouldCancelPending = function shouldCancelPending(action) {
  return action.type === 'COLLECTION_STARTING';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldEnd(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (shouldCancelPending(action)) {
          autoScroller.cancelPending();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ?  false ? invariant(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : __WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */];
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["e" /* createStore */])(reducer, composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_5_redux__["a" /* applyMiddleware */])(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, pendingDrop, autoScroll(autoScroller), responders(getResponders, announce))));
});

var clean$2 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};

var timingKey = 'Publish collection from DOM';
var createPublisher = (function (_ref) {
  var getEntries = _ref.getEntries,
      callbacks = _ref.callbacks;

  var advancedUsageWarning = function () {
    if (true) {
      return function () {};
    }

    var hasAnnounced = false;
    return function () {
      if (hasAnnounced) {
        return;
      }

      hasAnnounced = true;
       false ? warning("\n        Advanced usage warning: you are adding or removing a dimension during a drag\n        This an advanced feature.\n\n        More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/changes-while-dragging.md\n      ") : void 0;
    };
  }();

  var staging = clean$2();
  var frameId = null;

  var collect = function collect() {
    advancedUsageWarning();

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      callbacks.collectionStarting();
      var critical = callbacks.getCritical();
      start(timingKey);
      var entries = getEntries();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;

      var added = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys___default()(additions).map(function (id) {
        return entries.draggables[id].getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });

      var updated = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys___default()(modified).map(function (id) {
        var entry = entries.droppables[id];
        !entry ?  false ? invariant(false, 'Cannot find dynamically added droppable in cache') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
        var isHome = entry.descriptor.id === critical.droppable.id;
        var options = {
          withoutPlaceholder: !isHome
        };
        return entry.callbacks.recollect(options);
      });

      var result = {
        additions: added,
        removals: __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys___default()(removals),
        modified: updated
      };
      staging = clean$2();
      finish(timingKey);
      callbacks.publish(result);
    });
  };

  var add = function add(descriptor) {
    staging.additions[descriptor.id] = descriptor;
    staging.modified[descriptor.droppableId] = true;

    if (staging.removals[descriptor.id]) {
      delete staging.removals[descriptor.id];
    }

    collect();
  };

  var remove = function remove(descriptor) {
    staging.removals[descriptor.id] = descriptor;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$2();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
});

var getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ?  false ? invariant(false, 'Cannot find document.documentElement') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      entries = _ref.entries;
  var timingKey = 'Initial collection from DOM';
  start(timingKey);
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = values(entries.droppables).filter(function (entry) {
    return entry.descriptor.type === home.type;
  }).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = values(entries.draggables).filter(function (entry) {
    return entry.descriptor.type === critical.draggable.type;
  }).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish(timingKey);
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

var throwIfAddOrRemoveOfWrongType = function throwIfAddOrRemoveOfWrongType(collection, descriptor) {
  !(collection.critical.draggable.type === descriptor.type) ?  false ? invariant(false, "We have detected that you have added a Draggable during a drag.\n      This is not of the same type as the dragging item\n\n      Dragging type: " + collection.critical.draggable.type + ".\n      Added type: " + descriptor.type + "\n\n      We are not allowing this as you can run into problems if your change\n      has shifted the positioning of other Droppables, or has changed the size of the page") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
};

var createDimensionMarshal = (function (callbacks) {
  var entries = {
    droppables: {},
    draggables: {}
  };
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting,
      getCritical: function getCritical() {
        !collection ?  false ? invariant(false, 'Cannot get critical when there is no collection') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
        return collection.critical;
      }
    },
    getEntries: function getEntries() {
      return entries;
    }
  });

  var registerDraggable = function registerDraggable(descriptor, getDimension) {
    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    entries.draggables[descriptor.id] = entry;

    if (!collection) {
      return;
    }

    throwIfAddOrRemoveOfWrongType(collection, descriptor);
    publisher.add(descriptor);
  };

  var updateDraggable = function updateDraggable(published, descriptor, getDimension) {
    var existing = entries.draggables[published.id];
    !existing ?  false ? invariant(false, 'Cannot update draggable registration as no published registration was found') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (existing.descriptor === published) {
      delete entries.draggables[published.id];
    } else {
       false ? warning("\n        Detected incorrect usage of 'key' on '<Draggable draggableId=\"" + published.id + "\"$ />\n\n        Your 'key' should be:\n        - Unique for each Draggable in a list\n        - Not be based on the index of the Draggable\n\n        Usually you want your 'key' to just be the 'draggableId'\n\n        More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md#keys-for-a-list-of-draggable-\n      ") : void 0;
    }

    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    entries.draggables[descriptor.id] = entry;
  };

  var unregisterDraggable = function unregisterDraggable(descriptor) {
    var entry = entries.draggables[descriptor.id];
    !entry ?  false ? invariant(false, "Cannot unregister Draggable with id:\n      " + descriptor.id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (entry.descriptor !== descriptor) {
      return;
    }

    delete entries.draggables[descriptor.id];

    if (!collection) {
      return;
    }

    !(collection.critical.draggable.id !== descriptor.id) ?  false ? invariant(false, 'Cannot remove the dragging item during a drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    throwIfAddOrRemoveOfWrongType(collection, descriptor);
    publisher.remove(descriptor);
  };

  var registerDroppable = function registerDroppable(descriptor, droppableCallbacks) {
    var id = descriptor.id;
    entries.droppables[id] = {
      descriptor: descriptor,
      callbacks: droppableCallbacks
    };
    !!collection ?  false ? invariant(false, 'Cannot add a Droppable during a drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  };

  var unregisterDroppable = function unregisterDroppable(descriptor) {
    var entry = entries.droppables[descriptor.id];
    !entry ?  false ? invariant(false, "Cannot unregister Droppable with id " + descriptor.id + " as as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (entry.descriptor !== descriptor) {
      return;
    }

    delete entries.droppables[descriptor.id];
    !!collection ?  false ? invariant(false, 'Cannot add a Droppable during a drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  };

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !entries.droppables[id] ?  false ? invariant(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    !entries.droppables[id] ?  false ? invariant(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    !entries.droppables[id] ?  false ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableScroll({
      id: id,
      offset: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    var entry = entries.droppables[id];
    !entry ?  false ? invariant(false, "Cannot scroll Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    entry.callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    values(entries.droppables).filter(function (entry) {
      return entry.descriptor.type === home.type;
    }).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection = null;
  };

  var startPublishing = function startPublishing(request) {
    !!collection ?  false ? invariant(false, 'Cannot start capturing critical dimensions as there is already a collection') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var entry = entries.draggables[request.draggableId];
    !entry ?  false ? invariant(false, 'Cannot find critical draggable entry') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var home = entries.droppables[entry.descriptor.droppableId];
    !home ?  false ? invariant(false, 'Cannot find critical droppable entry') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    collection = {
      critical: critical
    };
    return getInitialPublish({
      critical: critical,
      entries: entries,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    registerDraggable: registerDraggable,
    updateDraggable: updateDraggable,
    unregisterDraggable: unregisterDraggable,
    registerDroppable: registerDroppable,
    unregisterDroppable: unregisterDroppable,
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ?  false ? invariant(false, 'Invalid result') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
     false ? warning("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;

  var now = __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default()();

  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$3 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$3({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(scrollWindow);
  var scheduleDroppableScroll = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ?  false ? invariant(false, 'Cannot fluid scroll if not dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var cancelPending = function cancelPending() {
    !dragging ?  false ? invariant(false, 'Cannot cancel pending fluid scroll when not started') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
  };

  var start$1 = function start$1(state) {
    start('starting fluid scroller');
    !!dragging ?  false ? invariant(false, 'Cannot start auto scrolling when already started') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var dragStartTime = __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default()();

    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish('starting fluid scroller');

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    cancelPending();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    cancelPending: cancelPending,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ?  false ? invariant(false, 'Cannot perform a jump scroll when there is no destination') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    cancelPending: fluidScroller.cancelPending,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix = 'data-react-beautiful-dnd';
var dragHandle = prefix + "-drag-handle";
var draggable = prefix + "-draggable";
var droppable = prefix + "-droppable";

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (uniqueContext) {
  var getSelector = makeGetSelector(uniqueContext);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"];

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ?  false ? invariant(false, 'Cannot find the head to append a style to') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl() {
  var el = document.createElement('style');
  el.type = 'text/css';
  return el;
};

function useStyleMarshal(uniqueId) {
  var uniqueContext = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return "" + uniqueId;
  }, [uniqueId]);
  var styles = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return getStyles$1(uniqueContext);
  }, [uniqueContext]);
  var alwaysRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var dynamicRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var setDynamicStyle = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (proposed) {
    var el = dynamicRef.current;
    !el ?  false ? invariant(false, 'Cannot set dynamic style element if it is not set') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (proposed) {
    var el = alwaysRef.current;
    !el ?  false ? invariant(false, 'Cannot set dynamic style element if it is not set') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ?  false ? invariant(false, 'style elements already mounted') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var always = createStyleEl();
    var dynamic = createStyleEl();
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix + "-always", uniqueContext);
    dynamic.setAttribute(prefix + "-dynamic", uniqueContext);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ?  false ? invariant(false, 'Cannot unmount ref as it is not set') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, uniqueContext]);
  var dragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting,
      styleContext: uniqueContext
    };
  }, [dragging, dropping, resting, uniqueContext]);
  return marshal;
}

var StoreContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ?  false ? invariant(false, 'Cannot find document.body') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};
var getId = function getId(uniqueId) {
  return "react-beautiful-dnd-announcement-" + uniqueId;
};
function useAnnouncer(uniqueId) {
  var id = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return getId(uniqueId);
  }, [uniqueId]);
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    !!ref.current ?  false ? invariant(false, 'Announcement node already mounted') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('role', 'log');
    el.setAttribute('aria-atomic', 'true');

    __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs2_core_js_object_assign___default()(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function () {
      var toBeRemoved = ref.current;
      !toBeRemoved ?  false ? invariant(false, 'Cannot unmount announcement node') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      getBodyElement().removeChild(toBeRemoved);
      ref.current = null;
    };
  }, [id]);
  var announce = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

     false ? warning("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
  }, []);
  return announce;
}

var AppContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(null);

var peerDependencies = {
	react: "^16.8.5"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ?  false ? invariant(false, "Unable to parse React version " + value) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

   false ? warning("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
     false ? warning("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
     false ? warning("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
  }

  if (doctype.publicId !== '') {
     false ? warning("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
  }
});

function useStartupValidation() {
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (true) {
      return;
    }

    checkReactVersion(peerDependencies.react, __WEBPACK_IMPORTED_MODULE_1_react___default.a.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(current);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    ref.current = current;
  });
  return ref;
}

var createResponders = function createResponders(props) {
  return {
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ?  false ? invariant(false, 'Could not find store from lazy ref') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var uniqueId = props.uniqueId,
      setOnError = props.setOnError;
  var lazyStoreRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(uniqueId);
  var styleMarshal = useStyleMarshal(uniqueId);
  var lazyDispatch = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var callbacks = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      publishWhileDragging: publishWhileDragging$1,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var dimensionMarshal = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createDimensionMarshal(callbacks);
  }, [callbacks]);
  var autoScroller = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createAutoScroller(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var store = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createStore({
      dimensionMarshal: dimensionMarshal,
      styleMarshal: styleMarshal,
      announce: announce,
      autoScroller: autoScroller,
      getResponders: getResponders
    });
  }, [announce, autoScroller, dimensionMarshal, getResponders, styleMarshal]);

  if (false) {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning('unexpected store change') : void 0;
    }
  }

  lazyStoreRef.current = store;
  var tryResetStore = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(clean$1({
        shouldFlush: true
      }));
    }
  }, []);
  setOnError(tryResetStore);
  var getCanLift = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      marshal: dimensionMarshal,
      style: styleMarshal.styleContext,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed
    };
  }, [dimensionMarshal, getCanLift, getIsMovementAllowed, styleMarshal.styleContext]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AppContext.Provider, {
    value: appContext
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */], {
    context: StoreContext,
    store: store
  }, props.children));
}

var instanceCount = 0;
function resetServerContext() {
  instanceCount = 0;
}
function DragDropContext(props) {
  var uniqueId = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return instanceCount++;
  }, []);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ErrorBoundary, null, function (setOnError) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(App, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      setOnError: setOnError,
      uniqueId: uniqueId
    }, props), props.children);
  });
}

var isEqual$2 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$2('scroll');
var isAuto = isEqual$2('auto');
var isVisible$1 = isEqual$2('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (true) {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

   false ? warning("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

   false ? warning("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["d" /* getBox */])(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["c" /* expand */])(paddingBox, base.border);
  var client = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["b" /* createBox */])({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["d" /* getBox */])(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

function withoutPlaceholder(placeholder, fn) {
  if (!placeholder) {
    return fn();
  }

  var last = placeholder.style.display;
  placeholder.style.display = 'none';
  var result = fn();
  placeholder.style.display = last;
  return result;
}

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Context);
  !result ?  false ? invariant(false, 'Could not find required context') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppableDimensionPublisher(args) {
  var whileDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var appContext = useRequiredContext(AppContext);
  var marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      id: args.droppableId,
      type: args.type
    };
  }, [args.droppableId, args.type]);
  var publishedDescriptorRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(descriptor);
  var memoizedUpdateScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (x, y) {
      !whileDraggingRef.current ?  false ? invariant(false, 'Can only update scroll when dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? invariant(false, 'Could not find scroll options while scrolling') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (windowScroll, options) {
    !!whileDraggingRef.current ?  false ? invariant(false, 'Cannot collect a droppable while a drag is occurring') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ?  false ? invariant(false, 'Cannot collect without a droppable ref') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });

    if (env.closestScrollable) {
      env.closestScrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (false) {
        checkForNestedScrollContainers(env.closestScrollable);
      }
    }

    return dimension;
  }, [descriptor, onClosestScroll, previousRef]);
  var recollect = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (options) {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? invariant(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var previous = previousRef.current;

    var execute = function execute() {
      return getDimension({
        ref: dragging.ref,
        descriptor: dragging.descriptor,
        env: dragging.env,
        windowScroll: origin,
        direction: previous.direction,
        isDropDisabled: previous.isDropDisabled,
        isCombineEnabled: previous.isCombineEnabled,
        shouldClipSubject: !previous.ignoreContainerClipping
      });
    };

    if (!options.withoutPlaceholder) {
      return execute();
    }

    return withoutPlaceholder(previous.getPlaceholderRef(), execute);
  }, [previousRef]);
  var dragStopped = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? invariant(false, 'Cannot stop drag when no active drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? invariant(false, 'Cannot scroll when there is no drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ?  false ? invariant(false, 'Cannot scroll a droppable with no closest scrollable') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      recollect: recollect,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, recollect, scroll]);
  useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = descriptor;
    marshal.registerDroppable(descriptor, callbacks);
    return function () {
      if (whileDraggingRef.current) {
         false ? warning('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
        dragStopped();
      }

      marshal.unregisterDroppable(descriptor);
    };
  }, [callbacks, descriptor, dragStopped, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop() {}

var empty = {
  width: 0,
  height: 0,
  margin: noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: transitions.placeholder
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var tryClearAnimateOpenTimer = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      styleContext = props.styleContext;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (!isAnimatingOpenOnMount) {
      return noop;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop;
    }

    if (animateOpenTimerRef.current) {
      return noop;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(props.placeholder.tagName, {
    style: style,
    'data-react-beautiful-dnd-placeholder': styleContext,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(Placeholder);

var DroppableContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(null);

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ?  false ? invariant(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
}

function checkOwnProps(props) {
  !props.droppableId ?  false ? invariant(false, 'A Droppable requires a droppableId prop') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !(typeof props.isDropDisabled === 'boolean') ?  false ? invariant(false, 'isDropDisabled must be a boolean') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !(typeof props.isCombineEnabled === 'boolean') ?  false ? invariant(false, 'isCombineEnabled must be a boolean') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !(typeof props.ignoreContainerClipping === 'boolean') ?  false ? invariant(false, 'ignoreContainerClipping must be a boolean') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
}

function checkPlaceholderRef(props, placeholderEl) {
  if (!props.placeholder) {
    return;
  }

  if (placeholderEl) {
    return;
  }

   false ? warning("\n    Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n    DroppableProvided > placeholder could not be found.\n\n    Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n  ") : void 0;
}

function useValidation(_ref) {
  var props = _ref.props,
      getDroppableRef = _ref.getDroppableRef,
      getPlaceholderRef = _ref.getPlaceholderRef;
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (false) {
      checkOwnProps(props);
      checkIsValidInnerRef(getDroppableRef());
      checkPlaceholderRef(props, getPlaceholderRef());
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

function Droppable(props) {
  var appContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(AppContext);
  !appContext ?  false ? invariant(false, 'Could not find app context') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var styleContext = appContext.style,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var placeholderRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      updateViewportMaxScroll = props.updateViewportMaxScroll;
  var getDroppableRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return droppableRef.current;
  }, []);
  var getPlaceholderRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return placeholderRef.current;
  }, []);
  var setDroppableRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (value) {
    droppableRef.current = value;
  }, []);
  var setPlaceholderRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (value) {
    placeholderRef.current = value;
  }, []);
  var onPlaceholderTransitionEnd = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppableDimensionPublisher({
    droppableId: droppableId,
    type: type,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var placeholder = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      styleContext: styleContext,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-react-beautiful-dnd-droppable': styleContext
      }
    };
  }, [placeholder, setDroppableRef, styleContext]);
  var droppableContext = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      droppableId: droppableId,
      type: type
    };
  }, [droppableId, type]);
  useValidation({
    props: props,
    getDroppableRef: function getDroppableRef() {
      return droppableRef.current;
    },
    getPlaceholderRef: function getPlaceholderRef() {
      return placeholderRef.current;
    }
  });
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot));
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps = function makeMapStateToProps() {
  var idle = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null
    }
  };

  var idleWithoutAnimation = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, idle, {
    shouldAnimatePlaceholder: false
  });

  var getMapProps = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (id, isDraggingOver, dragging, snapshot) {
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: snapshot
      };
    }

    if (!isDraggingOver) {
      return idle;
    }

    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot
    };
  });
  var getSnapshot = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (id, isDraggingOver, dragging) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;
    var draggingOverWith = isDraggingOver ? draggableId : null;
    var draggingFromThisWith = isHome ? draggableId : null;
    return {
      isDraggingOver: isDraggingOver,
      draggingOverWith: draggingOverWith,
      draggingFromThisWith: draggingFromThisWith
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idle;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      var snapshot = getSnapshot(id, isDraggingOver, dragging);
      return getMapProps(id, isDraggingOver, dragging, snapshot);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idle;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      var _snapshot = getSnapshot(id, whatIsDraggedOverFromResult(completed.result) === id, _dragging);

      return getMapProps(id, whatIsDraggedOver(completed.impact) === id, _dragging, _snapshot);
    }

    if (state.phase === 'IDLE' && !state.completed && state.shouldFlush) {
      return idleWithoutAnimation;
    }

    if (state.phase === 'IDLE' && state.completed) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idle;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.merge);

      if (state.shouldFlush) {
        return idleWithoutAnimation;
      }

      if (wasOver) {
        return wasCombining ? idle : idleWithoutAnimation;
      }

      return idle;
    }

    return idle;
  };

  return selector;
};
var mapDispatchToProps = {
  updateViewportMaxScroll: updateViewportMaxScroll
};
var defaultProps = {
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false
};
var ConnectedDroppable = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

var createEventMarshal = (function () {
  var isMouseDownHandled = false;

  var handle = function handle() {
    !!isMouseDownHandled ?  false ? invariant(false, 'Cannot handle mouse down as it is already handled') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    isMouseDownHandled = true;
  };

  var isHandled = function isHandled() {
    return isMouseDownHandled;
  };

  var reset = function reset() {
    isMouseDownHandled = false;
  };

  return {
    handle: handle,
    isHandled: isHandled,
    reset: reset
  };
});

var getOptions = function getOptions(shared, fromBinding) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, shared, fromBinding);
};

var bindEvents = function bindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
  });
};
var unbindEvents = function unbindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.removeEventListener(binding.eventName, binding.fn, options);
  });
};

var createScheduler = (function (callbacks) {
  var memoizedMove = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (x, y) {
    var point = {
      x: x,
      y: y
    };
    callbacks.onMove(point);
  });
  var move = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(function (point) {
    return memoizedMove(point.x, point.y);
  });
  var moveUp = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onMoveUp);
  var moveDown = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onMoveDown);
  var moveRight = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onMoveRight);
  var moveLeft = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onMoveLeft);
  var windowScrollMove = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onWindowScroll);

  var cancel = function cancel() {
    move.cancel();
    moveUp.cancel();
    moveDown.cancel();
    moveRight.cancel();
    moveLeft.cancel();
    windowScrollMove.cancel();
  };

  return {
    move: move,
    moveUp: moveUp,
    moveDown: moveDown,
    moveRight: moveRight,
    moveLeft: moveLeft,
    windowScrollMove: windowScrollMove,
    cancel: cancel
  };
});

var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var sharedOptions = {
  capture: true
};
var createPostDragEventPreventer = (function (getWindow) {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }

    isBound = true;
    bindEvents(getWindow(), pointerEvents, sharedOptions);
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }

    isBound = false;
    unbindEvents(getWindow(), pointerEvents, sharedOptions);
  };

  var pointerEvents = [{
    eventName: 'click',
    fn: function fn(event) {
      event.preventDefault();
      unbind();
    }
  }, {
    eventName: 'mousedown',
    fn: unbind
  }, {
    eventName: 'touchstart',
    fn: unbind
  }];

  var preventNext = function preventNext() {
    if (isBound) {
      unbind();
    }

    bind();
  };

  var preventer = {
    preventNext: preventNext,
    abort: unbind
  };
  return preventer;
});

var sloppyClickThreshold = 5;
var isSloppyClickThresholdExceeded = (function (original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
});

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var primaryButton = 0;

var noop$1 = function noop() {};

var mouseDownMarshal = createEventMarshal();
function useMouseSensor(args) {
  var canStartCapturing = args.canStartCapturing,
      getWindow = args.getWindow,
      callbacks = args.callbacks,
      getShouldRespectForcePress = args.getShouldRespectForcePress,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd;
  var pendingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var isDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var unbindWindowEventsRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(noop$1);
  var getIsCapturing = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return Boolean(pendingRef.current || isDraggingRef.current);
  }, []);
  var schedule = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsCapturing() ?  false ? invariant(false, 'Should not recreate scheduler while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsCapturing]);
  var postDragEventPreventer = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createPostDragEventPreventer(getWindow);
  }, [getWindow]);
  var stop = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!getIsCapturing()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    var shouldBlockClick = isDraggingRef.current;
    mouseDownMarshal.reset();

    if (shouldBlockClick) {
      postDragEventPreventer.preventNext();
    }

    pendingRef.current = null;
    isDraggingRef.current = false;
    onCaptureEnd();
  }, [getIsCapturing, onCaptureEnd, postDragEventPreventer, schedule]);
  var cancel = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var startDragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    !!isDraggingRef.current ?  false ? invariant(false, 'Cannot start a drag while dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var pending = pendingRef.current;
    !pending ?  false ? invariant(false, 'Cannot start a drag without a pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    pendingRef.current = null;
    isDraggingRef.current = true;
    callbacks.onLift({
      clientSelection: pending,
      movementMode: 'FLUID'
    });
  }, [callbacks]);
  var windowBindings = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsCapturing() ?  false ? invariant(false, 'Should not recreate window bindings while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var bindings = [{
      eventName: 'mousemove',
      fn: function fn(event) {
        var button = event.button,
            clientX = event.clientX,
            clientY = event.clientY;

        if (button !== primaryButton) {
          return;
        }

        var point = {
          x: clientX,
          y: clientY
        };

        if (isDraggingRef.current) {
          event.preventDefault();
          schedule.move(point);
          return;
        }

        var pending = pendingRef.current;

        if (!pending) {
          stop();
           false ? invariant(false, 'Expected there to be an active or pending drag when window mousemove event is received') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false);
        }

        if (!isSloppyClickThresholdExceeded(pending, point)) {
          return;
        }

        event.preventDefault();
        startDragging();
      }
    }, {
      eventName: 'mouseup',
      fn: function fn(event) {
        var wasDragging = isDraggingRef.current;
        stop();

        if (wasDragging) {
          event.preventDefault();
          callbacks.onDrop();
        }
      }
    }, {
      eventName: 'mousedown',
      fn: function fn(event) {
        if (isDraggingRef.current) {
          event.preventDefault();
        }

        cancel();
      }
    }, {
      eventName: 'keydown',
      fn: function fn(event) {
        if (pendingRef.current) {
          stop();
          return;
        }

        if (event.keyCode === escape) {
          event.preventDefault();
          cancel();
          return;
        }

        preventStandardKeyEvents(event);
      }
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'scroll',
      options: {
        passive: true,
        capture: false
      },
      fn: function fn(event) {
        if (event.currentTarget !== getWindow()) {
          return;
        }

        if (pendingRef.current) {
          stop();
          return;
        }

        schedule.windowScrollMove();
      }
    }, {
      eventName: 'webkitmouseforcechanged',
      fn: function fn(event) {
        if (event.webkitForce == null || MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN == null) {
           false ? warning('handling a mouse force changed event when it is not supported') : void 0;
          return;
        }

        var forcePressThreshold = MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
        var isForcePressing = event.webkitForce >= forcePressThreshold;

        if (!getShouldRespectForcePress()) {
          event.preventDefault();
          return;
        }

        if (isForcePressing) {
          cancel();
        }
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
    return bindings;
  }, [getIsCapturing, cancel, startDragging, schedule, stop, callbacks, getWindow, getShouldRespectForcePress]);
  var bindWindowEvents = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startPendingDrag = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (point) {
    !!pendingRef.current ?  false ? invariant(false, 'Expected there to be no pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    pendingRef.current = point;
    onCaptureStart(stop);
    bindWindowEvents();
  }, [bindWindowEvents, onCaptureStart, stop]);
  var onMouseDown = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (mouseDownMarshal.isHandled()) {
      return;
    }

    !!getIsCapturing() ?  false ? invariant(false, 'Should not be able to perform a mouse down while a drag or pending drag is occurring') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!canStartCapturing(event)) {
      return;
    }

    if (event.button !== primaryButton) {
      return;
    }

    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }

    mouseDownMarshal.handle();
    event.preventDefault();
    var point = {
      x: event.clientX,
      y: event.clientY
    };
    startPendingDrag(point);
  }, [canStartCapturing, getIsCapturing, startPendingDrag]);
  return onMouseDown;
}

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

var isAnInteractiveElement = function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
};

var shouldAllowDraggingFromTarget = (function (event, canDragInteractiveElements) {
  if (canDragInteractiveElements) {
    return true;
  }

  var target = event.target,
      currentTarget = event.currentTarget;

  if (!isElement(target) || !isElement(currentTarget)) {
    return true;
  }

  return !isAnInteractiveElement(currentTarget, target);
});

var getBorderBoxCenterPosition = (function (el) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])(el.getBoundingClientRect()).center;
});

var _scrollJumpKeys;
var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function noop$2() {}

function useKeyboardSensor(args) {
  var canStartCapturing = args.canStartCapturing,
      getWindow = args.getWindow,
      callbacks = args.callbacks,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd,
      getDraggableRef = args.getDraggableRef;
  var isDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var unbindWindowEventsRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(noop$2);
  var getIsDragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return isDraggingRef.current;
  }, []);
  var schedule = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsDragging() ?  false ? invariant(false, 'Should not recreate scheduler while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsDragging]);
  var stop = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!getIsDragging()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    isDraggingRef.current = false;
    onCaptureEnd();
  }, [getIsDragging, onCaptureEnd, schedule]);
  var cancel = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var windowBindings = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsDragging() ?  false ? invariant(false, 'Should not recreate window bindings when dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return [{
      eventName: 'mousedown',
      fn: cancel
    }, {
      eventName: 'mouseup',
      fn: cancel
    }, {
      eventName: 'click',
      fn: cancel
    }, {
      eventName: 'touchstart',
      fn: cancel
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'wheel',
      fn: cancel,
      options: {
        passive: true
      }
    }, {
      eventName: 'scroll',
      options: {
        capture: false
      },
      fn: function fn(event) {
        if (event.currentTarget !== getWindow()) {
          return;
        }

        callbacks.onWindowScroll();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
  }, [callbacks, cancel, getIsDragging, getWindow]);
  var bindWindowEvents = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startDragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    !!isDraggingRef.current ?  false ? invariant(false, 'Cannot start a drag while dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var ref = getDraggableRef();
    !ref ?  false ? invariant(false, 'Cannot start a keyboard drag without a draggable ref') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    isDraggingRef.current = true;
    onCaptureStart(stop);
    bindWindowEvents();
    var center = getBorderBoxCenterPosition(ref);
    callbacks.onLift({
      clientSelection: center,
      movementMode: 'SNAP'
    });
  }, [bindWindowEvents, callbacks, getDraggableRef, onCaptureStart, stop]);
  var onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (!getIsDragging()) {
      if (event.defaultPrevented) {
        return;
      }

      if (!canStartCapturing(event)) {
        return;
      }

      if (event.keyCode !== space) {
        return;
      }

      event.preventDefault();
      startDragging();
      return;
    }

    if (event.keyCode === escape) {
      event.preventDefault();
      cancel();
      return;
    }

    if (event.keyCode === space) {
      event.preventDefault();
      stop();
      callbacks.onDrop();
      return;
    }

    if (event.keyCode === arrowDown) {
      event.preventDefault();
      schedule.moveDown();
      return;
    }

    if (event.keyCode === arrowUp) {
      event.preventDefault();
      schedule.moveUp();
      return;
    }

    if (event.keyCode === arrowRight) {
      event.preventDefault();
      schedule.moveRight();
      return;
    }

    if (event.keyCode === arrowLeft) {
      event.preventDefault();
      schedule.moveLeft();
      return;
    }

    if (scrollJumpKeys[event.keyCode]) {
      event.preventDefault();
      return;
    }

    preventStandardKeyEvents(event);
  }, [callbacks, canStartCapturing, cancel, getIsDragging, schedule, startDragging, stop]);
  return onKeyDown;
}

var timeForLongPress = 150;
var forcePressThreshold = 0.15;
var touchStartMarshal = createEventMarshal();

var noop$3 = function noop() {};

var webkitHack = function () {
  var stub = {
    preventTouchMove: noop$3,
    releaseTouchMove: noop$3
  };

  if (typeof window === 'undefined') {
    return stub;
  }

  if (!('ontouchstart' in window)) {
    return stub;
  }

  var isBlocking = false;
  window.addEventListener('touchmove', function (event) {
    if (!isBlocking) {
      return;
    }

    if (event.defaultPrevented) {
      return;
    }

    event.preventDefault();
  }, {
    passive: false,
    capture: false
  });

  var preventTouchMove = function preventTouchMove() {
    isBlocking = true;
  };

  var releaseTouchMove = function releaseTouchMove() {
    isBlocking = false;
  };

  return {
    preventTouchMove: preventTouchMove,
    releaseTouchMove: releaseTouchMove
  };
}();

function useTouchSensor(args) {
  var callbacks = args.callbacks,
      getWindow = args.getWindow,
      canStartCapturing = args.canStartCapturing,
      getShouldRespectForcePress = args.getShouldRespectForcePress,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd;
  var pendingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var isDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var hasMovedRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var unbindWindowEventsRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(noop$3);
  var getIsCapturing = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return Boolean(pendingRef.current || isDraggingRef.current);
  }, []);
  var postDragClickPreventer = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createPostDragEventPreventer(getWindow);
  }, [getWindow]);
  var schedule = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsCapturing() ?  false ? invariant(false, 'Should not recreate scheduler while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsCapturing]);
  var stop = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!getIsCapturing()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    touchStartMarshal.reset();
    webkitHack.releaseTouchMove();
    hasMovedRef.current = false;
    onCaptureEnd();

    if (isDraggingRef.current) {
      postDragClickPreventer.preventNext();
      isDraggingRef.current = false;
      return;
    }

    var pending = pendingRef.current;
    !pending ?  false ? invariant(false, 'Expected a pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    clearTimeout(pending.longPressTimerId);
    pendingRef.current = null;
  }, [getIsCapturing, onCaptureEnd, postDragClickPreventer, schedule]);
  var cancel = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var windowBindings = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsCapturing() ?  false ? invariant(false, 'Should not recreate window bindings while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var bindings = [{
      eventName: 'touchmove',
      options: {
        passive: false,
        capture: false
      },
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        if (!hasMovedRef.current) {
          hasMovedRef.current = true;
        }

        var _event$touches$ = event.touches[0],
            clientX = _event$touches$.clientX,
            clientY = _event$touches$.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        event.preventDefault();
        schedule.move(point);
      }
    }, {
      eventName: 'touchend',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        event.preventDefault();
        stop();
        callbacks.onDrop();
      }
    }, {
      eventName: 'touchcancel',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        event.preventDefault();
        cancel();
      }
    }, {
      eventName: 'touchstart',
      fn: cancel
    }, {
      eventName: 'orientationchange',
      fn: cancel
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'scroll',
      options: {
        passive: true,
        capture: false
      },
      fn: function fn() {
        if (pendingRef.current) {
          stop();
          return;
        }

        schedule.windowScrollMove();
      }
    }, {
      eventName: 'contextmenu',
      fn: function fn(event) {
        event.preventDefault();
      }
    }, {
      eventName: 'keydown',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          cancel();
          return;
        }

        if (event.keyCode === escape) {
          event.preventDefault();
        }

        cancel();
      }
    }, {
      eventName: 'touchforcechange',
      fn: function fn(event) {
        if (!getShouldRespectForcePress()) {
          event.preventDefault();
          return;
        }

        if (hasMovedRef.current) {
          event.preventDefault();
          return;
        }

        var touch = event.touches[0];

        if (touch.force >= forcePressThreshold) {
          cancel();
        }
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
    return bindings;
  }, [callbacks, cancel, getIsCapturing, getShouldRespectForcePress, schedule, stop]);
  var bindWindowEvents = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startDragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var pending = pendingRef.current;
    !pending ?  false ? invariant(false, 'Cannot start a drag without a pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    isDraggingRef.current = true;
    pendingRef.current = null;
    hasMovedRef.current = false;
    callbacks.onLift({
      clientSelection: pending.point,
      movementMode: 'FLUID'
    });
  }, [callbacks]);
  var startPendingDrag = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    !!pendingRef.current ?  false ? invariant(false, 'Expected there to be no pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var touch = event.touches[0];
    var clientX = touch.clientX,
        clientY = touch.clientY;
    var point = {
      x: clientX,
      y: clientY
    };
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    var pending = {
      point: point,
      longPressTimerId: longPressTimerId
    };
    pendingRef.current = pending;
    onCaptureStart(stop);
    bindWindowEvents();
  }, [bindWindowEvents, onCaptureStart, startDragging, stop]);

  var onTouchStart = function onTouchStart(event) {
    if (touchStartMarshal.isHandled()) {
      return;
    }

    !!getIsCapturing() ?  false ? invariant(false, 'Should not be able to perform a touch start while a drag or pending drag is occurring') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!canStartCapturing(event)) {
      return;
    }

    touchStartMarshal.handle();
    webkitHack.preventTouchMove();
    startPendingDrag(event);
  };

  return onTouchStart;
}

function isSvgElement(el) {
  return Boolean(getWindowFromEl(el).SVGElement) && el instanceof getWindowFromEl(el).SVGElement;
}

var selector = "[" + dragHandle + "]";

var throwIfSVG = function throwIfSVG(el) {
  !!isSvgElement(el) ?  false ? invariant(false, "A drag handle cannot be an SVGElement: it has inconsistent focus support.\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/dragging-svgs.md") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
};

var getDragHandleRef = function getDragHandleRef(draggableRef) {
  if (draggableRef.hasAttribute(dragHandle)) {
    throwIfSVG(draggableRef);
    return draggableRef;
  }

  var el = draggableRef.querySelector(selector);
  throwIfSVG(draggableRef);
  !el ?  false ? invariant(false, "\n      Cannot find drag handle element inside of Draggable.\n      Please be sure to apply the {...provided.dragHandleProps} to your Draggable\n\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md\n    ") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !isHtmlElement(el) ?  false ? invariant(false, 'A drag handle must be a HTMLElement') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return el;
};

function useValidation$1(_ref) {
  var isEnabled = _ref.isEnabled,
      getDraggableRef = _ref.getDraggableRef;
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (false) {
      if (!isEnabled) {
        return;
      }

      var draggableRef = getDraggableRef();
      !draggableRef ? process.env.NODE_ENV !== "production" ? invariant(false, 'Drag handle was unable to find draggable ref') : invariant(false) : void 0;
      getDragHandleRef(draggableRef);
    }
  }, [getDraggableRef, isEnabled]);
}

var retainingFocusFor = null;
var listenerOptions = {
  capture: true
};

var clearRetentionOnFocusChange = function () {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }

    isBound = true;
    window.addEventListener('focus', onWindowFocusChange, listenerOptions);
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }

    isBound = false;
    window.removeEventListener('focus', onWindowFocusChange, listenerOptions);
  };

  var onWindowFocusChange = function onWindowFocusChange() {
    unbind();
    retainingFocusFor = null;
  };

  var result = function result() {
    return bind();
  };

  result.cancel = function () {
    return unbind();
  };

  return result;
}();

var retain = function retain(id) {
  retainingFocusFor = id;
  clearRetentionOnFocusChange();
};

var tryRestoreFocus = function tryRestoreFocus(id, draggableRef) {
  if (!retainingFocusFor) {
    return;
  }

  if (id !== retainingFocusFor) {
    return;
  }

  retainingFocusFor = null;
  clearRetentionOnFocusChange.cancel();
  var dragHandleRef = getDragHandleRef(draggableRef);

  if (!dragHandleRef) {
     false ? warning('Could not find drag handle in the DOM to focus on it') : void 0;
    return;
  }

  dragHandleRef.focus();
};

var retainer = {
  retain: retain,
  tryRestoreFocus: tryRestoreFocus
};

function noop$4() {}

function useFocusRetainer(args) {
  var isFocusedRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var lastArgsRef = usePrevious(args);
  var getDraggableRef = args.getDraggableRef;
  var onFocus = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    isFocusedRef.current = true;
  }, []);
  var onBlur = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    isFocusedRef.current = false;
  }, []);
  useIsomorphicLayoutEffect(function () {
    var first = lastArgsRef.current;

    if (!first.isEnabled) {
      return noop$4;
    }

    var draggable = getDraggableRef();
    !draggable ?  false ? invariant(false, 'Drag handle could not obtain draggable ref') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var dragHandle = getDragHandleRef(draggable);
    retainer.tryRestoreFocus(first.draggableId, dragHandle);
    return function () {
      var last = lastArgsRef.current;

      var shouldRetainFocus = function () {
        if (!last.isEnabled) {
          return false;
        }

        if (!isFocusedRef.current) {
          return false;
        }

        return last.isDragging || last.isDropAnimating;
      }();

      if (shouldRetainFocus) {
        retainer.retain(last.draggableId);
      }
    };
  }, [getDraggableRef, lastArgsRef]);
  var lastDraggableRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  useIsomorphicLayoutEffect(function () {
    if (!lastDraggableRef.current) {
      return;
    }

    var draggableRef = getDraggableRef();

    if (!draggableRef) {
      return;
    }

    if (draggableRef === lastDraggableRef.current) {
      return;
    }

    if (isFocusedRef.current && lastArgsRef.current.isEnabled) {
      getDragHandleRef(draggableRef).focus();
    }
  });
  useIsomorphicLayoutEffect(function () {
    lastDraggableRef.current = getDraggableRef();
  });
  return {
    onBlur: onBlur,
    onFocus: onFocus
  };
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function useDragHandle(args) {
  var capturingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var onCaptureStart = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (abort) {
    !!capturingRef.current ?  false ? invariant(false, 'Cannot start capturing while something else is') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    capturingRef.current = {
      abort: abort
    };
  }, []);
  var onCaptureEnd = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    !capturingRef.current ?  false ? invariant(false, 'Cannot stop capturing while nothing is capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    capturingRef.current = null;
  }, []);
  var abortCapture = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    !capturingRef.current ?  false ? invariant(false, 'Cannot abort capture when there is none') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    capturingRef.current.abort();
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      canLift = _useRequiredContext.canLift,
      styleContext = _useRequiredContext.style;

  var isDragging = args.isDragging,
      isEnabled = args.isEnabled,
      draggableId = args.draggableId,
      callbacks = args.callbacks,
      getDraggableRef = args.getDraggableRef,
      getShouldRespectForcePress = args.getShouldRespectForcePress,
      canDragInteractiveElements = args.canDragInteractiveElements;
  var lastArgsRef = usePrevious(args);
  useValidation$1({
    isEnabled: isEnabled,
    getDraggableRef: getDraggableRef
  });
  var getWindow = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return getWindowFromEl(getDraggableRef());
  }, [getDraggableRef]);
  var canStartCapturing = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (!isEnabled) {
      return false;
    }

    if (capturingRef.current) {
      return false;
    }

    if (!canLift(draggableId)) {
      return false;
    }

    return shouldAllowDraggingFromTarget(event, canDragInteractiveElements);
  }, [canDragInteractiveElements, canLift, draggableId, isEnabled]);

  var _useFocusRetainer = useFocusRetainer(args),
      onBlur = _useFocusRetainer.onBlur,
      onFocus = _useFocusRetainer.onFocus;

  var mouseArgs = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd,
      getShouldRespectForcePress: getShouldRespectForcePress
    };
  }, [callbacks, getDraggableRef, getWindow, canStartCapturing, onCaptureStart, onCaptureEnd, getShouldRespectForcePress]);
  var onMouseDown = useMouseSensor(mouseArgs);
  var keyboardArgs = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd
    };
  }, [callbacks, canStartCapturing, getDraggableRef, getWindow, onCaptureEnd, onCaptureStart]);
  var onKeyDown = useKeyboardSensor(keyboardArgs);
  var touchArgs = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      getShouldRespectForcePress: getShouldRespectForcePress,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd
    };
  }, [callbacks, getDraggableRef, getWindow, canStartCapturing, getShouldRespectForcePress, onCaptureStart, onCaptureEnd]);
  var onTouchStart = useTouchSensor(touchArgs);
  useIsomorphicLayoutEffect(function () {
    return function () {
      if (!capturingRef.current) {
        return;
      }

      abortCapture();

      if (lastArgsRef.current.isDragging) {
        lastArgsRef.current.callbacks.onCancel();
      }
    };
  }, []);

  if (!isEnabled && capturingRef.current) {
    abortCapture();

    if (lastArgsRef.current.isDragging) {
       false ? warning('You have disabled dragging on a Draggable while it was dragging. The drag has been cancelled') : void 0;
      callbacks.onCancel();
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (!isDragging && capturingRef.current) {
      abortCapture();
    }
  }, [abortCapture, isDragging]);
  var props = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    if (!isEnabled) {
      return null;
    }

    return {
      onMouseDown: onMouseDown,
      onKeyDown: onKeyDown,
      onTouchStart: onTouchStart,
      onFocus: onFocus,
      onBlur: onBlur,
      tabIndex: 0,
      'data-react-beautiful-dnd-drag-handle': styleContext,
      'aria-roledescription': 'Draggable item. Press space bar to lift',
      draggable: false,
      onDragStart: preventHtml5Dnd
    };
  }, [isEnabled, onBlur, onFocus, onKeyDown, onMouseDown, onTouchStart, styleContext]);
  return props;
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["a" /* calculateBox */])(borderBox, computedStyles);
  var page = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggableDimensionPublisher(args) {
  var draggableId = args.draggableId,
      index = args.index,
      getDraggableRef = args.getDraggableRef;
  var appContext = useRequiredContext(AppContext);
  var marshal = appContext.marshal;
  var droppableContext = useRequiredContext(DroppableContext);
  var droppableId = droppableContext.droppableId,
      type = droppableContext.type;
  var descriptor = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    var result = {
      id: draggableId,
      droppableId: droppableId,
      type: type,
      index: index
    };
    return result;
  }, [draggableId, droppableId, index, type]);
  var publishedDescriptorRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(descriptor);
  var makeDimension = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (windowScroll) {
    var latest = publishedDescriptorRef.current;
    var el = getDraggableRef();
    !el ?  false ? invariant(false, 'Cannot get dimension when no ref is set') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return getDimension$1(latest, el, windowScroll);
  }, [getDraggableRef]);
  useIsomorphicLayoutEffect(function () {
    marshal.registerDraggable(publishedDescriptorRef.current, makeDimension);
    return function () {
      return marshal.unregisterDraggable(publishedDescriptorRef.current);
    };
  }, [makeDimension, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (publishedDescriptorRef.current === descriptor) {
      return;
    }

    var previous = publishedDescriptorRef.current;
    publishedDescriptorRef.current = descriptor;
    marshal.updateDraggable(previous, descriptor, makeDimension);
  }, [descriptor, makeDimension, marshal]);
}

function checkOwnProps$1(props) {
  !__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer___default()(props.index) ?  false ? invariant(false, 'Draggable requires an integer index prop') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !props.draggableId ?  false ? invariant(false, 'Draggable requires a draggableId') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !(typeof props.isDragDisabled === 'boolean') ?  false ? invariant(false, 'isDragDisabled must be a boolean') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
}

function checkForOutdatedProps(props) {
  if (Object.prototype.hasOwnProperty.call(props, 'shouldRespectForceTouch')) {
     false ? warning('shouldRespectForceTouch has been renamed to shouldRespectForcePress') : void 0;
  }
}

function useValidation$2(props, getRef) {
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (false) {
      checkOwnProps$1(props);
      checkForOutdatedProps(props);
      checkIsValidInnerRef(getRef());
    }
  });
}

function Draggable(props) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var setRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (el) {
    ref.current = el;
  }, []);
  var getRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return ref.current;
  }, []);
  var appContext = useRequiredContext(AppContext);
  useValidation$2(props, getRef);
  var children = props.children,
      draggableId = props.draggableId,
      isDragDisabled = props.isDragDisabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.disableInteractiveElementBlocking,
      index = props.index,
      mapped = props.mapped,
      moveUpAction = props.moveUp,
      moveAction = props.move,
      dropAction = props.drop,
      moveDownAction = props.moveDown,
      moveRightAction = props.moveRight,
      moveLeftAction = props.moveLeft,
      moveByWindowScrollAction = props.moveByWindowScroll,
      liftAction = props.lift,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  var forPublisher = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      draggableId: draggableId,
      index: index,
      getDraggableRef: getRef
    };
  }, [draggableId, getRef, index]);
  useDraggableDimensionPublisher(forPublisher);
  var onLift = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (options) {
    start('LIFT');
    var el = ref.current;
    !el ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    !!isDragDisabled ?  false ? invariant(false, 'Cannot lift a Draggable when it is disabled') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var clientSelection = options.clientSelection,
        movementMode = options.movementMode;
    liftAction({
      id: draggableId,
      clientSelection: clientSelection,
      movementMode: movementMode
    });
    finish('LIFT');
  }, [draggableId, isDragDisabled, liftAction]);
  var getShouldRespectForcePress = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return shouldRespectForcePress;
  }, [shouldRespectForcePress]);
  var callbacks = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      onLift: onLift,
      onMove: function onMove(clientSelection) {
        return moveAction({
          client: clientSelection
        });
      },
      onDrop: function onDrop() {
        return dropAction({
          reason: 'DROP'
        });
      },
      onCancel: function onCancel() {
        return dropAction({
          reason: 'CANCEL'
        });
      },
      onMoveUp: moveUpAction,
      onMoveDown: moveDownAction,
      onMoveRight: moveRightAction,
      onMoveLeft: moveLeftAction,
      onWindowScroll: function onWindowScroll() {
        return moveByWindowScrollAction({
          newScroll: getWindowScroll()
        });
      }
    };
  }, [dropAction, moveAction, moveByWindowScrollAction, moveDownAction, moveLeftAction, moveRightAction, moveUpAction, onLift]);
  var isDragging = mapped.type === 'DRAGGING';
  var isDropAnimating = mapped.type === 'DRAGGING' && Boolean(mapped.dropping);
  var dragHandleArgs = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      draggableId: draggableId,
      isDragging: isDragging,
      isDropAnimating: isDropAnimating,
      isEnabled: !isDragDisabled,
      callbacks: callbacks,
      getDraggableRef: getRef,
      canDragInteractiveElements: canDragInteractiveElements,
      getShouldRespectForcePress: getShouldRespectForcePress
    };
  }, [callbacks, canDragInteractiveElements, draggableId, getRef, getShouldRespectForcePress, isDragDisabled, isDragging, isDropAnimating]);
  var dragHandleProps = useDragHandle(dragHandleArgs);
  var onMoveEnd = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-react-beautiful-dnd-draggable': appContext.style,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [appContext.style, dragHandleProps, mapped, onMoveEnd, setRef]);
  return children(provided, mapped.snapshot);
}

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.merge ? impact.merge.combine.draggableId : null;
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var getDraggingSnapshot = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (mode, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getSecondarySnapshot = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (combineTargetFor) {
    return {
      isDragging: false,
      isDropAnimating: false,
      dropAnimation: null,
      mode: null,
      draggingOver: null,
      combineTargetFor: combineTargetFor,
      combineWith: null
    };
  });
  var defaultMapProps = {
    mapped: {
      type: 'SECONDARY',
      offset: origin,
      combineTargetFor: null,
      shouldAnimateDisplacement: true,
      snapshot: getSecondarySnapshot(null)
    }
  };
  var memoizedOffset = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getDraggingProps = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (offset, mode, dimension, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getDraggingSnapshot(mode, draggingOver, combineWith, null)
      }
    };
  });
  var getSecondaryProps = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getSecondarySnapshot(combineTargetFor)
      }
    };
  });

  var getSecondaryMovement = function getSecondaryMovement(ownId, draggingId, impact) {
    var map = impact.movement.map;
    var displacement = map[ownId];
    var movement = impact.movement;
    var merge = impact.merge;
    var isCombinedWith = Boolean(merge && merge.combine.draggableId === ownId);
    var displacedBy = movement.displacedBy.point;
    var offset = memoizedOffset(displacedBy.x, displacedBy.y);

    if (isCombinedWith) {
      return getSecondaryProps(displacement ? offset : origin, draggingId, displacement ? displacement.shouldAnimate : true);
    }

    if (!displacement) {
      return null;
    }

    if (!displacement.isVisible) {
      return null;
    }

    return getSecondaryProps(offset, null, displacement.shouldAnimate);
  };

  var draggingSelector = function draggingSelector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var mode = state.movementMode;
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getDraggingProps(memoizedOffset(offset.x, offset.y), mode, dimension, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var _mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: _mode,
          forceShouldAnimate: null,
          snapshot: getDraggingSnapshot(_mode, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  var secondarySelector = function secondarySelector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getSecondaryMovement(ownProps.draggableId, state.critical.draggable.id, state.impact);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getSecondaryMovement(ownProps.draggableId, completed.result.draggableId, completed.impact);
    }

    return null;
  };

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || defaultMapProps;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  lift: lift,
  move: move,
  moveUp: moveUp,
  moveDown: moveDown,
  moveLeft: moveLeft,
  moveRight: moveRight,
  moveByWindowScroll: moveByWindowScroll,
  drop: drop,
  dropAnimationFinished: dropAnimationFinished
};
var defaultProps$1 = {
  isDragDisabled: false,
  disableInteractiveElementBlocking: false,
  shouldRespectForcePress: false
};
var ConnectedDraggable = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);
ConnectedDraggable.defaultProps = defaultProps$1;




/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(242);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(533);
var defined = __webpack_require__(534);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(541);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])(); // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?

  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      batch(function () {
        for (var i = 0; i < listeners.length; i++) {
          listeners[i]();
        }
      });
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var DragHandle=function DragHandle(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{style:{cursor:"move"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:"ellipsis",style:{transform:"rotate(90deg) translate(0px, -4px)"}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:"ellipsis",style:{transform:"rotate(90deg) translate(0px, 4px)"}}));};/* harmony default export */ __webpack_exports__["a"] = (DragHandle);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSdmxAttributeAttachmentLevelTranslations; });
var getSdmxAttributeAttachmentLevelTranslations=function getSdmxAttributeAttachmentLevelTranslations(t){var sdmxAttributeAttachmentLevelTranslations=function sdmxAttributeAttachmentLevelTranslations(t){return{Series:t('sdmxAttributeAttachmentLevel.series'),Observation:t('sdmxAttributeAttachmentLevel.observation'),Group:t('sdmxAttributeAttachmentLevel.group'),Dataset:t('sdmxAttributeAttachmentLevel.dataset')};};return sdmxAttributeAttachmentLevelTranslations(t!==undefined?t:function(str){return str;});};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1288);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _rcSwitch = _interopRequireDefault(__webpack_require__(1289));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _wave = _interopRequireDefault(__webpack_require__(298));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Switch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    var _this;

    _classCallCheck(this, Switch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Switch).apply(this, arguments));

    _this.saveSwitch = function (node) {
      _this.rcSwitch = node;
    };

    _this.renderSwitch = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          size = _this$props.size,
          loading = _this$props.loading,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          disabled = _this$props.disabled;
      var prefixCls = getPrefixCls('switch', customizePrefixCls);
      var classes = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-small"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _classNames));
      var loadingIcon = loading ? React.createElement(_icon["default"], {
        type: "loading",
        className: "".concat(prefixCls, "-loading-icon")
      }) : null;
      return React.createElement(_wave["default"], {
        insertExtraNode: true
      }, React.createElement(_rcSwitch["default"], _extends({}, (0, _omit["default"])(_this.props, ['loading']), {
        prefixCls: prefixCls,
        className: classes,
        disabled: disabled || loading,
        ref: _this.saveSwitch,
        loadingIcon: loadingIcon
      })));
    };

    return _this;
  }

  _createClass(Switch, [{
    key: "focus",
    value: function focus() {
      this.rcSwitch.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcSwitch.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSwitch);
    }
  }]);

  return Switch;
}(React.Component);

exports["default"] = Switch;
Switch.propTypes = {
  prefixCls: PropTypes.string,
  // HACK: https://github.com/ant-design/ant-design/issues/5368
  // size=default and size=large are the same
  size: PropTypes.oneOf(['small', 'default', 'large']),
  className: PropTypes.string
};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ARTEFACT_MIN_FORM_MODE_READ */
/* unused harmony export ARTEFACT_MIN_FORM_MODE_EDIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARTEFACT_MIN_FORM_MODE_CREATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_numbers__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__perf_input__ = __webpack_require__(103);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var mapPropsToFields=function mapPropsToFields(_ref){var artefact=_ref.artefact;return{id:__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.createFormField({value:artefact?artefact.id:null}),agencyID:__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.createFormField({value:artefact?artefact.agencyID:null}),version:__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.createFormField({value:artefact?artefact.version:null}),name:__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.createFormField({value:artefact?artefact.name:null})};};var onFieldsChange=function onFieldsChange(props,fields){if(props.onChange){var newFields=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;});if(newFields.id&&newFields.id.length>__WEBPACK_IMPORTED_MODULE_18__constants_numbers__["a" /* ID_MAX_LEN */]){__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.warning({title:props.t('commons.alerts.fieldTooLong.title'),content:props.t('commons.alerts.fieldTooLong.content',{maxLen:__WEBPACK_IMPORTED_MODULE_18__constants_numbers__["a" /* ID_MAX_LEN */]})});props.onChange(props.artefact);}else{props.onChange(newFields);}}};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_TWO_THIRDS"]}};var ARTEFACT_MIN_FORM_MODE_READ='ARTEFACT_MIN_FORM_MODE_READ';var ARTEFACT_MIN_FORM_MODE_EDIT='ARTEFACT_MIN_FORM_MODE_EDIT';var ARTEFACT_MIN_FORM_MODE_CREATE='ARTEFACT_MIN_FORM_MODE_CREATE';var ArtefactMinForm=function ArtefactMinForm(_ref3){var t=_ref3.t,form=_ref3.form,_ref3$mode=_ref3.mode,mode=_ref3$mode===undefined?ARTEFACT_MIN_FORM_MODE_READ:_ref3$mode,agencies=_ref3.agencies,artefact=_ref3.artefact,dataLanguages=_ref3.dataLanguages,appLanguage=_ref3.appLanguage;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_MIN_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.id.label'),validateStatus:artefact&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,artefact.id).help?"warning":null,help:artefact&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,artefact.id).help},formItemLayout),form.getFieldDecorator('id',{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,title:form.getFieldValue('id'),disabled:mode!==ARTEFACT_MIN_FORM_MODE_CREATE,style:{textTransform:"uppercase"}}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_MIN_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.agencyID.label')},formItemLayout),form.getFieldDecorator('agencyID')(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},title:agencies&&form.getFieldValue('agencyID')&&(Object(__WEBPACK_IMPORTED_MODULE_14__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[form.getFieldValue('agencyID')],language,dataLanguages)||form.getFieldValue('agencyID')),disabled:mode!==ARTEFACT_MIN_FORM_MODE_CREATE},agencies?Object.keys(agencies).map(function(agencyID,index){var agencyName=Object(__WEBPACK_IMPORTED_MODULE_14__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[agencyID],language,dataLanguages);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:index,value:agencyID,title:agencyID&&agencyName?agencyID+' - '+agencyName:agencyID},agencyID&&agencyName?agencyID+' - '+agencyName:agencyID);}):null))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:mode===ARTEFACT_MIN_FORM_MODE_CREATE?'form-item-required':null,label:t('data.artefact.version.label'),hasFeedback:true,validateStatus:artefact&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,artefact.version).help?"warning":null,help:artefact&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,artefact.version).help},formItemLayout),form.getFieldDecorator('version')(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,title:form.getFieldValue('version'),disabled:mode!==ARTEFACT_MIN_FORM_MODE_CREATE}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:mode!==ARTEFACT_MIN_FORM_MODE_READ?'form-item-required':null,label:t('data.artefact.name.label')},formItemLayout),form.getFieldDecorator('name')(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_12__multilanguage_input__["a" /* default */],title:form.getFieldValue('name'),disabled:mode===ARTEFACT_MIN_FORM_MODE_READ}))));});};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps),__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ArtefactMinForm));

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__infinite_scroll_table__ = __webpack_require__(52);
var mapStateToProps=function mapStateToProps(state){return{username:state.app.user.username};};var ArtefactOwnershipModal=function ArtefactOwnershipModal(_ref){var t=_ref.t,isVisible=_ref.isVisible,users=_ref.users,owners=_ref.owners,fetchUsers=_ref.fetchUsers,fetchOwners=_ref.fetchOwners,onOwnersChange=_ref.onOwnersChange,onSubmit=_ref.onSubmit,onClose=_ref.onClose,username=_ref.username;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["MODAL_WIDTH_MD"],title:t('components.artefactOwnershipModal.title'),onCancel:onClose,footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onClose},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:"primary",onClick:onSubmit},t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchUsers,disabled:users!==null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchOwners,disabled:owners!==null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__infinite_scroll_table__["a" /* default */],{data:users,getRowKey:function getRowKey(_ref2){var username=_ref2.username;return username;},getIsDisabledRow:function getIsDisabledRow(utente){return utente.username===username;},columns:[{title:t('data.user.username.label'),dataIndex:'username',minWidth:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.user.email.label'),dataIndex:'email',minWidth:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]}],rowSelection:{selectedRowKeys:owners||[],onChange:function onChange(checkedArr){if(!checkedArr.find(function(el){return el===username;})){checkedArr.push(username);}onOwnersChange(checkedArr);}}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps))(ArtefactOwnershipModal));

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_collapse_style__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_collapse_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_collapse_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_collapse__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_list_style__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_list__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_css__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__middlewares_scrollTo_actions__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.jQuery;var mapDispatchToProps=function mapDispatchToProps(dispatch){return{scrollToLastInput:function scrollToLastInput(lastListItem){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__middlewares_scrollTo_actions__["b" /* scrollTo */])(lastListItem));}};};var mapPropsToFields=function mapPropsToFields(_ref){var values=_ref.values;return{values:values?values.map(function(value){return __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:value});}):null};};var onFieldsChange=function onFieldsChange(props,fields){var newValues=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(props.values);props.onChange(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.merge(newValues,fields.values.map(function(el){return el.value;})));};var InputListForm=function(_React$Component){_inherits(InputListForm,_React$Component);function InputListForm(props){_classCallCheck(this,InputListForm);var _this=_possibleConstructorReturn(this,(InputListForm.__proto__||Object.getPrototypeOf(InputListForm)).call(this,props));_this.state={expanded:true,className:__WEBPACK_IMPORTED_MODULE_26_uuid___default()()};return _this;}_createClass(InputListForm,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.values&&this.props.values&&prevProps.values.length<this.props.values.length){var listItems=$("."+this.state.className+" .input-list-form__list-item");window.setTimeout(function(){return _this2.props.scrollToLastInput(listItems[listItems.length-1]);},250);}}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:this.state.className},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,null,this.props.values&&this.props.values.length>0?__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_collapse___default.a,{bordered:false,defaultActiveKey:["1"],onChange:function onChange(key){return key.includes("1")?_this3.setState({expanded:true}):_this3.setState({expanded:false});},activeKey:this.state.expanded?'1':''},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_collapse___default.a.Panel,{header:this.state.expanded?this.props.t("components.inputListForm.collapse.collapse.label"):this.props.t("components.inputListForm.collapse.expand.label",{count:this.props.values.length}),className:"input-list-form__collapse-panel__header__text",key:"1",style:{border:0,fontStyle:"italic",color:"red"}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_list___default.a,{bordered:true,split:true,size:"small"},this.props.values&&this.props.values.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_list___default.a.Item,{className:"input-list-form__list-item"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{style:{marginTop:0,marginBottom:4},validateStatus:_this3.props.validateId?_this3.props.form.getFieldValue("values["+index+"]")&&Object(__WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__["f" /* isIDValidWithHelp */])(_this3.props.t,_this3.props.form.getFieldValue("values["+index+"]")).help?"warning":null:"",help:_this3.props.validateId?_this3.props.form.getFieldValue("values["+index+"]")&&Object(__WEBPACK_IMPORTED_MODULE_27__utils_artefactValidators__["f" /* isIDValidWithHelp */])(_this3.props.t,_this3.props.form.getFieldValue("values["+index+"]")).help:""},_this3.props.form.getFieldDecorator("values["+index+"]",_this3.props.validateId?{getValueFromEvent:function getValueFromEvent(e){return(e.target.value||"").toUpperCase();}}:{})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,{title:_this3.props.form.getFieldValue("values["+index+"]"),className:_this3.props.minItems&&_this3.props.values.length<=_this3.props.minItems?'input-list-form__input--addon-after--disabled':'input-list-form__input--addon-after--enabled',addonAfter:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"delete",onClick:function onClick(){if(!_this3.props.minItems||_this3.props.values.length>_this3.props.minItems){var newValues=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(_this3.props.values);newValues.splice(index,1);_this3.props.onChange(newValues);}},title:_this3.props.removeItemLabel?_this3.props.removeItemLabel:_this3.props.t("components.inputListForm.buttons.remove.title"),style:{cursor:""+(_this3.props.minItems&&_this3.props.values.length<=_this3.props.minItems?'not-allowed':'pointer'),color:""+(_this3.props.minItems&&_this3.props.values.length<=_this3.props.minItems?'rgba(0, 0, 0, 0.25)':'')}})})))),_this3.props.values&&index!==_this3.props.values.length-1&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_divider___default.a,{style:{marginTop:0,marginBottom:0}}));})))):__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__custom_empty__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"start",style:{marginLeft:16,marginBottom:8,marginTop:this.props.values&&this.props.values.length>0?0:8}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{icon:"plus",onClick:function onClick(){var newValues=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(_this3.props.values);if(!newValues){newValues=[];}newValues.push("");_this3.setState({expanded:true});_this3.props.onChange(newValues);}},this.props.addItemLabel?this.props.addItemLabel:this.props.t("components.inputListForm.buttons.add.title"))))));}}]);return InputListForm;}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_19_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_21_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["b" /* connect */])(null,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(InputListForm));

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_menu_style__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_menu__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ping_icon__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
var EndpointsDropdown=function EndpointsDropdown(_ref){var endpoints=_ref.endpoints,endpointId=_ref.endpointId,isEndpointAvailable=_ref.isEndpointAvailable,onEndpointSet=_ref.onEndpointSet,onNodePing=_ref.onNodePing,disabled=_ref.disabled,canBeNull=_ref.canBeNull,fullWidth=_ref.fullWidth,doNotGoHome=_ref.doNotGoHome;return endpoints&&endpoints.length>0&&(endpointId||canBeNull)?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default.a,{disabled:disabled,trigger:['hover'],overlay:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_menu___default.a,{onClick:function onClick(_ref2){var key=_ref2.key;if(!doNotGoHome){window.open('./#','_self');}onEndpointSet(key);}},endpoints.map(function(endpoint){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_menu___default.a.Item,{key:endpoint.general.id},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("a",null,endpoint.general.name," (",endpoint.general.id,")"));}))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{htmlType:"button",style:fullWidth?{width:"calc(100% - 36px)"}:undefined},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{justify:endpointId?"space-between":"end",gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_SM"],type:"flex"},endpointId&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ping_icon__["a" /* default */],{isOk:isEndpointAvailable})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,!!endpoints.find(function(endpoint){return endpoint.general.id===endpointId;})?endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).general.name:endpointId))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:"down"}))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{icon:"sync",style:{marginLeft:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_XS"]},onClick:onNodePing,disabled:disabled})):null;};/* harmony default export */ __webpack_exports__["a"] = (EndpointsDropdown);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isReportIdWarningVisible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_copy_to_clipboard__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_html_template_viewer__ = __webpack_require__(363);
var $=window.jQuery;var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,appLang:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var isReportIdWarningVisible=function isReportIdWarningVisible(newId,reports){return!!(reports||[]).find(function(_ref){var id=_ref.id;return id===newId;});};var getParsedValue=function getParsedValue(str){return str.includes("urn:sdmx:")?Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(str)):str;};var ReportList=function ReportList(_ref2){var t=_ref2.t,nodeId=_ref2.nodeId,nodes=_ref2.nodes,appLang=_ref2.appLang,dataLanguages=_ref2.dataLanguages,isDcat=_ref2.isDcat,ReportDetailWrapper=_ref2.ReportDetailWrapper,hasPermission=_ref2.hasPermission,metadataSet=_ref2.metadataSet,reports=_ref2.reports,report=_ref2.report,reportAnnotations=_ref2.reportAnnotations,isReportVisible=_ref2.isReportVisible,reportStructure=_ref2.reportStructure,step=_ref2.step,reportId=_ref2.reportId,target=_ref2.target,identifiableTargets=_ref2.identifiableTargets,reportHtmlPageUrl=_ref2.reportHtmlPageUrl,selectedAttribute=_ref2.selectedAttribute,onReportCreate=_ref2.onReportCreate,onReportDelete=_ref2.onReportDelete,onReportShow=_ref2.onReportShow,onReportHide=_ref2.onReportHide,onReportSubmit=_ref2.onReportSubmit,onStepSet=_ref2.onStepSet,onReportStateSubmit=_ref2.onReportStateSubmit,onHtmlPageShow=_ref2.onHtmlPageShow,onHtmlPageHide=_ref2.onHtmlPageHide,onReportDownload=_ref2.onReportDownload;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLang;var connectedNode=nodes.find(function(node){return node.general.id===nodeId;});var annotationsConfig=connectedNode.annotations;var mawsUrl=connectedNode.endpoint.maEndpoint;var metadataApiBaseUrl=connectedNode.endpoint.metadataBaseURL;var actions=[function(_ref3){var dfPerm=_ref3.hasPermission;return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles_buttons__["l" /* BUTTON_DETAIL */],{title:dfPerm===false?t("commons.actions.detailReadOnly.title"):t("commons.actions.detail.title"),onClick:function onClick(_ref4){var id=_ref4.id;return onReportShow(metadataSet.id,id);}});},function(_ref5){var isPublished=_ref5.isPublished;return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles_buttons__["s" /* BUTTON_INFO_PAGE */],{title:t("scenes.referenceMetadata.commons.reportList.actions.navigateHtmlPage.title"),onClick:function onClick(_ref6){var id=_ref6.id;return onHtmlPageShow(Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["P" /* getReportHtmlPageUrl */])(nodeId,metadataSet.id,id,lang,metadataApiBaseUrl));},disabled:isPublished!==__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]||!metadataApiBaseUrl});},function(_ref7){var isPublished=_ref7.isPublished;return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles_buttons__["t" /* BUTTON_INFO_PAGE_LINK */],{title:t("scenes.referenceMetadata.commons.reportList.actions.copyHtmlUrl.title"),onClick:function onClick(_ref8){var id=_ref8.id;__WEBPACK_IMPORTED_MODULE_15_copy_to_clipboard___default()(Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["P" /* getReportHtmlPageUrl */])(nodeId,metadataSet.id,id,lang,metadataApiBaseUrl));return __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.info(t("scenes.referenceMetadata.commons.reportList.actions.copyHtmlUrl.message"));},disabled:isPublished!==__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]||!metadataApiBaseUrl});},function(_ref9){var isPublished=_ref9.isPublished;return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles_buttons__["b" /* BUTTON_API_LINK */],{title:t("scenes.referenceMetadata.commons.reportList.actions.copyCkanUrl.title"),onClick:function onClick(_ref10){var id=_ref10.id,target=_ref10.target;__WEBPACK_IMPORTED_MODULE_15_copy_to_clipboard___default()(metadataSet&&isDcat&&target.id===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["u" /* DATAFLOW_TARGET_ID */]?Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["J" /* getMetadataApiDcatReportUrl */])(metadataApiBaseUrl,metadataSet.id,id,lang):Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["K" /* getMetadataApiReportUrl */])(metadataApiBaseUrl,metadataSet.id,id));return __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.info(t("scenes.referenceMetadata.commons.reportList.actions.copyCkanUrl.message"));},disabled:isPublished!==__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]||!metadataApiBaseUrl});},function(_ref11){var isPublished=_ref11.isPublished;return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles_buttons__["m" /* BUTTON_DOWNLOAD */],{title:t("commons.actions.download.title"),onClick:function onClick(_ref12){var id=_ref12.id;return onReportDownload(metadataSet.id,id,metadataSet.id+"+"+id+".json",metadataApiBaseUrl);},disabled:isPublished!==__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]||!metadataApiBaseUrl});},function(_ref13){var dfPerm=_ref13.hasPermission,target=_ref13.target;return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles_buttons__["k" /* BUTTON_DELETE */],{title:t("commons.actions.delete.title"),onClick:function onClick(report){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t('scenes.referenceMetadata.commons.reportList.modals.confirms.delete.title',{id:report.id}),onOk:function onOk(){onReportDelete(Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(report,__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["x" /* REPORT_ID_ANNOTATION_ID */]).text);},cancelText:t('commons.buttons.cancel.title')});},disabled:isDcat?!dfPerm||target.id===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["t" /* CATALOG_TARGET_ID */]&&reports!==null&&reports.length>1:!hasPermission});}];var filteredReports=(reports||[]).filter(function(_ref14){var isPublished=_ref14.isPublished;return hasPermission?true:isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */];}).map(function(report){return Object.assign({},report,{targetId:report.target.id,targetReferenceValues:(report.target.referenceValues||[]).map(function(_ref15){var object=_ref15.object;return getParsedValue(object);}).join(", ")});});return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_infinite_scroll_table__["a" /* default */],{data:filteredReports,getRowKey:function getRowKey(_ref16){var id=_ref16.id;return id;},columns:[{title:t('scenes.referenceMetadata.commons.reportList.columns.id.title'),dataIndex:'id',minWidth:100},{title:t('scenes.referenceMetadata.commons.reportList.columns.structure.title'),dataIndex:'targetId',minWidth:100},{title:t('scenes.referenceMetadata.commons.reportList.columns.targetIdentifier.title'),dataIndex:'targetReferenceValues',minWidth:isDcat?100:500},{title:t('data.artefact.isPublished.shortLabel'),dataIndex:"isPublished",width:30,withValuesFilter:true,render:function render(isPublished){return isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"check"}):isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["y" /* REPORT_STATE_DRAFT */]?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"close"}):null;},renderText:function renderText(isPublished){return isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]?t('data.artefact.isPublished.values.published'):isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["y" /* REPORT_STATE_DRAFT */]?t('data.artefact.isPublished.values.draft'):t('data.artefact.isPublished.values.notPublished');}}],actions:[function(_ref17){var dfPerm=_ref17.hasPermission,isPublished=_ref17.isPublished;return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles_buttons__["A" /* BUTTON_PUBLISH */],{title:t("scenes.referenceMetadata.commons.reportList.actions.publish.title"),onClick:function onClick(_ref18){var id=_ref18.id;return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t('scenes.referenceMetadata.commons.reportList.modals.confirms.publish.title',{id:metadataSet.id}),onOk:function onOk(){onReportStateSubmit(metadataSet.id,id,__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]);},cancelText:t('commons.buttons.cancel.title')});},disabled:isDcat?isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["y" /* REPORT_STATE_DRAFT */]||!dfPerm:isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["y" /* REPORT_STATE_DRAFT */]||!hasPermission});}].concat(actions),altActions:[function(_ref19){var dfPerm=_ref19.hasPermission,isPublished=_ref19.isPublished;return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles_buttons__["G" /* BUTTON_UNPUBLISH */],{title:t("scenes.referenceMetadata.commons.reportList.actions.unpublish.title"),onClick:function onClick(_ref20){var id=_ref20.id;return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t('scenes.referenceMetadata.commons.reportList.modals.confirms.unpublish.title',{id:metadataSet.id}),onOk:function onOk(){onReportStateSubmit(metadataSet.id,id,__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["A" /* REPORT_STATE_NOT_PUBLISHED */]);},cancelText:t('commons.buttons.cancel.title')});},disabled:isDcat?isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["y" /* REPORT_STATE_DRAFT */]||!dfPerm:isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["y" /* REPORT_STATE_DRAFT */]||!hasPermission});}].concat(actions),getIsAltRow:function getIsAltRow(_ref21){var isPublished=_ref21.isPublished;return isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */];},rightActions:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:"primary",icon:"plus",onClick:onReportCreate,disabled:isDcat?false:!hasPermission},t('scenes.referenceMetadata.commons.reportList.actions.create.title'))}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:isReportVisible,onCancel:onReportHide,title:t('scenes.referenceMetadata.commons.reportList.modals.report.title'),fullscreen:true,withDataLanguageSelector:true,footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onReportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(step===__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */]){onStepSet(__WEBPACK_IMPORTED_MODULE_18__constants__["c" /* REPORT_DETAILS_WIZARD_STEP_SECOND */],dataLanguages,t,mawsUrl);}else{if(!selectedAttribute||Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["S" /* isAttributeValueValid */])(selectedAttribute)){var emptyNodes=Object(__WEBPACK_IMPORTED_MODULE_14__utils_tree__["l" /* getNodes */])(reportStructure,"metadataAttributes",function(node){return Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["U" /* isEmptyAttribute */])(node);}).map(function(_ref22){var name=_ref22.name;return name;});if(emptyNodes&&emptyNodes.length>0){__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.referenceMetadata.commons.reportList.modals.warning.emptyAttribute.title"),content:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,t("scenes.referenceMetadata.commons.reportList.modals.warning.emptyAttribute.content"),":",emptyNodes.map(function(node,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{key:index},"- ",node);})),onOk:function onOk(){onReportSubmit(metadataSet,report,reportAnnotations,reportStructure,reportId,target,identifiableTargets,annotationsConfig,true);},okText:t("scenes.referenceMetadata.commons.reportList.modals.warning.emptyAttribute.saveDraft.title")});}else{onReportSubmit(metadataSet,report,reportAnnotations,reportStructure,reportId,target,identifiableTargets,annotationsConfig,false);}}else if(selectedAttribute&&!Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["S" /* isAttributeValueValid */])(selectedAttribute)){$(".report-structure-tree__waring").css({color:"#FF0000"});}}},disabled:step===__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */]?reportId===null||reportId.length===0||report===null&&isReportIdWarningVisible(reportId,reports)||target===null||identifiableTargets.find(function(el){return!el.value||el.value.length===0;}):report&&report.isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]?true:isDcat?report&&!report.hasPermission:false},step===__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */]?t('commons.buttons.goForward.title'):t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ReportDetailWrapper,{hasPermission:hasPermission})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_html_template_viewer__["a" /* default */],{title:t('scenes.referenceMetadata.commons.modals.htmlPage.title'),htmlPageUrl:reportHtmlPageUrl,onClose:onHtmlPageHide}));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps))(ReportList));

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enhanced_modal__ = __webpack_require__(19);
var HtmlTemplateViewer=function HtmlTemplateViewer(_ref){var t=_ref.t,title=_ref.title,htmlPageUrl=_ref.htmlPageUrl,onClose=_ref.onClose;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__enhanced_modal__["a" /* default */],{fullscreen:true,visible:htmlPageUrl!==null,title:title,maskClosable:false,onCancel:onClose,bodyStyle:{position:"relative",padding:0},footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onClose},t('commons.buttons.close.title'))},htmlPageUrl&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("iframe",{title:"title",src:htmlPageUrl,style:{position:"absolute",border:0,width:"100%",height:"100%"}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])()(HtmlTemplateViewer));

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cache", function() { return cache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(1621);


var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;




/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(612);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(623);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Goto',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
};
module.exports = exports['default'];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
};
module.exports = exports['default'];

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(369);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(641);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(374);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(266);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(144);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(378);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(271);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(653)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context__ = __webpack_require__(272);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var removedIsInitialSSR = false;

var I18n = function (_Component) {
  _inherits(I18n, _Component);

  function I18n(props, context) {
    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_2__context__["b" /* getI18n */])();

    var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
    _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__context__["a" /* getDefaults */])(), i18nOptions, props);

    // nextjs SSR: getting data from next.js or other ssr stack
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.options.wait = false; // we got all passed down already
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }

    // provider SSR: data was set in provider and ssr flag was set
    if (_this.i18n.options && _this.i18n.options.isInitialSSR) {
      _this.options.wait = false;
    }

    var language = _this.i18n.languages && _this.i18n.languages[0];
    var ready = !!language && _this.getNamespaces().every(function (ns) {
      return _this.i18n.hasResourceBundle(language, ns);
    });

    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };

    _this.t = _this.getI18nTranslate();

    _this.onI18nChanged = _this.onI18nChanged.bind(_this);
    _this.getI18nTranslate = _this.getI18nTranslate.bind(_this);
    _this.namespaces = _this.getNamespaces.bind(_this);
    return _this;
  }

  _createClass(I18n, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        t: this.t,
        i18n: this.i18n
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadNamespaces();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Note that dynamically loading additional namespaces after the initial mount will not block rendering – even if the `wait` option is true.
      if (this.props.ns && prevProps.ns !== this.props.ns) this.loadNamespaces();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      this.mounted = false;
      if (this.onI18nChanged) {
        if (this.options.bindI18n) {
          var p = this.options.bindI18n.split(' ');
          p.forEach(function (f) {
            return _this2.i18n.off(f, _this2.onI18nChanged);
          });
        }
        if (this.options.bindStore) {
          var _p = this.options.bindStore.split(' ');
          _p.forEach(function (f) {
            return _this2.i18n.store && _this2.i18n.store.off(f, _this2.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: 'onI18nChanged',
    value: function onI18nChanged() {
      if (!this.mounted) return;
      if (!this.state.ready && this.options.omitBoundRerender) return;

      this.t = this.getI18nTranslate();
      this.setState({ i18nLoadedAt: new Date() }); // rerender
    }
  }, {
    key: 'getI18nTranslate',
    value: function getI18nTranslate() {
      return this.i18n.getFixedT(null, this.options.nsMode === 'fallback' ? this.getNamespaces() : this.getNamespaces()[0]);
    }
  }, {
    key: 'getNamespaces',
    value: function getNamespaces() {
      var ns = this.props.ns || this.i18n.options && this.i18n.options.defaultNS;
      return typeof ns === 'string' ? [ns] : ns;
    }
  }, {
    key: 'loadNamespaces',
    value: function loadNamespaces() {
      var _this3 = this;

      var bind = function bind() {
        if (_this3.options.bindI18n && _this3.i18n) _this3.i18n.on(_this3.options.bindI18n, _this3.onI18nChanged);
        if (_this3.options.bindStore && _this3.i18n.store) _this3.i18n.store.on(_this3.options.bindStore, _this3.onI18nChanged);
      };

      this.mounted = true;
      this.i18n.loadNamespaces(this.getNamespaces(), function () {
        var ready = function ready() {
          if (_this3.mounted && !_this3.state.ready) _this3.setState({ ready: true });
          if (_this3.options.wait && _this3.mounted) bind();
        };

        if (_this3.i18n.isInitialized) {
          ready();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              _this3.i18n.off('initialized', initialized);
            }, 1000);
            ready();
          };

          _this3.i18n.on('initialized', initialized);
        }
      });

      if (!this.options.wait) bind();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var children = this.props.children;
      var ready = this.state.ready;


      if (!ready && this.options.wait) return null;

      // remove ssr flag set by provider - first render was done from now on wait if set to wait
      if (this.i18n.options && this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete _this4.i18n.options.isInitialSSR;
        }, 100);
      }

      return children(this.t, {
        i18n: this.i18n,
        t: this.t,
        lng: this.i18n.language,
        ready: ready
      });
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (I18n);


I18n.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

I18n.childContextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return METADATA_API_PING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pingMetadataApi; });
var METADATA_API_PING="METADATA_API_PING";var pingMetadataApi=function pingMetadataApi(label,baseUrl){return{type:METADATA_API_PING,label:label,baseUrl:baseUrl};};

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DM_BUILDER_DSD_LIST_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_dsd_detail_modal_reducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares_current_node_config_middleware__ = __webpack_require__(42);
var DM_BUILDER_DSD_LIST_PREFIX="DM_BUILDER_DSD_LIST_PREFIX_";var builderDsdListReducer=function builderDsdListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{dsds:null,isVisible:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* BUILDER_DSD_LIST_SHOW */]:{return Object.assign({},state,{isVisible:true});}case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* BUILDER_DSD_LIST_HIDE */]:{return Object.assign({},state,{isVisible:false});}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* BUILDER_DSD_LIST_DSDS_READ */]:return Object.assign({},state,{dsds:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* BUILDER_DSD_LIST_DSDS_READ */]:return Object.assign({},state,{isVisible:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* BUILDER_DSD_LIST_DSDS_READ */]:var dsds=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[];return Object.assign({},state,{dsds:dsds.map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_5__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});default:return state;}}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["b" /* reuseInReducer */])(builderDsdListReducer,{dsdListDsd:Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_dsd_detail_modal_reducer__["c" /* default */],DM_BUILDER_DSD_LIST_PREFIX)}));

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _rcCheckbox = _interopRequireDefault(__webpack_require__(385));

var _shallowequal = _interopRequireDefault(__webpack_require__(132));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));

    _this.saveCheckbox = function (node) {
      _this.rcCheckbox = node;
    };

    _this.renderCheckbox = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          props = _assertThisInitialize.props,
          context = _assertThisInitialize.context;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          children = props.children,
          indeterminate = props.indeterminate,
          style = props.style,
          onMouseEnter = props.onMouseEnter,
          onMouseLeave = props.onMouseLeave,
          restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);

      var checkboxGroup = context.checkboxGroup;
      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);

      var checkboxProps = _extends({}, restProps);

      if (checkboxGroup) {
        checkboxProps.onChange = function () {
          if (restProps.onChange) {
            restProps.onChange.apply(restProps, arguments);
          }

          checkboxGroup.toggleOption({
            label: children,
            value: props.value
          });
        };

        checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
        checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
      }

      var classString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames));
      var checkboxClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
      return React.createElement("label", {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, React.createElement(_rcCheckbox["default"], _extends({}, checkboxProps, {
        prefixCls: prefixCls,
        className: checkboxClass,
        ref: _this.saveCheckbox
      })), children !== undefined && React.createElement("span", null, children));
    };

    return _this;
  }

  _createClass(Checkbox, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.checkboxGroup, nextContext.checkboxGroup);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcCheckbox.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcCheckbox.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckbox);
    }
  }]);

  return Checkbox;
}(React.Component);

exports["default"] = Checkbox;
Checkbox.defaultProps = {
  indeterminate: false
};
Checkbox.contextTypes = {
  checkboxGroup: PropTypes.any
};

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(689);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Checkbox__["a" /* default */]);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(129) && !__webpack_require__(176)(function () {
  return Object.defineProperty(__webpack_require__(387)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(148);
var document = __webpack_require__(119).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(130);
var toIObject = __webpack_require__(149);
var arrayIndexOf = __webpack_require__(695)(false);
var IE_PROTO = __webpack_require__(280)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(277);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(279);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(699)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(392)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(209);
var $export = __webpack_require__(128);
var redefine = __webpack_require__(393);
var hide = __webpack_require__(146);
var Iterators = __webpack_require__(178);
var $iterCreate = __webpack_require__(700);
var setToStringTag = __webpack_require__(286);
var getPrototypeOf = __webpack_require__(703);
var ITERATOR = __webpack_require__(100)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(146);


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(388);
var hiddenKeys = __webpack_require__(282).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(211);
var createDesc = __webpack_require__(177);
var toIObject = __webpack_require__(149);
var toPrimitive = __webpack_require__(276);
var has = __webpack_require__(130);
var IE8_DOM_DEFINE = __webpack_require__(386);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(129) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(735);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(741), __esModule: true };

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(290)))

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Sentinel__ = __webpack_require__(400);













var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TabPane, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          id = _props.id,
          className = _props.className,
          destroyInactiveTabPane = _props.destroyInactiveTabPane,
          active = _props.active,
          forceRender = _props.forceRender,
          rootPrefixCls = _props.rootPrefixCls,
          style = _props.style,
          children = _props.children,
          placeholder = _props.placeholder,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);

      this._isActived = this._isActived || active;
      var prefixCls = rootPrefixCls + '-tabpane';
      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-inactive', !active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-active', active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, className), _classnames));
      var isRender = destroyInactiveTabPane ? active : this._isActived;
      var shouldRender = isRender || forceRender;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__Sentinel__["a" /* SentinelConsumer */],
        null,
        function (_ref) {
          var sentinelStart = _ref.sentinelStart,
              sentinelEnd = _ref.sentinelEnd,
              setPanelSentinelStart = _ref.setPanelSentinelStart,
              setPanelSentinelEnd = _ref.setPanelSentinelEnd;

          // Create sentinel
          var panelSentinelStart = void 0;
          var panelSentinelEnd = void 0;
          if (active && shouldRender) {
            panelSentinelStart = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["c" /* default */], {
              setRef: setPanelSentinelStart,
              prevElement: sentinelStart
            });
            panelSentinelEnd = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["c" /* default */], {
              setRef: setPanelSentinelEnd,
              nextElement: sentinelEnd
            });
          }

          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              style: style,
              role: 'tabpanel',
              'aria-hidden': active ? 'false' : 'true',
              className: cls,
              id: id
            }, Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getDataAttr */])(restProps)),
            panelSentinelStart,
            shouldRender ? children : placeholder,
            panelSentinelEnd
          );
        }
      );
    }
  }]);

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TabPane);


TabPane.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

TabPane.defaultProps = {
  placeholder: null
};

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SentinelProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentinelConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_context__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_create_react_context__);




/* eslint-disable jsx-a11y/no-noninteractive-tabindex */





var SentinelContext = __WEBPACK_IMPORTED_MODULE_7_create_react_context___default()({});
var SentinelProvider = SentinelContext.Provider;
var SentinelConsumer = SentinelContext.Consumer;

var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', position: 'absolute' };

var Sentinel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Sentinel, _React$Component);

  function Sentinel() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Sentinel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Sentinel.__proto__ || Object.getPrototypeOf(Sentinel)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (_ref2) {
      var target = _ref2.target,
          which = _ref2.which,
          shiftKey = _ref2.shiftKey;
      var _this$props = _this.props,
          nextElement = _this$props.nextElement,
          prevElement = _this$props.prevElement;

      if (which !== __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].TAB || document.activeElement !== target) return;

      // Tab next
      if (!shiftKey && nextElement) {
        nextElement.focus();
      }

      // Tab prev
      if (shiftKey && prevElement) {
        prevElement.focus();
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Sentinel, [{
    key: 'render',
    value: function render() {
      var setRef = this.props.setRef;


      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', {
        tabIndex: 0,
        ref: setRef,
        style: sentinelStyle,
        onKeyDown: this.onKeyDown,
        role: 'presentation'
      });
    }
  }]);

  return Sentinel;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Sentinel.propTypes = {
  setRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  prevElement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  nextElement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["c"] = (Sentinel);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(852);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a"]; });


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _configProvider = __webpack_require__(35);

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _RowContext = _interopRequireDefault(__webpack_require__(404));

var _type = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
var enquire;

if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  };

  window.matchMedia = window.matchMedia || matchMediaPolyfill;
  enquire = __webpack_require__(405);
}

var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom');
var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');
var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};

var Row =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Row, _React$Component);

  function Row() {
    var _this;

    _classCallCheck(this, Row);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Row).apply(this, arguments));
    _this.state = {
      screens: {}
    };

    _this.renderRow = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          justify = _a.justify,
          align = _a.align,
          className = _a.className,
          style = _a.style,
          children = _a.children,
          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);

      var prefixCls = getPrefixCls('row', customizePrefixCls);

      var gutter = _this.getGutter();

      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);
      var rowStyle = gutter > 0 ? _extends({
        marginLeft: gutter / -2,
        marginRight: gutter / -2
      }, style) : style;

      var otherProps = _extends({}, others);

      delete otherProps.gutter;
      return React.createElement(_RowContext["default"].Provider, {
        value: {
          gutter: gutter
        }
      }, React.createElement("div", _extends({}, otherProps, {
        className: classes,
        style: rowStyle
      }), children));
    };

    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Object.keys(responsiveMap).map(function (screen) {
        return enquire.register(responsiveMap[screen], {
          match: function match() {
            if (_typeof(_this2.props.gutter) !== 'object') {
              return;
            }

            _this2.setState(function (prevState) {
              return {
                screens: _extends({}, prevState.screens, _defineProperty({}, screen, true))
              };
            });
          },
          unmatch: function unmatch() {
            if (_typeof(_this2.props.gutter) !== 'object') {
              return;
            }

            _this2.setState(function (prevState) {
              return {
                screens: _extends({}, prevState.screens, _defineProperty({}, screen, false))
              };
            });
          },
          // Keep a empty destory to avoid triggering unmatch when unregister
          destroy: function destroy() {}
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Object.keys(responsiveMap).map(function (screen) {
        return enquire.unregister(responsiveMap[screen]);
      });
    }
  }, {
    key: "getGutter",
    value: function getGutter() {
      var gutter = this.props.gutter;

      if (_typeof(gutter) === 'object') {
        for (var i = 0; i < responsiveArray.length; i++) {
          var breakpoint = responsiveArray[i];

          if (this.state.screens[breakpoint] && gutter[breakpoint] !== undefined) {
            return gutter[breakpoint];
          }
        }
      }

      return gutter;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRow);
    }
  }]);

  return Row;
}(React.Component);

exports["default"] = Row;
Row.defaultProps = {
  gutter: 0
};
Row.propTypes = {
  type: PropTypes.oneOf(['flex']),
  align: PropTypes.oneOf(RowAligns),
  justify: PropTypes.oneOf(RowJustify),
  className: PropTypes.string,
  children: PropTypes.node,
  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  prefixCls: PropTypes.string
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(171));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RowContext = (0, _createReactContext["default"])({});
var _default = RowContext;
exports["default"] = _default;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(861);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 406 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _RowContext = _interopRequireDefault(__webpack_require__(404));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);

var Col =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _this;

    _classCallCheck(this, Col);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Col).apply(this, arguments));

    _this.renderCol = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var props = _this.props;

      var customizePrefixCls = props.prefixCls,
          span = props.span,
          order = props.order,
          offset = props.offset,
          push = props.push,
          pull = props.pull,
          className = props.className,
          children = props.children,
          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);

      var prefixCls = getPrefixCls('col', customizePrefixCls);
      var sizeClassObj = {};
      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
        var _extends2;

        var sizeProps = {};

        if (typeof props[size] === 'number') {
          sizeProps.span = props[size];
        } else if (_typeof(props[size]) === 'object') {
          sizeProps = props[size] || {};
        }

        delete others[size];
        sizeClassObj = _extends({}, sizeClassObj, (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
      });
      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
      return React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
        var gutter = _ref2.gutter;
        var style = others.style;

        if (gutter > 0) {
          style = _extends({
            paddingLeft: gutter / 2,
            paddingRight: gutter / 2
          }, style);
        }

        return React.createElement("div", _extends({}, others, {
          style: style,
          className: classes
        }), children);
      });
    };

    return _this;
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCol);
    }
  }]);

  return Col;
}(React.Component);

exports["default"] = Col;
Col.propTypes = {
  span: PropTypes.number,
  order: PropTypes.number,
  offset: PropTypes.number,
  push: PropTypes.number,
  pull: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
  xs: objectOrNumber,
  sm: objectOrNumber,
  md: objectOrNumber,
  lg: objectOrNumber,
  xl: objectOrNumber,
  xxl: objectOrNumber
};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Option; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var Option =
/*#__PURE__*/
function (_Component) {
  _inherits(Option, _Component);

  function Option() {
    _classCallCheck(this, Option);

    return _possibleConstructorReturn(this, _getPrototypeOf(Option).apply(this, arguments));
  }

  return Option;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);


Option.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"]])
};
Option.isSelectOption = true;

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }



function propsValueType() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var props = args[0],
      propName = args[1],
      componentName = args[2],
      rest = args.slice(3);
  var basicType = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"]]);
  var labelInValueShape = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
    key: basicType.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"]
  });

  if (props.labelInValue) {
    var validate = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](labelInValueShape), labelInValueShape]);
    var error = validate.apply(void 0, [props, propName, componentName].concat(_toConsumableArray(rest)));

    if (error) {
      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`, ") + "when you set `labelInValue` to `true`, `".concat(propName, "` should in ") + "shape of `{ key: string | number, label?: ReactNode }`.");
    }
  } else if ((props.mode === 'multiple' || props.mode === 'tags' || props.multiple || props.tags) && props[propName] === '') {
    return new Error("Invalid prop `".concat(propName, "` of type `string` supplied to `").concat(componentName, "`, ") + "expected `array` when `multiple` or `tags` is `true`.");
  } else {
    var _validate = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](basicType), basicType]);

    return _validate.apply(void 0, [props, propName, componentName].concat(_toConsumableArray(rest)));
  }

  return null;
}

var SelectPropTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  defaultActiveFirstOption: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  multiple: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  filterOption: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  showSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  allowClear: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  showArrow: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transitionName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  optionLabelProp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  optionFilterProp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  animation: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  choiceTransitionName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  open: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  defaultOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onFocus: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  onInputKeyDown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"],
  onDeselect: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  labelInValue: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  loading: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
  value: propsValueType,
  defaultValue: propsValueType,
  dropdownStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  maxTagTextLength: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  maxTagCount: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  maxTagPlaceholder: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["node"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]]),
  tokenSeparators: __WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
  getInputElement: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
  showAction: __WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
  clearIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  inputIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  removeIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"],
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["node"]]),
  dropdownRender: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
};
/* harmony default export */ __webpack_exports__["a"] = (SelectPropTypes);

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeShape = undefined;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  setState: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveKey;
/* unused harmony export saveRef */
/* unused harmony export SubPopupMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DOMWrap__ = __webpack_require__(879);














function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }
  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var _extends2;

  var state = store.getState();
  store.setState({
    activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.activeKey, (_extends2 = {}, _extends2[menuId] = activeKey, _extends2))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found = void 0;
    Object(__WEBPACK_IMPORTED_MODULE_11__util__["e" /* loopMenuItem */])(children, function (c, i) {
      if (c && !c.props.disabled && activeKey === Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i)) {
        found = true;
      }
    });
    if (found) {
      return activeKey;
    }
  }
  activeKey = null;
  if (props.defaultActiveFirst) {
    Object(__WEBPACK_IMPORTED_MODULE_11__util__["e" /* loopMenuItem */])(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i);
      }
    });
    return activeKey;
  }
  return activeKey;
}

function saveRef(c) {
  if (c) {
    var index = this.instanceArray.indexOf(c);
    if (index !== -1) {
      // update component if it's already inside instanceArray
      this.instanceArray[index] = c;
    } else {
      // add component if it's not in instanceArray yet;
      this.instanceArray.push(c);
    }
  }
}

var SubPopupMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SubPopupMenu, _React$Component);

  function SubPopupMenu(props) {
    var _extends3;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SubPopupMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    props.store.setState({
      activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props.store.getState().activeKey, (_extends3 = {}, _extends3[props.eventKey] = getActiveKey(props, props.activeKey), _extends3))
    });

    _this.instanceArray = [];
    return _this;
  }

  SubPopupMenu.prototype.componentDidMount = function componentDidMount() {
    // invoke customized ref to expose component to mixin
    if (this.props.manualRef) {
      this.props.manualRef(this);
    }
  };

  SubPopupMenu.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.visible || nextProps.visible;
  };

  SubPopupMenu.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var props = this.props;
    var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
    var activeKey = getActiveKey(props, originalActiveKey);
    if (activeKey !== originalActiveKey) {
      updateActiveKey(props.store, getEventKey(props), activeKey);
    } else if ('activeKey' in prevProps) {
      // If prev activeKey is not same as current activeKey,
      // we should set it.
      var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);
      if (activeKey !== prevActiveKey) {
        updateActiveKey(props.store, getEventKey(props), activeKey);
      }
    }
  };

  // all keyboard events callbacks run from here at first


  SubPopupMenu.prototype.render = function render() {
    var _this2 = this;

    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    this.instanceArray = [];
    var className = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(props.prefixCls, props.className, props.prefixCls + '-' + props.mode);
    var domProps = {
      className: className,
      // role could be 'select' and by default set to menu
      role: props.role || 'menu'
    };
    if (props.id) {
      domProps.id = props.id;
    }
    if (props.focusable) {
      domProps.tabIndex = '0';
      domProps.onKeyDown = this.onKeyDown;
    }
    var prefixCls = props.prefixCls,
        eventKey = props.eventKey,
        visible = props.visible,
        level = props.level,
        mode = props.mode,
        overflowedIndicator = props.overflowedIndicator,
        theme = props.theme;

    __WEBPACK_IMPORTED_MODULE_11__util__["g" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });

    // Otherwise, the propagated click event will trigger another onClick
    delete props.onClick;

    return (
      // ESLint is not smart enough to know that the type of `children` was checked.
      /* eslint-disable */
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__DOMWrap__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
          prefixCls: prefixCls,
          mode: mode,
          tag: 'ul',
          level: level,
          theme: theme,
          hiddenClassName: prefixCls + '-hidden',
          visible: visible,
          overflowedIndicator: overflowedIndicator
        }, domProps),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(props.children, function (c, i) {
          return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
        })
      )
      /*eslint-enable */

    );
  };

  return SubPopupMenu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
SubPopupMenu.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    setState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),

  // adding in refactor
  focusable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['click', 'hover']),
  inlineIndent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  itemIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  expandIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node])
};
SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */]
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onKeyDown = function (e, callback) {
    var keyCode = e.keyCode;
    var handled = void 0;
    _this3.getFlatInstanceArray().forEach(function (obj) {
      if (obj && obj.props.active && obj.onKeyDown) {
        handled = obj.onKeyDown(e);
      }
    });
    if (handled) {
      return 1;
    }
    var activeItem = null;
    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      activeItem = _this3.step(keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP ? -1 : 1);
    }
    if (activeItem) {
      e.preventDefault();
      updateActiveKey(_this3.props.store, getEventKey(_this3.props), activeItem.props.eventKey);

      if (typeof callback === 'function') {
        callback(activeItem);
      }

      return 1;
    }
  };

  this.onItemHover = function (e) {
    var key = e.key,
        hover = e.hover;

    updateActiveKey(_this3.props.store, getEventKey(_this3.props), hover ? key : null);
  };

  this.onDeselect = function (selectInfo) {
    _this3.props.onDeselect(selectInfo);
  };

  this.onSelect = function (selectInfo) {
    _this3.props.onSelect(selectInfo);
  };

  this.onClick = function (e) {
    _this3.props.onClick(e);
  };

  this.onOpenChange = function (e) {
    _this3.props.onOpenChange(e);
  };

  this.onDestroy = function (key) {
    /* istanbul ignore next */
    _this3.props.onDestroy(key);
  };

  this.getFlatInstanceArray = function () {
    return _this3.instanceArray;
  };

  this.getOpenTransitionName = function () {
    return _this3.props.openTransitionName;
  };

  this.step = function (direction) {
    var children = _this3.getFlatInstanceArray();
    var activeKey = _this3.props.store.getState().activeKey[getEventKey(_this3.props)];
    var len = children.length;
    if (!len) {
      return null;
    }
    if (direction < 0) {
      children = children.concat().reverse();
    }
    // find current activeIndex
    var activeIndex = -1;
    children.every(function (c, ci) {
      if (c && c.props.eventKey === activeKey) {
        activeIndex = ci;
        return false;
      }
      return true;
    });
    if (!_this3.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
      return undefined;
    }
    var start = (activeIndex + 1) % len;
    var i = start;

    do {
      var child = children[i];
      if (!child || child.props.disabled) {
        i = (i + 1) % len;
      } else {
        return child;
      }
    } while (i !== start);

    return null;
  };

  this.renderCommonMenuItem = function (child, i, extraProps) {
    var state = _this3.props.store.getState();
    var props = _this3.props;
    var key = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(child, props.eventKey, i);
    var childProps = child.props;
    var isActive = key === state.activeKey;
    var newChildProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
      mode: childProps.mode || props.mode,
      level: props.level,
      inlineIndent: props.inlineIndent,
      renderMenuItem: _this3.renderMenuItem,
      rootPrefixCls: props.prefixCls,
      index: i,
      parentMenu: props.parentMenu,
      // customized ref function, need to be invoked manually in child's componentDidMount
      manualRef: childProps.disabled ? undefined : Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__["a" /* default */])(child.ref, saveRef.bind(_this3)),
      eventKey: key,
      active: !childProps.disabled && isActive,
      multiple: props.multiple,
      onClick: function onClick(e) {
        (childProps.onClick || __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */])(e);
        _this3.onClick(e);
      },
      onItemHover: _this3.onItemHover,
      openTransitionName: _this3.getOpenTransitionName(),
      openAnimation: props.openAnimation,
      subMenuOpenDelay: props.subMenuOpenDelay,
      subMenuCloseDelay: props.subMenuCloseDelay,
      forceSubMenuRender: props.forceSubMenuRender,
      onOpenChange: _this3.onOpenChange,
      onDeselect: _this3.onDeselect,
      onSelect: _this3.onSelect,
      builtinPlacements: props.builtinPlacements,
      itemIcon: childProps.itemIcon || _this3.props.itemIcon,
      expandIcon: childProps.expandIcon || _this3.props.expandIcon
    }, extraProps);
    // ref: https://github.com/ant-design/ant-design/issues/13943
    if (props.mode === 'inline' || Object(__WEBPACK_IMPORTED_MODULE_11__util__["d" /* isMobileDevice */])()) {
      newChildProps.triggerSubMenuAction = 'click';
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, newChildProps);
  };

  this.renderMenuItem = function (c, i, subMenuKey) {
    /* istanbul ignore if */
    if (!c) {
      return null;
    }
    var state = _this3.props.store.getState();
    var extraProps = {
      openKeys: state.openKeys,
      selectedKeys: state.selectedKeys,
      triggerSubMenuAction: _this3.props.triggerSubMenuAction,
      subMenuKey: subMenuKey
    };
    return _this3.renderCommonMenuItem(c, i, extraProps);
  };
};

var connected = Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["connect"])()(SubPopupMenu);

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);
  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(93)))

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__placements__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rc_animate__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(152);
















var guid = 0;

var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var _extends2;

  var menuId = Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.defaultActiveFirst, (_extends2 = {}, _extends2[menuId] = defaultActiveFirst, _extends2))
  });
};

var SubMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SubMenu, _React$Component);

  function SubMenu(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SubMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var store = props.store;
    var eventKey = props.eventKey;
    var defaultActiveFirst = store.getState().defaultActiveFirst;

    _this.isRootMenu = false;

    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    updateDefaultActiveFirst(store, eventKey, value);
    return _this;
  }

  SubMenu.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate();
  };

  SubMenu.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var _props = this.props,
        mode = _props.mode,
        parentMenu = _props.parentMenu,
        manualRef = _props.manualRef;

    // invoke customized ref to expose component to mixin

    if (manualRef) {
      manualRef(this);
    }

    if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
      return;
    }

    this.minWidthTimeout = setTimeout(function () {
      return _this2.adjustWidth();
    }, 0);
  };

  SubMenu.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        onDestroy = _props2.onDestroy,
        eventKey = _props2.eventKey;

    if (onDestroy) {
      onDestroy(eventKey);
    }

    /* istanbul ignore if */
    if (this.minWidthTimeout) {
      clearTimeout(this.minWidthTimeout);
    }

    /* istanbul ignore if */
    if (this.mouseenterTimeout) {
      clearTimeout(this.mouseenterTimeout);
    }
  };

  SubMenu.prototype.renderChildren = function renderChildren(children) {
    var props = this.props;
    var baseProps = {
      mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
      visible: this.props.isOpen,
      level: props.level + 1,
      inlineIndent: props.inlineIndent,
      focusable: false,
      onClick: this.onSubMenuClick,
      onSelect: this.onSelect,
      onDeselect: this.onDeselect,
      onDestroy: this.onDestroy,
      selectedKeys: props.selectedKeys,
      eventKey: props.eventKey + '-menu-',
      openKeys: props.openKeys,
      openTransitionName: props.openTransitionName,
      openAnimation: props.openAnimation,
      onOpenChange: this.onOpenChange,
      subMenuOpenDelay: props.subMenuOpenDelay,
      parentMenu: this,
      subMenuCloseDelay: props.subMenuCloseDelay,
      forceSubMenuRender: props.forceSubMenuRender,
      triggerSubMenuAction: props.triggerSubMenuAction,
      builtinPlacements: props.builtinPlacements,
      defaultActiveFirst: props.store.getState().defaultActiveFirst[Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(props.eventKey)],
      multiple: props.multiple,
      prefixCls: props.rootPrefixCls,
      id: this._menuId,
      manualRef: this.saveMenuInstance,
      itemIcon: props.itemIcon,
      expandIcon: props.expandIcon
    };

    var haveRendered = this.haveRendered;
    this.haveRendered = true;

    this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender;
    // never rendered not planning to, don't render
    if (!this.haveOpened) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null);
    }

    // don't show transition on first rendering (no animation for opened menu)
    // show appear transition if it's not visible (not sure why)
    // show appear transition if it's not inline mode
    var transitionAppear = haveRendered || !baseProps.visible || !baseProps.mode === 'inline';

    baseProps.className = ' ' + baseProps.prefixCls + '-sub';
    var animProps = {};

    if (baseProps.openTransitionName) {
      animProps.transitionName = baseProps.openTransitionName;
    } else if (typeof baseProps.openAnimation === 'object') {
      animProps.animation = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps.openAnimation);
      if (!transitionAppear) {
        delete animProps.animation.appear;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_rc_animate__["default"],
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, animProps, {
        showProp: 'visible',
        component: '',
        transitionAppear: transitionAppear
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps, { id: this._menuId }),
        children
      )
    );
  };

  SubMenu.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);
    var isOpen = props.isOpen;
    var prefixCls = this.getPrefixCls();
    var isInlineMode = props.mode === 'inline';
    var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, prefixCls + '-' + props.mode, (_classNames = {}, _classNames[props.className] = !!props.className, _classNames[this.getOpenClassName()] = isOpen, _classNames[this.getActiveClassName()] = props.active || isOpen && !isInlineMode, _classNames[this.getDisabledClassName()] = props.disabled, _classNames[this.getSelectedClassName()] = this.isChildrenSelected(), _classNames));

    if (!this._menuId) {
      if (props.eventKey) {
        this._menuId = props.eventKey + '$Menu';
      } else {
        this._menuId = '$__$' + ++guid + '$Menu';
      }
    }

    var mouseEvents = {};
    var titleClickEvents = {};
    var titleMouseEvents = {};
    if (!props.disabled) {
      mouseEvents = {
        onMouseLeave: this.onMouseLeave,
        onMouseEnter: this.onMouseEnter
      };

      // only works in title, not outer li
      titleClickEvents = {
        onClick: this.onTitleClick
      };
      titleMouseEvents = {
        onMouseEnter: this.onTitleMouseEnter,
        onMouseLeave: this.onTitleMouseLeave
      };
    }

    var style = {};
    if (isInlineMode) {
      style.paddingLeft = props.inlineIndent * props.level;
    }

    var ariaOwns = {};
    // only set aria-owns when menu is open
    // otherwise it would be an invalid aria-owns value
    // since corresponding node cannot be found
    if (this.props.isOpen) {
      ariaOwns = {
        'aria-owns': this._menuId
      };
    }

    // expand custom icon should NOT be displayed in menu with horizontal mode.
    var icon = null;
    if (props.mode !== 'horizontal') {
      icon = this.props.expandIcon; // ReactNode
      if (typeof this.props.expandIcon === 'function') {
        icon = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(this.props.expandIcon, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props));
      }
    }

    var title = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
        ref: this.saveSubMenuTitle,
        style: style,
        className: prefixCls + '-title'
      }, titleMouseEvents, titleClickEvents, {
        'aria-expanded': isOpen
      }, ariaOwns, {
        'aria-haspopup': 'true',
        title: typeof props.title === 'string' ? props.title : undefined
      }),
      props.title,
      icon || __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i', { className: prefixCls + '-arrow' })
    );
    var children = this.renderChildren(props.children);

    var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
      return triggerNode.parentNode;
    };
    var popupPlacement = popupPlacementMap[props.mode];
    var popupAlign = props.popupOffset ? { offset: props.popupOffset } : {};
    var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
    var disabled = props.disabled,
        triggerSubMenuAction = props.triggerSubMenuAction,
        subMenuOpenDelay = props.subMenuOpenDelay,
        forceSubMenuRender = props.forceSubMenuRender,
        subMenuCloseDelay = props.subMenuCloseDelay,
        builtinPlacements = props.builtinPlacements;

    __WEBPACK_IMPORTED_MODULE_14__util__["g" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });
    // Set onClick to null, to ignore propagated onClick event
    delete props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, props, mouseEvents, {
        className: className,
        role: 'menuitem'
      }),
      isInlineMode && title,
      isInlineMode && children,
      !isInlineMode && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["default"],
        {
          prefixCls: prefixCls,
          popupClassName: prefixCls + '-popup ' + popupClassName,
          getPopupContainer: getPopupContainer,
          builtinPlacements: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__placements__["a" /* default */], builtinPlacements),
          popupPlacement: popupPlacement,
          popupVisible: isOpen,
          popupAlign: popupAlign,
          popup: children,
          action: disabled ? [] : [triggerSubMenuAction],
          mouseEnterDelay: subMenuOpenDelay,
          mouseLeaveDelay: subMenuCloseDelay,
          onPopupVisibleChange: this.onPopupVisibleChange,
          forceRender: forceSubMenuRender
        },
        title
      )
    );
  };

  return SubMenu;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SubMenu.propTypes = {
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // TODO: remove
  onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  popupOffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  itemIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  expandIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node])
};
SubMenu.defaultProps = {
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["h" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["h" /* noop */],
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["h" /* noop */],
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["h" /* noop */],
  onTitleClick: __WEBPACK_IMPORTED_MODULE_14__util__["h" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_14__util__["h" /* noop */],
  mode: 'vertical',
  title: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onDestroy = function (key) {
    _this3.props.onDestroy(key);
  };

  this.onKeyDown = function (e) {
    var keyCode = e.keyCode;
    var menu = _this3.menuInstance;
    var _props3 = _this3.props,
        isOpen = _props3.isOpen,
        store = _props3.store;


    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].ENTER) {
      _this3.onTitleClick(e);
      updateDefaultActiveFirst(store, _this3.props.eventKey, true);
      return true;
    }

    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
      if (isOpen) {
        menu.onKeyDown(e);
      } else {
        _this3.triggerOpenChange(true);
        // need to update current menu's defaultActiveFirst value
        updateDefaultActiveFirst(store, _this3.props.eventKey, true);
      }
      return true;
    }
    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].LEFT) {
      var handled = void 0;
      if (isOpen) {
        handled = menu.onKeyDown(e);
      } else {
        return undefined;
      }
      if (!handled) {
        _this3.triggerOpenChange(false);
        handled = true;
      }
      return handled;
    }

    if (isOpen && (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN)) {
      return menu.onKeyDown(e);
    }
  };

  this.onOpenChange = function (e) {
    _this3.props.onOpenChange(e);
  };

  this.onPopupVisibleChange = function (visible) {
    _this3.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
  };

  this.onMouseEnter = function (e) {
    var _props4 = _this3.props,
        key = _props4.eventKey,
        onMouseEnter = _props4.onMouseEnter,
        store = _props4.store;

    updateDefaultActiveFirst(store, _this3.props.eventKey, false);
    onMouseEnter({
      key: key,
      domEvent: e
    });
  };

  this.onMouseLeave = function (e) {
    var _props5 = _this3.props,
        parentMenu = _props5.parentMenu,
        eventKey = _props5.eventKey,
        onMouseLeave = _props5.onMouseLeave;

    parentMenu.subMenuInstance = _this3;
    onMouseLeave({
      key: eventKey,
      domEvent: e
    });
  };

  this.onTitleMouseEnter = function (domEvent) {
    var _props6 = _this3.props,
        key = _props6.eventKey,
        onItemHover = _props6.onItemHover,
        onTitleMouseEnter = _props6.onTitleMouseEnter;

    onItemHover({
      key: key,
      hover: true
    });
    onTitleMouseEnter({
      key: key,
      domEvent: domEvent
    });
  };

  this.onTitleMouseLeave = function (e) {
    var _props7 = _this3.props,
        parentMenu = _props7.parentMenu,
        eventKey = _props7.eventKey,
        onItemHover = _props7.onItemHover,
        onTitleMouseLeave = _props7.onTitleMouseLeave;

    parentMenu.subMenuInstance = _this3;
    onItemHover({
      key: eventKey,
      hover: false
    });
    onTitleMouseLeave({
      key: eventKey,
      domEvent: e
    });
  };

  this.onTitleClick = function (e) {
    var props = _this3.props;

    props.onTitleClick({
      key: props.eventKey,
      domEvent: e
    });
    if (props.triggerSubMenuAction === 'hover') {
      return;
    }
    _this3.triggerOpenChange(!props.isOpen, 'click');
    updateDefaultActiveFirst(props.store, _this3.props.eventKey, false);
  };

  this.onSubMenuClick = function (info) {
    // in the case of overflowed submenu
    // onClick is not copied over
    if (typeof _this3.props.onClick === 'function') {
      _this3.props.onClick(_this3.addKeyPath(info));
    }
  };

  this.onSelect = function (info) {
    _this3.props.onSelect(info);
  };

  this.onDeselect = function (info) {
    _this3.props.onDeselect(info);
  };

  this.getPrefixCls = function () {
    return _this3.props.rootPrefixCls + '-submenu';
  };

  this.getActiveClassName = function () {
    return _this3.getPrefixCls() + '-active';
  };

  this.getDisabledClassName = function () {
    return _this3.getPrefixCls() + '-disabled';
  };

  this.getSelectedClassName = function () {
    return _this3.getPrefixCls() + '-selected';
  };

  this.getOpenClassName = function () {
    return _this3.props.rootPrefixCls + '-submenu-open';
  };

  this.saveMenuInstance = function (c) {
    // children menu instance
    _this3.menuInstance = c;
  };

  this.addKeyPath = function (info) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, info, {
      keyPath: (info.keyPath || []).concat(_this3.props.eventKey)
    });
  };

  this.triggerOpenChange = function (open, type) {
    var key = _this3.props.eventKey;
    var openChange = function openChange() {
      _this3.onOpenChange({
        key: key,
        item: _this3,
        trigger: type,
        open: open
      });
    };
    if (type === 'mouseenter') {
      // make sure mouseenter happen after other menu item's mouseleave
      _this3.mouseenterTimeout = setTimeout(function () {
        openChange();
      }, 0);
    } else {
      openChange();
    }
  };

  this.isChildrenSelected = function () {
    var ret = { find: false };
    Object(__WEBPACK_IMPORTED_MODULE_14__util__["f" /* loopMenuItemRecursively */])(_this3.props.children, _this3.props.selectedKeys, ret);
    return ret.find;
  };

  this.isOpen = function () {
    return _this3.props.openKeys.indexOf(_this3.props.eventKey) !== -1;
  };

  this.adjustWidth = function () {
    /* istanbul ignore if */
    if (!_this3.subMenuTitle || !_this3.menuInstance) {
      return;
    }
    var popupMenu = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this3.menuInstance);
    if (popupMenu.offsetWidth >= _this3.subMenuTitle.offsetWidth) {
      return;
    }

    /* istanbul ignore next */
    popupMenu.style.minWidth = _this3.subMenuTitle.offsetWidth + 'px';
  };

  this.saveSubMenuTitle = function (subMenuTitle) {
    _this3.subMenuTitle = subMenuTitle;
  };
};

var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
  var openKeys = _ref.openKeys,
      activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);

connected.isSubMenu = true;

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ContainerRender = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ContainerRender, _React$Component);

  function ContainerRender() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContainerRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(_this.container);
        _this.container.parentNode.removeChild(_this.container);
        _this.container = null;
      }
    }, _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContainerRender, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerRender);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Portal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this._container);
      }
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjustForViewport__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getElFuturePos__ = __webpack_require__(888);
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */







// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n = void 0;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  // 当前节点可以被放置的显示区域
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__["a" /* default */])(source);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/ig, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/ig, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = Object(__WEBPACK_IMPORTED_MODULE_2__adjustForViewport__["a" /* default */])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'width', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'height', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });

  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}

/* harmony default export */ __webpack_exports__["a"] = (doAlign);
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__ = __webpack_require__(886);




/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(element);
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(el, 'overflow') !== 'visible') {
      var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__["a" /* default */])(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);

    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

/* harmony default export */ __webpack_exports__["a"] = (getVisibleRectForElement);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);


/**
 * 得到会导致元素显示不全的祖先元素
 */

function getOffsetParent(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = void 0;
  var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
  }

  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (getOffsetParent);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);


function getRegion(node) {
  var offset = void 0;
  var w = void 0;
  var h = void 0;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(node) && node.nodeType !== 9) {
    offset = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(node);
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerWidth(node);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerHeight(node);
  } else {
    var win = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindow(node);
    offset = {
      left: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win),
      top: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win)
    };
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/* harmony default export */ __webpack_exports__["a"] = (getRegion);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(296);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(299),
    isArguments = __webpack_require__(431),
    isArray = __webpack_require__(121),
    isIndex = __webpack_require__(304),
    isLength = __webpack_require__(305),
    toKey = __webpack_require__(183);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(180),
    isObject = __webpack_require__(150);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(943),
    isObjectLike = __webpack_require__(181);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(57);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(944);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(953);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _asyncValidator = __webpack_require__(957);

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

var _warning = __webpack_require__(435);

var _warning2 = _interopRequireDefault(_warning);

var _get = __webpack_require__(436);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(438);

var _set2 = _interopRequireDefault(_set);

var _createFieldsStore = __webpack_require__(983);

var _createFieldsStore2 = _interopRequireDefault(_createFieldsStore);

var _utils = __webpack_require__(306);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prefer-es6-class */
/* eslint-disable prefer-promise-reject-errors */

var DEFAULT_TRIGGER = 'onChange';

function createBaseForm() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validateMessages = option.validateMessages,
      onFieldsChange = option.onFieldsChange,
      onValuesChange = option.onValuesChange,
      _option$mapProps = option.mapProps,
      mapProps = _option$mapProps === undefined ? _utils.identity : _option$mapProps,
      mapPropsToFields = option.mapPropsToFields,
      fieldNameProp = option.fieldNameProp,
      fieldMetaProp = option.fieldMetaProp,
      fieldDataProp = option.fieldDataProp,
      _option$formPropName = option.formPropName,
      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
      formName = option.name,
      withRef = option.withRef;


  return function decorate(WrappedComponent) {
    var Form = (0, _createReactClass2['default'])({
      displayName: 'Form',

      mixins: mixins,

      getInitialState: function getInitialState() {
        var _this = this;

        var fields = mapPropsToFields && mapPropsToFields(this.props);
        this.fieldsStore = (0, _createFieldsStore2['default'])(fields || {});

        this.instances = {};
        this.cachedBind = {};
        this.clearedFieldMetaCache = {};

        this.renderFields = {};
        this.domFields = {};

        // HACK: https://github.com/ant-design/ant-design/issues/6406
        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
          _this[key] = function () {
            var _fieldsStore;

            if (false) {
              (0, _warning2['default'])(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
            }
            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
          };
        });

        return {
          submitting: false
        };
      },
      componentDidMount: function componentDidMount() {
        this.cleanUpUselessFields();
      },
      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (mapPropsToFields) {
          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
        }
      },
      componentDidUpdate: function componentDidUpdate() {
        this.cleanUpUselessFields();
      },
      onCollectCommon: function onCollectCommon(name, action, args) {
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta[action]) {
          fieldMeta[action].apply(fieldMeta, (0, _toConsumableArray3['default'])(args));
        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
          var _fieldMeta$originalPr;

          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, (0, _toConsumableArray3['default'])(args));
        }
        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, (0, _toConsumableArray3['default'])(args)) : _utils.getValueFromEvent.apply(undefined, (0, _toConsumableArray3['default'])(args));
        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
          var valuesAll = this.fieldsStore.getAllValues();
          var valuesAllSet = {};
          valuesAll[name] = value;
          Object.keys(valuesAll).forEach(function (key) {
            return (0, _set2['default'])(valuesAllSet, key, valuesAll[key]);
          });
          onValuesChange(this.props, (0, _set2['default'])({}, name, value), valuesAllSet);
        }
        var field = this.fieldsStore.getField(name);
        return { name: name, field: (0, _extends3['default'])({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
      },
      onCollect: function onCollect(name_, action) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        var _onCollectCommon = this.onCollectCommon(name_, action, args),
            name = _onCollectCommon.name,
            field = _onCollectCommon.field,
            fieldMeta = _onCollectCommon.fieldMeta;

        var validate = fieldMeta.validate;

        var newField = (0, _extends3['default'])({}, field, {
          dirty: (0, _utils.hasRules)(validate)
        });
        this.setFields((0, _defineProperty3['default'])({}, name, newField));
      },
      onCollectValidate: function onCollectValidate(name_, action) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
            field = _onCollectCommon2.field,
            fieldMeta = _onCollectCommon2.fieldMeta;

        var newField = (0, _extends3['default'])({}, field, {
          dirty: true
        });
        this.validateFieldsInternal([newField], {
          action: action,
          options: {
            firstFields: !!fieldMeta.validateFirst
          }
        });
      },
      getCacheBind: function getCacheBind(name, action, fn) {
        if (!this.cachedBind[name]) {
          this.cachedBind[name] = {};
        }
        var cache = this.cachedBind[name];
        if (!cache[action] || cache[action].oriFn !== fn) {
          cache[action] = {
            fn: fn.bind(this, name, action),
            oriFn: fn
          };
        }
        return cache[action].fn;
      },
      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
        var _this2 = this;

        var props = this.getFieldProps(name, fieldOption);
        return function (fieldElem) {
          // We should put field in record if it is rendered
          _this2.renderFields[name] = true;

          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
          var originalProps = fieldElem.props;
          if (false) {
            var valuePropName = fieldMeta.valuePropName;
            (0, _warning2['default'])(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
            (0, _warning2['default'])(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
          }
          fieldMeta.originalProps = originalProps;
          fieldMeta.ref = fieldElem.ref;
          return _react2['default'].cloneElement(fieldElem, (0, _extends3['default'])({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
        };
      },
      getFieldProps: function getFieldProps(name) {
        var _this3 = this;

        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!name) {
          throw new Error('Must call `getFieldProps` with valid name string!');
        }
        if (false) {
          (0, _warning2['default'])(this.fieldsStore.isValidNestedFieldName(name), 'One field name cannot be part of another, e.g. `a` and `a.b`.');
          (0, _warning2['default'])(!('exclusive' in usersFieldOption), '`option.exclusive` of `getFieldProps`|`getFieldDecorator` had been remove.');
        }

        delete this.clearedFieldMetaCache[name];

        var fieldOption = (0, _extends3['default'])({
          name: name,
          trigger: DEFAULT_TRIGGER,
          valuePropName: 'value',
          validate: []
        }, usersFieldOption);

        var rules = fieldOption.rules,
            trigger = fieldOption.trigger,
            _fieldOption$validate = fieldOption.validateTrigger,
            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
            validate = fieldOption.validate;


        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if ('initialValue' in fieldOption) {
          fieldMeta.initialValue = fieldOption.initialValue;
        }

        var inputProps = (0, _extends3['default'])({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
        });
        if (fieldNameProp) {
          inputProps[fieldNameProp] = formName ? formName + '_' + name : name;
        }

        var validateRules = (0, _utils.normalizeValidateRules)(validate, rules, validateTrigger);
        var validateTriggers = (0, _utils.getValidateTriggers)(validateRules);
        validateTriggers.forEach(function (action) {
          if (inputProps[action]) return;
          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
        });

        // make sure that the value will be collect
        if (trigger && validateTriggers.indexOf(trigger) === -1) {
          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
        }

        var meta = (0, _extends3['default'])({}, fieldMeta, fieldOption, {
          validate: validateRules
        });
        this.fieldsStore.setFieldMeta(name, meta);
        if (fieldMetaProp) {
          inputProps[fieldMetaProp] = meta;
        }

        if (fieldDataProp) {
          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
        }

        // This field is rendered, record it
        this.renderFields[name] = true;

        return inputProps;
      },
      getFieldInstance: function getFieldInstance(name) {
        return this.instances[name];
      },
      getRules: function getRules(fieldMeta, action) {
        var actionRules = fieldMeta.validate.filter(function (item) {
          return !action || item.trigger.indexOf(action) >= 0;
        }).map(function (item) {
          return item.rules;
        });
        return (0, _utils.flattenArray)(actionRules);
      },
      setFields: function setFields(maybeNestedFields, callback) {
        var _this4 = this;

        var fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
        this.fieldsStore.setFields(fields);
        if (onFieldsChange) {
          var changedFields = Object.keys(fields).reduce(function (acc, name) {
            return (0, _set2['default'])(acc, name, _this4.fieldsStore.getField(name));
          }, {});
          onFieldsChange(this.props, changedFields, this.fieldsStore.getNestedAllFields());
        }
        this.forceUpdate(callback);
      },
      setFieldsValue: function setFieldsValue(changedValues, callback) {
        var fieldsMeta = this.fieldsStore.fieldsMeta;

        var values = this.fieldsStore.flattenRegisteredFields(changedValues);
        var newFields = Object.keys(values).reduce(function (acc, name) {
          var isRegistered = fieldsMeta[name];
          if (false) {
            (0, _warning2['default'])(isRegistered, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
          }
          if (isRegistered) {
            var value = values[name];
            acc[name] = {
              value: value
            };
          }
          return acc;
        }, {});
        this.setFields(newFields, callback);
        if (onValuesChange) {
          var allValues = this.fieldsStore.getAllValues();
          onValuesChange(this.props, changedValues, allValues);
        }
      },
      saveRef: function saveRef(name, _, component) {
        if (!component) {
          var _fieldMeta = this.fieldsStore.getFieldMeta(name);
          if (!_fieldMeta.preserve) {
            // after destroy, delete data
            this.clearedFieldMetaCache[name] = {
              field: this.fieldsStore.getField(name),
              meta: _fieldMeta
            };
            this.clearField(name);
          }
          delete this.domFields[name];
          return;
        }
        this.domFields[name] = true;
        this.recoverClearedField(name);
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta) {
          var ref = fieldMeta.ref;
          if (ref) {
            if (typeof ref === 'string') {
              throw new Error('can not set ref string for ' + name);
            } else if (typeof ref === 'function') {
              ref(component);
            } else if (Object.prototype.hasOwnProperty.call(ref, 'current')) {
              ref.current = component;
            }
          }
        }
        this.instances[name] = component;
      },
      cleanUpUselessFields: function cleanUpUselessFields() {
        var _this5 = this;

        var fieldList = this.fieldsStore.getAllFieldsName();
        var removedList = fieldList.filter(function (field) {
          var fieldMeta = _this5.fieldsStore.getFieldMeta(field);
          return !_this5.renderFields[field] && !_this5.domFields[field] && !fieldMeta.preserve;
        });
        if (removedList.length) {
          removedList.forEach(this.clearField);
        }
        this.renderFields = {};
      },
      clearField: function clearField(name) {
        this.fieldsStore.clearField(name);
        delete this.instances[name];
        delete this.cachedBind[name];
      },
      resetFields: function resetFields(ns) {
        var _this6 = this;

        var newFields = this.fieldsStore.resetFields(ns);
        if (Object.keys(newFields).length > 0) {
          this.setFields(newFields);
        }
        if (ns) {
          var names = Array.isArray(ns) ? ns : [ns];
          names.forEach(function (name) {
            return delete _this6.clearedFieldMetaCache[name];
          });
        } else {
          this.clearedFieldMetaCache = {};
        }
      },
      recoverClearedField: function recoverClearedField(name) {
        if (this.clearedFieldMetaCache[name]) {
          this.fieldsStore.setFields((0, _defineProperty3['default'])({}, name, this.clearedFieldMetaCache[name].field));
          this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
          delete this.clearedFieldMetaCache[name];
        }
      },
      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
        var _this7 = this;

        var fieldNames = _ref.fieldNames,
            action = _ref.action,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options;

        var allRules = {};
        var allValues = {};
        var allFields = {};
        var alreadyErrors = {};
        fields.forEach(function (field) {
          var name = field.name;
          if (options.force !== true && field.dirty === false) {
            if (field.errors) {
              (0, _set2['default'])(alreadyErrors, name, { errors: field.errors });
            }
            return;
          }
          var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
          var newField = (0, _extends3['default'])({}, field);
          newField.errors = undefined;
          newField.validating = true;
          newField.dirty = true;
          allRules[name] = _this7.getRules(fieldMeta, action);
          allValues[name] = newField.value;
          allFields[name] = newField;
        });
        this.setFields(allFields);
        // in case normalize
        Object.keys(allValues).forEach(function (f) {
          allValues[f] = _this7.fieldsStore.getFieldValue(f);
        });
        if (callback && (0, _utils.isEmptyObject)(allFields)) {
          callback((0, _utils.isEmptyObject)(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(fieldNames));
          return;
        }
        var validator = new _asyncValidator2['default'](allRules);
        if (validateMessages) {
          validator.messages(validateMessages);
        }
        validator.validate(allValues, options, function (errors) {
          var errorsGroup = (0, _extends3['default'])({}, alreadyErrors);
          if (errors && errors.length) {
            errors.forEach(function (e) {
              var fieldName = e.field;
              var field = (0, _get2['default'])(errorsGroup, fieldName);
              if (typeof field !== 'object' || Array.isArray(field)) {
                (0, _set2['default'])(errorsGroup, fieldName, { errors: [] });
              }
              var fieldErrors = (0, _get2['default'])(errorsGroup, fieldName.concat('.errors'));
              fieldErrors.push(e);
            });
          }
          var expired = [];
          var nowAllFields = {};
          Object.keys(allRules).forEach(function (name) {
            var fieldErrors = (0, _get2['default'])(errorsGroup, name);
            var nowField = _this7.fieldsStore.getField(name);
            // avoid concurrency problems
            if (nowField.value !== allValues[name]) {
              expired.push({
                name: name
              });
            } else {
              nowField.errors = fieldErrors && fieldErrors.errors;
              nowField.value = allValues[name];
              nowField.validating = false;
              nowField.dirty = false;
              nowAllFields[name] = nowField;
            }
          });
          _this7.setFields(nowAllFields);
          if (callback) {
            if (expired.length) {
              expired.forEach(function (_ref2) {
                var name = _ref2.name;

                var fieldErrors = [{
                  message: name + ' need to revalidate',
                  field: name
                }];
                (0, _set2['default'])(errorsGroup, name, {
                  expired: true,
                  errors: fieldErrors
                });
              });
            }

            callback((0, _utils.isEmptyObject)(errorsGroup) ? null : errorsGroup, _this7.fieldsStore.getFieldsValue(fieldNames));
          }
        });
      },
      validateFields: function validateFields(ns, opt, cb) {
        var _this8 = this;

        var pending = new Promise(function (resolve, reject) {
          var _getParams = (0, _utils.getParams)(ns, opt, cb),
              names = _getParams.names,
              options = _getParams.options;

          var _getParams2 = (0, _utils.getParams)(ns, opt, cb),
              callback = _getParams2.callback;

          if (!callback || typeof callback === 'function') {
            var oldCb = callback;
            callback = function callback(errors, values) {
              if (oldCb) {
                oldCb(errors, values);
              } else if (errors) {
                reject({ errors: errors, values: values });
              } else {
                resolve(values);
              }
            };
          }
          var fieldNames = names ? _this8.fieldsStore.getValidFieldsFullName(names) : _this8.fieldsStore.getValidFieldsName();
          var fields = fieldNames.filter(function (name) {
            var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
            return (0, _utils.hasRules)(fieldMeta.validate);
          }).map(function (name) {
            var field = _this8.fieldsStore.getField(name);
            field.value = _this8.fieldsStore.getFieldValue(name);
            return field;
          });
          if (!fields.length) {
            if (callback) {
              callback(null, _this8.fieldsStore.getFieldsValue(fieldNames));
            }
            return;
          }
          if (!('firstFields' in options)) {
            options.firstFields = fieldNames.filter(function (name) {
              var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
              return !!fieldMeta.validateFirst;
            });
          }
          _this8.validateFieldsInternal(fields, {
            fieldNames: fieldNames,
            options: options
          }, callback);
        });
        pending['catch'](function (e) {
          if (console.error) {
            // eslint-disable-line
            console.error(e); // eslint-disable-line
          }
          return e;
        });
        return pending;
      },
      isSubmitting: function isSubmitting() {
        if (false) {
          (0, _warning2['default'])(false, '`isSubmitting` is deprecated. ' + 'Actually, it\'s more convenient to handle submitting status by yourself.');
        }
        return this.state.submitting;
      },
      submit: function submit(callback) {
        var _this9 = this;

        if (false) {
          (0, _warning2['default'])(false, '`submit` is deprecated.' + 'Actually, it\'s more convenient to handle submitting status by yourself.');
        }
        var fn = function fn() {
          _this9.setState({
            submitting: false
          });
        };
        this.setState({
          submitting: true
        });
        callback(fn);
      },
      render: function render() {
        var _props = this.props,
            wrappedComponentRef = _props.wrappedComponentRef,
            restProps = (0, _objectWithoutProperties3['default'])(_props, ['wrappedComponentRef']); // eslint-disable-line

        var formProps = (0, _defineProperty3['default'])({}, formPropName, this.getForm());
        if (withRef) {
          if (false) {
            (0, _warning2['default'])(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
          }
          formProps.ref = 'wrappedComponent';
        } else if (wrappedComponentRef) {
          formProps.ref = wrappedComponentRef;
        }
        var props = mapProps.call(this, (0, _extends3['default'])({}, formProps, restProps));
        return _react2['default'].createElement(WrappedComponent, props);
      }
    });

    return (0, _utils.argumentContainer)(Form, WrappedComponent);
  };
}

exports['default'] = createBaseForm;
module.exports = exports['default'];

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(945), __esModule: true };

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(64);


/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || __WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */](value, type || rule.type))) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.required, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(437);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(299),
    toKey = __webpack_require__(183);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(979);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

exports.isFormField = isFormField;
exports["default"] = createFormField;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Field = function Field(fields) {
  (0, _classCallCheck3["default"])(this, Field);

  (0, _extends3["default"])(this, fields);
};

function isFormField(obj) {
  return obj instanceof Field;
}

function createFormField(field) {
  if (isFormField(field)) {
    return field;
  }
  return new Field(field);
}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FIELD_DATA_PROP = exports.FIELD_META_PROP = void 0;
var FIELD_META_PROP = 'data-__meta';
exports.FIELD_META_PROP = FIELD_META_PROP;
var FIELD_DATA_PROP = 'data-__field';
exports.FIELD_DATA_PROP = FIELD_DATA_PROP;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.destroyFns = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDialog = _interopRequireDefault(__webpack_require__(987));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _addEventListener = _interopRequireDefault(__webpack_require__(289));

var _locale = __webpack_require__(442);

var _icon = _interopRequireDefault(__webpack_require__(25));

var _button = _interopRequireDefault(__webpack_require__(7));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(142));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var mousePosition;
var mousePositionEventBinded;
var destroyFns = [];
exports.destroyFns = destroyFns;

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));

    _this.handleCancel = function (e) {
      var onCancel = _this.props.onCancel;

      if (onCancel) {
        onCancel(e);
      }
    };

    _this.handleOk = function (e) {
      var onOk = _this.props.onOk;

      if (onOk) {
        onOk(e);
      }
    };

    _this.renderFooter = function (locale) {
      var _this$props = _this.props,
          okText = _this$props.okText,
          okType = _this$props.okType,
          cancelText = _this$props.cancelText,
          confirmLoading = _this$props.confirmLoading;
      return React.createElement("div", null, React.createElement(_button["default"], _extends({
        onClick: _this.handleCancel
      }, _this.props.cancelButtonProps), cancelText || locale.cancelText), React.createElement(_button["default"], _extends({
        type: okType,
        loading: confirmLoading,
        onClick: _this.handleOk
      }, _this.props.okButtonProps), okText || locale.okText));
    };

    _this.renderModal = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          footer = _a.footer,
          visible = _a.visible,
          wrapClassName = _a.wrapClassName,
          centered = _a.centered,
          restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered"]);

      var prefixCls = getPrefixCls('modal', customizePrefixCls);
      var defaultFooter = React.createElement(_LocaleReceiver["default"], {
        componentName: "Modal",
        defaultLocale: (0, _locale.getConfirmLocale)()
      }, _this.renderFooter);
      var closeIcon = React.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
      }, React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-close-icon"),
        type: 'close'
      }));
      return React.createElement(_rcDialog["default"], _extends({}, restProps, {
        prefixCls: prefixCls,
        wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
        footer: footer === undefined ? defaultFooter : footer,
        visible: visible,
        mousePosition: mousePosition,
        onClose: _this.handleCancel,
        closeIcon: closeIcon
      }));
    };

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (mousePositionEventBinded) {
        return;
      } // 只有点击事件支持从鼠标位置动画展开


      (0, _addEventListener["default"])(document.documentElement, 'click', function (e) {
        mousePosition = {
          x: e.pageX,
          y: e.pageY
        }; // 100ms 内发生过点击事件，则从点击位置动画展示
        // 否则直接 zoom 展示
        // 这样可以兼容非点击方式展开

        setTimeout(function () {
          return mousePosition = null;
        }, 100);
      });
      mousePositionEventBinded = true;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderModal);
    }
  }]);

  return Modal;
}(React.Component);

exports["default"] = Modal;
Modal.defaultProps = {
  width: 520,
  transitionName: 'zoom',
  maskTransitionName: 'fade',
  confirmLoading: false,
  visible: false,
  okType: 'primary',
  okButtonDisabled: false,
  cancelButtonDisabled: false
};
Modal.propTypes = {
  prefixCls: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  centered: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  confirmLoading: PropTypes.bool,
  visible: PropTypes.bool,
  align: PropTypes.object,
  footer: PropTypes.node,
  title: PropTypes.node,
  closable: PropTypes.bool
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeConfirmLocale = changeConfirmLocale;
exports.getConfirmLocale = getConfirmLocale;

var _default = _interopRequireDefault(__webpack_require__(263));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var runtimeLocale = _extends({}, _default["default"].Modal);

function changeConfirmLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = _extends({}, runtimeLocale, newLocale);
  } else {
    runtimeLocale = _extends({}, _default["default"].Modal);
  }
}

function getConfirmLocale() {
  return runtimeLocale;
}

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var derivedItemSchemeReducer=function derivedItemSchemeReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{derivedItemScheme:null,derivedItemSchemeItems:null,derivedItemSchemeItemsTree:null,derivedItemSchemeItemsTreeMaxDepth:null,importCheckbox:{preserveHierarchy:true,importParents:true,importChildren:false,importDescendants:false},isCreateVisible:false,selectedSourceItems:null,selectedTargetItems:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* DERIVED_ITEM_SCHEME_ITEM_SELECT */]:{return Object.assign({},state,{selectedSourceItems:action.isSource?action.selectedArr:state.selectedSourceItems,selectedTargetItems:!action.isSource?action.selectedArr:state.selectedTargetItems});}case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* DERIVED_ITEM_SCHEME_ITEMS_ADD */]:{var oldItems=state.derivedItemSchemeItems||[];// create array of new items from itemTree
var itemsToAdd=Object(__WEBPACK_IMPORTED_MODULE_1__utils_tree__["l" /* getNodes */])(action.itemTree,action.childrenKey,function(node){return state.selectedSourceItems.includes(node.id);});if(action.forcePreserveHierarchy||state.importCheckbox.preserveHierarchy){var relatedItemsToAdd=[];if(!action.forcePreserveHierarchy){if(state.importCheckbox.importParents){itemsToAdd.forEach(function(child){var importParent=function importParent(node){if(node.parent){// get parent node
var parent=Object(__WEBPACK_IMPORTED_MODULE_1__utils_tree__["k" /* getNode */])(action.itemTree,action.childrenKey,function(_ref){var id=_ref.id;return id===node.parent;});if([].concat(_toConsumableArray(oldItems),_toConsumableArray(itemsToAdd),relatedItemsToAdd).find(function(alreadyAdded){return alreadyAdded.id===parent.id;})===undefined){// parent wasn't already added
relatedItemsToAdd.push(parent);}// recursively add parents
importParent(parent);}};importParent(child);});}if(state.importCheckbox.importChildren){itemsToAdd.forEach(function(par){return(par[action.childrenKey]||[]).forEach(function(child){var oldItem=oldItems.find(function(oldItem){return oldItem.id===child.id;});if(oldItem){// child already exists in oldItems
oldItem.parent=par.id;}else if([].concat(_toConsumableArray(itemsToAdd),relatedItemsToAdd).find(function(el){return el.id===child.id;})===undefined){// add children if not already exist
relatedItemsToAdd.push(child);}});});}if(state.importCheckbox.importDescendants){itemsToAdd.forEach(function(root){return relatedItemsToAdd.push.apply(relatedItemsToAdd,_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_1__utils_tree__["l" /* getNodes */])([root],action.childrenKey,function(node){return[].concat(_toConsumableArray(oldItems),_toConsumableArray(itemsToAdd),relatedItemsToAdd).find(function(_ref2){var id=_ref2.id;return id===node.id;})===undefined;})));});}}itemsToAdd=[].concat(_toConsumableArray(itemsToAdd),relatedItemsToAdd);// bring to root new items that will not have original parent in the new array
itemsToAdd=itemsToAdd.map(function(item){return Object.assign({},item,{parent:[].concat(_toConsumableArray(oldItems),_toConsumableArray(itemsToAdd)).find(function(parent){return parent.id===item.parent;})?item.parent:null});});}else{// bring to root any new item
itemsToAdd=itemsToAdd.map(function(item){return Object.assign({},item,{parent:null});});}// create array of items
var _newDerivedItemSchemeItems=[].concat(_toConsumableArray(oldItems),_toConsumableArray(itemsToAdd));// create tree from array of items
var _newDerivedItemSchemeItemsTree=Object(__WEBPACK_IMPORTED_MODULE_1__utils_tree__["h" /* getMappedTree */])(_newDerivedItemSchemeItems.filter(function(_ref3){var parent=_ref3.parent;return!parent;}),action.childrenKey,function(node){return Object.assign({},node,_defineProperty({},action.childrenKey,_newDerivedItemSchemeItems.filter(function(item){return item.parent===node.id;})));});return Object.assign({},state,{derivedItemSchemeItems:_newDerivedItemSchemeItems,derivedItemSchemeItemsTree:_newDerivedItemSchemeItemsTree,derivedItemSchemeItemsTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_1__utils_tree__["j" /* getMaxTreeDepth */])(_newDerivedItemSchemeItemsTree,action.childrenKey),selectedSourceItems:null});}case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* DERIVED_ITEM_SCHEME_ITEMS_REMOVE */]:// remove items from array
var newDerivedItemSchemeItems=state.derivedItemSchemeItems.filter(function(_ref4){var id=_ref4.id;return!action.items.includes(id);});// create tree from array of items
var newDerivedItemSchemeItemsTree=Object(__WEBPACK_IMPORTED_MODULE_1__utils_tree__["h" /* getMappedTree */])(newDerivedItemSchemeItems.filter(function(_ref5){var parent=_ref5.parent;return!parent;}),action.childrenKey,function(node){return Object.assign({},node,_defineProperty({},action.childrenKey,newDerivedItemSchemeItems.filter(function(item){return item.parent===node.id;})));});return Object.assign({},state,{derivedItemSchemeItems:newDerivedItemSchemeItems,derivedItemSchemeItemsTree:newDerivedItemSchemeItemsTree,derivedItemSchemeItemsTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_1__utils_tree__["j" /* getMaxTreeDepth */])(newDerivedItemSchemeItemsTree,action.childrenKey),selectedTargetItems:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DERIVED_ITEM_SCHEME_CHECKBOX_CHANGE */]:return Object.assign({},state,{importCheckbox:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(state.importCheckbox,action.checkbox)});case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* DERIVED_ITEM_SCHEME_CREATE_SHOW */]:return Object.assign({},state,{isCreateVisible:true,derivedItemScheme:{id:null,agencyID:null,version:null,name:null}});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* DERIVED_ITEM_SCHEME_CREATE_HIDE */]:return Object.assign({},state,{isCreateVisible:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DERIVED_ITEM_SCHEME_CREATE_CHANGE */]:var derivedItemScheme=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.derivedItemScheme);return Object.assign({},state,{derivedItemScheme:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(derivedItemScheme,action.fields)});case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* DERIVED_ITEM_SCHEME_STATE_RESET */]:return Object.assign({},state,{derivedItemScheme:null,derivedItemSchemeItems:null,derivedItemSchemeItemsTree:null,derivedItemSchemeItemsTreeMaxDepth:null,importCheckbox:{preserveHierarchy:true,importParents:true,importChildren:false,importDescendants:false},isCreateVisible:false,selectedSourceItems:null,selectedTargetItems:null});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (derivedItemSchemeReducer);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DM_BUILDER_CUBE_FORM_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dsd_control_reducer__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_control_reducer__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dsd_control_actions__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_components_redux_dsd_detail_modal_reducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cube_tree_actions__ = __webpack_require__(308);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DM_BUILDER_CUBE_FORM_PREFIX="DM_BUILDER_CUBE_FORM_PREFIX_";var builderCubeFormReducer=Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])({dsdControl:__WEBPACK_IMPORTED_MODULE_3__dsd_control_reducer__["b" /* default */],componentsControl:__WEBPACK_IMPORTED_MODULE_4__components_control_reducer__["b" /* default */]}),shared:Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["b" /* reuseInReducer */])(function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{cube:null,dsd:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_11__cube_tree_actions__["e" /* BUILDER_CUBE_TREE_CUBE_CREATE */]:return Object.assign({},state,{cube:{Code:null,IDCat:action.cubeCategoryId,labels:null,DSDCode:null,observedValueCanBeAlphanumeric:false,cubeComponents:null}});case __WEBPACK_IMPORTED_MODULE_6__dsd_control_actions__["d" /* BUILDER_CUBE_FORM_DSD_CONTROL_DSD_SET */]:return Object.assign({},state,{cube:Object.assign({},state.cube,{DSDCode:Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.dsdTriplet)})});case __WEBPACK_IMPORTED_MODULE_6__dsd_control_actions__["e" /* BUILDER_CUBE_FORM_DSD_CONTROL_DSD_UNSET */]:return Object.assign({},state,{cube:Object.assign({},state.cube,{DSDCode:null,cubeComponents:null})});case __WEBPACK_IMPORTED_MODULE_11__cube_tree_actions__["g" /* BUILDER_CUBE_TREE_CUBE_SELECT */]:if(state.cube===null||action.cubeId!==state.cube.IDCube){return Object.assign({},state,{cube:null,dsd:null});}else{return state;}case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* BUILDER_CUBE_FORM_CHANGE */]:return Object.assign({},state,{cube:Object.assign({},state.cube,action.fields)});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* BUILDER_CUBE_FORM_CUBE_READ */]:return Object.assign({},state,{cube:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* BUILDER_CUBE_FORM_DSD_READ */]:return Object.assign({},state,{dsd:null});default:return state;case __WEBPACK_IMPORTED_MODULE_11__cube_tree_actions__["a" /* BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{cube:null});}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* BUILDER_CUBE_FORM_DSD_READ */]:return Object.assign({},state,{cube:Object.assign({},state.cube,{DSDCode:null})});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* BUILDER_CUBE_FORM_CUBE_READ */]:return Object.assign({},state,{cube:Object.assign({},action.response,{observedValueCanBeAlphanumeric:action.response.Measures[0].IsAlphanumeric,cubeComponents:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* BUILDER_CUBE_FORM_DSD_READ */]:if(state.cube!==null){var dsd=Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["R" /* getDsdFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);if(dsd.dataStructureComponents.dimensionList.timeDimensions===undefined){dsd.dataStructureComponents.dimensionList.timeDimensions=[];}var getCubeComponents=function getCubeComponents(cube,dsd){return{dimensions:[].concat(_toConsumableArray(dsd.dataStructureComponents.dimensionList.dimensions.filter(function(dsdAttr){return cube===null||cube.Dimensions.filter(function(cubeAttr){return cubeAttr.Code===dsdAttr.id;}).length>0;}).map(function(dim){return Object.assign({},dim,{Code:dim.id});})),_toConsumableArray((dsd.dataStructureComponents.dimensionList.measureDimensions||[]).filter(function(dsdAttr){return cube===null||cube.Dimensions.filter(function(cubeAttr){return cubeAttr.Code===dsdAttr.id;}).length>0;}).map(function(dim){return Object.assign({},dim,{Code:dim.id});}))),timeDimensions:dsd.dataStructureComponents.dimensionList.timeDimensions.filter(function(dsdAttr){return cube===null||cube.Dimensions.filter(function(cubeAttr){return cubeAttr.Code===dsdAttr.id;}).length>0;}).map(function(dim){return Object.assign({},dim,{Code:dim.id});}),tidAttributes:cube===null?[{Code:'TID'}]:cube.Attributes.filter(function(attr){return attr.IsTid;}),attributes:dsd.dataStructureComponents.attributeList?dsd.dataStructureComponents.attributeList.attributes.filter(function(dsdAttr){return cube===null||cube.Attributes.filter(function(cubeAttr){return cubeAttr.Code===dsdAttr.id;}).length>0;}).map(function(attr){return Object.assign({},attr,{Code:attr.id,otherGroupDimensions:attr.attributeRelationship&&attr.attributeRelationship.attachmentGroups&&attr.attributeRelationship.attachmentGroups[0]&&dsd.dataStructureComponents.groups&&dsd.dataStructureComponents.groups.find(function(_ref){var id=_ref.id;return id===attr.attributeRelationship.attachmentGroups[0];})?dsd.dataStructureComponents.groups.find(function(_ref2){var id=_ref2.id;return id===attr.attributeRelationship.attachmentGroups[0];}).groupDimensions.filter(function(id){return id!==attr.id;}):null});}):[],measures:[dsd.dataStructureComponents.measureList.primaryMeasure].map(function(meas){return Object.assign({},meas,{Code:meas.id});})};};return Object.assign({},state,{dsd:dsd,cube:Object.assign({},state.cube,{cubeComponents:__WEBPACK_IMPORTED_MODULE_5_lodash___default()(getCubeComponents(state.cube.IDCube!==undefined?state.cube:null,dsd)).mapValues(function(compArr){return compArr.map(function(comp){return Object.assign({},comp,{checked:(!comp.Code||comp.Code!=='TID')&&(comp.assignmentStatus===undefined||comp.assignmentStatus==='Mandatory'),disabled:(!comp.Code||comp.Code!=='TID')&&(comp.assignmentStatus===undefined||comp.assignmentStatus==='Mandatory')});});}).value()})});}else{return state;}case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* BUILDER_CUBE_FORM_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_11__cube_tree_actions__["f" /* BUILDER_CUBE_TREE_CUBE_DELETE */]:return Object.assign({},state,{cube:null,dsd:null});default:return state;}}default:return state;}},{cubeFormDsd:Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_9__redux_components_redux_dsd_detail_modal_reducer__["c" /* default */],DM_BUILDER_CUBE_FORM_PREFIX)})});/* harmony default export */ __webpack_exports__["b"] = (builderCubeFormReducer);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DM_BUILDER_CUBE_FORM_DSD_CONTROL_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_dsd_detail_modal_reducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares_current_node_config_middleware__ = __webpack_require__(42);
var DM_BUILDER_CUBE_FORM_DSD_CONTROL_PREFIX="DM_BUILDER_CUBE_FORM_DSD_CONTROL_PREFIX_";var builderCubeFormDsdControlReducer=function builderCubeFormDsdControlReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{dsds:null,isDsdsVisible:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_SHOW */]:return Object.assign({},state,{isDsdsVisible:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_HIDE */]:return Object.assign({},state,{isDsdsVisible:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* BUILDER_CUBE_FORM_DSD_CONTROL_DSD_SET */]:return Object.assign({},state,{isDsdsVisible:false});case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["g" /* REQUEST_START */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_READ */]:return Object.assign({},state,{dsds:null});default:return state;}}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["b" /* REQUEST_ERROR */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_READ */]:{return Object.assign({},state,{isDsdsVisible:false});}default:return state;}}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* BUILDER_CUBE_FORM_DSD_CONTROL_DSDS_READ */]:return Object.assign({},state,{dsds:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_5__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});default:return state;}}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["b" /* reuseInReducer */])(builderCubeFormDsdControlReducer,{cubeFormDsdControlDsd:Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_dsd_detail_modal_reducer__["c" /* default */],DM_BUILDER_CUBE_FORM_DSD_CONTROL_PREFIX)}));

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DM_BUILDER_CUBE_FORM_COMPONENT_CONTROL_CODELIST_DETAIL_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_components_redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
var DM_BUILDER_CUBE_FORM_COMPONENT_CONTROL_CODELIST_DETAIL_PREFIX="DM_BUILDER_CUBE_FORM_COMPONENT_CONTROL_CODELIST_DETAIL_PREFIX_";var builderCubeFormComponentsControlReducer=function builderCubeFormComponentsControlReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{attributeId:null,dimensionId:null,isMeasureVisible:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_SHOW */]:return Object.assign({},state,{attributeId:action.attributeId});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_HIDE */]:return Object.assign({},state,{attributeId:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_SHOW */]:return Object.assign({},state,{dimensionId:action.dimensionId});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_HIDE */]:return Object.assign({},state,{dimensionId:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_SHOW */]:return Object.assign({},state,{isMeasureVisible:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_HIDE */]:return Object.assign({},state,{isMeasureVisible:false});default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_reduxReuse__["b" /* reuseInReducer */])(builderCubeFormComponentsControlReducer,{codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_1__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_2__redux_components_redux_codelist_detail_modal_reducer__["a" /* default */],DM_BUILDER_CUBE_FORM_COMPONENT_CONTROL_CODELIST_DETAIL_PREFIX)}));

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return showBuilderCubeFormComponentsControlAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hideBuilderCubeFormComponentsControlAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return showBuilderCubeFormComponentsControlDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hideBuilderCubeFormComponentsControlDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return showBuilderCubeFormComponentsControlMeasure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hideBuilderCubeFormComponentsControlMeasure; });
var BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_SHOW='BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_SHOW';var BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_HIDE='BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_HIDE';var BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_SHOW='BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_SHOW';var BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_HIDE='BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_HIDE';var BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_SHOW='BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_SHOW';var BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_HIDE='BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_HIDE';var showBuilderCubeFormComponentsControlAttribute=function showBuilderCubeFormComponentsControlAttribute(attributeId){return{type:BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_SHOW,attributeId:attributeId};};var hideBuilderCubeFormComponentsControlAttribute=function hideBuilderCubeFormComponentsControlAttribute(){return{type:BUILDER_CUBE_FORM_COMPONENTS_CONTROL_ATTRIBUTE_HIDE};};var showBuilderCubeFormComponentsControlDimension=function showBuilderCubeFormComponentsControlDimension(dimensionId){return{type:BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_SHOW,dimensionId:dimensionId};};var hideBuilderCubeFormComponentsControlDimension=function hideBuilderCubeFormComponentsControlDimension(){return{type:BUILDER_CUBE_FORM_COMPONENTS_CONTROL_DIMENSION_HIDE};};var showBuilderCubeFormComponentsControlMeasure=function showBuilderCubeFormComponentsControlMeasure(){return{type:BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_SHOW};};var hideBuilderCubeFormComponentsControlMeasure=function hideBuilderCubeFormComponentsControlMeasure(){return{type:BUILDER_CUBE_FORM_COMPONENTS_CONTROL_MEASURE_HIDE};};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_MAPPING_LIST_FILE_MAPPINGS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FILE_MAPPING_LIST_FILE_MAPPING_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILE_MAPPING_LIST_FILE_MAPPING_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FILE_MAPPING_LIST_FILE_MAPPING_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_MAPPING_LIST_FILE_MAPPING_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return readFileMappingListFileMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return showFileMappingListFileMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hideFileMappingListFileMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return readFileMappingListFileMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return readFileMappingListFileMappingCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteFileMappingListFileMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteFileMappingListFileMappingAll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var FILE_MAPPING_LIST_FILE_MAPPINGS_READ='FILE_MAPPING_LIST_FILE_MAPPINGS_READ';var FILE_MAPPING_LIST_FILE_MAPPING_SHOW='FILE_MAPPING_LIST_FILE_MAPPING_SHOW';var FILE_MAPPING_LIST_FILE_MAPPING_HIDE='FILE_MAPPING_LIST_FILE_MAPPING_HIDE';var FILE_MAPPING_LIST_FILE_MAPPING_READ='FILE_MAPPING_LIST_FILE_MAPPING_READ';var FILE_MAPPING_LIST_FILE_MAPPING_DELETE='FILE_MAPPING_LIST_FILE_MAPPING_DELETE';var FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ='FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ';var FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL='FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL';var readFileMappingListFileMappings=function readFileMappingListFileMappings(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(FILE_MAPPING_LIST_FILE_MAPPINGS_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["h" /* getAllCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_42" /* getFileMappingUrl */])()]);};var showFileMappingListFileMapping=function showFileMappingListFileMapping(fileMappingId){return{type:FILE_MAPPING_LIST_FILE_MAPPING_SHOW,fileMappingId:fileMappingId};};var hideFileMappingListFileMapping=function hideFileMappingListFileMapping(){return{type:FILE_MAPPING_LIST_FILE_MAPPING_HIDE};};var readFileMappingListFileMapping=function readFileMappingListFileMapping(fileMappingId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(FILE_MAPPING_LIST_FILE_MAPPING_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_42" /* getFileMappingUrl */])(fileMappingId));};var readFileMappingListFileMappingCube=function readFileMappingListFileMappingCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var deleteFileMappingListFileMapping=function deleteFileMappingListFileMapping(fileMappingId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(FILE_MAPPING_LIST_FILE_MAPPING_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_42" /* getFileMappingUrl */])(fileMappingId),function(t){return{success:t('scenes.dataManager.fileMapping.list.messages.fileMappingDelete.success')};});};var deleteFileMappingListFileMappingAll=function deleteFileMappingListFileMappingAll(fileMappingIds){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL,fileMappingIds.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),fileMappingIds.map(function(id){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_42" /* getFileMappingUrl */])(id);}),null,function(t){return{success:t('scenes.dataManager.fileMapping.list.messages.fileMappingDeleteAll.success')};});};

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_MAPPING_WIZARD_CSV_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeFileMappingWizardCsvForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setFileMappingWizardCsvFormFileFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return submitFileMappingWizardCsvForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var FILE_MAPPING_WIZARD_CSV_FORM_CHANGE='FILE_MAPPING_WIZARD_CSV_FORM_CHANGE';var FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET='FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET';var FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT='FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT';var changeFileMappingWizardCsvForm=function changeFileMappingWizardCsvForm(fields){return{type:FILE_MAPPING_WIZARD_CSV_FORM_CHANGE,fields:fields};};var setFileMappingWizardCsvFormFileFormat=function setFileMappingWizardCsvFormFileFormat(fileFormat){return{type:FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET,fileFormat:fileFormat};};var submitFileMappingWizardCsvForm=function submitFileMappingWizardCsvForm(file,xmlFile){var fileFormData=new FormData();fileFormData.append('file',file);var xmlFileFormData=new FormData();xmlFileFormData.append('file',xmlFile);if(xmlFile){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])()],[fileFormData,xmlFileFormData],function(t){return{start:t('scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.start'),success:t("scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.success")};},null);}else{return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(),fileFormData,function(t){return{start:t('scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.start'),success:t("scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.success")};});}};

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_components_redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
var fileMappingWizardCubeComponentListReducer=function fileMappingWizardCubeComponentListReducer(state){return state;};var DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX="DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX_";/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_reduxReuse__["b" /* reuseInReducer */])(fileMappingWizardCubeComponentListReducer,{codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_0__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_1__redux_components_redux_codelist_detail_modal_reducer__["a" /* default */],DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX)}));

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addFileMappingWizardComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeFileMappingWizardComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeAllFileMappingWizardComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addAllFileMappingWizardComponentMapperComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectFileMappingWizardComponentMapperComponent; });
var FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT='FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT';var FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD='FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD';var FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL='FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL';var FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE='FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE';var FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL='FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL';var addFileMappingWizardComponentMapperComponent=function addFileMappingWizardComponentMapperComponent(columnName,cubeComponentCode){return{type:FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD,columnName:columnName,cubeComponentCode:cubeComponentCode};};var removeFileMappingWizardComponentMapperComponent=function removeFileMappingWizardComponentMapperComponent(columnName,cubeComponentCode){return{type:FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE,columnName:columnName,cubeComponentCode:cubeComponentCode};};var removeAllFileMappingWizardComponentMapperComponent=function removeAllFileMappingWizardComponentMapperComponent(){return{type:FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL};};var addAllFileMappingWizardComponentMapperComponent=function addAllFileMappingWizardComponentMapperComponent(){return{type:FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL};};var selectFileMappingWizardComponentMapperComponent=function selectFileMappingWizardComponentMapperComponent(columnName,cubeComponentCode){return{type:FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT,columnName:columnName,cubeComponentCode:cubeComponentCode};};

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectFileMappingWizardCubeComponentListComponent; });
var FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT='FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT';var selectFileMappingWizardCubeComponentListComponent=function selectFileMappingWizardCubeComponentListComponent(cubeComponentCode){return{type:FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT,cubeComponentCode:cubeComponentCode};};

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_CSV_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADER_CSV_FORM_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOADER_CSV_FORM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADER_CSV_FORM_PX_TO_CSV_CONVERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOADER_CSV_FORM_XLS_TO_CSV_CONVERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return changeLoaderCsvForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return uploadLoaderCsvFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return submitLoaderCsvForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return onHideLoaderCsvFormIgnoreConcurrentUploadConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return convertLoaderCsvFormPxToCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return convertLoaderCsvFormXlsToCsv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var LOADER_CSV_FORM_CHANGE='LOADER_CSV_FORM_CHANGE';var LOADER_CSV_FORM_FILE_UPLOAD='LOADER_CSV_FORM_FILE_UPLOAD';var LOADER_CSV_FORM_SUBMIT='LOADER_CSV_FORM_SUBMIT';var LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE='LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE';var LOADER_CSV_FORM_PX_TO_CSV_CONVERT='LOADER_CSV_FORM_PX_TO_CSV_CONVERT';var LOADER_CSV_FORM_XLS_TO_CSV_CONVERT='LOADER_CSV_FORM_XLS_TO_CSV_CONVERT';var changeLoaderCsvForm=function changeLoaderCsvForm(fields){return{type:LOADER_CSV_FORM_CHANGE,fields:fields};};var uploadLoaderCsvFormFile=function uploadLoaderCsvFormFile(file,mappingCubeId,format){var fileFormData=new FormData();fileFormData.append('file',file);return Object.assign({format:format},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(LOADER_CSV_FORM_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(mappingCubeId),fileFormData,function(t){return{start:t('scenes.dataManager.loader.csvForm.messages.fileUpload.start'),success:t('scenes.dataManager.loader.csvForm.messages.fileUpload.success')};}));};var submitLoaderCsvForm=function submitLoaderCsvForm(separator,delimiter,hasHeader,importType,cubeId,mappingId,filePath,tid,cubeCode,idMappingSpecialTimePeriod,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])('LOADER_CSV_FORM_SUBMIT',Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_46" /* getImportCsvUrl */])(separator,delimiter,hasHeader,importType,cubeId,mappingId,filePath,tid,idMappingSpecialTimePeriod,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload),function(t){return{start:t('scenes.dataManager.loader.csvForm.messages.submit.start'),success:t('scenes.dataManager.loader.csvForm.messages.submit.success')};}),{reportFileNameId:cubeCode});};var onHideLoaderCsvFormIgnoreConcurrentUploadConfirm=function onHideLoaderCsvFormIgnoreConcurrentUploadConfirm(){return{type:LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE};};var convertLoaderCsvFormPxToCsv=function convertLoaderCsvFormPxToCsv(fileServerPath,cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(LOADER_CSV_FORM_PX_TO_CSV_CONVERT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["I" /* getConvertPxToCsvUrl */])(fileServerPath,cubeId));};var convertLoaderCsvFormXlsToCsv=function convertLoaderCsvFormXlsToCsv(fileServerPath,xmlServerPath,cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(LOADER_CSV_FORM_XLS_TO_CSV_CONVERT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["J" /* getConvertXlsToCsv */])(fileServerPath,xmlServerPath,cubeId));};

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userMustNotInsertTid;
function userMustNotInsertTid(mapping,mappingCube){return mapping===null||mappingCube!==null&&(mappingCube.Attributes.filter(function(attr){return attr.IsTid;}).length===0||mapping.Components.filter(function(comp){return comp.CubeComponentCode===mappingCube.Attributes.filter(function(attr){return attr.IsTid;})[0].Code;}).length>0);}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADER_XML_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOADER_XML_FORM_CUBE_TREE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOADER_XML_FORM_CUBE_TREE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADER_XML_FORM_CUBE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOADER_XML_FORM_CUBE_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOADER_XML_FORM_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_XML_FORM_CATEGORISED_CUBES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOADER_XML_FORM_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOADER_XML_FORM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOADER_XML_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return changeLoaderXmlForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return showLoaderXmlFormCubeTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hideLoaderXmlFormCubeTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setLoaderXmlFormCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return unsetLoaderXmlFormCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return readLoaderXmlFormCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return readLoaderXmlFormCategorisedCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return uploadLoaderXmlFormFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return submitLoaderXmlForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return onHideLoaderXmlFormIgnoreConcurrentUploadConfirm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var LOADER_XML_FORM_CHANGE='LOADER_XML_FORM_CHANGE';var LOADER_XML_FORM_CUBE_TREE_SHOW='LOADER_XML_FORM_CUBE_TREE_SHOW';var LOADER_XML_FORM_CUBE_TREE_HIDE='LOADER_XML_FORM_CUBE_TREE_HIDE';var LOADER_XML_FORM_CUBE_SET='LOADER_XML_FORM_CUBE_SET';var LOADER_XML_FORM_CUBE_UNSET='LOADER_XML_FORM_CUBE_UNSET';var LOADER_XML_FORM_CUBE_READ='LOADER_XML_FORM_CUBE_READ';var LOADER_XML_FORM_CATEGORISED_CUBES_READ='LOADER_XML_FORM_CATEGORISED_CUBES_READ';var LOADER_XML_FORM_FILE_UPLOAD='LOADER_XML_FORM_FILE_UPLOAD';var LOADER_XML_FORM_SUBMIT='LOADER_XML_FORM_SUBMIT';var LOADER_XML_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE='LOADER_XML_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE';var changeLoaderXmlForm=function changeLoaderXmlForm(fields){return{type:LOADER_XML_FORM_CHANGE,fields:fields};};var showLoaderXmlFormCubeTree=function showLoaderXmlFormCubeTree(){return{type:LOADER_XML_FORM_CUBE_TREE_SHOW};};var hideLoaderXmlFormCubeTree=function hideLoaderXmlFormCubeTree(){return{type:LOADER_XML_FORM_CUBE_TREE_HIDE};};var setLoaderXmlFormCube=function setLoaderXmlFormCube(cubeId){return{type:LOADER_XML_FORM_CUBE_SET,cubeId:cubeId};};var unsetLoaderXmlFormCube=function unsetLoaderXmlFormCube(){return{type:LOADER_XML_FORM_CUBE_UNSET};};var readLoaderXmlFormCube=function readLoaderXmlFormCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(LOADER_XML_FORM_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var readLoaderXmlFormCategorisedCubes=function readLoaderXmlFormCategorisedCubes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(LOADER_XML_FORM_CATEGORISED_CUBES_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])()]);};var uploadLoaderXmlFormFile=function uploadLoaderXmlFormFile(file,cubeId){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(LOADER_XML_FORM_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(cubeId),fileFormData,function(t){return{start:t('scenes.dataManager.loader.xmlForm.messages.fileUpload.start'),success:t('scenes.dataManager.loader.xmlForm.messages.fileUpload.success')};});};var submitLoaderXmlForm=function submitLoaderXmlForm(importType,cubeId,dsdId,dsdAgencyId,dsdVersion,filePath,tid,cubeCode,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(LOADER_XML_FORM_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_51" /* getImportSdmxMlUrl */])(importType,cubeId,dsdId,dsdAgencyId,dsdVersion,filePath,tid,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload)),{reportFileNameId:cubeCode});};var onHideLoaderXmlFormIgnoreConcurrentUploadConfirm=function onHideLoaderXmlFormIgnoreConcurrentUploadConfirm(){return{type:LOADER_XML_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE};};

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1014);

__webpack_require__(39);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tree = _interopRequireDefault(__webpack_require__(459));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Tree["default"];
exports["default"] = _default;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcTree = _interopRequireWildcard(__webpack_require__(1015));

var _DirectoryTree = _interopRequireDefault(__webpack_require__(1021));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

var _openAnimation = _interopRequireDefault(__webpack_require__(319));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Tree =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tree, _React$Component);

  function Tree() {
    var _this;

    _classCallCheck(this, Tree);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tree).apply(this, arguments));

    _this.renderSwitcherIcon = function (prefixCls, switcherIcon, _ref) {
      var isLeaf = _ref.isLeaf,
          expanded = _ref.expanded,
          loading = _ref.loading;
      var showLine = _this.props.showLine;

      if (loading) {
        return React.createElement(_icon["default"], {
          type: "loading",
          className: "".concat(prefixCls, "-switcher-loading-icon")
        });
      }

      if (showLine) {
        if (isLeaf) {
          return React.createElement(_icon["default"], {
            type: "file",
            className: "".concat(prefixCls, "-switcher-line-icon")
          });
        }

        return React.createElement(_icon["default"], {
          type: expanded ? 'minus-square' : 'plus-square',
          className: "".concat(prefixCls, "-switcher-line-icon"),
          theme: "outlined"
        });
      } else {
        var switcherCls = "".concat(prefixCls, "-switcher-icon");

        if (isLeaf) {
          return null;
        } else if (switcherIcon) {
          var switcherOriginCls = switcherIcon.props.className || '';
          return React.cloneElement(switcherIcon, {
            className: [switcherOriginCls, switcherCls]
          });
        } else {
          return React.createElement(_icon["default"], {
            type: "caret-down",
            className: switcherCls,
            theme: "filled"
          });
        }
      }
    };

    _this.setTreeRef = function (node) {
      _this.tree = node;
    };

    _this.renderTree = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls;
      var props = _this.props;
      var customizePrefixCls = props.prefixCls,
          className = props.className,
          showIcon = props.showIcon,
          _switcherIcon = props.switcherIcon;
      var checkable = props.checkable;
      var prefixCls = getPrefixCls('tree', customizePrefixCls);
      return React.createElement(_rcTree["default"], _extends({
        ref: _this.setTreeRef
      }, props, {
        prefixCls: prefixCls,
        className: (0, _classnames["default"])(!showIcon && "".concat(prefixCls, "-icon-hide"), className),
        checkable: checkable ? React.createElement("span", {
          className: "".concat(prefixCls, "-checkbox-inner")
        }) : checkable,
        switcherIcon: function switcherIcon(nodeProps) {
          return _this.renderSwitcherIcon(prefixCls, _switcherIcon, nodeProps);
        }
      }), _this.props.children);
    };

    return _this;
  }

  _createClass(Tree, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderTree);
    }
  }]);

  return Tree;
}(React.Component);

exports["default"] = Tree;
Tree.TreeNode = _rcTree.TreeNode;
Tree.DirectoryTree = _DirectoryTree["default"];
Tree.defaultProps = {
  checkable: false,
  showIcon: false,
  openAnimation: _extends({}, _openAnimation["default"], {
    appear: null
  })
};

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return treeContextTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nodeContextTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */



/**
 * Thought we still use `cloneElement` to pass `key`,
 * other props can pass with context for future refactor.
 */
var treeContextTypes = {
  rcTree: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    root: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

    prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    selectable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    showIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
    draggable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    checkable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    checkStrictly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    openTransitionName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),

    loadData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    filterTreeNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    renderTreeNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    isKeyChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    onNodeClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeDoubleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeCheck: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeContextMenu: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeDragEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onNodeDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func

    // TODO: Remove this
    // onBatchNodeCheck: PropTypes.func,
    // onCheckConductFinished: PropTypes.func,

    // Tree will store the entities when the treeNode refresh.
    // User can pass the func to add more info to customize the additional info.
    // processTreeEntity: PropTypes.func,
  })
};

var nodeContextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, treeContextTypes, {
  rcTreeNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onUpCheckConduct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["p"] = warnOnlyTreeNode;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrDel;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrAdd;
/* harmony export (immutable) */ __webpack_exports__["o"] = posToArr;
/* harmony export (immutable) */ __webpack_exports__["l"] = getPosition;
/* unused harmony export isTreeNode */
/* harmony export (immutable) */ __webpack_exports__["k"] = getNodeChildren;
/* unused harmony export isCheckDisabled */
/* unused harmony export traverseTreeNodes */
/* harmony export (immutable) */ __webpack_exports__["m"] = mapChildren;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDragNodesKeys;
/* harmony export (immutable) */ __webpack_exports__["c"] = calcDropPosition;
/* harmony export (immutable) */ __webpack_exports__["d"] = calcSelectedKeys;
/* harmony export (immutable) */ __webpack_exports__["g"] = convertDataToTree;
/* harmony export (immutable) */ __webpack_exports__["h"] = convertTreeToEntities;
/* harmony export (immutable) */ __webpack_exports__["n"] = parseCheckedKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = conductCheck;
/* harmony export (immutable) */ __webpack_exports__["f"] = conductExpandParent;
/* harmony export (immutable) */ __webpack_exports__["i"] = getDataAndAria;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_Children_toArray__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TreeNode__ = __webpack_require__(462);






var DRAG_SIDE_RANGE = 0.25;
var DRAG_MIN_GAP = 2;

var onlyTreeNodeWarned = false;

function warnOnlyTreeNode() {
  if (onlyTreeNodeWarned) return;

  onlyTreeNodeWarned = true;
  __WEBPACK_IMPORTED_MODULE_3_warning___default()(false, 'Tree only accept TreeNode as children.');
}

function arrDel(list, value) {
  var clone = list.slice();
  var index = clone.indexOf(value);
  if (index >= 0) {
    clone.splice(index, 1);
  }
  return clone;
}

function arrAdd(list, value) {
  var clone = list.slice();
  if (clone.indexOf(value) === -1) {
    clone.push(value);
  }
  return clone;
}

function posToArr(pos) {
  return pos.split('-');
}

function getPosition(level, index) {
  return level + '-' + index;
}

function isTreeNode(node) {
  return node && node.type && node.type.isTreeNode;
}

function getNodeChildren(children) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_Children_toArray__["a" /* default */])(children).filter(isTreeNode);
}

function isCheckDisabled(node) {
  var _ref = node.props || {},
      disabled = _ref.disabled,
      disableCheckbox = _ref.disableCheckbox;

  return !!(disabled || disableCheckbox);
}

function traverseTreeNodes(treeNodes, callback) {
  function processNode(node, index, parent) {
    var children = node ? node.props.children : treeNodes;
    var pos = node ? getPosition(parent.pos, index) : 0;

    // Filter children
    var childList = getNodeChildren(children);

    // Process node if is not root
    if (node) {
      var data = {
        node: node,
        index: index,
        pos: pos,
        key: node.key || pos,
        parentPos: parent.node ? parent.pos : null
      };

      callback(data);
    }

    // Process children node
    __WEBPACK_IMPORTED_MODULE_1_react__["Children"].forEach(childList, function (subNode, subIndex) {
      processNode(subNode, subIndex, { node: node, pos: pos });
    });
  }

  processNode(null);
}

/**
 * Use `rc-util` `toArray` to get the children list which keeps the key.
 * And return single node if children is only one(This can avoid `key` missing check).
 */
function mapChildren(children, func) {
  var list = Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_Children_toArray__["a" /* default */])(children).map(func);
  if (list.length === 1) {
    return list[0];
  }
  return list;
}

function getDragNodesKeys(treeNodes, node) {
  var _node$props = node.props,
      eventKey = _node$props.eventKey,
      pos = _node$props.pos;

  var dragNodesKeys = [];

  traverseTreeNodes(treeNodes, function (_ref2) {
    var key = _ref2.key;

    dragNodesKeys.push(key);
  });
  dragNodesKeys.push(eventKey || pos);
  return dragNodesKeys;
}

// Only used when drag, not affect SSR.
function calcDropPosition(event, treeNode) {
  var clientY = event.clientY;

  var _treeNode$selectHandl = treeNode.selectHandle.getBoundingClientRect(),
      top = _treeNode$selectHandl.top,
      bottom = _treeNode$selectHandl.bottom,
      height = _treeNode$selectHandl.height;

  var des = Math.max(height * DRAG_SIDE_RANGE, DRAG_MIN_GAP);

  if (clientY <= top + des) {
    return -1;
  } else if (clientY >= bottom - des) {
    return 1;
  }

  return 0;
}

/**
 * Return selectedKeys according with multiple prop
 * @param selectedKeys
 * @param props
 * @returns [string]
 */
function calcSelectedKeys(selectedKeys, props) {
  if (!selectedKeys) return undefined;

  var multiple = props.multiple;

  if (multiple) {
    return selectedKeys.slice();
  }

  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }
  return selectedKeys;
}

/**
 * Since React internal will convert key to string,
 * we need do this to avoid `checkStrictly` use number match
 */
function keyListToString(keyList) {
  if (!keyList) return keyList;
  return keyList.map(function (key) {
    return String(key);
  });
}

var internalProcessProps = function internalProcessProps(props) {
  return props;
};
function convertDataToTree(treeData, processer) {
  if (!treeData) return [];

  var _ref3 = processer || {},
      _ref3$processProps = _ref3.processProps,
      processProps = _ref3$processProps === undefined ? internalProcessProps : _ref3$processProps;

  var list = Array.isArray(treeData) ? treeData : [treeData];
  return list.map(function (_ref4) {
    var children = _ref4.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['children']);

    var childrenNodes = convertDataToTree(children, processer);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__TreeNode__["a" /* default */],
      processProps(props),
      childrenNodes
    );
  });
}

// TODO: ========================= NEW LOGIC =========================
/**
 * Calculate treeNodes entities. `processTreeEntity` is used for `rc-tree-select`
 * @param treeNodes
 * @param processTreeEntity  User can customize the entity
 */
function convertTreeToEntities(treeNodes) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      initWrapper = _ref5.initWrapper,
      processEntity = _ref5.processEntity,
      onProcessFinished = _ref5.onProcessFinished;

  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities: posEntities,
    keyEntities: keyEntities
  };

  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }

  traverseTreeNodes(treeNodes, function (item) {
    var node = item.node,
        index = item.index,
        pos = item.pos,
        key = item.key,
        parentPos = item.parentPos;

    var entity = { node: node, index: index, key: key, pos: pos };

    posEntities[pos] = entity;
    keyEntities[key] = entity;

    // Fill children
    entity.parent = posEntities[parentPos];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }

    if (processEntity) {
      processEntity(entity, wrapper);
    }
  });

  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }

  return wrapper;
}

/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */
function parseCheckedKeys(keys) {
  if (!keys) {
    return null;
  }

  // Convert keys to object format
  var keyProps = void 0;
  if (Array.isArray(keys)) {
    // [Legacy] Follow the api doc
    keyProps = {
      checkedKeys: keys,
      halfCheckedKeys: undefined
    };
  } else if (typeof keys === 'object') {
    keyProps = {
      checkedKeys: keys.checked || undefined,
      halfCheckedKeys: keys.halfChecked || undefined
    };
  } else {
    __WEBPACK_IMPORTED_MODULE_3_warning___default()(false, '`checkedKeys` is not an array or an object');
    return null;
  }

  keyProps.checkedKeys = keyListToString(keyProps.checkedKeys);
  keyProps.halfCheckedKeys = keyListToString(keyProps.halfCheckedKeys);

  return keyProps;
}

/**
 * Conduct check state by the keyList. It will conduct up & from the provided key.
 * If the conduct path reach the disabled or already checked / unchecked node will stop conduct.
 * @param keyList       list of keys
 * @param isCheck       is check the node or not
 * @param keyEntities   parsed by `convertTreeToEntities` function in Tree
 * @param checkStatus   Can pass current checked status for process (usually for uncheck operation)
 * @returns {{checkedKeys: [], halfCheckedKeys: []}}
 */
function conductCheck(keyList, isCheck, keyEntities) {
  var checkStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var checkedKeys = {};
  var halfCheckedKeys = {}; // Record the key has some child checked (include child half checked)

  (checkStatus.checkedKeys || []).forEach(function (key) {
    checkedKeys[key] = true;
  });

  (checkStatus.halfCheckedKeys || []).forEach(function (key) {
    halfCheckedKeys[key] = true;
  });

  // Conduct up
  function conductUp(key) {
    if (checkedKeys[key] === isCheck) return;

    var entity = keyEntities[key];
    if (!entity) return;

    var children = entity.children,
        parent = entity.parent,
        node = entity.node;


    if (isCheckDisabled(node)) return;

    // Check child node checked status
    var everyChildChecked = true;
    var someChildChecked = false; // Child checked or half checked

    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (_ref6) {
      var childKey = _ref6.key;

      var childChecked = checkedKeys[childKey];
      var childHalfChecked = halfCheckedKeys[childKey];

      if (childChecked || childHalfChecked) someChildChecked = true;
      if (!childChecked) everyChildChecked = false;
    });

    // Update checked status
    if (isCheck) {
      checkedKeys[key] = everyChildChecked;
    } else {
      checkedKeys[key] = false;
    }
    halfCheckedKeys[key] = someChildChecked;

    if (parent) {
      conductUp(parent.key);
    }
  }

  // Conduct down
  function conductDown(key) {
    if (checkedKeys[key] === isCheck) return;

    var entity = keyEntities[key];
    if (!entity) return;

    var children = entity.children,
        node = entity.node;


    if (isCheckDisabled(node)) return;

    checkedKeys[key] = isCheck;

    (children || []).forEach(function (child) {
      conductDown(child.key);
    });
  }

  function conduct(key) {
    var entity = keyEntities[key];

    if (!entity) {
      __WEBPACK_IMPORTED_MODULE_3_warning___default()(false, '\'' + key + '\' does not exist in the tree.');
      return;
    }

    var children = entity.children,
        parent = entity.parent,
        node = entity.node;

    checkedKeys[key] = isCheck;

    if (isCheckDisabled(node)) return;

    // Conduct down
    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (child) {
      conductDown(child.key);
    });

    // Conduct up
    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conduct(key);
  });

  var checkedKeyList = [];
  var halfCheckedKeyList = [];

  // Fill checked list
  Object.keys(checkedKeys).forEach(function (key) {
    if (checkedKeys[key]) {
      checkedKeyList.push(key);
    }
  });

  // Fill half checked list
  Object.keys(halfCheckedKeys).forEach(function (key) {
    if (!checkedKeys[key] && halfCheckedKeys[key]) {
      halfCheckedKeyList.push(key);
    }
  });

  return {
    checkedKeys: checkedKeyList,
    halfCheckedKeys: halfCheckedKeyList
  };
}

/**
 * If user use `autoExpandParent` we should get the list of parent node
 * @param keyList
 * @param keyEntities
 */
function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = {};

  function conductUp(key) {
    if (expandedKeys[key]) return;

    var entity = keyEntities[key];
    if (!entity) return;

    expandedKeys[key] = true;

    var parent = entity.parent,
        node = entity.node;


    if (isCheckDisabled(node)) return;

    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conductUp(key);
  });

  return Object.keys(expandedKeys);
}

/**
 * Returns only the data- and aria- key/value pairs
 * @param {object} props 
 */
function getDataAndAria(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Children_toArray__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contextTypes__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(461);
















var ICON_OPEN = 'open';
var ICON_CLOSE = 'close';

var defaultTitle = '---';

var TreeNode = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TreeNode, _React$Component);

  function TreeNode(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TreeNode);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TreeNode.__proto__ || Object.getPrototypeOf(TreeNode)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      dragNodeHighlight: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TreeNode, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.context, {
        rcTreeNode: {
          // onUpCheckConduct: this.onUpCheckConduct,
        }
      });
    }

    // Isomorphic needn't load data in server side

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncLoadData(this.props);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.syncLoadData(this.props);
    }

    // Disabled item still can be switch


    // Drag usage

  }, {
    key: 'isSelectable',
    value: function isSelectable() {
      var selectable = this.props.selectable;
      var treeSelectable = this.context.rcTree.selectable;

      // Ignore when selectable is undefined or null

      if (typeof selectable === 'boolean') {
        return selectable;
      }

      return treeSelectable;
    }

    // Load data to avoid default expanded tree without data


    // Switcher


    // Checkbox


    // Icon + Title


    // Children list wrapped with `Animation`

  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var loading = this.props.loading;

      var _props = this.props,
          className = _props.className,
          style = _props.style,
          dragOver = _props.dragOver,
          dragOverGapTop = _props.dragOverGapTop,
          dragOverGapBottom = _props.dragOverGapBottom,
          isLeaf = _props.isLeaf,
          expanded = _props.expanded,
          selected = _props.selected,
          checked = _props.checked,
          halfChecked = _props.halfChecked,
          otherProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'style', 'dragOver', 'dragOverGapTop', 'dragOverGapBottom', 'isLeaf', 'expanded', 'selected', 'checked', 'halfChecked']);

      var _context$rcTree = this.context.rcTree,
          prefixCls = _context$rcTree.prefixCls,
          filterTreeNode = _context$rcTree.filterTreeNode,
          draggable = _context$rcTree.draggable;

      var disabled = this.isDisabled();
      var dataOrAriaAttributeProps = Object(__WEBPACK_IMPORTED_MODULE_14__util__["i" /* getDataAndAria */])(otherProps);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'li',
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(className, (_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-treenode-disabled', disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-treenode-switcher-' + (expanded ? 'open' : 'close'), !isLeaf), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-treenode-checkbox-checked', checked), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-treenode-checkbox-indeterminate', halfChecked), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-treenode-selected', selected), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-treenode-loading', loading), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, 'drag-over', !disabled && dragOver), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, 'filter-node', filterTreeNode && filterTreeNode(this)), _classNames)),

          style: style,

          role: 'treeitem',

          onDragEnter: draggable ? this.onDragEnter : undefined,
          onDragOver: draggable ? this.onDragOver : undefined,
          onDragLeave: draggable ? this.onDragLeave : undefined,
          onDrop: draggable ? this.onDrop : undefined,
          onDragEnd: draggable ? this.onDragEnd : undefined
        }, dataOrAriaAttributeProps),
        this.renderSwitcher(),
        this.renderCheckbox(),
        this.renderSelector(),
        this.renderChildren()
      );
    }
  }]);

  return TreeNode;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

TreeNode.propTypes = {
  eventKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, // Pass by parent `cloneElement`
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  root: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  // By parent
  expanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  selected: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  checked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  loaded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  loading: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  halfChecked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  title: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  pos: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  dragOver: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  dragOverGapTop: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  dragOverGapBottom: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // By user
  isLeaf: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  selectable: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disableCheckbox: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  icon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),
  switcherIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func])
};
TreeNode.contextTypes = __WEBPACK_IMPORTED_MODULE_13__contextTypes__["a" /* nodeContextTypes */];
TreeNode.childContextTypes = __WEBPACK_IMPORTED_MODULE_13__contextTypes__["a" /* nodeContextTypes */];
TreeNode.defaultProps = {
  title: defaultTitle
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSelectorClick = function (e) {
    // Click trigger before select/check operation
    var onNodeClick = _this2.context.rcTree.onNodeClick;

    onNodeClick(e, _this2);

    if (_this2.isSelectable()) {
      _this2.onSelect(e);
    } else {
      _this2.onCheck(e);
    }
  };

  this.onSelectorDoubleClick = function (e) {
    var onNodeDoubleClick = _this2.context.rcTree.onNodeDoubleClick;

    onNodeDoubleClick(e, _this2);
  };

  this.onSelect = function (e) {
    if (_this2.isDisabled()) return;

    var onNodeSelect = _this2.context.rcTree.onNodeSelect;

    e.preventDefault();
    onNodeSelect(e, _this2);
  };

  this.onCheck = function (e) {
    if (_this2.isDisabled()) return;

    var _props2 = _this2.props,
        disableCheckbox = _props2.disableCheckbox,
        checked = _props2.checked;
    var _context$rcTree2 = _this2.context.rcTree,
        checkable = _context$rcTree2.checkable,
        onNodeCheck = _context$rcTree2.onNodeCheck;


    if (!checkable || disableCheckbox) return;

    e.preventDefault();
    var targetChecked = !checked;
    onNodeCheck(e, _this2, targetChecked);
  };

  this.onMouseEnter = function (e) {
    var onNodeMouseEnter = _this2.context.rcTree.onNodeMouseEnter;

    onNodeMouseEnter(e, _this2);
  };

  this.onMouseLeave = function (e) {
    var onNodeMouseLeave = _this2.context.rcTree.onNodeMouseLeave;

    onNodeMouseLeave(e, _this2);
  };

  this.onContextMenu = function (e) {
    var onNodeContextMenu = _this2.context.rcTree.onNodeContextMenu;

    onNodeContextMenu(e, _this2);
  };

  this.onDragStart = function (e) {
    var onNodeDragStart = _this2.context.rcTree.onNodeDragStart;


    e.stopPropagation();
    _this2.setState({
      dragNodeHighlight: true
    });
    onNodeDragStart(e, _this2);

    try {
      // ie throw error
      // firefox-need-it
      e.dataTransfer.setData('text/plain', '');
    } catch (error) {
      // empty
    }
  };

  this.onDragEnter = function (e) {
    var onNodeDragEnter = _this2.context.rcTree.onNodeDragEnter;


    e.preventDefault();
    e.stopPropagation();
    onNodeDragEnter(e, _this2);
  };

  this.onDragOver = function (e) {
    var onNodeDragOver = _this2.context.rcTree.onNodeDragOver;


    e.preventDefault();
    e.stopPropagation();
    onNodeDragOver(e, _this2);
  };

  this.onDragLeave = function (e) {
    var onNodeDragLeave = _this2.context.rcTree.onNodeDragLeave;


    e.stopPropagation();
    onNodeDragLeave(e, _this2);
  };

  this.onDragEnd = function (e) {
    var onNodeDragEnd = _this2.context.rcTree.onNodeDragEnd;


    e.stopPropagation();
    _this2.setState({
      dragNodeHighlight: false
    });
    onNodeDragEnd(e, _this2);
  };

  this.onDrop = function (e) {
    var onNodeDrop = _this2.context.rcTree.onNodeDrop;


    e.preventDefault();
    e.stopPropagation();
    _this2.setState({
      dragNodeHighlight: false
    });
    onNodeDrop(e, _this2);
  };

  this.onExpand = function (e) {
    var onNodeExpand = _this2.context.rcTree.onNodeExpand;

    onNodeExpand(e, _this2);
  };

  this.setSelectHandle = function (node) {
    _this2.selectHandle = node;
  };

  this.getNodeChildren = function () {
    var children = _this2.props.children;

    var originList = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Children_toArray__["a" /* default */])(children).filter(function (node) {
      return node;
    });
    var targetList = Object(__WEBPACK_IMPORTED_MODULE_14__util__["k" /* getNodeChildren */])(originList);

    if (originList.length !== targetList.length) {
      Object(__WEBPACK_IMPORTED_MODULE_14__util__["p" /* warnOnlyTreeNode */])();
    }

    return targetList;
  };

  this.getNodeState = function () {
    var expanded = _this2.props.expanded;


    if (_this2.isLeaf()) {
      return null;
    }

    return expanded ? ICON_OPEN : ICON_CLOSE;
  };

  this.isLeaf = function () {
    var _props3 = _this2.props,
        isLeaf = _props3.isLeaf,
        loaded = _props3.loaded;
    var loadData = _this2.context.rcTree.loadData;


    var hasChildren = _this2.getNodeChildren().length !== 0;

    if (isLeaf === false) {
      return false;
    }

    return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
  };

  this.isDisabled = function () {
    var disabled = _this2.props.disabled;
    var treeDisabled = _this2.context.rcTree.disabled;

    // Follow the logic of Selectable

    if (disabled === false) {
      return false;
    }

    return !!(treeDisabled || disabled);
  };

  this.syncLoadData = function (props) {
    var expanded = props.expanded,
        loading = props.loading,
        loaded = props.loaded;
    var _context$rcTree3 = _this2.context.rcTree,
        loadData = _context$rcTree3.loadData,
        onNodeLoad = _context$rcTree3.onNodeLoad;


    if (loading) return;

    // read from state to avoid loadData at same time
    if (loadData && expanded && !_this2.isLeaf()) {
      // We needn't reload data when has children in sync logic
      // It's only needed in node expanded
      var hasChildren = _this2.getNodeChildren().length !== 0;
      if (!hasChildren && !loaded) {
        onNodeLoad(_this2);
      }
    }
  };

  this.renderSwitcher = function () {
    var _props4 = _this2.props,
        expanded = _props4.expanded,
        switcherIconFromProps = _props4.switcherIcon;
    var _context$rcTree4 = _this2.context.rcTree,
        prefixCls = _context$rcTree4.prefixCls,
        switcherIconFromCtx = _context$rcTree4.switcherIcon;


    var switcherIcon = switcherIconFromProps || switcherIconFromCtx;

    if (_this2.isLeaf()) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls + '-switcher', prefixCls + '-switcher-noop') },
        typeof switcherIcon === 'function' ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(switcherIcon, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.props, { isLeaf: true })) : switcherIcon
      );
    }

    var switcherCls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls + '-switcher', prefixCls + '-switcher_' + (expanded ? ICON_OPEN : ICON_CLOSE));
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      { onClick: _this2.onExpand, className: switcherCls },
      typeof switcherIcon === 'function' ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(switcherIcon, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.props, { isLeaf: false })) : switcherIcon
    );
  };

  this.renderCheckbox = function () {
    var _props5 = _this2.props,
        checked = _props5.checked,
        halfChecked = _props5.halfChecked,
        disableCheckbox = _props5.disableCheckbox;
    var _context$rcTree5 = _this2.context.rcTree,
        prefixCls = _context$rcTree5.prefixCls,
        checkable = _context$rcTree5.checkable;

    var disabled = _this2.isDisabled();

    if (!checkable) return null;

    // [Legacy] Custom element should be separate with `checkable` in future
    var $custom = typeof checkable !== 'boolean' ? checkable : null;

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls + '-checkbox', checked && prefixCls + '-checkbox-checked', !checked && halfChecked && prefixCls + '-checkbox-indeterminate', (disabled || disableCheckbox) && prefixCls + '-checkbox-disabled'),
        onClick: _this2.onCheck
      },
      $custom
    );
  };

  this.renderIcon = function () {
    var loading = _this2.props.loading;
    var prefixCls = _this2.context.rcTree.prefixCls;


    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', {
      className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls + '-iconEle', prefixCls + '-icon__' + (_this2.getNodeState() || 'docu'), loading && prefixCls + '-icon_loading')
    });
  };

  this.renderSelector = function () {
    var dragNodeHighlight = _this2.state.dragNodeHighlight;
    var _props6 = _this2.props,
        title = _props6.title,
        selected = _props6.selected,
        icon = _props6.icon,
        loading = _props6.loading;
    var _context$rcTree6 = _this2.context.rcTree,
        prefixCls = _context$rcTree6.prefixCls,
        showIcon = _context$rcTree6.showIcon,
        treeIcon = _context$rcTree6.icon,
        draggable = _context$rcTree6.draggable,
        loadData = _context$rcTree6.loadData;

    var disabled = _this2.isDisabled();

    var wrapClass = prefixCls + '-node-content-wrapper';

    // Icon - Still show loading icon when loading without showIcon
    var $icon = void 0;

    if (showIcon) {
      var currentIcon = icon || treeIcon;

      $icon = currentIcon ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        {
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls + '-iconEle', prefixCls + '-icon__customize')
        },
        typeof currentIcon === 'function' ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(currentIcon, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.props)) : currentIcon
      ) : _this2.renderIcon();
    } else if (loadData && loading) {
      $icon = _this2.renderIcon();
    }

    // Title
    var $title = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      { className: prefixCls + '-title' },
      title
    );

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      {
        ref: _this2.setSelectHandle,
        title: typeof title === 'string' ? title : '',
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('' + wrapClass, wrapClass + '-' + (_this2.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && prefixCls + '-node-selected', !disabled && draggable && 'draggable'),
        draggable: !disabled && draggable || undefined,
        'aria-grabbed': !disabled && draggable || undefined,

        onMouseEnter: _this2.onMouseEnter,
        onMouseLeave: _this2.onMouseLeave,
        onContextMenu: _this2.onContextMenu,
        onClick: _this2.onSelectorClick,
        onDoubleClick: _this2.onSelectorDoubleClick,
        onDragStart: draggable ? _this2.onDragStart : undefined
      },
      $icon,
      $title
    );
  };

  this.renderChildren = function () {
    var _props7 = _this2.props,
        expanded = _props7.expanded,
        pos = _props7.pos;
    var _context$rcTree7 = _this2.context.rcTree,
        prefixCls = _context$rcTree7.prefixCls,
        openTransitionName = _context$rcTree7.openTransitionName,
        openAnimation = _context$rcTree7.openAnimation,
        renderTreeNode = _context$rcTree7.renderTreeNode;


    var animProps = {};
    if (openTransitionName) {
      animProps.transitionName = openTransitionName;
    } else if (typeof openAnimation === 'object') {
      animProps.animation = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, openAnimation);
    }

    // Children TreeNode
    var nodeList = _this2.getNodeChildren();

    if (nodeList.length === 0) {
      return null;
    }

    var $children = void 0;
    if (expanded) {
      $children = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'ul',
        {
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls + '-child-tree', expanded && prefixCls + '-child-tree-open'),
          'data-expanded': expanded,
          role: 'group'
        },
        Object(__WEBPACK_IMPORTED_MODULE_14__util__["m" /* mapChildren */])(nodeList, function (node, index) {
          return renderTreeNode(node, index, pos);
        })
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_rc_animate__["default"],
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, animProps, {
        showProp: 'data-expanded',
        component: ''
      }),
      $children
    );
  };
};

TreeNode.isTreeNode = 1;

Object(__WEBPACK_IMPORTED_MODULE_12_react_lifecycles_compat__["polyfill"])(TreeNode);

/* harmony default export */ __webpack_exports__["a"] = (TreeNode);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Animate__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimateChild__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CSSMotion__ = __webpack_require__(1020);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AnimateChild", function() { return __WEBPACK_IMPORTED_MODULE_1__AnimateChild__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CSSMotion", function() { return __WEBPACK_IMPORTED_MODULE_2__CSSMotion__["a"]; });






/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */]);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genAnimateChild */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_component_classes__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(317);















var clonePropList = ['appeared', 'show', 'exclusive', 'children', 'animation'];

/**
 * AnimateChild only accept one child node.
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genAnimateChild(transitionSupport) {
  var AnimateChild = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

    function AnimateChild() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

      // [Legacy] Since old code addListener on the element.
      // To avoid break the behaviour that component not handle animation/transition
      // also can handle the animate, let keep the logic.
      var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).call(this));

      _this.state = {
        child: null,

        eventQueue: [],
        eventActive: false
      };

      _this.onDomUpdated = function () {
        var eventActive = _this.state.eventActive;
        var _this$props = _this.props,
            transitionName = _this$props.transitionName,
            animation = _this$props.animation,
            onChildLeaved = _this$props.onChildLeaved,
            animateKey = _this$props.animateKey;


        var $ele = _this.getDomElement();

        // Skip if dom element not ready
        if (!$ele) return;

        // [Legacy] Add animation/transition event by dom level
        if (transitionSupport && _this.$prevEle !== $ele) {
          _this.cleanDomEvent();

          _this.$prevEle = $ele;
          _this.$prevEle.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util__["a" /* animationEndName */], _this.onMotionEnd);
          _this.$prevEle.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util__["g" /* transitionEndName */], _this.onMotionEnd);
        }

        var currentEvent = _this.getCurrentEvent();
        if (currentEvent.empty) {
          // Additional process the leave event
          if (currentEvent.lastEventType === 'leave') {
            onChildLeaved(animateKey);
          }
          return;
        }

        var eventType = currentEvent.eventType,
            restQueue = currentEvent.restQueue;

        var nodeClasses = __WEBPACK_IMPORTED_MODULE_10_component_classes___default()($ele);

        // [Legacy] Since origin code use js to set `className`.
        // This caused that any component without support `className` can be forced set.
        // Let's keep the logic.
        function legacyAppendClass() {
          if (!transitionSupport) return;

          var basicClassName = Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(transitionName, '' + eventType);
          if (basicClassName) nodeClasses.add(basicClassName);

          if (eventActive) {
            var activeClassName = Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(transitionName, eventType + '-active');
            if (activeClassName) nodeClasses.add(activeClassName);
          }
        }

        if (_this.currentEvent && _this.currentEvent.type === eventType) {
          legacyAppendClass();
          return;
        }

        // Clear timeout for legacy check
        clearTimeout(_this.timeout);

        // Clean up last event environment
        if (_this.currentEvent && _this.currentEvent.animateObj && _this.currentEvent.animateObj.stop) {
          _this.currentEvent.animateObj.stop();
        }

        // Clean up last transition class
        if (_this.currentEvent) {
          var basicClassName = Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(transitionName, '' + _this.currentEvent.type);
          var activeClassName = Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(transitionName, _this.currentEvent.type + '-active');
          if (basicClassName) nodeClasses.remove(basicClassName);
          if (activeClassName) nodeClasses.remove(activeClassName);
        }

        // New event come
        _this.currentEvent = {
          type: eventType
        };

        var animationHandler = (animation || {})[eventType];
        // =============== Check if has customize animation ===============
        if (animationHandler) {
          _this.currentEvent.animateObj = animationHandler($ele, function () {
            _this.onMotionEnd({ target: $ele });
          });

          // Do next step if not animate object provided
          if (!_this.currentEvent || !_this.currentEvent.animateObj) {
            _this.nextEvent(restQueue);
          }

          // ==================== Use transition instead ====================
        } else if (transitionSupport) {
          legacyAppendClass();
          if (!eventActive) {
            // Trigger `eventActive` in next frame
            __WEBPACK_IMPORTED_MODULE_11_raf___default()(function () {
              if (_this.currentEvent && _this.currentEvent.type === eventType && !_this._destroy) {
                _this.setState({ eventActive: true }, function () {
                  // [Legacy] Handle timeout if browser transition event not handle
                  var transitionDelay = Object(__WEBPACK_IMPORTED_MODULE_12__util__["c" /* getStyleValue */])($ele, 'transition-delay') || 0;
                  var transitionDuration = Object(__WEBPACK_IMPORTED_MODULE_12__util__["c" /* getStyleValue */])($ele, 'transition-duration') || 0;
                  var animationDelay = Object(__WEBPACK_IMPORTED_MODULE_12__util__["c" /* getStyleValue */])($ele, 'animation-delay') || 0;
                  var animationDuration = Object(__WEBPACK_IMPORTED_MODULE_12__util__["c" /* getStyleValue */])($ele, 'animation-duration') || 0;
                  var totalTime = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);

                  if (totalTime >= 0) {
                    _this.timeout = setTimeout(function () {
                      _this.onMotionEnd({ target: $ele });
                    }, totalTime * 1000);
                  }
                });
              }
            });
          }

          // ======================= Just next action =======================
        } else {
          _this.onMotionEnd({ target: $ele });
        }
      };

      _this.onMotionEnd = function (_ref) {
        var target = _ref.target;
        var _this$props2 = _this.props,
            transitionName = _this$props2.transitionName,
            onChildLeaved = _this$props2.onChildLeaved,
            animateKey = _this$props2.animateKey,
            onAppear = _this$props2.onAppear,
            onEnter = _this$props2.onEnter,
            onLeave = _this$props2.onLeave,
            onEnd = _this$props2.onEnd;

        var currentEvent = _this.getCurrentEvent();
        if (currentEvent.empty) return;

        // Clear timeout for legacy check
        clearTimeout(_this.timeout);

        var restQueue = currentEvent.restQueue;


        var $ele = _this.getDomElement();
        if (!_this.currentEvent || $ele !== target) return;

        if (_this.currentEvent.animateObj && _this.currentEvent.animateObj.stop) {
          _this.currentEvent.animateObj.stop();
        }

        // [Legacy] Same as above, we need call js to remove the class
        if (transitionSupport && _this.currentEvent) {
          var basicClassName = Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(transitionName, _this.currentEvent.type);
          var activeClassName = Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(transitionName, _this.currentEvent.type + '-active');

          var nodeClasses = __WEBPACK_IMPORTED_MODULE_10_component_classes___default()($ele);
          if (basicClassName) nodeClasses.remove(basicClassName);
          if (activeClassName) nodeClasses.remove(activeClassName);
        }

        // Additional process the leave event
        if (_this.currentEvent && _this.currentEvent.type === 'leave') {
          onChildLeaved(animateKey);
        }

        // [Legacy] Trigger on event when it's last event
        if (_this.currentEvent && !restQueue.length) {
          if (_this.currentEvent.type === 'appear' && onAppear) {
            onAppear(animateKey);
          } else if (_this.currentEvent.type === 'enter' && onEnter) {
            onEnter(animateKey);
          } else if (_this.currentEvent.type === 'leave' && onLeave) {
            onLeave(animateKey);
          }

          if (onEnd) {
            // OnEnd(key, isShow)
            onEnd(animateKey, _this.currentEvent.type !== 'leave');
          }
        }

        _this.currentEvent = null;

        // Next queue
        _this.nextEvent(restQueue);
      };

      _this.getDomElement = function () {
        if (_this._destroy) return null;
        return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);
      };

      _this.getCurrentEvent = function () {
        var _this$state$eventQueu = _this.state.eventQueue,
            eventQueue = _this$state$eventQueu === undefined ? [] : _this$state$eventQueu;
        var _this$props3 = _this.props,
            animation = _this$props3.animation,
            exclusive = _this$props3.exclusive,
            transitionAppear = _this$props3.transitionAppear,
            transitionEnter = _this$props3.transitionEnter,
            transitionLeave = _this$props3.transitionLeave;


        function hasEventHandler(eventType) {
          return eventType === 'appear' && (transitionAppear || animation.appear) || eventType === 'enter' && (transitionEnter || animation.enter) || eventType === 'leave' && (transitionLeave || animation.leave);
        }

        var event = null;
        // If is exclusive, only check the last event
        if (exclusive) {
          var eventType = eventQueue[eventQueue.length - 1];
          if (hasEventHandler(eventType)) {
            event = {
              eventType: eventType,
              restQueue: []
            };
          }
        } else {
          // Loop check the queue until find match
          var cloneQueue = eventQueue.slice();
          while (cloneQueue.length) {
            var _cloneQueue = cloneQueue,
                _cloneQueue2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(_cloneQueue),
                _eventType = _cloneQueue2[0],
                restQueue = _cloneQueue2.slice(1);

            if (hasEventHandler(_eventType)) {
              event = {
                eventType: _eventType,
                restQueue: restQueue
              };
              break;
            }
            cloneQueue = restQueue;
          }
        }

        if (!event) {
          event = {
            empty: true,
            lastEventType: eventQueue[eventQueue.length - 1]
          };
        }

        return event;
      };

      _this.nextEvent = function (restQueue) {
        // Next queue
        if (!_this._destroy) {
          _this.setState({
            eventQueue: restQueue,
            eventActive: false
          });
        }
      };

      _this.cleanDomEvent = function () {
        if (_this.$prevEle && transitionSupport) {
          _this.$prevEle.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util__["a" /* animationEndName */], _this.onMotionEnd);
          _this.$prevEle.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util__["g" /* transitionEndName */], _this.onMotionEnd);
        }
      };

      _this.$prevEle = null;

      _this.currentEvent = null;
      _this.timeout = null;
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AnimateChild, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.onDomUpdated();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.onDomUpdated();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        clearTimeout(this.timeout);
        this._destroy = true;
        this.cleanDomEvent();
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            child = _state.child,
            eventActive = _state.eventActive;
        var _props = this.props,
            showProp = _props.showProp,
            transitionName = _props.transitionName;

        var _ref2 = child.props || {},
            className = _ref2.className;

        var currentEvent = this.getCurrentEvent();

        // Class name
        var connectClassName = transitionSupport && this.currentEvent ? __WEBPACK_IMPORTED_MODULE_9_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(transitionName, this.currentEvent.type), eventActive && Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(transitionName, this.currentEvent.type + '-active')) : className;

        var show = true;

        // Keep show when is in transition or has customize animate
        if (transitionSupport && (!currentEvent.empty || this.currentEvent && this.currentEvent.animateObj)) {
          show = true;
        } else {
          show = child.props[showProp];
        }

        // Clone child
        var newChildProps = {
          className: connectClassName
        };

        if (showProp) {
          newChildProps[showProp] = show;
        }

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, newChildProps);
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, prevState) {
        var _prevState$prevProps = prevState.prevProps,
            prevProps = _prevState$prevProps === undefined ? {} : _prevState$prevProps;
        var appeared = nextProps.appeared;


        var newState = {
          prevProps: Object(__WEBPACK_IMPORTED_MODULE_12__util__["b" /* cloneProps */])(nextProps, clonePropList)
        };

        function processState(propName, updater) {
          if (prevProps[propName] !== nextProps[propName]) {
            if (updater) {
              updater(nextProps[propName]);
            }
            return true;
          }
          return false;
        }

        function pushEvent(eventType) {
          var eventQueue = newState.eventQueue || prevState.eventQueue.slice();
          var matchIndex = eventQueue.indexOf(eventType);

          // Clean the rest event if eventType match
          if (matchIndex !== -1) {
            eventQueue = eventQueue.slice(0, matchIndex);
          }

          eventQueue.push(eventType);
          newState.eventQueue = eventQueue;
        }

        // Child update. Only set child.
        processState('children', function (child) {
          newState.child = child;
        });

        processState('appeared', function (isAppeared) {
          if (isAppeared) {
            pushEvent('appear');
          }
        });

        // Show update
        processState('show', function (show) {
          if (!appeared) {
            if (show) {
              pushEvent('enter');
            } else {
              pushEvent('leave');
            }
          }
        });

        return newState;
      }
    }]);

    return AnimateChild;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

  AnimateChild.propTypes = {
    transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
    transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    appeared: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

    animateKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    onChildLeaved: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

    onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  };


  Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(AnimateChild);

  return AnimateChild;
}

/* harmony default export */ __webpack_exports__["a"] = (genAnimateChild(__WEBPACK_IMPORTED_MODULE_12__util__["f" /* supportTransition */]));

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toArray;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toArray(children) {
  var ret = [];
  _react2['default'].Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}
module.exports = exports['default'];

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 467 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AUTO_SEARCH_INPUT_TIMEOUT=500;var AutoSearchInput=function(_React$Component){_inherits(AutoSearchInput,_React$Component);function AutoSearchInput(props){_classCallCheck(this,AutoSearchInput);var _this=_possibleConstructorReturn(this,(AutoSearchInput.__proto__||Object.getPrototypeOf(AutoSearchInput)).call(this,props));_this.state={tempValue:props.value||"",value:props.value||"",timeout:null};_this.onChange=_this.onChange.bind(_this);_this.onClear=_this.onClear.bind(_this);return _this;}_createClass(AutoSearchInput,[{key:'onClear',value:function onClear(){if(this.state.timeout){clearTimeout(this.state.timeout);}this.setState({tempValue:null,value:"",timeout:null});this.props.onSearch("");}},{key:'onChange',value:function onChange(value){var _this2=this;if(this.state.timeout){clearTimeout(this.state.timeout);}this.setState({tempValue:value,timeout:setTimeout(function(){_this2.setState({tempValue:null,value:value});_this2.props.onSearch(value);},AUTO_SEARCH_INPUT_TIMEOUT)});}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.state.timeout){clearTimeout(this.state.timeout);}}},{key:'render',value:function render(){var _this3=this;var placeholder=this.props.placeholder;var _state=this.state,tempValue=_state.tempValue,value=_state.value;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{onChange:function onChange(_ref){var target=_ref.target;return _this3.onChange(target.value);},placeholder:placeholder,value:tempValue!==null?tempValue:value,suffix:value===null||value.length===0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'search'}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'close-circle',theme:'filled',onClick:this.onClear,style:{cursor:"pointer"}})});}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,state){if(nextProps.value!==undefined&&nextProps.value!==state.value){if(state.timeout){clearTimeout(state.timeout);}return{tempValue:null,value:nextProps.value};}else{return null;}}}]);return AutoSearchInput;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AutoSearchInput);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDropdown = _interopRequireDefault(__webpack_require__(1041));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

var _warning = _interopRequireDefault(__webpack_require__(87));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _type = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).apply(this, arguments));

    _this.renderOverlay = function (prefixCls) {
      // rc-dropdown already can process the function of overlay, but we have check logic here.
      // So we need render the element to check and pass back to rc-dropdown.
      var overlay = _this.props.overlay;
      var overlayNode;

      if (typeof overlay === 'function') {
        overlayNode = overlay();
      } else {
        overlayNode = overlay;
      }

      overlayNode = React.Children.only(overlayNode);
      var overlayProps = overlayNode.props; // Warning if use other mode

      (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
      // menu should be focusable in dropdown defaultly

      var _overlayProps$selecta = overlayProps.selectable,
          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
          _overlayProps$focusab = overlayProps.focusable,
          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
      var expandIcon = React.createElement("span", {
        className: "".concat(prefixCls, "-menu-submenu-arrow")
      }, React.createElement(_icon["default"], {
        type: "right",
        className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
      }));
      var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlay : React.cloneElement(overlayNode, {
        mode: 'vertical',
        selectable: selectable,
        focusable: focusable,
        expandIcon: expandIcon
      });
      return fixedModeOverlay;
    };

    _this.renderDropDown = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          children = _this$props.children,
          trigger = _this$props.trigger,
          disabled = _this$props.disabled,
          getPopupContainer = _this$props.getPopupContainer;
      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
      var child = React.Children.only(children);
      var dropdownTrigger = React.cloneElement(child, {
        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
        disabled: disabled
      });
      var triggerActions = disabled ? [] : trigger;
      var alignPoint;

      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
        alignPoint = true;
      }

      return React.createElement(_rcDropdown["default"], _extends({
        alignPoint: alignPoint
      }, _this.props, {
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: _this.getTransitionName(),
        trigger: triggerActions,
        overlay: function overlay() {
          return _this.renderOverlay(prefixCls);
        }
      }), dropdownTrigger);
    };

    return _this;
  }

  _createClass(Dropdown, [{
    key: "getTransitionName",
    value: function getTransitionName() {
      var _this$props2 = this.props,
          _this$props2$placemen = _this$props2.placement,
          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen,
          transitionName = _this$props2.transitionName;

      if (transitionName !== undefined) {
        return transitionName;
      }

      if (placement.indexOf('top') >= 0) {
        return 'slide-down';
      }

      return 'slide-up';
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderDropDown);
    }
  }]);

  return Dropdown;
}(React.Component);

exports["default"] = Dropdown;
Dropdown.defaultProps = {
  mouseEnterDelay: 0.15,
  mouseLeaveDelay: 0.1,
  placement: 'bottomLeft'
};

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchInput=function(_React$Component){_inherits(SearchInput,_React$Component);function SearchInput(props){_classCallCheck(this,SearchInput);var _this=_possibleConstructorReturn(this,(SearchInput.__proto__||Object.getPrototypeOf(SearchInput)).call(this,props));_this.state={value:props.value||""};_this.onChange=_this.onChange.bind(_this);_this.onSearch=_this.onSearch.bind(_this);_this.onClear=_this.onClear.bind(_this);return _this;}_createClass(SearchInput,[{key:'onChange',value:function onChange(value){this.setState({value:value});}},{key:'onSearch',value:function onSearch(value){this.props.onSearch(value);}},{key:'onClear',value:function onClear(){this.setState({value:""});this.props.onSearch("");}},{key:'render',value:function render(){var _this2=this;var placeholder=this.props.placeholder;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:"search-input"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{onChange:function onChange(_ref){var target=_ref.target;return _this2.onChange(target.value);},placeholder:placeholder,value:value,suffix:value!==null&&value.length>0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'close-circle',theme:'filled',style:{cursor:"pointer"},onClick:function onClick(){return _this2.onClear();}}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null),addonAfter:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'search',style:{cursor:'pointer'},onClick:function onClick(){return _this2.onSearch(value);}}),onPressEnter:function onPressEnter(){return _this2.onSearch(value);}}));}}]);return SearchInput;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SearchInput);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VariableSizeGrid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VariableSizeList; });
/* unused harmony export FixedSizeGrid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixedSizeList; });
/* unused harmony export areEqual */
/* unused harmony export shouldComponentUpdate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_memoize_one__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(127);







// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();

  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}

var size = -1; // This utility copied from "dom-helpers" package.

function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (size === -1 || recalculate) {
    var div = document.createElement('div');
    var style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }

  return size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function isRTLOffsetNegative(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);
    outerDiv.scrollLeft = -10;
    cachedRTLResult = outerDiv.scrollLeft === -10;
    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;

var defaultItemKey = function defaultItemKey(_ref) {
  var columnIndex = _ref.columnIndex,
      data = _ref.data,
      rowIndex = _ref.rowIndex;
  return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsOverscanCount = null;
var devWarningsOverscanRowsColumnsCount = null;
var devWarningsTagName = null;

if (false) {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsOverscanCount =
    /*#__PURE__*/
    new WeakSet();
    devWarningsOverscanRowsColumnsCount =
    /*#__PURE__*/
    new WeakSet();
    devWarningsTagName =
    /*#__PURE__*/
    new WeakSet();
  }
}

function createGridComponent(_ref2) {
  var _class, _temp;

  var getColumnOffset = _ref2.getColumnOffset,
      getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset,
      getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex,
      getColumnWidth = _ref2.getColumnWidth,
      getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight,
      getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth,
      getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment,
      getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment,
      getRowHeight = _ref2.getRowHeight,
      getRowOffset = _ref2.getRowOffset,
      getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset,
      getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex,
      initInstanceProps = _ref2.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref2.validateProps;
  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Grid, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function Grid(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
      _this._resetIsScrollingTimeoutId = null;
      _this._outerRef = void 0;
      _this.state = {
        instance: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
        isScrolling: false,
        horizontalScrollDirection: 'forward',
        scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
        scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
        scrollUpdateWasRequested: false,
        verticalScrollDirection: 'forward'
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = Object(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
        return _this.props.onItemsRendered({
          overscanColumnStartIndex: overscanColumnStartIndex,
          overscanColumnStopIndex: overscanColumnStopIndex,
          overscanRowStartIndex: overscanRowStartIndex,
          overscanRowStopIndex: overscanRowStopIndex,
          visibleColumnStartIndex: visibleColumnStartIndex,
          visibleColumnStopIndex: visibleColumnStopIndex,
          visibleRowStartIndex: visibleRowStartIndex,
          visibleRowStopIndex: visibleRowStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = Object(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          horizontalScrollDirection: horizontalScrollDirection,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          verticalScrollDirection: verticalScrollDirection,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (rowIndex, columnIndex) {
        var _this$props = _this.props,
            columnWidth = _this$props.columnWidth,
            direction = _this$props.direction,
            rowHeight = _this$props.rowHeight;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);

        var key = rowIndex + ":" + columnIndex;
        var style;

        if (itemStyleCache.hasOwnProperty(key)) {
          style = itemStyleCache[key];
        } else {
          var _style;

          itemStyleCache[key] = style = (_style = {
            position: 'absolute'
          }, _style[direction === 'rtl' ? 'right' : 'left'] = getColumnOffset(_this.props, columnIndex, _this._instanceProps), _style.top = getRowOffset(_this.props, rowIndex, _this._instanceProps), _style.height = getRowHeight(_this.props, rowIndex, _this._instanceProps), _style.width = getColumnWidth(_this.props, columnIndex, _this._instanceProps), _style);
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = Object(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (_, __, ___) {
        return {};
      });

      _this._onScroll = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientHeight = _event$currentTarget.clientHeight,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollTop = _event$currentTarget.scrollTop,
            scrollHeight = _event$currentTarget.scrollHeight,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var calculatedScrollLeft = scrollLeft;

          if (direction === 'rtl') {
            var isNegative = isRTLOffsetNegative(); // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.

            if (isNegative) {
              calculatedScrollLeft = -scrollLeft;
            } else {
              calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
          var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
            scrollLeft: calculatedScrollLeft,
            scrollTop: calculatedScrollTop,
            verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1);
        });
      };

      return _this;
    }

    Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = Grid.prototype;

    _proto.scrollTo = function scrollTo(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;

      if (scrollLeft !== undefined) {
        scrollLeft = Math.max(0, scrollLeft);
      }

      if (scrollTop !== undefined) {
        scrollTop = Math.max(0, scrollTop);
      }

      this.setState(function (prevState) {
        if (scrollLeft === undefined) {
          scrollLeft = prevState.scrollLeft;
        }

        if (scrollTop === undefined) {
          scrollTop = prevState.scrollTop;
        }

        if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
          return null;
        }

        return {
          horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          scrollUpdateWasRequested: true,
          verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(_ref4) {
      var _ref4$align = _ref4.align,
          align = _ref4$align === void 0 ? 'auto' : _ref4$align,
          columnIndex = _ref4.columnIndex,
          rowIndex = _ref4.rowIndex;
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          height = _this$props2.height,
          rowCount = _this$props2.rowCount,
          width = _this$props2.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;
      var scrollbarSize = getScrollbarSize();

      if (columnIndex !== undefined) {
        columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
      }

      if (rowIndex !== undefined) {
        rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
      }

      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
      // to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.

      var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
      var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
      this.scrollTo({
        scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
        scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
      });
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          initialScrollLeft = _this$props3.initialScrollLeft,
          initialScrollTop = _this$props3.initialScrollTop;

      if (this._outerRef != null) {
        var outerRef = this._outerRef;

        if (typeof initialScrollLeft === 'number') {
          outerRef.scrollLeft = initialScrollLeft;
        }

        if (typeof initialScrollTop === 'number') {
          outerRef.scrollTop = initialScrollTop;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var direction = this.props.direction;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollTop = _this$state2.scrollTop,
          scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
        // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
        // So we need to determine which browser behavior we're dealing with, and mimic it.
        var outerRef = this._outerRef;

        if (direction === 'rtl') {
          var isNegative = isRTLOffsetNegative();

          if (isNegative) {
            outerRef.scrollLeft = -scrollLeft;
          } else {
            var clientWidth = outerRef.clientWidth,
                scrollWidth = outerRef.scrollWidth;
            outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
          }
        } else {
          outerRef.scrollLeft = Math.max(0, scrollLeft);
        }

        outerRef.scrollTop = Math.max(0, scrollTop);
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          columnCount = _this$props4.columnCount,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey : _this$props4$itemKey,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          rowCount = _this$props4.rowCount,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling;

      var _this$_getHorizontalR = this._getHorizontalRangeToRender(),
          columnStartIndex = _this$_getHorizontalR[0],
          columnStopIndex = _this$_getHorizontalR[1];

      var _this$_getVerticalRan = this._getVerticalRangeToRender(),
          rowStartIndex = _this$_getVerticalRan[0],
          rowStopIndex = _this$_getVerticalRan[1];

      var items = [];

      if (columnCount > 0 && rowCount) {
        for (var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++) {
          for (var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++) {
            items.push(Object(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(children, {
              columnIndex: _columnIndex,
              data: itemData,
              isScrolling: useIsScrolling ? isScrolling : undefined,
              key: itemKey({
                columnIndex: _columnIndex,
                data: itemData,
                rowIndex: _rowIndex
              }),
              rowIndex: _rowIndex,
              style: this._getItemStyle(_rowIndex, _columnIndex)
            }));
          }
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, Object(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: estimatedTotalHeight,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: estimatedTotalWidth
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      var _this$props5 = this.props,
          columnCount = _this$props5.columnCount,
          onItemsRendered = _this$props5.onItemsRendered,
          onScroll = _this$props5.onScroll,
          rowCount = _this$props5.rowCount;

      if (typeof onItemsRendered === 'function') {
        if (columnCount > 0 && rowCount > 0) {
          var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(),
              _overscanColumnStartIndex = _this$_getHorizontalR2[0],
              _overscanColumnStopIndex = _this$_getHorizontalR2[1],
              _visibleColumnStartIndex = _this$_getHorizontalR2[2],
              _visibleColumnStopIndex = _this$_getHorizontalR2[3];

          var _this$_getVerticalRan2 = this._getVerticalRangeToRender(),
              _overscanRowStartIndex = _this$_getVerticalRan2[0],
              _overscanRowStopIndex = _this$_getVerticalRan2[1],
              _visibleRowStartIndex = _this$_getVerticalRan2[2],
              _visibleRowStopIndex = _this$_getVerticalRan2[3];

          this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
        }
      }

      if (typeof onScroll === 'function') {
        var _this$state3 = this.state,
            _horizontalScrollDirection = _this$state3.horizontalScrollDirection,
            _scrollLeft = _this$state3.scrollLeft,
            _scrollTop = _this$state3.scrollTop,
            _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested,
            _verticalScrollDirection = _this$state3.verticalScrollDirection;

        this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
      }
    }; // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.


    _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
      var _this$props6 = this.props,
          columnCount = _this$props6.columnCount,
          overscanColumnCount = _this$props6.overscanColumnCount,
          overscanColumnsCount = _this$props6.overscanColumnsCount,
          overscanCount = _this$props6.overscanCount,
          rowCount = _this$props6.rowCount;
      var _this$state4 = this.state,
          horizontalScrollDirection = _this$state4.horizontalScrollDirection,
          isScrolling = _this$state4.isScrolling,
          scrollLeft = _this$state4.scrollLeft;
      var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
      var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
      var _this$props7 = this.props,
          columnCount = _this$props7.columnCount,
          overscanCount = _this$props7.overscanCount,
          overscanRowCount = _this$props7.overscanRowCount,
          overscanRowsCount = _this$props7.overscanRowsCount,
          rowCount = _this$props7.rowCount;
      var _this$state5 = this.state,
          isScrolling = _this$state5.isScrolling,
          verticalScrollDirection = _this$state5.verticalScrollDirection,
          scrollTop = _this$state5.scrollTop;
      var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
      var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return Grid;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    useIsScrolling: false
  }, _temp;
}

var validateSharedProps = function validateSharedProps(_ref5, _ref6) {
  var children = _ref5.children,
      direction = _ref5.direction,
      height = _ref5.height,
      innerTagName = _ref5.innerTagName,
      outerTagName = _ref5.outerTagName,
      overscanColumnsCount = _ref5.overscanColumnsCount,
      overscanCount = _ref5.overscanCount,
      overscanRowsCount = _ref5.overscanRowsCount,
      width = _ref5.width;
  var instance = _ref6.instance;

  if (false) {
    if (typeof overscanCount === 'number') {
      if (devWarningsOverscanCount && !devWarningsOverscanCount.has(instance)) {
        devWarningsOverscanCount.add(instance);
        console.warn('The overscanCount prop has been deprecated. ' + 'Please use the overscanColumnCount and overscanRowCount props instead.');
      }
    }

    if (typeof overscanColumnsCount === 'number' || typeof overscanRowsCount === 'number') {
      if (devWarningsOverscanRowsColumnsCount && !devWarningsOverscanRowsColumnsCount.has(instance)) {
        devWarningsOverscanRowsColumnsCount.add(instance);
        console.warn('The overscanColumnsCount and overscanRowsCount props have been deprecated. ' + 'Please use the overscanColumnCount and overscanRowCount props instead.');
      }
    }

    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName && !devWarningsTagName.has(instance)) {
        devWarningsTagName.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    switch (direction) {
      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    if (typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Grids must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    }

    if (typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Grids must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var DEFAULT_ESTIMATED_ITEM_SIZE = 50;

var getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
  var rowCount = _ref.rowCount;
  var rowMetadataMap = _ref2.rowMetadataMap,
      estimatedRowHeight = _ref2.estimatedRowHeight,
      lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredRowIndex >= rowCount) {
    lastMeasuredRowIndex = rowCount - 1;
  }

  if (lastMeasuredRowIndex >= 0) {
    var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
  var columnCount = _ref3.columnCount;
  var columnMetadataMap = _ref4.columnMetadataMap,
      estimatedColumnWidth = _ref4.estimatedColumnWidth,
      lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredColumnIndex >= columnCount) {
    lastMeasuredColumnIndex = columnCount - 1;
  }

  if (lastMeasuredColumnIndex >= 0) {
    var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
  var itemMetadataMap, itemSize, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    itemSize = props.columnWidth;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    itemSize = props.rowHeight;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    if (itemType === 'column') {
      instanceProps.lastMeasuredColumnIndex = index;
    } else {
      instanceProps.lastMeasuredRowIndex = index;
    }
  }

  return itemMetadataMap[index];
};

var findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
  var itemMetadataMap, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
  var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
  var size = itemType === 'column' ? props.width : props.height;
  var itemMetadata = getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
  // To ensure it reflects actual measurements instead of just estimates.

  var estimatedTotalSize = itemType === 'column' ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
  var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
  var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);

  if (align === 'smart') {
    if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
      align = 'auto';
    } else {
      align = 'center';
    }
  }

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return Math.round(minOffset + (maxOffset - minOffset) / 2);

    case 'auto':
    default:
      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
        return scrollOffset;
      } else if (scrollOffset - minOffset < maxOffset - scrollOffset) {
        return minOffset;
      } else {
        return maxOffset;
      }

  }
};

var VariableSizeGrid =
/*#__PURE__*/
createGridComponent({
  getColumnOffset: function getColumnOffset(props, index, instanceProps) {
    return getItemMetadata('column', props, index, instanceProps).offset;
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
    return findNearestItem('column', props, instanceProps, scrollLeft);
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
    var columnCount = props.columnCount,
        width = props.width;
    var itemMetadata = getItemMetadata('column', props, startIndex, instanceProps);
    var maxOffset = scrollLeft + width;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < columnCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('column', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  getColumnWidth: function getColumnWidth(props, index, instanceProps) {
    return instanceProps.columnMetadataMap[index].size;
  },
  getEstimatedTotalHeight: getEstimatedTotalHeight,
  getEstimatedTotalWidth: getEstimatedTotalWidth,
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getRowOffset: function getRowOffset(props, index, instanceProps) {
    return getItemMetadata('row', props, index, instanceProps).offset;
  },
  getRowHeight: function getRowHeight(props, index, instanceProps) {
    return instanceProps.rowMetadataMap[index].size;
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
    return findNearestItem('row', props, instanceProps, scrollTop);
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
    var rowCount = props.rowCount,
        height = props.height;
    var itemMetadata = getItemMetadata('row', props, startIndex, instanceProps);
    var maxOffset = scrollTop + height;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < rowCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('row', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref5 = props,
        estimatedColumnWidth = _ref5.estimatedColumnWidth,
        estimatedRowHeight = _ref5.estimatedRowHeight;
    var instanceProps = {
      columnMetadataMap: {},
      estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
      estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };

    instance.resetAfterColumnIndex = function (columnIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        columnIndex: columnIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterRowIndex = function (rowIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        rowIndex: rowIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterIndices = function (_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex,
          _ref6$shouldForceUpda = _ref6.shouldForceUpdate,
          shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;

      if (typeof columnIndex === 'number') {
        instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
      }

      if (typeof rowIndex === 'number') {
        instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
      } // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.


      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref7) {
    var columnWidth = _ref7.columnWidth,
        rowHeight = _ref7.rowHeight;

    if (false) {
      if (typeof columnWidth !== 'function') {
        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (columnWidth === null ? 'null' : typeof columnWidth) + "\" was specified."));
      } else if (typeof rowHeight !== 'function') {
        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (rowHeight === null ? 'null' : typeof rowHeight) + "\" was specified."));
      }
    }
  }
});

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (false) {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsDirection =
    /*#__PURE__*/
    new WeakSet();
    devWarningsTagName$1 =
    /*#__PURE__*/
    new WeakSet();
  }
}

function createListComponent(_ref) {
  var _class, _temp;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = Object(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = Object(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _style;

          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          itemStyleCache[index] = style = (_style = {
            position: 'absolute'
          }, _style[direction === 'rtl' ? 'right' : 'left'] = isHorizontal ? _offset : 0, _style.top = !isHorizontal ? _offset : 0, _style.height = !isHorizontal ? size : '100%', _style.width = isHorizontal ? size : '100%', _style);
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = Object(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            var isNegative = isRTLOffsetNegative(); // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.

            if (isNegative) {
              scrollOffset = -scrollLeft;
            } else {
              scrollOffset = scrollWidth - clientWidth - scrollLeft;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollLeft ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var itemCount = this.props.itemCount;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1));
      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props2 = this.props,
          direction = _this$props2.direction,
          initialScrollOffset = _this$props2.initialScrollOffset,
          layout = _this$props2.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          layout = _this$props3.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            var isNegative = isRTLOffsetNegative();

            if (isNegative) {
              outerRef.scrollLeft = -scrollOffset;
            } else {
              var clientWidth = outerRef.clientWidth,
                  scrollWidth = outerRef.scrollWidth;
              outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemCount = _this$props4.itemCount,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey$1 : _this$props4$itemKey,
          layout = _this$props4.layout,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(Object(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, Object(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    }; // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.


    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props5 = this.props,
          itemCount = _this$props5.itemCount,
          overscanCount = _this$props5.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _temp;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (false) {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    } // TODO Deprecate direction "horizontal"


    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';

    switch (direction) {
      case 'horizontal':
      case 'vertical':
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". ' + 'Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }

        break;

      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    switch (layout) {
      case 'horizontal':
      case 'vertical':
        // Valid values
        break;

      default:
        throw Error('An invalid "layout" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ("\"" + layout + "\" was specified."));
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    if (isHorizontal && typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    } else if (!isHorizontal && typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;

var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
  var _ref = props,
      itemSize = _ref.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    instanceProps.lastMeasuredIndex = index;
  }

  return itemMetadataMap[index];
};

var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
  var itemCount = props.itemCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
  var itemCount = _ref2.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap,
      estimatedItemSize = _ref3.estimatedItemSize,
      lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }

  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};

var VariableSizeList =
/*#__PURE__*/
createListComponent({
  getItemOffset: function getItemOffset(props, index, instanceProps) {
    return getItemMetadata$1(props, index, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index, instanceProps) {
    return instanceProps.itemMetadataMap[index].size;
  },
  getEstimatedTotalSize: getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.

    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset - minOffset < maxOffset - scrollOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        itemCount = props.itemCount,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < itemCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref4 = props,
        estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };

    instance.resetAfterIndex = function (index, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.

      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref5) {
    var itemSize = _ref5.itemSize;

    if (false) {
      if (typeof itemSize !== 'function') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

var FixedSizeGrid =
/*#__PURE__*/
createGridComponent({
  getColumnOffset: function getColumnOffset(_ref, index) {
    var columnWidth = _ref.columnWidth;
    return index * columnWidth;
  },
  getColumnWidth: function getColumnWidth(_ref2, index) {
    var columnWidth = _ref2.columnWidth;
    return columnWidth;
  },
  getRowOffset: function getRowOffset(_ref3, index) {
    var rowHeight = _ref3.rowHeight;
    return index * rowHeight;
  },
  getRowHeight: function getRowHeight(_ref4, index) {
    var rowHeight = _ref4.rowHeight;
    return rowHeight;
  },
  getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
    var rowCount = _ref5.rowCount,
        rowHeight = _ref5.rowHeight;
    return rowHeight * rowCount;
  },
  getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
    var columnCount = _ref6.columnCount,
        columnWidth = _ref6.columnWidth;
    return columnWidth * columnCount;
  },
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
    var columnCount = _ref7.columnCount,
        columnWidth = _ref7.columnWidth,
        width = _ref7.width;
    var maxOffset = Math.max(0, Math.min(columnCount * columnWidth - width, columnIndex * columnWidth));
    var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);

    if (align === 'smart') {
      if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
          return scrollLeft;
        } else if (scrollLeft - minOffset < maxOffset - scrollLeft) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
    var rowHeight = _ref8.rowHeight,
        height = _ref8.height,
        rowCount = _ref8.rowCount;
    var maxOffset = Math.max(0, Math.min(rowCount * rowHeight - height, rowIndex * rowHeight));
    var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);

    if (align === 'smart') {
      if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
          return scrollTop;
        } else if (scrollTop - minOffset < maxOffset - scrollTop) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
    var columnWidth = _ref9.columnWidth,
        columnCount = _ref9.columnCount;
    return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
    var columnWidth = _ref10.columnWidth,
        columnCount = _ref10.columnCount,
        width = _ref10.width;
    var left = startIndex * columnWidth;
    return Math.max(0, Math.min(columnCount - 1, startIndex + Math.floor((width + (scrollLeft - left)) / columnWidth)));
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
    var rowHeight = _ref11.rowHeight,
        rowCount = _ref11.rowCount;
    return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
    var rowHeight = _ref12.rowHeight,
        rowCount = _ref12.rowCount,
        height = _ref12.height;
    var left = startIndex * rowHeight;
    return Math.max(0, Math.min(rowCount - 1, startIndex + Math.floor((height + (scrollTop - left)) / rowHeight)));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref13) {
    var columnWidth = _ref13.columnWidth,
        rowHeight = _ref13.rowHeight;

    if (false) {
      if (typeof columnWidth !== 'number') {
        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (columnWidth === null ? 'null' : typeof columnWidth) + "\" was specified."));
      }

      if (typeof rowHeight !== 'number') {
        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (rowHeight === null ? 'null' : typeof rowHeight) + "\" was specified."));
      }
    }
  }
});

var FixedSizeList =
/*#__PURE__*/
createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize,
        size = _ref.size;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize,
        size = _ref2.size;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var maxOffset = Math.max(0, Math.min(itemCount * itemSize - size, index * itemSize));
    var minOffset = Math.max(0, index * itemSize - size + itemSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset - minOffset < maxOffset - scrollOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    return Math.max(0, Math.min(itemCount - 1, startIndex + Math.floor((size + (scrollOffset - offset)) / itemSize)));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (false) {
      if (typeof itemSize !== 'number') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(prev, next) {
  for (var attribute in prev) {
    if (!(attribute in next)) {
      return true;
    }
  }

  for (var _attribute in next) {
    if (prev[_attribute] !== next[_attribute]) {
      return true;
    }
  }

  return false;
}

// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo

function areEqual(prevProps, nextProps) {
  var prevStyle = prevProps.style,
      prevRest = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(prevProps, ["style"]);

  var nextStyle = nextProps.style,
      nextRest = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(nextProps, ["style"]);

  return !shallowDiffers(prevStyle, nextStyle) && !shallowDiffers(prevRest, nextRest);
}

// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate

function shouldComponentUpdate(nextProps, nextState) {
  return !areEqual(this.props, nextProps) || shallowDiffers(this.state, nextState);
}




/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DEFAULT_TABLE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ROW_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TABLE_TOTAL_BORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS_GUTTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CELL_PADDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHECKBOX_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COL_WIDTH_SAFE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return HEADER_CELL_GUTTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HEADER_CELL_CONTROLS_GUTTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FILTER_BUTTON_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SORT_BUTTON_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATA_INDEX_ACTIONS_OBJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DATA_INDEX_FIXED_ACTIONS_OBJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATA_INDEX_CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DATA_INDEX_RENDERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DATA_INDEX_ORIGINAL_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DATA_INDEX_ORIGINAL_TRANSLATED_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DATA_INDEX_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RESIZE_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PAGINATION_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return VIEW_INDEXES_UPDATE_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MAX_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DEFAULT_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEFAULT_PAGE_NUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TABLE_PLACEHOLDER_BGCOLOR; });
var DEFAULT_TABLE_HEIGHT=340;var ROW_HEIGHT=40;var TABLE_TOTAL_BORDER=2;var ACTIONS_GUTTER=4;var ACTION_WIDTH=24;var CELL_PADDING=8;var CHECKBOX_WIDTH=32;var COL_WIDTH_SAFE=4;var HEADER_CELL_GUTTER=4;var HEADER_CELL_CONTROLS_GUTTER=4;var FILTER_BUTTON_WIDTH=16;var SORT_BUTTON_WIDTH=16;var DATA_INDEX_ACTIONS_OBJS="_actions";var DATA_INDEX_FIXED_ACTIONS_OBJS="_fixedActions";var DATA_INDEX_CHECKED="_checked";var DATA_INDEX_RENDERED="__rendered";var DATA_INDEX_ORIGINAL_ROW="__originalRow";var DATA_INDEX_ORIGINAL_TRANSLATED_ROW="__originalTranslatedRow";var DATA_INDEX_HEIGHT="__height";var RESIZE_TIMEOUT=1000;var PAGINATION_TIMEOUT=500;var VIEW_INDEXES_UPDATE_TIMEOUT=200;var MAX_PAGE_SIZE=200;var DEFAULT_PAGE_SIZE=Math.floor(MAX_PAGE_SIZE/3)*3;var DEFAULT_PAGE_NUM=1;var TABLE_PLACEHOLDER_BGCOLOR="#fafafa";

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1053);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _debounce = _interopRequireDefault(__webpack_require__(212));

var _configProvider = __webpack_require__(35);

var _type = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var SpinSizes = (0, _type.tuple)('small', 'default', 'large'); // Render indicator

var defaultIndicator = null;

function renderIndicator(prefixCls, props) {
  var indicator = props.indicator;
  var dotClassName = "".concat(prefixCls, "-dot");

  if (React.isValidElement(indicator)) {
    return React.cloneElement(indicator, {
      className: (0, _classnames["default"])(indicator.props.className, dotClassName)
    });
  }

  if (React.isValidElement(defaultIndicator)) {
    return React.cloneElement(defaultIndicator, {
      className: (0, _classnames["default"])(defaultIndicator.props.className, dotClassName)
    });
  }

  return React.createElement("span", {
    className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
  }, React.createElement("i", null), React.createElement("i", null), React.createElement("i", null), React.createElement("i", null));
}

function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}

var Spin =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Spin, _React$Component);

  function Spin(props) {
    var _this;

    _classCallCheck(this, Spin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Spin).call(this, props));

    _this.debouncifyUpdateSpinning = function (props) {
      var _ref = props || _this.props,
          delay = _ref.delay;

      if (delay) {
        _this.updateSpinning = (0, _debounce["default"])(_this.originalUpdateSpinning, delay);
      }
    };

    _this.updateSpinning = function () {
      var spinning = _this.props.spinning;
      var currentSpinning = _this.state.spinning;

      if (currentSpinning !== spinning) {
        _this.setState({
          spinning: spinning
        });
      }
    };

    _this.renderSpin = function (_ref2) {
      var _classNames;

      var getPrefixCls = _ref2.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          size = _a.size,
          tip = _a.tip,
          wrapperClassName = _a.wrapperClassName,
          style = _a.style,
          restProps = __rest(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);

      var spinning = _this.state.spinning;
      var prefixCls = getPrefixCls('spin', customizePrefixCls);
      var spinClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _classNames), className); // fix https://fb.me/react-unknown-prop

      var divProps = (0, _omit["default"])(restProps, ['spinning', 'delay', 'indicator']);
      var spinElement = React.createElement("div", _extends({}, divProps, {
        style: style,
        className: spinClassName
      }), renderIndicator(prefixCls, _this.props), tip ? React.createElement("div", {
        className: "".concat(prefixCls, "-text")
      }, tip) : null);

      if (_this.isNestedPattern()) {
        var containerClassName = (0, _classnames["default"])("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
        return React.createElement("div", _extends({}, divProps, {
          className: (0, _classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
        }), spinning && React.createElement("div", {
          key: "loading"
        }, spinElement), React.createElement("div", {
          className: containerClassName,
          key: "container"
        }, _this.props.children));
      }

      return spinElement;
    };

    var spinning = props.spinning,
        delay = props.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    _this.state = {
      spinning: spinning && !shouldBeDelayed
    };
    _this.originalUpdateSpinning = _this.updateSpinning;

    _this.debouncifyUpdateSpinning(props);

    return _this;
  }

  _createClass(Spin, [{
    key: "isNestedPattern",
    value: function isNestedPattern() {
      return !!(this.props && this.props.children);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var updateSpinning = this.updateSpinning;

      if (updateSpinning && updateSpinning.cancel) {
        updateSpinning.cancel();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSpinning();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.debouncifyUpdateSpinning();
      this.updateSpinning();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSpin);
    }
  }], [{
    key: "setDefaultIndicator",
    value: function setDefaultIndicator(indicator) {
      defaultIndicator = indicator;
    }
  }]);

  return Spin;
}(React.Component);

Spin.defaultProps = {
  spinning: true,
  size: 'default',
  wrapperClassName: ''
};
Spin.propTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  spinning: PropTypes.bool,
  size: PropTypes.oneOf(SpinSizes),
  wrapperClassName: PropTypes.string,
  indicator: PropTypes.element
};
var _default = Spin;
exports["default"] = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var createResizeDetector = _interopDefault(__webpack_require__(1054));
var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(__webpack_require__(5));
var ReactDOM = _interopDefault(__webpack_require__(38));
var invariant = _interopDefault(__webpack_require__(79));
var throttleDebounce = __webpack_require__(1065);
var isShallowEqual = _interopDefault(__webpack_require__(132));

var instances = {};

// Lazily require to not cause bug
// https://github.com/ctrlplusb/react-sizeme/issues/6
function resizeDetector() {
  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scroll';

  if (!instances[strategy]) {
    instances[strategy] = createResizeDetector({
      strategy: strategy
    });
  }

  return instances[strategy];
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/* eslint-disable react/no-multi-comp */

var errMsg = 'react-sizeme: an error occurred whilst stopping to listen to node size changes';

var defaultConfig = {
  monitorWidth: true,
  monitorHeight: false,
  monitorPosition: false,
  refreshRate: 16,
  refreshMode: 'throttle',
  noPlaceholder: false,
  resizeDetectorStrategy: 'scroll'
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * This is a utility wrapper component that will allow our higher order
 * component to get a ref handle on our wrapped components html.
 * @see https://gist.github.com/jimfb/32b587ee6177665fb4cf
 */

var ReferenceWrapper = function (_Component) {
  inherits(ReferenceWrapper, _Component);

  function ReferenceWrapper() {
    classCallCheck(this, ReferenceWrapper);
    return possibleConstructorReturn(this, (ReferenceWrapper.__proto__ || Object.getPrototypeOf(ReferenceWrapper)).apply(this, arguments));
  }

  createClass(ReferenceWrapper, [{
    key: 'render',
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);
  return ReferenceWrapper;
}(React.Component);

ReferenceWrapper.displayName = 'SizeMeReferenceWrapper';

ReferenceWrapper.propTypes = { children: PropTypes.element.isRequired };

function Placeholder(_ref) {
  var className = _ref.className,
      style = _ref.style;

  // Lets create the props for the temp element.
  var phProps = {};

  // We will use any provided className/style or else make the temp
  // container take the full available space.
  if (!className && !style) {
    phProps.style = { width: '100%', height: '100%' };
  } else {
    if (className) {
      phProps.className = className;
    }
    if (style) {
      phProps.style = style;
    }
  }

  return React__default.createElement('div', phProps);
}
Placeholder.displayName = 'SizeMePlaceholder';
Placeholder.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object

  /**
   * As we need to maintain a ref on the root node that is rendered within our
   * SizeMe component we need to wrap our entire render in a sub component.
   * Without this, we lose the DOM ref after the placeholder is removed from
   * the render and the actual component is rendered.
   * It took me forever to figure this out, so tread extra careful on this one!
   */
};var renderWrapper = function renderWrapper(WrappedComponent) {
  function SizeMeRenderer(props) {
    var explicitRef = props.explicitRef,
        className = props.className,
        style = props.style,
        size = props.size,
        disablePlaceholder = props.disablePlaceholder,
        onSize = props.onSize,
        restProps = objectWithoutProperties(props, ['explicitRef', 'className', 'style', 'size', 'disablePlaceholder', 'onSize']);


    var noSizeData = size == null || size.width == null && size.height == null && size.position == null;

    var renderPlaceholder = noSizeData && !disablePlaceholder;

    var renderProps = {
      className: className,
      style: style
    };

    if (size != null) {
      renderProps.size = size;
    }

    var toRender = renderPlaceholder ? React__default.createElement(Placeholder, { className: className, style: style }) : React__default.createElement(WrappedComponent, _extends({}, renderProps, restProps));

    return React__default.createElement(
      ReferenceWrapper,
      { ref: explicitRef },
      toRender
    );
  }

  SizeMeRenderer.displayName = 'SizeMeRenderer(' + getDisplayName(WrappedComponent) + ')';

  SizeMeRenderer.propTypes = {
    explicitRef: PropTypes.func.isRequired,
    className: PropTypes.string,
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    size: PropTypes.shape({
      width: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
      height: PropTypes.number // eslint-disable-line react/no-unused-prop-types
    }),
    disablePlaceholder: PropTypes.bool,
    onSize: PropTypes.func
  };

  return SizeMeRenderer;
};

/**
 * :: config -> Component -> WrappedComponent
 *
 * Higher order component that allows the wrapped component to become aware
 * of it's size, by receiving it as an object within it's props.
 *
 * @param  monitorWidth
 *   Default true, whether changes in the element's width should be monitored,
 *   causing a size property to be broadcast.
 * @param  monitorHeight
 *   Default false, whether changes in the element's height should be monitored,
 *   causing a size property to be broadcast.
 *
 * @return The wrapped component.
 */
function withSize() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
  var _config$monitorWidth = config.monitorWidth,
      monitorWidth = _config$monitorWidth === undefined ? defaultConfig.monitorWidth : _config$monitorWidth,
      _config$monitorHeight = config.monitorHeight,
      monitorHeight = _config$monitorHeight === undefined ? defaultConfig.monitorHeight : _config$monitorHeight,
      _config$monitorPositi = config.monitorPosition,
      monitorPosition = _config$monitorPositi === undefined ? defaultConfig.monitorPosition : _config$monitorPositi,
      _config$refreshRate = config.refreshRate,
      refreshRate = _config$refreshRate === undefined ? defaultConfig.refreshRate : _config$refreshRate,
      _config$refreshMode = config.refreshMode,
      refreshMode = _config$refreshMode === undefined ? defaultConfig.refreshMode : _config$refreshMode,
      _config$noPlaceholder = config.noPlaceholder,
      noPlaceholder = _config$noPlaceholder === undefined ? defaultConfig.noPlaceholder : _config$noPlaceholder,
      _config$resizeDetecto = config.resizeDetectorStrategy,
      resizeDetectorStrategy = _config$resizeDetecto === undefined ? defaultConfig.resizeDetectorStrategy : _config$resizeDetecto;


  invariant(monitorWidth || monitorHeight || monitorPosition, 'You have to monitor at least one of the width, height, or position when using "sizeMe"');

  invariant(refreshRate >= 16, "It is highly recommended that you don't put your refreshRate lower than " + '16 as this may cause layout thrashing.');

  invariant(refreshMode === 'throttle' || refreshMode === 'debounce', 'The refreshMode should have a value of "throttle" or "debounce"');

  var refreshDelayStrategy = refreshMode === 'throttle' ? throttleDebounce.throttle : throttleDebounce.debounce;

  return function WrapComponent(WrappedComponent) {
    var SizeMeRenderWrapper = renderWrapper(WrappedComponent);

    var SizeAwareComponent = function (_React$Component) {
      inherits(SizeAwareComponent, _React$Component);

      function SizeAwareComponent() {
        var _ref2;

        var _temp, _this2, _ret;

        classCallCheck(this, SizeAwareComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = possibleConstructorReturn(this, (_ref2 = SizeAwareComponent.__proto__ || Object.getPrototypeOf(SizeAwareComponent)).call.apply(_ref2, [this].concat(args))), _this2), _this2.domEl = null, _this2.state = {
          width: undefined,
          height: undefined,
          position: undefined
        }, _this2.uninstall = function () {
          if (_this2.domEl) {
            try {
              _this2.detector.uninstall(_this2.domEl);
            } catch (err) {
              // eslint-disable-next-line no-console
              console.warn(errMsg);
            }
            _this2.domEl = null;
          }
        }, _this2.determineStrategy = function (props) {
          if (props.onSize) {
            if (!_this2.callbackState) {
              _this2.callbackState = _extends({}, _this2.state);
            }
            _this2.strategy = 'callback';
          } else {
            _this2.strategy = 'render';
          }
        }, _this2.strategisedSetState = function (state) {
          if (_this2.strategy === 'callback') {
            _this2.callbackState = state;
            _this2.props.onSize(state);
          }
          _this2.setState(state);
        }, _this2.strategisedGetState = function () {
          return _this2.strategy === 'callback' ? _this2.callbackState : _this2.state;
        }, _this2.refCallback = function (element) {
          _this2.element = element;
        }, _this2.hasSizeChanged = function (current, next) {
          var c = current;
          var n = next;
          var cp = c.position || {};
          var np = n.position || {};

          return monitorWidth && c.width !== n.width || monitorHeight && c.height !== n.height || monitorPosition && (cp.top !== np.top || cp.left !== np.left || cp.bottom !== np.bottom || cp.right !== np.right);
        }, _this2.checkIfSizeChanged = refreshDelayStrategy(refreshRate, function (el) {
          var _el$getBoundingClient = el.getBoundingClientRect(),
              width = _el$getBoundingClient.width,
              height = _el$getBoundingClient.height,
              right = _el$getBoundingClient.right,
              left = _el$getBoundingClient.left,
              top = _el$getBoundingClient.top,
              bottom = _el$getBoundingClient.bottom;

          var next = {
            width: monitorWidth ? width : null,
            height: monitorHeight ? height : null,
            position: monitorPosition ? { right: right, left: left, top: top, bottom: bottom } : null
          };

          if (_this2.hasSizeChanged(_this2.strategisedGetState(), next)) {
            _this2.strategisedSetState(next);
          }
        }), _temp), possibleConstructorReturn(_this2, _ret);
      }

      createClass(SizeAwareComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.detector = resizeDetector(resizeDetectorStrategy);
          this.determineStrategy(this.props);
          this.handleDOMNode();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.determineStrategy(this.props);
          this.handleDOMNode();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          // Change our size checker to a noop just in case we have some
          // late running events.
          this.hasSizeChanged = function () {
            return undefined;
          };
          this.checkIfSizeChanged = function () {
            return undefined;
          };
          this.uninstall();
        }
      }, {
        key: 'handleDOMNode',
        value: function handleDOMNode() {
          var found = this.element && ReactDOM.findDOMNode(this.element);

          if (!found) {
            // If we previously had a dom node then we need to ensure that
            // we remove any existing listeners to avoid memory leaks.
            this.uninstall();
            return;
          }

          if (!this.domEl) {
            this.domEl = found;
            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
          } else if (!this.domEl.isSameNode(found)) {
            this.uninstall();
            this.domEl = found;
            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var disablePlaceholder = withSize.enableSSRBehaviour || withSize.noPlaceholders || noPlaceholder || this.strategy === 'callback';

          var size = _extends({}, this.state);

          return React__default.createElement(SizeMeRenderWrapper, _extends({
            explicitRef: this.refCallback,
            size: this.strategy === 'callback' ? null : size,
            disablePlaceholder: disablePlaceholder
          }, this.props));
        }
      }]);
      return SizeAwareComponent;
    }(React__default.Component);

    SizeAwareComponent.displayName = 'SizeMe(' + getDisplayName(WrappedComponent) + ')';
    SizeAwareComponent.propTypes = {
      onSize: PropTypes.func
    };


    SizeAwareComponent.WrappedComponent = WrappedComponent;

    return SizeAwareComponent;
  };
}

/**
 * Allow SizeMe to run within SSR environments.  This is a "global" behaviour
 * flag that should be set within the initialisation phase of your application.
 *
 * Warning: don't set this flag unless you need to as using it may cause
 * extra render cycles to happen within your components depending on the logic
 * contained within them around the usage of the `size` data.
 *
 * DEPRECATED: Please use the global noPlaceholders
 */
withSize.enableSSRBehaviour = false;

/**
 * Global configuration allowing to disable placeholder rendering for all
 * sizeMe components.
 */
withSize.noPlaceholders = false;

var SizeMe = function (_Component) {
  inherits(SizeMe, _Component);

  function SizeMe(props) {
    classCallCheck(this, SizeMe);

    var _this = possibleConstructorReturn(this, (SizeMe.__proto__ || Object.getPrototypeOf(SizeMe)).call(this, props));

    _initialiseProps.call(_this);

    var children = props.children,
        render = props.render,
        sizeMeConfig = objectWithoutProperties(props, ['children', 'render']);

    _this.createComponent(sizeMeConfig);
    _this.state = {
      size: {
        width: undefined,
        height: undefined
      }
    };
    return _this;
  }

  createClass(SizeMe, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          prevChildren = _props.children,
          prevRender = _props.render,
          currentSizeMeConfig = objectWithoutProperties(_props, ['children', 'render']);
      var nextChildren = prevProps.children,
          nextRender = prevProps.render,
          prevSizeMeConfig = objectWithoutProperties(prevProps, ['children', 'render']);

      if (!isShallowEqual(currentSizeMeConfig, prevSizeMeConfig)) {
        this.createComponent(currentSizeMeConfig);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var SizeAware = this.SizeAware;

      var render = this.props.children || this.props.render;
      return React__default.createElement(
        SizeAware,
        { onSize: this.onSize },
        render({ size: this.state.size })
      );
    }
  }]);
  return SizeMe;
}(React.Component);

SizeMe.propTypes = {
  children: PropTypes.func,
  render: PropTypes.func
};
SizeMe.defaultProps = {
  children: undefined,
  render: undefined
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.createComponent = function (config) {
    _this2.SizeAware = withSize(config)(function (_ref) {
      var children = _ref.children;
      return children;
    });
  };

  this.onSize = function (size) {
    return _this2.setState({ size: size });
  };
};

withSize.SizeMe = SizeMe;
withSize.withSize = withSize;

module.exports = withSize;
//# sourceMappingURL=react-sizeme.js.map


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDataOrAriaProps;

function getDataOrAriaProps(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1069);

__webpack_require__(26);

__webpack_require__(324);

__webpack_require__(325);

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rcCalendar = _interopRequireDefault(__webpack_require__(482));

var _MonthCalendar = _interopRequireDefault(__webpack_require__(486));

var _createPicker = _interopRequireDefault(__webpack_require__(1095));

var _wrapPicker = _interopRequireDefault(__webpack_require__(1098));

var _RangePicker = _interopRequireDefault(__webpack_require__(1104));

var _WeekPicker = _interopRequireDefault(__webpack_require__(1113));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DatePicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_rcCalendar["default"]));
var MonthPicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_MonthCalendar["default"]), 'YYYY-MM');

_extends(DatePicker, {
  RangePicker: (0, _wrapPicker["default"])(_RangePicker["default"]),
  MonthPicker: MonthPicker,
  WeekPicker: (0, _wrapPicker["default"])(_WeekPicker["default"], 'gggg-wo')
});

var _default = DatePicker;
exports["default"] = _default;

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(1072);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Calendar__["a" /* default */]);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapSelf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, mirror);
}

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
});

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyCode = __webpack_require__(230);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _CalendarHeader = __webpack_require__(487);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _CalendarFooter = __webpack_require__(1093);

var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);

var _CalendarMixin = __webpack_require__(1094);

var _CommonMixin = __webpack_require__(492);

var _moment = __webpack_require__(46);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MonthCalendar = function (_React$Component) {
  (0, _inherits3['default'])(MonthCalendar, _React$Component);

  function MonthCalendar(props) {
    (0, _classCallCheck3['default'])(this, MonthCalendar);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.onKeyDown = function (event) {
      var keyCode = event.keyCode;
      var ctrlKey = event.ctrlKey || event.metaKey;
      var stateValue = _this.state.value;
      var disabledDate = _this.props.disabledDate;

      var value = stateValue;
      switch (keyCode) {
        case _KeyCode2['default'].DOWN:
          value = stateValue.clone();
          value.add(3, 'months');
          break;
        case _KeyCode2['default'].UP:
          value = stateValue.clone();
          value.add(-3, 'months');
          break;
        case _KeyCode2['default'].LEFT:
          value = stateValue.clone();
          if (ctrlKey) {
            value.add(-1, 'years');
          } else {
            value.add(-1, 'months');
          }
          break;
        case _KeyCode2['default'].RIGHT:
          value = stateValue.clone();
          if (ctrlKey) {
            value.add(1, 'years');
          } else {
            value.add(1, 'months');
          }
          break;
        case _KeyCode2['default'].ENTER:
          if (!disabledDate || !disabledDate(stateValue)) {
            _this.onSelect(stateValue);
          }
          event.preventDefault();
          return 1;
        default:
          return undefined;
      }
      if (value !== stateValue) {
        _this.setValue(value);
        event.preventDefault();
        return 1;
      }
    };

    _this.handlePanelChange = function (_, mode) {
      if (mode !== 'date') {
        _this.setState({ mode: mode });
      }
    };

    _this.state = {
      mode: 'month',
      value: props.value || props.defaultValue || (0, _moment2['default'])(),
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
    return _this;
  }

  MonthCalendar.prototype.render = function render() {
    var props = this.props,
        state = this.state;
    var mode = state.mode,
        value = state.value;

    var children = _react2['default'].createElement(
      'div',
      { className: props.prefixCls + '-month-calendar-content' },
      _react2['default'].createElement(
        'div',
        { className: props.prefixCls + '-month-header-wrap' },
        _react2['default'].createElement(_CalendarHeader2['default'], {
          prefixCls: props.prefixCls,
          mode: mode,
          value: value,
          locale: props.locale,
          disabledMonth: props.disabledDate,
          monthCellRender: props.monthCellRender,
          monthCellContentRender: props.monthCellContentRender,
          onMonthSelect: this.onSelect,
          onValueChange: this.setValue,
          onPanelChange: this.handlePanelChange
        })
      ),
      _react2['default'].createElement(_CalendarFooter2['default'], {
        prefixCls: props.prefixCls,
        renderFooter: props.renderFooter
      })
    );
    return this.renderRoot({
      className: props.prefixCls + '-month-calendar',
      children: children
    });
  };

  return MonthCalendar;
}(_react2['default'].Component);

MonthCalendar.propTypes = (0, _extends3['default'])({}, _CalendarMixin.calendarMixinPropTypes, _CommonMixin.propType, {
  monthCellRender: _propTypes2['default'].func,
  dateCellRender: _propTypes2['default'].func,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  selectedValue: _propTypes2['default'].object,
  defaultSelectedValue: _propTypes2['default'].object,
  disabledDate: _propTypes2['default'].func
});
MonthCalendar.defaultProps = (0, _extends3['default'])({}, _CommonMixin.defaultProp, _CalendarMixin.calendarMixinDefaultProps);
exports['default'] = (0, _CalendarMixin.calendarMixinWrapper)((0, _CommonMixin.commonMixinWrapper)(MonthCalendar));
module.exports = exports['default'];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapSelf = __webpack_require__(488);

var _mapSelf2 = _interopRequireDefault(_mapSelf);

var _MonthPanel = __webpack_require__(1089);

var _MonthPanel2 = _interopRequireDefault(_MonthPanel);

var _YearPanel = __webpack_require__(1091);

var _YearPanel2 = _interopRequireDefault(_YearPanel);

var _DecadePanel = __webpack_require__(1092);

var _DecadePanel2 = _interopRequireDefault(_DecadePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = function (_React$Component) {
  (0, _inherits3['default'])(CalendarHeader, _React$Component);

  function CalendarHeader(props) {
    (0, _classCallCheck3['default'])(this, CalendarHeader);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.nextMonth = goMonth.bind(_this, 1);
    _this.previousMonth = goMonth.bind(_this, -1);
    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);

    _this.state = { yearPanelReferer: null };
    return _this;
  }

  CalendarHeader.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth,
        renderFooter = props.renderFooter;


    var panel = null;
    if (mode === 'month') {
      panel = _react2['default'].createElement(_MonthPanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onMonthSelect,
        onYearPanelShow: function onYearPanelShow() {
          return _this2.showYearPanel('month');
        },
        disabledDate: disabledMonth,
        cellRender: props.monthCellRender,
        contentRender: props.monthCellContentRender,
        renderFooter: renderFooter
      });
    }
    if (mode === 'year') {
      panel = _react2['default'].createElement(_YearPanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onYearSelect,
        onDecadePanelShow: this.showDecadePanel,
        renderFooter: renderFooter
      });
    }
    if (mode === 'decade') {
      panel = _react2['default'].createElement(_DecadePanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onDecadeSelect,
        renderFooter: renderFooter
      });
    }

    return _react2['default'].createElement(
      'div',
      { className: prefixCls + '-header' },
      _react2['default'].createElement(
        'div',
        { style: { position: 'relative' } },
        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-prev-year-btn',
          role: 'button',
          onClick: this.previousYear,
          title: locale.previousYear
        })),
        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-prev-month-btn',
          role: 'button',
          onClick: this.previousMonth,
          title: locale.previousMonth
        })),
        this.monthYearElement(showTimePicker),
        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-next-month-btn',
          onClick: this.nextMonth,
          title: locale.nextMonth
        })),
        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-next-year-btn',
          onClick: this.nextYear,
          title: locale.nextYear
        }))
      ),
      panel
    );
  };

  return CalendarHeader;
}(_react2['default'].Component);

CalendarHeader.propTypes = {
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  onValueChange: _propTypes2['default'].func,
  showTimePicker: _propTypes2['default'].bool,
  onPanelChange: _propTypes2['default'].func,
  locale: _propTypes2['default'].object,
  enablePrev: _propTypes2['default'].any,
  enableNext: _propTypes2['default'].any,
  disabledMonth: _propTypes2['default'].func,
  renderFooter: _propTypes2['default'].func,
  onMonthSelect: _propTypes2['default'].func
};
CalendarHeader.defaultProps = {
  enableNext: 1,
  enablePrev: 1,
  onPanelChange: function onPanelChange() {},
  onValueChange: function onValueChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onMonthSelect = function (value) {
    _this3.props.onPanelChange(value, 'date');
    if (_this3.props.onMonthSelect) {
      _this3.props.onMonthSelect(value);
    } else {
      _this3.props.onValueChange(value);
    }
  };

  this.onYearSelect = function (value) {
    var referer = _this3.state.yearPanelReferer;
    _this3.setState({ yearPanelReferer: null });
    _this3.props.onPanelChange(value, referer);
    _this3.props.onValueChange(value);
  };

  this.onDecadeSelect = function (value) {
    _this3.props.onPanelChange(value, 'year');
    _this3.props.onValueChange(value);
  };

  this.monthYearElement = function (showTimePicker) {
    var props = _this3.props;
    var prefixCls = props.prefixCls;
    var locale = props.locale;
    var value = props.value;
    var localeData = value.localeData();
    var monthBeforeYear = locale.monthBeforeYear;
    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
    var timeClassName = showTimePicker ? ' ' + prefixCls + '-time-status' : '';
    var year = _react2['default'].createElement(
      'a',
      {
        className: prefixCls + '-year-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : function () {
          return _this3.showYearPanel('date');
        },
        title: showTimePicker ? null : locale.yearSelect
      },
      value.format(locale.yearFormat)
    );
    var month = _react2['default'].createElement(
      'a',
      {
        className: prefixCls + '-month-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : _this3.showMonthPanel,
        title: showTimePicker ? null : locale.monthSelect
      },
      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
    );
    var day = void 0;
    if (showTimePicker) {
      day = _react2['default'].createElement(
        'a',
        {
          className: prefixCls + '-day-select' + timeClassName,
          role: 'button'
        },
        value.format(locale.dayFormat)
      );
    }
    var my = [];
    if (monthBeforeYear) {
      my = [month, day, year];
    } else {
      my = [year, month, day];
    }
    return _react2['default'].createElement(
      'span',
      { className: selectClassName },
      (0, _mapSelf2['default'])(my)
    );
  };

  this.showMonthPanel = function () {
    // null means that users' interaction doesn't change value
    _this3.props.onPanelChange(null, 'month');
  };

  this.showYearPanel = function (referer) {
    _this3.setState({ yearPanelReferer: referer });
    _this3.props.onPanelChange(null, 'year');
  };

  this.showDecadePanel = function () {
    _this3.props.onPanelChange(null, 'decade');
  };
};

exports['default'] = CalendarHeader;
module.exports = exports['default'];

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = mapSelf;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return _react2['default'].Children.map(children, mirror);
}
module.exports = exports['default'];

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = TodayButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;

  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !(0, _util.isAllowedDate)((0, _util.getTodayTime)(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return _react2['default'].createElement(
    'a',
    {
      className: prefixCls + '-today-btn ' + disabledTodayClass,
      role: 'button',
      onClick: isDisabled ? null : onToday,
      title: (0, _util.getTodayTimeStr)(value)
    },
    localeNow
  );
}
module.exports = exports['default'];

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = OkButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + "-ok-btn";
  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }
  return _react2["default"].createElement(
    "a",
    {
      className: className,
      role: "button",
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}
module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = TimePickerButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(15);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;

  var className = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
  var onClick = null;
  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }
  return _react2['default'].createElement(
    'a',
    {
      className: className,
      role: 'button',
      onClick: onClick
    },
    showTimePicker ? locale.dateSelect : locale.timeSelect
  );
}
module.exports = exports['default'];

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.commonMixinWrapper = exports.defaultProp = exports.propType = undefined;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _en_US = __webpack_require__(368);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

var propType = exports.propType = {
  className: _propTypes2['default'].string,
  locale: _propTypes2['default'].object,
  style: _propTypes2['default'].object,
  visible: _propTypes2['default'].bool,
  onSelect: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  onChange: _propTypes2['default'].func,
  onOk: _propTypes2['default'].func
};

var defaultProp = exports.defaultProp = {
  locale: _en_US2['default'],
  style: {},
  visible: true,
  prefixCls: 'rc-calendar',
  className: '',
  onSelect: noop,
  onChange: noop,
  onClear: noop,
  renderFooter: function renderFooter() {
    return null;
  },
  renderSidebar: function renderSidebar() {
    return null;
  }
};

var commonMixinWrapper = exports.commonMixinWrapper = function commonMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    (0, _inherits3['default'])(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      (0, _classCallCheck3['default'])(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.getFormat = function () {
        var format = _this.props.format;
        var _this$props = _this.props,
            locale = _this$props.locale,
            timePicker = _this$props.timePicker;

        if (!format) {
          if (timePicker) {
            format = locale.dateTimeFormat;
          } else {
            format = locale.dateFormat;
          }
        }
        return format;
      }, _this.focus = function () {
        if (_this.focusElement) {
          _this.focusElement.focus();
        } else if (_this.rootInstance) {
          _this.rootInstance.focus();
        }
      }, _this.saveFocusElement = function (focusElement) {
        _this.focusElement = focusElement;
      }, _this.saveRoot = function (root) {
        _this.rootInstance = root;
      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
    }

    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CommonMixinWrapper', _temp2;
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _moment = _interopRequireDefault(__webpack_require__(46));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _Header = _interopRequireDefault(__webpack_require__(1099));

var _Combobox = _interopRequireDefault(__webpack_require__(1100));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function noop() {}

function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var arr = [];

  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }

  return arr;
}

function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
  var hour = hourOptions.slice().sort(function (a, b) {
    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
  })[0];
  var minute = minuteOptions.slice().sort(function (a, b) {
    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
  })[0];
  var second = secondOptions.slice().sort(function (a, b) {
    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
  })[0];
  return (0, _moment["default"])("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
}

var Panel =
/*#__PURE__*/
function (_Component) {
  _inherits(Panel, _Component);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Panel).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: newValue
      });

      onChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCurrentSelectPanelChange", function (currentSelectPanel) {
      _this.setState({
        currentSelectPanel: currentSelectPanel
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disabledHours", function () {
      var _this$props = _this.props,
          use12Hours = _this$props.use12Hours,
          disabledHours = _this$props.disabledHours;
      var disabledOptions = disabledHours();

      if (use12Hours && Array.isArray(disabledOptions)) {
        if (_this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }

      return disabledOptions;
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(Panel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;

      if (value) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "close",
    // https://github.com/ant-design/ant-design/issues/5829
    value: function close() {
      var onEsc = this.props.onEsc;
      onEsc();
    }
  }, {
    key: "isAM",
    value: function isAM() {
      var defaultOpenValue = this.props.defaultOpenValue;
      var value = this.state.value;
      var realValue = value || defaultOpenValue;
      return realValue.hour() >= 0 && realValue.hour() < 12;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          allowEmpty = _this$props2.allowEmpty,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          format = _this$props2.format,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          onEsc = _this$props2.onEsc,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          onClear = _this$props2.onClear,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          inputReadOnly = _this$props2.inputReadOnly,
          clearIcon = _this$props2.clearIcon;
      var _this$state = this.state,
          value = _this$state.value,
          currentSelectPanel = _this$state.currentSelectPanel;
      var disabledHourOptions = this.disabledHours();
      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
      var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-inner"), true), _defineProperty(_classNames, className, !!className), _classNames))
      }, _react["default"].createElement(_Header["default"], {
        clearText: clearText,
        prefixCls: prefixCls,
        defaultOpenValue: validDefaultOpenValue,
        value: value,
        currentSelectPanel: currentSelectPanel,
        onEsc: onEsc,
        format: format,
        placeholder: placeholder,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onChange: this.onChange,
        onClear: onClear,
        allowEmpty: allowEmpty,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        inputReadOnly: inputReadOnly,
        clearIcon: clearIcon
      }), _react["default"].createElement(_Combobox["default"], {
        prefixCls: prefixCls,
        value: value,
        defaultOpenValue: validDefaultOpenValue,
        format: format,
        onChange: this.onChange,
        onAmPmChange: this.onAmPmChange,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
        use12Hours: use12Hours,
        isAM: this.isAM()
      }), addon(this));
    }
  }]);

  return Panel;
}(_react.Component);

_defineProperty(Panel, "propTypes", {
  clearText: _propTypes["default"].string,
  prefixCls: _propTypes["default"].string,
  className: _propTypes["default"].string,
  defaultOpenValue: _propTypes["default"].object,
  value: _propTypes["default"].object,
  placeholder: _propTypes["default"].string,
  format: _propTypes["default"].string,
  inputReadOnly: _propTypes["default"].bool,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  hideDisabledOptions: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  onEsc: _propTypes["default"].func,
  allowEmpty: _propTypes["default"].bool,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  onClear: _propTypes["default"].func,
  use12Hours: _propTypes["default"].bool,
  hourStep: _propTypes["default"].number,
  minuteStep: _propTypes["default"].number,
  secondStep: _propTypes["default"].number,
  addon: _propTypes["default"].func,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Panel, "defaultProps", {
  prefixCls: 'rc-time-picker-panel',
  onChange: noop,
  onClear: noop,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  defaultOpenValue: (0, _moment["default"])(),
  use12Hours: false,
  addon: noop,
  onKeyDown: noop,
  inputReadOnly: false
});

var _default = Panel;
exports["default"] = _default;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};
module.exports = exports['default'];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _it_IT = _interopRequireDefault(__webpack_require__(1114));

var _it_IT2 = _interopRequireDefault(__webpack_require__(1115));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Merge into a locale object
var locale = {
  lang: _extends({
    placeholder: 'Selezionare la data',
    rangePlaceholder: ["Data d'inizio", 'Data di fine']
  }, _it_IT["default"]),
  timePickerLocale: _extends({}, _it_IT2["default"])
}; // All settings at:
// https://github.com/ant-design/ant-design/issues/424

var _default = locale;
exports["default"] = _default;

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__infinite_scroll_data_table__ = __webpack_require__(74);
var QueryPreview=function QueryPreview(_ref){var t=_ref.t,cube=_ref.cube,rows=_ref.rows,filterStr=_ref.filterStr,isRowsModalVisible=_ref.isRowsModalVisible,onRowsModalHide=_ref.onRowsModalHide,fetchRows=_ref.fetchRows;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__enhanced_modal__["a" /* default */],{visible:isRowsModalVisible,onCancel:onRowsModalHide,footer:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onRowsModalHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_2__styles_constants__["MODAL_WIDTH_LG"],title:t('scenes.dataManager.dataflowBuilder.wizard.query.preview.rowsModal.title')},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__infinite_scroll_data_table__["a" /* default */],{data:rows&&rows.Data,cols:rows&&rows.Columns,rowTotal:rows&&rows.Count,onChange:function onChange(_ref2){var pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc;return fetchRows(cube!==null?cube.IDCube:null,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(_ref3){var ColName=_ref3.ColName;return ColName;}):null,Object(__WEBPACK_IMPORTED_MODULE_7__utils_filter__["e" /* getFilterStrFromViewerObj */])(rows&&rows.Columns.filter(function(colName){return colName!=='_OBS_VALUE';}),searchText,filters,filterStr),pageNum,pageSize,sortCol?[sortCol]:null,sortByDesc);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_i18next__["b" /* translate */])()(QueryPreview));

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATAFLOW_BUILDER_WIZARD_STEP_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_WIZARD_STEP_CATEGORISATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOW_BUILDER_WIZARD_STEP_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DATAFLOW_BUILDER_WIZARD_STEP_LAYOUT_ANNOTATIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wizard_reducer__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list_actions__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wizard_actions__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wizard_dataflow_form_actions__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tree_reducer__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wizard_category_tree_actions__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__wizard_header_form_actions__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__list_reducer__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wizard_layout_annotations_actions__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW=0;var DATAFLOW_BUILDER_WIZARD_STEP_QUERY=1;var DATAFLOW_BUILDER_WIZARD_STEP_CATEGORISATION=2;var DATAFLOW_BUILDER_WIZARD_STEP_HEADER=3;var DATAFLOW_BUILDER_WIZARD_STEP_LAYOUT_ANNOTATIONS=4;var dataflowBuilderReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({wizard:__WEBPACK_IMPORTED_MODULE_1__wizard_reducer__["a" /* dataflowBuilderWizardReducer */],tree:__WEBPACK_IMPORTED_MODULE_8__tree_reducer__["a" /* default */],list:__WEBPACK_IMPORTED_MODULE_11__list_reducer__["c" /* default */]}),shared:function shared(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isWizardVisible:false,wizardStep:null,dataflows:null,ddbDataflowId:null,dataflowTriplet:null,ddbDataflow:null,dataflow:null,dataflowOriginalAnnotations:null,cubeId:null,cube:null,cubeFirstRow:null,filter:null,filterTemp:null,treeFilter:{},treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_14__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],isFilterModalVisible:false,categoriesUrns:null,header:null,hasHeader:false,agencies:null,ddbDataflowLabels:null,dsdForLayoutAnnotations:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_3__wizard_actions__["d" /* DATAFLOW_BUILDER_WIZARD_SHOW */]:return Object.assign({},state,{isWizardVisible:true,wizardStep:DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW,dataflow:{id:null,agencyID:null,version:null,isFinal:true,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,header:null,hasHeader:false},ddbDataflowId:null,dataflowTriplet:null,ddbDataflow:null,cubeId:null,cube:null,cubeFirstRow:null,filter:null,treeFilter:{},filterMode:__WEBPACK_IMPORTED_MODULE_14__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],isFilterModalVisible:false,categoriesUrns:null,header:null,hasHeader:false,agencies:null,ddbDataflowLabels:null});case __WEBPACK_IMPORTED_MODULE_3__wizard_actions__["c" /* DATAFLOW_BUILDER_WIZARD_HIDE */]:return Object.assign({},state,{isWizardVisible:false,wizardStep:null,dataflowTriplet:null,dataflow:null,ddbDataflowId:null,ddbDataflow:null,cubeId:null,cube:null,cubeFirstRow:null,filter:null,treeFilter:{},filterMode:__WEBPACK_IMPORTED_MODULE_14__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],isFilterModalVisible:false,categoriesUrns:null,header:null,hasHeader:false,dataflows:null,agencies:null,ddbDataflowLabels:null,dsdForLayoutAnnotations:null});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["t" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SHOW */]:return Object.assign({},state,{isFilterModalVisible:true,filterTemp:state.filter,treeFilterTemp:state.treeFilter||{}});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["s" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_HIDE */]:return Object.assign({},state,{isFilterModalVisible:false,filterTemp:null,treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["u" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT */]:return Object.assign({},state,{isFilterModalVisible:false,filter:state.filterMode===__WEBPACK_IMPORTED_MODULE_14__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?action.filter:state.filter,filterTemp:null,treeFilter:state.filterMode===__WEBPACK_IMPORTED_MODULE_14__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]?action.filter:state.treeFilter,treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_3__wizard_actions__["e" /* DATAFLOW_BUILDER_WIZARD_STEP_SET */]:return Object.assign({},state,{wizardStep:action.step});case __WEBPACK_IMPORTED_MODULE_2__list_actions__["R" /* DATAFLOW_BUILDER_LIST_DATAFLOW_EDIT */]:var filterStr=Object(__WEBPACK_IMPORTED_MODULE_19__utils_filter__["d" /* getFilterStrFromServerQueryObj */])(action.filter);return Object.assign({},state,{isWizardVisible:true,wizardStep:DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW,dataflowTriplet:action.dataflowTriplet,ddbDataflowId:action.ddbDataflowId,cubeId:action.cubeId,filterMode:filterStr.includes(" IN ")?__WEBPACK_IMPORTED_MODULE_14__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]:__WEBPACK_IMPORTED_MODULE_14__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],filter:filterStr.includes(" IN ")?null:Object(__WEBPACK_IMPORTED_MODULE_19__utils_filter__["a" /* getFilterObjFromStr */])(filterStr),treeFilter:filterStr.includes(" IN ")?Object(__WEBPACK_IMPORTED_MODULE_15__components_tree_filter_utils__["g" /* getTreeFilterObjFromStr */])(filterStr):null,ddbDataflowLabels:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(state.dataflows,function(dataflow){return dataflow.IDDataflow===action.ddbDataflowId;}).labels});case __WEBPACK_IMPORTED_MODULE_5__wizard_dataflow_form_actions__["b" /* DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_DATAFLOW_CHANGE */]:var dataflow=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.dataflow);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};var newDataflow=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mergeWith(dataflow,action.fields,customizer);return Object.assign({},state,{dataflow:newDataflow,dataflowOriginalAnnotations:newDataflow.annotations});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["e" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_SET */]:return Object.assign({},state,{cubeId:action.cubeId,cube:null});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["h" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_UNSET */]:var nodeConfig=Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action);var annotationTabsConfig=nodeConfig.annotationTabs.tabs;var annotationsConfig=nodeConfig.annotations;return Object.assign({},state,{cubeId:null,cube:null,cubeFirstRow:null,filter:null,treeFilter:{},filterMode:__WEBPACK_IMPORTED_MODULE_14__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],dataflow:Object.assign({},state.dataflow,{structure:undefined,annotations:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["v" /* getGenericAnnotations */])(state.dataflow?state.dataflow.annotations:[],annotationTabsConfig,annotationsConfig))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(state.dataflow?state.dataflow.annotations:[],annotationTabsConfig)))))})});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["b" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CHANGE */]:{if(action.fields.cubeColumns!==undefined){var columns=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.cube.columns);return Object.assign({},state,{cube:Object.assign({},state.cube,{columns:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.merge(columns,action.fields.cubeColumns.value)})});}else{return state;}}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["j" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD */]:{var block={column:null,logicalOperator:'OR',conditions:null};return Object.assign({},state,{filterTemp:state.filterTemp!==null?[].concat(_toConsumableArray(state.filterTemp),[block]):[block]});}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["k" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE */]:{var filterTemp=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.filterTemp);filterTemp.splice(action.blockIndex,1);return Object.assign({},state,{filterTemp:filterTemp});}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["w" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_RESET */]:return Object.assign({},state,{filterTemp:[],treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["v" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE */]:return Object.assign({},state,{filterMode:action.filterMode,filterTemp:[],treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["q" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD */]:{var _filterTemp=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.filterTemp);var condition={comparisonOperator:null,value:null};if(_filterTemp[action.blockIndex].conditions!==null){_filterTemp[action.blockIndex].conditions.push(condition);}else{_filterTemp[action.blockIndex].conditions=[condition];}return Object.assign({},state,{filterTemp:_filterTemp});}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["r" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE */]:{var _filterTemp2=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.filterTemp);_filterTemp2[action.blockIndex].conditions.splice(action.conditionIndex,1);return Object.assign({},state,{filterTemp:_filterTemp2});}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["l" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE */]:{var _filterTemp3=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.filterTemp);if(action.fields.filter.filter(function(block){return block.column!==undefined;}).length>0){action.fields.filter=action.fields.filter.map(function(block){return Object.assign({},block,{conditions:null});});}return Object.assign({},state,{filterTemp:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.merge(_filterTemp3,action.fields.filter)});}case __WEBPACK_IMPORTED_MODULE_9__wizard_category_tree_actions__["b" /* DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_SELECTION_CHANGE */]:return Object.assign({},state,{categoriesUrns:action.selection});case __WEBPACK_IMPORTED_MODULE_10__wizard_header_form_actions__["a" /* DATAFLOW_BUILDER_WIZARD_HEADER_FORM_CHANGE */]:{return Object.assign({},state,{header:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.merge(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.header),action.fields)});}case __WEBPACK_IMPORTED_MODULE_10__wizard_header_form_actions__["c" /* DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HIDE */]:return Object.assign({},state,{hasHeader:false});case __WEBPACK_IMPORTED_MODULE_10__wizard_header_form_actions__["d" /* DATAFLOW_BUILDER_WIZARD_HEADER_FORM_SHOW */]:return Object.assign({},state,{hasHeader:true});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["z" /* DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE */]:return Object.assign({},state,{treeFilterTemp:action.treeFilter});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["D" /* DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE */]:{var cube=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.cube);var treeFilterTemp=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.treeFilterTemp);treeFilterTemp[action.colName]={mode:action.mode,values:treeFilterTemp[action.colName]&&treeFilterTemp[action.colName].values?treeFilterTemp[action.colName].values:[]};var colNames=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.flatten(Object.keys(state.cube.columns).map(function(key){return state.cube.columns[key];})).map(function(_ref){var name=_ref.name;return name;});var colIndex=colNames.indexOf(action.colName);var subsequentColNames=colNames.splice(colIndex+1);// delete filters for subsequent cols
subsequentColNames.forEach(function(name){delete treeFilterTemp[name];});// delete filteredCodelistTree for subsequent cols
cube.columns=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(cube.columns,function(colArr){return colArr.map(function(col){return subsequentColNames.includes(col.name)?Object.assign({},col,{filteredCodelistTree:null}):col;});});return Object.assign({},state,{cube:cube,treeFilterTemp:treeFilterTemp});}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["E" /* DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE */]:{var _treeFilterTemp=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.treeFilterTemp);_treeFilterTemp[action.colName]={mode:_treeFilterTemp[action.colName]&&_treeFilterTemp[action.colName].mode?_treeFilterTemp[action.colName].mode:__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["n" /* FILTER_MODE_IN */],values:action.values};var _colNames=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.flatten(Object.keys(state.cube.columns).map(function(key){return state.cube.columns[key];})).map(function(_ref2){var name=_ref2.name;return name;});var _colIndex=_colNames.indexOf(action.colName);var _subsequentColNames=_colNames.splice(_colIndex+1);// delete filters for subsequent cols
_subsequentColNames.forEach(function(name){delete _treeFilterTemp[name];});return Object.assign({},state,{cube:Object.assign({},state.cube,{columns:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(state.cube.columns,function(colArr){return(// delete filteredCodelistTree for subsequent cols
colArr.map(function(col){if(_subsequentColNames.includes(col.name)){return Object.assign({},col,{filteredCodelistTree:null});}else{return col;}}));})}),treeFilterTemp:_treeFilterTemp});}case __WEBPACK_IMPORTED_MODULE_18__wizard_layout_annotations_actions__["d" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT */]:return Object.assign({},state,{dataflow:Object.assign({},state.dataflow,{annotations:action.annotations})});case __WEBPACK_IMPORTED_MODULE_18__wizard_layout_annotations_actions__["b" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_RESET */]:return Object.assign({},state,{dataflow:Object.assign({},state.dataflow,{annotations:state.dataflowOriginalAnnotations})});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["p" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET */]:{var _cube=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.cube);_cube.columns=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(_cube.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{values:null,valuesCount:null}):col;});});return Object.assign({},state,{cube:_cube});}case __WEBPACK_IMPORTED_MODULE_4__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__list_actions__["a" /* DATAFLOW_BUILDER_LIST_DATAFLOWS_READ */]:return Object.assign({},state,{dataflows:[]});case __WEBPACK_IMPORTED_MODULE_3__wizard_actions__["a" /* DATAFLOW_BUILDER_WIZARD_DATAFLOW_READ */]:case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["i" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_DDB_DATAFLOW_READ */]:case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["d" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_READ */]:case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["m" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_CODELIST_READ */]:case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["o" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ */]:case __WEBPACK_IMPORTED_MODULE_9__wizard_category_tree_actions__["a" /* DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ */]:return Object.assign({},state,{isWizardVisible:false});case __WEBPACK_IMPORTED_MODULE_3__wizard_actions__["f" /* DATAFLOW_BUILDER_WIZARD_SUBMIT */]:if(action.error&&action.error.dfNewId){return Object.assign({},state,{ddbDataflow:Object.assign({},state.ddbDataflow,{IDDataflow:action.error.dfNewId})});}else{return state;}default:return state;}case __WEBPACK_IMPORTED_MODULE_4__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__list_actions__["U" /* DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_SET */]:case __WEBPACK_IMPORTED_MODULE_2__list_actions__["V" /* DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_UNSET */]:case __WEBPACK_IMPORTED_MODULE_2__list_actions__["_11" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_SET */]:case __WEBPACK_IMPORTED_MODULE_2__list_actions__["_9" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_SET */]:case __WEBPACK_IMPORTED_MODULE_2__list_actions__["_12" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_UNSET */]:case __WEBPACK_IMPORTED_MODULE_2__list_actions__["d" /* DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET */]:case __WEBPACK_IMPORTED_MODULE_2__list_actions__["e" /* DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET */]:case __WEBPACK_IMPORTED_MODULE_2__list_actions__["Z" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET */]:return Object.assign({},state,{dataflows:null});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["C" /* DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ */]:{var filteredValues=action.response.Data.map(function(obj){return obj[action.colName];});var _cube3=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.cube);_cube3.columns=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(_cube3.columns,function(colArr){return colArr.map(function(col){if(col.name===action.colName){var filteredCodelistTree=col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["g" /* getFilteredTreeWithPaths */])(col.codelistTree||[],"codes",function(_ref3){var id=_ref3.id;return filteredValues.includes(id);}):null;return Object.assign({},col,{filteredCodelistTree:filteredCodelistTree,filteredValues:filteredValues,filteredCodelistTreeMaxDepth:col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["j" /* getMaxTreeDepth */])(filteredCodelistTree,"codes"):null});}else return col;});});return Object.assign({},state,{cube:_cube3});}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["A" /* DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_COUNT_READ */]:{var _cube4=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.cube);_cube4.columns=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(_cube4.columns,function(colArr){return colArr.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistCount:Number(action.header["x-total-count"])}):col;});});return Object.assign({},state,{cube:_cube4});}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["B" /* DATAFLOW_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_CODELIST_TREE_READ */]:{var codelist=Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var itemsTree=Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["n" /* getTreeFromArray */])(codelist.codes||[],"codes");var _cube5=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.cube);_cube5.columns=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(_cube5.columns,function(colArr){return colArr.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistTree:itemsTree}):col;});});return Object.assign({},state,{cube:_cube5});}case __WEBPACK_IMPORTED_MODULE_3__wizard_actions__["b" /* DATAFLOW_BUILDER_WIZARD_DSD_FOR_LAYOUT_ANNOTATIONS_READ */]:return Object.assign({},state,{dsdForLayoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["R" /* getDsdFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)});case __WEBPACK_IMPORTED_MODULE_2__list_actions__["a" /* DATAFLOW_BUILDER_LIST_DATAFLOWS_READ */]:var msdbDataflows=(Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1],__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["B" /* SDMX_JSON_DATAFLOW_LIST_KEY */])||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);});return Object.assign({},state,{dataflows:(action.response[0]||[]).filter(function(ddbDataflow){return msdbDataflows.filter(function(_ref4){var id=_ref4.id,agencyID=_ref4.agencyID,version=_ref4.version;return ddbDataflow.ID===id&&ddbDataflow.Agency===agencyID&&ddbDataflow.Version===version;}).length;}).map(function(ddbDataflow){var dataflow=msdbDataflows.filter(function(_ref5){var id=_ref5.id,agencyID=_ref5.agencyID,version=_ref5.version;return ddbDataflow.ID===id&&ddbDataflow.Agency===agencyID&&ddbDataflow.Version===version;})[0];var dataflowNonProductionDataflowAnnotationArr=[].concat(_toConsumableArray(dataflow.annotations||[]),_toConsumableArray(dataflow.autoAnnotations||[])).filter(function(_ref6){var type=_ref6.type;return type==='NonProductionDataflow';});return Object.assign({},ddbDataflow,{isProduction:dataflowNonProductionDataflowAnnotationArr.length===0,cubeID:(action.response[2]||[]).filter(function(cube){return cube.IDCube===ddbDataflow.IDCube;})[0].Code,dsdTriplet:Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(dataflow.structure),annotations:dataflow.annotations,haveMetadata:(dataflow.autoAnnotations||[]).find(function(_ref7){var type=_ref7.type;return(type||"").toLowerCase()===(Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["e" /* AUTO_ANNOTATION_HAVE_METADATA_KEY */]]||"").toLowerCase();})});})});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["i" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_DDB_DATAFLOW_READ */]:return Object.assign({},state,{ddbDataflow:action.response});case __WEBPACK_IMPORTED_MODULE_3__wizard_actions__["a" /* DATAFLOW_BUILDER_WIZARD_DATAFLOW_READ */]:var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_20__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _dataflow=Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,customNoneIsAutoAnnotation),{name:state.ddbDataflowLabels});var _annotationTabsConfig=Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotationTabs.tabs;var _annotationsConfig=Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations;return Object.assign({},state,{dataflow:_dataflow,dataflowOriginalAnnotations:[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["v" /* getGenericAnnotations */])(_dataflow.annotations,_annotationTabsConfig,_annotationsConfig)),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(_dataflow.annotations,_annotationTabsConfig))))});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["d" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_READ */]:var _cube2=action.response;return Object.assign({},state,{dataflow:Object.assign({},state.dataflow,{structure:Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(_cube2.DSDCode),__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */])}),cube:Object.assign({},_cube2,{columns:{dimensions:_cube2.Dimensions.filter(function(dim){return!dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{name:dim.ColName,checked:state.ddbDataflow!==null&&state.ddbDataflow.IDCube===_cube2.IDCube?state.ddbDataflow.DataflowColumns.filter(function(col){return col===dim.ColName;}).length>0:true,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),timeDimensions:_cube2.Dimensions.filter(function(dim){return dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{name:dim.ColName,checked:state.ddbDataflow!==null&&state.ddbDataflow.IDCube===_cube2.IDCube?state.ddbDataflow.DataflowColumns.filter(function(col){return col===dim.ColName;}).length>0:true,disabled:true,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),tidAttributes:_cube2.Attributes.filter(function(attr){return attr.IsTid;}).map(function(attr){return Object.assign({},attr,{name:attr.ColName,checked:false,disabled:true,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),attributes:_cube2.Attributes.filter(function(attr){return!attr.IsTid;}).map(function(attr){return Object.assign({},attr,{name:attr.ColName,checked:state.ddbDataflow!==null&&state.ddbDataflow.IDCube===_cube2.IDCube?state.ddbDataflow.DataflowColumns.filter(function(col){return col===attr.ColName;}).length>0:true,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),measures:_cube2.Measures.map(function(meas){return Object.assign({},meas,{name:meas.ColName,checked:true,disabled:true,isNumeric:true});})}})});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["c" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_FIRST_ROW_READ */]:return Object.assign({},state,{cubeFirstRow:action.response.Data[0]});case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["o" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ */]:{var columnValues=action.response.Data.map(function(val){return val[action.columnName];});var _cube6=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.cube);_cube6.columns=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(_cube6.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{values:col.codes?col.codes.filter(function(_ref8){var id=_ref8.id;return columnValues.filter(function(val){return val===id;}).length;}):columnValues.map(function(val){return _defineProperty({},action.columnName,val);}),valuesCount:action.response.Count}):col;});});return Object.assign({},state,{cube:_cube6});}case __WEBPACK_IMPORTED_MODULE_12__wizard_query_actions__["n" /* DATAFLOW_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_CODES_READ */]:{var codes=Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)(Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes;var _cube7=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.cube);_cube7.columns=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(_cube7.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{codes:codes}):col;});});return Object.assign({},state,{cube:_cube7});}case __WEBPACK_IMPORTED_MODULE_9__wizard_category_tree_actions__["a" /* DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ */]:{if(state.dataflowTriplet!==null){var categorisations=(Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response,__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["r" /* SDMX_JSON_CATEGORISATION_LIST_KEY */])||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);});return Object.assign({},state,{categoriesUrns:categorisations.filter(function(_ref10){var source=_ref10.source;return Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(source).id===state.dataflowTriplet.id;}).map(function(_ref11){var target=_ref11.target;return target;})});}return state;}case __WEBPACK_IMPORTED_MODULE_10__wizard_header_form_actions__["b" /* DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HEADER_READ */]:var getHeaderContact=function getHeaderContact(obj){return{organisationId:obj&&obj.id||null,organisationName:obj&&obj.name&&obj.name.en||null,contactName:obj&&obj.contacts&&obj.contacts.length&&obj.contacts[0].name&&obj.contacts[0].name.en||null,contactDepartment:obj&&obj.contacts&&obj.contacts.length&&obj.contacts[0].department&&obj.contacts[0].department.en||null,contactRole:obj&&obj.contacts&&obj.contacts.length&&obj.contacts[0].role&&obj.contacts[0].role.en||null,contactEmail:obj&&obj.contacts&&obj.contacts.length&&obj.contacts[0].email&&obj.contacts[0].email&&obj.contacts[0].email.length&&obj.contacts[0].email[0]||null};};return Object.assign({},state,{hasHeader:action.response!==null,header:Object.assign({test:false,name:null,dataSetAgencyId:null,source:null},action.response||{},{sender:getHeaderContact(action.response&&action.response.sender||null),receiver:getHeaderContact(action.response&&action.response.receiver&&action.response.receiver.length&&action.response.receiver[0]||null)})});case __WEBPACK_IMPORTED_MODULE_3__wizard_actions__["f" /* DATAFLOW_BUILDER_WIZARD_SUBMIT */]:return Object.assign({},state,{isWizardVisible:false,wizardStep:null,dataflows:null,ddbDataflowId:null,dataflowTriplet:null,ddbDataflow:null,dataflow:null,cubeId:null,cube:null,cubeFirstRow:null,filter:null,treeFilter:{},filterMode:__WEBPACK_IMPORTED_MODULE_14__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],categoriesUrns:null,header:null,hasHeader:false,agencies:null,ddbDataflowLabels:null});case __WEBPACK_IMPORTED_MODULE_2__list_actions__["f" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DELETE */]:return Object.assign({},state,{dataflows:null});case __WEBPACK_IMPORTED_MODULE_5__wizard_dataflow_form_actions__["a" /* DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);})});default:return state;}default:return state;}}});/* harmony default export */ __webpack_exports__["f"] = (dataflowBuilderReducer);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_DATAFLOW_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_AGENCIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeDataflowBuilderWizardDataflowForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return readDataflowBuilderWizardDataflowFormAgencies; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_DATAFLOW_CHANGE='DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_DATAFLOW_CHANGE';var DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_AGENCIES_READ='DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_AGENCIES_READ';var changeDataflowBuilderWizardDataflowForm=function changeDataflowBuilderWizardDataflowForm(fields){return{type:DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_DATAFLOW_CHANGE,fields:fields};};var readDataflowBuilderWizardDataflowFormAgencies=function readDataflowBuilderWizardDataflowFormAgencies(allowedAgencies){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_WIZARD_DATAFLOW_FORM_AGENCIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* getAgencyNamesUrl */])()),{allowedAgencies:allowedAgencies});};

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DATAFLOW_BUILDER_WIZARD_HEADER_FORM_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_WIZARD_HEADER_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HEADER_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return showDataflowBuilderWizardHeaderForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hideDataflowBuilderWizardHeaderForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeDataflowBuilderWizardHeaderForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return readDataflowBuilderWizardHeaderFormHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var DATAFLOW_BUILDER_WIZARD_HEADER_FORM_SHOW='DATAFLOW_BUILDER_WIZARD_HEADER_FORM_SHOW';var DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HIDE='DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HIDE';var DATAFLOW_BUILDER_WIZARD_HEADER_FORM_CHANGE='DATAFLOW_BUILDER_WIZARD_HEADER_FORM_CHANGE';var DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HEADER_READ='DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HEADER_READ';var showDataflowBuilderWizardHeaderForm=function showDataflowBuilderWizardHeaderForm(){return{type:DATAFLOW_BUILDER_WIZARD_HEADER_FORM_SHOW};};var hideDataflowBuilderWizardHeaderForm=function hideDataflowBuilderWizardHeaderForm(){return{type:DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HIDE};};var changeDataflowBuilderWizardHeaderForm=function changeDataflowBuilderWizardHeaderForm(fields){return{type:DATAFLOW_BUILDER_WIZARD_HEADER_FORM_CHANGE,fields:fields};};var readDataflowBuilderWizardHeaderFormHeader=function readDataflowBuilderWizardHeaderFormHeader(dataflowTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DATAFLOW_BUILDER_WIZARD_HEADER_FORM_HEADER_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_4" /* getDataflowHeader */])(dataflowTriplet));};

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_download__ = __webpack_require__(55);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO='DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO';var DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC='DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC';var dataflowBuilderListReducer=function dataflowBuilderListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{dataflowId:null,dataflow:null,dataflowPreview:null,dataflowProductionModalMappingSetId:undefined,dataflowProductionModalDDBDataflowId:null,dataflowProductionModalDataflowTriplet:null,dataflowProductionModalTranscodingMode:DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO,dataflowProductionModalTranscodingContentConstraintTriplet:null,isDataflowProductionModalTranscodingContentConstraintListVisible:null,dataflowProductionModalTranscodingContentConstraints:null,dlDataflowId:null,dlDataflow:null,dlDataflowParams:null,dlDsdTriplet:null,dlDsdDimensions:null,dlDataflowTriplet:null,dlIsDataflowQueryVisible:false,cubeId:null,cube:null,dlRows:null,dlCols:null,dlCheckedCols:null,filter:null,filterTemp:null,treeFilter:{},treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],isFilterModalVisible:false,dlIsPreviewVisible:false,dataflowAnnotations:null,dataflowLayoutAnnotations:null,filterRows:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_SHOW */]:return Object.assign({},state,{dataflowId:action.dataflowId});case __WEBPACK_IMPORTED_MODULE_1__actions__["_10" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_MODE_CHANGE */]:return Object.assign({},state,{dataflowProductionModalTranscodingMode:action.mode,dataflowProductionModalTranscodingContentConstraintTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_8" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_SHOW */]:return Object.assign({},state,{isDataflowProductionModalTranscodingContentConstraintListVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["_6" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_HIDE */]:return Object.assign({},state,{isDataflowProductionModalTranscodingContentConstraintListVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["_4" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_SET */]:return Object.assign({},state,{dataflowProductionModalTranscodingContentConstraintTriplet:action.contentConstraintTriplet,isDataflowProductionModalTranscodingContentConstraintListVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["_5" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_CONTENT_CONSTRAINT_UNSET */]:return Object.assign({},state,{dataflowProductionModalTranscodingContentConstraintTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["W" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_HIDE */]:return Object.assign({},state,{dataflowId:null,dataflow:null,dataflowPreview:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_2" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW */]:return Object.assign({},state,{dataflowProductionModalDDBDataflowId:action.ddbDataflowId,dataflowProductionModalDataflowTriplet:action.dataflowTriplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["_1" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE */]:return Object.assign({},state,{dataflowProductionModalDDBDataflowId:null,dataflowProductionModalDataflowTriplet:null,dataflowProductionModalTranscodingMode:DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO,dataflowProductionModalTranscodingContentConstraintTriplet:null,isDataflowProductionModalTranscodingContentConstraintListVisible:null,dataflowProductionModalTranscodingContentConstraints:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["Q" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_SHOW */]:return Object.assign({},state,{dlDataflowId:action.ddbDataflowId,cubeId:action.cubeId,dlDataflowParams:{format:null,compression:false,csvLanguage:null,csvSeparator:";",csvDelimiter:null,selCols:null,filter:null,dimension:null},dlDataflowTriplet:action.dataflowTriplet,dlDsdTriplet:action.dsdTriplet,filter:null,filterTemp:null,treeFilter:{},treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_HIDE */]:return Object.assign({},state,{dlDataflowId:null,dlDataflow:null,dlDataflowParams:null,dlDsdTriplet:null,dlDsdDimensions:null,dlDataflowTriplet:null,dlIsDataflowQueryVisible:false,dlIsPreviewVisible:null,cube:null,cubeId:null,dlFilter:null,dlRows:null,dlCols:null,dlCheckedCols:null,filterTemp:null,treeFilter:{},treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CHANGE */]:var dataflowDownloadParams=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.dlDataflowParams);return Object.assign({},state,{dlDataflowParams:Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(dataflowDownloadParams,action.fields),{selCols:action.fields.format?null:state.dlDataflowParams.selCols,filter:action.fields.format?null:state.dlDataflowParams.selCols}),dlFilter:action.fields.format?null:state.dlFilter,dlRows:action.fields.format?null:state.dlRows,dlCols:action.fields.format?null:state.dlCols,dlCheckedCols:action.fields.format?null:state.selCols,filter:action.fields.format?null:state.filter,filterTemp:action.fields.format?null:state.filterTemp,treeFilter:action.fields.format?{}:state.treeFilter,treeFilterTemp:action.fields.format?{}:state.treeFilterTemp,filterMode:action.fields.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["p" /* DOWNLOAD_FORMAT_TYPE_GENERIC */]||action.fields.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["t" /* DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC */]||action.fields.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["q" /* DOWNLOAD_FORMAT_TYPE_GENERIC20 */]||action.fields.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["m" /* DOWNLOAD_FORMAT_TYPE_COMPACT */]||action.fields.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["s" /* DOWNLOAD_FORMAT_TYPE_SDMXCSV */]||action.fields.format===__WEBPACK_IMPORTED_MODULE_9__constants_download__["r" /* DOWNLOAD_FORMAT_TYPE_JSON */]?__WEBPACK_IMPORTED_MODULE_5__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]:state.filterMode});case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SET */]:return Object.assign({},state,{dlIsDataflowQueryVisible:false,dlDataflowParams:Object.assign({},state.dlDataflowParams,{selCols:action.selCols,filter:state.filterMode===__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?Object(__WEBPACK_IMPORTED_MODULE_8__utils_filter__["c" /* getFilterStrFromObj */])(action.filter,state.cube!==null&&state.cube.columns!==null?action.selCols.map(function(col){return{name:col};}):null):Object(__WEBPACK_IMPORTED_MODULE_7__components_tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(action.filter,state.cube!==null&&state.cube.columns!==null?action.selCols:null)})});case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET */]:return Object.assign({},state,{dlIsDataflowQueryVisible:false,dlFilter:null,dlRows:null,dlCols:null,dlCheckedCols:null,dlDataflowParams:Object.assign({},state.dlDataflowParams,{selCols:null,filter:null}),filter:null,filterTemp:null,treeFilter:{},treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW */]:return Object.assign({},state,{dlIsDataflowQueryVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE */]:return Object.assign({},state,{dlIsDataflowQueryVisible:false,dlCheckedCols:state.dlDataflowParams.selCols?state.dlDataflowParams.selCols:null,dlFilter:state.dlDataflowParams.filter?state.dlDataflowParams.filter:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_ADD */]:{var block={column:null,logicalOperator:'OR',conditions:null};return Object.assign({},state,{filterTemp:state.filterTemp!==null?[].concat(_toConsumableArray(state.filterTemp),[block]):[block]});}case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_BLOCK_DELETE */]:{var filterTemp=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filterTemp);filterTemp.splice(action.blockIndex,1);return Object.assign({},state,{filterTemp:filterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_ADD */]:{var _filterTemp=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filterTemp);var condition={comparisonOperator:null,value:null};if(_filterTemp[action.blockIndex].conditions!==null){_filterTemp[action.blockIndex].conditions.push(condition);}else{_filterTemp[action.blockIndex].conditions=[condition];}return Object.assign({},state,{filterTemp:_filterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_CONDITION_DELETE */]:{var _filterTemp2=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filterTemp);_filterTemp2[action.blockIndex].conditions.splice(action.conditionIndex,1);return Object.assign({},state,{filterTemp:_filterTemp2});}case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW */]:return Object.assign({},state,{dlIsPreviewVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_HIDE */]:return Object.assign({},state,{dlIsPreviewVisible:false,dlRows:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK */]:return Object.assign({},state,{dlCheckedCols:action.cols});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE */]:return Object.assign({},state,{dlCols:action.cols});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_SHOW */]:return Object.assign({},state,{dataflowAnnotations:action.annotations});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* DATAFLOW_BUILDER_LIST_DATAFLOW_ANNOTATIONS_HIDE */]:return Object.assign({},state,{dataflowAnnotations:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["T" /* DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_SHOW */]:return Object.assign({},state,{dataflowLayoutAnnotations:action.annotations});case __WEBPACK_IMPORTED_MODULE_1__actions__["S" /* DATAFLOW_BUILDER_LIST_DATAFLOW_LAYOUT_ANNOTATIONS_HIDE */]:return Object.assign({},state,{dataflowLayoutAnnotations:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SHOW */]:return Object.assign({},state,{isCubeDownloadFilterModalVisible:true,filterTemp:state.filter,treeFilterTemp:state.treeFilter||{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_HIDE */]:return Object.assign({},state,{isCubeDownloadFilterModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_SUBMIT */]:return Object.assign({},state,{isCubeDownloadFilterModalVisible:false,filter:state.filterMode===__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?action.filter:state.filter,filterTemp:null,treeFilter:state.filterMode===__WEBPACK_IMPORTED_MODULE_5__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]?action.filter:state.treeFilter,treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_RESET */]:return Object.assign({},state,{filterTemp:[],treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE */]:return Object.assign({},state,{filterMode:action.filterMode,filterTemp:[],treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE */]:{var _filterTemp3=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filterTemp);if(action.fields.filter.filter(function(block){return block.column!==undefined;}).length>0){action.fields.filter=action.fields.filter.map(function(block){return Object.assign({},block,{conditions:null});});}return Object.assign({},state,{filterTemp:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(_filterTemp3,action.fields.filter)});}case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE */]:return Object.assign({},state,{treeFilterTemp:action.treeFilter});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE */]:{var cube=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);var treeFilterTemp=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.treeFilterTemp);treeFilterTemp[action.colName]={mode:action.mode,values:treeFilterTemp[action.colName]&&treeFilterTemp[action.colName].values?treeFilterTemp[action.colName].values:[]};var colNames=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatten(Object.keys(state.cube.columns).map(function(key){return state.cube.columns[key];})).map(function(_ref){var name=_ref.name;return name;});var colIndex=colNames.indexOf(action.colName);var subsequentColNames=colNames.splice(colIndex+1);// delete filters for subsequent cols
subsequentColNames.forEach(function(name){delete treeFilterTemp[name];});// delete filteredCodelistTree for subsequent cols
cube.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(cube.columns,function(colArr){return colArr.map(function(col){return subsequentColNames.includes(col.name)?Object.assign({},col,{filteredCodelistTree:null}):col;});});return Object.assign({},state,{cube:cube,treeFilterTemp:treeFilterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE */]:{var _treeFilterTemp=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.treeFilterTemp);_treeFilterTemp[action.colName]={mode:_treeFilterTemp[action.colName]&&_treeFilterTemp[action.colName].mode?_treeFilterTemp[action.colName].mode:__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["n" /* FILTER_MODE_IN */],values:action.values};var _colNames=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatten(Object.keys(state.cube.columns).map(function(key){return state.cube.columns[key];})).map(function(_ref2){var name=_ref2.name;return name;});var _colIndex=_colNames.indexOf(action.colName);var _subsequentColNames=_colNames.splice(_colIndex+1);// delete filters for subsequent cols
_subsequentColNames.forEach(function(name){delete _treeFilterTemp[name];});return Object.assign({},state,{cube:Object.assign({},state.cube,{columns:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(state.cube.columns,function(colArr){return(// delete filteredCodelistTree for subsequent cols
colArr.map(function(col){if(_subsequentColNames.includes(col.name)){return Object.assign({},col,{filteredCodelistTree:null});}else{return col;}}));})}),treeFilterTemp:_treeFilterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_SHOW */]:return Object.assign({},state,{isRowsModalVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_MODAL_HIDE */]:return Object.assign({},state,{filterRows:null,isRowsModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_RESET */]:{var _cube=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{values:null,valuesCount:null}):col;});});return Object.assign({},state,{cube:_cube});}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CUBE_AND_DDBDATAFLOW_READ */]:return Object.assign({},state,{cube:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_UNSET */]:if(action.error&&action.error.dfNewId){return Object.assign({},state,{dataflowProductionModalDDBDataflowId:action.error.dfNewId});}else{return state;}case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_READ */]:return Object.assign({},state,{dlRows:null,dlIsPreviewVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_READ */]:return{filterRows:null,isRowsModalVisible:false};default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_ROWS_READ */]:return Object.assign({},state,{filterRows:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["U" /* DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_SET */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_UNSET */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["_11" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_SET */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["_9" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_SET */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["_12" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_UNSET */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* DATAFLOW_BUILDER_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["Z" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET */]:return Object.assign({},state,{dataflowProductionModalMappingSetId:undefined,dataflowProductionModalTranscodingContentConstraintTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["_3" /* DATAFLOW_BUILDER_LIST_DATAFLOW_READ */]:return Object.assign({},state,{dataflow:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["X" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PREVIEW_READ */]:return Object.assign({},state,{dataflowPreview:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["_0" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_DATAFLOW_MAPPING_SET_ID_READ */]:return Object.assign({},state,{dataflowProductionModalMappingSetId:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD */]:{return Object.assign({},state,{dlDataflowId:null,dlDataflow:null,dlDataflowParams:null,dlDsdTriplet:null,dlDsdDimensions:null,dlDataflowTriplet:null,dlIsDataflowQueryVisible:false,dlIsPreviewVisible:null,cube:null,cubeId:null,filter:null,treeFilter:null,treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],dlRows:null,dlCols:null,dlCheckedCols:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_CUBE_AND_DDBDATAFLOW_READ */]:{var _cube2=action.response[0];var columns={dimensions:_cube2.Dimensions.filter(function(dim){return!dim.type!==__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */];}).map(function(dim){return Object.assign({},dim,{name:dim.ColName,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),timeDimensions:_cube2.Dimensions.filter(function(dim){return!dim.type===__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */];}).map(function(dim){return Object.assign({},dim,{name:dim.ColName,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),tidAttributes:_cube2.Attributes.filter(function(attr){return attr.IsTid;}).map(function(attr){return Object.assign({},attr,{name:attr.ColName,checked:true,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),attributes:_cube2.Attributes.filter(function(attr){return!attr.IsTid;}).map(function(attr){return Object.assign({},attr,{name:attr.ColName,checked:true,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),measures:_cube2.Measures.map(function(meas){return Object.assign({},meas,{name:meas.ColName,checked:true,disabled:false,isNumeric:true});})};var columnsArr=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatten(Object.keys(columns).map(function(key){return columns[key];})).filter(function(col){return action.response[1].DataflowColumns.includes(col.name);}).map(function(col){return col.name;});return Object.assign({},state,{cube:Object.assign({},_cube2,{columns:columns}),dlDataflow:action.response[1],dlCols:columnsArr,dlCheckedCols:state.dlDataflowParams.selCols?state.dlDataflowParams.selCols:columnsArr,dlIsDataflowQueryVisible:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_VALUES_READ */]:{var columnValues=action.response.Data.map(function(val){return val[action.columnName];});var _cube3=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube3.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube3.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{values:col.codes?col.codes.filter(function(_ref3){var id=_ref3.id;return columnValues.filter(function(val){return val===id;}).length;}):columnValues.map(function(val){return _defineProperty({},action.columnName,val);}),valuesCount:action.response.Count}):col;});});return Object.assign({},state,{cube:_cube3});}case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_FORM_COLUMN_CODES_READ */]:{var codes=Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes;var _cube4=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube4.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube4.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{codes:codes}):col;});});return Object.assign({},state,{cube:_cube4});}case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_PREVIEW_READ */]:return Object.assign({},state,{dlRows:action.response,dlIsPreviewVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_DSD_READ */]:return Object.assign({},state,{dlDsdDimensions:Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["R" /* getDsdFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations).dimensions.map(function(_ref5){var id=_ref5.id;return id;})});case __WEBPACK_IMPORTED_MODULE_1__actions__["_7" /* DATAFLOW_BUILDER_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ */]:return Object.assign({},state,{dataflowProductionModalTranscodingContentConstraints:action.response.map(function(art){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(art,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);}).map(function(cc){return Object.assign({},cc,{agencyID:cc.agency});})});case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ */]:{var _cube5=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube5.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube5.columns,function(colArr){return colArr.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistCount:Number(action.header["x-total-count"])}):col;});});return Object.assign({},state,{cube:_cube5});}case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ */]:{var codelist=Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["n" /* getTreeFromArray */])(codelist.codes||[],"codes");var _cube6=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube6.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube6.columns,function(colArr){return colArr.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistTree:itemsTree}):col;});});return Object.assign({},state,{cube:_cube6});}case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ */]:{var filteredValues=action.response.Data.map(function(obj){return obj[action.colName];});var _cube7=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube7.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube7.columns,function(colArr){return colArr.map(function(col){if(col.name===action.colName){var filteredCodelistTree=col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["g" /* getFilteredTreeWithPaths */])(col.codelistTree||[],"codes",function(_ref6){var id=_ref6.id;return filteredValues.includes(id);}):null;return Object.assign({},col,{filteredCodelistTree:filteredCodelistTree,filteredValues:filteredValues,filteredCodelistTreeMaxDepth:col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["j" /* getMaxTreeDepth */])(filteredCodelistTree,"codes"):null});}else return col;});});return Object.assign({},state,{cube:_cube7});}default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["c"] = (dataflowBuilderListReducer);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var PingIcon=function PingIcon(_ref){var isOk=_ref.isOk;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:isOk?'check-circle':'close-circle',theme:'filled',style:{color:isOk?'green':'red'}});};/* harmony default export */ __webpack_exports__["a"] = (PingIcon);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMPORT_STRUCTURES_FORM_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IMPORT_STRUCTURES_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IMPORT_STRUCTURES_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IMPORT_STRUCTURES_REPORT_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IMPORT_STRUCTURES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IMPORT_STRUCTURES_ITEM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMPORT_STRUCTURES_ALL_ITEMS_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return changeImportStructuresForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return uploadImportStructuresFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return submitImportStructures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hideImportStructuresReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetImportStructures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectImportStructuresItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectImportStructuresAllItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var IMPORT_STRUCTURES_FORM_CHANGE='IMPORT_STRUCTURES_FORM_CHANGE';var IMPORT_STRUCTURES_FILE_UPLOAD='IMPORT_STRUCTURES_FILE_UPLOAD';var IMPORT_STRUCTURES_SUBMIT='IMPORT_STRUCTURES_SUBMIT';var IMPORT_STRUCTURES_REPORT_HIDE='IMPORT_STRUCTURES_REPORT_HIDE';var IMPORT_STRUCTURES_RESET='IMPORT_STRUCTURES_RESET';var IMPORT_STRUCTURES_ITEM_SELECT='IMPORT_STRUCTURES_ITEM_SELECT';var IMPORT_STRUCTURES_ALL_ITEMS_SELECT='IMPORT_STRUCTURES_ALL_ITEMS_SELECT';var changeImportStructuresForm=function changeImportStructuresForm(fields){return{type:IMPORT_STRUCTURES_FORM_CHANGE,fields:fields};};var uploadImportStructuresFile=function uploadImportStructuresFile(file){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(IMPORT_STRUCTURES_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["v" /* getCheckImportedFileXmlSdmxObjectsUrl */])(),fileFormData,function(t){return{success:t('scenes.utilities.importStructures.messages.fileUpload.success')};});};var submitImportStructures=function submitImportStructures(structures,hash){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(IMPORT_STRUCTURES_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_50" /* getImportFileXmlSdmxObjectsUrl */])(),{importedItem:structures,hashImport:hash});};var hideImportStructuresReport=function hideImportStructuresReport(){return{type:IMPORT_STRUCTURES_REPORT_HIDE};};var resetImportStructures=function resetImportStructures(){return{type:IMPORT_STRUCTURES_RESET};};var selectImportStructuresItem=function selectImportStructuresItem(item,selected){return{type:IMPORT_STRUCTURES_ITEM_SELECT,item:item,selected:selected};};var selectImportStructuresAllItems=function selectImportStructuresAllItems(items){return{type:IMPORT_STRUCTURES_ALL_ITEMS_SELECT,items:items};};

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CODELISTS_LIST_CODELISTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CODELISTS_CODELIST_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CODELISTS_SELECTED_CODELISTS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CODELISTS_DETAIL_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CODELISTS_DETAIL_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CODELISTS_CODELIST_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CODELISTS_CODELIST_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return readCodelistsListCodelists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteCodelistsCodelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return showCodelistsDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hideCodelistsDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteCodelistsSelectedCodelists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return readCodelistsCodelistParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hideCodelistsCodelistParentsAndChildren; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
var CODELISTS_LIST_CODELISTS_READ='CODELISTS_LIST_CODELISTS_READ';var CODELISTS_CODELIST_DELETE='CODELISTS_CODELIST_DELETE';var CODELISTS_SELECTED_CODELISTS_DELETE='CODELISTS_SELECTED_CODELISTS_DELETE';var CODELISTS_DETAIL_ANNOTATIONS_SHOW='CODELISTS_DETAIL_ANNOTATIONS_SHOW';var CODELISTS_DETAIL_ANNOTATIONS_HIDE='CODELISTS_DETAIL_ANNOTATIONS_HIDE';var CODELISTS_CODELIST_PARENTS_AND_CHILDREN_READ='CODELISTS_CODELIST_PARENTS_AND_CHILDREN_READ';var CODELISTS_CODELIST_PARENTS_AND_CHILDREN_HIDE='CODELISTS_CODELIST_PARENTS_AND_CHILDREN_HIDE';var readCodelistsListCodelists=function readCodelistsListCodelists(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CODELISTS_LIST_CODELISTS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["A" /* getCodelistUrl */])());};var deleteCodelistsCodelist=function deleteCodelistsCodelist(codelistTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(CODELISTS_CODELIST_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("CodeList",codelistTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var showCodelistsDetailAnnotations=function showCodelistsDetailAnnotations(annotations,triplet){return{type:CODELISTS_DETAIL_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideCodelistsDetailAnnotations=function hideCodelistsDetailAnnotations(){return{type:CODELISTS_DETAIL_ANNOTATIONS_HIDE};};var deleteCodelistsSelectedCodelists=function deleteCodelistsSelectedCodelists(codelistTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(CODELISTS_SELECTED_CODELISTS_DELETE,codelistTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),codelistTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("CodeList",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},codelistTriplets.map(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]),true);};var readCodelistsCodelistParentsAndChildren=function readCodelistsCodelistParentsAndChildren(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CODELISTS_CODELIST_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideCodelistsCodelistParentsAndChildren=function hideCodelistsCodelistParentsAndChildren(){return{type:CODELISTS_CODELIST_PARENTS_AND_CHILDREN_HIDE};};

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CATEGORY_SCHEMES_LIST_CATEGORY_SCHEMES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CATEGORY_SCHEMES_CATEGORY_SCHEME_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CATEGORY_SCHEMES_SELECTED_CATEGORY_SCHEMES_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return readCategorySchemesListCategorySchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteCategorySchemesCategoryScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteCategorySchemesSelectedCategorySchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return showCategorySchemesDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hideCategorySchemesDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return readCategorySchemesCategorySchemeParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hideCategorySchemesCategorySchemeParentsAndChildren; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
var CATEGORY_SCHEMES_LIST_CATEGORY_SCHEMES_READ='CATEGORY_SCHEMES_LIST_CATEGORY_SCHEMES_READ';var CATEGORY_SCHEMES_CATEGORY_SCHEME_DELETE='CATEGORY_SCHEMES_CATEGORY_SCHEME_DELETE';var CATEGORY_SCHEMES_SELECTED_CATEGORY_SCHEMES_DELETE='CATEGORY_SCHEMES_SELECTED_CATEGORY_SCHEMES_DELETE';var CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_SHOW='CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_SHOW';var CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_HIDE='CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_HIDE';var CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_READ='CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_READ';var CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_HIDE='CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_HIDE';var readCategorySchemesListCategorySchemes=function readCategorySchemesListCategorySchemes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CATEGORY_SCHEMES_LIST_CATEGORY_SCHEMES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["p" /* getCategorySchemeUrl */])());};var deleteCategorySchemesCategoryScheme=function deleteCategorySchemesCategoryScheme(categorySchemeTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(CATEGORY_SCHEMES_CATEGORY_SCHEME_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("CategoryScheme",categorySchemeTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var deleteCategorySchemesSelectedCategorySchemes=function deleteCategorySchemesSelectedCategorySchemes(categorySchemeTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(CATEGORY_SCHEMES_SELECTED_CATEGORY_SCHEMES_DELETE,categorySchemeTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),categorySchemeTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("CategoryScheme",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},categorySchemeTriplets.map(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]),true);};var showCategorySchemesDetailAnnotations=function showCategorySchemesDetailAnnotations(annotations,triplet){return{type:CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideCategorySchemesDetailAnnotations=function hideCategorySchemesDetailAnnotations(){return{type:CATEGORY_SCHEMES_DETAIL_ANNOTATIONS_HIDE};};var readCategorySchemesCategorySchemeParentsAndChildren=function readCategorySchemesCategorySchemeParentsAndChildren(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideCategorySchemesCategorySchemeParentsAndChildren=function hideCategorySchemesCategorySchemeParentsAndChildren(){return{type:CATEGORY_SCHEMES_CATEGORY_SCHEME_PARENTS_AND_CHILDREN_HIDE};};

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONCEPT_SCHEMES_LIST_CONCEPT_SCHEMES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONCEPT_SCHEMES_CONCEPT_SCHEME_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONCEPT_SCHEMES_SELECTED_CONCEPT_SCHEMES_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return readConceptSchemesListConceptSchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteConceptSchemesConceptScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return showConceptSchemesDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hideConceptSchemesDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteConceptSchemesSelectedConceptSchemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return readConceptSchemesConceptSchemeParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hideConceptSchemesConceptSchemeParentsAndChildren; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
var CONCEPT_SCHEMES_LIST_CONCEPT_SCHEMES_READ='CONCEPT_SCHEMES_LIST_CONCEPT_SCHEMES_READ';var CONCEPT_SCHEMES_CONCEPT_SCHEME_DELETE='CONCEPT_SCHEMES_CONCEPT_SCHEME_DELETE';var CONCEPT_SCHEMES_SELECTED_CONCEPT_SCHEMES_DELETE='CONCEPT_SCHEMES_SELECTED_CONCEPT_SCHEMES_DELETE';var CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_SHOW='CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_SHOW';var CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_HIDE='CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_HIDE';var CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_READ='CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_READ';var CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_HIDE='CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_HIDE';var readConceptSchemesListConceptSchemes=function readConceptSchemesListConceptSchemes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONCEPT_SCHEMES_LIST_CONCEPT_SCHEMES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["F" /* getConceptSchemeUrl */])());};var deleteConceptSchemesConceptScheme=function deleteConceptSchemesConceptScheme(conceptSchemeTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(CONCEPT_SCHEMES_CONCEPT_SCHEME_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("ConceptScheme",conceptSchemeTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var showConceptSchemesDetailAnnotations=function showConceptSchemesDetailAnnotations(annotations,triplet){return{type:CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideConceptSchemesDetailAnnotations=function hideConceptSchemesDetailAnnotations(){return{type:CONCEPT_SCHEMES_DETAIL_ANNOTATIONS_HIDE};};var deleteConceptSchemesSelectedConceptSchemes=function deleteConceptSchemesSelectedConceptSchemes(conceptSchemeTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(CONCEPT_SCHEMES_SELECTED_CONCEPT_SCHEMES_DELETE,conceptSchemeTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),conceptSchemeTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("ConceptScheme",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},conceptSchemeTriplets.map(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]),true);};var readConceptSchemesConceptSchemeParentsAndChildren=function readConceptSchemesConceptSchemeParentsAndChildren(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideConceptSchemesConceptSchemeParentsAndChildren=function hideConceptSchemesConceptSchemeParentsAndChildren(){return{type:CONCEPT_SCHEMES_CONCEPT_SCHEME_PARENTS_AND_CHILDREN_HIDE};};

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilterTab__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_artefact_export_form__ = __webpack_require__(51);
var contentConstraintDetailModalReducer=function contentConstraintDetailModalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{contentConstraintTriplet:null,forceIsFinalDisabled:false,isVisible:false,isEditDisabled:false,isContentConstraintValid:true,isAgenciesValid:true,isContentConstraintGeneralTabDirty:false,contentConstraint:null,agencies:null,downloadContentConstraintTriplet:null,downloadContentConstraintLang:null,downloadContentConstraintParams:null,cloneDestTriplet:null,contentConstraintAnnotations:null,contentConstraintExportSourceTriplet:null,contentConstraintExportDestination:null,contentConstraintExportReport:null,artefactType:null,isArtefactsVisible:false,artefacts:null,artefactTriplet:null,artefact:null,filterDsdTriplet:null,filterCubeId:null,filterColumns:null,filter:{},isFilterModalVisible:false,isFilterQueryVisible:false,releaseCalendar:{periodicity:{value:null,measureUnit:null},offset:{value:null,measureUnit:null},tolerance:{value:null,measureUnit:null}}};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* CONTENT_CONSTRAINT_DETAIL_CREATE */]:return Object.assign({},state,{contentConstraint:{id:null,agencyID:null,version:null,isFinal:false,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,structure:null},isVisible:true,isEditDisabled:false,isAgenciesValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* CONTENT_CONSTRAINT_DETAIL_EDIT */]:return Object.assign({},state,{isVisible:true,contentConstraintTriplet:action.contentConstraintTriplet,isContentConstraintValid:false,isAgenciesValid:false,isContentConstraintGeneralTabDirty:false,isEditDisabled:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* CONTENT_CONSTRAINT_DETAIL_SHOW */]:return Object.assign({},state,{forceIsFinalDisabled:false,isVisible:true,contentConstraintTriplet:action.contentConstraintTriplet,isContentConstraintValid:false,isAgenciesValid:false,isContentConstraintGeneralTabDirty:false,isEditDisabled:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* CONTENT_CONSTRAINT_DETAIL_HIDE */]:return Object.assign({},state,{forceIsFinalDisabled:false,isVisible:false,contentConstraintTriplet:null,contentConstraint:null,agencies:null,allAgencies:null,artefactType:null,isArtefactsVisible:false,artefacts:null,artefactTriplet:null,artefact:null,filterDsdTriplet:null,filterCubeId:null,filterColumns:null,filter:{},releaseCalendar:{periodicity:{value:null,measureUnit:null},offset:{value:null,measureUnit:null},tolerance:{value:null,measureUnit:null}},isEditDisabled:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* CONTENT_CONSTRAINT_DETAIL_CHANGE */]:{var contentConstraint=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.contentConstraint);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{contentConstraint:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(contentConstraint,action.fields,customizer),isContentConstraintGeneralTabDirty:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadContentConstraintTriplet:action.artefactTriplet,downloadContentConstraintLang:action.lang,downloadContentConstraintParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadContentConstraintTriplet:null,downloadContentConstraintLang:null,downloadContentConstraintParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_CHANGE */]:var downloadContentConstraintParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadContentConstraintParams);return Object.assign({},state,{downloadContentConstraintParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadContentConstraintParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* CONTENT_CONSTRAINT_DETAIL_CLONE_SHOW */]:var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),contentConstraintTriplet:state.contentConstraintTriplet?state.contentConstraintTriplet:action.srcTriplet,isContentConstraintValid:!!state.contentConstraint,isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* CONTENT_CONSTRAINT_DETAIL_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,contentConstraint:state.isVisible?state.contentConstraint:null,contentConstraintTriplet:state.isVisible?state.contentConstraintTriplet:null,artefactType:state.isVisible?state.artefactType:null,artefactTriplet:state.isVisible?state.artefactTriplet:null,filter:state.isVisible?state.filter:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* CONTENT_CONSTRAINT_DETAIL_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* CONTENT_CONSTRAINT_DETAIL_EXPORT_SHOW */]:return Object.assign({},state,{contentConstraintExportSourceTriplet:action.sourceTriplet,contentConstraintExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,loginOption:__WEBPACK_IMPORTED_MODULE_9__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null},contentConstraintTriplet:state.contentConstraintTriplet?state.contentConstraintTriplet:action.sourceTriplet,isContentConstraintValid:!!state.contentConstraint,isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* CONTENT_CONSTRAINT_DETAIL_EXPORT_HIDE */]:return Object.assign({},state,{contentConstraintExportSourceTriplet:null,contentConstraintExportDestination:null,contentConstraint:state.isVisible?state.contentConstraint:null,contentConstraintTriplet:state.isVisible?state.contentConstraintTriplet:null,artefactType:state.isVisible?state.artefactType:null,artefactTriplet:state.isVisible?state.artefactTriplet:null,filter:state.isVisible?state.filter:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* CONTENT_CONSTRAINT_DETAIL_EXPORT_CHANGE */]:var contentConstraintExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.contentConstraintExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(contentConstraintExportDestination,action.fields);return Object.assign({},state,{contentConstraintExportDestination:contentConstraintExportDestination});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CONTENT_CONSTRAINT_DETAIL_ARTEFACT_TYPE_SELECT */]:return Object.assign({},state,{artefactType:action.artefactType,artefactTriplet:action.artefactType!==state.artefactType?null:state.artefactTriplet,artefact:action.artefactType!==state.artefactType?null:state.artefact,filterDsdTriplet:action.artefactType!==state.artefactType?null:state.filterDsdTriplet,filterCubeId:action.artefactType!==state.artefactType?null:state.filterCubeId,filterColumns:action.artefactType!==state.artefactType?null:state.filterColumns,filter:action.artefactType!==state.artefactType?{}:state.filter});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_SHOW */]:return Object.assign({},state,{isArtefactsVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_HIDE */]:return Object.assign({},state,{isArtefactsVisible:false,artefacts:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CONTENT_CONSTRAINT_DETAIL_ARTEFACT_SET */]:return Object.assign({},state,{isArtefactsVisible:false,artefactTriplet:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.artefactTriplet),artefacts:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* CONTENT_CONSTRAINT_DETAIL_ARTEFACT_UNSET */]:return Object.assign({},state,{artefactTriplet:null,artefact:null,filterDsdTriplet:null,filterCubeId:null,filterColumns:null,filter:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* CONTENT_CONSTRAINT_DETAIL_RELEASE_CALENDAR_CHANGE */]:var releaseCalendar=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.releaseCalendar);return Object.assign({},state,{releaseCalendar:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(releaseCalendar,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_MODE_CHANGE */]:{var filter=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.filter);var columnName=Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["a" /* getNormalizedColumnName */])(action.colName);filter[columnName]={mode:action.mode,values:filter[columnName]&&filter[columnName].values?filter[columnName].values:[]};var colNames=state.filterColumns.map(function(_ref){var name=_ref.name;return name;});var colIndex=colNames.indexOf(action.colName);var subsequentColNames=colNames.splice(colIndex+1);// delete filters for subsequent cols
subsequentColNames.forEach(function(name){delete filter[Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["a" /* getNormalizedColumnName */])(name)];});return Object.assign({},state,{filterColumns:// delete filteredCodelistTree for subsequent cols
state.filterColumns.map(function(col){return subsequentColNames.includes(col.name)?Object.assign({},col,{filteredCodelistTree:state.filterCubeId?null:col.filteredCodelistTree}):col;}),filter:filter});}case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_VALUES_CHANGE */]:{var _filter=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.filter);var _columnName=Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["a" /* getNormalizedColumnName */])(action.colName);_filter[_columnName]={mode:_filter[_columnName]&&_filter[_columnName].mode?_filter[_columnName].mode:__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["n" /* FILTER_MODE_IN */],values:action.values};var _colNames=state.filterColumns.map(function(_ref2){var name=_ref2.name;return name;});var _colIndex=_colNames.indexOf(action.colName);var _subsequentColNames=_colNames.splice(_colIndex+1);// delete filters for subsequent cols
_subsequentColNames.forEach(function(name){delete _filter[Object(__WEBPACK_IMPORTED_MODULE_8__utils_normalizers__["a" /* getNormalizedColumnName */])(name)];});return Object.assign({},state,{filter:_filter,filterColumns:// delete filteredCodelistTree for subsequent cols
state.filterColumns.map(function(col){if(_subsequentColNames.includes(col.name)){return Object.assign({},col,{filteredCodelistTree:state.filterCubeId?null:col.filteredCodelistTree});}else{return col;}})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_SHOW */]:return Object.assign({},state,{isFilterModalVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* CONTENT_CONSTRAINT_DETAIL_FILTER_MODAL_HIDE */]:return Object.assign({},state,{isFilterModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_SHOW */]:return Object.assign({},state,{isFilterQueryVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* CONTENT_CONSTRAINT_DETAIL_FILTER_QUERY_HIDE */]:return Object.assign({},state,{isFilterQueryVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* CONTENT_CONSTRAINT_DETAIL_FILTER_RESET */]:return Object.assign({},state,{filter:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* CONTENT_CONSTRAINT_DETAIL_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{contentConstraintExportReport:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT */]:return Object.assign({},state,{isContentConstraintGeneralTabDirty:false,agencies:null,allAgencies:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* CONTENT_CONSTRAINT_DETAIL_READ */]:var _getContentConstraint=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["Q" /* getContentConstraintFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations),_contentConstraint=_getContentConstraint.contentConstraint,attachmentType=_getContentConstraint.attachmentType,attachmentUrn=_getContentConstraint.attachmentUrn,_filter2=_getContentConstraint.filter;return Object.assign({},state,{contentConstraint:_contentConstraint,artefactType:attachmentType.toLowerCase()==="datastructure"?__WEBPACK_IMPORTED_MODULE_4__FilterTab__["b" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD */]:__WEBPACK_IMPORTED_MODULE_4__FilterTab__["a" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW */],artefactTriplet:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(attachmentUrn)),isContentConstraintValid:true,filter:_filter2});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CONTENT_CONSTRAINT_DETAIL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response,isAgenciesValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* CONTENT_CONSTRAINT_DETAIL_CREATE_SUBMIT */]:return Object.assign({},state,{forceIsFinalDisabled:state.contentConstraint.isFinal});case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* CONTENT_CONSTRAINT_DETAIL_UPDATE_SUBMIT */]:return Object.assign({},state,{forceIsFinalDisabled:state.contentConstraint.isFinal});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SUBMIT */]:return Object.assign({},state,{downloadContentConstraintTriplet:null,downloadContentConstraintLang:null,downloadContentConstraintParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* CONTENT_CONSTRAINT_DETAIL_CLONE_SUBMIT */]:return Object.assign({},state,{cloneDestTriplet:null,contentConstraint:state.isVisible?state.contentConstraint:null,contentConstraintTriplet:state.isVisible?state.contentConstraintTriplet:null,artefactType:null,artefactTriplet:null,filter:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* CONTENT_CONSTRAINT_DETAIL_EXPORT_SUBMIT */]:return Object.assign({},state,{contentConstraintExportSourceTriplet:null,contentConstraintExportSourceAttachmentType:null,contentConstraintExportSourceAttachmentUrn:null,contentConstraintExportSourceFilter:null,contentConstraintExportDestination:null,contentConstraintExportReport:action.response.itemsMessage,contentConstraint:state.isVisible?state.contentConstraint:null,contentConstraintTriplet:state.isVisible?state.contentConstraintTriplet:null,artefactType:state.isVisible?state.artefactType:null,artefactTriplet:state.isVisible?state.artefactTriplet:null,filter:state.isVisible?state.filter:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CONTENT_CONSTRAINT_DETAIL_ARTEFACTS_READ */]:return Object.assign({},state,{artefacts:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CONTENT_CONSTRAINT_DETAIL_ARTEFACT_READ */]:var artefact=action.artefactType===__WEBPACK_IMPORTED_MODULE_4__FilterTab__["b" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD */]?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["R" /* getDsdFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0])[0],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations):Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0])[0],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);var isDDBDataflow=action.artefactType===__WEBPACK_IMPORTED_MODULE_4__FilterTab__["a" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW */]&&(artefact.autoAnnotations||[]).find(function(_ref3){var type=_ref3.type;return type.toLowerCase()===Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_7__utils_annotations__["c" /* AUTO_ANNOTATION_DDBDATAFLOW_KEY */]].toLowerCase();})&&action.haveDMWS&&action.isUserLogged&&action.response[1].find(function(ddbDf){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({agencyID:ddbDf.Agency,version:ddbDf.Version,id:ddbDf.ID})===Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(artefact);})!==undefined;return Object.assign({},state,{artefact:artefact,filterColumns:action.artefactType===__WEBPACK_IMPORTED_MODULE_4__FilterTab__["b" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DSD */]?(artefact.dimensions||[]).concat(artefact.attributes||[]).filter(function(comp){return comp.representation!==null||comp.type===__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */];}).map(function(comp){return{name:comp.id,CodelistCode:comp.representation!==null?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(comp.representation)):null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,filteredCodelistTreeMaxDepth:null,filteredValues:null};}):null,filterDsdTriplet:action.artefactType===__WEBPACK_IMPORTED_MODULE_4__FilterTab__["a" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW */]&&!isDDBDataflow?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(artefact.structure):null,filterCubeId:action.artefactType===__WEBPACK_IMPORTED_MODULE_4__FilterTab__["a" /* CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW */]&&action.haveDMWS&&isDDBDataflow?action.response[1].find(function(ddbDf){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({agencyID:ddbDf.Agency,version:ddbDf.Version,id:ddbDf.ID})===Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(artefact);}).IDCube:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* CONTENT_CONSTRAINT_DETAIL_FILTER_DSD_READ */]:var dsd=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["R" /* getDsdFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);return Object.assign({},state,{filterColumns:dsd.dimensions.concat(dsd.attributes||[]).map(function(comp){return{name:comp.id,CodelistCode:comp.representation?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(comp.representation)):null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,filteredCodelistTreeMaxDepth:null,filteredValues:null};})});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* CONTENT_CONSTRAINT_DETAIL_FILTER_CUBE_READ */]:return Object.assign({},state,{filterColumns:action.response.Dimensions.concat(action.response.Attributes).map(function(comp){return{name:comp.ColName,CodelistCode:comp.CodelistCode,codelistCount:null,codelistTree:null,filteredCodelistTree:null,filteredCodelistTreeMaxDepth:null,filteredValues:null};})});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_FILTERED_VALUES_READ */]:{var filteredValues=action.response.Data.map(function(obj){return obj[action.colName];});var filterColumns=state.filterColumns.map(function(col){if(col.name===action.colName){var filteredCodelistTree=col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["g" /* getFilteredTreeWithPaths */])(col.codelistTree||[],"codes",function(_ref4){var id=_ref4.id;return filteredValues.includes(id);}):null;return Object.assign({},col,{filteredCodelistTree:filteredCodelistTree,filteredValues:filteredValues,filteredCodelistTreeMaxDepth:col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["j" /* getMaxTreeDepth */])(filteredCodelistTree,"codes"):null});}else return col;});return Object.assign({},state,{filterColumns:filterColumns});}case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_COUNT_READ */]:{var _filterColumns=state.filterColumns.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistCount:Number(action.header["x-total-count"])}):col;});return Object.assign({},state,{filterColumns:_filterColumns});}case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* CONTENT_CONSTRAINT_DETAIL_FILTER_COLUMN_CODELIST_TREE_READ */]:{var codelist=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var itemsTree=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["n" /* getTreeFromArray */])(codelist.codes||[],"codes");var _filterColumns2=state.filterColumns.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistTree:itemsTree,filteredCodelistTree:state.filterCubeId?col.filteredCodelistTree:itemsTree,filteredValues:state.filterCubeId?col.filteredValues:Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["l" /* getNodes */])(itemsTree,"codes",function(){return true;}).map(function(_ref5){var id=_ref5.id;return id;}),filteredCodelistTreeMaxDepth:state.filterCubeId?col.filteredCodelistTreeMaxDepth:Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["j" /* getMaxTreeDepth */])(itemsTree,"codes")}):col;});return Object.assign({},state,{filterColumns:_filterColumns2});}default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* CONTENT_CONSTRAINT_DETAIL_READ */]:return Object.assign({},state,{isVisible:false,isContentConstraintValid:true});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (contentConstraintDetailModalReducer);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PERMISSIONS_TAB_FUNCTIONALITIES_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PERMISSIONS_TAB_RULES_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PERMISSIONS_TAB_AGENCIES_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PERMISSIONS_TAB_CUBES_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var SET_PERMISSIONS_TAB_FUNCTIONALITIES_KEY='SET_PERMISSIONS_TAB_FUNCTIONALITIES_KEY';var SET_PERMISSIONS_TAB_RULES_KEY='SET_PERMISSIONS_TAB_RULES_KEY';var SET_PERMISSIONS_TAB_AGENCIES_KEY='SET_PERMISSIONS_TAB_AGENCIES_KEY';var SET_PERMISSIONS_TAB_CUBES_KEY='SET_PERMISSIONS_TAB_CUBES_KEY';var setPermissionsReducer=function setPermissionsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{users:null,user:null,currentTab:SET_PERMISSIONS_TAB_FUNCTIONALITIES_KEY,functionalities:null,rules:null,agencies:null,categories:null,categorisedCubes:null,permissions:null,isSynchronized:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["n" /* SET_PERMISSIONS_USER_EDIT */]:return Object.assign({},state,{user:{username:action.username,email:action.email,password:null,confirmPassword:null},permissions:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["o" /* SET_PERMISSIONS_USER_HIDE */]:return Object.assign({},state,{currentTab:SET_PERMISSIONS_TAB_FUNCTIONALITIES_KEY,user:null,permissions:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["l" /* SET_PERMISSIONS_TAB_CHANGE */]:return Object.assign({},state,{currentTab:action.tab});case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* SET_PERMISSIONS_FUNCTIONALITIES_CHANGE */]:return Object.assign({},state,{permissions:Object.assign({},state.permissions,{functionality:action.functionalitiesPermissions/* TODO */})});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SET_PERMISSIONS_AGENCIES_CHANGE */]:return Object.assign({},state,{permissions:Object.assign({},state.permissions,{agencies:action.agenciesPermissions})});case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* SET_PERMISSIONS_RULES_CHANGE */]:return Object.assign({},state,{permissions:Object.assign({},state.permissions,{rules:action.rulesPermissions})});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* SET_PERMISSIONS_CATEGORISED_CUBES_CHANGE */]:var categoriesPermissions=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["l" /* getNodes */])(state.categorisedCubes,"children",function(_ref){var CatCode=_ref.CatCode;return CatCode&&(action.categorisedCubesPermissions||[]).filter(function(str){return CatCode===str;}).length;}).map(function(_ref2){var CatCode=_ref2.CatCode;return CatCode;});var cubesPermissions=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["l" /* getNodes */])(state.categorisedCubes,"children",function(_ref3){var Code=_ref3.Code;return Code&&(action.categorisedCubesPermissions||[]).filter(function(str){return Code===str;}).length;}).map(function(_ref4){var Code=_ref4.Code;return Code;});return Object.assign({},state,{permissions:Object.assign({},state.permissions,{category:categoriesPermissions,cube:cubesPermissions})});case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* SET_PERMISSIONS_SYNCHRONIZE */]:return Object.assign({},state,{isSynchronized:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* SET_PERMISSIONS_PERMISSIONS_SUBMIT */]:return Object.assign({},state,{users:null,user:null,permissions:null,currentTab:SET_PERMISSIONS_TAB_FUNCTIONALITIES_KEY});case __WEBPACK_IMPORTED_MODULE_0__actions__["m" /* SET_PERMISSIONS_USERS_READ */]:return Object.assign({},state,{users:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* SET_PERMISSIONS_PERMISSIONS_READ */]:return Object.assign({},state,{permissions:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* SET_PERMISSIONS_FUNCTIONALITIES_READ */]:// TODO: remove
return Object.assign({},state,{functionalities:Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["h" /* getMappedTree */])(action.response,"Children",function(node){return Object.assign({},node,{name:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["l" /* getNodes */])(action.menu,"children",function(_ref5){var path=_ref5.path;return path&&path.substr(path.lastIndexOf("/")+1)===node.Functionality;})[0]||{}).label||""});})});case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SET_PERMISSIONS_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.pickBy(action.response[1],function(_,agencyID){return action.response[0].includes(agencyID);})});case __WEBPACK_IMPORTED_MODULE_0__actions__["j" /* SET_PERMISSIONS_RULES_READ */]:return Object.assign({},state,{rules:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* SET_PERMISSIONS_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:Object(__WEBPACK_IMPORTED_MODULE_3__utils_treeBuilders__["b" /* getCubesTree */])(action.response[0],action.response[1])[0].children});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["e"] = (setPermissionsReducer);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SYNC_CODELISTS_CODELISTS_TO_SYNC_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SYNC_CODELISTS_CODELISTS_TO_SYNC_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SYNC_CODELISTS_SYNC_CODELISTS_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return readSyncCodelistCodelistToSyncList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeSyncCodelistsCodelistsToSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return submitSyncCodelistsSyncCodelists; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var SYNC_CODELISTS_CODELISTS_TO_SYNC_READ='SYNC_CODELISTS_CODELISTS_TO_SYNC_READ';var SYNC_CODELISTS_CODELISTS_TO_SYNC_CHANGE='SYNC_CODELISTS_CODELISTS_TO_SYNC_CHANGE';var SYNC_CODELISTS_SYNC_CODELISTS_SUBMIT='SYNC_CODELISTS_SYNC_CODELISTS_SUBMIT';var readSyncCodelistCodelistToSyncList=function readSyncCodelistCodelistToSyncList(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(SYNC_CODELISTS_CODELISTS_TO_SYNC_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["g" /* getAllCodelistToBeSynchronizedUrl */])());};var changeSyncCodelistsCodelistsToSync=function changeSyncCodelistsCodelistsToSync(selectedCodelists){return{type:SYNC_CODELISTS_CODELISTS_TO_SYNC_CHANGE,selectedCodelists:selectedCodelists};};var submitSyncCodelistsSyncCodelists=function submitSyncCodelistsSyncCodelists(codelistsToSync,codelists){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(SYNC_CODELISTS_SYNC_CODELISTS_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_88" /* getShyncCodelistsUrl */])(),codelists.filter(function(codelist){return codelistsToSync.includes(codelist.id+'+'+codelist.agency+'+'+codelist.version);}),function(t){return{success:t('scenes.dataManager.syncCodelist.messages.sync.success')};});};

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISATION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_LANGUAGE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return readCategorySchemesAndDataflowsTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return categoriseCategorySchemesAndDataflowsDataflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteCategorySchemesAndDataflowsDataflowCategorisation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeCategorySchemesAndDataflowsLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__ = __webpack_require__(10);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ='CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ';var CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISE='CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISE';var CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISATION_DELETE='CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISATION_DELETE';var CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_LANGUAGE_CHANGE='CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_LANGUAGE_CHANGE';var readCategorySchemesAndDataflowsTree=function readCategorySchemesAndDataflowsTree(lang){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["i" /* allRequest */])(CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ,[__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["p" /* getCategorySchemeUrl */])(null,true),Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_7" /* getDataflowUrl */])()]),{lang:lang});};var categoriseCategorySchemesAndDataflowsDataflow=function categoriseCategorySchemesAndDataflowsDataflow(dataflow,newCategoryUrn,categorisations,from,to,fromSisterDfOrderedCategorisations,toSisterDfOrderedCategorisations,lang,orderAnnotationType,agencyPermissions,t){if(!dataflow.categoryUrn){// dataflow was uncategorised
var categorisationId='CAT_'+dataflow.id.substr(0,40)+'_'+String(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.random(99999)).padStart(5,'0');var categorisation={id:categorisationId,agencyID:dataflow.agencyID,version:dataflow.version,name:{en:categorisationId},source:dataflow.urn,target:newCategoryUrn,autoAnnotations:[{type:orderAnnotationType,text:_defineProperty({},lang,String(to))}]};// sister df categorisations must have order in 0..to-1 or to+1..N
var newToSisterDfCategorisations=toSisterDfOrderedCategorisations.filter(function(_ref){var source=_ref.source;return source!==dataflow.urn;}).map(function(categoris,index){var newOrderAnnot={type:orderAnnotationType,text:Object.assign({},((categoris.autoAnnotations||[]).find(function(_ref2){var type=_ref2.type;return type===orderAnnotationType;})||{}).text||{},_defineProperty({},lang,String(index<to?index:index+1)))};return Object.assign({},categoris,{autoAnnotations:[].concat(_toConsumableArray((categoris.autoAnnotations||[]).filter(function(_ref3){var type=_ref3.type;return type!==orderAnnotationType;})),[newOrderAnnot])});});var structures=[Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(categorisation)].concat(_toConsumableArray(newToSisterDfCategorisations.map(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])));var notAllowedAgency=null;structures.forEach(function(_ref4){var agencyID=_ref4.agencyID;if(!notAllowedAgency&&!agencyPermissions.includes(agencyID)){notAllowedAgency=agencyID;}});if(notAllowedAgency){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t("scenes.metaManager.categorySchemesDataflowsTree.errors.notAllowedAgency.title",{agencyId:notAllowedAgency})});return{type:"NOP"};}return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["n" /* putRequest */])(CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])(structures,__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["r" /* SDMX_JSON_CATEGORISATION_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.categorySchemesAndDataflows.messages.categorisation.update.success')};});}else{// dataflow was categorised
var newCategorisation=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(categorisations,function(cat){return cat.source===dataflow.urn&&cat.target===dataflow.categoryUrn;});newCategorisation.target=newCategoryUrn;newCategorisation.autoAnnotations=[].concat(_toConsumableArray((newCategorisation.autoAnnotations||[]).filter(function(_ref5){var type=_ref5.type;return type!==orderAnnotationType;})),[{type:orderAnnotationType,text:Object.assign({},((newCategorisation.autoAnnotations||[]).find(function(_ref6){var type=_ref6.type;return type===orderAnnotationType;})||{}).text||{},_defineProperty({},lang,String(to)))}]);// sister source df categorisations must have order in 0..N-1
var newFromSisterDfCategorisations=fromSisterDfOrderedCategorisations.filter(function(_ref7){var source=_ref7.source;return source!==dataflow.urn;}).map(function(categoris,index){var newOrderAnnot={type:orderAnnotationType,text:Object.assign({},((categoris.autoAnnotations||[]).find(function(_ref8){var type=_ref8.type;return type===orderAnnotationType;})||{}).text||{},_defineProperty({},lang,String(index)))};return Object.assign({},categoris,{autoAnnotations:[].concat(_toConsumableArray((categoris.autoAnnotations||[]).filter(function(_ref9){var type=_ref9.type;return type!==orderAnnotationType;})),[newOrderAnnot])});});// sister target df categorisations must have order in 0..to-1 or to+1..N
var _newToSisterDfCategorisations=toSisterDfOrderedCategorisations.filter(function(_ref10){var source=_ref10.source;return source!==dataflow.urn;}).map(function(categoris,index){var newOrderAnnot={type:orderAnnotationType,text:Object.assign({},((categoris.autoAnnotations||[]).find(function(_ref11){var type=_ref11.type;return type===orderAnnotationType;})||{}).text||{},_defineProperty({},lang,String(index<to?index:index+1)))};return Object.assign({},categoris,{autoAnnotations:[].concat(_toConsumableArray((categoris.autoAnnotations||[]).filter(function(_ref12){var type=_ref12.type;return type!==orderAnnotationType;})),[newOrderAnnot])});});var _structures=[Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(newCategorisation)].concat(_toConsumableArray(newFromSisterDfCategorisations.map(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])),_toConsumableArray(_newToSisterDfCategorisations.map(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])));var _notAllowedAgency=null;_structures.forEach(function(_ref13){var agencyID=_ref13.agencyID;if(!_notAllowedAgency&&!agencyPermissions.includes(agencyID)){_notAllowedAgency=agencyID;}});if(_notAllowedAgency){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t("scenes.metaManager.categorySchemesDataflowsTree.errors.notAllowedAgency.title",{agencyId:_notAllowedAgency})});return{type:"NOP"};}return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["n" /* putRequest */])(CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_96" /* getUpdateArtefactsUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])(_structures,__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["r" /* SDMX_JSON_CATEGORISATION_LIST_KEY */]),function(t){return{success:t('scenes.metaManager.categorySchemesAndDataflows.messages.categorisation.update.success')};});}};var deleteCategorySchemesAndDataflowsDataflowCategorisation=function deleteCategorySchemesAndDataflowsDataflowCategorisation(dataflow,categorisations){var categorisation=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(categorisations,function(cat){return cat.source===dataflow.urn&&cat.target===dataflow.categoryUrn;});return Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["j" /* deleteRequest */])(CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISATION_DELETE,Object(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["_11" /* getDeleteArtefactUrl */])("Categorisation",Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(categorisation.urn)),function(t){return{success:t('scenes.metaManager.categorySchemesAndDataflows.messages.categorisation.delete.success')};});};var changeCategorySchemesAndDataflowsLanguage=function changeCategorySchemesAndDataflowsLanguage(){return{type:CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_LANGUAGE_CHANGE};};

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return categorisationsSorterFactory; });
var categorisationsSorterFactory=function categorisationsSorterFactory(annotationType,lang){return function(a,b){var aOrderAnnot=a.autoAnnotations&&a.autoAnnotations.length&&a.autoAnnotations.find(function(_ref){var type=_ref.type;return type===annotationType;});var bOrderAnnot=b.autoAnnotations&&b.autoAnnotations.length&&b.autoAnnotations.find(function(_ref2){var type=_ref2.type;return type===annotationType;});if(aOrderAnnot&&aOrderAnnot.text&&aOrderAnnot.text[lang]&&bOrderAnnot&&bOrderAnnot.text&&bOrderAnnot.text[lang]){return Number(aOrderAnnot.text[lang])-Number(bOrderAnnot.text[lang]);}else{return 0;}};};

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DSDS_LIST_DSDS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DSDS_LIST_DSD_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DSDS_LIST_DSD_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DSDS_LIST_DSD_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DSDS_LIST_SELECTED_DSDS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DSDS_DSD_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DSDS_DSD_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return readDsdsListDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteDsdsListDsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteDsdsListSelectedDsds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return showDsdsListDsdAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return hideDsdsListDsdAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return showDsdsListDsdLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hideDsdsListDsdLayoutAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return readDsdsDetailItemsImportFormAllCsvRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hideDsdsDetailItemsImportFormAllCsvRows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
var DSDS_LIST_DSDS_READ='DSDS_LIST_DSDS_READ';var DSDS_LIST_DSD_ANNOTATIONS_SHOW='DSDS_LIST_DSD_ANNOTATIONS_SHOW';var DSDS_LIST_DSD_ANNOTATIONS_HIDE='DSDS_LIST_DSD_ANNOTATIONS_HIDE';var DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_SHOW='DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_SHOW';var DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_HIDE='DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_HIDE';var DSDS_LIST_DSD_DELETE='DSDS_LIST_DSD_DELETE';var DSDS_LIST_SELECTED_DSDS_DELETE='DSDS_LIST_SELECTED_DSDS_DELETE';var DSDS_DSD_PARENTS_AND_CHILDREN_READ='DSDS_DSD_PARENTS_AND_CHILDREN_READ';var DSDS_DSD_PARENTS_AND_CHILDREN_HIDE='DSDS_DSD_PARENTS_AND_CHILDREN_HIDE';var readDsdsListDsds=function readDsdsListDsds(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DSDS_LIST_DSDS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_30" /* getDsdUrl */])());};var deleteDsdsListDsd=function deleteDsdsListDsd(dsdTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(DSDS_LIST_DSD_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("Dsd",dsdTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var deleteDsdsListSelectedDsds=function deleteDsdsListSelectedDsds(dsdTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(DSDS_LIST_SELECTED_DSDS_DELETE,dsdTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),dsdTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("Dsd",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},dsdTriplets.map(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]));};var showDsdsListDsdAnnotations=function showDsdsListDsdAnnotations(annotations,triplet){return{type:DSDS_LIST_DSD_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideDsdsListDsdAnnotations=function hideDsdsListDsdAnnotations(){return{type:DSDS_LIST_DSD_ANNOTATIONS_HIDE};};var showDsdsListDsdLayoutAnnotations=function showDsdsListDsdLayoutAnnotations(annotations,triplet){return{type:DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideDsdsListDsdLayoutAnnotations=function hideDsdsListDsdLayoutAnnotations(){return{type:DSDS_LIST_DSD_LAYOUT_ANNOTATIONS_HIDE};};var readDsdsDetailItemsImportFormAllCsvRows=function readDsdsDetailItemsImportFormAllCsvRows(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(DSDS_DSD_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideDsdsDetailItemsImportFormAllCsvRows=function hideDsdsDetailItemsImportFormAllCsvRows(){return{type:DSDS_DSD_PARENTS_AND_CHILDREN_HIDE};};

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DM_COMPARE_DSDS_DSD_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DM_COMPARE_DSDS_CODELIST_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DM_COMPARE_DSDS_SOURCE_MSDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DM_COMPARE_DSDS_SOURCE_XML; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_dsd_detail_modal_reducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
var DM_COMPARE_DSDS_DSD_DETAIL_PREFIX="DM_COMPARE_DSDS_DSD_DETAIL_PREFIX_";var DM_COMPARE_DSDS_CODELIST_DETAIL_PREFIX="DM_COMPARE_DSDS_CODELIST_DETAIL_PREFIX_";var DM_COMPARE_DSDS_SOURCE_MSDB="msdb";var DM_COMPARE_DSDS_SOURCE_XML="xml";var compareDsdsReducer=function compareDsdsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isSrcDsdsVisible:false,isTargetDsdsVisible:false,srcDsds:null,targetDsds:null,srcTriplet:null,targetTriplet:null,report:null,codelistCompareReport:null,srcSource:DM_COMPARE_DSDS_SOURCE_MSDB,targetSource:DM_COMPARE_DSDS_SOURCE_MSDB,srcFile:null,targetFile:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* COMPARE_DSDS_SRC_DSDS_SHOW */]:return Object.assign({},state,{isSrcDsdsVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* COMPARE_DSDS_TARGET_DSDS_SHOW */]:return Object.assign({},state,{isTargetDsdsVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* COMPARE_DSDS_SRC_DSDS_HIDE */]:return Object.assign({},state,{isSrcDsdsVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* COMPARE_DSDS_TARGET_DSDS_HIDE */]:return Object.assign({},state,{isTargetDsdsVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* COMPARE_DSDS_SRC_TRIPLET_SET */]:return Object.assign({},state,{srcTriplet:action.srcTriplet,srcDsds:null,isSrcDsdsVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* COMPARE_DSDS_SRC_TRIPLET_RESET */]:return Object.assign({},state,{srcTriplet:null,report:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* COMPARE_DSDS_TARGET_TRIPLET_SET */]:return Object.assign({},state,{targetTriplet:action.targetTriplet,targetDsds:null,isTargetDsdsVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* COMPARE_DSDS_TARGET_TRIPLET_RESET */]:return Object.assign({},state,{targetTriplet:null,report:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* COMPARE_DSDS_CODELIST_COMPARE_REPORT_HIDE */]:return Object.assign({},state,{codelistCompareReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* COMPARE_DSDS_DSD_SOURCE_CHANGE */]:return Object.assign({},state,{srcSource:action.isSrc?action.source:state.srcSource,targetSource:!action.isSrc?action.source:state.targetSource,srcTriplet:action.isSrc?null:state.srcTriplet,targetTriplet:!action.isSrc?null:state.targetTriplet,srcFile:action.isSrc?null:state.srcFile,targetFile:!action.isSrc?null:state.targetFile,report:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* COMPARE_DSDS_DSD_FILE_SET */]:return Object.assign({},state,{srcFile:action.isSrc?action.file:state.srcFile,targetFile:!action.isSrc?action.file:state.targetFile,report:action.file===null?null:state.report});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* COMPARE_DSDS_SRC_DSDS_READ */]:return Object.assign({},state,{srcDsds:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response).map(function(art){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(art,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* COMPARE_DSDS_TARGET_DSDS_READ */]:return Object.assign({},state,{targetDsds:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response).map(function(art){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(art,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* COMPARE_DSDS_REPORT_READ */]:return Object.assign({},state,{report:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* COMPARE_DSDS_CODELIST_COMPARE_REPORT_READ */]:return Object.assign({},state,{codelistCompareReport:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["e"] = (Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["b" /* reuseInReducer */])(compareDsdsReducer,{dsdDetail:Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_dsd_detail_modal_reducer__["c" /* default */],DM_COMPARE_DSDS_DSD_DETAIL_PREFIX),codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_reducer__["a" /* default */],DM_COMPARE_DSDS_CODELIST_DETAIL_PREFIX)}));

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTENT_CONSTRAINTS_LIST_CONTENT_CONSTRAINTS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONTENT_CONSTRAINTS_SELECTED_CONTENT_CONSTRAINTS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return readContentConstraintsListContentConstraints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteContentConstraintsContentConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteContentConstraintsSelectedContentConstraints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return showContentConstraintsDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hideContentConstraintsDetailAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return readContentConstraintsContentConstraintParentsAndChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hideContentConstraintsContentConstraintParentsAndChildren; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
var CONTENT_CONSTRAINTS_LIST_CONTENT_CONSTRAINTS_READ='CONTENT_CONSTRAINTS_LIST_CONTENT_CONSTRAINTS_READ';var CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_DELETE='CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_DELETE';var CONTENT_CONSTRAINTS_SELECTED_CONTENT_CONSTRAINTS_DELETE='CONTENT_CONSTRAINTS_SELECTED_CONTENT_CONSTRAINTS_DELETE';var CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_SHOW='CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_SHOW';var CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_HIDE='CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_HIDE';var CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_READ='CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_READ';var CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_HIDE='CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_HIDE';var readContentConstraintsListContentConstraints=function readContentConstraintsListContentConstraints(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONTENT_CONSTRAINTS_LIST_CONTENT_CONSTRAINTS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["H" /* getContentConstraintUrl */])());};var deleteContentConstraintsContentConstraint=function deleteContentConstraintsContentConstraint(contentConstraintTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["j" /* deleteRequest */])(CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("ContentConstraint",contentConstraintTriplet),function(t){return{success:t('scenes.metaManager.commons.messages.delete.success')};});};var deleteContentConstraintsSelectedContentConstraints=function deleteContentConstraintsSelectedContentConstraints(contentConstraintTriplets){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(CONTENT_CONSTRAINTS_SELECTED_CONTENT_CONSTRAINTS_DELETE,contentConstraintTriplets.map(function(){return __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["c" /* REQUEST_METHOD_DELETE */];}),contentConstraintTriplets.map(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_11" /* getDeleteArtefactUrl */])("ContentConstraint",triplet);}),null,function(t){return{success:t('scenes.metaManager.commons.messages.multiDelete.success')};},contentConstraintTriplets.map(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */]));};var showContentConstraintsDetailAnnotations=function showContentConstraintsDetailAnnotations(annotations,triplet){return{type:CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_SHOW,annotations:annotations,triplet:triplet};};var hideContentConstraintsDetailAnnotations=function hideContentConstraintsDetailAnnotations(){return{type:CONTENT_CONSTRAINTS_DETAIL_ANNOTATIONS_HIDE};};var readContentConstraintsContentConstraintParentsAndChildren=function readContentConstraintsContentConstraintParentsAndChildren(artefactType,artefactTriplet){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* getArtefactReferenceUrl */])(artefactType,artefactTriplet));};var hideContentConstraintsContentConstraintParentsAndChildren=function hideContentConstraintsContentConstraintParentsAndChildren(){return{type:CONTENT_CONSTRAINTS_CONTENT_CONSTRAINT_PARENTS_AND_CHILDREN_HIDE};};

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UTILITIES_MERGE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UTILITIES_MERGE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UTILITIES_MERGE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_reducer__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_components_redux_concept_scheme_detail_modal_reducer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_components_redux_category_scheme_detail_modal_reducer__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_artefacts__ = __webpack_require__(56);
var UTILITIES_MERGE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX="UTILITIES_MERGE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX_";var UTILITIES_MERGE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX="UTILITIES_MERGE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX_";var UTILITIES_MERGE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX="UTILITIES_MERGE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX_";var mergeItemSchemesReducer=function mergeItemSchemesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{artefactType:__WEBPACK_IMPORTED_MODULE_1__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */],sourceFormat:__WEBPACK_IMPORTED_MODULE_1__actions__["t" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */],targetFormat:__WEBPACK_IMPORTED_MODULE_1__actions__["t" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */],source:null,target:null,isSource:null,isArtefactsVisible:false,artefacts:null,sourceCsvProps:null,targetCsvProps:null,mergedItems:null,mergedItemsFromServer:null,mergeCodelistTriplet:{id:"IdUseOnlyForMerge-aea11369-686d-4997-bff1-98853f3c4882",agencyID:"MERGE",version:"1.0"},mergeCodelistItemCount:null,mergeCodelistFetchParams:null,isMergeVisible:false,mergedItemScheme:null,agencies:null,isCsvPreviewVisible:false,isXmlPreviewVisible:false,isSourcePreview:null,previewItems:null,previewItemCount:null,previewCodelistTriplet:{id:"IdUseOnlyForPreview-aea11369-686d-4997-bff1-98853f3c4882",agencyID:"MERGE",version:"1.0"},previewItemParams:null,csvFilePath:null,allCsvRows:null,mergedWithConflict:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE */]:return Object.assign({},state,{artefactType:action.artefactType,sourceFormat:__WEBPACK_IMPORTED_MODULE_1__actions__["t" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */],targetFormat:__WEBPACK_IMPORTED_MODULE_1__actions__["t" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */],source:null,target:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* MERGE_ITEM_SCHEMES_FORMAT_CHANGE */]:return Object.assign({},state,{sourceFormat:action.isSource?action.format:state.sourceFormat,targetFormat:!action.isSource?action.format:state.targetFormat,source:action.isSource?null:state.source,target:!action.isSource?null:state.target,sourceCsvProps:action.isSource?state.sourceFormat!==__WEBPACK_IMPORTED_MODULE_1__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&action.format===__WEBPACK_IMPORTED_MODULE_1__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]?{identity:{ID:'tempID_1',Agency:'tempAgency_1',Version:'1.0'},textSeparator:';',textDelimiter:'',lang:action.lang,type:state.artefactType,firstRowHeader:true}:null:state.sourceCsvProps,targetCsvProps:!action.isSource?state.targetFormat!==__WEBPACK_IMPORTED_MODULE_1__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&action.format===__WEBPACK_IMPORTED_MODULE_1__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]?{identity:{ID:'tempID_2',Agency:'tempAgency_2',Version:'1.0'},textSeparator:';',textDelimiter:'',lang:action.lang,type:state.artefactType,firstRowHeader:true}:null:state.targetCsvProps});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* MERGE_ITEM_SCHEMES_CSV_PROPS_CHANGE */]:var sourceCsvProps=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.sourceCsvProps);var targetCsvProps=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.targetCsvProps);return Object.assign({},state,{sourceCsvProps:action.isSource?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(sourceCsvProps,action.fields):state.sourceCsvProps,targetCsvProps:!action.isSource?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(targetCsvProps,action.fields):state.targetCsvProps});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* MERGE_ITEM_SCHEMES_FILE_SET */]:return Object.assign({},state,{source:action.isSource?action.file:state.source,target:!action.isSource?action.file:state.target});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* MERGE_ITEM_SCHEMES_ARTEFACTS_SHOW */]:return Object.assign({},state,{isArtefactsVisible:true,isSource:action.isSource});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* MERGE_ITEM_SCHEMES_ARTEFACTS_HIDE */]:return Object.assign({},state,{isArtefactsVisible:false,artefacts:null,isSource:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* MERGE_ITEM_SCHEMES_ARTEFACT_SET */]:return Object.assign({},state,{isArtefactsVisible:false,artefacts:null,isSource:null,source:state.isSource?action.artefactTriplet:state.source,target:!state.isSource?action.artefactTriplet:state.target});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* MERGE_ITEM_SCHEMES_ARTEFACT_UNSET */]:return Object.assign({},state,{source:action.isSource?null:state.source,target:!action.isSource?null:state.target});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* MERGE_ITEM_SCHEMES_MERGE_PREVIEW_HIDE */]:return Object.assign({},state,{mergedItems:null,mergedItemsFromServer:null,mergeCodelistItemCount:null,mergeCodelistFetchParams:null,mergeConflict:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_PARAMS_UPDATE */]:return Object.assign({},state,{mergeCodelistFetchParams:Object.assign({},action.params,{timeStamp:new Date().getTime()})});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* MERGE_ITEM_SCHEMES_CODELIST_MERGE_PREVIEW_LANG_CHANGE */]:return Object.assign({},state,{mergeCodelistFetchParams:Object.assign({},state.mergeCodelistFetchParams,{pageNum:1,lang:action.lang}),mergedItems:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* MERGE_ITEM_SCHEMES_MERGE_HIDE */]:return Object.assign({},state,{isMergeVisible:false,mergedItemScheme:null,agencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* MERGE_ITEM_SCHEMES_MERGE_CHANGE */]:var mergedItemScheme=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.mergedItemScheme);return Object.assign({},state,{mergedItemScheme:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(mergedItemScheme,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* MERGE_ITEM_SCHEMES_CSV_PREVIEW_SHOW */]:return Object.assign({},state,{isCsvPreviewVisible:true,isSourcePreview:action.isSource});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* MERGE_ITEM_SCHEMES_XML_PREVIEW_SHOW */]:return Object.assign({},state,{isXmlPreviewVisible:true,isSourcePreview:action.isSource});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* MERGE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE */]:return Object.assign({},state,{previewItemParams:Object.assign({},action.params,{timeStamp:new Date().getTime()})});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* MERGE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE */]:return Object.assign({},state,{previewItemParams:Object.assign({},state.previewItemParams,{pageNum:1,lang:action.lang}),previewItems:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* MERGE_ITEM_SCHEMES_PREVIEW_HIDE */]:return Object.assign({},state,{isCsvPreviewVisible:false,isXmlPreviewVisible:false,isSourcePreview:null,previewItems:null,previewItemCount:null,previewItemParams:null,csvFilePath:null,allCsvRows:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* MERGE_ITEM_SCHEMES_ARTEFACTS_READ */]:return Object.assign({},state,{artefacts:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* MERGE_ITEM_SCHEMES_MERGE_PREVIEW_READ */]:var _mergedItemScheme=null;var mergedItems=[];var mergedItemsFromServer=null;if(state.artefactType===__WEBPACK_IMPORTED_MODULE_1__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]){mergedItems=JSON.parse(action.response.jsonSdmx);}else if(state.artefactType===__WEBPACK_IMPORTED_MODULE_1__actions__["e" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME */]){_mergedItemScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(JSON.parse(action.response.jsonSdmx))[0];var categoryScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(_mergedItemScheme,Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);var itemsTree=categoryScheme.categories?Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["h" /* getMappedTree */])(categoryScheme.categories,"categories",function(node){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(node,Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]);}):[];itemsTree=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["h" /* getMappedTree */])([{isRoot:true,categories:itemsTree}],"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_10__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].categories;mergedItems=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["l" /* getNodes */])(itemsTree,"categories",function(){return true;});mergedItemsFromServer=_mergedItemScheme.categories;}else if(state.artefactType===__WEBPACK_IMPORTED_MODULE_1__actions__["h" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]){_mergedItemScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(JSON.parse(action.response.jsonSdmx))[0];var conceptScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["y" /* SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)(_mergedItemScheme);mergedItems=conceptScheme.concepts;mergedItemsFromServer=_mergedItemScheme.concepts;}return Object.assign({},state,{mergedItemScheme:Object.assign({},_mergedItemScheme,{id:null,agencyID:null,version:null,name:null,codes:null,concepts:null,categories:null}),mergedItems:mergedItems.map(function(item){return Object.assign({},item,{mergeConflict:action.response.itemConflicts.includes(item.id)});}),mergedItemsFromServer:mergedItemsFromServer,mergeConflict:action.response.haveConflicts});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* MERGE_ITEM_SCHEMES_CODELIST_PAGE_READ */]:{var codelist=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(JSON.parse(action.response.jsonSdmx))[0]);var isInvisibleItem=function isInvisibleItem(item){return item.annotations&&item.annotations.find(function(annot){return annot.id==="INVISIBLE"&&annot.title==="INVISIBLE"&&annot.type==="INVISIBLE";})!==undefined;};return Object.assign({},state,{mergedItems:(codelist.codes||[]).filter(function(item){return!isInvisibleItem(item);}).map(function(item){return Object.assign({},item,{mergeConflict:action.response.itemConflicts.includes(item.id)});}),mergeCodelistItemCount:Number(action.header["x-total-count"]),mergeConflict:action.response.haveConflicts});}case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* MERGE_ITEM_SCHEMES_MERGE_SHOW */]:return Object.assign({},state,{isMergeVisible:true,agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* MERGE_ITEM_SCHEMES_MERGE_SUBMIT */]:return Object.assign({},state,{isMergeVisible:false,mergedItemScheme:null,mergedItems:null,mergedItemsFromServer:null,mergeCodelistItemCount:null,agencies:null,sourceFormat:__WEBPACK_IMPORTED_MODULE_1__actions__["t" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */],targetFormat:__WEBPACK_IMPORTED_MODULE_1__actions__["t" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */],source:null,target:null,sourceCsvProps:null,targetCsvProps:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* MERGE_ITEM_SCHEMES_XML_PREVIEW_READ */]:var previewItems=null;var previewItemCount=null;if(state.artefactType===__WEBPACK_IMPORTED_MODULE_1__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]){previewItems=action.response;previewItemCount=Number(action.header["x-total-count"]);}else if(state.artefactType===__WEBPACK_IMPORTED_MODULE_1__actions__["e" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME */]){var _categoryScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);var _itemsTree=_categoryScheme.categories?Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["h" /* getMappedTree */])(_categoryScheme.categories,"categories",function(node){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(node,Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]);}):[];_itemsTree=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["h" /* getMappedTree */])([{isRoot:true,categories:_itemsTree}],"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_10__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].categories;previewItems=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["l" /* getNodes */])(_itemsTree,"categories",function(){return true;});}else if(state.artefactType===__WEBPACK_IMPORTED_MODULE_1__actions__["h" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]){var _conceptScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["y" /* SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);previewItems=_conceptScheme.concepts;}return Object.assign({},state,{previewItems:previewItems,previewItemCount:previewItemCount});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* MERGE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ */]:{var _codelist=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var _isInvisibleItem=function _isInvisibleItem(item){return item.annotations&&item.annotations.find(function(annot){return annot.id==="INVISIBLE"&&annot.title==="INVISIBLE"&&annot.type==="INVISIBLE";})!==undefined;};return Object.assign({},state,{previewItems:(_codelist.codes||[]).filter(function(item){return!_isInvisibleItem(item);}),previewItemCount:Number(action.header["x-total-count"])});}case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* MERGE_ITEM_SCHEMES_CSV_FILE_UPLOAD */]:return Object.assign({},state,{csvFilePath:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* MERGE_ITEM_SCHEMES_CSV_PAGE_READ */]:return Object.assign({},state,{allCsvRows:action.response});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* MERGE_ITEM_SCHEMES_XML_PREVIEW_READ */]:return Object.assign({},state,{isXmlPreviewVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* MERGE_ITEM_SCHEMES_CSV_FILE_UPLOAD */]:return Object.assign({},state,{isCsvPreviewVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* MERGE_ITEM_SCHEMES_CSV_PAGE_READ */]:return Object.assign({},state,{isCsvPreviewVisible:false,csvFilePath:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["d"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["b" /* reuseInReducer */])(mergeItemSchemesReducer,{codelistDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_codelist_detail_modal_reducer__["a" /* default */],UTILITIES_MERGE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX),conceptSchemeDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_6__redux_components_redux_concept_scheme_detail_modal_reducer__["b" /* default */],UTILITIES_MERGE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX),categorySchemeDetail:Object(__WEBPACK_IMPORTED_MODULE_4__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_7__redux_components_redux_category_scheme_detail_modal_reducer__["b" /* default */],UTILITIES_MERGE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX)}));

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MANAGE_SERIES_CUBES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MANAGE_SERIES_CUBES_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MANAGE_SERIES_CUBE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MANAGE_SERIES_CUBE_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return MANAGE_SERIES_SELECTED_SERIES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MANAGE_SERIES_CUBES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MANAGE_SERIES_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return MANAGE_SERIES_SERIES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return MANAGE_SERIES_SERIES_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MANAGE_SERIES_FILTER_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MANAGE_SERIES_FILTER_MODAL_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MANAGE_SERIES_FILTER_MODAL_FILTER_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MANAGE_SERIES_FILTER_MODAL_FILTER_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MANAGE_SERIES_FILTER_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MANAGE_SERIES_FILTER_MODAL_FILTER_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MANAGE_SERIES_FILTER_ROWS_MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MANAGE_SERIES_FILTER_ROWS_MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MANAGE_SERIES_FILTER_ROWS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MANAGE_SERIES_FILTER_FORM_BLOCK_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MANAGE_SERIES_FILTER_FORM_BLOCK_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MANAGE_SERIES_FILTER_FORM_CONDITION_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MANAGE_SERIES_FILTER_FORM_CONDITION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MANAGE_SERIES_FILTER_FORM_COLUMN_CODES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return MANAGE_SERIES_SERIES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return showManageSeriesCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return setManageSeriesCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return hideManageSeriesCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return unsetManageSeriesCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return setSelectedSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return readManageSeriesCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return readManageSeriesCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return readManageSeriesSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return deleteManageSeriesSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return showManageSeriesFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return hideManageSeriesFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return submitManageSeriesFilterModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return changeManageSeriesFilterModalTreeFilterColumnMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return changeManageSeriesFilterModalFilterMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return resetManageSeriesFilterModalFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return changeManageSeriesFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return changeManageSeriesFilterModalTreeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return showManageSeriesSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return readManageSeriesFilterModalTreeFilterColumnCodelistCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return readManageSeriesFilterModalTreeFilterColumnCodelistTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return readManageSeriesFilterModalTreeFilterColumnFilteredValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return changeManageSeriesFilterModalTreeFilterColumnValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return showManageSeriesFilterRowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return hideManageSeriesFilterRowsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return readManageSeriesFilterRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return addManageSeriesFilterFormBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return deleteManageSeriesFilterFormBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return addManageSeriesFilterFormCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return deleteManageSeriesFilterFormCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return readManageSeriesFilterFormColumnValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return resetManageSeriesFilterFormColumnValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return readManageSeriesFilterFormColumnCodes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tree_filter_utils__ = __webpack_require__(65);
var MANAGE_SERIES_CUBES_SHOW='MANAGE_SERIES_CUBES_SHOW';var MANAGE_SERIES_CUBES_HIDE='MANAGE_SERIES_CUBES_HIDE';var MANAGE_SERIES_CUBE_SET='MANAGE_SERIES_CUBE_SET';var MANAGE_SERIES_CUBE_UNSET='MANAGE_SERIES_CUBE_UNSET';var MANAGE_SERIES_SELECTED_SERIES_SET='MANAGE_SERIES_SELECTED_SERIES_SET';var MANAGE_SERIES_CUBES_READ='MANAGE_SERIES_CUBES_READ';var MANAGE_SERIES_CUBE_READ='MANAGE_SERIES_CUBE_READ';var MANAGE_SERIES_SERIES_READ='MANAGE_SERIES_SERIES_READ';var MANAGE_SERIES_SERIES_DELETE='MANAGE_SERIES_SERIES_DELETE';var MANAGE_SERIES_FILTER_MODAL_SHOW='MANAGE_SERIES_FILTER_MODAL_SHOW';var MANAGE_SERIES_FILTER_MODAL_SUBMIT='MANAGE_SERIES_FILTER_MODAL_SUBMIT';var MANAGE_SERIES_FILTER_MODAL_FILTER_RESET='MANAGE_SERIES_FILTER_MODAL_FILTER_RESET';var MANAGE_SERIES_FILTER_MODAL_FILTER_MODE_CHANGE='MANAGE_SERIES_FILTER_MODAL_FILTER_MODE_CHANGE';var MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_CHANGE='MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_CHANGE';var MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE='MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE';var MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE='MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE';var MANAGE_SERIES_FILTER_MODAL_HIDE='MANAGE_SERIES_FILTER_MODAL_HIDE';var MANAGE_SERIES_FILTER_MODAL_FILTER_CHANGE='MANAGE_SERIES_FILTER_MODAL_FILTER_CHANGE';var MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ='MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ';var MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ='MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ';var MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ='MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ';var MANAGE_SERIES_FILTER_ROWS_MODAL_SHOW='MANAGE_SERIES_FILTER_ROWS_MODAL_SHOW';var MANAGE_SERIES_FILTER_ROWS_MODAL_HIDE='MANAGE_SERIES_FILTER_ROWS_MODAL_HIDE';var MANAGE_SERIES_FILTER_ROWS_READ='MANAGE_SERIES_FILTER_ROWS_READ';var MANAGE_SERIES_FILTER_FORM_BLOCK_ADD='MANAGE_SERIES_FILTER_FORM_BLOCK_ADD';var MANAGE_SERIES_FILTER_FORM_BLOCK_DELETE='MANAGE_SERIES_FILTER_FORM_BLOCK_DELETE';var MANAGE_SERIES_FILTER_FORM_CONDITION_ADD='MANAGE_SERIES_FILTER_FORM_CONDITION_ADD';var MANAGE_SERIES_FILTER_FORM_CONDITION_DELETE='MANAGE_SERIES_FILTER_FORM_CONDITION_DELETE';var MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_READ='MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_READ';var MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_RESET='MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_RESET';var MANAGE_SERIES_FILTER_FORM_COLUMN_CODES_READ='MANAGE_SERIES_FILTER_FORM_COLUMN_CODES_READ';var MANAGE_SERIES_SERIES_SHOW='MANAGE_SERIES_SERIES_SHOW';var showManageSeriesCubes=function showManageSeriesCubes(){return{type:MANAGE_SERIES_CUBES_SHOW};};var setManageSeriesCube=function setManageSeriesCube(cubeId){return{type:MANAGE_SERIES_CUBE_SET,cubeId:cubeId};};var hideManageSeriesCubes=function hideManageSeriesCubes(){return{type:MANAGE_SERIES_CUBES_HIDE};};var unsetManageSeriesCube=function unsetManageSeriesCube(){return{type:MANAGE_SERIES_CUBE_UNSET};};var setSelectedSeries=function setSelectedSeries(selectedSeries){return{type:MANAGE_SERIES_SELECTED_SERIES_SET,selectedSeries:selectedSeries};};var readManageSeriesCubes=function readManageSeriesCubes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(MANAGE_SERIES_CUBES_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])()]);};var readManageSeriesCube=function readManageSeriesCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(MANAGE_SERIES_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var readManageSeriesSeries=function readManageSeriesSeries(idCube,filterStr,cols,sortCols,sortByDesc,pageNum,pageSize){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MANAGE_SERIES_SERIES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_84" /* getSeriesForCubeUrl */])(idCube),Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(cols,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_4__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filterStr)),pageNum,pageSize,sortCols,sortByDesc,idCube));};var deleteManageSeriesSeries=function deleteManageSeriesSeries(idCube,seriesIds){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["n" /* putRequest */])(MANAGE_SERIES_SERIES_DELETE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_17" /* getDeleteSeriesForCubeUrl */])(idCube),seriesIds,function(t){return{success:t('scenes.dataManager.manageSeries.messages.delete.success')};});};var showManageSeriesFilterModal=function showManageSeriesFilterModal(){return{type:MANAGE_SERIES_FILTER_MODAL_SHOW};};var hideManageSeriesFilterModal=function hideManageSeriesFilterModal(){return{type:MANAGE_SERIES_FILTER_MODAL_HIDE};};var submitManageSeriesFilterModal=function submitManageSeriesFilterModal(filter){return{type:MANAGE_SERIES_FILTER_MODAL_SUBMIT,filter:filter};};var changeManageSeriesFilterModalTreeFilterColumnMode=function changeManageSeriesFilterModalTreeFilterColumnMode(colName,mode){return{type:MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE,colName:colName,mode:mode};};var changeManageSeriesFilterModalFilterMode=function changeManageSeriesFilterModalFilterMode(filterMode){return{type:MANAGE_SERIES_FILTER_MODAL_FILTER_MODE_CHANGE,filterMode:filterMode};};var resetManageSeriesFilterModalFilter=function resetManageSeriesFilterModalFilter(){return{type:MANAGE_SERIES_FILTER_MODAL_FILTER_RESET};};var changeManageSeriesFilter=function changeManageSeriesFilter(fields){return{type:MANAGE_SERIES_FILTER_MODAL_FILTER_CHANGE,fields:fields};};var changeManageSeriesFilterModalTreeFilter=function changeManageSeriesFilterModalTreeFilter(treeFilter){return{type:MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_CHANGE,treeFilter:treeFilter};};var showManageSeriesSeries=function showManageSeriesSeries(){return{type:MANAGE_SERIES_SERIES_SHOW};};var readManageSeriesFilterModalTreeFilterColumnCodelistCount=function readManageSeriesFilterModalTreeFilterColumnCodelistCount(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var readManageSeriesFilterModalTreeFilterColumnCodelistTree=function readManageSeriesFilterModalTreeFilterColumnCodelistTree(codelistTriplet,language){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:codelistTriplet.id,agencyId:codelistTriplet.agencyID,version:codelistTriplet.version,pageNum:1,pageSize:-1,lang:language,rebuildDb:false}),{codelistTriplet:codelistTriplet});};var readManageSeriesFilterModalTreeFilterColumnFilteredValues=function readManageSeriesFilterModalTreeFilterColumnFilteredValues(cubeId,colNames,filter){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(colNames[colNames.length-1],1,-1),{idCube:cubeId,dataflowColumns:colNames,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(undefined,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_4__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter))).Filter}),{colName:colNames[colNames.length-1]});};var changeManageSeriesFilterModalTreeFilterColumnValues=function changeManageSeriesFilterModalTreeFilterColumnValues(colName,values){return{type:MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE,colName:colName,values:values};};var showManageSeriesFilterRowsModal=function showManageSeriesFilterRowsModal(){return{type:MANAGE_SERIES_FILTER_ROWS_MODAL_SHOW};};var hideManageSeriesFilterRowsModal=function hideManageSeriesFilterRowsModal(){return{type:MANAGE_SERIES_FILTER_ROWS_MODAL_HIDE};};var readManageSeriesFilterRows=function readManageSeriesFilterRows(cubeId,cubeColumns,filter,pageNum,pageSize,sortCols,sortByDesc){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MANAGE_SERIES_FILTER_ROWS_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_6" /* getDataflowPreviewUrl */])(true),Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(cubeColumns,Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_4__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filter)),pageNum,pageSize,sortCols,sortByDesc,cubeId));};var addManageSeriesFilterFormBlock=function addManageSeriesFilterFormBlock(){return{type:MANAGE_SERIES_FILTER_FORM_BLOCK_ADD};};var deleteManageSeriesFilterFormBlock=function deleteManageSeriesFilterFormBlock(blockIndex){return{type:MANAGE_SERIES_FILTER_FORM_BLOCK_DELETE,blockIndex:blockIndex};};var addManageSeriesFilterFormCondition=function addManageSeriesFilterFormCondition(blockIndex){return{type:MANAGE_SERIES_FILTER_FORM_CONDITION_ADD,blockIndex:blockIndex};};var deleteManageSeriesFilterFormCondition=function deleteManageSeriesFilterFormCondition(blockIndex,conditionIndex){return{type:MANAGE_SERIES_FILTER_FORM_CONDITION_DELETE,blockIndex:blockIndex,conditionIndex:conditionIndex};};var readManageSeriesFilterFormColumnValue=function readManageSeriesFilterFormColumnValue(cubeId,columnName,viewerObj){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_1" /* getDataflowColumnPreviewUrl */])(columnName,viewerObj.pageNum,viewerObj.pageSize),{idCube:cubeId,dataflowColumns:[columnName],idDataflow:0,filter:Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["f" /* getServerQueryObj */])(undefined,viewerObj.filterObj||Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["a" /* getFilterObjFromStr */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["e" /* getFilterStrFromViewerObj */])([columnName],viewerObj.searchText,[],""))).Filter}),{columnName:columnName});};var resetManageSeriesFilterFormColumnValue=function resetManageSeriesFilterFormColumnValue(columnName){return{type:MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_RESET,columnName:columnName};};var readManageSeriesFilterFormColumnCodes=function readManageSeriesFilterFormColumnCodes(columnName,codelistCode){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(MANAGE_SERIES_FILTER_FORM_COLUMN_CODES_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_69" /* getPaginatedCodelistUrl */])(),{id:Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).id,agencyId:Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).agencyID,version:Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistCode).version,pageNum:1,pageSize:-1,rebuildDb:false,lang:"en"}),{columnName:columnName});};

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IMPORT_ATTRIBUTE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IMPORT_ATTRIBUTE_CUBE_TREE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IMPORT_ATTRIBUTE_CUBE_TREE_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IMPORT_ATTRIBUTE_CUBE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IMPORT_ATTRIBUTE_CUBE_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMPORT_ATTRIBUTE_CUBE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IMPORT_ATTRIBUTE_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IMPORT_ATTRIBUTE_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return changeAttributeFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return showAttributeFileCubeTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hideAttributeFileCubeTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setAttributeFileCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return unsetAttributeFileCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return readAttributeFileCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return readAttributeFileCategorisedCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return uploadAttributeFileFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return submitAttributeFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return onHideAttributeFileIgnoreConcurrentUploadConfirm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var IMPORT_ATTRIBUTE_CHANGE='IMPORT_ATTRIBUTE_CHANGE';var IMPORT_ATTRIBUTE_CUBE_TREE_SHOW='IMPORT_ATTRIBUTE_CUBE_TREE_SHOW';var IMPORT_ATTRIBUTE_CUBE_TREE_HIDE='IMPORT_ATTRIBUTE_CUBE_TREE_HIDE';var IMPORT_ATTRIBUTE_CUBE_SET='IMPORT_ATTRIBUTE_CUBE_SET';var IMPORT_ATTRIBUTE_CUBE_UNSET='IMPORT_ATTRIBUTE_CUBE_UNSET';var IMPORT_ATTRIBUTE_CUBE_READ='IMPORT_ATTRIBUTE_CUBE_READ';var IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ='IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ';var IMPORT_ATTRIBUTE_FILE_UPLOAD='IMPORT_ATTRIBUTE_FILE_UPLOAD';var IMPORT_ATTRIBUTE_SUBMIT='IMPORT_ATTRIBUTE_SUBMIT';var IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE='IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE';var changeAttributeFile=function changeAttributeFile(fields){return{type:IMPORT_ATTRIBUTE_CHANGE,fields:fields};};var showAttributeFileCubeTree=function showAttributeFileCubeTree(){return{type:IMPORT_ATTRIBUTE_CUBE_TREE_SHOW};};var hideAttributeFileCubeTree=function hideAttributeFileCubeTree(){return{type:IMPORT_ATTRIBUTE_CUBE_TREE_HIDE};};var setAttributeFileCube=function setAttributeFileCube(cubeId){return{type:IMPORT_ATTRIBUTE_CUBE_SET,cubeId:cubeId};};var unsetAttributeFileCube=function unsetAttributeFileCube(){return{type:IMPORT_ATTRIBUTE_CUBE_UNSET};};var readAttributeFileCube=function readAttributeFileCube(cubeId){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(IMPORT_ATTRIBUTE_CUBE_READ,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(cubeId));};var readAttributeFileCategorisedCubes=function readAttributeFileCategorisedCubes(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["i" /* allRequest */])(IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ,[__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */],__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["d" /* REQUEST_METHOD_GET */]],[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["X" /* getCubeUrl */])(),Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_8" /* getDcsUrl */])()]);};var uploadAttributeFileFile=function uploadAttributeFileFile(file,cubeId){var fileFormData=new FormData();fileFormData.append('file',file);return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(IMPORT_ATTRIBUTE_FILE_UPLOAD,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_106" /* getUploadFileOnServerUrl */])(cubeId),fileFormData,function(t){return{start:t('scenes.dataManager.attributeFile.messages.fileUpload.start'),success:t('scenes.dataManager.attributeFile.messages.fileUpload.success')};});};var submitAttributeFile=function submitAttributeFile(separator,delimiter,cubeId,filePath,tid,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["l" /* getRequest */])(IMPORT_ATTRIBUTE_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["n" /* getAttributeFileUrl */])(separator,delimiter,true,cubeId,filePath,tid,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload),function(t){return{start:t('scenes.dataManager.attributeFile.messages.submit.start'),success:t('scenes.dataManager.attributeFile.messages.submit.success')};});};var onHideAttributeFileIgnoreConcurrentUploadConfirm=function onHideAttributeFileIgnoreConcurrentUploadConfirm(){return{type:IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE};};

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_category_scheme_detail_modal_reducer__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__current_node_config_middleware__ = __webpack_require__(42);
var DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX="DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX_";var defaultCategorySchemeSelectorReducer=function defaultCategorySchemeSelectorReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{categorySchemes:null,isVisible:false,isSelectModalVisible:false,isCreateModalVisible:false,category:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_SHOW */]:return Object.assign({},state,{isVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_CHANGE */]:return Object.assign({},state,{category:Object.assign({},state.category,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_HIDE */]:return Object.assign({},state,{isVisible:false,isCreateModalVisible:false,isSelectModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_MODAL_SHOW */]:return Object.assign({},state,{isCreateModalVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_MODAL_SHOW */]:return Object.assign({},state,{isSelectModalVisible:true});case __WEBPACK_IMPORTED_MODULE_0__api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ */]:return Object.assign({},state,{categorySchemes:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ */]:return Object.assign({},state,{isSelectModalVisible:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CATEGORY_SCHEMES_READ */]:var categorySchemes=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[];return Object.assign({},state,{categorySchemes:categorySchemes.map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_5__current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action));})});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT */]:return Object.assign({},state,{categorySchemes:null,isSelectModalVisible:false,isCreateModalVisible:false});default:return state;}}default:return state;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["b" /* reuseInReducer */])(defaultCategorySchemeSelectorReducer,{categorySchemeDetail:Object(__WEBPACK_IMPORTED_MODULE_3__utils_reduxReuse__["c" /* reuseReducer */])(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_category_scheme_detail_modal_reducer__["b" /* default */],DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX)}));

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1163);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);
var settle = __webpack_require__(1167);
var buildURL = __webpack_require__(1169);
var parseHeaders = __webpack_require__(1170);
var isURLSameOrigin = __webpack_require__(1171);
var createError = __webpack_require__(522);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1172);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1173);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1168);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStatusCodesTranslations; });
var getStatusCodesTranslations=function getStatusCodesTranslations(t){var statusCodesTranslations=function statusCodesTranslations(t){return{401:t('errors.statusCodes.401'),403:t('errors.statusCodes.403'),ECONNABORTED:t('errors.statusCodes.ECONNABORTED'),CUSTOM_STATUS_CODE_FILE_SUBMIT:t('errors.statusCodes.CUSTOM_STATUS_CODE_FILE_SUBMIT')};};return statusCodesTranslations(t!==undefined?t:function(str){return str;});};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Depricated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d)},e.onerror=function(){console.error("could not download file")},e.send()}function d(a){var b=new XMLHttpRequest;return b.open("HEAD",a,!1),b.send(),200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.saveAs||"object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null},j.readAsDataURL(a)}else{var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l)},4E4)}};f.saveAs=a.saveAs=a,"undefined"!=typeof module&&(module.exports=a)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEW_TAB_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openNewTab; });
var NEW_TAB_OPEN='NEW_TAB_OPEN';var openNewTab=function openNewTab(url){return{type:NEW_TAB_OPEN,url:url};};

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DROPPABLE_ID_ROW */
/* unused harmony export DROPPABLE_ID_COLUMN */
/* unused harmony export DROPPABLE_ID_FILTER */
/* unused harmony export DROPPABLE_ID_ROW_SECTION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_tag_style__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_tag_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_tag_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_tag__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_beautiful_dnd__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__drag_handle__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__htmlTable__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_css__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DROPPABLE_ID_ROW='DROPPABLE_ID_ROW';var DROPPABLE_ID_COLUMN='DROPPABLE_ID_COLUMN';var DROPPABLE_ID_FILTER='DROPPABLE_ID_FILTER';var DROPPABLE_ID_ROW_SECTION='DROPPABLE_ID_ROW_SECTION';var DefaultTableLayout=function(_React$Component){_inherits(DefaultTableLayout,_React$Component);function DefaultTableLayout(props){_classCallCheck(this,DefaultTableLayout);var _this=_possibleConstructorReturn(this,(DefaultTableLayout.__proto__||Object.getPrototypeOf(DefaultTableLayout)).call(this,props));var layoutAnnotationDefaultTableLayout=Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["H" /* getLayoutAnnotationDefaultTableLayout */])(_this.props.layoutAnnotations,_this.props.annotationsConfig);var _ref=layoutAnnotationDefaultTableLayout||_this.getDefaultLayout(),row=_ref.row,column=_ref.column,rowSection=_ref.rowSection,filter=_ref.filter;var mode=!layoutAnnotationDefaultTableLayout||filter.length>0?__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["j" /* LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER */]:__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["k" /* LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER */];_this.state={flagSaveAnnotation:!!layoutAnnotationDefaultTableLayout,row:row,column:column,rowSection:rowSection,filter:filter,mode:mode};_this.getDefaultLayout=_this.getDefaultLayout.bind(_this);_this.onFlagSaveAnnotationChange=_this.onFlagSaveAnnotationChange.bind(_this);return _this;}_createClass(DefaultTableLayout,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var _this2=this;if(this.props.dsdDimensions&&(!prevProps.dsdDimensions||this.props.dsdDimensions.length!==prevProps.dsdDimensions.length)){if(this.state.flagSaveAnnotation){var _state=this.state,row=_state.row,column=_state.column,filter=_state.filter,rowSection=_state.rowSection;this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["_1" /* setLayoutAnnotationDefaultTableLayout */])(__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,{row:row.filter(function(id){return _this2.props.dsdDimensions.find(function(dim){return dim.id===id;});}),column:column.filter(function(id){return _this2.props.dsdDimensions.find(function(dim){return dim.id===id;});}),filter:filter.filter(function(id){return _this2.props.dsdDimensions.find(function(dim){return dim.id===id;});}),rowSection:[].concat(_toConsumableArray(rowSection.filter(function(id){return _this2.props.dsdDimensions.find(function(dim){return dim.id===id;});})),_toConsumableArray(this.props.dsdDimensions.filter(function(dim){return![].concat(_toConsumableArray(row),_toConsumableArray(column),_toConsumableArray(filter),_toConsumableArray(rowSection)).find(function(id){return id===dim.id;});}).map(function(_ref2){var id=_ref2.id;return id;})))})});}}}},{key:"getDefaultLayout",value:function getDefaultLayout(){return{row:[],column:[],filter:[],rowSection:this.props.dsdDimensions.sort(function(a,b){return a.order&&b.order&&a.order!==b.order?a.order-b.order:a.id-b.id;}).map(function(_ref3){var id=_ref3.id;return id;})};}},{key:"onFlagSaveAnnotationChange",value:function onFlagSaveAnnotationChange(checked){var _state2=this.state,row=_state2.row,column=_state2.column,filter=_state2.filter,rowSection=_state2.rowSection;this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["_1" /* setLayoutAnnotationDefaultTableLayout */])(__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,checked?{row:row,column:column,filter:filter,rowSection:rowSection}:null)});this.setState({flagSaveAnnotation:checked});}},{key:"onDragEnd",value:function onDragEnd(source,destination){if(source&&destination){var _state3=this.state,row=_state3.row,column=_state3.column,filter=_state3.filter,rowSection=_state3.rowSection;var dragged=void 0;if(source.droppableId===DROPPABLE_ID_ROW){dragged=row[source.index];row.splice(source.index,1);}else if(source.droppableId===DROPPABLE_ID_COLUMN){dragged=column[source.index];column.splice(source.index,1);}else if(source.droppableId===DROPPABLE_ID_FILTER){dragged=filter[source.index];filter.splice(source.index,1);}else{dragged=rowSection[source.index];rowSection.splice(source.index,1);}if(destination.droppableId===DROPPABLE_ID_ROW){row.splice(destination.index,0,dragged);}else if(destination.droppableId===DROPPABLE_ID_COLUMN){column.splice(destination.index,0,dragged);}else if(destination.droppableId===DROPPABLE_ID_FILTER){filter.splice(destination.index,0,dragged);}else{rowSection.splice(destination.index,0,dragged);}this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["_1" /* setLayoutAnnotationDefaultTableLayout */])(__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,{row:row,column:column,filter:filter,rowSection:rowSection})});this.setState({row:row,column:column,filter:filter,rowSection:rowSection,flagSaveAnnotation:true});}}},{key:"render",value:function render(){var _this3=this;var _props=this.props,t=_props.t,disabled=_props.disabled;var _state4=this.state,flagSaveAnnotation=_state4.flagSaveAnnotation,row=_state4.row,column=_state4.column,rowSection=_state4.rowSection,filter=_state4.filter,mode=_state4.mode;var Dimension=function Dimension(_ref4){var id=_ref4.id,index=_ref4.index;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_beautiful_dnd__["b" /* Draggable */],{draggableId:id,index:index},function(provided){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",Object.assign({ref:provided.innerRef},provided.draggableProps),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_tag___default.a,{style:{width:"100%",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"},title:id},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",provided.dragHandleProps,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__drag_handle__["a" /* default */],null)),id))));});};var cardStyle={style:{height:"100%"},bodyStyle:{minHeight:120,position:"relative",padding:0}};var droppableStyle={position:"absolute",height:"100%",width:"100%",padding:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["PADDING_MD"],overflowY:"auto",overflowX:"hidden"};var filterCard=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default.a,Object.assign({type:"inner",title:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.filter.title")},cardStyle),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_beautiful_dnd__["c" /* Droppable */],{droppableId:DROPPABLE_ID_FILTER},function(provided,_ref5){var isDraggingOver=_ref5.isDraggingOver;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",Object.assign({},provided.droppableProps,{ref:provided.innerRef,style:droppableStyle}),filter.map(function(id,index){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(Dimension,{id:id,key:index,index:index});}),provided.placeholder,filter.length===0&&!isDraggingOver&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__custom_empty__["a" /* default */],{text:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.placeholder")}));}));var rowSectionCard=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default.a,Object.assign({type:"inner",title:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.rowSection.title")},cardStyle),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_beautiful_dnd__["c" /* Droppable */],{droppableId:DROPPABLE_ID_ROW_SECTION},function(provided,_ref6){var isDraggingOver=_ref6.isDraggingOver;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",Object.assign({},provided.droppableProps,{ref:provided.innerRef,style:droppableStyle}),rowSection.map(function(id,index){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(Dimension,{id:id,key:index,index:index});}),provided.placeholder,rowSection.length===0&&!isDraggingOver&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__custom_empty__["a" /* default */],{text:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.placeholder")}));}));var columnCard=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default.a,Object.assign({type:"inner",title:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.column.title")},cardStyle),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_beautiful_dnd__["c" /* Droppable */],{droppableId:DROPPABLE_ID_COLUMN},function(provided,_ref7){var isDraggingOver=_ref7.isDraggingOver;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",Object.assign({},provided.droppableProps,{ref:provided.innerRef,style:droppableStyle}),column.map(function(id,index){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(Dimension,{id:id,key:index,index:index});}),provided.placeholder,column.length===0&&!isDraggingOver&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__custom_empty__["a" /* default */],{text:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.placeholder")}));}));var rowCard=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default.a,Object.assign({type:"inner",title:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.row.title")},cardStyle),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{height:"100%",backgroundColor:"red"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_beautiful_dnd__["c" /* Droppable */],{droppableId:DROPPABLE_ID_ROW},function(provided,_ref8){var isDraggingOver=_ref8.isDraggingOver;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",Object.assign({},provided.droppableProps,{ref:provided.innerRef,style:droppableStyle}),row.map(function(id,index){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(Dimension,{id:id,key:index,index:index});}),provided.placeholder,row.length===0&&!isDraggingOver&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__custom_empty__["a" /* default */],{text:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.placeholder")}));})));return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,!disabled&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,t("components.annotationsForm.layoutAnnotationDefaultTableLayout.flagSaveAnnotation.title"),":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{checked:flagSaveAnnotation,onChange:function onChange(e){return _this3.onFlagSaveAnnotationChange(e.target.checked);}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_beautiful_dnd__["a" /* DragDropContext */],{onDragEnd:function onDragEnd(_ref9){var source=_ref9.source,destination=_ref9.destination;return _this3.onDragEnd(source,destination);}},mode===__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["k" /* LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER */]?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_SM"]},type:"flex"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},rowSectionCard),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},rowCard)),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},columnCard))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_SM"]},type:"flex"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},filterCard),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},rowSectionCard)),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_SM"]},type:"flex"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},rowCard),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},columnCard))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Group,{disabled:disabled,value:mode,onChange:function onChange(_ref10){var target=_ref10.target;var foo=function foo(){var _getDefaultLayout=_this3.getDefaultLayout(),row=_getDefaultLayout.row,column=_getDefaultLayout.column,rowSection=_getDefaultLayout.rowSection,filter=_getDefaultLayout.filter;_this3.setState({row:row,column:column,rowSection:rowSection,filter:filter,mode:target.value});if(flagSaveAnnotation){_this3.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["_1" /* setLayoutAnnotationDefaultTableLayout */])(__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(_this3.props.layoutAnnotations),_this3.props.annotationsConfig,{row:row,column:column,rowSection:rowSection,filter:filter})});}};if(row.length>0||column.length>0||filter.length>0){__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a.confirm({title:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.confirms.modeChange.title"),content:t("components.annotationsForm.layoutAnnotationDefaultTableLayout.confirms.modeChange.content"),onOk:function onOk(){foo();},cancelText:t('commons.buttons.cancel.title')});}else{foo();}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["j" /* LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER */]},t('components.annotationsForm.layoutAnnotationDefaultTableLayout.modeRadio.dataBrowser.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_17__utils_annotations__["k" /* LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER */]},t('components.annotationsForm.layoutAnnotationDefaultTableLayout.modeRadio.dataExplorer.title'))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{justify:"center",style:{marginTop:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_FULL"],style:{overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"html-table",dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_23__htmlTable__["a" /* getHtmlTableString */])(row,column,rowSection)},style:{maxHeight:298}}))))));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(props,state){if(props.dsdDimensions){var row=state.row,column=state.column,rowSection=state.rowSection,filter=state.filter;return{row:row.filter(function(id){return props.dsdDimensions.find(function(dim){return dim.id===id;});}),column:column.filter(function(id){return props.dsdDimensions.find(function(dim){return dim.id===id;});}),filter:filter.filter(function(id){return props.dsdDimensions.find(function(dim){return dim.id===id;});}),rowSection:[].concat(_toConsumableArray(rowSection.filter(function(id){return props.dsdDimensions.find(function(dim){return dim.id===id;});})),_toConsumableArray(props.dsdDimensions.filter(function(dim){return![].concat(_toConsumableArray(row),_toConsumableArray(column),_toConsumableArray(filter),_toConsumableArray(rowSection)).find(function(id){return id===dim.id;});}).map(function(_ref11){var id=_ref11.id;return id;})))};}else{return null;}}}]);return DefaultTableLayout;}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_16_react_i18next__["b" /* translate */])())(DefaultTableLayout));

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1200);

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(350);
var IE8_DOM_DEFINE = __webpack_require__(1205);
var toPrimitive = __webpack_require__(1206);
var dP = Object.defineProperty;

exports.f = __webpack_require__(168) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(242);
var document = __webpack_require__(241).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 532 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(1210);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 534 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 535 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(1214)('keys');
var uid = __webpack_require__(1216);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 537 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 538 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(534);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Subscription__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(245);







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
}; // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect because we want
// `connect` to perform sync updates to a ref to save the latest props after
// a render is actually committed to the DOM.


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_4_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"];
function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      invariant(isValidElementType(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context

      var didStoreComeFromProps = Boolean(props.store);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(didStoreComeFromProps || didStoreComeFromContext, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      var store = props.store || contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new __WEBPACK_IMPORTED_MODULE_6__utils_Subscription__["a" /* default */](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffect(function () {
        // We want to capture the wrapper props and child props we used for later comparisons
        lastWrapperProps.current = wrapperProps;
        lastChildProps.current = actualChildProps;
        renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

        if (childPropsFromStoreUpdate.current) {
          childPropsFromStoreUpdate.current = null;
          notifyNestedSubs();
        }
      }); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffect(function () {
        // If we're not subscribed to the store, nothing to do here
        if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

        var didUnsubscribe = false;
        var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

        var checkForUpdates = function checkForUpdates() {
          if (didUnsubscribe) {
            // Don't run stale listeners.
            // Redux doesn't guarantee unsubscriptions happen until next dispatch.
            return;
          }

          var latestStoreState = store.getState();
          var newChildProps, error;

          try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
          } catch (e) {
            error = e;
            lastThrownError = e;
          }

          if (!error) {
            lastThrownError = null;
          } // If the child props haven't changed, nothing to do here - cascade the subscription update


          if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) {
              notifyNestedSubs();
            }
          } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

            forceComponentUpdateDispatch({
              type: 'STORE_UPDATED',
              payload: {
                latestStoreState: latestStoreState,
                error: error
              }
            });
          }
        }; // Actually subscribe to the nearest connected ancestor (or store)


        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe(); // Pull data from the store after first render in case the store has
        // changed since we began.

        checkForUpdates();

        var unsubscribeWrapper = function unsubscribeWrapper() {
          didUnsubscribe = true;
          subscription.tryUnsubscribe();

          if (lastThrownError) {
            // It's possible that we caught an error due to a bad mapState function, but the
            // parent re-rendered without this component and we're about to unmount.
            // This shouldn't happen as long as we do top-down subscriptions correctly, but
            // if we ever do those wrong, this throw will surface the error in our tests.
            // In that case, throw the error from here so it doesn't get lost.
            throw lastThrownError;
          }
        };

        return unsubscribeWrapper;
      }, [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(545);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(546);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useReduxContext__ = __webpack_require__(548);

/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

function useStore() {
  var _useReduxContext = Object(__WEBPACK_IMPORTED_MODULE_0__useReduxContext__["a" /* useReduxContext */])(),
      store = _useReduxContext.store;

  return store;
}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(245);



/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__components_Context__["a" /* ReactReduxContext */]);
  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(contextValue, 'could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  return contextValue;
}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tag_style__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tag_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tag_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tag__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__drag_handle__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_css__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DROPPABLE_ID_PRIMARY_DIM='primaryDim';var DROPPABLE_ID_SECONDARY_DIM='secondaryDim';var DROPPABLE_ID_FILTER='filter';var DefaultChartLayout=function(_React$Component){_inherits(DefaultChartLayout,_React$Component);function DefaultChartLayout(props){_classCallCheck(this,DefaultChartLayout);var _this=_possibleConstructorReturn(this,(DefaultChartLayout.__proto__||Object.getPrototypeOf(DefaultChartLayout)).call(this,props));var layoutAnnotationDefaultChartLayout=Object(__WEBPACK_IMPORTED_MODULE_13__utils_annotations__["E" /* getLayoutAnnotationDefaultChartLayout */])(_this.props.layoutAnnotations,_this.props.annotationsConfig);var _ref=layoutAnnotationDefaultChartLayout||_this.getDefaultLayout(),primaryDim=_ref.primaryDim,secondaryDim=_ref.secondaryDim,filter=_ref.filter;_this.state={flagSaveAnnotation:!!layoutAnnotationDefaultChartLayout,primaryDim:primaryDim,secondaryDim:secondaryDim,filter:filter};_this.getDefaultLayout=_this.getDefaultLayout.bind(_this);_this.onFlagSaveAnnotationChange=_this.onFlagSaveAnnotationChange.bind(_this);return _this;}_createClass(DefaultChartLayout,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var _this2=this;if(this.props.dsdDimensions&&(!prevProps.dsdDimensions||this.props.dsdDimensions.length!==prevProps.dsdDimensions.length)){if(this.state.flagSaveAnnotation){var _state=this.state,primaryDim=_state.primaryDim,secondaryDim=_state.secondaryDim,filter=_state.filter;this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_13__utils_annotations__["Y" /* setLayoutAnnotationDefaultChartLayout */])(__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,{primaryDim:primaryDim.filter(function(id){return _this2.props.dsdDimensions.find(function(dim){return dim.id===id;});}),secondaryDim:secondaryDim.filter(function(id){return _this2.props.dsdDimensions.find(function(dim){return dim.id===id;});}),filter:[].concat(_toConsumableArray(filter.filter(function(id){return _this2.props.dsdDimensions.find(function(dim){return dim.id===id;});})),_toConsumableArray(this.props.dsdDimensions.filter(function(dim){return![].concat(_toConsumableArray(primaryDim),_toConsumableArray(secondaryDim),_toConsumableArray(filter)).find(function(id){return id===dim.id;});}).map(function(_ref2){var id=_ref2.id;return id;})))})});}}}},{key:"getDefaultLayout",value:function getDefaultLayout(){var TIME_PERIOD_KEY="TIME_PERIOD";var dims=this.props.dsdDimensions.map(function(_ref3){var id=_ref3.id;return id;});var primaryDim=dims.includes(TIME_PERIOD_KEY)?[TIME_PERIOD_KEY]:dims.slice(0,1);return{primaryDim:primaryDim,secondaryDim:[],filter:this.props.dsdDimensions.sort(function(a,b){return a.order&&b.order&&a.order!==b.order?a.order-b.order:a.id-b.id;}).map(function(_ref4){var id=_ref4.id;return id;}).filter(function(id){return!primaryDim.includes(id);})};}},{key:"onFlagSaveAnnotationChange",value:function onFlagSaveAnnotationChange(checked){var _state2=this.state,row=_state2.row,column=_state2.column,filter=_state2.filter,rowSection=_state2.rowSection;this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_13__utils_annotations__["Y" /* setLayoutAnnotationDefaultChartLayout */])(__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,checked?{row:row,column:column,filter:filter,rowSection:rowSection}:null)});this.setState({flagSaveAnnotation:checked});}},{key:"onDragEnd",value:function onDragEnd(source,destination){var reorder=function reorder(list,startIndex,endIndex){var _list$splice=list.splice(startIndex,1),_list$splice2=_slicedToArray(_list$splice,1),removed=_list$splice2[0];list.splice(endIndex,0,removed);};var move=function move(source,destination,droppableSource,droppableDestination){var _source$splice=source.splice(droppableSource.index,1),_source$splice2=_slicedToArray(_source$splice,1),removed=_source$splice2[0];destination.splice(droppableDestination.index,0,removed);};var swap=function swap(sourceArr,destinationArr,droppableSource){var _sourceArr$splice=sourceArr.splice(droppableSource.index,1),_sourceArr$splice2=_slicedToArray(_sourceArr$splice,1),removedSrc=_sourceArr$splice2[0];var _destinationArr$splic=destinationArr.splice(0,1,removedSrc),_destinationArr$splic2=_slicedToArray(_destinationArr$splic,1),removedDst=_destinationArr$splic2[0];sourceArr.splice(sourceArr.length,0,removedDst);};if(source&&destination){var newLayout={primaryDim:this.state.primaryDim,secondaryDim:this.state.secondaryDim,filter:this.state.filter};if(source.droppableId===destination.droppableId){reorder(newLayout[source.droppableId],source.index,destination.index);}else if(source.droppableId===DROPPABLE_ID_SECONDARY_DIM&&destination.droppableId===DROPPABLE_ID_FILTER||source.droppableId===DROPPABLE_ID_FILTER&&destination.droppableId===DROPPABLE_ID_SECONDARY_DIM&&newLayout[destination.droppableId].length===0){move(newLayout[source.droppableId],newLayout[destination.droppableId],source,destination);}else{swap(newLayout[source.droppableId],newLayout[destination.droppableId],source);}this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_13__utils_annotations__["Y" /* setLayoutAnnotationDefaultChartLayout */])(__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,newLayout)});this.setState(Object.assign({},newLayout,{flagSaveAnnotation:true}));}}},{key:"render",value:function render(){var _this3=this;var _props=this.props,t=_props.t,disabled=_props.disabled;var _state3=this.state,flagSaveAnnotation=_state3.flagSaveAnnotation,primaryDim=_state3.primaryDim,secondaryDim=_state3.secondaryDim,filter=_state3.filter;var Dimension=function Dimension(_ref5){var id=_ref5.id,index=_ref5.index,isDragDisabled=_ref5.isDragDisabled;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["b" /* Draggable */],{draggableId:id,index:index,isDragDisabled:isDragDisabled},function(provided){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",Object.assign({ref:provided.innerRef},provided.draggableProps),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tag___default.a,{style:{width:"100%",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"},title:id},!isDragDisabled?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",provided.dragHandleProps,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__drag_handle__["a" /* default */],null)):null,id))));});};var cardStyle={height:"100%"};var cardBodyStyle={position:"relative",padding:0};var droppableStyle={position:"absolute",height:"100%",width:"100%",padding:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["PADDING_MD"],overflowY:"auto",overflowX:"hidden"};var filterCard=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:"inner",title:t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.filter.title"),style:Object.assign({},cardStyle),bodyStyle:Object.assign({},cardBodyStyle,{minHeight:297})},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["c" /* Droppable */],{droppableId:DROPPABLE_ID_FILTER},function(provided,_ref6){var isDraggingOver=_ref6.isDraggingOver;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",Object.assign({},provided.droppableProps,{ref:provided.innerRef,style:droppableStyle}),filter.map(function(id,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Dimension,{id:id,key:index,index:index});}),provided.placeholder,filter.length===0&&!isDraggingOver&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__custom_empty__["a" /* default */],{text:t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.placeholder")}));}));var primaryDimCard=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:"inner",title:t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.primaryDim.title"),style:Object.assign({},cardStyle),bodyStyle:Object.assign({},cardBodyStyle,{minHeight:120})},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["c" /* Droppable */],{droppableId:DROPPABLE_ID_PRIMARY_DIM},function(provided,_ref7){var isDraggingOver=_ref7.isDraggingOver;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",Object.assign({},provided.droppableProps,{ref:provided.innerRef,style:droppableStyle}),primaryDim.map(function(id,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Dimension,{id:id,key:index,index:index,isDragDisabled:true});}),provided.placeholder,primaryDim.length===0&&!isDraggingOver&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__custom_empty__["a" /* default */],{text:t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.placeholder")}));}));var secondaryCard=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:"inner",title:t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.secondaryDim.title"),style:Object.assign({},cardStyle),bodyStyle:Object.assign({},cardBodyStyle,{minHeight:120})},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["c" /* Droppable */],{droppableId:DROPPABLE_ID_SECONDARY_DIM},function(provided,_ref8){var isDraggingOver=_ref8.isDraggingOver;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",Object.assign({},provided.droppableProps,{ref:provided.innerRef,style:droppableStyle}),secondaryDim.map(function(id,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Dimension,{id:id,key:index,index:index});}),provided.placeholder,secondaryDim.length===0&&!isDraggingOver&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__custom_empty__["a" /* default */],{text:t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.placeholder")}));}));return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,!disabled&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("components.annotationsForm.layoutAnnotationDefaultChartLayout.flagSaveAnnotation.title"),":"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:flagSaveAnnotation,onChange:function onChange(e){return _this3.onFlagSaveAnnotationChange(e.target.checked);}}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["a" /* DragDropContext */],{onDragEnd:function onDragEnd(_ref9){var source=_ref9.source,destination=_ref9.destination;return _this3.onDragEnd(source,destination);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"],type:"flex"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},filterCard),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_SM"]}},primaryDimCard),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,null,secondaryCard)))));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(props,state){if(props.dsdDimensions){var primaryDim=state.primaryDim,secondaryDim=state.secondaryDim,filter=state.filter;return{primaryDim:primaryDim.filter(function(id){return props.dsdDimensions.find(function(dim){return dim.id===id;});}),secondaryDim:secondaryDim.filter(function(id){return props.dsdDimensions.find(function(dim){return dim.id===id;});}),filter:[].concat(_toConsumableArray(filter.filter(function(id){return props.dsdDimensions.find(function(dim){return dim.id===id;});})),_toConsumableArray(props.dsdDimensions.filter(function(dim){return![].concat(_toConsumableArray(primaryDim),_toConsumableArray(secondaryDim),_toConsumableArray(filter)).find(function(id){return id===dim.id;});}).map(function(_ref10){var id=_ref10.id;return id;})))};}else{return null;}}}]);return DefaultChartLayout;}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])())(DefaultChartLayout));

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__layout_annotations_form__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
var Layout=function Layout(_ref){var t=_ref.t,disabled=_ref.disabled,endpoints=_ref.endpoints,endpointId=_ref.endpointId,isFormVisible=_ref.isFormVisible,dataflow=_ref.dataflow,dsdForLayoutAnnotations=_ref.dsdForLayoutAnnotations,dsdDimensions=_ref.dsdDimensions,onFormShow=_ref.onFormShow,onFormHide=_ref.onFormHide,onFormSubmit=_ref.onFormSubmit,fetchDsdForLayoutAnnotations=_ref.fetchDsdForLayoutAnnotations,itemsPage=_ref.itemsPage,isOnlyFileDataflow=_ref.isOnlyFileDataflow,isVirtualDataflow=_ref.isVirtualDataflow,fetchItemsPage=_ref.fetchItemsPage,resetItemsPage=_ref.resetItemsPage,valuesForLayoutAnnotations=_ref.valuesForLayoutAnnotations,fetchValuesForLayoutAnnotations=_ref.fetchValuesForLayoutAnnotations,resetValuesForLayoutAnnotations=_ref.resetValuesForLayoutAnnotations;var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;var hasLayoutAnnotations=dataflow&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_annotations__["s" /* countLayoutAnnotations */])(dataflow.annotations,annotationsConfig)>0;var formRef=Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])();return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hocs_call__["a" /* default */],{cb:fetchDsdForLayoutAnnotations,cbParam:dataflow&&dataflow.structure?Object(__WEBPACK_IMPORTED_MODULE_11__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(dataflow.structure):null,disabled:!dataflow||!dataflow.structure},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{type:"primary",icon:hasLayoutAnnotations?"file-text":"plus",onClick:function onClick(){return onFormShow(dataflow.annotations);},disabled:dsdDimensions===null},hasLayoutAnnotations?t('commons.buttons.edit.title'):t('commons.buttons.create.title')))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__enhanced_modal__["a" /* default */],{visible:isFormVisible,title:t('scenes.dataManager.dataflowBuilder.wizard.layoutAnnotations.layoutAnnotationsForm.title'),width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_XL"],onCancel:onFormHide,footer:__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:onFormHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{type:"primary",disabled:disabled,onClick:function onClick(){formRef.current.submit(function(val){onFormSubmit(val);});}},t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__layout_annotations_form__["a" /* default */],{t:t,disabled:disabled,endpoints:endpoints,endpointId:endpointId,annotations:dataflow&&dataflow.annotations,dsdDimensions:dsdForLayoutAnnotations&&dsdForLayoutAnnotations.dimensions,dsdAttributes:dsdForLayoutAnnotations&&dsdForLayoutAnnotations.attributes,ref:formRef,itemsPage:itemsPage,fetchItemsPage:fetchItemsPage,resetItemsPage:resetItemsPage,isOnlyFileDataflow:isOnlyFileDataflow,isVirtualDataflow:isVirtualDataflow,valuesForLayoutAnnotations:valuesForLayoutAnnotations,fetchValuesForLayoutAnnotations:fetchValuesForLayoutAnnotations,resetValuesForLayoutAnnotations:resetValuesForLayoutAnnotations}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(function(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId};}))(Layout));

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, '__esModule', { value: true });

var React = __webpack_require__(0);

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var iterators = {};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

// Thank's IE8 for his funny defineProperty
var descriptors = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var isPure = true;

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode:  'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store$1 = new WeakMap$1();
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function (it, metadata) {
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f$1
};

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$2 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$2
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var path = {};

var aFunction = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global_1 : STATIC ? global_1[TARGET] : (global_1[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = functionBindContext(sourceProperty, global_1);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = functionBindContext(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var useSymbolAsUid = nativeSymbol
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (nativeSymbol && has(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var aFunction$1 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction$1(path[namespace]) || aFunction$1(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var html = getBuiltIn('document', 'documentElement');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

var defineProperty = objectDefineProperty.f;





var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG$2)) {
      defineProperty(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !toStringTagSupport) {
      createNonEnumerableProperty(target, 'toString', objectToString);
    }
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis = function () { return this; };

var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var redefine = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};

var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function () { return this; };

var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      iterators[TO_STRING_TAG] = returnThis$1;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (( FORCED) && IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$1, defaultIterator);
  }
  iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
iterators.Arguments = iterators.Array;

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG$3) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
  }
  iterators[COLLECTION_NAME] = iterators.Array;
}

var entryVirtual = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};

var values = entryVirtual('Array').values;

var values$1 = values;

var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

var values_1 = function (it) {
  var own = it.values;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.values)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? values$1 : own;
};

var values$2 = values_1;

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6)
};

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process$1 = global_1.process;
var versions = process$1 && process$1.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var defineProperty$1 = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

var arrayMethodUsesToLength = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !descriptors) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty$1(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};

var $filter = arrayIteration.filter;



var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var filter = entryVirtual('Array').filter;

var ArrayPrototype$1 = Array.prototype;

var filter_1 = function (it) {
  var own = it.filter;
  return it === ArrayPrototype$1 || (it instanceof Array && own === ArrayPrototype$1.filter) ? filter : own;
};

var filter$1 = filter_1;

var filter$2 = filter$1;

var $find = arrayIteration.find;



var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH$1 = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH$1 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var find = entryVirtual('Array').find;

var ArrayPrototype$2 = Array.prototype;

var find_1 = function (it) {
  var own = it.find;
  return it === ArrayPrototype$2 || (it instanceof Array && own === ArrayPrototype$2.find) ? find : own;
};

var find$1 = find_1;

var find$2 = find$1;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $reduce = arrayReduce.left;



var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH$2 = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH$2 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var reduce = entryVirtual('Array').reduce;

var ArrayPrototype$3 = Array.prototype;

var reduce_1 = function (it) {
  var own = it.reduce;
  return it === ArrayPrototype$3 || (it instanceof Array && own === ArrayPrototype$3.reduce) ? reduce : own;
};

var reduce$1 = reduce_1;

var reduce$2 = reduce$1;

var propertyIsEnumerable = objectPropertyIsEnumerable.f;

// `Object.{ entries, values }` methods implementation
var createMethod$3 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!descriptors || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod$3(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod$3(false)
};

var $values = objectToArray.values;

// `Object.values` method
// https://tc39.github.io/ecma262/#sec-object.values
_export({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

var values$3 = path.Object.values;

var values$4 = values$3;

var values$5 = values$4;

var $every = arrayIteration.every;



var STRICT_METHOD$1 = arrayMethodIsStrict('every');
var USES_TO_LENGTH$3 = arrayMethodUsesToLength('every');

// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$1 || !USES_TO_LENGTH$3 }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var every = entryVirtual('Array').every;

var ArrayPrototype$4 = Array.prototype;

var every_1 = function (it) {
  var own = it.every;
  return it === ArrayPrototype$4 || (it instanceof Array && own === ArrayPrototype$4.every) ? every : own;
};

var every$1 = every_1;

var every$2 = every$1;

var $map = arrayIteration.map;



var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH$4 = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 || !USES_TO_LENGTH$4 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var map = entryVirtual('Array').map;

var ArrayPrototype$5 = Array.prototype;

var map_1 = function (it) {
  var own = it.map;
  return it === ArrayPrototype$5 || (it instanceof Array && own === ArrayPrototype$5.map) ? map : own;
};

var map$1 = map_1;

var map$2 = map$1;

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$4 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$4(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$4(true)
};

var charAt = stringMultibyte.charAt;



var STRING_ITERATOR = 'String Iterator';
var setInternalState$1 = internalState.set;
var getInternalState$1 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$1(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var nativePromiseConstructor = global_1.Promise;

var redefineAll = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else redefine(target, key, src[key], options);
  } return target;
};

var SPECIES$2 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var anInstance = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var ITERATOR$2 = wellKnownSymbol('iterator');
var ArrayPrototype$6 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$6[ITERATOR$2] === it);
};

var ITERATOR$3 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$3]
    || it['@@iterator']
    || iterators[classof(it)];
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};

var iterate_1 = createCommonjsModule(function (module) {
var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = functionBindContext(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};
});

var ITERATOR$4 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$4] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$4] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var SPECIES$3 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$3]) == undefined ? defaultConstructor : aFunction(S);
};

var engineIsIos = /(iphone|ipod|ipad).*applewebkit/i.test(engineUserAgent);

var location = global_1.location;
var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$2 = global_1.process;
var MessageChannel = global_1.MessageChannel;
var Dispatch = global_1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global_1.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classofRaw(process$2) == 'process') {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !engineIsIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = functionBindContext(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1.addEventListener && typeof postMessage == 'function' && !global_1.importScripts && !fails(post)) {
    defer = post;
    global_1.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$1,
  clear: clear
};

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;

var macrotask = task.set;


var MutationObserver$1 = global_1.MutationObserver || global_1.WebKitMutationObserver;
var process$3 = global_1.process;
var Promise$1 = global_1.Promise;
var IS_NODE = classofRaw(process$3) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global_1, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process$3.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process$3.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver$1 && !engineIsIos) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver$1(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global_1, flush);
    };
  }
}

var microtask = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
var f$3 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
	f: f$3
};

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var hostReportErrors = function (a, b) {
  var console = global_1.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var task$1 = task.set;










var SPECIES$4 = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState$2 = internalState.get;
var setInternalState$2 = internalState.set;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var PromiseConstructor = nativePromiseConstructor;
var TypeError$1 = global_1.TypeError;
var document$2 = global_1.document;
var process$4 = global_1.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var IS_NODE$1 = classofRaw(process$4) == 'process';
var DISPATCH_EVENT = !!(document$2 && document$2.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper;

var FORCED = isForced_1(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (engineV8Version === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE$1 && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if ( !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (engineV8Version >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$4] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify$1 = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$2.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global_1['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process$4.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    if (IS_NODE$1) {
      process$4.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState$2(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE$1 ? process$4.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify$1(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$2(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
_export({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability$1(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

_export({ target: PROMISE, stat: true, forced: isPure  }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve( this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

_export({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate_1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate_1(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// `Promise.allSettled` method
// https://github.com/tc39/proposal-promise-allSettled
_export({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate_1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (e) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: e };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!nativePromiseConstructor && fails(function () {
  nativePromiseConstructor.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
_export({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

var promise$1 = path.Promise;

var promise$2 = promise$1;

var promise$3 = promise$2;

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var keys$1 = path.Object.keys;

var keys$2 = keys$1;

var keys$3 = keys$2;

var $includes = arrayIncludes.includes;



var USES_TO_LENGTH$5 = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true, forced: !USES_TO_LENGTH$5 }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var includes = entryVirtual('Array').includes;

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var includes$1 = entryVirtual('String').includes;

var ArrayPrototype$7 = Array.prototype;
var StringPrototype = String.prototype;

var includes$2 = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype$7 || (it instanceof Array && own === ArrayPrototype$7.includes)) return includes;
  if (typeof it === 'string' || it === StringPrototype || (it instanceof String && own === StringPrototype.includes)) {
    return includes$1;
  } return own;
};

var includes$3 = includes$2;

var includes$4 = includes$3;

var $forEach = arrayIteration.forEach;



var STRICT_METHOD$2 = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH$6 = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
var arrayForEach = (!STRICT_METHOD$2 || !USES_TO_LENGTH$6) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

var forEach = entryVirtual('Array').forEach;

var forEach$1 = forEach;

var ArrayPrototype$8 = Array.prototype;

var DOMIterables$1 = {
  DOMTokenList: true,
  NodeList: true
};

var forEach_1 = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype$8 || (it instanceof Array && own === ArrayPrototype$8.forEach)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables$1.hasOwnProperty(classof(it)) ? forEach$1 : own;
};

var forEach$2 = forEach_1;

var freezing = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});

var internalMetadata = createCommonjsModule(function (module) {
var defineProperty = objectDefineProperty.f;



var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (freezing && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;
});
var internalMetadata_1 = internalMetadata.REQUIRED;
var internalMetadata_2 = internalMetadata.fastKey;
var internalMetadata_3 = internalMetadata.getWeakData;
var internalMetadata_4 = internalMetadata.onFreeze;

var defineProperty$2 = objectDefineProperty.f;
var forEach$3 = arrayIteration.forEach;



var setInternalState$3 = internalState.set;
var internalStateGetterFor = internalState.getterFor;

var collection = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global_1[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var exported = {};
  var Constructor;

  if (!descriptors || typeof NativeConstructor != 'function'
    || !(IS_WEAK || NativePrototype.forEach && !fails(function () { new NativeConstructor().entries().next(); }))
  ) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    internalMetadata.REQUIRED = true;
  } else {
    Constructor = wrapper(function (target, iterable) {
      setInternalState$3(anInstance(target, Constructor, CONSTRUCTOR_NAME), {
        type: CONSTRUCTOR_NAME,
        collection: new NativeConstructor()
      });
      if (iterable != undefined) iterate_1(iterable, target[ADDER], target, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    forEach$3(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in NativePrototype && !(IS_WEAK && KEY == 'clear')) {
        createNonEnumerableProperty(Constructor.prototype, KEY, function (a, b) {
          var collection = getInternalState(this).collection;
          if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
          var result = collection[KEY](a === 0 ? 0 : a, b);
          return IS_ADDER ? this : result;
        });
      }
    });

    IS_WEAK || defineProperty$2(Constructor.prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).collection.size;
      }
    });
  }

  setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);

  exported[CONSTRUCTOR_NAME] = Constructor;
  _export({ global: true, forced: true }, exported);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

var defineProperty$3 = objectDefineProperty.f;








var fastKey = internalMetadata.fastKey;


var setInternalState$4 = internalState.set;
var internalStateGetterFor$1 = internalState.getterFor;

var collectionStrong = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState$4(that, {
        type: CONSTRUCTOR_NAME,
        index: objectCreate(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!descriptors) that.size = 0;
      if (iterable != undefined) iterate_1(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (descriptors) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (descriptors) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (descriptors) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (descriptors) defineProperty$3(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor$1(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$4(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
var es_set = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

var set$2 = path.Set;

var set$3 = set$2;

var set$4 = set$3;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var isNullOrUndefined = (function (value) {
  return value == null;
});

// `Array.isArray` method
// https://tc39.github.io/ecma262/#sec-array.isarray
_export({ target: 'Array', stat: true }, {
  isArray: isArray
});

var isArray$1 = path.Array.isArray;

var isArray$2 = isArray$1;

var isArray$3 = isArray$2;

var isArray$4 = (function (value) {
  return isArray$3(value);
});

var isObjectType = function (value) {
  return typeof value === 'object';
};
var isObject$1 = (function (value) {
  return !isNullOrUndefined(value) && !isArray$4(value) && isObjectType(value);
});

var isHTMLElement = (function (value) {
  return isObject$1(value) && value.nodeType === Node.ELEMENT_NODE;
});

var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit'
};
var VALUE = 'value';
var UNDEFINED = 'undefined';
var EVENTS = {
  BLUR: 'blur',
  CHANGE: 'change',
  INPUT: 'input'
};
var INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};
var REGEX_IS_DEEP_PROP = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var REGEX_IS_PLAIN_PROP = /^\w*$/;
var REGEX_PROP_NAME = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var REGEX_ESCAPE_CHAR = /\\(\\)?/g;
var REGEX_ARRAY_FIELD_INDEX = /[\d+]/g;

function attachEventListeners(_a) {
  var ref = _a.field.ref,
      handleChange = _a.handleChange,
      isRadioOrCheckbox = _a.isRadioOrCheckbox;

  if (isHTMLElement(ref) && handleChange) {
    ref.addEventListener(isRadioOrCheckbox ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
    ref.addEventListener(EVENTS.BLUR, handleChange);
  }
}

var $entries = objectToArray.entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
_export({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});

var entries = path.Object.entries;

var entries$1 = entries;

var entries$2 = entries$1;

var isKey = (function (value) {
  return !isArray$4(value) && (REGEX_IS_PLAIN_PROP.test(value) || !REGEX_IS_DEEP_PROP.test(value));
});

var stringToPath = (function (string) {
  var result = [];
  string.replace(REGEX_PROP_NAME, function (match, number, quote, string) {
    result.push(quote ? string.replace(REGEX_ESCAPE_CHAR, '$1') : number || match);
  });
  return result;
});

function set$5(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath(path);
  var length = tempPath.length;
  var lastIndex = length - 1;

  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;

    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject$1(objValue) || isArray$4(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }

    object[key] = newValue;
    object = object[key];
  }

  return object;
}

var transformToNestObject = (function (data) {
  var _context;

  return reduce$2(_context = entries$2(data)).call(_context, function (previous, _a) {
    var _b;

    var _c = __read(_a, 2),
        key = _c[0],
        value = _c[1];

    if (!isKey(key)) {
      set$5(previous, key, value);
      return previous;
    }

    return __assign(__assign({}, previous), (_b = {}, _b[key] = value, _b));
  }, {});
});

var isUndefined = (function (val) {
  return val === undefined;
});

var get$1 = (function (obj, path, defaultValue) {
  var _context, _context2;

  var result = reduce$2(_context = filter$2(_context2 = path.split(/[,[\].]+?/)).call(_context2, Boolean)).call(_context, function (result, key) {
    return isNullOrUndefined(result) ? result : result[key];
  }, obj);

  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
});

var focusOnErrorField = (function (fields, fieldErrors) {
  for (var key in fields) {
    if (get$1(fieldErrors, key)) {
      var field = fields[key];

      if (field) {
        if (field.ref.focus) {
          field.ref.focus();
          break;
        } else if (field.options) {
          field.options[0].ref.focus();
          break;
        }
      }
    }
  }
});

var removeAllEventListeners = (function (ref, validateWithStateUpdate) {
  if (isHTMLElement(ref) && ref.removeEventListener) {
    ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
  }
});

var isRadioInput = (function (element) {
  return element.type === 'radio';
});

var isCheckBoxInput = (function (element) {
  return element.type === 'checkbox';
});

function isDetached(element) {
  if (!element) {
    return true;
  }

  if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
    return false;
  }

  return isDetached(element.parentNode);
}

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH$7 = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES$5 = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max$1 = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 || !USES_TO_LENGTH$7 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$5];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$1(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var slice = entryVirtual('Array').slice;

var ArrayPrototype$9 = Array.prototype;

var slice_1 = function (it) {
  var own = it.slice;
  return it === ArrayPrototype$9 || (it instanceof Array && own === ArrayPrototype$9.slice) ? slice : own;
};

var slice$1 = slice_1;

var slice$2 = slice$1;

var isEmptyObject = (function (value) {
  return isObject$1(value) && !keys$3(value).length;
});

function castPath(value) {
  return isArray$4(value) ? value : stringToPath(value);
}

function baseGet(object, path) {
  var updatePath = isKey(path) ? [path] : castPath(path);
  var length = path.length;
  var index = 0;

  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }

  return index == length ? object : undefined;
}

function baseSlice(array, start, end) {
  var index = -1;
  var length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}

function parent(object, path) {
  return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
}

function baseUnset(object, path) {
  var updatePath = isKey(path) ? [path] : castPath(path);
  var childObject = parent(object, updatePath);
  var key = updatePath[updatePath.length - 1];
  var result = !(childObject != null) || delete childObject[key];
  var previousObjRef = undefined;

  for (var k = 0; k < slice$2(updatePath).call(updatePath, 0, -1).length; k++) {
    var index = -1;
    var objectRef = undefined;

    var currentPaths = slice$2(updatePath).call(updatePath, 0, -(k + 1));

    var currentPathsLength = currentPaths.length - 1;

    if (k > 0) {
      previousObjRef = object;
    }

    while (++index < currentPaths.length) {
      var item = currentPaths[index];
      objectRef = objectRef ? objectRef[item] : object[item];

      if (currentPathsLength === index) {
        if (isObject$1(objectRef) && isEmptyObject(objectRef) || isArray$4(objectRef) && !filter$2(objectRef).call(objectRef, function (data) {
          return isObject$1(data) && !isEmptyObject(data);
        }).length) {
          previousObjRef ? delete previousObjRef[item] : delete object[item];
        }
      }

      previousObjRef = objectRef;
    }
  }

  return result;
}

function unset(object, paths) {
  forEach$2(paths).call(paths, function (path) {
    baseUnset(object, path);
  });

  return object;
}

var isSameRef = function (fieldValue, ref) {
  return fieldValue && fieldValue.ref === ref;
};

function findRemovedFieldAndRemoveListener(fields, handleChange, field, forceDelete) {
  var ref = field.ref,
      _a = field.ref,
      name = _a.name,
      type = _a.type,
      mutationWatcher = field.mutationWatcher;
  var fieldValue = fields[name];

  if (!type) {
    delete fields[name];
    return;
  }

  if ((isRadioInput(ref) || isCheckBoxInput(ref)) && fieldValue) {
    var options_1 = fieldValue.options;

    if (isArray$4(options_1) && options_1.length) {
      var _context;

      forEach$2(_context = filter$2(options_1).call(options_1, Boolean)).call(_context, function (option, index) {
        var ref = option.ref,
            mutationWatcher = option.mutationWatcher;

        if (ref && isDetached(ref) && isSameRef(option, ref) || forceDelete) {
          removeAllEventListeners(ref, handleChange);

          if (mutationWatcher) {
            mutationWatcher.disconnect();
          }

          unset(options_1, ["[" + index + "]"]);
        }
      });

      if (options_1 && !filter$2(options_1).call(options_1, Boolean).length) {
        delete fields[name];
      }
    } else {
      delete fields[name];
    }
  } else if (isDetached(ref) && isSameRef(fieldValue, ref) || forceDelete) {
    removeAllEventListeners(ref, handleChange);

    if (mutationWatcher) {
      mutationWatcher.disconnect();
    }

    delete fields[name];
  }
}

var nativeStartsWith = ''.startsWith;
var min$2 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith');

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
_export({ target: 'String', proto: true, forced:  !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min$2(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

var startsWith = entryVirtual('String').startsWith;

var StringPrototype$1 = String.prototype;

var startsWith_1 = function (it) {
  var own = it.startsWith;
  return typeof it === 'string' || it === StringPrototype$1
    || (it instanceof String && own === StringPrototype$1.startsWith) ? startsWith : own;
};

var startsWith$1 = startsWith_1;

var startsWith$2 = startsWith$1;

var defaultReturn = {
  isValid: false,
  value: ''
};
var getRadioValue = (function (options) {
  return isArray$4(options) ? reduce$2(options).call(options, function (previous, option) {
    return option && option.ref.checked ? {
      isValid: true,
      value: option.ref.value
    } : previous;
  }, defaultReturn) : defaultReturn;
});

var getMultipleSelectValue = (function (options) {
  var _context, _context2;

  return map$2(_context = filter$2(_context2 = __spread(options)).call(_context2, function (_a) {
    var selected = _a.selected;
    return selected;
  })).call(_context, function (_a) {
    var value = _a.value;
    return value;
  });
});

var isFileInput = (function (element) {
  return element.type === 'file';
});

var isMultipleSelect = (function (element) {
  return element.type === 'select-multiple';
});

var isEmptyString = (function (value) {
  return value === '';
});

var defaultResult = {
  value: false,
  isValid: false
};
var validResult = {
  value: true,
  isValid: true
};
var getCheckboxValue = (function (options) {
  if (isArray$4(options)) {
    if (options.length > 1) {
      var _context;

      var values = map$2(_context = filter$2(options).call(options, function (option) {
        return option && option.ref.checked;
      })).call(_context, function (_a) {
        var value = _a.ref.value;
        return value;
      });

      return {
        value: values,
        isValid: !!values.length
      };
    }

    var _a = options[0].ref,
        checked = _a.checked,
        value = _a.value,
        attributes = _a.attributes;
    return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || isEmptyString(value) ? validResult : {
      value: value,
      isValid: true
    } : validResult : defaultResult;
  }

  return defaultResult;
});

function getFieldValue(fields, ref) {
  var name = ref.name,
      value = ref.value;
  var field = fields[name];

  if (isFileInput(ref)) {
    return ref.files;
  }

  if (isRadioInput(ref)) {
    return field ? getRadioValue(field.options).value : '';
  }

  if (isMultipleSelect(ref)) {
    return getMultipleSelectValue(ref.options);
  }

  if (isCheckBoxInput(ref)) {
    return field ? getCheckboxValue(field.options).value : false;
  }

  return value;
}

var isString = (function (value) {
  return typeof value === 'string';
});

var getFieldsValues = (function (fields, search) {
  var output = {};

  var _loop_1 = function (name_1) {
    if (isUndefined(search) || (isString(search) ? startsWith$2(name_1).call(name_1, search) : isArray$4(search) ? find$2(search).call(search, function (data) {
      return startsWith$2(name_1).call(name_1, data);
    }) : search && search.nest)) {
      output[name_1] = getFieldValue(fields, fields[name_1].ref);
    }
  };

  for (var name_1 in fields) {
    _loop_1(name_1);
  }

  return output;
});

var compareObject = (function (objectA, objectB) {
  if (objectA === void 0) {
    objectA = {};
  }

  if (objectB === void 0) {
    objectB = {};
  }

  var objectAKeys = keys$3(objectA);

  var objectBKeys = keys$3(objectB);

  return objectAKeys.length === objectBKeys.length && every$2(objectAKeys).call(objectAKeys, function (key) {
    return objectB[key] && objectB[key] === objectA[key];
  });
});

var isSameError = (function (error, _a) {
  var type = _a.type,
      types = _a.types,
      message = _a.message;
  return isObject$1(error) && error.type === type && error.message === message && compareObject(error.types, types);
});

function shouldRenderBasedOnError(_a) {
  var errors = _a.errors,
      name = _a.name,
      error = _a.error,
      validFields = _a.validFields,
      fieldsWithValidation = _a.fieldsWithValidation;
  var isFieldValid = isEmptyObject(error);
  var isFormValid = isEmptyObject(errors);
  var currentFieldError = get$1(error, name);
  var existFieldError = get$1(errors, name);

  if (isFieldValid && validFields.has(name) || existFieldError && existFieldError.isManual) {
    return false;
  }

  if (isFormValid !== isFieldValid || !isFormValid && !existFieldError || isFieldValid && fieldsWithValidation.has(name) && !validFields.has(name)) {
    return true;
  }

  return currentFieldError && !isSameError(existFieldError, currentFieldError);
}

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$5 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$5(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$5(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$5(3)
};

var trim = stringTrim.trim;


var $parseFloat = global_1.parseFloat;
var FORCED$1 = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED$1 ? function parseFloat(string) {
  var trimmedString = trim(String(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
_export({ global: true, forced: parseFloat != numberParseFloat }, {
  parseFloat: numberParseFloat
});

var _parseFloat = path.parseFloat;

var _parseFloat$1 = _parseFloat;

var _parseFloat$2 = _parseFloat$1;

var slice$3 = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
var functionBind = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice$3.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice$3.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};

// `Function.prototype.bind` method
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
_export({ target: 'Function', proto: true }, {
  bind: functionBind
});

var bind$1 = entryVirtual('Function').bind;

var FunctionPrototype = Function.prototype;

var bind_1 = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (it instanceof Function && own === FunctionPrototype.bind) ? bind$1 : own;
};

var bind$2 = bind_1;

var bind$3 = bind$2;

var isRegex = (function (value) {
  return value instanceof RegExp;
});

var getValueAndMessage = (function (validationData) {
  var isValueMessage = function (value) {
    return isObject$1(value) && !isRegex(value);
  };

  return isValueMessage(validationData) ? validationData : {
    value: validationData,
    message: ''
  };
});

var isFunction = (function (value) {
  return typeof value === 'function';
});

var isBoolean = (function (value) {
  return typeof value === 'boolean';
});

var isMessage = (function (value) {
  return isString(value) || isObject$1(value) && React.isValidElement(value);
});

function getValidateError(result, ref, type) {
  if (type === void 0) {
    type = 'validate';
  }

  if (isMessage(result) || isBoolean(result) && !result) {
    return {
      type: type,
      message: isMessage(result) ? result : '',
      ref: ref
    };
  }
}

var appendErrors = (function (name, validateAllFieldCriteria, errors, type, message) {
  var _a;

  if (validateAllFieldCriteria) {
    var error = errors[name];
    return __assign(__assign({}, error), {
      types: __assign(__assign({}, error && error.types ? error.types : {}), (_a = {}, _a[type] = message || true, _a))
    });
  }

  return {};
});

var validateField = (function (fieldsRef, validateAllFieldCriteria, _a) {
  var ref = _a.ref,
      _b = _a.ref,
      type = _b.type,
      value = _b.value,
      name = _b.name,
      options = _a.options,
      required = _a.required,
      maxLength = _a.maxLength,
      minLength = _a.minLength,
      min = _a.min,
      max = _a.max,
      pattern = _a.pattern,
      validate = _a.validate;
  return __awaiter(void 0, void 0, void 0, function () {
    var fields, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _c, requiredValue, requiredMessage, exceedMax, exceedMin, _d, maxValue, maxMessage, _e, minValue, minMessage, valueNumber, valueDate, _f, maxLengthValue, maxLengthMessage, _g, minLengthValue, minLengthMessage, inputLength, exceedMax, exceedMin, _h, patternValue, patternMessage, fieldValue, validateRef, result, validateError, validationResult, _j, _k, _l, key, validateFunction, validateResult, validateError, e_1_1;

    var e_1, _m;

    var _o;

    return __generator(this, function (_p) {
      switch (_p.label) {
        case 0:
          fields = fieldsRef.current;
          error = {};
          isRadio = isRadioInput(ref);
          isCheckBox = isCheckBoxInput(ref);
          isRadioOrCheckbox = isRadio || isCheckBox;
          isEmpty = isEmptyString(value);
          appendErrorsCurry = bind$3(appendErrors).call(appendErrors, null, name, validateAllFieldCriteria, error);

          getMinMaxMessage = function (exceedMax, maxLengthMessage, minLengthMessage, maxType, minType) {
            if (maxType === void 0) {
              maxType = INPUT_VALIDATION_RULES.maxLength;
            }

            if (minType === void 0) {
              minType = INPUT_VALIDATION_RULES.minLength;
            }

            var message = exceedMax ? maxLengthMessage : minLengthMessage;
            error[name] = __assign({
              type: exceedMax ? maxType : minType,
              message: message,
              ref: ref
            }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));

            if (!validateAllFieldCriteria) {
              return error;
            }
          };

          if (required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid)) {
            _c = isMessage(required) ? {
              value: !!required,
              message: required
            } : getValueAndMessage(required), requiredValue = _c.value, requiredMessage = _c.message;

            if (requiredValue) {
              error[name] = __assign({
                type: INPUT_VALIDATION_RULES.required,
                message: requiredMessage,
                ref: isRadioOrCheckbox ? (_o = fields[name].options) === null || _o === void 0 ? void 0 : _o[0].ref : ref
              }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, requiredMessage));

              if (!validateAllFieldCriteria) {
                return [2
                /*return*/
                , error];
              }
            }
          }

          if (!isNullOrUndefined(min) || !isNullOrUndefined(max)) {
            exceedMax = void 0;
            exceedMin = void 0;
            _d = getValueAndMessage(max), maxValue = _d.value, maxMessage = _d.message;
            _e = getValueAndMessage(min), minValue = _e.value, minMessage = _e.message;

            if (type === 'number' || !type && !isNaN(value)) {
              valueNumber = ref.valueAsNumber || _parseFloat$2(value);

              if (!isNullOrUndefined(maxValue)) {
                exceedMax = valueNumber > maxValue;
              }

              if (!isNullOrUndefined(minValue)) {
                exceedMin = valueNumber < minValue;
              }
            } else {
              valueDate = ref.valueAsDate || new Date(value);

              if (isString(maxValue)) {
                exceedMax = valueDate > new Date(maxValue);
              }

              if (isString(minValue)) {
                exceedMin = valueDate < new Date(minValue);
              }
            }

            if (exceedMax || exceedMin) {
              getMinMaxMessage(!!exceedMax, maxMessage, minMessage, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

              if (!validateAllFieldCriteria) {
                return [2
                /*return*/
                , error];
              }
            }
          }

          if (isString(value) && !isEmpty && (maxLength || minLength)) {
            _f = getValueAndMessage(maxLength), maxLengthValue = _f.value, maxLengthMessage = _f.message;
            _g = getValueAndMessage(minLength), minLengthValue = _g.value, minLengthMessage = _g.message;
            inputLength = value.toString().length;
            exceedMax = !isNullOrUndefined(maxLengthValue) && inputLength > maxLengthValue;
            exceedMin = !isNullOrUndefined(minLengthValue) && inputLength < minLengthValue;

            if (exceedMax || exceedMin) {
              getMinMaxMessage(!!exceedMax, maxLengthMessage, minLengthMessage);

              if (!validateAllFieldCriteria) {
                return [2
                /*return*/
                , error];
              }
            }
          }

          if (pattern && !isEmpty) {
            _h = getValueAndMessage(pattern), patternValue = _h.value, patternMessage = _h.message;

            if (isRegex(patternValue) && !patternValue.test(value)) {
              error[name] = __assign({
                type: INPUT_VALIDATION_RULES.pattern,
                message: patternMessage,
                ref: ref
              }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, patternMessage));

              if (!validateAllFieldCriteria) {
                return [2
                /*return*/
                , error];
              }
            }
          }

          if (!validate) return [3
          /*break*/
          , 11];
          fieldValue = getFieldValue(fields, ref);
          validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;
          if (!isFunction(validate)) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , validate(fieldValue)];

        case 1:
          result = _p.sent();
          validateError = getValidateError(result, validateRef);

          if (validateError) {
            error[name] = __assign(__assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

            if (!validateAllFieldCriteria) {
              return [2
              /*return*/
              , error];
            }
          }

          return [3
          /*break*/
          , 11];

        case 2:
          if (!isObject$1(validate)) return [3
          /*break*/
          , 11];
          validationResult = {};
          _p.label = 3;

        case 3:
          _p.trys.push([3, 8, 9, 10]);

          _j = __values(entries$2(validate)), _k = _j.next();
          _p.label = 4;

        case 4:
          if (!!_k.done) return [3
          /*break*/
          , 7];
          _l = __read(_k.value, 2), key = _l[0], validateFunction = _l[1];

          if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
            return [3
            /*break*/
            , 7];
          }

          return [4
          /*yield*/
          , validateFunction(fieldValue)];

        case 5:
          validateResult = _p.sent();
          validateError = getValidateError(validateResult, validateRef, key);

          if (validateError) {
            validationResult = __assign(__assign({}, validateError), appendErrorsCurry(key, validateError.message));

            if (validateAllFieldCriteria) {
              error[name] = validationResult;
            }
          }

          _p.label = 6;

        case 6:
          _k = _j.next();
          return [3
          /*break*/
          , 4];

        case 7:
          return [3
          /*break*/
          , 10];

        case 8:
          e_1_1 = _p.sent();
          e_1 = {
            error: e_1_1
          };
          return [3
          /*break*/
          , 10];

        case 9:
          try {
            if (_k && !_k.done && (_m = _j.return)) _m.call(_j);
          } finally {
            if (e_1) throw e_1.error;
          }

          return [7
          /*endfinally*/
          ];

        case 10:
          if (!isEmptyObject(validationResult)) {
            error[name] = __assign({
              ref: validateRef
            }, validationResult);

            if (!validateAllFieldCriteria) {
              return [2
              /*return*/
              , error];
            }
          }

          _p.label = 11;

        case 11:
          return [2
          /*return*/
          , error];
      }
    });
  });
});

var parseErrorSchema = function (error, validateAllFieldCriteria) {
  var _context;

  var _a;

  return isArray$4(error.inner) ? reduce$2(_context = error.inner).call(_context, function (previous, _a) {
    var _b, _c, _d;

    var path = _a.path,
        message = _a.message,
        type = _a.type;
    return __assign(__assign({}, previous), path ? previous[path] && validateAllFieldCriteria ? (_b = {}, _b[path] = appendErrors(path, validateAllFieldCriteria, previous, type, message), _b) : (_c = {}, _c[path] = previous[path] || __assign({
      message: message,
      type: type
    }, validateAllFieldCriteria ? {
      types: (_d = {}, _d[type] = message || true, _d)
    } : {}), _c) : {});
  }, {}) : (_a = {}, _a[error.path] = {
    message: error.message,
    type: error.type
  }, _a);
};
function validateWithSchema(validationSchema, validateAllFieldCriteria, data, validationResolver, context) {
  return __awaiter(this, void 0, void 0, function () {
    var _a, e_1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (validationResolver) {
            return [2
            /*return*/
            , validationResolver(data, context)];
          }

          _b.label = 1;

        case 1:
          _b.trys.push([1, 3,, 4]);

          _a = {};
          return [4
          /*yield*/
          , validationSchema.validate(data, {
            abortEarly: false,
            context: context
          })];

        case 2:
          return [2
          /*return*/
          , (_a.values = _b.sent(), _a.errors = {}, _a)];

        case 3:
          e_1 = _b.sent();
          return [2
          /*return*/
          , {
            values: {},
            errors: transformToNestObject(parseErrorSchema(e_1, validateAllFieldCriteria))
          }];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
}

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? functionBindContext(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray;

// `Array.prototype.flat` method
// https://github.com/tc39/proposal-flatMap
_export({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

var flat = entryVirtual('Array').flat;

var ArrayPrototype$a = Array.prototype;

var flat_1 = function (it) {
  var own = it.flat;
  return it === ArrayPrototype$a || (it instanceof Array && own === ArrayPrototype$a.flat) ? flat : own;
};

var flat$1 = flat_1;

var flat$2 = flat$1;

var isPrimitive = (function (value) {
  return isNullOrUndefined(value) || !isObjectType(value);
});

var getPath = function (path, values) {
  var _context;

  var getInnerPath = function (value, key, isObject) {
    var pathWithIndex = isObject ? path + "." + key : path + "[" + key + "]";
    return isPrimitive(value) ? pathWithIndex : getPath(pathWithIndex, value);
  };

  return isArray$4(values) ? map$2(values).call(values, function (value, key) {
    return getInnerPath(value, key);
  }) : map$2(_context = entries$2(values)).call(_context, function (_a) {
    var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];

    return getInnerPath(value, key, true);
  });
};

var getPath$1 = (function (parentPath, value) {
  var _context2;

  return flat$2(_context2 = getPath(parentPath, value)).call(_context2, Infinity);
});

var assignWatchFields = (function (fieldValues, fieldName, watchFields, inputValue, isSingleField) {
  var value;
  watchFields.add(fieldName);

  if (isEmptyObject(fieldValues)) {
    value = undefined;
  } else if (!isUndefined(fieldValues[fieldName])) {
    value = fieldValues[fieldName];
    watchFields.add(fieldName);
  } else {
    value = get$1(transformToNestObject(fieldValues), fieldName);

    if (!isUndefined(value)) {
      var _context;

      forEach$2(_context = getPath$1(fieldName, value)).call(_context, function (name) {
        return watchFields.add(name);
      });
    }
  }

  return isUndefined(value) ? isSingleField ? inputValue : get$1(inputValue, fieldName) : value;
});

var skipValidation = (function (_a) {
  var isOnChange = _a.isOnChange,
      hasError = _a.hasError,
      isBlurEvent = _a.isBlurEvent,
      isOnSubmit = _a.isOnSubmit,
      isReValidateOnSubmit = _a.isReValidateOnSubmit,
      isOnBlur = _a.isOnBlur,
      isReValidateOnBlur = _a.isReValidateOnBlur,
      isSubmitted = _a.isSubmitted;
  return isOnChange && isBlurEvent || isOnSubmit && isReValidateOnSubmit || isOnSubmit && !isSubmitted || isOnBlur && !isBlurEvent && !hasError || isReValidateOnBlur && !isBlurEvent && hasError || isReValidateOnSubmit && isSubmitted;
});

var $indexOf = arrayIncludes.indexOf;



var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD$3 = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH$8 = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD$3 || !USES_TO_LENGTH$8 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var indexOf$1 = entryVirtual('Array').indexOf;

var ArrayPrototype$b = Array.prototype;

var indexOf_1 = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype$b || (it instanceof Array && own === ArrayPrototype$b.indexOf) ? indexOf$1 : own;
};

var indexOf$2 = indexOf_1;

var indexOf$3 = indexOf$2;

var getFieldArrayParentName = (function (name) {
  return name.substring(0, indexOf$3(name).call(name, '['));
});

var getFieldValueByName = (function (fields, name) {
  var results = transformToNestObject(getFieldsValues(fields));
  return name ? get$1(results, name, results) : results;
});

function getIsFieldsDifferent(referenceArray, differenceArray) {
  var isMatch = false;

  if (!isArray$4(referenceArray) || !isArray$4(differenceArray) || referenceArray.length !== differenceArray.length) {
    return true;
  }

  for (var i = 0; i < referenceArray.length; i++) {
    if (isMatch) {
      break;
    }

    var dataA = referenceArray[i];
    var dataB = differenceArray[i];

    if (isUndefined(dataB) || keys$3(dataA).length !== keys$3(dataB).length) {
      isMatch = true;
      break;
    }

    for (var key in dataA) {
      if (dataA[key] !== dataB[key]) {
        isMatch = true;
        break;
      }
    }
  }

  return isMatch;
}

var $some = arrayIteration.some;



var STRICT_METHOD$4 = arrayMethodIsStrict('some');
var USES_TO_LENGTH$9 = arrayMethodUsesToLength('some');

// `Array.prototype.some` method
// https://tc39.github.io/ecma262/#sec-array.prototype.some
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$4 || !USES_TO_LENGTH$9 }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var some = entryVirtual('Array').some;

var ArrayPrototype$c = Array.prototype;

var some_1 = function (it) {
  var own = it.some;
  return it === ArrayPrototype$c || (it instanceof Array && own === ArrayPrototype$c.some) ? some : own;
};

var some$1 = some_1;

var some$2 = some$1;

var isMatchFieldArrayName = function (name, searchName) {
  return RegExp(("^" + searchName + "[\\d+]").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
};
var isNameInFieldArray = (function (names, name) {
  var _context;

  return some$2(_context = __spread(names)).call(_context, function (current) {
    return isMatchFieldArrayName(name, current);
  });
});

function onDomRemove(element, onDetachCallback) {
  var observer = new MutationObserver(function () {
    if (isDetached(element)) {
      observer.disconnect();
      onDetachCallback();
    }
  });
  observer.observe(window.document, {
    childList: true,
    subtree: true
  });
  return observer;
}

var modeChecker = (function (mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange
  };
});

var isRadioOrCheckboxFunction = (function (ref) {
  return isRadioInput(ref) || isCheckBoxInput(ref);
});

function useForm(_a) {
  var _this = this;

  var _b = _a === void 0 ? {} : _a,
      _c = _b.mode,
      mode = _c === void 0 ? VALIDATION_MODE.onSubmit : _c,
      _d = _b.reValidateMode,
      reValidateMode = _d === void 0 ? VALIDATION_MODE.onChange : _d,
      validationSchema = _b.validationSchema,
      validationResolver = _b.validationResolver,
      validationContext = _b.validationContext,
      _e = _b.defaultValues,
      defaultValues = _e === void 0 ? {} : _e,
      _f = _b.submitFocusError,
      submitFocusError = _f === void 0 ? true : _f,
      validateCriteriaMode = _b.validateCriteriaMode;

  var fieldsRef = React.useRef({});
  var errorsRef = React.useRef({});
  var touchedFieldsRef = React.useRef({});
  var fieldArrayDefaultValues = React.useRef({});
  var watchFieldsRef = React.useRef(new set$4());
  var dirtyFieldsRef = React.useRef(new set$4());
  var fieldsWithValidationRef = React.useRef(new set$4());
  var validFieldsRef = React.useRef(new set$4());
  var isValidRef = React.useRef(true);
  var defaultValuesRef = React.useRef(defaultValues);
  var defaultValuesAtRenderRef = React.useRef({});
  var isUnMount = React.useRef(false);
  var isWatchAllRef = React.useRef(false);
  var isSubmittedRef = React.useRef(false);
  var isDirtyRef = React.useRef(false);
  var submitCountRef = React.useRef(0);
  var isSubmittingRef = React.useRef(false);
  var handleChangeRef = React.useRef();
  var resetFieldArrayFunctionRef = React.useRef({});
  var validationContextRef = React.useRef(validationContext);
  var fieldArrayNamesRef = React.useRef(new set$4());

  var _g = __read(React.useState(), 2),
      render = _g[1];

  var _h = React.useRef(modeChecker(mode)).current,
      isOnBlur = _h.isOnBlur,
      isOnSubmit = _h.isOnSubmit,
      isOnChange = _h.isOnChange;
  var validateAllFieldCriteria = validateCriteriaMode === 'all';
  var isWindowUndefined = typeof window === UNDEFINED;
  var shouldValidateSchemaOrResolver = !!(validationSchema || validationResolver);
  var isWeb = typeof document !== UNDEFINED && !isWindowUndefined && !isUndefined(window.HTMLElement);
  var isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;
  var readFormStateRef = React.useRef({
    dirty: !isProxyEnabled,
    dirtyFields: !isProxyEnabled,
    isSubmitted: isOnSubmit,
    submitCount: !isProxyEnabled,
    touched: !isProxyEnabled,
    isSubmitting: !isProxyEnabled,
    isValid: !isProxyEnabled
  });
  var _j = React.useRef(modeChecker(reValidateMode)).current,
      isReValidateOnBlur = _j.isOnBlur,
      isReValidateOnSubmit = _j.isOnSubmit;
  validationContextRef.current = validationContext;
  var reRender = React.useCallback(function () {
    if (!isUnMount.current) {
      render({});
    }
  }, []);
  var shouldRenderBaseOnError = React.useCallback(function (name, error, shouldRender) {
    if (shouldRender === void 0) {
      shouldRender = false;
    }

    var shouldReRender = shouldRender || shouldRenderBasedOnError({
      errors: errorsRef.current,
      error: error,
      name: name,
      validFields: validFieldsRef.current,
      fieldsWithValidation: fieldsWithValidationRef.current
    });

    if (isEmptyObject(error)) {
      if (fieldsWithValidationRef.current.has(name) || shouldValidateSchemaOrResolver) {
        validFieldsRef.current.add(name);
        shouldReRender = shouldReRender || get$1(errorsRef.current, name);
      }

      errorsRef.current = unset(errorsRef.current, [name]);
    } else {
      validFieldsRef.current.delete(name);
      shouldReRender = shouldReRender || !get$1(errorsRef.current, name);
      set$5(errorsRef.current, name, error[name]);
    }

    if (shouldReRender && !isNullOrUndefined(shouldRender)) {
      reRender();
      return true;
    }
  }, [reRender, shouldValidateSchemaOrResolver]);
  var setFieldValue = React.useCallback(function (field, rawValue) {
    var ref = field.ref,
        options = field.options;
    var value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? '' : rawValue;

    if (isRadioInput(ref) && options) {
      forEach$2(options).call(options, function (_a) {
        var radioRef = _a.ref;
        return radioRef.checked = radioRef.value === value;
      });
    } else if (isFileInput(ref)) {
      if (isString(value)) {
        ref.value = value;
      } else {
        ref.files = value;
      }
    } else if (isMultipleSelect(ref)) {
      var _context;

      forEach$2(_context = __spread(ref.options)).call(_context, function (selectRef) {
        return selectRef.selected = includes$4(value).call(value, selectRef.value);
      });
    } else if (isCheckBoxInput(ref) && options) {
      options.length > 1 ? forEach$2(options).call(options, function (_a) {
        var checkboxRef = _a.ref;
        return checkboxRef.checked = includes$4(value).call(value, checkboxRef.value);
      }) : options[0].ref.checked = !!value;
    } else {
      ref.value = value;
    }
  }, [isWeb]);

  var setDirty = function (name) {
    if (!fieldsRef.current[name] || !readFormStateRef.current.dirty && !readFormStateRef.current.dirtyFields) {
      return false;
    }

    var isFieldDirty = defaultValuesAtRenderRef.current[name] !== getFieldValue(fieldsRef.current, fieldsRef.current[name].ref);
    var isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);
    var previousDirtyFieldsLength = dirtyFieldsRef.current.size;

    if (isFieldArray) {
      var fieldArrayName = getFieldArrayParentName(name);
      isFieldDirty = getIsFieldsDifferent(getFieldValueByName(fieldsRef.current, fieldArrayName), get$1(defaultValuesRef.current, fieldArrayName));
    }

    var isDirtyChanged = (isFieldArray ? isDirtyRef.current : dirtyFieldsRef.current.has(name)) !== isFieldDirty;

    if (isFieldDirty) {
      dirtyFieldsRef.current.add(name);
    } else {
      dirtyFieldsRef.current.delete(name);
    }

    isDirtyRef.current = isFieldArray ? isFieldDirty : !!dirtyFieldsRef.current.size;
    return readFormStateRef.current.dirty ? isDirtyChanged : previousDirtyFieldsLength !== dirtyFieldsRef.current.size;
  };

  var setDirtyAndTouchedFields = React.useCallback(function (fieldName) {
    if (setDirty(fieldName) || !get$1(touchedFieldsRef.current, fieldName) && readFormStateRef.current.touched) {
      return !!set$5(touchedFieldsRef.current, fieldName, true);
    }
  }, []);
  var setInternalValues = React.useCallback(function (name, value, parentFieldName) {
    var isValueArray = isArray$4(value);

    for (var key in value) {
      var fieldName = "" + (parentFieldName || name) + (isValueArray ? "[" + key + "]" : "." + key);
      var field = fieldsRef.current[fieldName];

      if (isObject$1(value[key])) {
        setInternalValues(name, value[key], fieldName);
      }

      if (field) {
        setFieldValue(field, value[key]);
        setDirtyAndTouchedFields(fieldName);
      }
    }
  }, [setFieldValue, setDirtyAndTouchedFields]);
  var setInternalValue = React.useCallback(function (name, value) {
    var field = fieldsRef.current[name];

    if (field) {
      setFieldValue(field, value);
      var output = setDirtyAndTouchedFields(name);

      if (isBoolean(output)) {
        return output;
      }
    } else if (!isPrimitive(value)) {
      setInternalValues(name, value);
    }
  }, [setDirtyAndTouchedFields, setFieldValue, setInternalValues]);
  var executeValidation = React.useCallback(function (name, skipReRender) {
    return __awaiter(_this, void 0, void 0, function () {
      var field, error;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            field = fieldsRef.current[name];
            if (!field) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , validateField(fieldsRef, validateAllFieldCriteria, field)];

          case 1:
            error = _a.sent();
            shouldRenderBaseOnError(name, error, skipReRender ? null : false);
            return [2
            /*return*/
            , isEmptyObject(error)];

          case 2:
            return [2
            /*return*/
            , false];
        }
      });
    });
  }, [shouldRenderBaseOnError, validateAllFieldCriteria]);
  var executeSchemaOrResolverValidation = React.useCallback(function (payload) {
    return __awaiter(_this, void 0, void 0, function () {
      var errors, previousFormIsValid, error;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , validateWithSchema(validationSchema, validateAllFieldCriteria, getFieldValueByName(fieldsRef.current), validationResolver, validationContextRef.current)];

          case 1:
            errors = _b.sent().errors;
            previousFormIsValid = isValidRef.current;
            isValidRef.current = isEmptyObject(errors);

            if (isArray$4(payload)) {
              forEach$2(payload).call(payload, function (name) {
                var error = get$1(errors, name);

                if (error) {
                  set$5(errorsRef.current, name, error);
                } else {
                  unset(errorsRef.current, [name]);
                }
              });

              reRender();
            } else {
              error = get$1(errors, payload);
              shouldRenderBaseOnError(payload, error ? (_a = {}, _a[payload] = error, _a) : {}, previousFormIsValid !== isValidRef.current);
            }

            return [2
            /*return*/
            , isEmptyObject(errorsRef.current)];
        }
      });
    });
  }, [reRender, shouldRenderBaseOnError, validateAllFieldCriteria, validationResolver, validationSchema]);
  var triggerValidation = React.useCallback(function (payload) {
    return __awaiter(_this, void 0, void 0, function () {
      var fields, result;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            fields = payload || keys$3(fieldsRef.current);

            if (shouldValidateSchemaOrResolver) {
              return [2
              /*return*/
              , executeSchemaOrResolverValidation(fields)];
            }

            if (!isArray$4(fields)) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , promise$3.all(map$2(fields).call(fields, function (data) {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4
                      /*yield*/
                      , executeValidation(data, true)];

                    case 1:
                      return [2
                      /*return*/
                      , _a.sent()];
                  }
                });
              });
            }))];

          case 1:
            result = _a.sent();
            reRender();
            return [2
            /*return*/
            , every$2(result).call(result, Boolean)];

          case 2:
            return [4
            /*yield*/
            , executeValidation(fields)];

          case 3:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  }, [executeSchemaOrResolverValidation, executeValidation, reRender, shouldValidateSchemaOrResolver]);

  var isFieldWatched = function (name) {
    return isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
  };

  function setValue(names, valueOrShouldValidate, shouldValidate) {
    var _context2;

    var shouldRender = false;
    var isArrayValue = isArray$4(names);

    forEach$2(_context2 = isArrayValue ? names : [names]).call(_context2, function (name) {
      var isStringFieldName = isString(name);
      shouldRender = setInternalValue(isStringFieldName ? name : keys$3(name)[0], isStringFieldName ? valueOrShouldValidate : values$5(name)[0]) || isArrayValue ? true : isFieldWatched(name);
    });

    if (shouldRender || isArrayValue) {
      reRender();
    }

    if (shouldValidate || isArrayValue && valueOrShouldValidate) {
      triggerValidation(isArrayValue ? undefined : names);
    }
  }

  handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : function (_a) {
    var type = _a.type,
        target = _a.target;
    return __awaiter(_this, void 0, void 0, function () {
      var name, fields, errors, field, currentError, error, isBlurEvent, shouldSkipValidation, shouldUpdateDirty, shouldRender, errors_1, previousFormIsValid;

      var _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            name = target ? target.name : '';
            fields = fieldsRef.current;
            errors = errorsRef.current;
            field = fields[name];
            currentError = get$1(errors, name);

            if (!field) {
              return [2
              /*return*/
              ];
            }

            isBlurEvent = type === EVENTS.BLUR;
            shouldSkipValidation = skipValidation({
              hasError: !!currentError,
              isOnChange: isOnChange,
              isBlurEvent: isBlurEvent,
              isOnSubmit: isOnSubmit,
              isReValidateOnSubmit: isReValidateOnSubmit,
              isOnBlur: isOnBlur,
              isReValidateOnBlur: isReValidateOnBlur,
              isSubmitted: isSubmittedRef.current
            });
            shouldUpdateDirty = setDirty(name);
            shouldRender = isFieldWatched(name) || shouldUpdateDirty;

            if (isBlurEvent && !get$1(touchedFieldsRef.current, name) && readFormStateRef.current.touched) {
              set$5(touchedFieldsRef.current, name, true);
              shouldRender = true;
            }

            if (shouldSkipValidation) {
              return [2
              /*return*/
              , shouldRender && reRender()];
            }

            if (!shouldValidateSchemaOrResolver) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , validateWithSchema(validationSchema, validateAllFieldCriteria, getFieldValueByName(fields), validationResolver, validationContextRef.current)];

          case 1:
            errors_1 = _c.sent().errors;
            previousFormIsValid = isValidRef.current;
            isValidRef.current = isEmptyObject(errors_1);
            error = get$1(errors_1, name) ? (_b = {}, _b[name] = get$1(errors_1, name), _b) : {};

            if (previousFormIsValid !== isValidRef.current) {
              shouldRender = true;
            }

            return [3
            /*break*/
            , 4];

          case 2:
            return [4
            /*yield*/
            , validateField(fieldsRef, validateAllFieldCriteria, field)];

          case 3:
            error = _c.sent();
            _c.label = 4;

          case 4:
            if (!shouldRenderBaseOnError(name, error) && shouldRender) {
              reRender();
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  var validateSchemaOrResolver = React.useCallback(function (values) {
    if (values === void 0) {
      values = {};
    }

    var fieldValues = isEmptyObject(defaultValuesRef.current) ? getFieldsValues(fieldsRef.current) : defaultValuesRef.current;
    validateWithSchema(validationSchema, validateAllFieldCriteria, transformToNestObject(__assign(__assign({}, fieldValues), values)), validationResolver, validationContextRef.current).then(function (_a) {
      var errors = _a.errors;
      var previousFormIsValid = isValidRef.current;
      isValidRef.current = isEmptyObject(errors);

      if (previousFormIsValid !== isValidRef.current) {
        reRender();
      }
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [reRender, validateAllFieldCriteria, validationResolver]);
  var removeFieldEventListener = React.useCallback(function (field, forceDelete) {
    if (handleChangeRef.current && field) {
      findRemovedFieldAndRemoveListener(fieldsRef.current, handleChangeRef.current, field, forceDelete);
    }
  }, []);
  var removeFieldEventListenerAndRef = React.useCallback(function (field, forceDelete) {
    var _context3;

    if (!field || field && isNameInFieldArray(fieldArrayNamesRef.current, field.ref.name) && !forceDelete) {
      return;
    }

    removeFieldEventListener(field, forceDelete);
    var name = field.ref.name;
    errorsRef.current = unset(errorsRef.current, [name]);
    touchedFieldsRef.current = unset(touchedFieldsRef.current, [name]);
    defaultValuesAtRenderRef.current = unset(defaultValuesAtRenderRef.current, [name]);

    forEach$2(_context3 = [dirtyFieldsRef, fieldsWithValidationRef, validFieldsRef, watchFieldsRef]).call(_context3, function (data) {
      return data.current.delete(name);
    });

    if (readFormStateRef.current.isValid || readFormStateRef.current.touched) {
      reRender();

      if (shouldValidateSchemaOrResolver) {
        validateSchemaOrResolver();
      }
    }
  }, [reRender, shouldValidateSchemaOrResolver, validateSchemaOrResolver, removeFieldEventListener]);

  function clearError(name) {
    if (name) {
      unset(errorsRef.current, isArray$4(name) ? name : [name]);
    } else {
      errorsRef.current = {};
    }

    reRender();
  }

  var setInternalError = function (_a) {
    var name = _a.name,
        type = _a.type,
        types = _a.types,
        message = _a.message,
        shouldRender = _a.shouldRender;
    var field = fieldsRef.current[name];

    if (!isSameError(errorsRef.current[name], {
      type: type,
      message: message,
      types: types
    })) {
      set$5(errorsRef.current, name, {
        type: type,
        types: types,
        message: message,
        ref: field ? field.ref : {},
        isManual: true
      });

      if (shouldRender) {
        reRender();
      }
    }
  };

  function setError(name, type, message) {
    if (type === void 0) {
      type = '';
    }

    if (isString(name)) {
      setInternalError(__assign(__assign({
        name: name
      }, isObject$1(type) ? {
        types: type,
        type: ''
      } : {
        type: type,
        message: message
      }), {
        shouldRender: true
      }));
    } else if (isArray$4(name)) {
      forEach$2(name).call(name, function (error) {
        return setInternalError(__assign({}, error));
      });

      reRender();
    }
  }

  function watch(fieldNames, defaultValue) {
    var watchFields = watchFieldsRef.current;
    var isDefaultValueUndefined = isUndefined(defaultValue);
    var combinedDefaultValues = isDefaultValueUndefined ? defaultValuesRef.current : defaultValue;
    var fieldValues = getFieldsValues(fieldsRef.current, fieldNames);

    if (isString(fieldNames)) {
      return assignWatchFields(fieldValues, fieldNames, watchFields, isDefaultValueUndefined ? get$1(combinedDefaultValues, fieldNames) : defaultValue, true);
    }

    if (isArray$4(fieldNames)) {
      return reduce$2(fieldNames).call(fieldNames, function (previous, name) {
        var _a;

        return __assign(__assign({}, previous), (_a = {}, _a[name] = assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues), _a));
      }, {});
    }

    isWatchAllRef.current = true;
    var result = !isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues;
    return fieldNames && fieldNames.nest ? transformToNestObject(result) : result;
  }

  function unregister(name) {
    if (fieldsRef.current) {
      var _context4;

      forEach$2(_context4 = isArray$4(name) ? name : [name]).call(_context4, function (fieldName) {
        return removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
      });
    }
  }

  function registerFieldsRef(ref, validateOptions) {
    var _context5, _context6;

    if (validateOptions === void 0) {
      validateOptions = {};
    }

    if (!ref.name) {
      // eslint-disable-next-line no-console
      return console.warn('Missing name @', ref);
    }

    var name = ref.name,
        type = ref.type,
        value = ref.value;

    var fieldRefAndValidationOptions = __assign({
      ref: ref
    }, validateOptions);

    var fields = fieldsRef.current;
    var isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
    var field = fields[name];
    var isEmptyDefaultValue = true;
    var isFieldArray;
    var defaultValue;

    if (isRadioOrCheckbox ? field && isArray$4(field.options) && find$2(_context5 = filter$2(_context6 = field.options).call(_context6, Boolean)).call(_context5, function (option) {
      return value === option.ref.value && option.ref === ref;
    }) : field && ref === field.ref) {
      fields[name] = __assign(__assign({}, field), validateOptions);
      return;
    }

    if (type) {
      var mutationWatcher = onDomRemove(ref, function () {
        return removeFieldEventListenerAndRef(field);
      });
      field = isRadioOrCheckbox ? __assign({
        options: __spread(field && field.options || [], [{
          ref: ref,
          mutationWatcher: mutationWatcher
        }]),
        ref: {
          type: type,
          name: name
        }
      }, validateOptions) : __assign(__assign({}, fieldRefAndValidationOptions), {
        mutationWatcher: mutationWatcher
      });
    } else {
      field = fieldRefAndValidationOptions;
    }

    fields[name] = field;

    if (!isEmptyObject(defaultValuesRef.current)) {
      defaultValue = get$1(defaultValuesRef.current, name);
      isEmptyDefaultValue = isUndefined(defaultValue);
      isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);

      if (!isEmptyDefaultValue && !isFieldArray) {
        setFieldValue(field, defaultValue);
      }
    }

    if (shouldValidateSchemaOrResolver && !isFieldArray && readFormStateRef.current.isValid) {
      validateSchemaOrResolver();
    } else if (!isEmptyObject(validateOptions)) {
      fieldsWithValidationRef.current.add(name);

      if (!isOnSubmit && readFormStateRef.current.isValid) {
        validateField(fieldsRef, validateAllFieldCriteria, field).then(function (error) {
          var previousFormIsValid = isValidRef.current;
          isEmptyObject(error) ? validFieldsRef.current.add(name) : isValidRef.current = false;

          if (previousFormIsValid !== isValidRef.current) {
            reRender();
          }
        });
      }
    }

    if (!defaultValuesAtRenderRef.current[name] && !(isFieldArray && isEmptyDefaultValue)) {
      defaultValuesAtRenderRef.current[name] = isEmptyDefaultValue ? getFieldValue(fields, field.ref) : defaultValue;
    }

    if (type) {
      attachEventListeners({
        field: isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field,
        isRadioOrCheckbox: isRadioOrCheckbox,
        handleChange: handleChangeRef.current
      });
    }
  }

  function register(refOrValidationOptions, validationOptions) {
    if (isWindowUndefined) {
      return;
    }

    if (isString(refOrValidationOptions)) {
      registerFieldsRef({
        name: refOrValidationOptions
      }, validationOptions);
      return;
    }

    if (isObject$1(refOrValidationOptions) && 'name' in refOrValidationOptions) {
      registerFieldsRef(refOrValidationOptions, validationOptions);
      return;
    }

    return function (ref) {
      return ref && registerFieldsRef(ref, refOrValidationOptions);
    };
  }

  var handleSubmit = React.useCallback(function (callback) {
    return function (e) {
      return __awaiter(_this, void 0, void 0, function () {
        var fieldErrors, fields, fieldValues, _a, errors, values, _b, _c, field, name_1, fieldError, e_1_1;

        var e_1, _d;

        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (e) {
                e.preventDefault();
                e.persist();
              }

              fieldErrors = {};
              fields = fieldsRef.current;
              fieldValues = getFieldsValues(fields);

              if (readFormStateRef.current.isSubmitting) {
                isSubmittingRef.current = true;
                reRender();
              }

              _e.label = 1;

            case 1:
              _e.trys.push([1,, 14, 15]);

              if (!shouldValidateSchemaOrResolver) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , validateWithSchema(validationSchema, validateAllFieldCriteria, transformToNestObject(fieldValues), validationResolver, validationContextRef.current)];

            case 2:
              _a = _e.sent(), errors = _a.errors, values = values$2(_a);
              errorsRef.current = errors;
              fieldErrors = errors;
              fieldValues = values;
              return [3
              /*break*/
              , 10];

            case 3:
              _e.trys.push([3, 8, 9, 10]);

              _b = __values(values$5(fields)), _c = _b.next();
              _e.label = 4;

            case 4:
              if (!!_c.done) return [3
              /*break*/
              , 7];
              field = _c.value;
              if (!field) return [3
              /*break*/
              , 6];
              name_1 = field.ref.name;
              return [4
              /*yield*/
              , validateField(fieldsRef, validateAllFieldCriteria, field)];

            case 5:
              fieldError = _e.sent();

              if (fieldError[name_1]) {
                set$5(fieldErrors, name_1, fieldError[name_1]);
                validFieldsRef.current.delete(name_1);
              } else {
                if (fieldsWithValidationRef.current.has(name_1)) {
                  validFieldsRef.current.add(name_1);
                }
              }

              _e.label = 6;

            case 6:
              _c = _b.next();
              return [3
              /*break*/
              , 4];

            case 7:
              return [3
              /*break*/
              , 10];

            case 8:
              e_1_1 = _e.sent();
              e_1 = {
                error: e_1_1
              };
              return [3
              /*break*/
              , 10];

            case 9:
              try {
                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
              } finally {
                if (e_1) throw e_1.error;
              }

              return [7
              /*endfinally*/
              ];

            case 10:
              if (!isEmptyObject(fieldErrors)) return [3
              /*break*/
              , 12];
              errorsRef.current = {};
              reRender();
              return [4
              /*yield*/
              , callback(transformToNestObject(fieldValues), e)];

            case 11:
              _e.sent();

              return [3
              /*break*/
              , 13];

            case 12:
              errorsRef.current = fieldErrors;

              if (submitFocusError && isWeb) {
                focusOnErrorField(fields, fieldErrors);
              }

              _e.label = 13;

            case 13:
              return [3
              /*break*/
              , 15];

            case 14:
              isSubmittedRef.current = true;
              isSubmittingRef.current = false;
              submitCountRef.current = submitCountRef.current + 1;
              reRender();
              return [7
              /*endfinally*/
              ];

            case 15:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
  }, [isWeb, reRender, shouldValidateSchemaOrResolver, submitFocusError, validateAllFieldCriteria, validationResolver, validationSchema]);

  var resetRefs = function (_a) {
    var errors = _a.errors,
        dirty = _a.dirty,
        isSubmitted = _a.isSubmitted,
        touched = _a.touched,
        isValid = _a.isValid,
        submitCount = _a.submitCount,
        dirtyFields = _a.dirtyFields;
    fieldsRef.current = {};

    if (!errors) {
      errorsRef.current = {};
    }

    if (!touched) {
      touchedFieldsRef.current = {};
    }

    if (!isValid) {
      validFieldsRef.current = new set$4();
      fieldsWithValidationRef.current = new set$4();
      isValidRef.current = true;
    }

    if (!dirty) {
      isDirtyRef.current = false;
    }

    if (!dirtyFields) {
      dirtyFieldsRef.current = new set$4();
    }

    if (!isSubmitted) {
      isSubmittedRef.current = false;
    }

    if (!submitCount) {
      submitCountRef.current = 0;
    }

    defaultValuesAtRenderRef.current = {};
    fieldArrayDefaultValues.current = {};
    watchFieldsRef.current = new set$4();
    isWatchAllRef.current = false;
  };

  var reset = function (values, omitResetState) {
    var _context7;

    var e_2, _a;

    if (omitResetState === void 0) {
      omitResetState = {};
    }

    if (isWeb) {
      try {
        for (var _b = __values(values$5(fieldsRef.current)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var field = _c.value;

          if (field) {
            var ref = field.ref,
                options = field.options;
            var inputRef = isRadioOrCheckboxFunction(ref) && isArray$4(options) ? options[0].ref : ref;

            if (isHTMLElement(inputRef)) {
              try {
                inputRef.closest('form').reset();
                break;
              } catch (_d) {}
            }
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }

    if (values) {
      defaultValuesRef.current = values;
    }

    forEach$2(_context7 = values$5(resetFieldArrayFunctionRef.current)).call(_context7, function (resetFieldArray) {
      return isFunction(resetFieldArray) && resetFieldArray();
    });

    resetRefs(omitResetState);
    reRender();
  };

  function getValues(payload) {
    if (isString(payload)) {
      return fieldsRef.current[payload] ? getFieldValue(fieldsRef.current, fieldsRef.current[payload].ref) : get$1(defaultValuesRef.current, payload);
    }

    var fieldValues = getFieldsValues(fieldsRef.current);
    var outputValues = isEmptyObject(fieldValues) ? defaultValuesRef.current : fieldValues;
    return payload && payload.nest ? transformToNestObject(outputValues) : outputValues;
  }

  React.useEffect(function () {
    return function () {
      var _context8;

      isUnMount.current = true;
      fieldsRef.current && "production" === 'production' && forEach$2(_context8 = values$5(fieldsRef.current)).call(_context8, function (field) {
        return removeFieldEventListenerAndRef(field, true);
      });
    };
  }, [removeFieldEventListenerAndRef]);

  if (!shouldValidateSchemaOrResolver) {
    isValidRef.current = validFieldsRef.current.size >= fieldsWithValidationRef.current.size && isEmptyObject(errorsRef.current);
  }

  var formState = {
    dirty: isDirtyRef.current,
    dirtyFields: dirtyFieldsRef.current,
    isSubmitted: isSubmittedRef.current,
    submitCount: submitCountRef.current,
    touched: touchedFieldsRef.current,
    isSubmitting: isSubmittingRef.current,
    isValid: isOnSubmit ? isSubmittedRef.current && isEmptyObject(errorsRef.current) : isValidRef.current
  };
  var commonProps = {
    triggerValidation: triggerValidation,
    setValue: React.useCallback(setValue, [reRender, setInternalValue, triggerValidation]),
    register: React.useCallback(register, [defaultValuesRef.current, defaultValuesAtRenderRef.current]),
    unregister: React.useCallback(unregister, []),
    getValues: React.useCallback(getValues, []),
    formState: isProxyEnabled ? new Proxy(formState, {
      get: function (obj, prop) {
        if (prop in obj) {
          readFormStateRef.current[prop] = true;
          return obj[prop];
        }

        return undefined;
      }
    }) : formState
  };

  var control = __assign(__assign(__assign({
    removeFieldEventListener: removeFieldEventListener,
    reRender: reRender
  }, shouldValidateSchemaOrResolver ? {
    validateSchemaIsValid: validateSchemaOrResolver
  } : {}), {
    mode: {
      isOnBlur: isOnBlur,
      isOnSubmit: isOnSubmit,
      isOnChange: isOnChange
    },
    reValidateMode: {
      isReValidateOnBlur: isReValidateOnBlur,
      isReValidateOnSubmit: isReValidateOnSubmit
    },
    errorsRef: errorsRef,
    touchedFieldsRef: touchedFieldsRef,
    fieldsRef: fieldsRef,
    isWatchAllRef: isWatchAllRef,
    watchFieldsRef: watchFieldsRef,
    resetFieldArrayFunctionRef: resetFieldArrayFunctionRef,
    fieldArrayDefaultValues: fieldArrayDefaultValues,
    validFieldsRef: validFieldsRef,
    dirtyFieldsRef: dirtyFieldsRef,
    fieldsWithValidationRef: fieldsWithValidationRef,
    fieldArrayNamesRef: fieldArrayNamesRef,
    isDirtyRef: isDirtyRef,
    readFormStateRef: readFormStateRef,
    defaultValuesRef: defaultValuesRef
  }), commonProps);

  return __assign({
    watch: watch,
    control: control,
    handleSubmit: handleSubmit,
    reset: React.useCallback(reset, []),
    clearError: React.useCallback(clearError, []),
    setError: React.useCallback(setError, []),
    errors: errorsRef.current
  }, commonProps);
}

var test$1 = [];
var nativeSort = test$1.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD$5 = arrayMethodIsStrict('sort');

var FORCED$2 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$5;

// `Array.prototype.sort` method
// https://tc39.github.io/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED$2 }, {
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? nativeSort.call(toObject(this))
      : nativeSort.call(toObject(this), aFunction(comparefn));
  }
});

var sort = entryVirtual('Array').sort;

var ArrayPrototype$d = Array.prototype;

var sort_1 = function (it) {
  var own = it.sort;
  return it === ArrayPrototype$d || (it instanceof Array && own === ArrayPrototype$d.sort) ? sort : own;
};

var sort$1 = sort_1;

var sort$2 = sort$1;

var FormGlobalContext = React.createContext(null);
function useFormContext() {
  return React.useContext(FormGlobalContext);
}
function FormContext(_a) {
  var children = _a.children,
      formState = _a.formState,
      errors = _a.errors,
      restMethods = __rest(_a, ["children", "formState", "errors"]);

  return React.createElement(FormGlobalContext.Provider, {
    value: __assign(__assign({}, restMethods), {
      formState: formState,
      errors: errors
    })
  }, children);
}

// `Date.now` method
// https://tc39.github.io/ecma262/#sec-date.now
_export({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});

var now = path.Date.now;

var now$1 = now;

var now$2 = now$1;

var generateId = (function () {
  var d = typeof performance === UNDEFINED ? now$2() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
});

var appendId = function (value, keyName) {
  var _a;

  return __assign((_a = {}, _a[keyName] = generateId(), _a), isObject$1(value) ? value : {
    value: value
  });
};
var mapIds = function (data, keyName) {
  var _context;

  return map$2(_context = isArray$4(data) ? data : []).call(_context, function (value) {
    return appendId(value, keyName);
  });
};

var getSortRemovedItems = (function (indexes, removeIndexes, updatedIndexes, count, notFoundIndexes) {
  var e_1, _a, e_2, _b;

  if (updatedIndexes === void 0) {
    updatedIndexes = [];
  }

  if (count === void 0) {
    count = 0;
  }

  if (notFoundIndexes === void 0) {
    notFoundIndexes = [];
  }

  try {
    for (var removeIndexes_1 = __values(removeIndexes), removeIndexes_1_1 = removeIndexes_1.next(); !removeIndexes_1_1.done; removeIndexes_1_1 = removeIndexes_1.next()) {
      var removeIndex = removeIndexes_1_1.value;

      if (indexOf$3(indexes).call(indexes, removeIndex) < 0) {
        notFoundIndexes.push(removeIndex);
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (removeIndexes_1_1 && !removeIndexes_1_1.done && (_a = removeIndexes_1.return)) _a.call(removeIndexes_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  var _loop_1 = function (index) {
    if (indexOf$3(removeIndexes).call(removeIndexes, index) > -1) {
      updatedIndexes.push(-1);
      count++;
    } else {
      var _context;

      updatedIndexes.push(index - count - (notFoundIndexes.length ? filter$2(_context = map$2(notFoundIndexes).call(notFoundIndexes, function (notFoundIndex) {
        return notFoundIndex < index;
      })).call(_context, Boolean).length : 0));
    }
  };

  try {
    for (var _c = __values(sort$2(indexes).call(indexes)), _d = _c.next(); !_d.done; _d = _c.next()) {
      var index = _d.value;

      _loop_1(index);
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  return updatedIndexes;
});

var removeAt = function (data, index) {
  return __spread(slice$2(data).call(data, 0, index), slice$2(data).call(data, index + 1));
};

function removeAtIndexes(data, index) {
  var k = -1;

  while (++k < data.length) {
    if (indexOf$3(index).call(index, k) >= 0) {
      delete data[k];
    }
  }

  return filter$2(data).call(data, Boolean);
}

var removeArrayAt = (function (data, index) {
  return isUndefined(index) ? [] : isArray$4(index) ? removeAtIndexes(data, index) : removeAt(data, index);
});

var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH$a = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max$2 = Math.max;
var min$3 = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 || !USES_TO_LENGTH$a }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$3(max$2(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

var splice = entryVirtual('Array').splice;

var ArrayPrototype$e = Array.prototype;

var splice_1 = function (it) {
  var own = it.splice;
  return it === ArrayPrototype$e || (it instanceof Array && own === ArrayPrototype$e.splice) ? splice : own;
};

var splice$1 = splice_1;

var splice$2 = splice$1;

var moveArrayAt = (function (data, from, to) {
  return isArray$4(data) ? splice$2(data).call(data, to, 0, splice$2(data).call(data, from, 1)[0]) : [];
});

var swapArrayAt = (function (data, indexA, indexB) {
  var temp = [data[indexB], data[indexA]];
  data[indexA] = temp[0];
  data[indexB] = temp[1];
});

function prepend(data, value) {
  return __spread(isArray$4(value) ? value : [value || null], data);
}

function insert(data, index, value) {
  return __spread(slice$2(data).call(data, 0, index), isArray$4(value) ? value : [value || null], slice$2(data).call(data, index));
}

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

// `Array.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
_export({ target: 'Array', proto: true }, {
  fill: arrayFill
});

var fill = entryVirtual('Array').fill;

var ArrayPrototype$f = Array.prototype;

var fill_1 = function (it) {
  var own = it.fill;
  return it === ArrayPrototype$f || (it instanceof Array && own === ArrayPrototype$f.fill) ? fill : own;
};

var fill$1 = fill_1;

var fill$2 = fill$1;

var fillEmptyArray = (function (value) {
  var _context;

  return isArray$4(value) ? fill$2(_context = Array(value.length)).call(_context, null) : null;
});

var useFieldArray = function (_a) {
  var control = _a.control,
      name = _a.name,
      _b = _a.keyName,
      keyName = _b === void 0 ? 'id' : _b;
  var methods = useFormContext();

  var _c = control || methods.control,
      isWatchAllRef = _c.isWatchAllRef,
      resetFieldArrayFunctionRef = _c.resetFieldArrayFunctionRef,
      fieldArrayNamesRef = _c.fieldArrayNamesRef,
      reRender = _c.reRender,
      fieldsRef = _c.fieldsRef,
      getValues = _c.getValues,
      defaultValuesRef = _c.defaultValuesRef,
      removeFieldEventListener = _c.removeFieldEventListener,
      errorsRef = _c.errorsRef,
      dirtyFieldsRef = _c.dirtyFieldsRef,
      isDirtyRef = _c.isDirtyRef,
      touchedFieldsRef = _c.touchedFieldsRef,
      readFormStateRef = _c.readFormStateRef,
      watchFieldsRef = _c.watchFieldsRef,
      validFieldsRef = _c.validFieldsRef,
      fieldsWithValidationRef = _c.fieldsWithValidationRef,
      fieldArrayDefaultValues = _c.fieldArrayDefaultValues,
      validateSchemaIsValid = _c.validateSchemaIsValid;

  var getDefaultValues = function () {
    return __spread(get$1(fieldArrayDefaultValues.current[getFieldArrayParentName(name)] ? fieldArrayDefaultValues.current : defaultValuesRef.current, name, []));
  };

  var memoizedDefaultValues = React.useRef(getDefaultValues());

  var _d = __read(React.useState(mapIds(memoizedDefaultValues.current, keyName)), 2),
      fields = _d[0],
      setField = _d[1];

  var _e = __read(React.useState(false), 2),
      isDeleted = _e[0],
      setIsDeleted = _e[1];

  var allFields = React.useRef(fields);
  var isNameKey = isKey(name);
  allFields.current = fields;

  if (isNameKey) {
    fieldArrayDefaultValues.current[name] = memoizedDefaultValues.current;
  }

  var appendValueWithKey = function (values) {
    return map$2(values).call(values, function (value) {
      return appendId(value, keyName);
    });
  };

  var setFieldAndValidState = function (fieldsValues) {
    var _a;

    setField(fieldsValues);

    if (readFormStateRef.current.isValid && validateSchemaIsValid) {
      validateSchemaIsValid((_a = {}, _a[name] = fieldsValues, _a));
    }
  };

  var modifyDirtyFields = function (_a) {
    var e_1, _b;

    var _c = _a === void 0 ? {} : _a,
        shouldRender = _c.shouldRender,
        isRemove = _c.isRemove,
        isPrePend = _c.isPrePend,
        index = _c.index,
        _d = _c.value,
        value = _d === void 0 ? {} : _d;

    var render = shouldRender;
    var values = isArray$4(value) ? value : [value];

    if (readFormStateRef.current.dirty) {
      var dirtyFieldIndexesAndValues = {};

      if (isPrePend || isRemove) {
        try {
          for (var _e = __values(sort$2(_context = __spread(dirtyFieldsRef.current)).call(_context)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var _context;

            var dirtyField = _f.value;

            if (isMatchFieldArrayName(dirtyField, name)) {
              var matchedIndexes = dirtyField.match(REGEX_ARRAY_FIELD_INDEX);

              if (matchedIndexes) {
                var matchIndex = +matchedIndexes[matchedIndexes.length - 1];

                if (dirtyFieldIndexesAndValues[matchIndex]) {
                  dirtyFieldIndexesAndValues[matchIndex].push(dirtyField);
                } else {
                  dirtyFieldIndexesAndValues[matchIndex] = [dirtyField];
                }
              }

              dirtyFieldsRef.current.delete(dirtyField);
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }

      if (!isUndefined(index) || isPrePend) {
        var _context2, _context3;

        var updatedDirtyFieldIndexes_1 = isUndefined(index) ? [] : getSortRemovedItems(map$2(_context2 = keys$3(dirtyFieldIndexesAndValues)).call(_context2, function (i) {
          return +i;
        }), isArray$4(index) ? index : [index]);

        forEach$2(_context3 = values$5(dirtyFieldIndexesAndValues)).call(_context3, function (values, index) {
          var e_2, _a;

          var updateIndex = isPrePend ? 0 : updatedDirtyFieldIndexes_1[index];

          if (updateIndex > -1) {
            try {
              for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                var value_1 = values_1_1.value;
                var matchedIndexes = value_1.match(REGEX_ARRAY_FIELD_INDEX);

                if (matchedIndexes) {
                  dirtyFieldsRef.current.add(value_1.replace(/[\d+]([^[\d+]+)$/, (isPrePend ? +matchedIndexes[matchedIndexes.length - 1] + values.length : updateIndex) + "$1"));
                }
              }
            } catch (e_2_1) {
              e_2 = {
                error: e_2_1
              };
            } finally {
              try {
                if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
              } finally {
                if (e_2) throw e_2.error;
              }
            }
          }
        });
      }

      if (!isRemove) {
        forEach$2(values).call(values, function (fieldValue, index) {
          var _context4;

          return forEach$2(_context4 = keys$3(fieldValue)).call(_context4, function (key) {
            return dirtyFieldsRef.current.add(name + "[" + (isPrePend ? index : allFields.current.length + index) + "]." + key);
          });
        });

        isDirtyRef.current = true;
      }

      render = true;
    }

    if (render && !isWatchAllRef.current) {
      reRender();
    }
  };

  var resetFields = function (flagOrFields) {
    if (readFormStateRef.current.dirty) {
      isDirtyRef.current = isUndefined(flagOrFields) ? true : getIsFieldsDifferent(flagOrFields, defaultValuesRef.current[name] || []);
    }

    for (var key in fieldsRef.current) {
      if (isMatchFieldArrayName(key, name) && fieldsRef.current[key]) {
        removeFieldEventListener(fieldsRef.current[key], true);
      }
    }
  };

  var mapCurrentFieldsValueWithState = function () {
    var currentFieldsValue = get$1(getValues({
      nest: true
    }), name);

    if (isArray$4(currentFieldsValue)) {
      for (var i = 0; i < currentFieldsValue.length; i++) {
        allFields.current[i] = __assign(__assign({}, allFields.current[i]), currentFieldsValue[i]);
      }
    }
  };

  var append = function (value) {
    setFieldAndValidState(__spread(allFields.current, isArray$4(value) ? appendValueWithKey(value) : [appendId(value, keyName)]));
    modifyDirtyFields({
      value: value
    });
  };

  var prepend$1 = function (value) {
    var shouldRender = false;
    resetFields();
    setFieldAndValidState(prepend(allFields.current, isArray$4(value) ? appendValueWithKey(value) : [appendId(value, keyName)]));

    if (errorsRef.current[name]) {
      errorsRef.current[name] = prepend(errorsRef.current[name], fillEmptyArray(value));
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      touchedFieldsRef.current[name] = prepend(touchedFieldsRef.current[name], fillEmptyArray(value));
      shouldRender = true;
    }

    modifyDirtyFields({
      shouldRender: shouldRender,
      isPrePend: true,
      value: value
    });
  };

  var remove = function (index) {
    var shouldRender = false;
    var isIndexUndefined = isUndefined(index);

    if (!isIndexUndefined) {
      mapCurrentFieldsValueWithState();
    }

    resetFields(removeArrayAt(getFieldValueByName(fieldsRef.current, name), index));
    setFieldAndValidState(removeArrayAt(allFields.current, index));
    setIsDeleted(true);

    if (errorsRef.current[name]) {
      var _context5;

      errorsRef.current[name] = removeArrayAt(errorsRef.current[name], index);

      if (!filter$2(_context5 = errorsRef.current[name]).call(_context5, Boolean).length) {
        delete errorsRef.current[name];
      }
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      touchedFieldsRef.current[name] = removeArrayAt(touchedFieldsRef.current[name], index);
      shouldRender = true;
    }

    if (readFormStateRef.current.isValid && !validateSchemaIsValid) {
      var fieldIndex = -1;
      var isFound = false;
      var isIndexUndefined_1 = isUndefined(index);

      while (fieldIndex++ < fields.length) {
        var _context6;

        var isLast = fieldIndex === fields.length - 1;
        var isCurrentIndex = indexOf$3(_context6 = isArray$4(index) ? index : [index]).call(_context6, fieldIndex) >= 0;

        if (isCurrentIndex || isIndexUndefined_1) {
          isFound = true;
        }

        if (!isFound) {
          continue;
        }

        for (var key in fields[fieldIndex]) {
          var currentFieldName = name + "[" + fieldIndex + "]." + key;

          if (isCurrentIndex || isLast || isIndexUndefined_1) {
            validFieldsRef.current.delete(currentFieldName);
            fieldsWithValidationRef.current.delete(currentFieldName);
          } else {
            var previousFieldName = name + "[" + (fieldIndex - 1) + "]." + key;

            if (validFieldsRef.current.has(currentFieldName)) {
              validFieldsRef.current.add(previousFieldName);
            }

            if (fieldsWithValidationRef.current.has(currentFieldName)) {
              fieldsWithValidationRef.current.add(previousFieldName);
            }
          }
        }
      }
    }

    modifyDirtyFields({
      shouldRender: shouldRender,
      isRemove: true,
      index: index
    });
  };

  var insert$1 = function (index, value) {
    mapCurrentFieldsValueWithState();
    resetFields(insert(getFieldValueByName(fieldsRef.current, name), index));
    setFieldAndValidState(insert(allFields.current, index, isArray$4(value) ? appendValueWithKey(value) : [appendId(value, keyName)]));

    if (errorsRef.current[name]) {
      errorsRef.current[name] = insert(errorsRef.current[name], index, fillEmptyArray(value));
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      touchedFieldsRef.current[name] = insert(touchedFieldsRef.current[name], index, fillEmptyArray(value));
      reRender();
    }
  };

  var swap = function (indexA, indexB) {
    mapCurrentFieldsValueWithState();
    var fieldValues = getFieldValueByName(fieldsRef.current, name);
    swapArrayAt(fieldValues, indexA, indexB);
    resetFields(fieldValues);
    swapArrayAt(allFields.current, indexA, indexB);
    setFieldAndValidState(__spread(allFields.current));

    if (errorsRef.current[name]) {
      swapArrayAt(errorsRef.current[name], indexA, indexB);
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      swapArrayAt(touchedFieldsRef.current[name], indexA, indexB);
      reRender();
    }
  };

  var move = function (from, to) {
    mapCurrentFieldsValueWithState();
    var fieldValues = getFieldValueByName(fieldsRef.current, name);
    moveArrayAt(fieldValues, from, to);
    resetFields(fieldValues);
    moveArrayAt(allFields.current, from, to);
    setFieldAndValidState(__spread(allFields.current));

    if (errorsRef.current[name]) {
      moveArrayAt(errorsRef.current[name], from, to);
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      moveArrayAt(touchedFieldsRef.current[name], from, to);
      reRender();
    }
  };

  var reset = function () {
    resetFields();
    memoizedDefaultValues.current = getDefaultValues();
    setField(mapIds(memoizedDefaultValues.current, keyName));
  };

  React.useEffect(function () {
    if (isNameKey && isDeleted && fieldArrayDefaultValues.current[name] && fields.length < fieldArrayDefaultValues.current[name].length) {
      fieldArrayDefaultValues.current[name].pop();
    }
  }, [fields, name, fieldArrayDefaultValues, isDeleted, isNameKey]);
  React.useEffect(function () {
    var e_3, _a;

    if (isWatchAllRef && isWatchAllRef.current) {
      reRender();
    } else if (watchFieldsRef) {
      try {
        for (var _b = __values(watchFieldsRef.current), _c = _b.next(); !_c.done; _c = _b.next()) {
          var watchField = _c.value;

          if (startsWith$2(watchField).call(watchField, name)) {
            reRender();
            break;
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    }
  }, [fields, name, reRender, watchFieldsRef, isWatchAllRef]);
  React.useEffect(function () {
    var resetFunctions = resetFieldArrayFunctionRef.current;
    var fieldArrayNames = fieldArrayNamesRef.current;
    fieldArrayNames.add(name);
    resetFunctions[name] = reset;
    return function () {
      resetFields();
      delete resetFunctions[name];
      fieldArrayNames.delete(name);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    swap: React.useCallback(swap, [name]),
    move: React.useCallback(move, [name]),
    prepend: React.useCallback(prepend$1, [name]),
    append: React.useCallback(append, [name]),
    remove: React.useCallback(remove, [fields, name]),
    insert: React.useCallback(insert$1, [name]),
    fields: fields
  };
};

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
_export({ target: 'Object', stat: true, forced: !descriptors, sham: !descriptors }, {
  defineProperty: objectDefineProperty.f
});

var defineProperty_1 = createCommonjsModule(function (module) {
var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;
});

var defineProperty$4 = defineProperty_1;

var defineProperty$5 = defineProperty$4;

var getInputValue = (function (event, isCheckboxInput) {
  return isPrimitive(event) || !isObject$1(event.target) || isObject$1(event.target) && !event.type ? event : isCheckboxInput || isUndefined(event.target.value) ? event.target.checked : event.target.value;
});

var Controller = function (_a) {
  var _b, _c, _d, _e;

  var name = _a.name,
      rules = _a.rules,
      InnerComponent = _a.as,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      _f = _a.onChangeName,
      onChangeName = _f === void 0 ? VALIDATION_MODE.onChange : _f,
      _g = _a.onBlurName,
      onBlurName = _g === void 0 ? VALIDATION_MODE.onBlur : _g,
      valueName = _a.valueName,
      defaultValue = _a.defaultValue,
      control = _a.control,
      onFocus = _a.onFocus,
      rest = __rest(_a, ["name", "rules", "as", "onBlur", "onChange", "onChangeName", "onBlurName", "valueName", "defaultValue", "control", "onFocus"]);

  var methods = useFormContext();

  var _h = control || methods.control,
      defaultValuesRef = _h.defaultValuesRef,
      setValue = _h.setValue,
      register = _h.register,
      unregister = _h.unregister,
      errorsRef = _h.errorsRef,
      removeFieldEventListener = _h.removeFieldEventListener,
      triggerValidation = _h.triggerValidation,
      _j = _h.mode,
      isOnSubmit = _j.isOnSubmit,
      isOnBlur = _j.isOnBlur,
      isOnChange = _j.isOnChange,
      _k = _h.reValidateMode,
      isReValidateOnBlur = _k.isReValidateOnBlur,
      isReValidateOnSubmit = _k.isReValidateOnSubmit,
      isSubmitted = _h.formState.isSubmitted,
      fieldsRef = _h.fieldsRef,
      fieldArrayNamesRef = _h.fieldArrayNamesRef;

  var _l = __read(React.useState(isUndefined(defaultValue) ? get$1(defaultValuesRef.current, name) : defaultValue), 2),
      value = _l[0],
      setInputStateValue = _l[1];

  var valueRef = React.useRef(value);
  var isCheckboxInput = isBoolean(value);
  var shouldReValidateOnBlur = isOnBlur || isReValidateOnBlur;
  var rulesRef = React.useRef(rules);
  var onFocusRef = React.useRef(onFocus);
  var isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);
  rulesRef.current = rules;

  var shouldValidate = function () {
    return !skipValidation({
      hasError: !!get$1(errorsRef.current, name),
      isOnBlur: isOnBlur,
      isOnSubmit: isOnSubmit,
      isOnChange: isOnChange,
      isReValidateOnBlur: isReValidateOnBlur,
      isReValidateOnSubmit: isReValidateOnSubmit,
      isSubmitted: isSubmitted
    });
  };

  var commonTask = function (event) {
    var data = getInputValue(event, isCheckboxInput);
    setInputStateValue(data);
    valueRef.current = data;
    return data;
  };

  var eventWrapper = function (event) {
    return function () {
      var arg = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        arg[_i] = arguments[_i];
      }

      return setValue(name, commonTask(event(arg)), shouldValidate());
    };
  };

  var handleChange = function (event) {
    var data = commonTask(event);
    setValue(name, data, shouldValidate());
  };

  var registerField = React.useCallback(function () {
    if (!isNotFieldArray) {
      removeFieldEventListener(fieldsRef.current[name], true);
    }

    register(defineProperty$5({
      name: name,
      focus: onFocusRef.current
    }, VALUE, {
      set: function (data) {
        setInputStateValue(data);
        valueRef.current = data;
      },
      get: function () {
        return valueRef.current;
      }
    }), rulesRef.current);
  }, [isNotFieldArray, fieldsRef, rulesRef, name, onFocusRef, register, removeFieldEventListener]);
  React.useEffect(function () {
    return function () {
      !isNameInFieldArray(fieldArrayNamesRef.current, name) && unregister(name);
    };
  }, [unregister, name, fieldArrayNamesRef]);
  React.useEffect(function () {
    registerField();
  }, [registerField]); // eslint-disable-next-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    if (!fieldsRef.current[name]) {
      registerField();

      if (isNotFieldArray) {
        setInputStateValue(isUndefined(defaultValue) ? get$1(defaultValuesRef.current, name) : defaultValue);
      }
    }
  });

  var props = __assign(__assign(__assign(__assign({
    name: name
  }, rest), onChange ? (_b = {}, _b[onChangeName] = eventWrapper(onChange), _b) : (_c = {}, _c[onChangeName] = handleChange, _c)), onBlur || shouldReValidateOnBlur ? (_d = {}, _d[onBlurName] = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (onBlur) {
      onBlur(args);
    }

    if (shouldReValidateOnBlur) {
      triggerValidation(name);
    }
  }, _d) : {}), (_e = {}, _e[valueName || (isCheckboxInput ? 'checked' : VALUE)] = value, _e));

  return React.isValidElement(InnerComponent) ? React.cloneElement(InnerComponent, props) : React.createElement(InnerComponent, props);
};

var ErrorMessage = function (_a) {
  var InnerComponent = _a.as,
      errors = _a.errors,
      name = _a.name,
      message = _a.message,
      children = _a.children,
      rest = __rest(_a, ["as", "errors", "name", "message", "children"]);

  var methods = useFormContext();
  var error = get$1(errors || methods.errors, name);

  if (!error) {
    return null;
  }

  var messageFromRegister = error.message,
      types = error.types;

  var props = __assign(__assign({}, InnerComponent ? rest : {}), {
    children: children ? children({
      message: messageFromRegister || message,
      messages: types
    }) : messageFromRegister || message
  });

  return InnerComponent ? React.isValidElement(InnerComponent) ? React.cloneElement(InnerComponent, props) : React.createElement(InnerComponent, props) : React.createElement(React.Fragment, __assign({}, props));
};

exports.Controller = Controller;
exports.ErrorMessage = ErrorMessage;
exports.FormContext = FormContext;
exports.useFieldArray = useFieldArray;
exports.useForm = useForm;
exports.useFormContext = useFormContext;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return Panel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapse__ = __webpack_require__(1269);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Collapse__["a" /* default */]);
var Panel = __WEBPACK_IMPORTED_MODULE_0__Collapse__["a" /* default */].Panel;

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSdmxDimensionTypesTranslations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__ = __webpack_require__(10);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var getSdmxDimensionTypesTranslations=function getSdmxDimensionTypesTranslations(t){var sdmxDimensionTypesTranslations=function sdmxDimensionTypesTranslations(t){var _ref;return _ref={},_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["l" /* DSD_DIMENSION_TYPE_NORMAL */],t('sdmxDimensionTypes.normal')),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["j" /* DSD_DIMENSION_TYPE_FREQUENCY */],t('sdmxDimensionTypes.frequency')),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */],t('sdmxDimensionTypes.time')),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_0__utils_sdmxJson__["k" /* DSD_DIMENSION_TYPE_MEASURE */],t('sdmxDimensionTypes.measure')),_ref;};return sdmxDimensionTypesTranslations(t!==undefined?t:function(str){return str;});};

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_locale_it_IT__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_locale_it_IT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_locale_it_IT__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language};};var LocalizedMonthPicker=function LocalizedMonthPicker(_ref){var appLanguage=_ref.appLanguage,value=_ref.value,_ref$format=_ref.format,format=_ref$format===undefined?"YYYY-MM-DD":_ref$format,returnParsedDate=_ref.returnParsedDate,_onChange=_ref.onChange,props=_objectWithoutProperties(_ref,["appLanguage","value","format","returnParsedDate","onChange"]);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{title:value?__WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format(format):null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a.MonthPicker,Object.assign({},props,{style:Object.assign({width:"100%"},props["style"]),value:value?__WEBPACK_IMPORTED_MODULE_5_moment___default()(value):null,locale:appLanguage==='it'?__WEBPACK_IMPORTED_MODULE_4_antd_lib_date_picker_locale_it_IT___default.a:null,format:format,onChange:function onChange(date){return _onChange(date?returnParsedDate?__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format(format):date:null);}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(LocalizedMonthPicker));

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_hook_form_dist_react_hook_form_ie11__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_hook_form_dist_react_hook_form_ie11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_hook_form_dist_react_hook_form_ie11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(2);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_TWO_THIRDS"]}};var DefaultMapLayout=function DefaultMapLayout(_ref){var t=_ref.t,forwardedRef=_ref.forwardedRef,disabled=_ref.disabled,dsdDimensions=_ref.dsdDimensions,annotations=_ref.annotations,annotationsConfig=_ref.annotationsConfig,onChange=_ref.onChange;var _useForm=Object(__WEBPACK_IMPORTED_MODULE_10_react_hook_form_dist_react_hook_form_ie11__["useForm"])({defaultValues:{territorialDimensionIds:Object(__WEBPACK_IMPORTED_MODULE_12__utils_annotations__["N" /* getLayoutAnnotationTerritorialDimensionIds */])(annotations,annotationsConfig)[0]||null}}),register=_useForm.register,watch=_useForm.watch,setValue=_useForm.setValue,handleSubmit=_useForm.handleSubmit;Object(__WEBPACK_IMPORTED_MODULE_8_react__["useEffect"])(function(){register({name:'territorialDimensionIds'});},[]);var territorialDimensionIds=watch('territorialDimensionIds');Object(__WEBPACK_IMPORTED_MODULE_8_react__["useEffect"])(function(){if(onChange){var newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_12__utils_annotations__["_7" /* setLayoutAnnotationTerritorialDimensionIds */])(annotations,annotationsConfig,territorialDimensionIds?[territorialDimensionIds]:[]);onChange({layoutAnnotations:newLayoutAnnotations});}},[territorialDimensionIds]);Object(__WEBPACK_IMPORTED_MODULE_8_react__["useImperativeHandle"])(forwardedRef,function(){return{submit:function submit(annotations,cb){handleSubmit(function(val){var newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_12__utils_annotations__["_7" /* setLayoutAnnotationTerritorialDimensionIds */])(annotations,annotationsConfig,val.territorialDimensionIds?[val.territorialDimensionIds]:[]);cb(newLayoutAnnotations);})();}};});return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__["b" /* DataLanguageProvider */],{value:null},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutTerritorialDimensionIds.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{disabled:disabled,title:watch('territorialDimensionIds'),value:watch('territorialDimensionIds'),onChange:function onChange(val){return setValue('territorialDimensionIds',val);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:null,title:t('layoutAnnotations.empty')},t('layoutAnnotations.empty')),(dsdDimensions||[]).map(function(_ref2){var id=_ref2.id;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:id,value:id,title:id},id);}))))))));};var ConnectedDefaultMapLayout=Object(__WEBPACK_IMPORTED_MODULE_14_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__["c" /* withDataLanguage */])(),Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(function(state){return{appLanguage:state.app.language};}))(DefaultMapLayout);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react__["forwardRef"])(function(props,ref){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ConnectedDefaultMapLayout,Object.assign({},props,{forwardedRef:ref}));}));

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _configProvider = __webpack_require__(35);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var BreadcrumbItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    var _this;

    _classCallCheck(this, BreadcrumbItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BreadcrumbItem).apply(this, arguments));

    _this.renderBreadcrumbItem = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          separator = _a.separator,
          children = _a.children,
          restProps = __rest(_a, ["prefixCls", "separator", "children"]);

      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
      var link;

      if ('href' in _this.props) {
        link = React.createElement("a", _extends({
          className: "".concat(prefixCls, "-link")
        }, restProps), children);
      } else {
        link = React.createElement("span", _extends({
          className: "".concat(prefixCls, "-link")
        }, restProps), children);
      }

      if (children) {
        return React.createElement("span", null, link, React.createElement("span", {
          className: "".concat(prefixCls, "-separator")
        }, separator));
      }

      return null;
    };

    return _this;
  }

  _createClass(BreadcrumbItem, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumbItem);
    }
  }]);

  return BreadcrumbItem;
}(React.Component);

exports["default"] = BreadcrumbItem;
BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
BreadcrumbItem.defaultProps = {
  separator: '/'
};
BreadcrumbItem.propTypes = {
  prefixCls: PropTypes.string,
  separator: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  href: PropTypes.string
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1300);

__webpack_require__(206);

__webpack_require__(474);

__webpack_require__(1301);

__webpack_require__(427);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

var _spin = _interopRequireDefault(__webpack_require__(475));

var _pagination = _interopRequireDefault(__webpack_require__(1303));

var _grid = __webpack_require__(215);

var _Item = _interopRequireDefault(__webpack_require__(1311));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var List =
/*#__PURE__*/
function (_React$Component) {
  _inherits(List, _React$Component);

  function List() {
    var _this;

    _classCallCheck(this, List);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(List).apply(this, arguments));
    _this.state = {
      paginationCurrent: 1
    };
    _this.defaultPaginationProps = {
      current: 1,
      pageSize: 10,
      onChange: function onChange(page, pageSize) {
        var pagination = _this.props.pagination;

        _this.setState({
          paginationCurrent: page
        });

        if (pagination && pagination.onChange) {
          pagination.onChange(page, pageSize);
        }
      },
      total: 0
    };
    _this.keys = {};

    _this.renderItem = function (item, index) {
      var _this$props = _this.props,
          dataSource = _this$props.dataSource,
          renderItem = _this$props.renderItem,
          rowKey = _this$props.rowKey;
      var key;

      if (typeof rowKey === 'function') {
        key = rowKey(dataSource[index]);
      } else if (typeof rowKey === 'string') {
        key = dataSource[rowKey];
      } else {
        key = dataSource.key;
      }

      if (!key) {
        key = "list-item-".concat(index);
      }

      _this.keys[index] = key;
      return renderItem(item, index);
    };

    _this.renderEmpty = function (prefixCls, renderEmpty) {
      var locale = _this.props.locale;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-empty-text")
      }, locale && locale.emptyText || renderEmpty('List'));
    };

    _this.renderList = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls,
          renderEmpty = _ref.renderEmpty;
      var paginationCurrent = _this.state.paginationCurrent;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          bordered = _a.bordered,
          split = _a.split,
          className = _a.className,
          children = _a.children,
          itemLayout = _a.itemLayout,
          loadMore = _a.loadMore,
          pagination = _a.pagination,
          grid = _a.grid,
          dataSource = _a.dataSource,
          size = _a.size,
          rowKey = _a.rowKey,
          renderItem = _a.renderItem,
          header = _a.header,
          footer = _a.footer,
          loading = _a.loading,
          locale = _a.locale,
          rest = __rest(_a, ["prefixCls", "bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "grid", "dataSource", "size", "rowKey", "renderItem", "header", "footer", "loading", "locale"]);

      var prefixCls = getPrefixCls('list', customizePrefixCls);
      var loadingProp = loading;

      if (typeof loadingProp === 'boolean') {
        loadingProp = {
          spinning: loadingProp
        };
      }

      var isLoading = loadingProp && loadingProp.spinning; // large => lg
      // small => sm

      var sizeCls = '';

      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;

        case 'small':
          sizeCls = 'sm';

        default:
          break;
      }

      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-split"), split), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), isLoading), _defineProperty(_classNames, "".concat(prefixCls, "-grid"), grid), _defineProperty(_classNames, "".concat(prefixCls, "-something-after-last-item"), _this.isSomethingAfterLastItem()), _classNames));

      var paginationProps = _extends({}, _this.defaultPaginationProps, {
        total: dataSource.length,
        current: paginationCurrent
      }, pagination || {});

      var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);

      if (paginationProps.current > largestPage) {
        paginationProps.current = largestPage;
      }

      var paginationContent = pagination ? React.createElement("div", {
        className: "".concat(prefixCls, "-pagination")
      }, React.createElement(_pagination["default"], _extends({}, paginationProps, {
        onChange: _this.defaultPaginationProps.onChange
      }))) : null;

      var splitDataSource = _toConsumableArray(dataSource);

      if (pagination) {
        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
          splitDataSource = _toConsumableArray(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
        }
      }

      var childrenContent;
      childrenContent = isLoading && React.createElement("div", {
        style: {
          minHeight: 53
        }
      });

      if (splitDataSource.length > 0) {
        var items = splitDataSource.map(function (item, index) {
          return _this.renderItem(item, index);
        });
        var childrenList = [];
        React.Children.forEach(items, function (child, index) {
          childrenList.push(React.cloneElement(child, {
            key: _this.keys[index]
          }));
        });
        childrenContent = grid ? React.createElement(_grid.Row, {
          gutter: grid.gutter
        }, childrenList) : childrenList;
      } else if (!children && !isLoading) {
        childrenContent = _this.renderEmpty(prefixCls, renderEmpty);
      }

      var paginationPosition = paginationProps.position || 'bottom';
      return React.createElement("div", _extends({
        className: classString
      }, rest), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, header), React.createElement(_spin["default"], loadingProp, childrenContent, children), footer && React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent);
    };

    return _this;
  }

  _createClass(List, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        grid: this.props.grid
      };
    }
  }, {
    key: "isSomethingAfterLastItem",
    value: function isSomethingAfterLastItem() {
      var _this$props2 = this.props,
          loadMore = _this$props2.loadMore,
          pagination = _this$props2.pagination,
          footer = _this$props2.footer;
      return !!(loadMore || pagination || footer);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderList);
    }
  }]);

  return List;
}(React.Component);

exports["default"] = List;
List.Item = _Item["default"];
List.childContextTypes = {
  grid: PropTypes.any
};
List.defaultProps = {
  dataSource: [],
  bordered: false,
  split: true,
  loading: false,
  pagination: false
};

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ZERO: 48,
  NINE: 57,

  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,

  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,

  ARROW_UP: 38,
  ARROW_DOWN: 40
});

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1313);

__webpack_require__(1314);

__webpack_require__(154);

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Upload = _interopRequireDefault(__webpack_require__(563));

var _Dragger = _interopRequireDefault(__webpack_require__(1386));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Upload["default"].Dragger = _Dragger["default"];
var _default = _Upload["default"];
exports["default"] = _default;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(49);

var _rcUpload = _interopRequireDefault(__webpack_require__(1316));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _uniqBy = _interopRequireDefault(__webpack_require__(1324));

var _UploadList = _interopRequireDefault(__webpack_require__(1379));

var _utils = __webpack_require__(1385);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(142));

var _default2 = _interopRequireDefault(__webpack_require__(263));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Upload =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Upload, _React$Component);

  function Upload(props) {
    var _this;

    _classCallCheck(this, Upload);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Upload).call(this, props));

    _this.onStart = function (file) {
      var targetItem = (0, _utils.fileToObject)(file);
      targetItem.status = 'uploading';

      var nextFileList = _this.state.fileList.concat();

      var fileIndex = nextFileList.findIndex(function (_ref) {
        var uid = _ref.uid;
        return uid === targetItem.uid;
      });

      if (fileIndex === -1) {
        nextFileList.push(targetItem);
      } else {
        nextFileList[fileIndex] = targetItem;
      }

      _this.onChange({
        file: targetItem,
        fileList: nextFileList
      }); // fix ie progress


      if (!window.FormData) {
        _this.autoUpdateProgress(0, targetItem);
      }
    };

    _this.onSuccess = function (response, file) {
      _this.clearProgressTimer();

      try {
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }
      } catch (e) {
        /* do nothing */
      }

      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.status = 'done';
      targetItem.response = response;

      _this.onChange({
        file: _extends({}, targetItem),
        fileList: fileList
      });
    };

    _this.onProgress = function (e, file) {
      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.percent = e.percent;

      _this.onChange({
        event: e,
        file: _extends({}, targetItem),
        fileList: _this.state.fileList
      });
    };

    _this.onError = function (error, response, file) {
      _this.clearProgressTimer();

      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.error = error;
      targetItem.response = response;
      targetItem.status = 'error';

      _this.onChange({
        file: _extends({}, targetItem),
        fileList: fileList
      });
    };

    _this.handleManualRemove = function (file) {
      _this.upload.abort(file);

      file.status = 'removed'; // eslint-disable-line

      _this.handleRemove(file);
    };

    _this.onChange = function (info) {
      if (!('fileList' in _this.props)) {
        _this.setState({
          fileList: info.fileList
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(info);
      }
    };

    _this.onFileDrop = function (e) {
      _this.setState({
        dragState: e.type
      });
    };

    _this.beforeUpload = function (file, fileList) {
      if (!_this.props.beforeUpload) {
        return true;
      }

      var result = _this.props.beforeUpload(file, fileList);

      if (result === false) {
        _this.onChange({
          file: file,
          fileList: (0, _uniqBy["default"])(_this.state.fileList.concat(fileList.map(_utils.fileToObject)), function (item) {
            return item.uid;
          })
        });

        return false;
      } else if (result && result.then) {
        return result;
      }

      return true;
    };

    _this.saveUpload = function (node) {
      _this.upload = node;
    };

    _this.renderUploadList = function (locale) {
      var _this$props = _this.props,
          showUploadList = _this$props.showUploadList,
          listType = _this$props.listType,
          onPreview = _this$props.onPreview;
      var showRemoveIcon = showUploadList.showRemoveIcon,
          showPreviewIcon = showUploadList.showPreviewIcon;
      return React.createElement(_UploadList["default"], {
        listType: listType,
        items: _this.state.fileList,
        onPreview: onPreview,
        onRemove: _this.handleManualRemove,
        showRemoveIcon: showRemoveIcon,
        showPreviewIcon: showPreviewIcon,
        locale: _extends({}, locale, _this.props.locale)
      });
    };

    _this.renderUpload = function (_ref2) {
      var _classNames2;

      var getPrefixCls = _ref2.getPrefixCls;
      var _this$props2 = _this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          showUploadList = _this$props2.showUploadList,
          listType = _this$props2.listType,
          type = _this$props2.type,
          disabled = _this$props2.disabled,
          children = _this$props2.children;
      var prefixCls = getPrefixCls('upload', customizePrefixCls);

      var rcUploadProps = _extends({
        onStart: _this.onStart,
        onError: _this.onError,
        onProgress: _this.onProgress,
        onSuccess: _this.onSuccess
      }, _this.props, {
        prefixCls: prefixCls,
        beforeUpload: _this.beforeUpload
      });

      delete rcUploadProps.className;
      var uploadList = showUploadList ? React.createElement(_LocaleReceiver["default"], {
        componentName: "Upload",
        defaultLocale: _default2["default"].Upload
      }, _this.renderUploadList) : null;

      if (type === 'drag') {
        var _classNames;

        var dragCls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-drag"), true), _defineProperty(_classNames, "".concat(prefixCls, "-drag-uploading"), _this.state.fileList.some(function (file) {
          return file.status === 'uploading';
        })), _defineProperty(_classNames, "".concat(prefixCls, "-drag-hover"), _this.state.dragState === 'dragover'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
        return React.createElement("span", {
          className: className
        }, React.createElement("div", {
          className: dragCls,
          onDrop: _this.onFileDrop,
          onDragOver: _this.onFileDrop,
          onDragLeave: _this.onFileDrop
        }, React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
          ref: _this.saveUpload,
          className: "".concat(prefixCls, "-btn")
        }), React.createElement("div", {
          className: "".concat(prefixCls, "-drag-container")
        }, children))), uploadList);
      }

      var uploadButtonCls = (0, _classnames["default"])(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _classNames2));
      var uploadButton = React.createElement("div", {
        className: uploadButtonCls,
        style: {
          display: children ? '' : 'none'
        }
      }, React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
        ref: _this.saveUpload
      })));

      if (listType === 'picture-card') {
        return React.createElement("span", {
          className: className
        }, uploadList, uploadButton);
      }

      return React.createElement("span", {
        className: className
      }, uploadButton, uploadList);
    };

    _this.state = {
      fileList: props.fileList || props.defaultFileList || [],
      dragState: 'drop'
    };
    return _this;
  }

  _createClass(Upload, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearProgressTimer();
    }
  }, {
    key: "autoUpdateProgress",
    value: function autoUpdateProgress(_, file) {
      var _this2 = this;

      var getPercent = (0, _utils.genPercentAdd)();
      var curPercent = 0;
      this.clearProgressTimer();
      this.progressTimer = setInterval(function () {
        curPercent = getPercent(curPercent);

        _this2.onProgress({
          percent: curPercent * 100
        }, file);
      }, 200);
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(file) {
      var _this3 = this;

      var onRemove = this.props.onRemove;
      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
        // Prevent removing file
        if (ret === false) {
          return;
        }

        var removedFileList = (0, _utils.removeFileItem)(file, _this3.state.fileList);

        if (removedFileList) {
          _this3.onChange({
            file: file,
            fileList: removedFileList
          });
        }
      });
    }
  }, {
    key: "clearProgressTimer",
    value: function clearProgressTimer() {
      clearInterval(this.progressTimer);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderUpload);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('fileList' in nextProps) {
        return {
          fileList: nextProps.fileList || []
        };
      }

      return null;
    }
  }]);

  return Upload;
}(React.Component);

Upload.defaultProps = {
  type: 'select',
  multiple: false,
  action: '',
  data: {},
  accept: '',
  beforeUpload: _utils.T,
  showUploadList: true,
  listType: 'text',
  className: '',
  disabled: false,
  supportServerRender: true
};
(0, _reactLifecyclesCompat.polyfill)(Upload);
var _default = Upload;
exports["default"] = _default;

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uid;
var now = +new Date();
var index = 0;

function uid() {
  return "rc-upload-" + now + "-" + ++index;
}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(218),
    stackClear = __webpack_require__(1328),
    stackDelete = __webpack_require__(1329),
    stackGet = __webpack_require__(1330),
    stackHas = __webpack_require__(1331),
    stackSet = __webpack_require__(1332);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1333),
    isObjectLike = __webpack_require__(181);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(568),
    arraySome = __webpack_require__(1336),
    cacheHas = __webpack_require__(569);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(301),
    setCacheAdd = __webpack_require__(1334),
    setCacheHas = __webpack_require__(1335);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1347),
    baseKeys = __webpack_require__(1353),
    isArrayLike = __webpack_require__(1357);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(101),
    stubFalse = __webpack_require__(1349);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(207)(module)))

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1350),
    baseUnary = __webpack_require__(1351),
    nodeUtil = __webpack_require__(1352);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(135),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(150);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);



var enhancer = function enhancer(WrappedComponent) {
  return function (_WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Progress, _WrappedComponent);

    function Progress() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Progress);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _WrappedComponent.apply(this, arguments));
    }

    Progress.prototype.componentDidUpdate = function componentDidUpdate() {
      if (!this.path) {
        return;
      }
      var pathStyle = this.path.style;
      pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
      var now = Date.now();
      if (this.prevTimeStamp && now - this.prevTimeStamp < 100) {
        pathStyle.transitionDuration = '0s, 0s';
      }
      this.prevTimeStamp = Date.now();
    };

    Progress.prototype.render = function render() {
      return _WrappedComponent.prototype.render.call(this);
    };

    return Progress;
  }(WrappedComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (enhancer);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var defaultProps = {
  className: '',
  percent: 0,
  prefixCls: 'rc-progress',
  strokeColor: '#2db7f5',
  strokeLinecap: 'round',
  strokeWidth: 1,
  style: {},
  trailColor: '#D9D9D9',
  trailWidth: 1
};

var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  percent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
  prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  strokeColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  strokeLinecap: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['butt', 'round', 'square']),
  strokeWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  trailColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  trailWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
};

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{dataLanguages:state.config.dataManagement.dataLanguages};};var TREE_NODE_KEY_ALL=__WEBPACK_IMPORTED_MODULE_6__tree_filter_utils__["b" /* TREE_NODE_KEY_PREFIX */]+'ALL';var TREE_NODE_KEY_OF_LEVEL_PREFIX=__WEBPACK_IMPORTED_MODULE_6__tree_filter_utils__["b" /* TREE_NODE_KEY_PREFIX */]+'OF_LEVEL_';var CheckableItemsTree=function CheckableItemsTree(_ref){var t=_ref.t,itemTree=_ref.itemTree,itemTreeMaxDepth=_ref.itemTreeMaxDepth,childrenKey=_ref.childrenKey,dataLanguages=_ref.dataLanguages,rightActions=_ref.rightActions,selectedItems=_ref.selectedItems,onSelectedItemsChange=_ref.onSelectedItemsChange,getIsDisabledNode=_ref.getIsDisabledNode;var levelNodesKeys=itemTreeMaxDepth?[].concat(_toConsumableArray(Array(itemTreeMaxDepth))).map(function(_,index){return TREE_NODE_KEY_OF_LEVEL_PREFIX+index;}):[];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(lang){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__enhanced_tree__["a" /* default */],{searchBarSpan:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"],treePrefix:itemTree&&itemTree.length>0?[function(){var obj={id:TREE_NODE_KEY_OF_LEVEL_PREFIX+0,name:{en:t('components.checkableItemsTree.levelNode',{level:0})},level:0};if(itemTreeMaxDepth!==null){[].concat(_toConsumableArray(Array(itemTreeMaxDepth-1))).forEach(function(){var pointer=obj;var counter=0;while(pointer[childrenKey]){pointer=pointer[childrenKey][0];counter++;}pointer[childrenKey]=[{id:TREE_NODE_KEY_OF_LEVEL_PREFIX+Number(counter+1),name:{en:t('components.checkableItemsTree.levelNode',{level:counter+1})},level:counter+1}];});}return obj;}()]:null,tree:itemTree,getNodeKey:function getNodeKey(_ref2){var id=_ref2.id;return id;},childrenKey:childrenKey,hiddenIdKeys:[TREE_NODE_KEY_ALL].concat(_toConsumableArray(levelNodesKeys)),idKey:"id",nameKey:"name",catIdKey:"id",catNameKey:"name",icon:"file-text",isRootIconLikeChildrenIcon:true,isEmptyCategoryIconLikeLeafIcon:true,getFilter:function getFilter(searchText){return function(_ref3){var id=_ref3.id,name=_ref3.name;var search=searchText.toLowerCase();return id&&id.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_3__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,lang,dataLanguages).toLowerCase().indexOf(search)>=0;};},rightActions:rightActions,onShowMoreForbidden:function onShowMoreForbidden(){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('components.checkableItemsTree.modals.maxTreeSizeReached.title'),content:t('components.checkableItemsTree.modals.maxTreeSizeReached.content')});},checkable:true,checkStrictly:true,checkedKeys:{checked:selectedItems},onCheck:function onCheck(_ref4,_ref5){var checked=_ref4.checked;var node=_ref5.node,isChecked=_ref5.checked;var newChecked=[];if(node.props.eventKey===TREE_NODE_KEY_ALL){if(isChecked){newChecked=[TREE_NODE_KEY_ALL].concat(_toConsumableArray(levelNodesKeys),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_7__utils_tree__["l" /* getNodes */])(itemTree,childrenKey,function(){return true;}).map(function(_ref6){var id=_ref6.id;return id;})));}else{newChecked=[];}}else if(levelNodesKeys.includes(node.props.eventKey)){var level=Number(node.props.eventKey.replace(TREE_NODE_KEY_OF_LEVEL_PREFIX,""));var keysAtDepth=Object(__WEBPACK_IMPORTED_MODULE_7__utils_tree__["m" /* getNodesAtDepth */])(itemTree,childrenKey,level+1).map(function(_ref7){var id=_ref7.id;return id;});if(isChecked){newChecked=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq([TREE_NODE_KEY_OF_LEVEL_PREFIX+level].concat(_toConsumableArray(checked),_toConsumableArray(keysAtDepth)));}else{newChecked=checked.filter(function(key){return!keysAtDepth.includes(key);});}}else{newChecked=checked.filter(function(key){return!key.startsWith(__WEBPACK_IMPORTED_MODULE_6__tree_filter_utils__["b" /* TREE_NODE_KEY_PREFIX */]);});}onSelectedItemsChange(newChecked);},getNodeIsCheckable:getIsDisabledNode?function(node){return!getIsDisabledNode(node);}:null,nodeActions:[function(node){return node[childrenKey]&&node[childrenKey].length>0&&!node.id.startsWith(__WEBPACK_IMPORTED_MODULE_6__tree_filter_utils__["b" /* TREE_NODE_KEY_PREFIX */])?Object.assign({},__WEBPACK_IMPORTED_MODULE_9__styles_buttons__["c" /* BUTTON_CHECK_ALL_CHILDS */],{title:t("components.checkableItemsTree.checkUncheckAllChilds.title"),onClick:function onClick(){var childIds=node[childrenKey].filter(function(node){return getIsDisabledNode?!getIsDisabledNode(node):true;}).map(function(_ref8){var id=_ref8.id;return id;});var mergedIds=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(childIds.concat(selectedItems));var newSelectedItems=mergedIds.length>selectedItems.length?mergedIds:selectedItems.filter(function(id){return!childIds.includes(id);});onSelectedItemsChange(newSelectedItems);}}):null;}]});});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps))(CheckableItemsTree));

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_artefact_min_form__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__style_css__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__style_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{appLang:state.app.language,derivedItemScheme:instanceState.derivedItemScheme,derivedItemSchemeItems:instanceState.derivedItemSchemeItems,derivedItemSchemeItemsTree:instanceState.derivedItemSchemeItemsTree,derivedItemSchemeItemsTreeMaxDepth:instanceState.derivedItemSchemeItemsTreeMaxDepth,selectedSourceItems:instanceState.selectedSourceItems,selectedTargetItems:instanceState.selectedTargetItems,importCheckbox:instanceState.importCheckbox,isCreateVisible:instanceState.isCreateVisible};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onItemSelect:function onItemSelect(selectedArr,isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["o" /* selectDerivedItemSchemeItem */])(selectedArr,isSource),instancePrefix));},onItemsAdd:function onItemsAdd(itemTree,childrenKey,forcePreserveHierarchy){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["i" /* addDerivedItemSchemeItems */])(itemTree,childrenKey,forcePreserveHierarchy),instancePrefix));},onItemsRemove:function onItemsRemove(items,childrenKey){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["m" /* removeDerivedItemSchemeItems */])(items,childrenKey),instancePrefix));},onCheckboxChange:function onCheckboxChange(checkbox){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["j" /* changeDerivedItemSchemeCheckbox */])(checkbox),instancePrefix));},onCreateShow:function onCreateShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["p" /* showDerivedItemSchemeCreate */])(),instancePrefix));},onCreateHide:function onCreateHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["l" /* hideDerivedItemSchemeCreate */])(),instancePrefix));},onCreateChange:function onCreateChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["k" /* changeDerivedItemSchemeCreate */])(fields),instancePrefix));},onStateReset:function onStateReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["n" /* resetDerivedItemSchemeState */])(),instancePrefix));}};};var isItemsRemoveValid=function isItemsRemoveValid(totalItems,itemsToRemove){var items=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(totalItems);items=items.filter(function(_ref3){var id=_ref3.id;return!itemsToRemove.includes(id);});var mappedArr={};items.forEach(function(el){el.children=[];mappedArr[el.id]=el;});var ret=true;items.forEach(function(el){if(el.parent){if(!mappedArr[el.parent]){ret=false;}}});return ret;};var TABLE_HEIGHT=300;var ReduxDerivedItemScheme=function ReduxDerivedItemScheme(_ref4){var t=_ref4.t,appLang=_ref4.appLang,itemTree=_ref4.itemTree,viewMode=_ref4.viewMode,childrenKey=_ref4.childrenKey,agencies=_ref4.agencies,isCreateVisible=_ref4.isCreateVisible,derivedItemScheme=_ref4.derivedItemScheme,derivedItemSchemeItems=_ref4.derivedItemSchemeItems,derivedItemSchemeItemsTree=_ref4.derivedItemSchemeItemsTree,derivedItemSchemeItemsTreeMaxDepth=_ref4.derivedItemSchemeItemsTreeMaxDepth,selectedSourceItems=_ref4.selectedSourceItems,selectedTargetItems=_ref4.selectedTargetItems,importCheckbox=_ref4.importCheckbox,isImportParentDisabled=_ref4.isImportParentDisabled,onItemSelect=_ref4.onItemSelect,onItemsAdd=_ref4.onItemsAdd,onItemsRemove=_ref4.onItemsRemove,onCheckboxChange=_ref4.onCheckboxChange,onCreateShow=_ref4.onCreateShow,onCreateChange=_ref4.onCreateChange,onCreateHide=_ref4.onCreateHide,onCreateSubmit=_ref4.onCreateSubmit,onStateReset=_ref4.onStateReset,onViewModeChange=_ref4.onViewModeChange,itemTreeMaxDepth=_ref4.itemTreeMaxDepth,title=_ref4.title;var _useState=Object(__WEBPACK_IMPORTED_MODULE_14_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isVisible=_useState2[0],setIsVisible=_useState2[1];return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var columns=[{title:t('data.item.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.item.name.shortLabel'),dataIndex:'name',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.item.parent.shortLabel'),dataIndex:'parent',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]}];var lang=dataLanguage||appLang;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_enhanced_modal__["a" /* default */],{fullscreen:true,visible:isVisible,title:title,onCancel:function onCancel(){return setIsVisible(false);},footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return setIsVisible(false);},icon:"zoom-out"},t('commons.buttons.close.title')))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"space-between",align:"middle",gutter:32,style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",gutter:16},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Group,{value:viewMode,onChange:function onChange(_ref5){var target=_ref5.target;return onViewModeChange(target.value);}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{title:t('reduxComponents.derivedItemsScheme.viewModeRadio.table.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:"table"}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{title:t('reduxComponents.derivedItemsScheme.viewModeRadio.tree.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:"branches",style:{transform:"rotate(90deg)"}}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return setIsVisible(false);},icon:"zoom-out"},t('reduxComponents.derivedItemsScheme.buttons.zoom.title'))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,viewMode===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"end",align:"middle",gutter:32},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.preservesHierarchy.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:importCheckbox.preserveHierarchy,onChange:function onChange(e){return onCheckboxChange({preserveHierarchy:e.target.checked});},disabled:isImportParentDisabled})))),importCheckbox.preserveHierarchy&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.parents.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:importCheckbox.importParents,onChange:function onChange(e){return onCheckboxChange({importParents:e.target.checked});},disabled:isImportParentDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.children.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:importCheckbox.importChildren,onChange:function onChange(e){return onCheckboxChange({importChildren:e.target.checked});},disabled:isImportParentDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.descendants.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:importCheckbox.importDescendants,onChange:function onChange(e){return onCheckboxChange({importDescendants:e.target.checked});},disabled:isImportParentDisabled}))))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"redux-derived-item-scheme-viewer redux-derived-item-scheme-viewer__fullscreen"},viewMode===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__["a" /* default */],{itemTree:itemTree,childrenKey:childrenKey,rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsAdd(itemTree,childrenKey,true);},icon:"double-right",type:"primary",disabled:!selectedSourceItems||selectedSourceItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.addItems.title')),itemTreeMaxDepth:itemTreeMaxDepth,selectedItems:selectedSourceItems||[],onSelectedItemsChange:function onSelectedItemsChange(selectedArr){return onItemSelect(selectedArr,true);},getIsDisabledNode:function getIsDisabledNode(_ref6){var id=_ref6.id;return(derivedItemSchemeItems||[]).map(function(_ref7){var id=_ref7.id;return id;}).includes(id);}})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__["a" /* default */],{itemTree:(derivedItemSchemeItemsTree||[]).filter(function(item){return Object(__WEBPACK_IMPORTED_MODULE_25__utils_tree__["l" /* getNodes */])(derivedItemSchemeItemsTree,childrenKey,function(node){return node[childrenKey].find(function(child){return child.id===item.id;})!==undefined;}).length===0;}),childrenKey:childrenKey,rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){if(isItemsRemoveValid(derivedItemSchemeItems,selectedTargetItems)){onItemsRemove(selectedTargetItems,childrenKey);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('reduxComponents.derivedItemsScheme.modals.warning.delete.title')});}},icon:"delete",type:"primary",disabled:!selectedTargetItems||selectedTargetItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')),itemTreeMaxDepth:derivedItemSchemeItemsTreeMaxDepth,selectedItems:selectedTargetItems||[],onSelectedItemsChange:function onSelectedItemsChange(selectedArr){return onItemSelect(selectedArr,false);}}))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_infinite_scroll_table__["a" /* default */],{data:Object(__WEBPACK_IMPORTED_MODULE_25__utils_tree__["l" /* getNodes */])(itemTree,childrenKey,function(){return true;}),getRowKey:function getRowKey(_ref8){var id=_ref8.id;return id;},columns:columns,multilangStrDataIndexes:["name"],height:document.body.clientHeight-357,searchBarSpan:10,rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsAdd(itemTree,childrenKey);},icon:"double-right",type:"primary",disabled:!selectedSourceItems||selectedSourceItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.addItems.title')),rowSelection:{selectedRowKeys:selectedSourceItems||[],onChange:function onChange(selectedArr){return onItemSelect(selectedArr,true);}},getIsDisabledRow:function getIsDisabledRow(_ref9){var id=_ref9.id;return(derivedItemSchemeItems||[]).map(function(_ref10){var id=_ref10.id;return id;}).includes(id);}})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_infinite_scroll_table__["a" /* default */],{data:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.sortBy(derivedItemSchemeItems||[],["order["+lang+"]"]),getRowKey:function getRowKey(_ref11){var id=_ref11.id;return id;},columns:columns,multilangStrDataIndexes:["name"],height:document.body.clientHeight-357,searchBarSpan:10,rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){if(isItemsRemoveValid(derivedItemSchemeItems,selectedTargetItems)){onItemsRemove(selectedTargetItems,childrenKey);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('reduxComponents.derivedItemsScheme.modals.warning.delete.title')});}},icon:"delete",type:"primary",disabled:!selectedTargetItems||selectedTargetItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')),rowSelection:{selectedRowKeys:selectedTargetItems||[],onChange:function onChange(selectedArr){return onItemSelect(selectedArr,false);}}})))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"space-between",align:"middle",gutter:32,style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",align:"middle",gutter:16},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Group,{value:viewMode,onChange:function onChange(_ref12){var target=_ref12.target;return onViewModeChange(target.value);}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{title:t('reduxComponents.derivedItemsScheme.viewModeRadio.table.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:"table"}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{title:t('reduxComponents.derivedItemsScheme.viewModeRadio.tree.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:"branches",style:{transform:"rotate(90deg)"}}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return setIsVisible(true);},icon:"zoom-in"},t('reduxComponents.derivedItemsScheme.buttons.zoom.title'))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,viewMode===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"end",align:"middle",gutter:32},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.preservesHierarchy.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:importCheckbox.preserveHierarchy,onChange:function onChange(e){return onCheckboxChange({preserveHierarchy:e.target.checked});},disabled:isImportParentDisabled})))),importCheckbox.preserveHierarchy&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.parents.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:importCheckbox.importParents,onChange:function onChange(e){return onCheckboxChange({importParents:e.target.checked});},disabled:isImportParentDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.children.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:importCheckbox.importChildren,onChange:function onChange(e){return onCheckboxChange({importChildren:e.target.checked});},disabled:isImportParentDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.descendants.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:importCheckbox.importDescendants,onChange:function onChange(e){return onCheckboxChange({importDescendants:e.target.checked});},disabled:isImportParentDisabled}))))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"redux-derived-item-scheme-viewer"},viewMode===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__["a" /* default */],{itemTree:itemTree,childrenKey:childrenKey,rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsAdd(itemTree,childrenKey,true);},icon:"double-right",type:"primary",disabled:!selectedSourceItems||selectedSourceItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.addItems.title')),itemTreeMaxDepth:itemTreeMaxDepth,selectedItems:selectedSourceItems||[],onSelectedItemsChange:function onSelectedItemsChange(selectedArr){return onItemSelect(selectedArr,true);},getIsDisabledNode:function getIsDisabledNode(_ref13){var id=_ref13.id;return(derivedItemSchemeItems||[]).map(function(_ref14){var id=_ref14.id;return id;}).includes(id);}})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__["a" /* default */],{itemTree:(derivedItemSchemeItemsTree||[]).filter(function(item){return Object(__WEBPACK_IMPORTED_MODULE_25__utils_tree__["l" /* getNodes */])(derivedItemSchemeItemsTree,childrenKey,function(node){return node[childrenKey].find(function(child){return child.id===item.id;})!==undefined;}).length===0;}),childrenKey:childrenKey,rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){if(isItemsRemoveValid(derivedItemSchemeItems,selectedTargetItems)){onItemsRemove(selectedTargetItems,childrenKey);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('reduxComponents.derivedItemsScheme.modals.warning.delete.title')});}},icon:"delete",type:"primary",disabled:!selectedTargetItems||selectedTargetItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')),itemTreeMaxDepth:derivedItemSchemeItemsTreeMaxDepth,selectedItems:selectedTargetItems||[],onSelectedItemsChange:function onSelectedItemsChange(selectedArr){return onItemSelect(selectedArr,false);}}))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_infinite_scroll_table__["a" /* default */],{data:Object(__WEBPACK_IMPORTED_MODULE_25__utils_tree__["l" /* getNodes */])(itemTree,childrenKey,function(){return true;}),getRowKey:function getRowKey(_ref15){var id=_ref15.id;return id;},columns:columns,multilangStrDataIndexes:["name"],height:TABLE_HEIGHT,searchBarSpan:10,rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsAdd(itemTree,childrenKey);},icon:"double-right",type:"primary",disabled:!selectedSourceItems||selectedSourceItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.addItems.title')),rowSelection:{selectedRowKeys:selectedSourceItems||[],onChange:function onChange(selectedArr){return onItemSelect(selectedArr,true);}},getIsDisabledRow:function getIsDisabledRow(_ref16){var id=_ref16.id;return(derivedItemSchemeItems||[]).map(function(_ref17){var id=_ref17.id;return id;}).includes(id);}})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_infinite_scroll_table__["a" /* default */],{data:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.sortBy(derivedItemSchemeItems||[],["order["+lang+"]"]),getRowKey:function getRowKey(_ref18){var id=_ref18.id;return id;},columns:columns,multilangStrDataIndexes:["name"],height:TABLE_HEIGHT,searchBarSpan:10,rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){if(isItemsRemoveValid(derivedItemSchemeItems,selectedTargetItems)){onItemsRemove(selectedTargetItems,childrenKey);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('reduxComponents.derivedItemsScheme.modals.warning.delete.title')});}},icon:"delete",type:"primary",disabled:!selectedTargetItems||selectedTargetItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')),rowSelection:{selectedRowKeys:selectedTargetItems||[],onChange:function onChange(selectedArr){return onItemSelect(selectedArr,false);}}}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsRemove(derivedItemSchemeItems.map(function(_ref19){var id=_ref19.id;return id;}),childrenKey);},disabled:derivedItemSchemeItems===null||derivedItemSchemeItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.emptyList.title'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(isItemsRemoveValid(derivedItemSchemeItems,[])){onCreateShow();}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('reduxComponents.derivedItemsScheme.modals.warning.parentMissing.title')});}},disabled:derivedItemSchemeItems===null||derivedItemSchemeItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.create.title'))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_enhanced_modal__["a" /* default */],{visible:isCreateVisible,title:t('reduxComponents.derivedItemsScheme.modals.derive.title'),width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_MD"],withDataLanguageSelector:true,onCancel:onCreateHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onCreateHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["a" /* isArtefactValid */])(derivedItemScheme)){onCreateSubmit(derivedItemScheme,derivedItemSchemeItems);onStateReset();}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('reduxComponents.derivedItemsScheme.buttons.deriveSubmit.title')))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_artefact_min_form__["b" /* default */],{artefact:derivedItemScheme,agencies:agencies,onChange:onCreateChange,mode:__WEBPACK_IMPORTED_MODULE_27__components_artefact_min_form__["a" /* ARTEFACT_MIN_FORM_MODE_CREATE */]})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ReduxDerivedItemScheme));

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__file_mapping_component_list__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_css__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_css__);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["SPAN_TWO_THIRDS"]}};var mapPropsToFields=function mapPropsToFields(_ref){var fileMapping=_ref.fileMapping,cube=_ref.cube;return{name:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:fileMapping!==null?fileMapping.Name:null}),description:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:fileMapping!==null?fileMapping.Description:null}),cubeId:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:cube!==null?cube.Code:null}),cubeName:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:cube!==null?cube.labels:null})};};var FileMappingForm=function FileMappingForm(_ref2){var t=_ref2.t,form=_ref2.form,fileMapping=_ref2.fileMapping;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.fileMapping.name.label')},formItemLayout),form.getFieldDecorator('name')(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{disabled:true,title:form.getFieldValue('name')}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.fileMapping.description.label')},formItemLayout),form.getFieldDecorator('description')(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{disabled:true,title:form.getFieldValue('description')}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.fileMapping.cube.id.label')},formItemLayout),form.getFieldDecorator('cubeId')(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{disabled:true,title:form.getFieldValue('cubeId')}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.fileMapping.cube.name.label')},formItemLayout),form.getFieldDecorator('cubeName')(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__multilanguage_input__["a" /* default */],{disabled:true}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t('data.fileMapping.components.label'),className:'file-mapping-form__field__components',style:{marginBottom:8}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{style:{height:200}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__file_mapping_component_list__["a" /* default */],{value:fileMapping&&fileMapping.Components,disabled:true,columnNameKey:'ColumnName',cubeComponentCodeKey:'CubeComponentCode'})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields}))(FileMappingForm));

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_time_picker_style__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_time_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_time_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_time_picker__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__localized_date_picker__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hocs_call__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var EmbargoInput=function(_React$Component){_inherits(EmbargoInput,_React$Component);function EmbargoInput(props){_classCallCheck(this,EmbargoInput);var _this=_possibleConstructorReturn(this,(EmbargoInput.__proto__||Object.getPrototypeOf(EmbargoInput)).call(this,props));_this.state=EmbargoInput.getInitState();_this.callOnChange=_this.callOnChange.bind(_this);_this.onEnabledChange=_this.onEnabledChange.bind(_this);_this.onAutoReleaseDateChange=_this.onAutoReleaseDateChange.bind(_this);_this.onAutoReleaseTimeChange=_this.onAutoReleaseTimeChange.bind(_this);_this.onAutoReleaseEnabledChange=_this.onAutoReleaseEnabledChange.bind(_this);return _this;}_createClass(EmbargoInput,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){this.props.onChange(value);}}},{key:'onAutoReleaseDateChange',value:function onAutoReleaseDateChange(value){var state=Object.assign({},this.state);state.value.autoReleaseDate=value;this.setState(state);this.callOnChange(state.value);}},{key:'onAutoReleaseTimeChange',value:function onAutoReleaseTimeChange(value){var state=Object.assign({},this.state);state.value.autoReleaseTime=value;this.setState(state);this.callOnChange(state.value);}},{key:'onEnabledChange',value:function onEnabledChange(value){var state=Object.assign({},this.state);state.value.enabled=value;if(value===false){state.value.autoReleaseEnabled=false;state.value.autoReleaseDate=null;state.value.autoReleaseTime=null;}this.setState(state);this.callOnChange(state.value);}},{key:'onAutoReleaseEnabledChange',value:function onAutoReleaseEnabledChange(value){var state=Object.assign({},this.state);state.value.autoReleaseEnabled=value;this.setState(state);this.callOnChange(state.value);}},{key:'render',value:function render(){var _this2=this;var _state$value=this.state.value,enabled=_state$value.enabled,autoReleaseEnabled=_state$value.autoReleaseEnabled,autoReleaseDate=_state$value.autoReleaseDate,autoReleaseTime=_state$value.autoReleaseTime;var _props=this.props,t=_props.t,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('components.embargoInput.fields.enabled')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default.a,{onChange:this.onEnabledChange,checked:enabled,size:'small',disabled:disabled})),enabled&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('components.embargoInput.fields.autoReleaseEnabled')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default.a,{onChange:this.onAutoReleaseEnabledChange,checked:autoReleaseEnabled,size:'small'})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('components.embargoInput.fields.autoReleaseDate')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__localized_date_picker__["a" /* default */],{value:autoReleaseDate,onChange:this.onAutoReleaseDateChange,format:'DD/MM/YYYY',showToday:false})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('components.embargoInput.fields.autoReleaseTime')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_time_picker___default.a,{value:autoReleaseTime,onChange:this.onAutoReleaseTimeChange,format:'HH:mm',placeholder:t('components.embargoInput.placeholder'),clearText:t('components.embargoInput.clearIcon.title')})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__hocs_call__["a" /* default */],{cb:function cb(){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t('errors.notImplemented')});_this2.onAutoReleaseEnabledChange(false);},disabled:autoReleaseEnabled===false},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('span',null)));}}],[{key:'getInitState',value:function getInitState(){return{value:{enabled:false,autoReleaseEnabled:false,autoReleaseDate:null,autoReleaseTime:null}};}},{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){return nextProps.value!==null?{value:nextProps.value}:EmbargoInput.getInitState();}}]);return EmbargoInput;}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* translate */])()(EmbargoInput));

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tree_style__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tree_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tree_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tree__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_normalizers__ = __webpack_require__(82);
var DraggableCheckList=function DraggableCheckList(_ref){var items=_ref.items,getItemLabel=_ref.getItemLabel,getItemIcon=_ref.getItemIcon,getItemKey=_ref.getItemKey,checkedKeys=_ref.checkedKeys,onCheck=_ref.onCheck,onDrop=_ref.onDrop,disabled=_ref.disabled;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tree___default.a,{draggable:!disabled,checkable:!disabled,selectable:false,showIcon:true,checkedKeys:checkedKeys,onCheck:onCheck,onDrop:onDrop},items&&items.map(function(item){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tree___default.a.TreeNode,{key:getItemKey(item),title:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:getItemIcon(item),style:{marginRight:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MARGIN_SM"]}}),getItemLabel(Object(__WEBPACK_IMPORTED_MODULE_6__utils_normalizers__["a" /* getNormalizedColumnName */])(item))),icon:!disabled&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"ellipsis",style:{transform:"translate(0px, -2px) rotate(90deg)"}})});})));};/* harmony default export */ __webpack_exports__["a"] = (DraggableCheckList);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__node__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__middlewares_authentication_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__NodeCredentialsModal__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__middlewares_scrollTo_actions__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_beautiful_dnd__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_drag_handle__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_artefactValidators__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{dataLangs:state.config.dataManagement.dataLanguages,config:state.scenes.configuration.nodesConfig.config,superUserUsername:state.app.superUser.username,isMsdsVisible:state.scenes.configuration.nodesConfig.isMsdsVisible,msds:state.scenes.configuration.nodesConfig.msds,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(config){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["t" /* changeNodesConfigConfig */])(config));},onNodeAdd:function onNodeAdd(dataLangs){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["s" /* addNodesConfigNode */])(dataLangs));},onNewNodeRemove:function onNewNodeRemove(index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["D" /* removeNodesConfigNewNode */])(index));},onNodeRemove:function onNodeRemove(index,nodeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["E" /* removeNodesConfigNode */])(index,nodeId));},onNodeSubmit:function onNodeSubmit(nodeConfig,username,password){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["I" /* submitNodesConfigNodeConfig */])(nodeConfig,username,password));},onNodeSort:function onNodeSort(orderedNodes){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["H" /* sortNodesConfigNode */])(orderedNodes));},showConfigurationSuperUserLoginForm:function showConfigurationSuperUserLoginForm(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_authentication_actions__["e" /* showSuperUserLoginForm */])());},scrollToLastNewNode:function scrollToLastNewNode(lastNewNodeElement){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__middlewares_scrollTo_actions__["b" /* scrollTo */])(lastNewNodeElement));},onNodeCollapsedChange:function onNodeCollapsedChange(nodeIndex,collapsed){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["u" /* changeNodesConfigNodeCollapsed */])(nodeIndex,collapsed));},fetchConfig:function fetchConfig(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["A" /* getNodesConfigConfig */])());},onMsdsHide:function onMsdsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["B" /* hideNodesConfigMsds */])());},fetchMsds:function fetchMsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["C" /* readNodesConfigMsds */])());},onMsdSet:function onMsdSet(obj){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["F" /* setNodesConfigMsd */])(obj));},onNodeProviderSubmit:function onNodeProviderSubmit(nodeConfig,providerId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["J" /* submitNodesConfigNodeConfigProvider */])(nodeConfig,providerId));}};};var NodesConfig=function(_React$Component){_inherits(NodesConfig,_React$Component);function NodesConfig(){_classCallCheck(this,NodesConfig);return _possibleConstructorReturn(this,(NodesConfig.__proto__||Object.getPrototypeOf(NodesConfig)).apply(this,arguments));}_createClass(NodesConfig,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.config&&this.props.config&&prevProps.config.length<this.props.config.length){var nodeCards=document.getElementsByClassName("nodes-config__node");this.props.scrollToLastNewNode(nodeCards[nodeCards.length-1]);}}},{key:'render',value:function render(){var _props=this.props,t=_props.t,dataLangs=_props.dataLangs,config=_props.config,superUserUsername=_props.superUserUsername,onNodeAdd=_props.onNodeAdd,onNodeRemove=_props.onNodeRemove,onNewNodeRemove=_props.onNewNodeRemove,_onChange=_props.onChange,showConfigurationSuperUserLoginForm=_props.showConfigurationSuperUserLoginForm,onNodeSubmit=_props.onNodeSubmit,onNodeSort=_props.onNodeSort,onNodeCollapsedChange=_props.onNodeCollapsedChange,fetchConfig=_props.fetchConfig,isMsdsVisible=_props.isMsdsVisible,msds=_props.msds,user=_props.user,onMsdsHide=_props.onMsdsHide,fetchMsds=_props.fetchMsds,onMsdSet=_props.onMsdSet,onNodeProviderSubmit=_props.onNodeProviderSubmit;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:showConfigurationSuperUserLoginForm,disabled:superUserUsername!==null},superUserUsername&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:fetchConfig,disabled:config!==null},config!==null&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){return onNodeAdd(dataLangs);},type:'primary',icon:'plus',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},t('scenes.configuration.nodesConfig.buttons.addNode.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_beautiful_dnd__["a" /* DragDropContext */],{onDragEnd:function onDragEnd(_ref){var src=_ref.source,dest=_ref.destination;var moved=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(config[src.index]);var orderedNodes=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(config).filter(function(node,index){return index!==src.index;});orderedNodes=[].concat(_toConsumableArray(orderedNodes.slice(0,dest.index)),[moved],_toConsumableArray(orderedNodes.slice(dest.index)));onNodeSort(orderedNodes);}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_beautiful_dnd__["c" /* Droppable */],{droppableId:'droppable'},function(provided){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',Object.assign({},provided.droppableProps,{ref:provided.innerRef}),config.map(function(node,key){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_beautiful_dnd__["b" /* Draggable */],{key:key,draggableId:''+key,index:key},function(provided){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',Object.assign({ref:provided.innerRef},provided.draggableProps),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default.a,{className:'nodes-config__node',key:key,activeKey:'expanded',onChange:function onChange(){return onNodeCollapsedChange(key,!node.isCollapsed);}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default.a.Panel,{key:node.isCollapsed?'collapsed':'expanded',header:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{justify:'space-between',type:'flex'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('span',provided.dragHandleProps,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_drag_handle__["a" /* default */],null)),node.isNewNode?t('scenes.configuration.nodesConfig.newNodeCard.title'):node.General&&node.General.Name||t('scenes.configuration.nodesConfig.noNameNodeCard.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{size:'small',icon:'delete',title:t("scenes.configuration.nodesConfig.buttons.removeNode.title"),style:{marginRight:8},onClick:function onClick(event){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:node.isNewNode?t("scenes.configuration.nodesConfig.modals.deleteConfirm.title_newNode"):t("scenes.configuration.nodesConfig.modals.deleteConfirm.title",{id:node.General.ID}),onOk:function onOk(){node.isNewNode?onNewNodeRemove(key):onNodeRemove(key,node.General.ID);},cancelText:t('commons.buttons.cancel.title')});event.stopPropagation();}})))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__node__["a" /* default */],{node:node,onChange:function onChange(node){var newConfig=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(config);var customizer=function customizer(_,src){if(Array.isArray(src))return src;else{return undefined;}};__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.mergeWith(newConfig[key],node,customizer);_onChange(newConfig);},index:key}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{disabled:!node.General.ID||!node.General.Name||!node.General.DefaultItemsViewMode||node.Agencies.find(function(ag){return!ag.Id||ag.Id.length===0||!Object(__WEBPACK_IMPORTED_MODULE_29__utils_artefactValidators__["d" /* isDictionaryValid */])(ag.Name);})!==undefined||!node.Endpoint.NSIEndpoint||node.Endpoint.NSIEndpoint.length===0||node.Endpoint.NSIReadOnlyUsername&&!node.Endpoint.NSIReadOnlyPassword||!node.Endpoint.NSIReadOnlyUsername&&node.Endpoint.NSIReadOnlyPassword||!node.Endpoint.NSIEndpointType||!node.Endpoint.PingArtefact||node.AnnotationTabs.Tabs.filter(function(at){return!at.Name||!at.Annotations||at.Annotations.filter(function(a){return!a.Name;}).length;}).length||node.Proxy.Enabled&&(!node.Proxy.Address||!node.Proxy.Port||node.Proxy.Username&&!node.Proxy.Password||!node.Proxy.Username&&node.Proxy.Password)||node.Search.ExcludeCodelists.filter(function(ex){return!ex;}).length||node.Search.ExcludeConceptSchemes.filter(function(ex){return!ex;}).length||!node.Annotations||__WEBPACK_IMPORTED_MODULE_22_lodash___default()(node.Annotations).pickBy(function(val){return!val||val.length===0;}).keys().value().length>0||(node.DataBrowser.DataBrowserUrl||node.DataBrowser.Enable)&&(!node.DataBrowser.NodeID||node.DataBrowser.NodeID.length===0)||node.DataBrowser.Enable&&(!node.DataBrowser.URL||node.DataBrowser.URL.length===0||!node.DataBrowser.NodeID||node.DataBrowser.NodeID.length===0||!node.DataBrowser.Username||node.DataBrowser.Username.length===0)||node.DataBrowser.Enable&&node.DataBrowser.HTTPAuthEnable&&(!node.DataBrowser.HTTPAuthUsername||node.DataBrowser.HTTPAuthUsername.length===0)||node.DataBrowser.Enable&&node.DataBrowser.ProxyEnable&&(!node.DataBrowser.ProxyURL||node.DataBrowser.ProxyURL.length===0||!node.DataBrowser.ProxyPort||node.DataBrowser.ProxyPort.length===0)||node.AST&&node.AST.Enabled&&(!node.AST.TerritorialDimIds||node.AST.TerritorialDimIds.length===0||!node.AST.ASTTerritoryDimId||node.AST.ASTTerritoryDimId.length===0||!node.AST.ASTTerritorialCodelist||node.AST.ASTTerritorialCodelist.length===0||!node.AST.ASTTerritoryConceptScheme||node.AST.ASTTerritoryConceptScheme.length===0||!node.AST.ASTTerritoryConcept||node.AST.ASTTerritoryConcept.length===0)||(node.LoginProviders||[]).length>0&&node.LoginProviders.some(function(provider){return(provider.ProviderName||"").length===0||(provider.AuthorizationURL||"").length===0||(provider.LoginBaseURL||"").length===0||(provider.AppId||"").length===0;}// || ((provider.AppSecret || "").length === 0)                               
),type:'primary',onClick:function onClick(){var duplicateAnnotationName=void 0;var annotationNames=[];node.AnnotationTabs.Tabs.forEach(function(_ref2){var Annotations=_ref2.Annotations;if(!duplicateAnnotationName){Annotations.forEach(function(_ref3){var Name=_ref3.Name;if(!duplicateAnnotationName){if(annotationNames.includes(Name)){duplicateAnnotationName=Name;}else{annotationNames.push(Name);}}});}});if(config.filter(function(otherNode,index){return index!==key&&otherNode.General.ID===node.General.ID;}).length){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('scenes.configuration.nodesConfig.existsIdWarning.title')});}else if(duplicateAnnotationName){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('scenes.configuration.nodesConfig.duplicateAnnotationNameWarning.title',{name:duplicateAnnotationName})});}else if((!node.Endpoint.MAEndpoint||node.Endpoint.MAEndpoint.length===0)&&(!node.Endpoint.DMEndpoint||node.Endpoint.DMEndpoint.length===0)){onNodeSubmit(node,null,null);}else if(user&&user.providerId){onNodeProviderSubmit(node,user.providerId);}else{var modal=__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.info();modal.update({icon:'lock',title:t('scenes.configuration.nodesConfig.nodeCredentialsModal.title'),content:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__NodeCredentialsModal__["a" /* default */],{t:t,modal:modal,onSubmit:function onSubmit(username,password){return onNodeSubmit(node,username,password);}}),okButtonProps:{style:{display:'none'}},keyboard:false});}}},t('commons.buttons.save.title')))));});}),provided.placeholder);}))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_enhanced_modal__["a" /* default */],{visible:isMsdsVisible,onCancel:onMsdsHide,title:t('scenes.configuration.nodesConfig.modals.msdList.title'),width:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onMsdsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:fetchMsds,disabled:!isMsdsVisible},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_artefact_list__["a" /* default */],{artefacts:msds,onRowClick:function onRowClick(artefact){return onMsdSet(Object(__WEBPACK_IMPORTED_MODULE_27__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(artefact));}}))));}}]);return NodesConfig;}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_19_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(NodesConfig));

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROVIDERS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_list__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LoginProviderForm__ = __webpack_require__(1460);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId};};var PROVIDERS=["ISTATSHIBBOLETH"];var LoginProvidersForm=function LoginProvidersForm(_ref){var t=_ref.t,LoginProviders=_ref.LoginProviders,onChange=_ref.onChange;var availableProviders=PROVIDERS.filter(function(provider){return!(LoginProviders||[]).map(function(_ref2){var ProviderName=_ref2.ProviderName;return ProviderName;}).filter(function(val){return val;}).includes(provider);});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.loginProviders.label')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_form_list__["a" /* default */],{values:LoginProviders,Component:__WEBPACK_IMPORTED_MODULE_7__LoginProviderForm__["a" /* default */],componentProps:{availableProviders:availableProviders},newItem:{AppId:null,AppSecret:null,AuthorizationURL:null,Enabled:true,GrantType:null,Label:null,LoginBaseURL:null,ProviderName:null,SuperadminMails:null,UserPassword:null,IsNewProvider:true},addItemLabel:t('scenes.configuration.nodesConfig.loginProviders.addButton.title'),removeItemLabel:t('scenes.configuration.nodesConfig.loginProviders.removeButton.title'),onChange:onChange,isAddItemDisabled:availableProviders.length===0}));};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps))(LoginProvidersForm));

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UserInterfaceForm__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AgenciesForm__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DataManagementForm__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DefaultHeaderSubmitStructureForm__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SuperUserCredentialList__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__middlewares_authentication_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__EndpointSettingsForm__ = __webpack_require__(1469);
var mapStateToProps=function mapStateToProps(state){return{config:state.scenes.configuration.appConfig.config,isFetchConfigDisabled:state.scenes.configuration.appConfig.isFetchConfigDisabled,superUserUsername:state.app.superUser.username};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchConfig:function fetchConfig(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["o" /* readAppConfigConfig */])());},submitConfig:function submitConfig(config){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["p" /* submitAppConfigConfig */])(config));},showConfigurationSuperUserLoginForm:function showConfigurationSuperUserLoginForm(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__middlewares_authentication_actions__["e" /* showSuperUserLoginForm */])());}};};var AppConfig=function AppConfig(_ref){var t=_ref.t,config=_ref.config,isFetchConfigDisabled=_ref.isFetchConfigDisabled,superUserUsername=_ref.superUserUsername,fetchConfig=_ref.fetchConfig,submitConfig=_ref.submitConfig,showConfigurationSuperUserLoginForm=_ref.showConfigurationSuperUserLoginForm;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__hocs_call__["a" /* default */],{cb:showConfigurationSuperUserLoginForm,disabled:superUserUsername!==null},superUserUsername&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__hocs_call__["a" /* default */],{cb:fetchConfig,disabled:isFetchConfigDisabled},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a,{tabPosition:"left"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane,{key:"userInterface",tab:t('scenes.configuration.appConfig.tabs.userInterface.title')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__UserInterfaceForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane,{key:"agencies",tab:t('scenes.configuration.appConfig.tabs.agencies.title')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__AgenciesForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane,{key:"dataManagement",tab:t('scenes.configuration.appConfig.tabs.dataManagement.title')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DataManagementForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane,{key:"defaultHeaderSubmitStructure",tab:t('scenes.configuration.appConfig.tabs.defaultHeaderSubmitStructure.title')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DefaultHeaderSubmitStructureForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane,{key:"superUserCredentials",tab:t('scenes.configuration.appConfig.tabs.superUserCredentials.title')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__SuperUserCredentialList__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane,{key:"endpointSettings",tab:t('scenes.configuration.appConfig.tabs.endpointSettings.title')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__EndpointSettingsForm__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"start"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return submitConfig(config);},disabled:!config||!config.UserInterface||config.UserInterface.MinTreeNodesForPagination===null||config.UserInterface.MinTreeNodesForPagination.length===0||config.UserInterface.MaxNodeForExpandAll===null||config.UserInterface.MaxNodeForExpandAll.length===0||config.UserInterface.TreePageSize===null||config.UserInterface.TreePageSize.length===0||config.UserInterface.Languages===null||config.UserInterface.Languages.findIndex(function(el){return el===null||el==="";})!==-1||config.UserInterface.DefaultLanguage===null||config.UserInterface.DefaultLanguage.length===0||config.UserInterface.AnonymousPages===null||config.UserInterface.AnonymousPages.length===0||config.Agencies.find(function(ag){return!ag.Id||ag.Id.length===0||!Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["d" /* isDictionaryValid */])(ag.Name);})!==undefined||!config.DataManagement||config.DataManagement.DataLanguages===null||config.DataManagement.DataLanguages.findIndex(function(el){return(el===null||el==="")!==-1;})||config.DataManagement.MaxDescriptionLength===null||config.DataManagement.MaxDescriptionLength.length===0||!config.DefaultHeaderSubmitStructure||config.DefaultHeaderSubmitStructure.ID===null||config.DefaultHeaderSubmitStructure.ID.length===0||config.DefaultHeaderSubmitStructure.sender===null||config.DefaultHeaderSubmitStructure.sender.length===0||config.DefaultHeaderSubmitStructure.receiver===null||config.DefaultHeaderSubmitStructure.receiver.length===0||!config.SuperUserCredentials||config.SuperUserCredentials.findIndex(function(el){return el.username===null||el.username==="";})!==-1||config.SuperUserCredentials.findIndex(function(el){return(el.password||"")!==(el.confirmPassword||"");})!==-1||!config.EndpointSetting||config.EndpointSetting.NsiTimeOut===null||config.EndpointSetting.NsiTimeOut.length===0||config.EndpointSetting.DmTimeOut===null||config.EndpointSetting.DmTimeOut.length===0||config.EndpointSetting.MaTimeOut===null||config.EndpointSetting.MaTimeOut.length===0},t("commons.buttons.save.title"))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(AppConfig));

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
var mapPropsToFields=function mapPropsToFields(_ref){var value=_ref.value;return{Code:__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.createFormField({value:value!==null?value.Code:null}),Flag:__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.createFormField({value:value!==null?value.Flag:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var LanguageForm=function LanguageForm(_ref3){var t=_ref3.t,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,{layout:"inline"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t("scenes.configuration.appConfig.languageForm.code"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("Code")(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{title:form.getFieldValue("Code")}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t("scenes.configuration.appConfig.languageForm.flag"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("Flag")(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{title:form.getFieldValue("Flag"),suffix:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip___default.a,{title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('a',{target:'_blank',href:'https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('u',null,'https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2'))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'info-circle'}))}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(LanguageForm));

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__FilterTab__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ReleaseCalendarTab__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_artefact_download_form__ = __webpack_require__(97);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,isVisible:instanceState.isVisible,forceIsFinalDisabled:instanceState.forceIsFinalDisabled,isEditDisabled:instanceState.isEditDisabled,contentConstraintTriplet:instanceState.contentConstraintTriplet,isContentConstraintValid:instanceState.isContentConstraintValid,isAgenciesValid:instanceState.isAgenciesValid,isContentConstraintGeneralTabDirty:instanceState.isContentConstraintGeneralTabDirty,contentConstraint:instanceState.contentConstraint,agencies:instanceState.agencies,allAgencies:instanceState.allAgencies,downloadContentConstraintTriplet:instanceState.downloadContentConstraintTriplet,downloadContentConstraintLang:instanceState.downloadContentConstraintLang,downloadContentConstraintParams:instanceState.downloadContentConstraintParams,cloneDestTriplet:instanceState.cloneDestTriplet,focusItemsTab:instanceState.focusItemsTab,artefactType:instanceState.artefactType,isArtefactsVisible:instanceState.isArtefactsVisible,artefacts:instanceState.artefacts,artefactTriplet:instanceState.artefactTriplet,artefact:instanceState.artefact,filterDsdTriplet:instanceState.filterDsdTriplet,filterCubeId:instanceState.filterCubeId,filterColumns:instanceState.filterColumns,filter:instanceState.filter,isFilterModalVisible:instanceState.isFilterModalVisible,isFilterQueryVisible:instanceState.isFilterQueryVisible,releaseCalendar:instanceState.releaseCalendar,contentConstraintExportSourceTriplet:instanceState.contentConstraintExportSourceTriplet,contentConstraintExportDestination:instanceState.contentConstraintExportDestination,contentConstraintExportReport:instanceState.contentConstraintExportReport,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onDetailHide:function onDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_0" /* hideContentConstraintDetail */])(),instancePrefix));},onDetailChange:function onDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["Q" /* changeContentConstraintDetail */])(fields),instancePrefix));},onDetailCreate:function onDetailCreate(contentConstraint,attachmentType,attachmentUrn,filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_28" /* submitContentConstraintDetailCreate */])(contentConstraint,attachmentType,attachmentUrn,filter),instancePrefix));},onDetailUpdate:function onDetailUpdate(contentConstraint,attachmentType,attachmentUrn,filter,keepModalOpen){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_31" /* submitContentConstraintDetailUpdate */])(contentConstraint,attachmentType,attachmentUrn,filter,keepModalOpen),instancePrefix));},fetchContentConstraint:function fetchContentConstraint(contentConstraintTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_8" /* readContentConstraintDetail */])(contentConstraintTriplet),instancePrefix));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_9" /* readContentConstraintDetailAgencies */])(allowedAgencies),instancePrefix));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_23" /* showContentConstraintDetailDownload */])(artefactTriplets,lang),instancePrefix));},onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_3" /* hideContentConstraintDetailDownload */])(),instancePrefix));},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["S" /* changeContentConstraintDetailDownload */])(fields),instancePrefix));},onDownloadSubmit:function onDownloadSubmit(artefactTriplet,downloadContentConstraintParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_29" /* submitContentConstraintDetailDownload */])(artefactTriplet,downloadContentConstraintParams,lang),instancePrefix));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_22" /* showContentConstraintDetailClone */])(artefactTriplet),instancePrefix));},onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_2" /* hideContentConstraintDetailClone */])(),instancePrefix));},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["R" /* changeContentConstraintDetailClone */])(fields),instancePrefix));},onCloneSubmit:function onCloneSubmit(cloneDestTriplet,srcContentConstraint,srcContentConstraintType,srcContentConstraintUrn,srcContentConstraintFilter,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_27" /* submitContentConstraintDetailClone */])(cloneDestTriplet,srcContentConstraint,srcContentConstraintType,srcContentConstraintUrn,srcContentConstraintFilter,annotationsConfig),instancePrefix));},onExportShow:function onExportShow(sourceTriplet,sourceAttachmentType,sourceAttachmentUrn,sourceFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_24" /* showContentConstraintDetailExport */])(sourceTriplet,sourceAttachmentType,sourceAttachmentUrn,sourceFilter),instancePrefix));},onArtefactTypeSelect:function onArtefactTypeSelect(artefactType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_18" /* selectContentConstraintDetailArtefactType */])(artefactType),instancePrefix));},onArtefactsShow:function onArtefactsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_21" /* showContentConstraintDetailArtefacts */])(),instancePrefix));},onArtefactsHide:function onArtefactsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_1" /* hideContentConstraintDetailArtefacts */])(),instancePrefix));},fetchArtefacts:function fetchArtefacts(artefactType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_11" /* readContentConstraintDetailArtefacts */])(artefactType),instancePrefix));},onArtefactSet:function onArtefactSet(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_19" /* setContentConstraintDetailArtefact */])(artefactTriplet),instancePrefix));},onArtefactUnset:function onArtefactUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_32" /* unsetContentConstraintDetailArtefact */])(),instancePrefix));},onReleaseCalendarChange:function onReleaseCalendarChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["X" /* changeContentConstraintDetailReleaseCalendar */])(fields),instancePrefix));},onFilterReset:function onFilterReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_17" /* resetContentConstraintDetailFilter */])(),instancePrefix));},onFilterModalShow:function onFilterModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_25" /* showContentConstraintDetailFilterModal */])(),instancePrefix));},onFilterModalHide:function onFilterModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_6" /* hideContentConstraintDetailFilterModal */])(),instancePrefix));},onFilterQueryShow:function onFilterQueryShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_26" /* showContentConstraintDetailFilterQuery */])(),instancePrefix));},onFilterQueryHide:function onFilterQueryHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_7" /* hideContentConstraintDetailFilterQuery */])(),instancePrefix));},onFilterChange:function onFilterChange(filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["U" /* changeContentConstraintDetailFilter */])(filter),instancePrefix));},onFilterColumnModeChange:function onFilterColumnModeChange(colName,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["V" /* changeContentConstraintDetailFilterColumnMode */])(colName,mode),instancePrefix));},onFilterColumnValuesChange:function onFilterColumnValuesChange(colName,values){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["W" /* changeContentConstraintDetailFilterColumnValues */])(colName,values),instancePrefix));},fetchArtefact:function fetchArtefact(_ref3){var artefactType=_ref3.artefactType,artefactTriplet=_ref3.artefactTriplet,haveDMWS=_ref3.haveDMWS,isUserLogged=_ref3.isUserLogged;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_10" /* readContentConstraintDetailArtefact */])(artefactType,artefactTriplet,haveDMWS,isUserLogged),instancePrefix));},fetchFilterDsd:function fetchFilterDsd(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_16" /* readContentConstraintDetailFilterDsd */])(dsdTriplet),instancePrefix));},fetchFilterCube:function fetchFilterCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_15" /* readContentConstraintDetailFilterCube */])(cubeId),instancePrefix));},fetchFilterColumnCodelistCount:function fetchFilterColumnCodelistCount(_ref4){var codelistTriplet=_ref4.codelistTriplet,language=_ref4.language;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_12" /* readContentConstraintDetailFilterColumnCodelistCount */])(codelistTriplet,language),instancePrefix));},fetchFilterColumnFilteredValues:function fetchFilterColumnFilteredValues(cubeId,colNames,filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_14" /* readContentConstraintDetailFilterColumnFilteredValues */])(cubeId,colNames,filter),instancePrefix));},fetchFilterColumnCodelistTree:function fetchFilterColumnCodelistTree(_ref5){var codelistTriplet=_ref5.codelistTriplet,language=_ref5.language,itemsOrderAnnotationType=_ref5.itemsOrderAnnotationType;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_13" /* readContentConstraintDetailFilterColumnCodelistTree */])(codelistTriplet,language,itemsOrderAnnotationType),instancePrefix));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_4" /* hideContentConstraintDetailExport */])(),instancePrefix));},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["T" /* changeContentConstraintDetailExport */])(fields),instancePrefix));},onExportSubmit:function onExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_30" /* submitContentConstraintDetailExport */])(sourceTriplet,destination),instancePrefix));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_5" /* hideContentConstraintDetailExportReport */])(),instancePrefix));}};};var ReduxContentConstraintDetailModal=function ReduxContentConstraintDetailModal(_ref6){var t=_ref6.t,nodes=_ref6.nodes,nodeId=_ref6.nodeId,appLanguage=_ref6.appLanguage,dataLanguages=_ref6.dataLanguages,isVisible=_ref6.isVisible,isEditDisabled=_ref6.isEditDisabled,contentConstraintTriplet=_ref6.contentConstraintTriplet,isContentConstraintValid=_ref6.isContentConstraintValid,isAgenciesValid=_ref6.isAgenciesValid,isContentConstraintGeneralTabDirty=_ref6.isContentConstraintGeneralTabDirty,contentConstraint=_ref6.contentConstraint,agencies=_ref6.agencies,allAgencies=_ref6.allAgencies,onDetailHide=_ref6.onDetailHide,onDetailChange=_ref6.onDetailChange,onDetailCreate=_ref6.onDetailCreate,onDetailUpdate=_ref6.onDetailUpdate,fetchContentConstraint=_ref6.fetchContentConstraint,fetchAgencies=_ref6.fetchAgencies,permissions=_ref6.permissions,cloneDestTriplet=_ref6.cloneDestTriplet,focusItemsTab=_ref6.focusItemsTab,artefactType=_ref6.artefactType,isArtefactsVisible=_ref6.isArtefactsVisible,artefacts=_ref6.artefacts,artefactTriplet=_ref6.artefactTriplet,artefact=_ref6.artefact,filterDsdTriplet=_ref6.filterDsdTriplet,filterCubeId=_ref6.filterCubeId,filterColumns=_ref6.filterColumns,filter=_ref6.filter,onFilterColumnModeChange=_ref6.onFilterColumnModeChange,onFilterColumnValuesChange=_ref6.onFilterColumnValuesChange,onFilterChange=_ref6.onFilterChange,onFilterReset=_ref6.onFilterReset,fetchFilterDsd=_ref6.fetchFilterDsd,fetchFilterCube=_ref6.fetchFilterCube,fetchFilterColumnCodelistCount=_ref6.fetchFilterColumnCodelistCount,fetchFilterColumnCodelistTree=_ref6.fetchFilterColumnCodelistTree,fetchFilterColumnFilteredValues=_ref6.fetchFilterColumnFilteredValues,releaseCalendar=_ref6.releaseCalendar,downloadContentConstraintTriplet=_ref6.downloadContentConstraintTriplet,downloadContentConstraintLang=_ref6.downloadContentConstraintLang,downloadContentConstraintParams=_ref6.downloadContentConstraintParams,onDownloadShow=_ref6.onDownloadShow,onDownloadHide=_ref6.onDownloadHide,onDownloadChange=_ref6.onDownloadChange,onDownloadSubmit=_ref6.onDownloadSubmit,onCloneShow=_ref6.onCloneShow,onCloneHide=_ref6.onCloneHide,onCloneChange=_ref6.onCloneChange,onCloneSubmit=_ref6.onCloneSubmit,onExportShow=_ref6.onExportShow,onArtefactTypeSelect=_ref6.onArtefactTypeSelect,onArtefactsShow=_ref6.onArtefactsShow,onArtefactsHide=_ref6.onArtefactsHide,fetchArtefacts=_ref6.fetchArtefacts,onArtefactSet=_ref6.onArtefactSet,onArtefactUnset=_ref6.onArtefactUnset,onReleaseCalendarChange=_ref6.onReleaseCalendarChange,fetchArtefact=_ref6.fetchArtefact,onFilterQueryShow=_ref6.onFilterQueryShow,onFilterQueryHide=_ref6.onFilterQueryHide,onFilterModalShow=_ref6.onFilterModalShow,onFilterModalHide=_ref6.onFilterModalHide,isFilterModalVisible=_ref6.isFilterModalVisible,isFilterQueryVisible=_ref6.isFilterQueryVisible,contentConstraintExportSourceTriplet=_ref6.contentConstraintExportSourceTriplet,contentConstraintExportDestination=_ref6.contentConstraintExportDestination,contentConstraintExportReport=_ref6.contentConstraintExportReport,user=_ref6.user,onExportHide=_ref6.onExportHide,onExportChange=_ref6.onExportChange,onExportSubmit=_ref6.onExportSubmit,onExportReportHide=_ref6.onExportReportHide,forceIsFinalDisabled=_ref6.forceIsFinalDisabled;var userHasPermissionsToEdit=permissions&&contentConstraintTriplet&&permissions.agencies.filter(function(agency){return agency===contentConstraintTriplet.agencyID;}).length>0;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchContentConstraint,cbParam:contentConstraintTriplet,disabled:isContentConstraintValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:isAgenciesValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_XL"],title:contentConstraintTriplet!==null?userHasPermissionsToEdit&&!isEditDisabled?t('scenes.metaManager.contentConstraints.detail.title.editMode.title',{triplet:contentConstraintTriplet}):t('scenes.metaManager.contentConstraints.detail.title.viewMode.title',{triplet:contentConstraintTriplet}):t('scenes.metaManager.contentConstraints.detail.title.createMode.title'),onCancel:onDetailHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onDetailHide},t('commons.buttons.close.title')),contentConstraintTriplet===null||userHasPermissionsToEdit||!isEditDisabled?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["a" /* isArtefactValid */])(contentConstraint)&&artefactType!==null&&artefactTriplet!==null){if(contentConstraintTriplet!==null){onDetailUpdate(contentConstraint,artefactType,Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(artefactTriplet),artefactType===__WEBPACK_IMPORTED_MODULE_27__constants_download__["h" /* ARTEFACT_TYPE_DSD */]?__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */]:__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */]),filter);}else{onDetailCreate(contentConstraint,artefactType,Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(artefactTriplet),artefactType===__WEBPACK_IMPORTED_MODULE_27__constants_download__["h" /* ARTEFACT_TYPE_DSD */]?__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */]:__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */]),filter);}}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,contentConstraintTriplet&&permissions&&!userHasPermissionsToEdit&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),contentConstraintTriplet&&!isEditDisabled&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],justify:"end"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onDownloadShow([contentConstraintTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){return onCloneShow(contentConstraintTriplet);}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onExportShow(contentConstraintTriplet,artefactType,Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(artefactTriplet),artefactType===__WEBPACK_IMPORTED_MODULE_27__constants_download__["h" /* ARTEFACT_TYPE_DSD */]?__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */]:__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */]),filter);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{defaultActiveKey:focusItemsTab?"constraintItems":"general"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'general',tab:t('commons.artefact.tabs.general.title')},contentConstraint&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:contentConstraint,mode:contentConstraintTriplet?userHasPermissionsToEdit&&!isEditDisabled?__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */],agencies:agencies,onChange:onDetailChange,isFinalDisabled:forceIsFinalDisabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'constraintItems',tab:t('scenes.metaManager.commons.detail.tabs.constraintItems.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__FilterTab__["c" /* default */],{disabled:isEditDisabled||contentConstraintTriplet!==null&&!userHasPermissionsToEdit||contentConstraintTriplet!==null&&contentConstraint!==null&&contentConstraint.isFinal,artefactType:artefactType,artefactTriplet:artefactTriplet,artefact:artefact,filterColumns:filterColumns,onArtefactTypeSelect:onArtefactTypeSelect,onArtefactsShow:onArtefactsShow,onArtefactUnset:onArtefactUnset,fetchArtefact:fetchArtefact,fetchFilterDsd:fetchFilterDsd,fetchFilterCube:fetchFilterCube,onFilterReset:onFilterReset,fetchFilterColumnCodelistCount:fetchFilterColumnCodelistCount,fetchFilterColumnCodelistTree:fetchFilterColumnCodelistTree,fetchFilterColumnFilteredValues:fetchFilterColumnFilteredValues,onFilterChange:onFilterChange,filter:filter,filterDsdTriplet:filterDsdTriplet,filterCubeId:filterCubeId,onFilterColumnModeChange:onFilterColumnModeChange,onFilterColumnValuesChange:onFilterColumnValuesChange,isFilterModalVisible:isFilterModalVisible,onFilterModalShow:onFilterModalShow,onFilterModalHide:onFilterModalHide,onFilterQueryShow:onFilterQueryShow,onFilterQueryHide:onFilterQueryHide,isFilterQueryVisible:isFilterQueryVisible})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'releaseCalendar',tab:t('scenes.metaManager.commons.detail.tabs.releaseCalendar.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('errors.notSupportedBySdmxSource')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__ReleaseCalendarTab__["a" /* default */],{disabled:isEditDisabled||contentConstraintTriplet!==null&&!userHasPermissionsToEdit||contentConstraintTriplet!==null&&contentConstraint!==null&&contentConstraint.isFinal,releaseCalendar:releaseCalendar,onReleaseCalendarChange:onReleaseCalendarChange}))));})))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isArtefactsVisible,onCancel:onArtefactsHide,title:t('scenes.metaManager.commons.detail.modals.artefactList.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onArtefactsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchArtefacts,cbParam:artefactType,disabled:isArtefactsVisible===false},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_artefact_list__["a" /* default */],{artefacts:artefacts,getIsDisabledRow:function getIsDisabledRow(_ref7){var isFinal=_ref7.isFinal;return!isFinal;},onRowClick:function onRowClick(_ref8){var id=_ref8.id,agencyID=_ref8.agencyID,version=_ref8.version;return onArtefactSet({id:id,agencyID:agencyID,version:version});}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:downloadContentConstraintTriplet!==null&&downloadContentConstraintTriplet!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){return onDownloadSubmit(downloadContentConstraintTriplet,downloadContentConstraintParams,downloadContentConstraintLang);},type:'primary',disabled:downloadContentConstraintParams&&downloadContentConstraintParams.format===null||downloadContentConstraintParams&&downloadContentConstraintParams.format===__WEBPACK_IMPORTED_MODULE_27__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadContentConstraintParams.csvSeparator===null||downloadContentConstraintParams.csvSeparator.length!==1||downloadContentConstraintParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_SM"],title:downloadContentConstraintTriplet&&downloadContentConstraintTriplet.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadContentConstraintTriplet?Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadContentConstraintTriplet[0]):""})},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadContentConstraintParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_27__constants_download__["v" /* getArtefactDownloadOptions */])(t,__WEBPACK_IMPORTED_MODULE_27__constants_download__["e" /* ARTEFACT_TYPE_CONTENT_CONSTRAINT */]),langs:dataLanguages,hasReferences:true})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(cloneDestTriplet,contentConstraint,artefactType,Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(artefactTriplet),artefactType===__WEBPACK_IMPORTED_MODULE_27__constants_download__["h" /* ARTEFACT_TYPE_DSD */]?__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */]:__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */]),filter,nodes.find(function(node){return node.general.id===nodeId;}).annotations);}},type:'primary'},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:contentConstraint,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:contentConstraintExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["e" /* isExportDestinationValid */])(contentConstraintExportDestination,(user&&user.providerId)!==null)){onExportSubmit(contentConstraintExportSourceTriplet,contentConstraintExportDestination);}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_artefact_export_form__["b" /* default */],{type:'contentconstraint',agencies:allAgencies,sourceTriplet:contentConstraintExportSourceTriplet,destination:contentConstraintExportDestination,onChange:onExportChange})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:contentConstraintExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_artefact_export_report__["a" /* default */],{report:contentConstraintExportReport})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ReduxContentConstraintDetailModal));

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_calendar_es_locale_en_US__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__time_picker_locale_en_US__ = __webpack_require__(589);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


 // Merge into a locale object

var locale = {
  lang: _extends({
    placeholder: 'Select date',
    rangePlaceholder: ['Start date', 'End date']
  }, __WEBPACK_IMPORTED_MODULE_0_rc_calendar_es_locale_en_US__["a" /* default */]),
  timePickerLocale: _extends({}, __WEBPACK_IMPORTED_MODULE_1__time_picker_locale_en_US__["a" /* default */])
}; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var locale = {
  placeholder: 'Select time'
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_context__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_context__);

var RowContext = __WEBPACK_IMPORTED_MODULE_0_create_react_context___default()({});
/* harmony default export */ __webpack_exports__["a"] = (RowContext);

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(1501);

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData("text", text);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return METADATA_SET_DETAIL_MODE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return METADATA_SET_DETAIL_MODE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return METADATA_SET_DETAIL_MODE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isMetadataSetIdWarningVisible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_localized_date_picker__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_annotations_form__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_delayed_input__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_multilanguage_zoomable_textarea__ = __webpack_require__(141);
var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions};};var mapPropsToFields=function mapPropsToFields(_ref){var metadataSet=_ref.metadataSet;return{id:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet?metadataSet.id:null}),name:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet?metadataSet.name:null}),metadataflowTriplet:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet&&metadataSet.metadataflowTriplet?Object(__WEBPACK_IMPORTED_MODULE_21__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(metadataSet.metadataflowTriplet):null}),msdTriplet:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet&&metadataSet.msdUrn?Object(__WEBPACK_IMPORTED_MODULE_21__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_21__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(metadataSet.msdUrn)):null}),reportingBegin:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet?metadataSet.reportingBegin:null}),reportingEnd:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet?metadataSet.reportingEnd:null}),validFrom:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet?metadataSet.validFrom:null}),validTo:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet?metadataSet.validTo:null}),publicationYear:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet?metadataSet.publicationYear:null}),publicationPeriod:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:metadataSet?metadataSet.publicationPeriod:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onMetadataSetChange(__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var METADATA_SET_DETAIL_MODE_CREATE="METADATA_SET_DETAIL_MODE_CREATE";var METADATA_SET_DETAIL_MODE_READ="METADATA_SET_DETAIL_MODE_READ";var METADATA_SET_DETAIL_MODE_EDIT="METADATA_SET_DETAIL_MODE_EDIT";var formItemLayout=function formItemLayout(isDcat){return{labelCol:isDcat?{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_ONE_QUARTER"]}:undefined,wrapperCol:isDcat?{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_THREE_QUARTERS"]}:undefined};};var rowStyle=function rowStyle(isDcat){return{marginBottom:isDcat?__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]:undefined,marginLeft:isDcat?__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]:undefined,marginRight:isDcat?__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]:undefined};};var datePickerProps={format:'DD/MM/YYYY'};var isMetadataSetIdWarningVisible=function isMetadataSetIdWarningVisible(metadataSet,metadataSets){if(metadataSet&&!Object(__WEBPACK_IMPORTED_MODULE_23__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_23__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */])){return!!(metadataSets||[]).find(function(_ref3){var id=_ref3.id;return id===metadataSet.id;});}else{return false;}};var MetadataSetDetail=function MetadataSetDetail(_ref4){var t=_ref4.t,form=_ref4.form,permissions=_ref4.permissions,isDcat=_ref4.isDcat,_ref4$mode=_ref4.mode,mode=_ref4$mode===undefined?METADATA_SET_DETAIL_MODE_READ:_ref4$mode,metadataSet=_ref4.metadataSet,isMetadataflowsVisible=_ref4.isMetadataflowsVisible,metadataflows=_ref4.metadataflows,metadataSets=_ref4.metadataSets,onMetadataSetChange=_ref4.onMetadataSetChange,onMetadataflowsShow=_ref4.onMetadataflowsShow,onMetadataflowsHide=_ref4.onMetadataflowsHide,fetchMetadataflows=_ref4.fetchMetadataflows,onMetadataflowSet=_ref4.onMetadataflowSet,onMetadataflowUnset=_ref4.onMetadataflowUnset;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,metadataSet&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_MD"],style:rowStyle(isDcat)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.id.label"),className:'form-item-required',hasFeedback:true,validateStatus:isMetadataSetIdWarningVisible(metadataSet,metadataSets)||form.getFieldValue("id")&&Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue("id")).help?"warning":null,help:isMetadataSetIdWarningVisible(metadataSet,metadataSets)?t("scenes.referenceMetadata.commons.metadataSetDetail.id.alreadyUsed.help"):form.getFieldValue("id")?Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue("id")).help||undefined:undefined},formItemLayout(isDcat)),form.getFieldDecorator("id",{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_delayed_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,title:form.getFieldValue("id"),disabled:mode!==METADATA_SET_DETAIL_MODE_CREATE,style:{textTransform:"uppercase"}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.name.label"),className:'form-item-required'},formItemLayout(isDcat)),form.getFieldDecorator("name")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_delayed_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_26__components_multilanguage_zoomable_textarea__["a" /* default */],disabled:mode===METADATA_SET_DETAIL_MODE_READ}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_MD"],style:rowStyle(isDcat)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.metadataflow.label"),className:'form-item-required'},formItemLayout(isDcat)),form.getFieldDecorator("metadataflowTriplet")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_selector__["a" /* default */],{selectTitle:t('scenes.referenceMetadata.commons.metadataSetDetail.metadataflow.selector.select.title'),resetTitle:t('scenes.referenceMetadata.commons.metadataSetDetail.metadataflow.selector.reset.title'),onSelect:onMetadataflowsShow,onReset:onMetadataflowUnset,disabled:mode===METADATA_SET_DETAIL_MODE_READ})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.msd.label"),className:'form-item-required'},formItemLayout(isDcat)),form.getFieldDecorator("msdTriplet")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{disabled:true}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_MD"],style:rowStyle(isDcat)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.reportingBegin.label")},formItemLayout(isDcat)),form.getFieldDecorator("reportingBegin")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_localized_date_picker__["a" /* default */],Object.assign({disabled:mode===METADATA_SET_DETAIL_MODE_READ},datePickerProps))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.reportingEnd.label")},formItemLayout(isDcat),{hasFeedback:true,validateStatus:!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["c" /* isDateValid */])(metadataSet.reportingBegin,metadataSet.reportingEnd)?"warning":null,help:!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["c" /* isDateValid */])(metadataSet.reportingBegin,metadataSet.reportingEnd)?t("commons.helps.invalidDateRange.label"):null}),form.getFieldDecorator("reportingEnd")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_localized_date_picker__["a" /* default */],Object.assign({disabled:mode===METADATA_SET_DETAIL_MODE_READ},datePickerProps)))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_MD"],style:rowStyle(isDcat)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.validFrom.label")},formItemLayout(isDcat)),form.getFieldDecorator("validFrom")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_localized_date_picker__["a" /* default */],Object.assign({disabled:mode===METADATA_SET_DETAIL_MODE_READ},datePickerProps))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.validTo.label")},formItemLayout(isDcat),{hasFeedback:true,validateStatus:!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["c" /* isDateValid */])(metadataSet.validFrom,metadataSet.validTo)?"warning":null,help:!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["c" /* isDateValid */])(metadataSet.validFrom,metadataSet.validTo)?t("commons.helps.invalidDateRange.label"):null}),form.getFieldDecorator("validTo")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_localized_date_picker__["a" /* default */],Object.assign({disabled:mode===METADATA_SET_DETAIL_MODE_READ},datePickerProps)))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_MD"],style:rowStyle(isDcat)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.publicationYear.label")},formItemLayout(isDcat),{hasFeedback:true,validateStatus:metadataSet.publicationYear&&!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["j" /* isYearValid */])(metadataSet.publicationYear)?"warning":null,help:metadataSet.publicationYear&&!Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["j" /* isYearValid */])(metadataSet.publicationYear)?t("scenes.referenceMetadata.commons.metadataSetDetail.publicationYear.help"):undefined}),form.getFieldDecorator("publicationYear")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_delayed_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,title:form.getFieldValue("publicationYear"),disabled:mode===METADATA_SET_DETAIL_MODE_READ,style:{width:"100%"}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.commons.metadataSetDetail.publicationPeriod.label")},formItemLayout(isDcat)),form.getFieldDecorator("publicationPeriod")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_delayed_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,title:form.getFieldValue("publicationPeriod"),disabled:mode===METADATA_SET_DETAIL_MODE_READ})))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_annotations_form__["a" /* default */],{annotations:metadataSet?metadataSet.annotations:null,onChange:onMetadataSetChange,genericOnly:true,isGenericOneLinePerField:!isDcat,disabled:mode===METADATA_SET_DETAIL_MODE_READ})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isMetadataflowsVisible,onCancel:onMetadataflowsHide,title:t('scenes.referenceMetadata.commons.metadataSetDetail.modals.metadataflowsList.title'),width:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onMetadataflowsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchMetadataflows,cbParam:permissions&&permissions.metadataflowOwner?permissions.metadataflowOwner:[]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_list__["a" /* default */],{artefacts:metadataflows,onRowClick:function onRowClick(_ref5){var id=_ref5.id,agencyID=_ref5.agencyID,version=_ref5.version,structure=_ref5.structure;return onMetadataflowSet({id:id,agencyID:agencyID,version:version},structure);}}))));};/* harmony default export */ __webpack_exports__["d"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(MetadataSetDetail));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ON_CHANGE_TIMEOUT=100;var DelayedInput=function DelayedInput(props,ref){var Component=props.Component,externalValue=props.value,onChange=props.onChange;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),value=_useState2[0],setValue=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),timeoutId=_useState4[0],setTimeoutId=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return function(){if(timeoutId){clearTimeout(timeoutId);}};},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(externalValue!==null&&externalValue!==undefined&&value===null){setValue(externalValue);}},[externalValue]);var callOnChange=function callOnChange(value){setValue(value);if(onChange){if(timeoutId){clearTimeout(timeoutId);}setTimeoutId(setTimeout(function(){return onChange(value);},ON_CHANGE_TIMEOUT));}};var componentProps=Object.assign({},props);delete componentProps.Component;delete componentProps.getValueFromEvent;var getValueFromEvent=props.getValueFromEvent||function(e){return e.target?e.target.value:e;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},componentProps,{ref:ref,value:value,onChange:function onChange(e){return callOnChange(getValueFromEvent(e));}}));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(DelayedInput));

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_steps_style__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_steps_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_steps_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_steps__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_report_structure_tree__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ReportList__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__ = __webpack_require__(77);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,permissions:state.app.user.permissions,dataLanguages:state.config.dataManagement.dataLanguages};};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["SPAN_TWO_THIRDS"]}};var ReportDetail=function ReportDetail(_ref){var t=_ref.t,nodes=_ref.nodes,nodeId=_ref.nodeId,permissions=_ref.permissions,dataLanguages=_ref.dataLanguages,isDcat=_ref.isDcat,hasPermission=_ref.hasPermission,isReadOnly=_ref.isReadOnly,step=_ref.step,metadataSet=_ref.metadataSet,msdTree=_ref.msdTree,report=_ref.report,reports=_ref.reports,reportStructure=_ref.reportStructure,selectedAttribute=_ref.selectedAttribute,reportId=_ref.reportId,target=_ref.target,identifiableTargets=_ref.identifiableTargets,selectedIdentifiableTarget=_ref.selectedIdentifiableTarget,artefacts=_ref.artefacts,dataflow=_ref.dataflow,isCodesVisible=_ref.isCodesVisible,codes=_ref.codes,onAttributeSelect=_ref.onAttributeSelect,onAttributeChange=_ref.onAttributeChange,onAttributeCreate=_ref.onAttributeCreate,onAttributeDelete=_ref.onAttributeDelete,onStepSet=_ref.onStepSet,onCodesShow=_ref.onCodesShow,onCodesHide=_ref.onCodesHide,fetchCodes=_ref.fetchCodes,onCodeSet=_ref.onCodeSet,onCodeUnset=_ref.onCodeUnset,onIdChange=_ref.onIdChange,onTargetSelect=_ref.onTargetSelect,onArtefactsShow=_ref.onArtefactsShow,onArtefactsHide=_ref.onArtefactsHide,fetchArtefacts=_ref.fetchArtefacts,onArtefactSet=_ref.onArtefactSet,onArtefactUnset=_ref.onArtefactUnset,fetchDataflow=_ref.fetchDataflow,onDataflowChange=_ref.onDataflowChange,onDataflowSubmit=_ref.onDataflowSubmit,onDataflowHide=_ref.onDataflowHide,onAttachmentUpload=_ref.onAttachmentUpload,onAttachmentDownload=_ref.onAttachmentDownload;var connectedNode=nodes.find(function(node){return node.general.id===nodeId;});var mawsUrl=connectedNode.endpoint.maEndpoint;var attributeTitle=Object(__WEBPACK_IMPORTED_MODULE_36__utils_tree__["k" /* getNode */])(reportStructure,"metadataAttributes",function(_ref2){var id=_ref2.id;return id==="DCAT_AP_IT_DATASET_TITLE";});var dataLangs=dataLanguages.map(function(_ref3){var code=_ref3.code;return code;});return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["SPAN_THREE_QUARTERS"]},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_steps___default.a,{current:step,size:"small"},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_steps___default.a.Step,{icon:__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{shape:"circle",type:step===__WEBPACK_IMPORTED_MODULE_25__constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */]?'primary':null,onClick:function onClick(){return onStepSet(__WEBPACK_IMPORTED_MODULE_25__constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */],dataLanguages,t,mawsUrl);},size:"small"},"1"),title:__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{style:{cursor:'pointer'},onClick:function onClick(){return onStepSet(__WEBPACK_IMPORTED_MODULE_25__constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */],dataLanguages,t,mawsUrl);}},t("scenes.referenceMetadata.commons.reportDetails.steps.first.label"))}),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_steps___default.a.Step,{icon:__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{shape:"circle",size:"small",type:step===__WEBPACK_IMPORTED_MODULE_25__constants__["c" /* REPORT_DETAILS_WIZARD_STEP_SECOND */]?'primary':null,onClick:function onClick(){return onStepSet(__WEBPACK_IMPORTED_MODULE_25__constants__["c" /* REPORT_DETAILS_WIZARD_STEP_SECOND */],dataLanguages,t,mawsUrl);},disabled:reportId===null||reportId.length===0||report===null&&Object(__WEBPACK_IMPORTED_MODULE_33__ReportList__["b" /* isReportIdWarningVisible */])(reportId,reports)||target===null||identifiableTargets.find(function(el){return!el.value||el.value.length===0;})},"2"),title:__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{style:reportId===null||reportId.length===0||report===null&&Object(__WEBPACK_IMPORTED_MODULE_33__ReportList__["b" /* isReportIdWarningVisible */])(reportId,reports)||target===null||identifiableTargets.find(function(el){return!el.value||el.value.length===0;})?null:{cursor:'pointer'},onClick:function onClick(){return reportId===null||reportId.length===0||report===null&&Object(__WEBPACK_IMPORTED_MODULE_33__ReportList__["b" /* isReportIdWarningVisible */])(reportId,reports)||target===null||identifiableTargets.find(function(el){return!el.value||el.value.length===0;})?null:onStepSet(__WEBPACK_IMPORTED_MODULE_25__constants__["c" /* REPORT_DETAILS_WIZARD_STEP_SECOND */],dataLanguages,t,mawsUrl);}},t("scenes.referenceMetadata.commons.reportDetails.steps.second.label"))})))),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{style:{marginTop:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["MARGIN_MD"],height:"calc(100% - 48px)"}},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default.a,null),isReadOnly?__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a,{type:"warning",showIcon:true,message:t('scenes.referenceMetadata.commons.reportDetails.alerts.isReadOnly.label')}):isDcat&&target===__WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__["u" /* DATAFLOW_TARGET_ID */]&&step===__WEBPACK_IMPORTED_MODULE_25__constants__["c" /* REPORT_DETAILS_WIZARD_STEP_SECOND */]&&(!attributeTitle||!attributeTitle.texts||dataLangs.find(function(lang){return(attributeTitle.texts[lang]||"").length===0;}))&&__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a,{type:"warning",showIcon:true,message:t('scenes.referenceMetadata.commons.reportDetails.alerts.missingDataflowAttribute.label')}),step===__WEBPACK_IMPORTED_MODULE_25__constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */]?__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.referenceMetadata.commons.reportDetails.report.id.label'),className:"form-item-required",hasFeedback:true,validateStatus:report===null&&Object(__WEBPACK_IMPORTED_MODULE_33__ReportList__["b" /* isReportIdWarningVisible */])(reportId,reports)?"warning":null,help:report===null&&Object(__WEBPACK_IMPORTED_MODULE_33__ReportList__["b" /* isReportIdWarningVisible */])(reportId,reports)?t("scenes.referenceMetadata.commons.reportDetails.report.id.alreadyUsed.help"):undefined},formItemLayout),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{value:reportId,onChange:function onChange(e){return onIdChange(e.target.value);},disabled:report!==null}))),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.referenceMetadata.commons.reportDetails.target.id.label'),className:"form-item-required"},formItemLayout),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},value:target,onSelect:function onSelect(value){onTargetSelect(value);isDcat&&value===__WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__["t" /* CATALOG_TARGET_ID */]&&onArtefactSet(Object(__WEBPACK_IMPORTED_MODULE_29__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(metadataSet),__WEBPACK_IMPORTED_MODULE_29__utils_sdmxJson__["J" /* SDMX_JSON_METADATAFLOW_URN_NAMESPACE */]),__WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__["s" /* CATALOG_IDENTIFIER */]);},disabled:report!==null||!hasPermission||isReadOnly,style:{width:"100%"}},msdTree.filter(function(_ref5){var target=_ref5.target;return isDcat?target!==__WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__["t" /* CATALOG_TARGET_ID */]||!(reports||[]).find(function(_ref6){var target=_ref6.target;return target.id===__WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__["t" /* CATALOG_TARGET_ID */];}):true;}).map(function(_ref7){var target=_ref7.target;return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{key:target,value:target,title:target},target);})))),identifiableTargets?identifiableTargets.map(function(identifiableTarget){return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{key:identifiableTarget.id,style:{marginBottom:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:identifiableTarget.objectType,className:"form-item-required"},formItemLayout),isDcat&&target===__WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__["t" /* CATALOG_TARGET_ID */]?__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{value:Object(__WEBPACK_IMPORTED_MODULE_29__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_37__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(metadataSet)),disabled:true}):__WEBPACK_IMPORTED_MODULE_25__constants__["a" /* ARTEFACT_TYPES */].map(function(_ref8){var type=_ref8.type;return type;}).includes(identifiableTarget.objectType.toLowerCase())?__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_selector__["a" /* default */],{value:identifiableTarget.value?Object(__WEBPACK_IMPORTED_MODULE_29__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_29__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(identifiableTarget.value)):null,selectTitle:t('scenes.referenceMetadata.commons.reportDetails.selector.select.title'),resetTitle:t('scenes.referenceMetadata.commons.reportDetails.selector.reset.title'),detailTitle:t('scenes.referenceMetadata.commons.reportDetails.selector.detail.title'),onSelect:function onSelect(){return onArtefactsShow(identifiableTarget);},onReset:function onReset(){return onArtefactUnset(identifiableTarget);},onDetail:isDcat&&identifiableTarget.objectType==="Dataflow"?function(){return fetchDataflow(Object(__WEBPACK_IMPORTED_MODULE_29__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(identifiableTarget.value));}:null,disabled:!hasPermission||isReadOnly}):__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{value:identifiableTarget.value,onChange:function onChange(e){return onArtefactSet(e.target.value,identifiableTarget.id);},disabled:!hasPermission||isReadOnly})));}):null):__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_report_structure_tree__["a" /* default */],{reportStructure:reportStructure,selectedAttribute:selectedAttribute,disabled:!hasPermission||isReadOnly,onAttributeSelect:onAttributeSelect,onAttributeChange:onAttributeChange,onAttributeCreate:onAttributeCreate,onAttributeDelete:onAttributeDelete,onCodesShow:onCodesShow,onCodeUnset:onCodeUnset,isDcatReport:isDcat,onFileUpload:onAttachmentUpload,onFileDownload:onAttachmentDownload,height:"calc(100% - "+(25+(isReadOnly?55:0))+"px)"})),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_enhanced_modal__["a" /* default */],{visible:isCodesVisible,onCancel:onCodesHide,title:t('scenes.referenceMetadata.commons.reportDetails.modals.codeList.title'),width:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{onClick:onCodesHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__hocs_call__["a" /* default */],{cb:fetchCodes,cbParam:selectedAttribute&&selectedAttribute.localRepresentation&&selectedAttribute.localRepresentation.enumeration?Object(__WEBPACK_IMPORTED_MODULE_29__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(selectedAttribute.localRepresentation.enumeration):null,disabled:selectedAttribute===null||selectedAttribute.localRepresentation.enumeration===null},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_item_list__["a" /* default */],{data:codes,onRowClick:function onRowClick(_ref9){var id=_ref9.id;return onCodeSet(id);},hideOrderCol:true}))),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_enhanced_modal__["a" /* default */],{visible:dataflow!==null&&dataflow!==undefined,onCancel:onDataflowHide,title:t('scenes.referenceMetadata.commons.reportDetails.modals.dataflowDetail.title'),width:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["MODAL_WIDTH_LG"],withDataLanguageSelector:true,footer:__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{onClick:onDataflowHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(dataflow&&Object(__WEBPACK_IMPORTED_MODULE_34__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)){onDataflowSubmit(dataflow);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__components_artefact_form__["d" /* default */],{artefact:dataflow,mode:hasPermission&&!isReadOnly?__WEBPACK_IMPORTED_MODULE_35__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_35__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],onChange:onDataflowChange})),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_enhanced_modal__["a" /* default */],{visible:selectedIdentifiableTarget!==null,onCancel:onArtefactsHide,title:t('scenes.referenceMetadata.commons.reportDetails.modals.artefactList.title'),width:__WEBPACK_IMPORTED_MODULE_26__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{onClick:onArtefactsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__hocs_call__["a" /* default */],{cb:fetchArtefacts,cbParam:{identifiableTarget:selectedIdentifiableTarget,ownedDataflows:permissions&&permissions.dataflowOwner?permissions.dataflowOwner:[]},disabled:selectedIdentifiableTarget===null},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_artefact_list__["a" /* default */],{artefacts:artefacts,onRowClick:function onRowClick(_ref10){var id=_ref10.id,agencyID=_ref10.agencyID,version=_ref10.version;return onArtefactSet({id:id,agencyID:agencyID,version:version});}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_23_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_21_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["b" /* connect */])(mapStateToProps))(ReportDetail));

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

/*!*
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function(t,n){ true?module.exports=n(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],n):"object"==typeof exports?exports.CKEditor=n(require("react")):t.CKEditor=n(t.React)}("undefined"!=typeof self?self:this,function(t){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var o in t)e.d(r,o,function(n){return t[n]}.bind(null,o));return r},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=115)}([function(t,n,e){var r=e(1),o=e(16),i=e(31),c=e(50),u=r.Symbol,a=o("wks");t.exports=function(t){return a[t]||(a[t]=c&&u[t]||(c?u:i)("Symbol."+t))}},function(t,n,e){(function(n){var e="object",r=function(t){return t&&t.Math==Math&&t};t.exports=r(typeof globalThis==e&&globalThis)||r(typeof window==e&&window)||r(typeof self==e&&self)||r(typeof n==e&&n)||Function("return this")()}).call(this,e(70))},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var e={}.hasOwnProperty;t.exports=function(t,n){return e.call(t,n)}},function(t,n,e){var r=e(1),o=e(21).f,i=e(6),c=e(15),u=e(30),a=e(46),f=e(49);t.exports=function(t,n){var e,s,l,p,v,y=t.target,d=t.global,h=t.stat;if(e=d?r:h?r[y]||u(y,{}):(r[y]||{}).prototype)for(s in n){if(p=n[s],l=t.noTargetGet?(v=o(e,s))&&v.value:e[s],!f(d?s:y+(h?".":"#")+s,t.forced)&&void 0!==l){if(typeof p==typeof l)continue;a(p,l)}(t.sham||l&&l.sham)&&i(p,"sham",!0),c(e,s,p,t)}}},function(t,n,e){var r=e(9),o=e(8),i=e(14);t.exports=r?function(t,n,e){return o.f(t,n,i(1,e))}:function(t,n,e){return t[n]=e,t}},function(t,n,e){var r=e(3);t.exports=function(t){if(!r(t))throw TypeError(String(t)+" is not an object");return t}},function(t,n,e){var r=e(9),o=e(44),i=e(7),c=e(23),u=Object.defineProperty;n.f=r?u:function(t,n,e){if(i(t),n=c(n,!0),i(e),o)try{return u(t,n,e)}catch(t){}if("get"in e||"set"in e)throw TypeError("Accessors not supported");return"value"in e&&(t[n]=e.value),t}},function(t,n,e){var r=e(2);t.exports=!r(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var e={}.toString;t.exports=function(t){return e.call(t).slice(8,-1)}},function(t,n,e){t.exports=e(99)()},function(t,n,e){var r=e(43),o=e(22);t.exports=function(t){return r(o(t))}},function(t,n,e){var r=e(22);t.exports=function(t){return Object(r(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,e){var r=e(1),o=e(16),i=e(6),c=e(4),u=e(30),a=e(45),f=e(18),s=f.get,l=f.enforce,p=String(a).split("toString");o("inspectSource",function(t){return a.call(t)}),(t.exports=function(t,n,e,o){var a=!!o&&!!o.unsafe,f=!!o&&!!o.enumerable,s=!!o&&!!o.noTargetGet;"function"==typeof e&&("string"!=typeof n||c(e,"name")||i(e,"name",n),l(e).source=p.join("string"==typeof n?n:"")),t!==r?(a?!s&&t[n]&&(f=!0):delete t[n],f?t[n]=e:i(t,n,e)):f?t[n]=e:u(n,e)})(Function.prototype,"toString",function(){return"function"==typeof this&&s(this).source||a.call(this)})},function(t,n,e){var r=e(1),o=e(30),i=e(17),c=r["__core-js_shared__"]||o("__core-js_shared__",{});(t.exports=function(t,n){return c[t]||(c[t]=void 0!==n?n:{})})("versions",[]).push({version:"3.1.3",mode:i?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(t,n){t.exports=!1},function(t,n,e){var r,o,i,c=e(71),u=e(1),a=e(3),f=e(6),s=e(4),l=e(24),p=e(25),v=u.WeakMap;if(c){var y=new v,d=y.get,h=y.has,g=y.set;r=function(t,n){return g.call(y,t,n),n},o=function(t){return d.call(y,t)||{}},i=function(t){return h.call(y,t)}}else{var m=l("state");p[m]=!0,r=function(t,n){return f(t,m,n),n},o=function(t){return s(t,m)?t[m]:{}},i=function(t){return s(t,m)}}t.exports={set:r,get:o,has:i,enforce:function(t){return i(t)?o(t):r(t,{})},getterFor:function(t){return function(n){var e;if(!a(n)||(e=o(n)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return e}}}},function(t,n,e){var r=e(34),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,n){t.exports={}},function(t,n,e){var r=e(9),o=e(42),i=e(14),c=e(12),u=e(23),a=e(4),f=e(44),s=Object.getOwnPropertyDescriptor;n.f=r?s:function(t,n){if(t=c(t),n=u(n,!0),f)try{return s(t,n)}catch(t){}if(a(t,n))return i(!o.f.call(t,n),t[n])}},function(t,n){t.exports=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t}},function(t,n,e){var r=e(3);t.exports=function(t,n){if(!r(t))return t;var e,o;if(n&&"function"==typeof(e=t.toString)&&!r(o=e.call(t)))return o;if("function"==typeof(e=t.valueOf)&&!r(o=e.call(t)))return o;if(!n&&"function"==typeof(e=t.toString)&&!r(o=e.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n,e){var r=e(16),o=e(31),i=r("keys");t.exports=function(t){return i[t]||(i[t]=o(t))}},function(t,n){t.exports={}},function(t,n,e){var r=e(32),o=e(1),i=function(t){return"function"==typeof t?t:void 0};t.exports=function(t,n){return arguments.length<2?i(r[t])||i(o[t]):r[t]&&r[t][n]||o[t]&&o[t][n]}},function(t,n,e){var r=e(8).f,o=e(4),i=e(0)("toStringTag");t.exports=function(t,n,e){t&&!o(t=e?t:t.prototype,i)&&r(t,i,{configurable:!0,value:n})}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t}},function(t,n,e){var r=e(1),o=e(3),i=r.document,c=o(i)&&o(i.createElement);t.exports=function(t){return c?i.createElement(t):{}}},function(t,n,e){var r=e(1),o=e(6);t.exports=function(t,n){try{o(r,t,n)}catch(e){r[t]=n}return n}},function(t,n){var e=0,r=Math.random();t.exports=function(t){return"Symbol("+String(void 0===t?"":t)+")_"+(++e+r).toString(36)}},function(t,n,e){t.exports=e(1)},function(t,n,e){var r=e(47),o=e(35).concat("length","prototype");n.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,n){var e=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:e)(t)}},function(t,n){t.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},function(t,n,e){var r=e(10);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,n,e){var r=e(7),o=e(75),i=e(35),c=e(25),u=e(51),a=e(29),f=e(24)("IE_PROTO"),s=function(){},l=function(){var t,n=a("iframe"),e=i.length;for(n.style.display="none",u.appendChild(n),n.src=String("javascript:"),(t=n.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),l=t.F;e--;)delete l.prototype[i[e]];return l()};t.exports=Object.create||function(t,n){var e;return null!==t?(s.prototype=r(t),e=new s,s.prototype=null,e[f]=t):e=l(),void 0===n?e:o(e,n)},c[f]=!0},function(t,n,e){var r=e(47),o=e(35);t.exports=Object.keys||function(t){return r(t,o)}},function(t,n,e){var r=e(28);t.exports=function(t,n,e){if(r(t),void 0===n)return t;switch(e){case 0:return function(){return t.call(n)};case 1:return function(e){return t.call(n,e)};case 2:return function(e,r){return t.call(n,e,r)};case 3:return function(e,r,o){return t.call(n,e,r,o)}}return function(){return t.apply(n,arguments)}}},function(t,n,e){var r=e(4),o=e(13),i=e(24),c=e(60),u=i("IE_PROTO"),a=Object.prototype;t.exports=c?Object.getPrototypeOf:function(t){return t=o(t),r(t,u)?t[u]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(n,e){n.exports=t},function(t,n,e){"use strict";var r={}.propertyIsEnumerable,o=Object.getOwnPropertyDescriptor,i=o&&!r.call({1:2},1);n.f=i?function(t){var n=o(this,t);return!!n&&n.enumerable}:r},function(t,n,e){var r=e(2),o=e(10),i="".split;t.exports=r(function(){return!Object("z").propertyIsEnumerable(0)})?function(t){return"String"==o(t)?i.call(t,""):Object(t)}:Object},function(t,n,e){var r=e(9),o=e(2),i=e(29);t.exports=!r&&!o(function(){return 7!=Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a})},function(t,n,e){var r=e(16);t.exports=r("native-function-to-string",Function.toString)},function(t,n,e){var r=e(4),o=e(72),i=e(21),c=e(8);t.exports=function(t,n){for(var e=o(n),u=c.f,a=i.f,f=0;f<e.length;f++){var s=e[f];r(t,s)||u(t,s,a(n,s))}}},function(t,n,e){var r=e(4),o=e(12),i=e(73).indexOf,c=e(25);t.exports=function(t,n){var e,u=o(t),a=0,f=[];for(e in u)!r(c,e)&&r(u,e)&&f.push(e);for(;n.length>a;)r(u,e=n[a++])&&(~i(f,e)||f.push(e));return f}},function(t,n){n.f=Object.getOwnPropertySymbols},function(t,n,e){var r=e(2),o=/#|\.prototype\./,i=function(t,n){var e=u[c(t)];return e==f||e!=a&&("function"==typeof n?r(n):!!n)},c=i.normalize=function(t){return String(t).replace(o,".").toLowerCase()},u=i.data={},a=i.NATIVE="N",f=i.POLYFILL="P";t.exports=i},function(t,n,e){var r=e(2);t.exports=!!Object.getOwnPropertySymbols&&!r(function(){return!String(Symbol())})},function(t,n,e){var r=e(26);t.exports=r("document","documentElement")},function(t,n,e){n.f=e(0)},function(t,n,e){var r=e(32),o=e(4),i=e(52),c=e(8).f;t.exports=function(t){var n=r.Symbol||(r.Symbol={});o(n,t)||c(n,t,{value:i.f(t)})}},function(t,n,e){var r=e(39),o=e(43),i=e(13),c=e(19),u=e(55),a=[].push,f=function(t){var n=1==t,e=2==t,f=3==t,s=4==t,l=6==t,p=5==t||l;return function(v,y,d,h){for(var g,m,b=i(v),x=o(b),O=r(y,d,3),S=c(x.length),w=0,j=h||u,E=n?j(v,S):e?j(v,0):void 0;S>w;w++)if((p||w in x)&&(m=O(g=x[w],w,b),t))if(n)E[w]=m;else if(m)switch(t){case 3:return!0;case 5:return g;case 6:return w;case 2:a.call(E,g)}else if(s)return!1;return l?-1:f||s?s:E}};t.exports={forEach:f(0),map:f(1),filter:f(2),some:f(3),every:f(4),find:f(5),findIndex:f(6)}},function(t,n,e){var r=e(3),o=e(36),i=e(0)("species");t.exports=function(t,n){var e;return o(t)&&("function"!=typeof(e=t.constructor)||e!==Array&&!o(e.prototype)?r(e)&&null===(e=e[i])&&(e=void 0):e=void 0),new(void 0===e?Array:e)(0===n?0:n)}},function(t,n,e){"use strict";var r=e(54).forEach,o=e(83);t.exports=o("forEach")?function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}:[].forEach},function(t,n,e){"use strict";var r=e(12),o=e(84),i=e(20),c=e(18),u=e(58),a=c.set,f=c.getterFor("Array Iterator");t.exports=u(Array,"Array",function(t,n){a(this,{type:"Array Iterator",target:r(t),index:0,kind:n})},function(){var t=f(this),n=t.target,e=t.kind,r=t.index++;return!n||r>=n.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==e?{value:r,done:!1}:"values"==e?{value:n[r],done:!1}:{value:[r,n[r]],done:!1}},"values"),i.Arguments=i.Array,o("keys"),o("values"),o("entries")},function(t,n,e){"use strict";var r=e(5),o=e(85),i=e(40),c=e(61),u=e(27),a=e(6),f=e(15),s=e(0),l=e(17),p=e(20),v=e(59),y=v.IteratorPrototype,d=v.BUGGY_SAFARI_ITERATORS,h=s("iterator"),g=function(){return this};t.exports=function(t,n,e,s,v,m,b){o(e,n,s);var x,O,S,w=function(t){if(t===v&&_)return _;if(!d&&t in T)return T[t];switch(t){case"keys":case"values":case"entries":return function(){return new e(this,t)}}return function(){return new e(this)}},j=n+" Iterator",E=!1,T=t.prototype,P=T[h]||T["@@iterator"]||v&&T[v],_=!d&&P||w(v),k="Array"==n&&T.entries||P;if(k&&(x=i(k.call(new t)),y!==Object.prototype&&x.next&&(l||i(x)===y||(c?c(x,y):"function"!=typeof x[h]&&a(x,h,g)),u(x,j,!0,!0),l&&(p[j]=g))),"values"==v&&P&&"values"!==P.name&&(E=!0,_=function(){return P.call(this)}),l&&!b||T[h]===_||a(T,h,_),p[n]=_,v)if(O={values:w("values"),keys:m?_:w("keys"),entries:w("entries")},b)for(S in O)!d&&!E&&S in T||f(T,S,O[S]);else r({target:n,proto:!0,forced:d||E},O);return O}},function(t,n,e){"use strict";var r,o,i,c=e(40),u=e(6),a=e(4),f=e(0),s=e(17),l=f("iterator"),p=!1;[].keys&&("next"in(i=[].keys())?(o=c(c(i)))!==Object.prototype&&(r=o):p=!0),null==r&&(r={}),s||a(r,l)||u(r,l,function(){return this}),t.exports={IteratorPrototype:r,BUGGY_SAFARI_ITERATORS:p}},function(t,n,e){var r=e(2);t.exports=!r(function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype})},function(t,n,e){var r=e(7),o=e(86);t.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var t,n=!1,e={};try{(t=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(e,[]),n=e instanceof Array}catch(t){}return function(e,i){return r(e),o(i),n?t.call(e,i):e.__proto__=i,e}}():void 0)},function(t,n,e){var r=e(15),o=e(90),i=Object.prototype;o!==i.toString&&r(i,"toString",o,{unsafe:!0})},function(t,n,e){var r=e(10),o=e(0)("toStringTag"),i="Arguments"==r(function(){return arguments}());t.exports=function(t){var n,e,c;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(e=function(t,n){try{return t[n]}catch(t){}}(n=Object(t),o))?e:i?r(n):"Object"==(c=r(n))&&"function"==typeof n.callee?"Arguments":c}},function(t,n){t.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},function(t,n,e){var r,o,i,c=e(1),u=e(2),a=e(10),f=e(39),s=e(51),l=e(29),p=c.location,v=c.setImmediate,y=c.clearImmediate,d=c.process,h=c.MessageChannel,g=c.Dispatch,m=0,b={},x=function(t){if(b.hasOwnProperty(t)){var n=b[t];delete b[t],n()}},O=function(t){return function(){x(t)}},S=function(t){x(t.data)},w=function(t){c.postMessage(t+"",p.protocol+"//"+p.host)};v&&y||(v=function(t){for(var n=[],e=1;arguments.length>e;)n.push(arguments[e++]);return b[++m]=function(){("function"==typeof t?t:Function(t)).apply(void 0,n)},r(m),m},y=function(t){delete b[t]},"process"==a(d)?r=function(t){d.nextTick(O(t))}:g&&g.now?r=function(t){g.now(O(t))}:h?(i=(o=new h).port2,o.port1.onmessage=S,r=f(i.postMessage,i,1)):!c.addEventListener||"function"!=typeof postMessage||c.importScripts||u(w)?r="onreadystatechange"in l("script")?function(t){s.appendChild(l("script")).onreadystatechange=function(){s.removeChild(this),x(t)}}:function(t){setTimeout(O(t),0)}:(r=w,c.addEventListener("message",S,!1))),t.exports={set:v,clear:y}},function(t,n,e){var r=e(26);t.exports=r("navigator","userAgent")||""},function(t,n,e){"use strict";var r=e(28),o=function(t){var n,e;this.promise=new t(function(t,r){if(void 0!==n||void 0!==e)throw TypeError("Bad Promise constructor");n=t,e=r}),this.resolve=r(n),this.reject=r(e)};t.exports.f=function(t){return new o(t)}},function(t,n){function e(t,n){t.onload=function(){this.onerror=this.onload=null,n(null,t)},t.onerror=function(){this.onerror=this.onload=null,n(new Error("Failed to load "+this.src),t)}}function r(t,n){t.onreadystatechange=function(){"complete"!=this.readyState&&"loaded"!=this.readyState||(this.onreadystatechange=null,n(null,t))}}t.exports=function(t,n,o){var i=document.head||document.getElementsByTagName("head")[0],c=document.createElement("script");"function"==typeof n&&(o=n,n={}),n=n||{},o=o||function(){},c.type=n.type||"text/javascript",c.charset=n.charset||"utf8",c.async=!("async"in n)||!!n.async,c.src=t,n.attrs&&function(t,n){for(var e in n)t.setAttribute(e,n[e])}(c,n.attrs),n.text&&(c.text=""+n.text),("onload"in c?e:r)(c,o),c.onload||e(c,o),i.appendChild(c)}},function(t,n,e){"use strict";var r=e(5),o=e(1),i=e(17),c=e(9),u=e(50),a=e(2),f=e(4),s=e(36),l=e(3),p=e(7),v=e(13),y=e(12),d=e(23),h=e(14),g=e(37),m=e(38),b=e(33),x=e(76),O=e(48),S=e(21),w=e(8),j=e(42),E=e(6),T=e(15),P=e(16),_=e(24),k=e(25),L=e(31),A=e(0),C=e(52),M=e(53),I=e(27),R=e(18),D=e(54).forEach,F=_("hidden"),N=A("toPrimitive"),W=R.set,G=R.getterFor("Symbol"),H=Object.prototype,U=o.Symbol,B=o.JSON,K=B&&B.stringify,V=S.f,q=w.f,z=x.f,Y=j.f,J=P("symbols"),$=P("op-symbols"),Q=P("string-to-symbol-registry"),X=P("symbol-to-string-registry"),Z=P("wks"),tt=o.QObject,nt=!tt||!tt.prototype||!tt.prototype.findChild,et=c&&a(function(){return 7!=g(q({},"a",{get:function(){return q(this,"a",{value:7}).a}})).a})?function(t,n,e){var r=V(H,n);r&&delete H[n],q(t,n,e),r&&t!==H&&q(H,n,r)}:q,rt=function(t,n){var e=J[t]=g(U.prototype);return W(e,{type:"Symbol",tag:t,description:n}),c||(e.description=n),e},ot=u&&"symbol"==typeof U.iterator?function(t){return"symbol"==typeof t}:function(t){return Object(t)instanceof U},it=function(t,n,e){t===H&&it($,n,e),p(t);var r=d(n,!0);return p(e),f(J,r)?(e.enumerable?(f(t,F)&&t[F][r]&&(t[F][r]=!1),e=g(e,{enumerable:h(0,!1)})):(f(t,F)||q(t,F,h(1,{})),t[F][r]=!0),et(t,r,e)):q(t,r,e)},ct=function(t,n){p(t);var e=y(n),r=m(e).concat(st(e));return D(r,function(n){c&&!ut.call(e,n)||it(t,n,e[n])}),t},ut=function(t){var n=d(t,!0),e=Y.call(this,n);return!(this===H&&f(J,n)&&!f($,n))&&(!(e||!f(this,n)||!f(J,n)||f(this,F)&&this[F][n])||e)},at=function(t,n){var e=y(t),r=d(n,!0);if(e!==H||!f(J,r)||f($,r)){var o=V(e,r);return!o||!f(J,r)||f(e,F)&&e[F][r]||(o.enumerable=!0),o}},ft=function(t){var n=z(y(t)),e=[];return D(n,function(t){f(J,t)||f(k,t)||e.push(t)}),e},st=function(t){var n=t===H,e=z(n?$:y(t)),r=[];return D(e,function(t){!f(J,t)||n&&!f(H,t)||r.push(J[t])}),r};u||(T((U=function(){if(this instanceof U)throw TypeError("Symbol is not a constructor");var t=arguments.length&&void 0!==arguments[0]?String(arguments[0]):void 0,n=L(t),e=function(t){this===H&&e.call($,t),f(this,F)&&f(this[F],n)&&(this[F][n]=!1),et(this,n,h(1,t))};return c&&nt&&et(H,n,{configurable:!0,set:e}),rt(n,t)}).prototype,"toString",function(){return G(this).tag}),j.f=ut,w.f=it,S.f=at,b.f=x.f=ft,O.f=st,c&&(q(U.prototype,"description",{configurable:!0,get:function(){return G(this).description}}),i||T(H,"propertyIsEnumerable",ut,{unsafe:!0})),C.f=function(t){return rt(A(t),t)}),r({global:!0,wrap:!0,forced:!u,sham:!u},{Symbol:U}),D(m(Z),function(t){M(t)}),r({target:"Symbol",stat:!0,forced:!u},{for:function(t){var n=String(t);if(f(Q,n))return Q[n];var e=U(n);return Q[n]=e,X[e]=n,e},keyFor:function(t){if(!ot(t))throw TypeError(t+" is not a symbol");if(f(X,t))return X[t]},useSetter:function(){nt=!0},useSimple:function(){nt=!1}}),r({target:"Object",stat:!0,forced:!u,sham:!c},{create:function(t,n){return void 0===n?g(t):ct(g(t),n)},defineProperty:it,defineProperties:ct,getOwnPropertyDescriptor:at}),r({target:"Object",stat:!0,forced:!u},{getOwnPropertyNames:ft,getOwnPropertySymbols:st}),r({target:"Object",stat:!0,forced:a(function(){O.f(1)})},{getOwnPropertySymbols:function(t){return O.f(v(t))}}),B&&r({target:"JSON",stat:!0,forced:!u||a(function(){var t=U();return"[null]"!=K([t])||"{}"!=K({a:t})||"{}"!=K(Object(t))})},{stringify:function(t){for(var n,e,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(e=n=r[1],(l(n)||void 0!==t)&&!ot(t))return s(n)||(n=function(t,n){if("function"==typeof e&&(n=e.call(this,t,n)),!ot(n))return n}),r[1]=n,K.apply(B,r)}}),U.prototype[N]||E(U.prototype,N,U.prototype.valueOf),I(U,"Symbol"),k[F]=!0},function(t,n){var e;e=function(){return this}();try{e=e||new Function("return this")()}catch(t){"object"==typeof window&&(e=window)}t.exports=e},function(t,n,e){var r=e(1),o=e(45),i=r.WeakMap;t.exports="function"==typeof i&&/native code/.test(o.call(i))},function(t,n,e){var r=e(26),o=e(33),i=e(48),c=e(7);t.exports=r("Reflect","ownKeys")||function(t){var n=o.f(c(t)),e=i.f;return e?n.concat(e(t)):n}},function(t,n,e){var r=e(12),o=e(19),i=e(74),c=function(t){return function(n,e,c){var u,a=r(n),f=o(a.length),s=i(c,f);if(t&&e!=e){for(;f>s;)if((u=a[s++])!=u)return!0}else for(;f>s;s++)if((t||s in a)&&a[s]===e)return t||s||0;return!t&&-1}};t.exports={includes:c(!0),indexOf:c(!1)}},function(t,n,e){var r=e(34),o=Math.max,i=Math.min;t.exports=function(t,n){var e=r(t);return e<0?o(e+n,0):i(e,n)}},function(t,n,e){var r=e(9),o=e(8),i=e(7),c=e(38);t.exports=r?Object.defineProperties:function(t,n){i(t);for(var e,r=c(n),u=r.length,a=0;u>a;)o.f(t,e=r[a++],n[e]);return t}},function(t,n,e){var r=e(12),o=e(33).f,i={}.toString,c="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return c&&"[object Window]"==i.call(t)?function(t){try{return o(t)}catch(t){return c.slice()}}(t):o(r(t))}},function(t,n,e){"use strict";var r=e(5),o=e(9),i=e(1),c=e(4),u=e(3),a=e(8).f,f=e(46),s=i.Symbol;if(o&&"function"==typeof s&&(!("description"in s.prototype)||void 0!==s().description)){var l={},p=function(){var t=arguments.length<1||void 0===arguments[0]?void 0:String(arguments[0]),n=this instanceof p?new s(t):void 0===t?s():s(t);return""===t&&(l[n]=!0),n};f(p,s);var v=p.prototype=s.prototype;v.constructor=p;var y=v.toString,d="Symbol(test)"==String(s("test")),h=/^Symbol\((.*)\)[^)]+$/;a(v,"description",{configurable:!0,get:function(){var t=u(this)?this.valueOf():this,n=y.call(t);if(c(l,t))return"";var e=d?n.slice(7,-1):n.replace(h,"$1");return""===e?void 0:e}}),r({global:!0,forced:!0},{Symbol:p})}},function(t,n,e){e(53)("iterator")},function(t,n,e){"use strict";var r=e(5),o=e(2),i=e(36),c=e(3),u=e(13),a=e(19),f=e(80),s=e(55),l=e(81),p=e(0)("isConcatSpreadable"),v=!o(function(){var t=[];return t[p]=!1,t.concat()[0]!==t}),y=l("concat"),d=function(t){if(!c(t))return!1;var n=t[p];return void 0!==n?!!n:i(t)};r({target:"Array",proto:!0,forced:!v||!y},{concat:function(t){var n,e,r,o,i,c=u(this),l=s(c,0),p=0;for(n=-1,r=arguments.length;n<r;n++)if(i=-1===n?c:arguments[n],d(i)){if(p+(o=a(i.length))>9007199254740991)throw TypeError("Maximum allowed index exceeded");for(e=0;e<o;e++,p++)e in i&&f(l,p,i[e])}else{if(p>=9007199254740991)throw TypeError("Maximum allowed index exceeded");f(l,p++,i)}return l.length=p,l}})},function(t,n,e){"use strict";var r=e(23),o=e(8),i=e(14);t.exports=function(t,n,e){var c=r(n);c in t?o.f(t,c,i(0,e)):t[c]=e}},function(t,n,e){var r=e(2),o=e(0)("species");t.exports=function(t){return!r(function(){var n=[];return(n.constructor={})[o]=function(){return{foo:1}},1!==n[t](Boolean).foo})}},function(t,n,e){"use strict";var r=e(5),o=e(56);r({target:"Array",proto:!0,forced:[].forEach!=o},{forEach:o})},function(t,n,e){"use strict";var r=e(2);t.exports=function(t,n){var e=[][t];return!e||!r(function(){e.call(null,n||function(){throw 1},1)})}},function(t,n,e){var r=e(0),o=e(37),i=e(6),c=r("unscopables"),u=Array.prototype;null==u[c]&&i(u,c,o(null)),t.exports=function(t){u[c][t]=!0}},function(t,n,e){"use strict";var r=e(59).IteratorPrototype,o=e(37),i=e(14),c=e(27),u=e(20),a=function(){return this};t.exports=function(t,n,e){var f=n+" Iterator";return t.prototype=o(r,{next:i(1,e)}),c(t,f,!1,!0),u[f]=a,t}},function(t,n,e){var r=e(3);t.exports=function(t){if(!r(t)&&null!==t)throw TypeError("Can't set "+String(t)+" as a prototype");return t}},function(t,n,e){var r=e(5),o=e(2),i=e(13),c=e(40),u=e(60);r({target:"Object",stat:!0,forced:o(function(){c(1)}),sham:!u},{getPrototypeOf:function(t){return c(i(t))}})},function(t,n,e){var r=e(5),o=e(13),i=e(38);r({target:"Object",stat:!0,forced:e(2)(function(){i(1)})},{keys:function(t){return i(o(t))}})},function(t,n,e){e(5)({target:"Object",stat:!0},{setPrototypeOf:e(61)})},function(t,n,e){"use strict";var r=e(63),o={};o[e(0)("toStringTag")]="z",t.exports="[object z]"!==String(o)?function(){return"[object "+r(this)+"]"}:o.toString},function(t,n,e){"use strict";var r=e(92).charAt,o=e(18),i=e(58),c=o.set,u=o.getterFor("String Iterator");i(String,"String",function(t){c(this,{type:"String Iterator",string:String(t),index:0})},function(){var t,n=u(this),e=n.string,o=n.index;return o>=e.length?{value:void 0,done:!0}:(t=r(e,o),n.index+=t.length,{value:t,done:!1})})},function(t,n,e){var r=e(34),o=e(22),i=function(t){return function(n,e){var i,c,u=String(o(n)),a=r(e),f=u.length;return a<0||a>=f?t?"":void 0:(i=u.charCodeAt(a))<55296||i>56319||a+1===f||(c=u.charCodeAt(a+1))<56320||c>57343?t?u.charAt(a):i:t?u.slice(a,a+2):c-56320+(i-55296<<10)+65536}};t.exports={codeAt:i(!1),charAt:i(!0)}},function(t,n,e){"use strict";var r=e(5),o=e(19),i=e(94),c=e(22),u=e(96),a="".startsWith,f=Math.min;r({target:"String",proto:!0,forced:!u("startsWith")},{startsWith:function(t){var n=String(c(this));i(t);var e=o(f(arguments.length>1?arguments[1]:void 0,n.length)),r=String(t);return a?a.call(n,r,e):n.slice(e,e+r.length)===r}})},function(t,n,e){var r=e(95);t.exports=function(t){if(r(t))throw TypeError("The method doesn't accept regular expressions");return t}},function(t,n,e){var r=e(3),o=e(10),i=e(0)("match");t.exports=function(t){var n;return r(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,e){var r=e(0)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r]=!1,"/./"[t](n)}catch(t){}}return!1}},function(t,n,e){var r=e(1),o=e(64),i=e(56),c=e(6);for(var u in o){var a=r[u],f=a&&a.prototype;if(f&&f.forEach!==i)try{c(f,"forEach",i)}catch(t){f.forEach=i}}},function(t,n,e){var r=e(1),o=e(64),i=e(57),c=e(6),u=e(0),a=u("iterator"),f=u("toStringTag"),s=i.values;for(var l in o){var p=r[l],v=p&&p.prototype;if(v){if(v[a]!==s)try{c(v,a,s)}catch(t){v[a]=s}if(v[f]||c(v,f,l),o[l])for(var y in i)if(v[y]!==i[y])try{c(v,y,i[y])}catch(t){v[y]=i[y]}}}},function(t,n,e){"use strict";var r=e(100);function o(){}function i(){}i.resetWarningCache=o,t.exports=function(){function t(t,n,e,o,i,c){if(c!==r){var u=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw u.name="Invariant Violation",u}}function n(){return t}t.isRequired=t;var e={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:n,element:t,elementType:t,instanceOf:n,node:t,objectOf:n,oneOf:n,oneOfType:n,shape:n,exact:n,checkPropTypes:i,resetWarningCache:o};return e.PropTypes=e,e}},function(t,n,e){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,n,e){"use strict";var r,o,i,c=e(5),u=e(17),a=e(1),f=e(32),s=e(102),l=e(27),p=e(103),v=e(3),y=e(28),d=e(104),h=e(10),g=e(105),m=e(109),b=e(110),x=e(65).set,O=e(111),S=e(112),w=e(113),j=e(67),E=e(114),T=e(66),P=e(18),_=e(49),k=e(0)("species"),L="Promise",A=P.get,C=P.set,M=P.getterFor(L),I=a.Promise,R=a.TypeError,D=a.document,F=a.process,N=a.fetch,W=F&&F.versions,G=W&&W.v8||"",H=j.f,U=H,B="process"==h(F),K=!!(D&&D.createEvent&&a.dispatchEvent),V=_(L,function(){var t=I.resolve(1),n=function(){},e=(t.constructor={})[k]=function(t){t(n,n)};return!((B||"function"==typeof PromiseRejectionEvent)&&(!u||t.finally)&&t.then(n)instanceof e&&0!==G.indexOf("6.6")&&-1===T.indexOf("Chrome/66"))}),q=V||!m(function(t){I.all(t).catch(function(){})}),z=function(t){var n;return!(!v(t)||"function"!=typeof(n=t.then))&&n},Y=function(t,n,e){if(!n.notified){n.notified=!0;var r=n.reactions;O(function(){for(var o=n.value,i=1==n.state,c=0;r.length>c;){var u,a,f,s=r[c++],l=i?s.ok:s.fail,p=s.resolve,v=s.reject,y=s.domain;try{l?(i||(2===n.rejection&&X(t,n),n.rejection=1),!0===l?u=o:(y&&y.enter(),u=l(o),y&&(y.exit(),f=!0)),u===s.promise?v(R("Promise-chain cycle")):(a=z(u))?a.call(u,p,v):p(u)):v(o)}catch(t){y&&!f&&y.exit(),v(t)}}n.reactions=[],n.notified=!1,e&&!n.rejection&&$(t,n)})}},J=function(t,n,e){var r,o;K?((r=D.createEvent("Event")).promise=n,r.reason=e,r.initEvent(t,!1,!0),a.dispatchEvent(r)):r={promise:n,reason:e},(o=a["on"+t])?o(r):"unhandledrejection"===t&&w("Unhandled promise rejection",e)},$=function(t,n){x.call(a,function(){var e,r=n.value;if(Q(n)&&(e=E(function(){B?F.emit("unhandledRejection",r,t):J("unhandledrejection",t,r)}),n.rejection=B||Q(n)?2:1,e.error))throw e.value})},Q=function(t){return 1!==t.rejection&&!t.parent},X=function(t,n){x.call(a,function(){B?F.emit("rejectionHandled",t):J("rejectionhandled",t,n.value)})},Z=function(t,n,e,r){return function(o){t(n,e,o,r)}},tt=function(t,n,e,r){n.done||(n.done=!0,r&&(n=r),n.value=e,n.state=2,Y(t,n,!0))},nt=function(t,n,e,r){if(!n.done){n.done=!0,r&&(n=r);try{if(t===e)throw R("Promise can't be resolved itself");var o=z(e);o?O(function(){var r={done:!1};try{o.call(e,Z(nt,t,r,n),Z(tt,t,r,n))}catch(e){tt(t,r,e,n)}}):(n.value=e,n.state=1,Y(t,n,!1))}catch(e){tt(t,{done:!1},e,n)}}};V&&(I=function(t){d(this,I,L),y(t),r.call(this);var n=A(this);try{t(Z(nt,this,n),Z(tt,this,n))}catch(t){tt(this,n,t)}},(r=function(t){C(this,{type:L,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:0,value:void 0})}).prototype=s(I.prototype,{then:function(t,n){var e=M(this),r=H(b(this,I));return r.ok="function"!=typeof t||t,r.fail="function"==typeof n&&n,r.domain=B?F.domain:void 0,e.parent=!0,e.reactions.push(r),0!=e.state&&Y(this,e,!1),r.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new r,n=A(t);this.promise=t,this.resolve=Z(nt,t,n),this.reject=Z(tt,t,n)},j.f=H=function(t){return t===I||t===i?new o(t):U(t)},u||"function"!=typeof N||c({global:!0,enumerable:!0,forced:!0},{fetch:function(t){return S(I,N.apply(a,arguments))}})),c({global:!0,wrap:!0,forced:V},{Promise:I}),l(I,L,!1,!0),p(L),i=f.Promise,c({target:L,stat:!0,forced:V},{reject:function(t){var n=H(this);return n.reject.call(void 0,t),n.promise}}),c({target:L,stat:!0,forced:u||V},{resolve:function(t){return S(u&&this===i?I:this,t)}}),c({target:L,stat:!0,forced:q},{all:function(t){var n=this,e=H(n),r=e.resolve,o=e.reject,i=E(function(){var e=y(n.resolve),i=[],c=0,u=1;g(t,function(t){var a=c++,f=!1;i.push(void 0),u++,e.call(n,t).then(function(t){f||(f=!0,i[a]=t,--u||r(i))},o)}),--u||r(i)});return i.error&&o(i.value),e.promise},race:function(t){var n=this,e=H(n),r=e.reject,o=E(function(){var o=y(n.resolve);g(t,function(t){o.call(n,t).then(e.resolve,r)})});return o.error&&r(o.value),e.promise}})},function(t,n,e){var r=e(15);t.exports=function(t,n,e){for(var o in n)r(t,o,n[o],e);return t}},function(t,n,e){"use strict";var r=e(26),o=e(8),i=e(0),c=e(9),u=i("species");t.exports=function(t){var n=r(t),e=o.f;c&&n&&!n[u]&&e(n,u,{configurable:!0,get:function(){return this}})}},function(t,n){t.exports=function(t,n,e){if(!(t instanceof n))throw TypeError("Incorrect "+(e?e+" ":"")+"invocation");return t}},function(t,n,e){var r=e(7),o=e(106),i=e(19),c=e(39),u=e(107),a=e(108),f=function(t,n){this.stopped=t,this.result=n};(t.exports=function(t,n,e,s,l){var p,v,y,d,h,g,m=c(n,e,s?2:1);if(l)p=t;else{if("function"!=typeof(v=u(t)))throw TypeError("Target is not iterable");if(o(v)){for(y=0,d=i(t.length);d>y;y++)if((h=s?m(r(g=t[y])[0],g[1]):m(t[y]))&&h instanceof f)return h;return new f(!1)}p=v.call(t)}for(;!(g=p.next()).done;)if((h=a(p,m,g.value,s))&&h instanceof f)return h;return new f(!1)}).stop=function(t){return new f(!0,t)}},function(t,n,e){var r=e(0),o=e(20),i=r("iterator"),c=Array.prototype;t.exports=function(t){return void 0!==t&&(o.Array===t||c[i]===t)}},function(t,n,e){var r=e(63),o=e(20),i=e(0)("iterator");t.exports=function(t){if(null!=t)return t[i]||t["@@iterator"]||o[r(t)]}},function(t,n,e){var r=e(7);t.exports=function(t,n,e,o){try{return o?n(r(e)[0],e[1]):n(e)}catch(n){var i=t.return;throw void 0!==i&&r(i.call(t)),n}}},function(t,n,e){var r=e(0)("iterator"),o=!1;try{var i=0,c={next:function(){return{done:!!i++}},return:function(){o=!0}};c[r]=function(){return this},Array.from(c,function(){throw 2})}catch(t){}t.exports=function(t,n){if(!n&&!o)return!1;var e=!1;try{var i={};i[r]=function(){return{next:function(){return{done:e=!0}}}},t(i)}catch(t){}return e}},function(t,n,e){var r=e(7),o=e(28),i=e(0)("species");t.exports=function(t,n){var e,c=r(t).constructor;return void 0===c||null==(e=r(c)[i])?n:o(e)}},function(t,n,e){var r,o,i,c,u,a,f,s=e(1),l=e(21).f,p=e(10),v=e(65).set,y=e(66),d=s.MutationObserver||s.WebKitMutationObserver,h=s.process,g=s.Promise,m="process"==p(h),b=l(s,"queueMicrotask"),x=b&&b.value;x||(r=function(){var t,n;for(m&&(t=h.domain)&&t.exit();o;){n=o.fn,o=o.next;try{n()}catch(t){throw o?c():i=void 0,t}}i=void 0,t&&t.enter()},m?c=function(){h.nextTick(r)}:d&&!/(iphone|ipod|ipad).*applewebkit/i.test(y)?(u=!0,a=document.createTextNode(""),new d(r).observe(a,{characterData:!0}),c=function(){a.data=u=!u}):g&&g.resolve?(f=g.resolve(void 0),c=function(){f.then(r)}):c=function(){v.call(s,r)}),t.exports=x||function(t){var n={fn:t,next:void 0};i&&(i.next=n),o||(o=n,c()),i=n}},function(t,n,e){var r=e(7),o=e(3),i=e(67);t.exports=function(t,n){if(r(t),o(n)&&n.constructor===t)return n;var e=i.f(t);return(0,e.resolve)(n),e.promise}},function(t,n,e){var r=e(1);t.exports=function(t,n){var e=r.console;e&&e.error&&(1===arguments.length?e.error(t):e.error(t,n))}},function(t,n){t.exports=function(t){try{return{error:!1,value:t()}}catch(t){return{error:!0,value:t}}}},function(t,n,e){"use strict";e.r(n);e(69),e(77),e(78),e(79),e(82),e(57),e(87),e(88),e(89),e(62),e(91),e(93),e(97),e(98);var r,o=e(41),i=e.n(o),c=e(11),u=e.n(c),a=(e(101),e(68)),f=e.n(a);var s=function(t){if("string"!=typeof t||t.length<1)throw new TypeError("CKEditor URL must be a non-empty string.");return"CKEDITOR"in window?Promise.resolve(window.CKEDITOR):(r||(r=new Promise(function(n,e){f()(t,function(t){t?e(t):(n(window.CKEDITOR),r=void 0)})})),r)};function l(t){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function p(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function v(t,n){return!n||"object"!==l(n)&&"function"!=typeof n?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):n}function y(t){return(y=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function d(t,n){return(d=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t})(t,n)}var h=function(t){function n(t){var e;return function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n),(e=v(this,y(n).call(this,t))).element=null,e.editor=null,e}var e,r,o;return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&&d(t,n)}(n,i.a.Component),e=n,(r=[{key:"componentDidMount",value:function(){this._initEditor()}},{key:"componentWillUnmount",value:function(){this._destroyEditor()}},{key:"componentDidUpdate",value:function(t){var n=this.props,e=this.editor;e&&(t.data!==n.data&&e.getData()!==n.data&&e.setData(n.data),t.readOnly!==n.readOnly&&e.setReadOnly(n.readOnly),t.style!==n.style&&e.container.setStyles(n.style),this._attachEventHandlers(t))}},{key:"render",value:function(){var t=this;return i.a.createElement("div",{contentEditable:"true",style:this.props.style,ref:function(n){return t.element=n}})}},{key:"_initEditor",value:function(){var t=this;this.props.config.readOnly=this.props.readOnly,s(n.editorUrl).then(function(n){var e="inline"===t.props.type?"inline":"replace";t.props.onBeforeLoad&&t.props.onBeforeLoad(n);var r=t.editor=n[e](t.element,t.props.config);t._attachEventHandlers(),t.props.style&&"inline"!==t.props.type&&r.on("loaded",function(){r.container.setStyles(t.props.style)}),t.props.data&&r.setData(t.props.data)}).catch(console.error)}},{key:"_attachEventHandlers",value:function(){var t=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=this.props;Object.keys(this.props).forEach(function(r){r.startsWith("on")&&n[r]!==e[r]&&t._attachEventHandler(r,n[r])})}},{key:"_attachEventHandler",value:function(t,n){var e="".concat(t[2].toLowerCase()).concat(t.substr(3));n&&this.editor.removeListener(e,n),this.editor.on(e,this.props[t])}},{key:"_destroyEditor",value:function(){this.editor&&this.editor.destroy(),this.editor=null,this.element=null}}])&&p(e.prototype,r),o&&p(e,o),n}();h.propTypes={type:u.a.oneOf(["classic","inline"]),data:u.a.string,config:u.a.object,style:u.a.object,readOnly:u.a.bool,onBeforeLoad:u.a.func},h.defaultProps={type:"classic",data:"",config:{},readOnly:!1},h.editorUrl="https://cdn.ckeditor.com/4.13.1/standard-all/ckeditor.js",h.displayName="CKEditor";n.default=h}]).default});
//# sourceMappingURL=ckeditor.js.map

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ComponentsCompareTable__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentsDetailCompareTable__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__item_schemes_compare_report__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__redux_components_redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GroupsDetailCompareTable__ = __webpack_require__(1532);
var tabPaneStyle={maxHeight:640,overflow:'auto',padding:8};var getStringFromTriplet=function getStringFromTriplet(triplet){return triplet?triplet.id+'+'+triplet.agencyId+'+'+triplet.version:'';};// used to filter cases where the only difference is in attachmentLevel
var getFilteredDifferenceAttributes=function getFilteredDifferenceAttributes(differenceAttributes){return differenceAttributes.filter(function(component){return component.source&&!component.target||!component.source&&component.target||getStringFromTriplet(component.source)!==getStringFromTriplet(component.target)||(component.codelistCompare||{}).totalDifference>0;});};var DsdsCompareReport=function DsdsCompareReport(_ref){var t=_ref.t,report=_ref.report,codelistDetail=_ref.codelistDetail,codelistDetailInstancePrefix=_ref.codelistDetailInstancePrefix,onCodelistDetailShow=_ref.onCodelistDetailShow,codelistCompareReport=_ref.codelistCompareReport,fetchCodelistCompareReport=_ref.fetchCodelistCompareReport,onCodelistCompareReportHide=_ref.onCodelistCompareReportHide;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,report.sourceDimensions.length+report.targetDimensions.length+__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.unionBy(report.differenceDimensions,report.differenceConceptSchemeDimensions,"key").length+report.sourceAttributes.length+report.targetAttributes.length+getFilteredDifferenceAttributes(report.differenceAttributes).length+report.sourceMeasures.length+report.targetMeasures.length+report.sourceGroups.length+report.targetGroups.length+report.differenceGroups.length===0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a,{type:'info',showIcon:true,message:t("components.dsdCompareReport.noDifferencesAlert"),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane,{key:'dimensions',tab:t('components.dsdsCompareReport.tabs.dimensions.title',{count:report.sourceDimensions.length+report.targetDimensions.length}),style:Object.assign({},tabPaneStyle),disabled:report.sourceDimensions.length+report.targetDimensions.length===0},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ComponentsCompareTable__["a" /* default */],{sourceComponents:report.sourceDimensions,targetComponents:report.targetDimensions})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane,{key:'dimensionsDetail',tab:t('components.dsdsCompareReport.tabs.dimensionsDetail.title',{count:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.unionBy(report.differenceDimensions,report.differenceConceptSchemeDimensions,"key").length}),style:Object.assign({},tabPaneStyle),disabled:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.unionBy(report.differenceDimensions,report.differenceConceptSchemeDimensions,"key").length===0},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ComponentsDetailCompareTable__["a" /* default */],{commonComponentsCodelist:report.differenceDimensions,commonComponentsConcept:report.differenceConceptSchemeDimensions,fetchCodelistCompareReport:fetchCodelistCompareReport,sourceFile:report.sourceFile,targetFile:report.targetFile})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane,{key:'attributes',tab:t('components.dsdsCompareReport.tabs.attributes.title',{count:report.sourceAttributes.length+report.targetAttributes.length}),style:Object.assign({},tabPaneStyle),disabled:report.sourceAttributes.length+report.targetAttributes.length===0},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ComponentsCompareTable__["a" /* default */],{sourceComponents:report.sourceAttributes,targetComponents:report.targetAttributes})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane,{key:'attributesDetail',tab:t('components.dsdsCompareReport.tabs.attributesDetail.title',{count:getFilteredDifferenceAttributes(report.differenceAttributes).length}),style:Object.assign({},tabPaneStyle),disabled:getFilteredDifferenceAttributes(report.differenceAttributes).length===0},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ComponentsDetailCompareTable__["a" /* default */],{commonComponentsCodelist:getFilteredDifferenceAttributes(report.differenceAttributes),commonComponentsConcept:report.differenceConceptSchemeAttributes,fetchCodelistCompareReport:fetchCodelistCompareReport,sourceFile:report.sourceFile,targetFile:report.targetFile})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane,{key:'measures',tab:t('components.dsdsCompareReport.tabs.measures.title',{count:report.sourceMeasures.length+report.targetMeasures.length}),style:Object.assign({},tabPaneStyle),disabled:report.sourceMeasures.length+report.targetMeasures.length===0},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ComponentsCompareTable__["a" /* default */],{sourceComponents:report.sourceMeasures,targetComponents:report.targetMeasures})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane,{key:'groups',tab:t('components.dsdsCompareReport.tabs.groups.title',{count:report.sourceGroups.length+report.targetGroups.length}),style:Object.assign({},tabPaneStyle),disabled:report.sourceGroups.length+report.targetGroups.length===0},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ComponentsCompareTable__["a" /* default */],{sourceComponents:report.sourceGroups,targetComponents:report.targetGroups})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane,{key:'groupsDetail',tab:t('components.dsdsCompareReport.tabs.groupsDetail.title',{count:report.differenceGroups.length}),style:Object.assign({},tabPaneStyle),disabled:report.differenceGroups.length===0},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__GroupsDetailCompareTable__["a" /* default */],{commonComponentsGroups:report.differenceGroups}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__enhanced_modal__["a" /* default */],{title:t('components.dsdsCompareReport.modals.codelistCompare.title'),width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_LG"],visible:codelistCompareReport!==null&&codelistCompareReport!==undefined,onCancel:onCodelistCompareReportHide,footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onCodelistCompareReportHide},t('commons.buttons.close.title')))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__item_schemes_compare_report__["a" /* default */],{report:codelistCompareReport,onDetailShow:onCodelistDetailShow})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__redux_components_redux_codelist_detail_modal__["a" /* default */],{instancePrefix:codelistDetailInstancePrefix,instanceState:codelistDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])()(DsdsCompareReport));

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_constants__);
var SPAN_COMPONENT_COL=11;var SPAN_CENTER_COL=2;var IconFontCNIcons=__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a.createFromIconfontCN({scriptUrl:'./static/vendor/iconfont_cn/iconfont.js'});var differenceIconStyle={type:'circle',style:{color:'red',transform:'scale(1.3)'}};var mandatoryIconStyle={type:'m',style:{transform:'scale(1.1)'},title:"Mandatory"};var ComponentsCompareTable=function ComponentsCompareTable(_ref){var sourceComponents=_ref.sourceComponents,targetComponents=_ref.targetComponents;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,sourceComponents&&sourceComponents.map(function(component,idx){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],{key:idx},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",align:"middle",style:{marginTop:0,marginBottom:0},key:idx},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,component.key),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,component.mandatory?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconFontCNIcons,mandatoryIconStyle):null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_CENTER_COL},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconFontCNIcons,differenceIconStyle))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL})),!(idx===sourceComponents.length-1&&targetComponents.length===0)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_CENTER_COL},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"center"},"|")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL})));}),targetComponents&&targetComponents.map(function(component,idx){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],{key:idx},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",align:"middle",style:{marginTop:0,marginBottom:0},key:idx},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_CENTER_COL},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconFontCNIcons,differenceIconStyle))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,component.key),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,component.mandatory?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconFontCNIcons,mandatoryIconStyle):null)))),idx!==targetComponents.length-1&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_CENTER_COL},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"center"},"|")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL})));}));};/* harmony default export */ __webpack_exports__["a"] = (ComponentsCompareTable);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_css__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selector__ = __webpack_require__(54);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_TOTAL_DIFFERENCE=1000;var ItemSchemesCompareReport=function(_React$Component){_inherits(ItemSchemesCompareReport,_React$Component);function ItemSchemesCompareReport(props){_classCallCheck(this,ItemSchemesCompareReport);var _this=_possibleConstructorReturn(this,(ItemSchemesCompareReport.__proto__||Object.getPrototypeOf(ItemSchemesCompareReport)).call(this,props));_this.state={isSourceItemsVisible:true,isTargetItemsVisible:true};_this.changeSourceItemsVisibility=_this.changeSourceItemsVisibility.bind(_this);_this.changeTargetItemsVisibility=_this.changeTargetItemsVisibility.bind(_this);return _this;}_createClass(ItemSchemesCompareReport,[{key:'changeSourceItemsVisibility',value:function changeSourceItemsVisibility(){this.setState(Object.assign({},this.state,{isSourceItemsVisible:!this.state.isSourceItemsVisible}));}},{key:'changeTargetItemsVisibility',value:function changeTargetItemsVisibility(){this.setState(Object.assign({},this.state,{isTargetItemsVisible:!this.state.isTargetItemsVisible}));}},{key:'render',value:function render(){var _props=this.props,t=_props.t,report=_props.report,onDetailShow=_props.onDetailShow;var _state=this.state,isSourceItemsVisible=_state.isSourceItemsVisible,isTargetItemsVisible=_state.isTargetItemsVisible;var sourceItem=report&&report.sourceItem.map(function(item){return{sourceId:item.id,sourceName:item.names,targetId:null,targetName:null};});var targetItem=report&&report.targetItem.map(function(item){return{sourceId:null,sourceName:null,targetId:item.id,targetName:item.names};});return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,report&&report.totalDifference>MAX_TOTAL_DIFFERENCE&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t("components.itemSchemesCompareReport.alerts.tooMuchDiff.message")}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["GUTTER_MD"],justify:'space-between',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'start'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_TWO_THIRDS"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__selector__["a" /* default */],{value:report&&report.sourceArtefact?report.sourceArtefact.id+'+'+report.sourceArtefact.agencyId+'+'+report.sourceArtefact.version:null,detailTitle:t('components.itemSchemesCompareReport.selector.artefactDetail.title'),onDetail:onDetailShow?function(){return onDetailShow({id:report.sourceArtefact.id,agencyID:report.sourceArtefact.agencyId,version:report.sourceArtefact.version},true);}:null,disabled:true})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_TWO_THIRDS"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__selector__["a" /* default */],{value:report&&report.targetArtefact?report.targetArtefact.id+'+'+report.targetArtefact.agencyId+'+'+report.targetArtefact.version:null,detailTitle:t('components.itemSchemesCompareReport.selector.artefactDetail.title'),onDetail:onDetailShow?function(){return onDetailShow({id:report.targetArtefact.id,agencyID:report.targetArtefact.agencyId,version:report.targetArtefact.version},false);}:null,disabled:true}))))),sourceItem.length+targetItem.length===0&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'info',showIcon:true,message:t("components.itemSchemesCompareReport.noDifferencesAlert"),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["GUTTER_MD"],justify:'space-between',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'start',gutter:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("components.itemSchemesCompareReport.showItem.label")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:isSourceItemsVisible,onChange:this.changeSourceItemsVisibility})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',gutter:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("components.itemSchemesCompareReport.showItem.label")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:isTargetItemsVisible,onChange:this.changeTargetItemsVisibility}))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'item-schemes-compare-report__infinite-scroll-table'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__infinite_scroll_table__["a" /* default */],{data:(isSourceItemsVisible?sourceItem||[]:[]).concat(isTargetItemsVisible?targetItem||[]:[]),getRowKey:function getRowKey(_ref){var sourceId=_ref.sourceId,targetId=_ref.targetId;return sourceId+targetId;},multilangStrDataIndexes:["sourceName","targetName"],columns:[{title:t('data.item.id.shortLabel'),dataIndex:'sourceId',minWidth:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.item.name.shortLabel'),dataIndex:'sourceName',minWidth:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.item.id.shortLabel'),dataIndex:'targetId',minWidth:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.item.name.shortLabel'),dataIndex:'targetName',minWidth:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]}]})));}}]);return ItemSchemesCompareReport;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])()(ItemSchemesCompareReport));

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hocs_call__ = __webpack_require__(18);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onOk:function onOk(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* submitRemoveTempTables */])());}};};var RemoveTempTables=function RemoveTempTables(_ref){var t=_ref.t,_onOk=_ref.onOk;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.removeTempTables.modal.title'),content:t('scenes.dataManager.removeTempTables.modal.content'),onOk:function onOk(){_onOk();},cancelText:t('commons.buttons.cancel.title')});}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps))(RemoveTempTables));

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(1543);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onOk:function onOk(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* submitDdbReset */])());}};};var DdbReset=function DdbReset(_ref){var t=_ref.t,_onOk=_ref.onOk;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.ddbReset.modal.title'),content:t('scenes.dataManager.ddbReset.modal.content'),onOk:function onOk(){_onOk();},cancelText:t('commons.buttons.cancel.title')});}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps))(DdbReset));

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{callback:function callback(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* onUpdateDatabrowserCache */])());}};};var UpdateDatabrowserCache=function UpdateDatabrowserCache(_ref){var t=_ref.t,callback=_ref.callback;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.updateDataBrowserCache.modal.title'),content:t('scenes.dataManager.updateDataBrowserCache.modal.content'),onOk:function onOk(){callback();},cancelText:t('commons.buttons.cancel.title')});}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null,mapDispatchToProps))(UpdateDatabrowserCache));

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_steps_style__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_steps_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_steps_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_steps__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_step__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__connection_step__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__filter_step__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_css__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__load_step__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__structure_step__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__attributes_step__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__semantic_step__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__dimensions_step__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__mapping_step__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__structure_step_utils__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__dimensions_step_utils__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__attributes_step_utils__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__semantic_step_utils__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__mapping_step_utils__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__constants_paths__ = __webpack_require__(124);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,step:state.scenes.easyLoading.step,dstDataflow:state.scenes.easyLoading.dstDataflow,category:state.scenes.easyLoading.category,forbiddenCategoriesCodes:state.scenes.easyLoading.forbiddenCategoriesCodes,isConnectionEndpointAvailable:state.scenes.easyLoading.isConnectionEndpointAvailable,sourceFormat:state.scenes.easyLoading.sourceFormat,srcDataflow:state.scenes.easyLoading.srcDataflow,srcFile:state.scenes.easyLoading.srcFile,structureColumns:state.scenes.easyLoading.structureColumns,codelists:state.scenes.easyLoading.structureCodelists,components:state.scenes.easyLoading.components,cube:state.scenes.easyLoading.cube,permissions:state.app.user.permissions,astTerritorialCodelist:state.scenes.easyLoading.astTerritorialCodelist,astTerritoryConceptScheme:state.scenes.easyLoading.astTerritoryConceptScheme,astTerritoryConcept:state.scenes.easyLoading.astTerritoryConcept};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onStepSet:function onStepSet(step){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["_66" /* setELStep */])(step));},onReadASTTerritorialConfig:function onReadASTTerritorialConfig(codelist,conceptScheme,concept){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["_38" /* readASTTerritorialCodelistConcept */])(codelist,conceptScheme,concept));}};};var EasyLoading=function EasyLoading(_ref){var _allSteps;var t=_ref.t,mode=_ref.mode,endpoints=_ref.endpoints,endpointId=_ref.endpointId,step=_ref.step,dstDataflow=_ref.dstDataflow,category=_ref.category,forbiddenCategoriesCodes=_ref.forbiddenCategoriesCodes,isConnectionEndpointAvailable=_ref.isConnectionEndpointAvailable,sourceFormat=_ref.sourceFormat,srcDataflow=_ref.srcDataflow,srcFile=_ref.srcFile,structureColumns=_ref.structureColumns,codelists=_ref.codelists,components=_ref.components,cube=_ref.cube,permissions=_ref.permissions,astTerritorialCodelist=_ref.astTerritorialCodelist,astTerritoryConceptScheme=_ref.astTerritoryConceptScheme,astTerritoryConcept=_ref.astTerritoryConcept,onStepSet=_ref.onStepSet,onReadASTTerritorialConfig=_ref.onReadASTTerritorialConfig;var _useState=Object(__WEBPACK_IMPORTED_MODULE_14_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),steps=_useState2[0],setSteps=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_14_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),astEnabled=_useState4[0],setAstEnabled=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_14_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),userHasASTPermission=_useState6[0],setUserHasASTPermission=_useState6[1];Object(__WEBPACK_IMPORTED_MODULE_14_react__["useEffect"])(function(){var nodeASTConfig=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].ast;var isAstEnabled=nodeASTConfig?nodeASTConfig.enabled:false;setAstEnabled(isAstEnabled);var hasASTPermission=(permissions.agencies||[]).includes('AST');setUserHasASTPermission(hasASTPermission);},[endpoints,endpointId,permissions]);Object(__WEBPACK_IMPORTED_MODULE_14_react__["useEffect"])(function(){if(astEnabled&&userHasASTPermission&&astTerritorialCodelist===null){var nodeASTConfig=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].ast;var _astTerritorialCodelist=nodeASTConfig.astTerritorialCodelist;var _astTerritoryConceptScheme=nodeASTConfig.astTerritoryConceptScheme;var _astTerritoryConcept=nodeASTConfig.astTerritoryConcept;onReadASTTerritorialConfig(_astTerritorialCodelist,_astTerritoryConceptScheme,_astTerritoryConcept);}},[endpoints,endpointId,astTerritorialCodelist,astEnabled,userHasASTPermission]);Object(__WEBPACK_IMPORTED_MODULE_14_react__["useEffect"])(function(){var newSteps=void 0;if(mode===__WEBPACK_IMPORTED_MODULE_26__constants__["r" /* EL_MODE_CREATE */]){if(sourceFormat===__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]){newSteps=[__WEBPACK_IMPORTED_MODULE_26__constants__["B" /* EL_STEP_DATA */],__WEBPACK_IMPORTED_MODULE_26__constants__["A" /* EL_STEP_CONNECTION */],__WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */],__WEBPACK_IMPORTED_MODULE_26__constants__["E" /* EL_STEP_LOAD */]];}else{newSteps=[__WEBPACK_IMPORTED_MODULE_26__constants__["B" /* EL_STEP_DATA */],__WEBPACK_IMPORTED_MODULE_26__constants__["A" /* EL_STEP_CONNECTION */],__WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */],__WEBPACK_IMPORTED_MODULE_26__constants__["H" /* EL_STEP_STRUCTURE */],__WEBPACK_IMPORTED_MODULE_26__constants__["C" /* EL_STEP_DIMENSIONS */],__WEBPACK_IMPORTED_MODULE_26__constants__["z" /* EL_STEP_ATTRIBUTES */],__WEBPACK_IMPORTED_MODULE_26__constants__["G" /* EL_STEP_SEMANTIC */],__WEBPACK_IMPORTED_MODULE_26__constants__["E" /* EL_STEP_LOAD */]];}}else{if(sourceFormat===__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]){newSteps=[__WEBPACK_IMPORTED_MODULE_26__constants__["B" /* EL_STEP_DATA */],__WEBPACK_IMPORTED_MODULE_26__constants__["A" /* EL_STEP_CONNECTION */],__WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */],__WEBPACK_IMPORTED_MODULE_26__constants__["E" /* EL_STEP_LOAD */]];}else{newSteps=[__WEBPACK_IMPORTED_MODULE_26__constants__["B" /* EL_STEP_DATA */],__WEBPACK_IMPORTED_MODULE_26__constants__["A" /* EL_STEP_CONNECTION */],__WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */],__WEBPACK_IMPORTED_MODULE_26__constants__["F" /* EL_STEP_MAPPING */],__WEBPACK_IMPORTED_MODULE_26__constants__["E" /* EL_STEP_LOAD */]];}}setSteps(newSteps||[]);},[mode,sourceFormat]);var validationResult=null;var isStepValid=function isStepValid(step){validationResult=null;switch(step){case __WEBPACK_IMPORTED_MODULE_26__constants__["B" /* EL_STEP_DATA */]:return Object(__WEBPACK_IMPORTED_MODULE_24__utils_artefactValidators__["a" /* isArtefactValid */])(dstDataflow)&&(mode===__WEBPACK_IMPORTED_MODULE_26__constants__["s" /* EL_MODE_UPDATE */]||category!==null&&!(forbiddenCategoriesCodes||[]).includes(category.CatCode));case __WEBPACK_IMPORTED_MODULE_26__constants__["A" /* EL_STEP_CONNECTION */]:if(sourceFormat===__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]){return isConnectionEndpointAvailable&&srcDataflow;}else{return srcFile&&srcFile.csvPath;}case __WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */]:return true;case __WEBPACK_IMPORTED_MODULE_26__constants__["H" /* EL_STEP_STRUCTURE */]:validationResult=Object(__WEBPACK_IMPORTED_MODULE_32__structure_step_utils__["e" /* structureIsWellDefined */])(t,structureColumns);return validationResult.result;case __WEBPACK_IMPORTED_MODULE_26__constants__["C" /* EL_STEP_DIMENSIONS */]:validationResult=Object(__WEBPACK_IMPORTED_MODULE_33__dimensions_step_utils__["a" /* dimensionsAreWellDefined */])(t,structureColumns,codelists);return validationResult.result;case __WEBPACK_IMPORTED_MODULE_26__constants__["z" /* EL_STEP_ATTRIBUTES */]:return Object(__WEBPACK_IMPORTED_MODULE_34__attributes_step_utils__["a" /* attributesAreWellDefined */])(structureColumns);case __WEBPACK_IMPORTED_MODULE_26__constants__["G" /* EL_STEP_SEMANTIC */]:return Object(__WEBPACK_IMPORTED_MODULE_35__semantic_step_utils__["a" /* semanticIsWellDefined */])(structureColumns);case __WEBPACK_IMPORTED_MODULE_26__constants__["F" /* EL_STEP_MAPPING */]:return Object(__WEBPACK_IMPORTED_MODULE_36__mapping_step_utils__["c" /* mappingIsValid */])(components,cube.components);default:return false;}};var setStep=function setStep(step,steps){if(steps.slice(0,steps.indexOf(step)).find(function(s){return!isStepValid(s);})===undefined){onStepSet(step);}else{var hasValidationMessages=validationResult!==null&&(validationResult.messages||[]).length>0;__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:hasValidationMessages?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",null,validationResult.messages.map(function(msg,idx){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("p",{key:idx},msg);})):t('commons.alerts.invalidForm.content')});}};var allSteps=(_allSteps={},_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["B" /* EL_STEP_DATA */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["B" /* EL_STEP_DATA */],steps);}},t('components.easyLoading.steps.data.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__data_step__["a" /* default */],{mode:mode})}),_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["A" /* EL_STEP_CONNECTION */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["A" /* EL_STEP_CONNECTION */],steps);}},t('components.easyLoading.steps.connection.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__connection_step__["a" /* default */],null)}),_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */],steps);}},t('components.easyLoading.steps.filter.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__filter_step__["a" /* default */],{sdmxFilters:sourceFormat===__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]})}),_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["H" /* EL_STEP_STRUCTURE */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["H" /* EL_STEP_STRUCTURE */],steps);}},t('components.easyLoading.steps.structure.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__structure_step__["a" /* default */],null)}),_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["C" /* EL_STEP_DIMENSIONS */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["C" /* EL_STEP_DIMENSIONS */],steps);}},t('components.easyLoading.steps.dimensions.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__dimensions_step__["a" /* default */],null)}),_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["z" /* EL_STEP_ATTRIBUTES */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["z" /* EL_STEP_ATTRIBUTES */],steps);}},t('components.easyLoading.steps.attributes.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__attributes_step__["a" /* default */],null)}),_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["G" /* EL_STEP_SEMANTIC */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["G" /* EL_STEP_SEMANTIC */],steps);}},t('components.easyLoading.steps.semantic.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__semantic_step__["a" /* default */],null)}),_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["F" /* EL_STEP_MAPPING */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["F" /* EL_STEP_MAPPING */],steps);}},t('components.easyLoading.steps.mapping.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__mapping_step__["a" /* default */],null)}),_defineProperty(_allSteps,__WEBPACK_IMPORTED_MODULE_26__constants__["E" /* EL_STEP_LOAD */],{title:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{style:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["CSS_POINTER"],onClick:function onClick(){return setStep(__WEBPACK_IMPORTED_MODULE_26__constants__["E" /* EL_STEP_LOAD */],steps);}},t('components.easyLoading.steps.load.title')),render:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__load_step__["a" /* default */],{mode:mode})}),_allSteps);if(!mode||(steps||[]).length===0){return null;}var readIsFinish=astTerritorialCodelist&&astTerritoryConceptScheme&&astTerritoryConcept;if(!readIsFinish&&astEnabled&&userHasASTPermission){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",null);}var ELIsEnabled=astEnabled&&userHasASTPermission&&astTerritorialCodelist!==-1&&astTerritoryConceptScheme!==-1&&astTerritoryConcept!==-1;if(ELIsEnabled){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"],display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{width:160,paddingRight:40}},steps.indexOf(step)>0&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{style:{width:"100%"},onClick:function onClick(){return setStep(steps[steps.indexOf(step)-1],steps);}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:"left"}),t("commons.buttons.goBack.title"))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{width:"calc(100% - 320px)"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default.a,{size:"small",current:steps.indexOf(step)},steps.map(function(s,i){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default.a.Step,{key:i,title:allSteps[s].title,description:allSteps[s].description});}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{width:160,paddingLeft:40,display:"flex",justifyContent:"flex-end"}},steps.indexOf(step)<steps.length-1&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:"primary",style:{width:"100%"},onClick:function onClick(){return setStep(steps[steps.indexOf(step)+1],steps);}},t("commons.buttons.goForward.title"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:"right"})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{width:"100%",maxWidth:1200}},allSteps[step].render))));}else{var errorTitle=void 0;var errorContent=t('components.easyLoading.error.ast.noAstConfig.content')+" ";var hRef="./#"+__WEBPACK_IMPORTED_MODULE_38__constants_paths__["L" /* PATH_NODES_CONFIGURATION */];var link=t('components.easyLoading.error.ast.nodesConfigLink.label');if(!astEnabled){errorTitle=t('components.easyLoading.error.ast.noAstConfig.title');}else if(!userHasASTPermission){errorTitle=t('components.easyLoading.error.ast.notAllowedAgency.title');errorContent=t('components.easyLoading.error.ast.notAllowedAgency.content')+" ";hRef="./#"+__WEBPACK_IMPORTED_MODULE_38__constants_paths__["R" /* PATH_SET_PERMISSIONS */];link=t('components.easyLoading.error.ast.userConfigLink.label');}else if(astTerritorialCodelist===-1){errorTitle=t('components.easyLoading.error.ast.invalidTerritorialCodelist.title');}else if(astTerritoryConceptScheme===-1){errorTitle=t('components.easyLoading.error.ast.invalidTerritoryConceptScheme.title');}else if(astTerritoryConcept===-1){errorTitle=t('components.easyLoading.error.ast.invalidTerritoryConcept.title');}return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.error({title:errorTitle,content:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,errorContent,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("a",{href:hRef,style:{textDecoration:"underline"}},link))});}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",null));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_16_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(EasyLoading));

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIconType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dimensionsAreWellDefined; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(63);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var getIconType=function getIconType(role){var iconType="";switch(role){case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* EL_DIMENSION_ROLE_GENERIC */]:iconType="bar-chart";break;case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* EL_DIMENSION_ROLE_FREQUENCY */]:iconType="line-chart";break;case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* EL_DIMENSION_ROLE_MEASURE */]:iconType="stock";break;case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* EL_DIMENSION_ROLE_TERRITORY */]:iconType="global";break;case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* EL_DIMENSION_ROLE_TIME */]:iconType="calendar";break;default:iconType="";}return iconType;};var dimensionsAreWellDefined=function dimensionsAreWellDefined(t,structureColumns,codelists){var hasTerritorialDimension=false;var hasTimeDimension=false;var hasTerritorialDimensionTranslation=false;var hasTimeDimensionTranslation=false;var _loop=function _loop(i){var dim=structureColumns[i];if(dim.type!==__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EL_COL_TYPE_DIMENSION */]){return"continue";}if(dim.dimensionDefinition.role===null){return{v:false};}if(dim.dimensionDefinition.role===__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* EL_DIMENSION_ROLE_TIME */]){hasTimeDimension=true;if((dim.translations||[]).length>0){hasTimeDimensionTranslation=true;}}else{if(dim.dimensionDefinition.role!==__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* EL_DIMENSION_ROLE_TIME */]){if(dim.dimensionDefinition.association===null&&(dim.translations||[]).length===0){return{v:false};}else if(dim.dimensionDefinition.association!==null){if(!(codelists||[]).some(function(codelist){return codelist.id===dim.dimensionDefinition.association.id&&codelist.agencyID===dim.dimensionDefinition.association.agencyID&&codelist.version===dim.dimensionDefinition.association.version;})){return{v:false};}}}if(dim.dimensionDefinition.role===__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* EL_DIMENSION_ROLE_TERRITORY */]){hasTerritorialDimension=true;if((dim.translations||[]).length>0){hasTerritorialDimensionTranslation=true;}}}};for(var i=0;i<(structureColumns||[]).length;i++){var _ret=_loop(i);switch(_ret){case"continue":continue;default:if((typeof _ret==="undefined"?"undefined":_typeof(_ret))==="object")return _ret.v;}}var messages=[];if(!hasTerritorialDimension){messages.push(t('components.easyLoading.error.dimensions.territorialDimension'));};if(!hasTimeDimension){messages.push(t('components.easyLoading.error.dimensions.timeDimension'));}if(hasTerritorialDimensionTranslation){messages.push(t('components.easyLoading.error.dimensions.territorialDimensionTranslation'));}if(hasTimeDimensionTranslation){messages.push(t('components.easyLoading.error.dimensions.timeDimensionTranslation'));}return{result:hasTerritorialDimension&&hasTimeDimension&&!hasTerritorialDimensionTranslation&&!hasTimeDimensionTranslation,messages:messages};};

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(143);
var mapStateToProps=function mapStateToProps(state){return{isSidebarCollapsed:state.app.isSidebarCollapsed};};var logo=function logo(isSidebarCollapsed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:"/",style:{textDecoration:"none",cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:"100%",height:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:isSidebarCollapsed?"./static/png/istat_logo_mini.png":"./static/png/istat_logo_full.png",alt:"Logo ISTAT",style:{height:32,position:"relative",verticalAlign:"top",top:8,left:2,marginRight:24}})));};var SidebarHeader=function SidebarHeader(_ref){var isSidebarCollapsed=_ref.isSidebarCollapsed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:64,background:"white",paddingLeft:isSidebarCollapsed?6:22,paddingTop:6}},logo(isSidebarCollapsed));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SidebarHeader));

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(38));

var _reactLifecyclesCompat = __webpack_require__(49);

var _PropTypes = __webpack_require__(607);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(49);

var _ChildMapping = __webpack_require__(1620);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(610);
module.exports = __webpack_require__(615);


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(611).enable();
  window.Promise = __webpack_require__(613);
}

// fetch() polyfill for making API calls.
__webpack_require__(614);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(170);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(365);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(365);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 614 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_config_provider_style__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_config_provider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_config_provider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_config_provider__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_config_provider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_config_provider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_ant_overrides_css__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_ant_overrides_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_ant_overrides_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_jquery_ui_overrides_css__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_jquery_ui_overrides_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_jquery_ui_overrides_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_custom_css__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_fonts_font_style_css__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_fonts_font_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_fonts_font_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__init__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__page__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_config_actions__ = __webpack_require__(116);
Object(__WEBPACK_IMPORTED_MODULE_12__init__["a" /* default */])(function(store,i18n){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__reducers_config_actions__["c" /* initConfig */])());__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["a" /* I18nextProvider */],{i18n:i18n},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_config_provider___default.a,{renderEmpty:function renderEmpty(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_custom_empty__["a" /* default */],null);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__page__["a" /* default */],null))))),document.getElementById('react-root'));});

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(617);

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(170),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(622);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(366);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(621);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _empty = _interopRequireDefault(__webpack_require__(262));

var _ = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

/* babel-plugin-inline-import './empty.svg' */
var emptyImg = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var renderEmpty = function renderEmpty(componentName) {
  return React.createElement(_.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('empty');

    switch (componentName) {
      case 'Table':
      case 'List':
        return React.createElement(_empty["default"], {
          image: emptyImg,
          className: "".concat(prefix, "-normal")
        });

      case 'Select':
      case 'TreeSelect':
      case 'Cascader':
      case 'Transfer':
        return React.createElement(_empty["default"], {
          image: emptyImg,
          className: "".concat(prefix, "-small")
        });

      default:
        return React.createElement(_empty["default"], null);
    }
  });
};

var _default = renderEmpty;
exports["default"] = _default;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(264));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _en_US["default"];
exports["default"] = _default;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(170),r=__webpack_require__(627);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(628);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(266);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(172);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(373);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(637);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(93), __webpack_require__(372)(module)))

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(373);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(374);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(642);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(266);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(269);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(375);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(375);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(268);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(269);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(651);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(270);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(376);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(655);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(657);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(380);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(659);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(270);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(661);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(271);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(380);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(271);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(665);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(378);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = translate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shallowEqual__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__I18n__ = __webpack_require__(381);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function translate(namespaceArg) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  return function Wrapper(WrappedComponent) {
    var Translate = function (_Component) {
      _inherits(Translate, _Component);

      function Translate(props, context) {
        _classCallCheck(this, Translate);

        var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

        _this.i18n = props.i18n || options.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_4__context__["b" /* getI18n */])();
        _this.namespaces = typeof namespaceArg === 'function' ? namespaceArg(props) : namespaceArg || context.defaultNS || _this.i18n.options && _this.i18n.options.defaultNS;
        if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

        var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
        _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__context__["a" /* getDefaults */])(), i18nOptions, options);

        if (context.reportNS) {
          var namespaces = _this.namespaces || [undefined];
          namespaces.forEach(context.reportNS);
        }

        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
        return _this;
      }

      _createClass(Translate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
          if (!this.options.usePureComponent) {
            return true;
          }

          return !Object(__WEBPACK_IMPORTED_MODULE_3__shallowEqual__["a" /* default */])(this.props, nextProps);
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!this.options.withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          /* eslint react/no-string-refs: 1 */
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var extraProps = {};

          if (this.options.withRef) {
            extraProps.ref = function (c) {
              _this2.wrappedInstance = c;
            };
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__I18n__["a" /* default */], _extends({ ns: this.namespaces }, this.options, this.props, { i18n: this.i18n }), function (t, _ref) {
            var ready = _ref.ready,
                context = _objectWithoutProperties(_ref, ['ready']);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
              tReady: ready
            }, _this2.props, extraProps, context));
          });
        }
      }]);

      return Translate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      defaultNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      reportNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaceArg;

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Translate, WrappedComponent);
  };
}

translate.setDefaults = __WEBPACK_IMPORTED_MODULE_4__context__["c" /* setDefaults */];

translate.setI18n = __WEBPACK_IMPORTED_MODULE_4__context__["d" /* setI18n */];

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

/* eslint-disable no-self-compare */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Interpolate = function (_Component) {
  _inherits(Interpolate, _Component);

  function Interpolate(props, context) {
    _classCallCheck(this, Interpolate);

    var _this = _possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n;
    _this.t = props.t || context.t;
    return _this;
  }

  _createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props,
          className = _props.className,
          style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript', null);

      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
          return props[key];
        }

        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();

        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return Interpolate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Interpolate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Interpolate.defaultProps = {
  className: ''
};

Interpolate.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (Interpolate);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (!children) return '';
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];

  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = '' + i;

    if (typeof child === 'string') {
      mem = '' + mem + child;
    } else if (hasChildren(child)) {
      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
    } else if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      mem = mem + '<' + elementKey + '></' + elementKey + '>';
    } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object') {
      var clone = _extends({}, child);
      var format = clone.format;
      delete clone.format;

      var keys = Object.keys(clone);
      if (format && keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
      } else if (keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
      } else if (console && console.warn) {
        // not a valid interpolation object (can only contain one value plus format)
        console.warn('react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.', child);
      }
    } else if (console && console.warn) {
      console.warn('react-i18next: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.', child);
    }
  });

  return mem;
}

function renderNodes(children, targetString, i18n) {
  if (targetString === "") return [];
  if (!children) return [targetString];

  // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes
  var ast = __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default.a.parse('<0>' + targetString + '</0>');

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];

    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!
          mem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, { key: i }), inner));
        } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && !isElement) {
          var content = node.children[0] ? node.children[0].content : null;
          if (content) {
            var interpolated = i18n.services.interpolator.interpolate(node.children[0].content, child, i18n.language);
            mem.push(interpolated);
          }
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }
      return mem;
    }, []);
  }

  // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result
  var result = mapAST([{ dummy: true, children: children }], ast);
  return getChildren(result[0]);
}

var Trans = function (_React$Component) {
  _inherits(Trans, _React$Component);

  function Trans() {
    _classCallCheck(this, Trans);

    return _possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).apply(this, arguments));
  }

  _createClass(Trans, [{
    key: 'render',
    value: function render() {
      var contextAndProps = _extends({ i18n: this.context.i18n, t: this.context.t }, this.props);

      var children = contextAndProps.children,
          count = contextAndProps.count,
          parent = contextAndProps.parent,
          i18nKey = contextAndProps.i18nKey,
          tOptions = contextAndProps.tOptions,
          values = contextAndProps.values,
          defaults = contextAndProps.defaults,
          components = contextAndProps.components,
          namespace = contextAndProps.ns,
          i18n = contextAndProps.i18n,
          tFromContextAndProps = contextAndProps.t,
          additionalProps = _objectWithoutProperties(contextAndProps, ['children', 'count', 'parent', 'i18nKey', 'tOptions', 'values', 'defaults', 'components', 'ns', 'i18n', 't']);

      var t = tFromContextAndProps || i18n.t.bind(i18n);

      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;

      var defaultValue = defaults || nodesToString('', children, 0);
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var interpolationOverride = values ? {} : { interpolation: { prefix: '#$?', suffix: '?$#' } };
      var translation = key ? t(key, _extends({}, tOptions, values, interpolationOverride, { defaultValue: defaultValue, count: count, ns: namespace })) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];
        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (!useAsParent) return renderNodes(components || children, translation, i18n);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n));
    }
  }]);

  return Trans;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Trans);


Trans.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  i18nKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

// Trans.defaultProps = {
//   parent: 'div'
// };

Trans.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(671),
    stringify: __webpack_require__(674)
};


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(672);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(673);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 673 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 674 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var I18nextProvider = function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    _classCallCheck(this, I18nextProvider);

    var _this = _possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));

    _this.i18n = props.i18n;
    _this.defaultNS = props.defaultNS;
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }
    _this.reportNS = props.reportNS;
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        i18n: this.i18n,
        defaultNS: this.defaultNS,
        reportNS: this.reportNS
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);
    }
  }]);

  return I18nextProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

I18nextProvider.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  defaultNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reportNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

I18nextProvider.childContextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  defaultNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reportNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

I18nextProvider.defaultProps = {
  defaultNS: undefined,
  reportNS: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (I18nextProvider);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var objectEntries = Object.entries || function (obj) {
  var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }return resArray;
};

// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (_typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = objectEntries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_reducer__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_i18n_middlewareFactory__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18next__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_api_middlewareFactory__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares_user_feedback_middlewareFactory__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_default_category_scheme_selector_middleware__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_spinner_middlewareFactory__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__middlewares_newTab_middleware__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__middlewares_empty_nodes_modal_middlewareFactory__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_persistence_middleware__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middlewares_authentication_middlewareFactory__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__middlewares_file_save_middleware__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__middlewares_cube_no_data_modal_middlewareFactory__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__middlewares_scrollTo_middleware__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__middlewares_metadata_api_middleware__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__middlewares_config_middleware__ = __webpack_require__(1588);
var $=window.jQuery;var showError=function showError(){$('.preloader__message').text("Error contacting server");$('.preloader__spinner__icon').hide();$('.preloader__error-icon').show();};// get configuration and translations and passes to callback the initialized redux and i18next
var init=function init(onAfterInit){return fetch('./static/config.json')// get configuration file
.then(function(response){return response.json();}).then(function(config){return fetch(config.fetchBaseUrl+'/appConfig').then(function(response){return response.json();}).then(function(appConfig){return(// configuration json defines necessary translations
Promise.all(// ... need to get all these translations
appConfig.userInterface.languages.map(function(_ref){var code=_ref.code;return(// so, for each language defined in the configuration
fetch('./static/locales/'+code+'/translation.json')// ... get the translation file
.then(function(response){return response.headers.get("content-type").indexOf("application/json")!==-1?response.json():null;}).catch(showError));})).then(function(translations){// this is the array of translations objects
var resources={};// i18n configuration requires a static object
appConfig.userInterface.languages.forEach(function(_ref2,idx){var code=_ref2.code;// ... where each language
if(translations[idx]){resources[code]={translation:translations[idx]// ... is a property having an object like this as val
};}});__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */].init({lng:'it',resources:resources,returnEmptyString:false});onAfterInit(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_1__reducers_reducer__["a" /* default */],{},Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(Object(__WEBPACK_IMPORTED_MODULE_18__middlewares_config_middleware__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_2__middlewares_i18n_middlewareFactory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_6__middlewares_default_category_scheme_selector_middleware__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_empty_nodes_modal_middlewareFactory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_13__middlewares_cube_no_data_modal_middlewareFactory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_api_middlewareFactory__["a" /* default */])(config.fetchBaseUrl,__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_8__middlewares_newTab_middleware__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_5__middlewares_user_feedback_middlewareFactory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_spinner_middlewareFactory__["a" /* default */])(200),__WEBPACK_IMPORTED_MODULE_10__middlewares_persistence_middleware__["b" /* default */],Object(__WEBPACK_IMPORTED_MODULE_11__middlewares_authentication_middlewareFactory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_12__middlewares_file_save_middleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_14__middlewares_scrollTo_middleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_15__middlewares_metadata_api_middleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_16__middlewares_current_node_config_middleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_17__middlewares_current_user_permissions_middleware__["a" /* default */])),__WEBPACK_IMPORTED_MODULE_3_i18next__["a" /* default */]);}).catch(showError));});}).catch(showError);};/* harmony default export */ __webpack_exports__["a"] = (init);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_reducer__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_reducer__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_reducer__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_reducer__ = __webpack_require__(1144);
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({config:__WEBPACK_IMPORTED_MODULE_2__config_reducer__["a" /* default */],app:__WEBPACK_IMPORTED_MODULE_1__app_reducer__["a" /* default */],scenes:__WEBPACK_IMPORTED_MODULE_3__scenes_reducer__["a" /* default */],middlewares:__WEBPACK_IMPORTED_MODULE_4__middlewares_reducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_header_endpoint_dropdown_actions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_header_user_dropdown_actions__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares_persistence_middleware__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_authentication_actions__ = __webpack_require__(145);
var appReducer=function appReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isSidebarCollapsed:null,language:null,endpointId:null,isEndpointAvailable:null,user:{username:null,email:null,token:null,permissions:null,providerId:null},superUser:{username:null}};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* APP_LANGUAGE_SET */]:return Object.assign({},state,{language:action.payload.language});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* APP_ENDPOINT_SET */]:return Object.assign({},state,{endpointId:action.endpointId,isEndpointAvailable:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* APP_SIDEBAR_COLLAPSE */]:{return Object.assign({},state,{isSidebarCollapsed:true});}case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* APP_SIDEBAR_UNCOLLAPSE */]:{return Object.assign({},state,{isSidebarCollapsed:false});}// case APP_USER_UNSET:
//   return {
//     ...state,
//     user: {
//       ...state.user,
//       username: null,
//       isDropdownVisible: false
//     }
//   };
case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* APP_USER_DROPDOWN_VISIBLE_CHANGE */]:return Object.assign({},state,{user:Object.assign({},state.user,{isDropdownVisible:action.visible})});case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* APP_USER_CLEAR */]:return Object.assign({},state,{user:Object.assign({},state.user,{username:null,email:null,token:null,permissions:null,providerId:null})});case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__page_header_endpoint_dropdown_actions__["a" /* ENDPOINT_DROPDOWN_NODE_PING */]:{return Object.assign({},state,{isEndpointAvailable:false});}case __WEBPACK_IMPORTED_MODULE_4__page_header_user_dropdown_actions__["a" /* USER_DROPDOWN_USER_LOGIN */]:case __WEBPACK_IMPORTED_MODULE_4__page_header_user_dropdown_actions__["b" /* USER_DROPDOWN_USER_LOGOUT */]:return Object.assign({},state,{user:Object.assign({},state.user,{isDropdownVisible:false})});default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_6__middlewares_authentication_actions__["b" /* SUPER_USER_LOGIN_FORM_SUBMIT */]:return Object.assign({},state,{superUser:{username:action.username}});case __WEBPACK_IMPORTED_MODULE_6__middlewares_authentication_actions__["c" /* SUPER_USER_LOGOUT */]:return Object.assign({},state,{superUser:{username:null}});case __WEBPACK_IMPORTED_MODULE_1__page_header_endpoint_dropdown_actions__["a" /* ENDPOINT_DROPDOWN_NODE_PING */]:return Object.assign({},state,{isEndpointAvailable:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* APP_USER_PERMISSIONS_READ */]:return Object.assign({},state,{user:Object.assign({},state.user,{email:action.response.email,permissions:{functionality:action.response.functionality,agencies:action.response.agencies,categories:action.response.category,cubeOwner:action.response.cubeOwner,cube:action.response.cube,rules:action.response.rules,dataflowOwner:action.response.dataflowOwner,metadataflowOwner:action.response.metadataFlowOwner}})});case __WEBPACK_IMPORTED_MODULE_3__config_actions__["b" /* CONFIG_READ */]:var config=action.response;var persistentAppState=action[__WEBPACK_IMPORTED_MODULE_5__middlewares_persistence_middleware__["a" /* PERSISTENCE_ACTION_KEY */]];return Object.assign({},state,{isSidebarCollapsed:persistentAppState?persistentAppState.isSidebarCollapsed:config.userInterface.defaultSidebarCollapsed,language:persistentAppState?persistentAppState.language:config.userInterface.defaultLanguage,endpointId:persistentAppState&&config.nodes.filter(function(node){return node.general.id===persistentAppState.endpointId;}).length?persistentAppState.endpointId:config.nodes.length>0?config.nodes[0].general.id:null,user:persistentAppState?Object.assign({},persistentAppState.user,{permissions:null}):state.user});case __WEBPACK_IMPORTED_MODULE_4__page_header_user_dropdown_actions__["a" /* USER_DROPDOWN_USER_LOGIN */]:return Object.assign({},state,{user:Object.assign({},state.user,{username:action.data.Username||action.response.username,email:null,token:action.response.token,permissions:null,providerId:action.providerId||null})});case __WEBPACK_IMPORTED_MODULE_4__page_header_user_dropdown_actions__["b" /* USER_DROPDOWN_USER_LOGOUT */]:return Object.assign({},state,{user:Object.assign({},state.user,{username:null,email:null,token:null,permissions:null,providerId:null})});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (appReducer);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(116);
var configReducer=function configReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{nodes:[],userInterface:{defaultTableRows:null,maxTableRows:null,defaultSidebarCollapsed:null,defaultLanguage:null,languages:[],anonymousPages:[],minTreeNodesForPagination:null,maxTreeNodesForPagination:null,treePageSize:null},dataManagement:{cubeCodePrefix:null,dataLanguages:[],maxDescriptionLength:null}};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CONFIG_READ */]:return action.response;default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (configReducer);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scenes_data_manager_builder_reducer__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_data_manager_file_mapping_reducer__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_data_manager_loader_reducer__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_data_manager_cube_list_reducer__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_actions__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scenes_data_manager_dataflow_builder_reducer__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_configuration_app_config_reducer__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scenes_configuration_nodes_config_reducer__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scenes_utilities_import_structures_reducer__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_header_endpoint_dropdown_actions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scenes_reference_metadata_dcat_reducer__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scenes_meta_manager_codelists_reducer__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scenes_meta_manager_category_schemes_reducer__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__scenes_meta_manager_concept_schemes_reducer__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__scenes_meta_manager_dataflows_reducer__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__scenes_manage_users_set_permissions_reducer__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scenes_data_manager_sync_codelists_reducer__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scenes_meta_manager_category_schemes_and_dataflows_reducer__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scenes_meta_manager_dsds_reducer__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__scenes_meta_manager_msds_reducer__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__scenes_meta_manager_metadataflows_reducer__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__scenes_manage_users_user_menagment_reducer__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scenes_data_manager_upgrade_dsd_reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scenes_meta_manager_agency_schemes_reducer__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scenes_utilities_compare_dsds_reducer__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__scenes_utilities_compare_item_schemes_reducer__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__scenes_meta_manager_content_constraint_reducer__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__page_header_user_dropdown_actions__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__scenes_reference_metadata_metadata_set_reducer__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__scenes_utilities_merge_item_schemes_reducer__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__scenes_meta_manager_hierarchical_codelists_reducer__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__scenes_data_manager_manage_series_reducer__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__scenes_data_manager_attribute_file_reducer__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_easy_loading_reducer__ = __webpack_require__(345);
var scenesReducer=function scenesReducer(state,action){if(action.type===__WEBPACK_IMPORTED_MODULE_5__page_actions__["a" /* PAGE_NAVIGATE */]||action.type===__WEBPACK_IMPORTED_MODULE_11__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]&&action.label===__WEBPACK_IMPORTED_MODULE_10__page_header_endpoint_dropdown_actions__["a" /* ENDPOINT_DROPDOWN_NODE_PING */]&&action.response===true||action.type===__WEBPACK_IMPORTED_MODULE_11__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]&&action.label===__WEBPACK_IMPORTED_MODULE_29__page_header_user_dropdown_actions__["a" /* USER_DROPDOWN_USER_LOGIN */]||action.type===__WEBPACK_IMPORTED_MODULE_11__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]&&action.label===__WEBPACK_IMPORTED_MODULE_29__page_header_user_dropdown_actions__["b" /* USER_DROPDOWN_USER_LOGOUT */]){state=undefined;}return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({metaManager:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({codelists:__WEBPACK_IMPORTED_MODULE_13__scenes_meta_manager_codelists_reducer__["b" /* default */],categorySchemes:__WEBPACK_IMPORTED_MODULE_14__scenes_meta_manager_category_schemes_reducer__["b" /* default */],conceptSchemes:__WEBPACK_IMPORTED_MODULE_15__scenes_meta_manager_concept_schemes_reducer__["b" /* default */],dataflows:__WEBPACK_IMPORTED_MODULE_16__scenes_meta_manager_dataflows_reducer__["e" /* default */],categorySchemesAndDataflows:__WEBPACK_IMPORTED_MODULE_19__scenes_meta_manager_category_schemes_and_dataflows_reducer__["a" /* default */],dsds:__WEBPACK_IMPORTED_MODULE_20__scenes_meta_manager_dsds_reducer__["b" /* default */],msds:__WEBPACK_IMPORTED_MODULE_21__scenes_meta_manager_msds_reducer__["a" /* default */],metadataflows:__WEBPACK_IMPORTED_MODULE_22__scenes_meta_manager_metadataflows_reducer__["a" /* default */],agencySchemes:__WEBPACK_IMPORTED_MODULE_25__scenes_meta_manager_agency_schemes_reducer__["a" /* default */],contentConstraints:__WEBPACK_IMPORTED_MODULE_28__scenes_meta_manager_content_constraint_reducer__["b" /* default */],hierarchicalCodelists:__WEBPACK_IMPORTED_MODULE_32__scenes_meta_manager_hierarchical_codelists_reducer__["a" /* default */]}),dataManager:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({builder:__WEBPACK_IMPORTED_MODULE_1__scenes_data_manager_builder_reducer__["a" /* default */],fileMapping:__WEBPACK_IMPORTED_MODULE_2__scenes_data_manager_file_mapping_reducer__["a" /* default */],loader:__WEBPACK_IMPORTED_MODULE_3__scenes_data_manager_loader_reducer__["a" /* default */],cubeList:__WEBPACK_IMPORTED_MODULE_4__scenes_data_manager_cube_list_reducer__["a" /* default */],dataflowBuilder:__WEBPACK_IMPORTED_MODULE_6__scenes_data_manager_dataflow_builder_reducer__["f" /* default */],syncCodelist:__WEBPACK_IMPORTED_MODULE_18__scenes_data_manager_sync_codelists_reducer__["a" /* default */],attributeFile:__WEBPACK_IMPORTED_MODULE_34__scenes_data_manager_attribute_file_reducer__["a" /* default */],upgradeDsd:__WEBPACK_IMPORTED_MODULE_24__scenes_data_manager_upgrade_dsd_reducer__["c" /* default */],manageSeries:__WEBPACK_IMPORTED_MODULE_33__scenes_data_manager_manage_series_reducer__["a" /* default */]}),easyLoading:__WEBPACK_IMPORTED_MODULE_35__components_easy_loading_reducer__["b" /* default */],utilities:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({importStructures:__WEBPACK_IMPORTED_MODULE_9__scenes_utilities_import_structures_reducer__["a" /* default */],compareDsds:__WEBPACK_IMPORTED_MODULE_26__scenes_utilities_compare_dsds_reducer__["e" /* default */],compareItemSchemes:__WEBPACK_IMPORTED_MODULE_27__scenes_utilities_compare_item_schemes_reducer__["j" /* default */],mergeItemSchemes:__WEBPACK_IMPORTED_MODULE_31__scenes_utilities_merge_item_schemes_reducer__["d" /* default */]}),referenceMetadata:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({dcat:__WEBPACK_IMPORTED_MODULE_12__scenes_reference_metadata_dcat_reducer__["a" /* default */],metadataSet:__WEBPACK_IMPORTED_MODULE_30__scenes_reference_metadata_metadata_set_reducer__["a" /* default */]}),manageUsers:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({setPermissions:__WEBPACK_IMPORTED_MODULE_17__scenes_manage_users_set_permissions_reducer__["e" /* default */],userManagement:__WEBPACK_IMPORTED_MODULE_23__scenes_manage_users_user_menagment_reducer__["a" /* default */]}),configuration:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({appConfig:__WEBPACK_IMPORTED_MODULE_7__scenes_configuration_app_config_reducer__["a" /* default */],nodesConfig:__WEBPACK_IMPORTED_MODULE_8__scenes_configuration_nodes_config_reducer__["a" /* default */]})})(state,action);};/* harmony default export */ __webpack_exports__["a"] = (scenesReducer);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsd_list_reducer__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_form_actions__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_default_category_scheme_selector_actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__category_form_actions__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cube_form_reducer__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middlewares_current_node_config_middleware__ = __webpack_require__(42);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var builderReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({dsdList:__WEBPACK_IMPORTED_MODULE_1__dsd_list_reducer__["b" /* default */],cubeForm:__WEBPACK_IMPORTED_MODULE_9__cube_form_reducer__["b" /* default */]}),shared:function shared(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{cubeId:null,category:null,categorisedCubes:null,isCategoryFormParentModalVisible:false,forbiddenCubesCodes:null,forbiddenCategoriesCodes:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_8__category_form_actions__["g" /* BUILDER_CATEGORY_FORM_PARENT_MODAL_SHOW */]:return Object.assign({},state,{isCategoryFormParentModalVisible:true});case __WEBPACK_IMPORTED_MODULE_8__category_form_actions__["f" /* BUILDER_CATEGORY_FORM_PARENT_MODAL_HIDE */]:return Object.assign({},state,{isCategoryFormParentModalVisible:false});case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["g" /* BUILDER_CUBE_TREE_CUBE_SELECT */]:{return Object.assign({},state,{cubeId:action.cubeId});}case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["d" /* BUILDER_CUBE_TREE_CUBE_CATEGORY_SELECT */]:{return Object.assign({},state,{category:action.category});}case __WEBPACK_IMPORTED_MODULE_8__category_form_actions__["b" /* BUILDER_CATEGORY_FORM_CREATE */]:return Object.assign({},state,{category:{IDCat:null,ParCode:action.parCode,Ord:null,labels:null}});case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["e" /* BUILDER_CUBE_TREE_CUBE_CREATE */]:return Object.assign({},state,{category:null});case __WEBPACK_IMPORTED_MODULE_8__category_form_actions__["a" /* BUILDER_CATEGORY_FORM_CHANGE */]:return Object.assign({},state,{category:Object.assign({},state.category,action.fields)});case __WEBPACK_IMPORTED_MODULE_8__category_form_actions__["e" /* BUILDER_CATEGORY_FORM_HIDE */]:return Object.assign({},state,{category:null});case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["a" /* BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_3__cube_form_actions__["b" /* BUILDER_CUBE_FORM_CUBE_READ */]:return Object.assign({},state,{cubeId:null});case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["a" /* BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:[]});default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_3__cube_form_actions__["d" /* BUILDER_CUBE_FORM_SUBMIT */]:{return Object.assign({},state,{cubeId:action.response,category:null,categorisedCubes:null});}case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["f" /* BUILDER_CUBE_TREE_CUBE_DELETE */]:return Object.assign({},state,{cubeId:null,categorisedCubes:null});case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["a" /* BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ */]:var permissions=Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var isAdmin=permissions&&permissions.rules&&permissions.rules.includes("AdminRole");var canViewForbiddenObjects=Object(__WEBPACK_IMPORTED_MODULE_11__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).general.canViewUnallowedBuilderNodes;var _action$response=_slicedToArray(action.response,2),allCubes=_action$response[0],dcs=_action$response[1];var forbiddenCubesCodes=allCubes.filter(function(_ref){var Code=_ref.Code;return!permissions||!permissions.cube.includes(Code)&&!permissions.cubeOwner.includes(Code);}).map(function(_ref2){var Code=_ref2.Code;return Code;});var allowedCategorisedCubesTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_treeBuilders__["b" /* getCubesTree */])(allCubes.filter(function(_ref3){var Code=_ref3.Code;return canViewForbiddenObjects||!forbiddenCubesCodes.includes(Code);}),dcs);var forbiddenCategoriesCodes=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["l" /* getNodes */])(allowedCategorisedCubesTree,"children",function(_ref4){var CatCode=_ref4.CatCode;return!permissions||CatCode!==undefined&&permissions.categories.indexOf(CatCode)<0;}).map(function(_ref5){var CatCode=_ref5.CatCode;return CatCode;}).filter(function(catCode){return catCode!==__WEBPACK_IMPORTED_MODULE_4__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode&&catCode!==__WEBPACK_IMPORTED_MODULE_5__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */];});var allowedCategorisedCubesWithOnlyAllowedCategoriesTree=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["g" /* getFilteredTreeWithPaths */])(allowedCategorisedCubesTree,"children",function(obj){return obj.Code||isAdmin||!forbiddenCategoriesCodes.includes(obj.CatCode);});var finalOrderedTree=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["h" /* getMappedTree */])(allowedCategorisedCubesWithOnlyAllowedCategoriesTree,"children",function(node){var ordCount=1;return Object.assign({},node,{children:node.children?node.children.sort(function(a,b){if(a.Ord!==undefined&&b.Ord!==undefined){return a.Ord-b.Ord;}else if(a.Ord!==undefined){return a;}else if(b.Ord!==undefined){return b;}else{return(a.CatCode||-1)-(b.CatCode||-1);}}).map(function(c){return Object.assign({},c,{Ord:c.Ord!==undefined?String(ordCount++):undefined});}):node.children});});return Object.assign({},state,{categorisedCubes:finalOrderedTree,forbiddenCubesCodes:forbiddenCubesCodes,forbiddenCategoriesCodes:forbiddenCategoriesCodes});case __WEBPACK_IMPORTED_MODULE_6__middlewares_default_category_scheme_selector_actions__["g" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_6__middlewares_default_category_scheme_selector_actions__["d" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT */]:return Object.assign({},state,{categorisedCubes:null});case __WEBPACK_IMPORTED_MODULE_8__category_form_actions__["c" /* BUILDER_CATEGORY_FORM_CREATE_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_8__category_form_actions__["d" /* BUILDER_CATEGORY_FORM_EDIT_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["c" /* BUILDER_CUBE_TREE_CATEGORY_MOVE */]:return Object.assign({},state,{categorisedCubes:null});case __WEBPACK_IMPORTED_MODULE_7__cube_tree_actions__["b" /* BUILDER_CUBE_TREE_CATEGORY_DELETE */]:return Object.assign({},state,{categorisedCubes:null,category:null});default:return state;}}default:return state;}}});/* harmony default export */ __webpack_exports__["a"] = (builderReducer);

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);










var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Checkbox.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin___default.a.shouldComponentUpdate.apply(this, args);
  };

  Checkbox.prototype.focus = function focus() {
    this.input.focus();
  };

  Checkbox.prototype.blur = function blur() {
    this.input.blur();
  };

  Checkbox.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        className = _props.className,
        style = _props.style,
        name = _props.name,
        id = _props.id,
        type = _props.type,
        disabled = _props.disabled,
        readOnly = _props.readOnly,
        tabIndex = _props.tabIndex,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onBlur = _props.onBlur,
        autoFocus = _props.autoFocus,
        value = _props.value,
        others = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'className', 'style', 'name', 'id', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);

    var globalProps = Object.keys(others).reduce(function (prev, key) {
      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
        prev[key] = others[key];
      }
      return prev;
    }, {});

    var checked = this.state.checked;

    var classString = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'span',
      { className: classString, style: style },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        name: name,
        id: id,
        type: type,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: prefixCls + '-input',
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: this.handleChange,
        autoFocus: autoFocus,
        ref: this.saveInput,
        value: value
      }, globalProps)),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: prefixCls + '-inner' })
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Checkbox.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  checked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var props = _this2.props;

    if (props.disabled) {
      return;
    }
    if (!('checked' in props)) {
      _this2.setState({
        checked: e.target.checked
      });
    }
    props.onChange({
      target: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      },

      nativeEvent: e.nativeEvent
    });
  };

  this.saveInput = function (node) {
    _this2.input = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(691), __esModule: true };

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(692);
module.exports = __webpack_require__(99).Object.assign;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(128);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(694) });


/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(208);
var gOPS = __webpack_require__(283);
var pIE = __webpack_require__(211);
var toObject = __webpack_require__(284);
var IObject = __webpack_require__(389);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(176)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(149);
var toLength = __webpack_require__(390);
var toAbsoluteIndex = __webpack_require__(696);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(279);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(698), __esModule: true };

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(391);
__webpack_require__(704);
module.exports = __webpack_require__(287).f('iterator');


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(279);
var defined = __webpack_require__(278);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(285);
var descriptor = __webpack_require__(177);
var setToStringTag = __webpack_require__(286);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(146)(IteratorPrototype, __webpack_require__(100)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(120);
var anObject = __webpack_require__(147);
var getKeys = __webpack_require__(208);

module.exports = __webpack_require__(129) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(119).document;
module.exports = document && document.documentElement;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(130);
var toObject = __webpack_require__(284);
var IE_PROTO = __webpack_require__(280)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(705);
var global = __webpack_require__(119);
var hide = __webpack_require__(146);
var Iterators = __webpack_require__(178);
var TO_STRING_TAG = __webpack_require__(100)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(706);
var step = __webpack_require__(707);
var Iterators = __webpack_require__(178);
var toIObject = __webpack_require__(149);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(392)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(709), __esModule: true };

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(710);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
module.exports = __webpack_require__(99).Symbol;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(119);
var has = __webpack_require__(130);
var DESCRIPTORS = __webpack_require__(129);
var $export = __webpack_require__(128);
var redefine = __webpack_require__(393);
var META = __webpack_require__(711).KEY;
var $fails = __webpack_require__(176);
var shared = __webpack_require__(281);
var setToStringTag = __webpack_require__(286);
var uid = __webpack_require__(210);
var wks = __webpack_require__(100);
var wksExt = __webpack_require__(287);
var wksDefine = __webpack_require__(288);
var enumKeys = __webpack_require__(712);
var isArray = __webpack_require__(713);
var anObject = __webpack_require__(147);
var isObject = __webpack_require__(148);
var toIObject = __webpack_require__(149);
var toPrimitive = __webpack_require__(276);
var createDesc = __webpack_require__(177);
var _create = __webpack_require__(285);
var gOPNExt = __webpack_require__(714);
var $GOPD = __webpack_require__(395);
var $DP = __webpack_require__(120);
var $keys = __webpack_require__(208);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(394).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(211).f = $propertyIsEnumerable;
  __webpack_require__(283).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(209)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(146)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(210)('meta');
var isObject = __webpack_require__(148);
var has = __webpack_require__(130);
var setDesc = __webpack_require__(120).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(176)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(208);
var gOPS = __webpack_require__(283);
var pIE = __webpack_require__(211);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(277);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(149);
var gOPN = __webpack_require__(394).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 715 */
/***/ (function(module, exports) {



/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(288)('asyncIterator');


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(288)('observable');


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(719), __esModule: true };

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(720);
module.exports = __webpack_require__(99).Object.setPrototypeOf;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(128);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(721).set });


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(148);
var anObject = __webpack_require__(147);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(275)(Function.call, __webpack_require__(395).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(723), __esModule: true };

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(724);
var $Object = __webpack_require__(99).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(128);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(285) });


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */

var shallowEqual = __webpack_require__(726);

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}

/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */
var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};

module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__(727);

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(728),
    isArguments = __webpack_require__(729),
    isArray = __webpack_require__(730);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 728 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 729 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _reactLifecyclesCompat = __webpack_require__(49);

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _shallowequal = _interopRequireDefault(__webpack_require__(132));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _Checkbox = _interopRequireDefault(__webpack_require__(384));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var CheckboxGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxGroup).call(this, props));

    _this.toggleOption = function (option) {
      var optionIndex = _this.state.value.indexOf(option.value);

      var value = _toConsumableArray(_this.state.value);

      if (optionIndex === -1) {
        value.push(option.value);
      } else {
        value.splice(optionIndex, 1);
      }

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(value);
      }
    };

    _this.renderGroup = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          style = props.style,
          options = props.options,
          restProps = __rest(props, ["prefixCls", "className", "style", "options"]);

      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
      var groupPrefixCls = "".concat(prefixCls, "-group");
      var domProps = (0, _omit["default"])(restProps, ['children', 'defaultValue', 'value', 'onChange', 'disabled']);
      var children = props.children;

      if (options && options.length > 0) {
        children = _this.getOptions().map(function (option) {
          return React.createElement(_Checkbox["default"], {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : props.disabled,
            value: option.value,
            checked: state.value.indexOf(option.value) !== -1,
            onChange: option.onChange,
            className: "".concat(groupPrefixCls, "-item")
          }, option.label);
        });
      }

      var classString = (0, _classnames["default"])(groupPrefixCls, className);
      return React.createElement("div", _extends({
        className: classString,
        style: style
      }, domProps), children);
    };

    _this.state = {
      value: props.value || props.defaultValue || []
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        checkboxGroup: {
          toggleOption: this.toggleOption,
          value: this.state.value,
          disabled: this.props.disabled
        }
      };
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options; // https://github.com/Microsoft/TypeScript/issues/7960

      return options.map(function (option) {
        if (typeof option === 'string') {
          return {
            label: option,
            value: option
          };
        }

        return option;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value || []
        };
      }

      return null;
    }
  }]);

  return CheckboxGroup;
}(React.Component);

CheckboxGroup.defaultProps = {
  options: []
};
CheckboxGroup.propTypes = {
  defaultValue: PropTypes.array,
  value: PropTypes.array,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func
};
CheckboxGroup.childContextTypes = {
  checkboxGroup: PropTypes.any
};
(0, _reactLifecyclesCompat.polyfill)(CheckboxGroup);
var _default = CheckboxGroup;
exports["default"] = _default;

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(736);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(170);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var _default = function _default(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        className = props.className,
        others = __rest(props, ["prefixCls", "className"]);

    var prefixCls = getPrefixCls('card', customizePrefixCls);
    var classString = (0, _classnames["default"])("".concat(prefixCls, "-grid"), className);
    return React.createElement("div", _extends({}, others, {
      className: classString
    }));
  });
};

exports["default"] = _default;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var _default = function _default(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        className = props.className,
        avatar = props.avatar,
        title = props.title,
        description = props.description,
        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);

    var prefixCls = getPrefixCls('card', customizePrefixCls);
    var classString = (0, _classnames["default"])("".concat(prefixCls, "-meta"), className);
    var avatarDom = avatar ? React.createElement("div", {
      className: "".concat(prefixCls, "-meta-avatar")
    }, avatar) : null;
    var titleDom = title ? React.createElement("div", {
      className: "".concat(prefixCls, "-meta-title")
    }, title) : null;
    var descriptionDom = description ? React.createElement("div", {
      className: "".concat(prefixCls, "-meta-description")
    }, description) : null;
    var MetaDetail = titleDom || descriptionDom ? React.createElement("div", {
      className: "".concat(prefixCls, "-meta-detail")
    }, titleDom, descriptionDom) : null;
    return React.createElement("div", _extends({}, others, {
      className: classString
    }), avatarDom, MetaDetail);
  });
};

exports["default"] = _default;

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabPane__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabContent__ = __webpack_require__(745);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_1__TabPane__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_2__TabContent__["a"]; });




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tabs__["a" /* default */]);


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__KeyCode__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabPane__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Sentinel__ = __webpack_require__(400);
















function noop() {}

function getDefaultActiveKey(props) {
  var activeKey = void 0;
  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(props.children, function (child) {
    if (child && !activeKey && !child.props.disabled) {
      activeKey = child.key;
    }
  });
  return activeKey;
}

function activeKeyIsValid(props, key) {
  var keys = __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.map(props.children, function (child) {
    return child && child.key;
  });
  return keys.indexOf(key) >= 0;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _initialiseProps.call(_this);

    var activeKey = void 0;
    if ('activeKey' in props) {
      activeKey = props.activeKey;
    } else if ('defaultActiveKey' in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = getDefaultActiveKey(props);
    }

    _this.state = {
      activeKey: activeKey
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: nextProps.activeKey
        });
      } else if (!activeKeyIsValid(nextProps, this.state.activeKey)) {
        // https://github.com/ant-design/ant-design/issues/7093
        this.setState({
          activeKey: getDefaultActiveKey(nextProps)
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroy = true;
      __WEBPACK_IMPORTED_MODULE_10_raf___default.a.cancel(this.sentinelId);
    }

    // Sentinel for tab index

  }, {
    key: 'updateSentinelContext',
    value: function updateSentinelContext() {
      var _this2 = this;

      if (this.destroy) return;

      __WEBPACK_IMPORTED_MODULE_10_raf___default.a.cancel(this.sentinelId);
      this.sentinelId = __WEBPACK_IMPORTED_MODULE_10_raf___default()(function () {
        _this2.forceUpdate();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;

      var prefixCls = props.prefixCls,
          navWrapper = props.navWrapper,
          tabBarPosition = props.tabBarPosition,
          className = props.className,
          renderTabContent = props.renderTabContent,
          renderTabBar = props.renderTabBar,
          destroyInactiveTabPane = props.destroyInactiveTabPane,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'navWrapper', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane']);

      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-' + tabBarPosition, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, !!className), _classnames));

      this.tabBar = renderTabBar();

      var tabBar = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(this.tabBar, {
        prefixCls: prefixCls,
        navWrapper: navWrapper,
        key: 'tabBar',
        onKeyDown: this.onNavKeyDown,
        tabBarPosition: tabBarPosition,
        onTabClick: this.onTabClick,
        panels: props.children,
        activeKey: this.state.activeKey
      });

      var tabContent = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(renderTabContent(), {
        prefixCls: prefixCls,
        tabBarPosition: tabBarPosition,
        activeKey: this.state.activeKey,
        destroyInactiveTabPane: destroyInactiveTabPane,
        children: props.children,
        onChange: this.setActiveKey,
        key: 'tabContent'
      });

      var sentinelStart = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Sentinel__["c" /* default */], {
        key: 'sentinelStart',
        setRef: this.setSentinelStart,
        nextElement: this.panelSentinelStart
      });
      var sentinelEnd = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Sentinel__["c" /* default */], {
        key: 'sentinelEnd',
        setRef: this.setSentinelEnd,
        prevElement: this.panelSentinelEnd
      });

      var contents = [];
      if (tabBarPosition === 'bottom') {
        contents.push(sentinelStart, tabContent, sentinelEnd, tabBar);
      } else {
        contents.push(tabBar, sentinelStart, tabContent, sentinelEnd);
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14__Sentinel__["b" /* SentinelProvider */],
        {
          value: {
            sentinelStart: this.sentinelStart,
            sentinelEnd: this.sentinelEnd,
            setPanelSentinelStart: this.setPanelSentinelStart,
            setPanelSentinelEnd: this.setPanelSentinelEnd
          }
        },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: cls,
            style: props.style
          }, Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getDataAttr */])(restProps), {
            onScroll: this.onScroll
          }),
          contents
        )
      );
    }
  }]);

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onTabClick = function (activeKey, e) {
    if (_this3.tabBar.props.onTabClick) {
      _this3.tabBar.props.onTabClick(activeKey, e);
    }
    _this3.setActiveKey(activeKey);
  };

  this.onNavKeyDown = function (e) {
    var eventKeyCode = e.keyCode;
    if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].RIGHT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].DOWN) {
      e.preventDefault();
      var nextKey = _this3.getNextActiveKey(true);
      _this3.onTabClick(nextKey);
    } else if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].LEFT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].UP) {
      e.preventDefault();
      var previousKey = _this3.getNextActiveKey(false);
      _this3.onTabClick(previousKey);
    }
  };

  this.onScroll = function (_ref) {
    var target = _ref.target,
        currentTarget = _ref.currentTarget;

    if (target === currentTarget && target.scrollLeft > 0) {
      target.scrollLeft = 0;
    }
  };

  this.setSentinelStart = function (node) {
    _this3.sentinelStart = node;
  };

  this.setSentinelEnd = function (node) {
    _this3.sentinelEnd = node;
  };

  this.setPanelSentinelStart = function (node) {
    if (node !== _this3.panelSentinelStart) {
      _this3.updateSentinelContext();
    }
    _this3.panelSentinelStart = node;
  };

  this.setPanelSentinelEnd = function (node) {
    if (node !== _this3.panelSentinelEnd) {
      _this3.updateSentinelContext();
    }
    _this3.panelSentinelEnd = node;
  };

  this.setActiveKey = function (activeKey) {
    if (_this3.state.activeKey !== activeKey) {
      if (!('activeKey' in _this3.props)) {
        _this3.setState({
          activeKey: activeKey
        });
      }
      _this3.props.onChange(activeKey);
    }
  };

  this.getNextActiveKey = function (next) {
    var activeKey = _this3.state.activeKey;
    var children = [];
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(_this3.props.children, function (c) {
      if (c && !c.props.disabled) {
        if (next) {
          children.push(c);
        } else {
          children.unshift(c);
        }
      }
    });
    var length = children.length;
    var ret = length && children[0].key;
    children.forEach(function (child, i) {
      if (child.key === activeKey) {
        if (i === length - 1) {
          ret = children[0].key;
        } else {
          ret = children[i + 1].key;
        }
      }
    });
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Tabs);


Tabs.propTypes = {
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  renderTabBar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  renderTabContent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  navWrapper: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

Tabs.defaultProps = {
  prefixCls: 'rc-tabs',
  destroyInactiveTabPane: false,
  onChange: noop,
  navWrapper: function navWrapper(arg) {
    return arg;
  },
  tabBarPosition: 'top',
  children: null,
  style: {}
};

Tabs.TabPane = __WEBPACK_IMPORTED_MODULE_12__TabPane__["a" /* default */];

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(742);
var $Object = __webpack_require__(99).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(128);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(129), 'Object', { defineProperty: __webpack_require__(120).f });


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(398)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(291);











var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TabContent, [{
    key: 'getTabPanes',
    value: function getTabPanes() {
      var props = this.props;
      var activeKey = props.activeKey;
      var children = props.children;
      var newChildren = [];

      __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
        if (!child) {
          return;
        }
        var key = child.key;
        var active = activeKey === key;
        newChildren.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          active: active,
          destroyInactiveTabPane: props.destroyInactiveTabPane,
          rootPrefixCls: props.prefixCls
        }));
      });

      return newChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;
      var prefixCls = props.prefixCls,
          children = props.children,
          activeKey = props.activeKey,
          className = props.className,
          tabBarPosition = props.tabBarPosition,
          animated = props.animated,
          animatedWithMargin = props.animatedWithMargin;
      var style = props.style;

      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-content', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
      if (animated) {
        var activeIndex = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getActiveIndex */])(children, activeKey);
        if (activeIndex !== -1) {
          var animatedStyle = animatedWithMargin ? Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* getMarginStyle */])(activeIndex, tabBarPosition) : Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* getTransformPropValue */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getTransformByIndex */])(activeIndex, tabBarPosition));
          style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, animatedStyle);
        } else {
          style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
            display: 'none'
          });
        }
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          className: classes,
          style: style
        },
        this.getTabPanes()
      );
    }
  }]);

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TabContent);


TabContent.propTypes = {
  animated: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animatedWithMargin: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

TabContent.defaultProps = {
  animated: true
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(15);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabContent = function (_React$Component) {
  (0, _inherits3['default'])(TabContent, _React$Component);

  function TabContent() {
    (0, _classCallCheck3['default'])(this, TabContent);
    return (0, _possibleConstructorReturn3['default'])(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabContent, [{
    key: 'getTabPanes',
    value: function getTabPanes() {
      var props = this.props;
      var activeKey = props.activeKey;
      var children = props.children;
      var newChildren = [];

      _react2['default'].Children.forEach(children, function (child) {
        if (!child) {
          return;
        }
        var key = child.key;
        var active = activeKey === key;
        newChildren.push(_react2['default'].cloneElement(child, {
          active: active,
          destroyInactiveTabPane: props.destroyInactiveTabPane,
          rootPrefixCls: props.prefixCls
        }));
      });

      return newChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;
      var prefixCls = props.prefixCls,
          children = props.children,
          activeKey = props.activeKey,
          className = props.className,
          tabBarPosition = props.tabBarPosition,
          animated = props.animated,
          animatedWithMargin = props.animatedWithMargin;
      var style = props.style;

      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
      if (animated) {
        var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
        if (activeIndex !== -1) {
          var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition));
          style = (0, _extends3['default'])({}, style, animatedStyle);
        } else {
          style = (0, _extends3['default'])({}, style, {
            display: 'none'
          });
        }
      }
      return _react2['default'].createElement(
        'div',
        {
          className: classes,
          style: style
        },
        this.getTabPanes()
      );
    }
  }]);
  return TabContent;
}(_react2['default'].Component);

exports['default'] = TabContent;


TabContent.propTypes = {
  animated: _propTypes2['default'].bool,
  animatedWithMargin: _propTypes2['default'].bool,
  prefixCls: _propTypes2['default'].string,
  children: _propTypes2['default'].node,
  activeKey: _propTypes2['default'].string,
  style: _propTypes2['default'].any,
  tabBarPosition: _propTypes2['default'].string,
  className: _propTypes2['default'].string
};

TabContent.defaultProps = {
  animated: true
};
module.exports = exports['default'];

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _ScrollableInkTabBar = _interopRequireDefault(__webpack_require__(748));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _icon = _interopRequireDefault(__webpack_require__(25));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TabBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TabBar, _React$Component);

  function TabBar() {
    _classCallCheck(this, TabBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(TabBar).apply(this, arguments));
  }

  _createClass(TabBar, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          tabBarStyle = _this$props.tabBarStyle,
          animated = _this$props.animated,
          renderTabBar = _this$props.renderTabBar,
          tabBarExtraContent = _this$props.tabBarExtraContent,
          tabPosition = _this$props.tabPosition,
          prefixCls = _this$props.prefixCls,
          className = _this$props.className,
          size = _this$props.size,
          type = _this$props.type;
      var inkBarAnimated = _typeof(animated) === 'object' ? animated.inkBar : animated;
      var isVertical = tabPosition === 'left' || tabPosition === 'right';
      var prevIconType = isVertical ? 'up' : 'left';
      var nextIconType = isVertical ? 'down' : 'right';
      var prevIcon = React.createElement("span", {
        className: "".concat(prefixCls, "-tab-prev-icon")
      }, React.createElement(_icon["default"], {
        type: prevIconType,
        className: "".concat(prefixCls, "-tab-prev-icon-target")
      }));
      var nextIcon = React.createElement("span", {
        className: "".concat(prefixCls, "-tab-next-icon")
      }, React.createElement(_icon["default"], {
        type: nextIconType,
        className: "".concat(prefixCls, "-tab-next-icon-target")
      })); // Additional className for style usage

      var cls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-bar"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size, "-bar"), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card-bar"), type && type.indexOf('card') >= 0), _classNames), className);

      var renderProps = _extends({}, this.props, {
        inkBarAnimated: inkBarAnimated,
        extraContent: tabBarExtraContent,
        style: tabBarStyle,
        prevIcon: prevIcon,
        nextIcon: nextIcon,
        className: cls
      });

      var RenderTabBar;

      if (renderTabBar) {
        RenderTabBar = renderTabBar(renderProps, _ScrollableInkTabBar["default"]);
      } else {
        RenderTabBar = React.createElement(_ScrollableInkTabBar["default"], renderProps);
      }

      return React.cloneElement(RenderTabBar);
    }
  }]);

  return TabBar;
}(React.Component);

exports["default"] = TabBar;
TabBar.defaultProps = {
  animated: true,
  type: 'line'
};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _InkTabBarNode = __webpack_require__(749);

var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);

var _TabBarTabsNode = __webpack_require__(750);

var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);

var _TabBarRootNode = __webpack_require__(752);

var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);

var _ScrollableTabBarNode = __webpack_require__(753);

var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);

var _SaveRef = __webpack_require__(758);

var _SaveRef2 = _interopRequireDefault(_SaveRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prefer-stateless-function */
var ScrollableInkTabBar = function (_React$Component) {
  (0, _inherits3['default'])(ScrollableInkTabBar, _React$Component);

  function ScrollableInkTabBar() {
    (0, _classCallCheck3['default'])(this, ScrollableInkTabBar);
    return (0, _possibleConstructorReturn3['default'])(this, (ScrollableInkTabBar.__proto__ || Object.getPrototypeOf(ScrollableInkTabBar)).apply(this, arguments));
  }

  (0, _createClass3['default'])(ScrollableInkTabBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2['default'].createElement(
        _SaveRef2['default'],
        null,
        function (saveRef, getRef) {
          return _react2['default'].createElement(
            _TabBarRootNode2['default'],
            (0, _extends3['default'])({ saveRef: saveRef }, _this2.props),
            _react2['default'].createElement(
              _ScrollableTabBarNode2['default'],
              (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, _this2.props),
              _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props)),
              _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, _this2.props))
            )
          );
        }
      );
    }
  }]);
  return ScrollableInkTabBar;
}(_react2['default'].Component);

exports['default'] = ScrollableInkTabBar;
module.exports = exports['default'];

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(15);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _componentDidUpdate(component, init) {
  var _component$props = component.props,
      styles = _component$props.styles,
      panels = _component$props.panels,
      activeKey = _component$props.activeKey;

  var rootNode = component.props.getRef('root');
  var wrapNode = component.props.getRef('nav') || rootNode;
  var inkBarNode = component.props.getRef('inkBar');
  var activeTab = component.props.getRef('activeTab');
  var inkBarNodeStyle = inkBarNode.style;
  var tabBarPosition = component.props.tabBarPosition;
  var activeIndex = (0, _utils.getActiveIndex)(panels, activeKey);
  if (init) {
    // prevent mount animation
    inkBarNodeStyle.display = 'none';
  }
  if (activeTab) {
    var tabNode = activeTab;
    var transformSupported = (0, _utils.isTransformSupported)(inkBarNodeStyle);

    // Reset current style
    (0, _utils.setTransform)(inkBarNodeStyle, '');
    inkBarNodeStyle.width = '';
    inkBarNodeStyle.height = '';
    inkBarNodeStyle.left = '';
    inkBarNodeStyle.top = '';
    inkBarNodeStyle.bottom = '';
    inkBarNodeStyle.right = '';

    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
      var left = (0, _utils.getLeft)(tabNode, wrapNode);
      var width = tabNode.offsetWidth;

      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
      // It means no css working, then ink bar should not have width until css is loaded
      // Fix https://github.com/ant-design/ant-design/issues/7564
      if (width === rootNode.offsetWidth) {
        width = 0;
      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
        width = parseFloat(styles.inkBar.width, 10);
        if (width) {
          left += (tabNode.offsetWidth - width) / 2;
        }
      }

      // use 3d gpu to optimize render
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
      } else {
        inkBarNodeStyle.left = left + 'px';
      }
      inkBarNodeStyle.width = width + 'px';
    } else {
      var top = (0, _utils.getTop)(tabNode, wrapNode, true);
      var height = tabNode.offsetHeight;
      if (styles.inkBar && styles.inkBar.height !== undefined) {
        height = parseFloat(styles.inkBar.height, 10);
        if (height) {
          top += (tabNode.offsetHeight - height) / 2;
        }
      }
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
        inkBarNodeStyle.top = '0';
      } else {
        inkBarNodeStyle.top = top + 'px';
      }
      inkBarNodeStyle.height = height + 'px';
    }
  }
  inkBarNodeStyle.display = activeIndex !== -1 ? 'block' : 'none';
}

var InkTabBarNode = function (_React$Component) {
  (0, _inherits3['default'])(InkTabBarNode, _React$Component);

  function InkTabBarNode() {
    (0, _classCallCheck3['default'])(this, InkTabBarNode);
    return (0, _possibleConstructorReturn3['default'])(this, (InkTabBarNode.__proto__ || Object.getPrototypeOf(InkTabBarNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(InkTabBarNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // ref https://github.com/ant-design/ant-design/issues/8678
      // ref https://github.com/react-component/tabs/issues/135
      // InkTabBarNode need parent/root ref for calculating position
      // since parent componentDidMount triggered after child componentDidMount
      // we're doing a quick fix here to use setTimeout to calculate position
      // after parent/root component mounted
      this.timeout = setTimeout(function () {
        _componentDidUpdate(_this2, true);
      }, 0);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      _componentDidUpdate(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          styles = _props.styles,
          inkBarAnimated = _props.inkBarAnimated;

      var className = prefixCls + '-ink-bar';
      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
      return _react2['default'].createElement('div', {
        style: styles.inkBar,
        className: classes,
        key: 'inkBar',
        ref: this.props.saveRef('inkBar')
      });
    }
  }]);
  return InkTabBarNode;
}(_react2['default'].Component);

exports['default'] = InkTabBarNode;


InkTabBarNode.propTypes = {
  prefixCls: _propTypes2['default'].string,
  styles: _propTypes2['default'].object,
  inkBarAnimated: _propTypes2['default'].bool,
  saveRef: _propTypes2['default'].func
};

InkTabBarNode.defaultProps = {
  prefixCls: '',
  inkBarAnimated: true,
  styles: {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(751);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBarTabsNode = function (_React$Component) {
  (0, _inherits3['default'])(TabBarTabsNode, _React$Component);

  function TabBarTabsNode() {
    (0, _classCallCheck3['default'])(this, TabBarTabsNode);
    return (0, _possibleConstructorReturn3['default'])(this, (TabBarTabsNode.__proto__ || Object.getPrototypeOf(TabBarTabsNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabBarTabsNode, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.panels,
          activeKey = _props.activeKey,
          prefixCls = _props.prefixCls,
          tabBarGutter = _props.tabBarGutter,
          saveRef = _props.saveRef,
          tabBarPosition = _props.tabBarPosition;

      var rst = [];

      _react2['default'].Children.forEach(children, function (child, index) {
        if (!child) {
          return;
        }
        var key = child.key;
        var cls = activeKey === key ? prefixCls + '-tab-active' : '';
        cls += ' ' + prefixCls + '-tab';
        var events = {};
        if (child.props.disabled) {
          cls += ' ' + prefixCls + '-tab-disabled';
        } else {
          events = {
            onClick: _this2.props.onTabClick.bind(_this2, key)
          };
        }
        var ref = {};
        if (activeKey === key) {
          ref.ref = saveRef('activeTab');
        }

        var gutter = tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter;
        var style = (0, _defineProperty3['default'])({}, (0, _utils.isVertical)(tabBarPosition) ? 'marginBottom' : 'marginRight', gutter);
        (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');
        rst.push(_react2['default'].createElement(
          'div',
          (0, _extends3['default'])({
            role: 'tab',
            'aria-disabled': child.props.disabled ? 'true' : 'false',
            'aria-selected': activeKey === key ? 'true' : 'false'
          }, events, {
            className: cls,
            key: key,
            style: style
          }, ref),
          child.props.tab
        ));
      });

      return _react2['default'].createElement(
        'div',
        { ref: saveRef('navTabsContainer') },
        rst
      );
    }
  }]);
  return TabBarTabsNode;
}(_react2['default'].Component);

exports['default'] = TabBarTabsNode;


TabBarTabsNode.propTypes = {
  activeKey: _propTypes2['default'].string,
  panels: _propTypes2['default'].node,
  prefixCls: _propTypes2['default'].string,
  tabBarGutter: _propTypes2['default'].number,
  onTabClick: _propTypes2['default'].func,
  saveRef: _propTypes2['default'].func,
  tabBarPosition: _propTypes2['default'].string
};

TabBarTabsNode.defaultProps = {
  panels: [],
  prefixCls: [],
  tabBarGutter: null,
  onTabClick: function onTabClick() {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(57);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(15);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBarRootNode = function (_React$Component) {
  (0, _inherits3['default'])(TabBarRootNode, _React$Component);

  function TabBarRootNode() {
    (0, _classCallCheck3['default'])(this, TabBarRootNode);
    return (0, _possibleConstructorReturn3['default'])(this, (TabBarRootNode.__proto__ || Object.getPrototypeOf(TabBarRootNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabBarRootNode, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          onKeyDown = _props.onKeyDown,
          className = _props.className,
          extraContent = _props.extraContent,
          style = _props.style,
          tabBarPosition = _props.tabBarPosition,
          children = _props.children,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition', 'children']);

      var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
      var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
      var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
      var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
      var newChildren = children;
      if (extraContent) {
        newChildren = [(0, _react.cloneElement)(extraContent, {
          key: 'extra',
          style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
        }), (0, _react.cloneElement)(children, { key: 'content' })];
        newChildren = topOrBottom ? newChildren : newChildren.reverse();
      }
      return _react2['default'].createElement(
        'div',
        (0, _extends3['default'])({
          role: 'tablist',
          className: cls,
          tabIndex: '0',
          ref: this.props.saveRef('root'),
          onKeyDown: onKeyDown,
          style: style
        }, (0, _utils.getDataAttr)(restProps)),
        newChildren
      );
    }
  }]);
  return TabBarRootNode;
}(_react2['default'].Component);

exports['default'] = TabBarRootNode;


TabBarRootNode.propTypes = {
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  style: _propTypes2['default'].object,
  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
  children: _propTypes2['default'].node,
  extraContent: _propTypes2['default'].node,
  onKeyDown: _propTypes2['default'].func,
  saveRef: _propTypes2['default'].func
};

TabBarRootNode.defaultProps = {
  prefixCls: '',
  className: '',
  style: {},
  tabBarPosition: 'top',
  extraContent: null,
  children: null,
  onKeyDown: function onKeyDown() {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames5 = __webpack_require__(15);

var _classnames6 = _interopRequireDefault(_classnames5);

var _addEventListener = __webpack_require__(289);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _debounce = __webpack_require__(212);

var _debounce2 = _interopRequireDefault(_debounce);

var _utils = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ScrollableTabBarNode = function (_React$Component) {
  (0, _inherits3['default'])(ScrollableTabBarNode, _React$Component);

  function ScrollableTabBarNode(props) {
    (0, _classCallCheck3['default'])(this, ScrollableTabBarNode);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (ScrollableTabBarNode.__proto__ || Object.getPrototypeOf(ScrollableTabBarNode)).call(this, props));

    _this.prevTransitionEnd = function (e) {
      if (e.propertyName !== 'opacity') {
        return;
      }
      var container = _this.props.getRef('container');
      _this.scrollToActiveTab({
        target: container,
        currentTarget: container
      });
    };

    _this.scrollToActiveTab = function (e) {
      var activeTab = _this.props.getRef('activeTab');
      var navWrap = _this.props.getRef('navWrap');
      if (e && e.target !== e.currentTarget || !activeTab) {
        return;
      }

      // when not scrollable or enter scrollable first time, don't emit scrolling
      var needToSroll = _this.isNextPrevShown() && _this.lastNextPrevShown;
      _this.lastNextPrevShown = _this.isNextPrevShown();
      if (!needToSroll) {
        return;
      }

      var activeTabWH = _this.getScrollWH(activeTab);
      var navWrapNodeWH = _this.getOffsetWH(navWrap);
      var offset = _this.offset;

      var wrapOffset = _this.getOffsetLT(navWrap);
      var activeTabOffset = _this.getOffsetLT(activeTab);
      if (wrapOffset > activeTabOffset) {
        offset += wrapOffset - activeTabOffset;
        _this.setOffset(offset);
      } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
        offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
        _this.setOffset(offset);
      }
    };

    _this.prev = function (e) {
      _this.props.onPrevClick(e);
      var navWrapNode = _this.props.getRef('navWrap');
      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
      var offset = _this.offset;

      _this.setOffset(offset + navWrapNodeWH);
    };

    _this.next = function (e) {
      _this.props.onNextClick(e);
      var navWrapNode = _this.props.getRef('navWrap');
      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
      var offset = _this.offset;

      _this.setOffset(offset - navWrapNodeWH);
    };

    _this.offset = 0;

    _this.state = {
      next: false,
      prev: false
    };
    return _this;
  }

  (0, _createClass3['default'])(ScrollableTabBarNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.componentDidUpdate();
      this.debouncedResize = (0, _debounce2['default'])(function () {
        _this2.setNextPrev();
        _this2.scrollToActiveTab();
      }, 200);
      this.resizeEvent = (0, _addEventListener2['default'])(window, 'resize', this.debouncedResize);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
        this.setOffset(0);
        return;
      }
      var nextPrev = this.setNextPrev();
      // wait next, prev show hide
      /* eslint react/no-did-update-set-state:0 */
      if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
        this.setState({}, this.scrollToActiveTab);
      } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
        // can not use props.activeKey
        this.scrollToActiveTab();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.resizeEvent) {
        this.resizeEvent.remove();
      }
      if (this.debouncedResize && this.debouncedResize.cancel) {
        this.debouncedResize.cancel();
      }
    }
  }, {
    key: 'setNextPrev',
    value: function setNextPrev() {
      var navNode = this.props.getRef('nav');
      var navTabsContainer = this.props.getRef('navTabsContainer');
      var navNodeWH = this.getScrollWH(navTabsContainer || navNode);
      // Add 1px to fix `offsetWidth` with decimal in Chrome not correct handle
      // https://github.com/ant-design/ant-design/issues/13423
      var containerWH = this.getOffsetWH(this.props.getRef('container')) + 1;
      var navWrapNodeWH = this.getOffsetWH(this.props.getRef('navWrap'));
      var offset = this.offset;

      var minOffset = containerWH - navNodeWH;
      var _state = this.state,
          next = _state.next,
          prev = _state.prev;

      if (minOffset >= 0) {
        next = false;
        this.setOffset(0, false);
        offset = 0;
      } else if (minOffset < offset) {
        next = true;
      } else {
        next = false;
        // Fix https://github.com/ant-design/ant-design/issues/8861
        // Test with container offset which is stable
        // and set the offset of the nav wrap node
        var realOffset = navWrapNodeWH - navNodeWH;
        this.setOffset(realOffset, false);
        offset = realOffset;
      }

      if (offset < 0) {
        prev = true;
      } else {
        prev = false;
      }

      this.setNext(next);
      this.setPrev(prev);
      return {
        next: next,
        prev: prev
      };
    }
  }, {
    key: 'getOffsetWH',
    value: function getOffsetWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'offsetWidth';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'offsetHeight';
      }
      return node[prop];
    }
  }, {
    key: 'getScrollWH',
    value: function getScrollWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'scrollWidth';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'scrollHeight';
      }
      return node[prop];
    }
  }, {
    key: 'getOffsetLT',
    value: function getOffsetLT(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'left';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'top';
      }
      return node.getBoundingClientRect()[prop];
    }
  }, {
    key: 'setOffset',
    value: function setOffset(offset) {
      var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var target = Math.min(0, offset);
      if (this.offset !== target) {
        this.offset = target;
        var navOffset = {};
        var tabBarPosition = this.props.tabBarPosition;
        var navStyle = this.props.getRef('nav').style;
        var transformSupported = (0, _utils.isTransformSupported)(navStyle);
        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
          if (transformSupported) {
            navOffset = {
              value: 'translate3d(0,' + target + 'px,0)'
            };
          } else {
            navOffset = {
              name: 'top',
              value: target + 'px'
            };
          }
        } else if (transformSupported) {
          navOffset = {
            value: 'translate3d(' + target + 'px,0,0)'
          };
        } else {
          navOffset = {
            name: 'left',
            value: target + 'px'
          };
        }
        if (transformSupported) {
          (0, _utils.setTransform)(navStyle, navOffset.value);
        } else {
          navStyle[navOffset.name] = navOffset.value;
        }
        if (checkNextPrev) {
          this.setNextPrev();
        }
      }
    }
  }, {
    key: 'setPrev',
    value: function setPrev(v) {
      if (this.state.prev !== v) {
        this.setState({
          prev: v
        });
      }
    }
  }, {
    key: 'setNext',
    value: function setNext(v) {
      if (this.state.next !== v) {
        this.setState({
          next: v
        });
      }
    }
  }, {
    key: 'isNextPrevShown',
    value: function isNextPrevShown(state) {
      if (state) {
        return state.next || state.prev;
      }
      return this.state.next || this.state.prev;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2, _classnames3, _classnames4;

      var _state2 = this.state,
          next = _state2.next,
          prev = _state2.prev;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          scrollAnimated = _props.scrollAnimated,
          navWrapper = _props.navWrapper,
          prevIcon = _props.prevIcon,
          nextIcon = _props.nextIcon;

      var showNextPrev = prev || next;

      var prevButton = _react2['default'].createElement(
        'span',
        {
          onClick: prev ? this.prev : null,
          unselectable: 'unselectable',
          className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
          onTransitionEnd: this.prevTransitionEnd
        },
        prevIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' })
      );

      var nextButton = _react2['default'].createElement(
        'span',
        {
          onClick: next ? this.next : null,
          unselectable: 'unselectable',
          className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
        },
        nextIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' })
      );

      var navClassName = prefixCls + '-nav';
      var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));

      return _react2['default'].createElement(
        'div',
        {
          className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
          key: 'container',
          ref: this.props.saveRef('container')
        },
        prevButton,
        nextButton,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-nav-wrap', ref: this.props.saveRef('navWrap') },
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-nav-scroll' },
            _react2['default'].createElement(
              'div',
              { className: navClasses, ref: this.props.saveRef('nav') },
              navWrapper(this.props.children)
            )
          )
        )
      );
    }
  }]);
  return ScrollableTabBarNode;
}(_react2['default'].Component);

exports['default'] = ScrollableTabBarNode;


ScrollableTabBarNode.propTypes = {
  getRef: _propTypes2['default'].func.isRequired,
  saveRef: _propTypes2['default'].func.isRequired,
  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
  prefixCls: _propTypes2['default'].string,
  scrollAnimated: _propTypes2['default'].bool,
  onPrevClick: _propTypes2['default'].func,
  onNextClick: _propTypes2['default'].func,
  navWrapper: _propTypes2['default'].func,
  children: _propTypes2['default'].node,
  prevIcon: _propTypes2['default'].node,
  nextIcon: _propTypes2['default'].node
};

ScrollableTabBarNode.defaultProps = {
  tabBarPosition: 'left',
  prefixCls: '',
  scrollAnimated: true,
  onPrevClick: function onPrevClick() {},
  onNextClick: function onNextClick() {},
  navWrapper: function navWrapper(ele) {
    return ele;
  }
};
module.exports = exports['default'];

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(101);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(150),
    isSymbol = __webpack_require__(213);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(214);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SaveRef = function (_React$Component) {
  (0, _inherits3['default'])(SaveRef, _React$Component);

  function SaveRef() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, SaveRef);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = SaveRef.__proto__ || Object.getPrototypeOf(SaveRef)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (name) {
      return _this[name];
    }, _this.saveRef = function (name) {
      return function (node) {
        if (node) {
          _this[name] = node;
        }
      };
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(SaveRef, [{
    key: 'render',
    value: function render() {
      return this.props.children(this.saveRef, this.getRef);
    }
  }]);
  return SaveRef;
}(_react2['default'].Component);

exports['default'] = SaveRef;


SaveRef.propTypes = {
  children: _propTypes2['default'].func
};

SaveRef.defaultProps = {
  children: function children() {
    return null;
  }
};
module.exports = exports['default'];

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ant_design_icons_lib_outline_AreaChartOutline__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ant_design_icons_lib_outline_AreaChartOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ant_design_icons_lib_outline_AreaChartOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AreaChartOutline", function() { return __WEBPACK_IMPORTED_MODULE_0__ant_design_icons_lib_outline_AreaChartOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_lib_outline_AuditOutline__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_lib_outline_AuditOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ant_design_icons_lib_outline_AuditOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AuditOutline", function() { return __WEBPACK_IMPORTED_MODULE_1__ant_design_icons_lib_outline_AuditOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ant_design_icons_lib_outline_BarChartOutline__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ant_design_icons_lib_outline_BarChartOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ant_design_icons_lib_outline_BarChartOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "BarChartOutline", function() { return __WEBPACK_IMPORTED_MODULE_2__ant_design_icons_lib_outline_BarChartOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ant_design_icons_lib_outline_BlockOutline__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ant_design_icons_lib_outline_BlockOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ant_design_icons_lib_outline_BlockOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "BlockOutline", function() { return __WEBPACK_IMPORTED_MODULE_3__ant_design_icons_lib_outline_BlockOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_outline_BranchesOutline__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_outline_BranchesOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_outline_BranchesOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "BranchesOutline", function() { return __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_outline_BranchesOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ant_design_icons_lib_outline_CalendarOutline__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ant_design_icons_lib_outline_CalendarOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ant_design_icons_lib_outline_CalendarOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CalendarOutline", function() { return __WEBPACK_IMPORTED_MODULE_5__ant_design_icons_lib_outline_CalendarOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_outline_CaretDownOutline__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_outline_CaretDownOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_outline_CaretDownOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CaretDownOutline", function() { return __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_outline_CaretDownOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_outline_CaretLeftOutline__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_outline_CaretLeftOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_outline_CaretLeftOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CaretLeftOutline", function() { return __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_outline_CaretLeftOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_outline_CaretRightOutline__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_outline_CaretRightOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_outline_CaretRightOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CaretRightOutline", function() { return __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_outline_CaretRightOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_outline_CaretUpOutline__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_outline_CaretUpOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_outline_CaretUpOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CaretUpOutline", function() { return __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_outline_CaretUpOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_outline_CheckOutline__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_outline_CheckOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_outline_CheckOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CheckOutline", function() { return __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_outline_CheckOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_outline_CheckCircleOutline__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_outline_CheckCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_outline_CheckCircleOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CheckCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_outline_CheckCircleOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ant_design_icons_lib_outline_ClockCircleOutline__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ant_design_icons_lib_outline_ClockCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ant_design_icons_lib_outline_ClockCircleOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ClockCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_12__ant_design_icons_lib_outline_ClockCircleOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ant_design_icons_lib_outline_CloseOutline__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ant_design_icons_lib_outline_CloseOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ant_design_icons_lib_outline_CloseOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CloseOutline", function() { return __WEBPACK_IMPORTED_MODULE_13__ant_design_icons_lib_outline_CloseOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_outline_CloseCircleOutline__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_outline_CloseCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_outline_CloseCircleOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CloseCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_outline_CloseCircleOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_outline_CloseSquareOutline__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_outline_CloseSquareOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_outline_CloseSquareOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CloseSquareOutline", function() { return __WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_outline_CloseSquareOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ant_design_icons_lib_outline_CodeOutline__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ant_design_icons_lib_outline_CodeOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ant_design_icons_lib_outline_CodeOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CodeOutline", function() { return __WEBPACK_IMPORTED_MODULE_16__ant_design_icons_lib_outline_CodeOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ant_design_icons_lib_outline_CopyOutline__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ant_design_icons_lib_outline_CopyOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ant_design_icons_lib_outline_CopyOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CopyOutline", function() { return __WEBPACK_IMPORTED_MODULE_17__ant_design_icons_lib_outline_CopyOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ant_design_icons_lib_outline_DatabaseOutline__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ant_design_icons_lib_outline_DatabaseOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ant_design_icons_lib_outline_DatabaseOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DatabaseOutline", function() { return __WEBPACK_IMPORTED_MODULE_18__ant_design_icons_lib_outline_DatabaseOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ant_design_icons_lib_outline_DeleteOutline__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ant_design_icons_lib_outline_DeleteOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ant_design_icons_lib_outline_DeleteOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeleteOutline", function() { return __WEBPACK_IMPORTED_MODULE_19__ant_design_icons_lib_outline_DeleteOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ant_design_icons_lib_outline_DisconnectOutline__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ant_design_icons_lib_outline_DisconnectOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ant_design_icons_lib_outline_DisconnectOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DisconnectOutline", function() { return __WEBPACK_IMPORTED_MODULE_20__ant_design_icons_lib_outline_DisconnectOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ant_design_icons_lib_outline_DoubleLeftOutline__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ant_design_icons_lib_outline_DoubleLeftOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ant_design_icons_lib_outline_DoubleLeftOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DoubleLeftOutline", function() { return __WEBPACK_IMPORTED_MODULE_21__ant_design_icons_lib_outline_DoubleLeftOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ant_design_icons_lib_outline_DoubleRightOutline__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ant_design_icons_lib_outline_DoubleRightOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ant_design_icons_lib_outline_DoubleRightOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DoubleRightOutline", function() { return __WEBPACK_IMPORTED_MODULE_22__ant_design_icons_lib_outline_DoubleRightOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ant_design_icons_lib_outline_DownOutline__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ant_design_icons_lib_outline_DownOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__ant_design_icons_lib_outline_DownOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DownOutline", function() { return __WEBPACK_IMPORTED_MODULE_23__ant_design_icons_lib_outline_DownOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ant_design_icons_lib_outline_DownloadOutline__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ant_design_icons_lib_outline_DownloadOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__ant_design_icons_lib_outline_DownloadOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DownloadOutline", function() { return __WEBPACK_IMPORTED_MODULE_24__ant_design_icons_lib_outline_DownloadOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ant_design_icons_lib_outline_EllipsisOutline__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ant_design_icons_lib_outline_EllipsisOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__ant_design_icons_lib_outline_EllipsisOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EllipsisOutline", function() { return __WEBPACK_IMPORTED_MODULE_25__ant_design_icons_lib_outline_EllipsisOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ant_design_icons_lib_outline_EnvironmentOutline__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ant_design_icons_lib_outline_EnvironmentOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__ant_design_icons_lib_outline_EnvironmentOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EnvironmentOutline", function() { return __WEBPACK_IMPORTED_MODULE_26__ant_design_icons_lib_outline_EnvironmentOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ant_design_icons_lib_outline_ExclamationOutline__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ant_design_icons_lib_outline_ExclamationOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ant_design_icons_lib_outline_ExclamationOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExclamationOutline", function() { return __WEBPACK_IMPORTED_MODULE_27__ant_design_icons_lib_outline_ExclamationOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ant_design_icons_lib_outline_ExclamationCircleOutline__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ant_design_icons_lib_outline_ExclamationCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ant_design_icons_lib_outline_ExclamationCircleOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExclamationCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_28__ant_design_icons_lib_outline_ExclamationCircleOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ant_design_icons_lib_outline_ExportOutline__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ant_design_icons_lib_outline_ExportOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ant_design_icons_lib_outline_ExportOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExportOutline", function() { return __WEBPACK_IMPORTED_MODULE_29__ant_design_icons_lib_outline_ExportOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ant_design_icons_lib_outline_EyeOutline__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ant_design_icons_lib_outline_EyeOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ant_design_icons_lib_outline_EyeOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EyeOutline", function() { return __WEBPACK_IMPORTED_MODULE_30__ant_design_icons_lib_outline_EyeOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ant_design_icons_lib_outline_FileAddOutline__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ant_design_icons_lib_outline_FileAddOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__ant_design_icons_lib_outline_FileAddOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileAdd", function() { return __WEBPACK_IMPORTED_MODULE_31__ant_design_icons_lib_outline_FileAddOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ant_design_icons_lib_outline_FileOutline__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ant_design_icons_lib_outline_FileOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__ant_design_icons_lib_outline_FileOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileOutline", function() { return __WEBPACK_IMPORTED_MODULE_32__ant_design_icons_lib_outline_FileOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ant_design_icons_lib_outline_FileSearchOutline__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ant_design_icons_lib_outline_FileSearchOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__ant_design_icons_lib_outline_FileSearchOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileSearchOutline", function() { return __WEBPACK_IMPORTED_MODULE_33__ant_design_icons_lib_outline_FileSearchOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ant_design_icons_lib_outline_FileTextOutline__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ant_design_icons_lib_outline_FileTextOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__ant_design_icons_lib_outline_FileTextOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileTextOutline", function() { return __WEBPACK_IMPORTED_MODULE_34__ant_design_icons_lib_outline_FileTextOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ant_design_icons_lib_outline_FilterOutline__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ant_design_icons_lib_outline_FilterOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__ant_design_icons_lib_outline_FilterOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FilterOutline", function() { return __WEBPACK_IMPORTED_MODULE_35__ant_design_icons_lib_outline_FilterOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ant_design_icons_lib_outline_FlagOutline__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ant_design_icons_lib_outline_FlagOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__ant_design_icons_lib_outline_FlagOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FlagOutline", function() { return __WEBPACK_IMPORTED_MODULE_36__ant_design_icons_lib_outline_FlagOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ant_design_icons_lib_outline_FolderOutline__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ant_design_icons_lib_outline_FolderOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__ant_design_icons_lib_outline_FolderOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FolderOutline", function() { return __WEBPACK_IMPORTED_MODULE_37__ant_design_icons_lib_outline_FolderOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ant_design_icons_lib_outline_FolderOpenOutline__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ant_design_icons_lib_outline_FolderOpenOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__ant_design_icons_lib_outline_FolderOpenOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FolderOpenOutline", function() { return __WEBPACK_IMPORTED_MODULE_38__ant_design_icons_lib_outline_FolderOpenOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ant_design_icons_lib_outline_GlobalOutline__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ant_design_icons_lib_outline_GlobalOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__ant_design_icons_lib_outline_GlobalOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "GlobalOutline", function() { return __WEBPACK_IMPORTED_MODULE_39__ant_design_icons_lib_outline_GlobalOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ant_design_icons_lib_outline_InfoOutline__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ant_design_icons_lib_outline_InfoOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__ant_design_icons_lib_outline_InfoOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "InfoOutline", function() { return __WEBPACK_IMPORTED_MODULE_40__ant_design_icons_lib_outline_InfoOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ant_design_icons_lib_outline_InfoCircleOutline__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ant_design_icons_lib_outline_InfoCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__ant_design_icons_lib_outline_InfoCircleOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "InfoCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_41__ant_design_icons_lib_outline_InfoCircleOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__ant_design_icons_lib_outline_LeftOutline__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__ant_design_icons_lib_outline_LeftOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__ant_design_icons_lib_outline_LeftOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LeftOutline", function() { return __WEBPACK_IMPORTED_MODULE_42__ant_design_icons_lib_outline_LeftOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__ant_design_icons_lib_outline_LineChartOutline__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__ant_design_icons_lib_outline_LineChartOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__ant_design_icons_lib_outline_LineChartOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LineChartOutline", function() { return __WEBPACK_IMPORTED_MODULE_43__ant_design_icons_lib_outline_LineChartOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__ant_design_icons_lib_outline_LinkOutline__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__ant_design_icons_lib_outline_LinkOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__ant_design_icons_lib_outline_LinkOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LinkOutline", function() { return __WEBPACK_IMPORTED_MODULE_44__ant_design_icons_lib_outline_LinkOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ant_design_icons_lib_outline_LoadingOutline__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ant_design_icons_lib_outline_LoadingOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__ant_design_icons_lib_outline_LoadingOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LoadingOutline", function() { return __WEBPACK_IMPORTED_MODULE_45__ant_design_icons_lib_outline_LoadingOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ant_design_icons_lib_outline_LockOutline__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ant_design_icons_lib_outline_LockOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__ant_design_icons_lib_outline_LockOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LockOutline", function() { return __WEBPACK_IMPORTED_MODULE_46__ant_design_icons_lib_outline_LockOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ant_design_icons_lib_outline_LoginOutline__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ant_design_icons_lib_outline_LoginOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__ant_design_icons_lib_outline_LoginOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LoginOutline", function() { return __WEBPACK_IMPORTED_MODULE_47__ant_design_icons_lib_outline_LoginOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__ant_design_icons_lib_outline_LogoutOutline__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__ant_design_icons_lib_outline_LogoutOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__ant_design_icons_lib_outline_LogoutOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LogoutOutline", function() { return __WEBPACK_IMPORTED_MODULE_48__ant_design_icons_lib_outline_LogoutOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__ant_design_icons_lib_outline_MailOutline__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__ant_design_icons_lib_outline_MailOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__ant_design_icons_lib_outline_MailOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MailOutline", function() { return __WEBPACK_IMPORTED_MODULE_49__ant_design_icons_lib_outline_MailOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ant_design_icons_lib_outline_MenuFoldOutline__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ant_design_icons_lib_outline_MenuFoldOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__ant_design_icons_lib_outline_MenuFoldOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MenuFoldOutline", function() { return __WEBPACK_IMPORTED_MODULE_50__ant_design_icons_lib_outline_MenuFoldOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ant_design_icons_lib_outline_MenuUnfoldOutline__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ant_design_icons_lib_outline_MenuUnfoldOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__ant_design_icons_lib_outline_MenuUnfoldOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MenuUnfoldOutline", function() { return __WEBPACK_IMPORTED_MODULE_51__ant_design_icons_lib_outline_MenuUnfoldOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ant_design_icons_lib_outline_MinusOutline__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ant_design_icons_lib_outline_MinusOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__ant_design_icons_lib_outline_MinusOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MinusOutline", function() { return __WEBPACK_IMPORTED_MODULE_52__ant_design_icons_lib_outline_MinusOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ant_design_icons_lib_outline_PaperClipOutline__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ant_design_icons_lib_outline_PaperClipOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__ant_design_icons_lib_outline_PaperClipOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PaperClipOutline", function() { return __WEBPACK_IMPORTED_MODULE_53__ant_design_icons_lib_outline_PaperClipOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ant_design_icons_lib_outline_PhoneOutline__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ant_design_icons_lib_outline_PhoneOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__ant_design_icons_lib_outline_PhoneOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PhoneOutline", function() { return __WEBPACK_IMPORTED_MODULE_54__ant_design_icons_lib_outline_PhoneOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ant_design_icons_lib_outline_PlusOutline__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ant_design_icons_lib_outline_PlusOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__ant_design_icons_lib_outline_PlusOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PlusOutline", function() { return __WEBPACK_IMPORTED_MODULE_55__ant_design_icons_lib_outline_PlusOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ant_design_icons_lib_outline_ProfileOutline__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ant_design_icons_lib_outline_ProfileOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__ant_design_icons_lib_outline_ProfileOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ProfileOutline", function() { return __WEBPACK_IMPORTED_MODULE_56__ant_design_icons_lib_outline_ProfileOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__ant_design_icons_lib_outline_QuestionCircleOutline__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__ant_design_icons_lib_outline_QuestionCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__ant_design_icons_lib_outline_QuestionCircleOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "QuestionCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_57__ant_design_icons_lib_outline_QuestionCircleOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__ant_design_icons_lib_outline_RightOutline__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__ant_design_icons_lib_outline_RightOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__ant_design_icons_lib_outline_RightOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "RightOutline", function() { return __WEBPACK_IMPORTED_MODULE_58__ant_design_icons_lib_outline_RightOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__ant_design_icons_lib_outline_SaveOutline__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__ant_design_icons_lib_outline_SaveOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__ant_design_icons_lib_outline_SaveOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SaveOutline", function() { return __WEBPACK_IMPORTED_MODULE_59__ant_design_icons_lib_outline_SaveOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__ant_design_icons_lib_outline_ScissorOutline__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__ant_design_icons_lib_outline_ScissorOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__ant_design_icons_lib_outline_ScissorOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ScissorOutline", function() { return __WEBPACK_IMPORTED_MODULE_60__ant_design_icons_lib_outline_ScissorOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__ant_design_icons_lib_outline_SearchOutline__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__ant_design_icons_lib_outline_SearchOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__ant_design_icons_lib_outline_SearchOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SearchOutline", function() { return __WEBPACK_IMPORTED_MODULE_61__ant_design_icons_lib_outline_SearchOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__ant_design_icons_lib_outline_SnippetsOutline__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__ant_design_icons_lib_outline_SnippetsOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__ant_design_icons_lib_outline_SnippetsOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SnippetsOutline", function() { return __WEBPACK_IMPORTED_MODULE_62__ant_design_icons_lib_outline_SnippetsOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__ant_design_icons_lib_outline_SolutionOutline__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__ant_design_icons_lib_outline_SolutionOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__ant_design_icons_lib_outline_SolutionOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SolutionOutline", function() { return __WEBPACK_IMPORTED_MODULE_63__ant_design_icons_lib_outline_SolutionOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__ant_design_icons_lib_outline_StockOutline__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__ant_design_icons_lib_outline_StockOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__ant_design_icons_lib_outline_StockOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StockOutline", function() { return __WEBPACK_IMPORTED_MODULE_64__ant_design_icons_lib_outline_StockOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ant_design_icons_lib_outline_StopOutline__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ant_design_icons_lib_outline_StopOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__ant_design_icons_lib_outline_StopOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StopOutline", function() { return __WEBPACK_IMPORTED_MODULE_65__ant_design_icons_lib_outline_StopOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ant_design_icons_lib_outline_SyncOutline__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ant_design_icons_lib_outline_SyncOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__ant_design_icons_lib_outline_SyncOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SyncOutline", function() { return __WEBPACK_IMPORTED_MODULE_66__ant_design_icons_lib_outline_SyncOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ant_design_icons_lib_outline_TableOutline__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ant_design_icons_lib_outline_TableOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__ant_design_icons_lib_outline_TableOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TableOutline", function() { return __WEBPACK_IMPORTED_MODULE_67__ant_design_icons_lib_outline_TableOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__ant_design_icons_lib_outline_UnorderedListOutline__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__ant_design_icons_lib_outline_UnorderedListOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__ant_design_icons_lib_outline_UnorderedListOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "UnorderedListOutline", function() { return __WEBPACK_IMPORTED_MODULE_68__ant_design_icons_lib_outline_UnorderedListOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__ant_design_icons_lib_outline_UploadOutline__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__ant_design_icons_lib_outline_UploadOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__ant_design_icons_lib_outline_UploadOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "UploadOutline", function() { return __WEBPACK_IMPORTED_MODULE_69__ant_design_icons_lib_outline_UploadOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__ant_design_icons_lib_outline_UpOutline__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__ant_design_icons_lib_outline_UpOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__ant_design_icons_lib_outline_UpOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "UpOutline", function() { return __WEBPACK_IMPORTED_MODULE_70__ant_design_icons_lib_outline_UpOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__ant_design_icons_lib_outline_UpSquareOutline__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__ant_design_icons_lib_outline_UpSquareOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__ant_design_icons_lib_outline_UpSquareOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "UpSquareOutline", function() { return __WEBPACK_IMPORTED_MODULE_71__ant_design_icons_lib_outline_UpSquareOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__ant_design_icons_lib_outline_UserOutline__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__ant_design_icons_lib_outline_UserOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__ant_design_icons_lib_outline_UserOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "UserOutline", function() { return __WEBPACK_IMPORTED_MODULE_72__ant_design_icons_lib_outline_UserOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__ant_design_icons_lib_outline_WarningOutline__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__ant_design_icons_lib_outline_WarningOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__ant_design_icons_lib_outline_WarningOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "WarningOutline", function() { return __WEBPACK_IMPORTED_MODULE_73__ant_design_icons_lib_outline_WarningOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__ant_design_icons_lib_outline_ZoomInOutline__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__ant_design_icons_lib_outline_ZoomInOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__ant_design_icons_lib_outline_ZoomInOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ZoomInOutline", function() { return __WEBPACK_IMPORTED_MODULE_74__ant_design_icons_lib_outline_ZoomInOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__ant_design_icons_lib_outline_ZoomOutOutline__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__ant_design_icons_lib_outline_ZoomOutOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__ant_design_icons_lib_outline_ZoomOutOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ZoomOutOutline", function() { return __WEBPACK_IMPORTED_MODULE_75__ant_design_icons_lib_outline_ZoomOutOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__ant_design_icons_lib_outline_RetweetOutline__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__ant_design_icons_lib_outline_RetweetOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__ant_design_icons_lib_outline_RetweetOutline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "RetweetOutline", function() { return __WEBPACK_IMPORTED_MODULE_76__ant_design_icons_lib_outline_RetweetOutline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__ant_design_icons_lib_fill_AppstoreFill__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__ant_design_icons_lib_fill_AppstoreFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__ant_design_icons_lib_fill_AppstoreFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AppstoreFill", function() { return __WEBPACK_IMPORTED_MODULE_77__ant_design_icons_lib_fill_AppstoreFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__ant_design_icons_lib_fill_CaretDownFill__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__ant_design_icons_lib_fill_CaretDownFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__ant_design_icons_lib_fill_CaretDownFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CaretDownFill", function() { return __WEBPACK_IMPORTED_MODULE_78__ant_design_icons_lib_fill_CaretDownFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__ant_design_icons_lib_fill_CaretLeftFill__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__ant_design_icons_lib_fill_CaretLeftFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__ant_design_icons_lib_fill_CaretLeftFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CaretLeftFill", function() { return __WEBPACK_IMPORTED_MODULE_79__ant_design_icons_lib_fill_CaretLeftFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__ant_design_icons_lib_fill_CaretRightFill__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__ant_design_icons_lib_fill_CaretRightFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__ant_design_icons_lib_fill_CaretRightFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CaretRightFill", function() { return __WEBPACK_IMPORTED_MODULE_80__ant_design_icons_lib_fill_CaretRightFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__ant_design_icons_lib_fill_CaretUpFill__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__ant_design_icons_lib_fill_CaretUpFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__ant_design_icons_lib_fill_CaretUpFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CaretUpFill", function() { return __WEBPACK_IMPORTED_MODULE_81__ant_design_icons_lib_fill_CaretUpFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__ant_design_icons_lib_fill_CheckCircleFill__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__ant_design_icons_lib_fill_CheckCircleFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__ant_design_icons_lib_fill_CheckCircleFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CheckCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_82__ant_design_icons_lib_fill_CheckCircleFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__ant_design_icons_lib_fill_CloseCircleFill__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__ant_design_icons_lib_fill_CloseCircleFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__ant_design_icons_lib_fill_CloseCircleFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CloseCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_83__ant_design_icons_lib_fill_CloseCircleFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__ant_design_icons_lib_fill_ExclamationCircleFill__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__ant_design_icons_lib_fill_ExclamationCircleFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__ant_design_icons_lib_fill_ExclamationCircleFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExclamationCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_84__ant_design_icons_lib_fill_ExclamationCircleFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__ant_design_icons_lib_fill_FileFill__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__ant_design_icons_lib_fill_FileFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__ant_design_icons_lib_fill_FileFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileFill", function() { return __WEBPACK_IMPORTED_MODULE_85__ant_design_icons_lib_fill_FileFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__ant_design_icons_lib_fill_FileTextFill__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__ant_design_icons_lib_fill_FileTextFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__ant_design_icons_lib_fill_FileTextFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileTextFill", function() { return __WEBPACK_IMPORTED_MODULE_86__ant_design_icons_lib_fill_FileTextFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__ant_design_icons_lib_fill_FilterFill__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__ant_design_icons_lib_fill_FilterFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__ant_design_icons_lib_fill_FilterFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FilterFill", function() { return __WEBPACK_IMPORTED_MODULE_87__ant_design_icons_lib_fill_FilterFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__ant_design_icons_lib_fill_FolderFill__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__ant_design_icons_lib_fill_FolderFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__ant_design_icons_lib_fill_FolderFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FolderFill", function() { return __WEBPACK_IMPORTED_MODULE_88__ant_design_icons_lib_fill_FolderFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__ant_design_icons_lib_fill_FolderOpenFill__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__ant_design_icons_lib_fill_FolderOpenFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__ant_design_icons_lib_fill_FolderOpenFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FolderOpenFill", function() { return __WEBPACK_IMPORTED_MODULE_89__ant_design_icons_lib_fill_FolderOpenFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__ant_design_icons_lib_fill_InfoCircleFill__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__ant_design_icons_lib_fill_InfoCircleFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__ant_design_icons_lib_fill_InfoCircleFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "InfoCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_90__ant_design_icons_lib_fill_InfoCircleFill___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__ant_design_icons_lib_fill_QuestionCircleFill__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__ant_design_icons_lib_fill_QuestionCircleFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__ant_design_icons_lib_fill_QuestionCircleFill__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "QuestionCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_91__ant_design_icons_lib_fill_QuestionCircleFill___default.a; });
/* Outline *//* Fill */

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AreaChartOutline = {
    name: 'area-chart',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z'
                }
            }
        ]
    }
};
exports.default = AreaChartOutline;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuditOutline = {
    name: 'audit',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z'
                }
            }
        ]
    }
};
exports.default = AuditOutline;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BarChartOutline = {
    name: 'bar-chart',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z'
                }
            }
        ]
    }
};
exports.default = BarChartOutline;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BlockOutline = {
    name: 'block',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z'
                }
            }
        ]
    }
};
exports.default = BlockOutline;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BranchesOutline = {
    name: 'branches',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
                }
            }
        ]
    }
};
exports.default = BranchesOutline;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CalendarOutline = {
    name: 'calendar',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z'
                }
            }
        ]
    }
};
exports.default = CalendarOutline;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CaretDownOutline = {
    name: 'caret-down',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'
                }
            }
        ]
    }
};
exports.default = CaretDownOutline;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CaretLeftOutline = {
    name: 'caret-left',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'
                }
            }
        ]
    }
};
exports.default = CaretLeftOutline;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CaretRightOutline = {
    name: 'caret-right',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'
                }
            }
        ]
    }
};
exports.default = CaretRightOutline;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CaretUpOutline = {
    name: 'caret-up',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'
                }
            }
        ]
    }
};
exports.default = CaretUpOutline;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CheckOutline = {
    name: 'check',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z'
                }
            }
        ]
    }
};
exports.default = CheckOutline;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CheckCircleOutline = {
    name: 'check-circle',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z'
                }
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
                }
            }
        ]
    }
};
exports.default = CheckCircleOutline;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ClockCircleOutline = {
    name: 'clock-circle',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
                }
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z'
                }
            }
        ]
    }
};
exports.default = ClockCircleOutline;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CloseOutline = {
    name: 'close',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'
                }
            }
        ]
    }
};
exports.default = CloseOutline;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CloseCircleOutline = {
    name: 'close-circle',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z'
                }
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
                }
            }
        ]
    }
};
exports.default = CloseCircleOutline;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CloseSquareOutline = {
    name: 'close-square',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z'
                }
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
                }
            }
        ]
    }
};
exports.default = CloseSquareOutline;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CodeOutline = {
    name: 'code',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
                }
            }
        ]
    }
};
exports.default = CodeOutline;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CopyOutline = {
    name: 'copy',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'
                }
            }
        ]
    }
};
exports.default = CopyOutline;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DatabaseOutline = {
    name: 'database',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
                }
            }
        ]
    }
};
exports.default = DatabaseOutline;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeleteOutline = {
    name: 'delete',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z'
                }
            }
        ]
    }
};
exports.default = DeleteOutline;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DisconnectOutline = {
    name: 'disconnect',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z'
                }
            }
        ]
    }
};
exports.default = DisconnectOutline;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DoubleLeftOutline = {
    name: 'double-left',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z'
                }
            }
        ]
    }
};
exports.default = DoubleLeftOutline;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DoubleRightOutline = {
    name: 'double-right',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z'
                }
            }
        ]
    }
};
exports.default = DoubleRightOutline;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DownOutline = {
    name: 'down',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z'
                }
            }
        ]
    }
};
exports.default = DownOutline;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DownloadOutline = {
    name: 'download',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'
                }
            }
        ]
    }
};
exports.default = DownloadOutline;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EllipsisOutline = {
    name: 'ellipsis',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'
                }
            }
        ]
    }
};
exports.default = EllipsisOutline;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EnvironmentOutline = {
    name: 'environment',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'
                }
            }
        ]
    }
};
exports.default = EnvironmentOutline;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExclamationOutline = {
    name: 'exclamation',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'
                }
            }
        ]
    }
};
exports.default = ExclamationOutline;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExclamationCircleOutline = {
    name: 'exclamation-circle',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
                }
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z'
                }
            }
        ]
    }
};
exports.default = ExclamationCircleOutline;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExportOutline = {
    name: 'export',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'
                }
            }
        ]
    }
};
exports.default = ExportOutline;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EyeOutline = {
    name: 'eye',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'
                }
            }
        ]
    }
};
exports.default = EyeOutline;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileAddOutline = {
    name: 'file-add',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'
                }
            }
        ]
    }
};
exports.default = FileAddOutline;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileOutline = {
    name: 'file',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'
                }
            }
        ]
    }
};
exports.default = FileOutline;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileSearchOutline = {
    name: 'file-search',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'
                }
            }
        ]
    }
};
exports.default = FileSearchOutline;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileTextOutline = {
    name: 'file-text',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z'
                }
            }
        ]
    }
};
exports.default = FileTextOutline;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FilterOutline = {
    name: 'filter',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'
                }
            }
        ]
    }
};
exports.default = FilterOutline;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FlagOutline = {
    name: 'flag',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'
                }
            }
        ]
    }
};
exports.default = FlagOutline;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FolderOutline = {
    name: 'folder',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
                }
            }
        ]
    }
};
exports.default = FolderOutline;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FolderOpenOutline = {
    name: 'folder-open',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'
                }
            }
        ]
    }
};
exports.default = FolderOpenOutline;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GlobalOutline = {
    name: 'global',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z'
                }
            }
        ]
    }
};
exports.default = GlobalOutline;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InfoOutline = {
    name: 'info',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z'
                }
            }
        ]
    }
};
exports.default = InfoOutline;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InfoCircleOutline = {
    name: 'info-circle',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
                }
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'
                }
            }
        ]
    }
};
exports.default = InfoCircleOutline;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LeftOutline = {
    name: 'left',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z'
                }
            }
        ]
    }
};
exports.default = LeftOutline;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LineChartOutline = {
    name: 'line-chart',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z'
                }
            }
        ]
    }
};
exports.default = LineChartOutline;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkOutline = {
    name: 'link',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z'
                }
            }
        ]
    }
};
exports.default = LinkOutline;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LoadingOutline = {
    name: 'loading',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z'
                }
            }
        ]
    }
};
exports.default = LoadingOutline;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LockOutline = {
    name: 'lock',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
                }
            }
        ]
    }
};
exports.default = LockOutline;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LoginOutline = {
    name: 'login',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            { tag: 'defs', attrs: {}, children: [{ tag: 'style', attrs: {} }] },
            {
                tag: 'path',
                attrs: {
                    d: 'M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z'
                }
            }
        ]
    }
};
exports.default = LoginOutline;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LogoutOutline = {
    name: 'logout',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'
                }
            }
        ]
    }
};
exports.default = LogoutOutline;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MailOutline = {
    name: 'mail',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z'
                }
            }
        ]
    }
};
exports.default = MailOutline;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MenuFoldOutline = {
    name: 'menu-fold',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z'
                }
            }
        ]
    }
};
exports.default = MenuFoldOutline;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MenuUnfoldOutline = {
    name: 'menu-unfold',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z'
                }
            }
        ]
    }
};
exports.default = MenuUnfoldOutline;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MinusOutline = {
    name: 'minus',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'
                }
            }
        ]
    }
};
exports.default = MinusOutline;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PaperClipOutline = {
    name: 'paper-clip',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z'
                }
            }
        ]
    }
};
exports.default = PaperClipOutline;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PhoneOutline = {
    name: 'phone',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'
                }
            }
        ]
    }
};
exports.default = PhoneOutline;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PlusOutline = {
    name: 'plus',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M848 474H550V152h-76v322H176c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h298v322h76V550h298c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'
                }
            }
        ]
    }
};
exports.default = PlusOutline;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProfileOutline = {
    name: 'profile',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
                }
            }
        ]
    }
};
exports.default = ProfileOutline;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var QuestionCircleOutline = {
    name: 'question-circle',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
                }
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
                }
            }
        ]
    }
};
exports.default = QuestionCircleOutline;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RightOutline = {
    name: 'right',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z'
                }
            }
        ]
    }
};
exports.default = RightOutline;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SaveOutline = {
    name: 'save',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'
                }
            }
        ]
    }
};
exports.default = SaveOutline;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ScissorOutline = {
    name: 'scissor',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z'
                }
            }
        ]
    }
};
exports.default = ScissorOutline;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SearchOutline = {
    name: 'search',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z'
                }
            }
        ]
    }
};
exports.default = SearchOutline;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SnippetsOutline = {
    name: 'snippets',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'
                }
            }
        ]
    }
};
exports.default = SnippetsOutline;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SolutionOutline = {
    name: 'solution',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'
                }
            }
        ]
    }
};
exports.default = SolutionOutline;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StockOutline = {
    name: 'stock',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z'
                }
            }
        ]
    }
};
exports.default = StockOutline;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StopOutline = {
    name: 'stop',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z'
                }
            }
        ]
    }
};
exports.default = StopOutline;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SyncOutline = {
    name: 'sync',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z'
                }
            }
        ]
    }
};
exports.default = SyncOutline;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TableOutline = {
    name: 'table',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z'
                }
            }
        ]
    }
};
exports.default = TableOutline;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UnorderedListOutline = {
    name: 'unordered-list',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'
                }
            }
        ]
    }
};
exports.default = UnorderedListOutline;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UploadOutline = {
    name: 'upload',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'
                }
            }
        ]
    }
};
exports.default = UploadOutline;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UpOutline = {
    name: 'up',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z'
                }
            }
        ]
    }
};
exports.default = UpOutline;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UpSquareOutline = {
    name: 'up-square',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z'
                }
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
                }
            }
        ]
    }
};
exports.default = UpSquareOutline;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserOutline = {
    name: 'user',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z'
                }
            }
        ]
    }
};
exports.default = UserOutline;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WarningOutline = {
    name: 'warning',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'
                }
            }
        ]
    }
};
exports.default = WarningOutline;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ZoomInOutline = {
    name: 'zoom-in',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'
                }
            }
        ]
    }
};
exports.default = ZoomInOutline;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ZoomOutOutline = {
    name: 'zoom-out',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'
                }
            }
        ]
    }
};
exports.default = ZoomOutOutline;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RetweetOutline = {
    name: 'retweet',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z'
                }
            }
        ]
    }
};
exports.default = RetweetOutline;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AppstoreFill = {
    name: 'appstore',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z'
                }
            }
        ]
    }
};
exports.default = AppstoreFill;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CaretDownFill = {
    name: 'caret-down',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'
                }
            }
        ]
    }
};
exports.default = CaretDownFill;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CaretLeftFill = {
    name: 'caret-left',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'
                }
            }
        ]
    }
};
exports.default = CaretLeftFill;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CaretRightFill = {
    name: 'caret-right',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'
                }
            }
        ]
    }
};
exports.default = CaretRightFill;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CaretUpFill = {
    name: 'caret-up',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'
                }
            }
        ]
    }
};
exports.default = CaretUpFill;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CheckCircleFill = {
    name: 'check-circle',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z'
                }
            }
        ]
    }
};
exports.default = CheckCircleFill;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CloseCircleFill = {
    name: 'close-circle',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z'
                }
            }
        ]
    }
};
exports.default = CloseCircleFill;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExclamationCircleFill = {
    name: 'exclamation-circle',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
                }
            }
        ]
    }
};
exports.default = ExclamationCircleFill;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileFill = {
    name: 'file',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'
                }
            }
        ]
    }
};
exports.default = FileFill;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileTextFill = {
    name: 'file-text',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z'
                }
            }
        ]
    }
};
exports.default = FileTextFill;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FilterFill = {
    name: 'filter',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z'
                }
            }
        ]
    }
};
exports.default = FilterFill;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FolderFill = {
    name: 'folder',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z'
                }
            }
        ]
    }
};
exports.default = FolderFill;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FolderOpenFill = {
    name: 'folder-open',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z'
                }
            }
        ]
    }
};
exports.default = FolderOpenFill;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InfoCircleFill = {
    name: 'info-circle',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
                }
            }
        ]
    }
};
exports.default = InfoCircleFill;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var QuestionCircleFill = {
    name: 'question-circle',
    theme: 'fill',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '64 64 896 896' },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'
                }
            }
        ]
    }
};
exports.default = QuestionCircleFill;


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(853);









var twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6'
};

var Icon = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Icon, _React$Component);

    function Icon() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Icon);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Icon, [{
        key: 'render',
        value: function render() {
            var _extends2;

            var _props = this.props,
                type = _props.type,
                className = _props.className,
                onClick = _props.onClick,
                style = _props.style,
                primaryColor = _props.primaryColor,
                secondaryColor = _props.secondaryColor,
                rest = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['type', 'className', 'onClick', 'style', 'primaryColor', 'secondaryColor']);

            var target = void 0;
            var colors = twoToneColorPalette;
            if (primaryColor) {
                colors = {
                    primaryColor: primaryColor,
                    secondaryColor: secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* getSecondaryColor */])(primaryColor)
                };
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_8__utils__["d" /* isIconDefinition */])(type)) {
                target = type;
            } else if (typeof type === 'string') {
                target = Icon.get(type, colors);
                if (!target) {
                    // log(`Could not find icon: ${type}`);
                    return null;
                }
            }
            if (!target) {
                Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* log */])('type should be string or icon definiton, but got ' + type);
                return null;
            }
            if (target && typeof target.icon === 'function') {
                target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, target, {
                    icon: target.icon(colors.primaryColor, colors.secondaryColor)
                });
            }
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* generate */])(target.icon, 'svg-' + target.name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()((_extends2 = {
                className: className,
                onClick: onClick,
                style: style
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'data-icon', target.name), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'width', '1em'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'height', '1em'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'fill', 'currentColor'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'aria-hidden', 'true'), _extends2), rest));
        }
    }], [{
        key: 'add',
        value: function add() {
            var _this2 = this;

            for (var _len = arguments.length, icons = Array(_len), _key = 0; _key < _len; _key++) {
                icons[_key] = arguments[_key];
            }

            icons.forEach(function (icon) {
                _this2.definitions.set(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["f" /* withSuffix */])(icon.name, icon.theme), icon);
            });
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.definitions.clear();
        }
    }, {
        key: 'get',
        value: function get(key) {
            var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : twoToneColorPalette;

            if (key) {
                var target = this.definitions.get(key);
                if (target && typeof target.icon === 'function') {
                    target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, target, {
                        icon: target.icon(colors.primaryColor, colors.secondaryColor)
                    });
                }
                return target;
            }
        }
    }, {
        key: 'setTwoToneColors',
        value: function setTwoToneColors(_ref) {
            var primaryColor = _ref.primaryColor,
                secondaryColor = _ref.secondaryColor;

            twoToneColorPalette.primaryColor = primaryColor;
            twoToneColorPalette.secondaryColor = secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* getSecondaryColor */])(primaryColor);
        }
    }, {
        key: 'getTwoToneColors',
        value: function getTwoToneColors() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, twoToneColorPalette);
        }
    }]);

    return Icon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Icon.displayName = 'IconReact';
Icon.definitions = new __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* MiniMap */]();
/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["e"] = log;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIconDefinition;
/* unused harmony export normalizeAttrs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiniMap; });
/* harmony export (immutable) */ __webpack_exports__["b"] = generate;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSecondaryColor;
/* harmony export (immutable) */ __webpack_exports__["f"] = withSuffix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ant_design_palettes__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ant_design_palettes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ant_design_palettes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);





function log(message) {
    if (!(process && Object({"NODE_ENV":"production","PUBLIC_URL":"."}) && "production" === 'production')) {
        console.error('[@ant-design/icons-react]: ' + message + '.');
    }
}
function isIconDefinition(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return Object.keys(attrs).reduce(function (acc, key) {
        var val = attrs[key];
        switch (key) {
            case 'class':
                acc.className = val;
                delete acc['class'];
                break;
            default:
                acc[key] = val;
        }
        return acc;
    }, {});
}
var MiniMap = function () {
    function MiniMap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MiniMap);

        this.collection = {};
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MiniMap, [{
        key: 'clear',
        value: function clear() {
            this.collection = {};
        }
    }, {
        key: 'delete',
        value: function _delete(key) {
            return delete this.collection[key];
        }
    }, {
        key: 'get',
        value: function get(key) {
            return this.collection[key];
        }
    }, {
        key: 'has',
        value: function has(key) {
            return Boolean(this.collection[key]);
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            this.collection[key] = value;
            return this;
        }
    }, {
        key: 'size',
        get: function get() {
            return Object.keys(this.collection).length;
        }
    }]);

    return MiniMap;
}();
function generate(node, key, rootProps) {
    if (!rootProps) {
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](node.tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
            return generate(child, key + '-' + node.tag + '-' + index);
        }));
    }
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](node.tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        key: key
    }, normalizeAttrs(node.attrs), rootProps), (node.children || []).map(function (child, index) {
        return generate(child, key + '-' + node.tag + '-' + index);
    }));
}
function getSecondaryColor(primaryColor) {
    // choose the second color
    return Object(__WEBPACK_IMPORTED_MODULE_3_ant_design_palettes__["generate"])(primaryColor)[0];
}
function withSuffix(name, theme) {
    switch (theme) {
        case 'fill':
            return name + '-fill';
        case 'outline':
            return name + '-o';
        case 'twotone':
            return name + '-twotone';
        default:
            throw new TypeError('Unknown theme type: ' + theme + ', name: ' + name);
    }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(290)))

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presetPrimaryColors = exports.presetPalettes = exports.generate = undefined;

var _generate = __webpack_require__(855);

var _generate2 = _interopRequireDefault(_generate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var presetPrimaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#1890FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666'
};

var presetPalettes = {};

Object.keys(presetPrimaryColors).forEach(function (key) {
  presetPalettes[key] = (0, _generate2.default)(presetPrimaryColors[key]);
});

exports.generate = _generate2.default;
exports.presetPalettes = presetPalettes;
exports.presetPrimaryColors = presetPrimaryColors;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generate;

var _tinycolor = __webpack_require__(856);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hueStep = 2; // 色相阶梯
var saturationStep = 16; // 饱和度阶梯，浅色部分
var saturationStep2 = 5; // 饱和度阶梯，深色部分
var brightnessStep1 = 5; // 亮度阶梯，浅色部分
var brightnessStep2 = 15; // 亮度阶梯，深色部分
var lightColorCount = 5; // 浅色数量，主色上
var darkColorCount = 4; // 深色数量，主色下

function getHue(hsv, i, light) {
  var hue = void 0;
  // 根据色相不同，色相转向不同
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}

function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  var saturation = void 0;
  if (light) {
    saturation = Math.round(hsv.s * 100) - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = Math.round(hsv.s * 100) + saturationStep;
  } else {
    saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
  }
  // 边界值修正
  if (saturation > 100) {
    saturation = 100;
  }
  // 第一格的 s 限制在 6-10 之间
  if (light && i === lightColorCount && saturation > 10) {
    saturation = 10;
  }
  if (saturation < 6) {
    saturation = 6;
  }
  return saturation;
}

function getValue(hsv, i, light) {
  if (light) {
    return Math.round(hsv.v * 100) + brightnessStep1 * i;
  }
  return Math.round(hsv.v * 100) - brightnessStep2 * i;
}

function generate(color) {
  var patterns = [];
  var pColor = (0, _tinycolor2.default)(color);
  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = pColor.toHsv();
    var colorString = (0, _tinycolor2.default)({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    }).toHexString();
    patterns.push(colorString);
  }
  patterns.push(pColor.toHexString());
  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = pColor.toHsv();
    var _colorString = (0, _tinycolor2.default)({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue(_hsv, _i)
    }).toHexString();
    patterns.push(_colorString);
  }
  return patterns;
}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = create;

var _index = _interopRequireDefault(__webpack_require__(25));

var React = _interopRequireWildcard(__webpack_require__(0));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var customCache = new Set();

function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
      _options$extraCommonP = options.extraCommonProps,
      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = function Iconfont(props) {
    var type = props.type,
        children = props.children,
        restProps = __rest(props, ["type", "children"]); // component > children > type


    var content = null;

    if (props.type) {
      content = React.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    if (children) {
      content = children;
    }

    return React.createElement(_index["default"], _extends({}, restProps, extraCommonProps), content);
  };

  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeFromTypeName = getThemeFromTypeName;
exports.removeTypeTheme = removeTypeTheme;
exports.withThemeSuffix = withThemeSuffix;
exports.alias = alias;
exports.svgBaseProps = void 0;

var _warning = _interopRequireDefault(__webpack_require__(87));

var _svgBaseProps;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var svgBaseProps = (_svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor'
}, _defineProperty(_svgBaseProps, 'aria-hidden', 'true'), _defineProperty(_svgBaseProps, "focusable", 'false'), _svgBaseProps);
exports.svgBaseProps = svgBaseProps;
var fillTester = /-fill$/;
var outlineTester = /-o$/;
var twoToneTester = /-twotone$/;

function getThemeFromTypeName(type) {
  var result = null;

  if (fillTester.test(type)) {
    result = 'filled';
  } else if (outlineTester.test(type)) {
    result = 'outlined';
  } else if (twoToneTester.test(type)) {
    result = 'twoTone';
  }

  return result;
}

function removeTypeTheme(type) {
  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
}

function withThemeSuffix(type, theme) {
  var result = type;

  if (theme === 'filled') {
    result += '-fill';
  } else if (theme === 'outlined') {
    result += '-o';
  } else if (theme === 'twoTone') {
    result += '-twotone';
  } else {
    (0, _warning["default"])(false, "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
  }

  return result;
} // For alias or compatibility


function alias(type) {
  switch (type) {
    case 'cross':
      return 'close';

    default:
  }

  return type;
}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTwoToneColor = setTwoToneColor;
exports.getTwoToneColor = getTwoToneColor;

var _iconsReact = _interopRequireDefault(__webpack_require__(402));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function setTwoToneColor(primaryColor) {
  return _iconsReact["default"].setTwoToneColors({
    primaryColor: primaryColor
  });
}

function getTwoToneColor() {
  var colors = _iconsReact["default"].getTwoToneColors();

  return colors.primaryColor;
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isFlexSupported;

function isFlexSupported() {
  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
    var documentElement = window.document.documentElement;
    return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
  }

  return false;
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(862);
var Util = __webpack_require__(406);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(863);
var each = __webpack_require__(406).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = throttleByAnimationFrame;
exports.throttleByAnimationFrameDecorator = throttleByAnimationFrameDecorator;

var _raf = _interopRequireDefault(__webpack_require__(151));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function throttleByAnimationFrame(fn) {
  var requestId;

  var later = function later(args) {
    return function () {
      requestId = null;
      fn.apply(void 0, _toConsumableArray(args));
    };
  };

  var throttled = function throttled() {
    if (requestId == null) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      requestId = (0, _raf["default"])(later(args));
    }
  };

  throttled.cancel = function () {
    return _raf["default"].cancel(requestId);
  };

  return throttled;
}

function throttleByAnimationFrameDecorator() {
  return function (target, key, descriptor) {
    var fn = descriptor.value;
    var definingProperty = false;
    return {
      configurable: true,
      get: function get() {
        if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
          return fn;
        }

        var boundFn = throttleByAnimationFrame(fn.bind(this));
        definingProperty = true;
        Object.defineProperty(this, key, {
          value: boundFn,
          configurable: true,
          writable: true
        });
        definingProperty = false;
        return boundFn;
      }
    };
  };
}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OptGroup__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Option__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PropTypes__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select__ = __webpack_require__(870);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return __WEBPACK_IMPORTED_MODULE_1__Option__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OptGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__OptGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SelectPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_2__PropTypes__["a"]; });




__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */].Option = __WEBPACK_IMPORTED_MODULE_1__Option__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */].OptGroup = __WEBPACK_IMPORTED_MODULE_0__OptGroup__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3__Select__["a" /* default */]);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var OptGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(OptGroup, _Component);

  function OptGroup() {
    _classCallCheck(this, OptGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptGroup).apply(this, arguments));
  }

  return OptGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


OptGroup.isSelectOptGroup = true;

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_classes__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_animate__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_menu__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Option__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PropTypes__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SelectTrigger__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util__ = __webpack_require__(295);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }















var SELECT_EMPTY_VALUE_KEY = 'RC_SELECT_EMPTY_VALUE_KEY';

var noop = function noop() {
  return null;
};

function chaining() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < fns.length; i++) {
      if (fns[i] && typeof fns[i] === 'function') {
        fns[i].apply(chaining, args);
      }
    }
  };
}

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
    _this.inputRef = null;
    _this.inputMirrorRef = null;
    _this.topCtrlRef = null;
    _this.selectTriggerRef = null;
    _this.rootRef = null;
    _this.selectionRef = null;
    _this.dropdownContainer = null;
    _this.blurTimer = null;
    _this.focusTimer = null; // tslint:disable-next-line:variable-name

    _this._focused = false; // tslint:disable-next-line:variable-name

    _this._mouseDown = false; // tslint:disable-next-line:variable-name

    _this._options = [];

    _this.onInputChange = function (event) {
      var tokenSeparators = _this.props.tokenSeparators;
      var val = event.target.value;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) && tokenSeparators.length && Object(__WEBPACK_IMPORTED_MODULE_13__util__["l" /* includesSeparators */])(val, tokenSeparators)) {
        var nextValue = _this.getValueByInput(val);

        if (nextValue !== undefined) {
          _this.fireChange(nextValue);
        }

        _this.setOpenState(false, true);

        _this.setInputValue('', false);

        return;
      }

      _this.setInputValue(val);

      _this.setState({
        open: true
      });

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props)) {
        _this.fireChange([val]);
      }
    };

    _this.onDropdownVisibleChange = function (open) {
      if (open && !_this._focused) {
        _this.clearBlurTime();

        _this.timeoutFocus();

        _this._focused = true;

        _this.updateFocusClassName();
      }

      _this.setOpenState(open);
    }; // combobox ignore


    _this.onKeyDown = function (event) {
      var open = _this.state.open;
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      var keyCode = event.keyCode;

      if (open && !_this.getInputDOMNode()) {
        _this.onInputKeyDown(event);
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        if (!open) {
          _this.setOpenState(true);
        }

        event.preventDefault();
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].SPACE) {
        // Not block space if popup is shown
        if (!open) {
          _this.setOpenState(true);

          event.preventDefault();
        }
      }
    };

    _this.onInputKeyDown = function (event) {
      var props = _this.props;

      if (props.disabled) {
        return;
      }

      var state = _this.state; // magic code

      var keyCode = event.keyCode;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && !event.target.value && keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
        event.preventDefault();
        var value = state.value;

        if (value.length) {
          _this.removeSelected(value[value.length - 1]);
        }

        return;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        if (!state.open) {
          _this.openIfHasChildren();

          event.preventDefault();
          event.stopPropagation();
          return;
        }
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER && state.open) {
        // Aviod trigger form submit when select item
        // https://github.com/ant-design/ant-design/issues/10861
        event.preventDefault();
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ESC) {
        if (state.open) {
          _this.setOpenState(false);

          event.preventDefault();
          event.stopPropagation();
        }

        return;
      }

      if (_this.getRealOpenState(state) && _this.selectTriggerRef) {
        var menu = _this.selectTriggerRef.getInnerMenu();

        if (menu && menu.onKeyDown(event, _this.handleBackfill)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    };

    _this.onMenuSelect = function (_ref) {
      var item = _ref.item;

      if (!item) {
        return;
      }

      var value = _this.state.value;
      var props = _this.props;
      var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item);
      var lastValue = value[value.length - 1];

      _this.fireSelect(selectedValue);

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(value, selectedValue) !== -1) {
          return;
        }

        value = value.concat([selectedValue]);
      } else {
        if (lastValue !== undefined && lastValue === selectedValue && selectedValue !== _this.state.backfillValue) {
          _this.setOpenState(false, true);

          return;
        }

        value = [selectedValue];

        _this.setOpenState(false, true);
      }

      _this.fireChange(value);

      var inputValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props) ? Object(__WEBPACK_IMPORTED_MODULE_13__util__["i" /* getPropValue */])(item, props.optionLabelProp) : '';

      if (props.autoClearSearchValue) {
        _this.setInputValue(inputValue, false);
      }
    };

    _this.onMenuDeselect = function (_ref2) {
      var item = _ref2.item,
          domEvent = _ref2.domEvent;

      if (domEvent.type === 'keydown' && domEvent.keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.removeSelected(Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item));

        return;
      }

      if (domEvent.type === 'click') {
        _this.removeSelected(Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item));
      }

      var props = _this.props;

      if (props.autoClearSearchValue) {
        _this.setInputValue('', false);
      }
    };

    _this.onArrowClick = function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (!_this.props.disabled) {
        _this.setOpenState(!_this.state.open, !_this.state.open);
      }
    };

    _this.onPlaceholderClick = function () {
      if (_this.getInputDOMNode && _this.getInputDOMNode()) {
        _this.getInputDOMNode().focus();
      }
    };

    _this.onOuterFocus = function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      _this.clearBlurTime();

      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props) && e.target === _this.getInputDOMNode()) {
        return;
      }

      if (_this._focused) {
        return;
      }

      _this._focused = true;

      _this.updateFocusClassName(); // only effect multiple or tag mode


      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) || !_this._mouseDown) {
        _this.timeoutFocus();
      }
    };

    _this.onPopupFocus = function () {
      // fix ie scrollbar, focus element again
      _this.maybeFocus(true, true);
    };

    _this.onOuterBlur = function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      _this.blurTimer = window.setTimeout(function () {
        _this._focused = false;

        _this.updateFocusClassName();

        var props = _this.props;
        var value = _this.state.value;
        var inputValue = _this.state.inputValue;

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
          var options = _this._options || [];

          if (options.length) {
            var firstOption = Object(__WEBPACK_IMPORTED_MODULE_13__util__["d" /* findFirstMenuItem */])(options);

            if (firstOption) {
              value = [Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(firstOption)];

              _this.fireChange(value);
            }
          }
        } else if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && inputValue) {
          if (_this._mouseDown) {
            // need update dropmenu when not blur
            _this.setInputValue('');
          } else {
            // why not use setState?
            // this.state.inputValue = '';
            _this.setState({
              inputValue: ''
            }, function () {
              if (_this.getInputDOMNode && _this.getInputDOMNode()) {
                _this.getInputDOMNode().value = '';
              }
            });
          }

          var tmpValue = _this.getValueByInput(inputValue);

          if (tmpValue !== undefined) {
            value = tmpValue;

            _this.fireChange(value);
          }
        } // if click the rest space of Select in multiple mode


        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && _this._mouseDown) {
          _this.maybeFocus(true, true);

          _this._mouseDown = false;
          return;
        }

        _this.setOpenState(false);

        if (props.onBlur) {
          props.onBlur(_this.getVLForOnChange(value));
        }
      }, 10);
    };

    _this.onClearSelection = function (event) {
      var props = _this.props;
      var state = _this.state;

      if (props.disabled) {
        return;
      }

      var inputValue = state.inputValue;
      var value = state.value;
      event.stopPropagation();

      if (inputValue || value.length) {
        if (value.length) {
          _this.fireChange([]);
        }

        _this.setOpenState(false, true);

        if (inputValue) {
          _this.setInputValue('');
        }
      }
    };

    _this.onChoiceAnimationLeave = function () {
      _this.forcePopupAlign();
    };

    _this.getOptionInfoBySingleValue = function (value, optionsInfo) {
      var info;
      optionsInfo = optionsInfo || _this.state.optionsInfo;

      if (optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)]) {
        info = optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)];
      }

      if (info) {
        return info;
      }

      var defaultLabel = value;

      if (_this.props.labelInValue) {
        var label = Object(__WEBPACK_IMPORTED_MODULE_13__util__["g" /* getLabelFromPropsValue */])(_this.props.value, value);

        if (label !== undefined) {
          defaultLabel = label;
        }
      }

      var defaultInfo = {
        option: __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Option__["a" /* default */], {
          value: value,
          key: value
        }, value),
        value: value,
        label: defaultLabel
      };
      return defaultInfo;
    };

    _this.getOptionBySingleValue = function (value) {
      var _this$getOptionInfoBy = _this.getOptionInfoBySingleValue(value),
          option = _this$getOptionInfoBy.option;

      return option;
    };

    _this.getOptionsBySingleValue = function (values) {
      return values.map(function (value) {
        return _this.getOptionBySingleValue(value);
      });
    };

    _this.getValueByLabel = function (label) {
      if (label === undefined) {
        return null;
      }

      var value = null;
      Object.keys(_this.state.optionsInfo).forEach(function (key) {
        var info = _this.state.optionsInfo[key];
        var oldLable = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(info.label);

        if (oldLable && oldLable.join('') === label) {
          value = info.value;
        }
      });
      return value;
    };

    _this.getVLBySingleValue = function (value) {
      if (_this.props.labelInValue) {
        return {
          key: value,
          label: _this.getLabelBySingleValue(value)
        };
      }

      return value;
    };

    _this.getVLForOnChange = function (vlsS) {
      var vls = vlsS;

      if (vls !== undefined) {
        if (!_this.props.labelInValue) {
          vls = vls.map(function (v) {
            return v;
          });
        } else {
          vls = vls.map(function (vl) {
            return {
              key: vl,
              label: _this.getLabelBySingleValue(vl)
            };
          });
        }

        return Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) ? vls : vls[0];
      }

      return vls;
    };

    _this.getLabelBySingleValue = function (value, optionsInfo) {
      var _this$getOptionInfoBy2 = _this.getOptionInfoBySingleValue(value, optionsInfo),
          label = _this$getOptionInfoBy2.label;

      return label;
    };

    _this.getDropdownContainer = function () {
      if (!_this.dropdownContainer) {
        _this.dropdownContainer = document.createElement('div');
        document.body.appendChild(_this.dropdownContainer);
      }

      return _this.dropdownContainer;
    };

    _this.getPlaceholderElement = function () {
      var props = _this.props;
      var state = _this.state;
      var hidden = false;

      if (state.inputValue) {
        hidden = true;
      }

      var value = state.value;

      if (value.length) {
        hidden = true;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props) && value.length === 1 && state.value && !state.value[0]) {
        hidden = false;
      }

      var placeholder = props.placeholder;

      if (placeholder) {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", _extends({
          onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
          style: _extends({
            display: hidden ? 'none' : 'block'
          }, __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */])
        }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
          onClick: _this.onPlaceholderClick,
          className: "".concat(props.prefixCls, "-selection__placeholder")
        }), placeholder);
      }

      return null;
    };

    _this.getInputElement = function () {
      var props = _this.props;
      var defaultInput = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("input", {
        id: props.id,
        autoComplete: "off"
      }); // tslint:disable-next-line:typedef-whitespace

      var inputElement = props.getInputElement ? props.getInputElement() : defaultInput;
      var inputCls = __WEBPACK_IMPORTED_MODULE_0_classnames___default()(inputElement.props.className, _defineProperty({}, "".concat(props.prefixCls, "-search__field"), true)); // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
      // Add space to the end of the inputValue as the width measurement tolerance

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: "".concat(props.prefixCls, "-search__field__wrap")
      }, __WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"](inputElement, {
        ref: _this.saveInputRef,
        onChange: _this.onInputChange,
        onKeyDown: chaining(_this.onInputKeyDown, inputElement.props.onKeyDown, _this.props.onInputKeyDown),
        value: _this.state.inputValue,
        disabled: props.disabled,
        className: inputCls
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        ref: _this.saveInputMirrorRef,
        className: "".concat(props.prefixCls, "-search__field__mirror")
      }, _this.state.inputValue, "\xA0"));
    };

    _this.getInputDOMNode = function () {
      return _this.topCtrlRef ? _this.topCtrlRef.querySelector('input,textarea,div[contentEditable]') : _this.inputRef;
    };

    _this.getInputMirrorDOMNode = function () {
      return _this.inputMirrorRef;
    };

    _this.getPopupDOMNode = function () {
      if (_this.selectTriggerRef) {
        return _this.selectTriggerRef.getPopupDOMNode();
      }
    };

    _this.getPopupMenuComponent = function () {
      if (_this.selectTriggerRef) {
        return _this.selectTriggerRef.getInnerMenu();
      }
    };

    _this.setOpenState = function (open, needFocus) {
      var props = _this.props;
      var state = _this.state;

      if (state.open === open) {
        _this.maybeFocus(open, !!needFocus);

        return;
      }

      if (_this.props.onDropdownVisibleChange) {
        _this.props.onDropdownVisibleChange(open);
      }

      var nextState = {
        open: open,
        backfillValue: ''
      }; // clear search input value when open is false in singleMode.

      if (!open && Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props) && props.showSearch) {
        _this.setInputValue('', false);
      }

      if (!open) {
        _this.maybeFocus(open, !!needFocus);
      }

      _this.setState(_extends({
        open: open
      }, nextState), function () {
        if (open) {
          _this.maybeFocus(open, !!needFocus);
        }
      });
    };

    _this.setInputValue = function (inputValue) {
      var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (inputValue !== _this.state.inputValue) {
        _this.setState({
          inputValue: inputValue
        }, _this.forcePopupAlign);

        if (fireSearch && _this.props.onSearch) {
          _this.props.onSearch(inputValue);
        }
      }
    };

    _this.getValueByInput = function (str) {
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          tokenSeparators = _this$props.tokenSeparators;
      var nextValue = _this.state.value;
      var hasNewValue = false;
      Object(__WEBPACK_IMPORTED_MODULE_13__util__["s" /* splitBySeparators */])(str, tokenSeparators).forEach(function (label) {
        var selectedValue = [label];

        if (multiple) {
          var value = _this.getValueByLabel(label);

          if (value && Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(nextValue, value) === -1) {
            nextValue = nextValue.concat(value);
            hasNewValue = true;

            _this.fireSelect(value);
          }
        } else if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* findIndexInValueBySingleValue */])(nextValue, label) === -1) {
          nextValue = nextValue.concat(selectedValue);
          hasNewValue = true;

          _this.fireSelect(label);
        }
      });
      return hasNewValue ? nextValue : undefined;
    };

    _this.getRealOpenState = function (state) {
      // tslint:disable-next-line:variable-name
      var _open = _this.props.open;

      if (typeof _open === 'boolean') {
        return _open;
      }

      var open = (state || _this.state).open;
      var options = _this._options || [];

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props) || !_this.props.showSearch) {
        if (open && !options.length) {
          open = false;
        }
      }

      return open;
    };

    _this.markMouseDown = function () {
      _this._mouseDown = true;
    };

    _this.markMouseLeave = function () {
      _this._mouseDown = false;
    };

    _this.handleBackfill = function (item) {
      if (!_this.props.backfill || !(Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(_this.props) || Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props))) {
        return;
      }

      var key = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(item);

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(_this.props)) {
        _this.setInputValue(key, false);
      }

      _this.setState({
        value: [key],
        backfillValue: key
      });
    };

    _this.filterOption = function (input, child) {
      var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_13__util__["c" /* defaultFilterFn */];
      var value = _this.state.value;
      var lastValue = value[value.length - 1];

      if (!input || lastValue && lastValue === _this.state.backfillValue) {
        return true;
      }

      var filterFn = _this.props.filterOption;

      if ('filterOption' in _this.props) {
        if (filterFn === true) {
          filterFn = defaultFilter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        }
      } else {
        filterFn = defaultFilter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      }

      if (!filterFn) {
        return true;
      } else if (typeof filterFn === 'function') {
        return filterFn.call(_assertThisInitialized(_assertThisInitialized(_this)), input, child);
      } else if (child.props.disabled) {
        return false;
      }

      return true;
    };

    _this.timeoutFocus = function () {
      if (_this.focusTimer) {
        _this.clearFocusTime();
      }

      _this.focusTimer = window.setTimeout(function () {
        if (_this.props.onFocus) {
          _this.props.onFocus();
        }
      }, 10);
    };

    _this.clearFocusTime = function () {
      if (_this.focusTimer) {
        clearTimeout(_this.focusTimer);
        _this.focusTimer = null;
      }
    };

    _this.clearBlurTime = function () {
      if (_this.blurTimer) {
        clearTimeout(_this.blurTimer);
        _this.blurTimer = null;
      }
    };

    _this.updateFocusClassName = function () {
      var rootRef = _this.rootRef;
      var props = _this.props; // avoid setState and its side effect

      if (_this._focused) {
        __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(rootRef).add("".concat(props.prefixCls, "-focused"));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(rootRef).remove("".concat(props.prefixCls, "-focused"));
      }
    };

    _this.maybeFocus = function (open, needFocus) {
      if (needFocus || open) {
        var input = _this.getInputDOMNode();

        var _document = document,
            activeElement = _document.activeElement;

        if (input && (open || Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(_this.props))) {
          if (activeElement !== input) {
            input.focus();
            _this._focused = true;
          }
        } else if (activeElement !== _this.selectionRef && _this.selectionRef) {
          _this.selectionRef.focus();

          _this._focused = true;
        }
      }
    };

    _this.removeSelected = function (selectedKey, e) {
      var props = _this.props;

      if (props.disabled || _this.isChildDisabled(selectedKey)) {
        return;
      } // Do not trigger Trigger popup


      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      var oldValue = _this.state.value;
      var value = oldValue.filter(function (singleValue) {
        return singleValue !== selectedKey;
      });
      var canMultiple = Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props);

      if (canMultiple) {
        var event = selectedKey;

        if (props.labelInValue) {
          event = {
            key: selectedKey,
            label: _this.getLabelBySingleValue(selectedKey)
          };
        }

        if (props.onDeselect) {
          props.onDeselect(event, _this.getOptionBySingleValue(selectedKey));
        }
      }

      _this.fireChange(value);
    };

    _this.openIfHasChildren = function () {
      var props = _this.props;

      if (__WEBPACK_IMPORTED_MODULE_6_react__["Children"].count(props.children) || Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props)) {
        _this.setOpenState(true);
      }
    };

    _this.fireSelect = function (value) {
      if (_this.props.onSelect) {
        _this.props.onSelect(_this.getVLBySingleValue(value), _this.getOptionBySingleValue(value));
      }
    };

    _this.fireChange = function (value) {
      var props = _this.props;

      if (!('value' in props)) {
        _this.setState({
          value: value
        }, _this.forcePopupAlign);
      }

      var vls = _this.getVLForOnChange(value);

      var options = _this.getOptionsBySingleValue(value);

      if (props.onChange) {
        props.onChange(vls, Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(_this.props) ? options : options[0]);
      }
    };

    _this.isChildDisabled = function (key) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(_this.props.children).some(function (child) {
        var childValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(child);
        return childValue === key && child.props && child.props.disabled;
      });
    };

    _this.forcePopupAlign = function () {
      if (!_this.state.open) {
        return;
      }

      if (_this.selectTriggerRef && _this.selectTriggerRef.triggerRef) {
        _this.selectTriggerRef.triggerRef.forcePopupAlign();
      }
    };

    _this.renderFilterOptions = function () {
      var inputValue = _this.state.inputValue;
      var _this$props2 = _this.props,
          children = _this$props2.children,
          tags = _this$props2.tags,
          filterOption = _this$props2.filterOption,
          notFoundContent = _this$props2.notFoundContent;
      var menuItems = [];
      var childrenKeys = [];

      var options = _this.renderFilterOptionsFromChildren(children, childrenKeys, menuItems);

      if (tags) {
        // tags value must be string
        var value = _this.state.value;
        value = value.filter(function (singleValue) {
          return childrenKeys.indexOf(singleValue) === -1 && (!inputValue || String(singleValue).indexOf(String(inputValue)) > -1);
        });
        value.forEach(function (singleValue) {
          var key = singleValue;
          var menuItem = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
            role: "option",
            attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: key,
            key: key
          }, key);
          options.push(menuItem);
          menuItems.push(menuItem);
        });

        if (inputValue) {
          var notFindInputItem = menuItems.every(function (option) {
            // this.filterOption return true has two meaning,
            // 1, some one exists after filtering
            // 2, filterOption is set to false
            // condition 2 does not mean the option has same value with inputValue
            var filterFn = function filterFn() {
              return Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(option) === inputValue;
            };

            if (filterOption !== false) {
              return !_this.filterOption.call(_assertThisInitialized(_assertThisInitialized(_this)), inputValue, option, filterFn);
            }

            return !filterFn();
          });

          if (notFindInputItem) {
            options.unshift(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
              style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
              role: "option",
              attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
              value: inputValue,
              key: inputValue
            }, inputValue));
          }
        }
      }

      if (!options.length && notFoundContent) {
        options = [__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], {
          style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
          attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
          disabled: true,
          role: "option",
          value: "NOT_FOUND",
          key: "NOT_FOUND"
        }, notFoundContent)];
      }

      return options;
    };

    _this.renderFilterOptionsFromChildren = function (children, childrenKeys, menuItems) {
      var sel = [];
      var props = _this.props;
      var inputValue = _this.state.inputValue;
      var tags = props.tags;
      __WEBPACK_IMPORTED_MODULE_6_react__["Children"].forEach(children, function (child) {
        if (!child) {
          return;
        }

        var type = child.type;

        if (type.isSelectOptGroup) {
          var label = child.props.label;
          var key = child.key;

          if (!key && typeof label === 'string') {
            key = label;
          } else if (!label && key) {
            label = key;
          } // Match option group label


          if (inputValue && _this.filterOption(inputValue, child)) {
            var innerItems = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(child.props.children).map(function (subChild) {
              var childValueSub = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(subChild) || subChild.key;
              return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], _extends({
                key: childValueSub,
                value: childValueSub
              }, subChild.props));
            });
            sel.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["ItemGroup"], {
              key: key,
              title: label
            }, innerItems)); // Not match
          } else {
            var _innerItems = _this.renderFilterOptionsFromChildren(child.props.children, childrenKeys, menuItems);

            if (_innerItems.length) {
              sel.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["ItemGroup"], {
                key: key,
                title: label
              }, _innerItems));
            }
          }

          return;
        }

        __WEBPACK_IMPORTED_MODULE_9_warning___default()(type.isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + "instead of `".concat(type.name || type.displayName || child.type, "`."));
        var childValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(child);
        Object(__WEBPACK_IMPORTED_MODULE_13__util__["v" /* validateOptionValue */])(childValue, _this.props);

        if (_this.filterOption(inputValue, child)) {
          var menuItem = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["Item"], _extends({
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */],
            attribute: __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: childValue,
            key: childValue,
            role: "option"
          }, child.props));
          sel.push(menuItem);
          menuItems.push(menuItem);
        }

        if (tags) {
          childrenKeys.push(childValue);
        }
      });
      return sel;
    };

    _this.renderTopControlNode = function () {
      var _this$state = _this.state,
          open = _this$state.open,
          inputValue = _this$state.inputValue;
      var value = _this.state.value;
      var props = _this.props;
      var choiceTransitionName = props.choiceTransitionName,
          prefixCls = props.prefixCls,
          maxTagTextLength = props.maxTagTextLength,
          maxTagCount = props.maxTagCount,
          showSearch = props.showSearch,
          removeIcon = props.removeIcon;
      var maxTagPlaceholder = props.maxTagPlaceholder;
      var className = "".concat(prefixCls, "-selection__rendered"); // search input is inside topControlNode in single, multiple & combobox. 2016/04/13

      var innerNode = null;

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(props)) {
        var selectedValue = null;

        if (value.length) {
          var showSelectedValue = false;
          var opacity = 1;

          if (!showSearch) {
            showSelectedValue = true;
          } else if (open) {
            showSelectedValue = !inputValue;

            if (showSelectedValue) {
              opacity = 0.4;
            }
          } else {
            showSelectedValue = true;
          }

          var singleValue = value[0];

          var _this$getOptionInfoBy3 = _this.getOptionInfoBySingleValue(singleValue),
              label = _this$getOptionInfoBy3.label,
              title = _this$getOptionInfoBy3.title;

          selectedValue = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            key: "value",
            className: "".concat(prefixCls, "-selection-selected-value"),
            title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(title || label),
            style: {
              display: showSelectedValue ? 'block' : 'none',
              opacity: opacity
            }
          }, label);
        }

        if (!showSearch) {
          innerNode = [selectedValue];
        } else {
          innerNode = [selectedValue, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
            key: "input",
            style: {
              display: open ? 'block' : 'none'
            }
          }, _this.getInputElement())];
        }
      } else {
        var selectedValueNodes = [];
        var limitedCountValue = value;
        var maxTagPlaceholderEl;

        if (maxTagCount !== undefined && value.length > maxTagCount) {
          limitedCountValue = limitedCountValue.slice(0, maxTagCount);

          var omittedValues = _this.getVLForOnChange(value.slice(maxTagCount, value.length));

          var content = "+ ".concat(value.length - maxTagCount, " ...");

          if (maxTagPlaceholder) {
            content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
          }

          maxTagPlaceholderEl = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", _extends({
            style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
          }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
            role: "presentation",
            onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
            className: "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled"),
            key: "maxTagPlaceholder",
            title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(content)
          }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            className: "".concat(prefixCls, "-selection__choice__content")
          }, content));
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props)) {
          selectedValueNodes = limitedCountValue.map(function (singleValue) {
            var info = _this.getOptionInfoBySingleValue(singleValue);

            var content = info.label;
            var title = info.title || content;

            if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
              content = "".concat(content.slice(0, maxTagTextLength), "...");
            }

            var disabled = _this.isChildDisabled(singleValue);

            var choiceClassName = disabled ? "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled") : "".concat(prefixCls, "-selection__choice");
            return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", _extends({
              style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
            }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
              onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
              className: choiceClassName,
              role: "presentation",
              key: singleValue || SELECT_EMPTY_VALUE_KEY,
              title: Object(__WEBPACK_IMPORTED_MODULE_13__util__["u" /* toTitle */])(title)
            }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
              className: "".concat(prefixCls, "-selection__choice__content")
            }, content), disabled ? null : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
              onClick: function onClick(event) {
                _this.removeSelected(singleValue, event);
              },
              className: "".concat(prefixCls, "-selection__choice__remove")
            }, removeIcon || __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
              className: "".concat(prefixCls, "-selection__choice__remove-icon")
            }, "\xD7")));
          });
        }

        if (maxTagPlaceholderEl) {
          selectedValueNodes.push(maxTagPlaceholderEl);
        }

        selectedValueNodes.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("li", {
          className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
          key: "__input"
        }, _this.getInputElement()));

        if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props) && choiceTransitionName) {
          innerNode = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_animate__["default"], {
            onLeave: _this.onChoiceAnimationLeave,
            component: "ul",
            transitionName: choiceTransitionName
          }, selectedValueNodes);
        } else {
          innerNode = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("ul", null, selectedValueNodes);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: className,
        ref: _this.saveTopCtrlRef
      }, _this.getPlaceholderElement(), innerNode);
    };

    var optionsInfo = Select.getOptionsInfoFromProps(props);
    _this.state = {
      value: Select.getValueFromProps(props, true),
      inputValue: props.combobox ? Select.getInputValueForCombobox(props, optionsInfo, true) : '',
      open: props.defaultOpen,
      optionsInfo: optionsInfo,
      backfillValue: '',
      // a flag for aviod redundant getOptionsInfoFromProps call
      skipBuildOptionsInfo: true,
      ariaId: ''
    };
    _this.saveInputRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'inputRef');
    _this.saveInputMirrorRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'inputMirrorRef');
    _this.saveTopCtrlRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'topCtrlRef');
    _this.saveSelectTriggerRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'selectTriggerRef');
    _this.saveRootRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'rootRef');
    _this.saveSelectionRef = Object(__WEBPACK_IMPORTED_MODULE_13__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'selectionRef');
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }

      this.setState({
        ariaId: Object(__WEBPACK_IMPORTED_MODULE_13__util__["f" /* generateUUID */])()
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(this.props)) {
        var inputNode = this.getInputDOMNode();
        var mirrorNode = this.getInputMirrorDOMNode();

        if (inputNode && inputNode.value && mirrorNode) {
          inputNode.style.width = '';
          inputNode.style.width = "".concat(mirrorNode.clientWidth, "px");
        } else if (inputNode) {
          inputNode.style.width = '';
        }
      }

      this.forcePopupAlign();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearFocusTime();
      this.clearBlurTime();

      if (this.dropdownContainer) {
        __WEBPACK_IMPORTED_MODULE_7_react_dom__["unmountComponentAtNode"](this.dropdownContainer);
        document.body.removeChild(this.dropdownContainer);
        this.dropdownContainer = null;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(this.props) && this.selectionRef) {
        this.selectionRef.focus();
      } else if (this.getInputDOMNode()) {
        this.getInputDOMNode().focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* isSingleMode */])(this.props) && this.selectionRef) {
        this.selectionRef.blur();
      } else if (this.getInputDOMNode()) {
        this.getInputDOMNode().blur();
      }
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(multiple) {
      var _this$props3 = this.props,
          showArrow = _this$props3.showArrow,
          loading = _this$props3.loading,
          inputIcon = _this$props3.inputIcon,
          prefixCls = _this$props3.prefixCls;

      if (!showArrow) {
        return null;
      } // if loading  have loading icon


      if (multiple && !loading) {
        return null;
      }

      var defaultIcon = loading ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow-loading")
      }) : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow-icon")
      });
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", _extends({
        key: "arrow",
        className: "".concat(prefixCls, "-arrow"),
        style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
      }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
        onClick: this.onArrowClick
      }), inputIcon || defaultIcon);
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          allowClear = _this$props4.allowClear,
          clearIcon = _this$props4.clearIcon;
      var inputValue = this.state.inputValue;
      var value = this.state.value;
      var clear = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", _extends({
        key: "clear",
        className: "".concat(prefixCls, "-selection__clear"),
        onMouseDown: __WEBPACK_IMPORTED_MODULE_13__util__["q" /* preventDefaultEvent */],
        style: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* UNSELECTABLE_STYLE */]
      }, __WEBPACK_IMPORTED_MODULE_13__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
        onClick: this.onClearSelection
      }), clearIcon || __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-selection__clear-icon")
      }, "\xD7"));

      if (!allowClear) {
        return null;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(this.props)) {
        if (inputValue) {
          return clear;
        }

        return null;
      }

      if (inputValue || value.length) {
        return clear;
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _rootCls;

      var props = this.props;
      var multiple = Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* isMultipleOrTags */])(props);
      var state = this.state;
      var className = props.className,
          disabled = props.disabled,
          prefixCls = props.prefixCls;
      var ctrlNode = this.renderTopControlNode();
      var _this$state2 = this.state,
          open = _this$state2.open,
          ariaId = _this$state2.ariaId;

      if (open) {
        this._options = this.renderFilterOptions();
      }

      var realOpen = this.getRealOpenState();
      var options = this._options || [];
      var dataOrAriaAttributeProps = {};
      Object.keys(props).forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(props, key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
          dataOrAriaAttributeProps[key] = props[key];
        }
      }); // for (const key in props) {
      //   if (
      //     Object.prototype.hasOwnProperty.call(props, key) &&
      //     (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')
      //   ) {
      //     dataOrAriaAttributeProps[key] = props[key];
      //   }
      // }

      var extraSelectionProps = _extends({}, dataOrAriaAttributeProps);

      if (!Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* isMultipleOrTagsOrCombobox */])(props)) {
        extraSelectionProps = _extends({}, extraSelectionProps, {
          onKeyDown: this.onKeyDown,
          tabIndex: props.disabled ? -1 : props.tabIndex
        });
      }

      var rootCls = (_rootCls = {}, _defineProperty(_rootCls, className, !!className), _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "".concat(prefixCls, "-open"), open), _defineProperty(_rootCls, "".concat(prefixCls, "-focused"), open || !!this._focused), _defineProperty(_rootCls, "".concat(prefixCls, "-combobox"), Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* isCombobox */])(props)), _defineProperty(_rootCls, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-enabled"), !disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-allow-clear"), !!props.allowClear), _defineProperty(_rootCls, "".concat(prefixCls, "-no-arrow"), !props.showArrow), _rootCls);
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SelectTrigger__["a" /* default */], {
        onPopupFocus: this.onPopupFocus,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        dropdownAlign: props.dropdownAlign,
        dropdownClassName: props.dropdownClassName,
        dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
        defaultActiveFirstOption: props.defaultActiveFirstOption,
        dropdownMenuStyle: props.dropdownMenuStyle,
        transitionName: props.transitionName,
        animation: props.animation,
        prefixCls: props.prefixCls,
        dropdownStyle: props.dropdownStyle,
        combobox: props.combobox,
        showSearch: props.showSearch,
        options: options,
        multiple: multiple,
        disabled: disabled,
        visible: realOpen,
        inputValue: state.inputValue,
        value: state.value,
        backfillValue: state.backfillValue,
        firstActiveValue: props.firstActiveValue,
        onDropdownVisibleChange: this.onDropdownVisibleChange,
        getPopupContainer: props.getPopupContainer,
        onMenuSelect: this.onMenuSelect,
        onMenuDeselect: this.onMenuDeselect,
        onPopupScroll: props.onPopupScroll,
        showAction: props.showAction,
        ref: this.saveSelectTriggerRef,
        menuItemSelectedIcon: props.menuItemSelectedIcon,
        dropdownRender: props.dropdownRender,
        ariaId: ariaId
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        id: props.id,
        style: props.style,
        ref: this.saveRootRef,
        onBlur: this.onOuterBlur,
        onFocus: this.onOuterFocus,
        className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(rootCls),
        onMouseDown: this.markMouseDown,
        onMouseUp: this.markMouseLeave,
        onMouseOut: this.markMouseLeave
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", _extends({
        ref: this.saveSelectionRef,
        key: "selection",
        className: "".concat(prefixCls, "-selection\n            ").concat(prefixCls, "-selection--").concat(multiple ? 'multiple' : 'single'),
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-haspopup": "true",
        "aria-controls": ariaId,
        "aria-expanded": realOpen
      }, extraSelectionProps), ctrlNode, this.renderClear(), this.renderArrow(!!multiple))));
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Select.propTypes = __WEBPACK_IMPORTED_MODULE_11__PropTypes__["a" /* default */];
Select.defaultProps = {
  prefixCls: 'rc-select',
  defaultOpen: false,
  labelInValue: false,
  defaultActiveFirstOption: true,
  showSearch: true,
  allowClear: false,
  placeholder: '',
  onChange: noop,
  onFocus: noop,
  onBlur: noop,
  onSelect: noop,
  onSearch: noop,
  onDeselect: noop,
  onInputKeyDown: noop,
  showArrow: true,
  dropdownMatchSelectWidth: true,
  dropdownStyle: {},
  dropdownMenuStyle: {},
  optionFilterProp: 'value',
  optionLabelProp: 'value',
  notFoundContent: 'Not Found',
  backfill: false,
  showAction: ['click'],
  tokenSeparators: [],
  autoClearSearchValue: true,
  tabIndex: 0,
  dropdownRender: function dropdownRender(menu) {
    return menu;
  }
};

Select.getDerivedStateFromProps = function (nextProps, prevState) {
  var optionsInfo = prevState.skipBuildOptionsInfo ? prevState.optionsInfo : Select.getOptionsInfoFromProps(nextProps, prevState);
  var newState = {
    optionsInfo: optionsInfo,
    skipBuildOptionsInfo: false
  };

  if ('open' in nextProps) {
    newState.open = nextProps.open;
  }

  if ('value' in nextProps) {
    var value = Select.getValueFromProps(nextProps);
    newState.value = value;

    if (nextProps.combobox) {
      newState.inputValue = Select.getInputValueForCombobox(nextProps, optionsInfo);
    }
  }

  return newState;
};

Select.getOptionsFromChildren = function (children) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  __WEBPACK_IMPORTED_MODULE_6_react__["Children"].forEach(children, function (child) {
    if (!child) {
      return;
    }

    var type = child.type;

    if (type.isSelectOptGroup) {
      Select.getOptionsFromChildren(child.props.children, options);
    } else {
      options.push(child);
    }
  });
  return options;
};

Select.getInputValueForCombobox = function (props, optionsInfo, useDefaultValue) {
  var value = [];

  if ('value' in props && !useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.value);
  }

  if ('defaultValue' in props && useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.defaultValue);
  }

  if (value.length) {
    value = value[0];
  } else {
    return '';
  }

  var label = value;

  if (props.labelInValue) {
    label = value.label;
  } else if (optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)]) {
    label = optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(value)].label;
  }

  if (label === undefined) {
    label = '';
  }

  return label;
};

Select.getLabelFromOption = function (props, option) {
  return Object(__WEBPACK_IMPORTED_MODULE_13__util__["i" /* getPropValue */])(option, props.optionLabelProp);
};

Select.getOptionsInfoFromProps = function (props, preState) {
  var options = Select.getOptionsFromChildren(props.children);
  var optionsInfo = {};
  options.forEach(function (option) {
    var singleValue = Object(__WEBPACK_IMPORTED_MODULE_13__util__["k" /* getValuePropValue */])(option);
    optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(singleValue)] = {
      option: option,
      value: singleValue,
      label: Select.getLabelFromOption(props, option),
      title: option.props.title
    };
  });

  if (preState) {
    // keep option info in pre state value.
    var oldOptionsInfo = preState.optionsInfo;
    var value = preState.value;

    if (value) {
      value.forEach(function (v) {
        var key = Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* getMapKey */])(v);

        if (!optionsInfo[key] && oldOptionsInfo[key] !== undefined) {
          optionsInfo[key] = oldOptionsInfo[key];
        }
      });
    }
  }

  return optionsInfo;
};

Select.getValueFromProps = function (props, useDefaultValue) {
  var value = [];

  if ('value' in props && !useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.value);
  }

  if ('defaultValue' in props && useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_13__util__["t" /* toArray */])(props.defaultValue);
  }

  if (props.labelInValue) {
    value = value.map(function (v) {
      return v.key;
    });
  }

  return value;
};

Select.displayName = 'Select';
Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(Select);
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(411);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["isCssAnimationSupported"] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["default"])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(152);











var Menu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Menu, _React$Component);

  function Menu(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Menu);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.isRootMenu = true;

    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;
    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }
    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["create"])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: { '0-menu-': Object(__WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["b" /* getActiveKey */])(props, props.activeKey) }
    });
    return _this;
  }

  Menu.prototype.componentDidMount = function componentDidMount() {
    this.updateMiniStore();
  };

  Menu.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateMiniStore();
  };

  // onKeyDown needs to be exposed as a instance method
  // e.g., in rc-select, we need to navigate menu item while
  // current active item is rc-select input box rather than the menu itself


  Menu.prototype.updateMiniStore = function updateMiniStore() {
    if ('selectedKeys' in this.props) {
      this.store.setState({
        selectedKeys: this.props.selectedKeys || []
      });
    }
    if ('openKeys' in this.props) {
      this.store.setState({
        openKeys: this.props.openKeys || []
      });
    }
  };

  Menu.prototype.render = function render() {
    var _this2 = this;

    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    props.className += ' ' + props.prefixCls + '-root';
    props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.onClick,
      onOpenChange: this.onOpenChange,
      onDeselect: this.onDeselect,
      onSelect: this.onSelect,
      openTransitionName: this.getOpenTransitionName(),
      parentMenu: this
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_mini_store__["Provider"],
      { store: this.store },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { ref: function ref(c) {
            return _this2.innerMenu = c;
          } }),
        this.props.children
      )
    );
  };

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Menu.propTypes = {
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  subMenuOpenDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  subMenuCloseDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  forceSubMenuRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  selectable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  itemIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  expandIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  overflowedIndicator: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
};
Menu.defaultProps = {
  selectable: true,
  onClick: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onSelect: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onOpenChange: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  onDeselect: __WEBPACK_IMPORTED_MODULE_9__util__["h" /* noop */],
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {},
  builtinPlacements: {},
  overflowedIndicator: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'span',
    null,
    '\xB7\xB7\xB7'
  )
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSelect = function (selectInfo) {
    var props = _this3.props;
    if (props.selectable) {
      // root menu
      var selectedKeys = _this3.store.getState().selectedKeys;
      var selectedKey = selectInfo.key;
      if (props.multiple) {
        selectedKeys = selectedKeys.concat([selectedKey]);
      } else {
        selectedKeys = [selectedKey];
      }
      if (!('selectedKeys' in props)) {
        _this3.store.setState({
          selectedKeys: selectedKeys
        });
      }
      props.onSelect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
        selectedKeys: selectedKeys
      }));
    }
  };

  this.onClick = function (e) {
    _this3.props.onClick(e);
  };

  this.onKeyDown = function (e, callback) {
    _this3.innerMenu.getWrappedInstance().onKeyDown(e, callback);
  };

  this.onOpenChange = function (event) {
    var props = _this3.props;
    var openKeys = _this3.store.getState().openKeys.concat();
    var changed = false;
    var processSingle = function processSingle(e) {
      var oneChanged = false;
      if (e.open) {
        oneChanged = openKeys.indexOf(e.key) === -1;
        if (oneChanged) {
          openKeys.push(e.key);
        }
      } else {
        var index = openKeys.indexOf(e.key);
        oneChanged = index !== -1;
        if (oneChanged) {
          openKeys.splice(index, 1);
        }
      }
      changed = changed || oneChanged;
    };
    if (Array.isArray(event)) {
      // batch change call
      event.forEach(processSingle);
    } else {
      processSingle(event);
    }
    if (changed) {
      if (!('openKeys' in _this3.props)) {
        _this3.store.setState({ openKeys: openKeys });
      }
      props.onOpenChange(openKeys);
    }
  };

  this.onDeselect = function (selectInfo) {
    var props = _this3.props;
    if (props.selectable) {
      var selectedKeys = _this3.store.getState().selectedKeys.concat();
      var selectedKey = selectInfo.key;
      var index = selectedKeys.indexOf(selectedKey);
      if (index !== -1) {
        selectedKeys.splice(index, 1);
      }
      if (!('selectedKeys' in props)) {
        _this3.store.setState({
          selectedKeys: selectedKeys
        });
      }
      props.onDeselect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
        selectedKeys: selectedKeys
      }));
    }
  };

  this.getOpenTransitionName = function () {
    var props = _this3.props;
    var transitionName = props.openTransitionName;
    var animationName = props.openAnimation;
    if (!transitionName && typeof animationName === 'string') {
      transitionName = props.prefixCls + '-open-' + animationName;
    }
    return transitionName;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(412);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        miniStore: this.props.store
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

Provider.propTypes = {
  store: _PropTypes.storeShape.isRequired
};
Provider.childContextTypes = {
  miniStore: _PropTypes.storeShape.isRequired
};
exports.default = Provider;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connect;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__(132);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _hoistNonReactStatics = __webpack_require__(205);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactLifecyclesCompat = __webpack_require__(49);

var _PropTypes = __webpack_require__(412);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function isStateless(Component) {
  return !Component.prototype.render;
}

var defaultMapStateToProps = function defaultMapStateToProps() {
  return {};
};

function connect(mapStateToProps) {
  var shouldSubscribe = !!mapStateToProps;
  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;

  return function wrapWithConnect(WrappedComponent) {
    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      _createClass(Connect, null, [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, prevState) {
          // using ownProps
          if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
            return {
              subscribed: finnalMapStateToProps(prevState.store.getState(), props),
              props: props
            };
          }
          return { props: props };
        }
      }]);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));

        _this.handleChange = function () {
          if (!_this.unsubscribe) {
            return;
          }
          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
          _this.setState({ subscribed: nextState });
        };

        _this.store = context.miniStore;
        _this.state = {
          subscribed: finnalMapStateToProps(_this.store.getState(), props),
          store: _this.store,
          props: props
        };
        return _this;
      }

      _createClass(Connect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.trySubscribe();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.tryUnsubscribe();
        }
      }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state.subscribed, nextState.subscribed);
        }
      }, {
        key: 'trySubscribe',
        value: function trySubscribe() {
          if (shouldSubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange);
            this.handleChange();
          }
        }
      }, {
        key: 'tryUnsubscribe',
        value: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = _extends({}, this.props, this.state.subscribed, {
            store: this.store
          });

          if (!isStateless(WrappedComponent)) {
            props = _extends({}, props, {
              ref: function ref(c) {
                return _this2.wrappedInstance = c;
              }
            });
          }

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return Connect;
    }(_react.Component);

    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
    Connect.contextTypes = {
      miniStore: _PropTypes.storeShape.isRequired
    };


    (0, _reactLifecyclesCompat.polyfill)(Connect);

    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = create;
function create(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends({}, state, partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);

    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e){var n=/iPhone/i,t=/iPod/i,r=/iPad/i,a=/\bAndroid(?:.+)Mobile\b/i,p=/Android/i,l=/\bAndroid(?:.+)SD4930UR\b/i,b=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,f=/Windows Phone/i,u=/\bWindows(?:.+)ARM\b/i,c=/BlackBerry/i,s=/BB10/i,v=/Opera Mini/i,h=/\b(CriOS|Chrome)(?:.+)Mobile/i,w=/\Mobile(?:.+)Firefox\b/i;function m(e,i){return e.test(i)}function i(e){var i=e||("undefined"!=typeof navigator?navigator.userAgent:""),o=i.split("[FBAN");void 0!==o[1]&&(i=o[0]),void 0!==(o=i.split("Twitter"))[1]&&(i=o[0]);var d={apple:{phone:m(n,i)&&!m(f,i),ipod:m(t,i),tablet:!m(n,i)&&m(r,i)&&!m(f,i),device:(m(n,i)||m(t,i)||m(r,i))&&!m(f,i)},amazon:{phone:m(l,i),tablet:!m(l,i)&&m(b,i),device:m(l,i)||m(b,i)},android:{phone:!m(f,i)&&m(l,i)||!m(f,i)&&m(a,i),tablet:!m(f,i)&&!m(l,i)&&!m(a,i)&&(m(b,i)||m(p,i)),device:!m(f,i)&&(m(l,i)||m(b,i)||m(a,i)||m(p,i))},windows:{phone:m(f,i),tablet:m(u,i),device:m(f,i)||m(u,i)},other:{blackberry:m(c,i),blackberry10:m(s,i),opera:m(v,i),firefox:m(w,i),chrome:m(h,i),device:m(c,i)||m(s,i)||m(v,i)||m(w,i)||m(h,i)}};return d.any=d.apple.device||d.android.device||d.windows.device||d.other.device,d.phone=d.apple.phone||d.android.phone||d.windows.phone,d.tablet=d.apple.tablet||d.android.tablet||d.windows.tablet,d}"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=i:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=i(): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e.isMobile=i()),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):e.isMobile=i()}(this);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_resize_observer_polyfill__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubMenu__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(152);












var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
var FLOAT_PRECISION_ADJUST = 0.5;

// Fix ssr
if (canUseDOM) {
  __webpack_require__(894);
}

var DOMWrap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DOMWrap, _React$Component);

  function DOMWrap() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DOMWrap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      lastVisibleIndex: undefined
    }, _this.getMenuItemNodes = function () {
      var prefixCls = _this.props.prefixCls;

      var ul = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);
      if (!ul) {
        return [];
      }

      // filter out all overflowed indicator placeholder
      return [].slice.call(ul.children).filter(function (node) {
        return node.className.split(' ').indexOf(prefixCls + '-overflowed-submenu') < 0;
      });
    }, _this.getOverflowedSubMenuItem = function (keyPrefix, overflowedItems, renderPlaceholder) {
      var _this$props = _this.props,
          overflowedIndicator = _this$props.overflowedIndicator,
          level = _this$props.level,
          mode = _this$props.mode,
          prefixCls = _this$props.prefixCls,
          theme = _this$props.theme,
          propStyle = _this$props.style;

      if (level !== 1 || mode !== 'horizontal') {
        return null;
      }
      // put all the overflowed item inside a submenu
      // with a title of overflow indicator ('...')
      var copy = _this.props.children[0];

      var _copy$props = copy.props,
          throwAway = _copy$props.children,
          title = _copy$props.title,
          eventKey = _copy$props.eventKey,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_copy$props, ['children', 'title', 'eventKey']);

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, propStyle);
      var key = keyPrefix + '-overflowed-indicator';

      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
          display: 'none'
        });
      } else if (renderPlaceholder) {
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
          visibility: 'hidden',
          // prevent from taking normal dom space
          position: 'absolute'
        });
        key = key + '-placeholder';
      }

      var popupClassName = theme ? prefixCls + '-' + theme : '';
      var props = {};
      __WEBPACK_IMPORTED_MODULE_10__util__["g" /* menuAllProps */].forEach(function (k) {
        if (rest[k] !== undefined) {
          props[k] = rest[k];
        }
      });

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__SubMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: overflowedIndicator,
          className: prefixCls + '-overflowed-submenu',
          popupClassName: popupClassName
        }, props, {
          key: key,
          eventKey: keyPrefix + '-overflowed-indicator',
          disabled: false,
          style: style
        }),
        overflowedItems
      );
    }, _this.setChildrenWidthAndResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }
      var ul = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

      if (!ul) {
        return;
      }

      var ulChildrenNodes = ul.children;

      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
        return;
      }

      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1];

      // need last overflowed indicator for calculating length;
      Object(__WEBPACK_IMPORTED_MODULE_10__util__["i" /* setStyle */])(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');

      var menuItemNodes = _this.getMenuItemNodes();

      // reset display attribute for all hidden elements caused by overflow to calculate updated width
      // and then reset to original state after width calculation

      var overflowedItems = menuItemNodes.filter(function (c) {
        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
      });

      overflowedItems.forEach(function (c) {
        Object(__WEBPACK_IMPORTED_MODULE_10__util__["i" /* setStyle */])(c, 'display', 'inline-block');
      });

      _this.menuItemSizes = menuItemNodes.map(function (c) {
        return Object(__WEBPACK_IMPORTED_MODULE_10__util__["c" /* getWidth */])(c);
      });

      overflowedItems.forEach(function (c) {
        Object(__WEBPACK_IMPORTED_MODULE_10__util__["i" /* setStyle */])(c, 'display', 'none');
      });
      _this.overflowedIndicatorWidth = Object(__WEBPACK_IMPORTED_MODULE_10__util__["c" /* getWidth */])(ul.children[ul.children.length - 1]);
      _this.originalTotalWidth = _this.menuItemSizes.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      _this.handleResize();
      // prevent the overflowed indicator from taking space;
      Object(__WEBPACK_IMPORTED_MODULE_10__util__["i" /* setStyle */])(lastOverflowedIndicatorPlaceholder, 'display', 'none');
    }, _this.resizeObserver = null, _this.mutationObserver = null, _this.originalTotalWidth = 0, _this.overflowedItems = [], _this.menuItemSizes = [], _this.handleResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);
      if (!ul) {
        return;
      }
      var width = Object(__WEBPACK_IMPORTED_MODULE_10__util__["c" /* getWidth */])(ul);

      _this.overflowedItems = [];
      var currentSumWidth = 0;

      // index for last visible child in horizontal mode
      var lastVisibleIndex = undefined;

      // float number comparison could be problematic
      // e.g. 0.1 + 0.2 > 0.3 =====> true
      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation
      if (_this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
        lastVisibleIndex = -1;

        _this.menuItemSizes.forEach(function (liWidth) {
          currentSumWidth += liWidth;
          if (currentSumWidth + _this.overflowedIndicatorWidth <= width) {
            lastVisibleIndex++;
          }
        });
      }

      _this.setState({ lastVisibleIndex: lastVisibleIndex });
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  DOMWrap.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.setChildrenWidthAndResize();
    if (this.props.level === 1 && this.props.mode === 'horizontal') {
      var menuUl = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
      if (!menuUl) {
        return;
      }
      this.resizeObserver = new __WEBPACK_IMPORTED_MODULE_8_resize_observer_polyfill__["default"](function (entries) {
        entries.forEach(_this2.setChildrenWidthAndResize);
      });

      [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
        _this2.resizeObserver.observe(el);
      });

      if (typeof MutationObserver !== 'undefined') {
        this.mutationObserver = new MutationObserver(function () {
          _this2.resizeObserver.disconnect();
          [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
            _this2.resizeObserver.observe(el);
          });
          _this2.setChildrenWidthAndResize();
        });
        this.mutationObserver.observe(menuUl, { attributes: false, childList: true, subTree: false });
      }
    }
  };

  DOMWrap.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.mutationObserver) {
      this.resizeObserver.disconnect();
    }
  };

  // get all valid menuItem nodes


  // memorize rendered menuSize


  // original scroll size of the list


  // copy of overflowed items


  // cache item of the original items (so we can track the size and order)


  DOMWrap.prototype.renderChildren = function renderChildren(children) {
    var _this3 = this;

    // need to take care of overflowed items in horizontal mode
    var lastVisibleIndex = this.state.lastVisibleIndex;

    return (children || []).reduce(function (acc, childNode, index) {
      var item = childNode;
      if (_this3.props.mode === 'horizontal') {
        var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);
        if (lastVisibleIndex !== undefined && _this3.props.className.indexOf(_this3.props.prefixCls + '-root') !== -1) {
          if (index > lastVisibleIndex) {
            item = __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(childNode,
            // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
            {
              style: { display: 'none' },
              eventKey: childNode.props.eventKey + '-hidden',
              className: childNode.className + ' ' + MENUITEM_OVERFLOWED_CLASSNAME
            });
          }
          if (index === lastVisibleIndex + 1) {
            _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(c,
              // children[index].key will become '.$key' in clone by default,
              // we have to overwrite with the correct key explicitly
              { key: c.props.eventKey, mode: 'vertical-left' });
            });

            overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
          }
        }

        var ret = [].concat(acc, [overflowed, item]);

        if (index === children.length - 1) {
          // need a placeholder for calculating overflowed indicator width
          ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
        }
        return ret;
      }
      return [].concat(acc, [item]);
    }, []);
  };

  DOMWrap.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        overflowedIndicator = _props.overflowedIndicator,
        mode = _props.mode,
        level = _props.level,
        Tag = _props.tag,
        children = _props.children,
        theme = _props.theme,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible', 'prefixCls', 'overflowedIndicator', 'mode', 'level', 'tag', 'children', 'theme']);

    if (!visible) {
      rest.className += ' ' + hiddenClassName;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      Tag,
      rest,
      this.renderChildren(this.props.children)
    );
  };

  return DOMWrap;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DOMWrap.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  mode: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  level: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  theme: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  overflowedIndicator: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  visible: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};

/* harmony default export */ __webpack_exports__["a"] = (DOMWrap);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(421);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(882);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_align__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(891);











function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Align.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    // if parent ref not attached .... use document.getElementById
    this.forceAlign();
    if (!props.disabled && props.monitorWindowResize) {
      this.startMonitorWindowResize();
    }
  };

  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var reAlign = false;
    var props = this.props;

    if (!props.disabled) {
      var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var sourceRect = source ? source.getBoundingClientRect() : null;

      if (prevProps.disabled) {
        reAlign = true;
      } else {
        var lastElement = getElement(prevProps.target);
        var currentElement = getElement(props.target);
        var lastPoint = getPoint(prevProps.target);
        var currentPoint = getPoint(props.target);

        if (Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(currentElement)) {
          // Skip if is window
          reAlign = false;
        } else if (lastElement !== currentElement || // Element change
        lastElement && !currentElement && currentPoint || // Change from element to point
        lastPoint && currentPoint && currentElement || // Change from point to element
        currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_8__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
          reAlign = true;
        }

        // If source element size changed
        var preRect = this.sourceRect || {};
        if (!reAlign && source && (preRect.width !== sourceRect.width || preRect.height !== sourceRect.height)) {
          reAlign = true;
        }
      }

      this.sourceRect = sourceRect;
    }

    if (reAlign) {
      this.forceAlign();
    }

    if (props.monitorWindowResize && !props.disabled) {
      this.startMonitorWindowResize();
    } else {
      this.stopMonitorWindowResize();
    }
  };

  Align.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopMonitorWindowResize();
  };

  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
    if (!this.resizeHandler) {
      this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
      this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
    }
  };

  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
    if (this.resizeHandler) {
      this.bufferMonitor.clear();
      this.resizeHandler.remove();
      this.resizeHandler = null;
    }
  };

  Align.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        childrenProps = _props.childrenProps,
        children = _props.children;

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    if (childrenProps) {
      var newProps = {};
      var propList = Object.keys(childrenProps);
      propList.forEach(function (prop) {
        newProps[prop] = _this2.props[childrenProps[prop]];
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, newProps);
    }
    return child;
  };

  return Align;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align_alignElement__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__ = __webpack_require__(890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__["a"]; });





/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a" /* default */]);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(425);





function isOutOfVisibleRect(target) {
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(target);
  var targetRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);

  return Object(__WEBPACK_IMPORTED_MODULE_0__align__["a" /* default */])(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */];

alignElement.__getVisibleRectForElement = __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (alignElement);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransformName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransformXY;
/* harmony export (immutable) */ __webpack_exports__["d"] = setTransformXY;
var vendorPrefix = void 0;

var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
}

function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}

function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
  }
  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr = void 0;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, 'matrix(' + arr.join(',') + ')');
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
    }
  } else {
    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
  }
}

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAncestorFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);


function isAncestorFixed(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);


function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(pos, size);
}

/* harmony default export */ __webpack_exports__["a"] = (adjustForViewport);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignOffset__ = __webpack_require__(889);


function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(refNodeRegion, points[1]);
  var p2 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];

  return {
    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getElFuturePos);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;

  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getAlignOffset);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align__ = __webpack_require__(422);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX = void 0;
  var pageY = void 0;

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(el);
  var win = doc.defaultView || doc.parentWindow;

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };

  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];

  return Object(__WEBPACK_IMPORTED_MODULE_1__align__["a" /* default */])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
}

/* harmony default export */ __webpack_exports__["a"] = (alignPoint);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["c"] = isWindow;
function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(426);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// mutationobserver-shim v0.3.2 (github.com/megawac/MutationObserver.js)
// Authors: Graeme Yeates (github.com/megawac) 
window.MutationObserver=window.MutationObserver||function(w){function v(a){this.i=[];this.m=a}function I(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,v._period)})()}function p(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==w&&a[c]!==w&&(b[c]=a[c]);return b}function J(a,b){var c=C(a,b);return function(d){var f=d.length,n;b.a&&3===a.nodeType&&
a.nodeValue!==c.a&&d.push(new p({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&A(d,a,c.b,b.f);if(b.c||b.g)n=K(d,a,c,b);if(n||d.length!==f)c=C(a,b)}}function L(a,b){return b.value}function M(a,b){return"style"!==b.name?b.value:a.style.cssText}function A(a,b,c,d){for(var f={},n=b.attributes,k,g,x=n.length;x--;)k=n[x],g=k.name,d&&d[g]===w||(D(b,k)!==c[g]&&a.push(p({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(p({target:b,
type:"attributes",attributeName:g,oldValue:c[g]}))}function K(a,b,c,d){function f(b,c,f,k,y){var g=b.length-1;y=-~((g-y)/2);for(var h,l,e;e=b.pop();)h=f[e.j],l=k[e.l],d.c&&y&&Math.abs(e.j-e.l)>=g&&(a.push(p({type:"childList",target:c,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),y--),d.b&&l.b&&A(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(p({type:"characterData",target:h,oldValue:l.a})),d.g&&n(h,l)}function n(b,c){for(var g=b.childNodes,
q=c.c,x=g.length,v=q?q.length:0,h,l,e,m,t,z=0,u=0,r=0;u<x||r<v;)m=g[u],t=(e=q[r])&&e.node,m===t?(d.b&&e.b&&A(a,m,e.b,d.f),d.a&&e.a!==w&&m.nodeValue!==e.a&&a.push(p({type:"characterData",target:m,oldValue:e.a})),l&&f(l,b,g,q,z),d.g&&(m.childNodes.length||e.c&&e.c.length)&&n(m,e),u++,r++):(k=!0,h||(h={},l=[]),m&&(h[e=E(m)]||(h[e]=!0,-1===(e=F(q,m,r,"node"))?d.c&&(a.push(p({type:"childList",target:b,addedNodes:[m],nextSibling:m.nextSibling,previousSibling:m.previousSibling})),z++):l.push({j:u,l:e})),
u++),t&&t!==g[u]&&(h[e=E(t)]||(h[e]=!0,-1===(e=F(g,t,u))?d.c&&(a.push(p({type:"childList",target:c.node,removedNodes:[t],nextSibling:q[r+1],previousSibling:q[r-1]})),z--):l.push({j:e,l:r})),r++));l&&f(l,b,g,q,z)}var k;n(b,c);return k}function C(a,b){var c=!0;return function f(a){var k={node:a};!b.a||3!==a.nodeType&&8!==a.nodeType?(b.b&&c&&1===a.nodeType&&(k.b=G(a.attributes,function(c,f){if(!b.f||b.f[f.name])c[f.name]=D(a,f);return c})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=N(a.childNodes,f)),c=b.g):k.a=
a.nodeValue;return k}(a)}function E(a){try{return a.id||(a.mo_id=a.mo_id||H++)}catch(b){try{return a.nodeValue}catch(c){return H++}}}function N(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function G(a,b){for(var c={},d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function F(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}v._period=30;v.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,
a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=G(b.attributeFilter,function(a,b){a[b]=!0;return a}));d.push({s:a,o:J(a,c)});this.h||I(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var B=document.createElement("i");B.style.top=0;var D=(B="null"!=B.attributes.style.value)?L:M,H=1;return v}(void 0);


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(152);













/* eslint react/no-is-mounted:0 */

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onClick(e);
        return true;
      }
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;

      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;

      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;

      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: _this,
        domEvent: e
      };
      onClick(info);
      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    return _this;
  }

  MenuItem.prototype.componentDidMount = function componentDidMount() {
    // invoke customized ref to expose component to mixin
    this.callRef();
  };

  MenuItem.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.active) {
      __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default()(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this), __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.props.parentMenu), {
        onlyScrollIfNeeded: true
      });
    }
    this.callRef();
  };

  MenuItem.prototype.componentWillUnmount = function componentWillUnmount() {
    var props = this.props;
    if (props.onDestroy) {
      props.onDestroy(props.eventKey);
    }
  };

  MenuItem.prototype.getPrefixCls = function getPrefixCls() {
    return this.props.rootPrefixCls + '-item';
  };

  MenuItem.prototype.getActiveClassName = function getActiveClassName() {
    return this.getPrefixCls() + '-active';
  };

  MenuItem.prototype.getSelectedClassName = function getSelectedClassName() {
    return this.getPrefixCls() + '-selected';
  };

  MenuItem.prototype.getDisabledClassName = function getDisabledClassName() {
    return this.getPrefixCls() + '-disabled';
  };

  MenuItem.prototype.callRef = function callRef() {
    if (this.props.manualRef) {
      this.props.manualRef(this);
    }
  };

  MenuItem.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
    var className = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(this.getPrefixCls(), props.className, (_classNames = {}, _classNames[this.getActiveClassName()] = !props.disabled && props.active, _classNames[this.getSelectedClassName()] = props.isSelected, _classNames[this.getDisabledClassName()] = props.disabled, _classNames));
    var attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.attribute, {
      title: props.title,
      className: className,
      // set to menuitem by default
      role: props.role || 'menuitem',
      'aria-disabled': props.disabled
    });

    if (props.role === 'option') {
      // overwrite to option
      attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, attrs, {
        role: 'option',
        'aria-selected': props.isSelected
      });
    } else if (props.role === null || props.role === 'none') {
      // sometimes we want to specify role inside <li/> element
      // <li><a role='menuitem'>Link</a></li> would be a good example
      // in this case the role on <li/> should be "none" to
      // remove the implied listitem role.
      // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
      attrs.role = 'none';
    }
    // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner
    var mouseEvent = {
      onClick: props.disabled ? null : this.onClick,
      onMouseLeave: props.disabled ? null : this.onMouseLeave,
      onMouseEnter: props.disabled ? null : this.onMouseEnter
    };
    var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style);
    if (props.mode === 'inline') {
      style.paddingLeft = props.inlineIndent * props.level;
    }
    __WEBPACK_IMPORTED_MODULE_11__util__["g" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });
    var icon = this.props.itemIcon;
    if (typeof this.props.itemIcon === 'function') {
      icon = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(this.props.itemIcon, this.props);
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, attrs, mouseEvent, {
        style: style
      }),
      props.children,
      icon
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MenuItem.propTypes = {
  attribute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  isSelected: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  itemIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node])
};
MenuItem.defaultProps = {
  onSelect: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */]
};
MenuItem.isMenuItem = true;

var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem);

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(897);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(152);









var MenuItemGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItemGroup, _React$Component);

  function MenuItemGroup() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItemGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;

      return renderMenuItem(item, index, _this.props.subMenuKey);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  MenuItemGroup.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        rootPrefixCls = props.rootPrefixCls;

    var titleClassName = rootPrefixCls + '-item-group-title';
    var listClassName = rootPrefixCls + '-item-group-list';
    var title = props.title,
        children = props.children;

    __WEBPACK_IMPORTED_MODULE_7__util__["g" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });

    // Set onClick to null, to ignore propagated onClick event
    delete props.onClick;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: className + ' ' + rootPrefixCls + '-item-group' }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: titleClassName,
          title: typeof title === 'string' ? title : undefined
        },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'ul',
        { className: listClassName },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(children, this.renderInnerMenuItem)
      )
    );
  };

  return MenuItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MenuItemGroup.propTypes = {
  renderMenuItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  subMenuKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
MenuItemGroup.defaultProps = {
  disabled: true
};


MenuItemGroup.isMenuItemGroup = true;

/* harmony default export */ __webpack_exports__["a"] = (MenuItemGroup);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Divider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Divider, _React$Component);

  function Divider() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Divider);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Divider.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        rootPrefixCls = _props.rootPrefixCls,
        style = _props.style;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li', {
      className: className + ' ' + rootPrefixCls + '-item-divider',
      style: style
    });
  };

  return Divider;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Divider.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true,
  className: '',
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectTrigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_trigger__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownMenu__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(295);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};








__WEBPACK_IMPORTED_MODULE_2_rc_trigger__["default"].displayName = 'Trigger';
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};

var SelectTrigger =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectTrigger, _React$Component);

  function SelectTrigger(props) {
    var _this;

    _classCallCheck(this, SelectTrigger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectTrigger).call(this, props));
    _this.dropdownMenuRef = null;

    _this.setDropdownWidth = function () {
      var dom = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](_assertThisInitialized(_assertThisInitialized(_this)));
      var width = dom.offsetWidth;

      if (width !== _this.state.dropdownWidth) {
        _this.setState({
          dropdownWidth: width
        });
      }
    };

    _this.getInnerMenu = function () {
      return _this.dropdownMenuRef && _this.dropdownMenuRef.menuRef;
    };

    _this.getPopupDOMNode = function () {
      return _this.triggerRef.getPopupDomNode();
    };

    _this.getDropdownElement = function (newProps) {
      var props = _this.props;
      var dropdownRender = props.dropdownRender,
          ariaId = props.ariaId;
      var menuNode = __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DropdownMenu__["a" /* default */], _extends({
        ref: _this.saveDropdownMenuRef
      }, newProps, {
        ariaId: ariaId,
        prefixCls: _this.getDropdownPrefixCls(),
        onMenuSelect: props.onMenuSelect,
        onMenuDeselect: props.onMenuDeselect,
        onPopupScroll: props.onPopupScroll,
        value: props.value,
        backfillValue: props.backfillValue,
        firstActiveValue: props.firstActiveValue,
        defaultActiveFirstOption: props.defaultActiveFirstOption,
        dropdownMenuStyle: props.dropdownMenuStyle,
        menuItemSelectedIcon: props.menuItemSelectedIcon
      }));

      if (dropdownRender) {
        return dropdownRender(menuNode, props);
      }

      return null;
    };

    _this.getDropdownTransitionName = function () {
      var props = _this.props;
      var transitionName = props.transitionName;

      if (!transitionName && props.animation) {
        transitionName = "".concat(_this.getDropdownPrefixCls(), "-").concat(props.animation);
      }

      return transitionName;
    };

    _this.getDropdownPrefixCls = function () {
      return "".concat(_this.props.prefixCls, "-dropdown");
    };

    _this.saveDropdownMenuRef = Object(__WEBPACK_IMPORTED_MODULE_6__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'dropdownMenuRef');
    _this.saveTriggerRef = Object(__WEBPACK_IMPORTED_MODULE_6__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'triggerRef');
    _this.state = {
      dropdownWidth: 0
    };
    return _this;
  }

  _createClass(SelectTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setDropdownWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setDropdownWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _popupClassName;

      var _a = this.props,
          onPopupFocus = _a.onPopupFocus,
          props = __rest(_a, ["onPopupFocus"]);

      var multiple = props.multiple,
          visible = props.visible,
          inputValue = props.inputValue,
          dropdownAlign = props.dropdownAlign,
          disabled = props.disabled,
          showSearch = props.showSearch,
          dropdownClassName = props.dropdownClassName,
          dropdownStyle = props.dropdownStyle,
          dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;
      var dropdownPrefixCls = this.getDropdownPrefixCls();
      var popupClassName = (_popupClassName = {}, _defineProperty(_popupClassName, dropdownClassName, !!dropdownClassName), _defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--").concat(multiple ? 'multiple' : 'single'), 1), _popupClassName);
      var popupElement = this.getDropdownElement({
        menuItems: props.options,
        onPopupFocus: onPopupFocus,
        multiple: multiple,
        inputValue: inputValue,
        visible: visible
      });
      var hideAction;

      if (disabled) {
        hideAction = [];
      } else if (Object(__WEBPACK_IMPORTED_MODULE_6__util__["p" /* isSingleMode */])(props) && !showSearch) {
        hideAction = ['click'];
      } else {
        hideAction = ['blur'];
      }

      var popupStyle = _extends({}, dropdownStyle);

      var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';

      if (this.state.dropdownWidth) {
        popupStyle[widthProp] = "".concat(this.state.dropdownWidth, "px");
      }

      return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_trigger__["default"], _extends({}, props, {
        showAction: disabled ? [] : this.props.showAction,
        hideAction: hideAction,
        ref: this.saveTriggerRef,
        popupPlacement: "bottomLeft",
        builtinPlacements: BUILT_IN_PLACEMENTS,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: this.getDropdownTransitionName(),
        onPopupVisibleChange: props.onDropdownVisibleChange,
        popup: popupElement,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: props.getPopupContainer,
        popupClassName: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(popupClassName),
        popupStyle: popupStyle
      }), props.children);
    }
  }]);

  return SelectTrigger;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);


SelectTrigger.defaultProps = {
  dropdownRender: function dropdownRender(menu) {
    return menu;
  }
};
SelectTrigger.propTypes = {
  onPopupFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  dropdownMatchSelectWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  dropdownAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  showSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  dropdownClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  inputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  filterOption: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  popupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  showAction: __WEBPACK_IMPORTED_MODULE_1_prop_types__["arrayOf"](__WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]),
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["node"]]),
  dropdownRender: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  ariaId: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]
};
SelectTrigger.displayName = 'SelectTrigger';

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_menu__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(295);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }










var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _classCallCheck(this, DropdownMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownMenu).call(this, props));
    _this.rafInstance = {
      cancel: function cancel() {
        return null;
      }
    };
    _this.lastVisible = false;

    _this.scrollActiveItemToView = function () {
      // scroll into view
      var itemComponent = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this.firstActiveItem);
      var _this$props = _this.props,
          visible = _this$props.visible,
          firstActiveValue = _this$props.firstActiveValue;
      var value = _this.props.value;

      if (!itemComponent || !visible) {
        return;
      }

      var scrollIntoViewOpts = {
        onlyScrollIfNeeded: true
      };

      if ((!value || value.length === 0) && firstActiveValue) {
        scrollIntoViewOpts.alignWithTop = true;
      } // Delay to scroll since current frame item position is not ready when pre view is by filter
      // https://github.com/ant-design/ant-design/issues/11268#issuecomment-406634462


      _this.rafInstance = __WEBPACK_IMPORTED_MODULE_2_raf___default()(function () {
        __WEBPACK_IMPORTED_MODULE_0_dom_scroll_into_view___default()(itemComponent, Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this.menuRef), scrollIntoViewOpts);
      });
    };

    _this.renderMenu = function () {
      var _this$props2 = _this.props,
          menuItems = _this$props2.menuItems,
          menuItemSelectedIcon = _this$props2.menuItemSelectedIcon,
          defaultActiveFirstOption = _this$props2.defaultActiveFirstOption,
          prefixCls = _this$props2.prefixCls,
          multiple = _this$props2.multiple,
          onMenuSelect = _this$props2.onMenuSelect,
          inputValue = _this$props2.inputValue,
          backfillValue = _this$props2.backfillValue,
          onMenuDeselect = _this$props2.onMenuDeselect,
          visible = _this$props2.visible;
      var firstActiveValue = _this.props.firstActiveValue;

      if (menuItems && menuItems.length) {
        var menuProps = {};

        if (multiple) {
          menuProps.onDeselect = onMenuDeselect;
          menuProps.onSelect = onMenuSelect;
        } else {
          menuProps.onClick = onMenuSelect;
        }

        var value = _this.props.value;
        var selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_7__util__["j" /* getSelectKeys */])(menuItems, value);
        var activeKeyProps = {};
        var clonedMenuItems = menuItems;

        if (selectedKeys.length || firstActiveValue) {
          if (visible && !_this.lastVisible) {
            activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
          } else if (!visible) {
            activeKeyProps.activeKey = undefined;
          }

          var foundFirst = false; // set firstActiveItem via cloning menus
          // for scroll into view

          var clone = function clone(item) {
            var key = item.key;

            if (!foundFirst && selectedKeys.indexOf(key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
              foundFirst = true;
              return __WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](item, {
                ref: function ref(_ref) {
                  _this.firstActiveItem = _ref;
                }
              });
            }

            return item;
          };

          clonedMenuItems = menuItems.map(function (item) {
            if (item.type.isMenuItemGroup) {
              var children = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Children_toArray__["a" /* default */])(item.props.children).map(clone);
              return __WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](item, {}, children);
            }

            return clone(item);
          });
        } else {
          // Clear firstActiveItem when dropdown menu items was empty
          // Avoid `Unable to find node on an unmounted component`
          // https://github.com/ant-design/ant-design/issues/10774
          _this.firstActiveItem = null;
        } // clear activeKey when inputValue change


        var lastValue = value && value[value.length - 1];

        if (inputValue !== _this.lastInputValue && (!lastValue || lastValue !== backfillValue)) {
          activeKeyProps.activeKey = '';
        }

        return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_menu__["default"], _extends({
          ref: _this.saveMenuRef,
          style: _this.props.dropdownMenuStyle,
          defaultActiveFirst: defaultActiveFirstOption,
          role: "listbox",
          itemIcon: multiple ? menuItemSelectedIcon : null
        }, activeKeyProps, {
          multiple: multiple
        }, menuProps, {
          selectedKeys: selectedKeys,
          prefixCls: "".concat(prefixCls, "-menu")
        }), clonedMenuItems);
      }

      return null;
    };

    _this.lastInputValue = props.inputValue;
    _this.saveMenuRef = Object(__WEBPACK_IMPORTED_MODULE_7__util__["r" /* saveRef */])(_assertThisInitialized(_assertThisInitialized(_this)), 'menuRef');
    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollActiveItemToView();
      this.lastVisible = this.props.visible;
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (!nextProps.visible) {
        this.lastVisible = false;
      } // freeze when hide


      return this.props.visible && !nextProps.visible || nextProps.visible || nextProps.inputValue !== this.props.inputValue;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;

      if (!prevProps.visible && props.visible) {
        this.scrollActiveItemToView();
      }

      this.lastVisible = props.visible;
      this.lastInputValue = props.inputValue;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.rafInstance && this.rafInstance.cancel) {
        this.rafInstance.cancel();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var renderMenu = this.renderMenu();
      return renderMenu ? __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
        style: {
          overflow: 'auto',
          transform: 'translateZ(0)'
        },
        id: this.props.ariaId,
        onFocus: this.props.onPopupFocus,
        onMouseDown: __WEBPACK_IMPORTED_MODULE_7__util__["q" /* preventDefaultEvent */],
        onScroll: this.props.onPopupScroll
      }, renderMenu) : null;
    }
  }]);

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.propTypes = {
  ariaId: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  defaultActiveFirstOption: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  dropdownMenuStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  onPopupFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onMenuDeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  onMenuSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  menuItems: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
  inputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
  firstActiveValue: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  menuItemSelectedIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["node"]])
};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Group = function Group(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
    return React.createElement("span", {
      className: cls,
      style: props.style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }, props.children);
  });
};

var _default = Group;
exports["default"] = _default;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _Input = _interopRequireDefault(__webpack_require__(297));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _button = _interopRequireDefault(__webpack_require__(7));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Search =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search() {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).apply(this, arguments));

    _this.onSearch = function (e) {
      var onSearch = _this.props.onSearch;

      if (onSearch) {
        onSearch(_this.input.input.value, e);
      }

      _this.input.focus();
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.renderSearch = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeInputPrefixCls = _a.inputPrefixCls,
          className = _a.className,
          size = _a.size,
          suffix = _a.suffix,
          enterButton = _a.enterButton,
          others = __rest(_a, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton"]);

      delete others.onSearch;
      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);

      var buttonOrIcon = _this.getButtonOrIcon(prefixCls);

      var searchSuffix = suffix ? [suffix, buttonOrIcon] : buttonOrIcon;

      if (Array.isArray(searchSuffix)) {
        searchSuffix = searchSuffix.map(function (item, index) {
          if (!React.isValidElement(item) || item.key) {
            return item;
          }

          return React.cloneElement(item, {
            key: index
          });
        });
      }

      var inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
      return React.createElement(_Input["default"], _extends({
        onPressEnter: _this.onSearch
      }, others, {
        size: size,
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: searchSuffix,
        ref: _this.saveInput
      }));
    };

    return _this;
  }

  _createClass(Search, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "getButtonOrIcon",
    value: function getButtonOrIcon(prefixCls) {
      var _this$props = this.props,
          enterButton = _this$props.enterButton,
          size = _this$props.size,
          disabled = _this$props.disabled;
      var enterButtonAsElement = enterButton;
      var node;

      if (!enterButton) {
        node = React.createElement(_icon["default"], {
          className: "".concat(prefixCls, "-icon"),
          type: "search",
          key: "searchIcon"
        });
      } else if (enterButtonAsElement.type === _button["default"] || enterButtonAsElement.type === 'button') {
        node = React.cloneElement(enterButtonAsElement, enterButtonAsElement.type === _button["default"] ? {
          className: "".concat(prefixCls, "-button"),
          size: size
        } : {});
      } else {
        node = React.createElement(_button["default"], {
          className: "".concat(prefixCls, "-button"),
          type: "primary",
          size: size,
          disabled: disabled,
          key: "enterButton"
        }, enterButton === true ? React.createElement(_icon["default"], {
          type: "search"
        }) : enterButton);
      }

      return React.cloneElement(node, {
        onClick: this.onSearch
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch);
    }
  }]);

  return Search;
}(React.Component);

exports["default"] = Search;
Search.defaultProps = {
  enterButton: false
};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _reactLifecyclesCompat = __webpack_require__(49);

var _omit = _interopRequireDefault(__webpack_require__(86));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

var _wave = _interopRequireDefault(__webpack_require__(298));

var _type = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);

function isString(str) {
  return typeof str === 'string';
} // Insert one space between two chinese characters automatically.


function insertSpace(child, needInserted) {
  // Check the child if is undefined or null.
  if (child == null) {
    return;
  }

  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.

  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
  }

  if (typeof child === 'string') {
    if (isTwoCNChar(child)) {
      child = child.split('').join(SPACE);
    }

    return React.createElement("span", null, child);
  }

  return child;
}

var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger');
var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline');
var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');

var Button =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this, props));

    _this.saveButtonRef = function (node) {
      _this.buttonNode = node;
    };

    _this.handleClick = function (e) {
      var loading = _this.state.loading;
      var onClick = _this.props.onClick;

      if (!!loading) {
        return;
      }

      if (onClick) {
        onClick(e);
      }
    };

    _this.renderButton = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          shape = _a.shape,
          size = _a.size,
          className = _a.className,
          children = _a.children,
          icon = _a.icon,
          ghost = _a.ghost,
          _loadingProp = _a.loading,
          block = _a.block,
          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "loading", "block"]);

      var _this$state = _this.state,
          loading = _this$state.loading,
          hasTwoCNChar = _this$state.hasTwoCNChar;
      var prefixCls = getPrefixCls('btn', customizePrefixCls); // large => lg
      // small => sm

      var sizeCls = '';

      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;

        case 'small':
          sizeCls = 'sm';

        default:
          break;
      }

      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && icon), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
      var iconType = loading ? 'loading' : icon;
      var iconNode = iconType ? React.createElement(_icon["default"], {
        type: iconType
      }) : null;
      var kids = children || children === 0 ? React.Children.map(children, function (child) {
        return insertSpace(child, _this.isNeedInserted());
      }) : null;
      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType']);

      if (linkButtonRestProps.href !== undefined) {
        return React.createElement("a", _extends({}, linkButtonRestProps, {
          className: classes,
          onClick: _this.handleClick,
          ref: _this.saveButtonRef
        }), iconNode, kids);
      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.


      var _b = rest,
          htmlType = _b.htmlType,
          otherProps = __rest(_b, ["htmlType"]);

      return React.createElement(_wave["default"], null, React.createElement("button", _extends({}, otherProps, {
        type: htmlType || 'button',
        className: classes,
        onClick: _this.handleClick,
        ref: _this.saveButtonRef
      }), iconNode, kids));
    };

    _this.state = {
      loading: props.loading,
      hasTwoCNChar: false
    };
    return _this;
  }

  _createClass(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fixTwoCNChar();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      this.fixTwoCNChar();

      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
        clearTimeout(this.delayTimeout);
      }

      var loading = this.props.loading;

      if (loading && typeof loading !== 'boolean' && loading.delay) {
        this.delayTimeout = window.setTimeout(function () {
          return _this2.setState({
            loading: loading
          });
        }, loading.delay);
      } else if (prevProps.loading === this.props.loading) {
        return;
      } else {
        this.setState({
          loading: loading
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
      }
    }
  }, {
    key: "fixTwoCNChar",
    value: function fixTwoCNChar() {
      // Fix for HOC usage like <FormatMessage />
      if (!this.buttonNode) {
        return;
      }

      var buttonText = this.buttonNode.textContent || this.buttonNode.innerText;

      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
        if (!this.state.hasTwoCNChar) {
          this.setState({
            hasTwoCNChar: true
          });
        }
      } else if (this.state.hasTwoCNChar) {
        this.setState({
          hasTwoCNChar: false
        });
      }
    }
  }, {
    key: "isNeedInserted",
    value: function isNeedInserted() {
      var _this$props = this.props,
          icon = _this$props.icon,
          children = _this$props.children;
      return React.Children.count(children) === 1 && !icon;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.loading instanceof Boolean) {
        return _extends({}, prevState, {
          loading: nextProps.loading
        });
      }

      return null;
    }
  }]);

  return Button;
}(React.Component);

Button.__ANT_BUTTON = true;
Button.defaultProps = {
  loading: false,
  ghost: false,
  block: false
};
Button.propTypes = {
  type: PropTypes.string,
  shape: PropTypes.oneOf(ButtonShapes),
  size: PropTypes.oneOf(ButtonSizes),
  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
  onClick: PropTypes.func,
  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  className: PropTypes.string,
  icon: PropTypes.string,
  block: PropTypes.bool
};
(0, _reactLifecyclesCompat.polyfill)(Button);
var _default = Button;
exports["default"] = _default;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

exports['default'] = TransitionEvents;
module.exports = exports['default'];

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapperRaf;

var _raf = _interopRequireDefault(__webpack_require__(151));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var id = 0;
var ids = {}; // Support call raf with delay specified frame

function wrapperRaf(callback) {
  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var myId = id++;
  var restFrames = delayFrames;

  function internalCallback() {
    restFrames -= 1;

    if (restFrames <= 0) {
      callback();
      delete ids[id];
    } else {
      ids[id] = (0, _raf["default"])(internalCallback);
    }
  }

  ids[id] = (0, _raf["default"])(internalCallback);
  return myId;
}

wrapperRaf.cancel = function (pid) {
  _raf["default"].cancel(ids[pid]);

  delete ids[pid];
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = function ButtonGroup(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        size = props.size,
        className = props.className,
        others = __rest(props, ["prefixCls", "size", "className"]);

    var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
    // small => sm

    var sizeCls = '';

    switch (size) {
      case 'large':
        sizeCls = 'lg';
        break;

      case 'small':
        sizeCls = 'sm';

      default:
        break;
    }

    var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
    return React.createElement("div", _extends({}, others, {
      className: classes
    }));
  });
};

var _default = ButtonGroup;
exports["default"] = _default;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _reactLifecyclesCompat = __webpack_require__(49);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(415));

var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(909));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

function onNextFrame(cb) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(cb);
  }

  return window.setTimeout(cb, 1);
}

function clearNextFrameAction(nextFrameId) {
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(nextFrameId);
  } else {
    window.clearTimeout(nextFrameId);
  }
}

var TextArea =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea() {
    var _this;

    _classCallCheck(this, TextArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextArea).apply(this, arguments));
    _this.state = {
      textareaStyles: {}
    };

    _this.resizeOnNextFrame = function () {
      if (_this.nextFrameActionId) {
        clearNextFrameAction(_this.nextFrameActionId);
      }

      _this.nextFrameActionId = onNextFrame(_this.resizeTextarea);
    };

    _this.resizeTextarea = function () {
      var autosize = _this.props.autosize;

      if (!autosize || !_this.textAreaRef) {
        return;
      }

      var minRows = autosize ? autosize.minRows : null;
      var maxRows = autosize ? autosize.maxRows : null;
      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textAreaRef, false, minRows, maxRows);

      _this.setState({
        textareaStyles: textareaStyles
      });
    };

    _this.handleTextareaChange = function (e) {
      if (!('value' in _this.props)) {
        _this.resizeTextarea();
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(e);
      }
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onPressEnter = _this$props.onPressEnter,
          onKeyDown = _this$props.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.saveTextAreaRef = function (textArea) {
      _this.textAreaRef = textArea;
    };

    _this.renderTextArea = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var _this$props2 = _this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          disabled = _this$props2.disabled;

      var props = __rest(_this.props, []);

      var otherProps = (0, _omit["default"])(props, ['prefixCls', 'onPressEnter', 'autosize']);
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled));

      var style = _extends({}, props.style, _this.state.textareaStyles); // Fix https://github.com/ant-design/ant-design/issues/6776
      // Make sure it could be reset when using form.getFieldDecorator


      if ('value' in otherProps) {
        otherProps.value = otherProps.value || '';
      }

      return React.createElement("textarea", _extends({}, otherProps, {
        className: cls,
        style: style,
        onKeyDown: _this.handleKeyDown,
        onChange: _this.handleTextareaChange,
        ref: _this.saveTextAreaRef
      }));
    };

    return _this;
  }

  _createClass(TextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resizeTextarea();
      this.updateResizeObserverHook();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Re-render with the new content then recalculate the height as required.
      if (prevProps.value !== this.props.value) {
        this.resizeOnNextFrame();
      }

      this.updateResizeObserverHook();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    } // We will update hooks if `autosize` prop change

  }, {
    key: "updateResizeObserverHook",
    value: function updateResizeObserverHook() {
      if (!this.resizeObserver && this.props.autosize) {
        // Add resize observer
        this.resizeObserver = new _resizeObserverPolyfill["default"](this.resizeOnNextFrame);
        this.resizeObserver.observe(this.textAreaRef);
      } else if (this.resizeObserver && !this.props.autosize) {
        // Remove resize observer
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.textAreaRef.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.textAreaRef.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderTextArea);
    }
  }]);

  return TextArea;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(TextArea);
var _default = TextArea;
exports["default"] = _default;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateNodeHeight;
// Thanks to https://github.com/andreypopp/react-textarea-autosize/

/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea;

function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  var sizingStyle = SIZING_STYLE.map(function (name) {
    return "".concat(name, ":").concat(style.getPropertyValue(name));
  }).join(';');
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}

function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  } // Fix wrap="off" issue
  // https://github.com/ant-design/ant-design/issues/6577


  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
  var minHeight = Number.MIN_SAFE_INTEGER;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var height = hiddenTextarea.scrollHeight;
  var overflowY;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = ' ';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      overflowY = height > maxHeight ? '' : 'hidden';
      height = Math.min(maxHeight, height);
    }
  }

  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    overflowY: overflowY
  };
}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _Input = _interopRequireDefault(__webpack_require__(297));

var _icon = _interopRequireDefault(__webpack_require__(25));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var ActionMap = {
  click: 'onClick',
  hover: 'onMouseOver'
};

var Password =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Password, _React$Component);

  function Password() {
    var _this;

    _classCallCheck(this, Password);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Password).apply(this, arguments));
    _this.state = {
      visible: false
    };

    _this.onChange = function () {
      _this.setState({
        visible: !_this.state.visible
      });
    };

    return _this;
  }

  _createClass(Password, [{
    key: "getIcon",
    value: function getIcon() {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          action = _this$props.action;
      var iconTrigger = ActionMap[action] || '';

      var iconProps = _defineProperty({}, iconTrigger, this.onChange);

      return React.cloneElement(React.createElement(_icon["default"], _extends({}, iconProps, {
        className: "".concat(prefixCls, "-icon"),
        type: this.state.visible ? 'eye-invisible' : 'eye',
        key: "passwordIcon"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          prefixCls = _a.prefixCls,
          inputPrefixCls = _a.inputPrefixCls,
          size = _a.size,
          suffix = _a.suffix,
          visibilityToggle = _a.visibilityToggle,
          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "suffix", "visibilityToggle"]);

      var suffixIcon = visibilityToggle && this.getIcon();
      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
      return React.createElement(_Input["default"], _extends({}, restProps, {
        type: this.state.visible ? 'text' : 'password',
        size: size,
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon
      }));
    }
  }]);

  return Password;
}(React.Component);

exports["default"] = Password;
Password.defaultProps = {
  inputPrefixCls: 'ant-input',
  prefixCls: 'ant-input-password',
  action: 'click',
  visibilityToggle: true
};

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _createDOMForm = _interopRequireDefault(__webpack_require__(913));

var _createFormField = _interopRequireDefault(__webpack_require__(439));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _FormItem = _interopRequireDefault(__webpack_require__(985));

var _constants = __webpack_require__(440);

var _configProvider = __webpack_require__(35);

var _type = __webpack_require__(111);

var _warning = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FormLayouts = (0, _type.tuple)('horizontal', 'inline', 'vertical');

var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));

    _this.renderForm = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          hideRequiredMark = _this$props.hideRequiredMark,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          layout = _this$props.layout;
      var prefixCls = getPrefixCls('form', customizePrefixCls);
      var formClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-horizontal"), layout === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), layout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-inline"), layout === 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _classNames), className);
      var formProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark']);
      return React.createElement("form", _extends({}, formProps, {
        className: formClassName
      }));
    };

    (0, _warning["default"])(!props.form, 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
    return _this;
  }

  _createClass(Form, [{
    key: "getChildContext",
    value: function getChildContext() {
      var layout = this.props.layout;
      return {
        vertical: layout === 'vertical'
      };
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderForm);
    }
  }]);

  return Form;
}(React.Component);

exports["default"] = Form;
Form.defaultProps = {
  layout: 'horizontal',
  hideRequiredMark: false,
  onSubmit: function onSubmit(e) {
    e.preventDefault();
  }
};
Form.propTypes = {
  prefixCls: PropTypes.string,
  layout: PropTypes.oneOf(FormLayouts),
  children: PropTypes.any,
  onSubmit: PropTypes.func,
  hideRequiredMark: PropTypes.bool
};
Form.childContextTypes = {
  vertical: PropTypes.bool
};
Form.Item = _FormItem["default"];
Form.createFormField = _createFormField["default"];

Form.create = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _createDOMForm["default"])(_extends({
    fieldNameProp: 'id'
  }, options, {
    fieldMetaProp: _constants.FIELD_META_PROP,
    fieldDataProp: _constants.FIELD_DATA_PROP
  }));
};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domScrollIntoView = __webpack_require__(294);

var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);

var _has = __webpack_require__(914);

var _has2 = _interopRequireDefault(_has);

var _createBaseForm = __webpack_require__(432);

var _createBaseForm2 = _interopRequireDefault(_createBaseForm);

var _createForm = __webpack_require__(984);

var _utils = __webpack_require__(306);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function computedStyle(el, prop) {
  var getComputedStyle = window.getComputedStyle;
  var style =
  // If we have getComputedStyle
  getComputedStyle ?
  // Query it
  // TODO: From CSS-Query notes, we might need (node, null) for FF
  getComputedStyle(el) :

  // Otherwise, we are in IE and use currentStyle
  el.currentStyle;
  if (style) {
    return style[
    // Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function (word, letter) {
      return letter.toUpperCase();
    })];
  }
  return undefined;
}

function getScrollableContainer(n) {
  var node = n;
  var nodeName = void 0;
  /* eslint no-cond-assign:0 */
  while ((nodeName = node.nodeName.toLowerCase()) !== 'body') {
    var overflowY = computedStyle(node, 'overflowY');
    // https://stackoverflow.com/a/36900407/3040605
    if (node !== n && (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentNode;
  }
  return nodeName === 'body' ? node.ownerDocument : node;
}

var mixin = {
  getForm: function getForm() {
    return (0, _extends3['default'])({}, _createForm.mixin.getForm.call(this), {
      validateFieldsAndScroll: this.validateFieldsAndScroll
    });
  },
  validateFieldsAndScroll: function validateFieldsAndScroll(ns, opt, cb) {
    var _this = this;

    var _getParams = (0, _utils.getParams)(ns, opt, cb),
        names = _getParams.names,
        callback = _getParams.callback,
        options = _getParams.options;

    var newCb = function newCb(error, values) {
      if (error) {
        var validNames = _this.fieldsStore.getValidFieldsName();
        var firstNode = void 0;
        var firstTop = void 0;

        validNames.forEach(function (name) {
          if ((0, _has2['default'])(error, name)) {
            var instance = _this.getFieldInstance(name);
            if (instance) {
              var node = _reactDom2['default'].findDOMNode(instance);
              var top = node.getBoundingClientRect().top;
              if (node.type !== 'hidden' && (firstTop === undefined || firstTop > top)) {
                firstTop = top;
                firstNode = node;
              }
            }
          }
        });

        if (firstNode) {
          var c = options.container || getScrollableContainer(firstNode);
          (0, _domScrollIntoView2['default'])(firstNode, c, (0, _extends3['default'])({
            onlyScrollIfNeeded: true
          }, options.scroll));
        }
      }

      if (typeof callback === 'function') {
        callback(error, values);
      }
    };

    return this.validateFields(names, options, newCb);
  }
};

function createDOMForm(option) {
  return (0, _createBaseForm2['default'])((0, _extends3['default'])({}, option), [mixin]);
}

exports['default'] = createDOMForm;
module.exports = exports['default'];

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(915),
    hasPath = __webpack_require__(428);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(917);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(918);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(301);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(920),
    ListCache = __webpack_require__(218),
    Map = __webpack_require__(303);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(921),
    hashDelete = __webpack_require__(926),
    hashGet = __webpack_require__(927),
    hashHas = __webpack_require__(928),
    hashSet = __webpack_require__(929);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(217);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(429),
    isMasked = __webpack_require__(923),
    isObject = __webpack_require__(150),
    toSource = __webpack_require__(430);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(924);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(101);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 925 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 926 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(217);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(217);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(217);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 930 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(219);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(219);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(219);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(219);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(220);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(220);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(220);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(220);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(941);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(214),
    arrayMap = __webpack_require__(942),
    isArray = __webpack_require__(121),
    isSymbol = __webpack_require__(213);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 942 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(180),
    isObjectLike = __webpack_require__(181);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(433);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(391);
__webpack_require__(946);
module.exports = __webpack_require__(99).Array.from;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(275);
var $export = __webpack_require__(128);
var toObject = __webpack_require__(284);
var call = __webpack_require__(947);
var isArrayIter = __webpack_require__(948);
var toLength = __webpack_require__(390);
var createProperty = __webpack_require__(949);
var getIterFn = __webpack_require__(950);

$export($export.S + $export.F * !__webpack_require__(952)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(147);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(178);
var ITERATOR = __webpack_require__(100)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(120);
var createDesc = __webpack_require__(177);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(951);
var ITERATOR = __webpack_require__(100)('iterator');
var Iterators = __webpack_require__(178);
module.exports = __webpack_require__(99).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(277);
var TAG = __webpack_require__(100)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(100)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(954);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(170);

var emptyObject = __webpack_require__(955);
var _invariant = __webpack_require__(956);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validator___ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(978);






/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments[2];

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return;
    }
    function complete(results) {
      var i = void 0;
      var field = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          errors = errors.concat.apply(errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        for (i = 0; i < errors.length; i++) {
          field = errors[i].field;
          fields[field] = fields[field] || [];
          fields[field].push(errors[i]);
        }
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */]) {
        messages = Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])();
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* asyncMap */])(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.fields) === 'object' || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullfield(key, schema) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (errors.length) {
          Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* warning */])('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));
            } else if (options.error) {
              errors = [options.error(rule, Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            doIt(errs && errs.length ? errors.concat(errs) : errs);
          });
        }
      }

      var res = rule.validator(rule, data.value, cb, data.source, options);
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !__WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].hasOwnProperty(rule.type)) {
      throw new Error(Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].required;
    }
    return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][type] = validator;
};

Schema.messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];

/* harmony default export */ __webpack_exports__["default"] = (Schema);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__method__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boolean__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integer__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__float__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__array__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enum__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pattern__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__date__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__required__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type__ = __webpack_require__(977);















/* harmony default export */ __webpack_exports__["a"] = ({
  string: __WEBPACK_IMPORTED_MODULE_0__string__["a" /* default */],
  method: __WEBPACK_IMPORTED_MODULE_1__method__["a" /* default */],
  number: __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */],
  boolean: __WEBPACK_IMPORTED_MODULE_3__boolean__["a" /* default */],
  regexp: __WEBPACK_IMPORTED_MODULE_4__regexp__["a" /* default */],
  integer: __WEBPACK_IMPORTED_MODULE_5__integer__["a" /* default */],
  float: __WEBPACK_IMPORTED_MODULE_6__float__["a" /* default */],
  array: __WEBPACK_IMPORTED_MODULE_7__array__["a" /* default */],
  object: __WEBPACK_IMPORTED_MODULE_8__object__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_9__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_10__pattern__["a" /* default */],
  date: __WEBPACK_IMPORTED_MODULE_11__date__["a" /* default */],
  url: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  hex: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  email: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  required: __WEBPACK_IMPORTED_MODULE_12__required__["a" /* default */]
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'string');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (string);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(64);


/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.whitespace, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (whitespace);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__required__ = __webpack_require__(434);




/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    Object(__WEBPACK_IMPORTED_MODULE_2__required__["a" /* default */])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) !== rule.type) {
    errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(64);


/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (range);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(64);

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(64);


/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (method);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (number);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(81);



/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (boolean);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (regexp);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (integer);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (floatFn);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);


/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'array');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (array);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (object);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);


var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (date);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(81);



function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
  __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options, type);
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(64);



function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, ruleType);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = newMessages;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = newMessages();

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(980),
    castPath = __webpack_require__(299),
    isIndex = __webpack_require__(304),
    isObject = __webpack_require__(150),
    toKey = __webpack_require__(183);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(981),
    eq = __webpack_require__(302);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(982);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(135);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

exports['default'] = createFieldsStore;

var _set = __webpack_require__(438);

var _set2 = _interopRequireDefault(_set);

var _createFormField = __webpack_require__(439);

var _createFormField2 = _interopRequireDefault(_createFormField);

var _utils = __webpack_require__(306);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function partOf(a, b) {
  return b.indexOf(a) === 0 && ['.', '['].indexOf(b[a.length]) !== -1;
}

function internalFlattenFields(fields) {
  return (0, _utils.flattenFields)(fields, function (_, node) {
    return (0, _createFormField.isFormField)(node);
  }, 'You must wrap field data with `createFormField`.');
}

var FieldsStore = function () {
  function FieldsStore(fields) {
    (0, _classCallCheck3['default'])(this, FieldsStore);

    _initialiseProps.call(this);

    this.fields = internalFlattenFields(fields);
    this.fieldsMeta = {};
  }

  (0, _createClass3['default'])(FieldsStore, [{
    key: 'updateFields',
    value: function updateFields(fields) {
      this.fields = internalFlattenFields(fields);
    }
  }, {
    key: 'flattenRegisteredFields',
    value: function flattenRegisteredFields(fields) {
      var validFieldsName = this.getAllFieldsName();
      return (0, _utils.flattenFields)(fields, function (path) {
        return validFieldsName.indexOf(path) >= 0;
      }, 'You cannot set a form field before rendering a field associated with the value.');
    }
  }, {
    key: 'setFields',
    value: function setFields(fields) {
      var _this = this;

      var fieldsMeta = this.fieldsMeta;
      var nowFields = (0, _extends3['default'])({}, this.fields, fields);
      var nowValues = {};
      Object.keys(fieldsMeta).forEach(function (f) {
        nowValues[f] = _this.getValueFromFields(f, nowFields);
      });
      Object.keys(nowValues).forEach(function (f) {
        var value = nowValues[f];
        var fieldMeta = _this.getFieldMeta(f);
        if (fieldMeta && fieldMeta.normalize) {
          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
          if (nowValue !== value) {
            nowFields[f] = (0, _extends3['default'])({}, nowFields[f], {
              value: nowValue
            });
          }
        }
      });
      this.fields = nowFields;
    }
  }, {
    key: 'resetFields',
    value: function resetFields(ns) {
      var fields = this.fields;

      var names = ns ? this.getValidFieldsFullName(ns) : this.getAllFieldsName();
      return names.reduce(function (acc, name) {
        var field = fields[name];
        if (field && 'value' in field) {
          acc[name] = {};
        }
        return acc;
      }, {});
    }
  }, {
    key: 'setFieldMeta',
    value: function setFieldMeta(name, meta) {
      this.fieldsMeta[name] = meta;
    }
  }, {
    key: 'getFieldMeta',
    value: function getFieldMeta(name) {
      this.fieldsMeta[name] = this.fieldsMeta[name] || {};
      return this.fieldsMeta[name];
    }
  }, {
    key: 'getValueFromFields',
    value: function getValueFromFields(name, fields) {
      var field = fields[name];
      if (field && 'value' in field) {
        return field.value;
      }
      var fieldMeta = this.getFieldMeta(name);
      return fieldMeta && fieldMeta.initialValue;
    }
  }, {
    key: 'getValidFieldsName',
    value: function getValidFieldsName() {
      var _this2 = this;

      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
        return !_this2.getFieldMeta(name).hidden;
      }) : [];
    }
  }, {
    key: 'getAllFieldsName',
    value: function getAllFieldsName() {
      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta) : [];
    }
  }, {
    key: 'getValidFieldsFullName',
    value: function getValidFieldsFullName(maybePartialName) {
      var maybePartialNames = Array.isArray(maybePartialName) ? maybePartialName : [maybePartialName];
      return this.getValidFieldsName().filter(function (fullName) {
        return maybePartialNames.some(function (partialName) {
          return fullName === partialName || (0, _utils.startsWith)(fullName, partialName) && ['.', '['].indexOf(fullName[partialName.length]) >= 0;
        });
      });
    }
  }, {
    key: 'getFieldValuePropValue',
    value: function getFieldValuePropValue(fieldMeta) {
      var name = fieldMeta.name,
          getValueProps = fieldMeta.getValueProps,
          valuePropName = fieldMeta.valuePropName;

      var field = this.getField(name);
      var fieldValue = 'value' in field ? field.value : fieldMeta.initialValue;
      if (getValueProps) {
        return getValueProps(fieldValue);
      }
      return (0, _defineProperty3['default'])({}, valuePropName, fieldValue);
    }
  }, {
    key: 'getField',
    value: function getField(name) {
      return (0, _extends3['default'])({}, this.fields[name], {
        name: name
      });
    }
  }, {
    key: 'getNotCollectedFields',
    value: function getNotCollectedFields() {
      var _this3 = this;

      var fieldsName = this.getValidFieldsName();
      return fieldsName.filter(function (name) {
        return !_this3.fields[name];
      }).map(function (name) {
        return {
          name: name,
          dirty: false,
          value: _this3.getFieldMeta(name).initialValue
        };
      }).reduce(function (acc, field) {
        return (0, _set2['default'])(acc, field.name, (0, _createFormField2['default'])(field));
      }, {});
    }
  }, {
    key: 'getNestedAllFields',
    value: function getNestedAllFields() {
      var _this4 = this;

      return Object.keys(this.fields).reduce(function (acc, name) {
        return (0, _set2['default'])(acc, name, (0, _createFormField2['default'])(_this4.fields[name]));
      }, this.getNotCollectedFields());
    }
  }, {
    key: 'getFieldMember',
    value: function getFieldMember(name, member) {
      return this.getField(name)[member];
    }
  }, {
    key: 'getNestedFields',
    value: function getNestedFields(names, getter) {
      var fields = names || this.getValidFieldsName();
      return fields.reduce(function (acc, f) {
        return (0, _set2['default'])(acc, f, getter(f));
      }, {});
    }
  }, {
    key: 'getNestedField',
    value: function getNestedField(name, getter) {
      var fullNames = this.getValidFieldsFullName(name);
      if (fullNames.length === 0 || // Not registered
      fullNames.length === 1 && fullNames[0] === name // Name already is full name.
      ) {
          return getter(name);
        }
      var isArrayValue = fullNames[0][name.length] === '[';
      var suffixNameStartIndex = isArrayValue ? name.length : name.length + 1;
      return fullNames.reduce(function (acc, fullName) {
        return (0, _set2['default'])(acc, fullName.slice(suffixNameStartIndex), getter(fullName));
      }, isArrayValue ? [] : {});
    }
  }, {
    key: 'isValidNestedFieldName',


    // @private
    // BG: `a` and `a.b` cannot be use in the same form
    value: function isValidNestedFieldName(name) {
      var names = this.getAllFieldsName();
      return names.every(function (n) {
        return !partOf(n, name) && !partOf(name, n);
      });
    }
  }, {
    key: 'clearField',
    value: function clearField(name) {
      delete this.fields[name];
      delete this.fieldsMeta[name];
    }
  }]);
  return FieldsStore;
}();

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.setFieldsInitialValue = function (initialValues) {
    var flattenedInitialValues = _this5.flattenRegisteredFields(initialValues);
    var fieldsMeta = _this5.fieldsMeta;
    Object.keys(flattenedInitialValues).forEach(function (name) {
      if (fieldsMeta[name]) {
        _this5.setFieldMeta(name, (0, _extends3['default'])({}, _this5.getFieldMeta(name), {
          initialValue: flattenedInitialValues[name]
        }));
      }
    });
  };

  this.getAllValues = function () {
    var fieldsMeta = _this5.fieldsMeta,
        fields = _this5.fields;

    return Object.keys(fieldsMeta).reduce(function (acc, name) {
      return (0, _set2['default'])(acc, name, _this5.getValueFromFields(name, fields));
    }, {});
  };

  this.getFieldsValue = function (names) {
    return _this5.getNestedFields(names, _this5.getFieldValue);
  };

  this.getFieldValue = function (name) {
    var fields = _this5.fields;

    return _this5.getNestedField(name, function (fullName) {
      return _this5.getValueFromFields(fullName, fields);
    });
  };

  this.getFieldsError = function (names) {
    return _this5.getNestedFields(names, _this5.getFieldError);
  };

  this.getFieldError = function (name) {
    return _this5.getNestedField(name, function (fullName) {
      return (0, _utils.getErrorStrs)(_this5.getFieldMember(fullName, 'errors'));
    });
  };

  this.isFieldValidating = function (name) {
    return _this5.getFieldMember(name, 'validating');
  };

  this.isFieldsValidating = function (ns) {
    var names = ns || _this5.getValidFieldsName();
    return names.some(function (n) {
      return _this5.isFieldValidating(n);
    });
  };

  this.isFieldTouched = function (name) {
    return _this5.getFieldMember(name, 'touched');
  };

  this.isFieldsTouched = function (ns) {
    var names = ns || _this5.getValidFieldsName();
    return names.some(function (n) {
      return _this5.isFieldTouched(n);
    });
  };
};

function createFieldsStore(fields) {
  return new FieldsStore(fields);
}
module.exports = exports['default'];

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mixin = undefined;

var _createBaseForm = __webpack_require__(432);

var _createBaseForm2 = _interopRequireDefault(_createBaseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mixin = exports.mixin = {
  getForm: function getForm() {
    return {
      getFieldsValue: this.fieldsStore.getFieldsValue,
      getFieldValue: this.fieldsStore.getFieldValue,
      getFieldInstance: this.getFieldInstance,
      setFieldsValue: this.setFieldsValue,
      setFields: this.setFields,
      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
      getFieldDecorator: this.getFieldDecorator,
      getFieldProps: this.getFieldProps,
      getFieldsError: this.fieldsStore.getFieldsError,
      getFieldError: this.fieldsStore.getFieldError,
      isFieldValidating: this.fieldsStore.isFieldValidating,
      isFieldsValidating: this.fieldsStore.isFieldsValidating,
      isFieldsTouched: this.fieldsStore.isFieldsTouched,
      isFieldTouched: this.fieldsStore.isFieldTouched,
      isSubmitting: this.isSubmitting,
      submit: this.submit,
      validateFields: this.validateFields,
      resetFields: this.resetFields
    };
  }
};

function createForm(options) {
  return (0, _createBaseForm2['default'])(options, [mixin]);
}

exports['default'] = createForm;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(38));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _rcAnimate = _interopRequireDefault(__webpack_require__(102));

var _constants = __webpack_require__(440);

var _row = _interopRequireDefault(__webpack_require__(403));

var _col = _interopRequireDefault(__webpack_require__(407));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

var _warning = _interopRequireDefault(__webpack_require__(87));

var _type = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var ValidateStatuses = (0, _type.tuple)('success', 'warning', 'error', 'validating', '');

function intersperseSpace(list) {
  return list.reduce(function (current, item) {
    return [].concat(_toConsumableArray(current), [' ', item]);
  }, []).slice(1);
}

var FormItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormItem, _React$Component);

  function FormItem() {
    var _this;

    _classCallCheck(this, FormItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormItem).apply(this, arguments));
    _this.helpShow = false;

    _this.onHelpAnimEnd = function (_key, helpShow) {
      _this.helpShow = helpShow;

      if (!helpShow) {
        _this.setState({});
      }
    }; // Resolve duplicated ids bug between different forms
    // https://github.com/ant-design/ant-design/issues/7351


    _this.onLabelClick = function (e) {
      var label = _this.props.label;

      var id = _this.props.id || _this.getId();

      if (!id) {
        return;
      }

      var controls = document.querySelectorAll("[id=\"".concat(id, "\"]"));

      if (controls.length !== 1) {
        // Only prevent in default situation
        // Avoid preventing event in `label={<a href="xx">link</a>}``
        if (typeof label === 'string') {
          e.preventDefault();
        }

        var formItemNode = ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
        var control = formItemNode.querySelector("[id=\"".concat(id, "\"]"));

        if (control && control.focus) {
          control.focus();
        }
      }
    };

    _this.renderFormItem = function (_ref) {
      var _itemClassName;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          style = _this$props.style,
          colon = _this$props.colon,
          className = _this$props.className;
      var prefixCls = getPrefixCls('form', customizePrefixCls);

      var children = _this.renderChildren(prefixCls);

      var itemClassName = (_itemClassName = {}, _defineProperty(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-with-help"), _this.helpShow), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-no-colon"), !colon), _defineProperty(_itemClassName, "".concat(className), !!className), _itemClassName);
      return React.createElement(_row["default"], {
        className: (0, _classnames["default"])(itemClassName),
        style: style
      }, children);
    };

    return _this;
  }

  _createClass(FormItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _warning["default"])(this.getControls(this.props.children, true).length <= 1, '`Form.Item` cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
    }
  }, {
    key: "getHelpMessage",
    value: function getHelpMessage() {
      var help = this.props.help;

      if (help === undefined && this.getOnlyControl()) {
        var errors = this.getField().errors;

        if (errors) {
          return intersperseSpace(errors.map(function (e, index) {
            var node = null;

            if (React.isValidElement(e)) {
              node = e;
            } else if (React.isValidElement(e.message)) {
              node = e.message;
            }

            return node ? React.cloneElement(node, {
              key: index
            }) : e.message;
          }));
        }

        return '';
      }

      return help;
    }
  }, {
    key: "getControls",
    value: function getControls(children, recursively) {
      var controls = [];
      var childrenArray = React.Children.toArray(children);

      for (var i = 0; i < childrenArray.length; i++) {
        if (!recursively && controls.length > 0) {
          break;
        }

        var child = childrenArray[i];

        if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
          continue;
        }

        if (!child.props) {
          continue;
        }

        if (_constants.FIELD_META_PROP in child.props) {
          // And means FIELD_DATA_PROP in child.props, too.
          controls.push(child);
        } else if (child.props.children) {
          controls = controls.concat(this.getControls(child.props.children, recursively));
        }
      }

      return controls;
    }
  }, {
    key: "getOnlyControl",
    value: function getOnlyControl() {
      var child = this.getControls(this.props.children, false)[0];
      return child !== undefined ? child : null;
    }
  }, {
    key: "getChildProp",
    value: function getChildProp(prop) {
      var child = this.getOnlyControl();
      return child && child.props && child.props[prop];
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.getChildProp('id');
    }
  }, {
    key: "getMeta",
    value: function getMeta() {
      return this.getChildProp(_constants.FIELD_META_PROP);
    }
  }, {
    key: "getField",
    value: function getField() {
      return this.getChildProp(_constants.FIELD_DATA_PROP);
    }
  }, {
    key: "renderHelp",
    value: function renderHelp(prefixCls) {
      var help = this.getHelpMessage();
      var children = help ? React.createElement("div", {
        className: "".concat(prefixCls, "-explain"),
        key: "help"
      }, help) : null;

      if (children) {
        this.helpShow = !!children;
      }

      return React.createElement(_rcAnimate["default"], {
        transitionName: "show-help",
        component: "",
        transitionAppear: true,
        key: "help",
        onEnd: this.onHelpAnimEnd
      }, children);
    }
  }, {
    key: "renderExtra",
    value: function renderExtra(prefixCls) {
      var extra = this.props.extra;
      return extra ? React.createElement("div", {
        className: "".concat(prefixCls, "-extra")
      }, extra) : null;
    }
  }, {
    key: "getValidateStatus",
    value: function getValidateStatus() {
      var onlyControl = this.getOnlyControl();

      if (!onlyControl) {
        return '';
      }

      var field = this.getField();

      if (field.validating) {
        return 'validating';
      }

      if (field.errors) {
        return 'error';
      }

      var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;

      if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
        return 'success';
      }

      return '';
    }
  }, {
    key: "renderValidateWrapper",
    value: function renderValidateWrapper(prefixCls, c1, c2, c3) {
      var props = this.props;
      var onlyControl = this.getOnlyControl;
      var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
      var classes = "".concat(prefixCls, "-item-control");

      if (validateStatus) {
        classes = (0, _classnames["default"])("".concat(prefixCls, "-item-control"), {
          'has-feedback': props.hasFeedback || validateStatus === 'validating',
          'has-success': validateStatus === 'success',
          'has-warning': validateStatus === 'warning',
          'has-error': validateStatus === 'error',
          'is-validating': validateStatus === 'validating'
        });
      }

      var iconType = '';

      switch (validateStatus) {
        case 'success':
          iconType = 'check-circle';
          break;

        case 'warning':
          iconType = 'exclamation-circle';
          break;

        case 'error':
          iconType = 'close-circle';
          break;

        case 'validating':
          iconType = 'loading';
          break;

        default:
          iconType = '';
          break;
      }

      var icon = props.hasFeedback && iconType ? React.createElement("span", {
        className: "".concat(prefixCls, "-item-children-icon")
      }, React.createElement(_icon["default"], {
        type: iconType,
        theme: iconType === 'loading' ? 'outlined' : 'filled'
      })) : null;
      return React.createElement("div", {
        className: classes
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-item-children")
      }, c1, icon), c2, c3);
    }
  }, {
    key: "renderWrapper",
    value: function renderWrapper(prefixCls, children) {
      var wrapperCol = this.props.wrapperCol;
      var className = (0, _classnames["default"])("".concat(prefixCls, "-item-control-wrapper"), wrapperCol && wrapperCol.className);
      return React.createElement(_col["default"], _extends({}, wrapperCol, {
        className: className,
        key: "wrapper"
      }), children);
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      var required = this.props.required;

      if (required !== undefined) {
        return required;
      }

      if (this.getOnlyControl()) {
        var meta = this.getMeta() || {};
        var validate = meta.validate || [];
        return validate.filter(function (item) {
          return !!item.rules;
        }).some(function (item) {
          return item.rules.some(function (rule) {
            return rule.required;
          });
        });
      }

      return false;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(prefixCls) {
      var _this$props2 = this.props,
          label = _this$props2.label,
          labelCol = _this$props2.labelCol,
          colon = _this$props2.colon,
          id = _this$props2.id;
      var context = this.context;
      var required = this.isRequired();
      var labelColClassName = (0, _classnames["default"])("".concat(prefixCls, "-item-label"), labelCol && labelCol.className);
      var labelClassName = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-item-required"), required));
      var labelChildren = label; // Keep label is original where there should have no colon

      var haveColon = colon && !context.vertical; // Remove duplicated user input colon

      if (haveColon && typeof label === 'string' && label.trim() !== '') {
        labelChildren = label.replace(/[：|:]\s*$/, '');
      }

      return label ? React.createElement(_col["default"], _extends({}, labelCol, {
        className: labelColClassName,
        key: "label"
      }), React.createElement("label", {
        htmlFor: id || this.getId(),
        className: labelClassName,
        title: typeof label === 'string' ? label : '',
        onClick: this.onLabelClick
      }, labelChildren)) : null;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(prefixCls) {
      var children = this.props.children;
      return [this.renderLabel(prefixCls), this.renderWrapper(prefixCls, this.renderValidateWrapper(prefixCls, children, this.renderHelp(prefixCls), this.renderExtra(prefixCls)))];
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderFormItem);
    }
  }]);

  return FormItem;
}(React.Component);

exports["default"] = FormItem;
FormItem.defaultProps = {
  hasFeedback: false,
  colon: true
};
FormItem.propTypes = {
  prefixCls: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelCol: PropTypes.object,
  help: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  validateStatus: PropTypes.oneOf(ValidateStatuses),
  hasFeedback: PropTypes.bool,
  wrapperCol: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  colon: PropTypes.bool
};
FormItem.contextTypes = {
  vertical: PropTypes.bool
};

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dialog__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_ContainerRender__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Portal__ = __webpack_require__(420);









var IS_REACT_16 = 'createPortal' in __WEBPACK_IMPORTED_MODULE_5_react_dom__;

var DialogWrap = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DialogWrap, _React$Component);

    function DialogWrap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DialogWrap);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));

        _this.saveDialog = function (node) {
            _this._component = node;
        };
        _this.getComponent = function () {
            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ ref: _this.saveDialog }, _this.props, extra, { key: "dialog" }));
        };
        // fix issue #10656
        /*
        * Custom container should not be return, because in the Portal component, it will remove the
        * return container element here, if the custom container is the only child of it's component,
        * like issue #10656, It will has a conflict with removeChild method in react-dom.
        * So here should add a child (div element) to custom container.
        * */
        _this.getContainer = function () {
            var container = document.createElement('div');
            if (_this.props.getContainer) {
                _this.props.getContainer().appendChild(container);
            } else {
                document.body.appendChild(container);
            }
            return container;
        };
        return _this;
    }

    DialogWrap.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
        var visible = _ref.visible,
            forceRender = _ref.forceRender;

        return !!(this.props.visible || visible) || this.props.forceRender || forceRender;
    };

    DialogWrap.prototype.componentWillUnmount = function componentWillUnmount() {
        if (IS_REACT_16) {
            return;
        }
        if (this.props.visible) {
            this.renderComponent({
                afterClose: this.removeContainer,
                onClose: function onClose() {},

                visible: false
            });
        } else {
            this.removeContainer();
        }
    };

    DialogWrap.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            visible = _props.visible,
            forceRender = _props.forceRender;

        var portal = null;
        if (!IS_REACT_16) {
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_rc_util_es_ContainerRender__["a" /* default */], { parent: this, visible: visible, autoDestroy: false, getComponent: this.getComponent, getContainer: this.getContainer, forceRender: forceRender }, function (_ref2) {
                var renderComponent = _ref2.renderComponent,
                    removeContainer = _ref2.removeContainer;

                _this2.renderComponent = renderComponent;
                _this2.removeContainer = removeContainer;
                return null;
            });
        }
        if (visible || forceRender || this._component) {
            portal = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Portal__["a" /* default */], { getContainer: this.getContainer }, this.getComponent());
        }
        return portal;
    };

    return DialogWrap;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

DialogWrap.defaultProps = {
    visible: false,
    forceRender: false
};
/* harmony default export */ __webpack_exports__["default"] = (DialogWrap);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_getScrollBarSize__ = __webpack_require__(990);











var uuid = 0;
var openCount = 0;
/* eslint react/no-is-mounted:0 */
function getScroll(w, top) {
    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
    var method = 'scroll' + (top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') {
            ret = d.body[method];
        }
    }
    return ret;
}
function setTransformOrigin(node, value) {
    var style = node.style;
    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
        style[prefix + 'TransformOrigin'] = value;
    });
    style['transformOrigin'] = value;
}
function offset(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScroll(w);
    pos.top += getScroll(w, true);
    return pos;
}

var Dialog = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Dialog, _React$Component);

    function Dialog() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dialog);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));

        _this.onAnimateLeave = function () {
            var afterClose = _this.props.afterClose;
            // need demo?
            // https://github.com/react-component/dialog/pull/28

            if (_this.wrap) {
                _this.wrap.style.display = 'none';
            }
            _this.inTransition = false;
            _this.removeScrollingEffect();
            if (afterClose) {
                afterClose();
            }
        };
        _this.onMaskClick = function (e) {
            // android trigger click on open (fastclick??)
            if (Date.now() - _this.openTime < 300) {
                return;
            }
            if (e.target === e.currentTarget) {
                _this.close(e);
            }
        };
        _this.onKeyDown = function (e) {
            var props = _this.props;
            if (props.keyboard && e.keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].ESC) {
                e.stopPropagation();
                _this.close(e);
                return;
            }
            // keep focus inside dialog
            if (props.visible) {
                if (e.keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].TAB) {
                    var activeElement = document.activeElement;
                    var sentinelStart = _this.sentinelStart;
                    if (e.shiftKey) {
                        if (activeElement === sentinelStart) {
                            _this.sentinelEnd.focus();
                        }
                    } else if (activeElement === _this.sentinelEnd) {
                        sentinelStart.focus();
                    }
                }
            }
        };
        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var dest = {};
            if (props.width !== undefined) {
                dest.width = props.width;
            }
            if (props.height !== undefined) {
                dest.height = props.height;
            }
            var footer = void 0;
            if (props.footer) {
                footer = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-footer', ref: _this.saveRef('footer') }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-header', ref: _this.saveRef('header') }, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("button", { onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, props.closeIcon || __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", { className: prefixCls + '-close-x' }));
            }
            var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style, dest);
            var sentinelStyle = { width: 0, height: 0, overflow: 'hidden' };
            var transitionName = _this.getTransitionName();
            var dialogElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], { key: "dialog-element", role: "document", ref: _this.saveRef('dialog'), style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible }, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { tabIndex: 0, ref: _this.saveRef('sentinelStart'), style: sentinelStyle }, "sentinelStart"), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-content' }, closer, header, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: prefixCls + '-body', style: props.bodyStyle, ref: _this.saveRef('body') }, props.bodyProps), props.children), footer), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { tabIndex: 0, ref: _this.saveRef('sentinelEnd'), style: sentinelStyle }, "sentinelEnd"));
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, props.visible || !props.destroyOnClose ? dialogElement : null);
        };
        _this.getZIndexStyle = function () {
            var style = {};
            var props = _this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        };
        _this.getWrapStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.getZIndexStyle(), _this.props.wrapStyle);
        };
        _this.getMaskStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.getZIndexStyle(), _this.props.maskStyle);
        };
        _this.getMaskElement = function () {
            var props = _this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = _this.getMaskTransitionName();
                maskElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        };
        _this.getMaskTransitionName = function () {
            var props = _this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.getTransitionName = function () {
            var props = _this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.setScrollbar = function () {
            if (_this.bodyIsOverflowing && _this.scrollbarWidth !== undefined) {
                document.body.style.paddingRight = _this.scrollbarWidth + 'px';
            }
        };
        _this.addScrollingEffect = function () {
            openCount++;
            if (openCount !== 1) {
                return;
            }
            _this.checkScrollbar();
            _this.setScrollbar();
            document.body.style.overflow = 'hidden';
            // this.adjustDialog();
        };
        _this.removeScrollingEffect = function () {
            openCount--;
            if (openCount !== 0) {
                return;
            }
            document.body.style.overflow = '';
            _this.resetScrollbar();
            // this.resetAdjustments();
        };
        _this.close = function (e) {
            var onClose = _this.props.onClose;

            if (onClose) {
                onClose(e);
            }
        };
        _this.checkScrollbar = function () {
            var fullWindowWidth = window.innerWidth;
            if (!fullWindowWidth) {
                // workaround for missing window.innerWidth in IE8
                var documentElementRect = document.documentElement.getBoundingClientRect();
                fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
            }
            _this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
            if (_this.bodyIsOverflowing) {
                _this.scrollbarWidth = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_getScrollBarSize__["a" /* default */])();
            }
        };
        _this.resetScrollbar = function () {
            document.body.style.paddingRight = '';
        };
        _this.adjustDialog = function () {
            if (_this.wrap && _this.scrollbarWidth !== undefined) {
                var modalIsOverflowing = _this.wrap.scrollHeight > document.documentElement.clientHeight;
                _this.wrap.style.paddingLeft = (!_this.bodyIsOverflowing && modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
                _this.wrap.style.paddingRight = (_this.bodyIsOverflowing && !modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
            }
        };
        _this.resetAdjustments = function () {
            if (_this.wrap) {
                _this.wrap.style.paddingLeft = _this.wrap.style.paddingLeft = '';
            }
        };
        _this.saveRef = function (name) {
            return function (node) {
                _this[name] = node;
            };
        };
        return _this;
    }

    Dialog.prototype.componentWillMount = function componentWillMount() {
        this.inTransition = false;
        this.titleId = 'rcDialogTitle' + uuid++;
    };

    Dialog.prototype.componentDidMount = function componentDidMount() {
        this.componentDidUpdate({});
        // if forceRender is true, set element style display to be none;
        if (this.props.forceRender && this.wrap) {
            this.wrap.style.display = 'none';
        }
    };

    Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var props = this.props;
        var mousePosition = this.props.mousePosition;
        if (props.visible) {
            // first show
            if (!prevProps.visible) {
                this.openTime = Date.now();
                this.addScrollingEffect();
                this.tryFocus();
                var dialogNode = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](this.dialog);
                if (mousePosition) {
                    var elOffset = offset(dialogNode);
                    setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
                } else {
                    setTransformOrigin(dialogNode, '');
                }
            }
        } else if (prevProps.visible) {
            this.inTransition = true;
            if (props.mask && this.lastOutSideFocusNode) {
                try {
                    this.lastOutSideFocusNode.focus();
                } catch (e) {
                    this.lastOutSideFocusNode = null;
                }
                this.lastOutSideFocusNode = null;
            }
        }
    };

    Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.props.visible || this.inTransition) {
            this.removeScrollingEffect();
        }
    };

    Dialog.prototype.tryFocus = function tryFocus() {
        if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(this.wrap, document.activeElement)) {
            this.lastOutSideFocusNode = document.activeElement;
            this.sentinelStart.focus();
        }
    };

    Dialog.prototype.render = function render() {
        var props = this.props;
        var prefixCls = props.prefixCls,
            maskClosable = props.maskClosable;

        var style = this.getWrapStyle();
        // clear hide display
        // and only set display after async anim, not here for hide
        if (props.visible) {
            style.display = null;
        }
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", null, this.getMaskElement(), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: this.saveRef('wrap'), onClick: maskClosable ? this.onMaskClick : undefined, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
    };

    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Dialog);

Dialog.defaultProps = {
    className: '',
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    destroyOnClose: false,
    prefixCls: 'rc-dialog'
};

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var LazyRenderBox = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
    }

    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !!nextProps.hiddenClassName || !!nextProps.visible;
    };

    LazyRenderBox.prototype.render = function render() {
        var className = this.props.className;
        if (!!this.props.hiddenClassName && !this.props.visible) {
            className += " " + this.props.hiddenClassName;
        }
        var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
        delete props.hiddenClassName;
        delete props.visible;
        props.className = className;
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props));
    };

    return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollBarSize;
var cached = void 0;

function getScrollBarSize(fresh) {
  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';

    var outer = document.createElement('div');
    var outerStyle = outer.style;

    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';

    outer.appendChild(inner);

    document.body.appendChild(outer);

    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);

    cached = widthContained - widthScroll;
  }
  return cached;
}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = confirm;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(38));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _Modal = _interopRequireWildcard(__webpack_require__(441));

var _ActionButton = _interopRequireDefault(__webpack_require__(992));

var _locale = __webpack_require__(442);

var _warning = _interopRequireDefault(__webpack_require__(87));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IS_REACT_16 = !!ReactDOM.createPortal;

var ConfirmDialog = function ConfirmDialog(props) {
  var onCancel = props.onCancel,
      onOk = props.onOk,
      close = props.close,
      zIndex = props.zIndex,
      afterClose = props.afterClose,
      visible = props.visible,
      keyboard = props.keyboard,
      centered = props.centered,
      getContainer = props.getContainer,
      maskStyle = props.maskStyle,
      okButtonProps = props.okButtonProps,
      cancelButtonProps = props.cancelButtonProps,
      _props$iconType = props.iconType,
      iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
  (0, _warning["default"])(!('iconType' in props), "The property 'iconType' is deprecated. Use the property 'icon' instead.");
  var icon = props.icon ? props.icon : iconType;
  var okType = props.okType || 'primary';
  var prefixCls = props.prefixCls || 'ant-modal';
  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容

  var okCancel = 'okCancel' in props ? props.okCancel : true;
  var width = props.width || 416;
  var style = props.style || {}; // 默认为 false，保持旧版默认行为

  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
  var runtimeLocale = (0, _locale.getConfirmLocale)();
  var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
  var cancelText = props.cancelText || runtimeLocale.cancelText;
  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
  var cancelButton = okCancel && React.createElement(_ActionButton["default"], {
    actionFn: onCancel,
    closeModal: close,
    autoFocus: autoFocusButton === 'cancel',
    buttonProps: cancelButtonProps
  }, cancelText);
  var iconNode = typeof icon === 'string' ? React.createElement(_icon["default"], {
    type: icon
  }) : icon;
  return React.createElement(_Modal["default"], {
    prefixCls: prefixCls,
    className: classString,
    wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
    onCancel: close.bind(_this, {
      triggerCancel: true
    }),
    visible: visible,
    title: "",
    transitionName: "zoom",
    footer: "",
    maskTransitionName: "fade",
    maskClosable: maskClosable,
    maskStyle: maskStyle,
    style: style,
    width: width,
    zIndex: zIndex,
    afterClose: afterClose,
    keyboard: keyboard,
    centered: centered,
    getContainer: getContainer
  }, React.createElement("div", {
    className: "".concat(contentPrefixCls, "-body-wrapper")
  }, React.createElement("div", {
    className: "".concat(contentPrefixCls, "-body")
  }, iconNode, React.createElement("span", {
    className: "".concat(contentPrefixCls, "-title")
  }, props.title), React.createElement("div", {
    className: "".concat(contentPrefixCls, "-content")
  }, props.content)), React.createElement("div", {
    className: "".concat(contentPrefixCls, "-btns")
  }, cancelButton, React.createElement(_ActionButton["default"], {
    type: okType,
    actionFn: onOk,
    closeModal: close,
    autoFocus: autoFocusButton === 'ok',
    buttonProps: okButtonProps
  }, okText))));
};

function confirm(config) {
  var div = document.createElement('div');
  document.body.appendChild(div);

  var currentConfig = _extends({}, config, {
    close: close,
    visible: true
  });

  function close() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    currentConfig = _extends({}, currentConfig, {
      visible: false,
      afterClose: destroy.bind.apply(destroy, [this].concat(args))
    });

    if (IS_REACT_16) {
      render(currentConfig);
    } else {
      destroy.apply(void 0, args);
    }
  }

  function update(newConfig) {
    currentConfig = _extends({}, currentConfig, newConfig);
    render(currentConfig);
  }

  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);

    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var triggerCancel = args.some(function (param) {
      return param && param.triggerCancel;
    });

    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }

    for (var i = 0; i < _Modal.destroyFns.length; i++) {
      var fn = _Modal.destroyFns[i];

      if (fn === destroy) {
        _Modal.destroyFns.splice(i, 1);

        break;
      }
    }
  }

  function render(props) {
    ReactDOM.render(React.createElement(ConfirmDialog, props), div);
  }

  render(currentConfig);

  _Modal.destroyFns.push(close);

  return {
    destroy: close,
    update: update
  };
}

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(38));

var _button = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ActionButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ActionButton, _React$Component);

  function ActionButton(props) {
    var _this;

    _classCallCheck(this, ActionButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionButton).call(this, props));

    _this.onClick = function () {
      var _this$props = _this.props,
          actionFn = _this$props.actionFn,
          closeModal = _this$props.closeModal;

      if (actionFn) {
        var ret;

        if (actionFn.length) {
          ret = actionFn(closeModal);
        } else {
          ret = actionFn();

          if (!ret) {
            closeModal();
          }
        }

        if (ret && ret.then) {
          _this.setState({
            loading: true
          });

          ret.then(function () {
            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
            // this.setState({ loading: false });
            closeModal.apply(void 0, arguments);
          }, function () {
            // See: https://github.com/ant-design/ant-design/issues/6183
            _this.setState({
              loading: false
            });
          });
        }
      } else {
        closeModal();
      }
    };

    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(ActionButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        var $this = ReactDOM.findDOMNode(this);
        this.timeoutId = setTimeout(function () {
          return $this.focus();
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          children = _this$props2.children,
          buttonProps = _this$props2.buttonProps;
      var loading = this.state.loading;
      return React.createElement(_button["default"], _extends({
        type: type,
        onClick: this.onClick,
        loading: loading
      }, buttonProps), children);
    }
  }]);

  return ActionButton;
}(React.Component);

exports["default"] = ActionButton;

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list_reducer__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wizard_reducer__ = __webpack_require__(310);
var fileMappingReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({list:__WEBPACK_IMPORTED_MODULE_1__list_reducer__["a" /* default */],wizard:__WEBPACK_IMPORTED_MODULE_2__wizard_reducer__["f" /* default */]})});/* harmony default export */ __webpack_exports__["a"] = (fileMappingReducer);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wizard_actions__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tree__ = __webpack_require__(32);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var fileMappingListReducer=function fileMappingListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{fileMappingsTree:null,fileMappingId:null,fileMapping:null,fileMappingCube:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* FILE_MAPPING_LIST_FILE_MAPPING_SHOW */]:return Object.assign({},state,{fileMappingId:action.fileMappingId});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* FILE_MAPPING_LIST_FILE_MAPPING_HIDE */]:return Object.assign({},state,{fileMappingId:null,fileMapping:null,fileMappingCube:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_LIST_FILE_MAPPINGS_READ */]:return Object.assign({},state,{fileMappingsTree:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* FILE_MAPPING_LIST_FILE_MAPPING_READ */]:return Object.assign({},state,{fileMapping:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ */]:return Object.assign({},state,{fileMappingCube:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_LIST_FILE_MAPPINGS_READ */]:return Object.assign({},state,{fileMappingsTree:[]});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* FILE_MAPPING_LIST_FILE_MAPPING_READ */]:return Object.assign({},state,{fileMappingId:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ */]:return Object.assign({},state,{fileMappingId:null,fileMapping:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_LIST_FILE_MAPPINGS_READ */]:var _action$response=_slicedToArray(action.response,3),allCubes=_action$response[0],dcs=_action$response[1],mappings=_action$response[2];var treeWithCategories=Object(__WEBPACK_IMPORTED_MODULE_3__utils_treeBuilders__["b" /* getCubesTree */])(allCubes,dcs);var treeWithCategoriesOrd=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["h" /* getMappedTree */])(treeWithCategories,"children",function(node){var ordCount=1;return Object.assign({},node,{TreeID:node.CatCode?'Cat_'+node.CatCode:''+node.Code,children:node.children?node.children.sort(function(a,b){if(a.Ord!==undefined&&b.Ord!==undefined){return a.Ord-b.Ord;}else if(a.Ord!==undefined){return a;}else if(b.Ord!==undefined){return b;}else{return(a.CatCode||-1)-(b.CatCode||-1);}}).map(function(c){return Object.assign({},c,{Ord:c.Ord!==undefined?String(ordCount++):undefined});}):node.children});});var treeWithMappings=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["d" /* getCategorisedObjectsTree */])(mappings.map(function(mapping){return Object.assign({},mapping,{TreeID:'Mapp_'+mapping.IDMapping});}),treeWithCategoriesOrd,"children",function(a,b){return a.IDMapping-b.IDMapping;},function(mapping,cube){if(cube){return cube.IDCube===mapping.IDCube;}else{return true;}},null,null,true);var cleanedTreeWithMappings=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["g" /* getFilteredTreeWithPaths */])(treeWithMappings,"children",function(node){return node.IDMapping||node.children&&node.children.filter(function(_ref){var IDMapping=_ref.IDMapping;return IDMapping;}).length>0;});return Object.assign({},state,{fileMappingsTree:cleanedTreeWithMappings});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* FILE_MAPPING_LIST_FILE_MAPPING_READ */]:return Object.assign({},state,{fileMapping:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ */]:return Object.assign({},state,{fileMappingCube:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* FILE_MAPPING_LIST_FILE_MAPPING_DELETE */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL */]:return Object.assign({},state,{fileMappings:null,fileMappingsTree:null});case __WEBPACK_IMPORTED_MODULE_2__wizard_actions__["h" /* FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE */]:return Object.assign({},state,{fileMappings:null,fileMappingsTree:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (fileMappingListReducer);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares_default_category_scheme_selector_actions__ = __webpack_require__(123);
var fileMappingWizardCubeSelectorReducer=function fileMappingWizardCubeSelectorReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{categorisedCubes:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:[]});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:Object(__WEBPACK_IMPORTED_MODULE_2__utils_treeBuilders__["b" /* getCubesTree */])(action.response[0],action.response[1])});case __WEBPACK_IMPORTED_MODULE_3__middlewares_default_category_scheme_selector_actions__["g" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_3__middlewares_default_category_scheme_selector_actions__["d" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT */]:return Object.assign({},state,{categorisedCubes:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (fileMappingWizardCubeSelectorReducer);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(225);
var fileMappingWizardCsvRowListReducer=function fileMappingWizardCsvRowListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isVisible:false,csvRows:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* FILE_MAPPING_WIZARD_CSV_ROW_LIST_SHOW */]:return Object.assign({},state,{isVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* FILE_MAPPING_WIZARD_CSV_ROW_LIST_HIDE */]:return Object.assign({},state,{isVisible:false,csvRows:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET */]:return Object.assign({},state,{isVisible:false,csvRows:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET */]:return Object.assign({},state,{csvRows:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (fileMappingWizardCsvRowListReducer);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(312);
var fileMappingWizardCsvColValueListReducer=function fileMappingWizardCsvColValueListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{colName:null,colValues:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_SHOW */]:return Object.assign({},state,{colName:action.colName});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_HIDE */]:return Object.assign({},state,{colName:null,colValues:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_COL_VALUES_GET */]:return Object.assign({},state,{colName:null,colValues:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_COL_VALUES_GET */]:return Object.assign({},state,{colValues:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (fileMappingWizardCsvColValueListReducer);

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__csv_form_reducer__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xml_form_reducer__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(226);
var loaderReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({csvForm:__WEBPACK_IMPORTED_MODULE_1__csv_form_reducer__["a" /* default */],xmlForm:__WEBPACK_IMPORTED_MODULE_2__xml_form_reducer__["a" /* default */]}),shared:function shared(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{format:'csv'};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* LOADER_FORMAT_SET */]:return Object.assign({},state,{format:action.format});default:return state;}}});/* harmony default export */ __webpack_exports__["a"] = (loaderReducer);

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapping_control_reducer__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapping_control_actions__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__row_list_reducer__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(226);
var loaderCsvFormReducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({mappingControl:__WEBPACK_IMPORTED_MODULE_2__mapping_control_reducer__["a" /* default */],rowList:__WEBPACK_IMPORTED_MODULE_6__row_list_reducer__["a" /* default */]}),shared:function shared(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{mappingId:null,mapping:null,mappingCube:null,tid:null,separator:null,delimiter:null,hasHeader:false,hasDotStatFormat:null,fileServerPath:null,csvServerPath:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* LOADER_FORMAT_SET */]:return{mappingId:null,mapping:null,mappingCube:null,tid:null,separator:null,delimiter:null,hasHeader:false,hasDotStatFormat:null,fileServerPath:null,csvServerPath:null};case __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* LOADER_CSV_FORM_CHANGE */]:var _$mapValues=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapValues(action.fields,function(field){return field.value;}),mappingId=_$mapValues.mappingId,tid=_$mapValues.tid,separator=_$mapValues.separator,delimiter=_$mapValues.delimiter,hasHeader=_$mapValues.hasHeader,hasDotStatFormat=_$mapValues.hasDotStatFormat,file=_$mapValues.file;return Object.assign({},state,{tid:tid!==undefined?tid:state.tid,separator:separator!==undefined?separator:state.separator,delimiter:delimiter!==undefined?delimiter:state.delimiter,hasHeader:hasHeader!==undefined?hasHeader:state.hasHeader,hasDotStatFormat:hasDotStatFormat!==undefined?hasDotStatFormat:state.hasDotStatFormat,fileServerPath:mappingId!==undefined||file!==undefined||separator!==undefined||delimiter!==undefined||hasHeader!==undefined?null:state.fileServerPath,csvServerPath:mappingId!==undefined||file!==undefined||separator!==undefined||delimiter!==undefined||hasHeader!==undefined?null:state.csvServerPath});case __WEBPACK_IMPORTED_MODULE_3__mapping_control_actions__["h" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET */]:return Object.assign({},state,{mappingId:action.mappingId,tid:null});case __WEBPACK_IMPORTED_MODULE_3__mapping_control_actions__["i" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET */]:return Object.assign({},state,{mappingId:null,mapping:null,mappingCube:null,fileServerPath:null,csvServerPath:null,separator:null,delimiter:null,hasDotStatFormat:null,hasHeader:false,tid:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_3__mapping_control_actions__["l" /* LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ */]:return Object.assign({},state,{tid:null,mapping:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* LOADER_CSV_FORM_FILE_UPLOAD */]:return Object.assign({},state,{fileServerPath:null,csvServerPath:null});case __WEBPACK_IMPORTED_MODULE_3__mapping_control_actions__["j" /* LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ */]:return Object.assign({},state,{tid:null,mappingCube:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_3__mapping_control_actions__["l" /* LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ */]:return Object.assign({},state,{mapping:action.response,separator:action.response.CSVSeparator,delimiter:action.response.CSVDelimiter,hasHeader:action.response.HasHeader,hasDotStatFormat:action.response.HasSpecialTimePeriod});case __WEBPACK_IMPORTED_MODULE_3__mapping_control_actions__["j" /* LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ */]:return Object.assign({},state,{tid:!Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* userMustNotInsertTid */])(state.mapping,action.response)&&state.mapping.Tid!==null?state.mapping.Tid:null,mappingCube:action.response});case __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* LOADER_CSV_FORM_FILE_UPLOAD */]:return Object.assign({},state,{fileServerPath:action.response,csvServerPath:action.format==='csv'?action.response:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* LOADER_CSV_FORM_PX_TO_CSV_CONVERT */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* LOADER_CSV_FORM_XLS_TO_CSV_CONVERT */]:return Object.assign({},state,{csvServerPath:action.response});case __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* LOADER_CSV_FORM_SUBMIT */]:return{mappingId:null,mapping:null,mappingCube:null,tid:null,separator:null,delimiter:null,hasDotStatFormat:null,hasHeader:false,fileServerPath:null,csvServerPath:null};default:return state;}}default:return state;}},local:function local(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{importType:"SeriesAndData",file:null,embargo:{enabled:false,autoReleaseEnabled:false,autoReleaseDate:null,autoReleaseTime:null,refreshProdDf:false},isIgnoreConcurrentUploadConfirmVisible:false,checkFiltAttributes:true};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* LOADER_FORMAT_SET */]:return{importType:"SeriesAndData",file:null,embargo:{enabled:false,autoReleaseEnabled:false,autoReleaseDate:null,autoReleaseTime:null},refreshProdDf:false,checkFiltAttributes:true};case __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* LOADER_CSV_FORM_CHANGE */]:var _$mapValues2=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapValues(action.fields,function(field){return field.value;}),importType=_$mapValues2.importType,file=_$mapValues2.file,embargo=_$mapValues2.embargo,refreshProdDf=_$mapValues2.refreshProdDf,checkFiltAttributes=_$mapValues2.checkFiltAttributes;return Object.assign({},state,{importType:importType!==undefined?importType:state.importType,file:file!==undefined?file:state.file,embargo:embargo!==undefined?embargo:state.embargo,refreshProdDf:refreshProdDf!==undefined?refreshProdDf:state.refreshProdDf,checkFiltAttributes:checkFiltAttributes!==undefined?checkFiltAttributes:state.checkFiltAttributes});case __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE */]:return Object.assign({},state,{isIgnoreConcurrentUploadConfirmVisible:false});case __WEBPACK_IMPORTED_MODULE_3__mapping_control_actions__["i" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET */]:return Object.assign({},state,{tid:null,file:null,embargo:{enabled:false,autoReleaseEnabled:false,autoReleaseDate:null,autoReleaseTime:null},refreshProdDf:false,checkFiltAttributes:true});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* LOADER_CSV_FORM_SUBMIT */]:return Object.assign({},state,{importType:"SeriesAndData",file:null,isVisible:false,refreshProdDf:false,checkFiltAttributes:true});default:return state;}}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* LOADER_CSV_FORM_SUBMIT */]:if(action.error&&action.error.errorCode==="LOADING_CONCURRENT_UPLOAD_SAME_CUBE"){return Object.assign({},state,{isIgnoreConcurrentUploadConfirmVisible:true});}else{return state;}default:return state;}}default:return state;}}});/* harmony default export */ __webpack_exports__["a"] = (loaderCsvFormReducer);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tree__ = __webpack_require__(32);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var loaderCsvFormMappingControlReducer=function loaderCsvFormMappingControlReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isSelectedMappingVisible:false,isMappingsVisible:false,mappingsTree:null,detailMappingId:null,detailMapping:null,detailMappingCube:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET */]:return Object.assign({},state,{isMappingsVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW */]:return Object.assign({},state,{isMappingsVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW */]:return Object.assign({},state,{detailMappingId:action.mappingId});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW */]:return Object.assign({},state,{isSelectedMappingVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE */]:return Object.assign({},state,{isMappingsVisible:false,mappingsTree:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE */]:return Object.assign({},state,{detailMappingId:null,detailMapping:null,detailMappingCube:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE */]:return Object.assign({},state,{isSelectedMappingVisible:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ */]:return Object.assign({},state,{mappingsTree:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ */]:return Object.assign({},state,{detailMapping:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ */]:return Object.assign({},state,{detailMappingCube:null});default:return state;}}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ */]:return Object.assign({},state,{isMappingsVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ */]:return Object.assign({},state,{detailMappingId:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ */]:return Object.assign({},state,{isSelectedMappingVisible:false});default:return state;}}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ */]:var _action$response=_slicedToArray(action.response,3),allCubes=_action$response[0],dcs=_action$response[1],mappings=_action$response[2];var treeWithCategories=Object(__WEBPACK_IMPORTED_MODULE_2__utils_treeBuilders__["b" /* getCubesTree */])(allCubes,dcs);var treeWithCategoriesOrd=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(treeWithCategories,"children",function(node){var ordCount=1;return Object.assign({},node,{TreeID:node.CatCode?'Cat_'+node.CatCode:''+node.Code,children:node.children?node.children.sort(function(a,b){if(a.Ord!==undefined&&b.Ord!==undefined){return a.Ord-b.Ord;}else if(a.Ord!==undefined){return a;}else if(b.Ord!==undefined){return b;}else{return(a.CatCode||-1)-(b.CatCode||-1);}}).map(function(c){return Object.assign({},c,{Ord:c.Ord!==undefined?String(ordCount++):undefined});}):node.children});});var treeWithMappings=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["d" /* getCategorisedObjectsTree */])(mappings.map(function(mapping){return Object.assign({},mapping,{TreeID:'Mapp_'+mapping.IDMapping});}),treeWithCategoriesOrd,"children",function(a,b){return a.IDMapping-b.IDMapping;},function(mapping,cube){if(cube){return cube.IDCube===mapping.IDCube;}else{return true;}},null,null,true);var cleanedTreeWithMappings=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["g" /* getFilteredTreeWithPaths */])(treeWithMappings,"children",function(node){return node.IDMapping||node.children&&node.children.filter(function(_ref){var IDMapping=_ref.IDMapping;return IDMapping;}).length>0;});return Object.assign({},state,{mappingsTree:cleanedTreeWithMappings});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ */]:return Object.assign({},state,{detailMapping:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ */]:return Object.assign({},state,{detailMappingCube:action.response});default:return state;}}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (loaderCsvFormMappingControlReducer);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(314);
var loaderCsvFormRowListReducer=function loaderCsvFormRowListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isVisible:false,csvRows:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* LOADER_CSV_FORM_ROW_LIST_SHOW */]:return Object.assign({},state,{isVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* LOADER_CSV_FORM_ROW_LIST_HIDE */]:return Object.assign({},state,{isVisible:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* LOADER_CSV_FORM_ROW_LIST_CSV_ROWS_GET */]:return Object.assign({},state,{isVisible:false,csvRows:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* LOADER_CSV_FORM_ROW_LIST_CSV_ROWS_GET */]:return Object.assign({},state,{csvRows:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (loaderCsvFormRowListReducer);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__row_list_reducer__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_default_category_scheme_selector_actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(226);
var loaderXmlFormReducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({rowList:__WEBPACK_IMPORTED_MODULE_0__row_list_reducer__["a" /* default */]}),shared:function shared(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{cube:null,filePath:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* LOADER_FORMAT_SET */]:return Object.assign({},state,{filePath:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* LOADER_XML_FORM_CUBE_UNSET */]:return Object.assign({},state,{cube:null,filePath:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* LOADER_XML_FORM_CHANGE */]:var _$mapValues=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(action.fields,function(field){return field.value;}),file=_$mapValues.file;return Object.assign({},state,{filePath:file!==undefined?null:state.filePath});case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* LOADER_XML_FORM_FILE_UPLOAD */]:return Object.assign({},state,{filePath:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* LOADER_XML_FORM_FILE_UPLOAD */]:return Object.assign({},state,{filePath:action.response});case __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* LOADER_XML_FORM_SUBMIT */]:return Object.assign({},state,{filePath:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* LOADER_XML_FORM_CUBE_READ */]:return Object.assign({},state,{cube:action.response});default:return state;}default:return state;}},local:function local(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{cubeId:null,tid:null,importType:'SeriesAndData',file:null,categorisedCubes:null,isCubeTreeVisible:false,embargo:{enabled:false,autoReleaseEnabled:false,autoReleaseDate:null,autoReleaseTime:null},refreshProdDf:false,checkFiltAttributes:true,isIgnoreConcurrentUploadConfirmVisible:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* LOADER_FORMAT_SET */]:return Object.assign({},state,{cubeId:null,tid:null,importType:'SeriesAndData',file:null,categorisedCubes:null,isCubeTreeVisible:false,embargo:{enabled:false,autoReleaseEnabled:false,autoReleaseDate:null,autoReleaseTime:null},refreshProdDf:false,checkFiltAttributes:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* LOADER_XML_FORM_CUBE_TREE_SHOW */]:return Object.assign({},state,{isCubeTreeVisible:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* LOADER_XML_FORM_CUBE_TREE_HIDE */]:return Object.assign({},state,{isCubeTreeVisible:false,categorisedCubes:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* LOADER_XML_FORM_CHANGE */]:var _$mapValues2=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(action.fields,function(field){return field.value;}),tid=_$mapValues2.tid,importType=_$mapValues2.importType,file=_$mapValues2.file,embargo=_$mapValues2.embargo,refreshProdDf=_$mapValues2.refreshProdDf,checkFiltAttributes=_$mapValues2.checkFiltAttributes;return Object.assign({},state,{tid:tid!==undefined?tid:state.tid,importType:importType!==undefined?importType:state.importType,file:file!==undefined?file:state.file,embargo:embargo!==undefined?embargo:state.embargo,refreshProdDf:refreshProdDf!==undefined?refreshProdDf:state.refreshProdDf,checkFiltAttributes:checkFiltAttributes!==undefined?checkFiltAttributes:state.checkFiltAttributes});case __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* LOADER_XML_FORM_CUBE_SET */]:return Object.assign({},state,{cubeId:action.cubeId,isCubeTreeVisible:false,categorisedCubes:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* LOADER_XML_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE */]:return Object.assign({},state,{isIgnoreConcurrentUploadConfirmVisible:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* LOADER_XML_FORM_CUBE_UNSET */]:return Object.assign({},state,{cubeId:null,tid:null,file:null,embargo:{enabled:false,autoReleaseEnabled:false,autoReleaseDate:null,autoReleaseTime:null},refreshProdDf:false,checkFiltAttributes:true});case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["g" /* REQUEST_START */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* LOADER_XML_FORM_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:null});default:return state;}}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["b" /* REQUEST_ERROR */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* LOADER_XML_FORM_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{isCubeTreeVisible:false,categorisedCubes:[]});case __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* LOADER_XML_FORM_SUBMIT */]:if(action.error&&action.error.errorCode==="LOADING_CONCURRENT_UPLOAD_SAME_CUBE"){return Object.assign({},state,{isIgnoreConcurrentUploadConfirmVisible:true});}else{return state;}default:return state;}}case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* LOADER_XML_FORM_SUBMIT */]:return Object.assign({},state,{cubeId:null,importType:'SeriesAndData',file:null,categorisedCubes:null,isCubeTreeVisible:false,refreshProdDf:false,checkFiltAttributes:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* LOADER_XML_FORM_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:Object(__WEBPACK_IMPORTED_MODULE_5__utils_treeBuilders__["b" /* getCubesTree */])(action.response[0],action.response[1])});case __WEBPACK_IMPORTED_MODULE_6__middlewares_default_category_scheme_selector_actions__["g" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_6__middlewares_default_category_scheme_selector_actions__["d" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT */]:return Object.assign({},state,{categorisedCubes:null});default:return state;}}default:return state;}}});/* harmony default export */ __webpack_exports__["a"] = (loaderXmlFormReducer);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(315);
var loaderXmlFormRowListReducer=function loaderXmlFormRowListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isVisible:false,rows:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* LOADER_XML_ROW_LIST_SHOW */]:return Object.assign({},state,{isVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* LOADER_XML_ROW_LIST_HIDE */]:return Object.assign({},state,{isVisible:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* LOADER_XML_ROW_LIST_ROWS_READ */]:return Object.assign({},state,{isVisible:false,rows:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* LOADER_XML_ROW_LIST_ROWS_READ */]:return Object.assign({},state,{rows:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (loaderXmlFormRowListReducer);

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tree__ = __webpack_require__(32);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var cubeListReducer=function cubeListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{cubes:null,cube:null,cubeId:null,cubeDownloadId:null,currentDataView:null,isCubeDetailVisible:false,isCubeDownloadVisible:false,filter:null,filterTemp:null,treeFilter:{},treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],isRowsModalVisible:null,rows:null,cols:null,checkedCols:null,cubeOwnershipCubeId:null,cubeOwnershipOwners:null,cubeOwnershipUsers:null,isCubeDownloadFilterModalVisible:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* CUBE_LIST_CURRENT_DATA_VIEW_SHOW */]:return Object.assign({},state,{cubeId:action.cubeId,isCubeDetailVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* CUBE_LIST_CURRENT_DATA_VIEW_HIDE */]:return Object.assign({},state,{cubeId:null,cube:null,currentDataView:null,isCubeDetailVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* CUBE_LIST_CUBE_OWNERSHIP_SHOW */]:return Object.assign({},state,{cubeOwnershipCubeId:action.cubeId});case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* CUBE_LIST_CUBE_OWNERSHIP_HIDE */]:return Object.assign({},state,{cubeOwnershipCubeId:null,cubeOwnershipOwners:null,cubeOwnershipUsers:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* CUBE_LIST_CUBE_DOWNLOAD_SHOW */]:return Object.assign({},state,{cubeDownloadId:action.cubeId,isCubeDownloadVisible:true,filter:null,filterTemp:null,treeFilter:{},treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* CUBE_LIST_CUBE_DOWNLOAD_HIDE */]:return Object.assign({},state,{cube:null,cubeId:null,cubeDownloadId:null,currentDataView:null,isCubeDetailVisible:false,isCubeDownloadVisible:false,filter:null,filterTemp:null,treeFilter:{},treeFilterTemp:{},filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],isRowsModalVisible:null,rows:null,cols:null,checkedCols:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CHANGE */]:{if(action.fields.cubeColumns!==undefined){var columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube.columns);return Object.assign({},state,{cube:Object.assign({},state.cube,{columns:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(columns,action.fields.cubeColumns.value)})});}else if(action.fields.filter!==undefined){var filter=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filter);if(action.fields.filter.filter(function(block){return block.column!==undefined;}).length>0){action.fields.filter=action.fields.filter.map(function(block){return Object.assign({},block,{conditions:null});});}return Object.assign({},state,{filter:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(filter,action.fields.filter)});}else{return state;}}case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_ADD */]:{var block={column:null,logicalOperator:'OR',conditions:null};return Object.assign({},state,{filterTemp:state.filterTemp!==null?[].concat(_toConsumableArray(state.filterTemp),[block]):[block]});}case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_BLOCK_DELETE */]:{var filterTemp=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filterTemp);filterTemp.splice(action.blockIndex,1);return Object.assign({},state,{filterTemp:filterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_ADD */]:{var _filterTemp=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filterTemp);var condition={comparisonOperator:null,value:null};if(_filterTemp[action.blockIndex].conditions!==null){_filterTemp[action.blockIndex].conditions.push(condition);}else{_filterTemp[action.blockIndex].conditions=[condition];}return Object.assign({},state,{filterTemp:_filterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_CONDITION_DELETE */]:{var _filterTemp2=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filterTemp);_filterTemp2[action.blockIndex].conditions.splice(action.conditionIndex,1);return Object.assign({},state,{filterTemp:_filterTemp2});}case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_SHOW */]:return Object.assign({},state,{isRowsModalVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_MODAL_HIDE */]:return Object.assign({},state,{rows:null,isRowsModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHECK */]:return Object.assign({},state,{checkedCols:action.cols});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CUBE_LIST_CUBE_DOWNLOAD_CUBE_COLUMNS_CHANGE */]:return Object.assign({},state,{cols:action.cols});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* CUBE_LIST_CUBE_OWNERSHIP_OWNERS_CHANGE */]:return Object.assign({},state,{cubeOwnershipOwners:action.owners});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SHOW */]:return Object.assign({},state,{isCubeDownloadFilterModalVisible:true,filterTemp:state.filter,treeFilterTemp:state.treeFilter||{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_HIDE */]:return Object.assign({},state,{isCubeDownloadFilterModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_SUBMIT */]:return Object.assign({},state,{isCubeDownloadFilterModalVisible:false,filter:state.filterMode===__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?action.filter:state.filter,filterTemp:null,treeFilter:state.filterMode===__WEBPACK_IMPORTED_MODULE_5__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]?action.filter:state.treeFilter,treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_RESET */]:return Object.assign({},state,{filterTemp:[],treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_MODE_CHANGE */]:return Object.assign({},state,{filterMode:action.filterMode,filterTemp:[],treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_FILTER_CHANGE */]:{var _filterTemp3=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.filterTemp);if(action.fields.filter.filter(function(block){return block.column!==undefined;}).length>0){action.fields.filter=action.fields.filter.map(function(block){return Object.assign({},block,{conditions:null});});}return Object.assign({},state,{filterTemp:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(_filterTemp3,action.fields.filter)});}case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_CHANGE */]:return Object.assign({},state,{treeFilterTemp:action.treeFilter});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE */]:{var cube=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);var treeFilterTemp=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.treeFilterTemp);treeFilterTemp[action.colName]={mode:action.mode,values:treeFilterTemp[action.colName]&&treeFilterTemp[action.colName].values?treeFilterTemp[action.colName].values:[]};var colNames=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatten(Object.keys(state.cube.columns).map(function(key){return state.cube.columns[key];})).map(function(_ref){var name=_ref.name;return name;});var colIndex=colNames.indexOf(action.colName);var subsequentColNames=colNames.splice(colIndex+1);// delete filters for subsequent cols
subsequentColNames.forEach(function(name){delete treeFilterTemp[name];});// delete filteredCodelistTree for subsequent cols
cube.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(cube.columns,function(colArr){return colArr.map(function(col){return subsequentColNames.includes(col.name)?Object.assign({},col,{filteredCodelistTree:null}):col;});});return Object.assign({},state,{cube:cube,treeFilterTemp:treeFilterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE */]:{var _treeFilterTemp=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.treeFilterTemp);_treeFilterTemp[action.colName]={mode:_treeFilterTemp[action.colName]&&_treeFilterTemp[action.colName].mode?_treeFilterTemp[action.colName].mode:__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["n" /* FILTER_MODE_IN */],values:action.values};var _colNames=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatten(Object.keys(state.cube.columns).map(function(key){return state.cube.columns[key];})).map(function(_ref2){var name=_ref2.name;return name;});var _colIndex=_colNames.indexOf(action.colName);var _subsequentColNames=_colNames.splice(_colIndex+1);// delete filters for subsequent cols
_subsequentColNames.forEach(function(name){delete _treeFilterTemp[name];});return Object.assign({},state,{cube:Object.assign({},state.cube,{columns:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(state.cube.columns,function(colArr){return(// delete filteredCodelistTree for subsequent cols
colArr.map(function(col){if(_subsequentColNames.includes(col.name)){return Object.assign({},col,{filteredCodelistTree:null});}else{return col;}}));})}),treeFilterTemp:_treeFilterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_RESET */]:{var _cube=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{values:null,valuesCount:null}):col;});});return Object.assign({},state,{cube:_cube});}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CUBE_LIST_CUBES_READ */]:return Object.assign({},state,{cubes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CUBE_LIST_CUBE_DOWNLOAD_CUBE_READ */]:return Object.assign({},state,{cube:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_READ */]:return Object.assign({},state,{rows:null,isRowsModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* CUBE_LIST_CURRENT_DATA_VIEW_READ */]:return Object.assign({},state,{cubeId:null,cube:null,currentDataView:null,isCubeDetailVisible:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CUBE_LIST_CUBES_READ */]:return Object.assign({},state,{cubes:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* CUBE_LIST_CUBE_OWNERSHIP_OWNERS_READ */]:return Object.assign({},state,{cubeOwnershipOwners:action.response.owners.map(function(_ref3){var username=_ref3.username;return username;})});case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* CUBE_LIST_CUBE_OWNERSHIP_USERS_READ */]:return Object.assign({},state,{cubeOwnershipUsers:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* CUBE_LIST_CUBE_OWNERSHIP_OWNERS_SUBMIT */]:return Object.assign({},state,{cubeOwnershipCubeId:null,cubeOwnershipOwners:null,cubeOwnershipUsers:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* CUBE_LIST_CUBE_EMBARGO_REMOVE */]:return Object.assign({},state,{cubes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* CUBE_LIST_CURRENT_DATA_VIEW_READ */]:return Object.assign({},state,{currentDataView:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* CUBE_LIST_CUBE_DOWNLOAD_CUBE_READ */]:var _cube2=action.response;var _columns={dimensions:_cube2.Dimensions.filter(function(dim){return!dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{name:dim.ColName,checked:true,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),timeDimensions:_cube2.Dimensions.filter(function(dim){return dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{name:dim.ColName,checked:true,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),tidAttributes:_cube2.Attributes.filter(function(attr){return attr.IsTid;}).map(function(attr){return Object.assign({},attr,{name:attr.ColName,checked:true,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),attributes:_cube2.Attributes.filter(function(attr){return!attr.IsTid;}).map(function(attr){return Object.assign({},attr,{name:attr.ColName,checked:true,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});}),measures:_cube2.Measures.map(function(meas){return Object.assign({},meas,{name:meas.ColName,checked:true,disabled:false,isNumeric:true});})};var columnsStr=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatten(Object.keys(_columns).map(function(key){return _columns[key];})).filter(function(col){return col.checked;}).map(function(col){return col.name;});return Object.assign({},state,{cube:Object.assign({},_cube2,{columns:_columns}),cols:columnsStr,checkedCols:columnsStr});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_VALUES_READ */]:{var columnValues=action.response.Data.map(function(val){return val[action.columnName];});var _cube3=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube3.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube3.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{values:col.codes?col.codes.filter(function(_ref4){var id=_ref4.id;return columnValues.filter(function(val){return val===id;}).length;}):columnValues.map(function(val){return _defineProperty({},action.columnName,val);}),valuesCount:action.response.Count}):col;});});return Object.assign({},state,{cube:_cube3});}case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* CUBE_LIST_CUBE_DOWNLOAD_WHERE_CONDITIONS_FORM_COLUMN_CODES_READ */]:{var codes=Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes;var _cube4=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube4.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube4.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{codes:codes}):col;});});return Object.assign({},state,{cube:_cube4});}case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* CUBE_LIST_CUBE_DOWNLOAD_PREVIEW_ROWS_READ */]:return Object.assign({},state,{rows:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CUBE_LIST_CUBE_DOWNLOAD_CSV_READ */]:return Object.assign({},state,{cube:null,cubeId:null,cubeDownloadId:null,currentDataView:null,isCubeDetailVisible:false,isCubeDownloadVisible:false,filter:null,treeFilter:{},treeFilterTemp:{},isRowsModalVisible:null,rows:null,cols:null,checkedCols:null,filterMode:__WEBPACK_IMPORTED_MODULE_5__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* CUBE_LIST_CUBE_EMPTY_CUBE_SUBMIT */]:return Object.assign({},state,{cubes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CUBE_LIST_CUBE_DELETE_SUBMIT */]:return Object.assign({},state,{cubes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ */]:{var _cube5=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube5.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube5.columns,function(colArr){return colArr.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistCount:Number(action.header["x-total-count"])}):col;});});return Object.assign({},state,{cube:_cube5});}case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ */]:{var codelist=Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var itemsTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["n" /* getTreeFromArray */])(codelist.codes||[],"codes");var _cube6=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube6.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube6.columns,function(colArr){return colArr.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistTree:itemsTree}):col;});});return Object.assign({},state,{cube:_cube6});}case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* CUBE_LIST_CUBE_DOWNLOAD_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ */]:{var filteredValues=action.response.Data.map(function(obj){return obj[action.colName];});var _cube7=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.cube);_cube7.columns=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_cube7.columns,function(colArr){return colArr.map(function(col){if(col.name===action.colName){var filteredCodelistTree=col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["g" /* getFilteredTreeWithPaths */])(col.codelistTree||[],"codes",function(_ref6){var id=_ref6.id;return filteredValues.includes(id);}):null;return Object.assign({},col,{filteredCodelistTree:filteredCodelistTree,filteredValues:filteredValues,filteredCodelistTreeMaxDepth:col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_6__utils_tree__["j" /* getMaxTreeDepth */])(filteredCodelistTree,"codes"):null});}else return col;});});return Object.assign({},state,{cube:_cube7});}default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (cubeListReducer);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_css__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_cube_component_list__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
var mapPropsToFields=function mapPropsToFields(_ref){var appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,dataLanguage=_ref.dataLanguage,cube=_ref.cube;return{cubeId:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:cube!==null?'['+cube.Code+'] '+Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_i18n_utils__["a" /* getLocalizedStr */])(cube.labels,dataLanguage||appLanguage,dataLanguages):null}),cubeColumns:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:cube!==null?cube.columns:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onColumnsChange(fields);};var QueryColumnsForm=function QueryColumnsForm(_ref2){var t=_ref2.t,form=_ref2.form,appLanguage=_ref2.appLanguage,dataLanguages=_ref2.dataLanguages,categorisedCubes=_ref2.categorisedCubes,ddbDataflowId=_ref2.ddbDataflowId,ddbDataflow=_ref2.ddbDataflow,cubeId=_ref2.cubeId,cube=_ref2.cube,cubeFirstRow=_ref2.cubeFirstRow,isCubeTreeVisible=_ref2.isCubeTreeVisible,onCubeTreeShow=_ref2.onCubeTreeShow,onCubeTreeHide=_ref2.onCubeTreeHide,onCubeSet=_ref2.onCubeSet,onCubeUnset=_ref2.onCubeUnset,fetchDdbDataflow=_ref2.fetchDdbDataflow,fetchCube=_ref2.fetchCube,fetchCubeFirstRow=_ref2.fetchCubeFirstRow,fetchCategorisedCubes=_ref2.fetchCategorisedCubes,disabled=_ref2.disabled,uncheckableDims=_ref2.uncheckableDims;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__hocs_call__["a" /* default */],{cb:fetchDdbDataflow,cbParam:ddbDataflowId,disabled:ddbDataflowId===null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__hocs_call__["a" /* default */],{cb:fetchCube,cbParam:cubeId,disabled:ddbDataflowId!==null&&ddbDataflow===null||cubeId===null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__hocs_call__["a" /* default */],{cb:fetchCubeFirstRow,cbParam:{cubeId:cubeId,cubeColumns:cube!==null?__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(col){return col.name;}):null},disabled:cubeId===null||cube===null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_enhanced_modal__["a" /* default */],{visible:isCubeTreeVisible,title:t('scenes.dataManager.dataflowBuilder.wizard.query.columnsForm.cubeTreeModal.title'),footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:onCubeTreeHide},t('commons.buttons.close.title')),onCancel:onCubeTreeHide,withDataLanguageSelector:true,width:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MODAL_WIDTH_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__hocs_call__["a" /* default */],{cb:fetchCategorisedCubes,disabled:categorisedCubes!==null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'query__cube-columns-form__tree'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__enhanced_tree__["a" /* default */],{tree:categorisedCubes,idKey:'Code',childrenKey:'children',nameKey:'labels',catIdKey:'CatCode',catNameKey:'labels',unselectableKeys:Object(__WEBPACK_IMPORTED_MODULE_17__utils_tree__["l" /* getNodes */])(categorisedCubes,'children',function(node){return node.children;}).map(function(node){return node.CatCode;}),hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_18__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode,__WEBPACK_IMPORTED_MODULE_17__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],getFilter:function getFilter(searchText){return function(_ref3){var Code=_ref3.Code,CatCode=_ref3.CatCode,labels=_ref3.labels;var search=searchText.toLowerCase();return Code&&Code.toLowerCase().indexOf(search)>=0||CatCode&&CatCode.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},onSelect:function onSelect(selectedArr){var node=Object(__WEBPACK_IMPORTED_MODULE_17__utils_tree__["k" /* getNode */])(categorisedCubes,'children',function(node){return node.children?node.CatCode===selectedArr[0]:node.Code===selectedArr[0];});if(node!==null&&node.children===undefined){onCubeSet(node.IDCube);}else{onCubeUnset();}},treeActions:[{title:t('scenes.dataManager.dataflowBuilder.wizard.query.columnsForm.cubeTreeModal.tree.refreshButton.title'),icon:'sync',onClick:fetchCategorisedCubes}],icon:'cube',isCustomIcon:true,getIconColor:function getIconColor(){return"#37a0f4";},searchBarSpan:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_HALF"]})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{className:'form-item-required'},form.getFieldDecorator('cubeId')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__selector__["a" /* default */],{selectTitle:t('scenes.dataManager.dataflowBuilder.wizard.query.columnsForm.fields.cube.selectIcon.title'),resetTitle:t('scenes.dataManager.dataflowBuilder.wizard.query.columnsForm.fields.cube.resetIcon.title'),onSelect:onCubeTreeShow,onReset:onCubeUnset,onDetail:null,disabled:disabled}))))),cube!==null&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',style:{marginTop:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',bodyStyle:{height:391,overflow:'auto'}},form.getFieldDecorator('cubeColumns')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_cube_component_list__["a" /* default */],{uncheckableDims:uncheckableDims,labelKey:'ColName',checkboxDisabled:disabled||cubeFirstRow===undefined||cubeFirstRow===null}))))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(QueryColumnsForm));

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1009);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(1011);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["default"],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverflowOptions = getOverflowOptions;
exports["default"] = getPlacements;

var _placements = __webpack_require__(1013);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var autoAdjustOverflowEnabled = {
  adjustX: 1,
  adjustY: 1
};
var autoAdjustOverflowDisabled = {
  adjustX: 0,
  adjustY: 0
};
var targetOffset = [0, 0];

function getOverflowOptions(autoAdjustOverflow) {
  if (typeof autoAdjustOverflow === 'boolean') {
    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }

  return _extends({}, autoAdjustOverflowDisabled, autoAdjustOverflow);
}

function getPlacements() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$arrowWidth = config.arrowWidth,
      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
      _config$horizontalArr = config.horizontalArrowShift,
      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
      _config$verticalArrow = config.verticalArrowShift,
      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
      _config$autoAdjustOve = config.autoAdjustOverflow,
      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
  var placementMap = {
    left: {
      points: ['cr', 'cl'],
      offset: [-4, 0]
    },
    right: {
      points: ['cl', 'cr'],
      offset: [4, 0]
    },
    top: {
      points: ['bc', 'tc'],
      offset: [0, -4]
    },
    bottom: {
      points: ['tc', 'bc'],
      offset: [0, 4]
    },
    topLeft: {
      points: ['bl', 'tc'],
      offset: [-(horizontalArrowShift + arrowWidth), -4]
    },
    leftTop: {
      points: ['tr', 'cl'],
      offset: [-4, -(verticalArrowShift + arrowWidth)]
    },
    topRight: {
      points: ['br', 'tc'],
      offset: [horizontalArrowShift + arrowWidth, -4]
    },
    rightTop: {
      points: ['tl', 'cr'],
      offset: [4, -(verticalArrowShift + arrowWidth)]
    },
    bottomRight: {
      points: ['tr', 'bc'],
      offset: [horizontalArrowShift + arrowWidth, 4]
    },
    rightBottom: {
      points: ['bl', 'cr'],
      offset: [4, verticalArrowShift + arrowWidth]
    },
    bottomLeft: {
      points: ['tl', 'bc'],
      offset: [-(horizontalArrowShift + arrowWidth), 4]
    },
    leftBottom: {
      points: ['br', 'cl'],
      offset: [-4, verticalArrowShift + arrowWidth]
    }
  };
  Object.keys(placementMap).forEach(function (key) {
    placementMap[key] = config.arrowPointAtCenter ? _extends({}, placementMap[key], {
      overflow: getOverflowOptions(autoAdjustOverflow),
      targetOffset: targetOffset
    }) : _extends({}, _placements.placements[key], {
      overflow: getOverflowOptions(autoAdjustOverflow)
    });
    placementMap[key].ignoreShake = true;
  });
  return placementMap;
}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = exports.placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tree__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TreeNode__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return __WEBPACK_IMPORTED_MODULE_1__TreeNode__["a"]; });



__WEBPACK_IMPORTED_MODULE_0__Tree__["a" /* default */].TreeNode = __WEBPACK_IMPORTED_MODULE_1__TreeNode__["a" /* default */];


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tree__["a" /* default */]);

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Children_toArray__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__contextTypes__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util__ = __webpack_require__(461);
















var Tree = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Tree, _React$Component);

  function Tree() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tree);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Tree.__proto__ || Object.getPrototypeOf(Tree)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // TODO: Remove this eslint
      posEntities: {}, // eslint-disable-line react/no-unused-state
      keyEntities: {},

      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],

      treeNode: []
    }, _this.onNodeDragStart = function (event, node) {
      var expandedKeys = _this.state.expandedKeys;
      var onDragStart = _this.props.onDragStart;
      var _node$props = node.props,
          eventKey = _node$props.eventKey,
          children = _node$props.children;


      _this.dragNode = node;

      _this.setState({
        dragNodesKeys: Object(__WEBPACK_IMPORTED_MODULE_13__util__["j" /* getDragNodesKeys */])(children, node),
        expandedKeys: Object(__WEBPACK_IMPORTED_MODULE_13__util__["b" /* arrDel */])(expandedKeys, eventKey)
      });

      if (onDragStart) {
        onDragStart({ event: event, node: node });
      }
    }, _this.onNodeDragEnter = function (event, node) {
      var expandedKeys = _this.state.expandedKeys;
      var onDragEnter = _this.props.onDragEnter;
      var _node$props2 = node.props,
          pos = _node$props2.pos,
          eventKey = _node$props2.eventKey;


      if (!_this.dragNode) return;

      var dropPosition = Object(__WEBPACK_IMPORTED_MODULE_13__util__["c" /* calcDropPosition */])(event, node);

      // Skip if drag node is self
      if (_this.dragNode.props.eventKey === eventKey && dropPosition === 0) {
        _this.setState({
          dragOverNodeKey: '',
          dropPosition: null
        });
        return;
      }

      // Ref: https://github.com/react-component/tree/issues/132
      // Add timeout to let onDragLevel fire before onDragEnter,
      // so that we can clean drag props for onDragLeave node.
      // Macro task for this:
      // https://html.spec.whatwg.org/multipage/webappapis.html#clean-up-after-running-script
      setTimeout(function () {
        // Update drag over node
        _this.setState({
          dragOverNodeKey: eventKey,
          dropPosition: dropPosition
        });

        // Side effect for delay drag
        if (!_this.delayedDragEnterLogic) {
          _this.delayedDragEnterLogic = {};
        }
        Object.keys(_this.delayedDragEnterLogic).forEach(function (key) {
          clearTimeout(_this.delayedDragEnterLogic[key]);
        });
        _this.delayedDragEnterLogic[pos] = setTimeout(function () {
          var newExpandedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["a" /* arrAdd */])(expandedKeys, eventKey);
          if (!('expandedKeys' in _this.props)) {
            _this.setState({
              expandedKeys: newExpandedKeys
            });
          }

          if (onDragEnter) {
            onDragEnter({ event: event, node: node, expandedKeys: newExpandedKeys });
          }
        }, 400);
      }, 0);
    }, _this.onNodeDragOver = function (event, node) {
      var onDragOver = _this.props.onDragOver;
      var eventKey = node.props.eventKey;

      // Update drag position

      if (_this.dragNode && eventKey === _this.state.dragOverNodeKey) {
        var dropPosition = Object(__WEBPACK_IMPORTED_MODULE_13__util__["c" /* calcDropPosition */])(event, node);

        if (dropPosition === _this.state.dropPosition) return;

        _this.setState({
          dropPosition: dropPosition
        });
      }

      if (onDragOver) {
        onDragOver({ event: event, node: node });
      }
    }, _this.onNodeDragLeave = function (event, node) {
      var onDragLeave = _this.props.onDragLeave;


      _this.setState({
        dragOverNodeKey: ''
      });

      if (onDragLeave) {
        onDragLeave({ event: event, node: node });
      }
    }, _this.onNodeDragEnd = function (event, node) {
      var onDragEnd = _this.props.onDragEnd;

      _this.setState({
        dragOverNodeKey: ''
      });
      if (onDragEnd) {
        onDragEnd({ event: event, node: node });
      }

      _this.dragNode = null;
    }, _this.onNodeDrop = function (event, node) {
      var _this$state = _this.state,
          _this$state$dragNodes = _this$state.dragNodesKeys,
          dragNodesKeys = _this$state$dragNodes === undefined ? [] : _this$state$dragNodes,
          dropPosition = _this$state.dropPosition;
      var onDrop = _this.props.onDrop;
      var _node$props3 = node.props,
          eventKey = _node$props3.eventKey,
          pos = _node$props3.pos;


      _this.setState({
        dragOverNodeKey: ''
      });

      if (dragNodesKeys.indexOf(eventKey) !== -1) {
        __WEBPACK_IMPORTED_MODULE_9_warning___default()(false, 'Can not drop to dragNode(include it\'s children node)');
        return;
      }

      var posArr = Object(__WEBPACK_IMPORTED_MODULE_13__util__["o" /* posToArr */])(pos);

      var dropResult = {
        event: event,
        node: node,
        dragNode: _this.dragNode,
        dragNodesKeys: dragNodesKeys.slice(),
        dropPosition: dropPosition + Number(posArr[posArr.length - 1])
      };

      if (dropPosition !== 0) {
        dropResult.dropToGap = true;
      }

      if (onDrop) {
        onDrop(dropResult);
      }

      _this.dragNode = null;
    }, _this.onNodeClick = function (e, treeNode) {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e, treeNode);
      }
    }, _this.onNodeDoubleClick = function (e, treeNode) {
      var onDoubleClick = _this.props.onDoubleClick;

      if (onDoubleClick) {
        onDoubleClick(e, treeNode);
      }
    }, _this.onNodeSelect = function (e, treeNode) {
      var selectedKeys = _this.state.selectedKeys;
      var keyEntities = _this.state.keyEntities;
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          multiple = _this$props.multiple;
      var _treeNode$props = treeNode.props,
          selected = _treeNode$props.selected,
          eventKey = _treeNode$props.eventKey;

      var targetSelected = !selected;

      // Update selected keys
      if (!targetSelected) {
        selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["b" /* arrDel */])(selectedKeys, eventKey);
      } else if (!multiple) {
        selectedKeys = [eventKey];
      } else {
        selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["a" /* arrAdd */])(selectedKeys, eventKey);
      }

      // [Legacy] Not found related usage in doc or upper libs
      var selectedNodes = selectedKeys.map(function (key) {
        var entity = keyEntities[key];
        if (!entity) return null;

        return entity.node;
      }).filter(function (node) {
        return node;
      });

      _this.setUncontrolledState({ selectedKeys: selectedKeys });

      if (onSelect) {
        var eventObj = {
          event: 'select',
          selected: targetSelected,
          node: treeNode,
          selectedNodes: selectedNodes,
          nativeEvent: e.nativeEvent
        };
        onSelect(selectedKeys, eventObj);
      }
    }, _this.onNodeCheck = function (e, treeNode, checked) {
      var _this$state2 = _this.state,
          keyEntities = _this$state2.keyEntities,
          oriCheckedKeys = _this$state2.checkedKeys,
          oriHalfCheckedKeys = _this$state2.halfCheckedKeys;
      var _this$props2 = _this.props,
          checkStrictly = _this$props2.checkStrictly,
          onCheck = _this$props2.onCheck;
      var eventKey = treeNode.props.eventKey;

      // Prepare trigger arguments

      var checkedObj = void 0;
      var eventObj = {
        event: 'check',
        node: treeNode,
        checked: checked,
        nativeEvent: e.nativeEvent
      };

      if (checkStrictly) {
        var checkedKeys = checked ? Object(__WEBPACK_IMPORTED_MODULE_13__util__["a" /* arrAdd */])(oriCheckedKeys, eventKey) : Object(__WEBPACK_IMPORTED_MODULE_13__util__["b" /* arrDel */])(oriCheckedKeys, eventKey);
        var halfCheckedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["b" /* arrDel */])(oriHalfCheckedKeys, eventKey);
        checkedObj = { checked: checkedKeys, halfChecked: halfCheckedKeys };

        eventObj.checkedNodes = checkedKeys.map(function (key) {
          return keyEntities[key];
        }).filter(function (entity) {
          return entity;
        }).map(function (entity) {
          return entity.node;
        });

        _this.setUncontrolledState({ checkedKeys: checkedKeys });
      } else {
        var _conductCheck = Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* conductCheck */])([eventKey], checked, keyEntities, {
          checkedKeys: oriCheckedKeys, halfCheckedKeys: oriHalfCheckedKeys
        }),
            _checkedKeys = _conductCheck.checkedKeys,
            _halfCheckedKeys = _conductCheck.halfCheckedKeys;

        checkedObj = _checkedKeys;

        // [Legacy] This is used for `rc-tree-select`
        eventObj.checkedNodes = [];
        eventObj.checkedNodesPositions = [];
        eventObj.halfCheckedKeys = _halfCheckedKeys;

        _checkedKeys.forEach(function (key) {
          var entity = keyEntities[key];
          if (!entity) return;

          var node = entity.node,
              pos = entity.pos;


          eventObj.checkedNodes.push(node);
          eventObj.checkedNodesPositions.push({ node: node, pos: pos });
        });

        _this.setUncontrolledState({
          checkedKeys: _checkedKeys,
          halfCheckedKeys: _halfCheckedKeys
        });
      }

      if (onCheck) {
        onCheck(checkedObj, eventObj);
      }
    }, _this.onNodeLoad = function (treeNode) {
      return new Promise(function (resolve) {
        // We need to get the latest state of loading/loaded keys
        _this.setState(function (_ref2) {
          var _ref2$loadedKeys = _ref2.loadedKeys,
              loadedKeys = _ref2$loadedKeys === undefined ? [] : _ref2$loadedKeys,
              _ref2$loadingKeys = _ref2.loadingKeys,
              loadingKeys = _ref2$loadingKeys === undefined ? [] : _ref2$loadingKeys;
          var _this$props3 = _this.props,
              loadData = _this$props3.loadData,
              onLoad = _this$props3.onLoad;
          var eventKey = treeNode.props.eventKey;


          if (!loadData || loadedKeys.indexOf(eventKey) !== -1 || loadingKeys.indexOf(eventKey) !== -1) {
            // react 15 will warn if return null
            return {};
          }

          // Process load data
          var promise = loadData(treeNode);
          promise.then(function () {
            var newLoadedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["a" /* arrAdd */])(_this.state.loadedKeys, eventKey);
            var newLoadingKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["b" /* arrDel */])(_this.state.loadingKeys, eventKey);

            // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
            // https://github.com/ant-design/ant-design/issues/12464
            if (onLoad) {
              var eventObj = {
                event: 'load',
                node: treeNode
              };
              onLoad(newLoadedKeys, eventObj);
            }

            _this.setUncontrolledState({
              loadedKeys: newLoadedKeys
            });
            _this.setState({
              loadingKeys: newLoadingKeys
            });

            resolve();
          });

          return {
            loadingKeys: Object(__WEBPACK_IMPORTED_MODULE_13__util__["a" /* arrAdd */])(loadingKeys, eventKey)
          };
        });
      });
    }, _this.onNodeExpand = function (e, treeNode) {
      var expandedKeys = _this.state.expandedKeys;
      var _this$props4 = _this.props,
          onExpand = _this$props4.onExpand,
          loadData = _this$props4.loadData;
      var _treeNode$props2 = treeNode.props,
          eventKey = _treeNode$props2.eventKey,
          expanded = _treeNode$props2.expanded;

      // Update selected keys

      var index = expandedKeys.indexOf(eventKey);
      var targetExpanded = !expanded;

      __WEBPACK_IMPORTED_MODULE_9_warning___default()(expanded && index !== -1 || !expanded && index === -1, 'Expand state not sync with index check');

      if (targetExpanded) {
        expandedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["a" /* arrAdd */])(expandedKeys, eventKey);
      } else {
        expandedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["b" /* arrDel */])(expandedKeys, eventKey);
      }

      _this.setUncontrolledState({ expandedKeys: expandedKeys });

      if (onExpand) {
        onExpand(expandedKeys, {
          node: treeNode,
          expanded: targetExpanded,
          nativeEvent: e.nativeEvent
        });
      }

      // Async Load data
      if (targetExpanded && loadData) {
        var loadPromise = _this.onNodeLoad(treeNode);
        return loadPromise ? loadPromise.then(function () {
          // [Legacy] Refresh logic
          _this.setUncontrolledState({ expandedKeys: expandedKeys });
        }) : null;
      }

      return null;
    }, _this.onNodeMouseEnter = function (event, node) {
      var onMouseEnter = _this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter({ event: event, node: node });
      }
    }, _this.onNodeMouseLeave = function (event, node) {
      var onMouseLeave = _this.props.onMouseLeave;

      if (onMouseLeave) {
        onMouseLeave({ event: event, node: node });
      }
    }, _this.onNodeContextMenu = function (event, node) {
      var onRightClick = _this.props.onRightClick;

      if (onRightClick) {
        event.preventDefault();
        onRightClick({ event: event, node: node });
      }
    }, _this.setUncontrolledState = function (state) {
      var needSync = false;
      var newState = {};

      Object.keys(state).forEach(function (name) {
        if (name in _this.props) return;

        needSync = true;
        newState[name] = state[name];
      });

      if (needSync) {
        _this.setState(newState);
      }
    }, _this.isKeyChecked = function (key) {
      var _this$state$checkedKe = _this.state.checkedKeys,
          checkedKeys = _this$state$checkedKe === undefined ? [] : _this$state$checkedKe;

      return checkedKeys.indexOf(key) !== -1;
    }, _this.renderTreeNode = function (child, index) {
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _this$state3 = _this.state,
          keyEntities = _this$state3.keyEntities,
          _this$state3$expanded = _this$state3.expandedKeys,
          expandedKeys = _this$state3$expanded === undefined ? [] : _this$state3$expanded,
          _this$state3$selected = _this$state3.selectedKeys,
          selectedKeys = _this$state3$selected === undefined ? [] : _this$state3$selected,
          _this$state3$halfChec = _this$state3.halfCheckedKeys,
          halfCheckedKeys = _this$state3$halfChec === undefined ? [] : _this$state3$halfChec,
          _this$state3$loadedKe = _this$state3.loadedKeys,
          loadedKeys = _this$state3$loadedKe === undefined ? [] : _this$state3$loadedKe,
          _this$state3$loadingK = _this$state3.loadingKeys,
          loadingKeys = _this$state3$loadingK === undefined ? [] : _this$state3$loadingK,
          dragOverNodeKey = _this$state3.dragOverNodeKey,
          dropPosition = _this$state3.dropPosition;

      var pos = Object(__WEBPACK_IMPORTED_MODULE_13__util__["l" /* getPosition */])(level, index);
      var key = child.key || pos;

      if (!keyEntities[key]) {
        Object(__WEBPACK_IMPORTED_MODULE_13__util__["p" /* warnOnlyTreeNode */])();
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
        key: key,
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: _this.isKeyChecked(key),
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: pos,

        // [Legacy] Drag props
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Tree, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          selectable = _props.selectable,
          showIcon = _props.showIcon,
          icon = _props.icon,
          draggable = _props.draggable,
          checkable = _props.checkable,
          checkStrictly = _props.checkStrictly,
          disabled = _props.disabled,
          loadData = _props.loadData,
          filterTreeNode = _props.filterTreeNode,
          openTransitionName = _props.openTransitionName,
          openAnimation = _props.openAnimation,
          switcherIcon = _props.switcherIcon;


      return {
        rcTree: {
          // root: this,

          prefixCls: prefixCls,
          selectable: selectable,
          showIcon: showIcon,
          icon: icon,
          switcherIcon: switcherIcon,
          draggable: draggable,
          checkable: checkable,
          checkStrictly: checkStrictly,
          disabled: disabled,
          openTransitionName: openTransitionName,
          openAnimation: openAnimation,

          loadData: loadData,
          filterTreeNode: filterTreeNode,
          renderTreeNode: this.renderTreeNode,
          isKeyChecked: this.isKeyChecked,

          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var treeNode = this.state.treeNode;
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          className = _props2.className,
          focusable = _props2.focusable,
          showLine = _props2.showLine,
          _props2$tabIndex = _props2.tabIndex,
          tabIndex = _props2$tabIndex === undefined ? 0 : _props2$tabIndex;

      var domProps = Object(__WEBPACK_IMPORTED_MODULE_13__util__["i" /* getDataAndAria */])(this.props);

      if (focusable) {
        domProps.tabIndex = tabIndex;
        domProps.onKeyDown = this.onKeyDown;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, domProps, {
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, className, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-show-line', showLine)),
          role: 'tree',
          unselectable: 'on'
        }),
        Object(__WEBPACK_IMPORTED_MODULE_13__util__["m" /* mapChildren */])(treeNode, function (node, index) {
          return _this2.renderTreeNode(node, index);
        })
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, prevState) {
      var prevProps = prevState.prevProps;

      var newState = {
        prevProps: props
      };

      function needSync(name) {
        return !prevProps && name in props || prevProps && prevProps[name] !== props[name];
      }

      // ================== Tree Node ==================
      var treeNode = null;

      // Check if `treeData` or `children` changed and save into the state.
      if (needSync('treeData')) {
        treeNode = Object(__WEBPACK_IMPORTED_MODULE_13__util__["g" /* convertDataToTree */])(props.treeData);
      } else if (needSync('children')) {
        treeNode = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Children_toArray__["a" /* default */])(props.children);
      }

      // Tree support filter function which will break the tree structure in the vdm.
      // We cache the treeNodes in state so that we can return the treeNode in event trigger.
      if (treeNode) {
        newState.treeNode = treeNode;

        // Calculate the entities data for quick match
        var entitiesMap = Object(__WEBPACK_IMPORTED_MODULE_13__util__["h" /* convertTreeToEntities */])(treeNode);
        newState.posEntities = entitiesMap.posEntities;
        newState.keyEntities = entitiesMap.keyEntities;
      }

      var keyEntities = newState.keyEntities || prevState.keyEntities;

      // ================ expandedKeys =================
      if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) {
        newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? Object(__WEBPACK_IMPORTED_MODULE_13__util__["f" /* conductExpandParent */])(props.expandedKeys, keyEntities) : props.expandedKeys;
      } else if (!prevProps && props.defaultExpandAll) {
        newState.expandedKeys = Object.keys(keyEntities);
      } else if (!prevProps && props.defaultExpandedKeys) {
        newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? Object(__WEBPACK_IMPORTED_MODULE_13__util__["f" /* conductExpandParent */])(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
      }

      // ================ selectedKeys =================
      if (props.selectable) {
        if (needSync('selectedKeys')) {
          newState.selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["d" /* calcSelectedKeys */])(props.selectedKeys, props);
        } else if (!prevProps && props.defaultSelectedKeys) {
          newState.selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["d" /* calcSelectedKeys */])(props.defaultSelectedKeys, props);
        }
      }

      // ================= checkedKeys =================
      if (props.checkable) {
        var checkedKeyEntity = void 0;

        if (needSync('checkedKeys')) {
          checkedKeyEntity = Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* parseCheckedKeys */])(props.checkedKeys) || {};
        } else if (!prevProps && props.defaultCheckedKeys) {
          checkedKeyEntity = Object(__WEBPACK_IMPORTED_MODULE_13__util__["n" /* parseCheckedKeys */])(props.defaultCheckedKeys) || {};
        } else if (treeNode) {
          // If treeNode changed, we also need check it
          checkedKeyEntity = {
            checkedKeys: prevState.checkedKeys,
            halfCheckedKeys: prevState.halfCheckedKeys
          };
        }

        if (checkedKeyEntity) {
          var _checkedKeyEntity = checkedKeyEntity,
              _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys,
              checkedKeys = _checkedKeyEntity$che === undefined ? [] : _checkedKeyEntity$che,
              _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys,
              halfCheckedKeys = _checkedKeyEntity$hal === undefined ? [] : _checkedKeyEntity$hal;


          if (!props.checkStrictly) {
            var conductKeys = Object(__WEBPACK_IMPORTED_MODULE_13__util__["e" /* conductCheck */])(checkedKeys, true, keyEntities);
            checkedKeys = conductKeys.checkedKeys;
            halfCheckedKeys = conductKeys.halfCheckedKeys;
          }

          newState.checkedKeys = checkedKeys;
          newState.halfCheckedKeys = halfCheckedKeys;
        }
      }
      // ================= loadedKeys ==================
      if (needSync('loadedKeys')) {
        newState.loadedKeys = props.loadedKeys;
      }

      return newState;
    }

    /**
     * [Legacy] Select handler is less small than node,
     * so that this will trigger when drag enter node or select handler.
     * This is a little tricky if customize css without padding.
     * Better for use mouse move event to refresh drag state.
     * But let's just keep it to avoid event trigger logic change.
     */


    /**
     * Only update the value which is not in props
     */


    /**
     * [Legacy] Original logic use `key` as tracking clue.
     * We have to use `cloneElement` to pass `key`.
     */

  }]);

  return Tree;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Tree.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number]),
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  treeData: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, // Generate treeNode by children
  showLine: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  showIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  icon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  focusable: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  selectable: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  checkable: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),
  checkStrictly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  draggable: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  defaultExpandParent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  autoExpandParent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  defaultExpandAll: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  defaultExpandedKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
  expandedKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
  defaultCheckedKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
  checkedKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])), __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
  selectedKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDoubleClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onExpand: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onCheck: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLoad: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  loadData: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  loadedKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onRightClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDragStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDragEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDragOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDragLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDragEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDrop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  filterTreeNode: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  switcherIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func])
};
Tree.childContextTypes = __WEBPACK_IMPORTED_MODULE_12__contextTypes__["b" /* treeContextTypes */];
Tree.defaultProps = {
  prefixCls: 'rc-tree',
  showLine: false,
  showIcon: true,
  selectable: true,
  multiple: false,
  checkable: false,
  disabled: false,
  checkStrictly: false,
  draggable: false,
  defaultExpandParent: true,
  autoExpandParent: false,
  defaultExpandAll: false,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: []
};


Object(__WEBPACK_IMPORTED_MODULE_11_react_lifecycles_compat__["polyfill"])(Tree);

/* harmony default export */ __webpack_exports__["a"] = (Tree);

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genAnimate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Children_toArray__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_warning__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_fbjs_lib_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(317);














var defaultKey = 'rc_animate_' + Date.now();
var clonePropList = ['children'];

/**
 * Default use `AnimateChild` as component.
 * Here can also pass customize `ChildComponent` for test usage.
 */
function genAnimate(ChildComponent) {
  var Animate = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

    function Animate() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Animate);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Animate.__proto__ || Object.getPrototypeOf(Animate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        appeared: true,
        mergedChildren: []
      }, _this.onChildLeaved = function (key) {
        // Remove child which not exist anymore
        if (!_this.hasChild(key)) {
          var mergedChildren = _this.state.mergedChildren;

          _this.setState({
            mergedChildren: mergedChildren.filter(function (node) {
              return node.key !== key;
            })
          });
        }
      }, _this.hasChild = function (key) {
        var children = _this.props.children;


        return Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Children_toArray__["a" /* default */])(children).some(function (node) {
          return node && node.key === key;
        });
      }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }
    // [Legacy] Not sure usage
    // commit: https://github.com/react-component/animate/commit/0a1cbfd647407498b10a8c6602a2dea80b42e324
    // eslint-disable-line

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Animate, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // No need to re-render
        this.state.appeared = false;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _state = this.state,
            appeared = _state.appeared,
            mergedChildren = _state.mergedChildren;
        var _props = this.props,
            Component = _props.component,
            componentProps = _props.componentProps,
            className = _props.className,
            style = _props.style,
            showProp = _props.showProp;


        var $children = mergedChildren.map(function (node) {
          if (mergedChildren.length > 1 && !node.key) {
            __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_warning___default()(false, 'must set key for <rc-animate> children');
            return null;
          }

          var show = true;

          if (!_this2.hasChild(node.key)) {
            show = false;
          } else if (showProp) {
            show = node.props[showProp];
          }

          var key = node.key || defaultKey;

          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            ChildComponent,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, {
              appeared: appeared,
              show: show,
              className: node.props.className,
              style: node.props.style,
              key: key,

              animateKey: node.key // Keep trans origin key
              , onChildLeaved: _this2.onChildLeaved
            }),
            node
          );
        });

        // Wrap with component
        if (Component) {
          var passedProps = this.props;
          if (typeof Component === 'string') {
            passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              className: className,
              style: style
            }, componentProps);
          }

          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            Component,
            passedProps,
            $children
          );
        }

        return $children[0] || null;
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, prevState) {
        var _prevState$prevProps = prevState.prevProps,
            prevProps = _prevState$prevProps === undefined ? {} : _prevState$prevProps;

        var newState = {
          prevProps: Object(__WEBPACK_IMPORTED_MODULE_11__util__["b" /* cloneProps */])(nextProps, clonePropList)
        };
        var showProp = nextProps.showProp;


        function processState(propName, updater) {
          if (prevProps[propName] !== nextProps[propName]) {
            updater(nextProps[propName]);
            return true;
          }
          return false;
        }

        processState('children', function (children) {
          var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Children_toArray__["a" /* default */])(children).filter(function (node) {
            return node;
          });
          var prevChildren = prevState.mergedChildren.filter(function (node) {
            // Remove prev child if not show anymore
            if (currentChildren.every(function (_ref2) {
              var key = _ref2.key;
              return key !== node.key;
            }) && showProp && !node.props[showProp]) {
              return false;
            }
            return true;
          });

          // Merge prev children to keep the animation
          newState.mergedChildren = Object(__WEBPACK_IMPORTED_MODULE_11__util__["e" /* mergeChildren */])(prevChildren, currentChildren);
        });

        return newState;
      }
    }]);

    return Animate;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

  Animate.isAnimate = true;
  Animate.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    componentProps: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
    transitionEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    transitionAppear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    exclusive: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    transitionLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onAppear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    showProp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
    style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
  };
  Animate.defaultProps = {
    animation: {},
    component: 'span',
    componentProps: {},
    transitionEnter: true,
    transitionLeave: true,
    transitionAppear: false
  };


  Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Animate);

  return Animate;
}

/* harmony default export */ __webpack_exports__["a"] = (genAnimate(__WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */]));

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(433);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genCSSMotion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(317);














var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(transitionSupport) {
  var CSSMotion = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CSSMotion, _React$Component);

    function CSSMotion() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CSSMotion);

      var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;


        if (!transitionSupport) {
          return;
        }

        // Event injection
        var $ele = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(_this);
        if (_this.$ele !== $ele) {
          _this.removeEventListener(_this.$ele);
          _this.addEventListener($ele);
          _this.$ele = $ele;
        }

        // Init status
        if (newStatus && status === STATUS_APPEAR && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
          });
        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
          });
        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR && statusActive) {
          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_ENTER && statusActive) {
          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_LEAVE && statusActive) {
          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
        }
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;

        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util__["g" /* transitionEndName */], _this.onMotionEnd);
        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;

        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util__["g" /* transitionEndName */], _this.onMotionEnd);
        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(_this), event) : null;

        if (statusStyle === false || _this._destroyed) return;

        var nextStep = void 0;
        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;

          if (status !== currentStatus) return;

          _this.updateStatus(styleFunc, { statusActive: true });
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();
        _this.raf = __WEBPACK_IMPORTED_MODULE_11_raf___default()(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          __WEBPACK_IMPORTED_MODULE_11_raf___default.a.cancel(_this.raf);
          _this.raf = null;
        }
      };

      _this.state = {
        status: STATUS_NONE,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };
      _this.$ele = null;
      _this.raf = null;
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CSSMotion, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._destroyed = true;
        this.removeEventListener(this.$ele);
        this.cancelNextFrame();
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _state = this.state,
            status = _state.status,
            statusActive = _state.statusActive,
            statusStyle = _state.statusStyle;
        var _props = this.props,
            children = _props.children,
            motionName = _props.motionName,
            visible = _props.visible;


        if (!children) return null;

        if (status === STATUS_NONE || !transitionSupport) {
          return visible ? children({}) : null;
        }

        return children({
          className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(motionName, status), status !== STATUS_NONE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTransitionName */])(motionName, status + '-active'), status !== STATUS_NONE && statusActive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        });
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps;

        if (!transitionSupport) return {};

        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;

        var newState = {
          prevProps: props
        };

        // Appear
        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Enter
        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Leave
        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);

    return CSSMotion;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

  CSSMotion.propTypes = {
    visible: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    motionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
    motionAppear: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    motionEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    motionLeave: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    motionLeaveImmediately: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, // Trigger leave motion immediately
    onAppearStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onAppearActive: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onAppearEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onEnterStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onEnterActive: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onEnterEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onLeaveStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onLeaveActive: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onLeaveEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  };
  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true
  };


  Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(CSSMotion);

  return CSSMotion;
}

/* harmony default export */ __webpack_exports__["a"] = (genCSSMotion(__WEBPACK_IMPORTED_MODULE_12__util__["f" /* supportTransition */]));

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _debounce = _interopRequireDefault(__webpack_require__(212));

var _util = __webpack_require__(318);

var _configProvider = __webpack_require__(35);

var _Tree = _interopRequireDefault(__webpack_require__(459));

var _util2 = __webpack_require__(1024);

var _icon = _interopRequireDefault(__webpack_require__(25));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

function getIcon(props) {
  var isLeaf = props.isLeaf,
      expanded = props.expanded;

  if (isLeaf) {
    return React.createElement(_icon["default"], {
      type: "file"
    });
  }

  return React.createElement(_icon["default"], {
    type: expanded ? 'folder-open' : 'folder'
  });
}

var DirectoryTree =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DirectoryTree, _React$Component);

  function DirectoryTree(props) {
    var _this;

    _classCallCheck(this, DirectoryTree);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirectoryTree).call(this, props));

    _this.onExpand = function (expandedKeys, info) {
      var onExpand = _this.props.onExpand;

      _this.setUncontrolledState({
        expandedKeys: expandedKeys
      }); // Call origin function


      if (onExpand) {
        return onExpand(expandedKeys, info);
      }

      return undefined;
    };

    _this.onClick = function (event, node) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          expandAction = _this$props.expandAction; // Expand the tree

      if (expandAction === 'click') {
        _this.onDebounceExpand(event, node);
      }

      if (onClick) {
        onClick(event, node);
      }
    };

    _this.onDoubleClick = function (event, node) {
      var _this$props2 = _this.props,
          onDoubleClick = _this$props2.onDoubleClick,
          expandAction = _this$props2.expandAction; // Expand the tree

      if (expandAction === 'doubleClick') {
        _this.onDebounceExpand(event, node);
      }

      if (onDoubleClick) {
        onDoubleClick(event, node);
      }
    };

    _this.onSelect = function (keys, event) {
      var _this$props3 = _this.props,
          onSelect = _this$props3.onSelect,
          multiple = _this$props3.multiple,
          children = _this$props3.children;
      var _this$state$expandedK = _this.state.expandedKeys,
          expandedKeys = _this$state$expandedK === void 0 ? [] : _this$state$expandedK;
      var node = event.node,
          nativeEvent = event.nativeEvent;
      var _node$props$eventKey = node.props.eventKey,
          eventKey = _node$props$eventKey === void 0 ? '' : _node$props$eventKey;
      var newState = {}; // Windows / Mac single pick

      var ctrlPick = nativeEvent.ctrlKey || nativeEvent.metaKey;
      var shiftPick = nativeEvent.shiftKey; // Generate new selected keys

      var newSelectedKeys;

      if (multiple && ctrlPick) {
        // Control click
        newSelectedKeys = keys;
        _this.lastSelectedKey = eventKey;
        _this.cachedSelectedKeys = newSelectedKeys;
      } else if (multiple && shiftPick) {
        // Shift click
        newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(_this.cachedSelectedKeys || []), _toConsumableArray((0, _util2.calcRangeKeys)(children, expandedKeys, eventKey, _this.lastSelectedKey)))));
      } else {
        // Single click
        newSelectedKeys = [eventKey];
        _this.lastSelectedKey = eventKey;
        _this.cachedSelectedKeys = newSelectedKeys;
      }

      newState.selectedKeys = newSelectedKeys;

      if (onSelect) {
        onSelect(newSelectedKeys, event);
      }

      _this.setUncontrolledState(newState);
    };

    _this.setTreeRef = function (node) {
      _this.tree = node;
    };

    _this.expandFolderNode = function (event, node) {
      var isLeaf = node.props.isLeaf;

      if (isLeaf || event.shiftKey || event.metaKey || event.ctrlKey) {
        return;
      } // Get internal rc-tree


      var internalTree = _this.tree.tree; // Call internal rc-tree expand function
      // https://github.com/ant-design/ant-design/issues/12567

      internalTree.onNodeExpand(event, node);
    };

    _this.setUncontrolledState = function (state) {
      var newState = (0, _omit["default"])(state, Object.keys(_this.props));

      if (Object.keys(newState).length) {
        _this.setState(newState);
      }
    };

    _this.renderDirectoryTree = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          props = __rest(_a, ["prefixCls", "className"]);

      var _this$state = _this.state,
          expandedKeys = _this$state.expandedKeys,
          selectedKeys = _this$state.selectedKeys;
      var prefixCls = getPrefixCls('tree', customizePrefixCls);
      var connectClassName = (0, _classnames["default"])("".concat(prefixCls, "-directory"), className);
      return React.createElement(_Tree["default"], _extends({
        icon: getIcon,
        ref: _this.setTreeRef
      }, props, {
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: _this.onSelect,
        onClick: _this.onClick,
        onDoubleClick: _this.onDoubleClick,
        onExpand: _this.onExpand
      }));
    };

    var defaultExpandAll = props.defaultExpandAll,
        defaultExpandParent = props.defaultExpandParent,
        expandedKeys = props.expandedKeys,
        defaultExpandedKeys = props.defaultExpandedKeys,
        children = props.children;

    var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
        keyEntities = _convertTreeToEntitie.keyEntities; // Selected keys


    _this.state = {
      selectedKeys: props.selectedKeys || props.defaultSelectedKeys || []
    }; // Expanded keys

    if (defaultExpandAll) {
      _this.state.expandedKeys = (0, _util2.getFullKeyList)(props.children);
    } else if (defaultExpandParent) {
      _this.state.expandedKeys = (0, _util.conductExpandParent)(expandedKeys || defaultExpandedKeys, keyEntities);
    } else {
      _this.state.expandedKeys = expandedKeys || defaultExpandedKeys;
    }

    _this.onDebounceExpand = (0, _debounce["default"])(_this.expandFolderNode, 200, {
      leading: true
    });
    return _this;
  }

  _createClass(DirectoryTree, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('expandedKeys' in nextProps) {
        this.setState({
          expandedKeys: nextProps.expandedKeys
        });
      }

      if ('selectedKeys' in nextProps) {
        this.setState({
          selectedKeys: nextProps.selectedKeys
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderDirectoryTree);
    }
  }]);

  return DirectoryTree;
}(React.Component);

exports["default"] = DirectoryTree;
DirectoryTree.defaultProps = {
  showIcon: true,
  expandAction: 'click'
};

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(58);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(57);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(48);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcAnimate = __webpack_require__(463);

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _toArray = __webpack_require__(465);

var _toArray2 = _interopRequireDefault(_toArray);

var _reactLifecyclesCompat = __webpack_require__(49);

var _contextTypes = __webpack_require__(1023);

var _util = __webpack_require__(318);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ICON_OPEN = 'open';
var ICON_CLOSE = 'close';

var defaultTitle = '---';

var TreeNode = function (_React$Component) {
  (0, _inherits3['default'])(TreeNode, _React$Component);

  function TreeNode(props) {
    (0, _classCallCheck3['default'])(this, TreeNode);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (TreeNode.__proto__ || Object.getPrototypeOf(TreeNode)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      dragNodeHighlight: false
    };
    return _this;
  }

  (0, _createClass3['default'])(TreeNode, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return (0, _extends3['default'])({}, this.context, {
        rcTreeNode: {
          // onUpCheckConduct: this.onUpCheckConduct,
        }
      });
    }

    // Isomorphic needn't load data in server side

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncLoadData(this.props);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.syncLoadData(this.props);
    }

    // Disabled item still can be switch


    // Drag usage

  }, {
    key: 'isSelectable',
    value: function isSelectable() {
      var selectable = this.props.selectable;
      var treeSelectable = this.context.rcTree.selectable;

      // Ignore when selectable is undefined or null

      if (typeof selectable === 'boolean') {
        return selectable;
      }

      return treeSelectable;
    }

    // Load data to avoid default expanded tree without data


    // Switcher


    // Checkbox


    // Icon + Title


    // Children list wrapped with `Animation`

  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var loading = this.props.loading;
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          dragOver = _props.dragOver,
          dragOverGapTop = _props.dragOverGapTop,
          dragOverGapBottom = _props.dragOverGapBottom,
          isLeaf = _props.isLeaf,
          expanded = _props.expanded,
          selected = _props.selected,
          checked = _props.checked,
          halfChecked = _props.halfChecked,
          otherProps = (0, _objectWithoutProperties3['default'])(_props, ['className', 'style', 'dragOver', 'dragOverGapTop', 'dragOverGapBottom', 'isLeaf', 'expanded', 'selected', 'checked', 'halfChecked']);
      var _context$rcTree = this.context.rcTree,
          prefixCls = _context$rcTree.prefixCls,
          filterTreeNode = _context$rcTree.filterTreeNode,
          draggable = _context$rcTree.draggable;

      var disabled = this.isDisabled();
      var dataOrAriaAttributeProps = (0, _util.getDataAndAria)(otherProps);

      return _react2['default'].createElement(
        'li',
        (0, _extends3['default'])({
          className: (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-switcher-' + (expanded ? 'open' : 'close'), !isLeaf), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-checkbox-checked', checked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-checkbox-indeterminate', halfChecked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-selected', selected), (0, _defineProperty3['default'])(_classNames, prefixCls + '-treenode-loading', loading), (0, _defineProperty3['default'])(_classNames, 'drag-over', !disabled && dragOver), (0, _defineProperty3['default'])(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), (0, _defineProperty3['default'])(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), (0, _defineProperty3['default'])(_classNames, 'filter-node', filterTreeNode && filterTreeNode(this)), _classNames)),

          style: style,

          role: 'treeitem',

          onDragEnter: draggable ? this.onDragEnter : undefined,
          onDragOver: draggable ? this.onDragOver : undefined,
          onDragLeave: draggable ? this.onDragLeave : undefined,
          onDrop: draggable ? this.onDrop : undefined,
          onDragEnd: draggable ? this.onDragEnd : undefined
        }, dataOrAriaAttributeProps),
        this.renderSwitcher(),
        this.renderCheckbox(),
        this.renderSelector(),
        this.renderChildren()
      );
    }
  }]);
  return TreeNode;
}(_react2['default'].Component);

TreeNode.propTypes = {
  eventKey: _propTypes2['default'].string, // Pass by parent `cloneElement`
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  style: _propTypes2['default'].object,
  root: _propTypes2['default'].object,
  onSelect: _propTypes2['default'].func,

  // By parent
  expanded: _propTypes2['default'].bool,
  selected: _propTypes2['default'].bool,
  checked: _propTypes2['default'].bool,
  loaded: _propTypes2['default'].bool,
  loading: _propTypes2['default'].bool,
  halfChecked: _propTypes2['default'].bool,
  children: _propTypes2['default'].node,
  title: _propTypes2['default'].node,
  pos: _propTypes2['default'].string,
  dragOver: _propTypes2['default'].bool,
  dragOverGapTop: _propTypes2['default'].bool,
  dragOverGapBottom: _propTypes2['default'].bool,

  // By user
  isLeaf: _propTypes2['default'].bool,
  selectable: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  disableCheckbox: _propTypes2['default'].bool,
  icon: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
  switcherIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func])
};
TreeNode.contextTypes = _contextTypes.nodeContextTypes;
TreeNode.childContextTypes = _contextTypes.nodeContextTypes;
TreeNode.defaultProps = {
  title: defaultTitle
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSelectorClick = function (e) {
    // Click trigger before select/check operation
    var onNodeClick = _this2.context.rcTree.onNodeClick;

    onNodeClick(e, _this2);

    if (_this2.isSelectable()) {
      _this2.onSelect(e);
    } else {
      _this2.onCheck(e);
    }
  };

  this.onSelectorDoubleClick = function (e) {
    var onNodeDoubleClick = _this2.context.rcTree.onNodeDoubleClick;

    onNodeDoubleClick(e, _this2);
  };

  this.onSelect = function (e) {
    if (_this2.isDisabled()) return;

    var onNodeSelect = _this2.context.rcTree.onNodeSelect;

    e.preventDefault();
    onNodeSelect(e, _this2);
  };

  this.onCheck = function (e) {
    if (_this2.isDisabled()) return;

    var _props2 = _this2.props,
        disableCheckbox = _props2.disableCheckbox,
        checked = _props2.checked;
    var _context$rcTree2 = _this2.context.rcTree,
        checkable = _context$rcTree2.checkable,
        onNodeCheck = _context$rcTree2.onNodeCheck;


    if (!checkable || disableCheckbox) return;

    e.preventDefault();
    var targetChecked = !checked;
    onNodeCheck(e, _this2, targetChecked);
  };

  this.onMouseEnter = function (e) {
    var onNodeMouseEnter = _this2.context.rcTree.onNodeMouseEnter;

    onNodeMouseEnter(e, _this2);
  };

  this.onMouseLeave = function (e) {
    var onNodeMouseLeave = _this2.context.rcTree.onNodeMouseLeave;

    onNodeMouseLeave(e, _this2);
  };

  this.onContextMenu = function (e) {
    var onNodeContextMenu = _this2.context.rcTree.onNodeContextMenu;

    onNodeContextMenu(e, _this2);
  };

  this.onDragStart = function (e) {
    var onNodeDragStart = _this2.context.rcTree.onNodeDragStart;


    e.stopPropagation();
    _this2.setState({
      dragNodeHighlight: true
    });
    onNodeDragStart(e, _this2);

    try {
      // ie throw error
      // firefox-need-it
      e.dataTransfer.setData('text/plain', '');
    } catch (error) {
      // empty
    }
  };

  this.onDragEnter = function (e) {
    var onNodeDragEnter = _this2.context.rcTree.onNodeDragEnter;


    e.preventDefault();
    e.stopPropagation();
    onNodeDragEnter(e, _this2);
  };

  this.onDragOver = function (e) {
    var onNodeDragOver = _this2.context.rcTree.onNodeDragOver;


    e.preventDefault();
    e.stopPropagation();
    onNodeDragOver(e, _this2);
  };

  this.onDragLeave = function (e) {
    var onNodeDragLeave = _this2.context.rcTree.onNodeDragLeave;


    e.stopPropagation();
    onNodeDragLeave(e, _this2);
  };

  this.onDragEnd = function (e) {
    var onNodeDragEnd = _this2.context.rcTree.onNodeDragEnd;


    e.stopPropagation();
    _this2.setState({
      dragNodeHighlight: false
    });
    onNodeDragEnd(e, _this2);
  };

  this.onDrop = function (e) {
    var onNodeDrop = _this2.context.rcTree.onNodeDrop;


    e.preventDefault();
    e.stopPropagation();
    _this2.setState({
      dragNodeHighlight: false
    });
    onNodeDrop(e, _this2);
  };

  this.onExpand = function (e) {
    var onNodeExpand = _this2.context.rcTree.onNodeExpand;

    onNodeExpand(e, _this2);
  };

  this.setSelectHandle = function (node) {
    _this2.selectHandle = node;
  };

  this.getNodeChildren = function () {
    var children = _this2.props.children;

    var originList = (0, _toArray2['default'])(children).filter(function (node) {
      return node;
    });
    var targetList = (0, _util.getNodeChildren)(originList);

    if (originList.length !== targetList.length) {
      (0, _util.warnOnlyTreeNode)();
    }

    return targetList;
  };

  this.getNodeState = function () {
    var expanded = _this2.props.expanded;


    if (_this2.isLeaf()) {
      return null;
    }

    return expanded ? ICON_OPEN : ICON_CLOSE;
  };

  this.isLeaf = function () {
    var _props3 = _this2.props,
        isLeaf = _props3.isLeaf,
        loaded = _props3.loaded;
    var loadData = _this2.context.rcTree.loadData;


    var hasChildren = _this2.getNodeChildren().length !== 0;

    if (isLeaf === false) {
      return false;
    }

    return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
  };

  this.isDisabled = function () {
    var disabled = _this2.props.disabled;
    var treeDisabled = _this2.context.rcTree.disabled;

    // Follow the logic of Selectable

    if (disabled === false) {
      return false;
    }

    return !!(treeDisabled || disabled);
  };

  this.syncLoadData = function (props) {
    var expanded = props.expanded,
        loading = props.loading,
        loaded = props.loaded;
    var _context$rcTree3 = _this2.context.rcTree,
        loadData = _context$rcTree3.loadData,
        onNodeLoad = _context$rcTree3.onNodeLoad;


    if (loading) return;

    // read from state to avoid loadData at same time
    if (loadData && expanded && !_this2.isLeaf()) {
      // We needn't reload data when has children in sync logic
      // It's only needed in node expanded
      var hasChildren = _this2.getNodeChildren().length !== 0;
      if (!hasChildren && !loaded) {
        onNodeLoad(_this2);
      }
    }
  };

  this.renderSwitcher = function () {
    var _props4 = _this2.props,
        expanded = _props4.expanded,
        switcherIconFromProps = _props4.switcherIcon;
    var _context$rcTree4 = _this2.context.rcTree,
        prefixCls = _context$rcTree4.prefixCls,
        switcherIconFromCtx = _context$rcTree4.switcherIcon;


    var switcherIcon = switcherIconFromProps || switcherIconFromCtx;

    if (_this2.isLeaf()) {
      return _react2['default'].createElement(
        'span',
        { className: (0, _classnames2['default'])(prefixCls + '-switcher', prefixCls + '-switcher-noop') },
        typeof switcherIcon === 'function' ? _react2['default'].createElement(switcherIcon, (0, _extends3['default'])({}, _this2.props, { isLeaf: true })) : switcherIcon
      );
    }

    var switcherCls = (0, _classnames2['default'])(prefixCls + '-switcher', prefixCls + '-switcher_' + (expanded ? ICON_OPEN : ICON_CLOSE));
    return _react2['default'].createElement(
      'span',
      { onClick: _this2.onExpand, className: switcherCls },
      typeof switcherIcon === 'function' ? _react2['default'].createElement(switcherIcon, (0, _extends3['default'])({}, _this2.props, { isLeaf: false })) : switcherIcon
    );
  };

  this.renderCheckbox = function () {
    var _props5 = _this2.props,
        checked = _props5.checked,
        halfChecked = _props5.halfChecked,
        disableCheckbox = _props5.disableCheckbox;
    var _context$rcTree5 = _this2.context.rcTree,
        prefixCls = _context$rcTree5.prefixCls,
        checkable = _context$rcTree5.checkable;

    var disabled = _this2.isDisabled();

    if (!checkable) return null;

    // [Legacy] Custom element should be separate with `checkable` in future
    var $custom = typeof checkable !== 'boolean' ? checkable : null;

    return _react2['default'].createElement(
      'span',
      {
        className: (0, _classnames2['default'])(prefixCls + '-checkbox', checked && prefixCls + '-checkbox-checked', !checked && halfChecked && prefixCls + '-checkbox-indeterminate', (disabled || disableCheckbox) && prefixCls + '-checkbox-disabled'),
        onClick: _this2.onCheck
      },
      $custom
    );
  };

  this.renderIcon = function () {
    var loading = _this2.props.loading;
    var prefixCls = _this2.context.rcTree.prefixCls;


    return _react2['default'].createElement('span', {
      className: (0, _classnames2['default'])(prefixCls + '-iconEle', prefixCls + '-icon__' + (_this2.getNodeState() || 'docu'), loading && prefixCls + '-icon_loading')
    });
  };

  this.renderSelector = function () {
    var dragNodeHighlight = _this2.state.dragNodeHighlight;
    var _props6 = _this2.props,
        title = _props6.title,
        selected = _props6.selected,
        icon = _props6.icon,
        loading = _props6.loading;
    var _context$rcTree6 = _this2.context.rcTree,
        prefixCls = _context$rcTree6.prefixCls,
        showIcon = _context$rcTree6.showIcon,
        treeIcon = _context$rcTree6.icon,
        draggable = _context$rcTree6.draggable,
        loadData = _context$rcTree6.loadData;

    var disabled = _this2.isDisabled();

    var wrapClass = prefixCls + '-node-content-wrapper';

    // Icon - Still show loading icon when loading without showIcon
    var $icon = void 0;

    if (showIcon) {
      var currentIcon = icon || treeIcon;

      $icon = currentIcon ? _react2['default'].createElement(
        'span',
        {
          className: (0, _classnames2['default'])(prefixCls + '-iconEle', prefixCls + '-icon__customize')
        },
        typeof currentIcon === 'function' ? _react2['default'].createElement(currentIcon, (0, _extends3['default'])({}, _this2.props)) : currentIcon
      ) : _this2.renderIcon();
    } else if (loadData && loading) {
      $icon = _this2.renderIcon();
    }

    // Title
    var $title = _react2['default'].createElement(
      'span',
      { className: prefixCls + '-title' },
      title
    );

    return _react2['default'].createElement(
      'span',
      {
        ref: _this2.setSelectHandle,
        title: typeof title === 'string' ? title : '',
        className: (0, _classnames2['default'])('' + wrapClass, wrapClass + '-' + (_this2.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && prefixCls + '-node-selected', !disabled && draggable && 'draggable'),
        draggable: !disabled && draggable || undefined,
        'aria-grabbed': !disabled && draggable || undefined,

        onMouseEnter: _this2.onMouseEnter,
        onMouseLeave: _this2.onMouseLeave,
        onContextMenu: _this2.onContextMenu,
        onClick: _this2.onSelectorClick,
        onDoubleClick: _this2.onSelectorDoubleClick,
        onDragStart: draggable ? _this2.onDragStart : undefined
      },
      $icon,
      $title
    );
  };

  this.renderChildren = function () {
    var _props7 = _this2.props,
        expanded = _props7.expanded,
        pos = _props7.pos;
    var _context$rcTree7 = _this2.context.rcTree,
        prefixCls = _context$rcTree7.prefixCls,
        openTransitionName = _context$rcTree7.openTransitionName,
        openAnimation = _context$rcTree7.openAnimation,
        renderTreeNode = _context$rcTree7.renderTreeNode;


    var animProps = {};
    if (openTransitionName) {
      animProps.transitionName = openTransitionName;
    } else if (typeof openAnimation === 'object') {
      animProps.animation = (0, _extends3['default'])({}, openAnimation);
    }

    // Children TreeNode
    var nodeList = _this2.getNodeChildren();

    if (nodeList.length === 0) {
      return null;
    }

    var $children = void 0;
    if (expanded) {
      $children = _react2['default'].createElement(
        'ul',
        {
          className: (0, _classnames2['default'])(prefixCls + '-child-tree', expanded && prefixCls + '-child-tree-open'),
          'data-expanded': expanded,
          role: 'group'
        },
        (0, _util.mapChildren)(nodeList, function (node, index) {
          return renderTreeNode(node, index, pos);
        })
      );
    }

    return _react2['default'].createElement(
      _rcAnimate2['default'],
      (0, _extends3['default'])({}, animProps, {
        showProp: 'data-expanded',
        component: ''
      }),
      $children
    );
  };
};

TreeNode.isTreeNode = 1;

(0, _reactLifecyclesCompat.polyfill)(TreeNode);

exports['default'] = TreeNode;
module.exports = exports['default'];

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodeContextTypes = exports.treeContextTypes = undefined;

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Thought we still use `cloneElement` to pass `key`,
 * other props can pass with context for future refactor.
 */
var treeContextTypes = exports.treeContextTypes = {
  rcTree: _propTypes2['default'].shape({
    root: _propTypes2['default'].object,

    prefixCls: _propTypes2['default'].string,
    selectable: _propTypes2['default'].bool,
    showIcon: _propTypes2['default'].bool,
    icon: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
    draggable: _propTypes2['default'].bool,
    checkable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
    checkStrictly: _propTypes2['default'].bool,
    disabled: _propTypes2['default'].bool,
    openTransitionName: _propTypes2['default'].string,
    openAnimation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),

    loadData: _propTypes2['default'].func,
    filterTreeNode: _propTypes2['default'].func,
    renderTreeNode: _propTypes2['default'].func,

    isKeyChecked: _propTypes2['default'].func,

    onNodeClick: _propTypes2['default'].func,
    onNodeDoubleClick: _propTypes2['default'].func,
    onNodeExpand: _propTypes2['default'].func,
    onNodeSelect: _propTypes2['default'].func,
    onNodeCheck: _propTypes2['default'].func,
    onNodeMouseEnter: _propTypes2['default'].func,
    onNodeMouseLeave: _propTypes2['default'].func,
    onNodeContextMenu: _propTypes2['default'].func,
    onNodeDragStart: _propTypes2['default'].func,
    onNodeDragEnter: _propTypes2['default'].func,
    onNodeDragOver: _propTypes2['default'].func,
    onNodeDragLeave: _propTypes2['default'].func,
    onNodeDragEnd: _propTypes2['default'].func,
    onNodeDrop: _propTypes2['default'].func

    // TODO: Remove this
    // onBatchNodeCheck: PropTypes.func,
    // onCheckConductFinished: PropTypes.func,

    // Tree will store the entities when the treeNode refresh.
    // User can pass the func to add more info to customize the additional info.
    // processTreeEntity: PropTypes.func,
  })
}; /**
    * Webpack has bug for import loop, which is not the same behavior as ES module.
    * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
    */

var nodeContextTypes = exports.nodeContextTypes = (0, _extends3['default'])({}, treeContextTypes, {
  rcTreeNode: _propTypes2['default'].shape({
    onUpCheckConduct: _propTypes2['default'].func
  })
});

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFullKeyList = getFullKeyList;
exports.calcRangeKeys = calcRangeKeys;

var _util = __webpack_require__(318);

var Record;

(function (Record) {
  Record[Record["None"] = 0] = "None";
  Record[Record["Start"] = 1] = "Start";
  Record[Record["End"] = 2] = "End";
})(Record || (Record = {})); // TODO: Move this logic into `rc-tree`


function traverseNodesKey(rootChildren, callback) {
  var nodeList = (0, _util.getNodeChildren)(rootChildren) || [];

  function processNode(node) {
    var key = node.key,
        children = node.props.children;

    if (callback(key) !== false) {
      traverseNodesKey(children, callback);
    }
  }

  nodeList.forEach(processNode);
}

function getFullKeyList(children) {
  var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
      keyEntities = _convertTreeToEntitie.keyEntities;

  return Object.keys(keyEntities);
}
/** 计算选中范围，只考虑expanded情况以优化性能 */


function calcRangeKeys(rootChildren, expandedKeys, startKey, endKey) {
  var keys = [];
  var record = Record.None;

  if (startKey && startKey === endKey) {
    return [startKey];
  }

  if (!startKey || !endKey) {
    return [];
  }

  function matchKey(key) {
    return key === startKey || key === endKey;
  }

  traverseNodesKey(rootChildren, function (key) {
    if (record === Record.End) {
      return false;
    }

    if (matchKey(key)) {
      // Match test
      keys.push(key);

      if (record === Record.None) {
        record = Record.Start;
      } else if (record === Record.Start) {
        record = Record.End;
        return false;
      }
    } else if (record === Record.Start) {
      // Append selection
      keys.push(key);
    }

    if (expandedKeys.indexOf(key) === -1) {
      return false;
    }

    return true;
  });
  return keys;
}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(466);
var bytesToUuid = __webpack_require__(467);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(466);
var bytesToUuid = __webpack_require__(467);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_normalizers__ = __webpack_require__(82);
var IconFontCNIcons=__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a.createFromIconfontCN({scriptUrl:'./static/vendor/iconfont_cn/iconfont.js'});var mandatoryIconStyle={type:'m',title:"Mandatory"};var CubeComponentListItem=function CubeComponentListItem(_ref){var t=_ref.t,disabled=_ref.disabled,isChecked=_ref.isChecked,hasCheckbox=_ref.hasCheckbox,label=_ref.label,icon=_ref.icon,isMandatory=_ref.isMandatory,onChange=_ref.onChange,onCodelistShow=_ref.onCodelistShow,onDetail=_ref.onDetail,isTid=_ref.isTid;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{width:"100%",minWidth:100,marginBottom:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{display:"inline-block",verticalAlign:"middle",width:onCodelistShow!==undefined?"calc(100% - 22px)":"100%"}},hasCheckbox&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{display:"inline-block",verticalAlign:"middle",width:16,marginLeft:0,marginRight:16}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{checked:isChecked,disabled:disabled,onChange:onChange})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{display:"inline-block",verticalAlign:"middle",width:14,marginLeft:0,marginRight:8}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:icon})),isMandatory&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{display:"inline-block",verticalAlign:"middle",width:14,marginLeft:0,marginRight:4}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(IconFontCNIcons,Object.assign({style:{marginTop:3}},mandatoryIconStyle))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{onClick:onDetail,title:onDetail?t('components.cubeComponentList.item.detailShow.title'):label,style:{display:"inline-block",verticalAlign:"middle",width:'calc((100% - 22px)'+(isMandatory?' - 18px':'')+(hasCheckbox?' - 32px':'')+')',cursor:onDetail?'pointer':null,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_normalizers__["a" /* getNormalizedColumnName */])(label),isTid&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip___default.a,{title:t("components.cubeComponentList.item.tidTooltip")},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:'info-circle',style:{marginLeft:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MARGIN_SM"]}})))),onCodelistShow!==undefined&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{width:14,display:"inline-block",verticalAlign:"middle",marginLeft:8,marginRight:0}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:'file-search',onClick:onCodelistShow,style:{cursor:onCodelistShow?'pointer':null,color:!onCodelistShow?__WEBPACK_IMPORTED_MODULE_7__styles_constants__["COLOR_FONT_DISABLED"]:null},title:t('components.cubeComponentList.item.codelistShowIcon.title')})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])()(CubeComponentListItem));

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _shallowequal = _interopRequireDefault(__webpack_require__(132));

var _reactLifecyclesCompat = __webpack_require__(49);

var _radio = _interopRequireDefault(__webpack_require__(322));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function getCheckedValue(children) {
  var value = null;
  var matched = false;
  React.Children.forEach(children, function (radio) {
    if (radio && radio.props && radio.props.checked) {
      value = radio.props.value;
      matched = true;
    }
  });
  return matched ? {
    value: value
  } : undefined;
}

var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioGroup).call(this, props));

    _this.onRadioChange = function (ev) {
      var lastValue = _this.state.value;
      var value = ev.target.value;

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var onChange = _this.props.onChange;

      if (onChange && value !== lastValue) {
        onChange(ev);
      }
    };

    _this.renderGroup = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var props = _this.props;
      var customizePrefixCls = props.prefixCls,
          _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className,
          options = props.options,
          buttonStyle = props.buttonStyle;
      var prefixCls = getPrefixCls('radio', customizePrefixCls);
      var groupPrefixCls = "".concat(prefixCls, "-group");
      var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), _defineProperty({}, "".concat(groupPrefixCls, "-").concat(props.size), props.size), className);
      var children = props.children; // 如果存在 options, 优先使用

      if (options && options.length > 0) {
        children = options.map(function (option, index) {
          if (typeof option === 'string') {
            // 此处类型自动推导为 string
            return React.createElement(_radio["default"], {
              key: index,
              prefixCls: prefixCls,
              disabled: _this.props.disabled,
              value: option,
              onChange: _this.onRadioChange,
              checked: _this.state.value === option
            }, option);
          } else {
            // 此处类型自动推导为 { label: string value: string }
            return React.createElement(_radio["default"], {
              key: index,
              prefixCls: prefixCls,
              disabled: option.disabled || _this.props.disabled,
              value: option.value,
              onChange: _this.onRadioChange,
              checked: _this.state.value === option.value
            }, option.label);
          }
        });
      }

      return React.createElement("div", {
        className: classString,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        id: props.id
      }, children);
    };

    var value;

    if ('value' in props) {
      value = props.value;
    } else if ('defaultValue' in props) {
      value = props.defaultValue;
    } else {
      var checkedValue = getCheckedValue(props.children);
      value = checkedValue && checkedValue.value;
    }

    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        radioGroup: {
          onChange: this.onRadioChange,
          value: this.state.value,
          disabled: this.props.disabled,
          name: this.props.name
        }
      };
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      } else {
        var checkedValue = getCheckedValue(nextProps.children);

        if (checkedValue) {
          return {
            value: checkedValue.value
          };
        }
      }

      return null;
    }
  }]);

  return RadioGroup;
}(React.Component);

RadioGroup.defaultProps = {
  disabled: false,
  buttonStyle: 'outline'
};
RadioGroup.childContextTypes = {
  radioGroup: PropTypes.any
};
(0, _reactLifecyclesCompat.polyfill)(RadioGroup);
var _default = RadioGroup;
exports["default"] = _default;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _radio = _interopRequireDefault(__webpack_require__(322));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var RadioButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  function RadioButton() {
    var _this;

    _classCallCheck(this, RadioButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioButton).apply(this, arguments));

    _this.renderRadioButton = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          radioProps = __rest(_a, ["prefixCls"]);

      var prefixCls = getPrefixCls('radio-button', customizePrefixCls);

      if (_this.context.radioGroup) {
        radioProps.onChange = _this.context.radioGroup.onChange;
        radioProps.checked = _this.props.value === _this.context.radioGroup.value;
        radioProps.disabled = _this.props.disabled || _this.context.radioGroup.disabled;
      }

      return React.createElement(_radio["default"], _extends({
        prefixCls: prefixCls
      }, radioProps));
    };

    return _this;
  }

  _createClass(RadioButton, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRadioButton);
    }
  }]);

  return RadioButton;
}(React.Component);

exports["default"] = RadioButton;
RadioButton.contextTypes = {
  radioGroup: PropTypes.any
};

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__condition__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hocs_call__ = __webpack_require__(18);
var FilterFormBlock=function FilterFormBlock(_ref){var t=_ref.t,form=_ref.form,index=_ref.index,conditions=_ref.conditions,column=_ref.column,columns=_ref.columns,onDelete=_ref.onDelete,onConditionAdd=_ref.onConditionAdd,onConditionDelete=_ref.onConditionDelete,disabled=_ref.disabled;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'space-between',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:9},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,null,form.getFieldDecorator('filter['+index+'].column')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref2){var props=_ref2.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},size:'small',disabled:disabled},columns!==null?columns.map(function(column,columnIndex){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option,{key:columnIndex,value:column.name,title:Object(__WEBPACK_IMPORTED_MODULE_16__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)},Object(__WEBPACK_IMPORTED_MODULE_16__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name));}):null)))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:15},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,null,form.getFieldDecorator('filter['+index+'].logicalOperator')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group,{size:'small',disabled:disabled},['AND','OR'].map(function(op){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{key:op,value:op},op);})))))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:15},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:conditions!==null&&conditions.length>0&&column!==null&&column.values===null?{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}:null},conditions!==null&&conditions.length>0?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:column!==null&&column.fetchCodes,disabled:column===null||column.fetchCodes===null||column.codes!==null},column!==null&&(!column.fetchCodes||column.codes!==null)&&conditions.map(function(_,conditionIndex){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{key:conditionIndex,style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__condition__["a" /* default */],{form:form,blockIndex:index,values:column.values,codes:column.codes,colName:column.name,fetchValues:column.fetchValues,resetValues:column.resetValues,fetchCodes:column.fetchCodes,isNumeric:column.isNumeric,index:conditionIndex,onDelete:function onDelete(){return onConditionDelete(conditionIndex);},disabled:disabled,hasCodelist:column.hasCodelist,valuesCount:column.valuesCount}));})):null),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onConditionAdd,disabled:column===null||disabled,icon:'plus',size:'small'},t('components.whereConditionsForm.block.addConditionButton')))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'space-between',style:{marginTop:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onDelete,icon:'delete',size:'small',disabled:disabled},t('components.whereConditionsForm.block.removeButton')))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_i18next__["b" /* translate */])()(FilterFormBlock));

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__infinite_scroll_data_table__ = __webpack_require__(74);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var FilterFormBlockCondition=function FilterFormBlockCondition(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,form=_ref.form,blockIndex=_ref.blockIndex,index=_ref.index,values=_ref.values,valuesCount=_ref.valuesCount,fetchValues=_ref.fetchValues,resetValues=_ref.resetValues,isNumeric=_ref.isNumeric,hasCodelist=_ref.hasCodelist,codes=_ref.codes,colName=_ref.colName,onDelete=_ref.onDelete,disabled=_ref.disabled;var _useState=Object(__WEBPACK_IMPORTED_MODULE_12_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isValuesModalVisible=_useState2[0],setIsValuesModalVisible=_useState2[1];return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],justify:'space-between'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:5},form.getFieldDecorator('filter['+blockIndex+'].conditions['+index+'].comparisonOperator')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a,{style:{width:'100%'},size:'small',disabled:disabled},__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.compact(['=','<>',!isNumeric?'like':null,'<','>','<=','>=']).map(function(op){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option,{key:op,value:op},op);})))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:16},form.getFieldDecorator('filter['+blockIndex+'].conditions['+index+'].value')(values!==undefined&&form.getFieldValue('filter['+blockIndex+'].conditions['+index+'].comparisonOperator')&&form.getFieldValue('filter['+blockIndex+'].conditions['+index+'].comparisonOperator')!=='like'?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,form.getFieldDecorator('filter['+blockIndex+'].conditions['+index+'].value')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__selector__["a" /* default */],{style:{top:0},size:'small',selectTitle:t('components.whereConditionsForm.block.condition.selectValueButton.title'),resetTitle:t('components.whereConditionsForm.block.condition.resetValueButton.title'),onSelect:function onSelect(){return setIsValuesModalVisible(true);},onReset:function onReset(){var filter=[];var conditions=[];conditions[index]={value:null};filter[blockIndex]={conditions:conditions};form.setFieldsValue({filter:filter});},disabled:disabled,render:function render(value){return value!==null&&hasCodelist?value+' ('+Object(__WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__["a" /* getLocalizedStr */])(codes.find(function(_ref2){var id=_ref2.id;return id===value;}).name,dataLanguage||appLanguage,dataLanguages)+')':value;}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__enhanced_modal__["a" /* default */],{visible:isValuesModalVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_MD"],title:t('components.whereConditionsForm.block.condition.selectValueModal.title'),onCancel:function onCancel(){resetValues();setIsValuesModalVisible(false);},footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:function onClick(){resetValues();setIsValuesModalVisible(false);}},t('commons.buttons.close.title')),withDataLanguageSelector:!isNumeric},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){return hasCodelist?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__item_list__["a" /* default */],{noFilter:true,noSort:true,data:values||null,rowCount:valuesCount,isPaginated:true,onChange:function onChange(_ref3){var pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,searchText=_ref3.searchText;var filteredCodes=searchText?codes.filter(function(_ref4){var id=_ref4.id,name=_ref4.name;return id.toLowerCase().includes(searchText.toLowerCase())||Object(__WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,dataLanguage||appLanguage,dataLanguages).toLowerCase().includes(searchText.toLowerCase());}):null;var call=function call(){fetchValues({pageNum:pageNum,pageSize:pageSize,filterObj:searchText?[{column:colName,conditions:filteredCodes.length>0?filteredCodes.map(function(_ref5){var id=_ref5.id;return{comparisonOperator:"=",value:id};}):[{comparisonOperator:"=",value:"DUMMY_VALUE_FOR_NO_RESULTS"}],isOr:false}]:null});};if(searchText&&filteredCodes.length>1000){__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.error({title:t('components.whereConditionsForm.block.condition.selectValueModal.tooManyCodesAlert.title'),content:t('components.whereConditionsForm.block.condition.selectValueModal.tooManyCodesAlert.content')});}else{call();}},onRowClick:function onRowClick(row){var filter=[];var conditions=[];conditions[index]={value:row.id};filter[blockIndex]={conditions:conditions};form.setFieldsValue({filter:filter});resetValues();setIsValuesModalVisible(false);}}):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__infinite_scroll_data_table__["a" /* default */],{noFilter:true,noSort:true,data:values||null,rowTotal:valuesCount,cols:[colName],onChange:function onChange(_ref6){var pageNum=_ref6.pageNum,pageSize=_ref6.pageSize,searchText=_ref6.searchText;return fetchValues({pageNum:pageNum,pageSize:pageSize,searchText:searchText});},onRowClick:function onRowClick(row){var filter=[];var conditions=[];conditions[index]={value:row[colName]};filter[blockIndex]={conditions:conditions};form.setFieldsValue({filter:filter});resetValues();setIsValuesModalVisible(false);}});})));}):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{disabled:form.getFieldValue('filter['+blockIndex+'].conditions['+index+'].comparisonOperator')===null||disabled,style:{width:'100%'},size:'small'}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:3},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:onDelete,icon:'delete',size:'small',style:{width:'100%'},disabled:disabled})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["b" /* connect */])(mapStateToProps))(FilterFormBlockCondition));

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollBarWidth;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTextWidth;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTextHeight;
var $=window.jQuery;/* https://stackoverflow.com/questions/986937/how-can-i-get-the-browsers-scrollbar-sizes */function getScrollBarWidth(){var temp=$('<div>').css({visibility:'hidden',width:100,overflow:'scroll'}).appendTo('body');var widthWithScroll=$('<div>').css({width:'100%'}).appendTo(temp).outerWidth();temp.remove();return 100-widthWithScroll;}function getTextWidth(text,element){if(typeof text==="string"&&text.length>0){element.innerText=text;return element.offsetWidth;}else{return 0;}}function getTextHeight(text,element){element.innerText=typeof text==="string"&&text.length>0?text:"";return element.offsetHeight;}

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SORT_DIRECTION_ASC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SORT_DIRECTION_DESC; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);
var SORT_DIRECTION_ASC='SORT_DIRECTION_ASC';var SORT_DIRECTION_DESC='SORT_DIRECTION_DESC';var SortButtons=function SortButtons(_ref){var value=_ref.value,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'infinite-scroll-table__header__sort-buttons__icon-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{className:'infinite-scroll-table__header__icon '+(value===SORT_DIRECTION_ASC?"infinite-scroll-table__header__icon--active":""),type:'caret-up',onClick:function onClick(){return onChange(value!==SORT_DIRECTION_ASC?SORT_DIRECTION_ASC:null);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'infinite-scroll-table__header__sort-buttons__icon-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{className:'infinite-scroll-table__header__icon '+(value===SORT_DIRECTION_DESC?"infinite-scroll-table__header__icon--active":""),type:'caret-down',onClick:function onClick(){return onChange(value!==SORT_DIRECTION_DESC?SORT_DIRECTION_DESC:null);}})));};/* harmony default export */ __webpack_exports__["c"] = (SortButtons);

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_menu__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_css__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search_input__ = __webpack_require__(470);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var FilterButton=function FilterButton(_ref){var value=_ref.value,_onChange=_ref.onChange,options=_ref.options;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default.a,{trigger:['click'],overlay:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a,{className:options?"infinite-scroll-table__header__filter-button__options-container":null,style:{width:'100%'}},options&&options.length?options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item,{className:'infinite-scroll-table__header__filter-button__option',key:index,disabled:true,style:{cursor:"auto"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,{style:{marginRight:8},checked:(value||[]).find(function(val){return val===option.value;})!==undefined,onChange:function onChange(_ref2){var target=_ref2.target;return target.checked?_onChange([].concat(_toConsumableArray(value||[]),[option.value])):_onChange((value||[]).filter(function(val){return val!==option.value;}));}}),option.text);}):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item,{disabled:true,style:{cursor:"auto"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__search_input__["a" /* default */],{onSearch:_onChange,value:value})))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'infinite-scroll-table__header__filter-button__icon-container'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{className:'infinite-scroll-table__header__icon '+(value?"infinite-scroll-table__header__icon--active":""),type:'filter',theme:'filled'})));};/* harmony default export */ __webpack_exports__["a"] = (FilterButton);

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(1042);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Dropdown__["a" /* default */]);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_trigger__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placements__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    if ('visible' in props) {
      _this.state = {
        visible: props.visible
      };
    } else {
      _this.state = {
        visible: props.defaultVisible
      };
    }
    return _this;
  }

  Dropdown.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    if ('visible' in nextProps) {
      return {
        visible: nextProps.visible
      };
    }
    return null;
  };

  Dropdown.prototype.getOverlayElement = function getOverlayElement() {
    var overlay = this.props.overlay;

    var overlayElement = void 0;
    if (typeof overlay === 'function') {
      overlayElement = overlay();
    } else {
      overlayElement = overlay;
    }
    return overlayElement;
  };

  Dropdown.prototype.getMenuElementOrLambda = function getMenuElementOrLambda() {
    var overlay = this.props.overlay;

    if (typeof overlay === 'function') {
      return this.getMenuElement;
    }
    return this.getMenuElement();
  };

  Dropdown.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Dropdown.prototype.getOpenClassName = function getOpenClassName() {
    var _props = this.props,
        openClassName = _props.openClassName,
        prefixCls = _props.prefixCls;

    if (openClassName !== undefined) {
      return openClassName;
    }
    return prefixCls + '-open';
  };

  Dropdown.prototype.renderChildren = function renderChildren() {
    var children = this.props.children;
    var visible = this.state.visible;

    var childrenProps = children.props ? children.props : {};
    var childClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(childrenProps.className, this.getOpenClassName());
    return visible && children ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(children, { className: childClassName }) : children;
  };

  Dropdown.prototype.render = function render() {
    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        transitionName = _props2.transitionName,
        animation = _props2.animation,
        align = _props2.align,
        placement = _props2.placement,
        getPopupContainer = _props2.getPopupContainer,
        showAction = _props2.showAction,
        hideAction = _props2.hideAction,
        overlayClassName = _props2.overlayClassName,
        overlayStyle = _props2.overlayStyle,
        trigger = _props2.trigger,
        otherProps = _objectWithoutProperties(_props2, ['prefixCls', 'transitionName', 'animation', 'align', 'placement', 'getPopupContainer', 'showAction', 'hideAction', 'overlayClassName', 'overlayStyle', 'trigger']);

    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
      triggerHideAction = ['click'];
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_rc_trigger__["default"],
      _extends({}, otherProps, {
        prefixCls: prefixCls,
        ref: this.saveTrigger,
        popupClassName: overlayClassName,
        popupStyle: overlayStyle,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_5__placements__["a" /* default */],
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction || [],
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: this.state.visible,
        afterPopupVisibleChange: this.afterVisibleChange,
        popup: this.getMenuElementOrLambda(),
        onPopupVisibleChange: this.onVisibleChange,
        getPopupContainer: getPopupContainer
      }),
      this.renderChildren()
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dropdown.propTypes = {
  minOverlayWidthMatchTrigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  alignPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  hideAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Dropdown.defaultProps = {
  prefixCls: 'rc-dropdown',
  trigger: ['hover'],
  showAction: [],
  overlayClassName: '',
  overlayStyle: {},
  defaultVisible: false,
  onVisibleChange: function onVisibleChange() {},

  placement: 'bottomLeft'
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClick = function (e) {
    var props = _this2.props;
    var overlayProps = _this2.getOverlayElement().props;
    // do no call onVisibleChange, if you need click to hide, use onClick and control visible
    if (!('visible' in props)) {
      _this2.setState({
        visible: false
      });
    }
    if (props.onOverlayClick) {
      props.onOverlayClick(e);
    }
    if (overlayProps.onClick) {
      overlayProps.onClick(e);
    }
  };

  this.onVisibleChange = function (visible) {
    var props = _this2.props;
    if (!('visible' in props)) {
      _this2.setState({
        visible: visible
      });
    }
    props.onVisibleChange(visible);
  };

  this.getMinOverlayWidthMatchTrigger = function () {
    var _props3 = _this2.props,
        minOverlayWidthMatchTrigger = _props3.minOverlayWidthMatchTrigger,
        alignPoint = _props3.alignPoint;

    if ('minOverlayWidthMatchTrigger' in _this2.props) {
      return minOverlayWidthMatchTrigger;
    }

    return !alignPoint;
  };

  this.getMenuElement = function () {
    var prefixCls = _this2.props.prefixCls;

    var overlayElement = _this2.getOverlayElement();
    var extraOverlayProps = {
      prefixCls: prefixCls + '-menu',
      onClick: _this2.onClick
    };
    if (typeof overlayElement.type === 'string') {
      delete extraOverlayProps.prefixCls;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(overlayElement, extraOverlayProps);
  };

  this.afterVisibleChange = function (visible) {
    if (visible && _this2.getMinOverlayWidthMatchTrigger()) {
      var overlayNode = _this2.getPopupDomNode();
      var rootNode = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this2);
      if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
        overlayNode.style.minWidth = rootNode.offsetWidth + 'px';
        if (_this2.trigger && _this2.trigger._component && _this2.trigger._component.alignInstance) {
          _this2.trigger._component.alignInstance.forceAlign();
        }
      }
    }
  };

  this.saveTrigger = function (node) {
    _this2.trigger = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(Dropdown);

/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topCenter: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomCenter: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  }
};

/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _button = _interopRequireDefault(__webpack_require__(7));

var _configProvider = __webpack_require__(35);

var _dropdown = _interopRequireDefault(__webpack_require__(469));

var _classnames = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = _button["default"].Group;

var DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownButton, _React$Component);

  function DropdownButton() {
    var _this;

    _classCallCheck(this, DropdownButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownButton).apply(this, arguments));

    _this.renderButton = function (_ref) {
      var getContextPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          disabled = _a.disabled,
          onClick = _a.onClick,
          htmlType = _a.htmlType,
          children = _a.children,
          className = _a.className,
          overlay = _a.overlay,
          trigger = _a.trigger,
          align = _a.align,
          visible = _a.visible,
          onVisibleChange = _a.onVisibleChange,
          placement = _a.placement,
          getPopupContainer = _a.getPopupContainer,
          href = _a.href,
          restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href"]);

      var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
      var dropdownProps = {
        align: align,
        overlay: overlay,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onVisibleChange: onVisibleChange,
        placement: placement,
        getPopupContainer: getPopupContainer || getContextPopupContainer
      };

      if ('visible' in _this.props) {
        dropdownProps.visible = visible;
      }

      return React.createElement(ButtonGroup, _extends({}, restProps, {
        className: (0, _classnames["default"])(prefixCls, className)
      }), React.createElement(_button["default"], {
        type: type,
        disabled: disabled,
        onClick: onClick,
        htmlType: htmlType,
        href: href
      }, children), React.createElement(_dropdown["default"], dropdownProps, React.createElement(_button["default"], {
        type: type,
        icon: "ellipsis"
      })));
    };

    return _this;
  }

  _createClass(DropdownButton, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
    }
  }]);

  return DropdownButton;
}(React.Component);

exports["default"] = DropdownButton;
DropdownButton.defaultProps = {
  placement: 'bottomRight',
  type: 'default'
};

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _rcMenu = __webpack_require__(182);

var _classnames = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SubMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SubMenu, _React$Component);

  function SubMenu() {
    var _this;

    _classCallCheck(this, SubMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubMenu).apply(this, arguments));

    _this.onKeyDown = function (e) {
      _this.subMenu.onKeyDown(e);
    };

    _this.saveSubMenu = function (subMenu) {
      _this.subMenu = subMenu;
    };

    return _this;
  }

  _createClass(SubMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rootPrefixCls = _this$props.rootPrefixCls,
          className = _this$props.className;
      var theme = this.context.antdMenuTheme;
      return React.createElement(_rcMenu.SubMenu, _extends({}, this.props, {
        ref: this.saveSubMenu,
        popupClassName: (0, _classnames["default"])("".concat(rootPrefixCls, "-").concat(theme), className)
      }));
    }
  }]);

  return SubMenu;
}(React.Component);

SubMenu.contextTypes = {
  antdMenuTheme: PropTypes.string
}; // fix issue:https://github.com/ant-design/ant-design/issues/8666

SubMenu.isSubMenu = 1;
var _default = SubMenu;
exports["default"] = _default;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = __webpack_require__(182);

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _tooltip = _interopRequireDefault(__webpack_require__(155));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).apply(this, arguments));

    _this.onKeyDown = function (e) {
      _this.menuItem.onKeyDown(e);
    };

    _this.saveMenuItem = function (menuItem) {
      _this.menuItem = menuItem;
    };

    return _this;
  }

  _createClass(MenuItem, [{
    key: "render",
    value: function render() {
      var inlineCollapsed = this.context.inlineCollapsed;
      var _this$props = this.props,
          level = _this$props.level,
          children = _this$props.children,
          rootPrefixCls = _this$props.rootPrefixCls;

      var _a = this.props,
          title = _a.title,
          rest = __rest(_a, ["title"]);

      var titleNode;

      if (inlineCollapsed) {
        titleNode = title || (level === 1 ? children : '');
      }

      return React.createElement(_tooltip["default"], {
        title: titleNode,
        placement: "right",
        overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
      }, React.createElement(_rcMenu.Item, _extends({}, rest, {
        title: inlineCollapsed ? null : title,
        ref: this.saveMenuItem
      })));
    }
  }]);

  return MenuItem;
}(React.Component);

MenuItem.contextTypes = {
  inlineCollapsed: PropTypes.bool
};
MenuItem.isMenuItem = 1;
var _default = MenuItem;
exports["default"] = _default;

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIndexesFromPaginationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPaginationParamsFromIndexes; });
var getIndexesFromPaginationParams=function getIndexesFromPaginationParams(pageSize,pageNum){return{startIdx:pageSize*(pageNum-1),stopIdx:pageSize*pageNum-1};};var getPaginationParamsFromIndexes=function getPaginationParamsFromIndexes(startIdx,stopIdx,maxIdx){var minPageSize=stopIdx-startIdx+1;var maxPageSize=maxIdx+1;var pageNumForMinPageSize=(stopIdx+1)/minPageSize;if(Number.isInteger(pageNumForMinPageSize)){return{pageSize:minPageSize,pageNum:pageNumForMinPageSize};}else{for(var pageSize=minPageSize+1;pageSize<=maxPageSize;pageSize++){var minPageNum=Math.ceil((stopIdx+1)/pageSize);var maxPageNum=Math.floor(startIdx/pageSize+1);for(var pageNum=minPageNum;pageNum<=maxPageNum;pageNum++){var indexes=getIndexesFromPaginationParams(pageSize,pageNum);if(indexes.startIdx<=startIdx&&stopIdx<=indexes.stopIdx){return{pageSize:pageSize,pageNum:pageNum};}}}}};

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_input__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auto_search_input__ = __webpack_require__(468);
var PreHeader=function PreHeader(_ref){var t=_ref.t,searchText=_ref.searchText,autoSearch=_ref.autoSearch,onSearch=_ref.onSearch,selectedRowCount=_ref.selectedRowCount,tableActions=_ref.tableActions,renderTableAction=_ref.renderTableAction,leftActions=_ref.leftActions,rightActions=_ref.rightActions,searchBarSpan=_ref.searchBarSpan;var searchSpan=searchBarSpan||(leftActions||rightActions||tableActions&&tableActions.length>0?__WEBPACK_IMPORTED_MODULE_4__styles_constants__["SPAN_ONE_QUARTER"]:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["SPAN_HALF"]);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["MARGIN_MD"]},align:"middle"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:searchSpan},function(){var SearchComponent=autoSearch?__WEBPACK_IMPORTED_MODULE_8__auto_search_input__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_5__search_input__["a" /* default */];return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SearchComponent,{placeholder:t('components.infiniteScrollTable.search.placeholder'),value:searchText,onSearch:onSearch});}()),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["SPAN_FULL"]-searchSpan},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"space-between",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,leftActions),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["GUTTER_SM"]},tableActions&&selectedRowCount>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,t('components.infiniteScroll.header.selectedRowCount',{selectedRowCount:selectedRowCount})),tableActions.map(function(action,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{key:index},renderTableAction(action));}))),rightActions&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,rightActions))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])()(PreHeader));

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_spin__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
var Footer=function Footer(_ref){var isLoading=_ref.isLoading,isHidden=_ref.isHidden,rowNumStart=_ref.rowNumStart,rowNumEnd=_ref.rowNumEnd,rowCount=_ref.rowCount,t=_ref.t;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",style:{marginTop:__WEBPACK_IMPORTED_MODULE_6__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,!isHidden?isLoading?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_spin___default.a,{size:"small",className:"infinite-scroll-table__footer__spinner",style:{fontSize:10,width:13,height:13,marginRight:2}}):t('components.infiniteScrollTable.footer.rowInfos',{rowNumStart:rowNumStart,rowNumEnd:rowNumEnd,rowCount:rowCount}):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])()(Footer));

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__(477).forEach;
var elementUtilsMaker       = __webpack_require__(1055);
var listenerHandlerMaker    = __webpack_require__(1056);
var idGeneratorMaker        = __webpack_require__(1057);
var idHandlerMaker          = __webpack_require__(1058);
var reporterMaker           = __webpack_require__(1059);
var browserDetector         = __webpack_require__(478);
var batchProcessorMaker     = __webpack_require__(1060);
var stateHandler            = __webpack_require__(1062);

//Detection strategies.
var objectStrategyMaker     = __webpack_require__(1063);
var scrollStrategyMaker     = __webpack_require__(1064);

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1061);

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__(478);

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        if(!getObject(element)) {
            throw new Error("Element is not detectable by this strategy.");
        }

        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; padding: 0; margin: 0; opacity: 0; z-index: -1000; pointer-events: none;";

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.position = "relative";

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style[property] = 0;
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            setTimeout(function checkForObjectDocument() {
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.setAttribute("aria-hidden", "true");
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if(browserDetector.isIE(8)) {
            element.detachEvent("onresize", getState(element).object.proxy);
        } else {
            element.removeChild(getObject(element));
        }
        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__(477).forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
    // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    injectScrollStyle(styleId, detectionContainerClass);

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = "position: absolute; width: " + width*2 + "px; height: " + height*2 + "px; visibility: hidden; margin: 0; padding: 0;";

        var container = document.createElement("div");
        container.style.cssText = "position: absolute; width: " + width + "px; height: " + height + "px; overflow: scroll; visibility: none; top: " + -width*3 + "px; left: " + -height*3 + "px; visibility: hidden; margin: 0; padding: 0;";

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                document.head.appendChild(element);
            };

            var styleElement = document.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!document.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { display: none; }\n\n";
            style += "." + containerAnimationActiveClass + " { -webkit-animation-duration: 0.1s; animation-duration: 0.1s; -webkit-animation-name: " + containerAnimationClass + "; animation-name: " + containerAnimationClass + "; }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = window.getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = "visibility: hidden; display: inline; width: 0px; height: 0px; z-index: -1; overflow: hidden; margin: 0; padding: 0;";
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.position = "relative";

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return "left: " + left + "; top: " + top + "; right: " + right + "; bottom: " + bottom + ";";
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; width: 100%; height: 100%; left: 0px; top: 0px;";
            var containerStyle          = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; " + getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth);
            var expandStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var shrinkStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var expandChildStyle        = "position: absolute; left: 0; top: 0;";
            var shrinkChildStyle        = "position: absolute; width: 200%; height: 200%;";

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                getState(element).onExpand && getState(element).onExpand();
            }

            function onShrinkScroll() {
                getState(element).onShrink && getState(element).onShrink();
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.width     = expandWidth + "px";
                expandChild.style.height    = expandHeight + "px";
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify the if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                var width = element.offsetWidth;
                var height = element.offsetHeight;

                if (width !== getState(element).lastWidth || height !== getState(element).lastHeight) {
                    debug("Element size changed.");
                    updateDetectorElements(notifyListenersIfNeeded);
                } else {
                    debug("Element size has not changed (" + width + "x" + height + ").");
                }
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */

function debounce (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}




/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TREE_FILTER_SPINNER_SHOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return showQueryFormSpinner; });
var TREE_FILTER_SPINNER_SHOW='TREE_FILTER_SPINNER_SHOW';var showQueryFormSpinner=function showQueryFormSpinner(){return{type:TREE_FILTER_SPINNER_SHOW};};

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__infinite_scroll_data_table__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__localized_date_picker__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var datePickerProps={format:'DD/MM/YYYY'};var isDayInRange=function isDayInRange(day){var min=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var max=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var dayDate=__WEBPACK_IMPORTED_MODULE_23_moment___default()(day);var minDate=__WEBPACK_IMPORTED_MODULE_23_moment___default()(min);var maxDate=__WEBPACK_IMPORTED_MODULE_23_moment___default()(max);if(minDate.isValid()&&maxDate.isValid()){return dayDate>=minDate&&dayDate<=maxDate;}else{return true;}};var TreeFilterTimePeriod=function TreeFilterTimePeriod(_ref){var t=_ref.t,tempTPFrom=_ref.tempTPFrom,tempTPTo=_ref.tempTPTo,treeFilter=_ref.treeFilter,isCC=_ref.isCC,column=_ref.column,columns=_ref.columns,callOnColumnValuesChangeWithSpinner=_ref.callOnColumnValuesChangeWithSpinner,index=_ref.index,isSdmx=_ref.isSdmx,disabled=_ref.disabled,setTPFromTo=_ref.setTPFromTo,usePickers=_ref.usePickers,minDate=_ref.minDate,maxDate=_ref.maxDate;var _useState=Object(__WEBPACK_IMPORTED_MODULE_16_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isTPFromListVisible=_useState2[0],setTPFromListVisible=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_16_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isTPToListVisible=_useState4[0],setTPToListVisible=_useState4[1];var freqCol=columns.find(function(_ref2){var name=_ref2.name;return name==="FREQ"||name==="ID_FREQ";});var onTimePeriodChange=function onTimePeriodChange(newFromTo){var callOnColumnValuesChange=function callOnColumnValuesChange(){var values=newFromTo?[newFromTo.from,newFromTo.to]:[];var newTreeFilter=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.cloneDeep(treeFilter);var columnName=!isCC?column.name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name);newTreeFilter[columnName]={mode:__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["n" /* FILTER_MODE_IN */],values:values};var colNames=columns.map(function(_ref3){var name=_ref3.name;return!isCC?name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(name);});var colIndex=colNames.indexOf(columnName);var subsequentColNames=colNames.splice(colIndex+1);// delete filters for subsequent cols
subsequentColNames.forEach(function(name){delete newTreeFilter[!isCC?name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(name)];});if(Object(__WEBPACK_IMPORTED_MODULE_15__utils__["h" /* getTreeFilterStrFromObj */])(newTreeFilter,colNames).length>__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* TREE_FILTER_MAX_LENGTH */]){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t('components.treeFilter.errors.maxLength.title'),content:t('components.treeFilter.errors.maxLength.content')});}else{callOnColumnValuesChangeWithSpinner(column.name,values);}};var subsequentColumnNames=columns.slice(index+1).map(function(_ref4){var name=_ref4.name;return!isCC?name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(name);});if(subsequentColumnNames.find(function(name){return treeFilter[name];})){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('components.treeFilter.confirms.filterChange.title'),content:t('components.treeFilter.confirms.filterChange.content'),onOk:function onOk(){callOnColumnValuesChange();},cancelText:t('commons.buttons.cancel.title')});}else{callOnColumnValuesChange();}};return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,(isSdmx||isCC)&&(tempTPFrom!==null&&tempTPTo===null||tempTPFrom===null&&tempTPTo!==null)&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a,{type:"warning",showIcon:true,message:t('components.treeFilter.warnings.incompleteTimePeriod.title'),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}}),usePickers?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_THREE_QUARTERS"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('components.treeFilter.timePeriod.from.title'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]},className:"form-item-required"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__localized_date_picker__["a" /* default */],Object.assign({disabled:disabled},datePickerProps,{onChange:function onChange(val){var newFromTo={from:val?val.format("YYYY-MM-DDT00:00:00.000")+"Z":null,to:tempTPTo||(treeFilter[column.name]&&treeFilter[column.name].values.length>0?treeFilter[column.name].values[1]:treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]&&treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values.length>0?treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values[1]:null)};setTPFromTo({tempTPFrom:newFromTo.from,tempTPTo:newFromTo.to});if(newFromTo.from&&newFromTo.to){onTimePeriodChange(newFromTo);}else{onTimePeriodChange(null);}},value:treeFilter[column.name]&&treeFilter[column.name].values.length>0?__WEBPACK_IMPORTED_MODULE_23_moment___default.a.utc(treeFilter[column.name].values[0]):treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]&&treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values.length>0?__WEBPACK_IMPORTED_MODULE_23_moment___default.a.utc(treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values[0]):tempTPFrom?__WEBPACK_IMPORTED_MODULE_23_moment___default.a.utc(tempTPFrom):null,disabledDate:function disabledDate(date){return!isDayInRange(date,minDate,maxDate);},defaultPickerValue:minDate&&maxDate?minDate:null}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_THREE_QUARTERS"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('components.treeFilter.timePeriod.to.title'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]},className:"form-item-required"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__localized_date_picker__["a" /* default */],Object.assign({disabled:disabled},datePickerProps,{onChange:function onChange(val){var newFromTo={from:tempTPFrom||(treeFilter[column.name]&&treeFilter[column.name].values.length>0?treeFilter[column.name].values[0]:treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]&&treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values.length>0?treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values[0]:null),to:val?val.format("YYYY-MM-DDT00:00:00.000")+"Z":null};setTPFromTo({tempTPFrom:newFromTo.from,tempTPTo:newFromTo.to});if(newFromTo.from&&newFromTo.to){onTimePeriodChange(newFromTo);}else{onTimePeriodChange(null);}},value:treeFilter[column.name]&&treeFilter[column.name].values.length>0?__WEBPACK_IMPORTED_MODULE_23_moment___default.a.utc(treeFilter[column.name].values[1]):treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]&&treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values.length>0?__WEBPACK_IMPORTED_MODULE_23_moment___default.a.utc(treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values[1]):tempTPTo?__WEBPACK_IMPORTED_MODULE_23_moment___default.a.utc(tempTPTo):null,disabledDate:function disabledDate(date){return!isDayInRange(date,minDate,maxDate);},defaultPickerValue:minDate&&maxDate?maxDate:null})))))):!isCC||!freqCol||freqCol.filteredValues?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_THREE_QUARTERS"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('components.treeFilter.timePeriod.from.title'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__selector__["a" /* default */],{disabled:disabled,selectTitle:t('components.treeFilter.timePeriod.selector.selectButton.title'),resetTitle:t('components.treeFilter.timePeriod.selector.resetButton.title'),onSelect:function onSelect(){return setTPFromListVisible(true);},onReset:function onReset(){var newFromTo={from:null,to:tempTPTo||(treeFilter[column.name]&&treeFilter[column.name].values.length>0?treeFilter[column.name].values[1]:treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]&&treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values.length>0?treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values[1]:null)};setTPFromTo({tempTPFrom:newFromTo.from,tempTPTo:newFromTo.to});if(isSdmx||isCC){onTimePeriodChange(null);}else{onTimePeriodChange(newFromTo);}},value:treeFilter[column.name]&&treeFilter[column.name].values.length>0?treeFilter[column.name].values[0]:treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]&&treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values.length>0?treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values[0]:tempTPFrom||null,render:function render(val){return isCC&&val!==null?Object(__WEBPACK_IMPORTED_MODULE_15__utils__["f" /* getTimePeriodColumnValFromDateTimeStr */])(val,freqCol?Object(__WEBPACK_IMPORTED_MODULE_15__utils__["d" /* getBestFrequency */])(freqCol.filteredValues):"A"):val;}})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_THREE_QUARTERS"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('components.treeFilter.timePeriod.to.title'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__selector__["a" /* default */],{disabled:disabled,selectTitle:t('components.treeFilter.timePeriod.selector.selectButton.title'),resetTitle:t('components.treeFilter.timePeriod.selector.resetButton.title'),onSelect:function onSelect(){return setTPToListVisible(true);},onReset:function onReset(){var newFromTo={from:tempTPFrom||(treeFilter[column.name]&&treeFilter[column.name].values.length>0?treeFilter[column.name].values[0]:treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]&&treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values.length>0?treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values[0]:null),to:null};setTPFromTo({tempTPFrom:newFromTo.from,tempTPTo:newFromTo.to});if(isSdmx||isCC){onTimePeriodChange(null);}else{onTimePeriodChange(newFromTo);}},value:treeFilter[column.name]&&treeFilter[column.name].values.length>0?treeFilter[column.name].values[1]:treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]&&treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values.length>0?treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values[1]:tempTPTo||null,render:function render(val){return isCC&&val!==null?Object(__WEBPACK_IMPORTED_MODULE_15__utils__["f" /* getTimePeriodColumnValFromDateTimeStr */])(val,freqCol?Object(__WEBPACK_IMPORTED_MODULE_15__utils__["d" /* getBestFrequency */])(freqCol.filteredValues):"A"):val;}})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__enhanced_modal__["a" /* default */],{visible:isTPFromListVisible||isTPToListVisible,width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_MD"],title:t('components.treeFilter.timePeriod.valuesModal.title'),footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){setTPFromListVisible(false);setTPToListVisible(false);}},t('commons.buttons.close.title')),onCancel:function onCancel(){setTPFromListVisible(false);setTPToListVisible(false);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__infinite_scroll_data_table__["a" /* default */],{isPaginated:false,noFilter:true,noSort:true,data:column.filteredValues?column.filteredValues.filter(function(val){return val!==null;}).map(function(val){return _defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name),val);}):null,cols:[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)],onRowClick:function onRowClick(row){var rowVal=row[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)];var val=isCC?Object(__WEBPACK_IMPORTED_MODULE_15__utils__["e" /* getDateTimeStrFromTimePeriodColumnVal */])(rowVal,isTPToListVisible):rowVal;var newFromTo=void 0;if(isTPFromListVisible){newFromTo={from:val,to:tempTPTo};setTPFromListVisible(false);setTPFromTo({tempTPFrom:newFromTo.from});}else{newFromTo={from:tempTPFrom,to:val};setTPToListVisible(false);setTPFromTo({tempTPTo:newFromTo.to});}if(!isSdmx||isSdmx&&newFromTo.from&&newFromTo.to){onTimePeriodChange(newFromTo);}}}))):null);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_react_i18next__["b" /* translate */])()(TreeFilterTimePeriod));

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__date_DateTable__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar_CalendarHeader__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calendar_CalendarFooter__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__date_DateInput__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_toTime__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);



















function noop() {}

var Calendar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Calendar, _React$Component);

  function Calendar(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Calendar);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      mode: _this.props.mode || 'date',
      value: props.value || props.defaultValue || __WEBPACK_IMPORTED_MODULE_17_moment___default()(),
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    if (this.props.showDateInput) {
      this.saveFocusElement(__WEBPACK_IMPORTED_MODULE_14__date_DateInput__["a" /* default */].getInstance());
    }
  };

  Calendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var value = nextProps.value,
        selectedValue = nextProps.selectedValue;

    var newState = {};

    if ('mode' in nextProps && state.mode !== nextProps.mode) {
      newState = { mode: nextProps.mode };
    }
    if ('value' in nextProps) {
      newState.value = value || nextProps.defaultValue || Object(__WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["d" /* getNowByCurrentStateValue */])(state.value);
    }
    if ('selectedValue' in nextProps) {
      newState.selectedValue = selectedValue;
    }

    return newState;
  };

  Calendar.prototype.render = function render() {
    var props = this.props,
        state = this.state;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        disabledDate = props.disabledDate,
        dateInputPlaceholder = props.dateInputPlaceholder,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime,
        clearIcon = props.clearIcon,
        renderFooter = props.renderFooter;
    var value = state.value,
        selectedValue = state.selectedValue,
        mode = state.mode;

    var showTimePicker = mode === 'time';
    var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? Object(__WEBPACK_IMPORTED_MODULE_15__util__["c" /* getTimeConfig */])(selectedValue, disabledTime) : null;

    var timePickerEle = null;

    if (timePicker && showTimePicker) {
      var timePickerProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        showHour: true,
        showSecond: true,
        showMinute: true
      }, timePicker.props, disabledTimeConfig, {
        onChange: this.onDateInputChange,
        value: selectedValue,
        disabledTime: disabledTime
      });

      if (timePicker.props.defaultValue !== undefined) {
        timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
      }

      timePickerEle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(timePicker, timePickerProps);
    }

    var dateInputElement = props.showDateInput ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__date_DateInput__["a" /* default */], {
      format: this.getFormat(),
      key: 'date-input',
      value: value,
      locale: locale,
      placeholder: dateInputPlaceholder,
      showClear: true,
      disabledTime: disabledTime,
      disabledDate: disabledDate,
      onClear: this.onClear,
      prefixCls: prefixCls,
      selectedValue: selectedValue,
      onChange: this.onDateInputChange,
      onSelect: this.onDateInputSelect,
      clearIcon: clearIcon
    }) : null;

    var children = [];
    if (props.renderSidebar) {
      children.push(props.renderSidebar());
    }
    children.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: prefixCls + '-panel', key: 'panel' },
      dateInputElement,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          tabIndex: this.props.focusablePanel ? 0 : undefined,
          className: prefixCls + '-date-panel'
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__calendar_CalendarHeader__["a" /* default */], {
          locale: locale,
          mode: mode,
          value: value,
          onValueChange: this.setValue,
          onPanelChange: this.onPanelChange,
          renderFooter: renderFooter,
          showTimePicker: showTimePicker,
          prefixCls: prefixCls
        }),
        timePicker && showTimePicker ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-time-picker' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            { className: prefixCls + '-time-picker-panel' },
            timePickerEle
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__date_DateTable__["a" /* default */], {
            locale: locale,
            value: value,
            selectedValue: selectedValue,
            prefixCls: prefixCls,
            dateRender: props.dateRender,
            onSelect: this.onDateTableSelect,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__calendar_CalendarFooter__["a" /* default */], {
          showOk: props.showOk,
          mode: mode,
          renderFooter: props.renderFooter,
          locale: locale,
          prefixCls: prefixCls,
          showToday: props.showToday,
          disabledTime: disabledTime,
          showTimePicker: showTimePicker,
          showDateInput: props.showDateInput,
          timePicker: timePicker,
          selectedValue: selectedValue,
          value: value,
          disabledDate: disabledDate,
          okDisabled: props.showOk !== false && (!selectedValue || !this.isAllowedDate(selectedValue)),
          onOk: this.onOk,
          onSelect: this.onSelect,
          onToday: this.onToday,
          onOpenTimePicker: this.openTimePicker,
          onCloseTimePicker: this.closeTimePicker
        })
      )
    ));

    return this.renderRoot({
      children: children,
      className: props.showWeekNumber ? prefixCls + '-week-number' : ''
    });
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Calendar.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["b" /* calendarMixinPropTypes */], __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["c" /* propType */], {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  selectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultSelectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['time', 'date', 'month', 'year', 'decade']),
  locale: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  showDateInput: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showToday: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  timePicker: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element,
  dateInputPlaceholder: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onClear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onPanelChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabledTime: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  dateRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  renderSidebar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  clearIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  focusablePanel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
});
Calendar.defaultProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["a" /* calendarMixinDefaultProps */], __WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["b" /* defaultProp */], {
  showToday: true,
  showDateInput: true,
  timePicker: null,
  onOk: noop,
  onPanelChange: noop,
  focusablePanel: true
});

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    if (!('mode' in props)) {
      _this2.setState({ mode: mode });
    }
    props.onPanelChange(value || state.value, mode);
  };

  this.onKeyDown = function (event) {
    if (event.target.nodeName.toLowerCase() === 'input') {
      return undefined;
    }
    var keyCode = event.keyCode;
    // mac
    var ctrlKey = event.ctrlKey || event.metaKey;
    var disabledDate = _this2.props.disabledDate;
    var value = _this2.state.value;

    switch (keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].DOWN:
        _this2.goTime(1, 'weeks');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].UP:
        _this2.goTime(-1, 'weeks');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].LEFT:
        if (ctrlKey) {
          _this2.goTime(-1, 'years');
        } else {
          _this2.goTime(-1, 'days');
        }
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].RIGHT:
        if (ctrlKey) {
          _this2.goTime(1, 'years');
        } else {
          _this2.goTime(1, 'days');
        }
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].HOME:
        _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["b" /* goStartMonth */])(_this2.state.value));
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].END:
        _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["a" /* goEndMonth */])(_this2.state.value));
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
        _this2.goTime(1, 'month');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
        _this2.goTime(-1, 'month');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER:
        if (!disabledDate || !disabledDate(value)) {
          _this2.onSelect(value, {
            source: 'keyboard'
          });
        }
        event.preventDefault();
        return 1;
      default:
        _this2.props.onKeyDown(event);
        return 1;
    }
  };

  this.onClear = function () {
    _this2.onSelect(null);
    _this2.props.onClear();
  };

  this.onOk = function () {
    var selectedValue = _this2.state.selectedValue;

    if (_this2.isAllowedDate(selectedValue)) {
      _this2.props.onOk(selectedValue);
    }
  };

  this.onDateInputChange = function (value) {
    _this2.onSelect(value, {
      source: 'dateInput'
    });
  };

  this.onDateInputSelect = function (value) {
    _this2.onSelect(value, {
      source: 'dateInputSelect'
    });
  };

  this.onDateTableSelect = function (value) {
    var timePicker = _this2.props.timePicker;
    var selectedValue = _this2.state.selectedValue;

    if (!selectedValue && timePicker) {
      var timePickerDefaultValue = timePicker.props.defaultValue;
      if (timePickerDefaultValue) {
        Object(__WEBPACK_IMPORTED_MODULE_15__util__["h" /* syncTime */])(timePickerDefaultValue, value);
      }
    }
    _this2.onSelect(value);
  };

  this.onToday = function () {
    var value = _this2.state.value;

    var now = Object(__WEBPACK_IMPORTED_MODULE_15__util__["e" /* getTodayTime */])(value);
    _this2.onSelect(now, {
      source: 'todayButton'
    });
  };

  this.getRootDOMNode = function () {
    return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this2);
  };

  this.openTimePicker = function () {
    _this2.onPanelChange(null, 'time');
  };

  this.closeTimePicker = function () {
    _this2.onPanelChange(null, 'date');
  };

  this.goTime = function (direction, unit) {
    _this2.setValue(Object(__WEBPACK_IMPORTED_MODULE_16__util_toTime__["c" /* goTime */])(_this2.state.value, direction, unit));
  };
};

Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(Calendar);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__mixin_CalendarMixin__["c" /* calendarMixinWrapper */])(Object(__WEBPACK_IMPORTED_MODULE_13__mixin_CommonMixin__["a" /* commonMixinWrapper */])(Calendar)));

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateTHead__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateTBody__ = __webpack_require__(1075);








var DateTable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTable, _React$Component);

  function DateTable() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTable);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTable.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DateTHead__["a" /* default */], props),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DateTBody__["a" /* default */], props)
    );
  };

  return DateTable;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DateTable);

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateConstants__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var DateTHead = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTHead, _React$Component);

  function DateTHead() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTHead);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl = void 0;
    var now = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
    for (var dateColIndex = 0; dateColIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          veryShortWeekdays[xindex]
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'thead',
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DateTHead);

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateConstants__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___ = __webpack_require__(158);









function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
}

var DateTBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTBody, _React$Component);

  function DateTBody() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTBody);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTBody.prototype.render = function render() {
    var props = this.props;
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var iIndex = void 0;
    var jIndex = void 0;
    var current = void 0;
    var dateTable = [];
    var today = Object(__WEBPACK_IMPORTED_MODULE_7__util___["e" /* getTodayTime */])(value);
    var cellClass = prefixCls + '-cell';
    var weekNumberCellClass = prefixCls + '-week-number-cell';
    var dateClass = prefixCls + '-date';
    var todayClass = prefixCls + '-today';
    var selectedClass = prefixCls + '-selected-day';
    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
    var selectedStartDateClass = prefixCls + '-selected-start-date';
    var selectedEndDateClass = prefixCls + '-selected-end-date';
    var inRangeClass = prefixCls + '-in-range-cell';
    var lastMonthDayClass = prefixCls + '-last-month-cell';
    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
    var disabledClass = prefixCls + '-disabled-cell';
    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
    var month1 = value.clone();
    month1.date(1);
    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
    // calculate last month
    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }
        dateTable.push(current);
        passed++;
      }
    }
    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: dateTable[passed].week(),
            role: 'gridcell',
            className: weekNumberCellClass
          },
          dateTable[passed].week()
        );
      }
      for (jIndex = 0; jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];
        if (jIndex < __WEBPACK_IMPORTED_MODULE_6__DateConstants__["a" /* default */].DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += ' ' + todayClass;
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedStartDateClass;
              }
            }
            if (startValue && endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedEndDateClass;
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += ' ' + selectedDateClass;
        }

        if (isBeforeCurrentMonthYear) {
          cls += ' ' + lastMonthDayClass;
        }

        if (isAfterCurrentMonthYear) {
          cls += ' ' + nextMonthDayClass;
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += ' ' + lastDayOfMonthClass;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ' ' + firstDisableClass;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ' ' + lastDisableClass;
            }
          }
        }

        if (selected) {
          cls += ' ' + selectedClass;
        }

        if (disabled) {
          cls += ' ' + disabledClass;
        }

        var dateHtml = void 0;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            {
              key: getIdFromDate(current),
              className: dateClass,
              'aria-selected': selected,
              'aria-disabled': disabled
            },
            content
          );
        }

        dateCells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: passed,
            onClick: disabled ? undefined : props.onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: 'gridcell',
            title: Object(__WEBPACK_IMPORTED_MODULE_7__util___["d" /* getTitleString */])(current),
            className: cls
          },
          dateHtml
        ));

        passed++;
      }

      tableHtml.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        {
          key: iIndex,
          role: 'row',
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
        },
        weekNumberCell,
        dateCells
      ));
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'tbody',
      { className: prefixCls + '-tbody' },
      tableHtml
    );
  };

  return DateTBody;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DateTBody.propTypes = {
  contentRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  dateRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  selectedValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object)]),
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  hoverValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
DateTBody.defaultProps = {
  hoverValue: []
};
/* harmony default export */ __webpack_exports__["a"] = (DateTBody);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Children_mapSelf__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__month_MonthPanel__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__year_YearPanel__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decade_DecadePanel__ = __webpack_require__(1080);










function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CalendarHeader, _React$Component);

  function CalendarHeader(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CalendarHeader);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.nextMonth = goMonth.bind(_this, 1);
    _this.previousMonth = goMonth.bind(_this, -1);
    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);

    _this.state = { yearPanelReferer: null };
    return _this;
  }

  CalendarHeader.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth,
        renderFooter = props.renderFooter;


    var panel = null;
    if (mode === 'month') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__month_MonthPanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onMonthSelect,
        onYearPanelShow: function onYearPanelShow() {
          return _this2.showYearPanel('month');
        },
        disabledDate: disabledMonth,
        cellRender: props.monthCellRender,
        contentRender: props.monthCellContentRender,
        renderFooter: renderFooter
      });
    }
    if (mode === 'year') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__year_YearPanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onYearSelect,
        onDecadePanelShow: this.showDecadePanel,
        renderFooter: renderFooter
      });
    }
    if (mode === 'decade') {
      panel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__decade_DecadePanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onDecadeSelect,
        renderFooter: renderFooter
      });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-header' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { style: { position: 'relative' } },
        showIf(enablePrev && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-year-btn',
          role: 'button',
          onClick: this.previousYear,
          title: locale.previousYear
        })),
        showIf(enablePrev && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-month-btn',
          role: 'button',
          onClick: this.previousMonth,
          title: locale.previousMonth
        })),
        this.monthYearElement(showTimePicker),
        showIf(enableNext && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-month-btn',
          onClick: this.nextMonth,
          title: locale.nextMonth
        })),
        showIf(enableNext && !showTimePicker, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-year-btn',
          onClick: this.nextYear,
          title: locale.nextYear
        }))
      ),
      panel
    );
  };

  return CalendarHeader;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CalendarHeader.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  onValueChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  showTimePicker: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  onPanelChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  enablePrev: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  enableNext: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  disabledMonth: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMonthSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
CalendarHeader.defaultProps = {
  enableNext: 1,
  enablePrev: 1,
  onPanelChange: function onPanelChange() {},
  onValueChange: function onValueChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onMonthSelect = function (value) {
    _this3.props.onPanelChange(value, 'date');
    if (_this3.props.onMonthSelect) {
      _this3.props.onMonthSelect(value);
    } else {
      _this3.props.onValueChange(value);
    }
  };

  this.onYearSelect = function (value) {
    var referer = _this3.state.yearPanelReferer;
    _this3.setState({ yearPanelReferer: null });
    _this3.props.onPanelChange(value, referer);
    _this3.props.onValueChange(value);
  };

  this.onDecadeSelect = function (value) {
    _this3.props.onPanelChange(value, 'year');
    _this3.props.onValueChange(value);
  };

  this.monthYearElement = function (showTimePicker) {
    var props = _this3.props;
    var prefixCls = props.prefixCls;
    var locale = props.locale;
    var value = props.value;
    var localeData = value.localeData();
    var monthBeforeYear = locale.monthBeforeYear;
    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
    var timeClassName = showTimePicker ? ' ' + prefixCls + '-time-status' : '';
    var year = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      {
        className: prefixCls + '-year-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : function () {
          return _this3.showYearPanel('date');
        },
        title: showTimePicker ? null : locale.yearSelect
      },
      value.format(locale.yearFormat)
    );
    var month = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'a',
      {
        className: prefixCls + '-month-select' + timeClassName,
        role: 'button',
        onClick: showTimePicker ? null : _this3.showMonthPanel,
        title: showTimePicker ? null : locale.monthSelect
      },
      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
    );
    var day = void 0;
    if (showTimePicker) {
      day = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'a',
        {
          className: prefixCls + '-day-select' + timeClassName,
          role: 'button'
        },
        value.format(locale.dayFormat)
      );
    }
    var my = [];
    if (monthBeforeYear) {
      my = [month, day, year];
    } else {
      my = [year, month, day];
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'span',
      { className: selectClassName },
      Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Children_mapSelf__["a" /* default */])(my)
    );
  };

  this.showMonthPanel = function () {
    // null means that users' interaction doesn't change value
    _this3.props.onPanelChange(null, 'month');
  };

  this.showYearPanel = function (referer) {
    _this3.setState({ yearPanelReferer: referer });
    _this3.props.onPanelChange(null, 'year');
  };

  this.showDecadePanel = function () {
    _this3.props.onPanelChange(null, 'decade');
  };
};

/* harmony default export */ __webpack_exports__["a"] = (CalendarHeader);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonthTable__ = __webpack_require__(1078);








function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'year');
  this.setAndChangeValue(next);
}

function noop() {}

var MonthPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MonthPanel, _React$Component);

  function MonthPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MonthPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.setAndChangeValue = function (value) {
      _this.setValue(value);
      _this.props.onChange(value);
    };

    _this.setAndSelectValue = function (value) {
      _this.setValue(value);
      _this.props.onSelect(value);
    };

    _this.setValue = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }
    };

    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);
    _this.prefixCls = props.rootPrefixCls + '-month-panel';

    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  MonthPanel.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    var newState = {};

    if ('value' in nextProps) {
      newState = {
        value: nextProps.value
      };
    }

    return newState;
  };

  MonthPanel.prototype.render = function render() {
    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        cellRender = props.cellRender,
        contentRender = props.contentRender,
        renderFooter = props.renderFooter;

    var year = value.year();
    var prefixCls = this.prefixCls;

    var footer = renderFooter && renderFooter('month');

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls, style: props.style },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-header' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-year-select',
              role: 'button',
              onClick: props.onYearPanelShow,
              title: locale.yearSelect
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-year-select-content' },
              year
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-year-select-arrow' },
              'x'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MonthTable__["a" /* default */], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          })
        ),
        footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return MonthPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MonthPanel.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabledDate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
MonthPanel.defaultProps = {
  onChange: noop,
  onSelect: noop
};


Object(__WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__["polyfill"])(MonthPanel);

/* harmony default export */ __webpack_exports__["a"] = (MonthPanel);

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_index__ = __webpack_require__(158);








var ROW = 4;
var COL = 3;

function chooseMonth(month) {
  var next = this.state.value.clone();
  next.month(month);
  this.setAndSelectValue(next);
}

function noop() {}

var MonthTable = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MonthTable, _Component);

  function MonthTable(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MonthTable);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _this.state = {
      value: props.value
    };
    return _this;
  }

  MonthTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  };

  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
    this.setState({
      value: value
    });
    this.props.onSelect(value);
  };

  MonthTable.prototype.months = function months() {
    var value = this.state.value;
    var current = value.clone();
    var months = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      months[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        current.month(index);
        var content = Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["b" /* getMonthName */])(current);
        months[rowIndex][colIndex] = {
          value: index,
          content: content,
          title: content
        };
        index++;
      }
    }
    return months;
  };

  MonthTable.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var today = Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["e" /* getTodayTime */])(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender;

    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;
        if (props.disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = props.disabledDate(testValue);
        }
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
        var cellEl = void 0;
        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content = void 0;
          if (contentRender) {
            var _currentValue = value.clone();
            _currentValue.month(monthData.value);
            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }
          cellEl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            { className: prefixCls + '-month' },
            content
          );
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            role: 'gridcell',
            key: monthData.value,
            onClick: disabled ? null : chooseMonth.bind(_this2, monthData.value),
            title: monthData.title,
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          cellEl
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tbody',
        { className: prefixCls + '-tbody' },
        monthsEls
      )
    );
  };

  return MonthTable;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

MonthTable.defaultProps = {
  onSelect: noop
};
MonthTable.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  cellRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MonthTable);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);






var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.props.onSelect(value);
}

var YearPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(YearPanel, _React$Component);

  function YearPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, YearPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.prefixCls = props.rootPrefixCls + '-year-panel';
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.nextDecade = goYear.bind(_this, 10);
    _this.previousDecade = goYear.bind(_this, -10);
    return _this;
  }

  YearPanel.prototype.years = function years() {
    var value = this.state.value;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var previousYear = startYear - 1;
    var years = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var year = previousYear + index;
        var content = String(year);
        years[rowIndex][colIndex] = {
          content: content,
          year: year,
          title: content
        };
        index++;
      }
    }
    return years;
  };

  YearPanel.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        renderFooter = props.renderFooter;

    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = this.prefixCls;

    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
        var clickHandler = void 0;
        if (yearData.year < startYear) {
          clickHandler = _this2.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this2.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this2, yearData.year);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            role: 'gridcell',
            title: yearData.title,
            key: yearData.content,
            onClick: clickHandler,
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-year'
            },
            yearData.content
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    var footer = renderFooter && renderFooter('year');

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: this.prefixCls },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-header' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-decade-select',
              role: 'button',
              onClick: props.onDecadePanelShow,
              title: locale.decadeSelect
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-decade-select-content' },
              startYear,
              '-',
              endYear
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-decade-select-arrow' },
              'x'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'table',
            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'tbody',
              { className: prefixCls + '-tbody' },
              yeasEls
            )
          )
        ),
        footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return YearPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (YearPanel);


YearPanel.propTypes = {
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

YearPanel.defaultProps = {
  onSelect: function onSelect() {}
};

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);





var ROW = 4;
var COL = 3;


function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DecadePanel, _React$Component);

  function DecadePanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DecadePanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value || props.defaultValue
    };

    // bind methods
    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
    _this.nextCentury = goYear.bind(_this, 100);
    _this.previousCentury = goYear.bind(_this, -100);
    return _this;
  }

  DecadePanel.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var _props = this.props,
        locale = _props.locale,
        renderFooter = _props.renderFooter;

    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = this.prefixCls;

    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      decades[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var footer = renderFooter && renderFooter('decade');

    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
        var content = dStartDecade + '-' + dEndDecade;
        var clickHandler = void 0;
        if (isLast) {
          clickHandler = _this2.previousCentury;
        } else if (isNext) {
          clickHandler = _this2.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this2, dStartDecade);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: dStartDecade,
            onClick: clickHandler,
            role: 'gridcell',
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-decade'
            },
            content
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: decadeIndex, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: this.prefixCls },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-century-btn',
          role: 'button',
          onClick: this.previousCentury,
          title: locale.previousCentury
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-century' },
          startYear,
          '-',
          endYear
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-century-btn',
          role: 'button',
          onClick: this.nextCentury,
          title: locale.nextCentury
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-body' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'table',
          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'tbody',
            { className: prefixCls + '-tbody' },
            decadesEls
          )
        )
      ),
      footer && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-footer' },
        footer
      )
    );
  };

  return DecadePanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DecadePanel);


DecadePanel.propTypes = {
  locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Children_mapSelf__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__calendar_TodayButton__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar_OkButton__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calendar_TimePickerButton__ = __webpack_require__(1084);













var CalendarFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(CalendarFooter, _React$Component);

  function CalendarFooter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CalendarFooter);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CalendarFooter.prototype.onSelect = function onSelect(value) {
    this.props.onSelect(value);
  };

  CalendarFooter.prototype.getRootDOMNode = function getRootDOMNode() {
    return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
  };

  CalendarFooter.prototype.render = function render() {
    var props = this.props;
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter,
        mode = props.mode;

    var footerEl = null;
    var extraFooter = renderFooter && renderFooter(mode);
    if (props.showToday || timePicker || extraFooter) {
      var _cx;

      var nowEl = void 0;
      if (props.showToday) {
        nowEl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__calendar_TodayButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { value: value }));
      }
      var okBtn = void 0;
      if (showOk === true || showOk !== false && !!props.timePicker) {
        okBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__calendar_OkButton__["a" /* default */], props);
      }
      var timePickerBtn = void 0;
      if (!!props.timePicker) {
        timePickerBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__calendar_TimePickerButton__["a" /* default */], props);
      }

      var footerBtn = void 0;
      if (nowEl || timePickerBtn || okBtn || extraFooter) {
        footerBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'span',
          { className: prefixCls + '-footer-btn' },
          extraFooter,
          Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Children_mapSelf__["a" /* default */])([nowEl, timePickerBtn, okBtn])
        );
      }
      var cls = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls + '-footer', (_cx = {}, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
      footerEl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: cls },
        footerBtn
      );
    }
    return footerEl;
  };

  return CalendarFooter;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CalendarFooter.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  showDateInput: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabledTime: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  timePicker: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element,
  selectedValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  showOk: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  renderFooter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CalendarFooter);

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TodayButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___ = __webpack_require__(158);



function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;

  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !Object(__WEBPACK_IMPORTED_MODULE_1__util___["g" /* isAllowedDate */])(Object(__WEBPACK_IMPORTED_MODULE_1__util___["e" /* getTodayTime */])(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: prefixCls + '-today-btn ' + disabledTodayClass,
      role: 'button',
      onClick: isDisabled ? null : onToday,
      title: Object(__WEBPACK_IMPORTED_MODULE_1__util___["f" /* getTodayTimeStr */])(value)
    },
    localeNow
  );
}

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OkButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + "-ok-btn";
  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    {
      className: className,
      role: "button",
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TimePickerButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;

  var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
  var onClick = null;
  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: className,
      role: 'button',
      onClick: onClick
    },
    showTimePicker ? locale.dateSelect : locale.timeSelect
  );
}

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getNowByCurrentStateValue;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calendarMixinPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calendarMixinDefaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calendarMixinWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_index__ = __webpack_require__(158);









function noop() {}

function getNowByCurrentStateValue(value) {
  var ret = void 0;
  if (value) {
    ret = Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["e" /* getTodayTime */])(value);
  } else {
    ret = __WEBPACK_IMPORTED_MODULE_6_moment___default()();
  }
  return ret;
}

var calendarMixinPropTypes = {
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var calendarMixinDefaultProps = {
  onKeyDown: noop
};

var calendarMixinWrapper = function calendarMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.onSelect = function (value, cause) {
        if (value) {
          _this.setValue(value);
        }
        _this.setSelectedValue(value, cause);
      }, _this.renderRoot = function (newProps) {
        var _className;

        var props = _this.props;
        var prefixCls = props.prefixCls;

        var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          {
            ref: _this.saveRoot,
            className: '' + __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className),
            style: _this.props.style,
            tabIndex: '0',
            onKeyDown: _this.onKeyDown
          },
          newProps.children
        );
      }, _this.setSelectedValue = function (selectedValue, cause) {
        // if (this.isAllowedDate(selectedValue)) {
        if (!('selectedValue' in _this.props)) {
          _this.setState({
            selectedValue: selectedValue
          });
        }
        if (_this.props.onSelect) {
          _this.props.onSelect(selectedValue, cause);
        }
        // }
      }, _this.setValue = function (value) {
        var originalValue = _this.state.value;
        if (!('value' in _this.props)) {
          _this.setState({
            value: value
          });
        }
        if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
          _this.props.onChange(value);
        }
      }, _this.isAllowedDate = function (value) {
        var disabledDate = _this.props.disabledDate;
        var disabledTime = _this.props.disabledTime;
        return Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["g" /* isAllowedDate */])(value, disabledDate, disabledTime);
      }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      // Use origin function if provided
      if (ComposeComponent.getDerivedStateFromProps) {
        return ComposeComponent.getDerivedStateFromProps(nextProps, prevState);
      }

      var value = nextProps.value,
          selectedValue = nextProps.selectedValue;

      var newState = {};

      if ('value' in nextProps) {
        newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(prevState.value);
      }
      if ('selectedValue' in nextProps) {
        newState.selectedValue = selectedValue;
      }

      return newState;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CalendarMixinWrapper', _temp2;
};

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return propType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonMixinWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale_en_US__ = __webpack_require__(485);






function noop() {}

var propType = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  visible: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onOk: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProp = {
  locale: __WEBPACK_IMPORTED_MODULE_4__locale_en_US__["a" /* default */],
  style: {},
  visible: true,
  prefixCls: 'rc-calendar',
  className: '',
  onSelect: noop,
  onChange: noop,
  onClear: noop,
  renderFooter: function renderFooter() {
    return null;
  },
  renderSidebar: function renderSidebar() {
    return null;
  }
};

var commonMixinWrapper = function commonMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.getFormat = function () {
        var format = _this.props.format;
        var _this$props = _this.props,
            locale = _this$props.locale,
            timePicker = _this$props.timePicker;

        if (!format) {
          if (timePicker) {
            format = locale.dateTimeFormat;
          } else {
            format = locale.dateFormat;
          }
        }
        return format;
      }, _this.focus = function () {
        if (_this.focusElement) {
          _this.focusElement.focus();
        } else if (_this.rootInstance) {
          _this.rootInstance.focus();
        }
      }, _this.saveFocusElement = function (focusElement) {
        _this.focusElement = focusElement;
      }, _this.saveRoot = function (root) {
        _this.rootInstance = root;
      }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CommonMixinWrapper', _temp2;
};

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(158);











var cachedSelectionStart = void 0;
var cachedSelectionEnd = void 0;
var dateInputInstance = void 0;

var DateInput = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateInput, _React$Component);

  function DateInput(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateInput);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue;

    _this.state = {
      str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(selectedValue, _this.props.format),
      invalid: false,
      hasFocus: false
    };
    return _this;
  }

  DateInput.prototype.componentDidUpdate = function componentDidUpdate() {
    if (dateInputInstance && this.state.hasFocus && !this.state.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
      dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
    }
  };

  DateInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};

    if (dateInputInstance) {
      cachedSelectionStart = dateInputInstance.selectionStart;
      cachedSelectionEnd = dateInputInstance.selectionEnd;
    }
    // when popup show, click body will call this, bug!
    var selectedValue = nextProps.selectedValue;
    if (!state.hasFocus) {
      newState = {
        str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(selectedValue, nextProps.format),
        invalid: false
      };
    }

    return newState;
  };

  DateInput.getInstance = function getInstance() {
    return dateInputInstance;
  };

  DateInput.prototype.render = function render() {
    var props = this.props;
    var _state = this.state,
        invalid = _state.invalid,
        str = _state.str;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        placeholder = props.placeholder,
        clearIcon = props.clearIcon;

    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-input-wrap' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-date-input-wrap' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
          ref: this.saveDateInput,
          className: prefixCls + '-input ' + invalidClass,
          value: str,
          disabled: props.disabled,
          placeholder: placeholder,
          onChange: this.onInputChange,
          onKeyDown: this.onKeyDown,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        })
      ),
      props.showClear ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'a',
        {
          role: 'button',
          title: locale.clear,
          onClick: this.onClear
        },
        clearIcon || __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: prefixCls + '-clear-btn' })
      ) : null
    );
  };

  return DateInput;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DateInput.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  timePicker: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabledTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  format: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  locale: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabledDate: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onClear: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  selectedValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  clearIcon: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClear = function () {
    _this2.setState({
      str: ''
    });
    _this2.props.onClear(null);
  };

  this.onInputChange = function (event) {
    var str = event.target.value;
    var _props = _this2.props,
        disabledDate = _props.disabledDate,
        format = _props.format,
        onChange = _props.onChange,
        selectedValue = _props.selectedValue;

    // 没有内容，合法并直接退出

    if (!str) {
      onChange(null);
      _this2.setState({
        invalid: false,
        str: str
      });
      return;
    }

    // 不合法直接退出
    var parsed = __WEBPACK_IMPORTED_MODULE_8_moment___default()(str, format, true);
    if (!parsed.isValid()) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    var value = _this2.props.value.clone();
    value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

    if (!value || disabledDate && disabledDate(value)) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
      _this2.setState({
        invalid: false,
        str: str
      });
      onChange(value);
    }
  };

  this.onFocus = function () {
    _this2.setState({ hasFocus: true });
  };

  this.onBlur = function () {
    _this2.setState(function (prevState, prevProps) {
      return {
        hasFocus: false,
        str: Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* formatDate */])(prevProps.value, prevProps.format)
      };
    });
  };

  this.onKeyDown = function (_ref) {
    var keyCode = _ref.keyCode;
    var _props2 = _this2.props,
        onSelect = _props2.onSelect,
        value = _props2.value;

    if (keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].ENTER && onSelect) {
      onSelect(value.clone());
    }
  };

  this.getRootDOMNode = function () {
    return __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(_this2);
  };

  this.focus = function () {
    if (dateInputInstance) {
      dateInputInstance.focus();
    }
  };

  this.saveDateInput = function (dateInput) {
    dateInputInstance = dateInput;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(DateInput);

/* harmony default export */ __webpack_exports__["a"] = (DateInput);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = goStartMonth;
/* harmony export (immutable) */ __webpack_exports__["a"] = goEndMonth;
/* harmony export (immutable) */ __webpack_exports__["c"] = goTime;
/* unused harmony export includesTime */
function goStartMonth(time) {
  return time.clone().startOf('month');
}

function goEndMonth(time) {
  return time.clone().endOf('month');
}

function goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}

function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments[1];
  var unit = arguments[2];

  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = __webpack_require__(49);

var _MonthTable = __webpack_require__(1090);

var _MonthTable2 = _interopRequireDefault(_MonthTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'year');
  this.setAndChangeValue(next);
}

function noop() {}

var MonthPanel = function (_React$Component) {
  (0, _inherits3['default'])(MonthPanel, _React$Component);

  function MonthPanel(props) {
    (0, _classCallCheck3['default'])(this, MonthPanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.setAndChangeValue = function (value) {
      _this.setValue(value);
      _this.props.onChange(value);
    };

    _this.setAndSelectValue = function (value) {
      _this.setValue(value);
      _this.props.onSelect(value);
    };

    _this.setValue = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }
    };

    _this.nextYear = goYear.bind(_this, 1);
    _this.previousYear = goYear.bind(_this, -1);
    _this.prefixCls = props.rootPrefixCls + '-month-panel';

    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  MonthPanel.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    var newState = {};

    if ('value' in nextProps) {
      newState = {
        value: nextProps.value
      };
    }

    return newState;
  };

  MonthPanel.prototype.render = function render() {
    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        cellRender = props.cellRender,
        contentRender = props.contentRender,
        renderFooter = props.renderFooter;

    var year = value.year();
    var prefixCls = this.prefixCls;

    var footer = renderFooter && renderFooter('month');

    return _react2['default'].createElement(
      'div',
      { className: prefixCls, style: props.style },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }),
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-year-select',
              role: 'button',
              onClick: props.onYearPanelShow,
              title: locale.yearSelect
            },
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-year-select-content' },
              year
            ),
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-year-select-arrow' },
              'x'
            )
          ),
          _react2['default'].createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(_MonthTable2['default'], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          })
        ),
        footer && _react2['default'].createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return MonthPanel;
}(_react2['default'].Component);

MonthPanel.propTypes = {
  onChange: _propTypes2['default'].func,
  disabledDate: _propTypes2['default'].func,
  onSelect: _propTypes2['default'].func,
  renderFooter: _propTypes2['default'].func,
  rootPrefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object
};
MonthPanel.defaultProps = {
  onChange: noop,
  onSelect: noop
};


(0, _reactLifecyclesCompat.polyfill)(MonthPanel);

exports['default'] = MonthPanel;
module.exports = exports['default'];

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;

function chooseMonth(month) {
  var next = this.state.value.clone();
  next.month(month);
  this.setAndSelectValue(next);
}

function noop() {}

var MonthTable = function (_Component) {
  (0, _inherits3['default'])(MonthTable, _Component);

  function MonthTable(props) {
    (0, _classCallCheck3['default'])(this, MonthTable);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));

    _this.state = {
      value: props.value
    };
    return _this;
  }

  MonthTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  };

  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
    this.setState({
      value: value
    });
    this.props.onSelect(value);
  };

  MonthTable.prototype.months = function months() {
    var value = this.state.value;
    var current = value.clone();
    var months = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      months[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        current.month(index);
        var content = (0, _index.getMonthName)(current);
        months[rowIndex][colIndex] = {
          value: index,
          content: content,
          title: content
        };
        index++;
      }
    }
    return months;
  };

  MonthTable.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var today = (0, _index.getTodayTime)(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender;

    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;
        if (props.disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = props.disabledDate(testValue);
        }
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
        var cellEl = void 0;
        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content = void 0;
          if (contentRender) {
            var _currentValue = value.clone();
            _currentValue.month(monthData.value);
            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }
          cellEl = _react2['default'].createElement(
            'a',
            { className: prefixCls + '-month' },
            content
          );
        }
        return _react2['default'].createElement(
          'td',
          {
            role: 'gridcell',
            key: monthData.value,
            onClick: disabled ? null : chooseMonth.bind(_this2, monthData.value),
            title: monthData.title,
            className: (0, _classnames2['default'])(classNameMap)
          },
          cellEl
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      _react2['default'].createElement(
        'tbody',
        { className: prefixCls + '-tbody' },
        monthsEls
      )
    );
  };

  return MonthTable;
}(_react.Component);

MonthTable.defaultProps = {
  onSelect: noop
};
MonthTable.propTypes = {
  onSelect: _propTypes2['default'].func,
  cellRender: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object
};
exports['default'] = MonthTable;
module.exports = exports['default'];

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.props.onSelect(value);
}

var YearPanel = function (_React$Component) {
  (0, _inherits3['default'])(YearPanel, _React$Component);

  function YearPanel(props) {
    (0, _classCallCheck3['default'])(this, YearPanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.prefixCls = props.rootPrefixCls + '-year-panel';
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.nextDecade = goYear.bind(_this, 10);
    _this.previousDecade = goYear.bind(_this, -10);
    return _this;
  }

  YearPanel.prototype.years = function years() {
    var value = this.state.value;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var previousYear = startYear - 1;
    var years = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var year = previousYear + index;
        var content = String(year);
        years[rowIndex][colIndex] = {
          content: content,
          year: year,
          title: content
        };
        index++;
      }
    }
    return years;
  };

  YearPanel.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var locale = props.locale,
        renderFooter = props.renderFooter;

    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = this.prefixCls;

    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
        var clickHandler = void 0;
        if (yearData.year < startYear) {
          clickHandler = _this2.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this2.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this2, yearData.year);
        }
        return _react2['default'].createElement(
          'td',
          {
            role: 'gridcell',
            title: yearData.title,
            key: yearData.content,
            onClick: clickHandler,
            className: (0, _classnames2['default'])(classNameMap)
          },
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-year'
            },
            yearData.content
          )
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    var footer = renderFooter && renderFooter('year');

    return _react2['default'].createElement(
      'div',
      { className: this.prefixCls },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }),
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-decade-select',
              role: 'button',
              onClick: props.onDecadePanelShow,
              title: locale.decadeSelect
            },
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-decade-select-content' },
              startYear,
              '-',
              endYear
            ),
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-decade-select-arrow' },
              'x'
            )
          ),
          _react2['default'].createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(
            'table',
            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
            _react2['default'].createElement(
              'tbody',
              { className: prefixCls + '-tbody' },
              yeasEls
            )
          )
        ),
        footer && _react2['default'].createElement(
          'div',
          { className: prefixCls + '-footer' },
          footer
        )
      )
    );
  };

  return YearPanel;
}(_react2['default'].Component);

exports['default'] = YearPanel;


YearPanel.propTypes = {
  rootPrefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  renderFooter: _propTypes2['default'].func
};

YearPanel.defaultProps = {
  onSelect: function onSelect() {}
};
module.exports = exports['default'];

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;


function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = function (_React$Component) {
  (0, _inherits3['default'])(DecadePanel, _React$Component);

  function DecadePanel(props) {
    (0, _classCallCheck3['default'])(this, DecadePanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value || props.defaultValue
    };

    // bind methods
    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
    _this.nextCentury = goYear.bind(_this, 100);
    _this.previousCentury = goYear.bind(_this, -100);
    return _this;
  }

  DecadePanel.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var _props = this.props,
        locale = _props.locale,
        renderFooter = _props.renderFooter;

    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = this.prefixCls;

    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      decades[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var footer = renderFooter && renderFooter('decade');

    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
        var content = dStartDecade + '-' + dEndDecade;
        var clickHandler = void 0;
        if (isLast) {
          clickHandler = _this2.previousCentury;
        } else if (isNext) {
          clickHandler = _this2.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this2, dStartDecade);
        }
        return _react2['default'].createElement(
          'td',
          {
            key: dStartDecade,
            onClick: clickHandler,
            role: 'gridcell',
            className: (0, _classnames2['default'])(classNameMap)
          },
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-decade'
            },
            content
          )
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: decadeIndex, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'div',
      { className: this.prefixCls },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-header' },
        _react2['default'].createElement('a', {
          className: prefixCls + '-prev-century-btn',
          role: 'button',
          onClick: this.previousCentury,
          title: locale.previousCentury
        }),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-century' },
          startYear,
          '-',
          endYear
        ),
        _react2['default'].createElement('a', {
          className: prefixCls + '-next-century-btn',
          role: 'button',
          onClick: this.nextCentury,
          title: locale.nextCentury
        })
      ),
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-body' },
        _react2['default'].createElement(
          'table',
          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
          _react2['default'].createElement(
            'tbody',
            { className: prefixCls + '-tbody' },
            decadesEls
          )
        )
      ),
      footer && _react2['default'].createElement(
        'div',
        { className: prefixCls + '-footer' },
        footer
      )
    );
  };

  return DecadePanel;
}(_react2['default'].Component);

exports['default'] = DecadePanel;


DecadePanel.propTypes = {
  locale: _propTypes2['default'].object,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  rootPrefixCls: _propTypes2['default'].string,
  renderFooter: _propTypes2['default'].func
};

DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};
module.exports = exports['default'];

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapSelf = __webpack_require__(488);

var _mapSelf2 = _interopRequireDefault(_mapSelf);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _TodayButton = __webpack_require__(489);

var _TodayButton2 = _interopRequireDefault(_TodayButton);

var _OkButton = __webpack_require__(490);

var _OkButton2 = _interopRequireDefault(_OkButton);

var _TimePickerButton = __webpack_require__(491);

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarFooter = function (_React$Component) {
  (0, _inherits3['default'])(CalendarFooter, _React$Component);

  function CalendarFooter() {
    (0, _classCallCheck3['default'])(this, CalendarFooter);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  CalendarFooter.prototype.onSelect = function onSelect(value) {
    this.props.onSelect(value);
  };

  CalendarFooter.prototype.getRootDOMNode = function getRootDOMNode() {
    return _reactDom2['default'].findDOMNode(this);
  };

  CalendarFooter.prototype.render = function render() {
    var props = this.props;
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter,
        mode = props.mode;

    var footerEl = null;
    var extraFooter = renderFooter && renderFooter(mode);
    if (props.showToday || timePicker || extraFooter) {
      var _cx;

      var nowEl = void 0;
      if (props.showToday) {
        nowEl = _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, { value: value }));
      }
      var okBtn = void 0;
      if (showOk === true || showOk !== false && !!props.timePicker) {
        okBtn = _react2['default'].createElement(_OkButton2['default'], props);
      }
      var timePickerBtn = void 0;
      if (!!props.timePicker) {
        timePickerBtn = _react2['default'].createElement(_TimePickerButton2['default'], props);
      }

      var footerBtn = void 0;
      if (nowEl || timePickerBtn || okBtn || extraFooter) {
        footerBtn = _react2['default'].createElement(
          'span',
          { className: prefixCls + '-footer-btn' },
          extraFooter,
          (0, _mapSelf2['default'])([nowEl, timePickerBtn, okBtn])
        );
      }
      var cls = (0, _classnames2['default'])(prefixCls + '-footer', (_cx = {}, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
      footerEl = _react2['default'].createElement(
        'div',
        { className: cls },
        footerBtn
      );
    }
    return footerEl;
  };

  return CalendarFooter;
}(_react2['default'].Component);

CalendarFooter.propTypes = {
  prefixCls: _propTypes2['default'].string,
  showDateInput: _propTypes2['default'].bool,
  disabledTime: _propTypes2['default'].any,
  timePicker: _propTypes2['default'].element,
  selectedValue: _propTypes2['default'].any,
  showOk: _propTypes2['default'].bool,
  onSelect: _propTypes2['default'].func,
  value: _propTypes2['default'].object,
  renderFooter: _propTypes2['default'].func,
  defaultValue: _propTypes2['default'].object,
  mode: _propTypes2['default'].string
};
exports['default'] = CalendarFooter;
module.exports = exports['default'];

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.calendarMixinWrapper = exports.calendarMixinDefaultProps = exports.calendarMixinPropTypes = undefined;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getNowByCurrentStateValue = getNowByCurrentStateValue;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(46);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function getNowByCurrentStateValue(value) {
  var ret = void 0;
  if (value) {
    ret = (0, _index.getTodayTime)(value);
  } else {
    ret = (0, _moment2['default'])();
  }
  return ret;
}

var calendarMixinPropTypes = exports.calendarMixinPropTypes = {
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  onKeyDown: _propTypes2['default'].func
};

var calendarMixinDefaultProps = exports.calendarMixinDefaultProps = {
  onKeyDown: noop
};

var calendarMixinWrapper = exports.calendarMixinWrapper = function calendarMixinWrapper(ComposeComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_ComposeComponent) {
    (0, _inherits3['default'])(_class, _ComposeComponent);

    function _class() {
      var _temp, _this, _ret;

      (0, _classCallCheck3['default'])(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.onSelect = function (value, cause) {
        if (value) {
          _this.setValue(value);
        }
        _this.setSelectedValue(value, cause);
      }, _this.renderRoot = function (newProps) {
        var _className;

        var props = _this.props;
        var prefixCls = props.prefixCls;

        var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);

        return _react2['default'].createElement(
          'div',
          {
            ref: _this.saveRoot,
            className: '' + (0, _classnames2['default'])(className),
            style: _this.props.style,
            tabIndex: '0',
            onKeyDown: _this.onKeyDown
          },
          newProps.children
        );
      }, _this.setSelectedValue = function (selectedValue, cause) {
        // if (this.isAllowedDate(selectedValue)) {
        if (!('selectedValue' in _this.props)) {
          _this.setState({
            selectedValue: selectedValue
          });
        }
        if (_this.props.onSelect) {
          _this.props.onSelect(selectedValue, cause);
        }
        // }
      }, _this.setValue = function (value) {
        var originalValue = _this.state.value;
        if (!('value' in _this.props)) {
          _this.setState({
            value: value
          });
        }
        if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
          _this.props.onChange(value);
        }
      }, _this.isAllowedDate = function (value) {
        var disabledDate = _this.props.disabledDate;
        var disabledTime = _this.props.disabledTime;
        return (0, _index.isAllowedDate)(value, disabledDate, disabledTime);
      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
    }

    _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      // Use origin function if provided
      if (ComposeComponent.getDerivedStateFromProps) {
        return ComposeComponent.getDerivedStateFromProps(nextProps, prevState);
      }

      var value = nextProps.value,
          selectedValue = nextProps.selectedValue;

      var newState = {};

      if ('value' in nextProps) {
        newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(prevState.value);
      }
      if ('selectedValue' in nextProps) {
        newState.selectedValue = selectedValue;
      }

      return newState;
    };

    return _class;
  }(ComposeComponent), _class.displayName = 'CalendarMixinWrapper', _temp2;
};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createPicker;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(46));

var _reactLifecyclesCompat = __webpack_require__(49);

var _MonthCalendar = _interopRequireDefault(__webpack_require__(486));

var _Picker = _interopRequireDefault(__webpack_require__(326));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _omit = _interopRequireDefault(__webpack_require__(86));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

var _warning = _interopRequireDefault(__webpack_require__(87));

var _interopDefault = _interopRequireDefault(__webpack_require__(231));

var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(479));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function createPicker(TheCalendar) {
  var CalenderWrapper =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(CalenderWrapper, _React$Component);

    function CalenderWrapper(props) {
      var _this;

      _classCallCheck(this, CalenderWrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(CalenderWrapper).call(this, props));

      _this.renderFooter = function () {
        var renderExtraFooter = _this.props.renderExtraFooter;

        var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
            prefixCls = _assertThisInitialize.prefixCls;

        return renderExtraFooter ? React.createElement("div", {
          className: "".concat(prefixCls, "-footer-extra")
        }, renderExtraFooter.apply(void 0, arguments)) : null;
      };

      _this.clearSelection = function (e) {
        e.preventDefault();
        e.stopPropagation();

        _this.handleChange(null);
      };

      _this.handleChange = function (value) {
        var props = _this.props;

        if (!('value' in props)) {
          _this.setState({
            value: value,
            showDate: value
          });
        }

        props.onChange(value, value && value.format(props.format) || '');
      };

      _this.handleCalendarChange = function (value) {
        _this.setState({
          showDate: value
        });
      };

      _this.handleOpenChange = function (open) {
        var onOpenChange = _this.props.onOpenChange;

        if (!('open' in _this.props)) {
          _this.setState({
            open: open
          });
        }

        if (onOpenChange) {
          onOpenChange(open);
        }
      };

      _this.saveInput = function (node) {
        _this.input = node;
      };

      _this.renderPicker = function (_ref) {
        var _classNames, _classNames2;

        var getPrefixCls = _ref.getPrefixCls;
        var _this$state = _this.state,
            value = _this$state.value,
            showDate = _this$state.showDate,
            open = _this$state.open;
        var props = (0, _omit["default"])(_this.props, ['onChange']);
        var customizePrefixCls = props.prefixCls,
            locale = props.locale,
            localeCode = props.localeCode,
            suffixIcon = props.suffixIcon;
        var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
        // Have to add prefixCls on the instance.
        // https://github.com/facebook/react/issues/12397

        _this.prefixCls = prefixCls;
        var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
        var disabledTime = props.showTime ? props.disabledTime : null;
        var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), props.showTime), _defineProperty(_classNames, "".concat(prefixCls, "-month"), _MonthCalendar["default"] === TheCalendar), _classNames));

        if (value && localeCode) {
          value.locale(localeCode);
        }

        var pickerProps = {};
        var calendarProps = {};
        var pickerStyle = {};

        if (props.showTime) {
          calendarProps = {
            // fix https://github.com/ant-design/ant-design/issues/1902
            onSelect: _this.handleChange
          };
          pickerStyle.width = 195;
        } else {
          pickerProps = {
            onChange: _this.handleChange
          };
        }

        if ('mode' in props) {
          calendarProps.mode = props.mode;
        }

        (0, _warning["default"])(!('onOK' in props), 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
        var calendar = React.createElement(TheCalendar, _extends({}, calendarProps, {
          disabledDate: props.disabledDate,
          disabledTime: disabledTime,
          locale: locale.lang,
          timePicker: props.timePicker,
          defaultValue: props.defaultPickerValue || (0, _interopDefault["default"])(moment)(),
          dateInputPlaceholder: placeholder,
          prefixCls: prefixCls,
          className: calendarClassName,
          onOk: props.onOk,
          dateRender: props.dateRender,
          format: props.format,
          showToday: props.showToday,
          monthCellContentRender: props.monthCellContentRender,
          renderFooter: _this.renderFooter,
          onPanelChange: props.onPanelChange,
          onChange: _this.handleCalendarChange,
          value: showDate
        }));
        var clearIcon = !props.disabled && props.allowClear && value ? React.createElement(_icon["default"], {
          type: "close-circle",
          className: "".concat(prefixCls, "-picker-clear"),
          onClick: _this.clearSelection,
          theme: "filled"
        }) : null;
        var inputIcon = suffixIcon && (React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-icon"), true), _classNames2))
        }) : React.createElement("span", {
          className: "".concat(prefixCls, "-picker-icon")
        }, suffixIcon)) || React.createElement(_icon["default"], {
          type: "calendar",
          className: "".concat(prefixCls, "-picker-icon")
        });
        var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(props);

        var input = function input(_ref2) {
          var inputValue = _ref2.value;
          return React.createElement("div", null, React.createElement("input", _extends({
            ref: _this.saveInput,
            disabled: props.disabled,
            readOnly: true,
            value: inputValue && inputValue.format(props.format) || '',
            placeholder: placeholder,
            className: props.pickerInputClass,
            tabIndex: props.tabIndex
          }, dataOrAriaProps)), clearIcon, inputIcon);
        };

        return React.createElement("span", {
          id: props.id,
          className: (0, _classnames["default"])(props.className, props.pickerClass),
          style: _extends({}, pickerStyle, props.style),
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave
        }, React.createElement(_Picker["default"], _extends({}, props, pickerProps, {
          calendar: calendar,
          value: value,
          prefixCls: "".concat(prefixCls, "-picker-container"),
          style: props.popupStyle,
          open: open,
          onOpenChange: _this.handleOpenChange
        }), input));
      };

      var value = props.value || props.defaultValue;

      if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
        throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
      }

      _this.state = {
        value: value,
        showDate: value,
        open: false
      };
      return _this;
    }

    _createClass(CalenderWrapper, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(_, prevState) {
        if (!('open' in this.props) && prevState.open && !this.state.open) {
          this.focus();
        }
      }
    }, {
      key: "focus",
      value: function focus() {
        this.input.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.input.blur();
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(_configProvider.ConfigConsumer, null, this.renderPicker);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        var state = {};
        var open = prevState.open;

        if ('open' in nextProps) {
          state.open = nextProps.open;
          open = nextProps.open || false;
        }

        if ('value' in nextProps) {
          state.value = nextProps.value;

          if (nextProps.value !== prevState.value || !open && nextProps.value !== prevState.showDate) {
            state.showDate = nextProps.value;
          }
        }

        return Object.keys(state).length > 0 ? state : null;
      }
    }]);

    return CalenderWrapper;
  }(React.Component);

  CalenderWrapper.defaultProps = {
    allowClear: true,
    showToday: true
  };
  (0, _reactLifecyclesCompat.polyfill)(CalenderWrapper);
  return CalenderWrapper;
}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);
  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;
module.exports = exports['default'];

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapPicker;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Panel = _interopRequireDefault(__webpack_require__(493));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _en_US = _interopRequireDefault(__webpack_require__(264));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(142));

var _timePicker = __webpack_require__(327);

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function getColumns(_ref) {
  var showHour = _ref.showHour,
      showMinute = _ref.showMinute,
      showSecond = _ref.showSecond,
      use12Hours = _ref.use12Hours;
  var column = 0;

  if (showHour) {
    column += 1;
  }

  if (showMinute) {
    column += 1;
  }

  if (showSecond) {
    column += 1;
  }

  if (use12Hours) {
    column += 1;
  }

  return column;
}

function wrapPicker(Picker, defaultFormat) {
  var _a;

  return _a =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(PickerWrapper, _React$Component);

    function PickerWrapper() {
      var _this;

      _classCallCheck(this, PickerWrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(PickerWrapper).apply(this, arguments));

      _this.handleOpenChange = function (open) {
        var onOpenChange = _this.props.onOpenChange;
        onOpenChange(open);
      };

      _this.handleFocus = function (e) {
        var onFocus = _this.props.onFocus;

        if (onFocus) {
          onFocus(e);
        }
      };

      _this.handleBlur = function (e) {
        var onBlur = _this.props.onBlur;

        if (onBlur) {
          onBlur(e);
        }
      };

      _this.handleMouseEnter = function (e) {
        var onMouseEnter = _this.props.onMouseEnter;

        if (onMouseEnter) {
          onMouseEnter(e);
        }
      };

      _this.handleMouseLeave = function (e) {
        var onMouseLeave = _this.props.onMouseLeave;

        if (onMouseLeave) {
          onMouseLeave(e);
        }
      };

      _this.savePicker = function (node) {
        _this.picker = node;
      };

      _this.getDefaultLocale = function () {
        var result = _extends({}, _en_US["default"], _this.props.locale);

        result.lang = _extends({}, result.lang, (_this.props.locale || {}).lang);
        return result;
      };

      _this.renderPicker = function (locale, localeCode) {
        return React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
          var _classNames2;

          var getPrefixCls = _ref2.getPrefixCls;
          var _this$props = _this.props,
              customizePrefixCls = _this$props.prefixCls,
              customizeInputPrefixCls = _this$props.inputPrefixCls,
              size = _this$props.size,
              disabled = _this$props.disabled,
              showTime = _this$props.showTime;
          var prefixCls = getPrefixCls('calendar', customizePrefixCls);
          var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
          var pickerClass = (0, _classnames["default"])("".concat(prefixCls, "-picker"), _defineProperty({}, "".concat(prefixCls, "-picker-").concat(size), !!size));
          var pickerInputClass = (0, _classnames["default"])("".concat(prefixCls, "-picker-input"), inputPrefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-sm"), size === 'small'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames2));
          var timeFormat = showTime && showTime.format || 'HH:mm:ss';

          var rcTimePickerProps = _extends({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat), {
            format: timeFormat,
            use12Hours: showTime && showTime.use12Hours
          });

          var columns = getColumns(rcTimePickerProps);
          var timePickerCls = "".concat(prefixCls, "-time-picker-column-").concat(columns);
          var timePicker = showTime ? React.createElement(_Panel["default"], _extends({}, rcTimePickerProps, showTime, {
            prefixCls: "".concat(prefixCls, "-time-picker"),
            className: timePickerCls,
            placeholder: locale.timePickerLocale.placeholder,
            transitionName: "slide-up"
          })) : null;
          return React.createElement(Picker, _extends({}, _this.props, {
            ref: _this.savePicker,
            pickerClass: pickerClass,
            pickerInputClass: pickerInputClass,
            locale: locale,
            localeCode: localeCode,
            timePicker: timePicker,
            onOpenChange: _this.handleOpenChange,
            onFocus: _this.handleFocus,
            onBlur: _this.handleBlur,
            onMouseEnter: _this.handleMouseEnter,
            onMouseLeave: _this.handleMouseLeave
          }));
        });
      };

      return _this;
    }

    _createClass(PickerWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props2 = this.props,
            autoFocus = _this$props2.autoFocus,
            disabled = _this$props2.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: "focus",
      value: function focus() {
        this.picker.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.picker.blur();
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(_LocaleReceiver["default"], {
          componentName: "DatePicker",
          defaultLocale: this.getDefaultLocale
        }, this.renderPicker);
      }
    }]);

    return PickerWrapper;
  }(React.Component), _a.defaultProps = {
    format: defaultFormat || 'YYYY-MM-DD',
    transitionName: 'slide-up',
    popupStyle: {},
    onChange: function onChange() {},
    onOk: function onOk() {},
    onOpenChange: function onOpenChange() {},
    locale: {}
  }, _a;
}

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _moment = _interopRequireDefault(__webpack_require__(46));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (event) {
      var str = event.target.value;

      _this.setState({
        str: str
      });

      var _this$props = _this.props,
          format = _this$props.format,
          hourOptions = _this$props.hourOptions,
          minuteOptions = _this$props.minuteOptions,
          secondOptions = _this$props.secondOptions,
          disabledHours = _this$props.disabledHours,
          disabledMinutes = _this$props.disabledMinutes,
          disabledSeconds = _this$props.disabledSeconds,
          onChange = _this$props.onChange,
          allowEmpty = _this$props.allowEmpty;

      if (str) {
        var originalValue = _this.props.value;

        var value = _this.getProtoValue().clone();

        var parsed = (0, _moment["default"])(str, format, true);

        if (!parsed.isValid()) {
          _this.setState({
            invalid: true
          });

          return;
        }

        value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.

        if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
          _this.setState({
            invalid: true
          });

          return;
        } // if time value is disabled, response warning.


        var disabledHourOptions = disabledHours();
        var disabledMinuteOptions = disabledMinutes(value.hour());
        var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());

        if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
          _this.setState({
            invalid: true
          });

          return;
        }

        if (originalValue) {
          if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
            // keep other fields for rc-calendar
            var changedValue = originalValue.clone();
            changedValue.hour(value.hour());
            changedValue.minute(value.minute());
            changedValue.second(value.second());
            onChange(changedValue);
          }
        } else if (originalValue !== value) {
          onChange(value);
        }
      } else if (allowEmpty) {
        onChange(null);
      } else {
        _this.setState({
          invalid: true
        });

        return;
      }

      _this.setState({
        invalid: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (e) {
      var _this$props2 = _this.props,
          onEsc = _this$props2.onEsc,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 27) {
        onEsc();
      }

      onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClear", function () {
      var onClear = _this.props.onClear;

      _this.setState({
        str: ''
      });

      onClear();
    });

    var _value = props.value,
        _format = props.format;
    _this.state = {
      str: _value && _value.format(_format) || '',
      invalid: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var focusOnOpen = this.props.focusOnOpen;

      if (focusOnOpen) {
        // Wait one frame for the panel to be positioned before focusing
        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
        requestAnimationFrame(function () {
          _this2.refInput.focus();

          _this2.refInput.select();
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          format = nextProps.format;
      this.setState({
        str: value && value.format(format) || '',
        invalid: false
      });
    }
  }, {
    key: "getClearButton",
    value: function getClearButton() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          allowEmpty = _this$props3.allowEmpty,
          clearIcon = _this$props3.clearIcon,
          clearText = _this$props3.clearText;

      if (!allowEmpty) {
        return null;
      }

      return _react["default"].createElement("a", {
        role: "button",
        className: "".concat(prefixCls, "-clear-btn"),
        title: clearText,
        onMouseDown: this.onClear,
        tabIndex: 0
      }, clearIcon || _react["default"].createElement("i", {
        className: "".concat(prefixCls, "-clear-btn-icon")
      }));
    }
  }, {
    key: "getProtoValue",
    value: function getProtoValue() {
      var _this$props4 = this.props,
          value = _this$props4.value,
          defaultOpenValue = _this$props4.defaultOpenValue;
      return value || defaultOpenValue;
    }
  }, {
    key: "getInput",
    value: function getInput() {
      var _this3 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          placeholder = _this$props5.placeholder,
          inputReadOnly = _this$props5.inputReadOnly;
      var _this$state = this.state,
          invalid = _this$state.invalid,
          str = _this$state.str;
      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
      return _react["default"].createElement("input", {
        className: "".concat(prefixCls, "-input  ").concat(invalidClass),
        ref: function ref(_ref) {
          _this3.refInput = _ref;
        },
        onKeyDown: this.onKeyDown,
        value: str,
        placeholder: placeholder,
        onChange: this.onInputChange,
        readOnly: !!inputReadOnly
      });
    }
  }, {
    key: "render",
    value: function render() {
      var prefixCls = this.props.prefixCls;
      return _react["default"].createElement("div", {
        className: "".concat(prefixCls, "-input-wrap")
      }, this.getInput(), this.getClearButton());
    }
  }]);

  return Header;
}(_react.Component);

_defineProperty(Header, "propTypes", {
  format: _propTypes["default"].string,
  prefixCls: _propTypes["default"].string,
  disabledDate: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  clearText: _propTypes["default"].string,
  value: _propTypes["default"].object,
  inputReadOnly: _propTypes["default"].bool,
  hourOptions: _propTypes["default"].array,
  minuteOptions: _propTypes["default"].array,
  secondOptions: _propTypes["default"].array,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClear: _propTypes["default"].func,
  onEsc: _propTypes["default"].func,
  allowEmpty: _propTypes["default"].bool,
  defaultOpenValue: _propTypes["default"].object,
  currentSelectPanel: _propTypes["default"].string,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Header, "defaultProps", {
  inputReadOnly: false
});

var _default = Header;
exports["default"] = _default;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _Select = _interopRequireDefault(__webpack_require__(1101));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var formatOption = function formatOption(option, disabledOptions) {
  var value = "".concat(option);

  if (option < 10) {
    value = "0".concat(option);
  }

  var disabled = false;

  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
    disabled = true;
  }

  return {
    value: value,
    disabled: disabled
  };
};

var Combobox =
/*#__PURE__*/
function (_Component) {
  _inherits(Combobox, _Component);

  function Combobox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Combobox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Combobox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onItemChange", function (type, itemValue) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          defaultOpenValue = _this$props.defaultOpenValue,
          use12Hours = _this$props.use12Hours,
          propValue = _this$props.value,
          isAM = _this$props.isAM,
          onAmPmChange = _this$props.onAmPmChange;
      var value = (propValue || defaultOpenValue).clone();

      if (type === 'hour') {
        if (use12Hours) {
          if (isAM) {
            value.hour(+itemValue % 12);
          } else {
            value.hour(+itemValue % 12 + 12);
          }
        } else {
          value.hour(+itemValue);
        }
      } else if (type === 'minute') {
        value.minute(+itemValue);
      } else if (type === 'ampm') {
        var ampm = itemValue.toUpperCase();

        if (use12Hours) {
          if (ampm === 'PM' && value.hour() < 12) {
            value.hour(value.hour() % 12 + 12);
          }

          if (ampm === 'AM') {
            if (value.hour() >= 12) {
              value.hour(value.hour() - 12);
            }
          }
        }

        onAmPmChange(ampm);
      } else {
        value.second(+itemValue);
      }

      onChange(value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onEnterSelectPanel", function (range) {
      var onCurrentSelectPanelChange = _this.props.onCurrentSelectPanelChange;
      onCurrentSelectPanelChange(range);
    });

    return _this;
  }

  _createClass(Combobox, [{
    key: "getHourSelect",
    value: function getHourSelect(hour) {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          hourOptions = _this$props2.hourOptions,
          disabledHours = _this$props2.disabledHours,
          showHour = _this$props2.showHour,
          use12Hours = _this$props2.use12Hours;

      if (!showHour) {
        return null;
      }

      var disabledOptions = disabledHours();
      var hourOptionsAdj;
      var hourAdj;

      if (use12Hours) {
        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
          return h < 12 && h > 0;
        }));
        hourAdj = hour % 12 || 12;
      } else {
        hourOptionsAdj = hourOptions;
        hourAdj = hour;
      }

      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: hourOptionsAdj.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
        type: "hour",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this2.onEnterSelectPanel('hour');
        }
      });
    }
  }, {
    key: "getMinuteSelect",
    value: function getMinuteSelect(minute) {
      var _this3 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          minuteOptions = _this$props3.minuteOptions,
          disabledMinutes = _this$props3.disabledMinutes,
          defaultOpenValue = _this$props3.defaultOpenValue,
          showMinute = _this$props3.showMinute,
          propValue = _this$props3.value;

      if (!showMinute) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledMinutes(value.hour());
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: minuteOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: minuteOptions.indexOf(minute),
        type: "minute",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this3.onEnterSelectPanel('minute');
        }
      });
    }
  }, {
    key: "getSecondSelect",
    value: function getSecondSelect(second) {
      var _this4 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          secondOptions = _this$props4.secondOptions,
          disabledSeconds = _this$props4.disabledSeconds,
          showSecond = _this$props4.showSecond,
          defaultOpenValue = _this$props4.defaultOpenValue,
          propValue = _this$props4.value;

      if (!showSecond) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledSeconds(value.hour(), value.minute());
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: secondOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: secondOptions.indexOf(second),
        type: "second",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this4.onEnterSelectPanel('second');
        }
      });
    }
  }, {
    key: "getAMPMSelect",
    value: function getAMPMSelect() {
      var _this5 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          use12Hours = _this$props5.use12Hours,
          format = _this$props5.format,
          isAM = _this$props5.isAM;

      if (!use12Hours) {
        return null;
      }

      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
      .map(function (c) {
        return format.match(/\sA/) ? c.toUpperCase() : c;
      }).map(function (c) {
        return {
          value: c
        };
      });
      var selected = isAM ? 0 : 1;
      return _react["default"].createElement(_Select["default"], {
        prefixCls: prefixCls,
        options: AMPMOptions,
        selectedIndex: selected,
        type: "ampm",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this5.onEnterSelectPanel('ampm');
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          defaultOpenValue = _this$props6.defaultOpenValue,
          propValue = _this$props6.value;
      var value = propValue || defaultOpenValue;
      return _react["default"].createElement("div", {
        className: "".concat(prefixCls, "-combobox")
      }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
    }
  }]);

  return Combobox;
}(_react.Component);

_defineProperty(Combobox, "propTypes", {
  format: _propTypes["default"].string,
  defaultOpenValue: _propTypes["default"].object,
  prefixCls: _propTypes["default"].string,
  value: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  hourOptions: _propTypes["default"].array,
  minuteOptions: _propTypes["default"].array,
  secondOptions: _propTypes["default"].array,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  onCurrentSelectPanelChange: _propTypes["default"].func,
  use12Hours: _propTypes["default"].bool,
  isAM: _propTypes["default"].bool
});

var _default = Combobox;
exports["default"] = _default;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _reactDom = _interopRequireDefault(__webpack_require__(38));

var _classnames3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var scrollTo = function scrollTo(element, to, duration) {
  var requestAnimationFrame = window.requestAnimationFrame || function requestAnimationFrameTimeout() {
    return setTimeout(arguments[0], 10); // eslint-disable-line
  }; // jump to target if duration zero


  if (duration <= 0) {
    element.scrollTop = to;
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  requestAnimationFrame(function () {
    element.scrollTop += perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  });
};

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSelect", function (value) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          type = _this$props.type;
      onSelect(type, value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseEnter", function (e) {
      var onMouseEnter = _this.props.onMouseEnter;

      _this.setState({
        active: true
      });

      onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseLeave", function () {
      _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "saveList", function (node) {
      _this.list = node;
    });

    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // jump to selected option
      this.scrollToSelected(0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedIndex = this.props.selectedIndex; // smooth scroll to selected option

      if (prevProps.selectedIndex !== selectedIndex) {
        this.scrollToSelected(120);
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this2 = this;

      var _this$props2 = this.props,
          options = _this$props2.options,
          selectedIndex = _this$props2.selectedIndex,
          prefixCls = _this$props2.prefixCls;
      return options.map(function (item, index) {
        var _classnames;

        var cls = (0, _classnames3["default"])((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-select-option-selected"), selectedIndex === index), _defineProperty(_classnames, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _classnames));
        var onClick = item.disabled ? undefined : function () {
          _this2.onSelect(item.value);
        };
        return _react["default"].createElement("li", {
          role: "button",
          onClick: onClick,
          className: cls,
          key: index,
          disabled: item.disabled
        }, item.value);
      });
    }
  }, {
    key: "scrollToSelected",
    value: function scrollToSelected(duration) {
      // move to selected item
      var selectedIndex = this.props.selectedIndex;

      var select = _reactDom["default"].findDOMNode(this);

      var list = _reactDom["default"].findDOMNode(this.list);

      if (!list) {
        return;
      }

      var index = selectedIndex;

      if (index < 0) {
        index = 0;
      }

      var topOption = list.children[index];
      var to = topOption.offsetTop;
      scrollTo(select, to, duration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          options = _this$props3.options;
      var active = this.state.active;

      if (options.length === 0) {
        return null;
      }

      var cls = (0, _classnames3["default"])("".concat(prefixCls, "-select"), _defineProperty({}, "".concat(prefixCls, "-select-active"), active));
      return _react["default"].createElement("div", {
        className: cls,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, _react["default"].createElement("ul", {
        ref: this.saveList
      }, this.getOptions()));
    }
  }]);

  return Select;
}(_react.Component);

_defineProperty(Select, "propTypes", {
  prefixCls: _propTypes["default"].string,
  options: _propTypes["default"].array,
  selectedIndex: _propTypes["default"].number,
  type: _propTypes["default"].string,
  onSelect: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func
});

var _default = Select;
exports["default"] = _default;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _rcTrigger = _interopRequireDefault(__webpack_require__(153));

var _moment = _interopRequireDefault(__webpack_require__(46));

var _Panel = _interopRequireDefault(__webpack_require__(493));

var _placements = _interopRequireDefault(__webpack_require__(1103));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker =
/*#__PURE__*/
function (_Component) {
  _inherits(Picker, _Component);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onPanelChange", function (value) {
      _this.setValue(value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onPanelClear", function () {
      _this.setValue(null);

      _this.setOpen(false);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onVisibleChange", function (open) {
      _this.setOpen(open);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onEsc", function () {
      _this.setOpen(false);

      _this.focus();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (e) {
      if (e.keyCode === 40) {
        _this.setOpen(true);
      }
    });

    _this.saveInputRef = refFn.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'picker');
    _this.savePanelRef = refFn.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'panelInstance');

    var defaultOpen = props.defaultOpen,
        defaultValue = props.defaultValue,
        _props$open = props.open,
        _open = _props$open === void 0 ? defaultOpen : _props$open,
        _props$value = props.value,
        _value = _props$value === void 0 ? defaultValue : _props$value;

    _this.state = {
      open: _open,
      value: _value
    };
    return _this;
  }

  _createClass(Picker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          open = nextProps.open;

      if ('value' in nextProps) {
        this.setState({
          value: value
        });
      }

      if (open !== undefined) {
        this.setState({
          open: open
        });
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var onChange = this.props.onChange;

      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      onChange(value);
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var _this$props = this.props,
          format = _this$props.format,
          showHour = _this$props.showHour,
          showMinute = _this$props.showMinute,
          showSecond = _this$props.showSecond,
          use12Hours = _this$props.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
          return !!item;
        }).join(':');
        return fmtString.concat(' a');
      }

      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
    }
  }, {
    key: "getPanelElement",
    value: function getPanelElement() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          placeholder = _this$props2.placeholder,
          disabledHours = _this$props2.disabledHours,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          inputReadOnly = _this$props2.inputReadOnly,
          allowEmpty = _this$props2.allowEmpty,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          clearIcon = _this$props2.clearIcon;
      var value = this.state.value;
      return _react["default"].createElement(_Panel["default"], {
        clearText: clearText,
        prefixCls: "".concat(prefixCls, "-panel"),
        ref: this.savePanelRef,
        value: value,
        inputReadOnly: inputReadOnly,
        onChange: this.onPanelChange,
        onAmPmChange: this.onAmPmChange,
        onClear: this.onPanelClear,
        defaultOpenValue: defaultOpenValue,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        onEsc: this.onEsc,
        allowEmpty: allowEmpty,
        format: this.getFormat(),
        placeholder: placeholder,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        hideDisabledOptions: hideDisabledOptions,
        use12Hours: use12Hours,
        hourStep: hourStep,
        minuteStep: minuteStep,
        secondStep: secondStep,
        addon: addon,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        clearIcon: clearIcon
      });
    }
  }, {
    key: "getPopupClassName",
    value: function getPopupClassName() {
      var _this$props3 = this.props,
          showHour = _this$props3.showHour,
          showMinute = _this$props3.showMinute,
          showSecond = _this$props3.showSecond,
          use12Hours = _this$props3.use12Hours,
          prefixCls = _this$props3.prefixCls,
          popupClassName = _this$props3.popupClassName;
      var className = popupClassName; // Keep it for old compatibility

      if ((!showHour || !showMinute || !showSecond) && !use12Hours) {
        className += " ".concat(prefixCls, "-panel-narrow");
      }

      var selectColumnCount = 0;

      if (showHour) {
        selectColumnCount += 1;
      }

      if (showMinute) {
        selectColumnCount += 1;
      }

      if (showSecond) {
        selectColumnCount += 1;
      }

      if (use12Hours) {
        selectColumnCount += 1;
      }

      className += " ".concat(prefixCls, "-panel-column-").concat(selectColumnCount);
      return className;
    }
  }, {
    key: "setOpen",
    value: function setOpen(open) {
      var _this$props4 = this.props,
          onOpen = _this$props4.onOpen,
          onClose = _this$props4.onClose;
      var currentOpen = this.state.open;

      if (currentOpen !== open) {
        if (!('open' in this.props)) {
          this.setState({
            open: open
          });
        }

        if (open) {
          onOpen({
            open: open
          });
        } else {
          onClose({
            open: open
          });
        }
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          placeholder = _this$props5.placeholder,
          placement = _this$props5.placement,
          align = _this$props5.align,
          id = _this$props5.id,
          disabled = _this$props5.disabled,
          transitionName = _this$props5.transitionName,
          style = _this$props5.style,
          className = _this$props5.className,
          getPopupContainer = _this$props5.getPopupContainer,
          name = _this$props5.name,
          autoComplete = _this$props5.autoComplete,
          onFocus = _this$props5.onFocus,
          onBlur = _this$props5.onBlur,
          autoFocus = _this$props5.autoFocus,
          inputReadOnly = _this$props5.inputReadOnly,
          inputIcon = _this$props5.inputIcon,
          popupStyle = _this$props5.popupStyle;
      var _this$state = this.state,
          open = _this$state.open,
          value = _this$state.value;
      var popupClassName = this.getPopupClassName();
      return _react["default"].createElement(_rcTrigger["default"], {
        prefixCls: "".concat(prefixCls, "-panel"),
        popupClassName: popupClassName,
        popupStyle: popupStyle,
        popup: this.getPanelElement(),
        popupAlign: align,
        builtinPlacements: _placements["default"],
        popupPlacement: placement,
        action: disabled ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getPopupContainer,
        popupTransitionName: transitionName,
        popupVisible: open,
        onPopupVisibleChange: this.onVisibleChange
      }, _react["default"].createElement("span", {
        className: "".concat(prefixCls, " ").concat(className),
        style: style
      }, _react["default"].createElement("input", {
        className: "".concat(prefixCls, "-input"),
        ref: this.saveInputRef,
        type: "text",
        placeholder: placeholder,
        name: name,
        onKeyDown: this.onKeyDown,
        disabled: disabled,
        value: value && value.format(this.getFormat()) || '',
        autoComplete: autoComplete,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        onChange: noop,
        readOnly: !!inputReadOnly,
        id: id
      }), inputIcon || _react["default"].createElement("span", {
        className: "".concat(prefixCls, "-icon")
      })));
    }
  }]);

  return Picker;
}(_react.Component);

exports["default"] = Picker;

_defineProperty(Picker, "propTypes", {
  prefixCls: _propTypes["default"].string,
  clearText: _propTypes["default"].string,
  value: _propTypes["default"].object,
  defaultOpenValue: _propTypes["default"].object,
  inputReadOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  allowEmpty: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].object,
  open: _propTypes["default"].bool,
  defaultOpen: _propTypes["default"].bool,
  align: _propTypes["default"].object,
  placement: _propTypes["default"].any,
  transitionName: _propTypes["default"].string,
  getPopupContainer: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  format: _propTypes["default"].string,
  showHour: _propTypes["default"].bool,
  showMinute: _propTypes["default"].bool,
  showSecond: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  className: _propTypes["default"].string,
  popupClassName: _propTypes["default"].string,
  popupStyle: _propTypes["default"].object,
  disabledHours: _propTypes["default"].func,
  disabledMinutes: _propTypes["default"].func,
  disabledSeconds: _propTypes["default"].func,
  hideDisabledOptions: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onAmPmChange: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  addon: _propTypes["default"].func,
  name: _propTypes["default"].string,
  autoComplete: _propTypes["default"].string,
  use12Hours: _propTypes["default"].bool,
  hourStep: _propTypes["default"].number,
  minuteStep: _propTypes["default"].number,
  secondStep: _propTypes["default"].number,
  focusOnOpen: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  autoFocus: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  inputIcon: _propTypes["default"].node,
  clearIcon: _propTypes["default"].node
});

_defineProperty(Picker, "defaultProps", {
  clearText: 'clear',
  prefixCls: 'rc-time-picker',
  defaultOpen: false,
  inputReadOnly: false,
  style: {},
  className: '',
  popupClassName: '',
  popupStyle: {},
  id: '',
  align: {},
  defaultOpenValue: (0, _moment["default"])(),
  allowEmpty: true,
  showHour: true,
  showMinute: true,
  showSecond: true,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  onChange: noop,
  onAmPmChange: noop,
  onOpen: noop,
  onClose: noop,
  onFocus: noop,
  onBlur: noop,
  addon: noop,
  use12Hours: false,
  focusOnOpen: false,
  onKeyDown: noop
});

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};
var _default = placements;
exports["default"] = _default;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(46));

var _reactLifecyclesCompat = __webpack_require__(49);

var _RangeCalendar = _interopRequireDefault(__webpack_require__(1105));

var _Picker = _interopRequireDefault(__webpack_require__(326));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _shallowequal = _interopRequireDefault(__webpack_require__(132));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _tag = _interopRequireDefault(__webpack_require__(328));

var _configProvider = __webpack_require__(35);

var _warning = _interopRequireDefault(__webpack_require__(87));

var _interopDefault = _interopRequireDefault(__webpack_require__(231));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getShowDateFromValue(value) {
  var _value = _slicedToArray(value, 2),
      start = _value[0],
      end = _value[1]; // value could be an empty array, then we should not reset showDate


  if (!start && !end) {
    return;
  }

  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
  return [start, newEnd];
}

function formatValue(value, format) {
  return value && value.format(format) || '';
}

function pickerValueAdapter(value) {
  if (!value) {
    return;
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [value, value.clone().add(1, 'month')];
}

function isEmptyArray(arr) {
  if (Array.isArray(arr)) {
    return arr.length === 0 || arr.every(function (i) {
      return !i;
    });
  }

  return false;
}

function fixLocale(value, localeCode) {
  if (!localeCode) {
    return;
  }

  if (!value || value.length === 0) {
    return;
  }

  var _value2 = _slicedToArray(value, 2),
      start = _value2[0],
      end = _value2[1];

  if (start) {
    start.locale(localeCode);
  }

  if (end) {
    end.locale(localeCode);
  }
}

var RangePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RangePicker, _React$Component);

  function RangePicker(props) {
    var _this;

    _classCallCheck(this, RangePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangePicker).call(this, props));

    _this.clearSelection = function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        value: []
      });

      _this.handleChange([]);
    };

    _this.clearHoverValue = function () {
      return _this.setState({
        hoverValue: []
      });
    };

    _this.handleChange = function (value) {
      var props = _this.props;

      if (!('value' in props)) {
        _this.setState(function (_ref) {
          var showDate = _ref.showDate;
          return {
            value: value,
            showDate: getShowDateFromValue(value) || showDate
          };
        });
      }

      var _value3 = _slicedToArray(value, 2),
          start = _value3[0],
          end = _value3[1];

      props.onChange(value, [formatValue(start, props.format), formatValue(end, props.format)]);
    };

    _this.handleOpenChange = function (open) {
      if (!('open' in _this.props)) {
        _this.setState({
          open: open
        });
      }

      if (open === false) {
        _this.clearHoverValue();
      }

      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.handleShowDateChange = function (showDate) {
      return _this.setState({
        showDate: showDate
      });
    };

    _this.handleHoverChange = function (hoverValue) {
      return _this.setState({
        hoverValue: hoverValue
      });
    };

    _this.handleRangeMouseLeave = function () {
      if (_this.state.open) {
        _this.clearHoverValue();
      }
    };

    _this.handleCalendarInputSelect = function (value) {
      var _value4 = _slicedToArray(value, 1),
          start = _value4[0];

      if (!start) {
        return;
      }

      _this.setState(function (_ref2) {
        var showDate = _ref2.showDate;
        return {
          value: value,
          showDate: getShowDateFromValue(value) || showDate
        };
      });
    };

    _this.handleRangeClick = function (value) {
      if (typeof value === 'function') {
        value = value();
      }

      _this.setValue(value, true);

      var _this$props = _this.props,
          onOk = _this$props.onOk,
          onOpenChange = _this$props.onOpenChange;

      if (onOk) {
        onOk(value);
      }

      if (onOpenChange) {
        onOpenChange(false);
      }
    };

    _this.savePicker = function (node) {
      _this.picker = node;
    };

    _this.renderFooter = function () {
      var _this$props2 = _this.props,
          ranges = _this$props2.ranges,
          renderExtraFooter = _this$props2.renderExtraFooter;

      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          prefixCls = _assertThisInitialize.prefixCls,
          tagPrefixCls = _assertThisInitialize.tagPrefixCls;

      if (!ranges && !renderExtraFooter) {
        return null;
      }

      var customFooter = renderExtraFooter ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra"),
        key: "extra"
      }, renderExtraFooter.apply(void 0, arguments)) : null;
      var operations = Object.keys(ranges || {}).map(function (range) {
        var value = ranges[range];
        return React.createElement(_tag["default"], {
          key: range,
          prefixCls: tagPrefixCls,
          color: "blue",
          onClick: function onClick() {
            return _this.handleRangeClick(value);
          },
          onMouseEnter: function onMouseEnter() {
            return _this.setState({
              hoverValue: value
            });
          },
          onMouseLeave: _this.handleRangeMouseLeave
        }, range);
      });
      var rangeNode = operations && operations.length > 0 ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra ").concat(prefixCls, "-range-quick-selector"),
        key: "range"
      }, operations) : null;
      return [rangeNode, customFooter];
    };

    _this.renderRangePicker = function (_ref3) {
      var _classNames, _classNames2;

      var getPrefixCls = _ref3.getPrefixCls;

      var _assertThisInitialize2 = _assertThisInitialized(_assertThisInitialized(_this)),
          state = _assertThisInitialize2.state,
          props = _assertThisInitialize2.props;

      var value = state.value,
          showDate = state.showDate,
          hoverValue = state.hoverValue,
          open = state.open;
      var customizePrefixCls = props.prefixCls,
          customizeTagPrefixCls = props.tagPrefixCls,
          popupStyle = props.popupStyle,
          style = props.style,
          disabledDate = props.disabledDate,
          disabledTime = props.disabledTime,
          showTime = props.showTime,
          showToday = props.showToday,
          ranges = props.ranges,
          onOk = props.onOk,
          locale = props.locale,
          localeCode = props.localeCode,
          format = props.format,
          dateRender = props.dateRender,
          onCalendarChange = props.onCalendarChange,
          suffixIcon = props.suffixIcon;
      var prefixCls = getPrefixCls('calendar', customizePrefixCls);
      var tagPrefixCls = getPrefixCls('tag', customizeTagPrefixCls); // To support old version react.
      // Have to add prefixCls on the instance.
      // https://github.com/facebook/react/issues/12397

      _this.prefixCls = prefixCls;
      _this.tagPrefixCls = tagPrefixCls;
      fixLocale(value, localeCode);
      fixLocale(showDate, localeCode);
      (0, _warning["default"])(!('onOK' in props), 'It should be `RangePicker[onOk]`, instead of `onOK`!');
      var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), showTime), _defineProperty(_classNames, "".concat(prefixCls, "-range-with-ranges"), ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange

      var pickerChangeHandler = {
        onChange: _this.handleChange
      };
      var calendarProps = {
        onOk: _this.handleChange
      };

      if (props.timePicker) {
        pickerChangeHandler.onChange = function (changedValue) {
          return _this.handleChange(changedValue);
        };
      } else {
        calendarProps = {};
      }

      if ('mode' in props) {
        calendarProps.mode = props.mode;
      }

      var startPlaceholder = 'placeholder' in props ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
      var endPlaceholder = 'placeholder' in props ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
      var calendar = React.createElement(_RangeCalendar["default"], _extends({}, calendarProps, {
        onChange: onCalendarChange,
        format: format,
        prefixCls: prefixCls,
        className: calendarClassName,
        renderFooter: _this.renderFooter,
        timePicker: props.timePicker,
        disabledDate: disabledDate,
        disabledTime: disabledTime,
        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
        locale: locale.lang,
        onOk: onOk,
        dateRender: dateRender,
        value: showDate,
        onValueChange: _this.handleShowDateChange,
        hoverValue: hoverValue,
        onHoverChange: _this.handleHoverChange,
        onPanelChange: props.onPanelChange,
        showToday: showToday,
        onInputSelect: _this.handleCalendarInputSelect
      })); // default width for showTime

      var pickerStyle = {};

      if (props.showTime) {
        pickerStyle.width = style && style.width || 350;
      }

      var _value5 = _slicedToArray(value, 2),
          startValue = _value5[0],
          endValue = _value5[1];

      var clearIcon = !props.disabled && props.allowClear && value && (startValue || endValue) ? React.createElement(_icon["default"], {
        type: "close-circle",
        className: "".concat(prefixCls, "-picker-clear"),
        onClick: _this.clearSelection,
        theme: "filled"
      }) : null;
      var inputIcon = suffixIcon && (React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
        className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-icon"), true), _classNames2))
      }) : React.createElement("span", {
        className: "".concat(prefixCls, "-picker-icon")
      }, suffixIcon)) || React.createElement(_icon["default"], {
        type: "calendar",
        className: "".concat(prefixCls, "-picker-icon")
      });

      var input = function input(_ref4) {
        var inputValue = _ref4.value;

        var _inputValue = _slicedToArray(inputValue, 2),
            start = _inputValue[0],
            end = _inputValue[1];

        return React.createElement("span", {
          className: props.pickerInputClass
        }, React.createElement("input", {
          disabled: props.disabled,
          readOnly: true,
          value: start && start.format(props.format) || '',
          placeholder: startPlaceholder,
          className: "".concat(prefixCls, "-range-picker-input"),
          tabIndex: -1
        }), React.createElement("span", {
          className: "".concat(prefixCls, "-range-picker-separator")
        }, " ~ "), React.createElement("input", {
          disabled: props.disabled,
          readOnly: true,
          value: end && end.format(props.format) || '',
          placeholder: endPlaceholder,
          className: "".concat(prefixCls, "-range-picker-input"),
          tabIndex: -1
        }), clearIcon, inputIcon);
      };

      return React.createElement("span", {
        ref: _this.savePicker,
        id: props.id,
        className: (0, _classnames["default"])(props.className, props.pickerClass),
        style: _extends({}, style, pickerStyle),
        tabIndex: props.disabled ? -1 : 0,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
      }, React.createElement(_Picker["default"], _extends({}, props, pickerChangeHandler, {
        calendar: calendar,
        value: value,
        open: open,
        onOpenChange: _this.handleOpenChange,
        prefixCls: "".concat(prefixCls, "-picker-container"),
        style: popupStyle
      }), input));
    };

    var value = props.value || props.defaultValue || [];

    var _value6 = _slicedToArray(value, 2),
        start = _value6[0],
        end = _value6[1];

    if (start && !(0, _interopDefault["default"])(moment).isMoment(start) || end && !(0, _interopDefault["default"])(moment).isMoment(end)) {
      throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
    }

    var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
    _this.state = {
      value: value,
      showDate: pickerValueAdapter(pickerValue || (0, _interopDefault["default"])(moment)()),
      open: props.open,
      hoverValue: []
    };
    return _this;
  }

  _createClass(RangePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!('open' in this.props) && prevState.open && !this.state.open) {
        this.focus();
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value, hidePanel) {
      this.handleChange(value);

      if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRangePicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var state = null;

      if ('value' in nextProps) {
        var value = nextProps.value || [];
        state = {
          value: value
        };

        if (!(0, _shallowequal["default"])(nextProps.value, prevState.value)) {
          state = _extends({}, state, {
            showDate: getShowDateFromValue(value) || prevState.showDate
          });
        }
      }

      if ('open' in nextProps && prevState.open !== nextProps.open) {
        state = _extends({}, state, {
          open: nextProps.open
        });
      }

      return state;
    }
  }]);

  return RangePicker;
}(React.Component);

RangePicker.defaultProps = {
  allowClear: true,
  showToday: false
};
(0, _reactLifecyclesCompat.polyfill)(RangePicker);
var _default = RangePicker;
exports["default"] = _default;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(46);

var _moment2 = _interopRequireDefault(_moment);

var _classnames2 = __webpack_require__(15);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactLifecyclesCompat = __webpack_require__(49);

var _KeyCode = __webpack_require__(230);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _CalendarPart = __webpack_require__(1106);

var _CalendarPart2 = _interopRequireDefault(_CalendarPart);

var _TodayButton = __webpack_require__(489);

var _TodayButton2 = _interopRequireDefault(_TodayButton);

var _OkButton = __webpack_require__(490);

var _OkButton2 = _interopRequireDefault(_OkButton);

var _TimePickerButton = __webpack_require__(491);

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

var _CommonMixin = __webpack_require__(492);

var _util = __webpack_require__(136);

var _toTime = __webpack_require__(1111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function isEmptyArray(arr) {
  return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
    return !i;
  }));
}

function isArraysEqual(a, b) {
  if (a === b) return true;
  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false;
  }
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

function getValueFromSelectedValue(selectedValue) {
  var start = selectedValue[0],
      end = selectedValue[1];

  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
  return [start, newEnd];
}

function normalizeAnchor(props, init) {
  var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
  var value = props.value || init && props.defaultValue;
  var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
  return !isEmptyArray(normalizedValue) ? normalizedValue : init && [(0, _moment2['default'])(), (0, _moment2['default'])().add(1, 'months')];
}

function generateOptions(length, extraOptionGen) {
  var arr = extraOptionGen ? extraOptionGen().concat() : [];
  for (var value = 0; value < length; value++) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }
  return arr;
}

function onInputSelect(direction, value) {
  if (!value) {
    return;
  }
  var originalValue = this.state.selectedValue;
  var selectedValue = originalValue.concat();
  var index = direction === 'left' ? 0 : 1;
  selectedValue[index] = value;
  if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
    selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
  }
  this.props.onInputSelect(selectedValue);
  this.fireSelectValueChange(selectedValue);
}

var RangeCalendar = function (_React$Component) {
  (0, _inherits3['default'])(RangeCalendar, _React$Component);

  function RangeCalendar(props) {
    (0, _classCallCheck3['default'])(this, RangeCalendar);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue || props.defaultSelectedValue;
    var value = normalizeAnchor(props, 1);
    _this.state = {
      selectedValue: selectedValue,
      prevSelectedValue: selectedValue,
      firstSelectedValue: null,
      hoverValue: props.hoverValue || [],
      value: value,
      showTimePicker: false,
      mode: props.mode || ['date', 'date']
    };
    return _this;
  }

  RangeCalendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};
    if ('value' in nextProps) {
      newState.value = normalizeAnchor(nextProps, 0);
    }
    if ('hoverValue' in nextProps && !isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
      newState.hoverValue = nextProps.hoverValue;
    }
    if ('selectedValue' in nextProps) {
      newState.selectedValue = nextProps.selectedValue;
      newState.prevSelectedValue = nextProps.selectedValue;
    }
    if ('mode' in nextProps && !isArraysEqual(state.mode, nextProps.mode)) {
      newState = { mode: nextProps.mode };
    }
    return newState;
  };

  // get disabled hours for second picker


  RangeCalendar.prototype.render = function render() {
    var _className, _classnames;

    var props = this.props,
        state = this.state;
    var prefixCls = props.prefixCls,
        dateInputPlaceholder = props.dateInputPlaceholder,
        seperator = props.seperator,
        timePicker = props.timePicker,
        showOk = props.showOk,
        locale = props.locale,
        showClear = props.showClear,
        showToday = props.showToday,
        type = props.type,
        clearIcon = props.clearIcon;
    var hoverValue = state.hoverValue,
        selectedValue = state.selectedValue,
        mode = state.mode,
        showTimePicker = state.showTimePicker;

    var className = (_className = {}, _className[props.className] = !!props.className, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[prefixCls + '-range'] = 1, _className[prefixCls + '-show-time-picker'] = showTimePicker, _className[prefixCls + '-week-number'] = props.showWeekNumber, _className);
    var classes = (0, _classnames3['default'])(className);
    var newProps = {
      selectedValue: state.selectedValue,
      onSelect: this.onSelect,
      onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined
    };

    var placeholder1 = void 0;
    var placeholder2 = void 0;

    if (dateInputPlaceholder) {
      if (Array.isArray(dateInputPlaceholder)) {
        placeholder1 = dateInputPlaceholder[0];
        placeholder2 = dateInputPlaceholder[1];
      } else {
        placeholder1 = placeholder2 = dateInputPlaceholder;
      }
    }
    var showOkButton = showOk === true || showOk !== false && !!timePicker;
    var cls = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-footer'] = true, _classnames[prefixCls + '-range-bottom'] = true, _classnames[prefixCls + '-footer-show-ok'] = showOkButton, _classnames));

    var startValue = this.getStartValue();
    var endValue = this.getEndValue();
    var todayTime = (0, _util.getTodayTime)(startValue);
    var thisMonth = todayTime.month();
    var thisYear = todayTime.year();
    var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
    var nextMonthOfStart = startValue.clone().add(1, 'months');
    var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month();

    // console.warn('Render:', selectedValue.map(t => t.format('YYYY-MM-DD')).join(', '));
    // console.log('start:', startValue.format('YYYY-MM-DD'));
    // console.log('end:', endValue.format('YYYY-MM-DD'));

    var extraFooter = props.renderFooter();

    return _react2['default'].createElement(
      'div',
      {
        ref: this.saveRoot,
        className: classes,
        style: props.style,
        tabIndex: '0',
        onKeyDown: this.onKeyDown
      },
      props.renderSidebar(),
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-panel' },
        showClear && selectedValue[0] && selectedValue[1] ? _react2['default'].createElement(
          'a',
          {
            role: 'button',
            title: locale.clear,
            onClick: this.clear
          },
          clearIcon || _react2['default'].createElement('span', { className: prefixCls + '-clear-btn' })
        ) : null,
        _react2['default'].createElement(
          'div',
          {
            className: prefixCls + '-date-panel',
            onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
            onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
          },
          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'left',
            disabledTime: this.disabledStartTime,
            disabledMonth: this.disabledStartMonth,
            format: this.getFormat(),
            value: startValue,
            mode: mode[0],
            placeholder: placeholder1,
            onInputSelect: this.onStartInputSelect,
            onValueChange: this.onStartValueChange,
            onPanelChange: this.onStartPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker,
            enablePrev: true,
            enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1]),
            clearIcon: clearIcon
          })),
          _react2['default'].createElement(
            'span',
            { className: prefixCls + '-range-middle' },
            seperator
          ),
          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'right',
            format: this.getFormat(),
            timePickerDisabledTime: this.getEndDisableTime(),
            placeholder: placeholder2,
            value: endValue,
            mode: mode[1],
            onInputSelect: this.onEndInputSelect,
            onValueChange: this.onEndValueChange,
            onPanelChange: this.onEndPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker,
            disabledTime: this.disabledEndTime,
            disabledMonth: this.disabledEndMonth,
            enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
            enableNext: true,
            clearIcon: clearIcon
          }))
        ),
        _react2['default'].createElement(
          'div',
          { className: cls },
          showToday || props.timePicker || showOkButton || extraFooter ? _react2['default'].createElement(
            'div',
            { className: prefixCls + '-footer-btn' },
            extraFooter,
            showToday ? _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, {
              disabled: isTodayInView,
              value: state.value[0],
              onToday: this.onToday,
              text: locale.backToToday
            })) : null,
            props.timePicker ? _react2['default'].createElement(_TimePickerButton2['default'], (0, _extends3['default'])({}, props, {
              showTimePicker: showTimePicker,
              onOpenTimePicker: this.onOpenTimePicker,
              onCloseTimePicker: this.onCloseTimePicker,
              timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
            })) : null,
            showOkButton ? _react2['default'].createElement(_OkButton2['default'], (0, _extends3['default'])({}, props, {
              onOk: this.onOk,
              okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length
            })) : null
          ) : null
        )
      )
    );
  };

  return RangeCalendar;
}(_react2['default'].Component);

RangeCalendar.propTypes = (0, _extends3['default'])({}, _CommonMixin.propType, {
  prefixCls: _propTypes2['default'].string,
  dateInputPlaceholder: _propTypes2['default'].any,
  seperator: _propTypes2['default'].string,
  defaultValue: _propTypes2['default'].any,
  value: _propTypes2['default'].any,
  hoverValue: _propTypes2['default'].any,
  mode: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOf(['date', 'month', 'year', 'decade'])),
  showDateInput: _propTypes2['default'].bool,
  timePicker: _propTypes2['default'].any,
  showOk: _propTypes2['default'].bool,
  showToday: _propTypes2['default'].bool,
  defaultSelectedValue: _propTypes2['default'].array,
  selectedValue: _propTypes2['default'].array,
  onOk: _propTypes2['default'].func,
  showClear: _propTypes2['default'].bool,
  locale: _propTypes2['default'].object,
  onChange: _propTypes2['default'].func,
  onSelect: _propTypes2['default'].func,
  onValueChange: _propTypes2['default'].func,
  onHoverChange: _propTypes2['default'].func,
  onPanelChange: _propTypes2['default'].func,
  format: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
  onClear: _propTypes2['default'].func,
  type: _propTypes2['default'].any,
  disabledDate: _propTypes2['default'].func,
  disabledTime: _propTypes2['default'].func,
  clearIcon: _propTypes2['default'].node,
  onKeyDown: _propTypes2['default'].func
});
RangeCalendar.defaultProps = (0, _extends3['default'])({}, _CommonMixin.defaultProp, {
  type: 'both',
  seperator: '~',
  defaultSelectedValue: [],
  onValueChange: noop,
  onHoverChange: noop,
  onPanelChange: noop,
  disabledTime: noop,
  onInputSelect: noop,
  showToday: true,
  showDateInput: true
});

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onDatePanelEnter = function () {
    if (_this2.hasSelectedValue()) {
      _this2.fireHoverValueChange(_this2.state.selectedValue.concat());
    }
  };

  this.onDatePanelLeave = function () {
    if (_this2.hasSelectedValue()) {
      _this2.fireHoverValueChange([]);
    }
  };

  this.onSelect = function (value) {
    var type = _this2.props.type;
    var _state = _this2.state,
        selectedValue = _state.selectedValue,
        prevSelectedValue = _state.prevSelectedValue,
        firstSelectedValue = _state.firstSelectedValue;

    var nextSelectedValue = void 0;
    if (type === 'both') {
      if (!firstSelectedValue) {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        nextSelectedValue = [value];
      } else if (_this2.compare(firstSelectedValue, value) < 0) {
        (0, _util.syncTime)(prevSelectedValue[1], value);
        nextSelectedValue = [firstSelectedValue, value];
      } else {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        (0, _util.syncTime)(prevSelectedValue[1], firstSelectedValue);
        nextSelectedValue = [value, firstSelectedValue];
      }
    } else if (type === 'start') {
      (0, _util.syncTime)(prevSelectedValue[0], value);
      var endValue = selectedValue[1];
      nextSelectedValue = endValue && _this2.compare(endValue, value) > 0 ? [value, endValue] : [value];
    } else {
      // type === 'end'
      var startValue = selectedValue[0];
      if (startValue && _this2.compare(startValue, value) <= 0) {
        (0, _util.syncTime)(prevSelectedValue[1], value);
        nextSelectedValue = [startValue, value];
      } else {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        nextSelectedValue = [value];
      }
    }

    _this2.fireSelectValueChange(nextSelectedValue);
  };

  this.onKeyDown = function (event) {
    if (event.target.nodeName.toLowerCase() === 'input') {
      return;
    }

    var keyCode = event.keyCode;

    var ctrlKey = event.ctrlKey || event.metaKey;

    var _state2 = _this2.state,
        selectedValue = _state2.selectedValue,
        hoverValue = _state2.hoverValue,
        firstSelectedValue = _state2.firstSelectedValue,
        value = _state2.value;
    var _props = _this2.props,
        onKeyDown = _props.onKeyDown,
        disabledDate = _props.disabledDate;

    // Update last time of the picker

    var updateHoverPoint = function updateHoverPoint(func) {
      // Change hover to make focus in UI
      var currentHoverTime = void 0;
      var nextHoverTime = void 0;
      var nextHoverValue = void 0;

      if (!firstSelectedValue) {
        currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || (0, _moment2['default'])();
        nextHoverTime = func(currentHoverTime);
        nextHoverValue = [nextHoverTime];
        _this2.fireHoverValueChange(nextHoverValue);
      } else {
        if (hoverValue.length === 1) {
          currentHoverTime = hoverValue[0].clone();
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = _this2.onDayHover(nextHoverTime);
        } else {
          currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = _this2.onDayHover(nextHoverTime);
        }
      }

      // Find origin hover time on value index
      if (nextHoverValue.length >= 2) {
        var miss = nextHoverValue.some(function (ht) {
          return !(0, _toTime.includesTime)(value, ht, 'month');
        });
        if (miss) {
          var newValue = nextHoverValue.slice().sort(function (t1, t2) {
            return t1.valueOf() - t2.valueOf();
          });
          if (newValue[0].isSame(newValue[1], 'month')) {
            newValue[1] = newValue[0].clone().add(1, 'month');
          }
          _this2.fireValueChange(newValue);
        }
      } else if (nextHoverValue.length === 1) {
        // If only one value, let's keep the origin panel
        var oriValueIndex = value.findIndex(function (time) {
          return time.isSame(currentHoverTime, 'month');
        });
        if (oriValueIndex === -1) oriValueIndex = 0;

        if (value.every(function (time) {
          return !time.isSame(nextHoverTime, 'month');
        })) {
          var _newValue = value.slice();
          _newValue[oriValueIndex] = nextHoverTime.clone();
          _this2.fireValueChange(_newValue);
        }
      }

      event.preventDefault();

      return nextHoverTime;
    };

    switch (keyCode) {
      case _KeyCode2['default'].DOWN:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, 1, 'weeks');
        });
        return;
      case _KeyCode2['default'].UP:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, -1, 'weeks');
        });
        return;
      case _KeyCode2['default'].LEFT:
        if (ctrlKey) {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, -1, 'years');
          });
        } else {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, -1, 'days');
          });
        }
        return;
      case _KeyCode2['default'].RIGHT:
        if (ctrlKey) {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, 1, 'years');
          });
        } else {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, 1, 'days');
          });
        }
        return;
      case _KeyCode2['default'].HOME:
        updateHoverPoint(function (time) {
          return (0, _toTime.goStartMonth)(time);
        });
        return;
      case _KeyCode2['default'].END:
        updateHoverPoint(function (time) {
          return (0, _toTime.goEndMonth)(time);
        });
        return;
      case _KeyCode2['default'].PAGE_DOWN:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, 1, 'month');
        });
        return;
      case _KeyCode2['default'].PAGE_UP:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, -1, 'month');
        });
        return;
      case _KeyCode2['default'].ENTER:
        {
          var lastValue = void 0;
          if (hoverValue.length === 0) {
            lastValue = updateHoverPoint(function (time) {
              return time;
            });
          } else if (hoverValue.length === 1) {
            lastValue = hoverValue[0];
          } else {
            lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
          }
          if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
            _this2.onSelect(lastValue);
          }
          event.preventDefault();
          return;
        }
      default:
        if (onKeyDown) {
          onKeyDown(event);
        }
    }
  };

  this.onDayHover = function (value) {
    var hoverValue = [];
    var _state3 = _this2.state,
        selectedValue = _state3.selectedValue,
        firstSelectedValue = _state3.firstSelectedValue;
    var type = _this2.props.type;

    if (type === 'start' && selectedValue[1]) {
      hoverValue = _this2.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
    } else if (type === 'end' && selectedValue[0]) {
      hoverValue = _this2.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
    } else {
      if (!firstSelectedValue) {
        if (_this2.state.hoverValue.length) {
          _this2.setState({ hoverValue: [] });
        }
        return hoverValue;
      }
      hoverValue = _this2.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
    }
    _this2.fireHoverValueChange(hoverValue);

    return hoverValue;
  };

  this.onToday = function () {
    var startValue = (0, _util.getTodayTime)(_this2.state.value[0]);
    var endValue = startValue.clone().add(1, 'months');
    _this2.setState({ value: [startValue, endValue] });
  };

  this.onOpenTimePicker = function () {
    _this2.setState({
      showTimePicker: true
    });
  };

  this.onCloseTimePicker = function () {
    _this2.setState({
      showTimePicker: false
    });
  };

  this.onOk = function () {
    var selectedValue = _this2.state.selectedValue;

    if (_this2.isAllowedDateAndTime(selectedValue)) {
      _this2.props.onOk(_this2.state.selectedValue);
    }
  };

  this.onStartInputSelect = function () {
    for (var _len = arguments.length, oargs = Array(_len), _key = 0; _key < _len; _key++) {
      oargs[_key] = arguments[_key];
    }

    var args = ['left'].concat(oargs);
    return onInputSelect.apply(_this2, args);
  };

  this.onEndInputSelect = function () {
    for (var _len2 = arguments.length, oargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      oargs[_key2] = arguments[_key2];
    }

    var args = ['right'].concat(oargs);
    return onInputSelect.apply(_this2, args);
  };

  this.onStartValueChange = function (leftValue) {
    var value = [].concat(_this2.state.value);
    value[0] = leftValue;
    return _this2.fireValueChange(value);
  };

  this.onEndValueChange = function (rightValue) {
    var value = [].concat(_this2.state.value);
    value[1] = rightValue;
    return _this2.fireValueChange(value);
  };

  this.onStartPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    var newMode = [mode, state.mode[1]];
    if (!('mode' in props)) {
      _this2.setState({
        mode: newMode
      });
    }
    var newValue = [value || state.value[0], state.value[1]];
    props.onPanelChange(newValue, newMode);
  };

  this.onEndPanelChange = function (value, mode) {
    var props = _this2.props,
        state = _this2.state;

    var newMode = [state.mode[0], mode];
    if (!('mode' in props)) {
      _this2.setState({
        mode: newMode
      });
    }
    var newValue = [state.value[0], value || state.value[1]];
    props.onPanelChange(newValue, newMode);
  };

  this.getStartValue = function () {
    var value = _this2.state.value[0];
    var selectedValue = _this2.state.selectedValue;
    // keep selectedTime when select date
    if (selectedValue[0] && _this2.props.timePicker) {
      value = value.clone();
      (0, _util.syncTime)(selectedValue[0], value);
    }
    if (_this2.state.showTimePicker && selectedValue[0]) {
      return selectedValue[0];
    }
    return value;
  };

  this.getEndValue = function () {
    var _state4 = _this2.state,
        value = _state4.value,
        selectedValue = _state4.selectedValue,
        showTimePicker = _state4.showTimePicker;

    var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month');
    // keep selectedTime when select date
    if (selectedValue[1] && _this2.props.timePicker) {
      (0, _util.syncTime)(selectedValue[1], endValue);
    }
    if (showTimePicker) {
      return selectedValue[1] ? selectedValue[1] : _this2.getStartValue();
    }
    return endValue;
  };

  this.getEndDisableTime = function () {
    var _state5 = _this2.state,
        selectedValue = _state5.selectedValue,
        value = _state5.value;
    var disabledTime = _this2.props.disabledTime;

    var userSettingDisabledTime = disabledTime(selectedValue, 'end') || {};
    var startValue = selectedValue && selectedValue[0] || value[0].clone();
    // if startTime and endTime is same day..
    // the second time picker will not able to pick time before first time picker
    if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
      var hours = startValue.hour();
      var minutes = startValue.minute();
      var second = startValue.second();
      var _disabledHours = userSettingDisabledTime.disabledHours,
          _disabledMinutes = userSettingDisabledTime.disabledMinutes,
          _disabledSeconds = userSettingDisabledTime.disabledSeconds;

      var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
      var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
      _disabledHours = generateOptions(hours, _disabledHours);
      _disabledMinutes = generateOptions(minutes, _disabledMinutes);
      _disabledSeconds = generateOptions(second, _disabledSeconds);
      return {
        disabledHours: function disabledHours() {
          return _disabledHours;
        },
        disabledMinutes: function disabledMinutes(hour) {
          if (hour === hours) {
            return _disabledMinutes;
          }
          return oldDisabledMinutes;
        },
        disabledSeconds: function disabledSeconds(hour, minute) {
          if (hour === hours && minute === minutes) {
            return _disabledSeconds;
          }
          return olddisabledSeconds;
        }
      };
    }
    return userSettingDisabledTime;
  };

  this.isAllowedDateAndTime = function (selectedValue) {
    return (0, _util.isAllowedDate)(selectedValue[0], _this2.props.disabledDate, _this2.disabledStartTime) && (0, _util.isAllowedDate)(selectedValue[1], _this2.props.disabledDate, _this2.disabledEndTime);
  };

  this.isMonthYearPanelShow = function (mode) {
    return ['month', 'year', 'decade'].indexOf(mode) > -1;
  };

  this.hasSelectedValue = function () {
    var selectedValue = _this2.state.selectedValue;

    return !!selectedValue[1] && !!selectedValue[0];
  };

  this.compare = function (v1, v2) {
    if (_this2.props.timePicker) {
      return v1.diff(v2);
    }
    return v1.diff(v2, 'days');
  };

  this.fireSelectValueChange = function (selectedValue, direct) {
    var timePicker = _this2.props.timePicker;
    var prevSelectedValue = _this2.state.prevSelectedValue;

    if (timePicker && timePicker.props.defaultValue) {
      var timePickerDefaultValue = timePicker.props.defaultValue;
      if (!prevSelectedValue[0] && selectedValue[0]) {
        (0, _util.syncTime)(timePickerDefaultValue[0], selectedValue[0]);
      }
      if (!prevSelectedValue[1] && selectedValue[1]) {
        (0, _util.syncTime)(timePickerDefaultValue[1], selectedValue[1]);
      }
    }

    if (!('selectedValue' in _this2.props)) {
      _this2.setState({
        selectedValue: selectedValue
      });
    }

    // 尚未选择过时间，直接输入的话
    if (!_this2.state.selectedValue[0] || !_this2.state.selectedValue[1]) {
      var startValue = selectedValue[0] || (0, _moment2['default'])();
      var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
      _this2.setState({
        selectedValue: selectedValue,
        value: getValueFromSelectedValue([startValue, endValue])
      });
    }

    if (selectedValue[0] && !selectedValue[1]) {
      _this2.setState({ firstSelectedValue: selectedValue[0] });
      _this2.fireHoverValueChange(selectedValue.concat());
    }
    _this2.props.onChange(selectedValue);
    if (direct || selectedValue[0] && selectedValue[1]) {
      _this2.setState({
        prevSelectedValue: selectedValue,
        firstSelectedValue: null
      });
      _this2.fireHoverValueChange([]);
      _this2.props.onSelect(selectedValue);
    }
  };

  this.fireValueChange = function (value) {
    var props = _this2.props;
    if (!('value' in props)) {
      _this2.setState({
        value: value
      });
    }
    props.onValueChange(value);
  };

  this.fireHoverValueChange = function (hoverValue) {
    var props = _this2.props;
    if (!('hoverValue' in props)) {
      _this2.setState({ hoverValue: hoverValue });
    }
    props.onHoverChange(hoverValue);
  };

  this.clear = function () {
    _this2.fireSelectValueChange([], true);
    _this2.props.onClear();
  };

  this.disabledStartTime = function (time) {
    return _this2.props.disabledTime(time, 'start');
  };

  this.disabledEndTime = function (time) {
    return _this2.props.disabledTime(time, 'end');
  };

  this.disabledStartMonth = function (month) {
    var value = _this2.state.value;

    return month.isSameOrAfter(value[1], 'month');
  };

  this.disabledEndMonth = function (month) {
    var value = _this2.state.value;

    return month.isSameOrBefore(value[0], 'month');
  };
};

(0, _reactLifecyclesCompat.polyfill)(RangeCalendar);

exports['default'] = (0, _CommonMixin.commonMixinWrapper)(RangeCalendar);
module.exports = exports['default'];

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(31);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CalendarHeader = __webpack_require__(487);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _DateTable = __webpack_require__(1107);

var _DateTable2 = _interopRequireDefault(_DateTable);

var _DateInput = __webpack_require__(1110);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _index = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarPart = function (_React$Component) {
  (0, _inherits3['default'])(CalendarPart, _React$Component);

  function CalendarPart() {
    (0, _classCallCheck3['default'])(this, CalendarPart);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  CalendarPart.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        value = props.value,
        hoverValue = props.hoverValue,
        selectedValue = props.selectedValue,
        mode = props.mode,
        direction = props.direction,
        locale = props.locale,
        format = props.format,
        placeholder = props.placeholder,
        disabledDate = props.disabledDate,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime,
        timePickerDisabledTime = props.timePickerDisabledTime,
        showTimePicker = props.showTimePicker,
        onInputSelect = props.onInputSelect,
        enablePrev = props.enablePrev,
        enableNext = props.enableNext,
        clearIcon = props.clearIcon;

    var shouldShowTimePicker = showTimePicker && timePicker;
    var disabledTimeConfig = shouldShowTimePicker && disabledTime ? (0, _index.getTimeConfig)(selectedValue, disabledTime) : null;
    var rangeClassName = prefixCls + '-range';
    var newProps = {
      locale: locale,
      value: value,
      prefixCls: prefixCls,
      showTimePicker: showTimePicker
    };
    var index = direction === 'left' ? 0 : 1;
    var timePickerEle = shouldShowTimePicker && _react2['default'].cloneElement(timePicker, (0, _extends3['default'])({
      showHour: true,
      showMinute: true,
      showSecond: true
    }, timePicker.props, disabledTimeConfig, timePickerDisabledTime, {
      onChange: onInputSelect,
      defaultOpenValue: value,
      value: selectedValue[index]
    }));

    var dateInputElement = props.showDateInput && _react2['default'].createElement(_DateInput2['default'], {
      format: format,
      locale: locale,
      prefixCls: prefixCls,
      timePicker: timePicker,
      disabledDate: disabledDate,
      placeholder: placeholder,
      disabledTime: disabledTime,
      value: value,
      showClear: false,
      selectedValue: selectedValue[index],
      onChange: onInputSelect,
      clearIcon: clearIcon
    });

    return _react2['default'].createElement(
      'div',
      {
        className: rangeClassName + '-part ' + rangeClassName + '-' + direction
      },
      dateInputElement,
      _react2['default'].createElement(
        'div',
        { style: { outline: 'none' } },
        _react2['default'].createElement(_CalendarHeader2['default'], (0, _extends3['default'])({}, newProps, {
          mode: mode,
          enableNext: enableNext,
          enablePrev: enablePrev,
          onValueChange: props.onValueChange,
          onPanelChange: props.onPanelChange,
          disabledMonth: props.disabledMonth
        })),
        showTimePicker ? _react2['default'].createElement(
          'div',
          { className: prefixCls + '-time-picker' },
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-time-picker-panel' },
            timePickerEle
          )
        ) : null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(_DateTable2['default'], (0, _extends3['default'])({}, newProps, {
            hoverValue: hoverValue,
            selectedValue: selectedValue,
            dateRender: props.dateRender,
            onSelect: props.onSelect,
            onDayHover: props.onDayHover,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          }))
        )
      )
    );
  };

  return CalendarPart;
}(_react2['default'].Component);

CalendarPart.propTypes = {
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].any,
  hoverValue: _propTypes2['default'].any,
  selectedValue: _propTypes2['default'].any,
  direction: _propTypes2['default'].any,
  locale: _propTypes2['default'].any,
  showDateInput: _propTypes2['default'].bool,
  showTimePicker: _propTypes2['default'].bool,
  format: _propTypes2['default'].any,
  placeholder: _propTypes2['default'].any,
  disabledDate: _propTypes2['default'].any,
  timePicker: _propTypes2['default'].any,
  disabledTime: _propTypes2['default'].any,
  onInputSelect: _propTypes2['default'].func,
  timePickerDisabledTime: _propTypes2['default'].object,
  enableNext: _propTypes2['default'].any,
  enablePrev: _propTypes2['default'].any,
  clearIcon: _propTypes2['default'].node
};
exports['default'] = CalendarPart;
module.exports = exports['default'];

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DateTHead = __webpack_require__(1108);

var _DateTHead2 = _interopRequireDefault(_DateTHead);

var _DateTBody = __webpack_require__(1109);

var _DateTBody2 = _interopRequireDefault(_DateTBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTable = function (_React$Component) {
  (0, _inherits3['default'])(DateTable, _React$Component);

  function DateTable() {
    (0, _classCallCheck3['default'])(this, DateTable);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTable.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls;
    return _react2['default'].createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      _react2['default'].createElement(_DateTHead2['default'], props),
      _react2['default'].createElement(_DateTBody2['default'], props)
    );
  };

  return DateTable;
}(_react2['default'].Component);

exports['default'] = DateTable;
module.exports = exports['default'];

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DateConstants = __webpack_require__(494);

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _moment = __webpack_require__(46);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTHead = function (_React$Component) {
  (0, _inherits3['default'])(DateTHead, _React$Component);

  function DateTHead() {
    (0, _classCallCheck3['default'])(this, DateTHead);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl = void 0;
    var now = (0, _moment2['default'])();
    for (var dateColIndex = 0; dateColIndex < _DateConstants2['default'].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % _DateConstants2['default'].DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = _react2['default'].createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      return _react2['default'].createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          veryShortWeekdays[xindex]
        )
      );
    });
    return _react2['default'].createElement(
      'thead',
      null,
      _react2['default'].createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(_react2['default'].Component);

exports['default'] = DateTHead;
module.exports = exports['default'];

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _DateConstants = __webpack_require__(494);

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _util = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
}

var DateTBody = function (_React$Component) {
  (0, _inherits3['default'])(DateTBody, _React$Component);

  function DateTBody() {
    (0, _classCallCheck3['default'])(this, DateTBody);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTBody.prototype.render = function render() {
    var props = this.props;
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var iIndex = void 0;
    var jIndex = void 0;
    var current = void 0;
    var dateTable = [];
    var today = (0, _util.getTodayTime)(value);
    var cellClass = prefixCls + '-cell';
    var weekNumberCellClass = prefixCls + '-week-number-cell';
    var dateClass = prefixCls + '-date';
    var todayClass = prefixCls + '-today';
    var selectedClass = prefixCls + '-selected-day';
    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
    var selectedStartDateClass = prefixCls + '-selected-start-date';
    var selectedEndDateClass = prefixCls + '-selected-end-date';
    var inRangeClass = prefixCls + '-in-range-cell';
    var lastMonthDayClass = prefixCls + '-last-month-cell';
    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
    var disabledClass = prefixCls + '-disabled-cell';
    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
    var month1 = value.clone();
    month1.date(1);
    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
    // calculate last month
    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }
        dateTable.push(current);
        passed++;
      }
    }
    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = _react2['default'].createElement(
          'td',
          {
            key: dateTable[passed].week(),
            role: 'gridcell',
            className: weekNumberCellClass
          },
          dateTable[passed].week()
        );
      }
      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];
        if (jIndex < _DateConstants2['default'].DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += ' ' + todayClass;
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedStartDateClass;
              }
            }
            if (startValue && endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedEndDateClass;
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += ' ' + selectedDateClass;
        }

        if (isBeforeCurrentMonthYear) {
          cls += ' ' + lastMonthDayClass;
        }

        if (isAfterCurrentMonthYear) {
          cls += ' ' + nextMonthDayClass;
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += ' ' + lastDayOfMonthClass;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ' ' + firstDisableClass;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ' ' + lastDisableClass;
            }
          }
        }

        if (selected) {
          cls += ' ' + selectedClass;
        }

        if (disabled) {
          cls += ' ' + disabledClass;
        }

        var dateHtml = void 0;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = _react2['default'].createElement(
            'div',
            {
              key: getIdFromDate(current),
              className: dateClass,
              'aria-selected': selected,
              'aria-disabled': disabled
            },
            content
          );
        }

        dateCells.push(_react2['default'].createElement(
          'td',
          {
            key: passed,
            onClick: disabled ? undefined : props.onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: 'gridcell',
            title: (0, _util.getTitleString)(current),
            className: cls
          },
          dateHtml
        ));

        passed++;
      }

      tableHtml.push(_react2['default'].createElement(
        'tr',
        {
          key: iIndex,
          role: 'row',
          className: (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
        },
        weekNumberCell,
        dateCells
      ));
    }
    return _react2['default'].createElement(
      'tbody',
      { className: prefixCls + '-tbody' },
      tableHtml
    );
  };

  return DateTBody;
}(_react2['default'].Component);

DateTBody.propTypes = {
  contentRender: _propTypes2['default'].func,
  dateRender: _propTypes2['default'].func,
  disabledDate: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
  value: _propTypes2['default'].object,
  hoverValue: _propTypes2['default'].any,
  showWeekNumber: _propTypes2['default'].bool
};
DateTBody.defaultProps = {
  hoverValue: []
};
exports['default'] = DateTBody;
module.exports = exports['default'];

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyCode = __webpack_require__(230);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _reactLifecyclesCompat = __webpack_require__(49);

var _moment = __webpack_require__(46);

var _moment2 = _interopRequireDefault(_moment);

var _util = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cachedSelectionStart = void 0;
var cachedSelectionEnd = void 0;
var dateInputInstance = void 0;

var DateInput = function (_React$Component) {
  (0, _inherits3['default'])(DateInput, _React$Component);

  function DateInput(props) {
    (0, _classCallCheck3['default'])(this, DateInput);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var selectedValue = props.selectedValue;

    _this.state = {
      str: (0, _util.formatDate)(selectedValue, _this.props.format),
      invalid: false,
      hasFocus: false
    };
    return _this;
  }

  DateInput.prototype.componentDidUpdate = function componentDidUpdate() {
    if (dateInputInstance && this.state.hasFocus && !this.state.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
      dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
    }
  };

  DateInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
    var newState = {};

    if (dateInputInstance) {
      cachedSelectionStart = dateInputInstance.selectionStart;
      cachedSelectionEnd = dateInputInstance.selectionEnd;
    }
    // when popup show, click body will call this, bug!
    var selectedValue = nextProps.selectedValue;
    if (!state.hasFocus) {
      newState = {
        str: (0, _util.formatDate)(selectedValue, nextProps.format),
        invalid: false
      };
    }

    return newState;
  };

  DateInput.getInstance = function getInstance() {
    return dateInputInstance;
  };

  DateInput.prototype.render = function render() {
    var props = this.props;
    var _state = this.state,
        invalid = _state.invalid,
        str = _state.str;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        placeholder = props.placeholder,
        clearIcon = props.clearIcon;

    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
    return _react2['default'].createElement(
      'div',
      { className: prefixCls + '-input-wrap' },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-date-input-wrap' },
        _react2['default'].createElement('input', {
          ref: this.saveDateInput,
          className: prefixCls + '-input ' + invalidClass,
          value: str,
          disabled: props.disabled,
          placeholder: placeholder,
          onChange: this.onInputChange,
          onKeyDown: this.onKeyDown,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        })
      ),
      props.showClear ? _react2['default'].createElement(
        'a',
        {
          role: 'button',
          title: locale.clear,
          onClick: this.onClear
        },
        clearIcon || _react2['default'].createElement('span', { className: prefixCls + '-clear-btn' })
      ) : null
    );
  };

  return DateInput;
}(_react2['default'].Component);

DateInput.propTypes = {
  prefixCls: _propTypes2['default'].string,
  timePicker: _propTypes2['default'].object,
  value: _propTypes2['default'].object,
  disabledTime: _propTypes2['default'].any,
  format: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
  locale: _propTypes2['default'].object,
  disabledDate: _propTypes2['default'].func,
  onChange: _propTypes2['default'].func,
  onClear: _propTypes2['default'].func,
  placeholder: _propTypes2['default'].string,
  onSelect: _propTypes2['default'].func,
  selectedValue: _propTypes2['default'].object,
  clearIcon: _propTypes2['default'].node
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClear = function () {
    _this2.setState({
      str: ''
    });
    _this2.props.onClear(null);
  };

  this.onInputChange = function (event) {
    var str = event.target.value;
    var _props = _this2.props,
        disabledDate = _props.disabledDate,
        format = _props.format,
        onChange = _props.onChange,
        selectedValue = _props.selectedValue;

    // 没有内容，合法并直接退出

    if (!str) {
      onChange(null);
      _this2.setState({
        invalid: false,
        str: str
      });
      return;
    }

    // 不合法直接退出
    var parsed = (0, _moment2['default'])(str, format, true);
    if (!parsed.isValid()) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    var value = _this2.props.value.clone();
    value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

    if (!value || disabledDate && disabledDate(value)) {
      _this2.setState({
        invalid: true,
        str: str
      });
      return;
    }

    if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
      _this2.setState({
        invalid: false,
        str: str
      });
      onChange(value);
    }
  };

  this.onFocus = function () {
    _this2.setState({ hasFocus: true });
  };

  this.onBlur = function () {
    _this2.setState(function (prevState, prevProps) {
      return {
        hasFocus: false,
        str: (0, _util.formatDate)(prevProps.value, prevProps.format)
      };
    });
  };

  this.onKeyDown = function (_ref) {
    var keyCode = _ref.keyCode;
    var _props2 = _this2.props,
        onSelect = _props2.onSelect,
        value = _props2.value;

    if (keyCode === _KeyCode2['default'].ENTER && onSelect) {
      onSelect(value.clone());
    }
  };

  this.getRootDOMNode = function () {
    return _reactDom2['default'].findDOMNode(_this2);
  };

  this.focus = function () {
    if (dateInputInstance) {
      dateInputInstance.focus();
    }
  };

  this.saveDateInput = function (dateInput) {
    dateInputInstance = dateInput;
  };
};

(0, _reactLifecyclesCompat.polyfill)(DateInput);

exports['default'] = DateInput;
module.exports = exports['default'];

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.goStartMonth = goStartMonth;
exports.goEndMonth = goEndMonth;
exports.goTime = goTime;
exports.includesTime = includesTime;
function goStartMonth(time) {
  return time.clone().startOf('month');
}

function goEndMonth(time) {
  return time.clone().endOf('month');
}

function goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}

function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments[1];
  var unit = arguments[2];

  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var CheckableTag =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckableTag, _React$Component);

  function CheckableTag() {
    var _this;

    _classCallCheck(this, CheckableTag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckableTag).apply(this, arguments));

    _this.handleClick = function () {
      var _this$props = _this.props,
          checked = _this$props.checked,
          onChange = _this$props.onChange;

      if (onChange) {
        onChange(!checked);
      }
    };

    _this.renderCheckableTag = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          checked = _a.checked,
          restProps = __rest(_a, ["prefixCls", "className", "checked"]);

      var prefixCls = getPrefixCls('tag', customizePrefixCls);
      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checkable"), true), _defineProperty(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
      delete restProps.onChange; // TypeScript cannot check delete now.

      return React.createElement("div", _extends({}, restProps, {
        className: cls,
        onClick: _this.handleClick
      }));
    };

    return _this;
  }

  _createClass(CheckableTag, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckableTag);
    }
  }]);

  return CheckableTag;
}(React.Component);

exports["default"] = CheckableTag;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var moment = _interopRequireWildcard(__webpack_require__(46));

var _reactLifecyclesCompat = __webpack_require__(49);

var _rcCalendar = _interopRequireDefault(__webpack_require__(482));

var _Picker = _interopRequireDefault(__webpack_require__(326));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

var _interopDefault = _interopRequireDefault(__webpack_require__(231));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function formatValue(value, format) {
  return value && value.format(format) || '';
}

var WeekPicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WeekPicker, _React$Component);

  function WeekPicker(props) {
    var _this;

    _classCallCheck(this, WeekPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WeekPicker).call(this, props));

    _this.weekDateRender = function (current) {
      var selectedValue = _this.state.value;

      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          prefixCls = _assertThisInitialize.prefixCls;

      var dateRender = _this.props.dateRender;
      var dateNode = dateRender ? dateRender(current) : current.date();

      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
        return React.createElement("div", {
          className: "".concat(prefixCls, "-selected-day")
        }, React.createElement("div", {
          className: "".concat(prefixCls, "-date")
        }, dateNode));
      }

      return React.createElement("div", {
        className: "".concat(prefixCls, "-date")
      }, dateNode);
    };

    _this.handleChange = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      _this.props.onChange(value, formatValue(value, _this.props.format));
    };

    _this.handleOpenChange = function (open) {
      var onOpenChange = _this.props.onOpenChange;

      if (!('open' in _this.props)) {
        _this.setState({
          open: open
        });
      }

      if (onOpenChange) {
        onOpenChange(open);
      }
    };

    _this.clearSelection = function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.handleChange(null);
    };

    _this.renderFooter = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          renderExtraFooter = _this$props.renderExtraFooter;
      return renderExtraFooter ? React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra")
      }, renderExtraFooter.apply(void 0, arguments)) : null;
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.renderWeekPicker = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props2 = _this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          pickerClass = _this$props2.pickerClass,
          popupStyle = _this$props2.popupStyle,
          pickerInputClass = _this$props2.pickerInputClass,
          format = _this$props2.format,
          allowClear = _this$props2.allowClear,
          locale = _this$props2.locale,
          localeCode = _this$props2.localeCode,
          disabledDate = _this$props2.disabledDate,
          style = _this$props2.style,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          id = _this$props2.id,
          suffixIcon = _this$props2.suffixIcon;
      var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
      // Have to add prefixCls on the instance.
      // https://github.com/facebook/react/issues/12397

      _this.prefixCls = prefixCls;
      var _this$state = _this.state,
          open = _this$state.open,
          pickerValue = _this$state.value;

      if (pickerValue && localeCode) {
        pickerValue.locale(localeCode);
      }

      var placeholder = 'placeholder' in _this.props ? _this.props.placeholder : locale.lang.placeholder;
      var calendar = React.createElement(_rcCalendar["default"], {
        showWeekNumber: true,
        dateRender: _this.weekDateRender,
        prefixCls: prefixCls,
        format: format,
        locale: locale.lang,
        showDateInput: false,
        showToday: false,
        disabledDate: disabledDate,
        renderFooter: _this.renderFooter
      });
      var clearIcon = !disabled && allowClear && _this.state.value ? React.createElement(_icon["default"], {
        type: "close-circle",
        className: "".concat(prefixCls, "-picker-clear"),
        onClick: _this.clearSelection,
        theme: "filled"
      }) : null;
      var inputIcon = suffixIcon && (React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
        className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames, "".concat(prefixCls, "-picker-icon"), true), _classNames))
      }) : React.createElement("span", {
        className: "".concat(prefixCls, "-picker-icon")
      }, suffixIcon)) || React.createElement(_icon["default"], {
        type: "calendar",
        className: "".concat(prefixCls, "-picker-icon")
      });

      var input = function input(_ref2) {
        var value = _ref2.value;
        return React.createElement("span", {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, React.createElement("input", {
          ref: _this.saveInput,
          disabled: disabled,
          readOnly: true,
          value: value && value.format(format) || '',
          placeholder: placeholder,
          className: pickerInputClass,
          onFocus: onFocus,
          onBlur: onBlur
        }), clearIcon, inputIcon);
      };

      return React.createElement("span", {
        className: (0, _classnames["default"])(className, pickerClass),
        style: style,
        id: id
      }, React.createElement(_Picker["default"], _extends({}, _this.props, {
        calendar: calendar,
        prefixCls: "".concat(prefixCls, "-picker-container"),
        value: pickerValue,
        onChange: _this.handleChange,
        open: open,
        onOpenChange: _this.handleOpenChange,
        style: popupStyle
      }), input));
    };

    var value = props.value || props.defaultValue;

    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
      throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
    }

    _this.state = {
      value: value,
      open: props.open
    };
    return _this;
  }

  _createClass(WeekPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!('open' in this.props) && prevState.open && !this.state.open) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderWeekPicker);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps || 'open' in nextProps) {
        var state = {};

        if ('value' in nextProps) {
          state.value = nextProps.value;
        }

        if ('open' in nextProps) {
          state.open = nextProps.open;
        }

        return state;
      }

      return null;
    }
  }]);

  return WeekPicker;
}(React.Component);

WeekPicker.defaultProps = {
  format: 'gggg-wo',
  allowClear: true
};
(0, _reactLifecyclesCompat.polyfill)(WeekPicker);
var _default = WeekPicker;
exports["default"] = _default;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  today: 'Oggi',
  now: 'Adesso',
  backToToday: 'Torna ad oggi',
  ok: 'Ok',
  clear: 'Cancella',
  month: 'Mese',
  year: 'Anno',
  timeSelect: 'Seleziona l\'ora',
  dateSelect: 'Seleziona la data',
  monthSelect: 'Seleziona il mese',
  yearSelect: 'Seleziona l\'anno',
  decadeSelect: 'Seleziona il decennio',
  yearFormat: 'YYYY',
  dateFormat: 'D/M/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Il mese scorso (PageUp)',
  nextMonth: 'Il prossimo mese (PageDown)',
  previousYear: 'L\'anno scorso (Control + sinistra)',
  nextYear: 'L\'anno prossimo (Control + destra)',
  previousDecade: 'Ultimo decennio',
  nextDecade: 'Prossimo decennio',
  previousCentury: 'Secolo precedente',
  nextCentury: 'Prossimo secolo'
};
module.exports = exports['default'];

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: "Selezionare l'orario"
};
var _default = locale;
exports["default"] = _default;

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var TREE_NODE_KEY_ALL=__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* TREE_NODE_KEY_PREFIX */]+'ALL';var TREE_NODE_KEY_OF_LEVEL_PREFIX=__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* TREE_NODE_KEY_PREFIX */]+'OF_LEVEL_';var TreeFilterTree=function TreeFilterTree(_ref){var t=_ref.t,column=_ref.column,dataLanguage=_ref.dataLanguage,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,treeFilter=_ref.treeFilter,isCC=_ref.isCC,columns=_ref.columns,callOnColumnValuesChangeWithSpinner=_ref.callOnColumnValuesChangeWithSpinner,index=_ref.index,disabled=_ref.disabled,hideInclusionRadio=_ref.hideInclusionRadio,callOnColumnModeChangeWithSpinner=_ref.callOnColumnModeChangeWithSpinner,setTPFromTo=_ref.setTPFromTo,hideIds=_ref.hideIds;var levelNodesKeys=[].concat(_toConsumableArray(Array(column.filteredCodelistTreeMaxDepth))).map(function(_,index){return TREE_NODE_KEY_OF_LEVEL_PREFIX+index;});return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__enhanced_tree__["a" /* default */],{treePrefix:column.filteredValues&&(column.filteredCodelistTree&&column.filteredCodelistTree.length>0||column.filteredValues.length>0)?[function(){var obj={id:TREE_NODE_KEY_OF_LEVEL_PREFIX+0,name:{en:t('components.treeFilter.levelNode',{level:0})},level:0};if(column.filteredCodelistTreeMaxDepth!==null&&column.filteredCodelistTreeMaxDepth!==0){[].concat(_toConsumableArray(Array(column.filteredCodelistTreeMaxDepth-1))).forEach(function(){var pointer=obj;var counter=0;while(pointer.codes){pointer=pointer.codes[0];counter++;}pointer.codes=[{id:TREE_NODE_KEY_OF_LEVEL_PREFIX+Number(counter+1),name:{en:t('components.treeFilter.levelNode',{level:counter+1})},level:counter+1}];});}return obj;}()]:null,tree:column.filteredValues?column.filteredCodelistTree||column.filteredValues.filter(function(val){return val!==null;}).map(function(val){return{id:val,name:val};}):null,getNodeKey:function getNodeKey(_ref2){var id=_ref2.id;return id;},childrenKey:"codes",idKey:"id",nameKey:"name",catIdKey:"id",catNameKey:"name",icon:"file-text",hiddenIdKeys:[TREE_NODE_KEY_ALL].concat(_toConsumableArray(levelNodesKeys)),hideIds:hideIds,isRootIconLikeChildrenIcon:true,isEmptyCategoryIconLikeLeafIcon:true,placeholder:column.filteredCodelistTree&&column.filteredValues&&column.filteredCodelistTree.length===0||column.filteredValues&&column.filteredValues.length===0?t("components.treeFilter.noValuesPlaceholder"):column.filteredCodelistTree===null&&column.filteredValues&&column.filteredValues.filter(function(val){return val!==null;}).length===0?t("components.treeFilter.noValuesInColumnPlaceholder"):null,getFilter:function getFilter(searchText){return function(_ref3){var id=_ref3.id,name=_ref3.name;var search=searchText.toLowerCase();return id&&id.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,dataLanguage||appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},checkable:true,checkStrictly:true,onCheck:function onCheck(_ref4,_ref5){var checked=_ref4.checked;var node=_ref5.node,isChecked=_ref5.checked;var callOnColumnValuesChange=function callOnColumnValuesChange(){var newChecked=[];if(node.props.eventKey===TREE_NODE_KEY_ALL){if(isChecked){newChecked=[TREE_NODE_KEY_ALL].concat(_toConsumableArray(levelNodesKeys),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_10__utils_tree__["l" /* getNodes */])(column.filteredCodelistTree,"codes",function(){return true;}).map(function(_ref6){var id=_ref6.id;return id;})));}else{newChecked=[];}}else if(levelNodesKeys.includes(node.props.eventKey)){var level=Number(node.props.eventKey.replace(TREE_NODE_KEY_OF_LEVEL_PREFIX,""));var keysAtDepth=Object(__WEBPACK_IMPORTED_MODULE_10__utils_tree__["m" /* getNodesAtDepth */])(column.CodelistCode?column.filteredCodelistTree:(column.filteredValues||[]).map(function(val){return{id:val,name:val};}),"codes",level+1).map(function(_ref7){var id=_ref7.id;return id;});if(isChecked){newChecked=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.uniq([TREE_NODE_KEY_OF_LEVEL_PREFIX+level].concat(_toConsumableArray(checked),_toConsumableArray(keysAtDepth)));}else{newChecked=checked.filter(function(key){return!keysAtDepth.includes(key);});}}else{newChecked=checked.filter(function(key){return!key.startsWith(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* TREE_NODE_KEY_PREFIX */]);});}var newTreeFilter=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.cloneDeep(treeFilter);var columnName=!isCC?column.name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name);newChecked=newChecked.filter(function(id){return id.startsWith(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* TREE_NODE_KEY_PREFIX */])||(column.filteredValues||[]).includes(id);});newTreeFilter[columnName]={mode:newTreeFilter[columnName]&&newTreeFilter[columnName].mode?newTreeFilter[columnName].mode:__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["n" /* FILTER_MODE_IN */],values:newChecked};var colNames=columns.map(function(_ref8){var name=_ref8.name;return!isCC?name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(name);});var colIndex=colNames.indexOf(columnName);var subsequentColNames=colNames.splice(colIndex+1);// delete filters for subsequent cols
subsequentColNames.forEach(function(name){delete newTreeFilter[!isCC?name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(name)];});if(subsequentColNames.includes(column.name!=="ID_TIME_PERIOD")||subsequentColNames.includes(column.name!=="TIME_PERIOD")){setTPFromTo({tempTPFrom:null,tempTPTo:null});}if(Object(__WEBPACK_IMPORTED_MODULE_12__utils__["h" /* getTreeFilterStrFromObj */])(newTreeFilter,colNames).length>__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* TREE_FILTER_MAX_LENGTH */]){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t('components.treeFilter.errors.maxLength.title'),content:t('components.treeFilter.errors.maxLength.content')});}else{callOnColumnValuesChangeWithSpinner(column.name,newChecked);}};var subsequentColumnNames=columns.slice(index+1).map(function(_ref9){var name=_ref9.name;return!isCC?name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(name);});if(subsequentColumnNames.find(function(name){return treeFilter[name];})){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('components.treeFilter.confirms.filterChange.title'),content:t('components.treeFilter.confirms.filterChange.content'),onOk:function onOk(){callOnColumnValuesChange();},cancelText:t('commons.buttons.cancel.title')});}else{callOnColumnValuesChange();}},checkedKeys:{checked:treeFilter[column.name]?treeFilter[column.name].values:treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]?treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values:[]},getNodeIsCheckable:function getNodeIsCheckable(_ref10){var id=_ref10.id;return!disabled&&(id.startsWith(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* TREE_NODE_KEY_PREFIX */])||(column.filteredValues||[]).includes(id));},getNodeIsCounted:function getNodeIsCounted(_ref11){var id=_ref11.id;return!disabled&&(id.startsWith(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* TREE_NODE_KEY_PREFIX */])||(column.filteredValues||[]).includes(id));},leftActions:hideInclusionRadio!==true?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group,{disabled:disabled,value:treeFilter[column.name]&&treeFilter[column.name].mode?treeFilter[column.name].mode:__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["n" /* FILTER_MODE_IN */],onChange:function onChange(_ref12){var target=_ref12.target;var subsequentColumnNames=columns.slice(index+1).map(function(_ref13){var name=_ref13.name;return name;});if(subsequentColumnNames.find(function(name){return treeFilter[name];})){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('components.treeFilter.confirms.filterChange.title'),content:t('components.treeFilter.confirms.filterChange.content'),onOk:function onOk(){callOnColumnModeChangeWithSpinner(column.name,target.value);},cancelText:t('commons.buttons.cancel.title')});}else{callOnColumnModeChangeWithSpinner(column.name,target.value);}}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["n" /* FILTER_MODE_IN */]},t('components.treeFilter.filterModeRadio.in.title')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["o" /* FILTER_MODE_NOT_IN */]},t('components.treeFilter.filterModeRadio.notIn.title'))))):null,nodeActions:[function(_ref14){var id=_ref14.id,codes=_ref14.codes;return codes&&codes.length>0&&!id.startsWith(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* TREE_NODE_KEY_PREFIX */])?Object.assign({},__WEBPACK_IMPORTED_MODULE_15__styles_buttons__["c" /* BUTTON_CHECK_ALL_CHILDS */],{title:t("components.treeFilter.checkUncheckAllChilds.title"),disabled:disabled,onClick:function onClick(){var childIds=codes.map(function(_ref15){var id=_ref15.id;return id;});var checkedColIds=treeFilter[column.name]?treeFilter[column.name].values:treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)]?treeFilter[Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(column.name)].values:[];var mergedIds=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.uniq(childIds.concat(checkedColIds));var checked=mergedIds.length>checkedColIds.length?mergedIds:checkedColIds.filter(function(id){return!childIds.includes(id);});checked=checked.filter(function(id){return id.startsWith(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* TREE_NODE_KEY_PREFIX */])||(column.filteredValues||[]).includes(id);});var subsequentColumnNames=columns.slice(index+1).map(function(_ref16){var name=_ref16.name;return!isCC?name:Object(__WEBPACK_IMPORTED_MODULE_13__utils_normalizers__["a" /* getNormalizedColumnName */])(name);});if(subsequentColumnNames.find(function(name){return treeFilter[name];})){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('components.treeFilter.confirms.filterChange.title'),content:t('components.treeFilter.confirms.filterChange.content'),onOk:function onOk(){callOnColumnValuesChangeWithSpinner(column.name,checked);},cancelText:t('commons.buttons.cancel.title')});}else{callOnColumnValuesChangeWithSpinner(column.name,checked);}}}):null;}],disabledCheckboxTitle:disabled?null:function(){return t('components.treeFilter.disabledCheckbox.title');}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])()(TreeFilterTree));

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataflowBuilderWizardReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query_reducer__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_tree_reducer__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_annotations_reducer__ = __webpack_require__(1124);
var dataflowBuilderWizardReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({query:__WEBPACK_IMPORTED_MODULE_1__query_reducer__["a" /* default */],categoryTree:__WEBPACK_IMPORTED_MODULE_2__category_tree_reducer__["a" /* default */],layoutAnnotations:__WEBPACK_IMPORTED_MODULE_3__layout_annotations_reducer__["a" /* default */]})});/* unused harmony default export */ var _unused_webpack_default_export = (dataflowBuilderWizardReducer);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__columnsFormReducer__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__previewReducer__ = __webpack_require__(1122);
var dataflowBuilderWizardQueryReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({columnsForm:__WEBPACK_IMPORTED_MODULE_1__columnsFormReducer__["a" /* default */],preview:__WEBPACK_IMPORTED_MODULE_2__previewReducer__["a" /* default */]})});/* harmony default export */ __webpack_exports__["a"] = (dataflowBuilderWizardQueryReducer);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(190);
var dataflowBuilderWizardQueryColumnsFormReducer=function dataflowBuilderWizardQueryColumnsFormReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isCubeTreeVisible:false,categorisedCubes:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_SHOW */]:return Object.assign({},state,{isCubeTreeVisible:true});case __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_TREE_HIDE */]:return Object.assign({},state,{isCubeTreeVisible:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{isCubeTreeVisible:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:Object(__WEBPACK_IMPORTED_MODULE_1__utils_treeBuilders__["b" /* getCubesTree */])(action.response[0],action.response[1])});case __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_FIRST_ROW_READ */]:return Object.assign({},state,{isCubeTreeVisible:state.isCubeTreeVisible?action.response.Data[0]===null||action.response.Data[0]===undefined:false});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (dataflowBuilderWizardQueryColumnsFormReducer);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(190);
var dataflowBuilderWizardQueryPreviewReducer=function dataflowBuilderWizardQueryPreviewReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isRowsModalVisible:false,rows:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_SHOW */]:return Object.assign({},state,{isRowsModalVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* DATAFLOW_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_MODAL_HIDE */]:return Object.assign({},state,{rows:null,isRowsModalVisible:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* DATAFLOW_BUILER_WIZARD_QUERY_PREVIEW_ROWS_READ */]:return Object.assign({},state,{isRowsModalVisible:false,rows:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* DATAFLOW_BUILER_WIZARD_QUERY_PREVIEW_ROWS_READ */]:return Object.assign({},state,{rows:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (dataflowBuilderWizardQueryPreviewReducer);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(160);
var dataflowBuilderWizardCategoryTreeReducer=function dataflowBuilderWizardCategoryTreeReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{categorySchemes:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ */]:return Object.assign({},state,{categorySchemes:null});case __WEBPACK_IMPORTED_MODULE_6__actions__["c" /* DATAFLOW_BUILDER_WIZARD_HIDE */]:return Object.assign({},state,{categorySchemes:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ */]:return Object.assign({},state,{categorySchemes:[]});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DATAFLOW_BUILDER_WIZARD_CATEGORY_TREE_CATEGORISATIONS_READ */]:var categorySchemes=(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */])||[]).map(function(artefact){var categoryScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);categoryScheme.categories=categoryScheme.categories?Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(categoryScheme.categories,"categories",function(node){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(node,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]);}):[];return Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])([categoryScheme],"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]]);return node;})[0];});return Object.assign({},state,{categorySchemes:categorySchemes});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (dataflowBuilderWizardCategoryTreeReducer);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares_current_node_config_middleware__ = __webpack_require__(42);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var dataflowBuilderWizardLayoutAnnotationsReducer=function dataflowBuilderWizardLayoutAnnotationsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isFormVisible:false,itemsPage:null,valuesForLayoutAnnotations:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SHOW */]:return Object.assign({},state,{isFormVisible:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_HIDE */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT */]:return Object.assign({},state,{isFormVisible:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET */]:return Object.assign({},state,{itemsPage:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_RESET */]:return Object.assign({},state,{valuesForLayoutAnnotations:null});case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ */]:var itemsPage=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_3__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0])[0]).codes||[];var filteredCodes=action.response[1].Data.map(function(row){return row[action.colName];});return Object.assign({},state,{itemsPage:itemsPage.filter(function(_ref){var id=_ref.id;return filteredCodes.includes(id)||action.selectedCodes.includes(id);})});case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_READ */]:return Object.assign({},state,{valuesForLayoutAnnotations:action.response.Data.map(function(row){return row[action.colName];}).map(function(val){return _defineProperty({},action.colName,val);})});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (dataflowBuilderWizardLayoutAnnotationsReducer);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_artefacts__ = __webpack_require__(56);
var dataflowBuilderTreeReducer=function dataflowBuilderTreeReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isVisible:false,dataflowTree:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* DATAFLOW_BUILDER_TREE_SHOW */]:return Object.assign({},state,{isVisible:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DATAFLOW_BUILDER_TREE_HIDE */]:return Object.assign({},state,{isVisible:false});case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DATAFLOW_BUILDER_TREE_CATEGORISED_DATAFLOWS_READ */]:return Object.assign({},state,{dataflowTree:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DATAFLOW_BUILDER_TREE_CATEGORISED_DATAFLOWS_READ */]:return Object.assign({},state,{dataflowTree:[]});default:return state;}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DATAFLOW_BUILDER_TREE_CATEGORISED_DATAFLOWS_READ */]:var sdmxDataflows=(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[2],__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["B" /* SDMX_JSON_DATAFLOW_LIST_KEY */])||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);});var ddbDataflows=action.response[0];var dataflows=sdmxDataflows.filter(function(_ref){var id=_ref.id,agencyID=_ref.agencyID,version=_ref.version;return ddbDataflows.filter(function(_ref2){var ID=_ref2.ID,Agency=_ref2.Agency,Version=_ref2.Version;return ID===id&&Agency===agencyID&&Version===version;}).length>0;});var categorisations=(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1],__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["r" /* SDMX_JSON_CATEGORISATION_LIST_KEY */])||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);});var categorySchemes=(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1],__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */])||[]).map(function(artefact){var categoryScheme=Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);categoryScheme.categories=categoryScheme.categories?Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["h" /* getMappedTree */])(categoryScheme.categories,"categories",function(node){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(node,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]);}):[];return Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["h" /* getMappedTree */])([categoryScheme],"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]]);return node;})[0];});var isDataflowInCategory=function isDataflowInCategory(df,cat){if(cat)return df.categorisations.filter(function(_ref3){var urn=_ref3.urn;return urn===Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(cat);}).length>0;else return df.categorisations.length>0;};return Object.assign({},state,{dataflowTree:Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["d" /* getCategorisedObjectsTree */])(dataflows.map(function(dataflow){return Object.assign({},dataflow,{categorisations:categorisations.filter(function(_ref4){var source=_ref4.source;return source===dataflow.urn;}).map(function(_ref5){var target=_ref5.target,autoAnnotations=_ref5.autoAnnotations;return{urn:target,order:autoAnnotations?autoAnnotations.find(function(_ref6){var type=_ref6.type;return type===Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations.categorisationsOrder;})||null:null};})});}),categorySchemes,'categories',function(a,b,cat){var aOrder=(a.categorisations.find(function(_ref7){var urn=_ref7.urn;return urn===Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(cat);})||{}).order;var bOrder=(b.categorisations.find(function(_ref8){var urn=_ref8.urn;return urn===Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(cat);})||{}).order;if(aOrder&&aOrder.text&&aOrder.text[action.lang]&&bOrder&&bOrder.text&&bOrder.text[action.lang]){return Number(aOrder.text[action.lang])-Number(bOrder.text[action.lang]);}else{return 0;}},isDataflowInCategory,'id','name')});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (dataflowBuilderTreeReducer);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var appConfigReducer=function appConfigReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{config:{UserInterface:{MaxTreeNodes:null,MaxTreeNodesForPagination:null,MinTreeNodesForPagination:null,MaxNodeForExpandAll:null,TreePageSize:null,DefaultSidebarCollapsed:null,Languages:null,DefaultLanguage:null,AnonymousPages:null},Agencies:null,DataManagement:{CubeCodePrefix:null,DataLanguages:[],MaxDescriptionLength:null},DefaultHeaderSubmitStructure:{ID:null,test:null,sender:null,receiver:null},SuperUserCredentials:null,EndpointSetting:{NsiTimeOut:null,DmTimeOut:null,MaTimeOut:null}},isFetchConfigDisabled:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* APP_CONFIG_USER_INTERFACE_FORM_CHANGE */]:{var userInterface=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.config.UserInterface);var customizer=function customizer(_,src,key){if(key==="Languages"||key==="AnonymousPages")return src;else{return undefined;}};return Object.assign({},state,{config:Object.assign({},state.config,{UserInterface:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mergeWith(userInterface,action.fields,customizer)})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* APP_CONFIG_AGENCIES_CHANGE */]:{return Object.assign({},state,{config:Object.assign({},state.config,{Agencies:action.fields})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* APP_CONFIG_DATA_MANAGEMENT_CHANGE */]:{var dataManagement=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.config.DataManagement);var _customizer=function _customizer(_,src,key){if(key==="DataLanguages")return src;else{return undefined;}};return Object.assign({},state,{config:Object.assign({},state.config,{DataManagement:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mergeWith(dataManagement,action.fields,_customizer)})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* APP_CONFIG_DEFAULT_HEADER_SUBMIT_STRUCTURE_CHANGE */]:{var defaultHeaderSubmitStructure=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.config.DefaultHeaderSubmitStructure);return Object.assign({},state,{config:Object.assign({},state.config,{DefaultHeaderSubmitStructure:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(defaultHeaderSubmitStructure,action.fields)})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* APP_CONFIG_SUPERUSER_CREDENTIALS_CHANGE */]:{return Object.assign({},state,{config:Object.assign({},state.config,{SuperUserCredentials:action.fields})});}case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* APP_CONFIG_ENDPOINT_SETTINGS_CHANGE */]:{var endpointSettings=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state.config.EndpointSetting);return Object.assign({},state,{config:Object.assign({},state.config,{EndpointSetting:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(endpointSettings,action.fields)})});}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* APP_CONFIG_CONFIG_READ */]:return Object.assign({},state,{config:Object.assign({},state.config,action.response,{SuperUserCredentials:action.response.SuperUserCredentials.map(function(el){return Object.assign({},el,{password:"",confirmPassword:""});})}),isFetchConfigDisabled:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* APP_CONFIG_CONFIG_SUBMIT */]:return Object.assign({},state,{isFetchConfigDisabled:false});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (appConfigReducer);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_GeneralForm__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_EndpointForm__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var getDictionaryFromLangs=function getDictionaryFromLangs(langs,str){return langs.map(function(_ref){var code=_ref.code;return code;}).reduce(function(ac,a){return Object.assign({},ac,_defineProperty({},a,str));},{});};var nodesConfigReducer=function nodesConfigReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{config:null,configBeforeSort:null,isMsdsVisible:false,msds:null,nodeIndex:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* NODES_CONFIG_NODE_ADD */]:return Object.assign({},state,{config:[].concat(_toConsumableArray(state.config),[{isNewNode:true,isCollapsed:false,isNSIPingOk:null,isMAPingOk:null,isDMPingOk:null,isMDPingOk:null,General:{DefaultItemsViewMode:__WEBPACK_IMPORTED_MODULE_3__node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */],canViewUnallowedBuilderNodes:false,Invisible:false},Agencies:[{Id:"OECD",Name:getDictionaryFromLangs(action.dataLangs,"Organisation for Economic Co-operation and Development")},{Id:"ESTAT",Name:getDictionaryFromLangs(action.dataLangs,"Eurostat")},{Id:"ECB",Name:getDictionaryFromLangs(action.dataLangs,"European Central Bank")},{Id:"WB",Name:getDictionaryFromLangs(action.dataLangs,"World Bank")},{Id:"BIS",Name:getDictionaryFromLangs(action.dataLangs,"Bank for International Settlements")},{Id:"IMF",Name:getDictionaryFromLangs(action.dataLangs,"International Monetary Fund")},{Id:"UNSD",Name:getDictionaryFromLangs(action.dataLangs,"United Nation Statistical Division")},{Id:"UNICEF",Name:getDictionaryFromLangs(action.dataLangs,"United Nations Children's Fund")},{Id:"ILO",Name:getDictionaryFromLangs(action.dataLangs,"International Labour Organization")},{Id:"FAO",Name:getDictionaryFromLangs(action.dataLangs,"Food and Agriculture Organisation")},{Id:"IAEG-SDGs",Name:getDictionaryFromLangs(action.dataLangs,"Inter-Agency and Expert Group on SDGs")},{Id:"IT1",Name:getDictionaryFromLangs(action.dataLangs,"Istat")},{Id:"BE2",Name:getDictionaryFromLangs(action.dataLangs,"National Bank of Belgium")},{Id:"TN1",Name:getDictionaryFromLangs(action.dataLangs,"INS Tunisia")},{Id:"AU1",Name:getDictionaryFromLangs(action.dataLangs,"Australian Bureau of Statistics")},{Id:"AE1",Name:getDictionaryFromLangs(action.dataLangs,"Federal Competitiveness and Statistics Authority of United Arab Emirates")},{Id:"LU1",Name:getDictionaryFromLangs(action.dataLangs,"STATEC - National Institute of Statistics and Economic Studies of the Grand Duchy of Luxembourg")},{Id:"SPC",Name:getDictionaryFromLangs(action.dataLangs,"Pacific Community (SPC)")},{Id:"ITH1",Name:getDictionaryFromLangs(action.dataLangs,"Provincial Statistics Institute (ASTAT)")},{Id:"INE1",Name:getDictionaryFromLangs(action.dataLangs,"National Institute of Statistics (Chile)")},{Id:"SE1",Name:getDictionaryFromLangs(action.dataLangs,"Statistics Estonia")},{Id:"UKDS",Name:getDictionaryFromLangs(action.dataLangs,"UK Data Service")},{Id:"NZ1",Name:getDictionaryFromLangs(action.dataLangs,"Stats NZ")},{Id:"AST",Name:getDictionaryFromLangs(action.dataLangs,"AST")}],Endpoint:{PingArtefact:__WEBPACK_IMPORTED_MODULE_4__node_EndpointForm__["c" /* NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CONCEPT_SCHEME */],NSIEndpointType:__WEBPACK_IMPORTED_MODULE_4__node_EndpointForm__["b" /* NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_SOAP */]},AnnotationTabs:{IsTextCollapsed:true,Tabs:[]},Annotations:{ConceptSchemesOrder:"ORDER",CategorySchemesOrder:"ORDER",CodelistsOrder:"ORDER",CategorisationsOrder:"ORDER",LayoutRow:"LAYOUT_ROW",LayoutColumn:"LAYOUT_COLUMN",LayoutFilter:"LAYOUT_FILTER",LayoutRowSection:"LAYOUT_ROW_SECTION",LayoutChartPrimaryDim:"LAYOUT_CHART_PRIMARY_DIM",LayoutChartSecondaryDim:"LAYOUT_CHART_SECONDARY_DIM",LayoutChartFilter:"LAYOUT_CHART_FILTER",NotDisplayed:"NOT_DISPLAYED",LayoutDataflowKeywords:'KEYWORDS',LayoutCriteriaSelection:"CRITERIA_SELECTION",LayoutAttachedDataFiles:'ATTACHED_DATA_FILES',LayoutDefaultPresentation:'DEFAULT_VIEW',LayoutDecimalSeparator:'LAYOUT_DECIMAL_SEPARATOR',LayoutNumberOfDecimals:'LAYOUT_NUMBER_OF_DECIMALS',LayoutReferenceMetadata:'METADATA_URL',LayoutEmptyCellPlaceholder:'LAYOUT_EMPTY_CELL_PLACEHOLDER',LayoutDataflowNotes:'DATAFLOW_NOTES',LayoutTerritorialDimensionIds:'GEO_ID',LayoutDataflowSource:"DATAFLOW_SOURCE",LayoutDataflowHidden:"DATAFLOW_HIDDEN",FullName:"FULL_NAME",Default:"DEFAULT",VirtualDataflowNode:"VIRTUAL_DATAFLOW_NODE",DDBDataflow:"DDBDataflow",CustomDSD:"CustomDSD",AssociatedCube:"AssociatedCube",Changed:"CHANGED",Metadataset:"AssociatedMetadataSet",HaveMetadata:"HAVE_METADATA",RestrictedForPublication:"RESTRICTED_FOR_PUBLICATION",AttachedFilePath:"ATTACHED_FILE_PATH",DCAT_IsMultilingual:"SDMX21_IsMultilingual",CustomIsPresentational:"CUSTOM_IS_PRESENTATIONAL",LastUpdate:"LAST_UPDATE",DataflowCatalogType:"DATAFLOW_CATALOG_TYPE"},Search:{ExcludeCodelists:["CL_UPDATE_STATUS","SDMX_M_PERIODS","SDMX_Q_PERIODS","SDMX_S_PERIODS","SDMX_H_PERIODS"],ExcludeConceptSchemes:["COMPONENT_ROLES"]},Proxy:{Enabled:false},DataBrowser:{Enable:false,HTTPAuthEnable:false,ProxyEnable:false},DcatApIt:{MSD:null},AST:{TerritorialDimIds:["ITTER107","REF_AREA","TERRITORIO","TERRITORY"],ASTTerritoryDimId:"TERRITORIO",ASTTerritorialCodelist:"CL_AST_ITTER+IT1+1.3",ASTTerritoryConceptScheme:"CROSS_DOMAIN_CONCEPTS+SDMX+2.0",ASTTerritoryConcept:"REF_AREA"}}])});case __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* NODES_CONFIG_NEW_NODE_REMOVE */]:{var _config=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.config);_config.splice(action.nodeIndex,1);return Object.assign({},state,{config:_config});}case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NODES_CONFIG_CONFIG_CHANGE */]:var initialDataBrowserCacheFields={URL:"",Username:"",Password:"",HTTPAuthEnable:false,HTTPAuthUsername:"",HTTPAuthPassword:"",HTTPAuthDomain:"",ProxyEnable:false,ProxyURL:"",ProxyPort:"",ProxyUsername:"",ProxyPassword:""};return Object.assign({},state,{config:action.config.map(function(node){return Object.assign({},node,{isNSIPingOk:null,isMAPingOk:null,isDMPingOk:null,isMDPingOk:null,DataBrowser:Object.assign({},node.DataBrowser,node.DataBrowser.Enable?{}:initialDataBrowserCacheFields)});})});case __WEBPACK_IMPORTED_MODULE_2__actions__["o" /* NODES_CONFIG_NODE_COLLAPSED_CHANGE */]:{var _config2=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.config);return Object.assign({},state,{config:_config2.map(function(node,index){return Object.assign({},node,{isCollapsed:action.nodeIndex===index?action.collapsed:node.isCollapsed});})});}case __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* NODES_CONFIG_MSDS_SHOW */]:return Object.assign({},state,{isMsdsVisible:true,nodeIndex:action.nodeIndex});case __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* NODES_CONFIG_MSDS_HIDE */]:return Object.assign({},state,{isMsdsVisible:false,msds:null,nodeIndex:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* NODES_CONFIG_MSD_SET */]:return Object.assign({},state,{isMsdsVisible:false,msds:null,nodeIndex:null,config:state.config.map(function(node,index){if(index===state.nodeIndex){node.DcatApIt.MSD=action.msd;}return node;})});case __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* NODES_CONFIG_MSD_UNSET */]:return Object.assign({},state,{config:state.config.map(function(node,index){if(index===action.nodeIndex){node.DcatApIt.MSD=null;}return node;})});case __WEBPACK_IMPORTED_MODULE_2__actions__["m" /* NODES_CONFIG_NODE_CHECK_ENDPOINT_MD */]:var config=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.config);return Object.assign({},state,{config:config.map(function(node,index){return Object.assign({},node,{isMDPingOk:action.nodeIndex===index?action.requestSuccess:node.isMDPingOk});})});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["r" /* NODES_CONFIG_NODE_SORT */]:{return Object.assign({},state,{config:action.orderedNodes,configBeforeSort:state.config});}default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["r" /* NODES_CONFIG_NODE_SORT */]:{return Object.assign({},state,{config:state.configBeforeSort,configBeforeSort:null});}default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* NODES_CONFIG_CONFIG_READ */]:return Object.assign({},state,{config:action.response.map(function(node){return Object.assign({},node,{isCollapsed:true,isNSIPingOk:null,isMAPingOk:null,isDMPingOk:null,isMDPingOk:null,DataBrowser:Object.assign({Enable:false,HTTPAuthEnable:false,ProxyEnable:false},node.DataBrowser),LoginProviders:(node.LoginProviders||[]).map(function(loginProvider){return Object.assign({},loginProvider,{SuperadminMails:loginProvider.SuperadminMails?loginProvider.SuperadminMails.split("|"):null});})});}),configBeforeSort:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["q" /* NODES_CONFIG_NODE_REMOVE */]:{var _config3=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.config);_config3.splice(action.nodeIndex,1);return Object.assign({},state,{config:_config3});}case __WEBPACK_IMPORTED_MODULE_2__actions__["n" /* NODES_CONFIG_NODE_CHECK_ENDPOINT_NSI */]:{var _config4=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.config);return Object.assign({},state,{config:_config4.map(function(node,index){return Object.assign({},node,{isNSIPingOk:action.nodeIndex===index?action.response:node.isNSIPingOk});})});}case __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* NODES_CONFIG_NODE_CHECK_ENDPOINT_MA */]:{var _config5=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.config);return Object.assign({},state,{config:_config5.map(function(node,index){return Object.assign({},node,{isMAPingOk:action.nodeIndex===index?action.response:node.isMAPingOk});})});}case __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* NODES_CONFIG_NODE_CHECK_ENDPOINT_DM */]:{var _config6=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.config);return Object.assign({},state,{config:_config6.map(function(node,index){return Object.assign({},node,{isDMPingOk:action.nodeIndex===index?action.response:node.isDMPingOk});})});}case __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* NODES_CONFIG_MSDS_READ */]:return Object.assign({},state,{msds:(Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(msd){return Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(msd,Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (nodesConfigReducer);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var importStructuresReducer=function importStructuresReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{file:null,items:null,hash:null,report:null,selectedItems:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* IMPORT_STRUCTURES_FORM_CHANGE */]:return Object.assign({},state,{file:action.fields.file!==undefined?action.fields.file:state.file,items:null,hash:null,selectedItems:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* IMPORT_STRUCTURES_RESET */]:return Object.assign({},state,{file:null,items:null,hash:null,report:null,selectedItems:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* IMPORT_STRUCTURES_REPORT_HIDE */]:return Object.assign({},state,{report:null,items:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* IMPORT_STRUCTURES_ITEM_SELECT */]:var selectedItems=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.selectedItems);selectedItems=action.selected?(selectedItems||[]).concat(action.item):(selectedItems||[]).filter(function(item){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(item)!==Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.item);});return Object.assign({},state,{selectedItems:selectedItems});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* IMPORT_STRUCTURES_ALL_ITEMS_SELECT */]:return Object.assign({},state,{selectedItems:action.items});case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* IMPORT_STRUCTURES_FILE_UPLOAD */]:return Object.assign({},state,{hash:action.response.hashImport,items:action.response.importedItem});case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* IMPORT_STRUCTURES_SUBMIT */]:return Object.assign({},state,{file:null,hash:null,selectedItems:null,report:action.response.itemsMessage});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (importStructuresReducer);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPORT_DETAILS_WIZARD_STEP_FIRST */
/* unused harmony export REPORT_DETAILS_WIZARD_STEP_SECOND */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons_constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
var REPORT_DETAILS_WIZARD_STEP_FIRST=0;var REPORT_DETAILS_WIZARD_STEP_SECOND=1;var getCatalogueInitializedText=function getCatalogueInitializedText(node,dataflow,mawsUrl,isDefaultEmpty){switch(node.id){case"DCAT_AP_IT_DATASET_IDENTIFIER":{node.texts=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dataflow);break;}case"DCAT_AP_IT_DATASET_TITLE":{node.texts=dataflow.name;break;}case"DCAT_AP_IT_DATASET_DESCRIPTION":{node.texts=dataflow.description;break;}case"DCAT_AP_IT_DISTRIBUTION_FORMAT":{node.texts={en:"SDMX"};break;}case"DCAT_AP_IT_DISTRIBUTION_ACCESS_URL":{node.texts=mawsUrl?""+mawsUrl+(mawsUrl.slice(-1)==='/'?'':'/')+"sdmx/rest/data/"+dataflow.agencyID+","+dataflow.id+","+dataflow.version+"/all":node.texts;break;}default:{node.texts=isDefaultEmpty?null:node.texts;}}return node;};var dcatReducer=function dcatReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{metadataSets:null,metadataSetId:null,msd:null,msdTree:null,conceptSchemeTriplets:null,conceptSchemes:null,isMetadataSetVisible:false,metadataSet:null,isMetadataflowsVisible:false,metadataflows:null,isReportsVisible:false,reports:null,reportHtmlPageUrl:null,metadataSetHtmlPageUrl:null,isReportVisible:false,step:null,report:null,reportStructure:null,reportId:null,target:null,identifiableTargets:null,selectedIdentifiableTarget:null,artefacts:null,targetDataflow:null,selectedAttribute:null,isCodesVisible:false,codes:null,dataflow:null,isReportInitialized:false,reportAnnotations:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_5__actions__["v" /* DCAT_METADATA_SET_SHOW */]:return Object.assign({},state,{metadataSetId:action.metadataSetId,isMetadataSetVisible:true});case __WEBPACK_IMPORTED_MODULE_5__actions__["o" /* DCAT_METADATA_SET_HIDE */]:return Object.assign({},state,{metadataSetId:null,isMetadataSetVisible:false,metadataSet:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["m" /* DCAT_METADATA_SET_CREATE */]:return Object.assign({},state,{isMetadataSetVisible:true,metadataSet:{id:null,name:null,metadataflowTriplet:null,msdUrn:null,reportingBegin:null,reportingEnd:null,validFrom:null,validTo:null,publicationYear:null,publicationPeriod:null}});case __WEBPACK_IMPORTED_MODULE_5__actions__["u" /* DCAT_METADATA_SET_REPORTS_SHOW */]:return Object.assign({},state,{metadataSetId:action.metadataSetId,isReportsVisible:true});case __WEBPACK_IMPORTED_MODULE_5__actions__["s" /* DCAT_METADATA_SET_REPORTS_HIDE */]:return Object.assign({},state,{metadataSetId:null,isReportsVisible:false,reports:null,metadataSet:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["l" /* DCAT_METADATA_SET_CHANGE */]:{var metadataSet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.metadataSet);var _customizer=function _customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{metadataSet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(metadataSet,action.fields,_customizer)});}case __WEBPACK_IMPORTED_MODULE_5__actions__["I" /* DCAT_REPORT_CREATE */]:{return Object.assign({},state,{isReportVisible:true,step:REPORT_DETAILS_WIZARD_STEP_FIRST});}case __WEBPACK_IMPORTED_MODULE_5__actions__["h" /* DCAT_METADATAFLOWS_SHOW */]:return Object.assign({},state,{isMetadataflowsVisible:true});case __WEBPACK_IMPORTED_MODULE_5__actions__["f" /* DCAT_METADATAFLOWS_HIDE */]:return Object.assign({},state,{isMetadataflowsVisible:false,metadataflows:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["i" /* DCAT_METADATAFLOW_SET */]:return Object.assign({},state,{isMetadataflowsVisible:false,metadataflows:null,metadataSet:Object.assign({},state.metadataSet,{msdUrn:action.msdUrn,metadataflowTriplet:action.triplet})});case __WEBPACK_IMPORTED_MODULE_5__actions__["j" /* DCAT_METADATAFLOW_UNSET */]:return Object.assign({},state,{metadataSet:Object.assign({},state.metadataSet,{metadataflowTriplet:null,msdUrn:null})});case __WEBPACK_IMPORTED_MODULE_5__actions__["L" /* DCAT_REPORT_HIDE */]:return Object.assign({},state,{report:null,reportId:null,target:null,identifiableTargets:null,isReportVisible:false,reportStructure:null,selectedAttribute:null,step:null,targetDataflow:null,reportAnnotations:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["N" /* DCAT_REPORT_HTML_PAGE_SHOW */]:return Object.assign({},state,{reportHtmlPageUrl:action.htmlPageUrl});case __WEBPACK_IMPORTED_MODULE_5__actions__["M" /* DCAT_REPORT_HTML_PAGE_HIDE */]:return Object.assign({},state,{reportHtmlPageUrl:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["Q" /* DCAT_REPORT_STEP_SET */]:{var _reportStructure=action.step===REPORT_DETAILS_WIZARD_STEP_SECOND&&state.reportStructure===null?Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["Q" /* getReportStructureFromSdmxJsonReport */])(state.msdTree,state.target,state.report,action.dataLanguages,action.t,Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action)):state.reportStructure;if(action.step===REPORT_DETAILS_WIZARD_STEP_SECOND&&state.targetDataflow){_reportStructure=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["h" /* getMappedTree */])(_reportStructure,"metadataAttributes",function(node){return getCatalogueInitializedText(node,state.targetDataflow,action.mawsUrl,!state.isReportInitialized);});}return Object.assign({},state,{step:action.step,reportStructure:_reportStructure,selectedAttribute:null,isReportInitialized:true});}case __WEBPACK_IMPORTED_MODULE_5__actions__["H" /* DCAT_REPORT_ATTRIBUTE_SELECT */]:{var _reportStructure2=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.reportStructure);var selectedAttribute=action.selectedAttributeKey?Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["k" /* getNode */])(_reportStructure2,"metadataAttributes",function(node){return node.nodeKey===action.selectedAttributeKey;}):null;return Object.assign({},state,{selectedAttribute:selectedAttribute});}case __WEBPACK_IMPORTED_MODULE_5__actions__["z" /* DCAT_REPORT_ATTRIBUTE_CHANGE */]:{var _reportStructure3=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.reportStructure);var _selectedAttribute=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["k" /* getNode */])(_reportStructure3,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});var _customizer2=function _customizer2(_,src,key){if(key==="annotations"){return src;}else{return undefined;}};_selectedAttribute=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(_selectedAttribute,action.fields,_customizer2);return Object.assign({},state,{reportStructure:_reportStructure3,selectedAttribute:_selectedAttribute});}case __WEBPACK_IMPORTED_MODULE_5__actions__["F" /* DCAT_REPORT_ATTRIBUTE_CREATE */]:{var _reportStructure4=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.reportStructure);var selectedFolder=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["k" /* getNode */])(_reportStructure4,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});var node=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["k" /* getNode */])(state.msdTree,"metadataAttributes",function(node){return node.id===__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["v" /* EMPTY_REPORT_ATTRIBUTE_KEY */]+state.selectedAttribute.id;}));node=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["h" /* getMappedTree */])([node],"metadataAttributes",function(node){return Object.assign({},node,{nodeKey:__WEBPACK_IMPORTED_MODULE_4_uuid___default()()});})[0];selectedFolder.metadataAttributes.push(Object.assign({},node,{isFolder:null,id:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["O" /* getNextAttributeIndexAvailable */])(selectedFolder.metadataAttributes)+". "+selectedFolder.id,name:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["O" /* getNextAttributeIndexAvailable */])(selectedFolder.metadataAttributes)+". "+selectedFolder.name,nodeKey:__WEBPACK_IMPORTED_MODULE_4_uuid___default()(),texts:null}));return Object.assign({},state,{reportStructure:Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["f" /* getFilteredTree */])(_reportStructure4,"metadataAttributes",function(node){return!node.id.includes(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["v" /* EMPTY_REPORT_ATTRIBUTE_KEY */]);}),selectedAttribute:selectedFolder});}case __WEBPACK_IMPORTED_MODULE_5__actions__["G" /* DCAT_REPORT_ATTRIBUTE_DELETE */]:var reportStructure=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.reportStructure);var parentAttribute=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["k" /* getNode */])(reportStructure,"metadataAttributes",function(node){return node.metadataAttributes.find(function(child){return child.nodeKey===state.selectedAttribute.nodeKey;});});parentAttribute.metadataAttributes=parentAttribute.metadataAttributes.filter(function(child){return child.nodeKey!==state.selectedAttribute.nodeKey;});return Object.assign({},state,{reportStructure:reportStructure,selectedAttribute:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["C" /* DCAT_REPORT_ATTRIBUTE_CODES_SHOW */]:return Object.assign({},state,{isCodesVisible:true});case __WEBPACK_IMPORTED_MODULE_5__actions__["A" /* DCAT_REPORT_ATTRIBUTE_CODES_HIDE */]:return Object.assign({},state,{isCodesVisible:false,codes:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["D" /* DCAT_REPORT_ATTRIBUTE_CODE_SET */]:{var _reportStructure5=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.reportStructure);var selectedCode=state.codes.find(function(code){return code.id===action.codeId;});var _selectedAttribute2=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["k" /* getNode */])(_reportStructure5,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});_selectedAttribute2.texts=selectedCode.name;return Object.assign({},state,{isCodesVisible:false,codes:null,reportStructure:_reportStructure5,selectedAttribute:_selectedAttribute2});}case __WEBPACK_IMPORTED_MODULE_5__actions__["E" /* DCAT_REPORT_ATTRIBUTE_CODE_UNSET */]:{var _reportStructure6=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.reportStructure);var _selectedAttribute3=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["k" /* getNode */])(_reportStructure6,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});_selectedAttribute3.texts=null;return Object.assign({},state,{reportStructure:_reportStructure6,selectedAttribute:_selectedAttribute3});}case __WEBPACK_IMPORTED_MODULE_5__actions__["O" /* DCAT_REPORT_ID_CHANGE */]:{var newVal=action.id;var oldVal=state.id;return Object.assign({},state,{reportId:newVal?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toUpper(/^[a-zA-Z0-9_]*$/.test(newVal)?newVal:oldVal):newVal});}case __WEBPACK_IMPORTED_MODULE_5__actions__["X" /* DCAT_REPORT_TARGET_SELECT */]:{var msdTree=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.msdTree);return Object.assign({},state,{target:action.target,identifiableTargets:msdTree.find(function(msd){return msd.target===action.target;}).identifiableTargets,reportStructure:null,selectedAttribute:null});}case __WEBPACK_IMPORTED_MODULE_5__actions__["U" /* DCAT_REPORT_TARGET_ARTEFACTS_SHOW */]:return Object.assign({},state,{selectedIdentifiableTarget:action.identifiableTarget});case __WEBPACK_IMPORTED_MODULE_5__actions__["S" /* DCAT_REPORT_TARGET_ARTEFACTS_HIDE */]:return Object.assign({},state,{selectedIdentifiableTarget:null,artefacts:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["V" /* DCAT_REPORT_TARGET_ARTEFACT_SET */]:var identifiableTargets=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.identifiableTargets);var identifiableTargetId=action.identifiableTargetId?action.identifiableTargetId:state.selectedIdentifiableTarget.id;var identifiableTarget=identifiableTargets.find(function(_ref){var id=_ref.id;return id===identifiableTargetId;});if(state.selectedIdentifiableTarget){var urnNamespace=__WEBPACK_IMPORTED_MODULE_8__commons_constants__["a" /* ARTEFACT_TYPES */].find(function(_ref2){var type=_ref2.type;return type===state.selectedIdentifiableTarget.objectType.toLowerCase();}).urnNamespace;identifiableTarget.value=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(action.value,urnNamespace);}else{identifiableTarget.value=action.value;}return Object.assign({},state,{selectedIdentifiableTarget:null,identifiableTargets:identifiableTargets,artefacts:null,targetDataflow:state.artefacts?state.artefacts.find(function(dataflow){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dataflow)===Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.value);}):null});case __WEBPACK_IMPORTED_MODULE_5__actions__["W" /* DCAT_REPORT_TARGET_ARTEFACT_UNSET */]:{var _identifiableTargets=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.identifiableTargets);_identifiableTargets.find(function(value){return value.id===action.identifiableTarget.id;}).value=null;return Object.assign({},state,{identifiableTargets:_identifiableTargets});}case __WEBPACK_IMPORTED_MODULE_5__actions__["b" /* DCAT_DATAFLOW_CHANGE */]:var dataflow=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.dataflow);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{dataflow:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(dataflow,action.fields,customizer)});case __WEBPACK_IMPORTED_MODULE_5__actions__["c" /* DCAT_DATAFLOW_HIDE */]:return Object.assign({},state,{dataflow:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["q" /* DCAT_METADATA_SET_HTML_PAGE_SHOW */]:return Object.assign({},state,{metadataSetHtmlPageUrl:action.htmlPageUrl});case __WEBPACK_IMPORTED_MODULE_5__actions__["p" /* DCAT_METADATA_SET_HTML_PAGE_HIDE */]:return Object.assign({},state,{metadataSetHtmlPageUrl:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_5__actions__["k" /* DCAT_METADATA_SETS_READ */]:{var metadataSets=(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0],__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["K" /* SDMX_JSON_METADATA_SET_LIST_KEY */])||[]).map(function(ms){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(ms,null,__WEBPACK_IMPORTED_MODULE_8__commons_constants__["d" /* customIsReferenceMetadataAutoAnnotation */]);}).filter(function(_ref3){var msdUrn=_ref3.msdUrn;return msdUrn===Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).dcatapit.msd;}).map(function(ms){var mdfTriplet=Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(ms);return Object.assign({},ms,{mdfId:mdfTriplet.id,mdfAgency:mdfTriplet.agencyID,mdfVersion:mdfTriplet.version,hasPermission:action.ownedMetadataflows.includes(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(mdfTriplet))});});var msd=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1])[0]);var conceptSchemeTriplets=[];msd.metadataStructureComponents.reportStructureList.reportStructures.map(function(tree){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["h" /* getMappedTree */])(tree.metadataAttributeList.metadataAttributes,"metadataAttributes",function(node){if(!conceptSchemeTriplets.find(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(triplet)===Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(node.conceptIdentity));})){conceptSchemeTriplets.push(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(node.conceptIdentity));}return node;});});return Object.assign({},state,{metadataSets:metadataSets,msd:msd,conceptSchemeTriplets:conceptSchemeTriplets});}case __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* DCAT_CONCEPT_SCHEMES_READ */]:var conceptSchemes=action.response.map(function(res){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["y" /* SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(res)[0]);});var _msdTree=Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["N" /* getMsdTree */])(state.msd,conceptSchemes,action.appLang,action.dataLangs,Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action));return Object.assign({},state,{msdTree:_msdTree,conceptSchemes:conceptSchemes});case __WEBPACK_IMPORTED_MODULE_5__actions__["r" /* DCAT_METADATA_SET_READ */]:{var _userPermissions=Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var _customNoneIsAutoAnnotation=_userPermissions&&_userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _metadataSet=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],null,_customNoneIsAutoAnnotation||__WEBPACK_IMPORTED_MODULE_8__commons_constants__["d" /* customIsReferenceMetadataAutoAnnotation */]);return Object.assign({},state,{metadataSet:Object.assign({},_metadataSet,{metadataflowTriplet:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(_metadataSet)})});}case __WEBPACK_IMPORTED_MODULE_5__actions__["t" /* DCAT_METADATA_SET_REPORTS_READ */]:{var _metadataSet2=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],null,__WEBPACK_IMPORTED_MODULE_8__commons_constants__["d" /* customIsReferenceMetadataAutoAnnotation */]);var reports=(_metadataSet2.reports||[]).map(function(report){var referenceValueObject=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(report.target.referenceValues[0].object));return Object.assign({},report,{isPublished:(report.annotations.find(function(_ref4){var id=_ref4.id;return(id||"").toLowerCase()===__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["z" /* REPORT_STATE_NAME_ANNOTATION_ID */].toLowerCase();})||{}).text,hasPermission:report.target.id===__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["t" /* CATALOG_TARGET_ID */]?action.ownedMetadataflows.includes(referenceValueObject):action.ownedDataflows.includes(referenceValueObject)});});reports=reports.filter(function(report){return report.isPublished===__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */]||report.hasPermission;});var reportAnnotations=null;if(state.isReportVisible){var report=(reports||[]).find(function(_ref5){var id=_ref5.id;return id===state.id;});reportAnnotations=report?report.annotations:null;}return Object.assign({},state,{metadataSet:_metadataSet2,reports:reports,reportAnnotations:reportAnnotations});}case __WEBPACK_IMPORTED_MODULE_5__actions__["w" /* DCAT_METADATA_SET_SUBMIT */]:{return Object.assign({},state,{metadataSet:null,metadataSets:null,metadataSetId:null,msd:null,msdTree:null,conceptSchemeTriplets:null,conceptSchemes:null,isMetadataSetVisible:false});}case __WEBPACK_IMPORTED_MODULE_5__actions__["n" /* DCAT_METADATA_SET_DELETE */]:return Object.assign({},state,{metadataSets:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["g" /* DCAT_METADATAFLOWS_READ */]:var metadataflows=(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact);}).filter(function(_ref6){var structure=_ref6.structure;return structure===action.msdUrn;}).filter(function(_ref7){var id=_ref7.id,agencyID=_ref7.agencyID,version=_ref7.version;return action.ownedMetadataflows.includes(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agencyID,version:version}));});return Object.assign({},state,{metadataflows:metadataflows});case __WEBPACK_IMPORTED_MODULE_5__actions__["P" /* DCAT_REPORT_READ */]:{var _metadataSet3=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var _report=_metadataSet3.reports[0];var _identifiableTargets2=state.msdTree.find(function(msd){return msd.target===_report.target.id;}).identifiableTargets.map(function(el){var referenceValue=_report.target.referenceValues.find(function(_ref8){var id=_ref8.id;return id===el.id;});return Object.assign({},el,{value:referenceValue?referenceValue.object:null});});return Object.assign({},state,{report:_report,reportId:_report.id,target:_report.target.id,identifiableTargets:_identifiableTargets2,isReportVisible:true,step:REPORT_DETAILS_WIZARD_STEP_FIRST});}case __WEBPACK_IMPORTED_MODULE_5__actions__["B" /* DCAT_REPORT_ATTRIBUTE_CODES_READ */]:return Object.assign({},state,{codes:Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes});case __WEBPACK_IMPORTED_MODULE_5__actions__["T" /* DCAT_REPORT_TARGET_ARTEFACTS_READ */]:{var artefacts=(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact);});if(state.selectedIdentifiableTarget.objectType==="Dataflow"){artefacts=artefacts.filter(function(dataflow){return action.ownedDataflows.includes(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dataflow));});}return Object.assign({},state,{artefacts:artefacts});}case __WEBPACK_IMPORTED_MODULE_5__actions__["R" /* DCAT_REPORT_SUBMIT */]:{return Object.assign({},state,{reports:null});}case __WEBPACK_IMPORTED_MODULE_5__actions__["J" /* DCAT_REPORT_DELETE */]:return Object.assign({},state,{reports:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["Y" /* DCAT_UPDATE_REPORT_STATE_SUBMIT */]:return Object.assign({},state,{reports:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["d" /* DCAT_DATAFLOW_READ */]:var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _dataflow=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0],Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,customNoneIsAutoAnnotation);return Object.assign({},state,{dataflow:Object.assign({},_dataflow,{dsd:Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(_dataflow.structure))})});case __WEBPACK_IMPORTED_MODULE_5__actions__["e" /* DCAT_DATAFLOW_SUBMIT */]:{return Object.assign({},state,{targetDataflow:action.dataflow,dataflow:null});}case __WEBPACK_IMPORTED_MODULE_5__actions__["y" /* DCAT_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD */]:{var _reportStructure7=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.reportStructure);var _selectedAttribute4=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tree__["k" /* getNode */])(_reportStructure7,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});_selectedAttribute4.attachmentUploaded[action.lang]=true;_selectedAttribute4.attachmentName[action.lang]=action.response;return Object.assign({},state,{reportStructure:_reportStructure7,selectedAttribute:_selectedAttribute4});}default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_5__actions__["J" /* DCAT_REPORT_DELETE */]:case __WEBPACK_IMPORTED_MODULE_5__actions__["Y" /* DCAT_UPDATE_REPORT_STATE_SUBMIT */]:return Object.assign({},state,{conceptSchemeTriplets:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (dcatReducer);

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getContentConstraintFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tree_filter_utils__ = __webpack_require__(65);
var getContentConstraintFilter=function getContentConstraintFilter(filter){var res=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(filter);if(res){Object.keys(res).forEach(function(id){res[id].values=res[id].values&&res[id].values.length?res[id].values.filter(function(val){return!(val&&val.startsWith(__WEBPACK_IMPORTED_MODULE_1__components_tree_filter_utils__["b" /* TREE_NODE_KEY_PREFIX */]));}):res[id].values;});}return res;};

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
var syncCodelisReducer=function syncCodelisReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{codelists:null,selectedCodelists:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SYNC_CODELISTS_CODELISTS_TO_SYNC_CHANGE */]:return Object.assign({},state,{selectedCodelists:action.selectedCodelists});case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SYNC_CODELISTS_CODELISTS_TO_SYNC_READ */]:return Object.assign({},state,{codelists:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SYNC_CODELISTS_CODELISTS_TO_SYNC_READ */]:return Object.assign({},state,{codelists:action.response,selectedCodelists:action.response.map(function(codelist){return codelist.id+"+"+codelist.agency+"+"+codelist.version;})});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* SYNC_CODELISTS_SYNC_CODELISTS_SUBMIT */]:return Object.assign({},state,{codelists:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (syncCodelisReducer);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_app_actions__ = __webpack_require__(109);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var categorySchemesAndDataflowsReducer=function categorySchemesAndDataflowsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{tree:null,categorisations:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_7__reducers_app_actions__["b" /* APP_LANGUAGE_SET */]:if(state.tree&&state.categorisations){var newTree=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(state.tree,"categories",function(node){if(node.urn&&node.categories&&node.categories.length){return Object.assign({},node,{categories:[].concat(_toConsumableArray(node.categories.filter(function(_ref){var type=_ref.type;return type!=="dataflow";})),_toConsumableArray(node.categories.filter(function(_ref2){var type=_ref2.type;return type==="dataflow";}).sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* categorisationsSorterFactory */])(Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations.categorisationsOrder,action.payload.language)(state.categorisations.find(function(_ref3){var source=_ref3.source,target=_ref3.target;return source===a.urn&&target===node.urn;}),state.categorisations.find(function(_ref4){var source=_ref4.source,target=_ref4.target;return source===b.urn&&target===node.urn;}));})))});}else{return node;}});return Object.assign({},state,{tree:newTree});}else{return state;}case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_LANGUAGE_CHANGE */]:return Object.assign({},state,{tree:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ */]:return Object.assign({},state,{tree:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ */]:var categorySchemes=(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */])||[]).map(function(artefact){var categoryScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);categoryScheme.categories=categoryScheme.categories?Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(categoryScheme.categories,"categories",function(node){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(node,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]);}):[];return Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])([categoryScheme],"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]]);return node;})[0];});var categorisations=(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["r" /* SDMX_JSON_CATEGORISATION_LIST_KEY */])||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);});var dataflows=(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["B" /* SDMX_JSON_DATAFLOW_LIST_KEY */])||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);});var isDataflowInCategory=function isDataflowInCategory(df,cat){if(cat)return df.categorisations.filter(function(_ref5){var urn=_ref5.urn;return urn===Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(cat);}).length>0;else return df.categorisations.length>0;};var tree=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["d" /* getCategorisedObjectsTree */])(dataflows.map(function(dataflow){return Object.assign({},dataflow,{categorisations:categorisations.filter(function(_ref6){var source=_ref6.source;return source===dataflow.urn;}).map(function(_ref7){var target=_ref7.target,autoAnnotations=_ref7.autoAnnotations;return{urn:target,order:autoAnnotations?autoAnnotations.find(function(_ref8){var type=_ref8.type;return type===Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations.categorisationsOrder;})||null:null};})});}),categorySchemes,'categories',function(a,b,cat){var aOrder=(a.categorisations.find(function(_ref9){var urn=_ref9.urn;return urn===Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(cat);})||{}).order;var bOrder=(b.categorisations.find(function(_ref10){var urn=_ref10.urn;return urn===Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(cat);})||{}).order;if(aOrder&&aOrder.text&&aOrder.text[action.lang]&&bOrder&&bOrder.text&&bOrder.text[action.lang]){return Number(aOrder.text[action.lang])-Number(bOrder.text[action.lang]);}else{return 0;}},isDataflowInCategory,'id','name',false);var root=[{isRoot:true,categories:tree}];tree=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(root,"categories",function(node){if(!node.isRoot&&node.id!==__WEBPACK_IMPORTED_MODULE_3__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]&&Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_3" /* getTypeFromArtefact */])(node)!=="categoryscheme"&&node.categories){node.categories=node.categories.map(function(cat){return Object.assign({},cat,{categoryUrn:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(node)});});}if(!node.isRoot&&node.id!==__WEBPACK_IMPORTED_MODULE_3__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]){node.urn=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(node);node.type=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_3" /* getTypeFromArtefact */])(node);}return node;})[0].categories;tree=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(tree,"categories",function(node){if(node.urn&&node.categories&&node.categories.length){return Object.assign({},node,{categories:[].concat(_toConsumableArray(node.categories.filter(function(_ref11){var type=_ref11.type;return type!=="dataflow";})),_toConsumableArray(node.categories.filter(function(_ref12){var type=_ref12.type;return type==="dataflow";}).sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* categorisationsSorterFactory */])(Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations.categorisationsOrder,action.lang)(categorisations.find(function(_ref13){var source=_ref13.source,target=_ref13.target;return source===a.urn&&target===node.urn;}),categorisations.find(function(_ref14){var source=_ref14.source,target=_ref14.target;return source===b.urn&&target===node.urn;}));})))});}else{return node;}});return Object.assign({},state,{tree:tree,categorisations:categorisations});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISE */]:return Object.assign({},state,{tree:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISATION_DELETE */]:return Object.assign({},state,{tree:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (categorySchemesAndDataflowsReducer);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artefact_export_form__ = __webpack_require__(51);
var msdsReducer=function msdsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{msds:null,isVisible:false,msdTriplet:null,msd:null,agencies:null,allAgencies:null,downloadMsdTriplets:null,downloadMsdLang:null,downloadMsdParams:null,parentsAndChildren:null,cloneDestTriplet:null,msdExportSourceTriplet:null,msdExportDestination:null,msdExportReport:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* MSDS_MSD_DETAIL_SHOW */]:return Object.assign({},state,{isVisible:true,msdTriplet:action.artefactTriplet});case __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* MSDS_MSD_DETAIL_CHANGE */]:var msd=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.msd);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{msd:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(msd,action.fields,customizer)});case __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* MSDS_MSD_DETAIL_HIDE */]:return Object.assign({},state,{isVisible:false,msd:null,msdTriplet:null,agencies:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["p" /* MSDS_MSD_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadMsdTriplets:action.artefactTriplets,downloadMsdLang:action.lang,downloadMsdParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_2__actions__["o" /* MSDS_MSD_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadMsdTriplets:null,downloadMsdLang:null,downloadMsdParams:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["n" /* MSDS_MSD_DOWNLOAD_CHANGE */]:var downloadMsdParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadMsdParams);return Object.assign({},state,{downloadMsdParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadMsdParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_2__actions__["v" /* MSDS_MSD_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* MSDS_MSD_CLONE_SHOW */]:var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),msdTriplet:state.msdTriplet?state.msdTriplet:action.srcTriplet});case __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* MSDS_MSD_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,msd:state.isVisible?state.msd:null,msdTriplet:state.isVisible?state.msdTriplet:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* MSDS_MSD_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_2__actions__["t" /* MSDS_MSD_EXPORT_SHOW */]:return Object.assign({},state,{msdExportSourceTriplet:action.sourceTriplet,msdExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,loginOption:__WEBPACK_IMPORTED_MODULE_7__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null}});case __WEBPACK_IMPORTED_MODULE_2__actions__["r" /* MSDS_MSD_EXPORT_HIDE */]:return Object.assign({},state,{msdExportSourceTriplet:null,msdExportDestination:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["q" /* MSDS_MSD_EXPORT_CHANGE */]:var msdExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.msdExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(msdExportDestination,action.fields);return Object.assign({},state,{msdExportDestination:msdExportDestination});case __WEBPACK_IMPORTED_MODULE_2__actions__["s" /* MSDS_MSD_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{msdExportReport:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* MSDS_LIST_MSDS_READ */]:return Object.assign({},state,{msds:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* MSDS_LIST_MSDS_READ */]:return Object.assign({},state,{msds:Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* MSDS_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response});case __WEBPACK_IMPORTED_MODULE_2__actions__["j" /* MSDS_MSD_DETAIL_READ */]:var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _msd=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response,__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["L" /* SDMX_JSON_MSD_LIST_KEY */])[0],Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,customNoneIsAutoAnnotation);return Object.assign({},state,{msd:Object.assign({},_msd,{customIsPresentational:Object(__WEBPACK_IMPORTED_MODULE_5__utils_referenceMetadata__["E" /* getCustomIsPresentationalFromAnnotations */])(_msd,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)})});case __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* MSDS_MSD_DETAIL_SUBMIT */]:return Object.assign({},state,{msd:null,msds:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* MSDS_MSD_DELETE */]:return Object.assign({},state,{msds:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["x" /* MSDS_SELECTED_MSDS_DELETE */]:return Object.assign({},state,{msds:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["m" /* MSDS_MSD_DOWNLOAD */]:return Object.assign({},state,{downloadMsdTriplets:null,downloadMsdLang:null,downloadMsdParams:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["w" /* MSDS_MSD_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});case __WEBPACK_IMPORTED_MODULE_2__actions__["u" /* MSDS_MSD_EXPORT_SUBMIT */]:return Object.assign({},state,{msdExportSourceTriplet:null,msdExportDestination:null,msdExportReport:action.response.itemsMessage,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* MSDS_MSD_CLONE_SUBMIT */]:return Object.assign({},state,{msds:null,cloneDestTriplet:null,msd:state.isVisible?state.msd:null,msdTriplet:state.isVisible?state.msdTriplet:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["x" /* MSDS_SELECTED_MSDS_DELETE */]:return Object.assign({},state,{msds:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (msdsReducer);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artefact_export_form__ = __webpack_require__(51);
var metadataflowsReducer=function metadataflowsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isDetailVisible:false,metadataflowTriplet:null,metadataflows:null,isMetadataflowValid:true,isAgenciesValid:true,isMetadataflowGeneralTabDirty:false,metadataflow:null,agencies:null,msds:null,isMsdsListVisible:false,isMsdDetailVisible:false,downloadMetadataflowParams:null,downloadMetadataflowTriplets:null,downloadMetadataflowLang:null,cloneDestTriplet:null,metadataflowAnnotations:null,metadataflowAnnotationTriplet:null,metadataflowExportSourceTriplet:null,metadataflowExportDestination:null,metadataflowExportReport:null,metadataflowOwnershipMetadataflowTripletStr:null,metadataflowOwnershipOwners:null,metadataflowOwnershipUsers:null,parentsAndChildren:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* METADATAFLOWS_METADATAFLOW_CREATE */]:return Object.assign({},state,{metadataflow:{id:null,agencyID:null,version:null,isFinal:false,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,msd:null,structure:null},isDetailVisible:true,isAgenciesValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* METADATAFLOWS_METADATAFLOW_OWNERSHIP_SHOW */]:{return Object.assign({},state,{metadataflowOwnershipMetadataflowTripletStr:action.metadataflowTripletStr});}case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* METADATAFLOWS_METADATAFLOW_OWNERSHIP_HIDE */]:return Object.assign({},state,{metadataflowOwnershipMetadataflowTripletStr:null,metadataflowOwnershipOwners:null,metadataflowOwnershipUsers:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_CHANGE */]:return Object.assign({},state,{metadataflowOwnershipOwners:action.owners});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* METADATAFLOWS_METADATAFLOW_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{metadataflowExportReport:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* METADATAFLOWS_METADATAFLOW_EDIT */]:return Object.assign({},state,{isDetailVisible:true,metadataflowTriplet:action.metadataflowTriplet,isMetadataflowValid:false,isAgenciesValid:false,isMetadataflowGeneralTabDirty:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* METADATAFLOWS_DETAIL_HIDE */]:return Object.assign({},state,{isDetailVisible:false,metadataflowTriplet:null,metadataflow:null,msds:null,isMsdsListVisible:false,isMsdDetailVisible:false,agencies:null,allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* METADATAFLOWS_DETAIL_METADATAFLOW_CHANGE */]:{var metadataflow=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.metadataflow);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{metadataflow:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(metadataflow,action.fields,customizer),isMetadataflowGeneralTabDirty:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* METADATAFLOWS_DETAIL_MSDS_SHOW */]:return Object.assign({},state,{isMsdsListVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* METADATAFLOWS_DETAIL_MSDS_HIDE */]:return Object.assign({},state,{isMsdsListVisible:false,msds:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* METADATAFLOWS_DETAIL_MSD_SET */]:return Object.assign({},state,{isMsdsListVisible:false,msds:null,metadataflow:Object.assign({},state.metadataflow,{msd:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.msdTriplet),structure:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(action.msdTriplet,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["M" /* SDMX_JSON_MSD_URN_NAMESPACE */])})});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* METADATAFLOWS_DETAIL_MSD_UNSET */]:return Object.assign({},state,{metadataflow:Object.assign({},state.metadataflow,{msd:null,structure:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* METADATAFLOWS_DETAIL_ANNOTATIONS_SHOW */]:return Object.assign({},state,{metadataflowAnnotations:action.annotations,metadataflowAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* METADATAFLOWS_DETAIL_ANNOTATIONS_HIDE */]:return Object.assign({},state,{metadataflowAnnotations:null,metadataflowAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* METADATAFLOWS_METADATAFLOW_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadMetadataflowTriplets:action.artefactTriplets,downloadMetadataflowLang:action.lang,downloadMetadataflowParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* METADATAFLOWS_METADATAFLOW_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadMetadataflowTriplets:null,downloadMetadataflowLang:null,downloadMetadataflowParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* METADATAFLOWS_METADATAFLOW_DOWNLOAD_CHANGE */]:var downloadMetadataflowParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadMetadataflowParams);return Object.assign({},state,{downloadMetadataflowParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadMetadataflowParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* METADATAFLOWS_METADATAFLOW_CLONE_SHOW */]:var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),metadataflowTriplet:state.metadataflowTriplet?state.metadataflowTriplet:action.srcTriplet,isMetadataflowValid:!!state.metadataflow,isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* METADATAFLOWS_METADATAFLOW_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,metadataflow:state.isDetailVisible?state.metadataflow:null,metadataflowTriplet:state.isDetailVisible?state.metadataflowTriplet:null,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* METADATAFLOWS_METADATAFLOW_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* METADATAFLOWS_METADATAFLOW_EXPORT_SHOW */]:return Object.assign({},state,{metadataflowExportSourceTriplet:action.sourceTriplet,metadataflowExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,loginOption:__WEBPACK_IMPORTED_MODULE_6__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null},isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* METADATAFLOWS_METADATAFLOW_EXPORT_HIDE */]:return Object.assign({},state,{metadataflowExportSourceTriplet:null,metadataflowExportDestination:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* METADATAFLOWS_METADATAFLOW_EXPORT_CHANGE */]:var metadataflowExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.metadataflowExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(metadataflowExportDestination,action.fields);return Object.assign({},state,{metadataflowExportDestination:metadataflowExportDestination});case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* METADATAFLOWS_DETAIL_METADATAFLOW_UPDATE_SUBMIT */]:return Object.assign({},state,{isMetadataflowGeneralTabDirty:false,agencies:null,allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* METADATAFLOWS_DETAIL_MSDS_READ */]:return Object.assign({},state,{msds:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_READ */]:return Object.assign({},state,{metadataflowOwnershipOwners:action.response.owners.map(function(_ref){var username=_ref.username;return username;})});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* METADATAFLOWS_METADATAFLOW_OWNERSHIP_USERS_READ */]:return Object.assign({},state,{metadataflowOwnershipUsers:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* METADATAFLOWS_METADATAFLOW_OWNERSHIP_OWNERS_SUBMIT */]:return Object.assign({},state,{metadataflowOwnershipMetadataflowTripletStr:null,metadataflowOwnershipOwners:null,metadataflowOwnershipUsers:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* METADATAFLOWS_LIST_METADATAFLOWS_READ */]:return Object.assign({},state,{metadataflows:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* METADATAFLOWS_DETAIL_METADATAFLOW_READ */]:var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_5__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _metadataflow=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["I" /* SDMX_JSON_METADATAFLOW_LIST_KEY */])[0],Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,customNoneIsAutoAnnotation);return Object.assign({},state,{metadataflow:Object.assign({},_metadataflow,{msd:_metadataflow.structure?Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(_metadataflow.structure)):null}),isMetadataflowValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* METADATAFLOWS_DETAIL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response,isAgenciesValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* METADATAFLOWS_METADATAFLOW_DELETE */]:return Object.assign({},state,{metadataflowTriplet:null,metadataflow:null,metadataflows:null,isDetailVisible:false,agencies:null,allAgencies:null,msds:null,isMsdsListVisible:false,isMsdDetailVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* METADATAFLOWS_DETAIL_METADATAFLOW_CREATE_SUBMIT */]:return Object.assign({},state,{metadataflowTriplet:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(state.metadataflow)),metadataflow:null,isMetadataflowValid:false,metadataflows:null,msds:null,isMsdsListVisible:false,isMsdDetailVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* METADATAFLOWS_DETAIL_METADATAFLOW_UPDATE_SUBMIT */]:return Object.assign({},state,{metadataflows:null,isMetadataflowValid:false,msds:null,isMsdsListVisible:false,isMsdDetailVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* METADATAFLOWS_DETAIL_MSDS_READ */]:return Object.assign({},state,{msds:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* METADATAFLOWS_SELECTED_METADATAFLOWS_DELETE */]:return Object.assign({},state,{metadataflow:null,metadataflows:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* METADATAFLOWS_METADATAFLOW_DOWNLOAD */]:return Object.assign({},state,{downloadMetadataflowTriplets:null,downloadMetadataflowLang:null,downloadMetadataflowParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* METADATAFLOWS_METADATAFLOW_CLONE_SUBMIT */]:return Object.assign({},state,{metadataflows:null,cloneDestTriplet:null,metadataflow:state.isDetailVisible?state.metadataflow:null,metadataflowTriplet:state.isDetailVisible?state.metadataflowTriplet:null,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* METADATAFLOWS_METADATAFLOW_EXPORT_SUBMIT */]:return Object.assign({},state,{metadataflowExportSourceTriplet:null,metadataflowExportDestination:null,metadataflowExportReport:action.response.itemsMessage,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* METADATAFLOWS_METADATAFLOW_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* METADATAFLOWS_DETAIL_METADATAFLOW_READ */]:return Object.assign({},state,{isDetailVisible:false,isMetadataflowValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* METADATAFLOWS_SELECTED_METADATAFLOWS_DELETE */]:return Object.assign({},state,{metadataflows:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (metadataflowsReducer);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
var userManagementReducer=function userManagementReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{users:null,user:null,isSynchronized:false,editPassword:false,isLoginValid:true};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* USER_MANAGEMENT_USER_EDIT */]:return Object.assign({},state,{user:{username:action.username,email:action.email,password:null,confirmPassword:null,isExternal:action.isExternal}});case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* USER_MANAGEMENT_USER_HIDE */]:return Object.assign({},state,{user:null,editPassword:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* USER_MANAGEMENT_USER_CHANGE */]:return Object.assign({},state,{user:action.fields.editPassword===undefined?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.user),action.fields):state.user,editPassword:action.fields.editPassword!==undefined?action.fields.editPassword:state.editPassword});case __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* USER_MANAGEMENT_SYNCHRONIZE */]:return Object.assign({},state,{isSynchronized:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* USER_MANAGEMENT_USER_READ */]:return Object.assign({},state,{user:{username:action.response.username,email:action.response.email,password:null,confirmPassword:null,isExternal:action.response.isExternal}});case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* USER_MANAGEMENT_USER_CREATE */]:case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* USER_MANAGEMENT_USER_DELETE */]:return Object.assign({},state,{users:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* USER_MANAGEMENT_SUBMIT */]:return Object.assign({},state,{users:null,user:null,editPassword:false,isLoginValid:action.isLoginValid});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* USER_MANAGEMENT_USERS_READ */]:return Object.assign({},state,{users:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (userManagementReducer);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_normalizers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_artefact_export_form__ = __webpack_require__(51);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var AGENCY_SCHEME_ID="AGENCIES";var AGENCY_SCHEME_VERSION="1.0";var agencySchemesReducer=function agencySchemesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isDetailVisible:false,agencySchemeTriplet:null,agencySchemes:null,isAgencySchemeValid:true,isAgenciesValid:true,isAgencySchemeGeneralTabDirty:false,agencyScheme:null,item:null,selectedItem:null,isItemEditMode:false,agencies:null,allAgencies:null,itemsViewMode:null,isItemsImportFormVisible:false,itemsImportForm:null,itemAnnotations:null,itemLayoutAnnotations:null,agencySchemeAnnotations:null,agencySchemeAnnotationTriplet:null,itemsTree:null,maxOrder:null,isNormalizeNeeded:false,isDuplicateItemErrorVisible:false,focusItemsTab:false,cutItem:null,downloadAgencySchemeParams:null,downloadAgencySchemeTriplets:null,downloadAgencySchemeLang:null,cloneDestTriplet:null,agencySchemeExportSourceTriplet:null,agencySchemeExportDestination:null,agencySchemeExportReport:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* AGENCY_SCHEMES_AGENCY_SCHEME_CREATE */]:return Object.assign({},state,{agencyScheme:{id:AGENCY_SCHEME_ID,agencyID:null,version:AGENCY_SCHEME_VERSION,isFinal:false,uri:null,urn:null,validTo:null,validFrom:null,name:null,description:null,agencies:null},isDetailVisible:true,itemsViewMode:action.defaultItemsViewMode,isAgenciesValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* AGENCY_SCHEMES_AGENCY_SCHEME_EDIT */]:return Object.assign({},state,{isDetailVisible:true,agencySchemeTriplet:action.agencySchemeTriplet,isAgencySchemeValid:false,isAgenciesValid:false,isAgencySchemeGeneralTabDirty:false,focusItemsTab:false,itemsViewMode:action.defaultItemsViewMode});case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* AGENCY_SCHEMES_DETAIL_HIDE */]:return Object.assign({},state,{isDetailVisible:false,agencySchemeTriplet:null,agencyScheme:null,item:null,selectedItem:null,itemsViewMode:null,itemsTree:null,maxOrder:null,focusItemsTab:false,cutItem:null,agencies:null,allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CHANGE */]:{var agencyScheme=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.agencyScheme);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{agencyScheme:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(agencyScheme,action.fields,customizer),isAgencySchemeGeneralTabDirty:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["U" /* AGENCY_SCHEMES_DETAIL_ITEMS_VIEW_MODE_CHANGE */]:return Object.assign({},state,{itemsViewMode:action.viewMode,selectedItem:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["K" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CREATE */]:{var maxOrder=state.maxOrder+1;var isNormalizeNeeded=Number(action.order)!==maxOrder;return Object.assign({},state,{item:{id:null,parent:action.parentId?action.parentId:null,order:_defineProperty({},action.lang,action.order),name:null,annotations:null,autoAnnotations:[{type:action.itemsOrderAnnotationType,text:_defineProperty({},action.lang,action.order)}],description:null,agencies:[]},isItemEditMode:false,maxOrder:maxOrder,isNormalizeNeeded:isNormalizeNeeded});}case __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_EDIT */]:var node=null;if(action.item){node=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"agencies",function(node){return node.id===action.item.id;});}return Object.assign({},state,{item:{id:action.item?action.item.id:null,parent:action.item?action.item.parent:null,order:node?node.order:null,name:node?node.name:null,annotations:action.item?action.item.annotations:null,autoAnnotations:action.item?action.item.autoAnnotations:null,description:node?node.description:null,agencies:node?node.agencies:[]},isItemEditMode:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["M" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_CHANGE */]:{var item=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.item);var _isNormalizeNeeded=state.isNormalizeNeeded;if(action.fields.order){item.autoAnnotations.find(function(annotation){return annotation.type===action.itemsOrderAnnotationType;}).text=action.fields.order;_isNormalizeNeeded=state.item.order[action.lang]!==action.fields.order[action.lang];}var _customizer=function _customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{item:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(item,action.fields,_customizer),isNormalizeNeeded:_isNormalizeNeeded});}case __WEBPACK_IMPORTED_MODULE_1__actions__["O" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DETAIL_HIDE */]:return Object.assign({},state,{item:null,isItemEditMode:false,isDuplicateItemErrorVisible:false,maxOrder:state.maxOrder-1});case __WEBPACK_IMPORTED_MODULE_1__actions__["T" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_SELECT */]:{var selectedItem=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"agencies",function(node){return node.id===action.id;});return Object.assign({},state,{selectedItem:action.id?selectedItem:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["H" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_SHOW */]:return Object.assign({},state,{isItemsImportFormVisible:true,itemsImportForm:{file:null,language:null,separator:";",delimiter:null,hasHeader:true,hasDescriptionCol:true,hasParentCol:true,hasOrderCol:true,hasLayoutAnnotationFullNameCol:false,hasLayoutAnnotationIsDefaultCol:false,csvRows:null,filePath:null,allCsvRows:null,isAllCsvRowsVisible:false}});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_SHOW */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{isAllCsvRowsVisible:true})});case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_HIDE */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{isAllCsvRowsVisible:false})});case __WEBPACK_IMPORTED_MODULE_1__actions__["G" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_HIDE */]:return Object.assign({},state,{isItemsImportFormVisible:false,itemsImportForm:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CHANGE */]:return Object.assign({},state,{itemsImportForm:Object.assign({},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(state.itemsImportForm,action.fields),{hash:action.fields.language?state.itemsImportForm.hash:null,csvRows:action.fields.language?state.itemsImportForm.csvRows:null,filePath:action.fields.language?state.itemsImportForm.filePath:null,allCsvRows:action.fields.language?state.itemsImportForm.allCsvRows:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_SHOW */]:return Object.assign({},state,{itemAnnotations:action.annotations});case __WEBPACK_IMPORTED_MODULE_1__actions__["I" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_ANNOTATIONS_HIDE */]:return Object.assign({},state,{itemAnnotations:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["S" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_SHOW */]:return Object.assign({},state,{itemLayoutAnnotations:action.annotations});case __WEBPACK_IMPORTED_MODULE_1__actions__["R" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_LAYOUT_ANNOTATIONS_HIDE */]:return Object.assign({},state,{itemLayoutAnnotations:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* AGENCY_SCHEMES_DETAIL_ANNOTATIONS_SHOW */]:return Object.assign({},state,{agencySchemeAnnotations:action.annotations,agencySchemeAnnotationTriplet:action.triplet});case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* AGENCY_SCHEMES_DETAIL_ANNOTATIONS_HIDE */]:return Object.assign({},state,{agencySchemeAnnotations:null,agencySchemeAnnotationTriplet:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_LANGUAGE_CHANGE */]:{var root=[{isRoot:true,agencies:state.itemsTree}];var itemsTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["h" /* getMappedTree */])(root,"agencies",function(node){node.agencies=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.agencies,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].agencies;var count=Object(__WEBPACK_IMPORTED_MODULE_6__utils_normalizers__["b" /* normalizeItemsOrder */])(itemsTree,"agencies",action.lang,action.itemsOrderAnnotationType);return Object.assign({},state,{itemsTree:itemsTree,maxOrder:count});}case __WEBPACK_IMPORTED_MODULE_1__actions__["Q" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_SHOW */]:return Object.assign({},state,{isDuplicateItemErrorVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["P" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_DUPLICATE_ITEM_ERROR_HIDE */]:return Object.assign({},state,{isDuplicateItemErrorVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* AGENCY_SCHEMES_DETAIL_ITEMS_ITEM_CUT */]:var parentNode=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["k" /* getNode */])(state.itemsTree,"agencies",function(node){return node.id===action.item.parent;});parentNode?parentNode.agencies=parentNode.agencies.filter(function(child){return child.id!==action.item.id;}):state.itemsTree=state.itemsTree.filter(function(child){return child.id!==action.item.id;});return Object.assign({},state,{cutItem:action.item,itemsTree:state.itemsTree.splice(0)});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadAgencySchemeTriplets:action.artefactTriplets,downloadAgencySchemeLang:action.lang,downloadAgencySchemeParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadAgencySchemeTriplets:null,downloadAgencySchemeLang:null,downloadAgencySchemeParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD_CHANGE */]:var downloadAgencySchemeParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadAgencySchemeParams);return Object.assign({},state,{downloadAgencySchemeParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadAgencySchemeParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SHOW */]:return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{agencyID:null}),agencySchemeTriplet:state.agencySchemeTriplet?state.agencySchemeTriplet:action.srcTriplet,isAgencySchemeValid:!!state.agencyScheme,isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,agencyScheme:state.isDetailVisible?state.agencyScheme:null,agencySchemeTriplet:state.isDetailVisible?state.agencySchemeTriplet:null,itemsTree:state.isDetailVisible?state.itemsTree:null,maxOrder:state.isDetailVisible?state.maxOrder:null,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SHOW */]:return Object.assign({},state,{agencySchemeExportSourceTriplet:action.sourceTriplet,agencySchemeExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,loginOption:__WEBPACK_IMPORTED_MODULE_9__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null},isAgenciesValid:!!state.allAgencies});case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_HIDE */]:return Object.assign({},state,{agencySchemeExportSourceTriplet:null,agencySchemeExportDestination:null,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_CHANGE */]:var agencySchemeExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.agencySchemeExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(agencySchemeExportDestination,action.fields);return Object.assign({},state,{agencySchemeExportDestination:agencySchemeExportDestination});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{agencySchemeExportReport:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_UPDATE_SUBMIT */]:return Object.assign({},state,{isAgencySchemeGeneralTabDirty:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* AGENCY_SCHEMES_LIST_AGENCY_SCHEMES_READ */]:return Object.assign({},state,{agencySchemes:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_READ */]:var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_8__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _agencyScheme=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["p" /* SDMX_JSON_AGENCY_SCHEME_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,undefined,customNoneIsAutoAnnotation)(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var _itemsTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["n" /* getTreeFromArray */])(_agencyScheme.agencies||[],"agencies");var _root=[{isRoot:true,agencies:_itemsTree}];_itemsTree=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["h" /* getMappedTree */])(_root,"agencies",function(node){node.agencies=Object(__WEBPACK_IMPORTED_MODULE_5__utils_artefacts__["f" /* getOrderedChildren */])(node.agencies,node.id,action.lang,action.itemsOrderAnnotationType);return node;})[0].agencies;var _count=Object(__WEBPACK_IMPORTED_MODULE_6__utils_normalizers__["b" /* normalizeItemsOrder */])(_itemsTree,"agencies",action.lang,action.itemsOrderAnnotationType);return Object.assign({},state,{agencyScheme:_agencyScheme,isAgencySchemeValid:true,itemsTree:_itemsTree,maxOrder:_count});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* AGENCY_SCHEMES_DETAIL_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response,isAgenciesValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_CREATE_SUBMIT */]:return Object.assign({},state,{agencyScheme:null,agencySchemes:null,isDetailVisible:true,itemsTree:null,maxOrder:null,agencySchemeTriplet:action.agencySchemeTriplet,isAgencySchemeValid:false,isAgencySchemeGeneralTabDirty:false,focusItemsTab:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* AGENCY_SCHEMES_AGENCY_SCHEME_DELETE */]:return Object.assign({},state,{agencyScheme:null,agencySchemes:null,isDetailVisible:false,itemsTree:null,maxOrder:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_UPDATE_SUBMIT */]:return Object.assign({},state,{agencySchemes:null,item:null,selectedItem:null,itemsTree:action.itemsTree,isNormalizeNeeded:false,cutItem:null,agencies:null,allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_UPLOAD */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{csvRows:action.response.importedItemCsv,hash:action.response.hashImport,allCsvRows:null,filePath:null})});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_FILE_IMPORT */]:return Object.assign({},state,{itemsImportForm:null,isItemsImportFormVisible:false,isAgencySchemeValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["W" /* AGENCY_SCHEMES_SELECTED_AGENCY_SCHEMES_DELETE */]:return Object.assign({},state,{agencyScheme:null,agencySchemes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD */]:return Object.assign({},state,{downloadAgencySchemeTriplets:null,downloadAgencySchemeLang:null,downloadAgencySchemeParams:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* AGENCY_SCHEMES_AGENCY_SCHEME_CLONE_SUBMIT */]:return Object.assign({},state,{agencySchemes:null,cloneDestTriplet:null,agencyScheme:state.isDetailVisible?state.agencyScheme:null,agencySchemeTriplet:state.isDetailVisible?state.agencySchemeTriplet:null,itemsTree:state.isDetailVisible?state.itemsTree:null,maxOrder:state.isDetailVisible?state.maxOrder:null,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* AGENCY_SCHEMES_AGENCY_SCHEME_EXPORT_SUBMIT */]:return Object.assign({},state,{agencySchemeExportSourceTriplet:null,agencySchemeExportDestination:null,agencySchemeExportReport:action.response.itemsMessage,agencies:state.isDetailVisible?state.agencies:null,allAgencies:state.isDetailVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_CSV_UPLOAD */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{filePath:action.response})});case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* AGENCY_SCHEMES_DETAIL_ITEMS_IMPORT_FORM_ALL_CSV_ROWS_READ */]:return Object.assign({},state,{itemsImportForm:Object.assign({},state.itemsImportForm,{allCsvRows:action.response})});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_READ */]:return Object.assign({},state,{isDetailVisible:false,isAgencySchemeValid:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* AGENCY_SCHEMES_DETAIL_AGENCY_SCHEME_UPDATE_SUBMIT */]:return Object.assign({},state,{agencyScheme:null,isAgencySchemeValid:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["W" /* AGENCY_SCHEMES_SELECTED_AGENCY_SCHEMES_DELETE */]:return Object.assign({},state,{agencySchemes:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (agencySchemesReducer);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons_constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
var metadataSetReducer=function metadataSetReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{categorySchemes:null,categoryId:null,categoryUrn:null,metadataSets:null,metadataSetTree:null,metadataSetId:null,metadataSetCategory:null,msdTriplet:null,metadataSet:null,metadataflows:null,isMetadataflowsVisible:false,msd:null,msdTree:null,report:null,isReportVisible:false,reportStructure:null,selectedAttribute:null,step:null,isCodesVisible:false,codes:null,reportId:null,target:null,identifiableTargets:null,selectedIdentifiableTarget:null,artefacts:null,isFetchMetadataSetDisabled:true,reportHtmlPageUrl:null,conceptSchemeTriplets:null,conceptSchemes:null,isCloneVisible:false,cloneId:null,metadataSetHtmlPageUrl:null,reportAnnotations:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* METADATA_SET_CATEGORY_SELECT */]:return Object.assign({},state,{categoryId:action.categoryId,categoryUrn:action.categoryUrn,metadataSet:null,conceptSchemeTriplets:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["t" /* METADATA_SET_METADATA_SET_SELECT */]:return Object.assign({},state,{metadataSetId:action.metadataSet?action.metadataSet.id:null,metadataSetCategory:action.metadataSet?action.metadataSet.categoryUrn:null,msdTriplet:action.msdTriplet,metadataSet:action.metadataSetId!==state.metadataSetId?null:state.metadataSet,isFetchMetadataSetDisabled:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["o" /* METADATA_SET_METADATA_SET_CREATE */]:return Object.assign({},state,{metadataSet:{id:null,name:null,metadataflowTriplet:null,msdUrn:null,reportingBegin:null,reportingEnd:null,validFrom:null,validTo:null,publicationYear:null,publicationPeriod:null}});case __WEBPACK_IMPORTED_MODULE_0__actions__["j" /* METADATA_SET_METADATA_SET_CHANGE */]:{var metadataSet=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.metadataSet);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{metadataSet:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mergeWith(metadataSet,action.fields,customizer)});}case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* METADATA_SET_METADATAFLOWS_SHOW */]:return Object.assign({},state,{isMetadataflowsVisible:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* METADATA_SET_METADATAFLOWS_HIDE */]:return Object.assign({},state,{isMetadataflowsVisible:false,metadataflows:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* METADATA_SET_METADATAFLOW_SET */]:return Object.assign({},state,{isMetadataflowsVisible:false,metadataflows:null,metadataSet:Object.assign({},state.metadataSet,{msdUrn:action.msdUrn,metadataflowTriplet:action.triplet})});case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* METADATA_SET_METADATAFLOW_UNSET */]:return Object.assign({},state,{metadataSet:Object.assign({},state.metadataSet,{metadataflowTriplet:null,msdUrn:null})});case __WEBPACK_IMPORTED_MODULE_0__actions__["G" /* METADATA_SET_REPORT_CREATE */]:{return Object.assign({},state,{isReportVisible:true,step:__WEBPACK_IMPORTED_MODULE_9__commons_constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */]});}case __WEBPACK_IMPORTED_MODULE_0__actions__["J" /* METADATA_SET_REPORT_HIDE */]:return Object.assign({},state,{report:null,isReportVisible:false,reportStructure:null,selectedAttribute:null,step:null,reportId:null,target:null,identifiableTargets:null,reportAnnotations:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["L" /* METADATA_SET_REPORT_HTML_PAGE_SHOW */]:return Object.assign({},state,{reportHtmlPageUrl:action.htmlPageUrl});case __WEBPACK_IMPORTED_MODULE_0__actions__["K" /* METADATA_SET_REPORT_HTML_PAGE_HIDE */]:return Object.assign({},state,{reportHtmlPageUrl:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["O" /* METADATA_SET_REPORT_STEP_SET */]:{var _reportStructure=action.step===__WEBPACK_IMPORTED_MODULE_9__commons_constants__["c" /* REPORT_DETAILS_WIZARD_STEP_SECOND */]&&state.reportStructure===null?Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["Q" /* getReportStructureFromSdmxJsonReport */])(state.msdTree,state.target,state.report,action.dataLanguages,action.t,Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action)):state.reportStructure;return Object.assign({},state,{step:action.step,reportStructure:_reportStructure,selectedAttribute:null});}case __WEBPACK_IMPORTED_MODULE_0__actions__["F" /* METADATA_SET_REPORT_ATTRIBUTE_SELECT */]:{var _reportStructure2=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.reportStructure);var selectedAttribute=action.selectedAttributeKey?Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(_reportStructure2,"metadataAttributes",function(node){return node.nodeKey===action.selectedAttributeKey;}):null;return Object.assign({},state,{selectedAttribute:selectedAttribute});}case __WEBPACK_IMPORTED_MODULE_0__actions__["x" /* METADATA_SET_REPORT_ATTRIBUTE_CHANGE */]:{var _reportStructure3=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.reportStructure);var _selectedAttribute=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(_reportStructure3,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});var _customizer=function _customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};_selectedAttribute=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mergeWith(_selectedAttribute,action.fields,_customizer);return Object.assign({},state,{reportStructure:_reportStructure3,selectedAttribute:_selectedAttribute});}case __WEBPACK_IMPORTED_MODULE_0__actions__["D" /* METADATA_SET_REPORT_ATTRIBUTE_CREATE */]:{var _reportStructure4=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.reportStructure);var selectedFolder=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(_reportStructure4,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});var node=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(state.msdTree,"metadataAttributes",function(node){return node.id===__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["v" /* EMPTY_REPORT_ATTRIBUTE_KEY */]+state.selectedAttribute.id;}));node=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])([node],"metadataAttributes",function(node){return Object.assign({},node,{nodeKey:__WEBPACK_IMPORTED_MODULE_5_uuid___default()()});})[0];selectedFolder.metadataAttributes.push(Object.assign({},node,{isFolder:null,id:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["O" /* getNextAttributeIndexAvailable */])(selectedFolder.metadataAttributes)+". "+selectedFolder.id,name:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["O" /* getNextAttributeIndexAvailable */])(selectedFolder.metadataAttributes)+". "+selectedFolder.name,nodeKey:__WEBPACK_IMPORTED_MODULE_5_uuid___default()(),texts:null}));return Object.assign({},state,{reportStructure:Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["f" /* getFilteredTree */])(_reportStructure4,"metadataAttributes",function(node){return!node.id.includes(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["v" /* EMPTY_REPORT_ATTRIBUTE_KEY */]);}),selectedAttribute:selectedFolder});}case __WEBPACK_IMPORTED_MODULE_0__actions__["E" /* METADATA_SET_REPORT_ATTRIBUTE_DELETE */]:var reportStructure=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.reportStructure);var parentAttribute=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(reportStructure,"metadataAttributes",function(node){return node.metadataAttributes.find(function(child){return child.nodeKey===state.selectedAttribute.nodeKey;});});parentAttribute.metadataAttributes=parentAttribute.metadataAttributes.filter(function(child){return child.nodeKey!==state.selectedAttribute.nodeKey;});return Object.assign({},state,{reportStructure:reportStructure,selectedAttribute:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["A" /* METADATA_SET_REPORT_ATTRIBUTE_CODES_SHOW */]:return Object.assign({},state,{isCodesVisible:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["y" /* METADATA_SET_REPORT_ATTRIBUTE_CODES_HIDE */]:return Object.assign({},state,{isCodesVisible:false,codes:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["B" /* METADATA_SET_REPORT_ATTRIBUTE_CODE_SET */]:{var _reportStructure5=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.reportStructure);var selectedCode=state.codes.find(function(code){return code.id===action.codeId;});var _selectedAttribute2=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(_reportStructure5,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});_selectedAttribute2.texts=selectedCode.name;return Object.assign({},state,{isCodesVisible:false,codes:null,reportStructure:_reportStructure5,selectedAttribute:_selectedAttribute2});}case __WEBPACK_IMPORTED_MODULE_0__actions__["C" /* METADATA_SET_REPORT_ATTRIBUTE_CODE_UNSET */]:{var _reportStructure6=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.reportStructure);var _selectedAttribute3=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(_reportStructure6,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});_selectedAttribute3.texts=null;return Object.assign({},state,{reportStructure:_reportStructure6,selectedAttribute:_selectedAttribute3});}case __WEBPACK_IMPORTED_MODULE_0__actions__["M" /* METADATA_SET_REPORT_ID_CHANGE */]:{var newVal=action.id;var oldVal=state.id;return Object.assign({},state,{reportId:newVal?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toUpper(/^[a-zA-Z0-9_]*$/.test(newVal)?newVal:oldVal):newVal});}case __WEBPACK_IMPORTED_MODULE_0__actions__["V" /* METADATA_SET_REPORT_TARGET_SELECT */]:{var msdTree=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.msdTree);return Object.assign({},state,{target:action.target,identifiableTargets:msdTree.find(function(msd){return msd.target===action.target;}).identifiableTargets,reportStructure:null,selectedAttribute:null});}case __WEBPACK_IMPORTED_MODULE_0__actions__["S" /* METADATA_SET_REPORT_TARGET_ARTEFACTS_SHOW */]:return Object.assign({},state,{selectedIdentifiableTarget:action.identifiableTarget});case __WEBPACK_IMPORTED_MODULE_0__actions__["Q" /* METADATA_SET_REPORT_TARGET_ARTEFACTS_HIDE */]:return Object.assign({},state,{selectedIdentifiableTarget:null,artefacts:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["T" /* METADATA_SET_REPORT_TARGET_ARTEFACT_SET */]:{var identifiableTargets=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.identifiableTargets);var identifiableTargetId=action.identifiableTargetId?action.identifiableTargetId:state.selectedIdentifiableTarget.id;var identifiableTarget=identifiableTargets.find(function(_ref){var id=_ref.id;return id===identifiableTargetId;});if(state.selectedIdentifiableTarget){var urnNamespace=__WEBPACK_IMPORTED_MODULE_9__commons_constants__["a" /* ARTEFACT_TYPES */].find(function(_ref2){var type=_ref2.type;return type===state.selectedIdentifiableTarget.objectType.toLowerCase();}).urnNamespace;identifiableTarget.value=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(action.value,urnNamespace);}else{identifiableTarget.value=action.value;}return Object.assign({},state,{selectedIdentifiableTarget:null,identifiableTargets:identifiableTargets,artefacts:null});}case __WEBPACK_IMPORTED_MODULE_0__actions__["U" /* METADATA_SET_REPORT_TARGET_ARTEFACT_UNSET */]:{var _identifiableTargets=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.identifiableTargets);_identifiableTargets.find(function(value){return value.id===action.identifiableTarget.id;}).value=null;return Object.assign({},state,{identifiableTargets:_identifiableTargets});}case __WEBPACK_IMPORTED_MODULE_0__actions__["m" /* METADATA_SET_METADATA_SET_CLONE_SHOW */]:return Object.assign({},state,{isCloneVisible:true});case __WEBPACK_IMPORTED_MODULE_0__actions__["l" /* METADATA_SET_METADATA_SET_CLONE_HIDE */]:return Object.assign({},state,{isCloneVisible:false,cloneId:null});case __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* METADATA_SET_METADATA_SET_CLONE_CHANGE */]:return Object.assign({},state,{cloneId:action.fields.cloneId});case __WEBPACK_IMPORTED_MODULE_0__actions__["r" /* METADATA_SET_METADATA_SET_HTML_PAGE_SHOW */]:return Object.assign({},state,{metadataSetHtmlPageUrl:action.htmlPageUrl});case __WEBPACK_IMPORTED_MODULE_0__actions__["q" /* METADATA_SET_METADATA_SET_HTML_PAGE_HIDE */]:return Object.assign({},state,{metadataSetHtmlPageUrl:null});case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* METADATA_SET_CATEGORIZED_METADATA_SETS_READ */]:{// gets metadataset list from server response
var metadataSets=(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1])||[]).map(function(ms){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(ms,null,__WEBPACK_IMPORTED_MODULE_9__commons_constants__["d" /* customIsReferenceMetadataAutoAnnotation */]);}).filter(function(_ref3){var msdUrn=_ref3.msdUrn;return msdUrn!==Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).dcatapit.msd;}).map(function(metadataSet){return Object.assign({},metadataSet,{type:"metadataSet",categorisations:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["D" /* getCategorisationsFromAnnotations */])(metadataSet),metadataflowTriplet:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(metadataSet)});});// gets ordered categoryScheme tree from server response
var categorySchemes=(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0],__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["s" /* SDMX_JSON_CATEGORY_SCHEME_LIST_KEY */])||[]).map(function(artefact){var categoryScheme=Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations),{categories:artefact.categories||[],type:"categoryScheme",urn:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(artefact)});categoryScheme.categories=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(categoryScheme.categories,"categories",function(category){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["S" /* getItemFromSdmxJsonStructure */])(category,Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]),{type:"category",urn:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(category)});});return Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])([categoryScheme],"categories",function(node){node.categories=Object(__WEBPACK_IMPORTED_MODULE_8__utils_artefacts__["f" /* getOrderedChildren */])(node.categories,node.id,action.lang,Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations[__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["a" /* CATEGORY_SCHEME_ORDER_ANNOTATION_KEY */]]);return node;})[0];});// utility to test if a metadataSet belongs to a specific category
var checkIfMetadataSetBelongsToCategory=function checkIfMetadataSetBelongsToCategory(metadataSet,category){if(category){return category.type==="category"?metadataSet.categorisations.find(function(categorisation){return categorisation.target===category.urn;}):false;}else{return metadataSet.categorisations.length>0;}};// building category tree with metadataSet
var metadataSetTree=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["d" /* getCategorisedObjectsTree */])(metadataSets,categorySchemes,'categories',function(a,b){return a.id-b.id;},checkIfMetadataSetBelongsToCategory,'id','name',false,true);// iterates on tree adding "categoryUrn" and "parent" to all node in the tree
metadataSetTree=metadataSetTree.map(function(metadataSet){metadataSet.categories=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(metadataSet.categories,"categories",function(node){if(node.urn&&node.categories){node.categories=node.categories.map(function(child){return Object.assign({},child,{categoryUrn:node.urn,parent:node.id});});}return node;});return metadataSet;});// iterates on tree adding unique key to all node in the tree
metadataSetTree=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(metadataSetTree,"categories",function(node){return Object.assign({},node,{nodeKey:node.type!=="metadataSet"?node.urn+"+"+node.id:"cat_"+node.categoryUrn+"+"+node.id});});return Object.assign({},state,{metadataSets:metadataSets,categorySchemes:categorySchemes,metadataSetTree:metadataSetTree});}case __WEBPACK_IMPORTED_MODULE_0__actions__["s" /* METADATA_SET_METADATA_SET_READ */]:{var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _metadataSet=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[0])[0],null,customNoneIsAutoAnnotation||__WEBPACK_IMPORTED_MODULE_9__commons_constants__["d" /* customIsReferenceMetadataAutoAnnotation */]);var metadataSetNode=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(state.metadataSetTree,"categories",function(node){return node.type==="metadataSet"&&node.id===state.metadataSetId&&(!node.categoryUrn||node.categoryUrn===state.metadataSetCategory);});var msd=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response[1])[0]);var conceptSchemeTriplets=[];msd.metadataStructureComponents.reportStructureList.reportStructures.map(function(tree){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["h" /* getMappedTree */])(tree.metadataAttributeList.metadataAttributes,"metadataAttributes",function(node){if(!conceptSchemeTriplets.find(function(triplet){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(triplet)===Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(node.conceptIdentity));})){conceptSchemeTriplets.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(node.conceptIdentity));}return node;});});var reportAnnotations=null;if(state.isReportVisible){var report=(_metadataSet.reports||[]).find(function(_ref4){var id=_ref4.id;return id===state.id;});reportAnnotations=report?report.annotations:null;}return Object.assign({},state,{metadataSet:Object.assign({},_metadataSet,{metadataflowTriplet:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(_metadataSet),reports:(_metadataSet.reports||[]).map(function(report){return Object.assign({},report,{isPublished:(report.annotations.find(function(_ref5){var id=_ref5.id;return(id||"").toLowerCase()===__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["z" /* REPORT_STATE_NAME_ANNOTATION_ID */].toLowerCase();})||{}).text});}),categoryUrn:metadataSetNode.categoryUrn,type:metadataSetNode.type}),msd:msd,isFetchMetadataSetDisabled:true,conceptSchemeTriplets:conceptSchemeTriplets,reportAnnotations:reportAnnotations});}case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* METADATA_SET_METADATAFLOWS_READ */]:var metadataflows=(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact);}).filter(function(_ref6){var id=_ref6.id,agencyID=_ref6.agencyID,version=_ref6.version;return action.ownedMetadataflows.includes(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agencyID,version:version}));}).filter(function(_ref7){var structure=_ref7.structure;return structure!==Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).dcatapit.msd;});return Object.assign({},state,{metadataflows:metadataflows});case __WEBPACK_IMPORTED_MODULE_0__actions__["u" /* METADATA_SET_METADATA_SET_SUBMIT */]:return Object.assign({},state,{categorySchemes:null,categoryId:null,categoryUrn:null,metadataSets:null,metadataSetTree:null,metadataSet:null,conceptSchemeTriplets:null,isFetchMetadataSetDisabled:false,metadataSetId:action.metadataSetId,metadataSetCategory:action.metadataSetCategory,msdTriplet:action.msdTriplet});case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* METADATA_SET_METADATA_SET_CATEGORISE */]:return Object.assign({},state,{categorySchemes:null,categoryId:null,categoryUrn:null,metadataSets:null,metadataSetTree:null,metadataSet:null,conceptSchemeTriplets:null,isFetchMetadataSetDisabled:!!action.metadataSetId,metadataSetId:action.metadataSetId,metadataSetCategory:action.metadataSetCategory,msdTriplet:action.msdTriplet});case __WEBPACK_IMPORTED_MODULE_0__actions__["p" /* METADATA_SET_METADATA_SET_DELETE */]:return Object.assign({},state,{categorySchemes:null,categoryId:null,categoryUrn:null,metadataSets:null,metadataSetTree:null,metadataSetId:state.metadataSetId===action.metadataSetId?null:state.metadataSetId,metadataSetCategory:state.metadataSetId===action.metadataSetId?null:state.metadataSetCategory,msdTriplet:state.metadataSetId===action.metadataSetId?null:state.msdTriplet,metadataSet:null,conceptSchemeTriplets:null,isFetchMetadataSetDisabled:state.metadataSetId===action.metadataSetId});case __WEBPACK_IMPORTED_MODULE_0__actions__["N" /* METADATA_SET_REPORT_READ */]:{var _metadataSet2=Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var _report=_metadataSet2.reports[0];var _msdTree=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.msdTree);var _identifiableTargets2=_msdTree.find(function(msd){return msd.target===_report.target.id;}).identifiableTargets.map(function(el){var referenceValue=_report.target.referenceValues.find(function(_ref8){var id=_ref8.id;return id===el.id;});return Object.assign({},el,{value:referenceValue?referenceValue.object:null});});return Object.assign({},state,{report:_report,reportId:_report.id,target:_report.target.id,identifiableTargets:_identifiableTargets2,isReportVisible:true,step:__WEBPACK_IMPORTED_MODULE_9__commons_constants__["b" /* REPORT_DETAILS_WIZARD_STEP_FIRST */]});}case __WEBPACK_IMPORTED_MODULE_0__actions__["z" /* METADATA_SET_REPORT_ATTRIBUTE_CODES_READ */]:return Object.assign({},state,{codes:Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes});case __WEBPACK_IMPORTED_MODULE_0__actions__["R" /* METADATA_SET_REPORT_TARGET_ARTEFACTS_READ */]:return Object.assign({},state,{artefacts:(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)||[]).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact);})});case __WEBPACK_IMPORTED_MODULE_0__actions__["P" /* METADATA_SET_REPORT_SUBMIT */]:{return Object.assign({},state,{isFetchMetadataSetDisabled:false});}case __WEBPACK_IMPORTED_MODULE_0__actions__["H" /* METADATA_SET_REPORT_DELETE */]:return Object.assign({},state,{isFetchMetadataSetDisabled:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["W" /* METADATA_SET_UPDATE_REPORT_STATE_SUBMIT */]:return Object.assign({},state,{isFetchMetadataSetDisabled:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* METADATA_SET_CONCEPT_SCHEMES_READ */]:var conceptSchemes=action.response.map(function(res){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["y" /* SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(res)[0]);});return Object.assign({},state,{msdTree:Object(__WEBPACK_IMPORTED_MODULE_6__utils_referenceMetadata__["N" /* getMsdTree */])(state.msd,conceptSchemes,action.appLang,action.dataLangs,Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action)),conceptSchemes:conceptSchemes});case __WEBPACK_IMPORTED_MODULE_0__actions__["n" /* METADATA_SET_METADATA_SET_CLONE_SUBMIT */]:return Object.assign({},state,{categorySchemes:null,categoryId:null,categoryUrn:null,metadataSets:null,metadataSetTree:null,metadataSet:null,conceptSchemeTriplets:null,isCloneVisible:false,cloneId:null,isFetchMetadataSetDisabled:false});case __WEBPACK_IMPORTED_MODULE_0__actions__["w" /* METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD */]:{var _reportStructure7=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(state.reportStructure);var _selectedAttribute4=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(_reportStructure7,"metadataAttributes",function(node){return node.nodeKey===state.selectedAttribute.nodeKey;});_selectedAttribute4.attachmentUploaded[action.lang]=true;_selectedAttribute4.attachmentName[action.lang]=action.response;return Object.assign({},state,{reportStructure:_reportStructure7,selectedAttribute:_selectedAttribute4});}default:return state;}case __WEBPACK_IMPORTED_MODULE_1__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* METADATA_SET_METADATA_SET_CATEGORISE */]:return metadataSetReducer(undefined,{});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (metadataSetReducer);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_user_permissions_middleware__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artefact_export_form__ = __webpack_require__(51);
var hierarchicalCodelistsReducer=function hierarchicalCodelistsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{hierarchicalCodelists:null,isVisible:false,hierarchicalCodelistTriplet:null,hierarchicalCodelist:null,agencies:null,allAgencies:null,downloadHierarchicalCodelistTriplets:null,downloadHierarchicalCodelistLang:null,downloadHierarchicalCodelistParams:null,parentsAndChildren:null,cloneDestTriplet:null,hierarchicalCodelistExportSourceTriplet:null,hierarchicalCodelistExportDestination:null,hierarchicalCodelistExportReport:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions__["j" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SHOW */]:return Object.assign({},state,{isVisible:true,hierarchicalCodelistTriplet:action.artefactTriplet});case __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE */]:var hierarchicalCodelist=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.hierarchicalCodelist);var customizer=function customizer(_,src,key){if(key==="annotations")return src;else{return undefined;}};return Object.assign({},state,{hierarchicalCodelist:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mergeWith(hierarchicalCodelist,action.fields,customizer)});case __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE */]:return Object.assign({},state,{isVisible:false,hierarchicalCodelist:null,hierarchicalCodelistTriplet:null,agencies:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["o" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW */]:return Object.assign({},state,{downloadHierarchicalCodelistTriplets:action.artefactTriplets,downloadHierarchicalCodelistLang:action.lang,downloadHierarchicalCodelistParams:{format:null,references:false,compression:false,csvSeparator:";",csvDelimiter:null,csvLanguage:null}});case __WEBPACK_IMPORTED_MODULE_2__actions__["n" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE */]:return Object.assign({},state,{downloadHierarchicalCodelistTriplets:null,downloadHierarchicalCodelistLang:null,downloadHierarchicalCodelistParams:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["m" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE */]:var downloadHierarchicalCodelistParams=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.downloadHierarchicalCodelistParams);return Object.assign({},state,{downloadHierarchicalCodelistParams:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(downloadHierarchicalCodelistParams,action.fields)});case __WEBPACK_IMPORTED_MODULE_2__actions__["u" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE */]:return Object.assign({},state,{parentsAndChildren:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW */]:var srcVersionArr=action.srcTriplet.version.split(".");var destVersionArr=srcVersionArr.map(function(num,index){return index===srcVersionArr.length-1?Number(num)+1:num;});return Object.assign({},state,{cloneDestTriplet:Object.assign({},action.srcTriplet,{version:destVersionArr.join(".")}),hierarchicalCodelistTriplet:state.hierarchicalCodelistTriplet?state.hierarchicalCodelistTriplet:action.srcTriplet});case __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE */]:return Object.assign({},state,{cloneDestTriplet:null,hierarchicalCodelist:state.isVisible?state.hierarchicalCodelist:null,hierarchicalCodelistTriplet:state.isVisible?state.hierarchicalCodelistTriplet:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE */]:var cloneDestTriplet=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cloneDestTriplet);return Object.assign({},state,{cloneDestTriplet:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(cloneDestTriplet,action.fields)});case __WEBPACK_IMPORTED_MODULE_2__actions__["s" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW */]:return Object.assign({},state,{hierarchicalCodelistExportSourceTriplet:action.sourceTriplet,hierarchicalCodelistExportDestination:{endpoint:null,username:null,password:null,id:action.sourceTriplet.id,agencyID:action.sourceTriplet.agencyID,version:action.sourceTriplet.version,loginOption:__WEBPACK_IMPORTED_MODULE_7__components_artefact_export_form__["a" /* LOGIN_OPTION_ACCOUNT */],providerLoginCode:null}});case __WEBPACK_IMPORTED_MODULE_2__actions__["q" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE */]:return Object.assign({},state,{hierarchicalCodelistExportSourceTriplet:null,hierarchicalCodelistExportDestination:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["p" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE */]:var hierarchicalCodelistExportDestination=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.hierarchicalCodelistExportDestination);__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(hierarchicalCodelistExportDestination,action.fields);return Object.assign({},state,{hierarchicalCodelistExportDestination:hierarchicalCodelistExportDestination});case __WEBPACK_IMPORTED_MODULE_2__actions__["r" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE */]:return Object.assign({},state,{hierarchicalCodelistExportReport:null});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["w" /* HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ */]:return Object.assign({},state,{hierarchicalCodelists:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["w" /* HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ */]:return Object.assign({},state,{hierarchicalCodelists:Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response).map(function(artefact){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(artefact,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations);})});case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* HIERARCHICAL_CODELISTS_AGENCIES_READ */]:return Object.assign({},state,{agencies:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(action.response,function(_,agencyID){return!action.allowedAgencies||action.allowedAgencies.includes(agencyID);}),allAgencies:action.response});case __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ */]:var userPermissions=Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_user_permissions_middleware__["b" /* getCurrentUserPermissions */])(action);var customNoneIsAutoAnnotation=userPermissions&&userPermissions.rules.includes("CanManageWorkingAnnotation")?function(){return false;}:undefined;var _hierarchicalCodelist=Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["N" /* getArtefactFromSdmxJsonStructure */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response,__WEBPACK_IMPORTED_MODULE_1__utils_sdmxJson__["F" /* SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY */])[0],Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,customNoneIsAutoAnnotation);return Object.assign({},state,{hierarchicalCodelist:Object.assign({},_hierarchicalCodelist,{customIsPresentational:Object(__WEBPACK_IMPORTED_MODULE_5__utils_referenceMetadata__["E" /* getCustomIsPresentationalFromAnnotations */])(_hierarchicalCodelist,Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)})});case __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SUBMIT */]:return Object.assign({},state,{hierarchicalCodelist:null,hierarchicalCodelists:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE */]:return Object.assign({},state,{hierarchicalCodelists:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["x" /* HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE */]:return Object.assign({},state,{hierarchicalCodelists:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD */]:return Object.assign({},state,{downloadHierarchicalCodelistTriplets:null,downloadHierarchicalCodelistLang:null,downloadHierarchicalCodelistParams:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["v" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ */]:return Object.assign({},state,{parentsAndChildren:action.response});case __WEBPACK_IMPORTED_MODULE_2__actions__["t" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT */]:return Object.assign({},state,{hierarchicalCodelistExportSourceTriplet:null,hierarchicalCodelistExportDestination:null,hierarchicalCodelistExportReport:action.response.itemsMessage,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT */]:return Object.assign({},state,{hierarchicalCodelists:null,cloneDestTriplet:null,hierarchicalCodelistTriplet:state.isVisible?state.hierarchicalCodelistTriplet:null,hierarchicalCodelist:state.isVisible?state.hierarchicalCodelist:null,agencies:state.isVisible?state.agencies:null,allAgencies:state.isVisible?state.allAgencies:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["x" /* HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE */]:return Object.assign({},state,{hierarchicalCodelists:null});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (hierarchicalCodelistsReducer);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tree__ = __webpack_require__(32);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var manageSeriesReducer=function manageSeriesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isCubesVisible:null,cubes:null,cubeId:null,cube:null,series:null,selectedSeries:[],isFilterModalVisible:false,filter:null,treeFilter:null,filterTemp:null,treeFilterTemp:null,filterMode:__WEBPACK_IMPORTED_MODULE_4__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */],filterRows:null,isFilterRowsModalVisible:false,isSeriesVisible:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* MANAGE_SERIES_CUBES_SHOW */]:return Object.assign({},state,{isCubesVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* MANAGE_SERIES_CUBES_HIDE */]:return Object.assign({},state,{isCubesVisible:false,cubes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* MANAGE_SERIES_CUBE_SET */]:return Object.assign({},state,{isCubesVisible:false,cubeId:action.cubeId,isSeriesVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* MANAGE_SERIES_CUBE_UNSET */]:return Object.assign({},state,{cubeId:null,cube:null,series:null,selectedSeries:[],isSeriesVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* MANAGE_SERIES_SERIES_SHOW */]:return Object.assign({},state,{series:null,isSeriesVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["C" /* MANAGE_SERIES_SELECTED_SERIES_SET */]:return Object.assign({},state,{selectedSeries:action.selectedSeries});case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* MANAGE_SERIES_FILTER_FORM_BLOCK_ADD */]:{var block={column:null,logicalOperator:'OR',conditions:null};return Object.assign({},state,{filterTemp:state.filterTemp!==null?[].concat(_toConsumableArray(state.filterTemp),[block]):[block]});}case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* MANAGE_SERIES_FILTER_FORM_BLOCK_DELETE */]:{var filterTemp=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.filterTemp);filterTemp.splice(action.blockIndex,1);return Object.assign({},state,{filterTemp:filterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* MANAGE_SERIES_FILTER_FORM_CONDITION_ADD */]:{var _filterTemp=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.filterTemp);var condition={comparisonOperator:null,value:null};if(_filterTemp[action.blockIndex].conditions!==null){_filterTemp[action.blockIndex].conditions.push(condition);}else{_filterTemp[action.blockIndex].conditions=[condition];}return Object.assign({},state,{filterTemp:_filterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* MANAGE_SERIES_FILTER_FORM_CONDITION_DELETE */]:{var _filterTemp2=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.filterTemp);_filterTemp2[action.blockIndex].conditions.splice(action.conditionIndex,1);return Object.assign({},state,{filterTemp:_filterTemp2});}case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* MANAGE_SERIES_FILTER_MODAL_SHOW */]:return Object.assign({},state,{isFilterModalVisible:true,filterTemp:state.filter,treeFilterTemp:state.treeFilter||{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* MANAGE_SERIES_FILTER_MODAL_HIDE */]:return Object.assign({},state,{isFilterModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* MANAGE_SERIES_FILTER_MODAL_SUBMIT */]:return Object.assign({},state,{isFilterModalVisible:false,filter:state.filterMode===__WEBPACK_IMPORTED_MODULE_4__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?action.filter:state.filter,filterTemp:null,treeFilter:state.filterMode===__WEBPACK_IMPORTED_MODULE_4__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]?action.filter:state.treeFilter,treeFilterTemp:{},series:null,selectedSeries:[],isSeriesVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* MANAGE_SERIES_FILTER_MODAL_FILTER_RESET */]:return Object.assign({},state,{filterTemp:[],treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* MANAGE_SERIES_FILTER_MODAL_FILTER_MODE_CHANGE */]:return Object.assign({},state,{filterMode:action.filterMode,filterTemp:[],treeFilterTemp:{}});case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* MANAGE_SERIES_FILTER_MODAL_FILTER_CHANGE */]:{var _filterTemp3=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.filterTemp);if(action.fields.filter.filter(function(block){return block.column!==undefined;}).length>0){action.fields.filter=action.fields.filter.map(function(block){return Object.assign({},block,{conditions:null});});}return Object.assign({},state,{filterTemp:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(_filterTemp3,action.fields.filter)});}case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_CHANGE */]:return Object.assign({},state,{treeFilterTemp:action.treeFilter});case __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_MODE_CHANGE */]:{var cube=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cube);var treeFilterTemp=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.treeFilterTemp);treeFilterTemp[action.colName]={mode:action.mode,values:treeFilterTemp[action.colName]&&treeFilterTemp[action.colName].values?treeFilterTemp[action.colName].values:[]};var colNames=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flatten(Object.keys(state.cube.columns).map(function(key){return state.cube.columns[key];})).map(function(_ref){var name=_ref.name;return name;});var colIndex=colNames.indexOf(action.colName);var subsequentColNames=colNames.splice(colIndex+1);// delete filters for subsequent cols
subsequentColNames.forEach(function(name){delete treeFilterTemp[name];});// delete filteredCodelistTree for subsequent cols
cube.columns=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(cube.columns,function(colArr){return colArr.map(function(col){return subsequentColNames.includes(col.name)?Object.assign({},col,{filteredCodelistTree:null}):col;});});return Object.assign({},state,{cube:cube,treeFilterTemp:treeFilterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["y" /* MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_VALUES_CHANGE */]:{var _treeFilterTemp=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.treeFilterTemp);_treeFilterTemp[action.colName]={mode:_treeFilterTemp[action.colName]&&_treeFilterTemp[action.colName].mode?_treeFilterTemp[action.colName].mode:__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["n" /* FILTER_MODE_IN */],values:action.values};var _colNames=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flatten(Object.keys(state.cube.columns).map(function(key){return state.cube.columns[key];})).map(function(_ref2){var name=_ref2.name;return name;});var _colIndex=_colNames.indexOf(action.colName);var _subsequentColNames=_colNames.splice(_colIndex+1);// delete filters for subsequent cols
_subsequentColNames.forEach(function(name){delete _treeFilterTemp[name];});return Object.assign({},state,{cube:Object.assign({},state.cube,{columns:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(state.cube.columns,function(colArr){return(// delete filteredCodelistTree for subsequent cols
colArr.map(function(col){if(_subsequentColNames.includes(col.name)){return Object.assign({},col,{filteredCodelistTree:null});}else{return col;}}));})}),treeFilterTemp:_treeFilterTemp});}case __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* MANAGE_SERIES_FILTER_ROWS_MODAL_SHOW */]:return Object.assign({},state,{isFilterRowsModalVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* MANAGE_SERIES_FILTER_ROWS_MODAL_HIDE */]:return Object.assign({},state,{filterRows:null,isFilterRowsModalVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_RESET */]:{var _cube=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cube);_cube.columns=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(_cube.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{values:null,valuesCount:null}):col;});});return Object.assign({},state,{cube:_cube});}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* MANAGE_SERIES_CUBES_READ */]:return Object.assign({},state,{cubes:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* MANAGE_SERIES_CUBE_READ */]:return Object.assign({},state,{cube:null});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* MANAGE_SERIES_SERIES_READ */]:return Object.assign({},state,{series:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* MANAGE_SERIES_FILTER_ROWS_READ */]:return Object.assign({},state,{filterRows:null,isFilterRowsModalVisible:false});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* MANAGE_SERIES_CUBES_READ */]:return Object.assign({},state,{cubes:Object(__WEBPACK_IMPORTED_MODULE_2__utils_treeBuilders__["b" /* getCubesTree */])(action.response[0],action.response[1])});case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* MANAGE_SERIES_CUBE_READ */]:var _cube2=action.response;return Object.assign({},state,{cube:Object.assign({},_cube2,{columns:{dimensions:_cube2.Dimensions.filter(function(dim){return!dim.IsTimeSeriesDim;}).map(function(dim){return Object.assign({},dim,{name:dim.ColName,disabled:false,isNumeric:false,values:null,valuesCount:null,codelistCount:null,codelistTree:null,filteredCodelistTree:null,codes:null});})}})});case __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* MANAGE_SERIES_SERIES_READ */]:return Object.assign({},state,{series:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* MANAGE_SERIES_SERIES_DELETE */]:return Object.assign({},state,{series:null,selectedSeries:[],isSeriesVisible:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* MANAGE_SERIES_FILTER_ROWS_READ */]:return Object.assign({},state,{filterRows:action.response});case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* MANAGE_SERIES_FILTER_FORM_COLUMN_VALUES_READ */]:{var columnValues=action.response.Data.map(function(val){return val[action.columnName];});var _cube3=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cube);_cube3.columns=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(_cube3.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{values:col.codes?col.codes.filter(function(_ref3){var id=_ref3.id;return columnValues.filter(function(val){return val===id;}).length;}):columnValues.map(function(val){return _defineProperty({},action.columnName,val);}),valuesCount:action.response.Count}):col;});});return Object.assign({},state,{cube:_cube3});}case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* MANAGE_SERIES_FILTER_FORM_COLUMN_CODES_READ */]:{var codes=Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations)(Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]).codes;var _cube4=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cube);_cube4.columns=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(_cube4.columns,function(colArr){return colArr.map(function(col){return col.ColName===action.columnName?Object.assign({},col,{codes:codes}):col;});});return Object.assign({},state,{cube:_cube4});}case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_COUNT_READ */]:{var _cube5=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cube);_cube5.columns=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(_cube5.columns,function(colArr){return colArr.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistCount:Number(action.header["x-total-count"])}):col;});});return Object.assign({},state,{cube:_cube5});}case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_CODELIST_TREE_READ */]:{var codelist=Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["T" /* getItemSchemeFromSdmxJsonFactory */])(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["u" /* SDMX_JSON_CODELIST_ITEMS_KEY */],Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_current_node_config_middleware__["b" /* getCurrentNodeConfig */])(action).annotations,__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["b" /* CODELIST_ORDER_ANNOTATION_KEY */])(Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["_0" /* getSdmxStructuresFromSdmxJson */])(action.response)[0]);var itemsTree=Object(__WEBPACK_IMPORTED_MODULE_7__utils_tree__["n" /* getTreeFromArray */])(codelist.codes||[],"codes");var _cube6=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cube);_cube6.columns=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(_cube6.columns,function(colArr){return colArr.map(function(col){return col.CodelistCode===Object(__WEBPACK_IMPORTED_MODULE_5__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(action.codelistTriplet)?Object.assign({},col,{codelistTree:itemsTree}):col;});});return Object.assign({},state,{cube:_cube6});}case __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* MANAGE_SERIES_FILTER_MODAL_TREE_FILTER_COLUMN_FILTERED_VALUES_READ */]:{var filteredValues=action.response.Data.map(function(obj){return obj[action.colName];});var _cube7=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(state.cube);_cube7.columns=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(_cube7.columns,function(colArr){return colArr.map(function(col){if(col.name===action.colName){var filteredCodelistTree=col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_7__utils_tree__["g" /* getFilteredTreeWithPaths */])(col.codelistTree||[],"codes",function(_ref5){var id=_ref5.id;return filteredValues.includes(id);}):null;return Object.assign({},col,{filteredCodelistTree:filteredCodelistTree,filteredValues:filteredValues,filteredCodelistTreeMaxDepth:col.CodelistCode!==null?Object(__WEBPACK_IMPORTED_MODULE_7__utils_tree__["j" /* getMaxTreeDepth */])(filteredCodelistTree,"codes"):null});}else return col;});});return Object.assign({},state,{cube:_cube7});}default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (manageSeriesReducer);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__row_list_reducer__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares_default_category_scheme_selector_actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var attributeFileReducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({components:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({rowList:__WEBPACK_IMPORTED_MODULE_3__row_list_reducer__["a" /* default */]}),shared:function shared(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{separator:";",delimiter:null,csvServerPath:null,tid:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* IMPORT_ATTRIBUTE_CUBE_UNSET */]:return Object.assign({},state,{separator:";",delimiter:null,csvServerPath:null,tid:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* IMPORT_ATTRIBUTE_CHANGE */]:var _$mapValues=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(action.fields,function(field){return field.value;}),separator=_$mapValues.separator,delimiter=_$mapValues.delimiter,file=_$mapValues.file,tid=_$mapValues.tid;return Object.assign({},state,{tid:tid!==undefined?tid:state.tid,csvServerPath:separator!==undefined&&separator!==state.separator||delimiter!==undefined&&delimiter!==state.delimiter?null:file===null?null:state.csvServerPath,separator:file===null?";":separator!==undefined?separator:state.separator,delimiter:file===null?null:delimiter!==undefined?delimiter:state.delimiter});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* IMPORT_ATTRIBUTE_FILE_UPLOAD */]:return Object.assign({},state,{csvServerPath:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* IMPORT_ATTRIBUTE_FILE_UPLOAD */]:return Object.assign({},state,{csvServerPath:action.response});case __WEBPACK_IMPORTED_MODULE_2__actions__["j" /* IMPORT_ATTRIBUTE_SUBMIT */]:return Object.assign({},state,{separator:";",delimiter:null,csvServerPath:null,tid:null});default:return state;}default:return state;}},local:function local(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{file:null,cubeId:null,cube:null,categorisedCubes:null,isCubeTreeVisible:false,checkFiltAttributes:false,refreshProdDf:false,isIgnoreConcurrentUploadConfirmVisible:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* IMPORT_ATTRIBUTE_CUBE_TREE_SHOW */]:return Object.assign({},state,{isCubeTreeVisible:true});case __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* IMPORT_ATTRIBUTE_CUBE_TREE_HIDE */]:return Object.assign({},state,{isCubeTreeVisible:false,categorisedCubes:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* IMPORT_ATTRIBUTE_CUBE_SET */]:return Object.assign({},state,{cubeId:action.cubeId,isCubeTreeVisible:false,categorisedCubes:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* IMPORT_ATTRIBUTE_CUBE_UNSET */]:return Object.assign({},state,{cubeId:null,cube:null,file:null,refreshProdDf:false,checkFiltAttributes:false});case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* IMPORT_ATTRIBUTE_CHANGE */]:var _$mapValues2=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(action.fields,function(field){return field.value;}),file=_$mapValues2.file,refreshProdDf=_$mapValues2.refreshProdDf,checkFiltAttributes=_$mapValues2.checkFiltAttributes;return Object.assign({},state,{file:file!==undefined?file:state.file,refreshProdDf:refreshProdDf!==undefined?refreshProdDf:state.refreshProdDf,checkFiltAttributes:checkFiltAttributes!==undefined?checkFiltAttributes:state.checkFiltAttributes});case __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE */]:return Object.assign({},state,{isIgnoreConcurrentUploadConfirmVisible:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["g" /* REQUEST_START */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:null});default:return state;}}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{categorisedCubes:Object(__WEBPACK_IMPORTED_MODULE_4__utils_treeBuilders__["b" /* getCubesTree */])(action.response[0],action.response[1])});case __WEBPACK_IMPORTED_MODULE_5__middlewares_default_category_scheme_selector_actions__["g" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT */]:case __WEBPACK_IMPORTED_MODULE_5__middlewares_default_category_scheme_selector_actions__["d" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT */]:return Object.assign({},state,{categorisedCubes:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* IMPORT_ATTRIBUTE_CUBE_READ */]:return Object.assign({},state,{cube:action.response});case __WEBPACK_IMPORTED_MODULE_2__actions__["j" /* IMPORT_ATTRIBUTE_SUBMIT */]:return Object.assign({},state,{file:null,cubeId:null,cube:null,categorisedCubes:null,isCubeTreeVisible:false,checkFiltAttributes:false,refreshProdDf:false,isIgnoreConcurrentUploadConfirmVisible:false});default:return state;}}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:{switch(action.label){case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ */]:return Object.assign({},state,{isCubeTreeVisible:false,categorisedCubes:[]});case __WEBPACK_IMPORTED_MODULE_2__actions__["j" /* IMPORT_ATTRIBUTE_SUBMIT */]:if(action.error&&action.error.errorCode==="LOADING_CONCURRENT_UPLOAD_SAME_CUBE"){return Object.assign({},state,{isIgnoreConcurrentUploadConfirmVisible:true});}else{return state;}default:return state;}}default:return state;}}});/* harmony default export */ __webpack_exports__["a"] = (attributeFileReducer);

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(344);
var attributeFileFormRowListReducer=function attributeFileFormRowListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isVisible:false,csvRows:null};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* IMPORT_ATTRIBUTE_ROW_LIST_SHOW */]:return Object.assign({},state,{isVisible:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* IMPORT_ATTRIBUTE_ROW_LIST_HIDE */]:return Object.assign({},state,{isVisible:false});case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["b" /* REQUEST_ERROR */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET */]:return Object.assign({},state,{isVisible:false,csvRows:null});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET */]:return Object.assign({},state,{csvRows:action.response});default:return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (attributeFileFormRowListReducer);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCreateCodelistsRequests; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCreateConceptRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDataflowDSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCreateFileComponentMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUpdateFileComponentMapping; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(63);
var ValidId=function ValidId(id){return id.replace(/([^0-9A-Z_-]+)/gi,'_').toUpperCase();};var getCreateCodelistsRequests=function getCreateCodelistsRequests(structureColumns,filterStr,dfId,tableName,inStagingDb){var requestsMethod=[];var requestsUrl=[];var requestsBody=[];var requestData=[];var filter=Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["f" /* getServerQueryObj */])(null,Object(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["a" /* getFilterObjFromStr */])(filterStr)).Filter;var translations=structureColumns.filter(function(column){return column.type===__WEBPACK_IMPORTED_MODULE_5__constants__["h" /* EL_COL_TYPE_TRANSLATION */];}).map(function(column){return{id:column.id,lang:column.translationDefinition.langCode,translatedColumn:column.translationDefinition.transColId};});if(translations.length>0){var translatedColumns=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.mapValues(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(translations,'translatedColumn'),function(tList){return tList.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(t,'translatedColumn');});});var dict={};Object.keys(translatedColumns).forEach(function(column){var idKvp={"Key":"Id","Value":column};var lst=[idKvp];translatedColumns[column].forEach(function(t){var kvp={"Key":t.lang,"Value":t.id};lst.push(kvp);});dict[ValidId(column)]=lst;requestData.push(ValidId(column));});var req={};req["filter"]=filter;req["cols"]=dict;var requestBody=req;requestsMethod.push(__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */]);requestsUrl.push(Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["L" /* getCreateCodelistUrl */])(dfId,tableName,inStagingDb));requestsBody.push(requestBody);var codelistRequests={methods:requestsMethod,urls:requestsUrl,body:requestsBody,data:requestData};return codelistRequests;}return null;};var getCreateConceptRequest=function getCreateConceptRequest(structureColumns,dstDataflow,appLang){var newConcepts=[];var columnsConcepts={};var id=dstDataflow.id;var agencyID=dstDataflow.agencyID;var version=dstDataflow.version;structureColumns.filter(function(column){return column.type!==__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* EL_COL_TYPE_IGNORE */]&&column.type!==__WEBPACK_IMPORTED_MODULE_5__constants__["h" /* EL_COL_TYPE_TRANSLATION */]&&column.semanticDefinition.conceptType===__WEBPACK_IMPORTED_MODULE_5__constants__["u" /* EL_SEMANTIC_CONCEPT_NEW */];}).forEach(function(column){var concept={id:""+ValidId(column.id),names:column.semanticDefinition.newConcept};newConcepts.push(concept);columnsConcepts[column.id]=concept;});if(newConcepts.length>0){var name={};name[appLang]="Concept scheme for dataflow "+id+"+"+agencyID+"+"+version;var csId="CS_"+id+"_"+agencyID+"_"+version.replace('.','_');var suffix=String(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.random(99999)).padStart(5,'0');csId=csId.substring(0,44)+'_'+suffix;var conceptSchema={id:csId,agencyID:"AST",version:"1.0",isFinal:true,name:name,concepts:newConcepts};return{methods:[__WEBPACK_IMPORTED_MODULE_2__middlewares_api_actions__["e" /* REQUEST_METHOD_POST */]],urls:[Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["K" /* getCreateArtefactsUrl */])()],body:[Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["V" /* getSdmxJsonFromSdmxJsonStructures */])([Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["W" /* getSdmxJsonStructureFromArtefact */])(conceptSchema)],__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["z" /* SDMX_JSON_CONCEPT_SCHEME_LIST_KEY */])],data:{conceptSchema:conceptSchema,columnsConcepts:columnsConcepts}};}return null;};var getConceptUrn=function getConceptUrn(column,conceptSchemaDefinition){if(column.semanticDefinition.conceptType===__WEBPACK_IMPORTED_MODULE_5__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */]){return Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(column.semanticDefinition.concept);}else{var columnConcept=conceptSchemaDefinition.columnsConcepts[column.id];var conceptSchema=conceptSchemaDefinition.conceptSchema;var conceptSchemaUrn=Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(conceptSchema,__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["H" /* SDMX_JSON_INFO_MODEL_CONCEPT_URN_NAMESPACE */]);return conceptSchemaUrn+"."+columnConcept.id;}};var getAttributeAttachmentData=function getAttributeAttachmentData(attributeDefinition){var attachmentLevel=void 0;var attachedDimensions=null;var attributeRelationship={};switch(attributeDefinition.refers){case __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* EL_ATTRIBUTE_REFERS_OBSERVATION */]:default:attachmentLevel=__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["f" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_OBSERVATION */];break;case __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* EL_ATTRIBUTE_REFERS_DATASET */]:attachmentLevel=__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["d" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_DATASET */];break;case __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* EL_ATTRIBUTE_REFERS_DIMENSION */]:attachmentLevel=__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["g" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_SERIES */];attachedDimensions=attributeDefinition.dimensions;attributeRelationship={"dimensions":attributeDefinition.dimensions};break;}return{level:attachmentLevel,dimensions:attachedDimensions,attributeRelationship:attributeRelationship};};var getDimensionData=function getDimensionData(column,timeDimensionOrder,codelists,astTerritoryDimId){var type=void 0;var order=0;var representation=null;var id=ValidId(column.id);switch(column.dimensionDefinition.role){case __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* EL_DIMENSION_ROLE_FREQUENCY */]:type=__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["j" /* DSD_DIMENSION_TYPE_FREQUENCY */];order=1;break;case __WEBPACK_IMPORTED_MODULE_5__constants__["k" /* EL_DIMENSION_ROLE_MEASURE */]:type=__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["k" /* DSD_DIMENSION_TYPE_MEASURE */];break;case __WEBPACK_IMPORTED_MODULE_5__constants__["m" /* EL_DIMENSION_ROLE_TIME */]:type=__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */];order=timeDimensionOrder;break;case __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* EL_DIMENSION_ROLE_TERRITORY */]:type=__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["l" /* DSD_DIMENSION_TYPE_NORMAL */];id=astTerritoryDimId;break;default:type=__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["l" /* DSD_DIMENSION_TYPE_NORMAL */];}if(column.dimensionDefinition.role!==__WEBPACK_IMPORTED_MODULE_5__constants__["m" /* EL_DIMENSION_ROLE_TIME */]){if(column.dimensionDefinition.association){try{representation=Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(column.dimensionDefinition.association);}catch(e){representation=Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(column.dimensionDefinition.association,__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["G" /* SDMX_JSON_INFO_MODEL_CODELIST_URN_NAMESPACE */]);}}else{var codelist=codelists[ValidId(column.id)];representation=Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])({id:codelist,agencyID:"AST",version:"1.0"},__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["G" /* SDMX_JSON_INFO_MODEL_CODELIST_URN_NAMESPACE */]);}}return{id:id,type:type,order:order,representation:representation};};var getDataflowDSD=function getDataflowDSD(structureColumns,dstDataflow,appLang,codelists,conceptSchemaDefinition,astTerritoryDimId){var name={};name[appLang]="DSD for dataflow "+dstDataflow.id+"+"+dstDataflow.agencyID+"+"+dstDataflow.version;var dimensions=[];var attributes=[];var attrOrder=1;var columns=structureColumns.filter(function(column){return column.type!==__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* EL_COL_TYPE_IGNORE */];});var timeDimensionOrder=columns.filter(function(column){return column.type===__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* EL_COL_TYPE_DIMENSION */];}).length;var dimensionOrder=1;if(columns.some(function(column){return column.dimensionDefinition.role===__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* EL_DIMENSION_ROLE_FREQUENCY */];})){dimensionOrder=2;}// const dsdId = `DSD_${dstDataflow.id}_${dstDataflow.agencyID}_${dstDataflow.version.replace('.', '')}`;
var dsdId="DSD_"+dstDataflow.id+"_"+dstDataflow.agencyID+"_"+dstDataflow.version.replace('.','_');var suffix=String(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.random(99999)).padStart(5,'0');dsdId=dsdId.substring(0,44)+'_'+suffix;var dsd={id:dsdId,agencyID:"AST",version:"1.0",isFinal:true,name:name};columns.forEach(function(column){if(column.type===__WEBPACK_IMPORTED_MODULE_5__constants__["g" /* EL_COL_TYPE_MEASURE */]){dsd.primaryMeasure={id:ValidId(column.id),concept:getConceptUrn(column,conceptSchemaDefinition),representation:null,annotations:null};}else if(column.type===__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* EL_COL_TYPE_ATTRIBUTE */]){var attachmentData=getAttributeAttachmentData(column.attributeDefinition);var attribute={id:ValidId(column.id),order:attrOrder++,concept:getConceptUrn(column,conceptSchemaDefinition),representation:column.attributeDefinition.association?Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(column.attributeDefinition.association):null,assignmentStatus:"Conditional",attachmentLevel:attachmentData.level,annotations:null,attachedDimensions:attachmentData.dimensions,attachmentGroup:null,attributeRelationship:attachmentData.attributeRelationship};attributes.push(attribute);}else if(column.type===__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* EL_COL_TYPE_DIMENSION */]){var dimensionData=getDimensionData(column,timeDimensionOrder,codelists,astTerritoryDimId);var dimension={type:dimensionData.type,id:dimensionData.id,order:dimensionData.order===0?dimensionOrder++:dimensionData.order,concept:getConceptUrn(column,conceptSchemaDefinition),representation:dimensionData.representation};dimensions.push(dimension);}});dsd.dimensions=dimensions;dsd.attributes=attributes;dsd.annotations=[];return dsd;};var getCreateFileComponentMapping=function getCreateFileComponentMapping(structureColumns,astTerritoryDimId){var componentMapping=[];var columns=structureColumns.filter(function(column){return column.type===__WEBPACK_IMPORTED_MODULE_5__constants__["g" /* EL_COL_TYPE_MEASURE */]||column.type===__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* EL_COL_TYPE_ATTRIBUTE */]||column.type===__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* EL_COL_TYPE_DIMENSION */];});columns.forEach(function(column){var cubeComponentCode=ValidId(column.id);var cubeComponentType=__WEBPACK_IMPORTED_MODULE_5__constants__["o" /* EL_LOAD_CUBE_COMPONENT_TYPE_DIMENSION */];switch(column.type){case __WEBPACK_IMPORTED_MODULE_5__constants__["g" /* EL_COL_TYPE_MEASURE */]:cubeComponentType=__WEBPACK_IMPORTED_MODULE_5__constants__["p" /* EL_LOAD_CUBE_COMPONENT_TYPE_MEASURE */];break;case __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* EL_COL_TYPE_ATTRIBUTE */]:cubeComponentType=__WEBPACK_IMPORTED_MODULE_5__constants__["n" /* EL_LOAD_CUBE_COMPONENT_TYPE_ATTRIBUTE */];break;case __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* EL_COL_TYPE_DIMENSION */]:default:if(column.dimensionDefinition.role===__WEBPACK_IMPORTED_MODULE_5__constants__["m" /* EL_DIMENSION_ROLE_TIME */]){cubeComponentType=__WEBPACK_IMPORTED_MODULE_5__constants__["q" /* EL_LOAD_CUBE_COMPONENT_TYPE_TIME_DIMENSION */];}else if(column.dimensionDefinition.role===__WEBPACK_IMPORTED_MODULE_5__constants__["l" /* EL_DIMENSION_ROLE_TERRITORY */]){cubeComponentCode=ValidId(astTerritoryDimId);}break;}var mapping={idComp:0,idMapping:0,columnName:column.id,cubeComponentCode:cubeComponentCode,cubeComponentType:cubeComponentType,mappingType:0};componentMapping.push(mapping);});return componentMapping;};var getUpdateFileComponentMapping=function getUpdateFileComponentMapping(components){var componentMapping=[];components.forEach(function(component){var mapping={idComp:0,idMapping:0,columnName:component.columnName,cubeComponentCode:component.cubeComponentCode,cubeComponentType:component.cubeComponentType,mappingType:0};componentMapping.push(mapping);});return componentMapping;};

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_default_category_scheme_selector_reducer__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_spinner_reducer__ = __webpack_require__(1145);
var middlewaresReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({defaultCategorySchemeSelector:__WEBPACK_IMPORTED_MODULE_1__middlewares_default_category_scheme_selector_reducer__["b" /* default */],spinner:__WEBPACK_IMPORTED_MODULE_2__middlewares_spinner_reducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (middlewaresReducer);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(188);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var spinnerReducer=function spinnerReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{actions:[]};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SPINNER_ACTION_ADD */]:return Object.assign({},state,{actions:[].concat(_toConsumableArray(state.actions),[Object.assign({},action,{isCompleted:false})])});case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* SPINNER_ACTION_COMPLETE */]:return Object.assign({},state,{actions:state.actions.map(function(el){return el.uuid===action.uuid?Object.assign({},el,{isCompleted:true}):el;})});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SPINNER_ACTIONS_FLUSH */]:return Object.assign({},state,{actions:[]});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (spinnerReducer);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_app_actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_config_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_it__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_en_gb__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_en_gb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_locale_en_gb__);
var middlewareFactory=function middlewareFactory(i18n){return function(_ref){var dispatch=_ref.dispatch;return function(next){return function(action){if(action.type===__WEBPACK_IMPORTED_MODULE_0__reducers_app_actions__["b" /* APP_LANGUAGE_SET */]&&action.payload.language){__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('en-gb');if(action.payload.language==='it'){__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('it');}}var result=next(action);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__reducers_app_actions__["b" /* APP_LANGUAGE_SET */]:i18n.changeLanguage(action.payload.language);break;case __WEBPACK_IMPORTED_MODULE_2__api_actions__["h" /* REQUEST_SUCCESS */]:switch(action.label){case __WEBPACK_IMPORTED_MODULE_1__reducers_config_actions__["b" /* CONFIG_READ */]:dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__reducers_app_actions__["n" /* setAppLanguage */])(action.response.userInterface.defaultLanguage));break;default:break;}break;default:break;}return result;};};};};/* harmony default export */ __webpack_exports__["a"] = (middlewareFactory);

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(46)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(46)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changeLanguage */
/* unused harmony export cloneInstance */
/* unused harmony export createInstance */
/* unused harmony export dir */
/* unused harmony export exists */
/* unused harmony export getFixedT */
/* unused harmony export init */
/* unused harmony export loadLanguages */
/* unused harmony export loadNamespaces */
/* unused harmony export loadResources */
/* unused harmony export off */
/* unused harmony export on */
/* unused harmony export setDefaultNamespace */
/* unused harmony export t */
/* unused harmony export use */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(1150);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator_js__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaults_js__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__ = __webpack_require__(518);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }












function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.backendConnector.load(toLoad, this.options.ns, callback);
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns, callback) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = function callback() {};
    this.services.backendConnector.reload(lngs, ns, callback);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }

      var options = _extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(239);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { silent: false };

    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : { silent: false };

    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, pack);

    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.getDataByLanguage = function getDataByLanguage(lng) {
    return this.data[lng];
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(239);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }






var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, _this);

    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys, options) {
    var _this2 = this;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (!options) options = {};

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var resUsedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            var deepKey = '' + resUsedKey + keySeparator + m;
            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;

        if (options.count !== undefined) {
          var suffix = this.pluralResolver.getSuffix(lng, options.count);
          res = options['defaultValue' + suffix];
        }
        if (!res) res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        var send = function send(l, k) {
          if (_this2.options.missingKeyHandler) {
            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          }
          _this2.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(function (l) {
              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

              plurals.forEach(function (p) {
                return send([l], p);
              });
            });
          } else {
            send(lngs, key);
          }
        }
      }

      // extend
      res = this.extendTranslation(res, keys, options, resolved);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options, resolved) {
    var _this3 = this;

    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, { resolved: resolved });
    } else if (!options.skipInterpolation) {
      // i18next.parsing
      if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

      // interpolate
      var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
      res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

      // nesting
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        return _this3.translate.apply(_this3, arguments);
      }, options);

      if (options.interpolation) this.interpolator.reset();
    }

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;
    var usedLng = void 0;
    var usedNS = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this4.isValidLookup(found)) return;
      var extracted = _this4.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);

      namespaces.forEach(function (ns) {
        if (_this4.isValidLookup(found)) return;
        usedNS = ns;

        codes.forEach(function (code) {
          if (_this4.isValidLookup(found)) return;
          usedLng = code;

          var finalKey = key;
          var finalKeys = [finalKey];

          if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
            _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            var pluralSuffix = void 0;
            if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);

            // fallback for plural if context not found
            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

            // get key for context if needed
            if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);

            // get key for plural if needed
            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
          }

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this4.isValidLookup(found)) {
              found = _this4.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey, usedLng: usedLng, usedNS: usedNS };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(165);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(165);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
    var _this = this;

    var ret = [];

    var rule = this.getRule(code);

    if (!rule) return ret;

    rule.numbers.forEach(function (n) {
      var suffix = _this.getSuffix(code, n);
      ret.push('' + key + suffix);
    });

    return ret;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this2 = this;

    var rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(165);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escape = iOpts.escape !== undefined ? iOpts.escape : __WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* escape */];
    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng, options) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (value === undefined) {
        if (typeof missingInterpolationHandler === 'function') {
          var temp = missingInterpolationHandler(str, match);
          value = typeof temp === 'string' ? temp : '';
        } else {
          this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
          value = '';
        }
      } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
        value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key, inheritedOptions) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);

        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__ = __webpack_require__(238);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, options, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // consolidated loading done in this run - only emit once for a loaded namespace
    var loaded = {};

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        // only do once per loaded -> this.emit('loaded', q.loaded);
        Object.keys(q.loaded).forEach(function (l) {
          if (!loaded[l]) loaded[l] = [];
          if (q.loaded[l].length) {
            q.loaded[l].forEach(function (ns) {
              if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
            });
          }
        });

        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // emit consolidated loaded event
    this.emit('loaded', loaded);

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this3 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.prepareLoading = function prepareLoading(languages, namespaces) {
    var _this4 = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = arguments[3];

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    toLoad.toLoad.forEach(function (name) {
      _this4.loadOne(name);
    });
  };

  Connector.prototype.load = function load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  };

  Connector.prototype.reload = function reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, { reload: true }, callback);
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this5 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split3 = name.split('|'),
        _name$split4 = _slicedToArray(_name$split3, 2),
        lng = _name$split4[0],
        ns = _name$split4[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this5.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this5.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this5.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, { isUpdate: isUpdate }));
    }

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    saveMissingPlurals: true, // will save all forms not only singular key
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false, // function(str, match)

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (args[1]) ret.defaultValue = args[1];
      if (args[2]) ret.tDescription = args[2];
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers_app_actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__spinner_actions__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_getStatusCodesTranslations__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants_getErrorCodesTranslations__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants_customStatusCodes__ = __webpack_require__(1181);
var apiMiddlewareFactory=function apiMiddlewareFactory(baseUrl,i18next){__WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.config({duration:3,maxCount:1});var t=i18next.t.bind(i18next);var fetchFromApi=__WEBPACK_IMPORTED_MODULE_13_axios___default.a.create({baseURL:baseUrl});return function(_ref){var dispatch=_ref.dispatch,getState=_ref.getState;return function(next){return function(action){var handleResponseSuccess=function handleResponseSuccess(uuid,action,res,hideFeedback){if(res[0].headers['token-expired']){handleTokenExpired();}if(!hideFeedback&&action.messages!==undefined&&action.messages.success!==undefined){__WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success(action.messages.success);}var successAction=Object(__WEBPACK_IMPORTED_MODULE_12__actions__["p" /* successRequest */])(uuid,action,action.isArray?res.map(function(res){return res.data;}):res[0].data,action.isArray?res.map(function(res){return res.headers;}):res[0].headers);dispatch(successAction);dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__spinner_actions__["e" /* completeSpinnerAction */])(successAction,uuid));};var handleTokenExpired=function handleTokenExpired(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__reducers_app_actions__["i" /* clearAppUser */])());};var handleCustomError=function handleCustomError(uuid,action,errObj,hideFeedback){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["k" /* errorRequest */])(uuid,action,null,errObj,hideFeedback));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__spinner_actions__["e" /* completeSpinnerAction */])(action,uuid));console.error(''+errObj.errorCode+(errObj.stackTrace?'- '+errObj.stackTrace:''));};var handleGenericError=function handleGenericError(uuid,action,statusCode,hideFeedback){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["k" /* errorRequest */])(uuid,action,statusCode,null,hideFeedback));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__spinner_actions__["e" /* completeSpinnerAction */])(action,uuid));console.error(''+action.label+(statusCode?' - '+statusCode:''));};var handleResponseError=function handleResponseError(uuid,action,res,hideFeedback){if(res.response){if(res.response.headers['token-expired']){handleTokenExpired();}if(res.response.data){if(action.doNotJSONParse){res.response.data=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(res.response.data)));}if(res.response.data.errorCode){handleCustomError(uuid,action,res.response.data,hideFeedback);if(res.response.data.errorCode==="CONFIG_NODE_SESSION_NOT_FOUND"){dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__reducers_app_actions__["i" /* clearAppUser */])());}}else{handleGenericError(uuid,action,res.response.status,hideFeedback);}}else{handleGenericError(uuid,action,res.response.status,hideFeedback);}}else{handleGenericError(uuid,action,res.code||null,hideFeedback);}};var result=next(action);if(action.type===__WEBPACK_IMPORTED_MODULE_12__actions__["a" /* REQUEST */]){var method=action.method,url=action.url,data=action.data,isArray=action.isArray,contentType=action.contentType,doNotJSONParse=action.doNotJSONParse,sequential=action.sequential,endpointId=action.endpointId,timeout=action.timeout;if(!isArray){method=[method];url=[url];data=[data];}// if (messages !== undefined && messages !== null && messages.start !== undefined) {
//   message.loading(messages.start, 0);
// }
var uuid=__WEBPACK_IMPORTED_MODULE_15_uuid___default()();var startAction=Object(__WEBPACK_IMPORTED_MODULE_12__actions__["o" /* startRequest */])(uuid,action);dispatch(startAction);dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__spinner_actions__["d" /* addSpinnerAction */])(startAction,uuid));var token=getState().app.user.token;var nodeId=endpointId||getState().app.endpointId;var requestsParams=method.map(function(method,idx){var headers={nodeId:nodeId};if(contentType){headers['Content-Type']=contentType;}if(token&&!endpointId){headers['Authorization']='bearer '+token;}return{withCredentials:true,headers:headers,method:method,url:url[idx],transformResponse:doNotJSONParse?function(res){return res;}:null,data:data&&data[idx]?data[idx]:undefined,responseType:doNotJSONParse?'arraybuffer':undefined,timeout:timeout||undefined};});var handleResponses=function handleResponses(resArr,reqArr){reqArr=reqArr.filter(function(r,i){return resArr[i]!==undefined;});resArr=resArr.filter(function(r){return r!==undefined;});if(resArr.length>0){var errorsCount=resArr.filter(function(res){return!res||!res.status||res.status!==200;}).length;if(errorsCount===0){handleResponseSuccess(uuid,action,resArr);}else{var handleError=function handleError(){handleResponseError(uuid,action,resArr.filter(function(_ref2){var status=_ref2.status;return status!==200;})[0],resArr.length>1&&action.idsForErrorReport);if(resArr.length>1&&action.idsForErrorReport){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.error({title:t("errors.some"),width:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MODAL_WIDTH_MD"],content:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',bodyStyle:{maxHeight:320,overflowY:"auto",overflowX:"hidden"}},resArr.map(function(res,index){return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div',{style:index<resArr.length-1?{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_SM"]}:null,key:index},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,res.status===200?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:'check-circle',theme:'filled',style:{color:'green'}}):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:'close-circle',theme:'filled',style:{color:'red'}})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,action.idsForErrorReport[index])),res.status!==200&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,function(){if(!res.response){return t('errors.generic');}else{if(action.doNotJSONParse){res.response.data=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(res.response.data)));}if(!res.response.data||!res.response.data.errorCode){var translatedStatusCode=Object(__WEBPACK_IMPORTED_MODULE_18__constants_getStatusCodesTranslations__["a" /* getStatusCodesTranslations */])(t)[res.response.status];return translatedStatusCode!==undefined?translatedStatusCode:t('errors.unknown',{code:''+res.response.status});}else{var translatedErrorCode=Object(__WEBPACK_IMPORTED_MODULE_19__constants_getErrorCodesTranslations__["a" /* getErrorCodesTranslations */])(t)[res.response.data.errorCode];return translatedErrorCode!==undefined?translatedErrorCode:res.response.data.errorCode;}}}())));}))});}};var files=reqArr.filter(function(req){return req.data!==undefined&&req.data instanceof FormData&&req.data.has("file");}).map(function(req){return req.data.get("file");});if(files.length>0){var checkFile=function checkFile(index){var reader=new FileReader();reader.onload=function(){if(index===files.length-1){handleError();}else{checkFile(index+1);}};reader.onerror=function(){return handleGenericError(uuid,action,__WEBPACK_IMPORTED_MODULE_21__constants_customStatusCodes__["a" /* CUSTOM_STATUS_CODE_FILE_SUBMIT */]);};reader.readAsText(files[index],"UTF-8");};checkFile(0);}else{handleError();}}}};if(sequential){var resArr=[];var reqArr=[];var foo=function foo(index){fetchFromApi(requestsParams[index]).catch(function(err){return err;}).then(function(res){resArr.push(res);reqArr.push(requestsParams[index]);if(index<requestsParams.length-1){foo(index+1);}else{handleResponses(resArr,reqArr);}});};foo(0);}else{__WEBPACK_IMPORTED_MODULE_13_axios___default.a.all(requestsParams.map(fetchFromApi).map(function(promise){return promise.catch(function(err){return err;});})).then(function(resArr){return handleResponses(resArr,requestsParams);});}}return result;};};};};/* harmony default export */ __webpack_exports__["a"] = (apiMiddlewareFactory);

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification__ = __webpack_require__(1161);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notification__["a" /* default */]);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notice__ = __webpack_require__(1162);















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      var maxCount = _this.props.maxCount;

      _this.setState(function (previousState) {
        var notices = previousState.notices;
        var noticeIndex = notices.map(function (v) {
          return v.key;
        }).indexOf(key);
        var updatedNotices = notices.concat();
        if (noticeIndex !== -1) {
          updatedNotices.splice(noticeIndex, 1, notice);
        } else {
          if (maxCount && notices.length >= maxCount) {
                                                notice.updateKey = updatedNotices[0].updateKey || updatedNotices[0].key;
            updatedNotices.shift();
          }
          updatedNotices.push(notice);
        }
        return {
          notices: updatedNotices
        };
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var notices = this.state.notices;

      var noticeNodes = notices.map(function (notice, index) {
        var update = Boolean(index === notices.length - 1 && notice.updateKey);
        var key = notice.updateKey ? notice.updateKey : notice.key;
        var onClose = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__["a" /* default */])(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__Notice__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
            prefixCls: props.prefixCls
          }, notice, {
            key: key,
            update: update,
            onClose: onClose,
            onClick: notice.onClick,
            closeIcon: props.closeIcon
          }),
          notice.content
        );
      });
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_rc_animate__["default"],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Notification.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  maxCount: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  closeIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
};
Notification.defaultProps = {
  prefixCls: 'rc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['getContainer']);

  var div = document.createElement('div');
  if (getContainer) {
    var root = getContainer();
    root.appendChild(div);
  } else {
    document.body.appendChild(div);
  }
  var called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },

      component: notification,
      destroy: function destroy() {
        __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.unmountComponentAtNode(div);
        div.parentNode.removeChild(div);
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Notification, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, { ref: ref })), div);
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var Notice = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.duration !== prevProps.duration || this.props.update) {
        this.restartCloseTimer();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'restartCloseTimer',
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, '' + componentClass, 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, componentClass + '-closable', props.closable), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className),
          style: props.style,
          onMouseEnter: this.clearCloseTimer,
          onMouseLeave: this.startCloseTimer,
          onClick: props.onClick
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          props.closeIcon || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Notice.propTypes = {
  duration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  update: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  closeIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Notice);

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);
var bind = __webpack_require__(520);
var Axios = __webpack_require__(1165);
var defaults = __webpack_require__(348);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(524);
axios.CancelToken = __webpack_require__(1179);
axios.isCancel = __webpack_require__(523);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1180);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1164 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(348);
var utils = __webpack_require__(92);
var InterceptorManager = __webpack_require__(1174);
var dispatchRequest = __webpack_require__(1175);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(522);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);
var transformData = __webpack_require__(1176);
var isCancel = __webpack_require__(523);
var defaults = __webpack_require__(348);
var isAbsoluteURL = __webpack_require__(1177);
var combineURLs = __webpack_require__(1178);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(92);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(524);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOM_STATUS_CODE_FILE_SUBMIT; });
var CUSTOM_STATUS_CODE_FILE_SUBMIT="CUSTOM_STATUS_CODE_FILE_SUBMIT";

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ReportWarningList__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ReportInfoList__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_string_download_button__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_getErrorCodesTranslations__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_getStatusCodesTranslations__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__page_actions__ = __webpack_require__(329);
var middlewareFactory=function middlewareFactory(i18next){return function(){return function(next){return function(action){var t=i18next.t.bind(i18next);switch(action.type){case __WEBPACK_IMPORTED_MODULE_19__page_actions__["a" /* PAGE_NAVIGATE */]:__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.destroyAll();return next(action);case __WEBPACK_IMPORTED_MODULE_11__api_actions__["a" /* REQUEST */]:if(typeof action.messages==='function'){action.messages=action.messages(t);}return next(action);case __WEBPACK_IMPORTED_MODULE_11__api_actions__["h" /* REQUEST_SUCCESS */]:if(action.response&&(action.response.ReportDictionary||action.response.WarnDictionary)){var infos=action.response.ReportDictionary;var warnings=action.response.WarnDictionary;var wrongLines=action.response.WrongLines;var reportFileNameId=action.reportFileNameId;var reportFileNameTime=__WEBPACK_IMPORTED_MODULE_16_moment___default()().format('YYYY-MM-DD_HH-mm-ss');if(window.modal!==undefined){window.modal.destroy();}var modal=__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.info();modal.update({width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_LG"],title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:'close',onClick:modal.destroy,style:{cursor:'pointer'}}))),content:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ReportInfoList__["a" /* ReportInfoList */],{t:t,infos:infos}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ReportWarningList__["a" /* default */],{t:t,warnings:warnings})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_string_download_button__["a" /* default */],{str:Object(__WEBPACK_IMPORTED_MODULE_14__ReportInfoList__["b" /* getReportInfoListStr */])(t,infos)+'\r\n'+Object(__WEBPACK_IMPORTED_MODULE_13__ReportWarningList__["b" /* getReportWarningListStr */])(t,warnings),fileName:'report_'+(reportFileNameId?reportFileNameId+'_':'')+reportFileNameTime+'.txt',mimeType:'text/plain'},t('middlewares.feedback.buttons.warningListDownload'))),wrongLines&&wrongLines.length>0&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_string_download_button__["a" /* default */],{str:Object(__WEBPACK_IMPORTED_MODULE_13__ReportWarningList__["c" /* getReportWrongLinesStr */])(wrongLines),fileName:'wrong-lines_'+(reportFileNameId?reportFileNameId+'_':'')+reportFileNameTime+'.csv',mimeType:'text/csv'},t('middlewares.feedback.buttons.wrongLinesDownload')))))});window.modal=modal;}return next(action);case __WEBPACK_IMPORTED_MODULE_11__api_actions__["b" /* REQUEST_ERROR */]:if(!action.hideFeedback){var content=null;var isWarning=false;if(action.error){var _action$error=action.error,errorCode=_action$error.errorCode,report=_action$error.report;var translatedErrorCode=Object(__WEBPACK_IMPORTED_MODULE_17__constants_getErrorCodesTranslations__["a" /* getErrorCodesTranslations */])(t)[errorCode];var _reportFileNameId=action.reportFileName;var _reportFileNameTime=__WEBPACK_IMPORTED_MODULE_16_moment___default()().format('YYYY-MM-DD_HH-mm-ss');/* gestione custom di alcuni errori */if(errorCode==="DEF_CAT_SCHEME_EMPTY"){isWarning=true;}if(errorCode==="LOADING_CONCURRENT_UPLOAD_SAME_CUBE"){return next(action);}content=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,translatedErrorCode!==undefined?translatedErrorCode:errorCode,report&&Object.keys(report).length>0&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ReportWarningList__["a" /* default */],{t:t,warnings:report}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_string_download_button__["a" /* default */],{str:''+Object(__WEBPACK_IMPORTED_MODULE_13__ReportWarningList__["b" /* getReportWarningListStr */])(t,report),fileName:'report_'+(_reportFileNameId?_reportFileNameId+'_':'')+_reportFileNameTime+'.txt',mimeType:'text/plain'},t('middlewares.feedback.buttons.warningListDownload'))))));}else if(action.statusCode){var translatedStatusCode=Object(__WEBPACK_IMPORTED_MODULE_18__constants_getStatusCodesTranslations__["a" /* getStatusCodesTranslations */])(t)[action.statusCode];content=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,translatedStatusCode!==undefined?translatedStatusCode:t('errors.unknown',{code:''+action.statusCode}));}else{content=t('errors.generic');}__WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.destroy();// TODO: improve
if(window.modal!==undefined){window.modal.destroy();}window.modal=(isWarning?__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warn:__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.error)({title:isWarning?t('errors.titleForWarning'):t('errors.title'),content:content,onOk:function onOk(closeDialog){closeDialog();},width:action.error&&action.error.report&&Object.keys(action.error.report).length>0?__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_LG"]:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_SM"]});}return next(action);default:return next(action);}};};};};/* harmony default export */ __webpack_exports__["a"] = (middlewareFactory);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getReportWarningListStr;
/* harmony export (immutable) */ __webpack_exports__["c"] = getReportWrongLinesStr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_getErrorCodesTranslations__ = __webpack_require__(240);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getRow(warningKey){var doubleDotsSplit=warningKey.split(':');var beforeDoubleDots=doubleDotsSplit.length>0&&doubleDotsSplit[0].length>0?doubleDotsSplit[0]:null;if(beforeDoubleDots){var atSignSplit=beforeDoubleDots.split('@');return atSignSplit[0];}else{return null;}}function getCode(warningKey){var doubleDotsSplit=warningKey.split(':');var beforeDoubleDots=doubleDotsSplit.length>0&&doubleDotsSplit[0].length>0?doubleDotsSplit[0]:null;if(beforeDoubleDots){var atSignSplit=beforeDoubleDots.split('@');return atSignSplit[1];}else{return null;}}function getCol(warningKey){var split=warningKey.split(':');return split.length>1&&split[1].length>0?split[1]:null;}function getTitleStr(t){return t('middlewares.feedback.warningList.title');}function getLinePrefix(t,key){var row=getRow(key);var code=getCode(key);var col=getCol(key);var rowStr=row?t('middlewares.feedback.warningList.row')+' '+row:'';var colStr=col?t('middlewares.feedback.warningList.column')+' '+col:'';var codeStr=code?t('middlewares.feedback.warningList.code')+' '+code:'';return[rowStr,colStr,codeStr].filter(function(str){return str.length>0;}).join(" - ")+(row||col||code?': ':'');}function getLineContent(t,warnings,key){return Object(__WEBPACK_IMPORTED_MODULE_5__constants_getErrorCodesTranslations__["a" /* getErrorCodesTranslations */])(t)[warnings[key]]||t('errors.unknown',{code:warnings[key]});}function getReportWarningListStr(t,warnings){var _ref;var getLine=function getLine(key){return'\t'+getLinePrefix(t,key)+getLineContent(t,warnings,key)+'\r\n';};return warnings&&Object.keys(warnings).length>0?getTitleStr(t)+'\r\n\r\n'+(_ref='').concat.apply(_ref,_toConsumableArray(Object.keys(warnings).map(getLine))):'';}function getReportWrongLinesStr(wrongLines){return wrongLines.join("\r\n");}var ReportWarningList=function ReportWarningList(_ref2){var t=_ref2.t,warnings=_ref2.warnings;return warnings&&Object.keys(warnings).length>0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',title:getTitleStr(t),bodyStyle:{maxHeight:320,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a,{type:'info',showIcon:true,message:t('middlewares.feedback.alerts.onlyFirstErrorForRow')}),Object.keys(warnings).sort(function(k1,k2){return Number(getRow(k1))-Number(getRow(k2));}).map(function(key,index){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,getLinePrefix(t,key)),' ',getLineContent(t,warnings,key),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br',null));})):null;};/* harmony default export */ __webpack_exports__["a"] = (ReportWarningList);

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getReportInfoListStr;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportInfoList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_getErrorCodesTranslations__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getTitle(t){return t('middlewares.feedback.infoList.title');}function getLinePrefix(t,key){return(Object(__WEBPACK_IMPORTED_MODULE_2__constants_getErrorCodesTranslations__["a" /* getErrorCodesTranslations */])(t)[key]||t('errors.unknown',{code:key}))+': ';}function getLineContent(infos,key){return infos[key];}function getReportInfoListStr(t,infos){var _ref;var getLine=function getLine(key){return'\t'+getLinePrefix(t,key)+getLineContent(infos,key)+'\r\n';};return infos&&Object.keys(infos).length>0?getTitle(t)+'\r\n\r\n'+(_ref='').concat.apply(_ref,_toConsumableArray(Object.keys(infos).map(getLine))):'';}var ReportInfoList=function ReportInfoList(_ref2){var t=_ref2.t,infos=_ref2.infos;return infos&&Object.keys(infos).length>0&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',title:getTitle(t),bodyStyle:{maxHeight:160,overflow:'auto'}},Object.keys(infos).map(function(key,index){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,getLinePrefix(t,key)),' ',getLineContent(infos,key),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('br',null));}));};

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_saver__);
var StringDownloadButton=function StringDownloadButton(_ref){var str=_ref.str,fileName=_ref.fileName,mimeType=_ref.mimeType,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{icon:'download',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_3_file_saver___default.a.saveAs(new File([str],fileName,{type:mimeType+';charset=utf-8'}));}},children);};/* harmony default export */ __webpack_exports__["a"] = (StringDownloadButton);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(123);
var defaultCategorySchemeSelectorMiddleware=function defaultCategorySchemeSelectorMiddleware(_ref){var dispatch=_ref.dispatch;return function(next){return function(action){var result=next(action);if(action.type===__WEBPACK_IMPORTED_MODULE_0__api_actions__["b" /* REQUEST_ERROR */]&&action.error!==null&&action.error.errorCode==='DEF_CAT_SCHEME_EMPTY'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions__["l" /* showDefaultCategorySchemeSelector */])());}return result;};};};/* harmony default export */ __webpack_exports__["a"] = (defaultCategorySchemeSelectorMiddleware);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(188);
var spinnerMiddlewareFactory=function spinnerMiddlewareFactory(timeout){window.spinnerTimeout=null;return function(_ref){var getState=_ref.getState,dispatch=_ref.dispatch;return function(next){return function(action){var result=next(action);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SPINNER_ACTION_ADD */]:if(window.spinnerTimeout!==null){clearTimeout(window.spinnerTimeout);}break;case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* SPINNER_ACTION_COMPLETE */]:if(getState().middlewares.spinner.actions.filter(function(action){return!action.isCompleted;}).length===0){window.spinnerTimeout=setTimeout(function(){window.spinnerTimeout=null;dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* flushSpinnerActions */])());},timeout);}break;default:}return result;};};};};/* harmony default export */ __webpack_exports__["a"] = (spinnerMiddlewareFactory);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(527);
var newTabMiddleware=function newTabMiddleware(){return function(next){return function(action){if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* NEW_TAB_OPEN */]){window.open(action.url,'_blank');}return next(action);};};};/* harmony default export */ __webpack_exports__["a"] = (newTabMiddleware);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_config_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_paths__ = __webpack_require__(124);
var emptyNodesModalMiddlewareFactory=function emptyNodesModalMiddlewareFactory(i18next){return function(){return function(next){return function(action){var result=next(action);var t=i18next.t.bind(i18next);if(action.type===__WEBPACK_IMPORTED_MODULE_2__api_actions__["h" /* REQUEST_SUCCESS */]&&action.label===__WEBPACK_IMPORTED_MODULE_3__reducers_config_actions__["b" /* CONFIG_READ */]&&action.response.nodes.length===0){if(window.modal!==undefined){window.modal.destroy();}window.modal=__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('middlewares.emptyNodesModal.title'),content:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,t('middlewares.emptyNodesModal.content.text')+" ",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("a",{href:"./#"+__WEBPACK_IMPORTED_MODULE_5__constants_paths__["L" /* PATH_NODES_CONFIGURATION */],onClick:function onClick(){return window.modal.destroy();},style:{textDecoration:"underline"}},t('middlewares.emptyNodesModal.content.nodesConfigLink'))),onOk:function onOk(){window.open('./#','_self');},okText:t('commons.buttons.goHome.label')});}return result;};};};};/* harmony default export */ __webpack_exports__["a"] = (emptyNodesModalMiddlewareFactory);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_header_user_dropdown_actions__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_app_actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scenes_manage_users_set_permissions_actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_config_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SuperUserLoginForm__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__page_header_endpoint_dropdown_actions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scenes_meta_manager_metadataflows_actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scenes_meta_manager_dataflows_actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__scenes_data_manager_builder_cube_form_actions__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__scenes_configuration_app_config_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__page_utils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__default_category_scheme_selector_actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scenes_data_manager_builder_category_form_actions__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_easy_loading_actions__ = __webpack_require__(88);
var authenticationMiddlewareFactory=function authenticationMiddlewareFactory(i18next){return function(_ref){var getState=_ref.getState,dispatch=_ref.dispatch;return function(next){return function(action){var t=i18next.t.bind(i18next);var result=next(action);var type=action.type,label=action.label;if(getState().app.user.username&&(type===__WEBPACK_IMPORTED_MODULE_11__reducers_app_actions__["a" /* APP_ENDPOINT_SET */]||label===__WEBPACK_IMPORTED_MODULE_18__page_header_endpoint_dropdown_actions__["a" /* ENDPOINT_DROPDOWN_NODE_PING */]&&type===__WEBPACK_IMPORTED_MODULE_12__api_actions__["b" /* REQUEST_ERROR */])){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__page_header_user_dropdown_actions__["e" /* logoutUserDropdownUser */])());}if(type===__WEBPACK_IMPORTED_MODULE_11__reducers_app_actions__["e" /* APP_USER_CLEAR */]){__WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.warn(t('middlewares.authentication.messages.clear'));}if(getState().app.user.username&&type===__WEBPACK_IMPORTED_MODULE_12__api_actions__["h" /* REQUEST_SUCCESS */]&&(label===__WEBPACK_IMPORTED_MODULE_14__reducers_config_actions__["b" /* CONFIG_READ */]||label===__WEBPACK_IMPORTED_MODULE_10__page_header_user_dropdown_actions__["a" /* USER_DROPDOWN_USER_LOGIN */]||label===__WEBPACK_IMPORTED_MODULE_13__scenes_manage_users_set_permissions_actions__["h" /* SET_PERMISSIONS_PERMISSIONS_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_19__scenes_meta_manager_metadataflows_actions__["f" /* METADATAFLOWS_DETAIL_METADATAFLOW_CREATE_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_19__scenes_meta_manager_metadataflows_actions__["r" /* METADATAFLOWS_METADATAFLOW_CLONE_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_20__scenes_meta_manager_dataflows_actions__["F" /* DATAFLOWS_DETAIL_DATAFLOW_CREATE_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_20__scenes_meta_manager_dataflows_actions__["d" /* DATAFLOWS_DATAFLOW_CLONE_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_21__scenes_data_manager_builder_cube_form_actions__["d" /* BUILDER_CUBE_FORM_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_25__default_category_scheme_selector_actions__["d" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_26__scenes_data_manager_builder_category_form_actions__["c" /* BUILDER_CATEGORY_FORM_CREATE_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_26__scenes_data_manager_builder_category_form_actions__["d" /* BUILDER_CATEGORY_FORM_EDIT_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_27__components_easy_loading_actions__["s" /* EL_DATA_CREATE_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_27__components_easy_loading_actions__["r" /* EL_DATA_CREATE_FROM_FILE_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_27__components_easy_loading_actions__["q" /* EL_DATA_CREATE_FROM_DB_SUBMIT */])){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__reducers_app_actions__["l" /* readAppUserPermissions */])());}if(type===__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* SUPER_USER_LOGIN_FORM_SHOW */]){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.destroyAll();var modal=__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.info();modal.update({icon:'lock',title:__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"space-between"},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t('middlewares.authentication.superUserLoginModal.title')),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"close",onClick:function onClick(){modal.destroy();window.open('./#','_self');},style:{cursor:'pointer'}}))),content:__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SuperUserLoginForm__["a" /* default */],{t:t,modal:modal,onSubmit:function onSubmit(username,password){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* submitSuperUserLoginForm */])(username,password,action.onSuccessAction));}}),okButtonProps:{style:{display:'none'}},keyboard:false});}if(type===__WEBPACK_IMPORTED_MODULE_12__api_actions__["h" /* REQUEST_SUCCESS */]&&label===__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* SUPER_USER_LOGIN_FORM_SUBMIT */]){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.destroyAll();if(action.onSuccessAction||window.superUserModalOnSuccessAction){dispatch(action.onSuccessAction||window.superUserModalOnSuccessAction);window.superUserModalOnSuccessAction=undefined;}}if(type===__WEBPACK_IMPORTED_MODULE_12__api_actions__["b" /* REQUEST_ERROR */]&&label===__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* SUPER_USER_LOGIN_FORM_SUBMIT */]&&action.onSuccessAction){window.superUserModalOnSuccessAction=action.onSuccessAction;}if(type===__WEBPACK_IMPORTED_MODULE_12__api_actions__["b" /* REQUEST_ERROR */]&&(label===__WEBPACK_IMPORTED_MODULE_23__scenes_configuration_app_config_actions__["b" /* APP_CONFIG_CONFIG_READ */]||label===__WEBPACK_IMPORTED_MODULE_23__scenes_configuration_app_config_actions__["c" /* APP_CONFIG_CONFIG_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__["b" /* NODES_CONFIG_CONFIG_READ */]||label===__WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__["p" /* NODES_CONFIG_NODE_CONFIG_SUBMIT */]||label===__WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__["q" /* NODES_CONFIG_NODE_REMOVE */]||label===__WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__["r" /* NODES_CONFIG_NODE_SORT */]||label===__WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__["n" /* NODES_CONFIG_NODE_CHECK_ENDPOINT_NSI */]||label===__WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__["l" /* NODES_CONFIG_NODE_CHECK_ENDPOINT_MA */]||label===__WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__["k" /* NODES_CONFIG_NODE_CHECK_ENDPOINT_DM */]||label===__WEBPACK_IMPORTED_MODULE_22__scenes_configuration_nodes_config_actions__["d" /* NODES_CONFIG_MSDS_READ */])&&action.error&&action.error.errorCode==="UNAUTHORIZED"){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* logoutSuperUser */])());}if(type===__WEBPACK_IMPORTED_MODULE_12__api_actions__["h" /* REQUEST_SUCCESS */]&&label===__WEBPACK_IMPORTED_MODULE_10__page_header_user_dropdown_actions__["a" /* USER_DROPDOWN_USER_LOGIN */]&&Object(__WEBPACK_IMPORTED_MODULE_24__page_utils__["a" /* isClassificationsServer */])(action.response.username,action.response,getState().config.userInterface.anonymousPages,t)){window.open("./#/meta-manager/"+action.response.functionality[0],'_self');}if(type===__WEBPACK_IMPORTED_MODULE_12__api_actions__["h" /* REQUEST_SUCCESS */]&&label===__WEBPACK_IMPORTED_MODULE_10__page_header_user_dropdown_actions__["a" /* USER_DROPDOWN_USER_LOGIN */]&&getState().app.isEndpointAvailable===false){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__page_header_endpoint_dropdown_actions__["b" /* pingNode */])());}if(type===__WEBPACK_IMPORTED_MODULE_12__api_actions__["h" /* REQUEST_SUCCESS */]&&label===__WEBPACK_IMPORTED_MODULE_10__page_header_user_dropdown_actions__["b" /* USER_DROPDOWN_USER_LOGOUT */]&&getState().app.isEndpointAvailable===false){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__page_header_endpoint_dropdown_actions__["b" /* pingNode */])());}if(type===__WEBPACK_IMPORTED_MODULE_11__reducers_app_actions__["a" /* APP_ENDPOINT_SET */]&&(getState().app.user===null||getState().app.user.username===null)){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__page_header_endpoint_dropdown_actions__["b" /* pingNode */])());}return result;};};};};/* harmony default export */ __webpack_exports__["a"] = (authenticationMiddlewareFactory);

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_TWO_THIRDS"]}};var SuperUserLoginForm=function SuperUserLoginForm(_ref){var t=_ref.t,form=_ref.form,modal=_ref.modal,onSubmit=_ref.onSubmit;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"],marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.username.label')},formItemLayout),form.getFieldDecorator('username')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{autoComplete:'username'}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.password.label')},formItemLayout),form.getFieldDecorator('password')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{type:'password',autoComplete:'current-password'}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',gutter:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){modal.destroy();window.open('./#','_self');}},t('middlewares.authentication.superUserLoginModal.buttons.cancel.title'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:'primary',icon:'login',disabled:!form.getFieldValue('username')||form.getFieldValue('username').length<1||!form.getFieldValue('password')||form.getFieldValue('password').length<1,onClick:function onClick(){return onSubmit(form.getFieldValue('username'),form.getFieldValue('password'));},htmlType:'submit'},t('middlewares.authentication.superUserLoginModal.buttons.login.title')))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create())(SuperUserLoginForm));

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_css__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dsd_list__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dsd_list_actions__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cube_tree__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cube_form__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__category_form__ = __webpack_require__(1402);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDsdListShow:function onDsdListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__dsd_list_actions__["f" /* showBuilderDsdList */])());}};};var Builder=function Builder(_ref){var t=_ref.t,onDsdListShow=_ref.onDsdListShow;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__dsd_list__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'builder__cube-tree'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__cube_tree__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'end'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onDsdListShow,type:'primary'},t('scenes.dataManager.builder.dsdListShowButton.label')))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__cube_form__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__category_form__["a" /* default */],null))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(null,mapDispatchToProps))(Builder));

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducer__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_components_redux_dsd_detail_modal_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_artefact_list__ = __webpack_require__(50);
var mapStateToProps=function mapStateToProps(state){return{dsds:state.scenes.dataManager.builder.components.dsdList.dsds,isVisible:state.scenes.dataManager.builder.components.dsdList.isVisible,dsdListDsd:state.scenes.dataManager.builder.components.dsdList.dsdListDsd};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* hideBuilderDsdList */])());},onDsdShow:function onDsdShow(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__redux_components_redux_dsd_detail_modal_actions__["_72" /* showDsdDetail */])(dsdTriplet),__WEBPACK_IMPORTED_MODULE_12__reducer__["a" /* DM_BUILDER_DSD_LIST_PREFIX */]));},fetchDsds:function fetchDsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* readBuilderDsdListDsds */])());}};};var BuilderDsdList=function BuilderDsdList(_ref){var t=_ref.t,dsds=_ref.dsds,dsdListDsd=_ref.dsdListDsd,isVisible=_ref.isVisible,onHide=_ref.onHide,onDsdShow=_ref.onDsdShow,fetchDsds=_ref.fetchDsds;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_enhanced_modal__["a" /* default */],{visible:isVisible,onCancel:onHide,title:t('scenes.dataManager.builder.dsdList.title'),width:__WEBPACK_IMPORTED_MODULE_2__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchDsds},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_artefact_list__["a" /* default */],{artefacts:dsds,onDetailShow:onDsdShow})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_12__reducer__["a" /* DM_BUILDER_DSD_LIST_PREFIX */],instanceState:dsdListDsd}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(BuilderDsdList));

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ComponentForm__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ComponentList__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux__ = __webpack_require__(2);
var DSD_DETAIL_TAB_GENERAL='DSD_DETAIL_TAB_GENERAL';var DSD_DETAIL_TAB_PRIMARY_MEASURE='DSD_DETAIL_TAB_PRIMARY_MEASURE';var DSD_DETAIL_TAB_DIMENSIONS='DSD_DETAIL_TAB_DIMENSIONS';var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions};};var DsdDetail=function DsdDetail(_ref){var t=_ref.t,permissions=_ref.permissions,dsd=_ref.dsd,mode=_ref.mode,isComponentsDisabled=_ref.isComponentsDisabled,agencies=_ref.agencies,_ref$activeTab=_ref.activeTab,activeTab=_ref$activeTab===undefined?DSD_DETAIL_TAB_GENERAL:_ref$activeTab,onDimensionDetail=_ref.onDimensionDetail,onDimensionCreate=_ref.onDimensionCreate,onDimensionDelete=_ref.onDimensionDelete,onGroupDetail=_ref.onGroupDetail,onGroupCreate=_ref.onGroupCreate,onGroupDelete=_ref.onGroupDelete,onAttributeDetail=_ref.onAttributeDetail,onAttributeCreate=_ref.onAttributeCreate,onAttributeDelete=_ref.onAttributeDelete,onCodelistDetail=_ref.onCodelistDetail,onConceptDetail=_ref.onConceptDetail,onConceptSchemeDetail=_ref.onConceptSchemeDetail,onGeneralChange=_ref.onGeneralChange,onPrimaryMeasureChange=_ref.onPrimaryMeasureChange,onPrimaryMeasureConceptSelect=_ref.onPrimaryMeasureConceptSelect,onPrimaryMeasureCodelistSelect=_ref.onPrimaryMeasureCodelistSelect;var userHasPermissionsToEdit=permissions&&dsd&&permissions.agencies.filter(function(agency){return agency===dsd.agencyID;}).length>0;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a,{defaultActiveKey:activeTab,onTabClick:function onTabClick(key){return key==="categorisations"?__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.error({title:t('errors.notImplemented')}):null;}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane,{key:DSD_DETAIL_TAB_GENERAL,tab:t('components.dsdDetail.tabs.general.title')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["d" /* default */],{artefact:dsd,mode:mode,agencies:agencies,onChange:onGeneralChange,dsdDimensions:mode!==__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */]?dsd&&dsd.dimensions:undefined})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane,{key:DSD_DETAIL_TAB_PRIMARY_MEASURE,tab:t('components.dsdDetail.tabs.primaryMeasure.title')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ComponentForm__["e" /* default */],{component:dsd&&dsd.primaryMeasure,mode:isComponentsDisabled?__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]:mode,disableAnnotations:mode!==__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */]&&!userHasPermissionsToEdit,type:__WEBPACK_IMPORTED_MODULE_13__ComponentForm__["d" /* DSD_COMPONENT_TYPE_MEASURE */],onChange:onPrimaryMeasureChange,onConceptSelect:onPrimaryMeasureConceptSelect,onCodelistSelect:onPrimaryMeasureCodelistSelect})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane,{key:DSD_DETAIL_TAB_DIMENSIONS,tab:t('components.dsdDetail.tabs.dimensions.title')},onDimensionCreate&&!isComponentsDisabled&&mode!==__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'end'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',icon:'plus',onClick:onDimensionCreate},t('components.dsdDetail.buttons.createComponent')))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ComponentList__["a" /* default */],{mode:isComponentsDisabled?__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]:mode,type:__WEBPACK_IMPORTED_MODULE_13__ComponentForm__["b" /* DSD_COMPONENT_TYPE_DIMENSION */],onDetail:onDimensionDetail,onDelete:onDimensionDelete,onConceptDetail:onConceptDetail,onCodelistDetail:onCodelistDetail,onConceptSchemeDetail:onConceptSchemeDetail,components:dsd?dsd.dimensions||[]:null})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane,{key:'groups',tab:t('components.dsdDetail.tabs.groups.title')},onGroupCreate&&!isComponentsDisabled&&mode!==__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'end'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',icon:'plus',onClick:onGroupCreate},t('components.dsdDetail.buttons.createComponent')))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ComponentList__["a" /* default */],{mode:isComponentsDisabled?__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]:mode,type:__WEBPACK_IMPORTED_MODULE_13__ComponentForm__["c" /* DSD_COMPONENT_TYPE_GROUP */],onDetail:onGroupDetail,onDelete:onGroupDelete,components:dsd?dsd.groups||[]:null})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane,{key:'attributes',tab:t('components.dsdDetail.tabs.attributes.title')},onAttributeCreate&&!isComponentsDisabled&&mode!==__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'end'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',icon:'plus',onClick:onAttributeCreate},t('components.dsdDetail.buttons.createComponent')))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ComponentList__["a" /* default */],{mode:isComponentsDisabled?__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]:mode,type:__WEBPACK_IMPORTED_MODULE_13__ComponentForm__["a" /* DSD_COMPONENT_TYPE_ATTRIBUTE */],onDetail:onAttributeDetail,onDelete:onAttributeDelete,components:dsd?dsd.attributes||[]:null,onConceptDetail:onConceptDetail,onCodelistDetail:onCodelistDetail})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane,{key:'categorisations',tab:t('components.dsdDetail.tabs.categorisations.title')}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps))(DsdDetail));

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__multilanguage_zoomable_textarea__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__perf_input__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__ = __webpack_require__(37);
var formItemLayout={labelCol:{span:9},wrapperCol:{span:15}};var rowStyle={marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]};var mapPropsToFields=function mapPropsToFields(_ref){var annotations=_ref.annotations;return{annotations:annotations?annotations.map(function(annotation){return{id:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:annotation?annotation.id:null}),title:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:annotation?annotation.title:null}),type:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:annotation?annotation.type:null}),text:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:annotation&&annotation.text?annotation.text:null})};}):null};};var onFieldsChange=function onFieldsChange(props,fields){var newAnnotations=__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.cloneDeep(props.annotations);!props.disabled&&props.onChange({annotations:__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.merge(newAnnotations,fields.annotations.map(function(el){return __WEBPACK_IMPORTED_MODULE_17_lodash___default.a.mapValues(el,function(_ref2){var value=_ref2.value;return value;});}))});};var GenericAnnotationsForm=function GenericAnnotationsForm(_ref3){var t=_ref3.t,form=_ref3.form,annotations=_ref3.annotations,disabled=_ref3.disabled,onChange=_ref3.onChange,isOneLinePerField=_ref3.isOneLinePerField;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,annotations&&annotations.length>0?annotations.map(function(annotation,index){var oneLinePerFieldItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_THREE_QUARTERS"]}};var idField=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,Object.assign({label:t("data.annotation.id.label")},isOneLinePerField?oneLinePerFieldItemLayout:formItemLayout,{validateStatus:annotation&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,annotation.id).help?"warning":null,help:annotation&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,annotation.id).help}),form.getFieldDecorator("annotations["+index+"].id",{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,disabled:disabled,title:form.getFieldValue("annotations["+index+"].id"),style:{textTransform:"uppercase"}})));var titleField=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,Object.assign({label:t("data.annotation.title.label")},isOneLinePerField?oneLinePerFieldItemLayout:formItemLayout),form.getFieldDecorator("annotations["+index+"].title")(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,disabled:disabled,title:form.getFieldValue("annotations["+index+"].title")})));var typeField=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,Object.assign({label:t("data.annotation.type.label")},isOneLinePerField?oneLinePerFieldItemLayout:formItemLayout),form.getFieldDecorator("annotations["+index+"].type")(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,disabled:disabled,title:form.getFieldValue("annotations["+index+"].type")})));var textField=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{label:t("data.annotation.text.label"),labelCol:{span:isOneLinePerField?__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_ONE_QUARTER"]:3},wrapperCol:{span:isOneLinePerField?__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_THREE_QUARTERS"]:21}},form.getFieldDecorator("annotations["+index+"].text")(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_16__multilanguage_zoomable_textarea__["a" /* default */],disabled:disabled,title:form.getFieldValue("annotations["+index+"].text")})));return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{key:index,style:{marginTop:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},isOneLinePerField?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:rowStyle},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},idField)),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:rowStyle},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},titleField)),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:rowStyle},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},typeField)),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:rowStyle},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},textField))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:rowStyle},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_ONE_THIRD"]},idField),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_ONE_THIRD"]},titleField),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_ONE_THIRD"]},typeField)),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",style:{marginTop:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"],marginRight:1}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},textField))),!disabled&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{icon:"delete",disabled:annotations[index].type==='NonProductionDataflow',onClick:function onClick(){var newAnnotations=__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.cloneDeep(annotations);newAnnotations.splice(index,1);return onChange({annotations:newAnnotations});}},t("components.annotationsForm.cards.annotations.buttons.remove.title"))))));}):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__custom_empty__["a" /* default */],null)),!disabled&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{icon:"plus",onClick:function onClick(){var newAnnotations=__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.cloneDeep(annotations);if(!newAnnotations){newAnnotations=[];}newAnnotations.push({id:null,title:null,type:null,text:null});return onChange({annotations:newAnnotations});}},t("components.annotationsForm.cards.annotations.buttons.add.title"))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(__WEBPACK_IMPORTED_MODULE_14_react___default.a.memo(GenericAnnotationsForm,function(prevProps,nextProps){return __WEBPACK_IMPORTED_MODULE_17_lodash___default.a.isEqual(prevProps.annotations,nextProps.annotations);})));

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__multilanguage_zoomable_textarea__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["SPAN_THREE_QUARTERS"]}};var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var mapPropsToFields=function mapPropsToFields(_ref){var typesMap=_ref.typesMap;return{typesMap:typesMap?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapValues(typesMap,function(annot){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.createFormField({value:annot||null});}):{}};};var onFieldsChange=function onFieldsChange(props,fields){var newTypeMap=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(props.typesMap);!props.disabled&&props.onChange({typesMap:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.merge(newTypeMap,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapValues(fields.typesMap,function(_ref2){var value=_ref2.value;return value;}))});};var CustomAnnotationsForm=function CustomAnnotationsForm(_ref3){var form=_ref3.form,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,config=_ref3.config,disabled=_ref3.disabled;var annotationsToShow=config||[];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,annotationsToShow.length>0?annotationsToShow.map(function(_ref4,key){var name=_ref4.name,label=_ref4.label;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,Object.assign({key:key,label:Object(__WEBPACK_IMPORTED_MODULE_9__middlewares_i18n_utils__["a" /* getLocalizedStr */])(label,lang,dataLanguages)||name},formItemLayout),form.getFieldDecorator("typesMap."+name)(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__multilanguage_zoomable_textarea__["a" /* default */],{disabled:disabled})));}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__custom_empty__["a" /* default */],null));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps))(CustomAnnotationsForm));

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_assign__);

function _extends() {
  _extends = __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign___default.a || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1201);
module.exports = __webpack_require__(113).Object.assign;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(167);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1208) });


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1203);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(530);
var createDesc = __webpack_require__(1207);
module.exports = __webpack_require__(168) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(168) && !__webpack_require__(243)(function () {
  return Object.defineProperty(__webpack_require__(531)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(242);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(168);
var getKeys = __webpack_require__(244);
var gOPS = __webpack_require__(1217);
var pIE = __webpack_require__(538);
var toObject = __webpack_require__(539);
var IObject = __webpack_require__(533);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(243)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(532);
var toIObject = __webpack_require__(351);
var arrayIndexOf = __webpack_require__(1211)(false);
var IE_PROTO = __webpack_require__(536)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(351);
var toLength = __webpack_require__(1212);
var toAbsoluteIndex = __webpack_require__(1213);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(535);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(535);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(113);
var global = __webpack_require__(241);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(1215) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 1215 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCallback; });
/* unused harmony export useCallbackOne */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useMemo; });
/* unused harmony export useMemoOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var committed = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(initial);
  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = isInputMatch ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;




/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_create__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_create__);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = __WEBPACK_IMPORTED_MODULE_0__core_js_object_create___default()(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1221);

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1222);
var $Object = __webpack_require__(113).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(167);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(1223) });


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(350);
var dPs = __webpack_require__(1224);
var enumBugKeys = __webpack_require__(537);
var IE_PROTO = __webpack_require__(536)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(531)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1225).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(530);
var anObject = __webpack_require__(350);
var getKeys = __webpack_require__(244);

module.exports = __webpack_require__(168) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(241).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_batch__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__ = __webpack_require__(543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* unused harmony reexport ReactReduxContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* unused harmony reexport batch */
/* unused harmony reexport useDispatch */
/* unused harmony reexport useSelector */
/* unused harmony reexport useStore */
/* unused harmony reexport shallowEqual */










Object(__WEBPACK_IMPORTED_MODULE_7__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Context__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__ = __webpack_require__(352);







var Provider =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

  function Provider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var store = props.store;
    _this.notifySubscribers = _this.notifySubscribers.bind(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    var subscription = new __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* default */](store);
    subscription.onStateChange = _this.notifySubscribers;
    _this.state = {
      store: store,
      subscription: subscription
    };
    _this.previousState = store.getState();
    return _this;
  }

  var _proto = Provider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.state.subscription.trySubscribe();

    if (this.previousState !== this.props.store.getState()) {
      this.state.subscription.notifyNestedSubs();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this.state.subscription.tryUnsubscribe();
    this._isMounted = false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.store !== prevProps.store) {
      this.state.subscription.tryUnsubscribe();
      var subscription = new __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* default */](this.props.store);
      subscription.onStateChange = this.notifySubscribers;
      this.setState({
        store: this.props.store,
        subscription: subscription
      });
    }
  };

  _proto.notifySubscribers = function notifySubscribers() {
    this.state.subscription.notifyNestedSubs();
  };

  _proto.render = function render() {
    var Context = this.props.context || __WEBPACK_IMPORTED_MODULE_4__Context__["a" /* ReactReduxContext */];
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Context.Provider, {
      value: this.state
    }, this.props.children);
  };

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Provider.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    subscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    dispatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getState: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
  }),
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(172);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1234);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(544);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(544);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(545);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1235);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(546);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useDispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useStore__ = __webpack_require__(547);

/**
 * A hook to access the redux `dispatch` function. Note that in most cases where you
 * might want to use this hook it is recommended to use `useActions` instead to bind
 * action creators to the `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useReduxDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

function useDispatch() {
  var store = Object(__WEBPACK_IMPORTED_MODULE_0__useStore__["a" /* useStore */])();
  return store.dispatch;
}

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(352);



 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

var refEquality = function refEquality(a, b) {
  return a === b;
};
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */


function useSelector(selector, equalityFn) {
  if (equalityFn === void 0) {
    equalityFn = refEquality;
  }

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(selector, "You must pass a selector to useSelectors");

  var _useReduxContext = Object(__WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */])(),
      store = _useReduxContext.store,
      contextSub = _useReduxContext.subscription;

  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    var errorMessage = "An error occured while selecting the store state: " + err.message + ".";

    if (latestSubscriptionCallbackError.current) {
      errorMessage += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\nOriginal stack trace:";
    }

    throw new Error(errorMessage);
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return offset; });
/* unused harmony export shrink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_invariant__ = __webpack_require__(540);


var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ?  false ? invariant(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : Object(__WEBPACK_IMPORTED_MODULE_0_tiny_invariant__["a" /* default */])(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};




/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1241);

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1242);
module.exports = __webpack_require__(113).Object.values;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(167);
var $values = __webpack_require__(1243)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(168);
var getKeys = __webpack_require__(244);
var toIObject = __webpack_require__(351);
var isEnum = __webpack_require__(538).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1245);

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1246);
module.exports = __webpack_require__(113).Object.keys;


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(539);
var $keys = __webpack_require__(244);

__webpack_require__(1247)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(167);
var core = __webpack_require__(113);
var fails = __webpack_require__(243);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1249);

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1250);
module.exports = __webpack_require__(113).Date.now;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(167);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

/* harmony default export */ __webpack_exports__["a"] = (rafSchd);


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1253);

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1254);
module.exports = __webpack_require__(113).Number.isInteger;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(167);

$export($export.S, 'Number', { isInteger: __webpack_require__(1255) });


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(242);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHtmlTableString; });
var JSONSTAT_TABLE_PREVIEW_PLACEHOLDER="xxx";var JSONSTAT_TABLE_SECTION_DIMENSIONS_SEPARATOR='<svg height="6px" width="6px" fill="#00295a"><path d="M 0 0 H 6 V 6 H 0 Z"/></svg>';var getHtmlTableString=function getHtmlTableString(rows,cols,sections){/** HTML generating **/var table='<table>';/** table head **/table+='<thead>';cols.forEach(function(col,idx){table+='<tr data-row-key="h-'+idx+'">';table+='<th class="c ch" colspan="'+rows.length+'">'+col+'</th>';for(var c=0;c<3;c++){table+='<th class="c csh">'+JSONSTAT_TABLE_PREVIEW_PLACEHOLDER+'</th>';}table+='</tr>';});if(rows.length>0){table+='<tr data-row-key="hh">';rows.forEach(function(row){return table+='<th class="c ch">'+row+'</th>';});table+='<th class="c csh" colspan="'+(cols.length>0?3:1)+'"/>';table+='</tr>';}table+='</thead>';/** table body **/table+='<tbody id="body">';if(sections&&sections.length>0){table+='<tr data-row-key="s-0" class="rs">';var sectionLabel="";sections.forEach(function(section,idx){sectionLabel+='<div style="display: inline-block;">'+section+': '+JSONSTAT_TABLE_PREVIEW_PLACEHOLDER+'</div>';sectionLabel+=idx<sections.length-1?'<div style="display: inline-block; margin: 0 8px">'+JSONSTAT_TABLE_SECTION_DIMENSIONS_SEPARATOR+'</div>':'';});table+='<th class="c cs" colspan="'+((rows.length||1)+(cols.length>0?3:1))+'">'+sectionLabel+'</th>';table+='</tr>';}for(var r=0;r<(rows.length>0?3:1);r++){table+='<tr data-row-key="r-'+r+'">';if(rows.length>0){for(var rr=0;rr<rows.length;rr++){table+='<th class="c csh">'+JSONSTAT_TABLE_PREVIEW_PLACEHOLDER+'</th>';}}else{table+='<th class="c csh">&nbsp;</th>';}for(var c=0;c<(cols.length>0?3:1);c++){table+='<td class="c"/>';}table+='</tr>';}table+='</tbody>';table+='</table>';return table;};

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_css__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__annotations_form_DefaultTableLayout__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GeneralParameters__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__annotations_form_NotDisplayed__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__annotations_form_Default__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__annotations_form_DefaultChartLayout__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DefaultMapLayout__ = __webpack_require__(556);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var LAYOUT_ANNOTATIONS_FORM_TAB_NOT_DISPLAYED_ITEMS_KEY="LAYOUT_ANNOTATIONS_FORM_TAB_NOT_DISPLAYED_ITEMS_KEY";var LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_ITEMS_KEY="LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_ITEMS_KEY";var LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_TABLE_LAYOUT_KEY="LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_TABLE_LAYOUT_KEY";var LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_CHART_LAYOUT_KEY="LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_CHART_LAYOUT_KEY";var LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_MAP_LAYOUT_KEY="LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_MAP_LAYOUT_KEY";var LAYOUT_ANNOTATIONS_FORM_TAB_GENERAL_PARAMS_KEY="LAYOUT_ANNOTATIONS_FORM_TAB_GENERAL_PARAMS_KEY";var LayoutAnnotationsForm=function LayoutAnnotationsForm(_ref,ref){var t=_ref.t,disabled=_ref.disabled,dsdDimensions=_ref.dsdDimensions,dsdAttributes=_ref.dsdAttributes,endpoints=_ref.endpoints,endpointId=_ref.endpointId,annotations=_ref.annotations,itemsPage=_ref.itemsPage,isOnlyFileDataflow=_ref.isOnlyFileDataflow,isVirtualDataflow=_ref.isVirtualDataflow,fetchItemsPage=_ref.fetchItemsPage,resetItemsPage=_ref.resetItemsPage,valuesForLayoutAnnotations=_ref.valuesForLayoutAnnotations,fetchValuesForLayoutAnnotations=_ref.fetchValuesForLayoutAnnotations,resetValuesForLayoutAnnotations=_ref.resetValuesForLayoutAnnotations;var annotationTabsConfig=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].annotationTabs.tabs;var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;var _useState=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["v" /* getGenericAnnotations */])(annotations,annotationTabsConfig,annotationsConfig))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(annotations,annotationTabsConfig)))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["O" /* getLayoutAnnotations */])(annotations,annotationsConfig))))),_useState2=_slicedToArray(_useState,2),tempAnnotations=_useState2[0],setTempAnnotations=_useState2[1];var generalParamsRef=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])();var defaultMapLayoutRef=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])();Object(__WEBPACK_IMPORTED_MODULE_6_react__["useImperativeHandle"])(ref,function(){return{submit:function submit(cb){generalParamsRef.current.submit(tempAnnotations,function(res1){if(defaultMapLayoutRef.current){defaultMapLayoutRef.current.submit(res1,function(res2){return cb(res2);});}else{cb(res1);}});}};});var tempLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["O" /* getLayoutAnnotations */])(tempAnnotations,annotationsConfig);var generalParameters=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__GeneralParameters__["a" /* default */],{t:t,disabled:disabled,dsdDimensions:dsdDimensions,annotationsConfig:annotationsConfig,annotations:tempAnnotations,isOnlyFileDataflow:isOnlyFileDataflow,ref:generalParamsRef});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"layout-annotations-form"},(annotations||[]).find(function(annot){return annot.title&&annot.title.length>4000;})&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a,{type:"warning",showIcon:true,message:t("components.layoutAnnotationsForm.alerts.titleTooLong"),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]}}),isOnlyFileDataflow||isVirtualDataflow?generalParameters:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:LAYOUT_ANNOTATIONS_FORM_TAB_NOT_DISPLAYED_ITEMS_KEY,tab:t('components.layoutAnnotationsForm.tabs.notDisplayedItems.title')},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__annotations_form_NotDisplayed__["a" /* default */],{disabled:disabled,dsdDimensions:dsdDimensions,dsdAttributes:dsdAttributes,layoutAnnotations:tempLayoutAnnotations,onChange:function onChange(_ref2){var layoutAnnotations=_ref2.layoutAnnotations;return setTempAnnotations([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["v" /* getGenericAnnotations */])(tempAnnotations,annotationTabsConfig,annotationsConfig))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(tempAnnotations,annotationTabsConfig)))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(layoutAnnotations))));},annotationsConfig:annotationsConfig,fetchItemsPage:fetchItemsPage,itemsPage:itemsPage,resetItemsPage:resetItemsPage}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_ITEMS_KEY,tab:t('components.layoutAnnotationsForm.tabs.defaultItems.title')},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__annotations_form_Default__["a" /* default */],{disabled:disabled,dsdDimensions:dsdDimensions,layoutAnnotations:tempLayoutAnnotations,onChange:function onChange(_ref3){var layoutAnnotations=_ref3.layoutAnnotations;return setTempAnnotations([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["v" /* getGenericAnnotations */])(tempAnnotations,annotationTabsConfig,annotationsConfig))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(tempAnnotations,annotationTabsConfig)))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(layoutAnnotations))));},annotationsConfig:annotationsConfig,fetchItemsPage:fetchItemsPage,itemsPage:itemsPage,resetItemsPage:resetItemsPage,valuesForLayoutAnnotations:valuesForLayoutAnnotations,fetchValuesForLayoutAnnotations:fetchValuesForLayoutAnnotations,resetValuesForLayoutAnnotations:resetValuesForLayoutAnnotations}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_TABLE_LAYOUT_KEY,tab:t('components.layoutAnnotationsForm.tabs.defaultTableLayout.title')},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__annotations_form_DefaultTableLayout__["a" /* default */],{disabled:disabled,dsdDimensions:dsdDimensions,annotationsConfig:annotationsConfig,layoutAnnotations:tempLayoutAnnotations,onChange:function onChange(_ref4){var layoutAnnotations=_ref4.layoutAnnotations;return setTempAnnotations([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["v" /* getGenericAnnotations */])(tempAnnotations,annotationTabsConfig,annotationsConfig))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(tempAnnotations,annotationTabsConfig)))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(layoutAnnotations))));}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_CHART_LAYOUT_KEY,tab:t('components.layoutAnnotationsForm.tabs.defaultChartLayout.title')},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__annotations_form_DefaultChartLayout__["a" /* default */],{disabled:disabled,dsdDimensions:dsdDimensions,annotationsConfig:annotationsConfig,layoutAnnotations:tempLayoutAnnotations,onChange:function onChange(_ref5){var layoutAnnotations=_ref5.layoutAnnotations;return setTempAnnotations([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["v" /* getGenericAnnotations */])(tempAnnotations,annotationTabsConfig,annotationsConfig))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["t" /* getCustomAnnotationsFromTabsMap */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["u" /* getCustomAnnotationsTabsMap */])(tempAnnotations,annotationTabsConfig)))),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(layoutAnnotations))));}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:LAYOUT_ANNOTATIONS_FORM_TAB_DEFAULT_MAP_LAYOUT_KEY,tab:t('components.layoutAnnotationsForm.tabs.defaultMapLayout.title'),forceRender:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__DefaultMapLayout__["a" /* default */],{t:t,disabled:disabled,dsdDimensions:dsdDimensions,annotationsConfig:annotationsConfig,annotations:tempAnnotations,ref:defaultMapLayoutRef}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:LAYOUT_ANNOTATIONS_FORM_TAB_GENERAL_PARAMS_KEY,tab:t('components.layoutAnnotationsForm.tabs.generalParameters.title'),forceRender:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,null,generalParameters))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react__["forwardRef"])(LayoutAnnotationsForm));

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_hook_form_dist_react_hook_form_ie11__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_hook_form_dist_react_hook_form_ie11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_hook_form_dist_react_hook_form_ie11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__multilanguage_tags_select__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__multilanguage_zoomable_textarea__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__form_list__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AttachedDataFileForm__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__data_language_selector__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_use_custom_compare_effect_lib__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_use_custom_compare_effect_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_use_custom_compare_effect_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]}};var DEFAULT_PRESENTATION_OPTION_TABLE='Table';var DEFAULT_PRESENTATION_OPTION_GRAPH='Graph';var DEFAULT_PRESENTATION_OPTION_MAP='Map';var getDefaultPresentationTranslations=function getDefaultPresentationTranslations(t){var defaultPresentationTranslations=function defaultPresentationTranslations(t){var _ref;return _ref={},_defineProperty(_ref,DEFAULT_PRESENTATION_OPTION_TABLE,t('layoutAnnotations.defaultPresentation.table')),_defineProperty(_ref,DEFAULT_PRESENTATION_OPTION_GRAPH,t('layoutAnnotations.defaultPresentation.graph')),_defineProperty(_ref,DEFAULT_PRESENTATION_OPTION_MAP,t('layoutAnnotations.defaultPresentation.map')),_ref;};return defaultPresentationTranslations(t!==undefined?t:function(str){return str;});};var CRITERIA_SELECTION_OPTION_ALL_FULL='FullAll';var CRITERIA_SELECTION_OPTION_ALL_PARTIAL='PartialAll';var CRITERIA_SELECTION_OPTION_STEP_BY_STEP_DYNAMIC='Dynamic';var CRITERIA_SELECTION_OPTION_STEP_BY_STEP_FULL='FullStep';var CRITERIA_SELECTION_OPTION_STEP_BY_STEP_PARTIAL='PartialStep';var getCriteriaSelectionTranslations=function getCriteriaSelectionTranslations(t){var criteriaSelectionTranslations=function criteriaSelectionTranslations(t){var _ref2;return _ref2={},_defineProperty(_ref2,CRITERIA_SELECTION_OPTION_ALL_FULL,t('layoutAnnotations.criteriaSelection.allFull')),_defineProperty(_ref2,CRITERIA_SELECTION_OPTION_ALL_PARTIAL,t('layoutAnnotations.criteriaSelection.allPartial')),_defineProperty(_ref2,CRITERIA_SELECTION_OPTION_STEP_BY_STEP_DYNAMIC,t('layoutAnnotations.criteriaSelection.stepByStepDynamic')),_defineProperty(_ref2,CRITERIA_SELECTION_OPTION_STEP_BY_STEP_FULL,t('layoutAnnotations.criteriaSelection.stepByStepFull')),_defineProperty(_ref2,CRITERIA_SELECTION_OPTION_STEP_BY_STEP_PARTIAL,t('layoutAnnotations.criteriaSelection.stepByStepPartial')),_ref2;};return criteriaSelectionTranslations(t!==undefined?t:function(str){return str;});};var GeneralParameters=function GeneralParameters(_ref3){var t=_ref3.t,forwardedRef=_ref3.forwardedRef,disabled=_ref3.disabled,annotations=_ref3.annotations,annotationsConfig=_ref3.annotationsConfig,dataLanguage=_ref3.dataLanguage,appLanguage=_ref3.appLanguage,isOnlyFileDataflow=_ref3.isOnlyFileDataflow;var _useState=Object(__WEBPACK_IMPORTED_MODULE_16_react__["useState"])(dataLanguage||appLanguage),_useState2=_slicedToArray(_useState,2),attachedDataFilesLanguage=_useState2[0],setAttachedDataFilesLanguage=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_16_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["z" /* getLayoutAnnotationDataflowKeywords */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["x" /* getLayoutAnnotationCriteriaSelection */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["G" /* getLayoutAnnotationDefaultPresentation */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["w" /* getLayoutAnnotationAttachedDataFiles */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["C" /* getLayoutAnnotationDecimalSeparator */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["L" /* getLayoutAnnotationNumberOfDecimals */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["M" /* getLayoutAnnotationReferenceMetadata */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["I" /* getLayoutAnnotationEmptyCellPlaceholder */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["A" /* getLayoutAnnotationDataflowNotes */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["B" /* getLayoutAnnotationDataflowSource */])(annotations,annotationsConfig)!==null||Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["y" /* getLayoutAnnotationDataflowHidden */])(annotations,annotationsConfig)===true),_useState4=_slicedToArray(_useState3,2),flagSaveAnnotation=_useState4[0],setFlagSaveAnnotation=_useState4[1];var _useForm=Object(__WEBPACK_IMPORTED_MODULE_18_react_hook_form_dist_react_hook_form_ie11__["useForm"])({defaultValues:{dataflowKeywords:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["z" /* getLayoutAnnotationDataflowKeywords */])(annotations,annotationsConfig),criteriaSelection:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["x" /* getLayoutAnnotationCriteriaSelection */])(annotations,annotationsConfig),defaultPresentation:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["G" /* getLayoutAnnotationDefaultPresentation */])(annotations,annotationsConfig),attachedDataFiles:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["w" /* getLayoutAnnotationAttachedDataFiles */])(annotations,annotationsConfig)||{},decimalSeparator:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["C" /* getLayoutAnnotationDecimalSeparator */])(annotations,annotationsConfig),numberOfDecimals:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["L" /* getLayoutAnnotationNumberOfDecimals */])(annotations,annotationsConfig),referenceMetadata:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["M" /* getLayoutAnnotationReferenceMetadata */])(annotations,annotationsConfig),emptyCellPlaceholder:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["I" /* getLayoutAnnotationEmptyCellPlaceholder */])(annotations,annotationsConfig),dataflowNotes:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["A" /* getLayoutAnnotationDataflowNotes */])(annotations,annotationsConfig),dataflowSource:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["B" /* getLayoutAnnotationDataflowSource */])(annotations,annotationsConfig),dataflowHidden:Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["y" /* getLayoutAnnotationDataflowHidden */])(annotations,annotationsConfig)}}),register=_useForm.register,watch=_useForm.watch,setValue=_useForm.setValue,handleSubmit=_useForm.handleSubmit;__WEBPACK_IMPORTED_MODULE_28_use_custom_compare_effect_lib___default()(function(){var form=watch();if(form.dataflowKeywords!==null&&Object.keys(form.dataflowKeywords).length>0||form.criteriaSelection!==null||form.defaultPresentation!==null||form.attachedDataFiles!==null&&Object.keys(form.attachedDataFiles).length>0||form.decimalSeparator!==null||form.numberOfDecimals!==null||form.referenceMetadata!==null||form.emptyCellPlaceholder!==null||form.dataflowNotes!==null||form.dataflowSource!==null||form.dataflowHidden===true){setFlagSaveAnnotation(true);}},[watch()],__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.isEqual);Object(__WEBPACK_IMPORTED_MODULE_16_react__["useEffect"])(function(){register({name:'dataflowKeywords'});register({name:'criteriaSelection'});register({name:'attachedDataFiles'});register({name:'defaultPresentation'});register({name:'decimalSeparator'});register({name:'numberOfDecimals'});register({name:'referenceMetadata'});register({name:'emptyCellPlaceholder'});register({name:'dataflowNotes'});register({name:'dataflowSource'});register({name:'dataflowHidden'});},[]);Object(__WEBPACK_IMPORTED_MODULE_16_react__["useImperativeHandle"])(forwardedRef,function(){return{submit:function submit(annotations,cb){handleSubmit(function(val){var newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["T" /* setLayoutAnnotationDataflowKeywords */])(annotations,annotationsConfig,flagSaveAnnotation?val.dataflowKeywords:[]);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["R" /* setLayoutAnnotationCriteriaSelection */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.criteriaSelection:null);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["Q" /* setLayoutAnnotationAttachedDataFiles */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.attachedDataFiles:{});newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["_0" /* setLayoutAnnotationDefaultPresentation */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.defaultPresentation:null);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["W" /* setLayoutAnnotationDecimalSeparator */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.decimalSeparator:null);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["_5" /* setLayoutAnnotationNumberOfDecimals */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.numberOfDecimals:null);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["_6" /* setLayoutAnnotationReferenceMetadata */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.referenceMetadata:null);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["_2" /* setLayoutAnnotationEmptyCellPlaceholder */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.emptyCellPlaceholder:null);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["U" /* setLayoutAnnotationDataflowNotes */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.dataflowNotes:null);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["V" /* setLayoutAnnotationDataflowSource */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.dataflowSource:null);newLayoutAnnotations=Object(__WEBPACK_IMPORTED_MODULE_21__utils_annotations__["S" /* setLayoutAnnotationDataflowHidden */])(newLayoutAnnotations,annotationsConfig,flagSaveAnnotation?val.dataflowHidden:false);cb(newLayoutAnnotations);})();}};});return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,!disabled&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,null,t("components.layoutAnnotationsForm.generalParameters.flagSaveAnnotation.title"),":"),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default.a,{checked:flagSaveAnnotation,onChange:function onChange(e){return setFlagSaveAnnotation(e.target.checked);}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__["b" /* DataLanguageProvider */],{value:null},isOnlyFileDataflow?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutDataflowKeywords.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__multilanguage_tags_select__["a" /* default */],{disabled:disabled,value:watch('dataflowKeywords'),onChange:function onChange(val){return setValue('dataflowKeywords',val);}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutReferenceMetadata.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__multilanguage_zoomable_textarea__["a" /* default */],{placeholder:t('components.urlInput.placeholder.title'),singleLine:true,disabled:disabled,title:watch('referenceMetadata'),value:watch('referenceMetadata'),onChange:function onChange(val){return setValue('referenceMetadata',val);}})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutDataflowNotes.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__multilanguage_zoomable_textarea__["a" /* default */],{placeholder:t('components.urlInput.placeholder.title'),singleLine:true,disabled:disabled,title:watch('dataflowNotes'),value:watch('dataflowNotes'),onChange:function onChange(val){return setValue('dataflowNotes',val);}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutDataflowSource.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__multilanguage_zoomable_textarea__["a" /* default */],{placeholder:t('components.urlInput.placeholder.title'),singleLine:true,disabled:disabled,title:watch('dataflowSource'),value:watch('dataflowSource'),onChange:function onChange(val){return setValue('dataflowSource',val);}}))))):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutDataflowKeywords.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__multilanguage_tags_select__["a" /* default */],{disabled:disabled,value:watch('dataflowKeywords'),onChange:function onChange(val){return setValue('dataflowKeywords',val);}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutCriteriaSelection.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{disabled:disabled,title:watch('criteriaSelection'),value:watch('criteriaSelection'),onChange:function onChange(val){return setValue('criteriaSelection',val);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:null,title:t('layoutAnnotations.empty')},t('layoutAnnotations.empty')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CRITERIA_SELECTION_OPTION_ALL_FULL,title:getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_ALL_FULL]},getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_ALL_FULL]),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CRITERIA_SELECTION_OPTION_ALL_PARTIAL,title:getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_ALL_PARTIAL]},getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_ALL_PARTIAL]),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CRITERIA_SELECTION_OPTION_STEP_BY_STEP_DYNAMIC,title:getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_STEP_BY_STEP_DYNAMIC]},getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_STEP_BY_STEP_DYNAMIC]),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CRITERIA_SELECTION_OPTION_STEP_BY_STEP_FULL,title:getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_STEP_BY_STEP_FULL]},getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_STEP_BY_STEP_FULL]),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CRITERIA_SELECTION_OPTION_STEP_BY_STEP_PARTIAL,title:getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_STEP_BY_STEP_PARTIAL]},getCriteriaSelectionTranslations(t)[CRITERIA_SELECTION_OPTION_STEP_BY_STEP_PARTIAL]))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutDefaultPresentation.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{disabled:disabled,title:watch('defaultPresentation'),value:watch('defaultPresentation'),onChange:function onChange(val){return setValue('defaultPresentation',val);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:null,title:t('layoutAnnotations.empty')},t('layoutAnnotations.empty')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:DEFAULT_PRESENTATION_OPTION_TABLE,title:getDefaultPresentationTranslations(t)[DEFAULT_PRESENTATION_OPTION_TABLE]},getDefaultPresentationTranslations(t)[DEFAULT_PRESENTATION_OPTION_TABLE]),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:DEFAULT_PRESENTATION_OPTION_GRAPH,title:getDefaultPresentationTranslations(t)[DEFAULT_PRESENTATION_OPTION_GRAPH]},getDefaultPresentationTranslations(t)[DEFAULT_PRESENTATION_OPTION_GRAPH]),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:DEFAULT_PRESENTATION_OPTION_MAP,title:getDefaultPresentationTranslations(t)[DEFAULT_PRESENTATION_OPTION_MAP]},getDefaultPresentationTranslations(t)[DEFAULT_PRESENTATION_OPTION_MAP])))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutDecimalSeparator.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{disabled:disabled,title:watch('decimalSeparator'),value:watch('decimalSeparator'),onChange:function onChange(val){return setValue('decimalSeparator',val);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:null,title:t('layoutAnnotations.empty')},t('layoutAnnotations.empty')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:"."},"."),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:","},","))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutNumberOfDecimals.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default.a,{style:{width:"100%"},min:0,precision:0,disabled:disabled,title:watch('numberOfDecimals'),value:watch('numberOfDecimals'),onChange:function onChange(val){return setValue('numberOfDecimals',val);}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutReferenceMetadata.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__multilanguage_zoomable_textarea__["a" /* default */],{placeholder:t('components.urlInput.placeholder.title'),singleLine:true,disabled:disabled,title:watch('referenceMetadata'),value:watch('referenceMetadata'),onChange:function onChange(val){return setValue('referenceMetadata',val);}})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutEmptyCellPlaceholder.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{disabled:disabled,title:watch('emptyCellPlaceholder'),value:watch('emptyCellPlaceholder'),onChange:function onChange(e){return setValue('emptyCellPlaceholder',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutHidden.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default.a,{disabled:disabled,title:watch("dataflowHidden"),checked:watch('dataflowHidden'),onChange:function onChange(e){return setValue('dataflowHidden',e.target.checked);}})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutDataflowNotes.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__multilanguage_zoomable_textarea__["a" /* default */],{placeholder:t('components.urlInput.placeholder.title'),singleLine:true,disabled:disabled,title:watch('dataflowNotes'),value:watch('dataflowNotes'),onChange:function onChange(val){return setValue('dataflowNotes',val);}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.nodesConfig.annotations.layoutDataflowSource.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__multilanguage_zoomable_textarea__["a" /* default */],{placeholder:t('components.urlInput.placeholder.title'),singleLine:true,disabled:disabled,title:watch('dataflowSource'),value:watch('dataflowSource'),onChange:function onChange(val){return setValue('dataflowSource',val);}}))))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner",style:{marginTop:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:"flex",justify:"space-between"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.annotations.layoutAttachedDataFiles.label')})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__data_language_selector__["a" /* default */],{value:attachedDataFilesLanguage,size:"small",onSelect:function onSelect(selected){return setAttachedDataFilesLanguage(selected);}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__form_list__["a" /* default */],{compact:true,disabled:disabled,values:watch('attachedDataFiles')[attachedDataFilesLanguage]||[],Component:__WEBPACK_IMPORTED_MODULE_24__AttachedDataFileForm__["a" /* default */],newItem:{format:null,url:null},addItemLabel:t('components.layoutAnnotationsForm.generalParameters.attachedDataFiles.modal.addButton.title'),removeItemLabel:t('components.layoutAnnotationsForm.generalParameters.attachedDataFiles.modal.removeButton.title'),onChange:function onChange(val){var newAttachedDataFiles=watch('attachedDataFiles');newAttachedDataFiles[attachedDataFilesLanguage]=val;setValue('attachedDataFiles',newAttachedDataFiles);setFlagSaveAnnotation(true);}})));};var ConnectedGeneralParameters=Object(__WEBPACK_IMPORTED_MODULE_27_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__["c" /* withDataLanguage */])(),Object(__WEBPACK_IMPORTED_MODULE_26_react_redux__["b" /* connect */])(function(state){return{appLanguage:state.app.language};}))(GeneralParameters);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react__["forwardRef"])(function(props,ref){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(ConnectedGeneralParameters,Object.assign({},props,{forwardedRef:ref}));}));

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_is_negative_zero__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_is_negative_zero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_is_negative_zero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InputHandler__ = __webpack_require__(1263);












function noop() {}

function preventDefault(e) {
  e.preventDefault();
}

function defaultParser(input) {
  return input.replace(/[^\w\.-]+/g, '');
}

/**
 * When click and hold on a button - the speed of auto changin the value.
 */
var SPEED = 200;

/**
 * When click and hold on a button - the delay before auto changin the value.
 */
var DELAY = 600;

/**
 * Max Safe Integer -- on IE this is not available, so manually set the number in that case.
 * The reason this is used, instead of Infinity is because numbers above the MSI are unstable
 */
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var InputNumber = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputNumber, _React$Component);

  function InputNumber(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputNumber);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var value = void 0;
    if ('value' in props) {
      value = props.value;
    } else {
      value = props.defaultValue;
    }
    value = _this.toNumber(value);

    _this.state = {
      inputValue: _this.toPrecisionAsStep(value),
      value: value,
      focused: props.autoFocus
    };
    return _this;
  }

  InputNumber.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate();
  };

  InputNumber.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps && nextProps.value !== this.props.value) {
      var value = this.state.focused ? nextProps.value : this.getValidValue(nextProps.value, nextProps.min, nextProps.max);
      this.setState({
        value: value,
        inputValue: this.inputting ? value : this.toPrecisionAsStep(value)
      });
    }

    // Trigger onChange when max or min change
    // https://github.com/ant-design/ant-design/issues/11574
    var nextValue = 'value' in nextProps ? nextProps.value : this.state.value;
    var _props = this.props,
        onChange = _props.onChange,
        max = _props.max,
        min = _props.min;
    // ref: null < 20 === true
    // https://github.com/ant-design/ant-design/issues/14277

    if ('max' in nextProps && nextProps.max !== max && typeof nextValue === 'number' && nextValue > nextProps.max && onChange) {
      onChange(nextProps.max);
    }
    if ('min' in nextProps && nextProps.min !== min && typeof nextValue === 'number' && nextValue < nextProps.min && onChange) {
      onChange(nextProps.min);
    }
  };

  InputNumber.prototype.componentDidUpdate = function componentDidUpdate() {
    // Restore cursor
    try {
      // Firefox set the input cursor after it get focused.
      // This caused that if an input didn't init with the selection,
      // set will cause cursor not correct when first focus.
      // Safari will focus input if set selection. We need skip this.
      if (this.cursorStart !== undefined && this.state.focused) {
        // In most cases, the string after cursor is stable.
        // We can move the cursor before it

        if (
        // If not match full str, try to match part of str
        !this.partRestoreByAfter(this.cursorAfter) && this.state.value !== this.props.value) {
          // If not match any of then, let's just keep the position
          // TODO: Logic should not reach here, need check if happens
          var pos = this.cursorStart + 1;

          // If not have last string, just position to the end
          if (!this.cursorAfter) {
            pos = this.input.value.length;
          } else if (this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
            pos = this.cursorStart - 1;
          } else if (this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__["a" /* default */].DELETE) {
            pos = this.cursorStart;
          }
          this.fixCaret(pos, pos);
        } else if (this.currentValue === this.input.value) {
          // Handle some special key code
          switch (this.lastKeyCode) {
            case __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__["a" /* default */].BACKSPACE:
              this.fixCaret(this.cursorStart - 1, this.cursorStart - 1);
              break;
            case __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__["a" /* default */].DELETE:
              this.fixCaret(this.cursorStart + 1, this.cursorStart + 1);
              break;
            default:
            // Do nothing
          }
        }
      }
    } catch (e) {}
    // Do nothing


    // Reset last key
    this.lastKeyCode = null;

    // pressingUpOrDown is true means that someone just click up or down button
    if (!this.pressingUpOrDown) {
      return;
    }
    if (this.props.focusOnUpDown && this.state.focused) {
      if (document.activeElement !== this.input) {
        this.focus();
      }
    }

    this.pressingUpOrDown = false;
  };

  InputNumber.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stop();
  };

  InputNumber.prototype.getCurrentValidValue = function getCurrentValidValue(value) {
    var val = value;
    if (val === '') {
      val = '';
    } else if (!this.isNotCompleteNumber(parseFloat(val, 10))) {
      val = this.getValidValue(val);
    } else {
      val = this.state.value;
    }
    return this.toNumber(val);
  };

  InputNumber.prototype.getRatio = function getRatio(e) {
    var ratio = 1;
    if (e.metaKey || e.ctrlKey) {
      ratio = 0.1;
    } else if (e.shiftKey) {
      ratio = 10;
    }
    return ratio;
  };

  InputNumber.prototype.getValueFromEvent = function getValueFromEvent(e) {
    // optimize for chinese input expierence
    // https://github.com/ant-design/ant-design/issues/8196
    var value = e.target.value.trim().replace(/。/g, '.');

    if ('decimalSeparator' in this.props) {
      value = value.replace(this.props.decimalSeparator, '.');
    }

    return value;
  };

  InputNumber.prototype.getValidValue = function getValidValue(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.min;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.max;

    var val = parseFloat(value, 10);
    // https://github.com/ant-design/ant-design/issues/7358
    if (isNaN(val)) {
      return value;
    }
    if (val < min) {
      val = min;
    }
    if (val > max) {
      val = max;
    }
    return val;
  };

  InputNumber.prototype.setValue = function setValue(v, callback) {
    // trigger onChange
    var newValue = this.isNotCompleteNumber(parseFloat(v, 10)) ? undefined : parseFloat(v, 10);
    var changed = newValue !== this.state.value || '' + newValue !== '' + this.state.inputValue; // https://github.com/ant-design/ant-design/issues/7363
    if (!('value' in this.props)) {
      this.setState({
        value: newValue,
        inputValue: this.toPrecisionAsStep(v)
      }, callback);
    } else {
      // always set input value same as value
      this.setState({
        inputValue: this.toPrecisionAsStep(this.state.value)
      }, callback);
    }
    if (changed) {
      this.props.onChange(newValue);
    }
  };

  InputNumber.prototype.getPrecision = function getPrecision(value) {
    if ('precision' in this.props) {
      return this.props.precision;
    }
    var valueString = value.toString();
    if (valueString.indexOf('e-') >= 0) {
      return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
    }
    var precision = 0;
    if (valueString.indexOf('.') >= 0) {
      precision = valueString.length - valueString.indexOf('.') - 1;
    }
    return precision;
  };

  // step={1.0} value={1.51}
  // press +
  // then value should be 2.51, rather than 2.5
  // if this.props.precision is undefined
  // https://github.com/react-component/input-number/issues/39


  InputNumber.prototype.getMaxPrecision = function getMaxPrecision(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    if ('precision' in this.props) {
      return this.props.precision;
    }
    var step = this.props.step;

    var ratioPrecision = this.getPrecision(ratio);
    var stepPrecision = this.getPrecision(step);
    var currentValuePrecision = this.getPrecision(currentValue);
    if (!currentValue) {
      return ratioPrecision + stepPrecision;
    }
    return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
  };

  InputNumber.prototype.getPrecisionFactor = function getPrecisionFactor(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var precision = this.getMaxPrecision(currentValue, ratio);
    return Math.pow(10, precision);
  };

  InputNumber.prototype.fixCaret = function fixCaret(start, end) {
    if (start === undefined || end === undefined || !this.input || !this.input.value) {
      return;
    }

    try {
      var currentStart = this.input.selectionStart;
      var currentEnd = this.input.selectionEnd;

      if (start !== currentStart || end !== currentEnd) {
        this.input.setSelectionRange(start, end);
      }
    } catch (e) {
      // Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  };

  InputNumber.prototype.focus = function focus() {
    this.input.focus();
    this.recordCursorPosition();
  };

  InputNumber.prototype.blur = function blur() {
    this.input.blur();
  };

  InputNumber.prototype.formatWrapper = function formatWrapper(num) {
    // http://2ality.com/2012/03/signedzero.html
    // https://github.com/ant-design/ant-design/issues/9439
    if (__WEBPACK_IMPORTED_MODULE_8_is_negative_zero___default()(num)) {
      return '-0';
    }
    if (this.props.formatter) {
      return this.props.formatter(num);
    }
    return num;
  };

  InputNumber.prototype.toPrecisionAsStep = function toPrecisionAsStep(num) {
    if (this.isNotCompleteNumber(num) || num === '') {
      return num;
    }
    var precision = Math.abs(this.getMaxPrecision(num));
    if (precision === 0) {
      return num.toString();
    }
    if (!isNaN(precision)) {
      return Number(num).toFixed(precision);
    }
    return num.toString();
  };

  // '1.' '1x' 'xx' '' => are not complete numbers


  InputNumber.prototype.isNotCompleteNumber = function isNotCompleteNumber(num) {
    return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
  };

  InputNumber.prototype.toNumber = function toNumber(num) {
    if (this.isNotCompleteNumber(num)) {
      return num;
    }
    if ('precision' in this.props) {
      return Number(Number(num).toFixed(this.props.precision));
    }
    return Number(num);
  };

  // '1.0' '1.00'  => may be a inputing number


  InputNumber.prototype.toNumberWhenUserInput = function toNumberWhenUserInput(num) {
    // num.length > 16 => prevent input large number will became Infinity
    if ((/\.\d*0$/.test(num) || num.length > 16) && this.state.focused) {
      return num;
    }
    return this.toNumber(num);
  };

  InputNumber.prototype.upStep = function upStep(val, rat) {
    var _props2 = this.props,
        step = _props2.step,
        min = _props2.min;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = void 0;
    if (typeof val === 'number') {
      result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    } else {
      result = min === -Infinity ? step : min;
    }
    return this.toNumber(result);
  };

  InputNumber.prototype.downStep = function downStep(val, rat) {
    var _props3 = this.props,
        step = _props3.step,
        min = _props3.min;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = void 0;
    if (typeof val === 'number') {
      result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    } else {
      result = min === -Infinity ? -step : min;
    }
    return this.toNumber(result);
  };

  InputNumber.prototype.step = function step(type, e) {
    var _this2 = this;

    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var recursive = arguments[3];

    this.stop();
    if (e) {
      e.persist();
      e.preventDefault();
    }
    var props = this.props;
    if (props.disabled) {
      return;
    }
    var value = this.getCurrentValidValue(this.state.inputValue) || 0;
    if (this.isNotCompleteNumber(value)) {
      return;
    }
    var val = this[type + 'Step'](value, ratio);
    var outOfRange = val > props.max || val < props.min;
    if (val > props.max) {
      val = props.max;
    } else if (val < props.min) {
      val = props.min;
    }
    this.setValue(val);
    this.setState({
      focused: true
    });
    if (outOfRange) {
      return;
    }
    this.autoStepTimer = setTimeout(function () {
      _this2[type](e, ratio, true);
    }, recursive ? SPEED : DELAY);
  };

  InputNumber.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props);

    var prefixCls = props.prefixCls,
        disabled = props.disabled,
        readOnly = props.readOnly,
        useTouch = props.useTouch,
        autoComplete = props.autoComplete,
        upHandler = props.upHandler,
        downHandler = props.downHandler,
        rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'disabled', 'readOnly', 'useTouch', 'autoComplete', 'upHandler', 'downHandler']);

    var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()((_classNames = {}, _classNames[prefixCls] = true, _classNames[props.className] = !!props.className, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-focused'] = this.state.focused, _classNames));
    var upDisabledClass = '';
    var downDisabledClass = '';
    var value = this.state.value;

    if (value || value === 0) {
      if (!isNaN(value)) {
        var val = Number(value);
        if (val >= props.max) {
          upDisabledClass = prefixCls + '-handler-up-disabled';
        }
        if (val <= props.min) {
          downDisabledClass = prefixCls + '-handler-down-disabled';
        }
      } else {
        upDisabledClass = prefixCls + '-handler-up-disabled';
        downDisabledClass = prefixCls + '-handler-down-disabled';
      }
    }

    var dataOrAriaAttributeProps = {};
    for (var key in props) {
      if (props.hasOwnProperty(key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
        dataOrAriaAttributeProps[key] = props[key];
      }
    }

    var editable = !props.readOnly && !props.disabled;

    // focus state, show input value
    // unfocus state, show valid value
    var inputDisplayValue = this.getInputDisplayValue();

    var upEvents = void 0;
    var downEvents = void 0;
    if (useTouch) {
      upEvents = {
        onTouchStart: editable && !upDisabledClass ? this.up : noop,
        onTouchEnd: this.stop
      };
      downEvents = {
        onTouchStart: editable && !downDisabledClass ? this.down : noop,
        onTouchEnd: this.stop
      };
    } else {
      upEvents = {
        onMouseDown: editable && !upDisabledClass ? this.up : noop,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
      downEvents = {
        onMouseDown: editable && !downDisabledClass ? this.down : noop,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
    }

    var inputDisplayValueFormat = this.formatWrapper(inputDisplayValue);
    if ('decimalSeparator' in this.props) {
      inputDisplayValueFormat = inputDisplayValueFormat.toString().replace('.', this.props.decimalSeparator);
    }
    var isUpDisabled = !!upDisabledClass || disabled || readOnly;
    var isDownDisabled = !!downDisabledClass || disabled || readOnly;
    // ref for test
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      {
        className: classes,
        style: props.style,
        title: props.title,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseOver: props.onMouseOver,
        onMouseOut: props.onMouseOut
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-handler-wrap' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__InputHandler__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            ref: this.saveUp,
            disabled: isUpDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, upEvents, {
            role: 'button',
            'aria-label': 'Increase Value',
            'aria-disabled': !!isUpDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-up ' + upDisabledClass
          }),
          upHandler || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-up-inner',
            onClick: preventDefault
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__InputHandler__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            ref: this.saveDown,
            disabled: isDownDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, downEvents, {
            role: 'button',
            'aria-label': 'Decrease Value',
            'aria-disabled': !!isDownDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-down ' + downDisabledClass
          }),
          downHandler || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-down-inner',
            onClick: preventDefault
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: prefixCls + '-input-wrap',
          role: 'spinbutton',
          'aria-valuemin': props.min,
          'aria-valuemax': props.max,
          'aria-valuenow': value
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          required: props.required,
          type: props.type,
          placeholder: props.placeholder,
          onClick: props.onClick,
          onMouseUp: this.onMouseUp,
          className: prefixCls + '-input',
          tabIndex: props.tabIndex,
          autoComplete: autoComplete,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onKeyDown: editable ? this.onKeyDown : noop,
          onKeyUp: editable ? this.onKeyUp : noop,
          autoFocus: props.autoFocus,
          maxLength: props.maxLength,
          readOnly: props.readOnly,
          disabled: props.disabled,
          max: props.max,
          min: props.min,
          step: props.step,
          name: props.name,
          id: props.id,
          onChange: this.onChange,
          ref: this.saveInput,
          value: inputDisplayValueFormat,
          pattern: props.pattern
        }, dataOrAriaAttributeProps))
      )
    );
  };

  return InputNumber;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

InputNumber.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  focusOnUpDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  step: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  upHandler: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  downHandler: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  useTouch: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  formatter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  parser: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  precision: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  required: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pattern: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  decimalSeparator: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
InputNumber.defaultProps = {
  focusOnUpDown: true,
  useTouch: false,
  prefixCls: 'rc-input-number',
  min: -MAX_SAFE_INTEGER,
  step: 1,
  style: {},
  onChange: noop,
  onKeyDown: noop,
  onFocus: noop,
  onBlur: noop,
  parser: defaultParser,
  required: false,
  autoComplete: 'off'
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onKeyDown = function (e) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var onKeyDown = _this3.props.onKeyDown;


    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__["a" /* default */].UP) {
      var ratio = _this3.getRatio(e);
      _this3.up(e, ratio);
      _this3.stop();
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      var _ratio = _this3.getRatio(e);
      _this3.down(e, _ratio);
      _this3.stop();
    }

    // Trigger user key down
    _this3.recordCursorPosition();
    _this3.lastKeyCode = e.keyCode;
    if (onKeyDown) {
      onKeyDown.apply(undefined, [e].concat(args));
    }
  };

  this.onKeyUp = function (e) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var onKeyUp = _this3.props.onKeyUp;


    _this3.stop();

    _this3.recordCursorPosition();

    // Trigger user key up
    if (onKeyUp) {
      onKeyUp.apply(undefined, [e].concat(args));
    }
  };

  this.onChange = function (e) {
    if (_this3.state.focused) {
      _this3.inputting = true;
    }
    var input = _this3.props.parser(_this3.getValueFromEvent(e));
    _this3.setState({ inputValue: input });
    _this3.props.onChange(_this3.toNumberWhenUserInput(input)); // valid number or invalid string
  };

  this.onMouseUp = function () {
    var onMouseUp = _this3.props.onMouseUp;


    _this3.recordCursorPosition();

    if (onMouseUp) {
      onMouseUp.apply(undefined, arguments);
    }
  };

  this.onFocus = function () {
    var _props4;

    _this3.setState({
      focused: true
    });
    (_props4 = _this3.props).onFocus.apply(_props4, arguments);
  };

  this.onBlur = function (e) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    _this3.inputting = false;
    _this3.setState({
      focused: false
    });
    var value = _this3.getCurrentValidValue(_this3.state.inputValue);
    e.persist(); // fix https://github.com/react-component/input-number/issues/51
    _this3.setValue(value, function () {
      var _props5;

      (_props5 = _this3.props).onBlur.apply(_props5, [e].concat(args));
    });
  };

  this.getInputDisplayValue = function () {
    var _state = _this3.state,
        focused = _state.focused,
        inputValue = _state.inputValue,
        value = _state.value;

    var inputDisplayValue = void 0;
    if (focused) {
      inputDisplayValue = inputValue;
    } else {
      inputDisplayValue = _this3.toPrecisionAsStep(value);
    }

    if (inputDisplayValue === undefined || inputDisplayValue === null) {
      inputDisplayValue = '';
    }

    return inputDisplayValue;
  };

  this.recordCursorPosition = function () {
    // Record position
    try {
      _this3.cursorStart = _this3.input.selectionStart;
      _this3.cursorEnd = _this3.input.selectionEnd;
      _this3.currentValue = _this3.input.value;
      _this3.cursorBefore = _this3.input.value.substring(0, _this3.cursorStart);
      _this3.cursorAfter = _this3.input.value.substring(_this3.cursorEnd);
    } catch (e) {
      // Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  };

  this.restoreByAfter = function (str) {
    if (str === undefined) return false;

    var fullStr = _this3.input.value;
    var index = fullStr.lastIndexOf(str);

    if (index === -1) return false;

    if (index + str.length === fullStr.length) {
      _this3.fixCaret(index, index);

      return true;
    }
    return false;
  };

  this.partRestoreByAfter = function (str) {
    if (str === undefined) return false;

    // For loop from full str to the str with last char to map. e.g. 123
    // -> 123
    // -> 23
    // -> 3
    return Array.prototype.some.call(str, function (_, start) {
      var partStr = str.substring(start);

      return _this3.restoreByAfter(partStr);
    });
  };

  this.stop = function () {
    if (_this3.autoStepTimer) {
      clearTimeout(_this3.autoStepTimer);
    }
  };

  this.down = function (e, ratio, recursive) {
    _this3.pressingUpOrDown = true;
    _this3.step('down', e, ratio, recursive);
  };

  this.up = function (e, ratio, recursive) {
    _this3.pressingUpOrDown = true;
    _this3.step('up', e, ratio, recursive);
  };

  this.saveUp = function (node) {
    _this3.upHandler = node;
  };

  this.saveDown = function (node) {
    _this3.downHandler = node;
  };

  this.saveInput = function (node) {
    _this3.input = node;
  };
};

/* harmony default export */ __webpack_exports__["default"] = (InputNumber);

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isNegativeZero(number) {
	return number === 0 && (1 / number) === -Infinity;
};



/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rmc_feedback__ = __webpack_require__(1264);








var InputHandler = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InputHandler, _Component);

  function InputHandler() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InputHandler);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  InputHandler.prototype.render = function render() {
    var _props = this.props,
        prefixCls = _props.prefixCls,
        disabled = _props.disabled,
        otherProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'disabled']);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_rmc_feedback__["a" /* default */],
      {
        disabled: disabled,
        activeClassName: prefixCls + '-handler-active'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', otherProps)
    );
  };

  return InputHandler;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

InputHandler.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchEnd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (InputHandler);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__ = __webpack_require__(1265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__["a"]; });


/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);








var TouchFeedback = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TouchFeedback, _React$Component);

    function TouchFeedback() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TouchFeedback);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.onTouchStart = function (e) {
            _this.triggerEvent('TouchStart', true, e);
        };
        _this.onTouchMove = function (e) {
            _this.triggerEvent('TouchMove', false, e);
        };
        _this.onTouchEnd = function (e) {
            _this.triggerEvent('TouchEnd', false, e);
        };
        _this.onTouchCancel = function (e) {
            _this.triggerEvent('TouchCancel', false, e);
        };
        _this.onMouseDown = function (e) {
            // pc simulate mobile
            _this.triggerEvent('MouseDown', true, e);
        };
        _this.onMouseUp = function (e) {
            _this.triggerEvent('MouseUp', false, e);
        };
        _this.onMouseLeave = function (e) {
            _this.triggerEvent('MouseLeave', false, e);
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TouchFeedback, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'triggerEvent',
        value: function triggerEvent(type, isActive, ev) {
            var eventType = 'on' + type;
            var children = this.props.children;

            if (children.props[eventType]) {
                children.props[eventType](ev);
            }
            if (isActive !== this.state.active) {
                this.setState({
                    active: isActive
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                activeClassName = _props.activeClassName,
                activeStyle = _props.activeStyle;

            var events = disabled ? undefined : {
                onTouchStart: this.onTouchStart,
                onTouchMove: this.onTouchMove,
                onTouchEnd: this.onTouchEnd,
                onTouchCancel: this.onTouchCancel,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            var child = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle !== false) {
                    if (activeStyle) {
                        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, activeStyle);
                    }
                    className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, activeClassName);
                }
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: className,
                    style: style }, events));
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, events);
        }
    }]);

    return TouchFeedback;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TouchFeedback);

TouchFeedback.defaultProps = {
    disabled: false
};

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_flag_icon_css_css_flag_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_languages__ = __webpack_require__(91);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var MultilanguageTagsSelect=function(_React$Component){_inherits(MultilanguageTagsSelect,_React$Component);function MultilanguageTagsSelect(props){_classCallCheck(this,MultilanguageTagsSelect);var _this=_possibleConstructorReturn(this,(MultilanguageTagsSelect.__proto__||Object.getPrototypeOf(MultilanguageTagsSelect)).call(this,props));_this.state=MultilanguageTagsSelect.getInitState(props);_this.callOnChange=_this.callOnChange.bind(_this);_this.setLanguage=_this.setLanguage.bind(_this);_this.setValueForLanguage=_this.setValueForLanguage.bind(_this);return _this;}_createClass(MultilanguageTagsSelect,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){this.props.onChange(value);}}},{key:'setLanguage',value:function setLanguage(lang){var state=Object.assign({},this.state);state.language=lang;this.setState(state);this.callOnChange(state.value);}},{key:'setValueForLanguage',value:function setValueForLanguage(newValue,language){var state=Object.assign({},this.state);state.value[language]=newValue;this.setState(state);this.callOnChange(state.value);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,disabled=_props.disabled,dataLanguages=_props.dataLanguages;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(contextDataLanguage){var language=contextDataLanguage||_this2.state.language;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a.Group,{compact:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{mode:'tags',value:value[language],onChange:function onChange(selected){return _this2.setValueForLanguage(selected,language);},title:value[language],disabled:disabled,style:{width:contextDataLanguage?'100%':'calc(100% - 100px)'}}),!contextDataLanguage&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{value:language,onChange:_this2.setLanguage,style:{width:100}},value&&Object.keys(value).map(function(lang){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{key:lang,value:lang,title:Object(__WEBPACK_IMPORTED_MODULE_11__utils_languages__["c" /* getLanguageLabel */])(t,lang)},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',{className:'flag-icon '+Object(__WEBPACK_IMPORTED_MODULE_11__utils_languages__["b" /* getLanguageFlagIconCss */])(lang,dataLanguages),style:{marginRight:8}}),lang!==null?lang.toUpperCase():null);})));});}}],[{key:'getInitState',value:function getInitState(props){return{value:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.fromPairs(props.dataLanguages.map(function(_ref){var code=_ref.code;return[code,[]];})),language:(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(props.dataLanguages,function(_ref2){var code=_ref2.code;return code===props.appLanguage;})||{}).code||'en',isInitialized:false};}},{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){if(props.value!==null){if(!state.isInitialized){return{value:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.merge(state.value,props.value),isInitialized:true};}else{return state;}}else{return MultilanguageTagsSelect.getInitState(props);}}}]);return MultilanguageTagsSelect;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps))(MultilanguageTagsSelect));

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcCollapse = _interopRequireDefault(__webpack_require__(553));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _CollapsePanel = _interopRequireDefault(__webpack_require__(1273));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _configProvider = __webpack_require__(35);

var _openAnimation = _interopRequireDefault(__webpack_require__(319));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Collapse, _React$Component);

  function Collapse() {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapse).apply(this, arguments));

    _this.renderExpandIcon = function () {
      return React.createElement(_icon["default"], {
        type: "right",
        className: "arrow"
      });
    };

    _this.renderCollapse = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          bordered = _this$props.bordered;
      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
      var collapseClassName = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-borderless"), !bordered), className);
      return React.createElement(_rcCollapse["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        className: collapseClassName,
        expandIcon: _this.renderExpandIcon
      }));
    };

    return _this;
  }

  _createClass(Collapse, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapse);
    }
  }]);

  return Collapse;
}(React.Component);

exports["default"] = Collapse;
Collapse.Panel = _CollapsePanel["default"];
Collapse.defaultProps = {
  bordered: true,
  openAnimation: _extends({}, _openAnimation["default"], {
    appear: function appear() {}
  })
};

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Panel__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__openAnimationFactory__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function toArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
  }
  return currentActiveKey;
}

var Collapse = function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    var _this$props = _this.props,
        activeKey = _this$props.activeKey,
        defaultActiveKey = _this$props.defaultActiveKey;

    var currentActiveKey = defaultActiveKey;
    if ('activeKey' in _this.props) {
      currentActiveKey = activeKey;
    }

    _this.state = {
      openAnimation: _this.props.openAnimation || Object(__WEBPACK_IMPORTED_MODULE_3__openAnimationFactory__["a" /* default */])(_this.props.prefixCls),
      activeKey: toArray(currentActiveKey)
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: toArray(nextProps.activeKey)
        });
      }
      if ('openAnimation' in nextProps) {
        this.setState({
          openAnimation: nextProps.openAnimation
        });
      }
    }
  }, {
    key: 'onClickItem',
    value: function onClickItem(key) {
      var activeKey = this.state.activeKey;
      if (this.props.accordion) {
        activeKey = activeKey[0] === key ? [] : [key];
      } else {
        activeKey = [].concat(_toConsumableArray(activeKey));
        var index = activeKey.indexOf(key);
        var isActive = index > -1;
        if (isActive) {
          // remove active state
          activeKey.splice(index, 1);
        } else {
          activeKey.push(key);
        }
      }
      this.setActiveKey(activeKey);
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var activeKey = this.state.activeKey;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          accordion = _props.accordion,
          destroyInactivePanel = _props.destroyInactivePanel,
          expandIcon = _props.expandIcon,
          children = _props.children;

      var newChildren = [];
      var childList = Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isFragment"])(children) ? children.props.children : children;

      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(childList, function (child, index) {
        if (!child) return;
        // If there is no key provide, use the panel order as default key
        var key = child.key || String(index);
        var _child$props = child.props,
            header = _child$props.header,
            headerClass = _child$props.headerClass,
            disabled = _child$props.disabled;

        var isActive = false;
        if (accordion) {
          isActive = activeKey[0] === key;
        } else {
          isActive = activeKey.indexOf(key) > -1;
        }

        var props = {
          key: key,
          header: header,
          headerClass: headerClass,
          isActive: isActive,
          prefixCls: prefixCls,
          destroyInactivePanel: destroyInactivePanel,
          openAnimation: _this2.state.openAnimation,
          accordion: accordion,
          children: child.props.children,
          onItemClick: disabled ? null : function () {
            return _this2.onClickItem(key);
          },
          expandIcon: expandIcon
        };

        newChildren.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, props));
      });
      //  ref: https://github.com/ant-design/ant-design/issues/13884
      if (Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isFragment"])(children)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          newChildren
        );
      }

      return newChildren;
    }
  }, {
    key: 'setActiveKey',
    value: function setActiveKey(activeKey) {
      if (!('activeKey' in this.props)) {
        this.setState({ activeKey: activeKey });
      }
      this.props.onChange(this.props.accordion ? activeKey[0] : activeKey);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          className = _props2.className,
          style = _props2.style,
          accordion = _props2.accordion;

      var collapseClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: collapseClassName, style: style, role: accordion ? 'tablist' : null },
        this.getItems()
      );
    }
  }]);

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  accordion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  expandIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Collapse.defaultProps = {
  prefixCls: 'rc-collapse',
  onChange: function onChange() {},

  accordion: false,
  destroyInactivePanel: false
};

Collapse.Panel = __WEBPACK_IMPORTED_MODULE_2__Panel__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContent__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_animate__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CollapsePanel = function (_Component) {
  _inherits(CollapsePanel, _Component);

  function CollapsePanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CollapsePanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function () {
      if (_this.props.onItemClick) {
        _this.props.onItemClick();
      }
    }, _this.handleKeyPress = function (e) {
      if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
        _this.handleItemClick();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CollapsePanel, [{
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props = this.props,
          className = _props.className,
          id = _props.id,
          style = _props.style,
          prefixCls = _props.prefixCls,
          header = _props.header,
          headerClass = _props.headerClass,
          children = _props.children,
          isActive = _props.isActive,
          showArrow = _props.showArrow,
          destroyInactivePanel = _props.destroyInactivePanel,
          disabled = _props.disabled,
          accordion = _props.accordion,
          forceRender = _props.forceRender,
          expandIcon = _props.expandIcon;

      var headerCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
      var itemCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);

      var icon = null;
      if (showArrow && typeof expandIcon === 'function') {
        icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(expandIcon, _extends({}, this.props));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: itemCls, style: style, id: id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: headerCls,
            onClick: this.handleItemClick,
            role: accordion ? 'tab' : 'button',
            tabIndex: disabled ? -1 : 0,
            'aria-expanded': '' + isActive,
            onKeyPress: this.handleKeyPress
          },
          showArrow && (icon || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'arrow' })),
          header
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_rc_animate__["default"],
          {
            showProp: 'isActive',
            exclusive: true,
            component: '',
            animation: this.props.openAnimation
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__PanelContent__["a" /* default */],
            {
              prefixCls: prefixCls,
              isActive: isActive,
              destroyInactivePanel: destroyInactivePanel,
              forceRender: forceRender,
              role: accordion ? 'tabpanel' : null
            },
            children
          )
        )
      );
    }
  }]);

  return CollapsePanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CollapsePanel.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  headerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onItemClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  accordion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  expandIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

CollapsePanel.defaultProps = {
  showArrow: true,
  isActive: false,
  destroyInactivePanel: false,
  onItemClick: function onItemClick() {},

  headerClass: '',
  forceRender: false
};

/* harmony default export */ __webpack_exports__["a"] = (CollapsePanel);

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PanelContent = function (_Component) {
  _inherits(PanelContent, _Component);

  function PanelContent() {
    _classCallCheck(this, PanelContent);

    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
  }

  _createClass(PanelContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.forceRender || this.props.isActive || nextProps.isActive;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      this._isActived = this.props.forceRender || this._isActived || this.props.isActive;
      if (!this._isActived) {
        return null;
      }
      var _props = this.props,
          prefixCls = _props.prefixCls,
          isActive = _props.isActive,
          children = _props.children,
          destroyInactivePanel = _props.destroyInactivePanel,
          forceRender = _props.forceRender,
          role = _props.role;

      var contentCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
      var child = !forceRender && !isActive && destroyInactivePanel ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: prefixCls + '-content-box' },
        children
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: contentCls,
          role: role
        },
        child
      );
    }
  }]);

  return PanelContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PanelContent.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (PanelContent);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_animation__ = __webpack_require__(293);


function animate(node, show, transitionName, done) {
  var height = void 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0_css_animation__["default"])(node, transitionName, {
    start: function start() {
      if (!show) {
        node.style.height = node.offsetHeight + 'px';
      } else {
        height = node.offsetHeight;
        node.style.height = 0;
      }
    },
    active: function active() {
      node.style.height = (show ? height : 0) + 'px';
    },
    end: function end() {
      node.style.height = '';
      done();
    }
  });
}

function animation(prefixCls) {
  return {
    enter: function enter(node, done) {
      return animate(node, true, prefixCls + '-anim', done);
    },
    leave: function leave(node, done) {
      return animate(node, false, prefixCls + '-anim', done);
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (animation);

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcCollapse = _interopRequireDefault(__webpack_require__(553));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CollapsePanel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CollapsePanel, _React$Component);

  function CollapsePanel() {
    var _this;

    _classCallCheck(this, CollapsePanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CollapsePanel).apply(this, arguments));

    _this.renderCollapsePanel = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          _this$props$showArrow = _this$props.showArrow,
          showArrow = _this$props$showArrow === void 0 ? true : _this$props$showArrow;
      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
      var collapsePanelClassName = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-no-arrow"), !showArrow), className);
      return React.createElement(_rcCollapse["default"].Panel, _extends({}, _this.props, {
        prefixCls: prefixCls,
        className: collapsePanelClassName
      }));
    };

    return _this;
  }

  _createClass(CollapsePanel, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapsePanel);
    }
  }]);

  return CollapsePanel;
}(React.Component);

exports["default"] = CollapsePanel;

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zoomable_textarea__ = __webpack_require__(232);
var mapPropsToFields=function mapPropsToFields(_ref){var value=_ref.value;return{url:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:value!==null?value.url:null}),format:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:value!==null?value.format:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var AttachedDataFileForm=function AttachedDataFileForm(_ref3){var t=_ref3.t,disabled=_ref3.disabled,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a,{layout:"inline"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("components.layoutAnnotationsForm.generalParameters.attachedDataFileForm.url"),style:{marginBottom:0},className:'form-item-required'},form.getFieldDecorator("url")(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__zoomable_textarea__["a" /* default */],{disabled:disabled,placeholder:t('components.urlInput.placeholder.title'),singleLine:true,multilanguage:false,title:form.getFieldValue("url")}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("components.layoutAnnotationsForm.generalParameters.attachedDataFileForm.format"),style:{marginBottom:0},className:'form-item-required'},form.getFieldDecorator("format")(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{disabled:disabled,title:form.getFieldValue("format")}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(AttachedDataFileForm));

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

function useCustomCompareMemo(value, equal) {
  var ref = (0, _react.useRef)(value);

  if (!equal(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

function useCustomCompareEffect(create, input, equal) {
  (0, _react.useEffect)(create, [useCustomCompareMemo(input, equal)]);
}

var _default = useCustomCompareEffect;
exports["default"] = _default;

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_components_redux_dsd_detail_modal_dsd_detail_ComponentForm__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__item_list__ = __webpack_require__(84);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language};};var NotDisplayed=function(_React$Component){_inherits(NotDisplayed,_React$Component);function NotDisplayed(props){_classCallCheck(this,NotDisplayed);var _this2=_possibleConstructorReturn(this,(NotDisplayed.__proto__||Object.getPrototypeOf(NotDisplayed)).call(this,props));_this2.state={isEditTableVisible:false,tempEditTableChecked:null,codesEditTableId:null,tempCodesEditTableChecked:null,codelistTriplet:null};_this2.onEditTableShow=_this2.onEditTableShow.bind(_this2);_this2.onEditTableHide=_this2.onEditTableHide.bind(_this2);_this2.onEditTableChange=_this2.onEditTableChange.bind(_this2);_this2.onSubmit=_this2.onSubmit.bind(_this2);_this2.onCodesEditTableShow=_this2.onCodesEditTableShow.bind(_this2);_this2.onCodesEditTableHide=_this2.onCodesEditTableHide.bind(_this2);_this2.onCodesEditTableChange=_this2.onCodesEditTableChange.bind(_this2);return _this2;}_createClass(NotDisplayed,[{key:"onEditTableShow",value:function onEditTableShow(){this.setState({isEditTableVisible:true,tempEditTableChecked:Object.keys(Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(this.props.layoutAnnotations,this.props.annotationsConfig))});}},{key:"onEditTableHide",value:function onEditTableHide(){this.setState({isEditTableVisible:false,tempEditTableChecked:null});}},{key:"onSubmit",value:function onSubmit(){var _this3=this;var codesEditTableId=this.state.codesEditTableId;var notDisplayed={};var oldNotDisplayed=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(this.props.layoutAnnotations,this.props.annotationsConfig);(this.state.tempEditTableChecked||Object.keys(oldNotDisplayed)).forEach(function(id){return notDisplayed[id]=id===codesEditTableId?_this3.state.tempCodesEditTableChecked||oldNotDisplayed[id]||[]:oldNotDisplayed[id]||[];});this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["_4" /* setLayoutAnnotationNotDisplayed */])(__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,notDisplayed)});this.onEditTableHide();this.onCodesEditTableHide();}},{key:"onEditTableChange",value:function onEditTableChange(checkedArr){this.setState({tempEditTableChecked:checkedArr});}},{key:"onCodesEditTableShow",value:function onCodesEditTableShow(id,codelistTriplet){this.setState({codesEditTableId:id,codelistTriplet:codelistTriplet,tempCodesEditTableChecked:Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(this.props.layoutAnnotations,this.props.annotationsConfig)[id]||[]});}},{key:"onCodesEditTableHide",value:function onCodesEditTableHide(){this.setState({codesEditTableId:null,codelistTriplet:null,tempCodesEditTableChecked:null});if(!this.props.noCodes){this.props.resetItemsPage();}}},{key:"onCodesEditTableChange",value:function onCodesEditTableChange(checkedArr){this.setState({tempCodesEditTableChecked:checkedArr});}},{key:"onDeleteComponent",value:function onDeleteComponent(id){var notDisplayed={};var oldNotDisplayed=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(this.props.layoutAnnotations,this.props.annotationsConfig);Object.keys(oldNotDisplayed).forEach(function(el){if(id!==el){notDisplayed[el]=oldNotDisplayed[el];}});this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["_4" /* setLayoutAnnotationNotDisplayed */])(__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,notDisplayed)});this.onEditTableHide();this.onCodesEditTableHide();}},{key:"render",value:function render(){var _this4=this;var _props=this.props,t=_props.t,disabled=_props.disabled,noCodes=_props.noCodes,dsdDimensions=_props.dsdDimensions,dsdAttributes=_props.dsdAttributes,layoutAnnotations=_props.layoutAnnotations,annotationsConfig=_props.annotationsConfig,appLanguage=_props.appLanguage,itemCount=_props.itemCount,itemsPage=_props.itemsPage,fetchItemsPage=_props.fetchItemsPage;var _state=this.state,isEditTableVisible=_state.isEditTableVisible,tempEditTableChecked=_state.tempEditTableChecked,tempCodesEditTableChecked=_state.tempCodesEditTableChecked,codesEditTableId=_state.codesEditTableId,codelistTriplet=_state.codelistTriplet;var notDisplayed=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["K" /* getLayoutAnnotationNotDisplayed */])(layoutAnnotations,annotationsConfig);var dsdComponents=(dsdDimensions||[]).map(function(_ref){var id=_ref.id,localRepresentation=_ref.localRepresentation;return{id:id,type:__WEBPACK_IMPORTED_MODULE_13__redux_components_redux_dsd_detail_modal_dsd_detail_ComponentForm__["b" /* DSD_COMPONENT_TYPE_DIMENSION */],codelistTriplet:localRepresentation&&localRepresentation.enumeration&&Object(__WEBPACK_IMPORTED_MODULE_18__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_18__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(localRepresentation.enumeration))||null,codes:notDisplayed[id]||[]};}).sort(function(a,b){return a.order&&b.order&&a.order!==b.order?a.order-b.order:a.id-b.id;}).concat((dsdAttributes||[]).map(function(_ref2){var id=_ref2.id,localRepresentation=_ref2.localRepresentation;return{id:id,type:__WEBPACK_IMPORTED_MODULE_13__redux_components_redux_dsd_detail_modal_dsd_detail_ComponentForm__["a" /* DSD_COMPONENT_TYPE_ATTRIBUTE */],codelistTriplet:localRepresentation&&localRepresentation.enumeration&&Object(__WEBPACK_IMPORTED_MODULE_18__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_18__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(localRepresentation.enumeration))||null,codes:notDisplayed[id]||[]};}).sort(function(a,b){return a.order&&b.order&&a.order!==b.order?a.order-b.order:a.id-b.id;}));var columns=[{title:t('data.dsd.component.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.dsd.component.type.shortLabel'),dataIndex:'type',minWidth:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["TABLE_COL_MIN_WIDTH_ID"],withValuesFilter:true,render:function render(type){return type===__WEBPACK_IMPORTED_MODULE_13__redux_components_redux_dsd_detail_modal_dsd_detail_ComponentForm__["b" /* DSD_COMPONENT_TYPE_DIMENSION */]?t('data.dsd.component.type.values.dimension'):t('data.dsd.component.type.values.attribute');},renderText:function renderText(type){return type===__WEBPACK_IMPORTED_MODULE_13__redux_components_redux_dsd_detail_modal_dsd_detail_ComponentForm__["b" /* DSD_COMPONENT_TYPE_DIMENSION */]?t('data.dsd.component.type.values.dimension'):t('data.dsd.component.type.values.attribute');}}].concat(!noCodes?{title:t('components.notDisplayed.dsdComponentsTable.columns.codes.title'),dataIndex:'codes',render:function render(codes){return codes.join("+");},renderText:function renderText(codes){return codes.join("+");}}:[]);var _this=this;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__infinite_scroll_table__["a" /* default */],{data:dsdComponents.filter(function(_ref3){var id=_ref3.id;return Object.keys(notDisplayed).includes(id);}),getRowKey:function getRowKey(_ref4){var id=_ref4.id;return id;},columns:columns,actions:[function(_ref5){var id=_ref5.id,codelistTriplet=_ref5.codelistTriplet;return!noCodes?Object.assign({},__WEBPACK_IMPORTED_MODULE_17__styles_buttons__["l" /* BUTTON_DETAIL */],{title:codelistTriplet!==null?t('components.notDisplayed.dsdComponentsTable.actions.detail.title'):t('components.notDisplayed.dsdComponentsTable.actions.detailNoCodelist.title'),onClick:function onClick(){return _this4.onCodesEditTableShow(id,codelistTriplet);},disabled:codelistTriplet===null}):null;},function(_ref6){var id=_ref6.id;return Object.assign({},__WEBPACK_IMPORTED_MODULE_17__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('components.notDisplayed.dsdComponentsTable.actions.delete.title'),onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('components.notDisplayed.dsdComponentsTable.confirms.delete.title',{id:id}),content:notDisplayed[id]&&notDisplayed[id].length?t('components.notDisplayed.dsdComponentsTable.confirms.delete.content'):undefined,onOk:function onOk(){_this.onDeleteComponent(id);},cancelText:t('commons.buttons.cancel.title')});}});}],rightActions:!disabled&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",onClick:this.onEditTableShow},t("components.annotationsForm.layoutAnnotationNotDisplayed.editButton.title")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__enhanced_modal__["a" /* default */],{visible:isEditTableVisible,width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_MD"],title:t("components.annotationsForm.layoutAnnotationNotDisplayed.editTable.title"),onCancel:this.onEditTableHide,footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:this.onEditTableHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:this.onSubmit,type:"primary"},t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__infinite_scroll_table__["a" /* default */],{data:dsdComponents,getRowKey:function getRowKey(_ref7){var id=_ref7.id;return id;},columns:columns,rowSelection:{selectedRowKeys:tempEditTableChecked||[],onChange:this.onEditTableChange}}))))}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__enhanced_modal__["a" /* default */],{visible:codesEditTableId!==null,width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_MD"],title:t("components.annotationsForm.layoutAnnotationNotDisplayed.codesEditTable.title",{componentId:codesEditTableId}),onCancel:this.onCodesEditTableHide,footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:this.onCodesEditTableHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:this.onSubmit,type:"primary"},t('commons.buttons.save.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__item_list__["a" /* default */],{data:itemsPage||null,rowCount:itemCount,isPaginated:true,onChange:function onChange(_ref8){var pageNum=_ref8.pageNum,pageSize=_ref8.pageSize,searchText=_ref8.searchText,filters=_ref8.filters,sortCol=_ref8.sortCol,sortByDesc=_ref8.sortByDesc;return fetchItemsPage({codelistTriplet:Object(__WEBPACK_IMPORTED_MODULE_18__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistTriplet),language:language,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc},codesEditTableId,tempCodesEditTableChecked||[]);},rowSelection:{selectedRowKeys:tempCodesEditTableChecked||[],onChange:_this4.onCodesEditTableChange}});})));}}]);return NotDisplayed;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["b" /* connect */])(mapStateToProps))(NotDisplayed));

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__infinite_scroll_data_table__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__localized_month_picker__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language};};var timeDimensionEditFormItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_THREE_QUARTERS"]}};var Default=function(_React$Component){_inherits(Default,_React$Component);function Default(props){_classCallCheck(this,Default);var _this2=_possibleConstructorReturn(this,(Default.__proto__||Object.getPrototypeOf(Default)).call(this,props));var defaultObj=Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(_this2.props.layoutAnnotations,_this2.props.annotationsConfig);_this2.state={isEditTableVisible:false,tempEditTableChecked:null,codesEditTableId:null,tempCodesEditTableChecked:null,codelistTriplet:null,isTimeDimensionEditTableVisible:false,tempTimeDimensionStart:null,tempTimeDimensionEnd:null,tempTimeDimensionLastNObservations:null,tempTimeDimensionLastNPeriods:null,timeDimensionMode:defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]]?__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["n" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS */]:__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */],isTimeDimensionFromListVisible:false,isTimeDimensionToListVisible:false,timeDimensionId:null};_this2.onEditTableShow=_this2.onEditTableShow.bind(_this2);_this2.onEditTableHide=_this2.onEditTableHide.bind(_this2);_this2.onEditTableChange=_this2.onEditTableChange.bind(_this2);_this2.onSubmit=_this2.onSubmit.bind(_this2);_this2.onCodesEditTableShow=_this2.onCodesEditTableShow.bind(_this2);_this2.onCodesEditTableHide=_this2.onCodesEditTableHide.bind(_this2);_this2.onCodesEditTableChange=_this2.onCodesEditTableChange.bind(_this2);_this2.onTimeDimensionEditFormShow=_this2.onTimeDimensionEditFormShow.bind(_this2);_this2.onTimeDimensionEditFormHide=_this2.onTimeDimensionEditFormHide.bind(_this2);_this2.onTempTimeDimensionStartChange=_this2.onTempTimeDimensionStartChange.bind(_this2);_this2.onTempTimeDimensionEndChange=_this2.onTempTimeDimensionEndChange.bind(_this2);_this2.onTempTimeDimensionLastNObservationsChange=_this2.onTempTimeDimensionLastNObservationsChange.bind(_this2);_this2.onTempTimeDimensionLastNPeriodsChange=_this2.onTempTimeDimensionLastNPeriodsChange.bind(_this2);_this2.onTimeDimensionModeChange=_this2.onTimeDimensionModeChange.bind(_this2);_this2.onTimeDimensionToListShow=_this2.onTimeDimensionToListShow.bind(_this2);_this2.onTimeDimensionToListHide=_this2.onTimeDimensionToListHide.bind(_this2);_this2.onTimeDimensionFromListShow=_this2.onTimeDimensionFromListShow.bind(_this2);_this2.onTimeDimensionFromListHide=_this2.onTimeDimensionFromListHide.bind(_this2);return _this2;}_createClass(Default,[{key:"onEditTableShow",value:function onEditTableShow(){var defaultObj=Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(this.props.layoutAnnotations,this.props.annotationsConfig);var newTempEditTableChecked=Object.keys(defaultObj);if(defaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]]||defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]]||defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]]||defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]]||defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]]){newTempEditTableChecked.push(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]);}this.setState({isEditTableVisible:true,tempEditTableChecked:newTempEditTableChecked});}},{key:"onEditTableHide",value:function onEditTableHide(){this.setState({isEditTableVisible:false,tempEditTableChecked:null});}},{key:"onTimeDimensionEditFormShow",value:function onTimeDimensionEditFormShow(id){var timeDimensionMode=this.state.timeDimensionMode;this.setState({isTimeDimensionEditTableVisible:true,tempTimeDimensionStart:timeDimensionMode===__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */]?Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(this.props.layoutAnnotations,this.props.annotationsConfig)[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]]||null:null,tempTimeDimensionEnd:timeDimensionMode===__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */]?Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(this.props.layoutAnnotations,this.props.annotationsConfig)[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]]||null:null,tempTimeDimensionLastNObservations:timeDimensionMode===__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */]?Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(this.props.layoutAnnotations,this.props.annotationsConfig)[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]]||null:null,tempTimeDimensionLastNPeriods:timeDimensionMode===__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["n" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS */]?Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(this.props.layoutAnnotations,this.props.annotationsConfig)[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]]||null:null,timeDimensionId:id});}},{key:"onTimeDimensionEditFormHide",value:function onTimeDimensionEditFormHide(){this.setState({isTimeDimensionEditTableVisible:false,tempTimeDimensionStart:null,tempTimeDimensionEnd:null,tempTimeDimensionLastNObservations:null,tempTimeDimensionLastNPeriods:null,timeDimensionId:null});}},{key:"onTempTimeDimensionStartChange",value:function onTempTimeDimensionStartChange(val){this.setState({tempTimeDimensionStart:val});}},{key:"onTempTimeDimensionEndChange",value:function onTempTimeDimensionEndChange(val){this.setState({tempTimeDimensionEnd:val});}},{key:"onTempTimeDimensionLastNObservationsChange",value:function onTempTimeDimensionLastNObservationsChange(val){this.setState({tempTimeDimensionLastNObservations:val});}},{key:"onTempTimeDimensionLastNPeriodsChange",value:function onTempTimeDimensionLastNPeriodsChange(val){this.setState({tempTimeDimensionLastNPeriods:val});}},{key:"onTimeDimensionModeChange",value:function onTimeDimensionModeChange(val){this.setState({timeDimensionMode:val,tempTimeDimensionStart:null,tempTimeDimensionEnd:null,tempTimeDimensionLastNObservations:null,tempTimeDimensionLastNPeriods:null});}},{key:"onTimeDimensionFromListShow",value:function onTimeDimensionFromListShow(){this.setState({isTimeDimensionFromListVisible:true});}},{key:"onTimeDimensionFromListHide",value:function onTimeDimensionFromListHide(){this.setState({isTimeDimensionFromListVisible:false});this.props.resetValuesForLayoutAnnotations();}},{key:"onTimeDimensionToListShow",value:function onTimeDimensionToListShow(){this.setState({isTimeDimensionToListVisible:true});}},{key:"onTimeDimensionToListHide",value:function onTimeDimensionToListHide(){this.setState({isTimeDimensionToListVisible:false});this.props.resetValuesForLayoutAnnotations();}},{key:"onSubmit",value:function onSubmit(){var _this3=this;var codesEditTableId=this.state.codesEditTableId;var defaultObj={};var oldDefaultObj=Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(this.props.layoutAnnotations,this.props.annotationsConfig);(this.state.tempEditTableChecked||Object.keys(oldDefaultObj)).forEach(function(id){return defaultObj[id]=id===codesEditTableId?_this3.state.tempCodesEditTableChecked||oldDefaultObj[id]||[]:oldDefaultObj[id]||[];});var hadTimeDimension=oldDefaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]]||oldDefaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]]||oldDefaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]]||oldDefaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]]||oldDefaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]];if(this.state.tempTimeDimensionStart){defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]]=[this.state.tempTimeDimensionStart];delete defaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]];}else{delete defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]];}if(this.state.tempTimeDimensionEnd){defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]]=[this.state.tempTimeDimensionEnd];delete defaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]];}else{delete defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]];}if(this.state.tempTimeDimensionLastNObservations){defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]]=[this.state.tempTimeDimensionLastNObservations];delete defaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]];}else{delete defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]];}if(this.state.tempTimeDimensionLastNPeriods){defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]]=[this.state.tempTimeDimensionLastNPeriods];delete defaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]];}else{delete defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]];}if(hadTimeDimension&&!(this.state.tempTimeDimensionStart||this.state.tempTimeDimensionEnd||this.state.tempTimeDimensionLastNObservations||this.state.tempTimeDimensionLastNPeriods)){defaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]]=[];}this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["X" /* setLayoutAnnotationDefault */])(__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,defaultObj)});this.onEditTableHide();this.onCodesEditTableHide();this.onTimeDimensionEditFormHide();}},{key:"onEditTableChange",value:function onEditTableChange(checkedArr){this.setState({tempEditTableChecked:checkedArr});}},{key:"onCodesEditTableShow",value:function onCodesEditTableShow(id,codelistTriplet){this.setState({codesEditTableId:id,codelistTriplet:codelistTriplet,tempCodesEditTableChecked:Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(this.props.layoutAnnotations,this.props.annotationsConfig)[id]||[]});}},{key:"onCodesEditTableHide",value:function onCodesEditTableHide(){this.setState({codesEditTableId:null,codelistTriplet:null,tempCodesEditTableChecked:null});this.props.resetItemsPage();}},{key:"onCodesEditTableChange",value:function onCodesEditTableChange(checkedArr){this.setState({tempCodesEditTableChecked:checkedArr});}},{key:"onDeleteComponent",value:function onDeleteComponent(id){var defaultObj={};var oldDefaultObj=Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(this.props.layoutAnnotations,this.props.annotationsConfig);Object.keys(oldDefaultObj).forEach(function(el){if(id!==el){defaultObj[el]=oldDefaultObj[el];}});if(id===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]){delete defaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]];delete defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]];delete defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]];delete defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]];delete defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]];}this.props.onChange({layoutAnnotations:Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["X" /* setLayoutAnnotationDefault */])(__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(this.props.layoutAnnotations),this.props.annotationsConfig,defaultObj)});this.onEditTableHide();this.onCodesEditTableHide();}},{key:"render",value:function render(){var _this4=this;var _props=this.props,t=_props.t,disabled=_props.disabled,noCodes=_props.noCodes,dsdDimensions=_props.dsdDimensions,layoutAnnotations=_props.layoutAnnotations,annotationsConfig=_props.annotationsConfig,appLanguage=_props.appLanguage,itemCount=_props.itemCount,itemsPage=_props.itemsPage,fetchItemsPage=_props.fetchItemsPage,valuesForLayoutAnnotations=_props.valuesForLayoutAnnotations,fetchValuesForLayoutAnnotations=_props.fetchValuesForLayoutAnnotations;var _state=this.state,isEditTableVisible=_state.isEditTableVisible,tempEditTableChecked=_state.tempEditTableChecked,tempCodesEditTableChecked=_state.tempCodesEditTableChecked,codesEditTableId=_state.codesEditTableId,codelistTriplet=_state.codelistTriplet,isTimeDimensionEditTableVisible=_state.isTimeDimensionEditTableVisible,tempTimeDimensionStart=_state.tempTimeDimensionStart,tempTimeDimensionEnd=_state.tempTimeDimensionEnd,tempTimeDimensionLastNObservations=_state.tempTimeDimensionLastNObservations,tempTimeDimensionLastNPeriods=_state.tempTimeDimensionLastNPeriods,timeDimensionMode=_state.timeDimensionMode,isTimeDimensionFromListVisible=_state.isTimeDimensionFromListVisible,isTimeDimensionToListVisible=_state.isTimeDimensionToListVisible,timeDimensionId=_state.timeDimensionId;var defaultObj=Object(__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["D" /* getLayoutAnnotationDefault */])(layoutAnnotations,annotationsConfig);var dsdComponents=(dsdDimensions||[]).map(function(_ref){var id=_ref.id,localRepresentation=_ref.localRepresentation,type=_ref.type;return{id:id,type:type,codelistTriplet:localRepresentation&&localRepresentation.enumeration&&Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(localRepresentation.enumeration))||null,preview:type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]?[defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]]?__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]+"="+defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]][0]:null,defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]]?__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]+"="+defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]][0]:null,defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]]?__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]+"="+defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]][0]:null,defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]]?__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]+"="+defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]][0]:null].filter(function(val){return!!val;}).join(","):(defaultObj[id]||[]).join("+")};}).sort(function(a,b){return a.order&&b.order&&a.order!==b.order?a.order-b.order:a.id-b.id;});var columns=[{title:t('data.dsd.component.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('components.default.dsdComponentsTable.columns.preview.title'),dataIndex:'preview'}];var _this=this;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__infinite_scroll_table__["a" /* default */],{data:dsdComponents.filter(function(_ref2){var id=_ref2.id,type=_ref2.type;return type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]&&(defaultObj[__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["i" /* DSD_DIMENSION_ID_TIME */]]||defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["q" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_START */]]||defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["p" /* TIME_DIMENSION_DEFAULT_ANNOTATION_TIME_PERIOD_END */]]||defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["l" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_OBSERVATIONS */]]||defaultObj[__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["m" /* TIME_DIMENSION_DEFAULT_ANNOTATION_LAST_N_PERIODS */]])||Object.keys(defaultObj).includes(id);}),getRowKey:function getRowKey(_ref3){var id=_ref3.id;return id;},columns:columns,actions:[function(_ref4){var id=_ref4.id,codelistTriplet=_ref4.codelistTriplet,type=_ref4.type;return!noCodes?Object.assign({},__WEBPACK_IMPORTED_MODULE_22__styles_buttons__["l" /* BUTTON_DETAIL */],{title:type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]||codelistTriplet!==null?t('components.default.dsdComponentsTable.actions.detail.title'):t('components.default.dsdComponentsTable.actions.detailNoCodelist.title'),onClick:function onClick(){if(type===__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]){_this4.onTimeDimensionEditFormShow(id);}else{_this4.onCodesEditTableShow(id,codelistTriplet);}},disabled:type!==__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["m" /* DSD_DIMENSION_TYPE_TIME */]&&codelistTriplet===null}):null;},function(_ref5){var id=_ref5.id;return Object.assign({},__WEBPACK_IMPORTED_MODULE_22__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('components.default.dsdComponentsTable.actions.delete.title'),onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('components.default.dsdComponentsTable.confirms.delete.title',{id:id}),content:defaultObj[id]&&defaultObj[id].length?t('components.default.dsdComponentsTable.confirms.delete.content'):undefined,onOk:function onOk(){_this.onDeleteComponent(id);},cancelText:t('commons.buttons.cancel.title')});}});}],rightActions:!disabled&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:"primary",onClick:this.onEditTableShow},t("components.annotationsForm.layoutAnnotationDefault.editButton.title")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__enhanced_modal__["a" /* default */],{visible:isEditTableVisible,width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_MD"],title:t("components.annotationsForm.layoutAnnotationDefault.editTable.title"),onCancel:this.onEditTableHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:this.onEditTableHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:this.onSubmit,type:"primary"},t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__infinite_scroll_table__["a" /* default */],{data:dsdComponents,getRowKey:function getRowKey(_ref6){var id=_ref6.id;return id;},columns:columns,rowSelection:{selectedRowKeys:tempEditTableChecked||[],onChange:this.onEditTableChange}}))))}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__enhanced_modal__["a" /* default */],{visible:codesEditTableId!==null,width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_MD"],title:t("components.annotationsForm.layoutAnnotationDefault.codesEditTable.title",{componentId:codesEditTableId}),onCancel:this.onCodesEditTableHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:this.onCodesEditTableHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:this.onSubmit,type:"primary"},t('commons.buttons.save.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__item_list__["a" /* default */],{data:itemsPage||null,rowCount:itemCount,isPaginated:true,onChange:function onChange(_ref7){var pageNum=_ref7.pageNum,pageSize=_ref7.pageSize,searchText=_ref7.searchText,filters=_ref7.filters,sortCol=_ref7.sortCol,sortByDesc=_ref7.sortByDesc;return fetchItemsPage({codelistTriplet:Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(codelistTriplet),language:language,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc},codesEditTableId,tempCodesEditTableChecked||[]);},rowSelection:{selectedRowKeys:tempCodesEditTableChecked||[],onChange:_this4.onCodesEditTableChange}});})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__enhanced_modal__["a" /* default */],{visible:isTimeDimensionEditTableVisible,width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_MD"],title:t("components.annotationsForm.layoutAnnotationDefault.timeDimensionEdit.title"),onCancel:this.onTimeDimensionEditFormHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:this.onTimeDimensionEditFormHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:this.onSubmit,type:"primary"},t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.timDimension.mode.label')},timeDimensionEditFormItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group,{disabled:disabled,value:timeDimensionMode,onChange:function onChange(_ref8){var target=_ref8.target;if(tempTimeDimensionStart||tempTimeDimensionEnd||tempTimeDimensionLastNObservations||tempTimeDimensionLastNPeriods){var _this5=_this4;__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('components.annotationsForm.layoutAnnotationDefault.timeDimensionEdit.modeChangeConfirm.title'),content:t('components.annotationsForm.layoutAnnotationDefault.timeDimensionEdit.modeChangeConfirm.content'),onOk:function onOk(){_this5.onTimeDimensionModeChange(target.value);},cancelText:t('commons.buttons.cancel.title')});}else{_this4.onTimeDimensionModeChange(target.value);}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */]},t('data.dsd.timDimension.mode.values.range')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["n" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS */]},t('data.dsd.timDimension.mode.values.lastNPeriods')))))),timeDimensionMode===__WEBPACK_IMPORTED_MODULE_19__utils_annotations__["o" /* TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE */]?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,fetchValuesForLayoutAnnotations?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.timDimension.defaultTimeStart.label')},timeDimensionEditFormItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__selector__["a" /* default */],{disabled:disabled,selectTitle:t('data.dsd.timDimension.defaultTimeStart.selector.selectTitle'),resetTitle:t('data.dsd.timDimension.defaultTimeStart.selector.resetTitle'),onSelect:function onSelect(){return _this4.onTimeDimensionFromListShow();},onReset:function onReset(){return _this4.onTempTimeDimensionStartChange(null);},value:tempTimeDimensionStart})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.timDimension.defaultTimeEnd.label')},timeDimensionEditFormItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__selector__["a" /* default */],{disabled:disabled,selectTitle:t('data.dsd.timDimension.defaultTimeEnd.selector.selectTitle'),resetTitle:t('data.dsd.timDimension.defaultTimeEnd.selector.resetTitle'),onSelect:function onSelect(){return _this4.onTimeDimensionToListShow();},onReset:function onReset(){return _this4.onTempTimeDimensionEndChange(null);},value:tempTimeDimensionEnd})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__enhanced_modal__["a" /* default */],{visible:isTimeDimensionFromListVisible||isTimeDimensionToListVisible,width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_MD"],title:t('components.treeFilter.timeDimension.valuesModal.title'),footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){_this4.onTimeDimensionFromListHide();_this4.onTimeDimensionToListHide();}},t('commons.buttons.close.title')),onCancel:function onCancel(){_this4.onTimeDimensionFromListHide();_this4.onTimeDimensionToListHide();}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__hocs_call__["a" /* default */],{cb:fetchValuesForLayoutAnnotations,cbParam:timeDimensionId,disabled:valuesForLayoutAnnotations},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__infinite_scroll_data_table__["a" /* default */],{isPaginated:false,noFilter:true,noSort:true,data:valuesForLayoutAnnotations,cols:valuesForLayoutAnnotations&&valuesForLayoutAnnotations.length>0?[Object.keys(valuesForLayoutAnnotations[0])[0]]:["TIME_PERIOD"],onRowClick:function onRowClick(row){if(isTimeDimensionFromListVisible){_this4.onTempTimeDimensionStartChange(row[Object.keys(row)[0]]);_this4.onTimeDimensionFromListHide();}else{_this4.onTempTimeDimensionEndChange(row[Object.keys(row)[0]]);_this4.onTimeDimensionToListHide();}}})))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.timDimension.defaultTimeStart.label')},timeDimensionEditFormItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__localized_month_picker__["a" /* default */],{format:"YYYY-MM",value:tempTimeDimensionStart?__WEBPACK_IMPORTED_MODULE_31_moment___default()(tempTimeDimensionStart):null,disabled:disabled,onChange:function onChange(val){return _this4.onTempTimeDimensionStartChange(val?val.format("YYYY-MM"):null);}})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.timDimension.defaultTimeEnd.label')},timeDimensionEditFormItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__localized_month_picker__["a" /* default */],{format:"YYYY-MM",value:tempTimeDimensionEnd?__WEBPACK_IMPORTED_MODULE_31_moment___default()(tempTimeDimensionEnd):null,disabled:disabled,onChange:function onChange(val){return _this4.onTempTimeDimensionEndChange(val?val.format("YYYY-MM"):null);}}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.timDimension.defaultLastNObservations.label')},timeDimensionEditFormItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default.a,{style:{width:"100%"},min:0,precision:0,value:tempTimeDimensionLastNObservations,disabled:disabled,onChange:function onChange(val){return _this4.onTempTimeDimensionLastNObservationsChange(val||null);}}))))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,Object.assign({label:t('data.dsd.timDimension.defaultLastNPeriods.label')},timeDimensionEditFormItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default.a,{style:{width:"100%"},min:0,precision:0,value:tempTimeDimensionLastNPeriods,disabled:disabled,onChange:function onChange(val){return _this4.onTempTimeDimensionLastNPeriodsChange(val||null);}}))))));}}]);return Default;}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_16_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(mapStateToProps))(Default));

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComponentForm__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_annotation_list__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getSdmxDimensionTypesTranslations__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getSdmxAttributeAttachmentLevelTranslations__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,username:state.app.user.username};};var ComponentList=function(_React$Component){_inherits(ComponentList,_React$Component);function ComponentList(props){_classCallCheck(this,ComponentList);var _this=_possibleConstructorReturn(this,(ComponentList.__proto__||Object.getPrototypeOf(ComponentList)).call(this,props));_this.state={annotationsComponentId:null,layoutAnnotationsComponentId:null};_this.showAnnotations=_this.showAnnotations.bind(_this);_this.hideAnnotations=_this.hideAnnotations.bind(_this);_this.showLayoutAnnotations=_this.showLayoutAnnotations.bind(_this);_this.hideLayoutAnnotations=_this.hideLayoutAnnotations.bind(_this);return _this;}_createClass(ComponentList,[{key:'showAnnotations',value:function showAnnotations(componentId){this.setState({annotationsComponentId:componentId});}},{key:'hideAnnotations',value:function hideAnnotations(){this.setState({annotationsComponentId:null});}},{key:'showLayoutAnnotations',value:function showLayoutAnnotations(componentId){this.setState({layoutAnnotationsComponentId:componentId});}},{key:'hideLayoutAnnotations',value:function hideLayoutAnnotations(){this.setState({layoutAnnotationsComponentId:null});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,components=_props.components,onDetail=_props.onDetail,onCodelistDetail=_props.onCodelistDetail,onConceptDetail=_props.onConceptDetail,onConceptSchemeDetail=_props.onConceptSchemeDetail,onDelete=_props.onDelete,mode=_props.mode,type=_props.type,endpoints=_props.endpoints,endpointId=_props.endpointId,username=_props.username;var annotationsComponentId=this.state.annotationsComponentId;var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;var customAnnotationsConfig=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].annotationTabs.tabs;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_infinite_scroll_table__["a" /* default */],{data:components&&components.map(function(comp){return Object.assign({},comp,{concept:comp.concept?Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_2" /* getStringFromItemUrn */])(comp.concept):null,representation:comp.representation?Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(comp.representation)):null,groupDimensions:comp.groupDimensions?comp.groupDimensions.join(", "):null});}).sort(function(a,b){return a.order&&b.order&&a.order!==b.order?a.order-b.order:a.id-b.id;}),getRowKey:function getRowKey(_ref){var id=_ref.id;return id;},columns:[].concat(type===__WEBPACK_IMPORTED_MODULE_1__ComponentForm__["b" /* DSD_COMPONENT_TYPE_DIMENSION */]||type===__WEBPACK_IMPORTED_MODULE_1__ComponentForm__["a" /* DSD_COMPONENT_TYPE_ATTRIBUTE */]?{title:t('data.dsd.component.order.shortLabel'),dataIndex:'order',widthToContent:true}:[]).concat({title:t('data.dsd.component.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]}).concat(type===__WEBPACK_IMPORTED_MODULE_1__ComponentForm__["b" /* DSD_COMPONENT_TYPE_DIMENSION */]||type===__WEBPACK_IMPORTED_MODULE_1__ComponentForm__["a" /* DSD_COMPONENT_TYPE_ATTRIBUTE */]?[{title:t('data.dsd.component.concept.shortLabel'),dataIndex:'concept',minWidth:150,render:function render(concept){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{cursor:"pointer",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"},onClick:function onClick(){return onConceptDetail(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["U" /* getQuartupletFromItemString */])(concept));}},concept);}},{title:t('data.dsd.component.representation.shortLabel'),dataIndex:'representation',minWidth:150,render:function render(representation,row){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{cursor:"pointer",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"},onClick:function onClick(){if(representation){if(onCodelistDetail&&(type===__WEBPACK_IMPORTED_MODULE_1__ComponentForm__["a" /* DSD_COMPONENT_TYPE_ATTRIBUTE */]||row.type===__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["l" /* DSD_DIMENSION_TYPE_NORMAL */]||row.type===__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["j" /* DSD_DIMENSION_TYPE_FREQUENCY */])){onCodelistDetail(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(representation));}else if(onConceptSchemeDetail&&row.type===__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["k" /* DSD_DIMENSION_TYPE_MEASURE */]){onConceptSchemeDetail(Object(__WEBPACK_IMPORTED_MODULE_3__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(representation));}}else{return null;}}},representation);}}]:[]).concat(type===__WEBPACK_IMPORTED_MODULE_1__ComponentForm__["c" /* DSD_COMPONENT_TYPE_GROUP */]?{title:t('data.dsd.group.dimensions.shortLabel'),dataIndex:'groupDimensions',minWidth:200}:[]).concat(type===__WEBPACK_IMPORTED_MODULE_1__ComponentForm__["b" /* DSD_COMPONENT_TYPE_DIMENSION */]?{title:t('data.dsd.dimension.type.shortLabel'),dataIndex:'type',widthToContent:true,withValuesFilter:true,render:function render(type){return Object(__WEBPACK_IMPORTED_MODULE_7__getSdmxDimensionTypesTranslations__["a" /* getSdmxDimensionTypesTranslations */])(t)[type];},renderText:function renderText(type){return Object(__WEBPACK_IMPORTED_MODULE_7__getSdmxDimensionTypesTranslations__["a" /* getSdmxDimensionTypesTranslations */])(t)[type];}}:[]).concat(type===__WEBPACK_IMPORTED_MODULE_1__ComponentForm__["a" /* DSD_COMPONENT_TYPE_ATTRIBUTE */]?[{title:t('data.dsd.attribute.assignmentStatus.shortLabel'),dataIndex:'assignmentStatus',widthToContent:true,withValuesFilter:true},{title:t('data.dsd.attribute.attachmentLevel.shortLabel'),dataIndex:'attachmentLevel',widthToContent:true,withValuesFilter:true,render:function render(level){return Object(__WEBPACK_IMPORTED_MODULE_8__getSdmxAttributeAttachmentLevelTranslations__["a" /* getSdmxAttributeAttachmentLevelTranslations */])(t)[level];},renderText:function renderText(level){return Object(__WEBPACK_IMPORTED_MODULE_8__getSdmxAttributeAttachmentLevelTranslations__["a" /* getSdmxAttributeAttachmentLevelTranslations */])(t)[level];}}]:[]),actions:[].concat(onDetail?Object.assign({},__WEBPACK_IMPORTED_MODULE_9__styles_buttons__["l" /* BUTTON_DETAIL */],{title:mode!==__WEBPACK_IMPORTED_MODULE_4__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]?t('components.dsdDetail.componentList.actions.detail'):t('components.dsdDetail.componentList.actions.detailReadOnly'),onClick:onDetail}):[]).concat(onDelete&&mode!==__WEBPACK_IMPORTED_MODULE_4__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]?Object.assign({},__WEBPACK_IMPORTED_MODULE_9__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('components.dsdDetail.componentList.actions.delete'),onClick:onDelete}):[]),fixedActions:[].concat(function(_ref2){var id=_ref2.id,annotations=_ref2.annotations;var customAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["r" /* countCustomAnnotations */])(annotations,customAnnotationsConfig);return customAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_9__styles_buttons__["g" /* BUTTON_CUSTOM_ANNOTATIONS */],{title:t('commons.actions.customAnnotations.title')+": "+customAnnotationsCount,onClick:function onClick(){return _this2.showAnnotations(id);}}):null;}).concat(username?function(_ref3){var id=_ref3.id,annotations=_ref3.annotations;var layoutAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_10__utils_annotations__["s" /* countLayoutAnnotations */])(annotations,annotationsConfig);return layoutAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_9__styles_buttons__["u" /* BUTTON_LAYOUT_ANNOTATIONS */],{title:t('commons.actions.layoutAnnotations.title')+": "+layoutAnnotationsCount,onClick:function onClick(){return _this2.showLayoutAnnotations(id);}}):null;}:[])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_custom_annotation_list__["a" /* default */],{annotations:annotationsComponentId?components.find(function(_ref4){var id=_ref4.id;return annotationsComponentId===id;}).annotations:null,onClose:this.hideAnnotations}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_layout_annotation_list__["a" /* default */],{annotations:annotationsComponentId?components.find(function(_ref5){var id=_ref5.id;return annotationsComponentId===id;}).annotations:null,onClose:this.hideLayoutAnnotations}));}}]);return ComponentList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps))(ComponentList));

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_collapse_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CollapsibleText=function(_React$Component){_inherits(CollapsibleText,_React$Component);function CollapsibleText(props){_classCallCheck(this,CollapsibleText);var _this=_possibleConstructorReturn(this,(CollapsibleText.__proto__||Object.getPrototypeOf(CollapsibleText)).call(this,props));_this.state={collapsed:_this.props.isCollapsedDefault!==undefined?_this.props.isCollapsedDefault:true};return _this;}_createClass(CollapsibleText,[{key:"render",value:function render(){var _this2=this;var text=String(this.props.children);var lineBreakMatch=/\r|\n/.exec(text);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"collapsible-text "+(!lineBreakMatch?"collapsible-text--single-line":"")},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default.a,{bordered:false,defaultActiveKey:this.props.isCollapsedDefault?null:"1",onChange:function onChange(keys){if(keys.includes("1")){_this2.setState({collapsed:false});}else{_this2.setState({collapsed:true});}}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_collapse___default.a.Panel,{key:"1",header:function(){if(!_this2.state.collapsed){return text;}else{if(lineBreakMatch){return text.substr(0,lineBreakMatch.index)+"...";}else{return text;}}}(),style:{border:0}})));}}]);return CollapsibleText;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CollapsibleText);

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artefact_list__ = __webpack_require__(50);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{isCodelistsForSelectorVisible:instanceState.isCodelistsForSelectorVisible,codelists:instanceState.codelists};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onCodelistsForSelectorHide:function onCodelistsForSelectorHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_51" /* hideDsdDetailCodelistsForSelector */])(),instancePrefix));},onCodelistsForSelectorSet:function onCodelistsForSelectorSet(codelistUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_69" /* setDsdDetailCodelistsForSelector */])(codelistUrn),instancePrefix));}};};var DsdsCodelistSelector=function DsdsCodelistSelector(_ref3){var t=_ref3.t,isCodelistsForSelectorVisible=_ref3.isCodelistsForSelectorVisible,codelists=_ref3.codelists,onCodelistsForSelectorHide=_ref3.onCodelistsForSelectorHide,onCodelistsForSelectorSet=_ref3.onCodelistsForSelectorSet;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_enhanced_modal__["a" /* default */],{visible:isCodelistsForSelectorVisible&&codelists!==null,width:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MODAL_WIDTH_LG"],title:t('reduxComponents.dsdDetail.codelistsSelector.title'),onCancel:onCodelistsForSelectorHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onCodelistsForSelectorHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_artefact_list__["a" /* default */],{artefacts:codelists,onRowClick:function onRowClick(_ref4){var urn=_ref4.urn;return onCodelistsForSelectorSet(urn);},getIsDisabledRow:function getIsDisabledRow(_ref5){var isFinal=_ref5.isFinal;return!isFinal;}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsCodelistSelector));

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artefact_list__ = __webpack_require__(50);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{isMeasureDimensionConceptSchemesForSelectorVisible:instanceState.isMeasureDimensionConceptSchemesForSelectorVisible,conceptSchemes:instanceState.conceptSchemes};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onMeasureDimensionConceptSchemesForSelectorHide:function onMeasureDimensionConceptSchemesForSelectorHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_60" /* hideDsdDetailMeasureDimensionConceptSchemesForSelector */])(),instancePrefix));},onMeasureDimensionConceptSchemesForSelectorSet:function onMeasureDimensionConceptSchemesForSelectorSet(conceptSchemeUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_71" /* setDsdDetailMeasureDimensionConceptSchemesSelector */])(conceptSchemeUrn),instancePrefix));}};};var DsdsConceptSchemeSelector=function DsdsConceptSchemeSelector(_ref3){var t=_ref3.t,isMeasureDimensionConceptSchemesForSelectorVisible=_ref3.isMeasureDimensionConceptSchemesForSelectorVisible,conceptSchemes=_ref3.conceptSchemes,onMeasureDimensionConceptSchemesForSelectorSet=_ref3.onMeasureDimensionConceptSchemesForSelectorSet,onMeasureDimensionConceptSchemesForSelectorHide=_ref3.onMeasureDimensionConceptSchemesForSelectorHide;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_enhanced_modal__["a" /* default */],{visible:isMeasureDimensionConceptSchemesForSelectorVisible&&conceptSchemes!==null,width:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MODAL_WIDTH_LG"],title:t('reduxComponents.dsdDetail.codelistsSelector.title'),onCancel:onMeasureDimensionConceptSchemesForSelectorHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onMeasureDimensionConceptSchemesForSelectorHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_artefact_list__["a" /* default */],{artefacts:conceptSchemes,onRowClick:function onRowClick(_ref4){var urn=_ref4.urn;return onMeasureDimensionConceptSchemesForSelectorSet(urn);},getIsDisabledRow:function getIsDisabledRow(_ref5){var isFinal=_ref5.isFinal;return!isFinal;}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsConceptSchemeSelector));

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artefact_summary__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_item_list__ = __webpack_require__(84);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,endpointId:state.app.endpointId,isConceptSchemesForSelectorVisible:instanceState.isConceptSchemesForSelectorVisible,conceptSchemeForSelectorTriplet:instanceState.conceptSchemeForSelectorTriplet,conceptSchemes:instanceState.conceptSchemes,conceptSchemeForSelector:instanceState.conceptSchemeForSelector};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onConceptSchemesForSelectorHide:function onConceptSchemesForSelectorHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_53" /* hideDsdDetailConceptSchemesForSelector */])(),instancePrefix));},onConceptSchemeForSelectorShow:function onConceptSchemeForSelectorShow(conceptSchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_75" /* showDsdDetailConceptSchemeForSelector */])(conceptSchemeTriplet),instancePrefix));},onConceptSchemeForSelectorHide:function onConceptSchemeForSelectorHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_52" /* hideDsdDetailConceptSchemeForSelector */])(),instancePrefix));},onConceptSchemeForSelectorSet:function onConceptSchemeForSelectorSet(conceptUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_70" /* setDsdDetailConceptSchemeForSelector */])(conceptUrn),instancePrefix));},fetchConceptSchemeForSelector:function fetchConceptSchemeForSelector(_ref3){var conceptSchemeTriplet=_ref3.conceptSchemeTriplet,itemOrderAnnotationType=_ref3.itemOrderAnnotationType;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_65" /* readDsdDetailConceptSchemeForSelector */])(conceptSchemeTriplet,itemOrderAnnotationType),instancePrefix));}};};var DsdsConceptSelector=function DsdsConceptSelector(_ref4){var t=_ref4.t,endpointId=_ref4.endpointId,nodes=_ref4.nodes,isConceptSchemesForSelectorVisible=_ref4.isConceptSchemesForSelectorVisible,conceptSchemeForSelectorTriplet=_ref4.conceptSchemeForSelectorTriplet,conceptSchemes=_ref4.conceptSchemes,conceptSchemeForSelector=_ref4.conceptSchemeForSelector,onConceptSchemesForSelectorHide=_ref4.onConceptSchemesForSelectorHide,onConceptSchemeForSelectorHide=_ref4.onConceptSchemeForSelectorHide,onConceptSchemeForSelectorShow=_ref4.onConceptSchemeForSelectorShow,onConceptSchemeForSelectorSet=_ref4.onConceptSchemeForSelectorSet,fetchConceptSchemeForSelector=_ref4.fetchConceptSchemeForSelector;var conceptSchemeItemOrderAnnotationType=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(nodes,function(node){return node.general.id===endpointId;}).annotations.conceptSchemesOrder;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_enhanced_modal__["a" /* default */],{visible:isConceptSchemesForSelectorVisible&&conceptSchemes!==null,width:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["MODAL_WIDTH_LG"],title:t('reduxComponents.dsdDetail.conceptSchemesSelector.title'),onCancel:onConceptSchemesForSelectorHide,footer:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onConceptSchemesForSelectorHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_artefact_list__["a" /* default */],{artefacts:conceptSchemes,onRowClick:function onRowClick(_ref5){var id=_ref5.id,agencyID=_ref5.agencyID,version=_ref5.version;return onConceptSchemeForSelectorShow({id:id,agencyID:agencyID,version:version});},getIsDisabledRow:function getIsDisabledRow(_ref6){var isFinal=_ref6.isFinal;return!isFinal;}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hocs_call__["a" /* default */],{cb:fetchConceptSchemeForSelector,cbParam:{conceptSchemeTriplet:conceptSchemeForSelectorTriplet,itemOrderAnnotationType:conceptSchemeItemOrderAnnotationType},disabled:conceptSchemeForSelectorTriplet===null},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_enhanced_modal__["a" /* default */],{visible:conceptSchemeForSelector!==null,width:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["MODAL_WIDTH_LG"],title:t('reduxComponents.dsdDetail.conceptSchemeSelector.title'),onCancel:onConceptSchemeForSelectorHide,footer:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onConceptSchemeForSelectorHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_4__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_artefact_summary__["a" /* default */],{id:conceptSchemeForSelectorTriplet&&conceptSchemeForSelectorTriplet.id,agencyID:conceptSchemeForSelectorTriplet&&conceptSchemeForSelectorTriplet.agencyID,version:conceptSchemeForSelectorTriplet&&conceptSchemeForSelectorTriplet.version})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_item_list__["a" /* default */],{data:conceptSchemeForSelector?conceptSchemeForSelector.concepts:null,onRowClick:function onRowClick(_ref7){var id=_ref7.id;return onConceptSchemeForSelectorSet("urn:sdmx:org.sdmx.infomodel.conceptscheme.Concept="+conceptSchemeForSelectorTriplet.agencyID+":"+conceptSchemeForSelectorTriplet.id+"("+conceptSchemeForSelectorTriplet.version+")."+id);}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsConceptSelector));

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dsd_detail_ComponentForm__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{dimension:instanceState.dimension,dsdTriplet:instanceState.dsdTriplet,dsd:instanceState.dsd,isCreatingComponent:instanceState.isCreatingComponent,notDisplayedVal:instanceState.notDisplayedVal,defaultVal:instanceState.defaultVal,defaultTimeDimensionStart:instanceState.defaultTimeDimensionStart,defaultTimeDimensionEnd:instanceState.defaultTimeDimensionEnd,defaultTimeDimensionLastNObservations:instanceState.defaultTimeDimensionLastNObservations,defaultTimeDimensionLastNPeriods:instanceState.defaultTimeDimensionLastNPeriods,defaultTimeDimensionMode:instanceState.defaultTimeDimensionMode};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onCodelistsForSelectorShow:function onCodelistsForSelectorShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_74" /* showDsdDetailCodelistsForSelector */])(),instancePrefix));},onConceptSchemesForSelectorShow:function onConceptSchemesForSelectorShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_76" /* showDsdDetailConceptSchemesForSelector */])(),instancePrefix));},onMeasureDimensionConceptSchemesForSelectorShow:function onMeasureDimensionConceptSchemesForSelectorShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_80" /* showDsdDetailMeasureDimensionConceptSchemesForSelector */])(),instancePrefix));},onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_55" /* hideDsdDetailDimension */])(),instancePrefix));},onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_31" /* changeDsdDetailDimension */])(fields),instancePrefix));},onNotDisplayedValChange:function onNotDisplayedValChange(val){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_24" /* changeDsdDetailComponentNotDisplayed */])(val),instancePrefix));},onDefaultValChange:function onDefaultValChange(val){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_23" /* changeDsdDetailComponentDefault */])(val),instancePrefix));},onDefaultTimeDimensionStartChange:function onDefaultTimeDimensionStartChange(val){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_30" /* changeDsdDetailDefaultTimeDimensionStart */])(val),instancePrefix));},onDefaultTimeDimensionEndChange:function onDefaultTimeDimensionEndChange(val){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_26" /* changeDsdDetailDefaultTimeDimensionEnd */])(val),instancePrefix));},onDefaultTimeDimensionLastNObservationsChange:function onDefaultTimeDimensionLastNObservationsChange(val){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_27" /* changeDsdDetailDefaultTimeDimensionLastNObservations */])(val),instancePrefix));},onDefaultTimeDimensionLastNPeriodsChange:function onDefaultTimeDimensionLastNPeriodsChange(val){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_28" /* changeDsdDetailDefaultTimeDimensionLastNPeriods */])(val),instancePrefix));},onDefaultTimeDimensionModeChange:function onDefaultTimeDimensionModeChange(val){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_29" /* changeDsdDetailDefaultTimeDimensionMode */])(val),instancePrefix));},onSubmit:function onSubmit(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_86" /* submitDsdDetailDimension */])(),instancePrefix));},onNotDisplayedCodesSelectorShow:function onNotDisplayedCodesSelectorShow(codelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_81" /* showDsdDetailNotDisplayedCodesSelector */])(codelistTriplet),instancePrefix));},onDefaultCodesSelectorShow:function onDefaultCodesSelectorShow(codelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["_77" /* showDsdDetailDefaultCodesSelector */])(codelistTriplet),instancePrefix));}};};var DsdsDimensionDetail=function DsdsDimensionDetail(_ref3){var t=_ref3.t,dimension=_ref3.dimension,dsdTriplet=_ref3.dsdTriplet,dsd=_ref3.dsd,userHasPermissionsToEdit=_ref3.userHasPermissionsToEdit,notDisplayedVal=_ref3.notDisplayedVal,defaultVal=_ref3.defaultVal,defaultTimeDimensionStart=_ref3.defaultTimeDimensionStart,defaultTimeDimensionEnd=_ref3.defaultTimeDimensionEnd,defaultTimeDimensionLastNObservations=_ref3.defaultTimeDimensionLastNObservations,defaultTimeDimensionLastNPeriods=_ref3.defaultTimeDimensionLastNPeriods,defaultTimeDimensionMode=_ref3.defaultTimeDimensionMode,onHide=_ref3.onHide,onChange=_ref3.onChange,onNotDisplayedValChange=_ref3.onNotDisplayedValChange,onDefaultValChange=_ref3.onDefaultValChange,onDefaultTimeDimensionStartChange=_ref3.onDefaultTimeDimensionStartChange,onDefaultTimeDimensionEndChange=_ref3.onDefaultTimeDimensionEndChange,onDefaultTimeDimensionLastNObservationsChange=_ref3.onDefaultTimeDimensionLastNObservationsChange,onDefaultTimeDimensionLastNPeriodsChange=_ref3.onDefaultTimeDimensionLastNPeriodsChange,onDefaultTimeDimensionModeChange=_ref3.onDefaultTimeDimensionModeChange,onSubmit=_ref3.onSubmit,isCreatingComponent=_ref3.isCreatingComponent,onCodelistsForSelectorShow=_ref3.onCodelistsForSelectorShow,onConceptSchemesForSelectorShow=_ref3.onConceptSchemesForSelectorShow,onMeasureDimensionConceptSchemesForSelectorShow=_ref3.onMeasureDimensionConceptSchemesForSelectorShow,onNotDisplayedCodesSelectorShow=_ref3.onNotDisplayedCodesSelectorShow,onDefaultCodesSelectorShow=_ref3.onDefaultCodesSelectorShow;var isDisabledAnnotations=!isCreatingComponent&&dsdTriplet!==null&&!userHasPermissionsToEdit;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_enhanced_modal__["a" /* default */],{visible:dimension!==null,width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],title:t('reduxComponents.dsdDetail.dimensionDetail.title'),onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),(dsdTriplet===null||dsd&&!dsd.remoteIsFinal&&userHasPermissionsToEdit||!isDisabledAnnotations)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{disabled:!(dimension&&dimension.type&&dimension.id&&dimension.concept&&(dimension.type!==__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["k" /* DSD_DIMENSION_TYPE_MEASURE */]||dimension.representation)&&(dimension.annotations||[]).filter(function(annot){return annot.id===null||annot.id!==undefined&&annot.id.length===0||annot.type===null||annot.type!==undefined&&annot.type.length===0;}).length===0),onClick:function onClick(){return isCreatingComponent&&Object(__WEBPACK_IMPORTED_MODULE_13__utils_artefacts__["b" /* existsComponentWithId */])(dsd,dimension.id)?__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('reduxComponents.dsdDetail.component.createWarningModal.title',{id:dimension.id}),content:t('reduxComponents.dsdDetail.component.createWarningModal.content')}):onSubmit();},type:"primary"},t('commons.buttons.save.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__dsd_detail_ComponentForm__["e" /* default */],{type:__WEBPACK_IMPORTED_MODULE_11__dsd_detail_ComponentForm__["b" /* DSD_COMPONENT_TYPE_DIMENSION */],component:dimension,mode:isCreatingComponent?__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */]:dsdTriplet===null||dsd&&!dsd.remoteIsFinal&&userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_12__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],disableAnnotations:isDisabledAnnotations,notDisplayedVal:notDisplayedVal,defaultVal:defaultVal,defaultTimeDimensionStart:defaultTimeDimensionStart,defaultTimeDimensionEnd:defaultTimeDimensionEnd,defaultTimeDimensionLastNObservations:defaultTimeDimensionLastNObservations,defaultTimeDimensionLastNPeriods:defaultTimeDimensionLastNPeriods,defaultTimeDimensionMode:defaultTimeDimensionMode,onChange:onChange,onNotDisplayedValChange:onNotDisplayedValChange,onDefaultValChange:onDefaultValChange,onDefaultTimeDimensionStartChange:onDefaultTimeDimensionStartChange,onDefaultTimeDimensionEndChange:onDefaultTimeDimensionEndChange,onDefaultTimeDimensionLastNObservationsChange:onDefaultTimeDimensionLastNObservationsChange,onDefaultTimeDimensionLastNPeriodsChange:onDefaultTimeDimensionLastNPeriodsChange,onDefaultTimeDimensionModeChange:onDefaultTimeDimensionModeChange,onCodelistSelect:onCodelistsForSelectorShow,onConceptSelect:onConceptSchemesForSelectorShow,onConceptSchemeSelect:onMeasureDimensionConceptSchemesForSelectorShow,onNotDisplayedCodesSelectorShow:onNotDisplayedCodesSelectorShow,onDefaultCodesSelectorShow:onDefaultCodesSelectorShow}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsDimensionDetail));

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dsd_detail_ComponentForm__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{dsdTriplet:instanceState.dsdTriplet,dsd:instanceState.dsd,group:instanceState.group,isCreatingComponent:instanceState.isCreatingComponent};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_59" /* hideDsdDetailGroup */])(),instancePrefix));},onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_34" /* changeDsdDetailGroup */])(fields),instancePrefix));},onSubmit:function onSubmit(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_89" /* submitDsdDetailGroup */])(),instancePrefix));}};};var DsdsGroupDetail=function DsdsGroupDetail(_ref3){var t=_ref3.t,group=_ref3.group,dsdTriplet=_ref3.dsdTriplet,dsd=_ref3.dsd,isCreatingComponent=_ref3.isCreatingComponent,onHide=_ref3.onHide,onChange=_ref3.onChange,onSubmit=_ref3.onSubmit,userHasPermissionsToEdit=_ref3.userHasPermissionsToEdit;var isDisabledAnnotations=!isCreatingComponent&&dsdTriplet!==null&&!userHasPermissionsToEdit;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_enhanced_modal__["a" /* default */],{visible:group!==null,width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],title:t('reduxComponents.dsdDetail.groupDetail.title'),onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),(dsdTriplet===null||dsd&&!dsd.remoteIsFinal&&userHasPermissionsToEdit||!isDisabledAnnotations)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{disabled:!(group&&group.id&&group.groupDimensions&&group.groupDimensions.length),onClick:function onClick(){return isCreatingComponent&&Object(__WEBPACK_IMPORTED_MODULE_12__utils_artefacts__["b" /* existsComponentWithId */])(dsd,group.id)?__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('reduxComponents.dsdDetail.component.createWarningModal.title'),content:t('reduxComponents.dsdDetail.component.createWarningModal.content')}):onSubmit();},type:"primary"},t('commons.buttons.save.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__dsd_detail_ComponentForm__["e" /* default */],{type:__WEBPACK_IMPORTED_MODULE_10__dsd_detail_ComponentForm__["c" /* DSD_COMPONENT_TYPE_GROUP */],component:group,dimensions:dsd&&dsd.dimensions,mode:isCreatingComponent?__WEBPACK_IMPORTED_MODULE_11__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */]:dsdTriplet===null||dsd&&!dsd.remoteIsFinal&&userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_11__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_11__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],disableAnnotations:isDisabledAnnotations,onChange:onChange}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsGroupDetail));

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dsd_detail_ComponentForm__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_artefacts__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{dsdTriplet:instanceState.dsdTriplet,dsd:instanceState.dsd,attribute:instanceState.attribute,isCreatingComponent:instanceState.isCreatingComponent,notDisplayedVal:instanceState.notDisplayedVal};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onCodelistsForSelectorShow:function onCodelistsForSelectorShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_74" /* showDsdDetailCodelistsForSelector */])(),instancePrefix));},onConceptSchemesForSelectorShow:function onConceptSchemesForSelectorShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_76" /* showDsdDetailConceptSchemesForSelector */])(),instancePrefix));},onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_49" /* hideDsdDetailAttribute */])(),instancePrefix));},onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_21" /* changeDsdDetailAttribute */])(fields),instancePrefix));},onNotDisplayedValChange:function onNotDisplayedValChange(val){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_24" /* changeDsdDetailComponentNotDisplayed */])(val),instancePrefix));},onSubmit:function onSubmit(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_82" /* submitDsdDetailAttribute */])(),instancePrefix));},onNotDisplayedCodesSelectorShow:function onNotDisplayedCodesSelectorShow(codelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_81" /* showDsdDetailNotDisplayedCodesSelector */])(codelistTriplet),instancePrefix));}};};var DsdsGroupDetail=function DsdsGroupDetail(_ref3){var t=_ref3.t,dsdTriplet=_ref3.dsdTriplet,dsd=_ref3.dsd,attribute=_ref3.attribute,isCreatingComponent=_ref3.isCreatingComponent,notDisplayedVal=_ref3.notDisplayedVal,onHide=_ref3.onHide,onChange=_ref3.onChange,onSubmit=_ref3.onSubmit,onNotDisplayedValChange=_ref3.onNotDisplayedValChange,onCodelistsForSelectorShow=_ref3.onCodelistsForSelectorShow,onConceptSchemesForSelectorShow=_ref3.onConceptSchemesForSelectorShow,userHasPermissionsToEdit=_ref3.userHasPermissionsToEdit,onNotDisplayedCodesSelectorShow=_ref3.onNotDisplayedCodesSelectorShow;var isDisabledAnnotations=!isCreatingComponent&&dsdTriplet!==null&&!userHasPermissionsToEdit;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_enhanced_modal__["a" /* default */],{visible:attribute!==null,width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],title:t('reduxComponents.dsdDetail.attributeDetail.title'),onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),(dsdTriplet===null||dsd&&!dsd.remoteIsFinal&&userHasPermissionsToEdit||!isDisabledAnnotations)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{disabled:!(attribute&&attribute.id&&attribute.concept&&attribute.assignmentStatus&&attribute.attachmentLevel&&(attribute.attachmentLevel!==__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["e" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_GROUP */]||attribute.attachmentGroup)&&(attribute.attachmentLevel!==__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["g" /* DSD_ATTRIBUTE_ATTACHMENT_LEVEL_SERIES */]||attribute.attachedDimensions&&attribute.attachedDimensions.length)&&(attribute.annotations||[]).filter(function(annot){return annot.id===null||annot.id!==undefined&&annot.id.length===0||annot.type===null||annot.type!==undefined&&annot.type.length===0;}).length===0),onClick:function onClick(){return isCreatingComponent&&Object(__WEBPACK_IMPORTED_MODULE_12__utils_artefacts__["b" /* existsComponentWithId */])(dsd,attribute.id)?__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('reduxComponents.dsdDetail.component.createWarningModal.title',{id:attribute.id}),content:t('reduxComponents.dsdDetail.component.createWarningModal.content')}):onSubmit();},type:"primary"},t('commons.buttons.save.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__dsd_detail_ComponentForm__["e" /* default */],{type:__WEBPACK_IMPORTED_MODULE_10__dsd_detail_ComponentForm__["a" /* DSD_COMPONENT_TYPE_ATTRIBUTE */],component:attribute,mode:isCreatingComponent?__WEBPACK_IMPORTED_MODULE_11__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */]:dsdTriplet===null||dsd&&!dsd.remoteIsFinal&&userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_11__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_11__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],disableAnnotations:isDisabledAnnotations,dimensions:dsd&&dsd.dimensions,groups:dsd&&dsd.groups,onChange:onChange,onCodelistSelect:onCodelistsForSelectorShow,onConceptSelect:onConceptSchemesForSelectorShow,notDisplayedVal:notDisplayedVal,onNotDisplayedValChange:onNotDisplayedValChange,onNotDisplayedCodesSelectorShow:onNotDisplayedCodesSelectorShow}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsGroupDetail));

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1290);

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);









var classNames = __webpack_require__(15);

function noop() {}

var Switch = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Switch, _Component);

  function Switch(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Switch);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));

    _initialiseProps.call(_this);

    var checked = false;
    if ('checked' in props) {
      checked = !!props.checked;
    } else {
      checked = !!props.defaultChecked;
    }
    _this.state = { checked: checked };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Switch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          autoFocus = _props.autoFocus,
          disabled = _props.disabled;

      if (autoFocus && !disabled) {
        this.focus();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps) {
        this.setState({
          checked: !!nextProps.checked
        });
      }
    }
  }, {
    key: 'setChecked',
    value: function setChecked(checked) {
      if (this.props.disabled) {
        return;
      }
      if (!('checked' in this.props)) {
        this.setState({
          checked: checked
        });
      }
      this.props.onChange(checked);
    }

    // Handle auto focus when click switch in Chrome

  }, {
    key: 'focus',
    value: function focus() {
      this.node.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.node.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          className = _props2.className,
          prefixCls = _props2.prefixCls,
          disabled = _props2.disabled,
          loadingIcon = _props2.loadingIcon,
          checkedChildren = _props2.checkedChildren,
          unCheckedChildren = _props2.unCheckedChildren,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['className', 'prefixCls', 'disabled', 'loadingIcon', 'checkedChildren', 'unCheckedChildren']);

      var checked = this.state.checked;
      var switchClassName = classNames((_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className, !!className), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-checked', checked), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), _classNames));
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'button',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps, {
          type: 'button',
          role: 'switch',
          'aria-checked': checked,
          disabled: disabled,
          className: switchClassName,
          ref: this.saveNode,
          onKeyDown: this.handleKeyDown,
          onClick: this.toggle,
          onMouseUp: this.handleMouseUp
        }),
        loadingIcon,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'span',
          { className: prefixCls + '-inner' },
          checked ? checkedChildren : unCheckedChildren
        )
      );
    }
  }]);

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.toggle = function () {
    var onClick = _this2.props.onClick;

    var checked = !_this2.state.checked;
    _this2.setChecked(checked);
    onClick(checked);
  };

  this.handleKeyDown = function (e) {
    if (e.keyCode === 37) {
      // Left
      _this2.setChecked(false);
    } else if (e.keyCode === 39) {
      // Right
      _this2.setChecked(true);
    }
  };

  this.handleMouseUp = function (e) {
    if (_this2.node) {
      _this2.node.blur();
    }
    if (_this2.props.onMouseUp) {
      _this2.props.onMouseUp(e);
    }
  };

  this.saveNode = function (node) {
    _this2.node = node;
  };
};

Switch.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  checkedChildren: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  unCheckedChildren: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  checked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  loadingIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
};

Switch.defaultProps = {
  prefixCls: 'rc-switch',
  checkedChildren: null,
  unCheckedChildren: null,
  className: '',
  defaultChecked: false,
  onChange: noop,
  onClick: noop
};

/* harmony default export */ __webpack_exports__["default"] = (Switch);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_items_viewer__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_items_import_form__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layout_annotation_list__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{appLanguage:state.app.language,nodes:state.config.nodes,nodeId:state.app.endpointId,codelistTriplet:instanceState.codelistTriplet,codelist:instanceState.codelist,selectedItem:instanceState.selectedItem,itemsViewMode:instanceState.itemsViewMode,isItemsImportFormVisible:instanceState.isItemsImportFormVisible,itemsImportForm:instanceState.itemsImportForm,itemAnnotations:instanceState.itemAnnotations,itemLayoutAnnotations:instanceState.itemLayoutAnnotations,itemAnnotationId:instanceState.itemAnnotationId,itemsTree:instanceState.itemsTree,maxOrder:instanceState.maxOrder,cutItem:instanceState.cutItem,itemPage:instanceState.itemPage,fetchPageParams:instanceState.fetchPageParams,itemCount:instanceState.itemCount,autoSave:instanceState.autoSave,isFileSystemTreeVisible:instanceState.isFileSystemTreeVisible,fileSystemSelectedItem:instanceState.fileSystemSelectedItem,unsavedChange:instanceState.unsavedChange,rebuildDb:instanceState.rebuildDb,currentTab:instanceState.currentTab};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onCreate:function onCreate(id,order,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_45" /* createCodelistDetailItemsItem */])(id,order,lang),instancePrefix));},onDetailEdit:function onDetailEdit(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_50" /* editCodelistDetailItemsItem */])(item),instancePrefix));},onDelete:function onDelete(codelist,itemId,itemsTree,cutItem,lang,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_47" /* deleteCodelistDetailsItemsItem */])(codelist,itemId,itemsTree,cutItem,lang,t),instancePrefix));},onSelect:function onSelect(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_84" /* selectCodelistDetailsItemsItem */])(id),instancePrefix));},onDrop:function onDrop(artefactTriplet,itemId,newParentId,moveBefore,moveAfter,lang,autoSave,itemsTree,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_48" /* dropCodelistDetailItemsItem */])(artefactTriplet,itemId,newParentId,moveBefore,moveAfter,lang,autoSave,itemsTree,cutItem,t),instancePrefix));},onCut:function onCut(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_46" /* cutCodelistDetailItemsItem */])(item),instancePrefix));},onPaste:function onPaste(artefactTriplet,lang,cutItemId,newParentId,pasteAfterId,autoSave){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_66" /* pasteCodelistDetailItemsItem */])(artefactTriplet,lang,cutItemId,newParentId,pasteAfterId,autoSave),instancePrefix));},onAnnotationsShow:function onAnnotationsShow(annotations,itemId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_95" /* showCodelistDetailItemsItemAnnotations */])(annotations,itemId),instancePrefix));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_62" /* hideCodelistDetailItemsItemAnnotations */])(),instancePrefix));},onLayoutAnnotationsShow:function onLayoutAnnotationsShow(annotations,itemId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_96" /* showCodelistDetailItemsItemLayoutAnnotations */])(annotations,itemId),instancePrefix));},onLayoutAnnotationsHide:function onLayoutAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_63" /* hideCodelistDetailItemsItemLayoutAnnotations */])(),instancePrefix));},onImportFormShow:function onImportFormShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_93" /* showCodelistDetailItemsImportForm */])(),instancePrefix));},onImportFormHide:function onImportFormHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_59" /* hideCodelistDetailItemsImportForm */])(),instancePrefix));},onImportFormChange:function onImportFormChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_40" /* changeCodelistDetailItemsImportForm */])(fields),instancePrefix));},onImportFormFileUpload:function onImportFormFileUpload(codelist,itemsImportForm){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_113" /* uploadCodelistDetailItemsImportFormFile */])(codelist,itemsImportForm),instancePrefix));},onImportFormFileImport:function onImportFormFileImport(codelist,itemsImportForm){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_65" /* importCodelistDetailItemsImportFormFile */])(codelist,itemsImportForm),instancePrefix));},onViewModeChange:function onViewModeChange(viewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_42" /* changeCodelistDetailItemsViewMode */])(viewMode),instancePrefix));},fetchItemPage:function fetchItemPage(_ref3){var artefactTriplet=_ref3.artefactTriplet,lang=_ref3.lang,pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,itemsOrderAnnotationType=_ref3.itemsOrderAnnotationType,searchText=_ref3.searchText,filters=_ref3.filters,sortCol=_ref3.sortCol,sortByDesc=_ref3.sortByDesc,rebuildDb=_ref3.rebuildDb;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_73" /* readCodelistDetailItemPage */])(artefactTriplet,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc,rebuildDb),instancePrefix));},fetchPageParamsUpdate:function fetchPageParamsUpdate(fetchPageParams){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_111" /* updateCodelistDetailItemPageParams */])(fetchPageParams),instancePrefix));},fetchItemTree:function fetchItemTree(_ref4){var artefactTriplet=_ref4.artefactTriplet,lang=_ref4.lang,itemsOrderAnnotationType=_ref4.itemsOrderAnnotationType,rebuildDb=_ref4.rebuildDb;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_74" /* readCodelistDetailItemTree */])(artefactTriplet,lang,itemsOrderAnnotationType,rebuildDb),instancePrefix));},onFileSystemtreeShow:function onFileSystemtreeShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_92" /* showCodelistDetailItemsFileSystemTree */])(),instancePrefix));},onFileSystemtreeHide:function onFileSystemtreeHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_58" /* hideCodelistDetailItemsFileSystemTree */])(),instancePrefix));},onFileSystemSelect:function onFileSystemSelect(selectedItem){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_83" /* selectCodelistDetailItemsFileSystemTreeItem */])(selectedItem),instancePrefix));},onItemSubmit:function onItemSubmit(triplet,item,lang,isItemEditMode,autoSave,itemsOrderAnnotationType,itemsTree,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_105" /* submitCodelistDetailItemsItem */])(triplet,item,lang,isItemEditMode,autoSave,itemsOrderAnnotationType,itemsTree,cutItem,t),instancePrefix));},onImportFormAllCsvRowsShow:function onImportFormAllCsvRowsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_94" /* showCodelistDetailItemsImportFormAllCsvRows */])(),instancePrefix));},onImportFormAllCsvRowsHide:function onImportFormAllCsvRowsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_60" /* hideCodelistDetailItemsImportFormAllCsvRows */])(),instancePrefix));},uploadImportFormCsv:function uploadImportFormCsv(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_112" /* uploadCodelistDetailItemsImportFormCsv */])(file),instancePrefix));},fetchImportFormAllCsvRows:function fetchImportFormAllCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_75" /* readCodelistDetailItemsImportFormAllCsvRows */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath),instancePrefix));},onSetDefaultOrder:function onSetDefaultOrder(artefactTriplet,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["_85" /* setCodelistDetailItemsDefaultOrder */])(artefactTriplet,lang),instancePrefix));}};};var CodelistDetailItems=function CodelistDetailItems(_ref5){var t=_ref5.t,appLanguage=_ref5.appLanguage,nodes=_ref5.nodes,nodeId=_ref5.nodeId,instanceState=_ref5.instanceState,instancePrefix=_ref5.instancePrefix,codelistTriplet=_ref5.codelistTriplet,codelist=_ref5.codelist,itemCount=_ref5.itemCount,itemPage=_ref5.itemPage,itemsTree=_ref5.itemsTree,selectedItem=_ref5.selectedItem,cutItem=_ref5.cutItem,itemAnnotations=_ref5.itemAnnotations,itemLayoutAnnotations=_ref5.itemLayoutAnnotations,itemAnnotationId=_ref5.itemAnnotationId,itemsViewMode=_ref5.itemsViewMode,isItemsImportFormVisible=_ref5.isItemsImportFormVisible,itemsImportForm=_ref5.itemsImportForm,onCreate=_ref5.onCreate,onDetailEdit=_ref5.onDetailEdit,onDelete=_ref5.onDelete,onSelect=_ref5.onSelect,onDrop=_ref5.onDrop,onCut=_ref5.onCut,onPaste=_ref5.onPaste,onAnnotationsShow=_ref5.onAnnotationsShow,onAnnotationsHide=_ref5.onAnnotationsHide,onLayoutAnnotationsShow=_ref5.onLayoutAnnotationsShow,onLayoutAnnotationsHide=_ref5.onLayoutAnnotationsHide,onImportFormShow=_ref5.onImportFormShow,onImportFormHide=_ref5.onImportFormHide,onImportFormChange=_ref5.onImportFormChange,onImportFormFileUpload=_ref5.onImportFormFileUpload,onImportFormFileImport=_ref5.onImportFormFileImport,onViewModeChange=_ref5.onViewModeChange,fetchItemTree=_ref5.fetchItemTree,fetchItemPage=_ref5.fetchItemPage,fetchPageParams=_ref5.fetchPageParams,fetchPageParamsUpdate=_ref5.fetchPageParamsUpdate,autoSave=_ref5.autoSave,isFileSystemTreeVisible=_ref5.isFileSystemTreeVisible,onFileSystemtreeShow=_ref5.onFileSystemtreeShow,onFileSystemtreeHide=_ref5.onFileSystemtreeHide,fileSystemSelectedItem=_ref5.fileSystemSelectedItem,onFileSystemSelect=_ref5.onFileSystemSelect,unsavedChange=_ref5.unsavedChange,rebuildDb=_ref5.rebuildDb,onItemSubmit=_ref5.onItemSubmit,onImportFormAllCsvRowsShow=_ref5.onImportFormAllCsvRowsShow,onImportFormAllCsvRowsHide=_ref5.onImportFormAllCsvRowsHide,uploadImportFormCsv=_ref5.uploadImportFormCsv,fetchImportFormAllCsvRows=_ref5.fetchImportFormAllCsvRows,isEditDisabled=_ref5.isEditDisabled,currentTab=_ref5.currentTab,onSetDefaultOrder=_ref5.onSetDefaultOrder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;var annotationsConfig=nodes.find(function(node){return node.general.id===nodeId;}).annotations;var itemsOrderAnnotationType=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(nodes,function(node){return node.general.id===nodeId;}).annotations.codelistsOrder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_items_viewer__["a" /* default */],{artefact:codelist,artefactTriplet:codelistTriplet,itemTree:itemsTree,fetchTree:fetchItemTree,itemPage:itemPage,fetchPageParams:fetchPageParams,fetchPageParamsUpdate:fetchPageParamsUpdate,fetchPage:fetchItemPage,itemCount:itemCount,childrenKey:"codes",selectedItem:selectedItem,cutItem:cutItem,itemsViewMode:itemsViewMode,itemsOrderAnnotationType:itemsOrderAnnotationType,onPaginatedCreate:onCreate,onPaginatedDelete:onDelete,onDetailShow:onDetailEdit,onSelect:onSelect,onPaginatedDrop:onDrop,onCut:onCut,onPaginatedPaste:onPaste,onAnnotationsShow:onAnnotationsShow,onLayoutAnnotationsShow:onLayoutAnnotationsShow,onViewModeChange:onViewModeChange,onImportFormShow:onImportFormShow,autoSave:autoSave,isFileSystemTreeVisible:isFileSystemTreeVisible,onFileSystemtreeShow:onFileSystemtreeShow,onFileSystemtreeHide:onFileSystemtreeHide,fileSystemSelectedItem:fileSystemSelectedItem,onFileSystemSelect:onFileSystemSelect,unsavedChange:unsavedChange,rebuildDb:rebuildDb,onSetDefault:function onSetDefault(item){var newItem=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);newItem.annotations=Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["Z" /* setLayoutAnnotationDefaultForCodelist */])(newItem.annotations,annotationsConfig,true);onItemSubmit(codelistTriplet,newItem,lang,true,autoSave,itemsOrderAnnotationType,itemsTree,cutItem,t);},onUnsetDefault:function onUnsetDefault(item){var newItem=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);newItem.annotations=Object(__WEBPACK_IMPORTED_MODULE_11__utils_annotations__["Z" /* setLayoutAnnotationDefaultForCodelist */])(newItem.annotations,annotationsConfig,false);onItemSubmit(codelistTriplet,newItem,lang,true,autoSave,itemsOrderAnnotationType,itemsTree,cutItem,t);},isEditDisabled:isEditDisabled,isCallDisabled:currentTab!=="items",onPaginatedSetDefaultOrder:onSetDefaultOrder}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_items_import_form__["a" /* default */],{isVisible:isItemsImportFormVisible,formData:itemsImportForm,onHide:onImportFormHide,onChange:onImportFormChange,onUpload:function onUpload(){return onImportFormFileUpload(codelist,itemsImportForm);},onImport:function onImport(){return onImportFormFileImport(codelist,itemsImportForm);},onAllCsvRowsShow:onImportFormAllCsvRowsShow,onAllCsvRowsHide:onImportFormAllCsvRowsHide,uploadCsv:uploadImportFormCsv,fetchAllCsvRows:fetchImportFormAllCsvRows}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix,isEditDisabled:isEditDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_custom_annotation_list__["a" /* default */],{annotations:itemAnnotations,onClose:onAnnotationsHide,title:itemAnnotationId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_layout_annotation_list__["a" /* default */],{annotations:itemLayoutAnnotations,onClose:onLayoutAnnotationsHide,title:itemAnnotationId}));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CodelistDetailItems));

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_item_form__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_artefactValidators__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{appLanguage:state.app.language,nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,codelist:instanceState.codelist,codelistTriplet:instanceState.codelistTriplet,item:instanceState.item,isItemEditMode:instanceState.isItemEditMode,isItemsParentListVisible:instanceState.isItemsParentListVisible,itemsTree:instanceState.itemsTree,cutItem:instanceState.cutItem,itemCount:instanceState.itemCount,parentPage:instanceState.parentPage,autoSave:instanceState.autoSave};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onItemDetailChange:function onItemDetailChange(fields,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_41" /* changeCodelistDetailItemsItem */])(fields,lang,itemsOrderAnnotationType),instancePrefix));},onItemSubmit:function onItemSubmit(triplet,item,lang,isItemEditMode,autoSave,itemsOrderAnnotationType,itemsTree,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_105" /* submitCodelistDetailItemsItem */])(triplet,item,lang,isItemEditMode,autoSave,itemsOrderAnnotationType,itemsTree,cutItem,t),instancePrefix));},onItemDetailHide:function onItemDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_61" /* hideCodelistDetailItemsItem */])(),instancePrefix));},onItemsParentListShow:function onItemsParentListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_97" /* showCodelistDetailItemsItemParentList */])(),instancePrefix));},onItemsParentListHide:function onItemsParentListHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_64" /* hideCodelistDetailItemsItemParentList */])(),instancePrefix));},onItemsParentListSet:function onItemsParentListSet(parentId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_86" /* setCodelistDetailItemsItemParentList */])(parentId),instancePrefix));},onItemsParentListUnset:function onItemsParentListUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_108" /* unsetCodelistDetailItemsItemParentList */])(),instancePrefix));},fetchParentPage:function fetchParentPage(artefactTriplet,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_76" /* readCodelistDetailItemsItemParentListPage */])(artefactTriplet,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc),instancePrefix));}};};var CodelistDetailItem=function CodelistDetailItem(_ref3){var t=_ref3.t,appLanguage=_ref3.appLanguage,codelist=_ref3.codelist,codelistTriplet=_ref3.codelistTriplet,item=_ref3.item,isItemEditMode=_ref3.isItemEditMode,onItemDetailChange=_ref3.onItemDetailChange,onItemSubmit=_ref3.onItemSubmit,onItemDetailHide=_ref3.onItemDetailHide,nodes=_ref3.nodes,nodeId=_ref3.nodeId,permissions=_ref3.permissions,isItemsParentListVisible=_ref3.isItemsParentListVisible,onItemsParentListShow=_ref3.onItemsParentListShow,onItemsParentListHide=_ref3.onItemsParentListHide,onItemsParentListSet=_ref3.onItemsParentListSet,onItemsParentListUnset=_ref3.onItemsParentListUnset,itemsTree=_ref3.itemsTree,cutItem=_ref3.cutItem,fetchParentPage=_ref3.fetchParentPage,parentPage=_ref3.parentPage,itemCount=_ref3.itemCount,autoSave=_ref3.autoSave,isEditDisabled=_ref3.isEditDisabled;var annotationsConfig=nodes.find(function(node){return node.general.id===nodeId;}).annotations;var itemsOrderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.codelistsOrder;var userHasPermissionsToEdit=permissions&&codelist&&permissions.agencies.filter(function(agency){return agency===codelist.agencyID;}).length>0&&!isEditDisabled;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__["a" /* default */],{title:isItemEditMode&&item?userHasPermissionsToEdit?t("commons.artefact.tabs.items.item.detail.title.editMode.title",{id:item.id}):t("commons.artefact.tabs.items.item.detail.title.viewMode.title",{id:item.id}):t("commons.artefact.tabs.items.item.detail.title.createMode.title"),visible:item!==null,onCancel:onItemDetailHide,width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onItemDetailHide},t('commons.buttons.close.title')),!isItemEditMode||userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_15__utils_artefactValidators__["g" /* isItemValid */])(item)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onItemSubmit(codelistTriplet,item,dataLanguage,isItemEditMode,autoSave,itemsOrderAnnotationType,itemsTree,cutItem,t);}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_item_form__["f" /* default */],{item:item?item:null,mode:isItemEditMode?userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_10__components_item_form__["c" /* ITEM_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_10__components_item_form__["e" /* ITEM_FORM_MODE_READ */]:__WEBPACK_IMPORTED_MODULE_10__components_item_form__["a" /* ITEM_FORM_MODE_CREATE */],onChange:function onChange(fields){return onItemDetailChange(fields,lang,itemsOrderAnnotationType);},itemsParentListShow:onItemsParentListShow,itemsParentListUnset:onItemsParentListUnset,annotationsConfig:annotationsConfig})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__["a" /* default */],{visible:isItemsParentListVisible?isItemsParentListVisible:false,onCancel:onItemsParentListHide,title:t('commons.artefact.tabs.items.item.detail.modals.parentList.title'),width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onItemsParentListHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_item_list__["a" /* default */],{data:parentPage?parentPage:null,rowCount:itemCount,isPaginated:true,onRowClick:function onRowClick(item){return onItemsParentListSet(item);},onChange:function onChange(_ref4){var pageNum=_ref4.pageNum,pageSize=_ref4.pageSize,searchText=_ref4.searchText,filters=_ref4.filters,sortCol=_ref4.sortCol,sortByDesc=_ref4.sortByDesc;return fetchParentPage(codelistTriplet,item.id,dataLanguage,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc);}})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CodelistDetailItem));

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_flag_icon_css_css_flag_icon_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_flag_icon_css_css_flag_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_languages__ = __webpack_require__(91);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */var MultilanguageInputNumber=function(_React$Component){_inherits(MultilanguageInputNumber,_React$Component);function MultilanguageInputNumber(props){_classCallCheck(this,MultilanguageInputNumber);var _this=_possibleConstructorReturn(this,(MultilanguageInputNumber.__proto__||Object.getPrototypeOf(MultilanguageInputNumber)).call(this,props));_this.state=MultilanguageInputNumber.getInitState(props);_this.callOnChange=_this.callOnChange.bind(_this);_this.setLanguage=_this.setLanguage.bind(_this);_this.setValueForLanguage=_this.setValueForLanguage.bind(_this);return _this;}_createClass(MultilanguageInputNumber,[{key:'callOnChange',value:function callOnChange(value){if(this.props.onChange){this.props.onChange(value);}}},{key:'setLanguage',value:function setLanguage(lang){var state=Object.assign({},this.state);state.language=lang;this.setState(state);this.callOnChange(state.value);}},{key:'setValueForLanguage',value:function setValueForLanguage(newValue,language){var state=Object.assign({},this.state);state.value[language]=newValue;this.setState(state);this.callOnChange(state.value);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,disabled=_props.disabled,dataLanguages=_props.dataLanguages,min=_props.min,onBlur=_props.onBlur;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(contextDataLanguage){var language=contextDataLanguage||_this2.state.language;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a.Group,{compact:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default.a,{value:value[language],onChange:function onChange(value){return _this2.setValueForLanguage(value,language);},title:value[language],disabled:disabled,style:{width:contextDataLanguage?'100%':'calc(100% - 100px)'},min:min,onBlur:onBlur}),!contextDataLanguage&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{value:language,onChange:_this2.setLanguage,style:{width:100}},dataLanguages.map(function(_ref){var code=_ref.code;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{key:code,value:code,title:Object(__WEBPACK_IMPORTED_MODULE_13__utils_languages__["c" /* getLanguageLabel */])(t,code)},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i',{className:'flag-icon '+Object(__WEBPACK_IMPORTED_MODULE_13__utils_languages__["b" /* getLanguageFlagIconCss */])(code,dataLanguages),style:{marginRight:8}}),code!==null?code.toUpperCase():null);})));});}}],[{key:'getInitState',value:function getInitState(props){return{value:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.fromPairs(props.dataLanguages.map(function(_ref2){var code=_ref2.code;return[code,''];})),language:(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.find(props.dataLanguages,function(_ref3){var code=_ref3.code;return code===props.appLanguage;})||{}).code||'en'// isInitialized: false OBSOLETE
};}},{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props){if(props.value!==null&&props.value!==undefined){return{value:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.merge(MultilanguageInputNumber.getInitState(props).value,props.value)// isInitialized: true OBSOLETE
};}else{return MultilanguageInputNumber.getInitState(props);}}}]);return MultilanguageInputNumber;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps))(MultilanguageInputNumber));

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_breadcrumb_style__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_empty_style__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_empty_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_empty_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_empty__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_window__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_css__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__custom_empty__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.jQuery;var FileSystemTree=function(_React$Component){_inherits(FileSystemTree,_React$Component);function FileSystemTree(props){_classCallCheck(this,FileSystemTree);var _this=_possibleConstructorReturn(this,(FileSystemTree.__proto__||Object.getPrototypeOf(FileSystemTree)).call(this,props));_this.state={currentPath:[],backStack:[],forwardStack:[]};_this.navigate=_this.navigate.bind(_this);_this.goBack=_this.goBack.bind(_this);_this.goForward=_this.goForward.bind(_this);_this.onSelect=_this.onSelect.bind(_this);return _this;}_createClass(FileSystemTree,[{key:'navigate',value:function navigate(newPath){var state=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.cloneDeep(this.state);state.backStack.push(state.currentPath);state.forwardStack=[];state.currentPath=newPath;this.setState(state);this.onSelect(null);$('.file-system-tree__list').scrollTop(0);}},{key:'goBack',value:function goBack(){var state=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.cloneDeep(this.state);state.forwardStack.push(state.currentPath);state.currentPath=state.backStack.pop();this.onSelect(null);this.setState(state);}},{key:'goForward',value:function goForward(){var state=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.cloneDeep(this.state);state.backStack.push(state.currentPath);state.currentPath=state.forwardStack.pop();this.onSelect(null);this.setState(state);}},{key:'onSelect',value:function onSelect(key){if(this.props.onSelect){if(!(key===null&&this.props.selected===null)){this.props.onSelect(this.props.selected!==key?key:null);}}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,height=_props.height,getItemKey=_props.getItemKey,getItemIcon=_props.getItemIcon,getItemLabel=_props.getItemLabel,getItemLabelForPath=_props.getItemLabelForPath,getItemIsLeaf=_props.getItemIsLeaf,getItems=_props.getItems,itemActions=_props.itemActions,fixedItemActions=_props.fixedItemActions,actions=_props.actions,treeActions=_props.treeActions,selected=_props.selected,t=_props.t;var _state=this.state,currentPath=_state.currentPath,backStack=_state.backStack,forwardStack=_state.forwardStack;var items=getItems(currentPath.length?currentPath[currentPath.length-1].key:null);var itemStyle={borderRadius:2,paddingLeft:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["PADDING_XS"],paddingRight:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["PADDING_XS"]};var Item=function Item(_ref){var index=_ref.index,style=_ref.style;if(index!==undefined){var isItemLeaf=getItemIsLeaf(items[index]);var itemLabel=getItemLabel(items[index]);var isItemSelected=getItemKey(items[index])===selected;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a.Item,{style:style,className:'file-system-tree__item'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{marginLeft:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]/2,marginRight:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]/2,width:'100%'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'space-between',onClick:isItemLeaf?null:function(){return _this2.navigate([].concat(_toConsumableArray(currentPath),[{key:getItemKey(items[index]),label:getItemLabelForPath(items[index])}]));},style:Object.assign({},itemStyle,{cursor:isItemLeaf?'default':'pointer'})},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox___default.a,{checked:isItemSelected,onClick:function onClick(e){_this2.onSelect(getItemKey(items[index]));e.stopPropagation();}})),getItemIcon&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{paddingTop:2}},getItemIcon(items[index]))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{title:itemLabel},itemLabel.length>80?itemLabel.substr(0,80)+'...':itemLabel)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]},(fixedItemActions||[]).filter(function(fixedAction){return fixedAction;}).map(function(fixedAction){return typeof fixedAction==="function"?fixedAction(items[index]):fixedAction;}).filter(function(action){return action;}).map(function(action,key){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{key:key},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,Object.assign({},action,{onClick:function onClick(e){e.preventDefault();e.stopPropagation();action.onClick(items[index]);},size:'small',shape:'circle',type:'primary'})));}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:"file-system-tree__item__actions",style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]},(itemActions||[]).filter(function(action){return action;}).map(function(action){return typeof action==="function"?action(items[index]):action;}).filter(function(action){return action;}).map(function(action,key){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{key:key},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,Object.assign({},action,{onClick:function onClick(e){e.preventDefault();e.stopPropagation();action.onClick(items[index]);},size:'small',shape:'circle',type:'primary'})));})))))));}else{return null;}};return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:'noselect'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'space-between',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_XS"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{icon:'left',title:t("commons.buttons.goBack.title"),disabled:!backStack.length,onClick:this.goBack})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{icon:'right',title:t("commons.buttons.goForward.title"),disabled:!forwardStack.length,onClick:this.goForward})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]},(treeActions||[]).filter(function(action){return action;}).map(function(action,key){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{key:key},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,Object.assign({},action,{onClick:function onClick(e){e.preventDefault();e.stopPropagation();action.onClick();},type:'primary'})));}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]},(actions||[]).filter(function(action){return action;}).map(function(action,key){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{key:key},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,Object.assign({},action,{onClick:function onClick(e){e.preventDefault();e.stopPropagation();action.onClick();}})));})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_SM"]},bodyStyle:{padding:0,height:height}},!items&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_empty___default.a,{image:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',null),description:t('components.fileSystemTree.placeholder.unknownItem')}),items&&items.length===0&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__custom_empty__["a" /* default */],null),items&&items.length>0&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_window__["a" /* FixedSizeList */],{className:'file-system-tree__list',itemCount:items.length,itemSize:32,height:height},Item)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{bodyStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["PADDING_MD"],paddingTop:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["PADDING_SM"],paddingBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["PADDING_SM"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:'file-system-tree__breadcrumb'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb___default.a,{separator:'>'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb___default.a.Item,{className:'file-system-tree__item',onClick:currentPath.length>0?function(){return _this2.navigate([]);}:null,style:Object.assign({},itemStyle,{cursor:currentPath.length>0?'pointer':'default'})},t('components.fileSystemTree.breadcrumb.rootItem.label')),currentPath.map(function(_ref2,index){var label=_ref2.label;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb___default.a.Item,{className:'file-system-tree__item',onClick:index<currentPath.length?function(){return _this2.navigate(currentPath.slice(0,index+1));}:null,key:index,style:Object.assign({},itemStyle,{cursor:index<currentPath.length-1?'pointer':'default'})},label);})))));}}]);return FileSystemTree;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])()(FileSystemTree));

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1297);

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Breadcrumb = _interopRequireDefault(__webpack_require__(1299));

var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(557));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Breadcrumb["default"].Item = _BreadcrumbItem["default"];
var _default = _Breadcrumb["default"];
exports["default"] = _default;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(557));

var _configProvider = __webpack_require__(35);

var _warning = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function getBreadcrumbName(route, params) {
  if (!route.breadcrumbName) {
    return null;
  }

  var paramsKeys = Object.keys(params).join('|');
  var name = route.breadcrumbName.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function (replacement, key) {
    return params[key] || replacement;
  });
  return name;
}

function defaultItemRender(route, params, routes, paths) {
  var isLastItem = routes.indexOf(route) === routes.length - 1;
  var name = getBreadcrumbName(route, params);
  return isLastItem ? React.createElement("span", null, name) : React.createElement("a", {
    href: "#/".concat(paths.join('/'))
  }, name);
}

var Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Breadcrumb, _React$Component);

  function Breadcrumb() {
    var _this;

    _classCallCheck(this, Breadcrumb);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Breadcrumb).apply(this, arguments));

    _this.renderBreadcrumb = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var crumbs;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          separator = _this$props.separator,
          style = _this$props.style,
          className = _this$props.className,
          routes = _this$props.routes,
          _this$props$params = _this$props.params,
          params = _this$props$params === void 0 ? {} : _this$props$params,
          children = _this$props.children,
          _this$props$itemRende = _this$props.itemRender,
          itemRender = _this$props$itemRende === void 0 ? defaultItemRender : _this$props$itemRende;
      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);

      if (routes && routes.length > 0) {
        var paths = [];
        crumbs = routes.map(function (route) {
          route.path = route.path || '';
          var path = route.path.replace(/^\//, '');
          Object.keys(params).forEach(function (key) {
            path = path.replace(":".concat(key), params[key]);
          });

          if (path) {
            paths.push(path);
          }

          return React.createElement(_BreadcrumbItem["default"], {
            separator: separator,
            key: route.breadcrumbName || path
          }, itemRender(route, params, routes, paths));
        });
      } else if (children) {
        crumbs = React.Children.map(children, function (element, index) {
          if (!element) {
            return element;
          }

          (0, _warning["default"])(element.type && element.type.__ANT_BREADCRUMB_ITEM, "Breadcrumb only accepts Breadcrumb.Item as it's children");
          return (0, React.cloneElement)(element, {
            separator: separator,
            key: index
          });
        });
      }

      return React.createElement("div", {
        className: (0, _classnames["default"])(className, prefixCls),
        style: style
      }, crumbs);
    };

    return _this;
  }

  _createClass(Breadcrumb, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var props = this.props;
      (0, _warning["default"])(!('linkRender' in props || 'nameRender' in props), '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumb);
    }
  }]);

  return Breadcrumb;
}(React.Component);

exports["default"] = Breadcrumb;
Breadcrumb.defaultProps = {
  separator: '/'
};
Breadcrumb.propTypes = {
  prefixCls: PropTypes.string,
  separator: PropTypes.node,
  routes: PropTypes.array,
  params: PropTypes.object,
  linkRender: PropTypes.func,
  nameRender: PropTypes.func
};

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1302);

__webpack_require__(47);

__webpack_require__(26);

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pagination = _interopRequireDefault(__webpack_require__(1304));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Pagination["default"];
exports["default"] = _default;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcPagination = _interopRequireDefault(__webpack_require__(1305));

var _en_US = _interopRequireDefault(__webpack_require__(367));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _MiniSelect = _interopRequireDefault(__webpack_require__(1310));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _select = _interopRequireDefault(__webpack_require__(44));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(142));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));

    _this.getIconsProps = function (prefixCls) {
      var prevIcon = React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, React.createElement(_icon["default"], {
        type: "left"
      }));
      var nextIcon = React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, React.createElement(_icon["default"], {
        type: "right"
      }));
      var jumpPrevIcon = React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-item-container")
      }, React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-item-link-icon"),
        type: "double-left"
      }), React.createElement("span", {
        className: "".concat(prefixCls, "-item-ellipsis")
      }, "\u2022\u2022\u2022")));
      var jumpNextIcon = React.createElement("a", {
        className: "".concat(prefixCls, "-item-link")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-item-container")
      }, React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-item-link-icon"),
        type: "double-right"
      }), React.createElement("span", {
        className: "".concat(prefixCls, "-item-ellipsis")
      }, "\u2022\u2022\u2022")));
      return {
        prevIcon: prevIcon,
        nextIcon: nextIcon,
        jumpPrevIcon: jumpPrevIcon,
        jumpNextIcon: jumpNextIcon
      };
    };

    _this.renderPagination = function (contextLocale) {
      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeSelectPrefixCls = _a.selectPrefixCls,
          className = _a.className,
          size = _a.size,
          customLocale = _a.locale,
          restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);

      var locale = _extends({}, contextLocale, customLocale);

      var isSmall = size === 'small';
      return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefixCls = getPrefixCls('pagination', customizePrefixCls);
        var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        return React.createElement(_rcPagination["default"], _extends({}, restProps, {
          prefixCls: prefixCls,
          selectPrefixCls: selectPrefixCls
        }, _this.getIconsProps(prefixCls), {
          className: (0, _classnames["default"])(className, {
            mini: isSmall
          }),
          selectComponentClass: isSmall ? _MiniSelect["default"] : _select["default"],
          locale: locale
        }));
      });
    };

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      return React.createElement(_LocaleReceiver["default"], {
        componentName: "Pagination",
        defaultLocale: _en_US["default"]
      }, this.renderPagination);
    }
  }]);

  return Pagination;
}(React.Component);

exports["default"] = Pagination;

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(1306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Pagination__["a"]; });


/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pager__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Options__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__KeyCode__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__locale_zh_CN__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_lifecycles_compat__ = __webpack_require__(49);













function noop() {}

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function defaultItemRender(page, type, element) {
  return element;
}

function calculatePage(p, state, props) {
  var pageSize = p;
  if (typeof pageSize === 'undefined') {
    pageSize = state.pageSize;
  }
  return Math.floor((props.total - 1) / pageSize) + 1;
}

var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    _initialiseProps.call(_this);

    var hasOnChange = props.onChange !== noop;
    var hasCurrent = 'current' in props;
    if (hasCurrent && !hasOnChange) {
      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
    }

    var current = props.defaultCurrent;
    if ('current' in props) {
      current = props.current;
    }

    var pageSize = props.defaultPageSize;
    if ('pageSize' in props) {
      pageSize = props.pageSize;
    }

    _this.state = {
      current: current,
      currentInputValue: current,
      pageSize: pageSize
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Pagination, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // When current page change, fix focused style of prev item
      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
      var prefixCls = this.props.prefixCls;

      if (prevState.current !== this.state.current && this.paginationNode) {
        var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
          lastCurrentNode.blur();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // When hideOnSinglePage is true and there is only 1 page, hide the pager
      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
        return null;
      }

      var props = this.props;
      var locale = props.locale;

      var prefixCls = props.prefixCls;
      var allPages = calculatePage(undefined, this.state, this.props);
      var pagerList = [];
      var jumpPrev = null;
      var jumpNext = null;
      var firstPager = null;
      var lastPager = null;
      var gotoButton = null;

      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
      var pageBufferSize = props.showLessItems ? 1 : 2;
      var _state = this.state,
          current = _state.current,
          pageSize = _state.pageSize;


      var prevPage = current - 1 > 0 ? current - 1 : 0;
      var nextPage = current + 1 < allPages ? current + 1 : allPages;

      var dataOrAriaAttributeProps = Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          prev[key] = props[key];
        }
        return prev;
      }, {});

      if (props.simple) {
        if (goButton) {
          if (typeof goButton === 'boolean') {
            gotoButton = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'button',
              {
                type: 'button',
                onClick: this.handleGoTO,
                onKeyUp: this.handleGoTO
              },
              locale.jump_to_confirm
            );
          } else {
            gotoButton = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'span',
              {
                onClick: this.handleGoTO,
                onKeyUp: this.handleGoTO
              },
              goButton
            );
          }
          gotoButton = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
              className: prefixCls + '-simple-pager'
            },
            gotoButton
          );
        }

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'ul',
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: prefixCls + ' ' + prefixCls + '-simple ' + props.className,
            style: props.style,
            ref: this.savePaginationNode
          }, dataOrAriaAttributeProps),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? locale.prev_page : null,
              onClick: this.prev,
              tabIndex: this.hasPrev() ? 0 : null,
              onKeyPress: this.runIfEnterPrev,
              className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
              'aria-disabled': !this.hasPrev()
            },
            props.itemRender(prevPage, 'prev', this.getItemIcon(props.prevIcon))
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? this.state.current + '/' + allPages : null,
              className: prefixCls + '-simple-pager'
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
              type: 'text',
              value: this.state.currentInputValue,
              onKeyDown: this.handleKeyDown,
              onKeyUp: this.handleKeyUp,
              onChange: this.handleKeyUp,
              size: '3'
            }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'span',
              { className: prefixCls + '-slash' },
              '\uFF0F'
            ),
            allPages
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? locale.next_page : null,
              onClick: this.next,
              tabIndex: this.hasPrev() ? 0 : null,
              onKeyPress: this.runIfEnterNext,
              className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
              'aria-disabled': !this.hasNext()
            },
            props.itemRender(nextPage, 'next', this.getItemIcon(props.nextIcon))
          ),
          gotoButton
        );
      }

      if (allPages <= 5 + pageBufferSize * 2) {
        var pagerProps = {
          locale: locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        };
        if (!allPages) {
          pagerList.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, pagerProps, {
            key: 'noPager',
            page: allPages,
            className: prefixCls + '-disabled'
          })));
        }
        for (var i = 1; i <= allPages; i++) {
          var active = this.state.current === i;
          pagerList.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, pagerProps, {
            key: i,
            page: i,
            active: active
          })));
        }
      } else {
        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
        if (props.showPrevNextJumpers) {
          var jumpPrevClassString = prefixCls + '-jump-prev';
          if (props.jumpPrevIcon) {
            jumpPrevClassString += ' ' + prefixCls + '-jump-prev-custom-icon';
          }
          jumpPrev = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? prevItemTitle : null,
              key: 'prev',
              onClick: this.jumpPrev,
              tabIndex: '0',
              onKeyPress: this.runIfEnterJumpPrev,
              className: jumpPrevClassString
            },
            props.itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(props.jumpPrevIcon))
          );
          var jumpNextClassString = prefixCls + '-jump-next';
          if (props.jumpNextIcon) {
            jumpNextClassString += ' ' + prefixCls + '-jump-next-custom-icon';
          }
          jumpNext = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? nextItemTitle : null,
              key: 'next',
              tabIndex: '0',
              onClick: this.jumpNext,
              onKeyPress: this.runIfEnterJumpNext,
              className: jumpNextClassString
            },
            props.itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(props.jumpNextIcon))
          );
        }
        lastPager = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], {
          locale: props.locale,
          last: true,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: allPages,
          page: allPages,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });
        firstPager = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], {
          locale: props.locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: 1,
          page: 1,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });

        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);

        if (current - 1 <= pageBufferSize) {
          right = 1 + pageBufferSize * 2;
        }

        if (allPages - current <= pageBufferSize) {
          left = allPages - pageBufferSize * 2;
        }

        for (var _i = left; _i <= right; _i++) {
          var _active = current === _i;
          pagerList.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], {
            locale: props.locale,
            rootPrefixCls: prefixCls,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: _i,
            page: _i,
            active: _active,
            showTitle: props.showTitle,
            itemRender: props.itemRender
          }));
        }

        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
          pagerList[0] = __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(pagerList[0], {
            className: prefixCls + '-item-after-jump-prev'
          });
          pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
          pagerList[pagerList.length - 1] = __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(pagerList[pagerList.length - 1], {
            className: prefixCls + '-item-before-jump-next'
          });
          pagerList.push(jumpNext);
        }

        if (left !== 1) {
          pagerList.unshift(firstPager);
        }
        if (right !== allPages) {
          pagerList.push(lastPager);
        }
      }

      var totalText = null;

      if (props.showTotal) {
        totalText = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'li',
          { className: prefixCls + '-total-text' },
          props.showTotal(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
        );
      }
      var prevDisabled = !this.hasPrev() || !allPages;
      var nextDisabled = !this.hasNext() || !allPages;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          className: prefixCls + ' ' + props.className,
          style: props.style,
          unselectable: 'unselectable',
          ref: this.savePaginationNode
        }, dataOrAriaAttributeProps),
        totalText,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'li',
          {
            title: props.showTitle ? locale.prev_page : null,
            onClick: this.prev,
            tabIndex: prevDisabled ? null : 0,
            onKeyPress: this.runIfEnterPrev,
            className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
            'aria-disabled': prevDisabled
          },
          props.itemRender(prevPage, 'prev', this.getItemIcon(props.prevIcon))
        ),
        pagerList,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'li',
          {
            title: props.showTitle ? locale.next_page : null,
            onClick: this.next,
            tabIndex: nextDisabled ? null : 0,
            onKeyPress: this.runIfEnterNext,
            className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
            'aria-disabled': nextDisabled
          },
          props.itemRender(nextPage, 'next', this.getItemIcon(props.nextIcon))
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Options__["a" /* default */], {
          locale: props.locale,
          rootPrefixCls: prefixCls,
          selectComponentClass: props.selectComponentClass,
          selectPrefixCls: props.selectPrefixCls,
          changeSize: this.props.showSizeChanger ? this.changePageSize : null,
          current: this.state.current,
          pageSize: this.state.pageSize,
          pageSizeOptions: this.props.pageSizeOptions,
          quickGo: this.props.showQuickJumper ? this.handleChange : null,
          goButton: goButton
        })
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, prevState) {
      var newState = {};

      if ('current' in props) {
        newState.current = props.current;

        if (props.current !== prevState.current) {
          newState.currentInputValue = newState.current;
        }
      }

      if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
        var current = prevState.current;
        var newCurrent = calculatePage(props.pageSize, prevState, props);
        current = current > newCurrent ? newCurrent : current;

        if (!('current' in props)) {
          newState.current = current;
          newState.currentInputValue = current;
        }
        newState.pageSize = props.pageSize;
      }

      return newState;
    }

    /**
     * computed icon node that need to be rendered.
     * @param {React.ReactNode | React.ComponentType<PaginationProps>} icon received icon.
     * @returns {React.ReactNode}
     */

  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Pagination.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  current: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  defaultCurrent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  total: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  pageSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  defaultPageSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  hideOnSinglePage: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showSizeChanger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showLessItems: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onShowSizeChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  selectComponentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  showPrevNextJumpers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showQuickJumper: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  showTitle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  showTotal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  itemRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  jumpPrevIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  jumpNextIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node])
};
Pagination.defaultProps = {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop,
  className: '',
  selectPrefixCls: 'rc-select',
  prefixCls: 'rc-pagination',
  selectComponentClass: null,
  hideOnSinglePage: false,
  showPrevNextJumpers: true,
  showQuickJumper: false,
  showSizeChanger: false,
  showLessItems: false,
  showTitle: true,
  onShowSizeChange: noop,
  locale: __WEBPACK_IMPORTED_MODULE_10__locale_zh_CN__["a" /* default */],
  style: {},
  itemRender: defaultItemRender
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getJumpPrevPage = function () {
    return Math.max(1, _this2.state.current - (_this2.props.showLessItems ? 3 : 5));
  };

  this.getJumpNextPage = function () {
    return Math.min(calculatePage(undefined, _this2.state, _this2.props), _this2.state.current + (_this2.props.showLessItems ? 3 : 5));
  };

  this.getItemIcon = function (icon) {
    var prefixCls = _this2.props.prefixCls;

    var iconNode = icon || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a', { className: prefixCls + '-item-link' });
    if (typeof icon === 'function') {
      iconNode = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(icon, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props));
    }
    return iconNode;
  };

  this.savePaginationNode = function (node) {
    _this2.paginationNode = node;
  };

  this.isValid = function (page) {
    return isInteger(page) && page >= 1 && page !== _this2.state.current;
  };

  this.handleKeyDown = function (e) {
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ARROW_UP || e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ARROW_DOWN) {
      e.preventDefault();
    }
  };

  this.handleKeyUp = function (e) {
    var inputValue = e.target.value;
    var currentInputValue = _this2.state.currentInputValue;
    var value = void 0;

    if (inputValue === '') {
      value = inputValue;
    } else if (isNaN(Number(inputValue))) {
      value = currentInputValue;
    } else {
      value = Number(inputValue);
    }

    if (value !== currentInputValue) {
      _this2.setState({
        currentInputValue: value
      });
    }

    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ENTER) {
      _this2.handleChange(value);
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ARROW_UP) {
      _this2.handleChange(value - 1);
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ARROW_DOWN) {
      _this2.handleChange(value + 1);
    }
  };

  this.changePageSize = function (size) {
    var current = _this2.state.current;
    var newCurrent = calculatePage(size, _this2.state, _this2.props);
    current = current > newCurrent ? newCurrent : current;
    // fix the issue:
    // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
    if (newCurrent === 0) {
      current = _this2.state.current;
    }

    if (typeof size === 'number') {
      if (!('pageSize' in _this2.props)) {
        _this2.setState({
          pageSize: size
        });
      }
      if (!('current' in _this2.props)) {
        _this2.setState({
          current: current,
          currentInputValue: current
        });
      }
    }
    _this2.props.onShowSizeChange(current, size);
  };

  this.handleChange = function (p) {
    var page = p;
    if (_this2.isValid(page)) {
      var currentPage = calculatePage(undefined, _this2.state, _this2.props);
      if (page > currentPage) {
        page = currentPage;
      }

      if (!('current' in _this2.props)) {
        _this2.setState({
          current: page,
          currentInputValue: page
        });
      }

      var pageSize = _this2.state.pageSize;
      _this2.props.onChange(page, pageSize);

      return page;
    }

    return _this2.state.current;
  };

  this.prev = function () {
    if (_this2.hasPrev()) {
      _this2.handleChange(_this2.state.current - 1);
    }
  };

  this.next = function () {
    if (_this2.hasNext()) {
      _this2.handleChange(_this2.state.current + 1);
    }
  };

  this.jumpPrev = function () {
    _this2.handleChange(_this2.getJumpPrevPage());
  };

  this.jumpNext = function () {
    _this2.handleChange(_this2.getJumpNextPage());
  };

  this.hasPrev = function () {
    return _this2.state.current > 1;
  };

  this.hasNext = function () {
    return _this2.state.current < calculatePage(undefined, _this2.state, _this2.props);
  };

  this.runIfEnter = function (event, callback) {
    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      restParams[_key - 2] = arguments[_key];
    }

    if (event.key === 'Enter' || event.charCode === 13) {
      callback.apply(undefined, restParams);
    }
  };

  this.runIfEnterPrev = function (e) {
    _this2.runIfEnter(e, _this2.prev);
  };

  this.runIfEnterNext = function (e) {
    _this2.runIfEnter(e, _this2.next);
  };

  this.runIfEnterJumpPrev = function (e) {
    _this2.runIfEnter(e, _this2.jumpPrev);
  };

  this.runIfEnterJumpNext = function (e) {
    _this2.runIfEnter(e, _this2.jumpNext);
  };

  this.handleGoTO = function (e) {
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
      _this2.handleChange(_this2.state.currentInputValue);
    }
  };
};

Object(__WEBPACK_IMPORTED_MODULE_11_react_lifecycles_compat__["polyfill"])(Pagination);

/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Pager = function Pager(props) {
  var prefixCls = props.rootPrefixCls + '-item';
  var cls = prefixCls + ' ' + prefixCls + '-' + props.page;

  if (props.active) {
    cls = cls + ' ' + prefixCls + '-active';
  }

  if (props.className) {
    cls = cls + ' ' + props.className;
  }

  if (!props.page) {
    cls = cls + ' ' + prefixCls + '-disabled';
  }

  var handleClick = function handleClick() {
    props.onClick(props.page);
  };

  var handleKeyPress = function handleKeyPress(e) {
    props.onKeyPress(e, props.onClick, props.page);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    {
      title: props.showTitle ? props.page : null,
      className: cls,
      onClick: handleClick,
      onKeyPress: handleKeyPress,
      tabIndex: '0'
    },
    props.itemRender(props.page, 'page', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      null,
      props.page
    ))
  );
};

Pager.propTypes = {
  page: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  last: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyPress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  itemRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Pager);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KeyCode__ = __webpack_require__(560);








var Options = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Options, _React$Component);

  function Options(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Options);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, props));

    _this.buildOptionText = function (value) {
      return value + ' ' + _this.props.locale.items_per_page;
    };

    _this.changeSize = function (value) {
      _this.props.changeSize(Number(value));
    };

    _this.handleChange = function (e) {
      _this.setState({
        goInputText: e.target.value
      });
    };

    _this.go = function (e) {
      var val = _this.state.goInputText;
      if (val === '') {
        return;
      }
      val = isNaN(val) ? _this.props.current : Number(val);
      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_6__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
        _this.setState({
          goInputText: ''
        });
        _this.props.quickGo(val);
      }
    };

    _this.state = {
      goInputText: ''
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Options, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var state = this.state;
      var locale = props.locale;
      var prefixCls = props.rootPrefixCls + '-options';
      var changeSize = props.changeSize;
      var quickGo = props.quickGo;
      var goButton = props.goButton;
      var buildOptionText = props.buildOptionText || this.buildOptionText;
      var Select = props.selectComponentClass;
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;

      if (!(changeSize || quickGo)) {
        return null;
      }

      if (changeSize && Select) {
        var Option = Select.Option;
        var pageSize = props.pageSize || props.pageSizeOptions[0];
        var options = props.pageSizeOptions.map(function (opt, i) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            Option,
            { key: i, value: opt },
            buildOptionText(opt)
          );
        });

        changeSelect = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          Select,
          {
            prefixCls: props.selectPrefixCls,
            showSearch: false,
            className: prefixCls + '-size-changer',
            optionLabelProp: 'children',
            dropdownMatchSelectWidth: false,
            value: pageSize.toString(),
            onChange: this.changeSize,
            getPopupContainer: function getPopupContainer(triggerNode) {
              return triggerNode.parentNode;
            }
          },
          options
        );
      }

      if (quickGo) {
        if (goButton) {
          if (typeof goButton === 'boolean') {
            gotoButton = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'button',
              {
                type: 'button',
                onClick: this.go,
                onKeyUp: this.go
              },
              locale.jump_to_confirm
            );
          } else {
            gotoButton = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              {
                onClick: this.go,
                onKeyUp: this.go
              },
              goButton
            );
          }
        }
        goInput = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-quick-jumper' },
          locale.jump_to,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input', {
            type: 'text',
            value: state.goInputText,
            onChange: this.handleChange,
            onKeyUp: this.go
          }),
          locale.page,
          gotoButton
        );
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'li',
        { className: '' + prefixCls },
        changeSelect,
        goInput
      );
    }
  }]);

  return Options;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Options.propTypes = {
  changeSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  quickGo: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  selectComponentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  current: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string),
  pageSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  buildOptionText: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
Options.defaultProps = {
  pageSizeOptions: ['10', '20', '30', '40']
};


/* harmony default export */ __webpack_exports__["a"] = (Options);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳至',
  jump_to_confirm: '确定',
  page: '页',

  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页'
});

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _select = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MiniSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MiniSelect, _React$Component);

  function MiniSelect() {
    _classCallCheck(this, MiniSelect);

    return _possibleConstructorReturn(this, _getPrototypeOf(MiniSelect).apply(this, arguments));
  }

  _createClass(MiniSelect, [{
    key: "render",
    value: function render() {
      return React.createElement(_select["default"], _extends({
        size: "small"
      }, this.props));
    }
  }]);

  return MiniSelect;
}(React.Component);

exports["default"] = MiniSelect;
MiniSelect.Option = _select["default"].Option;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Meta = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _grid = __webpack_require__(215);

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var Meta = function Meta(props) {
  return React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        className = props.className,
        avatar = props.avatar,
        title = props.title,
        description = props.description,
        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);

    var prefixCls = getPrefixCls('list', customizePrefixCls);
    var classString = (0, _classnames["default"])("".concat(prefixCls, "-item-meta"), className);
    var content = React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-content")
    }, title && React.createElement("h4", {
      className: "".concat(prefixCls, "-item-meta-title")
    }, title), description && React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-description")
    }, description));
    return React.createElement("div", _extends({}, others, {
      className: classString
    }), avatar && React.createElement("div", {
      className: "".concat(prefixCls, "-item-meta-avatar")
    }, avatar), (title || description) && content);
  });
};

exports.Meta = Meta;

function getGrid(grid, t) {
  return grid[t] && Math.floor(24 / grid[t]);
}

var Item =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Item, _React$Component);

  function Item() {
    var _this;

    _classCallCheck(this, Item);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Item).apply(this, arguments));

    _this.renderItem = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls;
      var grid = _this.context.grid;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          children = _a.children,
          actions = _a.actions,
          extra = _a.extra,
          className = _a.className,
          others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);

      var prefixCls = getPrefixCls('list', customizePrefixCls);
      var classString = (0, _classnames["default"])("".concat(prefixCls, "-item"), className);
      var metaContent = [];
      var otherContent = [];
      React.Children.forEach(children, function (element) {
        if (element && element.type && element.type === Meta) {
          metaContent.push(element);
        } else {
          otherContent.push(element);
        }
      });
      var contentClassString = (0, _classnames["default"])("".concat(prefixCls, "-item-content"), _defineProperty({}, "".concat(prefixCls, "-item-content-single"), metaContent.length < 1));
      var content = otherContent.length > 0 ? React.createElement("div", {
        className: contentClassString
      }, otherContent) : null;
      var actionsContent;

      if (actions && actions.length > 0) {
        var actionsContentItem = function actionsContentItem(action, i) {
          return React.createElement("li", {
            key: "".concat(prefixCls, "-item-action-").concat(i)
          }, action, i !== actions.length - 1 && React.createElement("em", {
            className: "".concat(prefixCls, "-item-action-split")
          }));
        };

        actionsContent = React.createElement("ul", {
          className: "".concat(prefixCls, "-item-action")
        }, actions.map(function (action, i) {
          return actionsContentItem(action, i);
        }));
      }

      var extraContent = React.createElement("div", {
        className: "".concat(prefixCls, "-item-extra-wrap")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-item-main")
      }, metaContent, content, actionsContent), React.createElement("div", {
        className: "".concat(prefixCls, "-item-extra")
      }, extra));
      var mainContent = grid ? React.createElement(_grid.Col, {
        span: getGrid(grid, 'column'),
        xs: getGrid(grid, 'xs'),
        sm: getGrid(grid, 'sm'),
        md: getGrid(grid, 'md'),
        lg: getGrid(grid, 'lg'),
        xl: getGrid(grid, 'xl'),
        xxl: getGrid(grid, 'xxl')
      }, React.createElement("div", _extends({}, others, {
        className: classString
      }), extra && extraContent, !extra && metaContent, !extra && content, !extra && actionsContent)) : React.createElement("div", _extends({}, others, {
        className: classString
      }), extra && extraContent, !extra && metaContent, !extra && content, !extra && actionsContent);
      return mainContent;
    };

    return _this;
  }

  _createClass(Item, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderItem);
    }
  }]);

  return Item;
}(React.Component);

exports["default"] = Item;
Item.Meta = Meta;
Item.contextTypes = {
  grid: PropTypes.any
};

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

__webpack_require__(1315);

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Upload__ = __webpack_require__(1317);
// export this package's api


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Upload__["a" /* default */]);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AjaxUploader__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IframeUploader__ = __webpack_require__(1322);










function empty() {}

var Upload = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Upload, _Component);

  function Upload() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Upload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Upload.__proto__ || Object.getPrototypeOf(Upload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      Component: null
    }, _this.saveUploader = function (node) {
      _this.uploader = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Upload, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.supportServerRender) {
        /* eslint react/no-did-mount-set-state:0 */
        this.setState({
          Component: this.getComponent()
        }, this.props.onReady);
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      return typeof File !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_7__AjaxUploader__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__IframeUploader__["a" /* default */];
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      this.uploader.abort(file);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.supportServerRender) {
        var _ComponentUploader = this.state.Component;
        if (_ComponentUploader) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(_ComponentUploader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { ref: this.saveUploader }));
        }
        return null;
      }
      var ComponentUploader = this.getComponent();
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ComponentUploader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { ref: this.saveUploader }));
    }
  }]);

  return Upload;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Upload.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multipart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  directory: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onError: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSuccess: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onProgress: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  headers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  accept: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  beforeUpload: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  customRequest: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onReady: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  withCredentials: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  supportServerRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  openFileDialogOnClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
Upload.defaultProps = {
  component: 'span',
  prefixCls: 'rc-upload',
  data: {},
  headers: {},
  name: 'file',
  multipart: false,
  onReady: empty,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  supportServerRender: false,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false,
  openFileDialogOnClick: true
};


/* harmony default export */ __webpack_exports__["a"] = (Upload);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__request__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uid__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__attr_accept__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__traverseFileTree__ = __webpack_require__(1321);






/* eslint react/no-is-mounted:0 react/sort-comp:0 */









var AjaxUploader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AjaxUploader, _Component);

  function AjaxUploader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AjaxUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AjaxUploader.__proto__ || Object.getPrototypeOf(AjaxUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])() }, _this.reqs = {}, _this.onChange = function (e) {
      var files = e.target.files;
      _this.uploadFiles(files);
      _this.reset();
    }, _this.onClick = function () {
      var el = _this.fileInput;
      if (!el) {
        return;
      }
      el.click();
    }, _this.onKeyDown = function (e) {
      if (e.key === 'Enter') {
        _this.onClick();
      }
    }, _this.onFileDrop = function (e) {
      e.preventDefault();

      if (e.type === 'dragover') {
        return;
      }

      if (_this.props.directory) {
        Object(__WEBPACK_IMPORTED_MODULE_12__traverseFileTree__["a" /* default */])(e.dataTransfer.items, _this.uploadFiles, function (_file) {
          return Object(__WEBPACK_IMPORTED_MODULE_11__attr_accept__["a" /* default */])(_file, _this.props.accept);
        });
      } else {
        var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
          return Object(__WEBPACK_IMPORTED_MODULE_11__attr_accept__["a" /* default */])(file, _this.props.accept);
        });
        _this.uploadFiles(files);
      }
    }, _this.uploadFiles = function (files) {
      var postFiles = Array.prototype.slice.call(files);
      postFiles.forEach(function (file) {
        file.uid = Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])();
        _this.upload(file, postFiles);
      });
    }, _this.saveFileInput = function (node) {
      _this.fileInput = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AjaxUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.abort();
    }
  }, {
    key: 'upload',
    value: function upload(file, fileList) {
      var _this2 = this;

      var props = this.props;

      if (!props.beforeUpload) {
        // always async in case use react state to keep fileList
        return setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }

      var before = props.beforeUpload(file, fileList);
      if (before && before.then) {
        before.then(function (processedFile) {
          var processedFileType = Object.prototype.toString.call(processedFile);
          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
            return _this2.post(processedFile);
          }
          return _this2.post(file);
        })['catch'](function (e) {
          console && console.log(e); // eslint-disable-line
        });
      } else if (before !== false) {
        setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }
    }
  }, {
    key: 'post',
    value: function post(file) {
      var _this3 = this;

      if (!this._isMounted) {
        return;
      }
      var props = this.props;
      var data = props.data;
      var onStart = props.onStart,
          onProgress = props.onProgress;

      if (typeof data === 'function') {
        data = data(file);
      }
      new Promise(function (resolve) {
        var action = props.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }
        resolve(action);
      }).then(function (action) {
        var uid = file.uid;

        var request = props.customRequest || __WEBPACK_IMPORTED_MODULE_9__request__["a" /* default */];
        _this3.reqs[uid] = request({
          action: action,
          filename: props.name,
          file: file,
          data: data,
          headers: props.headers,
          withCredentials: props.withCredentials,
          onProgress: onProgress ? function (e) {
            onProgress(e, file);
          } : null,
          onSuccess: function onSuccess(ret, xhr) {
            delete _this3.reqs[uid];
            props.onSuccess(ret, file, xhr);
          },
          onError: function onError(err, ret) {
            delete _this3.reqs[uid];
            props.onError(err, ret, file);
          }
        });
        onStart(file);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setState({
        uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])()
      });
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file && file.uid) {
          uid = file.uid;
        }
        if (reqs[uid]) {
          reqs[uid].abort();
          delete reqs[uid];
        }
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid]) {
            reqs[uid].abort();
          }

          delete reqs[uid];
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Tag = _props.component,
          prefixCls = _props.prefixCls,
          className = _props.className,
          disabled = _props.disabled,
          id = _props.id,
          style = _props.style,
          multiple = _props.multiple,
          accept = _props.accept,
          children = _props.children,
          directory = _props.directory,
          openFileDialogOnClick = _props.openFileDialogOnClick;

      var cls = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
      var events = disabled ? {} : {
        onClick: openFileDialogOnClick ? this.onClick : function () {},
        onKeyDown: this.onKeyDown,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: '0'
      };
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Tag,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, events, {
          className: cls,
          role: 'button',
          style: style
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
          id: id,
          type: 'file',
          ref: this.saveFileInput,
          key: this.state.uid,
          style: { display: 'none' },
          accept: accept,
          directory: directory ? 'directory' : null,
          webkitdirectory: directory ? 'webkitdirectory' : null,
          multiple: multiple,
          onChange: this.onChange
        }),
        children
      );
    }
  }]);

  return AjaxUploader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AjaxUploader.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  directory: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  accept: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  headers: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  beforeUpload: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  customRequest: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onProgress: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  withCredentials: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  openFileDialogOnClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (AjaxUploader);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = upload;
function getError(option, xhr) {
  var msg = 'cannot post ' + option.action + ' ' + xhr.status + '\'';
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = option.action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

// option {
//  onProgress: (event: { percent: number }): void,
//  onError: (event: Error, body?: Object): void,
//  onSuccess: (body: Object): void,
//  data: Object,
//  filename: String,
//  file: File,
//  withCredentials: Boolean,
//  action: String,
//  headers: Object,
// }
function upload(option) {
  var xhr = new XMLHttpRequest();

  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).map(function (key) {
      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    // allow success when 2xx status
    // see https://github.com/react-component/upload/issues/34
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody(xhr));
    }

    option.onSuccess(getBody(xhr), xhr);
  };

  xhr.open('post', option.action, true);

  // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {};

  // when set headers['X-Requested-With'] = null , can close default XHR header
  // see https://github.com/react-component/upload/issues/33
  if (headers['X-Requested-With'] !== null) {
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  }

  for (var h in headers) {
    if (headers.hasOwnProperty(h) && headers[h] !== null) {
      xhr.setRequestHeader(h, headers[h]);
    }
  }
  xhr.send(formData);

  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

/* harmony default export */ __webpack_exports__["a"] = (function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');

    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();
      if (validType.charAt(0) === '.') {
        return endsWith(fileName.toLowerCase(), validType.toLowerCase());
      } else if (/\/\*$/.test(validType)) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }
      return mimeType === validType;
    });
  }
  return true;
});

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
  var _traverseFileTree = function _traverseFileTree(item, path) {
    path = path || '';
    if (item.isFile) {
      item.file(function (file) {
        if (isAccepted(file)) {
          callback([file]);
        }
      });
    } else if (item.isDirectory) {
      var dirReader = item.createReader();

      dirReader.readEntries(function (entries) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var entrieItem = _step.value;

            _traverseFileTree(entrieItem, '' + path + item.name + '/');
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  };
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = files[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var file = _step2.value;

      _traverseFileTree(file.webkitGetAsEntry());
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (traverseFileTree);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uid__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);






/* eslint react/sort-comp:0 */







var IFRAME_STYLE = {
  position: 'absolute',
  top: 0,
  opacity: 0,
  filter: 'alpha(opacity=0)',
  left: 0,
  zIndex: 9999
};

// diferent from AjaxUpload, can only upload on at one time, serial seriously

var IframeUploader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(IframeUploader, _Component);

  function IframeUploader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, IframeUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = IframeUploader.__proto__ || Object.getPrototypeOf(IframeUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uploading: false }, _this.file = {}, _this.onLoad = function () {
      if (!_this.state.uploading) {
        return;
      }
      var _this2 = _this,
          props = _this2.props,
          file = _this2.file;

      var response = void 0;
      try {
        var doc = _this.getIframeDocument();
        var script = doc.getElementsByTagName('script')[0];
        if (script && script.parentNode === doc.body) {
          doc.body.removeChild(script);
        }
        response = doc.body.innerHTML;
        props.onSuccess(response, file);
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_11_warning___default()(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
        response = 'cross-domain';
        props.onError(err, null, file);
      }
      _this.endUpload();
    }, _this.onChange = function () {
      var target = _this.getFormInputNode();
      // ie8/9 don't support FileList Object
      // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files
      var file = _this.file = {
        uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])(),
        name: target.value
      };
      _this.startUpload();
      var _this3 = _this,
          props = _this3.props;

      if (!props.beforeUpload) {
        return _this.post(file);
      }
      var before = props.beforeUpload(file);
      if (before && before.then) {
        before.then(function () {
          _this.post(file);
        }, function () {
          _this.endUpload();
        });
      } else if (before !== false) {
        _this.post(file);
      } else {
        _this.endUpload();
      }
    }, _this.saveIframe = function (node) {
      _this.iframe = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(IframeUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateIframeWH();
      this.initIframe();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateIframeWH();
    }
  }, {
    key: 'getIframeNode',
    value: function getIframeNode() {
      return this.iframe;
    }
  }, {
    key: 'getIframeDocument',
    value: function getIframeDocument() {
      return this.getIframeNode().contentDocument;
    }
  }, {
    key: 'getFormNode',
    value: function getFormNode() {
      return this.getIframeDocument().getElementById('form');
    }
  }, {
    key: 'getFormInputNode',
    value: function getFormInputNode() {
      return this.getIframeDocument().getElementById('input');
    }
  }, {
    key: 'getFormDataNode',
    value: function getFormDataNode() {
      return this.getIframeDocument().getElementById('data');
    }
  }, {
    key: 'getFileForMultiple',
    value: function getFileForMultiple(file) {
      return this.props.multiple ? [file] : file;
    }
  }, {
    key: 'getIframeHTML',
    value: function getIframeHTML(domain) {
      var domainScript = '';
      var domainInput = '';
      if (domain) {
        var script = 'script';
        domainScript = '<' + script + '>document.domain="' + domain + '";</' + script + '>';
        domainInput = '<input name="_documentDomain" value="' + domain + '" />';
      }
      return '\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    ' + domainScript + '\n    </head>\n    <body>\n    <form method="post"\n    encType="multipart/form-data"\n    action="" id="form"\n    style="display:block;height:9999px;position:relative;overflow:hidden;">\n    <input id="input" type="file"\n     name="' + this.props.name + '"\n     style="position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;"/>\n    ' + domainInput + '\n    <span id="data"></span>\n    </form>\n    </body>\n    </html>\n    ';
    }
  }, {
    key: 'initIframeSrc',
    value: function initIframeSrc() {
      if (this.domain) {
        this.getIframeNode().src = 'javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain=\'' + this.domain + '\';\n        d.write(\'\');\n        d.close();\n      })())';
      }
    }
  }, {
    key: 'initIframe',
    value: function initIframe() {
      var iframeNode = this.getIframeNode();
      var win = iframeNode.contentWindow;
      var doc = void 0;
      this.domain = this.domain || '';
      this.initIframeSrc();
      try {
        doc = win.document;
      } catch (e) {
        this.domain = document.domain;
        this.initIframeSrc();
        win = iframeNode.contentWindow;
        doc = win.document;
      }
      doc.open('text/html', 'replace');
      doc.write(this.getIframeHTML(this.domain));
      doc.close();
      this.getFormInputNode().onchange = this.onChange;
    }
  }, {
    key: 'endUpload',
    value: function endUpload() {
      if (this.state.uploading) {
        this.file = {};
        // hack avoid batch
        this.state.uploading = false;
        this.setState({
          uploading: false
        });
        this.initIframe();
      }
    }
  }, {
    key: 'startUpload',
    value: function startUpload() {
      if (!this.state.uploading) {
        this.state.uploading = true;
        this.setState({
          uploading: true
        });
      }
    }
  }, {
    key: 'updateIframeWH',
    value: function updateIframeWH() {
      var rootNode = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this);
      var iframeNode = this.getIframeNode();
      iframeNode.style.height = rootNode.offsetHeight + 'px';
      iframeNode.style.width = rootNode.offsetWidth + 'px';
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      if (file) {
        var uid = file;
        if (file && file.uid) {
          uid = file.uid;
        }
        if (uid === this.file.uid) {
          this.endUpload();
        }
      } else {
        this.endUpload();
      }
    }
  }, {
    key: 'post',
    value: function post(file) {
      var _this4 = this;

      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.props.data;
      var onStart = this.props.onStart;

      if (typeof data === 'function') {
        data = data(file);
      }
      var inputs = document.createDocumentFragment();
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          var input = document.createElement('input');
          input.setAttribute('name', key);
          input.value = data[key];
          inputs.appendChild(input);
        }
      }
      dataSpan.appendChild(inputs);
      new Promise(function (resolve) {
        var action = _this4.props.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }
        resolve(action);
      }).then(function (action) {
        formNode.setAttribute('action', action);
        formNode.submit();
        dataSpan.innerHTML = '';
        onStart(file);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Tag = _props.component,
          disabled = _props.disabled,
          className = _props.className,
          prefixCls = _props.prefixCls,
          children = _props.children,
          style = _props.style;

      var iframeStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, IFRAME_STYLE, {
        display: this.state.uploading || disabled ? 'none' : ''
      });
      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Tag,
        {
          className: cls,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ position: 'relative', zIndex: 0 }, style)
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('iframe', {
          ref: this.saveIframe,
          onLoad: this.onLoad,
          style: iframeStyle
        }),
        children
      );
    }
  }]);

  return IframeUploader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

IframeUploader.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  accept: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (IframeUploader);

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(1325),
    baseUniq = __webpack_require__(1370);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1326),
    baseMatchesProperty = __webpack_require__(1363),
    identity = __webpack_require__(1366),
    isArray = __webpack_require__(121),
    property = __webpack_require__(1367);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1327),
    getMatchData = __webpack_require__(1362),
    matchesStrictComparable = __webpack_require__(575);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(565),
    baseIsEqual = __webpack_require__(566);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(218);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1329 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1330 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1331 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(218),
    Map = __webpack_require__(303),
    MapCache = __webpack_require__(301);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(565),
    equalArrays = __webpack_require__(567),
    equalByTag = __webpack_require__(1337),
    equalObjects = __webpack_require__(1340),
    getTag = __webpack_require__(1358),
    isArray = __webpack_require__(121),
    isBuffer = __webpack_require__(571),
    isTypedArray = __webpack_require__(572);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1334 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1335 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1336 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(214),
    Uint8Array = __webpack_require__(1338),
    eq = __webpack_require__(302),
    equalArrays = __webpack_require__(567),
    mapToArray = __webpack_require__(1339),
    setToArray = __webpack_require__(357);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(101);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1339 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1341);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1342),
    getSymbols = __webpack_require__(1344),
    keys = __webpack_require__(570);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1343),
    isArray = __webpack_require__(121);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1343 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1345),
    stubArray = __webpack_require__(1346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1345 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1346 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1348),
    isArguments = __webpack_require__(431),
    isArray = __webpack_require__(121),
    isBuffer = __webpack_require__(571),
    isIndex = __webpack_require__(304),
    isTypedArray = __webpack_require__(572);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1348 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1349 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(180),
    isLength = __webpack_require__(305),
    isObjectLike = __webpack_require__(181);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1351 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(401);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(207)(module)))

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1354),
    nativeKeys = __webpack_require__(1355);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1354 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1356);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1356 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(429),
    isLength = __webpack_require__(305);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1359),
    Map = __webpack_require__(303),
    Promise = __webpack_require__(1360),
    Set = __webpack_require__(573),
    WeakMap = __webpack_require__(1361),
    baseGetTag = __webpack_require__(180),
    toSource = __webpack_require__(430);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(135),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(135),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(135),
    root = __webpack_require__(101);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(574),
    keys = __webpack_require__(570);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(566),
    get = __webpack_require__(436),
    hasIn = __webpack_require__(1364),
    isKey = __webpack_require__(300),
    isStrictComparable = __webpack_require__(574),
    matchesStrictComparable = __webpack_require__(575),
    toKey = __webpack_require__(183);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1365),
    hasPath = __webpack_require__(428);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1365 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1366 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1368),
    basePropertyDeep = __webpack_require__(1369),
    isKey = __webpack_require__(300),
    toKey = __webpack_require__(183);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(437);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(568),
    arrayIncludes = __webpack_require__(1371),
    arrayIncludesWith = __webpack_require__(1376),
    cacheHas = __webpack_require__(569),
    createSet = __webpack_require__(1377),
    setToArray = __webpack_require__(357);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1372);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1373),
    baseIsNaN = __webpack_require__(1374),
    strictIndexOf = __webpack_require__(1375);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1373 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1374 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1375 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1376 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(573),
    noop = __webpack_require__(1378),
    setToArray = __webpack_require__(357);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1378 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcAnimate = _interopRequireDefault(__webpack_require__(102));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _tooltip = _interopRequireDefault(__webpack_require__(155));

var _progress = _interopRequireDefault(__webpack_require__(1380));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var imageTypes = ['image', 'webp', 'png', 'svg', 'gif', 'jpg', 'jpeg', 'bmp', 'dpg']; // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL

var previewFile = function previewFile(file, callback) {
  if (file.type && !imageTypes.includes(file.type)) {
    callback('');
  }

  var reader = new FileReader();

  reader.onloadend = function () {
    return callback(reader.result);
  };

  reader.readAsDataURL(file);
};

var extname = function extname(url) {
  if (!url) {
    return '';
  }

  var temp = url.split('/');
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};

var isImageUrl = function isImageUrl(file) {
  if (imageTypes.includes(file.type)) {
    return true;
  }

  var url = file.thumbUrl || file.url;
  var extension = extname(url);

  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|bmp|dpg)$/i.test(extension)) {
    return true;
  } else if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  } else if (extension) {
    // other file types which have extension
    return false;
  }

  return true;
};

var UploadList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UploadList, _React$Component);

  function UploadList() {
    var _this;

    _classCallCheck(this, UploadList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UploadList).apply(this, arguments));

    _this.handleClose = function (file) {
      var onRemove = _this.props.onRemove;

      if (onRemove) {
        onRemove(file);
      }
    };

    _this.handlePreview = function (file, e) {
      var onPreview = _this.props.onPreview;

      if (!onPreview) {
        return;
      }

      e.preventDefault();
      return onPreview(file);
    };

    _this.renderUploadList = function (_ref) {
      var _classNames2;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          _this$props$items = _this$props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items,
          listType = _this$props.listType,
          showPreviewIcon = _this$props.showPreviewIcon,
          showRemoveIcon = _this$props.showRemoveIcon,
          locale = _this$props.locale;
      var prefixCls = getPrefixCls('upload', customizePrefixCls);
      var list = items.map(function (file) {
        var _classNames;

        var progress;
        var icon = React.createElement(_icon["default"], {
          type: file.status === 'uploading' ? 'loading' : 'paper-clip'
        });

        if (listType === 'picture' || listType === 'picture-card') {
          if (listType === 'picture-card' && file.status === 'uploading') {
            icon = React.createElement("div", {
              className: "".concat(prefixCls, "-list-item-uploading-text")
            }, locale.uploading);
          } else if (!file.thumbUrl && !file.url) {
            icon = React.createElement(_icon["default"], {
              className: "".concat(prefixCls, "-list-item-thumbnail"),
              type: "picture",
              theme: "twoTone"
            });
          } else {
            var thumbnail = isImageUrl(file) ? React.createElement("img", {
              src: file.thumbUrl || file.url,
              alt: file.name
            }) : React.createElement(_icon["default"], {
              type: "file",
              className: "".concat(prefixCls, "-list-item-icon"),
              theme: "twoTone"
            });
            icon = React.createElement("a", {
              className: "".concat(prefixCls, "-list-item-thumbnail"),
              onClick: function onClick(e) {
                return _this.handlePreview(file, e);
              },
              href: file.url || file.thumbUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }, thumbnail);
          }
        }

        if (file.status === 'uploading') {
          // show loading icon if upload progress listener is disabled
          var loadingProgress = 'percent' in file ? React.createElement(_progress["default"], _extends({
            type: "line"
          }, _this.props.progressAttr, {
            percent: file.percent
          })) : null;
          progress = React.createElement("div", {
            className: "".concat(prefixCls, "-list-item-progress"),
            key: "progress"
          }, loadingProgress);
        }

        var infoUploadingClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-list-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-").concat(file.status), true), _classNames));
        var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
        var preview = file.url ? React.createElement("a", _extends({
          target: "_blank",
          rel: "noopener noreferrer",
          className: "".concat(prefixCls, "-list-item-name"),
          title: file.name
        }, linkProps, {
          href: file.url,
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          }
        }), file.name) : React.createElement("span", {
          className: "".concat(prefixCls, "-list-item-name"),
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          },
          title: file.name
        }, file.name);
        var style = {
          pointerEvents: 'none',
          opacity: 0.5
        };
        var previewIcon = showPreviewIcon ? React.createElement("a", {
          href: file.url || file.thumbUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          style: file.url || file.thumbUrl ? undefined : style,
          onClick: function onClick(e) {
            return _this.handlePreview(file, e);
          },
          title: locale.previewFile
        }, React.createElement(_icon["default"], {
          type: "eye-o"
        })) : null;
        var removeIcon = showRemoveIcon ? React.createElement(_icon["default"], {
          type: "delete",
          title: locale.removeFile,
          onClick: function onClick() {
            return _this.handleClose(file);
          }
        }) : null;
        var removeIconClose = showRemoveIcon ? React.createElement(_icon["default"], {
          type: "close",
          title: locale.removeFile,
          onClick: function onClick() {
            return _this.handleClose(file);
          }
        }) : null;
        var actions = listType === 'picture-card' && file.status !== 'uploading' ? React.createElement("span", {
          className: "".concat(prefixCls, "-list-item-actions")
        }, previewIcon, removeIcon) : removeIconClose;
        var message;

        if (file.response && typeof file.response === 'string') {
          message = file.response;
        } else {
          message = file.error && file.error.statusText || locale.uploadError;
        }

        var iconAndPreview = file.status === 'error' ? React.createElement(_tooltip["default"], {
          title: message
        }, icon, preview) : React.createElement("span", null, icon, preview);
        return React.createElement("div", {
          className: infoUploadingClass,
          key: file.uid
        }, React.createElement("div", {
          className: "".concat(prefixCls, "-list-item-info")
        }, iconAndPreview), actions, React.createElement(_rcAnimate["default"], {
          transitionName: "fade",
          component: ""
        }, progress));
      });
      var listClassNames = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-list"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-list-").concat(listType), true), _classNames2));
      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
      return React.createElement(_rcAnimate["default"], {
        transitionName: "".concat(prefixCls, "-").concat(animationDirection),
        component: "div",
        className: listClassNames
      }, list);
    };

    return _this;
  }

  _createClass(UploadList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.listType !== 'picture' && this.props.listType !== 'picture-card') {
        return;
      }

      (this.props.items || []).forEach(function (file) {
        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File) || file.thumbUrl !== undefined) {
          return;
        }
        /*eslint-disable */


        file.thumbUrl = '';
        /*eslint-enable */

        previewFile(file.originFileObj, function (previewDataUrl) {
          /*eslint-disable */
          file.thumbUrl = previewDataUrl;
          /*eslint-enable */

          _this2.forceUpdate();
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderUploadList);
    }
  }]);

  return UploadList;
}(React.Component);

exports["default"] = UploadList;
UploadList.defaultProps = {
  listType: 'text',
  progressAttr: {
    strokeWidth: 2,
    showInfo: false
  },
  showRemoveIcon: true,
  showPreviewIcon: true
};

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _progress = _interopRequireDefault(__webpack_require__(1381));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _progress["default"];
exports["default"] = _default;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var React = _interopRequireWildcard(__webpack_require__(0));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _rcProgress = __webpack_require__(1382);

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

var _type = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var statusColorMap = {
  normal: '#108ee9',
  exception: '#ff5500',
  success: '#87d068'
};
var ProgressTypes = (0, _type.tuple)('line', 'circle', 'dashboard');
var ProgressStatuses = (0, _type.tuple)('normal', 'exception', 'active', 'success');

var validProgress = function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  } else if (progress > 100) {
    return 100;
  }

  return progress;
};

var Progress =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Progress, _React$Component);

  function Progress() {
    var _this;

    _classCallCheck(this, Progress);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Progress).apply(this, arguments));

    _this.renderProgress = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var props = _this.props;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          _props$percent = props.percent,
          percent = _props$percent === void 0 ? 0 : _props$percent,
          status = props.status,
          format = props.format,
          trailColor = props.trailColor,
          size = props.size,
          successPercent = props.successPercent,
          type = props.type,
          strokeWidth = props.strokeWidth,
          width = props.width,
          showInfo = props.showInfo,
          _props$gapDegree = props.gapDegree,
          gapDegree = _props$gapDegree === void 0 ? 0 : _props$gapDegree,
          gapPosition = props.gapPosition,
          strokeColor = props.strokeColor,
          _props$strokeLinecap = props.strokeLinecap,
          strokeLinecap = _props$strokeLinecap === void 0 ? 'round' : _props$strokeLinecap,
          restProps = __rest(props, ["prefixCls", "className", "percent", "status", "format", "trailColor", "size", "successPercent", "type", "strokeWidth", "width", "showInfo", "gapDegree", "gapPosition", "strokeColor", "strokeLinecap"]);

      var prefixCls = getPrefixCls('progress', customizePrefixCls);
      var progressStatus = parseInt(successPercent ? successPercent.toString() : percent.toString(), 10) >= 100 && !('status' in props) ? 'success' : status || 'normal';
      var progressInfo;
      var progress;

      var textFormatter = format || function (percentNumber) {
        return "".concat(percentNumber, "%");
      };

      if (showInfo) {
        var text;
        var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';

        if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
          text = textFormatter(validProgress(percent), validProgress(successPercent));
        } else if (progressStatus === 'exception') {
          text = React.createElement(_icon["default"], {
            type: "close".concat(iconType),
            theme: type === 'line' ? 'filled' : 'outlined'
          });
        } else if (progressStatus === 'success') {
          text = React.createElement(_icon["default"], {
            type: "check".concat(iconType),
            theme: type === 'line' ? 'filled' : 'outlined'
          });
        }

        progressInfo = React.createElement("span", {
          className: "".concat(prefixCls, "-text"),
          title: typeof text === 'string' ? text : undefined
        }, text);
      }

      if (type === 'line') {
        var percentStyle = {
          width: "".concat(validProgress(percent), "%"),
          height: strokeWidth || (size === 'small' ? 6 : 8),
          background: strokeColor,
          borderRadius: strokeLinecap === 'square' ? 0 : '100px'
        };
        var successPercentStyle = {
          width: "".concat(validProgress(successPercent), "%"),
          height: strokeWidth || (size === 'small' ? 6 : 8),
          borderRadius: strokeLinecap === 'square' ? 0 : '100px'
        };
        var successSegment = successPercent !== undefined ? React.createElement("div", {
          className: "".concat(prefixCls, "-success-bg"),
          style: successPercentStyle
        }) : null;
        progress = React.createElement("div", null, React.createElement("div", {
          className: "".concat(prefixCls, "-outer")
        }, React.createElement("div", {
          className: "".concat(prefixCls, "-inner")
        }, React.createElement("div", {
          className: "".concat(prefixCls, "-bg"),
          style: percentStyle
        }), successSegment)), progressInfo);
      } else if (type === 'circle' || type === 'dashboard') {
        var circleSize = width || 120;
        var circleStyle = {
          width: circleSize,
          height: circleSize,
          fontSize: circleSize * 0.15 + 6
        };
        var circleWidth = strokeWidth || 6;
        var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
        var gapDeg = gapDegree || type === 'dashboard' && 75;
        progress = React.createElement("div", {
          className: "".concat(prefixCls, "-inner"),
          style: circleStyle
        }, React.createElement(_rcProgress.Circle, {
          percent: validProgress(percent),
          strokeWidth: circleWidth,
          trailWidth: circleWidth,
          strokeColor: strokeColor || statusColorMap[progressStatus],
          strokeLinecap: strokeLinecap,
          trailColor: trailColor,
          prefixCls: prefixCls,
          gapDegree: gapDeg,
          gapPosition: gapPos
        }), progressInfo);
      }

      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
      return React.createElement("div", _extends({}, restProps, {
        className: classString
      }), progress);
    };

    return _this;
  }

  _createClass(Progress, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderProgress);
    }
  }]);

  return Progress;
}(React.Component);

exports["default"] = Progress;
Progress.defaultProps = {
  type: 'line',
  percent: 0,
  showInfo: true,
  trailColor: '#f3f3f3',
  size: 'default'
};
Progress.propTypes = {
  status: PropTypes.oneOf(ProgressStatuses),
  type: PropTypes.oneOf(ProgressTypes),
  showInfo: PropTypes.bool,
  percent: PropTypes.number,
  width: PropTypes.number,
  strokeWidth: PropTypes.number,
  strokeLinecap: PropTypes.oneOf(['round', 'square']),
  strokeColor: PropTypes.string,
  trailColor: PropTypes.string,
  format: PropTypes.func,
  gapDegree: PropTypes.number,
  "default": PropTypes.oneOf(['default', 'small'])
};

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Line__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Circle__ = __webpack_require__(1384);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_0__Line__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return __WEBPACK_IMPORTED_MODULE_1__Circle__["a"]; });





/* harmony default export */ __webpack_exports__["default"] = ({
  Line: __WEBPACK_IMPORTED_MODULE_0__Line__["a" /* default */],
  Circle: __WEBPACK_IMPORTED_MODULE_1__Circle__["a" /* default */]
});

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enhancer__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(577);









var Line = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Line, _Component);

  function Line() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Line);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  Line.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        percent = _props.percent,
        prefixCls = _props.prefixCls,
        strokeColor = _props.strokeColor,
        strokeLinecap = _props.strokeLinecap,
        strokeWidth = _props.strokeWidth,
        style = _props.style,
        trailColor = _props.trailColor,
        trailWidth = _props.trailWidth,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'percent', 'prefixCls', 'strokeColor', 'strokeLinecap', 'strokeWidth', 'style', 'trailColor', 'trailWidth']);

    delete restProps.gapPosition;

    var pathStyle = {
      strokeDasharray: '100px, 100px',
      strokeDashoffset: 100 - percent + 'px',
      transition: 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear'
    };

    var center = strokeWidth / 2;
    var right = 100 - strokeWidth / 2;
    var pathString = 'M ' + (strokeLinecap === 'round' ? center : 0) + ',' + center + '\n           L ' + (strokeLinecap === 'round' ? right : 100) + ',' + center;
    var viewBoxString = '0 0 100 ' + strokeWidth;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'svg',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        className: prefixCls + '-line ' + className,
        viewBox: viewBoxString,
        preserveAspectRatio: 'none',
        style: style
      }, restProps),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path', {
        className: prefixCls + '-line-trail',
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: '0'
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path', {
        className: prefixCls + '-line-path',
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        fillOpacity: '0',
        ref: function ref(path) {
          _this2.path = path;
        },
        style: pathStyle
      })
    );
  };

  return Line;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Line.propTypes = __WEBPACK_IMPORTED_MODULE_7__types__["b" /* propTypes */];

Line.defaultProps = __WEBPACK_IMPORTED_MODULE_7__types__["a" /* defaultProps */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__enhancer__["a" /* default */])(Line));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enhancer__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(577);





/* eslint react/prop-types: 0 */





var Circle = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Circle, _Component);

  function Circle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Circle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  Circle.prototype.getPathStyles = function getPathStyles() {
    var _props = this.props,
        percent = _props.percent,
        strokeWidth = _props.strokeWidth,
        strokeColor = _props.strokeColor,
        _props$gapDegree = _props.gapDegree,
        gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
        gapPosition = _props.gapPosition;

    var radius = 50 - strokeWidth / 2;
    var beginPositionX = 0;
    var beginPositionY = -radius;
    var endPositionX = 0;
    var endPositionY = -2 * radius;
    switch (gapPosition) {
      case 'left':
        beginPositionX = -radius;
        beginPositionY = 0;
        endPositionX = 2 * radius;
        endPositionY = 0;
        break;
      case 'right':
        beginPositionX = radius;
        beginPositionY = 0;
        endPositionX = -2 * radius;
        endPositionY = 0;
        break;
      case 'bottom':
        beginPositionY = radius;
        endPositionY = 2 * radius;
        break;
      default:
    }
    var pathString = 'M 50,50 m ' + beginPositionX + ',' + beginPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + endPositionX + ',' + -endPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + -endPositionX + ',' + endPositionY;
    var len = Math.PI * 2 * radius;
    var trailPathStyle = {
      strokeDasharray: len - gapDegree + 'px ' + len + 'px',
      strokeDashoffset: '-' + gapDegree / 2 + 'px',
      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s'
    };
    var strokePathStyle = {
      stroke: strokeColor,
      strokeDasharray: percent / 100 * (len - gapDegree) + 'px ' + len + 'px',
      strokeDashoffset: '-' + gapDegree / 2 + 'px',
      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line
    };
    return { pathString: pathString, trailPathStyle: trailPathStyle, strokePathStyle: strokePathStyle };
  };

  Circle.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        strokeWidth = _props2.strokeWidth,
        trailWidth = _props2.trailWidth,
        percent = _props2.percent,
        trailColor = _props2.trailColor,
        strokeLinecap = _props2.strokeLinecap,
        style = _props2.style,
        className = _props2.className,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['prefixCls', 'strokeWidth', 'trailWidth', 'percent', 'trailColor', 'strokeLinecap', 'style', 'className']);

    var _getPathStyles = this.getPathStyles(),
        pathString = _getPathStyles.pathString,
        trailPathStyle = _getPathStyles.trailPathStyle,
        strokePathStyle = _getPathStyles.strokePathStyle;

    delete restProps.percent;
    delete restProps.gapDegree;
    delete restProps.gapPosition;
    delete restProps.strokeColor;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'svg',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        className: prefixCls + '-circle ' + className,
        viewBox: '0 0 100 100',
        style: style
      }, restProps),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path', {
        className: prefixCls + '-circle-trail',
        d: pathString,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: '0',
        style: trailPathStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path', {
        className: prefixCls + '-circle-path',
        d: pathString,
        strokeLinecap: strokeLinecap,
        strokeWidth: this.props.percent === 0 ? 0 : strokeWidth,
        fillOpacity: '0',
        ref: function ref(path) {
          _this2.path = path;
        },
        style: strokePathStyle
      })
    );
  };

  return Circle;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Circle.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__types__["b" /* propTypes */], {
  gapPosition: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['top', 'bottom', 'left', 'right'])
});

Circle.defaultProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__types__["a" /* defaultProps */], {
  gapPosition: 'top'
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__enhancer__["a" /* default */])(Circle));

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.T = T;
exports.fileToObject = fileToObject;
exports.genPercentAdd = genPercentAdd;
exports.getFileItem = getFileItem;
exports.removeFileItem = removeFileItem;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function T() {
  return true;
} // Fix IE file.status problem
// via coping a new Object


function fileToObject(file) {
  return _extends({}, file, {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}
/**
 * 生成Progress percent: 0.1 -> 0.98
 *   - for ie
 */


function genPercentAdd() {
  var k = 0.1;
  var i = 0.01;
  var end = 0.98;
  return function (s) {
    var start = s;

    if (start >= end) {
      return start;
    }

    start += k;
    k = k - i;

    if (k < 0.001) {
      k = 0.001;
    }

    return start;
  };
}

function getFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  return fileList.filter(function (item) {
    return item[matchKey] === file[matchKey];
  })[0];
}

function removeFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  var removed = fileList.filter(function (item) {
    return item[matchKey] !== file[matchKey];
  });

  if (removed.length === fileList.length) {
    return null;
  }

  return removed;
}

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Upload = _interopRequireDefault(__webpack_require__(563));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Dragger =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dragger, _React$Component);

  function Dragger() {
    _classCallCheck(this, Dragger);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dragger).apply(this, arguments));
  }

  _createClass(Dragger, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return React.createElement(_Upload["default"], _extends({}, props, {
        type: "drag",
        style: _extends({}, props.style, {
          height: props.height
        })
      }));
    }
  }]);

  return Dragger;
}(React.Component);

exports["default"] = Dragger;

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_artefact_min_form__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__style_css__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__style_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,appLang:state.app.language,codelistTriplet:instanceState.codelistTriplet,derivedCodelist:instanceState.derivedCodelist,dCSourceFetchPageParams:instanceState.dCSourceFetchPageParams,dCSourceItemPage:instanceState.dCSourceItemPage,dCSourceItemCount:instanceState.dCSourceItemCount,dCSourceSelectedItemCount:instanceState.dCSourceSelectedItemCount,dCTargetFetchPageParams:instanceState.dCTargetFetchPageParams,dCTargetItemPage:instanceState.dCTargetItemPage,dCTargetItemCount:instanceState.dCTargetItemCount,dCTargetSelectedItemCount:instanceState.dCTargetSelectedItemCount,importCheckbox:instanceState.importCheckbox,isCreateVisible:instanceState.isCreateVisible,currentTab:instanceState.currentTab,derivedCodelistViewMode:instanceState.derivedCodelistViewMode,dcSourceItemTree:instanceState.dcSourceItemTree,dcSourceItemTreeMaxDepth:instanceState.dcSourceItemTreeMaxDepth,dcTargetItemTree:instanceState.dcTargetItemTree,dcTargetItemTreeMaxDepth:instanceState.dcTargetItemTreeMaxDepth,dcSourceSelectedItems:instanceState.dcSourceSelectedItems,dcTargetSelectedItems:instanceState.dcTargetSelectedItems,dcTargetItemTreeTimeStamp:instanceState.dcTargetItemTreeTimeStamp,dcTargetItemTreeTimestamp:instanceState.dcTargetItemTreeTimeStamp,maxTreeNodes:state.config.userInterface.maxTreeNodes};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onSourceItemPageParamsUpdate:function onSourceItemPageParamsUpdate(fetchPageParams){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_109" /* updateCodelistDetailDerivedCodelistSourceItemPageParams */])(fetchPageParams),instancePrefix));},fetchSourceItemPage:function fetchSourceItemPage(_ref3){var codelistTriplet=_ref3.codelistTriplet,lang=_ref3.lang,pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,itemsOrderAnnotationType=_ref3.itemsOrderAnnotationType,searchText=_ref3.searchText,filters=_ref3.filters,sortCol=_ref3.sortCol,sortByDesc=_ref3.sortByDesc;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_69" /* readCodelistDetailDerivedCodelistSourceItemPage */])(codelistTriplet,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc),instancePrefix));},onTargetItemPageParamsUpdate:function onTargetItemPageParamsUpdate(fetchPageParams){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_110" /* updateCodelistDetailDerivedCodelistTargetItemPageParams */])(fetchPageParams),instancePrefix));},fetchTargetItemPage:function fetchTargetItemPage(_ref4){var codelistTriplet=_ref4.codelistTriplet,lang=_ref4.lang,pageNum=_ref4.pageNum,pageSize=_ref4.pageSize,itemsOrderAnnotationType=_ref4.itemsOrderAnnotationType,searchText=_ref4.searchText,filters=_ref4.filters,sortCol=_ref4.sortCol,sortByDesc=_ref4.sortByDesc;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_71" /* readCodelistDetailDerivedCodelistTargetItemPage */])(codelistTriplet,lang,pageNum,pageSize,itemsOrderAnnotationType,searchText,filters,sortCol,sortByDesc),instancePrefix));},onSourceItemSelect:function onSourceItemSelect(itemId,codelistTriplet,isSelected,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_79" /* selectCodelistDetailDerivedCodelistSourceItem */])(itemId,codelistTriplet,isSelected,lang),instancePrefix));},onTargetItemSelect:function onTargetItemSelect(itemId,codelistTriplet,isSelected,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_81" /* selectCodelistDetailDerivedCodelistTargetItem */])(itemId,codelistTriplet,isSelected,lang),instancePrefix));},onAllItemsSelect:function onAllItemsSelect(codelistTriplet,isTarget,isSelected,filter,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_78" /* selectCodelistDetailDerivedCodelistAllItems */])(codelistTriplet,isTarget,isSelected,filter,lang),instancePrefix));},onSelectedItemsStore:function onSelectedItemsStore(isTarget,codelistTriplet,lang,importCheckbox){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_99" /* storeCodelistDetailDerivedCodelistSelectedItems */])(isTarget,codelistTriplet,lang,importCheckbox),instancePrefix));},onItemsStore:function onItemsStore(items,isTarget,codelistTriplet,lang,importCheckbox){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_98" /* storeCodelistDetailDerivedCodelistItems */])(items,isTarget,codelistTriplet,lang,importCheckbox),instancePrefix));},onCheckboxChange:function onCheckboxChange(checkbox){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_34" /* changeCodelistDetailDerivedCodelistCheckbox */])(checkbox),instancePrefix));},onCreateShow:function onCreateShow(codelistTriplet,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_89" /* showCodelistDetailDerivedCodelistCreate */])(codelistTriplet,lang),instancePrefix));},onCreateHide:function onCreateHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_54" /* hideCodelistDetailDerivedCodelistCreate */])(),instancePrefix));},onCreateChange:function onCreateChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_35" /* changeCodelistDetailDerivedCodelistCreate */])(fields),instancePrefix));},onCreateSubmit:function onCreateSubmit(codelistTriplet,lang,derivedCodelist){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_102" /* submitCodelistDetailDerivedCodelistCreate */])(codelistTriplet,lang,derivedCodelist),instancePrefix));},onSelectedDbRestore:function onSelectedDbRestore(codelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_77" /* restoreCodelistDetailDerivedCodelistDb */])(codelistTriplet),instancePrefix));},onDerivedCodelistViewModeChange:function onDerivedCodelistViewModeChange(mode,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_36" /* changeCodelistDetailDerivedCodelistViewMode */])(mode,triplet),instancePrefix));},fetchDCSourceItemTree:function fetchDCSourceItemTree(_ref5){var triplet=_ref5.triplet,lang=_ref5.lang,itemsOrderAnnotationType=_ref5.itemsOrderAnnotationType;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_70" /* readCodelistDetailDerivedCodelistSourceItemTree */])(triplet,lang,itemsOrderAnnotationType),instancePrefix));},fetchDCTargetItemTree:function fetchDCTargetItemTree(_ref6){var triplet=_ref6.triplet,lang=_ref6.lang,itemsOrderAnnotationType=_ref6.itemsOrderAnnotationType;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_72" /* readCodelistDetailDerivedCodelistTargetItemTree */])(triplet,lang,itemsOrderAnnotationType),instancePrefix));},onSourceTreeItemSelect:function onSourceTreeItemSelect(itemIds){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_80" /* selectCodelistDetailDerivedCodelistSourceTreeItem */])(itemIds),instancePrefix));},onTargetTreeItemSelect:function onTargetTreeItemSelect(itemIds){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_82" /* selectCodelistDetailDerivedCodelistTargetTreeItem */])(itemIds),instancePrefix));}};};var TABLE_HEIGHT=300;var DerivedCodelist=function DerivedCodelist(_ref7){var t=_ref7.t,nodes=_ref7.nodes,nodeId=_ref7.nodeId,appLang=_ref7.appLang,agencies=_ref7.agencies,codelistTriplet=_ref7.codelistTriplet,dCSourceFetchPageParams=_ref7.dCSourceFetchPageParams,dCSourceItemPage=_ref7.dCSourceItemPage,dCSourceItemCount=_ref7.dCSourceItemCount,dCSourceSelectedItemCount=_ref7.dCSourceSelectedItemCount,dCTargetFetchPageParams=_ref7.dCTargetFetchPageParams,dCTargetItemPage=_ref7.dCTargetItemPage,dCTargetItemCount=_ref7.dCTargetItemCount,dCTargetSelectedItemCount=_ref7.dCTargetSelectedItemCount,isCreateVisible=_ref7.isCreateVisible,currentTab=_ref7.currentTab,derivedCodelist=_ref7.derivedCodelist,importCheckbox=_ref7.importCheckbox,isImportParentDisabled=_ref7.isImportParentDisabled,fetchSourceItemPage=_ref7.fetchSourceItemPage,onSourceItemPageParamsUpdate=_ref7.onSourceItemPageParamsUpdate,fetchTargetItemPage=_ref7.fetchTargetItemPage,onTargetItemPageParamsUpdate=_ref7.onTargetItemPageParamsUpdate,onSourceItemSelect=_ref7.onSourceItemSelect,onTargetItemSelect=_ref7.onTargetItemSelect,onAllItemsSelect=_ref7.onAllItemsSelect,onSelectedItemsStore=_ref7.onSelectedItemsStore,onItemsStore=_ref7.onItemsStore,onCheckboxChange=_ref7.onCheckboxChange,onCreateShow=_ref7.onCreateShow,onCreateChange=_ref7.onCreateChange,onCreateHide=_ref7.onCreateHide,onCreateSubmit=_ref7.onCreateSubmit,onSelectedDbRestore=_ref7.onSelectedDbRestore,derivedCodelistViewMode=_ref7.derivedCodelistViewMode,onDerivedCodelistViewModeChange=_ref7.onDerivedCodelistViewModeChange,fetchDCSourceItemTree=_ref7.fetchDCSourceItemTree,fetchDCTargetItemTree=_ref7.fetchDCTargetItemTree,dcSourceItemTree=_ref7.dcSourceItemTree,dcTargetItemTree=_ref7.dcTargetItemTree,dcSourceItemTreeMaxDepth=_ref7.dcSourceItemTreeMaxDepth,dcTargetItemTreeMaxDepth=_ref7.dcTargetItemTreeMaxDepth,dcSourceSelectedItems=_ref7.dcSourceSelectedItems,dcTargetSelectedItems=_ref7.dcTargetSelectedItems,onSourceTreeItemSelect=_ref7.onSourceTreeItemSelect,onTargetTreeItemSelect=_ref7.onTargetTreeItemSelect,dcTargetItemTreeTimeStamp=_ref7.dcTargetItemTreeTimeStamp,dcTargetItemTreeTimestamp=_ref7.dcTargetItemTreeTimestamp,maxTreeNodes=_ref7.maxTreeNodes;var itemsOrderAnnotationType=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.find(nodes,function(node){return node.general.id===nodeId;}).annotations.codelistsOrder;var columns=[{title:t('data.item.id.shortLabel'),dataIndex:'code',minWidth:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.item.name.shortLabel'),dataIndex:'name',minWidth:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.item.parent.shortLabel'),dataIndex:'parent',minWidth:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]}];var _useState=Object(__WEBPACK_IMPORTED_MODULE_14_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isVisible=_useState2[0],setIsVisible=_useState2[1];return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLang;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{fullscreen:true,visible:isVisible,title:t('reduxComponents.codelistDetail.tabs.derived.title'),onCancel:function onCancel(){return setIsVisible(false);},footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return setIsVisible(false);},icon:"zoom-out"},t('commons.buttons.close.title')))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"space-between",align:"middle",gutter:32,style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:16},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group,{value:derivedCodelistViewMode,onChange:function onChange(_ref8){var target=_ref8.target;if(target.value===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]&&dCSourceItemCount&&dCSourceItemCount>maxTreeNodes){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t('components.itemList.modals.treeViewModeUnavailable.title'),content:t('components.itemList.modals.treeViewModeUnavailable.content')});}else if(dCSourceItemPage&&dCSourceItemPage.find(function(_ref9){var isSelected=_ref9.isSelected;return isSelected;})||dcSourceSelectedItems.length>0){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('reduxComponents.derivedItemsScheme.viewModeRadio.confirm.title'),content:t('reduxComponents.derivedItemsScheme.viewModeRadio.confirm.content'),onOk:function onOk(){onDerivedCodelistViewModeChange(target.value,codelistTriplet);},cancelText:t('commons.buttons.cancel.title')});}else{onDerivedCodelistViewModeChange(target.value,codelistTriplet);}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{title:t('reduxComponents.derivedItemsScheme.viewModeRadio.table.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"table"}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{title:t('reduxComponents.derivedItemsScheme.viewModeRadio.tree.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"branches",style:{transform:"rotate(90deg)"}}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return setIsVisible(false);},icon:"zoom-out"},t('reduxComponents.derivedItemsScheme.buttons.zoom.title'))))),derivedCodelistViewMode===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:32},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.preservesHierarchy.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:importCheckbox.preserveHierarchy,onChange:function onChange(e){return onCheckboxChange({preserveHierarchy:e.target.checked});},disabled:isImportParentDisabled})))),importCheckbox.preserveHierarchy&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.parents.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:importCheckbox.importParents,onChange:function onChange(e){return onCheckboxChange({importParents:e.target.checked});},disabled:isImportParentDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.children.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:importCheckbox.importChildren,onChange:function onChange(e){return onCheckboxChange({importChildren:e.target.checked});},disabled:isImportParentDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.descendants.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:importCheckbox.importDescendants,onChange:function onChange(e){return onCheckboxChange({importDescendants:e.target.checked});},disabled:isImportParentDisabled}))))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"redux-codelist-detail-modal__derived-codelist__fullscreen"},derivedCodelistViewMode===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"],height:"100%"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"],style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchDCSourceItemTree,cbParam:{triplet:codelistTriplet,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType,dcTargetItemTreeTimeStamp:dcTargetItemTreeTimeStamp},disabled:derivedCodelistViewMode!==__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__["a" /* default */],{itemTree:dcSourceItemTree,childrenKey:"codes",rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsStore(dcSourceSelectedItems,false,codelistTriplet,lang,importCheckbox);},icon:"double-right",type:"primary",disabled:dcSourceSelectedItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.addItems.title')),itemTreeMaxDepth:dcSourceItemTreeMaxDepth,selectedItems:dcSourceSelectedItems,onSelectedItemsChange:onSourceTreeItemSelect,getIsDisabledNode:function getIsDisabledNode(_ref10){var isSelectable=_ref10.isSelectable;return isSelectable===false;}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"],style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchDCTargetItemTree,cbParam:{triplet:codelistTriplet,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType,dcTargetItemTreeTimestamp:dcTargetItemTreeTimestamp},disabled:derivedCodelistViewMode!==__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__["a" /* default */],{itemTree:dcTargetItemTree,childrenKey:"codes",rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsStore(dcTargetSelectedItems,true,codelistTriplet,lang);},icon:"delete",type:"primary",disabled:dcTargetSelectedItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')),itemTreeMaxDepth:dcTargetItemTreeMaxDepth,selectedItems:dcTargetSelectedItems,onSelectedItemsChange:onTargetTreeItemSelect})))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchSourceItemPage,cbParam:dCSourceFetchPageParams,disabled:dCSourceFetchPageParams===null||currentTab!=="derived"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_infinite_scroll_table__["a" /* default */],{data:dCSourceItemPage,getRowKey:function getRowKey(_ref11){var code=_ref11.code;return code;},rowCount:dCSourceItemCount,columns:columns,height:document.body.clientHeight-357,searchBarSpan:10,rowSelection:{selectedRowKeys:dCSourceItemPage?dCSourceItemPage.filter(function(_ref12){var isSelected=_ref12.isSelected;return isSelected;}).map(function(_ref13){var code=_ref13.code;return code;}):[],onSelect:function onSelect(itemCode,selected){return onSourceItemSelect(itemCode,codelistTriplet,selected,lang);},onSelectAll:function onSelectAll(selected,filter){return onAllItemsSelect(codelistTriplet,false,selected,filter,lang);}},getIsDisabledRow:function getIsDisabledRow(_ref14){var isSelectable=_ref14.isSelectable;return!isSelectable;},rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onSelectedItemsStore(false,codelistTriplet,lang,importCheckbox);},icon:"double-right",type:"primary",disabled:!dCSourceSelectedItemCount||dCSourceSelectedItemCount===0},t('reduxComponents.derivedItemsScheme.buttons.addItems.title')),isPaginated:true,selectedRowCount:dCSourceSelectedItemCount,onChange:function onChange(_ref15){var pageNum=_ref15.pageNum,pageSize=_ref15.pageSize,searchText=_ref15.searchText,filters=_ref15.filters,sortCol=_ref15.sortCol,sortByDesc=_ref15.sortByDesc;return onSourceItemPageParamsUpdate({codelistTriplet:codelistTriplet,lang:lang,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc,itemsOrderAnnotationType:itemsOrderAnnotationType});}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchTargetItemPage,cbParam:dCTargetFetchPageParams,disabled:dCTargetFetchPageParams===null||dCSourceItemPage===null||currentTab!=="derived"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_infinite_scroll_table__["a" /* default */],{data:dCTargetItemPage,getRowKey:function getRowKey(_ref16){var code=_ref16.code;return code;},rowCount:dCTargetItemCount,columns:columns,height:document.body.clientHeight-357,searchBarSpan:10,rowSelection:{selectedRowKeys:dCTargetItemPage?dCTargetItemPage.filter(function(_ref17){var isSelected=_ref17.isSelected;return isSelected;}).map(function(_ref18){var code=_ref18.code;return code;}):[],onSelect:function onSelect(itemCode,selected){return onTargetItemSelect(itemCode,codelistTriplet,selected,lang);},onSelectAll:function onSelectAll(selected,filter){return onAllItemsSelect(codelistTriplet,true,selected,filter,lang);}},rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onSelectedItemsStore(true,codelistTriplet,lang);},icon:"delete",type:"primary",disabled:!dCTargetSelectedItemCount||dCTargetSelectedItemCount===0},t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')),isPaginated:true,selectedRowCount:dCTargetSelectedItemCount,onChange:function onChange(_ref19){var pageNum=_ref19.pageNum,pageSize=_ref19.pageSize,searchText=_ref19.searchText,filters=_ref19.filters,sortCol=_ref19.sortCol,sortByDesc=_ref19.sortByDesc;return onTargetItemPageParamsUpdate({codelistTriplet:codelistTriplet,lang:lang,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc,itemsOrderAnnotationType:itemsOrderAnnotationType});}}))))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"space-between",align:"middle",gutter:32,style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:16},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group,{value:derivedCodelistViewMode,onChange:function onChange(_ref20){var target=_ref20.target;if(target.value===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]&&dCSourceItemCount&&dCSourceItemCount>maxTreeNodes){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t('components.itemList.modals.treeViewModeUnavailable.title'),content:t('components.itemList.modals.treeViewModeUnavailable.content')});}else if(dCSourceItemPage&&dCSourceItemPage.find(function(_ref21){var isSelected=_ref21.isSelected;return isSelected;})||dcSourceSelectedItems.length>0){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('reduxComponents.derivedItemsScheme.viewModeRadio.confirm.title'),content:t('reduxComponents.derivedItemsScheme.viewModeRadio.confirm.content'),onOk:function onOk(){onDerivedCodelistViewModeChange(target.value,codelistTriplet);},cancelText:t('commons.buttons.cancel.title')});}else{onDerivedCodelistViewModeChange(target.value,codelistTriplet);}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{title:t('reduxComponents.derivedItemsScheme.viewModeRadio.table.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"table"}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{title:t('reduxComponents.derivedItemsScheme.viewModeRadio.tree.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"branches",style:{transform:"rotate(90deg)"}}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return setIsVisible(true);},icon:"zoom-in"},t('reduxComponents.derivedItemsScheme.buttons.zoom.title'))))),derivedCodelistViewMode===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["a" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:32},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.preservesHierarchy.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:importCheckbox.preserveHierarchy,onChange:function onChange(e){return onCheckboxChange({preserveHierarchy:e.target.checked});},disabled:isImportParentDisabled})))),importCheckbox.preserveHierarchy&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.parents.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:importCheckbox.importParents,onChange:function onChange(e){return onCheckboxChange({importParents:e.target.checked});},disabled:isImportParentDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.children.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:importCheckbox.importChildren,onChange:function onChange(e){return onCheckboxChange({importChildren:e.target.checked});},disabled:isImportParentDisabled})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,t("reduxComponents.derivedItemsScheme.autoImport.descendants.label")+":"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:importCheckbox.importDescendants,onChange:function onChange(e){return onCheckboxChange({importDescendants:e.target.checked});},disabled:isImportParentDisabled}))))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"redux-codelist-detail-modal__derived-codelist"},derivedCodelistViewMode===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchDCSourceItemTree,cbParam:{triplet:codelistTriplet,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType,dcTargetItemTreeTimeStamp:dcTargetItemTreeTimeStamp},disabled:derivedCodelistViewMode!==__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__["a" /* default */],{itemTree:dcSourceItemTree,childrenKey:"codes",rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsStore(dcSourceSelectedItems,false,codelistTriplet,lang,importCheckbox);},icon:"double-right",type:"primary",disabled:dcSourceSelectedItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.addItems.title')),itemTreeMaxDepth:dcSourceItemTreeMaxDepth,selectedItems:dcSourceSelectedItems,onSelectedItemsChange:onSourceTreeItemSelect,getIsDisabledNode:function getIsDisabledNode(_ref22){var isSelectable=_ref22.isSelectable;return isSelectable===false;}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchDCTargetItemTree,cbParam:{triplet:codelistTriplet,lang:lang,itemsOrderAnnotationType:itemsOrderAnnotationType,dcTargetItemTreeTimestamp:dcTargetItemTreeTimestamp},disabled:derivedCodelistViewMode!==__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_GeneralForm__["b" /* NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE */]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_checkable_items_tree__["a" /* default */],{itemTree:dcTargetItemTree,childrenKey:"codes",rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onItemsStore(dcTargetSelectedItems,true,codelistTriplet,lang);},icon:"delete",type:"primary",disabled:dcTargetSelectedItems.length===0},t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')),itemTreeMaxDepth:dcTargetItemTreeMaxDepth,selectedItems:dcTargetSelectedItems,onSelectedItemsChange:onTargetTreeItemSelect})))):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchSourceItemPage,cbParam:dCSourceFetchPageParams,disabled:dCSourceFetchPageParams===null||currentTab!=="derived"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_infinite_scroll_table__["a" /* default */],{data:dCSourceItemPage,getRowKey:function getRowKey(_ref23){var code=_ref23.code;return code;},rowCount:dCSourceItemCount,columns:columns,height:TABLE_HEIGHT,searchBarSpan:10,rowSelection:{selectedRowKeys:dCSourceItemPage?dCSourceItemPage.filter(function(_ref24){var isSelected=_ref24.isSelected;return isSelected;}).map(function(_ref25){var code=_ref25.code;return code;}):[],onSelect:function onSelect(itemCode,selected){return onSourceItemSelect(itemCode,codelistTriplet,selected,lang);},onSelectAll:function onSelectAll(selected,filter){return onAllItemsSelect(codelistTriplet,false,selected,filter,lang);}},getIsDisabledRow:function getIsDisabledRow(_ref26){var isSelectable=_ref26.isSelectable;return!isSelectable;},rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onSelectedItemsStore(false,codelistTriplet,lang,importCheckbox);},icon:"double-right",type:"primary",disabled:!dCSourceSelectedItemCount||dCSourceSelectedItemCount===0},t('reduxComponents.derivedItemsScheme.buttons.addItems.title')),isPaginated:true,selectedRowCount:dCSourceSelectedItemCount,onChange:function onChange(_ref27){var pageNum=_ref27.pageNum,pageSize=_ref27.pageSize,searchText=_ref27.searchText,filters=_ref27.filters,sortCol=_ref27.sortCol,sortByDesc=_ref27.sortByDesc;return onSourceItemPageParamsUpdate({codelistTriplet:codelistTriplet,lang:lang,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc,itemsOrderAnnotationType:itemsOrderAnnotationType});}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchTargetItemPage,cbParam:dCTargetFetchPageParams,disabled:dCTargetFetchPageParams===null||dCSourceItemPage===null||currentTab!=="derived"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_infinite_scroll_table__["a" /* default */],{data:dCTargetItemPage,getRowKey:function getRowKey(_ref28){var code=_ref28.code;return code;},rowCount:dCTargetItemCount,columns:columns,height:TABLE_HEIGHT,searchBarSpan:10,rowSelection:{selectedRowKeys:dCTargetItemPage?dCTargetItemPage.filter(function(_ref29){var isSelected=_ref29.isSelected;return isSelected;}).map(function(_ref30){var code=_ref30.code;return code;}):[],onSelect:function onSelect(itemCode,selected){return onTargetItemSelect(itemCode,codelistTriplet,selected,lang);},onSelectAll:function onSelectAll(selected,filter){return onAllItemsSelect(codelistTriplet,true,selected,filter,lang);}},rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onSelectedItemsStore(true,codelistTriplet,lang);},icon:"delete",type:"primary",disabled:!dCTargetSelectedItemCount||dCTargetSelectedItemCount===0},t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')),isPaginated:true,selectedRowCount:dCTargetSelectedItemCount,onChange:function onChange(_ref31){var pageNum=_ref31.pageNum,pageSize=_ref31.pageSize,searchText=_ref31.searchText,filters=_ref31.filters,sortCol=_ref31.sortCol,sortByDesc=_ref31.sortByDesc;return onTargetItemPageParamsUpdate({codelistTriplet:codelistTriplet,lang:lang,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc,itemsOrderAnnotationType:itemsOrderAnnotationType});}})))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onSelectedDbRestore(codelistTriplet);},disabled:!(dCTargetItemCount>0||dcTargetItemTreeMaxDepth>0)},t('reduxComponents.derivedItemsScheme.buttons.emptyList.title'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onCreateShow(codelistTriplet,lang);},disabled:!(dCTargetItemCount>0||dcTargetItemTreeMaxDepth>0)},t('reduxComponents.derivedItemsScheme.buttons.create.title')))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isCreateVisible&&derivedCodelist!==null,title:t('reduxComponents.derivedItemsScheme.modals.derive.title'),width:__WEBPACK_IMPORTED_MODULE_19__styles_constants__["MODAL_WIDTH_MD"],withDataLanguageSelector:true,onCancel:onCreateHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onCreateHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_23__utils_artefactValidators__["a" /* isArtefactValid */])(derivedCodelist)){onCreateSubmit(codelistTriplet,lang,derivedCodelist);}else{__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('reduxComponents.derivedItemsScheme.buttons.deriveSubmit.title')))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_artefact_min_form__["b" /* default */],{artefact:derivedCodelist,agencies:agencies,onChange:onCreateChange,mode:__WEBPACK_IMPORTED_MODULE_27__components_artefact_min_form__["a" /* ARTEFACT_MIN_FORM_MODE_CREATE */]})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t('reduxComponents.derivedItemsScheme.modals.warning.parentMissing.title'),onOk:function onOk(){onCreateHide();},onCancel:function onCancel(){onCreateHide();}});},disabled:!(isCreateVisible&&!derivedCodelist)},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",null)));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DerivedCodelist));

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Item__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_items_import_form__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_items_viewer__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_layout_annotation_list__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,appLanguage:state.app.language,conceptSchemeTriplet:instanceState.conceptSchemeTriplet,conceptScheme:instanceState.conceptScheme,selectedItem:instanceState.selectedItem,itemsViewMode:instanceState.itemsViewMode,isItemsImportFormVisible:instanceState.isItemsImportFormVisible,itemsImportForm:instanceState.itemsImportForm,itemAnnotations:instanceState.itemAnnotations,itemLayoutAnnotations:instanceState.itemLayoutAnnotations,itemAnnotationId:instanceState.itemAnnotationId,itemsTree:instanceState.itemsTree,maxOrder:instanceState.maxOrder,isDuplicateItemErrorVisible:instanceState.isDuplicateItemErrorVisible,cutItem:instanceState.cutItem};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onViewModeChange:function onViewModeChange(viewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_9" /* changeConceptSchemeDetailItemsViewMode */])(viewMode),instancePrefix));},onCreate:function onCreate(parentId,order,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_11" /* createConceptSchemeDetailsItemsItem */])(parentId,order,lang,itemsOrderAnnotationType),instancePrefix));},onDetailEdit:function onDetailEdit(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_16" /* editConceptSchemeDetailItemsItemDetail */])(item),instancePrefix));},onDelete:function onDelete(conceptScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_13" /* deleteConceptSchemeDetailsItemsItem */])(conceptScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType),instancePrefix));},onSelect:function onSelect(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_35" /* selectConceptSchemeDetailsItemsItem */])(id),instancePrefix));},onImportFormShow:function onImportFormShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_42" /* showConceptSchemeDetailItemsImportForm */])(),instancePrefix));},onImportFormHide:function onImportFormHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_23" /* hideConceptSchemeDetailItemsImportForm */])(),instancePrefix));},onImportFormChange:function onImportFormChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_7" /* changeConceptSchemeDetailItemsImportForm */])(fields),instancePrefix));},onImportFormFileUpload:function onImportFormFileUpload(conceptScheme,itemsImportForm){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_57" /* uploadConceptSchemeDetailItemsImportFormFile */])(conceptScheme,itemsImportForm),instancePrefix));},onImportFormFileImport:function onImportFormFileImport(conceptScheme,itemsImportForm){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_30" /* importConceptSchemeDetailItemsImportFormFile */])(conceptScheme,itemsImportForm),instancePrefix));},onAnnotationsShow:function onAnnotationsShow(annotations,itemId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_44" /* showConceptSchemeDetailItemsItemAnnotations */])(annotations,itemId),instancePrefix));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_25" /* hideConceptSchemeDetailItemsItemAnnotations */])(),instancePrefix));},onLayoutAnnotationsShow:function onLayoutAnnotationsShow(annotations,itemId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_45" /* showConceptSchemeDetailItemsItemLayoutAnnotations */])(annotations,itemId),instancePrefix));},onLayoutAnnotationsHide:function onLayoutAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_28" /* hideConceptSchemeDetailItemsItemLayoutAnnotations */])(),instancePrefix));},onDrop:function onDrop(node,newParent,newOrder,conceptScheme,itemsTree,itemsOrderAnnotationType,lang,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_14" /* dropConceptSchemeDetailItemsItems */])(node,newParent,newOrder,conceptScheme,itemsTree,itemsOrderAnnotationType,lang,cutItem,t),instancePrefix));},onDuplicateItemErrorHide:function onDuplicateItemErrorHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_27" /* hideConceptSchemeDetailItemsItemDuplicateItemError */])(),instancePrefix));},onCut:function onCut(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_12" /* cutConceptSchemeDetailItemsItem */])(item),instancePrefix));},onPaste:function onPaste(cutItem,newParent,pasteAfter,conceptScheme,itemsTree,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_31" /* pasteConceptSchemeDetailItemsItem */])(cutItem,newParent,pasteAfter,conceptScheme,itemsTree,lang,itemsOrderAnnotationType),instancePrefix));},onItemSubmit:function onItemSubmit(conceptScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_52" /* submitConceptSchemeDetailItemsItem */])(conceptScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t),instancePrefix));},onImportFormAllCsvRowsShow:function onImportFormAllCsvRowsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_43" /* showConceptSchemeDetailItemsImportFormAllCsvRows */])(),instancePrefix));},onImportFormAllCsvRowsHide:function onImportFormAllCsvRowsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_24" /* hideConceptSchemeDetailItemsImportFormAllCsvRows */])(),instancePrefix));},uploadImportFormCsv:function uploadImportFormCsv(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_56" /* uploadConceptSchemeDetailItemsImportFormCsv */])(file),instancePrefix));},fetchImportFormAllCsvRows:function fetchImportFormAllCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_34" /* readConceptSchemeDetailItemsImportFormAllCsvRows */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath),instancePrefix));},onSetDefaultOrder:function onSetDefaultOrder(conceptScheme,itemsTree,currLang,dataLangs,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_36" /* setConceptSchemeDetailItemsDefaultOrder */])(conceptScheme,itemsTree,currLang,dataLangs,itemsOrderAnnotationType),instancePrefix));}};};var ConceptSchemeDetailItems=function ConceptSchemeDetailItems(_ref3){var t=_ref3.t,nodes=_ref3.nodes,nodeId=_ref3.nodeId,appLanguage=_ref3.appLanguage,instanceState=_ref3.instanceState,instancePrefix=_ref3.instancePrefix,isEditDisabled=_ref3.isEditDisabled,conceptSchemeTriplet=_ref3.conceptSchemeTriplet,conceptScheme=_ref3.conceptScheme,itemsViewMode=_ref3.itemsViewMode,selectedItem=_ref3.selectedItem,isItemsImportFormVisible=_ref3.isItemsImportFormVisible,itemsImportForm=_ref3.itemsImportForm,onViewModeChange=_ref3.onViewModeChange,onCreate=_ref3.onCreate,onDetailEdit=_ref3.onDetailEdit,onDelete=_ref3.onDelete,onSelect=_ref3.onSelect,onImportFormShow=_ref3.onImportFormShow,onImportFormHide=_ref3.onImportFormHide,onImportFormChange=_ref3.onImportFormChange,onImportFormFileUpload=_ref3.onImportFormFileUpload,onImportFormFileImport=_ref3.onImportFormFileImport,itemAnnotations=_ref3.itemAnnotations,itemLayoutAnnotations=_ref3.itemLayoutAnnotations,itemAnnotationId=_ref3.itemAnnotationId,onAnnotationsShow=_ref3.onAnnotationsShow,onAnnotationsHide=_ref3.onAnnotationsHide,onLayoutAnnotationsShow=_ref3.onLayoutAnnotationsShow,onLayoutAnnotationsHide=_ref3.onLayoutAnnotationsHide,onDrop=_ref3.onDrop,itemsTree=_ref3.itemsTree,maxOrder=_ref3.maxOrder,isDuplicateItemErrorVisible=_ref3.isDuplicateItemErrorVisible,onDuplicateItemErrorHide=_ref3.onDuplicateItemErrorHide,cutItem=_ref3.cutItem,onCut=_ref3.onCut,onPaste=_ref3.onPaste,onItemSubmit=_ref3.onItemSubmit,onImportFormAllCsvRowsShow=_ref3.onImportFormAllCsvRowsShow,onImportFormAllCsvRowsHide=_ref3.onImportFormAllCsvRowsHide,uploadImportFormCsv=_ref3.uploadImportFormCsv,fetchImportFormAllCsvRows=_ref3.fetchImportFormAllCsvRows,onSetDefaultOrder=_ref3.onSetDefaultOrder;var annotationsConfig=nodes.find(function(node){return node.general.id===nodeId;}).annotations;var itemsOrderAnnotationType=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(nodes,function(node){return node.general.id===nodeId;}).annotations.conceptSchemesOrder;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_items_viewer__["a" /* default */],{artefact:conceptScheme,artefactTriplet:conceptSchemeTriplet,itemTree:itemsTree,childrenKey:"concepts",selectedItem:selectedItem,cutItem:cutItem,itemsViewMode:itemsViewMode,itemsOrderAnnotationType:itemsOrderAnnotationType,maxOrder:maxOrder,onCreate:onCreate,onDelete:onDelete,onDetailShow:onDetailEdit,onSelect:onSelect,onDrop:onDrop,onCut:onCut,onPaste:onPaste,onAnnotationsShow:onAnnotationsShow,onLayoutAnnotationsShow:onLayoutAnnotationsShow,onViewModeChange:onViewModeChange,onImportFormShow:onImportFormShow,onSetDefault:function onSetDefault(item){var newItem=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);newItem.annotations=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["Z" /* setLayoutAnnotationDefaultForCodelist */])(newItem.annotations,annotationsConfig,true);onItemSubmit(conceptScheme,itemsTree,newItem,itemsOrderAnnotationType,true,lang,false,cutItem,t);},onUnsetDefault:function onUnsetDefault(item){var newItem=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);newItem.annotations=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["Z" /* setLayoutAnnotationDefaultForCodelist */])(newItem.annotations,annotationsConfig,false);onItemSubmit(conceptScheme,itemsTree,newItem,itemsOrderAnnotationType,true,lang,false,cutItem,t);},isEditDisabled:isEditDisabled,onSetDefaultOrder:onSetDefaultOrder}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_items_import_form__["a" /* default */],{isVisible:isItemsImportFormVisible,formData:itemsImportForm,onHide:onImportFormHide,onChange:onImportFormChange,onUpload:function onUpload(){return onImportFormFileUpload(conceptScheme,itemsImportForm);},onImport:function onImport(){return onImportFormFileImport(conceptScheme,itemsImportForm);},onAllCsvRowsShow:onImportFormAllCsvRowsShow,onAllCsvRowsHide:onImportFormAllCsvRowsHide,uploadCsv:uploadImportFormCsv,fetchAllCsvRows:fetchImportFormAllCsvRows}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix,isEditDisabled:isEditDisabled}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_custom_annotation_list__["a" /* default */],{annotations:itemAnnotations,onClose:onAnnotationsHide,title:itemAnnotationId}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_layout_annotation_list__["a" /* default */],{annotations:itemLayoutAnnotations,onClose:onLayoutAnnotationsHide,title:itemAnnotationId}),isDuplicateItemErrorVisible&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t('commons.artefact.tabs.items.modals.errors.duplicateItem'),onOk:function onOk(){onDuplicateItemErrorHide();},onCancel:function onCancel(){onDuplicateItemErrorHide();}});}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",null)));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ConceptSchemeDetailItems));

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_item_form__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,appLanguage:state.app.language,conceptScheme:instanceState.conceptScheme,item:instanceState.item,isItemEditMode:instanceState.isItemEditMode,isItemsParentListVisible:instanceState.isItemsParentListVisible,itemsTree:instanceState.itemsTree,isNormalizeNeeded:instanceState.isNormalizeNeeded,cutItem:instanceState.cutItem};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onItemDetailChange:function onItemDetailChange(fields,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_8" /* changeConceptSchemeDetailItemsItemDetail */])(fields,lang,itemsOrderAnnotationType),instancePrefix));},onItemDetailSubmit:function onItemDetailSubmit(conceptScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_52" /* submitConceptSchemeDetailItemsItem */])(conceptScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t),instancePrefix));},onItemDetailHide:function onItemDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_26" /* hideConceptSchemeDetailItemsItemDetail */])(),instancePrefix));},onItemsParentListShow:function onItemsParentListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_46" /* showConceptSchemeDetailItemsItemParentList */])(),instancePrefix));},onItemsParentListHide:function onItemsParentListHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_29" /* hideConceptSchemeDetailItemsItemParentList */])(),instancePrefix));},onItemsParentListSet:function onItemsParentListSet(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_37" /* setConceptSchemeDetailItemsItemParentList */])(item),instancePrefix));},onItemsParentListUnset:function onItemsParentListUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_55" /* unsetConceptSchemeDetailItemsItemParentList */])(),instancePrefix));}};};var ConceptSchemesDetailItem=function ConceptSchemesDetailItem(_ref3){var t=_ref3.t,nodes=_ref3.nodes,nodeId=_ref3.nodeId,permissions=_ref3.permissions,appLanguage=_ref3.appLanguage,isEditDisabled=_ref3.isEditDisabled,conceptScheme=_ref3.conceptScheme,item=_ref3.item,isItemEditMode=_ref3.isItemEditMode,onItemDetailChange=_ref3.onItemDetailChange,onItemDetailSubmit=_ref3.onItemDetailSubmit,onItemDetailHide=_ref3.onItemDetailHide,isItemsParentListVisible=_ref3.isItemsParentListVisible,onItemsParentListShow=_ref3.onItemsParentListShow,onItemsParentListHide=_ref3.onItemsParentListHide,onItemsParentListSet=_ref3.onItemsParentListSet,onItemsParentListUnset=_ref3.onItemsParentListUnset,itemsTree=_ref3.itemsTree,isNormalizeNeeded=_ref3.isNormalizeNeeded,cutItem=_ref3.cutItem;var annotationsConfig=nodes.find(function(node){return node.general.id===nodeId;}).annotations;var itemsOrderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.conceptSchemesOrder;var userHasPermissionsToEdit=permissions&&conceptScheme&&permissions.agencies.filter(function(agency){return agency===conceptScheme.agencyID;}).length>0&&!isEditDisabled;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__["a" /* default */],{title:isItemEditMode&&item?userHasPermissionsToEdit?t("commons.artefact.tabs.items.item.detail.title.editMode.title",{id:item.id}):t("commons.artefact.tabs.items.item.detail.title.viewMode.title",{id:item.id}):t("commons.artefact.tabs.items.item.detail.title.createMode.title"),visible:item!==null,onCancel:onItemDetailHide,width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onItemDetailHide},t('commons.buttons.close.title')),!isItemEditMode||userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["g" /* isItemValid */])(item)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onItemDetailSubmit(conceptScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t);}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_item_form__["f" /* default */],{item:item?item:null,mode:isItemEditMode?userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_9__components_item_form__["c" /* ITEM_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_9__components_item_form__["e" /* ITEM_FORM_MODE_READ */]:__WEBPACK_IMPORTED_MODULE_9__components_item_form__["a" /* ITEM_FORM_MODE_CREATE */],onChange:function onChange(fields){return onItemDetailChange(fields,lang,itemsOrderAnnotationType);},itemsParentListShow:onItemsParentListShow,itemsParentListUnset:onItemsParentListUnset,annotationsConfig:annotationsConfig})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__["a" /* default */],{visible:isItemsParentListVisible?isItemsParentListVisible:false,onCancel:onItemsParentListHide,title:t('commons.artefact.tabs.items.item.detail.modals.parentList.title'),width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onItemsParentListHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_item_list__["a" /* default */],{data:item&&Object(__WEBPACK_IMPORTED_MODULE_12__utils_tree__["l" /* getNodes */])(itemsTree,"concepts",function(node){return node.id!==item.id;}).filter(function(node){return!Object(__WEBPACK_IMPORTED_MODULE_12__utils_tree__["o" /* testAnchestor */])(node,item,itemsTree,"concepts");}),onRowClick:function onRowClick(item){return onItemsParentListSet(item);}})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ConceptSchemesDetailItem));

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artefact_summary__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{codelistTriplet:instanceState.codelistTripletForCodesSelector,itemsPage:instanceState.itemsPageForNotDisplayedCodesSelector,itemsCount:instanceState.itemsCountForNotDisplayedCodesSelector,appLanguage:state.app.language,tempSelectedCodes:instanceState.tempSelectedCodesForNotDisplayedCodesSelector};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_61" /* hideDsdDetailNotDisplayedCodesSelector */])(),instancePrefix));},onSubmit:function onSubmit(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_90" /* submitDsdDetailNotDisplayedCodesSelector */])(),instancePrefix));},fetchItemsPage:function fetchItemsPage(_ref3){var codelistTriplet=_ref3.codelistTriplet,language=_ref3.language,pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,searchText=_ref3.searchText,filters=_ref3.filters,sortCol=_ref3.sortCol,sortByDesc=_ref3.sortByDesc;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_68" /* readDsdDetailItemsPageForNotDisplayedCodesSelector */])({codelistTriplet:codelistTriplet,language:language,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc}),instancePrefix));},onChangeTempSelectedCodes:function onChangeTempSelectedCodes(selected){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_35" /* changeDsdDetailNotDisplayedCodesSelectorTempSelectedCodes */])(selected),instancePrefix));}};};var DsdsNotDisplayedCodesSelector=function DsdsNotDisplayedCodesSelector(_ref4){var t=_ref4.t,appLanguage=_ref4.appLanguage,codelistTriplet=_ref4.codelistTriplet,tempSelectedCodes=_ref4.tempSelectedCodes,itemsPage=_ref4.itemsPage,itemsCount=_ref4.itemsCount,onHide=_ref4.onHide,onSubmit=_ref4.onSubmit,fetchItemsPage=_ref4.fetchItemsPage,onChangeTempSelectedCodes=_ref4.onChangeTempSelectedCodes;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_enhanced_modal__["a" /* default */],{visible:codelistTriplet!==null&&tempSelectedCodes!==null,width:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MODAL_WIDTH_LG"],title:t('reduxComponents.dsdDetail.notDisplayedCodesSelector.title'),onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.cancel.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onSubmit,type:"primary"},t('commons.buttons.save.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_artefact_summary__["a" /* default */],{id:codelistTriplet&&codelistTriplet.id,agencyID:codelistTriplet&&codelistTriplet.agencyID,version:codelistTriplet&&codelistTriplet.version})),codelistTriplet!==null&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_item_list__["a" /* default */],{data:itemsPage||null,rowCount:itemsCount,isPaginated:true,onChange:function onChange(_ref5){var pageNum=_ref5.pageNum,pageSize=_ref5.pageSize,searchText=_ref5.searchText,filters=_ref5.filters,sortCol=_ref5.sortCol,sortByDesc=_ref5.sortByDesc;return fetchItemsPage({codelistTriplet:codelistTriplet,language:language,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc});},rowSelection:{selectedRowKeys:tempSelectedCodes,onChange:onChangeTempSelectedCodes}});}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsNotDisplayedCodesSelector));

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artefact_summary__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{codelistTriplet:instanceState.codelistTripletForCodesSelector,itemsPage:instanceState.itemsPageForDefaultCodesSelector,itemsCount:instanceState.itemsCountForDefaultCodesSelector,appLanguage:state.app.language,tempSelectedCodes:instanceState.tempSelectedCodesForDefaultCodesSelector};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_54" /* hideDsdDetailDefaultCodesSelector */])(),instancePrefix));},onSubmit:function onSubmit(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_85" /* submitDsdDetailDefaultCodesSelector */])(),instancePrefix));},fetchItemsPage:function fetchItemsPage(_ref3){var codelistTriplet=_ref3.codelistTriplet,language=_ref3.language,pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,searchText=_ref3.searchText,filters=_ref3.filters,sortCol=_ref3.sortCol,sortByDesc=_ref3.sortByDesc;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_67" /* readDsdDetailItemsPageForDefaultCodesSelector */])({codelistTriplet:codelistTriplet,language:language,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc}),instancePrefix));},onChangeTempSelectedCodes:function onChangeTempSelectedCodes(selected){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_25" /* changeDsdDetailDefaultCodesSelectorTempSelectedCodes */])(selected),instancePrefix));}};};var DsdsDefaultCodesSelector=function DsdsDefaultCodesSelector(_ref4){var t=_ref4.t,appLanguage=_ref4.appLanguage,codelistTriplet=_ref4.codelistTriplet,tempSelectedCodes=_ref4.tempSelectedCodes,itemsPage=_ref4.itemsPage,itemsCount=_ref4.itemsCount,onHide=_ref4.onHide,onSubmit=_ref4.onSubmit,fetchItemsPage=_ref4.fetchItemsPage,onChangeTempSelectedCodes=_ref4.onChangeTempSelectedCodes;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_enhanced_modal__["a" /* default */],{visible:codelistTriplet!==null&&tempSelectedCodes!==null,width:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MODAL_WIDTH_LG"],title:t('reduxComponents.dsdDetail.defaultCodesSelector.title'),onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.cancel.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onSubmit,type:"primary"},t('commons.buttons.save.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_artefact_summary__["a" /* default */],{id:codelistTriplet&&codelistTriplet.id,agencyID:codelistTriplet&&codelistTriplet.agencyID,version:codelistTriplet&&codelistTriplet.version})),codelistTriplet!==null&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_item_list__["a" /* default */],{data:itemsPage||null,rowCount:itemsCount,isPaginated:true,onChange:function onChange(_ref5){var pageNum=_ref5.pageNum,pageSize=_ref5.pageSize,searchText=_ref5.searchText,filters=_ref5.filters,sortCol=_ref5.sortCol,sortByDesc=_ref5.sortByDesc;return fetchItemsPage({codelistTriplet:codelistTriplet,language:language,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc});},rowSelection:{selectedRowKeys:tempSelectedCodes,onChange:onChangeTempSelectedCodes}});}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsDefaultCodesSelector));

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_menu__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__category_form_actions__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(308);
var CREATE_BUTTON_ITEM_CREATE_CUBE="CREATE_BUTTON_ITEM_CREATE_CUBE";var CREATE_BUTTON_ITEM_CREATE_CATEGORY="CREATE_BUTTON_ITEM_CREATE_CATEGORY";var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,categorisedCubes:state.scenes.dataManager.builder.shared.categorisedCubes,selectedCubeId:state.scenes.dataManager.builder.shared.cubeId,category:state.scenes.dataManager.builder.shared.category,permissions:state.app.user.permissions,forbiddenCubesCodes:state.scenes.dataManager.builder.shared.forbiddenCubesCodes,forbiddenCategoriesCodes:state.scenes.dataManager.builder.shared.forbiddenCategoriesCodes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCubeSelect:function onCubeSelect(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["m" /* selectBuilderCubeTreeCube */])(cubeId));},onCategorySelect:function onCategorySelect(category){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["n" /* selectBuilderCubeTreeCubeCategory */])(category));},onCubeCreate:function onCubeCreate(categoryId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["h" /* createBuilderCubeTreeCube */])(categoryId));},onCubeDelete:function onCubeDelete(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["j" /* deleteBuilderCubeTreeCube */])(cubeId));},onCategoryCreate:function onCategoryCreate(parCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__category_form_actions__["i" /* createBuilderCategoryForm */])(parCode));},onCategoryDelete:function onCategoryDelete(catCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["i" /* deleteBuilderCubeTreeCategory */])(catCode));},fetchCategorisedCubes:function fetchCategorisedCubes(_ref){var forbiddenCubesCodes=_ref.forbiddenCubesCodes,forbiddenCategoriesCodes=_ref.forbiddenCategoriesCodes;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["l" /* readBuilderCubeTreeCategorisedCubes */])(forbiddenCubesCodes,forbiddenCategoriesCodes));},onCategoryMove:function onCategoryMove(categories){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["k" /* moveBuilderCubeTreeCategory */])(categories));}};};var disabledItemStyle={cursor:"not-allowed",color:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["COLOR_FONT_DISABLED"]};var _onDrop=function _onDrop(ev,categorisedCubes,t,onCategoryMove){var pos=ev.node.props.pos.split('-');var dropPos=ev.dropPosition-Number(pos[pos.length-1]);var draggedNode=ev.dragNode.props["data-node"];var targetNode=ev.node.props["data-node"];if(draggedNode.CatCode&&targetNode.CatCode&&draggedNode.CatCode!==targetNode.CatCode&&draggedNode.CatCode!==__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode){if(ev.dropToGap&&targetNode.CatCode!==__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode){// moved next to a category (but not next to the root)
draggedNode.Ord=dropPos>0?String(Number(targetNode.Ord)+Number("0.1")):String(Number(targetNode.Ord)-Number("0.1"));var targetParentNode=Object(__WEBPACK_IMPORTED_MODULE_16__utils_tree__["k" /* getNode */])(categorisedCubes,"children",function(node){return node.CatCode===targetNode.ParCode||targetNode.ParCode===null&&node.CatCode===__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode;});if(targetParentNode.CatCode!==__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode&&draggedNode.ParCode!==targetParentNode.CatCode||targetParentNode.CatCode===__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode&&draggedNode.ParCode!==null){// parent has to be changed
targetParentNode.children.push(draggedNode);draggedNode.ParCode=targetParentNode.CatCode!==__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode?targetParentNode.CatCode:null;}targetParentNode.children=targetParentNode.children.sort(function(a,b){if(a.Ord!==undefined&&b.Ord!==undefined){return a.Ord-b.Ord;}else if(a.Ord!==undefined){return a;}else if(b.Ord!==undefined){return b;}else{return(a.CatCode||-1)-(b.CatCode||-1);}});var ordCount=1;targetParentNode.children=targetParentNode.children.map(function(c){return Object.assign({},c,{Ord:c.Ord!==undefined?String(ordCount++):undefined});});onCategoryMove(targetParentNode.children.filter(function(c){return c.CatCode!==undefined;}));}else if(targetNode.CatCode!==__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode&&draggedNode.ParCode!==targetNode.CatCode||targetNode.CatCode===__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode&&draggedNode.ParCode!==null){// moved into a category (not the parent)
draggedNode.Ord=String(targetNode.children.filter(function(c){return c.CatCode!==undefined;}).length+1);draggedNode.ParCode=targetNode.CatCode!==__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode?targetNode.CatCode:null;onCategoryMove([draggedNode]);}}else{__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t('scenes.dataManager.builder.cubeTree.modals.forbiddenDragNDrop.title'),content:t('scenes.dataManager.builder.cubeTree.modals.forbiddenDragNDrop.content')});}};var BuilderCategorisedCubesTree=function BuilderCategorisedCubesTree(_ref2){var t=_ref2.t,appLanguage=_ref2.appLanguage,permissions=_ref2.permissions,dataLanguages=_ref2.dataLanguages,categorisedCubes=_ref2.categorisedCubes,selectedCubeId=_ref2.selectedCubeId,category=_ref2.category,forbiddenCubesCodes=_ref2.forbiddenCubesCodes,forbiddenCategoriesCodes=_ref2.forbiddenCategoriesCodes,onCubeSelect=_ref2.onCubeSelect,onCategorySelect=_ref2.onCategorySelect,onCubeCreate=_ref2.onCubeCreate,onCubeDelete=_ref2.onCubeDelete,onCategoryCreate=_ref2.onCategoryCreate,onCategoryDelete=_ref2.onCategoryDelete,onCategoryMove=_ref2.onCategoryMove,fetchCategorisedCubes=_ref2.fetchCategorisedCubes;var isAdmin=permissions&&permissions.rules&&permissions.rules.includes("AdminRole");var isCreateCubeDisabled=function isCreateCubeDisabled(category){return category===null||category.CatCode===null||forbiddenCategoriesCodes.includes(category.CatCode);};var addAction=isAdmin?{title:t('scenes.dataManager.builder.cubeTree.createButton.title'),icon:'plus',render:function render(props){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default.a,{disabled:category===null||category.IDCat===null,trigger:['click'],overlay:__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a,{onClick:function onClick(_ref3){var key=_ref3.key;switch(key){case CREATE_BUTTON_ITEM_CREATE_CUBE:if(!isCreateCubeDisabled(category)){onCubeCreate(category.IDCat);}break;case CREATE_BUTTON_ITEM_CREATE_CATEGORY:onCategoryCreate(category.CatCode);break;default:break;}}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item,{key:CREATE_BUTTON_ITEM_CREATE_CUBE},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('a',{style:isCreateCubeDisabled(category)?disabledItemStyle:null},t('scenes.dataManager.builder.cubeTree.createButton.items.createCube'))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item,{key:CREATE_BUTTON_ITEM_CREATE_CATEGORY},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('a',{style:category===null?disabledItemStyle:null},t('scenes.dataManager.builder.cubeTree.createButton.items.createCategory'))))},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,props));}}:{disabled:category===null||forbiddenCategoriesCodes.includes(category.CatCode),title:t('scenes.dataManager.builder.cubeTree.createButton.title'),icon:'plus',onClick:function onClick(){return onCubeCreate(category.IDCat);}};var deleteAction=isAdmin?{disabled:selectedCubeId===null&&(category===null||category.IDCat===null||category.CatCode===__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode||category.children.length>0),title:selectedCubeId!==null?t('scenes.dataManager.builder.cubeTree.deleteButton.cube.title'):category!==null&&category.IDCat!==null?t('scenes.dataManager.builder.cubeTree.deleteButton.category.title'):null,icon:'delete',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:selectedCubeId!==null?t('scenes.dataManager.builder.cubeTree.deleteButton.cube.confirm',{id:Object(__WEBPACK_IMPORTED_MODULE_16__utils_tree__["k" /* getNode */])(categorisedCubes,'children',function(node){return node.IDCube===selectedCubeId;}).Code}):t('scenes.dataManager.builder.cubeTree.deleteButton.category.confirm',{id:category.CatCode}),onOk:function onOk(){if(selectedCubeId!==null){onCubeDelete(selectedCubeId);}else{onCategoryDelete(category.CatCode);}},cancelText:t('commons.buttons.cancel.title')});}}:{disabled:selectedCubeId===null,title:t('scenes.dataManager.builder.cubeTree.deleteButton.cube.title'),icon:'delete',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.builder.cubeTree.deleteButton.cube.confirm',{id:Object(__WEBPACK_IMPORTED_MODULE_16__utils_tree__["k" /* getNode */])(categorisedCubes,'children',function(node){return node.IDCube===selectedCubeId;}).Code}),onOk:function onOk(){onCubeDelete(selectedCubeId);},cancelText:t('commons.buttons.cancel.title')});}};return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchCategorisedCubes,cbParam:{forbiddenCubesCodes:forbiddenCubesCodes,forbiddenCategoriesCodes:forbiddenCategoriesCodes},disabled:categorisedCubes!==null},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_enhanced_tree__["a" /* default */],{tree:categorisedCubes,childrenKey:'children',idKey:'Code',nameKey:'labels',catIdKey:'CatCode',catNameKey:'labels',unselectableKeys:[__WEBPACK_IMPORTED_MODULE_16__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode,__WEBPACK_IMPORTED_MODULE_16__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],unallowedIdKeys:!!forbiddenCategoriesCodes&&!!forbiddenCubesCodes?forbiddenCubesCodes.concat(forbiddenCategoriesCodes):[],getFilter:function getFilter(searchText){return function(_ref4){var Code=_ref4.Code,CatCode=_ref4.CatCode,labels=_ref4.labels;var search=searchText.toLowerCase();return Code&&Code.toLowerCase().indexOf(search)>=0||CatCode&&CatCode.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_15__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},actions:[addAction,deleteAction],onSelect:function onSelect(selectedArr){if(selectedArr!==null&&selectedArr.length>0){var node=Object(__WEBPACK_IMPORTED_MODULE_16__utils_tree__["k" /* getNode */])(categorisedCubes,'children',function(node){return node.children?node.CatCode===selectedArr[0]:node.Code===selectedArr[0];});if(node&&node.children){onCategorySelect(Object.assign({},node,{CatCode:node.CatCode!==__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode?node.CatCode:null}));if(!isAdmin&&node.CatCode!==__WEBPACK_IMPORTED_MODULE_17__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode&&forbiddenCategoriesCodes.includes(node.CatCode)){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t('scenes.dataManager.builder.cubeTree.modals.forbiddenCategory.title'),content:t('scenes.dataManager.builder.cubeTree.modals.forbiddenCategory.content')});}}else{onCategorySelect(null);}onCubeSelect(node&&!node.children&&!forbiddenCubesCodes.includes(node.Code)?node.IDCube:null);if(node&&forbiddenCubesCodes.includes(node.Code)){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t('scenes.dataManager.builder.cubeTree.modals.forbiddenNode.title'),content:t('scenes.dataManager.builder.cubeTree.modals.forbiddenNode.content')});}}else{onCategorySelect(null);onCubeSelect(null);}},treeActions:[{title:t('scenes.dataManager.builder.cubeTree.refreshButton.title'),icon:'sync',onClick:function onClick(){return fetchCategorisedCubes(forbiddenCubesCodes,forbiddenCategoriesCodes);}}],icon:'cube',isCustomIcon:true,getIconColor:function getIconColor(){return"#37a0f4";},searchBarSpan:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_HALF"],draggable:isAdmin,onDrop:function onDrop(e){return _onDrop(e,categorisedCubes,t,onCategoryMove);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(BuilderCategorisedCubesTree));

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dsd_control__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_control__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__constants_numbers__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_perf_input__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__style_css__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__style_css__);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]}};var mapStateToProps=function mapStateToProps(state){return{cubeId:state.scenes.dataManager.builder.shared.cubeId,cube:state.scenes.dataManager.builder.components.cubeForm.shared.cube,cubeCodePrefix:state.config.dataManagement.cubeCodePrefix};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCube:function fetchCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["f" /* readBuilderCubeFormCube */])(cubeId));},fetchDsd:function fetchDsd(dsdCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["g" /* readBuilderCubeFormDsd */])(dsdCode));},onSubmit:function onSubmit(cube){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["h" /* submitBuilderCubeForm */])(cube));},onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["e" /* changeBuilderCubeForm */])(fields));}};};var mapPropsToFields=function mapPropsToFields(_ref){var cube=_ref.cube;return{Code:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:cube!==null&&cube.Code!==undefined?cube.Code:null}),labels:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:cube!==null&&cube.labels!==undefined?cube.labels:null}),DSDCode:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:cube!==null&&cube.DSDCode!==undefined?cube.DSDCode:null}),observedValueCanBeAlphanumeric:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:cube!==null&&cube.observedValueCanBeAlphanumeric!==undefined?cube.observedValueCanBeAlphanumeric:null}),cubeComponents:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:cube!==null&&cube.cubeComponents!==undefined?cube.cubeComponents:null})};};// TODO: prevent multiple changes relative to same value
var onFieldsChange=function onFieldsChange(props,fields){var newFields=__WEBPACK_IMPORTED_MODULE_26_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;});if(newFields.Code&&newFields.Code.length>__WEBPACK_IMPORTED_MODULE_27__constants_numbers__["a" /* ID_MAX_LEN */]){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:props.t('commons.alerts.fieldTooLong.title'),content:props.t('commons.alerts.fieldTooLong.content',{maxLen:__WEBPACK_IMPORTED_MODULE_27__constants_numbers__["a" /* ID_MAX_LEN */]})});props.onChange(props.cube);}else{props.onChange(newFields);}};var BuilderCubeForm=function BuilderCubeForm(_ref3){var t=_ref3.t,form=_ref3.form,cubeId=_ref3.cubeId,cube=_ref3.cube,onSubmit=_ref3.onSubmit,cubeCodePrefix=_ref3.cubeCodePrefix,fetchCube=_ref3.fetchCube,fetchDsd=_ref3.fetchDsd;return cubeId!==null||cube!==null?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchCube,cbParam:cubeId,disabled:cubeId===null},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,{className:'advanced-form'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:cubeId===null?'form-item-required':null,label:t('data.cube.id.label'),validateStatus:cube&&Object(__WEBPACK_IMPORTED_MODULE_28__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,cube.Code).help?"warning":null,help:cube&&Object(__WEBPACK_IMPORTED_MODULE_28__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,cube.Code).help},formItemLayout),form.getFieldDecorator('Code',{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,disabled:cubeId!==null,addonBefore:cubeId===null&&cubeCodePrefix,title:form.getFieldValue('Code'),className:'builder__cube-form__id-input'}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:cubeId===null?'form-item-required':null,label:t('data.cube.name.label')},formItemLayout),form.getFieldDecorator('labels')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_multilanguage_input__["a" /* default */],{disabled:cubeId!==null}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchDsd,cbParam:cube!==null&&cube.DSDCode,disabled:cube===null||cube.DSDCode===null},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:cubeId===null?'form-item-required':null,label:t('data.cube.dsd.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__dsd_control__["a" /* default */],{form:form})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'end',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{label:t('data.cube.observedValueCanBeAlphanumeric')},form.getFieldDecorator('observedValueCanBeAlphanumeric',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{disabled:cubeId!==null}))))),cube!==null&&cube.DSDCode!==null&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:cubeId===null?'form-item-required':null,label:t('data.cube.components.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:'inner',bodyStyle:{maxHeight:260,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_control__["a" /* default */],{form:form})))),cubeId===null&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,formItemLayout,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(cube===null||cube.Code===undefined||cube.Code===null||cube.Code.length<1||!Object(__WEBPACK_IMPORTED_MODULE_28__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,cube.Code).valid||cube.labels===undefined||cube.labels===null||__WEBPACK_IMPORTED_MODULE_26_lodash___default()(cube.labels).pickBy(function(val){return val.length>0;}).keys().value().length<1||cube.DSDCode===undefined||cube.DSDCode===null||cube.cubeComponents===undefined||cube.cubeComponents===null){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onSubmit(Object.assign({},cube,{Code:(cubeCodePrefix||'')+cube.Code}));}}},t('data.cube.saveButton.label')))))):null;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(BuilderCubeForm));

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducer__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducer__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__redux_components_redux_dsd_detail_modal__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__redux_components_redux_dsd_detail_modal_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artefact_list__ = __webpack_require__(50);
var mapStateToProps=function mapStateToProps(state){return{cubeId:state.scenes.dataManager.builder.shared.cubeId,cube:state.scenes.dataManager.builder.components.cubeForm.shared.cube,cubeDsd:state.scenes.dataManager.builder.components.cubeForm.shared.dsd,dsds:state.scenes.dataManager.builder.components.cubeForm.components.dsdControl.dsds,isDsdsVisible:state.scenes.dataManager.builder.components.cubeForm.components.dsdControl.isDsdsVisible,cubeFormDsd:state.scenes.dataManager.builder.components.cubeForm.shared.cubeFormDsd,cubeFormDsdControlDsd:state.scenes.dataManager.builder.components.cubeForm.components.dsdControl.cubeFormDsdControlDsd};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCubeDsdShow:function onCubeDsdShow(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_15__redux_components_redux_dsd_detail_modal_actions__["_72" /* showDsdDetail */])(dsdTriplet),__WEBPACK_IMPORTED_MODULE_12__reducer__["a" /* DM_BUILDER_CUBE_FORM_PREFIX */]));},onCubeDsdSet:function onCubeDsdSet(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* setBuilderCubeFormDsdControlDsd */])(dsdTriplet));},onCubeDsdUnset:function onCubeDsdUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["j" /* unsetBuilderCubeFormDsdControlDsd */])());},onDsdsShow:function onDsdsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["i" /* showBuilderCubeFormDsdControlDsds */])());},onDsdsHide:function onDsdsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["f" /* hideBuilderCUbeFormDsdControlDsds */])());},fetchDsds:function fetchDsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["g" /* readBuilderCubeFormDsdControlDsds */])());},onDetailDsdShow:function onDetailDsdShow(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_15__redux_components_redux_dsd_detail_modal_actions__["_72" /* showDsdDetail */])(dsdTriplet),__WEBPACK_IMPORTED_MODULE_13__reducer__["a" /* DM_BUILDER_CUBE_FORM_DSD_CONTROL_PREFIX */]));}};};var BuilderCubeFormDsdControl=function BuilderCubeFormDsdControl(_ref){var t=_ref.t,form=_ref.form,cubeId=_ref.cubeId,cube=_ref.cube,cubeDsd=_ref.cubeDsd,dsds=_ref.dsds,isDsdsVisible=_ref.isDsdsVisible,cubeFormDsd=_ref.cubeFormDsd,cubeFormDsdControlDsd=_ref.cubeFormDsdControlDsd,onCubeDsdShow=_ref.onCubeDsdShow,onDsdsShow=_ref.onDsdsShow,onDsdsHide=_ref.onDsdsHide,onDetailDsdShow=_ref.onDetailDsdShow,onCubeDsdSet=_ref.onCubeDsdSet,onCubeDsdUnset=_ref.onCubeDsdUnset,fetchDsds=_ref.fetchDsds;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,cube!==null&&cube.DSDCode!==null&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__redux_components_redux_dsd_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_12__reducer__["a" /* DM_BUILDER_CUBE_FORM_PREFIX */],instanceState:cubeFormDsd}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_enhanced_modal__["a" /* default */],{visible:isDsdsVisible,onCancel:onDsdsHide,title:t('scenes.dataManager.builder.cubeForm.dsdControl.dsdList.title'),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onDsdsHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchDsds},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_artefact_list__["a" /* default */],{artefacts:dsds,onRowClick:onCubeDsdSet,getIsDisabledRow:function getIsDisabledRow(record){return!record.isFinal;},onDetailShow:onDetailDsdShow}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__redux_components_redux_dsd_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_13__reducer__["a" /* DM_BUILDER_CUBE_FORM_DSD_CONTROL_PREFIX */],instanceState:cubeFormDsdControlDsd}),form.getFieldDecorator('DSDCode')(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_selector__["a" /* default */],{disabled:cubeId!==null,detailTitle:t('scenes.dataManager.builder.cubeForm.dsdControl.detailIcon.title'),selectTitle:t('scenes.dataManager.builder.cubeForm.dsdControl.selectIcon.title'),resetTitle:t('scenes.dataManager.builder.cubeForm.dsdControl.resetIcon.title'),onDetail:function onDetail(){return onCubeDsdShow({id:cubeDsd.id,agencyID:cubeDsd.agencyID,version:cubeDsd.version});},onSelect:onDsdsShow,onReset:onCubeDsdUnset})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(BuilderCubeFormDsdControl));

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_attribute_detail__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_cube_component_list__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dimension_detail__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_measure_detail__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_components_redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducer__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,cubeId:state.scenes.dataManager.builder.shared.cubeId,dsd:state.scenes.dataManager.builder.components.cubeForm.shared.dsd,codelistDetail:state.scenes.dataManager.builder.components.cubeForm.components.componentsControl.codelistDetail,attributeId:state.scenes.dataManager.builder.components.cubeForm.components.componentsControl.attributeId,dimensionId:state.scenes.dataManager.builder.components.cubeForm.components.componentsControl.dimensionId,isMeasureVisible:state.scenes.dataManager.builder.components.cubeForm.components.componentsControl.isMeasureVisible};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCodelistShow:function onCodelistShow(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_16__redux_components_redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_14__reducer__["a" /* DM_BUILDER_CUBE_FORM_COMPONENT_CONTROL_CODELIST_DETAIL_PREFIX */]));},onAttributeShow:function onAttributeShow(attributeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["j" /* showBuilderCubeFormComponentsControlAttribute */])(attributeId));},onAttributeHide:function onAttributeHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["g" /* hideBuilderCubeFormComponentsControlAttribute */])());},onDimensionShow:function onDimensionShow(dimensionId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["k" /* showBuilderCubeFormComponentsControlDimension */])(dimensionId));},onDimensionHide:function onDimensionHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["h" /* hideBuilderCubeFormComponentsControlDimension */])());},onMeasureShow:function onMeasureShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["l" /* showBuilderCubeFormComponentsControlMeasure */])());},onMeasureHide:function onMeasureHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["i" /* hideBuilderCubeFormComponentsControlMeasure */])());}};};var BuilderCubeFormComponentsControl=function BuilderCubeFormComponentsControl(_ref){var t=_ref.t,nodeId=_ref.nodeId,nodes=_ref.nodes,form=_ref.form,cubeId=_ref.cubeId,dsd=_ref.dsd,codelistDetail=_ref.codelistDetail,attributeId=_ref.attributeId,dimensionId=_ref.dimensionId,isMeasureVisible=_ref.isMeasureVisible,_onCodelistShow=_ref.onCodelistShow,onAttributeShow=_ref.onAttributeShow,onAttributeHide=_ref.onAttributeHide,onDimensionShow=_ref.onDimensionShow,onDimensionHide=_ref.onDimensionHide,onMeasureShow=_ref.onMeasureShow,onMeasureHide=_ref.onMeasureHide;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__redux_components_redux_codelist_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_14__reducer__["a" /* DM_BUILDER_CUBE_FORM_COMPONENT_CONTROL_CODELIST_DETAIL_PREFIX */],instanceState:codelistDetail}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__["a" /* default */],{visible:attributeId!==null,onCancel:onAttributeHide,title:t('scenes.dataManager.builder.componensControl.attributeModal.title'),width:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MODAL_WIDTH_SM"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onAttributeHide},t('commons.buttons.close.title'))},attributeId!==null&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_attribute_detail__["a" /* default */],{attribute:dsd!==null&&dsd.dataStructureComponents.attributeList.attributes.filter(function(attr){return attr.id===attributeId;})[0]})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__["a" /* default */],{visible:dimensionId!==null,onCancel:onDimensionHide,title:t('scenes.dataManager.builder.componensControl.dimensionModal.title'),width:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MODAL_WIDTH_SM"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onDimensionHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_dimension_detail__["a" /* default */],{dimension:dsd!==null&&(dsd.dataStructureComponents.dimensionList.dimensions.filter(function(dim){return dim.id===dimensionId;})[0]||(dsd.dataStructureComponents.dimensionList.measureDimensions||[]).filter(function(dim){return dim.id===dimensionId;})[0]||dsd.dataStructureComponents.dimensionList.timeDimensions.filter(function(dim){return dim.id===dimensionId;})[0])})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__["a" /* default */],{visible:isMeasureVisible,onCancel:onMeasureHide,title:t('scenes.dataManager.builder.componensControl.measureModal.title'),width:__WEBPACK_IMPORTED_MODULE_3__styles_constants__["MODAL_WIDTH_SM"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onMeasureHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_measure_detail__["a" /* default */],{measure:dsd!==null&&dsd.dataStructureComponents.measureList.primaryMeasure})),form.getFieldDecorator('cubeComponents')(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_cube_component_list__["a" /* default */],{disabled:cubeId!==null,onCodelistShow:function onCodelistShow(triplet){return _onCodelistShow(triplet,defaultItemsViewMode);},onAttributeShow:onAttributeShow,onDimensionShow:onDimensionShow,onMeasureShow:onMeasureShow})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(BuilderCubeFormComponentsControl));

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_components_redux_dsd_detail_modal_dsd_detail_getSdmxAttributeAttachmentLevelTranslations__ = __webpack_require__(354);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_TWO_THIRDS"]}};var mapPropsToFields=function mapPropsToFields(_ref){var attribute=_ref.attribute,t=_ref.t;return{id:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:attribute!==null?attribute.id:null}),assignmentStatus:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:attribute!==null?attribute.assignmentStatus:null}),attachmentLevel:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:attribute!==null?Object(__WEBPACK_IMPORTED_MODULE_11__redux_components_redux_dsd_detail_modal_dsd_detail_getSdmxAttributeAttachmentLevelTranslations__["a" /* getSdmxAttributeAttachmentLevelTranslations */])(t)[attribute.attachmentLevel]:null}),attachmentGroup:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:attribute!==null?attribute.attachmentGroup:null}),concept:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:attribute!==null?'('+Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(attribute.conceptIdentity))+')'+' '+attribute.conceptIdentity.split('.').pop():null}),codelist:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:attribute!==null?attribute.localRepresentation&&attribute.localRepresentation.enumeration&&Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(attribute.localRepresentation.enumeration)):null})};};var AttributeDetail=function AttributeDetail(_ref2){var t=_ref2.t,form=_ref2.form;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.attribute.id.label')},formItemLayout),form.getFieldDecorator('id')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('id'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.attribute.assignmentStatus.label')},formItemLayout),form.getFieldDecorator('assignmentStatus')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('assignmentStatus'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.attribute.attachmentLevel.label')},formItemLayout),form.getFieldDecorator('attachmentLevel')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('attachmentLevel'),disabled:true}))),form.getFieldValue('attachmentLevel')==='Group'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.attribute.group.label')},formItemLayout),form.getFieldDecorator('attachmentGroup')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('attachmentGroup'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.attribute.concept.label')},formItemLayout),form.getFieldDecorator('concept')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('concept'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.attribute.codelist.label')},formItemLayout),form.getFieldDecorator('codelist')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('codelist'),disabled:true}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields}))(AttributeDetail));

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__ = __webpack_require__(10);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_TWO_THIRDS"]}};var mapPropsToFields=function mapPropsToFields(_ref){var dimension=_ref.dimension;return{id:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:dimension!==null?dimension.id:null}),concept:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:dimension!==null?'('+Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(dimension.conceptIdentity))+')'+' '+dimension.conceptIdentity.split('.').pop():null}),codelist:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:dimension!==null?dimension.localRepresentation&&dimension.localRepresentation.enumeration&&Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(dimension.localRepresentation.enumeration)):null})};};var DimensionDetail=function DimensionDetail(_ref2){var t=_ref2.t,form=_ref2.form;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.dimension.id.label')},formItemLayout),form.getFieldDecorator('id')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('id'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.attribute.concept.label')},formItemLayout),form.getFieldDecorator('concept')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('concept'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.attribute.codelist.label')},formItemLayout),form.getFieldDecorator('codelist')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('codelist'),disabled:true}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields}))(DimensionDetail));

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__ = __webpack_require__(10);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_TWO_THIRDS"]}};var mapPropsToFields=function mapPropsToFields(_ref){var measure=_ref.measure;return{id:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:measure!==null?measure.id:null}),concept:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:measure!==null?'('+Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(measure.conceptIdentity))+')'+' '+measure.conceptIdentity.split('.').pop():null}),codelist:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:measure!==null?measure.localRepresentation&&measure.localRepresentation.enumeration&&Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(measure.localRepresentation.enumeration)):null})};};var MeasureDetail=function MeasureDetail(_ref2){var t=_ref2.t,form=_ref2.form;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.measure.id.label')},formItemLayout),form.getFieldDecorator('id')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('id'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.measure.concept.label')},formItemLayout),form.getFieldDecorator('concept')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('concept'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('data.measure.codelist.label')},formItemLayout),form.getFieldDecorator('codelist')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('codelist'),disabled:true}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields}))(MeasureDetail));

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dcs_category_form__ = __webpack_require__(1403);
var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions,category:state.scenes.dataManager.builder.shared.category,categorisedCubes:state.scenes.dataManager.builder.shared.categorisedCubes,isCategoryFormParentModalVisible:state.scenes.dataManager.builder.shared.isCategoryFormParentModalVisible};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* changeBuilderCategoryForm */])(fields));},onCreateSubmit:function onCreateSubmit(category){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["l" /* submitBuilderCategoryFormCreate */])(category));},onEditSubmit:function onEditSubmit(category){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["m" /* submitBuilderCategoryFormEdit */])(category));},onParentModalShow:function onParentModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["k" /* showBuilderCategoryFormParentModal */])());},onParentModalHide:function onParentModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["j" /* hideBuilderCategoryFormParentModal */])());}};};var mapPropsToFields=function mapPropsToFields(_ref){var category=_ref.category;return{CatCode:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:category!==null&&category.CatCode!==undefined?category.CatCode:null}),ParCode:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:category!==null&&category.ParCode!==undefined?category.ParCode:null}),labels:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:category!==null&&category.labels!==undefined?category.labels:null})};};var onFieldsChange=function onFieldsChange(_ref2,fields){var onChange=_ref2.onChange;onChange(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.mapValues(fields,function(_ref3){var value=_ref3.value;return value;}));};var BuilderCategoryForm=function BuilderCategoryForm(_ref4){var t=_ref4.t,form=_ref4.form,permissions=_ref4.permissions,category=_ref4.category,categorisedCubes=_ref4.categorisedCubes,isCategoryFormParentModalVisible=_ref4.isCategoryFormParentModalVisible,onCreateSubmit=_ref4.onCreateSubmit,onEditSubmit=_ref4.onEditSubmit,onParentModalShow=_ref4.onParentModalShow,onParentModalHide=_ref4.onParentModalHide;var disabled=!permissions||!permissions.rules||!permissions.rules.includes("AdminRole");return category!==null&&category.CatCode!==null&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_dcs_category_form__["a" /* DCSCategoryForm */],{t:t,form:form,disabled:disabled,onParentModalShow:onParentModalShow,isCategoryFormParentModalVisible:isCategoryFormParentModalVisible,onParentModalHide:onParentModalHide,categorisedCubes:categorisedCubes,category:category,onEditSubmit:onEditSubmit,onCreateSubmit:onCreateSubmit}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(BuilderCategoryForm));

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DCSCategoryForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__perf_input__ = __webpack_require__(103);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_TWO_THIRDS"]}};var DCSCategoryForm=function DCSCategoryForm(_ref){var t=_ref.t,form=_ref.form,disabled=_ref.disabled,onParentModalShow=_ref.onParentModalShow,isCategoryFormParentModalVisible=_ref.isCategoryFormParentModalVisible,onParentModalHide=_ref.onParentModalHide,categorisedCubes=_ref.categorisedCubes,category=_ref.category,onEditSubmit=_ref.onEditSubmit,onCreateSubmit=_ref.onCreateSubmit,noParent=_ref.noParent;return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{className:"advanced-form"},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t("data.item.id.label"),validateStatus:form.getFieldValue("CatCode")&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue("CatCode")).help?"warning":null,help:form.getFieldValue("CatCode")&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue("CatCode")).help},formItemLayout),form.getFieldDecorator("CatCode",{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,title:form.getFieldValue("CatCode"),style:{textTransform:"uppercase"},disabled:disabled||category.IDCat!==null}))),!noParent&&__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t("data.item.parent.label")},formItemLayout),form.getFieldDecorator("ParCode",{getValueFromEvent:function getValueFromEvent(val){return val.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__selector__["a" /* default */],{selectTitle:t('scenes.dataManager.builder.categoryForm.parentSelector.select.title'),resetTitle:t('scenes.dataManager.builder.categoryForm.parentSelector.reset.title'),onDetail:null,render:function render(v){return(v||"").toUpperCase();},onSelect:onParentModalShow,onReset:function onReset(){return form.setFieldsValue({ParCode:null});},disabled:disabled})),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__enhanced_modal__["a" /* default */],{visible:isCategoryFormParentModalVisible,onCancel:onParentModalHide,title:t('scenes.dataManager.builder.categoryForm.parentModal.title'),width:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onParentModalHide},t('commons.buttons.close.title'))},isCategoryFormParentModalVisible&&__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__infinite_scroll_table__["a" /* default */],{data:Object(__WEBPACK_IMPORTED_MODULE_12__utils_tree__["l" /* getNodes */])(categorisedCubes,"children",function(_ref2){var ParCode=_ref2.ParCode;return ParCode!==undefined;}),getRowKey:function getRowKey(_ref3){var CatCode=_ref3.CatCode;return CatCode;},columns:[{title:t("data.item.id.label"),dataIndex:'CatCode',minWidth:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t("data.item.name.label"),dataIndex:'labels',minWidth:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t("data.item.parent.label"),dataIndex:'ParCode',minWidth:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]}],onRowClick:function onRowClick(_ref4){var CatCode=_ref4.CatCode;form.setFieldsValue({ParCode:CatCode});onParentModalHide();},multilangStrDataIndexes:["labels"]}))),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t("data.item.name.label")},formItemLayout),form.getFieldDecorator("labels")(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__multilanguage_input__["a" /* default */],{title:form.getFieldValue("labels"),disabled:disabled}))),!disabled&&__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,formItemLayout,__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(category.CatCode===null||!Object(__WEBPACK_IMPORTED_MODULE_14__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,category.CatCode).valid||!Object(__WEBPACK_IMPORTED_MODULE_14__utils_artefactValidators__["d" /* isDictionaryValid */])(category.labels)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{if(category.IDCat!==null){onEditSubmit(category);}else{onCreateSubmit(category);}}}},t('data.cube.saveButton.label'))));};

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wizard__ = __webpack_require__(1407);
var FileMapping=function FileMapping(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__wizard__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (FileMapping);

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_file_mapping_form__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__wizard_actions__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_buttons__ = __webpack_require__(67);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var IconFontCNIcon=__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a.createFromIconfontCN({scriptUrl:'./static/vendor/iconfont_cn/iconfont.js'});var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,fileMappingsTree:state.scenes.dataManager.fileMapping.components.list.fileMappingsTree,fileMappingId:state.scenes.dataManager.fileMapping.components.list.fileMappingId,fileMapping:state.scenes.dataManager.fileMapping.components.list.fileMapping,fileMappingCube:state.scenes.dataManager.fileMapping.components.list.fileMappingCube};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onWizardShow:function onWizardShow(cubeId,cubeCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__wizard_actions__["z" /* showFileMappingWizard */])(cubeId,cubeCode));},onFileMappingShow:function onFileMappingShow(fileMappingId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["n" /* showFileMappingListFileMapping */])(fileMappingId));},onFileMappingHide:function onFileMappingHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["j" /* hideFileMappingListFileMapping */])());},onFileMappingDelete:function onFileMappingDelete(fileMappingId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["h" /* deleteFileMappingListFileMapping */])(fileMappingId));},onFileMappingDeleteAll:function onFileMappingDeleteAll(fileMappingIds){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["i" /* deleteFileMappingListFileMappingAll */])(fileMappingIds));},fetchFileMappings:function fetchFileMappings(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["m" /* readFileMappingListFileMappings */])());},fetchFileMapping:function fetchFileMapping(fileMappingId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["k" /* readFileMappingListFileMapping */])(fileMappingId));},fetchFileMappingCube:function fetchFileMappingCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["l" /* readFileMappingListFileMappingCube */])(cubeId));}};};var FileMappingList=function FileMappingList(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,fileMappingsTree=_ref.fileMappingsTree,fileMappingId=_ref.fileMappingId,fileMapping=_ref.fileMapping,fileMappingCube=_ref.fileMappingCube,onWizardShow=_ref.onWizardShow,onFileMappingShow=_ref.onFileMappingShow,onFileMappingHide=_ref.onFileMappingHide,onFileMappingDelete=_ref.onFileMappingDelete,fetchFileMappings=_ref.fetchFileMappings,fetchFileMapping=_ref.fetchFileMapping,fetchFileMappingCube=_ref.fetchFileMappingCube;var _useState=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),selected=_useState2[0],setSelected=_useState2[1];return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:fileMappingId!==null,onCancel:onFileMappingHide,title:t('scenes.dataManager.fileMapping.list.fileMappingModal.title'),width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_SM"],footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onFileMappingHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__hocs_call__["a" /* default */],{cb:fetchFileMapping,cbParam:fileMappingId},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__hocs_call__["a" /* default */],{cb:fetchFileMappingCube,cbParam:fileMapping!==null&&fileMapping.IDCube,disabled:fileMapping===null},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_file_mapping_form__["a" /* default */],{fileMapping:fileMapping,cube:fileMappingCube})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__hocs_call__["a" /* default */],{cb:fetchFileMappings,disabled:fileMappingsTree!==null},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_tree__["a" /* default */],{tree:fileMappingsTree,idKey:'TreeID',nameKey:'Name',childrenKey:'children',catIdKey:'TreeID',catNameKey:'labels',getIsNameMultilanguage:function getIsNameMultilanguage(node){return!node.IDMapping;},unselectableKeys:Object(__WEBPACK_IMPORTED_MODULE_17__utils_tree__["l" /* getNodes */])(fileMappingsTree,'children',function(node){return!node.IDMapping&&!node.IDCube;}).map(function(node){return node.TreeID;}),hiddenIdKeys:Object(__WEBPACK_IMPORTED_MODULE_17__utils_tree__["l" /* getNodes */])(fileMappingsTree,'children',function(_ref2){var Code=_ref2.Code;return!Code;}).map(function(node){return node.TreeID;}),getIcon:function getIcon(_ref3){var Code=_ref3.Code,IDMapping=_ref3.IDMapping;if(Code){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconFontCNIcon,{theme:'filled',style:{color:"#37a0f4"},type:'cube'});}else if(IDMapping){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{theme:'filled',type:'file-text'});}else{return null;}},getFilter:function getFilter(searchText){return function(_ref4){var labels=_ref4.labels,Code=_ref4.Code,Name=_ref4.Name;var search=searchText.toLowerCase();return Name&&Name.toLowerCase().indexOf(search)>=0||Code&&Code.toLowerCase().indexOf(search)>=0||labels&&Object(__WEBPACK_IMPORTED_MODULE_18__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},onSelect:function onSelect(selectedArr){if(selectedArr&&selectedArr[0]){setSelected(selectedArr[0]);}else{setSelected(null);}},treeActions:[{title:t('scenes.dataManager.loader.csvForm.mappingControl.refreshTree.title'),icon:'sync',onClick:fetchFileMappings},{title:t('scenes.dataManager.fileMapping.wizardShowButton.label'),icon:'plus',onClick:function onClick(){if(selected&&!selected.startsWith("Mapp_")){onWizardShow(Object(__WEBPACK_IMPORTED_MODULE_17__utils_tree__["l" /* getNodes */])(fileMappingsTree,'children',function(node){return!!node.IDCube;}).find(function(_ref5){var Code=_ref5.Code;return Code===selected.replace("Mapp_","");}).IDCube,selected);}else{onWizardShow();}}}],actions:function(){if(selected&&selected.startsWith("Mapp_")){return[Object.assign({},__WEBPACK_IMPORTED_MODULE_19__styles_buttons__["l" /* BUTTON_DETAIL */],{title:t('components.itemList.actions.view.title'),onClick:function onClick(){return onFileMappingShow(Number(selected.replace("Mapp_","")));}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_19__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('components.itemList.actions.delete.title'),onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.fileMapping.list.deleteButton.confirm',{id:(Object(__WEBPACK_IMPORTED_MODULE_17__utils_tree__["l" /* getNodes */])(fileMappingsTree,'children',function(_ref6){var IDMapping=_ref6.IDMapping;return IDMapping===Number(selected.replace("Mapp_",""));})||[])[0].Name}),onOk:function onOk(){setSelected(null);onFileMappingDelete(Number(selected.replace("Mapp_","")));},cancelText:t('commons.buttons.cancel.title')});}})];}else{return null;}}()})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(FileMappingList));

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_steps_style__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_steps_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_steps_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_steps__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__csv_form__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__component_list__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cube_selector__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__csv_row_list__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__csv_column_value_list__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__component_mapper__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__cube_component_list__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__csv_row_list_actions__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__csv_column_value_list_actions__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__style_css__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_cube_component_list__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_file_mapping_component_list__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_zoomable_textarea__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__constants_numbers__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__utils_artefactValidators__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(_ref){var app=_ref.app,config=_ref.config,wizard=_ref.scenes.dataManager.fileMapping.components.wizard;return{appLanguage:app.language,dataLanguages:config.dataManagement.dataLanguages,isVisible:wizard.local.isVisible,isCubeComponentsVisible:wizard.local.isCubeComponentsVisible,isComponentsVisible:wizard.local.isComponentsVisible,csvForm:wizard.shared.csvForm,csvServerPath:wizard.shared.csvServerPath,xmlServerPath:wizard.shared.xmlServerPath,csvHeader:wizard.shared.csvHeader,cubeId:wizard.shared.cubeId,cube:wizard.shared.cube,selectedColumnName:wizard.shared.selectedColumnName,components:wizard.shared.components,name:wizard.local.name,description:wizard.local.description,tid:wizard.local.tid,step:wizard.local.step};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["t" /* hideFileMappingWizard */])());},onCsvRowListShow:function onCsvRowListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__csv_row_list_actions__["f" /* showFileMappingWizardCsvRowList */])());},onCsvColumnValueListShow:function onCsvColumnValueListShow(columnName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__csv_column_value_list_actions__["f" /* showFileMappingWizardColumnValueList */])(columnName));},onColumnSelect:function onColumnSelect(columnName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["x" /* selectFileMappingWizardColumn */])(columnName));},onCreateFileMapping:function onCreateFileMapping(name,description,tid,cubeId,components,csvForm,xmlServerPath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["r" /* createFileMappingWizardFileMapping */])(name,description,tid,cubeId,components,csvForm,xmlServerPath));},onStepSet:function onStepSet(step){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["y" /* setFileMappingWizardStep */])(step));},onFormChange:function onFormChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["o" /* changeFileMappingWizardForm */])(fields));},fetchCsvHeader:function fetchCsvHeader(_ref2){var csvServerPath=_ref2.csvServerPath,csvSeparator=_ref2.csvSeparator,csvDelimiter=_ref2.csvDelimiter,csvHasHeader=_ref2.csvHasHeader,csvHasDotStatFormat=_ref2.csvHasDotStatFormat;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["s" /* getFileMappingWizardCsvHeader */])(csvSeparator,csvDelimiter,csvHasHeader,csvServerPath,csvHasDotStatFormat));},fetchCube:function fetchCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["w" /* readFileMappingWizardCube */])(cubeId));},onCubeComponentsShow:function onCubeComponentsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["B" /* showFileMappingWizardCubeComponents */])());},onCubeComponentsHide:function onCubeComponentsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["v" /* hideFileMappingWizardCubeComponents */])());},onComponentsShow:function onComponentsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["A" /* showFileMappingWizardComponents */])());},onComponentsHide:function onComponentsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["u" /* hideFileMappingWizardComponents */])());}};};var mapPropsToFields=function mapPropsToFields(_ref3){var name=_ref3.name,description=_ref3.description,tid=_ref3.tid;return{name:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:name}),description:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:description}),tid:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:tid})};};// TODO: prevent multiple changes relative to same value
var onFieldsChange=function onFieldsChange(props,fields){var newFields=__WEBPACK_IMPORTED_MODULE_40_lodash___default.a.mapValues(fields,function(_ref4){var value=_ref4.value;return value;});if(newFields.name&&newFields.name.length>__WEBPACK_IMPORTED_MODULE_41__constants_numbers__["a" /* ID_MAX_LEN */]){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:props.t('commons.alerts.fieldTooLong.title'),content:props.t('commons.alerts.fieldTooLong.content',{maxLen:__WEBPACK_IMPORTED_MODULE_41__constants_numbers__["a" /* ID_MAX_LEN */]})});props.onFormChange({name:props.name,description:props.description,tid:props.tid});}else{props.onFormChange(newFields);}};var cardStyle={type:'inner',headStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["PADDING_MD"]},bodyStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["PADDING_MD"],height:420}};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]}};var stepNameFormItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_THREE_QUARTERS"]}};var FileMappingWizard=function FileMappingWizard(_ref5){var t=_ref5.t,appLanguage=_ref5.appLanguage,dataLanguages=_ref5.dataLanguages,form=_ref5.form,isVisible=_ref5.isVisible,step=_ref5.step,csvForm=_ref5.csvForm,csvServerPath=_ref5.csvServerPath,xmlServerPath=_ref5.xmlServerPath,isCubeComponentsVisible=_ref5.isCubeComponentsVisible,isComponentsVisible=_ref5.isComponentsVisible,csvHeader=_ref5.csvHeader,cubeId=_ref5.cubeId,cube=_ref5.cube,name=_ref5.name,description=_ref5.description,tid=_ref5.tid,selectedColumnName=_ref5.selectedColumnName,components=_ref5.components,onHide=_ref5.onHide,onCsvRowListShow=_ref5.onCsvRowListShow,onCsvColumnValueListShow=_ref5.onCsvColumnValueListShow,onColumnSelect=_ref5.onColumnSelect,onCreateFileMapping=_ref5.onCreateFileMapping,onStepSet=_ref5.onStepSet,onCubeComponentsShow=_ref5.onCubeComponentsShow,onCubeComponentsHide=_ref5.onCubeComponentsHide,onComponentsShow=_ref5.onComponentsShow,onComponentsHide=_ref5.onComponentsHide,fetchCsvHeader=_ref5.fetchCsvHeader,fetchCube=_ref5.fetchCube;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__components_enhanced_modal__["a" /* default */],{visible:isVisible,onCancel:onHide,title:t('scenes.dataManager.fileMapping.wizard.title'),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_XL"],footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),step>__WEBPACK_IMPORTED_MODULE_32__reducer__["d" /* FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){return onStepSet(step-1);}},t('scenes.dataManager.fileMapping.wizard.prevStepButton.label')),step<__WEBPACK_IMPORTED_MODULE_32__reducer__["e" /* FILE_MAPPING_WIZARD_STEP_NAME */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){return onStepSet(step+1);},disabled:step===__WEBPACK_IMPORTED_MODULE_32__reducer__["d" /* FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION */]&&cubeId===null||step===__WEBPACK_IMPORTED_MODULE_32__reducer__["c" /* FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD */]&&csvServerPath===null||step===__WEBPACK_IMPORTED_MODULE_32__reducer__["b" /* FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING */]&&components.length===0,type:'primary'},t('scenes.dataManager.fileMapping.wizard.nextStepButton.label')),step===__WEBPACK_IMPORTED_MODULE_32__reducer__["e" /* FILE_MAPPING_WIZARD_STEP_NAME */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){return onCreateFileMapping(name,description,tid,cubeId,components,csvForm,xmlServerPath);},disabled:name===null||name.length===0||components.length===0,type:'primary'},t('scenes.dataManager.fileMapping.wizard.saveButton.label'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:'file-mapping__wizard'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__csv_row_list__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchCube,cbParam:cubeId,disabled:cubeId===null},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchCsvHeader,cbParam:{csvServerPath:csvServerPath,csvSeparator:csvForm.file&&csvForm.file.name.endsWith('.csv')?csvForm.separator:";",csvDelimiter:csvForm.file&&csvForm.file.name.endsWith('.csv')?!!csvForm.delimiter?csvForm.delimiter:null:'"',csvHasHeader:csvForm.file&&csvForm.file.name.endsWith('.csv')?csvForm.hasHeader:true,csvHasDotStatFormat:csvForm.file&&csvForm.file.name.endsWith('.csv')?csvForm.hasDotStatFormat:false},disabled:csvServerPath===null},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default.a,{current:step,size:'small'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{style:{cursor:'pointer'},onClick:function onClick(){return onStepSet(__WEBPACK_IMPORTED_MODULE_32__reducer__["d" /* FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION */]);}},t('scenes.dataManager.fileMapping.wizard.steps.cubeSelection.title')),icon:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',type:step===__WEBPACK_IMPORTED_MODULE_32__reducer__["d" /* FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION */]?'primary':null,onClick:function onClick(){return onStepSet(__WEBPACK_IMPORTED_MODULE_32__reducer__["d" /* FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION */]);},size:'small'},'1'),description:cube!==null?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{onClick:onCubeComponentsShow,style:{cursor:'pointer'},title:'['+cube.Code+'] '+Object(__WEBPACK_IMPORTED_MODULE_35__middlewares_i18n_utils__["a" /* getLocalizedStr */])(cube.labels,dataLanguage||appLanguage,dataLanguages)},'[',cube.Code,'] ',Object(__WEBPACK_IMPORTED_MODULE_35__middlewares_i18n_utils__["a" /* getLocalizedStr */])(cube.labels,dataLanguage||appLanguage,dataLanguages));}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__components_enhanced_modal__["a" /* default */],{visible:isCubeComponentsVisible,onCancel:onCubeComponentsHide,footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onCubeComponentsHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_SM"],title:t('scenes.dataManager.fileMapping.wizard.steps.cubeSelection.description.cubeComponents')},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,{type:'inner',bodyStyle:{maxHeight:460,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_cube_component_list__["a" /* default */],{disabled:true,value:cube!==null?cube.components:null})))):null}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{style:cubeId!==null?{cursor:'pointer'}:null,onClick:function onClick(){return cubeId!==null?onStepSet(__WEBPACK_IMPORTED_MODULE_32__reducer__["c" /* FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD */]):null;}},t('scenes.dataManager.fileMapping.wizard.steps.fileUpload.title')),icon:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',disabled:cubeId===null,onClick:function onClick(){return cubeId!==null?onStepSet(__WEBPACK_IMPORTED_MODULE_32__reducer__["c" /* FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD */]):null;},type:step===__WEBPACK_IMPORTED_MODULE_32__reducer__["c" /* FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD */]?'primary':null,size:'small'},'2'),description:csvForm.file!==null?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{title:csvForm.file.name},csvForm.file.name):null}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{style:csvServerPath!==null?{cursor:'pointer'}:null,onClick:function onClick(){return csvServerPath!==null?onStepSet(__WEBPACK_IMPORTED_MODULE_32__reducer__["b" /* FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING */]):null;}},t('scenes.dataManager.fileMapping.wizard.steps.componentsMapping.title')),icon:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',disabled:csvServerPath===null,onClick:function onClick(){return csvServerPath!==null?onStepSet(__WEBPACK_IMPORTED_MODULE_32__reducer__["b" /* FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING */]):null;},type:step===__WEBPACK_IMPORTED_MODULE_32__reducer__["b" /* FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING */]?'primary':null,size:'small'},'3'),description:components.length>0?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__components_enhanced_modal__["a" /* default */],{className:'file-mapping__wizard__components-modal',visible:isComponentsVisible,onCancel:onComponentsHide,footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onComponentsHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_SM"],title:t('scenes.dataManager.fileMapping.wizard.steps.componentsMapping.description.components')},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_file_mapping_component_list__["a" /* default */],{value:components,columnNameKey:'columnName',cubeComponentCodeKey:'cubeComponentCode'})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{style:{cursor:'pointer'},onClick:onComponentsShow},t('scenes.dataManager.fileMapping.wizard.steps.componentsMapping.description.mappedComponents',{count:components.length}))):null}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',{style:components.length>0?{cursor:'pointer'}:null,onClick:function onClick(){return components.length>0?onStepSet(__WEBPACK_IMPORTED_MODULE_32__reducer__["e" /* FILE_MAPPING_WIZARD_STEP_NAME */]):null;}},t('scenes.dataManager.fileMapping.wizard.steps.nameForm.title')),icon:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',disabled:components.length===0,onClick:function onClick(){return components.length>0?onStepSet(__WEBPACK_IMPORTED_MODULE_32__reducer__["e" /* FILE_MAPPING_WIZARD_STEP_NAME */]):null;},type:step===__WEBPACK_IMPORTED_MODULE_32__reducer__["e" /* FILE_MAPPING_WIZARD_STEP_NAME */]?'primary':null,size:'small'},'4')})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,{style:step!==__WEBPACK_IMPORTED_MODULE_32__reducer__["d" /* FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION */]?{display:'none'}:null,type:'inner'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:'file-mapping__wizard__cube-selector'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__cube_selector__["a" /* default */],null))),step===__WEBPACK_IMPORTED_MODULE_32__reducer__["c" /* FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_SM"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__csv_form__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,null,step===__WEBPACK_IMPORTED_MODULE_32__reducer__["b" /* FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:7},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:'file-mapping__wizard__csv-header'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,Object.assign({title:t('scenes.dataManager.fileMapping.wizard.cards.csvHeader.title')},cardStyle),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"],height:330}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__csv_column_value_list__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__component_list__["a" /* default */],{components:csvHeader!==null?csvHeader.map(function(name,idx){return{name:name,key:idx,onDetail:name!==__WEBPACK_IMPORTED_MODULE_32__reducer__["a" /* DOT_STAT_COLUMN_NAME */]?function(){return onCsvColumnValueListShow(name);}:null,detailTitle:name!==__WEBPACK_IMPORTED_MODULE_32__reducer__["a" /* DOT_STAT_COLUMN_NAME */]?t('scenes.dataManager.fileMapping.wizard.cards.csvHeader.csvComponentList.detail.title'):t('scenes.dataManager.fileMapping.wizard.cards.csvHeader.csvComponentList.dotStatColumnDetail.title')};}):[],selected:selectedColumnName!==null?selectedColumnName:null,onSelect:function onSelect(_ref6){var name=_ref6.name;return onColumnSelect(name);},disabled:components.map(function(comp){return comp.columnName;})})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onCsvRowListShow,icon:'table',disabled:csvHeader===null,style:{width:'100%'}},t('data.csv.tableShowButton.label'))))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:10},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:'file-mapping__wizard__component-mapper'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,cardStyle,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__component_mapper__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:7},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:'file-mapping__wizard__cube-components'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,Object.assign({title:t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.title')},cardStyle),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__cube_component_list__["a" /* default */],null))))),!(cube===null||cube.components.tidAttributes.length===0)&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,{type:'inner',style:{marginTop:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.fileMapping.tid.label'),validateStatus:tid&&Object(__WEBPACK_IMPORTED_MODULE_42__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,tid).help?"warning":null,help:tid&&Object(__WEBPACK_IMPORTED_MODULE_42__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,tid).help},formItemLayout),form.getFieldDecorator('tid',{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue('tid'),style:{textTransform:"uppercase"}}))))))),step===__WEBPACK_IMPORTED_MODULE_32__reducer__["e" /* FILE_MAPPING_WIZARD_STEP_NAME */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.fileMapping.name.label')},stepNameFormItemLayout),form.getFieldDecorator('name',{normalize:function normalize(str){return str!==null?str.toUpperCase():null;}})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue('name')}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.fileMapping.description.label')},stepNameFormItemLayout),form.getFieldDecorator('description')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_zoomable_textarea__["a" /* default */],{title:form.getFieldValue('description')})))))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_33_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_31_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_34_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(FileMappingWizard));

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Steps__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Step__ = __webpack_require__(1412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Step", function() { return __WEBPACK_IMPORTED_MODULE_1__Step__["a"]; });



__WEBPACK_IMPORTED_MODULE_0__Steps__["a" /* default */].Step = __WEBPACK_IMPORTED_MODULE_1__Step__["a" /* default */];


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Steps__["a" /* default */]);

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_debounce__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(1411);





/* eslint react/no-did-mount-set-state: 0 */







var Steps = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Steps, _Component);

  function Steps(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Steps);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _this.calcStepOffsetWidth = function () {
      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* isFlexSupported */])()) {
        return;
      }
      // Just for IE9
      var domNode = Object(__WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"])(_this);
      if (domNode.children.length > 0) {
        if (_this.calcTimeout) {
          clearTimeout(_this.calcTimeout);
        }
        _this.calcTimeout = setTimeout(function () {
          // +1 for fit edge bug of digit width, like 35.4px
          var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1;
          // Reduce shake bug
          if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
            return;
          }
          _this.setState({ lastStepOffsetWidth: lastStepOffsetWidth });
        });
      }
    };

    _this.state = {
      flexSupported: true,
      lastStepOffsetWidth: 0
    };
    _this.calcStepOffsetWidth = __WEBPACK_IMPORTED_MODULE_9_lodash_debounce___default()(_this.calcStepOffsetWidth, 150);
    return _this;
  }

  Steps.prototype.componentDidMount = function componentDidMount() {
    this.calcStepOffsetWidth();
    if (!Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* isFlexSupported */])()) {
      this.setState({
        flexSupported: false
      });
    }
  };

  Steps.prototype.componentDidUpdate = function componentDidUpdate() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.calcTimeout) {
      clearTimeout(this.calcTimeout);
    }
    if (this.calcStepOffsetWidth && this.calcStepOffsetWidth.cancel) {
      this.calcStepOffsetWidth.cancel();
    }
  };

  Steps.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        _props$style = _props.style,
        style = _props$style === undefined ? {} : _props$style,
        className = _props.className,
        children = _props.children,
        direction = _props.direction,
        labelPlacement = _props.labelPlacement,
        iconPrefix = _props.iconPrefix,
        status = _props.status,
        size = _props.size,
        current = _props.current,
        progressDot = _props.progressDot,
        initial = _props.initial,
        icons = _props.icons,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'iconPrefix', 'status', 'size', 'current', 'progressDot', 'initial', 'icons']);

    var _state = this.state,
        lastStepOffsetWidth = _state.lastStepOffsetWidth,
        flexSupported = _state.flexSupported;

    var filteredChildren = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.toArray(children).filter(function (c) {
      return !!c;
    });
    var lastIndex = filteredChildren.length - 1;
    var adjustedlabelPlacement = !!progressDot ? 'vertical' : labelPlacement;
    var classString = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, prefixCls + '-' + direction, className, (_classNames = {}, _classNames[prefixCls + '-' + size] = size, _classNames[prefixCls + '-label-' + adjustedlabelPlacement] = direction === 'horizontal', _classNames[prefixCls + '-dot'] = !!progressDot, _classNames[prefixCls + '-flex-not-supported'] = !flexSupported, _classNames));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: classString, style: style }, restProps),
      __WEBPACK_IMPORTED_MODULE_5_react__["Children"].map(filteredChildren, function (child, index) {
        if (!child) {
          return null;
        }
        var stepNumber = initial + index;
        var childProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          stepNumber: '' + (stepNumber + 1),
          prefixCls: prefixCls,
          iconPrefix: iconPrefix,
          wrapperStyle: style,
          progressDot: progressDot,
          icons: icons
        }, child.props);
        if (!flexSupported && direction !== 'vertical' && index !== lastIndex) {
          childProps.itemWidth = 100 / lastIndex + '%';
          childProps.adjustMarginRight = -Math.round(lastStepOffsetWidth / lastIndex + 1);
        }
        // fix tail color
        if (status === 'error' && index === current - 1) {
          childProps.className = prefixCls + '-next-error';
        }
        if (!child.props.status) {
          if (stepNumber === current) {
            childProps.status = status;
          } else if (stepNumber < current) {
            childProps.status = 'finish';
          } else {
            childProps.status = 'wait';
          }
        }
        return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, childProps);
      })
    );
  };

  return Steps;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Steps.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  iconPrefix: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  labelPlacement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  status: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  progressDot: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  initial: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  current: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  icons: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    finish: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
    error: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
  })
};
Steps.defaultProps = {
  prefixCls: 'rc-steps',
  iconPrefix: 'rc',
  direction: 'horizontal',
  labelPlacement: 'horizontal',
  initial: 0,
  current: 0,
  status: 'process',
  size: '',
  progressDot: false
};
/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFlexSupported;
function isFlexSupported() {
  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
    var documentElement = window.document.documentElement;

    return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
  }
  return false;
}

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);









function isString(str) {
  return typeof str === 'string';
}

var Step = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Step, _React$Component);

  function Step() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Step);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Step.prototype.renderIconNode = function renderIconNode() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        progressDot = _props.progressDot,
        stepNumber = _props.stepNumber,
        status = _props.status,
        title = _props.title,
        description = _props.description,
        icon = _props.icon,
        iconPrefix = _props.iconPrefix,
        icons = _props.icons;

    var iconNode = void 0;
    var iconClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls + '-icon', iconPrefix + 'icon', (_classNames = {}, _classNames[iconPrefix + 'icon-' + icon] = icon && isString(icon), _classNames[iconPrefix + 'icon-check'] = !icon && status === 'finish' && icons && !icons.finish, _classNames[iconPrefix + 'icon-close'] = !icon && status === 'error' && icons && !icons.error, _classNames));
    var iconDot = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: prefixCls + '-icon-dot' });
    // `progressDot` enjoy the highest priority
    if (progressDot) {
      if (typeof progressDot === 'function') {
        iconNode = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'span',
          { className: prefixCls + '-icon' },
          progressDot(iconDot, { index: stepNumber - 1, status: status, title: title, description: description })
        );
      } else {
        iconNode = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'span',
          { className: prefixCls + '-icon' },
          iconDot
        );
      }
    } else if (icon && !isString(icon)) {
      iconNode = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'span',
        { className: prefixCls + '-icon' },
        icon
      );
    } else if (icons && icons.finish && status === 'finish') {
      iconNode = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'span',
        { className: prefixCls + '-icon' },
        icons.finish
      );
    } else if (icons && icons.error && status === 'error') {
      iconNode = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'span',
        { className: prefixCls + '-icon' },
        icons.error
      );
    } else if (icon || status === 'finish' || status === 'error') {
      iconNode = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: iconClassName });
    } else {
      iconNode = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'span',
        { className: prefixCls + '-icon' },
        stepNumber
      );
    }

    return iconNode;
  };

  Step.prototype.render = function render() {
    var _classNames2;

    var _props2 = this.props,
        className = _props2.className,
        prefixCls = _props2.prefixCls,
        style = _props2.style,
        itemWidth = _props2.itemWidth,
        _props2$status = _props2.status,
        status = _props2$status === undefined ? 'wait' : _props2$status,
        iconPrefix = _props2.iconPrefix,
        icon = _props2.icon,
        wrapperStyle = _props2.wrapperStyle,
        adjustMarginRight = _props2.adjustMarginRight,
        stepNumber = _props2.stepNumber,
        description = _props2.description,
        title = _props2.title,
        progressDot = _props2.progressDot,
        tailContent = _props2.tailContent,
        icons = _props2.icons,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'iconPrefix', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'description', 'title', 'progressDot', 'tailContent', 'icons']);

    var classString = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls + '-item', prefixCls + '-item-' + status, className, (_classNames2 = {}, _classNames2[prefixCls + '-item-custom'] = icon, _classNames2));
    var stepItemStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style);
    if (itemWidth) {
      stepItemStyle.width = itemWidth;
    }
    if (adjustMarginRight) {
      stepItemStyle.marginRight = adjustMarginRight;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps, {
        className: classString,
        style: stepItemStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-item-tail' },
        tailContent
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-item-icon' },
        this.renderIconNode()
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-item-content' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: prefixCls + '-item-title' },
          title
        ),
        description && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: prefixCls + '-item-description' },
          description
        )
      )
    );
  };

  return Step;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Step.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  itemWidth: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  status: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  iconPrefix: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  adjustMarginRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  stepNumber: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  progressDot: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  tailContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  icons: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    finish: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
    error: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
  })
};
/* harmony default export */ __webpack_exports__["a"] = (Step);

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux_es_connect_connect__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__csv_row_list_actions__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__hocs_call__ = __webpack_require__(18);
var mapStateToProps=function mapStateToProps(state){return{csvForm:state.scenes.dataManager.fileMapping.components.wizard.shared.csvForm,csvHeader:state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader,fileFormat:state.scenes.dataManager.fileMapping.components.wizard.shared.fileFormat,fileServerPath:state.scenes.dataManager.fileMapping.components.wizard.shared.fileServerPath,csvServerPath:state.scenes.dataManager.fileMapping.components.wizard.shared.csvServerPath,xmlServerPath:state.scenes.dataManager.fileMapping.components.wizard.shared.xmlServerPath,cubeId:state.scenes.dataManager.fileMapping.components.wizard.shared.cubeId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["d" /* changeFileMappingWizardCsvForm */])(fields));},onFileFormatSet:function onFileFormatSet(fileFormat){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["e" /* setFileMappingWizardCsvFormFileFormat */])(fileFormat));},onSubmit:function onSubmit(file,xmlFile){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["f" /* submitFileMappingWizardCsvForm */])(file,xmlFile));},onCsvRowListShow:function onCsvRowListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__csv_row_list_actions__["f" /* showFileMappingWizardCsvRowList */])());},onConvertPxToCsv:function onConvertPxToCsv(_ref){var fileServerPath=_ref.fileServerPath,cubeId=_ref.cubeId;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["p" /* convertFileMappingWizardPxToCsv */])(fileServerPath,cubeId));},onConvertXlsToCsv:function onConvertXlsToCsv(_ref2){var fileServerPath=_ref2.fileServerPath,xmlServerPath=_ref2.xmlServerPath,cubeId=_ref2.cubeId;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["q" /* convertFileMappingWizardXlsToCsv */])(fileServerPath,xmlServerPath,cubeId));}};};var mapPropsToFields=function mapPropsToFields(_ref3){var csvForm=_ref3.csvForm;return{file:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:csvForm.file}),xmlFile:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:csvForm.xmlFile}),separator:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:csvForm.separator}),delimiter:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:csvForm.delimiter}),hasHeader:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:csvForm.hasHeader}),hasDotStatFormat:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:csvForm.hasDotStatFormat})};};// TODO: prevent multiple changes relative to same value
var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(fields);};var FileMappingWizardCsvForm=function FileMappingWizardCsvForm(_ref4){var t=_ref4.t,form=_ref4.form,fileFormat=_ref4.fileFormat,csvForm=_ref4.csvForm,csvHeader=_ref4.csvHeader,cubeId=_ref4.cubeId,fileServerPath=_ref4.fileServerPath,csvServerPath=_ref4.csvServerPath,xmlServerPath=_ref4.xmlServerPath,onFileFormatSet=_ref4.onFileFormatSet,onConvertPxToCsv=_ref4.onConvertPxToCsv,onConvertXlsToCsv=_ref4.onConvertXlsToCsv,onSubmit=_ref4.onSubmit,onCsvRowListShow=_ref4.onCsvRowListShow;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__hocs_call__["a" /* default */],{cb:onConvertPxToCsv,cbParam:{fileServerPath:fileServerPath,cubeId:cubeId},disabled:fileFormat!=='px'||fileServerPath===null||csvServerPath!==null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__hocs_call__["a" /* default */],{cb:onConvertXlsToCsv,cbParam:{fileServerPath:fileServerPath,xmlServerPath:xmlServerPath,cubeId:cubeId},disabled:fileFormat!=='xls'||fileServerPath===null||xmlServerPath===null||csvServerPath!==null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a,{className:'advanced-form'},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Group,{defaultValue:'csv',value:fileFormat,onChange:function onChange(_ref5){var target=_ref5.target;return onFileFormatSet(target.value);}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Button,{value:'csv'},'CSV'),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Button,{value:'xls'},'Excel'),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Button,{value:'px'},'PC-Axis')))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.file.label')},form.getFieldDecorator('file')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_file_input__["a" /* default */],{accept:fileFormat==="xls"?".xls,.xlsx":'.'+fileFormat}))))),fileFormat==='csv'&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.separator.label')},form.getFieldDecorator('separator')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{maxLength:1})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{label:t('data.csv.delimiter.label')},form.getFieldDecorator('delimiter')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{maxLength:1}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.hasHeader.label')},form.getFieldDecorator('hasHeader',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null)))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.hasDotStatFormat.label')},form.getFieldDecorator('hasDotStatFormat',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null)))))),fileFormat==='xls'&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]},gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.xmlFile.label')},form.getFieldDecorator('xmlFile')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_file_input__["a" /* default */],{accept:'.xml'}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{disabled:csvForm.file===null||fileFormat==='csv'&&(csvForm.separator===null||csvForm.separator.length!==1)||fileFormat==='xls'&&csvForm.xmlFile===null,icon:'upload',type:'primary',onClick:function onClick(){return onSubmit(csvForm.file,fileFormat==='xls'?csvForm.xmlFile:null);}},t('data.csv.uploadButton.label'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onCsvRowListShow,icon:'table',disabled:csvHeader===null,style:{width:'100%'}},t('scenes.dataManager.fileMapping.wizard.csvForm.buttons.csvRowListShow')))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_18_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(FileMappingWizardCsvForm));

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(310);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,categorisedCubes:state.scenes.dataManager.fileMapping.components.wizard.components.cubeSelector.categorisedCubes,cubeCode:state.scenes.dataManager.fileMapping.components.wizard.shared.cubeCode,step:state.scenes.dataManager.fileMapping.components.wizard.local.step};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCubeSet:function onCubeSet(cubeId,cubeCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["e" /* setFileMappingWizardCubeSelectorCube */])(cubeId,cubeCode));},onCubeUnset:function onCubeUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["f" /* unsetFileMappingWizardCubeSelectorCube */])());},fetchCategorisedCubes:function fetchCategorisedCubes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["d" /* readFileMappingWizardCubeSelectorCategorisedCubes */])());}};};var FileMappingWizardCubeSelector=function FileMappingWizardCubeSelector(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,categorisedCubes=_ref.categorisedCubes,cubeCode=_ref.cubeCode,step=_ref.step,onCubeSet=_ref.onCubeSet,onCubeUnset=_ref.onCubeUnset,fetchCategorisedCubes=_ref.fetchCategorisedCubes;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__hocs_call__["a" /* default */],{cb:fetchCategorisedCubes,disabled:categorisedCubes!==null||step!==__WEBPACK_IMPORTED_MODULE_10__reducer__["d" /* FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION */]},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_enhanced_tree__["a" /* default */],{tree:categorisedCubes,idKey:'Code',childrenKey:'children',nameKey:'labels',catIdKey:'CatCode',catNameKey:'labels',defaultSelectedKeys:cubeCode?[cubeCode]:null,unselectableKeys:Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["l" /* getNodes */])(categorisedCubes,'children',function(node){return node.children;}).map(function(node){return node.CatCode;}),hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_2__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode,__WEBPACK_IMPORTED_MODULE_3__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],getFilter:function getFilter(searchText){return function(_ref2){var Code=_ref2.Code,CatCode=_ref2.CatCode,labels=_ref2.labels;var search=searchText.toLowerCase();return Code&&Code.toLowerCase().indexOf(search)>=0||CatCode&&CatCode.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},onSelect:function onSelect(selectedArr){var node=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tree__["k" /* getNode */])(categorisedCubes,'children',function(node){return node.children?node.CatCode===selectedArr[0]:node.Code===selectedArr[0];});if(node!==null&&node.children===undefined){onCubeSet(node.IDCube,node.Code);}else{onCubeUnset();}},treeActions:[{title:t('scenes.dataManager.fileMapping.wizard.cubeSelector.refreshButton.title'),icon:'sync',onClick:fetchCategorisedCubes}],icon:'cube',isCustomIcon:true,getIconColor:function getIconColor(){return"#37a0f4";}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(FileMappingWizardCubeSelector));

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_infinite_scroll_data_table__ = __webpack_require__(74);
var mapStateToProps=function mapStateToProps(state){return{isVisible:state.scenes.dataManager.fileMapping.components.wizard.components.csvRowList.isVisible,csvRows:state.scenes.dataManager.fileMapping.components.wizard.components.csvRowList.csvRows,csvForm:state.scenes.dataManager.fileMapping.components.wizard.shared.csvForm,csvServerPath:state.scenes.dataManager.fileMapping.components.wizard.shared.csvServerPath,csvHeader:state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader,fileFormat:state.scenes.dataManager.fileMapping.components.wizard.shared.fileFormat};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* hideFileMappingWizardCsvRowList */])());},fetchCsvRows:function fetchCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* getFileMappingWizardCsvRowListCsvRows */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath));}};};var FileMappingWizardCsvRowList=function FileMappingWizardCsvRowList(_ref){var t=_ref.t,isVisible=_ref.isVisible,csvRows=_ref.csvRows,csvForm=_ref.csvForm,csvServerPath=_ref.csvServerPath,csvHeader=_ref.csvHeader,fileFormat=_ref.fileFormat,onHide=_ref.onHide,fetchCsvRows=_ref.fetchCsvRows;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__["a" /* default */],{visible:isVisible,onCancel:onHide,title:t('scenes.dataManager.fileMapping.wizard.csvRowList.title'),width:__WEBPACK_IMPORTED_MODULE_2__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title'))},csvForm!==null&&csvHeader!==null&&csvServerPath!==null&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_infinite_scroll_data_table__["a" /* default */],{data:csvRows&&csvRows.Data,rowTotal:csvRows&&csvRows.Count,cols:csvRows&&csvRows.Columns,hiddenCols:['NumRow'],onChange:function onChange(_ref2){var pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc;return fetchCsvRows(pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_9__utils_filter__["b" /* getFilterObjFromViewerObj */])(csvRows&&csvRows.Columns.filter(function(colName){return colName!=='NumRow';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc,fileFormat==='csv'?csvForm.separator:";",fileFormat==='csv'?csvForm.delimiter:'"',fileFormat==='csv'?csvForm.hasHeader:true,csvServerPath);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(FileMappingWizardCsvRowList));

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_infinite_scroll_data_table__ = __webpack_require__(74);
var mapStateToProps=function mapStateToProps(state){return{colName:state.scenes.dataManager.fileMapping.components.wizard.components.csvColumnValueList.colName,colValues:state.scenes.dataManager.fileMapping.components.wizard.components.csvColumnValueList.colValues,csvForm:state.scenes.dataManager.fileMapping.components.wizard.shared.csvForm,csvServerPath:state.scenes.dataManager.fileMapping.components.wizard.shared.csvServerPath,csvHeader:state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* hideFileMappingWizardColumnValueList */])());},fetchColValues:function fetchColValues(colName,pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* getFileMappingWizardCsvColumnValueListColValues */])(colName,pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath));}};};var FileMappingWizardCsvColumnValueList=function FileMappingWizardCsvColumnValueList(_ref){var t=_ref.t,colName=_ref.colName,colValues=_ref.colValues,csvForm=_ref.csvForm,csvServerPath=_ref.csvServerPath,csvHeader=_ref.csvHeader,onHide=_ref.onHide,fetchColValues=_ref.fetchColValues;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__["a" /* default */],{visible:colName!==null,onCancel:onHide,title:t('scenes.dataManager.fileMapping.wizard.colValueList.title'),width:__WEBPACK_IMPORTED_MODULE_2__styles_constants__["MODAL_WIDTH_SM"],footer:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title'))},csvForm!==null&&csvHeader!==null&&csvServerPath!==null&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_infinite_scroll_data_table__["a" /* default */],{data:colValues&&colValues.Data,rowTotal:colValues&&colValues.Count,cols:colValues&&colValues.Columns,onChange:function onChange(_ref2){var pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc;return fetchColValues(colName,pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_9__utils_filter__["b" /* getFilterObjFromViewerObj */])(colValues&&colValues.Columns,searchText,filters),sortCol?[sortCol]:null,sortByDesc,csvForm.separator,csvForm.delimiter,csvForm.hasHeader,csvServerPath);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(FileMappingWizardCsvColumnValueList));

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_file_mapping_component_list__ = __webpack_require__(254);
var mapStateToProps=function mapStateToProps(state){return{components:state.scenes.dataManager.fileMapping.components.wizard.shared.components,selectedColumnName:state.scenes.dataManager.fileMapping.components.wizard.shared.selectedColumnName,selectedCubeComponentCode:state.scenes.dataManager.fileMapping.components.wizard.shared.selectedCubeComponentCode,selectedComponent:state.scenes.dataManager.fileMapping.components.wizard.shared.selectedComponent,csvHeader:state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader,cube:state.scenes.dataManager.fileMapping.components.wizard.shared.cube};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onComponentAdd:function onComponentAdd(columnName,cubeComponentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["g" /* addFileMappingWizardComponentMapperComponent */])(columnName,cubeComponentCode));},onComponentAddAll:function onComponentAddAll(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["f" /* addAllFileMappingWizardComponentMapperComponent */])());},onComponentRemove:function onComponentRemove(columnName,cubeComponentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["i" /* removeFileMappingWizardComponentMapperComponent */])(columnName,cubeComponentCode));},onComponentRemoveAll:function onComponentRemoveAll(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["h" /* removeAllFileMappingWizardComponentMapperComponent */])());},onComponentSelect:function onComponentSelect(columnName,cubeComponentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["j" /* selectFileMappingWizardComponentMapperComponent */])(columnName,cubeComponentCode));}};};var FileMappingWizardComponentMapper=function FileMappingWizardComponentMapper(_ref){var t=_ref.t,components=_ref.components,csvHeader=_ref.csvHeader,cube=_ref.cube,selectedColumnName=_ref.selectedColumnName,selectedCubeComponentCode=_ref.selectedCubeComponentCode,selectedComponent=_ref.selectedComponent,onComponentAdd=_ref.onComponentAdd,onComponentAddAll=_ref.onComponentAddAll,onComponentRemove=_ref.onComponentRemove,onComponentRemoveAll=_ref.onComponentRemoveAll,onComponentSelect=_ref.onComponentSelect;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'space-between',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onComponentAdd(selectedColumnName,selectedCubeComponentCode);},disabled:selectedColumnName===null||selectedCubeComponentCode===null,title:t('scenes.dataManager.fileMapping.wizard.componentMapper.componentAddButton.title'),icon:'plus'})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onComponentAddAll();},disabled:csvHeader===null||cube===null,title:t('scenes.dataManager.fileMapping.wizard.componentMapper.componentAddAllButton.title'),style:{'paddingLeft':6,'paddingRight':6,'fontSize':22}},'++')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onComponentRemove(selectedComponent.columnName,selectedComponent.cubeComponentCode);},disabled:selectedComponent===null,icon:'minus',title:t('scenes.dataManager.fileMapping.wizard.componentMapper.componentRemoveButton.title')})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{className:'file-mapping__file-mapping__wizardjoined__icons'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{disabled:components.length===0,onClick:function onClick(){return onComponentRemoveAll();},icon:'delete',title:t('scenes.dataManager.fileMapping.wizard.componentMapper.componentRemoveAllButton.title')}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_file_mapping_component_list__["a" /* default */],{value:components,selected:selectedComponent!==null?''+selectedComponent.columnName+selectedComponent.cubeComponentCode:null,onSelect:function onSelect(_ref2){var columnName=_ref2.columnName,cubeComponentCode=_ref2.cubeComponentCode;return onComponentSelect(columnName,cubeComponentCode);},columnNameKey:'columnName',cubeComponentCodeKey:'cubeComponentCode'}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(FileMappingWizardComponentMapper));

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_list__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__ = __webpack_require__(10);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,cube:state.scenes.dataManager.fileMapping.components.wizard.shared.cube,codelistDetail:state.scenes.dataManager.fileMapping.components.wizard.components.cubeComponentList.codelistDetail,selectedCubeComponentCode:state.scenes.dataManager.fileMapping.components.wizard.shared.selectedCubeComponentCode,components:state.scenes.dataManager.fileMapping.components.wizard.shared.components};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCodelistShow:function onCodelistShow(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_7__redux_components_redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_5__reducer__["a" /* DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX */]));},onCubeComponentSelect:function onCubeComponentSelect(cubeComponentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* selectFileMappingWizardCubeComponentListComponent */])(cubeComponentCode));}};};var FileMappingWizardCubeComponentList=function FileMappingWizardCubeComponentList(_ref){var nodeId=_ref.nodeId,nodes=_ref.nodes,cube=_ref.cube,codelistDetail=_ref.codelistDetail,selectedCubeComponentCode=_ref.selectedCubeComponentCode,components=_ref.components,onCodelistShow=_ref.onCodelistShow,onCubeComponentSelect=_ref.onCubeComponentSelect;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_codelist_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_5__reducer__["a" /* DM_FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_PREFIX */],instanceState:codelistDetail}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__component_list__["a" /* default */],{components:cube!==null?[].concat(_toConsumableArray(cube.components.dimensions.map(function(dim){return Object.assign({},dim,{icon:'bar-chart'});})),_toConsumableArray(cube.components.timeDimensions.map(function(dim){return Object.assign({},dim,{icon:'clock-circle'});})),_toConsumableArray(cube.components.attributes.map(function(attr){return Object.assign({},attr,{icon:'profile'});})),_toConsumableArray(cube.components.measures.map(function(meas){return Object.assign({},meas,{icon:'line-chart'});}))).map(function(comp,idx){return Object.assign({},comp,{name:comp.Code,key:idx,onDetail:comp.CodelistCode!==undefined&&comp.CodelistCode!==null?function(){return onCodelistShow(Object(__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(comp.CodelistCode),defaultItemsViewMode);}:null});}):[],selected:selectedCubeComponentCode!==null?selectedCubeComponentCode:null,onSelect:function onSelect(_ref2){var Code=_ref2.Code;return onCubeComponentSelect(Code);},disabled:components.map(function(comp){return comp.cubeComponentCode;}),hasIcon:true}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(FileMappingWizardCubeComponentList));

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__csv_form__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__xml_form__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(226);
var mapStateToProps=function mapStateToProps(state){return{format:state.scenes.dataManager.loader.shared.format};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setFormat:function setFormat(format){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["b" /* setLoaderFormat */])(format));}};};var Loader=function Loader(_ref){var format=_ref.format,setFormat=_ref.setFormat;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group,{defaultValue:'csv',onChange:function onChange(_ref2){var target=_ref2.target;return setFormat(target.value);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Button,{value:'csv'},'CSV'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Button,{value:'sdmx-ml'},'SDMX-ML'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Button,{value:'xls'},'Excel'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Button,{value:'px'},'PC-Axis')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_divider___default.a,null),(format==='csv'||format==='xls'||format==='px')&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__csv_form__["a" /* default */],null),format==='sdmx-ml'&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__xml_form__["a" /* default */],{dataLanguage:dataLanguage});}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(Loader));

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mapping_control__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__row_list__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__row_list_actions__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_embargo_input__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__style_css__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__style_css__);
var mapStateToProps=function mapStateToProps(state){return{format:state.scenes.dataManager.loader.shared.format,mappingId:state.scenes.dataManager.loader.components.csvForm.shared.mappingId,mapping:state.scenes.dataManager.loader.components.csvForm.shared.mapping,mappingCube:state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,tid:state.scenes.dataManager.loader.components.csvForm.shared.tid,importType:state.scenes.dataManager.loader.components.csvForm.local.importType,file:state.scenes.dataManager.loader.components.csvForm.local.file,separator:state.scenes.dataManager.loader.components.csvForm.shared.separator,delimiter:state.scenes.dataManager.loader.components.csvForm.shared.delimiter,hasHeader:state.scenes.dataManager.loader.components.csvForm.shared.hasHeader,hasDotStatFormat:state.scenes.dataManager.loader.components.csvForm.shared.hasDotStatFormat,fileServerPath:state.scenes.dataManager.loader.components.csvForm.shared.fileServerPath,csvServerPath:state.scenes.dataManager.loader.components.csvForm.shared.csvServerPath,embargo:state.scenes.dataManager.loader.components.csvForm.local.embargo,refreshProdDf:state.scenes.dataManager.loader.components.csvForm.local.refreshProdDf,checkFiltAttributes:state.scenes.dataManager.loader.components.csvForm.local.checkFiltAttributes,isIgnoreConcurrentUploadConfirmVisible:state.scenes.dataManager.loader.components.csvForm.local.isIgnoreConcurrentUploadConfirmVisible};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["g" /* changeLoaderCsvForm */])(fields));},onFileUpload:function onFileUpload(file,mappingCubeId,format){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["l" /* uploadLoaderCsvFormFile */])(file,mappingCubeId,format));},onRowListShow:function onRowListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__row_list_actions__["f" /* showLoaderCsvFormRowList */])());},onSubmit:function onSubmit(separator,delimiter,hasHeader,importType,cubeId,mappingId,filePath,tid,cubeCode,idMappingSpecialTimePeriod,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["k" /* submitLoaderCsvForm */])(separator,delimiter,hasHeader,importType,cubeId,mappingId,filePath,tid,cubeCode,idMappingSpecialTimePeriod,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload));},onHideIgnoreConcurrentUploadConfirm:function onHideIgnoreConcurrentUploadConfirm(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["j" /* onHideLoaderCsvFormIgnoreConcurrentUploadConfirm */])());},onConvertPxToCsv:function onConvertPxToCsv(_ref){var fileServerPath=_ref.fileServerPath,cubeId=_ref.cubeId;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["h" /* convertLoaderCsvFormPxToCsv */])(fileServerPath,cubeId));},onConvertXlsToCsv:function onConvertXlsToCsv(_ref2){var fileServerPath=_ref2.fileServerPath,xmlFileServerPath=_ref2.xmlFileServerPath,cubeId=_ref2.cubeId;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["i" /* convertLoaderCsvFormXlsToCsv */])(fileServerPath,xmlFileServerPath,cubeId));}};};var mapPropsToFields=function mapPropsToFields(_ref3){var mapping=_ref3.mapping,tid=_ref3.tid,importType=_ref3.importType,file=_ref3.file,separator=_ref3.separator,delimiter=_ref3.delimiter,hasHeader=_ref3.hasHeader,hasDotStatFormat=_ref3.hasDotStatFormat,embargo=_ref3.embargo,refreshProdDf=_ref3.refreshProdDf,checkFiltAttributes=_ref3.checkFiltAttributes;return{mappingId:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:mapping!==null?'['+mapping.Name+'] '+(mapping.Description||''):null}),tid:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:tid}),importType:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:importType}),file:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:file}),separator:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:separator}),delimiter:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:delimiter}),hasHeader:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:hasHeader}),hasDotStatFormat:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:hasDotStatFormat}),embargo:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:embargo}),refreshProdDf:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:refreshProdDf}),checkFiltAttributes:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:checkFiltAttributes})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(fields);};var LoaderCsvForm=function LoaderCsvForm(_ref4){var t=_ref4.t,format=_ref4.format,form=_ref4.form,mappingId=_ref4.mappingId,mapping=_ref4.mapping,mappingCube=_ref4.mappingCube,tid=_ref4.tid,importType=_ref4.importType,file=_ref4.file,separator=_ref4.separator,hasHeader=_ref4.hasHeader,hasDotStatFormat=_ref4.hasDotStatFormat,delimiter=_ref4.delimiter,fileServerPath=_ref4.fileServerPath,csvServerPath=_ref4.csvServerPath,onFileUpload=_ref4.onFileUpload,onRowListShow=_ref4.onRowListShow,onSubmit=_ref4.onSubmit,embargo=_ref4.embargo,refreshProdDf=_ref4.refreshProdDf,checkFiltAttributes=_ref4.checkFiltAttributes,isIgnoreConcurrentUploadConfirmVisible=_ref4.isIgnoreConcurrentUploadConfirmVisible,onHideIgnoreConcurrentUploadConfirm=_ref4.onHideIgnoreConcurrentUploadConfirm,onConvertPxToCsv=_ref4.onConvertPxToCsv,onConvertXlsToCsv=_ref4.onConvertXlsToCsv;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__hocs_call__["a" /* default */],{cb:onConvertPxToCsv,cbParam:{fileServerPath:fileServerPath,cubeId:mappingCube?mappingCube.IDCube:null},disabled:!mappingCube||format!=='px'||fileServerPath===null},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__hocs_call__["a" /* default */],{cb:onConvertXlsToCsv,cbParam:{fileServerPath:fileServerPath,xmlFileServerPath:mapping?mapping.XMLFilePath:null,cubeId:mappingCube?mappingCube.IDCube:null},disabled:!mappingCube||format!=='xls'||fileServerPath===null||!mapping||!mapping.XMLFilePath},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{style:{width:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MODAL_WIDTH_SM"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,{className:'advanced-form'},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('scenes.dataManager.loader.csvForm.fields.mapping.label')},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__mapping_control__["a" /* default */],{form:form})))),!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('scenes.dataManager.loader.csvForm.fields.tid.label'),validateStatus:tid&&Object(__WEBPACK_IMPORTED_MODULE_31__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,tid).help?"warning":null,help:tid&&Object(__WEBPACK_IMPORTED_MODULE_31__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,tid).help},form.getFieldDecorator('tid',{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{style:{textTransform:"uppercase"}}))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('scenes.dataManager.loader.csvForm.fields.importType.label')},form.getFieldDecorator('importType')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref5){var props=_ref5.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:mappingId===null||!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&(tid===null||tid.length===0)},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:'SeriesAndData',title:t('scenes.dataManager.loader.csvForm.fields.importType.option.SeriesAndData')},t('scenes.dataManager.loader.csvForm.fields.importType.option.SeriesAndData')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:'Series',title:t('scenes.dataManager.loader.csvForm.fields.importType.option.Series')},t('scenes.dataManager.loader.csvForm.fields.importType.option.Series')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{value:'Data',title:t('scenes.dataManager.loader.csvForm.fields.importType.option.Data')},t('scenes.dataManager.loader.csvForm.fields.importType.option.Data'))))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.file.label')},form.getFieldDecorator('file')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_file_input__["a" /* default */],{disabled:mappingId===null||!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&(tid===null||tid.length===0),accept:format==='xls'?".xls,.xlsx":"."+format,isZipAllowed:true}))))),format==='csv'&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.separator.label')},form.getFieldDecorator('separator')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{disabled:mappingId===null||!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&(tid===null||tid.length===0),maxLength:1})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.csv.delimiter.label')},form.getFieldDecorator('delimiter')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{disabled:mappingId===null||!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&(tid===null||tid.length===0),maxLength:1}))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.csv.hasHeader.label')},form.getFieldDecorator('hasHeader',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,{disabled:mappingId===null||!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&(tid===null||tid.length===0)})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.csv.hasDotStatFormat.label')},form.getFieldDecorator('hasDotStatFormat',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,{disabled:mappingId===null||!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&(tid===null||tid.length===0)})))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{type:'flex',justify:'center',gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onFileUpload(file,mappingCube.IDCube,format);},disabled:!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&(tid===null||tid.length===0)||mappingCube===null||file===null||format==='csv'&&(separator===null||separator.length===0||hasHeader===null),type:'primary',icon:'upload'},t('data.csv.uploadButton.label')))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onRowListShow,disabled:csvServerPath===null,icon:'table'},t('data.csv.tableShowButton.label')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__row_list__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,{type:'flex',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,form.getFieldDecorator('embargo')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_embargo_input__["a" /* default */],{disabled:csvServerPath===null}))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,function(){var submit=function submit(ignoreConcurrentUpload){return onSubmit(format==='csv'?separator:';',format==='csv'?!!delimiter?delimiter:null:'"',format==='csv'?hasHeader:true,importType,mappingCube.IDCube,mappingId,csvServerPath,tid,mappingCube.Code,hasDotStatFormat?mappingId:null,embargo?embargo.enabled:false,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload);};return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.title'),content:t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.content'),onOk:function onOk(){submit(true);onHideIgnoreConcurrentUploadConfirm();},onCancel:function onCancel(){onHideIgnoreConcurrentUploadConfirm();},cancelText:t('commons.buttons.cancel.title')});},disabled:!isIgnoreConcurrentUploadConfirmVisible},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.loader.confirms.submit.title'),onOk:function onOk(){submit();},cancelText:t('commons.buttons.cancel.title')});},disabled:mappingId===null||mappingCube===null||importType===null||!Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* userMustNotInsertTid */])(mapping,mappingCube)&&(tid===null||tid.length===0)||format==='csv'&&(separator===null||separator.length===0||hasHeader===null)||csvServerPath===null,type:'primary',icon:'check'},t('scenes.dataManager.loader.csvForm.submitButton.label')));}())),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('scenes.dataManager.loader.csvForm.refreshProdDf.label')},form.getFieldDecorator('refreshProdDf',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,{disabled:fileServerPath===null})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('scenes.dataManager.loader.csvForm.checkFiltAttributes.label')},form.getFieldDecorator('checkFiltAttributes',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,{disabled:fileServerPath===null})))))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_23_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(LoaderCsvForm));

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_file_mapping_form__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_buttons__ = __webpack_require__(67);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var IconFontCNIcon=__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a.createFromIconfontCN({scriptUrl:'./static/vendor/iconfont_cn/iconfont.js'});var mapStateToProps=function mapStateToProps(state){return{selectedMappingId:state.scenes.dataManager.loader.components.csvForm.shared.mappingId,selectedMapping:state.scenes.dataManager.loader.components.csvForm.shared.mapping,selectedMappingCube:state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,isSelectedMappingVisible:state.scenes.dataManager.loader.components.csvForm.components.mappingControl.isSelectedMappingVisible,isMappingsVisible:state.scenes.dataManager.loader.components.csvForm.components.mappingControl.isMappingsVisible,mappingsTree:state.scenes.dataManager.loader.components.csvForm.components.mappingControl.mappingsTree,detailMappingId:state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMappingId,detailMapping:state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMapping,detailMappingCube:state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMappingCube,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMappingSet:function onMappingSet(mappingId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["v" /* setLoaderCsvFormMappingControlMapping */])(mappingId));},onMappingUnset:function onMappingUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["z" /* unsetLoaderCsvFormMappingControlMapping */])());},onMappingsShow:function onMappingsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["x" /* showLoaderCsvFormMappingControlMappings */])());},onDetailMappingShow:function onDetailMappingShow(mappingId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["w" /* showLoaderCsvFormMappingControlDetailMapping */])(mappingId));},onSelectedMappingShow:function onSelectedMappingShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["y" /* showLoaderCsvFormMappingControlSelectedMapping */])());},onMappingsHide:function onMappingsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["o" /* hideLoaderCsvFormMappingControlMappings */])());},onDetailMappingHide:function onDetailMappingHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["n" /* hideLoaderCsvFormMappingControlDetailMapping */])());},onSelectedMappingHide:function onSelectedMappingHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["p" /* hideLoaderCsvFormMappingControlSelectedMapping */])());},fetchMappings:function fetchMappings(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["s" /* readLoaderCsvFormMappingControlMappings */])());},fetchDetailMapping:function fetchDetailMapping(mappingId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["q" /* readLoaderCsvFormMappingControlDetailMapping */])(mappingId));},fetchDetailMappingCube:function fetchDetailMappingCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["r" /* readLoaderCsvFormMappingControlDetailMappingCube */])(cubeId));},fetchSelectedMapping:function fetchSelectedMapping(mappingId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["t" /* readLoaderCsvFormMappingControlSelectedMapping */])(mappingId));},fetchSelectedMappingCube:function fetchSelectedMappingCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["u" /* readLoaderCsvFormMappingControlSelectedMappingCube */])(cubeId));}};};var LoaderCsvFormMappingControl=function LoaderCsvFormMappingControl(_ref){var t=_ref.t,form=_ref.form,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,selectedMappingId=_ref.selectedMappingId,selectedMapping=_ref.selectedMapping,selectedMappingCube=_ref.selectedMappingCube,isSelectedMappingVisible=_ref.isSelectedMappingVisible,isMappingsVisible=_ref.isMappingsVisible,mappingsTree=_ref.mappingsTree,detailMappingId=_ref.detailMappingId,detailMapping=_ref.detailMapping,detailMappingCube=_ref.detailMappingCube,onMappingSet=_ref.onMappingSet,onMappingUnset=_ref.onMappingUnset,onMappingsShow=_ref.onMappingsShow,onDetailMappingShow=_ref.onDetailMappingShow,onSelectedMappingShow=_ref.onSelectedMappingShow,onMappingsHide=_ref.onMappingsHide,onDetailMappingHide=_ref.onDetailMappingHide,onSelectedMappingHide=_ref.onSelectedMappingHide,fetchMappings=_ref.fetchMappings,fetchDetailMapping=_ref.fetchDetailMapping,fetchDetailMappingCube=_ref.fetchDetailMappingCube,fetchSelectedMapping=_ref.fetchSelectedMapping,fetchSelectedMappingCube=_ref.fetchSelectedMappingCube;var _useState=Object(__WEBPACK_IMPORTED_MODULE_7_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),selected=_useState2[0],setSelected=_useState2[1];return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hocs_call__["a" /* default */],{cb:fetchSelectedMapping,cbParam:selectedMappingId,disabled:selectedMappingId===null},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hocs_call__["a" /* default */],{cb:fetchSelectedMappingCube,cbParam:selectedMapping!==null&&selectedMapping.IDCube,disabled:selectedMapping===null},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_enhanced_modal__["a" /* default */],{visible:isSelectedMappingVisible,onCancel:onSelectedMappingHide,title:t('scenes.dataManager.loader.csvForm.mappingControl.selectedMapping.title'),width:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MODAL_WIDTH_SM"],footer:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onSelectedMappingHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_file_mapping_form__["a" /* default */],{fileMapping:selectedMapping,cube:selectedMappingCube})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_enhanced_modal__["a" /* default */],{visible:isMappingsVisible,onCancel:onMappingsHide,title:t('scenes.dataManager.loader.csvForm.mappingControl.mappingList.title'),width:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onMappingsHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){return onMappingSet(selected);},type:'primary',disabled:!selected},t('commons.buttons.select.title')))},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hocs_call__["a" /* default */],{cb:fetchMappings},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'loader__csv-form__tree'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_tree__["a" /* default */],{tree:mappingsTree,idKey:'TreeID',nameKey:'Name',childrenKey:'children',catIdKey:'TreeID',catNameKey:'labels',getIsNameMultilanguage:function getIsNameMultilanguage(node){return!node.IDMapping;},unselectableKeys:Object(__WEBPACK_IMPORTED_MODULE_17__utils_tree__["l" /* getNodes */])(mappingsTree,'children',function(node){return!node.IDMapping;}).map(function(node){return node.TreeID;}),hiddenIdKeys:Object(__WEBPACK_IMPORTED_MODULE_17__utils_tree__["l" /* getNodes */])(mappingsTree,'children',function(_ref2){var Code=_ref2.Code;return!Code;}).map(function(node){return node.TreeID;}),getIcon:function getIcon(_ref3){var Code=_ref3.Code,IDMapping=_ref3.IDMapping;if(Code){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(IconFontCNIcon,{theme:'filled',style:{color:"#37a0f4"},type:'cube'});}else if(IDMapping){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{theme:'filled',type:'file-text'});}else{return null;}},getFilter:function getFilter(searchText){return function(_ref4){var labels=_ref4.labels,Code=_ref4.Code,Name=_ref4.Name;var search=searchText.toLowerCase();return Name&&Name.toLowerCase().indexOf(search)>=0||Code&&Code.toLowerCase().indexOf(search)>=0||labels&&Object(__WEBPACK_IMPORTED_MODULE_18__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},onSelect:function onSelect(selectedArr){if(selectedArr&&selectedArr[0]){setSelected(Number(selectedArr[0].replace("Mapp_","")));}else{setSelected(null);}},treeActions:[{title:t('scenes.dataManager.loader.csvForm.mappingControl.refreshTree.title'),icon:'sync',onClick:fetchMappings}],actions:[selected?Object.assign({},__WEBPACK_IMPORTED_MODULE_19__styles_buttons__["l" /* BUTTON_DETAIL */],{title:t('components.itemList.actions.view.title'),onClick:function onClick(){return onDetailMappingShow(selected);}}):null]})))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_enhanced_modal__["a" /* default */],{visible:detailMappingId!==null,onCancel:onDetailMappingHide,title:t('scenes.dataManager.loader.csvForm.mappingControl.detailMapping.title'),width:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MODAL_WIDTH_SM"],footer:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onDetailMappingHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hocs_call__["a" /* default */],{cb:fetchDetailMapping,cbParam:detailMappingId},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hocs_call__["a" /* default */],{cb:fetchDetailMappingCube,cbParam:detailMapping!==null&&detailMapping.IDCube,disabled:detailMapping===null},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_file_mapping_form__["a" /* default */],{fileMapping:detailMapping,cube:detailMappingCube})))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,null,form.getFieldDecorator('mappingId')(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_selector__["a" /* default */],{detailTitle:t('scenes.dataManager.loader.csvForm.mappingControl.detailIcon.title'),selectTitle:t('scenes.dataManager.loader.csvForm.mappingControl.selectIcon.title'),resetTitle:t('scenes.dataManager.loader.csvForm.mappingControl.resetIcon.title'),onDetail:onSelectedMappingShow,onSelect:onMappingsShow,onReset:onMappingUnset})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(LoaderCsvFormMappingControl));

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_infinite_scroll_data_table__ = __webpack_require__(74);
var mapStateToProps=function mapStateToProps(state){return{isVisible:state.scenes.dataManager.loader.components.csvForm.components.rowList.isVisible,tid:state.scenes.dataManager.loader.components.csvForm.shared.tid,mappingId:state.scenes.dataManager.loader.components.csvForm.shared.mappingId,separator:state.scenes.dataManager.loader.components.csvForm.shared.separator,delimiter:state.scenes.dataManager.loader.components.csvForm.shared.delimiter,hasHeader:state.scenes.dataManager.loader.components.csvForm.shared.hasHeader,hasDotStatFormat:state.scenes.dataManager.loader.components.csvForm.shared.hasDotStatFormat,csvServerPath:state.scenes.dataManager.loader.components.csvForm.shared.csvServerPath,format:state.scenes.dataManager.loader.shared.format,csvRows:state.scenes.dataManager.loader.components.csvForm.components.rowList.csvRows};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* hideLoaderCsvFormRowList */])());},fetchCsvRows:function fetchCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,tid,filePath,idMappingSpecialTimePeriod){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* getLoaderCsvFormRowListCsvRows */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,tid,filePath,idMappingSpecialTimePeriod));}};};var LoaderCsvFormRowList=function LoaderCsvFormRowList(_ref){var t=_ref.t,isVisible=_ref.isVisible,tid=_ref.tid,mappingId=_ref.mappingId,separator=_ref.separator,delimiter=_ref.delimiter,hasHeader=_ref.hasHeader,hasDotStatFormat=_ref.hasDotStatFormat,csvServerPath=_ref.csvServerPath,csvRows=_ref.csvRows,onHide=_ref.onHide,fetchCsvRows=_ref.fetchCsvRows,format=_ref.format;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__["a" /* default */],{visible:isVisible,onCancel:onHide,title:t('scenes.dataManager.loader.csvForm.rowList.title'),width:__WEBPACK_IMPORTED_MODULE_2__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title'))},csvServerPath!==null&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_infinite_scroll_data_table__["a" /* default */],{data:csvRows&&csvRows.Data,rowTotal:csvRows&&csvRows.Count,cols:csvRows&&csvRows.Columns,hiddenCols:['NumRow'],onChange:function onChange(_ref2){var pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc;return fetchCsvRows(pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_9__utils_filter__["b" /* getFilterObjFromViewerObj */])(csvRows&&csvRows.Columns.filter(function(colName){return colName!=='NumRow';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc,format==='px'?';':separator,format==='px'?'"':!!delimiter?delimiter:null,format==='px'?true:hasHeader,tid,csvServerPath,hasDotStatFormat?mappingId:null);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(LoaderCsvFormRowList));

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__row_list__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__actions__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__row_list_actions__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__style_css__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_embargo_input__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_artefactValidators__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,categorisedCubes:state.scenes.dataManager.loader.components.xmlForm.local.categorisedCubes,isCubeTreeVisible:state.scenes.dataManager.loader.components.xmlForm.local.isCubeTreeVisible,cubeId:state.scenes.dataManager.loader.components.xmlForm.local.cubeId,cube:state.scenes.dataManager.loader.components.xmlForm.shared.cube,filePath:state.scenes.dataManager.loader.components.xmlForm.shared.filePath,tid:state.scenes.dataManager.loader.components.xmlForm.local.tid,importType:state.scenes.dataManager.loader.components.xmlForm.local.importType,file:state.scenes.dataManager.loader.components.xmlForm.local.file,embargo:state.scenes.dataManager.loader.components.xmlForm.local.embargo,refreshProdDf:state.scenes.dataManager.loader.components.xmlForm.local.refreshProdDf,checkFiltAttributes:state.scenes.dataManager.loader.components.xmlForm.local.checkFiltAttributes,isIgnoreConcurrentUploadConfirmVisible:state.scenes.dataManager.loader.components.xmlForm.local.isIgnoreConcurrentUploadConfirmVisible};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["k" /* changeLoaderXmlForm */])(fields));},onCubeTreeShow:function onCubeTreeShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["q" /* showLoaderXmlFormCubeTree */])());},onCubeTreeHide:function onCubeTreeHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["l" /* hideLoaderXmlFormCubeTree */])());},onCubeSet:function onCubeSet(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["p" /* setLoaderXmlFormCube */])(cubeId));},onCubeUnset:function onCubeUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["s" /* unsetLoaderXmlFormCube */])());},onRowListShow:function onRowListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__row_list_actions__["f" /* showLoaderXmlRowList */])());},onFileUpload:function onFileUpload(file,cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["t" /* uploadLoaderXmlFormFile */])(file,cubeId));},onSubmit:function onSubmit(importType,cubeId,dsdId,dsdAgencyId,dsdVersion,filePath,tid,cubeCode,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["r" /* submitLoaderXmlForm */])(importType,cubeId,dsdId,dsdAgencyId,dsdVersion,filePath,tid,cubeCode,embargo,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload));},fetchCategorisedCubes:function fetchCategorisedCubes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["n" /* readLoaderXmlFormCategorisedCubes */])());},fetchCube:function fetchCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["o" /* readLoaderXmlFormCube */])(cubeId));},onHideIgnoreConcurrentUploadConfirm:function onHideIgnoreConcurrentUploadConfirm(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions__["m" /* onHideLoaderXmlFormIgnoreConcurrentUploadConfirm */])());}};};var mapPropsToFields=function mapPropsToFields(_ref){var cube=_ref.cube,tid=_ref.tid,importType=_ref.importType,file=_ref.file,embargo=_ref.embargo,appLanguage=_ref.appLanguage,dataLanguage=_ref.dataLanguage,dataLanguages=_ref.dataLanguages,refreshProdDf=_ref.refreshProdDf,checkFiltAttributes=_ref.checkFiltAttributes;return{cubeId:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:cube!==null?'['+cube.Code+'] '+Object(__WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__["a" /* getLocalizedStr */])(cube.labels,dataLanguage||appLanguage,dataLanguages):null}),tid:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:tid}),importType:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:importType}),file:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:file}),embargo:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:embargo}),refreshProdDf:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:refreshProdDf}),checkFiltAttributes:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:checkFiltAttributes})};};var onFieldsChange=function onFieldsChange(_ref2,fields){var onChange=_ref2.onChange;return onChange(fields);};var LoaderXmlForm=function LoaderXmlForm(_ref3){var t=_ref3.t,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,form=_ref3.form,cubeId=_ref3.cubeId,cube=_ref3.cube,tid=_ref3.tid,file=_ref3.file,filePath=_ref3.filePath,embargo=_ref3.embargo,importType=_ref3.importType,isCubeTreeVisible=_ref3.isCubeTreeVisible,categorisedCubes=_ref3.categorisedCubes,onCubeTreeShow=_ref3.onCubeTreeShow,onCubeTreeHide=_ref3.onCubeTreeHide,onCubeSet=_ref3.onCubeSet,onCubeUnset=_ref3.onCubeUnset,onFileUpload=_ref3.onFileUpload,onRowListShow=_ref3.onRowListShow,onSubmit=_ref3.onSubmit,fetchCategorisedCubes=_ref3.fetchCategorisedCubes,fetchCube=_ref3.fetchCube,refreshProdDf=_ref3.refreshProdDf,checkFiltAttributes=_ref3.checkFiltAttributes,isIgnoreConcurrentUploadConfirmVisible=_ref3.isIgnoreConcurrentUploadConfirmVisible,onHideIgnoreConcurrentUploadConfirm=_ref3.onHideIgnoreConcurrentUploadConfirm;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_enhanced_modal__["a" /* default */],{visible:isCubeTreeVisible,title:t('scenes.dataManager.loader.xmlForm.cubeTreeModal.title'),footer:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{onClick:onCubeTreeHide},t('commons.buttons.close.title')),onCancel:onCubeTreeHide,width:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MODAL_WIDTH_MD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__hocs_call__["a" /* default */],{cb:fetchCategorisedCubes,disabled:categorisedCubes!==null},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div',{className:'loader__xml-form__tree'},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_enhanced_tree__["a" /* default */],{tree:categorisedCubes,idKey:'Code',nameKey:'labels',childrenKey:'children',catIdKey:'CatCode',catNameKey:'labels',unselectableKeys:Object(__WEBPACK_IMPORTED_MODULE_29__utils_tree__["l" /* getNodes */])(categorisedCubes,'children',function(node){return node.children;}).map(function(node){return node.CatCode;}),hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_30__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode,__WEBPACK_IMPORTED_MODULE_29__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],getFilter:function getFilter(searchText){return function(_ref4){var Code=_ref4.Code,CatCode=_ref4.CatCode,labels=_ref4.labels;var search=searchText.toLowerCase();return Code&&Code.toLowerCase().indexOf(search)>=0||CatCode&&CatCode.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_19__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},onSelect:function onSelect(selectedArr){var node=Object(__WEBPACK_IMPORTED_MODULE_29__utils_tree__["k" /* getNode */])(categorisedCubes,'children',function(node){return node.children?node.CatCode===selectedArr[0]:node.Code===selectedArr[0];});if(node!==null&&node.children===undefined){onCubeSet(node.IDCube);}else{onCubeUnset();}},treeActions:[{title:t('scenes.dataManager.loader.xmlForm.cubeTreeModal.tree.refreshButton.title'),icon:'sync',onClick:fetchCategorisedCubes}],icon:'cube',isCustomIcon:true,getIconColor:function getIconColor(){return"#37a0f4";},searchBarSpan:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_HALF"]})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{style:{width:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MODAL_WIDTH_SM"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,{className:'advanced-form'},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('scenes.dataManager.loader.xmlForm.fields.cube.label')},form.getFieldDecorator('cubeId')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_selector__["a" /* default */],{selectTitle:t('scenes.dataManager.loader.xmlForm.fields.cube.selectIcon.title'),resetTitle:t('scenes.dataManager.loader.xmlForm.fields.cube.resetIcon.title'),onSelect:onCubeTreeShow,onReset:onCubeUnset,onDetail:null}))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__hocs_call__["a" /* default */],{cb:fetchCube,cbParam:cubeId,disabled:cubeId===null},cube!==null&&cube.Attributes.filter(function(_ref5){var IsTid=_ref5.IsTid;return IsTid;}).length>0&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('scenes.dataManager.loader.xmlForm.fields.tid.label'),validateStatus:tid&&Object(__WEBPACK_IMPORTED_MODULE_37__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,tid).help?"warning":null,help:tid&&Object(__WEBPACK_IMPORTED_MODULE_37__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,tid).help},form.getFieldDecorator('tid',{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{style:{textTransform:"uppercase"}}))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('scenes.dataManager.loader.xmlForm.fields.importType.label')},form.getFieldDecorator('importType')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref6){var props=_ref6.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:cube===null},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:'SeriesAndData',title:t('scenes.dataManager.loader.xmlForm.fields.importType.option.SeriesAndData')},t('scenes.dataManager.loader.xmlForm.fields.importType.option.SeriesAndData')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:'Series',title:t('scenes.dataManager.loader.xmlForm.fields.importType.option.Series')},t('scenes.dataManager.loader.xmlForm.fields.importType.option.Series')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:'Data',title:t('scenes.dataManager.loader.xmlForm.fields.importType.option.Data')},t('scenes.dataManager.loader.xmlForm.fields.importType.option.Data'))))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.xml.file.label')},form.getFieldDecorator('file')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_file_input__["a" /* default */],{disabled:cube===null,accept:'.xml',isZipAllowed:true}))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:'flex',justify:'center',gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{onClick:function onClick(){return onFileUpload(file,cube.IDCube);},disabled:cube===null||file===null,type:'primary',icon:'upload'},t('data.xml.uploadButton.label')))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{disabled:filePath===null,onClick:onRowListShow,icon:'table'},t('data.xml.tableShowButton.label')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__row_list__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:'flex',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,form.getFieldDecorator('embargo')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_embargo_input__["a" /* default */],{disabled:filePath===null}))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,function(){var submit=function submit(ignoreConcurrentUpload){return onSubmit(importType,cube.IDCube,Object(__WEBPACK_IMPORTED_MODULE_35__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(cube.DSDCode).id,Object(__WEBPACK_IMPORTED_MODULE_35__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(cube.DSDCode).agencyID,Object(__WEBPACK_IMPORTED_MODULE_35__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(cube.DSDCode).version,filePath,tid,cube.Code,embargo?embargo.enabled:false,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload);};return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.title'),content:t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.content'),onOk:function onOk(){submit(true);onHideIgnoreConcurrentUploadConfirm();},onCancel:function onCancel(){onHideIgnoreConcurrentUploadConfirm();},cancelText:t('commons.buttons.cancel.title')});},disabled:!isIgnoreConcurrentUploadConfirmVisible},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_button___default.a,{onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.loader.confirms.submit.title'),onOk:function onOk(){submit();},cancelText:t('commons.buttons.cancel.title')});},type:'primary',icon:'check',disabled:filePath===null},t('scenes.dataManager.loader.xmlForm.submitButton.label')));}())),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('scenes.dataManager.loader.csvForm.refreshProdDf.label')},form.getFieldDecorator('refreshProdDf',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{disabled:filePath===null})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('scenes.dataManager.loader.csvForm.checkFiltAttributes.label')},form.getFieldDecorator('checkFiltAttributes',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{disabled:filePath===null}))))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(LoaderXmlForm));

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_infinite_scroll_data_table__ = __webpack_require__(74);
var mapStateToProps=function mapStateToProps(state){return{isVisible:state.scenes.dataManager.loader.components.xmlForm.components.rowList.isVisible,cube:state.scenes.dataManager.loader.components.xmlForm.shared.cube,filePath:state.scenes.dataManager.loader.components.xmlForm.shared.filePath,rows:state.scenes.dataManager.loader.components.xmlForm.components.rowList.rows};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* hideLoaderXmlRowList */])());},fetchRows:function fetchRows(dsdId,dsdAgencyId,dsdVersion,pageNum,pageSize,filterTable,sortCols,sortByDesc,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* getLoaderXmlFormRowListRows */])(dsdId,dsdAgencyId,dsdVersion,pageNum,pageSize,filterTable,sortCols,sortByDesc,filePath));}};};var LoaderCsvFormRowList=function LoaderCsvFormRowList(_ref){var t=_ref.t,isVisible=_ref.isVisible,filePath=_ref.filePath,cube=_ref.cube,rows=_ref.rows,onHide=_ref.onHide,fetchRows=_ref.fetchRows;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_enhanced_modal__["a" /* default */],{visible:isVisible,onCancel:onHide,title:t('scenes.dataManager.loader.xmlForm.rowList.title'),width:__WEBPACK_IMPORTED_MODULE_2__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title'))},cube!==null&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_infinite_scroll_data_table__["a" /* default */],{data:rows&&rows.Data,rowTotal:rows&&rows.Count,cols:rows&&rows.Columns,hiddenCols:['NumRow'],onChange:function onChange(_ref2){var pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc;return fetchRows(Object(__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(cube.DSDCode).id,Object(__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(cube.DSDCode).agencyID,Object(__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(cube.DSDCode).version,pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_10__utils_filter__["b" /* getFilterObjFromViewerObj */])(rows&&rows.Columns.filter(function(colName){return colName!=='NumRow';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc,filePath);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(LoaderCsvFormRowList));

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CubeDownload__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_artefact_ownership_modal__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_infinite_scroll_data_table__ = __webpack_require__(74);
var mapStateToProps=function mapStateToProps(state){return{cubes:state.scenes.dataManager.cubeList.cubes,cubeId:state.scenes.dataManager.cubeList.cubeId,currentDataView:state.scenes.dataManager.cubeList.currentDataView,isCubeDetailVisible:state.scenes.dataManager.cubeList.isCubeDetailVisible,isCubeDownloadVisible:state.scenes.dataManager.cubeList.isCubeDownloadVisible,cubeOwnershipCubeId:state.scenes.dataManager.cubeList.cubeOwnershipCubeId,permissions:state.app.user.permissions,cubeOwnershipUsers:state.scenes.dataManager.cubeList.cubeOwnershipUsers,cubeOwnershipOwners:state.scenes.dataManager.cubeList.cubeOwnershipOwners};};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_THREE_QUARTERS"]}};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCurrentDataViewShow:function onCurrentDataViewShow(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_26" /* showCubeListCurrentDataView */])(cubeId));},onCurrentDataViewHide:function onCurrentDataViewHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_6" /* hideCubeListCurrentDataView */])());},fetchCubes:function fetchCubes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_17" /* readCubeListCubes */])());},fetchCurrentDataView:function fetchCurrentDataView(cubeId,pageNum,pageSize,filterTable,sortCols,sortByDesc){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_18" /* readCubeListCurrentDataView */])(cubeId,pageNum,pageSize,filterTable,sortCols,sortByDesc));},onCubeDownloadShow:function onCubeDownloadShow(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_22" /* showCubeListCubeDownload */])(cubeId));},onCubeEmbargoRemove:function onCubeEmbargoRemove(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_19" /* removeCubeListCubeEmbargo */])(cubeId));},onCubeOwnershipShow:function onCubeOwnershipShow(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_25" /* showCubeListCubeOwnership */])(cubeId));},onCubeOwnershipHide:function onCubeOwnershipHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_5" /* hideCubeListCubeOwnership */])());},fetchOwnershipUsers:function fetchOwnershipUsers(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_16" /* readCubeListCubeOwnershipUsersRead */])());},fetchOwnershipOwners:function fetchOwnershipOwners(cubeCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_15" /* readCubeListCubeOwnershipOwnersRead */])(cubeCode));},onCubeOwnershipOwnersChange:function onCubeOwnershipOwnersChange(owners){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["Y" /* changeCubeListCubeOwnershipOwners */])(owners));},onCubeOwnershipSubmit:function onCubeOwnershipSubmit(cubeCode,owners){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_28" /* submitCubeListCubeOwnership */])(cubeCode,owners));},onEmptyCube:function onEmptyCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_30" /* submitCubeListEmptyCube */])(cubeId));},onDeleteCube:function onDeleteCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_29" /* submitCubeListDeleteCube */])(cubeId));}};};var CubeList=function CubeList(_ref){var t=_ref.t,cubes=_ref.cubes,cubeId=_ref.cubeId,permissions=_ref.permissions,currentDataView=_ref.currentDataView,onCurrentDataViewShow=_ref.onCurrentDataViewShow,onCurrentDataViewHide=_ref.onCurrentDataViewHide,fetchCubes=_ref.fetchCubes,fetchCurrentDataView=_ref.fetchCurrentDataView,isCubeDetailVisible=_ref.isCubeDetailVisible,onCubeDownloadShow=_ref.onCubeDownloadShow,onCubeEmbargoRemove=_ref.onCubeEmbargoRemove,onCubeOwnershipShow=_ref.onCubeOwnershipShow,onCubeOwnershipHide=_ref.onCubeOwnershipHide,cubeOwnershipCubeId=_ref.cubeOwnershipCubeId,cubeOwnershipUsers=_ref.cubeOwnershipUsers,cubeOwnershipOwners=_ref.cubeOwnershipOwners,fetchOwnershipUsers=_ref.fetchOwnershipUsers,fetchOwnershipOwners=_ref.fetchOwnershipOwners,onCubeOwnershipOwnersChange=_ref.onCubeOwnershipOwnersChange,onCubeOwnershipSubmit=_ref.onCubeOwnershipSubmit,onEmptyCube=_ref.onEmptyCube,onDeleteCube=_ref.onDeleteCube;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_enhanced_modal__["a" /* default */],{visible:cubeId!==null&&isCubeDetailVisible,title:t('scenes.dataManager.cubeList.currentDataViewModal.title',{id:cubes&&cubeId?cubes.find(function(_ref2){var IDCube=_ref2.IDCube;return IDCube===cubeId;}).Code:""}),width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_LG"],onCancel:onCurrentDataViewHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onCurrentDataViewHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_infinite_scroll_data_table__["a" /* default */],{data:currentDataView&&currentDataView.Data,cols:currentDataView&&currentDataView.Columns,rowTotal:currentDataView&&currentDataView.Count,hiddenCols:['SID'],onChange:function onChange(_ref3){var pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,searchText=_ref3.searchText,filters=_ref3.filters,sortCol=_ref3.sortCol,sortByDesc=_ref3.sortByDesc;return fetchCurrentDataView(cubeId,pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_23__utils_filter__["b" /* getFilterObjFromViewerObj */])(currentDataView&&currentDataView.Columns.filter(function(colName){return colName!=='SID';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc);}})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:fetchCubes,disabled:cubes!==null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_infinite_scroll_table__["a" /* default */],{data:cubes?cubes.map(function(cube){return Object.assign({},cube,{view:'Dataset_'+cube.IDCube+'_ViewCurrentData',fact:'FactS'+cube.IDCube,filter:'FiltS'+cube.IDCube});}):null,getRowKey:function getRowKey(cube){return cube.Code;},multilangStrDataIndexes:['labels'],columns:[{title:t('data.cube.id.label'),dataIndex:'Code',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.cube.name.label'),dataIndex:'labels',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.cube.dsd.label'),dataIndex:'DSDCode',minWidth:150},{title:t('data.cube.lastUpdate.label'),dataIndex:'LastUpdate',widthToContent:true,render:function render(dateTime){return new Date(dateTime).toLocaleString();},renderText:function renderText(dateTime){return new Date(dateTime).toLocaleString();}},{title:t('data.cube.hasEmbargoedData.shortLabel'),dataIndex:'HasEmbargoedData',width:30,withValuesFilter:true,render:function render(HasEmbargoedData){return HasEmbargoedData?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'check'}):null;},renderText:function renderText(HasEmbargoedData){return HasEmbargoedData?t('data.dataflow.hasEmbargoedData.values.true'):t('data.dataflow.hasEmbargoedData.values.false');}}],actions:[Object.assign({},__WEBPACK_IMPORTED_MODULE_24__styles_buttons__["l" /* BUTTON_DETAIL */],{title:t('scenes.dataManager.cubeList.actions.detail.title'),onClick:function onClick(_ref4){var IDCube=_ref4.IDCube;return onCurrentDataViewShow(IDCube);}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_24__styles_buttons__["r" /* BUTTON_INFO */],{title:t('scenes.dataManager.cubeList.actions.info'),onClick:function onClick(_ref5){var view=_ref5.view,fact=_ref5.fact,filter=_ref5.filter,Code=_ref5.Code;return __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.info({title:t('scenes.dataManager.cubeList.modals.info.title',{id:Code}),content:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.dataManager.cubeList.modals.info.view.title')},formItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{value:view,title:view,disabled:true})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.dataManager.cubeList.modals.info.fact.title')},formItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{value:fact,title:fact,disabled:true})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.dataManager.cubeList.modals.info.filter.title')},formItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{value:filter,title:filter,disabled:true})))))});}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_24__styles_buttons__["m" /* BUTTON_DOWNLOAD */],{title:t('scenes.dataManager.cubeList.actions.download.title'),onClick:function onClick(_ref6){var IDCube=_ref6.IDCube;return onCubeDownloadShow(IDCube);}}),function(_ref7){var HasEmbargoedData=_ref7.HasEmbargoedData;return HasEmbargoedData?Object.assign({},__WEBPACK_IMPORTED_MODULE_24__styles_buttons__["B" /* BUTTON_REMOVE_EMBARGO */],{title:t('scenes.dataManager.cubeList.actions.removeEmbargo.title'),onClick:function onClick(_ref8){var IDCube=_ref8.IDCube,Code=_ref8.Code;return __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.cubeList.modals.confirms.removeEmbargo.title',{id:Code}),onOk:function onOk(){onCubeEmbargoRemove(IDCube);},cancelText:t('commons.buttons.cancel.title')});}}):null;},function(_ref9){var Code=_ref9.Code;return permissions.cubeOwner.includes(Code)?Object.assign({},__WEBPACK_IMPORTED_MODULE_24__styles_buttons__["v" /* BUTTON_MANAGE_OWNERS */],{title:t('commons.actions.manageOwners.title'),onClick:function onClick(cube){return onCubeOwnershipShow(cube.Code);}}):null;},Object.assign({},__WEBPACK_IMPORTED_MODULE_24__styles_buttons__["p" /* BUTTON_EMPTY_CUBE */],{title:t('commons.actions.emptyCube.title'),onClick:function onClick(_ref10){var IDCube=_ref10.IDCube,Code=_ref10.Code;return __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.cubeList.modals.confirms.emptyCube.title',{id:Code}),onOk:function onOk(){onEmptyCube(IDCube);},cancelText:t('commons.buttons.cancel.title')});}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_24__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('commons.actions.delete.title'),onClick:function onClick(_ref11){var IDCube=_ref11.IDCube,Code=_ref11.Code;return __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.cubeList.modals.confirms.delete.title',{id:Code}),onOk:function onOk(){onDeleteCube(IDCube);},cancelText:t('commons.buttons.cancel.title')});}})]})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__CubeDownload__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_artefact_ownership_modal__["a" /* default */],{isVisible:cubeOwnershipCubeId!==null,id:cubeOwnershipCubeId,onClose:onCubeOwnershipHide,users:cubeOwnershipUsers,owners:cubeOwnershipOwners,fetchUsers:fetchOwnershipUsers,fetchOwners:function fetchOwners(){return fetchOwnershipOwners(cubeOwnershipCubeId);},onOwnersChange:onCubeOwnershipOwnersChange,onSubmit:function onSubmit(){return onCubeOwnershipSubmit(cubeOwnershipCubeId,cubeOwnershipOwners);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_19_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CubeList));

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_draggable_check_list__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_css__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CubeDownloadCSVForm__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_query_form_filter__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_filter__ = __webpack_require__(53);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,cubeId:state.scenes.dataManager.cubeList.cubeDownloadId,cube:state.scenes.dataManager.cubeList.cube,filter:state.scenes.dataManager.cubeList.filter,isCubeDownloadVisible:state.scenes.dataManager.cubeList.isCubeDownloadVisible,isRowsModalVisible:state.scenes.dataManager.cubeList.isRowsModalVisible,rows:state.scenes.dataManager.cubeList.rows,cols:state.scenes.dataManager.cubeList.cols,checkedCols:state.scenes.dataManager.cubeList.checkedCols,isFilterModalVisible:state.scenes.dataManager.cubeList.isCubeDownloadFilterModalVisible,filterTemp:state.scenes.dataManager.cubeList.filterTemp,treeFilter:state.scenes.dataManager.cubeList.treeFilter,treeFilterTemp:state.scenes.dataManager.cubeList.treeFilterTemp,filterMode:state.scenes.dataManager.cubeList.filterMode};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCube:function fetchCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_8" /* readCubeListCubeDownloadCube */])(cubeId));},onCubeDownloadHide:function onCubeDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_2" /* hideCubeListCubeDownload */])());},onBlockAdd:function onBlockAdd(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["Q" /* addCubeListCubeDownloadWhereConditionsFormBlock */])());},onBlockDelete:function onBlockDelete(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_0" /* deleteCubeListCubeDownloadWhereConditionsFormBlock */])(blockIndex));},onConditionAdd:function onConditionAdd(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["R" /* addCubeListCubeDownloadWhereConditionsFormCondition */])(blockIndex));},onConditionDelete:function onConditionDelete(blockIndex,conditionIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_1" /* deleteCubeListCubeDownloadWhereConditionsFormCondition */])(blockIndex,conditionIndex));},fetchColumnValues:function fetchColumnValues(cubeId,columnName,viewerObj){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_14" /* readCubeListCubeDownloadWhereConditionsFormColumnValue */])(cubeId,columnName,viewerObj));},resetColumnValues:function resetColumnValues(columnName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_21" /* resetCubeListCubeDownloadWhereConditionsFormColumnValue */])(columnName));},fetchColumnCodes:function fetchColumnCodes(columnName,codelistCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_13" /* readCubeListCubeDownloadWhereConditionsFormColumnCodes */])(columnName,codelistCode));},onRowsModalShow:function onRowsModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_24" /* showCubeListCubeDownloadPreviewRowsModal */])());},onRowsModalHide:function onRowsModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_4" /* hideCubeListCubeDownloadPreviewRowsModal */])());},fetchRows:function fetchRows(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_12" /* readCubeListCubeDownloadPreviewRows */])(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc));},fetchCsv:function fetchCsv(cubeId,cubeColumns,filterStr,separator,delimiter,compression){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_7" /* readCubeListCubeDownloadCsv */])(cubeId,cubeColumns,filterStr,separator,delimiter,compression));},onCubeColumnsCheck:function onCubeColumnsCheck(cols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["Z" /* checkCubeListCubeDownloadCubeColumns */])(cols));},onCubeColumnsChange:function onCubeColumnsChange(cols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["S" /* changeCubeListCubeDownloadCubeColumns */])(cols));},onFilterModalShow:function onFilterModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_23" /* showCubeListCubeDownloadFilterModal */])());},onFilterModalHide:function onFilterModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_3" /* hideCubeListCubeDownloadFilterModal */])());},onFilterModalSubmit:function onFilterModalSubmit(filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_27" /* submitCubeListCubeDownloadFilterModal */])(filter));},onColumnModeChange:function onColumnModeChange(colName,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["W" /* changeCubeListCubeDownloadFilterModalTreeFilterColumnMode */])(colName,mode));},onFilterModeChange:function onFilterModeChange(filterMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["U" /* changeCubeListCubeDownloadFilterModalFilterMode */])(filterMode));},onFilterReset:function onFilterReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_20" /* resetCubeListCubeDownloadFilterModalFilter */])());},onFilterChange:function onFilterChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["T" /* changeCubeListCubeDownloadFilter */])(fields));},onTreeFilterChange:function onTreeFilterChange(treeFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["V" /* changeCubeListCubeDownloadFilterModalTreeFilter */])(treeFilter));},fetchColumnCodelistCount:function fetchColumnCodelistCount(_ref){var codelistTriplet=_ref.codelistTriplet,language=_ref.language;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_9" /* readCubeListCubeDownloadFilterModalTreeFilterColumnCodelistCount */])(codelistTriplet,language));},fetchColumnCodelistTree:function fetchColumnCodelistTree(_ref2){var codelistTriplet=_ref2.codelistTriplet,language=_ref2.language,itemsOrderAnnotationType=_ref2.itemsOrderAnnotationType;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_10" /* readCubeListCubeDownloadFilterModalTreeFilterColumnCodelistTree */])(codelistTriplet,language,itemsOrderAnnotationType));},fetchColumnFilteredValues:function fetchColumnFilteredValues(cubeId,colNames,filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_11" /* readCubeListCubeDownloadFilterModalTreeFilterColumnFilteredValues */])(cubeId,colNames,filter));},onColumnValuesChange:function onColumnValuesChange(colName,values){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["X" /* changeCubeListCubeDownloadFilterModalTreeFilterColumnValues */])(colName,values));}};};var cardStyle={type:'inner',headStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_MD"]},bodyStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_MD"],height:480,overflow:'auto'}};var _onDrop=function _onDrop(ev,cols){var array=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(cols);var pos=ev.node.props.pos.split('-');var dropPos=ev.dropPosition-Number(pos[pos.length-1]);var from=array.indexOf(ev.dragNode.props.eventKey);var to=array.indexOf(ev.node.props.eventKey);to=from<to?dropPos<0// moving forward into the array
?to-1// dropPos = -1 => drag on top node gap
:to// dropPos = 1 => drag on bottom node gap
:dropPos<0// moving backwards into the array
?to// dropPos = -1 => drag on top node gap
:to+1;// dropPos = 1 => drag on bottom node gap
if(to===-1){to=0;}if(to===array.length+1){to=array.length;}array.splice(to,0,array.splice(from,1)[0]);return array;};var getOrderCheckedCols=function getOrderCheckedCols(cols,checkedCols){var ret=[];cols&&checkedCols&&cols.map(function(col){return __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.findIndex(checkedCols,function(checkedCol){return checkedCol===col;})!==-1?ret.push(col):null;});return ret;};var CubeDownload=function CubeDownload(_ref3){var t=_ref3.t,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,cubeId=_ref3.cubeId,cube=_ref3.cube,filter=_ref3.filter,isCubeDownloadVisible=_ref3.isCubeDownloadVisible,isFilterModalVisible=_ref3.isFilterModalVisible,onFilterModalShow=_ref3.onFilterModalShow,onFilterModalHide=_ref3.onFilterModalHide,filterTemp=_ref3.filterTemp,treeFilter=_ref3.treeFilter,treeFilterTemp=_ref3.treeFilterTemp,onFilterModalSubmit=_ref3.onFilterModalSubmit,onColumnModeChange=_ref3.onColumnModeChange,onFilterModeChange=_ref3.onFilterModeChange,filterMode=_ref3.filterMode,onFilterReset=_ref3.onFilterReset,onFilterChange=_ref3.onFilterChange,onTreeFilterChange=_ref3.onTreeFilterChange,onColumnValuesChange=_ref3.onColumnValuesChange,fetchColumnCodelistCount=_ref3.fetchColumnCodelistCount,fetchColumnCodelistTree=_ref3.fetchColumnCodelistTree,fetchColumnFilteredValues=_ref3.fetchColumnFilteredValues,isRowsModalVisible=_ref3.isRowsModalVisible,onCubeDownloadHide=_ref3.onCubeDownloadHide,rows=_ref3.rows,cols=_ref3.cols,checkedCols=_ref3.checkedCols,fetchCube=_ref3.fetchCube,onBlockAdd=_ref3.onBlockAdd,onBlockDelete=_ref3.onBlockDelete,onConditionAdd=_ref3.onConditionAdd,onConditionDelete=_ref3.onConditionDelete,fetchColumnValues=_ref3.fetchColumnValues,resetColumnValues=_ref3.resetColumnValues,fetchColumnCodes=_ref3.fetchColumnCodes,onRowsModalShow=_ref3.onRowsModalShow,onRowsModalHide=_ref3.onRowsModalHide,fetchRows=_ref3.fetchRows,fetchCsv=_ref3.fetchCsv,onCubeColumnsCheck=_ref3.onCubeColumnsCheck,onCubeColumnsChange=_ref3.onCubeColumnsChange;var filterStr=filterMode===__WEBPACK_IMPORTED_MODULE_27__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?Object(__WEBPACK_IMPORTED_MODULE_29__utils_filter__["c" /* getFilterStrFromObj */])(filter,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})):null):Object(__WEBPACK_IMPORTED_MODULE_28__components_tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(treeFilter,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(_ref4){var name=_ref4.name;return name;}):null);var findIcon=function findIcon(label){if(cube&&cube.columns&&cube.columns.dimensions&&!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isEmpty(cube.columns.dimensions.filter(function(col){return label===col.ColName;}))){return"bar-chart";}else if(cube&&cube.columns&&cube.columns.timeDimensions&&!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isEmpty(cube.columns.timeDimensions.filter(function(col){return label===col.ColName;}))){return"clock-circle";}else if(cube&&cube.columns&&cube.columns.tidAttributes&&!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isEmpty(cube.columns.tidAttributes.filter(function(col){return label===col.ColName;}))){return"flag";}else if(cube&&cube.columns&&cube.columns.attributes&&!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isEmpty(cube.columns.attributes.filter(function(col){return label===col.ColName;}))){return"profile";}else if(cube&&cube.columns&&cube.columns.measures&&!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isEmpty(cube.columns.measures.filter(function(col){return label===col.ColName;}))){return"line-chart";}else{return"";}};var cubeWithCheckedCols=cube?Object.assign({},cube,{columns:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.mapValues(cube.columns,function(type){return type.map(function(col){return Object.assign({},col,{checked:checkedCols.includes(col.ColName)});});})}):null;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchCube,cbParam:cubeId,disabled:cubeId===null},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_enhanced_modal__["a" /* default */],{visible:cubeId!==null&&isCubeDownloadVisible,width:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MODAL_WIDTH_XL"],title:t('scenes.dataManager.cubeList.modals.cubeDownload.title'),onCancel:onCubeDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onCubeDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',disabled:checkedCols&&checkedCols.length===0,onClick:function onClick(){var modal=__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.info();modal.update({title:t("scenes.dataManager.cubeList.modals.cubeDownload.csvForm.title"),content:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__CubeDownloadCSVForm__["a" /* default */],{t:t,modal:modal,onDownload:function onDownload(separator,delimiter,compression){return fetchCsv(cubeId,getOrderCheckedCols(cols,checkedCols),filterStr,separator,delimiter,compression);}}),okButtonProps:{style:{display:'none'}},cancelButtonProps:{style:{display:'none'}},icon:'download'});}},t('scenes.dataManager.cubeList.modals.cubeDownload.buttons.download.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,Object.assign({title:t('scenes.dataManager.cubeList.modals.cubeDownload.cards.columns.title')},cardStyle),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{disabled:true,value:cube!==null?'['+cube.Code+'] '+Object(__WEBPACK_IMPORTED_MODULE_18__middlewares_i18n_utils__["a" /* getLocalizedStr */])(cube.labels,dataLanguage||appLanguage,dataLanguages):null}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,{type:'inner',bodyStyle:{height:391,overflow:"auto"},style:{marginTop:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_MD"]}},cols&&checkedCols&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{className:'draggable-check-list-drag-over'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_draggable_check_list__["a" /* default */],{items:cols,getItemLabel:function getItemLabel(item){return item;},getItemIcon:function getItemIcon(item){return findIcon(item);},getItemKey:function getItemKey(item){return item;},checkedKeys:checkedCols,onCheck:onCubeColumnsCheck,onDrop:function onDrop(ev){return onCubeColumnsChange(_onDrop(ev,cols));}}))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["SPAN_TWO_THIRDS"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,Object.assign({title:t('scenes.dataManager.cubeList.modals.cubeDownload.cards.whereConditions.title')},cardStyle),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_query_form_filter__["a" /* default */],{isFilterModalVisible:isFilterModalVisible,onFilterModalShow:onFilterModalShow,onFilterModalHide:onFilterModalHide,cube:cubeWithCheckedCols,filter:filter,filterTemp:filterTemp,treeFilter:treeFilter,treeFilterTemp:treeFilterTemp,dataLanguage:dataLanguage,fetchColumnValues:fetchColumnValues,resetColumnValues:resetColumnValues,fetchColumnCodes:fetchColumnCodes,onBlockAdd:onBlockAdd,onBlockDelete:onBlockDelete,onConditionAdd:onConditionAdd,onConditionDelete:onConditionDelete,rows:rows,isRowsModalVisible:isRowsModalVisible,onRowsModalHide:onRowsModalHide,fetchRows:fetchRows,cubeId:cubeId,onRowsModalShow:onRowsModalShow,onFilterModalSubmit:onFilterModalSubmit,onColumnModeChange:onColumnModeChange,onFilterModeChange:onFilterModeChange,filterMode:filterMode,onFilterReset:onFilterReset,onFilterChange:onFilterChange,onTreeFilterChange:onTreeFilterChange,fetchColumnCodelistCount:fetchColumnCodelistCount,fetchColumnCodelistTree:fetchColumnCodelistTree,fetchColumnFilteredValues:fetchColumnFilteredValues,onColumnValuesChange:onColumnValuesChange,cubeFirstRow:true}))));})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CubeDownload));

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_HALF"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_HALF"]}};var CubeDownloadCSVForm=function CubeDownloadCSVForm(_ref){var form=_ref.form,t=_ref.t,modal=_ref.modal,onDownload=_ref.onDownload;return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,{className:"advanced-form"},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.csv.separator.label')},formItemLayout),form.getFieldDecorator('separator',{initialValue:";"})(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{maxLength:1,style:{width:96}}))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.csv.delimiter.label')},formItemLayout),form.getFieldDecorator('delimiter')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{maxLength:1,style:{width:96}}))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('components.artefactDownloadForm.compression.label')},formItemLayout),form.getFieldDecorator('compression',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{title:form.getFieldValue('compression')}))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",style:{marginTop:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_LG"]},justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return modal.destroy();}},t("scenes.dataManager.cubeList.modals.cubeDownload.csvForm.buttons.cancel.title"))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:"primary",disabled:!form.getFieldValue('separator')||form.getFieldValue('separator').length===0,onClick:function onClick(){modal.destroy();onDownload(form.getFieldValue('separator'),form.getFieldValue('delimiter'),form.getFieldValue('compression'));}},t("scenes.dataManager.cubeList.modals.cubeDownload.csvForm.buttons.download.title")))));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create()(CubeDownloadCSVForm));

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list__ = __webpack_require__(1433);
var DataflowBuilder=function DataflowBuilder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (DataflowBuilder);

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__middlewares_newTab_actions__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DataflowProductionModal__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DataflowDownload__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__tree__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__wizard__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tree_actions__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__wizard_actions__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_layout_annotation_list__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_infinite_scroll_data_table__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{dataflows:state.scenes.dataManager.dataflowBuilder.shared.dataflows,dataflowId:state.scenes.dataManager.dataflowBuilder.components.list.dataflowId,dataflow:state.scenes.dataManager.dataflowBuilder.components.list.dataflow,dataflowPreview:state.scenes.dataManager.dataflowBuilder.components.list.dataflowPreview,nodeId:state.app.endpointId,nodes:state.config.nodes,dataflowAnnotations:state.scenes.dataManager.dataflowBuilder.components.list.dataflowAnnotations,dataflowLayoutAnnotations:state.scenes.dataManager.dataflowBuilder.components.list.dataflowLayoutAnnotations,endpoints:state.config.nodes,endpointId:state.app.endpointId,username:state.app.user.username,permissions:state.app.user.permissions};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCategorisationsShow:function onCategorisationsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__tree_actions__["f" /* showDataflowBuilderTree */])());},onWizardShow:function onWizardShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_30__wizard_actions__["k" /* showDataflowBuilderWizard */])());},onDataflowEdit:function onDataflowEdit(ddbDataflowId,dataflowTriplet,cubeId,filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_28" /* editDataflowBuilderListDataflow */])(ddbDataflowId,dataflowTriplet,cubeId,filter));},onDataflowDelete:function onDataflowDelete(ddbDataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_24" /* deleteDataflowBuilderListDataflow */])(ddbDataflowId));},onDataflowPreviewShow:function onDataflowPreviewShow(dataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_70" /* showDataflowBuilderListDataflowPreview */])(dataflowId));},onDataflowPreviewHide:function onDataflowPreviewHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_37" /* hideDataflowBuilderListDataflowPreview */])());},onDataflowProductionModalShow:function onDataflowProductionModalShow(ddbDataflowId,dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_71" /* showDataflowBuilderListDataflowProductionModal */])(ddbDataflowId,dataflowTriplet));},onOpenNewTab:function onOpenNewTab(url){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__middlewares_newTab_actions__["b" /* openNewTab */])(url));},fetchDataflows:function fetchDataflows(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_52" /* readDataflowBuilderListDataflows */])());},fetchDataflow:function fetchDataflow(dataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_40" /* readDataflowBuilderListDataflow */])(dataflowId));},fetchDataflowPreview:function fetchDataflowPreview(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc,dataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_50" /* readDataflowBuilderListDataflowPreview */])(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc,dataflowId));},onDownloadShow:function onDownloadShow(ddbDataflowId,cubeId,dataflowTriplet,dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_64" /* showDataflowBuilderListDataflowDownload */])(ddbDataflowId,cubeId,dataflowTriplet,dsdTriplet));},onAnnotationsShow:function onAnnotationsShow(annotations){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_63" /* showDataflowBuilderListDataflowAnnotations */])(annotations));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_30" /* hideDataflowBuilderListDataflowAnnotations */])());},onLayoutAnnotationsShow:function onLayoutAnnotationsShow(annotations){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_69" /* showDataflowBuilderListDataflowLayoutAnnotations */])(annotations));},onLayoutAnnotationsHide:function onLayoutAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_36" /* hideDataflowBuilderListDataflowLayoutAnnotations */])());}};};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_THREE_QUARTERS"]}};var DataflowBuilderList=function DataflowBuilderList(_ref){var t=_ref.t,dataflows=_ref.dataflows,dataflowId=_ref.dataflowId,dataflow=_ref.dataflow,dataflowPreview=_ref.dataflowPreview,nodes=_ref.nodes,nodeId=_ref.nodeId,onCategorisationsShow=_ref.onCategorisationsShow,onWizardShow=_ref.onWizardShow,onDataflowEdit=_ref.onDataflowEdit,onDataflowDelete=_ref.onDataflowDelete,onDataflowPreviewShow=_ref.onDataflowPreviewShow,onDataflowPreviewHide=_ref.onDataflowPreviewHide,onOpenNewTab=_ref.onOpenNewTab,onDataflowProductionModalShow=_ref.onDataflowProductionModalShow,fetchDataflows=_ref.fetchDataflows,fetchDataflow=_ref.fetchDataflow,fetchDataflowPreview=_ref.fetchDataflowPreview,onDownloadShow=_ref.onDownloadShow,dataflowAnnotations=_ref.dataflowAnnotations,dataflowLayoutAnnotations=_ref.dataflowLayoutAnnotations,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onLayoutAnnotationsShow=_ref.onLayoutAnnotationsShow,onLayoutAnnotationsHide=_ref.onLayoutAnnotationsHide,endpointId=_ref.endpointId,endpoints=_ref.endpoints,username=_ref.username,permissions=_ref.permissions;var productionAction=function productionAction(_ref2){var Agency=_ref2.Agency;return permissions&&permissions.agencies.filter(function(agency){return agency===Agency;}).length>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["A" /* BUTTON_PUBLISH */],{title:t('scenes.dataManager.dataflowBuilder.list.actions.production.title'),onClick:function onClick(_ref3){var IDDataflow=_ref3.IDDataflow,ID=_ref3.ID,Agency=_ref3.Agency,Version=_ref3.Version;return onDataflowProductionModalShow(IDDataflow,{id:ID,agencyID:Agency,version:Version});}}):null;};var detailAction=Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["l" /* BUTTON_DETAIL */],{title:t('scenes.dataManager.dataflowBuilder.list.actions.edit'),onClick:function onClick(_ref4){var IDDataflow=_ref4.IDDataflow,ID=_ref4.ID,Agency=_ref4.Agency,Version=_ref4.Version,IDCube=_ref4.IDCube,Filter=_ref4.Filter;return onDataflowEdit(IDDataflow,{id:ID,agencyID:Agency,version:Version},IDCube,Filter);}});var actions=[Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["z" /* BUTTON_PREVIEW */],{title:t('scenes.dataManager.dataflowBuilder.list.actions.preview'),onClick:function onClick(_ref5){var IDDataflow=_ref5.IDDataflow;return onDataflowPreviewShow(IDDataflow);}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["r" /* BUTTON_INFO */],{title:t('scenes.dataManager.dataflowBuilder.list.actions.info'),onClick:function onClick(_ref6){var cubeID=_ref6.cubeID,viewName=_ref6.viewName,ID=_ref6.ID;return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.info({title:t('scenes.dataManager.dataflowBuilder.modals.info.title',{id:ID}),content:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.cubeID.shortLabel')},formItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{value:cubeID,title:cubeID,disabled:true})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.viewName.shortLabel')},formItemLayout),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{value:viewName,title:viewName,disabled:true})))))});}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["m" /* BUTTON_DOWNLOAD */],{title:t('scenes.dataManager.dataflowBuilder.list.actions.download'),onClick:function onClick(_ref7){var IDDataflow=_ref7.IDDataflow,IDCube=_ref7.IDCube,ID=_ref7.ID,Agency=_ref7.Agency,Version=_ref7.Version,dsdTriplet=_ref7.dsdTriplet;return onDownloadShow(IDDataflow,IDCube,{id:ID,agencyID:Agency,version:Version},dsdTriplet);}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('scenes.dataManager.dataflowBuilder.list.actions.delete.title'),onClick:function onClick(_ref8){var IDDataflow=_ref8.IDDataflow,haveMetadata=_ref8.haveMetadata,ID=_ref8.ID,Agency=_ref8.Agency,Version=_ref8.Version;return haveMetadata?__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('scenes.dataManager.dataflowBuilder.list.actions.delete.haveMetadata.title')}):__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.dataflowBuilder.list.actions.delete.confirm',{triplet:Object(__WEBPACK_IMPORTED_MODULE_36__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:ID,agencyID:Agency,version:Version})}),onOk:function onOk(){onDataflowDelete(IDDataflow);},cancelText:t('commons.buttons.cancel.title')});}})];var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;var customAnnotationsConfig=endpoints.filter(function(endpoint){return endpoint.general.id===endpointId;})[0].annotationTabs.tabs;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:fetchDataflows,disabled:dataflows!==null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_infinite_scroll_table__["a" /* default */],{data:dataflows,getRowKey:function getRowKey(_ref9){var IDDataflow=_ref9.IDDataflow;return IDDataflow;},getIsAltRow:function getIsAltRow(_ref10){var isProduction=_ref10.isProduction;return isProduction;},columns:[{title:t('data.artefact.id.shortLabel'),dataIndex:'ID',minWidth:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.agencyID.shortLabel'),dataIndex:'Agency'},{title:t('data.artefact.name.shortLabel'),dataIndex:'labels',minWidth:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.artefact.version.shortLabel'),dataIndex:'Version',widthToContent:true,withValuesFilter:true},{title:t('data.dataflow.hasTranscoding.shortLabel'),dataIndex:'HasTranscoding',width:30,withValuesFilter:true,render:function render(hasTranscoding){return hasTranscoding?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'check'}):null;},renderText:function renderText(hasTranscoding){return hasTranscoding?t('data.dataflow.hasTranscoding.values.true'):t('data.dataflow.hasTranscoding.values.false');}},{title:t('data.dataflow.hasContentConstraint.shortLabel'),dataIndex:'HasContentConstraints',width:30,withValuesFilter:true,render:function render(hasContentConstraints){return hasContentConstraints?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'check'}):null;},renderText:function renderText(hasContentConstraints){return hasContentConstraints?t('data.dataflow.hasContentConstraints.values.true'):t('data.dataflow.hasContentConstraints.values.false');}},{title:t('data.dataflow.isProduction.shortLabel'),dataIndex:'isProduction',width:30,withValuesFilter:true,render:function render(isProduction){return isProduction?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'check'}):null;},renderText:function renderText(isProduction){return isProduction?t('data.dataflow.isProduction.values.true'):t('data.dataflow.isProduction.values.false');}}],multilangStrDataIndexes:['labels'],actions:[productionAction,detailAction].concat(actions),altActions:[productionAction,detailAction,function(){if(nodes.filter(function(node){return node.general.id===nodeId;})[0].dataBrowser.dataBrowserUrl){return Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["j" /* BUTTON_DATA_EXPLORER */],{title:t('scenes.dataManager.dataflowBuilder.list.actions.dataBrowserPreview'),onClick:function onClick(_ref11){var ID=_ref11.ID,Agency=_ref11.Agency,Version=_ref11.Version;return onOpenNewTab(nodes.filter(function(node){return node.general.id===nodeId;})[0].dataBrowser.dataBrowserUrl+"/#/en/"+nodes.filter(function(node){return node.general.id===nodeId;})[0].dataBrowser.nodeID.toLowerCase()+"/"+encodeURI(Agency)+","+encodeURI(ID)+","+encodeURI(Version));}});}else{return null;}}].concat(actions),fixedActions:[function(_ref12){var annotations=_ref12.annotations;var customAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_33__utils_annotations__["r" /* countCustomAnnotations */])(annotations,customAnnotationsConfig);return customAnnotationsCount>0&&onAnnotationsShow?Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["g" /* BUTTON_CUSTOM_ANNOTATIONS */],{title:t('commons.actions.customAnnotations.title')+": "+customAnnotationsCount,onClick:function onClick(){return onAnnotationsShow(annotations);}}):null;}].concat(username&&onLayoutAnnotationsShow?function(_ref13){var annotations=_ref13.annotations;var layoutAnnotationsCount=Object(__WEBPACK_IMPORTED_MODULE_33__utils_annotations__["s" /* countLayoutAnnotations */])(annotations,annotationsConfig);return layoutAnnotationsCount>0?Object.assign({},__WEBPACK_IMPORTED_MODULE_26__styles_buttons__["u" /* BUTTON_LAYOUT_ANNOTATIONS */],{title:t('commons.actions.layoutAnnotations.title')+": "+layoutAnnotationsCount,onClick:function onClick(){return onLayoutAnnotationsShow(annotations);}}):null;}:[]),rightActions:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'end',gutter:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onCategorisationsShow},t('scenes.dataManager.dataflowBuilder.categorisationsShowButton')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__tree__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onWizardShow,type:'primary',icon:'plus'},t('scenes.dataManager.dataflowBuilder.wizardShowButton')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__wizard__["a" /* default */],null)))}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:fetchDataflow,cbParam:dataflowId,disabled:dataflowId===null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_enhanced_modal__["a" /* default */],{visible:dataflowId!==null,onCancel:onDataflowPreviewHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onDataflowPreviewHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_20__styles_constants__["MODAL_WIDTH_LG"],title:t('scenes.dataManager.dataflowBuilder.list.previewModal.title',{id:dataflows&&dataflowId?dataflows.find(function(_ref14){var IDDataflow=_ref14.IDDataflow;return IDDataflow===dataflowId;}).ID:""})},dataflow!==null&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__components_infinite_scroll_data_table__["a" /* default */],{data:dataflowPreview&&dataflowPreview.Data,cols:dataflowPreview&&dataflowPreview.Columns,rowTotal:dataflowPreview&&dataflowPreview.Count,onChange:function onChange(_ref15){var pageNum=_ref15.pageNum,pageSize=_ref15.pageSize,searchText=_ref15.searchText,filters=_ref15.filters,sortCol=_ref15.sortCol,sortByDesc=_ref15.sortByDesc;return fetchDataflowPreview(dataflow!==null?dataflow.IDCube:null,dataflow!==null?dataflow.DataflowColumns:null,Object(__WEBPACK_IMPORTED_MODULE_24__utils_filter__["e" /* getFilterStrFromViewerObj */])(dataflowPreview&&dataflowPreview.Columns.filter(function(colName){return colName!=='_OBS_VALUE';}),searchText,filters,""),pageNum,pageSize,sortCol?[sortCol]:null,sortByDesc,dataflowId);}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__DataflowProductionModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__DataflowDownload__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_custom_annotation_list__["a" /* default */],{annotations:dataflowAnnotations,onClose:onAnnotationsHide}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_layout_annotation_list__["a" /* default */],{annotations:dataflowLayoutAnnotations,onClose:onLayoutAnnotationsHide}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DataflowBuilderList));

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__reducer__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_artefact_list__ = __webpack_require__(50);
var labelStyle={fontSize:14,fontWeight:500,color:"rgba(0,0,0,0.85)"};var disabledLabelStyle={fontSize:14,fontWeight:500,color:"rgba(0,0,0,0.35)"};var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,dataflows:state.scenes.dataManager.dataflowBuilder.shared.dataflows,dataflowProductionModalDDBDataflowId:state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalDDBDataflowId,dataflowProductionModalDataflowTriplet:state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalDataflowTriplet,dataflowProductionModalMappingSetId:state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalMappingSetId,dataflowProductionModalTranscodingMode:state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalTranscodingMode,dataflowProductionModalTranscodingContentConstraintTriplet:state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalTranscodingContentConstraintTriplet,isDataflowProductionModalTranscodingContentConstraintListVisible:state.scenes.dataManager.dataflowBuilder.components.list.isDataflowProductionModalTranscodingContentConstraintListVisible,dataflowProductionModalTranscodingContentConstraints:state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalTranscodingContentConstraints};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMappingSetCreate:function onMappingSetCreate(ddbDataflowId,defaultValue){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_58" /* setDataflowBuilderListDataflowMappingSet */])(ddbDataflowId,defaultValue));},onMappingSetDelete:function onMappingSetDelete(ddbDataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_76" /* unsetDataflowBuilderListDataflowMappingSet */])(ddbDataflowId));},onTranscodingModeChange:function onTranscodingModeChange(mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_22" /* changeDataflowBuilderListDataflowTranscodingMode */])(mode));},onTranscodingFromCCContentConstraintSet:function onTranscodingFromCCContentConstraintSet(contentConstraintTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_62" /* setDataflowBuilderListDataflowTranscodingFromCCContentConstraint */])(contentConstraintTriplet));},onTranscodingFromCCContentConstraintUnset:function onTranscodingFromCCContentConstraintUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_78" /* unsetDataflowBuilderListDataflowTranscodingFromCCContentConstraint */])());},onTranscodingCreate:function onTranscodingCreate(ddbDataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_60" /* setDataflowBuilderListDataflowTranscoding */])(ddbDataflowId));},onTranscodingFromCCCreate:function onTranscodingFromCCCreate(ddbDataflowId,contentConstraintTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_61" /* setDataflowBuilderListDataflowTranscodingFromCC */])(ddbDataflowId,contentConstraintTriplet));},onTranscodingFromCCListShow:function onTranscodingFromCCListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_72" /* showDataflowBuilderListDataflowTranscodingFromCCList */])());},onTranscodingFromCCListHide:function onTranscodingFromCCListHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_39" /* hideDataflowBuilderListDataflowTranscodingFromCCList */])());},onTranscodingDelete:function onTranscodingDelete(ddbDataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_77" /* unsetDataflowBuilderListDataflowTranscoding */])(ddbDataflowId));},onContentConstraintCreate:function onContentConstraintCreate(ddbDataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_56" /* setDataflowBuilderListDataflowContentConstraint */])(ddbDataflowId));},onContentConstraintDelete:function onContentConstraintDelete(ddbDataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_74" /* unsetDataflowBuilderListDataflowContentConstraint */])(ddbDataflowId));},onSetProductionFlag:function onSetProductionFlag(ddbDataflowId,isProduction){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_59" /* setDataflowBuilderListDataflowProductionFlag */])(ddbDataflowId,isProduction));},onForceCacheUpdate:function onForceCacheUpdate(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_29" /* forceDataflowBuilderListDataflowCacheUpdate */])(dataflowTriplet));},onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_38" /* hideDataflowBuilderListDataflowProductionModal */])());},fetchDataflowMappingSetId:function fetchDataflowMappingSetId(ddbDataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_53" /* readDataflowBuilderListonDataflowMappingSetId */])(ddbDataflowId));},fetchTranscodingFromCCList:function fetchTranscodingFromCCList(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_51" /* readDataflowBuilderListDataflowTranscodingFromCCList */])(dataflowTriplet));}};};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_TWO_THIRDS"]}};var CreateMappingSetForm=__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create()(function(_ref){var form=_ref.form,t=_ref.t,modal=_ref.modal,onMappingSetCreate=_ref.onMappingSetCreate;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"],marginTop:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({},formItemLayout,{label:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.confirm.defaultValue.label")}),form.getFieldDecorator('defaultValue')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,null))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",style:{marginTop:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]},justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:function onClick(){return modal.destroy();}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.confirm.cancelButton.title"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){modal.destroy();onMappingSetCreate(form.getFieldValue('defaultValue'));}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.confirm.okButton.title")))));});var DataflowBuilderListDataflowProductionModal=function DataflowBuilderListDataflowProductionModal(_ref2){var t=_ref2.t,endpoints=_ref2.endpoints,endpointId=_ref2.endpointId,dataflows=_ref2.dataflows,dataflowProductionModalDDBDataflowId=_ref2.dataflowProductionModalDDBDataflowId,dataflowProductionModalDataflowTriplet=_ref2.dataflowProductionModalDataflowTriplet,dataflowProductionModalMappingSetId=_ref2.dataflowProductionModalMappingSetId,_onMappingSetCreate=_ref2.onMappingSetCreate,onMappingSetDelete=_ref2.onMappingSetDelete,dataflowProductionModalTranscodingMode=_ref2.dataflowProductionModalTranscodingMode,dataflowProductionModalTranscodingContentConstraintTriplet=_ref2.dataflowProductionModalTranscodingContentConstraintTriplet,isDataflowProductionModalTranscodingContentConstraintListVisible=_ref2.isDataflowProductionModalTranscodingContentConstraintListVisible,onTranscodingModeChange=_ref2.onTranscodingModeChange,onTranscodingFromCCListShow=_ref2.onTranscodingFromCCListShow,onTranscodingFromCCListHide=_ref2.onTranscodingFromCCListHide,dataflowProductionModalTranscodingContentConstraints=_ref2.dataflowProductionModalTranscodingContentConstraints,onTranscodingFromCCContentConstraintSet=_ref2.onTranscodingFromCCContentConstraintSet,onTranscodingFromCCContentConstraintUnset=_ref2.onTranscodingFromCCContentConstraintUnset,onTranscodingFromCCCreate=_ref2.onTranscodingFromCCCreate,onTranscodingCreate=_ref2.onTranscodingCreate,onTranscodingDelete=_ref2.onTranscodingDelete,onContentConstraintCreate=_ref2.onContentConstraintCreate,onContentConstraintDelete=_ref2.onContentConstraintDelete,onSetProductionFlag=_ref2.onSetProductionFlag,onForceCacheUpdate=_ref2.onForceCacheUpdate,onHide=_ref2.onHide,fetchDataflowMappingSetId=_ref2.fetchDataflowMappingSetId,fetchTranscodingFromCCList=_ref2.fetchTranscodingFromCCList;var dataflowProductionModalDataflow=dataflows&&dataflowProductionModalDDBDataflowId?dataflows.filter(function(df){return df.IDDataflow===dataflowProductionModalDDBDataflowId;})[0]:null;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchDataflowMappingSetId,cbParam:dataflowProductionModalDataflow!==null?dataflowProductionModalDataflow.IDDataflow:null,disabled:dataflowProductionModalDataflow===null},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_enhanced_modal__["a" /* default */],{visible:dataflowProductionModalDDBDataflowId!==null,onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:onHide},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.close.title")),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_MD"],title:t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.title',{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""})},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{justify:"space-between",type:"flex",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{style:labelStyle},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.label")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_SM"],justify:"end",type:"flex"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{disabled:dataflowProductionModalMappingSetId===undefined||dataflowProductionModalDataflow===null||dataflowProductionModalMappingSetId!==null,size:"small",type:"primary",onClick:function onClick(){var modal=__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm();modal.update({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),content:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(CreateMappingSetForm,{t:t,modal:modal,onMappingSetCreate:function onMappingSetCreate(defaultValue){return _onMappingSetCreate(dataflowProductionModalDataflow.IDDataflow,defaultValue);}}),okButtonProps:{style:{display:'none'}},cancelButtonProps:{style:{display:'none'}}});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.title"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{disabled:dataflowProductionModalDataflow===null||dataflowProductionModalMappingSetId===null||dataflowProductionModalMappingSetId===undefined,size:"small",type:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.deleteButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),onOk:function onOk(){onMappingSetDelete(dataflowProductionModalDataflow.IDDataflow);},cancelText:t('commons.buttons.cancel.title')});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.deleteButton.title")))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{style:dataflowProductionModalMappingSetId!==null?labelStyle:disabledLabelStyle},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.label"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{justify:"space-between",type:"flex"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_SM"],type:"flex"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Group,{value:dataflowProductionModalTranscodingMode,onChange:function onChange(_ref3){var target=_ref3.target;return onTranscodingModeChange(target.value);},size:"small",disabled:dataflowProductionModalMappingSetId===null||dataflowProductionModalMappingSetId===undefined||dataflowProductionModalDataflow&&dataflowProductionModalDataflow.HasTranscoding},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_24__reducer__["a" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO */]},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.transcodingRadio.auto.title")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_24__reducer__["b" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC */]},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.transcodingRadio.fromContentConstraint.title")))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,dataflowProductionModalTranscodingMode===__WEBPACK_IMPORTED_MODULE_24__reducer__["b" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC */]&&dataflowProductionModalMappingSetId!==null&&dataflowProductionModalMappingSetId!==undefined&&dataflowProductionModalDataflow&&!dataflowProductionModalDataflow.HasTranscoding&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_selector__["a" /* default */],{selectTitle:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.transcodingCCSelector.select.title"),resetTitle:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.transcodingCCSelector.reset.title"),onSelect:onTranscodingFromCCListShow,onReset:onTranscodingFromCCContentConstraintUnset,value:dataflowProductionModalTranscodingContentConstraintTriplet?Object(__WEBPACK_IMPORTED_MODULE_26__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dataflowProductionModalTranscodingContentConstraintTriplet):null,size:"small"},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.selectButton.title")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_enhanced_modal__["a" /* default */],{visible:isDataflowProductionModalTranscodingContentConstraintListVisible,title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcodingContentConstraintList.title"),onCancel:onTranscodingFromCCListHide,footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:onTranscodingFromCCListHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_LG"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchTranscodingFromCCList,cbParam:dataflowProductionModalDataflowTriplet,disabled:!isDataflowProductionModalTranscodingContentConstraintListVisible},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_artefact_list__["a" /* default */],{artefacts:dataflowProductionModalTranscodingContentConstraints,onRowClick:function onRowClick(_ref4){var id=_ref4.id,agencyID=_ref4.agencyID,version=_ref4.version;return onTranscodingFromCCContentConstraintSet({id:id,agencyID:agencyID,version:version});}}))))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_SM"],type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{disabled:dataflowProductionModalDataflow===null||dataflowProductionModalMappingSetId===null||dataflowProductionModalMappingSetId===undefined||dataflowProductionModalDataflow.HasTranscoding||dataflowProductionModalTranscodingMode===__WEBPACK_IMPORTED_MODULE_24__reducer__["b" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC */]&&dataflowProductionModalTranscodingContentConstraintTriplet===null,size:"small",type:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.createButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),onOk:function onOk(){if(dataflowProductionModalTranscodingMode===__WEBPACK_IMPORTED_MODULE_24__reducer__["a" /* DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO */]){onTranscodingCreate(dataflowProductionModalDataflow.IDDataflow);}else{onTranscodingFromCCCreate(dataflowProductionModalDataflow.IDDataflow,dataflowProductionModalTranscodingContentConstraintTriplet);}},cancelText:t('commons.buttons.cancel.title')});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.createButton.title"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{disabled:dataflowProductionModalDataflow===null||dataflowProductionModalMappingSetId===null||dataflowProductionModalMappingSetId===undefined||!dataflowProductionModalDataflow.HasTranscoding,size:"small",type:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.deleteButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),onOk:function onOk(){onTranscodingDelete(dataflowProductionModalDataflow.IDDataflow);},cancelText:t('commons.buttons.cancel.title')});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.deleteButton.title")))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],justify:"space-between",type:"flex"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{style:dataflowProductionModalDataflow!==null&&dataflowProductionModalMappingSetId!==null&&dataflowProductionModalDataflow.HasTranscoding?labelStyle:disabledLabelStyle},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.label")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_SM"],justify:"end",type:"flex"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{disabled:dataflowProductionModalDataflow===null||dataflowProductionModalMappingSetId===undefined||dataflowProductionModalMappingSetId===null||!dataflowProductionModalDataflow.HasTranscoding||dataflowProductionModalDataflow.HasContentConstraints,size:"small",type:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.createButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),onOk:function onOk(){onContentConstraintCreate(dataflowProductionModalDataflow.IDDataflow);},cancelText:t('commons.buttons.cancel.title')});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.createButton.title"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{disabled:dataflowProductionModalDataflow===null||dataflowProductionModalMappingSetId===undefined||dataflowProductionModalMappingSetId===null||!dataflowProductionModalDataflow.HasTranscoding||!dataflowProductionModalDataflow.HasContentConstraints,size:"small",type:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.deleteButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),onOk:function onOk(){onContentConstraintDelete(dataflowProductionModalDataflow.IDDataflow);},cancelText:t('commons.buttons.cancel.title')});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.deleteButton.title")))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],justify:"space-between",type:"flex"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{style:dataflowProductionModalDataflow!==null&&(dataflowProductionModalMappingSetId!==null||dataflowProductionModalDataflow.HasTranscoding||dataflowProductionModalDataflow.hasContentConstraint)?labelStyle:disabledLabelStyle},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.label")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_SM"],justify:"end",type:"flex"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{disabled:dataflowProductionModalDataflow===null||dataflowProductionModalMappingSetId===undefined||dataflowProductionModalMappingSetId===null&&!dataflowProductionModalDataflow.HasTranscoding&&!dataflowProductionModalDataflow.hasContentConstraint||dataflowProductionModalDataflow.isProduction,size:"small",type:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.publishButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),onOk:function onOk(){onSetProductionFlag(dataflowProductionModalDataflow.IDDataflow,false);},cancelText:t('commons.buttons.cancel.title')});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.publishButton.title"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{disabled:dataflowProductionModalDataflow===null||dataflowProductionModalMappingSetId===undefined||dataflowProductionModalMappingSetId===null&&!dataflowProductionModalDataflow.HasTranscoding&&!dataflowProductionModalDataflow.hasContentConstraint||!dataflowProductionModalDataflow.isProduction,size:"small",type:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.removeButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),onOk:function onOk(){onSetProductionFlag(dataflowProductionModalDataflow.IDDataflow,true);},cancelText:t('commons.buttons.cancel.title')});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.removeButton.title")))))),(endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).dataBrowser||{}).enable&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],justify:"space-between",type:"flex"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{style:labelStyle},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.label")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{size:"small",type:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.forceCacheUpdateButton.confirm.title",{id:dataflowProductionModalDataflow?dataflowProductionModalDataflow.ID:""}),onOk:function onOk(){onForceCacheUpdate(dataflowProductionModalDataflowTriplet);},cancelText:t('commons.buttons.cancel.title')});}},t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.forceCacheUpdateButton.title"))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),Object(__WEBPACK_IMPORTED_MODULE_22_react_i18next__["b" /* translate */])())(DataflowBuilderListDataflowProductionModal));

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DataflowDownloadQueryForm__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_infinite_scroll_data_table__ = __webpack_require__(74);
var mapStateToProps=function mapStateToProps(state){return{dataflows:state.scenes.dataManager.dataflowBuilder.shared.dataflows,dataLanguages:state.config.dataManagement.dataLanguages,dlDataflowId:state.scenes.dataManager.dataflowBuilder.components.list.dlDataflowId,cubeId:state.scenes.dataManager.dataflowBuilder.components.list.cubeId,dlDataflowParams:state.scenes.dataManager.dataflowBuilder.components.list.dlDataflowParams,dlDataflowTriplet:state.scenes.dataManager.dataflowBuilder.components.list.dlDataflowTriplet,dlIsPreviewVisible:state.scenes.dataManager.dataflowBuilder.components.list.dlIsPreviewVisible,dlRows:state.scenes.dataManager.dataflowBuilder.components.list.dlRows,dlCols:state.scenes.dataManager.dataflowBuilder.components.list.dlCols,dlCheckedCols:state.scenes.dataManager.dataflowBuilder.components.list.dlCheckedCols,dlDsdTriplet:state.scenes.dataManager.dataflowBuilder.components.list.dlDsdTriplet,dlDsdDimensions:state.scenes.dataManager.dataflowBuilder.components.list.dlDsdDimensions};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_31" /* hideDataflowBuilderListDataflowDownload */])());},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_15" /* changeDataflowBuilderListDataflowDownload */])(fields));},onDownload:function onDownload(ddbdataflowId,dataflowtriplet,dataflowDownloadParams,dlCols,cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_27" /* downloadDataflowBuilderListDataflow */])(ddbdataflowId,dataflowtriplet,dataflowDownloadParams,dlCols,cubeId));},fetchCubeAndDdbDataflow:function fetchCubeAndDdbDataflow(cubeId,dataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_41" /* readDataflowBuilderListDataflowDownloadCubeAndDdBDataflow */])(cubeId,dataflowId));},onDownloadQueryShow:function onDownloadQueryShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_68" /* showDataflowBuilderListDataflowDownloadQuery */])());},onPreviewShow:function onPreviewShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_67" /* showDataflowBuilderListDataflowDownloadPreview */])());},onPreviewHide:function onPreviewHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_34" /* hideDataflowBuilderListDataflowDownloadPreview */])());},fetchPreview:function fetchPreview(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc,dataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_48" /* readDataflowBuilderListDataflowDownloadPreview */])(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc,dataflowId));},fetchDownloadDsd:function fetchDownloadDsd(triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_49" /* readDataflowBuilderListDataflowDsdDataflow */])(triplet));}};};var getOrderCheckedCols=function getOrderCheckedCols(cols,checkedCols){var ret=[];cols&&checkedCols&&cols.map(function(col){return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.findIndex(checkedCols,function(checkedCol){return checkedCol===col;})!==-1?ret.push(col):null;});return ret;};var DataflowDownload=function DataflowDownload(_ref){var t=_ref.t,dataLanguages=_ref.dataLanguages,dataflows=_ref.dataflows,dlDataflowId=_ref.dlDataflowId,cubeId=_ref.cubeId,dlDataflowParams=_ref.dlDataflowParams,dlDsdTriplet=_ref.dlDsdTriplet,dlDsdDimensions=_ref.dlDsdDimensions,dlDataflowTriplet=_ref.dlDataflowTriplet,dlIsPreviewVisible=_ref.dlIsPreviewVisible,dlRows=_ref.dlRows,dlCols=_ref.dlCols,dlCheckedCols=_ref.dlCheckedCols,onDownloadHide=_ref.onDownloadHide,onDownloadChange=_ref.onDownloadChange,fetchCubeAndDdbDataflow=_ref.fetchCubeAndDdbDataflow,onDownloadQueryShow=_ref.onDownloadQueryShow,onDownload=_ref.onDownload,onPreviewShow=_ref.onPreviewShow,onPreviewHide=_ref.onPreviewHide,fetchPreview=_ref.fetchPreview,fetchDownloadDsd=_ref.fetchDownloadDsd;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_enhanced_modal__["a" /* default */],{visible:dlDataflowId!==null,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return onDownload(dlDataflowId,dlDataflowTriplet,dlDataflowParams,dlCols,cubeId);},type:"primary",disabled:dlDataflowParams&&dlDataflowParams.format===null||dlDataflowParams&&dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_7__constants_download__["o" /* DOWNLOAD_FORMAT_TYPE_CSV_CUSTOM */]&&(dlDataflowParams.csvSeparator===null||dlDataflowParams.csvSeparator.length!==1||dlDataflowParams.selCols===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MODAL_WIDTH_SM"],title:t('scenes.dataManager.dataflowBuilder.dataflowDownload.modals.download.title',{id:dataflows&&dlDataflowId?dataflows.find(function(_ref2){var IDDataflow=_ref2.IDDataflow;return IDDataflow===dlDataflowId;}).ID:""})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__hocs_call__["a" /* default */],{cb:fetchDownloadDsd,cbParam:dlDsdTriplet,disabled:!(dlDataflowParams&&(dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_7__constants_download__["t" /* DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC */]||dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_7__constants_download__["r" /* DOWNLOAD_FORMAT_TYPE_JSON */])&&dlDsdDimensions===null)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:dlDataflowParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_7__constants_download__["v" /* getArtefactDownloadOptions */])(t,__WEBPACK_IMPORTED_MODULE_7__constants_download__["g" /* ARTEFACT_TYPE_DDBDATAFLOW */]),langs:dataLanguages,queryFormRead:function queryFormRead(){return fetchCubeAndDdbDataflow(cubeId,dlDataflowId);},queryFormShow:onDownloadQueryShow,queryPreviewShow:onPreviewShow,isQuerySet:dlDataflowParams&&dlDataflowParams.selCols!==null,isQueryPreviewShowDisabled:dlDataflowParams&&dlDataflowParams.selCols===null,dimensions:dlDsdDimensions,sdmxFilters:true}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DataflowDownloadQueryForm__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_enhanced_modal__["a" /* default */],{visible:dlIsPreviewVisible,onCancel:onPreviewHide,footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onPreviewHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MODAL_WIDTH_LG"],title:t('scenes.dataManager.dataflowBuilder.dataflowDownload.modals.preview.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_infinite_scroll_data_table__["a" /* default */],{data:dlRows&&dlRows.Data,cols:dlRows&&dlRows.Columns,rowTotal:dlRows&&dlRows.Count,onChange:function onChange(_ref3){var pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,searchText=_ref3.searchText,filters=_ref3.filters,sortCol=_ref3.sortCol,sortByDesc=_ref3.sortByDesc;fetchPreview(cubeId,getOrderCheckedCols(dlCols,dlCheckedCols),Object(__WEBPACK_IMPORTED_MODULE_12__utils_filter__["e" /* getFilterStrFromViewerObj */])(dlRows&&dlRows.Columns.filter(function(colName){return colName!=='_OBS_VALUE';}),searchText,filters,dlDataflowParams.filter),pageNum,pageSize,sortCol?[sortCol]:null,sortByDesc,dlDataflowId);}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),Object(__WEBPACK_IMPORTED_MODULE_5_react_i18next__["b" /* translate */])())(DataflowDownload));

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_draggable_check_list__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_css__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_query_form_filter__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__constants_download__ = __webpack_require__(55);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,dlIsDataflowQueryVisible:state.scenes.dataManager.dataflowBuilder.components.list.dlIsDataflowQueryVisible,dlDataflowId:state.scenes.dataManager.dataflowBuilder.components.list.dlDataflowId,dlDataflow:state.scenes.dataManager.dataflowBuilder.components.list.dlDataflow,dlDataflowParams:state.scenes.dataManager.dataflowBuilder.components.list.dlDataflowParams,cube:state.scenes.dataManager.dataflowBuilder.components.list.cube,cubeId:state.scenes.dataManager.dataflowBuilder.components.list.cubeId,dlCols:state.scenes.dataManager.dataflowBuilder.components.list.dlCols,dlCheckedCols:state.scenes.dataManager.dataflowBuilder.components.list.dlCheckedCols,isFilterModalVisible:state.scenes.dataManager.dataflowBuilder.components.list.isCubeDownloadFilterModalVisible,filter:state.scenes.dataManager.dataflowBuilder.components.list.filter,filterTemp:state.scenes.dataManager.dataflowBuilder.components.list.filterTemp,treeFilter:state.scenes.dataManager.dataflowBuilder.components.list.treeFilter,treeFilterTemp:state.scenes.dataManager.dataflowBuilder.components.list.treeFilterTemp,filterMode:state.scenes.dataManager.dataflowBuilder.components.list.filterMode,filterRows:state.scenes.dataManager.dataflowBuilder.components.list.filterRows,isRowsModalVisible:state.scenes.dataManager.dataflowBuilder.components.list.isRowsModalVisible};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDownloadQueryHide:function onDownloadQueryHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_35" /* hideDataflowBuilderListDataflowDownloadQuery */])());},onDownloadQuerySet:function onDownloadQuerySet(cols,filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_57" /* setDataflowBuilderListDataflowDownloadQuery */])(cols,filter));},onDownloadQueryUnset:function onDownloadQueryUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_75" /* unsetDataflowBuilderListDataflowDownloadQuery */])());},onBlockAdd:function onBlockAdd(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_13" /* addDataflowBuilderListDataflowDownloadFilterFormBlock */])());},onBlockDelete:function onBlockDelete(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_25" /* deleteDataflowBuilderListDataflowDownloadFilterFormBlock */])(blockIndex));},onConditionAdd:function onConditionAdd(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_14" /* addDataflowBuilderListDataflowDownloadFilterFormCondition */])(blockIndex));},onConditionDelete:function onConditionDelete(blockIndex,conditionIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_26" /* deleteDataflowBuilderListDataflowDownloadFilterFormCondition */])(blockIndex,conditionIndex));},onPreviewShow:function onPreviewShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_67" /* showDataflowBuilderListDataflowDownloadPreview */])());},onColumnsCheck:function onColumnsCheck(cols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_23" /* checkDataflowBuilderListDataflowDownloadColumns */])(cols));},onColumnsChange:function onColumnsChange(cols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_16" /* changeDataflowBuilderListDataflowDownloadColumns */])(cols));},onFilterModalShow:function onFilterModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_65" /* showDataflowBuilderListDataflowDownloadFilterModal */])());},onFilterModalHide:function onFilterModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_32" /* hideDataflowBuilderListDataflowDownloadFilterModal */])());},onFilterModalSubmit:function onFilterModalSubmit(filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_73" /* submitDataflowBuilderListDataflowDownloadFilterModal */])(filter));},onColumnModeChange:function onColumnModeChange(colName,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_20" /* changeDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnMode */])(colName,mode));},onFilterModeChange:function onFilterModeChange(filterMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_18" /* changeDataflowBuilderListDataflowDownloadFilterModalFilterMode */])(filterMode));},onFilterReset:function onFilterReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_55" /* resetDataflowBuilderListDataflowDownloadFilterModalFilter */])());},onFilterChange:function onFilterChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_17" /* changeDataflowBuilderListDataflowDownloadFilter */])(fields));},onTreeFilterChange:function onTreeFilterChange(treeFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_19" /* changeDataflowBuilderListDataflowDownloadFilterModalTreeFilter */])(treeFilter));},fetchColumnCodelistCount:function fetchColumnCodelistCount(_ref){var codelistTriplet=_ref.codelistTriplet,language=_ref.language;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_44" /* readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnCodelistCount */])(codelistTriplet,language));},fetchColumnCodelistTree:function fetchColumnCodelistTree(_ref2){var codelistTriplet=_ref2.codelistTriplet,language=_ref2.language,itemsOrderAnnotationType=_ref2.itemsOrderAnnotationType;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_45" /* readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnCodelistTree */])(codelistTriplet,language,itemsOrderAnnotationType));},fetchColumnFilteredValues:function fetchColumnFilteredValues(cubeId,colNames,filter,dataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_46" /* readDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnFilteredValues */])(cubeId,colNames,filter,dataflowId));},onColumnValuesChange:function onColumnValuesChange(colName,values){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_21" /* changeDataflowBuilderListDataflowDownloadFilterModalTreeFilterColumnValues */])(colName,values));},onRowsModalShow:function onRowsModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_66" /* showDataflowBuilderListDataflowDownloadFilterRowsModal */])());},onRowsModalHide:function onRowsModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_33" /* hideDataflowBuilderListDataflowDownloadFilterRowsModal */])());},fetchRows:function fetchRows(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc,dataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_47" /* readDataflowBuilderListDataflowDownloadFilterRows */])(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc,dataflowId));},fetchColumnValues:function fetchColumnValues(cubeId,columnName,viewerObj,dataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_43" /* readDataflowBuilderListDataflowDownloadFilterFormColumnValue */])(cubeId,columnName,viewerObj,dataflowId));},resetColumnValues:function resetColumnValues(columnName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_54" /* resetDataflowBuilderListDataflowDownloadFilterFormColumnValue */])(columnName));},fetchColumnCodes:function fetchColumnCodes(columnName,codelistCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_42" /* readDataflowBuilderListDataflowDownloadFilterFormColumnCodes */])(columnName,codelistCode));}};};var cardStyle={type:'inner',headStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["PADDING_MD"]},bodyStyle:{paddingLeft:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["PADDING_MD"],height:480,overflow:'auto'}};var _onDrop=function _onDrop(ev,cols){var array=__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.cloneDeep(cols);var pos=ev.node.props.pos.split('-');var dropPos=ev.dropPosition-Number(pos[pos.length-1]);var from=array.indexOf(ev.dragNode.props.eventKey);var to=array.indexOf(ev.node.props.eventKey);to=from<to?dropPos<0// moving forward into the array
?to-1// dropPos = -1 => drag on top node gap
:to// dropPos = 1 => drag on bottom node gap
:dropPos<0// moving backwards into the array
?to// dropPos = -1 => drag on top node gap
:to+1;// dropPos = 1 => drag on bottom node gap
if(to===-1){to=0;}if(to===array.length+1){to=array.length;}array.splice(to,0,array.splice(from,1)[0]);return array;};var DataflowDownloadQueryForm=function DataflowDownloadQueryForm(_ref3){var t=_ref3.t,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,dlIsDataflowQueryVisible=_ref3.dlIsDataflowQueryVisible,dlDataflowId=_ref3.dlDataflowId,dlDataflow=_ref3.dlDataflow,dlDataflowParams=_ref3.dlDataflowParams,cube=_ref3.cube,cubeId=_ref3.cubeId,isFilterModalVisible=_ref3.isFilterModalVisible,onFilterModalShow=_ref3.onFilterModalShow,onFilterModalHide=_ref3.onFilterModalHide,filter=_ref3.filter,filterTemp=_ref3.filterTemp,treeFilter=_ref3.treeFilter,treeFilterTemp=_ref3.treeFilterTemp,onFilterModalSubmit=_ref3.onFilterModalSubmit,onColumnModeChange=_ref3.onColumnModeChange,onFilterModeChange=_ref3.onFilterModeChange,filterMode=_ref3.filterMode,onFilterReset=_ref3.onFilterReset,onFilterChange=_ref3.onFilterChange,onTreeFilterChange=_ref3.onTreeFilterChange,onColumnValuesChange=_ref3.onColumnValuesChange,fetchColumnCodelistCount=_ref3.fetchColumnCodelistCount,fetchColumnCodelistTree=_ref3.fetchColumnCodelistTree,_fetchColumnFilteredValues=_ref3.fetchColumnFilteredValues,dlCols=_ref3.dlCols,dlCheckedCols=_ref3.dlCheckedCols,onDownloadQueryHide=_ref3.onDownloadQueryHide,onDownloadQuerySet=_ref3.onDownloadQuerySet,onDownloadQueryUnset=_ref3.onDownloadQueryUnset,onBlockAdd=_ref3.onBlockAdd,onBlockDelete=_ref3.onBlockDelete,onConditionAdd=_ref3.onConditionAdd,onConditionDelete=_ref3.onConditionDelete,_fetchColumnValues=_ref3.fetchColumnValues,onColumnsCheck=_ref3.onColumnsCheck,onColumnsChange=_ref3.onColumnsChange,filterRows=_ref3.filterRows,isRowsModalVisible=_ref3.isRowsModalVisible,onRowsModalShow=_ref3.onRowsModalShow,onRowsModalHide=_ref3.onRowsModalHide,_fetchRows=_ref3.fetchRows,resetColumnValues=_ref3.resetColumnValues,fetchColumnCodes=_ref3.fetchColumnCodes;var findIcon=function findIcon(label){if(cube&&cube.columns&&cube.columns.dimensions&&!__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.isEmpty(cube.columns.dimensions.filter(function(col){return label===col.ColName;}))){return"bar-chart";}else if(cube&&cube.columns&&cube.columns.timeDimensions&&!__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.isEmpty(cube.columns.timeDimensions.filter(function(col){return label===col.ColName;}))){return"clock-circle";}else if(cube&&cube.columns&&cube.columns.tidAttributes&&!__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.isEmpty(cube.columns.tidAttributes.filter(function(col){return label===col.ColName;}))){return"flag";}else if(cube&&cube.columns&&cube.columns.attributes&&!__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.isEmpty(cube.columns.attributes.filter(function(col){return label===col.ColName;}))){return"profile";}else if(cube&&cube.columns&&cube.columns.measures&&!__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.isEmpty(cube.columns.measures.filter(function(col){return label===col.ColName;}))){return"line-chart";}else{return"";}};var isSdmxFilters=dlDataflowParams&&(dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_24__constants_download__["p" /* DOWNLOAD_FORMAT_TYPE_GENERIC */]||dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_24__constants_download__["t" /* DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC */]||dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_24__constants_download__["q" /* DOWNLOAD_FORMAT_TYPE_GENERIC20 */]||dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_24__constants_download__["m" /* DOWNLOAD_FORMAT_TYPE_COMPACT */]||dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_24__constants_download__["s" /* DOWNLOAD_FORMAT_TYPE_SDMXCSV */]||dlDataflowParams.format===__WEBPACK_IMPORTED_MODULE_24__constants_download__["r" /* DOWNLOAD_FORMAT_TYPE_JSON */]);var cubeWithCheckedColsForFilter=cube?Object.assign({},cube,{columns:__WEBPACK_IMPORTED_MODULE_17_lodash___default()(cube.columns).pickBy(function(_,key){return!isSdmxFilters||key!=="attributes"&&key!=="tidAttributes";}).mapValues(function(cols){return cols.filter(function(col){return(dlCols||[]).includes(col.ColName);}).map(function(col){return Object.assign({},col,{checked:(dlCheckedCols||[]).includes(col.ColName)});});}).value()}):null;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_enhanced_modal__["a" /* default */],{visible:dlIsDataflowQueryVisible,width:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MODAL_WIDTH_XL"],title:t('scenes.dataManager.dataflowBuilder.dataflowDownload.modals.query.title'),onCancel:onDownloadQueryHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onDownloadQueryHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onDownloadQueryUnset},t('commons.buttons.unset.title')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){return onDownloadQuerySet(dlCheckedCols,filterMode===__WEBPACK_IMPORTED_MODULE_23__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]?treeFilter:filter);},disabled:dlCheckedCols&&dlCheckedCols.length===0},t('commons.buttons.set.title'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_ONE_THIRD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,Object.assign({title:t('scenes.dataManager.dataflowBuilder.dataflowDownload.modals.query.cards.columns.title')},cardStyle),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{disabled:true,value:dlDataflow!==null?'['+dlDataflow.ID+'] '+Object(__WEBPACK_IMPORTED_MODULE_15__middlewares_i18n_utils__["a" /* getLocalizedStr */])(dlDataflow.labels,lang,dataLanguages):null}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,{type:'inner',bodyStyle:{height:391,overflow:"auto"},style:{marginTop:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]}},dlCols&&dlCheckedCols&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'draggable-check-list-drag-over'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_draggable_check_list__["a" /* default */],{items:dlCols,getItemLabel:function getItemLabel(item){return item;},getItemIcon:function getItemIcon(item){return findIcon(item);},getItemKey:function getItemKey(item){return item;},checkedKeys:dlCheckedCols,onCheck:onColumnsCheck,onDrop:function onDrop(ev){return onColumnsChange(_onDrop(ev,dlCols));},disabled:isSdmxFilters}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_TWO_THIRDS"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,Object.assign({title:t('scenes.dataManager.dataflowBuilder.dataflowDownload.modals.query.cards.filter.title')},cardStyle),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_query_form_filter__["a" /* default */],{isFilterModalVisible:isFilterModalVisible,onFilterModalShow:onFilterModalShow,onFilterModalHide:onFilterModalHide,cubeId:cubeId,cube:cubeWithCheckedColsForFilter,filter:filter,filterTemp:filterTemp,treeFilter:treeFilter,treeFilterTemp:treeFilterTemp,dataLanguage:dataLanguage,fetchColumnValues:function fetchColumnValues(cubeId,columnName,viewerObj){return _fetchColumnValues(cubeId,columnName,viewerObj,dlDataflowId);},onBlockAdd:onBlockAdd,onBlockDelete:onBlockDelete,onConditionAdd:onConditionAdd,onConditionDelete:onConditionDelete,onFilterModalSubmit:onFilterModalSubmit,onColumnModeChange:onColumnModeChange,onFilterModeChange:onFilterModeChange,filterMode:filterMode,onFilterReset:onFilterReset,onFilterChange:onFilterChange,onTreeFilterChange:onTreeFilterChange,fetchColumnCodelistCount:fetchColumnCodelistCount,fetchColumnCodelistTree:fetchColumnCodelistTree,fetchColumnFilteredValues:function fetchColumnFilteredValues(cubeId,colNames,filter){return _fetchColumnFilteredValues(cubeId,colNames,filter,dlDataflowId);},onColumnValuesChange:onColumnValuesChange,cubeFirstRow:true,rows:filterRows,isRowsModalVisible:isRowsModalVisible,onRowsModalShow:onRowsModalShow,onRowsModalHide:onRowsModalHide,fetchRows:function fetchRows(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc){return _fetchRows(cubeId,isSdmxFilters?dlCols:cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc,dlDataflowId);},sdmxFilters:isSdmxFilters,resetColumnValues:resetColumnValues,fetchColumnCodes:fetchColumnCodes}))));}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DataflowDownloadQueryForm));

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_css__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__ = __webpack_require__(29);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,nodes:state.config.nodes,isVisible:state.scenes.dataManager.dataflowBuilder.components.tree.isVisible,dataflowTree:state.scenes.dataManager.dataflowBuilder.components.tree.dataflowTree};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* hideDataflowBuilderTree */])());},fetchDataflowTree:function fetchDataflowTree(lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* readDataflowBuilderTreeCategorisedDataflows */])(lang));}};};var DataflowBuilderTree=function DataflowBuilderTree(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,nodes=_ref.nodes,dataflowTree=_ref.dataflowTree,isVisible=_ref.isVisible,onHide=_ref.onHide,fetchDataflowTree=_ref.fetchDataflowTree;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_enhanced_modal__["a" /* default */],{title:t('scenes.dataManager.dataflowBuilder.categorisations.title'),visible:isVisible,onCancel:onHide,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__hocs_call__["a" /* default */],{cb:fetchDataflowTree,cbParam:lang,disabled:!(nodes&&nodes.length>0)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'dataflow-builder__categorisations__tree'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_enhanced_tree__["a" /* default */],{tree:dataflowTree,getNodeKey:function getNodeKey(node){return node.id!==__WEBPACK_IMPORTED_MODULE_11__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]?Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(node):__WEBPACK_IMPORTED_MODULE_11__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */];},childrenKey:'categories',idKey:'id',nameKey:'name',catIdKey:'id',catNameKey:'name',defaultCollapsed:true,unselectableKeys:[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_11__utils_tree__["l" /* getNodes */])(dataflowTree,'categories',function(){return true;}).filter(function(node){return node.id!==__WEBPACK_IMPORTED_MODULE_11__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */];}).map(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_4" /* getUrnFromArtefact */])),[__WEBPACK_IMPORTED_MODULE_11__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]]),hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_11__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],hiddenKeys:Object(__WEBPACK_IMPORTED_MODULE_11__utils_tree__["e" /* getDeadEndNodes */])(dataflowTree,'categories').map(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_4" /* getUrnFromArtefact */]),getFilter:function getFilter(searchText){return function(_ref2){var id=_ref2.id,name=_ref2.name;var search=searchText.toLowerCase();return id&&id.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},icon:'file-text',getIconColor:function getIconColor(){return"#37a0f4";},treeActions:[{title:t('scenes.dataManager.dataflowBuilder.categorisations.refreshButton.title'),icon:'sync',onClick:function onClick(){return fetchDataflowTree(lang);}}]})));}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DataflowBuilderTree));

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_steps_style__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_steps_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_steps_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_steps__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dataflow_form__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__query__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__category_tree__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__header_form__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducer__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__layout_annotations__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_filter__ = __webpack_require__(53);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{nodes:state.config.nodes,nodeId:state.app.endpointId,isVisible:state.scenes.dataManager.dataflowBuilder.shared.isWizardVisible,step:state.scenes.dataManager.dataflowBuilder.shared.wizardStep,ddbDataflow:state.scenes.dataManager.dataflowBuilder.shared.ddbDataflow,dataflowTriplet:state.scenes.dataManager.dataflowBuilder.shared.dataflowTriplet,dataflow:state.scenes.dataManager.dataflowBuilder.shared.dataflow,filter:state.scenes.dataManager.dataflowBuilder.shared.filter,treeFilter:state.scenes.dataManager.dataflowBuilder.shared.treeFilter,filterMode:state.scenes.dataManager.dataflowBuilder.shared.filterMode,cube:state.scenes.dataManager.dataflowBuilder.shared.cube,cubeFirstRow:state.scenes.dataManager.dataflowBuilder.shared.cubeFirstRow,categoriesUrns:state.scenes.dataManager.dataflowBuilder.shared.categoriesUrns,header:state.scenes.dataManager.dataflowBuilder.shared.header,hasHeader:state.scenes.dataManager.dataflowBuilder.shared.hasHeader,permissions:state.app.user.permissions};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["g" /* hideDataflowBuilderWizard */])());},onStepSet:function onStepSet(step){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["j" /* setDataflowBuilderWizardStep */])(step));},onSubmit:function onSubmit(dataflow,cube,filterObj,categoriesUrns,header,isEditing,cubeCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["l" /* submitDataflowBuilderWizard */])(dataflow,cube,filterObj,categoriesUrns,header,isEditing,cubeCode));},fetchDataflow:function fetchDataflow(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["h" /* readDataflowBuilderWizardDataflow */])(dataflowTriplet));}};};function isCategorisationStepDisabled(cubeFirstRow){return cubeFirstRow===undefined||cubeFirstRow===null;}function isHeaderStepDisabled(categoriesUrns,cubeFirstRow){return isCategorisationStepDisabled(cubeFirstRow)||categoriesUrns===null||categoriesUrns.length===0;}function isLayoutAnnotationsStepDisabled(categoriesUrns,cubeFirstRow){return isHeaderStepDisabled(categoriesUrns,cubeFirstRow);}var DataflowBuilderWizard=function DataflowBuilderWizard(_ref){var t=_ref.t,nodes=_ref.nodes,nodeId=_ref.nodeId,isVisible=_ref.isVisible,step=_ref.step,dataflow=_ref.dataflow,dataflowTriplet=_ref.dataflowTriplet,ddbDataflow=_ref.ddbDataflow,cube=_ref.cube,cubeFirstRow=_ref.cubeFirstRow,filter=_ref.filter,treeFilter=_ref.treeFilter,filterMode=_ref.filterMode,categoriesUrns=_ref.categoriesUrns,header=_ref.header,hasHeader=_ref.hasHeader,onHide=_ref.onHide,onStepSet=_ref.onStepSet,onSubmit=_ref.onSubmit,fetchDataflow=_ref.fetchDataflow,permissions=_ref.permissions;var userHasPermissionsToEdit=permissions&&dataflowTriplet&&permissions.agencies.filter(function(agency){return agency===dataflowTriplet.agencyID;}).length>0;var disabled=dataflowTriplet&&dataflow&&[].concat(_toConsumableArray(dataflow.annotations||[]),_toConsumableArray(dataflow.autoAnnotations||[])).filter(function(_ref2){var type=_ref2.type;return type==='NonProductionDataflow';}).length===0||permissions&&!userHasPermissionsToEdit&&dataflowTriplet!==null;var filterStr=filterMode===__WEBPACK_IMPORTED_MODULE_28__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?Object(__WEBPACK_IMPORTED_MODULE_30__utils_filter__["c" /* getFilterStrFromObj */])(filter,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})):null):Object(__WEBPACK_IMPORTED_MODULE_27__components_tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(treeFilter,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(_ref3){var name=_ref3.name;return name;}):null);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_XL"],title:dataflowTriplet!==null?t('scenes.dataManager.dataflowBuilder.wizard.editMode.title',{triplet:dataflowTriplet}):t('scenes.dataManager.dataflowBuilder.wizard.createMode.title'),onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),step>__WEBPACK_IMPORTED_MODULE_19__reducer__["b" /* DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW */]&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){return onStepSet(step-1);}},t('scenes.dataManager.dataflowBuilder.wizard.prevStepButton.label')),step<__WEBPACK_IMPORTED_MODULE_19__reducer__["d" /* DATAFLOW_BUILDER_WIZARD_STEP_LAYOUT_ANNOTATIONS */]&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||step===__WEBPACK_IMPORTED_MODULE_19__reducer__["e" /* DATAFLOW_BUILDER_WIZARD_STEP_QUERY */]&&isCategorisationStepDisabled(cubeFirstRow)||step===__WEBPACK_IMPORTED_MODULE_19__reducer__["a" /* DATAFLOW_BUILDER_WIZARD_STEP_CATEGORISATION */]&&isHeaderStepDisabled(categoriesUrns,cubeFirstRow)||step===__WEBPACK_IMPORTED_MODULE_19__reducer__["c" /* DATAFLOW_BUILDER_WIZARD_STEP_HEADER */]&&isLayoutAnnotationsStepDisabled(categoriesUrns,cubeFirstRow)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onStepSet(step+1);}},type:'primary'},t('scenes.dataManager.dataflowBuilder.wizard.nextStepButton.label')),(ddbDataflow!==null&&ddbDataflow.IDDataflow!==null&&dataflow&&[].concat(_toConsumableArray(dataflow.annotations||[]),_toConsumableArray(dataflow.autoAnnotations||[])).filter(function(_ref4){var type=_ref4.type;return type==='NonProductionDataflow';}).length>0||(ddbDataflow===null||ddbDataflow.IDDataflow===null)&&step===__WEBPACK_IMPORTED_MODULE_19__reducer__["d" /* DATAFLOW_BUILDER_WIZARD_STEP_LAYOUT_ANNOTATIONS */])&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||isCategorisationStepDisabled(cubeFirstRow)||isHeaderStepDisabled(categoriesUrns,cubeFirstRow)||hasHeader&&(header===null||header.sender===null||header.sender===undefined||header.sender.organisationId===null||header.sender.organisationId===undefined||header.sender.organisationId.length===0)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{if(header&&header.receiver&&(header.receiver.organisationId===null||header.receiver.organisationId===undefined||header.receiver.organisationId.length===0)&&(header.receiver.organisationName&&header.receiver.organisationName.length>0||header.receiver.contactName&&header.receiver.contactName.length>0||header.receiver.contactDepartment&&header.receiver.contactDepartment.length>0||header.receiver.contactRole&&header.receiver.contactRole.length>0||header.receiver.contactEmail&&header.receiver.contactEmail.length>0)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.error({title:t('scenes.dataManager.dataflowBuilder.wizard.invalidReceiverModal.title'),content:t('scenes.dataManager.dataflowBuilder.wizard.invalidReceiverModal.content')});}else{onSubmit(dataflow,cube,filterStr,categoriesUrns,hasHeader?header:null,ddbDataflow!==null&&ddbDataflow.IDDataflow!==null?ddbDataflow.IDDataflow:null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('cube',{className:'Code'}));}}},type:'primary'},t('scenes.dataManager.dataflowBuilder.wizard.saveButton.label'))),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__hocs_call__["a" /* default */],{cb:fetchDataflow,cbParam:dataflowTriplet,disabled:dataflowTriplet===null},dataflowTriplet&&dataflow&&[].concat(_toConsumableArray(dataflow.annotations||[]),_toConsumableArray(dataflow.autoAnnotations||[])).filter(function(_ref5){var type=_ref5.type;return type==='NonProductionDataflow';}).length===0&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('scenes.dataManager.dataflowBuilder.wizard.inProductionAlert.message')}),permissions&&!userHasPermissionsToEdit&&dataflowTriplet!==null&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_steps___default.a,{current:step,size:'small'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('span',{style:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_POINTER"],onClick:function onClick(){return onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["b" /* DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW */]);}},t('scenes.dataManager.dataflowBuilder.wizard.steps.dataflow.title')),icon:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',type:step===__WEBPACK_IMPORTED_MODULE_19__reducer__["b" /* DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW */]?'primary':null,onClick:function onClick(){return onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["b" /* DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW */]);},size:'small'},'1')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('span',{style:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_POINTER"],onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)){onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["e" /* DATAFLOW_BUILDER_WIZARD_STEP_QUERY */]);}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('scenes.dataManager.dataflowBuilder.wizard.steps.query.title')),icon:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',type:step===__WEBPACK_IMPORTED_MODULE_19__reducer__["e" /* DATAFLOW_BUILDER_WIZARD_STEP_QUERY */]?'primary':null,onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)){onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["e" /* DATAFLOW_BUILDER_WIZARD_STEP_QUERY */]);}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}},size:'small'},'2')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('span',{style:isCategorisationStepDisabled(cubeFirstRow)?null:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_POINTER"],onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||isCategorisationStepDisabled(cubeFirstRow)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["a" /* DATAFLOW_BUILDER_WIZARD_STEP_CATEGORISATION */]);}}},t('scenes.dataManager.dataflowBuilder.wizard.steps.categorisation.title')),icon:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',type:step===__WEBPACK_IMPORTED_MODULE_19__reducer__["a" /* DATAFLOW_BUILDER_WIZARD_STEP_CATEGORISATION */]?'primary':null,onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||isCategorisationStepDisabled(cubeFirstRow)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["a" /* DATAFLOW_BUILDER_WIZARD_STEP_CATEGORISATION */]);}},size:'small'},'3')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('span',{style:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_POINTER"],onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||isHeaderStepDisabled(categoriesUrns,cubeFirstRow)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["c" /* DATAFLOW_BUILDER_WIZARD_STEP_HEADER */]);}}},t('scenes.dataManager.dataflowBuilder.wizard.steps.header.title')),icon:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',type:step===__WEBPACK_IMPORTED_MODULE_19__reducer__["c" /* DATAFLOW_BUILDER_WIZARD_STEP_HEADER */]?'primary':null,onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||isHeaderStepDisabled(categoriesUrns,cubeFirstRow)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["c" /* DATAFLOW_BUILDER_WIZARD_STEP_HEADER */]);}},size:'small'},'4')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_steps___default.a.Step,{title:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('span',{style:isLayoutAnnotationsStepDisabled(categoriesUrns,cubeFirstRow)?null:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_POINTER"],onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||isLayoutAnnotationsStepDisabled(categoriesUrns,cubeFirstRow)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["d" /* DATAFLOW_BUILDER_WIZARD_STEP_LAYOUT_ANNOTATIONS */]);}}},t('scenes.dataManager.dataflowBuilder.wizard.steps.layoutAnnotations.title')),icon:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{shape:'circle',type:step===__WEBPACK_IMPORTED_MODULE_19__reducer__["d" /* DATAFLOW_BUILDER_WIZARD_STEP_LAYOUT_ANNOTATIONS */]?'primary':null,onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_26__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||isLayoutAnnotationsStepDisabled(categoriesUrns,cubeFirstRow)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onStepSet(__WEBPACK_IMPORTED_MODULE_19__reducer__["d" /* DATAFLOW_BUILDER_WIZARD_STEP_LAYOUT_ANNOTATIONS */]);}},size:'small'},'5')})))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:step!==__WEBPACK_IMPORTED_MODULE_19__reducer__["b" /* DATAFLOW_BUILDER_WIZARD_STEP_DATAFLOW */]?__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_HIDDEN"]:null},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__dataflow_form__["a" /* default */],{disabled:disabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:step!==__WEBPACK_IMPORTED_MODULE_19__reducer__["e" /* DATAFLOW_BUILDER_WIZARD_STEP_QUERY */]?__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_HIDDEN"]:null},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__query__["a" /* default */],{disabled:disabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:step!==__WEBPACK_IMPORTED_MODULE_19__reducer__["a" /* DATAFLOW_BUILDER_WIZARD_STEP_CATEGORISATION */]?__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_HIDDEN"]:null},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__category_tree__["a" /* default */],{disabled:disabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:step!==__WEBPACK_IMPORTED_MODULE_19__reducer__["c" /* DATAFLOW_BUILDER_WIZARD_STEP_HEADER */]?__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_HIDDEN"]:null},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__header_form__["a" /* default */],{disabled:disabled})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:step!==__WEBPACK_IMPORTED_MODULE_19__reducer__["d" /* DATAFLOW_BUILDER_WIZARD_STEP_LAYOUT_ANNOTATIONS */]?__WEBPACK_IMPORTED_MODULE_13__styles_constants__["CSS_HIDDEN"]:null},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__layout_annotations__["a" /* default */],{disabled:disabled,filterStr:filterStr,cubeId:cube?cube.IDCube:null,colNames:cube?__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(_ref6){var name=_ref6.name;return name;}):null}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_24_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_25_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_23_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DataflowBuilderWizard));

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(160);
var mapStateToProps=function mapStateToProps(state){return{dataflowTriplet:state.scenes.dataManager.dataflowBuilder.shared.dataflowTriplet,dataflow:state.scenes.dataManager.dataflowBuilder.shared.dataflow,agencies:state.scenes.dataManager.dataflowBuilder.shared.agencies,permissions:state.app.user.permissions,dsdForLayoutAnnotations:state.scenes.dataManager.dataflowBuilder.shared.dsdForLayoutAnnotations};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* changeDataflowBuilderWizardDataflowForm */])(fields));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* readDataflowBuilderWizardDataflowFormAgencies */])(allowedAgencies));},fetchDsdForLayoutAnnotations:function fetchDsdForLayoutAnnotations(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["i" /* readDataflowBuilderWizardDsdForLayoutAnnotations */])(dsdTriplet));}};};var DataflowBuilderWizardDataflowForm=function DataflowBuilderWizardDataflowForm(_ref){var t=_ref.t,permissions=_ref.permissions,dataflowTriplet=_ref.dataflowTriplet,dataflow=_ref.dataflow,agencies=_ref.agencies,onChange=_ref.onChange,fetchAgencies=_ref.fetchAgencies,disabled=_ref.disabled,dsdForLayoutAnnotations=_ref.dsdForLayoutAnnotations,fetchDsdForLayoutAnnotations=_ref.fetchDsdForLayoutAnnotations;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hocs_call__["a" /* default */],{cb:fetchDsdForLayoutAnnotations,cbParam:dataflow&&dataflow.structure?Object(__WEBPACK_IMPORTED_MODULE_7__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(dataflow.structure):null,disabled:!dataflow||!dataflow.structure},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_artefact_form__["d" /* default */],{artefact:dataflow,onChange:onChange,mode:dataflowTriplet!==null?disabled?__WEBPACK_IMPORTED_MODULE_3__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */]:__WEBPACK_IMPORTED_MODULE_3__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_3__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */],isFinalDisabled:true,agencies:agencies,idMaxLen:40}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DataflowBuilderWizardDataflowForm));

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(190);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,categorisedCubes:state.scenes.dataManager.dataflowBuilder.components.wizard.components.query.components.columnsForm.categorisedCubes,ddbDataflowId:state.scenes.dataManager.dataflowBuilder.shared.ddbDataflowId,ddbDataflow:state.scenes.dataManager.dataflowBuilder.shared.ddbDataflow,isCubeTreeVisible:state.scenes.dataManager.dataflowBuilder.components.wizard.components.query.components.columnsForm.isCubeTreeVisible,cubeId:state.scenes.dataManager.dataflowBuilder.shared.cubeId,cube:state.scenes.dataManager.dataflowBuilder.shared.cube,cubeFirstRow:state.scenes.dataManager.dataflowBuilder.shared.cubeFirstRow,isRowsModalVisible:state.scenes.dataManager.dataflowBuilder.components.wizard.components.query.components.preview.isRowsModalVisible,filter:state.scenes.dataManager.dataflowBuilder.shared.filter,filterTemp:state.scenes.dataManager.dataflowBuilder.shared.filterTemp,treeFilter:state.scenes.dataManager.dataflowBuilder.shared.treeFilter,treeFilterTemp:state.scenes.dataManager.dataflowBuilder.shared.treeFilterTemp,filterMode:state.scenes.dataManager.dataflowBuilder.shared.filterMode,rows:state.scenes.dataManager.dataflowBuilder.components.wizard.components.query.components.preview.rows,isFilterModalVisible:state.scenes.dataManager.dataflowBuilder.shared.isFilterModalVisible,dsd:state.scenes.dataManager.dataflowBuilder.shared.dsdForLayoutAnnotations};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchDdbDataflow:function fetchDdbDataflow(ddbDataflowId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["W" /* readDataflowBuilderWizardQueryCubeColumnsFormDdbDataflow */])(ddbDataflowId));},fetchCube:function fetchCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["U" /* readDataflowBuilderWizardQueryCubeColumnsFormCube */])(cubeId));},fetchCategorisedCubes:function fetchCategorisedCubes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["T" /* readDataflowBuilderWizardQueryCubeColumnsFormCategorisedCubes */])());},fetchCubeFirstRow:function fetchCubeFirstRow(_ref){var cubeId=_ref.cubeId,cubeColumns=_ref.cubeColumns;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["V" /* readDataflowBuilderWizardQueryCubeColumnsFormCubeFirstRow */])(cubeId,cubeColumns));},fetchColumnValues:function fetchColumnValues(cubeId,columnName,viewerObj){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["Y" /* readDataflowBuilderWizardQueryFilterFormColumnValues */])(cubeId,columnName,viewerObj));},resetColumnValues:function resetColumnValues(columnName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_4" /* resetDataflowBuilderWizardQueryFilterFormColumnValues */])(columnName));},fetchColumnCodes:function fetchColumnCodes(columnName,codelistCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["X" /* readDataflowBuilderWizardQueryFilterFormColumnCodes */])(columnName,codelistCode));},onCubeTreeShow:function onCubeTreeShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_6" /* showDataflowBuilderWizardQueryCubeColumnsFormCubeTree */])());},onCubeTreeHide:function onCubeTreeHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["Q" /* hideDataflowBuilderWizardQueryCubeColumnsFormCubeTree */])());},onCubeSet:function onCubeSet(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_5" /* setDataflowBuilderWizardQueryCubeColumnsFormCube */])(cubeId));},onCubeUnset:function onCubeUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_10" /* unsetDataflowBuilderWizardQueryCubeColumnsFormCube */])());},onColumnsChange:function onColumnsChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["J" /* changeDataflowBuilderWizardQueryCubeColumnsForm */])(fields));},onBlockAdd:function onBlockAdd(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["G" /* addDataflowBuilderWizardQueryFilterFormBlock */])());},onBlockDelete:function onBlockDelete(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["O" /* deleteDataflowBuilderWizardQueryFilterFormBlock */])(blockIndex));},onConditionAdd:function onConditionAdd(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["H" /* addDataflowBuilderWizardQueryFilterFormCondition */])(blockIndex));},onConditionDelete:function onConditionDelete(blockIndex,conditionIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["P" /* deleteDataflowBuilderWizardQueryFilterFormCondition */])(blockIndex,conditionIndex));},onFilterChange:function onFilterChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["I" /* changeDataflowBuilderWizardFilterForm */])(fields));},fetchRows:function fetchRows(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["Z" /* readDataflowBuilderWizardQueryPreviewRows */])(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc));},onRowsModalShow:function onRowsModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_8" /* showDataflowBuilderWizardQueryPreviewRowsModal */])());},onRowsModalHide:function onRowsModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["S" /* hideDataflowBuilderWizardQueryPreviewRowsModal */])());},fetchColumnCodelistCount:function fetchColumnCodelistCount(_ref2){var codelistTriplet=_ref2.codelistTriplet,language=_ref2.language;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_0" /* readDataflowBuilderWizardQueryTreeFilterColumnCodelistCount */])(codelistTriplet,language));},fetchColumnCodelistTree:function fetchColumnCodelistTree(_ref3){var codelistTriplet=_ref3.codelistTriplet,language=_ref3.language,itemsOrderAnnotationType=_ref3.itemsOrderAnnotationType;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_1" /* readDataflowBuilderWizardQueryTreeFilterColumnCodelistTree */])(codelistTriplet,language,itemsOrderAnnotationType));},onFilterReset:function onFilterReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_3" /* resetDataflowBuilderWizardQueryFilter */])());},onFilterModeChange:function onFilterModeChange(filterMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["K" /* changeDataflowBuilderWizardQueryFilterMode */])(filterMode));},onFilterModalShow:function onFilterModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_7" /* showDataflowBuilderWizardQueryFilterModal */])());},onFilterModalHide:function onFilterModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["R" /* hideDataflowBuilderWizardQueryFilterModal */])());},onFilterModalSubmit:function onFilterModalSubmit(treeFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_9" /* submitDataflowBuilderWizardQueryFilterModal */])(treeFilter));},onTreeFilterChange:function onTreeFilterChange(treeFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["L" /* changeDataflowBuilderWizardQueryTreeFilter */])(treeFilter));},fetchColumnFilteredValues:function fetchColumnFilteredValues(cubeId,colNames,filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_2" /* readDataflowBuilderWizardQueryTreeFilterColumnFilteredValues */])(cubeId,colNames,filter));},onColumnModeChange:function onColumnModeChange(colName,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["M" /* changeDataflowBuilderWizardQueryTreeFilterColumnMode */])(colName,mode));},onColumnValuesChange:function onColumnValuesChange(colName,values){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["N" /* changeDataflowBuilderWizardQueryTreeFilterColumnValues */])(colName,values));}};};var DataflowBuilderWizardQuery=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__components_query_form__["c" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (DataflowBuilderWizardQuery);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,dataflowTriplet:state.scenes.dataManager.dataflowBuilder.shared.dataflowTriplet,categorySchemes:state.scenes.dataManager.dataflowBuilder.components.wizard.components.categoryTree.categorySchemes,categoriesUrns:state.scenes.dataManager.dataflowBuilder.shared.categoriesUrns};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSelectionChange:function onSelectionChange(selection){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* changeDataflowBuilderWizardCategoryTreeSelection */])(selection));},fetchCategorySchemes:function fetchCategorySchemes(lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* readDataflowBuilderWizardCategoryTreeCategorisations */])(lang));}};};var DataflowBuilderWizardCategoryTree=function DataflowBuilderWizardCategoryTree(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,dataflowTriplet=_ref.dataflowTriplet,categorySchemes=_ref.categorySchemes,categoriesUrns=_ref.categoriesUrns,onSelectionChange=_ref.onSelectionChange,fetchCategorySchemes=_ref.fetchCategorySchemes,disabled=_ref.disabled;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__hocs_call__["a" /* default */],{cb:fetchCategorySchemes,cbParam:lang},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dataflow-builder__wizard__category-tree__tree'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_enhanced_tree__["a" /* default */],{tree:categorySchemes,getNodeKey:__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["_4" /* getUrnFromArtefact */],childrenKey:'categories',idKey:'id',nameKey:'name',catIdKey:'id',catNameKey:'name',expandSelectedOnTreeChange:true,multiple:true,unselectableKeys:disabled?categorySchemes!==null?Object(__WEBPACK_IMPORTED_MODULE_10__utils_tree__["l" /* getNodes */])(categorySchemes,"categories",function(){return true;}).map(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["_4" /* getUrnFromArtefact */]):null:categorySchemes!==null?categorySchemes.map(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["_4" /* getUrnFromArtefact */]):null,defaultSelectedKeys:categoriesUrns!==null?categoriesUrns:null,getFilter:function getFilter(searchText){return function(_ref2){var id=_ref2.id,name=_ref2.name;var search=searchText.toLowerCase();return id&&id.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,lang,dataLanguages).toLowerCase().indexOf(search)>=0;};},onSelect:function onSelect(selected){return onSelectionChange(selected.map(function(urn){return Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_tree__["k" /* getNode */])(categorySchemes,'categories',function(node){return Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(node)===urn;}));}));},treeActions:[{title:t('scenes.dataManager.dataflowBuilder.wizard.categoryTree.refreshButton.title'),icon:'sync',onClick:function onClick(){return fetchCategorySchemes(lang);}}],icon:'file-text'})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DataflowBuilderWizardCategoryTree));

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__ = __webpack_require__(37);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_TWO_THIRDS"]}};var cardLayout={type:'inner',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}};var mapStateToProps=function mapStateToProps(state){return{hasHeader:state.scenes.dataManager.dataflowBuilder.shared.hasHeader,dataflowTriplet:state.scenes.dataManager.dataflowBuilder.shared.dataflowTriplet,header:state.scenes.dataManager.dataflowBuilder.shared.header};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onShow:function onShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* showDataflowBuilderWizardHeaderForm */])());},onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* hideDataflowBuilderWizardHeaderForm */])());},onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* changeDataflowBuilderWizardHeaderForm */])(fields));},fetchHeader:function fetchHeader(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* readDataflowBuilderWizardHeaderFormHeader */])(dataflowTriplet));}};};var mapPropsToFields=function mapPropsToFields(_ref){var header=_ref.header;return{test:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.test||null}),name:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.name||null}),sender:{organisationId:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.sender&&header.sender.organisationId||null}),organisationName:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.sender&&header.sender.organisationName||null}),contactName:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.sender&&header.sender.contactName||null}),contactDepartment:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.sender&&header.sender.contactDepartment||null}),contactRole:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.sender&&header.sender.contactRole||null}),contactEmail:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.sender&&header.sender.contactEmail||null})},receiver:{organisationId:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.receiver&&header.receiver.organisationId||null}),organisationName:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.receiver&&header.receiver.organisationName||null}),contactName:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.receiver&&header.receiver.contactName||null}),contactDepartment:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.receiver&&header.receiver.contactDepartment||null}),contactRole:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.receiver&&header.receiver.contactRole||null}),contactEmail:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.receiver&&header.receiver.contactEmail||null})},dataSetAgencyId:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.dataSetAgencyId||null}),source:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:header&&header.source||null})};};var onFieldsChange=function onFieldsChange(_ref2,fields){var onChange=_ref2.onChange;return onChange({test:fields.test!==undefined?fields.test.value:undefined,name:fields.name?fields.name.value:undefined,sender:fields.sender!==undefined?__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.mapValues(fields.sender,function(field){return field.value;}):undefined,receiver:fields.receiver!==undefined?__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.mapValues(fields.receiver,function(field){return field.value;}):undefined,dataSetAgencyId:fields.dataSetAgencyId!==undefined?fields.dataSetAgencyId.value:undefined,source:fields.source!==undefined?fields.source.value:undefined});};var DataflowBuilderWizardHeaderForm=function DataflowBuilderWizardHeaderForm(_ref3){var t=_ref3.t,form=_ref3.form,dataflowTriplet=_ref3.dataflowTriplet,header=_ref3.header,hasHeader=_ref3.hasHeader,onShow=_ref3.onShow,onHide=_ref3.onHide,fetchHeader=_ref3.fetchHeader,disabled=_ref3.disabled;return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchHeader,cbParam:dataflowTriplet,disabled:dataflowTriplet===null},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,{className:'advanced-form'},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('scenes.dataManager.dataflowBuilder.wizard.headerForm.isVisibleCheckbox.label')},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{onChange:function onChange(e){return e.target.checked?onShow():onHide();},checked:hasHeader,disabled:disabled})))),hasHeader&&__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.dataflow.header.test.label')},form.getFieldDecorator('test',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{disabled:disabled})))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.name.label')},formItemLayout),form.getFieldDecorator('name')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('name'),disabled:disabled}))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,Object.assign({title:t('data.dataflow.header.sender.label')},cardLayout),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.dataflow.header.organisationId.label'),validateStatus:form.getFieldValue('sender.organisationId')&&Object(__WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('sender.organisationId')).help?"warning":null,help:form.getFieldValue('sender.organisationId')&&Object(__WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('sender.organisationId')).help},formItemLayout),form.getFieldDecorator('sender.organisationId',{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('sender.organisationId'),disabled:disabled,style:{textTransform:"uppercase"}})))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.organisationName.label')},formItemLayout),form.getFieldDecorator('sender.organisationName')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('sender.organisationName'),disabled:disabled}))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.contactName.label')},formItemLayout),form.getFieldDecorator('sender.contactName')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('sender.contactName'),disabled:disabled})))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.contactEmail.label')},formItemLayout),form.getFieldDecorator('sender.contactEmail')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('sender.contactEmail'),disabled:disabled}))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.contactDepartment.label')},formItemLayout),form.getFieldDecorator('sender.contactDepartment')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('sender.contactDepartment'),disabled:disabled})))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.contactRole.label')},formItemLayout),form.getFieldDecorator('sender.contactRole')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('sender.contactRole'),disabled:disabled})))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,Object.assign({title:t('data.dataflow.header.receiver.label')},cardLayout),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.organisationId.label'),validateStatus:form.getFieldValue('receiver.organisationId')&&Object(__WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('receiver.organisationId')).help?"warning":null,help:form.getFieldValue('receiver.organisationId')&&Object(__WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('receiver.organisationId')).help},formItemLayout),form.getFieldDecorator('receiver.organisationId',{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('receiver.organisationId'),disabled:disabled,style:{textTransform:"uppercase"}})))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.organisationName.label')},formItemLayout),form.getFieldDecorator('receiver.organisationName')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{disabled:header===null||header.receiver===null||header.receiver===undefined||header.receiver.organisationId===null||header.receiver.organisationId.length===0||disabled,title:form.getFieldValue('receiver.organisationName')}))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.contactName.label')},formItemLayout),form.getFieldDecorator('receiver.contactName')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('receiver.contactName'),disabled:header===null||header.receiver===null||header.receiver===undefined||header.receiver.organisationId===null||header.receiver.organisationId.length===0||disabled})))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.contactEmail.label')},formItemLayout),form.getFieldDecorator('receiver.contactEmail')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('receiver.contactEmail'),disabled:header===null||header.receiver===null||header.receiver===undefined||header.receiver.organisationId===null||header.receiver.organisationId.length===0||disabled}))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.contactDepartment.label')},formItemLayout),form.getFieldDecorator('receiver.contactDepartment')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('receiver.contactDepartment'),disabled:header===null||header.receiver===null||header.receiver===undefined||header.receiver.organisationId===null||header.receiver.organisationId.length===0||disabled})))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.contactRole.label')},formItemLayout),form.getFieldDecorator('receiver.contactRole')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('receiver.contactRole'),disabled:header===null||header.receiver===null||header.receiver===undefined||header.receiver.organisationId===null||header.receiver.organisationId.length===0||disabled})))))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.dataSetAgencyId.label'),validateStatus:form.getFieldValue('dataSetAgencyId')&&Object(__WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('dataSetAgencyId')).help?"warning":null,help:form.getFieldValue('dataSetAgencyId')&&Object(__WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('dataSetAgencyId')).help},formItemLayout),form.getFieldDecorator('dataSetAgencyId',{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('dataSetAgencyId'),disabled:disabled,style:{textTransform:"uppercase"}})))),__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.dataflow.header.source.label')},formItemLayout),form.getFieldDecorator('source')(__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue('source'),disabled:disabled})))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_14_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(DataflowBuilderWizardHeaderForm));

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_annotations_form_Layout__ = __webpack_require__(551);
var mapStateToProps=function mapStateToProps(state){return{dataflow:state.scenes.dataManager.dataflowBuilder.shared.dataflow,isFormVisible:state.scenes.dataManager.dataflowBuilder.components.wizard.components.layoutAnnotations.isFormVisible,dsdForLayoutAnnotations:state.scenes.dataManager.dataflowBuilder.shared.dsdForLayoutAnnotations,itemsPage:state.scenes.dataManager.dataflowBuilder.components.wizard.components.layoutAnnotations.itemsPage,valuesForLayoutAnnotations:state.scenes.dataManager.dataflowBuilder.components.wizard.components.layoutAnnotations.valuesForLayoutAnnotations};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{onFormShow:function onFormShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["o" /* showDataflowBuilderWizardLayoutAnnotationsForm */])());},onFormHide:function onFormHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["j" /* hideDataflowBuilderWizardLayoutAnnotationsForm */])());},onFormSubmit:function onFormSubmit(annotations){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["p" /* submitDataflowBuilderWizardLayoutAnnotationsForm */])(annotations));},onFormReset:function onFormReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["l" /* resetDataflowBuilderWizardLayoutAnnotationsForm */])());},fetchDsdForLayoutAnnotations:function fetchDsdForLayoutAnnotations(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* readDataflowBuilderWizardDsdForLayoutAnnotations */])(dsdTriplet));},fetchItemsPage:function fetchItemsPage(_ref,dsdComponentName,selectedCodes){var codelistTriplet=_ref.codelistTriplet,language=_ref.language,pageNum=_ref.pageNum,pageSize=_ref.pageSize,searchText=_ref.searchText,filters=_ref.filters,sortCol=_ref.sortCol,sortByDesc=_ref.sortByDesc;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["k" /* readDataflowBuilderWizardLayoutAnnotationsItemsPage */])({codelistTriplet:codelistTriplet,language:language,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc},ownProps.cubeId,ownProps.colNames,"ID_"+dsdComponentName,ownProps.filterStr,selectedCodes));},resetItemsPage:function resetItemsPage(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["m" /* resetDataflowBuilderWizardLayoutAnnotationsItemsPage */])());},fetchValuesForLayoutAnnotations:function fetchValuesForLayoutAnnotations(colName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["i" /* fetchDataflowBuilderWizardLayoutAnnotationsValues */])(ownProps.cubeId,ownProps.colNames,"ID_"+colName,ownProps.filterStr));},resetValuesForLayoutAnnotations:function resetValuesForLayoutAnnotations(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["n" /* resetDataflowBuilderWizardLayoutAnnotationsValues */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(__WEBPACK_IMPORTED_MODULE_5__components_annotations_form_Layout__["a" /* default */]));

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GeneralForm__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AgenciesForm__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EndpointForm__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__custom_annotations_CustomAnnotationsForm__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProxyForm__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchForm__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnnotationsForm__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DcatApItForm__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DataBrowserForm__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AstForm__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LoginProvidersForm__ = __webpack_require__(584);
var Node=function Node(_ref){var t=_ref.t,node=_ref.node,index=_ref.index,_onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{tabPosition:'left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'general',tab:t('scenes.configuration.nodesConfig.tabs.general.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GeneralForm__["c" /* default */],{General:node.General,onChange:function onChange(fields){return _onChange({General:fields});},disableID:!node.isNewNode})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'agencies',tab:t('scenes.configuration.nodesConfig.tabs.agencies.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AgenciesForm__["a" /* default */],{Agencies:node.Agencies,onChange:function onChange(fields){return _onChange({Agencies:fields});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'endpoint',tab:t('scenes.configuration.nodesConfig.tabs.endpoint.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EndpointForm__["d" /* default */],{node:node,nodeIndex:index,onChange:function onChange(fields){return _onChange({Endpoint:fields});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'customAnnotations',tab:t('scenes.configuration.nodesConfig.tabs.customAnnotations.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__custom_annotations_CustomAnnotationsForm__["a" /* default */],{AnnotationTabs:node.AnnotationTabs,onChange:function onChange(fields){return _onChange({AnnotationTabs:fields});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'annotations',tab:t('scenes.configuration.nodesConfig.tabs.annotations.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AnnotationsForm__["a" /* default */],{Annotations:node.Annotations,onChange:function onChange(fields){return _onChange({Annotations:fields});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'proxy',tab:t('scenes.configuration.nodesConfig.tabs.proxy.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ProxyForm__["a" /* default */],{Proxy:node.Proxy,onChange:function onChange(fields){return _onChange({Proxy:fields});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'search',tab:t('scenes.configuration.nodesConfig.tabs.search.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SearchForm__["a" /* default */],{Search:node.Search,onChange:function onChange(fields){return _onChange({Search:fields});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'dcatApIt',tab:t('scenes.configuration.nodesConfig.tabs.dcatApIt.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DcatApItForm__["a" /* default */],{DcatApIt:node.DcatApIt,onChange:function onChange(fields){return _onChange({DcatApIt:fields});},nodeIndex:index})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'dataBrowser',tab:t('scenes.configuration.nodesConfig.tabs.dataBrowser.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DataBrowserForm__["a" /* default */],{DataBrowser:node.DataBrowser,onChange:function onChange(fields){return _onChange({DataBrowser:fields});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'ast',tab:t('scenes.configuration.nodesConfig.tabs.ast.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AstForm__["a" /* default */],{AST:node.AST,onChange:function onChange(fields){return _onChange({AST:fields});},nodeIndex:index,nodeId:node.General.ID})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'loginProviders',tab:t('scenes.configuration.nodesConfig.tabs.loginProviders.title')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__LoginProvidersForm__["b" /* default */],{LoginProviders:node.LoginProviders||[],onChange:function onChange(fields){return _onChange({LoginProviders:fields});}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])()(Node));

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_list__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AgencyForm__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCheckAgencyAssignedToAnyUser:function onCheckAgencyAssignedToAnyUser(agencyCode,nodeCode,onSuccess){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["z" /* checkNodesConfigNodeAgencyAssignedToAnyUser */])(agencyCode,nodeCode,onSuccess));}};};var AgenciesForm=function AgenciesForm(_ref){var t=_ref.t,nodeId=_ref.nodeId,Agencies=_ref.Agencies,_onChange=_ref.onChange,onCheckAgencyAssignedToAnyUser=_ref.onCheckAgencyAssignedToAnyUser;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.agencies.label')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_form_list__["a" /* default */],{compact:true,values:Agencies,Component:__WEBPACK_IMPORTED_MODULE_6__AgencyForm__["a" /* default */],newItem:{ID:null,Name:null},onChange:function onChange(newAgencies){if(newAgencies.length<Agencies.length){var deletedAgency=Agencies.find(function(oldAgency){return!newAgencies.find(function(newAgency){return newAgency.Id===oldAgency.Id;});});onCheckAgencyAssignedToAnyUser(deletedAgency.Id,nodeId,function(){return _onChange(newAgencies);});}else{_onChange(newAgencies);}},addItemLabel:t('scenes.configuration.nodesConfig.agencies.agencies.addButton.title'),removeItemLabel:t('scenes.configuration.nodesConfig.agencies.agencies.removeButton.title')}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(AgenciesForm));

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_artefactValidators__ = __webpack_require__(37);
var mapPropsToFields=function mapPropsToFields(_ref){var value=_ref.value;return{Id:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:value!==null?value.Id:null}),Name:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:value!==null?value.Name:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var AgencyForm=function AgencyForm(_ref3){var t=_ref3.t,value=_ref3.value,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a,{layout:"inline"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("scenes.configuration.nodesConfig.agencyForm.id"),className:'form-item-required',style:{marginBottom:0},validateStatus:value&&Object(__WEBPACK_IMPORTED_MODULE_9__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,value.Id).help?"warning":null,help:value&&Object(__WEBPACK_IMPORTED_MODULE_9__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,value.Id).help},form.getFieldDecorator("Id",{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue("Id"),style:{textTransform:"uppercase"}}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("scenes.configuration.nodesConfig.agencyForm.name"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("Name")(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_multilanguage_input__["a" /* default */],{title:form.getFieldValue("Name")}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(AgencyForm));

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_form_list__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CustomAnnotationForm__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
var mapPropsToFields=function mapPropsToFields(_ref){var AnnotationTabs=_ref.AnnotationTabs;return{IsTextCollapsed:__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.createFormField({value:AnnotationTabs?AnnotationTabs.IsTextCollapsed:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var CustomAnnotationsForm=function CustomAnnotationsForm(_ref3){var t=_ref3.t,form=_ref3.form,AnnotationTabs=_ref3.AnnotationTabs,_onChange=_ref3.onChange;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.annotationTabs.isTextCollapsed.label")+' :'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,null,form.getFieldDecorator("IsTextCollapsed",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.annotationTabs.annotationTabs.label')},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_form_list__["a" /* default */],{addItemLabel:t('scenes.configuration.nodesConfig.annotationTabs.annotationTabs.addButton.title'),removeItemLabel:t('scenes.configuration.nodesConfig.annotationTabs.annotationTabs.removeButton.title'),values:AnnotationTabs.Tabs||[],Component:__WEBPACK_IMPORTED_MODULE_11__CustomAnnotationForm__["a" /* default */],newItem:{Name:null,Annotations:[{Name:null,IsVisible:true}],IsVisible:true},onChange:function onChange(tabs){return _onChange({Tabs:tabs});}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(CustomAnnotationsForm));

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_form_list__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AnnotationForm__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_multilanguage_input__ = __webpack_require__(89);
var mapPropsToFields=function mapPropsToFields(_ref){var AnnotationTab=_ref.value;return{Name:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AnnotationTab?AnnotationTab.Name:null}),Label:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AnnotationTab?AnnotationTab.Label:null}),IsVisible:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AnnotationTab?AnnotationTab.IsVisible:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var CustomAnnotationForm=function CustomAnnotationForm(_ref3){var t=_ref3.t,form=_ref3.form,AnnotationTab=_ref3.value,_onChange=_ref3.onChange;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.nodesConfig.annotationTabs.annotationTabs.annotationTab.name.label')},form.getFieldDecorator('Name')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.annotationTabs.annotationTabs.annotationTab.label.label')},form.getFieldDecorator('Label')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_multilanguage_input__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.annotationTabs.annotationTabs.annotationTab.isVisible.label")+' :'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,null,form.getFieldDecorator("IsVisible",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null)))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.nodesConfig.annotationTabs.annotationTabs.annotationTab.annotations.label')},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_form_list__["a" /* default */],{compact:true,values:AnnotationTab.Annotations||[],minItems:1,Component:__WEBPACK_IMPORTED_MODULE_15__AnnotationForm__["a" /* default */],newItem:{Name:null,IsVisible:true},addItemLabel:t('scenes.configuration.nodesConfig.annotationTabs.annotationTabs.annotationTab.annotations.addButton.title'),removeItemLabel:t('scenes.configuration.nodesConfig.annotationTabs.annotationTabs.annotationTab.annotations.removeButton.title'),onChange:function onChange(arr){return _onChange({Annotations:arr});}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(CustomAnnotationForm));

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_multilanguage_input__ = __webpack_require__(89);
var mapPropsToFields=function mapPropsToFields(_ref){var Annotation=_ref.value;return{Name:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotation?Annotation.Name:null}),Label:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotation?Annotation.Label:null}),IsVisible:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotation?Annotation.IsVisible:false})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var AnnotationForm=function AnnotationForm(_ref3){var t=_ref3.t,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{layout:"inline"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.nodesConfig.annotationTabs.annotationTabs.annotationTab.annotations.annotation.name.label')},form.getFieldDecorator('Name')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.annotationTabs.annotationTabs.annotationTab.annotations.annotation.label.label')},form.getFieldDecorator('Label')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_multilanguage_input__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.annotationTabs.annotationTabs.annotationTab.annotations.annotation.isVisible.label')},form.getFieldDecorator('IsVisible',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,null))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(AnnotationForm));

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
var mapPropsToFields=function mapPropsToFields(_ref){var Proxy=_ref.Proxy;return{Enabled:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:Proxy?Proxy.Enabled:null}),Address:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:Proxy&&Proxy.Address?Proxy.Address:""}),Port:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:Proxy?Proxy.Port:null}),Username:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:Proxy&&Proxy.Username?Proxy.Username:""}),Password:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:Proxy&&Proxy.Password?Proxy.Password:""})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var ProxyForm=function ProxyForm(_ref3){var t=_ref3.t,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.node.proxy.enabled.label")+' :'),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,null,form.getFieldDecorator("Enabled",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,null))))),form.getFieldValue('Enabled')&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.node.proxy.address.label'),style:{marginBottom:0}},form.getFieldDecorator('Address')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.node.proxy.port.label'),style:{marginBottom:0}},form.getFieldDecorator('Port')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default.a,{min:0,style:{width:"100%"}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.node.proxy.username.label'),style:{marginBottom:0}},form.getFieldDecorator('Username')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.node.proxy.password.label'),style:{marginBottom:0}},form.getFieldDecorator('Password')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null)))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ProxyForm));

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_input_list_form__ = __webpack_require__(360);
var SearchForm=function SearchForm(_ref){var t=_ref.t,Search=_ref.Search,_onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.search.excludeCodelists.label')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_input_list_form__["a" /* default */],{values:Search.ExcludeCodelists||[],onChange:function onChange(arr){return _onChange({ExcludeCodelists:arr});},addItemLabel:t('scenes.configuration.nodesConfig.search.excludeCodelists.addButton.title'),removeItemLabel:t('scenes.configuration.nodesConfig.search.excludeCodelists.removeButton.title')})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.search.excludeConceptSchemes.label')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_input_list_form__["a" /* default */],{values:Search.ExcludeConceptSchemes||[],onChange:function onChange(arr){return _onChange({ExcludeConceptSchemes:arr});},addItemLabel:t('scenes.configuration.nodesConfig.search.excludeConceptSchemes.addButton.title'),removeItemLabel:t('scenes.configuration.nodesConfig.search.excludeConceptSchemes.removeButton.title')})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])()(SearchForm));

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_constants__);
var mapPropsToFields=function mapPropsToFields(_ref){var Annotations=_ref.Annotations;return{ConceptSchemesOrder:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.ConceptSchemesOrder?Annotations.ConceptSchemesOrder:""}),CategorySchemesOrder:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.CategorySchemesOrder?Annotations.CategorySchemesOrder:""}),CodelistsOrder:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.CodelistsOrder?Annotations.CodelistsOrder:""}),CategorisationsOrder:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.CategorisationsOrder?Annotations.CategorisationsOrder:""}),LayoutRow:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutRow?Annotations.LayoutRow:""}),LayoutColumn:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutColumn?Annotations.LayoutColumn:""}),LayoutFilter:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutFilter?Annotations.LayoutFilter:""}),LayoutRowSection:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutRowSection?Annotations.LayoutRowSection:""}),LayoutChartPrimaryDim:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutChartPrimaryDim?Annotations.LayoutChartPrimaryDim:""}),LayoutChartSecondaryDim:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutChartSecondaryDim?Annotations.LayoutChartSecondaryDim:""}),LayoutChartFilter:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutChartFilter?Annotations.LayoutChartFilter:""}),LayoutDataflowKeywords:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutDataflowKeywords?Annotations.LayoutDataflowKeywords:""}),LayoutCriteriaSelection:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutCriteriaSelection?Annotations.LayoutCriteriaSelection:""}),LayoutAttachedDataFiles:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutAttachedDataFiles?Annotations.LayoutAttachedDataFiles:""}),LayoutDefaultPresentation:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutDefaultPresentation?Annotations.LayoutDefaultPresentation:""}),LayoutDecimalSeparator:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutDecimalSeparator?Annotations.LayoutDecimalSeparator:""}),LayoutNumberOfDecimals:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutNumberOfDecimals?Annotations.LayoutNumberOfDecimals:""}),LayoutReferenceMetadata:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutReferenceMetadata?Annotations.LayoutReferenceMetadata:""}),LayoutEmptyCellPlaceholder:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutEmptyCellPlaceholder?Annotations.LayoutEmptyCellPlaceholder:""}),LayoutDataflowNotes:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutDataflowNotes?Annotations.LayoutDataflowNotes:""}),LayoutTerritorialDimensionIds:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutTerritorialDimensionIds?Annotations.LayoutTerritorialDimensionIds:""}),LayoutDataflowSource:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutDataflowSource?Annotations.LayoutDataflowSource:""}),LayoutDataflowHidden:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LayoutDataflowHidden?Annotations.LayoutDataflowHidden:""}),NotDisplayed:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.NotDisplayed?Annotations.NotDisplayed:""}),FullName:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.FullName?Annotations.FullName:""}),Default:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.Default?Annotations.Default:""}),VirtualDataflowNode:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.VirtualDataflowNode?Annotations.VirtualDataflowNode:""}),DDBDataflow:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.DDBDataflow?Annotations.DDBDataflow:""}),CustomDSD:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.CustomDSD?Annotations.CustomDSD:""}),AssociatedCube:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.AssociatedCube?Annotations.AssociatedCube:""}),Changed:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.Changed?Annotations.Changed:""}),Metadataset:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.Metadataset?Annotations.Metadataset:""}),HaveMetadata:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.HaveMetadata?Annotations.HaveMetadata:""}),RestrictedForPublication:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.RestrictedForPublication?Annotations.RestrictedForPublication:""}),AttachedFilePath:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.AttachedFilePath?Annotations.AttachedFilePath:""}),DCAT_IsMultilingual:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.DCAT_IsMultilingual?Annotations.DCAT_IsMultilingual:""}),CustomIsPresentational:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.CustomIsPresentational?Annotations.CustomIsPresentational:""}),LastUpdate:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.LastUpdate?Annotations.LastUpdate:""}),DataflowCatalogType:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:Annotations&&Annotations.DataflowCatalogType?Annotations.DataflowCatalogType:""})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var AnnotationsForm=function AnnotationsForm(_ref3){var t=_ref3.t,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',title:t("data.nodesConfig.annotations.cards.order.label"),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.conceptSchemesOrderAnnotation.label'),style:{marginBottom:0}},form.getFieldDecorator('ConceptSchemesOrder')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.categorySchemesOrderAnnotation.label'),style:{marginBottom:0}},form.getFieldDecorator('CategorySchemesOrder')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.codelistsOrderAnnotation.label'),style:{marginBottom:0}},form.getFieldDecorator('CodelistsOrder')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.categorisationsOrderAnnotation.label'),style:{marginBottom:0}},form.getFieldDecorator('CategorisationsOrder')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null)))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',title:t("data.nodesConfig.annotations.cards.layout.label"),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutRow.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutRow')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutColumn.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutColumn')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutFilter.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutFilter')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutRowSection.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutRowSection')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutChartPrimaryDim.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutChartPrimaryDim')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutChartSecondaryDim.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutChartSecondaryDim')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutChartFilter.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutChartFilter')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutDataflowKeywords.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutDataflowKeywords')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutCriteriaSelection.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutCriteriaSelection')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutAttachedDataFiles.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutAttachedDataFiles')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutDefaultPresentation.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutDefaultPresentation')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutDecimalSeparator.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutDecimalSeparator')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutNumberOfDecimals.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutNumberOfDecimals')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutReferenceMetadata.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutReferenceMetadata')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutEmptyCellPlaceholder.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutEmptyCellPlaceholder')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutDataflowNotes.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutDataflowNotes')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutTerritorialDimensionIds.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutTerritorialDimensionIds')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutDataflowSource.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutDataflowSource')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.layoutHidden.label'),style:{marginBottom:0}},form.getFieldDecorator('LayoutDataflowHidden')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.notDisplayed.label'),style:{marginBottom:0}},form.getFieldDecorator('NotDisplayed')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.fullName.label'),style:{marginBottom:0}},form.getFieldDecorator('FullName')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.default.label'),style:{marginBottom:0}},form.getFieldDecorator('Default')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null)))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.virtualDataflowNode.label'),style:{marginBottom:0}},form.getFieldDecorator('VirtualDataflowNode')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.dDBDataflow.label'),style:{marginBottom:0}},form.getFieldDecorator('DDBDataflow')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.customDSD.label'),style:{marginBottom:0}},form.getFieldDecorator('CustomDSD')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.associatedCube.label'),style:{marginBottom:0}},form.getFieldDecorator('AssociatedCube')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.changed.label'),style:{marginBottom:0}},form.getFieldDecorator('Changed')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.metadataset.label'),style:{marginBottom:0}},form.getFieldDecorator('Metadataset')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.haveMetadata.label'),style:{marginBottom:0}},form.getFieldDecorator('HaveMetadata')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.restrictedForPublication.label'),style:{marginBottom:0}},form.getFieldDecorator('RestrictedForPublication')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.attachedFilePath.label'),style:{marginBottom:0}},form.getFieldDecorator('AttachedFilePath')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.dcatIsMultilingual.label'),style:{marginBottom:0}},form.getFieldDecorator('DCAT_IsMultilingual')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.customIsPresentational.label'),style:{marginBottom:0}},form.getFieldDecorator('CustomIsPresentational')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.lastUpdate.label'),style:{marginBottom:0}},form.getFieldDecorator('LastUpdate')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.annotations.dataflowCatalogType.label'),style:{marginBottom:0}},form.getFieldDecorator('DataflowCatalogType')(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,null))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(AnnotationsForm));

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(117);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMsdsShow:function onMsdsShow(nodeIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["G" /* showNodesConfigMsds */])(nodeIndex));},onMsdUnset:function onMsdUnset(nodeIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["K" /* unsetNodesConfigMsd */])(nodeIndex));}};};var mapPropsToFields=function mapPropsToFields(_ref){var DcatApIt=_ref.DcatApIt;return{MSD:__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.createFormField({value:DcatApIt?DcatApIt.MSD:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var DcatApItForm=function DcatApItForm(_ref3){var t=_ref3.t,form=_ref3.form,nodeIndex=_ref3.nodeIndex,onMsdsShow=_ref3.onMsdsShow,onMsdUnset=_ref3.onMsdUnset;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,{label:t("data.nodesConfig.dcatApIt.msd.label"),style:{marginBottom:0}},form.getFieldDecorator("MSD")(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_selector__["a" /* default */],{selectTitle:t('data.nodesConfig.dcatApIt.msd.select.title'),resetTitle:t('data.nodesConfig.dcatApIt.msd.reset.title'),onSelect:function onSelect(){return onMsdsShow(nodeIndex);},onReset:function onReset(){return onMsdUnset(nodeIndex);}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps))(DcatApItForm));

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tooltip_style__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tooltip__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_constants__);
var mapPropsToFields=function mapPropsToFields(_ref){var DataBrowser=_ref.DataBrowser;return{DataBrowserUrl:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.DataBrowserUrl?DataBrowser.DataBrowserUrl:""}),NodeID:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.NodeID?DataBrowser.NodeID:""}),Enable:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.Enable?DataBrowser.Enable:false}),URL:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.URL?DataBrowser.URL:""}),Username:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.Username?DataBrowser.Username:""}),Password:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.Password?DataBrowser.Password:""}),HTTPAuthEnable:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.HTTPAuthEnable?DataBrowser.HTTPAuthEnable:false}),HTTPAuthUsername:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.HTTPAuthUsername?DataBrowser.HTTPAuthUsername:""}),HTTPAuthPassword:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.HTTPAuthPassword?DataBrowser.HTTPAuthPassword:""}),HTTPAuthDomain:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.HTTPAuthDomain?DataBrowser.HTTPAuthDomain:""}),ProxyEnable:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.ProxyEnable?DataBrowser.ProxyEnable:false}),ProxyURL:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.ProxyURL?DataBrowser.ProxyURL:""}),ProxyPort:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.ProxyPort?DataBrowser.ProxyPort:""}),ProxyUsername:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.ProxyUsername?DataBrowser.ProxyUsername:""}),ProxyPassword:__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.createFormField({value:DataBrowser&&DataBrowser.ProxyPassword?DataBrowser.ProxyPassword:""})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var DataBrowserForm=function DataBrowserForm(_ref3){var t=_ref3.t,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.dataBrowser.publicUrl.label'),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},form.getFieldDecorator('DataBrowserUrl')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:form.getFieldValue("DataBrowserUrl")||form.getFieldValue("Enable")?"form-item-required":null,label:t('data.nodesConfig.dataBrowser.nodeId.label'),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},form.getFieldDecorator('NodeID',{normalize:__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.toUpper})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:'inner',style:{marginTop:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"],marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.dataBrowser.enableCacheInvalidation.label")+' :'),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,form.getFieldDecorator("Enable",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox___default.a,null))))),form.getFieldValue("Enable")&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.dataBrowser.apiUrl.label'),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},form.getFieldDecorator('URL')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:'inner',title:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,t("data.nodesConfig.dataBrowser.cards.authentication.label"),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tooltip___default.a,{title:t("data.nodesConfig.dataBrowser.cards.authentication.tooltip")},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:'info-circle',style:{marginLeft:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_SM"]}})))},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.dataBrowser.username.label'),style:{marginBottom:0}},form.getFieldDecorator('Username')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.dataBrowser.password.label'),style:{marginBottom:0}},form.getFieldDecorator('Password')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{type:'password',autoComplete:'new-password'})))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:'inner',title:t("data.nodesConfig.dataBrowser.cards.httpAuthentication.label"),style:{marginTop:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"],marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.dataBrowser.httpAuthenticationEnable.label")+' :'),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,form.getFieldDecorator("HTTPAuthEnable",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox___default.a,null))))),form.getFieldValue("HTTPAuthEnable")&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.dataBrowser.httpAuthenticationUsername.label'),style:{marginBottom:0}},form.getFieldDecorator('HTTPAuthUsername')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.dataBrowser.httpAuthenticationPassword.label'),style:{marginBottom:0}},form.getFieldDecorator('HTTPAuthPassword')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.dataBrowser.httpAuthenticationDomain.label'),style:{marginBottom:0}},form.getFieldDecorator('HTTPAuthDomain')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:'inner',title:t("data.nodesConfig.dataBrowser.cards.proxy.label")},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.dataBrowser.proxyEnable.label")+' :'),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,form.getFieldDecorator("ProxyEnable",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox___default.a,null))))),form.getFieldValue("ProxyEnable")&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.dataBrowser.proxyUrl.label'),style:{marginBottom:0}},form.getFieldDecorator('ProxyURL')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.nodesConfig.dataBrowser.proxyPort.label'),style:{marginBottom:0}},form.getFieldDecorator('ProxyPort')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default.a,{min:0,style:{width:"100%"}}))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.dataBrowser.proxyUsername.label'),style:{marginBottom:0}},form.getFieldDecorator('ProxyUsername')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.dataBrowser.proxyPassword.label'),style:{marginBottom:0}},form.getFieldDecorator('ProxyPassword')(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{type:'password',autoComplete:'new-password'}))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(DataBrowserForm));

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_input_list_form__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__ = __webpack_require__(37);
var upperCaseStyle={textTransform:"uppercase"};var mapPropsToFields=function mapPropsToFields(_ref){var AST=_ref.AST;return{Enabled:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AST&&AST.Enabled?AST.Enabled:false}),TerritorialDimIds:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AST&&AST.TerritorialDimIds?AST.TerritorialDimIds:[]}),ASTTerritoryDimId:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AST&&AST.ASTTerritoryDimId?AST.ASTTerritoryDimId:""}),ASTTerritorialCodelist:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AST&&AST.ASTTerritorialCodelist?AST.ASTTerritorialCodelist:""}),ASTTerritoryConceptScheme:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AST&&AST.ASTTerritoryConceptScheme?AST.ASTTerritoryConceptScheme:""}),ASTTerritoryConcept:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:AST&&AST.ASTTerritoryConcept?AST.ASTTerritoryConcept:""})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var AstForm=function AstForm(_ref3){var t=_ref3.t,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.ast.enabled.label")+' :'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,null,form.getFieldDecorator("Enabled",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))))),form.getFieldValue('Enabled')&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.ast.territorialDimIds.label'),className:'form-item-required'},form.getFieldDecorator('TerritorialDimIds',{valuePropName:'values'})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_input_list_form__["a" /* default */],{addItemLabel:t('scenes.configuration.nodesConfig.ast.territorialDimIds.addButton.title'),removeItemLabel:t('scenes.configuration.nodesConfig.ast.territorialDimIds.removeButton.title'),validateId:true}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.ast.astTerritoryDimId.label'),className:'form-item-required',validateStatus:form.getFieldValue('ASTTerritoryDimId')&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('ASTTerritoryDimId')).help?"warning":null,help:form.getFieldValue('ASTTerritoryDimId')&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('ASTTerritoryDimId')).help},form.getFieldDecorator('ASTTerritoryDimId',{getValueFromEvent:function getValueFromEvent(e){return(e.target.value||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{style:upperCaseStyle}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.ast.astTerritorialCodelist.label'),className:'form-item-required',validateStatus:form.getFieldValue('ASTTerritorialCodelist')&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["h" /* isStrTripletValidWithHelp */])(t,form.getFieldValue('ASTTerritorialCodelist')).help?"warning":null,help:form.getFieldValue('ASTTerritorialCodelist')&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["h" /* isStrTripletValidWithHelp */])(t,form.getFieldValue('ASTTerritorialCodelist')).help},form.getFieldDecorator('ASTTerritorialCodelist',{getValueFromEvent:function getValueFromEvent(e){return(e.target.value||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{style:upperCaseStyle}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.ast.astTerritoryConceptScheme.label'),className:'form-item-required',validateStatus:form.getFieldValue('ASTTerritoryConceptScheme')&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["h" /* isStrTripletValidWithHelp */])(t,form.getFieldValue('ASTTerritoryConceptScheme')).help?"warning":null,help:form.getFieldValue('ASTTerritoryConceptScheme')&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["h" /* isStrTripletValidWithHelp */])(t,form.getFieldValue('ASTTerritoryConceptScheme')).help},form.getFieldDecorator('ASTTerritoryConceptScheme',{getValueFromEvent:function getValueFromEvent(e){return(e.target.value||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{style:upperCaseStyle}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.ast.astTerritoryConcept.label'),className:'form-item-required',validateStatus:form.getFieldValue('ASTTerritoryConcept')&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('ASTTerritoryConcept')).help?"warning":null,help:form.getFieldValue('ASTTerritoryConcept')&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue('ASTTerritoryConcept')).help},form.getFieldDecorator('ASTTerritoryConcept',{getValueFromEvent:function getValueFromEvent(e){return(e.target.value||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{style:upperCaseStyle})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(AstForm));

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_input_list_form__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LoginProvidersForm__ = __webpack_require__(584);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapPropsToFields=function mapPropsToFields(_ref){var LoginProvider=_ref.value;return{AppId:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.AppId?LoginProvider.AppId:null}),AppSecret:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.AppSecret?LoginProvider.AppSecret:null}),AuthorizationURL:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.AuthorizationURL?LoginProvider.AuthorizationURL:null}),Enabled:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider?LoginProvider.Enabled:true}),GrantType:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.GrantType?LoginProvider.GrantType:null}),Label:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.Label?LoginProvider.Label:null}),LoginBaseURL:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.LoginBaseURL?LoginProvider.LoginBaseURL:null}),ProviderName:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.ProviderName?LoginProvider.ProviderName:null}),UserPassword:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.UserPassword?LoginProvider.UserPassword:null}),SuperadminMails:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:LoginProvider&&LoginProvider.SuperadminMails?LoginProvider.SuperadminMails:[]})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var LoginProviderForm=function LoginProviderForm(_ref3){var t=_ref3.t,form=_ref3.form,LoginProvider=_ref3.value,availableProviders=_ref3.availableProviders;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.nodesConfig.loginProvider.providerName.label')},form.getFieldDecorator('ProviderName')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a,{style:{width:"100%"},disabled:LoginProvider.IsNewProvider!==true},__WEBPACK_IMPORTED_MODULE_18__LoginProvidersForm__["a" /* PROVIDERS */].map(function(provider,idx){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{key:idx,value:provider,disabled:![].concat(_toConsumableArray(availableProviders),[form.getFieldValue("ProviderName")]).includes(provider)},provider);})))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.nodesConfig.loginProvider.enabled.label")+' :'),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,null,form.getFieldDecorator("Enabled",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.loginProvider.label.label')},form.getFieldDecorator('Label')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.nodesConfig.loginProvider.loginBaseUrl.label')},form.getFieldDecorator('LoginBaseURL')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.nodesConfig.loginProvider.authorizationUrl.label')},form.getFieldDecorator('AuthorizationURL')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.nodesConfig.loginProvider.appId.label')},form.getFieldDecorator('AppId')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,null))),LoginProvider.IsNewProvider===true&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.loginProvider.grantType.label')},form.getFieldDecorator('GrantType')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.loginProvider.appSecret.label')},form.getFieldDecorator('AppSecret')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.loginProvider.userPassword.label')},form.getFieldDecorator('UserPassword')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{type:"password"})))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('data.nodesConfig.loginProvider.superadminMails.label')},form.getFieldDecorator('SuperadminMails',{valuePropName:'values'})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_input_list_form__["a" /* default */],{addItemLabel:t('scenes.configuration.nodesConfig.loginProvider.superadminMails.addButton.title'),removeItemLabel:t('scenes.configuration.nodesConfig.loginProvider.superadminMails.removeButton.title')}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(LoginProviderForm));

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_TWO_THIRDS"]}};var NodeCredentialsModal=function NodeCredentialsModal(_ref){var t=_ref.t,form=_ref.form,modal=_ref.modal,onSubmit=_ref.onSubmit;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"],marginTop:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.username.label')},formItemLayout,{className:'form-item-required'}),form.getFieldDecorator('username')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{autoComplete:'username'}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.password.label')},formItemLayout,{className:'form-item-required'}),form.getFieldDecorator('password')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{type:'password',autoComplete:'current-password'}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',gutter:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){modal.destroy();}},t('scenes.configuration.nodesConfig.nodeCredentialsModal.cancel.title'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:'primary',icon:'save',disabled:!form.getFieldValue('username')||form.getFieldValue('username').length<1,onClick:function onClick(){modal.destroy();onSubmit(form.getFieldValue('username'),form.getFieldValue('password'));},htmlType:'submit'},t('scenes.configuration.nodesConfig.nodeCredentialsModal.submit.title')))));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(NodeCredentialsModal));

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_menus__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_form_list__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LanguageForm__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__constants_paths__ = __webpack_require__(124);
var mapStateToProps=function mapStateToProps(state){return{UserInterface:state.scenes.configuration.appConfig.config.UserInterface};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["n" /* changeAppConfigUserInterfaceForm */])(fields));}};};var mapPropsToFields=function mapPropsToFields(_ref){var UserInterface=_ref.UserInterface;return{MaxTreeNodes:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.MaxTreeNodes:null}),MaxTreeNodesForPagination:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.MaxTreeNodesForPagination:null}),MinTreeNodesForPagination:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.MinTreeNodesForPagination:null}),MaxNodeForExpandAll:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.MaxNodeForExpandAll:null}),TreePageSize:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.TreePageSize:null}),DefaultSidebarCollapsed:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.DefaultSidebarCollapsed:null}),Languages:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.Languages:null}),DefaultLanguage:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.DefaultLanguage:null}),AnonymousPages:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:UserInterface!==null?UserInterface.AnonymousPages:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var UserInterfaceForm=function UserInterfaceForm(_ref3){var t=_ref3.t,form=_ref3.form,UserInterface=_ref3.UserInterface,_onChange=_ref3.onChange;var allNodes=Object(__WEBPACK_IMPORTED_MODULE_20__utils_tree__["l" /* getNodes */])(Object(__WEBPACK_IMPORTED_MODULE_18__constants_menus__["b" /* userMenu */])(t).concat(Object(__WEBPACK_IMPORTED_MODULE_18__constants_menus__["a" /* superUserMenu */])(t)),"children",function(node){return!node.isDivider;}).map(function(_ref4){var path=_ref4.path;return path;});return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t("data.appConfig.userInterfaceForm.maxTreeNodes.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("MaxTreeNodes")(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default.a,{title:form.getFieldValue("MaxTreeNodes"),min:0,style:{width:"100%"}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t("data.appConfig.userInterfaceForm.maxTreeNodesForPagination.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("MaxTreeNodesForPagination")(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default.a,{title:form.getFieldValue("MaxTreeNodesForPagination"),min:0,style:{width:"100%"}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t("data.appConfig.userInterfaceForm.minTreeNodesForPagination.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("MinTreeNodesForPagination")(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default.a,{title:form.getFieldValue("MinTreeNodesForPagination"),min:0,style:{width:"100%"}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t("data.appConfig.userInterfaceForm.maxNodeForExpandAll.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("MaxNodeForExpandAll")(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default.a,{title:form.getFieldValue("MaxNodeForExpandAll"),min:0,style:{width:"100%"}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t("data.appConfig.userInterfaceForm.treePageSize.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("TreePageSize")(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default.a,{title:form.getFieldValue("TreePageSize"),min:0,style:{width:"100%"}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.appConfig.userInterfaceForm.defaultSidebarCollapsed.label")+' :'),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,null,form.getFieldDecorator("DefaultSidebarCollapsed",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null)))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t("data.appConfig.userInterfaceForm.languages.label"),className:'form-item-required',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_form_list__["a" /* default */],{compact:true,values:UserInterface?UserInterface.Languages:null,Component:__WEBPACK_IMPORTED_MODULE_23__LanguageForm__["a" /* default */],newItem:{code:null,flag:null},minItems:1,addItemLabel:t("data.appConfig.userInterfaceForm.languages.buttons.add.label"),removeItemLabel:t("data.appConfig.userInterfaceForm.languages.buttons.remove.label"),onChange:function onChange(langs){return _onChange({Languages:langs});}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t("data.appConfig.userInterfaceForm.defaultLanguage.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("DefaultLanguage")(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue("DefaultLanguage")}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t("data.appConfig.userInterfaceForm.anonymousPages.label"),className:'form-item-required',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_enhanced_tree__["a" /* default */],{tree:Object(__WEBPACK_IMPORTED_MODULE_20__utils_tree__["f" /* getFilteredTree */])(Object(__WEBPACK_IMPORTED_MODULE_18__constants_menus__["b" /* userMenu */])(t).filter(function(_ref5){var path=_ref5.path;return path!==__WEBPACK_IMPORTED_MODULE_24__constants_paths__["s" /* PATH_DATA_MANAGER */];}).concat(Object(__WEBPACK_IMPORTED_MODULE_18__constants_menus__["a" /* superUserMenu */])(t)),"children",function(node){return!node.isDivider;}),childrenKey:'children',idKey:'path',nameKey:'label',catIdKey:'path',catNameKey:'label',hiddenIdKeys:allNodes,getFilter:function getFilter(searchText){return function(_ref6){var label=_ref6.label;return label&&label.toLowerCase().indexOf(searchText.toLowerCase())>=0;};},getIsNameMultilanguage:function getIsNameMultilanguage(){return false;},unselectableKeys:allNodes,checkable:true,checkStrictly:true,checkedKeys:UserInterface?UserInterface.AnonymousPages:[],onCheck:function onCheck(_ref7){var checked=_ref7.checked;return _onChange({AnonymousPages:checked});},noPagination:true,isRootIconLikeChildrenIcon:true,icon:'file'}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(UserInterfaceForm));

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AgencyForm__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_list__ = __webpack_require__(114);
var mapStateToProps=function mapStateToProps(state){return{Agencies:state.scenes.configuration.appConfig.config.Agencies};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["i" /* changeAppConfigAgenciesForm */])(fields));}};};var AgenciesForm=function AgenciesForm(_ref){var t=_ref.t,Agencies=_ref.Agencies,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,{label:t("data.appConfig.agencies.agencies.label")},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_form_list__["a" /* default */],{compact:true,values:Agencies,Component:__WEBPACK_IMPORTED_MODULE_7__AgencyForm__["a" /* default */],newItem:{Id:null,Name:null},onChange:onChange,addItemLabel:t('data.appConfig.agencies.agencies.buttons.add.label'),removeItemLabel:t('data.appConfig.agencies.agencies.buttons.remove.label')}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(AgenciesForm));

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_artefactValidators__ = __webpack_require__(37);
var mapPropsToFields=function mapPropsToFields(_ref){var value=_ref.value;return{Id:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:value!==null?value.Id:null}),Name:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:value!==null?value.Name:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var AgencyForm=function AgencyForm(_ref3){var t=_ref3.t,value=_ref3.value,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a,{layout:"inline"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("scenes.configuration.appConfig.agencyForm.id"),className:'form-item-required',style:{marginBottom:0},validateStatus:value&&Object(__WEBPACK_IMPORTED_MODULE_9__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,value.Id).help?"warning":null,help:value&&Object(__WEBPACK_IMPORTED_MODULE_9__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,value.Id).help},form.getFieldDecorator("Id",{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue("Id"),style:{textTransform:"uppercase"}}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("scenes.configuration.appConfig.agencyForm.name"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("Name")(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_multilanguage_input__["a" /* default */],{title:form.getFieldValue("Name")}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(AgencyForm));

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LanguageForm__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_form_list__ = __webpack_require__(114);
var mapStateToProps=function mapStateToProps(state){return{DataManagement:state.scenes.configuration.appConfig.config.DataManagement};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["j" /* changeAppConfigDataManagementForm */])(fields));}};};var mapPropsToFields=function mapPropsToFields(_ref){var DataManagement=_ref.DataManagement;return{CubeCodePrefix:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:DataManagement!==null?DataManagement.CubeCodePrefix:null}),DataLanguages:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:DataManagement!==null?DataManagement.DataLanguages:null}),MaxDescriptionLength:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:DataManagement!==null?DataManagement.MaxDescriptionLength:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var DataManagementForm=function DataManagementForm(_ref3){var t=_ref3.t,form=_ref3.form,DataManagement=_ref3.DataManagement,_onChange=_ref3.onChange;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:t("data.appConfig.dataManagementForm.cubeCodePrefix.label"),style:{marginBottom:0}},form.getFieldDecorator("CubeCodePrefix")(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue("CubeCodePrefix")})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:t("data.appConfig.dataManagementForm.dataLanguages.label"),className:'form-item-required',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_form_list__["a" /* default */],{compact:true,values:DataManagement?DataManagement.DataLanguages:null,Component:__WEBPACK_IMPORTED_MODULE_12__LanguageForm__["a" /* default */],newItem:{code:null,flag:null},minItems:1,addItemLabel:t("data.appConfig.dataManagementForm.dataLanguages.buttons.add.label"),removeItemLabel:t("data.appConfig.dataManagementForm.dataLanguages.buttons.remove.label"),onChange:function onChange(langs){return _onChange({DataLanguages:langs});}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:t("data.appConfig.dataManagementForm.maxDescriptionLength.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("MaxDescriptionLength")(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default.a,{title:form.getFieldValue("MaxDescriptionLength"),min:0,style:{width:"100%"}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(DataManagementForm));

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
var mapStateToProps=function mapStateToProps(state){return{DefaultHeaderSubmitStructure:state.scenes.configuration.appConfig.config.DefaultHeaderSubmitStructure};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["k" /* changeAppConfigDefaultHeaderSubmitStructureForm */])(fields));}};};var mapPropsToFields=function mapPropsToFields(_ref){var DefaultHeaderSubmitStructure=_ref.DefaultHeaderSubmitStructure;return{ID:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:DefaultHeaderSubmitStructure!==null?DefaultHeaderSubmitStructure.ID:null}),test:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:DefaultHeaderSubmitStructure!==null?DefaultHeaderSubmitStructure.test:null}),sender:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:DefaultHeaderSubmitStructure!==null?DefaultHeaderSubmitStructure.sender:null}),receiver:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:DefaultHeaderSubmitStructure!==null?DefaultHeaderSubmitStructure.receiver:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var DefaultHeaderSubmitStructureForm=function DefaultHeaderSubmitStructureForm(_ref3){var t=_ref3.t,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t("data.appConfig.defaultHeaderSubmitStructureForm.id.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("ID")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{title:form.getFieldValue("ID")}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'start',align:'middle',gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_MD"],style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("data.appConfig.defaultHeaderSubmitStructureForm.test.label")+' :'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,null,form.getFieldDecorator("test",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,null))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t("data.appConfig.defaultHeaderSubmitStructureForm.sender.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("sender")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{title:form.getFieldValue("sender")}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:t("data.appConfig.defaultHeaderSubmitStructureForm.receiver.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("receiver")(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{title:form.getFieldValue("receiver")}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(DefaultHeaderSubmitStructureForm));

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_list__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SuperUserCredentialForm__ = __webpack_require__(1468);
var mapStateToProps=function mapStateToProps(state){return{SuperUserCredentials:state.scenes.configuration.appConfig.config.SuperUserCredentials};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["m" /* changeAppConfigSuperUserCredentialsForm */])(fields));}};};var SuperUserCredentialList=function SuperUserCredentialList(_ref){var t=_ref.t,SuperUserCredentials=_ref.SuperUserCredentials,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,{className:'form-item-required',label:t("data.appConfig.superUserCredentials.superUserCredentials.label")},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_form_list__["a" /* default */],{values:SuperUserCredentials,Component:__WEBPACK_IMPORTED_MODULE_8__SuperUserCredentialForm__["a" /* default */],newItem:{username:null,password:null,confirmPassword:null},minItems:1,addItemLabel:t("data.appConfig.superUserCredentials.superUserCredentials.buttons.add.label"),removeItemLabel:t("data.appConfig.superUserCredentials.superUserCredentials.buttons.remove.label"),onChange:onChange}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(SuperUserCredentialList));

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
var mapPropsToFields=function mapPropsToFields(_ref){var SuperUserCredential=_ref.value;return{username:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:SuperUserCredential!==null?SuperUserCredential.username:null}),password:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:SuperUserCredential!==null?SuperUserCredential.password:null}),confirmPassword:__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.createFormField({value:SuperUserCredential!==null?SuperUserCredential.confirmPassword:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var SuperUserCredentialForm=function SuperUserCredentialForm(_ref3){var t=_ref3.t,form=_ref3.form,SuperUserCredential=_ref3.value;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("data.appConfig.superUserCredentials.superUserCredentials.username.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("username")(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue("username"),autoComplete:'new-password'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("data.appConfig.superUserCredentials.superUserCredentials.password.label"),style:{marginBottom:0}},form.getFieldDecorator("password")(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue("password"),type:"password",autoComplete:'new-password'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{label:t("data.appConfig.superUserCredentials.superUserCredentials.confirmPassword.label"),style:{marginBottom:0},hasFeedback:true,validateStatus:SuperUserCredential&&SuperUserCredential.confirmPassword&&SuperUserCredential.confirmPassword.length>0&&SuperUserCredential.password!==SuperUserCredential.confirmPassword?"warning":null,help:SuperUserCredential&&SuperUserCredential.confirmPassword&&SuperUserCredential.confirmPassword.length>0&&SuperUserCredential.password!==SuperUserCredential.confirmPassword?t("commons.helps.passwordsNotEqual.label"):null},form.getFieldDecorator("confirmPassword")(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue("confirmPassword"),type:"password",autoComplete:'new-password'}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(SuperUserCredentialForm));

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(94);
var mapStateToProps=function mapStateToProps(state){return{EndpointSetting:state.scenes.configuration.appConfig.config.EndpointSetting};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["l" /* changeAppConfigEndpointSettingsForm */])(fields));}};};var mapPropsToFields=function mapPropsToFields(_ref){var EndpointSetting=_ref.EndpointSetting;return{NsiTimeOut:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:EndpointSetting!==null?EndpointSetting.NsiTimeOut:null}),DmTimeOut:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:EndpointSetting!==null?EndpointSetting.DmTimeOut:null}),MaTimeOut:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:EndpointSetting!==null?EndpointSetting.MaTimeOut:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var EndpointSettingsForm=function EndpointSettingsForm(_ref3){var t=_ref3.t,form=_ref3.form;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:t("data.appConfig.endpointSettingsForm.nsiTimeOut.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("NsiTimeOut")(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{title:form.getFieldValue("NsiTimeOut")}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:t("data.appConfig.endpointSettingsForm.dmTimeOut.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("DmTimeOut")(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default.a,{title:form.getFieldValue("DmTimeOut"),min:0,style:{width:"100%"}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:t("data.appConfig.endpointSettingsForm.maTimeOut.label"),className:'form-item-required',style:{marginBottom:0}},form.getFieldDecorator("MaTimeOut")(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input_number___default.a,{title:form.getFieldValue("MaTimeOut"),min:0,style:{width:"100%"}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(EndpointSettingsForm));

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_infinite_scroll_table__ = __webpack_require__(52);
var mapStateToProps=function mapStateToProps(state){return{file:state.scenes.utilities.importStructures.file,items:state.scenes.utilities.importStructures.items,hash:state.scenes.utilities.importStructures.hash,report:state.scenes.utilities.importStructures.report,selectedItems:state.scenes.utilities.importStructures.selectedItems};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["h" /* changeImportStructuresForm */])(fields));},onFileUpload:function onFileUpload(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["n" /* uploadImportStructuresFile */])(file));},onSubmit:function onSubmit(structures,hash){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["m" /* submitImportStructures */])(structures,hash));},onReportHide:function onReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["i" /* hideImportStructuresReport */])());},onReset:function onReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["j" /* resetImportStructures */])());},onItemSelect:function onItemSelect(item,selected){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["l" /* selectImportStructuresItem */])(item,selected));},onAllItemsSelect:function onAllItemsSelect(items){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["k" /* selectImportStructuresAllItems */])(items));}};};var mapPropsToFields=function mapPropsToFields(_ref){var file=_ref.file;return{file:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:file})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS="Success";var IMPORT_STRUCTURES_REPORT_STATUS_WARNING="Warning";var IMPORT_STRUCTURES_REPORT_STATUS_ERROR="Error";var IMPORT_STRUCTURES_REPORT_STATUS_FAILURE="Failure";var ImportStructures=function ImportStructures(_ref3){var t=_ref3.t,form=_ref3.form,file=_ref3.file,items=_ref3.items,selectedItems=_ref3.selectedItems,hash=_ref3.hash,report=_ref3.report,onFileUpload=_ref3.onFileUpload,onSubmit=_ref3.onSubmit,onReportHide=_ref3.onReportHide,onReset=_ref3.onReset,onItemSelect=_ref3.onItemSelect,onAllItemsSelect=_ref3.onAllItemsSelect;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_enhanced_modal__["a" /* default */],{visible:report!==null,title:t('scenes.utilities.importStructures.reportModal.title'),onCancel:onReportHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:onReportHide},t('commons.buttons.close.title'))},items!==null&&report!==null?report.map(function(_ref4,index){var maintainableObject=_ref4.maintainableObject,status=_ref4.status,result=_ref4.result,isFinal=_ref4.isFinal;var triplet=Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(maintainableObject);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:index>0?{marginTop:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}:null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,function(){var item=items.filter(function(item){return item.id===triplet.id&&item.agency===triplet.agencyID&&item.version===triplet.version;})[0];return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,(item?item.type+" ":"")+"["+Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(triplet)+"] ",__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b",null,(isFinal?t("data.artefact.isFinal.values.final"):t("data.artefact.isFinal.values.notFinal")).toLowerCase()));}()),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,status===IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.success')+" ",__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"check-circle",theme:"filled",style:{color:'green'}})),status===IMPORT_STRUCTURES_REPORT_STATUS_WARNING&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.warning')+" ",__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"exclamation-circle",theme:"filled",style:{color:'orange'}})),status===IMPORT_STRUCTURES_REPORT_STATUS_ERROR&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.error')+" ",__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"close-circle",theme:"filled",style:{color:'red'}})),status===IMPORT_STRUCTURES_REPORT_STATUS_FAILURE&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.error')+" ",__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"close-circle",theme:"filled",style:{color:'red'}})))),status!==IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("i",null,result));}):null),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["GUTTER_MD"],justify:"center"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{style:{width:480}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,{className:"advanced-form"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('data.csv.file.label')},form.getFieldDecorator('file')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_file_input__["a" /* default */],{accept:".xml"}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{icon:"upload",type:"primary",onClick:function onClick(){return onFileUpload(file);},disabled:file===null},t('data.xml.uploadButton.label'))),items!==null&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{icon:"delete",onClick:onReset,disabled:items===null},t('scenes.utilities.importStructures.resetButton.label')))))),items!==null&&file!==null&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",style:{marginTop:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_infinite_scroll_table__["a" /* default */],{data:items,getRowKey:function getRowKey(_ref5){var id=_ref5.id,agency=_ref5.agency,version=_ref5.version,type=_ref5.type;return type+Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agency,version:version});},showAllRows:true,getIsDisabledRow:function getIsDisabledRow(_ref6){var isOk=_ref6.isOk;return!isOk;},columns:[{title:t('data.artefact.type.shortLabel'),dataIndex:'type',minWidth:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["TABLE_COL_MIN_WIDTH_ID"],withValuesFilter:true},{title:t('data.artefact.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.agencyID.shortLabel'),dataIndex:'agency',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.name.shortLabel'),dataIndex:'name',minWidth:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.artefact.version.shortLabel'),dataIndex:'version',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.isFinal.shortLabel'),dataIndex:"isFinal",width:30,withValuesFilter:true,render:function render(isFinal){return isFinal?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"check"}):null;},renderText:function renderText(isFinal){return isFinal?t('data.artefact.isFinal.values.final'):t('data.artefact.isFinal.values.notFinal');}}],multilangStrDataIndexes:['name'],rowSelection:{selectedRowKeys:(selectedItems||[]).map(function(_ref7){var id=_ref7.id,agency=_ref7.agency,version=_ref7.version,type=_ref7.type;return type+Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agency,version:version});}),getCheckboxProps:function getCheckboxProps(_ref8){var isOk=_ref8.isOk;return{disabled:!isOk};},onSelect:function onSelect(itemKey,selected){return onItemSelect(items.find(function(_ref9){var id=_ref9.id,agency=_ref9.agency,version=_ref9.version,type=_ref9.type;return type+Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agency,version:version})===itemKey;}),selected);},onSelectAll:function onSelectAll(selected){return selected?onAllItemsSelect(items.filter(function(_ref10){var isOk=_ref10.isOk;return isOk;})):onAllItemsSelect(null);}},rightActions:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{icon:"check",type:"primary",onClick:function onClick(){return onSubmit(selectedItems,hash);},disabled:!selectedItems||selectedItems.length===0},t('scenes.utilities.importStructures.table.import.submit.title'))})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ImportStructures));

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_components_redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(334);
var mapStateToProps=function mapStateToProps(state){return{codelistDetail:state.scenes.metaManager.codelists.codelistDetail};};var Codelists=function Codelists(_ref){var codelistDetail=_ref.codelistDetail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_codelist_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_4__reducer__["a" /* MM_CODELISTS_PREFIX */],instanceState:codelistDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Codelists));

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,codelists:state.scenes.metaManager.codelists.codelists,codelistAnnotations:state.scenes.metaManager.codelists.codelistAnnotations,codelistAnnotationTriplet:state.scenes.metaManager.codelists.codelistAnnotationTriplet,parentsAndChildren:state.scenes.metaManager.codelists.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCreate:function onCreate(defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__["_44" /* createCodelistDetail */])(defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CODELISTS_PREFIX */]));},onDetail:function onDetail(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__["_49" /* editCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CODELISTS_PREFIX */]));},fetchCodelists:function fetchCodelists(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* readCodelistsListCodelists */])());},onCodelistDelete:function onCodelistDelete(codelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* deleteCodelistsCodelist */])(codelistTriplet));},onAnnotationsShow:function onAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* showCodelistsDetailAnnotations */])(annotations,triplet));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* hideCodelistsDetailAnnotations */])());},onSelectedCodelistsDelete:function onSelectedCodelistsDelete(codelistTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* deleteCodelistsSelectedCodelists */])(codelistTriplets));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__["_90" /* showCodelistDetailDownload */])(artefactTriplets,lang),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CODELISTS_PREFIX */]));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__["_88" /* showCodelistDetailClone */])(artefactTriplet),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CODELISTS_PREFIX */]));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__["_91" /* showCodelistDetailExport */])(sourceTriplet),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CODELISTS_PREFIX */]));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* readCodelistsCodelistParentsAndChildren */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* hideCodelistsCodelistParentsAndChildren */])());}};};var CodelistsList=function CodelistsList(_ref){var nodeId=_ref.nodeId,nodes=_ref.nodes,codelists=_ref.codelists,_onCreate=_ref.onCreate,onDetail=_ref.onDetail,fetchCodelists=_ref.fetchCodelists,onCodelistDelete=_ref.onCodelistDelete,codelistAnnotations=_ref.codelistAnnotations,codelistAnnotationTriplet=_ref.codelistAnnotationTriplet,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onSelectedCodelistsDelete=_ref.onSelectedCodelistsDelete,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchCodelists,disabled:codelists!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_artefact_list__["a" /* default */],{artefacts:codelists,onCreate:function onCreate(){return _onCreate(defaultItemsViewMode);},onDetailShow:function onDetailShow(triplet){return onDetail(triplet,defaultItemsViewMode);},onDownloadShow:onDownloadShow,onCloneShow:onCloneShow,onExportShow:onExportShow,onDelete:onCodelistDelete,onSelectedItemDelete:onSelectedCodelistsDelete,onAnnotationsShow:onAnnotationsShow,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("codelist",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__["a" /* default */],{annotations:codelistAnnotations,onClose:onAnnotationsHide,title:codelistAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_11__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(codelistAnnotationTriplet):null}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CodelistsList));

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_category_scheme_detail_modal__ = __webpack_require__(258);
var mapStateToProps=function mapStateToProps(state){return{categorySchemeDetail:state.scenes.metaManager.categorySchemes.categorySchemeDetail};};var CategorySchemes=function CategorySchemes(_ref){var categorySchemeDetail=_ref.categorySchemeDetail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_category_scheme_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* MM_CATEGORY_SCHEMES_PREFIX */],instanceState:categorySchemeDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CategorySchemes));

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_components_redux_category_scheme_detail_modal_actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,categorySchemes:state.scenes.metaManager.categorySchemes.categorySchemes,categorySchemeAnnotations:state.scenes.metaManager.categorySchemes.categorySchemeAnnotations,categorySchemeAnnotationTriplet:state.scenes.metaManager.categorySchemes.categorySchemeAnnotationTriplet,parentsAndChildren:state.scenes.metaManager.categorySchemes.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCreate:function onCreate(defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__redux_components_redux_category_scheme_detail_modal_actions__["_10" /* createCategorySchemeDetail */])(defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CATEGORY_SCHEMES_PREFIX */]));},onDetail:function onDetail(categorySchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__redux_components_redux_category_scheme_detail_modal_actions__["_15" /* editCategorySchemeDetail */])(categorySchemeTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CATEGORY_SCHEMES_PREFIX */]));},fetchCategorySchemes:function fetchCategorySchemes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* readCategorySchemesListCategorySchemes */])());},onCategorySchemeDelete:function onCategorySchemeDelete(categorySchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* deleteCategorySchemesCategoryScheme */])(categorySchemeTriplet));},onAnnotationsShow:function onAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* showCategorySchemesDetailAnnotations */])(annotations,triplet));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* hideCategorySchemesDetailAnnotations */])());},onSelectedCategorySchemesDelete:function onSelectedCategorySchemesDelete(categorySchemeTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* deleteCategorySchemesSelectedCategorySchemes */])(categorySchemeTriplets));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__redux_components_redux_category_scheme_detail_modal_actions__["_41" /* showCategorySchemeDetailDownload */])(artefactTriplets,lang),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CATEGORY_SCHEMES_PREFIX */]));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__redux_components_redux_category_scheme_detail_modal_actions__["_38" /* showCategorySchemeCategorySchemeClone */])(artefactTriplet),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CATEGORY_SCHEMES_PREFIX */]));},onExportShow:function onExportShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_9__redux_components_redux_category_scheme_detail_modal_actions__["_39" /* showCategorySchemeCategorySchemeExport */])(artefactTriplet),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CATEGORY_SCHEMES_PREFIX */]));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* readCategorySchemesCategorySchemeParentsAndChildren */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* hideCategorySchemesCategorySchemeParentsAndChildren */])());}};};var CategorySchemesList=function CategorySchemesList(_ref){var nodeId=_ref.nodeId,nodes=_ref.nodes,categorySchemes=_ref.categorySchemes,_onCreate=_ref.onCreate,onDetail=_ref.onDetail,fetchCategorySchemes=_ref.fetchCategorySchemes,onCategorySchemeDelete=_ref.onCategorySchemeDelete,categorySchemeAnnotations=_ref.categorySchemeAnnotations,categorySchemeAnnotationTriplet=_ref.categorySchemeAnnotationTriplet,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onSelectedCategorySchemesDelete=_ref.onSelectedCategorySchemesDelete,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchCategorySchemes,disabled:categorySchemes!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_artefact_list__["a" /* default */],{artefacts:categorySchemes,onCreate:function onCreate(){return _onCreate(defaultItemsViewMode);},onDetailShow:function onDetailShow(triplet){return onDetail(triplet,defaultItemsViewMode);},onDownloadShow:onDownloadShow,onCloneShow:onCloneShow,onExportShow:onExportShow,onDelete:onCategorySchemeDelete,onSelectedItemDelete:onSelectedCategorySchemesDelete,onAnnotationsShow:onAnnotationsShow,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("categoryscheme",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__["a" /* default */],{annotations:categorySchemeAnnotations,onClose:onAnnotationsHide,title:categorySchemeAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_11__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(categorySchemeAnnotationTriplet):null}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CategorySchemesList));

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Item__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_items_import_form__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_items_viewer__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_layout_annotation_list__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,appLanguage:state.app.language,categorySchemeTriplet:instanceState.categorySchemeTriplet,categoryScheme:instanceState.categoryScheme,selectedItem:instanceState.selectedItem,itemsViewMode:instanceState.itemsViewMode,isItemsImportFormVisible:instanceState.isItemsImportFormVisible,itemsImportForm:instanceState.itemsImportForm,itemAnnotations:instanceState.itemAnnotations,itemLayoutAnnotations:instanceState.itemLayoutAnnotations,itemAnnotationId:instanceState.itemAnnotationId,itemsTree:instanceState.itemsTree,maxOrder:instanceState.maxOrder,isDuplicateItemErrorVisible:instanceState.isDuplicateItemErrorVisible,cutItem:instanceState.cutItem,catSchemeCategorisations:instanceState.catSchemeCategorisations};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onViewModeChange:function onViewModeChange(viewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_8" /* changeCategorySchemeDetailItemsViewMode */])(viewMode),instancePrefix));},onCreate:function onCreate(parentId,order,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_11" /* createCategorySchemesDetailsItemsItem */])(parentId,order,lang,itemsOrderAnnotationType),instancePrefix));},onDetailEdit:function onDetailEdit(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_16" /* editCategorySchemesDetailItemsItem */])(item),instancePrefix));},onDelete:function onDelete(categoryScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_13" /* deleteCategorySchemeDetailsItemsItem */])(categoryScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType),instancePrefix));},onSelect:function onSelect(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_35" /* selectCategorySchemeDetailsItemsItem */])(id),instancePrefix));},onImportFormShow:function onImportFormShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_42" /* showCategorySchemeDetailItemsImportForm */])(),instancePrefix));},onImportFormHide:function onImportFormHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_23" /* hideCategorySchemeDetailItemsImportForm */])(),instancePrefix));},onImportFormChange:function onImportFormChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_6" /* changeCategorySchemeDetailItemsImportForm */])(fields),instancePrefix));},onImportFormFileUpload:function onImportFormFileUpload(categoryScheme,itemsImportForm){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_57" /* uploadCategorySchemeDetailItemsImportFormFile */])(categoryScheme,itemsImportForm),instancePrefix));},onImportFormFileImport:function onImportFormFileImport(categoryScheme,itemsImportForm){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_30" /* importCategorySchemeDetailItemsImportFormFile */])(categoryScheme,itemsImportForm),instancePrefix));},onAnnotationsShow:function onAnnotationsShow(annotations,itemId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_44" /* showCategorySchemeDetailItemsItemAnnotations */])(annotations,itemId),instancePrefix));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_26" /* hideCategorySchemeDetailItemsItemAnnotations */])(),instancePrefix));},onLayoutAnnotationsShow:function onLayoutAnnotationsShow(annotations,itemId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_45" /* showCategorySchemeDetailItemsItemLayoutAnnotations */])(annotations,itemId),instancePrefix));},onLayoutAnnotationsHide:function onLayoutAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_28" /* hideCategorySchemeDetailItemsItemLayoutAnnotations */])(),instancePrefix));},onDrop:function onDrop(node,newParent,newOrder,categoryScheme,itemsTree,categorisations,itemsOrderAnnotationType,lang,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_14" /* dropCategorySchemesDetailItemsItems */])(node,newParent,newOrder,categoryScheme,itemsTree,categorisations,itemsOrderAnnotationType,lang,cutItem,t),instancePrefix));},onDuplicateItemErrorHide:function onDuplicateItemErrorHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_27" /* hideCategorySchemeDetailItemsItemDuplicateItemError */])(),instancePrefix));},onCut:function onCut(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_12" /* cutCategorySchemeDetailItemsItem */])(item),instancePrefix));},onPaste:function onPaste(cutItem,newParent,pasteAfter,categoryScheme,itemsTree,categorisations,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_31" /* pasteCategorySchemeDetailItemsItem */])(cutItem,newParent,pasteAfter,categoryScheme,itemsTree,categorisations,lang,itemsOrderAnnotationType),instancePrefix));},onItemSubmit:function onItemSubmit(categoryScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_52" /* submitCategorySchemeDetailItemsItem */])(categoryScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t),instancePrefix));},onImportFormAllCsvRowsShow:function onImportFormAllCsvRowsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_43" /* showCategorySchemeDetailItemsImportFormAllCsvRows */])(),instancePrefix));},onImportFormAllCsvRowsHide:function onImportFormAllCsvRowsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_24" /* hideCategorySchemeDetailItemsImportFormAllCsvRows */])(),instancePrefix));},uploadImportFormCsv:function uploadImportFormCsv(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_56" /* uploadCategorySchemeDetailItemsImportFormCsv */])(file),instancePrefix));},fetchImportFormAllCsvRows:function fetchImportFormAllCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_34" /* readCategorySchemeDetailItemsImportFormAllCsvRows */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath),instancePrefix));},onSetDefaultOrder:function onSetDefaultOrder(categoryScheme,itemsTree,currLang,dataLangs,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_36" /* setCategorySchemeDetailItemsDefaultOrder */])(categoryScheme,itemsTree,currLang,dataLangs,itemsOrderAnnotationType),instancePrefix));}};};var CategorySchemeDetailItems=function CategorySchemeDetailItems(_ref3){var t=_ref3.t,nodes=_ref3.nodes,nodeId=_ref3.nodeId,appLanguage=_ref3.appLanguage,instanceState=_ref3.instanceState,instancePrefix=_ref3.instancePrefix,isEditDisabled=_ref3.isEditDisabled,categorySchemeTriplet=_ref3.categorySchemeTriplet,categoryScheme=_ref3.categoryScheme,itemsViewMode=_ref3.itemsViewMode,selectedItem=_ref3.selectedItem,isItemsImportFormVisible=_ref3.isItemsImportFormVisible,itemsImportForm=_ref3.itemsImportForm,onViewModeChange=_ref3.onViewModeChange,onCreate=_ref3.onCreate,onDetailEdit=_ref3.onDetailEdit,onDelete=_ref3.onDelete,onSelect=_ref3.onSelect,onImportFormShow=_ref3.onImportFormShow,onImportFormHide=_ref3.onImportFormHide,onImportFormChange=_ref3.onImportFormChange,onImportFormFileUpload=_ref3.onImportFormFileUpload,onImportFormFileImport=_ref3.onImportFormFileImport,itemAnnotations=_ref3.itemAnnotations,itemLayoutAnnotations=_ref3.itemLayoutAnnotations,itemAnnotationId=_ref3.itemAnnotationId,onAnnotationsShow=_ref3.onAnnotationsShow,onAnnotationsHide=_ref3.onAnnotationsHide,onLayoutAnnotationsShow=_ref3.onLayoutAnnotationsShow,onLayoutAnnotationsHide=_ref3.onLayoutAnnotationsHide,_onDrop=_ref3.onDrop,itemsTree=_ref3.itemsTree,catSchemeCategorisations=_ref3.catSchemeCategorisations,maxOrder=_ref3.maxOrder,isDuplicateItemErrorVisible=_ref3.isDuplicateItemErrorVisible,onDuplicateItemErrorHide=_ref3.onDuplicateItemErrorHide,cutItem=_ref3.cutItem,onCut=_ref3.onCut,_onPaste=_ref3.onPaste,onItemSubmit=_ref3.onItemSubmit,onImportFormAllCsvRowsShow=_ref3.onImportFormAllCsvRowsShow,onImportFormAllCsvRowsHide=_ref3.onImportFormAllCsvRowsHide,uploadImportFormCsv=_ref3.uploadImportFormCsv,fetchImportFormAllCsvRows=_ref3.fetchImportFormAllCsvRows,onSetDefaultOrder=_ref3.onSetDefaultOrder;var annotationsConfig=nodes.find(function(node){return node.general.id===nodeId;}).annotations;var itemsOrderAnnotationType=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(nodes,function(node){return node.general.id===nodeId;}).annotations.categorySchemesOrder;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_items_viewer__["a" /* default */],{artefact:categoryScheme,artefactTriplet:categorySchemeTriplet,itemTree:itemsTree,childrenKey:"categories",selectedItem:selectedItem,cutItem:cutItem,itemsViewMode:itemsViewMode,itemsOrderAnnotationType:itemsOrderAnnotationType,maxOrder:maxOrder,onCreate:onCreate,onDelete:onDelete,onDetailShow:onDetailEdit,onSelect:onSelect,onDrop:function onDrop(node,newParent,newOrder,categoryScheme,itemsTree,itemsOrderAnnotationType,lang,cutItem,t){return _onDrop(node,newParent,newOrder,categoryScheme,itemsTree,catSchemeCategorisations,itemsOrderAnnotationType,lang,cutItem,t);},onCut:onCut,onPaste:function onPaste(cutItem,newParent,pasteAfter,categoryScheme,itemsTree,lang,itemsOrderAnnotationType){return _onPaste(cutItem,newParent,pasteAfter,categoryScheme,itemsTree,catSchemeCategorisations,lang,itemsOrderAnnotationType);},onAnnotationsShow:onAnnotationsShow,onLayoutAnnotationsShow:onLayoutAnnotationsShow,onViewModeChange:onViewModeChange,onImportFormShow:onImportFormShow,onSetDefault:function onSetDefault(item){var newItem=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);newItem.annotations=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["Z" /* setLayoutAnnotationDefaultForCodelist */])(newItem.annotations,annotationsConfig,true);onItemSubmit(categoryScheme,itemsTree,newItem,itemsOrderAnnotationType,true,lang,false,cutItem,t);},onUnsetDefault:function onUnsetDefault(item){var newItem=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);newItem.annotations=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["Z" /* setLayoutAnnotationDefaultForCodelist */])(newItem.annotations,annotationsConfig,false);onItemSubmit(categoryScheme,itemsTree,newItem,itemsOrderAnnotationType,true,lang,false,cutItem,t);},isEditDisabled:isEditDisabled,onSetDefaultOrder:onSetDefaultOrder}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_items_import_form__["a" /* default */],{isVisible:isItemsImportFormVisible,formData:itemsImportForm,onHide:onImportFormHide,onChange:onImportFormChange,onUpload:function onUpload(){return onImportFormFileUpload(categoryScheme,itemsImportForm);},onImport:function onImport(){return onImportFormFileImport(categoryScheme,itemsImportForm);},onAllCsvRowsShow:onImportFormAllCsvRowsShow,onAllCsvRowsHide:onImportFormAllCsvRowsHide,uploadCsv:uploadImportFormCsv,fetchAllCsvRows:fetchImportFormAllCsvRows}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* default */],{instanceState:instanceState,instancePrefix:instancePrefix,isEditDisabled:isEditDisabled}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_custom_annotation_list__["a" /* default */],{annotations:itemAnnotations,onClose:onAnnotationsHide,title:itemAnnotationId}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_layout_annotation_list__["a" /* default */],{annotations:itemLayoutAnnotations,onClose:onLayoutAnnotationsHide,title:itemAnnotationId}),isDuplicateItemErrorVisible&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t('commons.artefact.tabs.items.modals.errors.duplicateItem'),onOk:function onOk(){onDuplicateItemErrorHide();},onCancel:function onCancel(){onDuplicateItemErrorHide();}});}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",null)));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CategorySchemeDetailItems));

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_item_form__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state,_ref){var instanceState=_ref.instanceState;return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,appLanguage:state.app.language,categoryScheme:instanceState.categoryScheme,item:instanceState.item,isItemEditMode:instanceState.isItemEditMode,isItemsParentListVisible:instanceState.isItemsParentListVisible,itemsTree:instanceState.itemsTree,isNormalizeNeeded:instanceState.isNormalizeNeeded,cutItem:instanceState.cutItem};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var instancePrefix=_ref2.instancePrefix;return{onItemDetailChange:function onItemDetailChange(fields,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_7" /* changeCategorySchemeDetailItemsItem */])(fields,lang,itemsOrderAnnotationType),instancePrefix));},onItemDetailSubmit:function onItemDetailSubmit(categoryScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_52" /* submitCategorySchemeDetailItemsItem */])(categoryScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t),instancePrefix));},onItemDetailHide:function onItemDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_25" /* hideCategorySchemeDetailItemsItem */])(),instancePrefix));},onItemsParentListShow:function onItemsParentListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_46" /* showCategorySchemeDetailItemsItemParentList */])(),instancePrefix));},onItemsParentListHide:function onItemsParentListHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_29" /* hideCategorySchemeDetailItemsItemParentList */])(),instancePrefix));},onItemsParentListSet:function onItemsParentListSet(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_37" /* setCategorySchemeDetailItemsItemParentList */])(item),instancePrefix));},onItemsParentListUnset:function onItemsParentListUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_55" /* unsetCategorySchemeDetailItemsItemParentList */])(),instancePrefix));}};};var CategorySchemeDetailItem=function CategorySchemeDetailItem(_ref3){var t=_ref3.t,nodes=_ref3.nodes,nodeId=_ref3.nodeId,permissions=_ref3.permissions,appLanguage=_ref3.appLanguage,isEditDisabled=_ref3.isEditDisabled,categoryScheme=_ref3.categoryScheme,item=_ref3.item,isItemEditMode=_ref3.isItemEditMode,onItemDetailChange=_ref3.onItemDetailChange,onItemDetailSubmit=_ref3.onItemDetailSubmit,onItemDetailHide=_ref3.onItemDetailHide,isItemsParentListVisible=_ref3.isItemsParentListVisible,onItemsParentListShow=_ref3.onItemsParentListShow,onItemsParentListHide=_ref3.onItemsParentListHide,onItemsParentListSet=_ref3.onItemsParentListSet,onItemsParentListUnset=_ref3.onItemsParentListUnset,itemsTree=_ref3.itemsTree,isNormalizeNeeded=_ref3.isNormalizeNeeded,cutItem=_ref3.cutItem;var annotationsConfig=nodes.find(function(node){return node.general.id===nodeId;}).annotations;var itemsOrderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.categorySchemesOrder;var userHasPermissionsToEdit=permissions&&categoryScheme&&permissions.agencies.filter(function(agency){return agency===categoryScheme.agencyID;}).length>0&&!isEditDisabled;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__["a" /* default */],{title:isItemEditMode&&item?userHasPermissionsToEdit?t("commons.artefact.tabs.items.item.detail.title.editMode.title",{id:item.id}):t("commons.artefact.tabs.items.item.detail.title.viewMode.title",{id:item.id}):t("commons.artefact.tabs.items.item.detail.title.createMode.title"),visible:item!==null,onCancel:onItemDetailHide,width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onItemDetailHide},t('commons.buttons.close.title')),!isItemEditMode||userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["g" /* isItemValid */])(item)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onItemDetailSubmit(categoryScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t);}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_item_form__["f" /* default */],{item:item?item:null,mode:isItemEditMode?userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_9__components_item_form__["c" /* ITEM_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_9__components_item_form__["e" /* ITEM_FORM_MODE_READ */]:__WEBPACK_IMPORTED_MODULE_9__components_item_form__["a" /* ITEM_FORM_MODE_CREATE */],onChange:function onChange(fields){return onItemDetailChange(fields,lang,itemsOrderAnnotationType);},itemsParentListShow:onItemsParentListShow,itemsParentListUnset:onItemsParentListUnset,annotationsConfig:annotationsConfig})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__["a" /* default */],{visible:isItemsParentListVisible?isItemsParentListVisible:false,onCancel:onItemsParentListHide,title:t('commons.artefact.tabs.items.item.detail.modals.parentList.title'),width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onItemsParentListHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_item_list__["a" /* default */],{data:item&&Object(__WEBPACK_IMPORTED_MODULE_12__utils_tree__["l" /* getNodes */])(itemsTree,"categories",function(node){return node.id!==item.id;}).filter(function(node){return!Object(__WEBPACK_IMPORTED_MODULE_12__utils_tree__["o" /* testAnchestor */])(node,item,itemsTree,"categories");}),onRowClick:function onRowClick(item){return onItemsParentListSet(item);}})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CategorySchemeDetailItem));

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_components_redux_concept_scheme_detail_modal__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(336);
var mapStateToProps=function mapStateToProps(state){return{conceptSchemeDetail:state.scenes.metaManager.conceptSchemes.conceptSchemeDetail};};var ConceptSchemes=function ConceptSchemes(_ref){var conceptSchemeDetail=_ref.conceptSchemeDetail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_concept_scheme_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_4__reducer__["a" /* MM_CONCEPT_SCHEMES_PREFIX */],instanceState:conceptSchemeDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ConceptSchemes));

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducer__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_components_redux_concept_scheme_detail_modal_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,conceptSchemes:state.scenes.metaManager.conceptSchemes.conceptSchemes,conceptSchemeAnnotations:state.scenes.metaManager.conceptSchemes.conceptSchemeAnnotations,conceptSchemeAnnotationTriplet:state.scenes.metaManager.conceptSchemes.conceptSchemeAnnotationTriplet,parentsAndChildren:state.scenes.metaManager.conceptSchemes.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCreate:function onCreate(defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_concept_scheme_detail_modal_actions__["_10" /* createConceptSchemeDetail */])(defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_9__reducer__["a" /* MM_CONCEPT_SCHEMES_PREFIX */]));},onDetail:function onDetail(conceptSchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_concept_scheme_detail_modal_actions__["_15" /* editConceptSchemeDetail */])(conceptSchemeTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_9__reducer__["a" /* MM_CONCEPT_SCHEMES_PREFIX */]));},fetchConceptSchemes:function fetchConceptSchemes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* readConceptSchemesListConceptSchemes */])());},onConceptSchemeDelete:function onConceptSchemeDelete(conceptSchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* deleteConceptSchemesConceptScheme */])(conceptSchemeTriplet));},onAnnotationsShow:function onAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* showConceptSchemesDetailAnnotations */])(annotations,triplet));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* hideConceptSchemesDetailAnnotations */])());},onSelectedConceptSchemesDelete:function onSelectedConceptSchemesDelete(conceptSchemeTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* deleteConceptSchemesSelectedConceptSchemes */])(conceptSchemeTriplets));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_concept_scheme_detail_modal_actions__["_40" /* showConceptSchemeDetailDownload */])(artefactTriplets,lang),__WEBPACK_IMPORTED_MODULE_9__reducer__["a" /* MM_CONCEPT_SCHEMES_PREFIX */]));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_concept_scheme_detail_modal_actions__["_39" /* showConceptSchemeDetailClone */])(artefactTriplet),__WEBPACK_IMPORTED_MODULE_9__reducer__["a" /* MM_CONCEPT_SCHEMES_PREFIX */]));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_concept_scheme_detail_modal_actions__["_41" /* showConceptSchemeDetailExport */])(sourceTriplet),__WEBPACK_IMPORTED_MODULE_9__reducer__["a" /* MM_CONCEPT_SCHEMES_PREFIX */]));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* readConceptSchemesConceptSchemeParentsAndChildren */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* hideConceptSchemesConceptSchemeParentsAndChildren */])());}};};var ConceptSchemesList=function ConceptSchemesList(_ref){var nodeId=_ref.nodeId,nodes=_ref.nodes,conceptSchemes=_ref.conceptSchemes,_onCreate=_ref.onCreate,onDetail=_ref.onDetail,fetchConceptSchemes=_ref.fetchConceptSchemes,onConceptSchemeDelete=_ref.onConceptSchemeDelete,conceptSchemeAnnotations=_ref.conceptSchemeAnnotations,conceptSchemeAnnotationTriplet=_ref.conceptSchemeAnnotationTriplet,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onSelectedConceptSchemesDelete=_ref.onSelectedConceptSchemesDelete,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchConceptSchemes,disabled:conceptSchemes!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_artefact_list__["a" /* default */],{artefacts:conceptSchemes,onCreate:function onCreate(){return _onCreate(defaultItemsViewMode);},onDetailShow:function onDetailShow(triplet){return onDetail(triplet,defaultItemsViewMode);},onDownloadShow:onDownloadShow,onCloneShow:onCloneShow,onExportShow:onExportShow,onDelete:onConceptSchemeDelete,onSelectedItemDelete:onSelectedConceptSchemesDelete,onAnnotationsShow:onAnnotationsShow,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("conceptscheme",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_custom_annotation_list__["a" /* default */],{annotations:conceptSchemeAnnotations,onClose:onAnnotationsHide,title:conceptSchemeAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_11__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(conceptSchemeAnnotationTriplet):null}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ConceptSchemesList));

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Detail__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,dataLanguages:state.config.dataManagement.dataLanguages,dataflow:state.scenes.metaManager.dataflows.dataflow,allAgencies:state.scenes.metaManager.dataflows.allAgencies,downloadDataflowTriplets:state.scenes.metaManager.dataflows.downloadDataflowTriplets,downloadDataflowLang:state.scenes.metaManager.dataflows.downloadDataflowLang,downloadDataflowParams:state.scenes.metaManager.dataflows.downloadDataflowParams,cloneDestTriplet:state.scenes.metaManager.dataflows.cloneDestTriplet,dataflowExportSourceTriplet:state.scenes.metaManager.dataflows.dataflowExportSourceTriplet,dataflowExportDestination:state.scenes.metaManager.dataflows.dataflowExportDestination,dataflowExportReport:state.scenes.metaManager.dataflows.dataflowExportReport,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_18" /* hideDataflowsDataflowDownload */])());},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_7" /* changeDataflowsDataflowDownload */])(fields));},onDownloadSubmit:function onDownloadSubmit(artefactTriplet,downloadDataflowParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_56" /* submitDataflowsDataflowDownload */])(artefactTriplet,downloadDataflowParams,lang));},onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_16" /* hideDataflowsDataflowClone */])());},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_6" /* changeDataflowsDataflowClone */])(fields));},onCloneSubmit:function onCloneSubmit(cloneDestTriplet,srcDataflow,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_55" /* submitDataflowsDataflowClone */])(cloneDestTriplet,srcDataflow,annotationsConfig));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_19" /* hideDataflowsDataflowExport */])());},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_8" /* changeDataflowsDataflowExport */])(fields));},onExportSubmit:function onExportSubmit(sourceTriplets,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_57" /* submitDataflowsDataflowExport */])(sourceTriplets,destination));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_20" /* hideDataflowsDataflowExportReport */])());}};};var Dataflows=function Dataflows(_ref){var t=_ref.t,endpoints=_ref.endpoints,endpointId=_ref.endpointId,dataLanguages=_ref.dataLanguages,dataflow=_ref.dataflow,allAgencies=_ref.allAgencies,downloadDataflowTriplets=_ref.downloadDataflowTriplets,downloadDataflowLang=_ref.downloadDataflowLang,downloadDataflowParams=_ref.downloadDataflowParams,onDownloadHide=_ref.onDownloadHide,onDownloadChange=_ref.onDownloadChange,onDownloadSubmit=_ref.onDownloadSubmit,cloneDestTriplet=_ref.cloneDestTriplet,onCloneHide=_ref.onCloneHide,onCloneChange=_ref.onCloneChange,onCloneSubmit=_ref.onCloneSubmit,dataflowExportSourceTriplet=_ref.dataflowExportSourceTriplet,dataflowExportDestination=_ref.dataflowExportDestination,onExportHide=_ref.onExportHide,onExportChange=_ref.onExportChange,onExportSubmit=_ref.onExportSubmit,dataflowExportReport=_ref.dataflowExportReport,user=_ref.user,onExportReportHide=_ref.onExportReportHide;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Detail__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:downloadDataflowTriplets!==null&&downloadDataflowTriplets!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){return onDownloadSubmit(downloadDataflowTriplets,downloadDataflowParams,downloadDataflowLang);},type:"primary",disabled:downloadDataflowParams&&downloadDataflowParams.format===null||downloadDataflowParams&&downloadDataflowParams.format===__WEBPACK_IMPORTED_MODULE_14__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadDataflowParams.csvSeparator===null||downloadDataflowParams.csvSeparator.length!==1||downloadDataflowParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_SM"],title:downloadDataflowTriplets&&downloadDataflowTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadDataflowTriplets?Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadDataflowTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadDataflowParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_14__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadDataflowTriplets&&downloadDataflowTriplets.length>1?__WEBPACK_IMPORTED_MODULE_14__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_14__constants_download__["f" /* ARTEFACT_TYPE_DATAFLOW */]),langs:dataLanguages,hasReferences:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(cloneDestTriplet,dataflow,endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations);}},type:"primary"},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:dataflow,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:dataflowExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["e" /* isExportDestinationValid */])(dataflowExportDestination,(user&&user.providerId)!==null)){onExportSubmit(dataflowExportSourceTriplet,dataflowExportDestination);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__["b" /* default */],{type:"dataflow",agencies:allAgencies,sourceTriplet:dataflowExportSourceTriplet,destination:dataflowExportDestination,onChange:onExportChange})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:dataflowExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_artefact_export_report__["a" /* default */],{report:dataflowExportReport})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(Dataflows));

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layout_annotation_list__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artefact_ownership_modal__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ContentConstraintList__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_annotations__ = __webpack_require__(45);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,dataflows:state.scenes.metaManager.dataflows.dataflows,permissions:state.app.user.permissions,dataflowAnnotations:state.scenes.metaManager.dataflows.dataflowAnnotations,dataflowLayoutAnnotations:state.scenes.metaManager.dataflows.dataflowLayoutAnnotations,dataflowAnnotationTriplet:state.scenes.metaManager.dataflows.dataflowAnnotationTriplet,dataflowOwnershipDataflowTripletStr:state.scenes.metaManager.dataflows.dataflowOwnershipDataflowTripletStr,dataflowOwnershipUsers:state.scenes.metaManager.dataflows.dataflowOwnershipUsers,dataflowOwnershipOwners:state.scenes.metaManager.dataflows.dataflowOwnershipOwners,parentsAndChildren:state.scenes.metaManager.dataflows.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCreate:function onCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_12" /* createDataflowsDataflow */])());},onDetail:function onDetail(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_15" /* editDataflowsDataflow */])(dataflowTriplet));},fetchDataflows:function fetchDataflows(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_40" /* readDataflowsListDataflows */])());},onDataflowDelete:function onDataflowDelete(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_13" /* deleteDataflowsDataflow */])(dataflowTriplet));},onAnnotationsShow:function onAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_51" /* showDataflowsDetailAnnotations */])(annotations,triplet));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_24" /* hideDataflowsDetailAnnotations */])());},onLayoutAnnotationsShow:function onLayoutAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_53" /* showDataflowsDetailLayoutAnnotations */])(annotations,triplet));},onLayoutAnnotationsHide:function onLayoutAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_26" /* hideDataflowsDetailLayoutAnnotations */])());},onSelectedDataflowsDelete:function onSelectedDataflowsDelete(dataflowTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_14" /* deleteDataflowsSelectedDataflows */])(dataflowTriplets));},onDownloadShow:function onDownloadShow(dataflowTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_48" /* showDataflowsDataflowDownload */])(dataflowTriplets,lang));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_46" /* showDataflowsDataflowClone */])(artefactTriplet));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_49" /* showDataflowsDataflowExport */])(sourceTriplet));},onDataflowOwnershipShow:function onDataflowOwnershipShow(dataflowTripletStr){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_50" /* showDataflowsDataflowOwnership */])(dataflowTripletStr));},onDataflowOwnershipHide:function onDataflowOwnershipHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_21" /* hideDataflowsDataflowOwnership */])());},fetchOwnershipUsers:function fetchOwnershipUsers(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_32" /* readDataflowsDataflowOwnershipUsersRead */])());},fetchOwnershipOwners:function fetchOwnershipOwners(dataflowTripletStr){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_31" /* readDataflowsDataflowOwnershipOwnersRead */])(dataflowTripletStr));},onDataflowOwnershipOwnersChange:function onDataflowOwnershipOwnersChange(owners){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_9" /* changeDataflowsDataflowOwnershipOwners */])(owners));},onDataflowOwnershipSubmit:function onDataflowOwnershipSubmit(dataflowTripletStr,owners){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_58" /* submitDataflowsDataflowOwnership */])(dataflowTripletStr,owners));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_33" /* readDataflowsDataflowParentsAndChildren */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_22" /* hideDataflowsDataflowParentsAndChildren */])());},onContentConstraintsShow:function onContentConstraintsShow(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_47" /* showDataflowsDataflowContentConstraints */])(dataflowTriplet));},onContentConstraintsHide:function onContentConstraintsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_17" /* hideDataflowsDataflowContentConstraints */])());}};};var DataflowsList=function DataflowsList(_ref){var t=_ref.t,dataflows=_ref.dataflows,endpoints=_ref.endpoints,endpointId=_ref.endpointId,permissions=_ref.permissions,onCreate=_ref.onCreate,onDetail=_ref.onDetail,fetchDataflows=_ref.fetchDataflows,onDataflowDelete=_ref.onDataflowDelete,dataflowAnnotations=_ref.dataflowAnnotations,dataflowLayoutAnnotations=_ref.dataflowLayoutAnnotations,dataflowAnnotationTriplet=_ref.dataflowAnnotationTriplet,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onLayoutAnnotationsShow=_ref.onLayoutAnnotationsShow,onLayoutAnnotationsHide=_ref.onLayoutAnnotationsHide,onSelectedDataflowsDelete=_ref.onSelectedDataflowsDelete,onDownloadShow=_ref.onDownloadShow,_onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow,dataflowOwnershipDataflowTripletStr=_ref.dataflowOwnershipDataflowTripletStr,dataflowOwnershipUsers=_ref.dataflowOwnershipUsers,dataflowOwnershipOwners=_ref.dataflowOwnershipOwners,onDataflowOwnershipShow=_ref.onDataflowOwnershipShow,onDataflowOwnershipHide=_ref.onDataflowOwnershipHide,fetchOwnershipUsers=_ref.fetchOwnershipUsers,fetchOwnershipOwners=_ref.fetchOwnershipOwners,onDataflowOwnershipOwnersChange=_ref.onDataflowOwnershipOwnersChange,onDataflowOwnershipSubmit=_ref.onDataflowOwnershipSubmit,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide,onContentConstraintsShow=_ref.onContentConstraintsShow;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__hocs_call__["a" /* default */],{cb:fetchDataflows,disabled:dataflows!==null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_artefact_list__["a" /* default */],{artefacts:dataflows,onDetailShow:onDetail,onCreate:onCreate,onDownloadShow:onDownloadShow,onCloneShow:function onCloneShow(artefactTriplet){var annotationsConfig=endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations;var dataflow=dataflows.find(function(_ref2){var id=_ref2.id,agencyID=_ref2.agencyID,version=_ref2.version;return Object(__WEBPACK_IMPORTED_MODULE_13__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])({id:id,agencyID:agencyID,version:version},__WEBPACK_IMPORTED_MODULE_13__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */])===Object(__WEBPACK_IMPORTED_MODULE_13__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(artefactTriplet,__WEBPACK_IMPORTED_MODULE_13__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */]);});if(!!(dataflow.autoAnnotations||[]).find(function(_ref3){var type=_ref3.type;return type===annotationsConfig[__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["h" /* AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY */]];})){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t("scenes.metaManager.dataflows.errors.cannotCloneVirtualDF.title")});}else{_onCloneShow(artefactTriplet);}},onExportShow:onExportShow,onDelete:onDataflowDelete,onSelectedItemDelete:onSelectedDataflowsDelete,onAnnotationsShow:onAnnotationsShow,onLayoutAnnotationsShow:onLayoutAnnotationsShow,onOwnershipShow:onDataflowOwnershipShow,ownershipPermissions:permissions?permissions.dataflowOwner:null,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("dataflow",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide,onContentConstraintsShow:onContentConstraintsShow}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_custom_annotation_list__["a" /* default */],{annotations:dataflowAnnotations,onClose:onAnnotationsHide,title:dataflowAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_13__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dataflowAnnotationTriplet):null}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_layout_annotation_list__["a" /* default */],{annotations:dataflowLayoutAnnotations,onClose:onLayoutAnnotationsHide,title:dataflowAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_13__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dataflowAnnotationTriplet):null}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_artefact_ownership_modal__["a" /* default */],{isVisible:dataflowOwnershipDataflowTripletStr!==null,id:dataflowOwnershipDataflowTripletStr,onClose:onDataflowOwnershipHide,users:dataflowOwnershipUsers,owners:dataflowOwnershipOwners,fetchUsers:fetchOwnershipUsers,fetchOwners:function fetchOwners(){return fetchOwnershipOwners(dataflowOwnershipDataflowTripletStr);},onOwnersChange:onDataflowOwnershipOwnersChange,onSubmit:function onSubmit(){return onDataflowOwnershipSubmit(dataflowOwnershipDataflowTripletStr,dataflowOwnershipOwners);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ContentConstraintList__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DataflowsList));

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_components_redux_content_constraint_modal__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducer__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__redux_components_redux_content_constraint_modal_actions__ = __webpack_require__(162);
var mapStateToProps=function mapStateToProps(state){return{dataflowCCsDataflowTriplet:state.scenes.metaManager.dataflows.dataflowCCsDataflowTriplet,dataflowCCsContentConstraints:state.scenes.metaManager.dataflows.dataflowCCsContentConstraints,contentConstraintDetail:state.scenes.metaManager.dataflows.contentConstraintDetail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["_17" /* hideDataflowsDataflowContentConstraints */])());},fetchDataflowsDataflowContentConstraints:function fetchDataflowsDataflowContentConstraints(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["_30" /* readDataflowsDataflowContentConstraints */])(dataflowTriplet));},onDetailShow:function onDetailShow(contentConstraintTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_14__redux_components_redux_content_constraint_modal_actions__["_20" /* showContentConstraintDetail */])(contentConstraintTriplet),__WEBPACK_IMPORTED_MODULE_12__reducer__["b" /* MM_DATAFLOWS_CC_DETAIL_PREFIX */]));}};};var ContentConstraintList=function ContentConstraintList(_ref){var t=_ref.t,dataflowCCsDataflowTriplet=_ref.dataflowCCsDataflowTriplet,dataflowCCsContentConstraints=_ref.dataflowCCsContentConstraints,contentConstraintDetail=_ref.contentConstraintDetail,onHide=_ref.onHide,fetchDataflowsDataflowContentConstraints=_ref.fetchDataflowsDataflowContentConstraints,_onDetailShow=_ref.onDetailShow;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__["a" /* default */],{visible:dataflowCCsDataflowTriplet!==null,title:t('scenes.metaManager.dataflows.contentConstraintList.title'),onCancel:onHide,footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_LG"]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__hocs_call__["a" /* default */],{cb:fetchDataflowsDataflowContentConstraints,cbParam:dataflowCCsDataflowTriplet,disabled:dataflowCCsDataflowTriplet===null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_artefact_list__["a" /* default */],{artefacts:dataflowCCsContentConstraints?dataflowCCsContentConstraints.sort(function(a,b){return a.id.localeCompare(b.id);}):dataflowCCsContentConstraints,onDetailShow:function onDetailShow(triplet){return _onDetailShow(triplet);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__redux_components_redux_content_constraint_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_12__reducer__["b" /* MM_DATAFLOWS_CC_DETAIL_PREFIX */],instanceState:contentConstraintDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ContentConstraintList));

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
var mapPropsToFields=function mapPropsToFields(_ref){var releaseCalendar=_ref.releaseCalendar;return{periodicity:{value:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:releaseCalendar.periodicity.value}),measureUnit:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:releaseCalendar.periodicity.measureUnit})},offset:{value:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:releaseCalendar.offset.value}),measureUnit:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:releaseCalendar.offset.measureUnit})},tolerance:{value:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:releaseCalendar.tolerance.value}),measureUnit:__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.createFormField({value:releaseCalendar.tolerance.measureUnit})}};};var onFieldsChange=function onFieldsChange(props,fields){return props.onReleaseCalendarChange(__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.mapValues(fields,function(value){return __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.mapValues(value,function(_ref2){var value=_ref2.value;return value;});}));};var CONTENT_CONSTRAINTS_MEASURE_UNIT_DAYS="days";var CONTENT_CONSTRAINTS_MEASURE_UNIT_WEEKS="weeks";var CONTENT_CONSTRAINTS_MEASURE_UNIT_MONTHS="months";var CONTENT_CONSTRAINTS_MEASURE_UNIT_YEARS="years";var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_TWO_THIRDS"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_ONE_THIRD"]}};var MeasureUnitSelect=function MeasureUnitSelect(t,disabled){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref3){var props=_ref3.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},disabled:disabled},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CONTENT_CONSTRAINTS_MEASURE_UNIT_DAYS,title:t("scenes.metaManager.commons.detail.tabs.releaseCalendar.measureUnit.days.label")},t("scenes.metaManager.commons.detail.tabs.releaseCalendar.measureUnit.days.label")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CONTENT_CONSTRAINTS_MEASURE_UNIT_WEEKS,title:t("scenes.metaManager.commons.detail.tabs.releaseCalendar.measureUnit.weeks.label")},t("scenes.metaManager.commons.detail.tabs.releaseCalendar.measureUnit.weeks.label")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CONTENT_CONSTRAINTS_MEASURE_UNIT_MONTHS,title:t("scenes.metaManager.commons.detail.tabs.releaseCalendar.measureUnit.months.label")},t("scenes.metaManager.commons.detail.tabs.releaseCalendar.measureUnit.months.label")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:CONTENT_CONSTRAINTS_MEASURE_UNIT_YEARS,title:t("scenes.metaManager.commons.detail.tabs.releaseCalendar.measureUnit.years.label")},t("scenes.metaManager.commons.detail.tabs.releaseCalendar.measureUnit.years.label")));};var ReleaseCalendarTab=function ReleaseCalendarTab(_ref4){var t=_ref4.t,form=_ref4.form,disabled=_ref4.disabled;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',align:'middle'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.metaManager.commons.detail.tabs.releaseCalendar.periodicity.title')},formItemLayout),form.getFieldDecorator('periodicity.value')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default.a,{disabled:disabled,min:0,style:{width:"100%"}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},form.getFieldDecorator('periodicity.measureUnit')(MeasureUnitSelect(t,disabled)))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',align:'middle'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.metaManager.commons.detail.tabs.releaseCalendar.offset.title')},formItemLayout),form.getFieldDecorator('offset.value')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default.a,{disabled:disabled,min:0,style:{width:"100%"}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},form.getFieldDecorator('offset.measureUnit')(MeasureUnitSelect(t,disabled)))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',align:'middle'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object.assign({label:t('scenes.metaManager.commons.detail.tabs.releaseCalendar.tolerance.title')},formItemLayout),form.getFieldDecorator('tolerance.value')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number___default.a,{disabled:disabled,min:0,style:{width:"100%"}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},form.getFieldDecorator('tolerance.measureUnit')(MeasureUnitSelect(t,disabled)))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ReleaseCalendarTab));

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__redux_components_redux_dsd_detail_modal__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducer__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__redux_components_redux_dsd_detail_modal_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_endpoints_dropdown__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_dataflow__ = __webpack_require__(221);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{nodes:state.config.nodes,nodeId:state.app.endpointId,appLanguage:state.app.language,isVisible:state.scenes.metaManager.dataflows.isDetailVisible,dataflowTriplet:state.scenes.metaManager.dataflows.dataflowTriplet,isDataflowValid:state.scenes.metaManager.dataflows.isDataflowValid,isAgenciesValid:state.scenes.metaManager.dataflows.isAgenciesValid,isDataflowGeneralTabDirty:state.scenes.metaManager.dataflows.isDataflowGeneralTabDirty,dataflow:state.scenes.metaManager.dataflows.dataflow,agencies:state.scenes.metaManager.dataflows.agencies,dsds:state.scenes.metaManager.dataflows.dsds,isDsdsListVisible:state.scenes.metaManager.dataflows.isDsdsListVisible,dsdDetail:state.scenes.metaManager.dataflows.dsdDetail,selectedDsdDetail:state.scenes.metaManager.dataflows.selectedDsdDetail,selectedDsdTriplet:state.scenes.metaManager.dataflows.selectedDsdTriplet,permissions:state.app.user.permissions,dsdForLayoutAnnotations:state.scenes.metaManager.dataflows.dsdForLayoutAnnotations,isLayoutAnnotationsFormVisible:state.scenes.metaManager.dataflows.isLayoutAnnotationsFormVisible,itemsPageForLayoutAnnotations:state.scenes.metaManager.dataflows.itemsPageForLayoutAnnotations,endpoints:state.config.nodes,endpointId:state.app.endpointId,isVirtualDFEndpointAvailable:state.scenes.metaManager.dataflows.isVirtualDFEndpointAvailable,isVirtualDFDataflowsModalOpen:state.scenes.metaManager.dataflows.isVirtualDFDataflowsModalOpen,virtualDFDataflows:state.scenes.metaManager.dataflows.virtualDFDataflows};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDetailHide:function onDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_23" /* hideDataflowsDetail */])());},onDetailChange:function onDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_10" /* changeDataflowsDetailDataflow */])(fields));},onDetailCreate:function onDetailCreate(dataflow){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_59" /* submitDataflowsDetailDataflowCreate */])(dataflow));},onDetailUpdate:function onDetailUpdate(dataflow,keepModalOpen){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_60" /* submitDataflowsDetailDataflowUpdate */])(dataflow,keepModalOpen));},fetchDataflow:function fetchDataflow(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_35" /* readDataflowsDetailDataflow */])(dataflowTriplet));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_34" /* readDataflowsDetailAgencies */])(allowedAgencies));},onDsdsShow:function onDsdsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_52" /* showDataflowsDetailDsds */])());},onDsdsHide:function onDsdsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_25" /* hideDataflowsDetailDsds */])());},fetchDsds:function fetchDsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_37" /* readDataflowsDetailDsds */])());},onDsdDetailShow:function onDsdDetailShow(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_27__redux_components_redux_dsd_detail_modal_actions__["_72" /* showDsdDetail */])(dsdTriplet),__WEBPACK_IMPORTED_MODULE_25__reducer__["c" /* MM_DATAFLOWS_DSD_DETAIL_PREFIX */]));},onSelectedDsdDetailShow:function onSelectedDsdDetailShow(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_27__redux_components_redux_dsd_detail_modal_actions__["_72" /* showDsdDetail */])(dsdTriplet),__WEBPACK_IMPORTED_MODULE_25__reducer__["d" /* MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX */]));},onDsdSet:function onDsdSet(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_43" /* setDataflowsDetailDsd */])(dsdTriplet));},onDsdUnset:function onDsdUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_62" /* unsetDataflowsDetailDsd */])());},onDownloadShow:function onDownloadShow(dataflowTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_48" /* showDataflowsDataflowDownload */])(dataflowTriplets,lang));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_46" /* showDataflowsDataflowClone */])(artefactTriplet));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_49" /* showDataflowsDataflowExport */])(sourceTriplet));},fetchDsdForLayoutAnnotations:function fetchDsdForLayoutAnnotations(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_36" /* readDataflowsDetailDsdForLayoutAnnotations */])(dsdTriplet));},onLayoutAnnotationsFormShow:function onLayoutAnnotationsFormShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_54" /* showDataflowsDetailLayoutAnnotationsForm */])());},onLayoutAnnotationsFormHide:function onLayoutAnnotationsFormHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_27" /* hideDataflowsDetailLayoutAnnotationsForm */])());},onLayoutAnnotationsFormSubmit:function onLayoutAnnotationsFormSubmit(annotations){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_61" /* submitDataflowsDetailLayoutAnnotationsForm */])(annotations));},onLayoutAnnotationsFormReset:function onLayoutAnnotationsFormReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_41" /* resetDataflowsDetailLayoutAnnotationsForm */])());},fetchItemsPageForLayoutAnnotations:function fetchItemsPageForLayoutAnnotations(_ref){var codelistTriplet=_ref.codelistTriplet,language=_ref.language,pageNum=_ref.pageNum,pageSize=_ref.pageSize,searchText=_ref.searchText,filters=_ref.filters,sortCol=_ref.sortCol,sortByDesc=_ref.sortByDesc;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_38" /* readDataflowsDetailLayoutAnnotationsItemsPage */])({codelistTriplet:codelistTriplet,language:language,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc}));},resetItemsPageForLayoutAnnotations:function resetItemsPageForLayoutAnnotations(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_42" /* resetDataflowsDetailLayoutAnnotationsItemsPage */])());},onVirtualDFEndpointSet:function onVirtualDFEndpointSet(endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_45" /* setDataflowsDetailVirtualDataflowEndpoint */])(endpointId));},onVirtualDFDataflowSet:function onVirtualDFDataflowSet(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_44" /* setDataflowsDetailVirtualDataflowDataflow */])(dataflowTriplet));},onVirtualDFDataflowUnset:function onVirtualDFDataflowUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_63" /* unsetDataflowsDetailVirtualDataflowDataflow */])());},onVirtualDFEndpointPing:function onVirtualDFEndpointPing(endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_29" /* pingDataflowsDetailVirtualDataflowEndpoint */])(endpointId));},onVirtualDFDataflowsModalOpen:function onVirtualDFDataflowsModalOpen(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_28" /* openDataflowsDetailVirtualDataflowDataflowsModal */])());},onVirtualDFDataflowsModalClose:function onVirtualDFDataflowsModalClose(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_11" /* closeDataflowsDetailVirtualDataflowDataflowsModal */])());},fetchVirtualDFDataflows:function fetchVirtualDFDataflows(endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_39" /* readDataflowsDetailVirtualDataflowDataflows */])(endpointId));}};};var selector=function selector(t,onSelectedDsdDetailShow,selectedDsdTriplet,onDsdsShow,onDsdUnset,disabled){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_selector__["a" /* default */],{disabled:disabled,detailTitle:t('commons.artefact.tabs.general.dsd.selector.detail.title'),selectTitle:t('commons.artefact.tabs.general.dsd.selector.select.title'),resetTitle:t('commons.artefact.tabs.general.dsd.selector.reset.title'),onDetail:function onDetail(){return onSelectedDsdDetailShow(selectedDsdTriplet);},onSelect:onDsdsShow,onReset:onDsdUnset});};var DataflowsDetail=function DataflowsDetail(_ref2){var t=_ref2.t,appLanguage=_ref2.appLanguage,isVisible=_ref2.isVisible,dataflowTriplet=_ref2.dataflowTriplet,isDataflowValid=_ref2.isDataflowValid,isAgenciesValid=_ref2.isAgenciesValid,isDataflowGeneralTabDirty=_ref2.isDataflowGeneralTabDirty,dataflow=_ref2.dataflow,agencies=_ref2.agencies,onDetailHide=_ref2.onDetailHide,onDetailChange=_ref2.onDetailChange,onDetailCreate=_ref2.onDetailCreate,onDetailUpdate=_ref2.onDetailUpdate,fetchDataflow=_ref2.fetchDataflow,fetchAgencies=_ref2.fetchAgencies,dsds=_ref2.dsds,isDsdsListVisible=_ref2.isDsdsListVisible,dsdDetail=_ref2.dsdDetail,selectedDsdTriplet=_ref2.selectedDsdTriplet,selectedDsdDetail=_ref2.selectedDsdDetail,onDsdsShow=_ref2.onDsdsShow,onDsdsHide=_ref2.onDsdsHide,fetchDsds=_ref2.fetchDsds,onDsdDetailShow=_ref2.onDsdDetailShow,onSelectedDsdDetailShow=_ref2.onSelectedDsdDetailShow,onDsdSet=_ref2.onDsdSet,onDsdUnset=_ref2.onDsdUnset,permissions=_ref2.permissions,endpoints=_ref2.endpoints,endpointId=_ref2.endpointId,isVirtualDFEndpointAvailable=_ref2.isVirtualDFEndpointAvailable,isVirtualDFDataflowsModalOpen=_ref2.isVirtualDFDataflowsModalOpen,virtualDFDataflows=_ref2.virtualDFDataflows,onVirtualDFEndpointSet=_ref2.onVirtualDFEndpointSet,onVirtualDFDataflowsModalOpen=_ref2.onVirtualDFDataflowsModalOpen,onVirtualDFDataflowsModalClose=_ref2.onVirtualDFDataflowsModalClose,onVirtualDFDataflowSet=_ref2.onVirtualDFDataflowSet,onVirtualDFDataflowUnset=_ref2.onVirtualDFDataflowUnset,onVirtualDFEndpointPing=_ref2.onVirtualDFEndpointPing,fetchVirtualDFDataflows=_ref2.fetchVirtualDFDataflows,onDownloadShow=_ref2.onDownloadShow,onCloneShow=_ref2.onCloneShow,onExportShow=_ref2.onExportShow,fetchDsdForLayoutAnnotations=_ref2.fetchDsdForLayoutAnnotations,dsdForLayoutAnnotations=_ref2.dsdForLayoutAnnotations,isLayoutAnnotationsFormVisible=_ref2.isLayoutAnnotationsFormVisible,onLayoutAnnotationsFormShow=_ref2.onLayoutAnnotationsFormShow,onLayoutAnnotationsFormHide=_ref2.onLayoutAnnotationsFormHide,onLayoutAnnotationsFormSubmit=_ref2.onLayoutAnnotationsFormSubmit,onLayoutAnnotationsFormReset=_ref2.onLayoutAnnotationsFormReset,itemsPageForLayoutAnnotations=_ref2.itemsPageForLayoutAnnotations,fetchItemsPageForLayoutAnnotations=_ref2.fetchItemsPageForLayoutAnnotations,resetItemsPageForLayoutAnnotations=_ref2.resetItemsPageForLayoutAnnotations;var virtualDFEndpointIdAnnotType=endpoints.find(function(node){return node.general.id===endpointId;}).annotations[__WEBPACK_IMPORTED_MODULE_31__utils_annotations__["h" /* AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY */]];var virtualDFEndpointIdAnnot=dataflow?(dataflow.annotations||[]).find(function(_ref3){var type=_ref3.type;return type===virtualDFEndpointIdAnnotType;})||(dataflow.autoAnnotations||[]).find(function(_ref4){var type=_ref4.type;return type===virtualDFEndpointIdAnnotType;}):null;var virtualDFEndpointId=virtualDFEndpointIdAnnot?virtualDFEndpointIdAnnot.title:null;var userHasPermissionsToEdit=permissions&&dataflowTriplet&&permissions.agencies.filter(function(agency){return agency===dataflowTriplet.agencyID;}).length>0;var _useState=Object(__WEBPACK_IMPORTED_MODULE_12_react__["useState"])("general"),_useState2=_slicedToArray(_useState,2),tab=_useState2[0],setTab=_useState2[1];var VirtualDFNodeSelect=dataflow&&dataflow.isExternalReference?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_endpoints_dropdown__["a" /* default */],{disabled:dataflowTriplet,endpoints:endpoints.filter(function(ep){return ep.general.id!==endpointId;}),endpointId:virtualDFEndpointId,onEndpointSet:onVirtualDFEndpointSet,onNodePing:function onNodePing(){return onVirtualDFEndpointPing(virtualDFEndpointId);},isEndpointAvailable:isVirtualDFEndpointAvailable,doNotGoHome:true,canBeNull:true,fullWidth:true}):null;var VirtualDFDataflowSelector=!!dataflow&&dataflow.isExternalReference?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:onVirtualDFEndpointPing,cbParam:virtualDFEndpointId,disabled:!virtualDFEndpointId||endpoints.find(function(ep){return ep.general.id===virtualDFEndpointId;})===undefined},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_selector__["a" /* default */],{disabled:!!dataflowTriplet||!isVirtualDFEndpointAvailable||!virtualDFEndpointId,selectTitle:t("scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.select.title"),resetTitle:t("scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.reset.title"),onSelect:onVirtualDFDataflowsModalOpen,onReset:onVirtualDFDataflowUnset,value:dataflow.id&&dataflow.agencyID&&dataflow.version?Object(__WEBPACK_IMPORTED_MODULE_23__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:dataflow.id,agencyID:dataflow.agencyID,version:dataflow.version}):null}),virtualDFEndpointId&&isVirtualDFEndpointAvailable&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isVirtualDFDataflowsModalOpen,onCancel:onVirtualDFDataflowsModalClose,title:t('scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.modal.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onVirtualDFDataflowsModalClose},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchVirtualDFDataflows,cbParam:virtualDFEndpointId,disabled:!isVirtualDFDataflowsModalOpen},virtualDFDataflows&&virtualDFDataflows.find(function(_ref5){var agencyID=_ref5.agencyID;return!permissions.agencies.includes(agencyID);})&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.list.alert.someDataflowsAreDisabledForUnallowedAgency')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_artefact_list__["a" /* default */],{artefacts:virtualDFDataflows,onRowClick:onVirtualDFDataflowSet,getIsDisabledRow:function getIsDisabledRow(_ref6){var agencyID=_ref6.agencyID;return!permissions.agencies.includes(agencyID);}})))):null;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchDataflow,cbParam:dataflowTriplet,disabled:isDataflowValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:isAgenciesValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_XL"],title:dataflowTriplet!==null?userHasPermissionsToEdit?t('scenes.metaManager.dataflows.detail.title.editMode.title',{triplet:dataflowTriplet}):t('scenes.metaManager.dataflows.detail.title.viewMode.title',{triplet:dataflowTriplet}):t('scenes.metaManager.dataflows.detail.title.createMode.title'),onCancel:onDetailHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onDetailHide},t('commons.buttons.close.title')),dataflowTriplet===null||userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||dataflow.isExternalReference&&virtualDFEndpointId===null){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{if(dataflowTriplet!==null){onDetailUpdate(dataflow);}else{onDetailCreate(dataflow);}}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return dataflowTriplet?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,permissions&&!userHasPermissionsToEdit&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],justify:"end"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onDownloadShow([dataflowTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){if(dataflow.isExternalReference){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t("scenes.metaManager.dataflows.errors.cannotCloneVirtualDF.title")});}else{onCloneShow(dataflowTriplet);}}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onExportShow(dataflowTriplet);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{activeKey:tab,onTabClick:function onTabClick(key){if(!Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["a" /* isArtefactValid */])(dataflow)||dataflow.isExternalReference&&virtualDFEndpointId===null){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{setTab(key);if(key==="categorisations"){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t('errors.notImplemented')});}if(isDataflowGeneralTabDirty){onDetailUpdate(dataflow,true);}}}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'general',tab:t('commons.artefact.tabs.general.title')},dataflow&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:dataflow,mode:userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],agencies:agencies,onChange:onDetailChange,DSDInput:dataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_32__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]||dataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_32__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]?null:selector(t,onSelectedDsdDetailShow,selectedDsdTriplet,onDsdsShow,onDsdUnset,true),dsdDimensions:dsdForLayoutAnnotations&&dsdForLayoutAnnotations.dimensions,dsdAttributes:dsdForLayoutAnnotations&&dsdForLayoutAnnotations.attributes,isDataflow:true,isLayoutAnnotationsFormVisible:isLayoutAnnotationsFormVisible,dataflow:dataflow,dsdForLayoutAnnotations:dsdForLayoutAnnotations,onLayoutAnnotationsFormShow:onLayoutAnnotationsFormShow,onLayoutAnnotationsFormHide:onLayoutAnnotationsFormHide,onLayoutAnnotationsFormSubmit:onLayoutAnnotationsFormSubmit,onLayoutAnnotationsFormReset:onLayoutAnnotationsFormReset,fetchDsdForLayoutAnnotations:fetchDsdForLayoutAnnotations,itemsPageForLayoutAnnotations:itemsPageForLayoutAnnotations,fetchItemsPageForLayoutAnnotations:fetchItemsPageForLayoutAnnotations,resetItemsPageForLayoutAnnotations:resetItemsPageForLayoutAnnotations,canBeSpecialDataflow:true,VirtualDFNodeInput:VirtualDFNodeSelect,VirtualDFDataflowInput:VirtualDFDataflowSelector})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'categorisations',tab:t('commons.artefact.tabs.categorisations.title')}))):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:dataflow,mode:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */],agencies:agencies,onChange:onDetailChange,DSDInput:dataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_32__utils_dataflow__["c" /* DATAFLOW_TYPE_VIRTUAL */]||dataflow.dataflowType===__WEBPACK_IMPORTED_MODULE_32__utils_dataflow__["b" /* DATAFLOW_TYPE_ONLY_FILE */]?null:selector(t,onSelectedDsdDetailShow,selectedDsdTriplet,onDsdsShow,onDsdUnset),dsdDimensions:dsdForLayoutAnnotations&&dsdForLayoutAnnotations.dimensions,dsdAttributes:dsdForLayoutAnnotations&&dsdForLayoutAnnotations.attributes,isDataflow:true,isLayoutAnnotationsFormVisible:isLayoutAnnotationsFormVisible,dataflow:dataflow,dsdForLayoutAnnotations:dsdForLayoutAnnotations,onLayoutAnnotationsFormShow:onLayoutAnnotationsFormShow,onLayoutAnnotationsFormHide:onLayoutAnnotationsFormHide,onLayoutAnnotationsFormSubmit:onLayoutAnnotationsFormSubmit,onLayoutAnnotationsFormReset:onLayoutAnnotationsFormReset,fetchDsdForLayoutAnnotations:fetchDsdForLayoutAnnotations,itemsPageForLayoutAnnotations:itemsPageForLayoutAnnotations,fetchItemsPageForLayoutAnnotations:fetchItemsPageForLayoutAnnotations,resetItemsPageForLayoutAnnotations:resetItemsPageForLayoutAnnotations,canBeSpecialDataflow:true,VirtualDFNodeInput:VirtualDFNodeSelect,VirtualDFDataflowInput:VirtualDFDataflowSelector});})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isDsdsListVisible,onCancel:onDsdsHide,title:t('commons.artefact.tabs.general.dsd.modals.dsdList.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onDsdsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchDsds},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_artefact_list__["a" /* default */],{artefacts:dsds,onDetailShow:onDsdDetailShow,onRowClick:onDsdSet,getIsDisabledRow:function getIsDisabledRow(_ref7){var isFinal=_ref7.isFinal;return!isFinal;}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__redux_components_redux_dsd_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_25__reducer__["c" /* MM_DATAFLOWS_DSD_DETAIL_PREFIX */],instanceState:dsdDetail}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__redux_components_redux_dsd_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_25__reducer__["d" /* MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX */],instanceState:selectedDsdDetail})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DataflowsDetail));

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Agencies__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducer__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Functionalities__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Cubes__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Rules__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_css__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_infinite_scroll_table__ = __webpack_require__(52);
var mapStateToProps=function mapStateToProps(state){return{token:state.app.user.token,users:state.scenes.manageUsers.setPermissions.users,user:state.scenes.manageUsers.setPermissions.user,currentTab:state.scenes.manageUsers.setPermissions.currentTab,permissions:state.scenes.manageUsers.setPermissions.permissions,isSynchronized:state.scenes.manageUsers.setPermissions.isSynchronized};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchUsers:function fetchUsers(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["B" /* readSetPermissionsUsers */])());},onUserEdit:function onUserEdit(username,email){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["u" /* editSetPermissionsUser */])(username,email));},fetchPermissions:function fetchPermissions(username){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["z" /* readSetPermissionsPermissions */])(username));},onUserHide:function onUserHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["v" /* hideSetPermissionsUser */])());},onTabChange:function onTabChange(tab){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["t" /* changeSetPermissionsTab */])(tab));},onPermissionsSubmit:function onPermissionsSubmit(username,permissions,token){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["C" /* submitSetPermissionsPermissions */])(username,permissions,token));},synchronize:function synchronize(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["D" /* synchronizeSetPermissions */])());}};};var SetPermissions=function SetPermissions(_ref){var t=_ref.t,token=_ref.token,users=_ref.users,user=_ref.user,currentTab=_ref.currentTab,permissions=_ref.permissions,isSynchronized=_ref.isSynchronized,fetchUsers=_ref.fetchUsers,fetchPermissions=_ref.fetchPermissions,onUserEdit=_ref.onUserEdit,onUserHide=_ref.onUserHide,onTabChange=_ref.onTabChange,onPermissionsSubmit=_ref.onPermissionsSubmit,synchronize=_ref.synchronize;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:synchronize,disabled:isSynchronized},isSynchronized&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:fetchUsers,disabled:users!==null},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_infinite_scroll_table__["a" /* default */],{data:users,getRowKey:function getRowKey(_ref2){var username=_ref2.username;return username;},columns:[{title:t('data.user.username.label'),dataIndex:'username',minWidth:__WEBPACK_IMPORTED_MODULE_6__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.user.email.label'),dataIndex:'email',minWidth:__WEBPACK_IMPORTED_MODULE_6__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]}],actions:[function(_ref3){var username=_ref3.username,email=_ref3.email;return Object.assign({},__WEBPACK_IMPORTED_MODULE_18__styles_buttons__["l" /* BUTTON_DETAIL */],{title:t('commons.actions.detail.title'),onClick:function onClick(){return onUserEdit(username,email);}});}]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__hocs_call__["a" /* default */],{cb:fetchPermissions,cbParam:user?user.username:null,disabled:permissions!==null},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:user!==null,width:__WEBPACK_IMPORTED_MODULE_6__styles_constants__["MODAL_WIDTH_MD"],title:t('scenes.manageUsers.setPermissions.modals.setPermissions.title',{username:user?user.username:null}),onCancel:onUserHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onUserHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){return onPermissionsSubmit(user.username,permissions,token);}},t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{onTabClick:function onTabClick(tab){return onTabChange(tab);},activeKey:currentTab},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:__WEBPACK_IMPORTED_MODULE_11__reducer__["c" /* SET_PERMISSIONS_TAB_FUNCTIONALITIES_KEY */],tab:t('scenes.manageUsers.setPermissions.tabs.functionalities.title')},currentTab===__WEBPACK_IMPORTED_MODULE_11__reducer__["c" /* SET_PERMISSIONS_TAB_FUNCTIONALITIES_KEY */]&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Functionalities__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:__WEBPACK_IMPORTED_MODULE_11__reducer__["d" /* SET_PERMISSIONS_TAB_RULES_KEY */],tab:t('scenes.manageUsers.setPermissions.tabs.rules.title')},currentTab===__WEBPACK_IMPORTED_MODULE_11__reducer__["d" /* SET_PERMISSIONS_TAB_RULES_KEY */]&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Rules__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:__WEBPACK_IMPORTED_MODULE_11__reducer__["a" /* SET_PERMISSIONS_TAB_AGENCIES_KEY */],tab:t('scenes.manageUsers.setPermissions.tabs.agencies.title')},currentTab===__WEBPACK_IMPORTED_MODULE_11__reducer__["a" /* SET_PERMISSIONS_TAB_AGENCIES_KEY */]&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Agencies__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:__WEBPACK_IMPORTED_MODULE_11__reducer__["b" /* SET_PERMISSIONS_TAB_CUBES_KEY */],tab:t('scenes.manageUsers.setPermissions.tabs.cubes.title')},currentTab===__WEBPACK_IMPORTED_MODULE_11__reducer__["b" /* SET_PERMISSIONS_TAB_CUBES_KEY */]&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Cubes__["a" /* default */],null)))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(SetPermissions));

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_infinite_scroll_table__ = __webpack_require__(52);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,agencies:state.scenes.manageUsers.setPermissions.agencies,permissions:state.scenes.manageUsers.setPermissions.permissions};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(agenciesPermissions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["p" /* changeSetPermissionsAgenciesPermissions */])(agenciesPermissions));},fetchAgencies:function fetchAgencies(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["w" /* readSetPermissionsAgencies */])());}};};var SetPermissionsAgencies=function SetPermissionsAgencies(_ref){var t=_ref.t,agencies=_ref.agencies,permissions=_ref.permissions,onChange=_ref.onChange,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,fetchAgencies=_ref.fetchAgencies;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchAgencies},agencies&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_infinite_scroll_table__["a" /* default */],{showHeader:false,height:284,data:Object.keys(agencies).map(function(agencyID){var agencyName=Object(__WEBPACK_IMPORTED_MODULE_12__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[agencyID],appLanguage,dataLanguages);return{id:agencyID,label:agencyName?agencyID+' - '+agencyName:agencyID};}),getRowKey:function getRowKey(_ref2){var id=_ref2.id;return id;},columns:[{dataIndex:'label',minWidht:150}],rowSelection:{selectedRowKeys:permissions?permissions.agencies:[],onChange:onChange},rightActions:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onChange(Object.keys(agencies));},type:'primary'},t('commons.buttons.selectAll.title'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onChange([]);}},t('commons.buttons.deselectAll.title'))))}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(SetPermissionsAgencies));

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_menus__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_grid_row__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_grid_col__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{permissions:state.scenes.manageUsers.setPermissions.permissions,functionalities:state.scenes.manageUsers.setPermissions.functionalities};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(functionalitiesPermissions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["r" /* changeSetPermissionsFunctionalitiesPermissions */])(functionalitiesPermissions));},fetchFunctionalities:function fetchFunctionalities(menu){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["y" /* readSetPermissionsFunctionalities */])(menu));}};};var onNodeCheck=function onNodeCheck(checkedNodes,checkedNode,check,onChange){var ret=[];checkedNode=checkedNode.props["data-node"];check&&checkedNode&&checkedNode.Children&&checkedNode.Children.map(function(child){return ret.push(child.Functionality);});onChange(checkedNodes.concat(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.difference(ret,checkedNodes)));};var SetPermissionsFunctionalities=function SetPermissionsFunctionalities(_ref){var t=_ref.t,functionalities=_ref.functionalities,permissions=_ref.permissions,onChange=_ref.onChange,fetchFunctionalities=_ref.fetchFunctionalities;var allFunctionalities=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tree__["l" /* getNodes */])(functionalities,"Children",function(){return true;}).map(function(_ref2){var Functionality=_ref2.Functionality;return Functionality;});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchFunctionalities,cbParam:[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_10__constants_menus__["b" /* userMenu */])(t)),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_10__constants_menus__["a" /* superUserMenu */])(t)))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'set-permissions__functionalities__tree'},functionalities&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_enhanced_tree__["a" /* default */],{tree:functionalities,childrenKey:'Children',idKey:'Functionality',nameKey:'name',catIdKey:'Functionality',catNameKey:'name',hiddenIdKeys:allFunctionalities,getFilter:function getFilter(searchText){return function(_ref3){var name=_ref3.name;return name&&name.toLowerCase().indexOf(searchText.toLowerCase())>=0;};},getIsNameMultilanguage:function getIsNameMultilanguage(){return false;},checkable:true,checkStrictly:true,checkedKeys:permissions?permissions.functionality:[],onCheck:function onCheck(_ref4,_ref5){var checked=_ref4.checked;var node=_ref5.node,check=_ref5.checked;return onNodeCheck(checked,node,check,onChange);},noPagination:true,unselectableKeys:allFunctionalities,isEmptyCategoryIconLikeLeafIcon:true,isRootIconLikeChildrenIcon:true,icon:'file',rightActions:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_es_grid_row__["a" /* default */],{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_es_grid_col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return onChange(allFunctionalities);},type:'primary'},t('commons.buttons.selectAll.title'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_es_grid_col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return onChange(null);}},t('commons.buttons.deselectAll.title'))))})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(SetPermissionsFunctionalities));

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_provider__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RowContext__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_type__ = __webpack_require__(1494);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

 // matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82

var enquire;

if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  };

  window.matchMedia = window.matchMedia || matchMediaPolyfill;
  enquire = __webpack_require__(405);
}






var RowAligns = Object(__WEBPACK_IMPORTED_MODULE_5__util_type__["a" /* tuple */])('top', 'middle', 'bottom');
var RowJustify = Object(__WEBPACK_IMPORTED_MODULE_5__util_type__["a" /* tuple */])('start', 'end', 'center', 'space-around', 'space-between');
var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};

var Row =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Row, _React$Component);

  function Row() {
    var _this;

    _classCallCheck(this, Row);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Row).apply(this, arguments));
    _this.state = {
      screens: {}
    };

    _this.renderRow = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          justify = _a.justify,
          align = _a.align,
          className = _a.className,
          style = _a.style,
          children = _a.children,
          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);

      var prefixCls = getPrefixCls('row', customizePrefixCls);

      var gutter = _this.getGutter();

      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);
      var rowStyle = gutter > 0 ? _extends({
        marginLeft: gutter / -2,
        marginRight: gutter / -2
      }, style) : style;

      var otherProps = _extends({}, others);

      delete otherProps.gutter;
      return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__RowContext__["a" /* default */].Provider, {
        value: {
          gutter: gutter
        }
      }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", _extends({}, otherProps, {
        className: classes,
        style: rowStyle
      }), children));
    };

    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Object.keys(responsiveMap).map(function (screen) {
        return enquire.register(responsiveMap[screen], {
          match: function match() {
            if (_typeof(_this2.props.gutter) !== 'object') {
              return;
            }

            _this2.setState(function (prevState) {
              return {
                screens: _extends({}, prevState.screens, _defineProperty({}, screen, true))
              };
            });
          },
          unmatch: function unmatch() {
            if (_typeof(_this2.props.gutter) !== 'object') {
              return;
            }

            _this2.setState(function (prevState) {
              return {
                screens: _extends({}, prevState.screens, _defineProperty({}, screen, false))
              };
            });
          },
          // Keep a empty destory to avoid triggering unmatch when unregister
          destroy: function destroy() {}
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Object.keys(responsiveMap).map(function (screen) {
        return enquire.unregister(responsiveMap[screen]);
      });
    }
  }, {
    key: "getGutter",
    value: function getGutter() {
      var gutter = this.props.gutter;

      if (_typeof(gutter) === 'object') {
        for (var i = 0; i < responsiveArray.length; i++) {
          var breakpoint = responsiveArray[i];

          if (this.state.screens[breakpoint] && gutter[breakpoint] !== undefined) {
            return gutter[breakpoint];
          }
        }
      }

      return gutter;
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__config_provider__["a" /* ConfigConsumer */], null, this.renderRow);
    }
  }]);

  return Row;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);


Row.defaultProps = {
  gutter: 0
};
Row.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types__["oneOf"](['flex']),
  align: __WEBPACK_IMPORTED_MODULE_3_prop_types__["oneOf"](RowAligns),
  justify: __WEBPACK_IMPORTED_MODULE_3_prop_types__["oneOf"](RowJustify),
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types__["string"],
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types__["node"],
  gutter: __WEBPACK_IMPORTED_MODULE_3_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_3_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_3_prop_types__["number"]]),
  prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types__["string"]
};

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__empty__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(259);




/* babel-plugin-inline-import './empty.svg' */
var emptyImg = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var renderEmpty = function renderEmpty(componentName) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["a" /* ConfigConsumer */], null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('empty');

    switch (componentName) {
      case 'Table':
      case 'List':
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__empty__["a" /* default */], {
          image: emptyImg,
          className: "".concat(prefix, "-normal")
        });

      case 'Select':
      case 'TreeSelect':
      case 'Cascader':
      case 'Transfer':
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__empty__["a" /* default */], {
          image: emptyImg,
          className: "".concat(prefix, "-small")
        });

      default:
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__empty__["a" /* default */], null);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (renderEmpty);

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_provider__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale_provider_LocaleReceiver__ = __webpack_require__(1490);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};






/* babel-plugin-inline-import './empty.svg' */
var emptyImg = "data:image/svg+xml;base64,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";

var Empty = function Empty(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__config_provider__["a" /* ConfigConsumer */], null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var className = props.className,
        image = props.image,
        description = props.description,
        children = props.children,
        restProps = __rest(props, ["className", "image", "description", "children"]);

    var prefixCls = getPrefixCls('empty', props.prefixCls);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__locale_provider_LocaleReceiver__["a" /* default */], {
      componentName: "Empty"
    }, function (locale) {
      var des = description || locale.description;
      var alt = typeof des === 'string' ? des : 'empty';
      var imageNode = null;

      if (!image) {
        imageNode = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", {
          alt: alt,
          src: emptyImg
        });
      } else if (typeof image === 'string') {
        imageNode = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", {
          alt: alt,
          src: image
        });
      } else {
        imageNode = image;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(prefixCls, className)
      }, restProps), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
        className: "".concat(prefixCls, "-image")
      }, imageNode), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", {
        className: "".concat(prefixCls, "-description")
      }, des), children && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
        className: "".concat(prefixCls, "-footer")
      }, children));
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Empty);

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocaleReceiver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default__ = __webpack_require__(1491);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var LocaleReceiver =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocaleReceiver, _React$Component);

  function LocaleReceiver() {
    _classCallCheck(this, LocaleReceiver);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocaleReceiver).apply(this, arguments));
  }

  _createClass(LocaleReceiver, [{
    key: "getLocale",
    value: function getLocale() {
      var _this$props = this.props,
          componentName = _this$props.componentName,
          defaultLocale = _this$props.defaultLocale;
      var locale = defaultLocale || __WEBPACK_IMPORTED_MODULE_2__default__["a" /* default */][componentName || 'global'];
      var antLocale = this.context.antLocale;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _extends({}, typeof locale === 'function' ? locale() : locale, localeFromContext || {});
    }
  }, {
    key: "getLocaleCode",
    value: function getLocaleCode() {
      var antLocale = this.context.antLocale;
      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

      if (antLocale && antLocale.exist && !localeCode) {
        return __WEBPACK_IMPORTED_MODULE_2__default__["a" /* default */].locale;
      }

      return localeCode;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.getLocale(), this.getLocaleCode());
    }
  }]);

  return LocaleReceiver;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


LocaleReceiver.defaultProps = {
  componentName: 'global'
};
LocaleReceiver.contextTypes = {
  antLocale: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"]
};

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_pagination_es_locale_en_US__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_picker_locale_en_US__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_picker_locale_en_US__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar_locale_en_US__ = __webpack_require__(1493);




/* harmony default export */ __webpack_exports__["a"] = ({
  locale: 'en',
  Pagination: __WEBPACK_IMPORTED_MODULE_0_rc_pagination_es_locale_en_US__["a" /* default */],
  DatePicker: __WEBPACK_IMPORTED_MODULE_1__date_picker_locale_en_US__["a" /* default */],
  TimePicker: __WEBPACK_IMPORTED_MODULE_2__time_picker_locale_en_US__["a" /* default */],
  Calendar: __WEBPACK_IMPORTED_MODULE_3__calendar_locale_en_US__["a" /* default */],
  global: {
    placeholder: 'Please select'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    sortTitle: 'Sort'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file'
  },
  Empty: {
    description: 'No Data'
  }
});

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Goto',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
});

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_picker_locale_en_US__ = __webpack_require__(588);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__date_picker_locale_en_US__["a" /* default */]);

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tuple; });
// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Col; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RowContext__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_provider__ = __webpack_require__(259);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};






var objectOrNumber = __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"]]);

var Col =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _this;

    _classCallCheck(this, Col);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Col).apply(this, arguments));

    _this.renderCol = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var props = _this.props;

      var customizePrefixCls = props.prefixCls,
          span = props.span,
          order = props.order,
          offset = props.offset,
          push = props.push,
          pull = props.pull,
          className = props.className,
          children = props.children,
          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);

      var prefixCls = getPrefixCls('col', customizePrefixCls);
      var sizeClassObj = {};
      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
        var _extends2;

        var sizeProps = {};

        if (typeof props[size] === 'number') {
          sizeProps.span = props[size];
        } else if (_typeof(props[size]) === 'object') {
          sizeProps = props[size] || {};
        }

        delete others[size];
        sizeClassObj = _extends({}, sizeClassObj, (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
      });
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__RowContext__["a" /* default */].Consumer, null, function (_ref2) {
        var gutter = _ref2.gutter;
        var style = others.style;

        if (gutter > 0) {
          style = _extends({
            paddingLeft: gutter / 2,
            paddingRight: gutter / 2
          }, style);
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({}, others, {
          style: style,
          className: classes
        }), children);
      });
    };

    return _this;
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__config_provider__["a" /* ConfigConsumer */], null, this.renderCol);
    }
  }]);

  return Col;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


Col.propTypes = {
  span: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  order: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  pull: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["node"],
  xs: objectOrNumber,
  sm: objectOrNumber,
  md: objectOrNumber,
  lg: objectOrNumber,
  xl: objectOrNumber,
  xxl: objectOrNumber
};

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,categorisedCubes:state.scenes.manageUsers.setPermissions.categorisedCubes,permissions:state.scenes.manageUsers.setPermissions.permissions};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(categorisedCubesPermissions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["q" /* changeSetPermissionsCategorisedCubesPermissions */])(categorisedCubesPermissions));},fetchCategorisedCubes:function fetchCategorisedCubes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["x" /* readSetPermissionsCategorisedCubes */])());}};};var onNodeCheck=function onNodeCheck(checkedNodes,checkedNode,check,onChange){var ret=[];checkedNode=checkedNode.props["data-node"];check&&checkedNode&&checkedNode.children&&Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["h" /* getMappedTree */])(checkedNode.children,"children",function(child){child.Code?ret.push(child.Code):ret.push(child.CatCode);return child;});onChange(checkedNodes.concat(__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.difference(ret,checkedNodes)));};var SetPermissionsCubes=function SetPermissionsCubes(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,permissions=_ref.permissions,categorisedCubes=_ref.categorisedCubes,onChange=_ref.onChange,fetchCategorisedCubes=_ref.fetchCategorisedCubes;var allCubes=Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["l" /* getNodes */])(categorisedCubes,"children",function(){return true;}).map(function(_ref2){var Code=_ref2.Code,CatCode=_ref2.CatCode;return Code||CatCode;});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hocs_call__["a" /* default */],{cb:fetchCategorisedCubes},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"set-permissions__cubes__tree"},categorisedCubes&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_enhanced_tree__["a" /* default */],{tree:categorisedCubes,childrenKey:"children",idKey:"Code",nameKey:"labels",catIdKey:"CatCode",catNameKey:"labels",getFilter:function getFilter(searchText){return function(_ref3){var Code=_ref3.Code,CatCode=_ref3.CatCode,labels=_ref3.labels;var search=searchText.toLowerCase();return Code&&Code.toLowerCase().indexOf(search)>=0||CatCode&&CatCode.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_14__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},unselectableKeys:allCubes,checkable:true,checkStrictly:true,checkedKeys:permissions?[].concat(_toConsumableArray(permissions.cube),_toConsumableArray(permissions.cubeOwner),_toConsumableArray(permissions.category)):[],getNodeIsCheckable:function getNodeIsCheckable(_ref4){var Code=_ref4.Code;return Code===undefined||!permissions.cubeOwner.includes(Code);},onCheck:function onCheck(_ref5,_ref6){var checked=_ref5.checked;var node=_ref6.node,check=_ref6.checked;return onNodeCheck(checked.filter(function(_ref7){var Code=_ref7.Code;return Code===undefined||!permissions.cubeOwner.includes(Code)||permissions.cube.includes(Code);}),node,check,onChange);},noPagination:true,icon:"cube",isCustomIcon:true,getIconColor:function getIconColor(){return"#37a0f4";},isRootIconLikeChildrenIcon:true,rightActions:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onChange(allCubes);},type:"primary"},t('commons.buttons.selectAll.title'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onChange(null);}},t('commons.buttons.deselectAll.title'))))})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(SetPermissionsCubes));

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_infinite_scroll_table__ = __webpack_require__(52);
var mapStateToProps=function mapStateToProps(state){return{permissions:state.scenes.manageUsers.setPermissions.permissions,rules:state.scenes.manageUsers.setPermissions.rules};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(rulesPermissions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["s" /* changeSetPermissionsRulesPermissions */])(rulesPermissions));},fetchRules:function fetchRules(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["A" /* readSetPermissionsRules */])());}};};var SetPermissionsRules=function SetPermissionsRules(_ref){var t=_ref.t,rules=_ref.rules,permissions=_ref.permissions,onChange=_ref.onChange,fetchRules=_ref.fetchRules;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hocs_call__["a" /* default */],{cb:fetchRules},rules&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_infinite_scroll_table__["a" /* default */],{showHeader:false,height:284,data:rules.map(function(rule){return{name:rule};}),getRowKey:function getRowKey(_ref2){var name=_ref2.name;return name;},columns:[{dataIndex:'name',minWidht:150}],rowSelection:{selectedRowKeys:permissions?permissions.rules:[],onChange:onChange},rightActions:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onChange(rules);},type:'primary'},t('commons.buttons.selectAll.title'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onChange([]);}},t('commons.buttons.deselectAll.title'))))}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(SetPermissionsRules));

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_infinite_scroll_table__ = __webpack_require__(52);
var mapStateToProps=function mapStateToProps(state){return{codelists:state.scenes.dataManager.syncCodelist.codelists,selectedCodelists:state.scenes.dataManager.syncCodelist.selectedCodelists};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCodelistToSync:function fetchCodelistToSync(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["e" /* readSyncCodelistCodelistToSyncList */])());},onCodelistsToSyncChange:function onCodelistsToSyncChange(selectedCodelists){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["d" /* changeSyncCodelistsCodelistsToSync */])(selectedCodelists));},onSyncCodelistsSubmit:function onSyncCodelistsSubmit(codelistsToSync,codelists){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["f" /* submitSyncCodelistsSyncCodelists */])(codelistsToSync,codelists));}};};var SyncCodelist=function SyncCodelist(_ref){var t=_ref.t,codelists=_ref.codelists,selectedCodelists=_ref.selectedCodelists,fetchCodelistToSync=_ref.fetchCodelistToSync,onCodelistsToSyncChange=_ref.onCodelistsToSyncChange,onSyncCodelistsSubmit=_ref.onSyncCodelistsSubmit;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{title:t("scenes.dataManager.syncCodelist.title"),type:"inner"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__hocs_call__["a" /* default */],{cb:fetchCodelistToSync,disabled:codelists!==null},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_infinite_scroll_table__["a" /* default */],{data:codelists,getRowKey:function getRowKey(codelist){return codelist.id+"+"+codelist.agency+"+"+codelist.version;},columns:[{title:t('data.artefact.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.agencyID.shortLabel'),dataIndex:'agency',minWidthToContent:true,withValuesFilter:true},{title:t('data.artefact.version.shortLabel'),dataIndex:'version',minWidthToContent:true,withValuesFilter:true},{title:t('scenes.dataManager.syncCodelist.itemsToSync.label'),dataIndex:'itemsToSync',minWidthToContent:true,withValuesFilter:true}],rowSelection:{selectedRowKeys:selectedCodelists,onChange:function onChange(selectedArr){return onCodelistsToSyncChange(selectedArr);}}}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"end",style:{marginTop:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,selectedCodelists&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{disabled:!selectedCodelists||selectedCodelists.length===0,type:"primary",onClick:function onClick(){return onSyncCodelistsSubmit(selectedCodelists,codelists);}},selectedCodelists.length>0?t('scenes.dataManager.syncCodelist.buttons.sync.title',{count:selectedCodelists.length}):t('scenes.dataManager.syncCodelist.buttons.syncEmpty.title'))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(SyncCodelist));

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_paths__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_copy_to_clipboard__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commons_MetadataSetDetail__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__commons_ReportList__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ReportDetailWrapper__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_html_template_viewer__ = __webpack_require__(363);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,appLang:state.app.language,dataLangs:state.config.dataManagement.dataLanguages,permissions:state.app.user.permissions,conceptSchemeTriplets:state.scenes.referenceMetadata.dcat.conceptSchemeTriplets,metadataSetId:state.scenes.referenceMetadata.dcat.metadataSetId,isMetadataSetVisible:state.scenes.referenceMetadata.dcat.isMetadataSetVisible,metadataSet:state.scenes.referenceMetadata.dcat.metadataSet,metadataSets:state.scenes.referenceMetadata.dcat.metadataSets,metadataSetHtmlPageUrl:state.scenes.referenceMetadata.dcat.metadataSetHtmlPageUrl,isReportsVisible:state.scenes.referenceMetadata.dcat.isReportsVisible,reports:state.scenes.referenceMetadata.dcat.reports,isReportVisible:state.scenes.referenceMetadata.dcat.isReportVisible,report:state.scenes.referenceMetadata.dcat.report,reportAnnotations:state.scenes.referenceMetadata.dcat.reportAnnotations,reportStructure:state.scenes.referenceMetadata.dcat.reportStructure,step:state.scenes.referenceMetadata.dcat.step,reportId:state.scenes.referenceMetadata.dcat.reportId,target:state.scenes.referenceMetadata.dcat.target,identifiableTargets:state.scenes.referenceMetadata.dcat.identifiableTargets,reportHtmlPageUrl:state.scenes.referenceMetadata.dcat.reportHtmlPageUrl,isMetadataflowsVisible:state.scenes.referenceMetadata.dcat.isMetadataflowsVisible,metadataflows:state.scenes.referenceMetadata.dcat.metadataflows,selectedAttribute:state.scenes.referenceMetadata.dcat.selectedAttribute};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchMetadataSets:function fetchMetadataSets(_ref){var msdTriplet=_ref.msdTriplet,ownedMetadataflows=_ref.ownedMetadataflows;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_24" /* readDcatMetadataSets */])(msdTriplet,ownedMetadataflows));},onMetadataSetShow:function onMetadataSetShow(metadataSetId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_35" /* showDcatMetadataSet */])(metadataSetId));},onMetadataSetHide:function onMetadataSetHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_12" /* hideDcatMetadataSet */])());},fetchMetadataSet:function fetchMetadataSet(metadataSetId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_22" /* readDcatMetadataSet */])(metadataSetId));},onMetadataSetCreate:function onMetadataSetCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_3" /* createDcatMetadataSet */])());},onMetadataSetChange:function onMetadataSetChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_0" /* changeDcatMetadataSet */])(fields));},onMetadataSetSubmit:function onMetadataSetSubmit(metadataSet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_43" /* submitDcatMetadataSet */])(metadataSet));},onMetadataSetDelete:function onMetadataSetDelete(metadataSet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_6" /* deleteDcatMetadataSet */])(metadataSet));},onReportsShow:function onReportsShow(metadataSetId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_37" /* showDcatMetadataSetReports */])(metadataSetId));},onReportsHide:function onReportsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_14" /* hideDcatMetadataSetReports */])());},fetchReports:function fetchReports(_ref2){var metadataSetId=_ref2.metadataSetId,ownedDataflows=_ref2.ownedDataflows,ownedMetadataflows=_ref2.ownedMetadataflows;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_23" /* readDcatMetadataSetReports */])(metadataSetId,ownedDataflows,ownedMetadataflows));},fetchConceptSchemes:function fetchConceptSchemes(_ref3){var conceptSchemeTriplets=_ref3.conceptSchemeTriplets,appLang=_ref3.appLang,dataLangs=_ref3.dataLangs;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_20" /* readDcatConceptSchemes */])(conceptSchemeTriplets,appLang,dataLangs));},onMetadataflowsShow:function onMetadataflowsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_38" /* showDcatMetadataflows */])());},onMetadataflowsHide:function onMetadataflowsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_15" /* hideDcatMetadataflows */])());},fetchMetadataflows:function fetchMetadataflows(ownedMetadataflows,msdUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_25" /* readDcatMetadataflows */])(ownedMetadataflows,msdUrn));},onMetadataflowSet:function onMetadataflowSet(triplet,msdUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_31" /* setDcatMetadataflow */])(triplet,msdUrn));},onMetadataflowUnset:function onMetadataflowUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_46" /* unsetDcatMetadataflow */])());},onMetadataSetHtmlPageShow:function onMetadataSetHtmlPageShow(htmlPageUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_36" /* showDcatMetadataSetHtmlPage */])(htmlPageUrl));},onMetadataSetHtmlPageHide:function onMetadataSetHtmlPageHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_13" /* hideDcatMetadataSetHtmlPage */])());},onReportCreate:function onReportCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_4" /* createDcatReport */])());},onReportDelete:function onReportDelete(reportId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_7" /* deleteDcatReport */])(reportId));},fetchReport:function fetchReport(metadataSetId,reportId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_26" /* readDcatReport */])(metadataSetId,reportId));},onReportHide:function onReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_16" /* hideDcatReport */])());},onReportSubmit:function onReportSubmit(metadataSet,report,reportAnnotations,reportStructure,id,target,identifiableTargets,annotationsConfig,isDraft){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_44" /* submitDcatReport */])(metadataSet,report,reportAnnotations,reportStructure,id,target,identifiableTargets,annotationsConfig,isDraft));},onStepSet:function onStepSet(step,dataLanguages,t,mawsUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_33" /* setDcatReportStep */])(step,dataLanguages,t,mawsUrl));},onReportStateSubmit:function onReportStateSubmit(metadataSetId,reportId,newState){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_45" /* submitDcatUpdateReportState */])(metadataSetId,reportId,newState));},onReportHtmlPageShow:function onReportHtmlPageShow(htmlPageUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_40" /* showDcatReportHtmlPage */])(htmlPageUrl));},onReportHtmlPageHide:function onReportHtmlPageHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_18" /* hideDcatReportHtmlPage */])());},onReportDownload:function onReportDownload(metadataSetId,reportId,fileName,metadataApiBaseUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_9" /* downloadDcatReport */])(metadataSetId,reportId,fileName,metadataApiBaseUrl));}};};var DCAT=function DCAT(_ref4){var t=_ref4.t,nodes=_ref4.nodes,nodeId=_ref4.nodeId,appLang=_ref4.appLang,dataLangs=_ref4.dataLangs,permissions=_ref4.permissions,metadataSets=_ref4.metadataSets,metadataSetId=_ref4.metadataSetId,isMetadataSetVisible=_ref4.isMetadataSetVisible,metadataSet=_ref4.metadataSet,conceptSchemeTriplets=_ref4.conceptSchemeTriplets,isMetadataflowsVisible=_ref4.isMetadataflowsVisible,metadataflows=_ref4.metadataflows,metadataSetHtmlPageUrl=_ref4.metadataSetHtmlPageUrl,reportHtmlPageUrl=_ref4.reportHtmlPageUrl,isReportsVisible=_ref4.isReportsVisible,reports=_ref4.reports,isReportVisible=_ref4.isReportVisible,step=_ref4.step,report=_ref4.report,reportAnnotations=_ref4.reportAnnotations,reportStructure=_ref4.reportStructure,reportId=_ref4.reportId,target=_ref4.target,identifiableTargets=_ref4.identifiableTargets,selectedAttribute=_ref4.selectedAttribute,fetchMetadataSets=_ref4.fetchMetadataSets,onMetadataSetShow=_ref4.onMetadataSetShow,onMetadataSetHide=_ref4.onMetadataSetHide,fetchMetadataSet=_ref4.fetchMetadataSet,onMetadataSetCreate=_ref4.onMetadataSetCreate,onMetadataSetChange=_ref4.onMetadataSetChange,onMetadataSetSubmit=_ref4.onMetadataSetSubmit,onMetadataSetDelete=_ref4.onMetadataSetDelete,fetchConceptSchemes=_ref4.fetchConceptSchemes,onReportsShow=_ref4.onReportsShow,onReportsHide=_ref4.onReportsHide,fetchReports=_ref4.fetchReports,onMetadataflowsShow=_ref4.onMetadataflowsShow,onMetadataflowsHide=_ref4.onMetadataflowsHide,_fetchMetadataflows=_ref4.fetchMetadataflows,onMetadataflowSet=_ref4.onMetadataflowSet,onMetadataflowUnset=_ref4.onMetadataflowUnset,onMetadataSetHtmlPageShow=_ref4.onMetadataSetHtmlPageShow,onMetadataSetHtmlPageHide=_ref4.onMetadataSetHtmlPageHide,onReportCreate=_ref4.onReportCreate,onReportDelete=_ref4.onReportDelete,fetchReport=_ref4.fetchReport,onReportHide=_ref4.onReportHide,onReportSubmit=_ref4.onReportSubmit,onStepSet=_ref4.onStepSet,onReportStateSubmit=_ref4.onReportStateSubmit,onReportHtmlPageShow=_ref4.onReportHtmlPageShow,onReportHtmlPageHide=_ref4.onReportHtmlPageHide,onReportDownload=_ref4.onReportDownload;var connectedNode=nodes.find(function(node){return node.general.id===nodeId;});var metadataApiBaseUrl=connectedNode.endpoint.metadataBaseURL;var msdUrn=connectedNode.dcatapit.msd;var msdTriplet=msdUrn?Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(connectedNode.dcatapit.msd):null;var metadataflowTriplet=metadataSet?Object(__WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(metadataSet):null;var hasMetadataflowPermission=permissions&&metadataflowTriplet&&permissions.metadataflowOwner.includes(Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(metadataflowTriplet));var ownedDataflows=permissions&&permissions.dataflowOwner?permissions.dataflowOwner:[];var ownedMetadataflows=permissions&&permissions.metadataflowOwner?permissions.metadataflowOwner:[];return msdTriplet?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchMetadataSets,cbParam:{msdTriplet:msdTriplet,ownedMetadataflows:ownedMetadataflows},disabled:metadataSets!==null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchConceptSchemes,cbParam:{conceptSchemeTriplets:conceptSchemeTriplets,appLang:appLang,dataLangs:dataLangs},disabled:conceptSchemeTriplets===null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_infinite_scroll_table__["a" /* default */],{data:metadataSets,getRowKey:function getRowKey(_ref5){var id=_ref5.id;return id;},columns:[{title:t('data.artefact.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.name.shortLabel'),dataIndex:'name',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('scenes.referenceMetadata.dcat.metadataSetList.columns.mdfId.shortLabel'),dataIndex:'mdfId',minWidth:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('scenes.referenceMetadata.dcat.metadataSetList.columns.mdfAgency.shortLabel'),dataIndex:'mdfAgency',widthToContent:true,withValuesFilter:true},{title:t('scenes.referenceMetadata.dcat.metadataSetList.columns.mdfVersion.shortLabel'),dataIndex:'mdfVersion',widthToContent:true,withValuesFilter:true}],multilangStrDataIndexes:["name"],actions:[function(_ref6){var dfPerm=_ref6.hasPermission;return Object.assign({},__WEBPACK_IMPORTED_MODULE_22__styles_buttons__["l" /* BUTTON_DETAIL */],{title:dfPerm===false?t("commons.actions.detailReadOnly.title"):t("commons.actions.detail.title"),onClick:function onClick(_ref7){var id=_ref7.id;return onMetadataSetShow(id);}});},function(){return Object.assign({},__WEBPACK_IMPORTED_MODULE_22__styles_buttons__["C" /* BUTTON_REPORTS */],{title:t('scenes.referenceMetadata.dcat.metadataSetList.actions.showReportList.title'),onClick:function onClick(_ref8){var id=_ref8.id;return onReportsShow(id);}});},function(){return Object.assign({},__WEBPACK_IMPORTED_MODULE_22__styles_buttons__["s" /* BUTTON_INFO_PAGE */],{title:t('scenes.referenceMetadata.dcat.metadataSetList.actions.navigateCategoryHtmlPage.title'),onClick:function onClick(_ref9){var id=_ref9.id;return onMetadataSetHtmlPageShow(Object(__WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__["G" /* getDcatMetadataSetCategoryHtmlPageUrl */])(nodeId,id,appLang,metadataApiBaseUrl));},disabled:!metadataApiBaseUrl});},function(){return Object.assign({},__WEBPACK_IMPORTED_MODULE_22__styles_buttons__["t" /* BUTTON_INFO_PAGE_LINK */],{title:t('scenes.referenceMetadata.dcat.metadataSetList.actions.copyCategoryHtmlPageUrl.title'),onClick:function onClick(_ref10){var id=_ref10.id;__WEBPACK_IMPORTED_MODULE_23_copy_to_clipboard___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__["G" /* getDcatMetadataSetCategoryHtmlPageUrl */])(nodeId,id,appLang,metadataApiBaseUrl));return __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.info(t("scenes.referenceMetadata.dcat.metadataSetList.actions.copyCategoryHtmlPageUrl.message"));},disabled:!metadataApiBaseUrl});},function(){return Object.assign({},__WEBPACK_IMPORTED_MODULE_22__styles_buttons__["b" /* BUTTON_API_LINK */],{title:t('scenes.referenceMetadata.dcat.metadataSetList.actions.copyCkanUrl.title'),onClick:function onClick(_ref11){var id=_ref11.id;__WEBPACK_IMPORTED_MODULE_23_copy_to_clipboard___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__["I" /* getMetadataApiDcatMetadataSetUrl */])(metadataApiBaseUrl,id,appLang));return __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.info(t("scenes.referenceMetadata.dcat.metadataSetList.actions.copyCkanUrl.message"));},disabled:!metadataApiBaseUrl});},function(_ref12){var mdfPerm=_ref12.hasPermission;return Object.assign({},__WEBPACK_IMPORTED_MODULE_22__styles_buttons__["k" /* BUTTON_DELETE */],{title:t("commons.actions.delete.title"),onClick:function onClick(_ref13){var id=_ref13.id;return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('scenes.referenceMetadata.dcat.metadataSetList.actions.delete.title',{id:id}),onOk:function onOk(){onMetadataSetDelete(id);},cancelText:t('commons.buttons.cancel.title')});},disabled:!mdfPerm});}],rightActions:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",icon:"plus",onClick:onMetadataSetCreate},t('scenes.referenceMetadata.dcat.metadataSetList.actions.create.title'))}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isMetadataSetVisible,onCancel:onMetadataSetHide,title:t('scenes.referenceMetadata.dcat.modals.metadataSetDetail.title'),width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_LG"],withDataLanguageSelector:true,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onMetadataSetHide},t('commons.buttons.close.title'))),(!(metadataSet&&!!Object(__WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */]))||hasMetadataflowPermission)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onMetadataSetSubmit(metadataSet);},type:"primary",disabled:!metadataSet||!metadataSet.id||metadataSet.id.length===0||Object(__WEBPACK_IMPORTED_MODULE_24__commons_MetadataSetDetail__["e" /* isMetadataSetIdWarningVisible */])(metadataSet,metadataSets)||!Object(__WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__["d" /* isDictionaryValid */])(metadataSet.name)||!metadataSet.metadataflowTriplet||!metadataSet.msdUrn||!Object(__WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__["c" /* isDateValid */])(metadataSet.reportingBegin,metadataSet.reportingEnd)||!Object(__WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__["c" /* isDateValid */])(metadataSet.validFrom,metadataSet.validTo)||!Object(__WEBPACK_IMPORTED_MODULE_25__utils_artefactValidators__["j" /* isYearValid */])(metadataSet.publicationYear)},t("commons.buttons.save.title"))))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchMetadataSet,cbParam:metadataSetId,disabled:!metadataSetId||!msdTriplet||metadataSet!==null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__commons_MetadataSetDetail__["d" /* default */],{isDcat:true,mode:metadataSet&&Object(__WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_21__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */])!==undefined?hasMetadataflowPermission?__WEBPACK_IMPORTED_MODULE_24__commons_MetadataSetDetail__["b" /* METADATA_SET_DETAIL_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_24__commons_MetadataSetDetail__["c" /* METADATA_SET_DETAIL_MODE_READ */]:__WEBPACK_IMPORTED_MODULE_24__commons_MetadataSetDetail__["a" /* METADATA_SET_DETAIL_MODE_CREATE */],metadataSet:metadataSet,metadataSets:metadataSets,onMetadataSetChange:onMetadataSetChange,isMetadataflowsVisible:isMetadataflowsVisible,metadataflows:metadataflows,onMetadataflowsShow:onMetadataflowsShow,onMetadataflowsHide:onMetadataflowsHide,fetchMetadataflows:function fetchMetadataflows(ownedMetadataflows){return _fetchMetadataflows(ownedMetadataflows,msdUrn);},onMetadataflowSet:onMetadataflowSet,onMetadataflowUnset:onMetadataflowUnset}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isReportsVisible,onCancel:onReportsHide,title:t('scenes.referenceMetadata.dcat.modals.reportList.title'),width:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MODAL_WIDTH_LG"],withDataLanguageSelector:true,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onReportsHide},t('commons.buttons.close.title'))))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchReports,cbParam:{metadataSetId:metadataSetId,ownedDataflows:ownedDataflows,ownedMetadataflows:ownedMetadataflows},disabled:!metadataSetId||reports!==null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__commons_ReportList__["a" /* default */],{isDcat:true,ReportDetailWrapper:__WEBPACK_IMPORTED_MODULE_27__ReportDetailWrapper__["a" /* default */],hasPermission:true,metadataSet:metadataSet,reports:reports?reports.sort(function(a,b){return a.target.id.localeCompare(b.target.id);}):null,report:report,reportAnnotations:reportAnnotations,isReportVisible:isReportVisible,reportStructure:reportStructure,step:step,reportId:reportId,target:target,identifiableTargets:identifiableTargets,reportHtmlPageUrl:reportHtmlPageUrl,selectedAttribute:selectedAttribute,onReportCreate:onReportCreate,onReportDelete:onReportDelete,onReportShow:fetchReport,onReportHide:onReportHide,onReportSubmit:onReportSubmit,onStepSet:onStepSet,onReportStateSubmit:onReportStateSubmit,onHtmlPageShow:onReportHtmlPageShow,onHtmlPageHide:onReportHtmlPageHide,onReportDownload:onReportDownload}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_html_template_viewer__["a" /* default */],{title:t('scenes.referenceMetadata.commons.modals.htmlPage.title'),htmlPageUrl:metadataSetHtmlPageUrl,onClose:onMetadataSetHtmlPageHide})):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('scenes.referenceMetadata.dcat.noDcatMsd.title'),content:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,t('scenes.referenceMetadata.dcat.noDcatMsd.content')+" ",__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("a",{href:"./#"+__WEBPACK_IMPORTED_MODULE_17__constants_paths__["L" /* PATH_NODES_CONFIGURATION */],style:{textDecoration:"underline"}},t('scenes.referenceMetadata.dcat.nodesConfigLink.label')))});}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DCAT));

/***/ }),
/* 1501 */
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_ReportDetail__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__ = __webpack_require__(77);
var mapStateToProps=function mapStateToProps(state){return{metadataSet:state.scenes.referenceMetadata.dcat.metadataSet,msdTree:state.scenes.referenceMetadata.dcat.msdTree,reportId:state.scenes.referenceMetadata.dcat.reportId,target:state.scenes.referenceMetadata.dcat.target,identifiableTargets:state.scenes.referenceMetadata.dcat.identifiableTargets,selectedIdentifiableTarget:state.scenes.referenceMetadata.dcat.selectedIdentifiableTarget,report:state.scenes.referenceMetadata.dcat.report,reports:state.scenes.referenceMetadata.dcat.reports,artefacts:state.scenes.referenceMetadata.dcat.artefacts,reportStructure:state.scenes.referenceMetadata.dcat.reportStructure,selectedAttribute:state.scenes.referenceMetadata.dcat.selectedAttribute,step:state.scenes.referenceMetadata.dcat.step,isCodesVisible:state.scenes.referenceMetadata.dcat.isCodesVisible,codes:state.scenes.referenceMetadata.dcat.codes,dataflow:state.scenes.referenceMetadata.dcat.dataflow};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAttributeSelect:function onAttributeSelect(selectedAttributeKey){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_29" /* selectDcatReportAttribute */])(selectedAttributeKey));},onAttributeChange:function onAttributeChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_1" /* changeDcatReportAttribute */])(fields));},onAttributeCreate:function onAttributeCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_5" /* createDcatReportAttribute */])());},onAttributeDelete:function onAttributeDelete(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_8" /* deleteDcatReportAttribute */])());},onStepSet:function onStepSet(step,dataLanguages,t,mawsUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_33" /* setDcatReportStep */])(step,dataLanguages,t,mawsUrl));},onCodesShow:function onCodesShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_39" /* showDcatReportAttributeCodes */])());},onCodesHide:function onCodesHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_17" /* hideDcatReportAttributeCodes */])());},fetchCodes:function fetchCodes(triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_27" /* readDcatReportAttributeCodes */])(triplet));},onCodeSet:function onCodeSet(codeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_32" /* setDcatReportAttributeCode */])(codeId));},onCodeUnset:function onCodeUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_47" /* unsetDcatReportAttributeCode */])());},onIdChange:function onIdChange(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_2" /* changeDcatReportId */])(id));},onTargetSelect:function onTargetSelect(target){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_30" /* selectDcatReportTarget */])(target));},onArtefactsShow:function onArtefactsShow(identifiableTarget){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_41" /* showDcatReportTargetArtefacts */])(identifiableTarget));},onArtefactsHide:function onArtefactsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_19" /* hideDcatReportTargetArtefacts */])());},fetchArtefacts:function fetchArtefacts(_ref){var identifiableTarget=_ref.identifiableTarget,ownedDataflows=_ref.ownedDataflows;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_28" /* readDcatReportTargetArtefacts */])(identifiableTarget,ownedDataflows));},onArtefactSet:function onArtefactSet(value,identifiableTargetId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_34" /* setDcatReportTargetArtefact */])(value,identifiableTargetId));},onArtefactUnset:function onArtefactUnset(identifiableTarget){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_48" /* unsetDcatReportTargetArtefact */])(identifiableTarget));},fetchDataflow:function fetchDataflow(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_21" /* readDcatDataflow */])(dataflowTriplet));},onDataflowChange:function onDataflowChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["Z" /* changeDcatDataflow */])(fields));},onDataflowSubmit:function onDataflowSubmit(dataflow){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_42" /* submitDcatDataflow */])(dataflow));},onDataflowHide:function onDataflowHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_11" /* hideDcatDataflow */])());},onAttachmentUpload:function onAttachmentUpload(file,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_49" /* uploadDcatReportAttributeAttachment */])(file,lang));},onAttachmentDownload:function onAttachmentDownload(fileName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_10" /* downloadDcatReportAttributeAttachment */])(fileName));}};};var ReportDetailWrapper=function ReportDetailWrapper(_ref2){var metadataSet=_ref2.metadataSet,msdTree=_ref2.msdTree,reports=_ref2.reports,reportId=_ref2.reportId,target=_ref2.target,identifiableTargets=_ref2.identifiableTargets,selectedIdentifiableTarget=_ref2.selectedIdentifiableTarget,report=_ref2.report,artefacts=_ref2.artefacts,reportStructure=_ref2.reportStructure,selectedAttribute=_ref2.selectedAttribute,step=_ref2.step,isCodesVisible=_ref2.isCodesVisible,codes=_ref2.codes,dataflow=_ref2.dataflow,onAttributeSelect=_ref2.onAttributeSelect,onAttributeChange=_ref2.onAttributeChange,onAttributeCreate=_ref2.onAttributeCreate,onAttributeDelete=_ref2.onAttributeDelete,onStepSet=_ref2.onStepSet,onCodesShow=_ref2.onCodesShow,onCodesHide=_ref2.onCodesHide,fetchCodes=_ref2.fetchCodes,onCodeSet=_ref2.onCodeSet,onCodeUnset=_ref2.onCodeUnset,onIdChange=_ref2.onIdChange,onTargetSelect=_ref2.onTargetSelect,onArtefactsShow=_ref2.onArtefactsShow,onArtefactsHide=_ref2.onArtefactsHide,fetchArtefacts=_ref2.fetchArtefacts,onArtefactSet=_ref2.onArtefactSet,onArtefactUnset=_ref2.onArtefactUnset,fetchDataflow=_ref2.fetchDataflow,onDataflowChange=_ref2.onDataflowChange,onDataflowSubmit=_ref2.onDataflowSubmit,onDataflowHide=_ref2.onDataflowHide,onAttachmentUpload=_ref2.onAttachmentUpload,onAttachmentDownload=_ref2.onAttachmentDownload;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commons_ReportDetail__["a" /* default */],{isDcat:true,hasPermission:report===null||report.hasPermission,isReadOnly:report!==null&&report.isPublished===__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */],step:step,metadataSet:metadataSet,msdTree:msdTree,reports:reports,report:report,reportStructure:reportStructure,selectedAttribute:selectedAttribute,reportId:reportId,target:target,identifiableTargets:identifiableTargets,selectedIdentifiableTarget:selectedIdentifiableTarget,artefacts:artefacts,dataflow:dataflow,isCodesVisible:isCodesVisible,codes:codes,onAttributeSelect:onAttributeSelect,onAttributeChange:onAttributeChange,onAttributeCreate:onAttributeCreate,onAttributeDelete:onAttributeDelete,onStepSet:onStepSet,onCodesShow:onCodesShow,onCodesHide:onCodesHide,fetchCodes:fetchCodes,onCodeSet:onCodeSet,onCodeUnset:onCodeUnset,onIdChange:onIdChange,onTargetSelect:onTargetSelect,onArtefactsShow:onArtefactsShow,onArtefactsHide:onArtefactsHide,fetchArtefacts:fetchArtefacts,onArtefactSet:onArtefactSet,onArtefactUnset:onArtefactUnset,fetchDataflow:fetchDataflow,onDataflowChange:onDataflowChange,onDataflowSubmit:onDataflowSubmit,onDataflowHide:onDataflowHide,onAttachmentUpload:onAttachmentUpload,onAttachmentDownload:onAttachmentDownload});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ReportDetailWrapper));

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_time_picker_style__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_time_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_time_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_time_picker__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__localized_date_picker__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__delayed_input__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__html_editor__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__multilanguage_html_editor__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__zoomable_textarea__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__multilanguage_zoomable_textarea__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__annotations_form__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_quill_dist_quill_snow_css__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_react_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__multilanguage_input__ = __webpack_require__(89);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.jQuery;var mapStateToProps=function mapStateToProps(state){return{appLang:state.app.language,dataLangs:state.config.dataManagement.dataLanguages};};var mapPropsToFields=function mapPropsToFields(_ref){var selectedAttribute=_ref.selectedAttribute;return{texts:__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.createFormField({value:selectedAttribute?selectedAttribute.texts:null}),attachmentName:__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.createFormField({value:selectedAttribute?selectedAttribute.attachmentName:null}),isPublic:__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.createFormField({value:selectedAttribute?selectedAttribute.isPublic:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onAttributeChange(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var getIsAddAttributeDisabled=function getIsAddAttributeDisabled(selectedAttribute){var maxOccurs=isNaN(selectedAttribute.maxOccurs)?Number.MAX_VALUE:Number(selectedAttribute.maxOccurs);return selectedAttribute.metadataAttributes.length>=maxOccurs;};var getIsDeleteAttributeDisabled=function getIsDeleteAttributeDisabled(reportStructure,selectedAttribute){var parentAttribute=Object(__WEBPACK_IMPORTED_MODULE_29__utils_tree__["k" /* getNode */])(reportStructure,"metadataAttributes",function(node){return node.metadataAttributes.find(function(child){return child.nodeKey===selectedAttribute.nodeKey;});});return parentAttribute&&parentAttribute.isFolder?parentAttribute.metadataAttributes.length<=Number(parentAttribute.minOccurs):true;};var dcatDataflowDisabledFields=["DCAT_AP_IT_DATASET_IDENTIFIER","DCAT_AP_IT_DATASET_TITLE"];var getInputField=function getInputField(form,selectedAttribute,attributeType,disabled,isDcatReport,isHtmlMode,onSelect,onReset,prefLang,dataLangs,t){var isDisabled=disabled||isDcatReport&&dcatDataflowDisabledFields.includes(selectedAttribute.id);if(selectedAttribute.id==="DCAT_AP_IT_DATASET_IDENTIFIER"){return __WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input___default.a,{key:selectedAttribute.nodeKey,title:form.getFieldValue("texts"),disabled:isDisabled});}if(selectedAttribute.localRepresentation.enumeration!==null){return __WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__selector__["a" /* default */],{key:selectedAttribute.nodeKey,selectTitle:t('components.reportStructureTree.selector.select.title'),resetTitle:t('components.reportStructureTree.selector.reset.title'),onSelect:onSelect,onReset:onReset,render:function render(value){return Object(__WEBPACK_IMPORTED_MODULE_40__middlewares_i18n_utils__["a" /* getLocalizedStr */])(value,prefLang,dataLangs);},disabled:isDisabled});}else{if(attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["c" /* ATTRIBUTE_TEXT_TYPE_DATETIME */]){return __WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__localized_date_picker__["a" /* default */],{key:selectedAttribute.nodeKey,format:__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["f" /* ATTRIBUTE_TEXT_TYPE_FORMAT_DATETIME */],showTime:true,disabled:isDisabled});}else if(attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["h" /* ATTRIBUTE_TEXT_TYPE_GREGORIANDAY */]){return __WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__localized_date_picker__["a" /* default */],{key:selectedAttribute.nodeKey,format:__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["e" /* ATTRIBUTE_TEXT_TYPE_FORMAT_DATE */],disabled:isDisabled});}else if(attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["n" /* ATTRIBUTE_TEXT_TYPE_TIME */]){return __WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_time_picker___default.a,{key:selectedAttribute.nodeKey,format:__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["g" /* ATTRIBUTE_TEXT_TYPE_FORMAT_TIME */],style:{width:"100%"},disabled:isDisabled});}else if(attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["a" /* ATTRIBUTE_TEXT_TYPE_BOOLEAN */]){return __WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox___default.a,{key:selectedAttribute.nodeKey,disabled:isDisabled});}else if(attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["p" /* ATTRIBUTE_TEXT_TYPE_XHTML */]){return selectedAttribute.isMultiLang?__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__delayed_input__["a" /* default */],{key:selectedAttribute.nodeKey,Component:__WEBPACK_IMPORTED_MODULE_36__multilanguage_html_editor__["a" /* default */],initialEditorHeight:320,disabled:isDisabled}):__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__delayed_input__["a" /* default */],{key:selectedAttribute.nodeKey,Component:__WEBPACK_IMPORTED_MODULE_35__html_editor__["a" /* default */],initialEditorHeight:320,disabled:isDisabled});}else if(attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["m" /* ATTRIBUTE_TEXT_TYPE_STRING */]){return selectedAttribute.isMultiLang?isHtmlMode?__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__delayed_input__["a" /* default */],{key:selectedAttribute.nodeKey+"-html",Component:__WEBPACK_IMPORTED_MODULE_36__multilanguage_html_editor__["a" /* default */],initialEditorHeight:320,disabled:isDisabled}):__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__delayed_input__["a" /* default */],{key:selectedAttribute.nodeKey+"-string",Component:__WEBPACK_IMPORTED_MODULE_38__multilanguage_zoomable_textarea__["a" /* default */],disabled:isDisabled}):isHtmlMode?__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__delayed_input__["a" /* default */],{key:selectedAttribute.nodeKey+"-html",Component:__WEBPACK_IMPORTED_MODULE_35__html_editor__["a" /* default */],initialEditorHeight:320,disabled:isDisabled}):__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__delayed_input__["a" /* default */],{key:selectedAttribute.nodeKey+"-string",Component:__WEBPACK_IMPORTED_MODULE_37__zoomable_textarea__["a" /* default */],multilanguage:false,disabled:isDisabled});}else{return selectedAttribute.isMultiLang?__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__delayed_input__["a" /* default */],{key:selectedAttribute.nodeKey,Component:__WEBPACK_IMPORTED_MODULE_38__multilanguage_zoomable_textarea__["a" /* default */],disabled:isDisabled}):__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__delayed_input__["a" /* default */],{key:selectedAttribute.nodeKey,Component:__WEBPACK_IMPORTED_MODULE_37__zoomable_textarea__["a" /* default */],multilanguage:false,disabled:isDisabled});}}};var getHelp=function getHelp(attributeType,t){var helpPrefix=t('components.reportStructureTree.valueFormat.help.label')+": ";switch(attributeType){case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["d" /* ATTRIBUTE_TEXT_TYPE_DAY */]:return helpPrefix+"DD";case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["k" /* ATTRIBUTE_TEXT_TYPE_MONTH */]:return helpPrefix+"MM";case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["q" /* ATTRIBUTE_TEXT_TYPE_YEAR */]:case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["i" /* ATTRIBUTE_TEXT_TYPE_GREGORIANYEAR */]:return helpPrefix+"YYYY";case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["l" /* ATTRIBUTE_TEXT_TYPE_MONTHDAY */]:return helpPrefix+"MM-DD";case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["r" /* ATTRIBUTE_TEXT_TYPE_YEARMONTH */]:case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["j" /* ATTRIBUTE_TEXT_TYPE_GREGORIANYEARMONTH */]:return helpPrefix+"YYYY-MM";case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["b" /* ATTRIBUTE_TEXT_TYPE_DATE */]:return helpPrefix+"YYYY-MM-DD";case __WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["o" /* ATTRIBUTE_TEXT_TYPE_URI */]:return helpPrefix+t('components.reportStructureTree.valueFormat.help.uri.label');default:return null;}};var ReportStructureTree=function(_React$Component){_inherits(ReportStructureTree,_React$Component);function ReportStructureTree(props){_classCallCheck(this,ReportStructureTree);var _this=_possibleConstructorReturn(this,(ReportStructureTree.__proto__||Object.getPrototypeOf(ReportStructureTree)).call(this,props));_this.state={uuid:__WEBPACK_IMPORTED_MODULE_46_uuid___default()(),isHtmlMode:true};_this.handleTreeHeight=_this.handleTreeHeight.bind(_this);return _this;}_createClass(ReportStructureTree,[{key:"handleTreeHeight",value:function handleTreeHeight(){var treeHeaderHeight=$(".report-structure-tree__tree__"+this.state.uuid+" .custom-tree__tree-header").outerHeight(true)||0;var treeFooterHeight=$(".report-structure-tree__tree__"+this.state.uuid+" .custom-tree__tree-footer").outerHeight(true)||0;$(".report-structure-tree__tree__"+this.state.uuid).css({height:"100%"});$(".report-structure-tree__tree__"+this.state.uuid+" .custom-tree__tree-container").css({height:"calc(100% - "+(treeHeaderHeight+treeFooterHeight)+"px)"});}},{key:"componentDidMount",value:function componentDidMount(){window.addEventListener("resize",this.handleTreeHeight);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState,snapshot){if(!prevProps.selectedAttribute&&this.props.selectedAttribute||prevProps.selectedAttribute&&!this.props.selectedAttribute||prevProps.selectedAttribute&&this.props.selectedAttribute&&prevProps.selectedAttribute.nodeKey!==this.props.selectedAttribute.nodeKey||prevProps.dataLanguage!==this.props.dataLanguage){if(this.props.selectedAttribute){var isHtmlMode=true;var attributeType=Object(__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["C" /* getAttributeType */])(this.props.selectedAttribute).toLowerCase();if(attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["m" /* ATTRIBUTE_TEXT_TYPE_STRING */]||attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["p" /* ATTRIBUTE_TEXT_TYPE_XHTML */]){var regExp=/(<\w*)((\s\/>)|(.*<\/\w*>))/gm;if(this.props.selectedAttribute.isMultiLang){if(this.props.selectedAttribute.texts&&this.props.selectedAttribute.texts[this.props.dataLanguage]){isHtmlMode=regExp.test(this.props.selectedAttribute.texts[this.props.dataLanguage]);}}else{if(this.props.selectedAttribute.texts){isHtmlMode=regExp.test(this.props.selectedAttribute.texts);}}}this.setState({isHtmlMode:isHtmlMode});$(".report-structure-tree__waring").css({color:"#FAAD14"});}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("resize",this.handleTreeHeight);}},{key:"render",value:function render(){var _this2=this;var _state=this.state,uuid=_state.uuid,isHtmlMode=_state.isHtmlMode;var _props=this.props,t=_props.t,form=_props.form,dataLanguage=_props.dataLanguage,appLang=_props.appLang,dataLangs=_props.dataLangs,reportStructure=_props.reportStructure,selectedAttribute=_props.selectedAttribute,disabled=_props.disabled,onAttributeSelect=_props.onAttributeSelect,onAttributeCreate=_props.onAttributeCreate,onAttributeDelete=_props.onAttributeDelete,onCodesShow=_props.onCodesShow,onCodeUnset=_props.onCodeUnset,onAttributeChange=_props.onAttributeChange,isDcatReport=_props.isDcatReport,onFileUpload=_props.onFileUpload,onFileDownload=_props.onFileDownload,height=_props.height;var lang=dataLanguage||appLang;var attributeType=selectedAttribute?Object(__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["C" /* getAttributeType */])(selectedAttribute).toLowerCase():"";var isAttributeValid=Object(__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["S" /* isAttributeValueValid */])(selectedAttribute);return __WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["GUTTER_MD"],style:{height:height}},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["SPAN_HALF"],style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"report-structure-tree__tree report-structure-tree__tree__"+uuid},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__enhanced_tree__["a" /* default */],{onRenderComplete:this.handleTreeHeight,tree:reportStructure,getNodeKey:function getNodeKey(_ref3){var nodeKey=_ref3.nodeKey;return nodeKey;},childrenKey:"metadataAttributes",idKey:"id",nameKey:"name",catIdKey:"id",catNameKey:"name",hiddenIdKeys:Object(__WEBPACK_IMPORTED_MODULE_29__utils_tree__["l" /* getNodes */])(reportStructure,"metadataAttributes",function(){return true;}).map(function(_ref4){var nodeKey=_ref4.nodeKey;return nodeKey;}),isEmptyCategoryIconLikeLeafIcon:true,getFilter:function getFilter(searchText){return function(_ref5){var id=_ref5.id,name=_ref5.name;var search=searchText.toLowerCase();return id&&id.toLowerCase().indexOf(search)>=0||name&&Object(__WEBPACK_IMPORTED_MODULE_40__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,lang,dataLangs).toLowerCase().indexOf(search)>=0;};},externalControlledSelectedKeys:true,selectedKeys:selectedAttribute?[selectedAttribute.nodeKey]:[],onSelect:function onSelect(selectedArr){if(!selectedAttribute){onAttributeSelect(selectedArr[0]);}else{if(isAttributeValid){onAttributeSelect(selectedArr[0]);}else{$(".report-structure-tree__waring").css({color:"#FF0000"});}}},getIcon:function getIcon(node,expanded){return __WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{theme:"filled",style:{color:node.isFolder?"#f7c427":node.isPresentational?undefined:Object(__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["T" /* isAttributeValueValorizedAndValid */])(node)?"#4caf50":"#37a0f4"},type:node.isFolder?expanded&&node.metadataAttributes&&node.metadataAttributes.length>0?"folder-open":"folder":"file-text"});},searchBarSpan:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["SPAN_HALF"],treeActions:[Object.assign({},__WEBPACK_IMPORTED_MODULE_43__styles_buttons__["f" /* BUTTON_CREATE */],{title:t("components.reportStructureTree.tree.actions.addAttribute.title"),onClick:function onClick(){return onAttributeCreate();},disabled:disabled||!selectedAttribute||!selectedAttribute.isFolder||getIsAddAttributeDisabled(selectedAttribute)}),Object.assign({},__WEBPACK_IMPORTED_MODULE_43__styles_buttons__["k" /* BUTTON_DELETE */],{title:t("components.reportStructureTree.tree.actions.removeAttribute.title"),onClick:function onClick(){return onAttributeDelete();},disabled:disabled||!selectedAttribute||selectedAttribute.isFolder||getIsDeleteAttributeDisabled(reportStructure,selectedAttribute)})]}))),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["SPAN_HALF"],style:{height:"100%"}},selectedAttribute&&!selectedAttribute.isFolder?selectedAttribute.isPresentational?__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__custom_empty__["a" /* default */],{text:t("components.reportStructureTree.isPresentational.placeholder")}):__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{style:{height:"100%"},bodyStyle:{height:"100%",overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a,null,selectedAttribute.localRepresentation.enumeration===null&&attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["m" /* ATTRIBUTE_TEXT_TYPE_STRING */]&&selectedAttribute.id!=="DCAT_AP_IT_DATASET_IDENTIFIER"&&__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"end",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["GUTTER_SM"],style:{marginBottom:8}},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,t("components.reportStructureTree.htmlEditorModeSwitch.label")+":"),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_switch___default.a,{checked:isHtmlMode,onChange:function onChange(){return _this2.setState({isHtmlMode:!isHtmlMode});}}))),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item,{label:__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"start",gutter:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["GUTTER_XS"],style:{height:0,marginRight:4}},selectedAttribute.isMultiLang&&__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"global",title:t("components.reportStructureTree.isMultilang.title")})),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,t('components.reportStructureTree.value.label')),attributeType&&attributeType.length>0&&__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,"("+attributeType+")")),help:getHelp(attributeType,t),style:{marginBottom:attributeType!==__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["m" /* ATTRIBUTE_TEXT_TYPE_STRING */]?8:4}},form.getFieldDecorator("texts",{valuePropName:attributeType===__WEBPACK_IMPORTED_MODULE_42__utils_referenceMetadata__["a" /* ATTRIBUTE_TEXT_TYPE_BOOLEAN */]?'checked':"value"})(getInputField(form,selectedAttribute,attributeType,disabled,isDcatReport,isHtmlMode,onCodesShow,onCodeUnset,lang,dataLangs,t))),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"report-structure-tree__waring"},!isAttributeValid&&__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",style:{marginBottom:8}},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["SPAN_FULL"]},t("components.reportStructureTree.warning.notValidFormat.label")))),!isDcatReport&&__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item,{label:t('components.reportStructureTree.attachment.label'),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["MARGIN_XS"]}},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__multilanguage_input__["a" /* default */],{value:selectedAttribute.attachmentName,disabled:disabled,addonAfter:disabled?null:__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload___default.a,{customRequest:function customRequest(_ref6){var file=_ref6.file;if(!file||file.size<2147483648){// 2147483648 bytes = 2 GB
onAttributeChange({attachment:Object.assign({},selectedAttribute.attachment,_defineProperty({},lang,file)),attachmentName:Object.assign({},selectedAttribute.attachmentName,_defineProperty({},lang,file&&file.name?file.name:null))});}else{__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('components.fileInput.modals.warning.fileTooBig.title'),content:file.type!=="application/x-zip-compressed"?t('components.fileInput.modals.warning.fileTooBig.zipIt.content'):t('components.fileInput.modals.warning.fileTooBig.content')});}},style:{cursor:"pointer",width:"100%",height:"100%"},showUploadList:false,disabled:selectedAttribute.attachmentName[lang]!==null},selectedAttribute.attachmentName[lang]!==null?__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{onClick:function onClick(e){if(!disabled){e.stopPropagation();onAttributeChange({attachment:Object.assign({},selectedAttribute.attachment,_defineProperty({},lang,null)),attachmentName:Object.assign({},selectedAttribute.attachmentName,_defineProperty({},lang,null)),attachmentUploaded:Object.assign({},selectedAttribute.attachmentUploaded,_defineProperty({},lang,false))});}},type:"close",style:{cursor:!disabled?"pointer":"not-allowed"}}):__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"paper-clip",style:{cursor:!disabled?"pointer":"not-allowed"}}))})),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"end",style:{marginTop:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["MARGIN_XS"]}},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,!disabled&&__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{style:{color:'rgba(0, 0, 0, 0.85)',marginRight:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["MARGIN_SM"],display:"inline-block",verticalAlign:"middle"}},t("components.reportStructureTree.attachmentUploaded.label")+' :'),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{theme:"filled",type:selectedAttribute.attachmentUploaded[lang]?'check-circle':'close-circle',style:{color:selectedAttribute.attachmentUploaded[lang]?'green':'red',marginRight:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["MARGIN_MD"],display:"inline-block",verticalAlign:"middle"}}),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",title:t("commons.buttons.upload.title"),onClick:function onClick(){return onFileUpload(selectedAttribute.attachment[lang],lang);},disabled:!selectedAttribute.attachment[lang],style:{marginRight:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["MARGIN_SM"],display:"inline-block",verticalAlign:"middle"}},t("commons.buttons.upload.title"))),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",title:t("commons.buttons.download.title"),onClick:function onClick(){return onFileDownload(selectedAttribute.attachmentName[lang]);},disabled:!selectedAttribute.attachmentUploaded[lang],style:{display:"inline-block",verticalAlign:"middle"}},t("commons.buttons.download.title")))),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"start",align:"middle",gutter:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["GUTTER_MD"],style:{marginTop:__WEBPACK_IMPORTED_MODULE_30__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,{style:{color:'rgba(0, 0, 0, 0.85)'}},t("components.reportStructureTree.isPublic.label")+' :'),__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item,null,form.getFieldDecorator("isPublic",{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox___default.a,{disabled:disabled}))))))),!isDcatReport&&__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__annotations_form__["a" /* default */],{annotations:selectedAttribute?selectedAttribute.annotations:null,onChange:onAttributeChange,genericOnly:true,isGenericOneLinePerField:true,disabled:disabled})):null));}}]);return ReportStructureTree;}(__WEBPACK_IMPORTED_MODULE_24_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_25_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_27_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_26_react_redux__["b" /* connect */])(mapStateToProps),Object(__WEBPACK_IMPORTED_MODULE_45__contexts_DataLanguage__["c" /* withDataLanguage */])(),__WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ReportStructureTree));

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ckeditor4_react__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ckeditor4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_ckeditor4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_css__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_uuid__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var $=window.jQuery;var mapStateToProps=function mapStateToProps(state){return{appLang:state.app.language};};var getDefaultConfig=function getDefaultConfig(lang,initialEditorHeight){return{defaultLanguage:'en',language:lang,title:false,disableNativeSpellChecker:true,toolbar:[{name:'styles',items:['Format','Font','FontSize']},{name:'basicstyles',items:['Bold','Italic','Underline','Strike']},{name:'format',items:['RemoveFormat']},{name:'colors',items:['TextColor','BGColor']},{name:'insert',items:['Table']},{name:'links',items:['Link','Unlink']},{name:'paragraph',items:['NumberedList','BulletedList']},{name:'indent',items:['Outdent','Indent']},{name:'justify',items:['JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock']},{name:'clipboard',items:['Cut','Copy','Paste']},{name:'source',items:['Source']}],height:initialEditorHeight||200};};var HtmlEditor=function HtmlEditor(_ref){var t=_ref.t,appLang=_ref.appLang,externalValue=_ref.value,customConfig=_ref.customConfig,disabled=_ref.disabled,_ref$disableZoom=_ref.disableZoom,disableZoom=_ref$disableZoom===undefined?false:_ref$disableZoom,initialEditorHeight=_ref.initialEditorHeight,onChange=_ref.onChange;var _useState=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),value=_useState2[0],setValue=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),tmpValue=_useState4[0],setTmpValue=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(__WEBPACK_IMPORTED_MODULE_13_uuid___default()()),_useState6=_slicedToArray(_useState5,1),editorWrapperUuid=_useState6[0];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),isModalVisible=_useState8[0],setModalVisibility=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(null),_useState10=_slicedToArray(_useState9,2),fullScreenEditorInstance=_useState10[0],setFullscreenEditorInstance=_useState10[1];Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function(){setValue(externalValue);},[externalValue]);var callOnChange=function callOnChange(value){if(onChange){onChange(value);}};var handleFullscreenEditorHeight=function handleFullscreenEditorHeight(){if(fullScreenEditorInstance){fullScreenEditorInstance.resize("100%",$("#"+_this.state.editorWrapperUuid).outerHeight());}};var handleModalShow=function handleModalShow(){setTmpValue(value);setModalVisibility(true);window.addEventListener("resize",handleFullscreenEditorHeight);};var handleModalHide=function handleModalHide(){setTmpValue(null);setModalVisibility(false);setFullscreenEditorInstance(null);window.removeEventListener("resize",handleFullscreenEditorHeight);};var handleModalSubmit=function handleModalSubmit(){if(!disabled){callOnChange(tmpValue);}handleModalHide();};return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__enhanced_modal__["a" /* default */],{visible:isModalVisible,fullscreen:true,footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:handleModalSubmit,icon:"zoom-out"},t('commons.buttons.close.title'))),onCancel:handleModalSubmit,title:"\xA0"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{id:editorWrapperUuid,style:{width:"100%",height:"100%"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_ckeditor4_react___default.a,{data:tmpValue,config:customConfig!==null&&customConfig!==undefined?Object.assign({},customConfig,{resize_enabled:false}):Object.assign({},getDefaultConfig(appLang,initialEditorHeight),{resize_enabled:false}),onChange:function onChange(event){return setTmpValue(event.editor.getData());}// readOnly={disabled || false}
,onBeforeLoad:function onBeforeLoad(CKEDITOR){CKEDITOR.disableAutoInline=true;// needed to fix "Error code: editor-element-conflict."
},onInstanceReady:function onInstanceReady(_ref2){var editor=_ref2.editor;setFullscreenEditorInstance(editor);editor.resize("100%",$("#"+editorWrapperUuid).outerHeight());editor.setReadOnly(disabled);}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_ckeditor4_react___default.a,{data:value,config:customConfig!==null&&customConfig!==undefined?customConfig:getDefaultConfig(appLang,initialEditorHeight),onChange:function onChange(event){return callOnChange(event.editor.getData());}// readOnly={disabled || false}
,onBeforeLoad:function onBeforeLoad(CKEDITOR){CKEDITOR.disableAutoInline=true;// needed to fix "Error code: editor-element-conflict."
},onInstanceReady:function onInstanceReady(_ref3){var editor=_ref3.editor;editor.setReadOnly(disabled);}}),!disableZoom&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",style:{marginTop:8}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:handleModalShow,icon:"zoom-in"},t('components.htmlEditor.zoomIn.title')))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps))(HtmlEditor));

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ckeditor4_react__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ckeditor4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_ckeditor4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_css__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_languages__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_uuid__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var $=window.jQuery;var mapStateToProps=function mapStateToProps(state){return{appLang:state.app.language,dataLangs:state.config.dataManagement.dataLanguages};};var getDefaultConfig=function getDefaultConfig(lang,initialEditorHeight){return{defaultLanguage:'en',language:lang,title:false,disableNativeSpellChecker:true,toolbar:[{name:'styles',items:['Format','Font','FontSize']},{name:'basicstyles',items:['Bold','Italic','Underline','Strike']},{name:'format',items:['RemoveFormat']},{name:'colors',items:['TextColor','BGColor']},{name:'insert',items:['Table']},{name:'links',items:['Link','Unlink']},{name:'paragraph',items:['NumberedList','BulletedList']},{name:'indent',items:['Outdent','Indent']},{name:'justify',items:['JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock']},{name:'clipboard',items:['Cut','Copy','Paste']},{name:'source',items:['Source']}],height:initialEditorHeight||200};};var MultilanguageHtmlEditor=function MultilanguageHtmlEditor(_ref){var t=_ref.t,appLang=_ref.appLang,dataLangs=_ref.dataLangs,externalValue=_ref.value,customConfig=_ref.customConfig,disabled=_ref.disabled,_ref$disableZoom=_ref.disableZoom,disableZoom=_ref$disableZoom===undefined?false:_ref$disableZoom,initialEditorHeight=_ref.initialEditorHeight,onChange=_ref.onChange;var _useState=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_15__utils_languages__["a" /* getEmptyDictionaryForLanguages */])(dataLangs,"")),_useState2=_slicedToArray(_useState,2),value=_useState2[0],setValue=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),tmpValue=_useState4[0],setTmpValue=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),language=_useState6[0],setLanguage=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useState"])(__WEBPACK_IMPORTED_MODULE_18_uuid___default()()),_useState8=_slicedToArray(_useState7,1),editorWrapperUuid=_useState8[0];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),isModalVisible=_useState10[0],setModalVisibility=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),fullScreenEditorInstance=_useState12[0],setFullscreenEditorInstance=_useState12[1];Object(__WEBPACK_IMPORTED_MODULE_8_react__["useEffect"])(function(){var oldValue=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.cloneDeep(value);setValue(__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.merge(oldValue,externalValue));},[externalValue]);var callOnChange=function callOnChange(value){if(onChange){onChange(value);}};var handleSetLanguage=function handleSetLanguage(lang){setLanguage(lang);callOnChange(value);};var setValueForLanguage=function setValueForLanguage(val,lang){var newValue=Object.assign({},value,_defineProperty({},lang,val));callOnChange(newValue);};var handleFullscreenEditorHeight=function handleFullscreenEditorHeight(){if(fullScreenEditorInstance){fullScreenEditorInstance.resize("100%",$("#"+_this.state.editorWrapperUuid).outerHeight());}};var handleModalShow=function handleModalShow(){setTmpValue(value);setModalVisibility(true);window.addEventListener("resize",handleFullscreenEditorHeight);};var handleModalHide=function handleModalHide(){setTmpValue(null);setModalVisibility(false);setFullscreenEditorInstance(null);window.removeEventListener("resize",handleFullscreenEditorHeight);};var handleModalSubmit=function handleModalSubmit(){if(!disabled){callOnChange(tmpValue);}handleModalHide();};var setTmpValueForLanguage=function setTmpValueForLanguage(val,lang){var newTmpValue=Object.assign({},tmpValue,_defineProperty({},lang,val));setTmpValue(newTmpValue);};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(contextDataLanguage){var lang=contextDataLanguage||language;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__enhanced_modal__["a" /* default */],{visible:isModalVisible,fullscreen:true,withDataLanguageSelector:true,footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:handleModalSubmit,icon:"zoom-out"},t('commons.buttons.close.title'))),onCancel:handleModalSubmit},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(modalLanguage){var lang=modalLanguage||language;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{id:editorWrapperUuid,style:{width:"100%",height:"100%"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_ckeditor4_react___default.a,{data:tmpValue[lang],config:customConfig!==null&&customConfig!==undefined?Object.assign({},customConfig,{resize_enabled:false}):Object.assign({},getDefaultConfig(appLang,initialEditorHeight),{resize_enabled:false}),onChange:function onChange(event){return setTmpValueForLanguage(event.editor.getData(),lang);}// readOnly={disabled || false}
,onBeforeLoad:function onBeforeLoad(CKEDITOR){CKEDITOR.disableAutoInline=true;// needed to fix "Error code: editor-element-conflict."
},onInstanceReady:function onInstanceReady(_ref2){var editor=_ref2.editor;setFullscreenEditorInstance(editor);editor.resize("100%",$("#"+editorWrapperUuid).outerHeight());editor.setReadOnly(disabled);}}));})),!contextDataLanguage&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{value:lang,onChange:handleSetLanguage,style:{width:100}},dataLangs.map(function(_ref3){var code=_ref3.code;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option,{key:code,value:code,title:Object(__WEBPACK_IMPORTED_MODULE_15__utils_languages__["c" /* getLanguageLabel */])(t,code)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("i",{className:"flag-icon "+Object(__WEBPACK_IMPORTED_MODULE_15__utils_languages__["b" /* getLanguageFlagIconCss */])(code,dataLangs),style:{marginRight:8}}),code!==null?code.toUpperCase():null);})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_ckeditor4_react___default.a,{data:value[lang],config:customConfig!==null&&customConfig!==undefined?customConfig:getDefaultConfig(appLang,initialEditorHeight),onChange:function onChange(event){return setValueForLanguage(event.editor.getData(),lang);}// readOnly={disabled || false}
,onBeforeLoad:function onBeforeLoad(CKEDITOR){CKEDITOR.disableAutoInline=true;// needed to fix "Error code: editor-element-conflict."
},onInstanceReady:function onInstanceReady(_ref4){var editor=_ref4.editor;editor.setReadOnly(disabled);}}),!disableZoom&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",style:{marginTop:8}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:handleModalShow,icon:"zoom-in"},t('components.htmlEditor.zoomIn.title')))));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps))(MultilanguageHtmlEditor));

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_css__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions,tree:state.scenes.metaManager.categorySchemesAndDataflows.tree,categorisations:state.scenes.metaManager.categorySchemesAndDataflows.categorisations,nodeId:state.app.endpointId,nodes:state.config.nodes,appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchTree:function fetchTree(lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["h" /* readCategorySchemesAndDataflowsTree */])(lang));},onDataflowCategorise:function onDataflowCategorise(dataflow,categoryUrn,categorisations,from,to,fromSisterDfOrderedCategorisations,toSisterDfOrderedCategorisations,lang,orderAnnotationType,agencyPermissions,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["e" /* categoriseCategorySchemesAndDataflowsDataflow */])(dataflow,categoryUrn,categorisations,from,to,fromSisterDfOrderedCategorisations,toSisterDfOrderedCategorisations,lang,orderAnnotationType,agencyPermissions,t));},onDeleteDataflowCategorisation:function onDeleteDataflowCategorisation(dataflow,categorisations){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["g" /* deleteCategorySchemesAndDataflowsDataflowCategorisation */])(dataflow,categorisations));},onLanguageChange:function onLanguageChange(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["f" /* changeCategorySchemesAndDataflowsLanguage */])());}};};var _onDrop=function _onDrop(ev,onDataflowCategorise,categorisations,t,lang,orderAnnotationType,agencyPermissions){var draggedInto=ev.node.props["data-node"];if(ev.dragNode.props["data-node"].type==="dataflow"){var dataflow=ev.dragNode.props["data-node"];var pos=ev.node.props.pos.split('-');var dropPos=ev.dropPosition-Number(pos[pos.length-1]);var fromSisterDfOrderedCategorisations=categorisations.filter(function(_ref){var source=_ref.source,target=_ref.target;return source.includes(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */])&&target===dataflow.categoryUrn;}).sort(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* categorisationsSorterFactory */])(orderAnnotationType,lang));var toSisterDfOrderedCategorisations=categorisations.filter(function(_ref2){var source=_ref2.source,target=_ref2.target;return source.includes(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */])&&target===(ev.dropToGap?draggedInto.categoryUrn:draggedInto.urn);}).sort(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* categorisationsSorterFactory */])(orderAnnotationType,lang));var from=fromSisterDfOrderedCategorisations.map(function(_ref3){var source=_ref3.source;return source;}).indexOf(dataflow.urn);var to=toSisterDfOrderedCategorisations.map(function(_ref4){var source=_ref4.source;return source;}).indexOf(draggedInto.urn);if(ev.dropToGap){if(draggedInto.categoryUrn===dataflow.categoryUrn){// same category
fromSisterDfOrderedCategorisations=[];to=from<to?dropPos<0// moving forward into the array
?to-1// dropPos = -1 => drag on top node gap
:to// dropPos = 1 => drag on bottom node gap
:dropPos<0// moving backwards into the array
?to// dropPos = -1 => drag on top node gap
:to+1;// dropPos = 1 => drag on bottom node gap
if(to===-1){to=0;}if(to===toSisterDfOrderedCategorisations.length+1){to=toSisterDfOrderedCategorisations.length;}}else{// other category
if(toSisterDfOrderedCategorisations.find(function(_ref5){var source=_ref5.source;return source===Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(dataflow);})){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t("scenes.metaManager.categorySchemesDataflowsTree.errors.duplicateCategorisation.title")});return;}to=dropPos<0// moving backwards into the array
?to// dropPos = -1 => drag on top node gap
:to+1;// dropPos = 1 => drag on bottom node gap;
if(to===-1){to=0;}if(to===toSisterDfOrderedCategorisations.length+1){to=toSisterDfOrderedCategorisations.length;}}draggedInto.categoryUrn?onDataflowCategorise(dataflow,draggedInto.categoryUrn,categorisations,from,to,fromSisterDfOrderedCategorisations,toSisterDfOrderedCategorisations,lang,orderAnnotationType,agencyPermissions,t):__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t("scenes.metaManager.categorySchemesDataflowsTree.errors.notValidCategory.title")});}else if(draggedInto.urn&&draggedInto.type==="category"){if(toSisterDfOrderedCategorisations.find(function(_ref6){var source=_ref6.source;return source===Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(dataflow);})){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t("scenes.metaManager.categorySchemesDataflowsTree.errors.duplicateCategorisation.title")});}else{onDataflowCategorise(dataflow,draggedInto.urn,categorisations,from,0,fromSisterDfOrderedCategorisations,toSisterDfOrderedCategorisations,lang,orderAnnotationType,agencyPermissions,t);}}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t("scenes.metaManager.categorySchemesDataflowsTree.errors.notValidCategory.title")});}}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t("scenes.metaManager.categorySchemesDataflowsTree.errors.canDragOnlyDataflow.title")});}};var CategorySchemesAndDataflows=function CategorySchemesAndDataflows(_ref7){var t=_ref7.t,permissions=_ref7.permissions,tree=_ref7.tree,categorisations=_ref7.categorisations,nodes=_ref7.nodes,nodeId=_ref7.nodeId,appLanguage=_ref7.appLanguage,dataLanguages=_ref7.dataLanguages,fetchTree=_ref7.fetchTree,onDataflowCategorise=_ref7.onDataflowCategorise,onDeleteDataflowCategorisation=_ref7.onDeleteDataflowCategorisation,onLanguageChange=_ref7.onLanguageChange;var orderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.categorisationsOrder;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hocs_call__["a" /* default */],{cb:function cb(){return fetchTree(appLanguage);},disabled:!(nodes&&nodes.length>0&&tree===null)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hocs_call__["a" /* default */],{cb:onLanguageChange,cbParam:appLanguage,checkCbParamChangeOnly:true,disableFirst:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:"category-schemes-and-dataflows__categorisation__tree"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_enhanced_tree__["a" /* default */],{tree:tree,getNodeKey:function getNodeKey(node){return node.id===__WEBPACK_IMPORTED_MODULE_5__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]?__WEBPACK_IMPORTED_MODULE_5__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]:Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(node);},childrenKey:"categories",idKey:"id",nameKey:"name",catIdKey:"id",catNameKey:"name",defaultCollapsed:true,getFilter:function getFilter(searchText){return function(_ref8){var id=_ref8.id,name=_ref8.name;var search=searchText.toLowerCase();return id&&id.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_6__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_5__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],icon:"file-text",getIconColor:function getIconColor(){return"#37a0f4";},treeActions:[{title:t('scenes.metaManager.categorySchemesDataflowsTree.tree.refreshButton.title'),icon:'sync',onClick:function onClick(){return fetchTree(appLanguage);}}],draggable:true,unselectableKeys:[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_5__utils_tree__["l" /* getNodes */])(tree,'categories',function(){return true;}).map(function(node){return node.id===__WEBPACK_IMPORTED_MODULE_5__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]?__WEBPACK_IMPORTED_MODULE_5__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]:Object(__WEBPACK_IMPORTED_MODULE_4__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(node);}))),onDrop:function onDrop(ev){return _onDrop(ev,onDataflowCategorise,categorisations,t,appLanguage,orderAnnotationType,permissions?permissions.agencies:[]);},rightClickActions:[function(node){return node.type==="dataflow"&&node.categoryUrn?{icon:'disconnect',title:t('scenes.metaManager.categorySchemesDataflowsTree.tree.actions.deleteCategorisation.title'),onClick:function onClick(){return onDeleteDataflowCategorisation(node,categorisations);}}:null;}]}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CategorySchemesAndDataflows));

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_components_redux_dsd_detail_modal__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(338);
var mapStateToProps=function mapStateToProps(state){return{dsdDetail:state.scenes.metaManager.dsds.dsdDetail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var Dsds=function Dsds(_ref){var dsdDetail=_ref.dsdDetail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_dsd_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_4__reducer__["a" /* MM_DSDS_PREFIX */],instanceState:dsdDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Dsds));

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_annotation_list__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducer__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{dsds:state.scenes.metaManager.dsds.dsds,dsdAnnotations:state.scenes.metaManager.dsds.dsdAnnotations,dsdLayoutAnnotations:state.scenes.metaManager.dsds.dsdLayoutAnnotations,dsdAnnotationTriplet:state.scenes.metaManager.dsds.dsdAnnotationTriplet,parentsAndChildren:state.scenes.metaManager.dsds.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchDsds:function fetchDsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["p" /* readDsdsListDsds */])());},onCreate:function onCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal_actions__["_37" /* createDsdDetail */])(),__WEBPACK_IMPORTED_MODULE_11__reducer__["a" /* MM_DSDS_PREFIX */]));},onDetail:function onDetail(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal_actions__["_44" /* editDsdDetail */])(dsdTriplet),__WEBPACK_IMPORTED_MODULE_11__reducer__["a" /* MM_DSDS_PREFIX */]));},onDsdDelete:function onDsdDelete(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* deleteDsdsListDsd */])(dsdTriplet));},onDownloadShow:function onDownloadShow(dsdTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal_actions__["_78" /* showDsdDetailDownload */])(dsdTriplets,lang),__WEBPACK_IMPORTED_MODULE_11__reducer__["a" /* MM_DSDS_PREFIX */]));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal_actions__["_73" /* showDsdDetailClone */])(artefactTriplet),__WEBPACK_IMPORTED_MODULE_11__reducer__["a" /* MM_DSDS_PREFIX */]));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal_actions__["_79" /* showDsdDetailDsdExport */])(sourceTriplet),__WEBPACK_IMPORTED_MODULE_11__reducer__["a" /* MM_DSDS_PREFIX */]));},onAnnotationsShow:function onAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* showDsdsListDsdAnnotations */])(annotations,triplet));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* hideDsdsListDsdAnnotations */])());},onLayoutAnnotationsShow:function onLayoutAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["r" /* showDsdsListDsdLayoutAnnotations */])(annotations,triplet));},onLayoutAnnotationsHide:function onLayoutAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* hideDsdsListDsdLayoutAnnotations */])());},onSelectedDsdDelete:function onSelectedDsdDelete(dsdTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* deleteDsdsListSelectedDsds */])(dsdTriplets));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* readDsdsDetailItemsImportFormAllCsvRows */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["l" /* hideDsdsDetailItemsImportFormAllCsvRows */])());}};};var DsdsList=function DsdsList(_ref){var dsds=_ref.dsds,dsdAnnotations=_ref.dsdAnnotations,dsdLayoutAnnotations=_ref.dsdLayoutAnnotations,dsdAnnotationTriplet=_ref.dsdAnnotationTriplet,fetchDsds=_ref.fetchDsds,onCreate=_ref.onCreate,onDetail=_ref.onDetail,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow,onDsdDelete=_ref.onDsdDelete,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onLayoutAnnotationsShow=_ref.onLayoutAnnotationsShow,onLayoutAnnotationsHide=_ref.onLayoutAnnotationsHide,onSelectedDsdDelete=_ref.onSelectedDsdDelete,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchDsds,disabled:dsds!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_artefact_list__["a" /* default */],{artefacts:dsds,onDetailShow:onDetail,onCreate:onCreate,onDownloadShow:onDownloadShow,onCloneShow:onCloneShow,onExportShow:onExportShow,onDelete:onDsdDelete,onSelectedItemDelete:onSelectedDsdDelete,onAnnotationsShow:onAnnotationsShow,onLayoutAnnotationsShow:onLayoutAnnotationsShow,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("datastructure",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__["a" /* default */],{annotations:dsdAnnotations,onClose:onAnnotationsHide,title:dsdAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_12__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dsdAnnotationTriplet):null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_layout_annotation_list__["a" /* default */],{annotations:dsdLayoutAnnotations,onClose:onLayoutAnnotationsHide,title:dsdAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_12__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dsdAnnotationTriplet):null}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsList));

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditUser__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CreateUser__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__page_header_user_dropdown_actions__ = __webpack_require__(175);
var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions,username:state.app.user.username,token:state.app.user.token,users:state.scenes.manageUsers.userManagement.users,user:state.scenes.manageUsers.userManagement.user,isSynchronized:state.scenes.manageUsers.userManagement.isSynchronized,editPassword:state.scenes.manageUsers.userManagement.editPassword,isLoginValid:state.scenes.manageUsers.userManagement.isLoginValid};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchUsers:function fetchUsers(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["p" /* readUserManagementUsers */])());},fetchUser:function fetchUser(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["o" /* readUserManagementUser */])());},onUserEdit:function onUserEdit(_ref){var username=_ref.username,email=_ref.email,isExternal=_ref.isExternal;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["m" /* editUserManagementUser */])(username,email,isExternal));},onUserHide:function onUserHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["n" /* hideUserManagementUser */])());},onUserCreate:function onUserCreate(username,password,email){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["k" /* createUserManagementUser */])(username,password,email));},onUserSubmit:function onUserSubmit(user,token,editPassword,isLoginValid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["q" /* submitUserManagement */])(user,token,editPassword,isLoginValid));},onUserDelete:function onUserDelete(username){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["l" /* deleteUserManagementUser */])(username));},synchronize:function synchronize(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["r" /* synchronizeUserManagement */])());},onLogout:function onLogout(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__page_header_user_dropdown_actions__["e" /* logoutUserDropdownUser */])());}};};var UserManagement=function UserManagement(_ref2){var t=_ref2.t,permissions=_ref2.permissions,username=_ref2.username,token=_ref2.token,users=_ref2.users,user=_ref2.user,isSynchronized=_ref2.isSynchronized,fetchUsers=_ref2.fetchUsers,fetchUser=_ref2.fetchUser,onUserEdit=_ref2.onUserEdit,onUserHide=_ref2.onUserHide,onUserCreate=_ref2.onUserCreate,onUserSubmit=_ref2.onUserSubmit,onUserDelete=_ref2.onUserDelete,synchronize=_ref2.synchronize,editPassword=_ref2.editPassword,isLoginValid=_ref2.isLoginValid,onLogout=_ref2.onLogout;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__hocs_call__["a" /* default */],{cb:synchronize},isSynchronized&&(permissions&&permissions.rules&&permissions.rules.includes("AdminRole")?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__hocs_call__["a" /* default */],{cb:fetchUsers,disabled:users!==null||isLoginValid===false},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_infinite_scroll_table__["a" /* default */],{data:users,getRowKey:function getRowKey(_ref3){var username=_ref3.username;return username;},columns:[{title:t('data.user.username.label'),dataIndex:'username',minWidth:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.user.email.label'),dataIndex:'email',minWidth:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]}],actions:[function(_ref4){var username=_ref4.username,email=_ref4.email,isExternal=_ref4.isExternal;return Object.assign({},__WEBPACK_IMPORTED_MODULE_18__styles_buttons__["l" /* BUTTON_DETAIL */],{title:t('commons.actions.detail.title'),onClick:function onClick(){return onUserEdit({username:username,email:email,isExternal:isExternal});}});},function(_ref5){var username=_ref5.username;return Object.assign({},__WEBPACK_IMPORTED_MODULE_18__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('commons.actions.delete.title'),onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('scenes.manageUsers.userManagement.confirms.deleteUser.title',{id:username}),onOk:function onOk(){onUserDelete(username);},cancelText:t('commons.buttons.cancel.title')});}});}],rightActions:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",icon:"plus",onClick:function onClick(){var modal=__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.info();modal.update({icon:'user',title:t('scenes.manageUsers.userManagement.modals.createUser.title'),content:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__CreateUser__["a" /* default */],{t:t,modal:modal,onSubmit:function onSubmit(username,password,email){return onUserCreate(username,password,email);}}),okButtonProps:{style:{display:'none'}},keyboard:false});}},t('scenes.manageUsers.userManagement.buttons.createUser.title'))})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_enhanced_modal__["a" /* default */],{visible:user!==null,width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_MD"],title:t("scenes.manageUsers.userManagement.modals.editUser.title",{username:user?user.username:null}),onCancel:onUserHide,footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onUserHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onUserSubmit(user,token,editPassword,username!==user.username);},disabled:user===null||user.email===null||user.email.length===0||(user.password||"")!==(user.confirmPassword||"")},t('commons.buttons.save.title')))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__EditUser__["a" /* default */],null))):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__hocs_call__["a" /* default */],{cb:fetchUser,disabled:user!==null||isLoginValid===false},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__EditUser__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onUserSubmit(user,token,editPassword,username!==user.username);},disabled:user===null||user.email===null||user.email.length===0||(user.password||"")!==(user.confirmPassword||"")},t('commons.buttons.save.title'))))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__hocs_call__["a" /* default */],{cb:onLogout,disabled:isLoginValid!==false},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(UserManagement));

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_constants__);
var mapStateToProps=function mapStateToProps(state){return{user:state.scenes.manageUsers.userManagement.user,editPassword:state.scenes.manageUsers.userManagement.editPassword};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["j" /* changeUserManagementUser */])(fields));}};};var mapPropsToFields=function mapPropsToFields(_ref){var user=_ref.user;return{username:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:user?user.username:null}),password:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:user?user.password:null}),confirmPassword:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:user?user.confirmPassword:null}),email:__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.createFormField({value:user?user.email:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["SPAN_TWO_THIRDS"]}};var UserManagementEditUser=function UserManagementEditUser(_ref3){var t=_ref3.t,form=_ref3.form,user=_ref3.user,editPassword=_ref3.editPassword,onChange=_ref3.onChange;return user&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,null,user.isExternal===true&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t("data.user.warnings.externUser.message")})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.username.label'),className:'form-item-required'},formItemLayout),form.getFieldDecorator('username')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{disabled:true,autoComplete:'suppress'}))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginBottom:user.isExternal!==true?__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]:0},className:'form-item-required'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.email.label'),className:'form-item-required'},formItemLayout),form.getFieldDecorator('email')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{disabled:user.isExternal===true,autoComplete:'suppress'}))))),user.isExternal!==true&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],className:'form-item-required'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.editPassword.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{checked:editPassword,onClick:function onClick(e){return onChange({editPassword:e.target.checked});}})))),editPassword&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"],style:{marginTop:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"],marginBottom:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.password.label'),className:'form-item-required'},formItemLayout),form.getFieldDecorator('password')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{type:'password',autoComplete:'suppress'}))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_18__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,Object.assign({label:t('data.user.confirmPassword.label'),className:'form-item-required',hasFeedback:true,validateStatus:user&&user.confirmPassword&&user.confirmPassword.length>0&&user.password!==user.confirmPassword?"warning":null,help:user&&user.confirmPassword&&user.confirmPassword.length>0&&user.password!==user.confirmPassword?t("commons.helps.passwordsNotEqual.label"):null},formItemLayout),form.getFieldDecorator('confirmPassword')(__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{type:'password',autoComplete:'suppress'}))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_13_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(UserManagementEditUser));

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_TWO_THIRDS"]}};var UserManagementCreateUser=function UserManagementCreateUser(_ref){var t=_ref.t,form=_ref.form,modal=_ref.modal,onSubmit=_ref.onSubmit;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"],marginTop:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.user.username.label')},formItemLayout),form.getFieldDecorator('username')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{autoComplete:'suppress'}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.user.password.label'),hasFeedback:true,validateStatus:form.getFieldValue('confirmPassword')&&form.getFieldValue('confirmPassword').length>0&&form.getFieldValue('password')!==form.getFieldValue('confirmPassword')?"warning":null,help:form.getFieldValue('confirmPassword')&&form.getFieldValue('confirmPassword').length>0&&form.getFieldValue('password')!==form.getFieldValue('confirmPassword')?t("commons.helps.passwordsNotEqual.label"):null},formItemLayout),form.getFieldDecorator('password')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{type:'password',autoComplete:'suppress'}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.user.confirmPassword.label')},formItemLayout),form.getFieldDecorator('confirmPassword')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{type:'password',autoComplete:'suppress'}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.user.email.label')},formItemLayout),form.getFieldDecorator('email')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{autoComplete:'suppress'}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',gutter:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){modal.destroy();}},t('commons.buttons.cancel.title'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:'primary',icon:'save',disabled:!form.getFieldValue('username')||form.getFieldValue('username').length<1||form.getFieldValue('password')!==form.getFieldValue('confirmPassword')||!form.getFieldValue('email')||form.getFieldValue('email').length<1,onClick:function onClick(){modal.destroy();onSubmit(form.getFieldValue('username'),form.getFieldValue('password'),form.getFieldValue('email'));}},t('commons.buttons.save.title')))));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(UserManagementCreateUser));

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__List__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Detail__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,msd:state.scenes.metaManager.msds.msd,downloadMsdParams:state.scenes.metaManager.msds.downloadMsdParams,downloadMsdTriplets:state.scenes.metaManager.msds.downloadMsdTriplets,downloadMsdLang:state.scenes.metaManager.msds.downloadMsdLang,allAgencies:state.scenes.metaManager.msds.allAgencies,cloneDestTriplet:state.scenes.metaManager.msds.cloneDestTriplet,msdExportSourceTriplet:state.scenes.metaManager.msds.msdExportSourceTriplet,msdExportDestination:state.scenes.metaManager.msds.msdExportDestination,msdExportReport:state.scenes.metaManager.msds.msdExportReport,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["F" /* hideMsdsMsdClone */])());},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["y" /* changeMsdsMsdClone */])(fields));},onCloneSubmit:function onCloneSubmit(cloneDestTriplet,srcMsd,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["T" /* submitMsdsMsdClone */])(cloneDestTriplet,srcMsd,annotationsConfig));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["I" /* hideMsdsMsdExport */])());},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["B" /* changeMsdsMsdExport */])(fields));},onExportSubmit:function onExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["V" /* submitMsdsMsdExport */])(sourceTriplet,destination));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["J" /* hideMsdsMsdExportReport */])());},onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["H" /* hideMsdsMsdDownload */])());},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["A" /* changeMsdsMsdDownload */])(fields));},onDownload:function onDownload(msdTriplets,downloadMsdParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["E" /* downloadMsdsMsd */])(msdTriplets,downloadMsdParams,lang));}};};var Msds=function Msds(_ref){var t=_ref.t,msd=_ref.msd,endpoints=_ref.endpoints,endpointId=_ref.endpointId,downloadMsdParams=_ref.downloadMsdParams,downloadMsdTriplets=_ref.downloadMsdTriplets,downloadMsdLang=_ref.downloadMsdLang,allAgencies=_ref.allAgencies,cloneDestTriplet=_ref.cloneDestTriplet,msdExportSourceTriplet=_ref.msdExportSourceTriplet,msdExportDestination=_ref.msdExportDestination,msdExportReport=_ref.msdExportReport,user=_ref.user,onCloneHide=_ref.onCloneHide,onCloneChange=_ref.onCloneChange,onCloneSubmit=_ref.onCloneSubmit,onExportHide=_ref.onExportHide,onExportChange=_ref.onExportChange,onExportSubmit=_ref.onExportSubmit,onExportReportHide=_ref.onExportReportHide,onDownloadHide=_ref.onDownloadHide,onDownloadChange=_ref.onDownloadChange,onDownload=_ref.onDownload;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Detail__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(cloneDestTriplet,msd,endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations);}},type:"primary"},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:msd,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_enhanced_modal__["a" /* default */],{visible:msdExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["e" /* isExportDestinationValid */])(msdExportDestination,(user&&user.providerId)!==null)){onExportSubmit(msdExportSourceTriplet,msdExportDestination);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__["b" /* default */],{type:"metadatastructure",agencies:allAgencies,sourceTriplet:msdExportSourceTriplet,destination:msdExportDestination,onChange:onExportChange,withReferences:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_enhanced_modal__["a" /* default */],{visible:msdExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_artefact_export_report__["a" /* default */],{report:msdExportReport})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_enhanced_modal__["a" /* default */],{visible:downloadMsdTriplets!==null&&downloadMsdTriplets!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){return onDownload(downloadMsdTriplets,downloadMsdParams,downloadMsdLang);},type:"primary",disabled:downloadMsdParams&&downloadMsdParams.format===null||downloadMsdParams&&downloadMsdParams.format===__WEBPACK_IMPORTED_MODULE_8__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadMsdParams.csvSeparator===null||downloadMsdParams.csvSeparator.length!==1||downloadMsdParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_SM"],title:downloadMsdTriplets&&downloadMsdTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadMsdTriplets?Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadMsdTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadMsdParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_8__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadMsdTriplets&&downloadMsdTriplets.length>1?__WEBPACK_IMPORTED_MODULE_8__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_8__constants_download__["k" /* ARTEFACT_TYPE_MSD */]),hasReferences:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_14_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(Msds));

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(192);
var mapStateToProps=function mapStateToProps(state){return{msds:state.scenes.metaManager.msds.msds,parentsAndChildren:state.scenes.metaManager.msds.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchMsds:function fetchMsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["M" /* readMsdsListMsds */])());},onMsdShow:function onMsdShow(msdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["Q" /* showMsdsMsdDetail */])(msdTriplet));},onDelete:function onDelete(msdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["C" /* deleteMsdsMsd */])(msdTriplet));},onSelectedMsdsDelete:function onSelectedMsdsDelete(msdTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["D" /* deleteMsdsSelectedMsds */])(msdTriplets));},onDownloadShow:function onDownloadShow(msdTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["R" /* showMsdsMsdDownload */])(msdTriplets,lang));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["O" /* readMsdsMsdParentsAndChildren */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["K" /* hideMsdsMsdParentsAndChildren */])());},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["P" /* showMsdsMsdClone */])(artefactTriplet));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["S" /* showMsdsMsdExport */])(sourceTriplet));}};};var MsdsList=function MsdsList(_ref){var msds=_ref.msds,fetchMsds=_ref.fetchMsds,onMsdShow=_ref.onMsdShow,onDelete=_ref.onDelete,onSelectedMsdsDelete=_ref.onSelectedMsdsDelete,onDownloadShow=_ref.onDownloadShow,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hocs_call__["a" /* default */],{cb:fetchMsds,disabled:msds!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_artefact_list__["a" /* default */],{artefacts:msds,onDetailShow:onMsdShow,onDownloadShow:onDownloadShow,onDelete:onDelete,onSelectedItemDelete:onSelectedMsdsDelete,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("metadatastructure",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide,showImportButton:true,onCloneShow:onCloneShow,onExportShow:onExportShow}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MsdsList));

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,isVisible:state.scenes.metaManager.msds.isVisible,msdTriplet:state.scenes.metaManager.msds.msdTriplet,msd:state.scenes.metaManager.msds.msd,agencies:state.scenes.metaManager.msds.agencies,appLanguage:state.app.language};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMsdDetailHide:function onMsdDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["G" /* hideMsdsMsdDetail */])());},onMsdDetailChange:function onMsdDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["z" /* changeMsdsMsdDetail */])(fields));},onMsdDetailUpdate:function onMsdDetailUpdate(msd,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["U" /* submitMsdsMsdDetail */])(msd,annotationsConfig));},fetchMsd:function fetchMsd(msdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["N" /* readMsdsMsdDetail */])(msdTriplet));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["L" /* readMsdsAgencies */])(allowedAgencies));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["P" /* showMsdsMsdClone */])(artefactTriplet));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["S" /* showMsdsMsdExport */])(sourceTriplet));},onDownloadShow:function onDownloadShow(msdTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["R" /* showMsdsMsdDownload */])(msdTriplets,lang));}};};var MsdDetail=function MsdDetail(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,nodes=_ref.nodes,nodeId=_ref.nodeId,permissions=_ref.permissions,isVisible=_ref.isVisible,msdTriplet=_ref.msdTriplet,msd=_ref.msd,agencies=_ref.agencies,onMsdDetailHide=_ref.onMsdDetailHide,onMsdDetailChange=_ref.onMsdDetailChange,onMsdDetailUpdate=_ref.onMsdDetailUpdate,fetchMsd=_ref.fetchMsd,fetchAgencies=_ref.fetchAgencies,onCloneShow=_ref.onCloneShow,onDownloadShow=_ref.onDownloadShow,onExportShow=_ref.onExportShow;var currentNode=nodes.find(function(node){return node.general.id===nodeId;});var annotationsConfig=currentNode.annotations;var userHasPermissionsToEdit=permissions&&msdTriplet&&permissions.agencies.filter(function(agency){return agency===msdTriplet.agencyID;}).length>0;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchMsd,cbParam:msdTriplet,disabled:!msdTriplet||msd!==null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:!isVisible},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_XL"],title:userHasPermissionsToEdit?t('scenes.metaManager.msds.detail.title.editMode.title',{triplet:msdTriplet}):t('scenes.metaManager.msds.detail.title.viewMode.title',{triplet:msdTriplet}),onCancel:onMsdDetailHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onMsdDetailHide},t('commons.buttons.close.title')),userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_19__utils_artefactValidators__["a" /* isArtefactValid */])(msd)){onMsdDetailUpdate(msd,annotationsConfig);}else{__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,permissions&&!userHasPermissionsToEdit&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["GUTTER_SM"],justify:"end",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onDownloadShow([msdTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){return onCloneShow(msdTriplet);}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onExportShow(msdTriplet);}}))),msd&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_artefact_form__["d" /* default */],{artefact:msd,mode:userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_17__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_17__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],agencies:agencies,onChange:onMsdDetailChange,isMsd:true}));}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(MsdDetail));

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Detail__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,dataLanguages:state.config.dataManagement.dataLanguages,allAgencies:state.scenes.metaManager.agencySchemes.allAgencies,agencyScheme:state.scenes.metaManager.agencySchemes.agencyScheme,itemsTree:state.scenes.metaManager.agencySchemes.itemsTree,downloadAgencySchemeTriplets:state.scenes.metaManager.agencySchemes.downloadAgencySchemeTriplets,downloadAgencySchemeLang:state.scenes.metaManager.agencySchemes.downloadAgencySchemeLang,downloadAgencySchemeParams:state.scenes.metaManager.agencySchemes.downloadAgencySchemeParams,cloneDestTriplet:state.scenes.metaManager.agencySchemes.cloneDestTriplet,agencySchemeExportSourceTriplet:state.scenes.metaManager.agencySchemes.agencySchemeExportSourceTriplet,agencySchemeExportDestination:state.scenes.metaManager.agencySchemes.agencySchemeExportDestination,agencySchemeExportReport:state.scenes.metaManager.agencySchemes.agencySchemeExportReport,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAgencySchemeDownloadHide:function onAgencySchemeDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_18" /* hideAgencySchemesAgencySchemeDownload */])());},onAgencySchemeDownloadChange:function onAgencySchemeDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["Z" /* changeAgencySchemesAgencySchemeDownload */])(fields));},onAgencySchemeDownload:function onAgencySchemeDownload(artefactTriplets,downloadAgencySchemeParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_12" /* downloadAgencySchemesAgencyScheme */])(artefactTriplets,downloadAgencySchemeParams,lang));},onAgencySchemeCloneHide:function onAgencySchemeCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_17" /* hideAgencySchemesAgencySchemeClone */])());},onAgencySchemeCloneChange:function onAgencySchemeCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["Y" /* changeAgencySchemesAgencySchemeClone */])(fields));},onAgencySchemeCloneSubmit:function onAgencySchemeCloneSubmit(cloneDestTriplet,srcAgencyScheme,srcAgencySchemeItemsTree,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_43" /* submitAgencySchemesAgencySchemeClone */])(cloneDestTriplet,srcAgencyScheme,srcAgencySchemeItemsTree,annotationsConfig));},onAgencySchemeExportHide:function onAgencySchemeExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_19" /* hideAgencySchemesAgencySchemeExport */])());},onAgencySchemeExportChange:function onAgencySchemeExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_0" /* changeAgencySchemesAgencySchemeExport */])(fields));},onAgencySchemeExportSubmit:function onAgencySchemeExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_44" /* submitAgencySchemesAgencySchemeExport */])(sourceTriplet,destination));},onAgencySchemeExportReportHide:function onAgencySchemeExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_20" /* hideAgencySchemesAgencySchemeExportReport */])());}};};var AgencySchemes=function AgencySchemes(_ref){var t=_ref.t,endpoints=_ref.endpoints,endpointId=_ref.endpointId,allAgencies=_ref.allAgencies,dataLanguages=_ref.dataLanguages,agencyScheme=_ref.agencyScheme,itemsTree=_ref.itemsTree,downloadAgencySchemeTriplets=_ref.downloadAgencySchemeTriplets,downloadAgencySchemeLang=_ref.downloadAgencySchemeLang,downloadAgencySchemeParams=_ref.downloadAgencySchemeParams,onAgencySchemeDownloadHide=_ref.onAgencySchemeDownloadHide,onAgencySchemeDownloadChange=_ref.onAgencySchemeDownloadChange,onAgencySchemeDownload=_ref.onAgencySchemeDownload,cloneDestTriplet=_ref.cloneDestTriplet,onAgencySchemeCloneHide=_ref.onAgencySchemeCloneHide,onAgencySchemeCloneChange=_ref.onAgencySchemeCloneChange,onAgencySchemeCloneSubmit=_ref.onAgencySchemeCloneSubmit,agencySchemeExportSourceTriplet=_ref.agencySchemeExportSourceTriplet,agencySchemeExportDestination=_ref.agencySchemeExportDestination,onAgencySchemeExportChange=_ref.onAgencySchemeExportChange,onAgencySchemeExportSubmit=_ref.onAgencySchemeExportSubmit,onAgencySchemeExportHide=_ref.onAgencySchemeExportHide,agencySchemeExportReport=_ref.agencySchemeExportReport,user=_ref.user,onAgencySchemeExportReportHide=_ref.onAgencySchemeExportReportHide;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Detail__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:downloadAgencySchemeTriplets!==null&&downloadAgencySchemeTriplets!==undefined,onCancel:onAgencySchemeDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onAgencySchemeDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){return onAgencySchemeDownload(downloadAgencySchemeTriplets,downloadAgencySchemeParams,downloadAgencySchemeLang);},type:"primary",disabled:downloadAgencySchemeParams&&downloadAgencySchemeParams.format===null||downloadAgencySchemeParams&&downloadAgencySchemeParams.format===__WEBPACK_IMPORTED_MODULE_14__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadAgencySchemeParams.csvSeparator===null||downloadAgencySchemeParams.csvSeparator.length!==1||downloadAgencySchemeParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_SM"],title:downloadAgencySchemeTriplets&&downloadAgencySchemeTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadAgencySchemeTriplets?Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadAgencySchemeTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadAgencySchemeParams,onChange:onAgencySchemeDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_14__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadAgencySchemeTriplets&&downloadAgencySchemeTriplets.length>1?__WEBPACK_IMPORTED_MODULE_14__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_14__constants_download__["a" /* ARTEFACT_TYPE_AGENCY_SCHEME */]),langs:dataLanguages})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onAgencySchemeCloneHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onAgencySchemeCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onAgencySchemeCloneSubmit(cloneDestTriplet,agencyScheme,itemsTree,endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations);}},type:"primary"},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:agencyScheme,destTriplet:cloneDestTriplet,isIdDisabled:true,isVersionDisabled:true,onChange:onAgencySchemeCloneChange})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:agencySchemeExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],onCancel:onAgencySchemeExportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onAgencySchemeExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["e" /* isExportDestinationValid */])(agencySchemeExportDestination,(user&&user.providerId)!==null)){onAgencySchemeExportSubmit(agencySchemeExportSourceTriplet,agencySchemeExportDestination);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__["b" /* default */],{type:"agencyscheme",agencies:allAgencies,sourceTriplet:agencySchemeExportSourceTriplet,destination:agencySchemeExportDestination,onChange:onAgencySchemeExportChange,isIdDisabled:true,isVersionDisabled:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:agencySchemeExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],onCancel:onAgencySchemeExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onAgencySchemeExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_artefact_export_report__["a" /* default */],{report:agencySchemeExportReport})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(AgencySchemes));

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,agencySchemes:state.scenes.metaManager.agencySchemes.agencySchemes,agencySchemeAnnotations:state.scenes.metaManager.agencySchemes.agencySchemeAnnotations,agencySchemeAnnotationTriplet:state.scenes.metaManager.agencySchemes.agencySchemeAnnotationTriplet};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCreate:function onCreate(defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_6" /* createAgencySchemesAgencyScheme */])(defaultItemsViewMode));},onDetail:function onDetail(agencySchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_14" /* editAgencySchemesAgencyScheme */])(agencySchemeTriplet,defaultItemsViewMode));},fetchAgencySchemes:function fetchAgencySchemes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_33" /* readAgencySchemesListAgencySchemes */])());},onAgencySchemeDelete:function onAgencySchemeDelete(agencySchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_9" /* deleteAgencySchemesAgencyScheme */])(agencySchemeTriplet));},onAnnotationsShow:function onAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_38" /* showAgencySchemesDetailAnnotations */])(annotations,triplet));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_22" /* hideAgencySchemesDetailAnnotations */])());},onSelectedAgencySchemesDelete:function onSelectedAgencySchemesDelete(agencySchemeTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_11" /* deleteAgencySchemesSelectedAgencySchemes */])(agencySchemeTriplets));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_36" /* showAgencySchemesAgencySchemeDownload */])(artefactTriplets,lang));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_35" /* showAgencySchemesAgencySchemeClone */])(artefactTriplet));},onExportShow:function onExportShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_37" /* showAgencySchemesAgencySchemeExport */])(artefactTriplet));}};};var AgencySchemesList=function AgencySchemesList(_ref){var nodeId=_ref.nodeId,nodes=_ref.nodes,agencySchemes=_ref.agencySchemes,_onCreate=_ref.onCreate,onDetail=_ref.onDetail,fetchAgencySchemes=_ref.fetchAgencySchemes,onAgencySchemeDelete=_ref.onAgencySchemeDelete,agencySchemeAnnotations=_ref.agencySchemeAnnotations,agencySchemeAnnotationTriplet=_ref.agencySchemeAnnotationTriplet,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onSelectedAgencySchemesDelete=_ref.onSelectedAgencySchemesDelete,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchAgencySchemes,disabled:agencySchemes!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_artefact_list__["a" /* default */],{artefacts:agencySchemes,onCreate:function onCreate(){return _onCreate(defaultItemsViewMode);},onDetailShow:function onDetailShow(triplet){return onDetail(triplet,defaultItemsViewMode);},onDownloadShow:onDownloadShow,onCloneShow:onCloneShow,onExportShow:onExportShow,onDelete:onAgencySchemeDelete,onSelectedItemDelete:onSelectedAgencySchemesDelete,onAnnotationsShow:onAnnotationsShow}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__["a" /* default */],{annotations:agencySchemeAnnotations,onClose:onAnnotationsHide,title:agencySchemeAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(agencySchemeAnnotationTriplet):null}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(AgencySchemesList));

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Items__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_artefactValidators__ = __webpack_require__(37);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,appLanguage:state.app.language,isVisible:state.scenes.metaManager.agencySchemes.isDetailVisible,agencySchemeTriplet:state.scenes.metaManager.agencySchemes.agencySchemeTriplet,isAgencySchemeValid:state.scenes.metaManager.agencySchemes.isAgencySchemeValid,isAgenciesValid:state.scenes.metaManager.agencySchemes.isAgenciesValid,isAgencySchemeGeneralTabDirty:state.scenes.metaManager.agencySchemes.isAgencySchemeGeneralTabDirty,agencyScheme:state.scenes.metaManager.agencySchemes.agencyScheme,agencies:state.scenes.metaManager.agencySchemes.agencies,allAgencies:state.scenes.metaManager.agencySchemes.allAgencies,itemsTree:state.scenes.metaManager.agencySchemes.itemsTree,focusItemsTab:state.scenes.metaManager.agencySchemes.focusItemsTab};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAgencySchemeDetailHide:function onAgencySchemeDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_21" /* hideAgencySchemesDetail */])());},onAgencySchemeDetailChange:function onAgencySchemeDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_1" /* changeAgencySchemesDetailAgencyScheme */])(fields));},onAgencySchemeDetailCreate:function onAgencySchemeDetailCreate(agencyScheme,agencySchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_45" /* submitAgencySchemesDetailAgencySchemeCreate */])(agencyScheme,agencySchemeTriplet));},onAgencySchemeDetailUpdate:function onAgencySchemeDetailUpdate(agencyScheme,itemsTree,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_46" /* submitAgencySchemesDetailAgencySchemeUpdate */])(agencyScheme,itemsTree,itemsOrderAnnotationType));},fetchAgencyScheme:function fetchAgencyScheme(_ref){var agencySchemeTriplet=_ref.agencySchemeTriplet,itemsOrderAnnotationType=_ref.itemsOrderAnnotationType,lang=_ref.lang;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_31" /* readAgencySchemesDetailAgencyScheme */])(agencySchemeTriplet,itemsOrderAnnotationType,lang));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_30" /* readAgencySchemesDetailAgencies */])(allowedAgencies));},onLanguageChange:function onLanguageChange(lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_2" /* changeAgencySchemesDetailAgencySchemeLanguage */])(lang,itemsOrderAnnotationType));},onAgencySchemeDownloadShow:function onAgencySchemeDownloadShow(agencySchemeTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_36" /* showAgencySchemesAgencySchemeDownload */])(agencySchemeTriplets,lang));},onAgencySchemeCloneShow:function onAgencySchemeCloneShow(agencySchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_35" /* showAgencySchemesAgencySchemeClone */])(agencySchemeTriplet));},onAgencySchemeExportShow:function onAgencySchemeExportShow(agencySchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_37" /* showAgencySchemesAgencySchemeExport */])(agencySchemeTriplet));}};};var AgencySchemesDetail=function AgencySchemesDetail(_ref2){var t=_ref2.t,nodes=_ref2.nodes,nodeId=_ref2.nodeId,permissions=_ref2.permissions,appLanguage=_ref2.appLanguage,isVisible=_ref2.isVisible,agencySchemeTriplet=_ref2.agencySchemeTriplet,isAgencySchemeValid=_ref2.isAgencySchemeValid,isAgenciesValid=_ref2.isAgenciesValid,isAgencySchemeGeneralTabDirty=_ref2.isAgencySchemeGeneralTabDirty,agencyScheme=_ref2.agencyScheme,agencies=_ref2.agencies,onAgencySchemeDetailHide=_ref2.onAgencySchemeDetailHide,onAgencySchemeDetailChange=_ref2.onAgencySchemeDetailChange,onAgencySchemeDetailCreate=_ref2.onAgencySchemeDetailCreate,onAgencySchemeDetailUpdate=_ref2.onAgencySchemeDetailUpdate,fetchAgencyScheme=_ref2.fetchAgencyScheme,fetchAgencies=_ref2.fetchAgencies,itemsTree=_ref2.itemsTree,onLanguageChange=_ref2.onLanguageChange,focusItemsTab=_ref2.focusItemsTab,onAgencySchemeDownloadShow=_ref2.onAgencySchemeDownloadShow,onAgencySchemeCloneShow=_ref2.onAgencySchemeCloneShow,onAgencySchemeExportShow=_ref2.onAgencySchemeExportShow;var itemsOrderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.codelistsOrder;var userHasPermissionsToEdit=permissions&&agencySchemeTriplet&&permissions.agencies.filter(function(agency){return agency===agencySchemeTriplet.agencyID;}).length>0;var onArtefactFormChange=function onArtefactFormChange(agencySchemeFields){if(agencySchemeFields.isFinal){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t('scenes.metaManager.agencySchemes.detail.alerts.illegalFinal.title')});onAgencySchemeDetailChange(agencyScheme);}else{onAgencySchemeDetailChange(agencySchemeFields);}};var _useState=Object(__WEBPACK_IMPORTED_MODULE_12_react__["useState"])("general"),_useState2=_slicedToArray(_useState,2),tab=_useState2[0],setTab=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_12_react__["useEffect"])(function(){if(focusItemsTab){setTab("items");}else{setTab("general");}},[focusItemsTab]);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchAgencyScheme,cbParam:{agencySchemeTriplet:agencySchemeTriplet,itemsOrderAnnotationType:itemsOrderAnnotationType,lang:lang},disabled:isAgencySchemeValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:isAgenciesValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_XL"],title:agencySchemeTriplet!==null?userHasPermissionsToEdit?t('scenes.metaManager.agencySchemes.detail.title.editMode.title',{triplet:agencySchemeTriplet}):t('scenes.metaManager.agencySchemes.detail.title.viewMode.title',{triplet:agencySchemeTriplet}):t('scenes.metaManager.agencySchemes.detail.title.createMode.title'),onCancel:onAgencySchemeDetailHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onAgencySchemeDetailHide},t('commons.buttons.close.title')),agencySchemeTriplet===null||userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_23__utils_artefactValidators__["a" /* isArtefactValid */])(agencyScheme)){if(agencySchemeTriplet!==null){onAgencySchemeDetailUpdate(agencyScheme,itemsTree,itemsOrderAnnotationType);}else{onAgencySchemeDetailCreate(agencyScheme,{id:agencyScheme.id,agencyID:agencyScheme.agencyID,version:agencyScheme.version});}}else{__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true,onDataLanguageSelectorChange:function onDataLanguageSelectorChange(lang,changeLang){onLanguageChange(lang,itemsOrderAnnotationType);changeLang();}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return agencySchemeTriplet?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,permissions&&!userHasPermissionsToEdit&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],justify:"end"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onAgencySchemeDownloadShow([agencySchemeTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){return onAgencySchemeCloneShow(agencySchemeTriplet);}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onAgencySchemeExportShow(agencySchemeTriplet);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{activeKey:tab,onTabClick:function onTabClick(key){if(!Object(__WEBPACK_IMPORTED_MODULE_23__utils_artefactValidators__["a" /* isArtefactValid */])(agencyScheme)){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{setTab(key);if(key==="categorisations"){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t('errors.notImplemented')});}if(isAgencySchemeGeneralTabDirty){onAgencySchemeDetailUpdate(agencyScheme,itemsTree,itemsOrderAnnotationType);}}}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'general',tab:t('commons.artefact.tabs.general.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:agencyScheme,mode:userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],agencies:agencies,onChange:onArtefactFormChange,isIdDisabled:true,isVersionDisabled:true})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'items',tab:t('commons.artefact.tabs.items.title')},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Items__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'categorisations',tab:t('commons.artefact.tabs.categorisations.title')}))):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:agencyScheme,mode:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */],agencies:agencies,onChange:onArtefactFormChange,isIdDisabled:true,isVersionDisabled:true});}))));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(AgencySchemesDetail));

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Item__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_items_import_form__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_layout_annotation_list__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_items_viewer__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_annotations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__ = __webpack_require__(29);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onViewModeChange:function onViewModeChange(viewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_5" /* changeAgencySchemesDetailItemsViewMode */])(viewMode));},onCreate:function onCreate(parentId,order,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_7" /* createAgencySchemesDetailsItemsItem */])(parentId,order,lang,itemsOrderAnnotationType));},onDetailEdit:function onDetailEdit(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_15" /* editAgencySchemesDetailItemsItemDetail */])(item));},onDelete:function onDelete(agencyScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_10" /* deleteAgencySchemesDetailsItemsItem */])(agencyScheme,itemsTree,item,cutItem,lang,t,itemsOrderAnnotationType));},onSelect:function onSelect(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_34" /* selectAgencySchemesDetailsItemsItem */])(id));},onImportFormShow:function onImportFormShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_39" /* showAgencySchemesDetailItemsImportForm */])());},onImportFormHide:function onImportFormHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_23" /* hideAgencySchemesDetailItemsImportForm */])());},onImportFormChange:function onImportFormChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_3" /* changeAgencySchemesDetailItemsImportForm */])(fields));},onImportFormFileUpload:function onImportFormFileUpload(agencyScheme,itemsImportForm){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_49" /* uploadAgencySchemesDetailItemsImportFormFile */])(agencyScheme,itemsImportForm));},onImportFormFileImport:function onImportFormFileImport(agencyScheme,itemsImportForm){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_28" /* importAgencySchemesDetailItemsImportFormFile */])(agencyScheme,itemsImportForm));},onAnnotationsShow:function onAnnotationsShow(annotations){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_41" /* showAgencySchemesDetailItemsItemAnnotations */])(annotations));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_25" /* hideAgencySchemesDetailItemsItemAnnotations */])());},onLayoutAnnotationsShow:function onLayoutAnnotationsShow(annotations){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_42" /* showAgencySchemesDetailItemsItemLayoutAnnotations */])(annotations));},onLayoutAnnotationsHide:function onLayoutAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_27" /* hideAgencySchemesDetailItemsItemLayoutAnnotations */])());},onDrop:function onDrop(node,newParent,newOrder,agencyScheme,itemsTree,itemsOrderAnnotationType,lang,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_13" /* dropAgencySchemesDetailItemsItems */])(node,newParent,newOrder,agencyScheme,itemsTree,itemsOrderAnnotationType,lang,cutItem,t));},onDuplicateItemErrorHide:function onDuplicateItemErrorHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_16" /* hideAgencySchemeDetailItemsItemDuplicateItemError */])());},onCut:function onCut(item){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_8" /* cutAgencySchemesDetailItemsItem */])(item));},onPaste:function onPaste(cutItem,newParent,pasteAfter,agencyScheme,itemsTree,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_29" /* pasteAgencySchemesDetailItemsItem */])(cutItem,newParent,pasteAfter,agencyScheme,itemsTree,lang,itemsOrderAnnotationType));},onItemSubmit:function onItemSubmit(agencyScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_47" /* submitAgencySchemesDetailItemsItem */])(agencyScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t));},onImportFormAllCsvRowsShow:function onImportFormAllCsvRowsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_40" /* showAgencySchemesDetailItemsImportFormAllCsvRows */])());},onImportFormAllCsvRowsHide:function onImportFormAllCsvRowsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_24" /* hideAgencySchemesDetailItemsImportFormAllCsvRows */])());},uploadImportFormCsv:function uploadImportFormCsv(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_48" /* uploadAgencySchemesDetailItemsImportFormCsv */])(file));},fetchImportFormAllCsvRows:function fetchImportFormAllCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["_32" /* readAgencySchemesDetailItemsImportFormAllCsvRows */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath));},onAddAgencyToConfig:function onAddAgencyToConfig(superUserUsername,endpointId,agency){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["X" /* addAgencyToConfig */])(superUserUsername,endpointId,agency));}};};var mapStateToProps=function mapStateToProps(state){return{agencySchemeTriplet:state.scenes.metaManager.agencySchemes.agencySchemeTriplet,agencyScheme:state.scenes.metaManager.agencySchemes.agencyScheme,selectedItem:state.scenes.metaManager.agencySchemes.selectedItem,itemsViewMode:state.scenes.metaManager.agencySchemes.itemsViewMode,isItemsImportFormVisible:state.scenes.metaManager.agencySchemes.isItemsImportFormVisible,itemsImportForm:state.scenes.metaManager.agencySchemes.itemsImportForm,nodes:state.config.nodes,endpointId:state.app.endpointId,permissions:state.app.user.permissions,itemAnnotations:state.scenes.metaManager.agencySchemes.itemAnnotations,itemLayoutAnnotations:state.scenes.metaManager.agencySchemes.itemLayoutAnnotations,itemsTree:state.scenes.metaManager.agencySchemes.itemsTree,maxOrder:state.scenes.metaManager.agencySchemes.maxOrder,isDuplicateItemErrorVisible:state.scenes.metaManager.agencySchemes.isDuplicateItemErrorVisible,cutItem:state.scenes.metaManager.agencySchemes.cutItem,appLanguage:state.app.language,superUserUsername:state.app.superUser.username};};var AgencySchemesDetailItems=function AgencySchemesDetailItems(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,agencySchemeTriplet=_ref.agencySchemeTriplet,agencyScheme=_ref.agencyScheme,itemsViewMode=_ref.itemsViewMode,selectedItem=_ref.selectedItem,isItemsImportFormVisible=_ref.isItemsImportFormVisible,itemsImportForm=_ref.itemsImportForm,onViewModeChange=_ref.onViewModeChange,onCreate=_ref.onCreate,onDetailEdit=_ref.onDetailEdit,onDelete=_ref.onDelete,onSelect=_ref.onSelect,onImportFormShow=_ref.onImportFormShow,onImportFormHide=_ref.onImportFormHide,onImportFormChange=_ref.onImportFormChange,onImportFormFileUpload=_ref.onImportFormFileUpload,onImportFormFileImport=_ref.onImportFormFileImport,nodes=_ref.nodes,endpointId=_ref.endpointId,itemAnnotations=_ref.itemAnnotations,itemLayoutAnnotations=_ref.itemLayoutAnnotations,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onLayoutAnnotationsShow=_ref.onLayoutAnnotationsShow,onLayoutAnnotationsHide=_ref.onLayoutAnnotationsHide,onDrop=_ref.onDrop,itemsTree=_ref.itemsTree,maxOrder=_ref.maxOrder,isDuplicateItemErrorVisible=_ref.isDuplicateItemErrorVisible,onDuplicateItemErrorHide=_ref.onDuplicateItemErrorHide,cutItem=_ref.cutItem,onCut=_ref.onCut,onPaste=_ref.onPaste,onItemSubmit=_ref.onItemSubmit,onImportFormAllCsvRowsShow=_ref.onImportFormAllCsvRowsShow,onImportFormAllCsvRowsHide=_ref.onImportFormAllCsvRowsHide,uploadImportFormCsv=_ref.uploadImportFormCsv,fetchImportFormAllCsvRows=_ref.fetchImportFormAllCsvRows,_onAddAgencyToConfig=_ref.onAddAgencyToConfig,superUserUsername=_ref.superUserUsername;var annotationsConfig=nodes.find(function(node){return node.general.id===endpointId;}).annotations;var itemsOrderAnnotationType=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(nodes,function(node){return node.general.id===endpointId;}).annotations.codelistsOrder;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_items_viewer__["a" /* default */],{artefact:agencyScheme,artefactTriplet:agencySchemeTriplet,itemTree:itemsTree,childrenKey:"agencies",selectedItem:selectedItem,cutItem:cutItem,itemsViewMode:itemsViewMode,itemsOrderAnnotationType:itemsOrderAnnotationType,maxOrder:maxOrder,onCreate:onCreate,onDelete:onDelete,onDetailShow:onDetailEdit,onSelect:onSelect,onDrop:onDrop,onCut:onCut,onPaste:onPaste,onAnnotationsShow:onAnnotationsShow,onLayoutAnnotationsShow:onLayoutAnnotationsShow,onViewModeChange:onViewModeChange,onImportFormShow:onImportFormShow,onSetDefault:function onSetDefault(item){var newItem=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);newItem.annotations=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["Z" /* setLayoutAnnotationDefaultForCodelist */])(newItem.annotations,annotationsConfig,true);onItemSubmit(agencyScheme,itemsTree,newItem,itemsOrderAnnotationType,true,lang,false,cutItem,t);},onUnsetDefault:function onUnsetDefault(item){var newItem=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);newItem.annotations=Object(__WEBPACK_IMPORTED_MODULE_14__utils_annotations__["Z" /* setLayoutAnnotationDefaultForCodelist */])(newItem.annotations,annotationsConfig,false);onItemSubmit(agencyScheme,itemsTree,newItem,itemsOrderAnnotationType,true,lang,false,cutItem,t);},isNotHierarchical:true,onAddAgencyToConfig:function onAddAgencyToConfig(agency){return _onAddAgencyToConfig(superUserUsername,endpointId,agency);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_items_import_form__["a" /* default */],{isVisible:isItemsImportFormVisible,formData:itemsImportForm,onHide:onImportFormHide,onChange:onImportFormChange,onUpload:function onUpload(){return onImportFormFileUpload(agencyScheme,itemsImportForm);},onImport:function onImport(){return onImportFormFileImport(agencyScheme,itemsImportForm);},onAllCsvRowsShow:onImportFormAllCsvRowsShow,onAllCsvRowsHide:onImportFormAllCsvRowsHide,uploadCsv:uploadImportFormCsv,fetchAllCsvRows:fetchImportFormAllCsvRows}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_custom_annotation_list__["a" /* default */],{annotations:itemAnnotations,onClose:onAnnotationsHide}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_layout_annotation_list__["a" /* default */],{annotations:itemLayoutAnnotations,onClose:onLayoutAnnotationsHide}),isDuplicateItemErrorVisible&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t('commons.artefact.tabs.items.modals.errors.duplicateItem'),onOk:function onOk(){onDuplicateItemErrorHide();},onCancel:function onCancel(){onDuplicateItemErrorHide();}});}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",null)));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(AgencySchemesDetailItems));

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_item_form__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_artefactValidators__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,agencyScheme:state.scenes.metaManager.agencySchemes.agencyScheme,item:state.scenes.metaManager.agencySchemes.item,isItemEditMode:state.scenes.metaManager.agencySchemes.isItemEditMode,nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,itemsTree:state.scenes.metaManager.agencySchemes.itemsTree,isNormalizeNeeded:state.scenes.metaManager.agencySchemes.isNormalizeNeeded,cutItem:state.scenes.metaManager.agencySchemes.cutItem};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onItemDetailChange:function onItemDetailChange(fields,lang,itemsOrderAnnotationType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_4" /* changeAgencySchemesDetailItemsItemDetail */])(fields,lang,itemsOrderAnnotationType));},onItemDetailSubmit:function onItemDetailSubmit(agencyScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_47" /* submitAgencySchemesDetailItemsItem */])(agencyScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t));},onItemDetailHide:function onItemDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_26" /* hideAgencySchemesDetailItemsItemDetail */])());}};};var Item=function Item(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,agencyScheme=_ref.agencyScheme,item=_ref.item,isItemEditMode=_ref.isItemEditMode,onItemDetailChange=_ref.onItemDetailChange,onItemDetailSubmit=_ref.onItemDetailSubmit,onItemDetailHide=_ref.onItemDetailHide,nodes=_ref.nodes,nodeId=_ref.nodeId,permissions=_ref.permissions,itemsTree=_ref.itemsTree,isNormalizeNeeded=_ref.isNormalizeNeeded,cutItem=_ref.cutItem;var annotationsConfig=nodes.find(function(node){return node.general.id===nodeId;}).annotations;var itemsOrderAnnotationType=nodes.find(function(node){return node.general.id===nodeId;}).annotations.codelistsOrder;var userHasPermissionsToEdit=permissions&&agencyScheme&&permissions.agencies.filter(function(agency){return agency===agencyScheme.agencyID;}).length>0;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_enhanced_modal__["a" /* default */],{title:isItemEditMode&&item?userHasPermissionsToEdit?t("commons.artefact.tabs.items.item.detail.title.editMode.title",{id:item.id}):t("commons.artefact.tabs.items.item.detail.title.viewMode.title",{id:item.id}):t("commons.artefact.tabs.items.item.detail.title.createMode.title"),visible:item!==null,onCancel:onItemDetailHide,width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onItemDetailHide},t('commons.buttons.close.title')),!isItemEditMode||userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_13__utils_artefactValidators__["g" /* isItemValid */])(item)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onItemDetailSubmit(agencyScheme,itemsTree,item,itemsOrderAnnotationType,isItemEditMode,lang,isNormalizeNeeded,cutItem,t);}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_item_form__["f" /* default */],{item:item?item:null,mode:isItemEditMode?userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_9__components_item_form__["d" /* ITEM_FORM_MODE_EDIT_PARENT_DISABLED */]:__WEBPACK_IMPORTED_MODULE_9__components_item_form__["e" /* ITEM_FORM_MODE_READ */]:__WEBPACK_IMPORTED_MODULE_9__components_item_form__["b" /* ITEM_FORM_MODE_CREATE_PARENT_DISABLED */],onChange:function onChange(fields){return onItemDetailChange(fields,lang,itemsOrderAnnotationType);},annotationsConfig:annotationsConfig})));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(Item));

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Detail__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,dataLanguages:state.config.dataManagement.dataLanguages,metadataflow:state.scenes.metaManager.metadataflows.metadataflow,allAgencies:state.scenes.metaManager.metadataflows.allAgencies,downloadMetadataflowTriplets:state.scenes.metaManager.metadataflows.downloadMetadataflowTriplets,downloadMetadataflowLang:state.scenes.metaManager.metadataflows.downloadMetadataflowLang,downloadMetadataflowParams:state.scenes.metaManager.metadataflows.downloadMetadataflowParams,cloneDestTriplet:state.scenes.metaManager.metadataflows.cloneDestTriplet,metadataflowExportSourceTriplet:state.scenes.metaManager.metadataflows.metadataflowExportSourceTriplet,metadataflowExportDestination:state.scenes.metaManager.metadataflows.metadataflowExportDestination,metadataflowExportReport:state.scenes.metaManager.metadataflows.metadataflowExportReport,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_1" /* hideMetadataflowsMetadataflowDownload */])());},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["P" /* changeMetadataflowsMetadataflowDownload */])(fields));},onDownload:function onDownload(artefactTriplets,downloadMetadataflowParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["V" /* downloadMetadataflowsMetadataflow */])(artefactTriplets,downloadMetadataflowParams,lang));},onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_0" /* hideMetadataflowsMetadataflowClone */])());},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["O" /* changeMetadataflowsMetadataflowClone */])(fields));},onCloneSubmit:function onCloneSubmit(cloneDestTriplet,srcMetadataflow,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_22" /* submitMetadataflowsMetadataflowClone */])(cloneDestTriplet,srcMetadataflow,annotationsConfig));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_2" /* hideMetadataflowsMetadataflowExport */])());},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["Q" /* changeMetadataflowsMetadataflowExport */])(fields));},onExportSubmit:function onExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_23" /* submitMetadataflowsMetadataflowExport */])(sourceTriplet,destination));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["_3" /* hideMetadataflowsMetadataflowExportReport */])());}};};var Metadataflows=function Metadataflows(_ref){var t=_ref.t,endpoints=_ref.endpoints,endpointId=_ref.endpointId,dataLanguages=_ref.dataLanguages,metadataflow=_ref.metadataflow,allAgencies=_ref.allAgencies,downloadMetadataflowTriplets=_ref.downloadMetadataflowTriplets,downloadMetadataflowLang=_ref.downloadMetadataflowLang,downloadMetadataflowParams=_ref.downloadMetadataflowParams,onDownloadHide=_ref.onDownloadHide,onDownloadChange=_ref.onDownloadChange,onDownload=_ref.onDownload,cloneDestTriplet=_ref.cloneDestTriplet,onCloneHide=_ref.onCloneHide,onCloneChange=_ref.onCloneChange,onCloneSubmit=_ref.onCloneSubmit,metadataflowExportSourceTriplet=_ref.metadataflowExportSourceTriplet,metadataflowExportDestination=_ref.metadataflowExportDestination,onExportHide=_ref.onExportHide,onExportChange=_ref.onExportChange,onExportSubmit=_ref.onExportSubmit,metadataflowExportReport=_ref.metadataflowExportReport,user=_ref.user,onExportReportHide=_ref.onExportReportHide;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Detail__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:downloadMetadataflowTriplets!==null&&downloadMetadataflowTriplets!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){return onDownload(downloadMetadataflowTriplets,downloadMetadataflowParams,downloadMetadataflowLang);},type:"primary",disabled:downloadMetadataflowParams&&downloadMetadataflowParams.format===null||downloadMetadataflowParams&&downloadMetadataflowParams.format===__WEBPACK_IMPORTED_MODULE_14__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadMetadataflowParams.csvSeparator===null||downloadMetadataflowParams.csvSeparator.length!==1||downloadMetadataflowParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_SM"],title:downloadMetadataflowTriplets&&downloadMetadataflowTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadMetadataflowTriplets?Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadMetadataflowTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadMetadataflowParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_14__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadMetadataflowTriplets&&downloadMetadataflowTriplets.length>1?__WEBPACK_IMPORTED_MODULE_14__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_14__constants_download__["j" /* ARTEFACT_TYPE_METADATAFLOW */]),langs:dataLanguages,hasReferences:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(cloneDestTriplet,metadataflow,endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations);}},type:"primary"},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:metadataflow,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:metadataflowExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_17__utils_artefactValidators__["e" /* isExportDestinationValid */])(metadataflowExportDestination,(user&&user.providerId)!==null)){onExportSubmit(metadataflowExportSourceTriplet,metadataflowExportDestination);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__["b" /* default */],{type:"metadataflow",agencies:allAgencies,sourceTriplet:metadataflowExportSourceTriplet,destination:metadataflowExportDestination,onChange:onExportChange})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:metadataflowExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_artefact_export_report__["a" /* default */],{report:metadataflowExportReport})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(Metadataflows));

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artefact_ownership_modal__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions,metadataflows:state.scenes.metaManager.metadataflows.metadataflows,metadataflowAnnotations:state.scenes.metaManager.metadataflows.metadataflowAnnotations,metadataflowAnnotationTriplet:state.scenes.metaManager.metadataflows.metadataflowAnnotationTriplet,metadataflowOwnershipMetadataflowTripletStr:state.scenes.metaManager.metadataflows.metadataflowOwnershipMetadataflowTripletStr,metadataflowOwnershipUsers:state.scenes.metaManager.metadataflows.metadataflowOwnershipUsers,metadataflowOwnershipOwners:state.scenes.metaManager.metadataflows.metadataflowOwnershipOwners,parentsAndChildren:state.scenes.metaManager.metadataflows.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCreate:function onCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["S" /* createMetadataflowsMetadataflow */])());},onDetail:function onDetail(metadataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["W" /* editMetadataflowsMetadataflow */])(metadataflowTriplet));},fetchMetadataflows:function fetchMetadataflows(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_9" /* readMetadataflowsListMetadataflows */])());},onDelete:function onDelete(metadataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["T" /* deleteMetadataflowsMetadataflow */])(metadataflowTriplet));},onAnnotationsShow:function onAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_14" /* showMetadataflowsDetailAnnotations */])(annotations,triplet));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["Y" /* hideMetadataflowsDetailAnnotations */])());},onSelectedMetadataflowsDelete:function onSelectedMetadataflowsDelete(metadataflowTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["U" /* deleteMetadataflowsSelectedMetadataflows */])(metadataflowTriplets));},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_17" /* showMetadataflowsMetadataflowDownload */])(artefactTriplets,lang));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_16" /* showMetadataflowsMetadataflowClone */])(artefactTriplet));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_18" /* showMetadataflowsMetadataflowExport */])(sourceTriplet));},onOwnershipShow:function onOwnershipShow(dataflowTripletStr){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_19" /* showMetadataflowsMetadataflowOwnership */])(dataflowTripletStr));},onOwnershipHide:function onOwnershipHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_4" /* hideMetadataflowsMetadataflowOwnership */])());},fetchOwnershipUsers:function fetchOwnershipUsers(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_11" /* readMetadataflowsMetadataflowOwnershipUsersRead */])());},fetchOwnershipOwners:function fetchOwnershipOwners(metadataflowTripletStr){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_10" /* readMetadataflowsMetadataflowOwnershipOwnersRead */])(metadataflowTripletStr));},onOwnershipOwnersChange:function onOwnershipOwnersChange(owners){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["R" /* changeMetadataflowsMetadataflowOwnershipOwners */])(owners));},onOwnershipSubmit:function onOwnershipSubmit(dataflowTripletStr,owners){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_24" /* submitMetadataflowsMetadataflowOwnership */])(dataflowTripletStr,owners));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_12" /* readMetadataflowsMetadataflowParentsAndChildren */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_5" /* hideMetadataflowsMetadataflowParentsAndChildren */])());}};};var MetadataflowsList=function MetadataflowsList(_ref){var metadataflows=_ref.metadataflows,permissions=_ref.permissions,onCreate=_ref.onCreate,onDetail=_ref.onDetail,fetchMetadataflows=_ref.fetchMetadataflows,onDelete=_ref.onDelete,metadataflowAnnotations=_ref.metadataflowAnnotations,metadataflowAnnotationTriplet=_ref.metadataflowAnnotationTriplet,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onSelectedMetadataflowsDelete=_ref.onSelectedMetadataflowsDelete,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow,metadataflowOwnershipMetadataflowTripletStr=_ref.metadataflowOwnershipMetadataflowTripletStr,metadataflowOwnershipUsers=_ref.metadataflowOwnershipUsers,metadataflowOwnershipOwners=_ref.metadataflowOwnershipOwners,onOwnershipShow=_ref.onOwnershipShow,onOwnershipHide=_ref.onOwnershipHide,fetchOwnershipUsers=_ref.fetchOwnershipUsers,fetchOwnershipOwners=_ref.fetchOwnershipOwners,onOwnershipOwnersChange=_ref.onOwnershipOwnersChange,onOwnershipSubmit=_ref.onOwnershipSubmit,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchMetadataflows,disabled:metadataflows!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_artefact_list__["a" /* default */],{artefacts:metadataflows,onDetailShow:onDetail,onCreate:onCreate,onDownloadShow:onDownloadShow,onCloneShow:onCloneShow,onExportShow:onExportShow,onDelete:onDelete,onSelectedItemDelete:onSelectedMetadataflowsDelete,onAnnotationsShow:onAnnotationsShow,onOwnershipShow:onOwnershipShow,ownershipPermissions:permissions?permissions.metadataflowOwner:null,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("metadataflow",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__["a" /* default */],{annotations:metadataflowAnnotations,onClose:onAnnotationsHide,title:metadataflowAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(metadataflowAnnotationTriplet):null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_artefact_ownership_modal__["a" /* default */],{isVisible:metadataflowOwnershipMetadataflowTripletStr!==null,id:metadataflowOwnershipMetadataflowTripletStr,onClose:onOwnershipHide,users:metadataflowOwnershipUsers,owners:metadataflowOwnershipOwners,fetchUsers:fetchOwnershipUsers,fetchOwners:function fetchOwners(){return fetchOwnershipOwners(metadataflowOwnershipMetadataflowTripletStr);},onOwnersChange:onOwnershipOwnersChange,onSubmit:function onSubmit(){return onOwnershipSubmit(metadataflowOwnershipMetadataflowTripletStr,metadataflowOwnershipOwners);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(MetadataflowsList));

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__ = __webpack_require__(29);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{nodes:state.config.nodes,nodeId:state.app.endpointId,appLanguage:state.app.language,isVisible:state.scenes.metaManager.metadataflows.isDetailVisible,metadataflowTriplet:state.scenes.metaManager.metadataflows.metadataflowTriplet,isMetadataflowValid:state.scenes.metaManager.metadataflows.isMetadataflowValid,isAgenciesValid:state.scenes.metaManager.metadataflows.isAgenciesValid,isMetadataflowGeneralTabDirty:state.scenes.metaManager.metadataflows.isMetadataflowGeneralTabDirty,metadataflow:state.scenes.metaManager.metadataflows.metadataflow,agencies:state.scenes.metaManager.metadataflows.agencies,msds:state.scenes.metaManager.metadataflows.msds,isMsdsListVisible:state.scenes.metaManager.metadataflows.isMsdsListVisible,permissions:state.app.user.permissions};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDetailHide:function onDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["X" /* hideMetadataflowsDetail */])());},onDetailChange:function onDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["N" /* changeMetadataflowsDetailMetadataflow */])(fields));},onDetailCreate:function onDetailCreate(metadataflow){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_20" /* submitMetadataflowsDetailMetadataflowCreate */])(metadataflow));},onDetailUpdate:function onDetailUpdate(metadataflow,keepModalOpen){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_21" /* submitMetadataflowsDetailMetadataflowUpdate */])(metadataflow,keepModalOpen));},fetchMetadataflow:function fetchMetadataflow(metadataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_7" /* readMetadataflowsDetailMetadataflow */])(metadataflowTriplet));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_6" /* readMetadataflowsDetailAgencies */])(allowedAgencies));},onMsdsShow:function onMsdsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_15" /* showMetadataflowsDetailMsds */])());},onMsdsHide:function onMsdsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["Z" /* hideMetadataflowsDetailMsds */])());},fetchMsds:function fetchMsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_8" /* readMetadataflowsDetailMsds */])());},onMsdSet:function onMsdSet(msdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_13" /* setMetadataflowsDetailMsd */])(msdTriplet));},onMsdUnset:function onMsdUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_25" /* unsetMetadataflowsDetailMsd */])());},onDownloadShow:function onDownloadShow(metadataflowTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_17" /* showMetadataflowsMetadataflowDownload */])(metadataflowTriplets,lang));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_16" /* showMetadataflowsMetadataflowClone */])(artefactTriplet));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["_18" /* showMetadataflowsMetadataflowExport */])(sourceTriplet));}};};var selector=function selector(t,onMsdsShow,onMsdUnset,disabled){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_selector__["a" /* default */],{disabled:disabled,selectTitle:t('commons.artefact.tabs.general.msd.selector.select.title'),resetTitle:t('commons.artefact.tabs.general.msd.selector.reset.title'),onSelect:onMsdsShow,onReset:onMsdUnset});};var MetadataflowsDetail=function MetadataflowsDetail(_ref){var t=_ref.t,nodes=_ref.nodes,nodeId=_ref.nodeId,appLanguage=_ref.appLanguage,isVisible=_ref.isVisible,metadataflowTriplet=_ref.metadataflowTriplet,isMetadataflowValid=_ref.isMetadataflowValid,isAgenciesValid=_ref.isAgenciesValid,isMetadataflowGeneralTabDirty=_ref.isMetadataflowGeneralTabDirty,metadataflow=_ref.metadataflow,agencies=_ref.agencies,onDetailHide=_ref.onDetailHide,onDetailChange=_ref.onDetailChange,onDetailCreate=_ref.onDetailCreate,onDetailUpdate=_ref.onDetailUpdate,fetchMetadataflow=_ref.fetchMetadataflow,fetchAgencies=_ref.fetchAgencies,msds=_ref.msds,isMsdsListVisible=_ref.isMsdsListVisible,onMsdsShow=_ref.onMsdsShow,onMsdsHide=_ref.onMsdsHide,fetchMsds=_ref.fetchMsds,onMsdSet=_ref.onMsdSet,onMsdUnset=_ref.onMsdUnset,permissions=_ref.permissions,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow;var userHasPermissionsToEdit=permissions&&metadataflowTriplet&&permissions.agencies.filter(function(agency){return agency===metadataflowTriplet.agencyID;}).length>0;var _useState=Object(__WEBPACK_IMPORTED_MODULE_12_react__["useState"])("general"),_useState2=_slicedToArray(_useState,2),tab=_useState2[0],setTab=_useState2[1];return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchMetadataflow,cbParam:metadataflowTriplet,disabled:isMetadataflowValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:isAgenciesValid},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_XL"],title:metadataflowTriplet!==null?userHasPermissionsToEdit?t('scenes.metaManager.metadataflows.detail.title.editMode.title',{triplet:metadataflowTriplet}):t('scenes.metaManager.metadataflows.detail.title.viewMode.title',{triplet:metadataflowTriplet}):t('scenes.metaManager.metadataflows.detail.title.createMode.title'),onCancel:onDetailHide,footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onDetailHide},t('commons.buttons.close.title')),metadataflowTriplet===null||userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["a" /* isArtefactValid */])(metadataflow)){if(metadataflowTriplet!==null){onDetailUpdate(metadataflow);}else{onDetailCreate(metadataflow);}}else{__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return metadataflowTriplet?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,permissions&&!userHasPermissionsToEdit&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],justify:"end"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onDownloadShow([metadataflowTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){return onCloneShow(metadataflowTriplet);}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onExportShow(metadataflowTriplet);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a,{activeKey:tab,onTabClick:function onTabClick(key){if(!Object(__WEBPACK_IMPORTED_MODULE_22__utils_artefactValidators__["a" /* isArtefactValid */])(metadataflow)){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{setTab(key);if(key==="categorisations"){__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.error({title:t('errors.notImplemented')});}if(isMetadataflowGeneralTabDirty){onDetailUpdate(metadataflow,true);}}}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'general',tab:t('commons.artefact.tabs.general.title')},metadataflow&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:metadataflow,mode:userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],agencies:agencies,onChange:onDetailChange,MSDInput:selector(t,onMsdsShow,onMsdUnset,true)})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tabs___default.a.TabPane,{key:'categorisations',tab:t('commons.artefact.tabs.categorisations.title')}))):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["d" /* default */],{artefact:metadataflow,mode:__WEBPACK_IMPORTED_MODULE_19__components_artefact_form__["a" /* ARTEFACT_FORM_MODE_CREATE */],agencies:agencies,onChange:onDetailChange,MSDInput:selector(t,onMsdsShow,onMsdUnset,false)});})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_enhanced_modal__["a" /* default */],{visible:isMsdsListVisible,onCancel:onMsdsHide,title:t('commons.artefact.tabs.general.msd.modals.msdList.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:onMsdsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__hocs_call__["a" /* default */],{cb:fetchMsds},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_artefact_list__["a" /* default */],{artefacts:msds,onRowClick:function onRowClick(_ref2){var id=_ref2.id,agencyID=_ref2.agencyID,version=_ref2.version;return onMsdSet({id:id,agencyID:agencyID,version:version});},getIsDisabledRow:function getIsDisabledRow(_ref3){var isFinal=_ref3.isFinal;return!isFinal;}})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(MetadataflowsDetail));

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DsdList__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UpgradedDsdsList__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_components_redux_dsd_detail_modal__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{dsdDetail:state.scenes.dataManager.upgradeDsd.dsdDetail,dataflows:state.scenes.dataManager.upgradeDsd.dataflows,dataflowsDsdTriplet:state.scenes.dataManager.upgradeDsd.dataflowsDsdTriplet};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDataflowsHide:function onDataflowsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["z" /* hideUpgradeDsdDataflows */])());}};};var UpgradeDSD=function UpgradeDSD(_ref){var t=_ref.t,dsdDetail=_ref.dsdDetail,dataflows=_ref.dataflows,dataflowsDsdTriplet=_ref.dataflowsDsdTriplet,onDataflowsHide=_ref.onDataflowsHide;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DsdList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__UpgradedDsdsList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__redux_components_redux_dsd_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_12__reducer__["b" /* DM_UPGRADE_DSD_DSD_DETAIL_PREFIX */],instanceState:dsdDetail}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_enhanced_modal__["a" /* default */],{visible:dataflows!==null,onCancel:onDataflowsHide,title:t('scenes.dataManager.upgradeDsd.modals.dataflowList.title',{triplet:dataflowsDsdTriplet?Object(__WEBPACK_IMPORTED_MODULE_14__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dataflowsDsdTriplet):""}),withDataLanguageSelector:true,width:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onDataflowsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_infinite_scroll_table__["a" /* default */],{data:(dataflows||[]).sort(function(a,b){return a.id.localeCompare(b.id);}),getRowKey:function getRowKey(_ref2){var id=_ref2.id,agency=_ref2.agency,version=_ref2.version;return id+"+"+agency+"+"+version;},columns:[{title:t('data.artefact.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.agencyID.shortLabel'),dataIndex:'agency',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.name.shortLabel'),dataIndex:'names',minWidth:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.artefact.version.shortLabel'),dataIndex:'version',widthToContent:true,withValuesFilter:true}],multilangStrDataIndexes:["names"]})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(UpgradeDSD));

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_infinite_scroll_table__ = __webpack_require__(52);
var mapStateToProps=function mapStateToProps(state){return{dsds:state.scenes.dataManager.upgradeDsd.dsds};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchDsds:function fetchDsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["G" /* readUpgradeDsdDsds */])());},onDetailShow:function onDetailShow(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_10__redux_components_redux_dsd_detail_modal_actions__["_72" /* showDsdDetail */])(dsdTriplet),__WEBPACK_IMPORTED_MODULE_11__reducer__["b" /* DM_UPGRADE_DSD_DSD_DETAIL_PREFIX */]));},onUpgradedDsdsShow:function onUpgradedDsdsShow(dsdTripelt){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["M" /* showUpgradeDsdUpgradedDsds */])(dsdTripelt));},onDataflowListShow:function onDataflowListShow(dsdTriplet,dataflows){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["J" /* showUpgradeDsdDataflows */])(dsdTriplet,dataflows));}};};var DsdsList=function DsdsList(_ref){var t=_ref.t,dsds=_ref.dsds,fetchDsds=_ref.fetchDsds,onDetailShow=_ref.onDetailShow,onUpgradedDsdsShow=_ref.onUpgradedDsdsShow,onDataflowListShow=_ref.onDataflowListShow;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__hocs_call__["a" /* default */],{cb:fetchDsds,disabled:dsds!==null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_infinite_scroll_table__["a" /* default */],{data:(dsds||[]).sort(function(a,b){return a.id.localeCompare(b.id);}),getRowKey:function getRowKey(_ref2){var id=_ref2.id,agency=_ref2.agency,version=_ref2.version;return id+"+"+agency+"+"+version;},columns:[{title:t('data.artefact.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.agencyID.shortLabel'),dataIndex:'agency',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.name.shortLabel'),dataIndex:'names',minWidth:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.artefact.version.shortLabel'),dataIndex:'version',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.isFinal.shortLabel'),dataIndex:"isFinal",width:30,withValuesFilter:true,render:function render(isFinal){return isFinal?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:"check"}):null;},renderText:function renderText(isFinal){return isFinal?t('data.artefact.isFinal.values.final'):t('data.artefact.isFinal.values.notFinal');}}],multilangStrDataIndexes:["names"],actions:[Object.assign({},__WEBPACK_IMPORTED_MODULE_8__styles_buttons__["l" /* BUTTON_DETAIL */],{title:t('commons.actions.detailReadOnly.title'),onClick:function onClick(_ref3){var id=_ref3.id,agency=_ref3.agency,version=_ref3.version;return onDetailShow({id:id,agencyID:agency,version:version});}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_8__styles_buttons__["i" /* BUTTON_DATAFLOW_LIST */],{title:t('commons.actions.dataflowList.title'),onClick:function onClick(_ref4){var id=_ref4.id,agency=_ref4.agency,version=_ref4.version,dataflows=_ref4.dataflows;return onDataflowListShow({id:id,agencyID:agency,version:version},dataflows);}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_8__styles_buttons__["o" /* BUTTON_DSD_UPGRADE */],{title:t('commons.actions.upgradeDsd.title'),onClick:function onClick(_ref5){var id=_ref5.id,agency=_ref5.agency,version=_ref5.version;return onUpgradedDsdsShow({id:id,agencyID:agency,version:version});}})]}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DsdsList));

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_dsds_compare_report__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_file_input__ = __webpack_require__(96);
var IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS="Success";var IMPORT_STRUCTURES_REPORT_STATUS_WARNING="Warning";var IMPORT_STRUCTURES_REPORT_STATUS_ERROR="Error";var IMPORT_STRUCTURES_REPORT_STATUS_FAILURE="Failure";var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,appLanguage:state.app.language,isUpgradedDsdsVisible:state.scenes.dataManager.upgradeDsd.isUpgradedDsdsVisible,sourceDsdTriplet:state.scenes.dataManager.upgradeDsd.sourceDsdTriplet,targetDsdTriplet:state.scenes.dataManager.upgradeDsd.targetDsdTriplet,upgradedDsds:state.scenes.dataManager.upgradeDsd.upgradedDsds,isCompareReportVisible:state.scenes.dataManager.upgradeDsd.isCompareReportVisible,compareReport:state.scenes.dataManager.upgradeDsd.compareReport,isUpgradeVisible:state.scenes.dataManager.upgradeDsd.isUpgradeVisible,upgradeReport:state.scenes.dataManager.upgradeDsd.upgradeReport,codelistCompareReport:state.scenes.dataManager.upgradeDsd.codelistCompareReport,codelistDetail:state.scenes.dataManager.upgradeDsd.codelistDetail,isImportDsdVisible:state.scenes.dataManager.upgradeDsd.isImportDsdVisible,dsdFile:state.scenes.dataManager.upgradeDsd.dsdFile,isImportEnabled:state.scenes.dataManager.upgradeDsd.isImportEnabled,importDsdHash:state.scenes.dataManager.upgradeDsd.importDsdHash,importDsdItems:state.scenes.dataManager.upgradeDsd.importDsdItems,importDsdReport:state.scenes.dataManager.upgradeDsd.importDsdReport};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchUpgradedDsds:function fetchUpgradedDsds(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["H" /* readUpgradeDsdUpgradedDsds */])(dsdTriplet));},onUpgradedDsdsHide:function onUpgradedDsdsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["E" /* hideUpgradeDsdUpgradedDsds */])());},onDsdsCompare:function onDsdsCompare(_ref){var sourceDsdTriplet=_ref.sourceDsdTriplet,targetDsdTriplet=_ref.targetDsdTriplet,showModal=_ref.showModal;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["w" /* compareUpgradeDsdDsds */])(sourceDsdTriplet,targetDsdTriplet,showModal));},onDsdsCompareHide:function onDsdsCompareHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["B" /* hideUpgradeDsdDsdsCompare */])());},onDsdUpgradeShow:function onDsdUpgradeShow(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["K" /* showUpgradeDsdDsdUpgrade */])(dsdTriplet));},onDsdUpgrade:function onDsdUpgrade(compareReport){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["Q" /* upgradeUpgradeDsdDsd */])(compareReport));},onDsdUpgradeHide:function onDsdUpgradeHide(success){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["A" /* hideUpgradeDsdDsdUpgrade */])(success));},fetchCodelistCompareReport:function fetchCodelistCompareReport(sourceCodelistTriplet,targetCodelistTriplet,_,targetFile){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["F" /* readUpgradeDsdCodelistCompareReport */])(sourceCodelistTriplet,targetCodelistTriplet,targetFile));},onCodelistCompareReportHide:function onCodelistCompareReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["y" /* hideUpgradeDsdCodelistCompareReport */])());},onCodelistDetailShow:function onCodelistDetailShow(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_31__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_32__redux_components_redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_30__reducer__["a" /* DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX */]));},onImportDsdShow:function onImportDsdShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["L" /* showUpgradeDsdImportDsd */])());},onImportDsdHide:function onImportDsdHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["C" /* hideUpgradeDsdImportDsd */])());},onFileSet:function onFileSet(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["I" /* setUpgradeDsdImportDsdFile */])(file));},onDsdImportDsdsCompare:function onDsdImportDsdsCompare(_ref2){var sourceDsdTriplet=_ref2.sourceDsdTriplet,dsdFile=_ref2.dsdFile,showModal=_ref2.showModal;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["O" /* submitUpgradeDsdImportDsdDsdsCompare */])(sourceDsdTriplet,dsdFile,showModal));},onDsdsCompareDownload:function onDsdsCompareDownload(srcTriplet,targetTriplet,targetFile,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["x" /* downloadUpgradeDsdImportDsdDsdsCompare */])(srcTriplet,targetTriplet,targetFile,lang));},onImportDsdStart:function onImportDsdStart(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["N" /* startUpgradeDsdImportDsdImport */])());},onImportDsdFileUpload:function onImportDsdFileUpload(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["R" /* uploadUpgradeDsdImportDsdFile */])(file));},onImportDsdFileSubmit:function onImportDsdFileSubmit(_ref3){var importDsdItems=_ref3.importDsdItems,importDsdHash=_ref3.importDsdHash;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["P" /* submitUpgradeDsdImportDsdFile */])(importDsdItems,importDsdHash));},onImportDsdImportHide:function onImportDsdImportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["D" /* hideUpgradeDsdImportDsdReport */])());}};};var getColSpan=function getColSpan(upgradeReport){return __WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_FULL"]/__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.pickBy(Object.assign({},upgradeReport,{deleted:undefined}),function(arr){return arr&&arr.length>0;})).length;};var UpgradedDsdsList=function UpgradedDsdsList(_ref4){var t=_ref4.t,nodeId=_ref4.nodeId,nodes=_ref4.nodes,appLanguage=_ref4.appLanguage,isUpgradedDsdsVisible=_ref4.isUpgradedDsdsVisible,sourceDsdTriplet=_ref4.sourceDsdTriplet,targetDsdTriplet=_ref4.targetDsdTriplet,upgradedDsds=_ref4.upgradedDsds,isCompareReportVisible=_ref4.isCompareReportVisible,compareReport=_ref4.compareReport,isUpgradeVisible=_ref4.isUpgradeVisible,upgradeReport=_ref4.upgradeReport,codelistCompareReport=_ref4.codelistCompareReport,codelistDetail=_ref4.codelistDetail,isImportDsdVisible=_ref4.isImportDsdVisible,dsdFile=_ref4.dsdFile,isImportEnabled=_ref4.isImportEnabled,importDsdHash=_ref4.importDsdHash,importDsdItems=_ref4.importDsdItems,importDsdReport=_ref4.importDsdReport,fetchUpgradedDsds=_ref4.fetchUpgradedDsds,onUpgradedDsdsHide=_ref4.onUpgradedDsdsHide,onDsdsCompare=_ref4.onDsdsCompare,onDsdsCompareHide=_ref4.onDsdsCompareHide,onDsdUpgradeShow=_ref4.onDsdUpgradeShow,onDsdUpgrade=_ref4.onDsdUpgrade,onDsdUpgradeHide=_ref4.onDsdUpgradeHide,fetchCodelistCompareReport=_ref4.fetchCodelistCompareReport,onCodelistCompareReportHide=_ref4.onCodelistCompareReportHide,_onCodelistDetailShow=_ref4.onCodelistDetailShow,onImportDsdShow=_ref4.onImportDsdShow,onImportDsdHide=_ref4.onImportDsdHide,onFileSet=_ref4.onFileSet,onDsdImportDsdsCompare=_ref4.onDsdImportDsdsCompare,onDsdsCompareDownload=_ref4.onDsdsCompareDownload,onImportDsdStart=_ref4.onImportDsdStart,onImportDsdFileUpload=_ref4.onImportDsdFileUpload,onImportDsdFileSubmit=_ref4.onImportDsdFileSubmit,onImportDsdImportHide=_ref4.onImportDsdImportHide;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;var importDsdSelectedItems=(importDsdItems||[]).filter(function(_ref5){var isOk=_ref5.isOk;return isOk;});return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchUpgradedDsds,cbParam:sourceDsdTriplet,disabled:!sourceDsdTriplet||upgradedDsds!==null},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_enhanced_modal__["a" /* default */],{visible:isUpgradedDsdsVisible,onCancel:onUpgradedDsdsHide,title:t('scenes.dataManager.upgradeDsd.modals.upgradedDsdList.title',{triplet:sourceDsdTriplet?Object(__WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(sourceDsdTriplet):""}),withDataLanguageSelector:true,width:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{onClick:onUpgradedDsdsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_infinite_scroll_table__["a" /* default */],{data:upgradedDsds||[],getRowKey:function getRowKey(_ref6){var id=_ref6.id,agency=_ref6.agency,version=_ref6.version;return id+"+"+agency+"+"+version;},columns:[{title:t('data.artefact.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.artefact.agencyID.shortLabel'),dataIndex:'agency',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.name.shortLabel'),dataIndex:'names',minWidth:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.artefact.version.shortLabel'),dataIndex:'version',widthToContent:true,withValuesFilter:true},{title:t('data.artefact.isFinal.shortLabel'),dataIndex:"isFinal",width:30,withValuesFilter:true,render:function render(isFinal){return isFinal?__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"check"}):null;},renderText:function renderText(isFinal){return isFinal?t('data.artefact.isFinal.values.final'):t('data.artefact.isFinal.values.notFinal');}}],multilangStrDataIndexes:["names"],actions:[Object.assign({},__WEBPACK_IMPORTED_MODULE_27__styles_buttons__["n" /* BUTTON_DSD_COMPARE */],{title:t('commons.actions.compareDsds.title'),onClick:function onClick(_ref7){var id=_ref7.id,agency=_ref7.agency,version=_ref7.version;return onDsdsCompare({sourceDsdTriplet:sourceDsdTriplet,targetDsdTriplet:{id:id,agencyID:agency,version:version},showModal:true});}}),Object.assign({},__WEBPACK_IMPORTED_MODULE_27__styles_buttons__["o" /* BUTTON_DSD_UPGRADE */],{title:t('commons.actions.upgradeDsd.title'),onClick:function onClick(_ref8){var id=_ref8.id,agency=_ref8.agency,version=_ref8.version;return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.upgradeDsd.modals.confirms.upgrade.title',{triplet:Object(__WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agency,version:version})}),onOk:function onOk(){onDsdUpgradeShow({id:id,agencyID:agency,version:version});},cancelText:t('commons.buttons.cancel.title')});}})],rightActions:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:"primary",onClick:onImportDsdShow},t('scenes.dataManager.upgradeDsd.modals.upgradedDsdList.buttons.import.title'))}))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_enhanced_modal__["a" /* default */],{visible:isImportDsdVisible,onCancel:onImportDsdHide,title:t('scenes.dataManager.upgradeDsd.modals.importDsdFromFile.title'),withDataLanguageSelector:true,width:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MODAL_WIDTH_MD"],footer:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{onClick:onImportDsdHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:"primary",onClick:onImportDsdStart,disabled:!dsdFile},t('scenes.dataManager.upgradeDsd.modals.importDsdFromFile.importDsdInMsdb.title')))},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.Item,{label:t('scenes.dataManager.upgradeDsd.modals.importDsdFromFile.dsd.label'),className:"form-item-required",labelCol:{span:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_TWO_THIRDS"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_file_input__["a" /* default */],{value:dsdFile,accept:'.xml',onChange:function onChange(file){return onFileSet(file);}}))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"end",gutter:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onDsdImportDsdsCompare({sourceDsdTriplet:sourceDsdTriplet,dsdFile:dsdFile,showModal:true});},disabled:!dsdFile},t('scenes.dataManager.upgradeDsd.modals.importDsdFromFile.compareDsds.title')))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_enhanced_modal__["a" /* default */],{visible:isCompareReportVisible,onCancel:onDsdsCompareHide,title:t('scenes.dataManager.upgradeDsd.modals.compareDsdsReport.title'),withDataLanguageSelector:true,width:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{onClick:onDsdsCompareHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onDsdsCompareDownload(sourceDsdTriplet,targetDsdTriplet,dsdFile,appLanguage);}},t('commons.buttons.download.title')))},compareReport&&compareReport.compare===false&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a,{type:"warning",showIcon:true,message:t('scenes.dataManager.upgradeDsd.modals.compareDsdsReport.incompatibleDsds.title')}),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:10},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{value:compareReport?compareReport.sourceDsd:'',title:compareReport?compareReport.sourceDsd:'',disabled:true})),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:10},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{value:compareReport?compareReport.targetDsd:'',title:compareReport?compareReport.targetDsd:'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_dsds_compare_report__["a" /* default */],{report:compareReport,codelistDetail:codelistDetail,codelistDetailInstancePrefix:__WEBPACK_IMPORTED_MODULE_30__reducer__["a" /* DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX */],onCodelistDetailShow:function onCodelistDetailShow(triplet){return _onCodelistDetailShow(triplet,defaultItemsViewMode);},codelistCompareReport:codelistCompareReport,fetchCodelistCompareReport:fetchCodelistCompareReport,onCodelistCompareReportHide:onCodelistCompareReportHide})),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:onDsdsCompare,cbParam:{sourceDsdTriplet:sourceDsdTriplet,targetDsdTriplet:targetDsdTriplet,showModal:false},disabled:!sourceDsdTriplet||!targetDsdTriplet||isUpgradeVisible===false},compareReport&&isUpgradeVisible===true&&(compareReport.compare===false?__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('scenes.dataManager.upgradeDsd.modals.cannotUpgradeDsd.title'),onOk:function onOk(){onDsdUpgradeHide(false);},onCancel:function onCancel(){onDsdUpgradeHide(false);}});}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",null)):__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:onDsdUpgrade,cbParam:compareReport},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_enhanced_modal__["a" /* default */],{visible:upgradeReport!==null,onCancel:function onCancel(){return onDsdUpgradeHide(true);},title:t('scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.title'),withDataLanguageSelector:true,footer:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{onClick:function onClick(){return onDsdUpgradeHide(true);}},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onDsdsCompareDownload(sourceDsdTriplet,targetDsdTriplet,dsdFile,appLanguage);}},t('commons.buttons.download.title')))},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["GUTTER_MD"]},upgradeReport&&upgradeReport.upgrade&&upgradeReport.upgrade.length>0&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:getColSpan(upgradeReport)},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner",title:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["GUTTER_MD"],justify:"start"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"check-circle",theme:"filled",style:{color:'green'}})),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.updated.title"))),bodyStyle:{height:320,overflow:'auto'}},upgradeReport.upgrade.map(function(_ref9,index){var id=_ref9.id,agency=_ref9.agency,version=_ref9.version;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{key:index},Object(__WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agency,version:version}));}))),upgradeReport&&upgradeReport.reCreated&&upgradeReport.reCreated.length>0&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:getColSpan(upgradeReport)},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner",title:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["GUTTER_MD"],justify:"start"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"exclamation-circle",theme:"filled",style:{color:'orange'}})),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.notUpdated.title"))),bodyStyle:{height:320,overflow:'auto'}},upgradeReport.reCreated.map(function(_ref10,index){var id=_ref10.id,agency=_ref10.agency,version=_ref10.version;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{key:index},Object(__WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agency,version:version}));}))),upgradeReport&&upgradeReport.notChanged&&upgradeReport.notChanged.length>0&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:getColSpan(upgradeReport)},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner",title:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["GUTTER_MD"],justify:"start"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"exclamation-circle",theme:"filled",style:{color:'orange'}})),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.notChanged.title"))),bodyStyle:{height:320,overflow:'auto'}},upgradeReport.notChanged.map(function(_ref11,index){var id=_ref11.id,agency=_ref11.agency,version=_ref11.version;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{key:index},Object(__WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agency,version:version}));}))),upgradeReport&&upgradeReport.fail&&upgradeReport.fail.length>0&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:getColSpan(upgradeReport)},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner",title:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["GUTTER_MD"],justify:"start"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"close-circle",theme:"filled",style:{color:'red'}})),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.deleted.title"))),bodyStyle:{height:320,overflow:'auto'}},upgradeReport.fail.map(function(_ref12,index){var id=_ref12.id,agency=_ref12.agency,version=_ref12.version;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{key:index},Object(__WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])({id:id,agencyID:agency,version:version}));})))))))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:onDsdImportDsdsCompare,cbParam:{sourceDsdTriplet:sourceDsdTriplet,dsdFile:dsdFile,showModal:false},disabled:!sourceDsdTriplet||!dsdFile||isImportEnabled===false},compareReport&&isImportEnabled===true&&(compareReport.compare===false?__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.warning({title:t('scenes.dataManager.upgradeDsd.modals.cannotUpgradeDsd.title'),onOk:function onOk(){onImportDsdImportHide();},onCancel:function onCancel(){onImportDsdImportHide();}});}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",null)):__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:onImportDsdFileUpload,cbParam:dsdFile,disabled:!dsdFile||!!importDsdItems||!!importDsdHash},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:onImportDsdFileSubmit,cbParam:{importDsdItems:importDsdSelectedItems,importDsdHash:importDsdHash},disabled:!importDsdItems||!importDsdHash},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_enhanced_modal__["a" /* default */],{visible:importDsdReport!==null,onCancel:onImportDsdImportHide,title:t('scenes.dataManager.upgradeDsd.modals.importDsdReport.title'),footer:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{onClick:onImportDsdImportHide},t('commons.buttons.close.title'))},importDsdSelectedItems&&importDsdSelectedItems.length>0&&importDsdReport?importDsdReport.map(function(_ref13,index){var maintainableObject=_ref13.maintainableObject,status=_ref13.status,result=_ref13.result,isFinal=_ref13.isFinal;var triplet=Object(__WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(maintainableObject);return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:index>0?{marginTop:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MARGIN_MD"]}:null},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,importDsdItems.filter(function(item){return item.id===triplet.id&&item.agency===triplet.agencyID&&item.version===triplet.version;})[0].type," [",Object(__WEBPACK_IMPORTED_MODULE_28__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(triplet),"] ",__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("b",null,(isFinal?t("data.artefact.isFinal.values.final"):t("data.artefact.isFinal.values.notFinal")).toLowerCase())),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,status===IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.success')+" ",__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"check-circle",theme:"filled",style:{color:'green'}})),status===IMPORT_STRUCTURES_REPORT_STATUS_WARNING&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.warning')+" ",__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"exclamation-circle",theme:"filled",style:{color:'orange'}})),status===IMPORT_STRUCTURES_REPORT_STATUS_ERROR&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.error')+" ",__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"close-circle",theme:"filled",style:{color:'red'}})),status===IMPORT_STRUCTURES_REPORT_STATUS_FAILURE&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,t('scenes.utilities.importStructures.reportModal.status.error')+" ",__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a,{type:"close-circle",theme:"filled",style:{color:'red'}})))),status!==IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("i",null,result));}):__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",null,t("scenes.dataManager.upgradeDsd.modals.importDsdReport.nothingImported.placeholder"))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(UpgradedDsdsList));

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages};};var SPAN_COMPONENT_COL=10;var SPAN_CENTER_COL=4;var IconFontCNIcons=__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a.createFromIconfontCN({scriptUrl:'./static/vendor/iconfont_cn/iconfont.js'});var mandatoryIconStyle={type:'m',style:{transform:'scale(1.1)'},title:"Mandatory"};var getCodelistName=function getCodelistName(codelist,lang,dataLangs){return'['+codelist.id+'+'+codelist.agencyId+'+'+codelist.version+'] '+(codelist.names&&Object.keys(codelist.names).length>0?Object(__WEBPACK_IMPORTED_MODULE_16__middlewares_i18n_utils__["a" /* getLocalizedStr */])(codelist.names,lang,dataLangs):'');};var getConceptName=function getConceptName(concept){return'['+concept.id+'+'+concept.agencyId+'+'+concept.version+'] '+concept.conceptId;};var ComponentsDetailCompareTable=function ComponentsDetailCompareTable(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,commonComponentsCodelist=_ref.commonComponentsCodelist,commonComponentsConcept=_ref.commonComponentsConcept,sourceFile=_ref.sourceFile,targetFile=_ref.targetFile,fetchCodelistCompareReport=_ref.fetchCodelistCompareReport;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;var keys=__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.union(commonComponentsCodelist.map(function(_ref2){var key=_ref2.key;return key;}),commonComponentsConcept.map(function(_ref3){var key=_ref3.key;return key;}));var commonComponents=keys.map(function(key){return{key:(commonComponentsCodelist.find(function(comp){return comp.key===key;})||commonComponentsConcept.find(function(comp){return comp.key===key;})).key,mandatory:(commonComponentsCodelist.find(function(comp){return comp.key===key;})||commonComponentsConcept.find(function(comp){return comp.key===key;})).mandatory,sourceCodelist:(commonComponentsCodelist.find(function(comp){return comp.key===key;})||{}).source,targetCodelist:(commonComponentsCodelist.find(function(comp){return comp.key===key;})||{}).target,sourceConcept:(commonComponentsConcept.find(function(comp){return comp.key===key;})||{}).source,targetConcept:(commonComponentsConcept.find(function(comp){return comp.key===key;})||{}).target};});commonComponents=commonComponents.filter(function(component){return component.sourceCodelist||component.targetCodelist||component.sourceConcept||component.targetConcept;});return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,commonComponents.map(function(component,idx){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner',key:idx,title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'center',gutter:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,component.key),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,component.mandatory?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(IconFontCNIcons,mandatoryIconStyle):null)),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,(component.sourceCodelist||component.targetCodelist)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'center',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b',null,t("components.dsdsCompareReport.componentsDetailCompareTable.codelist.label")+':')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'center',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL},component.sourceCodelist&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'end'},getCodelistName(component.sourceCodelist,lang,dataLanguages))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:SPAN_CENTER_COL},component.sourceCodelist&&component.targetCodelist&&fetchCodelistCompareReport&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){return fetchCodelistCompareReport({id:component.sourceCodelist.id,agencyID:component.sourceCodelist.agencyId,version:component.sourceCodelist.version},{id:component.targetCodelist.id,agencyID:component.targetCodelist.agencyId,version:component.targetCodelist.version},sourceFile,targetFile);}},t("commons.buttons.detail.title")))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL},component.targetCodelist&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'start'},getCodelistName(component.targetCodelist,lang,dataLanguages))))),(component.sourceConcept||component.targetConcept)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'center',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('b',null,t("components.dsdsCompareReport.componentsDetailCompareTable.concept.label")+':')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'center',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL},component.sourceConcept&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'end'},getConceptName(component.sourceConcept))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:SPAN_CENTER_COL}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:SPAN_COMPONENT_COL},component.targetConcept&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'start'},getConceptName(component.targetConcept)))))));}));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps))(ComponentsDetailCompareTable));

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentsCompareTable__ = __webpack_require__(597);
var GroupsDetailCompareTable=function GroupsDetailCompareTable(_ref){var commonComponentsGroups=_ref.commonComponentsGroups;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,commonComponentsGroups&&commonComponentsGroups.map(function(group,idx){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner",key:idx,title:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"center"},group.key),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ComponentsCompareTable__["a" /* default */],{sourceComponents:(group.itemsSourceGroup||[]).map(function(group){return{key:group};}),targetComponents:(group.itemsTargetGroup||[]).map(function(group){return{key:group};})}));}));};/* harmony default export */ __webpack_exports__["a"] = (GroupsDetailCompareTable);

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submitRemoveTempTables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var REMOVE_TEMP_TABLES_SUBMIT='REMOVE_TEMP_TABLES_SUBMIT';var submitRemoveTempTables=function submitRemoveTempTables(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(REMOVE_TEMP_TABLES_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_79" /* getRemoveTempTablesUrl */])(),null,function(t){return{success:t('scenes.dataManager.removeTempTables.submit.success')};});};

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_dsds_compare_report__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__redux_components_redux_dsd_detail_modal__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__redux_components_redux_dsd_detail_modal_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducer__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_file_input__ = __webpack_require__(96);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,appLanguage:state.app.language,isSrcDsdsVisible:state.scenes.utilities.compareDsds.isSrcDsdsVisible,isTargetDsdsVisible:state.scenes.utilities.compareDsds.isTargetDsdsVisible,srcDsds:state.scenes.utilities.compareDsds.srcDsds,targetDsds:state.scenes.utilities.compareDsds.targetDsds,srcTriplet:state.scenes.utilities.compareDsds.srcTriplet,targetTriplet:state.scenes.utilities.compareDsds.targetTriplet,dsdDetail:state.scenes.utilities.compareDsds.dsdDetail,report:state.scenes.utilities.compareDsds.report,codelistDetail:state.scenes.utilities.compareDsds.codelistDetail,codelistCompareReport:state.scenes.utilities.compareDsds.codelistCompareReport,srcSource:state.scenes.utilities.compareDsds.srcSource,targetSource:state.scenes.utilities.compareDsds.targetSource,srcFile:state.scenes.utilities.compareDsds.srcFile,targetFile:state.scenes.utilities.compareDsds.targetFile};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSrcDsdsShow:function onSrcDsdsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["E" /* showCompareDsdsSrcDsds */])());},onTargetDsdsShow:function onTargetDsdsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["F" /* showCompareDsdsTargetDsds */])());},onSrcDsdsHide:function onSrcDsdsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["t" /* hideCompareDsdsSrcDsds */])());},onTargetDsdsHide:function onTargetDsdsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["u" /* hideCompareDsdsTargetDsds */])());},onSrcTripletSet:function onSrcTripletSet(srcTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["C" /* setCompareDsdsSrcTriplet */])(srcTriplet));},onTargetTripletSet:function onTargetTripletSet(srcTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["D" /* setCompareDsdsTargetTriplet */])(srcTriplet));},onSrcTripletReset:function onSrcTripletReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["z" /* resetCompareDsdsSrcTriplet */])());},onTargetTripletReset:function onTargetTripletReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["A" /* resetCompareDsdsTargetTriplet */])());},fetchSrcDsds:function fetchSrcDsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["x" /* readCompareDsdsSrcDsds */])());},fetchTargetDsds:function fetchTargetDsds(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["y" /* readCompareDsdsTargetDsds */])());},fetchCompareDsdsReport:function fetchCompareDsdsReport(srcTriplet,targetTriplet,srcFile,targetFile){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["w" /* readCompareDsdsReport */])(srcTriplet,targetTriplet,srcFile,targetFile));},fetchCodelistCompareReport:function fetchCodelistCompareReport(sourceCodelistTriplet,targetCodelistTriplet,sourceFile,targetFile){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["v" /* readCompareDsdsCodelistCompareReport */])(sourceCodelistTriplet,targetCodelistTriplet,sourceFile,targetFile));},onCodelistCompareReportHide:function onCodelistCompareReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["s" /* hideCompareDsdsCodelistCompareReport */])());},fetchDsdDetail:function fetchDsdDetail(dsdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__redux_components_redux_dsd_detail_modal_actions__["_72" /* showDsdDetail */])(dsdTriplet),__WEBPACK_IMPORTED_MODULE_25__reducer__["b" /* DM_COMPARE_DSDS_DSD_DETAIL_PREFIX */]));},onCodelistDetailShow:function onCodelistDetailShow(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_26__redux_components_redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_25__reducer__["a" /* DM_COMPARE_DSDS_CODELIST_DETAIL_PREFIX */]));},onReportDownload:function onReportDownload(srcTriplet,targetTriplet,srcFile,targetFile,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["r" /* downloadCompareDsdsReport */])(srcTriplet,targetTriplet,srcFile,targetFile,lang));},onSourceChange:function onSourceChange(source,isSrc){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["q" /* changeCompareDsdsDsdSource */])(source,isSrc));},onFileSet:function onFileSet(file,isSrc){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["B" /* setCompareDsdsDsdFile */])(file,isSrc));}};};var CompareDsds=function CompareDsds(_ref){var t=_ref.t,nodeId=_ref.nodeId,nodes=_ref.nodes,appLanguage=_ref.appLanguage,dsdDetail=_ref.dsdDetail,isSrcDsdsVisible=_ref.isSrcDsdsVisible,isTargetDsdsVisible=_ref.isTargetDsdsVisible,srcDsds=_ref.srcDsds,targetDsds=_ref.targetDsds,srcTriplet=_ref.srcTriplet,targetTriplet=_ref.targetTriplet,report=_ref.report,codelistDetail=_ref.codelistDetail,codelistCompareReport=_ref.codelistCompareReport,srcSource=_ref.srcSource,targetSource=_ref.targetSource,srcFile=_ref.srcFile,targetFile=_ref.targetFile,onSrcDsdsShow=_ref.onSrcDsdsShow,onTargetDsdsShow=_ref.onTargetDsdsShow,onSrcDsdsHide=_ref.onSrcDsdsHide,onTargetDsdsHide=_ref.onTargetDsdsHide,onSrcTripletSet=_ref.onSrcTripletSet,onSrcTripletReset=_ref.onSrcTripletReset,onTargetTripletSet=_ref.onTargetTripletSet,onTargetTripletReset=_ref.onTargetTripletReset,fetchSrcDsds=_ref.fetchSrcDsds,fetchTargetDsds=_ref.fetchTargetDsds,fetchCompareDsdsReport=_ref.fetchCompareDsdsReport,fetchCodelistCompareReport=_ref.fetchCodelistCompareReport,onCodelistCompareReportHide=_ref.onCodelistCompareReportHide,fetchDsdDetail=_ref.fetchDsdDetail,_onCodelistDetailShow=_ref.onCodelistDetailShow,onReportDownload=_ref.onReportDownload,onSourceChange=_ref.onSourceChange,onFileSet=_ref.onFileSet;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_enhanced_modal__["a" /* default */],{visible:isSrcDsdsVisible,onCancel:onSrcDsdsHide,title:t('scenes.utilities.compareDsds.sourceDsdSelector.modal.title'),width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onSrcDsdsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchSrcDsds},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_list__["a" /* default */],{artefacts:srcDsds,onRowClick:onSrcTripletSet,onDetailShow:fetchDsdDetail}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_enhanced_modal__["a" /* default */],{visible:isTargetDsdsVisible,onCancel:onTargetDsdsHide,title:t('scenes.utilities.compareDsds.sourceDsdSelector.modal.title'),width:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onTargetDsdsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchTargetDsds},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_artefact_list__["a" /* default */],{artefacts:targetDsds,onRowClick:onTargetTripletSet,onDetailShow:fetchDsdDetail}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'end',gutter:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',disabled:!((srcTriplet||srcFile)&&(targetTriplet||targetFile)),onClick:function onClick(){return fetchCompareDsdsReport(srcTriplet,targetTriplet,srcFile,targetFile);}},t('scenes.utilities.compareDsds.compareButton.title'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',disabled:!((srcTriplet||srcFile)&&(targetTriplet||targetFile)),onClick:function onClick(){return onReportDownload(srcTriplet,targetTriplet,srcFile,targetFile,appLanguage);}},t('scenes.utilities.compareDsds.generateReport.title')))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',gutter:48},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{style:{width:140}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group,{value:srcSource,onChange:function onChange(_ref2){var target=_ref2.target;return onSourceChange(target.value,true);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_25__reducer__["c" /* DM_COMPARE_DSDS_SOURCE_MSDB */],style:{width:70,textAlign:"center"}},'MSDB'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_25__reducer__["d" /* DM_COMPARE_DSDS_SOURCE_XML */],style:{width:70,textAlign:"center"}},'XML'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{style:{width:"calc(100% - 144px)"}},srcSource===__WEBPACK_IMPORTED_MODULE_25__reducer__["c" /* DM_COMPARE_DSDS_SOURCE_MSDB */]?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_selector__["a" /* default */],{value:srcTriplet&&Object(__WEBPACK_IMPORTED_MODULE_20__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(srcTriplet),selectTitle:t('scenes.utilities.compareDsds.sourceDsdSelector.selectButton.title'),resetTitle:t('scenes.utilities.compareDsds.sourceDsdSelector.resetButton.title'),detailTitle:t('scenes.utilities.compareDsds.sourceDsdSelector.detailButton.title'),onSelect:onSrcDsdsShow,onReset:onSrcTripletReset,onDetail:function onDetail(){return fetchDsdDetail(srcTriplet);}}):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_file_input__["a" /* default */],{value:srcFile,accept:'.xml',onChange:function onChange(file){return onFileSet(file,true);}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{style:{width:140}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group,{value:targetSource,onChange:function onChange(_ref3){var target=_ref3.target;return onSourceChange(target.value,false);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_25__reducer__["c" /* DM_COMPARE_DSDS_SOURCE_MSDB */],style:{width:70,textAlign:"center"}},'MSDB'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_25__reducer__["d" /* DM_COMPARE_DSDS_SOURCE_XML */],style:{width:70,textAlign:"center"}},'XML'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{style:{width:"calc(100% - 144px)"}},targetSource===__WEBPACK_IMPORTED_MODULE_25__reducer__["c" /* DM_COMPARE_DSDS_SOURCE_MSDB */]?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_selector__["a" /* default */],{value:targetTriplet&&Object(__WEBPACK_IMPORTED_MODULE_20__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(targetTriplet),selectTitle:t('scenes.utilities.compareDsds.targetDsdSelector.selectButton.title'),resetTitle:t('scenes.utilities.compareDsds.targetDsdSelector.resetButton.title'),detailTitle:t('scenes.utilities.compareDsds.sourceDsdSelector.detailButton.title'),onSelect:onTargetDsdsShow,onReset:onTargetTripletReset,onDetail:function onDetail(){return fetchDsdDetail(targetTriplet);}}):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_file_input__["a" /* default */],{value:targetFile,accept:'.xml',onChange:function onChange(file){return onFileSet(file,false);}})))))),report&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_dsds_compare_report__["a" /* default */],{report:report,codelistDetail:codelistDetail,codelistDetailInstancePrefix:__WEBPACK_IMPORTED_MODULE_25__reducer__["a" /* DM_COMPARE_DSDS_CODELIST_DETAIL_PREFIX */],onCodelistDetailShow:function onCodelistDetailShow(triplet){return _onCodelistDetailShow(triplet,defaultItemsViewMode);},codelistCompareReport:codelistCompareReport,fetchCodelistCompareReport:fetchCodelistCompareReport,onCodelistCompareReportHide:onCodelistCompareReportHide}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__redux_components_redux_dsd_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_25__reducer__["b" /* DM_COMPARE_DSDS_DSD_DETAIL_PREFIX */],instanceState:dsdDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CompareDsds));

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ArtefactSelectorCard__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducer__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_item_schemes_compare_report__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__redux_components_redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__redux_components_redux_concept_scheme_detail_modal__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__redux_components_redux_category_scheme_detail_modal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__redux_components_redux_concept_scheme_detail_modal_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__redux_components_redux_category_scheme_detail_modal_actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_infinite_scroll_data_table__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_filter__ = __webpack_require__(53);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,appLang:state.app.language,artefactType:state.scenes.utilities.compareItemSchemes.artefactType,sourceFormat:state.scenes.utilities.compareItemSchemes.sourceFormat,targetFormat:state.scenes.utilities.compareItemSchemes.targetFormat,source:state.scenes.utilities.compareItemSchemes.source,target:state.scenes.utilities.compareItemSchemes.target,isArtefactsVisible:state.scenes.utilities.compareItemSchemes.isArtefactsVisible,artefacts:state.scenes.utilities.compareItemSchemes.artefacts,codelistDetail:state.scenes.utilities.compareItemSchemes.codelistDetail,conceptSchemeDetail:state.scenes.utilities.compareItemSchemes.conceptSchemeDetail,categorySchemeDetail:state.scenes.utilities.compareItemSchemes.categorySchemeDetail,sourceCsvProps:state.scenes.utilities.compareItemSchemes.sourceCsvProps,targetCsvProps:state.scenes.utilities.compareItemSchemes.targetCsvProps,report:state.scenes.utilities.compareItemSchemes.report,isXmlPreviewVisible:state.scenes.utilities.compareItemSchemes.isXmlPreviewVisible,previewItems:state.scenes.utilities.compareItemSchemes.previewItems,isSourcePreview:state.scenes.utilities.compareItemSchemes.isSourcePreview,previewItemParams:state.scenes.utilities.compareItemSchemes.previewItemParams,previewCodelistTriplet:state.scenes.utilities.compareItemSchemes.previewCodelistTriplet,previewItemCount:state.scenes.utilities.compareItemSchemes.previewItemCount,isCsvPreviewVisible:state.scenes.utilities.compareItemSchemes.isCsvPreviewVisible,csvFilePath:state.scenes.utilities.compareItemSchemes.csvFilePath,allCsvRows:state.scenes.utilities.compareItemSchemes.allCsvRows};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onArtefactTypeChange:function onArtefactTypeChange(artefactType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["v" /* changeCompareItemSchemesArtefactType */])(artefactType));},onFormatChange:function onFormatChange(isSource,format,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["x" /* changeCompareItemSchemesFormat */])(isSource,format,lang));},onCsvPropsChange:function onCsvPropsChange(isSource,fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["w" /* changeCompareItemSchemesCsvProps */])(isSource,fields));},onFileSet:function onFileSet(isSource,file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["J" /* setCompareItemSchemesFile */])(isSource,file));},onArtefactsShow:function onArtefactsShow(isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["K" /* showCompareItemSchemesArtefacts */])(isSource));},onArtefactsHide:function onArtefactsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["A" /* hideCompareItemSchemesArtefacts */])());},fetchArtefacts:function fetchArtefacts(artefactType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["D" /* readCompareItemSchemesArtefacts */])(artefactType));},onArtefactSet:function onArtefactSet(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["I" /* setCompareItemSchemesArtefact */])(artefactTriplet));},onArtefactUnset:function onArtefactUnset(isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["N" /* unsetCompareItemSchemesArtefact */])(isSource));},onCodelistDetail:function onCodelistDetail(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_24__redux_components_redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_15__reducer__["h" /* UTILITIES_COMPARE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX */]));},onConceptSchemeDetail:function onConceptSchemeDetail(conceptSchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_25__redux_components_redux_concept_scheme_detail_modal_actions__["_38" /* showConceptSchemeDetail */])(conceptSchemeTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_15__reducer__["i" /* UTILITIES_COMPARE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX */]));},onCategorySchemeDetail:function onCategorySchemeDetail(categorySchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_26__redux_components_redux_category_scheme_detail_modal_actions__["_40" /* showCategorySchemeDetail */])(categorySchemeTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_15__reducer__["g" /* UTILITIES_COMPARE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX */]));},fetchCompare:function fetchCompare(artefactType,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["E" /* readCompareItemSchemesCompare */])(artefactType,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps));},onCompareHide:function onCompareHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["B" /* hideCompareItemSchemesCompare */])());},onCompareDownload:function onCompareDownload(artefactType,lang,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["z" /* downloadCompareItemSchemesCompare */])(artefactType,lang,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps));},fetchXmlPreview:function fetchXmlPreview(_ref){var artefactType=_ref.artefactType,file=_ref.file,lang=_ref.lang;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["G" /* readCompareItemSchemesXmlPreview */])(artefactType,file,lang));},fetchXmlPreviewPage:function fetchXmlPreviewPage(_ref2){var triplet=_ref2.triplet,lang=_ref2.lang,pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc,rebuildDb=_ref2.rebuildDb;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["H" /* readCompareItemSchemesXmlPreviewPage */])(triplet,lang,pageNum,pageSize,searchText,filters,sortCol,sortByDesc,rebuildDb));},onPreviewHide:function onPreviewHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["C" /* hideCompareItemSchemesPreview */])());},onXmlPreviewParamsUpdate:function onXmlPreviewParamsUpdate(fetchPageParams){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["O" /* updateCompareItemSchemesXmlPreviewParams */])(fetchPageParams));},onXmlPreviewLangChange:function onXmlPreviewLangChange(lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["y" /* changeCompareItemSchemesXmlPreviewLang */])(lang));},onXmlPreviewShow:function onXmlPreviewShow(isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["M" /* showCompareItemSchemesXmlPreview */])(isSource));},onCsvFileUpload:function onCsvFileUpload(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["P" /* uploadCompareItemSchemesCsvFile */])(file));},fetchCsvRows:function fetchCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["F" /* readCompareItemSchemesCsvPage */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath));},onCsvPreviewShow:function onCsvPreviewShow(isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["L" /* showCompareItemSchemesCsvPreview */])(isSource));}};};var CompareItemSchemes=function CompareItemSchemes(_ref3){var t=_ref3.t,nodeId=_ref3.nodeId,nodes=_ref3.nodes,appLang=_ref3.appLang,artefactType=_ref3.artefactType,sourceFormat=_ref3.sourceFormat,targetFormat=_ref3.targetFormat,source=_ref3.source,target=_ref3.target,isArtefactsVisible=_ref3.isArtefactsVisible,artefacts=_ref3.artefacts,codelistDetail=_ref3.codelistDetail,conceptSchemeDetail=_ref3.conceptSchemeDetail,categorySchemeDetail=_ref3.categorySchemeDetail,sourceCsvProps=_ref3.sourceCsvProps,targetCsvProps=_ref3.targetCsvProps,report=_ref3.report,onArtefactTypeChange=_ref3.onArtefactTypeChange,_onFormatChange=_ref3.onFormatChange,_onCsvPropsChange=_ref3.onCsvPropsChange,_onFileSet=_ref3.onFileSet,_onArtefactsShow=_ref3.onArtefactsShow,onArtefactsHide=_ref3.onArtefactsHide,fetchArtefacts=_ref3.fetchArtefacts,onArtefactSet=_ref3.onArtefactSet,_onArtefactUnset=_ref3.onArtefactUnset,onCodelistDetail=_ref3.onCodelistDetail,onConceptSchemeDetail=_ref3.onConceptSchemeDetail,onCategorySchemeDetail=_ref3.onCategorySchemeDetail,fetchCompare=_ref3.fetchCompare,onCompareHide=_ref3.onCompareHide,onCompareDownload=_ref3.onCompareDownload,isXmlPreviewVisible=_ref3.isXmlPreviewVisible,previewItems=_ref3.previewItems,isSourcePreview=_ref3.isSourcePreview,previewItemParams=_ref3.previewItemParams,previewCodelistTriplet=_ref3.previewCodelistTriplet,previewItemCount=_ref3.previewItemCount,fetchXmlPreview=_ref3.fetchXmlPreview,fetchXmlPreviewPage=_ref3.fetchXmlPreviewPage,onPreviewHide=_ref3.onPreviewHide,onXmlPreviewParamsUpdate=_ref3.onXmlPreviewParamsUpdate,onXmlPreviewLangChange=_ref3.onXmlPreviewLangChange,onXmlPreviewShow=_ref3.onXmlPreviewShow,isCsvPreviewVisible=_ref3.isCsvPreviewVisible,onCsvFileUpload=_ref3.onCsvFileUpload,fetchCsvRows=_ref3.fetchCsvRows,csvFilePath=_ref3.csvFilePath,allCsvRows=_ref3.allCsvRows,onCsvPreviewShow=_ref3.onCsvPreviewShow;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_MD"],align:"middle"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,t("scenes.utilities.compareItemSchemes.selectArtefactType.label")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group,{value:artefactType,onChange:function onChange(_ref4){var target=_ref4.target;return onArtefactTypeChange(target.value);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]},"Codelists"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_15__reducer__["a" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME */]},"Category Schemes"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_15__reducer__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]},"Concept Schemes"))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"center",gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return fetchCompare(artefactType,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps);},disabled:!source||!target||sourceFormat===__WEBPACK_IMPORTED_MODULE_15__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&(!sourceCsvProps.lang||!sourceCsvProps.textSeparator||sourceCsvProps.textSeparator.length<1)||targetFormat===__WEBPACK_IMPORTED_MODULE_15__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&(!targetCsvProps.lang||!targetCsvProps.textSeparator||targetCsvProps.textSeparator.length<1)},t("scenes.utilities.compareItemSchemes.buttons.compare.title"))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onCompareDownload(artefactType,appLang,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps);},disabled:!source||!target||sourceFormat===__WEBPACK_IMPORTED_MODULE_15__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&(!sourceCsvProps.lang||!sourceCsvProps.textSeparator||sourceCsvProps.textSeparator.length<1)||targetFormat===__WEBPACK_IMPORTED_MODULE_15__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&(!targetCsvProps.lang||!targetCsvProps.textSeparator||targetCsvProps.textSeparator.length<1)},t("scenes.utilities.compareItemSchemes.buttons.generateReport.title")))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ArtefactSelectorCard__["a" /* default */],{artefactType:true,title:(artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?"Codelist":artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?"Concept Scheme":"Category Scheme")+" 1",format:sourceFormat,onFormatChange:function onFormatChange(format){return _onFormatChange(true,format,appLang);},artefact:source,csvProps:sourceCsvProps,onArtefactDetailShow:function onArtefactDetailShow(){return artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?onCodelistDetail(source,defaultItemsViewMode):artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?onConceptSchemeDetail(source,defaultItemsViewMode):onCategorySchemeDetail(source,defaultItemsViewMode);},onArtefactsShow:function onArtefactsShow(){return _onArtefactsShow(true);},onArtefactUnset:function onArtefactUnset(){return _onArtefactUnset(true);},onFileSet:function onFileSet(file){return _onFileSet(true,file);},onCsvPropsChange:function onCsvPropsChange(fields){return _onCsvPropsChange(true,fields);}})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ArtefactSelectorCard__["a" /* default */],{artefactType:true,title:(artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?"Codelist":artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?"Concept Scheme":"Category Scheme")+" 2",format:targetFormat,onFormatChange:function onFormatChange(format){return _onFormatChange(false,format,appLang);},artefact:target,csvProps:targetCsvProps,onArtefactDetailShow:function onArtefactDetailShow(){return artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?onCodelistDetail(target,defaultItemsViewMode):artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?onConceptSchemeDetail(target,defaultItemsViewMode):onCategorySchemeDetail(target,defaultItemsViewMode);},onArtefactsShow:function onArtefactsShow(){return _onArtefactsShow(false);},onArtefactUnset:function onArtefactUnset(){return _onArtefactUnset(false);},onFileSet:function onFileSet(file){return _onFileSet(false,file);},onCsvPropsChange:function onCsvPropsChange(fields){return _onCsvPropsChange(false,fields);}}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:isArtefactsVisible,onCancel:onArtefactsHide,title:t('scenes.utilities.compareItemSchemes.modals.artefactList.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onArtefactsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchArtefacts,cbParam:artefactType},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_artefact_list__["a" /* default */],{artefacts:artefacts,onRowClick:function onRowClick(_ref5){var id=_ref5.id,agencyID=_ref5.agencyID,version=_ref5.version;return onArtefactSet({id:id,agencyID:agencyID,version:version});},onDetailShow:function onDetailShow(_ref6){var id=_ref6.id,agencyID=_ref6.agencyID,version=_ref6.version;return artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?onCodelistDetail({id:id,agencyID:agencyID,version:version},defaultItemsViewMode):artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?onConceptSchemeDetail({id:id,agencyID:agencyID,version:version},defaultItemsViewMode):onCategorySchemeDetail({id:id,agencyID:agencyID,version:version},defaultItemsViewMode);}}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:report!==null&&report!==undefined,onCancel:onCompareHide,title:t('scenes.utilities.compareItemSchemes.modals.itemSchemeCompareReport.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onCompareHide},t('commons.buttons.close.title')),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_item_schemes_compare_report__["a" /* default */],{report:report,onDetailShow:function onDetailShow(triplet,isSource){if(isSource){if(sourceFormat===__WEBPACK_IMPORTED_MODULE_15__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]){onCsvPreviewShow(true);}else if(sourceFormat===__WEBPACK_IMPORTED_MODULE_15__reducer__["f" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_SDMX */]){onXmlPreviewShow(true);}else{artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?onCodelistDetail(triplet,defaultItemsViewMode):artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?onConceptSchemeDetail(triplet,defaultItemsViewMode):onCategorySchemeDetail(triplet,defaultItemsViewMode);}}else{if(targetFormat===__WEBPACK_IMPORTED_MODULE_15__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]){onCsvPreviewShow(false);}else if(targetFormat===__WEBPACK_IMPORTED_MODULE_15__reducer__["f" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_SDMX */]){onXmlPreviewShow(false);}else{artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?onCodelistDetail(triplet,defaultItemsViewMode):artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["c" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?onConceptSchemeDetail(triplet,defaultItemsViewMode):onCategorySchemeDetail(triplet,defaultItemsViewMode);}}}})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__redux_components_redux_codelist_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_15__reducer__["h" /* UTILITIES_COMPARE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX */],instanceState:codelistDetail}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__redux_components_redux_concept_scheme_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_15__reducer__["i" /* UTILITIES_COMPARE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX */],instanceState:conceptSchemeDetail}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__redux_components_redux_category_scheme_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_15__reducer__["g" /* UTILITIES_COMPARE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX */],instanceState:categorySchemeDetail}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchXmlPreview,cbParam:{artefactType:artefactType,file:isSourcePreview?source:target,lang:appLang},disabled:!isXmlPreviewVisible},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:isXmlPreviewVisible&&previewItems!==null,onCancel:onPreviewHide,title:t('scenes.utilities.compareItemSchemes.modals.xmlPreview.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onPreviewHide},t('commons.buttons.close.title')),withDataLanguageSelector:true,onDataLanguageSelectorChange:function onDataLanguageSelectorChange(lang,changeLang){onXmlPreviewLangChange(lang);changeLang();}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLang;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:fetchXmlPreviewPage,cbParam:previewItemParams,disabled:!isXmlPreviewVisible||artefactType!==__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]||!previewItemParams||!previewItems},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_item_list__["a" /* default */],{data:previewItems,hideOrderCol:true,isPaginated:artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */],rowCount:artefactType===__WEBPACK_IMPORTED_MODULE_15__reducer__["b" /* COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?previewItemCount:null,onChange:function onChange(_ref7){var pageNum=_ref7.pageNum,pageSize=_ref7.pageSize,searchText=_ref7.searchText,filters=_ref7.filters,sortCol=_ref7.sortCol,sortByDesc=_ref7.sortByDesc;return onXmlPreviewParamsUpdate({triplet:previewCodelistTriplet,lang:lang,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc,rebuildDb:false});}}));}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_enhanced_modal__["a" /* default */],{visible:isCsvPreviewVisible,onCancel:onPreviewHide,title:t('scenes.utilities.compareItemSchemes.modals.csvPreview.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onPreviewHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__hocs_call__["a" /* default */],{cb:onCsvFileUpload,cbParam:isSourcePreview?source:target,disabled:!isCsvPreviewVisible},csvFilePath&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_infinite_scroll_data_table__["a" /* default */],{data:allCsvRows&&allCsvRows.Data,rowTotal:allCsvRows&&allCsvRows.Count,cols:allCsvRows&&allCsvRows.Columns,hiddenCols:["NumRow"],onChange:function onChange(_ref8){var pageNum=_ref8.pageNum,pageSize=_ref8.pageSize,searchText=_ref8.searchText,filters=_ref8.filters,sortCol=_ref8.sortCol,sortByDesc=_ref8.sortByDesc;return fetchCsvRows(pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_30__utils_filter__["b" /* getFilterObjFromViewerObj */])(allCsvRows&&allCsvRows.Columns.filter(function(colName){return colName!=='NumRow';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc,isSourcePreview?sourceCsvProps.textSeparator:targetCsvProps.textSeparator,isSourcePreview?sourceCsvProps.textDelimiter:targetCsvProps.textDelimiter,isSourcePreview?sourceCsvProps.firstRowHeader:targetCsvProps.firstRowHeader,csvFilePath);}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(CompareItemSchemes));

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducer__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_languages__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(3);
var mapStateToProps=function mapStateToProps(state){return{dataLanguages:state.config.dataManagement.dataLanguages};};var mapPropsToFields=function mapPropsToFields(_ref){var csvProps=_ref.csvProps;return{lang:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:csvProps?csvProps.lang:null}),textSeparator:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:csvProps?csvProps.textSeparator:null}),textDelimiter:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:csvProps?csvProps.textDelimiter:null}),firstRowHeader:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:csvProps?csvProps.firstRowHeader:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onCsvPropsChange(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_HALF"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_HALF"]}};var ArtefactSelectorCard=function ArtefactSelectorCard(_ref3){var t=_ref3.t,form=_ref3.form,dataLanguages=_ref3.dataLanguages,title=_ref3.title,format=_ref3.format,onFormatChange=_ref3.onFormatChange,artefact=_ref3.artefact,onFileSet=_ref3.onFileSet,onArtefactDetailShow=_ref3.onArtefactDetailShow,onArtefactsShow=_ref3.onArtefactsShow,onArtefactUnset=_ref3.onArtefactUnset;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{title:title,type:'inner'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:'flex',justify:'center',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Group,{value:format,onChange:function onChange(_ref4){var target=_ref4.target;return onFormatChange(target.value);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_22__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]},'MSDB'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_22__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]},'CSV'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_22__reducer__["f" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_SDMX */]},'SDMX-ML'))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:'flex',justify:'center',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MARGIN_MD"]}},format===__WEBPACK_IMPORTED_MODULE_22__reducer__["e" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_selector__["a" /* default */],{value:artefact&&artefact.id+'+'+artefact.agencyID+'+'+artefact.version,detailTitle:t('scenes.utilities.compareItemSchemes.artefactSelectorCard.selector.detail.title'),selectTitle:t('scenes.utilities.compareItemSchemes.artefactSelectorCard.selector.select.title'),resetTitle:t('scenes.utilities.compareItemSchemes.artefactSelectorCard.selector.reset.title'),onDetail:onArtefactDetailShow,onSelect:onArtefactsShow,onReset:onArtefactUnset}):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_file_input__["a" /* default */],{value:artefact,onChange:onFileSet,accept:format===__WEBPACK_IMPORTED_MODULE_22__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]?".csv":".xml"})),format===__WEBPACK_IMPORTED_MODULE_22__reducer__["d" /* COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.commons.language.label')},formItemLayout),form.getFieldDecorator('lang')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref5){var props=_ref5.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},style:{width:160}},dataLanguages.map(function(_ref6){var code=_ref6.code;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option,{key:code,value:code,title:Object(__WEBPACK_IMPORTED_MODULE_23__utils_languages__["c" /* getLanguageLabel */])(t,code)},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('i',{className:'flag-icon '+Object(__WEBPACK_IMPORTED_MODULE_23__utils_languages__["b" /* getLanguageFlagIconCss */])(code,dataLanguages),style:{marginRight:8}}),Object(__WEBPACK_IMPORTED_MODULE_23__utils_languages__["c" /* getLanguageLabel */])(t,code));})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.csv.separator.label')},formItemLayout),form.getFieldDecorator('textSeparator')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{maxLength:1,style:{width:48}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.csv.delimiter.label')},formItemLayout),form.getFieldDecorator('textDelimiter')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{maxLength:1,style:{width:48}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.csv.hasHeader.label')},formItemLayout),form.getFieldDecorator('firstRowHeader',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_18_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(mapStateToProps),__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ArtefactSelectorCard));

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_components_redux_content_constraint_modal__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(342);
var mapStateToProps=function mapStateToProps(state){return{contentConstraintDetail:state.scenes.metaManager.contentConstraints.contentConstraintDetail};};var ContentConstraints=function ContentConstraints(_ref){var contentConstraintDetail=_ref.contentConstraintDetail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_content_constraint_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_4__reducer__["a" /* MM_CONTENT_CONSTRAINTS_PREFIX */],instanceState:contentConstraintDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ContentConstraints));

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_components_redux_content_constraint_modal_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_download__ = __webpack_require__(55);
var mapStateToProps=function mapStateToProps(state){return{contentConstraints:state.scenes.metaManager.contentConstraints.contentConstraints,contentConstraintDetail:state.scenes.metaManager.contentConstraints.contentConstraintDetail,contentConstraintAnnotations:state.scenes.metaManager.contentConstraints.contentConstraintAnnotations,contentConstraintAnnotationTriplet:state.scenes.metaManager.contentConstraints.contentConstraintAnnotationTriplet,parentsAndChildren:state.scenes.metaManager.contentConstraints.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchContentConstraints:function fetchContentConstraints(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* readContentConstraintsListContentConstraints */])());},onCreateShow:function onCreateShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__redux_components_redux_content_constraint_modal_actions__["Y" /* createContentConstraintDetail */])(),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CONTENT_CONSTRAINTS_PREFIX */]));},onDetailShow:function onDetailShow(contentConstraintTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__redux_components_redux_content_constraint_modal_actions__["Z" /* editContentConstraintDetail */])(contentConstraintTriplet),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CONTENT_CONSTRAINTS_PREFIX */]));},onContentConstraintDelete:function onContentConstraintDelete(contentConstraintTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* deleteContentConstraintsContentConstraint */])(contentConstraintTriplet));},onSelectedContentConstraintsDelete:function onSelectedContentConstraintsDelete(contentConstraintTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* deleteContentConstraintsSelectedContentConstraints */])(contentConstraintTriplets));},onAnnotationsShow:function onAnnotationsShow(annotations,triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* showContentConstraintsDetailAnnotations */])(annotations,triplet));},onAnnotationsHide:function onAnnotationsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* hideContentConstraintsDetailAnnotations */])());},onDownloadShow:function onDownloadShow(artefactTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__redux_components_redux_content_constraint_modal_actions__["_23" /* showContentConstraintDetailDownload */])(artefactTriplets,lang),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CONTENT_CONSTRAINTS_PREFIX */]));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__redux_components_redux_content_constraint_modal_actions__["_22" /* showContentConstraintDetailClone */])(artefactTriplet),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CONTENT_CONSTRAINTS_PREFIX */]));},onExportShow:function onExportShow(sourceTriplet,sourceAttachmentType,sourceAttachmentUrn,sourceFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_11__redux_components_redux_content_constraint_modal_actions__["_24" /* showContentConstraintDetailExport */])(sourceTriplet,sourceAttachmentType,sourceAttachmentUrn,sourceFilter),__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* MM_CONTENT_CONSTRAINTS_PREFIX */]));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* readContentConstraintsContentConstraintParentsAndChildren */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* hideContentConstraintsContentConstraintParentsAndChildren */])());}};};var ContentConstraintsList=function ContentConstraintsList(_ref){var contentConstraints=_ref.contentConstraints,contentConstraintDetail=_ref.contentConstraintDetail,onCreateShow=_ref.onCreateShow,onDetailShow=_ref.onDetailShow,fetchContentConstraints=_ref.fetchContentConstraints,onContentConstraintDelete=_ref.onContentConstraintDelete,contentConstraintAnnotations=_ref.contentConstraintAnnotations,contentConstraintAnnotationTriplet=_ref.contentConstraintAnnotationTriplet,onAnnotationsShow=_ref.onAnnotationsShow,onAnnotationsHide=_ref.onAnnotationsHide,onSelectedContentConstraintsDelete=_ref.onSelectedContentConstraintsDelete,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,_onExportShow=_ref.onExportShow,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchContentConstraints,disabled:contentConstraints!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_artefact_list__["a" /* default */],{artefacts:contentConstraints,onDetailShow:onDetailShow,onCreate:onCreateShow,onDownloadShow:onDownloadShow,onCloneShow:onCloneShow,onExportShow:function onExportShow(triplet){return _onExportShow(triplet,contentConstraintDetail.artefactType,Object(__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["_5" /* getUrnFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(contentConstraintDetail.artefactTriplet||""),contentConstraintDetail.artefactType===__WEBPACK_IMPORTED_MODULE_12__constants_download__["h" /* ARTEFACT_TYPE_DSD */]?__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["E" /* SDMX_JSON_DSD_URN_NAMESPACE */]:__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["C" /* SDMX_JSON_DATAFLOW_URN_NAMESPACE */]),contentConstraintDetail.filter);},onDelete:onContentConstraintDelete,onSelectedItemDelete:onSelectedContentConstraintsDelete,onAnnotationsShow:onAnnotationsShow,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("contentconstraint",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_custom_annotation_list__["a" /* default */],{annotations:contentConstraintAnnotations,onClose:onAnnotationsHide,title:contentConstraintAnnotationTriplet?Object(__WEBPACK_IMPORTED_MODULE_8__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(contentConstraintAnnotationTriplet):null}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ContentConstraintsList));

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MetadataSetTree__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MetadataSetDetailWrapper__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commons_ReportList__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ReportDetailWrapper__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_css__);
var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions,metadataSet:state.scenes.referenceMetadata.metadataSet.metadataSet,isReportVisible:state.scenes.referenceMetadata.metadataSet.isReportVisible,report:state.scenes.referenceMetadata.metadataSet.report,reportAnnotations:state.scenes.referenceMetadata.metadataSet.reportAnnotations,reportStructure:state.scenes.referenceMetadata.metadataSet.reportStructure,step:state.scenes.referenceMetadata.metadataSet.step,reportId:state.scenes.referenceMetadata.metadataSet.reportId,target:state.scenes.referenceMetadata.metadataSet.target,identifiableTargets:state.scenes.referenceMetadata.metadataSet.identifiableTargets,reportHtmlPageUrl:state.scenes.referenceMetadata.metadataSet.reportHtmlPageUrl,selectedAttribute:state.scenes.referenceMetadata.metadataSet.selectedAttribute};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onReportCreate:function onReportCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_3" /* createMetadataSetReport */])());},onReportDelete:function onReportDelete(reportId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_6" /* deleteMetadataSetReport */])(reportId));},fetchReport:function fetchReport(metadataSetId,reportId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_21" /* readMetadataSetReport */])(metadataSetId,reportId));},onReportHide:function onReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_13" /* hideMetadataSetReport */])());},onReportSubmit:function onReportSubmit(metadataSet,report,reportAnnotations,reportStructure,reportId,target,identifiableTargets,annotationsConfig,isDraft){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_40" /* submitMetadataSetReport */])(metadataSet,report,reportAnnotations,reportStructure,reportId,target,identifiableTargets,annotationsConfig,isDraft));},onStepSet:function onStepSet(step,dataLanguages,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_30" /* setMetadataSetReportStep */])(step,dataLanguages,t));},onReportStateSubmit:function onReportStateSubmit(metadataSetId,reportId,newState){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_41" /* submitMetadataSetUpdateReportState */])(metadataSetId,reportId,newState));},onHtmlPageShow:function onHtmlPageShow(htmlPageUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_36" /* showMetadataSetReportHtmlPage */])(htmlPageUrl));},onHtmlPageHide:function onHtmlPageHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_15" /* hideMetadataSetReportHtmlPage */])());},onReportDownload:function onReportDownload(metadataSetId,reportId,fileName,metadataApiBaseUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["_8" /* downloadMetadataSetReport */])(metadataSetId,reportId,fileName,metadataApiBaseUrl));}};};var MetadataSet=function MetadataSet(_ref){var t=_ref.t,permissions=_ref.permissions,metadataSet=_ref.metadataSet,report=_ref.report,reportAnnotations=_ref.reportAnnotations,isReportVisible=_ref.isReportVisible,reportStructure=_ref.reportStructure,step=_ref.step,reportId=_ref.reportId,target=_ref.target,identifiableTargets=_ref.identifiableTargets,reportHtmlPageUrl=_ref.reportHtmlPageUrl,selectedAttribute=_ref.selectedAttribute,onReportCreate=_ref.onReportCreate,onReportDelete=_ref.onReportDelete,fetchReport=_ref.fetchReport,onReportHide=_ref.onReportHide,onReportSubmit=_ref.onReportSubmit,onStepSet=_ref.onStepSet,onReportStateSubmit=_ref.onReportStateSubmit,onHtmlPageShow=_ref.onHtmlPageShow,onHtmlPageHide=_ref.onHtmlPageHide,onReportDownload=_ref.onReportDownload;var hasPermission=metadataSet&&permissions&&(!Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */])||permissions.metadataflowOwner.includes(Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(metadataSet))));var reports=metadataSet?metadataSet.reports:null;reports=(reports||[]).filter(function(_ref2){var isPublished=_ref2.isPublished;return hasPermission?true:isPublished===__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */];}).map(function(report){return Object.assign({},report,{targetId:report.target.id,targetReferenceValues:(report.target.referenceValues||[]).map(function(_ref3){var object=_ref3.object;return object;}).join(", ")});});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MetadataSetTree__["a" /* default */],{hasPermission:hasPermission})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MetadataSetDetailWrapper__["a" /* default */],{hasPermission:hasPermission}))),metadataSet&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_16__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */])&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{title:t('scenes.referenceMetadata.commons.reportList.title'),type:"inner",style:{marginTop:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commons_ReportList__["a" /* default */],{isDcat:false,ReportDetailWrapper:__WEBPACK_IMPORTED_MODULE_14__ReportDetailWrapper__["a" /* default */],hasPermission:hasPermission,metadataSet:metadataSet,reports:reports,report:report,reportAnnotations:reportAnnotations,isReportVisible:isReportVisible,reportStructure:reportStructure,step:step,reportId:reportId,target:target,identifiableTargets:identifiableTargets,reportHtmlPageUrl:reportHtmlPageUrl,selectedAttribute:selectedAttribute,onReportCreate:onReportCreate,onReportDelete:onReportDelete,onReportShow:fetchReport,onReportHide:onReportHide,onReportSubmit:onReportSubmit,onStepSet:onStepSet,onReportStateSubmit:onReportStateSubmit,onHtmlPageShow:onHtmlPageShow,onHtmlPageHide:onHtmlPageHide,onReportDownload:onReportDownload})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(MetadataSet));

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_referenceMetadata__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__styles_buttons__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_html_template_viewer__ = __webpack_require__(363);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,metadataSetTree:state.scenes.referenceMetadata.metadataSet.metadataSetTree,metadataSetId:state.scenes.referenceMetadata.metadataSet.metadataSetId,metadataSetCategory:state.scenes.referenceMetadata.metadataSet.metadataSetCategory,metadataSet:state.scenes.referenceMetadata.metadataSet.metadataSet,metadataSets:state.scenes.referenceMetadata.metadataSet.metadataSets,categorySchemes:state.scenes.referenceMetadata.metadataSet.categorySchemes,categoryId:state.scenes.referenceMetadata.metadataSet.categoryId,categoryUrn:state.scenes.referenceMetadata.metadataSet.categoryUrn,isCloneVisible:state.scenes.referenceMetadata.metadataSet.isCloneVisible,cloneId:state.scenes.referenceMetadata.metadataSet.cloneId,metadataSetHtmlPageUrl:state.scenes.referenceMetadata.metadataSet.metadataSetHtmlPageUrl};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchMetadataSets:function fetchMetadataSets(lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_17" /* readMetadataSetCategorizedMetadataSets */])(lang));},onMetadataSetSelect:function onMetadataSetSelect(metadataSet,msdTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_25" /* selectMetadataSetMetadataSet */])(metadataSet,msdTriplet));},onCategorySelect:function onCategorySelect(categoryId,categoryUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_24" /* selectMetadataSetCategory */])(categoryId,categoryUrn));},onMetadataSetCreate:function onMetadataSetCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_2" /* createMetadataSetMetadataSet */])());},onMetadataSetCategorise:function onMetadataSetCategorise(metadataSet,categoryUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["X" /* categoriseMetadataSetMetadataSet */])(metadataSet,categoryUrn));},onMetadataSetDelete:function onMetadataSetDelete(metadataSetId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_5" /* deleteMetadataSetMetadataSet */])(metadataSetId));},onCloneShow:function onCloneShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_32" /* showMetadataSetMetadataSetClone */])());},onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_10" /* hideMetadataSetMetadataSetClone */])());},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["Z" /* changeMetadataSetMetadataSetClone */])(fields));},onCloneSubmit:function onCloneSubmit(metadataSetId,newMetadataSetId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_39" /* submitMetadataSetMetadataSetClone */])(metadataSetId,newMetadataSetId));},onHtmlPageShow:function onHtmlPageShow(htmlPageUrl){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_33" /* showMetadataSetMetadataSetHtmlPage */])(htmlPageUrl));},onHtmlPageHide:function onHtmlPageHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions__["_11" /* hideMetadataSetMetadataSetHtmlPage */])());}};};var mapPropsToFields=function mapPropsToFields(_ref){var cloneId=_ref.cloneId;return{cloneId:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:cloneId})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onCloneChange(__WEBPACK_IMPORTED_MODULE_26_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var hasLocalPermission=function hasLocalPermission(metadataSetId,metadataSetTree,permissions){if(!metadataSetId||!metadataSetTree||!permissions){return false;}else{var metadataSet=Object(__WEBPACK_IMPORTED_MODULE_19__utils_tree__["k" /* getNode */])(metadataSetTree,"categories",function(node){return node.type==="metadataSet"&&node.id===metadataSetId;});return metadataSet&&permissions.metadataflowOwner.includes(Object(__WEBPACK_IMPORTED_MODULE_27__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(Object(__WEBPACK_IMPORTED_MODULE_28__utils_referenceMetadata__["M" /* getMetadataflowTripletFromAnnotations */])(metadataSet)));}};var _onDrop=function _onDrop(ev,metadataSetTree,permissions,onMetadataSetCategorise,t){if(ev.dragNode.props["data-node"].type==="metadataSet"&&!hasLocalPermission(ev.dragNode.props["data-node"].id,metadataSetTree,permissions)){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t("scenes.referenceMetadata.metadataSet.metadataSetTree.errors.permissionDenied.title")});}else{if(ev.dragNode.props["data-node"].type==="metadataSet"){if(ev.dropToGap){if(ev.dragNode.props["data-node"].categoryUrn!==ev.node.props["data-node"].categoryUrn){ev.node.props["data-node"].urn&&ev.node.props["data-node"].parent?onMetadataSetCategorise(ev.dragNode.props["data-node"],ev.node.props["data-node"].categoryUrn):ev.node.props["data-node"].type==="metadataSet"?ev.node.props["data-node"].categoryUrn?onMetadataSetCategorise(ev.dragNode.props["data-node"],ev.node.props["data-node"].categoryUrn):onMetadataSetCategorise(ev.dragNode.props["data-node"],null):__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t("scenes.referenceMetadata.metadataSet.metadataSetTree.errors.notValidCategory.title")});}}else{var nodeUrn=ev.node.props["data-node"].urn;if(ev.dragNode.props["data-node"].categoryUrn!==nodeUrn){nodeUrn&&ev.node.props["data-node"].type==="category"?onMetadataSetCategorise(ev.dragNode.props["data-node"],nodeUrn):ev.node.props["data-node"].id===__WEBPACK_IMPORTED_MODULE_19__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]?onMetadataSetCategorise(ev.dragNode.props["data-node"],null):__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t("scenes.referenceMetadata.metadataSet.metadataSetTree.errors.notValidCategory.title")});}}}else{__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:t("scenes.referenceMetadata.metadataSet.metadataSetTree.errors.canDragOnlyMetadataSet.title")});}}};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_TWO_THIRDS"]}};var MetadataSetTree=function MetadataSetTree(_ref3){var t=_ref3.t,form=_ref3.form,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,permissions=_ref3.permissions,hasPermission=_ref3.hasPermission,nodes=_ref3.nodes,nodeId=_ref3.nodeId,metadataSetTree=_ref3.metadataSetTree,metadataSetId=_ref3.metadataSetId,metadataSetCategory=_ref3.metadataSetCategory,metadataSet=_ref3.metadataSet,metadataSets=_ref3.metadataSets,categorySchemes=_ref3.categorySchemes,categoryId=_ref3.categoryId,categoryUrn=_ref3.categoryUrn,isCloneVisible=_ref3.isCloneVisible,cloneId=_ref3.cloneId,metadataSetHtmlPageUrl=_ref3.metadataSetHtmlPageUrl,fetchMetadataSets=_ref3.fetchMetadataSets,onMetadataSetSelect=_ref3.onMetadataSetSelect,onCategorySelect=_ref3.onCategorySelect,onMetadataSetCreate=_ref3.onMetadataSetCreate,onMetadataSetCategorise=_ref3.onMetadataSetCategorise,onMetadataSetDelete=_ref3.onMetadataSetDelete,onCloneShow=_ref3.onCloneShow,onCloneHide=_ref3.onCloneHide,onCloneSubmit=_ref3.onCloneSubmit,onHtmlPageShow=_ref3.onHtmlPageShow,onHtmlPageHide=_ref3.onHtmlPageHide;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;var connectedNode=nodes.find(function(node){return node.general.id===nodeId;});var dcatMsdUrn=connectedNode.dcatapit.msd;var metadataApiBaseUrl=connectedNode.endpoint.metadataBaseURL;var uncategorizedNodeKey=(Object(__WEBPACK_IMPORTED_MODULE_19__utils_tree__["k" /* getNode */])(metadataSetTree,"categories",function(_ref4){var id=_ref4.id;return id===__WEBPACK_IMPORTED_MODULE_19__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */];})||{}).nodeKey;var _getNodeKey=function _getNodeKey(category,id,isMetadataSet){return isMetadataSet?"ms+"+(category||"uncategorized")+"+"+id:"cat+"+category+"+"+id;};return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__hocs_call__["a" /* default */],{cb:fetchMetadataSets,cbParam:lang,disabled:categorySchemes!==null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"metadata-set-tree__tree"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"start",gutter:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,Object.assign({},__WEBPACK_IMPORTED_MODULE_29__styles_buttons__["f" /* BUTTON_CREATE */],{onClick:function onClick(){return onMetadataSetCreate();},title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.actions.addMetadataSet.title'),disabled:categoryId===null||categoryUrn.split(".")[categoryUrn.split(".").length-1].includes(")")}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:"file-text"}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,Object.assign({},__WEBPACK_IMPORTED_MODULE_29__styles_buttons__["d" /* BUTTON_CLONE */],{onClick:function onClick(){return onCloneShow();},title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.actions.clone.title'),disabled:metadataSetId===null||!hasPermission}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,Object.assign({},__WEBPACK_IMPORTED_MODULE_29__styles_buttons__["s" /* BUTTON_INFO_PAGE */],{onClick:function onClick(){return onHtmlPageShow(metadataSet.msdUrn===dcatMsdUrn?Object(__WEBPACK_IMPORTED_MODULE_28__utils_referenceMetadata__["H" /* getDcatMetadataSetHtmlPageUrl */])(nodeId,metadataSet.id,lang,metadataApiBaseUrl):Object(__WEBPACK_IMPORTED_MODULE_28__utils_referenceMetadata__["L" /* getMetadataSetHtmlPageUrl */])(nodeId,metadataSet.id,lang,metadataApiBaseUrl));},title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.actions.navigateHtmlPage.title'),disabled:metadataSetId===null||!metadataApiBaseUrl}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,Object.assign({},__WEBPACK_IMPORTED_MODULE_29__styles_buttons__["F" /* BUTTON_UNCATEGORIZE */],{onClick:function onClick(){return onMetadataSetCategorise(metadataSet,null);},title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.actions.deleteCategorisation.title'),disabled:metadataSetId===null||metadataSet===null||!metadataSet.categoryUrn||!hasPermission}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,Object.assign({},__WEBPACK_IMPORTED_MODULE_29__styles_buttons__["k" /* BUTTON_DELETE */],{onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.modals.confirms.delete.title',{id:metadataSetId}),onOk:function onOk(){onMetadataSetDelete(metadataSetId);},cancelText:t('commons.buttons.cancel.title')});},title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.actions.delete.title'),disabled:metadataSetId===null||!hasPermission})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_enhanced_tree__["a" /* default */],{tree:metadataSetTree,getNodeKey:function getNodeKey(node){return node.type==="metadataSet"?_getNodeKey(node.categoryUrn,node.id,true):_getNodeKey(node.urn,node.id,false);},childrenKey:"categories",idKey:"id",nameKey:"name",catIdKey:"id",catNameKey:"name",getCatId:function getCatId(_ref5){var id=_ref5.id,version=_ref5.version;return""+id+(version?"("+version+")":'');},icon:"file-text",getIconColor:function getIconColor(){return"#37a0f4";},getFilter:function getFilter(searchText){return function(_ref6){var id=_ref6.id,name=_ref6.name;var search=searchText.toLowerCase();return id&&id.toLowerCase().indexOf(search)>=0||name&&Object(__WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__["a" /* getLocalizedStr */])(name,lang,dataLanguages).toLowerCase().indexOf(search)>=0;};},draggable:true,hiddenIdKeys:Object(__WEBPACK_IMPORTED_MODULE_19__utils_tree__["l" /* getNodes */])(metadataSetTree,"categories",function(){return true;}).filter(function(_ref7){var type=_ref7.type;return type==="category";}).map(function(node){return _getNodeKey(node.urn,node.id,false);}),unselectableKeys:[uncategorizedNodeKey],expandSelectedOnTreeChange:true,onDrop:function onDrop(ev){return _onDrop(ev,metadataSetTree,permissions,onMetadataSetCategorise,t);},selectedKeys:metadataSetId!==null?[_getNodeKey(metadataSetCategory,metadataSetId,true)]:[_getNodeKey(categoryUrn,categoryId,false)],onSelect:function onSelect(selectedArr){if(selectedArr!==null&&selectedArr.length>0){var node=Object(__WEBPACK_IMPORTED_MODULE_19__utils_tree__["k" /* getNode */])(metadataSetTree,'categories',function(node){return node.type==="metadataSet"?_getNodeKey(node.categoryUrn,node.id,true)===selectedArr[0]:_getNodeKey(node.urn,node.id,false)===selectedArr[0];});if(node.type==="metadataSet"){onMetadataSetSelect(node,Object(__WEBPACK_IMPORTED_MODULE_27__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(node.msdUrn));onCategorySelect(null,null);}else if(node.type==="category"){onMetadataSetSelect(null,null);onCategorySelect(node.id,node.urn);}else if(node.type==="categoryScheme"){onMetadataSetSelect(null,null);onCategorySelect(node.id,node.urn);}}else{onMetadataSetSelect(null,null);onCategorySelect(null,null);}},rightClickActions:[function(node){return node.type==="metadataSet"?Object.assign({},__WEBPACK_IMPORTED_MODULE_29__styles_buttons__["s" /* BUTTON_INFO_PAGE */],{title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.actions.navigateHtmlPage.title'),onClick:function onClick(_ref8){var id=_ref8.id,msdUrn=_ref8.msdUrn;return onHtmlPageShow(msdUrn===dcatMsdUrn?Object(__WEBPACK_IMPORTED_MODULE_28__utils_referenceMetadata__["H" /* getDcatMetadataSetHtmlPageUrl */])(nodeId,id,lang,metadataApiBaseUrl):Object(__WEBPACK_IMPORTED_MODULE_28__utils_referenceMetadata__["L" /* getMetadataSetHtmlPageUrl */])(nodeId,id,lang,metadataApiBaseUrl));},disabled:!metadataApiBaseUrl}):null;},function(node){return node.type==="metadataSet"?Object.assign({},__WEBPACK_IMPORTED_MODULE_29__styles_buttons__["F" /* BUTTON_UNCATEGORIZE */],{title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.actions.deleteCategorisation.title'),onClick:function onClick(){return onMetadataSetCategorise(node,null);},disabled:!node.categoryUrn||!hasLocalPermission(node.id,metadataSetTree,permissions)}):null;},function(node){return node.type==="metadataSet"?Object.assign({},__WEBPACK_IMPORTED_MODULE_29__styles_buttons__["k" /* BUTTON_DELETE */],{title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.actions.delete.title'),onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:t('scenes.referenceMetadata.metadataSet.metadataSetTree.modals.confirms.delete.title',{id:node.id}),onOk:function onOk(){onMetadataSetDelete(node.id);},cancelText:t('commons.buttons.cancel.title')});},disabled:!hasLocalPermission(node.id,metadataSetTree,permissions)}):null;}],searchBarSpan:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_THREE_QUARTERS"]}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_enhanced_modal__["a" /* default */],{title:t("scenes.referenceMetadata.metadataSet.modals.metadataSetClone.title"),visible:isCloneVisible,onCancel:onCloneHide,width:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MODAL_WIDTH_MD"],footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onCloneSubmit(metadataSet.id,cloneId);},disabled:cloneId===null||cloneId.length===0||(metadataSets||[]).find(function(_ref9){var id=_ref9.id;return id===cloneId;})},t("commons.buttons.save.title")))},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,Object.assign({label:t("scenes.referenceMetadata.metadataSet.metadataSetDetail.id.label"),className:"form-item-required",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MARGIN_MD"]},hasFeedback:true,validateStatus:(metadataSets||[]).find(function(_ref10){var id=_ref10.id;return id===cloneId;})||form.getFieldValue("cloneId")&&Object(__WEBPACK_IMPORTED_MODULE_30__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue("cloneId")).help?"warning":null,help:(metadataSets||[]).find(function(_ref11){var id=_ref11.id;return id===cloneId;})?t("scenes.referenceMetadata.metadataSet.metadataSetDetail.id.alreadyUsed.help"):form.getFieldValue("cloneId")?Object(__WEBPACK_IMPORTED_MODULE_30__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,form.getFieldValue("cloneId")).help||undefined:undefined},formItemLayout),form.getFieldDecorator("cloneId",{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue("cloneId"),style:{textTransform:"uppercase"}})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_html_template_viewer__["a" /* default */],{title:t('scenes.referenceMetadata.commons.modals.htmlPage.title'),htmlPageUrl:metadataSetHtmlPageUrl,onClose:onHtmlPageHide}));});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_16_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(MetadataSetTree));

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commons_MetadataSetDetail__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_referenceMetadata__ = __webpack_require__(77);
var mapStateToProps=function mapStateToProps(state){return{permissions:state.app.user.permissions,appLang:state.app.language,dataLangs:state.config.dataManagement.dataLanguages,metadataSetId:state.scenes.referenceMetadata.metadataSet.metadataSetId,msdTriplet:state.scenes.referenceMetadata.metadataSet.msdTriplet,metadataSet:state.scenes.referenceMetadata.metadataSet.metadataSet,isMetadataflowsVisible:state.scenes.referenceMetadata.metadataSet.isMetadataflowsVisible,metadataflows:state.scenes.referenceMetadata.metadataSet.metadataflows,categoryUrn:state.scenes.referenceMetadata.metadataSet.categoryUrn,isFetchMetadataSetDisabled:state.scenes.referenceMetadata.metadataSet.isFetchMetadataSetDisabled,conceptSchemeTriplets:state.scenes.referenceMetadata.metadataSet.conceptSchemeTriplets,metadataSets:state.scenes.referenceMetadata.metadataSet.metadataSets,metadataSetTree:state.scenes.referenceMetadata.metadataSet.metadataSetTree};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchMetadataSet:function fetchMetadataSet(_ref){var metadataSetId=_ref.metadataSetId,msdTriplet=_ref.msdTriplet;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["_19" /* readMetadataSetMetadataSet */])(metadataSetId,msdTriplet));},onMetadataSetChange:function onMetadataSetChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["Y" /* changeMetadataSetMetadataSet */])(fields));},onMetadataSetSubmit:function onMetadataSetSubmit(metadataSet,categoryUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["_38" /* submitMetadataSetMetadataSet */])(metadataSet,categoryUrn));},onMetadataflowsShow:function onMetadataflowsShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["_34" /* showMetadataSetMetadataflows */])());},onMetadataflowsHide:function onMetadataflowsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["_12" /* hideMetadataSetMetadataflows */])());},fetchMetadataflows:function fetchMetadataflows(ownedMetadataflows){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["_20" /* readMetadataSetMetadataflows */])(ownedMetadataflows));},onMetadataflowSet:function onMetadataflowSet(triplet,msdUrn){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["_28" /* setMetadataSetMetadataflow */])(triplet,msdUrn));},onMetadataflowUnset:function onMetadataflowUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["_42" /* unsetMetadataSetMetadataflow */])());},fetchConceptSchemes:function fetchConceptSchemes(_ref2){var conceptSchemeTriplets=_ref2.conceptSchemeTriplets,appLang=_ref2.appLang,dataLangs=_ref2.dataLangs;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["_18" /* readMetadataSetConceptSchemes */])(conceptSchemeTriplets,appLang,dataLangs));}};};var MetadataSetDetailWrapper=function MetadataSetDetailWrapper(_ref3){var t=_ref3.t,permissions=_ref3.permissions,appLang=_ref3.appLang,dataLangs=_ref3.dataLangs,hasPermission=_ref3.hasPermission,metadataSetId=_ref3.metadataSetId,msdTriplet=_ref3.msdTriplet,metadataSet=_ref3.metadataSet,isMetadataflowsVisible=_ref3.isMetadataflowsVisible,metadataflows=_ref3.metadataflows,categoryUrn=_ref3.categoryUrn,isFetchMetadataSetDisabled=_ref3.isFetchMetadataSetDisabled,metadataSets=_ref3.metadataSets,metadataSetTree=_ref3.metadataSetTree,fetchMetadataSet=_ref3.fetchMetadataSet,onMetadataSetChange=_ref3.onMetadataSetChange,onMetadataSetSubmit=_ref3.onMetadataSetSubmit,onMetadataflowsShow=_ref3.onMetadataflowsShow,onMetadataflowsHide=_ref3.onMetadataflowsHide,fetchMetadataflows=_ref3.fetchMetadataflows,onMetadataflowSet=_ref3.onMetadataflowSet,onMetadataflowUnset=_ref3.onMetadataflowUnset,conceptSchemeTriplets=_ref3.conceptSchemeTriplets,fetchConceptSchemes=_ref3.fetchConceptSchemes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__hocs_call__["a" /* default */],{cb:fetchMetadataSet,cbParam:{metadataSetId:metadataSetId,msdTriplet:msdTriplet},disabled:metadataSetId===null||isFetchMetadataSetDisabled||metadataSetTree===null},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__hocs_call__["a" /* default */],{cb:fetchConceptSchemes,cbParam:{conceptSchemeTriplets:conceptSchemeTriplets,appLang:appLang,dataLangs:dataLangs},disabled:conceptSchemeTriplets===null||metadataSetTree===null},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default.a,{type:"inner",bodyStyle:{height:630,overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commons_MetadataSetDetail__["d" /* default */],{mode:metadataSet&&!!Object(__WEBPACK_IMPORTED_MODULE_18__utils_referenceMetadata__["F" /* getDbIdAnnotationFromAnnotations */])(metadataSet,__WEBPACK_IMPORTED_MODULE_18__utils_referenceMetadata__["w" /* METADATA_SET_ID_ANNOTATION_ID */])?hasPermission?__WEBPACK_IMPORTED_MODULE_15__commons_MetadataSetDetail__["b" /* METADATA_SET_DETAIL_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_15__commons_MetadataSetDetail__["c" /* METADATA_SET_DETAIL_MODE_READ */]:__WEBPACK_IMPORTED_MODULE_15__commons_MetadataSetDetail__["a" /* METADATA_SET_DETAIL_MODE_CREATE */],metadataSet:metadataSet,metadataSets:metadataSets,onMetadataSetChange:onMetadataSetChange,isMetadataflowsVisible:isMetadataflowsVisible,metadataflows:metadataflows,onMetadataflowsShow:onMetadataflowsShow,onMetadataflowsHide:onMetadataflowsHide,fetchMetadataflows:fetchMetadataflows,onMetadataflowSet:onMetadataflowSet,onMetadataflowUnset:onMetadataflowUnset})),hasPermission&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"end",style:{marginTop:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onMetadataSetSubmit(metadataSet,categoryUrn);},type:"primary",disabled:!metadataSet.id||metadataSet.id.length===0||Object(__WEBPACK_IMPORTED_MODULE_15__commons_MetadataSetDetail__["e" /* isMetadataSetIdWarningVisible */])(metadataSet,metadataSets)||!Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["d" /* isDictionaryValid */])(metadataSet.name)||!metadataSet.metadataflowTriplet||!metadataSet.msdUrn||!Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["c" /* isDateValid */])(metadataSet.reportingBegin,metadataSet.reportingEnd)||!Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["c" /* isDateValid */])(metadataSet.validFrom,metadataSet.validTo)||!Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["j" /* isYearValid */])(metadataSet.publicationYear)},t("commons.buttons.save.title"))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(MetadataSetDetailWrapper));

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_ReportDetail__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__ = __webpack_require__(77);
var mapStateToProps=function mapStateToProps(state){return{metadataSet:state.scenes.referenceMetadata.metadataSet.metadataSet,msdTree:state.scenes.referenceMetadata.metadataSet.msdTree,report:state.scenes.referenceMetadata.metadataSet.report,reportId:state.scenes.referenceMetadata.metadataSet.reportId,target:state.scenes.referenceMetadata.metadataSet.target,identifiableTargets:state.scenes.referenceMetadata.metadataSet.identifiableTargets,selectedIdentifiableTarget:state.scenes.referenceMetadata.metadataSet.selectedIdentifiableTarget,artefacts:state.scenes.referenceMetadata.metadataSet.artefacts,reportStructure:state.scenes.referenceMetadata.metadataSet.reportStructure,selectedAttribute:state.scenes.referenceMetadata.metadataSet.selectedAttribute,step:state.scenes.referenceMetadata.metadataSet.step,isCodesVisible:state.scenes.referenceMetadata.metadataSet.isCodesVisible,codes:state.scenes.referenceMetadata.metadataSet.codes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAttributeSelect:function onAttributeSelect(selectedAttributeKey){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_26" /* selectMetadataSetReportAttribute */])(selectedAttributeKey));},onAttributeChange:function onAttributeChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_0" /* changeMetadataSetReportAttribute */])(fields));},onAttributeCreate:function onAttributeCreate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_4" /* createMetadataSetReportAttribute */])());},onAttributeDelete:function onAttributeDelete(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_7" /* deleteMetadataSetReportAttribute */])());},onStepSet:function onStepSet(step,dataLanguages,t){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_30" /* setMetadataSetReportStep */])(step,dataLanguages,t));},onCodesShow:function onCodesShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_35" /* showMetadataSetReportAttributeCodes */])());},onCodesHide:function onCodesHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_14" /* hideMetadataSetReportAttributeCodes */])());},fetchCodes:function fetchCodes(triplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_22" /* readMetadataSetReportAttributeCodes */])(triplet));},onCodeSet:function onCodeSet(codeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_29" /* setMetadataSetReportAttributeCode */])(codeId));},onCodeUnset:function onCodeUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_43" /* unsetMetadataSetReportAttributeCode */])());},onIdChange:function onIdChange(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_1" /* changeMetadataSetReportId */])(id));},onTargetSelect:function onTargetSelect(target){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_27" /* selectMetadataSetReportTarget */])(target));},onArtefactsShow:function onArtefactsShow(identifiableTarget){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_37" /* showMetadataSetReportTargetArtefacts */])(identifiableTarget));},onArtefactsHide:function onArtefactsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_16" /* hideMetadataSetReportTargetArtefacts */])());},fetchArtefacts:function fetchArtefacts(_ref){var identifiableTarget=_ref.identifiableTarget;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_23" /* readMetadataSetReportTargetArtefacts */])(identifiableTarget));},onArtefactSet:function onArtefactSet(value,identifiableTargetId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_31" /* setMetadataSetReportTargetArtefact */])(value,identifiableTargetId));},onArtefactUnset:function onArtefactUnset(identifiableTarget){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_44" /* unsetMetadataSetReportTargetArtefact */])(identifiableTarget));},onAttachmentUpload:function onAttachmentUpload(file,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_45" /* uploadMetadataSetReportAttributeAttachment */])(file,lang));},onAttachmentDownload:function onAttachmentDownload(fileName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["_9" /* downloadMetadataSetReportAttributeAttachment */])(fileName));}};};var ReportDetailWrapper=function ReportDetailWrapper(_ref2){var hasPermission=_ref2.hasPermission,metadataSet=_ref2.metadataSet,msdTree=_ref2.msdTree,report=_ref2.report,reportId=_ref2.reportId,target=_ref2.target,identifiableTargets=_ref2.identifiableTargets,selectedIdentifiableTarget=_ref2.selectedIdentifiableTarget,artefacts=_ref2.artefacts,reportStructure=_ref2.reportStructure,selectedAttribute=_ref2.selectedAttribute,step=_ref2.step,isCodesVisible=_ref2.isCodesVisible,codes=_ref2.codes,onAttributeSelect=_ref2.onAttributeSelect,onAttributeChange=_ref2.onAttributeChange,onAttributeCreate=_ref2.onAttributeCreate,onAttributeDelete=_ref2.onAttributeDelete,onStepSet=_ref2.onStepSet,onCodesShow=_ref2.onCodesShow,onCodesHide=_ref2.onCodesHide,fetchCodes=_ref2.fetchCodes,onCodeSet=_ref2.onCodeSet,onCodeUnset=_ref2.onCodeUnset,onIdChange=_ref2.onIdChange,onTargetSelect=_ref2.onTargetSelect,onArtefactsShow=_ref2.onArtefactsShow,onArtefactsHide=_ref2.onArtefactsHide,fetchArtefacts=_ref2.fetchArtefacts,onArtefactSet=_ref2.onArtefactSet,onArtefactUnset=_ref2.onArtefactUnset,onAttachmentUpload=_ref2.onAttachmentUpload,onAttachmentDownload=_ref2.onAttachmentDownload;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commons_ReportDetail__["a" /* default */],{isDcat:false,hasPermission:hasPermission,isReadOnly:report!==null&&report.isPublished===__WEBPACK_IMPORTED_MODULE_4__utils_referenceMetadata__["B" /* REPORT_STATE_PUBLISHED */],step:step,metadataSet:metadataSet,msdTree:msdTree,reports:metadataSet&&metadataSet.reports?metadataSet.reports:[],report:report,reportStructure:reportStructure,selectedAttribute:selectedAttribute,reportId:reportId,target:target,identifiableTargets:identifiableTargets,selectedIdentifiableTarget:selectedIdentifiableTarget,artefacts:artefacts,isCodesVisible:isCodesVisible,codes:codes,onAttributeSelect:onAttributeSelect,onAttributeChange:onAttributeChange,onAttributeCreate:onAttributeCreate,onAttributeDelete:onAttributeDelete,onStepSet:onStepSet,onCodesShow:onCodesShow,onCodesHide:onCodesHide,fetchCodes:fetchCodes,onCodeSet:onCodeSet,onCodeUnset:onCodeUnset,onIdChange:onIdChange,onTargetSelect:onTargetSelect,onArtefactsShow:onArtefactsShow,onArtefactsHide:onArtefactsHide,fetchArtefacts:fetchArtefacts,onArtefactSet:onArtefactSet,onArtefactUnset:onArtefactUnset,onAttachmentUpload:onAttachmentUpload,onAttachmentDownload:onAttachmentDownload});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ReportDetailWrapper));

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submitDdbReset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var DDB_RESET_SUBMIT='DDB_RESET_SUBMIT';var submitDdbReset=function submitDdbReset(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(DDB_RESET_SUBMIT,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["_10" /* getDdbResetUrl */])(),null,function(t){return{success:t('scenes.dataManager.ddbReset.submit.success')};});};

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ArtefactSelectorCard__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducer__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__redux_components_redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__redux_components_redux_concept_scheme_detail_modal__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__redux_components_redux_category_scheme_detail_modal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__redux_components_redux_concept_scheme_detail_modal_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__redux_components_redux_category_scheme_detail_modal_actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_item_list__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_infinite_scroll_data_table__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_artefact_min_form__ = __webpack_require__(358);
var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,permissions:state.app.user.permissions,appLang:state.app.language,artefactType:state.scenes.utilities.mergeItemSchemes.artefactType,sourceFormat:state.scenes.utilities.mergeItemSchemes.sourceFormat,targetFormat:state.scenes.utilities.mergeItemSchemes.targetFormat,source:state.scenes.utilities.mergeItemSchemes.source,target:state.scenes.utilities.mergeItemSchemes.target,isArtefactsVisible:state.scenes.utilities.mergeItemSchemes.isArtefactsVisible,artefacts:state.scenes.utilities.mergeItemSchemes.artefacts,codelistDetail:state.scenes.utilities.mergeItemSchemes.codelistDetail,conceptSchemeDetail:state.scenes.utilities.mergeItemSchemes.conceptSchemeDetail,categorySchemeDetail:state.scenes.utilities.mergeItemSchemes.categorySchemeDetail,sourceCsvProps:state.scenes.utilities.mergeItemSchemes.sourceCsvProps,targetCsvProps:state.scenes.utilities.mergeItemSchemes.targetCsvProps,isMergeVisible:state.scenes.utilities.mergeItemSchemes.isMergeVisible,mergedItems:state.scenes.utilities.mergeItemSchemes.mergedItems,mergedItemScheme:state.scenes.utilities.mergeItemSchemes.mergedItemScheme,mergedItemsFromServer:state.scenes.utilities.mergeItemSchemes.mergedItemsFromServer,mergeCodelistTriplet:state.scenes.utilities.mergeItemSchemes.mergeCodelistTriplet,mergeCodelistItemCount:state.scenes.utilities.mergeItemSchemes.mergeCodelistItemCount,mergeCodelistFetchParams:state.scenes.utilities.mergeItemSchemes.mergeCodelistFetchParams,agencies:state.scenes.utilities.mergeItemSchemes.agencies,isSourcePreview:state.scenes.utilities.mergeItemSchemes.isSourcePreview,isXmlPreviewVisible:state.scenes.utilities.mergeItemSchemes.isXmlPreviewVisible,isCsvPreviewVisible:state.scenes.utilities.mergeItemSchemes.isCsvPreviewVisible,previewItems:state.scenes.utilities.mergeItemSchemes.previewItems,previewItemCount:state.scenes.utilities.mergeItemSchemes.previewItemCount,previewCodelistTriplet:state.scenes.utilities.mergeItemSchemes.previewCodelistTriplet,previewItemParams:state.scenes.utilities.mergeItemSchemes.previewItemParams,csvFilePath:state.scenes.utilities.mergeItemSchemes.csvFilePath,allCsvRows:state.scenes.utilities.mergeItemSchemes.allCsvRows,mergeConflict:state.scenes.utilities.mergeItemSchemes.mergeConflict};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onArtefactTypeChange:function onArtefactTypeChange(artefactType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["H" /* changeMergeItemSchemesArtefactType */])(artefactType));},onFormatChange:function onFormatChange(isSource,format,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["K" /* changeMergeItemSchemesFormat */])(isSource,format,lang));},onCsvPropsChange:function onCsvPropsChange(isSource,fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["J" /* changeMergeItemSchemesCsvProps */])(isSource,fields));},onFileSet:function onFileSet(isSource,file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["Y" /* setMergeItemSchemesFile */])(isSource,file));},onArtefactsShow:function onArtefactsShow(isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["Z" /* showMergeItemSchemesArtefacts */])(isSource));},onArtefactsHide:function onArtefactsHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["N" /* hideMergeItemSchemesArtefacts */])());},fetchArtefacts:function fetchArtefacts(artefactType){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["R" /* readMergeItemSchemesArtefacts */])(artefactType));},onArtefactSet:function onArtefactSet(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["X" /* setMergeItemSchemesArtefact */])(artefactTriplet));},onArtefactUnset:function onArtefactUnset(isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_4" /* unsetMergeItemSchemesArtefact */])(isSource));},onCodelistDetail:function onCodelistDetail(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_27__redux_components_redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_19__reducer__["b" /* UTILITIES_MERGE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX */]));},onConceptSchemeDetail:function onConceptSchemeDetail(conceptSchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_28__redux_components_redux_concept_scheme_detail_modal_actions__["_38" /* showConceptSchemeDetail */])(conceptSchemeTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_19__reducer__["c" /* UTILITIES_MERGE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX */]));},onCategorySchemeDetail:function onCategorySchemeDetail(categorySchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_29__redux_components_redux_category_scheme_detail_modal_actions__["_40" /* showCategorySchemeDetail */])(categorySchemeTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_19__reducer__["a" /* UTILITIES_MERGE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX */]));},fetchMergePreview:function fetchMergePreview(artefactType,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["U" /* readMergeItemSchemesMergePreview */])(artefactType,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps,lang));},onMergePreviewHide:function onMergePreviewHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["P" /* hideMergeItemSchemesMergePreview */])());},onCodesParamsUpdate:function onCodesParamsUpdate(fetchPageParams){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_5" /* updateMergeItemSchemesCodelistMergePreviewParams */])(fetchPageParams));},onCodesLangChange:function onCodesLangChange(lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["I" /* changeMergeItemSchemesCodelistMergePreviewLang */])(lang));},fetchCodesPage:function fetchCodesPage(_ref){var triplet=_ref.triplet,lang=_ref.lang,pageNum=_ref.pageNum,pageSize=_ref.pageSize,searchText=_ref.searchText,filters=_ref.filters,sortCol=_ref.sortCol,sortByDesc=_ref.sortByDesc,rebuildDb=_ref.rebuildDb;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["S" /* readMergeItemSchemesCodelistPage */])(triplet,lang,pageNum,pageSize,searchText,filters,sortCol,sortByDesc,rebuildDb));},onMergeShow:function onMergeShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_1" /* showMergeItemSchemesMerge */])());},onMergeHide:function onMergeHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["O" /* hideMergeItemSchemesMerge */])());},onMergeChange:function onMergeChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["L" /* changeMergeItemSchemesMerge */])(fields));},onMergeSubmit:function onMergeSubmit(artefactType,mergedItemScheme,mergedItemsFromServer,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_3" /* submitMergeItemSchemesMerge */])(artefactType,mergedItemScheme,mergedItemsFromServer,lang));},onPreviewHide:function onPreviewHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["Q" /* hideMergeItemSchemesPreview */])());},fetchXmlPreview:function fetchXmlPreview(_ref2){var artefactType=_ref2.artefactType,file=_ref2.file,lang=_ref2.lang;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["V" /* readMergeItemSchemesXmlPreview */])(artefactType,file,lang));},onXmlPreviewParamsUpdate:function onXmlPreviewParamsUpdate(fetchPageParams){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_6" /* updateMergeItemSchemesXmlPreviewParams */])(fetchPageParams));},onXmlPreviewLangChange:function onXmlPreviewLangChange(lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["M" /* changeMergeItemSchemesXmlPreviewLang */])(lang));},fetchXmlPreviewPage:function fetchXmlPreviewPage(_ref3){var triplet=_ref3.triplet,lang=_ref3.lang,pageNum=_ref3.pageNum,pageSize=_ref3.pageSize,searchText=_ref3.searchText,filters=_ref3.filters,sortCol=_ref3.sortCol,sortByDesc=_ref3.sortByDesc,rebuildDb=_ref3.rebuildDb;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["W" /* readMergeItemSchemesXmlPreviewPage */])(triplet,lang,pageNum,pageSize,searchText,filters,sortCol,sortByDesc,rebuildDb));},onCsvFileUpload:function onCsvFileUpload(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_7" /* uploadMergeItemSchemesCsvFile */])(file));},fetchCsvRows:function fetchCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["T" /* readMergeItemSchemesCsvPage */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,filePath));}};};var MergeItemSchemes=function MergeItemSchemes(_ref4){var t=_ref4.t,nodeId=_ref4.nodeId,nodes=_ref4.nodes,permissions=_ref4.permissions,appLang=_ref4.appLang,artefactType=_ref4.artefactType,sourceFormat=_ref4.sourceFormat,targetFormat=_ref4.targetFormat,source=_ref4.source,target=_ref4.target,isArtefactsVisible=_ref4.isArtefactsVisible,artefacts=_ref4.artefacts,codelistDetail=_ref4.codelistDetail,conceptSchemeDetail=_ref4.conceptSchemeDetail,categorySchemeDetail=_ref4.categorySchemeDetail,sourceCsvProps=_ref4.sourceCsvProps,targetCsvProps=_ref4.targetCsvProps,isMergeVisible=_ref4.isMergeVisible,mergedItems=_ref4.mergedItems,mergedItemScheme=_ref4.mergedItemScheme,mergedItemsFromServer=_ref4.mergedItemsFromServer,mergeCodelistTriplet=_ref4.mergeCodelistTriplet,mergeCodelistItemCount=_ref4.mergeCodelistItemCount,mergeCodelistFetchParams=_ref4.mergeCodelistFetchParams,agencies=_ref4.agencies,isSourcePreview=_ref4.isSourcePreview,isXmlPreviewVisible=_ref4.isXmlPreviewVisible,isCsvPreviewVisible=_ref4.isCsvPreviewVisible,previewItems=_ref4.previewItems,previewItemCount=_ref4.previewItemCount,previewCodelistTriplet=_ref4.previewCodelistTriplet,previewItemParams=_ref4.previewItemParams,csvFilePath=_ref4.csvFilePath,allCsvRows=_ref4.allCsvRows,onArtefactTypeChange=_ref4.onArtefactTypeChange,_onFormatChange=_ref4.onFormatChange,_onCsvPropsChange=_ref4.onCsvPropsChange,_onFileSet=_ref4.onFileSet,_onArtefactsShow=_ref4.onArtefactsShow,onArtefactsHide=_ref4.onArtefactsHide,fetchArtefacts=_ref4.fetchArtefacts,onArtefactSet=_ref4.onArtefactSet,_onArtefactUnset=_ref4.onArtefactUnset,onCodelistDetail=_ref4.onCodelistDetail,onConceptSchemeDetail=_ref4.onConceptSchemeDetail,onCategorySchemeDetail=_ref4.onCategorySchemeDetail,fetchMergePreview=_ref4.fetchMergePreview,onMergePreviewHide=_ref4.onMergePreviewHide,fetchCodesPage=_ref4.fetchCodesPage,onCodesParamsUpdate=_ref4.onCodesParamsUpdate,onCodesLangChange=_ref4.onCodesLangChange,onMergeShow=_ref4.onMergeShow,onMergeHide=_ref4.onMergeHide,onMergeChange=_ref4.onMergeChange,onMergeSubmit=_ref4.onMergeSubmit,onPreviewHide=_ref4.onPreviewHide,fetchXmlPreview=_ref4.fetchXmlPreview,onXmlPreviewParamsUpdate=_ref4.onXmlPreviewParamsUpdate,onXmlPreviewLangChange=_ref4.onXmlPreviewLangChange,fetchXmlPreviewPage=_ref4.fetchXmlPreviewPage,onCsvFileUpload=_ref4.onCsvFileUpload,fetchCsvRows=_ref4.fetchCsvRows,mergeConflict=_ref4.mergeConflict;var defaultItemsViewMode=nodes.find(function(node){return node.general.id===nodeId;}).general.defaultItemsViewMode;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],align:"middle"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,t("scenes.utilities.mergeItemSchemes.selectArtefactType.label")),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Group,{value:artefactType,onChange:function onChange(_ref5){var target=_ref5.target;return onArtefactTypeChange(target.value);}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]},"Codelists"),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_16__actions__["e" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME */]},"Category Schemes"),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_16__actions__["h" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]},"Concept Schemes"))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return fetchMergePreview(artefactType,source,sourceFormat,sourceCsvProps,target,targetFormat,targetCsvProps,appLang);},disabled:!source||!target||sourceFormat===__WEBPACK_IMPORTED_MODULE_16__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&(!sourceCsvProps.lang||!sourceCsvProps.textSeparator||sourceCsvProps.textSeparator.length<1)||targetFormat===__WEBPACK_IMPORTED_MODULE_16__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&(!targetCsvProps.lang||!targetCsvProps.textSeparator||targetCsvProps.textSeparator.length<1)},t("scenes.utilities.mergeItemSchemes.buttons.merge.title")))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ArtefactSelectorCard__["a" /* default */],{isSource:true,title:(artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?"Codelist":artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["h" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?"Concept Scheme":"Category Scheme")+" 1",format:sourceFormat,onFormatChange:function onFormatChange(format){return _onFormatChange(true,format,appLang);},artefact:source,csvProps:sourceCsvProps,onArtefactDetailShow:function onArtefactDetailShow(){return artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?onCodelistDetail(source,defaultItemsViewMode):artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["h" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?onConceptSchemeDetail(source,defaultItemsViewMode):onCategorySchemeDetail(source,defaultItemsViewMode);},onArtefactsShow:function onArtefactsShow(){return _onArtefactsShow(true);},onArtefactUnset:function onArtefactUnset(){return _onArtefactUnset(true);},onFileSet:function onFileSet(file){return _onFileSet(true,file);},onCsvPropsChange:function onCsvPropsChange(fields){return _onCsvPropsChange(true,fields);}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ArtefactSelectorCard__["a" /* default */],{isSource:false,title:(artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?"Codelist":artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["h" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?"Concept Scheme":"Category Scheme")+" 2",format:targetFormat,onFormatChange:function onFormatChange(format){return _onFormatChange(false,format,appLang);},artefact:target,csvProps:targetCsvProps,onArtefactDetailShow:function onArtefactDetailShow(){return artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?onCodelistDetail(target,defaultItemsViewMode):artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["h" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?onConceptSchemeDetail(target,defaultItemsViewMode):onCategorySchemeDetail(target,defaultItemsViewMode);},onArtefactsShow:function onArtefactsShow(){return _onArtefactsShow(false);},onArtefactUnset:function onArtefactUnset(){return _onArtefactUnset(false);},onFileSet:function onFileSet(file){return _onFileSet(false,file);},onCsvPropsChange:function onCsvPropsChange(fields){return _onCsvPropsChange(false,fields);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isArtefactsVisible,onCancel:onArtefactsHide,title:t('scenes.utilities.mergeItemSchemes.modals.artefactList.title'),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onArtefactsHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__hocs_call__["a" /* default */],{cb:fetchArtefacts,cbParam:artefactType},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_artefact_list__["a" /* default */],{artefacts:artefacts,onRowClick:function onRowClick(_ref6){var id=_ref6.id,agencyID=_ref6.agencyID,version=_ref6.version;return onArtefactSet({id:id,agencyID:agencyID,version:version});},onDetailShow:function onDetailShow(_ref7){var id=_ref7.id,agencyID=_ref7.agencyID,version=_ref7.version;return artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?onCodelistDetail({id:id,agencyID:agencyID,version:version},defaultItemsViewMode):artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["h" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CONCEPT_SCHEME */]?onConceptSchemeDetail({id:id,agencyID:agencyID,version:version},defaultItemsViewMode):onCategorySchemeDetail({id:id,agencyID:agencyID,version:version},defaultItemsViewMode);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:mergedItems!==null,onCancel:onMergePreviewHide,title:t('scenes.utilities.mergeItemSchemes.modals.mergePreview.title'),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onMergePreviewHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onMergeShow(permissions?permissions.agencies:undefined);}},t('commons.buttons.goForward.title'))),withDataLanguageSelector:true,onDataLanguageSelectorChange:function onDataLanguageSelectorChange(lang,changeLang){onCodesLangChange(lang);changeLang();}},mergeConflict&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a,{type:"warning",showIcon:true,message:t('scenes.utilities.mergeItemSchemes.modals.mergePreview.mergedWithConflicts.message')}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLang;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__hocs_call__["a" /* default */],{cb:fetchCodesPage,cbParam:mergeCodelistFetchParams,disabled:artefactType!==__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]||!mergeCodelistFetchParams},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__components_infinite_scroll_table__["a" /* default */],{data:mergedItems,getRowKey:function getRowKey(_ref8){var id=_ref8.id;return id;},columns:[{title:t('data.item.id.shortLabel'),dataIndex:'id',minWidth:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},{title:t('data.item.name.shortLabel'),dataIndex:'name',minWidth:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["TABLE_COL_MIN_WIDTH_NAME"]},{title:t('data.item.parent.shortLabel'),dataIndex:'parent',minWidth:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["TABLE_COL_MIN_WIDTH_ID"]},mergeConflict?{title:t('data.artefact.mergeConflict.shortLabel'),dataIndex:"mergeConflict",width:30,withValuesFilter:true,render:function render(mergeConflict){return mergeConflict?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:"check"}):null;},renderText:function renderText(mergeConflict){return mergeConflict?t('data.artefact.mergeConflict.values.withMergeConflict'):t('data.artefact.mergeConflict.values.withoutMergeConflict');}}:null],multilangStrDataIndexes:["name"],isPaginated:artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */],rowCount:artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?mergeCodelistItemCount:null,onChange:function onChange(_ref9){var pageNum=_ref9.pageNum,pageSize=_ref9.pageSize,searchText=_ref9.searchText,filters=_ref9.filters,sortCol=_ref9.sortCol,sortByDesc=_ref9.sortByDesc;return onCodesParamsUpdate({triplet:mergeCodelistTriplet,lang:lang,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc,rebuildDb:false});}}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isMergeVisible,onCancel:onMergeHide,title:t('scenes.utilities.mergeItemSchemes.modals.mergedItemScheme.title'),withDataLanguageSelector:true,width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_MD"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onMergeHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_32__utils_artefactValidators__["a" /* isArtefactValid */])(mergedItemScheme)){onMergeSubmit(artefactType,mergedItemScheme,mergedItemsFromServer,lang);}else{}}},t('commons.buttons.create.title')))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_artefact_min_form__["b" /* default */],{artefact:mergedItemScheme,agencies:agencies,onChange:onMergeChange,mode:__WEBPACK_IMPORTED_MODULE_36__components_artefact_min_form__["a" /* ARTEFACT_MIN_FORM_MODE_CREATE */]})));})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__hocs_call__["a" /* default */],{cb:fetchXmlPreview,cbParam:{artefactType:artefactType,file:isSourcePreview?source:target,lang:appLang},disabled:!isXmlPreviewVisible},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isXmlPreviewVisible&&previewItems!==null,onCancel:onPreviewHide,title:t('scenes.utilities.mergeItemSchemes.modals.xmlPreview.title'),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onPreviewHide},t('commons.buttons.close.title')),withDataLanguageSelector:true,onDataLanguageSelectorChange:function onDataLanguageSelectorChange(lang,changeLang){onXmlPreviewLangChange(lang);changeLang();}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLang;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__hocs_call__["a" /* default */],{cb:fetchXmlPreviewPage,cbParam:previewItemParams,disabled:!isXmlPreviewVisible||artefactType!==__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]||!previewItemParams||!previewItems},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_item_list__["a" /* default */],{data:previewItems,hideOrderCol:true,isPaginated:artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */],rowCount:artefactType===__WEBPACK_IMPORTED_MODULE_16__actions__["g" /* MERGE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST */]?previewItemCount:null,onChange:function onChange(_ref10){var pageNum=_ref10.pageNum,pageSize=_ref10.pageSize,searchText=_ref10.searchText,filters=_ref10.filters,sortCol=_ref10.sortCol,sortByDesc=_ref10.sortByDesc;return onXmlPreviewParamsUpdate({triplet:previewCodelistTriplet,lang:lang,pageNum:pageNum,pageSize:pageSize,searchText:searchText,filters:filters,sortCol:sortCol,sortByDesc:sortByDesc,rebuildDb:false});}}));}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_enhanced_modal__["a" /* default */],{visible:isCsvPreviewVisible,onCancel:onPreviewHide,title:t('scenes.utilities.mergeItemSchemes.modals.csvPreview.title'),width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onPreviewHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__hocs_call__["a" /* default */],{cb:onCsvFileUpload,cbParam:isSourcePreview?source:target,disabled:!isCsvPreviewVisible},csvFilePath&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_infinite_scroll_data_table__["a" /* default */],{data:allCsvRows&&allCsvRows.Data,rowTotal:allCsvRows&&allCsvRows.Count,cols:allCsvRows&&allCsvRows.Columns,hiddenCols:["NumRow"],onChange:function onChange(_ref11){var pageNum=_ref11.pageNum,pageSize=_ref11.pageSize,searchText=_ref11.searchText,filters=_ref11.filters,sortCol=_ref11.sortCol,sortByDesc=_ref11.sortByDesc;return fetchCsvRows(pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_34__utils_filter__["b" /* getFilterObjFromViewerObj */])(allCsvRows&&allCsvRows.Columns.filter(function(colName){return colName!=='NumRow';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc,isSourcePreview?sourceCsvProps.textSeparator:targetCsvProps.textSeparator,isSourcePreview?sourceCsvProps.textDelimiter:targetCsvProps.textDelimiter,isSourcePreview?sourceCsvProps.firstRowHeader:targetCsvProps.firstRowHeader,csvFilePath);}}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__redux_components_redux_codelist_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_19__reducer__["b" /* UTILITIES_MERGE_ITEM_SCHEMES_CODELIST_DETAIL_PREFIX */],instanceState:codelistDetail}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__redux_components_redux_concept_scheme_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_19__reducer__["c" /* UTILITIES_MERGE_ITEM_SCHEMES_CONCEPT_SCHEME_DETAIL_PREFIX */],instanceState:conceptSchemeDetail}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__redux_components_redux_category_scheme_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_19__reducer__["a" /* UTILITIES_MERGE_ITEM_SCHEMES_CATEGORY_SCHEME_DETAIL_PREFIX */],instanceState:categorySchemeDetail}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(MergeItemSchemes));

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_languages__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__actions__ = __webpack_require__(343);
var mapStateToProps=function mapStateToProps(state){return{appLang:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,artefactType:state.scenes.utilities.mergeItemSchemes.artefactType};};var mapPropsToFields=function mapPropsToFields(_ref){var csvProps=_ref.csvProps;return{lang:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:csvProps?csvProps.lang:null}),textSeparator:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:csvProps?csvProps.textSeparator:null}),textDelimiter:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:csvProps?csvProps.textDelimiter:null}),firstRowHeader:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:csvProps?csvProps.firstRowHeader:null})};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onXmlPreviewShow:function onXmlPreviewShow(isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_2" /* showMergeItemSchemesXmlPreview */])(isSource));},onCsvPreviewShow:function onCsvPreviewShow(isSource){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions__["_0" /* showMergeItemSchemesCsvPreview */])(isSource));}};};var onFieldsChange=function onFieldsChange(props,fields){return props.onCsvPropsChange(__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;}));};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_HALF"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_HALF"]}};var ArtefactSelectorCard=function ArtefactSelectorCard(_ref3){var t=_ref3.t,form=_ref3.form,dataLanguages=_ref3.dataLanguages,title=_ref3.title,format=_ref3.format,onFormatChange=_ref3.onFormatChange,artefact=_ref3.artefact,isSource=_ref3.isSource,onFileSet=_ref3.onFileSet,onArtefactDetailShow=_ref3.onArtefactDetailShow,onArtefactsShow=_ref3.onArtefactsShow,onArtefactUnset=_ref3.onArtefactUnset,onXmlPreviewShow=_ref3.onXmlPreviewShow,onCsvPreviewShow=_ref3.onCsvPreviewShow;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{title:title,type:'inner'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:'flex',justify:'center',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Group,{value:format,onChange:function onChange(_ref4){var target=_ref4.target;return onFormatChange(target.value);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_25__actions__["t" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]},'MSDB'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_25__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]},'CSV'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_25__actions__["u" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_SDMX */]},'SDMX-ML'))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_row___default.a,{type:'flex',justify:'center',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MARGIN_MD"]}},format===__WEBPACK_IMPORTED_MODULE_25__actions__["t" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_MSDB */]?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_selector__["a" /* default */],{value:artefact&&artefact.id+'+'+artefact.agencyID+'+'+artefact.version,detailTitle:t('scenes.utilities.mergeItemSchemes.artefactSelectorCard.selector.detail.title'),selectTitle:t('scenes.utilities.mergeItemSchemes.artefactSelectorCard.selector.select.title'),resetTitle:t('scenes.utilities.mergeItemSchemes.artefactSelectorCard.selector.reset.title'),onDetail:onArtefactDetailShow,onSelect:onArtefactsShow,onReset:onArtefactUnset}):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{width:120,marginRight:8,display:"inline-block",verticalAlign:"middle"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',style:{width:"100%"},onClick:function onClick(){return format===__WEBPACK_IMPORTED_MODULE_25__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]?onCsvPreviewShow(isSource):onXmlPreviewShow(isSource);},disabled:!artefact},t('commons.buttons.preview.title'))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{width:"calc(100% - 128px)",display:"inline-block",verticalAlign:"middle"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_file_input__["a" /* default */],{value:artefact,onChange:onFileSet,accept:format===__WEBPACK_IMPORTED_MODULE_25__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]?".csv":".xml"})))),format===__WEBPACK_IMPORTED_MODULE_25__actions__["s" /* MERGE_ITEM_SCHEMES_FORMAT_TYPE_CSV */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.commons.language.label')},formItemLayout),form.getFieldDecorator('lang')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref5){var props=_ref5.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},style:{width:160}},dataLanguages.map(function(_ref6){var code=_ref6.code;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{key:code,value:code,title:Object(__WEBPACK_IMPORTED_MODULE_22__utils_languages__["c" /* getLanguageLabel */])(t,code)},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('i',{className:'flag-icon '+Object(__WEBPACK_IMPORTED_MODULE_22__utils_languages__["b" /* getLanguageFlagIconCss */])(code,dataLanguages),style:{marginRight:8}}),Object(__WEBPACK_IMPORTED_MODULE_22__utils_languages__["c" /* getLanguageLabel */])(t,code));})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.csv.hasHeader.label')},formItemLayout),form.getFieldDecorator('firstRowHeader',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,null))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.csv.separator.label')},formItemLayout),form.getFieldDecorator('textSeparator')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{maxLength:1,style:{width:48}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({label:t('data.csv.delimiter.label')},formItemLayout),form.getFieldDecorator('textDelimiter')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{maxLength:1,style:{width:48}})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_18_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_24_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ArtefactSelectorCard));

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__List__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Detail__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_artefact_clone_form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_download__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_artefact_download_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,hierarchicalCodelist:state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelist,allAgencies:state.scenes.metaManager.hierarchicalCodelists.allAgencies,downloadHierarchicalCodelistTriplets:state.scenes.metaManager.hierarchicalCodelists.downloadHierarchicalCodelistTriplets,downloadHierarchicalCodelistLang:state.scenes.metaManager.hierarchicalCodelists.downloadHierarchicalCodelistLang,downloadHierarchicalCodelistParams:state.scenes.metaManager.hierarchicalCodelists.downloadHierarchicalCodelistParams,cloneDestTriplet:state.scenes.metaManager.hierarchicalCodelists.cloneDestTriplet,hierarchicalCodelistExportSourceTriplet:state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistExportSourceTriplet,hierarchicalCodelistExportDestination:state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistExportDestination,hierarchicalCodelistExportReport:state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistExportReport,user:state.app.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCloneHide:function onCloneHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["F" /* hideHierarchicalCodelistsHierarchicalCodelistClone */])());},onCloneChange:function onCloneChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["y" /* changeHierarchicalCodelistsHierarchicalCodelistClone */])(fields));},onCloneSubmit:function onCloneSubmit(cloneDestTriplet,srcHierarchicalCodelist,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["T" /* submitHierarchicalCodelistsHierarchicalCodelistClone */])(cloneDestTriplet,srcHierarchicalCodelist,annotationsConfig));},onExportHide:function onExportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["I" /* hideHierarchicalCodelistsHierarchicalCodelistExport */])());},onExportChange:function onExportChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["B" /* changeHierarchicalCodelistsHierarchicalCodelistExport */])(fields));},onExportSubmit:function onExportSubmit(sourceTriplet,destination){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["V" /* submitHierarchicalCodelistsHierarchicalCodelistExport */])(sourceTriplet,destination));},onExportReportHide:function onExportReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["J" /* hideHierarchicalCodelistsHierarchicalCodelistExportReport */])());},onDownloadHide:function onDownloadHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["H" /* hideHierarchicalCodelistsHierarchicalCodelistDownload */])());},onDownloadChange:function onDownloadChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["A" /* changeHierarchicalCodelistsHierarchicalCodelistDownload */])(fields));},onDownload:function onDownload(hierarchicalCodelistTriplets,downloadHierarchicalCodelistParams,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["E" /* downloadHierarchicalCodelistsHierarchicalCodelist */])(hierarchicalCodelistTriplets,downloadHierarchicalCodelistParams,lang));}};};var HierarchicalCodelists=function HierarchicalCodelists(_ref){var t=_ref.t,endpoints=_ref.endpoints,cloneDestTriplet=_ref.cloneDestTriplet,hierarchicalCodelist=_ref.hierarchicalCodelist,endpointId=_ref.endpointId,allAgencies=_ref.allAgencies,onCloneHide=_ref.onCloneHide,onCloneChange=_ref.onCloneChange,onCloneSubmit=_ref.onCloneSubmit,hierarchicalCodelistExportSourceTriplet=_ref.hierarchicalCodelistExportSourceTriplet,hierarchicalCodelistExportDestination=_ref.hierarchicalCodelistExportDestination,hierarchicalCodelistExportReport=_ref.hierarchicalCodelistExportReport,user=_ref.user,onExportHide=_ref.onExportHide,onExportChange=_ref.onExportChange,onExportSubmit=_ref.onExportSubmit,onExportReportHide=_ref.onExportReportHide,onDownloadHide=_ref.onDownloadHide,onDownloadChange=_ref.onDownloadChange,onDownload=_ref.onDownload,downloadHierarchicalCodelistParams=_ref.downloadHierarchicalCodelistParams,downloadHierarchicalCodelistTriplets=_ref.downloadHierarchicalCodelistTriplets,downloadHierarchicalCodelistLang=_ref.downloadHierarchicalCodelistLang;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__List__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Detail__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__["a" /* default */],{visible:cloneDestTriplet!==null,width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_MD"],title:t('commons.artefact.modals.clone.title'),onCancel:onCloneHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onCloneHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){if(!Object(__WEBPACK_IMPORTED_MODULE_13__utils_artefactValidators__["b" /* isCloneDestTripletValid */])(cloneDestTriplet)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}else{onCloneSubmit(cloneDestTriplet,hierarchicalCodelist,endpoints.find(function(endpoint){return endpoint.general.id===endpointId;}).annotations);}},type:"primary"},t('commons.artefact.modals.clone.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_artefact_clone_form__["a" /* default */],{agencies:allAgencies,srcArtefact:hierarchicalCodelist,destTriplet:cloneDestTriplet,onChange:onCloneChange})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__["a" /* default */],{visible:hierarchicalCodelistExportSourceTriplet!==null,title:t('commons.artefact.modals.export.title'),width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onExportHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_13__utils_artefactValidators__["e" /* isExportDestinationValid */])(hierarchicalCodelistExportDestination,(user&&user.providerId)!==null)){onExportSubmit(hierarchicalCodelistExportSourceTriplet,hierarchicalCodelistExportDestination);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t('commons.artefact.modals.export.buttons.submit.title')))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_artefact_export_form__["b" /* default */],{type:"hierarchicalcodelist",agencies:allAgencies,sourceTriplet:hierarchicalCodelistExportSourceTriplet,destination:hierarchicalCodelistExportDestination,onChange:onExportChange})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__["a" /* default */],{visible:hierarchicalCodelistExportReport!==null,title:t('commons.artefact.modals.exportReport.title'),width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_MD"],onCancel:onExportReportHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onExportReportHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_artefact_export_report__["a" /* default */],{report:hierarchicalCodelistExportReport})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_enhanced_modal__["a" /* default */],{visible:downloadHierarchicalCodelistTriplets!==null&&downloadHierarchicalCodelistTriplets!==undefined,onCancel:onDownloadHide,footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onDownloadHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(){return onDownload(downloadHierarchicalCodelistTriplets,downloadHierarchicalCodelistParams,downloadHierarchicalCodelistLang);},type:"primary",disabled:downloadHierarchicalCodelistParams&&downloadHierarchicalCodelistParams.format===null||downloadHierarchicalCodelistParams&&downloadHierarchicalCodelistParams.format===__WEBPACK_IMPORTED_MODULE_17__constants_download__["n" /* DOWNLOAD_FORMAT_TYPE_CSV */]&&(downloadHierarchicalCodelistParams.csvSeparator===null||downloadHierarchicalCodelistParams.csvSeparator.length!==1||downloadHierarchicalCodelistParams.csvLanguage===null)},t('commons.buttons.download.title'))),width:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MODAL_WIDTH_SM"],title:downloadHierarchicalCodelistTriplets&&downloadHierarchicalCodelistTriplets.length>1?t('scenes.metaManager.commons.modals.download.titleMulti'):t('scenes.metaManager.commons.modals.download.title',{triplet:downloadHierarchicalCodelistTriplets?Object(__WEBPACK_IMPORTED_MODULE_19__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(downloadHierarchicalCodelistTriplets[0]):""})},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_artefact_download_form__["a" /* default */],{downloadArtefactForm:downloadHierarchicalCodelistParams,onChange:onDownloadChange,options:Object(__WEBPACK_IMPORTED_MODULE_17__constants_download__["v" /* getArtefactDownloadOptions */])(t,downloadHierarchicalCodelistTriplets&&downloadHierarchicalCodelistTriplets.length>1?__WEBPACK_IMPORTED_MODULE_17__constants_download__["l" /* ARTEFACT_TYPE_MULTIPLE */]:__WEBPACK_IMPORTED_MODULE_17__constants_download__["i" /* ARTEFACT_TYPE_HIERARCHICAL_CODELIST */]),hasReferences:true})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(HierarchicalCodelists));

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(194);
var mapStateToProps=function mapStateToProps(state){return{hierarchicalCodelists:state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelists,parentsAndChildren:state.scenes.metaManager.hierarchicalCodelists.parentsAndChildren};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchHierarchicalCodelists:function fetchHierarchicalCodelists(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["O" /* readHierarchicalCodelistsListHierarchicalCodelists */])());},onHierarchicalCodelistShow:function onHierarchicalCodelistShow(hierarchicalCodelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["Q" /* showHierarchicalCodelistsHierarchicalCodelistDetail */])(hierarchicalCodelistTriplet));},onDelete:function onDelete(hierarchicalCodelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["C" /* deleteHierarchicalCodelistsHierarchicalCodelist */])(hierarchicalCodelistTriplet));},onSelectedHierarchicalCodelistsDelete:function onSelectedHierarchicalCodelistsDelete(hierarchicalCodelistTriplets){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["D" /* deleteHierarchicalCodelistsSelectedHierarchicalCodelists */])(hierarchicalCodelistTriplets));},fetchParentsAndChildren:function fetchParentsAndChildren(artefactType,artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["N" /* readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren */])(artefactType,artefactTriplet));},onParentsAndChildrenHide:function onParentsAndChildrenHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["K" /* hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren */])());},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["P" /* showHierarchicalCodelistsHierarchicalCodelistClone */])(artefactTriplet));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["S" /* showHierarchicalCodelistsHierarchicalCodelistExport */])(sourceTriplet));},onDownloadShow:function onDownloadShow(hierarchicalCodelistTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["R" /* showHierarchicalCodelistsHierarchicalCodelistDownload */])(hierarchicalCodelistTriplets,lang));}};};var HierarchicalCodelistsList=function HierarchicalCodelistsList(_ref){var hierarchicalCodelists=_ref.hierarchicalCodelists,fetchHierarchicalCodelists=_ref.fetchHierarchicalCodelists,onHierarchicalCodelistShow=_ref.onHierarchicalCodelistShow,onDelete=_ref.onDelete,onSelectedHierarchicalCodelistsDelete=_ref.onSelectedHierarchicalCodelistsDelete,onDownloadShow=_ref.onDownloadShow,parentsAndChildren=_ref.parentsAndChildren,_fetchParentsAndChildren=_ref.fetchParentsAndChildren,onParentsAndChildrenHide=_ref.onParentsAndChildrenHide,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hocs_call__["a" /* default */],{cb:fetchHierarchicalCodelists,disabled:hierarchicalCodelists!==null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_artefact_list__["a" /* default */],{artefacts:hierarchicalCodelists,onDetailShow:onHierarchicalCodelistShow,onDownloadShow:onDownloadShow,onDelete:onDelete,onSelectedItemDelete:onSelectedHierarchicalCodelistsDelete,parentsAndChildren:parentsAndChildren,fetchParentsAndChildren:function fetchParentsAndChildren(triplet){return _fetchParentsAndChildren("hierarchicalCodelist",triplet);},onParentsAndChildrenHide:onParentsAndChildrenHide,showImportButton:true,onCloneShow:onCloneShow,onExportShow:onExportShow}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(HierarchicalCodelistsList));

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_artefact_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{nodes:state.config.nodes,nodeId:state.app.endpointId,permissions:state.app.user.permissions,appLanguage:state.app.language,isVisible:state.scenes.metaManager.hierarchicalCodelists.isVisible,hierarchicalCodelistTriplet:state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistTriplet,hierarchicalCodelist:state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelist,agencies:state.scenes.metaManager.hierarchicalCodelists.agencies};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHierarchicalCodelistDetailHide:function onHierarchicalCodelistDetailHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["G" /* hideHierarchicalCodelistsHierarchicalCodelistDetail */])());},onHierarchicalCodelistDetailChange:function onHierarchicalCodelistDetailChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["z" /* changeHierarchicalCodelistsHierarchicalCodelistDetail */])(fields));},onHierarchicalCodelistDetailUpdate:function onHierarchicalCodelistDetailUpdate(hierarchicalCodelist,annotationsConfig){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["U" /* submitHierarchicalCodelistsHierarchicalCodelistDetail */])(hierarchicalCodelist,annotationsConfig));},fetchHierarchicalCodelist:function fetchHierarchicalCodelist(hierarchicalCodelistTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["M" /* readHierarchicalCodelistsHierarchicalCodelistDetail */])(hierarchicalCodelistTriplet));},fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["L" /* readHierarchicalCodelistsAgencies */])(allowedAgencies));},onCloneShow:function onCloneShow(artefactTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["P" /* showHierarchicalCodelistsHierarchicalCodelistClone */])(artefactTriplet));},onExportShow:function onExportShow(sourceTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["S" /* showHierarchicalCodelistsHierarchicalCodelistExport */])(sourceTriplet));},onDownloadShow:function onDownloadShow(hierarchicalCodelistTriplets,lang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["R" /* showHierarchicalCodelistsHierarchicalCodelistDownload */])(hierarchicalCodelistTriplets,lang));}};};var HierarchicalCodelistDetail=function HierarchicalCodelistDetail(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,nodes=_ref.nodes,nodeId=_ref.nodeId,permissions=_ref.permissions,isVisible=_ref.isVisible,hierarchicalCodelistTriplet=_ref.hierarchicalCodelistTriplet,hierarchicalCodelist=_ref.hierarchicalCodelist,agencies=_ref.agencies,onHierarchicalCodelistDetailHide=_ref.onHierarchicalCodelistDetailHide,onHierarchicalCodelistDetailChange=_ref.onHierarchicalCodelistDetailChange,onHierarchicalCodelistDetailUpdate=_ref.onHierarchicalCodelistDetailUpdate,fetchHierarchicalCodelist=_ref.fetchHierarchicalCodelist,fetchAgencies=_ref.fetchAgencies,onDownloadShow=_ref.onDownloadShow,onCloneShow=_ref.onCloneShow,onExportShow=_ref.onExportShow;var currentNode=nodes.find(function(node){return node.general.id===nodeId;});var annotationsConfig=currentNode.annotations;var userHasPermissionsToEdit=permissions&&hierarchicalCodelistTriplet&&permissions.agencies.filter(function(agency){return agency===hierarchicalCodelistTriplet.agencyID;}).length>0;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchHierarchicalCodelist,cbParam:hierarchicalCodelistTriplet,disabled:!hierarchicalCodelistTriplet||hierarchicalCodelist!==null},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_enhanced_modal__["a" /* default */],{visible:isVisible,width:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MODAL_WIDTH_XL"],title:userHasPermissionsToEdit?t('scenes.metaManager.hierarchicalCodelists.detail.title.editMode.title',{triplet:hierarchicalCodelistTriplet}):t('scenes.metaManager.hierarchicalCodelists.detail.title.viewMode.title',{triplet:hierarchicalCodelistTriplet}),onCancel:onHierarchicalCodelistDetailHide,footer:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:onHierarchicalCodelistDetailHide},t('commons.buttons.close.title')),userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',onClick:function onClick(){if(Object(__WEBPACK_IMPORTED_MODULE_19__utils_artefactValidators__["a" /* isArtefactValid */])(hierarchicalCodelist)){onHierarchicalCodelistDetailUpdate(hierarchicalCodelist,annotationsConfig);}else{__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:t('commons.alerts.invalidForm.title'),content:t('commons.alerts.invalidForm.content')});}}},t("commons.buttons.save.title")):null),withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var lang=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,permissions&&!userHasPermissionsToEdit&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert___default.a,{type:'warning',showIcon:true,message:t('commons.artefact.alerts.hasNotAgencyPermission')}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["GUTTER_SM"],justify:"end",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'download',size:'small',title:t('commons.artefact.buttons.download.title'),onClick:function onClick(){return onDownloadShow([hierarchicalCodelistTriplet],lang);}})),permissions&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'copy',size:'small',title:t('commons.artefact.buttons.clone.title'),onClick:function onClick(){return onCloneShow(hierarchicalCodelistTriplet);}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',shape:'circle',icon:'export',size:'small',title:t('commons.artefact.buttons.export.title'),onClick:function onClick(){return onExportShow(hierarchicalCodelistTriplet);}}))),hierarchicalCodelist&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_artefact_form__["d" /* default */],{artefact:hierarchicalCodelist,mode:userHasPermissionsToEdit?__WEBPACK_IMPORTED_MODULE_17__components_artefact_form__["b" /* ARTEFACT_FORM_MODE_EDIT */]:__WEBPACK_IMPORTED_MODULE_17__components_artefact_form__["c" /* ARTEFACT_FORM_MODE_READ */],agencies:agencies,onChange:onHierarchicalCodelistDetailChange,isHierarchicalCodelist:true}));}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(HierarchicalCodelistDetail));

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_infinite_scroll_data_table__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__style_css__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_tree_filter_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_tree_filter__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_filter_form__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_query_form_Preview__ = __webpack_require__(496);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,cubes:state.scenes.dataManager.manageSeries.cubes,cubeId:state.scenes.dataManager.manageSeries.cubeId,cube:state.scenes.dataManager.manageSeries.cube,series:state.scenes.dataManager.manageSeries.series,selectedSeries:state.scenes.dataManager.manageSeries.selectedSeries,isCubesVisible:state.scenes.dataManager.manageSeries.isCubesVisible,isFilterModalVisible:state.scenes.dataManager.manageSeries.isFilterModalVisible,isFilterQueryModalVisible:state.scenes.dataManager.manageSeries.isFilterQueryModalVisible,filter:state.scenes.dataManager.manageSeries.filter,treeFilter:state.scenes.dataManager.manageSeries.treeFilter,filterTemp:state.scenes.dataManager.manageSeries.filterTemp,treeFilterTemp:state.scenes.dataManager.manageSeries.treeFilterTemp,filterMode:state.scenes.dataManager.manageSeries.filterMode,isFilterPreviewModalVisible:state.scenes.dataManager.manageSeries.isFilterPreviewModalVisible,isFilterRowsModalVisible:state.scenes.dataManager.manageSeries.isFilterRowsModalVisible,filterRows:state.scenes.dataManager.manageSeries.filterRows,isSeriesVisible:state.scenes.dataManager.manageSeries.isSeriesVisible};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCubesShow:function onCubesShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_6" /* showManageSeriesCubes */])());},onCubesHide:function onCubesHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["Q" /* hideManageSeriesCubes */])());},onCubeSet:function onCubeSet(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_4" /* setManageSeriesCube */])(cubeId));},onCubeUnset:function onCubeUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_11" /* unsetManageSeriesCube */])());},onSelectedSeriesChange:function onSelectedSeriesChange(selectedSeries){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_5" /* setSelectedSeries */])(selectedSeries));},fetchCubes:function fetchCubes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["U" /* readManageSeriesCubes */])());},fetchCube:function fetchCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["T" /* readManageSeriesCube */])(cubeId));},fetchSeries:function fetchSeries(idCube,filterStr,cols,sortCols,sortByDesc,pageNum,pageSize){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_1" /* readManageSeriesSeries */])(idCube,filterStr,cols,sortCols,sortByDesc,pageNum,pageSize));},onDeleteSeries:function onDeleteSeries(cubeId,seriesIds){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["P" /* deleteManageSeriesSeries */])(cubeId,seriesIds));},onFilterModalHide:function onFilterModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["R" /* hideManageSeriesFilterModal */])());},onFilterModeChange:function onFilterModeChange(filterMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["J" /* changeManageSeriesFilterModalFilterMode */])(filterMode));},onFilterReset:function onFilterReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_3" /* resetManageSeriesFilterModalFilter */])());},onRowsModalShow:function onRowsModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_8" /* showManageSeriesFilterRowsModal */])());},onRowsModalHide:function onRowsModalHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["S" /* hideManageSeriesFilterRowsModal */])());},onFilterChange:function onFilterChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["I" /* changeManageSeriesFilter */])(fields));},onBlockAdd:function onBlockAdd(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["G" /* addManageSeriesFilterFormBlock */])());},onBlockDelete:function onBlockDelete(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["N" /* deleteManageSeriesFilterFormBlock */])(blockIndex));},onConditionAdd:function onConditionAdd(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["H" /* addManageSeriesFilterFormCondition */])(blockIndex));},onConditionDelete:function onConditionDelete(blockIndex,conditionIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["O" /* deleteManageSeriesFilterFormCondition */])(blockIndex,conditionIndex));},fetchColumnCodelistCount:function fetchColumnCodelistCount(_ref){var codelistTriplet=_ref.codelistTriplet,language=_ref.language;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["X" /* readManageSeriesFilterModalTreeFilterColumnCodelistCount */])(codelistTriplet,language));},fetchColumnCodelistTree:function fetchColumnCodelistTree(_ref2){var codelistTriplet=_ref2.codelistTriplet,language=_ref2.language;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["Y" /* readManageSeriesFilterModalTreeFilterColumnCodelistTree */])(codelistTriplet,language));},fetchColumnFilteredValues:function fetchColumnFilteredValues(cubeId,colNames,filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["Z" /* readManageSeriesFilterModalTreeFilterColumnFilteredValues */])(cubeId,colNames,filter));},onTreeFilterChange:function onTreeFilterChange(treeFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["K" /* changeManageSeriesFilterModalTreeFilter */])(treeFilter));},onColumnModeChange:function onColumnModeChange(colName,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["L" /* changeManageSeriesFilterModalTreeFilterColumnMode */])(colName,mode));},onColumnValuesChange:function onColumnValuesChange(colName,values){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["M" /* changeManageSeriesFilterModalTreeFilterColumnValues */])(colName,values));},onFilterModalSubmit:function onFilterModalSubmit(filter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_10" /* submitManageSeriesFilterModal */])(filter));},onFilterModalShow:function onFilterModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_7" /* showManageSeriesFilterModal */])());},fetchRows:function fetchRows(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_0" /* readManageSeriesFilterRows */])(cubeId,cubeColumns,filterStr,pageNum,pageSize,sortCols,sortByDesc));},onSeriesShow:function onSeriesShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_9" /* showManageSeriesSeries */])());},fetchColumnValues:function fetchColumnValues(cubeId,columnName,viewerObj){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["W" /* readManageSeriesFilterFormColumnValue */])(cubeId,columnName,viewerObj));},resetColumnValues:function resetColumnValues(columnName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["_2" /* resetManageSeriesFilterFormColumnValue */])(columnName));},fetchColumnCodes:function fetchColumnCodes(columnName,codelistCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["V" /* readManageSeriesFilterFormColumnCodes */])(columnName,codelistCode));}};};var ManageSeries=function ManageSeries(_ref3){var t=_ref3.t,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,onCubesShow=_ref3.onCubesShow,onCubesHide=_ref3.onCubesHide,onCubeUnset=_ref3.onCubeUnset,onCubeSet=_ref3.onCubeSet,cubes=_ref3.cubes,cubeId=_ref3.cubeId,cube=_ref3.cube,series=_ref3.series,selectedSeries=_ref3.selectedSeries,onSelectedSeriesChange=_ref3.onSelectedSeriesChange,onDeleteSeries=_ref3.onDeleteSeries,isCubesVisible=_ref3.isCubesVisible,fetchCubes=_ref3.fetchCubes,fetchCube=_ref3.fetchCube,fetchSeries=_ref3.fetchSeries,isFilterModalVisible=_ref3.isFilterModalVisible,onFilterModalShow=_ref3.onFilterModalShow,onFilterModalHide=_ref3.onFilterModalHide,filterMode=_ref3.filterMode,filterTemp=_ref3.filterTemp,filter=_ref3.filter,treeFilter=_ref3.treeFilter,treeFilterTemp=_ref3.treeFilterTemp,onFilterModeChange=_ref3.onFilterModeChange,onFilterReset=_ref3.onFilterReset,onRowsModalShow=_ref3.onRowsModalShow,onRowsModalHide=_ref3.onRowsModalHide,onFilterChange=_ref3.onFilterChange,onBlockAdd=_ref3.onBlockAdd,onBlockDelete=_ref3.onBlockDelete,onConditionAdd=_ref3.onConditionAdd,onConditionDelete=_ref3.onConditionDelete,fetchColumnCodelistCount=_ref3.fetchColumnCodelistCount,fetchColumnCodelistTree=_ref3.fetchColumnCodelistTree,_fetchColumnFilteredValues=_ref3.fetchColumnFilteredValues,onTreeFilterChange=_ref3.onTreeFilterChange,onColumnModeChange=_ref3.onColumnModeChange,onColumnValuesChange=_ref3.onColumnValuesChange,fetchColumnValues=_ref3.fetchColumnValues,onFilterModalSubmit=_ref3.onFilterModalSubmit,filterRows=_ref3.filterRows,isFilterRowsModalVisible=_ref3.isFilterRowsModalVisible,fetchRows=_ref3.fetchRows,onSeriesShow=_ref3.onSeriesShow,isSeriesVisible=_ref3.isSeriesVisible,resetColumnValues=_ref3.resetColumnValues,fetchColumnCodes=_ref3.fetchColumnCodes;var _useState=Object(__WEBPACK_IMPORTED_MODULE_14_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isFilterQueryModalVisible=_useState2[0],setIsFilterQueryModalVisible=_useState2[1];var filterStr=filterMode===__WEBPACK_IMPORTED_MODULE_29__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?Object(__WEBPACK_IMPORTED_MODULE_30__utils_filter__["c" /* getFilterStrFromObj */])(filter,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})):null):Object(__WEBPACK_IMPORTED_MODULE_32__components_tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(treeFilter,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(_ref4){var name=_ref4.name;return name;}):null);var filterTempStr=filterMode===__WEBPACK_IMPORTED_MODULE_29__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?Object(__WEBPACK_IMPORTED_MODULE_30__utils_filter__["c" /* getFilterStrFromObj */])(filterTemp,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})):null):Object(__WEBPACK_IMPORTED_MODULE_32__components_tree_filter_utils__["h" /* getTreeFilterStrFromObj */])(treeFilterTemp,cube!==null&&cube.columns!==null?__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(_ref5){var name=_ref5.name;return name;}):null);var columns=cube!==null?__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.flatten(Object.keys(cube.columns).map(function(key){return cube.columns[key];})).map(function(col){return Object.assign({},col,{fetchValues:col.values!==undefined?function(viewerObj){return fetchColumnValues(cubeId,col.ColName,viewerObj);}:null,resetValues:function resetValues(){return resetColumnValues(col.ColName);},hasCodelist:!!col.CodelistCode,fetchCodes:!!col.CodelistCode?function(){return fetchColumnCodes(col.ColName,col.CodelistCode);}:null});}):null;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["GUTTER_MD"],type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{style:{width:480}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_selector__["a" /* default */],{selectTitle:t('scenes.dataManager.manageSeries.cubeSelector.selectIcon.title'),resetTitle:t('scenes.dataManager.manageSeries.cubeSelector.resetIcon.title'),onSelect:onCubesShow,onReset:onCubeUnset,onDetail:null,onChange:onCubeSet,value:cube!==null?"["+cube.Code+"] "+Object(__WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__["a" /* getLocalizedStr */])(cube.labels,appLanguage,appLanguage,dataLanguages):null}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_enhanced_modal__["a" /* default */],{visible:isCubesVisible,title:t('scenes.dataManager.manageSeries.cubeSelector.modal.title'),footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onCubesHide},t('commons.buttons.close.title')),onCancel:onCubesHide,withDataLanguageSelector:true,width:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MODAL_WIDTH_MD"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__hocs_call__["a" /* default */],{cb:fetchCubes,disabled:cubes!==null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"query__cube-columns-form__tree"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_enhanced_tree__["a" /* default */],{tree:cubes,idKey:"Code",childrenKey:"children",nameKey:"labels",catIdKey:"CatCode",catNameKey:"labels",unselectableKeys:Object(__WEBPACK_IMPORTED_MODULE_24__utils_tree__["l" /* getNodes */])(cubes,'children',function(node){return node.children;}).map(function(node){return node.CatCode;}),hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_25__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode,__WEBPACK_IMPORTED_MODULE_24__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],getFilter:function getFilter(searchText){return function(_ref6){var Code=_ref6.Code,CatCode=_ref6.CatCode,labels=_ref6.labels;var search=searchText.toLowerCase();return Code&&Code.toLowerCase().indexOf(search)>=0||CatCode&&CatCode.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_20__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},onSelect:function onSelect(selectedArr){var node=Object(__WEBPACK_IMPORTED_MODULE_24__utils_tree__["k" /* getNode */])(cubes,'children',function(node){return node.children?node.CatCode===selectedArr[0]:node.Code===selectedArr[0];});if(node!==null&&node.children===undefined){onCubeSet(node.IDCube);}else{onCubeUnset();}},treeActions:[{title:t('scenes.dataManager.manageSeries.cubesTree.refreshIcon.title'),icon:'sync',onClick:fetchCubes}],icon:"cube",isCustomIcon:true,getIconColor:function getIconColor(){return"#37a0f4";},searchBarSpan:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["SPAN_HALF"]}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",disabled:cube===null,onClick:onFilterModalShow},t('scenes.dataManager.manageSeries.showFiltersButton.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_enhanced_modal__["a" /* default */],{visible:isFilterModalVisible,onCancel:onFilterModalHide,footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onFilterModalHide},t('commons.buttons.cancel.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onFilterModalSubmit(filterMode===__WEBPACK_IMPORTED_MODULE_29__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]?filterTemp:treeFilterTemp);}},t('commons.buttons.confirm.title'))),width:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MODAL_WIDTH_LG"],title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterModal.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_enhanced_modal__["a" /* default */],{visible:isFilterQueryModalVisible,onCancel:function onCancel(){return setIsFilterQueryModalVisible(false);},footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return setIsFilterQueryModalVisible(false);}},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MODAL_WIDTH_LG"],title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterQueryModal.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{fontFamily:'monospace'}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a.TextArea,{disabled:true,value:Object(__WEBPACK_IMPORTED_MODULE_32__components_tree_filter_utils__["c" /* convertFilterStrWithSimpleFilterForTimePeriod */])(filterTempStr),style:{overflow:'auto',resize:'none',height:560}}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Group,{value:filterMode,onChange:function onChange(_ref7){var target=_ref7.target;if(target.value===__WEBPACK_IMPORTED_MODULE_29__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]&&Object.keys(treeFilterTemp).length>0||target.value===__WEBPACK_IMPORTED_MODULE_29__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]&&filterTempStr.length>0){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.title'),content:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.content'),onOk:function onOk(){onFilterModeChange(target.value);},cancelText:t('commons.buttons.cancel.title')});}else{onFilterModeChange(target.value);}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_29__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.plain.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_29__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.tree.title')))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{icon:"code",onClick:function onClick(){return setIsFilterQueryModalVisible(true);}},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.showQuery.title'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{icon:"delete",onClick:onFilterReset},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.resetFilter.title'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onRowsModalShow,disabled:cube===null,icon:"eye"},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.preview.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__components_query_form_Preview__["a" /* default */],{filterStr:isFilterModalVisible?filterTempStr:filterStr,rows:filterRows,cube:cube,isRowsModalVisible:isFilterRowsModalVisible,onRowsModalHide:onRowsModalHide,fetchRows:fetchRows}))))),filterMode===__WEBPACK_IMPORTED_MODULE_29__components_query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{bodyStyle:{height:396,overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_filter_form__["a" /* default */],{filter:filterTemp,columns:columns,onChange:onFilterChange,onBlockAdd:onBlockAdd,onBlockDelete:onBlockDelete,onBlockConditionAdd:onConditionAdd,onBlockConditionDelete:onConditionDelete})),filterMode===__WEBPACK_IMPORTED_MODULE_29__components_query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"query__tree-filter"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_tree_filter__["a" /* default */],{columns:columns,fetchColumnCodelistCount:fetchColumnCodelistCount,fetchColumnCodelistTree:fetchColumnCodelistTree,fetchColumnFilteredValues:function fetchColumnFilteredValues(_ref8){var colNames=_ref8.colNames,filterStr=_ref8.filterStr;return _fetchColumnFilteredValues(cubeId,colNames,filterStr);},onChange:onTreeFilterChange,treeFilter:treeFilterTemp,onColumnModeChange:onColumnModeChange,onColumnValuesChange:onColumnValuesChange})))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",disabled:cube===null||series!==null,onClick:onSeriesShow},t('scenes.dataManager.manageSeries.showSeriesButton.title'))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__hocs_call__["a" /* default */],{cb:fetchCube,cbParam:cubeId,disabled:cubeId===null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["GUTTER_MD"],type:"flex",justify:"end",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_21__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:"primary",disabled:selectedSeries.length<1,onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.manageSeries.modals.confirms.deleteSeries.title'),onOk:function onOk(){onDeleteSeries(cubeId,selectedSeries);},cancelText:t('commons.buttons.cancel.title')});},title:selectedSeries.length<1?t('scenes.dataManager.manageSeries.deleteSeriesButton.disabledTooltip'):undefined},t('scenes.dataManager.manageSeries.deleteSeriesButton.title')))),cube&&isSeriesVisible&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"manage-series__table"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_infinite_scroll_data_table__["a" /* default */],{data:series&&series.Data,cols:series&&series.Columns,rowTotal:series&&series.Count,onChange:function onChange(_ref9){var pageNum=_ref9.pageNum,pageSize=_ref9.pageSize,searchText=_ref9.searchText,filters=_ref9.filters,sortCol=_ref9.sortCol,sortByDesc=_ref9.sortByDesc;return fetchSeries(cube.IDCube,Object(__WEBPACK_IMPORTED_MODULE_30__utils_filter__["e" /* getFilterStrFromViewerObj */])((cube.Dimensions||[]).filter(function(_ref10){var IsTimeSeriesDim=_ref10.IsTimeSeriesDim;return!IsTimeSeriesDim;}).map(function(_ref11){var ColName=_ref11.ColName;return ColName;}),searchText,filters,filterStr),(cube.Dimensions||[]).filter(function(_ref12){var IsTimeSeriesDim=_ref12.IsTimeSeriesDim;return!IsTimeSeriesDim;}).map(function(_ref13){var ColName=_ref13.ColName;return ColName;}),sortCol?[sortCol]:[],sortByDesc,pageNum,pageSize);},rowSelection:{selectedRowKeys:selectedSeries,onSelect:function onSelect(sid,selected){return selected?onSelectedSeriesChange([].concat(_toConsumableArray(selectedSeries),[sid])):onSelectedSeriesChange(selectedSeries.filter(function(el){return el!==sid;}));}},getRowKey:function getRowKey(_ref14){var SID=_ref14.SID;return SID;}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ManageSeries));

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__row_list_actions__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_treeBuilders__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__row_list__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__style_css__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__style_css__);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,separator:state.scenes.dataManager.attributeFile.shared.separator,delimiter:state.scenes.dataManager.attributeFile.shared.delimiter,csvServerPath:state.scenes.dataManager.attributeFile.shared.csvServerPath,tid:state.scenes.dataManager.attributeFile.shared.tid,file:state.scenes.dataManager.attributeFile.local.file,refreshProdDf:state.scenes.dataManager.attributeFile.local.refreshProdDf,checkFiltAttributes:state.scenes.dataManager.attributeFile.local.checkFiltAttributes,cubeId:state.scenes.dataManager.attributeFile.local.cubeId,cube:state.scenes.dataManager.attributeFile.local.cube,categorisedCubes:state.scenes.dataManager.attributeFile.local.categorisedCubes,isCubeTreeVisible:state.scenes.dataManager.attributeFile.local.isCubeTreeVisible,isIgnoreConcurrentUploadConfirmVisible:state.scenes.dataManager.attributeFile.local.isIgnoreConcurrentUploadConfirmVisible};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["k" /* changeAttributeFile */])(fields));},onFileUpload:function onFileUpload(file,mappingCubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["t" /* uploadAttributeFileFile */])(file,mappingCubeId));},onRowListShow:function onRowListShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__row_list_actions__["f" /* showAttributeFileRowList */])());},onSubmit:function onSubmit(separator,delimiter,cubeId,filePath,tid,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["r" /* submitAttributeFile */])(separator,delimiter,cubeId,filePath,tid,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload));},onHideIgnoreConcurrentUploadConfirm:function onHideIgnoreConcurrentUploadConfirm(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["m" /* onHideAttributeFileIgnoreConcurrentUploadConfirm */])());},onCubeTreeShow:function onCubeTreeShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["q" /* showAttributeFileCubeTree */])());},onCubeTreeHide:function onCubeTreeHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["l" /* hideAttributeFileCubeTree */])());},onCubeSet:function onCubeSet(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["p" /* setAttributeFileCube */])(cubeId));},onCubeUnset:function onCubeUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["s" /* unsetAttributeFileCube */])());},fetchCategorisedCubes:function fetchCategorisedCubes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["n" /* readAttributeFileCategorisedCubes */])());},fetchCube:function fetchCube(cubeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["o" /* readAttributeFileCube */])(cubeId));}};};var mapPropsToFields=function mapPropsToFields(_ref){var cube=_ref.cube,tid=_ref.tid,file=_ref.file,separator=_ref.separator,delimiter=_ref.delimiter,refreshProdDf=_ref.refreshProdDf,checkFiltAttributes=_ref.checkFiltAttributes,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages;return{cubeId:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:cube!==null?'['+cube.Code+'] '+Object(__WEBPACK_IMPORTED_MODULE_29__middlewares_i18n_utils__["a" /* getLocalizedStr */])(cube.labels,appLanguage,dataLanguages):null}),tid:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:tid}),file:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:file}),separator:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:separator}),delimiter:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:delimiter}),refreshProdDf:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:refreshProdDf}),checkFiltAttributes:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:checkFiltAttributes})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(fields);};var AttributeFile=function AttributeFile(_ref2){var t=_ref2.t,form=_ref2.form,isCubeTreeVisible=_ref2.isCubeTreeVisible,onCubeTreeHide=_ref2.onCubeTreeHide,fetchCategorisedCubes=_ref2.fetchCategorisedCubes,fetchCube=_ref2.fetchCube,categorisedCubes=_ref2.categorisedCubes,appLanguage=_ref2.appLanguage,dataLanguages=_ref2.dataLanguages,onCubeSet=_ref2.onCubeSet,onCubeUnset=_ref2.onCubeUnset,onCubeTreeShow=_ref2.onCubeTreeShow,cubeId=_ref2.cubeId,cube=_ref2.cube,tid=_ref2.tid,onFileUpload=_ref2.onFileUpload,file=_ref2.file,separator=_ref2.separator,delimiter=_ref2.delimiter,onRowListShow=_ref2.onRowListShow,csvServerPath=_ref2.csvServerPath,onSubmit=_ref2.onSubmit,refreshProdDf=_ref2.refreshProdDf,checkFiltAttributes=_ref2.checkFiltAttributes,onHideIgnoreConcurrentUploadConfirm=_ref2.onHideIgnoreConcurrentUploadConfirm,isIgnoreConcurrentUploadConfirmVisible=_ref2.isIgnoreConcurrentUploadConfirmVisible;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{style:{width:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MODAL_WIDTH_SM"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,{className:'advanced-form'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_enhanced_modal__["a" /* default */],{visible:isCubeTreeVisible,title:t('scenes.dataManager.attributeFile.cubeTreeModal.title'),footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onCubeTreeHide},t('commons.buttons.close.title')),onCancel:onCubeTreeHide},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__hocs_call__["a" /* default */],{cb:fetchCategorisedCubes,disabled:categorisedCubes!==null},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:'attribute-file__tree'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_enhanced_tree__["a" /* default */],{searchBarSpan:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"],tree:categorisedCubes,idKey:'Code',nameKey:'labels',childrenKey:'children',catIdKey:'CatCode',catNameKey:'labels',unselectableKeys:Object(__WEBPACK_IMPORTED_MODULE_27__utils_tree__["l" /* getNodes */])(categorisedCubes,'children',function(node){return node.children;}).map(function(node){return node.CatCode;}),hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_28__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode,__WEBPACK_IMPORTED_MODULE_27__utils_tree__["a" /* UNCATEGORIZED_CATEGORY_CODE */]],getFilter:function getFilter(searchText){return function(_ref3){var Code=_ref3.Code,CatCode=_ref3.CatCode,labels=_ref3.labels;var search=searchText.toLowerCase();return Code&&Code.toLowerCase().indexOf(search)>=0||CatCode&&CatCode.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_29__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},onSelect:function onSelect(selectedArr){var node=Object(__WEBPACK_IMPORTED_MODULE_27__utils_tree__["k" /* getNode */])(categorisedCubes,'children',function(node){return node.children?node.CatCode===selectedArr[0]:node.Code===selectedArr[0];});if(node!==null&&node.children===undefined){onCubeSet(node.IDCube);}else{onCubeUnset();}},treeActions:[{title:t('scenes.dataManager.attributeFile.cubeTreeModal.tree.refreshButton.title'),icon:'sync',onClick:fetchCategorisedCubes}],icon:'cube',isCustomIcon:true,getIconColor:function getIconColor(){return"#37a0f4";}})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('scenes.dataManager.attributeFile.fields.cube.label')},form.getFieldDecorator('cubeId')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_selector__["a" /* default */],{selectTitle:t('scenes.dataManager.attributeFile.fields.cube.selectIcon.title'),resetTitle:t('scenes.dataManager.attributeFile.fields.cube.resetIcon.title'),onSelect:onCubeTreeShow,onReset:onCubeUnset,onDetail:null}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__hocs_call__["a" /* default */],{cb:fetchCube,cbParam:cubeId,disabled:cubeId===null},!Object(__WEBPACK_IMPORTED_MODULE_24__utils__["a" /* userMustNotInsertTid */])(cube)&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('scenes.dataManager.attributeFile.fields.tid.label')},form.getFieldDecorator('tid',{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{style:{textTransform:"uppercase"}}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.file.label')},form.getFieldDecorator('file')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_file_input__["a" /* default */],{disabled:cubeId===null||cube===null||!Object(__WEBPACK_IMPORTED_MODULE_24__utils__["a" /* userMustNotInsertTid */])(cube)&&(tid===null||tid.length===0),accept:'.csv',isZipAllowed:true}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.separator.label')},form.getFieldDecorator('separator')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{disabled:cubeId===null||cube===null||file===null||!Object(__WEBPACK_IMPORTED_MODULE_24__utils__["a" /* userMustNotInsertTid */])(cube)&&(tid===null||tid.length===0),maxLength:1})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{label:t('data.csv.delimiter.label')},form.getFieldDecorator('delimiter')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{disabled:cubeId===null||cube===null||file===null||!Object(__WEBPACK_IMPORTED_MODULE_24__utils__["a" /* userMustNotInsertTid */])(cube)&&(tid===null||tid.length===0),maxLength:1}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'center',gutter:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["GUTTER_MD"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return onFileUpload(file,cube.IDCube);},disabled:cubeId===null||cube===null||!Object(__WEBPACK_IMPORTED_MODULE_24__utils__["a" /* userMustNotInsertTid */])(cube)&&(tid===null||tid.length===0)||file===null||separator===null||separator.length===0,type:'primary',icon:'upload'},t('data.csv.uploadButton.label')))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:onRowListShow,disabled:csvServerPath===null,icon:'table'},t('data.csv.tableShowButton.label')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__row_list__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_ONE_QUARTER"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,function(){var submit=function submit(ignoreConcurrentUpload){return onSubmit(separator,delimiter,cubeId,csvServerPath,tid,refreshProdDf,checkFiltAttributes,ignoreConcurrentUpload);};return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__hocs_call__["a" /* default */],{cb:function cb(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.attributeFile.confirms.ignoreConcurrentUpload.title'),content:t('scenes.dataManager.attributeFile.confirms.ignoreConcurrentUpload.content'),onOk:function onOk(){submit(true);onHideIgnoreConcurrentUploadConfirm();},onCancel:function onCancel(){onHideIgnoreConcurrentUploadConfirm();},cancelText:t('commons.buttons.cancel.title')});},disabled:!isIgnoreConcurrentUploadConfirmVisible},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.attributeFile.confirms.submit.title'),onOk:function onOk(){submit();},cancelText:t('commons.buttons.cancel.title')});},disabled:cubeId===null||!Object(__WEBPACK_IMPORTED_MODULE_24__utils__["a" /* userMustNotInsertTid */])(cube)&&(tid===null||tid.length===0)||separator===null||separator.length===0||csvServerPath===null,type:'primary',icon:'check'},t('scenes.dataManager.attributeFile.submitButton.label')));}())),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_THREE_QUARTERS"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{label:t('scenes.dataManager.attributeFile.refreshProdDf.label')},form.getFieldDecorator('refreshProdDf',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{disabled:csvServerPath===null})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_17__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{label:t('scenes.dataManager.attributeFile.checkFiltAttributes.label')},form.getFieldDecorator('checkFiltAttributes',{valuePropName:'checked'})(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{disabled:csvServerPath===null}))))))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(AttributeFile));

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userMustNotInsertTid;
function userMustNotInsertTid(cube){return cube===null||cube.Attributes.filter(function(attr){return attr.IsTid;}).length===0;}

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_filter__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_infinite_scroll_data_table__ = __webpack_require__(74);
var mapStateToProps=function mapStateToProps(state){return{isVisible:state.scenes.dataManager.attributeFile.components.rowList.isVisible,separator:state.scenes.dataManager.attributeFile.shared.separator,delimiter:state.scenes.dataManager.attributeFile.shared.delimiter,csvServerPath:state.scenes.dataManager.attributeFile.shared.csvServerPath,tid:state.scenes.dataManager.attributeFile.shared.tid,csvRows:state.scenes.dataManager.attributeFile.components.rowList.csvRows};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* hideAttributeFileRowList */])());},fetchCsvRows:function fetchCsvRows(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,tid,filePath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* getAttributeFileRowListCsvRows */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,tid,filePath));}};};var AttributeFileRowList=function AttributeFileRowList(_ref){var t=_ref.t,isVisible=_ref.isVisible,tid=_ref.tid,separator=_ref.separator,delimiter=_ref.delimiter,csvServerPath=_ref.csvServerPath,csvRows=_ref.csvRows,onHide=_ref.onHide,fetchCsvRows=_ref.fetchCsvRows;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_enhanced_modal__["a" /* default */],{visible:isVisible,onCancel:onHide,title:t('scenes.dataManager.attributeFile.rowList.title'),width:__WEBPACK_IMPORTED_MODULE_2__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title'))},csvServerPath!==null&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_infinite_scroll_data_table__["a" /* default */],{data:csvRows&&csvRows.Data,rowTotal:csvRows&&csvRows.Count,cols:csvRows&&csvRows.Columns,hiddenCols:['NumRow'],onChange:function onChange(_ref2){var pageNum=_ref2.pageNum,pageSize=_ref2.pageSize,searchText=_ref2.searchText,filters=_ref2.filters,sortCol=_ref2.sortCol,sortByDesc=_ref2.sortByDesc;return fetchCsvRows(pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_9__utils_filter__["b" /* getFilterObjFromViewerObj */])(csvRows&&csvRows.Columns.filter(function(colName){return colName!=='NumRow';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc,separator,!!delimiter?delimiter:null,tid,csvServerPath);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(AttributeFileRowList));

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onUpdateDatabrowserCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(28);
var UPDATE_DATABROWSER_CACHE="UPDATE_DATABROWSER_CACHE";var onUpdateDatabrowserCache=function onUpdateDatabrowserCache(){return Object(__WEBPACK_IMPORTED_MODULE_0__middlewares_api_actions__["m" /* postRequest */])(UPDATE_DATABROWSER_CACHE,Object(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["Y" /* getDataBrowserClearAllCacheUrl */])(),{},function(t){return{success:t('scenes.dataManager.updateDatabrowserCache.messages.updateDatabrowserCache.success')};});};

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_easy_loading__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_easy_loading_constants__ = __webpack_require__(63);
var EasyLoadingCreate=function EasyLoadingCreate(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_easy_loading__["a" /* default */],{mode:__WEBPACK_IMPORTED_MODULE_2__components_easy_loading_constants__["r" /* EL_MODE_CREATE */]});};/* harmony default export */ __webpack_exports__["a"] = (EasyLoadingCreate);

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataForm__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CategoryTree__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DataSelect__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(63);
var ELDataStep=function ELDataStep(_ref){var mode=_ref.mode;return mode===__WEBPACK_IMPORTED_MODULE_4__constants__["r" /* EL_MODE_CREATE */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginBottom:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DataForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CategoryTree__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataSelect__["a" /* default */],null);};/* harmony default export */ __webpack_exports__["a"] = (ELDataStep);

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__perf_input__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants_numbers__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__hocs_call__ = __webpack_require__(18);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,permissions:state.app.user.permissions,dstDataflow:state.scenes.easyLoading.dstDataflow,agencies:state.scenes.easyLoading.agencies};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchAgencies:function fetchAgencies(allowedAgencies){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["_51" /* readElAgencies */])(allowedAgencies));},onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["_18" /* changeELDstDataflowForm */])(fields));}};};var mapPropsToFields=function mapPropsToFields(_ref){var dstDataflow=_ref.dstDataflow;return{id:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:dstDataflow?dstDataflow.id:null}),agencyID:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:dstDataflow?dstDataflow.agencyID:null}),version:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:dstDataflow?dstDataflow.version:null}),name:__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.createFormField({value:dstDataflow?dstDataflow.name:null})};};var onFieldsChange=function onFieldsChange(props,fields){if(props.onChange){var newFields=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.mapValues(fields,function(_ref2){var value=_ref2.value;return value;});if(newFields.id&&newFields.id.length>__WEBPACK_IMPORTED_MODULE_21__constants_numbers__["a" /* ID_MAX_LEN */]){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.warning({title:props.t('commons.alerts.fieldTooLong.title'),content:props.t('commons.alerts.fieldTooLong.content',{maxLen:__WEBPACK_IMPORTED_MODULE_21__constants_numbers__["a" /* ID_MAX_LEN */]})});props.onChange(props.artefact);}else{props.onChange(newFields);}}};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_THREE_QUARTERS"]}};var ELDataForm=function ELDataForm(_ref3){var t=_ref3.t,form=_ref3.form,appLanguage=_ref3.appLanguage,dataLanguages=_ref3.dataLanguages,agencies=_ref3.agencies,dstDataflow=_ref3.dstDataflow,fetchAgencies=_ref3.fetchAgencies,permissions=_ref3.permissions;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__hocs_call__["a" /* default */],{cb:fetchAgencies,cbParam:permissions?permissions.agencies:undefined,disabled:agencies!==null},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:"inner"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.id.label'),validateStatus:dstDataflow&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,dstDataflow.id).help?"warning":null,help:dstDataflow&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["f" /* isIDValidWithHelp */])(t,dstDataflow.id).help},formItemLayout),form.getFieldDecorator('id',{getValueFromEvent:function getValueFromEvent(e){return(e||"").toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,title:form.getFieldValue('id'),style:{textTransform:"uppercase"}}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__contexts_DataLanguage__["a" /* DataLanguageConsumer */],null,function(dataLanguage){var language=dataLanguage||appLanguage;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.agencyID.label')},formItemLayout),form.getFieldDecorator('agencyID')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(inputValue,_ref4){var props=_ref4.props;return props.title.toLowerCase().includes(inputValue.toLowerCase());},title:agencies&&form.getFieldValue('agencyID')&&(Object(__WEBPACK_IMPORTED_MODULE_25__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[form.getFieldValue('agencyID')],language,dataLanguages)||form.getFieldValue('agencyID'))},agencies?Object.keys(agencies).map(function(agencyID,index){var agencyName=Object(__WEBPACK_IMPORTED_MODULE_25__middlewares_i18n_utils__["a" /* getLocalizedStr */])(agencies[agencyID],language,dataLanguages);return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{key:index,value:agencyID,title:agencyID&&agencyName?agencyID+" - "+agencyName:agencyID},agencyID&&agencyName?agencyID+" - "+agencyName:agencyID);}):null)));}))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.version.label'),hasFeedback:true,validateStatus:dstDataflow&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,dstDataflow.version).help?"warning":null,help:dstDataflow&&Object(__WEBPACK_IMPORTED_MODULE_16__utils_artefactValidators__["i" /* isVersionValidWithHelp */])(t,dstDataflow.version).help},formItemLayout),form.getFieldDecorator('version')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,title:form.getFieldValue('version')}))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_15__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('data.artefact.name.label')},formItemLayout),form.getFieldDecorator('name')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_26__multilanguage_input__["a" /* default */]}))))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ELDataForm));

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enhanced_tree__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_treeBuilders__ = __webpack_require__(73);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,agencies:state.scenes.easyLoading.agencies,categoryTree:state.scenes.easyLoading.categoryTree,forbiddenCategoriesCodes:state.scenes.easyLoading.forbiddenCategoriesCodes,category:state.scenes.easyLoading.category};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCategories:function fetchCategories(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_39" /* readELCategories */])());},onCategorySet:function onCategorySet(category){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_59" /* setELCategory */])(category));}};};var ELCategoryTree=function ELCategoryTree(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,categoryTree=_ref.categoryTree,category=_ref.category,forbiddenCategoriesCodes=_ref.forbiddenCategoriesCodes,fetchCategories=_ref.fetchCategories,onCategorySet=_ref.onCategorySet;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"el__cubes-tree"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__hocs_call__["a" /* default */],{cb:fetchCategories,disabled:categoryTree!==null},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,{className:"form-item-required",label:t('components.easyLoading.steps.data.body.categoryTree.label'),style:{marginBottom:0}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__enhanced_tree__["a" /* default */],{tree:categoryTree,childrenKey:"children",idKey:"Code",nameKey:"labels",catIdKey:"CatCode",catNameKey:"labels",hiddenIdKeys:[__WEBPACK_IMPORTED_MODULE_14__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode],unselectableKeys:[__WEBPACK_IMPORTED_MODULE_14__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode],defaultSelectedKeys:category!==null?[category.CatCode]:null,getFilter:function getFilter(searchText){return function(_ref2){var CatCode=_ref2.CatCode,labels=_ref2.labels;var search=searchText.toLowerCase();return CatCode&&CatCode.toLowerCase().indexOf(search)>=0||Object(__WEBPACK_IMPORTED_MODULE_10__middlewares_i18n_utils__["a" /* getLocalizedStr */])(labels,appLanguage,dataLanguages).toLowerCase().indexOf(search)>=0;};},unallowedIdKeys:forbiddenCategoriesCodes,onSelect:function onSelect(selectedArr){if(selectedArr!==null&&selectedArr.length>0){var node=Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["k" /* getNode */])(categoryTree,'children',function(node){return node.children?node.CatCode===selectedArr[0]:node.Code===selectedArr[0];});onCategorySet(Object.assign({},node,{CatCode:node.CatCode!==__WEBPACK_IMPORTED_MODULE_14__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode?node.CatCode:null}));if(node.CatCode!==__WEBPACK_IMPORTED_MODULE_14__utils_treeBuilders__["a" /* DCS_ORDERED_TREE_ROOT */].CatCode&&forbiddenCategoriesCodes.includes(node.CatCode)){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t('components.easyLoading.steps.data.body.categoryTree.modals.forbiddenCategory.title'),content:t('components.easyLoading.steps.data.body.categoryTree.modals.forbiddenCategory.content')});}}else{onCategorySet(null);}},treeActions:[{title:t('components.easyLoading.steps.data.body.categoryTree.refreshButton.title'),icon:'sync',onClick:fetchCategories}],icon:"cube",isCustomIcon:true,getIconColor:function getIconColor(){return"#37a0f4";},searchBarSpan:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["SPAN_HALF"]})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELCategoryTree));

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(88);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,dstDataflow:state.scenes.easyLoading.dstDataflow,dstDataflows:state.scenes.easyLoading.dstDataflows};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchDataflows:function fetchDataflows(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_47" /* readELDstDataflows */])());},onDataflowSet:function onDataflowSet(dataflow){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_61" /* setELDstDataflow */])(dataflow));},onDataflowUnset:function onDataflowUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["_78" /* unsetELDstDataflow */])());}};};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["SPAN_THREE_QUARTERS"]}};var ELDataSelect=function ELDataSelect(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,dataLanguages=_ref.dataLanguages,dstDataflow=_ref.dstDataflow,dstDataflows=_ref.dstDataflows,fetchDataflows=_ref.fetchDataflows,onDataflowSet=_ref.onDataflowSet,onDataflowUnset=_ref.onDataflowUnset;var _useState=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isVisible=_useState2[0],setVisibility=_useState2[1];return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:"inner"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{className:"advanced-form"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t('components.easyLoading.steps.data.body.dataSelect.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__selector__["a" /* default */],{value:dstDataflow,render:function render(dataflow){return dataflow?Object(__WEBPACK_IMPORTED_MODULE_11__middlewares_i18n_utils__["a" /* getLocalizedStr */])(dataflow.name,appLanguage,dataLanguages):"";},selectTitle:t('components.easyLoading.steps.data.body.dataSelect.select'),resetTitle:t('components.easyLoading.steps.data.body.dataSelect.reset'),onSelect:function onSelect(){return setVisibility(true);},onReset:onDataflowUnset})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__enhanced_modal__["a" /* default */],{visible:isVisible,onCancel:function onCancel(){return setVisibility(false);},title:t('components.easyLoading.steps.data.body.dataSelect.modals.dataflow.title'),width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return setVisibility(false);}},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__hocs_call__["a" /* default */],{cb:fetchDataflows,disabled:!isVisible},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__artefact_list__["a" /* default */],{artefacts:dstDataflows||[],onRowClick:function onRowClick(dataflow){onDataflowSet(dataflow);setVisibility(false);},getIsDisabledRow:function getIsDisabledRow(dataflow){return!dataflow.isFinal;}}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELDataSelect));

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__file_input__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__endpoints_dropdown__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_EndpointForm__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__middlewares_i18n_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__infinite_scroll_data_table__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_filter__ = __webpack_require__(53);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,dataLanguages:state.config.dataManagement.dataLanguages,endpoints:state.config.nodes,endpointId:state.app.endpointId,sourceFormat:state.scenes.easyLoading.sourceFormat,connectionEndpointId:state.scenes.easyLoading.connectionEndpointId,isConnectionEndpointAvailable:state.scenes.easyLoading.isConnectionEndpointAvailable,srcDataflows:state.scenes.easyLoading.srcDataflows,srcDataflow:state.scenes.easyLoading.srcDataflow,srcFile:state.scenes.easyLoading.srcFile,srcFileRows:state.scenes.easyLoading.srcFileRows,srcFileRowsVisible:state.scenes.easyLoading.srcFileRowsVisible,srcTables:state.scenes.easyLoading.srcTables,srcTable:state.scenes.easyLoading.srcTable};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFormatSet:function onFormatSet(format){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_64" /* setELSourceFormat */])(format));},onConnectionEndpointSet:function onConnectionEndpointSet(endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_68" /* setElConnectionEndpoint */])(endpointId));},onConnectionEndpointPing:function onConnectionEndpointPing(endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_36" /* pingELConnectionEndpoint */])(endpointId));},fetchDataflows:function fetchDataflows(endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_50" /* readELSrcDataflows */])(endpointId));},onDataflowSet:function onDataflowSet(dataflow){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_65" /* setELSrcDataflow */])(dataflow));},onDataflowUnset:function onDataflowUnset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_79" /* unsetELSrcDataflow */])());},onChange:function onChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_23" /* changeELSrcFileForm */])(fields));},onFileCsvUpload:function onFileCsvUpload(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_80" /* uploadElSrcFileCsv */])(file));},onFileExcelUpload:function onFileExcelUpload(file,mapping){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_82" /* uploadElSrcFileExcel */])(file,mapping));},onFileExcelConvert:function onFileExcelConvert(_ref){var filePath=_ref.filePath,mappingPath=_ref.mappingPath;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_26" /* convertElSrcFileExcel */])(filePath,mappingPath));},onPreviewShow:function onPreviewShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_70" /* showElSrcFilePreview */])());},onPreviewHide:function onPreviewHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_35" /* hideElSrcFilePreview */])());},fetchPreview:function fetchPreview(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,csvPath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_52" /* readElSrcFilePreview */])(pageNum,pageSize,filterTable,sortCols,sortByDesc,separator,delimiter,hasHeader,csvPath));},fetchTables:function fetchTables(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_53" /* readElSrcTables */])());},onTableSet:function onTableSet(tableName,csvSeparator){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["_69" /* setElSrcTable */])(tableName,csvSeparator));}};};var mapPropsToFields=function mapPropsToFields(_ref2){var srcFile=_ref2.srcFile;return{file:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:srcFile&&srcFile.file?srcFile.file:null}),mapping:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:srcFile&&srcFile.mapping?srcFile.mapping:null}),separator:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:srcFile&&srcFile.separator?srcFile.separator:null}),delimiter:__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.createFormField({value:srcFile&&srcFile.delimiter?srcFile.delimiter:null})};};var onFieldsChange=function onFieldsChange(props,fields){return props.onChange(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.mapValues(fields,function(_ref3){var value=_ref3.value;return value;}));};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_ONE_QUARTER"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_THREE_QUARTERS"]}};var ELConnectionStep=function ELConnectionStep(_ref4){var t=_ref4.t,form=_ref4.form,appLanguage=_ref4.appLanguage,dataLanguages=_ref4.dataLanguages,endpoints=_ref4.endpoints,endpointId=_ref4.endpointId,sourceFormat=_ref4.sourceFormat,connectionEndpointId=_ref4.connectionEndpointId,isConnectionEndpointAvailable=_ref4.isConnectionEndpointAvailable,srcDataflows=_ref4.srcDataflows,srcDataflow=_ref4.srcDataflow,srcFile=_ref4.srcFile,srcFileRows=_ref4.srcFileRows,srcFileRowsVisible=_ref4.srcFileRowsVisible,srcTables=_ref4.srcTables,srcTable=_ref4.srcTable,onFormatSet=_ref4.onFormatSet,onConnectionEndpointSet=_ref4.onConnectionEndpointSet,onConnectionEndpointPing=_ref4.onConnectionEndpointPing,fetchDataflows=_ref4.fetchDataflows,onDataflowSet=_ref4.onDataflowSet,onDataflowUnset=_ref4.onDataflowUnset,onFileCsvUpload=_ref4.onFileCsvUpload,onFileExcelUpload=_ref4.onFileExcelUpload,onFileExcelConvert=_ref4.onFileExcelConvert,onPreviewShow=_ref4.onPreviewShow,onPreviewHide=_ref4.onPreviewHide,fetchPreview=_ref4.fetchPreview,fetchTables=_ref4.fetchTables,onTableSet=_ref4.onTableSet;var _useState=Object(__WEBPACK_IMPORTED_MODULE_16_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isVisible=_useState2[0],setVisibility=_useState2[1];return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{type:'inner'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,{className:'advanced-form'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.easyLoading.steps.connection.body.format.label'),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Group,{value:sourceFormat,onChange:function onChange(_ref5){var target=_ref5.target;return onFormatSet(target.value);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_30__constants__["v" /* EL_SOURCE_FORMAT_CSV */]},t('components.easyLoading.steps.connection.body.format.values.csv')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_30__constants__["y" /* EL_SOURCE_FORMAT_XLS */]},t('components.easyLoading.steps.connection.body.format.values.xls')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_30__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]},t('components.easyLoading.steps.connection.body.format.values.sdmxEp')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_30__constants__["w" /* EL_SOURCE_FORMAT_DB */]},t('components.easyLoading.steps.connection.body.format.values.db')))),(sourceFormat===__WEBPACK_IMPORTED_MODULE_30__constants__["v" /* EL_SOURCE_FORMAT_CSV */]||sourceFormat===__WEBPACK_IMPORTED_MODULE_30__constants__["y" /* EL_SOURCE_FORMAT_XLS */])&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.csv.file.label')},formItemLayout),form.getFieldDecorator('file')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__file_input__["a" /* default */],{accept:sourceFormat===__WEBPACK_IMPORTED_MODULE_30__constants__["v" /* EL_SOURCE_FORMAT_CSV */]?".csv":".xls,.xlsx"}))))),sourceFormat===__WEBPACK_IMPORTED_MODULE_30__constants__["y" /* EL_SOURCE_FORMAT_XLS */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.easyLoading.steps.connection.body.mapping.label')},formItemLayout),form.getFieldDecorator('mapping')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__file_input__["a" /* default */],{accept:'.xml'}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{className:'form-item-required',label:t('data.csv.separator.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_HALF"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_HALF"]}},form.getFieldDecorator('separator')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{maxLength:1})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_HALF"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{label:t('data.csv.delimiter.label'),labelCol:{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_HALF"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_HALF"]}},form.getFieldDecorator('delimiter')(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{maxLength:1}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'center',gutter:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{type:'primary',icon:'upload',onClick:function onClick(){return sourceFormat===__WEBPACK_IMPORTED_MODULE_30__constants__["v" /* EL_SOURCE_FORMAT_CSV */]?onFileCsvUpload(srcFile.file):onFileExcelUpload(srcFile.file,srcFile.mapping);},disabled:!srcFile||!srcFile.file||!srcFile.separator||sourceFormat===__WEBPACK_IMPORTED_MODULE_30__constants__["y" /* EL_SOURCE_FORMAT_XLS */]&&!srcFile.mapping},t('data.csv.uploadButton.label')))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{icon:'table',onClick:onPreviewShow,disabled:!srcFile||!srcFile.csvPath},t('data.csv.tableShowButton.label')))))),sourceFormat===__WEBPACK_IMPORTED_MODULE_30__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.easyLoading.steps.connection.body.endpoint.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__endpoints_dropdown__["a" /* default */],{endpoints:endpoints.filter(function(ep){return ep.general.id!==endpointId&&ep.endpoint.nsiEndpointType===__WEBPACK_IMPORTED_MODULE_28__scenes_configuration_nodes_config_node_EndpointForm__["a" /* NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_REST */];}),endpointId:connectionEndpointId,onEndpointSet:onConnectionEndpointSet,onNodePing:function onNodePing(){return onConnectionEndpointPing(connectionEndpointId);},isEndpointAvailable:isConnectionEndpointAvailable,doNotGoHome:true,canBeNull:true,fullWidth:true})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.easyLoading.steps.connection.body.dataflow.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:onConnectionEndpointPing,cbParam:connectionEndpointId,disabled:!connectionEndpointId},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__selector__["a" /* default */],{value:srcDataflow,render:function render(dataset){return dataset?Object(__WEBPACK_IMPORTED_MODULE_29__middlewares_i18n_utils__["a" /* getLocalizedStr */])(dataset.name,appLanguage,dataLanguages):"";},selectTitle:t('components.easyLoading.steps.connection.body.dataflow.select'),resetTitle:t('components.easyLoading.steps.connection.body.dataflow.reset'),onSelect:function onSelect(){return setVisibility(true);},onReset:onDataflowUnset,disabled:!connectionEndpointId||!isConnectionEndpointAvailable}),connectionEndpointId&&isConnectionEndpointAvailable&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__enhanced_modal__["a" /* default */],{visible:isVisible,onCancel:function onCancel(){return setVisibility(false);},title:t('components.easyLoading.steps.connection.body.modals.dataflow.title'),width:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return setVisibility(false);}},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchDataflows,cbParam:connectionEndpointId,disabled:!isVisible},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__artefact_list__["a" /* default */],{artefacts:srcDataflows||[],onRowClick:function onRowClick(dataflow){onDataflowSet(dataflow);setVisibility(false);}})))))))),sourceFormat===__WEBPACK_IMPORTED_MODULE_30__constants__["w" /* EL_SOURCE_FORMAT_DB */]&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:fetchTables,disabled:srcTables!==null},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('components.easyLoading.steps.connection.body.table.label')},formItemLayout),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{showSearch:true,value:srcTable,onChange:function onChange(val){return onTableSet(val,srcFile.separator);}},(srcTables||[]).map(function(table,idx){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{key:idx,value:table},table);}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{type:'flex',justify:'center',gutter:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{icon:'table',onClick:onPreviewShow,disabled:!srcFile||!srcFile.csvPath},t('data.csv.tableShowButton.label')))))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__enhanced_modal__["a" /* default */],{visible:srcFileRowsVisible,onCancel:onPreviewHide,title:t('components.easyLoading.steps.connection.modals.srcFilePreview.title'),width:__WEBPACK_IMPORTED_MODULE_22__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:onPreviewHide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__infinite_scroll_data_table__["a" /* default */],{data:srcFileRows&&srcFileRows.Data,rowTotal:srcFileRows&&srcFileRows.Count,cols:srcFileRows&&srcFileRows.Columns,hiddenCols:['NumRow'],onChange:function onChange(_ref6){var pageNum=_ref6.pageNum,pageSize=_ref6.pageSize,searchText=_ref6.searchText,filters=_ref6.filters,sortCol=_ref6.sortCol,sortByDesc=_ref6.sortByDesc;return fetchPreview(pageNum,pageSize,Object(__WEBPACK_IMPORTED_MODULE_33__utils_filter__["b" /* getFilterObjFromViewerObj */])(srcFileRows&&srcFileRows.Columns.filter(function(colName){return colName!=='NumRow';}),searchText,filters),sortCol?[sortCol]:null,sortByDesc,srcFile.separator,srcFile.delimiter||null,true,srcFile.csvPath);}})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__hocs_call__["a" /* default */],{cb:onFileExcelConvert,cbParam:{filePath:srcFile&&srcFile.filePath,mappingPath:srcFile&&srcFile.mappingPath},disabled:!srcFile||!srcFile.filePath||!srcFile.mappingPath||srcFile.csvPath},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span',null)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_18_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_19_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(ELConnectionStep));

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__query_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filter_form__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__tree_filter__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__constants__ = __webpack_require__(63);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{step:state.scenes.easyLoading.step,sourceFormat:state.scenes.easyLoading.sourceFormat,connectionEndpointId:state.scenes.easyLoading.connectionEndpointId,srcDataflow:state.scenes.easyLoading.srcDataflow,srcFile:state.scenes.easyLoading.srcFile,dsdColumns:state.scenes.easyLoading.dsdColumns,filterMode:state.scenes.easyLoading.filterMode,filter:state.scenes.easyLoading.filter,treeFilter:state.scenes.easyLoading.treeFilter,filterStr:state.scenes.easyLoading.filterStr};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchDataflowDsd:function fetchDataflowDsd(_ref){var dsdTriplet=_ref.dsdTriplet,endpointId=_ref.endpointId;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_49" /* readELSrcDataflowDsd */])(dsdTriplet,endpointId));},fetchCodelistCount:function fetchCodelistCount(sdcDataflowTriplet,dimensionId,endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_40" /* readELCodelistCount */])(sdcDataflowTriplet,dimensionId,endpointId));},fetchCodelistItems:function fetchCodelistItems(sdcDataflowTriplet,dimensionId,endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_41" /* readELCodelistItems */])(sdcDataflowTriplet,dimensionId,endpointId));},fetchCsvHeader:function fetchCsvHeader(_ref2){var separator=_ref2.separator,delimiter=_ref2.delimiter,hasHeader=_ref2.hasHeader,csvPath=_ref2.csvPath;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_46" /* readELCsvHeader */])(separator,delimiter,hasHeader,csvPath));},fetchCsvCountAndItems:function fetchCsvCountAndItems(_ref3){var dimensionId=_ref3.dimensionId,separator=_ref3.separator,delimiter=_ref3.delimiter,hasHeader=_ref3.hasHeader,csvPath=_ref3.csvPath;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_45" /* readELCsvCountAndItems */])(dimensionId,separator,delimiter,hasHeader,csvPath));},onFilterModeChange:function onFilterModeChange(mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_19" /* changeELFilterMode */])(mode));},onModeAdvancedValuesChange:function onModeAdvancedValuesChange(colName,values){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_21" /* changeELFilterModeAdvancedValues */])(colName,values));},onModeAdvancedModeChange:function onModeAdvancedModeChange(colName,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_20" /* changeELFilterModeAdvancedMode */])(colName,mode));},onModeSimpleBlockAdd:function onModeSimpleBlockAdd(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_16" /* addELFilterModeSimpleBlock */])());},onModeSimpleBlockDelete:function onModeSimpleBlockDelete(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_30" /* deleteELFilterModeSimpleBlock */])(blockIndex));},onModeSimpleConditionAdd:function onModeSimpleConditionAdd(blockIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_17" /* addELFilterModeSimpleCondition */])(blockIndex));},onModeSimpleConditionDelete:function onModeSimpleConditionDelete(blockIndex,conditionIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_31" /* deleteELFilterModeSimpleCondition */])(blockIndex,conditionIndex));},onModeSimpleValuesChange:function onModeSimpleValuesChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_22" /* changeELFilterModeSimpleValues */])(fields));},fetchModeSimpleValues:function fetchModeSimpleValues(dimensionId,separator,delimiter,hasHeader,csvPath){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_48" /* readELFilterModeSimpleValues */])(dimensionId,separator,delimiter,hasHeader,csvPath));},onModeSimpleValuesReset:function onModeSimpleValuesReset(dimensionId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_56" /* resetELFilterModeSimpleValues */])(dimensionId));},onFilterReset:function onFilterReset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["_55" /* resetELFilter */])());}};};var ELFilterStep=function ELFilterStep(_ref4){var t=_ref4.t,step=_ref4.step,sourceFormat=_ref4.sourceFormat,connectionEndpointId=_ref4.connectionEndpointId,srcDataflow=_ref4.srcDataflow,srcFile=_ref4.srcFile,dsdColumns=_ref4.dsdColumns,filterMode=_ref4.filterMode,filter=_ref4.filter,treeFilter=_ref4.treeFilter,filterStr=_ref4.filterStr,sdmxFilters=_ref4.sdmxFilters,_ref4$disabled=_ref4.disabled,disabled=_ref4$disabled===undefined?false:_ref4$disabled,fetchDataflowDsd=_ref4.fetchDataflowDsd,fetchCsvHeader=_ref4.fetchCsvHeader,onFilterReset=_ref4.onFilterReset,onFilterModeChange=_ref4.onFilterModeChange,onModeSimpleBlockAdd=_ref4.onModeSimpleBlockAdd,onModeSimpleBlockDelete=_ref4.onModeSimpleBlockDelete,onModeSimpleConditionAdd=_ref4.onModeSimpleConditionAdd,onModeSimpleConditionDelete=_ref4.onModeSimpleConditionDelete,onModeSimpleValuesChange=_ref4.onModeSimpleValuesChange,fetchModeSimpleValues=_ref4.fetchModeSimpleValues,onModeSimpleValuesReset=_ref4.onModeSimpleValuesReset,fetchCodelistCount=_ref4.fetchCodelistCount,fetchCodelistItems=_ref4.fetchCodelistItems,fetchCsvCountAndItems=_ref4.fetchCsvCountAndItems,onModeAdvancedValuesChange=_ref4.onModeAdvancedValuesChange,onModeAdvancedModeChange=_ref4.onModeAdvancedModeChange;var _useState=Object(__WEBPACK_IMPORTED_MODULE_14_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isFilterQueryModalVisible=_useState2[0],setFilterQueryModalVisibility=_useState2[1];var columns=(dsdColumns||[]).length>0?dsdColumns.map(function(col){return Object.assign({},col,{fetchValues:function fetchValues(){return fetchModeSimpleValues(col.id,srcFile.separator,srcFile.delimiter||null,true,srcFile.csvPath);},resetValues:function resetValues(){return onModeSimpleValuesReset(col.id);}});}):null;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__hocs_call__["a" /* default */],{cb:fetchDataflowDsd,cbParam:{dsdTriplet:srcDataflow?Object(__WEBPACK_IMPORTED_MODULE_20__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(srcDataflow.structure):null,endpointId:connectionEndpointId},disabled:sourceFormat!==__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]||step!==__WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */]||!srcDataflow||columns},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__hocs_call__["a" /* default */],{cb:fetchCsvHeader,cbParam:{separator:srcFile?srcFile.separator:null,delimiter:srcFile&&srcFile.delimiter?srcFile.delimiter:null,hasHeader:true,csvPath:srcFile?srcFile.csvPath:null},disabled:sourceFormat===__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]||step!==__WEBPACK_IMPORTED_MODULE_26__constants__["D" /* EL_STEP_FILTER */]||!srcFile||columns},columns&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"space-between",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,!sdmxFilters&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Group,{disabled:disabled,value:filterMode,onChange:function onChange(_ref5){var target=_ref5.target;if(filterStr.length>0){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.title'),content:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.content'),onOk:function onOk(){onFilterModeChange(target.value);},cancelText:t('commons.buttons.cancel.title')});}else{onFilterModeChange(target.value);}}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_15__query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.plain.title')),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Button,{value:__WEBPACK_IMPORTED_MODULE_15__query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.tree.title')))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{icon:"code",onClick:function onClick(){return setFilterQueryModalVisibility(true);},disabled:filterStr.length===0},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.showQuery.title'))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{icon:"delete",onClick:onFilterReset,disabled:disabled},t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.resetFilter.title')))))),filterMode===__WEBPACK_IMPORTED_MODULE_15__query_form__["a" /* QUERY_FORM_FILTER_MODE_PLAIN */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{bodyStyle:{height:396,overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__filter_form__["a" /* default */],{disabled:disabled,columns:columns,filter:filter,onChange:onModeSimpleValuesChange,onBlockAdd:onModeSimpleBlockAdd,onBlockDelete:onModeSimpleBlockDelete,onBlockConditionAdd:onModeSimpleConditionAdd,onBlockConditionDelete:onModeSimpleConditionDelete})),filterMode===__WEBPACK_IMPORTED_MODULE_15__query_form__["b" /* QUERY_FORM_FILTER_MODE_TREE */]&&__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"query__tree-filter"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__tree_filter__["a" /* default */],{disabled:disabled,columns:columns,treeFilter:treeFilter,fetchColumnCodelistCount:function fetchColumnCodelistCount(_ref6){var dimensionId=_ref6.dimensionId;return sourceFormat===__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]?fetchCodelistCount(srcDataflow,dimensionId,connectionEndpointId):fetchCsvCountAndItems({dimensionId:dimensionId,separator:srcFile?srcFile.separator:null,delimiter:srcFile&&srcFile.delimiter?srcFile.delimiter:null,hasHeader:true,csvPath:srcFile?srcFile.csvPath:null});},fetchColumnCodelistTree:function fetchColumnCodelistTree(_ref7){var dimensionId=_ref7.dimensionId;return sourceFormat===__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]?fetchCodelistItems(srcDataflow,dimensionId,connectionEndpointId):null;},fetchColumnFilteredValues:null,onColumnModeChange:onModeAdvancedModeChange,onColumnValuesChange:onModeAdvancedValuesChange,hideInclusionRadio:sdmxFilters,isSdmx:sdmxFilters,isCC:true,hideIds:sourceFormat!==__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */],showTimePeriodAsTree:sourceFormat!==__WEBPACK_IMPORTED_MODULE_26__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__enhanced_modal__["a" /* default */],{visible:isFilterQueryModalVisible,onCancel:function onCancel(){return setFilterQueryModalVisibility(false);},footer:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:function onClick(){return setFilterQueryModalVisibility(false);}},t('commons.buttons.close.title')),width:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MODAL_WIDTH_LG"],title:t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterQueryModal.title')},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{style:{fontFamily:'monospace'}},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a.TextArea,{disabled:true,value:filterStr,style:{overflow:'auto',resize:'none',height:560}}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_23_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])())(ELFilterStep));

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LoadMetadata__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LoadData__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(63);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,nodeId:state.app.endpointId,nodes:state.config.nodes,dstDataflow:state.scenes.easyLoading.dstDataflow,category:state.scenes.easyLoading.category,connectionEndpointId:state.scenes.easyLoading.connectionEndpointId,srcDataflow:state.scenes.easyLoading.srcDataflow,filterStr:state.scenes.easyLoading.filterStr,isMetadataImportReportVisible:state.scenes.easyLoading.isMetadataImportReportVisible,metadataImportReport:state.scenes.easyLoading.metadataImportReport,isDataImportPending:state.scenes.easyLoading.isDataImportPending,dataImportReport:state.scenes.easyLoading.dataImportReport,dataImportStatus:state.scenes.easyLoading.dataImportStatus,publishDf:state.scenes.easyLoading.publishDf,transcodeDf:state.scenes.easyLoading.transcodeDf,sourceFormat:state.scenes.easyLoading.sourceFormat,srcFile:state.scenes.easyLoading.srcFile,srcTable:state.scenes.easyLoading.srcTable,structureColumns:state.scenes.easyLoading.structureColumns,loadTableExists:state.scenes.easyLoading.loadTableExists,artefactsCreated:state.scenes.easyLoading.artefactsCreated,dsdTriplet:state.scenes.easyLoading.dsdTriplet,createdCodelists:state.scenes.easyLoading.createdCodelists,conceptSchemaDefinition:state.scenes.easyLoading.conceptSchemaDefinition,currentMapping:state.scenes.easyLoading.currentMapping,components:state.scenes.easyLoading.components,hasToDeleteArtefacts:state.scenes.easyLoading.hasToDeleteArtefacts,toDeleteCodelists:state.scenes.easyLoading.toDeleteCodelists,toDeleteConceptSchema:state.scenes.easyLoading.toDeleteConceptSchema};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMetadataSubmit:function onMetadataSubmit(endpointId,sdcDataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_77" /* submitELMetadata */])(endpointId,sdcDataflowTriplet));},onMetadataReportHide:function onMetadataReportHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_34" /* hideElMetadataReport */])());},onPublishDfChange:function onPublishDfChange(publishDf){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_24" /* changeElPublishDataflow */])(publishDf));},onTranscodeDfChange:function onTranscodeDfChange(transcodeDf){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_25" /* changeElTranscodeDataflow */])(transcodeDf));},onDataCreateSubmit:function onDataCreateSubmit(endpointId,sdcDataflowTriplet,dstDataflowTriplet,dsName,categoryId,filterStr,publishDf,transcodeDf){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_71" /* submitELDataCreate */])(endpointId,sdcDataflowTriplet,dstDataflowTriplet,dsName,categoryId,filterStr,publishDf,transcodeDf));},onDataUpdateSubmit:function onDataUpdateSubmit(endpointId,sdcDataflowTriplet,dstDDBDataflowId,filterStr,transcodeDf){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_76" /* submitELDataUpdate */])(endpointId,sdcDataflowTriplet,dstDDBDataflowId,filterStr,transcodeDf));},getImportStatus:function getImportStatus(dataflowTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_33" /* getELDataImportStatus */])(dataflowTriplet));},reset:function reset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_57" /* resetEl */])());},onPreloadCsv:function onPreloadCsv(separator,delimiter,hasHeader,filePath,tid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_37" /* preloadELCSV */])(separator,delimiter,hasHeader,filePath,tid));},onSetELLoadTableExists:function onSetELLoadTableExists(value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_62" /* setELLoadTableExists */])(value));},onELCreateArtefacts:function onELCreateArtefacts(structureColumns,filterStr,dstDataflow,tableName,inStagingDb,appLang){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_27" /* createELArtefacts */])(structureColumns,filterStr,dstDataflow,tableName,inStagingDb,appLang));},onELDeleteArtefacts:function onELDeleteArtefacts(toDeleteCodelists,toDeleteConceptSchema){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_29" /* deleteELCreatedArtefacts */])(toDeleteCodelists,toDeleteConceptSchema));},onELCreateDsd:function onELCreateDsd(structureColumns,dstDataflow,appLang,codelists,conceptSchema,astTerritoryDimId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_28" /* createELDsd */])(structureColumns,dstDataflow,appLang,codelists,conceptSchema,astTerritoryDimId));},onDataCreateFromFileSubmit:function onDataCreateFromFileSubmit(structureColumns,astTerritoryDimId,datasetName,filePath,separator,delimiter,hasHeader,DsId,DsAg,DsVs,CategoryId,DsdCode,mappFilePath,publishDf,executeTrans,filterStr){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_74" /* submitELDataFromFileCreate */])(structureColumns,astTerritoryDimId,datasetName,filePath,separator,delimiter,hasHeader,DsId,DsAg,DsVs,CategoryId,DsdCode,mappFilePath,publishDf,executeTrans,filterStr));},onDataCreateFromDbSubmit:function onDataCreateFromDbSubmit(structureColumns,astTerritoryDimId,tableName,datasetName,DsId,DsAg,DsVs,CategoryId,DsdCode,publishDf,executeTrans,filterStr){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_73" /* submitELDataFromDbCreate */])(structureColumns,astTerritoryDimId,tableName,datasetName,DsId,DsAg,DsVs,CategoryId,DsdCode,publishDf,executeTrans,filterStr));},onDataUpdateFromFileSubmit:function onDataUpdateFromFileSubmit(datasetName,filePath,separator,delimiter,hasHeader,ddbDataflowId,currentMapping,components,mappFilePath,transcodeDf,filterStr){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_75" /* submitELDataFromFileUpdate */])(datasetName,filePath,separator,delimiter,hasHeader,ddbDataflowId,currentMapping,components,mappFilePath,transcodeDf,filterStr));},onDataUpdateFromDBSubmit:function onDataUpdateFromDBSubmit(datasetName,tableName,ddbDataflowId,currentMapping,components,transcodeDf,filterStr){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_72" /* submitELDataFromDBUpdate */])(datasetName,tableName,ddbDataflowId,currentMapping,components,transcodeDf,filterStr));},onFileCsvAbsoluteUpload:function onFileCsvAbsoluteUpload(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_81" /* uploadElSrcFileCsvAbsolute */])(file));},onFileXlsAbsoluteUpload:function onFileXlsAbsoluteUpload(file,mappingFile){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["_83" /* uploadElSrcFileXlsAbsolute */])(file,mappingFile));}};};var ELLoadStep=function ELLoadStep(_ref){var t=_ref.t,appLanguage=_ref.appLanguage,nodeId=_ref.nodeId,nodes=_ref.nodes,mode=_ref.mode,dstDataflow=_ref.dstDataflow,category=_ref.category,connectionEndpointId=_ref.connectionEndpointId,srcDataflow=_ref.srcDataflow,filterStr=_ref.filterStr,isMetadataImportReportVisible=_ref.isMetadataImportReportVisible,metadataImportReport=_ref.metadataImportReport,isDataImportPending=_ref.isDataImportPending,dataImportStatus=_ref.dataImportStatus,dataImportReport=_ref.dataImportReport,publishDf=_ref.publishDf,transcodeDf=_ref.transcodeDf,sourceFormat=_ref.sourceFormat,srcFile=_ref.srcFile,srcTable=_ref.srcTable,structureColumns=_ref.structureColumns,loadTableExists=_ref.loadTableExists,artefactsCreated=_ref.artefactsCreated,dsdTriplet=_ref.dsdTriplet,createdCodelists=_ref.createdCodelists,conceptSchemaDefinition=_ref.conceptSchemaDefinition,currentMapping=_ref.currentMapping,components=_ref.components,hasToDeleteArtefacts=_ref.hasToDeleteArtefacts,toDeleteCodelists=_ref.toDeleteCodelists,toDeleteConceptSchema=_ref.toDeleteConceptSchema,onMetadataSubmit=_ref.onMetadataSubmit,onMetadataReportHide=_ref.onMetadataReportHide,onPublishDfChange=_ref.onPublishDfChange,onTranscodeDfChange=_ref.onTranscodeDfChange,onDataCreateSubmit=_ref.onDataCreateSubmit,onDataUpdateSubmit=_ref.onDataUpdateSubmit,getImportStatus=_ref.getImportStatus,reset=_ref.reset,onPreloadCsv=_ref.onPreloadCsv,onSetELLoadTableExists=_ref.onSetELLoadTableExists,onELCreateArtefacts=_ref.onELCreateArtefacts,onELDeleteArtefacts=_ref.onELDeleteArtefacts,onELCreateDsd=_ref.onELCreateDsd,onDataCreateFromFileSubmit=_ref.onDataCreateFromFileSubmit,onDataCreateFromDbSubmit=_ref.onDataCreateFromDbSubmit,onDataUpdateFromFileSubmit=_ref.onDataUpdateFromFileSubmit,onDataUpdateFromDBSubmit=_ref.onDataUpdateFromDBSubmit,onFileCsvAbsoluteUpload=_ref.onFileCsvAbsoluteUpload,onFileXlsAbsoluteUpload=_ref.onFileXlsAbsoluteUpload;var connectedNode=nodes.find(function(node){return node.general.id===nodeId;});var submitMetadata=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useCallback"])(function(){if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]){/* Calls "ImportDSDFromDataflow" which creates the metadata import report 
        sets the status variables
        isMetadataImportReportVisible: true,
        metadataImportReport: action.response.itemsMessage */onMetadataSubmit(connectionEndpointId,Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(srcDataflow)));}else if(sourceFormat!==__WEBPACK_IMPORTED_MODULE_16__constants__["w" /* EL_SOURCE_FORMAT_DB */]){/* Calls preloadCSV to load the csv/Excel table. Sets the status variables 
        srcTable: action.response,
        loadTableExists: true
      */onPreloadCsv(srcFile.separator,srcFile.delimiter?srcFile.delimiter:null,true,srcFile.csvPath,null);}else{/* EL_SOURCE_FORMAT_DB. Sets the variable status loadTableExists: true*/onSetELLoadTableExists(true);}},[onMetadataSubmit,onPreloadCsv,onSetELLoadTableExists,connectionEndpointId,srcDataflow,srcFile]);var submitDataCreate=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useCallback"])(function(){if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]){onDataCreateSubmit(connectionEndpointId,Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(srcDataflow)),dstDataflow,dstDataflow.name,category.IDCat,filterStr,publishDf,transcodeDf);}else if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["v" /* EL_SOURCE_FORMAT_CSV */]||sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["y" /* EL_SOURCE_FORMAT_XLS */]){onDataCreateFromFileSubmit(structureColumns,connectedNode.ast.astTerritoryDimId,dstDataflow.name,srcFile.fileAbsolutePath,srcFile.separator,srcFile.delimiter?srcFile.delimiter:null,true,// hasHeader
dstDataflow.id,dstDataflow.agencyID,dstDataflow.version,category.IDCat,Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dsdTriplet),srcFile.mappingAbsolutePath?srcFile.mappingAbsolutePath:null,publishDf,transcodeDf,filterStr);}else if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["w" /* EL_SOURCE_FORMAT_DB */]){onDataCreateFromDbSubmit(structureColumns,connectedNode.ast.astTerritoryDimId,srcTable,dstDataflow.name,dstDataflow.id,dstDataflow.agencyID,dstDataflow.version,category.IDCat,Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(dsdTriplet),publishDf,transcodeDf,filterStr);}},[connectionEndpointId,srcDataflow,dstDataflow,category,dsdTriplet,srcFile,filterStr,structureColumns,srcTable,publishDf,transcodeDf]);var submitDataUpdate=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useCallback"])(function(){if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]){onDataUpdateSubmit(connectionEndpointId,Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["P" /* getArtefactTripletFromUrn */])(Object(__WEBPACK_IMPORTED_MODULE_15__utils_sdmxJson__["_4" /* getUrnFromArtefact */])(srcDataflow)),dstDataflow.ddbDataflowId,filterStr,transcodeDf);}else if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["v" /* EL_SOURCE_FORMAT_CSV */]||sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["y" /* EL_SOURCE_FORMAT_XLS */]){onDataUpdateFromFileSubmit(dstDataflow.name,srcFile.fileAbsolutePath,srcFile.separator,srcFile.delimiter?srcFile.delimiter:null,true,// hasHeader,
dstDataflow.ddbDataflowId,currentMapping,components,srcFile.mappingAbsolutePath?srcFile.mappingAbsolutePath:null,transcodeDf,filterStr);}else if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["w" /* EL_SOURCE_FORMAT_DB */]){onDataUpdateFromDBSubmit(dstDataflow.name,srcTable,dstDataflow.ddbDataflowId,currentMapping,components,transcodeDf,filterStr);}},[sourceFormat,connectionEndpointId,srcDataflow,dstDataflow,filterStr,transcodeDf,srcFile,currentMapping,components,srcTable]);Object(__WEBPACK_IMPORTED_MODULE_8_react__["useEffect"])(function(){if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["v" /* EL_SOURCE_FORMAT_CSV */]){if(!srcFile.fileAbsolutePath){onFileCsvAbsoluteUpload(srcFile.file);}}else if(sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["y" /* EL_SOURCE_FORMAT_XLS */]){if(!srcFile.fileAbsolutePath||!srcFile.mappingAbsolutePath){onFileXlsAbsoluteUpload(srcFile.file,srcFile.mapping);}}},[sourceFormat,srcFile]);Object(__WEBPACK_IMPORTED_MODULE_8_react__["useEffect"])(function(){/* create artefacts when needed. Executes when load from DB, Excel, csv and dsd has not been created (dsdTriplet === null) */if(sourceFormat!==__WEBPACK_IMPORTED_MODULE_16__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]&&dstDataflow&&loadTableExists&&srcTable&&!dsdTriplet){onELCreateArtefacts(structureColumns,filterStr,dstDataflow,srcTable,false,appLanguage);}},[sourceFormat,dstDataflow,dsdTriplet,structureColumns,filterStr,appLanguage,loadTableExists,srcTable]);Object(__WEBPACK_IMPORTED_MODULE_8_react__["useEffect"])(function(){/* Deletes created artfefacts in case of error */if(sourceFormat!==__WEBPACK_IMPORTED_MODULE_16__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]&&hasToDeleteArtefacts){onELDeleteArtefacts(toDeleteCodelists,toDeleteConceptSchema);}},[sourceFormat,hasToDeleteArtefacts,toDeleteCodelists,toDeleteConceptSchema]);Object(__WEBPACK_IMPORTED_MODULE_8_react__["useEffect"])(function(){/* Creates the dsd when artefacts has been created and dsd has not been created */if(sourceFormat!==__WEBPACK_IMPORTED_MODULE_16__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]&&artefactsCreated&&!dsdTriplet){onELCreateDsd(structureColumns,dstDataflow,appLanguage,createdCodelists,conceptSchemaDefinition,connectedNode.ast.astTerritoryDimId);}},[sourceFormat,artefactsCreated,structureColumns,dstDataflow,createdCodelists,conceptSchemaDefinition,connectedNode,dsdTriplet]);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,mode===__WEBPACK_IMPORTED_MODULE_16__constants__["r" /* EL_MODE_CREATE */]&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__LoadMetadata__["a" /* default */],{onMetadataSubmit:submitMetadata,metadataImportReport:metadataImportReport,isMetadataImportReportVisible:isMetadataImportReportVisible,onMetadataReportHide:onMetadataReportHide,dsdTriplet:dsdTriplet,sourceFormat:sourceFormat}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__LoadData__["a" /* default */],{mode:mode,disabled:!!dataImportReport||mode===__WEBPACK_IMPORTED_MODULE_16__constants__["r" /* EL_MODE_CREATE */]&&sourceFormat===__WEBPACK_IMPORTED_MODULE_16__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]&&metadataImportReport===null||mode===__WEBPACK_IMPORTED_MODULE_16__constants__["r" /* EL_MODE_CREATE */]&&sourceFormat!==__WEBPACK_IMPORTED_MODULE_16__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]&&metadataImportReport===null&&(dsdTriplet===null||dsdTriplet===-1),onDataSubmit:mode===__WEBPACK_IMPORTED_MODULE_16__constants__["r" /* EL_MODE_CREATE */]?submitDataCreate:submitDataUpdate,dataImportReport:dataImportReport,isDataImportPending:isDataImportPending,dataImportStatus:dataImportStatus,getImportStatus:getImportStatus,dstDataflow:dstDataflow,publishDf:publishDf,transcodeDf:transcodeDf,onPublishDfChange:onPublishDfChange,onTranscodeDfChange:onTranscodeDfChange}),dataImportReport&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_divider___default.a,null),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:reset,icon:"plus"},mode===__WEBPACK_IMPORTED_MODULE_16__constants__["r" /* EL_MODE_CREATE */]?t("components.easyLoading.steps.load.body.createNewData.title"):t("components.easyLoading.steps.load.body.updateNewData.title"))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELLoadStep));

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__custom_empty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__artefact_export_report__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(63);
var ELLoadMetadata=function ELLoadMetadata(_ref){var t=_ref.t,onMetadataSubmit=_ref.onMetadataSubmit,metadataImportReport=_ref.metadataImportReport,isMetadataImportReportVisible=_ref.isMetadataImportReportVisible,dsdTriplet=_ref.dsdTriplet,sourceFormat=_ref.sourceFormat,onMetadataReportHide=_ref.onMetadataReportHide;return(/* The Load Metadata button creates the metadata: (codelists, concept scheme when needed) and dsd of the created dataflow, 
  producing a report of the result

  It is enabled when
   - in case of EL_SOURCE_FORMAT_SDMX_EP the metadata Import report has not been yet created by the server
   - otherwise when the dsd has not been created: dsdTriplet === null. 
  
   In case of error creating the dsd, the button is disabled (dsdTriplet === -1 indicates an error creating the dsd)
   
   Button Action: 
    EL_SOURCE_FORMAT_SDMX_EP: Calls "ImportDSDFromDataflow" which creates the metadata import report
    and sets the status variables
      isMetadataImportReportVisible: true,
      metadataImportReport: action.response.itemsMessage 

    EL_SOURCE_FORMAT_DB: Sets the variable status loadTableExists: true, indicating the data table exists
    Otherwise: Calls preloadCSV to load the csv/Excel table, which sets the status variables 
      srcTable: action.response,
      loadTableExists: true

    The last actions trigger the useEffect hooks in \load-step\index.jsx and the metadata import report 
    is created by the client

    When the status variable isMetadataImportReportVisible === true, shows a modal containing the result 
    of the load metadata process

   */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"center",style:{marginBottom:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:"primary",onClick:onMetadataSubmit,disabled:sourceFormat===__WEBPACK_IMPORTED_MODULE_17__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]&&metadataImportReport!==null||sourceFormat!==__WEBPACK_IMPORTED_MODULE_17__constants__["x" /* EL_SOURCE_FORMAT_SDMX_EP */]&&dsdTriplet!==null},t('components.easyLoading.steps.load.body.loadMetadata.title')))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a,{visible:isMetadataImportReportVisible,closable:false,title:null,footer:null,width:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MODAL_WIDTH_LG"]},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"space-between"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:"info-circle",style:{color:"#1890ff",fontSize:22,float:"left"}})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:"close",style:{fontSize:16,cursor:'pointer'},onClick:onMetadataReportHide}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{type:"inner",title:t("components.easyLoading.steps.load.body.loadMetadata.modals.metadataReport.title"),style:{marginLeft:38,marginTop:8},bodyStyle:{maxHeight:320,overflow:'auto'}},(metadataImportReport||[]).length>0?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__artefact_export_report__["a" /* default */],{report:metadataImportReport}):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__custom_empty__["a" /* default */],{text:t("components.easyLoading.steps.load.body.loadMetadata.modals.metadataReport.noMetadataImported")}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,{type:"flex",justify:"end"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:"primary",onClick:onMetadataReportHide,style:{marginTop:24}},"OK"))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_i18next__["b" /* translate */])()(ELLoadMetadata));

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__updated_status_getter__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
var ELLoadData=function ELLoadData(_ref){var t=_ref.t,mode=_ref.mode,disabled=_ref.disabled,onDataSubmit=_ref.onDataSubmit,dataImportReport=_ref.dataImportReport,isDataImportPending=_ref.isDataImportPending,dataImportStatus=_ref.dataImportStatus,getImportStatus=_ref.getImportStatus,dstDataflow=_ref.dstDataflow,publishDf=_ref.publishDf,transcodeDf=_ref.transcodeDf,onPublishDfChange=_ref.onPublishDfChange,onTranscodeDfChange=_ref.onTranscodeDfChange;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,mode===__WEBPACK_IMPORTED_MODULE_13__constants__["r" /* EL_MODE_CREATE */]&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"center",gutter:8,style:{marginBottom:16}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,t('components.easyLoading.steps.load.body.publishDataflow.title'),":"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,{checked:publishDf,onChange:function onChange(e){return onPublishDfChange(e.target.checked);},disabled:disabled}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"center",gutter:8,style:{marginBottom:16}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,t('components.easyLoading.steps.load.body.transcodeDataflow.title'),":"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,{checked:transcodeDf,onChange:function onChange(e){return onTranscodeDfChange(e.target.checked);},disabled:disabled}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",justify:"center"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:"primary",onClick:onDataSubmit,disabled:disabled},t('components.easyLoading.steps.load.body.loadData.title'),isDataImportPending&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"loading"})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:"flex",style:{marginTop:dataImportStatus?__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_LG"]:0}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__updated_status_getter__["a" /* default */],{enabled:isDataImportPending,callback:getImportStatus,callbackParam:dstDataflow,status:dataImportStatus,getStepLabel:function getStepLabel(step){return Object(__WEBPACK_IMPORTED_MODULE_13__constants__["I" /* getDataImportStatusTranslation */])(t)[step];},fishedWithError:!isDataImportPending&&!dataImportReport}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* translate */])()(ELLoadData));

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
var DEFAULT_DELAY=1000;function usePrevious(value){var ref=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])();Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function(){ref.current=value;});return ref.current;}var UpdatedStatusGetter=function UpdatedStatusGetter(_ref){var enabled=_ref.enabled,callback=_ref.callback,callbackParam=_ref.callbackParam,status=_ref.status,getStepLabel=_ref.getStepLabel,fishedWithError=_ref.fishedWithError;var prevEnabled=usePrevious(enabled);Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function(){if(callback){if(enabled){setTimeout(callback,DEFAULT_DELAY,callbackParam);}else{if(prevEnabled){callback(callbackParam);}}}},[enabled,callback,callbackParam,status]);var okIcon=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:'check-circle',theme:'filled',style:{marginLeft:8,color:'green'}});var errorIcon=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:'close-circle',theme:'filled',style:{marginLeft:8,color:'red'}});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,(status||[]).map(function(step,idx){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{key:idx,type:'flex',justify:'center',style:{padding:4}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i',null,getStepLabel&&getStepLabel(step)?getStepLabel(step):step),idx<status.length-1?okIcon:enabled?"...":fishedWithError?errorIcon:okIcon));}));};/* harmony default export */ __webpack_exports__["a"] = (UpdatedStatusGetter);

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(1569);
var mapStateToProps=function mapStateToProps(state){return{appLanguage:state.app.language,step:state.scenes.easyLoading.step,structureColumns:state.scenes.easyLoading.structureColumns,srcFile:state.scenes.easyLoading.srcFile,permissions:state.app.user.permissions};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCsvStructure:function fetchCsvStructure(_ref){var separator=_ref.separator,delimiter=_ref.delimiter,hasHeader=_ref.hasHeader,csvPath=_ref.csvPath,appLang=_ref.appLang;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_32" /* getELCsvStructure */])(separator,delimiter,hasHeader,csvPath,appLang));},onChange:function onChange(columnId,columnType,transColId,langCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["_67" /* setELStructureColumnType */])(columnId,columnType,transColId,langCode));}};};var ELStructureStep=function ELStructureStep(_ref2){var appLanguage=_ref2.appLanguage,step=_ref2.step,structureColumns=_ref2.structureColumns,srcFile=_ref2.srcFile,permissions=_ref2.permissions,fetchCsvStructure=_ref2.fetchCsvStructure,onChange=_ref2.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hocs_call__["a" /* default */],{cb:fetchCsvStructure,cbParam:{separator:srcFile?srcFile.separator:null,delimiter:srcFile&&srcFile.delimiter?srcFile.delimiter:null,hasHeader:true,csvPath:srcFile?srcFile.csvPath:null,appLang:appLanguage},disabled:step!==__WEBPACK_IMPORTED_MODULE_5__constants__["H" /* EL_STEP_STRUCTURE */]||!srcFile||structureColumns},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */],{structureColumns:structureColumns,permissions:permissions,onChange:onChange}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELStructureStep));

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_language_selector__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(346);
var TABLE_COL_WIDTH=110;var TABLE_COL_TRANSLATION_WIDTH=280;var TABLE_SELECT_WIDTH=120;var CenteredRadio=function CenteredRadio(_ref){var checked=_ref.checked,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{style:{width:"100%",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a,{checked:checked,onChange:onChange}));};var ELStructureStepTable=function ELStructureStepTable(_ref2){var t=_ref2.t,structureColumns=_ref2.structureColumns,permissions=_ref2.permissions,_onChange=_ref2.onChange;var canCreateCodelists=permissions&&permissions.rules&&permissions.rules.includes("CanUpdateStructuralMetadata");var columns=[{dataIndex:"id"},{dataIndex:"isDimension",title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,t('components.easyLoading.structure.table.dimension.title'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:"bar-chart",style:{marginLeft:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_SM"]}})),width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(isDimension,row){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CenteredRadio,{checked:isDimension,onChange:function onChange(){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_14__constants__["e" /* EL_COL_TYPE_DIMENSION */],null,null);}});},renderText:function renderText(isDimension){return isDimension?t('components.easyLoading.structure.table.dimension.values.true'):t('components.easyLoading.structure.table.dimension.values.false');}},{dataIndex:"isMeasure",title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,t('components.easyLoading.structure.table.measure.title'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:"line-chart",style:{marginLeft:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_SM"]}})),width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(isMeasure,row){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CenteredRadio,{checked:isMeasure,onChange:function onChange(){if(structureColumns.some(function(c){return c.type===__WEBPACK_IMPORTED_MODULE_14__constants__["g" /* EL_COL_TYPE_MEASURE */];})){__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a.error({title:t('components.easyLoading.structure.table.alerts.onlyOneMeasureAllowed.title'),content:t('components.easyLoading.structure.table.alerts.onlyOneMeasureAllowed.content')});}else{_onChange(row.id,__WEBPACK_IMPORTED_MODULE_14__constants__["g" /* EL_COL_TYPE_MEASURE */],null,null);}}});},renderText:function renderText(isMeasure){return isMeasure?t('components.easyLoading.structure.table.measure.values.true'):t('components.easyLoading.structure.table.measure.values.false');}},{dataIndex:"isAttribute",title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,t('components.easyLoading.structure.table.attribute.title'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:"profile",style:{marginLeft:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_SM"]}})),width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(isAttribute,row){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CenteredRadio,{checked:isAttribute,onChange:function onChange(){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_14__constants__["d" /* EL_COL_TYPE_ATTRIBUTE */],null,null);}});},renderText:function renderText(isAttribute){return isAttribute?t('components.easyLoading.structure.table.attribute.values.true'):t('components.easyLoading.structure.table.attribute.values.false');}}].concat(canCreateCodelists?{dataIndex:"translation",title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,t('components.easyLoading.structure.table.translation.title'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:"global",style:{marginLeft:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_SM"]}})),width:TABLE_COL_TRANSLATION_WIDTH,noFilter:true,noSort:true,render:function render(translation,row){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a,{checked:translation!==null,onChange:function onChange(){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_14__constants__["h" /* EL_COL_TYPE_TRANSLATION */],null,null);},style:{marginRight:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}}),translation&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{style:{marginRight:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"],width:TABLE_SELECT_WIDTH},onChange:function onChange(value){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_14__constants__["h" /* EL_COL_TYPE_TRANSLATION */],value,null);},value:row.translationDefinition.transColId},(structureColumns||[]).filter(function(column){return Object(__WEBPACK_IMPORTED_MODULE_15__utils__["d" /* columnCanBeTranslated */])(column);}).map(function(column,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:index,value:column.id},column.id);})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__data_language_selector__["a" /* default */],{value:row.translationDefinition.langCode,showLangCode:true,style:{width:90},onSelect:function onSelect(lang){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_14__constants__["h" /* EL_COL_TYPE_TRANSLATION */],row.translationDefinition.transColId,lang);}})));},renderText:function renderText(translation){var text=null;if(translation){if(translation.transColId){text=""+translation.transColId;if(translation.langCode){text=text+" ("+translation.langCode.toUpperCase()+")";}}}return text;}}:[]).concat({dataIndex:"isIgnored",title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,t('components.easyLoading.structure.table.ignore.title'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:"delete",style:{marginLeft:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_SM"]}})),width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(isIgnored,row){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CenteredRadio,{checked:isIgnored,onChange:function onChange(){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_14__constants__["f" /* EL_COL_TYPE_IGNORE */],null,null);}});},renderText:function renderText(isIgnored){return isIgnored?t('components.easyLoading.structure.table.ignore.values.true'):t('components.easyLoading.structure.table.ignore.values.false');}});return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__infinite_scroll_table__["a" /* default */],{data:(structureColumns||[]).map(function(column){return Object.assign({},column,{isDimension:column.type===__WEBPACK_IMPORTED_MODULE_14__constants__["e" /* EL_COL_TYPE_DIMENSION */],isMeasure:column.type===__WEBPACK_IMPORTED_MODULE_14__constants__["g" /* EL_COL_TYPE_MEASURE */],isAttribute:column.type===__WEBPACK_IMPORTED_MODULE_14__constants__["d" /* EL_COL_TYPE_ATTRIBUTE */],translation:column.type===__WEBPACK_IMPORTED_MODULE_14__constants__["h" /* EL_COL_TYPE_TRANSLATION */]?{langCode:column.translationDefinition.langCode,transColId:column.translationDefinition.transColId}:null,isIgnored:column.type===__WEBPACK_IMPORTED_MODULE_14__constants__["f" /* EL_COL_TYPE_IGNORE */]});}),getRowKey:function getRowKey(row){return row.id;},columns:columns});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])())(ELStructureStepTable));

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_components_redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducer__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Table__ = __webpack_require__(1571);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,structureColumns:state.scenes.easyLoading.structureColumns,codelists:state.scenes.easyLoading.structureCodelists,codelistDetail:state.scenes.easyLoading.codelistDetail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(columnId,refers,dimensions,association){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_58" /* setELAttributesColumnsValues */])(columnId,refers,dimensions,association));},onCodelistsFetch:function onCodelistsFetch(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_42" /* readELCodelists */])());},onCodelistShow:function onCodelistShow(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_14__reducer__["a" /* EL_CODELIST_DETAIL_PREFIX */]));}};};var ELDimensionsStep=function ELDimensionsStep(_ref){var t=_ref.t,nodeId=_ref.nodeId,nodes=_ref.nodes,structureColumns=_ref.structureColumns,codelists=_ref.codelists,codelistDetail=_ref.codelistDetail,onChange=_ref.onChange,onCodelistsFetch=_ref.onCodelistsFetch,onCodelistShow=_ref.onCodelistShow;var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),rowToAssociateCodelist=_useState2[0],setRowToAssociateCodelist=_useState2[1];var connectedNode=nodes.find(function(node){return node.general.id===nodeId;});var defaultItemsViewMode=connectedNode?connectedNode.general.defaultItemsViewMode:null;var handleCodelistSelect=function handleCodelistSelect(codelist){onChange(rowToAssociateCodelist.id,rowToAssociateCodelist.attributeDefinition.refers,rowToAssociateCodelist.attributeDefinition.dimensions,codelist);setRowToAssociateCodelist(null);};return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hocs_call__["a" /* default */],{cb:onCodelistsFetch,disabled:codelists!==null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Table__["a" /* default */],{structureColumns:structureColumns,setRowToAssociateCodelist:setRowToAssociateCodelist,onChange:onChange}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__enhanced_modal__["a" /* default */],{visible:rowToAssociateCodelist!==null,onCancel:function onCancel(){return setRowToAssociateCodelist(null);},title:t("components.easyLoading.attributes.table.modals.codelists.title"),width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return setRowToAssociateCodelist(null);}},t("commons.buttons.close.title"))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__artefact_list__["a" /* default */],{artefacts:codelists,onRowClick:function onRowClick(codelist){return handleCodelistSelect(codelist);},onDetailShow:function onDetailShow(triplet){return onCodelistShow(triplet,defaultItemsViewMode);},getIsDisabledRow:function getIsDisabledRow(_ref2){var isFinal=_ref2.isFinal;return!isFinal;}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__redux_components_redux_codelist_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_14__reducer__["a" /* EL_CODELIST_DETAIL_PREFIX */],instanceState:codelistDetail})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELDimensionsStep));

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__ = __webpack_require__(10);
var TABLE_COL_WIDTH=300;var TABLE_SELECT_WIDTH=200;var TABLE_COL_DIM_WIDTH=400;var TABLE_SELECT_DIM_WIDTH=300;var ELAttributesStepTable=function ELAttributesStepTable(_ref){var t=_ref.t,structureColumns=_ref.structureColumns,setRowToAssociateCodelist=_ref.setRowToAssociateCodelist,_onChange=_ref.onChange;var attributes=(structureColumns||[]).filter(function(column){return column.type===__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* EL_COL_TYPE_ATTRIBUTE */];});var dimensions=(structureColumns||[]).filter(function(column){return column.type===__WEBPACK_IMPORTED_MODULE_6__constants__["e" /* EL_COL_TYPE_DIMENSION */];});var columns=[{title:t('components.easyLoading.attributes.table.id.title'),dataIndex:"id"},{title:t('components.easyLoading.attributes.table.refers.title'),dataIndex:"refers",width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(refers,row){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{style:{marginRight:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MARGIN_MD"],width:TABLE_SELECT_WIDTH},value:refers,onChange:function onChange(value){_onChange(row.id,value,null,null);}},[__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* EL_ATTRIBUTE_REFERS_OBSERVATION */],__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* EL_ATTRIBUTE_REFERS_DIMENSION */],__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* EL_ATTRIBUTE_REFERS_DATASET */]].map(function(opt){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:opt,value:opt,title:Object(__WEBPACK_IMPORTED_MODULE_6__constants__["J" /* getELAtributeRefersTranslations */])(t)[opt]},Object(__WEBPACK_IMPORTED_MODULE_6__constants__["J" /* getELAtributeRefersTranslations */])(t)[opt]);}));}},{title:t('components.easyLoading.attributes.table.dimensions.title'),dataIndex:"referredDimensions",width:TABLE_COL_DIM_WIDTH,noFilter:true,noSort:true,render:function render(referredDimensions,row){return row.attributeDefinition.refers===__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* EL_ATTRIBUTE_REFERS_DIMENSION */]?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{mode:"multiple",style:{marginRight:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MARGIN_MD"],width:TABLE_SELECT_DIM_WIDTH},value:referredDimensions!==null?referredDimensions:undefined,onChange:function onChange(arr){_onChange(row.id,row.attributeDefinition.refers,arr,row.attributeDefinition.association);}},dimensions.map(function(dim){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:dim.id,value:dim.id,title:dim.id},dim.id);})):null;}},{title:t('components.easyLoading.attributes.table.association.title'),dataIndex:"association",width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(association,row){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__selector__["a" /* default */],{selectTitle:t('components.easyLoading.attributes.table.association.selector.selectTitle'),resetTitle:t('components.easyLoading.attributes.table.association.selector.resetTitle'),onSelect:function onSelect(){return setRowToAssociateCodelist(row);},onReset:function onReset(){return _onChange(row.id,row.attributeDefinition.refers,row.attributeDefinition.dimensions,null);},value:association,render:function render(codelist){return codelist?Object(__WEBPACK_IMPORTED_MODULE_9__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(codelist):"";}});}}];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__infinite_scroll_table__["a" /* default */],{data:attributes.map(function(attribute){return Object.assign({},attribute,{refers:attribute.attributeDefinition.refers,referredDimensions:attribute.attributeDefinition.dimensions,association:attribute.attributeDefinition.association});}),getRowKey:function getRowKey(row){return row.id;},columns:columns}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])())(ELAttributesStepTable));

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Table__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_artefact_summary__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__item_list__ = __webpack_require__(84);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{structureColumns:state.scenes.easyLoading.structureColumns,permissions:state.app.user.permissions,conceptSchemes:state.scenes.easyLoading.structureConceptSchemes,concepts:state.scenes.easyLoading.structureConcepts};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(columnId,conceptType,conceptName,conceptLang,conceptSchema,concept){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_63" /* setELSemanticColumnsConcept */])(columnId,conceptType,conceptName,conceptLang,conceptSchema,concept));},onConceptSchemesFetch:function onConceptSchemesFetch(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_43" /* readELConceptSchemes */])());},onConceptsFetch:function onConceptsFetch(csTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_44" /* readELConcepts */])(csTriplet));},onClearConcepts:function onClearConcepts(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["_54" /* resetELConcepts */])());}};};var ELSemanticStep=function ELSemanticStep(_ref){var t=_ref.t,structureColumns=_ref.structureColumns,permissions=_ref.permissions,conceptSchemes=_ref.conceptSchemes,concepts=_ref.concepts,onChange=_ref.onChange,onConceptSchemesFetch=_ref.onConceptSchemesFetch,onConceptsFetch=_ref.onConceptsFetch,onClearConcepts=_ref.onClearConcepts;var canCreateConcepts=permissions&&permissions.rules&&permissions.rules.includes("CanUpdateStructuralMetadata");var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),columnIdToAssociateConceptSchema=_useState2[0],setColumnIdToAssociateConceptSchema=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),columnIdToAssociateConcept=_useState4[0],setColumnIdToAssociateConcept=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),currentConceptSchema=_useState6[0],setCurrentConceptSchema=_useState6[1];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hocs_call__["a" /* default */],{cb:onConceptSchemesFetch,disabled:conceptSchemes!==null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Table__["a" /* default */],{structureColumns:structureColumns,canCreateConcepts:canCreateConcepts,setColumnIdToAssociateConceptSchema:setColumnIdToAssociateConceptSchema,onChange:onChange}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__enhanced_modal__["a" /* default */],{visible:columnIdToAssociateConceptSchema!==null,onCancel:function onCancel(){return setColumnIdToAssociateConceptSchema(null);},title:t("components.easyLoading.semantic.table.modals.conceptScheme.title"),width:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return setColumnIdToAssociateConceptSchema(null);}},t("commons.buttons.close.title"))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__artefact_list__["a" /* default */],{artefacts:conceptSchemes,onRowClick:function onRowClick(conceptSchema){var rowId=columnIdToAssociateConceptSchema;onChange(rowId,__WEBPACK_IMPORTED_MODULE_10__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */],null,null,conceptSchema,null);setCurrentConceptSchema(conceptSchema);setColumnIdToAssociateConcept(rowId);},getIsDisabledRow:function getIsDisabledRow(_ref2){var isFinal=_ref2.isFinal;return!isFinal;}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__enhanced_modal__["a" /* default */],{visible:columnIdToAssociateConcept!==null,onCancel:function onCancel(){return setColumnIdToAssociateConcept(null);},title:t("components.easyLoading.semantic.table.modals.concept.title"),width:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){onClearConcepts();setColumnIdToAssociateConcept(null);}},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hocs_call__["a" /* default */],{cb:onConceptsFetch,cbParam:currentConceptSchema},function(){if(currentConceptSchema===null){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_artefact_summary__["a" /* default */],{id:currentConceptSchema.id,agencyID:currentConceptSchema.agencyID,version:currentConceptSchema.version}));}(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__item_list__["a" /* default */],{data:concepts,hideOrderCol:true,onRowClick:function onRowClick(concept){onChange(columnIdToAssociateConcept,__WEBPACK_IMPORTED_MODULE_10__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */],null,null,currentConceptSchema,concept);setColumnIdToAssociateConcept(null);setColumnIdToAssociateConceptSchema(null);}})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELSemanticStep));

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__perf_input__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_language_selector__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_constants__);
var TABLE_COL_WIDTH=200;var TABLE_COL_SELECTOR_WIDTH=400;var LANG_SELECTOR_WIDTH=90;var inputStyle={marginRight:__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"],width:"calc(100% - "+LANG_SELECTOR_WIDTH+"px - "+__WEBPACK_IMPORTED_MODULE_12__styles_constants__["MARGIN_MD"]+"px"};var ELSemanticStepTable=function ELSemanticStepTable(_ref){var t=_ref.t,structureColumns=_ref.structureColumns,canCreateConcepts=_ref.canCreateConcepts,setColumnIdToAssociateConceptSchema=_ref.setColumnIdToAssociateConceptSchema,_onChange=_ref.onChange;var semanticColumns=(structureColumns||[]).filter(function(column){return column.type!==__WEBPACK_IMPORTED_MODULE_8__constants__["f" /* EL_COL_TYPE_IGNORE */]&&column.type!==__WEBPACK_IMPORTED_MODULE_8__constants__["h" /* EL_COL_TYPE_TRANSLATION */];});var conceptsCreationColumns=[{dataIndex:"conceptType",title:t("components.easyLoading.semantic.table.conceptType.title"),width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(conceptType,row){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a.Group,{onChange:function onChange(e){return _onChange(row.id,e.target.value,null,null,null,null);},value:conceptType},[__WEBPACK_IMPORTED_MODULE_8__constants__["u" /* EL_SEMANTIC_CONCEPT_NEW */],__WEBPACK_IMPORTED_MODULE_8__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */]].map(function(opt){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_radio___default.a,{key:opt,value:opt},Object(__WEBPACK_IMPORTED_MODULE_8__constants__["L" /* getELSemanticConceptTypeTranslations */])(t)[opt]);}));},renderText:function renderText(){return null;}},{dataIndex:"semanticDefinition",width:TABLE_COL_SELECTOR_WIDTH,noFilter:true,noSort:true,render:function render(semanticDefinition,row){if(semanticDefinition.conceptType===__WEBPACK_IMPORTED_MODULE_8__constants__["u" /* EL_SEMANTIC_CONCEPT_NEW */]){var newConcept=semanticDefinition.newConcept;var lang=semanticDefinition.currentLang;var name=newConcept[lang]||"";return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__perf_input__["a" /* default */],{Component:__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,style:inputStyle,value:name,onChange:function onChange(value){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_8__constants__["u" /* EL_SEMANTIC_CONCEPT_NEW */],value,lang,null,null);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__data_language_selector__["a" /* default */],{value:semanticDefinition.currentLang,showLangCode:true,style:{width:LANG_SELECTOR_WIDTH},onSelect:function onSelect(lang){_onChange(row.id,__WEBPACK_IMPORTED_MODULE_8__constants__["u" /* EL_SEMANTIC_CONCEPT_NEW */],newConcept[lang]||"",lang,null,null);}}));}else if(semanticDefinition.conceptType===__WEBPACK_IMPORTED_MODULE_8__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */]){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__selector__["a" /* default */],{selectTitle:t('components.easyLoading.semantic.table.conceptScheme.selector.selectTitle'),resetTitle:t('components.easyLoading.semantic.table.conceptScheme.selector.resetTitle'),onSelect:function onSelect(){return setColumnIdToAssociateConceptSchema(row.id);},onReset:function onReset(){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_8__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */],null,null,null,null);},value:semanticDefinition.concept,render:function render(concept){return concept?concept.id:"";}}));}else return null;},renderText:function renderText(){return null;}}];var conceptColumn=[{dataIndex:"semanticDefinition",width:TABLE_COL_SELECTOR_WIDTH,noFilter:true,noSort:true,render:function render(semanticDefinition,row){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__selector__["a" /* default */],{selectTitle:t('components.easyLoading.semantic.table.concept.selector.selectTitle'),resetTitle:t('components.easyLoading.semantic.table.concept.selector.resetTitle'),onSelect:function onSelect(){return setColumnIdToAssociateConceptSchema(row.id);},onReset:function onReset(){return _onChange(row.id,__WEBPACK_IMPORTED_MODULE_8__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */],null,null,null,null);},value:semanticDefinition.concept,render:function render(concept){return concept?concept.id:"";}}));},renderText:function renderText(){return null;}}];var columns=[{dataIndex:"id",title:t("components.easyLoading.semantic.table.id.title")}].concat(canCreateConcepts?conceptsCreationColumns:conceptColumn);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__infinite_scroll_table__["a" /* default */],{data:semanticColumns.map(function(column){return Object.assign({},column,{conceptType:column.semanticDefinition.conceptType});}),getRowKey:function getRowKey(row){return row.id;},columns:columns});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])())(ELSemanticStepTable));

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_components_redux_codelist_detail_modal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducer__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Table__ = __webpack_require__(1575);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var mapStateToProps=function mapStateToProps(state){return{nodeId:state.app.endpointId,nodes:state.config.nodes,structureColumns:state.scenes.easyLoading.structureColumns,codelists:state.scenes.easyLoading.structureCodelists,codelistDetail:state.scenes.easyLoading.codelistDetail,astTerritorialCodelist:state.scenes.easyLoading.astTerritorialCodelist};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChange:function onChange(columnId,role,association){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_60" /* setELDimensionsColumnsValues */])(columnId,role,association));},onCodelistsFetch:function onCodelistsFetch(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["_42" /* readELCodelists */])());},onCodelistShow:function onCodelistShow(codelistTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_8__redux_components_redux_codelist_detail_modal_actions__["_87" /* showCodelistDetail */])(codelistTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_14__reducer__["a" /* EL_CODELIST_DETAIL_PREFIX */]));}};};var ELDimensionsStep=function ELDimensionsStep(_ref){var t=_ref.t,nodeId=_ref.nodeId,nodes=_ref.nodes,structureColumns=_ref.structureColumns,codelists=_ref.codelists,codelistDetail=_ref.codelistDetail,astTerritorialCodelist=_ref.astTerritorialCodelist,onChange=_ref.onChange,onCodelistsFetch=_ref.onCodelistsFetch,onCodelistShow=_ref.onCodelistShow;var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),rowToAssociateCodelist=_useState2[0],setRowToAssociateCodelist=_useState2[1];var connectedNode=nodes.find(function(node){return node.general.id===nodeId;});var defaultItemsViewMode=connectedNode?connectedNode.general.defaultItemsViewMode:null;var handleCodelistSelect=function handleCodelistSelect(codelist){onChange(rowToAssociateCodelist.id,rowToAssociateCodelist.dimensionDefinition.role,codelist);setRowToAssociateCodelist(null);};return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hocs_call__["a" /* default */],{cb:onCodelistsFetch,disabled:codelists!==null},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Table__["a" /* default */],{structureColumns:structureColumns,setRowToAssociateCodelist:setRowToAssociateCodelist,astTerritorialCodelist:astTerritorialCodelist,onChange:onChange}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__enhanced_modal__["a" /* default */],{visible:rowToAssociateCodelist!==null,onCancel:function onCancel(){return setRowToAssociateCodelist(null);},title:t('components.easyLoading.dimensions.table.modals.codelists.title'),width:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return setRowToAssociateCodelist(null);}},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__artefact_list__["a" /* default */],{artefacts:codelists,onRowClick:function onRowClick(codelist){return handleCodelistSelect(codelist);},onDetailShow:function onDetailShow(triplet){return onCodelistShow(triplet,defaultItemsViewMode);},getIsDisabledRow:function getIsDisabledRow(_ref2){var isFinal=_ref2.isFinal;return!isFinal;}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__redux_components_redux_codelist_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_14__reducer__["a" /* EL_CODELIST_DETAIL_PREFIX */],instanceState:codelistDetail})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELDimensionsStep));

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__infinite_scroll_table__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_sdmxJson__ = __webpack_require__(10);
var TABLE_COL_WIDTH=300;var TABLE_SELECT_WIDTH=200;var ELDimensionsStepTable=function ELDimensionsStepTable(_ref){var t=_ref.t,structureColumns=_ref.structureColumns,setRowToAssociateCodelist=_ref.setRowToAssociateCodelist,astTerritorialCodelist=_ref.astTerritorialCodelist,_onChange=_ref.onChange;var dimensions=(structureColumns||[]).filter(function(column){return column.type===__WEBPACK_IMPORTED_MODULE_12__constants__["e" /* EL_COL_TYPE_DIMENSION */];});var columns=[{title:t('components.easyLoading.dimensions.table.id.title'),dataIndex:"id"},{title:t('components.easyLoading.dimensions.table.role.title'),dataIndex:"role",width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(role,row){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{style:{marginRight:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"],width:TABLE_SELECT_WIDTH},value:row.dimensionDefinition.role,onChange:function onChange(value){if(value===__WEBPACK_IMPORTED_MODULE_12__constants__["j" /* EL_DIMENSION_ROLE_GENERIC */]){_onChange(row.id,value,row.dimensionDefinition.association);}else{if(structureColumns.some(function(c){return c.dimensionDefinition.role===value;})){var roleTranslation=Object(__WEBPACK_IMPORTED_MODULE_12__constants__["K" /* getELDimensionRoleTranslations */])(t)[value];__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t('components.easyLoading.dimensions.table.alerts.dimensionRole.title'),content:t('components.easyLoading.dimensions.table.alerts.dimensionRole.onlyOne',{type:roleTranslation})});}else if(value===__WEBPACK_IMPORTED_MODULE_12__constants__["m" /* EL_DIMENSION_ROLE_TIME */]){if((row.translations||[]).length>0){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:t('components.easyLoading.dimensions.table.alerts.dimensionRole.title'),content:t('components.easyLoading.dimensions.table.alerts.dimensionRole.nonTranslated')});}else{_onChange(row.id,value,row.dimensionDefinition.association);}}else if(value===__WEBPACK_IMPORTED_MODULE_12__constants__["l" /* EL_DIMENSION_ROLE_TERRITORY */]){var dimAssociation=row.dimensionDefinition.association;if(astTerritorialCodelist){dimAssociation=Object(__WEBPACK_IMPORTED_MODULE_16__utils_sdmxJson__["O" /* getArtefactTripletFromString */])(astTerritorialCodelist);}_onChange(row.id,value,dimAssociation);}else{_onChange(row.id,value,row.dimensionDefinition.association);}}}},[__WEBPACK_IMPORTED_MODULE_12__constants__["j" /* EL_DIMENSION_ROLE_GENERIC */],__WEBPACK_IMPORTED_MODULE_12__constants__["i" /* EL_DIMENSION_ROLE_FREQUENCY */],__WEBPACK_IMPORTED_MODULE_12__constants__["m" /* EL_DIMENSION_ROLE_TIME */],__WEBPACK_IMPORTED_MODULE_12__constants__["l" /* EL_DIMENSION_ROLE_TERRITORY */]].map(function(opt){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{key:opt,value:opt,title:Object(__WEBPACK_IMPORTED_MODULE_12__constants__["K" /* getELDimensionRoleTranslations */])(t)[opt]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* getIconType */])(opt),style:{marginRight:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_SM"]}}),Object(__WEBPACK_IMPORTED_MODULE_12__constants__["K" /* getELDimensionRoleTranslations */])(t)[opt]);}));}},{title:t('components.easyLoading.dimensions.table.association.title'),dataIndex:"association",width:TABLE_COL_WIDTH,noFilter:true,noSort:true,render:function render(association,row){if((row.translations||[]).length>0){var text=[];row.translations.forEach(function(t){text.push(t.column+" ("+t.lang.toUpperCase()+")");});return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,t('components.easyLoading.dimensions.table.association.translation')+" "+text.join(' , '));}else if(row.dimensionDefinition.role!==__WEBPACK_IMPORTED_MODULE_12__constants__["m" /* EL_DIMENSION_ROLE_TIME */]){if(row.dimensionDefinition.role===__WEBPACK_IMPORTED_MODULE_12__constants__["l" /* EL_DIMENSION_ROLE_TERRITORY */]&&astTerritorialCodelist){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{disabled:true,style:{backgroundColor:"inherit"},value:Object(__WEBPACK_IMPORTED_MODULE_16__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(row.dimensionDefinition.association)});}else{return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__selector__["a" /* default */],{selectTitle:t('components.easyLoading.dimensions.table.association.selector.selectTitle'),resetTitle:t('components.easyLoading.dimensions.table.association.selector.resetTitle'),onSelect:function onSelect(){return setRowToAssociateCodelist(row);},onReset:function onReset(){return _onChange(row.id,row.dimensionDefinition.role,null);},value:association,render:function render(codelist){return codelist?Object(__WEBPACK_IMPORTED_MODULE_16__utils_sdmxJson__["_1" /* getStringFromArtefactTriplet */])(codelist):"";}});}}else{return null;}}}];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__infinite_scroll_table__["a" /* default */],{data:dimensions.map(function(dim){return Object.assign({},dim,{role:dim.dimensionDefinition.role,association:dim.dimensionDefinition.association});}),getRowKey:function getRowKey(row){return row.id;},columns:columns}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])())(ELDimensionsStepTable));

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ELMapper__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(347);
var mapStateToProps=function mapStateToProps(state){return{step:state.scenes.easyLoading.step,srcFile:state.scenes.easyLoading.srcFile,dstDataflow:state.scenes.easyLoading.dstDataflow,mappings:state.scenes.easyLoading.mappings,csvHeader:state.scenes.easyLoading.csvHeader,cube:state.scenes.easyLoading.cube,shouldVerifyMapping:state.scenes.easyLoading.shouldVerifyMapping,currentMapping:state.scenes.easyLoading.currentMapping,currentMappingIsValid:state.scenes.easyLoading.currentMappingIsValid};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCsvMappingsCube:function fetchCsvMappingsCube(_ref){var separator=_ref.separator,delimiter=_ref.delimiter,hasHeader=_ref.hasHeader,csvPath=_ref.csvPath,cubeId=_ref.cubeId;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["m" /* getELCsvMappingsCube */])(separator,delimiter,hasHeader,csvPath,cubeId));},clearMapping:function clearMapping(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["q" /* resetELMapping */])());},readMappingDetails:function readMappingDetails(fileMappingId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["n" /* readELFileMapping */])(fileMappingId));}};};var LABEL_WIDTH=100;var ELMappingStep=function ELMappingStep(_ref2){var t=_ref2.t,step=_ref2.step,srcFile=_ref2.srcFile,dstDataflow=_ref2.dstDataflow,mappings=_ref2.mappings,csvHeader=_ref2.csvHeader,cube=_ref2.cube,shouldVerifyMapping=_ref2.shouldVerifyMapping,currentMappingIsValid=_ref2.currentMappingIsValid,currentMapping=_ref2.currentMapping,fetchCsvMappingsCube=_ref2.fetchCsvMappingsCube,clearMapping=_ref2.clearMapping,readMappingDetails=_ref2.readMappingDetails;var newMappingOption=__WEBPACK_IMPORTED_MODULE_14__constants__["M" /* newMapping */];newMappingOption.Name=Object(__WEBPACK_IMPORTED_MODULE_16__constants__["h" /* getELMappingTranslations */])(t)[__WEBPACK_IMPORTED_MODULE_16__constants__["e" /* EL_MAPPING_NEW_MAPPING */]];var mappingOptions=[newMappingOption].concat(mappings||[]);var onMappingSelect=function onMappingSelect(mappingId){if(mappingId===-1){clearMapping();}else{readMappingDetails(mappingId);}};Object(__WEBPACK_IMPORTED_MODULE_8_react__["useEffect"])(function(){if((mappings||[]).length===1&&shouldVerifyMapping){readMappingDetails(mappings[0].IDMapping);}},[mappings,shouldVerifyMapping,readMappingDetails]);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__hocs_call__["a" /* default */],{cb:fetchCsvMappingsCube,cbParam:{separator:srcFile?srcFile.separator:null,delimiter:srcFile&&srcFile.delimiter?srcFile.delimiter:null,hasHeader:true,csvPath:srcFile?srcFile.csvPath:null,cubeId:dstDataflow.cubeId},disabled:step!==__WEBPACK_IMPORTED_MODULE_14__constants__["F" /* EL_STEP_MAPPING */]||!srcFile||mappings!==null||csvHeader!==null},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:"flex",gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"],style:{marginBottom:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_MD"]},align:"middle"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:17},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{style:{display:"inline-block",width:LABEL_WIDTH}},t('components.easyLoading.steps.mapping.title')+": "),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{style:{width:"calc(100% - "+LABEL_WIDTH+"px"},onChange:function onChange(value){return onMappingSelect(value);},value:currentMapping.IDMapping},mappingOptions.map(function(mapping,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option,{key:index,value:mapping.IDMapping},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:Object(__WEBPACK_IMPORTED_MODULE_18__utils__["b" /* getMappingIcon */])(mapping.IDMapping),style:{marginRight:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["MARGIN_SM"]}}),mapping.Name);}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:7},currentMappingIsValid?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:"check-circle",theme:"filled",style:{color:'green'}})," "+t('components.easyLoading.steps.mapping.validation.valid')):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:"close-circle",theme:"filled",style:{color:'red'}})," "+t('components.easyLoading.steps.mapping.validation.notValid')))),csvHeader&&cube&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_13__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ELMapper__["a" /* default */],{csvHeader:csvHeader,cube:cube,selectedMapping:currentMapping.IDMapping}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELMappingStep));

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ELComponentMapper__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ELCsvHeaderList__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ELCubeComponentList__ = __webpack_require__(1580);
var ELMapper=function ELMapper(_ref){var t=_ref.t,csvHeader=_ref.csvHeader,components=_ref.components,cube=_ref.cube,selectedMapping=_ref.selectedMapping;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a,{span:7},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"file-mapping__wizard__csv-header"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,Object.assign({title:t('components.easyLoading.steps.mapping.cards.csvHeader.title')},__WEBPACK_IMPORTED_MODULE_10__constants__["g" /* cardStyle */]),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MARGIN_MD"],height:__WEBPACK_IMPORTED_MODULE_10__constants__["f" /* EL_MAPPING_ROW_HEIGHT */]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ELCsvHeaderList__["a" /* default */],{csvHeader:csvHeader,selectedMapping:selectedMapping}))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a,{span:10},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"file-mapping__wizard__component-mapper"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,__WEBPACK_IMPORTED_MODULE_10__constants__["g" /* cardStyle */],__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MARGIN_MD"],height:__WEBPACK_IMPORTED_MODULE_10__constants__["f" /* EL_MAPPING_ROW_HEIGHT */]}},selectedMapping&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ELComponentMapper__["a" /* default */],{components:components,csvHeader:csvHeader,cube:cube,selectedMapping:selectedMapping}))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_col___default.a,{span:7},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"file-mapping__wizard__cube-components"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,Object.assign({title:t('components.easyLoading.steps.mapping.cards.cubeComponents.title')},__WEBPACK_IMPORTED_MODULE_10__constants__["g" /* cardStyle */]),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MARGIN_MD"],height:__WEBPACK_IMPORTED_MODULE_10__constants__["f" /* EL_MAPPING_ROW_HEIGHT */]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ELCubeComponentList__["a" /* default */],{cube:cube,selectedMapping:selectedMapping}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])())(ELMapper));

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__file_mapping_component_list__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(195);
var mapStateToProps=function mapStateToProps(state){return{components:state.scenes.easyLoading.components,selectedColumnName:state.scenes.easyLoading.selectedColumnName,selectedCubeComponentCode:state.scenes.easyLoading.selectedCubeComponentCode,selectedComponent:state.scenes.easyLoading.selectedComponent};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onComponentAdd:function onComponentAdd(columnName,cubeComponentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["l" /* addELComponentMapperComponent */])(columnName,cubeComponentCode));},onComponentAddAll:function onComponentAddAll(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["k" /* addAllELComponentMapperComponent */])());},onComponentRemove:function onComponentRemove(columnName,cubeComponentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["p" /* removeELComponentMapperComponent */])(columnName,cubeComponentCode));},onComponentRemoveAll:function onComponentRemoveAll(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["o" /* removeAllELComponentMapperComponent */])());},onComponentSelect:function onComponentSelect(columnName,cubeComponentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["r" /* selectELComponentMapperComponent */])(columnName,cubeComponentCode));}};};var ELComponentMapper=function ELComponentMapper(_ref){var t=_ref.t,components=_ref.components,selectedMapping=_ref.selectedMapping,selectedColumnName=_ref.selectedColumnName,selectedCubeComponentCode=_ref.selectedCubeComponentCode,selectedComponent=_ref.selectedComponent,onComponentAdd=_ref.onComponentAdd,onComponentAddAll=_ref.onComponentAddAll,onComponentRemove=_ref.onComponentRemove,onComponentRemoveAll=_ref.onComponentRemoveAll,onComponentSelect=_ref.onComponentSelect;var handleComponentSelect=function handleComponentSelect(columnName,cubeComponentCode){if(selectedMapping===-1){onComponentSelect(columnName,cubeComponentCode);}};return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'space-between',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_10__styles_constants__["GUTTER_SM"]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onComponentAdd(selectedColumnName,selectedCubeComponentCode);},disabled:selectedColumnName===null||selectedCubeComponentCode===null||selectedMapping>-1,title:t('components.easyLoading.steps.mapping.cards.componentMapper.componentAddButton.title'),icon:'plus'})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onComponentAddAll();},disabled:selectedMapping>-1,title:t('components.easyLoading.steps.mapping.cards.componentMapper.componentAddAllButton.title'),style:{'paddingLeft':6,'paddingRight':6,'fontSize':22}},'++')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{onClick:function onClick(){return onComponentRemove(selectedComponent.columnName,selectedComponent.cubeComponentCode);},disabled:selectedComponent===null||selectedMapping>-1,icon:'minus',title:t('components.easyLoading.steps.mapping.cards.componentMapper.componentRemoveButton.title')})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{className:'file-mapping__file-mapping__wizardjoined__icons'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{disabled:components.length===0||selectedMapping>-1,onClick:function onClick(){return onComponentRemoveAll();},icon:'delete',title:t('components.easyLoading.steps.mapping.cards.componentMapper.componentRemoveAllButton.title')}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__file_mapping_component_list__["a" /* default */],{value:components,selected:selectedComponent!==null?''+selectedComponent.columnName+selectedComponent.cubeComponentCode:null,onSelect:function onSelect(_ref2){var columnName=_ref2.columnName,cubeComponentCode=_ref2.cubeComponentCode;return handleComponentSelect(columnName,cubeComponentCode);},columnNameKey:'columnName',cubeComponentCodeKey:'cubeComponentCode'}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELComponentMapper));

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_data_manager_file_mapping_wizard_component_list__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(195);
var mapStateToProps=function mapStateToProps(state){return{selectedColumnName:state.scenes.easyLoading.selectedColumnName,components:state.scenes.easyLoading.components};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onColumnSelect:function onColumnSelect(columnName){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["t" /* selectELMappingColumn */])(columnName));}};};var ELCsvHeaderList=function ELCsvHeaderList(_ref){var t=_ref.t,csvHeader=_ref.csvHeader,selectedColumnName=_ref.selectedColumnName,components=_ref.components,selectedMapping=_ref.selectedMapping,onColumnSelect=_ref.onColumnSelect;var handleColumnSelect=function handleColumnSelect(name){if(selectedMapping===-1){onColumnSelect(name);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__scenes_data_manager_file_mapping_wizard_component_list__["a" /* default */],{components:csvHeader!==null?csvHeader.map(function(name,idx){return{name:name,key:idx,detailTitle:t('components.easyLoading.steps.mapping.csvComponentList.detail.title'),onDetail:null};}):[],selected:selectedColumnName!==null?selectedColumnName:null,onSelect:function onSelect(_ref2){var name=_ref2.name;return handleColumnSelect(name);},disabled:components.map(function(comp){return comp.columnName;})}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(ELCsvHeaderList));

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_data_manager_file_mapping_wizard_component_list__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(195);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{selectedCubeComponentCode:state.scenes.easyLoading.selectedCubeComponentCode,components:state.scenes.easyLoading.components,cube:state.scenes.easyLoading.cube};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCubeComponentSelect:function onCubeComponentSelect(cubeComponentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["s" /* selectELCubeComponentListComponent */])(cubeComponentCode));}};};var ELCubeComponentList=function ELCubeComponentList(_ref){var selectedCubeComponentCode=_ref.selectedCubeComponentCode,components=_ref.components,cube=_ref.cube,selectedMapping=_ref.selectedMapping,onCubeComponentSelect=_ref.onCubeComponentSelect;var handleCubeComponentSelect=function handleCubeComponentSelect(Code){if(selectedMapping===-1){onCubeComponentSelect(Code);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__scenes_data_manager_file_mapping_wizard_component_list__["a" /* default */],{components:cube!==null?[].concat(_toConsumableArray(cube.components.dimensions.map(function(dim){return Object.assign({},dim,{icon:'bar-chart'});})),_toConsumableArray(cube.components.timeDimensions.map(function(dim){return Object.assign({},dim,{icon:'clock-circle'});})),_toConsumableArray(cube.components.attributes.map(function(attr){return Object.assign({},attr,{icon:'profile'});})),_toConsumableArray(cube.components.measures.map(function(meas){return Object.assign({},meas,{icon:'line-chart'});}))).map(function(comp,idx){return Object.assign({},comp,{name:comp.Code,key:idx,onDetail:null});}):[],selected:selectedCubeComponentCode!==null?selectedCubeComponentCode:null,onSelect:function onSelect(_ref2){var Code=_ref2.Code;return handleCubeComponentSelect(Code);},disabled:components.map(function(comp){return comp.cubeComponentCode;}),hasIcon:true}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ELCubeComponentList));

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attributesAreWellDefined; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(63);
var attributesAreWellDefined=function attributesAreWellDefined(structureColumns){for(var i=0;i<(structureColumns||[]).length;i++){var column=structureColumns[i];if(column.type!==__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* EL_COL_TYPE_ATTRIBUTE */]){continue;}var attributeDefinition=column.attributeDefinition;if(attributeDefinition.refers===null){return false;}else if(attributeDefinition.refers===__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EL_ATTRIBUTE_REFERS_DIMENSION */]&&(attributeDefinition.dimensions||[]).length===0){return false;}}return true;};

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return semanticIsWellDefined; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(63);
var isSemanticColumn=function isSemanticColumn(column){return column.type!==__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EL_COL_TYPE_IGNORE */]&&column.type!==__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* EL_COL_TYPE_TRANSLATION */];};var newConceptHasError=function newConceptHasError(column){if(column.semanticDefinition.conceptType===__WEBPACK_IMPORTED_MODULE_0__constants__["u" /* EL_SEMANTIC_CONCEPT_NEW */]){if(Object.keys(column.semanticDefinition.newConcept).length===0){return true;}else{var hasError=false;Object.keys(column.semanticDefinition.newConcept).forEach(function(lang){if((column.semanticDefinition.newConcept[lang]||"").length===0){hasError=true;}});return hasError;}}return false;};var conceptHasError=function conceptHasError(column){if(column.semanticDefinition.conceptType===__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* EL_SEMANTIC_CONCEPT_EXISTING */]){return column.semanticDefinition.conceptSchema===null||column.semanticDefinition.concept===null;}return false;};var semanticIsWellDefined=function semanticIsWellDefined(structureColumns){return!(structureColumns||[]).some(function(column){return isSemanticColumn(column)&&(column.semanticDefinition.conceptType===null||newConceptHasError(column)||conceptHasError(column));});};

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_easy_loading__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_easy_loading_constants__ = __webpack_require__(63);
var EasyLoadingUpdate=function EasyLoadingUpdate(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_easy_loading__["a" /* default */],{mode:__WEBPACK_IMPORTED_MODULE_2__components_easy_loading_constants__["s" /* EL_MODE_UPDATE */]});};/* harmony default export */ __webpack_exports__["a"] = (EasyLoadingUpdate);

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_data_manager_cube_list_actions__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_components_redux_codelist_detail_modal_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_components_redux_category_scheme_detail_modal_actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_components_redux_concept_scheme_detail_modal_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scenes_meta_manager_dataflows_actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_data_manager_dataflow_builder_list_actions__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_components_redux_dsd_detail_modal_actions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scenes_meta_manager_msds_actions__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scenes_meta_manager_metadataflows_actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scenes_meta_manager_agency_schemes_actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_components_redux_content_constraint_modal_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scenes_utilities_compare_dsds_actions__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scenes_utilities_compare_item_schemes_actions__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__scenes_data_manager_upgrade_dsd_actions__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__scenes_reference_metadata_metadata_set_actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__scenes_reference_metadata_dcat_actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scenes_meta_manager_hierarchical_codelists_actions__ = __webpack_require__(194);
var fileSaveMiddleware=function fileSaveMiddleware(){return function(next){return function(action){var result=next(action);if(action.type===__WEBPACK_IMPORTED_MODULE_0__api_actions__["h" /* REQUEST_SUCCESS */]&&action.fileSave){if(action.label===__WEBPACK_IMPORTED_MODULE_2__scenes_data_manager_cube_list_actions__["c" /* CUBE_LIST_CUBE_DOWNLOAD_CSV_READ */]||action.label.endsWith(__WEBPACK_IMPORTED_MODULE_3__redux_components_redux_codelist_detail_modal_actions__["H" /* CODELIST_DETAIL_DOWNLOAD_SUBMIT */])||action.label.endsWith(__WEBPACK_IMPORTED_MODULE_4__redux_components_redux_category_scheme_detail_modal_actions__["p" /* CATEGORY_SCHEME_DETAIL_DOWNLOAD_SUBMIT */])||action.label.endsWith(__WEBPACK_IMPORTED_MODULE_5__redux_components_redux_concept_scheme_detail_modal_actions__["p" /* CONCEPT_SCHEME_DETAIL_DOWNLOAD_SUBMIT */])||action.label===__WEBPACK_IMPORTED_MODULE_11__scenes_meta_manager_agency_schemes_actions__["g" /* AGENCY_SCHEMES_AGENCY_SCHEME_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_6__scenes_meta_manager_dataflows_actions__["m" /* DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT */]||action.label===__WEBPACK_IMPORTED_MODULE_7__scenes_data_manager_dataflow_builder_list_actions__["g" /* DATAFLOW_BUILDER_LIST_DATAFLOW_DOWNLOAD */]||action.label.endsWith(__WEBPACK_IMPORTED_MODULE_8__redux_components_redux_dsd_detail_modal_actions__["U" /* DSD_DETAIL_DOWNLOAD_SUBMIT */])||action.label===__WEBPACK_IMPORTED_MODULE_9__scenes_meta_manager_msds_actions__["m" /* MSDS_MSD_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_10__scenes_meta_manager_metadataflows_actions__["u" /* METADATAFLOWS_METADATAFLOW_DOWNLOAD */]||action.label.endsWith(__WEBPACK_IMPORTED_MODULE_12__redux_components_redux_content_constraint_modal_actions__["s" /* CONTENT_CONSTRAINT_DETAIL_DOWNLOAD_SUBMIT */])||action.label===__WEBPACK_IMPORTED_MODULE_13__scenes_utilities_compare_dsds_actions__["e" /* COMPARE_DSDS_REPORT_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_14__scenes_utilities_compare_item_schemes_actions__["g" /* COMPARE_ITEM_SCHEMES_COMPARE_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_15__scenes_data_manager_upgrade_dsd_actions__["k" /* UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_16__scenes_reference_metadata_metadata_set_actions__["v" /* METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_17__scenes_reference_metadata_dcat_actions__["x" /* DCAT_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_18__scenes_meta_manager_hierarchical_codelists_actions__["l" /* HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_16__scenes_reference_metadata_metadata_set_actions__["I" /* METADATA_SET_REPORT_DOWNLOAD */]||action.label===__WEBPACK_IMPORTED_MODULE_17__scenes_reference_metadata_dcat_actions__["K" /* DCAT_REPORT_DOWNLOAD */]){var name=action.fileSave.name;if(action.label!==__WEBPACK_IMPORTED_MODULE_16__scenes_reference_metadata_metadata_set_actions__["v" /* METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD */]&&action.label!==__WEBPACK_IMPORTED_MODULE_17__scenes_reference_metadata_dcat_actions__["x" /* DCAT_REPORT_ATTRIBUTE_ATTACHMENT_DOWNLOAD */]){if(!name.endsWith("zip")&&action.header&&action.header["content-type"]==="application/zip"){name=action.fileSave.name.split(".");name.pop();name.push("zip");name=name.join(".");}}__WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(new Blob([!action.fileSave.stringifyResponse?action.response:JSON.stringify(action.response)],{type:action.fileSave.type}),name);}}return result;};};};/* harmony default export */ __webpack_exports__["a"] = (fileSaveMiddleware);

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_data_manager_dataflow_builder_wizard_query_actions__ = __webpack_require__(190);
var cubeNoDataModalMiddlewareFactory=function cubeNoDataModalMiddlewareFactory(i18next){return function(){return function(next){return function(action){var result=next(action);var t=i18next.t.bind(i18next);if(action.type===__WEBPACK_IMPORTED_MODULE_2__api_actions__["h" /* REQUEST_SUCCESS */]&&action.label===__WEBPACK_IMPORTED_MODULE_3__scenes_data_manager_dataflow_builder_wizard_query_actions__["c" /* DATAFLOW_BUILDER_WIZARD_QUERY_CUBE_COLUMNS_FORM_CUBE_FIRST_ROW_READ */]&&action.response.Data[0]===undefined){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({content:action.response.CountEmbargo&&action.response.CountEmbargo>0?t('scenes.dataManager.dataflowBuilder.wizard.query.columnsForm.cubeTreeModal.cubeOnlyEmbargoedDataModal.content'):t('scenes.dataManager.dataflowBuilder.wizard.query.columnsForm.cubeTreeModal.cubeNoDataModal.content')});}return result;};};};};/* harmony default export */ __webpack_exports__["a"] = (cubeNoDataModalMiddlewareFactory);

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(248);
var scrollToMiddleware=function scrollToMiddleware(){return function(next){return function(action){if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SCROLL_TO */]){action.element.scrollIntoView({block:'nearest'});}return next(action);};};};/* harmony default export */ __webpack_exports__["a"] = (scrollToMiddleware);

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_actions__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
var getMetadataApiPingUrl=function getMetadataApiPingUrl(baseUrl){return baseUrl+(baseUrl.slice(-1)==='/'?'':'/')+"ping";};var metadataApiMiddleware=function metadataApiMiddleware(_ref){var dispatch=_ref.dispatch;return function(next){return function(action){var result=next(action);if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* METADATA_API_PING */]){var uuid=__WEBPACK_IMPORTED_MODULE_3_uuid___default()();dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__spinner_actions__["d" /* addSpinnerAction */])(action,uuid));__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(getMetadataApiPingUrl(action.baseUrl)).then(function(response){// handle success
dispatch(Object.assign({},action,{type:action.label,requestSuccess:response.data===true}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__spinner_actions__["e" /* completeSpinnerAction */])(action,uuid));}).catch(function(error){// handle error
dispatch(Object.assign({},action,{type:action.label,requestSuccess:false}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__spinner_actions__["e" /* completeSpinnerAction */])(action,uuid));});}return result;};};};/* harmony default export */ __webpack_exports__["a"] = (metadataApiMiddleware);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_config_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_configuration_app_config_actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_actions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_header_endpoint_dropdown_actions__ = __webpack_require__(174);
var configMiddlewareFactory=function configMiddlewareFactory(i18next){return function(_ref){var dispatch=_ref.dispatch,getState=_ref.getState;return function(next){return function(action){var t=i18next.t.bind(i18next);if(action.type===__WEBPACK_IMPORTED_MODULE_2__reducers_config_actions__["a" /* CONFIG_INIT */]||action.type===__WEBPACK_IMPORTED_MODULE_3__api_actions__["h" /* REQUEST_SUCCESS */]&&(action.label===__WEBPACK_IMPORTED_MODULE_4__scenes_configuration_app_config_actions__["c" /* APP_CONFIG_CONFIG_SUBMIT */]||action.label===__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_actions__["p" /* NODES_CONFIG_NODE_CONFIG_SUBMIT */]||action.label===__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_actions__["r" /* NODES_CONFIG_NODE_SORT */]||action.label===__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_actions__["q" /* NODES_CONFIG_NODE_REMOVE */])){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_config_actions__["d" /* readConfig */])(undefined,action.label===__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_actions__["r" /* NODES_CONFIG_NODE_SORT */]||action.label===__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_actions__["q" /* NODES_CONFIG_NODE_REMOVE */]));}if(action.type===__WEBPACK_IMPORTED_MODULE_3__api_actions__["h" /* REQUEST_SUCCESS */]&&action.label===__WEBPACK_IMPORTED_MODULE_5__scenes_configuration_nodes_config_actions__["j" /* NODES_CONFIG_NODE_AGENCY_ASSIGNED_TO_ANY_USER_CHECK */]){if(action.response===false){action.onSuccess();}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:t('scenes.configuration.nodesConfig.agencies.agencies.agencyAssignedToAnyUserModal.title'),content:t('scenes.configuration.nodesConfig.agencies.agencies.agencyAssignedToAnyUserModal.content')});}}var result=next(action);if(!action.doNotPing&&action.type===__WEBPACK_IMPORTED_MODULE_3__api_actions__["h" /* REQUEST_SUCCESS */]&&action.label===__WEBPACK_IMPORTED_MODULE_2__reducers_config_actions__["b" /* CONFIG_READ */]&&getState().app.endpointId!==null){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__page_header_endpoint_dropdown_actions__["b" /* pingNode */])());}return result;};};};};/* harmony default export */ __webpack_exports__["a"] = (configMiddlewareFactory);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_divider__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_css__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__header__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sidebar__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scenes_home__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__breadcrumb__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_menus__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__footer__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__middlewares_default_category_scheme_selector__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_hot_loader__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__middlewares_spinner__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__NavigatePageDispatcher__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__scenes_configuration_nodes_config__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scenes_configuration_app_config__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scenes_data_manager_remove_temp_tables_RemoveTempTables__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__scenes_data_manager_ddb_reset_DdbReset__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scenes_data_manager_update_databrowser_cache_UpdateDatabrowserCache__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_provider_login__ = __webpack_require__(1634);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var cardChildStyle={paddingLeft:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_MD"],paddingRight:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_MD"]};var Components=Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["b" /* connect */])(function(state){return{endpointId:state.app.endpointId,isEndpointAvailable:state.app.isEndpointAvailable,anonymousPages:state.config.userInterface.anonymousPages,permissions:state.app.user.permissions,username:state.app.user.username};})(function(_ref){var endpointId=_ref.endpointId,isEndpointAvailable=_ref.isEndpointAvailable,anonymousPages=_ref.anonymousPages,t=_ref.t,permissions=_ref.permissions,username=_ref.username;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_25__utils_tree__["f" /* getFilteredTree */])(Object(__WEBPACK_IMPORTED_MODULE_14__constants_menus__["b" /* userMenu */])(t),"children",Object(__WEBPACK_IMPORTED_MODULE_27__utils__["b" /* isPageVisible */])(permissions,anonymousPages))),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_27__utils__["a" /* isClassificationsServer */])(username,permissions,anonymousPages,t)?[]:Object(__WEBPACK_IMPORTED_MODULE_25__utils_tree__["f" /* getFilteredTree */])(Object(__WEBPACK_IMPORTED_MODULE_14__constants_menus__["a" /* superUserMenu */])(t),"children",Object(__WEBPACK_IMPORTED_MODULE_27__utils__["b" /* isPageVisible */])(permissions,anonymousPages)))).map(function(parent){return parent.children.map(function(child){return!child.isDivider?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{key:child.path,path:child.path,exact:true,render:function render(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_MD"],marginBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_SM"],borderWidth:1,borderStyle:"solid",borderColor:"rgb(229, 229, 229)"},bodyStyle:{paddingTop:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_SM"],paddingBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_SM"],paddingLeft:0,paddingRight:0}},child.component!==__WEBPACK_IMPORTED_MODULE_26__scenes_data_manager_remove_temp_tables_RemoveTempTables__["a" /* default */]&&child.component!==__WEBPACK_IMPORTED_MODULE_28__scenes_data_manager_ddb_reset_DdbReset__["a" /* default */]&&child.component!==__WEBPACK_IMPORTED_MODULE_29__scenes_data_manager_update_databrowser_cache_UpdateDatabrowserCache__["a" /* default */]&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:cardChildStyle},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__breadcrumb__["a" /* default */],{child:child})),child.component&&child.component!==__WEBPACK_IMPORTED_MODULE_26__scenes_data_manager_remove_temp_tables_RemoveTempTables__["a" /* default */]&&child.component!==__WEBPACK_IMPORTED_MODULE_28__scenes_data_manager_ddb_reset_DdbReset__["a" /* default */]&&child.component!==__WEBPACK_IMPORTED_MODULE_29__scenes_data_manager_update_databrowser_cache_UpdateDatabrowserCache__["a" /* default */]&&(child.component===__WEBPACK_IMPORTED_MODULE_24__scenes_configuration_app_config__["a" /* default */]||child.component===__WEBPACK_IMPORTED_MODULE_23__scenes_configuration_nodes_config__["a" /* default */]||endpointId!==null&&isEndpointAvailable===true)?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_divider___default.a,{style:{marginTop:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_SM"],marginBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_MD"]}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:Object.assign({},cardChildStyle,{paddingBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_SM"]})},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(child.component,null))):child.component&&(child.component===__WEBPACK_IMPORTED_MODULE_26__scenes_data_manager_remove_temp_tables_RemoveTempTables__["a" /* default */]||child.component===__WEBPACK_IMPORTED_MODULE_28__scenes_data_manager_ddb_reset_DdbReset__["a" /* default */]||child.component===__WEBPACK_IMPORTED_MODULE_29__scenes_data_manager_update_databrowser_cache_UpdateDatabrowserCache__["a" /* default */])&&endpointId!==null&&isEndpointAvailable===true?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:Object.assign({},cardChildStyle,{paddingBottom:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["PADDING_SM"]})},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(child.component,null)):null);}}):null;});}));});var Page=function Page(_ref2){var t=_ref2.t;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__middlewares_spinner__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__middlewares_default_category_scheme_selector__["a" /* default */],null)," ",__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__NavigatePageDispatcher__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{path:"/auth/shibboleth",render:function render(props){var loginCode=new URLSearchParams(props.location.search).get("code");return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_provider_login__["a" /* default */],{loginCode:loginCode});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{path:"/",render:function render(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:"page",style:{position:"absolute",width:"100%",height:"100%"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{path:"/",component:__WEBPACK_IMPORTED_MODULE_11__sidebar__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:{marginLeft:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_LG"],marginRight:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_12__scenes_home__["a" /* default */],path:"/",exact:true}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Components,{t:t}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__footer__["a" /* default */],null))));}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_hot_loader__["hot"])(module),Object(__WEBPACK_IMPORTED_MODULE_8_react_i18next__["b" /* translate */])())(Page));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(372)(module)))

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _configProvider = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

function generator(_ref) {
  var suffixCls = _ref.suffixCls;
  return function (BasicComponent) {
    return (
      /*#__PURE__*/
      function (_React$Component) {
        _inherits(Adapter, _React$Component);

        function Adapter() {
          var _this;

          _classCallCheck(this, Adapter);

          _this = _possibleConstructorReturn(this, _getPrototypeOf(Adapter).apply(this, arguments));

          _this.renderComponent = function (_ref2) {
            var getPrefixCls = _ref2.getPrefixCls;
            var customizePrefixCls = _this.props.prefixCls;
            var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
            return React.createElement(BasicComponent, _extends({
              prefixCls: prefixCls
            }, _this.props));
          };

          return _this;
        }

        _createClass(Adapter, [{
          key: "render",
          value: function render() {
            return React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
          }
        }]);

        return Adapter;
      }(React.Component)
    );
  };
}

var Basic =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Basic, _React$Component2);

  function Basic() {
    _classCallCheck(this, Basic);

    return _possibleConstructorReturn(this, _getPrototypeOf(Basic).apply(this, arguments));
  }

  _createClass(Basic, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          prefixCls = _a.prefixCls,
          className = _a.className,
          children = _a.children,
          others = __rest(_a, ["prefixCls", "className", "children"]);

      var divCls = (0, _classnames["default"])(className, prefixCls);
      return React.createElement("div", _extends({
        className: divCls
      }, others), children);
    }
  }]);

  return Basic;
}(React.Component);

var BasicLayout =
/*#__PURE__*/
function (_React$Component3) {
  _inherits(BasicLayout, _React$Component3);

  function BasicLayout() {
    var _this2;

    _classCallCheck(this, BasicLayout);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(BasicLayout).apply(this, arguments));
    _this2.state = {
      siders: []
    };
    return _this2;
  }

  _createClass(BasicLayout, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this3 = this;

      return {
        siderHook: {
          addSider: function addSider(id) {
            _this3.setState(function (state) {
              return {
                siders: [].concat(_toConsumableArray(state.siders), [id])
              };
            });
          },
          removeSider: function removeSider(id) {
            _this3.setState(function (state) {
              return {
                siders: state.siders.filter(function (currentId) {
                  return currentId !== id;
                })
              };
            });
          }
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          prefixCls = _a.prefixCls,
          className = _a.className,
          children = _a.children,
          hasSider = _a.hasSider,
          others = __rest(_a, ["prefixCls", "className", "children", "hasSider"]);

      var divCls = (0, _classnames["default"])(className, prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), hasSider || this.state.siders.length > 0));
      return React.createElement("div", _extends({
        className: divCls
      }, others), children);
    }
  }]);

  return BasicLayout;
}(React.Component);

BasicLayout.childContextTypes = {
  siderHook: PropTypes.object
};
var Layout = generator({
  suffixCls: 'layout'
})(BasicLayout);
var Header = generator({
  suffixCls: 'layout-header'
})(Basic);
var Footer = generator({
  suffixCls: 'layout-footer'
})(Basic);
var Content = generator({
  suffixCls: 'layout-content'
})(Basic);
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
var _default = Layout;
exports["default"] = _default;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _configProvider = __webpack_require__(35);

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(49);

var _classnames = _interopRequireDefault(__webpack_require__(15));

var _omit = _interopRequireDefault(__webpack_require__(86));

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _icon = _interopRequireDefault(__webpack_require__(25));

var _isNumeric = _interopRequireDefault(__webpack_require__(1593));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  };

  window.matchMedia = window.matchMedia || matchMediaPolyfill;
}

var dimensionMap = {
  xs: '480px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px'
};

var generateId = function () {
  var i = 0;
  return function () {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    i += 1;
    return "".concat(prefix).concat(i);
  };
}();

var Sider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Sider, _React$Component);

  function Sider(props) {
    var _this;

    _classCallCheck(this, Sider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sider).call(this, props));

    _this.responsiveHandler = function (mql) {
      _this.setState({
        below: mql.matches
      });

      var onBreakpoint = _this.props.onBreakpoint;

      if (onBreakpoint) {
        onBreakpoint(mql.matches);
      }

      if (_this.state.collapsed !== mql.matches) {
        _this.setCollapsed(mql.matches, 'responsive');
      }
    };

    _this.setCollapsed = function (collapsed, type) {
      if (!('collapsed' in _this.props)) {
        _this.setState({
          collapsed: collapsed
        });
      }

      var onCollapse = _this.props.onCollapse;

      if (onCollapse) {
        onCollapse(collapsed, type);
      }
    };

    _this.toggle = function () {
      var collapsed = !_this.state.collapsed;

      _this.setCollapsed(collapsed, 'clickTrigger');
    };

    _this.belowShowChange = function () {
      _this.setState({
        belowShow: !_this.state.belowShow
      });
    };

    _this.renderSider = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          theme = _a.theme,
          collapsible = _a.collapsible,
          reverseArrow = _a.reverseArrow,
          trigger = _a.trigger,
          style = _a.style,
          width = _a.width,
          collapsedWidth = _a.collapsedWidth,
          others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth"]);

      var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
      var divProps = (0, _omit["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint']);
      var rawWidth = _this.state.collapsed ? collapsedWidth : width; // use "px" as fallback unit for width

      var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0

      var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? React.createElement("span", {
        onClick: _this.toggle,
        className: "".concat(prefixCls, "-zero-width-trigger")
      }, React.createElement(_icon["default"], {
        type: "bars"
      })) : null;
      var iconObj = {
        expanded: reverseArrow ? React.createElement(_icon["default"], {
          type: "right"
        }) : React.createElement(_icon["default"], {
          type: "left"
        }),
        collapsed: reverseArrow ? React.createElement(_icon["default"], {
          type: "left"
        }) : React.createElement(_icon["default"], {
          type: "right"
        })
      };
      var status = _this.state.collapsed ? 'collapsed' : 'expanded';
      var defaultTrigger = iconObj[status];
      var triggerDom = trigger !== null ? zeroWidthTrigger || React.createElement("div", {
        className: "".concat(prefixCls, "-trigger"),
        onClick: _this.toggle,
        style: {
          width: siderWidth
        }
      }, trigger || defaultTrigger) : null;

      var divStyle = _extends({}, style, {
        flex: "0 0 ".concat(siderWidth),
        maxWidth: siderWidth,
        minWidth: siderWidth,
        width: siderWidth
      });

      var siderCls = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), !!_this.state.collapsed), _defineProperty(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty(_classNames, "".concat(prefixCls, "-below"), !!_this.state.below), _defineProperty(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames));
      return React.createElement("div", _extends({
        className: siderCls
      }, divProps, {
        style: divStyle
      }), React.createElement("div", {
        className: "".concat(prefixCls, "-children")
      }, _this.props.children), collapsible || _this.state.below && zeroWidthTrigger ? triggerDom : null);
    };

    _this.uniqueId = generateId('ant-sider-');
    var matchMedia;

    if (typeof window !== 'undefined') {
      matchMedia = window.matchMedia;
    }

    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMap) {
      _this.mql = matchMedia("(max-width: ".concat(dimensionMap[props.breakpoint], ")"));
    }

    var collapsed;

    if ('collapsed' in props) {
      collapsed = props.collapsed;
    } else {
      collapsed = props.defaultCollapsed;
    }

    _this.state = {
      collapsed: collapsed,
      below: false
    };
    return _this;
  }

  _createClass(Sider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        siderCollapsed: this.state.collapsed,
        collapsedWidth: this.props.collapsedWidth
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.mql) {
        this.mql.addListener(this.responsiveHandler);
        this.responsiveHandler(this.mql);
      }

      if (this.context.siderHook) {
        this.context.siderHook.addSider(this.uniqueId);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.mql) {
        this.mql.removeListener(this.responsiveHandler);
      }

      if (this.context.siderHook) {
        this.context.siderHook.removeSider(this.uniqueId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderSider);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('collapsed' in nextProps) {
        return {
          collapsed: nextProps.collapsed
        };
      }

      return null;
    }
  }]);

  return Sider;
}(React.Component);

Sider.__ANT_LAYOUT_SIDER = true;
Sider.defaultProps = {
  collapsible: false,
  defaultCollapsed: false,
  reverseArrow: false,
  width: 200,
  collapsedWidth: 80,
  style: {},
  theme: 'dark'
};
Sider.childContextTypes = {
  siderCollapsed: PropTypes.bool,
  collapsedWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
Sider.contextTypes = {
  siderHook: PropTypes.object
};
(0, _reactLifecyclesCompat.polyfill)(Sider);
var _default = Sider;
exports["default"] = _default;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

var _default = isNumeric;
exports["default"] = _default;

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__language_dropdown__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__endpoint_dropdown__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__user_dropdown__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__help_button__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__middlewares_authentication_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers_app_actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sidebar_Header__ = __webpack_require__(605);
var mapStateToProps=function mapStateToProps(state){return{isSidebarCollapsed:state.app.isSidebarCollapsed,superUserUsername:state.app.superUser.username,username:state.app.user.username,permissions:state.app.user.permissions,anonymousPages:state.config.userInterface.anonymousPages,nodes:state.config.nodes,nodeId:state.app.endpointId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSidebarCollapse:function onSidebarCollapse(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__reducers_app_actions__["j" /* collapseAppSidebar */])());},onSidebarExpand:function onSidebarExpand(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__reducers_app_actions__["k" /* expandAppSidebar */])());},onSuperUserLogout:function onSuperUserLogout(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__middlewares_authentication_actions__["d" /* logoutSuperUser */])());}};};var PageHeader=function PageHeader(_ref){var t=_ref.t,isSidebarCollapsed=_ref.isSidebarCollapsed,onSidebarCollapse=_ref.onSidebarCollapse,superUserUsername=_ref.superUserUsername,onSidebarExpand=_ref.onSidebarExpand,onSuperUserLogout=_ref.onSuperUserLogout,username=_ref.username,permissions=_ref.permissions,anonymousPages=_ref.anonymousPages,nodes=_ref.nodes,nodeId=_ref.nodeId;var isReadOnlyNode=nodeId&&!__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.find(nodes,function(node){return node.general.id===nodeId;}).endpoint.haveDMWS;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a.Header,{style:{background:"white",paddingLeft:!Object(__WEBPACK_IMPORTED_MODULE_21__utils__["a" /* isClassificationsServer */])(username,permissions,anonymousPages,t)?24:6,paddingRight:24,borderBottom:"1px solid lightgrey"}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{type:'flex',gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_MD"]},Object(__WEBPACK_IMPORTED_MODULE_21__utils__["a" /* isClassificationsServer */])(username,permissions,anonymousPages,t)?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{style:{height:64,width:314,paddingTop:6,paddingLeft:32,borderRight:"rgb(229, 229, 229) 1px solid"}},Object(__WEBPACK_IMPORTED_MODULE_23__sidebar_Header__["b" /* logo */])())):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,isSidebarCollapsed!==null&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:isSidebarCollapsed?'menu-unfold':'menu-fold',onClick:isSidebarCollapsed?onSidebarExpand:onSidebarCollapse,style:{fontSize:20,cursor:"pointer",paddingTop:22}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('span',{style:{fontSize:30,color:"red",marginRight:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["MARGIN_XS"],fontFamily:'Fira Sans',fontWeight:600}},'M&D Manager'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('span',{style:{color:"gray",fontSize:12}},'v1.7.0_EL')))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{gutter:__WEBPACK_IMPORTED_MODULE_16__styles_constants__["GUTTER_SM"],type:'flex'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__endpoint_dropdown__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__language_dropdown__["a" /* default */],null)),isReadOnlyNode?null:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__user_dropdown__["a" /* default */],null)),superUserUsername&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:onSuperUserLogout,icon:'lock'},t('page.header.superUserLogoutButton.title'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__help_button__["a" /* default */],null))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])())(PageHeader));

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_menu_style__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_menu__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flag_icon_css_css_flag_icon_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_flag_icon_css_css_flag_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers_app_actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_languages__ = __webpack_require__(91);
var mapStateToProps=function mapStateToProps(state){return{selectableLanguages:state.config.userInterface.languages,selectedLanguage:state.app.language};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLanguageSelect:function onLanguageSelect(language){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__reducers_app_actions__["n" /* setAppLanguage */])(language));}};};var PageHeaderLanguageDropdown=function PageHeaderLanguageDropdown(_ref){var selectableLanguages=_ref.selectableLanguages,selectedLanguage=_ref.selectedLanguage,onLanguageSelect=_ref.onLanguageSelect,t=_ref.t;return selectableLanguages&&selectableLanguages.length>0&&selectedLanguage?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default.a,{trigger:['hover'],overlay:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_menu___default.a,{onClick:function onClick(_ref2){var language=_ref2.key;return onLanguageSelect(language);}},selectableLanguages.map(function(_ref3){var code=_ref3.code;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_menu___default.a.Item,{key:code},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('a',null,Object(__WEBPACK_IMPORTED_MODULE_15__utils_languages__["c" /* getLanguageLabel */])(t,code)));}))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{htmlType:'button'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i',{title:Object(__WEBPACK_IMPORTED_MODULE_15__utils_languages__["c" /* getLanguageLabel */])(t,selectedLanguage),className:'flag-icon '+Object(__WEBPACK_IMPORTED_MODULE_15__utils_languages__["b" /* getLanguageFlagIconCss */])(selectedLanguage,selectableLanguages),style:{marginRight:__WEBPACK_IMPORTED_MODULE_14__styles_constants__["MARGIN_SM"]}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:'down'}))):null;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),Object(__WEBPACK_IMPORTED_MODULE_10_react_i18next__["b" /* translate */])())(PageHeaderLanguageDropdown));

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_app_actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_endpoints_dropdown__ = __webpack_require__(361);
var mapStateToProps=function mapStateToProps(state){return{endpoints:state.config.nodes,endpointId:state.app.endpointId,isEndpointAvailable:state.app.isEndpointAvailable};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onEndpointSet:function onEndpointSet(endpointId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_app_actions__["m" /* setAppEndpoint */])(endpointId));},onNodePing:function onNodePing(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* pingNode */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_endpoints_dropdown__["a" /* default */]));

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_menu__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducers_app_actions__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__actions__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__RecoverPassword__ = __webpack_require__(1599);
var mapStateToProps=function mapStateToProps(state){return{username:state.app.user.username,isVisible:state.app.user.isDropdownVisible,nodes:state.config.nodes,nodeId:state.app.endpointId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onVisibleChange:function onVisibleChange(visibility){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__reducers_app_actions__["h" /* changeAppUserDropdownVisible */])(visibility));},onLogin:function onLogin(username,password){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["d" /* loginUserDropdownUser */])(username,password));},onLogout:function onLogout(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["e" /* logoutUserDropdownUser */])());},onRecoverPassword:function onRecoverPassword(username,email){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["f" /* recoverUserDropdownUserPassword */])(username,email));},onProviderLogin:function onProviderLogin(providerId,loginCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["c" /* loginUserDropdownProvider */])(providerId,loginCode));}};};var providerId=null;var PageHeaderUserDropdown=function PageHeaderUserDropdown(_ref){var t=_ref.t,form=_ref.form,isVisible=_ref.isVisible,username=_ref.username,nodes=_ref.nodes,nodeId=_ref.nodeId,onVisibleChange=_ref.onVisibleChange,onLogin=_ref.onLogin,onLogout=_ref.onLogout,onRecoverPassword=_ref.onRecoverPassword,onProviderLogin=_ref.onProviderLogin;var node=(nodes||[]).find(function(node){return node.general.id===nodeId;});var supportedAuths=node?node.supportedAuths||[]:[];var handleExternalLogin=function handleExternalLogin(provider,loginURL){providerId=provider;localStorage.removeItem("loginCode");function loginHandler(e){var loginCode=localStorage.getItem("loginCode");if(e.storageArea===localStorage&&loginCode&&providerId){onProviderLogin(providerId,loginCode);localStorage.removeItem("loginCode");providerId=null;}}window.addEventListener('storage',loginHandler,{once:true});window.open(loginURL,"","width=720,height=720");};return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default.a,{visible:isVisible,onVisibleChange:onVisibleChange,trigger:["click"],style:{minWidth:120},overlay:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a,{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_menu___default.a.Item,{disabled:true,style:{cursor:"auto"}},username?__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:"primary",onClick:onLogout,style:{width:"100%"}},t("page.header.userDropdown.buttons.logout")):__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a,{layout:"vertical"},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{style:{marginBottom:0}},form.getFieldDecorator("username")(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{autoComplete:"username",placeholder:t("page.header.userDropdown.fields.username.placeholder")}))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,{style:{marginBottom:0}},form.getFieldDecorator("password")(__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{type:"password",autoComplete:"current-password",placeholder:t("page.header.userDropdown.fields.password.placeholder")}))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){return onLogin(form.getFieldValue("username"),form.getFieldValue("password"));},disabled:!!!form.getFieldValue("username"),style:{width:"100%"},htmlType:"submit"},t("page.header.userDropdown.buttons.login")))),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{onClick:function onClick(){var modal=__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.info();modal.update({icon:"user",title:t("page.header.userDropdown.recoverPassword.title"),content:__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__RecoverPassword__["a" /* default */],{t:t,modal:modal,onSubmit:function onSubmit(username,email){return onRecoverPassword(username,email);}}),okButtonProps:{style:{display:"none"}},keyboard:false});},style:{width:"100%"}},t("page.header.userDropdown.buttons.recoverPassword")))),supportedAuths.length>0&&supportedAuths.map(function(_ref2){var label=_ref2.label,loginBaseURL=_ref2.loginBaseURL,providerName=_ref2.providerName;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,{key:providerName,style:{marginTop:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,{span:__WEBPACK_IMPORTED_MODULE_24__styles_constants__["SPAN_FULL"]},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{onClick:function onClick(){return handleExternalLogin(providerName,loginBaseURL);},style:{width:"100%"}},t("page.header.userDropdown.buttons.loginWith",{provider:label||providerName}))));})))))},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:username?"logout":"login"}),username||t("page.header.userDropdown.label.anonymous"),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:"down"})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_19_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create())(PageHeaderUserDropdown));

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_constants__);
var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["SPAN_TWO_THIRDS"]}};var UserDropdownRecoverPassword=function UserDropdownRecoverPassword(_ref){var t=_ref.t,form=_ref.form,modal=_ref.modal,onSubmit=_ref.onSubmit;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"],marginTop:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_MD"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.user.username.label')},formItemLayout),form.getFieldDecorator('username')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,null))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{style:{marginBottom:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["MARGIN_LG"]}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object.assign({className:'form-item-required',label:t('data.user.email.label')},formItemLayout),form.getFieldDecorator('email')(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,null))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',gutter:__WEBPACK_IMPORTED_MODULE_11__styles_constants__["GUTTER_MD"]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){modal.destroy();}},t('page.header.userDropdown.recoverPassword.buttons.cancel'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:'primary',icon:'mail',disabled:!form.getFieldValue('username')||form.getFieldValue('username').length<1||!form.getFieldValue('email')||form.getFieldValue('email').length<1,onClick:function onClick(){modal.destroy();onSubmit(form.getFieldValue('username'),form.getFieldValue('email'));},htmlType:'submit'},t('page.header.userDropdown.recoverPassword.buttons.submit')))));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(UserDropdownRecoverPassword));

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageHeaderHelpButton=function(_React$Component){_inherits(PageHeaderHelpButton,_React$Component);function PageHeaderHelpButton(props){_classCallCheck(this,PageHeaderHelpButton);var _this=_possibleConstructorReturn(this,(PageHeaderHelpButton.__proto__||Object.getPrototypeOf(PageHeaderHelpButton)).call(this,props));_this.state={isVisible:false};_this.show=_this.show.bind(_this);_this.hide=_this.hide.bind(_this);return _this;}_createClass(PageHeaderHelpButton,[{key:'show',value:function show(){this.setState({isVisible:true});}},{key:'hide',value:function hide(){this.setState({isVisible:false});}},{key:'render',value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:this.show,shape:'circle',size:'small'},'?'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_enhanced_modal__["a" /* default */],{visible:this.state.isVisible,width:960,onCancel:this.hide,footer:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:this.hide},t('commons.buttons.close.title'))},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:'./static/png/architettura.png',style:{width:'100%'},alt:t('page.header.helpButton.image.alt')})));}}]);return PageHeaderHelpButton;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* translate */])()(PageHeaderHelpButton));

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_menu_style__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_menu__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_menus__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Header__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_css__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_tree__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(198);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state){return{isCollapsed:state.app.isSidebarCollapsed,anonymousPages:state.config.userInterface.anonymousPages,permissions:state.app.user.permissions,username:state.app.user.username};};var SIDEBAR_TITLE_HEIGHT=64;var Sidebar=function Sidebar(_ref){var isCollapsed=_ref.isCollapsed,location=_ref.location,anonymousPages=_ref.anonymousPages,t=_ref.t,permissions=_ref.permissions,username=_ref.username;return Object(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* isClassificationsServer */])(username,permissions,anonymousPages,t)?null:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a.Sider,{className:'sidebar',width:320,collapsedWidth:64,theme:'dark',collapsible:true,collapsed:isCollapsed!==null?isCollapsed:true,trigger:null},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default.a,{className:'sidebar__menu '+((isCollapsed!==null?isCollapsed:true)?'sidebar__menu--collapsed':''),theme:'dark',mode:'inline',forceSubMenuRender:true,selectedKeys:[location.pathname],style:{height:'calc(100% - '+SIDEBAR_TITLE_HEIGHT+'px',overflow:"auto"}},[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["f" /* getFilteredTree */])(Object(__WEBPACK_IMPORTED_MODULE_8__constants_menus__["b" /* userMenu */])(t),"children",Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* isPageVisible */])(permissions,anonymousPages))),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_13__utils_tree__["f" /* getFilteredTree */])(Object(__WEBPACK_IMPORTED_MODULE_8__constants_menus__["a" /* superUserMenu */])(t),"children",Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* isPageVisible */])(permissions,anonymousPages)))).map(function(parent){return parent.children.filter(function(_ref2){var isDivider=_ref2.isDivider;return!isDivider;}).length&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default.a.SubMenu,{className:'sidebar__menu__item',key:parent.path,title:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{title:isCollapsed?t(parent.label):null},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'sidebar__menu__item__icon__container'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{alt:t(parent.label),className:'sidebar__menu__item__icon',src:parent.redIconPath})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'sidebar__menu__item__label'},t(parent.label)))},parent.children.map(function(child){return!child.isDivider?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default.a.Item,{key:child.path,className:'sidebar__menu__sub__item'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],{to:child.path},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'sidebar__menu__sub__item__icon__container'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{alt:t(child.label),className:'sidebar__menu__sub__item__icon',src:child.redIconPath})),t(child.label))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default.a.Divider,{key:__WEBPACK_IMPORTED_MODULE_11_uuid___default()()});}));})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps),Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* translate */])())(Sidebar));

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_utils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_sizeme__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_sizeme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_sizeme__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HOME_PAGE_PATH="static/homePage.html";var mapStateToProps=function mapStateToProps(state){return{anonymousPages:state.config.userInterface.anonymousPages,username:state.app.user.username,permissions:state.app.user.permissions};};var Home=function(_Component){_inherits(Home,_Component);function Home(){_classCallCheck(this,Home);return _possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).apply(this,arguments));}_createClass(Home,[{key:'componentDidMount',value:function componentDidMount(){var iframe=document.getElementById('homePageIframeId');if(iframe){iframe.onload=function(){iframe.height=iframe.contentWindow.document.body.scrollHeight+45+"px";};}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var iframe=document.getElementById('homePageIframeId');if(iframe&&iframe.contentWindow.document.body){iframe.height=iframe.contentWindow.document.body.scrollHeight+45+"px";}}},{key:'render',value:function render(){var _props=this.props,t=_props.t,username=_props.username,permissions=_props.permissions,anonymousPages=_props.anonymousPages;var currUrl=window.location;var baseUrl=currUrl.protocol+"//"+currUrl.host+currUrl.pathname;var homePage=''+baseUrl+(baseUrl.slice(-1)==='/'?'':'/')+HOME_PAGE_PATH;return Object(__WEBPACK_IMPORTED_MODULE_6__page_utils__["a" /* isClassificationsServer */])(username,permissions,anonymousPages,t)?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Redirect */],{to:anonymousPages[0]}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{className:'home',style:{marginTop:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MARGIN_MD"],marginBottom:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MARGIN_SM"],width:"100%"},bodyStyle:{padding:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["PADDING_MD"]}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('iframe',{title:"homePageIframeTitle",id:"homePageIframeId",src:homePage,style:{border:0,width:"100%"}}));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps),Object(__WEBPACK_IMPORTED_MODULE_5_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_9_react_sizeme__["withSize"])())(Home));

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_paths__ = __webpack_require__(124);
var BUILDER_PATH=__WEBPACK_IMPORTED_MODULE_9__constants_paths__["e" /* PATH_BUILDER */];var FILE_MAPPING_PATH=__WEBPACK_IMPORTED_MODULE_9__constants_paths__["A" /* PATH_FILE_MAPPING */];var LOADER_PATH=__WEBPACK_IMPORTED_MODULE_9__constants_paths__["D" /* PATH_LOADER */];var DATAFLOW_BUILDER_PATH=__WEBPACK_IMPORTED_MODULE_9__constants_paths__["q" /* PATH_DATAFLOW_BUILDER */];var titleStyle={marginLeft:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MARGIN_SM"],fontSize:20,color:'red',fontWeight:600,fontFamily:'Fira Sans'};var pathStyle={marginLeft:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MARGIN_SM"],marginRight:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["MARGIN_SM"],fontSize:18,fontWeight:500,cursor:"pointer"};var titleIconStyle={height:18,position:'relative',bottom:4};var PageBreadcrumb=function PageBreadcrumb(_ref){var child=_ref.child,t=_ref.t;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',align:'middle',justify:'space-between',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img',{alt:t(child.label),src:child.blackIconPath,style:titleIconStyle}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{style:titleStyle},t(child.label))),(child.path===BUILDER_PATH||child.path===FILE_MAPPING_PATH||child.path===LOADER_PATH||child.path===DATAFLOW_BUILDER_PATH)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{height:30,paddingTop:2}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{style:Object.assign({},pathStyle,{color:child.path===BUILDER_PATH?"red":""}),onClick:function onClick(){return window.open("./#"+BUILDER_PATH,'_self');}},t('menu.builder.label')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'right'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{style:Object.assign({},pathStyle,{color:child.path===FILE_MAPPING_PATH?"red":""}),onClick:function onClick(){return window.open("./#"+FILE_MAPPING_PATH,'_self');}},t('menu.fileMapping.label')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'right'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{style:Object.assign({},pathStyle,{color:child.path===LOADER_PATH?"red":""}),onClick:function onClick(){return window.open("./#"+LOADER_PATH,'_self');}},t('menu.loader.label')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'right'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{style:Object.assign({},pathStyle,{color:child.path===DATAFLOW_BUILDER_PATH?"red":""}),onClick:function onClick(){return window.open("./#"+DATAFLOW_BUILDER_PATH,'_self');}},t('menu.dataflowBuilder.label')))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])()(PageBreadcrumb));

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_constants__);
var Footer=function Footer(){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a.Footer,{style:{height:100,textAlign:"center",fontSize:12,padding:"16px 24px"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:'./static/png/istat_logo_gray.png',alt:'Logo ISTAT',style:{width:80,marginBottom:4}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{style:{display:"block",fontSize:14,fontWeight:"bold"}},'Istituto Nazionale di Statistica'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{style:{marginRight:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MARGIN_SM"]}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'environment-o',style:{marginRight:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MARGIN_XS"]}}),'Via Cesare Balbo, 16 - 00184 - Roma'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'phone',style:{marginRight:__WEBPACK_IMPORTED_MODULE_5__styles_constants__["MARGIN_XS"],transform:"rotate(90deg)"}}),'+39 06 46731'));};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultCategorySchemeSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hocs_call__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_artefact_list__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__redux_components_redux_category_scheme_detail_modal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducer__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_reduxReuse__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__redux_components_redux_category_scheme_detail_modal_actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CategoryForm__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state){return{nodes:state.config.nodes,nodeId:state.app.endpointId,isVisible:state.middlewares.defaultCategorySchemeSelector.isVisible,isSelectModalVisible:state.middlewares.defaultCategorySchemeSelector.isSelectModalVisible,isCreateModalVisible:state.middlewares.defaultCategorySchemeSelector.isCreateModalVisible,categorySchemes:state.middlewares.defaultCategorySchemeSelector.categorySchemes,categorySchemeDetail:state.middlewares.defaultCategorySchemeSelector.categorySchemeDetail,category:state.middlewares.defaultCategorySchemeSelector.category};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSelectModalShow:function onSelectModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["n" /* showDefaultCategorySchemeSelectorSelectModal */])());},onCreateModalShow:function onCreateModalShow(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["m" /* showDefaultCategorySchemeSelectorCreateModal */])());},fetchCategorySchemes:function fetchCategorySchemes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["k" /* readDefaultCategorySchemeSelectorCategorySchemes */])());},onHide:function onHide(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["j" /* hideDefaultCategorySchemeSelector */])());},onCategorySchemeShow:function onCategorySchemeShow(categorySchemeTriplet,defaultItemsViewMode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__utils_reduxReuse__["a" /* reuseAction */])(Object(__WEBPACK_IMPORTED_MODULE_18__redux_components_redux_category_scheme_detail_modal_actions__["_40" /* showCategorySchemeDetail */])(categorySchemeTriplet,defaultItemsViewMode),__WEBPACK_IMPORTED_MODULE_16__reducer__["a" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX */]));},onSelectSubmit:function onSelectSubmit(categorySchemeTriplet){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["p" /* submitDefaultCategorySchemeSelectorSelect */])(categorySchemeTriplet));},onCreateSubmit:function onCreateSubmit(category){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["o" /* submitDefaultCategorySchemeSelectorCreate */])(category));},onCategoryChange:function onCategoryChange(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions__["i" /* changeDefaultCategorySchemeSelectorCreate */])(fields));}};};var DefaultCategorySchemeSelector=function DefaultCategorySchemeSelector(_ref){var t=_ref.t,nodes=_ref.nodes,nodeId=_ref.nodeId,isVisible=_ref.isVisible,isSelectModalVisible=_ref.isSelectModalVisible,isCreateModalVisible=_ref.isCreateModalVisible,categorySchemes=_ref.categorySchemes,categorySchemeDetail=_ref.categorySchemeDetail,fetchCategorySchemes=_ref.fetchCategorySchemes,category=_ref.category,onCategoryChange=_ref.onCategoryChange,onHide=_ref.onHide,onCategorySchemeShow=_ref.onCategorySchemeShow,onSelectModalShow=_ref.onSelectModalShow,onCreateModalShow=_ref.onCreateModalShow,onSelectSubmit=_ref.onSelectSubmit,onCreateSubmit=_ref.onCreateSubmit;var connectedNode=nodes.find(function(node){return node.general.id===nodeId;});var defaultItemsViewMode=connectedNode?connectedNode.general.defaultItemsViewMode:null;return defaultItemsViewMode?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:function cb(){onHide();__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.destroyAll();__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.confirm({icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'warning'}),title:t('middlewares.defaultCategorySchemeSelector.alert.title'),content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a.destroyAll();},style:{textDecoration:"underline",color:"red",cursor:"pointer"}},t('middlewares.defaultCategorySchemeSelector.alert.backToHome')),okText:t('middlewares.defaultCategorySchemeSelector.alert.selectButton.title'),cancelText:t('middlewares.defaultCategorySchemeSelector.alert.createButton.title'),onOk:function onOk(){onSelectModalShow();},onCancel:function onCancel(){onCreateModalShow();}});},cbParam:isVisible,disabled:!isVisible},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:isSelectModalVisible,title:t('middlewares.defaultCategorySchemeSelector.selectModal.title'),width:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MODAL_WIDTH_LG"],footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),onCancel:onHide,withDataLanguageSelector:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hocs_call__["a" /* default */],{cb:fetchCategorySchemes},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_artefact_list__["a" /* default */],{artefacts:categorySchemes,onDetailShow:function onDetailShow(triplet){return onCategorySchemeShow(triplet,defaultItemsViewMode);},onRowClick:function onRowClick(_ref2){var id=_ref2.id,agencyID=_ref2.agencyID,version=_ref2.version;return onSelectSubmit({id:id,agencyID:agencyID,version:version});}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__redux_components_redux_category_scheme_detail_modal__["a" /* default */],{instancePrefix:__WEBPACK_IMPORTED_MODULE_16__reducer__["a" /* DEFAULT_CATEGORY_SCHEME_SELECTOR_PREFIX */],instanceState:categorySchemeDetail}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_enhanced_modal__["a" /* default */],{visible:isCreateModalVisible,title:t('middlewares.defaultCategorySchemeSelector.createModal.title'),width:__WEBPACK_IMPORTED_MODULE_7__styles_constants__["MODAL_WIDTH_SM"],footer:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:onHide},t('commons.buttons.close.title')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{onClick:function onClick(){return onCreateSubmit(category);},type:'primary',disabled:category===null||category.catCode===null||!Object(__WEBPACK_IMPORTED_MODULE_20__utils_artefactValidators__["d" /* isDictionaryValid */])(category.labels)},t('commons.buttons.save.title'))),onCancel:onHide},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__CategoryForm__["a" /* default */],{category:category,onChange:onCategoryChange}))):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps))(DefaultCategorySchemeSelector));

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_multilanguage_input__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
var mapPropsToFields=function mapPropsToFields(_ref){var category=_ref.category;return{catCode:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:category!==null&&category.catCode!==undefined?category.catCode:null}),labels:__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.createFormField({value:category!==null&&category.labels!==undefined?category.labels:null})};};var onFieldsChange=function onFieldsChange(_ref2,fields){var onChange=_ref2.onChange;onChange(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(fields,function(_ref3){var value=_ref3.value;return value;}));};var formItemLayout={labelCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_ONE_THIRD"]},wrapperCol:{span:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["SPAN_TWO_THIRDS"]}};var CategoryForm=function CategoryForm(_ref4){var form=_ref4.form,t=_ref4.t;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{className:"advanced-form"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert___default.a,{type:"info",showIcon:true,message:t("middlewares.defaultCategorySchemeSelector.createModal.infoMessage"),style:{marginBottom:__WEBPACK_IMPORTED_MODULE_9__styles_constants__["MARGIN_MD"]}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t("data.item.id.label")},formItemLayout),form.getFieldDecorator("catCode",{getValueFromEvent:function getValueFromEvent(e){return e.target.value.toUpperCase();}})(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{title:form.getFieldValue("catCode"),style:{textTransform:"uppercase"}}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object.assign({className:"form-item-required",label:t("data.item.name.label")},formItemLayout),form.getFieldDecorator("labels")(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_multilanguage_input__["a" /* default */],{title:form.getFieldValue("labels")}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* translate */])(),__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.create({mapPropsToFields:mapPropsToFields,onFieldsChange:onFieldsChange}))(CategoryForm));

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var evalAllowed = false;
try {
  eval('evalAllowed = true');
} catch (e) {
  // eval not allowed due to CSP
}

// RHL needs setPrototypeOf to operate Component inheritance, and eval to patch methods
var platformSupported = !!Object.setPrototypeOf && evalAllowed;

if (true) {
  if (false) {
    // we are not in prod mode, but RHL could not be activated
    console.warn('React-Hot-Loaded is not supported in this environment');
  }
  module.exports = __webpack_require__(1609);
} else {
  module.exports = require('./dist/react-hot-loader.development.js');
}


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(0)),classCallCheck=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},inherits=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},possibleConstructorReturn=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},AppContainer=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,e.apply(this,arguments))}return inherits(t,e),t.prototype.render=function(){return React.Children.only(this.props.children)},t}(React.Component),hot_prod=function(){return function(e){return e}},areComponentsEqual=function(e,t){return e===t},setConfig=function(){},cold=function(e){return e},configureComponent=function(){};exports.AppContainer=AppContainer,exports.hot=hot_prod,exports.areComponentsEqual=areComponentsEqual,exports.setConfig=setConfig,exports.cold=cold,exports.configureComponent=configureComponent;


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loading_overlay__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_constants__);
var mapStateToProps=function mapStateToProps(state){return{actions:state.middlewares.spinner.actions};};var Spinner=function Spinner(_ref){var t=_ref.t,actions=_ref.actions,children=_ref.children;var showSpinner=actions.find(function(_ref2){var action=_ref2.action;return!action.hideSpinner;});var overlayStyle={background:'rgba(0, 0, 0, 0)'};var spinner=null;if(showSpinner){spinner=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'loading',style:{color:'white',fontSize:32}});overlayStyle={background:'rgba(0, 0, 0, 0.65)'};}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_loading_overlay___default.a,{active:actions.length>0,spinner:spinner,classNamePrefix:'spinner_',fadeSpeed:300,styles:{wrapper:function wrapper(base){return Object.assign({},base,{width:'100%',height:'100%',position:'absolute'});},overlay:function overlay(base){return Object.assign({},base,{zIndex:__WEBPACK_IMPORTED_MODULE_8__styles_constants__["Z_INDEX_SPINNER"]},overlayStyle);}}},children);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* translate */])(),Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps))(Spinner));

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _reactTransitionGroup = __webpack_require__(1613);

var _emotion = __webpack_require__(364);

var _Spinner = _interopRequireDefault(__webpack_require__(1631));

var _styles = _interopRequireDefault(__webpack_require__(1632));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LoadingOverlayWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(LoadingOverlayWrapper, _Component);

  function LoadingOverlayWrapper(props) {
    var _this;

    _classCallCheck(this, LoadingOverlayWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoadingOverlayWrapper).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, providedState) {
      var base = _styles.default[key](providedState, _this.props);

      var custom = _this.props.styles[key];
      if (!custom) return base;
      return typeof custom === 'function' ? custom(base, _this.props) : custom;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cx", function (names) {
      var arr = Array.isArray(names) ? names : [names];

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return _emotion.cx.apply(void 0, _toConsumableArray(arr.map(function (name) {
        return name ? "".concat(_this.props.classNamePrefix).concat(name) : '';
      })).concat(args));
    });

    _this.wrapper = _react.default.createRef();
    _this.state = {
      overflowCSS: {}
    };
    return _this;
  }

  _createClass(LoadingOverlayWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var wrapperStyle = window.getComputedStyle(this.wrapper.current);
      var overflowCSS = ['overflow', 'overflowX', 'overflowY'].reduce(function (m, i) {
        if (wrapperStyle[i] !== 'visible') m[i] = 'hidden';
        return m;
      }, {});
      this.setState({
        overflowCSS: overflowCSS
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var active = this.props.active;
      if (active) this.wrapper.current.scrollTop = 0;
    }
    /**
     * Return an emotion css object for a given element key
     * If a custom style was provided via props, run it with
     * the base css obj.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var overflowCSS = this.state.overflowCSS;
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onClick = _this$props.onClick,
          active = _this$props.active,
          fadeSpeed = _this$props.fadeSpeed,
          spinner = _this$props.spinner,
          text = _this$props.text;
      return _react.default.createElement("div", {
        "data-testid": "wrapper",
        ref: this.wrapper,
        className: this.cx(['wrapper', active && 'wrapper--active'], (0, _emotion.css)(this.getStyles('wrapper', active ? overflowCSS : {})), className)
      }, _react.default.createElement(_reactTransitionGroup.CSSTransition, {
        in: active,
        classNames: "_loading-overlay-transition",
        timeout: fadeSpeed,
        unmountOnExit: true
      }, function (state) {
        return _react.default.createElement("div", {
          "data-testid": "overlay",
          className: _this2.cx('overlay', (0, _emotion.css)(_this2.getStyles('overlay', state))),
          onClick: onClick
        }, _react.default.createElement("div", {
          className: _this2.cx('content', (0, _emotion.css)(_this2.getStyles('content')))
        }, spinner && (typeof spinner === 'boolean' ? _react.default.createElement(_Spinner.default, {
          cx: _this2.cx,
          getStyles: _this2.getStyles
        }) : spinner), text));
      }), children);
    }
  }]);

  return LoadingOverlayWrapper;
}(_react.Component);

LoadingOverlayWrapper.propTypes = {
  active: _propTypes.default.bool,
  fadeSpeed: _propTypes.default.number,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  classNamePrefix: _propTypes.default.string,
  spinner: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),
  text: _propTypes.default.node,
  styles: _propTypes.default.shape({
    content: _propTypes.default.function,
    overlay: _propTypes.default.function,
    spinner: _propTypes.default.function,
    wrapper: _propTypes.default.function
  })
};
LoadingOverlayWrapper.defaultProps = {
  classNamePrefix: '_loading_overlay_',
  fadeSpeed: 500,
  styles: {}
};
var _default = LoadingOverlayWrapper;
exports.default = _default;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1614));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1619));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(608));

var _Transition = _interopRequireDefault(__webpack_require__(606));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(5));

var _addClass = _interopRequireDefault(__webpack_require__(1615));

var _removeClass = _interopRequireDefault(__webpack_require__(1618));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(606));

var _PropTypes = __webpack_require__(607);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1616);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1617));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(38);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(608));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_cache__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_serialize__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_utils__ = __webpack_require__(1630);




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_cache__["a" /* default */])(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered, this !== undefined ? this.mergedProps : undefined);
    Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["b" /* insertStyles */])(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: __WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */].bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(1625);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case 2:
          {
            for (var i = 0, len = selectors.length; len > i; i++) {
              // :last-child isn't included here since it's safe
              // because a style element will never be the last element
              var match = selectors[i].match(/:(first|nth|nth-last)-child/);

              if (match !== null) {
                console.error("The pseudo class \"" + match[0] + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + match[1] + "-of-type\"");
              }
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (weakMemoize);


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(1629);




var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          value = value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    if (key.charCodeAt(1) !== 45 && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, char) {
        return char.toUpperCase();
      }) + "?");
    }

    return oldProcessStyleValue(key, value);
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles;

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
      }
    // eslint-disable-next-line no-fallthrough

    default:
      {
        if (registered == null) {
          return interpolation;
        }

        var cached = registered[interpolation];

        if (false) {
          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
          shouldWarnAboutInterpolatingClassNameFromCss = false;
        }

        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
      }
  }
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
          }
        } else {
          string += _key + "{" + handleInterpolation(mergedProps, registered, value, false) + "}";
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _emotion = __webpack_require__(364);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(_ref) {
  var getStyles = _ref.getStyles,
      cx = _ref.cx;
  return _react.default.createElement("div", {
    className: cx('spinner', (0, _emotion.css)(getStyles('spinner')))
  }, _react.default.createElement("svg", {
    viewBox: "25 25 50 50"
  }, _react.default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  })));
};

Spinner.propTypes = {
  getStyles: _propTypes.default.func.isRequired,
  cx: _propTypes.default.func.isRequired
};
var _default = Spinner;
exports.default = _default;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = __webpack_require__(364);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1,200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89,200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dasharray: 89,200;\n    stroke-dashoffset: -124px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var rotate360 = (0, _emotion.keyframes)(_templateObject());
var spinnerDash = (0, _emotion.keyframes)(_templateObject2());
var _default = {
  wrapper: function wrapper(state) {
    return _objectSpread({
      position: 'relative'
    }, state);
  },
  overlay: function overlay(state, props) {
    return {
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: '0px',
      left: '0px',
      display: 'flex',
      textAlign: 'center',
      fontSize: '1.2em',
      color: '#FFF',
      background: 'rgba(0, 0, 0, 0.7)',
      zIndex: 800,
      transition: "opacity ".concat(props.fadeSpeed, "ms ease-in"),
      opacity: state === 'entering' || state === 'entered' ? 1 : 0
    };
  },
  content: function content() {
    return {
      margin: 'auto'
    };
  },
  spinner: function spinner(state) {
    return {
      position: 'relative',
      margin: '0px auto 10px auto',
      width: '50px',
      maxHeight: '100%',
      '&:before': {
        content: '""',
        display: 'block',
        paddingTop: '100%'
      },
      '& svg': {
        animation: "".concat(rotate360, " 2s linear infinite"),
        height: '100%',
        transformOrigin: 'center center',
        width: '100%',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        margin: 'auto',
        '& circle': {
          animation: "".concat(spinnerDash, " 1.5s ease-in-out infinite"),
          strokeDasharray: '1,200',
          strokeDashoffset: 0,
          strokeLinecap: 'round',
          stroke: '#FFF'
        }
      }
    };
  }
};
exports.default = _default;

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onNavigatePage:function onNavigatePage(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* navigatePage */])());}};};var NavigatePageDispatcher=function NavigatePageDispatcher(_ref){var onNavigatePage=_ref.onNavigatePage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Prompt */],{message:function message(){onNavigatePage();return null;}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null,mapDispatchToProps)(NavigatePageDispatcher));

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ProviderLogin=function ProviderLogin(_ref){var loginCode=_ref.loginCode;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(loginCode){localStorage.setItem("loginCode",loginCode);}var new_window=window.open(window.location.href,'_self');new_window.close();},[loginCode]);return null;};/* harmony default export */ __webpack_exports__["a"] = (ProviderLogin);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.96fe751d.js